(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2888],{

/***/ 97375:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "qq": function() { return /* binding */ useMergeRefs; }
/* harmony export */ });
/* unused harmony exports IdProvider, assignRef, useBoolean, useClipboard, useConst, useControllableProp, useControllableState, useDimensions, useDisclosure, useEventCallback, useEventListenerMap, useFocusEffect, useFocusOnHide, useFocusOnPointerDown, useFocusOnShow, useForceUpdate, useId, useIds, useInterval, useLatestRef, useMouseDownRef, useOptionalPart, useOutsideClick, usePanGesture, usePointerEvent, usePrevious, useShortcut, useTimeout, useUnmountEffect, useUpdateEffect, useWhyDidYouUpdate */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var copy_to_clipboard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20640);
/* harmony import */ var copy_to_clipboard__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(copy_to_clipboard__WEBPACK_IMPORTED_MODULE_1__);







/**
 * React hook to manage boolean (on - off) states
 *
 * @param initialState the initial boolean state value
 */
function useBoolean(initialState) {
  if (initialState === void 0) {
    initialState = false;
  }

  var _useState = useState(initialState),
      value = _useState[0],
      setValue = _useState[1];

  var callbacks = useMemo(function () {
    return {
      on: function on() {
        return setValue(true);
      },
      off: function off() {
        return setValue(false);
      },
      toggle: function toggle() {
        return setValue(function (prev) {
          return !prev;
        });
      }
    };
  }, []);
  return [value, callbacks];
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var _excluded = (/* unused pure expression or super */ null && (["timeout"]));

/**
 * React hook to copy content to clipboard
 *
 * @param text the text or value to copy
 * @param {Number} [optionsOrTimeout=1500] optionsOrTimeout - delay (in ms) to switch back to initial state once copied.
 * @param {Object} optionsOrTimeout
 * @param {string} optionsOrTimeout.format - set the desired MIME type
 * @param {number} optionsOrTimeout.timeout - delay (in ms) to switch back to initial state once copied.
 */
function useClipboard(text, optionsOrTimeout) {
  if (optionsOrTimeout === void 0) {
    optionsOrTimeout = {};
  }

  var _useState = useState(false),
      hasCopied = _useState[0],
      setHasCopied = _useState[1];

  var _ref = typeof optionsOrTimeout === "number" ? {
    timeout: optionsOrTimeout
  } : optionsOrTimeout,
      _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === void 0 ? 1500 : _ref$timeout,
      copyOptions = _objectWithoutPropertiesLoose(_ref, _excluded);

  var onCopy = useCallback(function () {
    var didCopy = copy(text, copyOptions);
    setHasCopied(didCopy);
  }, [text, copyOptions]);
  useEffect(function () {
    var timeoutId = null;

    if (hasCopied) {
      timeoutId = window.setTimeout(function () {
        setHasCopied(false);
      }, timeout);
    }

    return function () {
      if (timeoutId) {
        window.clearTimeout(timeoutId);
      }
    };
  }, [timeout, hasCopied]);
  return {
    value: text,
    onCopy: onCopy,
    hasCopied: hasCopied
  };
}

/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConst`
 * you can ensure that initializers don't execute twice or more.
 */
function useConst(init) {
  // Use useRef to store the value because it's the least expensive built-in
  // hook that works here. We could also use `useState` but that's more
  // expensive internally due to reducer handling which we don't need.
  var ref = useRef(null);

  if (ref.current === null) {
    ref.current = typeof init === "function" ? init() : init;
  }

  return ref.current;
}

function useControllableProp(prop, state) {
  var isControlled = prop !== undefined;
  var value = isControlled && typeof prop !== "undefined" ? prop : state;
  return [isControlled, value];
}

/**
 * React hook for using controlling component state.
 * @param props
 */
function useControllableState(props) {
  var valueProp = props.value,
      defaultValue = props.defaultValue,
      onChange = props.onChange,
      _props$shouldUpdate = props.shouldUpdate,
      shouldUpdate = _props$shouldUpdate === void 0 ? function (prev, next) {
    return prev !== next;
  } : _props$shouldUpdate;
  var onChangeProp = useCallbackRef(onChange);
  var shouldUpdateProp = useCallbackRef(shouldUpdate);

  var _React$useState = React.useState(defaultValue),
      valueState = _React$useState[0],
      setValue = _React$useState[1];

  var isControlled = valueProp !== undefined;
  var value = isControlled ? valueProp : valueState;
  var updateValue = React.useCallback(function (next) {
    var nextValue = runIfFn(next, value);

    if (!shouldUpdateProp(value, nextValue)) {
      return;
    }

    if (!isControlled) {
      setValue(nextValue);
    }

    onChangeProp(nextValue);
  }, [isControlled, onChangeProp, value, shouldUpdateProp]);
  return [value, updateValue];
}

/**
 * React hook to measure a component's dimensions
 *
 * @param ref ref of the component to measure
 * @param observe if `true`, resize and scroll observers will be turned on
 */

function useDimensions(ref, observe) {
  var _React$useState = React.useState(null),
      dimensions = _React$useState[0],
      setDimensions = _React$useState[1];

  var rafId = React.useRef();
  useSafeLayoutEffect(function () {
    if (!ref.current) return undefined;
    var node = ref.current;

    function measure() {
      rafId.current = requestAnimationFrame(function () {
        var boxModel = getBox(node);
        setDimensions(boxModel);
      });
    }

    measure();

    if (observe) {
      window.addEventListener("resize", measure);
      window.addEventListener("scroll", measure);
    }

    return function () {
      if (observe) {
        window.removeEventListener("resize", measure);
        window.removeEventListener("scroll", measure);
      }

      if (rafId.current) {
        cancelAnimationFrame(rafId.current);
      }
    };
  }, [observe]);
  return dimensions;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

// This implementation is heavily inspired by react-aria's implementation
var defaultIdContext = {
  current: 1
};
var IdContext = /*#__PURE__*/(/* unused pure expression or super */ null && (React.createContext(defaultIdContext)));
var IdProvider = /*#__PURE__*/(/* unused pure expression or super */ null && (React.memo(function (_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(IdContext.Provider, {
    value: {
      current: 1
    }
  }, children);
})));

var genId = function genId(context) {
  return context.current++;
};

function useId(idProp, prefix) {
  var context = React.useContext(IdContext);
  /*
      We get the current id by context and generate a new id inside useEffect so that the side effects occur during the commit phase,
      Doing this prevents the side effects from being called twice when used with strict mode (render() in function component is the function body), which ends up making the server with the client not synchronized
  */

  var _React$useState = React.useState(context.current),
      id = _React$useState[0],
      setId = _React$useState[1];

  React.useEffect(function () {
    setId(genId(context));
  }, [context]);
  return React.useMemo(function () {
    return idProp || [prefix, id].filter(Boolean).join("-");
  }, [idProp, prefix, id]);
}
/**
 * React hook to generate ids for use in compound components
 *
 * @param idProp the external id passed from the user
 * @param prefixes array of prefixes to use
 *
 * @example
 *
 * ```js
 * const [buttonId, menuId] = useIds("52", "button", "menu")
 *
 * // buttonId will be `button-52`
 * // menuId will be `menu-52`
 * ```
 */

function useIds(idProp) {
  for (var _len = arguments.length, prefixes = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    prefixes[_key - 1] = arguments[_key];
  }

  var id = useId(idProp);
  return React.useMemo(function () {
    return prefixes.map(function (prefix) {
      return prefix + "-" + id;
    });
  }, [id, prefixes]);
}
/**
 * Used to generate an id, and after render, check if that id is rendered, so we know
 * if we can use it in places such as `aria-labelledby`.
 *
 * @param partId - The unique id for the component part
 *
 * @example
 * const { ref, id } = useOptionalPart<HTMLInputElement>(`${id}-label`)
 */

function useOptionalPart(partId) {
  var _React$useState2 = React.useState(null),
      id = _React$useState2[0],
      setId = _React$useState2[1];

  var ref = React.useCallback(function (node) {
    setId(node ? partId : null);
  }, [partId]);
  return {
    ref: ref,
    id: id,
    isRendered: Boolean(id)
  };
}

function useDisclosure(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      onCloseProp = _props.onClose,
      onOpenProp = _props.onOpen,
      isOpenProp = _props.isOpen,
      idProp = _props.id;
  var onOpenPropCallbackRef = useCallbackRef(onOpenProp);
  var onClosePropCallbackRef = useCallbackRef(onCloseProp);

  var _React$useState = React.useState(props.defaultIsOpen || false),
      isOpenState = _React$useState[0],
      setIsOpen = _React$useState[1];

  var _useControllableProp = useControllableProp(isOpenProp, isOpenState),
      isControlled = _useControllableProp[0],
      isOpen = _useControllableProp[1];

  var id = useId(idProp, "disclosure");
  var onClose = React.useCallback(function () {
    if (!isControlled) {
      setIsOpen(false);
    }

    onClosePropCallbackRef == null ? void 0 : onClosePropCallbackRef();
  }, [isControlled, onClosePropCallbackRef]);
  var onOpen = React.useCallback(function () {
    if (!isControlled) {
      setIsOpen(true);
    }

    onOpenPropCallbackRef == null ? void 0 : onOpenPropCallbackRef();
  }, [isControlled, onOpenPropCallbackRef]);
  var onToggle = React.useCallback(function () {
    var action = isOpen ? onClose : onOpen;
    action();
  }, [isOpen, onOpen, onClose]);
  return {
    isOpen: !!isOpen,
    onOpen: onOpen,
    onClose: onClose,
    onToggle: onToggle,
    isControlled: isControlled,
    getButtonProps: function getButtonProps(props) {
      if (props === void 0) {
        props = {};
      }

      return _extends({}, props, {
        "aria-expanded": "true",
        "aria-controls": id,
        onClick: callAllHandlers(props.onClick, onToggle)
      });
    },
    getDisclosureProps: function getDisclosureProps(props) {
      if (props === void 0) {
        props = {};
      }

      return _extends({}, props, {
        hidden: !isOpen,
        id: id
      });
    }
  };
}

/**
 * React hook for performant `useCallbacks`
 *
 * @see https://github.com/facebook/react/issues/14099#issuecomment-440013892
 *
 * @deprecated Use `useCallbackRef` instead. `useEventCallback` will be removed
 * in a future version.
 */

function useEventCallback(callback) {
  var ref = React.useRef(callback);
  useSafeLayoutEffect(function () {
    ref.current = callback;
  });
  return React.useCallback(function (event) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return ref.current.apply(ref, [event].concat(args));
  }, []);
}

function useEventListenerMap() {
  var listeners = React.useRef(new Map());
  var currentListeners = listeners.current;
  var add = React.useCallback(function (el, type, listener, options) {
    var pointerEventListener = wrapPointerEventHandler(listener, type === "pointerdown");
    listeners.current.set(listener, {
      __listener: pointerEventListener,
      type: getPointerEventName(type),
      el: el,
      options: options
    });
    el.addEventListener(type, pointerEventListener, options);
  }, []);
  var remove = React.useCallback(function (el, type, listener, options) {
    var _listeners$current$ge = listeners.current.get(listener),
        pointerEventListener = _listeners$current$ge.__listener;

    el.removeEventListener(type, pointerEventListener, options);
    listeners.current["delete"](pointerEventListener);
  }, []);
  React.useEffect(function () {
    return function () {
      currentListeners.forEach(function (value, key) {
        remove(value.el, value.type, key, value.options);
      });
    };
  }, [remove, currentListeners]);
  return {
    add: add,
    remove: remove
  };
}

/**
 * React effect hook that invokes only on update.
 * It doesn't invoke on mount
 */

var useUpdateEffect = function useUpdateEffect(effect, deps) {
  var mounted = React.useRef(false);
  React.useEffect(function () {
    if (mounted.current) {
      return effect();
    }

    mounted.current = true;
    return undefined; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
  return mounted.current;
};

/**
 * React hook to focus an element conditionally
 *
 * @param ref the ref of the element to focus
 * @param options focus management options
 */
function useFocusEffect(ref, options) {
  var shouldFocus = options.shouldFocus,
      preventScroll = options.preventScroll;
  useUpdateEffect(function () {
    var node = ref.current;
    if (!node || !shouldFocus) return;

    if (!hasFocusWithin(node)) {
      focus(node, {
        preventScroll: preventScroll,
        nextTick: true
      });
    }
  }, [shouldFocus, ref, preventScroll]);
}

function preventReturnFocus(containerRef) {
  var el = containerRef.current;
  if (!el) return false;
  var activeElement = getActiveElement(el);
  if (!activeElement) return false;
  if (contains(el, activeElement)) return false;
  if (isTabbable(activeElement)) return true;
  return false;
}
/**
 * Popover hook to manage the focus when the popover closes or hides.
 *
 * We either want to return focus back to the popover trigger or
 * let focus proceed normally if user moved to another interactive
 * element in the viewport.
 */


function useFocusOnHide(containerRef, options) {
  var shouldFocusProp = options.shouldFocus,
      visible = options.visible,
      focusRef = options.focusRef;
  var shouldFocus = shouldFocusProp && !visible;
  useUpdateEffect(function () {
    if (!shouldFocus) return;

    if (preventReturnFocus(containerRef)) {
      return;
    }

    var el = (focusRef == null ? void 0 : focusRef.current) || containerRef.current;

    if (el) {
      focus(el, {
        nextTick: true
      });
    }
  }, [shouldFocus, containerRef, focusRef]);
}

/**
 * Credit goes to `framer-motion` of this useful utilities.
 * License can be found here: https://github.com/framer/motion
 */
/**
 * @internal
 */

function usePointerEvent(env, eventName, handler, options) {
  return useEventListener(getPointerEventName(eventName), wrapPointerEventHandler(handler, eventName === "pointerdown"), env, options);
}

/**
 * Polyfill to get `relatedTarget` working correctly consistently
 * across all browsers.
 *
 * It ensures that elements receives focus on pointer down if
 * it's not the active element.
 *
 * @internal
 */
function useFocusOnPointerDown(props) {
  var ref = props.ref,
      elements = props.elements,
      enabled = props.enabled;
  var isSafari = detectBrowser("Safari");

  var doc = function doc() {
    return getOwnerDocument(ref.current);
  };

  usePointerEvent(doc, "pointerdown", function (event) {
    if (!isSafari || !enabled) return;
    var target = event.target;
    var els = elements != null ? elements : [ref];
    var isValidTarget = els.some(function (elementOrRef) {
      var el = isRefObject(elementOrRef) ? elementOrRef.current : elementOrRef;
      return contains(el, target);
    });

    if (!isActiveElement(target) && isValidTarget) {
      event.preventDefault();
      focus(target);
    }
  });
}

var defaultOptions = {
  preventScroll: true,
  shouldFocus: false
};
function useFocusOnShow(target, options) {
  if (options === void 0) {
    options = defaultOptions;
  }

  var _options = options,
      focusRef = _options.focusRef,
      preventScroll = _options.preventScroll,
      shouldFocus = _options.shouldFocus,
      visible = _options.visible;
  var element = isRefObject(target) ? target.current : target;
  var autoFocus = shouldFocus && visible;
  var onFocus = useCallback(function () {
    if (!element || !autoFocus) return;
    if (contains(element, document.activeElement)) return;

    if (focusRef != null && focusRef.current) {
      focus(focusRef.current, {
        preventScroll: preventScroll,
        nextTick: true
      });
    } else {
      var tabbableEls = getAllFocusable(element);

      if (tabbableEls.length > 0) {
        focus(tabbableEls[0], {
          preventScroll: preventScroll,
          nextTick: true
        });
      }
    }
  }, [autoFocus, preventScroll, element, focusRef]);
  useUpdateEffect(function () {
    onFocus();
  }, [onFocus]);
  useEventListener("transitionend", onFocus, element);
}

function useUnmountEffect(fn, deps) {
  if (deps === void 0) {
    deps = [];
  }

  return React.useEffect(function () {
    return function () {
      return fn();
    };
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  deps);
}

function useForceUpdate() {
  var unloadingRef = React.useRef(false);

  var _React$useState = React.useState(0),
      count = _React$useState[0],
      setCount = _React$useState[1];

  useUnmountEffect(function () {
    unloadingRef.current = true;
  });
  return React.useCallback(function () {
    if (!unloadingRef.current) {
      setCount(count + 1);
    }
  }, [count]);
}

/**
 * React Hook that provides a declarative `setInterval`
 *
 * @param callback the callback to execute at interval
 * @param delay the `setInterval` delay (in ms)
 */

function useInterval(callback, delay) {
  var fn = useCallbackRef(callback);
  React.useEffect(function () {
    var intervalId = null;

    var tick = function tick() {
      return fn();
    };

    if (delay !== null) {
      intervalId = window.setInterval(tick, delay);
    }

    return function () {
      if (intervalId) {
        window.clearInterval(intervalId);
      }
    };
  }, [delay, fn]);
}

/**
 * React hook to persist any value between renders,
 * but keeps it up-to-date if it changes.
 *
 * @param value the value or function to persist
 */

function useLatestRef(value) {
  var ref = React.useRef(null);
  ref.current = value;
  return ref;
}

/* eslint-disable react-hooks/exhaustive-deps */
function assignRef(ref, value) {
  if (ref == null) return;

  if (typeof ref === "function") {
    ref(value);
    return;
  }

  try {
    // @ts-ignore
    ref.current = value;
  } catch (error) {
    throw new Error("Cannot assign value '" + value + "' to ref '" + ref + "'");
  }
}
/**
 * React hook that merges react refs into a single memoized function
 *
 * @example
 * import React from "react";
 * import { useMergeRefs } from `@chakra-ui/hooks`;
 *
 * const Component = React.forwardRef((props, ref) => {
 *   const internalRef = React.useRef();
 *   return <div {...props} ref={useMergeRefs(internalRef, ref)} />;
 * });
 */

function useMergeRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }

  return react__WEBPACK_IMPORTED_MODULE_0__.useMemo(function () {
    if (refs.every(function (ref) {
      return ref == null;
    })) {
      return null;
    }

    return function (node) {
      refs.forEach(function (ref) {
        if (ref) assignRef(ref, node);
      });
    };
  }, refs);
}

/**
 * @deprecated `useMouseDownRef` will be removed in a future version.
 */

function useMouseDownRef(shouldListen) {
  if (shouldListen === void 0) {
    shouldListen = true;
  }

  var mouseDownRef = React__default.useRef();
  useEventListener("mousedown", function (event) {
    if (shouldListen) {
      mouseDownRef.current = event.target;
    }
  });
  return mouseDownRef;
}

/**
 * Example, used in components like Dialogs and Popovers, so they can close
 * when a user clicks outside them.
 */
function useOutsideClick(props) {
  var ref = props.ref,
      handler = props.handler,
      _props$enabled = props.enabled,
      enabled = _props$enabled === void 0 ? true : _props$enabled;
  var savedHandler = useCallbackRef(handler);
  var stateRef = useRef({
    isPointerDown: false,
    ignoreEmulatedMouseEvents: false
  });
  var state = stateRef.current;
  useEffect(function () {
    if (!enabled) return;

    var onPointerDown = function onPointerDown(e) {
      if (isValidEvent(e, ref)) {
        state.isPointerDown = true;
      }
    };

    var onMouseUp = function onMouseUp(event) {
      if (state.ignoreEmulatedMouseEvents) {
        state.ignoreEmulatedMouseEvents = false;
        return;
      }

      if (state.isPointerDown && handler && isValidEvent(event, ref)) {
        state.isPointerDown = false;
        savedHandler(event);
      }
    };

    var onTouchEnd = function onTouchEnd(event) {
      state.ignoreEmulatedMouseEvents = true;

      if (handler && state.isPointerDown && isValidEvent(event, ref)) {
        state.isPointerDown = false;
        savedHandler(event);
      }
    };

    var doc = getOwnerDocument(ref.current);
    doc.addEventListener("mousedown", onPointerDown, true);
    doc.addEventListener("mouseup", onMouseUp, true);
    doc.addEventListener("touchstart", onPointerDown, true);
    doc.addEventListener("touchend", onTouchEnd, true);
    return function () {
      doc.removeEventListener("mousedown", onPointerDown, true);
      doc.removeEventListener("mouseup", onMouseUp, true);
      doc.removeEventListener("touchstart", onPointerDown, true);
      doc.removeEventListener("touchend", onTouchEnd, true);
    };
  }, [handler, ref, savedHandler, state, enabled]);
}

function isValidEvent(event, ref) {
  var _ref$current;

  var target = event.target;
  if (event.button > 0) return false; // if the event target is no longer in the document

  if (target) {
    var doc = getOwnerDocument(target);
    if (!doc.body.contains(target)) return false;
  }

  return !((_ref$current = ref.current) != null && _ref$current.contains(target));
}

function usePanGesture(ref, props) {
  var onPan = props.onPan,
      onPanStart = props.onPanStart,
      onPanEnd = props.onPanEnd,
      onPanSessionStart = props.onPanSessionStart,
      onPanSessionEnd = props.onPanSessionEnd,
      threshold = props.threshold;
  var hasPanEvents = Boolean(onPan || onPanStart || onPanEnd || onPanSessionStart || onPanSessionEnd);
  var panSession = useRef(null);
  var handlers = {
    onSessionStart: onPanSessionStart,
    onSessionEnd: onPanSessionEnd,
    onStart: onPanStart,
    onMove: onPan,
    onEnd: function onEnd(event, info) {
      panSession.current = null;
      onPanEnd == null ? void 0 : onPanEnd(event, info);
    }
  };
  useEffect(function () {
    var _panSession$current;

    (_panSession$current = panSession.current) == null ? void 0 : _panSession$current.updateHandlers(handlers);
  });

  function onPointerDown(event) {
    panSession.current = new PanSession(event, handlers, threshold);
  }

  usePointerEvent(function () {
    return ref.current;
  }, "pointerdown", hasPanEvents ? onPointerDown : noop);
  useUnmountEffect(function () {
    var _panSession$current2;

    (_panSession$current2 = panSession.current) == null ? void 0 : _panSession$current2.end();
    panSession.current = null;
  });
}

function usePrevious(value) {
  var ref = useRef();
  useEffect(function () {
    ref.current = value;
  }, [value]);
  return ref.current;
}

/**
 * Checks if the key pressed is a printable character
 * and can be used for shortcut navigation
 */

function isPrintableCharacter(event) {
  var key = event.key;
  return key.length === 1 || key.length > 1 && /[^a-zA-Z0-9]/.test(key);
}

/**
 * React hook that provides an enhanced keydown handler,
 * that's used for key navigation within menus, select dropdowns.
 */
function useShortcut(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      _props$timeout = _props.timeout,
      timeout = _props$timeout === void 0 ? 300 : _props$timeout,
      _props$preventDefault = _props.preventDefault,
      preventDefault = _props$preventDefault === void 0 ? function () {
    return true;
  } : _props$preventDefault;

  var _React$useState = React.useState([]),
      keys = _React$useState[0],
      setKeys = _React$useState[1];

  var timeoutRef = React.useRef();

  var flush = function flush() {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  };

  var clearKeysAfterDelay = function clearKeysAfterDelay() {
    flush();
    timeoutRef.current = setTimeout(function () {
      setKeys([]);
      timeoutRef.current = null;
    }, timeout);
  };

  React.useEffect(function () {
    return flush;
  }, []);

  function onKeyDown(fn) {
    return function (event) {
      if (event.key === "Backspace") {
        var keysCopy = [].concat(keys);
        keysCopy.pop();
        setKeys(keysCopy);
        return;
      }

      if (isPrintableCharacter(event)) {
        var _keysCopy = keys.concat(event.key);

        if (preventDefault(event)) {
          event.preventDefault();
          event.stopPropagation();
        }

        setKeys(_keysCopy);
        fn(_keysCopy.join(""));
        clearKeysAfterDelay();
      }
    };
  }

  return onKeyDown;
}

/**
 * React hook that provides a declarative `setTimeout`
 *
 * @param callback the callback to run after specified delay
 * @param delay the delay (in ms)
 */

function useTimeout(callback, delay) {
  var fn = useCallbackRef(callback);
  React.useEffect(function () {
    if (delay == null) return undefined;
    var timeoutId = null;
    timeoutId = window.setTimeout(function () {
      fn();
    }, delay);
    return function () {
      if (timeoutId) {
        window.clearTimeout(timeoutId);
      }
    };
  }, [delay, fn]);
}

function useWhyDidYouUpdate(name, props) {
  var previousProps = React.useRef();
  React.useEffect(function () {
    if (previousProps.current) {
      var allKeys = Object.keys(_extends({}, previousProps.current, props));
      var changesObj = {};
      allKeys.forEach(function (key) {
        if (previousProps.current[key] !== props[key]) {
          changesObj[key] = {
            from: previousProps.current[key],
            to: props[key]
          };
        }
      });

      if (Object.keys(changesObj).length) {
        console.log("[why-did-you-update]", name, changesObj);
      }
    }

    previousProps.current = props;
  });
}




/***/ }),

/***/ 24614:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f6": function() { return /* binding */ ThemeProvider; },
  "Gp": function() { return /* binding */ forwardRef; },
  "zo": function() { return /* binding */ styled; }
});

// UNUSED EXPORTS: CSSVars, ColorModeContext, ColorModeProvider, ColorModeScript, DarkMode, GlobalStyle, LightMode, StylesProvider, addPrefix, background, border, calc, chakra, color, cookieStorageManager, css, cssVar, effect, filter, flattenTokens, flexbox, getCss, grid, interactivity, isStyleProp, keyframes, layout, layoutPropNames, list, localStorageManager, omitThemingProps, others, position, propNames, pseudoPropNames, pseudoSelectors, ring, scroll, setScript, shouldForwardProp, space, storageKey, systemProps, textDecoration, toCSSObject, toCSSVar, toVarDefinition, toVarReference, tokenToCSSVar, transform, transition, typography, useChakra, useColorMode, useColorModeValue, useMultiStyleConfig, useProps, useStyleConfig, useStyles, useTheme, useToken

// EXTERNAL MODULE: ./node_modules/lodash.mergewith/index.js
var lodash_mergewith = __webpack_require__(38554);
var lodash_mergewith_default = /*#__PURE__*/__webpack_require__.n(lodash_mergewith);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/utils/node_modules/framesync/dist/es/on-next-frame.js
var defaultTimestep = (1 / 60) * 1000;
var getCurrentTime = typeof performance !== "undefined"
    ? function () { return performance.now(); }
    : function () { return Date.now(); };
var onNextFrame = typeof window !== "undefined"
    ? function (callback) {
        return window.requestAnimationFrame(callback);
    }
    : function (callback) {
        return setTimeout(function () { return callback(getCurrentTime()); }, defaultTimestep);
    };



;// CONCATENATED MODULE: ./node_modules/@chakra-ui/utils/node_modules/framesync/dist/es/create-render-step.js
function createRenderStep(runNextFrame) {
    var toRun = [];
    var toRunNextFrame = [];
    var numToRun = 0;
    var isProcessing = false;
    var toKeepAlive = new WeakSet();
    var step = {
        schedule: function (callback, keepAlive, immediate) {
            if (keepAlive === void 0) { keepAlive = false; }
            if (immediate === void 0) { immediate = false; }
            var addToCurrentFrame = immediate && isProcessing;
            var buffer = addToCurrentFrame ? toRun : toRunNextFrame;
            if (keepAlive)
                toKeepAlive.add(callback);
            if (buffer.indexOf(callback) === -1) {
                buffer.push(callback);
                if (addToCurrentFrame && isProcessing)
                    numToRun = toRun.length;
            }
            return callback;
        },
        cancel: function (callback) {
            var index = toRunNextFrame.indexOf(callback);
            if (index !== -1)
                toRunNextFrame.splice(index, 1);
            toKeepAlive.delete(callback);
        },
        process: function (frameData) {
            var _a;
            isProcessing = true;
            _a = [toRunNextFrame, toRun], toRun = _a[0], toRunNextFrame = _a[1];
            toRunNextFrame.length = 0;
            numToRun = toRun.length;
            if (numToRun) {
                for (var i = 0; i < numToRun; i++) {
                    var callback = toRun[i];
                    callback(frameData);
                    if (toKeepAlive.has(callback)) {
                        step.schedule(callback);
                        runNextFrame();
                    }
                }
            }
            isProcessing = false;
        },
    };
    return step;
}



;// CONCATENATED MODULE: ./node_modules/@chakra-ui/utils/node_modules/framesync/dist/es/index.js



var maxElapsed = 40;
var useDefaultElapsed = true;
var runNextFrame = false;
var isProcessing = false;
var es_frame = {
    delta: 0,
    timestamp: 0
};
var stepsOrder = ["read", "update", "preRender", "render", "postRender"];
var steps = /*#__PURE__*/stepsOrder.reduce(function (acc, key) {
    acc[key] = createRenderStep(function () {
        return runNextFrame = true;
    });
    return acc;
}, {});
var es_sync = /*#__PURE__*/stepsOrder.reduce(function (acc, key) {
    var step = steps[key];
    acc[key] = function (process, keepAlive, immediate) {
        if (keepAlive === void 0) {
            keepAlive = false;
        }
        if (immediate === void 0) {
            immediate = false;
        }
        if (!runNextFrame) startLoop();
        return step.schedule(process, keepAlive, immediate);
    };
    return acc;
}, {});
var es_cancelSync = /*#__PURE__*/stepsOrder.reduce(function (acc, key) {
    acc[key] = steps[key].cancel;
    return acc;
}, {});
var flushSync = /*#__PURE__*/stepsOrder.reduce(function (acc, key) {
    acc[key] = function () {
        return steps[key].process(es_frame);
    };
    return acc;
}, {});
var processStep = function (stepId) {
    return steps[stepId].process(es_frame);
};
var processFrame = function (timestamp) {
    runNextFrame = false;
    es_frame.delta = useDefaultElapsed ? defaultTimestep : Math.max(Math.min(timestamp - es_frame.timestamp, maxElapsed), 1);
    es_frame.timestamp = timestamp;
    isProcessing = true;
    stepsOrder.forEach(processStep);
    isProcessing = false;
    if (runNextFrame) {
        useDefaultElapsed = false;
        onNextFrame(processFrame);
    }
};
var startLoop = function () {
    runNextFrame = true;
    useDefaultElapsed = true;
    if (!isProcessing) onNextFrame(processFrame);
};
var es_getFrameData = function () {
    return es_frame;
};

/* harmony default export */ var es = ((/* unused pure expression or super */ null && (es_sync)));


;// CONCATENATED MODULE: ./node_modules/@chakra-ui/utils/dist/chakra-ui-utils.esm.js




function getFirstItem(array) {
  return array != null && array.length ? array[0] : undefined;
}
function getLastItem(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}
function getPrevItem(index, array, loop) {
  if (loop === void 0) {
    loop = true;
  }

  var prevIndex = getPrevIndex(index, array.length, loop);
  return array[prevIndex];
}
function getNextItem(index, array, loop) {
  if (loop === void 0) {
    loop = true;
  }

  var nextIndex = getNextIndex(index, array.length, 1, loop);
  return array[nextIndex];
}
function removeIndex(array, index) {
  return array.filter(function (_, idx) {
    return idx !== index;
  });
}
function addItem(array, item) {
  return [].concat(array, [item]);
}
function removeItem(array, item) {
  return array.filter(function (eachItem) {
    return eachItem !== item;
  });
}
/**
 * Get the next index based on the current index and step.
 *
 * @param currentIndex the current index
 * @param length the total length or count of items
 * @param step the number of steps
 * @param loop whether to circle back once `currentIndex` is at the start/end
 */

function getNextIndex(currentIndex, length, step, loop) {
  if (step === void 0) {
    step = 1;
  }

  if (loop === void 0) {
    loop = true;
  }

  var lastIndex = length - 1;

  if (currentIndex === -1) {
    return step > 0 ? 0 : lastIndex;
  }

  var nextIndex = currentIndex + step;

  if (nextIndex < 0) {
    return loop ? lastIndex : 0;
  }

  if (nextIndex >= length) {
    if (loop) return 0;
    return currentIndex > length ? length : currentIndex;
  }

  return nextIndex;
}
/**
 * Get's the previous index based on the current index.
 * Mostly used for keyboard navigation.
 *
 * @param index - the current index
 * @param count - the length or total count of items in the array
 * @param loop - whether we should circle back to the
 * first/last once `currentIndex` is at the start/end
 */

function getPrevIndex(index, count, loop) {
  if (loop === void 0) {
    loop = true;
  }

  return getNextIndex(index, count, -1, loop);
}
/**
 * Converts an array into smaller chunks or groups.
 *
 * @param array the array to chunk into group
 * @param size the length of each chunk
 */

function chunk(array, size) {
  return array.reduce(function (rows, currentValue, index) {
    if (index % size === 0) {
      rows.push([currentValue]);
    } else {
      rows[rows.length - 1].push(currentValue);
    }

    return rows;
  }, []);
}
/**
 * Gets the next item based on a search string
 *
 * @param items array of items
 * @param searchString the search string
 * @param itemToString resolves an item to string
 * @param currentItem the current selected item
 */

function getNextItemFromSearch(items, searchString, itemToString, currentItem) {
  if (searchString == null) {
    return currentItem;
  } // If current item doesn't exist, find the item that matches the search string


  if (!currentItem) {
    var foundItem = items.find(function (item) {
      return itemToString(item).toLowerCase().startsWith(searchString.toLowerCase());
    });
    return foundItem;
  } // Filter items for ones that match the search string (case insensitive)


  var matchingItems = items.filter(function (item) {
    return itemToString(item).toLowerCase().startsWith(searchString.toLowerCase());
  }); // If there's a match, let's get the next item to select

  if (matchingItems.length > 0) {
    var nextIndex; // If the currentItem is in the available items, we move to the next available option

    if (matchingItems.includes(currentItem)) {
      var currentIndex = matchingItems.indexOf(currentItem);
      nextIndex = currentIndex + 1;

      if (nextIndex === matchingItems.length) {
        nextIndex = 0;
      }

      return matchingItems[nextIndex];
    } // Else, we pick the first item in the available items


    nextIndex = items.indexOf(matchingItems[0]);
    return items[nextIndex];
  } // a decent fallback to the currentItem


  return currentItem;
}

// Number assertions
function isNumber(value) {
  return typeof value === "number";
}
function isNotNumber(value) {
  return typeof value !== "number" || Number.isNaN(value) || !Number.isFinite(value);
}
function isNumeric(value) {
  return value != null && value - parseFloat(value) + 1 >= 0;
} // Array assertions

function isArray(value) {
  return Array.isArray(value);
}
function isEmptyArray(value) {
  return isArray(value) && value.length === 0;
} // Function assertions

function chakra_ui_utils_esm_isFunction(value) {
  return typeof value === "function";
} // Generic assertions

function isDefined(value) {
  return typeof value !== "undefined" && value !== undefined;
}
function isUndefined(value) {
  return typeof value === "undefined" || value === undefined;
} // Object assertions

function isObject(value) {
  var type = typeof value;
  return value != null && (type === "object" || type === "function") && !isArray(value);
}
function isEmptyObject(value) {
  return isObject(value) && Object.keys(value).length === 0;
}
function isNotEmptyObject(value) {
  return value && !isEmptyObject(value);
}
function isNull(value) {
  return value == null;
} // String assertions

function isString(value) {
  return Object.prototype.toString.call(value) === "[object String]";
}
function isCssVar(value) {
  return /^var\(--.+\)$/.test(value);
} // Empty assertions

function isEmpty(value) {
  if (isArray(value)) return isEmptyArray(value);
  if (isObject(value)) return isEmptyObject(value);
  if (value == null || value === "") return true;
  return false;
}
var __DEV__ = "production" !== "production";
var __TEST__ = (/* unused pure expression or super */ null && ("production" === "test"));
function isRefObject(val) {
  return "current" in val;
}
function isInputEvent(value) {
  return value && isObject(value) && isObject(value.target);
}

function chakra_ui_utils_esm_omit(object, keys) {
  var result = {};
  Object.keys(object).forEach(function (key) {
    if (keys.includes(key)) return;
    result[key] = object[key];
  });
  return result;
}
function pick(object, keys) {
  var result = {};
  keys.forEach(function (key) {
    if (key in object) {
      result[key] = object[key];
    }
  });
  return result;
}
function split(object, keys) {
  var picked = {};
  var omitted = {};
  Object.keys(object).forEach(function (key) {
    if (keys.includes(key)) {
      picked[key] = object[key];
    } else {
      omitted[key] = object[key];
    }
  });
  return [picked, omitted];
}
/**
 * Get value from a deeply nested object using a string path.
 * Memoizes the value.
 * @param obj - the object
 * @param path - the string path
 * @param def  - the fallback value
 */

function get(obj, path, fallback, index) {
  var key = typeof path === "string" ? path.split(".") : [path];

  for (index = 0; index < key.length; index += 1) {
    if (!obj) break;
    obj = obj[key[index]];
  }

  return obj === undefined ? fallback : obj;
}
var memoize = function memoize(fn) {
  var cache = new WeakMap();

  var memoizedFn = function memoizedFn(obj, path, fallback, index) {
    if (typeof obj === "undefined") {
      return fn(obj, path, fallback);
    }

    if (!cache.has(obj)) {
      cache.set(obj, new Map());
    }

    var map = cache.get(obj);

    if (map.has(path)) {
      return map.get(path);
    }

    var value = fn(obj, path, fallback, index);
    map.set(path, value);
    return value;
  };

  return memoizedFn;
};
var chakra_ui_utils_esm_memoizedGet = memoize(get);
/**
 * Get value from deeply nested object, based on path
 * It returns the path value if not found in object
 *
 * @param path - the string path or value
 * @param scale - the string path or value
 */

function getWithDefault(path, scale) {
  return chakra_ui_utils_esm_memoizedGet(scale, path, path);
}

/**
 * Returns the items of an object that meet the condition specified in a callback function.
 *
 * @param object the object to loop through
 * @param fn The filter function
 */
function objectFilter(object, fn) {
  var result = {};
  Object.keys(object).forEach(function (key) {
    var value = object[key];
    var shouldPass = fn(value, key, object);

    if (shouldPass) {
      result[key] = value;
    }
  });
  return result;
}
var chakra_ui_utils_esm_filterUndefined = function filterUndefined(object) {
  return objectFilter(object, function (val) {
    return val !== null && val !== undefined;
  });
};
var objectKeys = function objectKeys(obj) {
  return Object.keys(obj);
};
/**
 * Object.entries polyfill for Nodev10 compatibility
 */

var fromEntries = function fromEntries(entries) {
  return entries.reduce(function (carry, _ref) {
    var key = _ref[0],
        value = _ref[1];
    carry[key] = value;
    return carry;
  }, {});
};
/**
 * Get the CSS variable ref stored in the theme
 */

var getCSSVar = function getCSSVar(theme, scale, value) {
  var _theme$__cssMap$$varR, _theme$__cssMap$;

  return (_theme$__cssMap$$varR = (_theme$__cssMap$ = theme.__cssMap[scale + "." + value]) == null ? void 0 : _theme$__cssMap$.varRef) != null ? _theme$__cssMap$$varR : value;
};

function analyzeCSSValue(value) {
  var num = parseFloat(value.toString());
  var unit = value.toString().replace(String(num), "");
  return {
    unitless: !unit,
    value: num,
    unit: unit
  };
}

function px(value) {
  if (value == null) return value;

  var _analyzeCSSValue = analyzeCSSValue(value),
      unitless = _analyzeCSSValue.unitless;

  return unitless || isNumber(value) ? value + "px" : value;
}

var sortByBreakpointValue = function sortByBreakpointValue(a, b) {
  return parseInt(a[1], 10) > parseInt(b[1], 10) ? 1 : -1;
};

var sortBps = function sortBps(breakpoints) {
  return fromEntries(Object.entries(breakpoints).sort(sortByBreakpointValue));
};

function normalize(breakpoints) {
  var sorted = sortBps(breakpoints);
  return Object.assign(Object.values(sorted), sorted);
}

function keys(breakpoints) {
  var value = Object.keys(sortBps(breakpoints));
  return new Set(value);
}

function subtract(value) {
  var _px;

  if (!value) return value;
  value = (_px = px(value)) != null ? _px : value;
  var factor = value.endsWith("px") ? -1 : // the equivalent of 1px in em using a 16px base
  -0.0635;
  return isNumber(value) ? "" + (value + factor) : value.replace(/([0-9]+\.?[0-9]*)/, function (m) {
    return "" + (parseFloat(m) + factor);
  });
}

function queryString(min, max) {
  var query = ["@media screen"];
  if (min) query.push("and", "(min-width: " + px(min) + ")");
  if (max) query.push("and", "(max-width: " + px(max) + ")");
  return query.join(" ");
}

function analyzeBreakpoints(breakpoints) {
  var _breakpoints$base;

  if (!breakpoints) return null;
  breakpoints.base = (_breakpoints$base = breakpoints.base) != null ? _breakpoints$base : "0px";
  var normalized = normalize(breakpoints);
  var queries = Object.entries(breakpoints).sort(sortByBreakpointValue).map(function (_ref, index, entry) {
    var _entry;

    var breakpoint = _ref[0],
        minW = _ref[1];

    var _ref2 = (_entry = entry[index + 1]) != null ? _entry : [],
        maxW = _ref2[1];

    maxW = parseFloat(maxW) > 0 ? subtract(maxW) : undefined;
    return {
      breakpoint: breakpoint,
      minW: minW,
      maxW: maxW,
      maxWQuery: queryString(null, maxW),
      minWQuery: queryString(minW),
      minMaxQuery: queryString(minW, maxW)
    };
  });

  var _keys = keys(breakpoints);

  var _keysArr = Array.from(_keys.values());

  return {
    keys: _keys,
    normalized: normalized,
    isResponsive: function isResponsive(test) {
      var keys = Object.keys(test);
      return keys.length > 0 && keys.every(function (key) {
        return _keys.has(key);
      });
    },
    asObject: sortBps(breakpoints),
    asArray: normalize(breakpoints),
    details: queries,
    media: [null].concat(normalized.map(function (minW) {
      return queryString(minW);
    }).slice(1)),
    toArrayValue: function toArrayValue(test) {
      if (!isObject(test)) {
        throw new Error("toArrayValue: value must be an object");
      }

      var result = _keysArr.map(function (bp) {
        var _test$bp;

        return (_test$bp = test[bp]) != null ? _test$bp : null;
      });

      while (getLastItem(result) === null) {
        result.pop();
      }

      return result;
    },
    toObjectValue: function toObjectValue(test) {
      if (!Array.isArray(test)) {
        throw new Error("toObjectValue: value must be an array");
      }

      return test.reduce(function (acc, value, index) {
        var key = _keysArr[index];
        if (key != null && value != null) acc[key] = value;
        return acc;
      }, {});
    }
  };
}

function isElement(el) {
  return el != null && typeof el == "object" && "nodeType" in el && el.nodeType === Node.ELEMENT_NODE;
}
function isHTMLElement(el) {
  var _el$ownerDocument$def;

  if (!isElement(el)) {
    return false;
  }

  var win = (_el$ownerDocument$def = el.ownerDocument.defaultView) != null ? _el$ownerDocument$def : window;
  return el instanceof win.HTMLElement;
}
function getOwnerWindow(node) {
  var _getOwnerDocument$def, _getOwnerDocument;

  return isElement(node) ? (_getOwnerDocument$def = (_getOwnerDocument = getOwnerDocument(node)) == null ? void 0 : _getOwnerDocument.defaultView) != null ? _getOwnerDocument$def : window : window;
}
function getOwnerDocument(node) {
  var _node$ownerDocument;

  return isElement(node) ? (_node$ownerDocument = node.ownerDocument) != null ? _node$ownerDocument : document : document;
}
function getEventWindow(event) {
  var _view;

  return (_view = event.view) != null ? _view : window;
}
function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}
var isBrowser = canUseDOM();
var dataAttr = function dataAttr(condition) {
  return condition ? "" : undefined;
};
var ariaAttr = function ariaAttr(condition) {
  return condition ? true : undefined;
};
var cx = function cx() {
  for (var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++) {
    classNames[_key] = arguments[_key];
  }

  return classNames.filter(Boolean).join(" ");
};
function getActiveElement(node) {
  var doc = getOwnerDocument(node);
  return doc == null ? void 0 : doc.activeElement;
}
function contains(parent, child) {
  if (!parent) return false;
  return parent === child || parent.contains(child);
}
function addDomEvent(target, eventName, handler, options) {
  target.addEventListener(eventName, handler, options);
  return function () {
    target.removeEventListener(eventName, handler, options);
  };
}
/**
 * Get the normalized event key across all browsers
 * @param event keyboard event
 */

function normalizeEventKey(event) {
  var key = event.key,
      keyCode = event.keyCode;
  var isArrowKey = keyCode >= 37 && keyCode <= 40 && key.indexOf("Arrow") !== 0;
  var eventKey = isArrowKey ? "Arrow" + key : key;
  return eventKey;
}
function getRelatedTarget(event) {
  var _event$target, _event$relatedTarget;

  var target = (_event$target = event.target) != null ? _event$target : event.currentTarget;
  var activeElement = getActiveElement(target);
  return (_event$relatedTarget = event.relatedTarget) != null ? _event$relatedTarget : activeElement;
}
function isRightClick(event) {
  return event.button !== 0;
}

// Really great work done by Diego Haz on this one
var hasDisplayNone = function hasDisplayNone(element) {
  return window.getComputedStyle(element).display === "none";
};
var hasTabIndex = function hasTabIndex(element) {
  return element.hasAttribute("tabindex");
};
var hasNegativeTabIndex = function hasNegativeTabIndex(element) {
  return hasTabIndex(element) && element.tabIndex === -1;
};
function isDisabled(element) {
  return Boolean(element.getAttribute("disabled")) === true || Boolean(element.getAttribute("aria-disabled")) === true;
}
function isInputElement(element) {
  return isHTMLElement(element) && element.tagName.toLowerCase() === "input" && "select" in element;
}
function isActiveElement(element) {
  var doc = isHTMLElement(element) ? getOwnerDocument(element) : document;
  return doc.activeElement === element;
}
function hasFocusWithin(element) {
  if (!document.activeElement) return false;
  return element.contains(document.activeElement);
}
function isHidden(element) {
  if (element.parentElement && isHidden(element.parentElement)) return true;
  return element.hidden;
}
function isContentEditable(element) {
  var value = element.getAttribute("contenteditable");
  return value !== "false" && value != null;
}
function isFocusable(element) {
  if (!isHTMLElement(element) || isHidden(element) || isDisabled(element)) {
    return false;
  }

  var localName = element.localName;
  var focusableTags = ["input", "select", "textarea", "button"];
  if (focusableTags.indexOf(localName) >= 0) return true;
  var others = {
    a: function a() {
      return element.hasAttribute("href");
    },
    audio: function audio() {
      return element.hasAttribute("controls");
    },
    video: function video() {
      return element.hasAttribute("controls");
    }
  };

  if (localName in others) {
    return others[localName]();
  }

  if (isContentEditable(element)) return true;
  return hasTabIndex(element);
}
function isTabbable(element) {
  if (!element) return false;
  return isHTMLElement(element) && isFocusable(element) && !hasNegativeTabIndex(element);
}

var focusableElList = ["input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])", "embed", "iframe", "object", "a[href]", "area[href]", "button:not([disabled])", "[tabindex]", "audio[controls]", "video[controls]", "*[tabindex]:not([aria-disabled])", "*[contenteditable]"];
var focusableElSelector = focusableElList.join();
function getAllFocusable(container) {
  var focusableEls = Array.from(container.querySelectorAll(focusableElSelector));
  focusableEls.unshift(container);
  return focusableEls.filter(isFocusable).filter(function (el) {
    return window.getComputedStyle(el).display !== "none";
  });
}
function getFirstFocusable(container) {
  var allFocusable = getAllFocusable(container);
  return allFocusable.length ? allFocusable[0] : null;
}
function getAllTabbable(container, fallbackToFocusable) {
  var allFocusable = Array.from(container.querySelectorAll(focusableElSelector));
  var allTabbable = allFocusable.filter(isTabbable);

  if (isTabbable(container)) {
    allTabbable.unshift(container);
  }

  if (!allTabbable.length && fallbackToFocusable) {
    return allFocusable;
  }

  return allTabbable;
}
function getFirstTabbableIn(container, fallbackToFocusable) {
  var _getAllTabbable = getAllTabbable(container, fallbackToFocusable),
      first = _getAllTabbable[0];

  return first || null;
}
function getLastTabbableIn(container, fallbackToFocusable) {
  var allTabbable = getAllTabbable(container, fallbackToFocusable);
  return allTabbable[allTabbable.length - 1] || null;
}
function getNextTabbable(container, fallbackToFocusable) {
  var allFocusable = getAllFocusable(container);
  var index = allFocusable.indexOf(document.activeElement);
  var slice = allFocusable.slice(index + 1);
  return slice.find(isTabbable) || allFocusable.find(isTabbable) || (fallbackToFocusable ? slice[0] : null);
}
function getPreviousTabbable(container, fallbackToFocusable) {
  var allFocusable = getAllFocusable(container).reverse();
  var index = allFocusable.indexOf(document.activeElement);
  var slice = allFocusable.slice(index + 1);
  return slice.find(isTabbable) || allFocusable.find(isTabbable) || (fallbackToFocusable ? slice[0] : null);
}
function focusNextTabbable(container, fallbackToFocusable) {
  var nextTabbable = getNextTabbable(container, fallbackToFocusable);

  if (nextTabbable && isHTMLElement(nextTabbable)) {
    nextTabbable.focus();
  }
}
function focusPreviousTabbable(container, fallbackToFocusable) {
  var previousTabbable = getPreviousTabbable(container, fallbackToFocusable);

  if (previousTabbable && isHTMLElement(previousTabbable)) {
    previousTabbable.focus();
  }
}

function matches(element, selectors) {
  if ("matches" in element) return element.matches(selectors);
  if ("msMatchesSelector" in element) return element.msMatchesSelector(selectors);
  return element.webkitMatchesSelector(selectors);
}

function closest(element, selectors) {
  if ("closest" in element) return element.closest(selectors);

  do {
    if (matches(element, selectors)) return element;
    element = element.parentElement || element.parentNode;
  } while (element !== null && element.nodeType === 1);

  return null;
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/* eslint-disable no-nested-ternary */
function chakra_ui_utils_esm_runIfFn(valueOrFn) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return chakra_ui_utils_esm_isFunction(valueOrFn) ? valueOrFn.apply(void 0, args) : valueOrFn;
}
function callAllHandlers() {
  for (var _len2 = arguments.length, fns = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    fns[_key2] = arguments[_key2];
  }

  return function func(event) {
    fns.some(function (fn) {
      fn == null ? void 0 : fn(event);
      return event == null ? void 0 : event.defaultPrevented;
    });
  };
}
function callAll() {
  for (var _len3 = arguments.length, fns = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    fns[_key3] = arguments[_key3];
  }

  return function mergedFn(arg) {
    fns.forEach(function (fn) {
      fn == null ? void 0 : fn(arg);
    });
  };
}
var compose = function compose(fn1) {
  for (var _len4 = arguments.length, fns = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    fns[_key4 - 1] = arguments[_key4];
  }

  return fns.reduce(function (f1, f2) {
    return function () {
      return f1(f2.apply(void 0, arguments));
    };
  }, fn1);
};
function once(fn) {
  var result;
  return function func() {
    if (fn) {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      result = fn.apply(this, args);
      fn = null;
    }

    return result;
  };
}
var noop = function noop() {};
var warn = once(function (options) {
  return function () {
    var condition = options.condition,
        message = options.message;

    if (condition && __DEV__) {
      console.warn(message);
    }
  };
});
var error = once(function (options) {
  return function () {
    var condition = options.condition,
        message = options.message;

    if (condition && __DEV__) {
      console.error(message);
    }
  };
});
var pipe = function pipe() {
  for (var _len6 = arguments.length, fns = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    fns[_key6] = arguments[_key6];
  }

  return function (v) {
    return fns.reduce(function (a, b) {
      return b(a);
    }, v);
  };
};

var distance1D = function distance1D(a, b) {
  return Math.abs(a - b);
};

var isPoint = function isPoint(point) {
  return "x" in point && "y" in point;
};

function distance(a, b) {
  if (isNumber(a) && isNumber(b)) {
    return distance1D(a, b);
  }

  if (isPoint(a) && isPoint(b)) {
    var xDelta = distance1D(a.x, b.x);
    var yDelta = distance1D(a.y, b.y);
    return Math.sqrt(Math.pow(xDelta, 2) + Math.pow(yDelta, 2));
  }

  return 0;
}

function chakra_ui_utils_esm_focus(element, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$isActive = _options.isActive,
      isActive = _options$isActive === void 0 ? isActiveElement : _options$isActive,
      nextTick = _options.nextTick,
      _options$preventScrol = _options.preventScroll,
      preventScroll = _options$preventScrol === void 0 ? true : _options$preventScrol,
      _options$selectTextIf = _options.selectTextIfInput,
      selectTextIfInput = _options$selectTextIf === void 0 ? true : _options$selectTextIf;
  if (!element || isActive(element)) return -1;

  function triggerFocus() {
    if (!element) {
      warn({
        condition: true,
        message: "[chakra-ui]: can't call focus() on `null` or `undefined` element"
      });
      return;
    }

    if (supportsPreventScroll()) {
      element.focus({
        preventScroll: preventScroll
      });
    } else {
      element.focus();

      if (preventScroll) {
        var scrollableElements = getScrollableElements(element);
        restoreScrollPosition(scrollableElements);
      }
    }

    if (isInputElement(element) && selectTextIfInput) {
      element.select();
    }
  }

  if (nextTick) {
    return requestAnimationFrame(triggerFocus);
  }

  triggerFocus();
  return -1;
}
var supportsPreventScrollCached = null;

function supportsPreventScroll() {
  if (supportsPreventScrollCached == null) {
    supportsPreventScrollCached = false;

    try {
      var div = document.createElement("div");
      div.focus({
        get preventScroll() {
          supportsPreventScrollCached = true;
          return true;
        }

      });
    } catch (e) {// Ignore
    }
  }

  return supportsPreventScrollCached;
}

function getScrollableElements(element) {
  var _doc$defaultView;

  var doc = getOwnerDocument(element);
  var win = (_doc$defaultView = doc.defaultView) != null ? _doc$defaultView : window;
  var parent = element.parentNode;
  var scrollableElements = [];
  var rootScrollingElement = doc.scrollingElement || doc.documentElement;

  while (parent instanceof win.HTMLElement && parent !== rootScrollingElement) {
    if (parent.offsetHeight < parent.scrollHeight || parent.offsetWidth < parent.scrollWidth) {
      scrollableElements.push({
        element: parent,
        scrollTop: parent.scrollTop,
        scrollLeft: parent.scrollLeft
      });
    }

    parent = parent.parentNode;
  }

  if (rootScrollingElement instanceof win.HTMLElement) {
    scrollableElements.push({
      element: rootScrollingElement,
      scrollTop: rootScrollingElement.scrollTop,
      scrollLeft: rootScrollingElement.scrollLeft
    });
  }

  return scrollableElements;
}

function restoreScrollPosition(scrollableElements) {
  for (var _iterator = _createForOfIteratorHelperLoose(scrollableElements), _step; !(_step = _iterator()).done;) {
    var _step$value = _step.value,
        element = _step$value.element,
        scrollTop = _step$value.scrollTop,
        scrollLeft = _step$value.scrollLeft;
    element.scrollTop = scrollTop;
    element.scrollLeft = scrollLeft;
  }
}

function flatten(target, maxDepth) {
  if (maxDepth === void 0) {
    maxDepth = Infinity;
  }

  if (!isObject(target) && !Array.isArray(target) || !maxDepth) {
    return target;
  }

  return Object.entries(target).reduce(function (result, _ref) {
    var key = _ref[0],
        value = _ref[1];

    if (isObject(value) || isArray(value)) {
      Object.entries(flatten(value, maxDepth - 1)).forEach(function (_ref2) {
        var childKey = _ref2[0],
            childValue = _ref2[1];
        // e.g. gray.500
        result[key + "." + childKey] = childValue;
      });
    } else {
      // e.g. transparent
      result[key] = value;
    }

    return result;
  }, {});
}

/**
 * Determines whether the children of a disclosure widget
 * should be rendered or not, depending on the lazy behavior.
 *
 * Used in accordion, tabs, popover, menu and other disclosure
 * widgets.
 */
function determineLazyBehavior(options) {
  var hasBeenSelected = options.hasBeenSelected,
      isLazy = options.isLazy,
      isSelected = options.isSelected,
      _options$lazyBehavior = options.lazyBehavior,
      lazyBehavior = _options$lazyBehavior === void 0 ? "unmount" : _options$lazyBehavior; // if not lazy, always render the disclosure's content

  if (!isLazy) return true; // if the diclosure is selected, render the disclosure's content

  if (isSelected) return true; // if the disclosure was selected but not active, keep its content active

  if (lazyBehavior === "keepMounted" && hasBeenSelected) return true;
  return false;
}

var minSafeInteger = Number.MIN_SAFE_INTEGER || -9007199254740991;
var maxSafeInteger = Number.MAX_SAFE_INTEGER || 9007199254740991;

function toNumber(value) {
  var num = parseFloat(value);
  return isNotNumber(num) ? 0 : num;
}
/**
 * Converts a value to a specific precision (or decimal points).
 *
 * Returns a string representing a number in fixed-point notation.
 *
 * @param value the value to convert
 * @param precision the precision or decimal points
 */


function toPrecision(value, precision) {
  var nextValue = toNumber(value);
  var scaleFactor = Math.pow(10, precision != null ? precision : 10);
  nextValue = Math.round(nextValue * scaleFactor) / scaleFactor;
  return precision ? nextValue.toFixed(precision) : nextValue.toString();
}
/**
 * Counts the number of decimal places a number has
 *
 * @param value the decimal value to count
 */

function countDecimalPlaces(value) {
  if (!Number.isFinite(value)) return 0;
  var e = 1;
  var p = 0;

  while (Math.round(value * e) / e !== value) {
    e *= 10;
    p += 1;
  }

  return p;
}
/**
 * Convert a value to percentage based on lower and upper bound values
 *
 * @param value the value in number
 * @param min the minimum value
 * @param max the maximum value
 */

function valueToPercent(value, min, max) {
  return (value - min) * 100 / (max - min);
}
/**
 * Calculate the value based on percentage, lower and upper bound values
 *
 * @param percent the percent value in decimals (e.g 0.6, 0.3)
 * @param min the minimum value
 * @param max the maximum value
 */

function percentToValue(percent, min, max) {
  return (max - min) * percent + min;
}
/**
 * Rounds a specific value to the next or previous step
 *
 * @param value the value to round
 * @param from the number that stepping started from
 * @param step the specified step
 */

function roundValueToStep(value, from, step) {
  var nextValue = Math.round((value - from) / step) * step + from;
  var precision = countDecimalPlaces(step);
  return toPrecision(nextValue, precision);
}
/**
 * Clamps a value to ensure it stays within the min and max range.
 *
 * @param value the value to clamp
 * @param min the minimum value
 * @param max the maximum value
 */

function clampValue(value, min, max) {
  if (value == null) return value;
  warn({
    condition: max < min,
    message: "clamp: max cannot be less than min"
  });
  return Math.min(Math.max(value, min), max);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/**
 * Credit goes to `framer-motion` of this useful utilities.
 * License can be found here: https://github.com/framer/motion
 */
function isMouseEvent(event) {
  var win = getEventWindow(event); // PointerEvent inherits from MouseEvent so we can't use a straight instanceof check.

  if (typeof win.PointerEvent !== "undefined" && event instanceof win.PointerEvent) {
    return !!(event.pointerType === "mouse");
  }

  return event instanceof win.MouseEvent;
}
function isTouchEvent(event) {
  var hasTouches = !!event.touches;
  return hasTouches;
}

/**
 * Filters out events not attached to the primary pointer (currently left mouse button)
 * @param eventHandler
 */
function filterPrimaryPointer(eventHandler) {
  return function (event) {
    var win = getEventWindow(event);
    var isMouseEvent = event instanceof win.MouseEvent;
    var isPrimaryPointer = !isMouseEvent || isMouseEvent && event.button === 0;

    if (isPrimaryPointer) {
      eventHandler(event);
    }
  };
}

var defaultPagePoint = {
  pageX: 0,
  pageY: 0
};

function pointFromTouch(e, pointType) {
  if (pointType === void 0) {
    pointType = "page";
  }

  var primaryTouch = e.touches[0] || e.changedTouches[0];
  var point = primaryTouch || defaultPagePoint;
  return {
    x: point[pointType + "X"],
    y: point[pointType + "Y"]
  };
}

function pointFromMouse(point, pointType) {
  if (pointType === void 0) {
    pointType = "page";
  }

  return {
    x: point[pointType + "X"],
    y: point[pointType + "Y"]
  };
}

function extractEventInfo(event, pointType) {
  if (pointType === void 0) {
    pointType = "page";
  }

  return {
    point: isTouchEvent(event) ? pointFromTouch(event, pointType) : pointFromMouse(event, pointType)
  };
}
function getViewportPointFromEvent(event) {
  return extractEventInfo(event, "client");
}
var wrapPointerEventHandler = function wrapPointerEventHandler(handler, shouldFilterPrimaryPointer) {
  if (shouldFilterPrimaryPointer === void 0) {
    shouldFilterPrimaryPointer = false;
  }

  var listener = function listener(event) {
    return handler(event, extractEventInfo(event));
  };

  return shouldFilterPrimaryPointer ? filterPrimaryPointer(listener) : listener;
}; // We check for event support via functions in case they've been mocked by a testing suite.

var supportsPointerEvents = function supportsPointerEvents() {
  return isBrowser && window.onpointerdown === null;
};

var supportsTouchEvents = function supportsTouchEvents() {
  return isBrowser && window.ontouchstart === null;
};

var supportsMouseEvents = function supportsMouseEvents() {
  return isBrowser && window.onmousedown === null;
};

var mouseEventNames = {
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointercancel: "mousecancel",
  pointerover: "mouseover",
  pointerout: "mouseout",
  pointerenter: "mouseenter",
  pointerleave: "mouseleave"
};
var touchEventNames = {
  pointerdown: "touchstart",
  pointermove: "touchmove",
  pointerup: "touchend",
  pointercancel: "touchcancel"
};
function getPointerEventName(name) {
  if (supportsPointerEvents()) {
    return name;
  }

  if (supportsTouchEvents()) {
    return touchEventNames[name];
  }

  if (supportsMouseEvents()) {
    return mouseEventNames[name];
  }

  return name;
}
function addPointerEvent(target, eventName, handler, options) {
  return addDomEvent(target, getPointerEventName(eventName), wrapPointerEventHandler(handler, eventName === "pointerdown"), options);
}
function isMultiTouchEvent(event) {
  return isTouchEvent(event) && event.touches.length > 1;
}

/**
 * The event information passed to pan event handlers like `onPan`, `onPanStart`.
 *
 * It contains information about the current state of the tap gesture such as its
 * `point`, `delta`, and `offset`
 */

/**
 * @internal
 *
 * A Pan Session is recognized when the pointer is down
 * and moved in the allowed direction.
 */
var PanSession = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  /**
   * We use this to keep track of the `x` and `y` pan session history
   * as the pan event happens. It helps to calculate the `offset` and `delta`
   */
  // The pointer event that started the pan session
  // The current pointer event for the pan session
  // The current pointer event info for the pan session

  /**
   * Minimal pan distance required before recognizing the pan.
   * @default "3px"
   */
  function PanSession(_event, handlers, threshold) {
    var _this = this;

    this.history = [];
    this.startEvent = null;
    this.lastEvent = null;
    this.lastEventInfo = null;
    this.handlers = {};
    this.removeListeners = noop;
    this.threshold = 3;
    this.win = void 0;

    this.updatePoint = function () {
      if (!(_this.lastEvent && _this.lastEventInfo)) return;
      var info = getPanInfo(_this.lastEventInfo, _this.history);
      var isPanStarted = _this.startEvent !== null;

      var isDistancePastThreshold = distance(info.offset, {
        x: 0,
        y: 0
      }) >= _this.threshold;

      if (!isPanStarted && !isDistancePastThreshold) return;

      var _getFrameData = getFrameData(),
          timestamp = _getFrameData.timestamp;

      _this.history.push(_extends({}, info.point, {
        timestamp: timestamp
      }));

      var _this$handlers = _this.handlers,
          onStart = _this$handlers.onStart,
          onMove = _this$handlers.onMove;

      if (!isPanStarted) {
        onStart == null ? void 0 : onStart(_this.lastEvent, info);
        _this.startEvent = _this.lastEvent;
      }

      onMove == null ? void 0 : onMove(_this.lastEvent, info);
    };

    this.onPointerMove = function (event, info) {
      _this.lastEvent = event;
      _this.lastEventInfo = info; // Because Safari doesn't trigger mouseup events when it's above a `<select>`

      if (isMouseEvent(event) && event.buttons === 0) {
        _this.onPointerUp(event, info);

        return;
      } // Throttle mouse move event to once per frame


      sync.update(_this.updatePoint, true);
    };

    this.onPointerUp = function (event, info) {
      // notify pan session ended
      var panInfo = getPanInfo(info, _this.history);
      var _this$handlers2 = _this.handlers,
          onEnd = _this$handlers2.onEnd,
          onSessionEnd = _this$handlers2.onSessionEnd;
      onSessionEnd == null ? void 0 : onSessionEnd(event, panInfo);

      _this.end(); // if panning never started, no need to call `onEnd`
      // panning requires a pointermove of at least 3px


      if (!onEnd || !_this.startEvent) return;
      onEnd == null ? void 0 : onEnd(event, panInfo);
    };

    this.win = getEventWindow(_event); // If we have more than one touch, don't start detecting this gesture

    if (isMultiTouchEvent(_event)) return;
    this.handlers = handlers;

    if (threshold) {
      this.threshold = threshold;
    } // stop default browser behavior


    _event.stopPropagation();

    _event.preventDefault(); // get and save the `pointerdown` event info in history
    // we'll use it to compute the `offset`


    var _info = extractEventInfo(_event);

    var _getFrameData2 = getFrameData(),
        _timestamp = _getFrameData2.timestamp;

    this.history = [_extends({}, _info.point, {
      timestamp: _timestamp
    })]; // notify pan session start

    var onSessionStart = handlers.onSessionStart;
    onSessionStart == null ? void 0 : onSessionStart(_event, getPanInfo(_info, this.history)); // attach event listeners and return a single function to remove them all

    this.removeListeners = pipe(addPointerEvent(this.win, "pointermove", this.onPointerMove), addPointerEvent(this.win, "pointerup", this.onPointerUp), addPointerEvent(this.win, "pointercancel", this.onPointerUp));
  }

  var _proto = PanSession.prototype;

  _proto.updateHandlers = function updateHandlers(handlers) {
    this.handlers = handlers;
  };

  _proto.end = function end() {
    var _this$removeListeners;

    (_this$removeListeners = this.removeListeners) == null ? void 0 : _this$removeListeners.call(this);
    cancelSync.update(this.updatePoint);
  };

  return PanSession;
}()));

function subtractPoint(a, b) {
  return {
    x: a.x - b.x,
    y: a.y - b.y
  };
}

function startPanPoint(history) {
  return history[0];
}

function lastPanPoint(history) {
  return history[history.length - 1];
}

function getPanInfo(info, history) {
  return {
    point: info.point,
    delta: subtractPoint(info.point, lastPanPoint(history)),
    offset: subtractPoint(info.point, startPanPoint(history)),
    velocity: getVelocity(history, 0.1)
  };
}

function lastDevicePoint(history) {
  return history[history.length - 1];
}

var toMilliseconds = function toMilliseconds(seconds) {
  return seconds * 1000;
};

function getVelocity(history, timeDelta) {
  if (history.length < 2) {
    return {
      x: 0,
      y: 0
    };
  }

  var i = history.length - 1;
  var timestampedPoint = null;
  var lastPoint = lastDevicePoint(history);

  while (i >= 0) {
    timestampedPoint = history[i];

    if (lastPoint.timestamp - timestampedPoint.timestamp > toMilliseconds(timeDelta)) {
      break;
    }

    i--;
  }

  if (!timestampedPoint) {
    return {
      x: 0,
      y: 0
    };
  }

  var time = (lastPoint.timestamp - timestampedPoint.timestamp) / 1000;

  if (time === 0) {
    return {
      x: 0,
      y: 0
    };
  }

  var currentVelocity = {
    x: (lastPoint.x - timestampedPoint.x) / time,
    y: (lastPoint.y - timestampedPoint.y) / time
  };

  if (currentVelocity.x === Infinity) {
    currentVelocity.x = 0;
  }

  if (currentVelocity.y === Infinity) {
    currentVelocity.y = 0;
  }

  return currentVelocity;
}

var breakpoints = Object.freeze(["base", "sm", "md", "lg", "xl", "2xl"]);
function mapResponsive(prop, mapper) {
  if (isArray(prop)) {
    return prop.map(function (item) {
      if (item === null) {
        return null;
      }

      return mapper(item);
    });
  }

  if (isObject(prop)) {
    return objectKeys(prop).reduce(function (result, key) {
      result[key] = mapper(prop[key]);
      return result;
    }, {});
  }

  if (prop != null) {
    return mapper(prop);
  }

  return null;
}
function objectToArrayNotation(obj, bps) {
  if (bps === void 0) {
    bps = breakpoints;
  }

  var result = bps.map(function (br) {
    var _obj$br;

    return (_obj$br = obj[br]) != null ? _obj$br : null;
  });

  while (getLastItem(result) === null) {
    result.pop();
  }

  return result;
}
function arrayToObjectNotation(values, bps) {
  if (bps === void 0) {
    bps = breakpoints;
  }

  var result = {};
  values.forEach(function (value, index) {
    var key = bps[index];
    if (value == null) return;
    result[key] = value;
  });
  return result;
}
function isResponsiveObjectLike(obj, bps) {
  if (bps === void 0) {
    bps = breakpoints;
  }

  var keys = Object.keys(obj);
  return keys.length > 0 && keys.every(function (key) {
    return bps.includes(key);
  });
}
/**
 * since breakpoints are defined as custom properties on an array, you may
 * `Object.keys(theme.breakpoints)` to retrieve both regular numeric indices
 * and custom breakpoints as string.
 *
 * This function returns true given a custom array property.
 */

var isCustomBreakpoint = function isCustomBreakpoint(maybeBreakpoint) {
  return Number.isNaN(Number(maybeBreakpoint));
};

function getUserAgentBrowser(navigator) {
  var ua = navigator.userAgent,
      vendor = navigator.vendor;
  var android = /(android)/i.test(ua);

  switch (true) {
    case /CriOS/.test(ua):
      return "Chrome for iOS";

    case /Edg\//.test(ua):
      return "Edge";

    case android && /Silk\//.test(ua):
      return "Silk";

    case /Chrome/.test(ua) && /Google Inc/.test(vendor):
      return "Chrome";

    case /Firefox\/\d+\.\d+$/.test(ua):
      return "Firefox";

    case android:
      return "AOSP";

    case /MSIE|Trident/.test(ua):
      return "IE";

    case /Safari/.test(navigator.userAgent) && /Apple Computer/.test(ua):
      return "Safari";

    case /AppleWebKit/.test(ua):
      return "WebKit";

    default:
      return null;
  }
}

function getUserAgentOS(navigator) {
  var ua = navigator.userAgent,
      platform = navigator.platform;

  switch (true) {
    case /Android/.test(ua):
      return "Android";

    case /iPhone|iPad|iPod/.test(platform):
      return "iOS";

    case /Win/.test(platform):
      return "Windows";

    case /Mac/.test(platform):
      return "Mac";

    case /CrOS/.test(ua):
      return "Chrome OS";

    case /Firefox/.test(ua):
      return "Firefox OS";

    default:
      return null;
  }
}

function detectDeviceType(navigator) {
  var ua = navigator.userAgent;
  if (/(tablet)|(iPad)|(Nexus 9)/i.test(ua)) return "tablet";
  if (/(mobi)/i.test(ua)) return "phone";
  return "desktop";
}
function detectOS(os) {
  if (!isBrowser) return false;
  return getUserAgentOS(window.navigator) === os;
}
function detectBrowser(browser) {
  if (!isBrowser) return false;
  return getUserAgentBrowser(window.navigator) === browser;
}
function detectTouch() {
  if (!isBrowser) return false;
  return window.ontouchstart === null && window.ontouchmove === null && window.ontouchend === null;
}

function walkObject(target, predicate) {
  function inner(value, path) {
    if (path === void 0) {
      path = [];
    }

    if (isArray(value)) {
      return value.map(function (item, index) {
        return inner(item, [].concat(path, [String(index)]));
      });
    }

    if (isObject(value)) {
      return fromEntries(Object.entries(value).map(function (_ref) {
        var key = _ref[0],
            child = _ref[1];
        return [key, inner(child, [].concat(path, [key]))];
      }));
    }

    return predicate(value, path);
  }

  return inner(target);
}



;// CONCATENATED MODULE: ./node_modules/@chakra-ui/styled-system/dist/chakra-ui-styled-system.esm.js


function chakra_ui_styled_system_esm_extends() {
  chakra_ui_styled_system_esm_extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return chakra_ui_styled_system_esm_extends.apply(this, arguments);
}

var tokenToCSSVar = function tokenToCSSVar(scale, value) {
  return function (theme) {
    var valueStr = String(value);
    var key = scale ? scale + "." + valueStr : valueStr;
    return isObject(theme.__cssMap) && key in theme.__cssMap ? theme.__cssMap[key].varRef : value;
  };
};
function createTransform(options) {
  var scale = options.scale,
      transform = options.transform,
      compose = options.compose;

  var fn = function fn(value, theme) {
    var _transform;

    var _value = tokenToCSSVar(scale, value)(theme);

    var result = (_transform = transform == null ? void 0 : transform(_value, theme)) != null ? _transform : _value;

    if (compose) {
      result = compose(result, theme);
    }

    return result;
  };

  return fn;
}

function toConfig(scale, transform) {
  return function (property) {
    var result = {
      property: property,
      scale: scale
    };
    result.transform = createTransform({
      scale: scale,
      transform: transform
    });
    return result;
  };
}

var getRtl = function getRtl(_ref) {
  var rtl = _ref.rtl,
      ltr = _ref.ltr;
  return function (theme) {
    return theme.direction === "rtl" ? rtl : ltr;
  };
};

function logical(options) {
  var property = options.property,
      scale = options.scale,
      transform = options.transform;
  return {
    scale: scale,
    property: getRtl(property),
    transform: scale ? createTransform({
      scale: scale,
      compose: transform
    }) : transform
  };
}

var _spaceXTemplate, _spaceYTemplate;

/**
 * The CSS transform order following the upcoming spec from CSSWG
 * translate => rotate => scale => skew
 * @see https://drafts.csswg.org/css-transforms-2/#ctm
 * @see https://www.stefanjudis.com/blog/order-in-css-transformation-transform-functions-vs-individual-transforms/
 */
var transformTemplate = ["rotate(var(--chakra-rotate, 0))", "scaleX(var(--chakra-scale-x, 1))", "scaleY(var(--chakra-scale-y, 1))", "skewX(var(--chakra-skew-x, 0))", "skewY(var(--chakra-skew-y, 0))"];
function getTransformTemplate() {
  return ["translateX(var(--chakra-translate-x, 0))", "translateY(var(--chakra-translate-y, 0))"].concat(transformTemplate).join(" ");
}
function getTransformGpuTemplate() {
  return ["translate3d(var(--chakra-translate-x, 0), var(--chakra-translate-y, 0), 0)"].concat(transformTemplate).join(" ");
}
var filterTemplate = {
  "--chakra-blur": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-invert": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-sepia": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-drop-shadow": "var(--chakra-empty,/*!*/ /*!*/)",
  filter: ["var(--chakra-blur)", "var(--chakra-brightness)", "var(--chakra-contrast)", "var(--chakra-grayscale)", "var(--chakra-hue-rotate)", "var(--chakra-invert)", "var(--chakra-saturate)", "var(--chakra-sepia)", "var(--chakra-drop-shadow)"].join(" ")
};
var backdropFilterTemplate = {
  backdropFilter: ["var(--chakra-backdrop-blur)", "var(--chakra-backdrop-brightness)", "var(--chakra-backdrop-contrast)", "var(--chakra-backdrop-grayscale)", "var(--chakra-backdrop-hue-rotate)", "var(--chakra-backdrop-invert)", "var(--chakra-backdrop-opacity)", "var(--chakra-backdrop-saturate)", "var(--chakra-backdrop-sepia)"].join(" "),
  "--chakra-backdrop-blur": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-invert": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-opacity": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-sepia": "var(--chakra-empty,/*!*/ /*!*/)"
};
function getRingTemplate(value) {
  return {
    "--chakra-ring-offset-shadow": "var(--chakra-ring-inset) 0 0 0 var(--chakra-ring-offset-width) var(--chakra-ring-offset-color)",
    "--chakra-ring-shadow": "var(--chakra-ring-inset) 0 0 0 calc(var(--chakra-ring-width) + var(--chakra-ring-offset-width)) var(--chakra-ring-color)",
    "--chakra-ring-width": value,
    boxShadow: ["var(--chakra-ring-offset-shadow)", "var(--chakra-ring-shadow)", "var(--chakra-shadow, 0 0 #0000)"].join(", ")
  };
}
var flexDirectionTemplate = {
  "row-reverse": {
    space: "--chakra-space-x-reverse",
    divide: "--chakra-divide-x-reverse"
  },
  "column-reverse": {
    space: "--chakra-space-y-reverse",
    divide: "--chakra-divide-y-reverse"
  }
};
var owlSelector = "& > :not(style) ~ :not(style)";
var spaceXTemplate = (_spaceXTemplate = {}, _spaceXTemplate[owlSelector] = {
  marginInlineStart: "calc(var(--chakra-space-x) * calc(1 - var(--chakra-space-x-reverse)))",
  marginInlineEnd: "calc(var(--chakra-space-x) * var(--chakra-space-x-reverse))"
}, _spaceXTemplate);
var spaceYTemplate = (_spaceYTemplate = {}, _spaceYTemplate[owlSelector] = {
  marginTop: "calc(var(--chakra-space-y) * calc(1 - var(--chakra-space-y-reverse)))",
  marginBottom: "calc(var(--chakra-space-y) * var(--chakra-space-y-reverse))"
}, _spaceYTemplate);

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _wrapRegExp() {
  _wrapRegExp = function (re, groups) {
    return new BabelRegExp(re, undefined, groups);
  };

  var _super = RegExp.prototype;

  var _groups = new WeakMap();

  function BabelRegExp(re, flags, groups) {
    var _this = new RegExp(re, flags);

    _groups.set(_this, groups || _groups.get(re));

    return _setPrototypeOf(_this, BabelRegExp.prototype);
  }

  _inherits(BabelRegExp, RegExp);

  BabelRegExp.prototype.exec = function (str) {
    var result = _super.exec.call(this, str);

    if (result) result.groups = buildGroups(result, this);
    return result;
  };

  BabelRegExp.prototype[Symbol.replace] = function (str, substitution) {
    if (typeof substitution === "string") {
      var groups = _groups.get(this);

      return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) {
        return "$" + groups[name];
      }));
    } else if (typeof substitution === "function") {
      var _this = this;

      return _super[Symbol.replace].call(this, str, function () {
        var args = arguments;

        if (typeof args[args.length - 1] !== "object") {
          args = [].slice.call(args);
          args.push(buildGroups(args, _this));
        }

        return substitution.apply(this, args);
      });
    } else {
      return _super[Symbol.replace].call(this, str, substitution);
    }
  };

  function buildGroups(result, re) {
    var g = _groups.get(re);

    return Object.keys(g).reduce(function (groups, name) {
      groups[name] = result[g[name]];
      return groups;
    }, Object.create(null));
  }

  return _wrapRegExp.apply(this, arguments);
}

var directionMap = {
  "to-t": "to top",
  "to-tr": "to top right",
  "to-r": "to right",
  "to-br": "to bottom right",
  "to-b": "to bottom",
  "to-bl": "to bottom left",
  "to-l": "to left",
  "to-tl": "to top left"
};
var valueSet = new Set(Object.values(directionMap));
var globalSet = new Set(["none", "-moz-initial", "inherit", "initial", "revert", "unset"]);

var trimSpace = function trimSpace(str) {
  return str.trim();
};

function parseGradient(value, theme) {
  var _regex$exec$groups, _regex$exec;

  if (value == null || globalSet.has(value)) return value;

  var regex = /*#__PURE__*/_wrapRegExp(/(^[\x2DA-Za-z]+)\(((.*))\)/g, {
    type: 1,
    values: 2
  });

  var _ref = (_regex$exec$groups = (_regex$exec = regex.exec(value)) == null ? void 0 : _regex$exec.groups) != null ? _regex$exec$groups : {},
      type = _ref.type,
      values = _ref.values;

  if (!type || !values) return value;

  var _type = type.includes("-gradient") ? type : type + "-gradient";

  var _values$split$map$fil = values.split(",").map(trimSpace).filter(Boolean),
      maybeDirection = _values$split$map$fil[0],
      stops = _values$split$map$fil.slice(1);

  if ((stops == null ? void 0 : stops.length) === 0) return value;
  var direction = maybeDirection in directionMap ? directionMap[maybeDirection] : maybeDirection;
  stops.unshift(direction);

  var _values = stops.map(function (stop) {
    // if stop is valid shorthand direction, return it
    if (valueSet.has(stop)) return stop;
    var firstStop = stop.indexOf(" "); // color stop could be `red.200 20%` based on css gradient spec

    var _ref2 = firstStop !== -1 ? [stop.substr(0, firstStop), stop.substr(firstStop + 1)] : [stop],
        _color = _ref2[0],
        _stop = _ref2[1];

    var _stopOrFunc = isCSSFunction(_stop) ? _stop : _stop && _stop.split(" "); // else, get and transform the color token or css value


    var key = "colors." + _color;
    var color = key in theme.__cssMap ? theme.__cssMap[key].varRef : _color;
    return _stopOrFunc ? [color].concat(Array.isArray(_stopOrFunc) ? _stopOrFunc : [_stopOrFunc]).join(" ") : color;
  });

  return _type + "(" + _values.join(", ") + ")";
}
var isCSSFunction = function isCSSFunction(value) {
  return isString(value) && value.includes("(") && value.includes(")");
};
var gradientTransform = function gradientTransform(value, theme) {
  return parseGradient(value, theme != null ? theme : {});
};

var chakra_ui_styled_system_esm_analyzeCSSValue = function analyzeCSSValue(value) {
  var num = parseFloat(value.toString());
  var unit = value.toString().replace(String(num), "");
  return {
    unitless: !unit,
    value: num,
    unit: unit
  };
};

var wrap = function wrap(str) {
  return function (value) {
    return str + "(" + value + ")";
  };
};

var transformFunctions = {
  filter: function filter(value) {
    return value !== "auto" ? value : filterTemplate;
  },
  backdropFilter: function backdropFilter(value) {
    return value !== "auto" ? value : backdropFilterTemplate;
  },
  ring: function ring(value) {
    return getRingTemplate(transformFunctions.px(value));
  },
  bgClip: function bgClip(value) {
    return value === "text" ? {
      color: "transparent",
      backgroundClip: "text"
    } : {
      backgroundClip: value
    };
  },
  transform: function transform(value) {
    if (value === "auto") return getTransformTemplate();
    if (value === "auto-gpu") return getTransformGpuTemplate();
    return value;
  },
  px: function px(value) {
    if (value == null) return value;

    var _analyzeCSSValue = chakra_ui_styled_system_esm_analyzeCSSValue(value),
        unitless = _analyzeCSSValue.unitless;

    return unitless || isNumber(value) ? value + "px" : value;
  },
  fraction: function fraction(value) {
    return !isNumber(value) || value > 1 ? value : value * 100 + "%";
  },
  "float": function float(value, theme) {
    var map = {
      left: "right",
      right: "left"
    };
    return theme.direction === "rtl" ? map[value] : value;
  },
  degree: function degree(value) {
    if (isCssVar(value) || value == null) return value;
    var unitless = isString(value) && !value.endsWith("deg");
    return isNumber(value) || unitless ? value + "deg" : value;
  },
  gradient: gradientTransform,
  blur: wrap("blur"),
  opacity: wrap("opacity"),
  brightness: wrap("brightness"),
  contrast: wrap("contrast"),
  dropShadow: wrap("drop-shadow"),
  grayscale: wrap("grayscale"),
  hueRotate: wrap("hue-rotate"),
  invert: wrap("invert"),
  saturate: wrap("saturate"),
  sepia: wrap("sepia"),
  bgImage: function bgImage(value) {
    if (value == null) return value;
    var prevent = isCSSFunction(value) || globalSet.has(value);
    return !prevent ? "url(" + value + ")" : value;
  },
  outline: function outline(value) {
    var isNoneOrZero = String(value) === "0" || String(value) === "none";
    return value !== null && isNoneOrZero ? {
      outline: "2px solid transparent",
      outlineOffset: "2px"
    } : {
      outline: value
    };
  },
  flexDirection: function flexDirection(value) {
    var _flexDirectionTemplat;

    var _ref = (_flexDirectionTemplat = flexDirectionTemplate[value]) != null ? _flexDirectionTemplat : {},
        space = _ref.space,
        divide = _ref.divide;

    var result = {
      flexDirection: value
    };
    if (space) result[space] = 1;
    if (divide) result[divide] = 1;
    return result;
  }
};

var t = {
  borderWidths: toConfig("borderWidths"),
  borderStyles: toConfig("borderStyles"),
  colors: toConfig("colors"),
  borders: toConfig("borders"),
  radii: toConfig("radii", transformFunctions.px),
  space: toConfig("space", transformFunctions.px),
  spaceT: toConfig("space", transformFunctions.px),
  degreeT: function degreeT(property) {
    return {
      property: property,
      transform: transformFunctions.degree
    };
  },
  prop: function prop(property, scale, transform) {
    return chakra_ui_styled_system_esm_extends({
      property: property,
      scale: scale
    }, scale && {
      transform: createTransform({
        scale: scale,
        transform: transform
      })
    });
  },
  propT: function propT(property, transform) {
    return {
      property: property,
      transform: transform
    };
  },
  sizes: toConfig("sizes", transformFunctions.px),
  sizesT: toConfig("sizes", transformFunctions.fraction),
  shadows: toConfig("shadows"),
  logical: logical,
  blur: toConfig("blur", transformFunctions.blur)
};

var background = {
  background: t.colors("background"),
  backgroundColor: t.colors("backgroundColor"),
  backgroundImage: t.propT("backgroundImage", transformFunctions.bgImage),
  backgroundSize: true,
  backgroundPosition: true,
  backgroundRepeat: true,
  backgroundAttachment: true,
  backgroundClip: {
    transform: transformFunctions.bgClip
  },
  bgSize: t.prop("backgroundSize"),
  bgPosition: t.prop("backgroundPosition"),
  bg: t.colors("background"),
  bgColor: t.colors("backgroundColor"),
  bgPos: t.prop("backgroundPosition"),
  bgRepeat: t.prop("backgroundRepeat"),
  bgAttachment: t.prop("backgroundAttachment"),
  bgGradient: t.propT("backgroundImage", transformFunctions.gradient),
  bgClip: {
    transform: transformFunctions.bgClip
  }
};
Object.assign(background, {
  bgImage: background.backgroundImage,
  bgImg: background.backgroundImage
});

var border = {
  border: t.borders("border"),
  borderWidth: t.borderWidths("borderWidth"),
  borderStyle: t.borderStyles("borderStyle"),
  borderColor: t.colors("borderColor"),
  borderRadius: t.radii("borderRadius"),
  borderTop: t.borders("borderTop"),
  borderBlockStart: t.borders("borderBlockStart"),
  borderTopLeftRadius: t.radii("borderTopLeftRadius"),
  borderStartStartRadius: t.logical({
    scale: "radii",
    property: {
      ltr: "borderTopLeftRadius",
      rtl: "borderTopRightRadius"
    }
  }),
  borderEndStartRadius: t.logical({
    scale: "radii",
    property: {
      ltr: "borderBottomLeftRadius",
      rtl: "borderBottomRightRadius"
    }
  }),
  borderTopRightRadius: t.radii("borderTopRightRadius"),
  borderStartEndRadius: t.logical({
    scale: "radii",
    property: {
      ltr: "borderTopRightRadius",
      rtl: "borderTopLeftRadius"
    }
  }),
  borderEndEndRadius: t.logical({
    scale: "radii",
    property: {
      ltr: "borderBottomRightRadius",
      rtl: "borderBottomLeftRadius"
    }
  }),
  borderRight: t.borders("borderRight"),
  borderInlineEnd: t.borders("borderInlineEnd"),
  borderBottom: t.borders("borderBottom"),
  borderBlockEnd: t.borders("borderBlockEnd"),
  borderBottomLeftRadius: t.radii("borderBottomLeftRadius"),
  borderBottomRightRadius: t.radii("borderBottomRightRadius"),
  borderLeft: t.borders("borderLeft"),
  borderInlineStart: {
    property: "borderInlineStart",
    scale: "borders"
  },
  borderInlineStartRadius: t.logical({
    scale: "radii",
    property: {
      ltr: ["borderTopLeftRadius", "borderBottomLeftRadius"],
      rtl: ["borderTopRightRadius", "borderBottomRightRadius"]
    }
  }),
  borderInlineEndRadius: t.logical({
    scale: "radii",
    property: {
      ltr: ["borderTopRightRadius", "borderBottomRightRadius"],
      rtl: ["borderTopLeftRadius", "borderBottomLeftRadius"]
    }
  }),
  borderX: t.borders(["borderLeft", "borderRight"]),
  borderInline: t.borders("borderInline"),
  borderY: t.borders(["borderTop", "borderBottom"]),
  borderBlock: t.borders("borderBlock"),
  borderTopWidth: t.borderWidths("borderTopWidth"),
  borderBlockStartWidth: t.borderWidths("borderBlockStartWidth"),
  borderTopColor: t.colors("borderTopColor"),
  borderBlockStartColor: t.colors("borderBlockStartColor"),
  borderTopStyle: t.borderStyles("borderTopStyle"),
  borderBlockStartStyle: t.borderStyles("borderBlockStartStyle"),
  borderBottomWidth: t.borderWidths("borderBottomWidth"),
  borderBlockEndWidth: t.borderWidths("borderBlockEndWidth"),
  borderBottomColor: t.colors("borderBottomColor"),
  borderBlockEndColor: t.colors("borderBlockEndColor"),
  borderBottomStyle: t.borderStyles("borderBottomStyle"),
  borderBlockEndStyle: t.borderStyles("borderBlockEndStyle"),
  borderLeftWidth: t.borderWidths("borderLeftWidth"),
  borderInlineStartWidth: t.borderWidths("borderInlineStartWidth"),
  borderLeftColor: t.colors("borderLeftColor"),
  borderInlineStartColor: t.colors("borderInlineStartColor"),
  borderLeftStyle: t.borderStyles("borderLeftStyle"),
  borderInlineStartStyle: t.borderStyles("borderInlineStartStyle"),
  borderRightWidth: t.borderWidths("borderRightWidth"),
  borderInlineEndWidth: t.borderWidths("borderInlineEndWidth"),
  borderRightColor: t.colors("borderRightColor"),
  borderInlineEndColor: t.colors("borderInlineEndColor"),
  borderRightStyle: t.borderStyles("borderRightStyle"),
  borderInlineEndStyle: t.borderStyles("borderInlineEndStyle"),
  borderTopRadius: t.radii(["borderTopLeftRadius", "borderTopRightRadius"]),
  borderBottomRadius: t.radii(["borderBottomLeftRadius", "borderBottomRightRadius"]),
  borderLeftRadius: t.radii(["borderTopLeftRadius", "borderBottomLeftRadius"]),
  borderRightRadius: t.radii(["borderTopRightRadius", "borderBottomRightRadius"])
};
Object.assign(border, {
  rounded: border.borderRadius,
  roundedTop: border.borderTopRadius,
  roundedTopLeft: border.borderTopLeftRadius,
  roundedTopRight: border.borderTopRightRadius,
  roundedTopStart: border.borderStartStartRadius,
  roundedTopEnd: border.borderStartEndRadius,
  roundedBottom: border.borderBottomRadius,
  roundedBottomLeft: border.borderBottomLeftRadius,
  roundedBottomRight: border.borderBottomRightRadius,
  roundedBottomStart: border.borderEndStartRadius,
  roundedBottomEnd: border.borderEndEndRadius,
  roundedLeft: border.borderLeftRadius,
  roundedRight: border.borderRightRadius,
  roundedStart: border.borderInlineStartRadius,
  roundedEnd: border.borderInlineEndRadius,
  borderStart: border.borderInlineStart,
  borderEnd: border.borderInlineEnd,
  borderTopStartRadius: border.borderStartStartRadius,
  borderTopEndRadius: border.borderStartEndRadius,
  borderBottomStartRadius: border.borderEndStartRadius,
  borderBottomEndRadius: border.borderEndEndRadius,
  borderStartRadius: border.borderInlineStartRadius,
  borderEndRadius: border.borderInlineEndRadius,
  borderStartWidth: border.borderInlineStartWidth,
  borderEndWidth: border.borderInlineEndWidth,
  borderStartColor: border.borderInlineStartColor,
  borderEndColor: border.borderInlineEndColor,
  borderStartStyle: border.borderInlineStartStyle,
  borderEndStyle: border.borderInlineEndStyle
});
/**
 * The prop types for border properties listed above
 */

var color = {
  color: t.colors("color"),
  textColor: t.colors("color"),
  fill: t.colors("fill"),
  stroke: t.colors("stroke")
};

var effect = {
  boxShadow: t.shadows("boxShadow"),
  mixBlendMode: true,
  blendMode: t.prop("mixBlendMode"),
  backgroundBlendMode: true,
  bgBlendMode: t.prop("backgroundBlendMode"),
  opacity: true
};
Object.assign(effect, {
  shadow: effect.boxShadow
});
/**
 * Types for box and text shadow properties
 */

var filter = {
  filter: {
    transform: transformFunctions.filter
  },
  blur: t.blur("--chakra-blur"),
  brightness: t.propT("--chakra-brightness", transformFunctions.brightness),
  contrast: t.propT("--chakra-contrast", transformFunctions.contrast),
  hueRotate: t.degreeT("--chakra-hue-rotate"),
  invert: t.propT("--chakra-invert", transformFunctions.invert),
  saturate: t.propT("--chakra-saturate", transformFunctions.saturate),
  dropShadow: t.propT("--chakra-drop-shadow", transformFunctions.dropShadow),
  backdropFilter: {
    transform: transformFunctions.backdropFilter
  },
  backdropBlur: t.blur("--chakra-backdrop-blur"),
  backdropBrightness: t.propT("--chakra-backdrop-brightness", transformFunctions.brightness),
  backdropContrast: t.propT("--chakra-backdrop-contrast", transformFunctions.contrast),
  backdropHueRotate: t.degreeT("--chakra-backdrop-hue-rotate"),
  backdropInvert: t.propT("--chakra-backdrop-invert", transformFunctions.invert),
  backdropSaturate: t.propT("--chakra-backdrop-saturate", transformFunctions.saturate)
};

var flexbox = {
  alignItems: true,
  alignContent: true,
  justifyItems: true,
  justifyContent: true,
  flexWrap: true,
  flexDirection: {
    transform: transformFunctions.flexDirection
  },
  experimental_spaceX: {
    "static": spaceXTemplate,
    transform: createTransform({
      scale: "space",
      transform: function transform(value) {
        return value !== null ? {
          "--chakra-space-x": value
        } : null;
      }
    })
  },
  experimental_spaceY: {
    "static": spaceYTemplate,
    transform: createTransform({
      scale: "space",
      transform: function transform(value) {
        return value != null ? {
          "--chakra-space-y": value
        } : null;
      }
    })
  },
  flex: true,
  flexFlow: true,
  flexGrow: true,
  flexShrink: true,
  flexBasis: t.sizes("flexBasis"),
  justifySelf: true,
  alignSelf: true,
  order: true,
  placeItems: true,
  placeContent: true,
  placeSelf: true,
  gap: t.space("gap"),
  rowGap: t.space("rowGap"),
  columnGap: t.space("columnGap")
};
Object.assign(flexbox, {
  flexDir: flexbox.flexDirection
});

var grid = {
  gridGap: t.space("gridGap"),
  gridColumnGap: t.space("gridColumnGap"),
  gridRowGap: t.space("gridRowGap"),
  gridColumn: true,
  gridRow: true,
  gridAutoFlow: true,
  gridAutoColumns: true,
  gridColumnStart: true,
  gridColumnEnd: true,
  gridRowStart: true,
  gridRowEnd: true,
  gridAutoRows: true,
  gridTemplate: true,
  gridTemplateColumns: true,
  gridTemplateRows: true,
  gridTemplateAreas: true,
  gridArea: true
};

var interactivity = {
  appearance: true,
  cursor: true,
  resize: true,
  userSelect: true,
  pointerEvents: true,
  outline: {
    transform: transformFunctions.outline
  },
  outlineOffset: true,
  outlineColor: t.colors("outlineColor")
};

var layout = {
  width: t.sizesT("width"),
  inlineSize: t.sizesT("inlineSize"),
  height: t.sizes("height"),
  blockSize: t.sizes("blockSize"),
  boxSize: t.sizes(["width", "height"]),
  minWidth: t.sizes("minWidth"),
  minInlineSize: t.sizes("minInlineSize"),
  minHeight: t.sizes("minHeight"),
  minBlockSize: t.sizes("minBlockSize"),
  maxWidth: t.sizes("maxWidth"),
  maxInlineSize: t.sizes("maxInlineSize"),
  maxHeight: t.sizes("maxHeight"),
  maxBlockSize: t.sizes("maxBlockSize"),
  d: t.prop("display"),
  overflow: true,
  overflowX: true,
  overflowY: true,
  overscrollBehavior: true,
  overscrollBehaviorX: true,
  overscrollBehaviorY: true,
  display: true,
  verticalAlign: true,
  boxSizing: true,
  boxDecorationBreak: true,
  "float": t.propT("float", transformFunctions["float"]),
  objectFit: true,
  objectPosition: true,
  visibility: true,
  isolation: true
};
Object.assign(layout, {
  w: layout.width,
  h: layout.height,
  minW: layout.minWidth,
  maxW: layout.maxWidth,
  minH: layout.minHeight,
  maxH: layout.maxHeight,
  overscroll: layout.overscrollBehavior,
  overscrollX: layout.overscrollBehaviorX,
  overscrollY: layout.overscrollBehaviorY
});
/**
 * Types for layout related CSS properties
 */

var list = {
  listStyleType: true,
  listStylePosition: true,
  listStylePos: t.prop("listStylePosition"),
  listStyleImage: true,
  listStyleImg: t.prop("listStyleImage")
};

var srOnly = {
  border: "0px",
  clip: "rect(0, 0, 0, 0)",
  width: "1px",
  height: "1px",
  margin: "-1px",
  padding: "0px",
  overflow: "hidden",
  whiteSpace: "nowrap",
  position: "absolute"
};
var srFocusable = {
  position: "static",
  width: "auto",
  height: "auto",
  clip: "auto",
  padding: "0",
  margin: "0",
  overflow: "visible",
  whiteSpace: "normal"
};

var getWithPriority = function getWithPriority(theme, key, styles) {
  var result = {};
  var obj = chakra_ui_utils_esm_memoizedGet(theme, key, {});

  for (var prop in obj) {
    var isInStyles = prop in styles && styles[prop] != null;
    if (!isInStyles) result[prop] = obj[prop];
  }

  return result;
};

var others = {
  srOnly: {
    transform: function transform(value) {
      if (value === true) return srOnly;
      if (value === "focusable") return srFocusable;
      return {};
    }
  },
  layerStyle: {
    processResult: true,
    transform: function transform(value, theme, styles) {
      return getWithPriority(theme, "layerStyles." + value, styles);
    }
  },
  textStyle: {
    processResult: true,
    transform: function transform(value, theme, styles) {
      return getWithPriority(theme, "textStyles." + value, styles);
    }
  },
  apply: {
    processResult: true,
    transform: function transform(value, theme, styles) {
      return getWithPriority(theme, value, styles);
    }
  }
};

var position = {
  position: true,
  pos: t.prop("position"),
  zIndex: t.prop("zIndex", "zIndices"),
  inset: t.spaceT("inset"),
  insetX: t.spaceT(["left", "right"]),
  insetInline: t.spaceT("insetInline"),
  insetY: t.spaceT(["top", "bottom"]),
  insetBlock: t.spaceT("insetBlock"),
  top: t.spaceT("top"),
  insetBlockStart: t.spaceT("insetBlockStart"),
  bottom: t.spaceT("bottom"),
  insetBlockEnd: t.spaceT("insetBlockEnd"),
  left: t.spaceT("left"),
  insetInlineStart: t.logical({
    scale: "space",
    property: {
      ltr: "left",
      rtl: "right"
    }
  }),
  right: t.spaceT("right"),
  insetInlineEnd: t.logical({
    scale: "space",
    property: {
      ltr: "right",
      rtl: "left"
    }
  })
};
Object.assign(position, {
  insetStart: position.insetInlineStart,
  insetEnd: position.insetInlineEnd
});
/**
 * Types for position CSS properties
 */

/**
 * The parser configuration for common outline properties
 */
var ring = {
  ring: {
    transform: transformFunctions.ring
  },
  ringColor: t.colors("--chakra-ring-color"),
  ringOffset: t.prop("--chakra-ring-offset-width"),
  ringOffsetColor: t.colors("--chakra-ring-offset-color"),
  ringInset: t.prop("--chakra-ring-inset")
};

var space = {
  margin: t.spaceT("margin"),
  marginTop: t.spaceT("marginTop"),
  marginBlockStart: t.spaceT("marginBlockStart"),
  marginRight: t.spaceT("marginRight"),
  marginInlineEnd: t.spaceT("marginInlineEnd"),
  marginBottom: t.spaceT("marginBottom"),
  marginBlockEnd: t.spaceT("marginBlockEnd"),
  marginLeft: t.spaceT("marginLeft"),
  marginInlineStart: t.spaceT("marginInlineStart"),
  marginX: t.spaceT(["marginInlineStart", "marginInlineEnd"]),
  marginInline: t.spaceT("marginInline"),
  marginY: t.spaceT(["marginTop", "marginBottom"]),
  marginBlock: t.spaceT("marginBlock"),
  padding: t.space("padding"),
  paddingTop: t.space("paddingTop"),
  paddingBlockStart: t.space("paddingBlockStart"),
  paddingRight: t.space("paddingRight"),
  paddingBottom: t.space("paddingBottom"),
  paddingBlockEnd: t.space("paddingBlockEnd"),
  paddingLeft: t.space("paddingLeft"),
  paddingInlineStart: t.space("paddingInlineStart"),
  paddingInlineEnd: t.space("paddingInlineEnd"),
  paddingX: t.space(["paddingInlineStart", "paddingInlineEnd"]),
  paddingInline: t.space("paddingInline"),
  paddingY: t.space(["paddingTop", "paddingBottom"]),
  paddingBlock: t.space("paddingBlock")
};
Object.assign(space, {
  m: space.margin,
  mt: space.marginTop,
  mr: space.marginRight,
  me: space.marginInlineEnd,
  marginEnd: space.marginInlineEnd,
  mb: space.marginBottom,
  ml: space.marginLeft,
  ms: space.marginInlineStart,
  marginStart: space.marginInlineStart,
  mx: space.marginX,
  my: space.marginY,
  p: space.padding,
  pt: space.paddingTop,
  py: space.paddingY,
  px: space.paddingX,
  pb: space.paddingBottom,
  pl: space.paddingLeft,
  ps: space.paddingInlineStart,
  paddingStart: space.paddingInlineStart,
  pr: space.paddingRight,
  pe: space.paddingInlineEnd,
  paddingEnd: space.paddingInlineEnd
});
/**
 * Types for space related CSS properties
 */

var textDecoration = {
  textDecorationColor: t.colors("textDecorationColor"),
  textDecoration: true,
  textDecor: {
    property: "textDecoration"
  },
  textDecorationLine: true,
  textDecorationStyle: true,
  textDecorationThickness: true,
  textUnderlineOffset: true,
  textShadow: t.shadows("textShadow")
};

var transform = {
  clipPath: true,
  transform: t.propT("transform", transformFunctions.transform),
  transformOrigin: true,
  translateX: t.spaceT("--chakra-translate-x"),
  translateY: t.spaceT("--chakra-translate-y"),
  skewX: t.degreeT("--chakra-skew-x"),
  skewY: t.degreeT("--chakra-skew-y"),
  scaleX: t.prop("--chakra-scale-x"),
  scaleY: t.prop("--chakra-scale-y"),
  scale: t.prop(["--chakra-scale-x", "--chakra-scale-y"]),
  rotate: t.degreeT("--chakra-rotate")
};

var transition = {
  transition: true,
  transitionDelay: true,
  animation: true,
  willChange: true,
  transitionDuration: t.prop("transitionDuration", "transition.duration"),
  transitionProperty: t.prop("transitionProperty", "transition.property"),
  transitionTimingFunction: t.prop("transitionTimingFunction", "transition.easing")
};

var typography = {
  fontFamily: t.prop("fontFamily", "fonts"),
  fontSize: t.prop("fontSize", "fontSizes", transformFunctions.px),
  fontWeight: t.prop("fontWeight", "fontWeights"),
  lineHeight: t.prop("lineHeight", "lineHeights"),
  letterSpacing: t.prop("letterSpacing", "letterSpacings"),
  textAlign: true,
  fontStyle: true,
  wordBreak: true,
  overflowWrap: true,
  textOverflow: true,
  textTransform: true,
  whiteSpace: true,
  noOfLines: {
    "static": {
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      //@ts-ignore
      WebkitLineClamp: "var(--chakra-line-clamp)"
    },
    property: "--chakra-line-clamp"
  },
  isTruncated: {
    transform: function transform(value) {
      if (value === true) {
        return {
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        };
      }
    }
  }
};
/**
 * Types for typography related CSS properties
 */

var chakra_ui_styled_system_esm_scroll = {
  scrollBehavior: true,
  scrollSnapAlign: true,
  scrollSnapStop: true,
  scrollSnapType: true,
  // scroll margin
  scrollMargin: t.spaceT("scrollMargin"),
  scrollMarginTop: t.spaceT("scrollMarginTop"),
  scrollMarginBottom: t.spaceT("scrollMarginBottom"),
  scrollMarginLeft: t.spaceT("scrollMarginLeft"),
  scrollMarginRight: t.spaceT("scrollMarginRight"),
  scrollMarginX: t.spaceT(["scrollMarginLeft", "scrollMarginRight"]),
  scrollMarginY: t.spaceT(["scrollMarginTop", "scrollMarginBottom"]),
  // scroll padding
  scrollPadding: t.spaceT("scrollPadding"),
  scrollPaddingTop: t.spaceT("scrollPaddingTop"),
  scrollPaddingBottom: t.spaceT("scrollPaddingBottom"),
  scrollPaddingLeft: t.spaceT("scrollPaddingLeft"),
  scrollPaddingRight: t.spaceT("scrollPaddingRight"),
  scrollPaddingX: t.spaceT(["scrollPaddingLeft", "scrollPaddingRight"]),
  scrollPaddingY: t.spaceT(["scrollPaddingTop", "scrollPaddingBottom"])
};

function chakra_ui_styled_system_esm_arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function chakra_ui_styled_system_esm_unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return chakra_ui_styled_system_esm_arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return chakra_ui_styled_system_esm_arrayLikeToArray(o, minLen);
}

function chakra_ui_styled_system_esm_createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = chakra_ui_styled_system_esm_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var state = {
  hover: function hover(str, post) {
    return str + ":hover " + post + ", " + str + "[data-hover] " + post;
  },
  focus: function focus(str, post) {
    return str + ":focus " + post + ", " + str + "[data-focus] " + post;
  },
  focusVisible: function focusVisible(str, post) {
    return str + ":focus-visible " + post;
  },
  focusWithin: function focusWithin(str, post) {
    return str + ":focus-within " + post;
  },
  active: function active(str, post) {
    return str + ":active " + post + ", " + str + "[data-active] " + post;
  },
  disabled: function disabled(str, post) {
    return str + ":disabled " + post + ", " + str + "[data-disabled] " + post;
  },
  invalid: function invalid(str, post) {
    return str + ":invalid " + post + ", " + str + "[data-invalid] " + post;
  },
  checked: function checked(str, post) {
    return str + ":checked " + post + ", " + str + "[data-checked] " + post;
  },
  indeterminate: function indeterminate(str, post) {
    return str + ":indeterminate " + post + ", " + str + "[aria-checked=mixed] " + post + ", " + str + "[data-indeterminate] " + post;
  },
  readOnly: function readOnly(str, post) {
    return str + ":read-only " + post + ", " + str + "[readonly] " + post + ", " + str + "[data-read-only] " + post;
  },
  expanded: function expanded(str, post) {
    return str + ":read-only " + post + ", " + str + "[aria-expanded=true] " + post + ", " + str + "[data-expanded] " + post;
  },
  placeholderShown: function placeholderShown(str, post) {
    return str + ":placeholder-shown " + post;
  }
};

var toGroup = function toGroup(fn) {
  return merge(function (v) {
    return fn(v, "&");
  }, "[role=group]", "[data-group]", ".group");
};

var toPeer = function toPeer(fn) {
  return merge(function (v) {
    return fn(v, "~ &");
  }, "[data-peer]", ".peer");
};

var merge = function merge(fn) {
  for (var _len = arguments.length, selectors = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    selectors[_key - 1] = arguments[_key];
  }

  return selectors.map(fn).join(", ");
};

var pseudoSelectors = {
  /**
   * Styles for CSS selector `&:hover`
   */
  _hover: "&:hover, &[data-hover]",

  /**
   * Styles for CSS Selector `&:active`
   */
  _active: "&:active, &[data-active]",

  /**
   * Styles for CSS selector `&:focus`
   *
   */
  _focus: "&:focus, &[data-focus]",

  /**
   * Styles for the highlighted state.
   */
  _highlighted: "&[data-highlighted]",

  /**
   * Styles to apply when a child of this element has received focus
   * - CSS Selector `&:focus-within`
   */
  _focusWithin: "&:focus-within",

  /**
   * Styles to apply when this element has received focus via tabbing
   * - CSS Selector `&:focus-visible`
   */
  _focusVisible: "&:focus-visible",

  /**
   * Styles to apply when this element is disabled. The passed styles are applied to these CSS selectors:
   * - `&[aria-disabled=true]`
   * - `&:disabled`
   * - `&[data-disabled]`
   */
  _disabled: "&[disabled], &[aria-disabled=true], &[data-disabled]",

  /**
   * Styles for CSS Selector `&:readonly`
   */
  _readOnly: "&[aria-readonly=true], &[readonly], &[data-readonly]",

  /**
   * Styles for CSS selector `&::before`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _before={{content:`""` }}/>
   * ```
   */
  _before: "&::before",

  /**
   * Styles for CSS selector `&::after`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _after={{content:`""` }}/>
   * ```
   */
  _after: "&::after",

  /**
   * Styles for CSS selector `&:empty`
   */
  _empty: "&:empty",

  /**
   * Styles to apply when the ARIA attribute `aria-expanded` is `true`
   * - CSS selector `&[aria-expanded=true]`
   */
  _expanded: "&[aria-expanded=true], &[data-expanded]",

  /**
   * Styles to apply when the ARIA attribute `aria-checked` is `true`
   * - CSS selector `&[aria-checked=true]`
   */
  _checked: "&[aria-checked=true], &[data-checked]",

  /**
   * Styles to apply when the ARIA attribute `aria-grabbed` is `true`
   * - CSS selector `&[aria-grabbed=true]`
   */
  _grabbed: "&[aria-grabbed=true], &[data-grabbed]",

  /**
   * Styles for CSS Selector `&[aria-pressed=true]`
   * Typically used to style the current "pressed" state of toggle buttons
   */
  _pressed: "&[aria-pressed=true], &[data-pressed]",

  /**
   * Styles to apply when the ARIA attribute `aria-invalid` is `true`
   * - CSS selector `&[aria-invalid=true]`
   */
  _invalid: "&[aria-invalid=true], &[data-invalid]",

  /**
   * Styles for the valid state
   * - CSS selector `&[data-valid], &[data-state=valid]`
   */
  _valid: "&[data-valid], &[data-state=valid]",

  /**
   * Styles for CSS Selector `&[aria-busy=true]` or `&[data-loading=true]`.
   * Useful for styling loading states
   */
  _loading: "&[data-loading], &[aria-busy=true]",

  /**
   * Styles to apply when the ARIA attribute `aria-selected` is `true`
   *
   * - CSS selector `&[aria-selected=true]`
   */
  _selected: "&[aria-selected=true], &[data-selected]",

  /**
   * Styles for CSS Selector `[hidden=true]`
   */
  _hidden: "&[hidden], &[data-hidden]",

  /**
   * Styles for CSS Selector `&:-webkit-autofill`
   */
  _autofill: "&:-webkit-autofill",

  /**
   * Styles for CSS Selector `&:nth-child(even)`
   */
  _even: "&:nth-of-type(even)",

  /**
   * Styles for CSS Selector `&:nth-child(odd)`
   */
  _odd: "&:nth-of-type(odd)",

  /**
   * Styles for CSS Selector `&:first-of-type`
   */
  _first: "&:first-of-type",

  /**
   * Styles for CSS Selector `&:last-of-type`
   */
  _last: "&:last-of-type",

  /**
   * Styles for CSS Selector `&:not(:first-of-type)`
   */
  _notFirst: "&:not(:first-of-type)",

  /**
   * Styles for CSS Selector `&:not(:last-of-type)`
   */
  _notLast: "&:not(:last-of-type)",

  /**
   * Styles for CSS Selector `&:visited`
   */
  _visited: "&:visited",

  /**
   * Used to style the active link in a navigation
   * Styles for CSS Selector `&[aria-current=page]`
   */
  _activeLink: "&[aria-current=page]",

  /**
   * Used to style the current step within a process
   * Styles for CSS Selector `&[aria-current=step]`
   */
  _activeStep: "&[aria-current=step]",

  /**
   * Styles to apply when the ARIA attribute `aria-checked` is `mixed`
   * - CSS selector `&[aria-checked=mixed]`
   */
  _indeterminate: "&:indeterminate, &[aria-checked=mixed], &[data-indeterminate]",

  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is hovered
   */
  _groupHover: toGroup(state.hover),

  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is hovered
   */
  _peerHover: toPeer(state.hover),

  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is focused
   */
  _groupFocus: toGroup(state.focus),

  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is focused
   */
  _peerFocus: toPeer(state.focus),

  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` has visible focus
   */
  _groupFocusVisible: toGroup(state.focusVisible),

  /**
   * Styles to apply when a sibling element with `.peer`or `data-peer` has visible focus
   */
  _peerFocusVisible: toPeer(state.focusVisible),

  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is active
   */
  _groupActive: toGroup(state.active),

  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is active
   */
  _peerActive: toPeer(state.active),

  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is disabled
   */
  _groupDisabled: toGroup(state.disabled),

  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` is disabled
   */
  _peerDisabled: toPeer(state.disabled),

  /**
   *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` is invalid
   */
  _groupInvalid: toGroup(state.invalid),

  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` is invalid
   */
  _peerInvalid: toPeer(state.invalid),

  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is checked
   */
  _groupChecked: toGroup(state.checked),

  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is checked
   */
  _peerChecked: toPeer(state.checked),

  /**
   *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` has focus within
   */
  _groupFocusWithin: toGroup(state.focusWithin),

  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` has focus within
   */
  _peerFocusWithin: toPeer(state.focusWithin),

  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` has placeholder shown
   */
  _peerPlaceholderShown: toPeer(state.placeholderShown),

  /**
   * Styles for CSS Selector `&::placeholder`.
   */
  _placeholder: "&::placeholder",

  /**
   * Styles for CSS Selector `&:placeholder-shown`.
   */
  _placeholderShown: "&:placeholder-shown",

  /**
   * Styles for CSS Selector `&:fullscreen`.
   */
  _fullScreen: "&:fullscreen",

  /**
   * Styles for CSS Selector `&::selection`
   */
  _selection: "&::selection",

  /**
   * Styles for CSS Selector `[dir=rtl] &`
   * It is applied when a parent element or this element has `dir="rtl"`
   */
  _rtl: "[dir=rtl] &, &[dir=rtl]",

  /**
   * Styles for CSS Selector `[dir=ltr] &`
   * It is applied when a parent element or this element has `dir="ltr"`
   */
  _ltr: "[dir=ltr] &, &[dir=ltr]",

  /**
   * Styles for CSS Selector `@media (prefers-color-scheme: dark)`
   * It is used when the user has requested the system use a light or dark color theme.
   */
  _mediaDark: "@media (prefers-color-scheme: dark)",

  /**
   * Styles for CSS Selector `@media (prefers-reduced-motion: reduce)`
   * It is used when the user has requested the system to reduce the amount of animations.
   */
  _mediaReduceMotion: "@media (prefers-reduced-motion: reduce)",

  /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */
  _dark: ".chakra-ui-dark &:not([data-theme])," + "[data-theme=dark] &:not([data-theme])," + "&[data-theme=dark]",

  /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */
  _light: ".chakra-ui-light &:not([data-theme])," + "[data-theme=light] &:not([data-theme])," + "&[data-theme=light]"
};
var pseudoPropNames = objectKeys(pseudoSelectors);

var systemProps = lodash_mergewith_default()({}, background, border, color, flexbox, layout, filter, ring, interactivity, grid, others, position, effect, space, chakra_ui_styled_system_esm_scroll, typography, textDecoration, transform, list, transition);
var layoutSystem = Object.assign({}, space, layout, flexbox, grid, position);
var layoutPropNames = objectKeys(layoutSystem);
var propNames = [].concat(objectKeys(systemProps), pseudoPropNames);

var styleProps = chakra_ui_styled_system_esm_extends({}, systemProps, pseudoSelectors);

var isStyleProp = function isStyleProp(prop) {
  return prop in styleProps;
};

/**
 * Expands an array or object syntax responsive style.
 *
 * @example
 * expandResponsive({ mx: [1, 2] })
 * // or
 * expandResponsive({ mx: { base: 1, sm: 2 } })
 *
 * // => { mx: 1, "@media(min-width:<sm>)": { mx: 2 } }
 */

var expandResponsive = function expandResponsive(styles) {
  return function (theme) {
    /**
     * Before any style can be processed, the user needs to call `toCSSVar`
     * which analyzes the theme's breakpoint and appends a `__breakpoints` property
     * to the theme with more details of the breakpoints.
     *
     * To learn more, go here: packages/utils/src/responsive.ts #analyzeBreakpoints
     */
    if (!theme.__breakpoints) return styles;
    var _theme$__breakpoints = theme.__breakpoints,
        isResponsive = _theme$__breakpoints.isResponsive,
        toArrayValue = _theme$__breakpoints.toArrayValue,
        medias = _theme$__breakpoints.media;
    var computedStyles = {};

    for (var key in styles) {
      var value = chakra_ui_utils_esm_runIfFn(styles[key], theme);
      if (value == null) continue; // converts the object responsive syntax to array syntax

      value = isObject(value) && isResponsive(value) ? toArrayValue(value) : value;

      if (!Array.isArray(value)) {
        computedStyles[key] = value;
        continue;
      }

      var queries = value.slice(0, medias.length).length;

      for (var index = 0; index < queries; index += 1) {
        var media = medias == null ? void 0 : medias[index];

        if (!media) {
          computedStyles[key] = value[index];
          continue;
        }

        computedStyles[media] = computedStyles[media] || {};

        if (value[index] == null) {
          continue;
        }

        computedStyles[media][key] = value[index];
      }
    }

    return computedStyles;
  };
};

var isCSSVariableTokenValue = function isCSSVariableTokenValue(key, value) {
  return key.startsWith("--") && isString(value) && !isCssVar(value);
};

var resolveTokenValue = function resolveTokenValue(theme, value) {
  var _ref, _getVar2;

  if (value == null) return value;

  var getVar = function getVar(val) {
    var _theme$__cssMap, _theme$__cssMap$val;

    return (_theme$__cssMap = theme.__cssMap) == null ? void 0 : (_theme$__cssMap$val = _theme$__cssMap[val]) == null ? void 0 : _theme$__cssMap$val.varRef;
  };

  var getValue = function getValue(val) {
    var _getVar;

    return (_getVar = getVar(val)) != null ? _getVar : val;
  };

  var valueSplit = value.split(",").map(function (v) {
    return v.trim();
  });
  var tokenValue = valueSplit[0],
      fallbackValue = valueSplit[1];
  value = (_ref = (_getVar2 = getVar(tokenValue)) != null ? _getVar2 : getValue(fallbackValue)) != null ? _ref : getValue(value);
  return value;
};

function getCss(options) {
  var _options$configs = options.configs,
      configs = _options$configs === void 0 ? {} : _options$configs,
      _options$pseudos = options.pseudos,
      pseudos = _options$pseudos === void 0 ? {} : _options$pseudos,
      theme = options.theme;

  var css = function css(stylesOrFn, nested) {
    if (nested === void 0) {
      nested = false;
    }

    var _styles = chakra_ui_utils_esm_runIfFn(stylesOrFn, theme);

    var styles = expandResponsive(_styles)(theme);
    var computedStyles = {};

    for (var key in styles) {
      var _config$transform, _config, _config2, _config3, _config4;

      var valueOrFn = styles[key];
      /**
       * allows the user to pass functional values
       * boxShadow: theme => `0 2px 2px ${theme.colors.red}`
       */

      var value = chakra_ui_utils_esm_runIfFn(valueOrFn, theme);
      /**
       * converts pseudo shorthands to valid selector
       * "_hover" => "&:hover"
       */

      if (key in pseudos) {
        key = pseudos[key];
      }
      /**
       * allows the user to use theme tokens in css vars
       * { --banner-height: "sizes.md" } => { --banner-height: "var(--chakra-sizes-md)" }
       *
       * You can also provide fallback values
       * { --banner-height: "sizes.no-exist, 40px" } => { --banner-height: "40px" }
       */


      if (isCSSVariableTokenValue(key, value)) {
        value = resolveTokenValue(theme, value);
      }

      var config = configs[key];

      if (config === true) {
        config = {
          property: key
        };
      }

      if (isObject(value)) {
        var _computedStyles$key;

        computedStyles[key] = (_computedStyles$key = computedStyles[key]) != null ? _computedStyles$key : {};
        computedStyles[key] = lodash_mergewith_default()({}, computedStyles[key], css(value, true));
        continue;
      }

      var rawValue = (_config$transform = (_config = config) == null ? void 0 : _config.transform == null ? void 0 : _config.transform(value, theme, _styles)) != null ? _config$transform : value;
      /**
       * Used for `layerStyle`, `textStyle` and `apply`. After getting the
       * styles in the theme, we need to process them since they might
       * contain theme tokens.
       *
       * `processResult` is the config property we pass to `layerStyle`, `textStyle` and `apply`
       */

      rawValue = (_config2 = config) != null && _config2.processResult ? css(rawValue, true) : rawValue;
      /**
       * allows us define css properties for RTL and LTR.
       *
       * const marginStart = {
       *   property: theme => theme.direction === "rtl" ? "marginRight": "marginLeft",
       * }
       */

      var configProperty = chakra_ui_utils_esm_runIfFn((_config3 = config) == null ? void 0 : _config3.property, theme);

      if (!nested && (_config4 = config) != null && _config4["static"]) {
        var staticStyles = chakra_ui_utils_esm_runIfFn(config["static"], theme);
        computedStyles = lodash_mergewith_default()({}, computedStyles, staticStyles);
      }

      if (configProperty && Array.isArray(configProperty)) {
        for (var _iterator = chakra_ui_styled_system_esm_createForOfIteratorHelperLoose(configProperty), _step; !(_step = _iterator()).done;) {
          var property = _step.value;
          computedStyles[property] = rawValue;
        }

        continue;
      }

      if (configProperty) {
        if (configProperty === "&" && isObject(rawValue)) {
          computedStyles = lodash_mergewith_default()({}, computedStyles, rawValue);
        } else {
          computedStyles[configProperty] = rawValue;
        }

        continue;
      }

      if (isObject(rawValue)) {
        computedStyles = lodash_mergewith_default()({}, computedStyles, rawValue);
        continue;
      }

      computedStyles[key] = rawValue;
    }

    return computedStyles;
  };

  return css;
}
var chakra_ui_styled_system_esm_css = function css(styles) {
  return function (theme) {
    var cssFn = getCss({
      theme: theme,
      pseudos: pseudoSelectors,
      configs: systemProps
    });
    return cssFn(styles);
  };
};

/**
 * Thank you @markdalgleish for this piece of art!
 */

function resolveReference(operand) {
  if (isObject(operand) && operand.reference) {
    return operand.reference;
  }

  return String(operand);
}

var toExpression = function toExpression(operator) {
  for (var _len = arguments.length, operands = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    operands[_key - 1] = arguments[_key];
  }

  return operands.map(resolveReference).join(" " + operator + " ").replace(/calc/g, "");
};

var _add = function add() {
  for (var _len2 = arguments.length, operands = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    operands[_key2] = arguments[_key2];
  }

  return "calc(" + toExpression.apply(void 0, ["+"].concat(operands)) + ")";
};

var _subtract = function subtract() {
  for (var _len3 = arguments.length, operands = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    operands[_key3] = arguments[_key3];
  }

  return "calc(" + toExpression.apply(void 0, ["-"].concat(operands)) + ")";
};

var _multiply = function multiply() {
  for (var _len4 = arguments.length, operands = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    operands[_key4] = arguments[_key4];
  }

  return "calc(" + toExpression.apply(void 0, ["*"].concat(operands)) + ")";
};

var _divide = function divide() {
  for (var _len5 = arguments.length, operands = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    operands[_key5] = arguments[_key5];
  }

  return "calc(" + toExpression.apply(void 0, ["/"].concat(operands)) + ")";
};

var _negate = function negate(x) {
  var value = resolveReference(x);

  if (value != null && !Number.isNaN(parseFloat(value))) {
    return String(value).startsWith("-") ? String(value).slice(1) : "-" + value;
  }

  return _multiply(value, -1);
};

var calc = Object.assign(function (x) {
  return {
    add: function add() {
      for (var _len6 = arguments.length, operands = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        operands[_key6] = arguments[_key6];
      }

      return calc(_add.apply(void 0, [x].concat(operands)));
    },
    subtract: function subtract() {
      for (var _len7 = arguments.length, operands = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        operands[_key7] = arguments[_key7];
      }

      return calc(_subtract.apply(void 0, [x].concat(operands)));
    },
    multiply: function multiply() {
      for (var _len8 = arguments.length, operands = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
        operands[_key8] = arguments[_key8];
      }

      return calc(_multiply.apply(void 0, [x].concat(operands)));
    },
    divide: function divide() {
      for (var _len9 = arguments.length, operands = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
        operands[_key9] = arguments[_key9];
      }

      return calc(_divide.apply(void 0, [x].concat(operands)));
    },
    negate: function negate() {
      return calc(_negate(x));
    },
    toString: function toString() {
      return x.toString();
    }
  };
}, {
  add: _add,
  subtract: _subtract,
  multiply: _multiply,
  divide: _divide,
  negate: _negate
});

function replaceWhiteSpace(value, replaceValue) {
  if (replaceValue === void 0) {
    replaceValue = "-";
  }

  return value.replace(/\s+/g, replaceValue);
}

function chakra_ui_styled_system_esm_escape(value) {
  var valueStr = replaceWhiteSpace(value.toString());
  if (valueStr.includes("\\.")) return value;
  var isDecimal = !Number.isInteger(parseFloat(value.toString()));
  return isDecimal ? valueStr.replace(".", "\\.") : value;
}

function addPrefix(value, prefix) {
  if (prefix === void 0) {
    prefix = "";
  }

  return [prefix, chakra_ui_styled_system_esm_escape(value)].filter(Boolean).join("-");
}
function toVarReference(name, fallback) {
  return "var(" + chakra_ui_styled_system_esm_escape(name) + (fallback ? ", " + fallback : "") + ")";
}
function toVarDefinition(value, prefix) {
  if (prefix === void 0) {
    prefix = "";
  }

  return "--" + addPrefix(value, prefix);
}
function cssVar(name, fallback, cssVarPrefix) {
  var cssVariable = toVarDefinition(name, cssVarPrefix);
  return {
    variable: cssVariable,
    reference: toVarReference(cssVariable, fallback)
  };
}

/**
 * Convert a token name to a css variable
 *
 * @example
 * tokenToCssVar('colors.red.500', 'chakra')
 * => {
 *   variable: '--chakra-colors-red-500',
 *   reference: 'var(--chakra-colors-red-500)'
 * }
 */
function tokenToCssVar(token, prefix) {
  return cssVar(String(token).replace(/\./g, "-"), undefined, prefix);
}

function createThemeVars(flatTokens, options) {
  var cssVars = {};
  var cssMap = {};

  var _loop = function _loop() {
    var _Object$entries$_i = _Object$entries[_i],
        token = _Object$entries$_i[0],
        tokenValue = _Object$entries$_i[1];
    var isSemantic = tokenValue.isSemantic,
        value = tokenValue.value;

    var _tokenToCssVar = tokenToCssVar(token, options == null ? void 0 : options.cssVarPrefix),
        variable = _tokenToCssVar.variable,
        reference = _tokenToCssVar.reference;

    if (!isSemantic) {
      if (token.startsWith("space")) {
        var keys = token.split(".");
        var firstKey = keys[0],
            referenceKeys = keys.slice(1);
        /** @example space.-4 */

        var negativeLookupKey = firstKey + ".-" + referenceKeys.join(".");
        var negativeValue = calc.negate(value);
        var negatedReference = calc.negate(reference);
        cssMap[negativeLookupKey] = {
          value: negativeValue,
          "var": variable,
          varRef: negatedReference
        };
      }

      cssVars[variable] = value;
      cssMap[token] = {
        value: value,
        "var": variable,
        varRef: reference
      };
      return "continue";
    }

    var lookupToken = function lookupToken(maybeToken) {
      var scale = String(token).split(".")[0];
      var withScale = [scale, maybeToken].join(".");
      /** @example flatTokens['space.4'] === '16px' */

      var resolvedTokenValue = flatTokens[withScale];
      if (!resolvedTokenValue) return maybeToken;

      var _tokenToCssVar2 = tokenToCssVar(withScale, options == null ? void 0 : options.cssVarPrefix),
          reference = _tokenToCssVar2.reference;

      return reference;
    };

    var normalizedValue = isObject(value) ? value : {
      "default": value
    };
    cssVars = lodash_mergewith_default()(cssVars, Object.entries(normalizedValue).reduce(function (acc, _ref) {
      var _pseudoSelectors$cond, _acc$conditionSelecto;

      var conditionAlias = _ref[0],
          conditionValue = _ref[1];
      var maybeReference = lookupToken(conditionValue);

      if (conditionAlias === "default") {
        acc[variable] = maybeReference;
        return acc;
      }
      /** @example { _dark: "#fff" } => { '.chakra-ui-dark': "#fff" } */


      var conditionSelector = (_pseudoSelectors$cond = pseudoSelectors == null ? void 0 : pseudoSelectors[conditionAlias]) != null ? _pseudoSelectors$cond : conditionAlias;
      acc[conditionSelector] = (_acc$conditionSelecto = {}, _acc$conditionSelecto[variable] = maybeReference, _acc$conditionSelecto);
      return acc;
    }, {}));
    cssMap[token] = {
      value: reference,
      "var": variable,
      varRef: reference
    };
  };

  for (var _i = 0, _Object$entries = Object.entries(flatTokens); _i < _Object$entries.length; _i++) {
    var _ret = _loop();

    if (_ret === "continue") continue;
  }

  return {
    cssVars: cssVars,
    cssMap: cssMap
  };
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var _excluded = ["__cssMap", "__cssVars", "__breakpoints"];
var tokens = ["colors", "borders", "borderWidths", "borderStyles", "fonts", "fontSizes", "fontWeights", "letterSpacings", "lineHeights", "radii", "space", "shadows", "sizes", "zIndices", "transition", "blur"];
function extractTokens(theme) {
  var _tokens = tokens;
  return pick(theme, _tokens);
}
function extractSemanticTokens(theme) {
  return theme.semanticTokens;
}
function omitVars(rawTheme) {
  rawTheme.__cssMap;
      rawTheme.__cssVars;
      rawTheme.__breakpoints;
      var cleanTheme = _objectWithoutPropertiesLoose(rawTheme, _excluded);

  return cleanTheme;
}

function flattenTokens(_ref) {
  var _flatten, _flatten2;

  var tokens = _ref.tokens,
      semanticTokens = _ref.semanticTokens;
  var tokenEntries = Object.entries((_flatten = flatten(tokens)) != null ? _flatten : {}).map(function (_ref2) {
    var token = _ref2[0],
        value = _ref2[1];
    var enhancedToken = {
      isSemantic: false,
      value: value
    };
    return [token, enhancedToken];
  });
  var semanticTokenEntries = Object.entries((_flatten2 = flatten(semanticTokens, 1)) != null ? _flatten2 : {}).map(function (_ref3) {
    var token = _ref3[0],
        value = _ref3[1];
    var enhancedToken = {
      isSemantic: true,
      value: value
    };
    return [token, enhancedToken];
  });
  return fromEntries([].concat(tokenEntries, semanticTokenEntries));
}

function toCSSVar(rawTheme) {
  var _theme$config;

  /**
   * In the case the theme has already been converted to css-var (e.g extending the theme),
   * we can omit the computed css vars and recompute it for the extended theme.
   */
  var theme = omitVars(rawTheme); // omit components and breakpoints from css variable map

  var tokens = extractTokens(theme);
  var semanticTokens = extractSemanticTokens(theme);
  var flatTokens = flattenTokens({
    tokens: tokens,
    semanticTokens: semanticTokens
  });
  var cssVarPrefix = (_theme$config = theme.config) == null ? void 0 : _theme$config.cssVarPrefix;

  var _createThemeVars = createThemeVars(flatTokens, {
    cssVarPrefix: cssVarPrefix
  }),
      cssMap = _createThemeVars.cssMap,
      cssVars = _createThemeVars.cssVars;

  var defaultCssVars = {
    "--chakra-ring-inset": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-ring-offset-width": "0px",
    "--chakra-ring-offset-color": "#fff",
    "--chakra-ring-color": "rgba(66, 153, 225, 0.6)",
    "--chakra-ring-offset-shadow": "0 0 #0000",
    "--chakra-ring-shadow": "0 0 #0000",
    "--chakra-space-x-reverse": "0",
    "--chakra-space-y-reverse": "0"
  };
  Object.assign(theme, {
    __cssVars: chakra_ui_styled_system_esm_extends({}, defaultCssVars, cssVars),
    __cssMap: cssMap,
    __breakpoints: analyzeBreakpoints(theme.breakpoints)
  });
  return theme;
}



// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.js + 1 modules
var emotion_element_c39617d8_browser_esm = __webpack_require__(30174);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-fast-compare/index.js
var react_fast_compare = __webpack_require__(69590);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/react-utils/dist/chakra-ui-react-utils.esm.js



/**
 * Assigns a value to a ref function or object
 *
 * @param ref the ref to assign to
 * @param value the value
 */
function assignRef(ref, value) {
  if (ref == null) return;

  if (isFunction(ref)) {
    ref(value);
    return;
  }

  try {
    // @ts-ignore
    ref.current = value;
  } catch (error) {
    throw new Error("Cannot assign value '" + value + "' to ref '" + ref + "'");
  }
}
/**
 * Combine multiple React refs into a single ref function.
 * This is used mostly when you need to allow consumers forward refs to
 * internal components
 *
 * @param refs refs to assign to value to
 */

function mergeRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }

  return function (node) {
    refs.forEach(function (ref) {
      return assignRef(ref, node);
    });
  };
}

/**
 * Creates a named context, provider, and hook.
 *
 * @param options create context options
 */
function createContext(options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$strict = _options.strict,
      strict = _options$strict === void 0 ? true : _options$strict,
      _options$errorMessage = _options.errorMessage,
      errorMessage = _options$errorMessage === void 0 ? "useContext: `context` is undefined. Seems you forgot to wrap component within the Provider" : _options$errorMessage,
      name = _options.name;
  var Context = /*#__PURE__*/react.createContext(undefined);
  Context.displayName = name;

  function useContext() {
    var context = react.useContext(Context);

    if (!context && strict) {
      var error = new Error(errorMessage);
      error.name = "ContextError";
      Error.captureStackTrace == null ? void 0 : Error.captureStackTrace(error, useContext);
      throw error;
    }

    return context;
  }

  return [Context.Provider, useContext, Context];
}

/**
 * Gets only the valid children of a component,
 * and ignores any nullish or falsy child.
 *
 * @param children the children
 */

function getValidChildren(children) {
  return React.Children.toArray(children).filter(function (child) {
    return /*#__PURE__*/React.isValidElement(child);
  });
}



// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js
var emotion_styled_browser_esm = __webpack_require__(37337);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/system/dist/chakra-ui-system.esm.js













function chakra_ui_system_esm_extends() {
  chakra_ui_system_esm_extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return chakra_ui_system_esm_extends.apply(this, arguments);
}

var ThemeProvider = function ThemeProvider(props) {
  var cssVarsRoot = props.cssVarsRoot,
      theme = props.theme,
      children = props.children;
  var computedTheme = react.useMemo(function () {
    return toCSSVar(theme);
  }, [theme]);
  return /*#__PURE__*/react.createElement(emotion_element_c39617d8_browser_esm.a, {
    theme: computedTheme
  }, /*#__PURE__*/react.createElement(CSSVars, {
    root: cssVarsRoot
  }), children);
};
var CSSVars = function CSSVars(_ref) {
  var _ref$root = _ref.root,
      root = _ref$root === void 0 ? ":host, :root" : _ref$root;

  /**
   * Append color mode selector to allow semantic tokens to change according to the color mode
   */
  var selector = [root, "[data-theme]"].join(",");
  return /*#__PURE__*/react.createElement(emotion_react_browser_esm/* Global */.xB, {
    styles: function styles(theme) {
      var _ref2;

      return _ref2 = {}, _ref2[selector] = theme.__cssVars, _ref2;
    }
  });
};
function useTheme() {
  var theme = React.useContext(ThemeContext);

  if (!theme) {
    throw Error("useTheme: `theme` is undefined. Seems you forgot to wrap your app in `<ChakraProvider />` or `<ThemeProvider />`");
  }

  return theme;
}

var _createContext = createContext({
  name: "StylesContext",
  errorMessage: "useStyles: `styles` is undefined. Seems you forgot to wrap the components in `<StylesProvider />` "
}),
    StylesProvider = _createContext[0],
    useStyles = _createContext[1];
/**
 * Applies styles defined in `theme.styles.global` globally
 * using emotion's `Global` component
 */

var GlobalStyle = function GlobalStyle() {
  var _useColorMode = useColorMode(),
      colorMode = _useColorMode.colorMode;

  return /*#__PURE__*/React.createElement(Global, {
    styles: function styles(theme) {
      var styleObjectOrFn = memoizedGet(theme, "styles.global");
      var globalStyles = runIfFn(styleObjectOrFn, {
        theme: theme,
        colorMode: colorMode
      });
      if (!globalStyles) return undefined;
      var styles = css(globalStyles)(theme);
      return styles;
    }
  });
};

function omitThemingProps(props) {
  return omit(props, ["styleConfig", "size", "variant", "colorScheme"]);
}

function useChakra() {
  var colorModeResult = useColorMode();
  var theme = useTheme();
  return chakra_ui_system_esm_extends({}, colorModeResult, {
    theme: theme
  });
}

var resolveBreakpointValue = function resolveBreakpointValue(theme, tokenValue, fallbackValue) {
  var _ref, _getValue;

  if (tokenValue === null) return tokenValue;

  var getValue = function getValue(val) {
    var _theme$__breakpoints, _theme$__breakpoints$;

    return (_theme$__breakpoints = theme.__breakpoints) == null ? void 0 : (_theme$__breakpoints$ = _theme$__breakpoints.asArray) == null ? void 0 : _theme$__breakpoints$[val];
  };

  return (_ref = (_getValue = getValue(tokenValue)) != null ? _getValue : getValue(fallbackValue)) != null ? _ref : fallbackValue;
}; // inspired from ./css.ts : resolveTokenValue


var chakra_ui_system_esm_resolveTokenValue = function resolveTokenValue(theme, tokenValue, fallbackValue) {
  var _ref2, _getValue2;

  if (tokenValue == null) return tokenValue;

  var getValue = function getValue(val) {
    var _theme$__cssMap, _theme$__cssMap$val;

    return (_theme$__cssMap = theme.__cssMap) == null ? void 0 : (_theme$__cssMap$val = _theme$__cssMap[val]) == null ? void 0 : _theme$__cssMap$val.value;
  };

  return (_ref2 = (_getValue2 = getValue(tokenValue)) != null ? _getValue2 : getValue(fallbackValue)) != null ? _ref2 : fallbackValue;
};

function useToken(scale, token, fallback) {
  var theme = useTheme();

  if (Array.isArray(token)) {
    var fallbackArr = [];

    if (fallback) {
      fallbackArr = Array.isArray(fallback) ? fallback : [fallback];
    }

    return token.map(function (token, index) {
      var _fallbackArr$index2;

      if (scale === "breakpoints") {
        var _fallbackArr$index;

        return resolveBreakpointValue(theme, token, (_fallbackArr$index = fallbackArr[index]) != null ? _fallbackArr$index : token);
      }

      var path = scale + "." + token;
      return chakra_ui_system_esm_resolveTokenValue(theme, path, (_fallbackArr$index2 = fallbackArr[index]) != null ? _fallbackArr$index2 : token);
    });
  }

  if (scale === "breakpoints") {
    return resolveBreakpointValue(theme, token, fallback);
  }

  var path = scale + "." + token;
  return chakra_ui_system_esm_resolveTokenValue(theme, path, fallback);
}
function useProps(themeKey, props) {
  var _theme$components, _styleConfig$defaultP;

  var _useChakra = useChakra(),
      theme = _useChakra.theme,
      colorMode = _useChakra.colorMode;

  var styleConfig = props.styleConfig || ((_theme$components = theme.components) == null ? void 0 : _theme$components[themeKey]);
  var defaultProps = (_styleConfig$defaultP = styleConfig == null ? void 0 : styleConfig.defaultProps) != null ? _styleConfig$defaultP : {};

  var propsWithDefault = chakra_ui_system_esm_extends({}, defaultProps, filterUndefined(props));

  var stylesRef = useRef({});
  var mergedProps = mergeWith({}, propsWithDefault, {
    theme: theme,
    colorMode: colorMode
  });
  var memoizedStyles = useMemo(function () {
    if (styleConfig) {
      var _styleConfig$baseStyl, _styleConfig$variants, _styleConfig$variants2, _styleConfig$sizes, _styleConfig$sizes2;

      var baseStyles = runIfFn((_styleConfig$baseStyl = styleConfig.baseStyle) != null ? _styleConfig$baseStyl : {}, mergedProps);
      var variants = runIfFn((_styleConfig$variants = (_styleConfig$variants2 = styleConfig.variants) == null ? void 0 : _styleConfig$variants2[mergedProps.variant]) != null ? _styleConfig$variants : {}, mergedProps);
      var sizes = runIfFn((_styleConfig$sizes = (_styleConfig$sizes2 = styleConfig.sizes) == null ? void 0 : _styleConfig$sizes2[mergedProps.size]) != null ? _styleConfig$sizes : {}, mergedProps);
      var styles = mergeWith(baseStyles, sizes, variants);

      if (styleConfig.parts) {
        styleConfig.parts.forEach(function (part) {
          var _styles$part;

          styles[part] = (_styles$part = styles[part]) != null ? _styles$part : {};
        });
      }

      var isStyleEqual = isEqual(stylesRef.current, styles);

      if (!isStyleEqual) {
        stylesRef.current = styles;
      }
    }

    return stylesRef.current;
  }, [styleConfig, mergedProps]);
  return {
    styles: memoizedStyles,
    props: omitThemingProps(propsWithDefault)
  };
}

function chakra_ui_system_esm_objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/**
 * List of props for emotion to omit from DOM.
 * It mostly consists of Chakra props
 */

var allPropNames = new Set([].concat(propNames, ["textStyle", "layerStyle", "apply", "isTruncated", "noOfLines", "focusBorderColor", "errorBorderColor", "as", "__css", "css", "sx"]));
/**
 * htmlWidth and htmlHeight is used in the <Image />
 * component to support the native `width` and `height` attributes
 *
 * https://github.com/chakra-ui/chakra-ui/issues/149
 */

var validHTMLProps = new Set(["htmlWidth", "htmlHeight", "htmlSize"]);
var shouldForwardProp = function shouldForwardProp(prop) {
  return validHTMLProps.has(prop) || !allPropNames.has(prop);
};

var _excluded$1 = ["theme", "css", "__css", "sx"],
    _excluded2 = ["baseStyle"];

/**
 * Style resolver function that manages how style props are merged
 * in combination with other possible ways of defining styles.
 *
 * For example, take a component defined this way:
 * ```jsx
 * <Box fontSize="24px" sx={{ fontSize: "40px" }}></Box>
 * ```
 *
 * We want to manage the priority of the styles properly to prevent unwanted
 * behaviors. Right now, the `sx` prop has the highest priority so the resolved
 * fontSize will be `40px`
 */
var toCSSObject = function toCSSObject(_ref) {
  var baseStyle = _ref.baseStyle;
  return function (props) {
    props.theme;
        var cssProp = props.css,
        __css = props.__css,
        sx = props.sx,
        rest = chakra_ui_system_esm_objectWithoutPropertiesLoose(props, _excluded$1);

    var styleProps = objectFilter(rest, function (_, prop) {
      return isStyleProp(prop);
    });
    var finalBaseStyle = chakra_ui_utils_esm_runIfFn(baseStyle, props);
    var finalStyles = Object.assign({}, __css, finalBaseStyle, chakra_ui_utils_esm_filterUndefined(styleProps), sx);
    var computedCSS = chakra_ui_styled_system_esm_css(finalStyles)(props.theme);
    return cssProp ? [computedCSS, cssProp] : computedCSS;
  };
};
function styled(component, options) {
  var _ref2 = options != null ? options : {},
      baseStyle = _ref2.baseStyle,
      styledOptions = chakra_ui_system_esm_objectWithoutPropertiesLoose(_ref2, _excluded2);

  if (!styledOptions.shouldForwardProp) {
    styledOptions.shouldForwardProp = shouldForwardProp;
  }

  var styleObject = toCSSObject({
    baseStyle: baseStyle
  });
  return (0,emotion_styled_browser_esm/* default */.Z)(component, styledOptions)(styleObject);
}

/**
 * All credit goes to Chance (Reach UI), Haz (Reakit) and (fluentui)
 * for creating the base type definitions upon which we improved on
 */
function forwardRef(component) {
  return /*#__PURE__*/react.forwardRef(component);
}

var chakra_ui_system_esm_excluded = (/* unused pure expression or super */ null && (["styleConfig"]));
function useStyleConfig(themeKey, props, opts) {
  var _styleConfig$defaultP;

  if (props === void 0) {
    props = {};
  }

  if (opts === void 0) {
    opts = {};
  }

  var _props = props,
      styleConfigProp = _props.styleConfig,
      rest = chakra_ui_system_esm_objectWithoutPropertiesLoose(_props, chakra_ui_system_esm_excluded);

  var _useChakra = useChakra(),
      theme = _useChakra.theme,
      colorMode = _useChakra.colorMode;

  var themeStyleConfig = memoizedGet(theme, "components." + themeKey);
  var styleConfig = styleConfigProp || themeStyleConfig;
  var mergedProps = mergeWith({
    theme: theme,
    colorMode: colorMode
  }, (_styleConfig$defaultP = styleConfig == null ? void 0 : styleConfig.defaultProps) != null ? _styleConfig$defaultP : {}, filterUndefined(omit(rest, ["children"])));
  /**
   * Store the computed styles in a `ref` to avoid unneeded re-computation
   */

  var stylesRef = useRef({});

  if (styleConfig) {
    var _styleConfig$baseStyl, _styleConfig$variants, _styleConfig$variants2, _styleConfig$sizes$me, _styleConfig$sizes, _opts;

    var baseStyles = runIfFn((_styleConfig$baseStyl = styleConfig.baseStyle) != null ? _styleConfig$baseStyl : {}, mergedProps);
    var variants = runIfFn((_styleConfig$variants = (_styleConfig$variants2 = styleConfig.variants) == null ? void 0 : _styleConfig$variants2[mergedProps.variant]) != null ? _styleConfig$variants : {}, mergedProps);
    var sizes = runIfFn((_styleConfig$sizes$me = (_styleConfig$sizes = styleConfig.sizes) == null ? void 0 : _styleConfig$sizes[mergedProps.size]) != null ? _styleConfig$sizes$me : {}, mergedProps);
    var styles = mergeWith({}, baseStyles, sizes, variants);

    if ((_opts = opts) != null && _opts.isMultiPart && styleConfig.parts) {
      styleConfig.parts.forEach(function (part) {
        var _styles$part;

        styles[part] = (_styles$part = styles[part]) != null ? _styles$part : {};
      });
    }

    var isStyleEqual = isEqual(stylesRef.current, styles);

    if (!isStyleEqual) {
      stylesRef.current = styles;
    }
  }

  return stylesRef.current;
}
function useMultiStyleConfig(themeKey, props) {
  return useStyleConfig(themeKey, props, {
    isMultiPart: true
  });
}

function factory() {
  var cache = new Map();
  return new Proxy(styled, {
    /**
     * @example
     * const Div = chakra("div")
     * const WithChakra = chakra(AnotherComponent)
     */
    apply: function apply(target, thisArg, argArray) {
      return styled.apply(void 0, argArray);
    },

    /**
     * @example
     * <chakra.div />
     */
    get: function get(_, element) {
      if (!cache.has(element)) {
        cache.set(element, styled(element));
      }

      return cache.get(element);
    }
  });
}

var chakra = factory();




/***/ }),

/***/ 8678:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ makePublicApi; },
/* harmony export */   "y": function() { return /* binding */ defineGlobal; }
/* harmony export */ });
/* harmony import */ var _tools_catchUserErrors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40812);
/* harmony import */ var _tools_monitor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64933);
/* harmony import */ var _tools_display__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13842);



function makePublicApi(stub) {
    const publicApi = {
        version: "6.25.0",
        // This API method is intentionally not monitored, since the only thing executed is the
        // user-provided 'callback'.  All SDK usages executed in the callback should be monitored, and
        // we don't want to interfere with the user uncaught exceptions.
        onReady(callback) {
            callback();
        },
        ...stub,
    };
    // Add a "hidden" property to set debug mode. We define it that way to hide it
    // as much as possible but of course it's not a real protection.
    Object.defineProperty(publicApi, '_setDebug', {
        get() {
            return _tools_monitor__WEBPACK_IMPORTED_MODULE_0__/* .setDebugMode */ .yD;
        },
        enumerable: false,
    });
    return publicApi;
}
function defineGlobal(global, name, api) {
    const existingGlobalVariable = global[name];
    if (existingGlobalVariable && !existingGlobalVariable.q && existingGlobalVariable.version) {
        _tools_display__WEBPACK_IMPORTED_MODULE_1__/* .display.warn */ .jf.warn('SDK is loaded more than once. This is unsupported and might have unexpected behavior.');
    }
    global[name] = api;
    if (existingGlobalVariable && existingGlobalVariable.q) {
        existingGlobalVariable.q.forEach((fn) => (0,_tools_catchUserErrors__WEBPACK_IMPORTED_MODULE_2__/* .catchUserErrors */ .Z)(fn, 'onReady callback threw an error:')());
    }
}
//# sourceMappingURL=init.js.map

/***/ }),

/***/ 83206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ addEventListener; },
/* harmony export */   "y": function() { return /* binding */ addEventListeners; }
/* harmony export */ });
/* harmony import */ var _tools_monitor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64933);
/* harmony import */ var _tools_getZoneJsOriginalValue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59693);


/**
 * Add an event listener to an event target object (Window, Element, mock object...).  This provides
 * a few conveniences compared to using `element.addEventListener` directly:
 *
 * * supports IE11 by: using an option object only if needed and emulating the `once` option
 *
 * * wraps the listener with a `monitor` function
 *
 * * returns a `stop` function to remove the listener
 */
function addEventListener(configuration, eventTarget, eventName, listener, options) {
    return addEventListeners(configuration, eventTarget, [eventName], listener, options);
}
/**
 * Add event listeners to an event target object (Window, Element, mock object...).  This provides
 * a few conveniences compared to using `element.addEventListener` directly:
 *
 * * supports IE11 by: using an option object only if needed and emulating the `once` option
 *
 * * wraps the listener with a `monitor` function
 *
 * * returns a `stop` function to remove the listener
 *
 * * with `once: true`, the listener will be called at most once, even if different events are listened
 */
function addEventListeners(configuration, eventTarget, eventNames, listener, { once, capture, passive } = {}) {
    const listenerWithMonitor = (0,_tools_monitor__WEBPACK_IMPORTED_MODULE_0__/* .monitor */ .zk)((event) => {
        if (!event.isTrusted && !event.__ddIsTrusted && !configuration.allowUntrustedEvents) {
            return;
        }
        if (once) {
            stop();
        }
        listener(event);
    });
    const options = passive ? { capture, passive } : capture;
    // Use the window.EventTarget.prototype when possible to avoid wrong overrides (e.g: https://github.com/salesforce/lwc/issues/1824)
    const listenerTarget = window.EventTarget && eventTarget instanceof EventTarget ? window.EventTarget.prototype : eventTarget;
    const add = (0,_tools_getZoneJsOriginalValue__WEBPACK_IMPORTED_MODULE_1__/* .getZoneJsOriginalValue */ .I)(listenerTarget, 'addEventListener');
    eventNames.forEach((eventName) => add.call(eventTarget, eventName, listenerWithMonitor, options));
    function stop() {
        const remove = (0,_tools_getZoneJsOriginalValue__WEBPACK_IMPORTED_MODULE_1__/* .getZoneJsOriginalValue */ .I)(listenerTarget, 'removeEventListener');
        eventNames.forEach((eventName) => remove.call(eventTarget, eventName, listenerWithMonitor, options));
    }
    return {
        stop,
    };
}
//# sourceMappingURL=addEventListener.js.map

/***/ }),

/***/ 49647:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$1": function() { return /* binding */ getCookies; },
/* harmony export */   "OC": function() { return /* binding */ getInitCookie; },
/* harmony export */   "WQ": function() { return /* binding */ getCurrentSite; },
/* harmony export */   "d8": function() { return /* binding */ setCookie; },
/* harmony export */   "ej": function() { return /* binding */ getCookie; },
/* harmony export */   "oX": function() { return /* binding */ areCookiesAuthorized; }
/* harmony export */ });
/* unused harmony exports resetInitCookies, deleteCookie, resetGetCurrentSite */
/* harmony import */ var _tools_display__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13842);
/* harmony import */ var _tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25026);
/* harmony import */ var _tools_utils_stringUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88129);
/* harmony import */ var _tools_utils_urlPolyfill__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70170);




function setCookie(name, value, expireDelay = 0, options) {
    const date = new Date();
    date.setTime(date.getTime() + expireDelay);
    const expires = `expires=${date.toUTCString()}`;
    const sameSite = options && options.crossSite ? 'none' : 'strict';
    const domain = options && options.domain ? `;domain=${options.domain}` : '';
    const secure = options && options.secure ? ';secure' : '';
    const partitioned = options && options.partitioned ? ';partitioned' : '';
    document.cookie = `${name}=${value};${expires};path=/;samesite=${sameSite}${domain}${secure}${partitioned}`;
}
/**
 * Returns the value of the cookie with the given name
 * If there are multiple cookies with the same name, returns the first one
 */
function getCookie(name) {
    return (0,_tools_utils_stringUtils__WEBPACK_IMPORTED_MODULE_0__/* .findCommaSeparatedValue */ .MY)(document.cookie, name);
}
/**
 * Returns all the values of the cookies with the given name
 */
function getCookies(name) {
    return (0,_tools_utils_stringUtils__WEBPACK_IMPORTED_MODULE_0__/* .findAllCommaSeparatedValues */ .ql)(document.cookie).get(name) || [];
}
let initCookieParsed;
/**
 * Returns a cached value of the cookie. Use this during SDK initialization (and whenever possible)
 * to avoid accessing document.cookie multiple times.
 *
 * ⚠️ If there are multiple cookies with the same name, returns the LAST one (unlike `getCookie()`)
 */
function getInitCookie(name) {
    if (!initCookieParsed) {
        initCookieParsed = (0,_tools_utils_stringUtils__WEBPACK_IMPORTED_MODULE_0__/* .findCommaSeparatedValues */ .kq)(document.cookie);
    }
    return initCookieParsed.get(name);
}
function resetInitCookies() {
    initCookieParsed = undefined;
}
function deleteCookie(name, options) {
    setCookie(name, '', 0, options);
}
function areCookiesAuthorized(options) {
    if (document.cookie === undefined || document.cookie === null) {
        return false;
    }
    try {
        // Use a unique cookie name to avoid issues when the SDK is initialized multiple times during
        // the test cookie lifetime
        const testCookieName = `dd_cookie_test_${(0,_tools_utils_stringUtils__WEBPACK_IMPORTED_MODULE_0__/* .generateUUID */ .DO)()}`;
        const testCookieValue = 'test';
        setCookie(testCookieName, testCookieValue, _tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_1__/* .ONE_MINUTE */ .yR, options);
        const isCookieCorrectlySet = getCookie(testCookieName) === testCookieValue;
        deleteCookie(testCookieName, options);
        return isCookieCorrectlySet;
    }
    catch (error) {
        _tools_display__WEBPACK_IMPORTED_MODULE_2__/* .display.error */ .jf.error(error);
        return false;
    }
}
/**
 * No API to retrieve it, number of levels for subdomain and suffix are unknown
 * strategy: find the minimal domain on which cookies are allowed to be set
 * https://web.dev/same-site-same-origin/#site
 */
let getCurrentSiteCache;
function getCurrentSite(hostname = location.hostname, referrer = document.referrer) {
    if (getCurrentSiteCache === undefined) {
        const defaultHostName = getCookieDefaultHostName(hostname, referrer);
        if (defaultHostName) {
            // Use a unique cookie name to avoid issues when the SDK is initialized multiple times during
            // the test cookie lifetime
            const testCookieName = `dd_site_test_${(0,_tools_utils_stringUtils__WEBPACK_IMPORTED_MODULE_0__/* .generateUUID */ .DO)()}`;
            const testCookieValue = 'test';
            const domainLevels = defaultHostName.split('.');
            let candidateDomain = domainLevels.pop();
            while (domainLevels.length && !getCookie(testCookieName)) {
                candidateDomain = `${domainLevels.pop()}.${candidateDomain}`;
                setCookie(testCookieName, testCookieValue, _tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_1__/* .ONE_SECOND */ .WT, { domain: candidateDomain });
            }
            deleteCookie(testCookieName, { domain: candidateDomain });
            getCurrentSiteCache = candidateDomain;
        }
    }
    return getCurrentSiteCache;
}
function getCookieDefaultHostName(hostname, referrer) {
    try {
        return hostname || (0,_tools_utils_urlPolyfill__WEBPACK_IMPORTED_MODULE_3__/* .buildUrl */ .Q2)(referrer).hostname;
    }
    catch (_a) {
        // Ignore
    }
}
function resetGetCurrentSite() {
    getCurrentSiteCache = undefined;
}
//# sourceMappingURL=cookie.js.map

/***/ }),

/***/ 47581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FP": function() { return /* binding */ createPageMayExitObservable; },
/* harmony export */   "PT": function() { return /* binding */ isPageExitReason; },
/* harmony export */   "k$": function() { return /* binding */ PageExitReason; }
/* harmony export */ });
/* harmony import */ var _tools_observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75721);
/* harmony import */ var _tools_utils_polyfills__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94776);
/* harmony import */ var _addEventListener__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83206);



const PageExitReason = {
    HIDDEN: 'visibility_hidden',
    UNLOADING: 'before_unload',
    PAGEHIDE: 'page_hide',
    FROZEN: 'page_frozen',
};
function createPageMayExitObservable(configuration) {
    return new _tools_observable__WEBPACK_IMPORTED_MODULE_0__/* .Observable */ .y$((observable) => {
        const { stop: stopListeners } = (0,_addEventListener__WEBPACK_IMPORTED_MODULE_1__/* .addEventListeners */ .y)(configuration, window, ["visibilitychange" /* DOM_EVENT.VISIBILITY_CHANGE */, "freeze" /* DOM_EVENT.FREEZE */], (event) => {
            if (event.type === "visibilitychange" /* DOM_EVENT.VISIBILITY_CHANGE */ && document.visibilityState === 'hidden') {
                /**
                 * Only event that guarantee to fire on mobile devices when the page transitions to background state
                 * (e.g. when user switches to a different application, goes to homescreen, etc), or is being unloaded.
                 */
                observable.notify({ reason: PageExitReason.HIDDEN });
            }
            else if (event.type === "freeze" /* DOM_EVENT.FREEZE */) {
                /**
                 * After transitioning in background a tab can be freezed to preserve resources. (cf: https://developer.chrome.com/blog/page-lifecycle-api)
                 * Allow to collect events happening between hidden and frozen state.
                 */
                observable.notify({ reason: PageExitReason.FROZEN });
            }
        }, { capture: true });
        const stopBeforeUnloadListener = (0,_addEventListener__WEBPACK_IMPORTED_MODULE_1__/* .addEventListener */ .O)(configuration, window, "beforeunload" /* DOM_EVENT.BEFORE_UNLOAD */, () => {
            observable.notify({ reason: PageExitReason.UNLOADING });
        }).stop;
        return () => {
            stopListeners();
            stopBeforeUnloadListener();
        };
    });
}
function isPageExitReason(reason) {
    return (0,_tools_utils_polyfills__WEBPACK_IMPORTED_MODULE_2__/* .objectValues */ .TT)(PageExitReason).includes(reason);
}
//# sourceMappingURL=pageMayExitObservable.js.map

/***/ }),

/***/ 10193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ runOnReadyState; },
/* harmony export */   "_": function() { return /* binding */ asyncRunOnReadyState; }
/* harmony export */ });
/* harmony import */ var _tools_utils_functionUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(251);
/* harmony import */ var _addEventListener__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83206);


function runOnReadyState(configuration, expectedReadyState, callback) {
    if (document.readyState === expectedReadyState || document.readyState === 'complete') {
        callback();
        return { stop: _tools_utils_functionUtils__WEBPACK_IMPORTED_MODULE_0__/* .noop */ .Z };
    }
    const eventName = expectedReadyState === 'complete' ? "load" /* DOM_EVENT.LOAD */ : "DOMContentLoaded" /* DOM_EVENT.DOM_CONTENT_LOADED */;
    return (0,_addEventListener__WEBPACK_IMPORTED_MODULE_1__/* .addEventListener */ .O)(configuration, window, eventName, callback, { once: true });
}
function asyncRunOnReadyState(configuration, expectedReadyState) {
    return new Promise((resolve) => {
        runOnReadyState(configuration, expectedReadyState, resolve);
    });
}
//# sourceMappingURL=runOnReadyState.js.map

/***/ }),

/***/ 18769:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Jj": function() { return /* binding */ DefaultPrivacyLevel; },
  "tg": function() { return /* binding */ TraceContextInjection; },
  "RJ": function() { return /* binding */ isSampleRate; },
  "JZ": function() { return /* binding */ serializeConfiguration; },
  "fP": function() { return /* binding */ validateAndBuildConfiguration; }
});

// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/catchUserErrors.js
var catchUserErrors = __webpack_require__(40812);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/display.js
var display = __webpack_require__(13842);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/numberUtils.js
var numberUtils = __webpack_require__(73603);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/objectUtils.js
var objectUtils = __webpack_require__(94162);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/sessionStore.js + 1 modules
var sessionStore = __webpack_require__(63893);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/trackingConsent.js
var trackingConsent = __webpack_require__(92988);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/matchOption.js
var matchOption = __webpack_require__(95562);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/extension/extensionUtils.js
const EXTENSION_PREFIXES = ['chrome-extension://', 'moz-extension://'];
function containsExtensionUrl(str) {
    return EXTENSION_PREFIXES.some((prefix) => str.includes(prefix));
}
/**
 * Utility function to detect if the SDK is being initialized in an unsupported browser extension environment.
 *
 * @param windowLocation - The current window location to check
 * @param stack - The error stack to check for extension URLs
 * @returns true if running in an unsupported browser extension environment
 */
function isUnsupportedExtensionEnvironment(windowLocation, stack = '') {
    // If the page itself is an extension page.
    if (containsExtensionUrl(windowLocation)) {
        return false;
    }
    // Since we generate the error on the init, we check the 2nd frame line.
    const frameLines = stack.split('\n').filter((line) => {
        const trimmedLine = line.trim();
        return trimmedLine.length && /^at\s+|@/.test(trimmedLine);
    });
    const target = frameLines[1] || '';
    return containsExtensionUrl(target);
}
//# sourceMappingURL=extensionUtils.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/allowedTrackingOrigins.js



const ERROR_DOES_NOT_HAVE_ALLOWED_TRACKING_ORIGIN = 'Running the Browser SDK in a Web extension content script is forbidden unless the `allowedTrackingOrigins` option is provided.';
const ERROR_NOT_ALLOWED_TRACKING_ORIGIN = 'SDK initialized on a non-allowed domain.';
function isAllowedTrackingOrigins(configuration, errorStack, windowOrigin = typeof location !== 'undefined' ? location.origin : '') {
    const allowedTrackingOrigins = configuration.allowedTrackingOrigins;
    if (!allowedTrackingOrigins) {
        if (isUnsupportedExtensionEnvironment(windowOrigin, errorStack)) {
            display/* display.error */.jf.error(ERROR_DOES_NOT_HAVE_ALLOWED_TRACKING_ORIGIN);
            return false;
        }
        return true;
    }
    const isAllowed = (0,matchOption/* matchList */.v)(allowedTrackingOrigins, windowOrigin);
    if (!isAllowed) {
        display/* display.error */.jf.error(ERROR_NOT_ALLOWED_TRACKING_ORIGIN);
    }
    return isAllowed;
}
//# sourceMappingURL=allowedTrackingOrigins.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/globalObject.js
var globalObject = __webpack_require__(51145);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/configuration/transportConfiguration.js
var transportConfiguration = __webpack_require__(25039);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/configuration/configuration.js









/**
 * Default privacy level for the browser SDK.
 *
 * [Replay Privacy Options](https://docs.datadoghq.com/real_user_monitoring/session_replay/browser/privacy_options) for further information.
 */
const DefaultPrivacyLevel = {
    ALLOW: 'allow',
    MASK: 'mask',
    MASK_USER_INPUT: 'mask-user-input',
    MASK_UNLESS_ALLOWLISTED: 'mask-unless-allowlisted',
};
/**
 * Trace context injection option.
 *
 * See [Connect RUM and Traces](https://docs.datadoghq.com/real_user_monitoring/platform/connect_rum_and_traces/?tab=browserrum) for further information.
 */
const TraceContextInjection = {
    ALL: 'all',
    SAMPLED: 'sampled',
};
function isString(tag, tagName) {
    if (tag !== undefined && tag !== null && typeof tag !== 'string') {
        display/* display.error */.jf.error(`${tagName} must be defined as a string`);
        return false;
    }
    return true;
}
function isDatadogSite(site) {
    if (site && typeof site === 'string' && !/(datadog|ddog|datad0g|dd0g)/.test(site)) {
        display/* display.error */.jf.error(`Site should be a valid Datadog site. ${display/* MORE_DETAILS */.IA} ${display/* DOCS_ORIGIN */.aA}/getting_started/site/.`);
        return false;
    }
    return true;
}
function isSampleRate(sampleRate, name) {
    if (sampleRate !== undefined && !(0,numberUtils/* isPercentage */.zz)(sampleRate)) {
        display/* display.error */.jf.error(`${name} Sample Rate should be a number between 0 and 100`);
        return false;
    }
    return true;
}
function validateAndBuildConfiguration(initConfiguration, errorStack) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    if (!initConfiguration || !initConfiguration.clientToken) {
        display/* display.error */.jf.error('Client Token is not configured, we will not send any data.');
        return;
    }
    if (initConfiguration.allowedTrackingOrigins !== undefined &&
        !Array.isArray(initConfiguration.allowedTrackingOrigins)) {
        display/* display.error */.jf.error('Allowed Tracking Origins must be an array');
        return;
    }
    if (!isDatadogSite(initConfiguration.site) ||
        !isSampleRate(initConfiguration.sessionSampleRate, 'Session') ||
        !isSampleRate(initConfiguration.telemetrySampleRate, 'Telemetry') ||
        !isSampleRate(initConfiguration.telemetryConfigurationSampleRate, 'Telemetry Configuration') ||
        !isSampleRate(initConfiguration.telemetryUsageSampleRate, 'Telemetry Usage') ||
        !isString(initConfiguration.version, 'Version') ||
        !isString(initConfiguration.env, 'Env') ||
        !isString(initConfiguration.service, 'Service') ||
        !isAllowedTrackingOrigins(initConfiguration, errorStack !== null && errorStack !== void 0 ? errorStack : '')) {
        return;
    }
    if (initConfiguration.trackingConsent !== undefined &&
        !(0,objectUtils/* objectHasValue */.E5)(trackingConsent/* TrackingConsent */.h, initConfiguration.trackingConsent)) {
        display/* display.error */.jf.error('Tracking Consent should be either "granted" or "not-granted"');
        return;
    }
    return {
        beforeSend: initConfiguration.beforeSend && (0,catchUserErrors/* catchUserErrors */.Z)(initConfiguration.beforeSend, 'beforeSend threw an error:'),
        sessionStoreStrategyType: globalObject/* isWorkerEnvironment */.jX ? undefined : (0,sessionStore/* selectSessionStoreStrategyType */.hB)(initConfiguration),
        sessionSampleRate: (_a = initConfiguration.sessionSampleRate) !== null && _a !== void 0 ? _a : 100,
        telemetrySampleRate: (_b = initConfiguration.telemetrySampleRate) !== null && _b !== void 0 ? _b : 20,
        telemetryConfigurationSampleRate: (_c = initConfiguration.telemetryConfigurationSampleRate) !== null && _c !== void 0 ? _c : 5,
        telemetryUsageSampleRate: (_d = initConfiguration.telemetryUsageSampleRate) !== null && _d !== void 0 ? _d : 5,
        service: (_e = initConfiguration.service) !== null && _e !== void 0 ? _e : undefined,
        env: (_f = initConfiguration.env) !== null && _f !== void 0 ? _f : undefined,
        version: (_g = initConfiguration.version) !== null && _g !== void 0 ? _g : undefined,
        datacenter: (_h = initConfiguration.datacenter) !== null && _h !== void 0 ? _h : undefined,
        silentMultipleInit: !!initConfiguration.silentMultipleInit,
        allowUntrustedEvents: !!initConfiguration.allowUntrustedEvents,
        trackingConsent: (_j = initConfiguration.trackingConsent) !== null && _j !== void 0 ? _j : trackingConsent/* TrackingConsent.GRANTED */.h.GRANTED,
        trackAnonymousUser: (_k = initConfiguration.trackAnonymousUser) !== null && _k !== void 0 ? _k : true,
        storeContextsAcrossPages: !!initConfiguration.storeContextsAcrossPages,
        betaEncodeCookieOptions: !!initConfiguration.betaEncodeCookieOptions,
        /**
         * The source of the SDK, used for support plugins purposes.
         */
        variant: initConfiguration.variant,
        sdkVersion: initConfiguration.sdkVersion,
        ...(0,transportConfiguration/* computeTransportConfiguration */.h)(initConfiguration),
    };
}
function serializeConfiguration(initConfiguration) {
    return {
        session_sample_rate: initConfiguration.sessionSampleRate,
        telemetry_sample_rate: initConfiguration.telemetrySampleRate,
        telemetry_configuration_sample_rate: initConfiguration.telemetryConfigurationSampleRate,
        telemetry_usage_sample_rate: initConfiguration.telemetryUsageSampleRate,
        use_before_send: !!initConfiguration.beforeSend,
        use_partitioned_cross_site_session_cookie: initConfiguration.usePartitionedCrossSiteSessionCookie,
        use_secure_session_cookie: initConfiguration.useSecureSessionCookie,
        use_proxy: !!initConfiguration.proxy,
        silent_multiple_init: initConfiguration.silentMultipleInit,
        track_session_across_subdomains: initConfiguration.trackSessionAcrossSubdomains,
        track_anonymous_user: initConfiguration.trackAnonymousUser,
        session_persistence: initConfiguration.sessionPersistence,
        allow_fallback_to_local_storage: !!initConfiguration.allowFallbackToLocalStorage,
        store_contexts_across_pages: !!initConfiguration.storeContextsAcrossPages,
        allow_untrusted_events: !!initConfiguration.allowUntrustedEvents,
        tracking_consent: initConfiguration.trackingConsent,
        use_allowed_tracking_origins: Array.isArray(initConfiguration.allowedTrackingOrigins),
        beta_encode_cookie_options: initConfiguration.betaEncodeCookieOptions,
        source: initConfiguration.source,
        sdk_version: initConfiguration.sdkVersion,
        variant: initConfiguration.variant,
    };
}
//# sourceMappingURL=configuration.js.map

/***/ }),

/***/ 99176:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ createEndpointBuilder; },
/* harmony export */   "_": function() { return /* binding */ buildEndpointHost; }
/* harmony export */ });
/* harmony import */ var _tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25026);
/* harmony import */ var _tools_utils_urlPolyfill__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70170);
/* harmony import */ var _tools_utils_stringUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88129);
/* harmony import */ var _intakeSites__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93909);




function createEndpointBuilder(initConfiguration, trackType, extraParameters) {
    const buildUrlWithParameters = createEndpointUrlWithParametersBuilder(initConfiguration, trackType);
    return {
        build(api, payload) {
            const parameters = buildEndpointParameters(initConfiguration, trackType, api, payload, extraParameters);
            return buildUrlWithParameters(parameters);
        },
        trackType,
    };
}
/**
 * Create a function used to build a full endpoint url from provided parameters. The goal of this
 * function is to pre-compute some parts of the URL to avoid re-computing everything on every
 * request, as only parameters are changing.
 */
function createEndpointUrlWithParametersBuilder(initConfiguration, trackType) {
    const path = `/api/v2/${trackType}`;
    const proxy = initConfiguration.proxy;
    if (typeof proxy === 'string') {
        const normalizedProxyUrl = (0,_tools_utils_urlPolyfill__WEBPACK_IMPORTED_MODULE_0__/* .normalizeUrl */ .D5)(proxy);
        return (parameters) => `${normalizedProxyUrl}?ddforward=${encodeURIComponent(`${path}?${parameters}`)}`;
    }
    if (typeof proxy === 'function') {
        return (parameters) => proxy({ path, parameters });
    }
    const host = buildEndpointHost(trackType, initConfiguration);
    return (parameters) => `https://${host}${path}?${parameters}`;
}
function buildEndpointHost(trackType, initConfiguration) {
    const { site = _intakeSites__WEBPACK_IMPORTED_MODULE_1__/* .INTAKE_SITE_US1 */ .D_, internalAnalyticsSubdomain } = initConfiguration;
    if (trackType === 'logs' && initConfiguration.usePciIntake && site === _intakeSites__WEBPACK_IMPORTED_MODULE_1__/* .INTAKE_SITE_US1 */ .D_) {
        return _intakeSites__WEBPACK_IMPORTED_MODULE_1__/* .PCI_INTAKE_HOST_US1 */ .iL;
    }
    if (internalAnalyticsSubdomain && site === _intakeSites__WEBPACK_IMPORTED_MODULE_1__/* .INTAKE_SITE_US1 */ .D_) {
        return `${internalAnalyticsSubdomain}.${_intakeSites__WEBPACK_IMPORTED_MODULE_1__/* .INTAKE_SITE_US1 */ .D_}`;
    }
    if (site === _intakeSites__WEBPACK_IMPORTED_MODULE_1__/* .INTAKE_SITE_FED_STAGING */ .by) {
        return `http-intake.logs.${site}`;
    }
    const domainParts = site.split('.');
    const extension = domainParts.pop();
    return `browser-intake-${domainParts.join('-')}.${extension}`;
}
/**
 * Build parameters to be used for an intake request. Parameters should be re-built for each
 * request, as they change randomly.
 */
function buildEndpointParameters({ clientToken, internalAnalyticsSubdomain, source = 'browser' }, trackType, api, { retry, encoding }, extraParameters = []) {
    const parameters = [
        `ddsource=${source}`,
        `dd-api-key=${clientToken}`,
        `dd-evp-origin-version=${encodeURIComponent("6.25.0")}`,
        'dd-evp-origin=browser',
        `dd-request-id=${(0,_tools_utils_stringUtils__WEBPACK_IMPORTED_MODULE_2__/* .generateUUID */ .DO)()}`,
    ].concat(extraParameters);
    if (encoding) {
        parameters.push(`dd-evp-encoding=${encoding}`);
    }
    if (trackType === 'rum') {
        parameters.push(`batch_time=${(0,_tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_3__/* .timeStampNow */ .n$)()}`, `_dd.api=${api}`);
        if (retry) {
            parameters.push(`_dd.retry_count=${retry.count}`, `_dd.retry_after=${retry.lastFailureStatus}`);
        }
    }
    if (internalAnalyticsSubdomain) {
        parameters.reverse();
    }
    return parameters.join('&');
}
//# sourceMappingURL=endpointBuilder.js.map

/***/ }),

/***/ 25039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ computeTransportConfiguration; },
/* harmony export */   "i": function() { return /* binding */ isIntakeUrl; }
/* harmony export */ });
/* harmony import */ var _intakeSites__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93909);
/* harmony import */ var _endpointBuilder__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99176);


function computeTransportConfiguration(initConfiguration) {
    const site = initConfiguration.site || _intakeSites__WEBPACK_IMPORTED_MODULE_0__/* .INTAKE_SITE_US1 */ .D_;
    const source = validateSource(initConfiguration.source);
    const endpointBuilders = computeEndpointBuilders({ ...initConfiguration, site, source });
    const replicaConfiguration = computeReplicaConfiguration({ ...initConfiguration, site, source });
    return {
        replica: replicaConfiguration,
        site,
        source,
        ...endpointBuilders,
    };
}
function validateSource(source) {
    if (source === 'flutter' || source === 'unity') {
        return source;
    }
    return 'browser';
}
function computeEndpointBuilders(initConfiguration) {
    return {
        logsEndpointBuilder: (0,_endpointBuilder__WEBPACK_IMPORTED_MODULE_1__/* .createEndpointBuilder */ .E)(initConfiguration, 'logs'),
        rumEndpointBuilder: (0,_endpointBuilder__WEBPACK_IMPORTED_MODULE_1__/* .createEndpointBuilder */ .E)(initConfiguration, 'rum'),
        profilingEndpointBuilder: (0,_endpointBuilder__WEBPACK_IMPORTED_MODULE_1__/* .createEndpointBuilder */ .E)(initConfiguration, 'profile'),
        sessionReplayEndpointBuilder: (0,_endpointBuilder__WEBPACK_IMPORTED_MODULE_1__/* .createEndpointBuilder */ .E)(initConfiguration, 'replay'),
        exposuresEndpointBuilder: (0,_endpointBuilder__WEBPACK_IMPORTED_MODULE_1__/* .createEndpointBuilder */ .E)(initConfiguration, 'exposures'),
        flagEvaluationEndpointBuilder: (0,_endpointBuilder__WEBPACK_IMPORTED_MODULE_1__/* .createEndpointBuilder */ .E)(initConfiguration, 'flagevaluation'),
    };
}
function computeReplicaConfiguration(initConfiguration) {
    if (!initConfiguration.replica) {
        return;
    }
    const replicaConfiguration = {
        ...initConfiguration,
        site: _intakeSites__WEBPACK_IMPORTED_MODULE_0__/* .INTAKE_SITE_US1 */ .D_,
        clientToken: initConfiguration.replica.clientToken,
    };
    return {
        logsEndpointBuilder: (0,_endpointBuilder__WEBPACK_IMPORTED_MODULE_1__/* .createEndpointBuilder */ .E)(replicaConfiguration, 'logs'),
        rumEndpointBuilder: (0,_endpointBuilder__WEBPACK_IMPORTED_MODULE_1__/* .createEndpointBuilder */ .E)(replicaConfiguration, 'rum', [
            `application.id=${initConfiguration.replica.applicationId}`,
        ]),
    };
}
function isIntakeUrl(url) {
    // check if tags is present in the query string
    return _intakeSites__WEBPACK_IMPORTED_MODULE_0__/* .INTAKE_URL_PARAMETERS.every */ .Rg.every((param) => url.includes(param));
}
//# sourceMappingURL=transportConfiguration.js.map

/***/ }),

/***/ 68826:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ getConnectivity; }
/* harmony export */ });
/* harmony import */ var _tools_globalObject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51145);

function getConnectivity() {
    var _a;
    const navigator = _tools_globalObject__WEBPACK_IMPORTED_MODULE_0__/* .globalObject.navigator */ .Zf.navigator;
    return {
        status: navigator.onLine ? 'connected' : 'not_connected',
        interfaces: navigator.connection && navigator.connection.type ? [navigator.connection.type] : undefined,
        effective_type: (_a = navigator.connection) === null || _a === void 0 ? void 0 : _a.effectiveType,
    };
}
//# sourceMappingURL=connectivity.js.map

/***/ }),

/***/ 45242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AP": function() { return /* binding */ computeRawError; },
/* harmony export */   "K$": function() { return /* binding */ NO_ERROR_STACK_PRESENT_MESSAGE; },
/* harmony export */   "VZ": function() { return /* binding */ isError; }
/* harmony export */ });
/* unused harmony exports tryToGetFingerprint, tryToGetErrorContext, getFileFromStackTraceString, flattenErrorCauses */
/* harmony import */ var _tools_serialisation_sanitize__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68566);
/* harmony import */ var _tools_serialisation_jsonStringify__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19012);
/* harmony import */ var _tools_stackTrace_computeStackTrace__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22685);
/* harmony import */ var _tools_stackTrace_handlingStack__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24507);




const NO_ERROR_STACK_PRESENT_MESSAGE = 'No stack, consider using an instance of Error';
function computeErrorBase({ originalError, stackTrace, source, useFallbackStack = true, nonErrorPrefix, }) {
    const isErrorInstance = isError(originalError);
    if (!stackTrace && isErrorInstance) {
        stackTrace = (0,_tools_stackTrace_computeStackTrace__WEBPACK_IMPORTED_MODULE_0__/* .computeStackTrace */ ._)(originalError);
    }
    return {
        source,
        type: stackTrace ? stackTrace.name : undefined,
        message: computeMessage(stackTrace, isErrorInstance, nonErrorPrefix, originalError),
        stack: stackTrace ? (0,_tools_stackTrace_handlingStack__WEBPACK_IMPORTED_MODULE_1__/* .toStackTraceString */ .P3)(stackTrace) : useFallbackStack ? NO_ERROR_STACK_PRESENT_MESSAGE : undefined,
    };
}
function computeRawError({ stackTrace, originalError, handlingStack, componentStack, startClocks, nonErrorPrefix, useFallbackStack = true, source, handling, }) {
    const errorBase = computeErrorBase({ originalError, stackTrace, source, useFallbackStack, nonErrorPrefix });
    return {
        startClocks,
        handling,
        handlingStack,
        componentStack,
        originalError,
        ...errorBase,
        causes: isError(originalError) ? flattenErrorCauses(originalError, source) : undefined,
        fingerprint: tryToGetFingerprint(originalError),
        context: tryToGetErrorContext(originalError),
    };
}
function computeMessage(stackTrace, isErrorInstance, nonErrorPrefix, originalError) {
    // Favor stackTrace message only if tracekit has really been able to extract something meaningful (message + name)
    // TODO rework tracekit integration to avoid scattering error building logic
    return (stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.message) && (stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.name)
        ? stackTrace.message
        : !isErrorInstance
            ? nonErrorPrefix
                ? `${nonErrorPrefix} ${(0,_tools_serialisation_jsonStringify__WEBPACK_IMPORTED_MODULE_2__/* .jsonStringify */ .l)((0,_tools_serialisation_sanitize__WEBPACK_IMPORTED_MODULE_3__/* .sanitize */ .N)(originalError))}`
                : (0,_tools_serialisation_jsonStringify__WEBPACK_IMPORTED_MODULE_2__/* .jsonStringify */ .l)((0,_tools_serialisation_sanitize__WEBPACK_IMPORTED_MODULE_3__/* .sanitize */ .N)(originalError))
            : 'Empty message';
}
function tryToGetFingerprint(originalError) {
    return isError(originalError) && 'dd_fingerprint' in originalError ? String(originalError.dd_fingerprint) : undefined;
}
function tryToGetErrorContext(originalError) {
    if (originalError !== null && typeof originalError === 'object' && 'dd_context' in originalError) {
        return originalError.dd_context;
    }
}
function getFileFromStackTraceString(stack) {
    var _a;
    return (_a = /@ (.+)/.exec(stack)) === null || _a === void 0 ? void 0 : _a[1];
}
function isError(error) {
    return error instanceof Error || Object.prototype.toString.call(error) === '[object Error]';
}
function flattenErrorCauses(error, parentSource) {
    const causes = [];
    let currentCause = error.cause;
    while (currentCause !== undefined && currentCause !== null && causes.length < 10) {
        const causeBase = computeErrorBase({
            originalError: currentCause,
            source: parentSource,
            useFallbackStack: false,
        });
        causes.push(causeBase);
        currentCause = isError(currentCause) ? currentCause.cause : undefined;
    }
    return causes.length ? causes : undefined;
}
//# sourceMappingURL=error.js.map

/***/ }),

/***/ 42419:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ ErrorSource; }
/* harmony export */ });
const ErrorSource = {
    AGENT: 'agent',
    CONSOLE: 'console',
    CUSTOM: 'custom',
    LOGGER: 'logger',
    NETWORK: 'network',
    SOURCE: 'source',
    REPORT: 'report',
};
//# sourceMappingURL=error.types.js.map

/***/ }),

/***/ 93909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DZ": function() { return /* binding */ INTAKE_SITE_STAGING; },
/* harmony export */   "D_": function() { return /* binding */ INTAKE_SITE_US1; },
/* harmony export */   "Ds": function() { return /* binding */ INTAKE_SITE_EU1; },
/* harmony export */   "Rg": function() { return /* binding */ INTAKE_URL_PARAMETERS; },
/* harmony export */   "by": function() { return /* binding */ INTAKE_SITE_FED_STAGING; },
/* harmony export */   "iL": function() { return /* binding */ PCI_INTAKE_HOST_US1; },
/* harmony export */   "y7": function() { return /* binding */ INTAKE_SITE_US1_FED; }
/* harmony export */ });
const INTAKE_SITE_STAGING = 'datad0g.com';
const INTAKE_SITE_FED_STAGING = 'dd0g-gov.com';
const INTAKE_SITE_US1 = 'datadoghq.com';
const INTAKE_SITE_EU1 = 'datadoghq.eu';
const INTAKE_SITE_US1_FED = 'ddog-gov.com';
const PCI_INTAKE_HOST_US1 = 'pci.browser-intake-datadoghq.com';
const INTAKE_URL_PARAMETERS = ['ddsource', 'dd-api-key', 'dd-request-id'];
//# sourceMappingURL=intakeSites.js.map

/***/ }),

/***/ 78981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TN": function() { return /* binding */ SESSION_TIME_OUT_DELAY; },
/* harmony export */   "_q": function() { return /* binding */ SessionPersistence; },
/* harmony export */   "m8": function() { return /* binding */ SESSION_NOT_TRACKED; },
/* harmony export */   "sr": function() { return /* binding */ SESSION_EXPIRATION_DELAY; },
/* harmony export */   "uY": function() { return /* binding */ SESSION_COOKIE_EXPIRATION_DELAY; }
/* harmony export */ });
/* harmony import */ var _tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25026);

const SESSION_TIME_OUT_DELAY = 4 * _tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_0__/* .ONE_HOUR */ .dV;
const SESSION_EXPIRATION_DELAY = 15 * _tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_0__/* .ONE_MINUTE */ .yR;
const SESSION_COOKIE_EXPIRATION_DELAY = _tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_0__/* .ONE_YEAR */ .P5;
const SESSION_NOT_TRACKED = '0';
/**
 * @internal
 */
const SessionPersistence = {
    COOKIE: 'cookie',
    LOCAL_STORAGE: 'local-storage',
};
//# sourceMappingURL=sessionConstants.js.map

/***/ }),

/***/ 66923:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Il": function() { return /* binding */ expandSessionState; },
  "NK": function() { return /* binding */ getExpiredSessionState; },
  "Ey": function() { return /* binding */ isSessionInExpiredState; },
  "Tm": function() { return /* binding */ isSessionInNotStartedState; },
  "Qw": function() { return /* binding */ isSessionStarted; },
  "q1": function() { return /* binding */ toSessionState; },
  "u_": function() { return /* binding */ toSessionString; }
});

// UNUSED EXPORTS: EXPIRED

// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/objectUtils.js
var objectUtils = __webpack_require__(94162);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/polyfills.js
var polyfills = __webpack_require__(94776);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/timeUtils.js
var timeUtils = __webpack_require__(25026);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/sessionConstants.js
var sessionConstants = __webpack_require__(78981);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/sessionStateValidation.js
const SESSION_ENTRY_REGEXP = /^([a-zA-Z]+)=([a-z0-9-]+)$/;
const SESSION_ENTRY_SEPARATOR = '&';
function isValidSessionString(sessionString) {
    return (!!sessionString &&
        (sessionString.indexOf(SESSION_ENTRY_SEPARATOR) !== -1 || SESSION_ENTRY_REGEXP.test(sessionString)));
}
//# sourceMappingURL=sessionStateValidation.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/sessionState.js





const EXPIRED = '1';
function getExpiredSessionState(previousSessionState, configuration) {
    const expiredSessionState = {
        isExpired: EXPIRED,
    };
    if (configuration.trackAnonymousUser && (previousSessionState === null || previousSessionState === void 0 ? void 0 : previousSessionState.anonymousId)) {
        expiredSessionState.anonymousId = previousSessionState === null || previousSessionState === void 0 ? void 0 : previousSessionState.anonymousId;
    }
    return expiredSessionState;
}
function isSessionInNotStartedState(session) {
    return (0,objectUtils/* isEmptyObject */.Qr)(session);
}
function isSessionStarted(session) {
    return !isSessionInNotStartedState(session);
}
function isSessionInExpiredState(session) {
    return session.isExpired !== undefined || !isActiveSession(session);
}
// An active session is a session in either `Tracked` or `NotTracked` state
function isActiveSession(sessionState) {
    // created and expire can be undefined for versions which was not storing them
    // these checks could be removed when older versions will not be available/live anymore
    return ((sessionState.created === undefined || (0,timeUtils/* dateNow */.m6)() - Number(sessionState.created) < sessionConstants/* SESSION_TIME_OUT_DELAY */.TN) &&
        (sessionState.expire === undefined || (0,timeUtils/* dateNow */.m6)() < Number(sessionState.expire)));
}
function expandSessionState(session) {
    session.expire = String((0,timeUtils/* dateNow */.m6)() + sessionConstants/* SESSION_EXPIRATION_DELAY */.sr);
}
function toSessionString(session) {
    return ((0,polyfills/* objectEntries */.qP)(session)
        // we use `aid` as a key for anonymousId
        .map(([key, value]) => (key === 'anonymousId' ? `aid=${value}` : `${key}=${value}`))
        .join(SESSION_ENTRY_SEPARATOR));
}
function toSessionState(sessionString) {
    const session = {};
    if (isValidSessionString(sessionString)) {
        sessionString.split(SESSION_ENTRY_SEPARATOR).forEach((entry) => {
            const matches = SESSION_ENTRY_REGEXP.exec(entry);
            if (matches !== null) {
                const [, key, value] = matches;
                if (key === 'aid') {
                    // we use `aid` as a key for anonymousId
                    session.anonymousId = value;
                }
                else {
                    session[key] = value;
                }
            }
        });
    }
    return session;
}
//# sourceMappingURL=sessionState.js.map

/***/ }),

/***/ 63893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "hB": function() { return /* binding */ selectSessionStoreStrategyType; },
  "vH": function() { return /* binding */ startSessionStore; }
});

// UNUSED EXPORTS: STORAGE_POLL_DELAY, getSessionStoreStrategy

// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/timer.js
var timer = __webpack_require__(65483);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/observable.js + 1 modules
var observable = __webpack_require__(75721);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/timeUtils.js
var timeUtils = __webpack_require__(25026);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/functionUtils.js
var functionUtils = __webpack_require__(251);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/stringUtils.js
var stringUtils = __webpack_require__(88129);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/display.js
var display = __webpack_require__(13842);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/storeStrategies/sessionInCookie.js + 1 modules
var sessionInCookie = __webpack_require__(49430);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/sessionState.js + 1 modules
var session_sessionState = __webpack_require__(66923);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/storeStrategies/sessionInLocalStorage.js
var sessionInLocalStorage = __webpack_require__(65485);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/sessionStoreOperations.js




const LOCK_RETRY_DELAY = 10;
const LOCK_MAX_TRIES = 100;
// Locks should be hold for a few milliseconds top, just the time it takes to read and write a
// cookie. Using one second should be enough in most situations.
const LOCK_EXPIRATION_DELAY = timeUtils/* ONE_SECOND */.WT;
const LOCK_SEPARATOR = '--';
const bufferedOperations = [];
let ongoingOperations;
function processSessionStoreOperations(operations, sessionStoreStrategy, numberOfRetries = 0) {
    var _a;
    const { isLockEnabled, persistSession, expireSession } = sessionStoreStrategy;
    const persistWithLock = (session) => persistSession({ ...session, lock: currentLock });
    const retrieveStore = () => {
        const { lock, ...session } = sessionStoreStrategy.retrieveSession();
        return {
            session,
            lock: lock && !isLockExpired(lock) ? lock : undefined,
        };
    };
    if (!ongoingOperations) {
        ongoingOperations = operations;
    }
    if (operations !== ongoingOperations) {
        bufferedOperations.push(operations);
        return;
    }
    if (isLockEnabled && numberOfRetries >= LOCK_MAX_TRIES) {
        next(sessionStoreStrategy);
        return;
    }
    let currentLock;
    let currentStore = retrieveStore();
    if (isLockEnabled) {
        // if someone has lock, retry later
        if (currentStore.lock) {
            retryLater(operations, sessionStoreStrategy, numberOfRetries);
            return;
        }
        // acquire lock
        currentLock = createLock();
        persistWithLock(currentStore.session);
        // if lock is not acquired, retry later
        currentStore = retrieveStore();
        if (currentStore.lock !== currentLock) {
            retryLater(operations, sessionStoreStrategy, numberOfRetries);
            return;
        }
    }
    let processedSession = operations.process(currentStore.session);
    if (isLockEnabled) {
        // if lock corrupted after process, retry later
        currentStore = retrieveStore();
        if (currentStore.lock !== currentLock) {
            retryLater(operations, sessionStoreStrategy, numberOfRetries);
            return;
        }
    }
    if (processedSession) {
        if ((0,session_sessionState/* isSessionInExpiredState */.Ey)(processedSession)) {
            expireSession(processedSession);
        }
        else {
            (0,session_sessionState/* expandSessionState */.Il)(processedSession);
            if (isLockEnabled) {
                persistWithLock(processedSession);
            }
            else {
                persistSession(processedSession);
            }
        }
    }
    if (isLockEnabled) {
        // correctly handle lock around expiration would require to handle this case properly at several levels
        // since we don't have evidence of lock issues around expiration, let's just not do the corruption check for it
        if (!(processedSession && (0,session_sessionState/* isSessionInExpiredState */.Ey)(processedSession))) {
            // if lock corrupted after persist, retry later
            currentStore = retrieveStore();
            if (currentStore.lock !== currentLock) {
                retryLater(operations, sessionStoreStrategy, numberOfRetries);
                return;
            }
            persistSession(currentStore.session);
            processedSession = currentStore.session;
        }
    }
    // call after even if session is not persisted in order to perform operations on
    // up-to-date session state value => the value could have been modified by another tab
    (_a = operations.after) === null || _a === void 0 ? void 0 : _a.call(operations, processedSession || currentStore.session);
    next(sessionStoreStrategy);
}
function retryLater(operations, sessionStore, currentNumberOfRetries) {
    (0,timer/* setTimeout */.iK)(() => {
        processSessionStoreOperations(operations, sessionStore, currentNumberOfRetries + 1);
    }, LOCK_RETRY_DELAY);
}
function next(sessionStore) {
    ongoingOperations = undefined;
    const nextOperations = bufferedOperations.shift();
    if (nextOperations) {
        processSessionStoreOperations(nextOperations, sessionStore);
    }
}
function createLock() {
    return (0,stringUtils/* generateUUID */.DO)() + LOCK_SEPARATOR + (0,timeUtils/* timeStampNow */.n$)();
}
function isLockExpired(lock) {
    const [, timeStamp] = lock.split(LOCK_SEPARATOR);
    return !timeStamp || (0,timeUtils/* elapsed */._J)(Number(timeStamp), (0,timeUtils/* timeStampNow */.n$)()) > LOCK_EXPIRATION_DELAY;
}
//# sourceMappingURL=sessionStoreOperations.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/sessionConstants.js
var sessionConstants = __webpack_require__(78981);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/sessionStore.js











/**
 * Every second, the storage will be polled to check for any change that can occur
 * to the session state in another browser tab, or another window.
 * This value has been determined from our previous cookie-only implementation.
 */
const STORAGE_POLL_DELAY = timeUtils/* ONE_SECOND */.WT;
/**
 * Selects the correct session store strategy type based on the configuration and storage
 * availability.
 */
function selectSessionStoreStrategyType(initConfiguration) {
    switch (initConfiguration.sessionPersistence) {
        case sessionConstants/* SessionPersistence.COOKIE */._q.COOKIE:
            return (0,sessionInCookie/* selectCookieStrategy */.XR)(initConfiguration);
        case sessionConstants/* SessionPersistence.LOCAL_STORAGE */._q.LOCAL_STORAGE:
            return (0,sessionInLocalStorage/* selectLocalStorageStrategy */.un)();
        case undefined: {
            let sessionStoreStrategyType = (0,sessionInCookie/* selectCookieStrategy */.XR)(initConfiguration);
            if (!sessionStoreStrategyType && initConfiguration.allowFallbackToLocalStorage) {
                sessionStoreStrategyType = (0,sessionInLocalStorage/* selectLocalStorageStrategy */.un)();
            }
            return sessionStoreStrategyType;
        }
        default:
            display/* display.error */.jf.error(`Invalid session persistence '${String(initConfiguration.sessionPersistence)}'`);
    }
}
function getSessionStoreStrategy(sessionStoreStrategyType, configuration) {
    return sessionStoreStrategyType.type === sessionConstants/* SessionPersistence.COOKIE */._q.COOKIE
        ? (0,sessionInCookie/* initCookieStrategy */.h$)(configuration, sessionStoreStrategyType.cookieOptions)
        : (0,sessionInLocalStorage/* initLocalStorageStrategy */.m_)(configuration);
}
/**
 * Different session concepts:
 * - tracked, the session has an id and is updated along the user navigation
 * - not tracked, the session does not have an id but it is updated along the user navigation
 * - inactive, no session in store or session expired, waiting for a renew session
 */
function startSessionStore(sessionStoreStrategyType, configuration, productKey, computeTrackingType, sessionStoreStrategy = getSessionStoreStrategy(sessionStoreStrategyType, configuration)) {
    const renewObservable = new observable/* Observable */.y$();
    const expireObservable = new observable/* Observable */.y$();
    const sessionStateUpdateObservable = new observable/* Observable */.y$();
    const watchSessionTimeoutId = (0,timer/* setInterval */.Zi)(watchSession, STORAGE_POLL_DELAY);
    let sessionCache;
    startSession();
    const { throttled: throttledExpandOrRenewSession, cancel: cancelExpandOrRenewSession } = (0,functionUtils/* throttle */.P)(() => {
        processSessionStoreOperations({
            process: (sessionState) => {
                if ((0,session_sessionState/* isSessionInNotStartedState */.Tm)(sessionState)) {
                    return;
                }
                const synchronizedSession = synchronizeSession(sessionState);
                expandOrRenewSessionState(synchronizedSession);
                return synchronizedSession;
            },
            after: (sessionState) => {
                if ((0,session_sessionState/* isSessionStarted */.Qw)(sessionState) && !hasSessionInCache()) {
                    renewSessionInCache(sessionState);
                }
                sessionCache = sessionState;
            },
        }, sessionStoreStrategy);
    }, STORAGE_POLL_DELAY);
    function expandSession() {
        processSessionStoreOperations({
            process: (sessionState) => (hasSessionInCache() ? synchronizeSession(sessionState) : undefined),
        }, sessionStoreStrategy);
    }
    /**
     * allows two behaviors:
     * - if the session is active, synchronize the session cache without updating the session store
     * - if the session is not active, clear the session store and expire the session cache
     */
    function watchSession() {
        const sessionState = sessionStoreStrategy.retrieveSession();
        if ((0,session_sessionState/* isSessionInExpiredState */.Ey)(sessionState)) {
            processSessionStoreOperations({
                process: (sessionState) => (0,session_sessionState/* isSessionInExpiredState */.Ey)(sessionState) ? (0,session_sessionState/* getExpiredSessionState */.NK)(sessionState, configuration) : undefined,
                after: synchronizeSession,
            }, sessionStoreStrategy);
        }
        else {
            synchronizeSession(sessionState);
        }
    }
    function synchronizeSession(sessionState) {
        if ((0,session_sessionState/* isSessionInExpiredState */.Ey)(sessionState)) {
            sessionState = (0,session_sessionState/* getExpiredSessionState */.NK)(sessionState, configuration);
        }
        if (hasSessionInCache()) {
            if (isSessionInCacheOutdated(sessionState)) {
                expireSessionInCache();
            }
            else {
                sessionStateUpdateObservable.notify({ previousState: sessionCache, newState: sessionState });
                sessionCache = sessionState;
            }
        }
        return sessionState;
    }
    function startSession() {
        processSessionStoreOperations({
            process: (sessionState) => {
                if ((0,session_sessionState/* isSessionInNotStartedState */.Tm)(sessionState)) {
                    sessionState.anonymousId = (0,stringUtils/* generateUUID */.DO)();
                    return (0,session_sessionState/* getExpiredSessionState */.NK)(sessionState, configuration);
                }
            },
            after: (sessionState) => {
                sessionCache = sessionState;
            },
        }, sessionStoreStrategy);
    }
    function expandOrRenewSessionState(sessionState) {
        if ((0,session_sessionState/* isSessionInNotStartedState */.Tm)(sessionState)) {
            return false;
        }
        const trackingType = computeTrackingType(sessionState[productKey]);
        sessionState[productKey] = trackingType;
        delete sessionState.isExpired;
        if (trackingType !== sessionConstants/* SESSION_NOT_TRACKED */.m8 && !sessionState.id) {
            sessionState.id = (0,stringUtils/* generateUUID */.DO)();
            sessionState.created = String((0,timeUtils/* dateNow */.m6)());
        }
    }
    function hasSessionInCache() {
        return (sessionCache === null || sessionCache === void 0 ? void 0 : sessionCache[productKey]) !== undefined;
    }
    function isSessionInCacheOutdated(sessionState) {
        return sessionCache.id !== sessionState.id || sessionCache[productKey] !== sessionState[productKey];
    }
    function expireSessionInCache() {
        sessionCache = (0,session_sessionState/* getExpiredSessionState */.NK)(sessionCache, configuration);
        expireObservable.notify();
    }
    function renewSessionInCache(sessionState) {
        sessionCache = sessionState;
        renewObservable.notify();
    }
    function updateSessionState(partialSessionState) {
        processSessionStoreOperations({
            process: (sessionState) => ({ ...sessionState, ...partialSessionState }),
            after: synchronizeSession,
        }, sessionStoreStrategy);
    }
    return {
        expandOrRenewSession: throttledExpandOrRenewSession,
        expandSession,
        getSession: () => sessionCache,
        renewObservable,
        expireObservable,
        sessionStateUpdateObservable,
        restartSession: startSession,
        expire: (hasConsent) => {
            cancelExpandOrRenewSession();
            if (hasConsent === false && sessionCache) {
                delete sessionCache.anonymousId;
            }
            sessionStoreStrategy.expireSession(sessionCache);
            synchronizeSession((0,session_sessionState/* getExpiredSessionState */.NK)(sessionCache, configuration));
        },
        stop: () => {
            (0,timer/* clearInterval */.cv)(watchSessionTimeoutId);
        },
        updateSessionState,
    };
}
//# sourceMappingURL=sessionStore.js.map

/***/ }),

/***/ 49430:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h$": function() { return /* binding */ initCookieStrategy; },
  "JP": function() { return /* binding */ retrieveSessionCookie; },
  "XR": function() { return /* binding */ selectCookieStrategy; }
});

// UNUSED EXPORTS: buildCookieOptions

// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/objectUtils.js
var objectUtils = __webpack_require__(94162);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/browserDetection.js
var browserDetection = __webpack_require__(12172);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/browser/cookie.js
var cookie = __webpack_require__(49647);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/storeStrategies/sessionStoreStrategy.js
var sessionStoreStrategy = __webpack_require__(4942);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/sessionState.js + 1 modules
var session_sessionState = __webpack_require__(66923);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/oldCookiesMigration.js



const OLD_SESSION_COOKIE_NAME = '_dd';
const OLD_RUM_COOKIE_NAME = '_dd_r';
const OLD_LOGS_COOKIE_NAME = '_dd_l';
// duplicate values to avoid dependency issues
const RUM_SESSION_KEY = 'rum';
const LOGS_SESSION_KEY = 'logs';
/**
 * This migration should remain in the codebase as long as older versions are available/live
 * to allow older sdk versions to be upgraded to newer versions without compatibility issues.
 */
function tryOldCookiesMigration(cookieStoreStrategy) {
    const sessionString = (0,cookie/* getInitCookie */.OC)(sessionStoreStrategy/* SESSION_STORE_KEY */.H);
    if (!sessionString) {
        const oldSessionId = (0,cookie/* getInitCookie */.OC)(OLD_SESSION_COOKIE_NAME);
        const oldRumType = (0,cookie/* getInitCookie */.OC)(OLD_RUM_COOKIE_NAME);
        const oldLogsType = (0,cookie/* getInitCookie */.OC)(OLD_LOGS_COOKIE_NAME);
        const session = {};
        if (oldSessionId) {
            session.id = oldSessionId;
        }
        if (oldLogsType && /^[01]$/.test(oldLogsType)) {
            session[LOGS_SESSION_KEY] = oldLogsType;
        }
        if (oldRumType && /^[012]$/.test(oldRumType)) {
            session[RUM_SESSION_KEY] = oldRumType;
        }
        if ((0,session_sessionState/* isSessionStarted */.Qw)(session)) {
            (0,session_sessionState/* expandSessionState */.Il)(session);
            cookieStoreStrategy.persistSession(session);
        }
    }
}
//# sourceMappingURL=oldCookiesMigration.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/sessionConstants.js
var sessionConstants = __webpack_require__(78981);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/storeStrategies/sessionInCookie.js







const SESSION_COOKIE_VERSION = 0;
function selectCookieStrategy(initConfiguration) {
    const cookieOptions = buildCookieOptions(initConfiguration);
    return cookieOptions && (0,cookie/* areCookiesAuthorized */.oX)(cookieOptions)
        ? { type: sessionConstants/* SessionPersistence.COOKIE */._q.COOKIE, cookieOptions }
        : undefined;
}
function initCookieStrategy(configuration, cookieOptions) {
    const cookieStore = {
        /**
         * Lock strategy allows mitigating issues due to concurrent access to cookie.
         * This issue concerns only chromium browsers and enabling this on firefox increases cookie write failures.
         */
        isLockEnabled: (0,browserDetection/* isChromium */.mJ)(),
        persistSession: (sessionState) => storeSessionCookie(cookieOptions, configuration, sessionState, sessionConstants/* SESSION_EXPIRATION_DELAY */.sr),
        retrieveSession: () => retrieveSessionCookie(cookieOptions, configuration),
        expireSession: (sessionState) => storeSessionCookie(cookieOptions, configuration, (0,session_sessionState/* getExpiredSessionState */.NK)(sessionState, configuration), sessionConstants/* SESSION_TIME_OUT_DELAY */.TN),
    };
    tryOldCookiesMigration(cookieStore);
    return cookieStore;
}
function storeSessionCookie(options, configuration, sessionState, defaultTimeout) {
    let sessionStateString = (0,session_sessionState/* toSessionString */.u_)(sessionState);
    if (configuration.betaEncodeCookieOptions) {
        sessionStateString = (0,session_sessionState/* toSessionString */.u_)({
            ...sessionState,
            // deleting a cookie is writing a new cookie with an empty value
            // we don't want to store the cookie options in this case otherwise the cookie will not be deleted
            ...(!(0,objectUtils/* isEmptyObject */.Qr)(sessionState) ? { c: encodeCookieOptions(options) } : {}),
        });
    }
    (0,cookie/* setCookie */.d8)(sessionStoreStrategy/* SESSION_STORE_KEY */.H, sessionStateString, configuration.trackAnonymousUser ? sessionConstants/* SESSION_COOKIE_EXPIRATION_DELAY */.uY : defaultTimeout, options);
}
/**
 * Retrieve the session state from the cookie that was set with the same cookie options
 * If there is no match, return the first cookie, because that's how `getCookie()` works
 */
function retrieveSessionCookie(cookieOptions, configuration) {
    if (configuration.betaEncodeCookieOptions) {
        return retrieveSessionCookieFromEncodedCookie(cookieOptions);
    }
    const sessionString = (0,cookie/* getCookie */.ej)(sessionStoreStrategy/* SESSION_STORE_KEY */.H);
    const sessionState = (0,session_sessionState/* toSessionState */.q1)(sessionString);
    return sessionState;
}
function buildCookieOptions(initConfiguration) {
    const cookieOptions = {};
    cookieOptions.secure =
        !!initConfiguration.useSecureSessionCookie || !!initConfiguration.usePartitionedCrossSiteSessionCookie;
    cookieOptions.crossSite = !!initConfiguration.usePartitionedCrossSiteSessionCookie;
    cookieOptions.partitioned = !!initConfiguration.usePartitionedCrossSiteSessionCookie;
    if (initConfiguration.trackSessionAcrossSubdomains) {
        const currentSite = (0,cookie/* getCurrentSite */.WQ)();
        if (!currentSite) {
            return;
        }
        cookieOptions.domain = currentSite;
    }
    return cookieOptions;
}
function encodeCookieOptions(cookieOptions) {
    const domainCount = cookieOptions.domain ? cookieOptions.domain.split('.').length - 1 : 0;
    /* eslint-disable no-bitwise */
    let byte = 0;
    byte |= SESSION_COOKIE_VERSION << 5; // Store version in upper 3 bits
    byte |= domainCount << 1; // Store domain count in next 4 bits
    byte |= cookieOptions.crossSite ? 1 : 0; // Store useCrossSiteScripting in next bit
    /* eslint-enable no-bitwise */
    return byte.toString(16); // Convert to hex string
}
/**
 * Retrieve the session state from the cookie that was set with the same cookie options.
 * If there is no match, fallback to the first cookie, (because that's how `getCookie()` works)
 * and this allows to keep the current session id when we release this feature.
 */
function retrieveSessionCookieFromEncodedCookie(cookieOptions) {
    const cookies = (0,cookie/* getCookies */.$1)(sessionStoreStrategy/* SESSION_STORE_KEY */.H);
    const opts = encodeCookieOptions(cookieOptions);
    let sessionState;
    // reverse the cookies so that if there is no match, the cookie returned is the first one
    for (const cookie of cookies.reverse()) {
        sessionState = (0,session_sessionState/* toSessionState */.q1)(cookie);
        if (sessionState.c === opts) {
            break;
        }
    }
    // remove the cookie options from the session state as this is not part of the session state
    sessionState === null || sessionState === void 0 ? true : delete sessionState.c;
    return sessionState !== null && sessionState !== void 0 ? sessionState : {};
}
//# sourceMappingURL=sessionInCookie.js.map

/***/ }),

/***/ 65485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m_": function() { return /* binding */ initLocalStorageStrategy; },
/* harmony export */   "q$": function() { return /* binding */ retrieveSessionFromLocalStorage; },
/* harmony export */   "un": function() { return /* binding */ selectLocalStorageStrategy; }
/* harmony export */ });
/* harmony import */ var _tools_utils_stringUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88129);
/* harmony import */ var _sessionConstants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78981);
/* harmony import */ var _sessionState__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66923);
/* harmony import */ var _sessionStoreStrategy__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4942);




const LOCAL_STORAGE_TEST_KEY = '_dd_test_';
function selectLocalStorageStrategy() {
    try {
        const id = (0,_tools_utils_stringUtils__WEBPACK_IMPORTED_MODULE_0__/* .generateUUID */ .DO)();
        const testKey = `${LOCAL_STORAGE_TEST_KEY}${id}`;
        localStorage.setItem(testKey, id);
        const retrievedId = localStorage.getItem(testKey);
        localStorage.removeItem(testKey);
        return id === retrievedId ? { type: _sessionConstants__WEBPACK_IMPORTED_MODULE_1__/* .SessionPersistence.LOCAL_STORAGE */ ._q.LOCAL_STORAGE } : undefined;
    }
    catch (_a) {
        return undefined;
    }
}
function initLocalStorageStrategy(configuration) {
    return {
        isLockEnabled: false,
        persistSession: persistInLocalStorage,
        retrieveSession: retrieveSessionFromLocalStorage,
        expireSession: (sessionState) => expireSessionFromLocalStorage(sessionState, configuration),
    };
}
function persistInLocalStorage(sessionState) {
    localStorage.setItem(_sessionStoreStrategy__WEBPACK_IMPORTED_MODULE_2__/* .SESSION_STORE_KEY */ .H, (0,_sessionState__WEBPACK_IMPORTED_MODULE_3__/* .toSessionString */ .u_)(sessionState));
}
function retrieveSessionFromLocalStorage() {
    const sessionString = localStorage.getItem(_sessionStoreStrategy__WEBPACK_IMPORTED_MODULE_2__/* .SESSION_STORE_KEY */ .H);
    return (0,_sessionState__WEBPACK_IMPORTED_MODULE_3__/* .toSessionState */ .q1)(sessionString);
}
function expireSessionFromLocalStorage(previousSessionState, configuration) {
    persistInLocalStorage((0,_sessionState__WEBPACK_IMPORTED_MODULE_3__/* .getExpiredSessionState */ .NK)(previousSessionState, configuration));
}
//# sourceMappingURL=sessionInLocalStorage.js.map

/***/ }),

/***/ 4942:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ SESSION_STORE_KEY; }
/* harmony export */ });
const SESSION_STORE_KEY = '_dd_s';
//# sourceMappingURL=sessionStoreStrategy.js.map

/***/ }),

/***/ 19276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MS": function() { return /* binding */ buildTags; }
/* harmony export */ });
/* unused harmony exports TAG_SIZE_LIMIT, buildTag, sanitizeTag, supportUnicodePropertyEscapes */
/* harmony import */ var _tools_display__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13842);

const TAG_SIZE_LIMIT = 200;
function buildTags(configuration) {
    const { env, service, version, datacenter, sdkVersion, variant } = configuration;
    const tags = [buildTag('sdk_version', sdkVersion !== null && sdkVersion !== void 0 ? sdkVersion : "6.25.0")];
    if (env) {
        tags.push(buildTag('env', env));
    }
    if (service) {
        tags.push(buildTag('service', service));
    }
    if (version) {
        tags.push(buildTag('version', version));
    }
    if (datacenter) {
        tags.push(buildTag('datacenter', datacenter));
    }
    if (variant) {
        tags.push(buildTag('variant', variant));
    }
    return tags;
}
function buildTag(key, rawValue) {
    // See https://docs.datadoghq.com/getting_started/tagging/#defining-tags for tags syntax. Note
    // that the backend may not follow the exact same rules, so we only want to display an informal
    // warning.
    const tag = rawValue ? `${key}:${rawValue}` : key;
    if (tag.length > TAG_SIZE_LIMIT || hasForbiddenCharacters(tag)) {
        _tools_display__WEBPACK_IMPORTED_MODULE_0__/* .display.warn */ .jf.warn(`Tag ${tag} doesn't meet tag requirements and will be sanitized. ${_tools_display__WEBPACK_IMPORTED_MODULE_0__/* .MORE_DETAILS */ .IA} ${_tools_display__WEBPACK_IMPORTED_MODULE_0__/* .DOCS_ORIGIN */ .aA}/getting_started/tagging/#defining-tags`);
    }
    // Let the backend do most of the sanitization, but still make sure multiple tags can't be crafted
    // by forging a value containing commas.
    return sanitizeTag(tag);
}
function sanitizeTag(tag) {
    return tag.replace(/,/g, '_');
}
function hasForbiddenCharacters(rawValue) {
    // Unicode property escapes is not supported in all browsers, so we use a try/catch.
    // Todo: Remove the try/catch when dropping support for Chrome 63 and Firefox 67
    // see: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Regular_expressions/Unicode_character_class_escape#browser_compatibility
    if (!supportUnicodePropertyEscapes()) {
        return false;
    }
    // We use the Unicode property escapes to match any character that is a letter including other languages like Chinese, Japanese, etc.
    // p{Ll} matches a lowercase letter.
    // p{Lo} matches a letter that is neither uppercase nor lowercase (ex: Japanese characters).
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Regular_expressions/Unicode_character_class_escape#unicode_property_escapes_vs._character_classes
    return new RegExp('[^\\p{Ll}\\p{Lo}0-9_:./-]', 'u').test(rawValue);
}
function supportUnicodePropertyEscapes() {
    try {
        new RegExp('[\\p{Ll}]', 'u');
        return true;
    }
    catch (_a) {
        return false;
    }
}
//# sourceMappingURL=tags.js.map

/***/ }),

/***/ 18797:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Uo": function() { return /* binding */ addTelemetryConfiguration; },
  "eJ": function() { return /* binding */ addTelemetryDebug; },
  "Sz": function() { return /* binding */ addTelemetryError; },
  "qZ": function() { return /* binding */ addTelemetryMetrics; },
  "eG": function() { return /* binding */ addTelemetryUsage; },
  "VL": function() { return /* binding */ startTelemetry; }
});

// UNUSED EXPORTS: formatError, getTelemetryObservable, resetTelemetry, scrubCustomerFrames, startTelemetryCollection

// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/display.js
var display = __webpack_require__(13842);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/error/error.js
var error = __webpack_require__(45242);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/stackTrace/handlingStack.js
var handlingStack = __webpack_require__(24507);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/experimentalFeatures.js
var experimentalFeatures = __webpack_require__(57549);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/tags.js
var tags = __webpack_require__(19276);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/intakeSites.js
var intakeSites = __webpack_require__(93909);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/observable.js + 1 modules
var tools_observable = __webpack_require__(75721);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/timeUtils.js
var timeUtils = __webpack_require__(25026);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/monitor.js
var monitor = __webpack_require__(64933);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/sendToExtension.js
var sendToExtension = __webpack_require__(38971);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/numberUtils.js
var numberUtils = __webpack_require__(73603);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/serialisation/jsonStringify.js
var jsonStringify = __webpack_require__(19012);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/mergeInto.js
var mergeInto = __webpack_require__(92904);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/stackTrace/computeStackTrace.js
var computeStackTrace = __webpack_require__(22685);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/connectivity/connectivity.js
var connectivity = __webpack_require__(68826);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/transport/eventBridge.js
var eventBridge = __webpack_require__(76876);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/transport/batch.js
var batch = __webpack_require__(53789);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/transport/httpRequest.js + 1 modules
var httpRequest = __webpack_require__(30481);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/transport/flushController.js
var flushController = __webpack_require__(5419);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/abstractHooks.js
var abstractHooks = __webpack_require__(89643);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/globalObject.js
var globalObject = __webpack_require__(51145);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/telemetry/rawTelemetryEvent.types.js
const TelemetryType = {
    LOG: 'log',
    CONFIGURATION: 'configuration',
    USAGE: 'usage',
};
//# sourceMappingURL=rawTelemetryEvent.types.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/telemetry/telemetry.js



















const ALLOWED_FRAME_URLS = [
    'https://www.datadoghq-browser-agent.com',
    'https://www.datad0g-browser-agent.com',
    'https://d3uc069fcn7uxw.cloudfront.net',
    'https://d20xtzwzcl0ceb.cloudfront.net',
    'http://localhost',
    '<anonymous>',
];
const METRIC_SAMPLE_RATE = 1;
const TELEMETRY_EXCLUDED_SITES = [intakeSites/* INTAKE_SITE_US1_FED */.y7];
const MAX_TELEMETRY_EVENTS_PER_PAGE = 15;
let telemetryObservable;
function getTelemetryObservable() {
    if (!telemetryObservable) {
        telemetryObservable = new tools_observable/* BufferedObservable */.fk(100);
    }
    return telemetryObservable;
}
function startTelemetry(telemetryService, configuration, hooks, reportError, pageMayExitObservable, createEncoder) {
    const observable = new tools_observable/* Observable */.y$();
    const { stop } = startTelemetryTransport(configuration, reportError, pageMayExitObservable, createEncoder, observable);
    const { enabled, metricsEnabled } = startTelemetryCollection(telemetryService, configuration, hooks, observable);
    return {
        stop,
        enabled,
        metricsEnabled,
    };
}
function startTelemetryCollection(telemetryService, configuration, hooks, observable, metricSampleRate = METRIC_SAMPLE_RATE, maxTelemetryEventsPerPage = MAX_TELEMETRY_EVENTS_PER_PAGE) {
    const alreadySentEventsByKind = {};
    const telemetryEnabled = !TELEMETRY_EXCLUDED_SITES.includes(configuration.site) && (0,numberUtils/* performDraw */.y7)(configuration.telemetrySampleRate);
    const telemetryEnabledPerType = {
        [TelemetryType.LOG]: telemetryEnabled,
        [TelemetryType.CONFIGURATION]: telemetryEnabled && (0,numberUtils/* performDraw */.y7)(configuration.telemetryConfigurationSampleRate),
        [TelemetryType.USAGE]: telemetryEnabled && (0,numberUtils/* performDraw */.y7)(configuration.telemetryUsageSampleRate),
        // not an actual "type" but using a single draw for all metrics
        metric: telemetryEnabled && (0,numberUtils/* performDraw */.y7)(metricSampleRate),
    };
    const runtimeEnvInfo = getRuntimeEnvInfo();
    const telemetryObservable = getTelemetryObservable();
    telemetryObservable.subscribe(({ rawEvent, metricName }) => {
        if ((metricName && !telemetryEnabledPerType['metric']) || !telemetryEnabledPerType[rawEvent.type]) {
            return;
        }
        const kind = metricName || rawEvent.status || rawEvent.type;
        let alreadySentEvents = alreadySentEventsByKind[kind];
        if (!alreadySentEvents) {
            alreadySentEvents = alreadySentEventsByKind[kind] = new Set();
        }
        if (alreadySentEvents.size >= maxTelemetryEventsPerPage) {
            return;
        }
        const stringifiedEvent = (0,jsonStringify/* jsonStringify */.l)(rawEvent);
        if (alreadySentEvents.has(stringifiedEvent)) {
            return;
        }
        const defaultTelemetryEventAttributes = hooks.triggerHook(1 /* HookNames.AssembleTelemetry */, {
            startTime: (0,timeUtils/* clocksNow */.$I)().relative,
        });
        if (defaultTelemetryEventAttributes === abstractHooks/* DISCARDED */.C_) {
            return;
        }
        const event = toTelemetryEvent(defaultTelemetryEventAttributes, telemetryService, rawEvent, runtimeEnvInfo);
        observable.notify(event);
        (0,sendToExtension/* sendToExtension */.j)('telemetry', event);
        alreadySentEvents.add(stringifiedEvent);
    });
    telemetryObservable.unbuffer();
    (0,monitor/* startMonitorErrorCollection */.P_)(addTelemetryError);
    return {
        enabled: telemetryEnabled,
        metricsEnabled: telemetryEnabledPerType['metric'],
    };
    function toTelemetryEvent(defaultTelemetryEventAttributes, telemetryService, rawEvent, runtimeEnvInfo) {
        const clockNow = (0,timeUtils/* clocksNow */.$I)();
        const event = {
            type: 'telemetry',
            date: clockNow.timeStamp,
            service: telemetryService,
            version: "6.25.0",
            source: 'browser',
            _dd: {
                format_version: 2,
            },
            telemetry: (0,mergeInto/* combine */.$e)(rawEvent, {
                runtime_env: runtimeEnvInfo,
                connectivity: (0,connectivity/* getConnectivity */.T)(),
                sdk_setup: "npm",
            }),
            ddtags: (0,tags/* buildTags */.MS)(configuration).join(','),
            experimental_features: Array.from((0,experimentalFeatures/* getExperimentalFeatures */.u0)()),
        };
        return (0,mergeInto/* combine */.$e)(event, defaultTelemetryEventAttributes);
    }
}
function startTelemetryTransport(configuration, reportError, pageMayExitObservable, createEncoder, telemetryObservable) {
    const cleanupTasks = [];
    if ((0,eventBridge/* canUseEventBridge */.xT)()) {
        const bridge = (0,eventBridge/* getEventBridge */.Ad)();
        const telemetrySubscription = telemetryObservable.subscribe((event) => bridge.send('internal_telemetry', event));
        cleanupTasks.push(telemetrySubscription.unsubscribe);
    }
    else {
        const endpoints = [configuration.rumEndpointBuilder];
        if (configuration.replica && isTelemetryReplicationAllowed(configuration)) {
            endpoints.push(configuration.replica.rumEndpointBuilder);
        }
        const telemetryBatch = (0,batch/* createBatch */.n)({
            encoder: createEncoder(4 /* DeflateEncoderStreamId.TELEMETRY */),
            request: (0,httpRequest/* createHttpRequest */.UF)(endpoints, reportError),
            flushController: (0,flushController/* createFlushController */.rK)({
                pageMayExitObservable,
                // We don't use an actual session expire observable here, to make telemetry collection
                // independent of the session. This allows to start and send telemetry events earlier.
                sessionExpireObservable: new tools_observable/* Observable */.y$(),
            }),
        });
        cleanupTasks.push(telemetryBatch.stop);
        const telemetrySubscription = telemetryObservable.subscribe(telemetryBatch.add);
        cleanupTasks.push(telemetrySubscription.unsubscribe);
    }
    return {
        stop: () => cleanupTasks.forEach((task) => task()),
    };
}
function getRuntimeEnvInfo() {
    var _a;
    return {
        is_local_file: ((_a = globalObject/* globalObject.location */.Zf.location) === null || _a === void 0 ? void 0 : _a.protocol) === 'file:',
        is_worker: globalObject/* isWorkerEnvironment */.jX,
    };
}
function resetTelemetry() {
    telemetryObservable = undefined;
}
/**
 * Avoid mixing telemetry events from different data centers
 * but keep replicating staging events for reliability
 */
function isTelemetryReplicationAllowed(configuration) {
    return configuration.site === intakeSites/* INTAKE_SITE_STAGING */.DZ;
}
function addTelemetryDebug(message, context) {
    (0,monitor/* displayIfDebugEnabled */.DV)(display/* ConsoleApiName.debug */.vA.debug, message, context);
    getTelemetryObservable().notify({
        rawEvent: {
            type: TelemetryType.LOG,
            message,
            status: "debug" /* StatusType.debug */,
            ...context,
        },
    });
}
function addTelemetryError(e, context) {
    getTelemetryObservable().notify({
        rawEvent: {
            type: TelemetryType.LOG,
            status: "error" /* StatusType.error */,
            ...formatError(e),
            ...context,
        },
    });
}
function addTelemetryConfiguration(configuration) {
    getTelemetryObservable().notify({
        rawEvent: {
            type: TelemetryType.CONFIGURATION,
            configuration,
        },
    });
}
function addTelemetryMetrics(metricName, context) {
    getTelemetryObservable().notify({
        rawEvent: {
            type: TelemetryType.LOG,
            message: metricName,
            status: "debug" /* StatusType.debug */,
            ...context,
        },
        metricName,
    });
}
function addTelemetryUsage(usage) {
    getTelemetryObservable().notify({
        rawEvent: {
            type: TelemetryType.USAGE,
            usage,
        },
    });
}
function formatError(e) {
    if ((0,error/* isError */.VZ)(e)) {
        const stackTrace = (0,computeStackTrace/* computeStackTrace */._)(e);
        return {
            error: {
                kind: stackTrace.name,
                stack: (0,handlingStack/* toStackTraceString */.P3)(scrubCustomerFrames(stackTrace)),
            },
            message: stackTrace.message,
        };
    }
    return {
        error: {
            stack: error/* NO_ERROR_STACK_PRESENT_MESSAGE */.K$,
        },
        message: `${"Uncaught" /* NonErrorPrefix.UNCAUGHT */} ${(0,jsonStringify/* jsonStringify */.l)(e)}`,
    };
}
function scrubCustomerFrames(stackTrace) {
    stackTrace.stack = stackTrace.stack.filter((frame) => !frame.url || ALLOWED_FRAME_URLS.some((allowedFrameUrl) => frame.url.startsWith(allowedFrameUrl)));
    return stackTrace;
}
//# sourceMappingURL=telemetry.js.map

/***/ }),

/***/ 92988:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ createTrackingConsentState; },
/* harmony export */   "h": function() { return /* binding */ TrackingConsent; }
/* harmony export */ });
/* harmony import */ var _tools_observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75721);

const TrackingConsent = {
    GRANTED: 'granted',
    NOT_GRANTED: 'not-granted',
};
function createTrackingConsentState(currentConsent) {
    const observable = new _tools_observable__WEBPACK_IMPORTED_MODULE_0__/* .Observable */ .y$();
    return {
        tryToInit(trackingConsent) {
            if (!currentConsent) {
                currentConsent = trackingConsent;
            }
        },
        update(trackingConsent) {
            currentConsent = trackingConsent;
            observable.notify();
        },
        isGranted() {
            return currentConsent === TrackingConsent.GRANTED;
        },
        observable,
    };
}
//# sourceMappingURL=trackingConsent.js.map

/***/ }),

/***/ 89643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C_": function() { return /* binding */ DISCARDED; },
/* harmony export */   "kb": function() { return /* binding */ SKIPPED; },
/* harmony export */   "uR": function() { return /* binding */ abstractHooks; }
/* harmony export */ });
/* harmony import */ var _mergeInto__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92904);

// Discards the event from being sent
const DISCARDED = 'DISCARDED';
// Skips from the assembly of the event
const SKIPPED = 'SKIPPED';
function abstractHooks() {
    const callbacks = {};
    return {
        register(hookName, callback) {
            if (!callbacks[hookName]) {
                callbacks[hookName] = [];
            }
            callbacks[hookName].push(callback);
            return {
                unregister: () => {
                    callbacks[hookName] = callbacks[hookName].filter((cb) => cb !== callback);
                },
            };
        },
        triggerHook(hookName, param) {
            const hookCallbacks = callbacks[hookName] || [];
            const results = [];
            for (const callback of hookCallbacks) {
                const result = callback(param);
                if (result === DISCARDED) {
                    return DISCARDED;
                }
                if (result === SKIPPED) {
                    continue;
                }
                results.push(result);
            }
            return (0,_mergeInto__WEBPACK_IMPORTED_MODULE_0__/* .combine */ .$e)(...results);
        },
    };
}
//# sourceMappingURL=abstractHooks.js.map

/***/ }),

/***/ 40812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ catchUserErrors; }
/* harmony export */ });
/* harmony import */ var _display__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13842);

function catchUserErrors(fn, errorMsg) {
    return (...args) => {
        try {
            return fn(...args);
        }
        catch (err) {
            _display__WEBPACK_IMPORTED_MODULE_0__/* .display.error */ .jf.error(errorMsg, err);
        }
    };
}
//# sourceMappingURL=catchUserErrors.js.map

/***/ }),

/***/ 13842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IA": function() { return /* binding */ MORE_DETAILS; },
/* harmony export */   "Qo": function() { return /* binding */ DOCS_TROUBLESHOOTING; },
/* harmony export */   "aA": function() { return /* binding */ DOCS_ORIGIN; },
/* harmony export */   "jG": function() { return /* binding */ globalConsole; },
/* harmony export */   "jf": function() { return /* binding */ display; },
/* harmony export */   "vA": function() { return /* binding */ ConsoleApiName; }
/* harmony export */ });
/* unused harmony export originalConsoleMethods */
/* eslint-disable local-rules/disallow-side-effects */
/**
 * Keep references on console methods to avoid triggering patched behaviors
 *
 * NB: in some setup, console could already be patched by another SDK.
 * In this case, some display messages can be sent by the other SDK
 * but we should be safe from infinite loop nonetheless.
 */
const ConsoleApiName = {
    log: 'log',
    debug: 'debug',
    info: 'info',
    warn: 'warn',
    error: 'error',
};
/**
 * When building JS bundles, some users might use a plugin[1] or configuration[2] to remove
 * "console.*" references. This causes some issue as we expect `console.*` to be defined.
 * As a workaround, let's use a variable alias, so those expressions won't be taken into account by
 * simple static analysis.
 *
 * [1]: https://babeljs.io/docs/babel-plugin-transform-remove-console/
 * [2]: https://github.com/terser/terser#compress-options (look for drop_console)
 */
const globalConsole = console;
const originalConsoleMethods = {};
Object.keys(ConsoleApiName).forEach((name) => {
    originalConsoleMethods[name] = globalConsole[name];
});
const PREFIX = 'Datadog Browser SDK:';
const display = {
    debug: originalConsoleMethods.debug.bind(globalConsole, PREFIX),
    log: originalConsoleMethods.log.bind(globalConsole, PREFIX),
    info: originalConsoleMethods.info.bind(globalConsole, PREFIX),
    warn: originalConsoleMethods.warn.bind(globalConsole, PREFIX),
    error: originalConsoleMethods.error.bind(globalConsole, PREFIX),
};
const DOCS_ORIGIN = 'https://docs.datadoghq.com';
const DOCS_TROUBLESHOOTING = `${DOCS_ORIGIN}/real_user_monitoring/browser/troubleshooting`;
const MORE_DETAILS = 'More details:';
//# sourceMappingURL=display.js.map

/***/ }),

/***/ 57549:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W_": function() { return /* binding */ isExperimentalFeatureEnabled; },
/* harmony export */   "fG": function() { return /* binding */ initFeatureFlags; },
/* harmony export */   "u0": function() { return /* binding */ getExperimentalFeatures; },
/* harmony export */   "uh": function() { return /* binding */ ExperimentalFeature; }
/* harmony export */ });
/* unused harmony exports addExperimentalFeatures, resetExperimentalFeatures */
/* harmony import */ var _utils_objectUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94162);
/**
 * LIMITATION:
 * For NPM setup, this feature flag singleton is shared between RUM and Logs product.
 * This means that an experimental flag set on the RUM product will be set on the Logs product.
 * So keep in mind that in certain configurations, your experimental feature flag may affect other products.
 *
 * FORMAT:
 * All feature flags should be snake_cased
 */
// We want to use a real enum (i.e. not a const enum) here, to be able to check whether an arbitrary
// string is an expected feature flag

// eslint-disable-next-line no-restricted-syntax
var ExperimentalFeature;
(function (ExperimentalFeature) {
    ExperimentalFeature["TRACK_INTAKE_REQUESTS"] = "track_intake_requests";
    ExperimentalFeature["USE_TREE_WALKER_FOR_ACTION_NAME"] = "use_tree_walker_for_action_name";
    ExperimentalFeature["FEATURE_OPERATION_VITAL"] = "feature_operation_vital";
    ExperimentalFeature["SHORT_SESSION_INVESTIGATION"] = "short_session_investigation";
    ExperimentalFeature["AVOID_FETCH_KEEPALIVE"] = "avoid_fetch_keepalive";
})(ExperimentalFeature || (ExperimentalFeature = {}));
const enabledExperimentalFeatures = new Set();
function initFeatureFlags(enableExperimentalFeatures) {
    if (Array.isArray(enableExperimentalFeatures)) {
        addExperimentalFeatures(enableExperimentalFeatures.filter((flag) => (0,_utils_objectUtils__WEBPACK_IMPORTED_MODULE_0__/* .objectHasValue */ .E5)(ExperimentalFeature, flag)));
    }
}
function addExperimentalFeatures(enabledFeatures) {
    enabledFeatures.forEach((flag) => {
        enabledExperimentalFeatures.add(flag);
    });
}
function isExperimentalFeatureEnabled(featureName) {
    return enabledExperimentalFeatures.has(featureName);
}
function resetExperimentalFeatures() {
    enabledExperimentalFeatures.clear();
}
function getExperimentalFeatures() {
    return enabledExperimentalFeatures;
}
//# sourceMappingURL=experimentalFeatures.js.map

/***/ }),

/***/ 59693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ getZoneJsOriginalValue; }
/* harmony export */ });
/* harmony import */ var _globalObject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51145);

/**
 * Gets the original value for a DOM API that was potentially patched by Zone.js.
 *
 * Zone.js[1] is a library that patches a bunch of JS and DOM APIs. It usually stores the original
 * value of the patched functions/constructors/methods in a hidden property prefixed by
 * __zone_symbol__.
 *
 * In multiple occasions, we observed that Zone.js is the culprit of important issues leading to
 * browser resource exhaustion (memory leak, high CPU usage). This method is used as a workaround to
 * use the original DOM API instead of the one patched by Zone.js.
 *
 * [1]: https://github.com/angular/angular/tree/main/packages/zone.js
 */
function getZoneJsOriginalValue(target, name) {
    const browserWindow = (0,_globalObject__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .Rf)();
    let original;
    if (browserWindow.Zone && typeof browserWindow.Zone.__symbol__ === 'function') {
        original = target[browserWindow.Zone.__symbol__(name)];
    }
    if (!original) {
        original = target[name];
    }
    return original;
}
//# sourceMappingURL=getZoneJsOriginalValue.js.map

/***/ }),

/***/ 51145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rf": function() { return /* binding */ getGlobalObject; },
/* harmony export */   "Zf": function() { return /* binding */ globalObject; },
/* harmony export */   "jX": function() { return /* binding */ isWorkerEnvironment; }
/* harmony export */ });
/**
 * inspired by https://mathiasbynens.be/notes/globalthis
 */
function getGlobalObject() {
    if (typeof globalThis === 'object') {
        return globalThis;
    }
    Object.defineProperty(Object.prototype, '_dd_temp_', {
        get() {
            return this;
        },
        configurable: true,
    });
    // @ts-ignore _dd_temp is defined using defineProperty
    let globalObject = _dd_temp_;
    // @ts-ignore _dd_temp is defined using defineProperty
    delete Object.prototype._dd_temp_;
    if (typeof globalObject !== 'object') {
        // on safari _dd_temp_ is available on window but not globally
        // fallback on other browser globals check
        if (typeof self === 'object') {
            globalObject = self;
        }
        else if (typeof window === 'object') {
            globalObject = window;
        }
        else {
            globalObject = {};
        }
    }
    return globalObject;
}
/**
 * Cached reference to the global object so it can be imported and re-used without
 * re-evaluating the heavyweight fallback logic in `getGlobalObject()`.
 */
// eslint-disable-next-line local-rules/disallow-side-effects
const globalObject = getGlobalObject();
const isWorkerEnvironment = 'WorkerGlobalScope' in globalObject;
//# sourceMappingURL=globalObject.js.map

/***/ }),

/***/ 55801:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ instrumentMethod; },
/* harmony export */   "X": function() { return /* binding */ instrumentSetter; }
/* harmony export */ });
/* harmony import */ var _timer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65483);
/* harmony import */ var _monitor__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64933);
/* harmony import */ var _utils_functionUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(251);
/* harmony import */ var _stackTrace_handlingStack__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24507);




/**
 * Instruments a method on a object, calling the given callback before the original method is
 * invoked. The callback receives an object with information about the method call.
 *
 * This function makes sure that we are "good citizens" regarding third party instrumentations: when
 * removing the instrumentation, the original method is usually restored, but if a third party
 * instrumentation was set after ours, we keep it in place and just replace our instrumentation with
 * a noop.
 *
 * Note: it is generally better to instrument methods that are "owned" by the object instead of ones
 * that are inherited from the prototype chain. Example:
 * * do:    `instrumentMethod(Array.prototype, 'push', ...)`
 * * don't: `instrumentMethod([], 'push', ...)`
 *
 * This method is also used to set event handler properties (ex: window.onerror = ...), as it has
 * the same requirements as instrumenting a method:
 * * if the event handler is already set by a third party, we need to call it and not just blindly
 * override it.
 * * if the event handler is set by a third party after us, we need to keep it in place when
 * removing ours.
 *
 * @example
 *
 *  instrumentMethod(window, 'fetch', ({ target, parameters, onPostCall }) => {
 *    console.log('Before calling fetch on', target, 'with parameters', parameters)
 *
 *    onPostCall((result) => {
 *      console.log('After fetch calling on', target, 'with parameters', parameters, 'and result', result)
 *    })
 *  })
 */
function instrumentMethod(targetPrototype, method, onPreCall, { computeHandlingStack } = {}) {
    let original = targetPrototype[method];
    if (typeof original !== 'function') {
        if (method in targetPrototype && typeof method === 'string' && method.startsWith('on')) {
            original = _utils_functionUtils__WEBPACK_IMPORTED_MODULE_0__/* .noop */ .Z;
        }
        else {
            return { stop: _utils_functionUtils__WEBPACK_IMPORTED_MODULE_0__/* .noop */ .Z };
        }
    }
    let stopped = false;
    const instrumentation = function () {
        if (stopped) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call
            return original.apply(this, arguments);
        }
        const parameters = Array.from(arguments);
        let postCallCallback;
        (0,_monitor__WEBPACK_IMPORTED_MODULE_1__/* .callMonitored */ .L6)(onPreCall, null, [
            {
                target: this,
                parameters,
                onPostCall: (callback) => {
                    postCallCallback = callback;
                },
                handlingStack: computeHandlingStack ? (0,_stackTrace_handlingStack__WEBPACK_IMPORTED_MODULE_2__/* .createHandlingStack */ .Xp)('instrumented method') : undefined,
            },
        ]);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        const result = original.apply(this, parameters);
        if (postCallCallback) {
            (0,_monitor__WEBPACK_IMPORTED_MODULE_1__/* .callMonitored */ .L6)(postCallCallback, null, [result]);
        }
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return result;
    };
    targetPrototype[method] = instrumentation;
    return {
        stop: () => {
            stopped = true;
            // If the instrumentation has been removed by a third party, keep the last one
            if (targetPrototype[method] === instrumentation) {
                targetPrototype[method] = original;
            }
        },
    };
}
function instrumentSetter(targetPrototype, property, after) {
    const originalDescriptor = Object.getOwnPropertyDescriptor(targetPrototype, property);
    if (!originalDescriptor || !originalDescriptor.set || !originalDescriptor.configurable) {
        return { stop: _utils_functionUtils__WEBPACK_IMPORTED_MODULE_0__/* .noop */ .Z };
    }
    const stoppedInstrumentation = _utils_functionUtils__WEBPACK_IMPORTED_MODULE_0__/* .noop */ .Z;
    let instrumentation = (target, value) => {
        // put hooked setter into event loop to avoid of set latency
        (0,_timer__WEBPACK_IMPORTED_MODULE_3__/* .setTimeout */ .iK)(() => {
            if (instrumentation !== stoppedInstrumentation) {
                after(target, value);
            }
        }, 0);
    };
    const instrumentationWrapper = function (value) {
        originalDescriptor.set.call(this, value);
        instrumentation(this, value);
    };
    Object.defineProperty(targetPrototype, property, {
        set: instrumentationWrapper,
    });
    return {
        stop: () => {
            var _a;
            if (((_a = Object.getOwnPropertyDescriptor(targetPrototype, property)) === null || _a === void 0 ? void 0 : _a.set) === instrumentationWrapper) {
                Object.defineProperty(targetPrototype, property, originalDescriptor);
            }
            instrumentation = stoppedInstrumentation;
        },
    };
}
//# sourceMappingURL=instrumentMethod.js.map

/***/ }),

/***/ 95562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ isMatchOption; },
/* harmony export */   "v": function() { return /* binding */ matchList; }
/* harmony export */ });
/* harmony import */ var _display__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13842);
/* harmony import */ var _utils_typeUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33234);


function isMatchOption(item) {
    const itemType = (0,_utils_typeUtils__WEBPACK_IMPORTED_MODULE_0__/* .getType */ .o)(item);
    return itemType === 'string' || itemType === 'function' || item instanceof RegExp;
}
/**
 * Returns true if value can be matched by at least one of the provided MatchOptions.
 * When comparing strings, setting useStartsWith to true will compare the value with the start of
 * the option, instead of requiring an exact match.
 */
function matchList(list, value, useStartsWith = false) {
    return list.some((item) => {
        try {
            if (typeof item === 'function') {
                return item(value);
            }
            else if (item instanceof RegExp) {
                return item.test(value);
            }
            else if (typeof item === 'string') {
                return useStartsWith ? value.startsWith(item) : item === value;
            }
        }
        catch (e) {
            _display__WEBPACK_IMPORTED_MODULE_1__/* .display.error */ .jf.error(e);
        }
        return false;
    });
}
//# sourceMappingURL=matchOption.js.map

/***/ }),

/***/ 92904:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$e": function() { return /* binding */ combine; },
/* harmony export */   "I8": function() { return /* binding */ deepClone; }
/* harmony export */ });
/* unused harmony export mergeInto */
/* harmony import */ var _utils_typeUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33234);

/**
 * Iterate over source and affect its sub values into destination, recursively.
 * If the source and destination can't be merged, return source.
 */
function mergeInto(destination, source, circularReferenceChecker = createCircularReferenceChecker()) {
    // ignore the source if it is undefined
    if (source === undefined) {
        return destination;
    }
    if (typeof source !== 'object' || source === null) {
        // primitive values - just return source
        return source;
    }
    else if (source instanceof Date) {
        return new Date(source.getTime());
    }
    else if (source instanceof RegExp) {
        const flags = source.flags ||
            // old browsers compatibility
            [
                source.global ? 'g' : '',
                source.ignoreCase ? 'i' : '',
                source.multiline ? 'm' : '',
                source.sticky ? 'y' : '',
                source.unicode ? 'u' : '',
            ].join('');
        return new RegExp(source.source, flags);
    }
    if (circularReferenceChecker.hasAlreadyBeenSeen(source)) {
        // remove circular references
        return undefined;
    }
    else if (Array.isArray(source)) {
        const merged = Array.isArray(destination) ? destination : [];
        for (let i = 0; i < source.length; ++i) {
            merged[i] = mergeInto(merged[i], source[i], circularReferenceChecker);
        }
        return merged;
    }
    const merged = (0,_utils_typeUtils__WEBPACK_IMPORTED_MODULE_0__/* .getType */ .o)(destination) === 'object' ? destination : {};
    for (const key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
            merged[key] = mergeInto(merged[key], source[key], circularReferenceChecker);
        }
    }
    return merged;
}
/**
 * A simplistic implementation of a deep clone algorithm.
 * Caveats:
 * - It doesn't maintain prototype chains - don't use with instances of custom classes.
 * - It doesn't handle Map and Set
 */
function deepClone(value) {
    return mergeInto(undefined, value);
}
function combine(...sources) {
    let destination;
    for (const source of sources) {
        // Ignore any undefined or null sources.
        if (source === undefined || source === null) {
            continue;
        }
        destination = mergeInto(destination, source);
    }
    return destination;
}
function createCircularReferenceChecker() {
    if (typeof WeakSet !== 'undefined') {
        const set = new WeakSet();
        return {
            hasAlreadyBeenSeen(value) {
                const has = set.has(value);
                if (!has) {
                    set.add(value);
                }
                return has;
            },
        };
    }
    const array = [];
    return {
        hasAlreadyBeenSeen(value) {
            const has = array.indexOf(value) >= 0;
            if (!has) {
                array.push(value);
            }
            return has;
        },
    };
}
//# sourceMappingURL=mergeInto.js.map

/***/ }),

/***/ 64933:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$y": function() { return /* binding */ monitorError; },
/* harmony export */   "DV": function() { return /* binding */ displayIfDebugEnabled; },
/* harmony export */   "L6": function() { return /* binding */ callMonitored; },
/* harmony export */   "P_": function() { return /* binding */ startMonitorErrorCollection; },
/* harmony export */   "yD": function() { return /* binding */ setDebugMode; },
/* harmony export */   "zk": function() { return /* binding */ monitor; }
/* harmony export */ });
/* unused harmony exports resetMonitor, monitored */
/* harmony import */ var _display__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13842);

let onMonitorErrorCollected;
let debugMode = false;
function startMonitorErrorCollection(newOnMonitorErrorCollected) {
    onMonitorErrorCollected = newOnMonitorErrorCollected;
}
function setDebugMode(newDebugMode) {
    debugMode = newDebugMode;
}
function resetMonitor() {
    onMonitorErrorCollected = undefined;
    debugMode = false;
}
function monitored(_, __, descriptor) {
    const originalMethod = descriptor.value;
    descriptor.value = function (...args) {
        const decorated = onMonitorErrorCollected ? monitor(originalMethod) : originalMethod;
        return decorated.apply(this, args);
    };
}
function monitor(fn) {
    return function (...args) {
        return callMonitored(fn, this, args);
    }; // consider output type has input type
}
function callMonitored(fn, context, args) {
    try {
        return fn.apply(context, args);
    }
    catch (e) {
        monitorError(e);
    }
}
function monitorError(e) {
    displayIfDebugEnabled(e);
    if (onMonitorErrorCollected) {
        try {
            onMonitorErrorCollected(e);
        }
        catch (e) {
            displayIfDebugEnabled(e);
        }
    }
}
function displayIfDebugEnabled(...args) {
    if (debugMode) {
        _display__WEBPACK_IMPORTED_MODULE_0__/* .display.error */ .jf.error('[MONITOR]', ...args);
    }
}
//# sourceMappingURL=monitor.js.map

/***/ }),

/***/ 75721:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "fk": function() { return /* binding */ BufferedObservable; },
  "y$": function() { return /* binding */ Observable; },
  "$Z": function() { return /* binding */ mergeObservables; }
});

// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/monitor.js
var monitor = __webpack_require__(64933);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/globalObject.js
var globalObject = __webpack_require__(51145);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/queueMicrotask.js


function queueMicrotask(callback) {
    var _a;
    const nativeImplementation = (_a = globalObject/* globalObject.queueMicrotask */.Zf.queueMicrotask) === null || _a === void 0 ? void 0 : _a.bind(globalObject/* globalObject */.Zf);
    if (typeof nativeImplementation === 'function') {
        nativeImplementation((0,monitor/* monitor */.zk)(callback));
    }
    else {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises -- the callback is monitored, so it'll never throw
        Promise.resolve().then((0,monitor/* monitor */.zk)(callback));
    }
}
//# sourceMappingURL=queueMicrotask.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/observable.js

// eslint-disable-next-line no-restricted-syntax
class Observable {
    constructor(onFirstSubscribe) {
        this.onFirstSubscribe = onFirstSubscribe;
        this.observers = [];
    }
    subscribe(observer) {
        this.addObserver(observer);
        return {
            unsubscribe: () => this.removeObserver(observer),
        };
    }
    notify(data) {
        this.observers.forEach((observer) => observer(data));
    }
    addObserver(observer) {
        this.observers.push(observer);
        if (this.observers.length === 1 && this.onFirstSubscribe) {
            this.onLastUnsubscribe = this.onFirstSubscribe(this) || undefined;
        }
    }
    removeObserver(observer) {
        this.observers = this.observers.filter((other) => observer !== other);
        if (!this.observers.length && this.onLastUnsubscribe) {
            this.onLastUnsubscribe();
        }
    }
}
function mergeObservables(...observables) {
    return new Observable((globalObservable) => {
        const subscriptions = observables.map((observable) => observable.subscribe((data) => globalObservable.notify(data)));
        return () => subscriptions.forEach((subscription) => subscription.unsubscribe());
    });
}
// eslint-disable-next-line no-restricted-syntax
class BufferedObservable extends Observable {
    constructor(maxBufferSize) {
        super();
        this.maxBufferSize = maxBufferSize;
        this.buffer = [];
    }
    notify(data) {
        this.buffer.push(data);
        if (this.buffer.length > this.maxBufferSize) {
            this.buffer.shift();
        }
        super.notify(data);
    }
    subscribe(observer) {
        let closed = false;
        const subscription = {
            unsubscribe: () => {
                closed = true;
                this.removeObserver(observer);
            },
        };
        queueMicrotask(() => {
            for (const data of this.buffer) {
                if (closed) {
                    return;
                }
                observer(data);
            }
            if (!closed) {
                this.addObserver(observer);
            }
        });
        return subscription;
    }
    /**
     * Drop buffered data and don't buffer future data. This is to avoid leaking memory when it's not
     * needed anymore. This can be seen as a performance optimization, and things will work probably
     * even if this method isn't called, but still useful to clarify our intent and lowering our
     * memory impact.
     */
    unbuffer() {
        queueMicrotask(() => {
            this.maxBufferSize = this.buffer.length = 0;
        });
    }
}
//# sourceMappingURL=observable.js.map

/***/ }),

/***/ 21337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kk": function() { return /* binding */ requestIdleCallback; }
/* harmony export */ });
/* unused harmony exports MAX_TASK_TIME, requestIdleCallbackShim */
/* harmony import */ var _timer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65483);
/* harmony import */ var _monitor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64933);
/* harmony import */ var _utils_timeUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25026);



/**
 * 'requestIdleCallback' with a shim.
 */
function requestIdleCallback(callback, opts) {
    // Note: check both 'requestIdleCallback' and 'cancelIdleCallback' existence because some polyfills only implement 'requestIdleCallback'.
    if (window.requestIdleCallback && window.cancelIdleCallback) {
        const id = window.requestIdleCallback((0,_monitor__WEBPACK_IMPORTED_MODULE_0__/* .monitor */ .zk)(callback), opts);
        return () => window.cancelIdleCallback(id);
    }
    return requestIdleCallbackShim(callback);
}
const MAX_TASK_TIME = 50;
/*
 * Shim from https://developer.chrome.com/blog/using-requestidlecallback#checking_for_requestidlecallback
 * Note: there is no simple way to support the "timeout" option, so we ignore it.
 */
function requestIdleCallbackShim(callback) {
    const start = (0,_utils_timeUtils__WEBPACK_IMPORTED_MODULE_1__/* .dateNow */ .m6)();
    const timeoutId = (0,_timer__WEBPACK_IMPORTED_MODULE_2__/* .setTimeout */ .iK)(() => {
        callback({
            didTimeout: false,
            timeRemaining: () => Math.max(0, MAX_TASK_TIME - ((0,_utils_timeUtils__WEBPACK_IMPORTED_MODULE_1__/* .dateNow */ .m6)() - start)),
        });
    }, 0);
    return () => (0,_timer__WEBPACK_IMPORTED_MODULE_2__/* .clearTimeout */ .gr)(timeoutId);
}
//# sourceMappingURL=requestIdleCallback.js.map

/***/ }),

/***/ 38971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ sendToExtension; }
/* harmony export */ });
/* harmony import */ var _globalObject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51145);

function sendToExtension(type, payload) {
    const callback = _globalObject__WEBPACK_IMPORTED_MODULE_0__/* .globalObject.__ddBrowserSdkExtensionCallback */ .Zf.__ddBrowserSdkExtensionCallback;
    if (callback) {
        callback({ type, payload });
    }
}
//# sourceMappingURL=sendToExtension.js.map

/***/ }),

/***/ 19012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ jsonStringify; },
/* harmony export */   "y": function() { return /* binding */ detachToJsonMethod; }
/* harmony export */ });
/* harmony import */ var _utils_functionUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(251);

/**
 * Custom implementation of JSON.stringify that ignores some toJSON methods. We need to do that
 * because some sites badly override toJSON on certain objects. Removing all toJSON methods from
 * nested values would be too costly, so we just detach them from the root value, and native classes
 * used to build JSON values (Array and Object).
 *
 * Note: this still assumes that JSON.stringify is correct.
 */
function jsonStringify(value, replacer, space) {
    if (typeof value !== 'object' || value === null) {
        return JSON.stringify(value);
    }
    // Note: The order matter here. We need to detach toJSON methods on parent classes before their
    // subclasses.
    const restoreObjectPrototypeToJson = detachToJsonMethod(Object.prototype);
    const restoreArrayPrototypeToJson = detachToJsonMethod(Array.prototype);
    const restoreValuePrototypeToJson = detachToJsonMethod(Object.getPrototypeOf(value));
    const restoreValueToJson = detachToJsonMethod(value);
    try {
        return JSON.stringify(value, replacer, space);
    }
    catch (_a) {
        return '<error: unable to serialize object>';
    }
    finally {
        restoreObjectPrototypeToJson();
        restoreArrayPrototypeToJson();
        restoreValuePrototypeToJson();
        restoreValueToJson();
    }
}
function detachToJsonMethod(value) {
    const object = value;
    const objectToJson = object.toJSON;
    if (objectToJson) {
        delete object.toJSON;
        return () => {
            object.toJSON = objectToJson;
        };
    }
    return _utils_functionUtils__WEBPACK_IMPORTED_MODULE_0__/* .noop */ .Z;
}
//# sourceMappingURL=jsonStringify.js.map

/***/ }),

/***/ 68566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ sanitize; }
/* harmony export */ });
/* harmony import */ var _display__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13842);
/* harmony import */ var _utils_byteUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51962);
/* harmony import */ var _jsonStringify__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19012);



// The maximum size of a single event is 256KiB. By default, we ensure that user-provided data
// going through sanitize fits inside our events, while leaving room for other contexts, metadata, ...
const SANITIZE_DEFAULT_MAX_CHARACTER_COUNT = 220 * _utils_byteUtils__WEBPACK_IMPORTED_MODULE_0__/* .ONE_KIBI_BYTE */ .Hi;
// Symbol for the root element of the JSONPath used for visited objects
const JSON_PATH_ROOT_ELEMENT = '$';
// When serializing (using JSON.stringify) a key of an object, { key: 42 } gets wrapped in quotes as "key".
// With the separator (:), we need to add 3 characters to the count.
const KEY_DECORATION_LENGTH = 3;
function sanitize(source, maxCharacterCount = SANITIZE_DEFAULT_MAX_CHARACTER_COUNT) {
    // Unbind any toJSON function we may have on [] or {} prototypes
    const restoreObjectPrototypeToJson = (0,_jsonStringify__WEBPACK_IMPORTED_MODULE_1__/* .detachToJsonMethod */ .y)(Object.prototype);
    const restoreArrayPrototypeToJson = (0,_jsonStringify__WEBPACK_IMPORTED_MODULE_1__/* .detachToJsonMethod */ .y)(Array.prototype);
    // Initial call to sanitizeProcessor - will populate containerQueue if source is an Array or a plain Object
    const containerQueue = [];
    const visitedObjectsWithPath = new WeakMap();
    const sanitizedData = sanitizeProcessor(source, JSON_PATH_ROOT_ELEMENT, undefined, containerQueue, visitedObjectsWithPath);
    const serializedSanitizedData = JSON.stringify(sanitizedData);
    let accumulatedCharacterCount = serializedSanitizedData ? serializedSanitizedData.length : 0;
    if (accumulatedCharacterCount > maxCharacterCount) {
        warnOverCharacterLimit(maxCharacterCount, 'discarded', source);
        return undefined;
    }
    while (containerQueue.length > 0 && accumulatedCharacterCount < maxCharacterCount) {
        const containerToProcess = containerQueue.shift();
        let separatorLength = 0; // 0 for the first element, 1 for subsequent elements
        // Arrays and Objects have to be handled distinctly to ensure
        // we do not pick up non-numerical properties from Arrays
        if (Array.isArray(containerToProcess.source)) {
            for (let key = 0; key < containerToProcess.source.length; key++) {
                const targetData = sanitizeProcessor(containerToProcess.source[key], containerToProcess.path, key, containerQueue, visitedObjectsWithPath);
                if (targetData !== undefined) {
                    accumulatedCharacterCount += JSON.stringify(targetData).length;
                }
                else {
                    // When an element of an Array (targetData) is undefined, it is serialized as null:
                    // JSON.stringify([undefined]) => '[null]' - This accounts for 4 characters
                    accumulatedCharacterCount += 4;
                }
                accumulatedCharacterCount += separatorLength;
                separatorLength = 1;
                if (accumulatedCharacterCount > maxCharacterCount) {
                    warnOverCharacterLimit(maxCharacterCount, 'truncated', source);
                    break;
                }
                ;
                containerToProcess.target[key] = targetData;
            }
        }
        else {
            for (const key in containerToProcess.source) {
                if (Object.prototype.hasOwnProperty.call(containerToProcess.source, key)) {
                    const targetData = sanitizeProcessor(containerToProcess.source[key], containerToProcess.path, key, containerQueue, visitedObjectsWithPath);
                    // When a property of an object has an undefined value, it will be dropped during serialization:
                    // JSON.stringify({a:undefined}) => '{}'
                    if (targetData !== undefined) {
                        accumulatedCharacterCount +=
                            JSON.stringify(targetData).length + separatorLength + key.length + KEY_DECORATION_LENGTH;
                        separatorLength = 1;
                    }
                    if (accumulatedCharacterCount > maxCharacterCount) {
                        warnOverCharacterLimit(maxCharacterCount, 'truncated', source);
                        break;
                    }
                    ;
                    containerToProcess.target[key] = targetData;
                }
            }
        }
    }
    // Rebind detached toJSON functions
    restoreObjectPrototypeToJson();
    restoreArrayPrototypeToJson();
    return sanitizedData;
}
/**
 * Internal function to factorize the process common to the
 * initial call to sanitize, and iterations for Arrays and Objects
 *
 */
function sanitizeProcessor(source, parentPath, key, queue, visitedObjectsWithPath) {
    // Start by handling toJSON, as we want to sanitize its output
    const sourceToSanitize = tryToApplyToJSON(source);
    if (!sourceToSanitize || typeof sourceToSanitize !== 'object') {
        return sanitizePrimitivesAndFunctions(sourceToSanitize);
    }
    const sanitizedSource = sanitizeObjects(sourceToSanitize);
    if (sanitizedSource !== '[Object]' && sanitizedSource !== '[Array]' && sanitizedSource !== '[Error]') {
        return sanitizedSource;
    }
    // Handle potential cyclic references
    // We need to use source as sourceToSanitize could be a reference to a new object
    // At this stage, we know the source is an object type
    const sourceAsObject = source;
    if (visitedObjectsWithPath.has(sourceAsObject)) {
        return `[Reference seen at ${visitedObjectsWithPath.get(sourceAsObject)}]`;
    }
    // Add processed source to queue
    const currentPath = key !== undefined ? `${parentPath}.${key}` : parentPath;
    const target = Array.isArray(sourceToSanitize) ? [] : {};
    visitedObjectsWithPath.set(sourceAsObject, currentPath);
    queue.push({ source: sourceToSanitize, target, path: currentPath });
    return target;
}
/**
 * Handles sanitization of simple, non-object types
 *
 */
function sanitizePrimitivesAndFunctions(value) {
    // BigInt cannot be serialized by JSON.stringify(), convert it to a string representation
    if (typeof value === 'bigint') {
        return `[BigInt] ${value.toString()}`;
    }
    // Functions cannot be serialized by JSON.stringify(). Moreover, if a faulty toJSON is present, it needs to be converted
    // so it won't prevent stringify from serializing later
    if (typeof value === 'function') {
        return `[Function] ${value.name || 'unknown'}`;
    }
    // JSON.stringify() does not serialize symbols.
    if (typeof value === 'symbol') {
        return `[Symbol] ${value.description || value.toString()}`;
    }
    return value;
}
/**
 * Handles sanitization of object types
 *
 * LIMITATIONS
 * - If a class defines a toStringTag Symbol, it will fall in the catch-all method and prevent enumeration of properties.
 * To avoid this, a toJSON method can be defined.
 */
function sanitizeObjects(value) {
    try {
        if (value instanceof Event) {
            return sanitizeEvent(value);
        }
        if (value instanceof RegExp) {
            return `[RegExp] ${value.toString()}`;
        }
        // Handle all remaining object types in a generic way
        const result = Object.prototype.toString.call(value);
        const match = result.match(/\[object (.*)\]/);
        if (match && match[1]) {
            return `[${match[1]}]`;
        }
    }
    catch (_a) {
        // If the previous serialization attempts failed, and we cannot convert using
        // Object.prototype.toString, declare the value unserializable
    }
    return '[Unserializable]';
}
function sanitizeEvent(event) {
    return {
        type: event.type,
        isTrusted: event.isTrusted,
        currentTarget: event.currentTarget ? sanitizeObjects(event.currentTarget) : null,
        target: event.target ? sanitizeObjects(event.target) : null,
    };
}
/**
 * Checks if a toJSON function exists and tries to execute it
 *
 */
function tryToApplyToJSON(value) {
    const object = value;
    if (object && typeof object.toJSON === 'function') {
        try {
            return object.toJSON();
        }
        catch (_a) {
            // If toJSON fails, we continue by trying to serialize the value manually
        }
    }
    return value;
}
/**
 * Helper function to display the warning when the accumulated character count is over the limit
 */
function warnOverCharacterLimit(maxCharacterCount, changeType, source) {
    _display__WEBPACK_IMPORTED_MODULE_2__/* .display.warn */ .jf.warn(`The data provided has been ${changeType} as it is over the limit of ${maxCharacterCount} characters:`, source);
}
//# sourceMappingURL=sanitize.js.map

/***/ }),

/***/ 22685:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ computeStackTrace; },
/* harmony export */   "f": function() { return /* binding */ computeStackTraceFromOnErrorMessage; }
/* harmony export */ });
/**
 * Cross-browser stack trace computation.
 *
 * Reference implementation: https://github.com/csnover/TraceKit/blob/04530298073c3823de72deb0b97e7b38ca7bcb59/tracekit.js
 */
const UNKNOWN_FUNCTION = '?';
function computeStackTrace(ex) {
    var _a, _b;
    const stack = [];
    let stackProperty = tryToGetString(ex, 'stack');
    const exString = String(ex);
    if (stackProperty && stackProperty.startsWith(exString)) {
        stackProperty = stackProperty.slice(exString.length);
    }
    if (stackProperty) {
        stackProperty.split('\n').forEach((line) => {
            const stackFrame = parseChromeLine(line) || parseChromeAnonymousLine(line) || parseWinLine(line) || parseGeckoLine(line);
            if (stackFrame) {
                if (!stackFrame.func && stackFrame.line) {
                    stackFrame.func = UNKNOWN_FUNCTION;
                }
                stack.push(stackFrame);
            }
        });
    }
    if (stack.length > 0 && isWronglyReportingCustomErrors() && ex instanceof Error) {
        // if we are wrongly reporting custom errors
        const constructors = [];
        // go through each inherited constructor
        let currentPrototype = ex;
        while ((currentPrototype = Object.getPrototypeOf(currentPrototype)) &&
            isNonNativeClassPrototype(currentPrototype)) {
            const constructorName = ((_a = currentPrototype.constructor) === null || _a === void 0 ? void 0 : _a.name) || UNKNOWN_FUNCTION;
            constructors.push(constructorName);
        }
        // traverse the stacktrace in reverse order because the stacktrace starts with the last inherited constructor
        // we check constructor names to ensure we remove the correct frame (and there isn't a weird unsupported environment behavior)
        for (let i = constructors.length - 1; i >= 0 && ((_b = stack[0]) === null || _b === void 0 ? void 0 : _b.func) === constructors[i]; i--) {
            // if the first stack frame is the custom error constructor
            // null stack frames may represent frames that failed to be parsed because the error class did not have a constructor
            stack.shift(); // remove it
        }
    }
    return {
        message: tryToGetString(ex, 'message'),
        name: tryToGetString(ex, 'name'),
        stack,
    };
}
const fileUrl = '((?:file|https?|blob|chrome-extension|electron|native|eval|webpack|snippet|<anonymous>|\\w+\\.|\\/).*?)';
const filePosition = '(?::(\\d+))';
const CHROME_LINE_RE = new RegExp(`^\\s*at (.*?) ?\\(${fileUrl}${filePosition}?${filePosition}?\\)?\\s*$`, 'i');
const CHROME_EVAL_RE = new RegExp(`\\((\\S*)${filePosition}${filePosition}\\)`);
function parseChromeLine(line) {
    const parts = CHROME_LINE_RE.exec(line);
    if (!parts) {
        return;
    }
    const isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
    const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
    const submatch = CHROME_EVAL_RE.exec(parts[2]);
    if (isEval && submatch) {
        // throw out eval line/column and use top-most line/column number
        parts[2] = submatch[1]; // url
        parts[3] = submatch[2]; // line
        parts[4] = submatch[3]; // column
    }
    return {
        args: isNative ? [parts[2]] : [],
        column: parts[4] ? +parts[4] : undefined,
        func: parts[1] || UNKNOWN_FUNCTION,
        line: parts[3] ? +parts[3] : undefined,
        url: !isNative ? parts[2] : undefined,
    };
}
const CHROME_ANONYMOUS_FUNCTION_RE = new RegExp(`^\\s*at ?${fileUrl}${filePosition}?${filePosition}??\\s*$`, 'i');
function parseChromeAnonymousLine(line) {
    const parts = CHROME_ANONYMOUS_FUNCTION_RE.exec(line);
    if (!parts) {
        return;
    }
    return {
        args: [],
        column: parts[3] ? +parts[3] : undefined,
        func: UNKNOWN_FUNCTION,
        line: parts[2] ? +parts[2] : undefined,
        url: parts[1],
    };
}
const WINJS_LINE_RE = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
function parseWinLine(line) {
    const parts = WINJS_LINE_RE.exec(line);
    if (!parts) {
        return;
    }
    return {
        args: [],
        column: parts[4] ? +parts[4] : undefined,
        func: parts[1] || UNKNOWN_FUNCTION,
        line: +parts[3],
        url: parts[2],
    };
}
const GECKO_LINE_RE = /^\s*(.*?)(?:\((.*?)\))?(?:(?:(?:^|@)((?:file|https?|blob|chrome|webpack|resource|capacitor|\[native).*?|[^@]*bundle|\[wasm code\])(?::(\d+))?(?::(\d+))?)|@)\s*$/i;
const GECKO_EVAL_RE = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
function parseGeckoLine(line) {
    const parts = GECKO_LINE_RE.exec(line);
    if (!parts) {
        return;
    }
    const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
    const submatch = GECKO_EVAL_RE.exec(parts[3]);
    if (isEval && submatch) {
        // throw out eval line/column and use top-most line number
        parts[3] = submatch[1];
        parts[4] = submatch[2];
        parts[5] = undefined; // no column when eval
    }
    return {
        args: parts[2] ? parts[2].split(',') : [],
        column: parts[5] ? +parts[5] : undefined,
        func: parts[1] || UNKNOWN_FUNCTION,
        line: parts[4] ? +parts[4] : undefined,
        url: parts[3],
    };
}
function tryToGetString(candidate, property) {
    if (typeof candidate !== 'object' || !candidate || !(property in candidate)) {
        return undefined;
    }
    const value = candidate[property];
    return typeof value === 'string' ? value : undefined;
}
function computeStackTraceFromOnErrorMessage(messageObj, url, line, column) {
    if (url === undefined) {
        return;
    }
    const { name, message } = tryToParseMessage(messageObj);
    return {
        name,
        message,
        stack: [{ url, column, line }],
    };
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
const ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?([\s\S]*)$/;
function tryToParseMessage(messageObj) {
    let name;
    let message;
    if ({}.toString.call(messageObj) === '[object String]') {
        ;
        [, name, message] = ERROR_TYPES_RE.exec(messageObj);
    }
    return { name, message };
}
// Custom error stacktrace fix
// Some browsers (safari/firefox) add the error constructor as a frame in the stacktrace
// In order to normalize the stacktrace, we need to remove it
function isNonNativeClassPrototype(prototype) {
    return String(prototype.constructor).startsWith('class ');
}
let isWronglyReportingCustomErrorsCache;
function isWronglyReportingCustomErrors() {
    if (isWronglyReportingCustomErrorsCache !== undefined) {
        return isWronglyReportingCustomErrorsCache;
    }
    /* eslint-disable no-restricted-syntax */
    class DatadogTestCustomError extends Error {
        constructor() {
            super();
            this.name = 'Error'; // set name to Error so that no browser would default to the constructor name
        }
    }
    const [customError, nativeError] = [DatadogTestCustomError, Error].map((errConstructor) => new errConstructor()); // so that both errors should exactly have the same stacktrace
    isWronglyReportingCustomErrorsCache =
        // If customError is not a class, it means that this was built with ES5 as target, converting the class to a normal object.
        // Thus, error constructors will be reported on all browsers, which is the expected behavior.
        isNonNativeClassPrototype(Object.getPrototypeOf(customError)) &&
            // If the browser is correctly reporting the stacktrace, the normal error stacktrace should be the same as the custom error stacktrace
            nativeError.stack !== customError.stack;
    return isWronglyReportingCustomErrorsCache;
}
//# sourceMappingURL=computeStackTrace.js.map

/***/ }),

/***/ 24507:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P3": function() { return /* binding */ toStackTraceString; },
/* harmony export */   "Xp": function() { return /* binding */ createHandlingStack; },
/* harmony export */   "jN": function() { return /* binding */ formatErrorMessage; }
/* harmony export */ });
/* harmony import */ var _monitor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64933);
/* harmony import */ var _computeStackTrace__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22685);


/**
 * Creates a stacktrace without SDK internal frames.
 * Constraints:
 * - Has to be called at the utmost position of the call stack.
 * - No monitored function should encapsulate it, that is why we need to use callMonitored inside it.
 */
function createHandlingStack(type) {
    /**
     * Skip the two internal frames:
     * - SDK API (console.error, ...)
     * - this function
     * in order to keep only the user calls
     */
    const internalFramesToSkip = 2;
    const error = new Error(type);
    error.name = 'HandlingStack';
    let formattedStack;
    (0,_monitor__WEBPACK_IMPORTED_MODULE_0__/* .callMonitored */ .L6)(() => {
        const stackTrace = (0,_computeStackTrace__WEBPACK_IMPORTED_MODULE_1__/* .computeStackTrace */ ._)(error);
        stackTrace.stack = stackTrace.stack.slice(internalFramesToSkip);
        formattedStack = toStackTraceString(stackTrace);
    });
    return formattedStack;
}
function toStackTraceString(stack) {
    let result = formatErrorMessage(stack);
    stack.stack.forEach((frame) => {
        const func = frame.func === '?' ? '<anonymous>' : frame.func;
        const args = frame.args && frame.args.length > 0 ? `(${frame.args.join(', ')})` : '';
        const line = frame.line ? `:${frame.line}` : '';
        const column = frame.line && frame.column ? `:${frame.column}` : '';
        result += `\n  at ${func}${args} @ ${frame.url}${line}${column}`;
    });
    return result;
}
function formatErrorMessage(stack) {
    return `${stack.name || 'Error'}: ${stack.message}`;
}
//# sourceMappingURL=handlingStack.js.map

/***/ }),

/***/ 65483:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Zi": function() { return /* binding */ setInterval; },
/* harmony export */   "cv": function() { return /* binding */ clearInterval; },
/* harmony export */   "gr": function() { return /* binding */ clearTimeout; },
/* harmony export */   "iK": function() { return /* binding */ setTimeout; }
/* harmony export */ });
/* harmony import */ var _getZoneJsOriginalValue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59693);
/* harmony import */ var _monitor__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64933);
/* harmony import */ var _globalObject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51145);



function setTimeout(callback, delay) {
    return (0,_getZoneJsOriginalValue__WEBPACK_IMPORTED_MODULE_0__/* .getZoneJsOriginalValue */ .I)((0,_globalObject__WEBPACK_IMPORTED_MODULE_1__/* .getGlobalObject */ .Rf)(), 'setTimeout')((0,_monitor__WEBPACK_IMPORTED_MODULE_2__/* .monitor */ .zk)(callback), delay);
}
function clearTimeout(timeoutId) {
    (0,_getZoneJsOriginalValue__WEBPACK_IMPORTED_MODULE_0__/* .getZoneJsOriginalValue */ .I)((0,_globalObject__WEBPACK_IMPORTED_MODULE_1__/* .getGlobalObject */ .Rf)(), 'clearTimeout')(timeoutId);
}
function setInterval(callback, delay) {
    return (0,_getZoneJsOriginalValue__WEBPACK_IMPORTED_MODULE_0__/* .getZoneJsOriginalValue */ .I)((0,_globalObject__WEBPACK_IMPORTED_MODULE_1__/* .getGlobalObject */ .Rf)(), 'setInterval')((0,_monitor__WEBPACK_IMPORTED_MODULE_2__/* .monitor */ .zk)(callback), delay);
}
function clearInterval(timeoutId) {
    (0,_getZoneJsOriginalValue__WEBPACK_IMPORTED_MODULE_0__/* .getZoneJsOriginalValue */ .I)((0,_globalObject__WEBPACK_IMPORTED_MODULE_1__/* .getGlobalObject */ .Rf)(), 'clearInterval')(timeoutId);
}
//# sourceMappingURL=timer.js.map

/***/ }),

/***/ 12172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G6": function() { return /* binding */ isSafari; },
/* harmony export */   "mJ": function() { return /* binding */ isChromium; }
/* harmony export */ });
/* unused harmony export detectBrowser */
function isChromium() {
    return detectBrowserCached() === 0 /* Browser.CHROMIUM */;
}
function isSafari() {
    return detectBrowserCached() === 1 /* Browser.SAFARI */;
}
let browserCache;
function detectBrowserCached() {
    return browserCache !== null && browserCache !== void 0 ? browserCache : (browserCache = detectBrowser());
}
// Exported only for tests
function detectBrowser(browserWindow = window) {
    var _a;
    const userAgent = browserWindow.navigator.userAgent;
    if (browserWindow.chrome || /HeadlessChrome/.test(userAgent)) {
        return 0 /* Browser.CHROMIUM */;
    }
    if (
    // navigator.vendor is deprecated, but it is the most resilient way we found to detect
    // "Apple maintained browsers" (AKA Safari). If one day it gets removed, we still have the
    // useragent test as a semi-working fallback.
    ((_a = browserWindow.navigator.vendor) === null || _a === void 0 ? void 0 : _a.indexOf('Apple')) === 0 ||
        (/safari/i.test(userAgent) && !/chrome|android/i.test(userAgent))) {
        return 1 /* Browser.SAFARI */;
    }
    return 2 /* Browser.OTHER */;
}
//# sourceMappingURL=browserDetection.js.map

/***/ }),

/***/ 51962:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hi": function() { return /* binding */ ONE_KIBI_BYTE; },
/* harmony export */   "Kb": function() { return /* binding */ concatBuffers; },
/* harmony export */   "X9": function() { return /* binding */ ONE_MEBI_BYTE; },
/* harmony export */   "qt": function() { return /* binding */ computeBytesCount; }
/* harmony export */ });
const ONE_KIBI_BYTE = 1024;
const ONE_MEBI_BYTE = 1024 * ONE_KIBI_BYTE;
// eslint-disable-next-line no-control-regex
const HAS_MULTI_BYTES_CHARACTERS = /[^\u0000-\u007F]/;
function computeBytesCount(candidate) {
    // Accurate bytes count computations can degrade performances when there is a lot of events to process
    if (!HAS_MULTI_BYTES_CHARACTERS.test(candidate)) {
        return candidate.length;
    }
    if (window.TextEncoder !== undefined) {
        return new TextEncoder().encode(candidate).length;
    }
    return new Blob([candidate]).size;
}
function concatBuffers(buffers) {
    // Optimization: if there is a single buffer, no need to copy it
    if (buffers.length === 1) {
        return buffers[0];
    }
    const length = buffers.reduce((total, buffer) => total + buffer.length, 0);
    const result = new Uint8Array(length);
    let offset = 0;
    for (const buffer of buffers) {
        result.set(buffer, offset);
        offset += buffer.length;
    }
    return result;
}
//# sourceMappingURL=byteUtils.js.map

/***/ }),

/***/ 251:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ throttle; },
/* harmony export */   "Z": function() { return /* binding */ noop; }
/* harmony export */ });
/* harmony import */ var _timer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65483);

// use lodash API
function throttle(fn, wait, options) {
    const needLeadingExecution = options && options.leading !== undefined ? options.leading : true;
    const needTrailingExecution = options && options.trailing !== undefined ? options.trailing : true;
    let inWaitPeriod = false;
    let pendingExecutionWithParameters;
    let pendingTimeoutId;
    return {
        throttled: (...parameters) => {
            if (inWaitPeriod) {
                pendingExecutionWithParameters = parameters;
                return;
            }
            if (needLeadingExecution) {
                fn(...parameters);
            }
            else {
                pendingExecutionWithParameters = parameters;
            }
            inWaitPeriod = true;
            pendingTimeoutId = (0,_timer__WEBPACK_IMPORTED_MODULE_0__/* .setTimeout */ .iK)(() => {
                if (needTrailingExecution && pendingExecutionWithParameters) {
                    fn(...pendingExecutionWithParameters);
                }
                inWaitPeriod = false;
                pendingExecutionWithParameters = undefined;
            }, wait);
        },
        cancel: () => {
            (0,_timer__WEBPACK_IMPORTED_MODULE_0__/* .clearTimeout */ .gr)(pendingTimeoutId);
            inWaitPeriod = false;
            pendingExecutionWithParameters = undefined;
        },
    };
}
// eslint-disable-next-line @typescript-eslint/no-empty-function
function noop() { }
//# sourceMappingURL=functionUtils.js.map

/***/ }),

/***/ 73603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NM": function() { return /* binding */ round; },
/* harmony export */   "hj": function() { return /* binding */ isNumber; },
/* harmony export */   "y7": function() { return /* binding */ performDraw; },
/* harmony export */   "zz": function() { return /* binding */ isPercentage; }
/* harmony export */ });
/**
 * Return true if the draw is successful
 *
 * @param threshold - Threshold between 0 and 100
 */
function performDraw(threshold) {
    return threshold !== 0 && Math.random() * 100 <= threshold;
}
function round(num, decimals) {
    return +num.toFixed(decimals);
}
function isPercentage(value) {
    return isNumber(value) && value >= 0 && value <= 100;
}
function isNumber(value) {
    return typeof value === 'number';
}
//# sourceMappingURL=numberUtils.js.map

/***/ }),

/***/ 94162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E5": function() { return /* binding */ objectHasValue; },
/* harmony export */   "Q8": function() { return /* binding */ mapValues; },
/* harmony export */   "Qr": function() { return /* binding */ isEmptyObject; },
/* harmony export */   "mv": function() { return /* binding */ shallowClone; }
/* harmony export */ });
function shallowClone(object) {
    return { ...object };
}
function objectHasValue(object, value) {
    return Object.keys(object).some((key) => object[key] === value);
}
function isEmptyObject(object) {
    return Object.keys(object).length === 0;
}
function mapValues(object, fn) {
    const newObject = {};
    for (const key of Object.keys(object)) {
        newObject[key] = fn(object[key]);
    }
    return newObject;
}
//# sourceMappingURL=objectUtils.js.map

/***/ }),

/***/ 94776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TT": function() { return /* binding */ objectValues; },
/* harmony export */   "dF": function() { return /* binding */ findLast; },
/* harmony export */   "qP": function() { return /* binding */ objectEntries; }
/* harmony export */ });
function findLast(array, predicate) {
    for (let i = array.length - 1; i >= 0; i -= 1) {
        const item = array[i];
        if (predicate(item, i, array)) {
            return item;
        }
    }
    return undefined;
}
// Keep the following wrapper functions as it can be mangled and will result in smaller bundle size that using
// the native Object.values and Object.entries directly
function objectValues(object) {
    return Object.values(object);
}
function objectEntries(object) {
    return Object.entries(object);
}
//# sourceMappingURL=polyfills.js.map

/***/ }),

/***/ 29100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ isServerError; },
/* harmony export */   "u": function() { return /* binding */ tryToClone; }
/* harmony export */ });
function isServerError(status) {
    return status >= 500;
}
function tryToClone(response) {
    try {
        return response.clone();
    }
    catch (_a) {
        // clone can throw if the response has already been used by another instrumentation or is disturbed
        return;
    }
}
//# sourceMappingURL=responseUtils.js.map

/***/ }),

/***/ 88129:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DO": function() { return /* binding */ generateUUID; },
/* harmony export */   "MY": function() { return /* binding */ findCommaSeparatedValue; },
/* harmony export */   "_z": function() { return /* binding */ safeTruncate; },
/* harmony export */   "kq": function() { return /* binding */ findCommaSeparatedValues; },
/* harmony export */   "ql": function() { return /* binding */ findAllCommaSeparatedValues; }
/* harmony export */ });
/**
 * UUID v4
 * from https://gist.github.com/jed/982883
 */
function generateUUID(placeholder) {
    return placeholder
        ? // eslint-disable-next-line  no-bitwise
            (parseInt(placeholder, 10) ^ ((Math.random() * 16) >> (parseInt(placeholder, 10) / 4))).toString(16)
        : `${1e7}-${1e3}-${4e3}-${8e3}-${1e11}`.replace(/[018]/g, generateUUID);
}
const COMMA_SEPARATED_KEY_VALUE = /([\w-]+)\s*=\s*([^;]+)/g;
/**
 * Returns the value of the key with the given name
 * If there are multiple values with the same key, returns the first one
 */
function findCommaSeparatedValue(rawString, name) {
    COMMA_SEPARATED_KEY_VALUE.lastIndex = 0;
    while (true) {
        const match = COMMA_SEPARATED_KEY_VALUE.exec(rawString);
        if (match) {
            if (match[1] === name) {
                return match[2];
            }
        }
        else {
            break;
        }
    }
}
/**
 * Returns a map of all the values with the given key
 * If there are multiple values with the same key, returns all the values
 */
function findAllCommaSeparatedValues(rawString) {
    const result = new Map();
    COMMA_SEPARATED_KEY_VALUE.lastIndex = 0;
    while (true) {
        const match = COMMA_SEPARATED_KEY_VALUE.exec(rawString);
        if (match) {
            const key = match[1];
            const value = match[2];
            if (result.has(key)) {
                result.get(key).push(value);
            }
            else {
                result.set(key, [value]);
            }
        }
        else {
            break;
        }
    }
    return result;
}
/**
 * Returns a map of the values with the given key
 * ⚠️ If there are multiple values with the same key, returns the LAST one
 *
 * @deprecated use `findAllCommaSeparatedValues()` instead
 */
function findCommaSeparatedValues(rawString) {
    const result = new Map();
    COMMA_SEPARATED_KEY_VALUE.lastIndex = 0;
    while (true) {
        const match = COMMA_SEPARATED_KEY_VALUE.exec(rawString);
        if (match) {
            result.set(match[1], match[2]);
        }
        else {
            break;
        }
    }
    return result;
}
function safeTruncate(candidate, length, suffix = '') {
    const lastChar = candidate.charCodeAt(length - 1);
    const isLastCharSurrogatePair = lastChar >= 0xd800 && lastChar <= 0xdbff;
    const correctedLength = isLastCharSurrogatePair ? length + 1 : length;
    if (candidate.length <= correctedLength) {
        return candidate;
    }
    return `${candidate.slice(0, correctedLength)}${suffix}`;
}
//# sourceMappingURL=stringUtils.js.map

/***/ }),

/***/ 25026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$I": function() { return /* binding */ clocksNow; },
/* harmony export */   "Cn": function() { return /* binding */ looksLikeRelativeTime; },
/* harmony export */   "DY": function() { return /* binding */ relativeToClocks; },
/* harmony export */   "P5": function() { return /* binding */ ONE_YEAR; },
/* harmony export */   "QA": function() { return /* binding */ currentDrift; },
/* harmony export */   "WK": function() { return /* binding */ addDuration; },
/* harmony export */   "WT": function() { return /* binding */ ONE_SECOND; },
/* harmony export */   "_J": function() { return /* binding */ elapsed; },
/* harmony export */   "_q": function() { return /* binding */ relativeNow; },
/* harmony export */   "c0": function() { return /* binding */ toServerDuration; },
/* harmony export */   "cQ": function() { return /* binding */ clocksOrigin; },
/* harmony export */   "dV": function() { return /* binding */ ONE_HOUR; },
/* harmony export */   "lO": function() { return /* binding */ timeStampToClocks; },
/* harmony export */   "m6": function() { return /* binding */ dateNow; },
/* harmony export */   "n$": function() { return /* binding */ timeStampNow; },
/* harmony export */   "ni": function() { return /* binding */ getRelativeTime; },
/* harmony export */   "yR": function() { return /* binding */ ONE_MINUTE; }
/* harmony export */ });
/* unused harmony exports ONE_DAY, getTimeStamp */
/* harmony import */ var _numberUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73603);

const ONE_SECOND = 1000;
const ONE_MINUTE = 60 * ONE_SECOND;
const ONE_HOUR = 60 * ONE_MINUTE;
const ONE_DAY = 24 * ONE_HOUR;
const ONE_YEAR = 365 * ONE_DAY;
function relativeToClocks(relative) {
    return { relative, timeStamp: getCorrectedTimeStamp(relative) };
}
function timeStampToClocks(timeStamp) {
    return { relative: getRelativeTime(timeStamp), timeStamp };
}
function getCorrectedTimeStamp(relativeTime) {
    const correctedOrigin = (dateNow() - performance.now());
    // apply correction only for positive drift
    if (correctedOrigin > getNavigationStart()) {
        return Math.round(addDuration(correctedOrigin, relativeTime));
    }
    return getTimeStamp(relativeTime);
}
function currentDrift() {
    return Math.round(dateNow() - addDuration(getNavigationStart(), performance.now()));
}
function toServerDuration(duration) {
    if (!(0,_numberUtils__WEBPACK_IMPORTED_MODULE_0__/* .isNumber */ .hj)(duration)) {
        return duration;
    }
    return (0,_numberUtils__WEBPACK_IMPORTED_MODULE_0__/* .round */ .NM)(duration * 1e6, 0);
}
function dateNow() {
    // Do not use `Date.now` because sometimes websites are wrongly "polyfilling" it. For example, we
    // had some users using a very old version of `datejs`, which patched `Date.now` to return a Date
    // instance instead of a timestamp[1]. Those users are unlikely to fix this, so let's handle this
    // case ourselves.
    // [1]: https://github.com/datejs/Datejs/blob/97f5c7c58c5bc5accdab8aa7602b6ac56462d778/src/core-debug.js#L14-L16
    return new Date().getTime();
}
function timeStampNow() {
    return dateNow();
}
function relativeNow() {
    return performance.now();
}
function clocksNow() {
    return { relative: relativeNow(), timeStamp: timeStampNow() };
}
function clocksOrigin() {
    return { relative: 0, timeStamp: getNavigationStart() };
}
function elapsed(start, end) {
    return (end - start);
}
function addDuration(a, b) {
    return a + b;
}
// Get the time since the navigation was started.
function getRelativeTime(timestamp) {
    return (timestamp - getNavigationStart());
}
function getTimeStamp(relativeTime) {
    return Math.round(addDuration(getNavigationStart(), relativeTime));
}
function looksLikeRelativeTime(time) {
    return time < ONE_YEAR;
}
/**
 * Navigation start slightly change on some rare cases
 */
let navigationStart;
/**
 * Notes: this does not use `performance.timeOrigin` because:
 * - It doesn't seem to reflect the actual time on which the navigation has started: it may be much farther in the past,
 * at least in Firefox 71. (see: https://bugzilla.mozilla.org/show_bug.cgi?id=1429926)
 * - It is not supported in Safari <15
 */
function getNavigationStart() {
    var _a, _b;
    if (navigationStart === undefined) {
        // ServiceWorkers do not support navigationStart (it's deprecated), so we fallback to timeOrigin
        navigationStart = ((_b = (_a = performance.timing) === null || _a === void 0 ? void 0 : _a.navigationStart) !== null && _b !== void 0 ? _b : performance.timeOrigin);
    }
    return navigationStart;
}
//# sourceMappingURL=timeUtils.js.map

/***/ }),

/***/ 33234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ getType; }
/* harmony export */ });
/**
 * Similar to `typeof`, but distinguish plain objects from `null` and arrays
 */
function getType(value) {
    if (value === null) {
        return 'null';
    }
    if (Array.isArray(value)) {
        return 'array';
    }
    return typeof value;
}
//# sourceMappingURL=typeUtils.js.map

/***/ }),

/***/ 70170:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D5": function() { return /* binding */ normalizeUrl; },
/* harmony export */   "Q2": function() { return /* binding */ buildUrl; },
/* harmony export */   "jv": function() { return /* binding */ isValidUrl; },
/* harmony export */   "ye": function() { return /* binding */ getPathName; }
/* harmony export */ });
/* unused harmony export getPristineWindow */
/* harmony import */ var _globalObject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51145);

function normalizeUrl(url) {
    return buildUrl(url, location.href).href;
}
function isValidUrl(url) {
    try {
        return !!buildUrl(url);
    }
    catch (_a) {
        return false;
    }
}
function getPathName(url) {
    const pathname = buildUrl(url).pathname;
    return pathname[0] === '/' ? pathname : `/${pathname}`;
}
function buildUrl(url, base) {
    const { URL } = getPristineWindow();
    try {
        return base !== undefined ? new URL(url, base) : new URL(url);
    }
    catch (error) {
        throw new Error(`Failed to construct URL: ${String(error)}`);
    }
}
/**
 * Get native URL constructor from a clean iframe
 * This avoids polyfill issues by getting the native implementation from a fresh iframe context
 * Falls back to the original URL constructor if iframe approach fails
 */
let getPristineGlobalObjectCache;
function getPristineWindow() {
    if (!getPristineGlobalObjectCache) {
        let iframe;
        let pristineWindow;
        try {
            iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            document.body.appendChild(iframe);
            pristineWindow = iframe.contentWindow;
        }
        catch (_a) {
            pristineWindow = _globalObject__WEBPACK_IMPORTED_MODULE_0__/* .globalObject */ .Zf;
        }
        getPristineGlobalObjectCache = {
            URL: pristineWindow.URL,
        };
        iframe === null || iframe === void 0 ? void 0 : iframe.remove();
    }
    return getPristineGlobalObjectCache;
}
//# sourceMappingURL=urlPolyfill.js.map

/***/ }),

/***/ 53789:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ createBatch; }
/* harmony export */ });
/* unused harmony export MESSAGE_BYTES_LIMIT */
/* harmony import */ var _tools_display__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13842);
/* harmony import */ var _tools_utils_polyfills__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94776);
/* harmony import */ var _browser_pageMayExitObservable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47581);
/* harmony import */ var _tools_serialisation_jsonStringify__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19012);
/* harmony import */ var _tools_utils_byteUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51962);





const MESSAGE_BYTES_LIMIT = 256 * _tools_utils_byteUtils__WEBPACK_IMPORTED_MODULE_0__/* .ONE_KIBI_BYTE */ .Hi;
function createBatch({ encoder, request, flushController, }) {
    let upsertBuffer = {};
    const flushSubscription = flushController.flushObservable.subscribe((event) => flush(event));
    function push(serializedMessage, estimatedMessageBytesCount, key) {
        flushController.notifyBeforeAddMessage(estimatedMessageBytesCount);
        if (key !== undefined) {
            upsertBuffer[key] = serializedMessage;
            flushController.notifyAfterAddMessage();
        }
        else {
            encoder.write(encoder.isEmpty ? serializedMessage : `\n${serializedMessage}`, (realMessageBytesCount) => {
                flushController.notifyAfterAddMessage(realMessageBytesCount - estimatedMessageBytesCount);
            });
        }
    }
    function hasMessageFor(key) {
        return key !== undefined && upsertBuffer[key] !== undefined;
    }
    function remove(key) {
        const removedMessage = upsertBuffer[key];
        delete upsertBuffer[key];
        const messageBytesCount = encoder.estimateEncodedBytesCount(removedMessage);
        flushController.notifyAfterRemoveMessage(messageBytesCount);
    }
    function addOrUpdate(message, key) {
        const serializedMessage = (0,_tools_serialisation_jsonStringify__WEBPACK_IMPORTED_MODULE_1__/* .jsonStringify */ .l)(message);
        const estimatedMessageBytesCount = encoder.estimateEncodedBytesCount(serializedMessage);
        if (estimatedMessageBytesCount >= MESSAGE_BYTES_LIMIT) {
            _tools_display__WEBPACK_IMPORTED_MODULE_2__/* .display.warn */ .jf.warn(`Discarded a message whose size was bigger than the maximum allowed size ${MESSAGE_BYTES_LIMIT / _tools_utils_byteUtils__WEBPACK_IMPORTED_MODULE_0__/* .ONE_KIBI_BYTE */ .Hi}KiB. ${_tools_display__WEBPACK_IMPORTED_MODULE_2__/* .MORE_DETAILS */ .IA} ${_tools_display__WEBPACK_IMPORTED_MODULE_2__/* .DOCS_TROUBLESHOOTING */ .Qo}/#technical-limitations`);
            return;
        }
        if (hasMessageFor(key)) {
            remove(key);
        }
        push(serializedMessage, estimatedMessageBytesCount, key);
    }
    function flush(event) {
        const upsertMessages = (0,_tools_utils_polyfills__WEBPACK_IMPORTED_MODULE_3__/* .objectValues */ .TT)(upsertBuffer).join('\n');
        upsertBuffer = {};
        const pageMightExit = (0,_browser_pageMayExitObservable__WEBPACK_IMPORTED_MODULE_4__/* .isPageExitReason */ .PT)(event.reason);
        const send = pageMightExit ? request.sendOnExit : request.send;
        if (pageMightExit &&
            // Note: checking that the encoder is async is not strictly needed, but it's an optimization:
            // if the encoder is async we need to send two requests in some cases (one for encoded data
            // and the other for non-encoded data). But if it's not async, we don't have to worry about
            // it and always send a single request.
            encoder.isAsync) {
            const encoderResult = encoder.finishSync();
            // Send encoded messages
            if (encoderResult.outputBytesCount) {
                send(formatPayloadFromEncoder(encoderResult));
            }
            // Send messages that are not yet encoded at this point
            const pendingMessages = [encoderResult.pendingData, upsertMessages].filter(Boolean).join('\n');
            if (pendingMessages) {
                send({
                    data: pendingMessages,
                    bytesCount: (0,_tools_utils_byteUtils__WEBPACK_IMPORTED_MODULE_0__/* .computeBytesCount */ .qt)(pendingMessages),
                });
            }
        }
        else {
            if (upsertMessages) {
                encoder.write(encoder.isEmpty ? upsertMessages : `\n${upsertMessages}`);
            }
            encoder.finish((encoderResult) => {
                send(formatPayloadFromEncoder(encoderResult));
            });
        }
    }
    return {
        flushController,
        add: addOrUpdate,
        upsert: addOrUpdate,
        stop: flushSubscription.unsubscribe,
    };
}
function formatPayloadFromEncoder(encoderResult) {
    let data;
    if (typeof encoderResult.output === 'string') {
        data = encoderResult.output;
    }
    else {
        data = new Blob([encoderResult.output], {
            // This will set the 'Content-Type: text/plain' header. Reasoning:
            // * The intake rejects the request if there is no content type.
            // * The browser will issue CORS preflight requests if we set it to 'application/json', which
            // could induce higher intake load (and maybe has other impacts).
            // * Also it's not quite JSON, since we are concatenating multiple JSON objects separated by
            // new lines.
            type: 'text/plain',
        });
    }
    return {
        data,
        bytesCount: encoderResult.outputBytesCount,
        encoding: encoderResult.encoding,
    };
}
//# sourceMappingURL=batch.js.map

/***/ }),

/***/ 76876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ad": function() { return /* binding */ getEventBridge; },
/* harmony export */   "ke": function() { return /* binding */ bridgeSupports; },
/* harmony export */   "xT": function() { return /* binding */ canUseEventBridge; }
/* harmony export */ });
/* harmony import */ var _tools_globalObject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51145);

function getEventBridge() {
    const eventBridgeGlobal = getEventBridgeGlobal();
    if (!eventBridgeGlobal) {
        return;
    }
    return {
        getCapabilities() {
            var _a;
            return JSON.parse(((_a = eventBridgeGlobal.getCapabilities) === null || _a === void 0 ? void 0 : _a.call(eventBridgeGlobal)) || '[]');
        },
        getPrivacyLevel() {
            var _a;
            return (_a = eventBridgeGlobal.getPrivacyLevel) === null || _a === void 0 ? void 0 : _a.call(eventBridgeGlobal);
        },
        getAllowedWebViewHosts() {
            return JSON.parse(eventBridgeGlobal.getAllowedWebViewHosts());
        },
        send(eventType, event, viewId) {
            const view = viewId ? { id: viewId } : undefined;
            eventBridgeGlobal.send(JSON.stringify({ eventType, event, view }));
        },
    };
}
function bridgeSupports(capability) {
    const bridge = getEventBridge();
    return !!bridge && bridge.getCapabilities().includes(capability);
}
function canUseEventBridge(currentHost) {
    var _a;
    if (currentHost === void 0) { currentHost = (_a = (0,_tools_globalObject__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .Rf)().location) === null || _a === void 0 ? void 0 : _a.hostname; }
    const bridge = getEventBridge();
    return (!!bridge &&
        bridge
            .getAllowedWebViewHosts()
            .some((allowedHost) => currentHost === allowedHost || currentHost.endsWith(`.${allowedHost}`)));
}
function getEventBridgeGlobal() {
    return (0,_tools_globalObject__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .Rf)().DatadogEventBridge;
}
//# sourceMappingURL=eventBridge.js.map

/***/ }),

/***/ 5419:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "rK": function() { return /* binding */ createFlushController; }
/* harmony export */ });
/* unused harmony exports FLUSH_DURATION_LIMIT, MESSAGES_LIMIT */
/* harmony import */ var _tools_globalObject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51145);
/* harmony import */ var _tools_observable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75721);
/* harmony import */ var _tools_timer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65483);
/* harmony import */ var _tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25026);
/* harmony import */ var _httpRequest__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30481);





/**
 * flush automatically, aim to be lower than ALB connection timeout
 * to maximize connection reuse.
 */
const FLUSH_DURATION_LIMIT = (30 * _tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_0__/* .ONE_SECOND */ .WT);
/**
 * When using the SDK in a Worker Environment, we limit the batch size to 1 to ensure it can be sent
 * in a single event.
 */
const MESSAGES_LIMIT = _tools_globalObject__WEBPACK_IMPORTED_MODULE_1__/* .isWorkerEnvironment */ .jX ? 1 : 50;
/**
 * Returns a "flush controller", responsible of notifying when flushing a pool of pending data needs
 * to happen. The implementation is designed to support both synchronous and asynchronous usages,
 * but relies on invariants described in each method documentation to keep a coherent state.
 */
function createFlushController({ pageMayExitObservable, sessionExpireObservable }) {
    const pageMayExitSubscription = pageMayExitObservable.subscribe((event) => flush(event.reason));
    const sessionExpireSubscription = sessionExpireObservable.subscribe(() => flush('session_expire'));
    const flushObservable = new _tools_observable__WEBPACK_IMPORTED_MODULE_2__/* .Observable */ .y$(() => () => {
        pageMayExitSubscription.unsubscribe();
        sessionExpireSubscription.unsubscribe();
    });
    let currentBytesCount = 0;
    let currentMessagesCount = 0;
    function flush(flushReason) {
        if (currentMessagesCount === 0) {
            return;
        }
        const messagesCount = currentMessagesCount;
        const bytesCount = currentBytesCount;
        currentMessagesCount = 0;
        currentBytesCount = 0;
        cancelDurationLimitTimeout();
        flushObservable.notify({
            reason: flushReason,
            messagesCount,
            bytesCount,
        });
    }
    let durationLimitTimeoutId;
    function scheduleDurationLimitTimeout() {
        if (durationLimitTimeoutId === undefined) {
            durationLimitTimeoutId = (0,_tools_timer__WEBPACK_IMPORTED_MODULE_3__/* .setTimeout */ .iK)(() => {
                flush('duration_limit');
            }, FLUSH_DURATION_LIMIT);
        }
    }
    function cancelDurationLimitTimeout() {
        (0,_tools_timer__WEBPACK_IMPORTED_MODULE_3__/* .clearTimeout */ .gr)(durationLimitTimeoutId);
        durationLimitTimeoutId = undefined;
    }
    return {
        flushObservable,
        get messagesCount() {
            return currentMessagesCount;
        },
        /**
         * Notifies that a message will be added to a pool of pending messages waiting to be flushed.
         *
         * This function needs to be called synchronously, right before adding the message, so no flush
         * event can happen after `notifyBeforeAddMessage` and before adding the message.
         *
         * @param estimatedMessageBytesCount - an estimation of the message bytes count once it is
         * actually added.
         */
        notifyBeforeAddMessage(estimatedMessageBytesCount) {
            if (currentBytesCount + estimatedMessageBytesCount >= _httpRequest__WEBPACK_IMPORTED_MODULE_4__/* .RECOMMENDED_REQUEST_BYTES_LIMIT */ .Wj) {
                flush('bytes_limit');
            }
            // Consider the message to be added now rather than in `notifyAfterAddMessage`, because if no
            // message was added yet and `notifyAfterAddMessage` is called asynchronously, we still want
            // to notify when a flush is needed (for example on page exit).
            currentMessagesCount += 1;
            currentBytesCount += estimatedMessageBytesCount;
            scheduleDurationLimitTimeout();
        },
        /**
         * Notifies that a message *was* added to a pool of pending messages waiting to be flushed.
         *
         * This function can be called asynchronously after the message was added, but in this case it
         * should not be called if a flush event occurred in between.
         *
         * @param messageBytesCountDiff - the difference between the estimated message bytes count and
         * its actual bytes count once added to the pool.
         */
        notifyAfterAddMessage(messageBytesCountDiff = 0) {
            currentBytesCount += messageBytesCountDiff;
            if (currentMessagesCount >= MESSAGES_LIMIT) {
                flush('messages_limit');
            }
            else if (currentBytesCount >= _httpRequest__WEBPACK_IMPORTED_MODULE_4__/* .RECOMMENDED_REQUEST_BYTES_LIMIT */ .Wj) {
                flush('bytes_limit');
            }
        },
        /**
         * Notifies that a message was removed from a pool of pending messages waiting to be flushed.
         *
         * This function needs to be called synchronously, right after removing the message, so no flush
         * event can happen after removing the message and before `notifyAfterRemoveMessage`.
         *
         * @param messageBytesCount - the message bytes count that was added to the pool. Should
         * correspond to the sum of bytes counts passed to `notifyBeforeAddMessage` and
         * `notifyAfterAddMessage`.
         */
        notifyAfterRemoveMessage(messageBytesCount) {
            currentBytesCount -= messageBytesCount;
            currentMessagesCount -= 1;
            if (currentMessagesCount === 0) {
                cancelDurationLimitTimeout();
            }
        },
    };
}
//# sourceMappingURL=flushController.js.map

/***/ }),

/***/ 30481:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Wj": function() { return /* binding */ RECOMMENDED_REQUEST_BYTES_LIMIT; },
  "UF": function() { return /* binding */ createHttpRequest; }
});

// UNUSED EXPORTS: fetchKeepAliveStrategy, fetchStrategy

// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/monitor.js
var monitor = __webpack_require__(64933);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/experimentalFeatures.js
var experimentalFeatures = __webpack_require__(57549);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/observable.js + 1 modules
var tools_observable = __webpack_require__(75721);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/byteUtils.js
var byteUtils = __webpack_require__(51962);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/timer.js
var timer = __webpack_require__(65483);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/timeUtils.js
var timeUtils = __webpack_require__(25026);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/responseUtils.js
var responseUtils = __webpack_require__(29100);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/error/error.types.js
var error_types = __webpack_require__(42419);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/transport/sendWithRetryStrategy.js





const MAX_ONGOING_BYTES_COUNT = 80 * byteUtils/* ONE_KIBI_BYTE */.Hi;
const MAX_ONGOING_REQUESTS = 32;
const MAX_QUEUE_BYTES_COUNT = 20 * byteUtils/* ONE_MEBI_BYTE */.X9;
const MAX_BACKOFF_TIME = timeUtils/* ONE_MINUTE */.yR;
const INITIAL_BACKOFF_TIME = timeUtils/* ONE_SECOND */.WT;
function sendWithRetryStrategy(payload, state, sendStrategy, trackType, reportError, requestObservable) {
    if (state.transportStatus === 0 /* TransportStatus.UP */ &&
        state.queuedPayloads.size() === 0 &&
        state.bandwidthMonitor.canHandle(payload)) {
        send(payload, state, sendStrategy, requestObservable, {
            onSuccess: () => retryQueuedPayloads(0 /* RetryReason.AFTER_SUCCESS */, state, sendStrategy, trackType, reportError, requestObservable),
            onFailure: () => {
                if (!state.queuedPayloads.enqueue(payload)) {
                    requestObservable.notify({ type: 'queue-full', bandwidth: state.bandwidthMonitor.stats(), payload });
                }
                scheduleRetry(state, sendStrategy, trackType, reportError, requestObservable);
            },
        });
    }
    else {
        if (!state.queuedPayloads.enqueue(payload)) {
            requestObservable.notify({ type: 'queue-full', bandwidth: state.bandwidthMonitor.stats(), payload });
        }
    }
}
function scheduleRetry(state, sendStrategy, trackType, reportError, requestObservable) {
    if (state.transportStatus !== 2 /* TransportStatus.DOWN */) {
        return;
    }
    (0,timer/* setTimeout */.iK)(() => {
        const payload = state.queuedPayloads.first();
        send(payload, state, sendStrategy, requestObservable, {
            onSuccess: () => {
                state.queuedPayloads.dequeue();
                state.currentBackoffTime = INITIAL_BACKOFF_TIME;
                retryQueuedPayloads(1 /* RetryReason.AFTER_RESUME */, state, sendStrategy, trackType, reportError, requestObservable);
            },
            onFailure: () => {
                state.currentBackoffTime = Math.min(MAX_BACKOFF_TIME, state.currentBackoffTime * 2);
                scheduleRetry(state, sendStrategy, trackType, reportError, requestObservable);
            },
        });
    }, state.currentBackoffTime);
}
function send(payload, state, sendStrategy, requestObservable, { onSuccess, onFailure }) {
    state.bandwidthMonitor.add(payload);
    sendStrategy(payload, (response) => {
        state.bandwidthMonitor.remove(payload);
        if (!shouldRetryRequest(response)) {
            state.transportStatus = 0 /* TransportStatus.UP */;
            requestObservable.notify({ type: 'success', bandwidth: state.bandwidthMonitor.stats(), payload });
            onSuccess();
        }
        else {
            // do not consider transport down if another ongoing request could succeed
            state.transportStatus =
                state.bandwidthMonitor.ongoingRequestCount > 0 ? 1 /* TransportStatus.FAILURE_DETECTED */ : 2 /* TransportStatus.DOWN */;
            payload.retry = {
                count: payload.retry ? payload.retry.count + 1 : 1,
                lastFailureStatus: response.status,
            };
            requestObservable.notify({ type: 'failure', bandwidth: state.bandwidthMonitor.stats(), payload });
            onFailure();
        }
    });
}
function retryQueuedPayloads(reason, state, sendStrategy, trackType, reportError, requestObservable) {
    if (reason === 0 /* RetryReason.AFTER_SUCCESS */ && state.queuedPayloads.isFull() && !state.queueFullReported) {
        reportError({
            message: `Reached max ${trackType} events size queued for upload: ${MAX_QUEUE_BYTES_COUNT / byteUtils/* ONE_MEBI_BYTE */.X9}MiB`,
            source: error_types/* ErrorSource.AGENT */.z.AGENT,
            startClocks: (0,timeUtils/* clocksNow */.$I)(),
        });
        state.queueFullReported = true;
    }
    const previousQueue = state.queuedPayloads;
    state.queuedPayloads = newPayloadQueue();
    while (previousQueue.size() > 0) {
        sendWithRetryStrategy(previousQueue.dequeue(), state, sendStrategy, trackType, reportError, requestObservable);
    }
}
function shouldRetryRequest(response) {
    return (response.type !== 'opaque' &&
        ((response.status === 0 && !navigator.onLine) ||
            response.status === 408 ||
            response.status === 429 ||
            (0,responseUtils/* isServerError */.o)(response.status)));
}
function newRetryState() {
    return {
        transportStatus: 0 /* TransportStatus.UP */,
        currentBackoffTime: INITIAL_BACKOFF_TIME,
        bandwidthMonitor: newBandwidthMonitor(),
        queuedPayloads: newPayloadQueue(),
        queueFullReported: false,
    };
}
function newPayloadQueue() {
    const queue = [];
    return {
        bytesCount: 0,
        enqueue(payload) {
            if (this.isFull()) {
                return false;
            }
            queue.push(payload);
            this.bytesCount += payload.bytesCount;
            return true;
        },
        first() {
            return queue[0];
        },
        dequeue() {
            const payload = queue.shift();
            if (payload) {
                this.bytesCount -= payload.bytesCount;
            }
            return payload;
        },
        size() {
            return queue.length;
        },
        isFull() {
            return this.bytesCount >= MAX_QUEUE_BYTES_COUNT;
        },
    };
}
function newBandwidthMonitor() {
    return {
        ongoingRequestCount: 0,
        ongoingByteCount: 0,
        canHandle(payload) {
            return (this.ongoingRequestCount === 0 ||
                (this.ongoingByteCount + payload.bytesCount <= MAX_ONGOING_BYTES_COUNT &&
                    this.ongoingRequestCount < MAX_ONGOING_REQUESTS));
        },
        add(payload) {
            this.ongoingRequestCount += 1;
            this.ongoingByteCount += payload.bytesCount;
        },
        remove(payload) {
            this.ongoingRequestCount -= 1;
            this.ongoingByteCount -= payload.bytesCount;
        },
        stats() {
            return {
                ongoingByteCount: this.ongoingByteCount,
                ongoingRequestCount: this.ongoingRequestCount,
            };
        },
    };
}
//# sourceMappingURL=sendWithRetryStrategy.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/transport/httpRequest.js





/**
 * beacon payload max queue size implementation is 64kb
 * ensure that we leave room for logs, rum and potential other users
 */
const RECOMMENDED_REQUEST_BYTES_LIMIT = 16 * byteUtils/* ONE_KIBI_BYTE */.Hi;
function createHttpRequest(endpointBuilders, reportError, bytesLimit = RECOMMENDED_REQUEST_BYTES_LIMIT) {
    const observable = new tools_observable/* Observable */.y$();
    const retryState = newRetryState();
    return {
        observable,
        send: (payload) => {
            for (const endpointBuilder of endpointBuilders) {
                sendWithRetryStrategy(payload, retryState, (payload, onResponse) => {
                    if ((0,experimentalFeatures/* isExperimentalFeatureEnabled */.W_)(experimentalFeatures/* ExperimentalFeature.AVOID_FETCH_KEEPALIVE */.uh.AVOID_FETCH_KEEPALIVE)) {
                        fetchStrategy(endpointBuilder, payload, onResponse);
                    }
                    else {
                        fetchKeepAliveStrategy(endpointBuilder, bytesLimit, payload, onResponse);
                    }
                }, endpointBuilder.trackType, reportError, observable);
            }
        },
        /**
         * Since fetch keepalive behaves like regular fetch on Firefox,
         * keep using sendBeaconStrategy on exit
         */
        sendOnExit: (payload) => {
            for (const endpointBuilder of endpointBuilders) {
                sendBeaconStrategy(endpointBuilder, bytesLimit, payload);
            }
        },
    };
}
function sendBeaconStrategy(endpointBuilder, bytesLimit, payload) {
    const canUseBeacon = !!navigator.sendBeacon && payload.bytesCount < bytesLimit;
    if (canUseBeacon) {
        try {
            const beaconUrl = endpointBuilder.build('beacon', payload);
            const isQueued = navigator.sendBeacon(beaconUrl, payload.data);
            if (isQueued) {
                return;
            }
        }
        catch (e) {
            reportBeaconError(e);
        }
    }
    fetchStrategy(endpointBuilder, payload);
}
let hasReportedBeaconError = false;
function reportBeaconError(e) {
    if (!hasReportedBeaconError) {
        hasReportedBeaconError = true;
        (0,monitor/* monitorError */.$y)(e);
    }
}
function fetchKeepAliveStrategy(endpointBuilder, bytesLimit, payload, onResponse) {
    const canUseKeepAlive = isKeepAliveSupported() && payload.bytesCount < bytesLimit;
    if (canUseKeepAlive) {
        const fetchUrl = endpointBuilder.build('fetch-keepalive', payload);
        fetch(fetchUrl, { method: 'POST', body: payload.data, keepalive: true, mode: 'cors' })
            .then((0,monitor/* monitor */.zk)((response) => onResponse === null || onResponse === void 0 ? void 0 : onResponse({ status: response.status, type: response.type })))
            .catch((0,monitor/* monitor */.zk)(() => fetchStrategy(endpointBuilder, payload, onResponse)));
    }
    else {
        fetchStrategy(endpointBuilder, payload, onResponse);
    }
}
function fetchStrategy(endpointBuilder, payload, onResponse) {
    const fetchUrl = endpointBuilder.build('fetch', payload);
    fetch(fetchUrl, { method: 'POST', body: payload.data, mode: 'cors' })
        .then((0,monitor/* monitor */.zk)((response) => onResponse === null || onResponse === void 0 ? void 0 : onResponse({ status: response.status, type: response.type })))
        .catch((0,monitor/* monitor */.zk)(() => onResponse === null || onResponse === void 0 ? void 0 : onResponse({ status: 0 })));
}
function isKeepAliveSupported() {
    // Request can throw, cf https://developer.mozilla.org/en-US/docs/Web/API/Request/Request#errors
    try {
        return window.Request && 'keepalive' in new Request('http://a');
    }
    catch (_a) {
        return false;
    }
}
//# sourceMappingURL=httpRequest.js.map

/***/ }),

/***/ 20478:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Us": function() { return /* reexport */ ActionType; },
  "Xn": function() { return /* reexport */ CENSORED_IMG_MARK; },
  "k6": function() { return /* reexport */ CENSORED_STRING_MARK; },
  "zx": function() { return /* reexport */ NodePrivacyLevel; },
  "$n": function() { return /* reexport */ PRIVACY_ATTR_NAME; },
  "nw": function() { return /* reexport */ PRIVACY_ATTR_VALUE_HIDDEN; },
  "D$": function() { return /* reexport */ RumEventType; },
  "uo": function() { return /* reexport */ RumPerformanceEntryType; },
  "QB": function() { return /* reexport */ createFormDataTransport; },
  "Uo": function() { return /* reexport */ forEachChildNodes; },
  "q5": function() { return /* reexport */ getMutationObserverConstructor; },
  "IE": function() { return /* reexport */ getNodePrivacyLevel; },
  "SZ": function() { return /* reexport */ getNodeSelfPrivacyLevel; },
  "Ow": function() { return /* reexport */ getParentNode; },
  "$1": function() { return /* reexport */ getScrollX; },
  "X_": function() { return /* reexport */ getScrollY; },
  "Gm": function() { return /* reexport */ getSessionReplayUrl; },
  "FB": function() { return /* reexport */ getTextContent; },
  "PA": function() { return /* reexport */ getViewportDimension; },
  "Sn": function() { return /* reexport */ hasChildNodes; },
  "AX": function() { return /* reexport */ initViewportObservable; },
  "aT": function() { return /* reexport */ isNodeShadowHost; },
  "VO": function() { return /* reexport */ isNodeShadowRoot; },
  "HR": function() { return /* reexport */ isSampled; },
  "_r": function() { return /* reexport */ makeRumPublicApi; },
  "Ch": function() { return /* reexport */ reducePrivacyLevel; },
  "Pu": function() { return /* reexport */ sanitizeIfLongDataUrl; },
  "vv": function() { return /* reexport */ shouldMaskAttribute; },
  "gR": function() { return /* reexport */ shouldMaskNode; },
  "iB": function() { return /* reexport */ startRum; },
  "wM": function() { return /* reexport */ supportPerformanceTimingEvent; }
});

// UNUSED EXPORTS: DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE, FORM_PRIVATE_TAG_NAMES, FrustrationType, LifeCycle, PRIVACY_ATTR_VALUE_ALLOW, PRIVACY_ATTR_VALUE_MASK, PRIVACY_ATTR_VALUE_MASK_UNLESS_ALLOWLISTED, PRIVACY_ATTR_VALUE_MASK_USER_INPUT, PRIVACY_CLASS_PREFIX, STABLE_ATTRIBUTES, TEXT_MASKING_CHAR, createHooks, getPrivacySelector, isAllowlisted, isCommentNode, isElementNode, isTextNode, maskDisallowedTextContent, shouldIgnoreElement, startViewHistory

// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/trackingConsent.js
var trackingConsent = __webpack_require__(92988);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/observable.js + 1 modules
var tools_observable = __webpack_require__(75721);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/instrumentMethod.js
var instrumentMethod = __webpack_require__(55801);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/timeUtils.js
var timeUtils = __webpack_require__(25026);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/stackTrace/computeStackTrace.js
var computeStackTrace = __webpack_require__(22685);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/globalObject.js
var globalObject = __webpack_require__(51145);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/error/error.js
var error_error = __webpack_require__(45242);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/error/error.types.js
var error_types = __webpack_require__(42419);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/error/trackRuntimeError.js







function trackRuntimeError() {
    return new tools_observable/* Observable */.y$((observer) => {
        const handleRuntimeError = (originalError, stackTrace) => {
            const rawError = (0,error_error/* computeRawError */.AP)({
                stackTrace,
                originalError,
                startClocks: (0,timeUtils/* clocksNow */.$I)(),
                nonErrorPrefix: "Uncaught" /* NonErrorPrefix.UNCAUGHT */,
                source: error_types/* ErrorSource.SOURCE */.z.SOURCE,
                handling: "unhandled" /* ErrorHandling.UNHANDLED */,
            });
            observer.notify(rawError);
        };
        const { stop: stopInstrumentingOnError } = instrumentOnError(handleRuntimeError);
        const { stop: stopInstrumentingOnUnhandledRejection } = instrumentUnhandledRejection(handleRuntimeError);
        return () => {
            stopInstrumentingOnError();
            stopInstrumentingOnUnhandledRejection();
        };
    });
}
function instrumentOnError(callback) {
    return (0,instrumentMethod/* instrumentMethod */.S)((0,globalObject/* getGlobalObject */.Rf)(), 'onerror', ({ parameters: [messageObj, url, line, column, errorObj] }) => {
        let stackTrace;
        if (!(0,error_error/* isError */.VZ)(errorObj)) {
            stackTrace = (0,computeStackTrace/* computeStackTraceFromOnErrorMessage */.f)(messageObj, url, line, column);
        }
        callback(errorObj !== null && errorObj !== void 0 ? errorObj : messageObj, stackTrace);
    });
}
function instrumentUnhandledRejection(callback) {
    return (0,instrumentMethod/* instrumentMethod */.S)((0,globalObject/* getGlobalObject */.Rf)(), 'onunhandledrejection', ({ parameters: [e] }) => {
        callback(e.reason || 'Empty reason');
    });
}
//# sourceMappingURL=trackRuntimeError.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/bufferedData.js


const BUFFER_LIMIT = 500;
function startBufferingData(trackRuntimeErrorImpl = trackRuntimeError) {
    const observable = new tools_observable/* BufferedObservable */.fk(BUFFER_LIMIT);
    const runtimeErrorSubscription = trackRuntimeErrorImpl().subscribe((error) => {
        observable.notify({
            type: 0 /* BufferedDataType.RUNTIME_ERROR */,
            error,
        });
    });
    return {
        observable,
        stop: () => {
            runtimeErrorSubscription.unsubscribe();
        },
    };
}
//# sourceMappingURL=bufferedData.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/byteUtils.js
var byteUtils = __webpack_require__(51962);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/encoder.js

function createIdentityEncoder() {
    let output = '';
    let outputBytesCount = 0;
    return {
        isAsync: false,
        get isEmpty() {
            return !output;
        },
        write(data, callback) {
            const additionalEncodedBytesCount = (0,byteUtils/* computeBytesCount */.qt)(data);
            outputBytesCount += additionalEncodedBytesCount;
            output += data;
            if (callback) {
                callback(additionalEncodedBytesCount);
            }
        },
        finish(callback) {
            callback(this.finishSync());
        },
        finishSync() {
            const result = {
                output,
                outputBytesCount,
                rawBytesCount: outputBytesCount,
                pendingData: '',
            };
            output = '';
            outputBytesCount = 0;
            return result;
        },
        estimateEncodedBytesCount(data) {
            return data.length;
        },
    };
}
//# sourceMappingURL=encoder.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/monitor.js
var monitor = __webpack_require__(64933);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/telemetry/telemetry.js + 1 modules
var telemetry_telemetry = __webpack_require__(18797);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/boot/init.js
var init = __webpack_require__(8678);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/mergeInto.js
var mergeInto = __webpack_require__(92904);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/stackTrace/handlingStack.js
var stackTrace_handlingStack = __webpack_require__(24507);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/serialisation/sanitize.js
var sanitize = __webpack_require__(68566);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/context/defineContextMethod.js


function defineContextMethod(getStrategy, contextName, methodName, usage) {
    return (0,monitor/* monitor */.zk)((...args) => {
        if (usage) {
            (0,telemetry_telemetry/* addTelemetryUsage */.eG)({ feature: usage });
        }
        return getStrategy()[contextName][methodName](...args);
    });
}
function bufferContextCalls(preStartContextManager, name, bufferApiCalls) {
    preStartContextManager.changeObservable.subscribe(() => {
        const context = preStartContextManager.getContext();
        bufferApiCalls.add((startResult) => startResult[name].setContext(context));
    });
}
//# sourceMappingURL=defineContextMethod.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/context/contextConstants.js
// Use a const instead of const enum to avoid inlining the enum values in the bundle and save bytes
const CustomerContextKey = {
    userContext: 'userContext',
    globalContext: 'globalContext',
    accountContext: 'accountContext',
};
// Use a const instead of const enum to avoid inlining the enum values in the bundle and save bytes
const ContextManagerMethod = {
    getContext: 'getContext',
    setContext: 'setContext',
    setContextProperty: 'setContextProperty',
    removeContextProperty: 'removeContextProperty',
    clearContext: 'clearContext',
};
//# sourceMappingURL=contextConstants.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/display.js
var display = __webpack_require__(13842);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/boot/displayAlreadyInitializedError.js

function displayAlreadyInitializedError(sdkName, initConfiguration) {
    if (!initConfiguration.silentMultipleInit) {
        display/* display.error */.jf.error(`${sdkName} is already initialized.`);
    }
}
//# sourceMappingURL=displayAlreadyInitializedError.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/rawRumEvent.types.js
const RumEventType = {
    ACTION: 'action',
    ERROR: 'error',
    LONG_TASK: 'long_task',
    VIEW: 'view',
    RESOURCE: 'resource',
    VITAL: 'vital',
};
const RumLongTaskEntryType = {
    LONG_TASK: 'long-task',
    LONG_ANIMATION_FRAME: 'long-animation-frame',
};
const ViewLoadingType = {
    INITIAL_LOAD: 'initial_load',
    ROUTE_CHANGE: 'route_change',
    BF_CACHE: 'bf_cache',
};
const ActionType = {
    CLICK: 'click',
    CUSTOM: 'custom',
};
const FrustrationType = {
    RAGE_CLICK: 'rage_click',
    ERROR_CLICK: 'error_click',
    DEAD_CLICK: 'dead_click',
};
const VitalType = {
    DURATION: 'duration',
    OPERATION_STEP: 'operation_step',
};
//# sourceMappingURL=rawRumEvent.types.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/experimentalFeatures.js
var experimentalFeatures = __webpack_require__(57549);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/stringUtils.js
var stringUtils = __webpack_require__(88129);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/vital/vitalCollection.js


function createCustomVitalsState() {
    const vitalsByName = new Map();
    const vitalsByReference = new WeakMap();
    return { vitalsByName, vitalsByReference };
}
function startVitalCollection(lifeCycle, pageStateHistory, customVitalsState) {
    function isValid(vital) {
        return !pageStateHistory.wasInPageStateDuringPeriod("frozen" /* PageState.FROZEN */, vital.startClocks.relative, vital.duration);
    }
    function addDurationVital(vital) {
        if (isValid(vital)) {
            lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, processVital(vital));
        }
    }
    function addOperationStepVital(name, stepType, options, failureReason) {
        if (!(0,experimentalFeatures/* isExperimentalFeatureEnabled */.W_)(experimentalFeatures/* ExperimentalFeature.FEATURE_OPERATION_VITAL */.uh.FEATURE_OPERATION_VITAL)) {
            return;
        }
        const { operationKey, context, description } = options || {};
        const vital = {
            name,
            type: VitalType.OPERATION_STEP,
            operationKey,
            failureReason,
            stepType,
            startClocks: (0,timeUtils/* clocksNow */.$I)(),
            context: (0,sanitize/* sanitize */.N)(context),
            description,
        };
        lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, processVital(vital));
    }
    return {
        addOperationStepVital,
        addDurationVital,
        startDurationVital: (name, options = {}) => startDurationVital(customVitalsState, name, options),
        stopDurationVital: (nameOrRef, options = {}) => {
            stopDurationVital(addDurationVital, customVitalsState, nameOrRef, options);
        },
    };
}
function startDurationVital({ vitalsByName, vitalsByReference }, name, options = {}) {
    const vital = {
        name,
        startClocks: (0,timeUtils/* clocksNow */.$I)(),
        ...options,
    };
    // To avoid leaking implementation details of the vital, we return a reference to it.
    const reference = { __dd_vital_reference: true };
    vitalsByName.set(name, vital);
    // To avoid memory leaks caused by the creation of numerous references (e.g., from improper useEffect implementations), we use a WeakMap.
    vitalsByReference.set(reference, vital);
    return reference;
}
function stopDurationVital(stopCallback, { vitalsByName, vitalsByReference }, nameOrRef, options = {}) {
    const vitalStart = typeof nameOrRef === 'string' ? vitalsByName.get(nameOrRef) : vitalsByReference.get(nameOrRef);
    if (!vitalStart) {
        return;
    }
    stopCallback(buildDurationVital(vitalStart, vitalStart.startClocks, options, (0,timeUtils/* clocksNow */.$I)()));
    if (typeof nameOrRef === 'string') {
        vitalsByName.delete(nameOrRef);
    }
    else {
        vitalsByReference.delete(nameOrRef);
    }
}
function buildDurationVital(vitalStart, startClocks, stopOptions, stopClocks) {
    var _a;
    return {
        name: vitalStart.name,
        type: VitalType.DURATION,
        startClocks,
        duration: (0,timeUtils/* elapsed */._J)(startClocks.timeStamp, stopClocks.timeStamp),
        context: (0,mergeInto/* combine */.$e)(vitalStart.context, stopOptions.context),
        description: (_a = stopOptions.description) !== null && _a !== void 0 ? _a : vitalStart.description,
    };
}
function processVital(vital) {
    const { startClocks, type, name, description, context } = vital;
    const vitalData = {
        id: (0,stringUtils/* generateUUID */.DO)(),
        type,
        name,
        description,
        ...(type === VitalType.DURATION
            ? { duration: (0,timeUtils/* toServerDuration */.c0)(vital.duration) }
            : {
                step_type: vital.stepType,
                operation_key: vital.operationKey,
                failure_reason: vital.failureReason,
            }),
    };
    return {
        rawRumEvent: {
            date: startClocks.timeStamp,
            vital: vitalData,
            type: RumEventType.VITAL,
            context,
        },
        startTime: startClocks.relative,
        duration: type === VitalType.DURATION ? vital.duration : undefined,
        domainContext: {},
    };
}
//# sourceMappingURL=vitalCollection.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/plugins.js
function callPluginsMethod(plugins, methodName, parameter) {
    if (!plugins) {
        return;
    }
    for (const plugin of plugins) {
        const method = plugin[methodName];
        if (method) {
            method(parameter);
        }
    }
}
//# sourceMappingURL=plugins.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/arrayUtils.js
function removeDuplicates(array) {
    const set = new Set();
    array.forEach((item) => set.add(item));
    return Array.from(set);
}
function removeItem(array, item) {
    const index = array.indexOf(item);
    if (index >= 0) {
        array.splice(index, 1);
    }
}
function isNonEmptyArray(value) {
    return Array.isArray(value) && value.length > 0;
}
//# sourceMappingURL=arrayUtils.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/boundedBuffer.js

const boundedBuffer_BUFFER_LIMIT = 500;
/**
 * createBoundedBuffer creates a BoundedBuffer.
 *
 * @deprecated Use `BufferedObservable` instead.
 */
function createBoundedBuffer() {
    const buffer = [];
    const add = (callback) => {
        const length = buffer.push(callback);
        if (length > boundedBuffer_BUFFER_LIMIT) {
            buffer.splice(0, 1);
        }
    };
    const remove = (callback) => {
        removeItem(buffer, callback);
    };
    const drain = (arg) => {
        buffer.forEach((callback) => callback(arg));
        buffer.length = 0;
    };
    return {
        add,
        remove,
        drain,
    };
}
//# sourceMappingURL=boundedBuffer.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/browser/addEventListener.js
var addEventListener = __webpack_require__(83206);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/objectUtils.js
var objectUtils = __webpack_require__(94162);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/context/storeContextManager.js



const CONTEXT_STORE_KEY_PREFIX = '_dd_c';
const storageListeners = [];
function storeContextManager(configuration, contextManager, productKey, customerDataType) {
    const storageKey = buildStorageKey(productKey, customerDataType);
    storageListeners.push((0,addEventListener/* addEventListener */.O)(configuration, window, "storage" /* DOM_EVENT.STORAGE */, ({ key }) => {
        if (storageKey === key) {
            synchronizeWithStorage();
        }
    }));
    contextManager.changeObservable.subscribe(dumpToStorage);
    const contextFromStorage = (0,mergeInto/* combine */.$e)(getFromStorage(), contextManager.getContext());
    if (!(0,objectUtils/* isEmptyObject */.Qr)(contextFromStorage)) {
        contextManager.setContext(contextFromStorage);
    }
    function synchronizeWithStorage() {
        contextManager.setContext(getFromStorage());
    }
    function dumpToStorage() {
        localStorage.setItem(storageKey, JSON.stringify(contextManager.getContext()));
    }
    function getFromStorage() {
        const rawContext = localStorage.getItem(storageKey);
        return rawContext ? JSON.parse(rawContext) : {};
    }
}
function buildStorageKey(productKey, customerDataType) {
    return `${CONTEXT_STORE_KEY_PREFIX}_${productKey}_${customerDataType}`;
}
function removeStorageListeners() {
    storageListeners.map((listener) => listener.stop());
}
//# sourceMappingURL=storeContextManager.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/typeUtils.js
var typeUtils = __webpack_require__(33234);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/context/contextUtils.js


/**
 * Simple check to ensure an object is a valid context
 */
function checkContext(maybeContext) {
    const isValid = (0,typeUtils/* getType */.o)(maybeContext) === 'object';
    if (!isValid) {
        display/* display.error */.jf.error('Unsupported context:', maybeContext);
    }
    return isValid;
}
//# sourceMappingURL=contextUtils.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/context/contextManager.js





function ensureProperties(context, propertiesConfig, name) {
    const newContext = { ...context };
    for (const [key, { required, type }] of Object.entries(propertiesConfig)) {
        /**
         * Ensure specified properties are strings as defined here:
         * https://docs.datadoghq.com/logs/log_configuration/attributes_naming_convention/#user-related-attributes
         */
        if (type === 'string' && !isDefined(newContext[key])) {
            /* eslint-disable @typescript-eslint/no-base-to-string */
            newContext[key] = String(newContext[key]);
        }
        if (required && isDefined(newContext[key])) {
            display/* display.warn */.jf.warn(`The property ${key} of ${name} is required; context will not be sent to the intake.`);
        }
    }
    return newContext;
}
function isDefined(value) {
    return value === undefined || value === null || value === '';
}
function createContextManager(name = '', { propertiesConfig = {}, } = {}) {
    let context = {};
    const changeObservable = new tools_observable/* Observable */.y$();
    const contextManager = {
        getContext: () => (0,mergeInto/* deepClone */.I8)(context),
        setContext: (newContext) => {
            if (checkContext(newContext)) {
                context = (0,sanitize/* sanitize */.N)(ensureProperties(newContext, propertiesConfig, name));
            }
            else {
                contextManager.clearContext();
            }
            changeObservable.notify();
        },
        setContextProperty: (key, property) => {
            context = (0,sanitize/* sanitize */.N)(ensureProperties({ ...context, [key]: property }, propertiesConfig, name));
            changeObservable.notify();
        },
        removeContextProperty: (key) => {
            delete context[key];
            ensureProperties(context, propertiesConfig, name);
            changeObservable.notify();
        },
        clearContext: () => {
            context = {};
            changeObservable.notify();
        },
        changeObservable,
    };
    return contextManager;
}
//# sourceMappingURL=contextManager.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/contexts/globalContext.js


function startGlobalContext(hooks, configuration, productKey, useContextNamespace) {
    const globalContextManager = buildGlobalContextManager();
    if (configuration.storeContextsAcrossPages) {
        storeContextManager(configuration, globalContextManager, productKey, 2 /* CustomerDataType.GlobalContext */);
    }
    hooks.register(0 /* HookNames.Assemble */, () => {
        const context = globalContextManager.getContext();
        return useContextNamespace ? { context } : context;
    });
    return globalContextManager;
}
function buildGlobalContextManager() {
    return createContextManager('global context');
}
//# sourceMappingURL=globalContext.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/abstractHooks.js
var abstractHooks = __webpack_require__(89643);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/contexts/userContext.js




function startUserContext(hooks, configuration, sessionManager, productKey) {
    const userContextManager = buildUserContextManager();
    if (configuration.storeContextsAcrossPages) {
        storeContextManager(configuration, userContextManager, productKey, 1 /* CustomerDataType.User */);
    }
    hooks.register(0 /* HookNames.Assemble */, ({ eventType, startTime }) => {
        const user = userContextManager.getContext();
        const session = sessionManager.findTrackedSession(startTime);
        if (session && session.anonymousId && !user.anonymous_id && !!configuration.trackAnonymousUser) {
            user.anonymous_id = session.anonymousId;
        }
        if ((0,objectUtils/* isEmptyObject */.Qr)(user)) {
            return abstractHooks/* SKIPPED */.kb;
        }
        return {
            type: eventType,
            usr: user,
        };
    });
    hooks.register(1 /* HookNames.AssembleTelemetry */, ({ startTime }) => {
        var _a;
        return ({
            anonymous_id: (_a = sessionManager.findTrackedSession(startTime)) === null || _a === void 0 ? void 0 : _a.anonymousId,
        });
    });
    return userContextManager;
}
function buildUserContextManager() {
    return createContextManager('user', {
        propertiesConfig: {
            id: { type: 'string' },
            name: { type: 'string' },
            email: { type: 'string' },
        },
    });
}
//# sourceMappingURL=userContext.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/contexts/accountContext.js




function startAccountContext(hooks, configuration, productKey) {
    const accountContextManager = buildAccountContextManager();
    if (configuration.storeContextsAcrossPages) {
        storeContextManager(configuration, accountContextManager, productKey, 4 /* CustomerDataType.Account */);
    }
    hooks.register(0 /* HookNames.Assemble */, () => {
        const account = accountContextManager.getContext();
        if ((0,objectUtils/* isEmptyObject */.Qr)(account) || !account.id) {
            return abstractHooks/* SKIPPED */.kb;
        }
        return {
            account,
        };
    });
    return accountContextManager;
}
function buildAccountContextManager() {
    return createContextManager('account', {
        propertiesConfig: {
            id: { type: 'string', required: true },
            name: { type: 'string' },
        },
    });
}
//# sourceMappingURL=accountContext.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/transport/eventBridge.js
var eventBridge = __webpack_require__(76876);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/functionUtils.js
var functionUtils = __webpack_require__(251);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/urlPolyfill.js
var urlPolyfill = __webpack_require__(70170);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/readBytesFromStream.js


/**
 * Read bytes from a ReadableStream until the end of the stream.
 * Returns the bytes if collectStreamBody is true, otherwise returns undefined.
 */
async function readBytesFromStream(stream, options) {
    const reader = stream.getReader();
    const chunks = [];
    while (true) {
        const result = await reader.read();
        if (result.done) {
            break;
        }
        if (options.collectStreamBody) {
            chunks.push(result.value);
        }
    }
    reader.cancel().catch(
    // we don't care if cancel fails, but we still need to catch the error to avoid reporting it
    // as an unhandled rejection
    functionUtils/* noop */.Z);
    return options.collectStreamBody ? (0,byteUtils/* concatBuffers */.Kb)(chunks) : undefined;
}
//# sourceMappingURL=readBytesFromStream.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/responseUtils.js
var responseUtils = __webpack_require__(29100);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/browser/fetchObservable.js








let fetchObservable;
const responseBodyActionGetters = [];
function initFetchObservable({ responseBodyAction } = {}) {
    if (responseBodyAction) {
        responseBodyActionGetters.push(responseBodyAction);
    }
    if (!fetchObservable) {
        fetchObservable = createFetchObservable();
    }
    return fetchObservable;
}
function resetFetchObservable() {
    fetchObservable = undefined;
    responseBodyActionGetters.length = 0;
}
function createFetchObservable() {
    return new tools_observable/* Observable */.y$((observable) => {
        if (!globalObject/* globalObject.fetch */.Zf.fetch) {
            return;
        }
        const { stop } = (0,instrumentMethod/* instrumentMethod */.S)(globalObject/* globalObject */.Zf, 'fetch', (call) => beforeSend(call, observable), {
            computeHandlingStack: true,
        });
        return stop;
    });
}
function beforeSend({ parameters, onPostCall, handlingStack }, observable) {
    const [input, init] = parameters;
    let methodFromParams = init && init.method;
    if (methodFromParams === undefined && input instanceof Request) {
        methodFromParams = input.method;
    }
    const method = methodFromParams !== undefined ? String(methodFromParams).toUpperCase() : 'GET';
    const url = input instanceof Request ? input.url : (0,urlPolyfill/* normalizeUrl */.D5)(String(input));
    const startClocks = (0,timeUtils/* clocksNow */.$I)();
    const context = {
        state: 'start',
        init,
        input,
        method,
        startClocks,
        url,
        handlingStack,
    };
    observable.notify(context);
    // Those properties can be changed by observable subscribers
    parameters[0] = context.input;
    parameters[1] = context.init;
    onPostCall((responsePromise) => {
        afterSend(observable, responsePromise, context).catch(monitor/* monitorError */.$y);
    });
}
async function afterSend(observable, responsePromise, startContext) {
    var _a, _b;
    const context = startContext;
    context.state = 'resolve';
    let response;
    try {
        response = await responsePromise;
    }
    catch (error) {
        context.status = 0;
        context.isAborted =
            ((_b = (_a = context.init) === null || _a === void 0 ? void 0 : _a.signal) === null || _b === void 0 ? void 0 : _b.aborted) || (error instanceof DOMException && error.code === DOMException.ABORT_ERR);
        context.error = error;
        observable.notify(context);
        return;
    }
    context.response = response;
    context.status = response.status;
    context.responseType = response.type;
    context.isAborted = false;
    const responseBodyCondition = responseBodyActionGetters.reduce((action, getter) => Math.max(action, getter(context)), 0 /* ResponseBodyAction.IGNORE */);
    if (responseBodyCondition !== 0 /* ResponseBodyAction.IGNORE */) {
        const clonedResponse = (0,responseUtils/* tryToClone */.u)(response);
        if (clonedResponse && clonedResponse.body) {
            try {
                const bytes = await readBytesFromStream(clonedResponse.body, {
                    collectStreamBody: responseBodyCondition === 2 /* ResponseBodyAction.COLLECT */,
                });
                context.responseBody = bytes && new TextDecoder().decode(bytes);
            }
            catch (_c) {
                // Ignore errors when reading the response body (e.g., stream aborted, network errors)
                // This is not critical and should not be reported as an SDK error
            }
        }
    }
    observable.notify(context);
}
//# sourceMappingURL=fetchObservable.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/browser/cookie.js
var cookie = __webpack_require__(49647);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/synthetics/syntheticsWorkerValues.js


const SYNTHETICS_TEST_ID_COOKIE_NAME = 'datadog-synthetics-public-id';
const SYNTHETICS_RESULT_ID_COOKIE_NAME = 'datadog-synthetics-result-id';
const SYNTHETICS_INJECTS_RUM_COOKIE_NAME = 'datadog-synthetics-injects-rum';
function willSyntheticsInjectRum() {
    if (globalObject/* isWorkerEnvironment */.jX) {
        // We don't expect to run synthetics tests in a worker environment
        return false;
    }
    return Boolean(globalObject/* globalObject._DATADOG_SYNTHETICS_INJECTS_RUM */.Zf._DATADOG_SYNTHETICS_INJECTS_RUM || (0,cookie/* getInitCookie */.OC)(SYNTHETICS_INJECTS_RUM_COOKIE_NAME));
}
function getSyntheticsTestId() {
    const value = window._DATADOG_SYNTHETICS_PUBLIC_ID || (0,cookie/* getInitCookie */.OC)(SYNTHETICS_TEST_ID_COOKIE_NAME);
    return typeof value === 'string' ? value : undefined;
}
function getSyntheticsResultId() {
    const value = window._DATADOG_SYNTHETICS_RESULT_ID || (0,cookie/* getInitCookie */.OC)(SYNTHETICS_RESULT_ID_COOKIE_NAME);
    return typeof value === 'string' ? value : undefined;
}
function isSyntheticsTest() {
    return Boolean(getSyntheticsTestId() && getSyntheticsResultId());
}
//# sourceMappingURL=syntheticsWorkerValues.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/configuration/configuration.js + 2 modules
var configuration_configuration = __webpack_require__(18769);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/numberUtils.js
var numberUtils = __webpack_require__(73603);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/matchOption.js
var matchOption = __webpack_require__(95562);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/polyfills.js
var polyfills = __webpack_require__(94776);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/sampler/sampler.js

const sampleDecisionCache = new Map();
function isSampled(sessionId, sampleRate) {
    // Shortcuts for common cases. This is not strictly necessary, but it makes the code faster for
    // customers willing to ingest all traces.
    if (sampleRate === 100) {
        return true;
    }
    if (sampleRate === 0) {
        return false;
    }
    const cachedDecision = sampleDecisionCache.get(sampleRate);
    if (cachedDecision && sessionId === cachedDecision.sessionId) {
        return cachedDecision.decision;
    }
    let decision;
    // @ts-expect-error BigInt might not be defined in every browser we support
    if (window.BigInt) {
        decision = sampleUsingKnuthFactor(BigInt(`0x${sessionId.split('-')[4]}`), sampleRate);
    }
    else {
        // For simplicity, we don't use consistent sampling for browser without BigInt support
        // TODO: remove this when all browser we support have BigInt support
        decision = (0,numberUtils/* performDraw */.y7)(sampleRate);
    }
    sampleDecisionCache.set(sampleRate, { sessionId, decision });
    return decision;
}
// Exported for tests
function resetSampleDecisionCache() {
    sampleDecisionCache.clear();
}
/**
 * Perform sampling using the Knuth factor method. This method offer consistent sampling result
 * based on the provided identifier.
 *
 * @param identifier - The identifier to use for sampling.
 * @param sampleRate - The sample rate in percentage between 0 and 100.
 */
function sampleUsingKnuthFactor(identifier, sampleRate) {
    // The formula is:
    //
    //   (identifier * knuthFactor) % 2^64 < sampleRate * 2^64
    //
    // Because JavaScript numbers are 64-bit floats, we can't represent 64-bit integers, and the
    // modulo would be incorrect. Thus, we are using BigInts here.
    //
    // Implementation in other languages:
    // * Go     https://github.com/DataDog/dd-trace-go/blob/ec6fbb1f2d517b7b8e69961052adf7136f3af773/ddtrace/tracer/sampler.go#L86-L91
    // * Python https://github.com/DataDog/dd-trace-py/blob/0cee2f066fb6e79aa15947c1514c0f406dea47c5/ddtrace/sampling_rule.py#L197
    // * Ruby   https://github.com/DataDog/dd-trace-rb/blob/1a6e255cdcb7e7e22235ea5955f90f6dfa91045d/lib/datadog/tracing/sampling/rate_sampler.rb#L42
    // * C++    https://github.com/DataDog/dd-trace-cpp/blob/159629edc438ae45f2bb318eb7bd51abd05e94b5/src/datadog/trace_sampler.cpp#L58
    // * Java   https://github.com/DataDog/dd-trace-java/blob/896dd6b380533216e0bdee59614606c8272d313e/dd-trace-core/src/main/java/datadog/trace/common/sampling/DeterministicSampler.java#L48
    //
    // Note: All implementations have slight variations. Some of them use '<=' instead of '<', and
    // use `sampleRate * 2^64 - 1` instead of `sampleRate * 2^64`. The following implementation
    // should adhere to the spec and is a bit simpler than using a 2^64-1 limit as there are less
    // BigInt arithmetic to write. In practice this does not matter, as we are using floating point
    // numbers in the end, and Number(2n**64n-1n) === Number(2n**64n).
    const knuthFactor = BigInt('1111111111111111111');
    const twoPow64 = BigInt('0x10000000000000000'); // 2n ** 64n
    const hash = (identifier * knuthFactor) % twoPow64;
    return Number(hash) <= (sampleRate / 100) * Number(twoPow64);
}
//# sourceMappingURL=sampler.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/tracing/identifier.js
function createTraceIdentifier() {
    return createIdentifier(64);
}
function createSpanIdentifier() {
    return createIdentifier(63);
}
function createIdentifier(bits) {
    const buffer = crypto.getRandomValues(new Uint32Array(2));
    if (bits === 63) {
        // eslint-disable-next-line no-bitwise
        buffer[buffer.length - 1] >>>= 1; // force 63-bit
    }
    // The `.toString` function is intentionally similar to Number and BigInt `.toString` method.
    //
    // JavaScript numbers can represent integers up to 48 bits, this is why we need two of them to
    // represent a 64 bits identifier. But BigInts don't have this limitation and can represent larger
    // integer values.
    //
    // In the future, when we drop browsers without BigInts support, we could use BigInts directly
    // represent identifiers by simply returning a BigInt from this function (as all we need is a
    // value with a `.toString` method).
    //
    // Examples:
    //   const buffer = getCrypto().getRandomValues(new Uint32Array(2))
    //   return BigInt(buffer[0]) + BigInt(buffer[1]) << 32n
    //
    //   // Alternative with BigUint64Array (different Browser support than plain bigints!):
    //   return crypto.getRandomValues(new BigUint64Array(1))[0]
    //
    // For now, let's keep using two plain numbers as having two different implementations (one for
    // browsers with BigInt support and one for older browsers) don't bring much value.
    return {
        toString(radix = 10) {
            let high = buffer[1];
            let low = buffer[0];
            let str = '';
            do {
                const mod = (high % radix) * 4294967296 + low;
                high = Math.floor(high / radix);
                low = Math.floor(mod / radix);
                str = (mod % radix).toString(radix) + str;
            } while (high || low);
            return str;
        },
    };
}
function toPaddedHexadecimalString(id) {
    return id.toString(16).padStart(16, '0');
}
//# sourceMappingURL=identifier.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/tracing/tracer.js



function isTracingOption(item) {
    const expectedItem = item;
    return ((0,typeUtils/* getType */.o)(expectedItem) === 'object' &&
        (0,matchOption/* isMatchOption */.o)(expectedItem.match) &&
        Array.isArray(expectedItem.propagatorTypes));
}
/**
 * Clear tracing information to avoid incomplete traces. Ideally, we should do it when the
 * request did not reach the server, but the browser does not expose this. So, we clear tracing
 * information if the request ended with status 0 without being aborted by the application.
 *
 * Reasoning:
 *
 * * Applications are usually aborting requests after a bit of time, for example when the user is
 * typing (autocompletion) or navigating away (in a SPA). With a performant device and good
 * network conditions, the request is likely to reach the server before being canceled.
 *
 * * Requests aborted otherwise (ex: lack of internet, CORS issue, blocked by a privacy extension)
 * are likely to finish quickly and without reaching the server.
 *
 * Of course, it might not be the case every time, but it should limit having incomplete traces a
 * bit.
 * */
function clearTracingIfNeeded(context) {
    if (context.status === 0 && !context.isAborted) {
        context.traceId = undefined;
        context.spanId = undefined;
        context.traceSampled = undefined;
    }
}
function startTracer(configuration, sessionManager, userContext, accountContext) {
    return {
        clearTracingIfNeeded,
        traceFetch: (context) => injectHeadersIfTracingAllowed(configuration, context, sessionManager, userContext, accountContext, (tracingHeaders) => {
            var _a;
            if (context.input instanceof Request && !((_a = context.init) === null || _a === void 0 ? void 0 : _a.headers)) {
                context.input = new Request(context.input);
                Object.keys(tracingHeaders).forEach((key) => {
                    ;
                    context.input.headers.append(key, tracingHeaders[key]);
                });
            }
            else {
                context.init = (0,objectUtils/* shallowClone */.mv)(context.init);
                const headers = [];
                if (context.init.headers instanceof Headers) {
                    context.init.headers.forEach((value, key) => {
                        headers.push([key, value]);
                    });
                }
                else if (Array.isArray(context.init.headers)) {
                    context.init.headers.forEach((header) => {
                        headers.push(header);
                    });
                }
                else if (context.init.headers) {
                    Object.keys(context.init.headers).forEach((key) => {
                        headers.push([key, context.init.headers[key]]);
                    });
                }
                context.init.headers = headers.concat((0,polyfills/* objectEntries */.qP)(tracingHeaders));
            }
        }),
        traceXhr: (context, xhr) => injectHeadersIfTracingAllowed(configuration, context, sessionManager, userContext, accountContext, (tracingHeaders) => {
            Object.keys(tracingHeaders).forEach((name) => {
                xhr.setRequestHeader(name, tracingHeaders[name]);
            });
        }),
    };
}
function injectHeadersIfTracingAllowed(configuration, context, sessionManager, userContext, accountContext, inject) {
    const session = sessionManager.findTrackedSession();
    if (!session) {
        return;
    }
    const tracingOption = configuration.allowedTracingUrls.find((tracingOption) => (0,matchOption/* matchList */.v)([tracingOption.match], context.url, true));
    if (!tracingOption) {
        return;
    }
    const traceSampled = isSampled(session.id, configuration.traceSampleRate);
    const shouldInjectHeaders = traceSampled || configuration.traceContextInjection === configuration_configuration/* TraceContextInjection.ALL */.tg.ALL;
    if (!shouldInjectHeaders) {
        return;
    }
    context.traceSampled = traceSampled;
    context.traceId = createTraceIdentifier();
    context.spanId = createSpanIdentifier();
    inject(makeTracingHeaders(context.traceId, context.spanId, context.traceSampled, session.id, tracingOption.propagatorTypes, userContext, accountContext, configuration));
}
/**
 * When trace is not sampled, set priority to '0' instead of not adding the tracing headers
 * to prepare the implementation for sampling delegation.
 */
function makeTracingHeaders(traceId, spanId, traceSampled, sessionId, propagatorTypes, userContext, accountContext, configuration) {
    const tracingHeaders = {};
    propagatorTypes.forEach((propagatorType) => {
        switch (propagatorType) {
            case 'datadog': {
                Object.assign(tracingHeaders, {
                    'x-datadog-origin': 'rum',
                    'x-datadog-parent-id': spanId.toString(),
                    'x-datadog-sampling-priority': traceSampled ? '1' : '0',
                    'x-datadog-trace-id': traceId.toString(),
                });
                break;
            }
            // https://www.w3.org/TR/trace-context/
            case 'tracecontext': {
                Object.assign(tracingHeaders, {
                    traceparent: `00-0000000000000000${toPaddedHexadecimalString(traceId)}-${toPaddedHexadecimalString(spanId)}-0${traceSampled ? '1' : '0'}`,
                    tracestate: `dd=s:${traceSampled ? '1' : '0'};o:rum`,
                });
                break;
            }
            // https://github.com/openzipkin/b3-propagation
            case 'b3': {
                Object.assign(tracingHeaders, {
                    b3: `${toPaddedHexadecimalString(traceId)}-${toPaddedHexadecimalString(spanId)}-${traceSampled ? '1' : '0'}`,
                });
                break;
            }
            case 'b3multi': {
                Object.assign(tracingHeaders, {
                    'X-B3-TraceId': toPaddedHexadecimalString(traceId),
                    'X-B3-SpanId': toPaddedHexadecimalString(spanId),
                    'X-B3-Sampled': traceSampled ? '1' : '0',
                });
                break;
            }
        }
    });
    if (configuration.propagateTraceBaggage) {
        const baggageItems = {
            'session.id': sessionId,
        };
        const userId = userContext.getContext().id;
        if (typeof userId === 'string') {
            baggageItems['user.id'] = userId;
        }
        const accountId = accountContext.getContext().id;
        if (typeof accountId === 'string') {
            baggageItems['account.id'] = accountId;
        }
        const baggageHeader = Object.entries(baggageItems)
            .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
            .join(',');
        if (baggageHeader) {
            tracingHeaders['baggage'] = baggageHeader;
        }
    }
    return tracingHeaders;
}
//# sourceMappingURL=tracer.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/configuration/configuration.js


const DEFAULT_PROPAGATOR_TYPES = ['tracecontext', 'datadog'];
function validateAndBuildRumConfiguration(initConfiguration, errorStack) {
    var _a, _b, _c, _d, _e, _f, _g;
    if (initConfiguration.trackFeatureFlagsForEvents !== undefined &&
        !Array.isArray(initConfiguration.trackFeatureFlagsForEvents)) {
        display/* display.warn */.jf.warn('trackFeatureFlagsForEvents should be an array');
    }
    if (!initConfiguration.applicationId) {
        display/* display.error */.jf.error('Application ID is not configured, no RUM data will be collected.');
        return;
    }
    if (!(0,configuration_configuration/* isSampleRate */.RJ)(initConfiguration.sessionReplaySampleRate, 'Session Replay') ||
        !(0,configuration_configuration/* isSampleRate */.RJ)(initConfiguration.traceSampleRate, 'Trace')) {
        return;
    }
    if (initConfiguration.excludedActivityUrls !== undefined && !Array.isArray(initConfiguration.excludedActivityUrls)) {
        display/* display.error */.jf.error('Excluded Activity Urls should be an array');
        return;
    }
    const allowedTracingUrls = validateAndBuildTracingOptions(initConfiguration);
    if (!allowedTracingUrls) {
        return;
    }
    const baseConfiguration = (0,configuration_configuration/* validateAndBuildConfiguration */.fP)(initConfiguration, errorStack);
    const allowedGraphQlUrls = validateAndBuildGraphQlOptions(initConfiguration);
    if (!baseConfiguration) {
        return;
    }
    const sessionReplaySampleRate = (_a = initConfiguration.sessionReplaySampleRate) !== null && _a !== void 0 ? _a : 0;
    return {
        applicationId: initConfiguration.applicationId,
        actionNameAttribute: initConfiguration.actionNameAttribute,
        sessionReplaySampleRate,
        startSessionReplayRecordingManually: initConfiguration.startSessionReplayRecordingManually !== undefined
            ? !!initConfiguration.startSessionReplayRecordingManually
            : sessionReplaySampleRate === 0,
        traceSampleRate: (_b = initConfiguration.traceSampleRate) !== null && _b !== void 0 ? _b : 100,
        rulePsr: (0,numberUtils/* isNumber */.hj)(initConfiguration.traceSampleRate) ? initConfiguration.traceSampleRate / 100 : undefined,
        allowedTracingUrls,
        excludedActivityUrls: (_c = initConfiguration.excludedActivityUrls) !== null && _c !== void 0 ? _c : [],
        workerUrl: initConfiguration.workerUrl,
        compressIntakeRequests: !!initConfiguration.compressIntakeRequests,
        trackUserInteractions: !!((_d = initConfiguration.trackUserInteractions) !== null && _d !== void 0 ? _d : true),
        trackViewsManually: !!initConfiguration.trackViewsManually,
        trackResources: !!((_e = initConfiguration.trackResources) !== null && _e !== void 0 ? _e : true),
        trackLongTasks: !!((_f = initConfiguration.trackLongTasks) !== null && _f !== void 0 ? _f : true),
        trackBfcacheViews: !!initConfiguration.trackBfcacheViews,
        trackEarlyRequests: !!initConfiguration.trackEarlyRequests,
        subdomain: initConfiguration.subdomain,
        defaultPrivacyLevel: (0,objectUtils/* objectHasValue */.E5)(configuration_configuration/* DefaultPrivacyLevel */.Jj, initConfiguration.defaultPrivacyLevel)
            ? initConfiguration.defaultPrivacyLevel
            : configuration_configuration/* DefaultPrivacyLevel.MASK */.Jj.MASK,
        enablePrivacyForActionName: !!initConfiguration.enablePrivacyForActionName,
        traceContextInjection: (0,objectUtils/* objectHasValue */.E5)(configuration_configuration/* TraceContextInjection */.tg, initConfiguration.traceContextInjection)
            ? initConfiguration.traceContextInjection
            : configuration_configuration/* TraceContextInjection.SAMPLED */.tg.SAMPLED,
        plugins: initConfiguration.plugins || [],
        trackFeatureFlagsForEvents: initConfiguration.trackFeatureFlagsForEvents || [],
        profilingSampleRate: (_g = initConfiguration.profilingSampleRate) !== null && _g !== void 0 ? _g : 0,
        propagateTraceBaggage: !!initConfiguration.propagateTraceBaggage,
        allowedGraphQlUrls,
        ...baseConfiguration,
    };
}
/**
 * Validates allowedTracingUrls and converts match options to tracing options
 */
function validateAndBuildTracingOptions(initConfiguration) {
    if (initConfiguration.allowedTracingUrls === undefined) {
        return [];
    }
    if (!Array.isArray(initConfiguration.allowedTracingUrls)) {
        display/* display.error */.jf.error('Allowed Tracing URLs should be an array');
        return;
    }
    if (initConfiguration.allowedTracingUrls.length !== 0 && initConfiguration.service === undefined) {
        display/* display.error */.jf.error('Service needs to be configured when tracing is enabled');
        return;
    }
    // Convert from (MatchOption | TracingOption) to TracingOption, remove unknown properties
    const tracingOptions = [];
    initConfiguration.allowedTracingUrls.forEach((option) => {
        if ((0,matchOption/* isMatchOption */.o)(option)) {
            tracingOptions.push({ match: option, propagatorTypes: DEFAULT_PROPAGATOR_TYPES });
        }
        else if (isTracingOption(option)) {
            tracingOptions.push(option);
        }
        else {
            display/* display.warn */.jf.warn('Allowed Tracing Urls parameters should be a string, RegExp, function, or an object. Ignoring parameter', option);
        }
    });
    return tracingOptions;
}
/**
 * Combines the selected tracing propagators from the different options in allowedTracingUrls
 */
function getSelectedTracingPropagators(configuration) {
    const usedTracingPropagators = new Set();
    if (isNonEmptyArray(configuration.allowedTracingUrls)) {
        configuration.allowedTracingUrls.forEach((option) => {
            if ((0,matchOption/* isMatchOption */.o)(option)) {
                DEFAULT_PROPAGATOR_TYPES.forEach((propagatorType) => usedTracingPropagators.add(propagatorType));
            }
            else if ((0,typeUtils/* getType */.o)(option) === 'object' && Array.isArray(option.propagatorTypes)) {
                // Ensure we have an array, as we cannot rely on types yet (configuration is provided by users)
                option.propagatorTypes.forEach((propagatorType) => usedTracingPropagators.add(propagatorType));
            }
        });
    }
    return Array.from(usedTracingPropagators);
}
/**
 * Build GraphQL options from configuration
 */
function validateAndBuildGraphQlOptions(initConfiguration) {
    if (!initConfiguration.allowedGraphQlUrls) {
        return [];
    }
    if (!Array.isArray(initConfiguration.allowedGraphQlUrls)) {
        display/* display.warn */.jf.warn('allowedGraphQlUrls should be an array');
        return [];
    }
    const graphQlOptions = [];
    initConfiguration.allowedGraphQlUrls.forEach((option) => {
        if ((0,matchOption/* isMatchOption */.o)(option)) {
            graphQlOptions.push({ match: option, trackPayload: false, trackResponseErrors: false });
        }
        else if (option && typeof option === 'object' && 'match' in option && (0,matchOption/* isMatchOption */.o)(option.match)) {
            graphQlOptions.push({
                match: option.match,
                trackPayload: !!option.trackPayload,
                trackResponseErrors: !!option.trackResponseErrors,
            });
        }
    });
    return graphQlOptions;
}
function hasGraphQlPayloadTracking(allowedGraphQlUrls) {
    return (isNonEmptyArray(allowedGraphQlUrls) &&
        allowedGraphQlUrls.some((option) => {
            if (typeof option === 'object' && 'trackPayload' in option) {
                return !!option.trackPayload;
            }
            return false;
        }));
}
function hasGraphQlResponseErrorsTracking(allowedGraphQlUrls) {
    return (isNonEmptyArray(allowedGraphQlUrls) &&
        allowedGraphQlUrls.some((option) => {
            if (typeof option === 'object' && 'trackResponseErrors' in option) {
                return !!option.trackResponseErrors;
            }
            return false;
        }));
}
function serializeRumConfiguration(configuration) {
    var _a;
    const baseSerializedConfiguration = (0,configuration_configuration/* serializeConfiguration */.JZ)(configuration);
    return {
        session_replay_sample_rate: configuration.sessionReplaySampleRate,
        start_session_replay_recording_manually: configuration.startSessionReplayRecordingManually,
        trace_sample_rate: configuration.traceSampleRate,
        trace_context_injection: configuration.traceContextInjection,
        propagate_trace_baggage: configuration.propagateTraceBaggage,
        action_name_attribute: configuration.actionNameAttribute,
        use_allowed_tracing_urls: isNonEmptyArray(configuration.allowedTracingUrls),
        use_allowed_graph_ql_urls: isNonEmptyArray(configuration.allowedGraphQlUrls),
        use_track_graph_ql_payload: hasGraphQlPayloadTracking(configuration.allowedGraphQlUrls),
        use_track_graph_ql_response_errors: hasGraphQlResponseErrorsTracking(configuration.allowedGraphQlUrls),
        selected_tracing_propagators: getSelectedTracingPropagators(configuration),
        default_privacy_level: configuration.defaultPrivacyLevel,
        enable_privacy_for_action_name: configuration.enablePrivacyForActionName,
        use_excluded_activity_urls: isNonEmptyArray(configuration.excludedActivityUrls),
        use_worker_url: !!configuration.workerUrl,
        compress_intake_requests: configuration.compressIntakeRequests,
        track_views_manually: configuration.trackViewsManually,
        track_user_interactions: configuration.trackUserInteractions,
        track_resources: configuration.trackResources,
        track_long_task: configuration.trackLongTasks,
        track_bfcache_views: configuration.trackBfcacheViews,
        track_early_requests: configuration.trackEarlyRequests,
        plugins: (_a = configuration.plugins) === null || _a === void 0 ? void 0 : _a.map((plugin) => {
            var _a;
            return ({
                name: plugin.name,
                ...(_a = plugin.getConfigurationTelemetry) === null || _a === void 0 ? void 0 : _a.call(plugin),
            });
        }),
        track_feature_flags_for_events: configuration.trackFeatureFlagsForEvents,
        remote_configuration_id: configuration.remoteConfigurationId,
        profiling_sample_rate: configuration.profilingSampleRate,
        use_remote_configuration_proxy: !!configuration.remoteConfigurationProxy,
        ...baseSerializedConfiguration,
    };
}
//# sourceMappingURL=configuration.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/configuration/endpointBuilder.js
var endpointBuilder = __webpack_require__(99176);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/configuration/jsonPathParser.js
/**
 * Terminology inspired from https://www.rfc-editor.org/rfc/rfc9535.html
 *
 * jsonpath-query      = segment*
 * segment             = .name-shorthand / bracketed-selection
 * bracketed-selection = ['name-selector'] / ["name-selector"] / [index-selector]
 *
 * Useful references:
 * - https://goessner.net/articles/JsonPath/
 * - https://jsonpath.com/
 * - https://github.com/jsonpath-standard
 */
/**
 * Extract selectors from a simple JSON path expression, return [] for an invalid path
 *
 * Supports:
 * - Dot notation: `foo.bar.baz`
 * - Bracket notation: `['foo']["bar"]`
 * - Array indices: `items[0]`, `data['users'][1]`
 *
 * Examples:
 * parseJsonPath("['foo'].bar[12]")
 * => ['foo', 'bar', '12']
 *
 * parseJsonPath("['foo")
 * => []
 */
function parseJsonPath(path) {
    const selectors = [];
    let previousToken = 0 /* Token.START */;
    let currentToken;
    const parsingContext = { quote: undefined, escapeSequence: undefined };
    let currentSelector = '';
    for (const char of path) {
        // find which kind of token is this char
        currentToken = ALLOWED_NEXT_TOKENS[previousToken].find((token) => TOKEN_PREDICATE[token](char, parsingContext));
        if (!currentToken) {
            return [];
        }
        if (parsingContext.escapeSequence !== undefined && currentToken !== 12 /* Token.ESCAPE_SEQUENCE_CHAR */) {
            if (!isValidEscapeSequence(parsingContext.escapeSequence)) {
                return [];
            }
            currentSelector += resolveEscapeSequence(parsingContext.escapeSequence);
            parsingContext.escapeSequence = undefined;
        }
        if (ALLOWED_SELECTOR_TOKENS.includes(currentToken)) {
            // buffer the char if it belongs to the selector
            // ex: foo['bar']
            //      ^    ^
            currentSelector += char;
        }
        else if (ALLOWED_SELECTOR_DELIMITER_TOKENS.includes(currentToken) && currentSelector !== '') {
            // close the current path part if we have reach a path part delimiter
            // ex: foo.bar['qux']
            //        ^   ^     ^
            selectors.push(currentSelector);
            currentSelector = '';
        }
        else if (currentToken === 12 /* Token.ESCAPE_SEQUENCE_CHAR */) {
            parsingContext.escapeSequence = parsingContext.escapeSequence ? `${parsingContext.escapeSequence}${char}` : char;
        }
        else if (currentToken === 8 /* Token.QUOTE_START */) {
            parsingContext.quote = char;
        }
        else if (currentToken === 9 /* Token.QUOTE_END */) {
            parsingContext.quote = undefined;
        }
        previousToken = currentToken;
    }
    if (!ALLOWED_NEXT_TOKENS[previousToken].includes(1 /* Token.END */)) {
        return [];
    }
    if (currentSelector !== '') {
        selectors.push(currentSelector);
    }
    return selectors;
}
const NAME_SHORTHAND_FIRST_CHAR_REGEX = /[a-zA-Z_$]/;
const NAME_SHORTHAND_CHAR_REGEX = /[a-zA-Z0-9_$]/;
const DIGIT_REGEX = /[0-9]/;
const UNICODE_CHAR_REGEX = /[a-fA-F0-9]/;
const QUOTE_CHARS = '\'"';
const TOKEN_PREDICATE = {
    // no char should match to START or END
    [0 /* Token.START */]: () => false,
    [1 /* Token.END */]: () => false,
    [2 /* Token.NAME_SHORTHAND_FIRST_CHAR */]: (char) => NAME_SHORTHAND_FIRST_CHAR_REGEX.test(char),
    [3 /* Token.NAME_SHORTHAND_CHAR */]: (char) => NAME_SHORTHAND_CHAR_REGEX.test(char),
    [4 /* Token.DOT */]: (char) => char === '.',
    [5 /* Token.BRACKET_START */]: (char) => char === '[',
    [6 /* Token.BRACKET_END */]: (char) => char === ']',
    [7 /* Token.DIGIT */]: (char) => DIGIT_REGEX.test(char),
    [8 /* Token.QUOTE_START */]: (char) => QUOTE_CHARS.includes(char),
    [9 /* Token.QUOTE_END */]: (char, parsingContext) => char === parsingContext.quote,
    [10 /* Token.NAME_SELECTOR_CHAR */]: () => true, // any char can be used in name selector
    [11 /* Token.ESCAPE */]: (char) => char === '\\',
    [12 /* Token.ESCAPE_SEQUENCE_CHAR */]: (char, parsingContext) => {
        if (parsingContext.escapeSequence === undefined) {
            // see https://www.rfc-editor.org/rfc/rfc9535.html#name-semantics-3
            return `${parsingContext.quote}/\\bfnrtu`.includes(char);
        }
        else if (parsingContext.escapeSequence.startsWith('u') && parsingContext.escapeSequence.length < 5) {
            return UNICODE_CHAR_REGEX.test(char);
        }
        return false;
    },
};
const ALLOWED_NEXT_TOKENS = {
    [0 /* Token.START */]: [2 /* Token.NAME_SHORTHAND_FIRST_CHAR */, 5 /* Token.BRACKET_START */],
    [1 /* Token.END */]: [],
    [2 /* Token.NAME_SHORTHAND_FIRST_CHAR */]: [3 /* Token.NAME_SHORTHAND_CHAR */, 4 /* Token.DOT */, 5 /* Token.BRACKET_START */, 1 /* Token.END */],
    [3 /* Token.NAME_SHORTHAND_CHAR */]: [3 /* Token.NAME_SHORTHAND_CHAR */, 4 /* Token.DOT */, 5 /* Token.BRACKET_START */, 1 /* Token.END */],
    [4 /* Token.DOT */]: [2 /* Token.NAME_SHORTHAND_FIRST_CHAR */],
    [5 /* Token.BRACKET_START */]: [8 /* Token.QUOTE_START */, 7 /* Token.DIGIT */],
    [6 /* Token.BRACKET_END */]: [4 /* Token.DOT */, 5 /* Token.BRACKET_START */, 1 /* Token.END */],
    [7 /* Token.DIGIT */]: [7 /* Token.DIGIT */, 6 /* Token.BRACKET_END */],
    [8 /* Token.QUOTE_START */]: [11 /* Token.ESCAPE */, 9 /* Token.QUOTE_END */, 10 /* Token.NAME_SELECTOR_CHAR */],
    [9 /* Token.QUOTE_END */]: [6 /* Token.BRACKET_END */],
    [10 /* Token.NAME_SELECTOR_CHAR */]: [11 /* Token.ESCAPE */, 9 /* Token.QUOTE_END */, 10 /* Token.NAME_SELECTOR_CHAR */],
    [11 /* Token.ESCAPE */]: [12 /* Token.ESCAPE_SEQUENCE_CHAR */],
    [12 /* Token.ESCAPE_SEQUENCE_CHAR */]: [12 /* Token.ESCAPE_SEQUENCE_CHAR */, 11 /* Token.ESCAPE */, 9 /* Token.QUOTE_END */, 10 /* Token.NAME_SELECTOR_CHAR */],
};
// foo['bar\n'][12]
// ^^    ^ ^^   ^
const ALLOWED_SELECTOR_TOKENS = [
    2 /* Token.NAME_SHORTHAND_FIRST_CHAR */,
    3 /* Token.NAME_SHORTHAND_CHAR */,
    7 /* Token.DIGIT */,
    10 /* Token.NAME_SELECTOR_CHAR */,
];
// foo.bar['qux']
//    ^   ^     ^
const ALLOWED_SELECTOR_DELIMITER_TOKENS = [4 /* Token.DOT */, 5 /* Token.BRACKET_START */, 6 /* Token.BRACKET_END */];
function isValidEscapeSequence(escapeSequence) {
    return '"\'/\\bfnrt'.includes(escapeSequence) || (escapeSequence.startsWith('u') && escapeSequence.length === 5);
}
const ESCAPED_CHARS = {
    '"': '"',
    "'": "'",
    '/': '/',
    '\\': '\\',
    b: '\b',
    f: '\f',
    n: '\n',
    r: '\r',
    t: '\t',
};
function resolveEscapeSequence(escapeSequence) {
    if (escapeSequence.startsWith('u')) {
        // build Unicode char from code
        return String.fromCharCode(parseInt(escapeSequence.slice(1), 16));
    }
    return ESCAPED_CHARS[escapeSequence];
}
//# sourceMappingURL=jsonPathParser.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/configuration/remoteConfiguration.js


const REMOTE_CONFIGURATION_VERSION = 'v1';
const SUPPORTED_FIELDS = [
    'applicationId',
    'service',
    'env',
    'version',
    'sessionSampleRate',
    'sessionReplaySampleRate',
    'defaultPrivacyLevel',
    'enablePrivacyForActionName',
    'traceSampleRate',
    'trackSessionAcrossSubdomains',
    'allowedTracingUrls',
    'allowedTrackingOrigins',
];
async function fetchAndApplyRemoteConfiguration(initConfiguration, supportedContextManagers) {
    let rumInitConfiguration;
    const metrics = initMetrics();
    const fetchResult = await fetchRemoteConfiguration(initConfiguration);
    if (!fetchResult.ok) {
        metrics.increment('fetch', 'failure');
        display/* display.error */.jf.error(fetchResult.error);
    }
    else {
        metrics.increment('fetch', 'success');
        rumInitConfiguration = applyRemoteConfiguration(initConfiguration, fetchResult.value, supportedContextManagers, metrics);
    }
    // monitor-until: forever
    (0,telemetry_telemetry/* addTelemetryMetrics */.qZ)("remote configuration metrics" /* TelemetryMetrics.REMOTE_CONFIGURATION_METRIC_NAME */, { metrics: metrics.get() });
    return rumInitConfiguration;
}
function applyRemoteConfiguration(initConfiguration, rumRemoteConfiguration, supportedContextManagers, metrics) {
    // intents:
    // - explicitly set each supported field to limit risk in case an attacker can create configurations
    // - check the existence in the remote config to avoid clearing a provided init field
    const appliedConfiguration = { ...initConfiguration };
    SUPPORTED_FIELDS.forEach((option) => {
        if (option in rumRemoteConfiguration) {
            appliedConfiguration[option] = resolveConfigurationProperty(rumRemoteConfiguration[option]);
        }
    });
    Object.keys(supportedContextManagers).forEach((context) => {
        if (rumRemoteConfiguration[context] !== undefined) {
            resolveContextProperty(supportedContextManagers[context], rumRemoteConfiguration[context]);
        }
    });
    return appliedConfiguration;
    // share context to access metrics
    function resolveConfigurationProperty(property) {
        if (Array.isArray(property)) {
            return property.map(resolveConfigurationProperty);
        }
        if (isObject(property)) {
            if (isSerializedOption(property)) {
                const type = property.rcSerializedType;
                switch (type) {
                    case 'string':
                        return property.value;
                    case 'regex':
                        return resolveRegex(property.value);
                    case 'dynamic':
                        return resolveDynamicOption(property);
                    default:
                        display/* display.error */.jf.error(`Unsupported remote configuration: "rcSerializedType": "${type}"`);
                        return;
                }
            }
            return (0,objectUtils/* mapValues */.Q8)(property, resolveConfigurationProperty);
        }
        return property;
    }
    function resolveContextProperty(contextManager, contextItems) {
        contextItems.forEach(({ key, value }) => {
            contextManager.setContextProperty(key, resolveConfigurationProperty(value));
        });
    }
    function resolveDynamicOption(property) {
        const strategy = property.strategy;
        let resolvedValue;
        switch (strategy) {
            case 'cookie':
                resolvedValue = resolveCookieValue(property);
                break;
            case 'dom':
                resolvedValue = resolveDomValue(property);
                break;
            case 'js':
                resolvedValue = resolveJsValue(property);
                break;
            default:
                display/* display.error */.jf.error(`Unsupported remote configuration: "strategy": "${strategy}"`);
                return;
        }
        const extractor = property.extractor;
        if (extractor !== undefined && typeof resolvedValue === 'string') {
            return extractValue(extractor, resolvedValue);
        }
        return resolvedValue;
    }
    function resolveCookieValue({ name }) {
        const value = (0,cookie/* getCookie */.ej)(name);
        metrics.increment('cookie', value !== undefined ? 'success' : 'missing');
        return value;
    }
    function resolveDomValue({ selector, attribute }) {
        let element;
        try {
            element = document.querySelector(selector);
        }
        catch (_a) {
            display/* display.error */.jf.error(`Invalid selector in the remote configuration: '${selector}'`);
            metrics.increment('dom', 'failure');
            return;
        }
        if (!element) {
            metrics.increment('dom', 'missing');
            return;
        }
        if (isForbidden(element, attribute)) {
            display/* display.error */.jf.error(`Forbidden element selected by the remote configuration: '${selector}'`);
            metrics.increment('dom', 'failure');
            return;
        }
        const domValue = attribute !== undefined ? element.getAttribute(attribute) : element.textContent;
        if (domValue === null) {
            metrics.increment('dom', 'missing');
            return;
        }
        metrics.increment('dom', 'success');
        return domValue;
    }
    function isForbidden(element, attribute) {
        return element.getAttribute('type') === 'password' && attribute === 'value';
    }
    function resolveJsValue({ path }) {
        let current = window;
        const pathParts = parseJsonPath(path);
        if (pathParts.length === 0) {
            display/* display.error */.jf.error(`Invalid JSON path in the remote configuration: '${path}'`);
            metrics.increment('js', 'failure');
            return;
        }
        for (const pathPart of pathParts) {
            if (!(pathPart in current)) {
                metrics.increment('js', 'missing');
                return;
            }
            try {
                current = current[pathPart];
            }
            catch (e) {
                display/* display.error */.jf.error(`Error accessing: '${path}'`, e);
                metrics.increment('js', 'failure');
                return;
            }
        }
        metrics.increment('js', 'success');
        return current;
    }
}
function initMetrics() {
    const metrics = { fetch: {} };
    return {
        get: () => metrics,
        increment: (metricName, type) => {
            if (!metrics[metricName]) {
                metrics[metricName] = {};
            }
            if (!metrics[metricName][type]) {
                metrics[metricName][type] = 0;
            }
            metrics[metricName][type] = metrics[metricName][type] + 1;
        },
    };
}
function isObject(property) {
    return typeof property === 'object' && property !== null;
}
function isSerializedOption(value) {
    return 'rcSerializedType' in value;
}
function resolveRegex(pattern) {
    try {
        return new RegExp(pattern);
    }
    catch (_a) {
        display/* display.error */.jf.error(`Invalid regex in the remote configuration: '${pattern}'`);
    }
}
function extractValue(extractor, candidate) {
    const resolvedExtractor = resolveRegex(extractor.value);
    if (resolvedExtractor === undefined) {
        return;
    }
    const regexResult = resolvedExtractor.exec(candidate);
    if (regexResult === null) {
        return;
    }
    const [match, capture] = regexResult;
    return capture ? capture : match;
}
async function fetchRemoteConfiguration(configuration) {
    let response;
    try {
        response = await fetch(buildEndpoint(configuration));
    }
    catch (_a) {
        response = undefined;
    }
    if (!response || !response.ok) {
        return {
            ok: false,
            error: new Error('Error fetching the remote configuration.'),
        };
    }
    const remoteConfiguration = await response.json();
    if (remoteConfiguration.rum) {
        return {
            ok: true,
            value: remoteConfiguration.rum,
        };
    }
    return {
        ok: false,
        error: new Error('No remote configuration for RUM.'),
    };
}
function buildEndpoint(configuration) {
    if (configuration.remoteConfigurationProxy) {
        return configuration.remoteConfigurationProxy;
    }
    return `https://sdk-configuration.${(0,endpointBuilder/* buildEndpointHost */._)('rum', configuration)}/${REMOTE_CONFIGURATION_VERSION}/${encodeURIComponent(configuration.remoteConfigurationId)}.json`;
}
//# sourceMappingURL=remoteConfiguration.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/configuration/index.js


//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/boot/preStartRum.js




function createPreStartStrategy({ ignoreInitIfSyntheticsWillInjectRum = true, startDeflateWorker }, trackingConsentState, customVitalsState, doStartRum) {
    const bufferApiCalls = createBoundedBuffer();
    // TODO next major: remove the globalContextManager, userContextManager and accountContextManager from preStartStrategy and use an empty context instead
    const globalContext = buildGlobalContextManager();
    preStartRum_bufferContextCalls(globalContext, CustomerContextKey.globalContext, bufferApiCalls);
    const userContext = buildUserContextManager();
    preStartRum_bufferContextCalls(userContext, CustomerContextKey.userContext, bufferApiCalls);
    const accountContext = buildAccountContextManager();
    preStartRum_bufferContextCalls(accountContext, CustomerContextKey.accountContext, bufferApiCalls);
    let firstStartViewCall;
    let deflateWorker;
    let cachedInitConfiguration;
    let cachedConfiguration;
    const trackingConsentStateSubscription = trackingConsentState.observable.subscribe(tryStartRum);
    const emptyContext = {};
    function tryStartRum() {
        if (!cachedInitConfiguration || !cachedConfiguration || !trackingConsentState.isGranted()) {
            return;
        }
        trackingConsentStateSubscription.unsubscribe();
        let initialViewOptions;
        if (cachedConfiguration.trackViewsManually) {
            if (!firstStartViewCall) {
                return;
            }
            // An initial view is always created when starting RUM.
            // When tracking views automatically, any startView call before RUM start creates an extra
            // view.
            // When tracking views manually, we use the ViewOptions from the first startView call as the
            // initial view options, and we remove the actual startView call so we don't create an extra
            // view.
            bufferApiCalls.remove(firstStartViewCall.callback);
            initialViewOptions = firstStartViewCall.options;
        }
        const startRumResult = doStartRum(cachedConfiguration, deflateWorker, initialViewOptions);
        bufferApiCalls.drain(startRumResult);
    }
    function doInit(initConfiguration, errorStack) {
        const eventBridgeAvailable = (0,eventBridge/* canUseEventBridge */.xT)();
        if (eventBridgeAvailable) {
            initConfiguration = overrideInitConfigurationForBridge(initConfiguration);
        }
        // Update the exposed initConfiguration to reflect the bridge and remote configuration overrides
        cachedInitConfiguration = initConfiguration;
        (0,telemetry_telemetry/* addTelemetryConfiguration */.Uo)(serializeRumConfiguration(initConfiguration));
        if (cachedConfiguration) {
            displayAlreadyInitializedError('DD_RUM', initConfiguration);
            return;
        }
        const configuration = validateAndBuildRumConfiguration(initConfiguration, errorStack);
        if (!configuration) {
            return;
        }
        if (!eventBridgeAvailable && !configuration.sessionStoreStrategyType) {
            display/* display.warn */.jf.warn('No storage available for session. We will not send any data.');
            return;
        }
        if (configuration.compressIntakeRequests && !eventBridgeAvailable && startDeflateWorker) {
            deflateWorker = startDeflateWorker(configuration, 'Datadog RUM', 
            // Worker initialization can fail asynchronously, especially in Firefox where even CSP
            // issues are reported asynchronously. For now, the SDK will continue its execution even if
            // data won't be sent to Datadog. We could improve this behavior in the future.
            functionUtils/* noop */.Z);
            if (!deflateWorker) {
                // `startDeflateWorker` should have logged an error message explaining the issue
                return;
            }
        }
        cachedConfiguration = configuration;
        // Instrument fetch to track network requests
        // This is needed in case the consent is not granted and some customer
        // library (Apollo Client) is storing uninstrumented fetch to be used later
        // The subscription is needed so that the instrumentation process is completed
        initFetchObservable().subscribe(functionUtils/* noop */.Z);
        trackingConsentState.tryToInit(configuration.trackingConsent);
        tryStartRum();
    }
    const addDurationVital = (vital) => {
        bufferApiCalls.add((startRumResult) => startRumResult.addDurationVital(vital));
    };
    const addOperationStepVital = (name, stepType, options, failureReason) => {
        bufferApiCalls.add((startRumResult) => startRumResult.addOperationStepVital((0,sanitize/* sanitize */.N)(name), stepType, (0,sanitize/* sanitize */.N)(options), (0,sanitize/* sanitize */.N)(failureReason)));
    };
    const strategy = {
        init(initConfiguration, publicApi, errorStack) {
            if (!initConfiguration) {
                display/* display.error */.jf.error('Missing configuration');
                return;
            }
            // Set the experimental feature flags as early as possible, so we can use them in most places
            (0,experimentalFeatures/* initFeatureFlags */.fG)(initConfiguration.enableExperimentalFeatures);
            // Expose the initial configuration regardless of initialization success.
            cachedInitConfiguration = initConfiguration;
            // If we are in a Synthetics test configured to automatically inject a RUM instance, we want
            // to completely discard the customer application RUM instance by ignoring their init() call.
            // But, we should not ignore the init() call from the Synthetics-injected RUM instance, so the
            // internal `ignoreInitIfSyntheticsWillInjectRum` option is here to bypass this condition.
            if (ignoreInitIfSyntheticsWillInjectRum && willSyntheticsInjectRum()) {
                return;
            }
            callPluginsMethod(initConfiguration.plugins, 'onInit', { initConfiguration, publicApi });
            if (initConfiguration.remoteConfigurationId) {
                fetchAndApplyRemoteConfiguration(initConfiguration, { user: userContext, context: globalContext })
                    .then((initConfiguration) => {
                    if (initConfiguration) {
                        doInit(initConfiguration, errorStack);
                    }
                })
                    .catch(monitor/* monitorError */.$y);
            }
            else {
                doInit(initConfiguration, errorStack);
            }
        },
        get initConfiguration() {
            return cachedInitConfiguration;
        },
        getInternalContext: functionUtils/* noop */.Z,
        stopSession: functionUtils/* noop */.Z,
        addTiming(name, time = (0,timeUtils/* timeStampNow */.n$)()) {
            bufferApiCalls.add((startRumResult) => startRumResult.addTiming(name, time));
        },
        startView(options, startClocks = (0,timeUtils/* clocksNow */.$I)()) {
            const callback = (startRumResult) => {
                startRumResult.startView(options, startClocks);
            };
            bufferApiCalls.add(callback);
            if (!firstStartViewCall) {
                firstStartViewCall = { options, callback };
                tryStartRum();
            }
        },
        setViewName(name) {
            bufferApiCalls.add((startRumResult) => startRumResult.setViewName(name));
        },
        // View context APIs
        setViewContext(context) {
            bufferApiCalls.add((startRumResult) => startRumResult.setViewContext(context));
        },
        setViewContextProperty(key, value) {
            bufferApiCalls.add((startRumResult) => startRumResult.setViewContextProperty(key, value));
        },
        getViewContext: () => emptyContext,
        globalContext,
        userContext,
        accountContext,
        addAction(action) {
            bufferApiCalls.add((startRumResult) => startRumResult.addAction(action));
        },
        addError(providedError) {
            bufferApiCalls.add((startRumResult) => startRumResult.addError(providedError));
        },
        addFeatureFlagEvaluation(key, value) {
            bufferApiCalls.add((startRumResult) => startRumResult.addFeatureFlagEvaluation(key, value));
        },
        startDurationVital(name, options) {
            return startDurationVital(customVitalsState, name, options);
        },
        stopDurationVital(name, options) {
            stopDurationVital(addDurationVital, customVitalsState, name, options);
        },
        addDurationVital,
        addOperationStepVital,
    };
    return strategy;
}
function overrideInitConfigurationForBridge(initConfiguration) {
    var _a, _b;
    return {
        ...initConfiguration,
        applicationId: '00000000-aaaa-0000-aaaa-000000000000',
        clientToken: 'empty',
        sessionSampleRate: 100,
        defaultPrivacyLevel: (_a = initConfiguration.defaultPrivacyLevel) !== null && _a !== void 0 ? _a : (_b = (0,eventBridge/* getEventBridge */.Ad)()) === null || _b === void 0 ? void 0 : _b.getPrivacyLevel(),
    };
}
function preStartRum_bufferContextCalls(preStartContextManager, name, bufferApiCalls) {
    preStartContextManager.changeObservable.subscribe(() => {
        const context = preStartContextManager.getContext();
        bufferApiCalls.add((startRumResult) => startRumResult[name].setContext(context));
    });
}
//# sourceMappingURL=preStartRum.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/boot/rumPublicApi.js





function makeRumPublicApi(startRumImpl, recorderApi, profilerApi, options = {}) {
    const trackingConsentState = (0,trackingConsent/* createTrackingConsentState */.H)();
    const customVitalsState = createCustomVitalsState();
    const bufferedDataObservable = startBufferingData().observable;
    let strategy = createPreStartStrategy(options, trackingConsentState, customVitalsState, (configuration, deflateWorker, initialViewOptions) => {
        const createEncoder = deflateWorker && options.createDeflateEncoder
            ? (streamId) => options.createDeflateEncoder(configuration, deflateWorker, streamId)
            : createIdentityEncoder;
        const startRumResult = startRumImpl(configuration, recorderApi, profilerApi, initialViewOptions, createEncoder, trackingConsentState, customVitalsState, bufferedDataObservable, options.sdkName);
        recorderApi.onRumStart(startRumResult.lifeCycle, configuration, startRumResult.session, startRumResult.viewHistory, deflateWorker, startRumResult.telemetry);
        profilerApi.onRumStart(startRumResult.lifeCycle, startRumResult.hooks, configuration, startRumResult.session, startRumResult.viewHistory, createEncoder);
        strategy = createPostStartStrategy(strategy, startRumResult);
        callPluginsMethod(configuration.plugins, 'onRumStart', {
            strategy, // TODO: remove this in the next major release
            addEvent: startRumResult.addEvent,
        });
        return startRumResult;
    });
    const getStrategy = () => strategy;
    const startView = (0,monitor/* monitor */.zk)((options) => {
        const sanitizedOptions = typeof options === 'object' ? options : { name: options };
        strategy.startView(sanitizedOptions);
        (0,telemetry_telemetry/* addTelemetryUsage */.eG)({ feature: 'start-view' });
    });
    const rumPublicApi = (0,init/* makePublicApi */.r)({
        init: (initConfiguration) => {
            const errorStack = new Error().stack;
            (0,monitor/* callMonitored */.L6)(() => strategy.init(initConfiguration, rumPublicApi, errorStack));
        },
        setTrackingConsent: (0,monitor/* monitor */.zk)((trackingConsent) => {
            trackingConsentState.update(trackingConsent);
            (0,telemetry_telemetry/* addTelemetryUsage */.eG)({ feature: 'set-tracking-consent', tracking_consent: trackingConsent });
        }),
        setViewName: (0,monitor/* monitor */.zk)((name) => {
            strategy.setViewName(name);
            (0,telemetry_telemetry/* addTelemetryUsage */.eG)({ feature: 'set-view-name' });
        }),
        setViewContext: (0,monitor/* monitor */.zk)((context) => {
            strategy.setViewContext(context);
            (0,telemetry_telemetry/* addTelemetryUsage */.eG)({ feature: 'set-view-context' });
        }),
        setViewContextProperty: (0,monitor/* monitor */.zk)((key, value) => {
            strategy.setViewContextProperty(key, value);
            (0,telemetry_telemetry/* addTelemetryUsage */.eG)({ feature: 'set-view-context-property' });
        }),
        getViewContext: (0,monitor/* monitor */.zk)(() => {
            (0,telemetry_telemetry/* addTelemetryUsage */.eG)({ feature: 'set-view-context-property' });
            return strategy.getViewContext();
        }),
        getInternalContext: (0,monitor/* monitor */.zk)((startTime) => strategy.getInternalContext(startTime)),
        getInitConfiguration: (0,monitor/* monitor */.zk)(() => (0,mergeInto/* deepClone */.I8)(strategy.initConfiguration)),
        addAction: (name, context) => {
            const handlingStack = (0,stackTrace_handlingStack/* createHandlingStack */.Xp)('action');
            (0,monitor/* callMonitored */.L6)(() => {
                strategy.addAction({
                    name: (0,sanitize/* sanitize */.N)(name),
                    context: (0,sanitize/* sanitize */.N)(context),
                    startClocks: (0,timeUtils/* clocksNow */.$I)(),
                    type: ActionType.CUSTOM,
                    handlingStack,
                });
                (0,telemetry_telemetry/* addTelemetryUsage */.eG)({ feature: 'add-action' });
            });
        },
        addError: (error, context) => {
            const handlingStack = (0,stackTrace_handlingStack/* createHandlingStack */.Xp)('error');
            (0,monitor/* callMonitored */.L6)(() => {
                strategy.addError({
                    error, // Do not sanitize error here, it is needed unserialized by computeRawError()
                    handlingStack,
                    context: (0,sanitize/* sanitize */.N)(context),
                    startClocks: (0,timeUtils/* clocksNow */.$I)(),
                });
                (0,telemetry_telemetry/* addTelemetryUsage */.eG)({ feature: 'add-error' });
            });
        },
        addTiming: (0,monitor/* monitor */.zk)((name, time) => {
            // TODO: next major decide to drop relative time support or update its behaviour
            strategy.addTiming((0,sanitize/* sanitize */.N)(name), time);
        }),
        setGlobalContext: defineContextMethod(getStrategy, CustomerContextKey.globalContext, ContextManagerMethod.setContext, 'set-global-context'),
        getGlobalContext: defineContextMethod(getStrategy, CustomerContextKey.globalContext, ContextManagerMethod.getContext, 'get-global-context'),
        setGlobalContextProperty: defineContextMethod(getStrategy, CustomerContextKey.globalContext, ContextManagerMethod.setContextProperty, 'set-global-context-property'),
        removeGlobalContextProperty: defineContextMethod(getStrategy, CustomerContextKey.globalContext, ContextManagerMethod.removeContextProperty, 'remove-global-context-property'),
        clearGlobalContext: defineContextMethod(getStrategy, CustomerContextKey.globalContext, ContextManagerMethod.clearContext, 'clear-global-context'),
        setUser: defineContextMethod(getStrategy, CustomerContextKey.userContext, ContextManagerMethod.setContext, 'set-user'),
        getUser: defineContextMethod(getStrategy, CustomerContextKey.userContext, ContextManagerMethod.getContext, 'get-user'),
        setUserProperty: defineContextMethod(getStrategy, CustomerContextKey.userContext, ContextManagerMethod.setContextProperty, 'set-user-property'),
        removeUserProperty: defineContextMethod(getStrategy, CustomerContextKey.userContext, ContextManagerMethod.removeContextProperty, 'remove-user-property'),
        clearUser: defineContextMethod(getStrategy, CustomerContextKey.userContext, ContextManagerMethod.clearContext, 'clear-user'),
        setAccount: defineContextMethod(getStrategy, CustomerContextKey.accountContext, ContextManagerMethod.setContext, 'set-account'),
        getAccount: defineContextMethod(getStrategy, CustomerContextKey.accountContext, ContextManagerMethod.getContext, 'get-account'),
        setAccountProperty: defineContextMethod(getStrategy, CustomerContextKey.accountContext, ContextManagerMethod.setContextProperty, 'set-account-property'),
        removeAccountProperty: defineContextMethod(getStrategy, CustomerContextKey.accountContext, ContextManagerMethod.removeContextProperty, 'remove-account-property'),
        clearAccount: defineContextMethod(getStrategy, CustomerContextKey.accountContext, ContextManagerMethod.clearContext, 'clear-account'),
        startView,
        stopSession: (0,monitor/* monitor */.zk)(() => {
            strategy.stopSession();
            (0,telemetry_telemetry/* addTelemetryUsage */.eG)({ feature: 'stop-session' });
        }),
        addFeatureFlagEvaluation: (0,monitor/* monitor */.zk)((key, value) => {
            strategy.addFeatureFlagEvaluation((0,sanitize/* sanitize */.N)(key), (0,sanitize/* sanitize */.N)(value));
            (0,telemetry_telemetry/* addTelemetryUsage */.eG)({ feature: 'add-feature-flag-evaluation' });
        }),
        getSessionReplayLink: (0,monitor/* monitor */.zk)(() => recorderApi.getSessionReplayLink()),
        startSessionReplayRecording: (0,monitor/* monitor */.zk)((options) => {
            recorderApi.start(options);
            (0,telemetry_telemetry/* addTelemetryUsage */.eG)({ feature: 'start-session-replay-recording', force: options && options.force });
        }),
        stopSessionReplayRecording: (0,monitor/* monitor */.zk)(() => recorderApi.stop()),
        addDurationVital: (0,monitor/* monitor */.zk)((name, options) => {
            (0,telemetry_telemetry/* addTelemetryUsage */.eG)({ feature: 'add-duration-vital' });
            strategy.addDurationVital({
                name: (0,sanitize/* sanitize */.N)(name),
                type: VitalType.DURATION,
                startClocks: (0,timeUtils/* timeStampToClocks */.lO)(options.startTime),
                duration: options.duration,
                context: (0,sanitize/* sanitize */.N)(options && options.context),
                description: (0,sanitize/* sanitize */.N)(options && options.description),
            });
        }),
        startDurationVital: (0,monitor/* monitor */.zk)((name, options) => {
            (0,telemetry_telemetry/* addTelemetryUsage */.eG)({ feature: 'start-duration-vital' });
            return strategy.startDurationVital((0,sanitize/* sanitize */.N)(name), {
                context: (0,sanitize/* sanitize */.N)(options && options.context),
                description: (0,sanitize/* sanitize */.N)(options && options.description),
            });
        }),
        stopDurationVital: (0,monitor/* monitor */.zk)((nameOrRef, options) => {
            (0,telemetry_telemetry/* addTelemetryUsage */.eG)({ feature: 'stop-duration-vital' });
            strategy.stopDurationVital(typeof nameOrRef === 'string' ? (0,sanitize/* sanitize */.N)(nameOrRef) : nameOrRef, {
                context: (0,sanitize/* sanitize */.N)(options && options.context),
                description: (0,sanitize/* sanitize */.N)(options && options.description),
            });
        }),
        startFeatureOperation: (0,monitor/* monitor */.zk)((name, options) => {
            (0,telemetry_telemetry/* addTelemetryUsage */.eG)({ feature: 'add-operation-step-vital', action_type: 'start' });
            strategy.addOperationStepVital(name, 'start', options);
        }),
        succeedFeatureOperation: (0,monitor/* monitor */.zk)((name, options) => {
            (0,telemetry_telemetry/* addTelemetryUsage */.eG)({ feature: 'add-operation-step-vital', action_type: 'succeed' });
            strategy.addOperationStepVital(name, 'end', options);
        }),
        failFeatureOperation: (0,monitor/* monitor */.zk)((name, failureReason, options) => {
            (0,telemetry_telemetry/* addTelemetryUsage */.eG)({ feature: 'add-operation-step-vital', action_type: 'fail' });
            strategy.addOperationStepVital(name, 'end', options, failureReason);
        }),
    });
    return rumPublicApi;
}
function createPostStartStrategy(preStartStrategy, startRumResult) {
    return {
        init: (initConfiguration) => {
            displayAlreadyInitializedError('DD_RUM', initConfiguration);
        },
        initConfiguration: preStartStrategy.initConfiguration,
        ...startRumResult,
    };
}
//# sourceMappingURL=rumPublicApi.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/sendToExtension.js
var sendToExtension = __webpack_require__(38971);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/browser/pageMayExitObservable.js
var browser_pageMayExitObservable = __webpack_require__(47581);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/getZoneJsOriginalValue.js
var getZoneJsOriginalValue = __webpack_require__(59693);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/browser/domMutationObservable.js

function createDOMMutationObservable() {
    const MutationObserver = getMutationObserverConstructor();
    return new tools_observable/* Observable */.y$((observable) => {
        if (!MutationObserver) {
            return;
        }
        const observer = new MutationObserver((0,monitor/* monitor */.zk)((records) => observable.notify(records)));
        observer.observe(document, {
            attributes: true,
            characterData: true,
            childList: true,
            subtree: true,
        });
        return () => observer.disconnect();
    });
}
function getMutationObserverConstructor() {
    let constructor;
    const browserWindow = window;
    // Angular uses Zone.js to provide a context persisting across async tasks.  Zone.js replaces the
    // global MutationObserver constructor with a patched version to support the context propagation.
    // There is an ongoing issue[1][2] with this setup when using a MutationObserver within a Angular
    // component: on some occasions, the callback is being called in an infinite loop, causing the
    // page to freeze (even if the callback is completely empty).
    //
    // To work around this issue, we try to get the original MutationObserver constructor stored by
    // Zone.js.
    //
    // [1] https://github.com/angular/angular/issues/26948
    // [2] https://github.com/angular/angular/issues/31712
    if (browserWindow.Zone) {
        // Zone.js 0.8.6+ is storing original class constructors into the browser 'window' object[3].
        //
        // [3] https://github.com/angular/angular/blob/6375fa79875c0fe7b815efc45940a6e6f5c9c9eb/packages/zone.js/lib/common/utils.ts#L288
        constructor = (0,getZoneJsOriginalValue/* getZoneJsOriginalValue */.I)(browserWindow, 'MutationObserver');
        if (browserWindow.MutationObserver && constructor === browserWindow.MutationObserver) {
            // Anterior Zone.js versions (used in Angular 2) does not expose the original MutationObserver
            // in the 'window' object. Luckily, the patched MutationObserver class is storing an original
            // instance in its properties[4]. Let's get the original MutationObserver constructor from
            // there.
            //
            // [4] https://github.com/angular/zone.js/blob/v0.8.5/lib/common/utils.ts#L412
            const patchedInstance = new browserWindow.MutationObserver(functionUtils/* noop */.Z);
            const originalInstance = (0,getZoneJsOriginalValue/* getZoneJsOriginalValue */.I)(patchedInstance, 'originalInstance');
            constructor = originalInstance && originalInstance.constructor;
        }
    }
    if (!constructor) {
        constructor = browserWindow.MutationObserver;
    }
    return constructor;
}
//# sourceMappingURL=domMutationObservable.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/browser/windowOpenObservable.js

function createWindowOpenObservable() {
    const observable = new tools_observable/* Observable */.y$();
    const { stop } = (0,instrumentMethod/* instrumentMethod */.S)(window, 'open', () => observable.notify());
    return { observable, stop };
}
//# sourceMappingURL=windowOpenObservable.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/contexts/internalContext.js
/**
 * Internal context keep returning v1 format
 * to not break compatibility with logs data format
 */
function startInternalContext(applicationId, sessionManager, viewHistory, actionContexts, urlContexts) {
    return {
        get: (startTime) => {
            const viewContext = viewHistory.findView(startTime);
            const urlContext = urlContexts.findUrl(startTime);
            const session = sessionManager.findTrackedSession(startTime);
            if (session && viewContext && urlContext) {
                const actionId = actionContexts.findActionId(startTime);
                return {
                    application_id: applicationId,
                    session_id: session.id,
                    user_action: actionId ? { id: actionId } : undefined,
                    view: { id: viewContext.id, name: viewContext.name, referrer: urlContext.referrer, url: urlContext.url },
                };
            }
        },
    };
}
//# sourceMappingURL=internalContext.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/abstractLifeCycle.js
// eslint-disable-next-line no-restricted-syntax
class AbstractLifeCycle {
    constructor() {
        this.callbacks = {};
    }
    notify(eventType, data) {
        const eventCallbacks = this.callbacks[eventType];
        if (eventCallbacks) {
            eventCallbacks.forEach((callback) => callback(data));
        }
    }
    subscribe(eventType, callback) {
        if (!this.callbacks[eventType]) {
            this.callbacks[eventType] = [];
        }
        this.callbacks[eventType].push(callback);
        return {
            unsubscribe: () => {
                this.callbacks[eventType] = this.callbacks[eventType].filter((other) => callback !== other);
            },
        };
    }
}
//# sourceMappingURL=abstractLifeCycle.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/lifeCycle.js

const LifeCycle = (AbstractLifeCycle);
//# sourceMappingURL=lifeCycle.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/sessionConstants.js
var sessionConstants = __webpack_require__(78981);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/timer.js
var timer = __webpack_require__(65483);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/valueHistory.js



const END_OF_TIMES = Infinity;
const CLEAR_OLD_VALUES_INTERVAL = timeUtils/* ONE_MINUTE */.yR;
let cleanupHistoriesInterval = null;
const cleanupTasks = new Set();
function cleanupHistories() {
    cleanupTasks.forEach((task) => task());
}
function createValueHistory({ expireDelay, maxEntries, }) {
    let entries = [];
    if (!cleanupHistoriesInterval) {
        cleanupHistoriesInterval = (0,timer/* setInterval */.Zi)(() => cleanupHistories(), CLEAR_OLD_VALUES_INTERVAL);
    }
    const clearExpiredValues = () => {
        const oldTimeThreshold = (0,timeUtils/* relativeNow */._q)() - expireDelay;
        while (entries.length > 0 && entries[entries.length - 1].endTime < oldTimeThreshold) {
            entries.pop();
        }
    };
    cleanupTasks.add(clearExpiredValues);
    /**
     * Add a value to the history associated with a start time. Returns a reference to this newly
     * added entry that can be removed or closed.
     */
    function add(value, startTime) {
        const entry = {
            value,
            startTime,
            endTime: END_OF_TIMES,
            remove: () => {
                removeItem(entries, entry);
            },
            close: (endTime) => {
                entry.endTime = endTime;
            },
        };
        if (maxEntries && entries.length >= maxEntries) {
            entries.pop();
        }
        entries.unshift(entry);
        return entry;
    }
    /**
     * Return the latest value that was active during `startTime`, or the currently active value
     * if no `startTime` is provided. This method assumes that entries are not overlapping.
     *
     * If `option.returnInactive` is true, returns the value at `startTime` (active or not).
     */
    function find(startTime = END_OF_TIMES, options = { returnInactive: false }) {
        for (const entry of entries) {
            if (entry.startTime <= startTime) {
                if (options.returnInactive || startTime <= entry.endTime) {
                    return entry.value;
                }
                break;
            }
        }
    }
    /**
     * Helper function to close the currently active value, if any. This method assumes that entries
     * are not overlapping.
     */
    function closeActive(endTime) {
        const latestEntry = entries[0];
        if (latestEntry && latestEntry.endTime === END_OF_TIMES) {
            latestEntry.close(endTime);
        }
    }
    /**
     * Return all values with an active period overlapping with the duration,
     * or all values that were active during `startTime` if no duration is provided,
     * or all currently active values if no `startTime` is provided.
     */
    function findAll(startTime = END_OF_TIMES, duration = 0) {
        const endTime = (0,timeUtils/* addDuration */.WK)(startTime, duration);
        return entries
            .filter((entry) => entry.startTime <= endTime && startTime <= entry.endTime)
            .map((entry) => entry.value);
    }
    /**
     * Remove all entries from this collection.
     */
    function reset() {
        entries = [];
    }
    /**
     * Stop internal garbage collection of past entries.
     */
    function stop() {
        cleanupTasks.delete(clearExpiredValues);
        if (cleanupTasks.size === 0 && cleanupHistoriesInterval) {
            (0,timer/* clearInterval */.cv)(cleanupHistoriesInterval);
            cleanupHistoriesInterval = null;
        }
    }
    return { add, find, closeActive, findAll, reset, stop };
}
//# sourceMappingURL=valueHistory.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/contexts/viewHistory.js

const VIEW_CONTEXT_TIME_OUT_DELAY = sessionConstants/* SESSION_TIME_OUT_DELAY */.TN;
function startViewHistory(lifeCycle) {
    const viewValueHistory = createValueHistory({ expireDelay: VIEW_CONTEXT_TIME_OUT_DELAY });
    lifeCycle.subscribe(1 /* LifeCycleEventType.BEFORE_VIEW_CREATED */, (view) => {
        viewValueHistory.add(buildViewHistoryEntry(view), view.startClocks.relative);
    });
    lifeCycle.subscribe(6 /* LifeCycleEventType.AFTER_VIEW_ENDED */, ({ endClocks }) => {
        viewValueHistory.closeActive(endClocks.relative);
    });
    lifeCycle.subscribe(3 /* LifeCycleEventType.BEFORE_VIEW_UPDATED */, (viewUpdate) => {
        const currentView = viewValueHistory.find(viewUpdate.startClocks.relative);
        if (!currentView) {
            return;
        }
        if (viewUpdate.name) {
            currentView.name = viewUpdate.name;
        }
        if (viewUpdate.context) {
            currentView.context = viewUpdate.context;
        }
        currentView.sessionIsActive = viewUpdate.sessionIsActive;
    });
    lifeCycle.subscribe(10 /* LifeCycleEventType.SESSION_RENEWED */, () => {
        viewValueHistory.reset();
    });
    function buildViewHistoryEntry(view) {
        return {
            service: view.service,
            version: view.version,
            context: view.context,
            id: view.id,
            name: view.name,
            startClocks: view.startClocks,
        };
    }
    return {
        findView: (startTime) => viewValueHistory.find(startTime),
        stop: () => {
            viewValueHistory.stop();
        },
    };
}
//# sourceMappingURL=viewHistory.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/browser/xhrObservable.js






let xhrObservable;
const xhrContexts = new WeakMap();
function initXhrObservable(configuration) {
    if (!xhrObservable) {
        xhrObservable = createXhrObservable(configuration);
    }
    return xhrObservable;
}
function createXhrObservable(configuration) {
    return new tools_observable/* Observable */.y$((observable) => {
        const { stop: stopInstrumentingStart } = (0,instrumentMethod/* instrumentMethod */.S)(XMLHttpRequest.prototype, 'open', openXhr);
        const { stop: stopInstrumentingSend } = (0,instrumentMethod/* instrumentMethod */.S)(XMLHttpRequest.prototype, 'send', (call) => {
            sendXhr(call, configuration, observable);
        }, { computeHandlingStack: true });
        const { stop: stopInstrumentingAbort } = (0,instrumentMethod/* instrumentMethod */.S)(XMLHttpRequest.prototype, 'abort', abortXhr);
        return () => {
            stopInstrumentingStart();
            stopInstrumentingSend();
            stopInstrumentingAbort();
        };
    });
}
function openXhr({ target: xhr, parameters: [method, url] }) {
    xhrContexts.set(xhr, {
        state: 'open',
        method: String(method).toUpperCase(),
        url: (0,urlPolyfill/* normalizeUrl */.D5)(String(url)),
    });
}
function sendXhr({ target: xhr, parameters: [body], handlingStack }, configuration, observable) {
    const context = xhrContexts.get(xhr);
    if (!context) {
        return;
    }
    const startContext = context;
    startContext.state = 'start';
    startContext.startClocks = (0,timeUtils/* clocksNow */.$I)();
    startContext.isAborted = false;
    startContext.xhr = xhr;
    startContext.handlingStack = handlingStack;
    startContext.requestBody = body;
    let hasBeenReported = false;
    const { stop: stopInstrumentingOnReadyStateChange } = (0,instrumentMethod/* instrumentMethod */.S)(xhr, 'onreadystatechange', () => {
        if (xhr.readyState === XMLHttpRequest.DONE) {
            // Try to report the XHR as soon as possible, because the XHR may be mutated by the
            // application during a future event. For example, Angular is calling .abort() on
            // completed requests during an onreadystatechange event, so the status becomes '0'
            // before the request is collected.
            onEnd();
        }
    });
    const onEnd = () => {
        unsubscribeLoadEndListener();
        stopInstrumentingOnReadyStateChange();
        if (hasBeenReported) {
            return;
        }
        hasBeenReported = true;
        const completeContext = context;
        completeContext.state = 'complete';
        completeContext.duration = (0,timeUtils/* elapsed */._J)(startContext.startClocks.timeStamp, (0,timeUtils/* timeStampNow */.n$)());
        completeContext.status = xhr.status;
        if (typeof xhr.response === 'string') {
            completeContext.responseBody = xhr.response;
        }
        observable.notify((0,objectUtils/* shallowClone */.mv)(completeContext));
    };
    const { stop: unsubscribeLoadEndListener } = (0,addEventListener/* addEventListener */.O)(configuration, xhr, 'loadend', onEnd);
    observable.notify(startContext);
}
function abortXhr({ target: xhr }) {
    const context = xhrContexts.get(xhr);
    if (context) {
        context.isAborted = true;
    }
}
//# sourceMappingURL=xhrObservable.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/resourceUtils.js
const ResourceType = {
    DOCUMENT: 'document',
    XHR: 'xhr',
    BEACON: 'beacon',
    FETCH: 'fetch',
    CSS: 'css',
    JS: 'js',
    IMAGE: 'image',
    FONT: 'font',
    MEDIA: 'media',
    OTHER: 'other',
};
const RequestType = {
    FETCH: ResourceType.FETCH,
    XHR: ResourceType.XHR,
};
//# sourceMappingURL=resourceUtils.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/configuration/transportConfiguration.js
var transportConfiguration = __webpack_require__(25039);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/resource/resourceUtils.js

const FAKE_INITIAL_DOCUMENT = 'initial_document';
const RESOURCE_TYPES = [
    [ResourceType.DOCUMENT, (initiatorType) => FAKE_INITIAL_DOCUMENT === initiatorType],
    [ResourceType.XHR, (initiatorType) => 'xmlhttprequest' === initiatorType],
    [ResourceType.FETCH, (initiatorType) => 'fetch' === initiatorType],
    [ResourceType.BEACON, (initiatorType) => 'beacon' === initiatorType],
    [ResourceType.CSS, (_, path) => /\.css$/i.test(path)],
    [ResourceType.JS, (_, path) => /\.js$/i.test(path)],
    [
        ResourceType.IMAGE,
        (initiatorType, path) => ['image', 'img', 'icon'].includes(initiatorType) || /\.(gif|jpg|jpeg|tiff|png|svg|ico)$/i.exec(path) !== null,
    ],
    [ResourceType.FONT, (_, path) => /\.(woff|eot|woff2|ttf)$/i.exec(path) !== null],
    [
        ResourceType.MEDIA,
        (initiatorType, path) => ['audio', 'video'].includes(initiatorType) || /\.(mp3|mp4)$/i.exec(path) !== null,
    ],
];
function computeResourceEntryType(entry) {
    const url = entry.name;
    if (!(0,urlPolyfill/* isValidUrl */.jv)(url)) {
        return ResourceType.OTHER;
    }
    const path = (0,urlPolyfill/* getPathName */.ye)(url);
    for (const [type, isType] of RESOURCE_TYPES) {
        if (isType(entry.initiatorType, path)) {
            return type;
        }
    }
    return ResourceType.OTHER;
}
function areInOrder(...numbers) {
    for (let i = 1; i < numbers.length; i += 1) {
        if (numbers[i - 1] > numbers[i]) {
            return false;
        }
    }
    return true;
}
function isResourceEntryRequestType(entry) {
    return entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch';
}
function computeResourceEntryDuration(entry) {
    const { duration, startTime, responseEnd } = entry;
    // Safari duration is always 0 on timings blocked by cross origin policies.
    if (duration === 0 && startTime < responseEnd) {
        return (0,timeUtils/* elapsed */._J)(startTime, responseEnd);
    }
    return duration;
}
function computeResourceEntryDetails(entry) {
    if (!hasValidResourceEntryTimings(entry)) {
        return undefined;
    }
    const { startTime, fetchStart, workerStart, redirectStart, redirectEnd, domainLookupStart, domainLookupEnd, connectStart, secureConnectionStart, connectEnd, requestStart, responseStart, responseEnd, } = entry;
    const details = {
        download: formatTiming(startTime, responseStart, responseEnd),
        first_byte: formatTiming(startTime, requestStart, responseStart),
    };
    // Make sure a worker processing time is recorded
    if (0 < workerStart && workerStart < fetchStart) {
        details.worker = formatTiming(startTime, workerStart, fetchStart);
    }
    // Make sure a connection occurred
    if (fetchStart < connectEnd) {
        details.connect = formatTiming(startTime, connectStart, connectEnd);
        // Make sure a secure connection occurred
        if (connectStart <= secureConnectionStart && secureConnectionStart <= connectEnd) {
            details.ssl = formatTiming(startTime, secureConnectionStart, connectEnd);
        }
    }
    // Make sure a domain lookup occurred
    if (fetchStart < domainLookupEnd) {
        details.dns = formatTiming(startTime, domainLookupStart, domainLookupEnd);
    }
    // Make sure a redirection occurred
    if (startTime < redirectEnd) {
        details.redirect = formatTiming(startTime, redirectStart, redirectEnd);
    }
    return details;
}
/**
 * Entries with negative duration are unexpected and should be dismissed. The intake will ignore RUM
 * Resource events with negative durations anyway.
 * Since Chromium 128, more entries have unexpected negative durations, see
 * https://issues.chromium.org/issues/363031537
 */
function hasValidResourceEntryDuration(entry) {
    return entry.duration >= 0;
}
function hasValidResourceEntryTimings(entry) {
    // Ensure timings are in the right order. On top of filtering out potential invalid
    // RumPerformanceResourceTiming, it will ignore entries from requests where timings cannot be
    // collected, for example cross origin requests without a "Timing-Allow-Origin" header allowing
    // it.
    const areCommonTimingsInOrder = areInOrder(entry.startTime, entry.fetchStart, entry.domainLookupStart, entry.domainLookupEnd, entry.connectStart, entry.connectEnd, entry.requestStart, entry.responseStart, entry.responseEnd);
    const areRedirectionTimingsInOrder = hasRedirection(entry)
        ? areInOrder(entry.startTime, entry.redirectStart, entry.redirectEnd, entry.fetchStart)
        : true;
    return areCommonTimingsInOrder && areRedirectionTimingsInOrder;
}
function hasRedirection(entry) {
    return entry.redirectEnd > entry.startTime;
}
function formatTiming(origin, start, end) {
    if (origin <= start && start <= end) {
        return {
            duration: (0,timeUtils/* toServerDuration */.c0)((0,timeUtils/* elapsed */._J)(start, end)),
            start: (0,timeUtils/* toServerDuration */.c0)((0,timeUtils/* elapsed */._J)(origin, start)),
        };
    }
}
/**
 * The 'nextHopProtocol' is an empty string for cross-origin resources without CORS headers,
 * meaning the protocol is unknown, and we shouldn't report it.
 * https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/nextHopProtocol#cross-origin_resources
 */
function computeResourceEntryProtocol(entry) {
    return entry.nextHopProtocol === '' ? undefined : entry.nextHopProtocol;
}
/**
 * Handles the 'deliveryType' property to distinguish between supported values ('cache', 'navigational-prefetch'),
 * undefined (unsupported in some browsers), and other cases ('other' for unknown or unrecognized values).
 * see: https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/deliveryType
 */
function computeResourceEntryDeliveryType(entry) {
    return entry.deliveryType === '' ? 'other' : entry.deliveryType;
}
function computeResourceEntrySize(entry) {
    // Make sure a request actually occurred
    if (entry.startTime < entry.responseStart) {
        const { encodedBodySize, decodedBodySize, transferSize } = entry;
        return {
            size: decodedBodySize,
            encoded_body_size: encodedBodySize,
            decoded_body_size: decodedBodySize,
            transfer_size: transferSize,
        };
    }
    return {
        size: undefined,
        encoded_body_size: undefined,
        decoded_body_size: undefined,
        transfer_size: undefined,
    };
}
function isAllowedRequestUrl(url) {
    return url && (!(0,transportConfiguration/* isIntakeUrl */.i)(url) || (0,experimentalFeatures/* isExperimentalFeatureEnabled */.W_)(experimentalFeatures/* ExperimentalFeature.TRACK_INTAKE_REQUESTS */.uh.TRACK_INTAKE_REQUESTS));
}
const DATA_URL_REGEX = /data:(.+)?(;base64)?,/g;
const MAX_RESOURCE_VALUE_CHAR_LENGTH = 24000;
function sanitizeIfLongDataUrl(url, lengthLimit = MAX_RESOURCE_VALUE_CHAR_LENGTH) {
    if (url.length <= lengthLimit || !url.startsWith('data:')) {
        return url;
    }
    // truncate url first to a random length to prevent match error when the url is too long
    const dataUrlMatchArray = url.substring(0, 100).match(DATA_URL_REGEX);
    if (!dataUrlMatchArray) {
        return url;
    }
    return `${dataUrlMatchArray[0]}[...]`;
}
//# sourceMappingURL=resourceUtils.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/resource/graphql.js

/**
 * arbitrary value, byte precision not needed
 */
const GRAPHQL_PAYLOAD_LIMIT = 32 * byteUtils/* ONE_KIBI_BYTE */.Hi;
function extractGraphQlMetadata(request, graphQlConfig) {
    const metadata = extractGraphQlRequestMetadata(request.requestBody, graphQlConfig.trackPayload);
    if (!metadata) {
        return;
    }
    if (graphQlConfig.trackResponseErrors && request.responseBody) {
        const responseErrors = parseGraphQlResponse(request.responseBody);
        if (responseErrors) {
            metadata.errors_count = responseErrors.length;
            metadata.errors = responseErrors;
        }
    }
    return metadata;
}
function parseGraphQlResponse(responseText) {
    let response;
    try {
        response = JSON.parse(responseText);
    }
    catch (_a) {
        // Invalid JSON response
        return;
    }
    if (!response || typeof response !== 'object') {
        return;
    }
    const responseObj = response;
    if (!isNonEmptyArray(responseObj.errors)) {
        return;
    }
    const errors = responseObj.errors.map((error) => {
        var _a;
        const graphqlError = {
            message: error.message,
            path: error.path,
            locations: error.locations,
            code: (_a = error.extensions) === null || _a === void 0 ? void 0 : _a.code,
        };
        return graphqlError;
    });
    return errors;
}
function findGraphQlConfiguration(url, configuration) {
    return configuration.allowedGraphQlUrls.find((graphQlOption) => (0,matchOption/* matchList */.v)([graphQlOption.match], url));
}
function extractGraphQlRequestMetadata(requestBody, trackPayload = false) {
    if (!requestBody || typeof requestBody !== 'string') {
        return;
    }
    let graphqlBody;
    try {
        graphqlBody = JSON.parse(requestBody);
    }
    catch (_a) {
        // Not valid JSON
        return;
    }
    if (!graphqlBody) {
        return;
    }
    let operationType;
    let payload;
    if (graphqlBody.query) {
        const trimmedQuery = graphqlBody.query.trim();
        operationType = getOperationType(trimmedQuery);
        if (trackPayload) {
            payload = (0,stringUtils/* safeTruncate */._z)(trimmedQuery, GRAPHQL_PAYLOAD_LIMIT, '...');
        }
    }
    const operationName = graphqlBody.operationName;
    let variables;
    if (graphqlBody.variables) {
        variables = JSON.stringify(graphqlBody.variables);
    }
    return {
        operationType,
        operationName,
        variables,
        payload,
    };
}
function getOperationType(query) {
    var _a;
    return (_a = query.match(/^\s*(query|mutation|subscription)\b/i)) === null || _a === void 0 ? void 0 : _a[1];
}
//# sourceMappingURL=graphql.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/requestCollection.js




let nextRequestIndex = 1;
function startRequestCollection(lifeCycle, configuration, sessionManager, userContext, accountContext) {
    const tracer = startTracer(configuration, sessionManager, userContext, accountContext);
    trackXhr(lifeCycle, configuration, tracer);
    trackFetch(lifeCycle, configuration, tracer);
}
function trackXhr(lifeCycle, configuration, tracer) {
    const subscription = initXhrObservable(configuration).subscribe((rawContext) => {
        const context = rawContext;
        if (!isAllowedRequestUrl(context.url)) {
            return;
        }
        switch (context.state) {
            case 'start':
                tracer.traceXhr(context, context.xhr);
                context.requestIndex = getNextRequestIndex();
                lifeCycle.notify(7 /* LifeCycleEventType.REQUEST_STARTED */, {
                    requestIndex: context.requestIndex,
                    url: context.url,
                });
                break;
            case 'complete':
                tracer.clearTracingIfNeeded(context);
                lifeCycle.notify(8 /* LifeCycleEventType.REQUEST_COMPLETED */, {
                    duration: context.duration,
                    method: context.method,
                    requestIndex: context.requestIndex,
                    spanId: context.spanId,
                    startClocks: context.startClocks,
                    status: context.status,
                    traceId: context.traceId,
                    traceSampled: context.traceSampled,
                    type: RequestType.XHR,
                    url: context.url,
                    xhr: context.xhr,
                    isAborted: context.isAborted,
                    handlingStack: context.handlingStack,
                    requestBody: context.requestBody,
                    responseBody: context.responseBody,
                });
                break;
        }
    });
    return { stop: () => subscription.unsubscribe() };
}
function trackFetch(lifeCycle, configuration, tracer) {
    const subscription = initFetchObservable({
        responseBodyAction: (context) => {
            var _a;
            if ((_a = findGraphQlConfiguration(context.url, configuration)) === null || _a === void 0 ? void 0 : _a.trackResponseErrors) {
                return 2 /* ResponseBodyAction.COLLECT */;
            }
            return 1 /* ResponseBodyAction.WAIT */;
        },
    }).subscribe((rawContext) => {
        var _a;
        const context = rawContext;
        if (!isAllowedRequestUrl(context.url)) {
            return;
        }
        switch (context.state) {
            case 'start':
                tracer.traceFetch(context);
                context.requestIndex = getNextRequestIndex();
                lifeCycle.notify(7 /* LifeCycleEventType.REQUEST_STARTED */, {
                    requestIndex: context.requestIndex,
                    url: context.url,
                });
                break;
            case 'resolve':
                tracer.clearTracingIfNeeded(context);
                lifeCycle.notify(8 /* LifeCycleEventType.REQUEST_COMPLETED */, {
                    duration: (0,timeUtils/* elapsed */._J)(context.startClocks.timeStamp, (0,timeUtils/* timeStampNow */.n$)()),
                    method: context.method,
                    requestIndex: context.requestIndex,
                    responseType: context.responseType,
                    spanId: context.spanId,
                    startClocks: context.startClocks,
                    status: context.status,
                    traceId: context.traceId,
                    traceSampled: context.traceSampled,
                    type: RequestType.FETCH,
                    url: context.url,
                    response: context.response,
                    init: context.init,
                    input: context.input,
                    isAborted: context.isAborted,
                    handlingStack: context.handlingStack,
                    requestBody: (_a = context.init) === null || _a === void 0 ? void 0 : _a.body,
                    responseBody: context.responseBody,
                });
                break;
        }
    });
    return { stop: () => subscription.unsubscribe() };
}
function getNextRequestIndex() {
    const result = nextRequestIndex;
    nextRequestIndex += 1;
    return result;
}
//# sourceMappingURL=requestCollection.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/discardNegativeDuration.js

function discardNegativeDuration(duration) {
    return (0,numberUtils/* isNumber */.hj)(duration) && duration < 0 ? undefined : duration;
}
//# sourceMappingURL=discardNegativeDuration.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/trackEventCounts.js


function trackEventCounts({ lifeCycle, isChildEvent, onChange: callback = functionUtils/* noop */.Z, }) {
    const eventCounts = {
        errorCount: 0,
        longTaskCount: 0,
        resourceCount: 0,
        actionCount: 0,
        frustrationCount: 0,
    };
    const subscription = lifeCycle.subscribe(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, (event) => {
        var _a;
        if (event.type === 'view' || event.type === 'vital' || !isChildEvent(event)) {
            return;
        }
        switch (event.type) {
            case RumEventType.ERROR:
                eventCounts.errorCount += 1;
                callback();
                break;
            case RumEventType.ACTION:
                eventCounts.actionCount += 1;
                if (event.action.frustration) {
                    eventCounts.frustrationCount += event.action.frustration.type.length;
                }
                callback();
                break;
            case RumEventType.LONG_TASK:
                eventCounts.longTaskCount += 1;
                callback();
                break;
            case RumEventType.RESOURCE:
                if (!((_a = event._dd) === null || _a === void 0 ? void 0 : _a.discarded)) {
                    eventCounts.resourceCount += 1;
                    callback();
                }
                break;
        }
    });
    return {
        stop: () => {
            subscription.unsubscribe();
        },
        eventCounts,
    };
}
//# sourceMappingURL=trackEventCounts.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/browser/firstInputPolyfill.js

/**
 * first-input timing entry polyfill based on
 * https://github.com/GoogleChrome/web-vitals/blob/master/src/lib/polyfills/firstInputPolyfill.ts
 */
function retrieveFirstInputTiming(configuration, callback) {
    const startTimeStamp = (0,timeUtils/* dateNow */.m6)();
    let timingSent = false;
    const { stop: removeEventListeners } = (0,addEventListener/* addEventListeners */.y)(configuration, window, ["click" /* DOM_EVENT.CLICK */, "mousedown" /* DOM_EVENT.MOUSE_DOWN */, "keydown" /* DOM_EVENT.KEY_DOWN */, "touchstart" /* DOM_EVENT.TOUCH_START */, "pointerdown" /* DOM_EVENT.POINTER_DOWN */], (evt) => {
        // Only count cancelable events, which should trigger behavior important to the user.
        if (!evt.cancelable) {
            return;
        }
        // This timing will be used to compute the "first Input delay", which is the delta between
        // when the system received the event (e.g. evt.timeStamp) and when it could run the callback
        // (e.g. performance.now()).
        const timing = {
            entryType: 'first-input',
            processingStart: (0,timeUtils/* relativeNow */._q)(),
            processingEnd: (0,timeUtils/* relativeNow */._q)(),
            startTime: evt.timeStamp,
            duration: 0, // arbitrary value to avoid nullable duration and simplify INP logic
            name: '',
            cancelable: false,
            target: null,
            toJSON: () => ({}),
        };
        if (evt.type === "pointerdown" /* DOM_EVENT.POINTER_DOWN */) {
            sendTimingIfPointerIsNotCancelled(configuration, timing);
        }
        else {
            sendTiming(timing);
        }
    }, { passive: true, capture: true });
    return { stop: removeEventListeners };
    /**
     * Pointer events are a special case, because they can trigger main or compositor thread behavior.
     * We differentiate these cases based on whether or not we see a pointercancel event, which are
     * fired when we scroll. If we're scrolling we don't need to report input delay since FID excludes
     * scrolling and pinch/zooming.
     */
    function sendTimingIfPointerIsNotCancelled(configuration, timing) {
        (0,addEventListener/* addEventListeners */.y)(configuration, window, ["pointerup" /* DOM_EVENT.POINTER_UP */, "pointercancel" /* DOM_EVENT.POINTER_CANCEL */], (event) => {
            if (event.type === "pointerup" /* DOM_EVENT.POINTER_UP */) {
                sendTiming(timing);
            }
        }, { once: true });
    }
    function sendTiming(timing) {
        if (!timingSent) {
            timingSent = true;
            removeEventListeners();
            // In some cases the recorded delay is clearly wrong, e.g. it's negative or it's larger than
            // the time between now and when the page was loaded.
            // - https://github.com/GoogleChromeLabs/first-input-delay/issues/4
            // - https://github.com/GoogleChromeLabs/first-input-delay/issues/6
            // - https://github.com/GoogleChromeLabs/first-input-delay/issues/7
            const delay = timing.processingStart - timing.startTime;
            if (delay >= 0 && delay < (0,timeUtils/* dateNow */.m6)() - startTimeStamp) {
                callback(timing);
            }
        }
    }
}
//# sourceMappingURL=firstInputPolyfill.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/browser/performanceObservable.js



// We want to use a real enum (i.e. not a const enum) here, to be able to check whether an arbitrary
// string is an expected performance entry
// eslint-disable-next-line no-restricted-syntax
var RumPerformanceEntryType;
(function (RumPerformanceEntryType) {
    RumPerformanceEntryType["EVENT"] = "event";
    RumPerformanceEntryType["FIRST_INPUT"] = "first-input";
    RumPerformanceEntryType["LARGEST_CONTENTFUL_PAINT"] = "largest-contentful-paint";
    RumPerformanceEntryType["LAYOUT_SHIFT"] = "layout-shift";
    RumPerformanceEntryType["LONG_TASK"] = "longtask";
    RumPerformanceEntryType["LONG_ANIMATION_FRAME"] = "long-animation-frame";
    RumPerformanceEntryType["NAVIGATION"] = "navigation";
    RumPerformanceEntryType["PAINT"] = "paint";
    RumPerformanceEntryType["RESOURCE"] = "resource";
    RumPerformanceEntryType["VISIBILITY_STATE"] = "visibility-state";
})(RumPerformanceEntryType || (RumPerformanceEntryType = {}));
function createPerformanceObservable(configuration, options) {
    return new tools_observable/* Observable */.y$((observable) => {
        if (!window.PerformanceObserver) {
            return;
        }
        const handlePerformanceEntries = (entries) => {
            const rumPerformanceEntries = filterRumPerformanceEntries(entries);
            if (rumPerformanceEntries.length > 0) {
                observable.notify(rumPerformanceEntries);
            }
        };
        let timeoutId;
        let isObserverInitializing = true;
        const observer = new PerformanceObserver((0,monitor/* monitor */.zk)((entries) => {
            // In Safari the performance observer callback is synchronous.
            // Because the buffered performance entry list can be quite large we delay the computation to prevent the SDK from blocking the main thread on init
            if (isObserverInitializing) {
                timeoutId = (0,timer/* setTimeout */.iK)(() => handlePerformanceEntries(entries.getEntries()));
            }
            else {
                handlePerformanceEntries(entries.getEntries());
            }
        }));
        try {
            observer.observe(options);
        }
        catch (_a) {
            // Some old browser versions (<= chrome 74 ) don't support the PerformanceObserver type and buffered options
            // In these cases, fallback to getEntriesByType and PerformanceObserver with entryTypes
            // TODO: remove this fallback in the next major version
            const fallbackSupportedEntryTypes = [
                RumPerformanceEntryType.RESOURCE,
                RumPerformanceEntryType.NAVIGATION,
                RumPerformanceEntryType.LONG_TASK,
                RumPerformanceEntryType.PAINT,
            ];
            if (fallbackSupportedEntryTypes.includes(options.type)) {
                if (options.buffered) {
                    timeoutId = (0,timer/* setTimeout */.iK)(() => handlePerformanceEntries(performance.getEntriesByType(options.type)));
                }
                try {
                    observer.observe({ entryTypes: [options.type] });
                }
                catch (_b) {
                    // Old versions of Safari are throwing "entryTypes contained only unsupported types"
                    // errors when observing only unsupported entry types.
                    //
                    // We could use `supportPerformanceTimingEvent` to make sure we don't invoke
                    // `observer.observe` with an unsupported entry type, but Safari 11 and 12 don't support
                    // `Performance.supportedEntryTypes`, so doing so would lose support for these versions
                    // even if they do support the entry type.
                    return;
                }
            }
        }
        isObserverInitializing = false;
        manageResourceTimingBufferFull(configuration);
        let stopFirstInputTiming;
        if (!supportPerformanceTimingEvent(RumPerformanceEntryType.FIRST_INPUT) &&
            options.type === RumPerformanceEntryType.FIRST_INPUT) {
            ;
            ({ stop: stopFirstInputTiming } = retrieveFirstInputTiming(configuration, (timing) => {
                handlePerformanceEntries([timing]);
            }));
        }
        return () => {
            observer.disconnect();
            if (stopFirstInputTiming) {
                stopFirstInputTiming();
            }
            (0,timer/* clearTimeout */.gr)(timeoutId);
        };
    });
}
let resourceTimingBufferFullListener;
function manageResourceTimingBufferFull(configuration) {
    if (!resourceTimingBufferFullListener && supportPerformanceObject() && 'addEventListener' in performance) {
        // https://bugzilla.mozilla.org/show_bug.cgi?id=1559377
        resourceTimingBufferFullListener = (0,addEventListener/* addEventListener */.O)(configuration, performance, 'resourcetimingbufferfull', () => {
            performance.clearResourceTimings();
        });
    }
    return () => {
        resourceTimingBufferFullListener === null || resourceTimingBufferFullListener === void 0 ? void 0 : resourceTimingBufferFullListener.stop();
    };
}
function supportPerformanceObject() {
    return window.performance !== undefined && 'getEntries' in performance;
}
function supportPerformanceTimingEvent(entryType) {
    return (window.PerformanceObserver &&
        PerformanceObserver.supportedEntryTypes !== undefined &&
        PerformanceObserver.supportedEntryTypes.includes(entryType));
}
function filterRumPerformanceEntries(entries) {
    return entries.filter((entry) => !isForbiddenResource(entry));
}
function isForbiddenResource(entry) {
    return (entry.entryType === RumPerformanceEntryType.RESOURCE &&
        (!isAllowedRequestUrl(entry.name) || !hasValidResourceEntryDuration(entry)));
}
//# sourceMappingURL=performanceObservable.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/browser/htmlDomUtils.js
function isTextNode(node) {
    return node.nodeType === Node.TEXT_NODE;
}
function isCommentNode(node) {
    return node.nodeType === Node.COMMENT_NODE;
}
function isElementNode(node) {
    return node.nodeType === Node.ELEMENT_NODE;
}
function isNodeShadowHost(node) {
    return isElementNode(node) && Boolean(node.shadowRoot);
}
function isNodeShadowRoot(node) {
    const shadowRoot = node;
    return !!shadowRoot.host && shadowRoot.nodeType === Node.DOCUMENT_FRAGMENT_NODE && isElementNode(shadowRoot.host);
}
function hasChildNodes(node) {
    return node.childNodes.length > 0 || isNodeShadowHost(node);
}
function forEachChildNodes(node, callback) {
    let child = node.firstChild;
    while (child) {
        callback(child);
        child = child.nextSibling;
    }
    if (isNodeShadowHost(node)) {
        callback(node.shadowRoot);
    }
}
/**
 * Return `host` in case if the current node is a shadow root otherwise will return the `parentNode`
 */
function getParentNode(node) {
    return isNodeShadowRoot(node) ? node.host : node.parentNode;
}
//# sourceMappingURL=htmlDomUtils.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/waitPageActivityEnd.js



// Delay to wait for a page activity to validate the tracking process
const PAGE_ACTIVITY_VALIDATION_DELAY = 100;
// Delay to wait after a page activity to end the tracking process
const PAGE_ACTIVITY_END_DELAY = 100;
const EXCLUDED_MUTATIONS_ATTRIBUTE = 'data-dd-excluded-activity-mutations';
/**
 * Wait for the page activity end
 *
 * Detection lifecycle:
 * ```
 *                        Wait page activity end
 *              .-------------------'--------------------.
 *              v                                        v
 *     [Wait for a page activity ]          [Wait for a maximum duration]
 *     [timeout: VALIDATION_DELAY]          [  timeout: maxDuration     ]
 *          /                  \                           |
 *         v                    v                          |
 *  [No page activity]   [Page activity]                   |
 *         |                   |,----------------------.   |
 *         v                   v                       |   |
 *     (Discard)     [Wait for a page activity]        |   |
 *                   [   timeout: END_DELAY   ]        |   |
 *                       /                \            |   |
 *                      v                  v           |   |
 *             [No page activity]    [Page activity]   |   |
 *                      |                 |            |   |
 *                      |                 '------------'   |
 *                      '-----------. ,--------------------'
 *                                   v
 *                                 (End)
 * ```
 *
 * Note: by assuming that maxDuration is greater than VALIDATION_DELAY, we are sure that if the
 * process is still alive after maxDuration, it has been validated.
 */
function waitPageActivityEnd(lifeCycle, domMutationObservable, windowOpenObservable, configuration, pageActivityEndCallback, maxDuration) {
    const pageActivityObservable = createPageActivityObservable(lifeCycle, domMutationObservable, windowOpenObservable, configuration);
    return doWaitPageActivityEnd(pageActivityObservable, pageActivityEndCallback, maxDuration);
}
function doWaitPageActivityEnd(pageActivityObservable, pageActivityEndCallback, maxDuration) {
    let pageActivityEndTimeoutId;
    let hasCompleted = false;
    const validationTimeoutId = (0,timer/* setTimeout */.iK)((0,monitor/* monitor */.zk)(() => complete({ hadActivity: false })), PAGE_ACTIVITY_VALIDATION_DELAY);
    const maxDurationTimeoutId = maxDuration !== undefined
        ? (0,timer/* setTimeout */.iK)((0,monitor/* monitor */.zk)(() => complete({ hadActivity: true, end: (0,timeUtils/* timeStampNow */.n$)() })), maxDuration)
        : undefined;
    const pageActivitySubscription = pageActivityObservable.subscribe(({ isBusy }) => {
        (0,timer/* clearTimeout */.gr)(validationTimeoutId);
        (0,timer/* clearTimeout */.gr)(pageActivityEndTimeoutId);
        const lastChangeTime = (0,timeUtils/* timeStampNow */.n$)();
        if (!isBusy) {
            pageActivityEndTimeoutId = (0,timer/* setTimeout */.iK)((0,monitor/* monitor */.zk)(() => complete({ hadActivity: true, end: lastChangeTime })), PAGE_ACTIVITY_END_DELAY);
        }
    });
    const stop = () => {
        hasCompleted = true;
        (0,timer/* clearTimeout */.gr)(validationTimeoutId);
        (0,timer/* clearTimeout */.gr)(pageActivityEndTimeoutId);
        (0,timer/* clearTimeout */.gr)(maxDurationTimeoutId);
        pageActivitySubscription.unsubscribe();
    };
    function complete(event) {
        if (hasCompleted) {
            return;
        }
        stop();
        pageActivityEndCallback(event);
    }
    return { stop };
}
function createPageActivityObservable(lifeCycle, domMutationObservable, windowOpenObservable, configuration) {
    return new tools_observable/* Observable */.y$((observable) => {
        const subscriptions = [];
        let firstRequestIndex;
        let pendingRequestsCount = 0;
        subscriptions.push(domMutationObservable.subscribe((mutations) => {
            if (!mutations.every(isExcludedMutation)) {
                notifyPageActivity();
            }
        }), windowOpenObservable.subscribe(notifyPageActivity), createPerformanceObservable(configuration, { type: RumPerformanceEntryType.RESOURCE }).subscribe((entries) => {
            if (entries.some((entry) => !isExcludedUrl(configuration, entry.name))) {
                notifyPageActivity();
            }
        }), lifeCycle.subscribe(7 /* LifeCycleEventType.REQUEST_STARTED */, (startEvent) => {
            if (isExcludedUrl(configuration, startEvent.url)) {
                return;
            }
            if (firstRequestIndex === undefined) {
                firstRequestIndex = startEvent.requestIndex;
            }
            pendingRequestsCount += 1;
            notifyPageActivity();
        }), lifeCycle.subscribe(8 /* LifeCycleEventType.REQUEST_COMPLETED */, (request) => {
            if (isExcludedUrl(configuration, request.url) ||
                firstRequestIndex === undefined ||
                // If the request started before the tracking start, ignore it
                request.requestIndex < firstRequestIndex) {
                return;
            }
            pendingRequestsCount -= 1;
            notifyPageActivity();
        }));
        return () => {
            subscriptions.forEach((s) => s.unsubscribe());
        };
        function notifyPageActivity() {
            observable.notify({ isBusy: pendingRequestsCount > 0 });
        }
    });
}
function isExcludedUrl(configuration, requestUrl) {
    return (0,matchOption/* matchList */.v)(configuration.excludedActivityUrls, requestUrl);
}
function isExcludedMutation(mutation) {
    const targetElement = mutation.type === 'characterData' ? mutation.target.parentElement : mutation.target;
    return Boolean(targetElement &&
        isElementNode(targetElement) &&
        targetElement.matches(`[${EXCLUDED_MUTATIONS_ATTRIBUTE}], [${EXCLUDED_MUTATIONS_ATTRIBUTE}] *`));
}
//# sourceMappingURL=waitPageActivityEnd.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/action/actionNameConstants.js
/**
 * Get the action name from the attribute 'data-dd-action-name' on the element or any of its parent.
 * It can also be retrieved from a user defined attribute.
 */
const DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE = 'data-dd-action-name';
const ACTION_NAME_PLACEHOLDER = 'Masked Element';
const ACTION_NAME_MASK = 'xxx';
//# sourceMappingURL=actionNameConstants.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/getSelectorFromElement.js

/**
 * Stable attributes are attributes that are commonly used to identify parts of a UI (ex:
 * component). Those attribute values should not be generated randomly (hardcoded most of the time)
 * and stay the same across deploys. They are not necessarily unique across the document.
 */
const STABLE_ATTRIBUTES = [
    DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE,
    // Common test attributes (list provided by google recorder)
    'data-testid',
    'data-test',
    'data-qa',
    'data-cy',
    'data-test-id',
    'data-qa-id',
    'data-testing',
    // FullStory decorator attributes:
    'data-component',
    'data-element',
    'data-source-file',
];
// Selectors to use if they target a single element on the whole document. Those selectors are
// considered as "stable" and uniquely identify an element regardless of the page state. If we find
// one, we should consider the selector "complete" and stop iterating over ancestors.
const GLOBALLY_UNIQUE_SELECTOR_GETTERS = [getStableAttributeSelector, getIDSelector];
// Selectors to use if they target a single element among an element descendants. Those selectors
// are more brittle than "globally unique" selectors and should be combined with ancestor selectors
// to improve specificity.
const UNIQUE_AMONG_CHILDREN_SELECTOR_GETTERS = [
    getStableAttributeSelector,
    getClassSelector,
    getTagNameSelector,
];
function getSelectorFromElement(targetElement, actionNameAttribute) {
    if (!targetElement.isConnected) {
        // We cannot compute a selector for a detached element, as we don't have access to all of its
        // parents, and we cannot determine if it's unique in the document.
        return;
    }
    let targetElementSelector;
    let currentElement = targetElement;
    while (currentElement && currentElement.nodeName !== 'HTML') {
        const globallyUniqueSelector = findSelector(currentElement, GLOBALLY_UNIQUE_SELECTOR_GETTERS, isSelectorUniqueGlobally, actionNameAttribute, targetElementSelector);
        if (globallyUniqueSelector) {
            return globallyUniqueSelector;
        }
        const uniqueSelectorAmongChildren = findSelector(currentElement, UNIQUE_AMONG_CHILDREN_SELECTOR_GETTERS, isSelectorUniqueAmongSiblings, actionNameAttribute, targetElementSelector);
        targetElementSelector =
            uniqueSelectorAmongChildren || combineSelector(getPositionSelector(currentElement), targetElementSelector);
        currentElement = currentElement.parentElement;
    }
    return targetElementSelector;
}
function isGeneratedValue(value) {
    // To compute the "URL path group", the backend replaces every URL path parts as a question mark
    // if it thinks the part is an identifier. The condition it uses is to checks whether a digit is
    // present.
    //
    // Here, we use the same strategy: if the value contains a digit, we consider it generated. This
    // strategy might be a bit naive and fail in some cases, but there are many fallbacks to generate
    // CSS selectors so it should be fine most of the time.
    return /[0-9]/.test(value);
}
function getIDSelector(element) {
    if (element.id && !isGeneratedValue(element.id)) {
        return `#${CSS.escape(element.id)}`;
    }
}
function getClassSelector(element) {
    if (element.tagName === 'BODY') {
        return;
    }
    const classList = element.classList;
    for (let i = 0; i < classList.length; i += 1) {
        const className = classList[i];
        if (isGeneratedValue(className)) {
            continue;
        }
        return `${CSS.escape(element.tagName)}.${CSS.escape(className)}`;
    }
}
function getTagNameSelector(element) {
    return CSS.escape(element.tagName);
}
function getStableAttributeSelector(element, actionNameAttribute) {
    if (actionNameAttribute) {
        const selector = getAttributeSelector(actionNameAttribute);
        if (selector) {
            return selector;
        }
    }
    for (const attributeName of STABLE_ATTRIBUTES) {
        const selector = getAttributeSelector(attributeName);
        if (selector) {
            return selector;
        }
    }
    function getAttributeSelector(attributeName) {
        if (element.hasAttribute(attributeName)) {
            return `${CSS.escape(element.tagName)}[${attributeName}="${CSS.escape(element.getAttribute(attributeName))}"]`;
        }
    }
}
function getPositionSelector(element) {
    let sibling = element.parentElement.firstElementChild;
    let elementIndex = 1;
    while (sibling && sibling !== element) {
        if (sibling.tagName === element.tagName) {
            elementIndex += 1;
        }
        sibling = sibling.nextElementSibling;
    }
    return `${CSS.escape(element.tagName)}:nth-of-type(${elementIndex})`;
}
function findSelector(element, selectorGetters, predicate, actionNameAttribute, childSelector) {
    for (const selectorGetter of selectorGetters) {
        const elementSelector = selectorGetter(element, actionNameAttribute);
        if (!elementSelector) {
            continue;
        }
        if (predicate(element, elementSelector, childSelector)) {
            return combineSelector(elementSelector, childSelector);
        }
    }
}
/**
 * Check whether the selector is unique among the whole document.
 */
function isSelectorUniqueGlobally(element, elementSelector, childSelector) {
    return element.ownerDocument.querySelectorAll(combineSelector(elementSelector, childSelector)).length === 1;
}
/**
 * Check whether the selector is unique among the element siblings. In other words, it returns true
 * if "ELEMENT_PARENT > CHILD_SELECTOR" returns a single element.
 *
 * @param currentElement - the element being considered while iterating over the target
 * element ancestors.
 * @param currentElementSelector - a selector that matches the current element. That
 * selector is not a composed selector (i.e. it might be a single tag name, class name...).
 * @param childSelector - child selector is a selector that targets a descendant
 * of the current element. When undefined, the current element is the target element.
 *
 * # Scope selector usage
 *
 * When composed together, the final selector will be joined with `>` operators to make sure we
 * target direct descendants at each level. In this function, we'll use `querySelector` to check if
 * a selector matches descendants of the current element. But by default, the query selector match
 * elements at any level. Example:
 *
 * ```html
 * <main>
 *   <div>
 *     <span></span>
 *   </div>
 *   <marquee>
 *     <div>
 *       <span></span>
 *     </div>
 *   </marquee>
 * </main>
 * ```
 *
 * `sibling.querySelector('DIV > SPAN')` will match both span elements, so we would consider the
 * selector to be not unique, even if it is unique when we'll compose it with the parent with a `>`
 * operator (`MAIN > DIV > SPAN`).
 *
 * To avoid this, we can use the `:scope` selector to make sure the selector starts from the current
 * sibling (i.e. `sibling.querySelector('DIV:scope > SPAN')` will only match the first span).
 *
 * [1]: https://developer.mozilla.org/fr/docs/Web/CSS/:scope
 *
 * # Performance considerations
 *
 * We compute selectors in performance-critical operations (ex: during a click), so we need to make
 * sure the function is as fast as possible. We observed that naively using `querySelectorAll` to
 * check if the selector matches more than 1 element is quite expensive, so we want to avoid it.
 *
 * Because we are iterating the DOM upward and we use that function at every level, we know the
 * child selector is already unique among the current element children, so we don't need to check
 * for the current element subtree.
 *
 * Instead, we can focus on the current element siblings. If we find a single element matching the
 * selector within a sibling, we know that it's not unique. This allows us to use `querySelector`
 * (or `matches`, when the current element is the target element) instead of `querySelectorAll`.
 */
function isSelectorUniqueAmongSiblings(currentElement, currentElementSelector, childSelector) {
    let isSiblingMatching;
    if (childSelector === undefined) {
        // If the child selector is undefined (meaning `currentElement` is the target element, not one
        // of its ancestor), we need to use `matches` to check if the sibling is matching the selector,
        // as `querySelector` only returns a descendant of the element.
        isSiblingMatching = (sibling) => sibling.matches(currentElementSelector);
    }
    else {
        const scopedSelector = combineSelector(`${currentElementSelector}:scope`, childSelector);
        isSiblingMatching = (sibling) => sibling.querySelector(scopedSelector) !== null;
    }
    const parent = currentElement.parentElement;
    let sibling = parent.firstElementChild;
    while (sibling) {
        if (sibling !== currentElement && isSiblingMatching(sibling)) {
            return false;
        }
        sibling = sibling.nextElementSibling;
    }
    return true;
}
function combineSelector(parent, child) {
    return child ? `${parent}>${child}` : parent;
}
//# sourceMappingURL=getSelectorFromElement.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/privacyConstants.js

const NodePrivacyLevel = {
    IGNORE: 'ignore',
    HIDDEN: 'hidden',
    ALLOW: configuration_configuration/* DefaultPrivacyLevel.ALLOW */.Jj.ALLOW,
    MASK: configuration_configuration/* DefaultPrivacyLevel.MASK */.Jj.MASK,
    MASK_USER_INPUT: configuration_configuration/* DefaultPrivacyLevel.MASK_USER_INPUT */.Jj.MASK_USER_INPUT,
    MASK_UNLESS_ALLOWLISTED: configuration_configuration/* DefaultPrivacyLevel.MASK_UNLESS_ALLOWLISTED */.Jj.MASK_UNLESS_ALLOWLISTED,
};
const PRIVACY_ATTR_NAME = 'data-dd-privacy';
// Privacy Attrs
const PRIVACY_ATTR_VALUE_ALLOW = 'allow';
const PRIVACY_ATTR_VALUE_MASK = 'mask';
const PRIVACY_ATTR_VALUE_MASK_USER_INPUT = 'mask-user-input';
const PRIVACY_ATTR_VALUE_MASK_UNLESS_ALLOWLISTED = 'mask-unless-allowlisted';
const PRIVACY_ATTR_VALUE_HIDDEN = 'hidden';
// Privacy Classes - not all customers can set plain HTML attributes, so support classes too
const PRIVACY_CLASS_PREFIX = 'dd-privacy-';
// Private Replacement Templates
const CENSORED_STRING_MARK = '***';
const CENSORED_IMG_MARK = 'data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==';
const FORM_PRIVATE_TAG_NAMES = {
    INPUT: true,
    OUTPUT: true,
    TEXTAREA: true,
    SELECT: true,
    OPTION: true,
    DATALIST: true,
    OPTGROUP: true,
};
const TEXT_MASKING_CHAR = 'x';
function getPrivacySelector(privacyLevel) {
    return `[${PRIVACY_ATTR_NAME}="${privacyLevel}"], .${PRIVACY_CLASS_PREFIX}${privacyLevel}`;
}
//# sourceMappingURL=privacyConstants.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/privacy.js



/**
 * Get node privacy level by iterating over its ancestors. When the direct parent privacy level is
 * know, it is best to use something like:
 *
 * derivePrivacyLevelGivenParent(getNodeSelfPrivacyLevel(node), parentNodePrivacyLevel)
 */
function getNodePrivacyLevel(node, defaultPrivacyLevel, cache) {
    if (cache && cache.has(node)) {
        return cache.get(node);
    }
    const parentNode = getParentNode(node);
    const parentNodePrivacyLevel = parentNode
        ? getNodePrivacyLevel(parentNode, defaultPrivacyLevel, cache)
        : defaultPrivacyLevel;
    const selfNodePrivacyLevel = getNodeSelfPrivacyLevel(node);
    const nodePrivacyLevel = reducePrivacyLevel(selfNodePrivacyLevel, parentNodePrivacyLevel);
    if (cache) {
        cache.set(node, nodePrivacyLevel);
    }
    return nodePrivacyLevel;
}
/**
 * Reduces the next privacy level based on self + parent privacy levels
 */
function reducePrivacyLevel(childPrivacyLevel, parentNodePrivacyLevel) {
    switch (parentNodePrivacyLevel) {
        // These values cannot be overridden
        case NodePrivacyLevel.HIDDEN:
        case NodePrivacyLevel.IGNORE:
            return parentNodePrivacyLevel;
    }
    switch (childPrivacyLevel) {
        case NodePrivacyLevel.ALLOW:
        case NodePrivacyLevel.MASK:
        case NodePrivacyLevel.MASK_USER_INPUT:
        case NodePrivacyLevel.MASK_UNLESS_ALLOWLISTED:
        case NodePrivacyLevel.HIDDEN:
        case NodePrivacyLevel.IGNORE:
            return childPrivacyLevel;
        default:
            return parentNodePrivacyLevel;
    }
}
/**
 * Determines the node's own privacy level without checking for ancestors.
 */
function getNodeSelfPrivacyLevel(node) {
    // Only Element types can have a privacy level set
    if (!isElementNode(node)) {
        return;
    }
    // Overrules for replay purpose
    if (node.tagName === 'BASE') {
        return NodePrivacyLevel.ALLOW;
    }
    // Overrules to enforce end-user protection
    if (node.tagName === 'INPUT') {
        const inputElement = node;
        if (inputElement.type === 'password' || inputElement.type === 'email' || inputElement.type === 'tel') {
            return NodePrivacyLevel.MASK;
        }
        if (inputElement.type === 'hidden') {
            return NodePrivacyLevel.MASK;
        }
        const autocomplete = inputElement.getAttribute('autocomplete');
        // Handle input[autocomplete=cc-number/cc-csc/cc-exp/cc-exp-month/cc-exp-year/new-password/current-password]
        if (autocomplete && (autocomplete.startsWith('cc-') || autocomplete.endsWith('-password'))) {
            return NodePrivacyLevel.MASK;
        }
    }
    // Check HTML privacy attributes and classes
    if (node.matches(getPrivacySelector(NodePrivacyLevel.HIDDEN))) {
        return NodePrivacyLevel.HIDDEN;
    }
    if (node.matches(getPrivacySelector(NodePrivacyLevel.MASK))) {
        return NodePrivacyLevel.MASK;
    }
    if (node.matches(getPrivacySelector(NodePrivacyLevel.MASK_UNLESS_ALLOWLISTED))) {
        return NodePrivacyLevel.MASK_UNLESS_ALLOWLISTED;
    }
    if (node.matches(getPrivacySelector(NodePrivacyLevel.MASK_USER_INPUT))) {
        return NodePrivacyLevel.MASK_USER_INPUT;
    }
    if (node.matches(getPrivacySelector(NodePrivacyLevel.ALLOW))) {
        return NodePrivacyLevel.ALLOW;
    }
    if (shouldIgnoreElement(node)) {
        return NodePrivacyLevel.IGNORE;
    }
}
/**
 * Helper aiming to unify `mask` and `mask-user-input` privacy levels:
 *
 * In the `mask` case, it is trivial: we should mask the element.
 *
 * In the `mask-user-input` case, we should mask the element only if it is a "form" element or the
 * direct parent is a form element for text nodes).
 *
 * Other `shouldMaskNode` cases are edge cases that should not matter too much (ex: should we mask a
 * node if it is ignored or hidden? it doesn't matter since it won't be serialized).
 */
function shouldMaskNode(node, privacyLevel) {
    switch (privacyLevel) {
        case NodePrivacyLevel.MASK:
        case NodePrivacyLevel.HIDDEN:
        case NodePrivacyLevel.IGNORE:
            return true;
        case NodePrivacyLevel.MASK_UNLESS_ALLOWLISTED:
            if (isTextNode(node)) {
                // Always return true if our parent is a form element, like MASK_USER_INPUT.
                // Otherwise, decide whether to mask based on the allowlist.
                return isFormElement(node.parentNode) ? true : !isAllowlisted(node.textContent || '');
            }
            // Always return true if we're a form element, like MASK_USER_INPUT.
            // Otherwise, return false; MASK_UNLESS_ALLOWLISTED only directly masks text nodes.
            return isFormElement(node);
        case NodePrivacyLevel.MASK_USER_INPUT:
            return isTextNode(node) ? isFormElement(node.parentNode) : isFormElement(node);
        default:
            return false;
    }
}
function shouldMaskAttribute(tagName, attributeName, attributeValue, nodePrivacyLevel, configuration) {
    if (nodePrivacyLevel !== NodePrivacyLevel.MASK && nodePrivacyLevel !== NodePrivacyLevel.MASK_UNLESS_ALLOWLISTED) {
        return false;
    }
    if (attributeName === PRIVACY_ATTR_NAME ||
        STABLE_ATTRIBUTES.includes(attributeName) ||
        attributeName === configuration.actionNameAttribute) {
        return false;
    }
    switch (attributeName) {
        case 'title':
        case 'alt':
        case 'placeholder':
        case 'aria-label':
        case 'name':
            return true;
    }
    if (tagName === 'A' && attributeName === 'href') {
        return true;
    }
    if (tagName === 'IFRAME' && attributeName === 'srcdoc') {
        return true;
    }
    if (attributeValue && attributeName.startsWith('data-')) {
        return true;
    }
    if ((tagName === 'IMG' || tagName === 'SOURCE') && (attributeName === 'src' || attributeName === 'srcset')) {
        return true;
    }
    return false;
}
function isFormElement(node) {
    if (!node || node.nodeType !== node.ELEMENT_NODE) {
        return false;
    }
    const element = node;
    if (element.tagName === 'INPUT') {
        switch (element.type) {
            case 'button':
            case 'color':
            case 'reset':
            case 'submit':
                return false;
        }
    }
    return !!FORM_PRIVATE_TAG_NAMES[element.tagName];
}
/**
 * Text censoring non-destructively maintains whitespace characters in order to preserve text shape
 * during replay.
 */
const censorText = (text) => text.replace(/\S/g, TEXT_MASKING_CHAR);
function getTextContent(textNode, parentNodePrivacyLevel) {
    var _a;
    // The parent node may not be a html element which has a tagName attribute.
    // So just let it be undefined which is ok in this use case.
    const parentTagName = (_a = textNode.parentElement) === null || _a === void 0 ? void 0 : _a.tagName;
    let textContent = textNode.textContent || '';
    const shouldIgnoreWhiteSpace = parentTagName === 'HEAD';
    if (shouldIgnoreWhiteSpace && !textContent.trim()) {
        return;
    }
    const nodePrivacyLevel = parentNodePrivacyLevel;
    const isScript = parentTagName === 'SCRIPT';
    if (isScript) {
        // For perf reasons, we don't record script (heuristic)
        textContent = CENSORED_STRING_MARK;
    }
    else if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
        // Should never occur, but just in case, we set to CENSORED_MARK.
        textContent = CENSORED_STRING_MARK;
    }
    else if (shouldMaskNode(textNode, nodePrivacyLevel)) {
        if (
        // Scrambling the child list breaks text nodes for DATALIST/SELECT/OPTGROUP
        parentTagName === 'DATALIST' ||
            parentTagName === 'SELECT' ||
            parentTagName === 'OPTGROUP') {
            if (!textContent.trim()) {
                return;
            }
        }
        else if (parentTagName === 'OPTION') {
            // <Option> has low entropy in charset + text length, so use `CENSORED_STRING_MARK` when masked
            textContent = CENSORED_STRING_MARK;
        }
        else if (nodePrivacyLevel === NodePrivacyLevel.MASK_UNLESS_ALLOWLISTED) {
            textContent = maskDisallowedTextContent(textContent);
        }
        else {
            textContent = censorText(textContent);
        }
    }
    return textContent;
}
/**
 * TODO: Preserve CSS element order, and record the presence of the tag, just don't render
 * We don't need this logic on the recorder side.
 * For security related meta's, customer can mask themmanually given they
 * are easy to identify in the HEAD tag.
 */
function shouldIgnoreElement(element) {
    if (element.nodeName === 'SCRIPT') {
        return true;
    }
    if (element.nodeName === 'LINK') {
        const relAttribute = getLowerCaseAttribute('rel');
        return (
        // Link as script - Ignore only when rel=preload, modulepreload or prefetch
        (/preload|prefetch/i.test(relAttribute) && getLowerCaseAttribute('as') === 'script') ||
            // Favicons
            relAttribute === 'shortcut icon' ||
            relAttribute === 'icon');
    }
    if (element.nodeName === 'META') {
        const nameAttribute = getLowerCaseAttribute('name');
        const relAttribute = getLowerCaseAttribute('rel');
        const propertyAttribute = getLowerCaseAttribute('property');
        return (
        // Favicons
        /^msapplication-tile(image|color)$/.test(nameAttribute) ||
            nameAttribute === 'application-name' ||
            relAttribute === 'icon' ||
            relAttribute === 'apple-touch-icon' ||
            relAttribute === 'shortcut icon' ||
            // Description
            nameAttribute === 'keywords' ||
            nameAttribute === 'description' ||
            // Social
            /^(og|twitter|fb):/.test(propertyAttribute) ||
            /^(og|twitter):/.test(nameAttribute) ||
            nameAttribute === 'pinterest' ||
            // Robots
            nameAttribute === 'robots' ||
            nameAttribute === 'googlebot' ||
            nameAttribute === 'bingbot' ||
            // Http headers. Ex: X-UA-Compatible, Content-Type, Content-Language, cache-control,
            // X-Translated-By
            element.hasAttribute('http-equiv') ||
            // Authorship
            nameAttribute === 'author' ||
            nameAttribute === 'generator' ||
            nameAttribute === 'framework' ||
            nameAttribute === 'publisher' ||
            nameAttribute === 'progid' ||
            /^article:/.test(propertyAttribute) ||
            /^product:/.test(propertyAttribute) ||
            // Verification
            nameAttribute === 'google-site-verification' ||
            nameAttribute === 'yandex-verification' ||
            nameAttribute === 'csrf-token' ||
            nameAttribute === 'p:domain_verify' ||
            nameAttribute === 'verify-v1' ||
            nameAttribute === 'verification' ||
            nameAttribute === 'shopify-checkout-api-token');
    }
    function getLowerCaseAttribute(name) {
        return (element.getAttribute(name) || '').toLowerCase();
    }
    return false;
}
function isAllowlisted(text) {
    var _a;
    if (!text || !text.trim()) {
        return true;
    }
    // We are using toLocaleLowerCase when adding to the allowlist to avoid case sensitivity
    // so we need to do the same here
    return ((_a = window.$DD_ALLOW) === null || _a === void 0 ? void 0 : _a.has(text.toLocaleLowerCase())) || false;
}
function maskDisallowedTextContent(text, fixedMask) {
    if (isAllowlisted(text)) {
        return text;
    }
    return fixedMask || censorText(text);
}
//# sourceMappingURL=privacy.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/action/clickChain.js

const MAX_DURATION_BETWEEN_CLICKS = timeUtils/* ONE_SECOND */.WT;
const MAX_DISTANCE_BETWEEN_CLICKS = 100;
function createClickChain(firstClick, onFinalize) {
    const bufferedClicks = [];
    let status = 0 /* ClickChainStatus.WaitingForMoreClicks */;
    let maxDurationBetweenClicksTimeoutId;
    appendClick(firstClick);
    function appendClick(click) {
        click.stopObservable.subscribe(tryFinalize);
        bufferedClicks.push(click);
        (0,timer/* clearTimeout */.gr)(maxDurationBetweenClicksTimeoutId);
        maxDurationBetweenClicksTimeoutId = (0,timer/* setTimeout */.iK)(dontAcceptMoreClick, MAX_DURATION_BETWEEN_CLICKS);
    }
    function tryFinalize() {
        if (status === 1 /* ClickChainStatus.WaitingForClicksToStop */ && bufferedClicks.every((click) => click.isStopped())) {
            status = 2 /* ClickChainStatus.Finalized */;
            onFinalize(bufferedClicks);
        }
    }
    function dontAcceptMoreClick() {
        (0,timer/* clearTimeout */.gr)(maxDurationBetweenClicksTimeoutId);
        if (status === 0 /* ClickChainStatus.WaitingForMoreClicks */) {
            status = 1 /* ClickChainStatus.WaitingForClicksToStop */;
            tryFinalize();
        }
    }
    return {
        tryAppend: (click) => {
            if (status !== 0 /* ClickChainStatus.WaitingForMoreClicks */) {
                return false;
            }
            if (bufferedClicks.length > 0 &&
                !areEventsSimilar(bufferedClicks[bufferedClicks.length - 1].event, click.event)) {
                dontAcceptMoreClick();
                return false;
            }
            appendClick(click);
            return true;
        },
        stop: () => {
            dontAcceptMoreClick();
        },
    };
}
/**
 * Checks whether two events are similar by comparing their target, position and timestamp
 */
function areEventsSimilar(first, second) {
    return (first.target === second.target &&
        mouseEventDistance(first, second) <= MAX_DISTANCE_BETWEEN_CLICKS &&
        first.timeStamp - second.timeStamp <= MAX_DURATION_BETWEEN_CLICKS);
}
function mouseEventDistance(origin, other) {
    return Math.sqrt(Math.pow(origin.clientX - other.clientX, 2) + Math.pow(origin.clientY - other.clientY, 2));
}
//# sourceMappingURL=clickChain.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/action/getActionNameFromElement.js





function getActionNameFromElement(element, rumConfiguration, nodePrivacyLevel = NodePrivacyLevel.ALLOW) {
    const nodePrivacyLevelCache = new Map();
    const { actionNameAttribute: userProgrammaticAttribute } = rumConfiguration;
    // Proceed to get the action name in two steps:
    // * first, get the name programmatically, explicitly defined by the user.
    // * then, if privacy is set to mask, return a placeholder for the undefined.
    // * if privacy is not set to mask, use strategies that are known to return good results.
    //   Those strategies will be used on the element and a few parents, but it's likely that they won't succeed at all.
    // * if no name is found this way, use strategies returning less accurate names as a fallback.
    //   Those are much likely to succeed.
    const defaultActionName = getActionNameFromElementProgrammatically(element, DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE) ||
        (userProgrammaticAttribute && getActionNameFromElementProgrammatically(element, userProgrammaticAttribute));
    if (defaultActionName) {
        return { name: defaultActionName, nameSource: "custom_attribute" /* ActionNameSource.CUSTOM_ATTRIBUTE */ };
    }
    else if (nodePrivacyLevel === NodePrivacyLevel.MASK) {
        return { name: ACTION_NAME_PLACEHOLDER, nameSource: "mask_placeholder" /* ActionNameSource.MASK_PLACEHOLDER */ };
    }
    return (getActionNameFromElementForStrategies(element, priorityStrategies, rumConfiguration, nodePrivacyLevelCache) ||
        getActionNameFromElementForStrategies(element, fallbackStrategies, rumConfiguration, nodePrivacyLevelCache) || {
        name: '',
        nameSource: "blank" /* ActionNameSource.BLANK */,
    });
}
function getActionNameFromElementProgrammatically(targetElement, programmaticAttribute) {
    // We don't use getActionNameFromElementForStrategies here, because we want to consider all parents,
    // without limit. It is up to the user to declare a relevant naming strategy.
    const elementWithAttribute = targetElement.closest(`[${programmaticAttribute}]`);
    if (!elementWithAttribute) {
        return;
    }
    const name = elementWithAttribute.getAttribute(programmaticAttribute);
    return truncate(normalizeWhitespace(name.trim()));
}
const priorityStrategies = [
    // associated LABEL text
    (element, rumConfiguration, nodePrivacyLevelCache) => {
        if ('labels' in element && element.labels && element.labels.length > 0) {
            return getActionNameFromTextualContent(element.labels[0], rumConfiguration, nodePrivacyLevelCache);
        }
    },
    // INPUT button (and associated) value
    (element) => {
        if (element.nodeName === 'INPUT') {
            const input = element;
            const type = input.getAttribute('type');
            if (type === 'button' || type === 'submit' || type === 'reset') {
                return { name: input.value, nameSource: "text_content" /* ActionNameSource.TEXT_CONTENT */ };
            }
        }
    },
    // BUTTON, LABEL or button-like element text
    (element, rumConfiguration, nodePrivacyLevelCache) => {
        if (element.nodeName === 'BUTTON' || element.nodeName === 'LABEL' || element.getAttribute('role') === 'button') {
            return getActionNameFromTextualContent(element, rumConfiguration, nodePrivacyLevelCache);
        }
    },
    (element, rumConfiguration, nodePrivacyLevelCache) => getActionNameFromStandardAttribute(element, 'aria-label', rumConfiguration, nodePrivacyLevelCache),
    // associated element text designated by the aria-labelledby attribute
    (element, rumConfiguration, nodePrivacyLevelCache) => {
        const labelledByAttribute = element.getAttribute('aria-labelledby');
        if (labelledByAttribute) {
            return {
                name: labelledByAttribute
                    .split(/\s+/)
                    .map((id) => getElementById(element, id))
                    .filter((label) => Boolean(label))
                    .map((element) => getTextualContent(element, rumConfiguration, nodePrivacyLevelCache))
                    .join(' '),
                nameSource: "text_content" /* ActionNameSource.TEXT_CONTENT */,
            };
        }
    },
    (element, rumConfiguration, nodePrivacyLevelCache) => getActionNameFromStandardAttribute(element, 'alt', rumConfiguration, nodePrivacyLevelCache),
    (element, rumConfiguration, nodePrivacyLevelCache) => getActionNameFromStandardAttribute(element, 'name', rumConfiguration, nodePrivacyLevelCache),
    (element, rumConfiguration, nodePrivacyLevelCache) => getActionNameFromStandardAttribute(element, 'title', rumConfiguration, nodePrivacyLevelCache),
    (element, rumConfiguration, nodePrivacyLevelCache) => getActionNameFromStandardAttribute(element, 'placeholder', rumConfiguration, nodePrivacyLevelCache),
    // SELECT first OPTION text
    (element, rumConfiguration, nodePrivacyLevelCache) => {
        if ('options' in element && element.options.length > 0) {
            return getActionNameFromTextualContent(element.options[0], rumConfiguration, nodePrivacyLevelCache);
        }
    },
];
const fallbackStrategies = [
    (element, rumConfiguration, nodePrivacyLevelCache) => getActionNameFromTextualContent(element, rumConfiguration, nodePrivacyLevelCache),
];
/**
 * Iterates over the target element and its parent, using the strategies list to get an action name.
 * Each strategies are applied on each element, stopping as soon as a non-empty value is returned.
 */
const MAX_PARENTS_TO_CONSIDER = 10;
function getActionNameFromElementForStrategies(targetElement, strategies, rumConfiguration, nodePrivacyLevelCache) {
    let element = targetElement;
    let recursionCounter = 0;
    while (recursionCounter <= MAX_PARENTS_TO_CONSIDER &&
        element &&
        element.nodeName !== 'BODY' &&
        element.nodeName !== 'HTML' &&
        element.nodeName !== 'HEAD') {
        for (const strategy of strategies) {
            const actionName = strategy(element, rumConfiguration, nodePrivacyLevelCache);
            if (actionName) {
                const { name, nameSource } = actionName;
                const trimmedName = name && name.trim();
                if (trimmedName) {
                    return { name: truncate(normalizeWhitespace(trimmedName)), nameSource };
                }
            }
        }
        // Consider a FORM as a contextual limit to get the action name.  This is experimental and may
        // be reconsidered in the future.
        if (element.nodeName === 'FORM') {
            break;
        }
        element = element.parentElement;
        recursionCounter += 1;
    }
}
function normalizeWhitespace(s) {
    return s.replace(/\s+/g, ' ');
}
function truncate(s) {
    return s.length > 100 ? `${(0,stringUtils/* safeTruncate */._z)(s, 100)} [...]` : s;
}
function getElementById(refElement, id) {
    // Use the element ownerDocument here, because tests are executed in an iframe, so
    // document.getElementById won't work.
    return refElement.ownerDocument ? refElement.ownerDocument.getElementById(id) : null;
}
function getActionNameFromStandardAttribute(element, attribute, rumConfiguration, nodePrivacyLevelCache) {
    const { enablePrivacyForActionName, defaultPrivacyLevel } = rumConfiguration;
    let attributeValue = element.getAttribute(attribute);
    if (attributeValue && enablePrivacyForActionName) {
        const nodePrivacyLevel = getNodePrivacyLevel(element, defaultPrivacyLevel, nodePrivacyLevelCache);
        if (shouldMaskAttribute(element.tagName, attribute, attributeValue, nodePrivacyLevel, rumConfiguration)) {
            attributeValue = maskDisallowedTextContent(attributeValue, ACTION_NAME_PLACEHOLDER);
        }
    }
    else if (!attributeValue) {
        attributeValue = '';
    }
    return {
        name: attributeValue,
        nameSource: "standard_attribute" /* ActionNameSource.STANDARD_ATTRIBUTE */,
    };
}
function getActionNameFromTextualContent(element, rumConfiguration, nodePrivacyLevelCache) {
    return {
        name: getTextualContent(element, rumConfiguration, nodePrivacyLevelCache) || '',
        nameSource: "text_content" /* ActionNameSource.TEXT_CONTENT */,
    };
}
function getTextualContent(element, rumConfiguration, nodePrivacyLevelCache) {
    if (element.isContentEditable) {
        return;
    }
    const { enablePrivacyForActionName, actionNameAttribute: userProgrammaticAttribute, defaultPrivacyLevel, } = rumConfiguration;
    if ((0,experimentalFeatures/* isExperimentalFeatureEnabled */.W_)(experimentalFeatures/* ExperimentalFeature.USE_TREE_WALKER_FOR_ACTION_NAME */.uh.USE_TREE_WALKER_FOR_ACTION_NAME)) {
        return getTextualContentWithTreeWalker(element, userProgrammaticAttribute, enablePrivacyForActionName, defaultPrivacyLevel, nodePrivacyLevelCache);
    }
    if ('innerText' in element) {
        let text = element.innerText;
        const removeTextFromElements = (query) => {
            const list = element.querySelectorAll(query);
            for (let index = 0; index < list.length; index += 1) {
                const element = list[index];
                if ('innerText' in element) {
                    const textToReplace = element.innerText;
                    if (textToReplace && textToReplace.trim().length > 0) {
                        text = text.replace(textToReplace, '');
                    }
                }
            }
        };
        // remove the text of elements with programmatic attribute value
        removeTextFromElements(`[${DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE}]`);
        if (userProgrammaticAttribute) {
            removeTextFromElements(`[${userProgrammaticAttribute}]`);
        }
        if (enablePrivacyForActionName) {
            // remove the text of elements with privacy override
            removeTextFromElements(`${getPrivacySelector(NodePrivacyLevel.HIDDEN)}, ${getPrivacySelector(NodePrivacyLevel.MASK)}`);
        }
        return text;
    }
    return element.textContent;
}
function getTextualContentWithTreeWalker(element, userProgrammaticAttribute, privacyEnabledActionName, defaultPrivacyLevel, nodePrivacyLevelCache) {
    const walker = document.createTreeWalker(element, 
    // eslint-disable-next-line no-bitwise
    NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT, rejectInvisibleOrMaskedElementsFilter);
    let text = '';
    while (walker.nextNode()) {
        const node = walker.currentNode;
        if (isElementNode(node)) {
            if (
            // Following InnerText rendering spec https://html.spec.whatwg.org/multipage/dom.html#rendered-text-collection-steps
            node.nodeName === 'BR' ||
                node.nodeName === 'P' ||
                ['block', 'flex', 'grid', 'list-item', 'table', 'table-caption'].includes(getComputedStyle(node).display)) {
                text += ' ';
            }
            continue; // skip element nodes
        }
        text += node.textContent || '';
    }
    return text.replace(/\s+/g, ' ').trim();
    function rejectInvisibleOrMaskedElementsFilter(node) {
        const nodeSelfPrivacyLevel = getNodePrivacyLevel(node, defaultPrivacyLevel, nodePrivacyLevelCache);
        if (privacyEnabledActionName && nodeSelfPrivacyLevel && shouldMaskNode(node, nodeSelfPrivacyLevel)) {
            return NodeFilter.FILTER_REJECT;
        }
        if (isElementNode(node)) {
            if (node.hasAttribute(DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE) ||
                (userProgrammaticAttribute && node.hasAttribute(userProgrammaticAttribute))) {
                return NodeFilter.FILTER_REJECT;
            }
            const style = getComputedStyle(node);
            if (style.visibility !== 'visible' ||
                style.display === 'none' ||
                (style.contentVisibility && style.contentVisibility !== 'visible')
            // contentVisibility is not supported in all browsers, so we need to check it
            ) {
                return NodeFilter.FILTER_REJECT;
            }
        }
        return NodeFilter.FILTER_ACCEPT;
    }
}
//# sourceMappingURL=getActionNameFromElement.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/action/listenActionEvents.js

function listenActionEvents(configuration, { onPointerDown, onPointerUp }) {
    let selectionEmptyAtPointerDown;
    let userActivity = {
        selection: false,
        input: false,
        scroll: false,
    };
    let clickContext;
    const listeners = [
        (0,addEventListener/* addEventListener */.O)(configuration, window, "pointerdown" /* DOM_EVENT.POINTER_DOWN */, (event) => {
            if (isValidPointerEvent(event)) {
                selectionEmptyAtPointerDown = isSelectionEmpty();
                userActivity = {
                    selection: false,
                    input: false,
                    scroll: false,
                };
                clickContext = onPointerDown(event);
            }
        }, { capture: true }),
        (0,addEventListener/* addEventListener */.O)(configuration, window, "selectionchange" /* DOM_EVENT.SELECTION_CHANGE */, () => {
            if (!selectionEmptyAtPointerDown || !isSelectionEmpty()) {
                userActivity.selection = true;
            }
        }, { capture: true }),
        (0,addEventListener/* addEventListener */.O)(configuration, window, "scroll" /* DOM_EVENT.SCROLL */, () => {
            userActivity.scroll = true;
        }, { capture: true, passive: true }),
        (0,addEventListener/* addEventListener */.O)(configuration, window, "pointerup" /* DOM_EVENT.POINTER_UP */, (event) => {
            if (isValidPointerEvent(event) && clickContext) {
                // Use a scoped variable to make sure the value is not changed by other clicks
                const localUserActivity = userActivity;
                onPointerUp(clickContext, event, () => localUserActivity);
                clickContext = undefined;
            }
        }, { capture: true }),
        (0,addEventListener/* addEventListener */.O)(configuration, window, "input" /* DOM_EVENT.INPUT */, () => {
            userActivity.input = true;
        }, { capture: true }),
    ];
    return {
        stop: () => {
            listeners.forEach((listener) => listener.stop());
        },
    };
}
function isSelectionEmpty() {
    const selection = window.getSelection();
    return !selection || selection.isCollapsed;
}
function isValidPointerEvent(event) {
    return (event.target instanceof Element &&
        // Only consider 'primary' pointer events for now. Multi-touch support could be implemented in
        // the future.
        event.isPrimary !== false);
}
//# sourceMappingURL=listenActionEvents.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/action/computeFrustration.js


const MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE = 3;
function computeFrustration(clicks, rageClick) {
    if (isRage(clicks)) {
        rageClick.addFrustration(FrustrationType.RAGE_CLICK);
        if (clicks.some(isDead)) {
            rageClick.addFrustration(FrustrationType.DEAD_CLICK);
        }
        if (rageClick.hasError) {
            rageClick.addFrustration(FrustrationType.ERROR_CLICK);
        }
        return { isRage: true };
    }
    const hasSelectionChanged = clicks.some((click) => click.getUserActivity().selection);
    clicks.forEach((click) => {
        if (click.hasError) {
            click.addFrustration(FrustrationType.ERROR_CLICK);
        }
        if (isDead(click) &&
            // Avoid considering clicks part of a double-click or triple-click selections as dead clicks
            !hasSelectionChanged) {
            click.addFrustration(FrustrationType.DEAD_CLICK);
        }
    });
    return { isRage: false };
}
function isRage(clicks) {
    if (clicks.some((click) => click.getUserActivity().selection || click.getUserActivity().scroll)) {
        return false;
    }
    for (let i = 0; i < clicks.length - (MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE - 1); i += 1) {
        if (clicks[i + MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE - 1].event.timeStamp - clicks[i].event.timeStamp <=
            timeUtils/* ONE_SECOND */.WT) {
            return true;
        }
    }
    return false;
}
const DEAD_CLICK_EXCLUDE_SELECTOR = 
// inputs that don't trigger a meaningful event like "input" when clicked, including textual
// inputs (using a negative selector is shorter here)
'input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]):not([type="reset"]):not([type="range"]),' +
    'textarea,' +
    'select,' +
    // contenteditable and their descendants don't always trigger meaningful changes when manipulated
    '[contenteditable],' +
    '[contenteditable] *,' +
    // canvas, as there is no good way to detect activity occurring on them
    'canvas,' +
    // links that are interactive (have an href attribute) or any of their descendants, as they can
    // open a new tab or navigate to a hash without triggering a meaningful event
    'a[href],' +
    'a[href] *';
function isDead(click) {
    if (click.hasPageActivity || click.getUserActivity().input || click.getUserActivity().scroll) {
        return false;
    }
    let target = click.event.target;
    if (target.tagName === 'LABEL' && target.hasAttribute('for')) {
        target = document.getElementById(target.getAttribute('for'));
    }
    return !target || !target.matches(DEAD_CLICK_EXCLUDE_SELECTOR);
}
//# sourceMappingURL=computeFrustration.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/action/interactionSelectorCache.js

// Maximum duration for click actions
const CLICK_ACTION_MAX_DURATION = 10 * timeUtils/* ONE_SECOND */.WT;
const interactionSelectorCache = new Map();
function getInteractionSelector(relativeTimestamp) {
    const selector = interactionSelectorCache.get(relativeTimestamp);
    interactionSelectorCache.delete(relativeTimestamp);
    return selector;
}
function updateInteractionSelector(relativeTimestamp, selector) {
    interactionSelectorCache.set(relativeTimestamp, selector);
    interactionSelectorCache.forEach((_, relativeTimestamp) => {
        if ((0,timeUtils/* elapsed */._J)(relativeTimestamp, (0,timeUtils/* relativeNow */._q)()) > CLICK_ACTION_MAX_DURATION) {
            interactionSelectorCache.delete(relativeTimestamp);
        }
    });
}
//# sourceMappingURL=interactionSelectorCache.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/action/trackClickActions.js












const ACTION_CONTEXT_TIME_OUT_DELAY = 5 * timeUtils/* ONE_MINUTE */.yR; // arbitrary
function trackClickActions(lifeCycle, domMutationObservable, windowOpenObservable, configuration) {
    const history = createValueHistory({ expireDelay: ACTION_CONTEXT_TIME_OUT_DELAY });
    const stopObservable = new tools_observable/* Observable */.y$();
    let currentClickChain;
    lifeCycle.subscribe(10 /* LifeCycleEventType.SESSION_RENEWED */, () => {
        history.reset();
    });
    lifeCycle.subscribe(5 /* LifeCycleEventType.VIEW_ENDED */, stopClickChain);
    lifeCycle.subscribe(11 /* LifeCycleEventType.PAGE_MAY_EXIT */, (event) => {
        if (event.reason === browser_pageMayExitObservable/* PageExitReason.UNLOADING */.k$.UNLOADING) {
            stopClickChain();
        }
    });
    const { stop: stopActionEventsListener } = listenActionEvents(configuration, {
        onPointerDown: (pointerDownEvent) => processPointerDown(configuration, lifeCycle, domMutationObservable, pointerDownEvent, windowOpenObservable),
        onPointerUp: ({ clickActionBase, hadActivityOnPointerDown }, startEvent, getUserActivity) => {
            startClickAction(configuration, lifeCycle, domMutationObservable, windowOpenObservable, history, stopObservable, appendClickToClickChain, clickActionBase, startEvent, getUserActivity, hadActivityOnPointerDown);
        },
    });
    const actionContexts = {
        findActionId: (startTime) => history.findAll(startTime),
    };
    return {
        stop: () => {
            stopClickChain();
            stopObservable.notify();
            stopActionEventsListener();
        },
        actionContexts,
    };
    function appendClickToClickChain(click) {
        if (!currentClickChain || !currentClickChain.tryAppend(click)) {
            const rageClick = click.clone();
            currentClickChain = createClickChain(click, (clicks) => {
                finalizeClicks(clicks, rageClick);
            });
        }
    }
    function stopClickChain() {
        if (currentClickChain) {
            currentClickChain.stop();
        }
    }
}
function processPointerDown(configuration, lifeCycle, domMutationObservable, pointerDownEvent, windowOpenObservable) {
    let nodePrivacyLevel;
    if (configuration.enablePrivacyForActionName) {
        nodePrivacyLevel = getNodePrivacyLevel(pointerDownEvent.target, configuration.defaultPrivacyLevel);
    }
    else {
        nodePrivacyLevel = NodePrivacyLevel.ALLOW;
    }
    if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
        return undefined;
    }
    const clickActionBase = computeClickActionBase(pointerDownEvent, nodePrivacyLevel, configuration);
    let hadActivityOnPointerDown = false;
    waitPageActivityEnd(lifeCycle, domMutationObservable, windowOpenObservable, configuration, (pageActivityEndEvent) => {
        hadActivityOnPointerDown = pageActivityEndEvent.hadActivity;
    }, 
    // We don't care about the activity duration, we just want to know whether an activity did happen
    // within the "validation delay" or not. Limit the duration so the callback is called sooner.
    PAGE_ACTIVITY_VALIDATION_DELAY);
    return { clickActionBase, hadActivityOnPointerDown: () => hadActivityOnPointerDown };
}
function startClickAction(configuration, lifeCycle, domMutationObservable, windowOpenObservable, history, stopObservable, appendClickToClickChain, clickActionBase, startEvent, getUserActivity, hadActivityOnPointerDown) {
    var _a;
    const click = newClick(lifeCycle, history, getUserActivity, clickActionBase, startEvent);
    appendClickToClickChain(click);
    const selector = (_a = clickActionBase === null || clickActionBase === void 0 ? void 0 : clickActionBase.target) === null || _a === void 0 ? void 0 : _a.selector;
    if (selector) {
        updateInteractionSelector(startEvent.timeStamp, selector);
    }
    const { stop: stopWaitPageActivityEnd } = waitPageActivityEnd(lifeCycle, domMutationObservable, windowOpenObservable, configuration, (pageActivityEndEvent) => {
        if (pageActivityEndEvent.hadActivity && pageActivityEndEvent.end < click.startClocks.timeStamp) {
            // If the clock is looking weird, just discard the click
            click.discard();
        }
        else {
            if (pageActivityEndEvent.hadActivity) {
                click.stop(pageActivityEndEvent.end);
            }
            else if (hadActivityOnPointerDown()) {
                click.stop(
                // using the click start as activity end, so the click will have some activity but its
                // duration will be 0 (as the activity started before the click start)
                click.startClocks.timeStamp);
            }
            else {
                click.stop();
            }
        }
    }, CLICK_ACTION_MAX_DURATION);
    const viewEndedSubscription = lifeCycle.subscribe(5 /* LifeCycleEventType.VIEW_ENDED */, ({ endClocks }) => {
        click.stop(endClocks.timeStamp);
    });
    const stopSubscription = stopObservable.subscribe(() => {
        click.stop();
    });
    click.stopObservable.subscribe(() => {
        viewEndedSubscription.unsubscribe();
        stopWaitPageActivityEnd();
        stopSubscription.unsubscribe();
    });
}
function computeClickActionBase(event, nodePrivacyLevel, configuration) {
    const rect = event.target.getBoundingClientRect();
    const selector = getSelectorFromElement(event.target, configuration.actionNameAttribute);
    if (selector) {
        updateInteractionSelector(event.timeStamp, selector);
    }
    const { name, nameSource } = getActionNameFromElement(event.target, configuration, nodePrivacyLevel);
    return {
        type: ActionType.CLICK,
        target: {
            width: Math.round(rect.width),
            height: Math.round(rect.height),
            selector,
        },
        position: {
            // Use clientX and Y because for SVG element offsetX and Y are relatives to the <svg> element
            x: Math.round(event.clientX - rect.left),
            y: Math.round(event.clientY - rect.top),
        },
        name,
        nameSource,
    };
}
function newClick(lifeCycle, history, getUserActivity, clickActionBase, startEvent) {
    const id = (0,stringUtils/* generateUUID */.DO)();
    const startClocks = (0,timeUtils/* clocksNow */.$I)();
    const historyEntry = history.add(id, startClocks.relative);
    const eventCountsSubscription = trackEventCounts({
        lifeCycle,
        isChildEvent: (event) => event.action !== undefined &&
            (Array.isArray(event.action.id) ? event.action.id.includes(id) : event.action.id === id),
    });
    let status = 0 /* ClickStatus.ONGOING */;
    let activityEndTime;
    const frustrationTypes = [];
    const stopObservable = new tools_observable/* Observable */.y$();
    function stop(newActivityEndTime) {
        if (status !== 0 /* ClickStatus.ONGOING */) {
            return;
        }
        activityEndTime = newActivityEndTime;
        status = 1 /* ClickStatus.STOPPED */;
        if (activityEndTime) {
            historyEntry.close((0,timeUtils/* getRelativeTime */.ni)(activityEndTime));
        }
        else {
            historyEntry.remove();
        }
        eventCountsSubscription.stop();
        stopObservable.notify();
    }
    return {
        event: startEvent,
        stop,
        stopObservable,
        get hasError() {
            return eventCountsSubscription.eventCounts.errorCount > 0;
        },
        get hasPageActivity() {
            return activityEndTime !== undefined;
        },
        getUserActivity,
        addFrustration: (frustrationType) => {
            frustrationTypes.push(frustrationType);
        },
        startClocks,
        isStopped: () => status === 1 /* ClickStatus.STOPPED */ || status === 2 /* ClickStatus.FINALIZED */,
        clone: () => newClick(lifeCycle, history, getUserActivity, clickActionBase, startEvent),
        validate: (domEvents) => {
            stop();
            if (status !== 1 /* ClickStatus.STOPPED */) {
                return;
            }
            const { resourceCount, errorCount, longTaskCount } = eventCountsSubscription.eventCounts;
            const clickAction = {
                duration: activityEndTime && (0,timeUtils/* elapsed */._J)(startClocks.timeStamp, activityEndTime),
                startClocks,
                id,
                frustrationTypes,
                counts: {
                    resourceCount,
                    errorCount,
                    longTaskCount,
                },
                events: domEvents !== null && domEvents !== void 0 ? domEvents : [startEvent],
                event: startEvent,
                ...clickActionBase,
            };
            lifeCycle.notify(0 /* LifeCycleEventType.AUTO_ACTION_COMPLETED */, clickAction);
            status = 2 /* ClickStatus.FINALIZED */;
        },
        discard: () => {
            stop();
            status = 2 /* ClickStatus.FINALIZED */;
        },
    };
}
function finalizeClicks(clicks, rageClick) {
    const { isRage } = computeFrustration(clicks, rageClick);
    if (isRage) {
        clicks.forEach((click) => click.discard());
        rageClick.stop((0,timeUtils/* timeStampNow */.n$)());
        rageClick.validate(clicks.map((click) => click.event));
    }
    else {
        rageClick.discard();
        clicks.forEach((click) => click.validate());
    }
}
//# sourceMappingURL=trackClickActions.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/action/actionCollection.js




function startActionCollection(lifeCycle, hooks, domMutationObservable, windowOpenObservable, configuration) {
    const { unsubscribe: unsubscribeAutoAction } = lifeCycle.subscribe(0 /* LifeCycleEventType.AUTO_ACTION_COMPLETED */, (action) => {
        lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, processAction(action));
    });
    hooks.register(0 /* HookNames.Assemble */, ({ startTime, eventType }) => {
        if (eventType !== RumEventType.ERROR &&
            eventType !== RumEventType.RESOURCE &&
            eventType !== RumEventType.LONG_TASK) {
            return abstractHooks/* SKIPPED */.kb;
        }
        const actionId = actionContexts.findActionId(startTime);
        if (!actionId) {
            return abstractHooks/* SKIPPED */.kb;
        }
        return {
            type: eventType,
            action: { id: actionId },
        };
    });
    hooks.register(1 /* HookNames.AssembleTelemetry */, ({ startTime }) => ({
        action: { id: actionContexts.findActionId(startTime) },
    }));
    let actionContexts = { findActionId: functionUtils/* noop */.Z };
    let stop = functionUtils/* noop */.Z;
    if (configuration.trackUserInteractions) {
        ;
        ({ actionContexts, stop } = trackClickActions(lifeCycle, domMutationObservable, windowOpenObservable, configuration));
    }
    return {
        addAction: (action) => {
            lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, processAction(action));
        },
        actionContexts,
        stop: () => {
            unsubscribeAutoAction();
            stop();
        },
    };
}
function processAction(action) {
    const autoActionProperties = isAutoAction(action)
        ? {
            action: {
                id: action.id,
                loading_time: discardNegativeDuration((0,timeUtils/* toServerDuration */.c0)(action.duration)),
                frustration: {
                    type: action.frustrationTypes,
                },
                error: {
                    count: action.counts.errorCount,
                },
                long_task: {
                    count: action.counts.longTaskCount,
                },
                resource: {
                    count: action.counts.resourceCount,
                },
            },
            _dd: {
                action: {
                    target: action.target,
                    position: action.position,
                    name_source: action.nameSource,
                },
            },
        }
        : {
            context: action.context,
        };
    const actionEvent = (0,mergeInto/* combine */.$e)({
        action: { id: (0,stringUtils/* generateUUID */.DO)(), target: { name: action.name }, type: action.type },
        date: action.startClocks.timeStamp,
        type: RumEventType.ACTION,
    }, autoActionProperties);
    const duration = isAutoAction(action) ? action.duration : undefined;
    const domainContext = isAutoAction(action)
        ? { events: action.events }
        : { handlingStack: action.handlingStack };
    return {
        rawRumEvent: actionEvent,
        duration,
        startTime: action.startClocks.relative,
        domainContext,
    };
}
function isAutoAction(action) {
    return action.type !== ActionType.CUSTOM;
}
//# sourceMappingURL=actionCollection.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/serialisation/jsonStringify.js
var jsonStringify = __webpack_require__(19012);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/console/consoleObservable.js










let consoleObservablesByApi = {};
function initConsoleObservable(apis) {
    const consoleObservables = apis.map((api) => {
        if (!consoleObservablesByApi[api]) {
            consoleObservablesByApi[api] = createConsoleObservable(api); // we are sure that the observable created for this api will yield the expected ConsoleLog type
        }
        return consoleObservablesByApi[api];
    });
    return (0,tools_observable/* mergeObservables */.$Z)(...consoleObservables);
}
function resetConsoleObservable() {
    consoleObservablesByApi = {};
}
function createConsoleObservable(api) {
    return new tools_observable/* Observable */.y$((observable) => {
        const originalConsoleApi = display/* globalConsole */.jG[api];
        display/* globalConsole */.jG[api] = (...params) => {
            originalConsoleApi.apply(console, params);
            const handlingStack = (0,stackTrace_handlingStack/* createHandlingStack */.Xp)('console error');
            (0,monitor/* callMonitored */.L6)(() => {
                observable.notify(buildConsoleLog(params, api, handlingStack));
            });
        };
        return () => {
            display/* globalConsole */.jG[api] = originalConsoleApi;
        };
    });
}
function buildConsoleLog(params, api, handlingStack) {
    const message = params.map((param) => formatConsoleParameters(param)).join(' ');
    if (api === display/* ConsoleApiName.error */.vA.error) {
        const firstErrorParam = params.find(error_error/* isError */.VZ);
        const rawError = (0,error_error/* computeRawError */.AP)({
            originalError: firstErrorParam,
            handlingStack,
            startClocks: (0,timeUtils/* clocksNow */.$I)(),
            source: error_types/* ErrorSource.CONSOLE */.z.CONSOLE,
            handling: "handled" /* ErrorHandling.HANDLED */,
            nonErrorPrefix: "Provided" /* NonErrorPrefix.PROVIDED */,
            // if no good stack is computed from the error, let's not use the fallback stack message
            // advising the user to use an instance of Error, as console.error is commonly used without an
            // Error instance.
            useFallbackStack: false,
        });
        // Use the full log message as the error message instead of just the error instance message.
        rawError.message = message;
        return {
            api,
            message,
            handlingStack,
            error: rawError,
        };
    }
    return {
        api,
        message,
        error: undefined,
        handlingStack,
    };
}
function formatConsoleParameters(param) {
    if (typeof param === 'string') {
        return (0,sanitize/* sanitize */.N)(param);
    }
    if ((0,error_error/* isError */.VZ)(param)) {
        return (0,stackTrace_handlingStack/* formatErrorMessage */.jN)((0,computeStackTrace/* computeStackTrace */._)(param));
    }
    return (0,jsonStringify/* jsonStringify */.l)((0,sanitize/* sanitize */.N)(param), undefined, 2);
}
//# sourceMappingURL=consoleObservable.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/error/trackConsoleError.js

function trackConsoleError(errorObservable) {
    const subscription = initConsoleObservable([display/* ConsoleApiName.error */.vA.error]).subscribe((consoleLog) => errorObservable.notify(consoleLog.error));
    return {
        stop: () => {
            subscription.unsubscribe();
        },
    };
}
//# sourceMappingURL=trackConsoleError.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/report/reportObservable.js







const RawReportType = {
    intervention: 'intervention',
    deprecation: 'deprecation',
    cspViolation: 'csp_violation',
};
function initReportObservable(configuration, apis) {
    const observables = [];
    if (apis.includes(RawReportType.cspViolation)) {
        observables.push(createCspViolationReportObservable(configuration));
    }
    const reportTypes = apis.filter((api) => api !== RawReportType.cspViolation);
    if (reportTypes.length) {
        observables.push(createReportObservable(reportTypes));
    }
    return (0,tools_observable/* mergeObservables */.$Z)(...observables);
}
function createReportObservable(reportTypes) {
    return new tools_observable/* Observable */.y$((observable) => {
        if (!window.ReportingObserver) {
            return;
        }
        const handleReports = (0,monitor/* monitor */.zk)((reports, _) => reports.forEach((report) => observable.notify(buildRawReportErrorFromReport(report))));
        const observer = new window.ReportingObserver(handleReports, {
            types: reportTypes,
            buffered: true,
        });
        observer.observe();
        return () => {
            observer.disconnect();
        };
    });
}
function createCspViolationReportObservable(configuration) {
    return new tools_observable/* Observable */.y$((observable) => {
        const { stop } = (0,addEventListener/* addEventListener */.O)(configuration, document, "securitypolicyviolation" /* DOM_EVENT.SECURITY_POLICY_VIOLATION */, (event) => {
            observable.notify(buildRawReportErrorFromCspViolation(event));
        });
        return stop;
    });
}
function buildRawReportErrorFromReport(report) {
    const { type, body } = report;
    return buildRawReportError({
        type: body.id,
        message: `${type}: ${body.message}`,
        originalError: report,
        stack: buildStack(body.id, body.message, body.sourceFile, body.lineNumber, body.columnNumber),
    });
}
function buildRawReportErrorFromCspViolation(event) {
    const message = `'${event.blockedURI}' blocked by '${event.effectiveDirective}' directive`;
    return buildRawReportError({
        type: event.effectiveDirective,
        message: `${RawReportType.cspViolation}: ${message}`,
        originalError: event,
        csp: {
            disposition: event.disposition,
        },
        stack: buildStack(event.effectiveDirective, event.originalPolicy
            ? `${message} of the policy "${(0,stringUtils/* safeTruncate */._z)(event.originalPolicy, 100, '...')}"`
            : 'no policy', event.sourceFile, event.lineNumber, event.columnNumber),
    });
}
function buildRawReportError(partial) {
    return {
        startClocks: (0,timeUtils/* clocksNow */.$I)(),
        source: error_types/* ErrorSource.REPORT */.z.REPORT,
        handling: "unhandled" /* ErrorHandling.UNHANDLED */,
        ...partial,
    };
}
function buildStack(name, message, sourceFile, lineNumber, columnNumber) {
    return sourceFile
        ? (0,stackTrace_handlingStack/* toStackTraceString */.P3)({
            name,
            message,
            stack: [
                {
                    func: '?',
                    url: sourceFile,
                    line: lineNumber !== null && lineNumber !== void 0 ? lineNumber : undefined,
                    column: columnNumber !== null && columnNumber !== void 0 ? columnNumber : undefined,
                },
            ],
        })
        : undefined;
}
//# sourceMappingURL=reportObservable.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/error/trackReportError.js

function trackReportError(configuration, errorObservable) {
    const subscription = initReportObservable(configuration, [
        RawReportType.cspViolation,
        RawReportType.intervention,
    ]).subscribe((rawError) => errorObservable.notify(rawError));
    return {
        stop: () => {
            subscription.unsubscribe();
        },
    };
}
//# sourceMappingURL=trackReportError.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/error/errorCollection.js




function startErrorCollection(lifeCycle, configuration, bufferedDataObservable) {
    const errorObservable = new tools_observable/* Observable */.y$();
    bufferedDataObservable.subscribe((bufferedData) => {
        if (bufferedData.type === 0 /* BufferedDataType.RUNTIME_ERROR */) {
            errorObservable.notify(bufferedData.error);
        }
    });
    trackConsoleError(errorObservable);
    trackReportError(configuration, errorObservable);
    errorObservable.subscribe((error) => lifeCycle.notify(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, { error }));
    return doStartErrorCollection(lifeCycle);
}
function doStartErrorCollection(lifeCycle) {
    lifeCycle.subscribe(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, ({ error }) => {
        lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, processError(error));
    });
    return {
        addError: ({ error, handlingStack, componentStack, startClocks, context }) => {
            const rawError = (0,error_error/* computeRawError */.AP)({
                originalError: error,
                handlingStack,
                componentStack,
                startClocks,
                nonErrorPrefix: "Provided" /* NonErrorPrefix.PROVIDED */,
                source: error_types/* ErrorSource.CUSTOM */.z.CUSTOM,
                handling: "handled" /* ErrorHandling.HANDLED */,
            });
            rawError.context = (0,mergeInto/* combine */.$e)(rawError.context, context);
            lifeCycle.notify(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, { error: rawError });
        },
    };
}
function processError(error) {
    const rawRumEvent = {
        date: error.startClocks.timeStamp,
        error: {
            id: (0,stringUtils/* generateUUID */.DO)(),
            message: error.message,
            source: error.source,
            stack: error.stack,
            handling_stack: error.handlingStack,
            component_stack: error.componentStack,
            type: error.type,
            handling: error.handling,
            causes: error.causes,
            source_type: 'browser',
            fingerprint: error.fingerprint,
            csp: error.csp,
        },
        type: RumEventType.ERROR,
        context: error.context,
    };
    const domainContext = {
        error: error.originalError,
        handlingStack: error.handlingStack,
    };
    return {
        rawRumEvent,
        startTime: error.startClocks.relative,
        domainContext,
    };
}
//# sourceMappingURL=errorCollection.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/requestIdleCallback.js
var requestIdleCallback = __webpack_require__(21337);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/taskQueue.js


/**
 * Maximum delay before starting to execute tasks in the queue. We don't want to wait too long
 * before running tasks, as it might hurt reliability (ex: if the user navigates away, we might lose
 * the opportunity to send some data). We also don't want to run tasks too often, as it might hurt
 * performance.
 */
const IDLE_CALLBACK_TIMEOUT = timeUtils/* ONE_SECOND */.WT;
/**
 * Maximum amount of time allocated to running tasks when a timeout (`IDLE_CALLBACK_TIMEOUT`) is
 * reached. We should not run tasks for too long as it will hurt performance, but we should still
 * run some tasks to avoid postponing them forever.
 *
 * Rational: Running tasks for 30ms every second (IDLE_CALLBACK_TIMEOUT) should be acceptable.
 */
const MAX_EXECUTION_TIME_ON_TIMEOUT = 30;
function createTaskQueue() {
    const pendingTasks = [];
    function run(deadline) {
        let executionTimeRemaining;
        if (deadline.didTimeout) {
            const start = performance.now();
            executionTimeRemaining = () => MAX_EXECUTION_TIME_ON_TIMEOUT - (performance.now() - start);
        }
        else {
            executionTimeRemaining = deadline.timeRemaining.bind(deadline);
        }
        while (executionTimeRemaining() > 0 && pendingTasks.length) {
            pendingTasks.shift()();
        }
        if (pendingTasks.length) {
            scheduleNextRun();
        }
    }
    function scheduleNextRun() {
        (0,requestIdleCallback/* requestIdleCallback */.Kk)(run, { timeout: IDLE_CALLBACK_TIMEOUT });
    }
    return {
        push(task) {
            if (pendingTasks.push(task) === 1) {
                scheduleNextRun();
            }
        },
        stop() {
            pendingTasks.length = 0;
        },
    };
}
//# sourceMappingURL=taskQueue.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/resource/matchRequestResourceEntry.js


const alreadyMatchedEntries = new WeakSet();
/**
 * Look for corresponding timing in resource timing buffer
 *
 * Observations:
 * - Timing (start, end) are nested inside the request (start, end)
 * - Some timing can be not exactly nested, being off by < 1 ms
 *
 * Strategy:
 * - from valid nested entries (with 1 ms error margin)
 * - filter out timing that were already matched to a request
 * - then, if a single timing match, return the timing
 * - otherwise we can't decide, return undefined
 */
function matchRequestResourceEntry(request) {
    if (!performance || !('getEntriesByName' in performance)) {
        return;
    }
    const sameNameEntries = performance.getEntriesByName(request.url, 'resource');
    if (!sameNameEntries.length || !('toJSON' in sameNameEntries[0])) {
        return;
    }
    const candidates = sameNameEntries
        .filter((entry) => !alreadyMatchedEntries.has(entry))
        .filter((entry) => hasValidResourceEntryDuration(entry) && hasValidResourceEntryTimings(entry))
        .filter((entry) => isBetween(entry, request.startClocks.relative, endTime({ startTime: request.startClocks.relative, duration: request.duration })));
    if (candidates.length === 1) {
        alreadyMatchedEntries.add(candidates[0]);
        return candidates[0].toJSON();
    }
    return;
}
function endTime(timing) {
    return (0,timeUtils/* addDuration */.WK)(timing.startTime, timing.duration);
}
function isBetween(timing, start, end) {
    const errorMargin = 1;
    return timing.startTime >= start - errorMargin && endTime(timing) <= (0,timeUtils/* addDuration */.WK)(end, errorMargin);
}
//# sourceMappingURL=matchRequestResourceEntry.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/browser/runOnReadyState.js
var runOnReadyState = __webpack_require__(10193);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/tracing/getDocumentTraceId.js


const INITIAL_DOCUMENT_OUTDATED_TRACE_ID_THRESHOLD = 2 * timeUtils/* ONE_MINUTE */.yR;
function getDocumentTraceId(document) {
    const data = getDocumentTraceDataFromMeta(document) || getDocumentTraceDataFromComment(document);
    if (!data || data.traceTime <= (0,timeUtils/* dateNow */.m6)() - INITIAL_DOCUMENT_OUTDATED_TRACE_ID_THRESHOLD) {
        return undefined;
    }
    return data.traceId;
}
function getDocumentTraceDataFromMeta(document) {
    const traceIdMeta = document.querySelector('meta[name=dd-trace-id]');
    const traceTimeMeta = document.querySelector('meta[name=dd-trace-time]');
    return createDocumentTraceData(traceIdMeta && traceIdMeta.content, traceTimeMeta && traceTimeMeta.content);
}
function getDocumentTraceDataFromComment(document) {
    const comment = findTraceComment(document);
    if (!comment) {
        return undefined;
    }
    return createDocumentTraceData((0,stringUtils/* findCommaSeparatedValue */.MY)(comment, 'trace-id'), (0,stringUtils/* findCommaSeparatedValue */.MY)(comment, 'trace-time'));
}
function createDocumentTraceData(traceId, rawTraceTime) {
    const traceTime = rawTraceTime && Number(rawTraceTime);
    if (!traceId || !traceTime) {
        return undefined;
    }
    return {
        traceId,
        traceTime,
    };
}
function findTraceComment(document) {
    // 1. Try to find the comment as a direct child of the document
    // Note: TSLint advises to use a 'for of', but TS doesn't allow to use 'for of' if the iterated
    // value is not an array or string (here, a NodeList).
    for (let i = 0; i < document.childNodes.length; i += 1) {
        const comment = getTraceCommentFromNode(document.childNodes[i]);
        if (comment) {
            return comment;
        }
    }
    // 2. If the comment is placed after the </html> tag, but have some space or new lines before or
    // after, the DOM parser will lift it (and the surrounding text) at the end of the <body> tag.
    // Try to look for the comment at the end of the <body> by by iterating over its child nodes in
    // reverse order, stopping if we come across a non-text node.
    if (document.body) {
        for (let i = document.body.childNodes.length - 1; i >= 0; i -= 1) {
            const node = document.body.childNodes[i];
            const comment = getTraceCommentFromNode(node);
            if (comment) {
                return comment;
            }
            if (!isTextNode(node)) {
                break;
            }
        }
    }
}
function getTraceCommentFromNode(node) {
    if (node && isCommentNode(node)) {
        const match = /^\s*DATADOG;(.*?)\s*$/.exec(node.data);
        if (match) {
            return match[1];
        }
    }
}
//# sourceMappingURL=getDocumentTraceId.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/browser/performanceUtils.js


function getNavigationEntry() {
    if (supportPerformanceTimingEvent(RumPerformanceEntryType.NAVIGATION)) {
        const navigationEntry = performance.getEntriesByType(RumPerformanceEntryType.NAVIGATION)[0];
        if (navigationEntry) {
            return navigationEntry;
        }
    }
    const timings = computeTimingsFromDeprecatedPerformanceTiming();
    const entry = {
        entryType: RumPerformanceEntryType.NAVIGATION,
        initiatorType: 'navigation',
        name: window.location.href,
        startTime: 0,
        duration: timings.loadEventEnd,
        decodedBodySize: 0,
        encodedBodySize: 0,
        transferSize: 0,
        workerStart: 0,
        toJSON: () => ({ ...entry, toJSON: undefined }),
        ...timings,
    };
    return entry;
}
function computeTimingsFromDeprecatedPerformanceTiming() {
    const result = {};
    const timing = performance.timing;
    for (const key in timing) {
        if ((0,numberUtils/* isNumber */.hj)(timing[key])) {
            const numberKey = key;
            const timingElement = timing[numberKey];
            result[numberKey] = timingElement === 0 ? 0 : (0,timeUtils/* getRelativeTime */.ni)(timingElement);
        }
    }
    return result;
}
//# sourceMappingURL=performanceUtils.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/resource/retrieveInitialDocumentResourceTiming.js





function retrieveInitialDocumentResourceTiming(configuration, callback, getNavigationEntryImpl = getNavigationEntry) {
    (0,runOnReadyState/* runOnReadyState */.T)(configuration, 'interactive', () => {
        const navigationEntry = getNavigationEntryImpl();
        const entry = Object.assign(navigationEntry.toJSON(), {
            entryType: RumPerformanceEntryType.RESOURCE,
            initiatorType: FAKE_INITIAL_DOCUMENT,
            // The ResourceTiming duration entry should be `responseEnd - startTime`. With
            // NavigationTiming entries, `startTime` is always 0, so set it to `responseEnd`.
            duration: navigationEntry.responseEnd,
            traceId: getDocumentTraceId(document),
            toJSON: () => ({ ...entry, toJSON: undefined }),
        });
        callback(entry);
    });
}
//# sourceMappingURL=retrieveInitialDocumentResourceTiming.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/resource/requestRegistry.js

// Maximum number of requests to keep in the registry. Requests should be removed quite quickly in
// general, this is just a safety limit to avoid memory leaks in case of a bug.
const MAX_REQUESTS = 1000;
function createRequestRegistry(lifeCycle) {
    const requests = new Set();
    const subscription = lifeCycle.subscribe(8 /* LifeCycleEventType.REQUEST_COMPLETED */, (request) => {
        requests.add(request);
        if (requests.size > MAX_REQUESTS) {
            // monitor-until: 2026-01-01, after early request collection GA
            (0,telemetry_telemetry/* addTelemetryDebug */.eJ)('Too many requests');
            requests.delete(requests.values().next().value);
        }
    });
    return {
        getMatchingRequest(entry) {
            // Returns the closest request object that happened before the entry
            let minTimeDifference = Infinity;
            let closestRequest;
            for (const request of requests) {
                const timeDifference = entry.startTime - request.startClocks.relative;
                if (0 <= timeDifference && timeDifference < minTimeDifference && request.url === entry.name) {
                    minTimeDifference = Math.abs(timeDifference);
                    closestRequest = request;
                }
            }
            if (closestRequest) {
                requests.delete(closestRequest);
            }
            return closestRequest;
        },
        stop() {
            subscription.unsubscribe();
        },
    };
}
//# sourceMappingURL=requestRegistry.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/resource/resourceCollection.js









function startResourceCollection(lifeCycle, configuration, pageStateHistory, taskQueue = createTaskQueue(), retrieveInitialDocumentResourceTimingImpl = retrieveInitialDocumentResourceTiming) {
    let requestRegistry;
    const isEarlyRequestCollectionEnabled = configuration.trackEarlyRequests;
    if (isEarlyRequestCollectionEnabled) {
        requestRegistry = createRequestRegistry(lifeCycle);
    }
    else {
        lifeCycle.subscribe(8 /* LifeCycleEventType.REQUEST_COMPLETED */, (request) => {
            handleResource(() => processRequest(request, configuration, pageStateHistory));
        });
    }
    const performanceResourceSubscription = createPerformanceObservable(configuration, {
        type: RumPerformanceEntryType.RESOURCE,
        buffered: true,
    }).subscribe((entries) => {
        for (const entry of entries) {
            if (isEarlyRequestCollectionEnabled || !isResourceEntryRequestType(entry)) {
                handleResource(() => processResourceEntry(entry, configuration, pageStateHistory, requestRegistry));
            }
        }
    });
    retrieveInitialDocumentResourceTimingImpl(configuration, (timing) => {
        handleResource(() => processResourceEntry(timing, configuration, pageStateHistory, requestRegistry));
    });
    function handleResource(computeRawEvent) {
        taskQueue.push(() => {
            const rawEvent = computeRawEvent();
            if (rawEvent) {
                lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, rawEvent);
            }
        });
    }
    return {
        stop: () => {
            taskQueue.stop();
            performanceResourceSubscription.unsubscribe();
        },
    };
}
function processRequest(request, configuration, pageStateHistory) {
    const matchingTiming = matchRequestResourceEntry(request);
    return assembleResource(matchingTiming, request, pageStateHistory, configuration);
}
function processResourceEntry(entry, configuration, pageStateHistory, requestRegistry) {
    const matchingRequest = isResourceEntryRequestType(entry) && requestRegistry ? requestRegistry.getMatchingRequest(entry) : undefined;
    return assembleResource(entry, matchingRequest, pageStateHistory, configuration);
}
// TODO: In the future, the `entry` parameter should be required, making things simpler.
function assembleResource(entry, request, pageStateHistory, configuration) {
    if (!entry && !request) {
        return;
    }
    const tracingInfo = request
        ? computeRequestTracingInfo(request, configuration)
        : computeResourceEntryTracingInfo(entry, configuration);
    if (!configuration.trackResources && !tracingInfo) {
        return;
    }
    const startClocks = entry ? (0,timeUtils/* relativeToClocks */.DY)(entry.startTime) : request.startClocks;
    const duration = entry
        ? computeResourceEntryDuration(entry)
        : computeRequestDuration(pageStateHistory, startClocks, request.duration);
    const graphql = request && computeGraphQlMetaData(request, configuration);
    const resourceEvent = (0,mergeInto/* combine */.$e)({
        date: startClocks.timeStamp,
        resource: {
            id: (0,stringUtils/* generateUUID */.DO)(),
            duration: (0,timeUtils/* toServerDuration */.c0)(duration),
            // TODO: in the future when `entry` is required, we can probably only rely on `computeResourceEntryType`
            type: request
                ? request.type === RequestType.XHR
                    ? ResourceType.XHR
                    : ResourceType.FETCH
                : computeResourceEntryType(entry),
            method: request ? request.method : undefined,
            status_code: request ? request.status : discardZeroStatus(entry.responseStatus),
            url: request ? sanitizeIfLongDataUrl(request.url) : entry.name,
            protocol: entry && computeResourceEntryProtocol(entry),
            delivery_type: entry && computeResourceEntryDeliveryType(entry),
            graphql,
        },
        type: RumEventType.RESOURCE,
        _dd: {
            discarded: !configuration.trackResources,
        },
    }, tracingInfo, entry && computeResourceEntryMetrics(entry));
    return {
        startTime: startClocks.relative,
        duration,
        rawRumEvent: resourceEvent,
        domainContext: getResourceDomainContext(entry, request),
    };
}
function computeGraphQlMetaData(request, configuration) {
    const graphQlConfig = findGraphQlConfiguration(request.url, configuration);
    if (!graphQlConfig) {
        return;
    }
    return extractGraphQlMetadata(request, graphQlConfig);
}
function getResourceDomainContext(entry, request) {
    if (request) {
        const baseDomainContext = {
            performanceEntry: entry,
            isAborted: request.isAborted,
            handlingStack: request.handlingStack,
        };
        if (request.type === RequestType.XHR) {
            return {
                xhr: request.xhr,
                ...baseDomainContext,
            };
        }
        return {
            requestInput: request.input,
            requestInit: request.init,
            response: request.response,
            error: request.error,
            ...baseDomainContext,
        };
    }
    return {
        // Currently, at least one of `entry` or `request` must be defined when calling this function.
        // So `entry` is guaranteed to be defined here. In the future, when `entry` is required, we can
        // remove the `!` assertion.
        performanceEntry: entry,
    };
}
function computeResourceEntryMetrics(entry) {
    const { renderBlockingStatus } = entry;
    return {
        resource: {
            render_blocking_status: renderBlockingStatus,
            ...computeResourceEntrySize(entry),
            ...computeResourceEntryDetails(entry),
        },
    };
}
function computeRequestTracingInfo(request, configuration) {
    const hasBeenTraced = request.traceSampled && request.traceId && request.spanId;
    if (!hasBeenTraced) {
        return undefined;
    }
    return {
        _dd: {
            span_id: request.spanId.toString(),
            trace_id: request.traceId.toString(),
            rule_psr: configuration.rulePsr,
        },
    };
}
function computeResourceEntryTracingInfo(entry, configuration) {
    const hasBeenTraced = entry.traceId;
    if (!hasBeenTraced) {
        return undefined;
    }
    return {
        _dd: {
            trace_id: entry.traceId,
            span_id: createSpanIdentifier().toString(),
            rule_psr: configuration.rulePsr,
        },
    };
}
function computeRequestDuration(pageStateHistory, startClocks, duration) {
    return !pageStateHistory.wasInPageStateDuringPeriod("frozen" /* PageState.FROZEN */, startClocks.relative, duration)
        ? duration
        : undefined;
}
/**
 * The status is 0 for cross-origin resources without CORS headers, so the status is meaningless, and we shouldn't report it
 * https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/responseStatus#cross-origin_response_status_codes
 */
function discardZeroStatus(statusCode) {
    return statusCode === 0 ? undefined : statusCode;
}
//# sourceMappingURL=resourceCollection.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/timezone.js
function getTimeZone() {
    try {
        const intl = new Intl.DateTimeFormat();
        return intl.resolvedOptions().timeZone;
    }
    catch (_a) {
        return undefined;
    }
}
//# sourceMappingURL=timezone.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/view/trackViewEventCounts.js

function trackViewEventCounts(lifeCycle, viewId, onChange) {
    const { stop, eventCounts } = trackEventCounts({
        lifeCycle,
        isChildEvent: (event) => event.view.id === viewId,
        onChange,
    });
    return {
        stop,
        eventCounts,
    };
}
//# sourceMappingURL=trackViewEventCounts.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackFirstContentfulPaint.js


// Discard FCP timings above a certain delay to avoid incorrect data
// It happens in some cases like sleep mode or some browser implementations
const FCP_MAXIMUM_DELAY = 10 * timeUtils/* ONE_MINUTE */.yR;
function trackFirstContentfulPaint(configuration, firstHidden, callback) {
    const performanceSubscription = createPerformanceObservable(configuration, {
        type: RumPerformanceEntryType.PAINT,
        buffered: true,
    }).subscribe((entries) => {
        const fcpEntry = entries.find((entry) => entry.name === 'first-contentful-paint' &&
            entry.startTime < firstHidden.timeStamp &&
            entry.startTime < FCP_MAXIMUM_DELAY);
        if (fcpEntry) {
            callback(fcpEntry.startTime);
        }
    });
    return {
        stop: performanceSubscription.unsubscribe,
    };
}
/**
 * Measure the First Contentful Paint after a BFCache restoration.
 * The DOM is restored synchronously, so we approximate the FCP with the first frame
 * rendered just after the pageshow event, using two nested requestAnimationFrame calls.
 */
function trackRestoredFirstContentfulPaint(viewStartRelative, callback) {
    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            callback((0,timeUtils/* elapsed */._J)(viewStartRelative, (0,timeUtils/* relativeNow */._q)()));
        });
    });
}
//# sourceMappingURL=trackFirstContentfulPaint.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackFirstInput.js




/**
 * Track the first input occurring during the initial View to return:
 * - First Input Delay
 * - First Input Time
 * Callback is called at most one time.
 * Documentation: https://web.dev/fid/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/getFID.ts
 */
function trackFirstInput(configuration, firstHidden, callback) {
    const performanceFirstInputSubscription = createPerformanceObservable(configuration, {
        type: RumPerformanceEntryType.FIRST_INPUT,
        buffered: true,
    }).subscribe((entries) => {
        const firstInputEntry = entries.find((entry) => entry.startTime < firstHidden.timeStamp);
        if (firstInputEntry) {
            const firstInputDelay = (0,timeUtils/* elapsed */._J)(firstInputEntry.startTime, firstInputEntry.processingStart);
            let firstInputTargetSelector;
            if (firstInputEntry.target && isElementNode(firstInputEntry.target)) {
                firstInputTargetSelector = getSelectorFromElement(firstInputEntry.target, configuration.actionNameAttribute);
            }
            callback({
                // Ensure firstInputDelay to be positive, see
                // https://bugs.chromium.org/p/chromium/issues/detail?id=1185815
                delay: firstInputDelay >= 0 ? firstInputDelay : 0,
                time: firstInputEntry.startTime,
                targetSelector: firstInputTargetSelector,
            });
        }
    });
    return {
        stop: () => {
            performanceFirstInputSubscription.unsubscribe();
        },
    };
}
//# sourceMappingURL=trackFirstInput.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackNavigationTimings.js


function trackNavigationTimings(configuration, callback, getNavigationEntryImpl = getNavigationEntry) {
    return waitAfterLoadEvent(configuration, () => {
        const entry = getNavigationEntryImpl();
        if (!isIncompleteNavigation(entry)) {
            callback(processNavigationEntry(entry));
        }
    });
}
function processNavigationEntry(entry) {
    return {
        domComplete: entry.domComplete,
        domContentLoaded: entry.domContentLoadedEventEnd,
        domInteractive: entry.domInteractive,
        loadEvent: entry.loadEventEnd,
        // In some cases the value reported is negative or is larger
        // than the current page time. Ignore these cases:
        // https://github.com/GoogleChrome/web-vitals/issues/137
        // https://github.com/GoogleChrome/web-vitals/issues/162
        firstByte: entry.responseStart >= 0 && entry.responseStart <= (0,timeUtils/* relativeNow */._q)() ? entry.responseStart : undefined,
    };
}
function isIncompleteNavigation(entry) {
    return entry.loadEventEnd <= 0;
}
function waitAfterLoadEvent(configuration, callback) {
    let timeoutId;
    const { stop: stopOnReadyState } = (0,runOnReadyState/* runOnReadyState */.T)(configuration, 'complete', () => {
        // Invoke the callback a bit after the actual load event, so the "loadEventEnd" timing is accurate
        timeoutId = (0,timer/* setTimeout */.iK)(() => callback());
    });
    return {
        stop: () => {
            stopOnReadyState();
            (0,timer/* clearTimeout */.gr)(timeoutId);
        },
    };
}
//# sourceMappingURL=trackNavigationTimings.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackLargestContentfulPaint.js



// Discard LCP timings above a certain delay to avoid incorrect data
// It happens in some cases like sleep mode or some browser implementations
const LCP_MAXIMUM_DELAY = 10 * timeUtils/* ONE_MINUTE */.yR;
/**
 * Track the largest contentful paint (LCP) occurring during the initial View.  This can yield
 * multiple values, only the most recent one should be used.
 * Documentation: https://web.dev/lcp/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/onLCP.ts
 */
function trackLargestContentfulPaint(configuration, firstHidden, eventTarget, callback) {
    // Ignore entries that come after the first user interaction. According to the documentation, the
    // browser should not send largest-contentful-paint entries after a user interact with the page,
    // but the web-vitals reference implementation uses this as a safeguard.
    let firstInteractionTimestamp = Infinity;
    const { stop: stopEventListener } = (0,addEventListener/* addEventListeners */.y)(configuration, eventTarget, ["pointerdown" /* DOM_EVENT.POINTER_DOWN */, "keydown" /* DOM_EVENT.KEY_DOWN */], (event) => {
        firstInteractionTimestamp = event.timeStamp;
    }, { capture: true, once: true });
    let biggestLcpSize = 0;
    const performanceLcpSubscription = createPerformanceObservable(configuration, {
        type: RumPerformanceEntryType.LARGEST_CONTENTFUL_PAINT,
        buffered: true,
    }).subscribe((entries) => {
        const lcpEntry = (0,polyfills/* findLast */.dF)(entries, (entry) => entry.entryType === RumPerformanceEntryType.LARGEST_CONTENTFUL_PAINT &&
            entry.startTime < firstInteractionTimestamp &&
            entry.startTime < firstHidden.timeStamp &&
            entry.startTime < LCP_MAXIMUM_DELAY &&
            // Ensure to get the LCP entry with the biggest size, see
            // https://bugs.chromium.org/p/chromium/issues/detail?id=1516655
            entry.size > biggestLcpSize);
        if (lcpEntry) {
            let lcpTargetSelector;
            if (lcpEntry.element) {
                lcpTargetSelector = getSelectorFromElement(lcpEntry.element, configuration.actionNameAttribute);
            }
            callback({
                value: lcpEntry.startTime,
                targetSelector: lcpTargetSelector,
                resourceUrl: computeLcpEntryUrl(lcpEntry),
            });
            biggestLcpSize = lcpEntry.size;
        }
    });
    return {
        stop: () => {
            stopEventListener();
            performanceLcpSubscription.unsubscribe();
        },
    };
}
// The property url report an empty string if the value is not available, we shouldn't report it in this case.
function computeLcpEntryUrl(entry) {
    return entry.url === '' ? undefined : entry.url;
}
//# sourceMappingURL=trackLargestContentfulPaint.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackFirstHidden.js


function trackFirstHidden(configuration, viewStart, eventTarget = window) {
    if (document.visibilityState === 'hidden') {
        return { timeStamp: 0, stop: functionUtils/* noop */.Z };
    }
    if (supportPerformanceTimingEvent(RumPerformanceEntryType.VISIBILITY_STATE)) {
        const firstHiddenEntry = performance
            .getEntriesByType(RumPerformanceEntryType.VISIBILITY_STATE)
            .filter((entry) => entry.name === 'hidden')
            .find((entry) => entry.startTime >= viewStart.relative);
        if (firstHiddenEntry) {
            return { timeStamp: firstHiddenEntry.startTime, stop: functionUtils/* noop */.Z };
        }
    }
    let timeStamp = Infinity;
    const { stop } = (0,addEventListener/* addEventListeners */.y)(configuration, eventTarget, ["pagehide" /* DOM_EVENT.PAGE_HIDE */, "visibilitychange" /* DOM_EVENT.VISIBILITY_CHANGE */], (event) => {
        if (event.type === "pagehide" /* DOM_EVENT.PAGE_HIDE */ || document.visibilityState === 'hidden') {
            timeStamp = event.timeStamp;
            stop();
        }
    }, { capture: true });
    return {
        get timeStamp() {
            return timeStamp;
        },
        stop,
    };
}
//# sourceMappingURL=trackFirstHidden.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackInitialViewMetrics.js





function trackInitialViewMetrics(configuration, viewStart, setLoadEvent, scheduleViewUpdate) {
    const initialViewMetrics = {};
    const { stop: stopNavigationTracking } = trackNavigationTimings(configuration, (navigationTimings) => {
        setLoadEvent(navigationTimings.loadEvent);
        initialViewMetrics.navigationTimings = navigationTimings;
        scheduleViewUpdate();
    });
    const firstHidden = trackFirstHidden(configuration, viewStart);
    const { stop: stopFCPTracking } = trackFirstContentfulPaint(configuration, firstHidden, (firstContentfulPaint) => {
        initialViewMetrics.firstContentfulPaint = firstContentfulPaint;
        scheduleViewUpdate();
    });
    const { stop: stopLCPTracking } = trackLargestContentfulPaint(configuration, firstHidden, window, (largestContentfulPaint) => {
        initialViewMetrics.largestContentfulPaint = largestContentfulPaint;
        scheduleViewUpdate();
    });
    const { stop: stopFIDTracking } = trackFirstInput(configuration, firstHidden, (firstInput) => {
        initialViewMetrics.firstInput = firstInput;
        scheduleViewUpdate();
    });
    function stop() {
        stopNavigationTracking();
        stopFCPTracking();
        stopLCPTracking();
        stopFIDTracking();
        firstHidden.stop();
    }
    return {
        stop,
        initialViewMetrics,
    };
}
//# sourceMappingURL=trackInitialViewMetrics.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/getClsAttributionImpactedArea.js
/**
 * Calculates the area of a rectangle given its width and height
 */
const calculateArea = (width, height) => width * height;
/**
 * Calculates the intersection area between two rectangles
 */
const calculateIntersectionArea = (rect1, rect2) => {
    const left = Math.max(rect1.left, rect2.left);
    const top = Math.max(rect1.top, rect2.top);
    const right = Math.min(rect1.right, rect2.right);
    const bottom = Math.min(rect1.bottom, rect2.bottom);
    if (left >= right || top >= bottom) {
        return 0;
    }
    return calculateArea(right - left, bottom - top);
};
/**
 * Calculates the total impacted area of a layout shift source
 * This is the sum of the previous and current areas minus their intersection
 */
const getClsAttributionImpactedArea = (source) => {
    const previousArea = calculateArea(source.previousRect.width, source.previousRect.height);
    const currentArea = calculateArea(source.currentRect.width, source.currentRect.height);
    const intersectionArea = calculateIntersectionArea(source.previousRect, source.currentRect);
    return previousArea + currentArea - intersectionArea;
};
//# sourceMappingURL=getClsAttributionImpactedArea.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackCumulativeLayoutShift.js





/**
 * Track the cumulative layout shifts (CLS).
 * Layout shifts are grouped into session windows.
 * The minimum gap between session windows is 1 second.
 * The maximum duration of a session window is 5 second.
 * The session window layout shift value is the sum of layout shifts inside it.
 * The CLS value is the max of session windows values.
 *
 * This yields a new value whenever the CLS value is updated (a higher session window value is computed).
 *
 * See isLayoutShiftSupported to check for browser support.
 *
 * Documentation:
 * https://web.dev/cls/
 * https://web.dev/evolving-cls/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/getCLS.ts
 */
function trackCumulativeLayoutShift(configuration, viewStart, callback) {
    if (!isLayoutShiftSupported()) {
        return {
            stop: functionUtils/* noop */.Z,
        };
    }
    let maxClsValue = 0;
    let biggestShift;
    // if no layout shift happen the value should be reported as 0
    callback({
        value: 0,
    });
    const slidingWindow = slidingSessionWindow();
    const performanceSubscription = createPerformanceObservable(configuration, {
        type: RumPerformanceEntryType.LAYOUT_SHIFT,
        buffered: true,
    }).subscribe((entries) => {
        var _a;
        for (const entry of entries) {
            if (entry.hadRecentInput || entry.startTime < viewStart) {
                continue;
            }
            const { cumulatedValue, isMaxValue } = slidingWindow.update(entry);
            if (isMaxValue) {
                const attribution = getTopImpactedElement(entry.sources);
                biggestShift = {
                    target: (attribution === null || attribution === void 0 ? void 0 : attribution.node) ? new WeakRef(attribution.node) : undefined,
                    time: (0,timeUtils/* elapsed */._J)(viewStart, entry.startTime),
                    previousRect: attribution === null || attribution === void 0 ? void 0 : attribution.previousRect,
                    currentRect: attribution === null || attribution === void 0 ? void 0 : attribution.currentRect,
                    devicePixelRatio: window.devicePixelRatio,
                };
            }
            if (cumulatedValue > maxClsValue) {
                maxClsValue = cumulatedValue;
                const target = (_a = biggestShift === null || biggestShift === void 0 ? void 0 : biggestShift.target) === null || _a === void 0 ? void 0 : _a.deref();
                callback({
                    value: (0,numberUtils/* round */.NM)(maxClsValue, 4),
                    targetSelector: target && getSelectorFromElement(target, configuration.actionNameAttribute),
                    time: biggestShift === null || biggestShift === void 0 ? void 0 : biggestShift.time,
                    previousRect: (biggestShift === null || biggestShift === void 0 ? void 0 : biggestShift.previousRect) ? asRumRect(biggestShift.previousRect) : undefined,
                    currentRect: (biggestShift === null || biggestShift === void 0 ? void 0 : biggestShift.currentRect) ? asRumRect(biggestShift.currentRect) : undefined,
                    devicePixelRatio: biggestShift === null || biggestShift === void 0 ? void 0 : biggestShift.devicePixelRatio,
                });
            }
        }
    });
    return {
        stop: () => {
            performanceSubscription.unsubscribe();
        },
    };
}
function getTopImpactedElement(sources) {
    let topImpactedSource;
    for (const source of sources) {
        if (source.node && isElementNode(source.node)) {
            const currentImpactedArea = getClsAttributionImpactedArea(source);
            if (!topImpactedSource || getClsAttributionImpactedArea(topImpactedSource) < currentImpactedArea) {
                topImpactedSource = source;
            }
        }
    }
    return topImpactedSource;
}
function asRumRect({ x, y, width, height }) {
    return { x, y, width, height };
}
const MAX_WINDOW_DURATION = 5 * timeUtils/* ONE_SECOND */.WT;
const MAX_UPDATE_GAP = timeUtils/* ONE_SECOND */.WT;
function slidingSessionWindow() {
    let cumulatedValue = 0;
    let startTime;
    let endTime;
    let maxValue = 0;
    return {
        update: (entry) => {
            const shouldCreateNewWindow = startTime === undefined ||
                entry.startTime - endTime >= MAX_UPDATE_GAP ||
                entry.startTime - startTime >= MAX_WINDOW_DURATION;
            let isMaxValue;
            if (shouldCreateNewWindow) {
                startTime = endTime = entry.startTime;
                maxValue = cumulatedValue = entry.value;
                isMaxValue = true;
            }
            else {
                cumulatedValue += entry.value;
                endTime = entry.startTime;
                isMaxValue = entry.value > maxValue;
                if (isMaxValue) {
                    maxValue = entry.value;
                }
            }
            return {
                cumulatedValue,
                isMaxValue,
            };
        },
    };
}
/**
 * Check whether `layout-shift` is supported by the browser.
 */
function isLayoutShiftSupported() {
    return supportPerformanceTimingEvent(RumPerformanceEntryType.LAYOUT_SHIFT) && 'WeakRef' in window;
}
//# sourceMappingURL=trackCumulativeLayoutShift.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/interactionCountPolyfill.js
/**
 * performance.interactionCount polyfill
 *
 * The interactionCount is an integer which counts the total number of distinct user interactions,
 * for which there was a unique interactionId.
 *
 * The interactionCount polyfill is an estimate based on a convention specific to Chrome. Cf: https://github.com/GoogleChrome/web-vitals/pull/213
 * This is currently not an issue as the polyfill is only used for INP which is currently only supported on Chrome.
 * Hopefully when/if other browsers will support INP, they will also implement performance.interactionCount at the same time, so we won't need that polyfill.
 *
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/polyfills/interactionCountPolyfill.ts
 */

let observer;
let interactionCountEstimate = 0;
let minKnownInteractionId = Infinity;
let maxKnownInteractionId = 0;
function initInteractionCountPolyfill() {
    if ('interactionCount' in performance || observer) {
        return;
    }
    observer = new window.PerformanceObserver((0,monitor/* monitor */.zk)((entries) => {
        entries.getEntries().forEach((e) => {
            const entry = e;
            if (entry.interactionId) {
                minKnownInteractionId = Math.min(minKnownInteractionId, entry.interactionId);
                maxKnownInteractionId = Math.max(maxKnownInteractionId, entry.interactionId);
                interactionCountEstimate = (maxKnownInteractionId - minKnownInteractionId) / 7 + 1;
            }
        });
    }));
    observer.observe({ type: 'event', buffered: true, durationThreshold: 0 });
}
/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */
const getInteractionCount = () => observer ? interactionCountEstimate : window.performance.interactionCount || 0;
//# sourceMappingURL=interactionCountPolyfill.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackInteractionToNextPaint.js







// Arbitrary value to prevent unnecessary memory usage on views with lots of interactions.
const MAX_INTERACTION_ENTRIES = 10;
// Arbitrary value to cap INP outliers
const MAX_INP_VALUE = (1 * timeUtils/* ONE_MINUTE */.yR);
/**
 * Track the interaction to next paint (INP).
 * To avoid outliers, return the p98 worst interaction of the view.
 * Documentation: https://web.dev/inp/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/main/src/onINP.ts
 */
function trackInteractionToNextPaint(configuration, viewStart, viewLoadingType) {
    if (!isInteractionToNextPaintSupported()) {
        return {
            getInteractionToNextPaint: () => undefined,
            setViewEnd: functionUtils/* noop */.Z,
            stop: functionUtils/* noop */.Z,
        };
    }
    const { getViewInteractionCount, stopViewInteractionCount } = trackViewInteractionCount(viewLoadingType);
    let viewEnd = Infinity;
    const longestInteractions = trackLongestInteractions(getViewInteractionCount);
    let interactionToNextPaint = -1;
    let interactionToNextPaintTargetSelector;
    let interactionToNextPaintStartTime;
    function handleEntries(entries) {
        for (const entry of entries) {
            if (entry.interactionId &&
                // Check the entry start time is inside the view bounds because some view interactions can be reported after the view end (if long duration).
                entry.startTime >= viewStart &&
                entry.startTime <= viewEnd) {
                longestInteractions.process(entry);
            }
        }
        const newInteraction = longestInteractions.estimateP98Interaction();
        if (newInteraction && newInteraction.duration !== interactionToNextPaint) {
            interactionToNextPaint = newInteraction.duration;
            interactionToNextPaintStartTime = (0,timeUtils/* elapsed */._J)(viewStart, newInteraction.startTime);
            interactionToNextPaintTargetSelector = getInteractionSelector(newInteraction.startTime);
            if (!interactionToNextPaintTargetSelector && newInteraction.target && isElementNode(newInteraction.target)) {
                interactionToNextPaintTargetSelector = getSelectorFromElement(newInteraction.target, configuration.actionNameAttribute);
            }
        }
    }
    const firstInputSubscription = createPerformanceObservable(configuration, {
        type: RumPerformanceEntryType.FIRST_INPUT,
        buffered: true,
    }).subscribe(handleEntries);
    const eventSubscription = createPerformanceObservable(configuration, {
        type: RumPerformanceEntryType.EVENT,
        // durationThreshold only impact PerformanceEventTiming entries used for INP computation which requires a threshold at 40 (default is 104ms)
        // cf: https://github.com/GoogleChrome/web-vitals/blob/3806160ffbc93c3c4abf210a167b81228172b31c/src/onINP.ts#L202-L210
        durationThreshold: 40,
        buffered: true,
    }).subscribe(handleEntries);
    return {
        getInteractionToNextPaint: () => {
            // If no INP duration where captured because of the performanceObserver 40ms threshold
            // but the view interaction count > 0 then report 0
            if (interactionToNextPaint >= 0) {
                return {
                    value: Math.min(interactionToNextPaint, MAX_INP_VALUE),
                    targetSelector: interactionToNextPaintTargetSelector,
                    time: interactionToNextPaintStartTime,
                };
            }
            else if (getViewInteractionCount()) {
                return {
                    value: 0,
                };
            }
        },
        setViewEnd: (viewEndTime) => {
            viewEnd = viewEndTime;
            stopViewInteractionCount();
        },
        stop: () => {
            eventSubscription.unsubscribe();
            firstInputSubscription.unsubscribe();
        },
    };
}
function trackLongestInteractions(getViewInteractionCount) {
    const longestInteractions = [];
    function sortAndTrimLongestInteractions() {
        longestInteractions.sort((a, b) => b.duration - a.duration).splice(MAX_INTERACTION_ENTRIES);
    }
    return {
        /**
         * Process the performance entry:
         * - if its duration is long enough, add the performance entry to the list of worst interactions
         * - if an entry with the same interaction id exists and its duration is lower than the new one, then replace it in the list of worst interactions
         */
        process(entry) {
            const interactionIndex = longestInteractions.findIndex((interaction) => entry.interactionId === interaction.interactionId);
            const minLongestInteraction = longestInteractions[longestInteractions.length - 1];
            if (interactionIndex !== -1) {
                if (entry.duration > longestInteractions[interactionIndex].duration) {
                    longestInteractions[interactionIndex] = entry;
                    sortAndTrimLongestInteractions();
                }
            }
            else if (longestInteractions.length < MAX_INTERACTION_ENTRIES ||
                entry.duration > minLongestInteraction.duration) {
                longestInteractions.push(entry);
                sortAndTrimLongestInteractions();
            }
        },
        /**
         * Compute the p98 longest interaction.
         * For better performance the computation is based on 10 longest interactions and the interaction count of the current view.
         */
        estimateP98Interaction() {
            const interactionIndex = Math.min(longestInteractions.length - 1, Math.floor(getViewInteractionCount() / 50));
            return longestInteractions[interactionIndex];
        },
    };
}
function trackViewInteractionCount(viewLoadingType) {
    initInteractionCountPolyfill();
    const previousInteractionCount = viewLoadingType === ViewLoadingType.INITIAL_LOAD ? 0 : getInteractionCount();
    let state = { stopped: false };
    function computeViewInteractionCount() {
        return getInteractionCount() - previousInteractionCount;
    }
    return {
        getViewInteractionCount: () => {
            if (state.stopped) {
                return state.interactionCount;
            }
            return computeViewInteractionCount();
        },
        stopViewInteractionCount: () => {
            state = { stopped: true, interactionCount: computeViewInteractionCount() };
        },
    };
}
function isInteractionToNextPaintSupported() {
    return (supportPerformanceTimingEvent(RumPerformanceEntryType.EVENT) &&
        window.PerformanceEventTiming &&
        'interactionId' in PerformanceEventTiming.prototype);
}
//# sourceMappingURL=trackInteractionToNextPaint.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackLoadingTime.js




/**
 * For non-initial views (such as route changes or BFCache restores), the regular load event does not fire
 * In these cases, trackLoadingTime can only emit a loadingTime  if waitPageActivityEnd detects some post-restore activity.
 * If nothing happens after the view starts,no candidate is recorded and loadingTime stays undefined.
 */
function trackLoadingTime(lifeCycle, domMutationObservable, windowOpenObservable, configuration, loadType, viewStart, callback) {
    let isWaitingForLoadEvent = loadType === ViewLoadingType.INITIAL_LOAD;
    let isWaitingForActivityLoadingTime = true;
    const loadingTimeCandidates = [];
    const firstHidden = trackFirstHidden(configuration, viewStart);
    function invokeCallbackIfAllCandidatesAreReceived() {
        if (!isWaitingForActivityLoadingTime && !isWaitingForLoadEvent && loadingTimeCandidates.length > 0) {
            const loadingTime = Math.max(...loadingTimeCandidates);
            // firstHidden is a relative time from time origin, so we use the relative start time of the view to compare with the loading time
            if (loadingTime < firstHidden.timeStamp - viewStart.relative) {
                callback(loadingTime);
            }
        }
    }
    const { stop } = waitPageActivityEnd(lifeCycle, domMutationObservable, windowOpenObservable, configuration, (event) => {
        if (isWaitingForActivityLoadingTime) {
            isWaitingForActivityLoadingTime = false;
            if (event.hadActivity) {
                loadingTimeCandidates.push((0,timeUtils/* elapsed */._J)(viewStart.timeStamp, event.end));
            }
            invokeCallbackIfAllCandidatesAreReceived();
        }
    });
    return {
        stop: () => {
            stop();
            firstHidden.stop();
        },
        setLoadEvent: (loadEvent) => {
            if (isWaitingForLoadEvent) {
                isWaitingForLoadEvent = false;
                loadingTimeCandidates.push(loadEvent);
                invokeCallbackIfAllCandidatesAreReceived();
            }
        },
    };
}
//# sourceMappingURL=trackLoadingTime.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/browser/scroll.js
function getScrollX() {
    let scrollX;
    const visual = window.visualViewport;
    if (visual) {
        scrollX = visual.pageLeft - visual.offsetLeft;
    }
    else if (window.scrollX !== undefined) {
        scrollX = window.scrollX;
    }
    else {
        scrollX = window.pageXOffset || 0;
    }
    return Math.round(scrollX);
}
function getScrollY() {
    let scrollY;
    const visual = window.visualViewport;
    if (visual) {
        scrollY = visual.pageTop - visual.offsetTop;
    }
    else if (window.scrollY !== undefined) {
        scrollY = window.scrollY;
    }
    else {
        scrollY = window.pageYOffset || 0;
    }
    return Math.round(scrollY);
}
//# sourceMappingURL=scroll.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/browser/viewportObservable.js

let viewportObservable;
function initViewportObservable(configuration) {
    if (!viewportObservable) {
        viewportObservable = createViewportObservable(configuration);
    }
    return viewportObservable;
}
function createViewportObservable(configuration) {
    return new tools_observable/* Observable */.y$((observable) => {
        const { throttled: updateDimension } = (0,functionUtils/* throttle */.P)(() => {
            observable.notify(getViewportDimension());
        }, 200);
        return (0,addEventListener/* addEventListener */.O)(configuration, window, "resize" /* DOM_EVENT.RESIZE */, updateDimension, { capture: true, passive: true })
            .stop;
    });
}
// excludes the width and height of any rendered classic scrollbar that is fixed to the visual viewport
function getViewportDimension() {
    const visual = window.visualViewport;
    if (visual) {
        return {
            width: Number(visual.width * visual.scale),
            height: Number(visual.height * visual.scale),
        };
    }
    return {
        width: Number(window.innerWidth || 0),
        height: Number(window.innerHeight || 0),
    };
}
//# sourceMappingURL=viewportObservable.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackScrollMetrics.js



/** Arbitrary scroll throttle duration */
const THROTTLE_SCROLL_DURATION = timeUtils/* ONE_SECOND */.WT;
function trackScrollMetrics(configuration, viewStart, callback, scrollValues = createScrollValuesObservable(configuration)) {
    let maxScrollDepth = 0;
    let maxScrollHeight = 0;
    let maxScrollHeightTime = 0;
    const subscription = scrollValues.subscribe(({ scrollDepth, scrollTop, scrollHeight }) => {
        let shouldUpdate = false;
        if (scrollDepth > maxScrollDepth) {
            maxScrollDepth = scrollDepth;
            shouldUpdate = true;
        }
        if (scrollHeight > maxScrollHeight) {
            maxScrollHeight = scrollHeight;
            const now = (0,timeUtils/* relativeNow */._q)();
            maxScrollHeightTime = (0,timeUtils/* elapsed */._J)(viewStart.relative, now);
            shouldUpdate = true;
        }
        if (shouldUpdate) {
            callback({
                maxDepth: Math.min(maxScrollDepth, maxScrollHeight),
                maxDepthScrollTop: scrollTop,
                maxScrollHeight,
                maxScrollHeightTime,
            });
        }
    });
    return {
        stop: () => subscription.unsubscribe(),
    };
}
function computeScrollValues() {
    const scrollTop = getScrollY();
    const { height } = getViewportDimension();
    const scrollHeight = Math.round((document.scrollingElement || document.documentElement).scrollHeight);
    const scrollDepth = Math.round(height + scrollTop);
    return {
        scrollHeight,
        scrollDepth,
        scrollTop,
    };
}
function createScrollValuesObservable(configuration, throttleDuration = THROTTLE_SCROLL_DURATION) {
    return new tools_observable/* Observable */.y$((observable) => {
        function notify() {
            observable.notify(computeScrollValues());
        }
        if (window.ResizeObserver) {
            const throttledNotify = (0,functionUtils/* throttle */.P)(notify, throttleDuration, {
                leading: false,
                trailing: true,
            });
            const observerTarget = document.scrollingElement || document.documentElement;
            const resizeObserver = new ResizeObserver((0,monitor/* monitor */.zk)(throttledNotify.throttled));
            if (observerTarget) {
                resizeObserver.observe(observerTarget);
            }
            const eventListener = (0,addEventListener/* addEventListener */.O)(configuration, window, "scroll" /* DOM_EVENT.SCROLL */, throttledNotify.throttled, {
                passive: true,
            });
            return () => {
                throttledNotify.cancel();
                resizeObserver.disconnect();
                eventListener.stop();
            };
        }
    });
}
//# sourceMappingURL=trackScrollMetrics.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackCommonViewMetrics.js




function trackCommonViewMetrics(lifeCycle, domMutationObservable, windowOpenObservable, configuration, scheduleViewUpdate, loadingType, viewStart) {
    const commonViewMetrics = {};
    const { stop: stopLoadingTimeTracking, setLoadEvent } = trackLoadingTime(lifeCycle, domMutationObservable, windowOpenObservable, configuration, loadingType, viewStart, (newLoadingTime) => {
        commonViewMetrics.loadingTime = newLoadingTime;
        scheduleViewUpdate();
    });
    const { stop: stopScrollMetricsTracking } = trackScrollMetrics(configuration, viewStart, (newScrollMetrics) => {
        commonViewMetrics.scroll = newScrollMetrics;
    });
    const { stop: stopCLSTracking } = trackCumulativeLayoutShift(configuration, viewStart.relative, (cumulativeLayoutShift) => {
        commonViewMetrics.cumulativeLayoutShift = cumulativeLayoutShift;
        scheduleViewUpdate();
    });
    const { stop: stopINPTracking, getInteractionToNextPaint, setViewEnd, } = trackInteractionToNextPaint(configuration, viewStart.relative, loadingType);
    return {
        stop: () => {
            stopLoadingTimeTracking();
            stopCLSTracking();
            stopScrollMetricsTracking();
        },
        stopINPTracking,
        setLoadEvent,
        setViewEnd,
        getCommonViewMetrics: () => {
            commonViewMetrics.interactionToNextPaint = getInteractionToNextPaint();
            return commonViewMetrics;
        },
    };
}
//# sourceMappingURL=trackCommonViewMetrics.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/view/bfCacheSupport.js

function onBFCacheRestore(configuration, callback) {
    const { stop } = (0,addEventListener/* addEventListener */.O)(configuration, window, "pageshow" /* DOM_EVENT.PAGE_SHOW */, (event) => {
        if (event.persisted) {
            callback(event);
        }
    }, { capture: true });
    return stop;
}
//# sourceMappingURL=bfCacheSupport.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackBfcacheMetrics.js

/**
 * BFCache keeps a full in-memory snapshot of the DOM. When the page is restored, nothing needs to be fetched, so the whole
 * viewport repaints in a single frame. Consequently, LCP almost always equals FCP.
 * (See: https://github.com/GoogleChrome/web-vitals/pull/87)
 */
function trackBfcacheMetrics(viewStart, metrics, scheduleViewUpdate) {
    trackRestoredFirstContentfulPaint(viewStart.relative, (paintTime) => {
        metrics.firstContentfulPaint = paintTime;
        metrics.largestContentfulPaint = { value: paintTime };
        scheduleViewUpdate();
    });
}
//# sourceMappingURL=trackBfcacheMetrics.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/view/trackViews.js







const THROTTLE_VIEW_UPDATE_PERIOD = 3000;
const SESSION_KEEP_ALIVE_INTERVAL = 5 * timeUtils/* ONE_MINUTE */.yR;
// Some events or metrics can be captured after the end of the view. To avoid missing those;
// an arbitrary delay is added for stopping their tracking after the view ends.
//
// Ideally, we would not stop and keep tracking events or metrics until the end of the session.
// But this might have a small performance impact if there are many many views.
// So let's have a fairly short delay improving the situation in most cases and avoid impacting performances too much.
const KEEP_TRACKING_AFTER_VIEW_DELAY = 5 * timeUtils/* ONE_MINUTE */.yR;
function trackViews(location, lifeCycle, domMutationObservable, windowOpenObservable, configuration, locationChangeObservable, areViewsTrackedAutomatically, initialViewOptions) {
    const activeViews = new Set();
    let currentView = startNewView(ViewLoadingType.INITIAL_LOAD, (0,timeUtils/* clocksOrigin */.cQ)(), initialViewOptions);
    let stopOnBFCacheRestore;
    startViewLifeCycle();
    let locationChangeSubscription;
    if (areViewsTrackedAutomatically) {
        locationChangeSubscription = renewViewOnLocationChange(locationChangeObservable);
        if (configuration.trackBfcacheViews) {
            stopOnBFCacheRestore = onBFCacheRestore(configuration, (pageshowEvent) => {
                currentView.end();
                const startClocks = (0,timeUtils/* relativeToClocks */.DY)(pageshowEvent.timeStamp);
                currentView = startNewView(ViewLoadingType.BF_CACHE, startClocks, undefined);
            });
        }
    }
    function startNewView(loadingType, startClocks, viewOptions) {
        const newlyCreatedView = newView(lifeCycle, domMutationObservable, windowOpenObservable, configuration, location, loadingType, startClocks, viewOptions);
        activeViews.add(newlyCreatedView);
        newlyCreatedView.stopObservable.subscribe(() => {
            activeViews.delete(newlyCreatedView);
        });
        return newlyCreatedView;
    }
    function startViewLifeCycle() {
        lifeCycle.subscribe(10 /* LifeCycleEventType.SESSION_RENEWED */, () => {
            // Renew view on session renewal
            currentView = startNewView(ViewLoadingType.ROUTE_CHANGE, undefined, {
                name: currentView.name,
                service: currentView.service,
                version: currentView.version,
                context: currentView.contextManager.getContext(),
            });
        });
        lifeCycle.subscribe(9 /* LifeCycleEventType.SESSION_EXPIRED */, () => {
            currentView.end({ sessionIsActive: false });
        });
    }
    function renewViewOnLocationChange(locationChangeObservable) {
        return locationChangeObservable.subscribe(({ oldLocation, newLocation }) => {
            if (areDifferentLocation(oldLocation, newLocation)) {
                currentView.end();
                currentView = startNewView(ViewLoadingType.ROUTE_CHANGE);
            }
        });
    }
    return {
        addTiming: (name, time = (0,timeUtils/* timeStampNow */.n$)()) => {
            currentView.addTiming(name, time);
        },
        startView: (options, startClocks) => {
            currentView.end({ endClocks: startClocks });
            currentView = startNewView(ViewLoadingType.ROUTE_CHANGE, startClocks, options);
        },
        setViewContext: (context) => {
            currentView.contextManager.setContext(context);
        },
        setViewContextProperty: (key, value) => {
            currentView.contextManager.setContextProperty(key, value);
        },
        setViewName: (name) => {
            currentView.setViewName(name);
        },
        getViewContext: () => currentView.contextManager.getContext(),
        stop: () => {
            if (locationChangeSubscription) {
                locationChangeSubscription.unsubscribe();
            }
            if (stopOnBFCacheRestore) {
                stopOnBFCacheRestore();
            }
            currentView.end();
            activeViews.forEach((view) => view.stop());
        },
    };
}
function newView(lifeCycle, domMutationObservable, windowOpenObservable, configuration, initialLocation, loadingType, startClocks = (0,timeUtils/* clocksNow */.$I)(), viewOptions) {
    // Setup initial values
    const id = (0,stringUtils/* generateUUID */.DO)();
    const stopObservable = new tools_observable/* Observable */.y$();
    const customTimings = {};
    let documentVersion = 0;
    let endClocks;
    const location = (0,objectUtils/* shallowClone */.mv)(initialLocation);
    const contextManager = createContextManager();
    let sessionIsActive = true;
    let name = viewOptions === null || viewOptions === void 0 ? void 0 : viewOptions.name;
    const service = (viewOptions === null || viewOptions === void 0 ? void 0 : viewOptions.service) || configuration.service;
    const version = (viewOptions === null || viewOptions === void 0 ? void 0 : viewOptions.version) || configuration.version;
    const context = viewOptions === null || viewOptions === void 0 ? void 0 : viewOptions.context;
    if (context) {
        contextManager.setContext(context);
    }
    const viewCreatedEvent = {
        id,
        name,
        startClocks,
        service,
        version,
        context,
    };
    lifeCycle.notify(1 /* LifeCycleEventType.BEFORE_VIEW_CREATED */, viewCreatedEvent);
    lifeCycle.notify(2 /* LifeCycleEventType.VIEW_CREATED */, viewCreatedEvent);
    // Update the view every time the measures are changing
    const { throttled, cancel: cancelScheduleViewUpdate } = (0,functionUtils/* throttle */.P)(triggerViewUpdate, THROTTLE_VIEW_UPDATE_PERIOD, {
        leading: false,
    });
    const { setLoadEvent, setViewEnd, stop: stopCommonViewMetricsTracking, stopINPTracking, getCommonViewMetrics, } = trackCommonViewMetrics(lifeCycle, domMutationObservable, windowOpenObservable, configuration, scheduleViewUpdate, loadingType, startClocks);
    const { stop: stopInitialViewMetricsTracking, initialViewMetrics } = loadingType === ViewLoadingType.INITIAL_LOAD
        ? trackInitialViewMetrics(configuration, startClocks, setLoadEvent, scheduleViewUpdate)
        : { stop: functionUtils/* noop */.Z, initialViewMetrics: {} };
    // Start BFCache-specific metrics when restoring from BFCache
    if (loadingType === ViewLoadingType.BF_CACHE) {
        trackBfcacheMetrics(startClocks, initialViewMetrics, scheduleViewUpdate);
    }
    const { stop: stopEventCountsTracking, eventCounts } = trackViewEventCounts(lifeCycle, id, scheduleViewUpdate);
    // Session keep alive
    const keepAliveIntervalId = (0,timer/* setInterval */.Zi)(triggerViewUpdate, SESSION_KEEP_ALIVE_INTERVAL);
    const pageMayExitSubscription = lifeCycle.subscribe(11 /* LifeCycleEventType.PAGE_MAY_EXIT */, (pageMayExitEvent) => {
        if (pageMayExitEvent.reason === browser_pageMayExitObservable/* PageExitReason.UNLOADING */.k$.UNLOADING) {
            triggerViewUpdate();
        }
    });
    // Initial view update
    triggerViewUpdate();
    // View context update should always be throttled
    contextManager.changeObservable.subscribe(scheduleViewUpdate);
    function triggerBeforeViewUpdate() {
        lifeCycle.notify(3 /* LifeCycleEventType.BEFORE_VIEW_UPDATED */, {
            id,
            name,
            context: contextManager.getContext(),
            startClocks,
            sessionIsActive,
        });
    }
    function scheduleViewUpdate() {
        triggerBeforeViewUpdate();
        throttled();
    }
    function triggerViewUpdate() {
        cancelScheduleViewUpdate();
        triggerBeforeViewUpdate();
        documentVersion += 1;
        const currentEnd = endClocks === undefined ? (0,timeUtils/* timeStampNow */.n$)() : endClocks.timeStamp;
        lifeCycle.notify(4 /* LifeCycleEventType.VIEW_UPDATED */, {
            customTimings,
            documentVersion,
            id,
            name,
            service,
            version,
            context: contextManager.getContext(),
            loadingType,
            location,
            startClocks,
            commonViewMetrics: getCommonViewMetrics(),
            initialViewMetrics,
            duration: (0,timeUtils/* elapsed */._J)(startClocks.timeStamp, currentEnd),
            isActive: endClocks === undefined,
            sessionIsActive,
            eventCounts,
        });
    }
    return {
        get name() {
            return name;
        },
        service,
        version,
        contextManager,
        stopObservable,
        end(options = {}) {
            var _a, _b;
            if (endClocks) {
                // view already ended
                return;
            }
            endClocks = (_a = options.endClocks) !== null && _a !== void 0 ? _a : (0,timeUtils/* clocksNow */.$I)();
            sessionIsActive = (_b = options.sessionIsActive) !== null && _b !== void 0 ? _b : true;
            lifeCycle.notify(5 /* LifeCycleEventType.VIEW_ENDED */, { endClocks });
            lifeCycle.notify(6 /* LifeCycleEventType.AFTER_VIEW_ENDED */, { endClocks });
            (0,timer/* clearInterval */.cv)(keepAliveIntervalId);
            setViewEnd(endClocks.relative);
            stopCommonViewMetricsTracking();
            pageMayExitSubscription.unsubscribe();
            triggerViewUpdate();
            (0,timer/* setTimeout */.iK)(() => {
                this.stop();
            }, KEEP_TRACKING_AFTER_VIEW_DELAY);
        },
        stop() {
            stopInitialViewMetricsTracking();
            stopEventCountsTracking();
            stopINPTracking();
            stopObservable.notify();
        },
        addTiming(name, time) {
            if (endClocks) {
                return;
            }
            const relativeTime = (0,timeUtils/* looksLikeRelativeTime */.Cn)(time) ? time : (0,timeUtils/* elapsed */._J)(startClocks.timeStamp, time);
            customTimings[sanitizeTiming(name)] = relativeTime;
            scheduleViewUpdate();
        },
        setViewName(updatedName) {
            name = updatedName;
            triggerViewUpdate();
        },
    };
}
/**
 * Timing name is used as facet path that must contain only letters, digits, or the characters - _ . @ $
 */
function sanitizeTiming(name) {
    const sanitized = name.replace(/[^a-zA-Z0-9-_.@$]/g, '_');
    if (sanitized !== name) {
        display/* display.warn */.jf.warn(`Invalid timing name: ${name}, sanitized to: ${sanitized}`);
    }
    return sanitized;
}
function areDifferentLocation(currentLocation, otherLocation) {
    return (currentLocation.pathname !== otherLocation.pathname ||
        (!isHashAnAnchor(otherLocation.hash) &&
            getPathFromHash(otherLocation.hash) !== getPathFromHash(currentLocation.hash)));
}
function isHashAnAnchor(hash) {
    const correspondingId = hash.substring(1);
    // check if the correspondingId is empty because on Firefox an empty string passed to getElementById() prints a consol warning
    return correspondingId !== '' && !!document.getElementById(correspondingId);
}
function getPathFromHash(hash) {
    const index = hash.indexOf('?');
    return index < 0 ? hash : hash.slice(0, index);
}
//# sourceMappingURL=trackViews.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/view/viewCollection.js




function startViewCollection(lifeCycle, hooks, configuration, location, domMutationObservable, pageOpenObservable, locationChangeObservable, recorderApi, viewHistory, initialViewOptions) {
    lifeCycle.subscribe(4 /* LifeCycleEventType.VIEW_UPDATED */, (view) => lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, processViewUpdate(view, configuration, recorderApi)));
    hooks.register(0 /* HookNames.Assemble */, ({ startTime, eventType }) => {
        const view = viewHistory.findView(startTime);
        if (!view) {
            return abstractHooks/* DISCARDED */.C_;
        }
        return {
            type: eventType,
            service: view.service,
            version: view.version,
            context: view.context,
            view: {
                id: view.id,
                name: view.name,
            },
        };
    });
    hooks.register(1 /* HookNames.AssembleTelemetry */, ({ startTime }) => {
        var _a;
        return ({
            view: {
                id: (_a = viewHistory.findView(startTime)) === null || _a === void 0 ? void 0 : _a.id,
            },
        });
    });
    return trackViews(location, lifeCycle, domMutationObservable, pageOpenObservable, configuration, locationChangeObservable, !configuration.trackViewsManually, initialViewOptions);
}
function processViewUpdate(view, configuration, recorderApi) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    const replayStats = recorderApi.getReplayStats(view.id);
    const clsDevicePixelRatio = (_b = (_a = view.commonViewMetrics) === null || _a === void 0 ? void 0 : _a.cumulativeLayoutShift) === null || _b === void 0 ? void 0 : _b.devicePixelRatio;
    const viewEvent = {
        _dd: {
            document_version: view.documentVersion,
            replay_stats: replayStats,
            cls: clsDevicePixelRatio
                ? {
                    device_pixel_ratio: clsDevicePixelRatio,
                }
                : undefined,
            configuration: {
                start_session_replay_recording_manually: configuration.startSessionReplayRecordingManually,
            },
        },
        date: view.startClocks.timeStamp,
        type: RumEventType.VIEW,
        view: {
            action: {
                count: view.eventCounts.actionCount,
            },
            frustration: {
                count: view.eventCounts.frustrationCount,
            },
            cumulative_layout_shift: (_c = view.commonViewMetrics.cumulativeLayoutShift) === null || _c === void 0 ? void 0 : _c.value,
            cumulative_layout_shift_time: (0,timeUtils/* toServerDuration */.c0)((_d = view.commonViewMetrics.cumulativeLayoutShift) === null || _d === void 0 ? void 0 : _d.time),
            cumulative_layout_shift_target_selector: (_e = view.commonViewMetrics.cumulativeLayoutShift) === null || _e === void 0 ? void 0 : _e.targetSelector,
            first_byte: (0,timeUtils/* toServerDuration */.c0)((_f = view.initialViewMetrics.navigationTimings) === null || _f === void 0 ? void 0 : _f.firstByte),
            dom_complete: (0,timeUtils/* toServerDuration */.c0)((_g = view.initialViewMetrics.navigationTimings) === null || _g === void 0 ? void 0 : _g.domComplete),
            dom_content_loaded: (0,timeUtils/* toServerDuration */.c0)((_h = view.initialViewMetrics.navigationTimings) === null || _h === void 0 ? void 0 : _h.domContentLoaded),
            dom_interactive: (0,timeUtils/* toServerDuration */.c0)((_j = view.initialViewMetrics.navigationTimings) === null || _j === void 0 ? void 0 : _j.domInteractive),
            error: {
                count: view.eventCounts.errorCount,
            },
            first_contentful_paint: (0,timeUtils/* toServerDuration */.c0)(view.initialViewMetrics.firstContentfulPaint),
            first_input_delay: (0,timeUtils/* toServerDuration */.c0)((_k = view.initialViewMetrics.firstInput) === null || _k === void 0 ? void 0 : _k.delay),
            first_input_time: (0,timeUtils/* toServerDuration */.c0)((_l = view.initialViewMetrics.firstInput) === null || _l === void 0 ? void 0 : _l.time),
            first_input_target_selector: (_m = view.initialViewMetrics.firstInput) === null || _m === void 0 ? void 0 : _m.targetSelector,
            interaction_to_next_paint: (0,timeUtils/* toServerDuration */.c0)((_o = view.commonViewMetrics.interactionToNextPaint) === null || _o === void 0 ? void 0 : _o.value),
            interaction_to_next_paint_time: (0,timeUtils/* toServerDuration */.c0)((_p = view.commonViewMetrics.interactionToNextPaint) === null || _p === void 0 ? void 0 : _p.time),
            interaction_to_next_paint_target_selector: (_q = view.commonViewMetrics.interactionToNextPaint) === null || _q === void 0 ? void 0 : _q.targetSelector,
            is_active: view.isActive,
            name: view.name,
            largest_contentful_paint: (0,timeUtils/* toServerDuration */.c0)((_r = view.initialViewMetrics.largestContentfulPaint) === null || _r === void 0 ? void 0 : _r.value),
            largest_contentful_paint_target_selector: (_s = view.initialViewMetrics.largestContentfulPaint) === null || _s === void 0 ? void 0 : _s.targetSelector,
            load_event: (0,timeUtils/* toServerDuration */.c0)((_t = view.initialViewMetrics.navigationTimings) === null || _t === void 0 ? void 0 : _t.loadEvent),
            loading_time: discardNegativeDuration((0,timeUtils/* toServerDuration */.c0)(view.commonViewMetrics.loadingTime)),
            loading_type: view.loadingType,
            long_task: {
                count: view.eventCounts.longTaskCount,
            },
            performance: computeViewPerformanceData(view.commonViewMetrics, view.initialViewMetrics),
            resource: {
                count: view.eventCounts.resourceCount,
            },
            time_spent: (0,timeUtils/* toServerDuration */.c0)(view.duration),
        },
        display: view.commonViewMetrics.scroll
            ? {
                scroll: {
                    max_depth: view.commonViewMetrics.scroll.maxDepth,
                    max_depth_scroll_top: view.commonViewMetrics.scroll.maxDepthScrollTop,
                    max_scroll_height: view.commonViewMetrics.scroll.maxScrollHeight,
                    max_scroll_height_time: (0,timeUtils/* toServerDuration */.c0)(view.commonViewMetrics.scroll.maxScrollHeightTime),
                },
            }
            : undefined,
        privacy: {
            replay_level: configuration.defaultPrivacyLevel,
        },
        device: {
            locale: navigator.language,
            locales: navigator.languages,
            time_zone: getTimeZone(),
        },
    };
    if (!(0,objectUtils/* isEmptyObject */.Qr)(view.customTimings)) {
        viewEvent.view.custom_timings = (0,objectUtils/* mapValues */.Q8)(view.customTimings, timeUtils/* toServerDuration */.c0);
    }
    return {
        rawRumEvent: viewEvent,
        startTime: view.startClocks.relative,
        duration: view.duration,
        domainContext: {
            location: view.location,
        },
    };
}
function computeViewPerformanceData({ cumulativeLayoutShift, interactionToNextPaint }, { firstContentfulPaint, firstInput, largestContentfulPaint }) {
    return {
        cls: cumulativeLayoutShift && {
            score: cumulativeLayoutShift.value,
            timestamp: (0,timeUtils/* toServerDuration */.c0)(cumulativeLayoutShift.time),
            target_selector: cumulativeLayoutShift.targetSelector,
            previous_rect: cumulativeLayoutShift.previousRect,
            current_rect: cumulativeLayoutShift.currentRect,
        },
        fcp: firstContentfulPaint && { timestamp: (0,timeUtils/* toServerDuration */.c0)(firstContentfulPaint) },
        fid: firstInput && {
            duration: (0,timeUtils/* toServerDuration */.c0)(firstInput.delay),
            timestamp: (0,timeUtils/* toServerDuration */.c0)(firstInput.time),
            target_selector: firstInput.targetSelector,
        },
        inp: interactionToNextPaint && {
            duration: (0,timeUtils/* toServerDuration */.c0)(interactionToNextPaint.value),
            timestamp: (0,timeUtils/* toServerDuration */.c0)(interactionToNextPaint.time),
            target_selector: interactionToNextPaint.targetSelector,
        },
        lcp: largestContentfulPaint && {
            timestamp: (0,timeUtils/* toServerDuration */.c0)(largestContentfulPaint.value),
            target_selector: largestContentfulPaint.targetSelector,
            resource_url: largestContentfulPaint.resourceUrl,
        },
    };
}
//# sourceMappingURL=viewCollection.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/sessionStore.js + 1 modules
var session_sessionStore = __webpack_require__(63893);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/sessionState.js + 1 modules
var sessionState = __webpack_require__(66923);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/storeStrategies/sessionInCookie.js + 1 modules
var sessionInCookie = __webpack_require__(49430);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/storeStrategies/sessionStoreStrategy.js
var sessionStoreStrategy = __webpack_require__(4942);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/storeStrategies/sessionInLocalStorage.js
var sessionInLocalStorage = __webpack_require__(65485);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/sessionManager.js

















const VISIBILITY_CHECK_DELAY = timeUtils/* ONE_MINUTE */.yR;
const SESSION_CONTEXT_TIMEOUT_DELAY = sessionConstants/* SESSION_TIME_OUT_DELAY */.TN;
let stopCallbacks = [];
function startSessionManager(configuration, productKey, computeTrackingType, trackingConsentState) {
    const renewObservable = new tools_observable/* Observable */.y$();
    const expireObservable = new tools_observable/* Observable */.y$();
    // TODO - Improve configuration type and remove assertion
    const sessionStore = (0,session_sessionStore/* startSessionStore */.vH)(configuration.sessionStoreStrategyType, configuration, productKey, computeTrackingType);
    stopCallbacks.push(() => sessionStore.stop());
    const sessionContextHistory = createValueHistory({
        expireDelay: SESSION_CONTEXT_TIMEOUT_DELAY,
    });
    stopCallbacks.push(() => sessionContextHistory.stop());
    sessionStore.renewObservable.subscribe(() => {
        sessionContextHistory.add(buildSessionContext(), (0,timeUtils/* relativeNow */._q)());
        renewObservable.notify();
    });
    sessionStore.expireObservable.subscribe(() => {
        expireObservable.notify();
        sessionContextHistory.closeActive((0,timeUtils/* relativeNow */._q)());
    });
    // We expand/renew session unconditionally as tracking consent is always granted when the session
    // manager is started.
    sessionStore.expandOrRenewSession();
    sessionContextHistory.add(buildSessionContext(), (0,timeUtils/* clocksOrigin */.cQ)().relative);
    if ((0,experimentalFeatures/* isExperimentalFeatureEnabled */.W_)(experimentalFeatures/* ExperimentalFeature.SHORT_SESSION_INVESTIGATION */.uh.SHORT_SESSION_INVESTIGATION)) {
        const session = sessionStore.getSession();
        if (session) {
            detectSessionIdChange(configuration, session);
        }
    }
    trackingConsentState.observable.subscribe(() => {
        if (trackingConsentState.isGranted()) {
            sessionStore.expandOrRenewSession();
        }
        else {
            sessionStore.expire(false);
        }
    });
    trackActivity(configuration, () => {
        if (trackingConsentState.isGranted()) {
            sessionStore.expandOrRenewSession();
        }
    });
    trackVisibility(configuration, () => sessionStore.expandSession());
    trackResume(configuration, () => sessionStore.restartSession());
    function buildSessionContext() {
        const session = sessionStore.getSession();
        if (!session) {
            reportUnexpectedSessionState(configuration).catch(() => void 0); // Ignore errors
            return {
                id: 'invalid',
                trackingType: sessionConstants/* SESSION_NOT_TRACKED */.m8,
                isReplayForced: false,
                anonymousId: undefined,
            };
        }
        return {
            id: session.id,
            trackingType: session[productKey],
            isReplayForced: !!session.forcedReplay,
            anonymousId: session.anonymousId,
        };
    }
    return {
        findSession: (startTime, options) => sessionContextHistory.find(startTime, options),
        renewObservable,
        expireObservable,
        sessionStateUpdateObservable: sessionStore.sessionStateUpdateObservable,
        expire: sessionStore.expire,
        updateSessionState: sessionStore.updateSessionState,
    };
}
function stopSessionManager() {
    stopCallbacks.forEach((e) => e());
    stopCallbacks = [];
}
function trackActivity(configuration, expandOrRenewSession) {
    const { stop } = (0,addEventListener/* addEventListeners */.y)(configuration, window, ["click" /* DOM_EVENT.CLICK */, "touchstart" /* DOM_EVENT.TOUCH_START */, "keydown" /* DOM_EVENT.KEY_DOWN */, "scroll" /* DOM_EVENT.SCROLL */], expandOrRenewSession, { capture: true, passive: true });
    stopCallbacks.push(stop);
}
function trackVisibility(configuration, expandSession) {
    const expandSessionWhenVisible = () => {
        if (document.visibilityState === 'visible') {
            expandSession();
        }
    };
    const { stop } = (0,addEventListener/* addEventListener */.O)(configuration, document, "visibilitychange" /* DOM_EVENT.VISIBILITY_CHANGE */, expandSessionWhenVisible);
    stopCallbacks.push(stop);
    const visibilityCheckInterval = (0,timer/* setInterval */.Zi)(expandSessionWhenVisible, VISIBILITY_CHECK_DELAY);
    stopCallbacks.push(() => {
        (0,timer/* clearInterval */.cv)(visibilityCheckInterval);
    });
}
function trackResume(configuration, cb) {
    const { stop } = (0,addEventListener/* addEventListener */.O)(configuration, window, "resume" /* DOM_EVENT.RESUME */, cb, { capture: true });
    stopCallbacks.push(stop);
}
async function reportUnexpectedSessionState(configuration) {
    const sessionStoreStrategyType = configuration.sessionStoreStrategyType;
    if (!sessionStoreStrategyType) {
        return;
    }
    let rawSession;
    let cookieContext;
    if (sessionStoreStrategyType.type === sessionConstants/* SessionPersistence.COOKIE */._q.COOKIE) {
        rawSession = (0,sessionInCookie/* retrieveSessionCookie */.JP)(sessionStoreStrategyType.cookieOptions, configuration);
        cookieContext = {
            cookie: await getSessionCookies(),
            currentDomain: `${window.location.protocol}//${window.location.hostname}`,
        };
    }
    else {
        rawSession = (0,sessionInLocalStorage/* retrieveSessionFromLocalStorage */.q$)();
    }
    // monitor-until: forever, could be handy to troubleshoot issues until session manager rework
    (0,telemetry_telemetry/* addTelemetryDebug */.eJ)('Unexpected session state', {
        sessionStoreStrategyType: sessionStoreStrategyType.type,
        session: rawSession,
        isSyntheticsTest: isSyntheticsTest(),
        createdTimestamp: rawSession === null || rawSession === void 0 ? void 0 : rawSession.created,
        expireTimestamp: rawSession === null || rawSession === void 0 ? void 0 : rawSession.expire,
        ...cookieContext,
    });
}
function detectSessionIdChange(configuration, initialSessionState) {
    if (!window.cookieStore || !initialSessionState.created) {
        return;
    }
    const sessionCreatedTime = Number(initialSessionState.created);
    const sdkInitTime = (0,timeUtils/* dateNow */.m6)();
    const { stop } = (0,addEventListener/* addEventListener */.O)(configuration, cookieStore, "change" /* DOM_EVENT.CHANGE */, listener);
    stopCallbacks.push(stop);
    function listener(event) {
        const changed = (0,polyfills/* findLast */.dF)(event.changed, (change) => change.name === sessionStoreStrategy/* SESSION_STORE_KEY */.H);
        if (!changed) {
            return;
        }
        const sessionAge = (0,timeUtils/* dateNow */.m6)() - sessionCreatedTime;
        if (sessionAge > 14 * timeUtils/* ONE_MINUTE */.yR) {
            // The session might have expired just because it's too old or lack activity
            stop();
        }
        else {
            const newSessionState = (0,sessionState/* toSessionState */.q1)(changed.value);
            if (newSessionState.id && newSessionState.id !== initialSessionState.id) {
                stop();
                const time = (0,timeUtils/* dateNow */.m6)() - sdkInitTime;
                getSessionCookies()
                    .then((cookie) => {
                    // monitor-until: 2026-04-01, after RUM-10845 investigation done
                    (0,telemetry_telemetry/* addTelemetryDebug */.eJ)('Session cookie changed', {
                        time,
                        session_age: sessionAge,
                        old: initialSessionState,
                        new: newSessionState,
                        cookie,
                    });
                })
                    .catch(monitor/* monitorError */.$y);
            }
        }
    }
}
async function getSessionCookies() {
    let sessionCookies;
    if ('cookieStore' in window) {
        sessionCookies = await window.cookieStore.getAll(sessionStoreStrategy/* SESSION_STORE_KEY */.H);
    }
    else {
        sessionCookies = document.cookie.split(/\s*;\s*/).filter((cookie) => cookie.startsWith(sessionStoreStrategy/* SESSION_STORE_KEY */.H));
    }
    return {
        count: sessionCookies.length,
        domain: (0,cookie/* getCurrentSite */.WQ)() || 'undefined',
        ...sessionCookies,
    };
}
//# sourceMappingURL=sessionManager.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumSessionManager.js

const RUM_SESSION_KEY = 'rum';
function startRumSessionManager(configuration, lifeCycle, trackingConsentState) {
    const sessionManager = startSessionManager(configuration, RUM_SESSION_KEY, (rawTrackingType) => computeTrackingType(configuration, rawTrackingType), trackingConsentState);
    sessionManager.expireObservable.subscribe(() => {
        lifeCycle.notify(9 /* LifeCycleEventType.SESSION_EXPIRED */);
    });
    sessionManager.renewObservable.subscribe(() => {
        lifeCycle.notify(10 /* LifeCycleEventType.SESSION_RENEWED */);
    });
    sessionManager.sessionStateUpdateObservable.subscribe(({ previousState, newState }) => {
        if (!previousState.forcedReplay && newState.forcedReplay) {
            const sessionEntity = sessionManager.findSession();
            if (sessionEntity) {
                sessionEntity.isReplayForced = true;
            }
        }
    });
    return {
        findTrackedSession: (startTime) => {
            const session = sessionManager.findSession(startTime);
            if (!session || session.trackingType === "0" /* RumTrackingType.NOT_TRACKED */) {
                return;
            }
            return {
                id: session.id,
                sessionReplay: session.trackingType === "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */
                    ? 1 /* SessionReplayState.SAMPLED */
                    : session.isReplayForced
                        ? 2 /* SessionReplayState.FORCED */
                        : 0 /* SessionReplayState.OFF */,
                anonymousId: session.anonymousId,
            };
        },
        expire: sessionManager.expire,
        expireObservable: sessionManager.expireObservable,
        setForcedReplay: () => sessionManager.updateSessionState({ forcedReplay: '1' }),
    };
}
/**
 * Start a tracked replay session stub
 */
function startRumSessionManagerStub() {
    const session = {
        id: '00000000-aaaa-0000-aaaa-000000000000',
        sessionReplay: (0,eventBridge/* bridgeSupports */.ke)("records" /* BridgeCapability.RECORDS */) ? 1 /* SessionReplayState.SAMPLED */ : 0 /* SessionReplayState.OFF */,
    };
    return {
        findTrackedSession: () => session,
        expire: functionUtils/* noop */.Z,
        expireObservable: new tools_observable/* Observable */.y$(),
        setForcedReplay: functionUtils/* noop */.Z,
    };
}
function computeTrackingType(configuration, rawTrackingType) {
    if (hasValidRumSession(rawTrackingType)) {
        return rawTrackingType;
    }
    if (!(0,numberUtils/* performDraw */.y7)(configuration.sessionSampleRate)) {
        return "0" /* RumTrackingType.NOT_TRACKED */;
    }
    if (!(0,numberUtils/* performDraw */.y7)(configuration.sessionReplaySampleRate)) {
        return "2" /* RumTrackingType.TRACKED_WITHOUT_SESSION_REPLAY */;
    }
    return "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */;
}
function hasValidRumSession(trackingType) {
    return (trackingType === "0" /* RumTrackingType.NOT_TRACKED */ ||
        trackingType === "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */ ||
        trackingType === "2" /* RumTrackingType.TRACKED_WITHOUT_SESSION_REPLAY */);
}
//# sourceMappingURL=rumSessionManager.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/transport/batch.js
var transport_batch = __webpack_require__(53789);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/transport/httpRequest.js + 1 modules
var transport_httpRequest = __webpack_require__(30481);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/transport/flushController.js
var flushController = __webpack_require__(5419);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/transport/startRumBatch.js


function startRumBatch(configuration, lifeCycle, reportError, pageMayExitObservable, sessionExpireObservable, createEncoder) {
    const endpoints = [configuration.rumEndpointBuilder];
    if (configuration.replica) {
        endpoints.push(configuration.replica.rumEndpointBuilder);
    }
    const batch = (0,transport_batch/* createBatch */.n)({
        encoder: createEncoder(2 /* DeflateEncoderStreamId.RUM */),
        request: (0,transport_httpRequest/* createHttpRequest */.UF)(endpoints, reportError),
        flushController: (0,flushController/* createFlushController */.rK)({
            pageMayExitObservable,
            sessionExpireObservable,
        }),
    });
    lifeCycle.subscribe(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, (serverRumEvent) => {
        if (serverRumEvent.type === RumEventType.VIEW) {
            batch.upsert(serverRumEvent, serverRumEvent.view.id);
        }
        else {
            batch.add(serverRumEvent);
        }
    });
    return batch;
}
//# sourceMappingURL=startRumBatch.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/transport/startRumEventBridge.js

function startRumEventBridge(lifeCycle) {
    const bridge = (0,eventBridge/* getEventBridge */.Ad)();
    lifeCycle.subscribe(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, (serverRumEvent) => {
        bridge.send('rum', serverRumEvent);
    });
}
//# sourceMappingURL=startRumEventBridge.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/contexts/urlContexts.js

/**
 * We want to attach to an event:
 * - the url corresponding to its start
 * - the referrer corresponding to the previous view url (or document referrer for initial view)
 */
const URL_CONTEXT_TIME_OUT_DELAY = sessionConstants/* SESSION_TIME_OUT_DELAY */.TN;
function startUrlContexts(lifeCycle, hooks, locationChangeObservable, location) {
    const urlContextHistory = createValueHistory({ expireDelay: URL_CONTEXT_TIME_OUT_DELAY });
    let previousViewUrl;
    lifeCycle.subscribe(1 /* LifeCycleEventType.BEFORE_VIEW_CREATED */, ({ startClocks }) => {
        const viewUrl = location.href;
        urlContextHistory.add(buildUrlContext({
            url: viewUrl,
            referrer: !previousViewUrl ? document.referrer : previousViewUrl,
        }), startClocks.relative);
        previousViewUrl = viewUrl;
    });
    lifeCycle.subscribe(6 /* LifeCycleEventType.AFTER_VIEW_ENDED */, ({ endClocks }) => {
        urlContextHistory.closeActive(endClocks.relative);
    });
    const locationChangeSubscription = locationChangeObservable.subscribe(({ newLocation }) => {
        const current = urlContextHistory.find();
        if (current) {
            const changeTime = (0,timeUtils/* relativeNow */._q)();
            urlContextHistory.closeActive(changeTime);
            urlContextHistory.add(buildUrlContext({
                url: newLocation.href,
                referrer: current.referrer,
            }), changeTime);
        }
    });
    function buildUrlContext({ url, referrer }) {
        return {
            url,
            referrer,
        };
    }
    hooks.register(0 /* HookNames.Assemble */, ({ startTime, eventType }) => {
        const urlContext = urlContextHistory.find(startTime);
        if (!urlContext) {
            return abstractHooks/* DISCARDED */.C_;
        }
        return {
            type: eventType,
            view: {
                url: urlContext.url,
                referrer: urlContext.referrer,
            },
        };
    });
    return {
        findUrl: (startTime) => urlContextHistory.find(startTime),
        stop: () => {
            locationChangeSubscription.unsubscribe();
            urlContextHistory.stop();
        },
    };
}
//# sourceMappingURL=urlContexts.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/browser/locationChangeObservable.js

function createLocationChangeObservable(configuration, location) {
    let currentLocation = (0,objectUtils/* shallowClone */.mv)(location);
    return new tools_observable/* Observable */.y$((observable) => {
        const { stop: stopHistoryTracking } = trackHistory(configuration, onLocationChange);
        const { stop: stopHashTracking } = trackHash(configuration, onLocationChange);
        function onLocationChange() {
            if (currentLocation.href === location.href) {
                return;
            }
            const newLocation = (0,objectUtils/* shallowClone */.mv)(location);
            observable.notify({
                newLocation,
                oldLocation: currentLocation,
            });
            currentLocation = newLocation;
        }
        return () => {
            stopHistoryTracking();
            stopHashTracking();
        };
    });
}
function trackHistory(configuration, onHistoryChange) {
    const { stop: stopInstrumentingPushState } = (0,instrumentMethod/* instrumentMethod */.S)(getHistoryInstrumentationTarget('pushState'), 'pushState', ({ onPostCall }) => {
        onPostCall(onHistoryChange);
    });
    const { stop: stopInstrumentingReplaceState } = (0,instrumentMethod/* instrumentMethod */.S)(getHistoryInstrumentationTarget('replaceState'), 'replaceState', ({ onPostCall }) => {
        onPostCall(onHistoryChange);
    });
    const { stop: removeListener } = (0,addEventListener/* addEventListener */.O)(configuration, window, "popstate" /* DOM_EVENT.POP_STATE */, onHistoryChange);
    return {
        stop: () => {
            stopInstrumentingPushState();
            stopInstrumentingReplaceState();
            removeListener();
        },
    };
}
function trackHash(configuration, onHashChange) {
    return (0,addEventListener/* addEventListener */.O)(configuration, window, "hashchange" /* DOM_EVENT.HASH_CHANGE */, onHashChange);
}
function getHistoryInstrumentationTarget(methodName) {
    // Ideally we should always instument the method on the prototype, however some frameworks (e.g [Next.js](https://github.com/vercel/next.js/blob/d3f5532065f3e3bb84fb54bd2dfd1a16d0f03a21/packages/next/src/client/components/app-router.tsx#L429))
    // are wrapping the instance method. In that case we should also wrap the instance method.
    return Object.prototype.hasOwnProperty.call(history, methodName) ? history : History.prototype;
}
//# sourceMappingURL=locationChangeObservable.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/contexts/featureFlagContext.js


const FEATURE_FLAG_CONTEXT_TIME_OUT_DELAY = sessionConstants/* SESSION_TIME_OUT_DELAY */.TN;
const BYTES_COMPUTATION_THROTTLING_DELAY = 200;
/**
 * Start feature flag contexts
 *
 * Feature flag contexts follow the life of views.
 * A new context is added when a view is created and ended when the view is ended
 *
 * Note: we choose not to add a new context at each evaluation to save memory
 */
function startFeatureFlagContexts(lifeCycle, hooks, configuration) {
    const featureFlagContexts = createValueHistory({
        expireDelay: FEATURE_FLAG_CONTEXT_TIME_OUT_DELAY,
    });
    lifeCycle.subscribe(1 /* LifeCycleEventType.BEFORE_VIEW_CREATED */, ({ startClocks }) => {
        featureFlagContexts.add({}, startClocks.relative);
    });
    lifeCycle.subscribe(6 /* LifeCycleEventType.AFTER_VIEW_ENDED */, ({ endClocks }) => {
        featureFlagContexts.closeActive(endClocks.relative);
    });
    hooks.register(0 /* HookNames.Assemble */, ({ startTime, eventType }) => {
        const trackFeatureFlagsForEvents = configuration.trackFeatureFlagsForEvents.concat([
            RumEventType.VIEW,
            RumEventType.ERROR,
        ]);
        if (!trackFeatureFlagsForEvents.includes(eventType)) {
            return abstractHooks/* SKIPPED */.kb;
        }
        const featureFlagContext = featureFlagContexts.find(startTime);
        if (!featureFlagContext || (0,objectUtils/* isEmptyObject */.Qr)(featureFlagContext)) {
            return abstractHooks/* SKIPPED */.kb;
        }
        return {
            type: eventType,
            feature_flags: featureFlagContext,
        };
    });
    return {
        addFeatureFlagEvaluation: (key, value) => {
            const currentContext = featureFlagContexts.find();
            if (currentContext) {
                currentContext[key] = value;
            }
        },
    };
}
//# sourceMappingURL=featureFlagContext.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/startCustomerDataTelemetry.js

const MEASURES_PERIOD_DURATION = 10 * timeUtils/* ONE_SECOND */.WT;
let currentPeriodMeasures;
let batchHasRumEvent;
function startCustomerDataTelemetry(telemetry, lifeCycle, batchFlushObservable) {
    if (!telemetry.metricsEnabled) {
        return;
    }
    initCurrentPeriodMeasures();
    batchHasRumEvent = false;
    // We measure the data of every view updates even if there could only be one per batch due to the upsert
    // It means that contexts bytes count sums can be higher than it really is
    lifeCycle.subscribe(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, () => {
        batchHasRumEvent = true;
    });
    batchFlushObservable.subscribe(({ bytesCount, messagesCount }) => {
        // Don't measure batch that only contains telemetry events to avoid batch sending loop
        // It could happen because after each batch we are adding a customer data measures telemetry event to the next one
        if (!batchHasRumEvent) {
            return;
        }
        batchHasRumEvent = false;
        currentPeriodMeasures.batchCount += 1;
        updateMeasure(currentPeriodMeasures.batchBytesCount, bytesCount);
        updateMeasure(currentPeriodMeasures.batchMessagesCount, messagesCount);
    });
    (0,timer/* setInterval */.Zi)(sendCurrentPeriodMeasures, MEASURES_PERIOD_DURATION);
}
function sendCurrentPeriodMeasures() {
    if (currentPeriodMeasures.batchCount === 0) {
        return;
    }
    // monitor-until: forever
    (0,telemetry_telemetry/* addTelemetryMetrics */.qZ)("Customer data measures" /* TelemetryMetrics.CUSTOMER_DATA_METRIC_NAME */, currentPeriodMeasures);
    initCurrentPeriodMeasures();
}
function createMeasure() {
    return { min: Infinity, max: 0, sum: 0 };
}
function updateMeasure(measure, value) {
    measure.sum += value;
    measure.min = Math.min(measure.min, value);
    measure.max = Math.max(measure.max, value);
}
function initCurrentPeriodMeasures() {
    currentPeriodMeasures = {
        batchCount: 0,
        batchBytesCount: createMeasure(),
        batchMessagesCount: createMeasure(),
    };
}
//# sourceMappingURL=startCustomerDataTelemetry.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/contexts/pageStateHistory.js



// Arbitrary value to cap number of element for memory consumption in the browser
const MAX_PAGE_STATE_ENTRIES = 4000;
// Arbitrary value to cap number of element for backend & to save bandwidth
const MAX_PAGE_STATE_ENTRIES_SELECTABLE = 500;
const PAGE_STATE_CONTEXT_TIME_OUT_DELAY = sessionConstants/* SESSION_TIME_OUT_DELAY */.TN;
function startPageStateHistory(hooks, configuration, maxPageStateEntriesSelectable = MAX_PAGE_STATE_ENTRIES_SELECTABLE) {
    const pageStateEntryHistory = createValueHistory({
        expireDelay: PAGE_STATE_CONTEXT_TIME_OUT_DELAY,
        maxEntries: MAX_PAGE_STATE_ENTRIES,
    });
    let currentPageState;
    if (supportPerformanceTimingEvent(RumPerformanceEntryType.VISIBILITY_STATE)) {
        const visibilityEntries = performance.getEntriesByType(RumPerformanceEntryType.VISIBILITY_STATE);
        visibilityEntries.forEach((entry) => {
            const state = entry.name === 'hidden' ? "hidden" /* PageState.HIDDEN */ : "active" /* PageState.ACTIVE */;
            addPageState(state, entry.startTime);
        });
    }
    addPageState(getPageState(), (0,timeUtils/* relativeNow */._q)());
    const { stop: stopEventListeners } = (0,addEventListener/* addEventListeners */.y)(configuration, window, [
        "pageshow" /* DOM_EVENT.PAGE_SHOW */,
        "focus" /* DOM_EVENT.FOCUS */,
        "blur" /* DOM_EVENT.BLUR */,
        "visibilitychange" /* DOM_EVENT.VISIBILITY_CHANGE */,
        "resume" /* DOM_EVENT.RESUME */,
        "freeze" /* DOM_EVENT.FREEZE */,
        "pagehide" /* DOM_EVENT.PAGE_HIDE */,
    ], (event) => {
        addPageState(computePageState(event), event.timeStamp);
    }, { capture: true });
    function addPageState(nextPageState, startTime = (0,timeUtils/* relativeNow */._q)()) {
        if (nextPageState === currentPageState) {
            return;
        }
        currentPageState = nextPageState;
        pageStateEntryHistory.closeActive(startTime);
        pageStateEntryHistory.add({ state: currentPageState, startTime }, startTime);
    }
    function wasInPageStateDuringPeriod(state, startTime, duration) {
        return pageStateEntryHistory.findAll(startTime, duration).some((pageState) => pageState.state === state);
    }
    hooks.register(0 /* HookNames.Assemble */, ({ startTime, duration = 0, eventType }) => {
        if (eventType === RumEventType.VIEW) {
            const pageStates = pageStateEntryHistory.findAll(startTime, duration);
            return {
                type: eventType,
                _dd: { page_states: processPageStates(pageStates, startTime, maxPageStateEntriesSelectable) },
            };
        }
        if (eventType === RumEventType.ACTION || eventType === RumEventType.ERROR) {
            return {
                type: eventType,
                view: { in_foreground: wasInPageStateDuringPeriod("active" /* PageState.ACTIVE */, startTime, 0) },
            };
        }
        return abstractHooks/* SKIPPED */.kb;
    });
    return {
        wasInPageStateDuringPeriod,
        addPageState,
        stop: () => {
            stopEventListeners();
            pageStateEntryHistory.stop();
        },
    };
}
function processPageStates(pageStateEntries, eventStartTime, maxPageStateEntriesSelectable) {
    if (pageStateEntries.length === 0) {
        return;
    }
    return pageStateEntries
        .slice(-maxPageStateEntriesSelectable)
        .reverse()
        .map(({ state, startTime }) => ({
        state,
        start: (0,timeUtils/* toServerDuration */.c0)((0,timeUtils/* elapsed */._J)(eventStartTime, startTime)),
    }));
}
function computePageState(event) {
    if (event.type === "freeze" /* DOM_EVENT.FREEZE */) {
        return "frozen" /* PageState.FROZEN */;
    }
    else if (event.type === "pagehide" /* DOM_EVENT.PAGE_HIDE */) {
        return event.persisted ? "frozen" /* PageState.FROZEN */ : "terminated" /* PageState.TERMINATED */;
    }
    return getPageState();
}
function getPageState() {
    if (document.visibilityState === 'hidden') {
        return "hidden" /* PageState.HIDDEN */;
    }
    if (document.hasFocus()) {
        return "active" /* PageState.ACTIVE */;
    }
    return "passive" /* PageState.PASSIVE */;
}
//# sourceMappingURL=pageStateHistory.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/contexts/displayContext.js


function startDisplayContext(hooks, configuration) {
    let viewport;
    // Use requestAnimationFrame to delay the calculation of viewport dimensions until after SDK initialization, preventing long tasks.
    const animationFrameId = requestAnimationFrame((0,monitor/* monitor */.zk)(() => {
        viewport = getViewportDimension();
    }));
    const unsubscribeViewport = initViewportObservable(configuration).subscribe((viewportDimension) => {
        viewport = viewportDimension;
    }).unsubscribe;
    hooks.register(0 /* HookNames.Assemble */, ({ eventType }) => ({
        type: eventType,
        display: viewport ? { viewport } : undefined,
    }));
    return {
        stop: () => {
            unsubscribeViewport();
            if (animationFrameId) {
                cancelAnimationFrame(animationFrameId);
            }
        },
    };
}
//# sourceMappingURL=displayContext.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/browser/cookieObservable.js

function createCookieObservable(configuration, cookieName) {
    const detectCookieChangeStrategy = window.cookieStore
        ? listenToCookieStoreChange(configuration)
        : watchCookieFallback;
    return new tools_observable/* Observable */.y$((observable) => detectCookieChangeStrategy(cookieName, (event) => observable.notify(event)));
}
function listenToCookieStoreChange(configuration) {
    return (cookieName, callback) => {
        const listener = (0,addEventListener/* addEventListener */.O)(configuration, window.cookieStore, "change" /* DOM_EVENT.CHANGE */, (event) => {
            // Based on our experimentation, we're assuming that entries for the same cookie cannot be in both the 'changed' and 'deleted' arrays.
            // However, due to ambiguity in the specification, we asked for clarification: https://github.com/WICG/cookie-store/issues/226
            const changeEvent = event.changed.find((event) => event.name === cookieName) ||
                event.deleted.find((event) => event.name === cookieName);
            if (changeEvent) {
                callback(changeEvent.value);
            }
        });
        return listener.stop;
    };
}
const WATCH_COOKIE_INTERVAL_DELAY = timeUtils/* ONE_SECOND */.WT;
function watchCookieFallback(cookieName, callback) {
    const previousCookieValue = (0,stringUtils/* findCommaSeparatedValue */.MY)(document.cookie, cookieName);
    const watchCookieIntervalId = (0,timer/* setInterval */.Zi)(() => {
        const cookieValue = (0,stringUtils/* findCommaSeparatedValue */.MY)(document.cookie, cookieName);
        if (cookieValue !== previousCookieValue) {
            callback(cookieValue);
        }
    }, WATCH_COOKIE_INTERVAL_DELAY);
    return () => {
        (0,timer/* clearInterval */.cv)(watchCookieIntervalId);
    };
}
//# sourceMappingURL=cookieObservable.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/contexts/ciVisibilityContext.js


const CI_VISIBILITY_TEST_ID_COOKIE_NAME = 'datadog-ci-visibility-test-execution-id';
function startCiVisibilityContext(configuration, hooks, cookieObservable = createCookieObservable(configuration, CI_VISIBILITY_TEST_ID_COOKIE_NAME)) {
    var _a;
    let testExecutionId = (0,cookie/* getInitCookie */.OC)(CI_VISIBILITY_TEST_ID_COOKIE_NAME) || ((_a = window.Cypress) === null || _a === void 0 ? void 0 : _a.env('traceId'));
    const cookieObservableSubscription = cookieObservable.subscribe((value) => {
        testExecutionId = value;
    });
    hooks.register(0 /* HookNames.Assemble */, ({ eventType }) => {
        if (typeof testExecutionId !== 'string') {
            return abstractHooks/* SKIPPED */.kb;
        }
        return {
            type: eventType,
            session: {
                type: "ci_test" /* SessionType.CI_TEST */,
            },
            ci_test: {
                test_execution_id: testExecutionId,
            },
        };
    });
    return {
        stop: () => {
            cookieObservableSubscription.unsubscribe();
        },
    };
}
//# sourceMappingURL=ciVisibilityContext.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/longAnimationFrame/longAnimationFrameCollection.js



function startLongAnimationFrameCollection(lifeCycle, configuration) {
    const performanceResourceSubscription = createPerformanceObservable(configuration, {
        type: RumPerformanceEntryType.LONG_ANIMATION_FRAME,
        buffered: true,
    }).subscribe((entries) => {
        for (const entry of entries) {
            const startClocks = (0,timeUtils/* relativeToClocks */.DY)(entry.startTime);
            const rawRumEvent = {
                date: startClocks.timeStamp,
                long_task: {
                    id: (0,stringUtils/* generateUUID */.DO)(),
                    entry_type: RumLongTaskEntryType.LONG_ANIMATION_FRAME,
                    duration: (0,timeUtils/* toServerDuration */.c0)(entry.duration),
                    blocking_duration: (0,timeUtils/* toServerDuration */.c0)(entry.blockingDuration),
                    first_ui_event_timestamp: (0,timeUtils/* toServerDuration */.c0)(entry.firstUIEventTimestamp),
                    render_start: (0,timeUtils/* toServerDuration */.c0)(entry.renderStart),
                    style_and_layout_start: (0,timeUtils/* toServerDuration */.c0)(entry.styleAndLayoutStart),
                    start_time: (0,timeUtils/* toServerDuration */.c0)(entry.startTime),
                    scripts: entry.scripts.map((script) => ({
                        duration: (0,timeUtils/* toServerDuration */.c0)(script.duration),
                        pause_duration: (0,timeUtils/* toServerDuration */.c0)(script.pauseDuration),
                        forced_style_and_layout_duration: (0,timeUtils/* toServerDuration */.c0)(script.forcedStyleAndLayoutDuration),
                        start_time: (0,timeUtils/* toServerDuration */.c0)(script.startTime),
                        execution_start: (0,timeUtils/* toServerDuration */.c0)(script.executionStart),
                        source_url: script.sourceURL,
                        source_function_name: script.sourceFunctionName,
                        source_char_position: script.sourceCharPosition,
                        invoker: script.invoker,
                        invoker_type: script.invokerType,
                        window_attribution: script.windowAttribution,
                    })),
                },
                type: RumEventType.LONG_TASK,
                _dd: {
                    discarded: false,
                },
            };
            lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, {
                rawRumEvent,
                startTime: startClocks.relative,
                duration: entry.duration,
                domainContext: { performanceEntry: entry },
            });
        }
    });
    return { stop: () => performanceResourceSubscription.unsubscribe() };
}
//# sourceMappingURL=longAnimationFrameCollection.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/longTask/longTaskCollection.js



function startLongTaskCollection(lifeCycle, configuration) {
    const performanceLongTaskSubscription = createPerformanceObservable(configuration, {
        type: RumPerformanceEntryType.LONG_TASK,
        buffered: true,
    }).subscribe((entries) => {
        for (const entry of entries) {
            if (entry.entryType !== RumPerformanceEntryType.LONG_TASK) {
                break;
            }
            if (!configuration.trackLongTasks) {
                break;
            }
            const startClocks = (0,timeUtils/* relativeToClocks */.DY)(entry.startTime);
            const rawRumEvent = {
                date: startClocks.timeStamp,
                long_task: {
                    id: (0,stringUtils/* generateUUID */.DO)(),
                    entry_type: RumLongTaskEntryType.LONG_TASK,
                    duration: (0,timeUtils/* toServerDuration */.c0)(entry.duration),
                },
                type: RumEventType.LONG_TASK,
                _dd: {
                    discarded: false,
                },
            };
            lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, {
                rawRumEvent,
                startTime: startClocks.relative,
                duration: entry.duration,
                domainContext: { performanceEntry: entry },
            });
        }
    });
    return {
        stop() {
            performanceLongTaskSubscription.unsubscribe();
        },
    };
}
//# sourceMappingURL=longTaskCollection.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/contexts/syntheticsContext.js

function startSyntheticsContext(hooks) {
    hooks.register(0 /* HookNames.Assemble */, ({ eventType }) => {
        if (!isSyntheticsTest()) {
            return abstractHooks/* SKIPPED */.kb;
        }
        const testId = getSyntheticsTestId();
        const resultId = getSyntheticsResultId();
        return {
            type: eventType,
            session: {
                type: "synthetics" /* SessionType.SYNTHETICS */,
            },
            synthetics: {
                test_id: testId,
                result_id: resultId,
                injected: willSyntheticsInjectRum(),
            },
        };
    });
}
//# sourceMappingURL=syntheticsContext.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/eventRateLimiter/createEventRateLimiter.js



// Limit the maximum number of actions, errors and logs per minutes
const EVENT_RATE_LIMIT = 3000;
function createEventRateLimiter(eventType, onLimitReached, limit = EVENT_RATE_LIMIT) {
    let eventCount = 0;
    let allowNextEvent = false;
    return {
        isLimitReached() {
            if (eventCount === 0) {
                (0,timer/* setTimeout */.iK)(() => {
                    eventCount = 0;
                }, timeUtils/* ONE_MINUTE */.yR);
            }
            eventCount += 1;
            if (eventCount <= limit || allowNextEvent) {
                allowNextEvent = false;
                return false;
            }
            if (eventCount === limit + 1) {
                allowNextEvent = true;
                try {
                    onLimitReached({
                        message: `Reached max number of ${eventType}s by minute: ${limit}`,
                        source: error_types/* ErrorSource.AGENT */.z.AGENT,
                        startClocks: (0,timeUtils/* clocksNow */.$I)(),
                    });
                }
                finally {
                    allowNextEvent = false;
                }
            }
            return true;
        },
    };
}
//# sourceMappingURL=createEventRateLimiter.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/tags.js
var tags = __webpack_require__(19276);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/limitModification.js

/**
 * Allows declaring and enforcing modifications to specific fields of an object.
 * Only supports modifying properties of an object (even if nested in an array).
 * Does not support array manipulation (adding/removing items).
 */
function limitModification(object, modifiableFieldPaths, modifier) {
    const clone = (0,mergeInto/* deepClone */.I8)(object);
    const result = modifier(clone);
    (0,polyfills/* objectEntries */.qP)(modifiableFieldPaths).forEach(([fieldPath, fieldType]) => 
    // Traverse both object and clone simultaneously up to the path and apply the modification from the clone to the original object when the type is valid
    setValueAtPath(object, clone, fieldPath.split(/\.|(?=\[\])/), fieldType));
    return result;
}
function setValueAtPath(object, clone, pathSegments, fieldType) {
    const [field, ...restPathSegments] = pathSegments;
    if (field === '[]') {
        if (Array.isArray(object) && Array.isArray(clone)) {
            object.forEach((item, i) => setValueAtPath(item, clone[i], restPathSegments, fieldType));
        }
        return;
    }
    if (!isValidObject(object) || !isValidObject(clone)) {
        return;
    }
    if (restPathSegments.length > 0) {
        return setValueAtPath(object[field], clone[field], restPathSegments, fieldType);
    }
    setNestedValue(object, field, clone[field], fieldType);
}
function setNestedValue(object, field, value, fieldType) {
    const newType = (0,typeUtils/* getType */.o)(value);
    if (newType === fieldType) {
        object[field] = (0,sanitize/* sanitize */.N)(value);
    }
    else if (fieldType === 'object' && (newType === 'undefined' || newType === 'null')) {
        object[field] = {};
    }
}
function isValidObject(object) {
    return (0,typeUtils/* getType */.o)(object) === 'object';
}
//# sourceMappingURL=limitModification.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/assembly.js



const VIEW_MODIFIABLE_FIELD_PATHS = {
    'view.name': 'string',
    'view.url': 'string',
    'view.referrer': 'string',
};
const USER_CUSTOMIZABLE_FIELD_PATHS = {
    context: 'object',
};
const ROOT_MODIFIABLE_FIELD_PATHS = {
    service: 'string',
    version: 'string',
};
let modifiableFieldPathsByEvent;
function startRumAssembly(configuration, lifeCycle, hooks, reportError, eventRateLimit) {
    modifiableFieldPathsByEvent = {
        [RumEventType.VIEW]: {
            'view.performance.lcp.resource_url': 'string',
            ...USER_CUSTOMIZABLE_FIELD_PATHS,
            ...VIEW_MODIFIABLE_FIELD_PATHS,
            ...ROOT_MODIFIABLE_FIELD_PATHS,
        },
        [RumEventType.ERROR]: {
            'error.message': 'string',
            'error.stack': 'string',
            'error.resource.url': 'string',
            'error.fingerprint': 'string',
            ...USER_CUSTOMIZABLE_FIELD_PATHS,
            ...VIEW_MODIFIABLE_FIELD_PATHS,
            ...ROOT_MODIFIABLE_FIELD_PATHS,
        },
        [RumEventType.RESOURCE]: {
            'resource.url': 'string',
            'resource.graphql.variables': 'string',
            ...USER_CUSTOMIZABLE_FIELD_PATHS,
            ...VIEW_MODIFIABLE_FIELD_PATHS,
            ...ROOT_MODIFIABLE_FIELD_PATHS,
        },
        [RumEventType.ACTION]: {
            'action.target.name': 'string',
            ...USER_CUSTOMIZABLE_FIELD_PATHS,
            ...VIEW_MODIFIABLE_FIELD_PATHS,
            ...ROOT_MODIFIABLE_FIELD_PATHS,
        },
        [RumEventType.LONG_TASK]: {
            'long_task.scripts[].source_url': 'string',
            'long_task.scripts[].invoker': 'string',
            ...USER_CUSTOMIZABLE_FIELD_PATHS,
            ...VIEW_MODIFIABLE_FIELD_PATHS,
            ...ROOT_MODIFIABLE_FIELD_PATHS,
        },
        [RumEventType.VITAL]: {
            ...USER_CUSTOMIZABLE_FIELD_PATHS,
            ...VIEW_MODIFIABLE_FIELD_PATHS,
            ...ROOT_MODIFIABLE_FIELD_PATHS,
        },
    };
    const eventRateLimiters = {
        [RumEventType.ERROR]: createEventRateLimiter(RumEventType.ERROR, reportError, eventRateLimit),
        [RumEventType.ACTION]: createEventRateLimiter(RumEventType.ACTION, reportError, eventRateLimit),
        [RumEventType.VITAL]: createEventRateLimiter(RumEventType.VITAL, reportError, eventRateLimit),
    };
    lifeCycle.subscribe(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, ({ startTime, duration, rawRumEvent, domainContext }) => {
        const defaultRumEventAttributes = hooks.triggerHook(0 /* HookNames.Assemble */, {
            eventType: rawRumEvent.type,
            startTime,
            duration,
        });
        if (defaultRumEventAttributes === abstractHooks/* DISCARDED */.C_) {
            return;
        }
        const serverRumEvent = (0,mergeInto/* combine */.$e)(defaultRumEventAttributes, rawRumEvent, {
            ddtags: (0,tags/* buildTags */.MS)(configuration).join(','),
        });
        if (shouldSend(serverRumEvent, configuration.beforeSend, domainContext, eventRateLimiters)) {
            if ((0,objectUtils/* isEmptyObject */.Qr)(serverRumEvent.context)) {
                delete serverRumEvent.context;
            }
            lifeCycle.notify(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, serverRumEvent);
        }
    });
}
function shouldSend(event, beforeSend, domainContext, eventRateLimiters) {
    var _a;
    if (beforeSend) {
        const result = limitModification(event, modifiableFieldPathsByEvent[event.type], (event) => beforeSend(event, domainContext));
        if (result === false && event.type !== RumEventType.VIEW) {
            return false;
        }
        if (result === false) {
            display/* display.warn */.jf.warn("Can't dismiss view events using beforeSend!");
        }
    }
    const rateLimitReached = (_a = eventRateLimiters[event.type]) === null || _a === void 0 ? void 0 : _a.isLimitReached();
    return !rateLimitReached;
}
//# sourceMappingURL=assembly.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/contexts/sessionContext.js


function startSessionContext(hooks, sessionManager, recorderApi, viewHistory) {
    hooks.register(0 /* HookNames.Assemble */, ({ eventType, startTime }) => {
        const session = sessionManager.findTrackedSession(startTime);
        const view = viewHistory.findView(startTime);
        if (!session || !view) {
            return abstractHooks/* DISCARDED */.C_;
        }
        let hasReplay;
        let sampledForReplay;
        let isActive;
        if (eventType === RumEventType.VIEW) {
            hasReplay = recorderApi.getReplayStats(view.id) ? true : undefined;
            sampledForReplay = session.sessionReplay === 1 /* SessionReplayState.SAMPLED */;
            isActive = view.sessionIsActive ? undefined : false;
        }
        else {
            hasReplay = recorderApi.isRecording() ? true : undefined;
        }
        return {
            type: eventType,
            session: {
                id: session.id,
                type: "user" /* SessionType.USER */,
                has_replay: hasReplay,
                sampled_for_replay: sampledForReplay,
                is_active: isActive,
            },
        };
    });
    hooks.register(1 /* HookNames.AssembleTelemetry */, ({ startTime }) => {
        const session = sessionManager.findTrackedSession(startTime);
        if (!session) {
            return abstractHooks/* SKIPPED */.kb;
        }
        return {
            session: {
                id: session.id,
            },
        };
    });
}
//# sourceMappingURL=sessionContext.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/connectivity/connectivity.js
var connectivity = __webpack_require__(68826);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/contexts/connectivityContext.js

function startConnectivityContext(hooks) {
    hooks.register(0 /* HookNames.Assemble */, ({ eventType }) => ({
        type: eventType,
        connectivity: (0,connectivity/* getConnectivity */.T)(),
    }));
}
//# sourceMappingURL=connectivityContext.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/contexts/defaultContext.js

function startDefaultContext(hooks, configuration, sdkName) {
    hooks.register(0 /* HookNames.Assemble */, ({ eventType }) => {
        const source = configuration.source;
        return {
            type: eventType,
            _dd: {
                format_version: 2,
                drift: (0,timeUtils/* currentDrift */.QA)(),
                configuration: {
                    session_sample_rate: (0,numberUtils/* round */.NM)(configuration.sessionSampleRate, 3),
                    session_replay_sample_rate: (0,numberUtils/* round */.NM)(configuration.sessionReplaySampleRate, 3),
                    profiling_sample_rate: (0,numberUtils/* round */.NM)(configuration.profilingSampleRate, 3),
                    trace_sample_rate: (0,numberUtils/* round */.NM)(configuration.traceSampleRate, 3),
                    beta_encode_cookie_options: configuration.betaEncodeCookieOptions,
                },
                browser_sdk_version: (0,eventBridge/* canUseEventBridge */.xT)() ? "6.25.0" : undefined,
                sdk_name: sdkName,
            },
            application: {
                id: configuration.applicationId,
            },
            date: (0,timeUtils/* timeStampNow */.n$)(),
            source,
        };
    });
    hooks.register(1 /* HookNames.AssembleTelemetry */, () => ({
        application: { id: configuration.applicationId },
    }));
}
//# sourceMappingURL=defaultContext.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/contexts/trackingConsentContext.js

function startTrackingConsentContext(hooks, trackingConsentState) {
    hooks.register(1 /* HookNames.AssembleTelemetry */, () => {
        const wasConsented = trackingConsentState.isGranted();
        if (!wasConsented) {
            return abstractHooks/* DISCARDED */.C_;
        }
        return abstractHooks/* SKIPPED */.kb;
    });
}
//# sourceMappingURL=trackingConsentContext.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/hooks.js

const createHooks = (abstractHooks/* abstractHooks */.uR);
//# sourceMappingURL=hooks.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/event/eventCollection.js

const allowedEventTypes = [
    RumEventType.ACTION,
    RumEventType.ERROR,
    RumEventType.LONG_TASK,
    RumEventType.RESOURCE,
    RumEventType.VITAL,
];
function startEventCollection(lifeCycle) {
    return {
        addEvent: (startTime, event, domainContext, duration) => {
            if (!allowedEventTypes.includes(event.type)) {
                return;
            }
            lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, {
                startTime,
                rawRumEvent: event,
                domainContext,
                duration,
            });
        },
    };
}
//# sourceMappingURL=eventCollection.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/startInitialViewMetricsTelemetry.js

function startInitialViewMetricsTelemetry(lifeCycle, telemetry) {
    if (!telemetry.metricsEnabled) {
        return { stop: functionUtils/* noop */.Z };
    }
    const { unsubscribe } = lifeCycle.subscribe(4 /* LifeCycleEventType.VIEW_UPDATED */, ({ initialViewMetrics }) => {
        if (!initialViewMetrics.largestContentfulPaint || !initialViewMetrics.navigationTimings) {
            return;
        }
        // The navigation timings become available shortly after the load event fires, so
        // we're snapshotting the LCP value available at that point. However, more LCP values
        // can be emitted until the page is scrolled or interacted with, so it's possible that
        // the final LCP value may differ. These metrics are intended to help diagnose
        // performance issues early in the page load process, and using LCP-at-page-load is a
        // good fit for that use case, but it's important to be aware that this is not
        // necessarily equivalent to the normal LCP metric.
        // monitor-until: 2026-07-01
        (0,telemetry_telemetry/* addTelemetryMetrics */.qZ)("Initial view metrics" /* TelemetryMetrics.INITIAL_VIEW_METRICS_TELEMETRY_NAME */, {
            metrics: createCoreInitialViewMetrics(initialViewMetrics.largestContentfulPaint, initialViewMetrics.navigationTimings),
        });
        unsubscribe();
    });
    return {
        stop: unsubscribe,
    };
}
function createCoreInitialViewMetrics(lcp, navigation) {
    return {
        lcp: {
            value: lcp.value,
        },
        navigation: {
            domComplete: navigation.domComplete,
            domContentLoaded: navigation.domContentLoaded,
            domInteractive: navigation.domInteractive,
            firstByte: navigation.firstByte,
            loadEvent: navigation.loadEvent,
        },
    };
}
//# sourceMappingURL=startInitialViewMetricsTelemetry.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/boot/startRum.js


































function startRum(configuration, recorderApi, profilerApi, initialViewOptions, createEncoder, 
// `startRum` and its subcomponents assume tracking consent is granted initially and starts
// collecting logs unconditionally. As such, `startRum` should be called with a
// `trackingConsentState` set to "granted".
trackingConsentState, customVitalsState, bufferedDataObservable, sdkName) {
    const cleanupTasks = [];
    const lifeCycle = new LifeCycle();
    const hooks = createHooks();
    lifeCycle.subscribe(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, (event) => (0,sendToExtension/* sendToExtension */.j)('rum', event));
    const reportError = (error) => {
        lifeCycle.notify(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, { error });
        // monitor-until: forever, to keep an eye on the errors reported to customers
        (0,telemetry_telemetry/* addTelemetryDebug */.eJ)('Error reported to customer', { 'error.message': error.message });
    };
    const pageMayExitObservable = (0,browser_pageMayExitObservable/* createPageMayExitObservable */.FP)(configuration);
    const pageMayExitSubscription = pageMayExitObservable.subscribe((event) => {
        lifeCycle.notify(11 /* LifeCycleEventType.PAGE_MAY_EXIT */, event);
    });
    cleanupTasks.push(() => pageMayExitSubscription.unsubscribe());
    const telemetry = (0,telemetry_telemetry/* startTelemetry */.VL)("browser-rum-sdk" /* TelemetryService.RUM */, configuration, hooks, reportError, pageMayExitObservable, createEncoder);
    cleanupTasks.push(telemetry.stop);
    const session = !(0,eventBridge/* canUseEventBridge */.xT)()
        ? startRumSessionManager(configuration, lifeCycle, trackingConsentState)
        : startRumSessionManagerStub();
    if (!(0,eventBridge/* canUseEventBridge */.xT)()) {
        const batch = startRumBatch(configuration, lifeCycle, reportError, pageMayExitObservable, session.expireObservable, createEncoder);
        cleanupTasks.push(() => batch.stop());
        startCustomerDataTelemetry(telemetry, lifeCycle, batch.flushController.flushObservable);
    }
    else {
        startRumEventBridge(lifeCycle);
    }
    startTrackingConsentContext(hooks, trackingConsentState);
    const { stop: stopInitialViewMetricsTelemetry } = startInitialViewMetricsTelemetry(lifeCycle, telemetry);
    cleanupTasks.push(stopInitialViewMetricsTelemetry);
    const { stop: stopRumEventCollection, ...startRumEventCollectionResult } = startRumEventCollection(lifeCycle, hooks, configuration, session, recorderApi, initialViewOptions, customVitalsState, bufferedDataObservable, sdkName, reportError);
    cleanupTasks.push(stopRumEventCollection);
    bufferedDataObservable.unbuffer();
    // Add Clean-up tasks for Profiler API.
    cleanupTasks.push(() => profilerApi.stop());
    return {
        ...startRumEventCollectionResult,
        lifeCycle,
        session,
        stopSession: () => session.expire(),
        telemetry,
        stop: () => {
            cleanupTasks.forEach((task) => task());
        },
        hooks,
    };
}
function startRumEventCollection(lifeCycle, hooks, configuration, session, recorderApi, initialViewOptions, customVitalsState, bufferedDataObservable, sdkName, reportError) {
    const cleanupTasks = [];
    const domMutationObservable = createDOMMutationObservable();
    const locationChangeObservable = createLocationChangeObservable(configuration, location);
    const { observable: windowOpenObservable, stop: stopWindowOpen } = createWindowOpenObservable();
    cleanupTasks.push(stopWindowOpen);
    startDefaultContext(hooks, configuration, sdkName);
    const pageStateHistory = startPageStateHistory(hooks, configuration);
    cleanupTasks.push(() => pageStateHistory.stop());
    const viewHistory = startViewHistory(lifeCycle);
    cleanupTasks.push(() => viewHistory.stop());
    const urlContexts = startUrlContexts(lifeCycle, hooks, locationChangeObservable, location);
    cleanupTasks.push(() => urlContexts.stop());
    const featureFlagContexts = startFeatureFlagContexts(lifeCycle, hooks, configuration);
    startSessionContext(hooks, session, recorderApi, viewHistory);
    startConnectivityContext(hooks);
    const globalContext = startGlobalContext(hooks, configuration, 'rum', true);
    const userContext = startUserContext(hooks, configuration, session, 'rum');
    const accountContext = startAccountContext(hooks, configuration, 'rum');
    const actionCollection = startActionCollection(lifeCycle, hooks, domMutationObservable, windowOpenObservable, configuration);
    cleanupTasks.push(actionCollection.stop);
    const eventCollection = startEventCollection(lifeCycle);
    const displayContext = startDisplayContext(hooks, configuration);
    cleanupTasks.push(displayContext.stop);
    const ciVisibilityContext = startCiVisibilityContext(configuration, hooks);
    cleanupTasks.push(ciVisibilityContext.stop);
    startSyntheticsContext(hooks);
    startRumAssembly(configuration, lifeCycle, hooks, reportError);
    const { addTiming, startView, setViewName, setViewContext, setViewContextProperty, getViewContext, stop: stopViewCollection, } = startViewCollection(lifeCycle, hooks, configuration, location, domMutationObservable, windowOpenObservable, locationChangeObservable, recorderApi, viewHistory, initialViewOptions);
    cleanupTasks.push(stopViewCollection);
    const { stop: stopResourceCollection } = startResourceCollection(lifeCycle, configuration, pageStateHistory);
    cleanupTasks.push(stopResourceCollection);
    if (configuration.trackLongTasks) {
        if (supportPerformanceTimingEvent(RumPerformanceEntryType.LONG_ANIMATION_FRAME)) {
            const { stop: stopLongAnimationFrameCollection } = startLongAnimationFrameCollection(lifeCycle, configuration);
            cleanupTasks.push(stopLongAnimationFrameCollection);
        }
        else {
            startLongTaskCollection(lifeCycle, configuration);
        }
    }
    const { addError } = startErrorCollection(lifeCycle, configuration, bufferedDataObservable);
    startRequestCollection(lifeCycle, configuration, session, userContext, accountContext);
    const vitalCollection = startVitalCollection(lifeCycle, pageStateHistory, customVitalsState);
    const internalContext = startInternalContext(configuration.applicationId, session, viewHistory, actionCollection.actionContexts, urlContexts);
    return {
        addAction: actionCollection.addAction,
        addEvent: eventCollection.addEvent,
        addError,
        addTiming,
        addFeatureFlagEvaluation: featureFlagContexts.addFeatureFlagEvaluation,
        startView,
        setViewContext,
        setViewContextProperty,
        getViewContext,
        setViewName,
        viewHistory,
        getInternalContext: internalContext.get,
        startDurationVital: vitalCollection.startDurationVital,
        stopDurationVital: vitalCollection.stopDurationVital,
        addDurationVital: vitalCollection.addDurationVital,
        addOperationStepVital: vitalCollection.addOperationStepVital,
        globalContext,
        userContext,
        accountContext,
        stop: () => cleanupTasks.forEach((task) => task()),
    };
}
//# sourceMappingURL=startRum.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/intakeSites.js
var intakeSites = __webpack_require__(93909);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/getSessionReplayUrl.js

function getSessionReplayUrl(configuration, { session, viewContext, errorType, }) {
    const sessionId = session ? session.id : 'no-session-id';
    const parameters = [];
    if (errorType !== undefined) {
        parameters.push(`error-type=${errorType}`);
    }
    if (viewContext) {
        parameters.push(`seed=${viewContext.id}`);
        parameters.push(`from=${viewContext.startClocks.timeStamp}`);
    }
    const origin = getDatadogSiteUrl(configuration);
    const path = `/rum/replay/sessions/${sessionId}`;
    return `${origin}${path}?${parameters.join('&')}`;
}
function getDatadogSiteUrl(rumConfiguration) {
    const site = rumConfiguration.site;
    const subdomain = rumConfiguration.subdomain || getSiteDefaultSubdomain(rumConfiguration);
    return `https://${subdomain ? `${subdomain}.` : ''}${site}`;
}
function getSiteDefaultSubdomain(configuration) {
    switch (configuration.site) {
        case intakeSites/* INTAKE_SITE_US1 */.D_:
        case intakeSites/* INTAKE_SITE_EU1 */.Ds:
            return 'app';
        case intakeSites/* INTAKE_SITE_STAGING */.DZ:
            return 'dd';
        default:
            return undefined;
    }
}
//# sourceMappingURL=getSessionReplayUrl.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/transport/formDataTransport.js

function createFormDataTransport(configuration, lifeCycle, createEncoder, streamId) {
    const reportError = (error) => {
        lifeCycle.notify(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, { error });
        // monitor-until: forever, to keep an eye on the errors reported to customers
        (0,telemetry_telemetry/* addTelemetryDebug */.eJ)('Error reported to customer', { 'error.message': error.message });
    };
    const httpRequest = (0,transport_httpRequest/* createHttpRequest */.UF)([configuration.profilingEndpointBuilder], reportError);
    const encoder = createEncoder(streamId);
    return {
        async send({ event, ...attachments }) {
            const formData = new FormData();
            const serializedEvent = (0,jsonStringify/* jsonStringify */.l)(event);
            if (!serializedEvent) {
                throw new Error('Failed to serialize event');
            }
            formData.append('event', new Blob([serializedEvent], { type: 'application/json' }), 'event.json');
            let bytesCount = serializedEvent.length;
            for (const [key, value] of (0,polyfills/* objectEntries */.qP)(attachments)) {
                const serializedValue = (0,jsonStringify/* jsonStringify */.l)(value);
                if (!serializedValue) {
                    throw new Error('Failed to serialize attachment');
                }
                const result = await encode(encoder, serializedValue);
                bytesCount += result.outputBytesCount;
                formData.append(key, new Blob([result.output]), key);
            }
            httpRequest.send({
                data: formData,
                bytesCount,
            });
        },
    };
}
function encode(encoder, data) {
    return new Promise((resolve) => {
        encoder.write(data);
        encoder.finish((encoderResult) => {
            resolve(encoderResult);
        });
    });
}
//# sourceMappingURL=formDataTransport.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/index.js




















//# sourceMappingURL=index.js.map

/***/ }),

/***/ 98290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FT": function() { return /* binding */ getSegmentsCount; },
/* harmony export */   "MA": function() { return /* binding */ getReplayStats; },
/* harmony export */   "pk": function() { return /* binding */ addWroteData; },
/* harmony export */   "ui": function() { return /* binding */ addSegment; },
/* harmony export */   "xK": function() { return /* binding */ addRecord; }
/* harmony export */ });
/* unused harmony exports MAX_STATS_HISTORY, resetReplayStats */
const MAX_STATS_HISTORY = 1000;
let statsPerView;
function getSegmentsCount(viewId) {
    return getOrCreateReplayStats(viewId).segments_count;
}
function addSegment(viewId) {
    getOrCreateReplayStats(viewId).segments_count += 1;
}
function addRecord(viewId) {
    getOrCreateReplayStats(viewId).records_count += 1;
}
function addWroteData(viewId, additionalBytesCount) {
    getOrCreateReplayStats(viewId).segments_total_raw_size += additionalBytesCount;
}
function getReplayStats(viewId) {
    return statsPerView === null || statsPerView === void 0 ? void 0 : statsPerView.get(viewId);
}
function resetReplayStats() {
    statsPerView = undefined;
}
function getOrCreateReplayStats(viewId) {
    if (!statsPerView) {
        statsPerView = new Map();
    }
    let replayStats;
    if (statsPerView.has(viewId)) {
        replayStats = statsPerView.get(viewId);
    }
    else {
        replayStats = {
            records_count: 0,
            segments_count: 0,
            segments_total_raw_size: 0,
        };
        statsPerView.set(viewId, replayStats);
        if (statsPerView.size > MAX_STATS_HISTORY) {
            deleteOldestStats();
        }
    }
    return replayStats;
}
function deleteOldestStats() {
    if (!statsPerView) {
        return;
    }
    const toDelete = statsPerView.keys().next().value;
    if (toDelete) {
        statsPerView.delete(toDelete);
    }
}
//# sourceMappingURL=replayStats.js.map

/***/ }),

/***/ 86947:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "DefaultPrivacyLevel": function() { return /* reexport */ configuration/* DefaultPrivacyLevel */.Jj; },
  "datadogRum": function() { return /* binding */ datadogRum; }
});

// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/boot/init.js
var init = __webpack_require__(8678);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/globalObject.js
var globalObject = __webpack_require__(51145);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-rum-core/esm/index.js + 119 modules
var esm = __webpack_require__(20478);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/transport/eventBridge.js
var eventBridge = __webpack_require__(76876);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/functionUtils.js
var functionUtils = __webpack_require__(251);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-rum/esm/domain/replayStats.js
var replayStats = __webpack_require__(98290);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/browser/addEventListener.js
var addEventListener = __webpack_require__(83206);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/byteUtils.js
var byteUtils = __webpack_require__(51962);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/deflate/deflateEncoder.js

function createDeflateEncoder(configuration, worker, streamId) {
    let rawBytesCount = 0;
    let compressedData = [];
    let compressedDataTrailer;
    let isEmpty = true;
    let nextWriteActionId = 0;
    const pendingWriteActions = [];
    const { stop: removeMessageListener } = (0,addEventListener/* addEventListener */.O)(configuration, worker, 'message', ({ data: workerResponse }) => {
        if (workerResponse.type !== 'wrote' || workerResponse.streamId !== streamId) {
            return;
        }
        const nextPendingAction = pendingWriteActions[0];
        if (nextPendingAction) {
            if (nextPendingAction.id === workerResponse.id) {
                pendingWriteActions.shift();
                rawBytesCount += workerResponse.additionalBytesCount;
                compressedData.push(workerResponse.result);
                compressedDataTrailer = workerResponse.trailer;
                if (nextPendingAction.writeCallback) {
                    nextPendingAction.writeCallback(workerResponse.result.byteLength);
                }
                else if (nextPendingAction.finishCallback) {
                    nextPendingAction.finishCallback();
                }
            }
            else if (nextPendingAction.id < workerResponse.id) {
                // Worker responses received out of order
                removeMessageListener();
            }
        }
    });
    function consumeResult() {
        const output = compressedData.length === 0 ? new Uint8Array(0) : (0,byteUtils/* concatBuffers */.Kb)(compressedData.concat(compressedDataTrailer));
        const result = {
            rawBytesCount,
            output,
            outputBytesCount: output.byteLength,
            encoding: 'deflate',
        };
        rawBytesCount = 0;
        compressedData = [];
        return result;
    }
    function sendResetIfNeeded() {
        if (!isEmpty) {
            worker.postMessage({
                action: 'reset',
                streamId,
            });
            isEmpty = true;
        }
    }
    return {
        isAsync: true,
        get isEmpty() {
            return isEmpty;
        },
        write(data, callback) {
            worker.postMessage({
                action: 'write',
                id: nextWriteActionId,
                data,
                streamId,
            });
            pendingWriteActions.push({
                id: nextWriteActionId,
                writeCallback: callback,
                data,
            });
            isEmpty = false;
            nextWriteActionId += 1;
        },
        finish(callback) {
            sendResetIfNeeded();
            if (!pendingWriteActions.length) {
                callback(consumeResult());
            }
            else {
                // Make sure we do not call any write callback
                pendingWriteActions.forEach((pendingWriteAction) => {
                    delete pendingWriteAction.writeCallback;
                });
                // Wait for the last action to finish before calling the finish callback
                pendingWriteActions[pendingWriteActions.length - 1].finishCallback = () => callback(consumeResult());
            }
        },
        finishSync() {
            sendResetIfNeeded();
            const pendingData = pendingWriteActions.map((pendingWriteAction) => pendingWriteAction.data).join('');
            // Ignore all pending write actions responses from the worker
            pendingWriteActions.length = 0;
            return { ...consumeResult(), pendingData };
        },
        estimateEncodedBytesCount(data) {
            // This is a rough estimation of the data size once it'll be encoded by deflate. We observed
            // that if it's the first chunk of data pushed to the stream, the ratio is lower (3-4), but
            // after that the ratio is greater (10+). We chose 8 here, which (on average) seems to produce
            // requests of the expected size.
            return data.length / 8;
        },
        stop() {
            removeMessageListener();
        },
    };
}
//# sourceMappingURL=deflateEncoder.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/timeUtils.js
var timeUtils = __webpack_require__(25026);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/timer.js
var timer = __webpack_require__(65483);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/display.js
var display = __webpack_require__(13842);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/telemetry/telemetry.js + 1 modules
var telemetry_telemetry = __webpack_require__(18797);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/scriptLoadingError.js

function reportScriptLoadingError({ configuredUrl, error, source, scriptType, }) {
    display/* display.error */.jf.error(`${source} failed to start: an error occurred while initializing the ${scriptType}:`, error);
    if (error instanceof Event || (error instanceof Error && isMessageCspRelated(error.message))) {
        let baseMessage;
        if (configuredUrl) {
            baseMessage = `Please make sure the ${scriptType} URL ${configuredUrl} is correct and CSP is correctly configured.`;
        }
        else {
            baseMessage = 'Please make sure CSP is correctly configured.';
        }
        display/* display.error */.jf.error(`${baseMessage} See documentation at ${display/* DOCS_ORIGIN */.aA}/integrations/content_security_policy_logs/#use-csp-with-real-user-monitoring-and-session-replay`);
    }
    else if (scriptType === 'worker') {
        (0,telemetry_telemetry/* addTelemetryError */.Sz)(error);
    }
}
function isMessageCspRelated(message) {
    return (message.includes('Content Security Policy') ||
        // Related to `require-trusted-types-for` CSP: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Security-Policy/require-trusted-types-for
        message.includes("requires 'TrustedScriptURL'"));
}
//# sourceMappingURL=scriptLoadingError.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/deflate/deflateWorker.js


const INITIALIZATION_TIME_OUT_DELAY = 30 * timeUtils/* ONE_SECOND */.WT;
function createDeflateWorker(configuration) {
    return new Worker(configuration.workerUrl || URL.createObjectURL(new Blob(["(()=>{function t(t){if(1===t.length)return t[0];const e=t.reduce((t,e)=>t+e.length,0),a=new Uint8Array(e);let n=0;for(const e of t)a.set(e,n),n+=e.length;return a}function e(t){for(var e=t.length;--e>=0;)t[e]=0}var a=new Uint8Array([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0]),n=new Uint8Array([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13]),r=new Uint8Array([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7]),i=new Uint8Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),s=Array(576);e(s);var h=Array(60);e(h);var l=Array(512);e(l);var _=Array(256);e(_);var o=Array(29);e(o);var d,u,f,c=Array(30);function p(t,e,a,n,r){this.static_tree=t,this.extra_bits=e,this.extra_base=a,this.elems=n,this.max_length=r,this.has_stree=t&&t.length}function g(t,e){this.dyn_tree=t,this.max_code=0,this.stat_desc=e}e(c);var v=function(t){return t<256?l[t]:l[256+(t>>>7)]},w=function(t,e){t.pending_buf[t.pending++]=255&e,t.pending_buf[t.pending++]=e>>>8&255},m=function(t,e,a){t.bi_valid>16-a?(t.bi_buf|=e<<t.bi_valid&65535,w(t,t.bi_buf),t.bi_buf=e>>16-t.bi_valid,t.bi_valid+=a-16):(t.bi_buf|=e<<t.bi_valid&65535,t.bi_valid+=a)},b=function(t,e,a){m(t,a[2*e],a[2*e+1])},y=function(t,e){var a=0;do{a|=1&t,t>>>=1,a<<=1}while(--e>0);return a>>>1},z=function(t,e,a){var n,r,i=Array(16),s=0;for(n=1;n<=15;n++)i[n]=s=s+a[n-1]<<1;for(r=0;r<=e;r++){var h=t[2*r+1];0!==h&&(t[2*r]=y(i[h]++,h))}},k=function(t){var e;for(e=0;e<286;e++)t.dyn_ltree[2*e]=0;for(e=0;e<30;e++)t.dyn_dtree[2*e]=0;for(e=0;e<19;e++)t.bl_tree[2*e]=0;t.dyn_ltree[512]=1,t.opt_len=t.static_len=0,t.last_lit=t.matches=0},x=function(t){t.bi_valid>8?w(t,t.bi_buf):t.bi_valid>0&&(t.pending_buf[t.pending++]=t.bi_buf),t.bi_buf=0,t.bi_valid=0},A=function(t,e,a,n){var r=2*e,i=2*a;return t[r]<t[i]||t[r]===t[i]&&n[e]<=n[a]},U=function(t,e,a){for(var n=t.heap[a],r=a<<1;r<=t.heap_len&&(r<t.heap_len&&A(e,t.heap[r+1],t.heap[r],t.depth)&&r++,!A(e,n,t.heap[r],t.depth));)t.heap[a]=t.heap[r],a=r,r<<=1;t.heap[a]=n},B=function(t,e,r){var i,s,h,l,d=0;if(0!==t.last_lit)do{i=t.pending_buf[t.d_buf+2*d]<<8|t.pending_buf[t.d_buf+2*d+1],s=t.pending_buf[t.l_buf+d],d++,0===i?b(t,s,e):(h=_[s],b(t,h+256+1,e),0!==(l=a[h])&&(s-=o[h],m(t,s,l)),i--,h=v(i),b(t,h,r),0!==(l=n[h])&&(i-=c[h],m(t,i,l)))}while(d<t.last_lit);b(t,256,e)},I=function(t,e){var a,n,r,i=e.dyn_tree,s=e.stat_desc.static_tree,h=e.stat_desc.has_stree,l=e.stat_desc.elems,_=-1;for(t.heap_len=0,t.heap_max=573,a=0;a<l;a++)0!==i[2*a]?(t.heap[++t.heap_len]=_=a,t.depth[a]=0):i[2*a+1]=0;for(;t.heap_len<2;)i[2*(r=t.heap[++t.heap_len]=_<2?++_:0)]=1,t.depth[r]=0,t.opt_len--,h&&(t.static_len-=s[2*r+1]);for(e.max_code=_,a=t.heap_len>>1;a>=1;a--)U(t,i,a);r=l;do{a=t.heap[1],t.heap[1]=t.heap[t.heap_len--],U(t,i,1),n=t.heap[1],t.heap[--t.heap_max]=a,t.heap[--t.heap_max]=n,i[2*r]=i[2*a]+i[2*n],t.depth[r]=(t.depth[a]>=t.depth[n]?t.depth[a]:t.depth[n])+1,i[2*a+1]=i[2*n+1]=r,t.heap[1]=r++,U(t,i,1)}while(t.heap_len>=2);t.heap[--t.heap_max]=t.heap[1],function(t,e){var a,n,r,i,s,h,l=e.dyn_tree,_=e.max_code,o=e.stat_desc.static_tree,d=e.stat_desc.has_stree,u=e.stat_desc.extra_bits,f=e.stat_desc.extra_base,c=e.stat_desc.max_length,p=0;for(i=0;i<=15;i++)t.bl_count[i]=0;for(l[2*t.heap[t.heap_max]+1]=0,a=t.heap_max+1;a<573;a++)(i=l[2*l[2*(n=t.heap[a])+1]+1]+1)>c&&(i=c,p++),l[2*n+1]=i,n>_||(t.bl_count[i]++,s=0,n>=f&&(s=u[n-f]),h=l[2*n],t.opt_len+=h*(i+s),d&&(t.static_len+=h*(o[2*n+1]+s)));if(0!==p){do{for(i=c-1;0===t.bl_count[i];)i--;t.bl_count[i]--,t.bl_count[i+1]+=2,t.bl_count[c]--,p-=2}while(p>0);for(i=c;0!==i;i--)for(n=t.bl_count[i];0!==n;)(r=t.heap[--a])>_||(l[2*r+1]!==i&&(t.opt_len+=(i-l[2*r+1])*l[2*r],l[2*r+1]=i),n--)}}(t,e),z(i,_,t.bl_count)},E=function(t,e,a){var n,r,i=-1,s=e[1],h=0,l=7,_=4;for(0===s&&(l=138,_=3),e[2*(a+1)+1]=65535,n=0;n<=a;n++)r=s,s=e[2*(n+1)+1],++h<l&&r===s||(h<_?t.bl_tree[2*r]+=h:0!==r?(r!==i&&t.bl_tree[2*r]++,t.bl_tree[32]++):h<=10?t.bl_tree[34]++:t.bl_tree[36]++,h=0,i=r,0===s?(l=138,_=3):r===s?(l=6,_=3):(l=7,_=4))},C=function(t,e,a){var n,r,i=-1,s=e[1],h=0,l=7,_=4;for(0===s&&(l=138,_=3),n=0;n<=a;n++)if(r=s,s=e[2*(n+1)+1],!(++h<l&&r===s)){if(h<_)do{b(t,r,t.bl_tree)}while(0!==--h);else 0!==r?(r!==i&&(b(t,r,t.bl_tree),h--),b(t,16,t.bl_tree),m(t,h-3,2)):h<=10?(b(t,17,t.bl_tree),m(t,h-3,3)):(b(t,18,t.bl_tree),m(t,h-11,7));h=0,i=r,0===s?(l=138,_=3):r===s?(l=6,_=3):(l=7,_=4)}},D=!1,M=function(t,e,a,n){m(t,0+(n?1:0),3),function(t,e,a){x(t),w(t,a),w(t,~a),t.pending_buf.set(t.window.subarray(e,e+a),t.pending),t.pending+=a}(t,e,a)},j=M,L=function(t,e,a,n){for(var r=65535&t,i=t>>>16&65535,s=0;0!==a;){a-=s=a>2e3?2e3:a;do{i=i+(r=r+e[n++]|0)|0}while(--s);r%=65521,i%=65521}return r|i<<16},S=new Uint32Array(function(){for(var t,e=[],a=0;a<256;a++){t=a;for(var n=0;n<8;n++)t=1&t?3988292384^t>>>1:t>>>1;e[a]=t}return e}()),T=function(t,e,a,n){var r=S,i=n+a;t^=-1;for(var s=n;s<i;s++)t=t>>>8^r[255&(t^e[s])];return-1^t},O={2:\"need dictionary\",1:\"stream end\",0:\"\",\"-1\":\"file error\",\"-2\":\"stream error\",\"-3\":\"data error\",\"-4\":\"insufficient memory\",\"-5\":\"buffer error\",\"-6\":\"incompatible version\"},q=j,F=function(t,e,a){return t.pending_buf[t.d_buf+2*t.last_lit]=e>>>8&255,t.pending_buf[t.d_buf+2*t.last_lit+1]=255&e,t.pending_buf[t.l_buf+t.last_lit]=255&a,t.last_lit++,0===e?t.dyn_ltree[2*a]++:(t.matches++,e--,t.dyn_ltree[2*(_[a]+256+1)]++,t.dyn_dtree[2*v(e)]++),t.last_lit===t.lit_bufsize-1},G=-2,H=258,J=262,K=103,N=113,P=666,Q=function(t,e){return t.msg=O[e],e},R=function(t){return(t<<1)-(t>4?9:0)},V=function(t){for(var e=t.length;--e>=0;)t[e]=0},W=function(t,e,a){return(e<<t.hash_shift^a)&t.hash_mask},X=function(t){var e=t.state,a=e.pending;a>t.avail_out&&(a=t.avail_out),0!==a&&(t.output.set(e.pending_buf.subarray(e.pending_out,e.pending_out+a),t.next_out),t.next_out+=a,e.pending_out+=a,t.total_out+=a,t.avail_out-=a,e.pending-=a,0===e.pending&&(e.pending_out=0))},Y=function(t,e){(function(t,e,a,n){var r,l,_=0;t.level>0?(2===t.strm.data_type&&(t.strm.data_type=function(t){var e,a=4093624447;for(e=0;e<=31;e++,a>>>=1)if(1&a&&0!==t.dyn_ltree[2*e])return 0;if(0!==t.dyn_ltree[18]||0!==t.dyn_ltree[20]||0!==t.dyn_ltree[26])return 1;for(e=32;e<256;e++)if(0!==t.dyn_ltree[2*e])return 1;return 0}(t)),I(t,t.l_desc),I(t,t.d_desc),_=function(t){var e;for(E(t,t.dyn_ltree,t.l_desc.max_code),E(t,t.dyn_dtree,t.d_desc.max_code),I(t,t.bl_desc),e=18;e>=3&&0===t.bl_tree[2*i[e]+1];e--);return t.opt_len+=3*(e+1)+5+5+4,e}(t),r=t.opt_len+3+7>>>3,(l=t.static_len+3+7>>>3)<=r&&(r=l)):r=l=a+5,a+4<=r&&-1!==e?M(t,e,a,n):4===t.strategy||l===r?(m(t,2+(n?1:0),3),B(t,s,h)):(m(t,4+(n?1:0),3),function(t,e,a,n){var r;for(m(t,e-257,5),m(t,a-1,5),m(t,n-4,4),r=0;r<n;r++)m(t,t.bl_tree[2*i[r]+1],3);C(t,t.dyn_ltree,e-1),C(t,t.dyn_dtree,a-1)}(t,t.l_desc.max_code+1,t.d_desc.max_code+1,_+1),B(t,t.dyn_ltree,t.dyn_dtree)),k(t),n&&x(t)})(t,t.block_start>=0?t.block_start:-1,t.strstart-t.block_start,e),t.block_start=t.strstart,X(t.strm)},Z=function(t,e){t.pending_buf[t.pending++]=e},$=function(t,e){t.pending_buf[t.pending++]=e>>>8&255,t.pending_buf[t.pending++]=255&e},tt=function(t,e,a,n){var r=t.avail_in;return r>n&&(r=n),0===r?0:(t.avail_in-=r,e.set(t.input.subarray(t.next_in,t.next_in+r),a),1===t.state.wrap?t.adler=L(t.adler,e,r,a):2===t.state.wrap&&(t.adler=T(t.adler,e,r,a)),t.next_in+=r,t.total_in+=r,r)},et=function(t,e){var a,n,r=t.max_chain_length,i=t.strstart,s=t.prev_length,h=t.nice_match,l=t.strstart>t.w_size-J?t.strstart-(t.w_size-J):0,_=t.window,o=t.w_mask,d=t.prev,u=t.strstart+H,f=_[i+s-1],c=_[i+s];t.prev_length>=t.good_match&&(r>>=2),h>t.lookahead&&(h=t.lookahead);do{if(_[(a=e)+s]===c&&_[a+s-1]===f&&_[a]===_[i]&&_[++a]===_[i+1]){i+=2,a++;do{}while(_[++i]===_[++a]&&_[++i]===_[++a]&&_[++i]===_[++a]&&_[++i]===_[++a]&&_[++i]===_[++a]&&_[++i]===_[++a]&&_[++i]===_[++a]&&_[++i]===_[++a]&&i<u);if(n=H-(u-i),i=u-H,n>s){if(t.match_start=e,s=n,n>=h)break;f=_[i+s-1],c=_[i+s]}}}while((e=d[e&o])>l&&0!==--r);return s<=t.lookahead?s:t.lookahead},at=function(t){var e,a,n,r,i,s=t.w_size;do{if(r=t.window_size-t.lookahead-t.strstart,t.strstart>=s+(s-J)){t.window.set(t.window.subarray(s,s+s),0),t.match_start-=s,t.strstart-=s,t.block_start-=s,e=a=t.hash_size;do{n=t.head[--e],t.head[e]=n>=s?n-s:0}while(--a);e=a=s;do{n=t.prev[--e],t.prev[e]=n>=s?n-s:0}while(--a);r+=s}if(0===t.strm.avail_in)break;if(a=tt(t.strm,t.window,t.strstart+t.lookahead,r),t.lookahead+=a,t.lookahead+t.insert>=3)for(i=t.strstart-t.insert,t.ins_h=t.window[i],t.ins_h=W(t,t.ins_h,t.window[i+1]);t.insert&&(t.ins_h=W(t,t.ins_h,t.window[i+3-1]),t.prev[i&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=i,i++,t.insert--,!(t.lookahead+t.insert<3)););}while(t.lookahead<J&&0!==t.strm.avail_in)},nt=function(t,e){for(var a,n;;){if(t.lookahead<J){if(at(t),t.lookahead<J&&0===e)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=W(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),0!==a&&t.strstart-a<=t.w_size-J&&(t.match_length=et(t,a)),t.match_length>=3)if(n=F(t,t.strstart-t.match_start,t.match_length-3),t.lookahead-=t.match_length,t.match_length<=t.max_lazy_match&&t.lookahead>=3){t.match_length--;do{t.strstart++,t.ins_h=W(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart}while(0!==--t.match_length);t.strstart++}else t.strstart+=t.match_length,t.match_length=0,t.ins_h=t.window[t.strstart],t.ins_h=W(t,t.ins_h,t.window[t.strstart+1]);else n=F(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++;if(n&&(Y(t,!1),0===t.strm.avail_out))return 1}return t.insert=t.strstart<2?t.strstart:2,4===e?(Y(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(Y(t,!1),0===t.strm.avail_out)?1:2},rt=function(t,e){for(var a,n,r;;){if(t.lookahead<J){if(at(t),t.lookahead<J&&0===e)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=W(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),t.prev_length=t.match_length,t.prev_match=t.match_start,t.match_length=2,0!==a&&t.prev_length<t.max_lazy_match&&t.strstart-a<=t.w_size-J&&(t.match_length=et(t,a),t.match_length<=5&&(1===t.strategy||3===t.match_length&&t.strstart-t.match_start>4096)&&(t.match_length=2)),t.prev_length>=3&&t.match_length<=t.prev_length){r=t.strstart+t.lookahead-3,n=F(t,t.strstart-1-t.prev_match,t.prev_length-3),t.lookahead-=t.prev_length-1,t.prev_length-=2;do{++t.strstart<=r&&(t.ins_h=W(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart)}while(0!==--t.prev_length);if(t.match_available=0,t.match_length=2,t.strstart++,n&&(Y(t,!1),0===t.strm.avail_out))return 1}else if(t.match_available){if((n=F(t,0,t.window[t.strstart-1]))&&Y(t,!1),t.strstart++,t.lookahead--,0===t.strm.avail_out)return 1}else t.match_available=1,t.strstart++,t.lookahead--}return t.match_available&&(n=F(t,0,t.window[t.strstart-1]),t.match_available=0),t.insert=t.strstart<2?t.strstart:2,4===e?(Y(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(Y(t,!1),0===t.strm.avail_out)?1:2};function it(t,e,a,n,r){this.good_length=t,this.max_lazy=e,this.nice_length=a,this.max_chain=n,this.func=r}var st=[new it(0,0,0,0,function(t,e){var a=65535;for(a>t.pending_buf_size-5&&(a=t.pending_buf_size-5);;){if(t.lookahead<=1){if(at(t),0===t.lookahead&&0===e)return 1;if(0===t.lookahead)break}t.strstart+=t.lookahead,t.lookahead=0;var n=t.block_start+a;if((0===t.strstart||t.strstart>=n)&&(t.lookahead=t.strstart-n,t.strstart=n,Y(t,!1),0===t.strm.avail_out))return 1;if(t.strstart-t.block_start>=t.w_size-J&&(Y(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,4===e?(Y(t,!0),0===t.strm.avail_out?3:4):(t.strstart>t.block_start&&(Y(t,!1),t.strm.avail_out),1)}),new it(4,4,8,4,nt),new it(4,5,16,8,nt),new it(4,6,32,32,nt),new it(4,4,16,16,rt),new it(8,16,32,32,rt),new it(8,16,128,128,rt),new it(8,32,128,256,rt),new it(32,128,258,1024,rt),new it(32,258,258,4096,rt)];function ht(){this.strm=null,this.status=0,this.pending_buf=null,this.pending_buf_size=0,this.pending_out=0,this.pending=0,this.wrap=0,this.gzhead=null,this.gzindex=0,this.method=8,this.last_flush=-1,this.w_size=0,this.w_bits=0,this.w_mask=0,this.window=null,this.window_size=0,this.prev=null,this.head=null,this.ins_h=0,this.hash_size=0,this.hash_bits=0,this.hash_mask=0,this.hash_shift=0,this.block_start=0,this.match_length=0,this.prev_match=0,this.match_available=0,this.strstart=0,this.match_start=0,this.lookahead=0,this.prev_length=0,this.max_chain_length=0,this.max_lazy_match=0,this.level=0,this.strategy=0,this.good_match=0,this.nice_match=0,this.dyn_ltree=new Uint16Array(1146),this.dyn_dtree=new Uint16Array(122),this.bl_tree=new Uint16Array(78),V(this.dyn_ltree),V(this.dyn_dtree),V(this.bl_tree),this.l_desc=null,this.d_desc=null,this.bl_desc=null,this.bl_count=new Uint16Array(16),this.heap=new Uint16Array(573),V(this.heap),this.heap_len=0,this.heap_max=0,this.depth=new Uint16Array(573),V(this.depth),this.l_buf=0,this.lit_bufsize=0,this.last_lit=0,this.d_buf=0,this.opt_len=0,this.static_len=0,this.matches=0,this.insert=0,this.bi_buf=0,this.bi_valid=0}for(var lt=function(t){var e,i=function(t){if(!t||!t.state)return Q(t,G);t.total_in=t.total_out=0,t.data_type=2;var e=t.state;return e.pending=0,e.pending_out=0,e.wrap<0&&(e.wrap=-e.wrap),e.status=e.wrap?42:N,t.adler=2===e.wrap?0:1,e.last_flush=0,function(t){D||(function(){var t,e,i,g,v,w=Array(16);for(i=0,g=0;g<28;g++)for(o[g]=i,t=0;t<1<<a[g];t++)_[i++]=g;for(_[i-1]=g,v=0,g=0;g<16;g++)for(c[g]=v,t=0;t<1<<n[g];t++)l[v++]=g;for(v>>=7;g<30;g++)for(c[g]=v<<7,t=0;t<1<<n[g]-7;t++)l[256+v++]=g;for(e=0;e<=15;e++)w[e]=0;for(t=0;t<=143;)s[2*t+1]=8,t++,w[8]++;for(;t<=255;)s[2*t+1]=9,t++,w[9]++;for(;t<=279;)s[2*t+1]=7,t++,w[7]++;for(;t<=287;)s[2*t+1]=8,t++,w[8]++;for(z(s,287,w),t=0;t<30;t++)h[2*t+1]=5,h[2*t]=y(t,5);d=new p(s,a,257,286,15),u=new p(h,n,0,30,15),f=new p([],r,0,19,7)}(),D=!0),t.l_desc=new g(t.dyn_ltree,d),t.d_desc=new g(t.dyn_dtree,u),t.bl_desc=new g(t.bl_tree,f),t.bi_buf=0,t.bi_valid=0,k(t)}(e),0}(t);return 0===i&&((e=t.state).window_size=2*e.w_size,V(e.head),e.max_lazy_match=st[e.level].max_lazy,e.good_match=st[e.level].good_length,e.nice_match=st[e.level].nice_length,e.max_chain_length=st[e.level].max_chain,e.strstart=0,e.block_start=0,e.lookahead=0,e.insert=0,e.match_length=e.prev_length=2,e.match_available=0,e.ins_h=0),i},_t=function(t,e){var a,n;if(!t||!t.state||e>5||e<0)return t?Q(t,G):G;var r=t.state;if(!t.output||!t.input&&0!==t.avail_in||r.status===P&&4!==e)return Q(t,0===t.avail_out?-5:G);r.strm=t;var i=r.last_flush;if(r.last_flush=e,42===r.status)if(2===r.wrap)t.adler=0,Z(r,31),Z(r,139),Z(r,8),r.gzhead?(Z(r,(r.gzhead.text?1:0)+(r.gzhead.hcrc?2:0)+(r.gzhead.extra?4:0)+(r.gzhead.name?8:0)+(r.gzhead.comment?16:0)),Z(r,255&r.gzhead.time),Z(r,r.gzhead.time>>8&255),Z(r,r.gzhead.time>>16&255),Z(r,r.gzhead.time>>24&255),Z(r,9===r.level?2:r.strategy>=2||r.level<2?4:0),Z(r,255&r.gzhead.os),r.gzhead.extra&&r.gzhead.extra.length&&(Z(r,255&r.gzhead.extra.length),Z(r,r.gzhead.extra.length>>8&255)),r.gzhead.hcrc&&(t.adler=T(t.adler,r.pending_buf,r.pending,0)),r.gzindex=0,r.status=69):(Z(r,0),Z(r,0),Z(r,0),Z(r,0),Z(r,0),Z(r,9===r.level?2:r.strategy>=2||r.level<2?4:0),Z(r,3),r.status=N);else{var h=8+(r.w_bits-8<<4)<<8;h|=(r.strategy>=2||r.level<2?0:r.level<6?1:6===r.level?2:3)<<6,0!==r.strstart&&(h|=32),h+=31-h%31,r.status=N,$(r,h),0!==r.strstart&&($(r,t.adler>>>16),$(r,65535&t.adler)),t.adler=1}if(69===r.status)if(r.gzhead.extra){for(a=r.pending;r.gzindex<(65535&r.gzhead.extra.length)&&(r.pending!==r.pending_buf_size||(r.gzhead.hcrc&&r.pending>a&&(t.adler=T(t.adler,r.pending_buf,r.pending-a,a)),X(t),a=r.pending,r.pending!==r.pending_buf_size));)Z(r,255&r.gzhead.extra[r.gzindex]),r.gzindex++;r.gzhead.hcrc&&r.pending>a&&(t.adler=T(t.adler,r.pending_buf,r.pending-a,a)),r.gzindex===r.gzhead.extra.length&&(r.gzindex=0,r.status=73)}else r.status=73;if(73===r.status)if(r.gzhead.name){a=r.pending;do{if(r.pending===r.pending_buf_size&&(r.gzhead.hcrc&&r.pending>a&&(t.adler=T(t.adler,r.pending_buf,r.pending-a,a)),X(t),a=r.pending,r.pending===r.pending_buf_size)){n=1;break}n=r.gzindex<r.gzhead.name.length?255&r.gzhead.name.charCodeAt(r.gzindex++):0,Z(r,n)}while(0!==n);r.gzhead.hcrc&&r.pending>a&&(t.adler=T(t.adler,r.pending_buf,r.pending-a,a)),0===n&&(r.gzindex=0,r.status=91)}else r.status=91;if(91===r.status)if(r.gzhead.comment){a=r.pending;do{if(r.pending===r.pending_buf_size&&(r.gzhead.hcrc&&r.pending>a&&(t.adler=T(t.adler,r.pending_buf,r.pending-a,a)),X(t),a=r.pending,r.pending===r.pending_buf_size)){n=1;break}n=r.gzindex<r.gzhead.comment.length?255&r.gzhead.comment.charCodeAt(r.gzindex++):0,Z(r,n)}while(0!==n);r.gzhead.hcrc&&r.pending>a&&(t.adler=T(t.adler,r.pending_buf,r.pending-a,a)),0===n&&(r.status=K)}else r.status=K;if(r.status===K&&(r.gzhead.hcrc?(r.pending+2>r.pending_buf_size&&X(t),r.pending+2<=r.pending_buf_size&&(Z(r,255&t.adler),Z(r,t.adler>>8&255),t.adler=0,r.status=N)):r.status=N),0!==r.pending){if(X(t),0===t.avail_out)return r.last_flush=-1,0}else if(0===t.avail_in&&R(e)<=R(i)&&4!==e)return Q(t,-5);if(r.status===P&&0!==t.avail_in)return Q(t,-5);if(0!==t.avail_in||0!==r.lookahead||0!==e&&r.status!==P){var l=2===r.strategy?function(t,e){for(var a;;){if(0===t.lookahead&&(at(t),0===t.lookahead)){if(0===e)return 1;break}if(t.match_length=0,a=F(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++,a&&(Y(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,4===e?(Y(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(Y(t,!1),0===t.strm.avail_out)?1:2}(r,e):3===r.strategy?function(t,e){for(var a,n,r,i,s=t.window;;){if(t.lookahead<=H){if(at(t),t.lookahead<=H&&0===e)return 1;if(0===t.lookahead)break}if(t.match_length=0,t.lookahead>=3&&t.strstart>0&&(n=s[r=t.strstart-1])===s[++r]&&n===s[++r]&&n===s[++r]){i=t.strstart+H;do{}while(n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&r<i);t.match_length=H-(i-r),t.match_length>t.lookahead&&(t.match_length=t.lookahead)}if(t.match_length>=3?(a=F(t,1,t.match_length-3),t.lookahead-=t.match_length,t.strstart+=t.match_length,t.match_length=0):(a=F(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++),a&&(Y(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,4===e?(Y(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(Y(t,!1),0===t.strm.avail_out)?1:2}(r,e):st[r.level].func(r,e);if(3!==l&&4!==l||(r.status=P),1===l||3===l)return 0===t.avail_out&&(r.last_flush=-1),0;if(2===l&&(1===e?function(t){m(t,2,3),b(t,256,s),function(t){16===t.bi_valid?(w(t,t.bi_buf),t.bi_buf=0,t.bi_valid=0):t.bi_valid>=8&&(t.pending_buf[t.pending++]=255&t.bi_buf,t.bi_buf>>=8,t.bi_valid-=8)}(t)}(r):5!==e&&(q(r,0,0,!1),3===e&&(V(r.head),0===r.lookahead&&(r.strstart=0,r.block_start=0,r.insert=0))),X(t),0===t.avail_out))return r.last_flush=-1,0}return 4!==e?0:r.wrap<=0?1:(2===r.wrap?(Z(r,255&t.adler),Z(r,t.adler>>8&255),Z(r,t.adler>>16&255),Z(r,t.adler>>24&255),Z(r,255&t.total_in),Z(r,t.total_in>>8&255),Z(r,t.total_in>>16&255),Z(r,t.total_in>>24&255)):($(r,t.adler>>>16),$(r,65535&t.adler)),X(t),r.wrap>0&&(r.wrap=-r.wrap),0!==r.pending?0:1)},ot=function(t){if(!t||!t.state)return G;var e=t.state.status;return 42!==e&&69!==e&&73!==e&&91!==e&&e!==K&&e!==N&&e!==P?Q(t,G):(t.state=null,e===N?Q(t,-3):0)},dt=new Uint8Array(256),ut=0;ut<256;ut++)dt[ut]=ut>=252?6:ut>=248?5:ut>=240?4:ut>=224?3:ut>=192?2:1;dt[254]=dt[254]=1;var ft=function(){this.input=null,this.next_in=0,this.avail_in=0,this.total_in=0,this.output=null,this.next_out=0,this.avail_out=0,this.total_out=0,this.msg=\"\",this.state=null,this.data_type=2,this.adler=0},ct=Object.prototype.toString;function pt(){this.options={level:-1,method:8,chunkSize:16384,windowBits:15,memLevel:8,strategy:0};var t=this.options;t.raw&&t.windowBits>0?t.windowBits=-t.windowBits:t.gzip&&t.windowBits>0&&t.windowBits<16&&(t.windowBits+=16),this.err=0,this.msg=\"\",this.ended=!1,this.chunks=[],this.strm=new ft,this.strm.avail_out=0;var e,a,n=function(t,e,a,n,r,i){if(!t)return G;var s=1;if(-1===e&&(e=6),n<0?(s=0,n=-n):n>15&&(s=2,n-=16),r<1||r>9||8!==a||n<8||n>15||e<0||e>9||i<0||i>4)return Q(t,G);8===n&&(n=9);var h=new ht;return t.state=h,h.strm=t,h.wrap=s,h.gzhead=null,h.w_bits=n,h.w_size=1<<h.w_bits,h.w_mask=h.w_size-1,h.hash_bits=r+7,h.hash_size=1<<h.hash_bits,h.hash_mask=h.hash_size-1,h.hash_shift=~~((h.hash_bits+3-1)/3),h.window=new Uint8Array(2*h.w_size),h.head=new Uint16Array(h.hash_size),h.prev=new Uint16Array(h.w_size),h.lit_bufsize=1<<r+6,h.pending_buf_size=4*h.lit_bufsize,h.pending_buf=new Uint8Array(h.pending_buf_size),h.d_buf=1*h.lit_bufsize,h.l_buf=3*h.lit_bufsize,h.level=e,h.strategy=i,h.method=a,lt(t)}(this.strm,t.level,t.method,t.windowBits,t.memLevel,t.strategy);if(0!==n)throw Error(O[n]);if(t.header&&(e=this.strm,a=t.header,e&&e.state&&(2!==e.state.wrap||(e.state.gzhead=a))),t.dictionary){var r;if(r=\"[object ArrayBuffer]\"===ct.call(t.dictionary)?new Uint8Array(t.dictionary):t.dictionary,0!==(n=function(t,e){var a=e.length;if(!t||!t.state)return G;var n=t.state,r=n.wrap;if(2===r||1===r&&42!==n.status||n.lookahead)return G;if(1===r&&(t.adler=L(t.adler,e,a,0)),n.wrap=0,a>=n.w_size){0===r&&(V(n.head),n.strstart=0,n.block_start=0,n.insert=0);var i=new Uint8Array(n.w_size);i.set(e.subarray(a-n.w_size,a),0),e=i,a=n.w_size}var s=t.avail_in,h=t.next_in,l=t.input;for(t.avail_in=a,t.next_in=0,t.input=e,at(n);n.lookahead>=3;){var _=n.strstart,o=n.lookahead-2;do{n.ins_h=W(n,n.ins_h,n.window[_+3-1]),n.prev[_&n.w_mask]=n.head[n.ins_h],n.head[n.ins_h]=_,_++}while(--o);n.strstart=_,n.lookahead=2,at(n)}return n.strstart+=n.lookahead,n.block_start=n.strstart,n.insert=n.lookahead,n.lookahead=0,n.match_length=n.prev_length=2,n.match_available=0,t.next_in=h,t.input=l,t.avail_in=s,n.wrap=r,0}(this.strm,r)))throw Error(O[n]);this._dict_set=!0}}function gt(t,e,a){try{t.postMessage({type:\"errored\",error:e,streamId:a})}catch(n){t.postMessage({type:\"errored\",error:e+\"\",streamId:a})}}function vt(t){const e=t.strm.adler;return new Uint8Array([3,0,e>>>24&255,e>>>16&255,e>>>8&255,255&e])}pt.prototype.push=function(t,e){var a,n,r=this.strm,i=this.options.chunkSize;if(this.ended)return!1;for(n=e===~~e?e:!0===e?4:0,\"[object ArrayBuffer]\"===ct.call(t)?r.input=new Uint8Array(t):r.input=t,r.next_in=0,r.avail_in=r.input.length;;)if(0===r.avail_out&&(r.output=new Uint8Array(i),r.next_out=0,r.avail_out=i),(2===n||3===n)&&r.avail_out<=6)this.onData(r.output.subarray(0,r.next_out)),r.avail_out=0;else{if(1===(a=_t(r,n)))return r.next_out>0&&this.onData(r.output.subarray(0,r.next_out)),a=ot(this.strm),this.onEnd(a),this.ended=!0,0===a;if(0!==r.avail_out){if(n>0&&r.next_out>0)this.onData(r.output.subarray(0,r.next_out)),r.avail_out=0;else if(0===r.avail_in)break}else this.onData(r.output)}return!0},pt.prototype.onData=function(t){this.chunks.push(t)},pt.prototype.onEnd=function(t){0===t&&(this.result=function(t){for(var e=0,a=0,n=t.length;a<n;a++)e+=t[a].length;for(var r=new Uint8Array(e),i=0,s=0,h=t.length;i<h;i++){var l=t[i];r.set(l,s),s+=l.length}return r}(this.chunks)),this.chunks=[],this.err=t,this.msg=this.strm.msg},function(e=self){try{const a=new Map;e.addEventListener(\"message\",n=>{try{const r=function(e,a){switch(a.action){case\"init\":return{type:\"initialized\",version:\"6.25.0\"};case\"write\":{let n=e.get(a.streamId);n||(n=new pt,e.set(a.streamId,n));const r=n.chunks.length,i=function(t){if(\"function\"==typeof TextEncoder&&TextEncoder.prototype.encode)return(new TextEncoder).encode(t);let e,a,n,r,i,s=t.length,h=0;for(r=0;r<s;r++)a=t.charCodeAt(r),55296==(64512&a)&&r+1<s&&(n=t.charCodeAt(r+1),56320==(64512&n)&&(a=65536+(a-55296<<10)+(n-56320),r++)),h+=a<128?1:a<2048?2:a<65536?3:4;for(e=new Uint8Array(h),i=0,r=0;i<h;r++)a=t.charCodeAt(r),55296==(64512&a)&&r+1<s&&(n=t.charCodeAt(r+1),56320==(64512&n)&&(a=65536+(a-55296<<10)+(n-56320),r++)),a<128?e[i++]=a:a<2048?(e[i++]=192|a>>>6,e[i++]=128|63&a):a<65536?(e[i++]=224|a>>>12,e[i++]=128|a>>>6&63,e[i++]=128|63&a):(e[i++]=240|a>>>18,e[i++]=128|a>>>12&63,e[i++]=128|a>>>6&63,e[i++]=128|63&a);return e}(a.data);return n.push(i,2),{type:\"wrote\",id:a.id,streamId:a.streamId,result:t(n.chunks.slice(r)),trailer:vt(n),additionalBytesCount:i.length}}case\"reset\":e.delete(a.streamId)}}(a,n.data);r&&e.postMessage(r)}catch(t){gt(e,t,n.data&&\"streamId\"in n.data?n.data.streamId:void 0)}})}catch(t){gt(e,t)}}()})();"])));
}
let state = { status: 0 /* DeflateWorkerStatus.Nil */ };
function startDeflateWorker(configuration, source, onInitializationFailure, createDeflateWorkerImpl = createDeflateWorker) {
    if (state.status === 0 /* DeflateWorkerStatus.Nil */) {
        // doStartDeflateWorker updates the state to "loading" or "error"
        doStartDeflateWorker(configuration, source, createDeflateWorkerImpl);
    }
    switch (state.status) {
        case 1 /* DeflateWorkerStatus.Loading */:
            state.initializationFailureCallbacks.push(onInitializationFailure);
            return state.worker;
        case 3 /* DeflateWorkerStatus.Initialized */:
            return state.worker;
    }
}
function resetDeflateWorkerState() {
    if (state.status === 3 /* DeflateWorkerStatus.Initialized */ || state.status === 1 /* DeflateWorkerStatus.Loading */) {
        state.stop();
    }
    state = { status: 0 /* DeflateWorkerStatus.Nil */ };
}
function getDeflateWorkerStatus() {
    return state.status;
}
/**
 * Starts the deflate worker and handle messages and errors
 *
 * The spec allow browsers to handle worker errors differently:
 * - Chromium throws an exception
 * - Firefox fires an error event
 *
 * more details: https://bugzilla.mozilla.org/show_bug.cgi?id=1736865#c2
 */
function doStartDeflateWorker(configuration, source, createDeflateWorkerImpl = createDeflateWorker) {
    try {
        const worker = createDeflateWorkerImpl(configuration);
        const { stop: removeErrorListener } = (0,addEventListener/* addEventListener */.O)(configuration, worker, 'error', (error) => {
            onError(configuration, source, error);
        });
        const { stop: removeMessageListener } = (0,addEventListener/* addEventListener */.O)(configuration, worker, 'message', ({ data }) => {
            if (data.type === 'errored') {
                onError(configuration, source, data.error, data.streamId);
            }
            else if (data.type === 'initialized') {
                onInitialized(data.version);
            }
        });
        worker.postMessage({ action: 'init' });
        (0,timer/* setTimeout */.iK)(() => onTimeout(source), INITIALIZATION_TIME_OUT_DELAY);
        const stop = () => {
            removeErrorListener();
            removeMessageListener();
        };
        state = { status: 1 /* DeflateWorkerStatus.Loading */, worker, stop, initializationFailureCallbacks: [] };
    }
    catch (error) {
        onError(configuration, source, error);
    }
}
function onTimeout(source) {
    if (state.status === 1 /* DeflateWorkerStatus.Loading */) {
        display/* display.error */.jf.error(`${source} failed to start: a timeout occurred while initializing the Worker`);
        state.initializationFailureCallbacks.forEach((callback) => callback());
        state = { status: 2 /* DeflateWorkerStatus.Error */ };
    }
}
function onInitialized(version) {
    if (state.status === 1 /* DeflateWorkerStatus.Loading */) {
        state = { status: 3 /* DeflateWorkerStatus.Initialized */, worker: state.worker, stop: state.stop, version };
    }
}
function onError(configuration, source, error, streamId) {
    if (state.status === 1 /* DeflateWorkerStatus.Loading */ || state.status === 0 /* DeflateWorkerStatus.Nil */) {
        reportScriptLoadingError({
            configuredUrl: configuration.workerUrl,
            error,
            source,
            scriptType: 'worker',
        });
        if (state.status === 1 /* DeflateWorkerStatus.Loading */) {
            state.initializationFailureCallbacks.forEach((callback) => callback());
        }
        state = { status: 2 /* DeflateWorkerStatus.Error */ };
    }
    else {
        (0,telemetry_telemetry/* addTelemetryError */.Sz)(error, {
            worker_version: state.status === 3 /* DeflateWorkerStatus.Initialized */ && state.version,
            stream_id: streamId,
        });
    }
}
//# sourceMappingURL=deflateWorker.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/deflate/index.js


//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/boot/isBrowserSupported.js
/**
 * Test for Browser features used while recording
 */
function isBrowserSupported() {
    return (
    // Array.from is a bit less supported by browsers than CSSSupportsRule, but has higher chances
    // to be polyfilled. Test for both to be more confident. We could add more things if we find out
    // this test is not sufficient.
    typeof Array.from === 'function' &&
        typeof CSSSupportsRule === 'function' &&
        typeof URL.createObjectURL === 'function' &&
        'forEach' in NodeList.prototype);
}
//# sourceMappingURL=isBrowserSupported.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/observable.js + 1 modules
var tools_observable = __webpack_require__(75721);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/browser/runOnReadyState.js
var runOnReadyState = __webpack_require__(10193);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/monitor.js
var monitor = __webpack_require__(64933);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/getSessionReplayLink.js


function getSessionReplayLink(configuration, sessionManager, viewHistory, isRecordingStarted) {
    const session = sessionManager.findTrackedSession();
    const errorType = getErrorType(session, isRecordingStarted);
    const viewContext = viewHistory.findView();
    return (0,esm/* getSessionReplayUrl */.Gm)(configuration, {
        viewContext,
        errorType,
        session,
    });
}
function getErrorType(session, isRecordingStarted) {
    if (!isBrowserSupported()) {
        return 'browser-not-supported';
    }
    if (!session) {
        // possibilities:
        // - rum sampled out
        // - session expired (edge case)
        return 'rum-not-tracked';
    }
    if (session.sessionReplay === 0 /* SessionReplayState.OFF */) {
        // possibilities
        // - replay sampled out
        return 'incorrect-session-plan';
    }
    if (!isRecordingStarted) {
        return 'replay-not-started';
    }
}
//# sourceMappingURL=getSessionReplayLink.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/startRecorderInitTelemetry.js

function startRecorderInitTelemetry(telemetry, observable) {
    if (!telemetry.metricsEnabled) {
        return { stop: functionUtils/* noop */.Z };
    }
    let startContext;
    let documentReadyDuration;
    let recorderSettledDuration;
    const { unsubscribe } = observable.subscribe((event) => {
        switch (event.type) {
            case 'start':
                startContext = { forced: event.forced, timestamp: (0,timeUtils/* timeStampNow */.n$)() };
                documentReadyDuration = undefined;
                recorderSettledDuration = undefined;
                break;
            case 'document-ready':
                if (startContext) {
                    documentReadyDuration = (0,timeUtils/* elapsed */._J)(startContext.timestamp, (0,timeUtils/* timeStampNow */.n$)());
                }
                break;
            case 'recorder-settled':
                if (startContext) {
                    recorderSettledDuration = (0,timeUtils/* elapsed */._J)(startContext.timestamp, (0,timeUtils/* timeStampNow */.n$)());
                }
                break;
            case 'aborted':
            case 'deflate-encoder-load-failed':
            case 'recorder-load-failed':
            case 'succeeded':
                // Only send metrics for the first attempt at starting the recorder.
                unsubscribe();
                if (startContext) {
                    // monitor-until: 2026-07-01
                    (0,telemetry_telemetry/* addTelemetryMetrics */.qZ)("Recorder init metrics" /* TelemetryMetrics.RECORDER_INIT_METRICS_TELEMETRY_NAME */, {
                        metrics: createRecorderInitMetrics(startContext.forced, recorderSettledDuration, (0,timeUtils/* elapsed */._J)(startContext.timestamp, (0,timeUtils/* timeStampNow */.n$)()), event.type, documentReadyDuration),
                    });
                }
                break;
        }
    });
    return { stop: unsubscribe };
}
function createRecorderInitMetrics(forced, loadRecorderModuleDuration, recorderInitDuration, result, waitForDocReadyDuration) {
    return {
        forced,
        loadRecorderModuleDuration,
        recorderInitDuration,
        result,
        waitForDocReadyDuration,
    };
}
//# sourceMappingURL=startRecorderInitTelemetry.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/boot/postStartStrategy.js



function createPostStartStrategy(configuration, lifeCycle, sessionManager, viewHistory, loadRecorder, getOrCreateDeflateEncoder, telemetry) {
    let status = 0 /* RecorderStatus.Stopped */;
    let stopRecording;
    lifeCycle.subscribe(9 /* LifeCycleEventType.SESSION_EXPIRED */, () => {
        if (status === 2 /* RecorderStatus.Starting */ || status === 3 /* RecorderStatus.Started */) {
            stop();
            status = 1 /* RecorderStatus.IntentToStart */;
        }
    });
    lifeCycle.subscribe(10 /* LifeCycleEventType.SESSION_RENEWED */, () => {
        if (status === 1 /* RecorderStatus.IntentToStart */) {
            start();
        }
    });
    const observable = new tools_observable/* Observable */.y$();
    startRecorderInitTelemetry(telemetry, observable);
    const doStart = async (forced) => {
        observable.notify({ type: 'start', forced });
        const [startRecordingImpl] = await Promise.all([
            notifyWhenSettled(observable, { type: 'recorder-settled' }, loadRecorder()),
            notifyWhenSettled(observable, { type: 'document-ready' }, (0,runOnReadyState/* asyncRunOnReadyState */._)(configuration, 'interactive')),
        ]);
        if (status !== 2 /* RecorderStatus.Starting */) {
            observable.notify({ type: 'aborted' });
            return;
        }
        if (!startRecordingImpl) {
            status = 0 /* RecorderStatus.Stopped */;
            observable.notify({ type: 'recorder-load-failed' });
            return;
        }
        const deflateEncoder = getOrCreateDeflateEncoder();
        if (!deflateEncoder) {
            status = 0 /* RecorderStatus.Stopped */;
            observable.notify({ type: 'deflate-encoder-load-failed' });
            return;
        }
        ;
        ({ stop: stopRecording } = startRecordingImpl(lifeCycle, configuration, sessionManager, viewHistory, deflateEncoder, telemetry));
        status = 3 /* RecorderStatus.Started */;
        observable.notify({ type: 'succeeded' });
    };
    function start(options) {
        const session = sessionManager.findTrackedSession();
        if (canStartRecording(session, options)) {
            status = 1 /* RecorderStatus.IntentToStart */;
            return;
        }
        if (isRecordingInProgress(status)) {
            return;
        }
        status = 2 /* RecorderStatus.Starting */;
        const forced = shouldForceReplay(session, options) || false;
        // Intentionally not awaiting doStart() to keep it asynchronous
        doStart(forced).catch(monitor/* monitorError */.$y);
        if (forced) {
            sessionManager.setForcedReplay();
        }
    }
    function stop() {
        if (status === 3 /* RecorderStatus.Started */) {
            stopRecording === null || stopRecording === void 0 ? void 0 : stopRecording();
        }
        status = 0 /* RecorderStatus.Stopped */;
    }
    return {
        start,
        stop,
        getSessionReplayLink() {
            return getSessionReplayLink(configuration, sessionManager, viewHistory, status !== 0 /* RecorderStatus.Stopped */);
        },
        isRecording: () => status === 3 /* RecorderStatus.Started */,
    };
}
function canStartRecording(session, options) {
    return !session || (session.sessionReplay === 0 /* SessionReplayState.OFF */ && (!options || !options.force));
}
function isRecordingInProgress(status) {
    return status === 2 /* RecorderStatus.Starting */ || status === 3 /* RecorderStatus.Started */;
}
function shouldForceReplay(session, options) {
    return options && options.force && session.sessionReplay === 0 /* SessionReplayState.OFF */;
}
async function notifyWhenSettled(observable, event, promise) {
    try {
        return await promise;
    }
    finally {
        observable.notify(event);
    }
}
//# sourceMappingURL=postStartStrategy.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/boot/preStartStrategy.js

function createPreStartStrategy() {
    let status = 0 /* PreStartRecorderStatus.None */;
    return {
        strategy: {
            start() {
                status = 1 /* PreStartRecorderStatus.HadManualStart */;
            },
            stop() {
                status = 2 /* PreStartRecorderStatus.HadManualStop */;
            },
            isRecording: () => false,
            getSessionReplayLink: functionUtils/* noop */.Z,
        },
        shouldStartImmediately(configuration) {
            return (status === 1 /* PreStartRecorderStatus.HadManualStart */ ||
                (status === 0 /* PreStartRecorderStatus.None */ && !configuration.startSessionReplayRecordingManually));
        },
    };
}
//# sourceMappingURL=preStartStrategy.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/boot/recorderApi.js






function makeRecorderApi(loadRecorder, createDeflateWorkerImpl) {
    if (((0,eventBridge/* canUseEventBridge */.xT)() && !(0,eventBridge/* bridgeSupports */.ke)("records" /* BridgeCapability.RECORDS */)) || !isBrowserSupported()) {
        return {
            start: functionUtils/* noop */.Z,
            stop: functionUtils/* noop */.Z,
            getReplayStats: () => undefined,
            onRumStart: functionUtils/* noop */.Z,
            isRecording: () => false,
            getSessionReplayLink: () => undefined,
        };
    }
    // eslint-disable-next-line prefer-const
    let { strategy, shouldStartImmediately } = createPreStartStrategy();
    return {
        start: (options) => strategy.start(options),
        stop: () => strategy.stop(),
        getSessionReplayLink: () => strategy.getSessionReplayLink(),
        onRumStart,
        isRecording: () => 
        // The worker is started optimistically, meaning we could have started to record but its
        // initialization fails a bit later. This could happen when:
        // * the worker URL (blob or plain URL) is blocked by CSP in Firefox only (Chromium and Safari
        // throw an exception when instantiating the worker, and IE doesn't care about CSP)
        // * the browser fails to load the worker in case the workerUrl is used
        // * an unexpected error occurs in the Worker before initialization, ex:
        //   * a runtime exception collected by monitor()
        //   * a syntax error notified by the browser via an error event
        // * the worker is unresponsive for some reason and timeouts
        //
        // It is not expected to happen often. Nonetheless, the "replayable" status on RUM events is
        // an important part of the Datadog App:
        // * If we have a false positive (we set has_replay: true even if no replay data is present),
        // we might display broken links to the Session Replay player.
        // * If we have a false negative (we don't set has_replay: true even if replay data is
        // available), it is less noticeable because no link will be displayed.
        //
        // Thus, it is better to have false negative, so let's make sure the worker is correctly
        // initialized before advertizing that we are recording.
        //
        // In the future, when the compression worker will also be used for RUM data, this will be
        // less important since no RUM event will be sent when the worker fails to initialize.
        getDeflateWorkerStatus() === 3 /* DeflateWorkerStatus.Initialized */ && strategy.isRecording(),
        getReplayStats: (viewId) => getDeflateWorkerStatus() === 3 /* DeflateWorkerStatus.Initialized */ ? (0,replayStats/* getReplayStats */.MA)(viewId) : undefined,
    };
    function onRumStart(lifeCycle, configuration, sessionManager, viewHistory, worker, telemetry) {
        let cachedDeflateEncoder;
        function getOrCreateDeflateEncoder() {
            if (!cachedDeflateEncoder) {
                worker !== null && worker !== void 0 ? worker : (worker = startDeflateWorker(configuration, 'Datadog Session Replay', () => {
                    strategy.stop();
                }, createDeflateWorkerImpl));
                if (worker) {
                    cachedDeflateEncoder = createDeflateEncoder(configuration, worker, 1 /* DeflateEncoderStreamId.REPLAY */);
                }
            }
            return cachedDeflateEncoder;
        }
        strategy = createPostStartStrategy(configuration, lifeCycle, sessionManager, viewHistory, loadRecorder, getOrCreateDeflateEncoder, telemetry);
        if (shouldStartImmediately(configuration)) {
            strategy.start();
        }
    }
}
//# sourceMappingURL=recorderApi.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/boot/lazyLoadRecorder.js

async function lazyLoadRecorder(importRecorderImpl = importRecorder) {
    try {
        return await importRecorderImpl();
    }
    catch (error) {
        reportScriptLoadingError({
            error,
            source: 'Recorder',
            scriptType: 'module',
        });
    }
}
async function importRecorder() {
    const module = await __webpack_require__.e(/* import() | recorder */ 7538).then(__webpack_require__.bind(__webpack_require__, 16564));
    return module.startRecording;
}
//# sourceMappingURL=lazyLoadRecorder.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/profiling/profilingSupported.js

function isProfilingSupported() {
    const globalThis = (0,globalObject/* getGlobalObject */.Rf)();
    // This API might be unavailable in some browsers
    const globalThisProfiler = globalThis.Profiler;
    return globalThisProfiler !== undefined;
}
//# sourceMappingURL=profilingSupported.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/abstractHooks.js
var abstractHooks = __webpack_require__(89643);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/profiling/profilingContext.js


const startProfilingContext = (hooks) => {
    // Default status is `starting`.
    let currentContext = {
        status: 'starting',
    };
    // Register the assemble hook to add the profiling context to the event attributes.
    hooks.register(0 /* HookNames.Assemble */, ({ eventType }) => {
        if (eventType !== esm/* RumEventType.VIEW */.D$.VIEW && eventType !== esm/* RumEventType.LONG_TASK */.D$.LONG_TASK) {
            return abstractHooks/* SKIPPED */.kb;
        }
        return {
            type: eventType,
            _dd: {
                profiling: currentContext,
            },
        };
    });
    return {
        get: () => currentContext,
        set: (newContext) => {
            currentContext = newContext;
        },
    };
};
//# sourceMappingURL=profilingContext.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/boot/lazyLoadProfiler.js

async function lazyLoadProfiler(importProfilerImpl = importProfiler) {
    try {
        return await importProfilerImpl();
    }
    catch (error) {
        reportScriptLoadingError({
            error,
            source: 'Profiler',
            scriptType: 'module',
        });
    }
}
async function importProfiler() {
    const module = await __webpack_require__.e(/* import() | profiler */ 9983).then(__webpack_require__.bind(__webpack_require__, 68574));
    return module.createRumProfiler;
}
//# sourceMappingURL=lazyLoadProfiler.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/boot/profilerApi.js





function makeProfilerApi() {
    let profiler;
    function onRumStart(lifeCycle, hooks, configuration, sessionManager, viewHistory, createEncoder) {
        const session = sessionManager.findTrackedSession(); // Check if the session is tracked.
        if (!session) {
            // No session tracked, no profiling.
            // Note: No Profiling context is set at this stage.
            return;
        }
        // Sampling (sticky sampling based on session id)
        if (!(0,esm/* isSampled */.HR)(session.id, configuration.profilingSampleRate)) {
            // No sampling, no profiling.
            // Note: No Profiling context is set at this stage.
            return;
        }
        // Listen to events and add the profiling context to them.
        const profilingContextManager = startProfilingContext(hooks);
        // Browser support check
        if (!isProfilingSupported()) {
            profilingContextManager.set({
                status: 'error',
                error_reason: 'not-supported-by-browser',
            });
            return;
        }
        lazyLoadProfiler()
            .then((createRumProfiler) => {
            if (!createRumProfiler) {
                // monitor-until: 2026-01-01, reconsider after profiling GA
                (0,telemetry_telemetry/* addTelemetryDebug */.eJ)('[DD_RUM] Failed to lazy load the RUM Profiler');
                profilingContextManager.set({ status: 'error', error_reason: 'failed-to-lazy-load' });
                return;
            }
            profiler = createRumProfiler(configuration, lifeCycle, sessionManager, profilingContextManager, createEncoder);
            profiler.start(viewHistory.findView());
        })
            .catch(monitor/* monitorError */.$y);
    }
    return {
        onRumStart,
        stop: () => {
            profiler === null || profiler === void 0 ? void 0 : profiler.stop().catch(monitor/* monitorError */.$y);
        },
    };
}
//# sourceMappingURL=profilerApi.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/configuration/configuration.js + 2 modules
var configuration = __webpack_require__(18769);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/entries/main.js
/**
 * Datadog Browser RUM SDK - Full version with Session Replay and Real User Profiling capabilities.
 * Use this package to monitor your web application's performance and user experience.
 *
 * @packageDocumentation
 * @see [RUM Browser Monitoring Setup](https://docs.datadoghq.com/real_user_monitoring/browser/)
 */
// Keep the following in sync with packages/rum-slim/src/entries/main.ts







const recorderApi = makeRecorderApi(lazyLoadRecorder);
const profilerApi = makeProfilerApi();
/**
 * The global RUM instance. Use this to call RUM methods.
 *
 * @category Main
 * @see {@link DatadogRum}
 * @see [RUM Browser Monitoring Setup](https://docs.datadoghq.com/real_user_monitoring/browser/)
 */
const datadogRum = (0,esm/* makeRumPublicApi */._r)(esm/* startRum */.iB, recorderApi, profilerApi, {
    startDeflateWorker: startDeflateWorker,
    createDeflateEncoder: createDeflateEncoder,
    sdkName: 'rum',
});
(0,init/* defineGlobal */.y)((0,globalObject/* getGlobalObject */.Rf)(), 'DD_RUM', datadogRum);
//# sourceMappingURL=main.js.map

/***/ }),

/***/ 48711:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ createCache; }
});

;// CONCATENATED MODULE: ./node_modules/@emotion/sheet/dist/emotion-sheet.esm.js
var isDevelopment = false;

/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/

function sheetForTag(tag) {
  if (tag.sheet) {
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      return document.styleSheets[i];
    }
  } // this function should always return with a value
  // TS can't understand it though so we make it stop complaining here


  return undefined;
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var StyleSheet = /*#__PURE__*/function () {
  // Using Node instead of HTMLElement since container may be a ShadowRoot
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ? !isDevelopment : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    this.tags.forEach(function (tag) {
      var _tag$parentNode;

      return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };

  return StyleSheet;
}();



;// CONCATENATED MODULE: ./node_modules/stylis/src/Utility.js
/**
 * @param {number}
 * @return {number}
 */
var abs = Math.abs

/**
 * @param {number}
 * @return {string}
 */
var Utility_from = String.fromCharCode

/**
 * @param {object}
 * @return {object}
 */
var Utility_assign = Object.assign

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash (value, length) {
	return Utility_charat(value, 0) ^ 45 ? (((((((length << 2) ^ Utility_charat(value, 0)) << 2) ^ Utility_charat(value, 1)) << 2) ^ Utility_charat(value, 2)) << 2) ^ Utility_charat(value, 3) : 0
}

/**
 * @param {string} value
 * @return {string}
 */
function trim (value) {
	return value.trim()
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function Utility_match (value, pattern) {
	return (value = pattern.exec(value)) ? value[0] : value
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function Utility_replace (value, pattern, replacement) {
	return value.replace(pattern, replacement)
}

/**
 * @param {string} value
 * @param {string} search
 * @return {number}
 */
function indexof (value, search) {
	return value.indexOf(search)
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function Utility_charat (value, index) {
	return value.charCodeAt(index) | 0
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function Utility_substr (value, begin, end) {
	return value.slice(begin, end)
}

/**
 * @param {string} value
 * @return {number}
 */
function Utility_strlen (value) {
	return value.length
}

/**
 * @param {any[]} value
 * @return {number}
 */
function Utility_sizeof (value) {
	return value.length
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function Utility_append (value, array) {
	return array.push(value), value
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function Utility_combine (array, callback) {
	return array.map(callback).join('')
}

;// CONCATENATED MODULE: ./node_modules/stylis/src/Tokenizer.js


var line = 1
var column = 1
var Tokenizer_length = 0
var position = 0
var character = 0
var characters = ''

/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {number} length
 */
function node (value, root, parent, type, props, children, length) {
	return {value: value, root: root, parent: parent, type: type, props: props, children: children, line: line, column: column, length: length, return: ''}
}

/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */
function Tokenizer_copy (root, props) {
	return Utility_assign(node('', null, null, '', null, null, 0), root, {length: -root.length}, props)
}

/**
 * @return {number}
 */
function Tokenizer_char () {
	return character
}

/**
 * @return {number}
 */
function prev () {
	character = position > 0 ? Utility_charat(characters, --position) : 0

	if (column--, character === 10)
		column = 1, line--

	return character
}

/**
 * @return {number}
 */
function next () {
	character = position < Tokenizer_length ? Utility_charat(characters, position++) : 0

	if (column++, character === 10)
		column = 1, line++

	return character
}

/**
 * @return {number}
 */
function peek () {
	return Utility_charat(characters, position)
}

/**
 * @return {number}
 */
function caret () {
	return position
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function slice (begin, end) {
	return Utility_substr(characters, begin, end)
}

/**
 * @param {number} type
 * @return {number}
 */
function token (type) {
	switch (type) {
		// \0 \t \n \r \s whitespace token
		case 0: case 9: case 10: case 13: case 32:
			return 5
		// ! + , / > @ ~ isolate token
		case 33: case 43: case 44: case 47: case 62: case 64: case 126:
		// ; { } breakpoint token
		case 59: case 123: case 125:
			return 4
		// : accompanied token
		case 58:
			return 3
		// " ' ( [ opening delimit token
		case 34: case 39: case 40: case 91:
			return 2
		// ) ] closing delimit token
		case 41: case 93:
			return 1
	}

	return 0
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc (value) {
	return line = column = 1, Tokenizer_length = Utility_strlen(characters = value), position = 0, []
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc (value) {
	return characters = '', value
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit (type) {
	return trim(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)))
}

/**
 * @param {string} value
 * @return {string[]}
 */
function Tokenizer_tokenize (value) {
	return dealloc(tokenizer(alloc(value)))
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace (type) {
	while (character = peek())
		if (character < 33)
			next()
		else
			break

	return token(type) > 2 || token(character) > 3 ? '' : ' '
}

/**
 * @param {string[]} children
 * @return {string[]}
 */
function tokenizer (children) {
	while (next())
		switch (token(character)) {
			case 0: append(identifier(position - 1), children)
				break
			case 2: append(delimit(character), children)
				break
			default: append(from(character), children)
		}

	return children
}

/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */
function escaping (index, count) {
	while (--count && next())
		// not 0-9 A-F a-f
		if (character < 48 || character > 102 || (character > 57 && character < 65) || (character > 70 && character < 97))
			break

	return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32))
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter (type) {
	while (next())
		switch (character) {
			// ] ) " '
			case type:
				return position
			// " '
			case 34: case 39:
				if (type !== 34 && type !== 39)
					delimiter(character)
				break
			// (
			case 40:
				if (type === 41)
					delimiter(type)
				break
			// \
			case 92:
				next()
				break
		}

	return position
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter (type, index) {
	while (next())
		// //
		if (type + character === 47 + 10)
			break
		// /*
		else if (type + character === 42 + 42 && peek() === 47)
			break

	return '/*' + slice(index, position - 1) + '*' + Utility_from(type === 47 ? type : next())
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier (index) {
	while (!token(peek()))
		next()

	return slice(index, position)
}

;// CONCATENATED MODULE: ./node_modules/stylis/src/Enum.js
var Enum_MS = '-ms-'
var Enum_MOZ = '-moz-'
var Enum_WEBKIT = '-webkit-'

var COMMENT = 'comm'
var Enum_RULESET = 'rule'
var Enum_DECLARATION = 'decl'

var PAGE = '@page'
var MEDIA = '@media'
var IMPORT = '@import'
var CHARSET = '@charset'
var VIEWPORT = '@viewport'
var SUPPORTS = '@supports'
var DOCUMENT = '@document'
var NAMESPACE = '@namespace'
var Enum_KEYFRAMES = '@keyframes'
var FONT_FACE = '@font-face'
var COUNTER_STYLE = '@counter-style'
var FONT_FEATURE_VALUES = '@font-feature-values'
var LAYER = '@layer'

;// CONCATENATED MODULE: ./node_modules/stylis/src/Serializer.js



/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function Serializer_serialize (children, callback) {
	var output = ''
	var length = Utility_sizeof(children)

	for (var i = 0; i < length; i++)
		output += callback(children[i], i, children, callback) || ''

	return output
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify (element, index, children, callback) {
	switch (element.type) {
		case LAYER: if (element.children.length) break
		case IMPORT: case Enum_DECLARATION: return element.return = element.return || element.value
		case COMMENT: return ''
		case Enum_KEYFRAMES: return element.return = element.value + '{' + Serializer_serialize(element.children, callback) + '}'
		case Enum_RULESET: element.value = element.props.join(',')
	}

	return Utility_strlen(children = Serializer_serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : ''
}

;// CONCATENATED MODULE: ./node_modules/stylis/src/Middleware.js






/**
 * @param {function[]} collection
 * @return {function}
 */
function middleware (collection) {
	var length = Utility_sizeof(collection)

	return function (element, index, children, callback) {
		var output = ''

		for (var i = 0; i < length; i++)
			output += collection[i](element, index, children, callback) || ''

		return output
	}
}

/**
 * @param {function} callback
 * @return {function}
 */
function rulesheet (callback) {
	return function (element) {
		if (!element.root)
			if (element = element.return)
				callback(element)
	}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 */
function prefixer (element, index, children, callback) {
	if (element.length > -1)
		if (!element.return)
			switch (element.type) {
				case DECLARATION: element.return = prefix(element.value, element.length, children)
					return
				case KEYFRAMES:
					return serialize([copy(element, {value: replace(element.value, '@', '@' + WEBKIT)})], callback)
				case RULESET:
					if (element.length)
						return combine(element.props, function (value) {
							switch (match(value, /(::plac\w+|:read-\w+)/)) {
								// :read-(only|write)
								case ':read-only': case ':read-write':
									return serialize([copy(element, {props: [replace(value, /:(read-\w+)/, ':' + MOZ + '$1')]})], callback)
								// :placeholder
								case '::placeholder':
									return serialize([
										copy(element, {props: [replace(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1')]}),
										copy(element, {props: [replace(value, /:(plac\w+)/, ':' + MOZ + '$1')]}),
										copy(element, {props: [replace(value, /:(plac\w+)/, MS + 'input-$1')]})
									], callback)
							}

							return ''
						})
			}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 */
function namespace (element) {
	switch (element.type) {
		case RULESET:
			element.props = element.props.map(function (value) {
				return combine(tokenize(value), function (value, index, children) {
					switch (charat(value, 0)) {
						// \f
						case 12:
							return substr(value, 1, strlen(value))
						// \0 ( + > ~
						case 0: case 40: case 43: case 62: case 126:
							return value
						// :
						case 58:
							if (children[++index] === 'global')
								children[index] = '', children[++index] = '\f' + substr(children[index], index = 1, -1)
						// \s
						case 32:
							return index === 1 ? '' : value
						default:
							switch (index) {
								case 0: element = value
									return sizeof(children) > 1 ? '' : value
								case index = sizeof(children) - 1: case 2:
									return index === 2 ? value + element + element : value + element
								default:
									return value
							}
					}
				})
			})
	}
}

;// CONCATENATED MODULE: ./node_modules/stylis/src/Parser.js




/**
 * @param {string} value
 * @return {object[]}
 */
function compile (value) {
	return dealloc(parse('', null, null, null, [''], value = alloc(value), 0, [0], value))
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse (value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
	var index = 0
	var offset = 0
	var length = pseudo
	var atrule = 0
	var property = 0
	var previous = 0
	var variable = 1
	var scanning = 1
	var ampersand = 1
	var character = 0
	var type = ''
	var props = rules
	var children = rulesets
	var reference = rule
	var characters = type

	while (scanning)
		switch (previous = character, character = next()) {
			// (
			case 40:
				if (previous != 108 && Utility_charat(characters, length - 1) == 58) {
					if (indexof(characters += Utility_replace(delimit(character), '&', '&\f'), '&\f') != -1)
						ampersand = -1
					break
				}
			// " ' [
			case 34: case 39: case 91:
				characters += delimit(character)
				break
			// \t \n \r \s
			case 9: case 10: case 13: case 32:
				characters += whitespace(previous)
				break
			// \
			case 92:
				characters += escaping(caret() - 1, 7)
				continue
			// /
			case 47:
				switch (peek()) {
					case 42: case 47:
						Utility_append(comment(commenter(next(), caret()), root, parent), declarations)
						break
					default:
						characters += '/'
				}
				break
			// {
			case 123 * variable:
				points[index++] = Utility_strlen(characters) * ampersand
			// } ; \0
			case 125 * variable: case 59: case 0:
				switch (character) {
					// \0 }
					case 0: case 125: scanning = 0
					// ;
					case 59 + offset: if (ampersand == -1) characters = Utility_replace(characters, /\f/g, '')
						if (property > 0 && (Utility_strlen(characters) - length))
							Utility_append(property > 32 ? declaration(characters + ';', rule, parent, length - 1) : declaration(Utility_replace(characters, ' ', '') + ';', rule, parent, length - 2), declarations)
						break
					// @ ;
					case 59: characters += ';'
					// { rule/at-rule
					default:
						Utility_append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets)

						if (character === 123)
							if (offset === 0)
								parse(characters, root, reference, reference, props, rulesets, length, points, children)
							else
								switch (atrule === 99 && Utility_charat(characters, 3) === 110 ? 100 : atrule) {
									// d l m s
									case 100: case 108: case 109: case 115:
										parse(value, reference, reference, rule && Utility_append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children)
										break
									default:
										parse(characters, reference, reference, reference, [''], children, 0, points, children)
								}
				}

				index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo
				break
			// :
			case 58:
				length = 1 + Utility_strlen(characters), property = previous
			default:
				if (variable < 1)
					if (character == 123)
						--variable
					else if (character == 125 && variable++ == 0 && prev() == 125)
						continue

				switch (characters += Utility_from(character), character * variable) {
					// &
					case 38:
						ampersand = offset > 0 ? 1 : (characters += '\f', -1)
						break
					// ,
					case 44:
						points[index++] = (Utility_strlen(characters) - 1) * ampersand, ampersand = 1
						break
					// @
					case 64:
						// -
						if (peek() === 45)
							characters += delimit(next())

						atrule = peek(), offset = length = Utility_strlen(type = characters += identifier(caret())), character++
						break
					// -
					case 45:
						if (previous === 45 && Utility_strlen(characters) == 2)
							variable = 0
				}
		}

	return rulesets
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @return {object}
 */
function ruleset (value, root, parent, index, offset, rules, points, type, props, children, length) {
	var post = offset - 1
	var rule = offset === 0 ? rules : ['']
	var size = Utility_sizeof(rule)

	for (var i = 0, j = 0, k = 0; i < index; ++i)
		for (var x = 0, y = Utility_substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x)
			if (z = trim(j > 0 ? rule[x] + ' ' + y : Utility_replace(y, /&\f/g, rule[x])))
				props[k++] = z

	return node(value, root, parent, offset === 0 ? Enum_RULESET : type, props, children, length)
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @return {object}
 */
function comment (value, root, parent) {
	return node(value, root, parent, COMMENT, Utility_from(Tokenizer_char()), Utility_substr(value, 2, -2), 0)
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @return {object}
 */
function declaration (value, root, parent, length) {
	return node(value, root, parent, Enum_DECLARATION, Utility_substr(value, 0, length), Utility_substr(value, length + 1, -1), length)
}

;// CONCATENATED MODULE: ./node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js





var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;

  while (true) {
    previous = character;
    character = peek(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }

    if (token(character)) {
      break;
    }

    next();
  }

  return slice(begin, position);
};

var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;

  do {
    switch (token(character)) {
      case 0:
        // &\f
        if (character === 38 && peek() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }

        parsed[index] += identifierWithPointTracking(position - 1, points, index);
        break;

      case 2:
        parsed[index] += delimit(character);
        break;

      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = peek() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += Utility_from(character);
    }
  } while (character = next());

  return parsed;
};

var getRules = function getRules(value, points) {
  return dealloc(toRules(alloc(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }

  var value = element.value;
  var parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;

  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case


  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */
  && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


  if (isImplicitRule) {
    return;
  }

  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;

  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;

    if ( // charcode for l
    value.charCodeAt(0) === 108 && // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};

/* eslint-disable no-fallthrough */

function emotion_cache_browser_esm_prefix(value, length) {
  switch (hash(value, length)) {
    // color-adjust
    case 5103:
      return Enum_WEBKIT + 'print-' + value + value;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)

    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921: // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break

    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005: // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,

    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855: // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)

    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Enum_WEBKIT + value + value;
    // appearance, user-select, transform, hyphens, text-size-adjust

    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Enum_WEBKIT + value + Enum_MOZ + value + Enum_MS + value + value;
    // flex, flex-direction

    case 6828:
    case 4268:
      return Enum_WEBKIT + value + Enum_MS + value + value;
    // order

    case 6165:
      return Enum_WEBKIT + value + Enum_MS + 'flex-' + value + value;
    // align-items

    case 5187:
      return Enum_WEBKIT + value + Utility_replace(value, /(\w+).+(:[^]+)/, Enum_WEBKIT + 'box-$1$2' + Enum_MS + 'flex-$1$2') + value;
    // align-self

    case 5443:
      return Enum_WEBKIT + value + Enum_MS + 'flex-item-' + Utility_replace(value, /flex-|-self/, '') + value;
    // align-content

    case 4675:
      return Enum_WEBKIT + value + Enum_MS + 'flex-line-pack' + Utility_replace(value, /align-content|flex-|-self/, '') + value;
    // flex-shrink

    case 5548:
      return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, 'shrink', 'negative') + value;
    // flex-basis

    case 5292:
      return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, 'basis', 'preferred-size') + value;
    // flex-grow

    case 6060:
      return Enum_WEBKIT + 'box-' + Utility_replace(value, '-grow', '') + Enum_WEBKIT + value + Enum_MS + Utility_replace(value, 'grow', 'positive') + value;
    // transition

    case 4554:
      return Enum_WEBKIT + Utility_replace(value, /([^-])(transform)/g, '$1' + Enum_WEBKIT + '$2') + value;
    // cursor

    case 6187:
      return Utility_replace(Utility_replace(Utility_replace(value, /(zoom-|grab)/, Enum_WEBKIT + '$1'), /(image-set)/, Enum_WEBKIT + '$1'), value, '') + value;
    // background, background-image

    case 5495:
    case 3959:
      return Utility_replace(value, /(image-set\([^]*)/, Enum_WEBKIT + '$1' + '$`$1');
    // justify-content

    case 4968:
      return Utility_replace(Utility_replace(value, /(.+:)(flex-)?(.*)/, Enum_WEBKIT + 'box-pack:$3' + Enum_MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + Enum_WEBKIT + value + value;
    // (margin|padding)-inline-(start|end)

    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Utility_replace(value, /(.+)-inline(.+)/, Enum_WEBKIT + '$1$2') + value;
    // (min|max)?(width|height|inline-size|block-size)

    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      // stretch, max-content, min-content, fill-available
      if (Utility_strlen(value) - 1 - length > 6) switch (Utility_charat(value, length + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          // -
          if (Utility_charat(value, length + 4) !== 45) break;
        // (f)ill-available, (f)it-content

        case 102:
          return Utility_replace(value, /(.+:)(.+)-([^]+)/, '$1' + Enum_WEBKIT + '$2-$3' + '$1' + Enum_MOZ + (Utility_charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
        // (s)tretch

        case 115:
          return ~indexof(value, 'stretch') ? emotion_cache_browser_esm_prefix(Utility_replace(value, 'stretch', 'fill-available'), length) + value : value;
      }
      break;
    // position: sticky

    case 4949:
      // (s)ticky?
      if (Utility_charat(value, length + 1) !== 115) break;
    // display: (flex|inline-flex)

    case 6444:
      switch (Utility_charat(value, Utility_strlen(value) - 3 - (~indexof(value, '!important') && 10))) {
        // stic(k)y
        case 107:
          return Utility_replace(value, ':', ':' + Enum_WEBKIT) + value;
        // (inline-)?fl(e)x

        case 101:
          return Utility_replace(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + Enum_WEBKIT + (Utility_charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + Enum_WEBKIT + '$2$3' + '$1' + Enum_MS + '$2box$3') + value;
      }

      break;
    // writing-mode

    case 5936:
      switch (Utility_charat(value, length + 11)) {
        // vertical-l(r)
        case 114:
          return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
        // vertical-r(l)

        case 108:
          return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
        // horizontal(-)tb

        case 45:
          return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
      }

      return Enum_WEBKIT + value + Enum_MS + value + value;
  }

  return value;
}

var emotion_cache_browser_esm_prefixer = function prefixer(element, index, children, callback) {
  if (element.length > -1) if (!element["return"]) switch (element.type) {
    case Enum_DECLARATION:
      element["return"] = emotion_cache_browser_esm_prefix(element.value, element.length);
      break;

    case Enum_KEYFRAMES:
      return Serializer_serialize([Tokenizer_copy(element, {
        value: Utility_replace(element.value, '@', '@' + Enum_WEBKIT)
      })], callback);

    case Enum_RULESET:
      if (element.length) return Utility_combine(element.props, function (value) {
        switch (Utility_match(value, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ':read-only':
          case ':read-write':
            return Serializer_serialize([Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(read-\w+)/, ':' + Enum_MOZ + '$1')]
            })], callback);
          // :placeholder

          case '::placeholder':
            return Serializer_serialize([Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(plac\w+)/, ':' + Enum_WEBKIT + 'input-$1')]
            }), Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(plac\w+)/, ':' + Enum_MOZ + '$1')]
            }), Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(plac\w+)/, Enum_MS + 'input-$1')]
            })], callback);
        }

        return '';
      });
  }
};

var defaultStylisPlugins = [emotion_cache_browser_esm_prefixer];

var createCache = function createCache(options) {
  var key = options.key;

  if (key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');

      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }

      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }

  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

  var inserted = {};
  var container;
  var nodesToHydrate = [];

  {
    container = options.container || document.head;
    Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' ');

      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }

      nodesToHydrate.push(node);
    });
  }

  var _insert;

  var omnipresentPlugins = [compat, removeLabel];

  {
    var currentSheet;
    var finalizingPlugins = [stringify, rulesheet(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

    var stylis = function stylis(styles) {
      return Serializer_serialize(compile(styles), serializer);
    };

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;

      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};




/***/ }),

/***/ 45042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ memoize; }
/* harmony export */ });
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}




/***/ }),

/***/ 30174:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* binding */ Emotion$1; },
  "T": function() { return /* binding */ ThemeContext; },
  "a": function() { return /* binding */ ThemeProvider; },
  "c": function() { return /* binding */ createEmotionProps; },
  "h": function() { return /* binding */ emotion_element_c39617d8_browser_esm_hasOwnProperty; },
  "i": function() { return /* binding */ isBrowser; },
  "w": function() { return /* binding */ withEmotionCache; }
});

// UNUSED EXPORTS: C, _, b, u

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js + 7 modules
var emotion_cache_browser_esm = __webpack_require__(48711);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
;// CONCATENATED MODULE: ./node_modules/@emotion/react/node_modules/@emotion/weak-memoize/dist/emotion-weak-memoize.esm.js
var weakMemoize = function weakMemoize(func) {
  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // $FlowFixMe
      return cache.get(arg);
    }

    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};



// EXTERNAL MODULE: ./node_modules/@emotion/utils/dist/emotion-utils.browser.esm.js
var emotion_utils_browser_esm = __webpack_require__(70444);
// EXTERNAL MODULE: ./node_modules/@emotion/serialize/dist/emotion-serialize.esm.js + 2 modules
var emotion_serialize_esm = __webpack_require__(85662);
// EXTERNAL MODULE: ./node_modules/@emotion/use-insertion-effect-with-fallbacks/dist/emotion-use-insertion-effect-with-fallbacks.browser.esm.js
var emotion_use_insertion_effect_with_fallbacks_browser_esm = __webpack_require__(27278);
;// CONCATENATED MODULE: ./node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.js










var isBrowser = "object" !== 'undefined';
var emotion_element_c39617d8_browser_esm_hasOwnProperty = {}.hasOwnProperty;

var EmotionCacheContext = /* #__PURE__ */react.createContext( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */(0,emotion_cache_browser_esm/* default */.Z)({
  key: 'css'
}) : null);

if (false) {}

var CacheProvider = EmotionCacheContext.Provider;
var __unsafe_useEmotionCache = function useEmotionCache() {
  return useContext(EmotionCacheContext);
};

var withEmotionCache = function withEmotionCache(func) {
  // $FlowFixMe
  return /*#__PURE__*/(0,react.forwardRef)(function (props, ref) {
    // the cache will never be null in the browser
    var cache = (0,react.useContext)(EmotionCacheContext);
    return func(props, cache, ref);
  });
};

if (!isBrowser) {
  withEmotionCache = function withEmotionCache(func) {
    return function (props) {
      var cache = (0,react.useContext)(EmotionCacheContext);

      if (cache === null) {
        // yes, we're potentially creating this on every render
        // it doesn't actually matter though since it's only on the server
        // so there will only every be a single render
        // that could change in the future because of suspense and etc. but for now,
        // this works and i don't want to optimise for a future thing that we aren't sure about
        cache = (0,emotion_cache_browser_esm/* default */.Z)({
          key: 'css'
        });
        return /*#__PURE__*/react.createElement(EmotionCacheContext.Provider, {
          value: cache
        }, func(props, cache));
      } else {
        return func(props, cache);
      }
    };
  };
}

var ThemeContext = /* #__PURE__ */react.createContext({});

if (false) {}

var useTheme = function useTheme() {
  return React.useContext(ThemeContext);
};

var getTheme = function getTheme(outerTheme, theme) {
  if (typeof theme === 'function') {
    var mergedTheme = theme(outerTheme);

    if (false) {}

    return mergedTheme;
  }

  if (false) {}

  return (0,esm_extends/* default */.Z)({}, outerTheme, theme);
};

var createCacheWithTheme = /* #__PURE__ */weakMemoize(function (outerTheme) {
  return weakMemoize(function (theme) {
    return getTheme(outerTheme, theme);
  });
});
var ThemeProvider = function ThemeProvider(props) {
  var theme = react.useContext(ThemeContext);

  if (props.theme !== theme) {
    theme = createCacheWithTheme(theme)(props.theme);
  }

  return /*#__PURE__*/react.createElement(ThemeContext.Provider, {
    value: theme
  }, props.children);
};
function withTheme(Component) {
  var componentName = Component.displayName || Component.name || 'Component';

  var render = function render(props, ref) {
    var theme = React.useContext(ThemeContext);
    return /*#__PURE__*/React.createElement(Component, _extends({
      theme: theme,
      ref: ref
    }, props));
  }; // $FlowFixMe


  var WithTheme = /*#__PURE__*/React.forwardRef(render);
  WithTheme.displayName = "WithTheme(" + componentName + ")";
  return hoistNonReactStatics(WithTheme, Component);
}

var getLastPart = function getLastPart(functionName) {
  // The match may be something like 'Object.createEmotionProps' or
  // 'Loader.prototype.render'
  var parts = functionName.split('.');
  return parts[parts.length - 1];
};

var getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
  // V8
  var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
  if (match) return getLastPart(match[1]); // Safari / Firefox

  match = /^([A-Za-z0-9$.]+)@/.exec(line);
  if (match) return getLastPart(match[1]);
  return undefined;
};

var internalReactFunctionNames = /* #__PURE__ */new Set(['renderWithHooks', 'processChild', 'finishClassComponent', 'renderToString']); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.

var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
  return identifier.replace(/\$/g, '-');
};

var getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
  if (!stackTrace) return undefined;
  var lines = stackTrace.split('\n');

  for (var i = 0; i < lines.length; i++) {
    var functionName = getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"

    if (!functionName) continue; // If we reach one of these, we have gone too far and should quit

    if (internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
    // uppercase letter

    if (/^[A-Z]/.test(functionName)) return sanitizeIdentifier(functionName);
  }

  return undefined;
};

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
  if (false) {}

  var newProps = {};

  for (var key in props) {
    if (emotion_element_c39617d8_browser_esm_hasOwnProperty.call(props, key)) {
      newProps[key] = props[key];
    }
  }

  newProps[typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
  // the label hasn't already been computed

  if (false) { var label; }

  return newProps;
};

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  (0,emotion_utils_browser_esm/* registerStyles */.hC)(cache, serialized, isStringTag);
  (0,emotion_use_insertion_effect_with_fallbacks_browser_esm/* useInsertionEffectAlwaysWithSyncFallback */.L)(function () {
    return (0,emotion_utils_browser_esm/* insertStyles */.My)(cache, serialized, isStringTag);
  });

  return null;
};

var Emotion = /* #__PURE__ */withEmotionCache(function (props, cache, ref) {
  var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var WrappedComponent = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = (0,emotion_utils_browser_esm/* getRegisteredStyles */.fp)(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = (0,emotion_serialize_esm/* serializeStyles */.O)(registeredStyles, undefined, react.useContext(ThemeContext));

  if (false) { var labelFromStack; }

  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (emotion_element_c39617d8_browser_esm_hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && ( true || 0)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(Insertion, {
    cache: cache,
    serialized: serialized,
    isStringTag: typeof WrappedComponent === 'string'
  }), /*#__PURE__*/react.createElement(WrappedComponent, newProps));
});

if (false) {}

var Emotion$1 = Emotion;




/***/ }),

/***/ 70917:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F4": function() { return /* binding */ keyframes; },
/* harmony export */   "iv": function() { return /* binding */ css; },
/* harmony export */   "tZ": function() { return /* binding */ jsx; },
/* harmony export */   "xB": function() { return /* binding */ Global; }
/* harmony export */ });
/* unused harmony exports ClassNames, createElement */
/* harmony import */ var _emotion_element_c39617d8_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30174);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70444);
/* harmony import */ var _emotion_use_insertion_effect_with_fallbacks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27278);
/* harmony import */ var _emotion_serialize__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85662);
/* harmony import */ var _emotion_cache__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48711);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8679);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_4__);












var pkg = {
	name: "@emotion/react",
	version: "11.11.1",
	main: "dist/emotion-react.cjs.js",
	module: "dist/emotion-react.esm.js",
	browser: {
		"./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
	},
	exports: {
		".": {
			module: {
				worker: "./dist/emotion-react.worker.esm.js",
				browser: "./dist/emotion-react.browser.esm.js",
				"default": "./dist/emotion-react.esm.js"
			},
			"import": "./dist/emotion-react.cjs.mjs",
			"default": "./dist/emotion-react.cjs.js"
		},
		"./jsx-runtime": {
			module: {
				worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
				browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
				"default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
			},
			"import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
			"default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
		},
		"./_isolated-hnrs": {
			module: {
				worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
				browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
				"default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
			},
			"import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
			"default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
		},
		"./jsx-dev-runtime": {
			module: {
				worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
				browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
				"default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
			},
			"import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
			"default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
		},
		"./package.json": "./package.json",
		"./types/css-prop": "./types/css-prop.d.ts",
		"./macro": {
			types: {
				"import": "./macro.d.mts",
				"default": "./macro.d.ts"
			},
			"default": "./macro.js"
		}
	},
	types: "types/index.d.ts",
	files: [
		"src",
		"dist",
		"jsx-runtime",
		"jsx-dev-runtime",
		"_isolated-hnrs",
		"types/*.d.ts",
		"macro.*"
	],
	sideEffects: false,
	author: "Emotion Contributors",
	license: "MIT",
	scripts: {
		"test:typescript": "dtslint types"
	},
	dependencies: {
		"@babel/runtime": "^7.18.3",
		"@emotion/babel-plugin": "^11.11.0",
		"@emotion/cache": "^11.11.0",
		"@emotion/serialize": "^1.1.2",
		"@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
		"@emotion/utils": "^1.2.1",
		"@emotion/weak-memoize": "^0.3.1",
		"hoist-non-react-statics": "^3.3.1"
	},
	peerDependencies: {
		react: ">=16.8.0"
	},
	peerDependenciesMeta: {
		"@types/react": {
			optional: true
		}
	},
	devDependencies: {
		"@definitelytyped/dtslint": "0.0.112",
		"@emotion/css": "11.11.0",
		"@emotion/css-prettifier": "1.1.3",
		"@emotion/server": "11.11.0",
		"@emotion/styled": "11.11.0",
		"html-tag-names": "^1.1.2",
		react: "16.14.0",
		"svg-tag-names": "^1.1.1",
		typescript: "^4.5.5"
	},
	repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
	publishConfig: {
		access: "public"
	},
	"umd:main": "dist/emotion-react.umd.min.js",
	preconstruct: {
		entrypoints: [
			"./index.js",
			"./jsx-runtime.js",
			"./jsx-dev-runtime.js",
			"./_isolated-hnrs.js"
		],
		umdName: "emotionReact",
		exports: {
			envConditions: [
				"browser",
				"worker"
			],
			extra: {
				"./types/css-prop": "./types/css-prop.d.ts",
				"./macro": {
					types: {
						"import": "./macro.d.mts",
						"default": "./macro.d.ts"
					},
					"default": "./macro.js"
				}
			}
		}
	}
};

var jsx = function jsx(type, props) {
  var args = arguments;

  if (props == null || !_emotion_element_c39617d8_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__.h.call(props, 'css')) {
    // $FlowFixMe
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement.apply(undefined, args);
  }

  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = _emotion_element_c39617d8_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__.E;
  createElementArgArray[1] = (0,_emotion_element_c39617d8_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__.c)(type, props);

  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  } // $FlowFixMe


  return react__WEBPACK_IMPORTED_MODULE_0__.createElement.apply(null, createElementArgArray);
};

var warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag

var Global = /* #__PURE__ */(0,_emotion_element_c39617d8_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__.w)(function (props, cache) {
  if (false) {}

  var styles = props.styles;
  var serialized = (0,_emotion_serialize__WEBPACK_IMPORTED_MODULE_2__/* .serializeStyles */ .O)([styles], undefined, react__WEBPACK_IMPORTED_MODULE_0__.useContext(_emotion_element_c39617d8_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__.T));

  if (!_emotion_element_c39617d8_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__.i) {
    var _ref;

    var serializedNames = serialized.name;
    var serializedStyles = serialized.styles;
    var next = serialized.next;

    while (next !== undefined) {
      serializedNames += ' ' + next.name;
      serializedStyles += next.styles;
      next = next.next;
    }

    var shouldCache = cache.compat === true;
    var rules = cache.insert("", {
      name: serializedNames,
      styles: serializedStyles
    }, cache.sheet, shouldCache);

    if (shouldCache) {
      return null;
    }

    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref.nonce = cache.sheet.nonce, _ref));
  } // yes, i know these hooks are used conditionally
  // but it is based on a constant that will never change at runtime
  // it's effectively like having two implementations and switching them out
  // so it's not actually breaking anything


  var sheetRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  (0,_emotion_use_insertion_effect_with_fallbacks__WEBPACK_IMPORTED_MODULE_1__/* .useInsertionEffectWithLayoutFallback */ .j)(function () {
    var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675

    var sheet = new cache.sheet.constructor({
      key: key,
      nonce: cache.sheet.nonce,
      container: cache.sheet.container,
      speedy: cache.sheet.isSpeedy
    });
    var rehydrating = false; // $FlowFixMe

    var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");

    if (cache.sheet.tags.length) {
      sheet.before = cache.sheet.tags[0];
    }

    if (node !== null) {
      rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s

      node.setAttribute('data-emotion', key);
      sheet.hydrate([node]);
    }

    sheetRef.current = [sheet, rehydrating];
    return function () {
      sheet.flush();
    };
  }, [cache]);
  (0,_emotion_use_insertion_effect_with_fallbacks__WEBPACK_IMPORTED_MODULE_1__/* .useInsertionEffectWithLayoutFallback */ .j)(function () {
    var sheetRefCurrent = sheetRef.current;
    var sheet = sheetRefCurrent[0],
        rehydrating = sheetRefCurrent[1];

    if (rehydrating) {
      sheetRefCurrent[1] = false;
      return;
    }

    if (serialized.next !== undefined) {
      // insert keyframes
      (0,_emotion_utils__WEBPACK_IMPORTED_MODULE_6__/* .insertStyles */ .My)(cache, serialized.next, true);
    }

    if (sheet.tags.length) {
      // if this doesn't exist then it will be null so the style element will be appended
      var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
      sheet.before = element;
      sheet.flush();
    }

    cache.insert("", serialized, sheet, false);
  }, [cache, serialized.name]);
  return null;
});

if (false) {}

function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return (0,_emotion_serialize__WEBPACK_IMPORTED_MODULE_2__/* .serializeStyles */ .O)(args);
}

var keyframes = function keyframes() {
  var insertable = css.apply(void 0, arguments);
  var name = "animation-" + insertable.name; // $FlowFixMe

  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            if (false) {}

            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serializedArr = _ref.serializedArr;
  useInsertionEffectAlwaysWithSyncFallback(function () {

    for (var i = 0; i < serializedArr.length; i++) {
      insertStyles(cache, serializedArr[i], false);
    }
  });

  return null;
};

var ClassNames = /* #__PURE__ */(/* unused pure expression or super */ null && (withEmotionCache(function (props, cache) {
  var hasRendered = false;
  var serializedArr = [];

  var css = function css() {
    if (hasRendered && "production" !== 'production') {}

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var serialized = serializeStyles(args, cache.registered);
    serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`

    registerStyles(cache, serialized, false);
    return cache.key + "-" + serialized.name;
  };

  var cx = function cx() {
    if (hasRendered && "production" !== 'production') {}

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return merge(cache.registered, css, classnames(args));
  };

  var content = {
    css: css,
    cx: cx,
    theme: React.useContext(ThemeContext)
  };
  var ele = props.children(content);
  hasRendered = true;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Insertion, {
    cache: cache,
    serializedArr: serializedArr
  }), ele);
})));

if (false) {}

if (false) { var globalKey, globalContext, isTestEnv, isBrowser; }




/***/ }),

/***/ 35944:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BX": function() { return /* binding */ jsxs; },
/* harmony export */   "HY": function() { return /* binding */ Fragment; },
/* harmony export */   "tZ": function() { return /* binding */ jsx; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _dist_emotion_element_c39617d8_browser_esm_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30174);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _emotion_cache__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48711);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8679);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _emotion_serialize__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85662);
/* harmony import */ var _emotion_use_insertion_effect_with_fallbacks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27278);












var Fragment = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment;
function jsx(type, props, key) {
  if (!_dist_emotion_element_c39617d8_browser_esm_js__WEBPACK_IMPORTED_MODULE_6__.h.call(props, 'css')) {
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx(type, props, key);
  }

  return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx(_dist_emotion_element_c39617d8_browser_esm_js__WEBPACK_IMPORTED_MODULE_6__.E, (0,_dist_emotion_element_c39617d8_browser_esm_js__WEBPACK_IMPORTED_MODULE_6__.c)(type, props), key);
}
function jsxs(type, props, key) {
  if (!_dist_emotion_element_c39617d8_browser_esm_js__WEBPACK_IMPORTED_MODULE_6__.h.call(props, 'css')) {
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs(type, props, key);
  }

  return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs(_dist_emotion_element_c39617d8_browser_esm_js__WEBPACK_IMPORTED_MODULE_6__.E, (0,_dist_emotion_element_c39617d8_browser_esm_js__WEBPACK_IMPORTED_MODULE_6__.c)(type, props), key);
}




/***/ }),

/***/ 85662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ serializeStyles; }
});

;// CONCATENATED MODULE: ./node_modules/@emotion/hash/dist/emotion-hash.esm.js
/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}



;// CONCATENATED MODULE: ./node_modules/@emotion/unitless/dist/emotion-unitless.esm.js
var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};



// EXTERNAL MODULE: ./node_modules/@emotion/memoize/dist/emotion-memoize.esm.js
var emotion_memoize_esm = __webpack_require__(45042);
;// CONCATENATED MODULE: ./node_modules/@emotion/serialize/dist/emotion-serialize.esm.js




var isDevelopment = false;

var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */(0,emotion_memoize_esm/* default */.Z)(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

var noComponentSelectorMessage = 'Component selectors can only be used in conjunction with ' + '@emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware ' + 'compiler transform.';

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  var componentSelector = interpolation;

  if (componentSelector.__emotion_styles !== undefined) {

    return componentSelector;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        var keyframes = interpolation;

        if (keyframes.anim === 1) {
          cursor = {
            name: keyframes.name,
            styles: keyframes.styles,
            next: cursor
          };
          return keyframes.name;
        }

        var serializedStyles = interpolation;

        if (serializedStyles.styles !== undefined) {
          var next = serializedStyles.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = serializedStyles.styles + ";";
          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        }

        break;
      }
  } // finalize string values (regular strings and functions interpolated into css calls)


  var asString = interpolation;

  if (registered == null) {
    return asString;
  }

  var cached = registered[asString];
  return cached !== undefined ? cached : asString;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var key in obj) {
      var value = obj[key];

      if (typeof value !== 'object') {
        var asString = value;

        if (registered != null && registered[asString] !== undefined) {
          string += key + "{" + registered[asString] + "}";
        } else if (isProcessableValue(asString)) {
          string += processStyleName(key) + ":" + processStyleValue(key, asString) + ";";
        }
      } else {
        if (key === 'NO_COMPONENT_SELECTOR' && isDevelopment) {
          throw new Error(noComponentSelectorMessage);
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(key) + ":" + processStyleValue(key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(key) + ":" + interpolated + ";";
                break;
              }

            default:
              {

                string += key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list

var cursor;
function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    var asTemplateStringsArr = strings;

    styles += asTemplateStringsArr[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {
      var templateStringsArr = strings;

      styles += templateStringsArr[i];
    }
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + match[1];
  }

  var name = murmur2(styles) + identifierName;

  return {
    name: name,
    styles: styles,
    next: cursor
  };
}




/***/ }),

/***/ 82110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ createStyled; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/memoize/dist/emotion-memoize.esm.js
var emotion_memoize_esm = __webpack_require__(45042);
;// CONCATENATED MODULE: ./node_modules/@emotion/styled/node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.esm.js


// eslint-disable-next-line no-undef
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */(0,emotion_memoize_esm/* default */.Z)(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);



// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.js + 1 modules
var emotion_element_c39617d8_browser_esm = __webpack_require__(30174);
// EXTERNAL MODULE: ./node_modules/@emotion/utils/dist/emotion-utils.browser.esm.js
var emotion_utils_browser_esm = __webpack_require__(70444);
// EXTERNAL MODULE: ./node_modules/@emotion/serialize/dist/emotion-serialize.esm.js + 2 modules
var emotion_serialize_esm = __webpack_require__(85662);
// EXTERNAL MODULE: ./node_modules/@emotion/use-insertion-effect-with-fallbacks/dist/emotion-use-insertion-effect-with-fallbacks.browser.esm.js
var emotion_use_insertion_effect_with_fallbacks_browser_esm = __webpack_require__(27278);
;// CONCATENATED MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js








var testOmitPropsOnStringTag = isPropValid;

var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
  return key !== 'theme';
};

var getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
  return typeof tag === 'string' && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};
var composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
  var shouldForwardProp;

  if (options) {
    var optionsShouldForwardProp = options.shouldForwardProp;
    shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function (propName) {
      return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
    } : optionsShouldForwardProp;
  }

  if (typeof shouldForwardProp !== 'function' && isReal) {
    shouldForwardProp = tag.__emotion_forwardProp;
  }

  return shouldForwardProp;
};

var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  (0,emotion_utils_browser_esm/* registerStyles */.hC)(cache, serialized, isStringTag);
  (0,emotion_use_insertion_effect_with_fallbacks_browser_esm/* useInsertionEffectAlwaysWithSyncFallback */.L)(function () {
    return (0,emotion_utils_browser_esm/* insertStyles */.My)(cache, serialized, isStringTag);
  });

  return null;
};

var createStyled = function createStyled(tag, options) {
  if (false) {}

  var isReal = tag.__emotion_real === tag;
  var baseTag = isReal && tag.__emotion_base || tag;
  var identifierName;
  var targetClassName;

  if (options !== undefined) {
    identifierName = options.label;
    targetClassName = options.target;
  }

  var shouldForwardProp = composeShouldForwardProps(tag, options, isReal);
  var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
  var shouldUseAs = !defaultShouldForwardProp('as');
  return function () {
    var args = arguments;
    var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];

    if (identifierName !== undefined) {
      styles.push("label:" + identifierName + ";");
    }

    if (args[0] == null || args[0].raw === undefined) {
      styles.push.apply(styles, args);
    } else {
      if (false) {}

      styles.push(args[0][0]);
      var len = args.length;
      var i = 1;

      for (; i < len; i++) {
        if (false) {}

        styles.push(args[i], args[0][i]);
      }
    } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class


    var Styled = (0,emotion_element_c39617d8_browser_esm.w)(function (props, cache, ref) {
      var FinalTag = shouldUseAs && props.as || baseTag;
      var className = '';
      var classInterpolations = [];
      var mergedProps = props;

      if (props.theme == null) {
        mergedProps = {};

        for (var key in props) {
          mergedProps[key] = props[key];
        }

        mergedProps.theme = react.useContext(emotion_element_c39617d8_browser_esm.T);
      }

      if (typeof props.className === 'string') {
        className = (0,emotion_utils_browser_esm/* getRegisteredStyles */.fp)(cache.registered, classInterpolations, props.className);
      } else if (props.className != null) {
        className = props.className + " ";
      }

      var serialized = (0,emotion_serialize_esm/* serializeStyles */.O)(styles.concat(classInterpolations), cache.registered, mergedProps);
      className += cache.key + "-" + serialized.name;

      if (targetClassName !== undefined) {
        className += " " + targetClassName;
      }

      var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
      var newProps = {};

      for (var _key in props) {
        if (shouldUseAs && _key === 'as') continue;

        if ( // $FlowFixMe
        finalShouldForwardProp(_key)) {
          newProps[_key] = props[_key];
        }
      }

      newProps.className = className;
      newProps.ref = ref;
      return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof FinalTag === 'string'
      }), /*#__PURE__*/react.createElement(FinalTag, newProps));
    });
    Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
    Styled.defaultProps = tag.defaultProps;
    Styled.__emotion_real = Styled;
    Styled.__emotion_base = baseTag;
    Styled.__emotion_styles = styles;
    Styled.__emotion_forwardProp = shouldForwardProp;
    Object.defineProperty(Styled, 'toString', {
      value: function value() {
        if (targetClassName === undefined && "production" !== 'production') {} // $FlowFixMe: coerce undefined to string


        return "." + targetClassName;
      }
    });

    Styled.withComponent = function (nextTag, nextOptions) {
      return createStyled(nextTag, (0,esm_extends/* default */.Z)({}, options, nextOptions, {
        shouldForwardProp: composeShouldForwardProps(Styled, nextOptions, true)
      })).apply(void 0, styles);
    };

    return Styled;
  };
};




/***/ }),

/***/ 37337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ newStyled; }
/* harmony export */ });
/* harmony import */ var _base_dist_emotion_styled_base_browser_esm_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82110);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _emotion_serialize__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85662);
/* harmony import */ var _emotion_use_insertion_effect_with_fallbacks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27278);









var tags = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', // SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

var newStyled = _base_dist_emotion_styled_base_browser_esm_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].bind */ .Z.bind();
tags.forEach(function (tagName) {
  // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
  newStyled[tagName] = newStyled(tagName);
});




/***/ }),

/***/ 27278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
var react__WEBPACK_IMPORTED_MODULE_0___namespace_cache;
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useInsertionEffectAlwaysWithSyncFallback; },
/* harmony export */   "j": function() { return /* binding */ useInsertionEffectWithLayoutFallback; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var syncFallback = function syncFallback(create) {
  return create();
};

var useInsertionEffect = /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))['useInsertion' + 'Effect'] ? /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))['useInsertion' + 'Effect'] : false;
var useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect || syncFallback;
var useInsertionEffectWithLayoutFallback = useInsertionEffect || react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect;




/***/ }),

/***/ 70444:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "My": function() { return /* binding */ insertStyles; },
/* harmony export */   "fp": function() { return /* binding */ getRegisteredStyles; },
/* harmony export */   "hC": function() { return /* binding */ registerStyles; }
/* harmony export */ });
var isBrowser = true;

function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else if (className) {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false ) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      current = current.next;
    } while (current !== undefined);
  }
};




/***/ }),

/***/ 4586:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * @noflow
 */

/* eslint no-bitwise: 0 */



function normalizeColor(color) {
  if (typeof color === 'number') {
    if (color >>> 0 === color && color >= 0 && color <= 0xffffffff) {
      return color;
    }
    return null;
  }

  if (typeof color !== 'string') {
    return null;
  }

  const matchers = getMatchers();
  let match;

  // Ordered based on occurrences on Facebook codebase
  if ((match = matchers.hex6.exec(color))) {
    return parseInt(match[1] + 'ff', 16) >>> 0;
  }

  const colorFromKeyword = normalizeKeyword(color);
  if (colorFromKeyword != null) {
    return colorFromKeyword;
  }

  if ((match = matchers.rgb.exec(color))) {
    return (
      ((parse255(match[1]) << 24) | // r
        (parse255(match[2]) << 16) | // g
        (parse255(match[3]) << 8) | // b
        0x000000ff) >>> // a
      0
    );
  }

  if ((match = matchers.rgba.exec(color))) {
    // rgba(R G B / A) notation
    if (match[6] !== undefined) {
      return (
        ((parse255(match[6]) << 24) | // r
          (parse255(match[7]) << 16) | // g
          (parse255(match[8]) << 8) | // b
          parse1(match[9])) >>> // a
        0
      );
    }

    // rgba(R, G, B, A) notation
    return (
      ((parse255(match[2]) << 24) | // r
        (parse255(match[3]) << 16) | // g
        (parse255(match[4]) << 8) | // b
        parse1(match[5])) >>> // a
      0
    );
  }

  if ((match = matchers.hex3.exec(color))) {
    return (
      parseInt(
        match[1] +
          match[1] + // r
          match[2] +
          match[2] + // g
          match[3] +
          match[3] + // b
          'ff', // a
        16,
      ) >>> 0
    );
  }

  // https://drafts.csswg.org/css-color-4/#hex-notation
  if ((match = matchers.hex8.exec(color))) {
    return parseInt(match[1], 16) >>> 0;
  }

  if ((match = matchers.hex4.exec(color))) {
    return (
      parseInt(
        match[1] +
          match[1] + // r
          match[2] +
          match[2] + // g
          match[3] +
          match[3] + // b
          match[4] +
          match[4], // a
        16,
      ) >>> 0
    );
  }

  if ((match = matchers.hsl.exec(color))) {
    return (
      (hslToRgb(
        parse360(match[1]), // h
        parsePercentage(match[2]), // s
        parsePercentage(match[3]), // l
      ) |
        0x000000ff) >>> // a
      0
    );
  }

  if ((match = matchers.hsla.exec(color))) {
    // hsla(H S L / A) notation
    if (match[6] !== undefined) {
      return (
        (hslToRgb(
          parse360(match[6]), // h
          parsePercentage(match[7]), // s
          parsePercentage(match[8]), // l
        ) |
          parse1(match[9])) >>> // a
        0
      );
    }

    // hsla(H, S, L, A) notation
    return (
      (hslToRgb(
        parse360(match[2]), // h
        parsePercentage(match[3]), // s
        parsePercentage(match[4]), // l
      ) |
        parse1(match[5])) >>> // a
      0
    );
  }

  if ((match = matchers.hwb.exec(color))) {
    return (
      (hwbToRgb(
        parse360(match[1]), // h
        parsePercentage(match[2]), // w
        parsePercentage(match[3]), // b
      ) |
        0x000000ff) >>> // a
      0
    );
  }

  return null;
}

function hue2rgb(p, q, t) {
  if (t < 0) {
    t += 1;
  }
  if (t > 1) {
    t -= 1;
  }
  if (t < 1 / 6) {
    return p + (q - p) * 6 * t;
  }
  if (t < 1 / 2) {
    return q;
  }
  if (t < 2 / 3) {
    return p + (q - p) * (2 / 3 - t) * 6;
  }
  return p;
}

function hslToRgb(h, s, l) {
  const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
  const p = 2 * l - q;
  const r = hue2rgb(p, q, h + 1 / 3);
  const g = hue2rgb(p, q, h);
  const b = hue2rgb(p, q, h - 1 / 3);

  return (
    (Math.round(r * 255) << 24) |
    (Math.round(g * 255) << 16) |
    (Math.round(b * 255) << 8)
  );
}

function hwbToRgb(h, w, b) {
  if (w + b >= 1) {
    const gray = Math.round((w * 255) / (w + b));

    return (gray << 24) | (gray << 16) | (gray << 8);
  }

  const red = hue2rgb(0, 1, h + 1 / 3) * (1 - w - b) + w;
  const green = hue2rgb(0, 1, h) * (1 - w - b) + w;
  const blue = hue2rgb(0, 1, h - 1 / 3) * (1 - w - b) + w;

  return (
    (Math.round(red * 255) << 24) |
    (Math.round(green * 255) << 16) |
    (Math.round(blue * 255) << 8)
  );
}

const NUMBER = '[-+]?\\d*\\.?\\d+';
const PERCENTAGE = NUMBER + '%';

function call(...args) {
  return '\\(\\s*(' + args.join(')\\s*,?\\s*(') + ')\\s*\\)';
}

function callWithSlashSeparator(...args) {
  return (
    '\\(\\s*(' +
    args.slice(0, args.length - 1).join(')\\s*,?\\s*(') +
    ')\\s*/\\s*(' +
    args[args.length - 1] +
    ')\\s*\\)'
  );
}

function commaSeparatedCall(...args) {
  return '\\(\\s*(' + args.join(')\\s*,\\s*(') + ')\\s*\\)';
}

let cachedMatchers;

function getMatchers() {
  if (cachedMatchers === undefined) {
    cachedMatchers = {
      rgb: new RegExp('rgb' + call(NUMBER, NUMBER, NUMBER)),
      rgba: new RegExp(
        'rgba(' +
          commaSeparatedCall(NUMBER, NUMBER, NUMBER, NUMBER) +
          '|' +
          callWithSlashSeparator(NUMBER, NUMBER, NUMBER, NUMBER) +
          ')',
      ),
      hsl: new RegExp('hsl' + call(NUMBER, PERCENTAGE, PERCENTAGE)),
      hsla: new RegExp(
        'hsla(' +
          commaSeparatedCall(NUMBER, PERCENTAGE, PERCENTAGE, NUMBER) +
          '|' +
          callWithSlashSeparator(NUMBER, PERCENTAGE, PERCENTAGE, NUMBER) +
          ')',
      ),
      hwb: new RegExp('hwb' + call(NUMBER, PERCENTAGE, PERCENTAGE)),
      hex3: /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
      hex4: /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
      hex6: /^#([0-9a-fA-F]{6})$/,
      hex8: /^#([0-9a-fA-F]{8})$/,
    };
  }
  return cachedMatchers;
}

function parse255(str) {
  const int = parseInt(str, 10);
  if (int < 0) {
    return 0;
  }
  if (int > 255) {
    return 255;
  }
  return int;
}

function parse360(str) {
  const int = parseFloat(str);
  return (((int % 360) + 360) % 360) / 360;
}

function parse1(str) {
  const num = parseFloat(str);
  if (num < 0) {
    return 0;
  }
  if (num > 1) {
    return 255;
  }
  return Math.round(num * 255);
}

function parsePercentage(str) {
  // parseFloat conveniently ignores the final %
  const int = parseFloat(str);
  if (int < 0) {
    return 0;
  }
  if (int > 100) {
    return 1;
  }
  return int / 100;
}

function normalizeKeyword(name) {
  // prettier-ignore
  switch (name) {
    case 'transparent': return 0x00000000;
    // http://www.w3.org/TR/css3-color/#svg-color
    case 'aliceblue': return 0xf0f8ffff;
    case 'antiquewhite': return 0xfaebd7ff;
    case 'aqua': return 0x00ffffff;
    case 'aquamarine': return 0x7fffd4ff;
    case 'azure': return 0xf0ffffff;
    case 'beige': return 0xf5f5dcff;
    case 'bisque': return 0xffe4c4ff;
    case 'black': return 0x000000ff;
    case 'blanchedalmond': return 0xffebcdff;
    case 'blue': return 0x0000ffff;
    case 'blueviolet': return 0x8a2be2ff;
    case 'brown': return 0xa52a2aff;
    case 'burlywood': return 0xdeb887ff;
    case 'burntsienna': return 0xea7e5dff;
    case 'cadetblue': return 0x5f9ea0ff;
    case 'chartreuse': return 0x7fff00ff;
    case 'chocolate': return 0xd2691eff;
    case 'coral': return 0xff7f50ff;
    case 'cornflowerblue': return 0x6495edff;
    case 'cornsilk': return 0xfff8dcff;
    case 'crimson': return 0xdc143cff;
    case 'cyan': return 0x00ffffff;
    case 'darkblue': return 0x00008bff;
    case 'darkcyan': return 0x008b8bff;
    case 'darkgoldenrod': return 0xb8860bff;
    case 'darkgray': return 0xa9a9a9ff;
    case 'darkgreen': return 0x006400ff;
    case 'darkgrey': return 0xa9a9a9ff;
    case 'darkkhaki': return 0xbdb76bff;
    case 'darkmagenta': return 0x8b008bff;
    case 'darkolivegreen': return 0x556b2fff;
    case 'darkorange': return 0xff8c00ff;
    case 'darkorchid': return 0x9932ccff;
    case 'darkred': return 0x8b0000ff;
    case 'darksalmon': return 0xe9967aff;
    case 'darkseagreen': return 0x8fbc8fff;
    case 'darkslateblue': return 0x483d8bff;
    case 'darkslategray': return 0x2f4f4fff;
    case 'darkslategrey': return 0x2f4f4fff;
    case 'darkturquoise': return 0x00ced1ff;
    case 'darkviolet': return 0x9400d3ff;
    case 'deeppink': return 0xff1493ff;
    case 'deepskyblue': return 0x00bfffff;
    case 'dimgray': return 0x696969ff;
    case 'dimgrey': return 0x696969ff;
    case 'dodgerblue': return 0x1e90ffff;
    case 'firebrick': return 0xb22222ff;
    case 'floralwhite': return 0xfffaf0ff;
    case 'forestgreen': return 0x228b22ff;
    case 'fuchsia': return 0xff00ffff;
    case 'gainsboro': return 0xdcdcdcff;
    case 'ghostwhite': return 0xf8f8ffff;
    case 'gold': return 0xffd700ff;
    case 'goldenrod': return 0xdaa520ff;
    case 'gray': return 0x808080ff;
    case 'green': return 0x008000ff;
    case 'greenyellow': return 0xadff2fff;
    case 'grey': return 0x808080ff;
    case 'honeydew': return 0xf0fff0ff;
    case 'hotpink': return 0xff69b4ff;
    case 'indianred': return 0xcd5c5cff;
    case 'indigo': return 0x4b0082ff;
    case 'ivory': return 0xfffff0ff;
    case 'khaki': return 0xf0e68cff;
    case 'lavender': return 0xe6e6faff;
    case 'lavenderblush': return 0xfff0f5ff;
    case 'lawngreen': return 0x7cfc00ff;
    case 'lemonchiffon': return 0xfffacdff;
    case 'lightblue': return 0xadd8e6ff;
    case 'lightcoral': return 0xf08080ff;
    case 'lightcyan': return 0xe0ffffff;
    case 'lightgoldenrodyellow': return 0xfafad2ff;
    case 'lightgray': return 0xd3d3d3ff;
    case 'lightgreen': return 0x90ee90ff;
    case 'lightgrey': return 0xd3d3d3ff;
    case 'lightpink': return 0xffb6c1ff;
    case 'lightsalmon': return 0xffa07aff;
    case 'lightseagreen': return 0x20b2aaff;
    case 'lightskyblue': return 0x87cefaff;
    case 'lightslategray': return 0x778899ff;
    case 'lightslategrey': return 0x778899ff;
    case 'lightsteelblue': return 0xb0c4deff;
    case 'lightyellow': return 0xffffe0ff;
    case 'lime': return 0x00ff00ff;
    case 'limegreen': return 0x32cd32ff;
    case 'linen': return 0xfaf0e6ff;
    case 'magenta': return 0xff00ffff;
    case 'maroon': return 0x800000ff;
    case 'mediumaquamarine': return 0x66cdaaff;
    case 'mediumblue': return 0x0000cdff;
    case 'mediumorchid': return 0xba55d3ff;
    case 'mediumpurple': return 0x9370dbff;
    case 'mediumseagreen': return 0x3cb371ff;
    case 'mediumslateblue': return 0x7b68eeff;
    case 'mediumspringgreen': return 0x00fa9aff;
    case 'mediumturquoise': return 0x48d1ccff;
    case 'mediumvioletred': return 0xc71585ff;
    case 'midnightblue': return 0x191970ff;
    case 'mintcream': return 0xf5fffaff;
    case 'mistyrose': return 0xffe4e1ff;
    case 'moccasin': return 0xffe4b5ff;
    case 'navajowhite': return 0xffdeadff;
    case 'navy': return 0x000080ff;
    case 'oldlace': return 0xfdf5e6ff;
    case 'olive': return 0x808000ff;
    case 'olivedrab': return 0x6b8e23ff;
    case 'orange': return 0xffa500ff;
    case 'orangered': return 0xff4500ff;
    case 'orchid': return 0xda70d6ff;
    case 'palegoldenrod': return 0xeee8aaff;
    case 'palegreen': return 0x98fb98ff;
    case 'paleturquoise': return 0xafeeeeff;
    case 'palevioletred': return 0xdb7093ff;
    case 'papayawhip': return 0xffefd5ff;
    case 'peachpuff': return 0xffdab9ff;
    case 'peru': return 0xcd853fff;
    case 'pink': return 0xffc0cbff;
    case 'plum': return 0xdda0ddff;
    case 'powderblue': return 0xb0e0e6ff;
    case 'purple': return 0x800080ff;
    case 'rebeccapurple': return 0x663399ff;
    case 'red': return 0xff0000ff;
    case 'rosybrown': return 0xbc8f8fff;
    case 'royalblue': return 0x4169e1ff;
    case 'saddlebrown': return 0x8b4513ff;
    case 'salmon': return 0xfa8072ff;
    case 'sandybrown': return 0xf4a460ff;
    case 'seagreen': return 0x2e8b57ff;
    case 'seashell': return 0xfff5eeff;
    case 'sienna': return 0xa0522dff;
    case 'silver': return 0xc0c0c0ff;
    case 'skyblue': return 0x87ceebff;
    case 'slateblue': return 0x6a5acdff;
    case 'slategray': return 0x708090ff;
    case 'slategrey': return 0x708090ff;
    case 'snow': return 0xfffafaff;
    case 'springgreen': return 0x00ff7fff;
    case 'steelblue': return 0x4682b4ff;
    case 'tan': return 0xd2b48cff;
    case 'teal': return 0x008080ff;
    case 'thistle': return 0xd8bfd8ff;
    case 'tomato': return 0xff6347ff;
    case 'turquoise': return 0x40e0d0ff;
    case 'violet': return 0xee82eeff;
    case 'wheat': return 0xf5deb3ff;
    case 'white': return 0xffffffff;
    case 'whitesmoke': return 0xf5f5f5ff;
    case 'yellow': return 0xffff00ff;
    case 'yellowgreen': return 0x9acd32ff;
  }
  return null;
}

module.exports = normalizeColor;


/***/ }),

/***/ 90212:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var compose_refs_exports = {};
__export(compose_refs_exports, {
  composeRefs: () => composeRefs,
  setRef: () => setRef,
  useComposedRefs: () => useComposedRefs
});
module.exports = __toCommonJS(compose_refs_exports);
var React = __toESM(__webpack_require__(67294));
function setRef(ref, value) {
  typeof ref == "function" ? ref(value) : ref && (ref.current = value);
}
function composeRefs(...refs) {
  return (node) => refs.forEach((ref) => setRef(ref, node));
}
function useComposedRefs(...refs) {
  return React.useCallback(composeRefs(...refs), refs);
}
//# sourceMappingURL=compose-refs.js.map


/***/ }),

/***/ 95915:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
}, __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var src_exports = {};
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(90212), module.exports);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 47346:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var constants_exports = {};
__export(constants_exports, {
  currentPlatform: () => currentPlatform,
  isAndroid: () => isAndroid,
  isChrome: () => isChrome,
  isClient: () => isClient,
  isIos: () => isIos,
  isServer: () => isServer,
  isTouchable: () => isTouchable,
  isWeb: () => isWeb,
  isWebTouchable: () => isWebTouchable,
  isWindowDefined: () => isWindowDefined,
  useIsomorphicLayoutEffect: () => useIsomorphicLayoutEffect
});
module.exports = __toCommonJS(constants_exports);
var import_react = __toESM(__webpack_require__(67294));
const isWeb = !0, isWindowDefined = typeof window < "u", isServer = isWeb && !isWindowDefined, isClient = isWeb && isWindowDefined, useIsomorphicLayoutEffect = isServer ? import_react.default.useEffect : import_react.default.useLayoutEffect, isChrome = typeof navigator < "u" && /Chrome/.test(navigator.userAgent || ""), isWebTouchable = isClient && ("ontouchstart" in window || navigator.maxTouchPoints > 0), isTouchable = !isWeb || isWebTouchable, isAndroid = !1, isIos = !1, currentPlatform = "web";
//# sourceMappingURL=constants.js.map


/***/ }),

/***/ 14810:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
}, __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var src_exports = {};
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(47346), module.exports);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 73058:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var createOptimizedView_exports = {};
__export(createOptimizedView_exports, {
  createOptimizedView: () => createOptimizedView
});
module.exports = __toCommonJS(createOptimizedView_exports);
function createOptimizedView(children, viewProps, baseViews) {
}
//# sourceMappingURL=createOptimizedView.js.map


/***/ }),

/***/ 68877:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var getBaseViews_exports = {};
__export(getBaseViews_exports, {
  getBaseViews: () => getBaseViews
});
module.exports = __toCommonJS(getBaseViews_exports);
function getBaseViews() {
  return null;
}
//# sourceMappingURL=getBaseViews.js.map


/***/ }),

/***/ 93691:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var getBoundingClientRect_exports = {};
__export(getBoundingClientRect_exports, {
  getBoundingClientRect: () => getBoundingClientRect
});
module.exports = __toCommonJS(getBoundingClientRect_exports);
const getBoundingClientRect = (node) => {
  if (!(!node || node.nodeType !== 1))
    return node.getBoundingClientRect?.();
};
//# sourceMappingURL=getBoundingClientRect.js.map


/***/ }),

/***/ 71023:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var getRect_exports = {};
__export(getRect_exports, {
  getRect: () => getRect
});
module.exports = __toCommonJS(getRect_exports);
var import_getBoundingClientRect = __webpack_require__(93691);
const getRect = (node) => {
  const rect = (0, import_getBoundingClientRect.getBoundingClientRect)(node);
  if (!rect) return;
  const { x, y, top, left } = rect;
  return { x, y, width: node.offsetWidth, height: node.offsetHeight, top, left };
};
//# sourceMappingURL=getRect.js.map


/***/ }),

/***/ 18987:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var useElementLayout_exports = {};
__export(useElementLayout_exports, {
  measureElement: () => measureElement,
  measureLayout: () => measureLayout,
  useElementLayout: () => useElementLayout
});
module.exports = __toCommonJS(useElementLayout_exports);
var import_constants = __webpack_require__(14810), import_getBoundingClientRect = __webpack_require__(93691);
const LayoutHandlers = /* @__PURE__ */ new WeakMap(), resizeListeners = /* @__PURE__ */ new Set();
let resizeObserver = null;
if (typeof window < "u" && "ResizeObserver" in window && (resizeObserver = new ResizeObserver((entries) => {
  for (const { target } of entries) {
    const onLayout = LayoutHandlers.get(target);
    if (typeof onLayout != "function") return;
    measureElement(target).then((event) => {
      onLayout(event);
    });
  }
}), typeof window.addEventListener == "function")) {
  let tm;
  window.addEventListener("resize", () => {
    clearTimeout(tm), tm = setTimeout(() => {
      resizeListeners.forEach((cb) => cb());
    }, 4);
  });
}
const measureElement = async (target) => new Promise((res) => {
  measureLayout(target, null, (x, y, width, height, left, top) => {
    res({
      nativeEvent: {
        layout: { x, y, width, height, left, top },
        target
      },
      timeStamp: Date.now()
    });
  });
}), cache = /* @__PURE__ */ new WeakMap(), measureLayout = (node, relativeTo, callback) => {
  const relativeNode = relativeTo || node?.parentNode;
  if (relativeNode instanceof HTMLElement) {
    const now = Date.now();
    cache.set(node, now), Promise.all([
      getBoundingClientRectAsync(node),
      getBoundingClientRectAsync(relativeNode)
    ]).then(([nodeDim, relativeNodeDim]) => {
      if (relativeNodeDim && nodeDim && cache.get(node) === now) {
        const { x, y, width, height, left, top } = getRelativeDimensions(
          nodeDim,
          relativeNodeDim
        );
        callback(x, y, width, height, left, top);
      }
    });
  }
}, getRelativeDimensions = (a, b) => {
  const { height, left, top, width } = a, x = left - b.left, y = top - b.top;
  return { x, y, width, height, left, top };
}, getBoundingClientRectAsync = (element) => new Promise((resolve) => {
  function fallbackToSync() {
    resolve((0, import_getBoundingClientRect.getBoundingClientRect)(element));
  }
  const tm = setTimeout(fallbackToSync, 10);
  new IntersectionObserver(
    (entries, ob) => {
      clearTimeout(tm), ob.disconnect(), resolve(entries[0]?.boundingClientRect);
    },
    {
      threshold: 1e-4
    }
  ).observe(element);
});
function useElementLayout(ref, onLayout) {
  (0, import_constants.useIsomorphicLayoutEffect)(() => {
    if (!onLayout) return;
    const node = ref.current;
    node && LayoutHandlers.set(node, onLayout);
  }, [ref, onLayout]), (0, import_constants.useIsomorphicLayoutEffect)(() => {
    if (!resizeObserver) return;
    const node = ref.current;
    if (!node || !LayoutHandlers.has(node)) return;
    const onResize = () => {
      measureElement(node).then(onLayout);
    };
    return resizeListeners.add(onResize), resizeObserver.observe(node), () => {
      resizeListeners.delete(onResize), resizeObserver?.unobserve(node);
    };
  }, [ref]);
}
//# sourceMappingURL=useElementLayout.js.map


/***/ }),

/***/ 55344:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var usePlatformMethods_exports = {};
__export(usePlatformMethods_exports, {
  usePlatformMethods: () => usePlatformMethods
});
module.exports = __toCommonJS(usePlatformMethods_exports);
var import_constants = __webpack_require__(14810), import_getRect = __webpack_require__(71023), import_useElementLayout = __webpack_require__(18987);
function usePlatformMethods(hostRef) {
  (0, import_constants.useIsomorphicLayoutEffect)(() => {
    const node = hostRef.current;
    node && (node.measure ||= (callback) => (0, import_useElementLayout.measureLayout)(node, null, callback), node.measureLayout ||= (relativeToNode, success) => (0, import_useElementLayout.measureLayout)(node, relativeToNode, success), node.measureInWindow ||= (callback) => {
      node && setTimeout(() => {
        const { height, left, top, width } = (0, import_getRect.getRect)(node);
        callback(left, top, width, height);
      }, 0);
    });
  }, [hostRef]);
}
//# sourceMappingURL=usePlatformMethods.js.map


/***/ }),

/***/ 86872:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
}, __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default")), __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var src_exports = {};
__export(src_exports, {
  Stack: () => Stack,
  Text: () => Text,
  View: () => View
});
module.exports = __toCommonJS(src_exports);
var import_react = __toESM(__webpack_require__(67294)), import_react_native_use_responder_events = __webpack_require__(94245), import_web = __webpack_require__(17187), import_createOptimizedView = __webpack_require__(73058), import_getBaseViews = __webpack_require__(68877), import_useElementLayout = __webpack_require__(18987), import_usePlatformMethods = __webpack_require__(55344), import_Pressability = __webpack_require__(5468);
__reExport(src_exports, __webpack_require__(17187), module.exports);
__reExport(src_exports, __webpack_require__(42668), module.exports);
const baseViews = (0, import_getBaseViews.getBaseViews)();
(0, import_web.setupHooks)({
  getBaseViews: import_getBaseViews.getBaseViews,
  usePropsTransform(elementType, propsIn, stateRef, willHydrate) {
    {
      const isDOM = typeof elementType == "string", {
        // event props
        onMoveShouldSetResponder,
        onMoveShouldSetResponderCapture,
        onResponderEnd,
        onResponderGrant,
        onResponderMove,
        onResponderReject,
        onResponderRelease,
        onResponderStart,
        onResponderTerminate,
        onResponderTerminationRequest,
        onScrollShouldSetResponder,
        onScrollShouldSetResponderCapture,
        onSelectionChangeShouldSetResponder,
        onSelectionChangeShouldSetResponderCapture,
        onStartShouldSetResponder,
        onStartShouldSetResponderCapture,
        // android
        collapsable,
        focusable,
        // deprecated,
        accessible,
        accessibilityDisabled,
        onLayout,
        hrefAttrs,
        ...plainDOMProps
      } = propsIn;
      if (willHydrate || isDOM) {
        const hostRef = import_react.default.useMemo(
          () => ({
            get current() {
              return stateRef.current.host;
            }
          }),
          [stateRef]
        );
        (0, import_usePlatformMethods.usePlatformMethods)(hostRef), (0, import_useElementLayout.useElementLayout)(hostRef, isDOM ? onLayout : void 0), (0, import_react_native_use_responder_events.useResponderEvents)(
          hostRef,
          isDOM ? {
            onMoveShouldSetResponder,
            onMoveShouldSetResponderCapture,
            onResponderEnd,
            onResponderGrant,
            onResponderMove,
            onResponderReject,
            onResponderRelease,
            onResponderStart,
            onResponderTerminate,
            onResponderTerminationRequest,
            onScrollShouldSetResponder,
            onScrollShouldSetResponderCapture,
            onSelectionChangeShouldSetResponder,
            onSelectionChangeShouldSetResponderCapture,
            onStartShouldSetResponder,
            onStartShouldSetResponderCapture
          } : void 0
        );
      }
      if (isDOM) {
        if (plainDOMProps.href && hrefAttrs) {
          const { download, rel, target } = hrefAttrs;
          download != null && (plainDOMProps.download = download), rel && (plainDOMProps.rel = rel), typeof target == "string" && (plainDOMProps.target = target.charAt(0) !== "_" ? `_${target}` : target);
        }
        return plainDOMProps;
      }
    }
  },
  useEvents(viewProps, events, { pseudos }, setStateShallow, staticConfig) {
  }
});
const View = import_web.View, Stack = import_web.Stack, Text = import_web.Text;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 42668:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var reactNativeTypes_exports = {};
module.exports = __toCommonJS(reactNativeTypes_exports);
//# sourceMappingURL=reactNativeTypes.js.map


/***/ }),

/***/ 5468:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var Pressability_exports = {};
__export(Pressability_exports, {
  Pressability: () => Pressability,
  usePressability: () => usePressability
});
module.exports = __toCommonJS(Pressability_exports);
const Pressability = {}, usePressability = (e) => ({});
//# sourceMappingURL=Pressability.js.map


/***/ }),

/***/ 35833:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var clamp_exports = {};
__export(clamp_exports, {
  clamp: () => clamp
});
module.exports = __toCommonJS(clamp_exports);
function clamp(value, [min, max]) {
  return Math.min(max, Math.max(min, value));
}
//# sourceMappingURL=clamp.js.map


/***/ }),

/***/ 83608:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var composeEventHandlers_exports = {};
__export(composeEventHandlers_exports, {
  composeEventHandlers: () => composeEventHandlers
});
module.exports = __toCommonJS(composeEventHandlers_exports);
function composeEventHandlers(og, next, { checkDefaultPrevented = !0 } = {}) {
  return !og || !next ? next || og || void 0 : (event) => {
    if (og?.(event), !event || !(checkDefaultPrevented && "defaultPrevented" in event) || // @ts-ignore
    "defaultPrevented" in event && !event.defaultPrevented)
      return next?.(event);
  };
}
//# sourceMappingURL=composeEventHandlers.js.map


/***/ }),

/***/ 26039:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var concatClassName_exports = {};
__export(concatClassName_exports, {
  concatClassName: () => concatClassName
});
module.exports = __toCommonJS(concatClassName_exports);
function concatClassName(_cn) {
  const args = arguments, usedPrefixes = [];
  let final = "";
  const len = args.length;
  let propObjects = null;
  for (let x = len; x >= 0; x--) {
    const cns = args[x];
    if (!cns) continue;
    if (!Array.isArray(cns) && typeof cns != "string") {
      propObjects = propObjects || [], propObjects.push(cns);
      continue;
    }
    const names = Array.isArray(cns) ? cns : cns.split(" "), numNames = names.length;
    for (let i = numNames - 1; i >= 0; i--) {
      const name = names[i];
      if (!name || name === " ") continue;
      if (name[0] !== "_") {
        final = name + " " + final;
        continue;
      }
      const splitIndex = name.indexOf("-");
      if (splitIndex < 1) {
        final = name + " " + final;
        continue;
      }
      const isMediaQuery = name[splitIndex + 1] === "_", styleKey = name.slice(1, name.lastIndexOf("-")), mediaKey = isMediaQuery ? name.slice(splitIndex + 2, splitIndex + 7) : null, uid = mediaKey ? styleKey + mediaKey : styleKey;
      if (usedPrefixes.indexOf(uid) > -1)
        continue;
      usedPrefixes.push(uid);
      const propName = styleKey;
      propName && propObjects && propObjects.some((po) => {
        if (mediaKey) {
          const propKey = pseudoInvert[mediaKey];
          return po && po[propKey] && propName in po[propKey] && po[propKey] !== null;
        }
        return po && propName in po && po[propName] !== null;
      }) || (final = name + " " + final);
    }
  }
  return final;
}
const pseudoInvert = {
  hover: "hoverStyle",
  focus: "focusStyle",
  press: "pressStyle",
  focusVisible: "focusVisibleStyle",
  disabled: "disabledStyle"
};
//# sourceMappingURL=concatClassName.js.map


/***/ }),

/***/ 37513:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
}, __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var src_exports = {};
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(14837), module.exports);
__reExport(src_exports, __webpack_require__(35833), module.exports);
__reExport(src_exports, __webpack_require__(83608), module.exports);
__reExport(src_exports, __webpack_require__(26039), module.exports);
__reExport(src_exports, __webpack_require__(42234), module.exports);
__reExport(src_exports, __webpack_require__(19108), module.exports);
__reExport(src_exports, __webpack_require__(13531), module.exports);
__reExport(src_exports, __webpack_require__(54881), module.exports);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 19108:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var shouldRenderNativePlatform_exports = {};
__export(shouldRenderNativePlatform_exports, {
  shouldRenderNativePlatform: () => shouldRenderNativePlatform
});
module.exports = __toCommonJS(shouldRenderNativePlatform_exports);
var import_constants = __webpack_require__(14810);
const ALL_PLATFORMS = ["web", "android", "ios"];
function shouldRenderNativePlatform(nativeProp) {
  if (!nativeProp)
    return null;
  const userRequestedPlatforms = resolvePlatformNames(nativeProp);
  for (const platform of ALL_PLATFORMS)
    if (platform === import_constants.currentPlatform && userRequestedPlatforms.has(platform))
      return platform;
  return null;
}
function resolvePlatformNames(nativeProp) {
  const platforms = nativeProp === !0 ? ALL_PLATFORMS : nativeProp === !1 ? [] : Array.isArray(nativeProp) ? nativeProp : [nativeProp], set = new Set(platforms);
  return set.has("mobile") && (set.add("android"), set.add("ios"), set.delete("mobile")), set;
}
//# sourceMappingURL=shouldRenderNativePlatform.js.map


/***/ }),

/***/ 42234:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var types_exports = {};
__export(types_exports, {
  StyleObjectIdentifier: () => StyleObjectIdentifier,
  StyleObjectProperty: () => StyleObjectProperty,
  StyleObjectPseudo: () => StyleObjectPseudo,
  StyleObjectRules: () => StyleObjectRules,
  StyleObjectValue: () => StyleObjectValue
});
module.exports = __toCommonJS(types_exports);
const StyleObjectProperty = 0, StyleObjectValue = 1, StyleObjectIdentifier = 2, StyleObjectPseudo = 3, StyleObjectRules = 4;
//# sourceMappingURL=types.js.map


/***/ }),

/***/ 13531:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var validStyleProps_exports = {};
__export(validStyleProps_exports, {
  stylePropsAll: () => stylePropsAll,
  stylePropsFont: () => stylePropsFont,
  stylePropsText: () => stylePropsText,
  stylePropsTextOnly: () => stylePropsTextOnly,
  stylePropsTransform: () => stylePropsTransform,
  stylePropsUnitless: () => stylePropsUnitless,
  stylePropsView: () => stylePropsView,
  tokenCategories: () => tokenCategories,
  validPseudoKeys: () => validPseudoKeys,
  validStyles: () => validStyles
});
module.exports = __toCommonJS(validStyleProps_exports);
var import_constants = __webpack_require__(14810);
const textColors = {
  color: !0,
  textDecorationColor: !0,
  textShadowColor: !0
}, tokenCategories = {
  radius: {
    borderRadius: !0,
    borderTopLeftRadius: !0,
    borderTopRightRadius: !0,
    borderBottomLeftRadius: !0,
    borderBottomRightRadius: !0,
    // logical
    borderStartStartRadius: !0,
    borderStartEndRadius: !0,
    borderEndStartRadius: !0,
    borderEndEndRadius: !0
  },
  size: {
    width: !0,
    height: !0,
    minWidth: !0,
    minHeight: !0,
    maxWidth: !0,
    maxHeight: !0,
    blockSize: !0,
    minBlockSize: !0,
    maxBlockSize: !0,
    inlineSize: !0,
    minInlineSize: !0,
    maxInlineSize: !0
  },
  zIndex: {
    zIndex: !0
  },
  color: {
    backgroundColor: !0,
    borderColor: !0,
    borderBlockStartColor: !0,
    borderBlockEndColor: !0,
    borderBlockColor: !0,
    borderBottomColor: !0,
    borderInlineColor: !0,
    borderInlineStartColor: !0,
    borderInlineEndColor: !0,
    borderTopColor: !0,
    borderLeftColor: !0,
    borderRightColor: !0,
    borderEndColor: !0,
    borderStartColor: !0,
    shadowColor: !0,
    ...textColors,
    outlineColor: !0,
    caretColor: !0
  }
}, stylePropsUnitless = {
  WebkitLineClamp: !0,
  animationIterationCount: !0,
  aspectRatio: !0,
  borderImageOutset: !0,
  borderImageSlice: !0,
  borderImageWidth: !0,
  columnCount: !0,
  flex: !0,
  flexGrow: !0,
  flexOrder: !0,
  flexPositive: !0,
  flexShrink: !0,
  flexNegative: !0,
  fontWeight: !0,
  gridRow: !0,
  gridRowEnd: !0,
  gridRowGap: !0,
  gridRowStart: !0,
  gridColumn: !0,
  gridColumnEnd: !0,
  gridColumnGap: !0,
  gridColumnStart: !0,
  gridTemplateColumns: !0,
  gridTemplateAreas: !0,
  lineClamp: !0,
  opacity: !0,
  order: !0,
  orphans: !0,
  tabSize: !0,
  widows: !0,
  zIndex: !0,
  zoom: !0,
  scale: !0,
  scaleX: !0,
  scaleY: !0,
  scaleZ: !0,
  shadowOpacity: !0
}, stylePropsTransform = {
  x: !0,
  y: !0,
  scale: !0,
  perspective: !0,
  scaleX: !0,
  scaleY: !0,
  skewX: !0,
  skewY: !0,
  matrix: !0,
  rotate: !0,
  rotateY: !0,
  rotateX: !0,
  rotateZ: !0
}, stylePropsView = {
  backfaceVisibility: !0,
  borderBottomEndRadius: !0,
  borderBottomStartRadius: !0,
  borderBottomWidth: !0,
  borderLeftWidth: !0,
  borderRightWidth: !0,
  borderBlockWidth: !0,
  borderBlockEndWidth: !0,
  borderBlockStartWidth: !0,
  borderInlineWidth: !0,
  borderInlineEndWidth: !0,
  borderInlineStartWidth: !0,
  borderStyle: !0,
  borderBlockStyle: !0,
  borderBlockEndStyle: !0,
  borderBlockStartStyle: !0,
  borderInlineStyle: !0,
  borderInlineEndStyle: !0,
  borderInlineStartStyle: !0,
  borderTopEndRadius: !0,
  borderTopStartRadius: !0,
  borderTopWidth: !0,
  borderWidth: !0,
  transform: !0,
  transformOrigin: !0,
  alignContent: !0,
  alignItems: !0,
  alignSelf: !0,
  borderEndWidth: !0,
  borderStartWidth: !0,
  bottom: !0,
  display: !0,
  end: !0,
  flexBasis: !0,
  flexDirection: !0,
  flexWrap: !0,
  gap: !0,
  columnGap: !0,
  rowGap: !0,
  justifyContent: !0,
  left: !0,
  margin: !0,
  marginBlock: !0,
  marginBlockEnd: !0,
  marginBlockStart: !0,
  marginInline: !0,
  marginInlineStart: !0,
  marginInlineEnd: !0,
  marginBottom: !0,
  marginEnd: !0,
  marginHorizontal: !0,
  marginLeft: !0,
  marginRight: !0,
  marginStart: !0,
  marginTop: !0,
  marginVertical: !0,
  overflow: !0,
  padding: !0,
  paddingBottom: !0,
  paddingInline: !0,
  paddingBlock: !0,
  paddingBlockStart: !0,
  paddingInlineEnd: !0,
  paddingInlineStart: !0,
  paddingEnd: !0,
  paddingHorizontal: !0,
  paddingLeft: !0,
  paddingRight: !0,
  paddingStart: !0,
  paddingTop: !0,
  paddingVertical: !0,
  position: !0,
  right: !0,
  start: !0,
  top: !0,
  inset: !0,
  insetBlock: !0,
  insetBlockEnd: !0,
  insetBlockStart: !0,
  insetInline: !0,
  insetInlineEnd: !0,
  insetInlineStart: !0,
  direction: !0,
  shadowOffset: !0,
  shadowRadius: !0,
  ...tokenCategories.color,
  ...tokenCategories.radius,
  ...tokenCategories.size,
  ...tokenCategories.radius,
  ...stylePropsTransform,
  ...stylePropsUnitless,
  // RN doesn't support specific border styles per-edge
  transition: !0,
  textWrap: !0,
  backdropFilter: !0,
  background: !0,
  backgroundAttachment: !0,
  backgroundBlendMode: !0,
  backgroundClip: !0,
  backgroundColor: !0,
  backgroundImage: !0,
  backgroundOrigin: !0,
  backgroundPosition: !0,
  backgroundRepeat: !0,
  backgroundSize: !0,
  borderBottomStyle: !0,
  borderImage: !0,
  borderLeftStyle: !0,
  borderRightStyle: !0,
  borderTopStyle: !0,
  boxShadow: !0,
  boxSizing: !0,
  caretColor: !0,
  clipPath: !0,
  contain: !0,
  containerType: !0,
  content: !0,
  cursor: !0,
  filter: !0,
  float: !0,
  mask: !0,
  maskBorder: !0,
  maskBorderMode: !0,
  maskBorderOutset: !0,
  maskBorderRepeat: !0,
  maskBorderSlice: !0,
  maskBorderSource: !0,
  maskBorderWidth: !0,
  maskClip: !0,
  maskComposite: !0,
  maskImage: !0,
  maskMode: !0,
  maskOrigin: !0,
  maskPosition: !0,
  maskRepeat: !0,
  maskSize: !0,
  maskType: !0,
  mixBlendMode: !0,
  objectFit: !0,
  objectPosition: !0,
  outlineOffset: !0,
  outlineStyle: !0,
  outlineWidth: !0,
  overflowBlock: !0,
  overflowInline: !0,
  overflowX: !0,
  overflowY: !0,
  pointerEvents: !0,
  scrollbarWidth: !0,
  textEmphasis: !0,
  touchAction: !0,
  transformStyle: !0,
  userSelect: !0,
  ...import_constants.isAndroid ? { elevationAndroid: !0 } : {}
}, stylePropsFont = {
  fontFamily: !0,
  fontSize: !0,
  fontStyle: !0,
  fontWeight: !0,
  letterSpacing: !0,
  lineHeight: !0,
  textTransform: !0
}, stylePropsTextOnly = {
  ...stylePropsFont,
  textAlign: !0,
  textDecorationLine: !0,
  textDecorationStyle: !0,
  ...textColors,
  textShadowOffset: !0,
  textShadowRadius: !0,
  userSelect: !0,
  selectable: !0,
  verticalAlign: !0,
  whiteSpace: !0,
  wordWrap: !0,
  textOverflow: !0,
  textDecorationDistance: !0,
  cursor: !0,
  WebkitLineClamp: !0,
  WebkitBoxOrient: !0
}, stylePropsText = {
  ...stylePropsView,
  ...stylePropsTextOnly
}, stylePropsAll = stylePropsText, validPseudoKeys = {
  enterStyle: !0,
  exitStyle: !0,
  hoverStyle: !0,
  pressStyle: !0,
  focusStyle: !0,
  disabledStyle: !0,
  focusVisibleStyle: !0
}, validStyles = {
  ...validPseudoKeys,
  ...stylePropsView
};
//# sourceMappingURL=validStyleProps.js.map


/***/ }),

/***/ 54881:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var withStaticProperties_exports = {};
__export(withStaticProperties_exports, {
  withStaticProperties: () => withStaticProperties
});
module.exports = __toCommonJS(withStaticProperties_exports);
var import_react = __toESM(__webpack_require__(67294));
const Decorated = Symbol(), withStaticProperties = (component, staticProps) => {
  const next = (() => {
    if (component[Decorated]) {
      const _ = import_react.default.forwardRef(
        (props, ref) => import_react.default.createElement(component, { ...props, ref })
      );
      for (const key in component) {
        const v = component[key];
        _[key] = v && typeof v == "object" ? { ...v } : v;
      }
    }
    return component;
  })();
  return Object.assign(next, staticProps), next[Decorated] = !0, next;
};
//# sourceMappingURL=withStaticProperties.js.map


/***/ }),

/***/ 17285:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var src_exports = {};
__export(src_exports, {
  default: () => src_default,
  normalizeCSSColor: () => normalizeCSSColor,
  rgba: () => rgba
});
module.exports = __toCommonJS(src_exports);
var normalizeColor = __toESM(__webpack_require__(4586));
const norm = normalizeColor.default || normalizeColor, normalizeCSSColor = norm;
function rgba(colorInt) {
  const r = Math.round((colorInt & 4278190080) >>> 24), g = Math.round((colorInt & 16711680) >>> 16), b = Math.round((colorInt & 65280) >>> 8), a = ((colorInt & 255) >>> 0) / 255;
  return {
    r,
    g,
    b,
    a
  };
}
var src_default = normalizeCSSColor;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 65190:
/***/ (function() {

if (typeof globalThis['__DEV__'] === 'undefined') {
  globalThis['__DEV__'] = "production" === 'development'
}


/***/ }),

/***/ 77379:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var ResponderSystem_exports = {};
__export(ResponderSystem_exports, {
  addNode: () => addNode,
  attachListeners: () => attachListeners,
  getResponderNode: () => getResponderNode,
  removeNode: () => removeNode,
  terminateResponder: () => terminateResponder
});
module.exports = __toCommonJS(ResponderSystem_exports);
var import_createResponderEvent = __toESM(__webpack_require__(38278)), import_ResponderTouchHistoryStore = __webpack_require__(59512), import_types = __webpack_require__(10529), import_utils = __webpack_require__(32222), import_utils2 = __webpack_require__(32222);
const emptyObject = {}, startRegistration = [
  "onStartShouldSetResponderCapture",
  "onStartShouldSetResponder",
  { bubbles: !0 }
], moveRegistration = [
  "onMoveShouldSetResponderCapture",
  "onMoveShouldSetResponder",
  { bubbles: !0 }
], scrollRegistration = [
  "onScrollShouldSetResponderCapture",
  "onScrollShouldSetResponder",
  { bubbles: !1 }
], shouldSetResponderEvents = {
  touchstart: startRegistration,
  mousedown: startRegistration,
  touchmove: moveRegistration,
  mousemove: moveRegistration,
  scroll: scrollRegistration
}, emptyResponder = { id: null, idPath: null, node: null }, responderListenersMap = /* @__PURE__ */ new Map();
let isEmulatingMouseEvents = !1, trackedTouchCount = 0, currentResponder = {
  id: null,
  node: null,
  idPath: null
};
const responderTouchHistoryStore = new import_ResponderTouchHistoryStore.ResponderTouchHistoryStore();
function changeCurrentResponder(responder) {
  currentResponder = responder;
}
function getResponderConfig(id) {
  const config = responderListenersMap.get(id);
  return config ?? emptyObject;
}
function eventListener(domEvent) {
  const eventType = domEvent.type, eventTarget = domEvent.target;
  if (eventType === "touchstart" && (isEmulatingMouseEvents = !0), (eventType === "touchmove" || trackedTouchCount > 1) && (isEmulatingMouseEvents = !1), // Ignore browser emulated mouse events
  eventType === "mousedown" && isEmulatingMouseEvents || eventType === "mousemove" && isEmulatingMouseEvents || // Ignore mousemove if a mousedown didn't occur first
  eventType === "mousemove" && trackedTouchCount < 1)
    return;
  if (isEmulatingMouseEvents && eventType === "mouseup") {
    trackedTouchCount === 0 && (isEmulatingMouseEvents = !1);
    return;
  }
  const isStartEvent = (0, import_types.isStartish)(eventType) && (0, import_utils2.isPrimaryPointerDown)(domEvent), isMoveEvent = (0, import_types.isMoveish)(eventType), isEndEvent = (0, import_types.isEndish)(eventType), isScrollEvent = (0, import_types.isScroll)(eventType), isSelectionChangeEvent = (0, import_types.isSelectionChange)(eventType), responderEvent = (0, import_createResponderEvent.default)(domEvent, responderTouchHistoryStore);
  (isStartEvent || isMoveEvent || isEndEvent) && (domEvent.touches ? trackedTouchCount = domEvent.touches.length : isStartEvent ? trackedTouchCount = 1 : isEndEvent && (trackedTouchCount = 0), responderTouchHistoryStore.recordTouchTrack(
    eventType,
    responderEvent.nativeEvent
  ));
  let eventPaths = (0, import_utils2.getResponderPaths)(domEvent), wasNegotiated = !1, wantsResponder;
  if (isStartEvent || isMoveEvent || isScrollEvent && trackedTouchCount > 0) {
    const currentResponderIdPath = currentResponder.idPath, eventIdPath = eventPaths.idPath;
    if (currentResponderIdPath != null && eventIdPath != null) {
      const lowestCommonAncestor = (0, import_utils2.getLowestCommonAncestor)(
        currentResponderIdPath,
        eventIdPath
      );
      if (lowestCommonAncestor != null) {
        const index = eventIdPath.indexOf(lowestCommonAncestor) + (lowestCommonAncestor === currentResponder.id ? 1 : 0);
        eventPaths = {
          idPath: eventIdPath.slice(index),
          nodePath: eventPaths.nodePath.slice(index)
        };
      } else
        eventPaths = null;
    }
    eventPaths != null && (wantsResponder = findWantsResponder(eventPaths, domEvent, responderEvent), wantsResponder != null && (attemptTransfer(responderEvent, wantsResponder), wasNegotiated = !0));
  }
  if (currentResponder.id != null && currentResponder.node != null) {
    const { id, node } = currentResponder, {
      onResponderStart,
      onResponderMove,
      onResponderEnd,
      onResponderRelease,
      onResponderTerminate,
      onResponderTerminationRequest
    } = getResponderConfig(id);
    if (responderEvent.bubbles = !1, responderEvent.cancelable = !1, responderEvent.currentTarget = node, isStartEvent)
      onResponderStart != null && (responderEvent.dispatchConfig.registrationName = "onResponderStart", onResponderStart(responderEvent));
    else if (isMoveEvent)
      onResponderMove != null && (responderEvent.dispatchConfig.registrationName = "onResponderMove", onResponderMove(responderEvent));
    else {
      const isTerminateEvent = (0, import_types.isCancelish)(eventType) || // native context menu
      eventType === "contextmenu" || // window blur
      eventType === "blur" && eventTarget === window || // responder (or ancestors) blur
      eventType === "blur" && eventTarget.contains(node) && domEvent.relatedTarget !== node || // native scroll without using a pointer
      isScrollEvent && trackedTouchCount === 0 || // native scroll on node that is parent of the responder (allow siblings to scroll)
      isScrollEvent && eventTarget.contains(node) && eventTarget !== node || // native select/selectionchange on node
      isSelectionChangeEvent && (0, import_utils2.hasValidSelection)(domEvent), isReleaseEvent = isEndEvent && !isTerminateEvent && !(0, import_utils2.hasTargetTouches)(node, domEvent.touches);
      if (isEndEvent && onResponderEnd != null && (responderEvent.dispatchConfig.registrationName = "onResponderEnd", onResponderEnd(responderEvent)), isReleaseEvent && (onResponderRelease != null && (responderEvent.dispatchConfig.registrationName = "onResponderRelease", onResponderRelease(responderEvent)), changeCurrentResponder(emptyResponder)), isTerminateEvent) {
        let shouldTerminate = !0;
        (eventType === "contextmenu" || eventType === "scroll" || eventType === "selectionchange") && (wasNegotiated ? shouldTerminate = !1 : onResponderTerminationRequest != null && (responderEvent.dispatchConfig.registrationName = "onResponderTerminationRequest", onResponderTerminationRequest(responderEvent) === !1 && (shouldTerminate = !1))), shouldTerminate && (onResponderTerminate != null && (responderEvent.dispatchConfig.registrationName = "onResponderTerminate", onResponderTerminate(responderEvent)), changeCurrentResponder(emptyResponder), isEmulatingMouseEvents = !1, trackedTouchCount = 0);
      }
    }
  }
}
function findWantsResponder(eventPaths, domEvent, responderEvent) {
  const shouldSetCallbacks = shouldSetResponderEvents[domEvent.type];
  if (shouldSetCallbacks != null) {
    const { idPath, nodePath } = eventPaths, shouldSetCallbackCaptureName = shouldSetCallbacks[0], shouldSetCallbackBubbleName = shouldSetCallbacks[1], { bubbles } = shouldSetCallbacks[2], check = (id, node, callbackName) => {
      const shouldSetCallback = getResponderConfig(id)[callbackName];
      if (shouldSetCallback != null && (responderEvent.currentTarget = node, shouldSetCallback(responderEvent) === !0)) {
        const prunedIdPath = idPath.slice(idPath.indexOf(id));
        return { id, node, idPath: prunedIdPath };
      }
    };
    for (let i = idPath.length - 1; i >= 0; i--) {
      const id = idPath[i], node = nodePath[i], result = check(id, node, shouldSetCallbackCaptureName);
      if (result != null)
        return result;
      if (responderEvent.isPropagationStopped() === !0)
        return;
    }
    if (bubbles)
      for (let i = 0; i < idPath.length; i++) {
        const id = idPath[i], node = nodePath[i], result = check(id, node, shouldSetCallbackBubbleName);
        if (result != null)
          return result;
        if (responderEvent.isPropagationStopped() === !0)
          return;
      }
    else {
      const id = idPath[0], node = nodePath[0];
      if (domEvent.target === node)
        return check(id, node, shouldSetCallbackBubbleName);
    }
  }
}
function attemptTransfer(responderEvent, wantsResponder) {
  const { id: currentId, node: currentNode } = currentResponder, { id, node } = wantsResponder, { onResponderGrant, onResponderReject } = getResponderConfig(id);
  if (responderEvent.bubbles = !1, responderEvent.cancelable = !1, responderEvent.currentTarget = node, currentId == null)
    onResponderGrant != null && (responderEvent.currentTarget = node, responderEvent.dispatchConfig.registrationName = "onResponderGrant", onResponderGrant(responderEvent)), changeCurrentResponder(wantsResponder);
  else {
    const { onResponderTerminate, onResponderTerminationRequest } = getResponderConfig(currentId);
    let allowTransfer = !0;
    onResponderTerminationRequest != null && (responderEvent.currentTarget = currentNode, responderEvent.dispatchConfig.registrationName = "onResponderTerminationRequest", onResponderTerminationRequest(responderEvent) === !1 && (allowTransfer = !1)), allowTransfer ? (onResponderTerminate != null && (responderEvent.currentTarget = currentNode, responderEvent.dispatchConfig.registrationName = "onResponderTerminate", onResponderTerminate(responderEvent)), onResponderGrant != null && (responderEvent.currentTarget = node, responderEvent.dispatchConfig.registrationName = "onResponderGrant", onResponderGrant(responderEvent)), changeCurrentResponder(wantsResponder)) : onResponderReject != null && (responderEvent.currentTarget = node, responderEvent.dispatchConfig.registrationName = "onResponderReject", onResponderReject(responderEvent));
  }
}
const documentEventsCapturePhase = ["blur", "scroll"], documentEventsBubblePhase = [
  // mouse
  "mousedown",
  "mousemove",
  "mouseup",
  "dragstart",
  // touch
  "touchstart",
  "touchmove",
  "touchend",
  "touchcancel",
  // other
  "contextmenu",
  "select",
  "selectionchange"
], isTamaguiResponderActive = Symbol();
function attachListeners() {
  import_utils.canUseDOM && !window[isTamaguiResponderActive] && (window.addEventListener("blur", eventListener), documentEventsBubblePhase.forEach((eventType) => {
    document.addEventListener(eventType, eventListener);
  }), documentEventsCapturePhase.forEach((eventType) => {
    document.addEventListener(eventType, eventListener, !0);
  }), window[isTamaguiResponderActive] = !0);
}
function addNode(id, node, config) {
  (0, import_utils2.setResponderId)(node, id), responderListenersMap.set(id, config);
}
function removeNode(id) {
  currentResponder.id === id && terminateResponder(), responderListenersMap.has(id) && responderListenersMap.delete(id);
}
function terminateResponder() {
  const { id, node } = currentResponder;
  if (id != null && node != null) {
    const { onResponderTerminate } = getResponderConfig(id);
    if (onResponderTerminate != null) {
      const event = (0, import_createResponderEvent.default)({}, responderTouchHistoryStore);
      event.currentTarget = node, onResponderTerminate(event);
    }
    changeCurrentResponder(emptyResponder);
  }
  isEmulatingMouseEvents = !1, trackedTouchCount = 0;
}
function getResponderNode() {
  return currentResponder.node;
}
//# sourceMappingURL=ResponderSystem.js.map


/***/ }),

/***/ 59512:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var ResponderTouchHistoryStore_exports = {};
__export(ResponderTouchHistoryStore_exports, {
  ResponderTouchHistoryStore: () => ResponderTouchHistoryStore
});
module.exports = __toCommonJS(ResponderTouchHistoryStore_exports);
var import_types = __webpack_require__(10529);
class ResponderTouchHistoryStore {
  _touchHistory = {
    touchBank: [],
    //Array<TouchRecord>
    numberActiveTouches: 0,
    // If there is only one active touch, we remember its location. This prevents
    // us having to loop through all of the touches all the time in the most
    // common case.
    indexOfSingleActiveTouch: -1,
    mostRecentTimeStamp: 0
  };
  recordTouchTrack(topLevelType, nativeEvent) {
    const touchHistory = this._touchHistory;
    if ((0, import_types.isMoveish)(topLevelType))
      nativeEvent.changedTouches.forEach((touch) => recordTouchMove(touch, touchHistory));
    else if ((0, import_types.isStartish)(topLevelType))
      nativeEvent.changedTouches.forEach((touch) => recordTouchStart(touch, touchHistory)), touchHistory.numberActiveTouches = nativeEvent.touches.length, touchHistory.numberActiveTouches === 1 && (touchHistory.indexOfSingleActiveTouch = nativeEvent.touches[0].identifier);
    else if ((0, import_types.isEndish)(topLevelType) && (nativeEvent.changedTouches.forEach((touch) => recordTouchEnd(touch, touchHistory)), touchHistory.numberActiveTouches = nativeEvent.touches.length, touchHistory.numberActiveTouches === 1)) {
      const { touchBank } = touchHistory;
      for (let i = 0; i < touchBank.length; i++)
        if (touchBank[i]?.touchActive) {
          touchHistory.indexOfSingleActiveTouch = i;
          break;
        }
       false && (0);
    }
  }
  get touchHistory() {
    return this._touchHistory;
  }
}
const MAX_TOUCH_BANK = 20;
function timestampForTouch(touch) {
  return touch.timeStamp || touch.timestamp;
}
function createTouchRecord(touch) {
  return {
    touchActive: !0,
    startPageX: touch.pageX,
    startPageY: touch.pageY,
    startTimeStamp: timestampForTouch(touch),
    currentPageX: touch.pageX,
    currentPageY: touch.pageY,
    currentTimeStamp: timestampForTouch(touch),
    previousPageX: touch.pageX,
    previousPageY: touch.pageY,
    previousTimeStamp: timestampForTouch(touch)
  };
}
function resetTouchRecord(touchRecord, touch) {
  touchRecord.touchActive = !0, touchRecord.startPageX = touch.pageX, touchRecord.startPageY = touch.pageY, touchRecord.startTimeStamp = timestampForTouch(touch), touchRecord.currentPageX = touch.pageX, touchRecord.currentPageY = touch.pageY, touchRecord.currentTimeStamp = timestampForTouch(touch), touchRecord.previousPageX = touch.pageX, touchRecord.previousPageY = touch.pageY, touchRecord.previousTimeStamp = timestampForTouch(touch);
}
function getTouchIdentifier({ identifier }) {
  return identifier == null && console.error("Touch object is missing identifier."),  false && 0, identifier;
}
function recordTouchStart(touch, touchHistory) {
  const identifier = getTouchIdentifier(touch), touchRecord = touchHistory.touchBank[identifier];
  touchRecord ? resetTouchRecord(touchRecord, touch) : touchHistory.touchBank[identifier] = createTouchRecord(touch), touchHistory.mostRecentTimeStamp = timestampForTouch(touch);
}
function recordTouchMove(touch, touchHistory) {
  const touchRecord = touchHistory.touchBank[getTouchIdentifier(touch)];
  touchRecord ? (touchRecord.touchActive = !0, touchRecord.previousPageX = touchRecord.currentPageX, touchRecord.previousPageY = touchRecord.currentPageY, touchRecord.previousTimeStamp = touchRecord.currentTimeStamp, touchRecord.currentPageX = touch.pageX, touchRecord.currentPageY = touch.pageY, touchRecord.currentTimeStamp = timestampForTouch(touch), touchHistory.mostRecentTimeStamp = timestampForTouch(touch)) : console.warn(
    `Cannot record touch move without a touch start.
`,
    `Touch Move: ${printTouch(touch)}
`,
    `Touch Bank: ${printTouchBank(touchHistory)}`
  );
}
function recordTouchEnd(touch, touchHistory) {
  const touchRecord = touchHistory.touchBank[getTouchIdentifier(touch)];
  touchRecord ? (touchRecord.touchActive = !1, touchRecord.previousPageX = touchRecord.currentPageX, touchRecord.previousPageY = touchRecord.currentPageY, touchRecord.previousTimeStamp = touchRecord.currentTimeStamp, touchRecord.currentPageX = touch.pageX, touchRecord.currentPageY = touch.pageY, touchRecord.currentTimeStamp = timestampForTouch(touch), touchHistory.mostRecentTimeStamp = timestampForTouch(touch)) : console.warn(
    `Cannot record touch end without a touch start.
`,
    `Touch End: ${printTouch(touch)}
`,
    `Touch Bank: ${printTouchBank(touchHistory)}`
  );
}
function printTouch(touch) {
  return JSON.stringify({
    identifier: touch.identifier,
    pageX: touch.pageX,
    pageY: touch.pageY,
    timestamp: timestampForTouch(touch)
  });
}
function printTouchBank(touchHistory) {
  const { touchBank } = touchHistory;
  let printed = JSON.stringify(touchBank.slice(0, MAX_TOUCH_BANK));
  return touchBank.length > MAX_TOUCH_BANK && (printed += ` (original size: ${touchBank.length})`), printed;
}
//# sourceMappingURL=ResponderTouchHistoryStore.js.map


/***/ }),

/***/ 38278:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var createResponderEvent_exports = {};
__export(createResponderEvent_exports, {
  default: () => createResponderEvent
});
module.exports = __toCommonJS(createResponderEvent_exports);
var import_utils = __webpack_require__(32222);
const emptyFunction = () => {
}, emptyObject = {}, emptyArray = [];
function normalizeIdentifier(identifier) {
  return identifier > 20 ? identifier % 20 : identifier;
}
function createResponderEvent(domEvent, responderTouchHistoryStore) {
  let rect, propagationWasStopped = !1, changedTouches, touches;
  const domEventChangedTouches = domEvent.changedTouches, domEventType = domEvent.type, metaKey = domEvent.metaKey === !0, shiftKey = domEvent.shiftKey === !0, force = domEventChangedTouches?.[0].force || 0, identifier = normalizeIdentifier(domEventChangedTouches?.[0].identifier || 0), clientX = domEventChangedTouches?.[0].clientX || domEvent.clientX, clientY = domEventChangedTouches?.[0].clientY || domEvent.clientY, pageX = domEventChangedTouches?.[0].pageX || domEvent.pageX, pageY = domEventChangedTouches?.[0].pageY || domEvent.pageY, preventDefault = typeof domEvent.preventDefault == "function" ? domEvent.preventDefault.bind(domEvent) : emptyFunction, timestamp = domEvent.timeStamp;
  function normalizeTouches(touches2) {
    return Array.prototype.slice.call(touches2).map((touch) => ({
      force: touch.force,
      identifier: normalizeIdentifier(touch.identifier),
      get locationX() {
        return locationX(touch.clientX);
      },
      get locationY() {
        return locationY(touch.clientY);
      },
      pageX: touch.pageX,
      pageY: touch.pageY,
      target: touch.target,
      timestamp
    }));
  }
  if (domEventChangedTouches != null)
    changedTouches = normalizeTouches(domEventChangedTouches), touches = normalizeTouches(domEvent.touches);
  else {
    const emulatedTouches = [
      {
        force,
        identifier,
        get locationX() {
          return locationX(clientX);
        },
        get locationY() {
          return locationY(clientY);
        },
        pageX,
        pageY,
        target: domEvent.target,
        timestamp
      }
    ];
    changedTouches = emulatedTouches, touches = domEventType === "mouseup" || domEventType === "dragstart" ? emptyArray : emulatedTouches;
  }
  const responderEvent = {
    bubbles: !0,
    cancelable: !0,
    // `currentTarget` is set before dispatch
    currentTarget: null,
    defaultPrevented: domEvent.defaultPrevented,
    dispatchConfig: emptyObject,
    eventPhase: domEvent.eventPhase,
    isDefaultPrevented() {
      return domEvent.defaultPrevented;
    },
    isPropagationStopped() {
      return propagationWasStopped;
    },
    isTrusted: domEvent.isTrusted,
    nativeEvent: {
      altKey: !1,
      ctrlKey: !1,
      metaKey,
      shiftKey,
      changedTouches,
      force,
      identifier,
      get locationX() {
        return locationX(clientX);
      },
      get locationY() {
        return locationY(clientY);
      },
      pageX,
      pageY,
      target: domEvent.target,
      timestamp,
      touches,
      type: domEventType
    },
    persist: emptyFunction,
    preventDefault,
    stopPropagation() {
      propagationWasStopped = !0;
    },
    target: domEvent.target,
    timeStamp: timestamp,
    touchHistory: responderTouchHistoryStore.touchHistory
  };
  function locationX(x) {
    if (rect = rect || (0, import_utils.getBoundingClientRect)(responderEvent.currentTarget), rect)
      return x - rect.left;
  }
  function locationY(y) {
    if (rect = rect || (0, import_utils.getBoundingClientRect)(responderEvent.currentTarget), rect)
      return y - rect.top;
  }
  return responderEvent;
}
//# sourceMappingURL=createResponderEvent.js.map


/***/ }),

/***/ 94245:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
}, __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var src_exports = {};
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(23955), module.exports);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 10529:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var types_exports = {};
__export(types_exports, {
  BLUR: () => BLUR,
  CONTEXT_MENU: () => CONTEXT_MENU,
  FOCUS_OUT: () => FOCUS_OUT,
  MOUSE_CANCEL: () => MOUSE_CANCEL,
  MOUSE_DOWN: () => MOUSE_DOWN,
  MOUSE_MOVE: () => MOUSE_MOVE,
  MOUSE_UP: () => MOUSE_UP,
  SCROLL: () => SCROLL,
  SELECT: () => SELECT,
  SELECTION_CHANGE: () => SELECTION_CHANGE,
  TOUCH_CANCEL: () => TOUCH_CANCEL,
  TOUCH_END: () => TOUCH_END,
  TOUCH_MOVE: () => TOUCH_MOVE,
  TOUCH_START: () => TOUCH_START,
  isCancelish: () => isCancelish,
  isEndish: () => isEndish,
  isMoveish: () => isMoveish,
  isScroll: () => isScroll,
  isSelectionChange: () => isSelectionChange,
  isStartish: () => isStartish
});
module.exports = __toCommonJS(types_exports);
const BLUR = "blur", CONTEXT_MENU = "contextmenu", FOCUS_OUT = "focusout", MOUSE_DOWN = "mousedown", MOUSE_MOVE = "mousemove", MOUSE_UP = "mouseup", MOUSE_CANCEL = "dragstart", TOUCH_START = "touchstart", TOUCH_MOVE = "touchmove", TOUCH_END = "touchend", TOUCH_CANCEL = "touchcancel", SCROLL = "scroll", SELECT = "select", SELECTION_CHANGE = "selectionchange";
function isStartish(eventType) {
  return eventType === TOUCH_START || eventType === MOUSE_DOWN;
}
function isMoveish(eventType) {
  return eventType === TOUCH_MOVE || eventType === MOUSE_MOVE;
}
function isEndish(eventType) {
  return eventType === TOUCH_END || eventType === MOUSE_UP || isCancelish(eventType);
}
function isCancelish(eventType) {
  return eventType === TOUCH_CANCEL || eventType === MOUSE_CANCEL;
}
function isScroll(eventType) {
  return eventType === SCROLL;
}
function isSelectionChange(eventType) {
  return eventType === SELECT || eventType === SELECTION_CHANGE;
}
//# sourceMappingURL=types.js.map


/***/ }),

/***/ 23955:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
}, __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default")), __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var useResponderEvents_exports = {};
__export(useResponderEvents_exports, {
  useResponderEvents: () => useResponderEvents
});
module.exports = __toCommonJS(useResponderEvents_exports);
var React = __toESM(__webpack_require__(67294)), ResponderSystem = __toESM(__webpack_require__(77379));
__reExport(useResponderEvents_exports, __webpack_require__(32222), module.exports);
const emptyObject = {};
function useResponderEvents(hostRef, config = emptyObject) {
  const id = React.useId(), isAttachedRef = React.useRef(!1);
  React.useEffect(() => (ResponderSystem.attachListeners(), () => {
    ResponderSystem.removeNode(id);
  }), [id]), React.useEffect(() => {
    const {
      onMoveShouldSetResponder,
      onMoveShouldSetResponderCapture,
      onScrollShouldSetResponder,
      onScrollShouldSetResponderCapture,
      onSelectionChangeShouldSetResponder,
      onSelectionChangeShouldSetResponderCapture,
      onStartShouldSetResponder,
      onStartShouldSetResponderCapture
    } = config, requiresResponderSystem = onMoveShouldSetResponder != null || onMoveShouldSetResponderCapture != null || onScrollShouldSetResponder != null || onScrollShouldSetResponderCapture != null || onSelectionChangeShouldSetResponder != null || onSelectionChangeShouldSetResponderCapture != null || onStartShouldSetResponder != null || onStartShouldSetResponderCapture != null, node = hostRef.current;
    requiresResponderSystem ? (ResponderSystem.addNode(id, node, config), isAttachedRef.current = !0) : isAttachedRef.current && (ResponderSystem.removeNode(id), isAttachedRef.current = !1);
  }, [config, hostRef, id]),  false && (0);
}
//# sourceMappingURL=useResponderEvents.js.map


/***/ }),

/***/ 32222:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var utils_exports = {};
__export(utils_exports, {
  canUseDOM: () => canUseDOM,
  getBoundingClientRect: () => getBoundingClientRect,
  getLowestCommonAncestor: () => getLowestCommonAncestor,
  getResponderPaths: () => getResponderPaths,
  hasTargetTouches: () => hasTargetTouches,
  hasValidSelection: () => hasValidSelection,
  isPrimaryPointerDown: () => isPrimaryPointerDown,
  isSelectionValid: () => isSelectionValid,
  setResponderId: () => setResponderId
});
module.exports = __toCommonJS(utils_exports);
const keyName = "__reactResponderId", canUseDOM = !!(typeof window < "u" && window.document && window.document.createElement), getBoundingClientRect = (node) => {
  if (node && node.nodeType === 1 && node.getBoundingClientRect)
    return node.getBoundingClientRect();
};
function getEventPath(domEvent) {
  if (domEvent.type === "selectionchange") {
    const target = window.getSelection()?.anchorNode;
    return composedPathFallback(target);
  }
  return domEvent.composedPath != null ? domEvent.composedPath() : composedPathFallback(domEvent.target);
}
function composedPathFallback(target) {
  const path = [];
  for (; target != null && target !== document.body; )
    path.push(target), target = target.parentNode;
  return path;
}
function getResponderId(node) {
  return node != null ? node[keyName] : null;
}
function setResponderId(node, id) {
  node != null && (node[keyName] = id);
}
function getResponderPaths(domEvent) {
  const idPath = [], nodePath = [], eventPath = getEventPath(domEvent);
  for (let i = 0; i < eventPath.length; i++) {
    const node = eventPath[i], id = getResponderId(node);
    id != null && (idPath.push(id), nodePath.push(node));
  }
  return { idPath, nodePath };
}
function getLowestCommonAncestor(pathA, pathB) {
  let pathALength = pathA.length, pathBLength = pathB.length;
  if (
    // If either path is empty
    pathALength === 0 || pathBLength === 0 || // If the last elements aren't the same there can't be a common ancestor
    // that is connected to the responder system
    pathA[pathALength - 1] !== pathB[pathBLength - 1]
  )
    return null;
  let itemA = pathA[0], indexA = 0, itemB = pathB[0], indexB = 0;
  pathALength - pathBLength > 0 && (indexA = pathALength - pathBLength, itemA = pathA[indexA], pathALength = pathBLength), pathBLength - pathALength > 0 && (indexB = pathBLength - pathALength, itemB = pathB[indexB], pathBLength = pathALength);
  let depth = pathALength;
  for (; depth--; ) {
    if (itemA === itemB)
      return itemA;
    itemA = pathA[indexA++], itemB = pathB[indexB++];
  }
  return null;
}
function hasTargetTouches(target, touches) {
  if (!touches || touches.length === 0)
    return !1;
  for (let i = 0; i < touches.length; i++) {
    const node = touches[i].target;
    if (node != null && target.contains(node))
      return !0;
  }
  return !1;
}
function hasValidSelection(domEvent) {
  return domEvent.type === "selectionchange" ? isSelectionValid() : domEvent.type === "select";
}
function isPrimaryPointerDown(domEvent) {
  const { altKey, button, buttons, ctrlKey, type } = domEvent, isTouch = type === "touchstart" || type === "touchmove", isPrimaryMouseDown = type === "mousedown" && (button === 0 || buttons === 1), isPrimaryMouseMove = type === "mousemove" && buttons === 1, noModifiers = altKey === !1 && ctrlKey === !1;
  return !!(isTouch || isPrimaryMouseDown && noModifiers || isPrimaryMouseMove && noModifiers);
}
function isSelectionValid() {
  const selection = window.getSelection();
  if (!selection) return !1;
  const string = selection.toString(), anchorNode = selection.anchorNode, focusNode = selection.focusNode, isTextNode = anchorNode && anchorNode.nodeType === window.Node.TEXT_NODE || focusNode && focusNode.nodeType === window.Node.TEXT_NODE;
  return string.length >= 1 && string !== `
` && !!isTextNode;
}
//# sourceMappingURL=utils.js.map


/***/ }),

/***/ 14837:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var src_exports = {};
__export(src_exports, {
  simpleHash: () => simpleHash
});
module.exports = __toCommonJS(src_exports);
const cache = /* @__PURE__ */ new Map(), simpleHash = (str, hashMin = 10) => {
  if (cache.has(str))
    return cache.get(str);
  let hash = 0, valids = "", added = 0;
  const len = str.length;
  for (let i = 0; i < len; i++) {
    if (hashMin !== "strict" && added <= hashMin) {
      const char = str.charCodeAt(i);
      if (char === 46) {
        valids += "--";
        continue;
      }
      if (isValidCSSCharCode(char)) {
        added++, valids += str[i];
        continue;
      }
    }
    hash = hashChar(hash, str[i]);
  }
  const res = valids + (hash ? Math.abs(hash) : "");
  return cache.size > 1e4 && cache.clear(), cache.set(str, res), res;
}, hashChar = (hash, c) => Math.imul(31, hash) + c.charCodeAt(0) | 0;
function isValidCSSCharCode(code) {
  return (
    // A-Z
    code >= 65 && code <= 90 || // a-z
    code >= 97 && code <= 122 || // _
    code === 95 || // -
    code === 45 || // 0-9
    code >= 48 && code <= 57
  );
}
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 36527:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var src_exports = {};
__export(src_exports, {
  useClientValue: () => useClientValue,
  useDidFinishSSR: () => useDidFinishSSR,
  useDidFinishSSRSync: () => useDidFinishSSRSync
});
module.exports = __toCommonJS(src_exports);
var React = __toESM(__webpack_require__(67294));
const emptyFn = () => {
}, emptyFnFn = () => emptyFn;
function useDidFinishSSR(value, options) {
  if (options?.sync)
    return React.useSyncExternalStore(
      emptyFnFn,
      () => value ?? !0,
      () => !1
    );
  const [cur, setCur] = React.useState(value);
  return React.useEffect(() => {
    setCur(value ?? !0);
  }, []), cur ?? !1;
}
function useDidFinishSSRSync(value) {
  return useDidFinishSSR(value, {
    sync: !0
  });
}
function useClientValue(value) {
  return useDidFinishSSR() ? typeof value == "function" ? value() : value : void 0;
}
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 90951:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
}, __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var src_exports = {};
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(92708), module.exports);
__reExport(src_exports, __webpack_require__(76146), module.exports);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 92708:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var useEvent_exports = {};
__export(useEvent_exports, {
  useEvent: () => useEvent
});
module.exports = __toCommonJS(useEvent_exports);
var import_useGet = __webpack_require__(76146);
function useEvent(callback) {
  return (0, import_useGet.useGet)(callback, defaultValue, !0);
}
const defaultValue = () => {
  throw new Error("Cannot call an event handler while rendering.");
};
//# sourceMappingURL=useEvent.js.map


/***/ }),

/***/ 76146:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var useGet_exports = {};
__export(useGet_exports, {
  useGet: () => useGet
});
module.exports = __toCommonJS(useGet_exports);
var import_constants = __webpack_require__(14810), React = __toESM(__webpack_require__(67294));
function useGet(currentValue, initialValue, forwardToFunction) {
  const curRef = React.useRef(initialValue ?? currentValue);
  return (0, import_constants.useIsomorphicLayoutEffect)(() => {
    curRef.current = currentValue;
  }), React.useCallback(
    forwardToFunction ? (...args) => curRef.current?.apply(null, args) : () => curRef.current,
    []
  );
}
//# sourceMappingURL=useGet.js.map


/***/ }),

/***/ 52707:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var src_exports = {};
__export(src_exports, {
  isServerSide: () => isServerSide,
  useForceUpdate: () => useForceUpdate
});
module.exports = __toCommonJS(src_exports);
var import_react = __toESM(__webpack_require__(67294));
const isServerSide = typeof window > "u", idFn = () => {
};
function useForceUpdate() {
  return isServerSide ? idFn : import_react.default.useReducer((x) => Math.random(), 0)[1];
}
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 5656:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var Tamagui_exports = {};
__export(Tamagui_exports, {
  Tamagui: () => Tamagui,
  getValueFromIdentifier: () => getValueFromIdentifier,
  setIdentifierValue: () => setIdentifierValue
});
module.exports = __toCommonJS(Tamagui_exports);
var Helpers = __toESM(__webpack_require__(37513)), import_config = __webpack_require__(16265), import_insertStyleRule = __webpack_require__(37269), import_useMedia = __webpack_require__(85030), import_useTheme = __webpack_require__(69953);
const Tamagui = (() => {
  if (false) {}
})(), identifierToValue = /* @__PURE__ */ new Map(), getValueFromIdentifier = (identifier) => identifierToValue.get(identifier), setIdentifierValue = (identifier, value) => {
  identifierToValue.set(identifier, value);
};
//# sourceMappingURL=Tamagui.js.map


/***/ }),

/***/ 12607:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var withStableStyle_exports = {};
__export(withStableStyle_exports, {
  _withStableStyle: () => _withStableStyle
});
module.exports = __toCommonJS(withStableStyle_exports);
var import_react = __toESM(__webpack_require__(67294)), import_useTheme = __webpack_require__(69953), import_jsx_runtime = __webpack_require__(85893);
const _withStableStyle = (Component, styleProvider) => import_react.default.forwardRef((props, ref) => {
  const { _expressions = [], ...rest } = props, theme = (0, import_useTheme.useTheme)();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Component, { ref, style: styleProvider(theme, _expressions), ...rest });
});
//# sourceMappingURL=_withStableStyle.js.map


/***/ }),

/***/ 16265:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var config_exports = {};
__export(config_exports, {
  configListeners: () => configListeners,
  devConfig: () => devConfig,
  getConfig: () => getConfig,
  getFont: () => getFont,
  getSetting: () => getSetting,
  getThemes: () => getThemes,
  getToken: () => getToken,
  getTokenObject: () => getTokenObject,
  getTokenValue: () => getTokenValue,
  getTokens: () => getTokens,
  onConfiguredOnce: () => onConfiguredOnce,
  setConfig: () => setConfig,
  setConfigFont: () => setConfigFont,
  setTokens: () => setTokens,
  setupDev: () => setupDev,
  updateConfig: () => updateConfig,
  useTokens: () => useTokens
});
module.exports = __toCommonJS(config_exports);
var import_constants = __webpack_require__(14810);
let conf;
const getSetting = (key) => {
  if (false)
    {}
  return conf.settings[key] ?? // @ts-expect-error
  conf[key];
}, setConfig = (next) => {
  conf = next;
}, setConfigFont = (name, font, fontParsed) => {
  if (false)
    {}
  conf.fonts[name] = font, conf.fontsParsed[`$${name}`] = fontParsed;
}, getConfig = () => {
  if (!conf)
    throw new Error(
       false ? 0 : "Err0"
    );
  return conf;
};
let tokensMerged;
function setTokens(_) {
  tokensMerged = _;
}
const getTokens = ({
  prefixed
} = {}) => {
  if (false)
    {}
  const { tokens, tokensParsed } = conf;
  return prefixed === !1 ? tokens : prefixed === !0 ? tokensParsed : tokensMerged;
}, getTokenObject = (value, group) => conf.specificTokens[value] ?? (group ? tokensMerged[group]?.[value] : tokensMerged[Object.keys(tokensMerged).find((cat) => tokensMerged[cat][value]) || ""]?.[value]), getToken = (value, group, useVariable = import_constants.isWeb) => {
  const token = getTokenObject(value, group);
  return useVariable ? token?.variable : token?.val;
}, getTokenValue = (value, group) => {
  if (!(value === "unset" || value === "auto"))
    return getToken(value, group, !1);
}, useTokens = getTokens, getThemes = () => conf.themes, configListeners = /* @__PURE__ */ new Set(), onConfiguredOnce = (cb) => {
  conf ? cb(conf) : configListeners.add(cb);
}, updateConfig = (key, value) => {
  Object.assign(conf[key], value);
}, getFont = (name) => {
  const conf2 = getConfig();
  return conf2.fontsParsed[name] ?? Object.entries(conf2.fontsParsed).find(
    ([k]) => conf2.fontsParsed[k]?.family?.val === name
  )?.[1];
};
let devConfig;
function setupDev(conf2) {
   false && (0);
}
//# sourceMappingURL=config.js.map


/***/ }),

/***/ 95466:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var accessibilityDirectMap_exports = {};
__export(accessibilityDirectMap_exports, {
  accessibilityDirectMap: () => accessibilityDirectMap,
  accessibilityWebRoleToNativeRole: () => accessibilityWebRoleToNativeRole,
  nativeAccessibilityState: () => nativeAccessibilityState,
  nativeAccessibilityValue: () => nativeAccessibilityValue,
  webToNativeAccessibilityDirectMap: () => webToNativeAccessibilityDirectMap
});
module.exports = __toCommonJS(accessibilityDirectMap_exports);
const accessibilityDirectMap = {};
{
  const items = {
    Hidden: !0,
    ActiveDescendant: !0,
    Atomic: !0,
    AutoComplete: !0,
    Busy: !0,
    Checked: !0,
    ColumnCount: "colcount",
    ColumnIndex: "colindex",
    ColumnSpan: "colspan",
    Current: !0,
    Details: !0,
    ErrorMessage: !0,
    Expanded: !0,
    HasPopup: !0,
    Invalid: !0,
    Label: !0,
    Level: !0,
    Modal: !0,
    Multiline: !0,
    MultiSelectable: !0,
    Orientation: !0,
    Owns: !0,
    Placeholder: !0,
    PosInSet: !0,
    Pressed: !0,
    RoleDescription: !0,
    RowCount: !0,
    RowIndex: !0,
    RowSpan: !0,
    Selected: !0,
    SetSize: !0,
    Sort: !0,
    ValueMax: !0,
    ValueMin: !0,
    ValueNow: !0,
    ValueText: !0
  };
  for (const key in items) {
    let val = items[key];
    val === !0 && (val = key.toLowerCase()), accessibilityDirectMap[`accessibility${key}`] = `aria-${val}`;
  }
}
const webToNativeAccessibilityDirectMap = null, nativeAccessibilityValue = null, nativeAccessibilityState = null, accessibilityWebRoleToNativeRole = null;
//# sourceMappingURL=accessibilityDirectMap.js.map


/***/ }),

/***/ 36297:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var constants_exports = {};
__export(constants_exports, {
  FONT_DATA_ATTRIBUTE_NAME: () => FONT_DATA_ATTRIBUTE_NAME,
  THEME_CLASSNAME_PREFIX: () => THEME_CLASSNAME_PREFIX,
  THEME_NAME_SEPARATOR: () => THEME_NAME_SEPARATOR,
  stackDefaultStyles: () => stackDefaultStyles,
  webViewFlexCompatStyles: () => webViewFlexCompatStyles
});
module.exports = __toCommonJS(constants_exports);
const THEME_NAME_SEPARATOR = "_", THEME_CLASSNAME_PREFIX = "t_", FONT_DATA_ATTRIBUTE_NAME = "data-tamagui-font", stackDefaultStyles = {}, webViewFlexCompatStyles = {
  display: "flex",
  alignItems: "stretch",
  flexDirection: "column",
  flexBasis: "auto",
  boxSizing: "border-box",
  position: "relative",
  minHeight: 0,
  minWidth: 0,
  flexShrink: 0
};
Object.assign(stackDefaultStyles, webViewFlexCompatStyles);
//# sourceMappingURL=constants.js.map


/***/ }),

/***/ 57405:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var isDevTools_exports = {};
__export(isDevTools_exports, {
  isDevTools: () => isDevTools
});
module.exports = __toCommonJS(isDevTools_exports);
const isDevTools = (() => {
  if (false)
    {}
  return !1;
})();
//# sourceMappingURL=isDevTools.js.map


/***/ }),

/***/ 27593:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var webToNativeProps_exports = {};
__export(webToNativeProps_exports, {
  webToNativeDynamicExpansion: () => webToNativeDynamicExpansion,
  webToNativeExpansion: () => webToNativeExpansion
});
module.exports = __toCommonJS(webToNativeProps_exports);
const webToNativeDynamicExpansion = {}, webToNativeExpansion = {};
//# sourceMappingURL=webToNativeProps.js.map


/***/ }),

/***/ 22597:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var ComponentContext_exports = {};
__export(ComponentContext_exports, {
  ComponentContext: () => ComponentContext
});
module.exports = __toCommonJS(ComponentContext_exports);
var import_createStyledContext = __webpack_require__(97564);
const ComponentContext = (0, import_createStyledContext.createStyledContext)({
  disableSSR: void 0,
  inText: !1,
  language: null,
  animationDriver: null,
  groups: {
    emit: null,
    subscribe: null,
    state: {}
  }
});
//# sourceMappingURL=ComponentContext.js.map


/***/ }),

/***/ 86932:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(34155);
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var createComponent_exports = {};
__export(createComponent_exports, {
  Spacer: () => Spacer,
  Unspaced: () => Unspaced,
  componentSetStates: () => componentSetStates,
  createComponent: () => createComponent,
  isDisabled: () => isDisabled,
  spacedChildren: () => spacedChildren,
  subscribeToContextGroup: () => subscribeToContextGroup,
  useComponentState: () => useComponentState
});
module.exports = __toCommonJS(createComponent_exports);
var import_react = __toESM(__webpack_require__(67294)), import_compose_refs = __webpack_require__(95915), import_constants = __webpack_require__(14810), import_helpers = __webpack_require__(37513), import_config = __webpack_require__(16265), import_constants2 = __webpack_require__(36297), import_isDevTools = __webpack_require__(57405), import_ComponentContext = __webpack_require__(22597), import_createVariable = __webpack_require__(88957), import_defaultComponentState = __webpack_require__(28646), import_createShallowSetState = __webpack_require__(66575), import_getSplitStyles = __webpack_require__(41384), import_isObj = __webpack_require__(88356), import_log = __webpack_require__(97727), import_mergeProps = __webpack_require__(1458), import_setElementProps = __webpack_require__(2934), import_themeable = __webpack_require__(26819), import_useDidHydrateOnce = __webpack_require__(61378), import_useMedia = __webpack_require__(85030), import_useTheme = __webpack_require__(69953), import_setupHooks = __webpack_require__(25142), import_Slot = __webpack_require__(12897), import_Theme = __webpack_require__(49798), import_ThemeDebug = __webpack_require__(14362), import_jsx_runtime = __webpack_require__(85893);
let tamaguiConfig, time, debugKeyListeners, startVisualizer;
const componentSetStates = /* @__PURE__ */ new Set();
if (typeof document < "u") {
  const cancelTouches = () => {
    componentSetStates.forEach(
      (setState) => setState((prev) => prev.press || prev.pressIn ? {
        ...prev,
        press: !1,
        pressIn: !1
      } : prev)
    ), componentSetStates.clear();
  };
  addEventListener("mouseup", cancelTouches), addEventListener("touchend", cancelTouches), addEventListener("touchcancel", cancelTouches),  false && (0);
}
const useComponentState = (props, { animationDriver, groups }, staticConfig, config) => {
  const useAnimations = animationDriver?.useAnimations, stateRef = import_react.default.useRef(
    void 0
  );
  stateRef.current || (stateRef.current = {});
  const hasAnimationProp = !!("animation" in props || props.style && hasAnimatedStyleValue(props.style)), supportsCSSVars = animationDriver?.supportsCSSVars, curStateRef = stateRef.current, willBeAnimatedClient = !!(!!(hasAnimationProp && !staticConfig.isHOC && useAnimations) || curStateRef.hasAnimated), willBeAnimated = !import_constants.isServer && willBeAnimatedClient;
  willBeAnimated && !curStateRef.hasAnimated && (curStateRef.hasAnimated = !0);
  const presence = willBeAnimated && props.animatePresence !== !1 && animationDriver?.usePresence?.() || null, presenceState = presence?.[2], isExiting = presenceState?.isPresent === !1, isEntering = presenceState?.isPresent === !0 && presenceState.initial !== !1, hasEnterStyle = !!props.enterStyle, hasRNAnimation = hasAnimationProp && animationDriver?.isReactNative;
   false && 0;
  const hasEnterState = hasEnterStyle || isEntering, didHydrateOnce = willBeAnimated ? (0, import_useDidHydrateOnce.useDidHydrateOnce)() : !0, initialState = hasEnterState || !didHydrateOnce && hasRNAnimation ? (
    // on the very first render we switch all spring animation drivers to css rendering
    // this is because we need to use css variables, which they don't support to do proper SSR
    // without flickers of the wrong colors.
    // but once we do that initial hydration and we are in client side rendering mode,
    // we can avoid the extra re-render on mount
    import_constants.isWeb && !didHydrateOnce ? import_defaultComponentState.defaultComponentState : import_defaultComponentState.defaultComponentStateShouldEnter
  ) : import_defaultComponentState.defaultComponentStateMounted, disabled = isDisabled(props);
  disabled != null && (initialState.disabled = disabled);
  const states = import_react.default.useState(initialState), state = props.forceStyle ? { ...states[0], [props.forceStyle]: !0 } : states[0], setState = states[1], isHydrated = state.unmounted === !1 || state.unmounted === "should-enter";
  let isAnimated = willBeAnimated;
  import_constants.isWeb && hasRNAnimation && !staticConfig.isHOC && state.unmounted === !0 && (isAnimated = !1, curStateRef.willHydrate = !0), disabled !== state.disabled && (state.disabled = disabled, disabled && Object.assign(state, import_defaultComponentState.defaultComponentStateMounted), setState({ ...state }));
  let setStateShallow = (0, import_createShallowSetState.createShallowSetState)(setState, disabled, !1, props.debug);
  if (presenceState && isAnimated && isHydrated && staticConfig.variants) {
     false && 0;
    const { enterVariant, exitVariant, enterExitVariant, custom } = presenceState;
    (0, import_isObj.isObj)(custom) && Object.assign(props, custom);
    const exv = exitVariant ?? enterExitVariant, env = enterVariant ?? enterExitVariant;
    state.unmounted && env && staticConfig.variants[env] ? ( false && 0, props[env] = !0) : isExiting && exv && ( false && 0, props[exv] = exitVariant !== enterExitVariant);
  }
  let shouldAvoidClasses = !import_constants.isWeb;
  if (import_constants.isWeb) {
    const { disableClassName } = props, isAnimatedAndHydrated = isAnimated && !supportsCSSVars && didHydrateOnce && !import_constants.isServer, isClassNameDisabled = !staticConfig.acceptsClassName && (config.disableSSR || didHydrateOnce), isDisabledManually = disableClassName && !import_constants.isServer && didHydrateOnce && state.unmounted === !0;
    (isAnimatedAndHydrated || isDisabledManually || isClassNameDisabled) && (shouldAvoidClasses = !0,  false && 0);
  }
  const groupName = props.group;
  if (groupName && !curStateRef.group) {
    const listeners = /* @__PURE__ */ new Set();
    curStateRef.group = {
      listeners,
      emit(name, state2) {
        listeners.forEach((l) => l(name, state2));
      },
      subscribe(cb) {
        return listeners.add(cb), () => {
          listeners.delete(cb);
        };
      }
    };
  }
  if (groupName) {
    const groupContextState = groups.state, og = setStateShallow;
    setStateShallow = (state2) => {
      og(state2), curStateRef.group.emit(groupName, {
        pseudo: state2
      });
      const next = {
        ...groupContextState[groupName],
        ...state2
      };
      groupContextState[groupName] = next;
    };
  }
  return {
    curStateRef,
    disabled,
    groupName,
    hasAnimationProp,
    hasEnterStyle,
    isAnimated,
    isExiting,
    isHydrated,
    presence,
    presenceState,
    setState,
    setStateShallow,
    shouldAvoidClasses,
    state,
    stateRef,
    supportsCSSVars,
    willBeAnimated,
    willBeAnimatedClient
  };
};
let BaseText, BaseView;
const lastInteractionWasKeyboard = { value: !1 };
import_constants.isWeb && globalThis.document && (document.addEventListener("keydown", () => {
  lastInteractionWasKeyboard.value = !0;
}), document.addEventListener("mousedown", () => {
  lastInteractionWasKeyboard.value = !1;
}), document.addEventListener("mousemove", () => {
  lastInteractionWasKeyboard.value = !1;
}));
function createComponent(staticConfig) {
  const { componentName } = staticConfig;
  let config = null, defaultProps = staticConfig.defaultProps;
  (0, import_config.onConfiguredOnce)((conf) => {
    if (config = conf, componentName) {
      const defaultForComponent = conf.defaultProps?.[componentName];
      defaultForComponent && (defaultProps = { ...defaultForComponent, ...defaultProps });
    }
  });
  const {
    Component,
    isText,
    isZStack,
    isHOC,
    validStyles: validStyles2 = {},
    variants = {}
  } = staticConfig;
   false && 0;
  const component = import_react.default.forwardRef((propsIn, forwardedRef) => {
    const internalID =  false ? 0 : "";
     false && (0),  false && (0);
    const componentContext = import_react.default.useContext(import_ComponentContext.ComponentContext);
    let styledContextProps, overriddenContextProps, contextValue;
    const { context, isReactNative } = staticConfig;
    if (context) {
      contextValue = import_react.default.useContext(context);
      const { inverseShorthands } = (0, import_config.getConfig)();
      for (const key in context.props) {
        const propVal = (
          // because its after default props but before props this annoying amount of checks
          propsIn[key] ?? propsIn[inverseShorthands[key]] ?? defaultProps?.[key] ?? defaultProps?.[inverseShorthands[key]]
        );
        propVal === void 0 ? contextValue && (key in validStyles2 || key in variants) && (styledContextProps ||= {}, styledContextProps[key] = contextValue[key]) : (overriddenContextProps ||= {}, overriddenContextProps[key] = propVal);
      }
    }
    const curDefaultProps = styledContextProps ? { ...defaultProps, ...styledContextProps } : defaultProps;
    let props = propsIn;
    curDefaultProps && (props = (0, import_mergeProps.mergeProps)(curDefaultProps, propsIn));
    const debugProp = props.debug, componentName2 = props.componentName || staticConfig.componentName;
     false && 0, !process.env.TAMAGUI_IS_CORE_NODE && "production" === "development" && 0 && 0 && (0),  false && 0,  false && 0,  false && 0;
    const animationDriver = componentContext.animationDriver, useAnimations = animationDriver?.useAnimations, {
      curStateRef,
      disabled,
      groupName,
      hasAnimationProp,
      hasEnterStyle,
      isAnimated,
      isExiting,
      isHydrated,
      presence,
      presenceState,
      setState,
      setStateShallow,
      shouldAvoidClasses,
      state,
      stateRef,
      supportsCSSVars,
      willBeAnimated,
      willBeAnimatedClient
    } = useComponentState(props, componentContext, staticConfig, config), shouldForcePseudo = !!propsIn.forceStyle, noClassNames = shouldAvoidClasses || shouldForcePseudo;
     false && 0;
    const hasTextAncestor = !!(import_constants.isWeb && isText && componentContext.inText);
     false && 0;
    const isTaggable = !Component || typeof Component == "string", tagProp = props.tag, element = import_constants.isWeb && isTaggable && tagProp || Component;
    let elementType = isText ? BaseText || element || "span" : BaseView || element || (hasTextAncestor ? "span" : "div");
    animationDriver && isAnimated && (elementType = animationDriver[isText ? "Text" : "View"] || elementType);
    const disableTheme = props["data-disable-theme"] || isHOC;
     false && 0, props.themeShallow && (curStateRef.themeShallow = !0);
    const themeStateProps = {
      componentName: componentName2,
      disable: disableTheme,
      shallow: curStateRef.themeShallow,
      debug: debugProp
    };
    if ("themeInverse" in props && (themeStateProps.inverse = props.themeInverse), "theme" in props && (themeStateProps.name = props.theme), typeof curStateRef.isListeningToTheme == "boolean" && (themeStateProps.shouldUpdate = () => stateRef.current.isListeningToTheme),  false && 0) {
      const name = `${componentName2 || Component?.displayName || Component?.name || "[Unnamed Component]"}`, type = (hasEnterStyle ? "(hasEnter)" : " ") + (isAnimated ? "(animated)" : " ") + (isReactNative ? "(rnw)" : " ") + (shouldAvoidClasses ? "(shouldAvoidClasses)" : " ") + (state.press || state.pressIn ? "(PRESSED)" : " ") + (state.hover ? "(HOVERED)" : " ") + (state.focus ? "(FOCUSED)" : " ") + (presenceState?.isPresent === !1 ? "(EXIT)" : ""), dataIs = propsIn["data-is"] || "", banner = `${internalID} ${name}${dataIs ? ` ${dataIs}` : ""} ${type}`;
      if (console.info(
        `%c ${banner} (hydrated: ${isHydrated}) (unmounted: ${state.unmounted})`,
        "background: green; color: white;"
      ), import_constants.isServer)
        (0, import_log.log)({ noClassNames, isAnimated, shouldAvoidClasses, isWeb: import_constants.isWeb, supportsCSSVars });
      else {
        console.groupEnd();
        const ch = propsIn.children;
        let childLog = typeof ch == "string" ? ch.length > 4 ? ch.slice(0, 4) + "..." : ch : "";
        childLog.length && (childLog = `(children: ${childLog})`), console.groupCollapsed(`${childLog} Props:`), (0, import_log.log)("props in:", propsIn), (0, import_log.log)("final props:", props), (0, import_log.log)({ state, staticConfig, elementType, themeStateProps }), (0, import_log.log)({ contextProps: styledContextProps, overriddenContextProps }), (0, import_log.log)({ presence, isAnimated, isHOC, hasAnimationProp, useAnimations }), console.groupEnd();
      }
    }
     false && 0;
    const [themeState, theme] = (0, import_useTheme.useThemeWithState)(themeStateProps);
    elementType = Component || elementType;
    const isStringElement = typeof elementType == "string";
     false && 0;
    const mediaState = (0, import_useMedia.useMedia)(stateRef, componentContext, debugProp);
    (0, import_createVariable.setDidGetVariableValue)(!1),  false && 0;
    const resolveValues = (
      // if HOC + mounted + has animation prop, resolve as value so it passes non-variable to child
      isAnimated && !supportsCSSVars || isHOC && state.unmounted == !1 && hasAnimationProp ? "value" : "auto"
    ), styleProps = {
      mediaState,
      noClassNames,
      resolveValues,
      isExiting,
      isAnimated,
      willBeAnimated
    }, splitStyles = (0, import_getSplitStyles.useSplitStyles)(
      props,
      staticConfig,
      theme,
      themeState?.state?.name || "",
      state,
      styleProps,
      null,
      componentContext,
      elementType,
      debugProp
    );
    props.group && props.untilMeasured === "hide" && !curStateRef.hasMeasured && (splitStyles.style ||= {}, splitStyles.style.opacity = 0),  false && 0, curStateRef.isListeningToTheme = splitStyles.dynamicThemeAccess;
    const hasRuntimeMediaKeys = splitStyles.hasMedia && splitStyles.hasMedia !== !0, shouldListenForMedia = (0, import_createVariable.didGetVariableValue)() || hasRuntimeMediaKeys || noClassNames && splitStyles.hasMedia === !0, mediaListeningKeys = hasRuntimeMediaKeys ? splitStyles.hasMedia : null;
     false && 0, (0, import_useMedia.setMediaShouldUpdate)(stateRef, {
      enabled: shouldListenForMedia,
      keys: mediaListeningKeys
    });
    const {
      viewProps: viewPropsIn,
      pseudos,
      style: splitStylesStyle,
      classNames,
      space
    } = splitStyles, propsWithAnimation = props, {
      asChild,
      children,
      themeShallow,
      spaceDirection: _spaceDirection,
      onPress,
      onLongPress,
      onPressIn,
      onPressOut,
      onHoverIn,
      onHoverOut,
      onMouseUp,
      onMouseDown,
      onMouseEnter,
      onMouseLeave,
      onFocus,
      onBlur,
      separator,
      // ignore from here on out
      forceStyle: _forceStyle,
      // @ts-ignore  for next/link compat etc
      onClick,
      theme: _themeProp,
      ...nonTamaguiProps
    } = viewPropsIn;
    let viewProps = nonTamaguiProps;
    !isTaggable && props.forceStyle && (viewProps.forceStyle = props.forceStyle), isHOC && _themeProp && (viewProps.theme = _themeProp), elementType.acceptTagProp && (viewProps.tag = tagProp);
    let animationStyles;
    if (
      // if it supports css vars we run it on server too to get matching initial style
      (supportsCSSVars ? willBeAnimatedClient : willBeAnimated) && useAnimations && !isHOC
    ) {
      const animations = useAnimations({
        props: propsWithAnimation,
        // if hydrating, send empty style
        style: splitStylesStyle || {},
        presence,
        componentState: state,
        styleProps,
        theme: themeState.state?.theme,
        pseudos: pseudos || null,
        staticConfig,
        stateRef
      });
      (isAnimated || supportsCSSVars) && animations && (animationStyles = animations.style, viewProps.style = animationStyles, animations.className && (viewProps.className = `${viewProps.className || ""} ${animations.className}`)),  false && 0;
    }
     false && 0,  false && 0, groupName && (nonTamaguiProps.onLayout = (0, import_helpers.composeEventHandlers)(
      nonTamaguiProps.onLayout,
      (e) => {
        stateRef.current.group.emit(groupName, {
          layout: e.nativeEvent.layout
        }), !stateRef.current.hasMeasured && props.untilMeasured === "hide" && setState((prev) => ({ ...prev })), stateRef.current.hasMeasured = !0;
      }
    )), viewProps = import_setupHooks.hooks.usePropsTransform?.(
      elementType,
      nonTamaguiProps,
      stateRef,
      curStateRef.willHydrate
    ) || nonTamaguiProps, curStateRef.composedRef || (curStateRef.composedRef = (0, import_compose_refs.composeRefs)(
      (x) => stateRef.current.host = x,
      forwardedRef,
      import_setElementProps.setElementProps
    )), viewProps.ref = curStateRef.composedRef,  false && 0,  false && 0;
    const { pseudoGroups, mediaGroups } = splitStyles, unPress = () => setStateShallow({ press: !1, pressIn: !1 });
     false && 0, import_react.default.useEffect(() => {
      if (disabled)
        return;
      if (state.unmounted === !0 && hasEnterStyle) {
        setStateShallow({ unmounted: "should-enter" });
        return;
      }
      if (state.unmounted) {
        setStateShallow({ unmounted: !1 });
        return;
      }
      const dispose = subscribeToContextGroup({
        disabled,
        componentContext,
        setStateShallow,
        state,
        mediaGroups,
        pseudoGroups
      });
      return () => {
        dispose?.(), componentSetStates.delete(setState);
      };
    }, [
      state.unmounted,
      disabled,
      pseudoGroups ? Object.keys([...pseudoGroups]).join("") : 0,
      mediaGroups ? Object.keys([...mediaGroups]).join("") : 0
    ]);
    const runtimePressStyle = !disabled && noClassNames && pseudos?.pressStyle, runtimeFocusStyle = !disabled && noClassNames && pseudos?.focusStyle, runtimeFocusVisibleStyle = !disabled && noClassNames && pseudos?.focusVisibleStyle, attachFocus = !!(runtimePressStyle || runtimeFocusStyle || runtimeFocusVisibleStyle || onFocus || onBlur), attachPress = !!(groupName || runtimePressStyle || onPress || onPressOut || onPressIn || onMouseDown || onMouseUp || onLongPress || onClick || pseudos?.focusVisibleStyle), runtimeHoverStyle = !disabled && noClassNames && pseudos?.hoverStyle, needsHoverState = !!(groupName || runtimeHoverStyle || onHoverIn || onHoverOut), attachHover = import_constants.isWeb && !!(groupName || needsHoverState || onMouseEnter || onMouseLeave), shouldAttach = !disabled && !props.asChild && !!(attachFocus || attachPress || attachHover || runtimePressStyle || runtimeHoverStyle || runtimeFocusStyle), needsPressState = !!(groupName || runtimePressStyle);
     false && 0,  false && 0;
    const events = shouldAttach ? {
      onPressOut: attachPress ? (e) => {
        unPress(), onPressOut?.(e), onMouseUp?.(e);
      } : void 0,
      ...(attachHover || attachPress) && {
        onMouseEnter: (e) => {
          const next = {};
          needsHoverState && (next.hover = !0), needsPressState && state.pressIn && (next.press = !0), setStateShallow(next), onHoverIn?.(e), onMouseEnter?.(e);
        },
        onMouseLeave: (e) => {
          const next = {};
          needsHoverState && (next.hover = !1), needsPressState && state.pressIn && (next.press = !1, next.pressIn = !1), setStateShallow(next), onHoverOut?.(e), onMouseLeave?.(e);
        }
      },
      onPressIn: attachPress ? (e) => {
        (runtimePressStyle || groupName) && setStateShallow({
          press: !0,
          pressIn: !0
        }), onPressIn?.(e), onMouseDown?.(e), import_constants.isWeb && componentSetStates.add(setState);
      } : void 0,
      onPress: attachPress ? (e) => {
        unPress(), import_constants.isWeb && onClick?.(e), onPress?.(e), onLongPress?.(e);
      } : void 0,
      ...attachFocus && {
        onFocus: (e) => {
          pseudos?.focusVisibleStyle ? setTimeout(() => {
            setStateShallow({
              focus: !0,
              focusVisible: !!lastInteractionWasKeyboard.value
            });
          }, 0) : setStateShallow({
            focus: !0,
            focusVisible: !1
          }), onFocus?.(e);
        },
        onBlur: (e) => {
          setStateShallow({
            focus: !1,
            focusVisible: !1
          }), onBlur?.(e);
        }
      }
    } : null;
    events && !isReactNative && Object.assign(viewProps, getWebEvents(events)),  false && 0,  false && 0, import_setupHooks.hooks.useEvents?.(viewProps, events, splitStyles, setStateShallow, staticConfig);
    const direction = props.spaceDirection || "both";
     false && 0;
    let content = !children || asChild ? children : spacedChildren({
      separator,
      children,
      space,
      direction,
      isZStack,
      debug: debugProp
    });
    if (asChild) {
      elementType = import_Slot.Slot;
      {
        const passEvents = getWebEvents(
          {
            onPress,
            onLongPress,
            onPressIn,
            onPressOut,
            onMouseUp,
            onMouseDown,
            onMouseEnter,
            onMouseLeave
          },
          asChild === "web" || asChild === "except-style-web"
        );
        Object.assign(viewProps, passEvents);
      }
    }
     false && 0;
    let useChildrenResult;
    import_setupHooks.hooks.useChildren && (useChildrenResult = import_setupHooks.hooks.useChildren(
      elementType,
      content,
      viewProps,
      events,
      staticConfig
    )), useChildrenResult ? content = useChildrenResult : content = import_react.default.createElement(elementType, viewProps, content);
    const ResetPresence = config?.animations?.ResetPresence;
    ResetPresence && willBeAnimated && (hasEnterStyle || presenceState) && content && typeof content != "string" && (content = /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ResetPresence, { children: content })),  false && 0;
    const groupState = curStateRef.group, subGroupContext = import_react.default.useMemo(() => {
      if (!(!groupState || !groupName))
        return groupState.listeners.clear(), {
          ...componentContext.groups,
          // change reference so as we mutate it doesn't affect siblings etc
          state: {
            ...componentContext.groups.state,
            [groupName]: {
              pseudo: import_defaultComponentState.defaultComponentStateMounted,
              // capture just initial width and height if they exist
              // will have top, left, width, height (not x, y)
              layout: {
                width: fromPx(splitStyles.style?.width),
                height: fromPx(splitStyles.style?.height)
              }
            }
          },
          emit: groupState.emit,
          subscribe: groupState.subscribe
        };
    }, [groupName]);
    if (groupName && subGroupContext && (content = /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ComponentContext.ComponentContext.Provider, { ...componentContext, groups: subGroupContext, children: content })),  false && 0, content = disableTheme ? content : (0, import_Theme.getThemedChildren)(themeState, content, themeStateProps, !1, stateRef),  false && 0,  false && (0), isReactNative && !asChild && (content = /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      "span",
      {
        className: "_dsp_contents",
        ...isHydrated && events && getWebEvents(events),
        children: content
      }
    )), staticConfig.context) {
      const contextProps = staticConfig.context.props;
      for (const key in contextProps)
        (viewProps.style && key in viewProps.style || key in viewProps) && (overriddenContextProps ||= {}, overriddenContextProps[key] = viewProps.style?.[key] ?? viewProps[key]);
    }
    if (overriddenContextProps) {
      const Provider = staticConfig.context.Provider;
      content = /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Provider, { ...contextValue, ...overriddenContextProps, children: content });
    }
    if (process.env.TAMAGUI_REACT_19) {
      const { rulesToInsert } = splitStyles, keys = Object.keys(splitStyles.rulesToInsert);
      keys.length && (content = /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, { children: [
        content,
        keys.map((key) => {
          const styleObject = rulesToInsert[key], identifier = styleObject[import_helpers.StyleObjectIdentifier];
          return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
            "style",
            {
              href: `t_${identifier}`,
              precedence: "default",
              children: styleObject[import_helpers.StyleObjectRules].join(`
`)
            },
            identifier
          );
        })
      ] }));
    }
    if (false) {}
    return  false && (0), content;
  });
  staticConfig.componentName && (component.displayName = staticConfig.componentName);
  let res = component;
  (process.env.TAMAGUI_FORCE_MEMO || staticConfig.memo) && (res = import_react.default.memo(res)), res.staticConfig = staticConfig;
  function extendStyledConfig(extended) {
    return {
      ...staticConfig,
      ...extended,
      neverFlatten: !0,
      isHOC: !0,
      isStyledHOC: !1
    };
  }
  function extractable(Component2, extended) {
    return Component2.staticConfig = extendStyledConfig(extended), Component2.styleable = styleable, Component2;
  }
  function styleable(Component2, options) {
    let out = Component2.render?.length === 2 ? Component2 : import_react.default.forwardRef(Component2);
    const extendedConfig = extendStyledConfig(options?.staticConfig);
    return out = options?.disableTheme ? out : (0, import_themeable.themeable)(out, extendedConfig), process.env.TAMAGUI_MEMOIZE_STYLEABLE && (out = import_react.default.memo(out)), out.staticConfig = extendedConfig, out.styleable = styleable, out;
  }
  return res.extractable = extractable, res.styleable = styleable, res;
}
function getWebEvents(events, webStyle = !0) {
  return {
    onMouseEnter: events.onMouseEnter,
    onMouseLeave: events.onMouseLeave,
    [webStyle ? "onClick" : "onPress"]: events.onPress,
    onMouseDown: events.onPressIn,
    onMouseUp: events.onPressOut,
    onTouchStart: events.onPressIn,
    onTouchEnd: events.onPressOut,
    onFocus: events.onFocus,
    onBlur: events.onBlur
  };
}
function Unspaced(props) {
  return props.children;
}
Unspaced.isUnspaced = !0;
const getSpacerSize = (size, { tokens }) => {
  size = size === !0 ? "$true" : size;
  const sizePx = tokens.space[size] ?? size;
  return {
    width: sizePx,
    height: sizePx,
    minWidth: sizePx,
    minHeight: sizePx
  };
}, Spacer = createComponent({
  acceptsClassName: !0,
  memo: !0,
  componentName: "Spacer",
  validStyles: import_helpers.validStyles,
  defaultProps: {
    ...import_constants2.stackDefaultStyles,
    // avoid nesting issues
    tag: "span",
    size: !0,
    pointerEvents: "none"
  },
  variants: {
    size: {
      "...": getSpacerSize
    },
    flex: {
      true: {
        flexGrow: 1
      }
    },
    direction: {
      horizontal: {
        height: 0,
        minHeight: 0
      },
      vertical: {
        width: 0,
        minWidth: 0
      },
      both: {}
    }
  }
});
function spacedChildren(props) {
  const { isZStack, children, space, direction, spaceFlex, separator, ensureKeys } = props, hasSpace = !!(space || spaceFlex), hasSeparator = separator != null, areChildrenArray = Array.isArray(children);
  if (!ensureKeys && !(hasSpace || hasSeparator || isZStack))
    return children;
  const childrenList = areChildrenArray ? children : import_react.default.Children.toArray(children);
  if (childrenList.length <= 1 && !isZStack && !childrenList[0]?.type?.shouldForwardSpace)
    return children;
  const final = [];
  for (let [index, child] of childrenList.entries()) {
    const isEmpty = child == null || Array.isArray(child) && child.length === 0;
    if (!isEmpty && import_react.default.isValidElement(child) && child.type?.shouldForwardSpace && (child = import_react.default.cloneElement(child, {
      space,
      spaceFlex,
      separator,
      key: child.key
    })), isEmpty || !child || child.key && !isZStack ? final.push(child) : final.push(
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react.default.Fragment, { children: isZStack ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AbsoluteFill, { children: child }) : child }, `${index}0t`)
    ), isUnspaced(child) && index === 0 || isZStack) continue;
    const next = childrenList[index + 1];
    next && !isEmpty && !isUnspaced(next) && (separator ? (hasSpace && final.push(
      createSpacer({
        key: `_${index}_00t`,
        direction,
        space,
        spaceFlex
      })
    ), final.push(/* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react.default.Fragment, { children: separator }, `${index}03t`)), hasSpace && final.push(
      createSpacer({
        key: `_${index}01t`,
        direction,
        space,
        spaceFlex
      })
    )) : final.push(
      createSpacer({
        key: `_${index}02t`,
        direction,
        space,
        spaceFlex
      })
    ));
  }
  return  false && 0, final;
}
function createSpacer({ key, direction, space, spaceFlex }) {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    Spacer,
    {
      size: space,
      direction,
      ...typeof spaceFlex < "u" && {
        flex: spaceFlex === !0 ? 1 : spaceFlex === !1 ? 0 : spaceFlex
      }
    },
    key
  );
}
function isUnspaced(child) {
  const t = child?.type;
  return t?.isVisuallyHidden || t?.isUnspaced;
}
const AbsoluteFill = createComponent({
  defaultProps: {
    ...import_constants2.stackDefaultStyles,
    flexDirection: "column",
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    pointerEvents: "box-none"
  }
});
function hasAnimatedStyleValue(style) {
  return Object.keys(style).some((k) => {
    const val = style[k];
    return val && typeof val == "object" && "_animation" in val;
  });
}
const fromPx = (val) => typeof val != "string" ? val : +val.replace("px", ""), isDisabled = (props) => props.disabled || props.accessibilityState?.disabled || props["aria-disabled"] || props.accessibilityDisabled || !1, subscribeToContextGroup = ({
  disabled = !1,
  setStateShallow,
  pseudoGroups,
  mediaGroups,
  componentContext,
  state
}) => {
  if (pseudoGroups || mediaGroups) {
    const current = {
      pseudo: {},
      media: {}
    };
    return  false && 0, componentContext.groups?.subscribe?.((name, { layout, pseudo }) => {
      if (pseudo && pseudoGroups?.has(String(name)))
        Object.assign(current.pseudo, pseudo), persist();
      else if (layout && mediaGroups) {
        const mediaState = (0, import_useMedia.getMediaState)(mediaGroups, layout), next = (0, import_createShallowSetState.mergeIfNotShallowEqual)(current.media, mediaState);
        next !== current.media && (Object.assign(current.media, next), persist());
      }
      function persist() {
        const group = {
          ...state.group,
          [name]: current
        };
        setStateShallow({
          group
        });
      }
    });
  }
};
//# sourceMappingURL=createComponent.js.map


/***/ }),

/***/ 74274:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var createFont_exports = {};
__export(createFont_exports, {
  createFont: () => createFont
});
module.exports = __toCommonJS(createFont_exports);
const fontWeights = [
  "100",
  "200",
  "300",
  "400",
  "500",
  "600",
  "700",
  "800",
  "900"
], processSection = (section, keys, defaultValue) => {
  if (typeof section == "string") return section;
  const sectionKeys = Object.keys(section);
  let fillValue = section[sectionKeys[0]];
  return Object.fromEntries(
    [.../* @__PURE__ */ new Set([...keys, ...sectionKeys])].map((key) => {
      const value = section[key] ?? defaultValue ?? fillValue;
      return fillValue = value, defaultValue = value, [key, value];
    })
  );
}, createFont = (font) => {
  const sizeKeys = Object.keys(font.size), processedFont = Object.fromEntries(
    Object.entries(font).map(([key, section]) => [
      key,
      processSection(
        section,
        key === "face" ? fontWeights : sizeKeys,
        key === "face" ? { normal: font.family } : void 0
      )
    ])
  );
  return Object.freeze(processedFont);
};
//# sourceMappingURL=createFont.js.map


/***/ }),

/***/ 99414:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var createShorthands_exports = {};
__export(createShorthands_exports, {
  createShorthands: () => createShorthands
});
module.exports = __toCommonJS(createShorthands_exports);
function createShorthands(shorthands) {
  return Object.freeze(shorthands);
}
//# sourceMappingURL=createShorthands.js.map


/***/ }),

/***/ 45502:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var createTamagui_exports = {};
__export(createTamagui_exports, {
  createTamagui: () => createTamagui
});
module.exports = __toCommonJS(createTamagui_exports);
var import_constants = __webpack_require__(14810), import_config = __webpack_require__(16265), import_createVariables = __webpack_require__(26596), import_getThemeCSSRules = __webpack_require__(75099), import_insertStyleRule = __webpack_require__(37269), import_proxyThemeToParents = __webpack_require__(63225), import_registerCSSVariable = __webpack_require__(20299), import_themes = __webpack_require__(49055), import_useMedia = __webpack_require__(85030), import_insertFont = __webpack_require__(89459), import_Tamagui = __webpack_require__(5656);
const createdConfigs = /* @__PURE__ */ new WeakMap();
function createTamagui(configIn) {
  if (createdConfigs.has(configIn))
    return configIn;
  const tokensParsed = {}, tokens = (0, import_createVariables.createVariables)(configIn.tokens || {});
  if (configIn.tokens) {
    const tokensMerged = {};
    for (const cat in tokens) {
      tokensParsed[cat] = {}, tokensMerged[cat] = {};
      const tokenCat = tokens[cat];
      for (const key in tokenCat) {
        const val = tokenCat[key], prefixedKey = `$${key}`;
        tokensParsed[cat][prefixedKey] = val, tokensMerged[cat][prefixedKey] = val, tokensMerged[cat][key] = val;
      }
    }
    (0, import_config.setTokens)(tokensMerged);
  }
  let foundThemes;
  if (configIn.themes) {
    const noThemes = Object.keys(configIn.themes).length === 0;
    foundThemes = (0, import_insertStyleRule.scanAllSheets)(noThemes, tokensParsed);
  }
  (0, import_insertStyleRule.listenForSheetChanges)();
  let fontSizeTokens = null, fontsParsed;
  if (configIn.fonts) {
    const fontTokens = Object.fromEntries(
      Object.entries(configIn.fonts).map(([k, v]) => [k, (0, import_createVariables.createVariables)(v, "f", !0)])
    );
    fontsParsed = (() => {
      const res = {};
      for (const familyName in fontTokens) {
        const font = fontTokens[familyName], fontParsed = (0, import_insertFont.parseFont)(font);
        res[`$${familyName}`] = fontParsed, !fontSizeTokens && fontParsed.size && (fontSizeTokens = new Set(Object.keys(fontParsed.size)));
      }
      return res;
    })();
  }
  const specificTokens = {}, themeConfig = (() => {
    const cssRuleSets = [], declarations = [], fontDeclarations = {};
    for (const key in tokens)
      for (const skey in tokens[key]) {
        const variable = tokens[key][skey];
        if (specificTokens[`$${key}.${skey}`] = variable,  false && 0)
          throw new Error(
            `No value for tokens.${key}.${skey}:
${JSON.stringify(variable, null, 2)}`
          );
        import_constants.isWeb && ((0, import_registerCSSVariable.registerCSSVariable)(variable), declarations.push((0, import_registerCSSVariable.variableToCSS)(variable, key === "zIndex")));
      }
    if (import_constants.isWeb) {
      let declarationsToRuleSet = function(decs, selector = "") {
        return `:root${selector} {${sep}${[...decs].join(`;${sep}`)}${sep}}`;
      };
      for (const key in fontsParsed) {
        const fontParsed = fontsParsed[key], [name, language] = key.includes("_") ? key.split("_") : [key], fontVars = (0, import_insertFont.registerFontVariables)(fontParsed);
        fontDeclarations[key] = {
          name: name.slice(1),
          declarations: fontVars,
          language
        };
      }
      const sep = configIn.cssStyleSeparator || "";
      if (cssRuleSets.push(declarationsToRuleSet(declarations)), fontDeclarations)
        for (const key in fontDeclarations) {
          const { name, declarations: declarations2, language = "default" } = fontDeclarations[key], fontSelector = `.font_${name}`, langSelector = `:root .t_lang-${name}-${language} ${fontSelector}`, selectors = language === "default" ? ` ${fontSelector}, ${langSelector}` : langSelector, specificRuleSet = declarationsToRuleSet(declarations2, selectors);
          cssRuleSets.push(specificRuleSet);
        }
    }
    const themesIn = { ...configIn.themes }, dedupedThemes = foundThemes ?? getThemesDeduped(themesIn);
    return {
      themes: (0, import_proxyThemeToParents.proxyThemesToParents)(dedupedThemes),
      cssRuleSets,
      getThemeRulesSets() {
        let themeRuleSets = [];
        if (import_constants.isWeb)
          for (const { names, theme } of dedupedThemes) {
            const nextRules = (0, import_getThemeCSSRules.getThemeCSSRules)({
              config: configIn,
              themeName: names[0],
              names,
              theme
            });
            themeRuleSets = [...themeRuleSets, ...nextRules];
          }
        return themeRuleSets;
      }
    };
  })(), shorthands = configIn.shorthands || {};
  let lastCSSInsertedRulesIndex = -1;
  const getCSS = (opts = {}) => {
    const { separator = `
`, sinceLastCall, exclude } = opts;
    if (sinceLastCall && lastCSSInsertedRulesIndex >= 0) {
      const rules = (0, import_insertStyleRule.getAllRules)();
      return lastCSSInsertedRulesIndex = rules.length, rules.slice(lastCSSInsertedRulesIndex).join(separator);
    }
    lastCSSInsertedRulesIndex = 0;
    const runtimeStyles = (0, import_insertStyleRule.getAllRules)().join(separator);
    return exclude === "design-system" ? runtimeStyles : `${`._ovs-contain {overscroll-behavior:contain;}
.is_Text .is_Text {display:inline-flex;}
._dsp_contents {display:contents;}
${themeConfig.cssRuleSets.join(separator)}`}
${exclude ? "" : themeConfig.getThemeRulesSets().join(separator)}
${runtimeStyles}`;
  }, getNewCSS = (opts) => getCSS({ ...opts, sinceLastCall: !0 });
  let defaultFontName = (configIn.settings?.defaultFont ?? configIn.defaultFont) || // uses font named "body" if present for compat
  configIn.fonts && ("body" in configIn.fonts ? "body" : "");
  !defaultFontName && configIn.fonts && (defaultFontName = Object.keys(configIn.fonts)[0]), defaultFontName?.[0] === "$" && (defaultFontName = defaultFontName.slice(1));
  const defaultFont = `$${defaultFontName}`, config = {
    fonts: {},
    onlyAllowShorthands: !1,
    fontLanguages: [],
    animations: {},
    media: {},
    ...configIn,
    unset: {
      fontFamily: defaultFontName ? defaultFont : void 0,
      ...configIn.unset
    },
    settings: {
      // move deprecated settings here so we can reference them all using `getSetting`
      // TODO remove this on v2
      disableSSR: configIn.disableSSR,
      defaultFont: configIn.defaultFont,
      disableRootThemeClass: configIn.disableRootThemeClass,
      onlyAllowShorthands: configIn.onlyAllowShorthands,
      mediaQueryDefaultActive: configIn.mediaQueryDefaultActive,
      themeClassNameOnRoot: configIn.themeClassNameOnRoot,
      cssStyleSeparator: configIn.cssStyleSeparator,
      webContainerType: "inline-size",
      ...configIn.settings
    },
    tokens,
    // vite made this into a function if it wasn't set
    shorthands,
    inverseShorthands: shorthands ? Object.fromEntries(Object.entries(shorthands).map(([k, v]) => [v, k])) : {},
    themes: themeConfig.themes,
    fontsParsed: fontsParsed || {},
    themeConfig,
    tokensParsed,
    parsed: !0,
    getNewCSS,
    getCSS,
    defaultFont,
    fontSizeTokens: fontSizeTokens || /* @__PURE__ */ new Set(),
    specificTokens
    // const tokens = [...getToken(tokens.size[0])]
    // .spacer-sm + ._dsp_contents._dsp-sm-hidden { margin-left: -var(--${}) }
  };
  return (0, import_config.setConfig)(config), (0, import_useMedia.configureMedia)(config), createdConfigs.set(config, !0), import_config.configListeners.size && (import_config.configListeners.forEach((cb) => cb(config)), import_config.configListeners.clear()),  false && (0), config;
}
function getThemesDeduped(themes) {
  const dedupedThemes = [], existing = /* @__PURE__ */ new Map();
  for (const themeName in themes) {
    const darkOrLightSpecificPrefix = themeName.startsWith("dark") ? "dark" : themeName.startsWith("light") ? "light" : "", rawTheme = themes[themeName], key = darkOrLightSpecificPrefix + JSON.stringify(rawTheme);
    if (existing.has(key)) {
      existing.get(key).names.push(themeName);
      continue;
    }
    const theme = { ...rawTheme };
    for (const key2 in theme)
      (0, import_themes.ensureThemeVariable)(theme, key2);
    const deduped = {
      names: [themeName],
      theme
    };
    dedupedThemes.push(deduped), existing.set(key, deduped);
  }
  return dedupedThemes;
}
//# sourceMappingURL=createTamagui.js.map


/***/ }),

/***/ 72705:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var createTheme_exports = {};
__export(createTheme_exports, {
  createTheme: () => createTheme
});
module.exports = __toCommonJS(createTheme_exports);
const createTheme = (theme) => theme;
//# sourceMappingURL=createTheme.js.map


/***/ }),

/***/ 6019:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var createTokens_exports = {};
__export(createTokens_exports, {
  createTokens: () => createTokens
});
module.exports = __toCommonJS(createTokens_exports);
var import_createVariables = __webpack_require__(26596);
function createTokens(tokens) {
  return (0, import_createVariables.createVariables)(tokens);
}
//# sourceMappingURL=createTokens.js.map


/***/ }),

/***/ 88957:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(34155);
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var createVariable_exports = {};
__export(createVariable_exports, {
  createCSSVariable: () => createCSSVariable,
  createVariable: () => createVariable,
  didGetVariableValue: () => didGetVariableValue,
  getVariable: () => getVariable,
  getVariableName: () => getVariableName,
  getVariableValue: () => getVariableValue,
  getVariableVariable: () => getVariableVariable,
  isVariable: () => isVariable,
  setDidGetVariableValue: () => setDidGetVariableValue,
  variableToString: () => variableToString
});
module.exports = __toCommonJS(createVariable_exports);
var import_constants = __webpack_require__(14810), import_helpers = __webpack_require__(37513), import_config = __webpack_require__(16265);
function constructCSSVariableName(name) {
  return `var(--${process.env.TAMAGUI_CSS_VARIABLE_PREFIX || ""}${name})`;
}
const createVariable = (props, skipHash = !1) => {
  if (!skipHash && isVariable(props)) return props;
  const { key, name, val } = props;
  return {
    isVar: !0,
    key,
    name: skipHash ? name : (0, import_helpers.simpleHash)(name, 40),
    val,
    variable: import_constants.isWeb ? skipHash ? constructCSSVariableName(name) : createCSSVariable(name) : ""
  };
};
function variableToString(vrble, getValue = !1) {
  return isVariable(vrble) ? !getValue && import_constants.isWeb && vrble.variable ? vrble.variable : `${vrble.val}` : `${vrble || ""}`;
}
function isVariable(v) {
  return v && typeof v == "object" && "isVar" in v;
}
function getVariable(nameOrVariable, group = "size") {
  if (setDidGetVariableValue(!0), isVariable(nameOrVariable))
    return variableToString(nameOrVariable);
  const tokens = (0, import_config.getConfig)().tokensParsed;
  return variableToString(tokens[group]?.[nameOrVariable] ?? nameOrVariable);
}
let accessed = !1;
const setDidGetVariableValue = (val) => accessed = val, didGetVariableValue = () => accessed;
function getVariableValue(v, group) {
  if (isVariable(v))
    return setDidGetVariableValue(!0), v.val;
  if (group) {
    const token = (0, import_config.getConfig)().tokensParsed[group]?.[v];
    if (token)
      return setDidGetVariableValue(!0), token.val;
  }
  return v;
}
function getVariableName(v) {
  return isVariable(v) ? v.name : v;
}
function getVariableVariable(v) {
  return isVariable(v) ? v.variable : v;
}
const createCSSVariable = (nameProp, includeVar = !0) => {
  if (false)
    {}
  const name = (0, import_helpers.simpleHash)(nameProp, 60);
  return includeVar ? constructCSSVariableName(name) : name;
};
//# sourceMappingURL=createVariable.js.map


/***/ }),

/***/ 26596:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var createVariables_exports = {};
__export(createVariables_exports, {
  createVariables: () => createVariables
});
module.exports = __toCommonJS(createVariables_exports);
var import_helpers = __webpack_require__(37513), import_createVariable = __webpack_require__(88957);
const cache = /* @__PURE__ */ new WeakMap(), createVariables = (tokens, parentPath = "", isFont = !1) => {
  if (cache.has(tokens)) return tokens;
  const res = {};
  let i = 0;
  for (let keyIn in tokens) {
    i++;
    const val = tokens[keyIn], isPrefixed = keyIn[0] === "$", keyWithPrefix = isPrefixed ? keyIn : `$${keyIn}`, key = isPrefixed ? keyWithPrefix.slice(1) : keyIn;
    if ((0, import_createVariable.isVariable)(val)) {
      res[key] = val;
      continue;
    }
    const niceKey = (0, import_helpers.simpleHash)(key, 1e3), name = parentPath && parentPath !== "color" ? `${parentPath}-${niceKey}` : niceKey;
    if (val && typeof val == "object") {
      res[key] = createVariables(
        tokens[key],
        name,
        !1
        /* note: don't pass isFont down, we want to avoid it past the first level */
      );
      continue;
    }
    const finalValue = (0, import_createVariable.isVariable)(val) ? val : (0, import_createVariable.createVariable)({ val, name, key: keyWithPrefix });
    res[key] = finalValue;
  }
  return cache.set(res, !0), res;
};
//# sourceMappingURL=createVariables.js.map


/***/ }),

/***/ 28646:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var defaultComponentState_exports = {};
__export(defaultComponentState_exports, {
  defaultComponentState: () => defaultComponentState,
  defaultComponentStateMounted: () => defaultComponentStateMounted,
  defaultComponentStateShouldEnter: () => defaultComponentStateShouldEnter
});
module.exports = __toCommonJS(defaultComponentState_exports);
const defaultComponentState = {
  hover: !1,
  press: !1,
  pressIn: !1,
  focus: !1,
  focusVisible: !1,
  unmounted: !0,
  disabled: !1
}, defaultComponentStateMounted = {
  ...defaultComponentState,
  unmounted: !1
}, defaultComponentStateShouldEnter = {
  ...defaultComponentState,
  unmounted: "should-enter"
};
//# sourceMappingURL=defaultComponentState.js.map


/***/ }),

/***/ 21497:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var ThemeManager_exports = {};
__export(ThemeManager_exports, {
  ThemeManager: () => ThemeManager,
  getHasThemeUpdatingProps: () => getHasThemeUpdatingProps,
  getManagers: () => getManagers
});
module.exports = __toCommonJS(ThemeManager_exports);
var import_constants = __webpack_require__(14810), import_config = __webpack_require__(16265), import_constants2 = __webpack_require__(36297);
const emptyState = { name: "" };
function getHasThemeUpdatingProps(props) {
  return !!(props.name || props.componentName || props.inverse || props.reset);
}
let uid = 0;
class ThemeManager {
  constructor(props = {}, parentManager) {
    this.props = props;
    if (uid = (uid + 1) % Number.MAX_VALUE, this.id = uid, parentManager === "root") {
      this.updateStateFromProps(props, !1);
      return;
    }
    if (!parentManager)
      throw  false ? 0 : "\u274C 000";
    if (this.parentManager = parentManager, !this.updateStateFromProps(props, !1))
      return parentManager;
  }
  id = 0;
  themeListeners = /* @__PURE__ */ new Set();
  parentManager = null;
  state = emptyState;
  updateStateFromProps(props = this.props || {}, shouldNotify = !0) {
    if (this.props = props, props.forceTheme)
      return this.state.theme = props.forceTheme, this.state.name = props.name || "", this.updateState(this.state, !0), this.state;
    const nextState = this.getStateIfChanged(props);
    if (nextState)
      return this.updateState(nextState, shouldNotify), nextState;
  }
  updateState(nextState, shouldNotify = !0) {
    this.state = nextState, this._allKeys = null, shouldNotify && queueMicrotask(() => {
      this.notify();
    });
  }
  getStateIfChanged(props = this.props, state = this.state, parentManager = this.parentManager) {
    const _ = this.getState(props, parentManager);
    if (state && state !== emptyState && !_)
      return parentManager?.state;
    if (this.getStateShouldChange(_, state))
      return _;
  }
  getStateShouldChange(nextState, state = this.state) {
    return !(!nextState?.theme || nextState.theme === state?.theme);
  }
  getState(props = this.props, parentManager = this.parentManager) {
    return getState(props, parentManager) || null;
  }
  _allKeys = null;
  get allKeys() {
    return this._allKeys ||= /* @__PURE__ */ new Set([
      ...this.parentManager?.allKeys || [],
      ...Object.keys(this.state.theme || {})
    ]), this._allKeys;
  }
  notify(forced = !1) {
    this.themeListeners.forEach((cb) => cb(this.state.name, this, forced)),  false && (0);
  }
  onChangeTheme(cb, debugId) {
    return  false && (0), this.themeListeners.add(cb), () => {
      this.themeListeners.delete(cb);
    };
  }
}
function getState(props, manager) {
  if (props.name && props.reset)
    throw new Error(
       true ? "\u274C004" : 0
    );
  if (!getHasThemeUpdatingProps(props))
    return null;
  const themes = (0, import_config.getThemes)(), [allManagers, componentManagers] = getManagers(manager), isDirectParentAComponentTheme = !!manager?.state.isComponent, startIndex = props.reset && !isDirectParentAComponentTheme ? 1 : 0;
  let baseManager = allManagers[startIndex], parentManager = allManagers[startIndex + 1];
  if (!baseManager && props.reset)
    return  false && 0, null;
  const { componentName } = props;
  let result = null, baseName = baseManager?.state.name || "";
  baseManager?.state.isComponent && (baseName = baseName.replace(/_[A-Z][A-Za-z]+/, ""));
  const nextName = props.reset ? baseName : props.name || "", allComponentThemes = componentManagers.map((x) => x?.state.name || "");
  isDirectParentAComponentTheme && allComponentThemes.shift();
  const base = baseName.split(import_constants2.THEME_NAME_SEPARATOR), max = base.length, min = props.componentName && !nextName ? max : 0;
  for (let i = max; i >= min; i--) {
    let prefix = base.slice(0, i).join(import_constants2.THEME_NAME_SEPARATOR);
    props.inverse && (prefix = inverseThemeName(prefix));
    let potentials = [];
    if (prefix && prefix !== baseName && prefix.includes(nextName) && potentials.push(prefix), nextName && potentials.unshift(prefix ? `${prefix}_${nextName}` : nextName), i === 1) {
      const lastSegment = potentials.findIndex((x) => !x.includes("_"));
      lastSegment > 0 && potentials.splice(lastSegment, 0, nextName);
    }
    if (componentName && !props.reset) {
      const baseLen = base.length;
      let componentPotentials = [];
      if (nextName && baseLen > 1) {
        const beforeSeparator = base[0];
        componentPotentials.push(`${beforeSeparator}_${nextName}_${componentName}`);
      }
      if (componentPotentials.push(`${prefix}_${componentName}`), nextName) {
        if (i > baseLen) {
          const prefixLessOne = base.slice(0, i - 1).join(import_constants2.THEME_NAME_SEPARATOR);
          if (prefixLessOne) {
            const lessSpecific = `${prefixLessOne}_${nextName}_${componentName}`;
            componentPotentials.unshift(lessSpecific);
          }
        }
        const moreSpecific = `${prefix}_${nextName}_${componentName}`;
        componentPotentials.unshift(moreSpecific);
      }
      potentials = [...componentPotentials, ...potentials, ...allComponentThemes];
    }
    const found = potentials.find((t) => t in themes);
    if ( false && 0, found) {
      const names = found.split("_"), [firstName, ...restNames] = names, lastName = names[names.length - 1], isComponent = lastName[0] === lastName[0].toUpperCase(), scheme = firstName === "light" ? "light" : firstName === "dark" ? "dark" : void 0, pre = import_constants2.THEME_CLASSNAME_PREFIX, className = import_constants.isWeb ? `${pre}sub_theme ${pre}${!scheme || !restNames.length ? firstName : restNames.join("_")}` : "", parentName = (baseManager || parentManager)?.state?.name;
      result = {
        name: found,
        parentName,
        theme: themes[found],
        className,
        isComponent,
        scheme
      };
      break;
    }
  }
  return  false && (0), result;
}
const inverseThemeName = (themeName) => themeName.startsWith("light") ? themeName.replace(/^light/, "dark") : themeName.replace(/^dark/, "light");
function getManagers(themeManager) {
  const comp = [], all = [];
  let cur = themeManager;
  for (; cur; )
    all.push(cur), cur.state.isComponent && comp.push(cur), cur = cur.parentManager;
  return [all, comp];
}
//# sourceMappingURL=ThemeManager.js.map


/***/ }),

/***/ 2856:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var ThemeManagerContext_exports = {};
__export(ThemeManagerContext_exports, {
  ThemeManagerIDContext: () => ThemeManagerIDContext
});
module.exports = __toCommonJS(ThemeManagerContext_exports);
var import_react = __toESM(__webpack_require__(67294));
const ThemeManagerIDContext = import_react.default.createContext(1);
//# sourceMappingURL=ThemeManagerContext.js.map


/***/ }),

/***/ 44395:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var createMediaStyle_exports = {};
__export(createMediaStyle_exports, {
  MEDIA_SEP: () => MEDIA_SEP,
  createMediaStyle: () => createMediaStyle
});
module.exports = __toCommonJS(createMediaStyle_exports);
var import_config = __webpack_require__(16265), import_useMedia = __webpack_require__(85030), import_getGroupPropParts = __webpack_require__(20793);
const MEDIA_SEP = "_";
let prefixes = null, selectors = null;
const groupPseudoToPseudoCSSMap = {
  press: "active"
}, specifities = new Array(5).fill(0).map((_, i) => new Array(i).fill(":root").join(""));
function getThemeOrGroupSelector(name, styleInner, isGroup, groupParts, isTheme = !1, precedenceImportancePrefix = "") {
  const selectorStart = styleInner.indexOf(":root"), selectorEnd = styleInner.lastIndexOf("{"), selector = styleInner.slice(selectorStart, selectorEnd), precedenceSpace = (0, import_config.getSetting)("themeClassNameOnRoot") && isTheme ? "" : " ", pseudoSelectorName = groupParts.pseudo ? groupPseudoToPseudoCSSMap[groupParts.pseudo] || groupParts.pseudo : void 0, pseudoSelector = pseudoSelectorName ? `:${pseudoSelectorName}` : "", presedencePrefix = `:root${precedenceImportancePrefix}${precedenceSpace}`, mediaSelector = `.t_${isGroup ? "group_" : ""}${name}${pseudoSelector}`;
  return [
    selector,
    `${presedencePrefix}${mediaSelector} ${selector.replace(":root", "")}`
  ];
}
const createMediaStyle = (styleObject, mediaKeyIn, mediaQueries, type, negate, priority) => {
  const [property, , identifier, , rules] = styleObject, enableMediaPropOrder = (0, import_config.getSetting)("mediaPropOrder"), isTheme = type === "theme", isPlatform = type === "platform", isGroup = type === "group", isNonWindowMedia = isTheme || isPlatform || isGroup, negKey = negate ? "0" : "", ogPrefix = identifier.slice(0, identifier.indexOf("-") + 1), id = `${ogPrefix}${MEDIA_SEP}${mediaKeyIn.replace("-", "")}${negKey}${MEDIA_SEP}`;
  let styleRule = "", groupPriority = "", groupMediaKey, containerName, nextIdentifier = identifier.replace(ogPrefix, id), styleInner = rules.map((rule) => rule.replace(identifier, nextIdentifier)).join(";"), isHover = !1;
  if (isNonWindowMedia) {
    let specificity = (priority || 0) + (isGroup || isPlatform ? 1 : 0);
    if (isTheme || isGroup) {
      const { name, media, pseudo } = (0, import_getGroupPropParts.getGroupPropParts)(mediaKeyIn);
      groupMediaKey = media;
      const groupParts = (0, import_getGroupPropParts.getGroupPropParts)(mediaKeyIn);
      isGroup && (containerName = name), pseudo === "press" && (specificity += 2), pseudo === "hover" && (isHover = !0);
      const [selector, nextSelector] = getThemeOrGroupSelector(
        name,
        styleInner,
        isGroup,
        groupParts,
        isTheme,
        specifities[specificity]
      );
      styleRule = styleInner.replace(selector, nextSelector);
    } else
      styleRule = `${specifities[specificity]}${styleInner}`;
  }
  if (!isNonWindowMedia || groupMediaKey) {
    if (!selectors) {
      const mediaKeys = Object.keys(mediaQueries);
      selectors = Object.fromEntries(
        mediaKeys.map((key) => [key, (0, import_useMedia.mediaObjectToString)(mediaQueries[key])])
      ), enableMediaPropOrder || (prefixes = Object.fromEntries(
        mediaKeys.map((k, index) => [k, new Array(index + 1).fill(":root").join("")])
      ));
    }
    const mediaKey = groupMediaKey || mediaKeyIn, mediaSelector = selectors[mediaKey], mediaQuery = `${negate ? "not all and " : ""}${mediaSelector}`, precedenceImportancePrefix = groupMediaKey ? groupPriority : enableMediaPropOrder && priority ? (
      // this new array should be cached
      specifities[priority]
    ) : (
      // @ts-ignore
      prefixes[mediaKey]
    ), prefix = groupMediaKey ? `@container ${containerName}` : "@media";
    groupMediaKey && (styleInner = styleRule), styleInner.includes(prefix) ? styleRule = styleInner.replace("{", ` and ${mediaQuery} {`).replace("and screen and", "and") : styleRule = `${prefix} ${mediaQuery}{${precedenceImportancePrefix}${styleInner}}`, groupMediaKey && (styleRule = `@supports (contain: ${(0, import_config.getSetting)("webContainerType") || "inline-size"}) {${styleRule}}`);
  }
  return isHover && (styleRule = `@media (hover:hover){${styleRule}}`), [property, void 0, nextIdentifier, void 0, [styleRule]];
};
//# sourceMappingURL=createMediaStyle.js.map


/***/ }),

/***/ 66575:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var createShallowSetState_exports = {};
__export(createShallowSetState_exports, {
  createShallowSetState: () => createShallowSetState,
  isEqualShallow: () => isEqualShallow,
  mergeIfNotShallowEqual: () => mergeIfNotShallowEqual
});
module.exports = __toCommonJS(createShallowSetState_exports);
var import_react = __webpack_require__(67294);
const callImmediate = (cb) => cb();
function createShallowSetState(setter, isDisabled, transition, debug) {
  return (next) => {
    (transition ? import_react.startTransition : callImmediate)(() => {
      setter((prev) => mergeIfNotShallowEqual(prev, next, isDisabled, debug));
    });
  };
}
function mergeIfNotShallowEqual(prev, next, isDisabled, debug) {
  if (isDisabled || !prev || !next || isEqualShallow(prev, next))
    return prev || next;
  if (false)
    {}
  return { ...prev, ...next };
}
function isEqualShallow(prev, next) {
  for (const key in next)
    if (prev[key] !== next[key])
      return !1;
  return !0;
}
//# sourceMappingURL=createShallowSetState.js.map


/***/ }),

/***/ 97564:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var createStyledContext_exports = {};
__export(createStyledContext_exports, {
  createStyledContext: () => createStyledContext
});
module.exports = __toCommonJS(createStyledContext_exports);
var import_react = __toESM(__webpack_require__(67294)), import_objectIdentityKey = __webpack_require__(2761), import_jsx_runtime = __webpack_require__(85893);
function createStyledContext(defaultValues) {
  const OGContext = import_react.default.createContext(defaultValues), OGProvider = OGContext.Provider, Context = OGContext, scopedContexts = /* @__PURE__ */ new Map(), Provider = ({
    children,
    scope,
    ...values
  }) => {
    const next = import_react.default.useMemo(() => ({
      // this ! is a workaround for ts error
      ...defaultValues,
      ...values
    }), [(0, import_objectIdentityKey.objectIdentityKey)(values)]);
    let Provider2 = OGProvider;
    if (scope) {
      let ScopedContext = scopedContexts.get(scope);
      ScopedContext || (ScopedContext = import_react.default.createContext(defaultValues), scopedContexts.set(scope, ScopedContext)), Provider2 = ScopedContext.Provider;
    }
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Provider2, { value: next, children });
  }, useStyledContext = (scope) => {
    const context = scope ? scopedContexts.get(scope) : OGContext;
    return import_react.default.useContext(context);
  };
  return Context.Provider = Provider, Context.props = defaultValues, Context.context = OGContext, Context.useStyledContext = useStyledContext, Context;
}
//# sourceMappingURL=createStyledContext.js.map


/***/ }),

/***/ 30550:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var defaultOffset_exports = {};
__export(defaultOffset_exports, {
  defaultOffset: () => defaultOffset
});
module.exports = __toCommonJS(defaultOffset_exports);
const defaultOffset = { height: 0, width: 0 };
//# sourceMappingURL=defaultOffset.js.map


/***/ }),

/***/ 32549:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all2) => {
  for (var name in all2)
    __defProp(target, name, { get: all2[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var expandStyle_exports = {};
__export(expandStyle_exports, {
  expandStyle: () => expandStyle
});
module.exports = __toCommonJS(expandStyle_exports);
var import_constants = __webpack_require__(14810), import_webToNativeProps = __webpack_require__(27593), import_config = __webpack_require__(16265);
const neg1Flex = [
  ["flexGrow", 0],
  ["flexShrink", 1],
  ["flexBasis", "auto"]
];
function expandStyle(key, value) {
  if (key === "flex")
    return value === -1 ? neg1Flex : [
      ["flexGrow", value],
      ["flexShrink", 1],
      ["flexBasis", (0, import_config.getConfig)().settings.styleCompat === "react-native" ? 0 : "auto"]
    ];
  switch (key) {
    case "textAlignVertical":
      return [["verticalAlign", value === "center" ? "middle" : value]];
    case "writingDirection":
      return [["direction", value]];
  }
  if (key in EXPANSIONS)
    return EXPANSIONS[key].map((key2) => [key2, value]);
  if (key in import_webToNativeProps.webToNativeExpansion)
    return import_webToNativeProps.webToNativeExpansion[key].map((key2) => [key2, value]);
  if (key in import_webToNativeProps.webToNativeDynamicExpansion)
    return import_webToNativeProps.webToNativeDynamicExpansion[key](value);
}
const all = ["Top", "Right", "Bottom", "Left"], horiz = ["Right", "Left"], vert = ["Top", "Bottom"], xy = ["X", "Y"], EXPANSIONS = {
  borderColor: ["TopColor", "RightColor", "BottomColor", "LeftColor"],
  borderRadius: [
    "TopLeftRadius",
    "TopRightRadius",
    "BottomRightRadius",
    "BottomLeftRadius"
  ],
  borderWidth: ["TopWidth", "RightWidth", "BottomWidth", "LeftWidth"],
  margin: all,
  marginHorizontal: horiz,
  marginVertical: vert,
  overscrollBehavior: xy,
  padding: all,
  paddingHorizontal: horiz,
  paddingVertical: vert,
  ...import_constants.isWeb && {
    // react-native only supports borderStyle
    borderStyle: ["TopStyle", "RightStyle", "BottomStyle", "LeftStyle"],
    // react-native doesn't support X / Y
    overflow: xy
  }
};
for (const parent in EXPANSIONS) {
  const prefix = parent.slice(0, /[A-Z]/.exec(parent)?.index ?? parent.length);
  EXPANSIONS[parent] = EXPANSIONS[parent].map((k) => `${prefix}${k}`);
}
//# sourceMappingURL=expandStyle.js.map


/***/ }),

/***/ 36152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var expandStyles_exports = {};
__export(expandStyles_exports, {
  fixStyles: () => fixStyles
});
module.exports = __toCommonJS(expandStyles_exports);
var import_constants = __webpack_require__(14810), import_normalizeShadow = __webpack_require__(27234);
function fixStyles(style) {
  (style.shadowRadius != null || style.shadowColor || style.shadowOpacity != null || style.shadowOffset) && Object.assign(style, (0, import_normalizeShadow.normalizeShadow)(style));
  for (const key in borderDefaults)
    key in style && (style[borderDefaults[key]] ||= "solid");
}
const nativeStyle = import_constants.isWeb ? null : "borderStyle", borderDefaults = {
  borderWidth: "borderStyle",
  borderBottomWidth: nativeStyle || "borderBottomStyle",
  borderTopWidth: nativeStyle || "borderTopStyle",
  borderLeftWidth: nativeStyle || "borderLeftStyle",
  borderRightWidth: nativeStyle || "borderRightStyle"
  // TODO: need to add borderBlock and borderInline here, but they are alot and might impact performance
};
//# sourceMappingURL=expandStyles.js.map


/***/ }),

/***/ 13642:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var getExpandedShorthands_exports = {};
__export(getExpandedShorthands_exports, {
  getExpandedShorthands: () => getExpandedShorthands
});
module.exports = __toCommonJS(getExpandedShorthands_exports);
var import_config = __webpack_require__(16265);
function getExpandedShorthands(props) {
  const shorthands = (0, import_config.getConfig)().shorthands;
  if (!shorthands) return props;
  const res = {};
  for (const key in props)
    res[shorthands[key] || key] = props[key];
  return res;
}
//# sourceMappingURL=getExpandedShorthands.js.map


/***/ }),

/***/ 20793:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var getGroupPropParts_exports = {};
__export(getGroupPropParts_exports, {
  getGroupPropParts: () => getGroupPropParts
});
module.exports = __toCommonJS(getGroupPropParts_exports);
var import_useMedia = __webpack_require__(85030);
function getGroupPropParts(groupProp) {
  const mediaQueries = (0, import_useMedia.getMedia)(), [_, name, part3, part4] = groupProp.split("-");
  let pseudo;
  const media = part3 in mediaQueries ? part3 : void 0;
  return media ? pseudo = part4 : pseudo = part3, { name, pseudo, media };
}
//# sourceMappingURL=getGroupPropParts.js.map


/***/ }),

/***/ 41384:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(34155);
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var getSplitStyles_exports = {};
__export(getSplitStyles_exports, {
  PROP_SPLIT: () => PROP_SPLIT,
  getSplitStyles: () => getSplitStyles,
  getSubStyle: () => getSubStyle,
  useSplitStyles: () => useSplitStyles
});
module.exports = __toCommonJS(getSplitStyles_exports);
var import_react = __toESM(__webpack_require__(67294)), import_constants = __webpack_require__(14810), import_helpers = __webpack_require__(37513), import_config = __webpack_require__(16265), import_accessibilityDirectMap = __webpack_require__(95466), import_constants2 = __webpack_require__(36297), import_isDevTools = __webpack_require__(57405), import_useMedia = __webpack_require__(85030), import_createMediaStyle = __webpack_require__(44395), import_expandStyles = __webpack_require__(36152), import_getGroupPropParts = __webpack_require__(20793), import_getStylesAtomic = __webpack_require__(9161), import_insertStyleRule = __webpack_require__(37269), import_log = __webpack_require__(97727), import_normalizeValueWithProperty = __webpack_require__(31053), import_propMapper = __webpack_require__(80408), import_pseudoDescriptors = __webpack_require__(45204), import_skipProps = __webpack_require__(86255), import_transformsToString = __webpack_require__(90013), import_isActivePlatform = __webpack_require__(4268);
const consoleGroupCollapsed = import_constants.isWeb ? console.groupCollapsed : console.info;
let conf;
const PROP_SPLIT = "-";
function isValidStyleKey(key, staticConfig) {
  return (staticConfig.validStyles || (staticConfig.isText || staticConfig.isInput ? import_helpers.stylePropsText : import_helpers.validStyles))[key] || staticConfig.accept?.[key];
}
const getSplitStyles = (props, staticConfig, theme, themeName, componentState, styleProps, parentSplitStyles, context, elementType, debug, skipThemeTokenResolution) => {
  conf = conf || (0, import_config.getConfig)(), import_constants.isWeb && styleProps.isAnimated && conf.animations.isReactNative && !styleProps.noNormalize && (styleProps.noNormalize = "values");
  const { shorthands } = conf, {
    isHOC,
    isText,
    isInput,
    variants,
    isReactNative,
    inlineProps,
    inlineWhenUnflattened,
    parentStaticConfig,
    acceptsClassName
  } = staticConfig, viewProps = {}, mediaState = styleProps.mediaState || import_useMedia.mediaState, usedKeys = {}, shouldDoClasses = acceptsClassName && import_constants.isWeb && !styleProps.noClassNames, rulesToInsert = {}, classNames = {}, transforms = {};
  let pseudos = null, space = props.space, hasMedia = !1, dynamicThemeAccess, pseudoGroups, mediaGroups, className = props.className || "", mediaStylesSeen = 0;
  const styleState = {
    classNames,
    conf,
    props,
    styleProps,
    componentState,
    staticConfig,
    style: null,
    theme,
    usedKeys,
    viewProps,
    context,
    debug,
    skipThemeTokenResolution
  };
   false && (0);
  const { asChild } = props, { accept } = staticConfig, { noSkip, disableExpandShorthands, noExpand } = styleProps, { webContainerType } = conf.settings, parentVariants = parentStaticConfig?.variants;
  for (const keyOg in props) {
    let keyInit = keyOg, valInit = props[keyInit];
    if (accept) {
      const accepted = accept[keyInit];
      if ((accepted === "style" || accepted === "textStyle") && valInit && typeof valInit == "object") {
        viewProps[keyInit] = getSubStyle(
          styleState,
          keyInit,
          valInit,
          styleProps.noClassNames
        );
        continue;
      }
    }
    if ( false && 0, disableExpandShorthands || keyInit in shorthands && (keyInit = shorthands[keyInit]), keyInit === "className" || keyInit in usedKeys || asChild && import_constants2.webViewFlexCompatStyles[keyInit] === valInit)
      continue;
    if (keyInit in import_skipProps.skipProps && !noSkip && !isHOC) {
      if (keyInit === "group") {
        const identifier = `t_group_${valInit}`, containerCSS = [
          "continer",
          void 0,
          identifier,
          void 0,
          [
            `.${identifier} { container-name: ${valInit}; container-type: ${webContainerType || "inline-size"}; }`
          ]
        ];
        addStyleToInsertRules(rulesToInsert, containerCSS);
      }
      continue;
    }
    const valInitType = typeof valInit, isValidStyleKeyInit = isValidStyleKey(keyInit, staticConfig);
    if (isValidStyleKeyInit && valInitType === "string" && valInit[0] === "_") {
      const isValidClassName = keyInit in import_helpers.validStyles, isMediaOrPseudo2 = !isValidClassName && // media are flattened for some reason to color-hover keys,
      // we should probably just leave them in place to avoid extra complexity
      keyInit.includes(PROP_SPLIT) && import_helpers.validStyles[keyInit.split(PROP_SPLIT)[0]];
      if (isValidClassName || isMediaOrPseudo2) {
        shouldDoClasses ? (mergeClassName(transforms, classNames, keyInit, valInit, isMediaOrPseudo2), styleState.style && delete styleState.style[keyInit]) : (styleState.style ||= {}, styleState.style[keyInit] = (0, import_normalizeValueWithProperty.reverseMapClassNameToValue)(keyInit, valInit), delete classNames[keyInit]);
        continue;
      }
    }
    if (keyInit === "dataSet") {
      for (const keyInit2 in valInit)
        viewProps[`data-${hyphenate(keyInit2)}`] = valInit[keyInit2];
      continue;
    }
    if (!noExpand) {
      if (keyInit === "disabled" && valInit === !0 && (viewProps["aria-disabled"] = !0, (elementType === "button" || elementType === "form" || elementType === "input" || elementType === "select" || elementType === "textarea") && (viewProps.disabled = !0), !variants?.disabled))
        continue;
      if (keyInit === "testID") {
        viewProps[isReactNative ? keyInit : "data-testid"] = valInit;
        continue;
      }
      if (keyInit === "id" || keyInit === "nativeID") {
        viewProps.id = valInit;
        continue;
      }
      let didUseKeyInit = !1;
      if (isReactNative) {
        if (keyInit in import_accessibilityDirectMap.accessibilityDirectMap || keyInit.startsWith("accessibility")) {
          viewProps[keyInit] = valInit;
          continue;
        }
      } else {
        if (didUseKeyInit = !0, keyInit in import_accessibilityDirectMap.accessibilityDirectMap) {
          viewProps[import_accessibilityDirectMap.accessibilityDirectMap[keyInit]] = valInit;
          continue;
        }
        switch (keyInit) {
          case "accessibilityRole": {
            valInit === "none" ? viewProps.role = "presentation" : viewProps.role = accessibilityRoleToWebRole[valInit] || valInit;
            continue;
          }
          case "accessibilityLabelledBy":
          case "accessibilityFlowTo":
          case "accessibilityControls":
          case "accessibilityDescribedBy": {
            viewProps[`aria-${keyInit.replace("accessibility", "").toLowerCase()}`] = processIDRefList(valInit);
            continue;
          }
          case "accessibilityKeyShortcuts": {
            Array.isArray(valInit) && (viewProps["aria-keyshortcuts"] = valInit.join(" "));
            continue;
          }
          case "accessibilityLiveRegion": {
            viewProps["aria-live"] = valInit === "none" ? "off" : valInit;
            continue;
          }
          case "accessibilityReadOnly": {
            viewProps["aria-readonly"] = valInit, (elementType === "input" || elementType === "select" || elementType === "textarea") && (viewProps.readOnly = !0);
            continue;
          }
          case "accessibilityRequired": {
            viewProps["aria-required"] = valInit, (elementType === "input" || elementType === "select" || elementType === "textarea") && (viewProps.required = valInit);
            continue;
          }
          default:
            didUseKeyInit = !1;
        }
      }
      if (didUseKeyInit)
        continue;
    }
    const isShorthand = keyInit in shorthands;
    let isVariant = !isValidStyleKeyInit && variants && keyInit in variants;
    const isStyleLikeKey = isShorthand || isValidStyleKeyInit || isVariant;
    let isPseudo = keyInit in import_helpers.validPseudoKeys, isMedia = !isStyleLikeKey && !isPseudo && (0, import_useMedia.isMediaKey)(keyInit), isMediaOrPseudo = !!(isMedia || isPseudo);
    if (isMediaOrPseudo && keyInit.startsWith("$group-")) {
      const name = keyInit.split("-")[1];
      context?.groups.subscribe && !context?.groups.state[name] && (keyInit = keyInit.replace("$group-", "$group-true-"));
    }
    const isStyleProp = isValidStyleKeyInit || isMediaOrPseudo || isVariant && !noExpand || isShorthand;
    if (isStyleProp && (asChild === "except-style" || asChild === "except-style-web"))
      continue;
    const shouldPassProp = !isStyleProp || // is in parent variants
    isHOC && parentVariants && keyInit in parentVariants || inlineProps?.has(keyInit), parentVariant = parentVariants?.[keyInit], isHOCShouldPassThrough = !!(isHOC && (isShorthand || isValidStyleKeyInit || isMediaOrPseudo || parentVariant || keyInit in import_skipProps.skipProps)), shouldPassThrough = shouldPassProp || isHOCShouldPassThrough;
    if ( false && (0), shouldPassThrough && (passDownProp(viewProps, keyInit, valInit, isMediaOrPseudo), !isVariant)) {
       false && 0;
      continue;
    }
    if (!noSkip && keyInit in import_skipProps.skipProps) {
       false && 0;
      continue;
    }
    (isText || isInput) && valInit && (keyInit === "fontFamily" || keyInit === shorthands.fontFamily) && valInit in conf.fontsParsed && (styleState.fontFamily = valInit);
    const avoidPropMap = isMediaOrPseudo || !isVariant && !isValidStyleKeyInit, expanded = avoidPropMap ? null : (0, import_propMapper.propMapper)(keyInit, valInit, styleState);
    if (!avoidPropMap) {
      if (!expanded) continue;
      const next = (0, import_propMapper.getPropMappedFontFamily)(expanded);
      next && (styleState.fontFamily = next);
    }
    if (false) {}
    let key = keyInit, val = valInit;
    const max = expanded ? expanded.length : 1;
    for (let i = 0; i < max; i++) {
      if (expanded) {
        const [k, v] = expanded[i];
        key = k, val = v;
      }
      if (val == null || key in usedKeys) continue;
      if (isPseudo = key in import_helpers.validPseudoKeys, isMedia = !isPseudo && !isValidStyleKeyInit && (0, import_useMedia.isMediaKey)(key), isMediaOrPseudo = !!(isMedia || isPseudo), isVariant = variants && key in variants, (inlineProps?.has(key) ||  false && 0) && (viewProps[key] = props[key] ?? val), styleProps.noExpand && isPseudo || isHOC && (isMediaOrPseudo || parentStaticConfig?.variants?.[keyInit])) {
        passDownProp(viewProps, key, val, isMediaOrPseudo),  false && (0);
        continue;
      }
      if (isPseudo) {
        if (!val) continue;
        const pseudoStyleObject = getSubStyle(
          styleState,
          key,
          val,
          styleProps.noClassNames
        ), descriptor = import_pseudoDescriptors.pseudoDescriptors[key], isEnter = key === "enterStyle", isExit = key === "exitStyle";
        if (!descriptor)
          continue;
        if ((!shouldDoClasses || "" === "is_static") && (pseudos ||= {}, pseudos[key] ||= {}, "" === "is_static")) {
          Object.assign(pseudos[key], pseudoStyleObject);
          continue;
        }
        if (shouldDoClasses && !isExit) {
          const pseudoStyles = (0, import_getStylesAtomic.getStyleAtomic)(pseudoStyleObject, descriptor);
           false && (0);
          for (const psuedoStyle of pseudoStyles) {
            const fullKey = `${psuedoStyle[import_helpers.StyleObjectProperty]}${PROP_SPLIT}${descriptor.name}`;
            fullKey in usedKeys || (addStyleToInsertRules(rulesToInsert, psuedoStyle), mergeClassName(
              transforms,
              classNames,
              fullKey,
              psuedoStyle[import_helpers.StyleObjectIdentifier],
              isMediaOrPseudo,
              !0
            ));
          }
        }
        if (!shouldDoClasses || isExit || isEnter) {
          const descriptorKey = descriptor.stateKey || descriptor.name;
          let isDisabled = componentState[descriptorKey] === !1;
          isExit && (isDisabled = !styleProps.isExiting), isEnter && componentState.unmounted === !1 && (isDisabled = !0),  false && (0);
          const importance = descriptor.priority;
          for (const pkey in pseudoStyleObject) {
            const val2 = pseudoStyleObject[pkey];
            if (isDisabled)
              applyDefaultStyle(pkey, styleState);
            else {
              const curImportance = usedKeys[pkey] || 0, shouldMerge = importance >= curImportance;
              shouldMerge && (pseudos ||= {}, pseudos[key] ||= {}, pseudos[key][pkey] = val2, mergeStyle(styleState, pkey, val2)),  false && 0;
            }
          }
          if (!isDisabled)
            for (const key2 in val) {
              const k = shorthands[key2] || key2;
              usedKeys[k] = Math.max(importance, usedKeys[k] || 0);
            }
        }
        continue;
      }
      if (isMedia) {
        if (!val) continue;
        const hasSpace = val.space, mediaKeyShort = key.slice(1);
        if (hasMedia ||= !0, (hasSpace || !shouldDoClasses || styleProps.willBeAnimated) && (typeof hasMedia != "object" && (hasMedia = {}), hasMedia[mediaKeyShort] = !0), isMedia === "platform" && !(0, import_isActivePlatform.isActivePlatform)(key))
          continue;
        if ( false && 0, shouldDoClasses) {
          const mediaStyle = getSubStyle(styleState, key, val, !1);
          if (hasSpace && (delete mediaStyle.space, mediaState[mediaKeyShort])) {
            const importance = (0, import_useMedia.getMediaImportanceIfMoreImportant)(
              mediaKeyShort,
              "space",
              usedKeys,
              !0
            );
            importance && (space = val.space, usedKeys.space = importance,  false && 0);
          }
          const mediaStyles = (0, import_getStylesAtomic.getStylesAtomic)(mediaStyle), priority = mediaStylesSeen;
          mediaStylesSeen += 1;
          for (const style of mediaStyles) {
            const property = style[0];
            if (property[0] === "$" && property.startsWith("$platform") && !(0, import_isActivePlatform.isActivePlatform)(property))
              continue;
            const out = (0, import_createMediaStyle.createMediaStyle)(
              style,
              mediaKeyShort,
              import_useMedia.mediaQueryConfig,
              isMedia,
              !1,
              priority
            );
             false && 0;
            const fullKey = `${style[import_helpers.StyleObjectProperty]}${PROP_SPLIT}${mediaKeyShort}${style[import_helpers.StyleObjectPseudo] || ""}`;
            fullKey in usedKeys || (addStyleToInsertRules(rulesToInsert, out), mergeClassName(
              transforms,
              classNames,
              fullKey,
              out[import_helpers.StyleObjectIdentifier],
              !0,
              !0
            ));
          }
        } else {
          let mergeMediaStyle = function(key2, val2) {
            styleState.style ||= {}, mergeMediaByImportance(
              styleState,
              mediaKeyShort,
              key2,
              val2,
              usedKeys,
              mediaState[mediaKeyShort],
              importanceBump,
              debug
            ) && key2 === "fontFamily" && (styleState.fontFamily = mediaStyle.fontFamily);
          };
          const isThemeMedia = isMedia === "theme", isGroupMedia = isMedia === "group";
          if (!isThemeMedia && !(isMedia === "platform") && !isGroupMedia) {
            if (!mediaState[mediaKeyShort]) {
               false && 0;
              continue;
            }
             false && 0;
          }
          const mediaStyle = getSubStyle(styleState, key, val, !0);
          let importanceBump = 0;
          if (isThemeMedia) {
            dynamicThemeAccess = !0;
            const mediaThemeName = mediaKeyShort.slice(6);
            if (!(themeName === mediaThemeName || themeName.startsWith(mediaThemeName)))
              continue;
          } else if (isGroupMedia) {
            const groupInfo = (0, import_getGroupPropParts.getGroupPropParts)(mediaKeyShort), groupName = groupInfo.name, groupContext = context?.groups.state[groupName];
            if (!groupContext) {
               false && 0;
              continue;
            }
            const groupPseudoKey = groupInfo.pseudo, groupMediaKey = groupInfo.media, componentGroupState = componentState.group?.[groupName];
            if (groupMediaKey) {
              mediaGroups ||= /* @__PURE__ */ new Set(), mediaGroups.add(groupMediaKey);
              const mediaState2 = componentGroupState?.media;
              let isActive = mediaState2?.[groupMediaKey];
              if (!mediaState2 && groupContext.layout && (isActive = (0, import_useMedia.mediaKeyMatch)(groupMediaKey, groupContext.layout)),  false && 0, !isActive) {
                for (const pkey in mediaStyle)
                  applyDefaultStyle(pkey, styleState);
                continue;
              }
              importanceBump = 2;
            }
            if (groupPseudoKey) {
              pseudoGroups ||= /* @__PURE__ */ new Set(), pseudoGroups.add(groupName);
              const isActive = (componentGroupState || // fallback to context initially
              context.groups.state[groupName]).pseudo?.[groupPseudoKey], priority = import_pseudoDescriptors.pseudoPriorities[groupPseudoKey];
              if ( false && 0, !isActive) {
                for (const pkey in mediaStyle)
                  applyDefaultStyle(pkey, styleState);
                continue;
              }
              importanceBump = priority;
            }
          }
          for (const subKey in mediaStyle) {
            if (subKey === "space") {
              space = valInit.space;
              continue;
            }
            if (subKey[0] === "$") {
              if (!(0, import_isActivePlatform.isActivePlatform)(subKey))
                continue;
              for (const subSubKey in mediaStyle[subKey])
                mergeMediaStyle(subSubKey, mediaStyle[subKey][subSubKey]);
            } else
              mergeMediaStyle(subKey, mediaStyle[subKey]);
          }
        }
        continue;
      }
      if (
        // is HOC we can just pass through the styles as props
        // this fixes issues where style prop got merged with wrong priority
        !isHOC && isValidStyleKey(key, staticConfig)
      ) {
        mergeStyle(styleState, key, val);
        continue;
      }
      isVariant || (viewProps[key] = val);
    }
    if (false) {}
  }
  if (!(styleProps.noNormalize === !1) && (styleState.style && ((0, import_expandStyles.fixStyles)(styleState.style), import_constants.isWeb && !isReactNative && (0, import_getStylesAtomic.styleToCSS)(styleState.style)), styleState.flatTransforms && (styleState.style ||= {}, Object.entries(styleState.flatTransforms).sort(([a], [b]) => a.localeCompare(b)).forEach(([key, val]) => {
    mergeTransform(styleState.style, key, val, !0);
  })), parentSplitStyles)) {
    if (shouldDoClasses)
      for (const key in parentSplitStyles.classNames) {
        const val = parentSplitStyles.classNames[key];
        styleState.style && key in styleState.style || key in classNames || (classNames[key] = val);
      }
    if (!shouldDoClasses)
      for (const key in parentSplitStyles.style)
        key in classNames || styleState.style && key in styleState.style || (styleState.style ||= {}, styleState.style[key] = parentSplitStyles.style[key]);
  }
  if (!styleProps.noNormalize && !staticConfig.isReactNative && !staticConfig.isHOC && (!styleProps.isAnimated || conf.animations.supportsCSSVars) && Array.isArray(styleState.style?.transform) && (styleState.style.transform = (0, import_transformsToString.transformsToString)(styleState.style.transform)), styleState.style && shouldDoClasses) {
    let retainedStyles, shouldRetain = !1;
    if (!styleState.style.$$css) {
      const atomic = (0, import_getStylesAtomic.getStylesAtomic)(styleState.style);
      for (const atomicStyle of atomic) {
        const [key, value, identifier] = atomicStyle, isAnimatedAndAnimateOnly = styleProps.isAnimated && styleProps.noClassNames && (!props.animateOnly || props.animateOnly.includes(key)), nonAnimatedAnimateOnly = !isAnimatedAndAnimateOnly && !styleProps.isAnimated && props.animateOnly?.includes(key);
        isAnimatedAndAnimateOnly ? (retainedStyles ||= {}, retainedStyles[key] = styleState.style[key]) : nonAnimatedAnimateOnly ? (retainedStyles ||= {}, retainedStyles[key] = value, shouldRetain = !0) : (addStyleToInsertRules(rulesToInsert, atomicStyle), mergeClassName(transforms, classNames, key, identifier, !1, !0));
      }
       false && (0), (shouldRetain || "" !== "is_static") && (styleState.style = retainedStyles || {});
    }
    if (transforms)
      for (const namespace in transforms) {
        if (!transforms[namespace]) {
           false && 0;
          continue;
        }
        const [hash, val] = transforms[namespace], identifier = `_transform${hash}`;
        if (import_constants.isClient && !import_insertStyleRule.insertedTransforms[identifier]) {
          const rule = `.${identifier} { transform: ${val}; }`;
          addStyleToInsertRules(rulesToInsert, [
            namespace,
            val,
            identifier,
            void 0,
            [rule]
          ]);
        }
        classNames[namespace] = identifier;
      }
  }
  if (isReactNative)
    viewProps.tabIndex === 0 && (viewProps.accessible ??= !0);
  else if (viewProps.tabIndex == null) {
    const isFocusable = viewProps.focusable ?? viewProps.accessible;
    viewProps.focusable && delete viewProps.focusable;
    const role = viewProps.role;
    isFocusable === !1 && (viewProps.tabIndex = "-1"), // These native elements are focusable by default
    elementType === "a" || elementType === "button" || elementType === "input" || elementType === "select" || elementType === "textarea" ? (isFocusable === !1 || props.accessibilityDisabled === !0) && (viewProps.tabIndex = "-1") : (
      // These roles are made focusable by default
      (role === "button" || role === "checkbox" || role === "link" || role === "radio" || // @ts-expect-error (consistent with RNW)
      role === "textbox" || role === "switch") && isFocusable !== !1 && (viewProps.tabIndex = "0")
    ), isFocusable && (viewProps.tabIndex = "0", delete viewProps.focusable);
  }
  const styleProp = props.style;
  if (styleProp)
    if (isHOC)
      viewProps.style = normalizeStyle(styleProp);
    else {
      const isArray = Array.isArray(styleProp), len = isArray ? styleProp.length : 1;
      for (let i = 0; i < len; i++) {
        const style = isArray ? styleProp[i] : styleProp;
        style && (style.$$css ? Object.assign(styleState.classNames, style) : (styleState.style ||= {}, Object.assign(styleState.style, normalizeStyle(style))));
      }
    }
  const result = {
    space,
    hasMedia,
    fontFamily: styleState.fontFamily,
    viewProps,
    style: styleState.style,
    pseudos,
    classNames,
    rulesToInsert,
    dynamicThemeAccess,
    pseudoGroups,
    mediaGroups
  };
  if (!(asChild === "except-style" || asChild === "except-style-web")) {
    const style = styleState.style;
    {
      let fontFamily = isText || isInput ? styleState.fontFamily || staticConfig.defaultProps?.fontFamily : null;
      fontFamily && fontFamily[0] === "$" && (fontFamily = fontFamily.slice(1));
      const fontFamilyClassName = fontFamily ? `font_${fontFamily}` : "", groupClassName = props.group ? `t_group_${props.group}` : "", componentNameFinal = props.componentName || staticConfig.componentName, componentClassName = props.asChild || !componentNameFinal ? "" : `is_${componentNameFinal}`;
      let classList = [];
      componentClassName && classList.push(componentClassName), fontFamilyClassName && classList.push(fontFamilyClassName), classNames && classList.push(Object.values(classNames).join(" ")), groupClassName && classList.push(groupClassName), props.className && classList.push(props.className);
      const finalClassName = classList.join(" ");
      if (styleProps.noMergeStyle)
        finalClassName && (viewProps.className = finalClassName);
      else if (styleProps.isAnimated && !conf.animations.supportsCSSVars && isReactNative)
        style && (viewProps.style = style);
      else if (isReactNative) {
        const cnStyles = { $$css: !0 };
        for (const name of finalClassName.split(" "))
          cnStyles[name] = name;
        viewProps.style = [...Array.isArray(style) ? style : [style], cnStyles];
      } else
        finalClassName && (viewProps.className = finalClassName), style && (viewProps.style = style);
    }
  }
  if (false) {}
  return result;
};
function mergeClassName(transforms, classNames, key, val, isMediaOrPseudo = !1, isInsertingNow = !1) {
  if (val)
    if (!isInsertingNow && val[0] === "_" && val.startsWith("_transform-")) {
      const ns = isMediaOrPseudo ? key : "transform";
      let transform = import_insertStyleRule.insertedTransforms[val];
      import_constants.isClient && !transform && ((0, import_insertStyleRule.scanAllSheets)(), transform = import_insertStyleRule.insertedTransforms[val], !transform && import_constants.isWeb && val[0] !== "_" && (transform = val)), transforms[ns] ||= ["", ""], transforms[ns][0] += val.replace("_transform", ""), transform && (transforms[ns][1] += transform);
    } else
      classNames[key] = val;
}
function mergeStyle(styleState, key, val, disableNormalize = !1) {
  const { classNames, viewProps, usedKeys, styleProps, staticConfig } = styleState;
  if (import_constants.isWeb && val?.[0] === "_")
    classNames[key] = val, usedKeys[key] ||= 1;
  else if (key in import_helpers.stylePropsTransform)
    styleState.flatTransforms ||= {}, styleState.flatTransforms[key] = val;
  else {
    const out = import_constants.isWeb && !disableNormalize && !styleProps.noNormalize ? (0, import_normalizeValueWithProperty.normalizeValueWithProperty)(val, key) : val;
    // accept is for props not styles
    staticConfig.accept && key in staticConfig.accept ? viewProps[key] = out : (styleState.style ||= {}, styleState.style[key] = out);
  }
}
const getSubStyle = (styleState, subKey, styleIn, avoidMergeTransform) => {
  const { staticConfig, conf: conf2, styleProps } = styleState, styleOut = {};
  for (let key in styleIn) {
    const val = styleIn[key];
    key = conf2.shorthands[key] || key;
    const expanded = (0, import_propMapper.propMapper)(key, val, styleState);
    if (!(!expanded || !staticConfig.isHOC && key in import_skipProps.skipProps && !styleProps.noSkip))
      for (const [skey, sval] of expanded)
        !avoidMergeTransform && skey in import_helpers.stylePropsTransform ? mergeTransform(styleOut, skey, sval) : styleOut[skey] = styleProps.noNormalize ? sval : (0, import_normalizeValueWithProperty.normalizeValueWithProperty)(sval, key);
  }
  return styleProps.noNormalize || (0, import_expandStyles.fixStyles)(styleOut), styleOut;
}, useInsertEffectCompat = import_constants.isWeb ? import_react.default.useInsertionEffect || import_constants.useIsomorphicLayoutEffect : () => {
}, useSplitStyles = (a, b, c, d, e, f, g, h, i, j) => {
  conf = conf || (0, import_config.getConfig)();
  const res = getSplitStyles(a, b, c, d, e, f, g, h, i, j);
  return process.env.TAMAGUI_REACT_19 || useInsertEffectCompat(() => {
    (0, import_insertStyleRule.insertStyleRules)(res.rulesToInsert);
  }, [res.rulesToInsert]), res;
};
function addStyleToInsertRules(rulesToInsert, styleObject) {
  {
    const identifier = styleObject[import_helpers.StyleObjectIdentifier];
    process.env.TAMAGUI_REACT_19 || (0, import_insertStyleRule.shouldInsertStyleRules)(identifier) && (0, import_insertStyleRule.updateRules)(identifier, styleObject[import_helpers.StyleObjectRules]), rulesToInsert[identifier] = styleObject;
  }
}
function processIDRefList(idRefList) {
  return Array.isArray(idRefList) ? idRefList.join(" ") : idRefList;
}
const defaultColor = process.env.TAMAGUI_DEFAULT_COLOR || "rgba(0,0,0,0)", animatableDefaults = {
  ...Object.fromEntries(
    Object.entries(import_helpers.tokenCategories.color).map(([k, v]) => [k, defaultColor])
  ),
  opacity: 1,
  scale: 1,
  rotate: "0deg",
  rotateY: "0deg",
  rotateX: "0deg",
  x: 0,
  y: 0,
  borderRadius: 0
}, lowercaseHyphenate = (match) => `-${match.toLowerCase()}`, hyphenate = (str) => str.replace(/[A-Z]/g, lowercaseHyphenate), mergeTransform = (obj, key, val, backwards = !1) => {
  typeof obj.transform != "string" && (obj.transform ||= [], obj.transform[backwards ? "unshift" : "push"]({
    [mapTransformKeys[key] || key]: val
  }));
}, mapTransformKeys = {
  x: "translateX",
  y: "translateY"
}, accessibilityRoleToWebRole = {
  adjustable: "slider",
  header: "heading",
  image: "img",
  link: "link",
  none: "presentation",
  summary: "region"
};
function passDownProp(viewProps, key, val, shouldMergeObject = !1) {
  if (shouldMergeObject) {
    const next = {
      ...viewProps[key],
      ...val
    };
    delete viewProps[key], viewProps[key] = next;
  } else
    viewProps[key] = val;
}
function mergeMediaByImportance(styleState, mediaKey, key, value, importancesUsed, isSizeMedia, importanceBump, debugProp) {
  let importance = (0, import_useMedia.getMediaImportanceIfMoreImportant)(
    mediaKey,
    key,
    importancesUsed,
    isSizeMedia
  );
  if (importanceBump && (importance = (importance || 0) + importanceBump),  false && 0, importance === null)
    return !1;
  if (importancesUsed[key] = importance, key in import_pseudoDescriptors.pseudoDescriptors) {
    const descriptor = import_pseudoDescriptors.pseudoDescriptors[key], descriptorKey = descriptor.stateKey || descriptor.name;
    if (styleState.componentState[descriptorKey] === !1)
      return !1;
    for (const subKey in value)
      mergeStyle(styleState, subKey, value[subKey]);
  } else
    mergeStyle(styleState, key, value);
  return !0;
}
function normalizeStyle(style) {
  const out = {};
  for (const key in style) {
    const val = style[key];
    key in import_helpers.stylePropsTransform ? mergeTransform(out, key, val) : out[key] = (0, import_normalizeValueWithProperty.normalizeValueWithProperty)(val, key);
  }
  return import_constants.isWeb && Array.isArray(out.transform) && (out.transform = (0, import_transformsToString.transformsToString)(out.transform)), (0, import_expandStyles.fixStyles)(out), out;
}
function applyDefaultStyle(pkey, styleState) {
  const defaultValues = animatableDefaults[pkey];
  defaultValues != null && !(pkey in styleState.usedKeys) && (!styleState.style || !(pkey in styleState.style)) && mergeStyle(styleState, pkey, defaultValues);
}
//# sourceMappingURL=getSplitStyles.js.map


/***/ }),

/***/ 9161:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var getStylesAtomic_exports = {};
__export(getStylesAtomic_exports, {
  getStyleAtomic: () => getStyleAtomic,
  getStylesAtomic: () => getStylesAtomic,
  styleToCSS: () => styleToCSS
});
module.exports = __toCommonJS(getStylesAtomic_exports);
var import_helpers = __webpack_require__(37513), import_config = __webpack_require__(16265), import_defaultOffset = __webpack_require__(30550), import_normalizeColor = __webpack_require__(66106), import_normalizeValueWithProperty = __webpack_require__(31053), import_pseudoDescriptors = __webpack_require__(45204), import_transformsToString = __webpack_require__(90013), import_useMedia = __webpack_require__(85030);
function getStylesAtomic(style) {
  styleToCSS(style);
  const out = [];
  for (const key in style) {
    const val = style[key];
    if (key in import_pseudoDescriptors.pseudoDescriptors)
      val && out.push(...getStyleAtomic(val, import_pseudoDescriptors.pseudoDescriptors[key]));
    else if ((0, import_useMedia.isMediaKey)(key))
      for (const subKey in val) {
        const so = getStyleObject(val, subKey);
        so && (so[0] = key, out.push(so));
      }
    else {
      const so = getStyleObject(style, key);
      so && out.push(so);
    }
  }
  return out;
}
const getStyleAtomic = (style, pseudo) => {
  styleToCSS(style);
  const out = [];
  for (const key in style) {
    const so = getStyleObject(style, key, pseudo);
    so && out.push(so);
  }
  return out;
};
let conf;
const getStyleObject = (style, key, pseudo) => {
  let val = style[key];
  if (val == null) return;
  key === "transform" && Array.isArray(style.transform) && (val = (0, import_transformsToString.transformsToString)(val));
  const value = (0, import_normalizeValueWithProperty.normalizeValueWithProperty)(val, key), hash = (0, import_helpers.simpleHash)(`${value}`), pseudoPrefix = pseudo ? `0${pseudo.name}-` : "";
  conf ||= (0, import_config.getConfig)();
  const identifier = `_${conf.inverseShorthands[key] || key}-${pseudoPrefix}${hash}`, rules = createAtomicRules(identifier, key, value, pseudo);
  return [
    // array for performance
    key,
    value,
    identifier,
    pseudo?.name,
    rules
  ];
};
function styleToCSS(style) {
  const { shadowOffset, shadowRadius, shadowColor, shadowOpacity } = style;
  if (shadowRadius || shadowColor) {
    const offset = shadowOffset || import_defaultOffset.defaultOffset, width = (0, import_normalizeValueWithProperty.normalizeValueWithProperty)(offset.width), height = (0, import_normalizeValueWithProperty.normalizeValueWithProperty)(offset.height), radius = (0, import_normalizeValueWithProperty.normalizeValueWithProperty)(shadowRadius), color = (0, import_normalizeColor.normalizeColor)(shadowColor, shadowOpacity), shadow = `${width} ${height} ${radius} ${color}`;
    style.boxShadow = style.boxShadow ? `${style.boxShadow}, ${shadow}` : shadow, delete style.shadowOffset, delete style.shadowRadius, delete style.shadowColor, delete style.shadowOpacity;
  }
  const { textShadowColor, textShadowOffset, textShadowRadius } = style;
  if (textShadowColor || textShadowOffset || textShadowRadius) {
    const { height, width } = textShadowOffset || import_defaultOffset.defaultOffset, radius = textShadowRadius || 0, color = (0, import_normalizeValueWithProperty.normalizeValueWithProperty)(textShadowColor, "textShadowColor");
    if (color && (height !== 0 || width !== 0 || radius !== 0)) {
      const blurRadius = (0, import_normalizeValueWithProperty.normalizeValueWithProperty)(radius), offsetX = (0, import_normalizeValueWithProperty.normalizeValueWithProperty)(width), offsetY = (0, import_normalizeValueWithProperty.normalizeValueWithProperty)(height);
      style.textShadow = `${offsetX} ${offsetY} ${blurRadius} ${color}`;
    }
    delete style.textShadowColor, delete style.textShadowOffset, delete style.textShadowRadius;
  }
}
function createDeclarationBlock(style, important = !1) {
  let next = "";
  for (const [key, value] of style)
    next += `${hyphenateStyleName(key)}:${value}${important ? " !important" : ""};`;
  return `{${next}}`;
}
const hcache = {}, toHyphenLower = (match) => `-${match.toLowerCase()}`, hyphenateStyleName = (key) => {
  if (key in hcache) return hcache[key];
  const val = key.replace(/[A-Z]/g, toHyphenLower);
  return hcache[key] = val, val;
}, selectorPriority = (() => {
  const res = {};
  for (const key in import_pseudoDescriptors.pseudoDescriptors) {
    const pseudo = import_pseudoDescriptors.pseudoDescriptors[key];
    res[pseudo.name] = `${[...Array(pseudo.priority)].map(() => ":root").join("")} `;
  }
  return res;
})();
function createAtomicRules(identifier, property, value, pseudo) {
  const pseudoIdPostfix = pseudo ? pseudo.name === "disabled" ? "[aria-disabled]" : `:${pseudo.name}` : "", pseudoSelector = pseudo?.selector;
  let selector = pseudo ? pseudoSelector ? `${pseudoSelector} .${identifier}` : `${selectorPriority[pseudo.name]} .${identifier}${pseudoIdPostfix}` : `:root .${identifier}`;
  pseudoSelector === import_pseudoDescriptors.pseudoDescriptors.enterStyle.selector && (selector = `${selector}, .${identifier}${pseudoSelector}`);
  const important = !!pseudo;
  let rules = [];
  switch (property) {
    case "placeholderTextColor": {
      const block = createDeclarationBlock(
        [
          ["color", value],
          ["opacity", 1]
        ],
        important
      );
      rules.push(`${selector}::placeholder${block}`);
      break;
    }
    case "backgroundClip":
    case "userSelect": {
      const webkitProperty = `Webkit${`${property[0].toUpperCase()}${property.slice(1)}`}`, block = createDeclarationBlock(
        [
          [property, value],
          [webkitProperty, value]
        ],
        important
      );
      rules.push(`${selector}${block}`);
      break;
    }
    case "pointerEvents": {
      let finalValue = value;
      value === "auto" || value === "box-only" ? (finalValue = "auto", value === "box-only" && rules.push(`${selector}>*${boxOnly}`)) : (value === "none" || value === "box-none") && (finalValue = "none", value === "box-none" && rules.push(`${selector}>*${boxNone}`));
      const block = createDeclarationBlock([["pointerEvents", finalValue]], !0);
      rules.push(`${selector}${block}`);
      break;
    }
    default: {
      const block = createDeclarationBlock([[property, value]], important);
      rules.push(`${selector}${block}`);
      break;
    }
  }
  return pseudo?.name === "hover" && (rules = rules.map((r) => `@media (hover) {${r}}`)), rules;
}
const boxNone = createDeclarationBlock([["pointerEvents", "auto"]], !0), boxOnly = createDeclarationBlock([["pointerEvents", "none"]], !0);
//# sourceMappingURL=getStylesAtomic.js.map


/***/ }),

/***/ 75099:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(34155);
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var getThemeCSSRules_exports = {};
__export(getThemeCSSRules_exports, {
  getThemeCSSRules: () => getThemeCSSRules
});
module.exports = __toCommonJS(getThemeCSSRules_exports);
var import_helpers = __webpack_require__(37513), import_constants = __webpack_require__(36297), import_createVariable = __webpack_require__(88957), import_registerCSSVariable = __webpack_require__(20299), import_config = __webpack_require__(16265);
const darkLight = ["dark", "light"], lightDark = ["light", "dark"];
function getThemeCSSRules(props) {
  const cssRuleSets = [];
  if (!process.env.TAMAGUI_DOES_SSR_CSS || process.env.TAMAGUI_DOES_SSR_CSS === "mutates-themes" || process.env.TAMAGUI_DOES_SSR_CSS === "false") {
    const { config, themeName, theme, names } = props, hasDarkLight = props.hasDarkLight ?? (config.themes && ("light" in config.themes || "dark" in config.themes)), CNP = `.${import_constants.THEME_CLASSNAME_PREFIX}`;
    let vars = "";
    for (const themeKey in theme) {
      const variable = theme[themeKey];
      let value = null;
      import_registerCSSVariable.tokensValueToVariable.has(variable.val) ? value = import_registerCSSVariable.tokensValueToVariable.get(variable.val).variable : value = variable.val, vars += `--${process.env.TAMAGUI_CSS_VARIABLE_PREFIX || ""}${(0, import_helpers.simpleHash)(
        themeKey,
        40
      )}:${value};`;
    }
    const isDarkBase = themeName === "dark", isLightBase = themeName === "light", baseSelectors = names.map((name) => `${CNP}${name}`), selectorsSet = new Set(isDarkBase || isLightBase ? baseSelectors : []);
    if (hasDarkLight) {
      const maxDepth = (0, import_config.getSetting)("maxDarkLightNesting") ?? 3;
      for (const subName of names) {
        const isDark = isDarkBase || subName.startsWith("dark_"), isLight = !isDark && (isLightBase || subName.startsWith("light_"));
        if (!(isDark || isLight)) {
          selectorsSet.add(`${CNP}${subName}`);
          continue;
        }
        const childSelector = `${CNP}${subName.replace(/^(dark|light)_/, "")}`, order = isDark ? darkLight : lightDark, [stronger, weaker] = order, numSelectors = Math.round(maxDepth * 1.5);
        for (let depth = 0; depth < numSelectors; depth++) {
          const isOdd = depth % 2 === 1;
          if (isOdd && depth < 3)
            continue;
          const parents = new Array(depth + 1).fill(0).map((_, idx) => `${CNP}${idx % 2 === 0 ? stronger : weaker}`);
          let parentSelectors = parents.length > 1 ? parents.slice(1) : parents;
          if (isOdd) {
            const [_first, second, ...rest] = parentSelectors;
            parentSelectors = [second, ...rest, second];
          }
          const lastParentSelector = parentSelectors[parentSelectors.length - 1], nextChildSelector = childSelector === lastParentSelector ? "" : childSelector, parentSelectorString = parentSelectors.join(" ");
          selectorsSet.add(`${parentSelectorString} ${nextChildSelector}`);
        }
      }
    }
    const selectors = [...selectorsSet].sort((a, b) => a.localeCompare(b)), css = `${selectors.map((x) => `:root${isBaseTheme(x) && (0, import_config.getSetting)("themeClassNameOnRoot") ? "" : " "}${x}`).join(", ")} {${vars}}`;
    if (cssRuleSets.push(css), (0, import_config.getSetting)("shouldAddPrefersColorThemes")) {
      const bgString = theme.background ? `background:${(0, import_createVariable.variableToString)(theme.background)};` : "", fgString = theme.color ? `color:${(0, import_createVariable.variableToString)(theme.color)}` : "", bodyRules = `body{${bgString}${fgString}}`, isDark = themeName.startsWith("dark"), baseName = isDark ? "dark" : "light", themeRules = `${selectors.map((x) => {
        if (x == darkSelector || x === lightSelector) return ":root";
        if (!(isDark && x.startsWith(lightSelector) || !isDark && x.startsWith(darkSelector)))
          return x.replace(/^\.t_(dark|light) /, "").trim();
      }).filter(Boolean).join(", ")} {${vars}}`, prefersMediaSelectors = `@media(prefers-color-scheme:${baseName}){
    ${bodyRules}
    ${themeRules}
  }`;
      cssRuleSets.push(prefersMediaSelectors);
    }
    const selectionStyles = (0, import_config.getSetting)("selectionStyles");
    if (selectionStyles) {
      const rules = selectionStyles(theme);
      if (rules) {
        const selectionSelectors = baseSelectors.map((s) => `${s} ::selection`).join(", "), styles = Object.entries(rules).flatMap(
          ([k, v]) => v ? `${k === "backgroundColor" ? "background" : k}:${(0, import_createVariable.variableToString)(v)}` : []
        ).join(";");
        if (styles) {
          const css2 = `${selectionSelectors}{${styles}}`;
          cssRuleSets.push(css2);
        }
      }
    }
  }
  return cssRuleSets;
}
const darkSelector = ".t_dark", lightSelector = ".t_light", isBaseTheme = (x) => x === darkSelector || x === lightSelector || x.startsWith(".t_dark ") || x.startsWith(".t_light ");
//# sourceMappingURL=getThemeCSSRules.js.map


/***/ }),

/***/ 37645:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var getVariantExtras_exports = {};
__export(getVariantExtras_exports, {
  getFontsForLanguage: () => getFontsForLanguage,
  getVariantExtras: () => getVariantExtras
});
module.exports = __toCommonJS(getVariantExtras_exports);
var import_createVariable = __webpack_require__(88957);
const cache = /* @__PURE__ */ new WeakMap(), getVariantExtras = (styleState) => {
  if (cache.has(styleState))
    return cache.get(styleState);
  const { props, conf, context, theme } = styleState;
  let fonts = conf.fontsParsed;
  context?.language && (fonts = getFontsForLanguage(conf.fontsParsed, context.language));
  const next = {
    fonts,
    tokens: conf.tokensParsed,
    theme,
    get fontFamily() {
      return (0, import_createVariable.getVariableValue)(styleState.fontFamily || styleState.props.fontFamily) || props.fontFamily || (0, import_createVariable.getVariableValue)(styleState.conf.defaultFont);
    },
    get font() {
      return fonts[this.fontFamily] || (!props.fontFamily || props.fontFamily[0] === "$" ? fonts[styleState.conf.defaultFont] : void 0);
    },
    props
  };
  return cache.set(styleState, next), next;
}, fontLanguageCache = /* @__PURE__ */ new WeakMap();
function getFontsForLanguage(fonts, language) {
  if (fontLanguageCache.has(language))
    return fontLanguageCache.get(language);
  const next = {
    ...fonts,
    ...Object.fromEntries(
      Object.entries(language).map(([name, lang]) => {
        if (lang === "default")
          return [];
        const langKey = `$${name}_${lang}`;
        return [`$${name}`, fonts[langKey]];
      })
    )
  };
  return fontLanguageCache.set(language, next), next;
}
//# sourceMappingURL=getVariantExtras.js.map


/***/ }),

/***/ 37269:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(34155);
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var insertStyleRule_exports = {};
__export(insertStyleRule_exports, {
  getAllRules: () => getAllRules,
  getAllSelectors: () => getAllSelectors,
  getAllTransforms: () => getAllTransforms,
  insertStyleRules: () => insertStyleRules,
  insertedTransforms: () => insertedTransforms,
  listenForSheetChanges: () => listenForSheetChanges,
  scanAllSheets: () => scanAllSheets,
  setNonce: () => setNonce,
  shouldInsertStyleRules: () => shouldInsertStyleRules,
  updateRules: () => updateRules
});
module.exports = __toCommonJS(insertStyleRule_exports);
var import_constants = __webpack_require__(14810), import_helpers = __webpack_require__(37513), import_createVariable = __webpack_require__(88957);
const scannedCache = /* @__PURE__ */ new WeakMap(), totalSelectorsInserted = /* @__PURE__ */ new Map(), allSelectors = {}, allRules = {}, insertedTransforms = {}, getAllSelectors = () => allSelectors, getAllRules = () => Object.values(allRules), getAllTransforms = () => insertedTransforms;
function addTransform(identifier, css, rule) {
  const s = css.indexOf("transform:");
  if (s === -1) {
     false && 0;
    return;
  }
  const startI = s + 10, endI = css.indexOf(";"), value = css.slice(startI, endI);
  if (!insertedTransforms[identifier])
    return insertedTransforms[identifier] = value, !0;
}
function listenForSheetChanges() {
  if (!import_constants.isClient) return;
  new MutationObserver((entries) => {
    for (const entry of entries)
      if (entry instanceof HTMLStyleElement && entry.sheet || entry instanceof HTMLLinkElement && entry.href.endsWith(".css")) {
        scanAllSheets();
        break;
      }
  }).observe(document.head, {
    childList: !0
  });
}
let lastScannedSheets = null;
function scanAllSheets(collectThemes = !1, tokens) {
  if ( false || !import_constants.isClient) return;
  let themes;
  const sheets = document.styleSheets || [], prev = lastScannedSheets, current = new Set(sheets);
  if (document.styleSheets) {
    for (const sheet2 of current)
      if (sheet2) {
        const out = updateSheetStyles(sheet2, !1, collectThemes, tokens);
        out && (themes = out);
      }
    lastScannedSheets = current;
  }
  if (prev)
    for (const sheet2 of prev)
      sheet2 && !current.has(sheet2) && updateSheetStyles(sheet2, !0);
  return themes;
}
function track(id, remove = !1) {
  const next = (totalSelectorsInserted.get(id) || 0) + (remove ? -1 : 1);
  return totalSelectorsInserted.set(id, next), next;
}
const bailAfterEnv = process.env.TAMAGUI_BAIL_AFTER_SCANNING_X_CSS_RULES, bailAfter = bailAfterEnv ? +bailAfterEnv : 250;
function updateSheetStyles(sheet2, remove = !1, collectThemes = !1, tokens) {
  let rules;
  try {
    if (rules = sheet2.cssRules, !rules)
      return;
  } catch {
    return;
  }
  const firstSelector = getTamaguiSelector(rules[0], collectThemes)?.[0], lastSelector = getTamaguiSelector(rules[rules.length - 1], collectThemes)?.[0], cacheKey = `${rules.length}${firstSelector}${lastSelector}`, lastScanned = scannedCache.get(sheet2);
  if (!remove && lastScanned === cacheKey)
    return;
  const len = rules.length;
  let fails = 0, dedupedThemes;
  for (let i = 0; i < len; i++) {
    const rule = rules[i];
    if (!(rule instanceof CSSStyleRule)) continue;
    const response = getTamaguiSelector(rule, collectThemes);
    if (response)
      fails = 0;
    else {
      if (fails++, fails > bailAfter)
        return;
      continue;
    }
    const [identifier, cssRule, isTheme] = response;
    if (isTheme) {
      const deduped = addThemesFromCSS(cssRule, tokens);
      deduped && (dedupedThemes ||= [], dedupedThemes.push(deduped));
      continue;
    }
    if (!process.env.TAMAGUI_REACT_19) {
      const total = track(identifier, remove);
      remove ? total === 0 && delete allSelectors[identifier] : identifier in allSelectors || (!identifier.startsWith("_transform-") || addTransform(identifier, cssRule.cssText, cssRule)) && (allSelectors[identifier] = cssRule.cssText);
    }
  }
  return scannedCache.set(sheet2, cacheKey), dedupedThemes;
}
let colorVarToVal, rootComputedStyle = null;
function addThemesFromCSS(cssStyleRule, tokens) {
  const selectors = cssStyleRule.selectorText.split(",");
  if (!selectors.length) return;
  if (tokens && !colorVarToVal) {
    colorVarToVal = {};
    for (const key in tokens.color) {
      const token = tokens.color[key];
      colorVarToVal[token.name] = token.val;
    }
  }
  const rules = (cssStyleRule.cssText || "").slice(
    cssStyleRule.selectorText.length + 2,
    -1
  ).split(";"), values = {};
  for (const rule of rules) {
    const sepI = rule.indexOf(":");
    if (sepI === -1) continue;
    const varIndex = rule.indexOf("--");
    let key = rule.slice(varIndex === -1 ? 0 : varIndex + 2, sepI);
    process.env.TAMAGUI_CSS_VARIABLE_PREFIX && (key = key.replace(process.env.TAMAGUI_CSS_VARIABLE_PREFIX, ""));
    const val = rule.slice(sepI + 2);
    let value;
    if (val[0] === "v" && val.startsWith("var(")) {
      const varName = val.slice(6, -1), tokenVal = colorVarToVal[varName];
      tokenVal ? value = tokenVal : (rootComputedStyle ||= getComputedStyle(document.body), value = rootComputedStyle.getPropertyValue("--" + varName));
    } else
      value = val;
    values[key] = (0, import_createVariable.createVariable)(
      {
        key,
        name: key,
        val: value
      },
      !0
    );
  }
  const names = /* @__PURE__ */ new Set();
  for (const selector of selectors) {
    const lastThemeSelectorIndex = selector.lastIndexOf(".t_"), name = selector.slice(lastThemeSelectorIndex).slice(3), [schemeChar] = selector[lastThemeSelectorIndex - 5], scheme = schemeChar === "d" ? "dark" : schemeChar === "i" ? "light" : "", themeName = scheme && scheme !== name ? `${scheme}_${name}` : name;
    !themeName || themeName === "light_dark" || themeName === "dark_light" || names.add(themeName);
  }
  return {
    names: [...names],
    theme: values
  };
}
function getTamaguiSelector(rule, collectThemes = !1) {
  if (rule instanceof CSSStyleRule) {
    const text = rule.selectorText;
    if (text[0] === ":" && text[1] === "r") {
      if (text.startsWith(":root ._"))
        return [getIdentifierFromTamaguiSelector(text), rule];
      if (collectThemes && (text.startsWith(":root.t_") || text.startsWith(":root .t_")))
        return [
          text.slice(0, 20),
          // just used as uid
          rule,
          !0
        ];
    }
  } else if (rule instanceof CSSMediaRule)
    return rule.cssRules.length > 1 ? void 0 : getTamaguiSelector(rule.cssRules[0]);
}
const getIdentifierFromTamaguiSelector = (selector) => {
  const dotIndex = selector.indexOf(":");
  return dotIndex > -1 ? selector.slice(7, dotIndex) : selector.slice(7);
};
let sheet = null;
function updateRules(identifier, rules) {
  if (!process.env.TAMAGUI_REACT_19)
    return identifier in allRules ? !1 : (allRules[identifier] = rules.join(" "), identifier.startsWith("_transform-") ? addTransform(identifier, rules[0]) : !0);
}
let nonce = "";
function setNonce(_) {
  nonce = _;
}
function insertStyleRules(rulesToInsert) {
  if (!process.env.TAMAGUI_REACT_19) {
    if (!sheet && import_constants.isClient && document.head) {
      const styleTag = document.createElement("style");
      nonce && (styleTag.nonce = nonce), sheet = document.head.appendChild(styleTag).sheet;
    }
    if (!sheet) return;
    for (const key in rulesToInsert) {
      const styleObject = rulesToInsert[key], identifier = styleObject[import_helpers.StyleObjectIdentifier];
      if (!shouldInsertStyleRules(identifier))
        continue;
      const rules = styleObject[import_helpers.StyleObjectRules];
      allSelectors[identifier] = rules.join(`
`), track(identifier), updateRules(identifier, rules);
      for (const rule of rules)
        if (true)
          try {
            sheet.insertRule(rule, sheet.cssRules.length);
          } catch (err) {
            console.error("Error inserting CSS", err);
          }
        else
          {}
    }
  }
}
const minInsertAmt = process.env.TAMAGUI_INSERT_SELECTOR_TRIES ? +process.env.TAMAGUI_INSERT_SELECTOR_TRIES : 1;
function shouldInsertStyleRules(identifier) {
  if (process.env.TAMAGUI_REACT_19)
    return !0;
  {
    if (false)
      {}
    const total = totalSelectorsInserted.get(identifier);
    return  false && 0, total === void 0 || total < minInsertAmt;
  }
}
//# sourceMappingURL=insertStyleRule.js.map


/***/ }),

/***/ 4268:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var isActivePlatform_exports = {};
__export(isActivePlatform_exports, {
  isActivePlatform: () => isActivePlatform
});
module.exports = __toCommonJS(isActivePlatform_exports);
var import_constants = __webpack_require__(14810);
function isActivePlatform(key) {
  const platform = key.slice(10);
  return (
    // web, ios, android
    platform === import_constants.currentPlatform || // web, native
    platform === "web"
  );
}
//# sourceMappingURL=isActivePlatform.js.map


/***/ }),

/***/ 88356:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var isObj_exports = {};
__export(isObj_exports, {
  isObj: () => isObj
});
module.exports = __toCommonJS(isObj_exports);
const isObj = (x) => x && !Array.isArray(x) && typeof x == "object";
//# sourceMappingURL=isObj.js.map


/***/ }),

/***/ 45701:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var isTamaguiComponent_exports = {};
__export(isTamaguiComponent_exports, {
  isTamaguiComponent: () => isTamaguiComponent
});
module.exports = __toCommonJS(isTamaguiComponent_exports);
function isTamaguiComponent(comp, name) {
  const config = comp?.staticConfig;
  return !!(config && (!name || name === config.componentName));
}
//# sourceMappingURL=isTamaguiComponent.js.map


/***/ }),

/***/ 10454:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var isTamaguiElement_exports = {};
__export(isTamaguiElement_exports, {
  isTamaguiElement: () => isTamaguiElement
});
module.exports = __toCommonJS(isTamaguiElement_exports);
var import_react = __toESM(__webpack_require__(67294)), import_isTamaguiComponent = __webpack_require__(45701);
const isTamaguiElement = (child, name) => import_react.default.isValidElement(child) && (0, import_isTamaguiComponent.isTamaguiComponent)(child.type, name);
//# sourceMappingURL=isTamaguiElement.js.map


/***/ }),

/***/ 97727:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var log_exports = {};
__export(log_exports, {
  log: () => log
});
module.exports = __toCommonJS(log_exports);
var import_useMedia = __webpack_require__(85030);
function log(...args) {
  if (false) {}
}
//# sourceMappingURL=log.js.map


/***/ }),

/***/ 69464:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var matchMedia_exports = {};
__export(matchMedia_exports, {
  matchMedia: () => matchMedia,
  setupMatchMedia: () => setupMatchMedia
});
module.exports = __toCommonJS(matchMedia_exports);
const matchMedia = typeof window < "u" && window.matchMedia || matchMediaFallback;
function matchMediaFallback(_) {
  return {
    match: (a, b) => !1,
    addListener() {
    },
    removeListener() {
    },
    matches: !1
  };
}
function setupMatchMedia(_) {
}
//# sourceMappingURL=matchMedia.js.map


/***/ }),

/***/ 1458:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var mergeProps_exports = {};
__export(mergeProps_exports, {
  mergeProps: () => mergeProps
});
module.exports = __toCommonJS(mergeProps_exports);
var import_useMedia = __webpack_require__(85030), import_pseudoDescriptors = __webpack_require__(45204);
const mergeProps = (a, b, inverseShorthands) => {
  const out = {};
  for (const key in a)
    mergeProp(out, a, b, key, inverseShorthands);
  if (b)
    for (const key in b)
      mergeProp(out, b, void 0, key, inverseShorthands);
  return out;
};
function mergeProp(out, a, b, key, inverseShorthands) {
  const longhand = inverseShorthands?.[key] || null, val = a[key];
  if (key in import_pseudoDescriptors.pseudoDescriptors || import_useMedia.mediaKeys.has(key)) {
    out[key] = {
      ...out[key],
      ...val
    };
    return;
  }
  b && (key in b || longhand && longhand in b) || (out[longhand || key] = val);
}
//# sourceMappingURL=mergeProps.js.map


/***/ }),

/***/ 73474:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var mergeVariants_exports = {};
__export(mergeVariants_exports, {
  mergeVariants: () => mergeVariants
});
module.exports = __toCommonJS(mergeVariants_exports);
const mergeVariants = (parentVariants, ourVariants, level = 0) => {
  const variants = {};
  for (const key in ourVariants) {
    const parentVariant = parentVariants?.[key], ourVariant = ourVariants[key];
    !parentVariant || typeof ourVariant == "function" ? variants[key] = ourVariant : parentVariant && !ourVariant ? variants[key] = parentVariant[key] : level === 0 ? variants[key] = mergeVariants(
      parentVariant,
      ourVariant,
      level + 1
    ) : variants[key] = {
      ...parentVariant,
      ...ourVariant
    };
  }
  return {
    ...parentVariants,
    ...variants
  };
};
//# sourceMappingURL=mergeVariants.js.map


/***/ }),

/***/ 66106:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var normalizeColor_exports = {};
__export(normalizeColor_exports, {
  getRgba: () => getRgba,
  normalizeColor: () => normalizeColor,
  rgba: () => import_normalize_css_color2.rgba
});
module.exports = __toCommonJS(normalizeColor_exports);
var import_normalize_css_color = __webpack_require__(17285), import_normalize_css_color2 = __webpack_require__(17285);
const normalizeColor = (color, opacity) => {
  if (color) {
    if (color[0] === "$") return color;
    if (color.startsWith("var(")) {
      if (typeof opacity == "number" && opacity < 1)
        return `color-mix(in srgb, ${color} ${opacity * 100}%, transparent)`;
    } else {
      const rgba3 = getRgba(color);
      if (rgba3) {
        const colors = `${rgba3.r},${rgba3.g},${rgba3.b}`;
        return opacity === 1 ? `rgb(${colors})` : `rgba(${colors},${opacity ?? rgba3.a ?? 1})`;
      }
    }
    return color;
  }
}, getRgba = (color) => {
  const colorNum = (0, import_normalize_css_color.normalizeCSSColor)(color);
  if (colorNum != null)
    return (0, import_normalize_css_color.rgba)(colorNum);
};
//# sourceMappingURL=normalizeColor.js.map


/***/ }),

/***/ 27234:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var normalizeShadow_exports = {};
__export(normalizeShadow_exports, {
  normalizeShadow: () => normalizeShadow
});
module.exports = __toCommonJS(normalizeShadow_exports);
var import_defaultOffset = __webpack_require__(30550), import_normalizeColor = __webpack_require__(66106);
function normalizeShadow({
  shadowColor,
  shadowOffset,
  shadowOpacity,
  shadowRadius
}) {
  const { height, width } = shadowOffset || import_defaultOffset.defaultOffset;
  return {
    shadowOffset: {
      width: width || 0,
      height: height || 0
    },
    shadowRadius: shadowRadius || 0,
    shadowColor: (0, import_normalizeColor.normalizeColor)(shadowColor, 1),
    shadowOpacity: shadowOpacity ?? (shadowColor ? (0, import_normalizeColor.getRgba)(shadowColor)?.a : 1)
  };
}
//# sourceMappingURL=normalizeShadow.js.map


/***/ }),

/***/ 58325:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var normalizeStyle_exports = {};
__export(normalizeStyle_exports, {
  normalizeStyle: () => normalizeStyle
});
module.exports = __toCommonJS(normalizeStyle_exports);
var import_expandStyle = __webpack_require__(32549), import_expandStyles = __webpack_require__(36152), import_isObj = __webpack_require__(88356), import_normalizeValueWithProperty = __webpack_require__(31053), import_pseudoDescriptors = __webpack_require__(45204);
function normalizeStyle(style, disableNormalize = !1) {
  const res = {};
  for (let key in style) {
    const prop = style[key];
    if (prop == null) continue;
    if (key in import_pseudoDescriptors.pseudoDescriptors || // this should capture all parent-based styles like media, group, etc
    key[0] === "$" && (0, import_isObj.isObj)(prop)) {
      res[key] = normalizeStyle(prop, disableNormalize);
      continue;
    }
    const value = disableNormalize ? prop : (0, import_normalizeValueWithProperty.normalizeValueWithProperty)(prop, key), out = (0, import_expandStyle.expandStyle)(key, value);
    out ? Object.assign(res, Object.fromEntries(out)) : res[key] = value;
  }
  return (0, import_expandStyles.fixStyles)(res), res;
}
//# sourceMappingURL=normalizeStyle.js.map


/***/ }),

/***/ 31053:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var normalizeValueWithProperty_exports = {};
__export(normalizeValueWithProperty_exports, {
  normalizeValueWithProperty: () => normalizeValueWithProperty,
  reverseMapClassNameToValue: () => reverseMapClassNameToValue
});
module.exports = __toCommonJS(normalizeValueWithProperty_exports);
var import_constants = __webpack_require__(14810), import_helpers = __webpack_require__(37513), import_insertStyleRule = __webpack_require__(37269);
const stylePropsAllPlusTransforms = {
  ...import_helpers.stylePropsAll,
  translateX: !0,
  translateY: !0
};
function normalizeValueWithProperty(value, property = "") {
  if (!import_constants.isWeb || import_helpers.stylePropsUnitless[property] || property && !stylePropsAllPlusTransforms[property] || typeof value == "boolean")
    return value;
  let res = value;
  return value && typeof value == "object" ? value : (typeof value == "number" ? res = `${value}px` : property && (res = `${res}`), res);
}
const rcache = {};
function reverseMapClassNameToValue(key, className) {
  const cssRule = (0, import_insertStyleRule.getAllSelectors)()[className];
  if (rcache[cssRule])
    return rcache[cssRule];
  if (!cssRule) {
     false && 0;
    return;
  }
  const cssVal = cssRule.replace(/.*:/, "").replace(/;.*/, "").trim();
  let res;
  return cssVal.startsWith("var(") ? res = cssVal : import_helpers.stylePropsUnitless[key] ? res = +cssVal : cssVal.endsWith("px") ? res = +cssVal.replace("px", "") : res = cssVal, rcache[cssRule] = res,  false && 0, res;
}
//# sourceMappingURL=normalizeValueWithProperty.js.map


/***/ }),

/***/ 2761:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var objectIdentityKey_exports = {};
__export(objectIdentityKey_exports, {
  objectIdentityKey: () => objectIdentityKey
});
module.exports = __toCommonJS(objectIdentityKey_exports);
function objectIdentityKey(obj) {
  let k = "";
  for (const key in obj) {
    k += key;
    const arg = obj[key];
    let type = typeof arg;
    if (!arg || type !== "object" && type !== "function")
      k += type + arg;
    else if (cache.has(arg))
      k += cache.get(arg);
    else {
      let v = Math.random();
      cache.set(arg, v), k += v;
    }
  }
  return k;
}
const cache = /* @__PURE__ */ new WeakMap();
//# sourceMappingURL=objectIdentityKey.js.map


/***/ }),

/***/ 80408:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(34155);
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var propMapper_exports = {};
__export(propMapper_exports, {
  getFontFamilyFromNameOrVariable: () => getFontFamilyFromNameOrVariable,
  getPropMappedFontFamily: () => getPropMappedFontFamily,
  getTokenForKey: () => getTokenForKey,
  propMapper: () => propMapper
});
module.exports = __toCommonJS(propMapper_exports);
var import_constants = __webpack_require__(14810), import_helpers = __webpack_require__(37513), import_config = __webpack_require__(16265), import_createVariable = __webpack_require__(88957), import_expandStyle = __webpack_require__(32549), import_normalizeStyle = __webpack_require__(58325), import_getVariantExtras = __webpack_require__(37645), import_isObj = __webpack_require__(88356), import_pseudoDescriptors = __webpack_require__(45204), import_skipProps = __webpack_require__(86255);
const propMapper = (key, value, styleState) => {
  if (lastFontFamilyToken = null, key === "elevationAndroid") return;
  const { conf, styleProps, fontFamily, staticConfig } = styleState;
  if (value === "unset") {
    const unsetVal = conf.unset?.[key];
    if (unsetVal != null)
      value = unsetVal;
    else
      return;
  }
  styleProps.fallbackProps && (styleState.props = styleProps.fallbackProps);
  const { variants } = staticConfig;
  if ( false && 0, !styleProps.noExpand && variants && key in variants) {
    const variantValue = resolveVariants(key, value, styleProps, styleState, "");
    if (variantValue)
      return variantValue;
  }
  if (styleProps.disableExpandShorthands || key in conf.shorthands && (key = conf.shorthands[key]), value && (value[0] === "$" ? value = getTokenForKey(key, value, styleProps.resolveValues, styleState) : (0, import_createVariable.isVariable)(value) && (value = resolveVariableValue(key, value, styleProps.resolveValues))), value != null) {
    const result = (styleProps.noExpand ? null : (0, import_expandStyle.expandStyle)(key, value)) || [
      [key, value]
    ];
    return key === "fontFamily" && lastFontFamilyToken && fontFamilyCache.set(result, lastFontFamilyToken), result;
  }
}, resolveVariants = (key, value, styleProps, styleState, parentVariantKey) => {
  const { staticConfig, conf, debug } = styleState, { variants } = staticConfig;
  if (!variants) return;
  let variantValue = getVariantDefinition(variants[key], value, conf);
  if ( false && (0), !variantValue) {
    if (process.env.TAMAGUI_WARN_ON_MISSING_VARIANT === "1" && typeof value != "boolean") {
      const name = staticConfig.componentName || "[UnnamedComponent]";
      console.warn(
        `No variant found: ${name} has variant "${key}", but no matching value "${value}"`
      );
    }
    return;
  }
  if (typeof variantValue == "function") {
    const fn = variantValue, extras = (0, import_getVariantExtras.getVariantExtras)(styleState);
    variantValue = fn(value, extras),  false && (0);
  }
  let fontFamilyResult;
  if ((0, import_isObj.isObj)(variantValue)) {
    const fontFamilyUpdate = variantValue.fontFamily || variantValue[conf.inverseShorthands.fontFamily];
    fontFamilyUpdate && (fontFamilyResult = getFontFamilyFromNameOrVariable(fontFamilyUpdate, conf), styleState.fontFamily = fontFamilyResult,  false && 0), variantValue = resolveTokensAndVariants(
      key,
      variantValue,
      styleProps,
      styleState,
      parentVariantKey
    );
  }
  if (variantValue) {
    const expanded = (0, import_normalizeStyle.normalizeStyle)(variantValue, !!styleProps.noNormalize);
     false && 0;
    const next = Object.entries(expanded);
    return fontFamilyResult && fontFamilyResult[0] === "$" && fontFamilyCache.set(next, (0, import_createVariable.getVariableValue)(fontFamilyResult)), next;
  }
};
function getFontFamilyFromNameOrVariable(input, conf) {
  if ((0, import_createVariable.isVariable)(input)) {
    const val = variableToFontNameCache.get(input);
    if (val) return val;
    for (const key in conf.fontsParsed) {
      const familyVariable = conf.fontsParsed[key].family;
      if ((0, import_createVariable.isVariable)(familyVariable) && (variableToFontNameCache.set(familyVariable, key), familyVariable === input))
        return key;
    }
  } else if (typeof input == "string" && input[0] === "$")
    return input;
}
const variableToFontNameCache = /* @__PURE__ */ new WeakMap(), fontFamilyCache = /* @__PURE__ */ new WeakMap(), getPropMappedFontFamily = (expanded) => expanded && fontFamilyCache.get(expanded), resolveTokensAndVariants = (key, value, styleProps, styleState, parentVariantKey) => {
  const { conf, staticConfig, debug, theme } = styleState, { variants } = staticConfig, res = {};
   false && 0;
  for (const _key in value) {
    const subKey = conf.shorthands[_key] || _key, val = value[_key];
    if (!(!styleProps.noSkip && subKey in import_skipProps.skipProps)) {
      if (styleProps.noExpand)
        res[subKey] = val;
      else if (variants && subKey in variants) {
        if (parentVariantKey && parentVariantKey === key)
          res[subKey] = // SYNC WITH *1
          val[0] === "$" ? getTokenForKey(subKey, val, styleProps.resolveValues, styleState) : val;
        else {
          const variantOut = resolveVariants(subKey, val, styleProps, styleState, key);
          if (variantOut)
            for (const [key2, val2] of variantOut)
              val2 != null && (key2 in import_pseudoDescriptors.pseudoDescriptors ? (res[key2] ??= {}, Object.assign(res[key2], val2)) : res[key2] = val2);
        }
        continue;
      }
      if ((0, import_createVariable.isVariable)(val)) {
        res[subKey] = resolveVariableValue(subKey, val, styleProps.resolveValues),  false && 0;
        continue;
      }
      if (typeof val == "string") {
        const fVal = (
          // SYNC WITH *1
          val[0] === "$" ? getTokenForKey(subKey, val, styleProps.resolveValues, styleState) : val
        );
        res[subKey] = fVal;
        continue;
      }
      if ((0, import_isObj.isObj)(val)) {
        const subObject = resolveTokensAndVariants(subKey, val, styleProps, styleState, key);
         false && 0, res[subKey] ??= {}, Object.assign(res[subKey], subObject);
      } else
        res[subKey] = val;
       false && 0;
    }
  }
  return res;
}, tokenCats = ["size", "color", "radius", "space", "zIndex"].map((name) => ({
  name,
  spreadName: `...${name}`
}));
function getVariantDefinition(variant, value, conf) {
  if (typeof variant == "function")
    return variant;
  const exact = variant[value];
  if (exact)
    return exact;
  if (value != null) {
    const { tokensParsed } = conf;
    for (const { name, spreadName } of tokenCats)
      if (spreadName in variant && value in tokensParsed[name])
        return variant[spreadName];
    const fontSizeVariant = variant["...fontSize"];
    if (fontSizeVariant && conf.fontSizeTokens.has(value))
      return fontSizeVariant;
  }
  return variant[`:${typeof value}`] || variant["..."];
}
const fontShorthand = {
  fontSize: "size",
  fontWeight: "weight"
};
let lastFontFamilyToken = null;
const getTokenForKey = (key, value, resolveAs = "none", styleState) => {
  if (resolveAs === "none")
    return value;
  const { theme, conf = (0, import_config.getConfig)(), context, fontFamily, staticConfig } = styleState, tokensParsed = conf.tokensParsed;
  let valOrVar, hasSet = !1;
  const customTokenAccept = staticConfig?.accept?.[key];
  if (customTokenAccept) {
    const val = theme?.[value] ?? tokensParsed[customTokenAccept][value];
    val != null && (resolveAs = "value", valOrVar = val, hasSet = !0);
  }
  if (theme && value in theme) {
    if (valOrVar = theme[value], styleState.skipThemeTokenResolution && valOrVar?.val)
      return  false && 0, value;
     false && 0, hasSet = !0;
  } else {
    if (value in conf.specificTokens)
      hasSet = !0, valOrVar = conf.specificTokens[value];
    else {
      switch (key) {
        case "fontFamily": {
          valOrVar = (context?.language ? (0, import_getVariantExtras.getFontsForLanguage)(conf.fontsParsed, context.language) : conf.fontsParsed)[value]?.family || value, lastFontFamilyToken = value, hasSet = !0;
          break;
        }
        case "fontSize":
        case "lineHeight":
        case "letterSpacing":
        case "fontWeight": {
          const defaultFont = conf.defaultFont || "$body", fam = fontFamily || defaultFont;
          if (fam) {
            const fontsParsed = context?.language ? (0, import_getVariantExtras.getFontsForLanguage)(conf.fontsParsed, context.language) : conf.fontsParsed;
            valOrVar = (fontsParsed[fam] || fontsParsed[defaultFont])?.[fontShorthand[key] || key]?.[value] || value, hasSet = !0;
          }
          break;
        }
      }
      for (const cat in import_helpers.tokenCategories)
        if (key in import_helpers.tokenCategories[cat]) {
          const res = tokensParsed[cat][value];
          res != null && (valOrVar = res, hasSet = !0);
        }
    }
    if (!hasSet) {
      const spaceVar = tokensParsed.space[value];
      spaceVar != null && (valOrVar = spaceVar, hasSet = !0);
    }
  }
  if (hasSet) {
    const out = resolveVariableValue(key, valOrVar, resolveAs);
    return  false && 0, out;
  }
   false && 0;
};
function resolveVariableValue(key, valOrVar, resolveValues) {
  if (resolveValues === "none") return valOrVar;
  if ((0, import_createVariable.isVariable)(valOrVar)) {
    if (resolveValues === "value")
      return valOrVar.val;
    const get = valOrVar?.get;
    return typeof get == "function" ? get(resolveValues === "web" ? "web" : void 0) : valOrVar.variable;
  }
  return valOrVar;
}
//# sourceMappingURL=propMapper.js.map


/***/ }),

/***/ 63225:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var proxyThemeToParents_exports = {};
__export(proxyThemeToParents_exports, {
  proxyThemeToParents: () => proxyThemeToParents,
  proxyThemesToParents: () => proxyThemesToParents
});
module.exports = __toCommonJS(proxyThemeToParents_exports);
var import_config = __webpack_require__(16265);
const themesRaw = {};
function proxyThemesToParents(dedupedThemes) {
  for (const { names, theme } of dedupedThemes)
    for (const name of names)
      themesRaw[name] = theme;
  const themes = {};
  for (const { names, theme } of dedupedThemes)
    for (const themeName of names) {
      const proxiedTheme = proxyThemeToParents(themeName, theme);
      themes[themeName] = proxiedTheme;
    }
  return themes;
}
function proxyThemeToParents(themeName, theme) {
  const cur = [], parents = themeName.split("_").slice(0, -1).map((part) => (cur.push(part), cur.join("_"))), numParents = parents.length;
  return new Proxy(theme, {
    get(target, key) {
      if (!key || // dont ask me, idk why but on hermes you can see that useTheme()[undefined] passes in STRING undefined to proxy
      // if someone is crazy enough to use "undefined" as a theme key then this not working is on them
      key == "undefined" || Reflect.has(target, key))
        return Reflect.get(target, key);
      for (let i = numParents - 1; i >= 0; i--) {
        const parent = themesRaw[parents[i]];
        if (parent && Reflect.has(parent, key))
          return Reflect.get(parent, key);
      }
      return (0, import_config.getTokenObject)(key);
    }
  });
}
//# sourceMappingURL=proxyThemeToParents.js.map


/***/ }),

/***/ 22476:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var proxyThemeVariables_exports = {};
__export(proxyThemeVariables_exports, {
  proxyThemeVariables: () => proxyThemeVariables
});
module.exports = __toCommonJS(proxyThemeVariables_exports);
function proxyThemeVariables(obj) {
  return new Proxy(obj || {}, {
    has(target, key) {
      return Reflect.has(target, removeStarting$(key));
    },
    get(target, key) {
      return Reflect.get(target, removeStarting$(key));
    }
  });
}
const removeStarting$ = (str) => typeof str == "string" && str[0] === "$" ? str.slice(1) : str;
//# sourceMappingURL=proxyThemeVariables.js.map


/***/ }),

/***/ 45204:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var pseudoDescriptors_exports = {};
__export(pseudoDescriptors_exports, {
  pseudoDescriptors: () => pseudoDescriptors,
  pseudoDescriptorsBase: () => pseudoDescriptorsBase,
  pseudoPriorities: () => pseudoPriorities
});
module.exports = __toCommonJS(pseudoDescriptors_exports);
const pseudoDescriptorsBase = {
  // order of keys here important! in priority order
  hoverStyle: {
    name: "hover",
    priority: 1
  },
  pressStyle: {
    name: "active",
    stateKey: "press",
    priority: 2
  },
  focusVisibleStyle: {
    name: "focus-visible",
    priority: 3,
    stateKey: "focusVisible"
  },
  focusStyle: {
    name: "focus",
    priority: 3
  },
  disabledStyle: {
    name: "disabled",
    priority: 4,
    stateKey: "disabled"
  }
}, pseudoPriorities = {
  hover: 1,
  press: 2,
  focus: 3,
  focusVisible: 3,
  disabled: 4
}, pseudoDescriptors = {
  ...pseudoDescriptorsBase,
  enterStyle: {
    name: "enter",
    selector: ".t_unmounted",
    priority: 4
  },
  exitStyle: {
    name: "exit",
    priority: 5
  }
};
//# sourceMappingURL=pseudoDescriptors.js.map


/***/ }),

/***/ 20299:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(34155);
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var registerCSSVariable_exports = {};
__export(registerCSSVariable_exports, {
  registerCSSVariable: () => registerCSSVariable,
  tokensValueToVariable: () => tokensValueToVariable,
  variableToCSS: () => variableToCSS
});
module.exports = __toCommonJS(registerCSSVariable_exports);
var import_createVariable = __webpack_require__(88957);
const registerCSSVariable = (v) => {
  tokensValueToVariable.set((0, import_createVariable.getVariableValue)(v), v);
}, variableToCSS = (v, unitless = !1) => `--${process.env.TAMAGUI_CSS_VARIABLE_PREFIX || ""}${(0, import_createVariable.createCSSVariable)(
  v.name,
  !1
)}:${!unitless && typeof v.val == "number" ? `${v.val}px` : v.val}`, tokensValueToVariable = /* @__PURE__ */ new Map();
//# sourceMappingURL=registerCSSVariable.js.map


/***/ }),

/***/ 2934:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var setElementProps_exports = {};
__export(setElementProps_exports, {
  setElementProps: () => setElementProps
});
module.exports = __toCommonJS(setElementProps_exports);
const setElementProps = void 0;
//# sourceMappingURL=setElementProps.js.map


/***/ }),

/***/ 86255:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var skipProps_exports = {};
__export(skipProps_exports, {
  skipProps: () => skipProps
});
module.exports = __toCommonJS(skipProps_exports);
var import_webPropsToSkip = __webpack_require__(8695);
const skipProps = {
  untilMeasured: 1,
  animation: 1,
  space: 1,
  animateOnly: 1,
  disableClassName: 1,
  debug: 1,
  componentName: 1,
  disableOptimization: 1,
  tag: 1,
  style: 1,
  // handled after loop so pseudos set usedKeys and override it if necessary
  group: 1,
  themeInverse: 1,
  animatePresence: 1
};
 false && (0);
 false && 0;
//# sourceMappingURL=skipProps.js.map


/***/ }),

/***/ 26819:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var themeable_exports = {};
__export(themeable_exports, {
  themeable: () => themeable
});
module.exports = __toCommonJS(themeable_exports);
var import_react = __toESM(__webpack_require__(67294)), import_Theme = __webpack_require__(49798), import_jsx_runtime = (
  // @ts-expect-error its ok
  __webpack_require__(85893)
);
function themeable(Component, staticConfig) {
  const withTheme = import_react.default.forwardRef(function(props, ref) {
    const { themeInverse, theme, componentName, themeReset, ...rest } = props, element = /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Component, { ref, ...rest, "data-disable-theme": !0 });
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      import_Theme.Theme,
      {
        componentName: componentName || staticConfig?.componentName,
        name: theme,
        "disable-child-theme": !0,
        debug: props.debug,
        inverse: themeInverse,
        reset: themeReset,
        children: element
      }
    );
  });
  return withTheme.displayName = `Themed(${Component?.displayName || Component?.name || "Anonymous"})`, withTheme;
}
//# sourceMappingURL=themeable.js.map


/***/ }),

/***/ 49055:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var themes_exports = {};
__export(themes_exports, {
  ensureThemeVariable: () => ensureThemeVariable
});
module.exports = __toCommonJS(themes_exports);
var import_createVariable = __webpack_require__(88957);
function ensureThemeVariable(theme, key) {
  const val = theme[key];
  (0, import_createVariable.isVariable)(val) ? val.name !== key && (theme[key] = (0, import_createVariable.createVariable)({
    key: val.name,
    name: key,
    val: val.val
  })) : theme[key] = (0, import_createVariable.createVariable)({
    key,
    name: key,
    val
  });
}
//# sourceMappingURL=themes.js.map


/***/ }),

/***/ 90013:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var transformsToString_exports = {};
__export(transformsToString_exports, {
  transformsToString: () => transformsToString
});
module.exports = __toCommonJS(transformsToString_exports);
var import_normalizeValueWithProperty = __webpack_require__(31053);
function transformsToString(transforms) {
  return transforms.map(
    // { scale: 2 } => 'scale(2)'
    // { translateX: 20 } => 'translateX(20px)'
    // { matrix: [1,2,3,4,5,6] } => 'matrix(1,2,3,4,5,6)'
    (transform) => {
      const type = Object.keys(transform)[0], value = transform[type];
      return type === "matrix" || type === "matrix3d" ? `${type}(${value.join(",")})` : `${type}(${(0, import_normalizeValueWithProperty.normalizeValueWithProperty)(value, type)})`;
    }
  ).join(" ");
}
//# sourceMappingURL=transformsToString.js.map


/***/ }),

/***/ 8695:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var webPropsToSkip_exports = {};
__export(webPropsToSkip_exports, {
  webPropsToSkip: () => webPropsToSkip
});
module.exports = __toCommonJS(webPropsToSkip_exports);
const webPropsToSkip = {};
//# sourceMappingURL=webPropsToSkip.js.map


/***/ }),

/***/ 14964:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var useConfiguration_exports = {};
__export(useConfiguration_exports, {
  useConfiguration: () => useConfiguration
});
module.exports = __toCommonJS(useConfiguration_exports);
var import_react = __toESM(__webpack_require__(67294)), import_config = __webpack_require__(16265), import_ComponentContext = __webpack_require__(22597);
const useConfiguration = () => {
  const { groups, animationDriver, ...restComponentConfig } = import_react.default.useContext(import_ComponentContext.ComponentContext), { animations, ...restConfig } = (0, import_config.getConfig)();
  return {
    ...restConfig,
    ...restComponentConfig,
    animationDriver: animationDriver ?? (0, import_config.getConfig)().animations
  };
};
//# sourceMappingURL=useConfiguration.js.map


/***/ }),

/***/ 61378:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var useDidHydrateOnce_exports = {};
__export(useDidHydrateOnce_exports, {
  useDidHydrateOnce: () => useDidHydrateOnce,
  useDidHydrateOnceRoot: () => useDidHydrateOnceRoot
});
module.exports = __toCommonJS(useDidHydrateOnce_exports);
var import_react = __toESM(__webpack_require__(67294)), import_config = __webpack_require__(16265);
function useDidHydrateOnceRoot() {
  return !0;
}
let last = Date.now();
function useDidHydrateOnce() {
  return (0, import_config.getSetting)("disableSSR") ? !0 : useDidHydrateSync();
}
const emptySubscribe = () => () => {
}, getClientSnapshot = () => !0, getServerSnapshot = () => !1, useDidHydrateSync = () => import_react.default.useSyncExternalStore(emptySubscribe, getClientSnapshot, getServerSnapshot);
//# sourceMappingURL=useDidHydrateOnce.js.map


/***/ }),

/***/ 61968:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var useDisableSSR_exports = {};
__export(useDisableSSR_exports, {
  getDisableSSR: () => getDisableSSR
});
module.exports = __toCommonJS(useDisableSSR_exports);
var import_config = __webpack_require__(16265);
function getDisableSSR(componentContext) {
  return componentContext?.disableSSR ?? (0, import_config.getSetting)("disableSSR");
}
//# sourceMappingURL=useDisableSSR.js.map


/***/ }),

/***/ 25230:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var useIsTouchDevice_exports = {};
__export(useIsTouchDevice_exports, {
  useIsTouchDevice: () => useIsTouchDevice
});
module.exports = __toCommonJS(useIsTouchDevice_exports);
var import_constants = __webpack_require__(14810), import_use_did_finish_ssr = __webpack_require__(36527);
const useIsTouchDevice = () => import_constants.isWeb ? (0, import_use_did_finish_ssr.useDidFinishSSR)() ? import_constants.isTouchable : !1 : !0;
//# sourceMappingURL=useIsTouchDevice.js.map


/***/ }),

/***/ 85030:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(34155);
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var useMedia_exports = {};
__export(useMedia_exports, {
  _dmt: () => _dmt,
  configureMedia: () => configureMedia,
  getMedia: () => getMedia,
  getMediaImportanceIfMoreImportant: () => getMediaImportanceIfMoreImportant,
  getMediaKeyImportance: () => getMediaKeyImportance,
  getMediaState: () => getMediaState,
  isMediaKey: () => isMediaKey,
  mediaKeyMatch: () => mediaKeyMatch,
  mediaKeyToQuery: () => mediaKeyToQuery,
  mediaKeys: () => mediaKeys,
  mediaObjectToString: () => mediaObjectToString,
  mediaQueryConfig: () => mediaQueryConfig,
  mediaState: () => mediaState,
  setMediaShouldUpdate: () => setMediaShouldUpdate,
  setupMediaListeners: () => setupMediaListeners,
  useMedia: () => useMedia
});
module.exports = __toCommonJS(useMedia_exports);
var import_react = __toESM(__webpack_require__(67294)), import_constants = __webpack_require__(14810), import_config = __webpack_require__(16265), import_matchMedia = __webpack_require__(69464), import_pseudoDescriptors = __webpack_require__(45204), import_useDisableSSR = __webpack_require__(61968);
let mediaState = (
  // development only safeguard
   false ? 0 : {}
);
const mediaQueryConfig = {}, getMedia = () => mediaState, mediaKeys = /* @__PURE__ */ new Set(), mediaKeyRegex = /\$(platform|theme|group)-/, isMediaKey = (key) => {
  if (mediaKeys.has(key)) return !0;
  if (key[0] === "$") {
    const match = key.match(mediaKeyRegex);
    if (match) return match[1];
  }
  return !1;
};
let initState;
const defaultMediaImportance = Object.keys(import_pseudoDescriptors.pseudoDescriptors).length;
let mediaKeysOrdered;
const getMediaKeyImportance = (key) => {
  if (false)
    {}
  return (0, import_config.getConfig)().settings.mediaPropOrder ? defaultMediaImportance : mediaKeysOrdered.indexOf(key) + 100;
}, dispose = /* @__PURE__ */ new Set();
let mediaVersion = 0;
const configureMedia = (config) => {
  const { media } = config, mediaQueryDefaultActive = (0, import_config.getSetting)("mediaQueryDefaultActive");
  if (media) {
    mediaVersion++;
    for (const key in media)
      mediaState[key] = mediaQueryDefaultActive?.[key] || !1, mediaKeys.add(`$${key}`);
    Object.assign(mediaQueryConfig, media), initState = { ...mediaState }, mediaKeysOrdered = Object.keys(media), config.disableSSR ? setupMediaListeners() : updateCurrentState();
  }
};
function unlisten() {
  dispose.forEach((cb) => cb()), dispose.clear();
}
let setupVersion = -1;
function setupMediaListeners() {
  if (!(import_constants.isWeb && import_constants.isServer) && setupVersion !== mediaVersion) {
    setupVersion = mediaVersion, unlisten();
    for (const key in mediaQueryConfig) {
      let update = function() {
        const next = !!getMatch().matches;
        next !== mediaState[key] && (mediaState = { ...mediaState, [key]: next }, updateCurrentState());
      };
      const str = mediaObjectToString(mediaQueryConfig[key], key), getMatch = () => (0, import_matchMedia.matchMedia)(str), match = getMatch();
      if (!match)
        throw new Error("\u26A0\uFE0F No match");
      match.addListener(update), dispose.add(() => {
        match.removeListener(update);
      }), update();
    }
  }
}
const listeners = /* @__PURE__ */ new Set();
let flushing = !1, flushVersion = -1;
function updateCurrentState() {
  flushing && flushVersion === mediaVersion || (flushVersion = mediaVersion, flushing = !0, Promise.resolve().then(() => {
    flushing = !1, listeners.forEach((cb) => cb(mediaState));
  }));
}
const States = /* @__PURE__ */ new WeakMap();
function setMediaShouldUpdate(ref, props) {
  return States.set(ref, {
    ...States.get(ref),
    ...props
  });
}
function subscribe(subscriber) {
  return listeners.add(subscriber), () => {
    listeners.delete(subscriber);
  };
}
function useMedia(uidIn, componentContext, debug) {
  const uid = uidIn ?? import_react.default.useRef(), disableSSR = (0, import_useDisableSSR.getDisableSSR)(componentContext), initialState = (disableSSR || !import_constants.isWeb ? mediaState : initState) || {};
  let componentState = States.get(uid);
  componentState || (componentState = { prev: initialState }, States.set(uid, componentState));
  const getSnapshot = () => {
    if (!componentState)
      return initialState;
    const { enabled, keys, prev = initialState } = componentState;
    if (enabled === !1)
      return prev;
    const testKeys = keys ?? (enabled && keys) ?? null;
    return !testKeys || Object.keys(testKeys).every((key) => mediaState[key] === prev[key]) ? prev : (componentState.prev = mediaState, mediaState);
  };
  let state;
  if (process.env.TAMAGUI_SYNC_MEDIA_QUERY)
    state = import_react.default.useSyncExternalStore(
      subscribe,
      getSnapshot,
      () => initialState
    );
  else {
    const [_state, setState] = import_react.default.useState(initialState);
    state = _state, (0, import_constants.useIsomorphicLayoutEffect)(() => {
      function update() {
        setState(getSnapshot);
      }
      return update(), disableSSR || Promise.resolve().then(() => {
        update();
      }), subscribe(update);
    }, []);
  }
  return new Proxy(state, {
    get(_, key) {
      if (!disableMediaTouch)
        return typeof key == "string" && (componentState.keys ||= {}, componentState.keys[key] = !0,  false && 0), Reflect.get(state, key);
    }
  });
}
let disableMediaTouch = !1;
function _dmt(val) {
  disableMediaTouch = val;
}
function getMediaState(mediaGroups, layout) {
  disableMediaTouch = !0;
  let res;
  try {
    res = Object.fromEntries(
      [...mediaGroups].map((mediaKey) => [mediaKey, mediaKeyMatch(mediaKey, layout)])
    );
  } finally {
    disableMediaTouch = !1;
  }
  return res;
}
const getMediaImportanceIfMoreImportant = (mediaKey, key, importancesUsed, isSizeMedia) => {
  const importance = isSizeMedia && !(0, import_config.getSetting)("mediaPropOrder") ? getMediaKeyImportance(mediaKey) : defaultMediaImportance;
  return !importancesUsed[key] || importance > importancesUsed[key] ? importance : null;
};
function camelToHyphen(str) {
  return str.replace(/[A-Z]/g, (m) => `-${m.toLowerCase()}`).toLowerCase();
}
const cache = /* @__PURE__ */ new WeakMap(), cachedMediaKeyToQuery = {};
function mediaObjectToString(query, key) {
  if (typeof query == "string")
    return query;
  if (cache.has(query))
    return cache.get(query);
  const res = Object.entries(query).map(([feature, value]) => (feature = camelToHyphen(feature), typeof value == "string" ? `(${feature}: ${value})` : (typeof value == "number" && /[height|width]$/.test(feature) && (value = `${value}px`), `(${feature}: ${value})`))).join(" and ");
  return key && (cachedMediaKeyToQuery[key] = res), cache.set(query, res), res;
}
function mediaKeyToQuery(key) {
  return cachedMediaKeyToQuery[key] || mediaObjectToString(mediaQueryConfig[key], key);
}
function mediaKeyMatch(key, dimensions) {
  const mediaQueries = mediaQueryConfig[key];
  return Object.keys(mediaQueries).every((query) => {
    const expectedVal = +mediaQueries[query], isMax = query.startsWith("max"), isWidth = query.endsWith("Width"), givenVal = dimensions[isWidth ? "width" : "height"];
    return isMax ? givenVal < expectedVal : givenVal > expectedVal;
  });
}
//# sourceMappingURL=useMedia.js.map


/***/ }),

/***/ 69667:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var useProps_exports = {};
__export(useProps_exports, {
  useProps: () => useProps,
  usePropsAndStyle: () => usePropsAndStyle,
  useStyle: () => useStyle
});
module.exports = __toCommonJS(useProps_exports);
var import_react = __toESM(__webpack_require__(67294)), import_config = __webpack_require__(16265), import_ComponentContext = __webpack_require__(22597), import_createComponent = __webpack_require__(86932), import_getSplitStyles = __webpack_require__(41384), import_Stack = __webpack_require__(30926), import_useMedia = __webpack_require__(85030), import_useTheme = __webpack_require__(69953);
function useProps(props, opts) {
  const [propsOut, styleOut] = usePropsAndStyle(props, {
    ...opts,
    noExpand: !0,
    noNormalize: !0,
    resolveValues: "none"
  });
  return {
    ...propsOut,
    ...styleOut
  };
}
function useStyle(props, opts) {
  return usePropsAndStyle(props, opts)[1] || {};
}
function usePropsAndStyle(props, opts) {
  const staticConfig = opts?.forComponent?.staticConfig ?? import_Stack.Stack.staticConfig, [themeState, theme] = (0, import_useTheme.useThemeWithState)({
    componentName: staticConfig.componentName,
    name: "theme" in props ? props.theme : void 0,
    inverse: "themeInverse" in props ? props.themeInverse : void 0
  }), componentContext = import_react.default.useContext(import_ComponentContext.ComponentContext), { state, disabled, setStateShallow } = (0, import_createComponent.useComponentState)(
    props,
    componentContext,
    staticConfig,
    (0, import_config.getConfig)()
  ), media = (0, import_useMedia.useMedia)(), splitStyles = (0, import_getSplitStyles.useSplitStyles)(
    props,
    staticConfig,
    theme,
    themeState.state?.name || "",
    state,
    {
      isAnimated: !1,
      mediaState: media,
      noSkip: !0,
      noMergeStyle: !0,
      noClassNames: !0,
      resolveValues: "auto",
      ...opts
    },
    null,
    componentContext
  ), { mediaGroups, pseudoGroups } = splitStyles;
  return import_react.default.useEffect(() => {
    if (!disabled) {
      if (state.unmounted) {
        setStateShallow({ unmounted: !1 });
        return;
      }
      return (0, import_createComponent.subscribeToContextGroup)({
        disabled,
        componentContext,
        setStateShallow,
        state,
        mediaGroups,
        pseudoGroups
      });
    }
  }, [
    disabled,
    pseudoGroups ? Object.keys([...pseudoGroups]).join("") : 0,
    mediaGroups ? Object.keys([...mediaGroups]).join("") : 0
  ]), [splitStyles.viewProps, splitStyles.style || {}, theme, media];
}
//# sourceMappingURL=useProps.js.map


/***/ }),

/***/ 69953:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var useTheme_exports = {};
__export(useTheme_exports, {
  activeThemeManagers: () => activeThemeManagers,
  getThemeManager: () => getThemeManager,
  getThemeProxied: () => getThemeProxied,
  useChangeThemeEffect: () => useChangeThemeEffect,
  useTheme: () => useTheme,
  useThemeWithState: () => useThemeWithState
});
module.exports = __toCommonJS(useTheme_exports);
var import_react = __toESM(__webpack_require__(67294)), import_constants = __webpack_require__(14810), import_config = __webpack_require__(16265), import_createVariable = __webpack_require__(88957), import_ThemeManager = __webpack_require__(21497), import_ThemeManagerContext = __webpack_require__(2856), import_createShallowSetState = __webpack_require__(66575);
const emptyProps = { name: null };
let cached;
function getDefaultThemeProxied() {
  if (cached) return cached;
  const config = (0, import_config.getConfig)(), name = config.themes.light ? "light" : Object.keys(config.themes)[0], defaultTheme = config.themes[name];
  return cached = getThemeProxied({ theme: defaultTheme, name }), cached;
}
const useTheme = (props = emptyProps) => {
  const [_, theme] = useThemeWithState(props);
  return theme || getDefaultThemeProxied();
}, useThemeWithState = (props) => {
  const keys = import_react.default.useRef([]), changedThemeState = useChangeThemeEffect(
    props,
    !1,
    keys.current,
    import_constants.isServer ? void 0 : () => {
      const next = props.shouldUpdate?.() ?? (keys.current.length > 0 ? !0 : void 0);
      return  false && 0, next;
    }
  ), { themeManager, state } = changedThemeState;
   false && (0);
  const themeProxied = import_react.default.useMemo(() => !themeManager || !state?.theme ? {} : getThemeProxied(state, props.deopt, themeManager, keys.current, props.debug), [state?.theme, themeManager, props.deopt, props.debug]);
  return  false && (0), [changedThemeState, themeProxied];
};
function getThemeProxied({ theme, name, scheme }, deopt = !1, themeManager, keys, debug) {
  if (!theme) return {};
  const config = (0, import_config.getConfig)();
  function track(key) {
    keys && !keys.includes(key) && (keys.push(key),  false && 0);
  }
  return new Proxy(theme, {
    has(_, key) {
      if (Reflect.has(theme, key))
        return !0;
      if (typeof key == "string")
        return key[0] === "$" && (key = key.slice(1)), themeManager?.allKeys.has(key);
    },
    get(_, key) {
      if (
        // dont ask me, idk why but on hermes you can see that useTheme()[undefined] passes in STRING undefined to proxy
        // if someone is crazy enough to use "undefined" as a theme key then this not working is on them
        key !== "undefined" && typeof key == "string"
      ) {
        const keyString = key[0] === "$" ? key.slice(1) : key, val = theme[keyString];
        if (val && typeof val == "object")
          return new Proxy(val, {
            // when they touch the actual value we only track it
            // if its a variable (web), its ignored!
            get(_2, subkey) {
              if (subkey === "val")
                track(keyString);
              else if (subkey === "get")
                return (platform) => (0, import_createVariable.getVariable)(val);
              return Reflect.get(val, subkey);
            }
          });
        if (false)
          {}
      }
      return Reflect.get(_, key);
    }
  });
}
const activeThemeManagers = /* @__PURE__ */ new Set(), _uidToManager = /* @__PURE__ */ new WeakMap(), _idToUID = {}, getId = (id) => _idToUID[id], getThemeManager = (id) => _uidToManager.get(getId(id)), registerThemeManager = (t) => {
  if (!_idToUID[t.id]) {
    const id = _idToUID[t.id] = {};
    _uidToManager.set(id, t);
  }
}, ogLog = console.error, preventWarnSetState =  true ? ogLog : (
  // temporary fix for logs, they are harmless in that i've tried to rewrite this
  // a few times using the "right" ways, but they are always slower. maybe skill issue
  0
), useChangeThemeEffect = (props, isRoot = !1, keys, shouldUpdate) => {
  const { disable } = props, parentManagerId = import_react.default.useContext(import_ThemeManagerContext.ThemeManagerIDContext), parentManager = getThemeManager(parentManagerId);
  if (!isRoot && !parentManager || disable)
    return {
      isNewTheme: !1,
      state: parentManager?.state,
      themeManager: parentManager
    };
  const [themeState, setThemeState] = import_react.default.useState(createState), { state, mounted, isNewTheme, themeManager, inversed } = themeState, isInversingOnMount = !!(!themeState.mounted && props.inverse);
  function getShouldUpdateTheme(manager = themeManager, nextState, prevState = state, forceShouldChange = !1) {
    const forceUpdate = shouldUpdate?.();
    if (!manager || !forceShouldChange && forceUpdate === !1) return;
    const next = nextState || manager.getState(props, parentManager);
    if (forceShouldChange) return next;
    if (next && !(forceUpdate !== !0 && !manager.getStateShouldChange(next, prevState)))
      return next;
  }
  if (import_constants.isServer || (import_react.default.useEffect(() => {
    if (!themeManager) return;
    if (props.inverse && !mounted) {
      setThemeState((prev) => createState({
        ...prev,
        mounted: !0
      }));
      return;
    }
    (isNewTheme || getShouldUpdateTheme(themeManager)) && (activeThemeManagers.add(themeManager), setThemeState(createState));
    const selfListenerDispose = themeManager.onChangeTheme((_a, _b, forced) => {
      forced && (console.error = preventWarnSetState, setThemeState((prev) => createState(prev, !0)), console.error = ogLog);
    }), disposeChangeListener = parentManager?.onChangeTheme(
      (name, manager, forced) => {
        const force = forced || shouldUpdate?.() || props.deopt || void 0, shouldTryUpdate = force ?? !!(keys?.length || isNewTheme);
         false && 0, shouldTryUpdate && (console.error = preventWarnSetState, setThemeState((prev) => createState(prev, force)), console.error = ogLog);
      },
      themeManager.id
    );
    return () => {
      selfListenerDispose(), disposeChangeListener?.(), isNewTheme && activeThemeManagers.delete(themeManager);
    };
  }, [
    themeManager,
    parentManager,
    isNewTheme,
    props.componentName,
    props.inverse,
    props.name,
    props.reset,
    mounted
  ]),  false && 0), import_constants.isWeb && isInversingOnMount)
    return {
      isNewTheme: !1,
      inversed: !1,
      themeManager: parentManager,
      state: {
        name: "",
        ...parentManager?.state,
        className: ""
      }
    };
  return {
    state,
    isNewTheme,
    inversed,
    themeManager
  };
  function createState(prev, force = !1) {
    if (prev && shouldUpdate?.() === !1 && !force)
      return prev;
    let themeManager2 = parentManager, state2;
    if ((0, import_ThemeManager.getHasThemeUpdatingProps)(props)) {
      const getNewThemeManager = () => new import_ThemeManager.ThemeManager(props, isRoot ? "root" : parentManager);
      if (prev?.themeManager) {
        themeManager2 = prev.themeManager;
        const forceChange = force || !!keys?.length, next = themeManager2.getState(props, parentManager), nextState = getShouldUpdateTheme(
          themeManager2,
          next,
          prev.state,
          forceChange
        );
        nextState ? (state2 = nextState, !prev.isNewTheme && !isRoot ? themeManager2 = getNewThemeManager() : themeManager2.updateState(nextState)) : prev.isNewTheme && parentManager && !next && (themeManager2 = parentManager);
      } else
        themeManager2 = getNewThemeManager(), state2 = { ...themeManager2.state };
    }
    const isNewTheme2 = !!(themeManager2 !== parentManager || props.inverse);
    isNewTheme2 && registerThemeManager(themeManager2);
    const isWebSSR = import_constants.isWeb ? !(0, import_config.getSetting)("disableSSR") : !1, mounted2 = isWebSSR ? isRoot || prev?.mounted : !0;
    state2 || (isNewTheme2 ? state2 = themeManager2.state : (state2 = parentManager.state, themeManager2 = parentManager));
    const wasInversed = prev?.inversed, isInherentlyInversed = isNewTheme2 && state2.scheme !== parentManager?.state.scheme, inversed2 = isRoot ? !1 : isInherentlyInversed ? !0 : isWebSSR ? wasInversed != null ? !1 : null : props.inverse, response = {
      themeManager: themeManager2,
      isNewTheme: isNewTheme2,
      mounted: mounted2,
      inversed: inversed2
    }, shouldReturnPrev = prev && !force && // isEqualShallow uses the second arg as the keys so this should compare without state first...
    (0, import_createShallowSetState.isEqualShallow)(prev, response) && // ... and then compare just the state, because we make a new state obj but is likely the same
    (0, import_createShallowSetState.isEqualShallow)(prev.state, state2);
    if (prev && shouldReturnPrev)
      return prev;
    if (response.state = state2,  false && 0) {
      console.groupCollapsed(`\u{1F537} [${themeManager2.id}] useChangeThemeEffect createState`);
      const parentState = { ...parentManager?.state }, parentId = parentManager?.id, themeManagerState = { ...themeManager2.state };
      console.info({
        props,
        parentState,
        parentId,
        themeManager: themeManager2,
        prev,
        response,
        themeManagerState
      }), console.groupEnd();
    }
    return response;
  }
};
//# sourceMappingURL=useTheme.js.map


/***/ }),

/***/ 63114:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var useThemeName_exports = {};
__export(useThemeName_exports, {
  useThemeName: () => useThemeName
});
module.exports = __toCommonJS(useThemeName_exports);
var import_react = __toESM(__webpack_require__(67294)), import_constants = __webpack_require__(14810), import_ThemeManagerContext = __webpack_require__(2856), import_useTheme = __webpack_require__(69953);
function useThemeName(opts) {
  const manager = (0, import_useTheme.getThemeManager)(import_react.default.useContext(import_ThemeManagerContext.ThemeManagerIDContext)), [name, setName] = import_react.default.useState(manager?.state.name || "");
  return (0, import_constants.useIsomorphicLayoutEffect)(() => {
    if (manager)
      return setName(manager.state.name), manager.onChangeTheme((next, manager2) => {
        const name2 = opts?.parent && manager2.state.parentName || next;
        name2 && setName(name2);
      });
  }, [manager?.state.name]), name;
}
//# sourceMappingURL=useThemeName.js.map


/***/ }),

/***/ 17187:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
}, __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var src_exports = {};
__export(src_exports, {
  configureMedia: () => import_useMedia.configureMedia,
  getConfig: () => import_config.getConfig,
  getMedia: () => import_useMedia.getMedia,
  getThemes: () => import_config.getThemes,
  getToken: () => import_config.getToken,
  getTokenValue: () => import_config.getTokenValue,
  getTokens: () => import_config.getTokens,
  mediaKeyMatch: () => import_useMedia.mediaKeyMatch,
  mediaObjectToString: () => import_useMedia.mediaObjectToString,
  mediaQueryConfig: () => import_useMedia.mediaQueryConfig,
  mediaState: () => import_useMedia.mediaState,
  setNonce: () => import_insertStyleRule.setNonce,
  setupDev: () => import_config.setupDev,
  updateConfig: () => import_config.updateConfig,
  useMedia: () => import_useMedia.useMedia
});
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(5656), module.exports);
__reExport(src_exports, __webpack_require__(86932), module.exports);
__reExport(src_exports, __webpack_require__(99414), module.exports);
__reExport(src_exports, __webpack_require__(72705), module.exports);
__reExport(src_exports, __webpack_require__(45502), module.exports);
__reExport(src_exports, __webpack_require__(74274), module.exports);
__reExport(src_exports, __webpack_require__(6019), module.exports);
__reExport(src_exports, __webpack_require__(88957), module.exports);
__reExport(src_exports, __webpack_require__(26596), module.exports);
__reExport(src_exports, __webpack_require__(89459), module.exports);
__reExport(src_exports, __webpack_require__(86077), module.exports);
__reExport(src_exports, __webpack_require__(83013), module.exports);
__reExport(src_exports, __webpack_require__(29846), module.exports);
var import_config = __webpack_require__(16265), import_insertStyleRule = __webpack_require__(37269);
__reExport(src_exports, __webpack_require__(36297), module.exports);
__reExport(src_exports, __webpack_require__(22597), module.exports);
__reExport(src_exports, __webpack_require__(12607), module.exports);
__reExport(src_exports, __webpack_require__(44395), module.exports);
__reExport(src_exports, __webpack_require__(66575), module.exports);
__reExport(src_exports, __webpack_require__(97564), module.exports);
__reExport(src_exports, __webpack_require__(36152), module.exports);
__reExport(src_exports, __webpack_require__(13642), module.exports);
__reExport(src_exports, __webpack_require__(41384), module.exports);
__reExport(src_exports, __webpack_require__(9161), module.exports);
__reExport(src_exports, __webpack_require__(86932), module.exports);
__reExport(src_exports, __webpack_require__(75099), module.exports);
__reExport(src_exports, __webpack_require__(37645), module.exports);
__reExport(src_exports, __webpack_require__(45701), module.exports);
__reExport(src_exports, __webpack_require__(10454), module.exports);
__reExport(src_exports, __webpack_require__(69464), module.exports);
__reExport(src_exports, __webpack_require__(1458), module.exports);
__reExport(src_exports, __webpack_require__(66106), module.exports);
__reExport(src_exports, __webpack_require__(58325), module.exports);
__reExport(src_exports, __webpack_require__(31053), module.exports);
__reExport(src_exports, __webpack_require__(80408), module.exports);
__reExport(src_exports, __webpack_require__(63225), module.exports);
__reExport(src_exports, __webpack_require__(22476), module.exports);
__reExport(src_exports, __webpack_require__(45204), module.exports);
__reExport(src_exports, __webpack_require__(26819), module.exports);
__reExport(src_exports, __webpack_require__(49055), module.exports);
__reExport(src_exports, __webpack_require__(90013), module.exports);
var import_useMedia = __webpack_require__(85030);
__reExport(src_exports, __webpack_require__(69953), module.exports);
__reExport(src_exports, __webpack_require__(63114), module.exports);
__reExport(src_exports, __webpack_require__(14964), module.exports);
__reExport(src_exports, __webpack_require__(25230), module.exports);
__reExport(src_exports, __webpack_require__(69667), module.exports);
__reExport(src_exports, __webpack_require__(14964), module.exports);
__reExport(src_exports, __webpack_require__(12897), module.exports);
__reExport(src_exports, __webpack_require__(30926), module.exports);
__reExport(src_exports, __webpack_require__(33339), module.exports);
__reExport(src_exports, __webpack_require__(34632), module.exports);
__reExport(src_exports, __webpack_require__(49798), module.exports);
__reExport(src_exports, __webpack_require__(15795), module.exports);
__reExport(src_exports, __webpack_require__(74065), module.exports);
__reExport(src_exports, __webpack_require__(20770), module.exports);
__reExport(src_exports, __webpack_require__(60900), module.exports);
__reExport(src_exports, __webpack_require__(36527), module.exports);
__reExport(src_exports, __webpack_require__(90951), module.exports);
__reExport(src_exports, __webpack_require__(95915), module.exports);
__reExport(src_exports, __webpack_require__(37513), module.exports);
__reExport(src_exports, __webpack_require__(14810), module.exports);
__reExport(src_exports, __webpack_require__(25142), module.exports);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 89459:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var insertFont_exports = {};
__export(insertFont_exports, {
  insertFont: () => insertFont,
  parseFont: () => parseFont,
  registerFontVariables: () => registerFontVariables,
  updateFont: () => updateFont
});
module.exports = __toCommonJS(insertFont_exports);
var import_config = __webpack_require__(16265), import_constants = __webpack_require__(36297), import_createFont = __webpack_require__(74274), import_createVariables = __webpack_require__(26596), import_registerCSSVariable = __webpack_require__(20299);
function insertFont(name, fontIn) {
  const font = (0, import_createFont.createFont)(fontIn), tokened = (0, import_createVariables.createVariables)(font, name), parsed = parseFont(tokened);
  if (typeof document < "u") {
    const fontVars = registerFontVariables(parsed), styleElement = document.querySelector(`style[${import_constants.FONT_DATA_ATTRIBUTE_NAME}="${name}"]`) || document.createElement("style");
    styleElement.innerText = `:root .font_${name} {${fontVars.join(";")}}`, styleElement.setAttribute(import_constants.FONT_DATA_ATTRIBUTE_NAME, name), document.head.appendChild(styleElement);
  }
  return (0, import_config.setConfigFont)(name, tokened, parsed), parsed;
}
const updateFont = insertFont;
function parseFont(definition) {
  const parsed = {};
  for (const attrKey in definition) {
    const attr = definition[attrKey];
    if (attrKey === "family" || attrKey === "face")
      parsed[attrKey] = attr;
    else {
      parsed[attrKey] = {};
      for (const key in attr) {
        let val = attr[key];
        val.val?.[0] === "$" && (val = val.val), parsed[attrKey][`$${key}`] = val;
      }
    }
  }
  return parsed;
}
function registerFontVariables(parsedFont) {
  const response = [];
  for (const fkey in parsedFont)
    if (fkey !== "face") {
      if (fkey === "family") {
        const val = parsedFont[fkey];
        (0, import_registerCSSVariable.registerCSSVariable)(val), response.push((0, import_registerCSSVariable.variableToCSS)(val));
      } else
        for (const fskey in parsedFont[fkey])
          if (typeof parsedFont[fkey][fskey] != "string") {
            const val = parsedFont[fkey][fskey];
            (0, import_registerCSSVariable.registerCSSVariable)(val), response.push((0, import_registerCSSVariable.variableToCSS)(val));
          }
    }
  return response;
}
//# sourceMappingURL=insertFont.js.map


/***/ }),

/***/ 29846:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var GetRef_exports = {};
module.exports = __toCommonJS(GetRef_exports);
//# sourceMappingURL=GetRef.js.map


/***/ }),

/***/ 25142:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var setupHooks_exports = {};
__export(setupHooks_exports, {
  hooks: () => hooks,
  setupHooks: () => setupHooks
});
module.exports = __toCommonJS(setupHooks_exports);
const hooks = {};
function setupHooks(next) {
  Object.assign(hooks, next);
}
//# sourceMappingURL=setupHooks.js.map


/***/ }),

/***/ 83013:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var setupReactNative_exports = {};
__export(setupReactNative_exports, {
  getReactNativeConfig: () => getReactNativeConfig,
  setupReactNative: () => setupReactNative
});
module.exports = __toCommonJS(setupReactNative_exports);
const ReactNativeStaticConfigs = /* @__PURE__ */ new WeakMap();
function getReactNativeConfig(Component) {
  if (Component)
    return Component.getSize && Component.prefetch ? RNConfigs.Image : Component.displayName === "Text" && Component.render ? RNConfigs.Text : Component.render && (Component.displayName === "ScrollView" || Component.displayName === "View") ? RNConfigs.default : Component.State?.blurTextInput ? RNConfigs.TextInput : ReactNativeStaticConfigs.get(Component);
}
const RNConfigs = {
  Image: {
    isReactNative: !0,
    inlineProps: /* @__PURE__ */ new Set(["src", "width", "height"])
  },
  Text: {
    isReactNative: !0,
    isText: !0
  },
  TextInput: {
    isReactNative: !0,
    isInput: !0,
    isText: !0
  },
  default: {
    isReactNative: !0
  }
};
function setupReactNative(rnExports) {
}
//# sourceMappingURL=setupReactNative.js.map


/***/ }),

/***/ 86077:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var styled_exports = {};
__export(styled_exports, {
  styled: () => styled
});
module.exports = __toCommonJS(styled_exports);
var import_createComponent = __webpack_require__(86932), import_mergeVariants = __webpack_require__(73474), import_setupReactNative = __webpack_require__(83013);
function styled(ComponentIn, options, staticExtractionOptions) {
  if (false)
    {}
  const parentStaticConfig = ComponentIn.staticConfig, isPlainStyledComponent = !!parentStaticConfig && !(parentStaticConfig.isReactNative || parentStaticConfig.isHOC);
  let Component = parentStaticConfig?.isHOC && !parentStaticConfig?.isStyledHOC || isPlainStyledComponent ? ComponentIn : parentStaticConfig?.Component || ComponentIn;
  const reactNativeConfig = parentStaticConfig ? void 0 : (0, import_setupReactNative.getReactNativeConfig)(Component), isReactNative = !!(reactNativeConfig || staticExtractionOptions?.isReactNative || parentStaticConfig?.isReactNative), staticConfigProps = (() => {
    if (options) {
      let {
        variants,
        name,
        defaultVariants,
        acceptsClassName: acceptsClassNameProp,
        context,
        ...defaultProps
      } = options, parentDefaultVariants, parentDefaultProps;
      if (parentStaticConfig && !(parentStaticConfig.isHOC && !parentStaticConfig.isStyledHOC)) {
        const pdp = parentStaticConfig.defaultProps;
        for (const key in pdp) {
          const val = pdp[key];
          parentStaticConfig.defaultVariants && key in parentStaticConfig.defaultVariants && (!defaultVariants || !(key in defaultVariants)) && (parentDefaultVariants ||= {}, parentDefaultVariants[key] = val), key in defaultProps || (parentDefaultProps ||= {}, parentDefaultProps[key] = pdp[key]);
        }
        parentStaticConfig.variants && (variants = (0, import_mergeVariants.mergeVariants)(parentStaticConfig.variants, variants));
      }
      (parentDefaultProps || defaultVariants || parentDefaultVariants) && (defaultProps = {
        ...parentDefaultProps,
        ...parentDefaultVariants,
        ...defaultProps,
        ...defaultVariants
      }), parentStaticConfig?.isHOC && name && (defaultProps.componentName = name);
      const isText = !!(staticExtractionOptions?.isText || parentStaticConfig?.isText), acceptsClassName = staticExtractionOptions?.acceptsClassName ?? acceptsClassNameProp ?? (isPlainStyledComponent || isReactNative || parentStaticConfig?.isHOC && parentStaticConfig?.acceptsClassName), conf = {
        ...parentStaticConfig,
        ...staticExtractionOptions,
        ...!isPlainStyledComponent && {
          Component
        },
        // @ts-expect-error
        variants,
        defaultProps,
        defaultVariants,
        componentName: name || parentStaticConfig?.componentName,
        isReactNative,
        isText,
        acceptsClassName,
        context,
        ...reactNativeConfig,
        isStyledHOC: !!parentStaticConfig?.isHOC,
        parentStaticConfig
      };
      return (defaultProps.children || !acceptsClassName || context) && (conf.neverFlatten = !0), conf;
    }
  })(), component = (0, import_createComponent.createComponent)(staticConfigProps || {});
  for (const key in ComponentIn)
    key !== "propTypes" && (key in component || (component[key] = ComponentIn[key]));
  return component;
}
//# sourceMappingURL=styled.js.map


/***/ }),

/***/ 60900:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var Configuration_exports = {};
__export(Configuration_exports, {
  Configuration: () => Configuration
});
module.exports = __toCommonJS(Configuration_exports);
var import_react = __toESM(__webpack_require__(67294)), import_ComponentContext = __webpack_require__(22597), import_jsx_runtime = __webpack_require__(85893);
const Configuration = (props) => {
  const current = import_react.default.useContext(import_ComponentContext.ComponentContext);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ComponentContext.ComponentContext.Provider, { ...current, ...props });
};
Configuration.displayName = "Configuration";
//# sourceMappingURL=Configuration.js.map


/***/ }),

/***/ 74065:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var FontLanguage_exports = {};
__export(FontLanguage_exports, {
  FontLanguage: () => FontLanguage
});
module.exports = __toCommonJS(FontLanguage_exports);
var import_jsx_runtime = __webpack_require__(85893);
const FontLanguage = ({ children, ...props }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
  "div",
  {
    style: {
      display: "contents"
    },
    className: Object.entries(props).map(([name, language]) => `t_lang-${name}-${language}`).join(" "),
    children
  }
);
FontLanguage.displayName = "FontLanguage";
//# sourceMappingURL=FontLanguage.js.map


/***/ }),

/***/ 12897:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var Slot_exports = {};
__export(Slot_exports, {
  Slot: () => Slot,
  Slottable: () => Slottable
});
module.exports = __toCommonJS(Slot_exports);
var import_compose_refs = __webpack_require__(95915), import_constants = __webpack_require__(14810), import_helpers = __webpack_require__(37513), import_react = __webpack_require__(67294), import_jsx_runtime = __webpack_require__(85893);
const is19 = import_react.version.startsWith("19."), Slot = (0, import_react.forwardRef)(function(props, forwardedRef) {
  const { children, ...slotProps } = props;
  if ((0, import_react.isValidElement)(children)) {
    const mergedProps = mergeSlotProps(children, slotProps);
    return (0, import_react.cloneElement)(
      children,
      children.type.avoidForwardRef ? mergedProps : {
        ...mergedProps,
        ref: (0, import_compose_refs.composeRefs)(
          forwardedRef,
          is19 ? children.props.ref : children.ref
        )
      }
    );
  }
  return import_react.Children.count(children) > 1 ? import_react.Children.only(null) : null;
});
Slot.displayName = "Slot";
const Slottable = ({ children }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, { children });
Slottable.displayName = "Slottable";
const pressMap = import_constants.isWeb ? {
  onPress: "onClick",
  onPressOut: "onMouseUp",
  onPressIn: "onMouseDown"
} : {};
function mergeSlotProps(child, slotProps) {
  const childProps = child.props, overrideProps = { ...childProps }, isHTMLChild = typeof child.type == "string";
  if (isHTMLChild)
    for (const key in pressMap)
      key in slotProps && (slotProps[pressMap[key]] = slotProps[key], delete slotProps[key]);
  for (let propName in childProps) {
    const slotPropValue = slotProps[propName], childPropValue = childProps[propName];
    isHTMLChild && propName in pressMap && (propName = pressMap[propName], delete overrideProps[propName]), handleRegex.test(propName) ? overrideProps[propName] = (0, import_helpers.composeEventHandlers)(childPropValue, slotPropValue) : propName === "style" ? overrideProps[propName] = { ...slotPropValue, ...childPropValue } : propName === "className" && (overrideProps[propName] = [slotPropValue, childPropValue].filter(Boolean).join(" "));
  }
  return { ...slotProps, ...overrideProps };
}
const handleRegex = /^on[A-Z]/;
//# sourceMappingURL=Slot.js.map


/***/ }),

/***/ 30926:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var Stack_exports = {};
__export(Stack_exports, {
  Stack: () => Stack
});
module.exports = __toCommonJS(Stack_exports);
var import_helpers = __webpack_require__(37513), import_constants = __webpack_require__(36297), import_createComponent = __webpack_require__(86932);
const Stack = (0, import_createComponent.createComponent)({
  acceptsClassName: !0,
  defaultProps: import_constants.stackDefaultStyles,
  validStyles: import_helpers.validStyles
});
Stack.displayName = "Stack";
//# sourceMappingURL=Stack.js.map


/***/ }),

/***/ 20770:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var TamaguiProvider_exports = {};
__export(TamaguiProvider_exports, {
  TamaguiProvider: () => TamaguiProvider
});
module.exports = __toCommonJS(TamaguiProvider_exports);
var import_react = __toESM(__webpack_require__(67294)), import_constants = __webpack_require__(14810), import_ComponentContext = __webpack_require__(22597), import_useDidHydrateOnce = __webpack_require__(61378), import_useMedia = __webpack_require__(85030), import_ThemeProvider = __webpack_require__(15795), import_config = __webpack_require__(16265), import_jsx_runtime = __webpack_require__(85893);
function TamaguiProvider({
  children,
  disableInjectCSS,
  config,
  className,
  defaultTheme,
  disableRootThemeClass,
  reset,
  themeClassNameOnRoot
}) {
  return (0, import_useMedia.setupMediaListeners)(), import_constants.isClient && ((0, import_useDidHydrateOnce.useDidHydrateOnceRoot)(), (0, import_constants.useIsomorphicLayoutEffect)(() => {
    if (config && !disableInjectCSS) {
      const style = document.createElement("style");
      return style.appendChild(document.createTextNode(config.getCSS())), document.head.appendChild(style), () => {
        document.head.removeChild(style);
      };
    }
  }, [config, disableInjectCSS])), /* @__PURE__ */ (0, import_jsx_runtime.jsx)(UnmountedClassName, { children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ComponentContext.ComponentContext.Provider, { animationDriver: config?.animations, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    import_ThemeProvider.ThemeProvider,
    {
      themeClassNameOnRoot: themeClassNameOnRoot ?? (0, import_config.getSetting)("themeClassNameOnRoot"),
      disableRootThemeClass: disableRootThemeClass ?? (0, import_config.getSetting)("disableRootThemeClass"),
      defaultTheme: defaultTheme ?? (config ? Object.keys(config.themes)[0] : ""),
      reset,
      className,
      children
    }
  ) }) });
}
function UnmountedClassName(props) {
  const [mounted, setMounted] = import_react.default.useState(!1);
  return import_react.default.useEffect(() => {
    setMounted(!0);
  }, []), import_constants.isWeb ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)("span", { style: { display: "contents" }, className: mounted ? "" : "t_unmounted", children: props.children }) : props.children;
}
TamaguiProvider.displayName = "TamaguiProvider";
//# sourceMappingURL=TamaguiProvider.js.map


/***/ }),

/***/ 34632:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var Text_exports = {};
__export(Text_exports, {
  Text: () => Text
});
module.exports = __toCommonJS(Text_exports);
var import_helpers = __webpack_require__(37513), import_createComponent = __webpack_require__(86932);
const ellipseStyle = {
  maxWidth: "100%",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
}, defaultWebStyle = {
  display: "inline",
  // display: inline breaks css transform styles
  boxSizing: "border-box",
  wordWrap: "break-word",
  whiteSpace: "pre-wrap",
  margin: 0
}, ellipsisStyle = ellipseStyle, Text = (0, import_createComponent.createComponent)({
  acceptsClassName: !0,
  isText: !0,
  defaultProps: {
    fontFamily: "unset",
    ...defaultWebStyle
  },
  inlineWhenUnflattened: /* @__PURE__ */ new Set(["fontFamily"]),
  variants: {
    numberOfLines: {
      1: ellipseStyle,
      ":number": (numberOfLines) => numberOfLines >= 1 ? {
        WebkitLineClamp: numberOfLines,
        WebkitBoxOrient: "vertical",
        display: "-webkit-box",
        overflow: "hidden"
      } : null
    },
    selectable: {
      true: {
        userSelect: "text",
        cursor: "text"
      },
      false: {
        userSelect: "none",
        cursor: "default"
      }
    },
    /**
     * @deprecated Use ellipsis instead
     */
    ellipse: {
      true: ellipsisStyle
    },
    ellipsis: {
      true: ellipsisStyle
    }
  },
  validStyles: {
    ...import_helpers.validStyles,
    ...import_helpers.stylePropsTextOnly
  }
});
Text.displayName = "Text";
//# sourceMappingURL=Text.js.map


/***/ }),

/***/ 49798:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var Theme_exports = {};
__export(Theme_exports, {
  Theme: () => Theme,
  getThemedChildren: () => getThemedChildren
});
module.exports = __toCommonJS(Theme_exports);
var import_constants = __webpack_require__(14810), import_react = __toESM(__webpack_require__(67294)), import_createVariable = __webpack_require__(88957), import_ThemeManagerContext = __webpack_require__(2856), import_useTheme = __webpack_require__(69953), import_ThemeDebug = __webpack_require__(14362), import_log = __webpack_require__(97727), import_jsx_runtime = __webpack_require__(85893);
const Theme = (0, import_react.forwardRef)(function({ children, ...props }, ref) {
  if (props.disable)
    return children;
  const isRoot = !!props._isRoot, themeState = (0, import_useTheme.useChangeThemeEffect)(props, isRoot);
  let finalChildren = props["disable-child-theme"] ? import_react.Children.map(
    children,
    (child) => (0, import_react.cloneElement)(child, { "data-disable-theme": !0 })
  ) : children;
  if (ref)
    try {
      import_react.default.Children.only(finalChildren), finalChildren = (0, import_react.cloneElement)(finalChildren, { ref });
    } catch {
    }
   false && (0);
  const stateRef = (0, import_react.useRef)({
    hasEverThemed: !1
  });
  return getThemedChildren(themeState, finalChildren, props, isRoot, stateRef);
});
Theme.displayName = "Theme";
Theme.avoidForwardRef = !0;
function getThemedChildren(themeState, children, props, isRoot = !1, stateRef) {
  const { themeManager, isNewTheme } = themeState;
  if (!themeManager)
    throw new Error(
       false ? 0 : "\u274C 005"
    );
  const { shallow, forceClassName } = props;
  let shouldRenderChildrenWithTheme = isNewTheme || isRoot || stateRef.current.hasEverThemed || typeof props.inverse == "boolean";
  if (shouldRenderChildrenWithTheme && (stateRef.current.hasEverThemed = !0), !shouldRenderChildrenWithTheme)
    return children;
   false && 0;
  let next = children;
  shallow && (next = import_react.Children.toArray(children).map((child) => (0, import_react.isValidElement)(child) ? (0, import_react.cloneElement)(
    child,
    void 0,
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Theme, { name: themeManager.state.parentName, children: child.props.children })
  ) : child));
  const elementsWithContext = /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ThemeManagerContext.ThemeManagerIDContext.Provider, { value: themeManager.id, children: next });
  return forceClassName === !1 ? elementsWithContext : import_constants.isWeb ? wrapThemeElements({
    children: elementsWithContext,
    themeState,
    forceClassName,
    isRoot
  }) : elementsWithContext;
}
function wrapThemeElements({
  children,
  themeState,
  forceClassName,
  isRoot
}) {
  if (isRoot && forceClassName === !1)
    return children;
  const inverse = themeState.inversed, requiresExtraWrapper = inverse != null || forceClassName, { className, style } = getThemeClassNameAndStyle(themeState, isRoot);
  let themedChildren = /* @__PURE__ */ (0, import_jsx_runtime.jsx)("span", { className: `${className} _dsp_contents is_Theme`, style, children });
  if (requiresExtraWrapper) {
    const name = themeState.state?.name || "", inverseClassName = name.startsWith("light") ? "t_light is_inversed" : name.startsWith("dark") ? "t_dark is_inversed" : "";
    themedChildren = /* @__PURE__ */ (0, import_jsx_runtime.jsx)("span", { className: `${inverse ? inverseClassName : ""} _dsp_contents`, children: themedChildren });
  }
  return themedChildren;
}
const emptyObj = {};
function getThemeClassNameAndStyle(themeState, isRoot = !1) {
  if (!themeState.isNewTheme)
    return { className: "", style: emptyObj };
  const themeColor = themeState.state?.theme && themeState.isNewTheme ? (0, import_createVariable.variableToString)(themeState.state.theme.color) : "", style = themeColor ? {
    color: themeColor
  } : void 0;
  let className = themeState.state?.className || "";
  return isRoot && (className = className.replace("t_sub_theme", "")), { style, className };
}
//# sourceMappingURL=Theme.js.map


/***/ }),

/***/ 14362:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var ThemeDebug_exports = {};
__export(ThemeDebug_exports, {
  ThemeDebug: () => ThemeDebug
});
module.exports = __toCommonJS(ThemeDebug_exports);
var import_react = __toESM(__webpack_require__(67294)), import_use_did_finish_ssr = __webpack_require__(36527), import_use_force_update = __webpack_require__(52707), import_react_dom = __webpack_require__(73935), import_jsx_runtime = __webpack_require__(85893);
let node;
function ThemeDebug({
  themeState,
  themeProps,
  children
}) {
  if (false) {}
  return children;
}
ThemeDebug.displayName = "ThemeDebug";
//# sourceMappingURL=ThemeDebug.js.map


/***/ }),

/***/ 15795:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var ThemeProvider_exports = {};
__export(ThemeProvider_exports, {
  ThemeProvider: () => ThemeProvider
});
module.exports = __toCommonJS(ThemeProvider_exports);
var import_react = __toESM(__webpack_require__(67294)), import_constants = __webpack_require__(14810), import_constants2 = __webpack_require__(36297), import_Theme = __webpack_require__(49798), import_config = __webpack_require__(16265), import_jsx_runtime = __webpack_require__(85893);
const ThemeProvider = (props) => (import_constants.isClient && import_react.default.useLayoutEffect(() => {
  if (props.disableRootThemeClass) return;
  const cn = `${import_constants2.THEME_CLASSNAME_PREFIX}${props.defaultTheme}`, target = props.themeClassNameOnRoot ?? (0, import_config.getSetting)("themeClassNameOnRoot") ? document.documentElement : document.body;
  return target.classList.add(cn), () => {
    target.classList.remove(cn);
  };
}, [props.defaultTheme, props.disableRootThemeClass, props.themeClassNameOnRoot]), /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
  import_Theme.Theme,
  {
    className: props.className,
    name: props.defaultTheme,
    forceClassName: !props.disableRootThemeClass,
    _isRoot: !0,
    children: props.children
  }
));
//# sourceMappingURL=ThemeProvider.js.map


/***/ }),

/***/ 33339:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var View_exports = {};
__export(View_exports, {
  View: () => View
});
module.exports = __toCommonJS(View_exports);
var import_helpers = __webpack_require__(37513), import_constants = __webpack_require__(36297), import_createComponent = __webpack_require__(86932);
const View = (0, import_createComponent.createComponent)({
  acceptsClassName: !0,
  defaultProps: import_constants.stackDefaultStyles,
  validStyles: import_helpers.validStyles
});
//# sourceMappingURL=View.js.map


/***/ }),

/***/ 20640:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var deselectCurrent = __webpack_require__(11742);

var clipboardToIE11Formatting = {
  "text/plain": "Text",
  "text/html": "Url",
  "default": "Text"
}

var defaultMessage = "Copy to clipboard: #{key}, Enter";

function format(message) {
  var copyKey = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
  return message.replace(/#{\s*key\s*}/g, copyKey);
}

function copy(text, options) {
  var debug,
    message,
    reselectPrevious,
    range,
    selection,
    mark,
    success = false;
  if (!options) {
    options = {};
  }
  debug = options.debug || false;
  try {
    reselectPrevious = deselectCurrent();

    range = document.createRange();
    selection = document.getSelection();

    mark = document.createElement("span");
    mark.textContent = text;
    // reset user styles for span element
    mark.style.all = "unset";
    // prevents scrolling to the end of the page
    mark.style.position = "fixed";
    mark.style.top = 0;
    mark.style.clip = "rect(0, 0, 0, 0)";
    // used to preserve spaces and line breaks
    mark.style.whiteSpace = "pre";
    // do not inherit user-select (it may be `none`)
    mark.style.webkitUserSelect = "text";
    mark.style.MozUserSelect = "text";
    mark.style.msUserSelect = "text";
    mark.style.userSelect = "text";
    mark.addEventListener("copy", function(e) {
      e.stopPropagation();
      if (options.format) {
        e.preventDefault();
        if (typeof e.clipboardData === "undefined") { // IE 11
          debug && console.warn("unable to use e.clipboardData");
          debug && console.warn("trying IE specific stuff");
          window.clipboardData.clearData();
          var format = clipboardToIE11Formatting[options.format] || clipboardToIE11Formatting["default"]
          window.clipboardData.setData(format, text);
        } else { // all other browsers
          e.clipboardData.clearData();
          e.clipboardData.setData(options.format, text);
        }
      }
      if (options.onCopy) {
        e.preventDefault();
        options.onCopy(e.clipboardData);
      }
    });

    document.body.appendChild(mark);

    range.selectNodeContents(mark);
    selection.addRange(range);

    var successful = document.execCommand("copy");
    if (!successful) {
      throw new Error("copy command was unsuccessful");
    }
    success = true;
  } catch (err) {
    debug && console.error("unable to copy using execCommand: ", err);
    debug && console.warn("trying IE specific stuff");
    try {
      window.clipboardData.setData(options.format || "text", text);
      options.onCopy && options.onCopy(window.clipboardData);
      success = true;
    } catch (err) {
      debug && console.error("unable to copy using clipboardData: ", err);
      debug && console.error("falling back to prompt");
      message = format("message" in options ? options.message : defaultMessage);
      window.prompt(message, text);
    }
  } finally {
    if (selection) {
      if (typeof selection.removeRange == "function") {
        selection.removeRange(range);
      } else {
        selection.removeAllRanges();
      }
    }

    if (mark) {
      document.body.removeChild(mark);
    }
    reselectPrevious();
  }

  return success;
}

module.exports = copy;


/***/ }),

/***/ 13099:
/***/ (function(module) {

module.exports = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};


/***/ }),

/***/ 96077:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(70111);

module.exports = function (it) {
  if (!isObject(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};


/***/ }),

/***/ 51223:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(5112);
var create = __webpack_require__(70030);
var definePropertyModule = __webpack_require__(3070);

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ 31530:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var charAt = (__webpack_require__(28710).charAt);

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};


/***/ }),

/***/ 25787:
/***/ (function(module) {

module.exports = function (it, Constructor, name) {
  if (!(it instanceof Constructor)) {
    throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
  } return it;
};


/***/ }),

/***/ 19670:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(70111);

module.exports = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};


/***/ }),

/***/ 18533:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $forEach = (__webpack_require__(42092).forEach);
var arrayMethodIsStrict = __webpack_require__(9341);

var STRICT_METHOD = arrayMethodIsStrict('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
module.exports = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;


/***/ }),

/***/ 48457:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__(49974);
var toObject = __webpack_require__(47908);
var callWithSafeIterationClosing = __webpack_require__(53411);
var isArrayIteratorMethod = __webpack_require__(97659);
var toLength = __webpack_require__(17466);
var createProperty = __webpack_require__(86135);
var getIterator = __webpack_require__(18554);
var getIteratorMethod = __webpack_require__(71246);

// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject(arrayLike);
  var C = typeof this == 'function' ? this : Array;
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  var iteratorMethod = getIteratorMethod(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined, 2);
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod != undefined && !(C == Array && isArrayIteratorMethod(iteratorMethod))) {
    iterator = getIterator(O, iteratorMethod);
    next = iterator.next;
    result = new C();
    for (;!(step = next.call(iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty(result, index, value);
    }
  } else {
    length = toLength(O.length);
    result = new C(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }
  result.length = index;
  return result;
};


/***/ }),

/***/ 41318:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toIndexedObject = __webpack_require__(45656);
var toLength = __webpack_require__(17466);
var toAbsoluteIndex = __webpack_require__(51400);

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ 42092:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var bind = __webpack_require__(49974);
var IndexedObject = __webpack_require__(68361);
var toObject = __webpack_require__(47908);
var toLength = __webpack_require__(17466);
var arraySpeciesCreate = __webpack_require__(65417);

var push = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_REJECT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push.call(target, value); // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push.call(target, value); // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod(7)
};


/***/ }),

/***/ 81194:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(47293);
var wellKnownSymbol = __webpack_require__(5112);
var V8_VERSION = __webpack_require__(7392);

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),

/***/ 9341:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(47293);

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal -- required for testing
    method.call(null, argument || function () { throw 1; }, 1);
  });
};


/***/ }),

/***/ 53671:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var aFunction = __webpack_require__(13099);
var toObject = __webpack_require__(47908);
var IndexedObject = __webpack_require__(68361);
var toLength = __webpack_require__(17466);

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aFunction(callbackfn);
    var O = toObject(that);
    var self = IndexedObject(O);
    var length = toLength(O.length);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw TypeError('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

module.exports = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: createMethod(true)
};


/***/ }),

/***/ 94362:
/***/ (function(module) {

// TODO: use something more complex like timsort?
var floor = Math.floor;

var mergeSort = function (array, comparefn) {
  var length = array.length;
  var middle = floor(length / 2);
  return length < 8 ? insertionSort(array, comparefn) : merge(
    mergeSort(array.slice(0, middle), comparefn),
    mergeSort(array.slice(middle), comparefn),
    comparefn
  );
};

var insertionSort = function (array, comparefn) {
  var length = array.length;
  var i = 1;
  var element, j;

  while (i < length) {
    j = i;
    element = array[i];
    while (j && comparefn(array[j - 1], element) > 0) {
      array[j] = array[--j];
    }
    if (j !== i++) array[j] = element;
  } return array;
};

var merge = function (left, right, comparefn) {
  var llength = left.length;
  var rlength = right.length;
  var lindex = 0;
  var rindex = 0;
  var result = [];

  while (lindex < llength || rindex < rlength) {
    if (lindex < llength && rindex < rlength) {
      result.push(comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++]);
    } else {
      result.push(lindex < llength ? left[lindex++] : right[rindex++]);
    }
  } return result;
};

module.exports = mergeSort;


/***/ }),

/***/ 77475:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(70111);
var isArray = __webpack_require__(43157);
var wellKnownSymbol = __webpack_require__(5112);

var SPECIES = wellKnownSymbol('species');

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),

/***/ 65417:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arraySpeciesConstructor = __webpack_require__(77475);

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};


/***/ }),

/***/ 53411:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var anObject = __webpack_require__(19670);
var iteratorClose = __webpack_require__(99212);

// call something on iterator step with safe closing on error
module.exports = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose(iterator, 'throw', error);
  }
};


/***/ }),

/***/ 17072:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(5112);

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),

/***/ 84326:
/***/ (function(module) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ 70648:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__(51694);
var classofRaw = __webpack_require__(84326);
var wellKnownSymbol = __webpack_require__(5112);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};


/***/ }),

/***/ 95631:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var defineProperty = (__webpack_require__(3070).f);
var create = __webpack_require__(70030);
var redefineAll = __webpack_require__(12248);
var bind = __webpack_require__(49974);
var anInstance = __webpack_require__(25787);
var iterate = __webpack_require__(20408);
var defineIterator = __webpack_require__(70654);
var setSpecies = __webpack_require__(96340);
var DESCRIPTORS = __webpack_require__(19781);
var fastKey = (__webpack_require__(62423).fastKey);
var InternalStateModule = __webpack_require__(29909);

var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;

module.exports = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, CONSTRUCTOR_NAME);
      setInternalState(that, {
        type: CONSTRUCTOR_NAME,
        index: create(null),
        first: undefined,
        last: undefined,
        size: 0
      });
      if (!DESCRIPTORS) that.size = 0;
      if (iterable != undefined) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
    });

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var entry = getEntry(that, key);
      var previous, index;
      // change existing entry
      if (entry) {
        entry.value = value;
      // create new entry
      } else {
        state.last = entry = {
          index: index = fastKey(key, true),
          key: key,
          value: value,
          previous: previous = state.last,
          next: undefined,
          removed: false
        };
        if (!state.first) state.first = entry;
        if (previous) previous.next = entry;
        if (DESCRIPTORS) state.size++;
        else that.size++;
        // add to index
        if (index !== 'F') state.index[index] = entry;
      } return that;
    };

    var getEntry = function (that, key) {
      var state = getInternalState(that);
      // fast case
      var index = fastKey(key);
      var entry;
      if (index !== 'F') return state.index[index];
      // frozen object case
      for (entry = state.first; entry; entry = entry.next) {
        if (entry.key == key) return entry;
      }
    };

    redefineAll(C.prototype, {
      // `{ Map, Set }.prototype.clear()` methods
      // https://tc39.es/ecma262/#sec-map.prototype.clear
      // https://tc39.es/ecma262/#sec-set.prototype.clear
      clear: function clear() {
        var that = this;
        var state = getInternalState(that);
        var data = state.index;
        var entry = state.first;
        while (entry) {
          entry.removed = true;
          if (entry.previous) entry.previous = entry.previous.next = undefined;
          delete data[entry.index];
          entry = entry.next;
        }
        state.first = state.last = undefined;
        if (DESCRIPTORS) state.size = 0;
        else that.size = 0;
      },
      // `{ Map, Set }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.delete
      // https://tc39.es/ecma262/#sec-set.prototype.delete
      'delete': function (key) {
        var that = this;
        var state = getInternalState(that);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.next;
          var prev = entry.previous;
          delete state.index[entry.index];
          entry.removed = true;
          if (prev) prev.next = next;
          if (next) next.previous = prev;
          if (state.first == entry) state.first = next;
          if (state.last == entry) state.last = prev;
          if (DESCRIPTORS) state.size--;
          else that.size--;
        } return !!entry;
      },
      // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.foreach
      // https://tc39.es/ecma262/#sec-set.prototype.foreach
      forEach: function forEach(callbackfn /* , that = undefined */) {
        var state = getInternalState(this);
        var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.next : state.first) {
          boundFunction(entry.value, entry.key, this);
          // revert to the last existing entry
          while (entry && entry.removed) entry = entry.previous;
        }
      },
      // `{ Map, Set}.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.has
      // https://tc39.es/ecma262/#sec-set.prototype.has
      has: function has(key) {
        return !!getEntry(this, key);
      }
    });

    redefineAll(C.prototype, IS_MAP ? {
      // `Map.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-map.prototype.get
      get: function get(key) {
        var entry = getEntry(this, key);
        return entry && entry.value;
      },
      // `Map.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-map.prototype.set
      set: function set(key, value) {
        return define(this, key === 0 ? 0 : key, value);
      }
    } : {
      // `Set.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-set.prototype.add
      add: function add(value) {
        return define(this, value = value === 0 ? 0 : value, value);
      }
    });
    if (DESCRIPTORS) defineProperty(C.prototype, 'size', {
      get: function () {
        return getInternalState(this).size;
      }
    });
    return C;
  },
  setStrong: function (C, CONSTRUCTOR_NAME, IS_MAP) {
    var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
    var getInternalCollectionState = internalStateGetterFor(CONSTRUCTOR_NAME);
    var getInternalIteratorState = internalStateGetterFor(ITERATOR_NAME);
    // `{ Map, Set }.prototype.{ keys, values, entries, @@iterator }()` methods
    // https://tc39.es/ecma262/#sec-map.prototype.entries
    // https://tc39.es/ecma262/#sec-map.prototype.keys
    // https://tc39.es/ecma262/#sec-map.prototype.values
    // https://tc39.es/ecma262/#sec-map.prototype-@@iterator
    // https://tc39.es/ecma262/#sec-set.prototype.entries
    // https://tc39.es/ecma262/#sec-set.prototype.keys
    // https://tc39.es/ecma262/#sec-set.prototype.values
    // https://tc39.es/ecma262/#sec-set.prototype-@@iterator
    defineIterator(C, CONSTRUCTOR_NAME, function (iterated, kind) {
      setInternalState(this, {
        type: ITERATOR_NAME,
        target: iterated,
        state: getInternalCollectionState(iterated),
        kind: kind,
        last: undefined
      });
    }, function () {
      var state = getInternalIteratorState(this);
      var kind = state.kind;
      var entry = state.last;
      // revert to the last existing entry
      while (entry && entry.removed) entry = entry.previous;
      // get next entry
      if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
        // or finish the iteration
        state.target = undefined;
        return { value: undefined, done: true };
      }
      // return step by kind
      if (kind == 'keys') return { value: entry.key, done: false };
      if (kind == 'values') return { value: entry.value, done: false };
      return { value: [entry.key, entry.value], done: false };
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // `{ Map, Set }.prototype[@@species]` accessors
    // https://tc39.es/ecma262/#sec-get-map-@@species
    // https://tc39.es/ecma262/#sec-get-set-@@species
    setSpecies(CONSTRUCTOR_NAME);
  }
};


/***/ }),

/***/ 29320:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(12248);
var getWeakData = (__webpack_require__(62423).getWeakData);
var anObject = __webpack_require__(19670);
var isObject = __webpack_require__(70111);
var anInstance = __webpack_require__(25787);
var iterate = __webpack_require__(20408);
var ArrayIterationModule = __webpack_require__(42092);
var $has = __webpack_require__(86656);
var InternalStateModule = __webpack_require__(29909);

var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;
var find = ArrayIterationModule.find;
var findIndex = ArrayIterationModule.findIndex;
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (store) {
  return store.frozen || (store.frozen = new UncaughtFrozenStore());
};

var UncaughtFrozenStore = function () {
  this.entries = [];
};

var findUncaughtFrozen = function (store, key) {
  return find(store.entries, function (it) {
    return it[0] === key;
  });
};

UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.entries.push([key, value]);
  },
  'delete': function (key) {
    var index = findIndex(this.entries, function (it) {
      return it[0] === key;
    });
    if (~index) this.entries.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, CONSTRUCTOR_NAME);
      setInternalState(that, {
        type: CONSTRUCTOR_NAME,
        id: id++,
        frozen: undefined
      });
      if (iterable != undefined) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
    });

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var data = getWeakData(anObject(key), true);
      if (data === true) uncaughtFrozenStore(state).set(key, value);
      else data[state.id] = value;
      return that;
    };

    redefineAll(C.prototype, {
      // `{ WeakMap, WeakSet }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-weakmap.prototype.delete
      // https://tc39.es/ecma262/#sec-weakset.prototype.delete
      'delete': function (key) {
        var state = getInternalState(this);
        if (!isObject(key)) return false;
        var data = getWeakData(key);
        if (data === true) return uncaughtFrozenStore(state)['delete'](key);
        return data && $has(data, state.id) && delete data[state.id];
      },
      // `{ WeakMap, WeakSet }.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-weakmap.prototype.has
      // https://tc39.es/ecma262/#sec-weakset.prototype.has
      has: function has(key) {
        var state = getInternalState(this);
        if (!isObject(key)) return false;
        var data = getWeakData(key);
        if (data === true) return uncaughtFrozenStore(state).has(key);
        return data && $has(data, state.id);
      }
    });

    redefineAll(C.prototype, IS_MAP ? {
      // `WeakMap.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-weakmap.prototype.get
      get: function get(key) {
        var state = getInternalState(this);
        if (isObject(key)) {
          var data = getWeakData(key);
          if (data === true) return uncaughtFrozenStore(state).get(key);
          return data ? data[state.id] : undefined;
        }
      },
      // `WeakMap.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-weakmap.prototype.set
      set: function set(key, value) {
        return define(this, key, value);
      }
    } : {
      // `WeakSet.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-weakset.prototype.add
      add: function add(value) {
        return define(this, value, true);
      }
    });

    return C;
  }
};


/***/ }),

/***/ 77710:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(82109);
var global = __webpack_require__(17854);
var isForced = __webpack_require__(54705);
var redefine = __webpack_require__(31320);
var InternalMetadataModule = __webpack_require__(62423);
var iterate = __webpack_require__(20408);
var anInstance = __webpack_require__(25787);
var isObject = __webpack_require__(70111);
var fails = __webpack_require__(47293);
var checkCorrectnessOfIteration = __webpack_require__(17072);
var setToStringTag = __webpack_require__(58003);
var inheritIfRequired = __webpack_require__(79587);

module.exports = function (CONSTRUCTOR_NAME, wrapper, common) {
  var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
  var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
  var ADDER = IS_MAP ? 'set' : 'add';
  var NativeConstructor = global[CONSTRUCTOR_NAME];
  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
  var Constructor = NativeConstructor;
  var exported = {};

  var fixMethod = function (KEY) {
    var nativeMethod = NativePrototype[KEY];
    redefine(NativePrototype, KEY,
      KEY == 'add' ? function add(value) {
        nativeMethod.call(this, value === 0 ? 0 : value);
        return this;
      } : KEY == 'delete' ? function (key) {
        return IS_WEAK && !isObject(key) ? false : nativeMethod.call(this, key === 0 ? 0 : key);
      } : KEY == 'get' ? function get(key) {
        return IS_WEAK && !isObject(key) ? undefined : nativeMethod.call(this, key === 0 ? 0 : key);
      } : KEY == 'has' ? function has(key) {
        return IS_WEAK && !isObject(key) ? false : nativeMethod.call(this, key === 0 ? 0 : key);
      } : function set(key, value) {
        nativeMethod.call(this, key === 0 ? 0 : key, value);
        return this;
      }
    );
  };

  var REPLACE = isForced(
    CONSTRUCTOR_NAME,
    typeof NativeConstructor != 'function' || !(IS_WEAK || NativePrototype.forEach && !fails(function () {
      new NativeConstructor().entries().next();
    }))
  );

  if (REPLACE) {
    // create collection constructor
    Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
    InternalMetadataModule.enable();
  } else if (isForced(CONSTRUCTOR_NAME, true)) {
    var instance = new Constructor();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    // eslint-disable-next-line no-new -- required for testing
    var ACCEPT_ITERABLES = checkCorrectnessOfIteration(function (iterable) { new NativeConstructor(iterable); });
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new NativeConstructor();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });

    if (!ACCEPT_ITERABLES) {
      Constructor = wrapper(function (dummy, iterable) {
        anInstance(dummy, Constructor, CONSTRUCTOR_NAME);
        var that = inheritIfRequired(new NativeConstructor(), dummy, Constructor);
        if (iterable != undefined) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
        return that;
      });
      Constructor.prototype = NativePrototype;
      NativePrototype.constructor = Constructor;
    }

    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }

    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);

    // weak collections should not contains .clear method
    if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
  }

  exported[CONSTRUCTOR_NAME] = Constructor;
  $({ global: true, forced: Constructor != NativeConstructor }, exported);

  setToStringTag(Constructor, CONSTRUCTOR_NAME);

  if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);

  return Constructor;
};


/***/ }),

/***/ 99920:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var has = __webpack_require__(86656);
var ownKeys = __webpack_require__(53887);
var getOwnPropertyDescriptorModule = __webpack_require__(31236);
var definePropertyModule = __webpack_require__(3070);

module.exports = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};


/***/ }),

/***/ 84964:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(5112);

var MATCH = wellKnownSymbol('match');

module.exports = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};


/***/ }),

/***/ 49920:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(47293);

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ 14230:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__(84488);
var toString = __webpack_require__(41340);

var quot = /"/g;

// `CreateHTML` abstract operation
// https://tc39.es/ecma262/#sec-createhtml
module.exports = function (string, tag, attribute, value) {
  var S = toString(requireObjectCoercible(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + toString(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};


/***/ }),

/***/ 24994:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var IteratorPrototype = (__webpack_require__(13383).IteratorPrototype);
var create = __webpack_require__(70030);
var createPropertyDescriptor = __webpack_require__(79114);
var setToStringTag = __webpack_require__(58003);
var Iterators = __webpack_require__(97497);

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(1, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),

/***/ 68880:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(19781);
var definePropertyModule = __webpack_require__(3070);
var createPropertyDescriptor = __webpack_require__(79114);

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ 79114:
/***/ (function(module) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ 86135:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toPropertyKey = __webpack_require__(34948);
var definePropertyModule = __webpack_require__(3070);
var createPropertyDescriptor = __webpack_require__(79114);

module.exports = function (object, key, value) {
  var propertyKey = toPropertyKey(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),

/***/ 38709:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(19670);
var ordinaryToPrimitive = __webpack_require__(92140);

// `Date.prototype[@@toPrimitive](hint)` method implementation
// https://tc39.es/ecma262/#sec-date.prototype-@@toprimitive
module.exports = function (hint) {
  anObject(this);
  if (hint === 'string' || hint === 'default') hint = 'string';
  else if (hint !== 'number') throw TypeError('Incorrect hint');
  return ordinaryToPrimitive(this, hint);
};


/***/ }),

/***/ 70654:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(82109);
var createIteratorConstructor = __webpack_require__(24994);
var getPrototypeOf = __webpack_require__(79518);
var setPrototypeOf = __webpack_require__(27674);
var setToStringTag = __webpack_require__(58003);
var createNonEnumerableProperty = __webpack_require__(68880);
var redefine = __webpack_require__(31320);
var wellKnownSymbol = __webpack_require__(5112);
var IS_PURE = __webpack_require__(31913);
var Iterators = __webpack_require__(97497);
var IteratorsCore = __webpack_require__(13383);

var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (typeof CurrentIteratorPrototype[ITERATOR] != 'function') {
          createNonEnumerableProperty(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    INCORRECT_VALUES_NAME = true;
    defaultIterator = function values() { return nativeIterator.call(this); };
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    createNonEnumerableProperty(IterablePrototype, ITERATOR, defaultIterator);
  }
  Iterators[NAME] = defaultIterator;

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  return methods;
};


/***/ }),

/***/ 97235:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var path = __webpack_require__(40857);
var has = __webpack_require__(86656);
var wrappedWellKnownSymbolModule = __webpack_require__(6061);
var defineProperty = (__webpack_require__(3070).f);

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!has(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),

/***/ 19781:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(47293);

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),

/***/ 80317:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(17854);
var isObject = __webpack_require__(70111);

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ 48324:
/***/ (function(module) {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),

/***/ 98509:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = __webpack_require__(80317);

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;

module.exports = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;


/***/ }),

/***/ 68886:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var userAgent = __webpack_require__(88113);

var firefox = userAgent.match(/firefox\/(\d+)/i);

module.exports = !!firefox && +firefox[1];


/***/ }),

/***/ 7871:
/***/ (function(module) {

module.exports = typeof window == 'object';


/***/ }),

/***/ 30256:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var UA = __webpack_require__(88113);

module.exports = /MSIE|Trident/.test(UA);


/***/ }),

/***/ 71528:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var userAgent = __webpack_require__(88113);
var global = __webpack_require__(17854);

module.exports = /ipad|iphone|ipod/i.test(userAgent) && global.Pebble !== undefined;


/***/ }),

/***/ 6833:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var userAgent = __webpack_require__(88113);

module.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent);


/***/ }),

/***/ 35268:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var classof = __webpack_require__(84326);
var global = __webpack_require__(17854);

module.exports = classof(global.process) == 'process';


/***/ }),

/***/ 71036:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var userAgent = __webpack_require__(88113);

module.exports = /web0s(?!.*chrome)/i.test(userAgent);


/***/ }),

/***/ 88113:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(35005);

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),

/***/ 7392:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(17854);
var userAgent = __webpack_require__(88113);

var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] < 4 ? 1 : match[0] + match[1];
} else if (userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

module.exports = version && +version;


/***/ }),

/***/ 98008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var userAgent = __webpack_require__(88113);

var webkit = userAgent.match(/AppleWebKit\/(\d+)\./);

module.exports = !!webkit && +webkit[1];


/***/ }),

/***/ 80748:
/***/ (function(module) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ 82109:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(17854);
var getOwnPropertyDescriptor = (__webpack_require__(31236).f);
var createNonEnumerableProperty = __webpack_require__(68880);
var redefine = __webpack_require__(31320);
var setGlobal = __webpack_require__(83505);
var copyConstructorProperties = __webpack_require__(99920);
var isForced = __webpack_require__(54705);

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ 47293:
/***/ (function(module) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ 27007:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4` since it's moved to entry points
__webpack_require__(74916);
var redefine = __webpack_require__(31320);
var regexpExec = __webpack_require__(22261);
var fails = __webpack_require__(47293);
var wellKnownSymbol = __webpack_require__(5112);
var createNonEnumerableProperty = __webpack_require__(68880);

var SPECIES = wellKnownSymbol('species');
var RegExpPrototype = RegExp.prototype;

module.exports = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var $exec = regexp.exec;
      if ($exec === regexpExec || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
        }
        return { done: true, value: nativeMethod.call(str, regexp, arg2) };
      }
      return { done: false };
    });

    redefine(String.prototype, KEY, methods[0]);
    redefine(RegExpPrototype, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
};


/***/ }),

/***/ 76677:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(47293);

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
  return Object.isExtensible(Object.preventExtensions({}));
});


/***/ }),

/***/ 49974:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var aFunction = __webpack_require__(13099);

// optional / simple context binding
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ 27065:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(13099);
var isObject = __webpack_require__(70111);

var slice = [].slice;
var factories = {};

var construct = function (C, argsLength, args) {
  if (!(argsLength in factories)) {
    for (var list = [], i = 0; i < argsLength; i++) list[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func -- we have no proper alternatives, IE8- only
    factories[argsLength] = Function('C,a', 'return new C(' + list.join(',') + ')');
  } return factories[argsLength](C, args);
};

// `Function.prototype.bind` method implementation
// https://tc39.es/ecma262/#sec-function.prototype.bind
module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = slice.call(arguments, 1);
  var boundFunction = function bound(/* args... */) {
    var args = partArgs.concat(slice.call(arguments));
    return this instanceof boundFunction ? construct(fn, args.length, args) : fn.apply(that, args);
  };
  if (isObject(fn.prototype)) boundFunction.prototype = fn.prototype;
  return boundFunction;
};


/***/ }),

/***/ 35005:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(17854);

var aFunction = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
};


/***/ }),

/***/ 71246:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var classof = __webpack_require__(70648);
var Iterators = __webpack_require__(97497);
var wellKnownSymbol = __webpack_require__(5112);

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ 18554:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var anObject = __webpack_require__(19670);
var getIteratorMethod = __webpack_require__(71246);

module.exports = function (it, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(it) : usingIterator;
  if (typeof iteratorMethod != 'function') {
    throw TypeError(String(it) + ' is not iterable');
  } return anObject(iteratorMethod.call(it));
};


/***/ }),

/***/ 10647:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toObject = __webpack_require__(47908);

var floor = Math.floor;
var replace = ''.replace;
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
module.exports = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace.call(replacement, symbols, function (match, ch) {
    var capture;
    switch (ch.charAt(0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return str.slice(0, position);
      case "'": return str.slice(tailPos);
      case '<':
        capture = namedCaptures[ch.slice(1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};


/***/ }),

/***/ 17854:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof __webpack_require__.g == 'object' && __webpack_require__.g) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();


/***/ }),

/***/ 86656:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toObject = __webpack_require__(47908);

var hasOwnProperty = {}.hasOwnProperty;

module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty.call(toObject(it), key);
};


/***/ }),

/***/ 3501:
/***/ (function(module) {

module.exports = {};


/***/ }),

/***/ 842:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(17854);

module.exports = function (a, b) {
  var console = global.console;
  if (console && console.error) {
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  }
};


/***/ }),

/***/ 60490:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(35005);

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ 64664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(19781);
var fails = __webpack_require__(47293);
var createElement = __webpack_require__(80317);

// Thank's IE8 for his funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ 68361:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(47293);
var classof = __webpack_require__(84326);

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;


/***/ }),

/***/ 79587:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(70111);
var setPrototypeOf = __webpack_require__(27674);

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    typeof (NewTarget = dummy.constructor) == 'function' &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),

/***/ 42788:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var store = __webpack_require__(5465);

var functionToString = Function.toString;

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof store.inspectSource != 'function') {
  store.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ 62423:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(82109);
var hiddenKeys = __webpack_require__(3501);
var isObject = __webpack_require__(70111);
var has = __webpack_require__(86656);
var defineProperty = (__webpack_require__(3070).f);
var getOwnPropertyNamesModule = __webpack_require__(8006);
var getOwnPropertyNamesExternalModule = __webpack_require__(1156);
var uid = __webpack_require__(69711);
var FREEZING = __webpack_require__(76677);

var REQUIRED = false;
var METADATA = uid('meta');
var id = 0;

// eslint-disable-next-line es/no-object-isextensible -- safe
var isExtensible = Object.isExtensible || function () {
  return true;
};

var setMetadata = function (it) {
  defineProperty(it, METADATA, { value: {
    objectID: 'O' + id++, // object ID
    weakData: {}          // weak collections IDs
  } });
};

var fastKey = function (it, create) {
  // return a primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMetadata(it);
  // return object ID
  } return it[METADATA].objectID;
};

var getWeakData = function (it, create) {
  if (!has(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMetadata(it);
  // return the store of weak collections IDs
  } return it[METADATA].weakData;
};

// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZING && REQUIRED && isExtensible(it) && !has(it, METADATA)) setMetadata(it);
  return it;
};

var enable = function () {
  meta.enable = function () { /* empty */ };
  REQUIRED = true;
  var getOwnPropertyNames = getOwnPropertyNamesModule.f;
  var splice = [].splice;
  var test = {};
  test[METADATA] = 1;

  // prevent exposing of metadata key
  if (getOwnPropertyNames(test).length) {
    getOwnPropertyNamesModule.f = function (it) {
      var result = getOwnPropertyNames(it);
      for (var i = 0, length = result.length; i < length; i++) {
        if (result[i] === METADATA) {
          splice.call(result, i, 1);
          break;
        }
      } return result;
    };

    $({ target: 'Object', stat: true, forced: true }, {
      getOwnPropertyNames: getOwnPropertyNamesExternalModule.f
    });
  }
};

var meta = module.exports = {
  enable: enable,
  fastKey: fastKey,
  getWeakData: getWeakData,
  onFreeze: onFreeze
};

hiddenKeys[METADATA] = true;


/***/ }),

/***/ 29909:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__(68536);
var global = __webpack_require__(17854);
var isObject = __webpack_require__(70111);
var createNonEnumerableProperty = __webpack_require__(68880);
var objectHas = __webpack_require__(86656);
var shared = __webpack_require__(5465);
var sharedKey = __webpack_require__(6200);
var hiddenKeys = __webpack_require__(3501);

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    if (wmhas.call(store, it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (objectHas(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return objectHas(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ 97659:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(5112);
var Iterators = __webpack_require__(97497);

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),

/***/ 43157:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var classof = __webpack_require__(84326);

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(arg) {
  return classof(arg) == 'Array';
};


/***/ }),

/***/ 54705:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(47293);

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ 70111:
/***/ (function(module) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ 31913:
/***/ (function(module) {

module.exports = false;


/***/ }),

/***/ 47850:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(70111);
var classof = __webpack_require__(84326);
var wellKnownSymbol = __webpack_require__(5112);

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
};


/***/ }),

/***/ 52190:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(35005);
var USE_SYMBOL_AS_UID = __webpack_require__(43307);

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return typeof $Symbol == 'function' && Object(it) instanceof $Symbol;
};


/***/ }),

/***/ 20408:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var anObject = __webpack_require__(19670);
var isArrayIteratorMethod = __webpack_require__(97659);
var toLength = __webpack_require__(17466);
var bind = __webpack_require__(49974);
var getIterator = __webpack_require__(18554);
var getIteratorMethod = __webpack_require__(71246);
var iteratorClose = __webpack_require__(99212);

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

module.exports = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind(unboundFunction, that, 1 + AS_ENTRIES + INTERRUPTED);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (typeof iterFn != 'function') throw TypeError('Target is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = toLength(iterable.length); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && result instanceof Result) return result;
      } return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }

  next = iterator.next;
  while (!(step = next.call(iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && result instanceof Result) return result;
  } return new Result(false);
};


/***/ }),

/***/ 99212:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var anObject = __webpack_require__(19670);

module.exports = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject(iterator);
  try {
    innerResult = iterator['return'];
    if (innerResult === undefined) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = innerResult.call(iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject(innerResult);
  return value;
};


/***/ }),

/***/ 54956:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(13099);
var anObject = __webpack_require__(19670);
var create = __webpack_require__(70030);
var createNonEnumerableProperty = __webpack_require__(68880);
var redefineAll = __webpack_require__(12248);
var wellKnownSymbol = __webpack_require__(5112);
var InternalStateModule = __webpack_require__(29909);
var IteratorPrototype = (__webpack_require__(13383).IteratorPrototype);

var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.get;

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (nextHandler, IS_ITERATOR) {
  var IteratorProxy = function Iterator(state) {
    state.next = aFunction(state.iterator.next);
    state.done = false;
    state.ignoreArg = !IS_ITERATOR;
    setInternalState(this, state);
  };

  IteratorProxy.prototype = redefineAll(create(IteratorPrototype), {
    next: function next(arg) {
      var state = getInternalState(this);
      var args = arguments.length ? [state.ignoreArg ? undefined : arg] : IS_ITERATOR ? [] : [undefined];
      state.ignoreArg = false;
      var result = state.done ? undefined : nextHandler.call(state, args);
      return { done: state.done, value: result };
    },
    'return': function (value) {
      var state = getInternalState(this);
      var iterator = state.iterator;
      state.done = true;
      var $$return = iterator['return'];
      return { done: true, value: $$return === undefined ? value : anObject($$return.call(iterator, value)).value };
    },
    'throw': function (value) {
      var state = getInternalState(this);
      var iterator = state.iterator;
      state.done = true;
      var $$throw = iterator['throw'];
      if ($$throw === undefined) throw value;
      return $$throw.call(iterator, value);
    }
  });

  if (!IS_ITERATOR) {
    createNonEnumerableProperty(IteratorProxy.prototype, TO_STRING_TAG, 'Generator');
  }

  return IteratorProxy;
};


/***/ }),

/***/ 13383:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(47293);
var create = __webpack_require__(70030);
var getPrototypeOf = __webpack_require__(79518);
var createNonEnumerableProperty = __webpack_require__(68880);
var wellKnownSymbol = __webpack_require__(5112);
var IS_PURE = __webpack_require__(31913);

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = IteratorPrototype == undefined || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};
else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (typeof IteratorPrototype[ITERATOR] !== 'function') {
  createNonEnumerableProperty(IteratorPrototype, ITERATOR, function () {
    return this;
  });
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),

/***/ 97497:
/***/ (function(module) {

module.exports = {};


/***/ }),

/***/ 95948:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(17854);
var getOwnPropertyDescriptor = (__webpack_require__(31236).f);
var macrotask = (__webpack_require__(20261).set);
var IS_IOS = __webpack_require__(6833);
var IS_IOS_PEBBLE = __webpack_require__(71528);
var IS_WEBOS_WEBKIT = __webpack_require__(71036);
var IS_NODE = __webpack_require__(35268);

var MutationObserver = global.MutationObserver || global.WebKitMutationObserver;
var document = global.document;
var process = global.process;
var Promise = global.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global, 'queueMicrotask');
var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;

var flush, head, last, notify, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!queueMicrotask) {
  flush = function () {
    var parent, fn;
    if (IS_NODE && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (error) {
        if (head) notify();
        else last = undefined;
        throw error;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE && !IS_WEBOS_WEBKIT && MutationObserver && document) {
    toggle = true;
    node = document.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (!IS_IOS_PEBBLE && Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise;
    then = promise.then;
    notify = function () {
      then.call(promise, flush);
    };
  // Node.js without promises
  } else if (IS_NODE) {
    notify = function () {
      process.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }
}

module.exports = queueMicrotask || function (fn) {
  var task = { fn: fn, next: undefined };
  if (last) last.next = task;
  if (!head) {
    head = task;
    notify();
  } last = task;
};


/***/ }),

/***/ 13366:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(17854);

module.exports = global.Promise;


/***/ }),

/***/ 30133:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__(7392);
var fails = __webpack_require__(47293);

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),

/***/ 68536:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(17854);
var inspectSource = __webpack_require__(42788);

var WeakMap = global.WeakMap;

module.exports = typeof WeakMap === 'function' && /native code/.test(inspectSource(WeakMap));


/***/ }),

/***/ 78523:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(13099);

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ 3929:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isRegExp = __webpack_require__(47850);

module.exports = function (it) {
  if (isRegExp(it)) {
    throw TypeError("The method doesn't accept regular expressions");
  } return it;
};


/***/ }),

/***/ 2814:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(17854);
var toString = __webpack_require__(41340);
var trim = (__webpack_require__(53111).trim);
var whitespaces = __webpack_require__(81361);

var $parseFloat = global.parseFloat;
var FORCED = 1 / $parseFloat(whitespaces + '-0') !== -Infinity;

// `parseFloat` method
// https://tc39.es/ecma262/#sec-parsefloat-string
module.exports = FORCED ? function parseFloat(string) {
  var trimmedString = trim(toString(string));
  var result = $parseFloat(trimmedString);
  return result === 0 && trimmedString.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),

/***/ 83009:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(17854);
var toString = __webpack_require__(41340);
var trim = (__webpack_require__(53111).trim);
var whitespaces = __webpack_require__(81361);

var $parseInt = global.parseInt;
var hex = /^[+-]?0[Xx]/;
var FORCED = $parseInt(whitespaces + '08') !== 8 || $parseInt(whitespaces + '0x16') !== 22;

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
module.exports = FORCED ? function parseInt(string, radix) {
  var S = trim(toString(string));
  return $parseInt(S, (radix >>> 0) || (hex.test(S) ? 16 : 10));
} : $parseInt;


/***/ }),

/***/ 21574:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(19781);
var fails = __webpack_require__(47293);
var objectKeys = __webpack_require__(81956);
var getOwnPropertySymbolsModule = __webpack_require__(25181);
var propertyIsEnumerableModule = __webpack_require__(55296);
var toObject = __webpack_require__(47908);
var IndexedObject = __webpack_require__(68361);

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty = Object.defineProperty;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
module.exports = !$assign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && $assign({ b: 1 }, $assign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? objectKeys(S).concat(getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || propertyIsEnumerable.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),

/***/ 70030:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* global ActiveXObject -- old IE, WSH */
var anObject = __webpack_require__(19670);
var defineProperties = __webpack_require__(36048);
var enumBugKeys = __webpack_require__(80748);
var hiddenKeys = __webpack_require__(3501);
var html = __webpack_require__(60490);
var documentCreateElement = __webpack_require__(80317);
var sharedKey = __webpack_require__(6200);

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : defineProperties(result, Properties);
};


/***/ }),

/***/ 36048:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(19781);
var definePropertyModule = __webpack_require__(3070);
var anObject = __webpack_require__(19670);
var objectKeys = __webpack_require__(81956);

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], Properties[key]);
  return O;
};


/***/ }),

/***/ 3070:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(19781);
var IE8_DOM_DEFINE = __webpack_require__(64664);
var anObject = __webpack_require__(19670);
var toPropertyKey = __webpack_require__(34948);

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ 31236:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(19781);
var propertyIsEnumerableModule = __webpack_require__(55296);
var createPropertyDescriptor = __webpack_require__(79114);
var toIndexedObject = __webpack_require__(45656);
var toPropertyKey = __webpack_require__(34948);
var has = __webpack_require__(86656);
var IE8_DOM_DEFINE = __webpack_require__(64664);

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
};


/***/ }),

/***/ 1156:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* eslint-disable es/no-object-getownpropertynames -- safe */
var toIndexedObject = __webpack_require__(45656);
var $getOwnPropertyNames = (__webpack_require__(8006).f);

var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return $getOwnPropertyNames(it);
  } catch (error) {
    return windowNames.slice();
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]'
    ? getWindowNames(it)
    : $getOwnPropertyNames(toIndexedObject(it));
};


/***/ }),

/***/ 8006:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__(16324);
var enumBugKeys = __webpack_require__(80748);

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ 25181:
/***/ (function(__unused_webpack_module, exports) {

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ 79518:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var has = __webpack_require__(86656);
var toObject = __webpack_require__(47908);
var sharedKey = __webpack_require__(6200);
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(49920);

var IE_PROTO = sharedKey('IE_PROTO');
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectPrototype : null;
};


/***/ }),

/***/ 16324:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var has = __webpack_require__(86656);
var toIndexedObject = __webpack_require__(45656);
var indexOf = (__webpack_require__(41318).indexOf);
var hiddenKeys = __webpack_require__(3501);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ 81956:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__(16324);
var enumBugKeys = __webpack_require__(80748);

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ 55296:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),

/***/ 27674:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* eslint-disable no-proto -- safe */
var anObject = __webpack_require__(19670);
var aPossiblePrototype = __webpack_require__(96077);

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ 44699:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(19781);
var objectKeys = __webpack_require__(81956);
var toIndexedObject = __webpack_require__(45656);
var propertyIsEnumerable = (__webpack_require__(55296).f);

// `Object.{ entries, values }` methods implementation
var createMethod = function (TO_ENTRIES) {
  return function (it) {
    var O = toIndexedObject(it);
    var keys = objectKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || propertyIsEnumerable.call(O, key)) {
        result.push(TO_ENTRIES ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

module.exports = {
  // `Object.entries` method
  // https://tc39.es/ecma262/#sec-object.entries
  entries: createMethod(true),
  // `Object.values` method
  // https://tc39.es/ecma262/#sec-object.values
  values: createMethod(false)
};


/***/ }),

/***/ 90288:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__(51694);
var classof = __webpack_require__(70648);

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),

/***/ 92140:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(70111);

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
  if (pref !== 'string' && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ 53887:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(35005);
var getOwnPropertyNamesModule = __webpack_require__(8006);
var getOwnPropertySymbolsModule = __webpack_require__(25181);
var anObject = __webpack_require__(19670);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ 40857:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(17854);

module.exports = global;


/***/ }),

/***/ 12534:
/***/ (function(module) {

module.exports = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};


/***/ }),

/***/ 69478:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var anObject = __webpack_require__(19670);
var isObject = __webpack_require__(70111);
var newPromiseCapability = __webpack_require__(78523);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ 12248:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var redefine = __webpack_require__(31320);

module.exports = function (target, src, options) {
  for (var key in src) redefine(target, key, src[key], options);
  return target;
};


/***/ }),

/***/ 31320:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(17854);
var createNonEnumerableProperty = __webpack_require__(68880);
var has = __webpack_require__(86656);
var setGlobal = __webpack_require__(83505);
var inspectSource = __webpack_require__(42788);
var InternalStateModule = __webpack_require__(29909);

var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(String).split('String');

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  var state;
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has(value, 'name')) {
      createNonEnumerableProperty(value, 'name', key);
    }
    state = enforceInternalState(value);
    if (!state.source) {
      state.source = TEMPLATE.join(typeof key == 'string' ? key : '');
    }
  }
  if (O === global) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState(this).source || inspectSource(this);
});


/***/ }),

/***/ 97651:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var classof = __webpack_require__(84326);
var regexpExec = __webpack_require__(22261);

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }

  if (classof(R) !== 'RegExp') {
    throw TypeError('RegExp#exec called on incompatible receiver');
  }

  return regexpExec.call(R, S);
};



/***/ }),

/***/ 22261:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var toString = __webpack_require__(41340);
var regexpFlags = __webpack_require__(67066);
var stickyHelpers = __webpack_require__(52999);
var shared = __webpack_require__(72309);
var create = __webpack_require__(70030);
var getInternalState = (__webpack_require__(29909).get);
var UNSUPPORTED_DOT_ALL = __webpack_require__(9441);
var UNSUPPORTED_NCG = __webpack_require__(38173);

var nativeExec = RegExp.prototype.exec;
var nativeReplace = shared('native-string-replace', String.prototype.replace);

var patchedExec = nativeExec;

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y || stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

if (PATCH) {
  // eslint-disable-next-line max-statements -- TODO
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState(re);
    var str = toString(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = patchedExec.call(raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = regexpFlags.call(re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = flags.replace('y', '');
      if (flags.indexOf('g') === -1) {
        flags += 'g';
      }

      strCopy = str.slice(re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && str.charAt(re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = nativeExec.call(sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = match.input.slice(charsAdded);
        match[0] = match[0].slice(charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ 67066:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(19670);

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ 52999:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var fails = __webpack_require__(47293);
var global = __webpack_require__(17854);

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp = global.RegExp;

exports.UNSUPPORTED_Y = fails(function () {
  var re = $RegExp('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

exports.BROKEN_CARET = fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});


/***/ }),

/***/ 9441:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(47293);
var global = __webpack_require__(17854);

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp = global.RegExp;

module.exports = fails(function () {
  var re = $RegExp('.', 's');
  return !(re.dotAll && re.exec('\n') && re.flags === 's');
});


/***/ }),

/***/ 38173:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(47293);
var global = __webpack_require__(17854);

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = global.RegExp;

module.exports = fails(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});


/***/ }),

/***/ 84488:
/***/ (function(module) {

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ 83505:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(17854);

module.exports = function (key, value) {
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty(global, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ 96340:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(35005);
var definePropertyModule = __webpack_require__(3070);
var wellKnownSymbol = __webpack_require__(5112);
var DESCRIPTORS = __webpack_require__(19781);

var SPECIES = wellKnownSymbol('species');

module.exports = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule.f;

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
    defineProperty(Constructor, SPECIES, {
      configurable: true,
      get: function () { return this; }
    });
  }
};


/***/ }),

/***/ 58003:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var defineProperty = (__webpack_require__(3070).f);
var has = __webpack_require__(86656);
var wellKnownSymbol = __webpack_require__(5112);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (it, TAG, STATIC) {
  if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
    defineProperty(it, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),

/***/ 6200:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var shared = __webpack_require__(72309);
var uid = __webpack_require__(69711);

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ 5465:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(17854);
var setGlobal = __webpack_require__(83505);

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;


/***/ }),

/***/ 72309:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var IS_PURE = __webpack_require__(31913);
var store = __webpack_require__(5465);

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.17.3',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ 36707:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var anObject = __webpack_require__(19670);
var aFunction = __webpack_require__(13099);
var wellKnownSymbol = __webpack_require__(5112);

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aFunction(S);
};


/***/ }),

/***/ 43429:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(47293);

// check the existence of a method, lowercase
// of a tag and escaping quotes in arguments
module.exports = function (METHOD_NAME) {
  return fails(function () {
    var test = ''[METHOD_NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  });
};


/***/ }),

/***/ 28710:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toInteger = __webpack_require__(99958);
var toString = __webpack_require__(41340);
var requireObjectCoercible = __webpack_require__(84488);

// `String.prototype.codePointAt` methods implementation
var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString(requireObjectCoercible($this));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),

/***/ 53111:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__(84488);
var toString = __webpack_require__(41340);
var whitespaces = __webpack_require__(81361);

var whitespace = '[' + whitespaces + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = toString(requireObjectCoercible($this));
    if (TYPE & 1) string = string.replace(ltrim, '');
    if (TYPE & 2) string = string.replace(rtrim, '');
    return string;
  };
};

module.exports = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};


/***/ }),

/***/ 20261:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(17854);
var fails = __webpack_require__(47293);
var bind = __webpack_require__(49974);
var html = __webpack_require__(60490);
var createElement = __webpack_require__(80317);
var IS_IOS = __webpack_require__(6833);
var IS_NODE = __webpack_require__(35268);

var set = global.setImmediate;
var clear = global.clearImmediate;
var process = global.process;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var location, defer, channel, port;

try {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  location = global.location;
} catch (error) { /* empty */ }

var run = function (id) {
  // eslint-disable-next-line no-prototype-builtins -- safe
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var listener = function (event) {
  run(event.data);
};

var post = function (id) {
  // old engines have not location.origin
  global.postMessage(String(id), location.protocol + '//' + location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(fn) {
    var args = [];
    var argumentsLength = arguments.length;
    var i = 1;
    while (argumentsLength > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func -- spec requirement
      (typeof fn == 'function' ? fn : Function(fn)).apply(undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (IS_NODE) {
    defer = function (id) {
      process.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = bind(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global.addEventListener &&
    typeof postMessage == 'function' &&
    !global.importScripts &&
    location && location.protocol !== 'file:' &&
    !fails(post)
  ) {
    defer = post;
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

module.exports = {
  set: set,
  clear: clear
};


/***/ }),

/***/ 51400:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toInteger = __webpack_require__(99958);

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ 45656:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__(68361);
var requireObjectCoercible = __webpack_require__(84488);

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ 99958:
/***/ (function(module) {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.es/ecma262/#sec-tointeger
module.exports = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};


/***/ }),

/***/ 17466:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toInteger = __webpack_require__(99958);

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ 47908:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__(84488);

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ 57593:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(70111);
var isSymbol = __webpack_require__(52190);
var ordinaryToPrimitive = __webpack_require__(92140);
var wellKnownSymbol = __webpack_require__(5112);

var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = input[TO_PRIMITIVE];
  var result;
  if (exoticToPrim !== undefined) {
    if (pref === undefined) pref = 'default';
    result = exoticToPrim.call(input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};


/***/ }),

/***/ 34948:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toPrimitive = __webpack_require__(57593);
var isSymbol = __webpack_require__(52190);

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : String(key);
};


/***/ }),

/***/ 51694:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(5112);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ 41340:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSymbol = __webpack_require__(52190);

module.exports = function (argument) {
  if (isSymbol(argument)) throw TypeError('Cannot convert a Symbol value to a string');
  return String(argument);
};


/***/ }),

/***/ 69711:
/***/ (function(module) {

var id = 0;
var postfix = Math.random();

module.exports = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};


/***/ }),

/***/ 43307:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__(30133);

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),

/***/ 6061:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(5112);

exports.f = wellKnownSymbol;


/***/ }),

/***/ 5112:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(17854);
var shared = __webpack_require__(72309);
var has = __webpack_require__(86656);
var uid = __webpack_require__(69711);
var NATIVE_SYMBOL = __webpack_require__(30133);
var USE_SYMBOL_AS_UID = __webpack_require__(43307);

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!has(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    if (NATIVE_SYMBOL && has(Symbol, name)) {
      WellKnownSymbolsStore[name] = Symbol[name];
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
    }
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ 81361:
/***/ (function(module) {

// a string of all valid unicode whitespaces
module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),

/***/ 92222:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(82109);
var fails = __webpack_require__(47293);
var isArray = __webpack_require__(43157);
var isObject = __webpack_require__(70111);
var toObject = __webpack_require__(47908);
var toLength = __webpack_require__(17466);
var createProperty = __webpack_require__(86135);
var arraySpeciesCreate = __webpack_require__(65417);
var arrayMethodHasSpeciesSupport = __webpack_require__(81194);
var wellKnownSymbol = __webpack_require__(5112);
var V8_VERSION = __webpack_require__(7392);

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = toLength(E.length);
        if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),

/***/ 26541:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(82109);
var $every = (__webpack_require__(42092).every);
var arrayMethodIsStrict = __webpack_require__(9341);

var STRICT_METHOD = arrayMethodIsStrict('every');

// `Array.prototype.every` method
// https://tc39.es/ecma262/#sec-array.prototype.every
$({ target: 'Array', proto: true, forced: !STRICT_METHOD }, {
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ 57327:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(82109);
var $filter = (__webpack_require__(42092).filter);
var arrayMethodHasSpeciesSupport = __webpack_require__(81194);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');

// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ 89554:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(82109);
var forEach = __webpack_require__(18533);

// `Array.prototype.forEach` method
// https://tc39.es/ecma262/#sec-array.prototype.foreach
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
$({ target: 'Array', proto: true, forced: [].forEach != forEach }, {
  forEach: forEach
});


/***/ }),

/***/ 91038:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(82109);
var from = __webpack_require__(48457);
var checkCorrectnessOfIteration = __webpack_require__(17072);

var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
  // eslint-disable-next-line es/no-array-from -- required for testing
  Array.from(iterable);
});

// `Array.from` method
// https://tc39.es/ecma262/#sec-array.from
$({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
  from: from
});


/***/ }),

/***/ 26699:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(82109);
var $includes = (__webpack_require__(41318).includes);
var addToUnscopables = __webpack_require__(51223);

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$({ target: 'Array', proto: true }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');


/***/ }),

/***/ 82772:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-array-prototype-indexof -- required for testing */
var $ = __webpack_require__(82109);
var $indexOf = (__webpack_require__(41318).indexOf);
var arrayMethodIsStrict = __webpack_require__(9341);

var nativeIndexOf = [].indexOf;

var NEGATIVE_ZERO = !!nativeIndexOf && 1 / [1].indexOf(1, -0) < 0;
var STRICT_METHOD = arrayMethodIsStrict('indexOf');

// `Array.prototype.indexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.indexof
$({ target: 'Array', proto: true, forced: NEGATIVE_ZERO || !STRICT_METHOD }, {
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? nativeIndexOf.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ 66992:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__(45656);
var addToUnscopables = __webpack_require__(51223);
var Iterators = __webpack_require__(97497);
var InternalStateModule = __webpack_require__(29909);
var defineIterator = __webpack_require__(70654);

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ 69600:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(82109);
var IndexedObject = __webpack_require__(68361);
var toIndexedObject = __webpack_require__(45656);
var arrayMethodIsStrict = __webpack_require__(9341);

var nativeJoin = [].join;

var ES3_STRINGS = IndexedObject != Object;
var STRICT_METHOD = arrayMethodIsStrict('join', ',');

// `Array.prototype.join` method
// https://tc39.es/ecma262/#sec-array.prototype.join
$({ target: 'Array', proto: true, forced: ES3_STRINGS || !STRICT_METHOD }, {
  join: function join(separator) {
    return nativeJoin.call(toIndexedObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),

/***/ 21249:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(82109);
var $map = (__webpack_require__(42092).map);
var arrayMethodHasSpeciesSupport = __webpack_require__(81194);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');

// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ 85827:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(82109);
var $reduce = (__webpack_require__(53671).left);
var arrayMethodIsStrict = __webpack_require__(9341);
var CHROME_VERSION = __webpack_require__(7392);
var IS_NODE = __webpack_require__(35268);

var STRICT_METHOD = arrayMethodIsStrict('reduce');
// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83;

// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$({ target: 'Array', proto: true, forced: !STRICT_METHOD || CHROME_BUG }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ 65069:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(82109);
var isArray = __webpack_require__(43157);

var nativeReverse = [].reverse;
var test = [1, 2];

// `Array.prototype.reverse` method
// https://tc39.es/ecma262/#sec-array.prototype.reverse
// fix for Safari 12.0 bug
// https://bugs.webkit.org/show_bug.cgi?id=188794
$({ target: 'Array', proto: true, forced: String(test) === String(test.reverse()) }, {
  reverse: function reverse() {
    // eslint-disable-next-line no-self-assign -- dirty hack
    if (isArray(this)) this.length = this.length;
    return nativeReverse.call(this);
  }
});


/***/ }),

/***/ 47042:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(82109);
var isObject = __webpack_require__(70111);
var isArray = __webpack_require__(43157);
var toAbsoluteIndex = __webpack_require__(51400);
var toLength = __webpack_require__(17466);
var toIndexedObject = __webpack_require__(45656);
var createProperty = __webpack_require__(86135);
var wellKnownSymbol = __webpack_require__(5112);
var arrayMethodHasSpeciesSupport = __webpack_require__(81194);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');

var SPECIES = wellKnownSymbol('species');
var nativeSlice = [].slice;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = toLength(O.length);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (typeof Constructor == 'function' && (Constructor === Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === Array || Constructor === undefined) {
        return nativeSlice.call(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});


/***/ }),

/***/ 5212:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(82109);
var $some = (__webpack_require__(42092).some);
var arrayMethodIsStrict = __webpack_require__(9341);

var STRICT_METHOD = arrayMethodIsStrict('some');

// `Array.prototype.some` method
// https://tc39.es/ecma262/#sec-array.prototype.some
$({ target: 'Array', proto: true, forced: !STRICT_METHOD }, {
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ 2707:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(82109);
var aFunction = __webpack_require__(13099);
var toObject = __webpack_require__(47908);
var toLength = __webpack_require__(17466);
var toString = __webpack_require__(41340);
var fails = __webpack_require__(47293);
var internalSort = __webpack_require__(94362);
var arrayMethodIsStrict = __webpack_require__(9341);
var FF = __webpack_require__(68886);
var IE_OR_EDGE = __webpack_require__(30256);
var V8 = __webpack_require__(7392);
var WEBKIT = __webpack_require__(98008);

var test = [];
var nativeSort = test.sort;

// IE8-
var FAILS_ON_UNDEFINED = fails(function () {
  test.sort(undefined);
});
// V8 bug
var FAILS_ON_NULL = fails(function () {
  test.sort(null);
});
// Old WebKit
var STRICT_METHOD = arrayMethodIsStrict('sort');

var STABLE_SORT = !fails(function () {
  // feature detection can be too slow, so check engines versions
  if (V8) return V8 < 70;
  if (FF && FF > 3) return;
  if (IE_OR_EDGE) return true;
  if (WEBKIT) return WEBKIT < 603;

  var result = '';
  var code, chr, value, index;

  // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
  for (code = 65; code < 76; code++) {
    chr = String.fromCharCode(code);

    switch (code) {
      case 66: case 69: case 70: case 72: value = 3; break;
      case 68: case 71: value = 4; break;
      default: value = 2;
    }

    for (index = 0; index < 47; index++) {
      test.push({ k: chr + index, v: value });
    }
  }

  test.sort(function (a, b) { return b.v - a.v; });

  for (index = 0; index < test.length; index++) {
    chr = test[index].k.charAt(0);
    if (result.charAt(result.length - 1) !== chr) result += chr;
  }

  return result !== 'DGBEFHACIJK';
});

var FORCED = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD || !STABLE_SORT;

var getSortCompare = function (comparefn) {
  return function (x, y) {
    if (y === undefined) return -1;
    if (x === undefined) return 1;
    if (comparefn !== undefined) return +comparefn(x, y) || 0;
    return toString(x) > toString(y) ? 1 : -1;
  };
};

// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
$({ target: 'Array', proto: true, forced: FORCED }, {
  sort: function sort(comparefn) {
    if (comparefn !== undefined) aFunction(comparefn);

    var array = toObject(this);

    if (STABLE_SORT) return comparefn === undefined ? nativeSort.call(array) : nativeSort.call(array, comparefn);

    var items = [];
    var arrayLength = toLength(array.length);
    var itemsLength, index;

    for (index = 0; index < arrayLength; index++) {
      if (index in array) items.push(array[index]);
    }

    items = internalSort(items, getSortCompare(comparefn));
    itemsLength = items.length;
    index = 0;

    while (index < itemsLength) array[index] = items[index++];
    while (index < arrayLength) delete array[index++];

    return array;
  }
});


/***/ }),

/***/ 5735:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(82109);
var fails = __webpack_require__(47293);
var toObject = __webpack_require__(47908);
var toPrimitive = __webpack_require__(57593);

var FORCED = fails(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
});

// `Date.prototype.toJSON` method
// https://tc39.es/ecma262/#sec-date.prototype.tojson
$({ target: 'Date', proto: true, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O, 'number');
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),

/***/ 96078:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var createNonEnumerableProperty = __webpack_require__(68880);
var dateToPrimitive = __webpack_require__(38709);
var wellKnownSymbol = __webpack_require__(5112);

var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
var DatePrototype = Date.prototype;

// `Date.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-date.prototype-@@toprimitive
if (!(TO_PRIMITIVE in DatePrototype)) {
  createNonEnumerableProperty(DatePrototype, TO_PRIMITIVE, dateToPrimitive);
}


/***/ }),

/***/ 68309:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(19781);
var defineProperty = (__webpack_require__(3070).f);

var FunctionPrototype = Function.prototype;
var FunctionPrototypeToString = FunctionPrototype.toString;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if (DESCRIPTORS && !(NAME in FunctionPrototype)) {
  defineProperty(FunctionPrototype, NAME, {
    configurable: true,
    get: function () {
      try {
        return FunctionPrototypeToString.call(this).match(nameRE)[1];
      } catch (error) {
        return '';
      }
    }
  });
}


/***/ }),

/***/ 35837:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(82109);
var global = __webpack_require__(17854);

// `globalThis` object
// https://tc39.es/ecma262/#sec-globalthis
$({ global: true }, {
  globalThis: global
});


/***/ }),

/***/ 38862:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(82109);
var getBuiltIn = __webpack_require__(35005);
var fails = __webpack_require__(47293);

var $stringify = getBuiltIn('JSON', 'stringify');
var re = /[\uD800-\uDFFF]/g;
var low = /^[\uD800-\uDBFF]$/;
var hi = /^[\uDC00-\uDFFF]$/;

var fix = function (match, offset, string) {
  var prev = string.charAt(offset - 1);
  var next = string.charAt(offset + 1);
  if ((low.test(match) && !hi.test(next)) || (hi.test(match) && !low.test(prev))) {
    return '\\u' + match.charCodeAt(0).toString(16);
  } return match;
};

var FORCED = fails(function () {
  return $stringify('\uDF06\uD834') !== '"\\udf06\\ud834"'
    || $stringify('\uDEAD') !== '"\\udead"';
});

if ($stringify) {
  // `JSON.stringify` method
  // https://tc39.es/ecma262/#sec-json.stringify
  // https://github.com/tc39/proposal-well-formed-stringify
  $({ target: 'JSON', stat: true, forced: FORCED }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var result = $stringify.apply(null, arguments);
      return typeof result == 'string' ? result.replace(re, fix) : result;
    }
  });
}


/***/ }),

/***/ 73706:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(17854);
var setToStringTag = __webpack_require__(58003);

// JSON[@@toStringTag] property
// https://tc39.es/ecma262/#sec-json-@@tostringtag
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ 51532:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var collection = __webpack_require__(77710);
var collectionStrong = __webpack_require__(95631);

// `Map` constructor
// https://tc39.es/ecma262/#sec-map-objects
module.exports = collection('Map', function (init) {
  return function Map() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);


/***/ }),

/***/ 10408:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var setToStringTag = __webpack_require__(58003);

// Math[@@toStringTag] property
// https://tc39.es/ecma262/#sec-math-@@tostringtag
setToStringTag(Math, 'Math', true);


/***/ }),

/***/ 9653:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(19781);
var global = __webpack_require__(17854);
var isForced = __webpack_require__(54705);
var redefine = __webpack_require__(31320);
var has = __webpack_require__(86656);
var classof = __webpack_require__(84326);
var inheritIfRequired = __webpack_require__(79587);
var isSymbol = __webpack_require__(52190);
var toPrimitive = __webpack_require__(57593);
var fails = __webpack_require__(47293);
var create = __webpack_require__(70030);
var getOwnPropertyNames = (__webpack_require__(8006).f);
var getOwnPropertyDescriptor = (__webpack_require__(31236).f);
var defineProperty = (__webpack_require__(3070).f);
var trim = (__webpack_require__(53111).trim);

var NUMBER = 'Number';
var NativeNumber = global[NUMBER];
var NumberPrototype = NativeNumber.prototype;

// Opera ~12 has broken Object#toString
var BROKEN_CLASSOF = classof(create(NumberPrototype)) == NUMBER;

// `ToNumber` abstract operation
// https://tc39.es/ecma262/#sec-tonumber
var toNumber = function (argument) {
  if (isSymbol(argument)) throw TypeError('Cannot convert a Symbol value to a number');
  var it = toPrimitive(argument, 'number');
  var first, third, radix, maxCode, digits, length, index, code;
  if (typeof it == 'string' && it.length > 2) {
    it = trim(it);
    first = it.charCodeAt(0);
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal of /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal of /^0o[0-7]+$/i
        default: return +it;
      }
      digits = it.slice(2);
      length = digits.length;
      for (index = 0; index < length; index++) {
        code = digits.charCodeAt(index);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

// `Number` constructor
// https://tc39.es/ecma262/#sec-number-constructor
if (isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'))) {
  var NumberWrapper = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var dummy = this;
    return dummy instanceof NumberWrapper
      // check on 1..constructor(foo) case
      && (BROKEN_CLASSOF ? fails(function () { NumberPrototype.valueOf.call(dummy); }) : classof(dummy) != NUMBER)
        ? inheritIfRequired(new NativeNumber(toNumber(it)), dummy, NumberWrapper) : toNumber(it);
  };
  for (var keys = DESCRIPTORS ? getOwnPropertyNames(NativeNumber) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES2015 (in case, if modules with ES2015 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger,' +
    // ESNext
    'fromString,range'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(NativeNumber, key = keys[j]) && !has(NumberWrapper, key)) {
      defineProperty(NumberWrapper, key, getOwnPropertyDescriptor(NativeNumber, key));
    }
  }
  NumberWrapper.prototype = NumberPrototype;
  NumberPrototype.constructor = NumberWrapper;
  redefine(global, NUMBER, NumberWrapper);
}


/***/ }),

/***/ 19601:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(82109);
var assign = __webpack_require__(21574);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$({ target: 'Object', stat: true, forced: Object.assign !== assign }, {
  assign: assign
});


/***/ }),

/***/ 33321:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(82109);
var DESCRIPTORS = __webpack_require__(19781);
var defineProperties = __webpack_require__(36048);

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
$({ target: 'Object', stat: true, forced: !DESCRIPTORS, sham: !DESCRIPTORS }, {
  defineProperties: defineProperties
});


/***/ }),

/***/ 69070:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(82109);
var DESCRIPTORS = __webpack_require__(19781);
var objectDefinePropertyModile = __webpack_require__(3070);

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
$({ target: 'Object', stat: true, forced: !DESCRIPTORS, sham: !DESCRIPTORS }, {
  defineProperty: objectDefinePropertyModile.f
});


/***/ }),

/***/ 69720:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(82109);
var $entries = (__webpack_require__(44699).entries);

// `Object.entries` method
// https://tc39.es/ecma262/#sec-object.entries
$({ target: 'Object', stat: true }, {
  entries: function entries(O) {
    return $entries(O);
  }
});


/***/ }),

/***/ 43371:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(82109);
var FREEZING = __webpack_require__(76677);
var fails = __webpack_require__(47293);
var isObject = __webpack_require__(70111);
var onFreeze = (__webpack_require__(62423).onFreeze);

// eslint-disable-next-line es/no-object-freeze -- safe
var $freeze = Object.freeze;
var FAILS_ON_PRIMITIVES = fails(function () { $freeze(1); });

// `Object.freeze` method
// https://tc39.es/ecma262/#sec-object.freeze
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !FREEZING }, {
  freeze: function freeze(it) {
    return $freeze && isObject(it) ? $freeze(onFreeze(it)) : it;
  }
});


/***/ }),

/***/ 38559:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(82109);
var iterate = __webpack_require__(20408);
var createProperty = __webpack_require__(86135);

// `Object.fromEntries` method
// https://github.com/tc39/proposal-object-from-entries
$({ target: 'Object', stat: true }, {
  fromEntries: function fromEntries(iterable) {
    var obj = {};
    iterate(iterable, function (k, v) {
      createProperty(obj, k, v);
    }, { AS_ENTRIES: true });
    return obj;
  }
});


/***/ }),

/***/ 38880:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(82109);
var fails = __webpack_require__(47293);
var toIndexedObject = __webpack_require__(45656);
var nativeGetOwnPropertyDescriptor = (__webpack_require__(31236).f);
var DESCRIPTORS = __webpack_require__(19781);

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetOwnPropertyDescriptor(1); });
var FORCED = !DESCRIPTORS || FAILS_ON_PRIMITIVES;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$({ target: 'Object', stat: true, forced: FORCED, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
    return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
  }
});


/***/ }),

/***/ 49337:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(82109);
var DESCRIPTORS = __webpack_require__(19781);
var ownKeys = __webpack_require__(53887);
var toIndexedObject = __webpack_require__(45656);
var getOwnPropertyDescriptorModule = __webpack_require__(31236);
var createProperty = __webpack_require__(86135);

// `Object.getOwnPropertyDescriptors` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
$({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIndexedObject(object);
    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
    var keys = ownKeys(O);
    var result = {};
    var index = 0;
    var key, descriptor;
    while (keys.length > index) {
      descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
      if (descriptor !== undefined) createProperty(result, key, descriptor);
    }
    return result;
  }
});


/***/ }),

/***/ 30489:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(82109);
var fails = __webpack_require__(47293);
var toObject = __webpack_require__(47908);
var nativeGetPrototypeOf = __webpack_require__(79518);
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(49920);

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetPrototypeOf(1); });

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !CORRECT_PROTOTYPE_GETTER }, {
  getPrototypeOf: function getPrototypeOf(it) {
    return nativeGetPrototypeOf(toObject(it));
  }
});



/***/ }),

/***/ 47941:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(82109);
var toObject = __webpack_require__(47908);
var nativeKeys = __webpack_require__(81956);
var fails = __webpack_require__(47293);

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});


/***/ }),

/***/ 68304:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(82109);
var setPrototypeOf = __webpack_require__(27674);

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
$({ target: 'Object', stat: true }, {
  setPrototypeOf: setPrototypeOf
});


/***/ }),

/***/ 41539:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__(51694);
var redefine = __webpack_require__(31320);
var toString = __webpack_require__(90288);

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  redefine(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),

/***/ 26833:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(82109);
var $values = (__webpack_require__(44699).values);

// `Object.values` method
// https://tc39.es/ecma262/#sec-object.values
$({ target: 'Object', stat: true }, {
  values: function values(O) {
    return $values(O);
  }
});


/***/ }),

/***/ 54678:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(82109);
var parseFloatImplementation = __webpack_require__(2814);

// `parseFloat` method
// https://tc39.es/ecma262/#sec-parsefloat-string
$({ global: true, forced: parseFloat != parseFloatImplementation }, {
  parseFloat: parseFloatImplementation
});


/***/ }),

/***/ 91058:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(82109);
var parseIntImplementation = __webpack_require__(83009);

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$({ global: true, forced: parseInt != parseIntImplementation }, {
  parseInt: parseIntImplementation
});


/***/ }),

/***/ 88674:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(82109);
var IS_PURE = __webpack_require__(31913);
var global = __webpack_require__(17854);
var getBuiltIn = __webpack_require__(35005);
var NativePromise = __webpack_require__(13366);
var redefine = __webpack_require__(31320);
var redefineAll = __webpack_require__(12248);
var setPrototypeOf = __webpack_require__(27674);
var setToStringTag = __webpack_require__(58003);
var setSpecies = __webpack_require__(96340);
var isObject = __webpack_require__(70111);
var aFunction = __webpack_require__(13099);
var anInstance = __webpack_require__(25787);
var inspectSource = __webpack_require__(42788);
var iterate = __webpack_require__(20408);
var checkCorrectnessOfIteration = __webpack_require__(17072);
var speciesConstructor = __webpack_require__(36707);
var task = (__webpack_require__(20261).set);
var microtask = __webpack_require__(95948);
var promiseResolve = __webpack_require__(69478);
var hostReportErrors = __webpack_require__(842);
var newPromiseCapabilityModule = __webpack_require__(78523);
var perform = __webpack_require__(12534);
var InternalStateModule = __webpack_require__(29909);
var isForced = __webpack_require__(54705);
var wellKnownSymbol = __webpack_require__(5112);
var IS_BROWSER = __webpack_require__(7871);
var IS_NODE = __webpack_require__(35268);
var V8_VERSION = __webpack_require__(7392);

var SPECIES = wellKnownSymbol('species');
var PROMISE = 'Promise';
var getInternalState = InternalStateModule.get;
var setInternalState = InternalStateModule.set;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var NativePromisePrototype = NativePromise && NativePromise.prototype;
var PromiseConstructor = NativePromise;
var PromiseConstructorPrototype = NativePromisePrototype;
var TypeError = global.TypeError;
var document = global.document;
var process = global.process;
var newPromiseCapability = newPromiseCapabilityModule.f;
var newGenericPromiseCapability = newPromiseCapability;
var DISPATCH_EVENT = !!(document && document.createEvent && global.dispatchEvent);
var NATIVE_REJECTION_EVENT = typeof PromiseRejectionEvent == 'function';
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;
var SUBCLASSING = false;
var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

var FORCED = isForced(PROMISE, function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(PromiseConstructor);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(PromiseConstructor);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
  // We need Promise#finally in the pure version for preventing prototype pollution
  if (IS_PURE && !PromiseConstructorPrototype['finally']) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (V8_VERSION >= 51 && /native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) return false;
  // Detect correctness of subclassing with @@species support
  var promise = new PromiseConstructor(function (resolve) { resolve(1); });
  var FakePromise = function (exec) {
    exec(function () { /* empty */ }, function () { /* empty */ });
  };
  var constructor = promise.constructor = {};
  constructor[SPECIES] = FakePromise;
  SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
  if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  return !GLOBAL_CORE_JS_PROMISE && IS_BROWSER && !NATIVE_REJECTION_EVENT;
});

var INCORRECT_ITERATION = FORCED || !checkCorrectnessOfIteration(function (iterable) {
  PromiseConstructor.all(iterable)['catch'](function () { /* empty */ });
});

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  var chain = state.reactions;
  microtask(function () {
    var value = state.value;
    var ok = state.state == FULFILLED;
    var index = 0;
    // variable length - can't use forEach
    while (chain.length > index) {
      var reaction = chain[index++];
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (state.rejection === UNHANDLED) onHandleUnhandled(state);
            state.rejection = HANDLED;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // can throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
      }
    }
    state.reactions = [];
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_REJECTION_EVENT && (handler = global['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  task.call(global, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (IS_NODE) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  task.call(global, function () {
    var promise = state.facade;
    if (IS_NODE) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw TypeError("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          then.call(value,
            bind(internalResolve, wrapper, state),
            bind(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromiseConstructor, PROMISE);
    aFunction(executor);
    Internal.call(this);
    var state = getInternalState(this);
    try {
      executor(bind(internalResolve, state), bind(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };
  PromiseConstructorPrototype = PromiseConstructor.prototype;
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: [],
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };
  Internal.prototype = redefineAll(PromiseConstructorPrototype, {
    // `Promise.prototype.then` method
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    then: function then(onFulfilled, onRejected) {
      var state = getInternalPromiseState(this);
      var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = IS_NODE ? process.domain : undefined;
      state.parent = true;
      state.reactions.push(reaction);
      if (state.state != PENDING) notify(state, false);
      return reaction.promise;
    },
    // `Promise.prototype.catch` method
    // https://tc39.es/ecma262/#sec-promise.prototype.catch
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalState(promise);
    this.promise = promise;
    this.resolve = bind(internalResolve, state);
    this.reject = bind(internalReject, state);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (!IS_PURE && typeof NativePromise == 'function' && NativePromisePrototype !== Object.prototype) {
    nativeThen = NativePromisePrototype.then;

    if (!SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      redefine(NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          nativeThen.call(that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });

      // makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
      redefine(NativePromisePrototype, 'catch', PromiseConstructorPrototype['catch'], { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf) {
      setPrototypeOf(NativePromisePrototype, PromiseConstructorPrototype);
    }
  }
}

$({ global: true, wrap: true, forced: FORCED }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false, true);
setSpecies(PROMISE);

PromiseWrapper = getBuiltIn(PROMISE);

// statics
$({ target: PROMISE, stat: true, forced: FORCED }, {
  // `Promise.reject` method
  // https://tc39.es/ecma262/#sec-promise.reject
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    capability.reject.call(undefined, r);
    return capability.promise;
  }
});

$({ target: PROMISE, stat: true, forced: IS_PURE || FORCED }, {
  // `Promise.resolve` method
  // https://tc39.es/ecma262/#sec-promise.resolve
  resolve: function resolve(x) {
    return promiseResolve(IS_PURE && this === PromiseWrapper ? PromiseConstructor : this, x);
  }
});

$({ target: PROMISE, stat: true, forced: INCORRECT_ITERATION }, {
  // `Promise.all` method
  // https://tc39.es/ecma262/#sec-promise.all
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aFunction(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        $promiseResolve.call(C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  },
  // `Promise.race` method
  // https://tc39.es/ecma262/#sec-promise.race
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aFunction(C.resolve);
      iterate(iterable, function (promise) {
        $promiseResolve.call(C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),

/***/ 12419:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(82109);
var getBuiltIn = __webpack_require__(35005);
var aFunction = __webpack_require__(13099);
var anObject = __webpack_require__(19670);
var isObject = __webpack_require__(70111);
var create = __webpack_require__(70030);
var bind = __webpack_require__(27065);
var fails = __webpack_require__(47293);

var nativeConstruct = getBuiltIn('Reflect', 'construct');

// `Reflect.construct` method
// https://tc39.es/ecma262/#sec-reflect.construct
// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(nativeConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  nativeConstruct(function () { /* empty */ });
});
var FORCED = NEW_TARGET_BUG || ARGS_BUG;

$({ target: 'Reflect', stat: true, forced: FORCED, sham: FORCED }, {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return nativeConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),

/***/ 81299:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(82109);
var global = __webpack_require__(17854);
var setToStringTag = __webpack_require__(58003);

$({ global: true }, { Reflect: {} });

// Reflect[@@toStringTag] property
// https://tc39.es/ecma262/#sec-reflect-@@tostringtag
setToStringTag(global.Reflect, 'Reflect', true);


/***/ }),

/***/ 74916:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(82109);
var exec = __webpack_require__(22261);

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});


/***/ }),

/***/ 77601:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4` since it's moved to entry points
__webpack_require__(74916);
var $ = __webpack_require__(82109);
var isObject = __webpack_require__(70111);

var DELEGATES_TO_EXEC = function () {
  var execCalled = false;
  var re = /[ac]/;
  re.exec = function () {
    execCalled = true;
    return /./.exec.apply(this, arguments);
  };
  return re.test('abc') === true && execCalled;
}();

var nativeTest = /./.test;

// `RegExp.prototype.test` method
// https://tc39.es/ecma262/#sec-regexp.prototype.test
$({ target: 'RegExp', proto: true, forced: !DELEGATES_TO_EXEC }, {
  test: function (str) {
    if (typeof this.exec !== 'function') {
      return nativeTest.call(this, str);
    }
    var result = this.exec(str);
    if (result !== null && !isObject(result)) {
      throw new Error('RegExp exec method returned something other than an Object or null');
    }
    return !!result;
  }
});


/***/ }),

/***/ 39714:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var redefine = __webpack_require__(31320);
var anObject = __webpack_require__(19670);
var $toString = __webpack_require__(41340);
var fails = __webpack_require__(47293);
var flags = __webpack_require__(67066);

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var nativeToString = RegExpPrototype[TO_STRING];

var NOT_GENERIC = fails(function () { return nativeToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = nativeToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  redefine(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var p = $toString(R.source);
    var rf = R.flags;
    var f = $toString(rf === undefined && R instanceof RegExp && !('flags' in RegExpPrototype) ? flags.call(R) : rf);
    return '/' + p + '/' + f;
  }, { unsafe: true });
}


/***/ }),

/***/ 70189:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var collection = __webpack_require__(77710);
var collectionStrong = __webpack_require__(95631);

// `Set` constructor
// https://tc39.es/ecma262/#sec-set-objects
module.exports = collection('Set', function (init) {
  return function Set() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);


/***/ }),

/***/ 50915:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(82109);
var createHTML = __webpack_require__(14230);
var forcedStringHTMLMethod = __webpack_require__(43429);

// `String.prototype.bold` method
// https://tc39.es/ecma262/#sec-string.prototype.bold
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('bold') }, {
  bold: function bold() {
    return createHTML(this, 'b', '', '');
  }
});


/***/ }),

/***/ 27852:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(82109);
var getOwnPropertyDescriptor = (__webpack_require__(31236).f);
var toLength = __webpack_require__(17466);
var toString = __webpack_require__(41340);
var notARegExp = __webpack_require__(3929);
var requireObjectCoercible = __webpack_require__(84488);
var correctIsRegExpLogic = __webpack_require__(84964);
var IS_PURE = __webpack_require__(31913);

// eslint-disable-next-line es/no-string-prototype-endswith -- safe
var $endsWith = ''.endsWith;
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('endsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'endsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.endsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.endswith
$({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = toString(requireObjectCoercible(this));
    notARegExp(searchString);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : min(toLength(endPosition), len);
    var search = toString(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),

/***/ 32023:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(82109);
var notARegExp = __webpack_require__(3929);
var requireObjectCoercible = __webpack_require__(84488);
var toString = __webpack_require__(41340);
var correctIsRegExpLogic = __webpack_require__(84964);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~toString(requireObjectCoercible(this))
      .indexOf(toString(notARegExp(searchString)), arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ 78783:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var charAt = (__webpack_require__(28710).charAt);
var toString = __webpack_require__(41340);
var InternalStateModule = __webpack_require__(29909);
var defineIterator = __webpack_require__(70654);

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: toString(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt(string, index);
  state.index += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ 68757:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(82109);
var requireObjectCoercible = __webpack_require__(84488);
var isRegExp = __webpack_require__(47850);
var toString = __webpack_require__(41340);
var getRegExpFlags = __webpack_require__(67066);
var getSubstitution = __webpack_require__(10647);
var wellKnownSymbol = __webpack_require__(5112);
var IS_PURE = __webpack_require__(31913);

var REPLACE = wellKnownSymbol('replace');
var RegExpPrototype = RegExp.prototype;
var max = Math.max;

var stringIndexOf = function (string, searchValue, fromIndex) {
  if (fromIndex > string.length) return -1;
  if (searchValue === '') return fromIndex;
  return string.indexOf(searchValue, fromIndex);
};

// `String.prototype.replaceAll` method
// https://tc39.es/ecma262/#sec-string.prototype.replaceall
$({ target: 'String', proto: true }, {
  replaceAll: function replaceAll(searchValue, replaceValue) {
    var O = requireObjectCoercible(this);
    var IS_REG_EXP, flags, replacer, string, searchString, functionalReplace, searchLength, advanceBy, replacement;
    var position = 0;
    var endOfLastMatch = 0;
    var result = '';
    if (searchValue != null) {
      IS_REG_EXP = isRegExp(searchValue);
      if (IS_REG_EXP) {
        flags = toString(requireObjectCoercible('flags' in RegExpPrototype
          ? searchValue.flags
          : getRegExpFlags.call(searchValue)
        ));
        if (!~flags.indexOf('g')) throw TypeError('`.replaceAll` does not allow non-global regexes');
      }
      replacer = searchValue[REPLACE];
      if (replacer !== undefined) {
        return replacer.call(searchValue, O, replaceValue);
      } else if (IS_PURE && IS_REG_EXP) {
        return toString(O).replace(searchValue, replaceValue);
      }
    }
    string = toString(O);
    searchString = toString(searchValue);
    functionalReplace = typeof replaceValue === 'function';
    if (!functionalReplace) replaceValue = toString(replaceValue);
    searchLength = searchString.length;
    advanceBy = max(1, searchLength);
    position = stringIndexOf(string, searchString, 0);
    while (position !== -1) {
      if (functionalReplace) {
        replacement = toString(replaceValue(searchString, position, string));
      } else {
        replacement = getSubstitution(searchString, string, position, [], undefined, replaceValue);
      }
      result += string.slice(endOfLastMatch, position) + replacement;
      endOfLastMatch = position + searchLength;
      position = stringIndexOf(string, searchString, position + advanceBy);
    }
    if (endOfLastMatch < string.length) {
      result += string.slice(endOfLastMatch);
    }
    return result;
  }
});


/***/ }),

/***/ 15306:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__(27007);
var fails = __webpack_require__(47293);
var anObject = __webpack_require__(19670);
var toInteger = __webpack_require__(99958);
var toLength = __webpack_require__(17466);
var toString = __webpack_require__(41340);
var requireObjectCoercible = __webpack_require__(84488);
var advanceStringIndex = __webpack_require__(31530);
var getSubstitution = __webpack_require__(10647);
var regExpExec = __webpack_require__(97651);
var wellKnownSymbol = __webpack_require__(5112);

var REPLACE = wellKnownSymbol('replace');
var max = Math.max;
var min = Math.min;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegExpWellKnownSymbolLogic('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = searchValue == undefined ? undefined : searchValue[REPLACE];
      return replacer !== undefined
        ? replacer.call(searchValue, O, replaceValue)
        : nativeReplace.call(toString(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      var rx = anObject(this);
      var S = toString(string);

      if (
        typeof replaceValue === 'string' &&
        replaceValue.indexOf(UNSAFE_SUBSTITUTE) === -1 &&
        replaceValue.indexOf('$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
        if (res.done) return res.value;
      }

      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = toString(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;

        results.push(result);
        if (!global) break;

        var matchStr = toString(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = toString(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = toString(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);


/***/ }),

/***/ 23157:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(82109);
var getOwnPropertyDescriptor = (__webpack_require__(31236).f);
var toLength = __webpack_require__(17466);
var toString = __webpack_require__(41340);
var notARegExp = __webpack_require__(3929);
var requireObjectCoercible = __webpack_require__(84488);
var correctIsRegExpLogic = __webpack_require__(84964);
var IS_PURE = __webpack_require__(31913);

// eslint-disable-next-line es/no-string-prototype-startswith -- safe
var $startsWith = ''.startsWith;
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('startsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'startsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.startsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.startswith
$({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = toString(requireObjectCoercible(this));
    notARegExp(searchString);
    var index = toLength(min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = toString(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),

/***/ 72443:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(97235);

// `Symbol.asyncIterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.asynciterator
defineWellKnownSymbol('asyncIterator');


/***/ }),

/***/ 41817:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";
// `Symbol.prototype.description` getter
// https://tc39.es/ecma262/#sec-symbol.prototype.description

var $ = __webpack_require__(82109);
var DESCRIPTORS = __webpack_require__(19781);
var global = __webpack_require__(17854);
var has = __webpack_require__(86656);
var isObject = __webpack_require__(70111);
var defineProperty = (__webpack_require__(3070).f);
var copyConstructorProperties = __webpack_require__(99920);

var NativeSymbol = global.Symbol;

if (DESCRIPTORS && typeof NativeSymbol == 'function' && (!('description' in NativeSymbol.prototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : String(arguments[0]);
    var result = this instanceof SymbolWrapper
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };
  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  var symbolPrototype = SymbolWrapper.prototype = NativeSymbol.prototype;
  symbolPrototype.constructor = SymbolWrapper;

  var symbolToString = symbolPrototype.toString;
  var nativeSymbol = String(NativeSymbol('test')) == 'Symbol(test)';
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  defineProperty(symbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = isObject(this) ? this.valueOf() : this;
      var string = symbolToString.call(symbol);
      if (has(EmptyStringDescriptionStore, symbol)) return '';
      var desc = nativeSymbol ? string.slice(7, -1) : string.replace(regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}


/***/ }),

/***/ 32165:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(97235);

// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');


/***/ }),

/***/ 82526:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(82109);
var global = __webpack_require__(17854);
var getBuiltIn = __webpack_require__(35005);
var IS_PURE = __webpack_require__(31913);
var DESCRIPTORS = __webpack_require__(19781);
var NATIVE_SYMBOL = __webpack_require__(30133);
var fails = __webpack_require__(47293);
var has = __webpack_require__(86656);
var isArray = __webpack_require__(43157);
var isObject = __webpack_require__(70111);
var isSymbol = __webpack_require__(52190);
var anObject = __webpack_require__(19670);
var toObject = __webpack_require__(47908);
var toIndexedObject = __webpack_require__(45656);
var toPropertyKey = __webpack_require__(34948);
var $toString = __webpack_require__(41340);
var createPropertyDescriptor = __webpack_require__(79114);
var nativeObjectCreate = __webpack_require__(70030);
var objectKeys = __webpack_require__(81956);
var getOwnPropertyNamesModule = __webpack_require__(8006);
var getOwnPropertyNamesExternal = __webpack_require__(1156);
var getOwnPropertySymbolsModule = __webpack_require__(25181);
var getOwnPropertyDescriptorModule = __webpack_require__(31236);
var definePropertyModule = __webpack_require__(3070);
var propertyIsEnumerableModule = __webpack_require__(55296);
var createNonEnumerableProperty = __webpack_require__(68880);
var redefine = __webpack_require__(31320);
var shared = __webpack_require__(72309);
var sharedKey = __webpack_require__(6200);
var hiddenKeys = __webpack_require__(3501);
var uid = __webpack_require__(69711);
var wellKnownSymbol = __webpack_require__(5112);
var wrappedWellKnownSymbolModule = __webpack_require__(6061);
var defineWellKnownSymbol = __webpack_require__(97235);
var setToStringTag = __webpack_require__(58003);
var InternalStateModule = __webpack_require__(29909);
var $forEach = (__webpack_require__(42092).forEach);

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);
var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var $stringify = getBuiltIn('JSON', 'stringify');
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');
var WellKnownSymbolsStore = shared('wks');
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate($Symbol[PROTOTYPE]);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPropertyKey(P);
  anObject(Attributes);
  if (has(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!has(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (has(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || $propertyIsEnumerable.call(properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPropertyKey(V);
  var enumerable = nativePropertyIsEnumerable.call(this, P);
  if (this === ObjectPrototype && has(AllSymbols, P) && !has(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !has(this, P) || !has(AllSymbols, P) || has(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPropertyKey(P);
  if (it === ObjectPrototype && has(AllSymbols, key) && !has(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!has(AllSymbols, key) && !has(hiddenKeys, key)) result.push(key);
  });
  return result;
};

var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (has(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || has(ObjectPrototype, key))) {
      result.push(AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : $toString(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype) setter.call(ObjectPrototypeSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return getInternalState(this).tag;
  });

  redefine($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty($Symbol[PROTOTYPE], 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      redefine(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$({ global: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  // `Symbol.for` method
  // https://tc39.es/ecma262/#sec-symbol.for
  'for': function (key) {
    var string = $toString(key);
    if (has(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = $Symbol(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  },
  // `Symbol.keyFor` method
  // https://tc39.es/ecma262/#sec-symbol.keyfor
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol');
    if (has(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  },
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames,
  // `Object.getOwnPropertySymbols` method
  // https://tc39.es/ecma262/#sec-object.getownpropertysymbols
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
$({ target: 'Object', stat: true, forced: fails(function () { getOwnPropertySymbolsModule.f(1); }) }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return getOwnPropertySymbolsModule.f(toObject(it));
  }
});

// `JSON.stringify` method behavior with symbols
// https://tc39.es/ecma262/#sec-json.stringify
if ($stringify) {
  var FORCED_JSON_STRINGIFY = !NATIVE_SYMBOL || fails(function () {
    var symbol = $Symbol();
    // MS Edge converts symbol values to JSON as {}
    return $stringify([symbol]) != '[null]'
      // WebKit converts symbol values to JSON as null
      || $stringify({ a: symbol }) != '{}'
      // V8 throws on boxed symbols
      || $stringify(Object(symbol)) != '{}';
  });

  $({ target: 'JSON', stat: true, forced: FORCED_JSON_STRINGIFY }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = [it];
      var index = 1;
      var $replacer;
      while (arguments.length > index) args.push(arguments[index++]);
      $replacer = replacer;
      if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
      if (!isArray(replacer)) replacer = function (key, value) {
        if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
        if (!isSymbol(value)) return value;
      };
      args[1] = replacer;
      return $stringify.apply(null, args);
    }
  });
}

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
if (!$Symbol[PROTOTYPE][TO_PRIMITIVE]) {
  createNonEnumerableProperty($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
}
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;


/***/ }),

/***/ 96649:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(97235);

// `Symbol.toPrimitive` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.toprimitive
defineWellKnownSymbol('toPrimitive');


/***/ }),

/***/ 39341:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(97235);

// `Symbol.toStringTag` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.tostringtag
defineWellKnownSymbol('toStringTag');


/***/ }),

/***/ 4129:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(17854);
var redefineAll = __webpack_require__(12248);
var InternalMetadataModule = __webpack_require__(62423);
var collection = __webpack_require__(77710);
var collectionWeak = __webpack_require__(29320);
var isObject = __webpack_require__(70111);
var enforceIternalState = (__webpack_require__(29909).enforce);
var NATIVE_WEAK_MAP = __webpack_require__(68536);

var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
// eslint-disable-next-line es/no-object-isextensible -- safe
var isExtensible = Object.isExtensible;
var InternalWeakMap;

var wrapper = function (init) {
  return function WeakMap() {
    return init(this, arguments.length ? arguments[0] : undefined);
  };
};

// `WeakMap` constructor
// https://tc39.es/ecma262/#sec-weakmap-constructor
var $WeakMap = module.exports = collection('WeakMap', wrapper, collectionWeak);

// IE11 WeakMap frozen keys fix
// We can't use feature detection because it crash some old IE builds
// https://github.com/zloirock/core-js/issues/485
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalWeakMap = collectionWeak.getConstructor(wrapper, 'WeakMap', true);
  InternalMetadataModule.enable();
  var WeakMapPrototype = $WeakMap.prototype;
  var nativeDelete = WeakMapPrototype['delete'];
  var nativeHas = WeakMapPrototype.has;
  var nativeGet = WeakMapPrototype.get;
  var nativeSet = WeakMapPrototype.set;
  redefineAll(WeakMapPrototype, {
    'delete': function (key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceIternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeDelete.call(this, key) || state.frozen['delete'](key);
      } return nativeDelete.call(this, key);
    },
    has: function has(key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceIternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeHas.call(this, key) || state.frozen.has(key);
      } return nativeHas.call(this, key);
    },
    get: function get(key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceIternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeHas.call(this, key) ? nativeGet.call(this, key) : state.frozen.get(key);
      } return nativeGet.call(this, key);
    },
    set: function set(key, value) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceIternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        nativeHas.call(this, key) ? nativeSet.call(this, key, value) : state.frozen.set(key, value);
      } else nativeSet.call(this, key, value);
      return this;
    }
  });
}


/***/ }),

/***/ 2490:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-iterator-helpers
var $ = __webpack_require__(82109);
var global = __webpack_require__(17854);
var anInstance = __webpack_require__(25787);
var createNonEnumerableProperty = __webpack_require__(68880);
var fails = __webpack_require__(47293);
var has = __webpack_require__(86656);
var wellKnownSymbol = __webpack_require__(5112);
var IteratorPrototype = (__webpack_require__(13383).IteratorPrototype);
var IS_PURE = __webpack_require__(31913);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

var NativeIterator = global.Iterator;

// FF56- have non-standard global helper `Iterator`
var FORCED = IS_PURE
  || typeof NativeIterator != 'function'
  || NativeIterator.prototype !== IteratorPrototype
  // FF44- non-standard `Iterator` passes previous tests
  || !fails(function () { NativeIterator({}); });

var IteratorConstructor = function Iterator() {
  anInstance(this, IteratorConstructor);
};

if (!has(IteratorPrototype, TO_STRING_TAG)) {
  createNonEnumerableProperty(IteratorPrototype, TO_STRING_TAG, 'Iterator');
}

if (FORCED || !has(IteratorPrototype, 'constructor') || IteratorPrototype.constructor === Object) {
  createNonEnumerableProperty(IteratorPrototype, 'constructor', IteratorConstructor);
}

IteratorConstructor.prototype = IteratorPrototype;

$({ global: true, forced: FORCED }, {
  Iterator: IteratorConstructor
});


/***/ }),

/***/ 59849:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-iterator-helpers
var $ = __webpack_require__(82109);
var aFunction = __webpack_require__(13099);
var anObject = __webpack_require__(19670);
var createIteratorProxy = __webpack_require__(54956);
var callWithSafeIterationClosing = __webpack_require__(53411);

var IteratorProxy = createIteratorProxy(function (args) {
  var iterator = this.iterator;
  var filterer = this.filterer;
  var next = this.next;
  var result, done, value;
  while (true) {
    result = anObject(next.apply(iterator, args));
    done = this.done = !!result.done;
    if (done) return;
    value = result.value;
    if (callWithSafeIterationClosing(iterator, filterer, value)) return value;
  }
});

$({ target: 'Iterator', proto: true, real: true }, {
  filter: function filter(filterer) {
    return new IteratorProxy({
      iterator: anObject(this),
      filterer: aFunction(filterer)
    });
  }
});


/***/ }),

/***/ 34514:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-iterator-helpers
var $ = __webpack_require__(82109);
var iterate = __webpack_require__(20408);
var anObject = __webpack_require__(19670);

$({ target: 'Iterator', proto: true, real: true }, {
  forEach: function forEach(fn) {
    iterate(anObject(this), fn, { IS_ITERATOR: true });
  }
});


/***/ }),

/***/ 41874:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-iterator-helpers
var $ = __webpack_require__(82109);
var iterate = __webpack_require__(20408);
var aFunction = __webpack_require__(13099);
var anObject = __webpack_require__(19670);

$({ target: 'Iterator', proto: true, real: true }, {
  some: function some(fn) {
    anObject(this);
    aFunction(fn);
    return iterate(this, function (value, stop) {
      if (fn(value)) return stop();
    }, { IS_ITERATOR: true, INTERRUPTED: true }).stopped;
  }
});


/***/ }),

/***/ 54747:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(17854);
var DOMIterables = __webpack_require__(48324);
var DOMTokenListPrototype = __webpack_require__(98509);
var forEach = __webpack_require__(18533);
var createNonEnumerableProperty = __webpack_require__(68880);

var handlePrototype = function (CollectionPrototype) {
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
  } catch (error) {
    CollectionPrototype.forEach = forEach;
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype);
}

handlePrototype(DOMTokenListPrototype);


/***/ }),

/***/ 33948:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(17854);
var DOMIterables = __webpack_require__(48324);
var DOMTokenListPrototype = __webpack_require__(98509);
var ArrayIteratorMethods = __webpack_require__(66992);
var createNonEnumerableProperty = __webpack_require__(68880);
var wellKnownSymbol = __webpack_require__(5112);

var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');


/***/ }),

/***/ 32564:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(82109);
var global = __webpack_require__(17854);
var userAgent = __webpack_require__(88113);

var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check

var wrap = function (scheduler) {
  return function (handler, timeout /* , ...arguments */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : undefined;
    return scheduler(boundArgs ? function () {
      // eslint-disable-next-line no-new-func -- spec requirement
      (typeof handler == 'function' ? handler : Function(handler)).apply(this, args);
    } : handler, timeout);
  };
};

// ie9- setTimeout & setInterval additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
$({ global: true, bind: true, forced: MSIE }, {
  // `setTimeout` method
  // https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-settimeout
  setTimeout: wrap(global.setTimeout),
  // `setInterval` method
  // https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-setinterval
  setInterval: wrap(global.setInterval)
});


/***/ }),

/***/ 58875:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return ExecutionEnvironment;
		}).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}

}());


/***/ }),

/***/ 8679:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(21296);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 96103:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 21296:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(96103);
} else {}


/***/ }),

/***/ 36808:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.1.4
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader = false;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function init (converter) {
		function api (key, value, attributes) {
			var result;
			if (typeof document === 'undefined') {
				return;
			}

			// Write

			if (arguments.length > 1) {
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);

				if (typeof attributes.expires === 'number') {
					var expires = new Date();
					expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
					attributes.expires = expires;
				}

				// We're using "expires" because "max-age" is not supported by IE
				attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

				try {
					result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}

				if (!converter.write) {
					value = encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
				} else {
					value = converter.write(value, key);
				}

				key = encodeURIComponent(String(key));
				key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
				key = key.replace(/[\(\)]/g, escape);

				var stringifiedAttributes = '';

				for (var attributeName in attributes) {
					if (!attributes[attributeName]) {
						continue;
					}
					stringifiedAttributes += '; ' + attributeName;
					if (attributes[attributeName] === true) {
						continue;
					}
					stringifiedAttributes += '=' + attributes[attributeName];
				}
				return (document.cookie = key + '=' + value + stringifiedAttributes);
			}

			// Read

			if (!key) {
				result = {};
			}

			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all. Also prevents odd result when
			// calling "get()"
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var rdecode = /(%[0-9A-Z]{2})+/g;
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = parts[0].replace(rdecode, decodeURIComponent);
					cookie = converter.read ?
						converter.read(cookie, name) : converter(cookie, name) ||
						cookie.replace(rdecode, decodeURIComponent);

					if (this.json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					if (key === name) {
						result = cookie;
						break;
					}

					if (!key) {
						result[name] = cookie;
					}
				} catch (e) {}
			}

			return result;
		}

		api.set = api;
		api.get = function (key) {
			return api.call(api, key);
		};
		api.getJSON = function () {
			return api.apply({
				json: true
			}, [].slice.call(arguments));
		};
		api.defaults = {};

		api.remove = function (key, attributes) {
			api(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),

/***/ 38554:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    asyncTag = '[object AsyncFunction]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    nullTag = '[object Null]',
    objectTag = '[object Object]',
    proxyTag = '[object Proxy]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    undefinedTag = '[object Undefined]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    objectCreate = Object.create,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeMax = Math.max,
    nativeNow = Date.now;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */
var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
  baseMerge(object, source, srcIndex, customizer);
});

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = mergeWith;


/***/ }),

/***/ 18552:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ 1989:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hashClear = __webpack_require__(51789),
    hashDelete = __webpack_require__(80401),
    hashGet = __webpack_require__(57667),
    hashHas = __webpack_require__(21327),
    hashSet = __webpack_require__(81866);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ 38407:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var listCacheClear = __webpack_require__(27040),
    listCacheDelete = __webpack_require__(14125),
    listCacheGet = __webpack_require__(82117),
    listCacheHas = __webpack_require__(67518),
    listCacheSet = __webpack_require__(13399);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ 57071:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ 83369:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(24785),
    mapCacheDelete = __webpack_require__(11285),
    mapCacheGet = __webpack_require__(96000),
    mapCacheHas = __webpack_require__(49916),
    mapCacheSet = __webpack_require__(95265);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ 53818:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ 58525:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ 88668:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(83369),
    setCacheAdd = __webpack_require__(90619),
    setCacheHas = __webpack_require__(72385);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),

/***/ 46384:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(38407),
    stackClear = __webpack_require__(37465),
    stackDelete = __webpack_require__(63779),
    stackGet = __webpack_require__(67599),
    stackHas = __webpack_require__(44758),
    stackSet = __webpack_require__(34309);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ 62705:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 11149:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ 70577:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ 96874:
/***/ (function(module) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),

/***/ 77412:
/***/ (function(module) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),

/***/ 34963:
/***/ (function(module) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ 14636:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTimes = __webpack_require__(22545),
    isArguments = __webpack_require__(35694),
    isArray = __webpack_require__(1469),
    isBuffer = __webpack_require__(44144),
    isIndex = __webpack_require__(65776),
    isTypedArray = __webpack_require__(36719);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ 29932:
/***/ (function(module) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ 62488:
/***/ (function(module) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ 82908:
/***/ (function(module) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),

/***/ 86556:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(89465),
    eq = __webpack_require__(77813);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),

/***/ 34865:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(89465),
    eq = __webpack_require__(77813);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),

/***/ 18470:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(77813);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ 44037:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(98363),
    keys = __webpack_require__(3674);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),

/***/ 63886:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(98363),
    keysIn = __webpack_require__(81704);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),

/***/ 89465:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var defineProperty = __webpack_require__(38777);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),

/***/ 85990:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(46384),
    arrayEach = __webpack_require__(77412),
    assignValue = __webpack_require__(34865),
    baseAssign = __webpack_require__(44037),
    baseAssignIn = __webpack_require__(63886),
    cloneBuffer = __webpack_require__(64626),
    copyArray = __webpack_require__(278),
    copySymbols = __webpack_require__(18805),
    copySymbolsIn = __webpack_require__(1911),
    getAllKeys = __webpack_require__(58234),
    getAllKeysIn = __webpack_require__(46904),
    getTag = __webpack_require__(64160),
    initCloneArray = __webpack_require__(43824),
    initCloneByTag = __webpack_require__(29148),
    initCloneObject = __webpack_require__(38517),
    isArray = __webpack_require__(1469),
    isBuffer = __webpack_require__(44144),
    isMap = __webpack_require__(56688),
    isObject = __webpack_require__(13218),
    isSet = __webpack_require__(72928),
    keys = __webpack_require__(3674),
    keysIn = __webpack_require__(81704);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),

/***/ 3118:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(13218);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),

/***/ 89881:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseForOwn = __webpack_require__(47816),
    createBaseEach = __webpack_require__(99291);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),

/***/ 41848:
/***/ (function(module) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),

/***/ 21078:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(62488),
    isFlattenable = __webpack_require__(37285);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),

/***/ 28483:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createBaseFor = __webpack_require__(25063);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),

/***/ 47816:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFor = __webpack_require__(28483),
    keys = __webpack_require__(3674);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),

/***/ 97786:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(71811),
    toKey = __webpack_require__(40327);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),

/***/ 68866:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(62488),
    isArray = __webpack_require__(1469);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ 44239:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    getRawTag = __webpack_require__(89607),
    objectToString = __webpack_require__(2333);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 13:
/***/ (function(module) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),

/***/ 9454:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ 90939:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(2492),
    isObjectLike = __webpack_require__(37005);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),

/***/ 2492:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(46384),
    equalArrays = __webpack_require__(67114),
    equalByTag = __webpack_require__(18351),
    equalObjects = __webpack_require__(16096),
    getTag = __webpack_require__(64160),
    isArray = __webpack_require__(1469),
    isBuffer = __webpack_require__(44144),
    isTypedArray = __webpack_require__(36719);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),

/***/ 25588:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getTag = __webpack_require__(64160),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),

/***/ 2958:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(46384),
    baseIsEqual = __webpack_require__(90939);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),

/***/ 28458:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(23560),
    isMasked = __webpack_require__(15346),
    isObject = __webpack_require__(13218),
    toSource = __webpack_require__(80346);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ 29221:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getTag = __webpack_require__(64160),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),

/***/ 38749:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isLength = __webpack_require__(41780),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ 67206:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseMatches = __webpack_require__(91573),
    baseMatchesProperty = __webpack_require__(16432),
    identity = __webpack_require__(6557),
    isArray = __webpack_require__(1469),
    property = __webpack_require__(39601);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),

/***/ 280:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototype = __webpack_require__(25726),
    nativeKeys = __webpack_require__(86916);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ 10313:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(13218),
    isPrototype = __webpack_require__(25726),
    nativeKeysIn = __webpack_require__(33498);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),

/***/ 69199:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseEach = __webpack_require__(89881),
    isArrayLike = __webpack_require__(98612);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),

/***/ 91573:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(2958),
    getMatchData = __webpack_require__(1499),
    matchesStrictComparable = __webpack_require__(42634);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),

/***/ 16432:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(90939),
    get = __webpack_require__(27361),
    hasIn = __webpack_require__(79095),
    isKey = __webpack_require__(15403),
    isStrictComparable = __webpack_require__(89162),
    matchesStrictComparable = __webpack_require__(42634),
    toKey = __webpack_require__(40327);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),

/***/ 42980:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(46384),
    assignMergeValue = __webpack_require__(86556),
    baseFor = __webpack_require__(28483),
    baseMergeDeep = __webpack_require__(59783),
    isObject = __webpack_require__(13218),
    keysIn = __webpack_require__(81704),
    safeGet = __webpack_require__(36390);

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),

/***/ 59783:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assignMergeValue = __webpack_require__(86556),
    cloneBuffer = __webpack_require__(64626),
    cloneTypedArray = __webpack_require__(77133),
    copyArray = __webpack_require__(278),
    initCloneObject = __webpack_require__(38517),
    isArguments = __webpack_require__(35694),
    isArray = __webpack_require__(1469),
    isArrayLikeObject = __webpack_require__(29246),
    isBuffer = __webpack_require__(44144),
    isFunction = __webpack_require__(23560),
    isObject = __webpack_require__(13218),
    isPlainObject = __webpack_require__(68630),
    isTypedArray = __webpack_require__(36719),
    safeGet = __webpack_require__(36390),
    toPlainObject = __webpack_require__(59881);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),

/***/ 82689:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayMap = __webpack_require__(29932),
    baseGet = __webpack_require__(97786),
    baseIteratee = __webpack_require__(67206),
    baseMap = __webpack_require__(69199),
    baseSortBy = __webpack_require__(71131),
    baseUnary = __webpack_require__(7518),
    compareMultiple = __webpack_require__(85022),
    identity = __webpack_require__(6557),
    isArray = __webpack_require__(1469);

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = arrayMap(iteratees, function(iteratee) {
      if (isArray(iteratee)) {
        return function(value) {
          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        }
      }
      return iteratee;
    });
  } else {
    iteratees = [identity];
  }

  var index = -1;
  iteratees = arrayMap(iteratees, baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

module.exports = baseOrderBy;


/***/ }),

/***/ 40371:
/***/ (function(module) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),

/***/ 79152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(97786);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),

/***/ 5976:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var identity = __webpack_require__(6557),
    overRest = __webpack_require__(45357),
    setToString = __webpack_require__(30061);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),

/***/ 56560:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var constant = __webpack_require__(75703),
    defineProperty = __webpack_require__(38777),
    identity = __webpack_require__(6557);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),

/***/ 71131:
/***/ (function(module) {

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

module.exports = baseSortBy;


/***/ }),

/***/ 22545:
/***/ (function(module) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ 80531:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    arrayMap = __webpack_require__(29932),
    isArray = __webpack_require__(1469),
    isSymbol = __webpack_require__(33448);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ 27561:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(67990);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ 7518:
/***/ (function(module) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ 74757:
/***/ (function(module) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),

/***/ 71811:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(1469),
    isKey = __webpack_require__(15403),
    stringToPath = __webpack_require__(55514),
    toString = __webpack_require__(79833);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),

/***/ 74318:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Uint8Array = __webpack_require__(11149);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),

/***/ 64626:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(55639);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;


/***/ }),

/***/ 57157:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(74318);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),

/***/ 93147:
/***/ (function(module) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),

/***/ 40419:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),

/***/ 77133:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(74318);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),

/***/ 26393:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSymbol = __webpack_require__(33448);

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

module.exports = compareAscending;


/***/ }),

/***/ 85022:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var compareAscending = __webpack_require__(26393);

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

module.exports = compareMultiple;


/***/ }),

/***/ 278:
/***/ (function(module) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),

/***/ 98363:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assignValue = __webpack_require__(34865),
    baseAssignValue = __webpack_require__(89465);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),

/***/ 18805:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(98363),
    getSymbols = __webpack_require__(99551);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),

/***/ 1911:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(98363),
    getSymbolsIn = __webpack_require__(51442);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),

/***/ 14429:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ 21463:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseRest = __webpack_require__(5976),
    isIterateeCall = __webpack_require__(16612);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),

/***/ 99291:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArrayLike = __webpack_require__(98612);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),

/***/ 25063:
/***/ (function(module) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),

/***/ 67740:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIteratee = __webpack_require__(67206),
    isArrayLike = __webpack_require__(98612),
    keys = __webpack_require__(3674);

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


/***/ }),

/***/ 38777:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),

/***/ 67114:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var SetCache = __webpack_require__(88668),
    arraySome = __webpack_require__(82908),
    cacheHas = __webpack_require__(74757);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),

/***/ 18351:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    Uint8Array = __webpack_require__(11149),
    eq = __webpack_require__(77813),
    equalArrays = __webpack_require__(67114),
    mapToArray = __webpack_require__(68776),
    setToArray = __webpack_require__(21814);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),

/***/ 16096:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getAllKeys = __webpack_require__(58234);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),

/***/ 31957:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


/***/ }),

/***/ 58234:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(68866),
    getSymbols = __webpack_require__(99551),
    keys = __webpack_require__(3674);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ 46904:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(68866),
    getSymbolsIn = __webpack_require__(51442),
    keysIn = __webpack_require__(81704);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),

/***/ 45050:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isKeyable = __webpack_require__(37019);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ 1499:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(89162),
    keys = __webpack_require__(3674);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),

/***/ 10852:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsNative = __webpack_require__(28458),
    getValue = __webpack_require__(47801);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ 85924:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(5569);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),

/***/ 89607:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 99551:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayFilter = __webpack_require__(34963),
    stubArray = __webpack_require__(70479);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ 51442:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(62488),
    getPrototype = __webpack_require__(85924),
    getSymbols = __webpack_require__(99551),
    stubArray = __webpack_require__(70479);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),

/***/ 64160:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DataView = __webpack_require__(18552),
    Map = __webpack_require__(57071),
    Promise = __webpack_require__(53818),
    Set = __webpack_require__(58525),
    WeakMap = __webpack_require__(70577),
    baseGetTag = __webpack_require__(44239),
    toSource = __webpack_require__(80346);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ 47801:
/***/ (function(module) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ 222:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(71811),
    isArguments = __webpack_require__(35694),
    isArray = __webpack_require__(1469),
    isIndex = __webpack_require__(65776),
    isLength = __webpack_require__(41780),
    toKey = __webpack_require__(40327);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),

/***/ 51789:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ 80401:
/***/ (function(module) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ 57667:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ 21327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ 81866:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ 43824:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),

/***/ 29148:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(74318),
    cloneDataView = __webpack_require__(57157),
    cloneRegExp = __webpack_require__(93147),
    cloneSymbol = __webpack_require__(40419),
    cloneTypedArray = __webpack_require__(77133);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),

/***/ 38517:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseCreate = __webpack_require__(3118),
    getPrototype = __webpack_require__(85924),
    isPrototype = __webpack_require__(25726);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),

/***/ 37285:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    isArguments = __webpack_require__(35694),
    isArray = __webpack_require__(1469);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),

/***/ 65776:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ 16612:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(77813),
    isArrayLike = __webpack_require__(98612),
    isIndex = __webpack_require__(65776),
    isObject = __webpack_require__(13218);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),

/***/ 15403:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(1469),
    isSymbol = __webpack_require__(33448);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),

/***/ 37019:
/***/ (function(module) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ 15346:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var coreJsData = __webpack_require__(14429);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ 25726:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ 89162:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(13218);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),

/***/ 27040:
/***/ (function(module) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ 14125:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ 82117:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ 67518:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ 13399:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ 24785:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Hash = __webpack_require__(1989),
    ListCache = __webpack_require__(38407),
    Map = __webpack_require__(57071);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ 11285:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ 96000:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ 49916:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ 95265:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ 68776:
/***/ (function(module) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),

/***/ 42634:
/***/ (function(module) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),

/***/ 24523:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoize = __webpack_require__(88306);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),

/***/ 94536:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ 86916:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(5569);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ 33498:
/***/ (function(module) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),

/***/ 31167:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var freeGlobal = __webpack_require__(31957);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;


/***/ }),

/***/ 2333:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 5569:
/***/ (function(module) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ 45357:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var apply = __webpack_require__(96874);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),

/***/ 55639:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var freeGlobal = __webpack_require__(31957);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 36390:
/***/ (function(module) {

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;


/***/ }),

/***/ 90619:
/***/ (function(module) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),

/***/ 72385:
/***/ (function(module) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),

/***/ 21814:
/***/ (function(module) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),

/***/ 30061:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseSetToString = __webpack_require__(56560),
    shortOut = __webpack_require__(21275);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),

/***/ 21275:
/***/ (function(module) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),

/***/ 37465:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(38407);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ 63779:
/***/ (function(module) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ 67599:
/***/ (function(module) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ 44758:
/***/ (function(module) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ 34309:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(38407),
    Map = __webpack_require__(57071),
    MapCache = __webpack_require__(83369);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ 55514:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(24523);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),

/***/ 40327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSymbol = __webpack_require__(33448);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),

/***/ 80346:
/***/ (function(module) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ 67990:
/***/ (function(module) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ 50361:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseClone = __webpack_require__(85990);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

module.exports = cloneDeep;


/***/ }),

/***/ 75703:
/***/ (function(module) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),

/***/ 23279:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(13218),
    now = __webpack_require__(7771),
    toNumber = __webpack_require__(14841);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ 77813:
/***/ (function(module) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ 13311:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createFind = __webpack_require__(67740),
    findIndex = __webpack_require__(30998);

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

module.exports = find;


/***/ }),

/***/ 30998:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(41848),
    baseIteratee = __webpack_require__(67206),
    toInteger = __webpack_require__(40554);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),

/***/ 27361:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(97786);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),

/***/ 79095:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseHasIn = __webpack_require__(13),
    hasPath = __webpack_require__(222);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),

/***/ 6557:
/***/ (function(module) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ 35694:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(9454),
    isObjectLike = __webpack_require__(37005);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ 1469:
/***/ (function(module) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ 98612:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(23560),
    isLength = __webpack_require__(41780);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ 29246:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArrayLike = __webpack_require__(98612),
    isObjectLike = __webpack_require__(37005);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),

/***/ 44144:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(55639),
    stubFalse = __webpack_require__(95062);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;


/***/ }),

/***/ 23560:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObject = __webpack_require__(13218);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ 41780:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ 56688:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsMap = __webpack_require__(25588),
    baseUnary = __webpack_require__(7518),
    nodeUtil = __webpack_require__(31167);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),

/***/ 14293:
/***/ (function(module) {

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

module.exports = isNil;


/***/ }),

/***/ 13218:
/***/ (function(module) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ 37005:
/***/ (function(module) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 68630:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    getPrototype = __webpack_require__(85924),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),

/***/ 72928:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsSet = __webpack_require__(29221),
    baseUnary = __webpack_require__(7518),
    nodeUtil = __webpack_require__(31167);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),

/***/ 33448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ 36719:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(38749),
    baseUnary = __webpack_require__(7518),
    nodeUtil = __webpack_require__(31167);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ 3674:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(14636),
    baseKeys = __webpack_require__(280),
    isArrayLike = __webpack_require__(98612);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ 81704:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(14636),
    baseKeysIn = __webpack_require__(10313),
    isArrayLike = __webpack_require__(98612);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),

/***/ 88306:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(83369);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),

/***/ 30236:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseMerge = __webpack_require__(42980),
    createAssigner = __webpack_require__(21463);

/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */
var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
  baseMerge(object, source, srcIndex, customizer);
});

module.exports = mergeWith;


/***/ }),

/***/ 7771:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ 39601:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseProperty = __webpack_require__(40371),
    basePropertyDeep = __webpack_require__(79152),
    isKey = __webpack_require__(15403),
    toKey = __webpack_require__(40327);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),

/***/ 89734:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFlatten = __webpack_require__(21078),
    baseOrderBy = __webpack_require__(82689),
    baseRest = __webpack_require__(5976),
    isIterateeCall = __webpack_require__(16612);

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

module.exports = sortBy;


/***/ }),

/***/ 70479:
/***/ (function(module) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ 95062:
/***/ (function(module) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ 18601:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toNumber = __webpack_require__(14841);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),

/***/ 40554:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toFinite = __webpack_require__(18601);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),

/***/ 14841:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTrim = __webpack_require__(27561),
    isObject = __webpack_require__(13218),
    isSymbol = __webpack_require__(33448);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 59881:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(98363),
    keysIn = __webpack_require__(81704);

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),

/***/ 79833:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseToString = __webpack_require__(80531);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ 42555:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var shorterNames = __webpack_require__(62178);
var REGEX = {
  whitespace: /\s+/g,
  urlHexPairs: /%[\dA-F]{2}/g,
  quotes: /"/g,
}

function collapseWhitespace(str) {
  return str.trim().replace(REGEX.whitespace, ' ');
}

function dataURIPayload(string) {
  return encodeURIComponent(string)
    .replace(REGEX.urlHexPairs, specialHexEncode);
}

// `#` gets converted to `%23`, so quite a few CSS named colors are shorter than
// their equivalent URL-encoded hex codes.
function colorCodeToShorterNames(string) {
  Object.keys(shorterNames).forEach(function(key) {
    if (shorterNames[key].test(string)) {
      string = string.replace(shorterNames[key], key);
    }
  });

  return string;
}

function specialHexEncode(match) {
  switch (match) { // Browsers tolerate these characters, and they're frequent
    case '%20': return ' ';
    case '%3D': return '=';
    case '%3A': return ':';
    case '%2F': return '/';
    default: return match.toLowerCase(); // compresses better
  }
}

function svgToTinyDataUri(svgString) {
  if (typeof svgString !== 'string') {
    throw new TypeError('Expected a string, but received ' + typeof svgString);
  }
  // Strip the Byte-Order Mark if the SVG has one
  if (svgString.charCodeAt(0) === 0xfeff) { svgString = svgString.slice(1) }

  var body = colorCodeToShorterNames(collapseWhitespace(svgString))
    .replace(REGEX.quotes, "'");
  return 'data:image/svg+xml,' + dataURIPayload(body);
}

svgToTinyDataUri.toSrcset = function toSrcset(svgString) {
  return svgToTinyDataUri(svgString).replace(/ /g, '%20');
}

module.exports = svgToTinyDataUri;


/***/ }),

/***/ 62178:
/***/ (function(module) {

module.exports = {
  aqua: /#00ffff(ff)?(?!\w)|#0ff(f)?(?!\w)/gi,
  azure: /#f0ffff(ff)?(?!\w)/gi,
  beige: /#f5f5dc(ff)?(?!\w)/gi,
  bisque: /#ffe4c4(ff)?(?!\w)/gi,
  black: /#000000(ff)?(?!\w)|#000(f)?(?!\w)/gi,
  blue: /#0000ff(ff)?(?!\w)|#00f(f)?(?!\w)/gi,
  brown: /#a52a2a(ff)?(?!\w)/gi,
  coral: /#ff7f50(ff)?(?!\w)/gi,
  cornsilk: /#fff8dc(ff)?(?!\w)/gi,
  crimson: /#dc143c(ff)?(?!\w)/gi,
  cyan: /#00ffff(ff)?(?!\w)|#0ff(f)?(?!\w)/gi,
  darkblue: /#00008b(ff)?(?!\w)/gi,
  darkcyan: /#008b8b(ff)?(?!\w)/gi,
  darkgrey: /#a9a9a9(ff)?(?!\w)/gi,
  darkred: /#8b0000(ff)?(?!\w)/gi,
  deeppink: /#ff1493(ff)?(?!\w)/gi,
  dimgrey: /#696969(ff)?(?!\w)/gi,
  gold: /#ffd700(ff)?(?!\w)/gi,
  green: /#008000(ff)?(?!\w)/gi,
  grey: /#808080(ff)?(?!\w)/gi,
  honeydew: /#f0fff0(ff)?(?!\w)/gi,
  hotpink: /#ff69b4(ff)?(?!\w)/gi,
  indigo: /#4b0082(ff)?(?!\w)/gi,
  ivory: /#fffff0(ff)?(?!\w)/gi,
  khaki: /#f0e68c(ff)?(?!\w)/gi,
  lavender: /#e6e6fa(ff)?(?!\w)/gi,
  lime: /#00ff00(ff)?(?!\w)|#0f0(f)?(?!\w)/gi,
  linen: /#faf0e6(ff)?(?!\w)/gi,
  maroon: /#800000(ff)?(?!\w)/gi,
  moccasin: /#ffe4b5(ff)?(?!\w)/gi,
  navy: /#000080(ff)?(?!\w)/gi,
  oldlace: /#fdf5e6(ff)?(?!\w)/gi,
  olive: /#808000(ff)?(?!\w)/gi,
  orange: /#ffa500(ff)?(?!\w)/gi,
  orchid: /#da70d6(ff)?(?!\w)/gi,
  peru: /#cd853f(ff)?(?!\w)/gi,
  pink: /#ffc0cb(ff)?(?!\w)/gi,
  plum: /#dda0dd(ff)?(?!\w)/gi,
  purple: /#800080(ff)?(?!\w)/gi,
  red: /#ff0000(ff)?(?!\w)|#f00(f)?(?!\w)/gi,
  salmon: /#fa8072(ff)?(?!\w)/gi,
  seagreen: /#2e8b57(ff)?(?!\w)/gi,
  seashell: /#fff5ee(ff)?(?!\w)/gi,
  sienna: /#a0522d(ff)?(?!\w)/gi,
  silver: /#c0c0c0(ff)?(?!\w)/gi,
  skyblue: /#87ceeb(ff)?(?!\w)/gi,
  snow: /#fffafa(ff)?(?!\w)/gi,
  tan: /#d2b48c(ff)?(?!\w)/gi,
  teal: /#008080(ff)?(?!\w)/gi,
  thistle: /#d8bfd8(ff)?(?!\w)/gi,
  tomato: /#ff6347(ff)?(?!\w)/gi,
  violet: /#ee82ee(ff)?(?!\w)/gi,
  wheat: /#f5deb3(ff)?(?!\w)/gi,
  white: /#ffffff(ff)?(?!\w)|#fff(f)?(?!\w)/gi,
};


/***/ }),

/***/ 30381:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    0
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i,
            arrLen = arr.length;
        for (i = 0; i < arrLen; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i,
            prop,
            val,
            momentPropertiesLen = momentProperties.length;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentPropertiesLen > 0) {
            for (i = 0; i < momentPropertiesLen; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key,
                    argLen = arguments.length;
                for (i = 0; i < argLen; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens =
            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i,
                prioritizedLen = prioritized.length;
            for (i = 0; i < prioritizedLen; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord =
            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(
                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
                    function (matched, p1, p2, p3, p4) {
                        return p1 || p2 || p3 || p4;
                    }
                )
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback,
            tokenLen;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        tokenLen = token.length;
        for (i = 0; i < tokenLen; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths =
            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                '_'
            ),
        defaultLocaleMonthsShort =
            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(
        ['w', 'ww', 'W', 'WW'],
        function (input, week, config, token) {
            week[token.substr(0, 1)] = toInt(input);
        }
    );

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays =
            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        return name.match('^[^/\\\\]*$') != null;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            "object" !== 'undefined' &&
            module &&
            module.exports &&
            isLocaleNameSane(name)
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = undefined;
                Object(function webpackMissingModule() { var e = new Error("Cannot find module 'undefined'"); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 =
            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat,
            isoDatesLen = isoDates.length,
            isoTimesLen = isoTimes.length;

        if (match) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDatesLen; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimesLen; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^()]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era,
            tokenLen;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for (i = 0; i < tokenLen; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false,
            configfLen = config._f.length;

        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < configfLen; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i,
            orderLen = ordering.length;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < orderLen; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex =
            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property,
            propertyLen = properties.length;

        for (i = 0; i < propertyLen; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(
        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
        function (input, array, config, token) {
            var era = config._locale.erasParse(input, token, config._strict);
            if (era) {
                getParsingFlags(config).era = era;
            } else {
                getParsingFlags(config).invalidEra = input;
            }
        }
    );

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(
        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
        function (input, week, config, token) {
            week[token.substr(0, 2)] = toInt(input);
        }
    );

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.29.4';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));


/***/ }),

/***/ 7544:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(45794)


/***/ }),

/***/ 6840:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(71211);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 74562:
/***/ (function() {

"use strict";
var _sentryCollisionFreeGlobalObject =  true ? window : 0;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {
    "id": "cosmos@879c6580639e7f22400a3c8abc6bab77b69cfdb5"
};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";



/***/ }),

/***/ 46329:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AJ": function() { return /* binding */ MarketplacePropertyCategory_ReactionEventReaction; },
/* harmony export */   "SG": function() { return /* binding */ MarketplacePropertyCategory; }
/* harmony export */ });
/* unused harmony exports protobufPackage, marketplacePropertyCategory_ReactionEventReactionFromJSON, marketplacePropertyCategory_ReactionEventReactionToJSON, MarketplacePropertyCategory_DetailPageViewEvent, MarketplacePropertyCategory_SimilarHomesClickEvent, MarketplacePropertyCategory_TourBookingStartEvent, MarketplacePropertyCategory_ReactionEvent, MarketplacePropertyCategory_OfferStartEvent, MarketplacePropertyCategory_ShareEvent, MarketplacePropertyCategory_RentalScamBannerViewEvent, MarketplacePropertyCategory_RentalScamBannerLearnMoreEvent */
/* eslint-disable */ var protobufPackage = "od_protos.journey.data.categories";
var MarketplacePropertyCategory_ReactionEventReaction;
(function(MarketplacePropertyCategory_ReactionEventReaction) {
    MarketplacePropertyCategory_ReactionEventReaction[MarketplacePropertyCategory_ReactionEventReaction["REACTION_UNSPECIFIED"] = 0] = "REACTION_UNSPECIFIED";
    MarketplacePropertyCategory_ReactionEventReaction[MarketplacePropertyCategory_ReactionEventReaction["REACTION_ADD_LIKE"] = 1] = "REACTION_ADD_LIKE";
    MarketplacePropertyCategory_ReactionEventReaction[MarketplacePropertyCategory_ReactionEventReaction["REACTION_REMOVE_LIKE"] = 2] = "REACTION_REMOVE_LIKE";
    MarketplacePropertyCategory_ReactionEventReaction[MarketplacePropertyCategory_ReactionEventReaction["REACTION_ADD_DISLIKE"] = 3] = "REACTION_ADD_DISLIKE";
    MarketplacePropertyCategory_ReactionEventReaction[MarketplacePropertyCategory_ReactionEventReaction["REACTION_REMOVE_DISLIKE"] = 4] = "REACTION_REMOVE_DISLIKE";
    MarketplacePropertyCategory_ReactionEventReaction[MarketplacePropertyCategory_ReactionEventReaction["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(MarketplacePropertyCategory_ReactionEventReaction || (MarketplacePropertyCategory_ReactionEventReaction = {}));
function marketplacePropertyCategory_ReactionEventReactionFromJSON(object) {
    switch(object){
        case 0:
        case "REACTION_UNSPECIFIED":
            return MarketplacePropertyCategory_ReactionEventReaction.REACTION_UNSPECIFIED;
        case 1:
        case "REACTION_ADD_LIKE":
            return MarketplacePropertyCategory_ReactionEventReaction.REACTION_ADD_LIKE;
        case 2:
        case "REACTION_REMOVE_LIKE":
            return MarketplacePropertyCategory_ReactionEventReaction.REACTION_REMOVE_LIKE;
        case 3:
        case "REACTION_ADD_DISLIKE":
            return MarketplacePropertyCategory_ReactionEventReaction.REACTION_ADD_DISLIKE;
        case 4:
        case "REACTION_REMOVE_DISLIKE":
            return MarketplacePropertyCategory_ReactionEventReaction.REACTION_REMOVE_DISLIKE;
        case -1:
        case "UNRECOGNIZED":
        default:
            return MarketplacePropertyCategory_ReactionEventReaction.UNRECOGNIZED;
    }
}
function marketplacePropertyCategory_ReactionEventReactionToJSON(object) {
    switch(object){
        case MarketplacePropertyCategory_ReactionEventReaction.REACTION_UNSPECIFIED:
            return "REACTION_UNSPECIFIED";
        case MarketplacePropertyCategory_ReactionEventReaction.REACTION_ADD_LIKE:
            return "REACTION_ADD_LIKE";
        case MarketplacePropertyCategory_ReactionEventReaction.REACTION_REMOVE_LIKE:
            return "REACTION_REMOVE_LIKE";
        case MarketplacePropertyCategory_ReactionEventReaction.REACTION_ADD_DISLIKE:
            return "REACTION_ADD_DISLIKE";
        case MarketplacePropertyCategory_ReactionEventReaction.REACTION_REMOVE_DISLIKE:
            return "REACTION_REMOVE_DISLIKE";
        case MarketplacePropertyCategory_ReactionEventReaction.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
function createBaseMarketplacePropertyCategory() {
    return {
        event: undefined
    };
}
var MarketplacePropertyCategory = {
    fromJSON: function fromJSON(object) {
        return {
            event: isSet(object.detailPageView) ? {
                $case: "detailPageView",
                detailPageView: MarketplacePropertyCategory_DetailPageViewEvent.fromJSON(object.detailPageView)
            } : isSet(object.similarHomesClick) ? {
                $case: "similarHomesClick",
                similarHomesClick: MarketplacePropertyCategory_SimilarHomesClickEvent.fromJSON(object.similarHomesClick)
            } : isSet(object.tourBookingStart) ? {
                $case: "tourBookingStart",
                tourBookingStart: MarketplacePropertyCategory_TourBookingStartEvent.fromJSON(object.tourBookingStart)
            } : isSet(object.reaction) ? {
                $case: "reaction",
                reaction: MarketplacePropertyCategory_ReactionEvent.fromJSON(object.reaction)
            } : isSet(object.offerStart) ? {
                $case: "offerStart",
                offerStart: MarketplacePropertyCategory_OfferStartEvent.fromJSON(object.offerStart)
            } : isSet(object.share) ? {
                $case: "share",
                share: MarketplacePropertyCategory_ShareEvent.fromJSON(object.share)
            } : isSet(object.rentalScamBannerView) ? {
                $case: "rentalScamBannerView",
                rentalScamBannerView: MarketplacePropertyCategory_RentalScamBannerViewEvent.fromJSON(object.rentalScamBannerView)
            } : isSet(object.rentalScamBannerLearnMore) ? {
                $case: "rentalScamBannerLearnMore",
                rentalScamBannerLearnMore: MarketplacePropertyCategory_RentalScamBannerLearnMoreEvent.fromJSON(object.rentalScamBannerLearnMore)
            } : undefined
        };
    },
    toJSON: function toJSON(message) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
        var obj = {};
        if (((ref = message.event) === null || ref === void 0 ? void 0 : ref.$case) === "detailPageView") {
            obj.detailPageView = MarketplacePropertyCategory_DetailPageViewEvent.toJSON(message.event.detailPageView);
        }
        if (((ref1 = message.event) === null || ref1 === void 0 ? void 0 : ref1.$case) === "similarHomesClick") {
            obj.similarHomesClick = MarketplacePropertyCategory_SimilarHomesClickEvent.toJSON(message.event.similarHomesClick);
        }
        if (((ref2 = message.event) === null || ref2 === void 0 ? void 0 : ref2.$case) === "tourBookingStart") {
            obj.tourBookingStart = MarketplacePropertyCategory_TourBookingStartEvent.toJSON(message.event.tourBookingStart);
        }
        if (((ref3 = message.event) === null || ref3 === void 0 ? void 0 : ref3.$case) === "reaction") {
            obj.reaction = MarketplacePropertyCategory_ReactionEvent.toJSON(message.event.reaction);
        }
        if (((ref4 = message.event) === null || ref4 === void 0 ? void 0 : ref4.$case) === "offerStart") {
            obj.offerStart = MarketplacePropertyCategory_OfferStartEvent.toJSON(message.event.offerStart);
        }
        if (((ref5 = message.event) === null || ref5 === void 0 ? void 0 : ref5.$case) === "share") {
            obj.share = MarketplacePropertyCategory_ShareEvent.toJSON(message.event.share);
        }
        if (((ref6 = message.event) === null || ref6 === void 0 ? void 0 : ref6.$case) === "rentalScamBannerView") {
            obj.rentalScamBannerView = MarketplacePropertyCategory_RentalScamBannerViewEvent.toJSON(message.event.rentalScamBannerView);
        }
        if (((ref7 = message.event) === null || ref7 === void 0 ? void 0 : ref7.$case) === "rentalScamBannerLearnMore") {
            obj.rentalScamBannerLearnMore = MarketplacePropertyCategory_RentalScamBannerLearnMoreEvent.toJSON(message.event.rentalScamBannerLearnMore);
        }
        return obj;
    },
    create: function create(base) {
        return MarketplacePropertyCategory.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23;
        var message = createBaseMarketplacePropertyCategory();
        if (((ref = object.event) === null || ref === void 0 ? void 0 : ref.$case) === "detailPageView" && ((ref1 = object.event) === null || ref1 === void 0 ? void 0 : ref1.detailPageView) !== undefined && ((ref2 = object.event) === null || ref2 === void 0 ? void 0 : ref2.detailPageView) !== null) {
            message.event = {
                $case: "detailPageView",
                detailPageView: MarketplacePropertyCategory_DetailPageViewEvent.fromPartial(object.event.detailPageView)
            };
        }
        if (((ref3 = object.event) === null || ref3 === void 0 ? void 0 : ref3.$case) === "similarHomesClick" && ((ref4 = object.event) === null || ref4 === void 0 ? void 0 : ref4.similarHomesClick) !== undefined && ((ref5 = object.event) === null || ref5 === void 0 ? void 0 : ref5.similarHomesClick) !== null) {
            message.event = {
                $case: "similarHomesClick",
                similarHomesClick: MarketplacePropertyCategory_SimilarHomesClickEvent.fromPartial(object.event.similarHomesClick)
            };
        }
        if (((ref6 = object.event) === null || ref6 === void 0 ? void 0 : ref6.$case) === "tourBookingStart" && ((ref7 = object.event) === null || ref7 === void 0 ? void 0 : ref7.tourBookingStart) !== undefined && ((ref8 = object.event) === null || ref8 === void 0 ? void 0 : ref8.tourBookingStart) !== null) {
            message.event = {
                $case: "tourBookingStart",
                tourBookingStart: MarketplacePropertyCategory_TourBookingStartEvent.fromPartial(object.event.tourBookingStart)
            };
        }
        if (((ref9 = object.event) === null || ref9 === void 0 ? void 0 : ref9.$case) === "reaction" && ((ref10 = object.event) === null || ref10 === void 0 ? void 0 : ref10.reaction) !== undefined && ((ref11 = object.event) === null || ref11 === void 0 ? void 0 : ref11.reaction) !== null) {
            message.event = {
                $case: "reaction",
                reaction: MarketplacePropertyCategory_ReactionEvent.fromPartial(object.event.reaction)
            };
        }
        if (((ref12 = object.event) === null || ref12 === void 0 ? void 0 : ref12.$case) === "offerStart" && ((ref13 = object.event) === null || ref13 === void 0 ? void 0 : ref13.offerStart) !== undefined && ((ref14 = object.event) === null || ref14 === void 0 ? void 0 : ref14.offerStart) !== null) {
            message.event = {
                $case: "offerStart",
                offerStart: MarketplacePropertyCategory_OfferStartEvent.fromPartial(object.event.offerStart)
            };
        }
        if (((ref15 = object.event) === null || ref15 === void 0 ? void 0 : ref15.$case) === "share" && ((ref16 = object.event) === null || ref16 === void 0 ? void 0 : ref16.share) !== undefined && ((ref17 = object.event) === null || ref17 === void 0 ? void 0 : ref17.share) !== null) {
            message.event = {
                $case: "share",
                share: MarketplacePropertyCategory_ShareEvent.fromPartial(object.event.share)
            };
        }
        if (((ref18 = object.event) === null || ref18 === void 0 ? void 0 : ref18.$case) === "rentalScamBannerView" && ((ref19 = object.event) === null || ref19 === void 0 ? void 0 : ref19.rentalScamBannerView) !== undefined && ((ref20 = object.event) === null || ref20 === void 0 ? void 0 : ref20.rentalScamBannerView) !== null) {
            message.event = {
                $case: "rentalScamBannerView",
                rentalScamBannerView: MarketplacePropertyCategory_RentalScamBannerViewEvent.fromPartial(object.event.rentalScamBannerView)
            };
        }
        if (((ref21 = object.event) === null || ref21 === void 0 ? void 0 : ref21.$case) === "rentalScamBannerLearnMore" && ((ref22 = object.event) === null || ref22 === void 0 ? void 0 : ref22.rentalScamBannerLearnMore) !== undefined && ((ref23 = object.event) === null || ref23 === void 0 ? void 0 : ref23.rentalScamBannerLearnMore) !== null) {
            message.event = {
                $case: "rentalScamBannerLearnMore",
                rentalScamBannerLearnMore: MarketplacePropertyCategory_RentalScamBannerLearnMoreEvent.fromPartial(object.event.rentalScamBannerLearnMore)
            };
        }
        return message;
    }
};
function createBaseMarketplacePropertyCategory_DetailPageViewEvent() {
    return {
        addressUuid: ""
    };
}
var MarketplacePropertyCategory_DetailPageViewEvent = {
    fromJSON: function fromJSON(object) {
        return {
            addressUuid: isSet(object.addressUuid) ? String(object.addressUuid) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.addressUuid !== "") {
            obj.addressUuid = message.addressUuid;
        }
        return obj;
    },
    create: function create(base) {
        return MarketplacePropertyCategory_DetailPageViewEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseMarketplacePropertyCategory_DetailPageViewEvent();
        var _addressUuid;
        message.addressUuid = (_addressUuid = object.addressUuid) !== null && _addressUuid !== void 0 ? _addressUuid : "";
        return message;
    }
};
function createBaseMarketplacePropertyCategory_SimilarHomesClickEvent() {
    return {
        addressUuid: "",
        clickedAddressUuid: ""
    };
}
var MarketplacePropertyCategory_SimilarHomesClickEvent = {
    fromJSON: function fromJSON(object) {
        return {
            addressUuid: isSet(object.addressUuid) ? String(object.addressUuid) : "",
            clickedAddressUuid: isSet(object.clickedAddressUuid) ? String(object.clickedAddressUuid) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.addressUuid !== "") {
            obj.addressUuid = message.addressUuid;
        }
        if (message.clickedAddressUuid !== "") {
            obj.clickedAddressUuid = message.clickedAddressUuid;
        }
        return obj;
    },
    create: function create(base) {
        return MarketplacePropertyCategory_SimilarHomesClickEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseMarketplacePropertyCategory_SimilarHomesClickEvent();
        var _addressUuid;
        message.addressUuid = (_addressUuid = object.addressUuid) !== null && _addressUuid !== void 0 ? _addressUuid : "";
        var _clickedAddressUuid;
        message.clickedAddressUuid = (_clickedAddressUuid = object.clickedAddressUuid) !== null && _clickedAddressUuid !== void 0 ? _clickedAddressUuid : "";
        return message;
    }
};
function createBaseMarketplacePropertyCategory_TourBookingStartEvent() {
    return {
        addressUuid: "",
        placement: ""
    };
}
var MarketplacePropertyCategory_TourBookingStartEvent = {
    fromJSON: function fromJSON(object) {
        return {
            addressUuid: isSet(object.addressUuid) ? String(object.addressUuid) : "",
            placement: isSet(object.placement) ? String(object.placement) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.addressUuid !== "") {
            obj.addressUuid = message.addressUuid;
        }
        if (message.placement !== "") {
            obj.placement = message.placement;
        }
        return obj;
    },
    create: function create(base) {
        return MarketplacePropertyCategory_TourBookingStartEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseMarketplacePropertyCategory_TourBookingStartEvent();
        var _addressUuid;
        message.addressUuid = (_addressUuid = object.addressUuid) !== null && _addressUuid !== void 0 ? _addressUuid : "";
        var _placement;
        message.placement = (_placement = object.placement) !== null && _placement !== void 0 ? _placement : "";
        return message;
    }
};
function createBaseMarketplacePropertyCategory_ReactionEvent() {
    return {
        addressUuid: "",
        source: "",
        reaction: 0
    };
}
var MarketplacePropertyCategory_ReactionEvent = {
    fromJSON: function fromJSON(object) {
        return {
            addressUuid: isSet(object.addressUuid) ? String(object.addressUuid) : "",
            source: isSet(object.source) ? String(object.source) : "",
            reaction: isSet(object.reaction) ? marketplacePropertyCategory_ReactionEventReactionFromJSON(object.reaction) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.addressUuid !== "") {
            obj.addressUuid = message.addressUuid;
        }
        if (message.source !== "") {
            obj.source = message.source;
        }
        if (message.reaction !== 0) {
            obj.reaction = marketplacePropertyCategory_ReactionEventReactionToJSON(message.reaction);
        }
        return obj;
    },
    create: function create(base) {
        return MarketplacePropertyCategory_ReactionEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseMarketplacePropertyCategory_ReactionEvent();
        var _addressUuid;
        message.addressUuid = (_addressUuid = object.addressUuid) !== null && _addressUuid !== void 0 ? _addressUuid : "";
        var _source;
        message.source = (_source = object.source) !== null && _source !== void 0 ? _source : "";
        var _reaction;
        message.reaction = (_reaction = object.reaction) !== null && _reaction !== void 0 ? _reaction : 0;
        return message;
    }
};
function createBaseMarketplacePropertyCategory_OfferStartEvent() {
    return {
        addressUuid: "",
        source: ""
    };
}
var MarketplacePropertyCategory_OfferStartEvent = {
    fromJSON: function fromJSON(object) {
        return {
            addressUuid: isSet(object.addressUuid) ? String(object.addressUuid) : "",
            source: isSet(object.source) ? String(object.source) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.addressUuid !== "") {
            obj.addressUuid = message.addressUuid;
        }
        if (message.source !== "") {
            obj.source = message.source;
        }
        return obj;
    },
    create: function create(base) {
        return MarketplacePropertyCategory_OfferStartEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseMarketplacePropertyCategory_OfferStartEvent();
        var _addressUuid;
        message.addressUuid = (_addressUuid = object.addressUuid) !== null && _addressUuid !== void 0 ? _addressUuid : "";
        var _source;
        message.source = (_source = object.source) !== null && _source !== void 0 ? _source : "";
        return message;
    }
};
function createBaseMarketplacePropertyCategory_ShareEvent() {
    return {
        addressUuid: "",
        source: ""
    };
}
var MarketplacePropertyCategory_ShareEvent = {
    fromJSON: function fromJSON(object) {
        return {
            addressUuid: isSet(object.addressUuid) ? String(object.addressUuid) : "",
            source: isSet(object.source) ? String(object.source) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.addressUuid !== "") {
            obj.addressUuid = message.addressUuid;
        }
        if (message.source !== "") {
            obj.source = message.source;
        }
        return obj;
    },
    create: function create(base) {
        return MarketplacePropertyCategory_ShareEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseMarketplacePropertyCategory_ShareEvent();
        var _addressUuid;
        message.addressUuid = (_addressUuid = object.addressUuid) !== null && _addressUuid !== void 0 ? _addressUuid : "";
        var _source;
        message.source = (_source = object.source) !== null && _source !== void 0 ? _source : "";
        return message;
    }
};
function createBaseMarketplacePropertyCategory_RentalScamBannerViewEvent() {
    return {
        addressUuid: ""
    };
}
var MarketplacePropertyCategory_RentalScamBannerViewEvent = {
    fromJSON: function fromJSON(object) {
        return {
            addressUuid: isSet(object.addressUuid) ? String(object.addressUuid) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.addressUuid !== "") {
            obj.addressUuid = message.addressUuid;
        }
        return obj;
    },
    create: function create(base) {
        return MarketplacePropertyCategory_RentalScamBannerViewEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseMarketplacePropertyCategory_RentalScamBannerViewEvent();
        var _addressUuid;
        message.addressUuid = (_addressUuid = object.addressUuid) !== null && _addressUuid !== void 0 ? _addressUuid : "";
        return message;
    }
};
function createBaseMarketplacePropertyCategory_RentalScamBannerLearnMoreEvent() {
    return {
        addressUuid: ""
    };
}
var MarketplacePropertyCategory_RentalScamBannerLearnMoreEvent = {
    fromJSON: function fromJSON(object) {
        return {
            addressUuid: isSet(object.addressUuid) ? String(object.addressUuid) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.addressUuid !== "") {
            obj.addressUuid = message.addressUuid;
        }
        return obj;
    },
    create: function create(base) {
        return MarketplacePropertyCategory_RentalScamBannerLearnMoreEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseMarketplacePropertyCategory_RentalScamBannerLearnMoreEvent();
        var _addressUuid;
        message.addressUuid = (_addressUuid = object.addressUuid) !== null && _addressUuid !== void 0 ? _addressUuid : "";
        return message;
    }
};
function isSet(value) {
    return value !== null && value !== undefined;
}


/***/ }),

/***/ 79800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ru": function() { return /* binding */ retailWebUnlockCategory_ListingValidationFailureFlavorFromJSON; },
/* harmony export */   "Tt": function() { return /* binding */ RetailWebUnlockCategory_IDVerificationActions; },
/* harmony export */   "Xq": function() { return /* binding */ retailWebUnlockCategory_UnlockFailureFlavorFromJSON; },
/* harmony export */   "Yz": function() { return /* binding */ RetailWebUnlockCategory_StepType; },
/* harmony export */   "cR": function() { return /* binding */ RetailWebUnlockCategory_UnlockFailureFlavor; },
/* harmony export */   "kv": function() { return /* binding */ RetailWebUnlockCategory; },
/* harmony export */   "yo": function() { return /* binding */ RetailWebUnlockCategory_IDVerificationFailureFlavor; }
/* harmony export */ });
/* unused harmony exports protobufPackage, retailWebUnlockCategory_StepTypeFromJSON, retailWebUnlockCategory_StepTypeToJSON, RetailWebUnlockCategory_ListingValidationFailureFlavor, retailWebUnlockCategory_ListingValidationFailureFlavorToJSON, retailWebUnlockCategory_IDVerificationActionsFromJSON, retailWebUnlockCategory_IDVerificationActionsToJSON, retailWebUnlockCategory_IDVerificationFailureFlavorFromJSON, retailWebUnlockCategory_IDVerificationFailureFlavorToJSON, retailWebUnlockCategory_UnlockFailureFlavorToJSON, RetailWebUnlockCategory_ViewEvent, RetailWebUnlockCategory_LocationPermissionEvent, RetailWebUnlockCategory_ContactUsEvent, RetailWebUnlockCategory_PropertyStatusEvent, RetailWebUnlockCategory_IDVerificationEvent, RetailWebUnlockCategory_IDVerificationSubmissionEvent, RetailWebUnlockCategory_UnlockAttemptEvent, RetailWebUnlockCategory_GeneralErrorEvent */
/* eslint-disable */ var protobufPackage = "od_protos.journey.data.categories";
var RetailWebUnlockCategory_StepType;
(function(RetailWebUnlockCategory_StepType) {
    RetailWebUnlockCategory_StepType[RetailWebUnlockCategory_StepType["UNKNOWN_STEP"] = 0] = "UNKNOWN_STEP";
    RetailWebUnlockCategory_StepType[RetailWebUnlockCategory_StepType["PROPERTY_CONFIRMATION_STEPS"] = 1] = "PROPERTY_CONFIRMATION_STEPS";
    RetailWebUnlockCategory_StepType[RetailWebUnlockCategory_StepType["ONBOARDING_STEPS"] = 2] = "ONBOARDING_STEPS";
    RetailWebUnlockCategory_StepType[RetailWebUnlockCategory_StepType["ID_VERIFICATION_STEPS"] = 3] = "ID_VERIFICATION_STEPS";
    RetailWebUnlockCategory_StepType[RetailWebUnlockCategory_StepType["UNLOCK_HOME_STEPS"] = 4] = "UNLOCK_HOME_STEPS";
    RetailWebUnlockCategory_StepType[RetailWebUnlockCategory_StepType["GENERAL_ERROR"] = 5] = "GENERAL_ERROR";
    RetailWebUnlockCategory_StepType[RetailWebUnlockCategory_StepType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(RetailWebUnlockCategory_StepType || (RetailWebUnlockCategory_StepType = {}));
function retailWebUnlockCategory_StepTypeFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN_STEP":
            return RetailWebUnlockCategory_StepType.UNKNOWN_STEP;
        case 1:
        case "PROPERTY_CONFIRMATION_STEPS":
            return RetailWebUnlockCategory_StepType.PROPERTY_CONFIRMATION_STEPS;
        case 2:
        case "ONBOARDING_STEPS":
            return RetailWebUnlockCategory_StepType.ONBOARDING_STEPS;
        case 3:
        case "ID_VERIFICATION_STEPS":
            return RetailWebUnlockCategory_StepType.ID_VERIFICATION_STEPS;
        case 4:
        case "UNLOCK_HOME_STEPS":
            return RetailWebUnlockCategory_StepType.UNLOCK_HOME_STEPS;
        case 5:
        case "GENERAL_ERROR":
            return RetailWebUnlockCategory_StepType.GENERAL_ERROR;
        case -1:
        case "UNRECOGNIZED":
        default:
            return RetailWebUnlockCategory_StepType.UNRECOGNIZED;
    }
}
function retailWebUnlockCategory_StepTypeToJSON(object) {
    switch(object){
        case RetailWebUnlockCategory_StepType.UNKNOWN_STEP:
            return "UNKNOWN_STEP";
        case RetailWebUnlockCategory_StepType.PROPERTY_CONFIRMATION_STEPS:
            return "PROPERTY_CONFIRMATION_STEPS";
        case RetailWebUnlockCategory_StepType.ONBOARDING_STEPS:
            return "ONBOARDING_STEPS";
        case RetailWebUnlockCategory_StepType.ID_VERIFICATION_STEPS:
            return "ID_VERIFICATION_STEPS";
        case RetailWebUnlockCategory_StepType.UNLOCK_HOME_STEPS:
            return "UNLOCK_HOME_STEPS";
        case RetailWebUnlockCategory_StepType.GENERAL_ERROR:
            return "GENERAL_ERROR";
        case RetailWebUnlockCategory_StepType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var RetailWebUnlockCategory_ListingValidationFailureFlavor;
(function(RetailWebUnlockCategory_ListingValidationFailureFlavor) {
    RetailWebUnlockCategory_ListingValidationFailureFlavor[RetailWebUnlockCategory_ListingValidationFailureFlavor["UNKNOWN_LISTING_FAILURE"] = 0] = "UNKNOWN_LISTING_FAILURE";
    RetailWebUnlockCategory_ListingValidationFailureFlavor[RetailWebUnlockCategory_ListingValidationFailureFlavor["TEMPORARILY_OFF_MARKET"] = 1] = "TEMPORARILY_OFF_MARKET";
    RetailWebUnlockCategory_ListingValidationFailureFlavor[RetailWebUnlockCategory_ListingValidationFailureFlavor["TRADITIONAL_LISTING"] = 2] = "TRADITIONAL_LISTING";
    RetailWebUnlockCategory_ListingValidationFailureFlavor[RetailWebUnlockCategory_ListingValidationFailureFlavor["AFTER_HOURS_TOURING"] = 3] = "AFTER_HOURS_TOURING";
    RetailWebUnlockCategory_ListingValidationFailureFlavor[RetailWebUnlockCategory_ListingValidationFailureFlavor["HOME_UNDER_CONTRACT"] = 4] = "HOME_UNDER_CONTRACT";
    RetailWebUnlockCategory_ListingValidationFailureFlavor[RetailWebUnlockCategory_ListingValidationFailureFlavor["HOME_SOLD"] = 5] = "HOME_SOLD";
    RetailWebUnlockCategory_ListingValidationFailureFlavor[RetailWebUnlockCategory_ListingValidationFailureFlavor["PPM"] = 6] = "PPM";
    RetailWebUnlockCategory_ListingValidationFailureFlavor[RetailWebUnlockCategory_ListingValidationFailureFlavor["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(RetailWebUnlockCategory_ListingValidationFailureFlavor || (RetailWebUnlockCategory_ListingValidationFailureFlavor = {}));
function retailWebUnlockCategory_ListingValidationFailureFlavorFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN_LISTING_FAILURE":
            return RetailWebUnlockCategory_ListingValidationFailureFlavor.UNKNOWN_LISTING_FAILURE;
        case 1:
        case "TEMPORARILY_OFF_MARKET":
            return RetailWebUnlockCategory_ListingValidationFailureFlavor.TEMPORARILY_OFF_MARKET;
        case 2:
        case "TRADITIONAL_LISTING":
            return RetailWebUnlockCategory_ListingValidationFailureFlavor.TRADITIONAL_LISTING;
        case 3:
        case "AFTER_HOURS_TOURING":
            return RetailWebUnlockCategory_ListingValidationFailureFlavor.AFTER_HOURS_TOURING;
        case 4:
        case "HOME_UNDER_CONTRACT":
            return RetailWebUnlockCategory_ListingValidationFailureFlavor.HOME_UNDER_CONTRACT;
        case 5:
        case "HOME_SOLD":
            return RetailWebUnlockCategory_ListingValidationFailureFlavor.HOME_SOLD;
        case 6:
        case "PPM":
            return RetailWebUnlockCategory_ListingValidationFailureFlavor.PPM;
        case -1:
        case "UNRECOGNIZED":
        default:
            return RetailWebUnlockCategory_ListingValidationFailureFlavor.UNRECOGNIZED;
    }
}
function retailWebUnlockCategory_ListingValidationFailureFlavorToJSON(object) {
    switch(object){
        case RetailWebUnlockCategory_ListingValidationFailureFlavor.UNKNOWN_LISTING_FAILURE:
            return "UNKNOWN_LISTING_FAILURE";
        case RetailWebUnlockCategory_ListingValidationFailureFlavor.TEMPORARILY_OFF_MARKET:
            return "TEMPORARILY_OFF_MARKET";
        case RetailWebUnlockCategory_ListingValidationFailureFlavor.TRADITIONAL_LISTING:
            return "TRADITIONAL_LISTING";
        case RetailWebUnlockCategory_ListingValidationFailureFlavor.AFTER_HOURS_TOURING:
            return "AFTER_HOURS_TOURING";
        case RetailWebUnlockCategory_ListingValidationFailureFlavor.HOME_UNDER_CONTRACT:
            return "HOME_UNDER_CONTRACT";
        case RetailWebUnlockCategory_ListingValidationFailureFlavor.HOME_SOLD:
            return "HOME_SOLD";
        case RetailWebUnlockCategory_ListingValidationFailureFlavor.PPM:
            return "PPM";
        case RetailWebUnlockCategory_ListingValidationFailureFlavor.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var RetailWebUnlockCategory_IDVerificationActions;
(function(RetailWebUnlockCategory_IDVerificationActions) {
    RetailWebUnlockCategory_IDVerificationActions[RetailWebUnlockCategory_IDVerificationActions["UNKNOWN_IDV_ACTION"] = 0] = "UNKNOWN_IDV_ACTION";
    RetailWebUnlockCategory_IDVerificationActions[RetailWebUnlockCategory_IDVerificationActions["ALLOW_CAMERA"] = 1] = "ALLOW_CAMERA";
    RetailWebUnlockCategory_IDVerificationActions[RetailWebUnlockCategory_IDVerificationActions["DISALLOW_CAMERA"] = 2] = "DISALLOW_CAMERA";
    RetailWebUnlockCategory_IDVerificationActions[RetailWebUnlockCategory_IDVerificationActions["SCAN_FRONT"] = 3] = "SCAN_FRONT";
    RetailWebUnlockCategory_IDVerificationActions[RetailWebUnlockCategory_IDVerificationActions["SCAN_BACK"] = 4] = "SCAN_BACK";
    RetailWebUnlockCategory_IDVerificationActions[RetailWebUnlockCategory_IDVerificationActions["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(RetailWebUnlockCategory_IDVerificationActions || (RetailWebUnlockCategory_IDVerificationActions = {}));
function retailWebUnlockCategory_IDVerificationActionsFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN_IDV_ACTION":
            return RetailWebUnlockCategory_IDVerificationActions.UNKNOWN_IDV_ACTION;
        case 1:
        case "ALLOW_CAMERA":
            return RetailWebUnlockCategory_IDVerificationActions.ALLOW_CAMERA;
        case 2:
        case "DISALLOW_CAMERA":
            return RetailWebUnlockCategory_IDVerificationActions.DISALLOW_CAMERA;
        case 3:
        case "SCAN_FRONT":
            return RetailWebUnlockCategory_IDVerificationActions.SCAN_FRONT;
        case 4:
        case "SCAN_BACK":
            return RetailWebUnlockCategory_IDVerificationActions.SCAN_BACK;
        case -1:
        case "UNRECOGNIZED":
        default:
            return RetailWebUnlockCategory_IDVerificationActions.UNRECOGNIZED;
    }
}
function retailWebUnlockCategory_IDVerificationActionsToJSON(object) {
    switch(object){
        case RetailWebUnlockCategory_IDVerificationActions.UNKNOWN_IDV_ACTION:
            return "UNKNOWN_IDV_ACTION";
        case RetailWebUnlockCategory_IDVerificationActions.ALLOW_CAMERA:
            return "ALLOW_CAMERA";
        case RetailWebUnlockCategory_IDVerificationActions.DISALLOW_CAMERA:
            return "DISALLOW_CAMERA";
        case RetailWebUnlockCategory_IDVerificationActions.SCAN_FRONT:
            return "SCAN_FRONT";
        case RetailWebUnlockCategory_IDVerificationActions.SCAN_BACK:
            return "SCAN_BACK";
        case RetailWebUnlockCategory_IDVerificationActions.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var RetailWebUnlockCategory_IDVerificationFailureFlavor;
(function(RetailWebUnlockCategory_IDVerificationFailureFlavor) {
    RetailWebUnlockCategory_IDVerificationFailureFlavor[RetailWebUnlockCategory_IDVerificationFailureFlavor["UNKNOWN_IDV_FAILURE"] = 0] = "UNKNOWN_IDV_FAILURE";
    RetailWebUnlockCategory_IDVerificationFailureFlavor[RetailWebUnlockCategory_IDVerificationFailureFlavor["OD_SERVERSIDE_ERROR"] = 1] = "OD_SERVERSIDE_ERROR";
    RetailWebUnlockCategory_IDVerificationFailureFlavor[RetailWebUnlockCategory_IDVerificationFailureFlavor["EXPIRED_ID"] = 2] = "EXPIRED_ID";
    RetailWebUnlockCategory_IDVerificationFailureFlavor[RetailWebUnlockCategory_IDVerificationFailureFlavor["MITEK_ERROR"] = 3] = "MITEK_ERROR";
    RetailWebUnlockCategory_IDVerificationFailureFlavor[RetailWebUnlockCategory_IDVerificationFailureFlavor["UNDERAGE_ID"] = 4] = "UNDERAGE_ID";
    RetailWebUnlockCategory_IDVerificationFailureFlavor[RetailWebUnlockCategory_IDVerificationFailureFlavor["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(RetailWebUnlockCategory_IDVerificationFailureFlavor || (RetailWebUnlockCategory_IDVerificationFailureFlavor = {}));
function retailWebUnlockCategory_IDVerificationFailureFlavorFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN_IDV_FAILURE":
            return RetailWebUnlockCategory_IDVerificationFailureFlavor.UNKNOWN_IDV_FAILURE;
        case 1:
        case "OD_SERVERSIDE_ERROR":
            return RetailWebUnlockCategory_IDVerificationFailureFlavor.OD_SERVERSIDE_ERROR;
        case 2:
        case "EXPIRED_ID":
            return RetailWebUnlockCategory_IDVerificationFailureFlavor.EXPIRED_ID;
        case 3:
        case "MITEK_ERROR":
            return RetailWebUnlockCategory_IDVerificationFailureFlavor.MITEK_ERROR;
        case 4:
        case "UNDERAGE_ID":
            return RetailWebUnlockCategory_IDVerificationFailureFlavor.UNDERAGE_ID;
        case -1:
        case "UNRECOGNIZED":
        default:
            return RetailWebUnlockCategory_IDVerificationFailureFlavor.UNRECOGNIZED;
    }
}
function retailWebUnlockCategory_IDVerificationFailureFlavorToJSON(object) {
    switch(object){
        case RetailWebUnlockCategory_IDVerificationFailureFlavor.UNKNOWN_IDV_FAILURE:
            return "UNKNOWN_IDV_FAILURE";
        case RetailWebUnlockCategory_IDVerificationFailureFlavor.OD_SERVERSIDE_ERROR:
            return "OD_SERVERSIDE_ERROR";
        case RetailWebUnlockCategory_IDVerificationFailureFlavor.EXPIRED_ID:
            return "EXPIRED_ID";
        case RetailWebUnlockCategory_IDVerificationFailureFlavor.MITEK_ERROR:
            return "MITEK_ERROR";
        case RetailWebUnlockCategory_IDVerificationFailureFlavor.UNDERAGE_ID:
            return "UNDERAGE_ID";
        case RetailWebUnlockCategory_IDVerificationFailureFlavor.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var RetailWebUnlockCategory_UnlockFailureFlavor;
(function(RetailWebUnlockCategory_UnlockFailureFlavor) {
    RetailWebUnlockCategory_UnlockFailureFlavor[RetailWebUnlockCategory_UnlockFailureFlavor["UNKNOWN_UNLOCK_FAILURE"] = 0] = "UNKNOWN_UNLOCK_FAILURE";
    RetailWebUnlockCategory_UnlockFailureFlavor[RetailWebUnlockCategory_UnlockFailureFlavor["CODE_UNLOCK"] = 1] = "CODE_UNLOCK";
    RetailWebUnlockCategory_UnlockFailureFlavor[RetailWebUnlockCategory_UnlockFailureFlavor["FAILED_UNLOCK"] = 2] = "FAILED_UNLOCK";
    RetailWebUnlockCategory_UnlockFailureFlavor[RetailWebUnlockCategory_UnlockFailureFlavor["NEED_MORE_INFO"] = 3] = "NEED_MORE_INFO";
    RetailWebUnlockCategory_UnlockFailureFlavor[RetailWebUnlockCategory_UnlockFailureFlavor["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(RetailWebUnlockCategory_UnlockFailureFlavor || (RetailWebUnlockCategory_UnlockFailureFlavor = {}));
function retailWebUnlockCategory_UnlockFailureFlavorFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN_UNLOCK_FAILURE":
            return RetailWebUnlockCategory_UnlockFailureFlavor.UNKNOWN_UNLOCK_FAILURE;
        case 1:
        case "CODE_UNLOCK":
            return RetailWebUnlockCategory_UnlockFailureFlavor.CODE_UNLOCK;
        case 2:
        case "FAILED_UNLOCK":
            return RetailWebUnlockCategory_UnlockFailureFlavor.FAILED_UNLOCK;
        case 3:
        case "NEED_MORE_INFO":
            return RetailWebUnlockCategory_UnlockFailureFlavor.NEED_MORE_INFO;
        case -1:
        case "UNRECOGNIZED":
        default:
            return RetailWebUnlockCategory_UnlockFailureFlavor.UNRECOGNIZED;
    }
}
function retailWebUnlockCategory_UnlockFailureFlavorToJSON(object) {
    switch(object){
        case RetailWebUnlockCategory_UnlockFailureFlavor.UNKNOWN_UNLOCK_FAILURE:
            return "UNKNOWN_UNLOCK_FAILURE";
        case RetailWebUnlockCategory_UnlockFailureFlavor.CODE_UNLOCK:
            return "CODE_UNLOCK";
        case RetailWebUnlockCategory_UnlockFailureFlavor.FAILED_UNLOCK:
            return "FAILED_UNLOCK";
        case RetailWebUnlockCategory_UnlockFailureFlavor.NEED_MORE_INFO:
            return "NEED_MORE_INFO";
        case RetailWebUnlockCategory_UnlockFailureFlavor.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
function createBaseRetailWebUnlockCategory() {
    return {
        event: undefined
    };
}
var RetailWebUnlockCategory = {
    fromJSON: function fromJSON(object) {
        return {
            event: isSet(object.viewEvent) ? {
                $case: "viewEvent",
                viewEvent: RetailWebUnlockCategory_ViewEvent.fromJSON(object.viewEvent)
            } : isSet(object.locationPermissionEvent) ? {
                $case: "locationPermissionEvent",
                locationPermissionEvent: RetailWebUnlockCategory_LocationPermissionEvent.fromJSON(object.locationPermissionEvent)
            } : isSet(object.contactUsEvent) ? {
                $case: "contactUsEvent",
                contactUsEvent: RetailWebUnlockCategory_ContactUsEvent.fromJSON(object.contactUsEvent)
            } : isSet(object.propertyStatusEvent) ? {
                $case: "propertyStatusEvent",
                propertyStatusEvent: RetailWebUnlockCategory_PropertyStatusEvent.fromJSON(object.propertyStatusEvent)
            } : isSet(object.idVerificationEvent) ? {
                $case: "idVerificationEvent",
                idVerificationEvent: RetailWebUnlockCategory_IDVerificationEvent.fromJSON(object.idVerificationEvent)
            } : isSet(object.idVerificationSubmissionEvent) ? {
                $case: "idVerificationSubmissionEvent",
                idVerificationSubmissionEvent: RetailWebUnlockCategory_IDVerificationSubmissionEvent.fromJSON(object.idVerificationSubmissionEvent)
            } : isSet(object.unlockAttemptEvent) ? {
                $case: "unlockAttemptEvent",
                unlockAttemptEvent: RetailWebUnlockCategory_UnlockAttemptEvent.fromJSON(object.unlockAttemptEvent)
            } : isSet(object.generalErrorEvent) ? {
                $case: "generalErrorEvent",
                generalErrorEvent: RetailWebUnlockCategory_GeneralErrorEvent.fromJSON(object.generalErrorEvent)
            } : undefined
        };
    },
    toJSON: function toJSON(message) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
        var obj = {};
        if (((ref = message.event) === null || ref === void 0 ? void 0 : ref.$case) === "viewEvent") {
            obj.viewEvent = RetailWebUnlockCategory_ViewEvent.toJSON(message.event.viewEvent);
        }
        if (((ref1 = message.event) === null || ref1 === void 0 ? void 0 : ref1.$case) === "locationPermissionEvent") {
            obj.locationPermissionEvent = RetailWebUnlockCategory_LocationPermissionEvent.toJSON(message.event.locationPermissionEvent);
        }
        if (((ref2 = message.event) === null || ref2 === void 0 ? void 0 : ref2.$case) === "contactUsEvent") {
            obj.contactUsEvent = RetailWebUnlockCategory_ContactUsEvent.toJSON(message.event.contactUsEvent);
        }
        if (((ref3 = message.event) === null || ref3 === void 0 ? void 0 : ref3.$case) === "propertyStatusEvent") {
            obj.propertyStatusEvent = RetailWebUnlockCategory_PropertyStatusEvent.toJSON(message.event.propertyStatusEvent);
        }
        if (((ref4 = message.event) === null || ref4 === void 0 ? void 0 : ref4.$case) === "idVerificationEvent") {
            obj.idVerificationEvent = RetailWebUnlockCategory_IDVerificationEvent.toJSON(message.event.idVerificationEvent);
        }
        if (((ref5 = message.event) === null || ref5 === void 0 ? void 0 : ref5.$case) === "idVerificationSubmissionEvent") {
            obj.idVerificationSubmissionEvent = RetailWebUnlockCategory_IDVerificationSubmissionEvent.toJSON(message.event.idVerificationSubmissionEvent);
        }
        if (((ref6 = message.event) === null || ref6 === void 0 ? void 0 : ref6.$case) === "unlockAttemptEvent") {
            obj.unlockAttemptEvent = RetailWebUnlockCategory_UnlockAttemptEvent.toJSON(message.event.unlockAttemptEvent);
        }
        if (((ref7 = message.event) === null || ref7 === void 0 ? void 0 : ref7.$case) === "generalErrorEvent") {
            obj.generalErrorEvent = RetailWebUnlockCategory_GeneralErrorEvent.toJSON(message.event.generalErrorEvent);
        }
        return obj;
    },
    create: function create(base) {
        return RetailWebUnlockCategory.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23;
        var message = createBaseRetailWebUnlockCategory();
        if (((ref = object.event) === null || ref === void 0 ? void 0 : ref.$case) === "viewEvent" && ((ref1 = object.event) === null || ref1 === void 0 ? void 0 : ref1.viewEvent) !== undefined && ((ref2 = object.event) === null || ref2 === void 0 ? void 0 : ref2.viewEvent) !== null) {
            message.event = {
                $case: "viewEvent",
                viewEvent: RetailWebUnlockCategory_ViewEvent.fromPartial(object.event.viewEvent)
            };
        }
        if (((ref3 = object.event) === null || ref3 === void 0 ? void 0 : ref3.$case) === "locationPermissionEvent" && ((ref4 = object.event) === null || ref4 === void 0 ? void 0 : ref4.locationPermissionEvent) !== undefined && ((ref5 = object.event) === null || ref5 === void 0 ? void 0 : ref5.locationPermissionEvent) !== null) {
            message.event = {
                $case: "locationPermissionEvent",
                locationPermissionEvent: RetailWebUnlockCategory_LocationPermissionEvent.fromPartial(object.event.locationPermissionEvent)
            };
        }
        if (((ref6 = object.event) === null || ref6 === void 0 ? void 0 : ref6.$case) === "contactUsEvent" && ((ref7 = object.event) === null || ref7 === void 0 ? void 0 : ref7.contactUsEvent) !== undefined && ((ref8 = object.event) === null || ref8 === void 0 ? void 0 : ref8.contactUsEvent) !== null) {
            message.event = {
                $case: "contactUsEvent",
                contactUsEvent: RetailWebUnlockCategory_ContactUsEvent.fromPartial(object.event.contactUsEvent)
            };
        }
        if (((ref9 = object.event) === null || ref9 === void 0 ? void 0 : ref9.$case) === "propertyStatusEvent" && ((ref10 = object.event) === null || ref10 === void 0 ? void 0 : ref10.propertyStatusEvent) !== undefined && ((ref11 = object.event) === null || ref11 === void 0 ? void 0 : ref11.propertyStatusEvent) !== null) {
            message.event = {
                $case: "propertyStatusEvent",
                propertyStatusEvent: RetailWebUnlockCategory_PropertyStatusEvent.fromPartial(object.event.propertyStatusEvent)
            };
        }
        if (((ref12 = object.event) === null || ref12 === void 0 ? void 0 : ref12.$case) === "idVerificationEvent" && ((ref13 = object.event) === null || ref13 === void 0 ? void 0 : ref13.idVerificationEvent) !== undefined && ((ref14 = object.event) === null || ref14 === void 0 ? void 0 : ref14.idVerificationEvent) !== null) {
            message.event = {
                $case: "idVerificationEvent",
                idVerificationEvent: RetailWebUnlockCategory_IDVerificationEvent.fromPartial(object.event.idVerificationEvent)
            };
        }
        if (((ref15 = object.event) === null || ref15 === void 0 ? void 0 : ref15.$case) === "idVerificationSubmissionEvent" && ((ref16 = object.event) === null || ref16 === void 0 ? void 0 : ref16.idVerificationSubmissionEvent) !== undefined && ((ref17 = object.event) === null || ref17 === void 0 ? void 0 : ref17.idVerificationSubmissionEvent) !== null) {
            message.event = {
                $case: "idVerificationSubmissionEvent",
                idVerificationSubmissionEvent: RetailWebUnlockCategory_IDVerificationSubmissionEvent.fromPartial(object.event.idVerificationSubmissionEvent)
            };
        }
        if (((ref18 = object.event) === null || ref18 === void 0 ? void 0 : ref18.$case) === "unlockAttemptEvent" && ((ref19 = object.event) === null || ref19 === void 0 ? void 0 : ref19.unlockAttemptEvent) !== undefined && ((ref20 = object.event) === null || ref20 === void 0 ? void 0 : ref20.unlockAttemptEvent) !== null) {
            message.event = {
                $case: "unlockAttemptEvent",
                unlockAttemptEvent: RetailWebUnlockCategory_UnlockAttemptEvent.fromPartial(object.event.unlockAttemptEvent)
            };
        }
        if (((ref21 = object.event) === null || ref21 === void 0 ? void 0 : ref21.$case) === "generalErrorEvent" && ((ref22 = object.event) === null || ref22 === void 0 ? void 0 : ref22.generalErrorEvent) !== undefined && ((ref23 = object.event) === null || ref23 === void 0 ? void 0 : ref23.generalErrorEvent) !== null) {
            message.event = {
                $case: "generalErrorEvent",
                generalErrorEvent: RetailWebUnlockCategory_GeneralErrorEvent.fromPartial(object.event.generalErrorEvent)
            };
        }
        return message;
    }
};
function createBaseRetailWebUnlockCategory_ViewEvent() {
    return {
        listingId: undefined,
        addressUuid: undefined,
        stepType: 0,
        step: ""
    };
}
var RetailWebUnlockCategory_ViewEvent = {
    fromJSON: function fromJSON(object) {
        return {
            listingId: isSet(object.listingId) ? String(object.listingId) : undefined,
            addressUuid: isSet(object.addressUuid) ? String(object.addressUuid) : undefined,
            stepType: isSet(object.stepType) ? retailWebUnlockCategory_StepTypeFromJSON(object.stepType) : 0,
            step: isSet(object.step) ? String(object.step) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.listingId !== undefined) {
            obj.listingId = message.listingId;
        }
        if (message.addressUuid !== undefined) {
            obj.addressUuid = message.addressUuid;
        }
        if (message.stepType !== 0) {
            obj.stepType = retailWebUnlockCategory_StepTypeToJSON(message.stepType);
        }
        if (message.step !== "") {
            obj.step = message.step;
        }
        return obj;
    },
    create: function create(base) {
        return RetailWebUnlockCategory_ViewEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseRetailWebUnlockCategory_ViewEvent();
        var _listingId;
        message.listingId = (_listingId = object.listingId) !== null && _listingId !== void 0 ? _listingId : undefined;
        var _addressUuid;
        message.addressUuid = (_addressUuid = object.addressUuid) !== null && _addressUuid !== void 0 ? _addressUuid : undefined;
        var _stepType;
        message.stepType = (_stepType = object.stepType) !== null && _stepType !== void 0 ? _stepType : 0;
        var _step;
        message.step = (_step = object.step) !== null && _step !== void 0 ? _step : "";
        return message;
    }
};
function createBaseRetailWebUnlockCategory_LocationPermissionEvent() {
    return {
        locationPermission: false
    };
}
var RetailWebUnlockCategory_LocationPermissionEvent = {
    fromJSON: function fromJSON(object) {
        return {
            locationPermission: isSet(object.locationPermission) ? Boolean(object.locationPermission) : false
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.locationPermission === true) {
            obj.locationPermission = message.locationPermission;
        }
        return obj;
    },
    create: function create(base) {
        return RetailWebUnlockCategory_LocationPermissionEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseRetailWebUnlockCategory_LocationPermissionEvent();
        var _locationPermission;
        message.locationPermission = (_locationPermission = object.locationPermission) !== null && _locationPermission !== void 0 ? _locationPermission : false;
        return message;
    }
};
function createBaseRetailWebUnlockCategory_ContactUsEvent() {
    return {
        target: ""
    };
}
var RetailWebUnlockCategory_ContactUsEvent = {
    fromJSON: function fromJSON(object) {
        return {
            target: isSet(object.target) ? String(object.target) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.target !== "") {
            obj.target = message.target;
        }
        return obj;
    },
    create: function create(base) {
        return RetailWebUnlockCategory_ContactUsEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseRetailWebUnlockCategory_ContactUsEvent();
        var _target;
        message.target = (_target = object.target) !== null && _target !== void 0 ? _target : "";
        return message;
    }
};
function createBaseRetailWebUnlockCategory_PropertyStatusEvent() {
    return {
        listingId: "",
        addressUuid: "",
        tourUnavailableReason: 0
    };
}
var RetailWebUnlockCategory_PropertyStatusEvent = {
    fromJSON: function fromJSON(object) {
        return {
            listingId: isSet(object.listingId) ? String(object.listingId) : "",
            addressUuid: isSet(object.addressUuid) ? String(object.addressUuid) : "",
            tourUnavailableReason: isSet(object.tourUnavailableReason) ? retailWebUnlockCategory_ListingValidationFailureFlavorFromJSON(object.tourUnavailableReason) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.listingId !== "") {
            obj.listingId = message.listingId;
        }
        if (message.addressUuid !== "") {
            obj.addressUuid = message.addressUuid;
        }
        if (message.tourUnavailableReason !== 0) {
            obj.tourUnavailableReason = retailWebUnlockCategory_ListingValidationFailureFlavorToJSON(message.tourUnavailableReason);
        }
        return obj;
    },
    create: function create(base) {
        return RetailWebUnlockCategory_PropertyStatusEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseRetailWebUnlockCategory_PropertyStatusEvent();
        var _listingId;
        message.listingId = (_listingId = object.listingId) !== null && _listingId !== void 0 ? _listingId : "";
        var _addressUuid;
        message.addressUuid = (_addressUuid = object.addressUuid) !== null && _addressUuid !== void 0 ? _addressUuid : "";
        var _tourUnavailableReason;
        message.tourUnavailableReason = (_tourUnavailableReason = object.tourUnavailableReason) !== null && _tourUnavailableReason !== void 0 ? _tourUnavailableReason : 0;
        return message;
    }
};
function createBaseRetailWebUnlockCategory_IDVerificationEvent() {
    return {
        action: 0
    };
}
var RetailWebUnlockCategory_IDVerificationEvent = {
    fromJSON: function fromJSON(object) {
        return {
            action: isSet(object.action) ? retailWebUnlockCategory_IDVerificationActionsFromJSON(object.action) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.action !== 0) {
            obj.action = retailWebUnlockCategory_IDVerificationActionsToJSON(message.action);
        }
        return obj;
    },
    create: function create(base) {
        return RetailWebUnlockCategory_IDVerificationEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseRetailWebUnlockCategory_IDVerificationEvent();
        var _action;
        message.action = (_action = object.action) !== null && _action !== void 0 ? _action : 0;
        return message;
    }
};
function createBaseRetailWebUnlockCategory_IDVerificationSubmissionEvent() {
    return {
        success: false,
        failureReason: 0
    };
}
var RetailWebUnlockCategory_IDVerificationSubmissionEvent = {
    fromJSON: function fromJSON(object) {
        return {
            success: isSet(object.success) ? Boolean(object.success) : false,
            failureReason: isSet(object.failureReason) ? retailWebUnlockCategory_IDVerificationFailureFlavorFromJSON(object.failureReason) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.success === true) {
            obj.success = message.success;
        }
        if (message.failureReason !== 0) {
            obj.failureReason = retailWebUnlockCategory_IDVerificationFailureFlavorToJSON(message.failureReason);
        }
        return obj;
    },
    create: function create(base) {
        return RetailWebUnlockCategory_IDVerificationSubmissionEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseRetailWebUnlockCategory_IDVerificationSubmissionEvent();
        var _success;
        message.success = (_success = object.success) !== null && _success !== void 0 ? _success : false;
        var _failureReason;
        message.failureReason = (_failureReason = object.failureReason) !== null && _failureReason !== void 0 ? _failureReason : 0;
        return message;
    }
};
function createBaseRetailWebUnlockCategory_UnlockAttemptEvent() {
    return {
        listingId: "",
        addressUuid: "",
        success: false,
        failureReason: 0
    };
}
var RetailWebUnlockCategory_UnlockAttemptEvent = {
    fromJSON: function fromJSON(object) {
        return {
            listingId: isSet(object.listingId) ? String(object.listingId) : "",
            addressUuid: isSet(object.addressUuid) ? String(object.addressUuid) : "",
            success: isSet(object.success) ? Boolean(object.success) : false,
            failureReason: isSet(object.failureReason) ? retailWebUnlockCategory_UnlockFailureFlavorFromJSON(object.failureReason) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.listingId !== "") {
            obj.listingId = message.listingId;
        }
        if (message.addressUuid !== "") {
            obj.addressUuid = message.addressUuid;
        }
        if (message.success === true) {
            obj.success = message.success;
        }
        if (message.failureReason !== 0) {
            obj.failureReason = retailWebUnlockCategory_UnlockFailureFlavorToJSON(message.failureReason);
        }
        return obj;
    },
    create: function create(base) {
        return RetailWebUnlockCategory_UnlockAttemptEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseRetailWebUnlockCategory_UnlockAttemptEvent();
        var _listingId;
        message.listingId = (_listingId = object.listingId) !== null && _listingId !== void 0 ? _listingId : "";
        var _addressUuid;
        message.addressUuid = (_addressUuid = object.addressUuid) !== null && _addressUuid !== void 0 ? _addressUuid : "";
        var _success;
        message.success = (_success = object.success) !== null && _success !== void 0 ? _success : false;
        var _failureReason;
        message.failureReason = (_failureReason = object.failureReason) !== null && _failureReason !== void 0 ? _failureReason : 0;
        return message;
    }
};
function createBaseRetailWebUnlockCategory_GeneralErrorEvent() {
    return {
        listingId: undefined,
        addressUuid: undefined,
        error: ""
    };
}
var RetailWebUnlockCategory_GeneralErrorEvent = {
    fromJSON: function fromJSON(object) {
        return {
            listingId: isSet(object.listingId) ? String(object.listingId) : undefined,
            addressUuid: isSet(object.addressUuid) ? String(object.addressUuid) : undefined,
            error: isSet(object.error) ? String(object.error) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.listingId !== undefined) {
            obj.listingId = message.listingId;
        }
        if (message.addressUuid !== undefined) {
            obj.addressUuid = message.addressUuid;
        }
        if (message.error !== "") {
            obj.error = message.error;
        }
        return obj;
    },
    create: function create(base) {
        return RetailWebUnlockCategory_GeneralErrorEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseRetailWebUnlockCategory_GeneralErrorEvent();
        var _listingId;
        message.listingId = (_listingId = object.listingId) !== null && _listingId !== void 0 ? _listingId : undefined;
        var _addressUuid;
        message.addressUuid = (_addressUuid = object.addressUuid) !== null && _addressUuid !== void 0 ? _addressUuid : undefined;
        var _error;
        message.error = (_error = object.error) !== null && _error !== void 0 ? _error : "";
        return message;
    }
};
function isSet(value) {
    return value !== null && value !== undefined;
}


/***/ }),

/***/ 61661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Yr": function() { return /* binding */ AddressAutocomplete; },
  "bY": function() { return /* binding */ CancelBuyDirectOfferStatus; },
  "h6": function() { return /* binding */ GetGeoShapeFromUserLocation; },
  "NA": function() { return /* binding */ GetPropertiesFromGeoShape; },
  "xR": function() { return /* binding */ GetUnlockPropertyInfo; },
  "BH": function() { return /* binding */ cancelBuyDirectOffer; },
  "lX": function() { return /* binding */ createSellerInput; },
  "Tc": function() { return /* binding */ doBFFPost; },
  "gc": function() { return /* binding */ doGet; },
  "cv": function() { return /* binding */ fetchSellerReturnExperience; },
  "k8": function() { return /* binding */ getAthenaClient; },
  "X_": function() { return /* binding */ getBuyDirectPropertyInfo; },
  "OC": function() { return /* binding */ getFeatureFlag; },
  "WQ": function() { return /* binding */ getResaleOffers; },
  "DF": function() { return /* binding */ getSessionExtras; },
  "wf": function() { return /* binding */ requestNewToken; },
  "fs": function() { return /* binding */ requestNewTokenByEmail; },
  "Y": function() { return /* binding */ unsubscribeMailer; },
  "gh": function() { return /* binding */ updateAnswers; },
  "Yj": function() { return /* binding */ updateCurrentCustomer; },
  "il": function() { return /* binding */ validatePartnerEmailAddress; }
});

// UNUSED EXPORTS: fetchTraitByAnonymousId

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(36808);
// EXTERNAL MODULE: ./node_modules/@opendoor/observability/dist/observability-slim.mjs
var observability_slim = __webpack_require__(74593);
// EXTERNAL MODULE: ./node_modules/graphql-request/build/entrypoints/main.js + 14 modules
var main = __webpack_require__(65759);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql/language/parser.mjs + 11 modules
var parser = __webpack_require__(86355);
;// CONCATENATED MODULE: ./node_modules/graphql-tag/lib/index.js


var docCache = new Map();
var fragmentSourceMap = new Map();
var printFragmentWarnings = true;
var experimentalFragmentVariables = false;
function normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function cacheKeyFromLoc(loc) {
    return normalize(loc.source.body.substring(loc.start, loc.end));
}
function processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function (fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if (printFragmentWarnings) {
                    console.warn("Warning: fragment with name " + fragmentName + " already exists.\n"
                        + "graphql-tag enforces all fragment names across your application to be unique; read more about\n"
                        + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
                }
            }
            else if (!sourceKeySet) {
                fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            }
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        }
        else {
            definitions.push(fragmentDefinition);
        }
    });
    return (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, ast), { definitions: definitions });
}
function stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function (node) {
        if (node.loc)
            delete node.loc;
        Object.keys(node).forEach(function (key) {
            var value = node[key];
            if (value && typeof value === 'object') {
                workSet.add(value);
            }
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function parseDocument(source) {
    var cacheKey = normalize(source);
    if (!docCache.has(cacheKey)) {
        var parsed = (0,parser/* parse */.Qc)(source, {
            experimentalFragmentVariables: experimentalFragmentVariables,
            allowLegacyFragmentVariables: experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') {
            throw new Error('Not a valid GraphQL document.');
        }
        docCache.set(cacheKey, stripLoc(processFragments(parsed)));
    }
    return docCache.get(cacheKey);
}
function gql(literals) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (typeof literals === 'string') {
        literals = [literals];
    }
    var result = literals[0];
    args.forEach(function (arg, i) {
        if (arg && arg.kind === 'Document') {
            result += arg.loc.source.body;
        }
        else {
            result += arg;
        }
        result += literals[i + 1];
    });
    return parseDocument(result);
}
function resetCaches() {
    docCache.clear();
    fragmentSourceMap.clear();
}
function disableFragmentWarnings() {
    printFragmentWarnings = false;
}
function enableExperimentalFragmentVariables() {
    experimentalFragmentVariables = true;
}
function disableExperimentalFragmentVariables() {
    experimentalFragmentVariables = false;
}
var extras = {
    gql: gql,
    resetCaches: resetCaches,
    disableFragmentWarnings: disableFragmentWarnings,
    enableExperimentalFragmentVariables: enableExperimentalFragmentVariables,
    disableExperimentalFragmentVariables: disableExperimentalFragmentVariables
};
(function (gql_1) {
    gql_1.gql = extras.gql, gql_1.resetCaches = extras.resetCaches, gql_1.disableFragmentWarnings = extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = extras.disableExperimentalFragmentVariables;
})(gql || (gql = {}));
gql["default"] = gql;
/* harmony default export */ var lib = (gql);
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./src/__generated__/athena.ts


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment SimilarProperty on MarketplacePropertyListResult {\n  id\n  addressToken\n  baths\n  beds\n  city\n  dwellingType\n  estimatedMonthlyPayment\n  fullAddress\n  listPrice\n  livingSquareFootage\n  neighborhood\n  slug\n  photos\n}\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment SimilarProperties on MarketplacePropertyListQueryResult {\n  results {\n    ...SimilarProperty\n  }\n  count\n  nextPage\n}\n    ",
        ""
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment PropertyDetails on MarketplaceProperty {\n  addressToken\n  bathrooms\n  bedrooms\n  buyDirectPrice\n  canSelfTour\n  city\n  cumulativeDaysOnMarket\n  daysOnMarket\n  description\n  displayBadge\n  dwellingType\n  estimatedMonthlyPayment\n  exteriorStories\n  fhaEligible\n  fhaEligibleDate\n  garageSpaces\n  hasPrivatePool\n  hasCommunityPool\n  hoas {\n    name\n    feeAmount\n    feeFrequency\n  }\n  inGatedCommunity\n  kitchenCountertop\n  latitude\n  longitude\n  listPrice\n  listingHistory {\n    state\n    timestamp\n    mls\n    originalListPriceCents\n    soldPriceCents\n    currentListPriceCents\n  }\n  listingMetadata {\n    buyDirectDiscountPercent\n  }\n  estimatedBuyDirectMonthlyPayment\n  listingState\n  listingTags\n  market\n  masterBedroomLocation\n  photos\n  pricePerSqFt\n  schoolDistricts\n  schools {\n    id\n    name\n    rating\n  }\n  sellerDisclosuresDownloadUrl\n  similarProperties {\n    ...SimilarProperties\n  }\n  slug\n  sqFtLot\n  sqFtTotalLiving\n  state\n  street\n  subdivision\n  unitType\n  unitNumber\n  yearBuilt\n  zip\n}\n    ",
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment PropertiesByMarketResult on PropertySearchResult {\n  displaySlug\n  bedrooms\n  bathroomsTotal\n  originalListPrice\n  sqFtTotalLiving\n  sqFtAboveGrade\n  listPrice\n  listTimestamp\n  street\n  unitType\n  unitNumber\n  city\n  state\n  postalCode\n  longitude\n  latitude\n  sqFtLot\n  addressId\n  photos(pageInput: {first: 5}) {\n    nodes {\n      id\n      urls {\n        resizable\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment MarketplacePropertySearchResult on MarketplacePropertySearchResult {\n  id\n  addressToken\n  badges\n  beds\n  baths\n  listDate\n  listPrice\n  livingSquareFootage\n  listingState\n  location {\n    lat\n    lon\n  }\n  slug\n}\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment MarketplacePropertySearch on MarketplacePropertySearchQueryResult {\n  count\n  results {\n    ...MarketplacePropertySearchResult\n  }\n}\n    ",
        ""
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment AddressSearchResult on AddressSearchProperty {\n  addressToken\n  id\n  fullAddress\n  priceCents\n}\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment MarketplacePropertyListResult on MarketplacePropertyListResult {\n  id\n  addressToken\n  badges\n  beds\n  baths\n  city\n  dwellingType\n  estimatedMonthlyPayment\n  fullAddress\n  isLiked\n  listDate\n  listPrice\n  livingSquareFootage\n  listingState\n  neighborhood\n  photos\n  slug\n  zip\n}\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment MarketplacePropertyList on MarketplacePropertyListQueryResult {\n  count\n  nextPage\n  results {\n    ...MarketplacePropertyListResult\n  }\n}\n    ",
        ""
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment BuyerPropertyReaction on OdProtosBuyerV2Data_PropertyReaction {\n  addressId\n  reaction\n  source\n}\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment MarketConfig on OdProtosBuyerData_MarketConfig {\n  shape\n  displayName\n  identifier\n  buyingExperience\n}\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment MapMarkerDetails on MarketplaceProperty {\n  addressToken\n  photos\n  estimatedMonthlyPayment\n  bathrooms\n  bedrooms\n  sqFtTotalLiving\n  dwellingType\n  isLiked\n}\n    "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation UnsubscribeMailer($address: OdProtosWebServicesMarketing_UnsubscribeMailerRequestInput!) {\n  marketing {\n    unsubscribeMailer(input: $address) {\n      _empty\n    }\n  }\n}\n    "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation SetMarketplacePropertyReaction($input: OdProtosBuyerV2ServicesBuyer_SetPropertyReactionRequestInput!) {\n  buyerService {\n    setPropertyReaction(input: $input) {\n      _empty\n    }\n  }\n}\n    "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation RemoveMarketplacePropertyReaction($input: OdProtosBuyerV2ServicesBuyer_RemovePropertyReactionRequestInput!) {\n  buyerService {\n    removePropertyReaction(input: $input) {\n      _empty\n    }\n  }\n}\n    "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation SetImpression($grain: OdProtosVariantData_GrainInput, $key: String!, $variantValue: String!) {\n  variant {\n    setImpression(input: {grain: $grain, key: $key, variantValue: $variantValue}) {\n      _empty\n    }\n  }\n}\n    "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation UpdateCustomer($customerUuid: String!, $params: OdProtosCustomerV1Services_CustomerRequests_Update_ParamsInput!) {\n  customerService {\n    update(input: {uuid: $customerUuid, params: $params}) {\n      updatedCustomer {\n        uuid\n        createdAt\n        firstName\n        lastName\n        primaryEmail {\n          address {\n            value\n          }\n        }\n        otherEmails {\n          address {\n            value\n          }\n        }\n        primaryPhoneNumber {\n          number {\n            value\n          }\n          type\n        }\n        otherPhoneNumbers {\n          number {\n            value\n          }\n          type\n        }\n        isAgent\n        ccpaSaleOfDataOptOut\n        fullName\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation UpdateCurrentCustomer($customerUpdates: OdProtosCustomerV1Services_CustomerRequests_UpdateCurrentInput!) {\n  customerService {\n    updateCurrent(input: $customerUpdates) {\n      updatedCustomer {\n        uuid\n        createdAt\n        firstName\n        lastName\n        primaryEmail {\n          address {\n            value\n          }\n        }\n        otherEmails {\n          address {\n            value\n          }\n        }\n        primaryPhoneNumber {\n          number {\n            value\n          }\n          type\n        }\n        otherPhoneNumbers {\n          number {\n            value\n          }\n          type\n        }\n        isAgent\n        ccpaSaleOfDataOptOut\n        fullName\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation CreateViewingAppointment($customerUUID: String!, $appointmentDate: String!, $appointmentTime: String!, $listingId: Int, $duration: Int) {\n  web {\n    createViewingAppointment(\n      customerUUID: $customerUUID\n      appointmentDate: $appointmentDate\n      appointmentTime: $appointmentTime\n      listingId: $listingId\n      duration: $duration\n    ) {\n      id\n    }\n  }\n}\n    "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation UploadAgentPhoto($key: String!) {\n  external {\n    aws {\n      s3CreatePutObjectPresignedUrl(\n        input: {clientName: IMGDROP_PRODUCTION, key: $key}\n      ) {\n        signedUrl\n        key\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation RemoveSavedSearch($input: OdProtosBuyerV2ServicesBuyer_RemoveSavedSearchRequestInput!) {\n  buyerService {\n    removeSavedSearch(input: $input) {\n      _empty\n    }\n  }\n}\n    "
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation UpdateSavedSearch($input: OdProtosBuyerV2ServicesBuyer_UpdateSavedSearchRequestInput!) {\n  buyerService {\n    updateSavedSearch(input: $input) {\n      savedSearch {\n        id\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation InitiateCustomerTask($taskType: CustomerTaskType!, $id: String!) {\n  customerAccount {\n    buying {\n      initiateCustomerTask(input: {taskType: $taskType, id: $id}) {\n        success\n        errorMessage\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation CreateBuyDirectListingOffer($buyer: OdProtosWebServicesBuyDirect_Requests_CreateBuyDirectOffer_CustomerInput!, $coBuyer: OdProtosWebServicesBuyDirect_Requests_CreateBuyDirectOffer_CustomerInput, $downPaymentCents: Float, $financingType: OdProtosWebData_ListingOfferDetails_FinancingStatus, $closeOfEscrow: OdProtosCommon_DateInput, $preApprovalLetter: OdProtosWebServicesBuyDirect_Requests_CreateBuyDirectOffer_DocumentInput, $listing: OdProtosWebServicesBuyDirect_Requests_CreateBuyDirectOffer_ListingOneofInput, $addOns: [OdProtosWebServicesBuyDirect_Requests_CreateBuyDirectOffer_AddOn!], $tradeInAddress: String, $requestedHeroesHomeCredit: Boolean) {\n  webBuyDirectListingOffer {\n    createBuyDirectOffer(\n      input: {buyer: $buyer, coBuyer: $coBuyer, downPaymentCents: $downPaymentCents, financingType: $financingType, closeOfEscrow: $closeOfEscrow, preApprovalLetter: $preApprovalLetter, listing: $listing, addOns: $addOns, tradeInAddress: $tradeInAddress, requestedHeroesHomeCredit: $requestedHeroesHomeCredit}\n    ) {\n      listingOfferId\n      listingOfferUuid\n      contractSignatureId\n    }\n  }\n}\n    "
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetSchools($latitude: Float!, $longitude: Float!) {\n  geoDataStore {\n    getSchools(input: {latitude: $latitude, longitude: $longitude}) {\n      schools {\n        name\n        rating\n        educationLevel\n        greatSchoolsUrl\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetPropertyStatusForRoute($addressId: String!) {\n  property {\n    property(input: {addressId: $addressId}) {\n      addressId\n      displaySlug\n      isDisplayable\n      odMarketIdentifier\n    }\n  }\n}\n    "
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetMarketplacePropertyForRoute($addressId: ID!) {\n  marketplace {\n    property(addressToken: $addressId) {\n      addressToken\n      market\n      slug\n    }\n  }\n}\n    "
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetAddressForId($addressId: String!) {\n  casa {\n    find(input: {uuid: $addressId}) {\n      address {\n        street\n        unitNumber\n        city\n        state\n        postalCode\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetShortListingPropertyInfo($addressId: String!) {\n  property {\n    property(input: {addressId: $addressId}) {\n      addressId\n      sellRequestId\n      displaySlug\n      bathroomsHalf\n      bathroomsFull\n      bedrooms\n      listPrice\n      listingMetadata {\n        tags\n        buyDirectDiscountPercent\n      }\n      status\n      sqFtTotalLiving\n      sqFtAboveGrade\n      sqFtLot\n      yearBuilt\n      poolFeatures\n      publicRemarks\n      hoas {\n        name\n        feeAmount\n        feeFrequency\n        features\n      }\n      garageSpaces\n      photos(pageInput: {first: 50}) {\n        nodes {\n          id\n          urls {\n            resizable\n          }\n        }\n      }\n      sourceType\n    }\n  }\n}\n    "
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetMarketplacePropertyReaction($addressToken: ID!) {\n  marketplace {\n    property(addressToken: $addressToken) {\n      addressToken\n      isDisliked\n      isLiked\n    }\n  }\n}\n    "
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetMarketplacePropertySimilarProperties($addressToken: ID!) {\n  marketplace {\n    property(addressToken: $addressToken) {\n      similarProperties {\n        ...SimilarProperties\n      }\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetMarketplaceProperty($addressToken: ID!) {\n  marketplace {\n    property(addressToken: $addressToken) {\n      ...PropertyDetails\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetMarketplacePropertySellerDisclosures($addressToken: ID!) {\n  marketplace {\n    property(addressToken: $addressToken) {\n      sellerDisclosuresDownloadUrl\n    }\n  }\n}\n    "
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetMarketplacePropertyAccessCode($addressToken: ID!) {\n  marketplace {\n    property(addressToken: $addressToken) {\n      accessCode\n    }\n  }\n}\n    "
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetLongListingPropertyInfo($addressId: String!) {\n  property {\n    property(input: {addressId: $addressId}) {\n      addressId\n      odMarketIdentifier\n      statePropertyTaxRate\n      sellRequestId\n      city\n      displaySlug\n      postalCode\n      state\n      street\n      county\n      unitNumber\n      unitType\n      dwellingType\n      bedrooms\n      bathroomsHalf\n      bathroomsFull\n      builderName\n      exteriorStories\n      sellerDisclosuresDownloadUrl\n      listingMetadata {\n        tags\n        buyDirectDiscountPercent\n      }\n      listPrice\n      listTimestamp\n      status\n      sqFtTotalLiving\n      sqFtAboveGrade\n      sqFtLot\n      yearBuilt\n      poolFeatures\n      publicRemarks\n      hoas {\n        name\n        feeAmount\n        feeFrequency\n        features\n      }\n      inGatedCommunity\n      agent {\n        brokerage\n        firstName\n        lastName\n        fullName\n        licenseNumber\n        mls\n        mlsId\n        email\n        phoneNumber\n      }\n      listingOfficeName\n      apn\n      mls {\n        identifier\n        logoUrl\n        logoRequiredDimensions {\n          width\n          height\n        }\n        legalText\n        detailPageLogo\n        detailPageLegalText\n        detailPageAgentOffice\n        detailPageAgentName\n        detailPageMLSNumber\n        detailPageContactInfo\n      }\n      mlsDisplayPermission\n      mlsNumber\n      entryTimestamp\n      listTimestamp\n      sellRequestCreatedAt\n      newConstruction\n      opendoorOwned\n      instantTourable\n      schools {\n        id\n        name\n        rating\n        gradesOffered\n      }\n      sourceType\n      odMarketIdentifier\n      zones {\n        id\n        name\n        mapPageSlug\n      }\n      similarListings(input: {pageInput: {first: 5}}) {\n        results {\n          nodes {\n            addressId\n            displaySlug\n            city\n            postalCode\n            state\n            street\n            unitNumber\n            unitType\n            bedrooms\n            bathroomsTotal\n            listPrice\n            listTimestamp\n            status\n            photos(pageInput: {first: 1}) {\n              nodes {\n                id\n                urls {\n                  resizable\n                }\n              }\n            }\n            sqFtLot\n            sqFtTotalLiving\n            sqFtAboveGrade\n            listTimestamp\n            status\n            latitude\n            longitude\n          }\n        }\n      }\n      photos(pageInput: {first: 50}) {\n        nodes {\n          id\n          urls {\n            resizable\n          }\n        }\n      }\n      latitude\n      longitude\n      commissionBreakdown {\n        buyer {\n          value\n          type\n        }\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetMarketplacePropertySearch($market: String, $bedrooms: Int, $bathrooms: Float, $canSelfTour: Boolean, $hasPool: Boolean, $maxHoaMonthlyFee: Float, $maxSquareFootage: Int, $minSquareFootage: Int, $maxListPrice: Float, $minListPrice: Float, $maxYearBuilt: Int, $minYearBuilt: Int, $propertyTypes: [PropertyType!], $singleStoryOnly: Boolean, $vertices: [GeoPoint!], $zoneIds: [String!]) {\n  marketplace {\n    propertySearch(\n      filters: {listingState: ON_THE_MARKET, minBeds: $bedrooms, minBathrooms: $bathrooms, minListPrice: $minListPrice, maxListPrice: $maxListPrice, minSquareFootage: $minSquareFootage, maxSquareFootage: $maxSquareFootage, maxYearBuilt: $maxYearBuilt, minYearBuilt: $minYearBuilt, isSelfTourEligible: $canSelfTour, propertyType: $propertyTypes, hasSingleStory: $singleStoryOnly, hasPool: $hasPool, maxHoaMonthlyFee: $maxHoaMonthlyFee}\n      where: {market: $market, zoneIds: $zoneIds, vertices: $vertices}\n    ) {\n      ...MarketplacePropertySearch\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetMarketplacePropertyList($page: Int!, $market: String, $bedrooms: Int, $bathrooms: Float, $canSelfTour: Boolean, $hasPool: Boolean, $maxHoaMonthlyFee: Float, $maxListPrice: Float, $minListPrice: Float, $maxSquareFootage: Int, $minSquareFootage: Int, $maxYearBuilt: Int, $minYearBuilt: Int, $propertyTypes: [PropertyType!], $singleStoryOnly: Boolean, $vertices: [GeoPoint!], $zoneIds: [String!]) {\n  marketplace {\n    propertyList(\n      page: $page\n      filters: {listingState: ON_THE_MARKET, minBeds: $bedrooms, minBathrooms: $bathrooms, minListPrice: $minListPrice, maxListPrice: $maxListPrice, minSquareFootage: $minSquareFootage, maxSquareFootage: $maxSquareFootage, maxYearBuilt: $maxYearBuilt, minYearBuilt: $minYearBuilt, isSelfTourEligible: $canSelfTour, propertyType: $propertyTypes, hasSingleStory: $singleStoryOnly, hasPool: $hasPool, maxHoaMonthlyFee: $maxHoaMonthlyFee}\n      where: {market: $market, zoneIds: $zoneIds, vertices: $vertices}\n      sortBy: [LIST_DATE_DSC]\n    ) {\n      ...MarketplacePropertyList\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetPropertiesByMarket($shape: String!, $filters: PropertyFilters, $pageInput: PageInput!) {\n  property {\n    geoSearch(input: {shape: $shape, filters: $filters, pageInput: $pageInput}) {\n      results {\n        nodes {\n          ...PropertiesByMarketResult\n        }\n      }\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject37 = function _templateObject37() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetIsLikedByAddressIdForCurrentUser($addressId: String!) {\n  buyer {\n    isLikedByAddressIdForCurrentUser(addressId: $addressId) {\n      isLiked\n    }\n  }\n}\n    "
    ]);
    _templateObject38 = function _templateObject38() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetPropertyPhotosByAddressIDs($addressIds: [String!]!, $photoCount: Int!) {\n  property {\n    properties(input: {addressIds: $addressIds}) {\n      addressId\n      listTimestamp\n      photos(pageInput: {first: $photoCount}) {\n        nodes {\n          urls {\n            fullSize\n          }\n        }\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject39 = function _templateObject39() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetVariantRequest($grain: OdProtosVariantData_GrainInput, $key: String!, $props: GoogleProtobuf_StructInput, $autoImpression: Boolean) {\n  variant {\n    getVariant(\n      input: {grain: $grain, key: $key, props: $props, autoImpression: $autoImpression}\n    ) {\n      variant {\n        value\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject40 = function _templateObject40() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetSeveralVariantsRequest($grain: OdProtosVariantData_GrainInput, $keys: [String!], $props: GoogleProtobuf_StructInput) {\n  variant {\n    getVariants(input: {grain: $grain, keys: $keys, props: $props}) {\n      variants {\n        key\n        value {\n          value\n        }\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject41 = function _templateObject41() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetSeveralFeatureFlagsRequest($grain: OdProtosVariantData_GrainInput, $keys: [String!], $props: GoogleProtobuf_StructInput) {\n  variant {\n    getFeatureFlags(input: {grain: $grain, keys: $keys, props: $props}) {\n      variants {\n        key\n        value {\n          value\n        }\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject42 = function _templateObject42() {
        return data;
    };
    return data;
}
function _templateObject43() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query ListLeadsOnUniqueAddresses($customerUuid: String!) {\n  sellDirect {\n    listLeadsOnUniqueAddresses(input: {customerUuid: $customerUuid}) {\n      leads {\n        id\n        isQualified\n        latestOffer {\n          state\n        }\n        address {\n          uuid\n          street\n        }\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject43 = function _templateObject43() {
        return data;
    };
    return data;
}
function _templateObject44() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetUnlockPropertyInfo($addressId: String!) {\n  property {\n    property(input: {addressId: $addressId}) {\n      addressId\n      street\n      unitType\n      unitNumber\n      city\n      state\n      postalCode\n      odMarketIdentifier\n      sourceId\n      photos(pageInput: {first: 1}) {\n        nodes {\n          id\n          urls {\n            fullSize\n          }\n        }\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject44 = function _templateObject44() {
        return data;
    };
    return data;
}
function _templateObject45() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetGeoShapeFromUserLocation($latitude: Float!, $longitude: Float!, $shapeGeoOption: OdProtosGeoDataStoreServices_ShapeGeoOption!) {\n  geoDataStore {\n    getZoneHierarchy(\n      input: {latitude: $latitude, longitude: $longitude, shapeGeoOption: $shapeGeoOption}\n    ) {\n      zones {\n        shape\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject45 = function _templateObject45() {
        return data;
    };
    return data;
}
function _templateObject46() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetPropertiesFromGeoShape($shape: String!, $filters: OdProtosPropertyDataStoreServices_PropertyFiltersInput!, $paginationRequest: OdProtosPropertyDataStoreServices_PaginationRequestInput) {\n  propertyDataStore {\n    mapSearchProperties(\n      input: {shape: $shape, filters: $filters, paginationRequest: $paginationRequest}\n    ) {\n      properties {\n        addressId\n        latitude\n        longitude\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject46 = function _templateObject46() {
        return data;
    };
    return data;
}
function _templateObject47() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query AddressAutocomplete($query: String!, $filters: PropertyFilters, $pageInput: PageInput!, $latitude: Float, $longitude: Float) {\n  property {\n    textSearch(\n      input: {query: $query, filters: $filters, pageInput: $pageInput, latitude: $latitude, longitude: $longitude}\n    ) {\n      results {\n        nodes {\n          addressId\n          displaySlug\n          unitNumber\n          street\n          city\n          state\n          postalCode\n        }\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject47 = function _templateObject47() {
        return data;
    };
    return data;
}
function _templateObject48() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetCurrentCustomer {\n  customerService {\n    getCurrentCustomer {\n      customer {\n        uuid\n        createdAt\n        firstName\n        lastName\n        primaryEmail {\n          address {\n            value\n          }\n        }\n        otherEmails {\n          address {\n            value\n          }\n        }\n        primaryPhoneNumber {\n          number {\n            value\n          }\n          type\n        }\n        otherPhoneNumbers {\n          number {\n            value\n          }\n          type\n        }\n        isAgent\n        ccpaSaleOfDataOptOut\n        fullName\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject48 = function _templateObject48() {
        return data;
    };
    return data;
}
function _templateObject49() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetViewingAppointmentsData($customerUuid: String!, $listingId: String!, $daysOut: Int, $durationMinutes: Int) {\n  web {\n    viewingAppointmentsByCustomer(customerUuid: $customerUuid) {\n      listing_address_id\n      scheduled_for\n      end_time\n      timezone\n    }\n    viewingAppointmentAvailabilityForListing(\n      listingId: $listingId\n      daysOut: $daysOut\n      durationMinutes: $durationMinutes\n    ) {\n      available_days {\n        date\n        available_slots {\n          start_time\n          end_time\n          is_now\n        }\n      }\n      timezone\n    }\n  }\n}\n    "
    ]);
    _templateObject49 = function _templateObject49() {
        return data;
    };
    return data;
}
function _templateObject50() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetViewingAppointmentsByCustomer($customerUuid: String!) {\n  web {\n    viewingAppointmentsByCustomer(customerUuid: $customerUuid) {\n      listing_address_id\n      scheduled_for\n      end_time\n      timezone\n    }\n  }\n}\n    "
    ]);
    _templateObject50 = function _templateObject50() {
        return data;
    };
    return data;
}
function _templateObject51() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query SearchLocations($query: String!, $types: [OdProtosGeoDataStoreData_Zone_Type!]) {\n  geoDataStore {\n    searchZonesByTextQuery(input: {queryString: $query, types: $types}) {\n      zones {\n        zone {\n          county\n          name\n          shortName\n          stateAbbr\n          uuid\n          zoneType\n          centroid\n          population\n        }\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject51 = function _templateObject51() {
        return data;
    };
    return data;
}
function _templateObject52() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query SearchZonesByLocation($latitude: Float!, $longitude: Float!, $searchDistance: Float!) {\n  geoDataStore {\n    searchZonesByLocation(\n      input: {latitude: $latitude, longitude: $longitude, searchDistance: $searchDistance, types: [NEIGHBORHOOD]}\n    ) {\n      zones {\n        zoneType\n        uuid\n        name\n        slug\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject52 = function _templateObject52() {
        return data;
    };
    return data;
}
function _templateObject53() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetMarketCoordinates($market: OdProtosCommonMarket_Market) {\n  buyer {\n    getMarketConfigByMarket(input: {market: $market}) {\n      marketConfig {\n        ...MarketConfig\n      }\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject53 = function _templateObject53() {
        return data;
    };
    return data;
}
function _templateObject54() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetMarketplacePropertyCoreDetails($addressToken: ID!) {\n  marketplace {\n    property(addressToken: $addressToken) {\n      ...PropertyDetails\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject54 = function _templateObject54() {
        return data;
    };
    return data;
}
function _templateObject55() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query HistoricalMarketMetricsQuery($zip: String, $filters: OdProtosSellerDashboardMetricsData_HistoricalMarketMetricsFiltersInput, $numWeeks: Float) {\n  sellerDashboardMetrics {\n    getHistoricalMarketMetrics(\n      input: {zip: $zip, filters: $filters, numWeeks: $numWeeks}\n    ) {\n      medianSalePrice\n      medianSalePriceMom\n      daysOnMarket\n      daysOnMarketMom\n      homesSold\n      homesSoldMom\n      homesOnMarket\n      homesOnMarketMom\n      avgListingPrice\n      avgListingPriceMom\n      unfilteredGraphs {\n        medianSalePriceGraph\n        daysOnMarketGraph\n        homesSoldGraph\n      }\n      filteredGraphs {\n        medianSalePriceGraph\n        daysOnMarketGraph\n        homesSoldGraph\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject55 = function _templateObject55() {
        return data;
    };
    return data;
}
function _templateObject56() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetMarketMetricsQuery($marketIdentifier: String) {\n  sellerDashboardMetrics {\n    getMarketMetrics(input: {marketIdentifier: $marketIdentifier}) {\n      marketIdentifier\n      timePeriod\n      homesSold\n      homesSoldWow\n      newListings\n      newListingsWow\n      delistings\n      delistingsWow\n      homesOnMarket\n      homesOnMarketWow\n      averagePriceChange\n      averagePriceChangeWow\n      marketHotness\n    }\n  }\n}\n    "
    ]);
    _templateObject56 = function _templateObject56() {
        return data;
    };
    return data;
}
function _templateObject57() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetMarketplacePropertyDetailsForMapMarkers($addressToken: ID!) {\n  marketplace {\n    property(addressToken: $addressToken) {\n      ...MapMarkerDetails\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject57 = function _templateObject57() {
        return data;
    };
    return data;
}
function _templateObject58() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetBuyerPropertyReactions($customerId: String!) {\n  buyerService {\n    getBuyer(input: {customerId: $customerId}) {\n      buyer {\n        reactions {\n          ...BuyerPropertyReaction\n        }\n      }\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject58 = function _templateObject58() {
        return data;
    };
    return data;
}
function _templateObject59() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetZoneData($zoneId: String!) {\n  geoDataStore {\n    getZones(input: {uuids: [$zoneId]}) {\n      zones {\n        uuid\n        name\n        slug\n        zoneType\n        boundingBox\n        centroid\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject59 = function _templateObject59() {
        return data;
    };
    return data;
}
function _templateObject60() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query AddressSearch($query: String!) {\n  marketplace {\n    addressSearch(query: $query) {\n      properties {\n        ...AddressSearchResult\n      }\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject60 = function _templateObject60() {
        return data;
    };
    return data;
}
function _templateObject61() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query FavoriteProperties {\n  marketplace {\n    favoriteProperties {\n      properties {\n        id\n        addressToken\n        beds\n        baths\n        dwellingType\n        fullAddress\n        photos\n        listPrice\n        livingSquareFootage\n        slug\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject61 = function _templateObject61() {
        return data;
    };
    return data;
}
function _templateObject62() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetActiveBuyMarkets($first: Int) {\n  pbdb {\n    activeBuyMarket(first: $first) {\n      identifier\n      displayName\n      stateName\n      displayState\n      homesPath\n    }\n  }\n}\n    "
    ]);
    _templateObject62 = function _templateObject62() {
        return data;
    };
    return data;
}
function _templateObject63() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query PurchaseTransaction($transactionId: String!) {\n  buy {\n    purchaseTransaction(transactionId: $transactionId) {\n      id\n      acceptedOfferPrice\n      agent {\n        id\n        email\n        name\n        photoUrl\n        primaryNumber\n        isPartnerAgent\n      }\n      buyerCustomerId\n      buyerEmail\n      buyerName\n      buyerPhone\n      inspectionPeriodDaysRemaining\n      listingOfferId\n      propertyV2 {\n        addressToken\n        photos\n      }\n      tasks {\n        id\n        description\n        isDone: isComplete\n        title\n        taskType\n      }\n      transactionState\n      resaleCloseOfEscrowDaysRemaining\n    }\n  }\n}\n    "
    ]);
    _templateObject63 = function _templateObject63() {
        return data;
    };
    return data;
}
function _templateObject64() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query BuyerOffersMinimal {\n  customerAccount {\n    buying {\n      offers {\n        id\n        transactionState\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject64 = function _templateObject64() {
        return data;
    };
    return data;
}
function _templateObject65() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query BuyerOffer($offerId: ID!) {\n  customerAccount {\n    buying {\n      offers(filter: {id: $offerId}) {\n        id\n        priceDollars\n        discountDollars\n        hasHeroHomeCredit\n        requestedEarlyCheckIn\n        requestedHomeWarranty\n        tradeInAddress\n        transactionState\n        closeOfEscrowDate\n        resaleAgent {\n          id\n          email\n          name\n          photoUrl\n          primaryNumber\n        }\n        listing {\n          id\n          property {\n            ...PropertyDetails\n          }\n        }\n        notices {\n          type\n          message\n        }\n        taskGroups {\n          title\n          icon\n          progress {\n            completed\n            total\n          }\n          tasks {\n            id\n            taskType\n            title\n            description\n            state\n            ... on InformationalTask {\n              defaultExpanded\n              expandedContent {\n                instructions\n                bulletPoints\n              }\n            }\n            ... on SingleCTATask {\n              defaultExpanded\n              expandedContent {\n                instructions\n                bulletPoints\n              }\n              action {\n                label\n                type\n                variant\n                payload {\n                  __typename\n                  ... on RevealContentPayload {\n                    content\n                  }\n                  ... on ExternalLinkPayload {\n                    url\n                    openInNewTab\n                  }\n                  ... on ModalPayload {\n                    modalId\n                    modalData\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject65 = function _templateObject65() {
        return data;
    };
    return data;
}
function _templateObject66() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetMarketInventoryCounts($markets: [String!]!) {\n  marketplace {\n    marketInventoryCounts(markets: $markets) {\n      market\n      count\n    }\n  }\n}\n    "
    ]);
    _templateObject66 = function _templateObject66() {
        return data;
    };
    return data;
}
function _templateObject67() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetBuyDirectPropertyInfo($addressToken: ID!) {\n  marketplace {\n    property(addressToken: $addressToken) {\n      addressToken\n      bathrooms\n      bedrooms\n      buyDirectPrice\n      city\n      fhaEligible\n      fhaEligibleDate\n      listPrice\n      listingTags\n      photos\n      sellerDisclosuresDownloadUrl\n      slug\n      sqFtTotalLiving\n      state\n      street\n      unitNumber\n      unitType\n      zip\n    }\n  }\n}\n    "
    ]);
    _templateObject67 = function _templateObject67() {
        return data;
    };
    return data;
}
function _templateObject68() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetResaleOffers($customerId: String!) {\n  webListingOffer {\n    listOffers(input: {identifier: {customerId: $customerId}}) {\n      offers {\n        id\n        uuid\n        address {\n          uuid\n        }\n        details {\n          contractSignatureId\n          state\n        }\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject68 = function _templateObject68() {
        return data;
    };
    return data;
}
function _templateObject69() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetBuyDirectS3Urls($bucketName: String!, $documentName: String!) {\n  seller {\n    s3DocumentUploadUrl(bucketName: $bucketName, documentName: $documentName)\n    s3DocumentDownloadUrl(bucketName: $bucketName, s3Directory: $documentName)\n  }\n}\n    "
    ]);
    _templateObject69 = function _templateObject69() {
        return data;
    };
    return data;
}
function _templateObject70() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetCloseOfEscrowHolidays {\n  buyer {\n    closeOfEscrowHolidays {\n      dates\n    }\n  }\n}\n    "
    ]);
    _templateObject70 = function _templateObject70() {
        return data;
    };
    return data;
}

var SimilarPropertyFragmentDoc = lib(_templateObject());
var SimilarPropertiesFragmentDoc = lib(_templateObject1(), SimilarPropertyFragmentDoc);
var PropertyDetailsFragmentDoc = lib(_templateObject2(), SimilarPropertiesFragmentDoc);
var PropertiesByMarketResultFragmentDoc = lib(_templateObject3());
var MarketplacePropertySearchResultFragmentDoc = lib(_templateObject4());
var MarketplacePropertySearchFragmentDoc = lib(_templateObject5(), MarketplacePropertySearchResultFragmentDoc);
var AddressSearchResultFragmentDoc = lib(_templateObject6());
var MarketplacePropertyListResultFragmentDoc = lib(_templateObject7());
var MarketplacePropertyListFragmentDoc = lib(_templateObject8(), MarketplacePropertyListResultFragmentDoc);
var BuyerPropertyReactionFragmentDoc = lib(_templateObject9());
var MarketConfigFragmentDoc = lib(_templateObject10());
var MapMarkerDetailsFragmentDoc = lib(_templateObject11());
var UnsubscribeMailerDocument = lib(_templateObject12());
var SetMarketplacePropertyReactionDocument = lib(_templateObject13());
var RemoveMarketplacePropertyReactionDocument = lib(_templateObject14());
var SetImpressionDocument = lib(_templateObject15());
var UpdateCustomerDocument = lib(_templateObject16());
var UpdateCurrentCustomerDocument = lib(_templateObject17());
var CreateViewingAppointmentDocument = lib(_templateObject18());
var UploadAgentPhotoDocument = lib(_templateObject19());
var RemoveSavedSearchDocument = lib(_templateObject20());
var UpdateSavedSearchDocument = lib(_templateObject21());
var InitiateCustomerTaskDocument = lib(_templateObject22());
var CreateBuyDirectListingOfferDocument = lib(_templateObject23());
var GetSchoolsDocument = lib(_templateObject24());
var GetPropertyStatusForRouteDocument = lib(_templateObject25());
var GetMarketplacePropertyForRouteDocument = lib(_templateObject26());
var GetAddressForIdDocument = lib(_templateObject27());
var GetShortListingPropertyInfoDocument = lib(_templateObject28());
var GetMarketplacePropertyReactionDocument = lib(_templateObject29());
var GetMarketplacePropertySimilarPropertiesDocument = lib(_templateObject30(), SimilarPropertiesFragmentDoc);
var GetMarketplacePropertyDocument = lib(_templateObject31(), PropertyDetailsFragmentDoc);
var GetMarketplacePropertySellerDisclosuresDocument = lib(_templateObject32());
var GetMarketplacePropertyAccessCodeDocument = lib(_templateObject33());
var GetLongListingPropertyInfoDocument = lib(_templateObject34());
var GetMarketplacePropertySearchDocument = lib(_templateObject35(), MarketplacePropertySearchFragmentDoc);
var GetMarketplacePropertyListDocument = lib(_templateObject36(), MarketplacePropertyListFragmentDoc);
var GetPropertiesByMarketDocument = lib(_templateObject37(), PropertiesByMarketResultFragmentDoc);
var GetIsLikedByAddressIdForCurrentUserDocument = lib(_templateObject38());
var GetPropertyPhotosByAddressIDsDocument = lib(_templateObject39());
var GetVariantRequestDocument = lib(_templateObject40());
var GetSeveralVariantsRequestDocument = lib(_templateObject41());
var GetSeveralFeatureFlagsRequestDocument = lib(_templateObject42());
var ListLeadsOnUniqueAddressesDocument = lib(_templateObject43());
var GetUnlockPropertyInfoDocument = lib(_templateObject44());
var GetGeoShapeFromUserLocationDocument = lib(_templateObject45());
var GetPropertiesFromGeoShapeDocument = lib(_templateObject46());
var AddressAutocompleteDocument = lib(_templateObject47());
var GetCurrentCustomerDocument = lib(_templateObject48());
var GetViewingAppointmentsDataDocument = lib(_templateObject49());
var GetViewingAppointmentsByCustomerDocument = lib(_templateObject50());
var SearchLocationsDocument = lib(_templateObject51());
var SearchZonesByLocationDocument = lib(_templateObject52());
var GetMarketCoordinatesDocument = lib(_templateObject53(), MarketConfigFragmentDoc);
var GetMarketplacePropertyCoreDetailsDocument = lib(_templateObject54(), PropertyDetailsFragmentDoc);
var HistoricalMarketMetricsQueryDocument = lib(_templateObject55());
var GetMarketMetricsQueryDocument = lib(_templateObject56());
var GetMarketplacePropertyDetailsForMapMarkersDocument = lib(_templateObject57(), MapMarkerDetailsFragmentDoc);
var GetBuyerPropertyReactionsDocument = lib(_templateObject58(), BuyerPropertyReactionFragmentDoc);
var GetZoneDataDocument = lib(_templateObject59());
var AddressSearchDocument = lib(_templateObject60(), AddressSearchResultFragmentDoc);
var FavoritePropertiesDocument = lib(_templateObject61());
var GetActiveBuyMarketsDocument = lib(_templateObject62());
var PurchaseTransactionDocument = lib(_templateObject63());
var BuyerOffersMinimalDocument = lib(_templateObject64());
var BuyerOfferDocument = lib(_templateObject65(), PropertyDetailsFragmentDoc);
var GetMarketInventoryCountsDocument = lib(_templateObject66());
var GetBuyDirectPropertyInfoDocument = lib(_templateObject67());
var GetResaleOffersDocument = lib(_templateObject68());
var GetBuyDirectS3UrlsDocument = lib(_templateObject69());
var GetCloseOfEscrowHolidaysDocument = lib(_templateObject70());
var defaultWrapper = function(action, _operationName, _operationType, _variables) {
    return action();
};
function getSdk(client) {
    var withWrapper = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultWrapper;
    return {
        UnsubscribeMailer: function UnsubscribeMailer(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: UnsubscribeMailerDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "UnsubscribeMailer", "mutation", variables);
        },
        SetMarketplacePropertyReaction: function SetMarketplacePropertyReaction(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: SetMarketplacePropertyReactionDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "SetMarketplacePropertyReaction", "mutation", variables);
        },
        RemoveMarketplacePropertyReaction: function RemoveMarketplacePropertyReaction(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: RemoveMarketplacePropertyReactionDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "RemoveMarketplacePropertyReaction", "mutation", variables);
        },
        SetImpression: function SetImpression(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: SetImpressionDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "SetImpression", "mutation", variables);
        },
        UpdateCustomer: function UpdateCustomer(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: UpdateCustomerDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "UpdateCustomer", "mutation", variables);
        },
        UpdateCurrentCustomer: function UpdateCurrentCustomer(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: UpdateCurrentCustomerDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "UpdateCurrentCustomer", "mutation", variables);
        },
        CreateViewingAppointment: function CreateViewingAppointment(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: CreateViewingAppointmentDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "CreateViewingAppointment", "mutation", variables);
        },
        UploadAgentPhoto: function UploadAgentPhoto(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: UploadAgentPhotoDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "UploadAgentPhoto", "mutation", variables);
        },
        RemoveSavedSearch: function RemoveSavedSearch(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: RemoveSavedSearchDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "RemoveSavedSearch", "mutation", variables);
        },
        UpdateSavedSearch: function UpdateSavedSearch(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: UpdateSavedSearchDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "UpdateSavedSearch", "mutation", variables);
        },
        InitiateCustomerTask: function InitiateCustomerTask(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: InitiateCustomerTaskDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "InitiateCustomerTask", "mutation", variables);
        },
        CreateBuyDirectListingOffer: function CreateBuyDirectListingOffer(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: CreateBuyDirectListingOfferDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "CreateBuyDirectListingOffer", "mutation", variables);
        },
        GetSchools: function GetSchools(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetSchoolsDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetSchools", "query", variables);
        },
        GetPropertyStatusForRoute: function GetPropertyStatusForRoute(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetPropertyStatusForRouteDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetPropertyStatusForRoute", "query", variables);
        },
        GetMarketplacePropertyForRoute: function GetMarketplacePropertyForRoute(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetMarketplacePropertyForRouteDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetMarketplacePropertyForRoute", "query", variables);
        },
        GetAddressForId: function GetAddressForId(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetAddressForIdDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetAddressForId", "query", variables);
        },
        GetShortListingPropertyInfo: function GetShortListingPropertyInfo(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetShortListingPropertyInfoDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetShortListingPropertyInfo", "query", variables);
        },
        GetMarketplacePropertyReaction: function GetMarketplacePropertyReaction(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetMarketplacePropertyReactionDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetMarketplacePropertyReaction", "query", variables);
        },
        GetMarketplacePropertySimilarProperties: function GetMarketplacePropertySimilarProperties(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetMarketplacePropertySimilarPropertiesDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetMarketplacePropertySimilarProperties", "query", variables);
        },
        GetMarketplaceProperty: function GetMarketplaceProperty(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetMarketplacePropertyDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetMarketplaceProperty", "query", variables);
        },
        GetMarketplacePropertySellerDisclosures: function GetMarketplacePropertySellerDisclosures(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetMarketplacePropertySellerDisclosuresDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetMarketplacePropertySellerDisclosures", "query", variables);
        },
        GetMarketplacePropertyAccessCode: function GetMarketplacePropertyAccessCode(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetMarketplacePropertyAccessCodeDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetMarketplacePropertyAccessCode", "query", variables);
        },
        GetLongListingPropertyInfo: function GetLongListingPropertyInfo(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetLongListingPropertyInfoDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetLongListingPropertyInfo", "query", variables);
        },
        GetMarketplacePropertySearch: function GetMarketplacePropertySearch(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetMarketplacePropertySearchDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetMarketplacePropertySearch", "query", variables);
        },
        GetMarketplacePropertyList: function GetMarketplacePropertyList(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetMarketplacePropertyListDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetMarketplacePropertyList", "query", variables);
        },
        GetPropertiesByMarket: function GetPropertiesByMarket(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetPropertiesByMarketDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetPropertiesByMarket", "query", variables);
        },
        GetIsLikedByAddressIdForCurrentUser: function GetIsLikedByAddressIdForCurrentUser(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetIsLikedByAddressIdForCurrentUserDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetIsLikedByAddressIdForCurrentUser", "query", variables);
        },
        GetPropertyPhotosByAddressIDs: function GetPropertyPhotosByAddressIDs(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetPropertyPhotosByAddressIDsDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetPropertyPhotosByAddressIDs", "query", variables);
        },
        GetVariantRequest: function GetVariantRequest(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetVariantRequestDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetVariantRequest", "query", variables);
        },
        GetSeveralVariantsRequest: function GetSeveralVariantsRequest(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetSeveralVariantsRequestDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetSeveralVariantsRequest", "query", variables);
        },
        GetSeveralFeatureFlagsRequest: function GetSeveralFeatureFlagsRequest(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetSeveralFeatureFlagsRequestDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetSeveralFeatureFlagsRequest", "query", variables);
        },
        ListLeadsOnUniqueAddresses: function ListLeadsOnUniqueAddresses(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: ListLeadsOnUniqueAddressesDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "ListLeadsOnUniqueAddresses", "query", variables);
        },
        GetUnlockPropertyInfo: function GetUnlockPropertyInfo(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetUnlockPropertyInfoDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetUnlockPropertyInfo", "query", variables);
        },
        GetGeoShapeFromUserLocation: function GetGeoShapeFromUserLocation(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetGeoShapeFromUserLocationDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetGeoShapeFromUserLocation", "query", variables);
        },
        GetPropertiesFromGeoShape: function GetPropertiesFromGeoShape(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetPropertiesFromGeoShapeDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetPropertiesFromGeoShape", "query", variables);
        },
        AddressAutocomplete: function AddressAutocomplete(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: AddressAutocompleteDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "AddressAutocomplete", "query", variables);
        },
        GetCurrentCustomer: function GetCurrentCustomer(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetCurrentCustomerDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetCurrentCustomer", "query", variables);
        },
        GetViewingAppointmentsData: function GetViewingAppointmentsData(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetViewingAppointmentsDataDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetViewingAppointmentsData", "query", variables);
        },
        GetViewingAppointmentsByCustomer: function GetViewingAppointmentsByCustomer(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetViewingAppointmentsByCustomerDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetViewingAppointmentsByCustomer", "query", variables);
        },
        SearchLocations: function SearchLocations(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: SearchLocationsDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "SearchLocations", "query", variables);
        },
        SearchZonesByLocation: function SearchZonesByLocation(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: SearchZonesByLocationDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "SearchZonesByLocation", "query", variables);
        },
        GetMarketCoordinates: function GetMarketCoordinates(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetMarketCoordinatesDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetMarketCoordinates", "query", variables);
        },
        GetMarketplacePropertyCoreDetails: function GetMarketplacePropertyCoreDetails(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetMarketplacePropertyCoreDetailsDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetMarketplacePropertyCoreDetails", "query", variables);
        },
        HistoricalMarketMetricsQuery: function HistoricalMarketMetricsQuery(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: HistoricalMarketMetricsQueryDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "HistoricalMarketMetricsQuery", "query", variables);
        },
        GetMarketMetricsQuery: function GetMarketMetricsQuery(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetMarketMetricsQueryDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetMarketMetricsQuery", "query", variables);
        },
        GetMarketplacePropertyDetailsForMapMarkers: function GetMarketplacePropertyDetailsForMapMarkers(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetMarketplacePropertyDetailsForMapMarkersDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetMarketplacePropertyDetailsForMapMarkers", "query", variables);
        },
        GetBuyerPropertyReactions: function GetBuyerPropertyReactions(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetBuyerPropertyReactionsDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetBuyerPropertyReactions", "query", variables);
        },
        GetZoneData: function GetZoneData(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetZoneDataDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetZoneData", "query", variables);
        },
        AddressSearch: function AddressSearch(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: AddressSearchDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "AddressSearch", "query", variables);
        },
        FavoriteProperties: function FavoriteProperties(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: FavoritePropertiesDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "FavoriteProperties", "query", variables);
        },
        GetActiveBuyMarkets: function GetActiveBuyMarkets(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetActiveBuyMarketsDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetActiveBuyMarkets", "query", variables);
        },
        PurchaseTransaction: function PurchaseTransaction(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: PurchaseTransactionDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "PurchaseTransaction", "query", variables);
        },
        BuyerOffersMinimal: function BuyerOffersMinimal(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: BuyerOffersMinimalDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "BuyerOffersMinimal", "query", variables);
        },
        BuyerOffer: function BuyerOffer(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: BuyerOfferDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "BuyerOffer", "query", variables);
        },
        GetMarketInventoryCounts: function GetMarketInventoryCounts(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetMarketInventoryCountsDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetMarketInventoryCounts", "query", variables);
        },
        GetBuyDirectPropertyInfo: function GetBuyDirectPropertyInfo(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetBuyDirectPropertyInfoDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetBuyDirectPropertyInfo", "query", variables);
        },
        GetResaleOffers: function GetResaleOffers(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetResaleOffersDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetResaleOffers", "query", variables);
        },
        GetBuyDirectS3Urls: function GetBuyDirectS3Urls(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetBuyDirectS3UrlsDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetBuyDirectS3Urls", "query", variables);
        },
        GetCloseOfEscrowHolidays: function GetCloseOfEscrowHolidays(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetCloseOfEscrowHolidaysDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetCloseOfEscrowHolidays", "query", variables);
        }
    };
}

;// CONCATENATED MODULE: ./src/__generated__/partnerships.ts


function partnerships_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query ValidateEmail($email: String!) {\n  validateEmail(email: $email) {\n    isValid\n    normalizedEmail\n  }\n}\n    "
    ]);
    partnerships_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ValidateEmailDocument = lib(partnerships_templateObject());
var partnerships_defaultWrapper = function(action, _operationName, _operationType, _variables) {
    return action();
};
function partnerships_getSdk(client) {
    var withWrapper = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : partnerships_defaultWrapper;
    return {
        ValidateEmail: function ValidateEmail(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: ValidateEmailDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "ValidateEmail", "query", variables);
        }
    };
}

// EXTERNAL MODULE: ./src/components/globals.ts
var globals = __webpack_require__(35480);
// EXTERNAL MODULE: ./src/components/helpers/hooks.ts
var hooks = __webpack_require__(94886);
// EXTERNAL MODULE: ./src/components/shared/trackers.tsx
var trackers = __webpack_require__(59431);
;// CONCATENATED MODULE: ./src/components/api/index.ts
/* provided dependency */ var process = __webpack_require__(34155);













/**
 * A wrapper around `fetch` with optional retries.
 * Retries up to `options.retries` times (defaults to `5` if not specified)
 * with a delay of `options.retryDelay` (defaults to `500ms` if not specified)
 */ var fetchWithRetry = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(url, options) {
        var retries, retryDelay, err;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    retries = options.retries || 0;
                    retryDelay = options.retryDelay || 500;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        6
                    ]);
                    return [
                        4,
                        fetch(url, options)
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    err = _state.sent();
                    if (retries < 1) throw err;
                    // sleep the specified amount of time, then recursively retry
                    return [
                        4,
                        new Promise(function(r) {
                            return setTimeout(r, retryDelay);
                        })
                    ];
                case 4:
                    _state.sent();
                    return [
                        4,
                        fetchWithRetry(url, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, options), {
                            retries: retries - 1
                        }))
                    ];
                case 5:
                    return [
                        2,
                        _state.sent()
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchWithRetry(url, options) {
        return _ref.apply(this, arguments);
    };
}();
var Sentry = observability_slim/* globalObservability.getSentryClient */.w.getSentryClient();
// To do: strengthen jsonParam's type
// Do not pass skip doBFFPost as it will not actually skip making the request - instead handle it conditionally
function doBFFPost(apiUrl, jsonParams) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return fetchWithRetry(apiUrl, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        retries: 5,
        retryDelay: 500,
        credentials: "include",
        method: "POST",
        body: JSON.stringify(jsonParams)
    }, options), {
        headers: (0,_object_spread/* default */.Z)({
            Accept: "application/json",
            "Content-Type": "application/json",
            "X-CSRF-Token": js_cookie.get(globals/* XSRF_COOKIE_KEY */.x0) || ""
        }, options.headers)
    }));
}
function getAthenaClient(incomingRequestHeaders, options) {
    // Use explicit headers if provided, otherwise try AsyncLocalStorage context
    // This allows SSR pages to wrap their logic with withRequestContext() and have
    // all nested getAthenaClient() calls automatically receive headers
    var effectiveHeaders = incomingRequestHeaders;
    // Only import requestContext on server-side to prevent webpack bundling async_hooks for client
    if (!effectiveHeaders && "object" === "undefined") { var getRequestHeaders; }
    var tivoHeaders = [];
    if (globals/* DEPLOY_ENV */.Zp === "test") {
        if (effectiveHeaders) {
            // Filter out any headers that are not prefixed with 'x-tivo-'
            tivoHeaders = Object.fromEntries(Object.entries(effectiveHeaders).filter(function(param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 1), key = _param[0];
                return key.startsWith("x-tivo-");
            }));
        }
    }
    // Forward cookies for SSR authentication
    var headers = (0,_object_spread/* default */.Z)({
        "apollographql-client-name": "cosmos"
    }, tivoHeaders);
    // If we have request headers (explicit or from context), forward the cookie header
    if (effectiveHeaders === null || effectiveHeaders === void 0 ? void 0 : effectiveHeaders.cookie) {
        headers.cookie = effectiveHeaders.cookie;
    }
    // Local development auth bypass - send user token to local Athena
    // eslint-disable-next-line @opendoor/no-direct-env-check
    var devUserToken = process.env.ATHENA_DEV_USER_TOKEN || process.env.NEXT_PUBLIC_ATHENA_DEV_USER_TOKEN;
    if (globals/* DEPLOY_ENV */.Zp === "development" && devUserToken) {
        headers["x-athena-request-user"] = devUserToken;
    }
    var ref;
    return getSdk(new main/* GraphQLClient */.g6(globals/* ATHENA_URL */.Uw, {
        credentials: "include",
        headers: headers,
        // graphql-request vendors its own DOM type defs whose AbortSignal
        // diverges from the native type. Identical at runtime.
        signal: (ref = options === null || options === void 0 ? void 0 : options.signal) !== null && ref !== void 0 ? ref : undefined
    }));
}
function getPartnershipsClient() {
    return partnerships_getSdk(new main/* GraphQLClient */.g6("".concat(globals/* PARTNERSHIP_BFF_URL */.Ff, "/api/internal/graphql"), {
        credentials: "include",
        headers: {
            "apollographql-client-name": "cosmos"
        }
    }));
}
function doGet(path) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return fetchWithRetry("".concat(globals/* RAILS_URL */.oF).concat(path), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        retries: 5,
        retryDelay: 500,
        credentials: "include"
    }, options), {
        headers: (0,_object_spread/* default */.Z)({
            Accept: "application/json",
            "Content-Type": "application/json",
            "X-CSRF-Token": js_cookie.get(globals/* XSRF_COOKIE_KEY */.x0) || ""
        }, options.headers)
    }));
}
function trackLead(trackingKeywords) {
    return doGet("/track/".concat(trackingKeywords));
}
function getSessionExtras() {
    return _getSessionExtras.apply(this, arguments);
}
function _getSessionExtras() {
    _getSessionExtras = (0,_async_to_generator/* default */.Z)(function() {
        var ref, response, data, ref1, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        doGet("/session/info")
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    data = _state.sent();
                    return [
                        2,
                        {
                            has_resale_closing_dashboard: (ref1 = (ref = data.human) === null || ref === void 0 ? void 0 : ref.has_resale_closing_dashboard) !== null && ref1 !== void 0 ? ref1 : false
                        }
                    ];
                case 3:
                    e = _state.sent();
                    return [
                        2,
                        {
                            has_resale_closing_dashboard: false
                        }
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _getSessionExtras.apply(this, arguments);
}
function validatePartnerEmailAddress(email) {
    return _validatePartnerEmailAddress.apply(this, arguments);
}
function _validatePartnerEmailAddress() {
    _validatePartnerEmailAddress = (0,_async_to_generator/* default */.Z)(function(email) {
        var ref;
        return (0,tslib_es6.__generator)(this, function(_state) {
            try {
                return [
                    2,
                    getPartnershipsClient().ValidateEmail({
                        email: email
                    })
                ];
            } catch (e) {
                ;
                (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, e);
                return [
                    2
                ];
            }
            return [
                2
            ];
        });
    });
    return _validatePartnerEmailAddress.apply(this, arguments);
}
var createSellerInput = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param, param1) {
        var street1, unit, city, postal_code, state, product, url, ref, channel, covid19Whitelist, experimentEntityId, sellerFlowNameOverride, sellerFlowUuidOverride, trackingKeywords, partnerReferralId, addressUUID;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    street1 = param.street1, unit = param.unit, city = param.city, postal_code = param.postal_code, state = param.state, product = param1.product, url = param1.url, ref = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : {}, channel = ref.channel, covid19Whitelist = ref.covid19Whitelist, experimentEntityId = ref.experiment_entity_id, sellerFlowNameOverride = ref.seller_flow_name_override, sellerFlowUuidOverride = ref.seller_flow_uuid_override, trackingKeywords = ref.trackingKeywords, partnerReferralId = ref.partnerReferralId, addressUUID = _arguments.length > 3 ? _arguments[3] : void 0;
                    if (!trackingKeywords) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        trackLead(trackingKeywords).catch(function(e) {
                            var ref;
                            return (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, e);
                        })
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        2,
                        doBFFPost(globals/* ATHENA_URL */.Uw, {
                            operationName: "CreateSellerInputWithTrackingDataFromCookies",
                            query: "mutation CreateSellerInputWithTrackingDataFromCookies(\n        $input: OdProtosReceptionServices_CreateSellerInputRequestInput!\n      ) {\n        reception {\n          createSellerInputWithTrackingDataFromCookies(input: $input) {\n            sellerInput {\n              uuid\n              pdpUrl\n              isInPartnershipDenialServiceRegions\n              address {\n                postalCode\n              }\n              analyticsMetadata {\n                addressEntry {\n                  product\n                  url\n                }\n              }\n            }\n          }\n        }\n      }",
                            variables: {
                                input: {
                                    address: {
                                        uuid: addressUUID,
                                        city: city,
                                        postalCode: postal_code,
                                        state: state,
                                        street: street1,
                                        unit: unit
                                    },
                                    channel: channel,
                                    partnerReferralId: partnerReferralId,
                                    experimentEntityId: experimentEntityId,
                                    sellerFlowNameOverride: sellerFlowNameOverride,
                                    sellerFlowUuidOverride: sellerFlowUuidOverride,
                                    covid19Whitelist: covid19Whitelist,
                                    analyticsMetadata: {
                                        addressEntry: {
                                            product: product,
                                            url: url
                                        }
                                    }
                                }
                            }
                        }, {
                            headers: {
                                "apollographql-client-name": "cosmos"
                            }
                        }).then(handleResponse)
                    ];
            }
        });
    });
    return function createSellerInput(_, _1) {
        return _ref.apply(this, arguments);
    };
}();
var updateAnswers = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(answers, sellerFlowLastCompletedSlug, sellerInputUUID) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                doBFFPost(globals/* ATHENA_URL */.Uw, {
                    operationName: "UpdateAnswers",
                    query: "mutation UpdateAnswers(\n        $answers: String!\n        $sellerFlowLastCompletedSlug: String!\n        $sellerInputUUID: String!\n      ) {\n        reception {\n          updateSellerInput(\n            input: {\n              uuid: $sellerInputUUID\n              answers: $answers\n              sellerFlowLastCompletedSlug: $sellerFlowLastCompletedSlug\n            }\n          ) {\n            sellerInput {\n              uuid\n            }\n          }\n        }\n      }",
                    variables: {
                        answers: JSON.stringify(answers),
                        sellerFlowLastCompletedSlug: sellerFlowLastCompletedSlug,
                        sellerInputUUID: sellerInputUUID
                    }
                }, {
                    headers: {
                        "apollographql-client-name": "cosmos"
                    }
                }).then(handleResponse)
            ];
        });
    });
    return function updateAnswers(answers, sellerFlowLastCompletedSlug, sellerInputUUID) {
        return _ref.apply(this, arguments);
    };
}();
function handleResponse(res) {
    var ref;
    if (res.ok) {
        return res.json();
    }
    (ref = Sentry.withScope) === null || ref === void 0 ? void 0 : ref.call(Sentry, function(scope) {
        var ref;
        scope.setExtras({
            resonse: res
        });
        (ref = Sentry.captureMessage) === null || ref === void 0 ? void 0 : ref.call(Sentry, "Non-200 response received in cosmos api call");
    });
    return;
}
var getGrainID = function(customerUUID, anonId) {
    var anonymousId = (0,trackers/* getAnonymousId */.y)() || anonId;
    return {
        primaryId: {
            customerUuid: customerUUID ? customerUUID : null
        },
        temporaryId: {
            anonymousId: anonymousId ? anonymousId : null
        }
    };
};
function getFeatureFlag(name, customerUUID) {
    return _getFeatureFlag.apply(this, arguments);
}
function _getFeatureFlag() {
    _getFeatureFlag = (0,_async_to_generator/* default */.Z)(function(name, customerUUID) {
        var options, anonymousId, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, _isLoading, isLoading, _defaultValue, defaultValue, props, customer, shouldOverrideLocally, res;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    options = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : {}, anonymousId = _arguments.length > 3 ? _arguments[3] : void 0;
                    _isLoading = options.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, _defaultValue = options.defaultValue, defaultValue = _defaultValue === void 0 ? "control" : _defaultValue, props = options.props;
                    customer = getGrainID(customerUUID, anonymousId);
                    shouldOverrideLocally = (0,hooks/* getLocalFeatureFlagOverrides */.iE)(name);
                    if (shouldOverrideLocally) {
                        // Returns true if override exists
                        return [
                            2,
                            Promise.resolve(shouldOverrideLocally)
                        ];
                    }
                    if (isLoading) {
                        return [
                            2,
                            defaultValue
                        ];
                    }
                    return [
                        4,
                        doBFFPost(globals/* ATHENA_URL */.Uw, {
                            operationName: "GetSeveralFeatureFlagsRequest",
                            query: "query GetSeveralFeatureFlagsRequest(\n          $grain: OdProtosVariantData_GrainInput\n          $keys: [String!]\n          $props: GoogleProtobuf_StructInput\n        ) {\n          variant {\n            getFeatureFlags(input: { grain: $grain, keys: $keys, props: $props }) {\n              variants {\n                key\n                value {\n                  value\n                }\n              }\n            }\n          }\n        }",
                            variables: {
                                grain: {
                                    grain: {
                                        customer: customer
                                    }
                                },
                                keys: [
                                    name
                                ],
                                props: props
                            }
                        }, {
                            headers: {
                                "apollographql-client-name": "cosmos"
                            }
                        }).then(function(res) {
                            if (res.ok) {
                                return res.json();
                            }
                            return;
                        }).catch(function(e) {
                            var ref;
                            return (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, e);
                        })
                    ];
                case 1:
                    res = _state.sent();
                    // Returns default if there is no value for the FF
                    if (!((ref3 = res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : (ref1 = ref.variant) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.getFeatureFlags) === null || ref2 === void 0 ? void 0 : ref2.variants[0].value) === null || ref3 === void 0 ? void 0 : ref3.value)) {
                        return [
                            2,
                            defaultValue
                        ];
                    }
                    return [
                        2,
                        (ref7 = (ref4 = res.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.variant) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.getFeatureFlags) === null || ref6 === void 0 ? void 0 : ref6.variants[0].value) === null || ref7 === void 0 ? void 0 : ref7.value
                    ];
            }
        });
    });
    return _getFeatureFlag.apply(this, arguments);
}
function GetUnlockPropertyInfo(addressId) {
    return _GetUnlockPropertyInfo.apply(this, arguments);
}
function _GetUnlockPropertyInfo() {
    _GetUnlockPropertyInfo = (0,_async_to_generator/* default */.Z)(function(addressId) {
        var ref;
        return (0,tslib_es6.__generator)(this, function(_state) {
            try {
                return [
                    2,
                    getAthenaClient().GetUnlockPropertyInfo({
                        addressId: addressId
                    })
                ];
            } catch (e) {
                ;
                (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, e);
                return [
                    2
                ];
            }
            return [
                2
            ];
        });
    });
    return _GetUnlockPropertyInfo.apply(this, arguments);
}
function GetGeoShapeFromUserLocation(latitude, longitude, shapeGeoOption) {
    return _GetGeoShapeFromUserLocation.apply(this, arguments);
}
function _GetGeoShapeFromUserLocation() {
    _GetGeoShapeFromUserLocation = (0,_async_to_generator/* default */.Z)(function(latitude, longitude, shapeGeoOption) {
        var ref;
        return (0,tslib_es6.__generator)(this, function(_state) {
            try {
                return [
                    2,
                    getAthenaClient().GetGeoShapeFromUserLocation({
                        latitude: latitude,
                        longitude: longitude,
                        shapeGeoOption: shapeGeoOption
                    })
                ];
            } catch (e) {
                ;
                (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, e);
                return [
                    2
                ];
            }
            return [
                2
            ];
        });
    });
    return _GetGeoShapeFromUserLocation.apply(this, arguments);
}
function GetPropertiesFromGeoShape(shape, filters, paginationRequest) {
    return _GetPropertiesFromGeoShape.apply(this, arguments);
}
function _GetPropertiesFromGeoShape() {
    _GetPropertiesFromGeoShape = (0,_async_to_generator/* default */.Z)(function(shape, filters, paginationRequest) {
        var ref;
        return (0,tslib_es6.__generator)(this, function(_state) {
            try {
                return [
                    2,
                    getAthenaClient().GetPropertiesFromGeoShape({
                        shape: shape,
                        filters: filters,
                        paginationRequest: paginationRequest
                    })
                ];
            } catch (e) {
                ;
                (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, e);
                return [
                    2
                ];
            }
            return [
                2
            ];
        });
    });
    return _GetPropertiesFromGeoShape.apply(this, arguments);
}
function AddressAutocomplete(query, filters, pageInput, latitude, longitude) {
    return _AddressAutocomplete.apply(this, arguments);
}
function _AddressAutocomplete() {
    _AddressAutocomplete = (0,_async_to_generator/* default */.Z)(function(query, filters, pageInput, latitude, longitude) {
        var ref;
        return (0,tslib_es6.__generator)(this, function(_state) {
            try {
                return [
                    2,
                    getAthenaClient().AddressAutocomplete({
                        query: query,
                        filters: filters,
                        latitude: latitude,
                        longitude: longitude,
                        pageInput: pageInput
                    })
                ];
            } catch (e) {
                ;
                (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, e);
                return [
                    2
                ];
            }
            return [
                2
            ];
        });
    });
    return _AddressAutocomplete.apply(this, arguments);
}
function fetchSellerReturnExperience(sellerInputUUID) {
    return doBFFPost(globals/* ATHENA_URL */.Uw, {
        operationName: "ReturnExperienceQuery",
        query: "query ReturnExperienceQuery($sellerInputUUID: String!) {\n      reception {\n        getSellerInput(input: { uuid: $sellerInputUUID }) {\n          sellerInput {\n            productOfferings {\n              product\n              deniedAt\n            }\n            address {\n              street\n              unitType\n              unitNumber\n              city\n              state\n              postalCode\n            }\n            answers {\n              email\n              homeGuideRegistered\n            }\n            sellerFlowLastCompletedSlug\n          }\n        }\n      }\n      sellDirect {\n        getLead(input: { lead: { source: { type: RECEPTION, id: $sellerInputUUID }} }) {\n          lead {\n            isQualified\n            customerV2 {\n              uuid\n              firstName\n            }\n            address {\n              uuid\n              street\n            }\n            latestOffer {\n              preliminaryOfferExpirationDate\n              state\n              headlinePriceCents\n              offerRequestSource\n            }\n            previousOffer {\n              headlinePriceCents\n            }\n          }\n        }\n      }\n    }",
        variables: {
            sellerInputUUID: sellerInputUUID
        }
    }, {
        headers: {
            "apollographql-client-name": "cosmos"
        }
    }).then(handleResponse).catch(function(e) {
        var ref;
        return (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, e);
    });
}
function unsubscribeMailer(addressUuid) {
    return doBFFPost(globals/* ATHENA_URL */.Uw, {
        operationName: "UnsubscribeMailer",
        query: "mutation UnsubscribeMailer($address: OdProtosWebServicesMarketing_UnsubscribeMailerRequestInput!) {\n      marketing {\n        unsubscribeMailer(input: $address) {\n          _empty\n        }\n      }\n    }",
        variables: {
            address: {
                addressToken: addressUuid
            }
        }
    }, {
        headers: {
            "apollographql-client-name": "cosmos"
        }
    }).then(handleResponse).catch(function(e) {
        var ref;
        return (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, e);
    });
}
function requestNewToken(expiredToken) {
    return doBFFPost(globals/* ATHENA_URL */.Uw, {
        operationName: "RequestNewToken",
        query: "mutation RequestNewToken($expiredToken: String!) {\n        passwordless {\n          requestNewToken(input: {token: $expiredToken }) {\n            token\n          }\n        }\n      }",
        variables: {
            expiredToken: expiredToken
        }
    }, {
        headers: {
            "apollographql-client-name": "cosmos"
        }
    }).then(handleResponse).catch(function(e) {
        var ref;
        return (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, e);
    });
}
function requestNewTokenByEmail(email, redirectUrl) {
    return doBFFPost(globals/* ATHENA_URL */.Uw, {
        operationName: "RequestNewToken",
        query: "mutation RequestNewToken($email: String!, $redirectUrl: String) {\n        passwordless {\n          requestNewToken(input: {email: $email, redirectUrl: $redirectUrl}) {\n            token\n          }\n        }\n      }",
        variables: {
            email: email,
            redirectUrl: redirectUrl
        }
    }, {
        headers: {
            "apollographql-client-name": "cosmos"
        }
    }).then(handleResponse).catch(function(e) {
        var ref;
        return (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, e);
    });
}
function updateCurrentCustomer(params) {
    return _updateCurrentCustomer.apply(this, arguments);
}
function _updateCurrentCustomer() {
    _updateCurrentCustomer = (0,_async_to_generator/* default */.Z)(function(params) {
        var e, ref;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        getAthenaClient().UpdateCurrentCustomer({
                            customerUpdates: params
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
                case 2:
                    e = _state.sent();
                    (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, e);
                    return [
                        2
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _updateCurrentCustomer.apply(this, arguments);
}
function fetchTraitByAnonymousId(traitName, anonymousId) {
    return doBFFPost(ATHENA_URL, {
        operationName: "GetTrait",
        query: "query GetTrait($anonymousUuid: String, $traitName: String) {\n        insightV2 {\n          getTraitForIdentifier(\n            input: {\n              identifier: {\n                identifier: {\n                  customerIdentifier: { identifier: { anonymousId: $anonymousUuid } }\n                }\n              }\n              traitName: $traitName\n            }\n          ) {\n            trait {\n              name\n              value {\n                kind {\n                  ... on GoogleProtobuf_Value_KindOneof_StringValue {\n                    stringValue\n                  }\n                  ... on GoogleProtobuf_Value_KindOneof_ListValue {\n                    listValue {\n                      values {\n                        kind {\n                          ... on GoogleProtobuf_Value_KindOneof_StringValue {\n                            stringValue\n                          }\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }",
        variables: {
            anonymousUuid: anonymousId,
            traitName: traitName
        }
    }, {
        headers: {
            "apollographql-client-name": "cosmos"
        }
    }).then(handleResponse).catch(function(e) {
        var ref;
        (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, e);
        return null;
    });
}
var CancelBuyDirectOfferStatus = {
    SUCCESS_OFFER_CANCELLED: "SUCCESS_OFFER_CANCELLED",
    SUCCESS_TASK_CREATED: "SUCCESS_TASK_CREATED"
};
function cancelBuyDirectOffer(listingOfferUuid) {
    return doBFFPost(globals/* ATHENA_URL */.Uw, {
        operationName: "CancelBuyDirectOffer",
        query: "mutation CancelBuyDirectOffer($listingOfferUuid: String!) {\n        webBuyDirectListingOffer {\n          cancelBuyDirectOffer(input: { listingOfferUuid: $listingOfferUuid }) {\n            __typename\n            status\n          }\n        }\n      }",
        variables: {
            listingOfferUuid: listingOfferUuid
        }
    }, {
        headers: {
            "apollographql-client-name": "cosmos"
        }
    }).then(handleResponse).catch(function(e) {
        var ref;
        (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, e);
        return null;
    });
}
// Buy Direct Checkout API functions
function getBuyDirectPropertyInfo(addressToken) {
    return _getBuyDirectPropertyInfo.apply(this, arguments);
}
function _getBuyDirectPropertyInfo() {
    _getBuyDirectPropertyInfo = (0,_async_to_generator/* default */.Z)(function(addressToken) {
        var e, ref;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        getAthenaClient().GetBuyDirectPropertyInfo({
                            addressToken: addressToken
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
                case 2:
                    e = _state.sent();
                    (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, e);
                    throw e;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _getBuyDirectPropertyInfo.apply(this, arguments);
}
function getResaleOffers(customerId) {
    return _getResaleOffers.apply(this, arguments);
}
function _getResaleOffers() {
    _getResaleOffers = (0,_async_to_generator/* default */.Z)(function(customerId) {
        var e, ref;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        getAthenaClient().GetResaleOffers({
                            customerId: customerId
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
                case 2:
                    e = _state.sent();
                    (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, e);
                    throw e;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _getResaleOffers.apply(this, arguments);
}


/***/ }),

/***/ 35480:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EQ": function() { return /* binding */ COSMOS_URL; },
/* harmony export */   "Ff": function() { return /* binding */ PARTNERSHIP_BFF_URL; },
/* harmony export */   "Kz": function() { return /* binding */ CONSUMER_URL; },
/* harmony export */   "Ut": function() { return /* binding */ REDIRECT_URLS_REGEX; },
/* harmony export */   "Uw": function() { return /* binding */ ATHENA_URL; },
/* harmony export */   "WL": function() { return /* binding */ EXCLUSIVE_RAILS_HOST; },
/* harmony export */   "Zp": function() { return /* binding */ DEPLOY_ENV; },
/* harmony export */   "eH": function() { return /* binding */ LAZY_LOAD_OFFSET; },
/* harmony export */   "ed": function() { return /* binding */ CONSUMER_FE_URL; },
/* harmony export */   "eu": function() { return /* binding */ GOOGLE_MAPS_API_KEY; },
/* harmony export */   "go": function() { return /* binding */ MITEK_SDK_PATH; },
/* harmony export */   "hW": function() { return /* binding */ MITEK_LICENSE; },
/* harmony export */   "oF": function() { return /* binding */ RAILS_URL; },
/* harmony export */   "oe": function() { return /* binding */ MITEK_SCIENCE_SDK_PATH; },
/* harmony export */   "sE": function() { return /* binding */ DATADOG_RUM_APPLICATION_CLIENT_TOKEN; },
/* harmony export */   "vt": function() { return /* binding */ DATADOG_RUM_APPLICATION_ID; },
/* harmony export */   "vu": function() { return /* binding */ MORTGAGE_API_URL; },
/* harmony export */   "wL": function() { return /* binding */ GOOGLE_CLIENT_ID; },
/* harmony export */   "x0": function() { return /* binding */ XSRF_COOKIE_KEY; },
/* harmony export */   "xR": function() { return /* binding */ MAPBOX_KEY; },
/* harmony export */   "zu": function() { return /* binding */ COSMOS_URLS; }
/* harmony export */ });
/* unused harmony export BUYER_HOST */
/* harmony import */ var _opendoor_shared_fe_build_commonGlobals__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85491);

// eslint-disable-next-line @opendoor/no-direct-env-check
var DEPLOY_ENV = "production" || 0;
var secrets = _opendoor_shared_fe_build_commonGlobals__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[DEPLOY_ENV];
var XSRF_COOKIE_KEY = DEPLOY_ENV !== "development" ? "XSRF-G-TOKEN" : "XSRF-TOKEN";
var CONSUMER_FE_URL = secrets.consumerFeUrl;
var GOOGLE_CLIENT_ID = secrets.googleClientID;
var GOOGLE_MAPS_API_KEY = secrets.googleMaps;
var RAILS_URL = secrets.railsUrl;
var REDIRECT_URLS_REGEX = secrets.redirectURLsRegex;
var PARTNERSHIP_BFF_URL = secrets.partnerBffUrl;
var DATADOG_RUM_APPLICATION_ID = "a317f46d-d080-42c8-967f-147a7dfd8863";
var DATADOG_RUM_APPLICATION_CLIENT_TOKEN = "pub5745c1085abb698bce5cfc45d4c737ba";
var MAPBOX_KEY = "pk.eyJ1Ijoib3BlbmRvb3IiLCJhIjoiY2xqaGNqY294MDJ6bTNmbzNteDZreWp6bCJ9.xN6JQcm_ppepFmpk_UUBrw";
var MITEK_PATH = "/_odfiles/mitek-v5.5.0";
var MITEK_SDK_PATH = "".concat(MITEK_PATH, "/mitekSDK");
var MITEK_SCIENCE_SDK_PATH = "".concat(MITEK_PATH, "/mitek-science-sdk.js");
var MITEK_LICENSE = "eyJzaWduYXR1cmUiOiJFT2xoaURUK1FRL3VPL3hqTTE5NFBySFYwWnBYeVRLT3BqMDFZcHRQWUN4UDRpSHhzSlo4QlZ5N3k5NlNURjFYRnQrL1MyNkxWZEdEa1dmQTdGemFlZkhMQm9pY0tING45VXZ3bXQ2cjVaaVdRZHN0dW9mZVVCWjVOK2syZXNlRCtzcGxNYzhLWE03aU9NYmxPSHVNdW8veUtMMzdlWU45ZzFIOG1UdGVxUGpkRkRrQmZ2bEVGVmdZNG05dlpwVS9Ccmx6dHBFVDZabzhZcTd0STJqbFVuRm5IUjROcTlkcGNaUDZYWWVseWJEczRqSkh6b2FueUFmS0hMTzUrRzM2TmVWV0FINGFpM3BlNmRUb2hQLzNEWWtFMEpocy92Rnk3bWUzS3FPYXVrajhmNWJUbVpPdVN1TjJIK016dUFYcys0WmVuMERuOFNMTmxpa3JnZzJxTWc9PSIsInNpZ25lZCI6eyJleHBpcnkiOiIyMDI0LTA5LTA0IiwiZmVhdHVyZXMiOlsiYmFyY29kZSIsImlkIl0sImFwcGxpY2F0aW9uSWRlbnRpZmllciI6eyJ3ZWIiOlsiKi5vcGVuZG9vci5jb20iLCJvcGVuZG9vci5jb20iLCIqLnNpbXBsZXJzZWxsLmNvbSIsInNpbXBsZXJzZWxsLmNvbSJdfSwiZ3BvIjoiMTZkIiwib3JnYW5pemF0aW9uIjoiTWl0ZWsgU3lzdGVtcyBJbmMuIiwidmVyc2lvbiI6IjEuMCJ9LCJiYXJjb2RlV2ViTGljZW5zZSI6IlZiVTAxN21GcEVYUFJGWmMrN3pwLzRUL01NbkJqZ0xxakNMYUdQMEZrcXJqUmlGam5JM2tNV3V1d3hQQXQvWHpGQXZvTCt0RXVYYTN3amNYdjNOdEZ5bU5BVTVsZllPTlcxdEFhM09pVFBvdzZtZmJJT0tsNDBwNmluNktGNm9RSVcwdWg5UElublRlYVpQUGFteCs5MFJhN1NJZC9rMHZCdjZDdFM5S1Axd0FjZDhCVEZYTlhFUHhudkVMSDN3WFJIQWNReW9odU0wMHMrbCtMQ3dJNzRFVHR0cEFpNTE2MTBXUmlja3NMZlFkNEdRK1ZucVNnZkJyRCtBb0tDOVBrd2w3WVp2Qkpxakk0UnBrOENiem1uKzVNOHZoN3FneGp3S0Q1VmdYK0wzaXNmT0hhNW5qckNSc3B6NS9ESDdpanF3YitJbUNacy9OMDk1cGk4M0Z4ODBkMEU1cHlPWVM3M1psV0R4NC9LWHZtUHloVy9EbDBzMi96WmZ2Zld1ZVMwSHltSVFJS0NUQzNZaldCU2JhWjZ5clpSdzI2U3cwUmt4ZE40VjdvWUJHTThJWEFDY0IzTktLaExTc3NmSy9OMHltVVlNd2pJT1M0c28rY29uWE9WOW45ZGUzdHpYcjErTnhwQ2ZBQ2YrTkhMMmF5TURVY21rYjZCSWM0dURQIn0";
// Hit staging Athena by default in development
//
// To hit local Athena invert the comment & uncommented `development` keys
var ATHENA_URLS = {
    production: "https://graphql.apps.opendoor.com/api/graphql",
    // development: 'http://localhost:4000/api/graphql',
    development: "https://graphql.simplersell.com/api/graphql",
    // development: 'http://athena-api-nginx-vpn-http.apps.internal.opendoor.com/api/graphql',
    qa: "https://graphql.simplersell.com/api/graphql",
    staging: "https://graphql.simplersell.com/api/graphql",
    test: "https://graphql.simplersell.com/api/graphql"
};
var ATHENA_URL = ATHENA_URLS[DEPLOY_ENV];
// Mortgage API URLs
// Hit staging mortgage API by default in development
// To hit local, change development to 'http://localhost:3000/graphql/v1'
var MORTGAGE_API_URLS = {
    production: "https://mortgages.opendoor.com/graphql/v1",
    development: "https://mortgages.simplersell.com/graphql/v1",
    qa: "https://mortgages.simplersell.com/graphql/v1",
    staging: "https://mortgages.simplersell.com/graphql/v1",
    test: "https://mortgages.simplersell.com/graphql/v1"
};
var MORTGAGE_API_URL = MORTGAGE_API_URLS[DEPLOY_ENV];
// Cosmos URL
var COSMOS_URLS = {
    production: "https://www.opendoor.com",
    staging: "https://demo.simplersell.com",
    qa: "https://qa.simplersell.com",
    test: "http://localhost:3011",
    development: "http://localhost:3011"
};
var COSMOS_URL = COSMOS_URLS[DEPLOY_ENV];
// Hit qa Ola by default in development
//
// To hit local Ola invert the comment & uncommented `development` keys
var BUYER_HOSTS = {
    production: "https://buy.opendoor.com",
    // development: 'http://localhost:3000',
    development: "https://staging-buy.simplersell.com",
    qa: "https://staging-buy.simplersell.com",
    staging: "https://staging-buy.simplersell.com",
    test: "https://staging-buy.simplersell.com"
};
// Consumer URLs
var CONSUMER_URLS = {
    production: "https://consumer.opendoor.com",
    development: "https://consumer.simplersell.com",
    qa: "https://consumer.simplersell.com",
    staging: "https://consumer.simplersell.com",
    test: "https://consumer.simplersell.com"
};
var CONSUMER_URL = CONSUMER_URLS[DEPLOY_ENV];
var BUYER_HOST = BUYER_HOSTS[DEPLOY_ENV];
/*
 * Hit staging Rails by default in development
 * To hit local Web backend invert the comment & uncommented `development` keys
 */ var EXCLUSIVE_RAILS_HOSTS = {
    production: "https://www.opendoor.com",
    // development: 'http://localhost:5006',
    // development: 'https://www.opendoor.com',
    development: "https://demo.simplersell.com",
    qa: "https://demo.simplersell.com",
    staging: "https://demo.simplersell.com",
    test: "https://demo.simplersell.com"
};
var EXCLUSIVE_RAILS_HOST = EXCLUSIVE_RAILS_HOSTS[DEPLOY_ENV];
var LAZY_LOAD_OFFSET = 300; // px before the element comes into view


/***/ }),

/***/ 94886:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gv": function() { return /* binding */ useGetFeatureFlag; },
/* harmony export */   "iE": function() { return /* binding */ getLocalFeatureFlagOverrides; }
/* harmony export */ });
/* unused harmony export useCurrentCustomer */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _opendoor_auth_fe__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95674);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61661);





/**
 * Checks for a localstorage feature flag override
 * Used for development/QA only!
 *
 * force enabled -> window.localStorage.setItem('opendoor.reception.alo', true)
 * force disabled -> window.localStorage.setItem('opendoor.reception.alo', false)
 */ var getLocalFeatureFlagOverrides = function(featureFlag) {
    try {
        // Ignore override check on the server
        return  true && window.localStorage.getItem("opendoor.cosmos.".concat(featureFlag)) === "true";
    } catch (e) {
        return false;
    }
};
var useGetFeatureFlag = function(name) {
    var customerUUID = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, anonId = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(options.defaultValue || ""), featureFlag = ref[0], setFeatureFlag = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        (0,_api__WEBPACK_IMPORTED_MODULE_2__/* .getFeatureFlag */ .OC)(name, customerUUID, options, anonId).then(setFeatureFlag);
    }, []);
    return featureFlag;
};
/**
 * Gets the customer data for the currently logged in user and provides a method to update the current cutomer's data.
 */ var useCurrentCustomer = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref = useState(null), customer = ref[0], setCustomer = ref[1];
    var ref1 = useState(true), isLoading = ref1[0], setIsLoading = ref1[1];
    var ref2 = useState(false), isUpdating = ref2[0], setIsUpdating = ref2[1];
    var ref3 = useAuth(), _authentication = ref3.authentication, authState = _authentication.state;
    useEffect(function() {
        if (authState !== "authenticated") {
            setCustomer(null);
            setIsLoading(false);
            return;
        }
        var getCustomer = function() {
            var _ref = _async_to_generator(function() {
                var ref, customerResp, e;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setIsLoading(true);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                4,
                                5
                            ]);
                            return [
                                4,
                                getAthenaClient().GetCurrentCustomer()
                            ];
                        case 2:
                            customerResp = _state.sent();
                            setCustomer(((ref = customerResp.customerService.getCurrentCustomer) === null || ref === void 0 ? void 0 : ref.customer) || null);
                            return [
                                3,
                                5
                            ];
                        case 3:
                            e = _state.sent();
                            setCustomer(null);
                            if (!options.onGetError) throw e;
                            options.onGetError(e);
                            return [
                                3,
                                5
                            ];
                        case 4:
                            setIsLoading(false);
                            return [
                                7
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function getCustomer() {
                return _ref.apply(this, arguments);
            };
        }();
        getCustomer();
    }, [
        authState
    ]);
    var update = function() {
        var _ref = _async_to_generator(function(params) {
            var ref, resp, updatedCustomer, e;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!customer) return [
                            2
                        ];
                        setIsUpdating(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            getAthenaClient().UpdateCurrentCustomer({
                                customerUpdates: params
                            })
                        ];
                    case 2:
                        resp = _state.sent();
                        updatedCustomer = (ref = resp.customerService.updateCurrent) === null || ref === void 0 ? void 0 : ref.updatedCustomer;
                        setCustomer(updatedCustomer);
                        return [
                            2,
                            updatedCustomer
                        ];
                    case 3:
                        e = _state.sent();
                        if (!options.onUpdateError) throw e;
                        options.onUpdateError(e);
                        return [
                            2
                        ];
                    case 4:
                        setIsUpdating(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function update(params) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        customer: customer,
        isLoading: isLoading,
        isUpdating: isUpdating,
        isUserAuthenticated: authState === "authenticated",
        update: update
    };
};


/***/ }),

/***/ 98066:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(28668);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(71418);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37337);
/* harmony import */ var _opendoor_bricks_complex_AutocompleteInput_AutocompleteInput__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(54022);
/* harmony import */ var _opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8013);
/* harmony import */ var _opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26029);
/* harmony import */ var _opendoor_bricks_theme_eero__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(81762);
/* harmony import */ var _opendoor_bricks_theme_eero__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99425);
/* harmony import */ var _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74593);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23279);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);














// Generate unique session token for API billing purposes
// https://developers.google.com/maps/documentation/places/web-service/session-tokens
var generateGoogleMapsSessionToken = function() {
    return Math.floor(Math.random() * Number.MAX_SAFE_INTEGER).toString();
};
var ADDRESS_INPUT_URL = "/_address-input";
var AddressInputDiv = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    target: "e1mo6em90"
})("display:block;position:relative;& .invalid-input,& .autocomplete--error{border:none;box-shadow:none;}", function(props) {
    return props.showPoweredByGoogle && "\n      & ".concat(_opendoor_bricks_complex_AutocompleteInput_AutocompleteInput__WEBPACK_IMPORTED_MODULE_6__/* .ResultList */ .E4, "::after {\n        content: 'powered by Google';\n        display: block;\n        width: 98%;\n        color: transparent;\n        background: url('https://images.opendoor.com/source/s3/imgdrop-production/powered-by-google.png?preset=square-2048&h=18')\n          no-repeat center;\n        background-size: 104px 16px;\n        font-size: 14px;\n      }\n    ");
});
var InlineError = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_opendoor_bricks_complex_AutocompleteInput_AutocompleteInput__WEBPACK_IMPORTED_MODULE_6__/* .ResultList */ .E4, {
    target: "e1mo6em91"
})("background-color:", _opendoor_bricks_theme_eero__WEBPACK_IMPORTED_MODULE_7__/* ["default"].red50 */ .ZP.red50, ";color:#fff;padding:", _opendoor_bricks_theme_eero__WEBPACK_IMPORTED_MODULE_8__/* .space[2] */ .D[2], "px ", _opendoor_bricks_theme_eero__WEBPACK_IMPORTED_MODULE_8__/* .space[6] */ .D[6], "px;border:none;text-align:center;margin-top:-1px;");
var InlineErrorLink = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
        variant: "inline-link",
        color: "neutrals0",
        _hover: {
            color: "neutrals30"
        },
        _active: {
            color: "neutrals30"
        },
        backgroundColor: "transparent"
    }, props));
};
var ALLOWED_TYPES = [
    "street_address",
    "premise",
    "subpremise",
    "route"
];
var _Component;
var AddressInput = /*#__PURE__*/ function(_superClass) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(AddressInput, _superClass);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(AddressInput);
    function AddressInput() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(this, AddressInput);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            addressError: false,
            hasLoaded: false,
            autocompleteOptions: [],
            fetchIsLoading: false,
            addressLoading: false,
            submitOnLoadingComplete: false,
            query: _this.props.initialInput || "",
            selectedIndex: -1,
            sessionToken: generateGoogleMapsSessionToken(),
            isPoweredByGoogle: false
        };
        _this.fetchAutocompleteOptions = lodash_debounce__WEBPACK_IMPORTED_MODULE_3___default()(function(input) {
            _this.setState({
                addressError: false,
                fetchIsLoading: true
            });
            if (!input) {
                _this.setState({
                    addressError: false,
                    autocompleteOptions: [],
                    selectedIndex: -1
                });
                return;
            }
            _this.setState({
                addressError: false
            });
            fetch(_this.buildAutocompleteUrl(input)).then(function(res) {
                return res.json();
            }).then(function(res) {
                var ref, ref1, ref2, ref3;
                (ref = res.predictions) === null || ref === void 0 ? void 0 : ref.forEach(function(result) {
                    result.description = result.description.replace(", USA", "");
                });
                var autocompleteOptions = [];
                if (res.source === "casa") {
                    autocompleteOptions = res.predictions;
                    _this.setState({
                        isPoweredByGoogle: false
                    });
                } else {
                    autocompleteOptions = res.predictions.filter(function(result) {
                        var resultAllowedTypes = result.types.filter(function(value) {
                            return ALLOWED_TYPES.includes(value);
                        });
                        return result.terms.length >= 5 && resultAllowedTypes.length != 0 || // Ensures the string starts with a house number (digits with optional suffix), followed by a space, then the beginning of a street name and another space
                        result.terms.length === 4 && result.terms[0].value.match(/^\d+\S*\s\S+\s/) !== null;
                    });
                    _this.setState({
                        isPoweredByGoogle: true
                    });
                }
                _this.setState({
                    autocompleteOptions: autocompleteOptions,
                    fetchIsLoading: false,
                    hasLoaded: true
                });
                // For direct mail qr code scan, the prefilled address from casa might not completely match with auto complete result
                // so we want to update the query to the first prediction result
                var correctedPrefilledAddress = (ref1 = autocompleteOptions[0]) === null || ref1 === void 0 ? void 0 : ref1.description;
                var prefilledAddress = (ref2 = _this.props.router) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.query) === null || ref3 === void 0 ? void 0 : ref3.pa;
                if (_this.state.query === prefilledAddress && correctedPrefilledAddress && prefilledAddress && correctedPrefilledAddress !== prefilledAddress) {
                    _this.setState({
                        query: correctedPrefilledAddress
                    }, function() {
                        _this.handleQueryChange(correctedPrefilledAddress, false);
                    });
                }
            }).catch(function() {
                return _this.setState({
                    addressError: true,
                    fetchIsLoading: false
                });
            });
        }, 100);
        _this.handleClick = function(e) {
            e.preventDefault();
            if (!_this.state.query.trim()) {
                return;
            }
            if (!_this.state.addressLoading) {
                _this.chooseFirstOrSelectedItem();
            }
        };
        _this.handleBlur = function(e) {
            if (_this.props.setValueOnBlur && _this.state.selectedIndex < 0) {
                _this.chooseFirstOrSelectedItem();
            }
            _this.props.onBlur && _this.props.onBlur(e);
        };
        _this.handleQueryChange = function(newValue, fromResultsSelection) {
            if (!fromResultsSelection) {
                _this.props.onQueryChange && _this.props.onQueryChange(newValue, _this.state.query);
                // use handleQueryChange for fetching results instead of updateOptions since
                // updateOptions has a default debounce of 500, and we want to be quicker
                // in this case
                _this.fetchAutocompleteOptions(newValue);
                _this.setState({
                    query: newValue,
                    hasLoaded: false
                });
            } else {
                // user has used the arrow keys or mouse to select a value in our results dropdown
                _this.setState({
                    query: newValue
                });
            }
        };
        _this.onInputFocus = function(e) {
            _this.props.onFocus && _this.props.onFocus(e);
        };
        _this.handleItemClick = function(autocompleteItem) {
            if (!autocompleteItem.value) {
                // if autocompleteItem does not a value, then it is the raw
                // text typed in from the user
                _this.chooseFirstOrSelectedItem();
            } else {
                _this.chooseResult({
                    result: autocompleteItem
                });
            }
        };
        _this.buildAutocompleteUrl = function(query) {
            return "".concat(ADDRESS_INPUT_URL, "/autocomplete?sessionToken=").concat(_this.state.sessionToken, "&query=").concat(query);
        };
        _this.buildPlacesUrl = function(placeId, addressToken, source) {
            var baseUrl = "".concat(ADDRESS_INPUT_URL, "/place");
            if (source === "casa") {
                return baseUrl + "?addressToken=".concat(addressToken);
            }
            return baseUrl + "?sessionToken=".concat(_this.state.sessionToken, "&placeId=").concat(placeId);
        };
        _this.fetchAddress = function(prediction, onSuccess) {
            var buildPlacesUrl = "";
            var source = "";
            if (_this.isCasaPrediction(prediction.prediction)) {
                source = "casa";
                buildPlacesUrl = _this.buildPlacesUrl("", prediction.prediction.addressToken, source);
            } else {
                source = "google";
                buildPlacesUrl = _this.buildPlacesUrl(prediction.prediction.place_id, "", source);
            }
            fetch(buildPlacesUrl).then(function(res) {
                return res.json();
            }).then(function(address) {
                return onSuccess(address);
            }).catch(function(error) {
                var _obj, ref;
                (ref = (_obj = _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_2__/* .globalObservability.getSentryClient */ .w.getSentryClient()).captureException) === null || ref === void 0 ? void 0 : ref.call(_obj, error);
                _this.setError();
                _this.props.onValidate && _this.props.onValidate(false);
            });
        };
        _this.chooseResult = function(param) {
            var result = param.result, firstPrediction = param.firstPrediction;
            if (!result || !result.prediction) {
                if (_this.state.fetchIsLoading || !_this.state.hasLoaded) {
                    // If we've not loaded any results since last query change and we are
                    // loading still, then wait until loading has completed before deciding
                    // where to send the user
                    if (!_this.state.submitOnLoadingComplete) {
                        _this.setState({
                            submitOnLoadingComplete: true,
                            addressLoading: true
                        });
                    }
                    return;
                }
                _this.setState({
                    addressLoading: true
                });
                if (firstPrediction) {
                    _this.fetchAddress(firstPrediction, function(address) {
                        return _this.props.onChooseManualEntry && _this.props.onChooseManualEntry(_this.props.channel, address);
                    });
                }
                return _this.props.onChooseManualEntry && _this.props.onChooseManualEntry(_this.props.channel);
            }
            _this.setState({
                addressLoading: true
            });
            _this.fetchAddress(result, function(address) {
                _this.submit(address);
                _this.props.onValidate && _this.props.onValidate(true);
                return;
            });
        };
        _this.submit = function(place) {
            _this.props.onSubmit && _this.props.onSubmit(place, _this.props.channel);
            _this.props.shouldRedirectOnSubmit || _this.setState({
                addressLoading: true
            });
        };
        _this.doesQueryMatch = function(prediction, query) {
            var matchedAtStart = false;
            // see how much of our query string matches the parts google has marked as matching
            var matchedLength = prediction.matched_substrings.reduce(function(total, substr) {
                if (substr.offset == 0) {
                    matchedAtStart = true;
                }
                // make sure matched_substring actually occurs in query
                if (query.indexOf(prediction.description.substr(substr.offset, substr.length)) !== -1) {
                    return total + substr.length;
                }
                return total;
            }, prediction.matched_substrings.length - 1);
            if (// if we did not match the query from the beginning, send to manual
            !matchedAtStart || // if we somehow get here and query is empty, go to manual entr
            query.length == 0 || // if the match is < 80% the same, then send user to manual entry
            matchedLength / query.length < 0.8) {
                return false;
            }
            return true;
        };
        _this.doesQueryMatchCasa = function(prediction, query) {
            if (query.length === 0) {
                return false;
            }
            var lowerAddress = prediction.toLowerCase();
            var lowerQuery = query.toLowerCase();
            if (!lowerAddress.startsWith(lowerQuery)) {
                return false;
            }
            var matchedLength = 0;
            for(var i = 0; i < Math.min(lowerAddress.length, lowerQuery.length); i++){
                if (lowerAddress[i] !== lowerQuery[i]) {
                    break;
                }
                matchedLength++;
            }
            return matchedLength / query.length >= 0.8;
        };
        _this.chooseFirstOrSelectedItem = function() {
            // selectedIndex is only set when the user uses arrow keys to select an item
            var _state = _this.state, autocompleteOptions = _state.autocompleteOptions, selectedIndex = _state.selectedIndex;
            var prediction = autocompleteOptions[selectedIndex] || autocompleteOptions[0];
            var buildPredictionResult = function() {
                return {
                    displayValue: prediction.description,
                    value: prediction.description,
                    prediction: prediction
                };
            };
            // Test to see if we have a good prediction match
            // This is to help avoid where users enter a search but we use the first
            // result even if it is a poor match.
            //
            // This can happen when a user enters an address that google/casa does not know
            // about.
            //
            // If we have 4 or 5 matched sub strings then it is probably a good enough match
            var isFirstPredictionFallback = selectedIndex === -1 && prediction && (_this.isCasaPrediction(prediction) && _this.state.query.length < 4 && !_this.doesQueryMatchCasa(prediction.description, _this.state.query) || !_this.isCasaPrediction(prediction) && prediction.matched_substrings.length < 4 && !_this.doesQueryMatch(prediction, _this.state.query));
            if (isFirstPredictionFallback) {
                return _this.chooseResult({
                    firstPrediction: buildPredictionResult()
                });
            }
            // match looks decent enough or is undefined
            return _this.chooseResult({
                result: prediction ? buildPredictionResult() : undefined
            });
        };
        _this.goToManualEntry = function(e) {
            e.preventDefault();
            _this.props.onChooseManualEntry && _this.props.onChooseManualEntry(_this.props.channel);
        };
        _this.placeToOption = function(prediction) {
            return {
                displayValue: prediction.description,
                value: prediction.description,
                prediction: prediction
            };
        };
        _this.displayManualEntry = function() {
            var designStyle = _this.props.designStyle;
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("small", {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(InlineError, {
                    className: "inline-error",
                    designStyle: designStyle,
                    children: [
                        "We couldn’t find that address. Try without zip codes or unit numbers.",
                        _this.props.hideErrorFormLink || /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .Fragment */ .HY, {
                            children: [
                                " ",
                                "Or try our",
                                " ",
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(InlineErrorLink, {
                                    analyticsName: "".concat(_this.props.analyticsName, "-inline-error"),
                                    "aria-label": "Navigate to this link to manually submit an address",
                                    onClick: _this.goToManualEntry,
                                    children: "simplified form"
                                }),
                                "."
                            ]
                        })
                    ]
                })
            });
        };
        return _this;
    }
    var _proto = AddressInput.prototype;
    _proto.isCasaPrediction = function isCasaPrediction(prediction) {
        return (prediction === null || prediction === void 0 ? void 0 : prediction.addressToken) !== undefined;
    };
    // Populate the initial autocomplete options. These aren't shown, but they are
    // required in order for the AutocompleteInput to work
    _proto.componentDidMount = function componentDidMount() {
        var _this = this;
        var ref, ref1;
        if (this.state.query !== "") {
            this.fetchAutocompleteOptions(this.state.query);
        }
        var prefilledAddress = (ref = this.props.router) === null || ref === void 0 ? void 0 : (ref1 = ref.query) === null || ref1 === void 0 ? void 0 : ref1.pa;
        if (prefilledAddress) {
            this.setState({
                query: prefilledAddress,
                hasLoaded: false
            }, function() {
                _this.handleQueryChange(prefilledAddress, false);
            });
        }
    };
    _proto.componentDidUpdate = function componentDidUpdate(_prevProps, prevState) {
        if (this.state.submitOnLoadingComplete && this.state.fetchIsLoading == false && prevState.fetchIsLoading == true) {
            this.chooseFirstOrSelectedItem();
            this.setState({
                submitOnLoadingComplete: false
            });
        }
    };
    _proto.render = function render() {
        var ref, ref1;
        var _props = this.props, ariaLabelledby = _props.ariaLabelledby, autoFocus = _props.autoFocus, className = _props.className, paddingLevel = _props.paddingLevel, placeholderText = _props.placeholderText, optionsDisplayProps = _props.optionsDisplayProps, unboundedWidth = _props.unboundedWidth, designStyle = _props.designStyle, showCta = _props.showCta, showBorder = _props.showBorder, showShadow = _props.showShadow, showError = _props.showError, size = _props.size, analyticsName = _props.analyticsName, ariaLabel = _props["aria-label"];
        var _state = this.state, query = _state.query, addressLoading = _state.addressLoading, autocompleteOptions = _state.autocompleteOptions, fetchIsLoading = _state.fetchIsLoading, addressError = _state.addressError, isPoweredByGoogle = _state.isPoweredByGoogle;
        var ref2, ref3;
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(AddressInputDiv, {
            showPoweredByGoogle: isPoweredByGoogle,
            className: "od-address-input " + (className || ""),
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_opendoor_bricks_complex_AutocompleteInput_AutocompleteInput__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
                autoComplete: "off",
                ariaLabelledby: ariaLabelledby,
                ariaLabel: ariaLabel,
                analyticsName: analyticsName,
                name: "AddressInput",
                input: query || "",
                showCta: showCta
            }, showCta && "ctaProps" in this.props ? {
                ctaProps: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, this.props.ctaProps), {
                    actionText: (ref2 = (ref = this.props.ctaProps) === null || ref === void 0 ? void 0 : ref.actionText) !== null && ref2 !== void 0 ? ref2 : "Get offer",
                    variant: (ref3 = (ref1 = this.props.ctaProps) === null || ref1 === void 0 ? void 0 : ref1.variant) !== null && ref3 !== void 0 ? ref3 : "primary",
                    onClick: this.handleClick,
                    loading: addressLoading,
                    disabled: addressLoading,
                    size: size
                })
            } : {}), {
                inputProps: {
                    id: "address-input",
                    autoFocus: autoFocus,
                    paddingLevel: paddingLevel,
                    unboundedWidth: unboundedWidth,
                    designStyle: designStyle,
                    showBorder: showBorder,
                    showShadow: showShadow
                },
                optionsDisplayProps: optionsDisplayProps,
                placeholderText: placeholderText,
                onInputChange: this.handleQueryChange,
                select: this.handleItemClick,
                onFocus: this.onInputFocus,
                onBlur: this.handleBlur,
                options: autocompleteOptions.map(this.placeToOption),
                failure: addressError,
                renderError: showError ? this.displayManualEntry : undefined,
                fetchOptionsStatus: {
                    isLoading: fetchIsLoading
                }
            }))
        });
    };
    _proto.setError = function setError() {
        this.setState({
            addressLoading: false
        });
    };
    return AddressInput;
}(_Component = react__WEBPACK_IMPORTED_MODULE_0__.Component);
AddressInput.defaultProps = {
    setValueOnBlur: false,
    hideErrorFormLink: false,
    onChooseManualEntry: function() {},
    onQueryChange: function() {},
    onSubmit: function() {},
    onInputReady: function() {},
    onFocus: function() {},
    onBlur: function() {},
    paddingLevel: "medium",
    placeholderText: "Enter your home address",
    showBorder: true,
    showShadow: false,
    showCta: true,
    ctaProps: {
        actionText: "Get offer",
        variant: "primary",
        "aria-label": ""
    },
    unboundedWidth: true,
    showError: true,
    shouldRedirectOnSubmit: true
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,next_router__WEBPACK_IMPORTED_MODULE_4__.withRouter)(AddressInput));


/***/ }),

/***/ 59431:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ setCookie; },
/* harmony export */   "y": function() { return /* binding */ getAnonymousId; }
/* harmony export */ });
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36808);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_0__);

function getAnonymousId() {
    var anonymousId = js_cookie__WEBPACK_IMPORTED_MODULE_0__.get("ajs_anonymous_id");
    if (!anonymousId) {
        return undefined;
    }
    return anonymousId;
}
var setCookie = function(key, value, expires) {
    // For real staging and production, we need the cookie to be accessible
    // across all subdomains
    // i.e. ".domain.com" cookies are available on all subdomains, vs "www.domain.com"
    // which is only available on same-origin
    // https://www.mxsasha.eu/blog/2014/03/04/definitive-guide-to-cookie-domains/
    var cookieDomain = window.location.hostname;
    if (cookieDomain.indexOf("opendoor.com") !== -1) {
        cookieDomain = ".opendoor.com";
    } else if (window.location.hostname.indexOf("simplersell.com") !== -1) {
        cookieDomain = ".simplersell.com";
    }
    // expires is in days
    js_cookie__WEBPACK_IMPORTED_MODULE_0__.set(key, value, {
        expires: expires,
        domain: cookieDomain
    });
};


/***/ }),

/***/ 37662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "le": function() { return /* binding */ ADDRESS_INVALID_RESULT; },
  "Pj": function() { return /* binding */ AddressValidationContextProvider; },
  "Qk": function() { return /* binding */ gateProceedToOnboardingFlow; },
  "oK": function() { return /* binding */ useAddressValidationContext; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@opendoor/cinderblocks/es/helpers/addressValidation.mjs
var addressValidation = __webpack_require__(63353);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@opendoor/observability/dist/observability-slim.mjs
var observability_slim = __webpack_require__(74593);
// EXTERNAL MODULE: ./src/components/api/index.ts + 3 modules
var api = __webpack_require__(61661);
// EXTERNAL MODULE: ./src/components/shared/trackers.tsx
var trackers = __webpack_require__(59431);
;// CONCATENATED MODULE: ./src/components/api/addressInputHelpers.ts







var Sentry = observability_slim/* globalObservability.getSentryClient */.w.getSentryClient();
var getSellerFlowUUID = function() {
    var fragments = window.location.search.match(/sfuuid=([-\w]+)/);
    if (!fragments) {
        return undefined;
    }
    return fragments[1];
};
var getUrlParam = function(paramName) {
    var regExp = new RegExp("".concat(paramName, "\\=([\\w-_]+)"));
    var fragments = window.location.search.match(regExp);
    if (!fragments) {
        return undefined;
    }
    return fragments[1];
};
var getSellerFlowName = function() {
    return getUrlParam("sfname");
};
var getCovid19Whitelist = function() {
    return getUrlParam("covid19_whitelist") === "true";
};
var getChannelOverride = function() {
    var ref;
    return (ref = getUrlParam("channel_override")) === null || ref === void 0 ? void 0 : ref.toUpperCase();
};
var GRPC_ERROR_CODE = "GRPC_ERROR";
var INVALID_ARGUMENT_ERROR_CODE = 3;
/** Determines whether the errors array includes a invalid argument error */ var hasInvalidArgumentError = function(errors) {
    return errors.some(function(error) {
        var ref, ref1, ref2;
        return ((ref = error.extensions) === null || ref === void 0 ? void 0 : ref.code) === GRPC_ERROR_CODE && ((ref1 = error.extensions) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.exception) === null || ref2 === void 0 ? void 0 : ref2.code) === INVALID_ARGUMENT_ERROR_CODE;
    }) || false;
};
var startAddressVerification = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var addressUUID, address, product, channel, trackingKeywords, inputLocation, onSuccess, partnerReferralId, pageSetPath, addressEntry, options, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    addressUUID = param.addressUUID, address = param.address, product = param.product, channel = param.channel, trackingKeywords = param.trackingKeywords, inputLocation = param.inputLocation, onSuccess = param.onSuccess, partnerReferralId = param.partnerReferralId, pageSetPath = param.pageSetPath;
                    observability_slim/* analytics.trackEvent */.co.trackEvent("inputting", "address", "verifying", (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, address), {
                        inputLocation: inputLocation
                    }));
                    addressEntry = {
                        product: product,
                        url: window.location.href
                    };
                    options = {
                        channel: getChannelOverride() || channel,
                        covid19Whitelist: getCovid19Whitelist(),
                        seller_flow_name_override: getSellerFlowName(),
                        seller_flow_uuid_override: getSellerFlowUUID(),
                        trackingKeywords: trackingKeywords,
                        partnerReferralId: partnerReferralId
                    };
                    return [
                        4,
                        api/* createSellerInput */.lX(address, addressEntry, options, addressUUID).then(function(resp) {
                            var ref, ref1, ref2, ref3;
                            if (!resp) {
                                throw {
                                    type: "generic-error",
                                    message: "received non-200 error or could not json parse response, check network logs"
                                };
                            }
                            if ((ref = resp.errors) === null || ref === void 0 ? void 0 : ref.length) {
                                if (hasInvalidArgumentError(resp.errors)) {
                                    throw {
                                        type: "invalid-address",
                                        message: resp.errors
                                    };
                                }
                                throw {
                                    type: "generic-error",
                                    message: resp.errors
                                };
                            }
                            var sellerInput = resp === null || resp === void 0 ? void 0 : (ref1 = resp.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.reception) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.createSellerInputWithTrackingDataFromCookies) === null || ref3 === void 0 ? void 0 : ref3.sellerInput;
                            if (!sellerInput) {
                                // in case an error is not returned in the response, but seller input is empty.
                                throw {
                                    type: "generic-error",
                                    message: "startAddressVerification: seller input from CreateSellerInputWithTrackingDataFromCookies response is undefined"
                                };
                            }
                            var uuid = sellerInput.uuid, pdpUrl = sellerInput.pdpUrl, isInPartnershipDenialServiceRegions = sellerInput.isInPartnershipDenialServiceRegions;
                            var postalCode = sellerInput.address.postalCode;
                            if (address.postal_code && postalCode !== address.postal_code) {
                                throw {
                                    type: "invalid-address",
                                    message: "startAddressVerification: postal code mismatch: ".concat(postalCode, " !== ").concat(address.postal_code)
                                };
                            }
                            (0,trackers/* setCookie */.d)("isInPartnershipDenialServiceRegions-".concat(uuid), isInPartnershipDenialServiceRegions.toString(), 1);
                            observability_slim/* analytics.register */.co.register({
                                "Offer ID": uuid,
                                "Offer Postal Code": postalCode
                            });
                            onSuccess && onSuccess(uuid, pdpUrl, pageSetPath);
                            return;
                        }).catch(function(e) {
                            var ref;
                            observability_slim/* analytics.trackEvent */.co.trackEvent("lead", "failed");
                            (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, e.message, {
                                captureContext: {
                                    extra: {
                                        address: address,
                                        addressEntry: addressEntry,
                                        options: options
                                    }
                                }
                            });
                            return e;
                        })
                    ];
                case 1:
                    error = _state.sent();
                    return [
                        2,
                        error
                    ];
            }
        });
    });
    return function startAddressVerification(_) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./node_modules/@opendoor/cinderblocks/es/helpers/api.mjs
var helpers_api = __webpack_require__(82293);
// EXTERNAL MODULE: ./src/helpers/observability.ts + 57 modules
var observability = __webpack_require__(49048);
// EXTERNAL MODULE: ./src/components/globals.ts
var globals = __webpack_require__(35480);
// EXTERNAL MODULE: ./src/components/shared/NewAddressInput.tsx
var NewAddressInput = __webpack_require__(98066);
;// CONCATENATED MODULE: ./src/components/shared/SellerFlowAddressInput.tsx











// TODO(betty): Move new address input component into Cinderblocks after React 18 upgrade
// import { AddressInput, IAddressInputProps } from '@opendoor/cinderblocks/growth/AddressInput';




var ADDRESS_QUERY_PARAM = [
    "street",
    "city",
    "postalCode",
    "state",
    "result",
    "unit",
    "street1",
    "postal_code", 
];
var UNIVERSAL_NIL_ADDRESS = "6aae647b-d603-5533-8464-c42c658b101a";
var SellerFlowAddressInput_Sentry = observability_slim/* globalObservability.getSentryClient */.w.getSentryClient();
var checkAndMaybeStartManualAddressVerification = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var forceRedirect, address, channel, trackingKeywords, ref, ref1, ref2, ref3, ref4, standardizeAddressResponse, casaAddress;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    forceRedirect = param.forceRedirect, address = param.address, channel = param.channel, trackingKeywords = param.trackingKeywords;
                    if (!address) {
                        startManualAddressVerification(channel, trackingKeywords);
                        return [
                            2,
                            true
                        ];
                    }
                    if (forceRedirect) {
                        startManualAddressVerification(channel, trackingKeywords, address);
                        return [
                            2,
                            true
                        ];
                    }
                    if (!(address.source === "google")) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        (0,helpers_api/* standardizeAddress */.ce)(address)
                    ];
                case 1:
                    standardizeAddressResponse = _state.sent();
                    if (!standardizeAddressResponse || !standardizeAddressResponse.data || standardizeAddressResponse.errors || ((ref1 = (ref = standardizeAddressResponse.data) === null || ref === void 0 ? void 0 : ref.casa.findByFields) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.address) === null || ref2 === void 0 ? void 0 : ref2.uuid) === UNIVERSAL_NIL_ADDRESS) {
                        startManualAddressVerification(channel, trackingKeywords, address);
                        return [
                            2,
                            true
                        ];
                    }
                    casaAddress = (ref4 = (ref3 = standardizeAddressResponse.data) === null || ref3 === void 0 ? void 0 : ref3.casa.findByFields) === null || ref4 === void 0 ? void 0 : ref4.address;
                    if (ADDRESS_INVALID_RESULT.some(function(error) {
                        return casaAddress === null || casaAddress === void 0 ? void 0 : casaAddress.result.includes(error);
                    })) {
                        startManualAddressVerification(channel, trackingKeywords, casaAddress);
                        return [
                            2,
                            true
                        ];
                    }
                    _state.label = 2;
                case 2:
                    return [
                        2,
                        false
                    ];
            }
        });
    });
    return function checkAndMaybeStartManualAddressVerification(_) {
        return _ref.apply(this, arguments);
    };
}();
var handleAddressVerificationSuccess = function(param) {
    var address = param.address, token = param.token, trackEvent = param.trackEvent, pdpUrl = param.pdpUrl, pageSetPath = param.pageSetPath, onSuccess = param.onSuccess, relationshipAnswers = param.relationshipAnswers;
    var performRedirection = function() {
        if (pdpUrl) {
            trackEvent("inputting_address_success", "pdp-redirect");
            if (onSuccess) {
                return onSuccess(address, token, pdpUrl);
            }
            window.location.href = "".concat(globals/* COSMOS_URL */.EQ).concat(pdpUrl, "?utm_source=seller&utm_medium=web&utm_campaign=ae_pdp");
        } else {
            trackEvent("inputting_address_success", "onboarding-redirect");
            if (onSuccess) {
                return onSuccess(address, token, pdpUrl);
            }
            var redirectUrl = pageSetPath ? "".concat(globals/* CONSUMER_FE_URL */.ed, "/seller-lead/").concat(token).concat(pageSetPath) : "".concat(globals/* CONSUMER_FE_URL */.ed, "/seller-lead/").concat(token);
            window.location.href = redirectUrl;
        }
    };
    var answers = (0,src_object_spread/* default */.Z)({
        "home.user_verified_address": true
    }, relationshipAnswers);
    if (relationshipAnswers === null || relationshipAnswers === void 0 ? void 0 : relationshipAnswers["seller.relation_to_owner"]) {
        answers["experimental"] = [
            {
                question_key: "seller.relation_to_owner_from_cosmos",
                string_values: {
                    values: [
                        relationshipAnswers["seller.relation_to_owner"]
                    ]
                }
            }, 
        ];
    }
    (0,api/* updateAnswers */.gh)(answers, "", token).then(function() {
        performRedirection();
    }).catch(function(err) {
        var ref;
        (ref = SellerFlowAddressInput_Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(SellerFlowAddressInput_Sentry, err);
    });
};
var handleAddressSubmit = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var address, trackEvent, product, trackingTaxonomy, channel, trackingKeywords, inputLocation, onSuccess, partnerReferralId, pageSetPath, manualVerificationStarted, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    address = param.address, trackEvent = param.trackEvent, product = param.product, trackingTaxonomy = param.trackingTaxonomy, channel = param.channel, trackingKeywords = param.trackingKeywords, inputLocation = param.inputLocation, onSuccess = param.onSuccess, partnerReferralId = param.partnerReferralId, pageSetPath = param.pageSetPath;
                    // Setting cookie to know where the customer is coming from in reception-fe for experiments
                    if (trackingTaxonomy) {
                        (0,trackers/* setCookie */.d)("sourceForTracking", trackingTaxonomy, 1);
                    }
                    return [
                        4,
                        checkAndMaybeStartManualAddressVerification({
                            forceRedirect: false,
                            address: address,
                            channel: channel,
                            trackingKeywords: trackingKeywords
                        })
                    ];
                case 1:
                    manualVerificationStarted = _state.sent();
                    if (manualVerificationStarted) {
                        return [
                            2
                        ];
                    }
                    return [
                        4,
                        startAddressVerification({
                            addressUUID: address.id,
                            address: address,
                            product: product,
                            channel: channel,
                            trackingKeywords: trackingKeywords,
                            inputLocation: inputLocation,
                            onSuccess: function(token, pdpUrl, pageSetPath) {
                                handleAddressVerificationSuccess({
                                    address: address,
                                    token: token,
                                    trackEvent: trackEvent,
                                    pdpUrl: pdpUrl,
                                    pageSetPath: pageSetPath,
                                    onSuccess: onSuccess
                                });
                            },
                            partnerReferralId: partnerReferralId,
                            pageSetPath: pageSetPath
                        })
                    ];
                case 2:
                    error = _state.sent();
                    if (!error) return [
                        3,
                        5
                    ];
                    if (!(error.type === "invalid-address")) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        checkAndMaybeStartManualAddressVerification({
                            address: address,
                            forceRedirect: true,
                            channel: channel,
                            trackingKeywords: trackingKeywords
                        })
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        5
                    ];
                case 4:
                    window.location.href = "/error";
                    _state.label = 5;
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function handleAddressSubmit(_) {
        return _ref.apply(this, arguments);
    };
}();
var startManualAddressVerification = function(channel, trackingKeywords, address) {
    var path = "".concat(globals/* CONSUMER_FE_URL */.ed, "/seller-lead/address-manual");
    var searchParams = new URLSearchParams();
    if (channel) {
        searchParams.set("channel", channel);
    }
    if (trackingKeywords) {
        searchParams.set("keywords", trackingKeywords);
    }
    if (address) {
        ADDRESS_QUERY_PARAM.forEach(function(param) {
            if (address[param]) {
                var queryParamName = param;
                if (param === "street1") {
                    queryParamName = "street";
                } else if (param === "postal_code") {
                    queryParamName = "postalCode";
                }
                searchParams.set(queryParamName, address[param]);
            }
        });
    }
    var params = searchParams.toString();
    window.location.assign(path + (params ? "?".concat(params) : ""));
};
var SellerFlowAddressInput = function(_param) {
    var className = _param.className, inputLocation = _param.inputLocation, trackingKeywords = _param.trackingKeywords, partnerReferralId = _param.partnerReferralId, trackingTaxonomy = _param.trackingTaxonomy, channel = _param.channel, displayAbove = _param.displayAbove, placeholderText = _param.placeholderText, product = _param.product, onChooseManualEntry = _param.onChooseManualEntry, onSuccess = _param.onSuccess, _showError = _param.showError, showError = _showError === void 0 ? false : _showError, pageSetPath = _param.pageSetPath, others = _object_without_properties(_param, [
        "className",
        "inputLocation",
        "trackingKeywords",
        "partnerReferralId",
        "trackingTaxonomy",
        "channel",
        "displayAbove",
        "placeholderText",
        "product",
        "onChooseManualEntry",
        "onSuccess",
        "showError",
        "pageSetPath"
    ]);
    var trackEvent = useObservability().trackEvent;
    return /*#__PURE__*/ _jsx(AddressInput, _object_spread({
        ariaLabelledby: "address-input-label",
        "aria-label": "Enter your home address",
        showError: showError,
        className: className,
        placeholderText: placeholderText !== null && placeholderText !== void 0 ? placeholderText : "125 W Muriel Dr",
        onSubmit: function(address, providedChannel) {
            handleAddressSubmit({
                address: address,
                trackEvent: trackEvent,
                product: product,
                trackingTaxonomy: trackingTaxonomy,
                channel: providedChannel || channel,
                trackingKeywords: trackingKeywords,
                inputLocation: inputLocation,
                onSuccess: onSuccess,
                partnerReferralId: partnerReferralId,
                pageSetPath: pageSetPath
            });
        },
        onChooseManualEntry: onChooseManualEntry || function(providedChannel, providedAddress) {
            var ref, ref1, ref2, ref3, ref4;
            checkAndMaybeStartManualAddressVerification({
                address: {
                    street1: (ref = providedAddress === null || providedAddress === void 0 ? void 0 : providedAddress.street1) !== null && ref !== void 0 ? ref : "",
                    city: (ref1 = providedAddress === null || providedAddress === void 0 ? void 0 : providedAddress.city) !== null && ref1 !== void 0 ? ref1 : "",
                    state: (ref2 = providedAddress === null || providedAddress === void 0 ? void 0 : providedAddress.state) !== null && ref2 !== void 0 ? ref2 : "",
                    postal_code: (ref3 = providedAddress === null || providedAddress === void 0 ? void 0 : providedAddress.postal_code) !== null && ref3 !== void 0 ? ref3 : "",
                    unit: (ref4 = providedAddress === null || providedAddress === void 0 ? void 0 : providedAddress.unit) !== null && ref4 !== void 0 ? ref4 : ""
                },
                forceRedirect: true,
                channel: providedChannel || channel,
                trackingKeywords: trackingKeywords
            });
        },
        onValidate: function(isValid) {
            if (isValid) {
                return;
            }
            // onValidate is called if we get a correct address back from google
            // but then the place_id verification fails, example is:
            // 1673 Sunburst St, Northridge, CA, USA
            onChooseManualEntry ? onChooseManualEntry(channel) : checkAndMaybeStartManualAddressVerification({
                forceRedirect: true,
                channel: channel,
                trackingKeywords: trackingKeywords
            });
        },
        channel: channel,
        optionsDisplayProps: {
            displayAbove: displayAbove
        }
    }, others));
};

// EXTERNAL MODULE: ./src/helpers/queryParams.ts
var queryParams = __webpack_require__(43552);
;// CONCATENATED MODULE: ./src/helpers/AddressValidationContext.tsx










var ADDRESS_INVALID_RESULT = addressValidation/* ADDRESS_INVALID_RESULT */.le;
var gateProceedToOnboardingFlow = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var address, product, trackEvent, trackingTaxonomy, channel, trackingKeywords, inputLocation, onSuccess, partnerReferralId, pageSetPath, addressUUID, _canRedirect, canRedirect, relationshipAnswers, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    address = param.address, product = param.product, trackEvent = param.trackEvent, trackingTaxonomy = param.trackingTaxonomy, channel = param.channel, trackingKeywords = param.trackingKeywords, inputLocation = param.inputLocation, onSuccess = param.onSuccess, partnerReferralId = param.partnerReferralId, pageSetPath = param.pageSetPath, addressUUID = param.addressUUID, _canRedirect = param.canRedirect, canRedirect = _canRedirect === void 0 ? true : _canRedirect, relationshipAnswers = param.relationshipAnswers;
                    if (trackingTaxonomy) {
                        (0,trackers/* setCookie */.d)("sourceForTracking", trackingTaxonomy, 1);
                    }
                    return [
                        4,
                        startAddressVerification({
                            addressUUID: addressUUID,
                            address: address,
                            product: product,
                            channel: channel,
                            trackingKeywords: trackingKeywords,
                            inputLocation: inputLocation,
                            onSuccess: function(token, pdpUrl, pageSetPath) {
                                handleAddressVerificationSuccess({
                                    address: address,
                                    token: token,
                                    trackEvent: trackEvent,
                                    pdpUrl: pdpUrl,
                                    pageSetPath: pageSetPath,
                                    onSuccess: onSuccess,
                                    relationshipAnswers: relationshipAnswers
                                });
                            },
                            partnerReferralId: partnerReferralId,
                            pageSetPath: pageSetPath
                        })
                    ];
                case 1:
                    error = _state.sent();
                    if (error) {
                        if (error.type === "invalid-address") {
                            if (canRedirect) {
                                window.location.href = "/manual-address-entry";
                            } else {
                                throw new Error(error.message);
                            }
                        } else {
                            window.location.href = "/error";
                        }
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return function gateProceedToOnboardingFlow(_) {
        return _ref.apply(this, arguments);
    };
}();
var AddressValidationContext = /*#__PURE__*/ react.createContext({
    validatedAddress: undefined,
    setValidatedAddress: function() {
        return null;
    },
    addressResults: [],
    setAddressResults: function() {
        return null;
    },
    isPredictionSelectLoading: false,
    setIsPredictionSelectLoading: function() {
        return null;
    },
    firstPrediction: null,
    setFirstPrediction: function() {
        return null;
    },
    partnerReferralId: undefined,
    setPartnerReferralId: function() {
        return null;
    },
    pageSetPath: undefined,
    setPageSetPath: function() {
        return null;
    },
    trackingKeywords: undefined,
    setTrackingKeywords: function() {
        return null;
    },
    channel: undefined,
    setChannel: function() {
        return null;
    }
});
var useAddressValidationContext = function() {
    return react.useContext(AddressValidationContext);
};
var AddressValidationContextProvider = function(param) {
    var children = param.children;
    var ref = (0,queryParams/* default */.Z)(), address = ref.address, result = ref.result, pageSetPathQueryParam = ref.pageSetPath, trackingKeyworksQueryParam = ref.trackingKeyword, partnerReferralIdQueryParam = ref.partnerReferralId, channelQueryParam = ref.channel;
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(function() {
        if (!address) return undefined;
        return JSON.parse(address);
    }), 2), validatedAddress = ref1[0], setValidatedAddress = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)(react.useState(function() {
        if (!result) return [];
        if (Array.isArray(result)) {
            return result;
        }
        return [
            result
        ];
    }), 2), addressResults = ref2[0], setAddressResults = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), isPredictionSelectLoading = ref3[0], setIsPredictionSelectLoading = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), firstPrediction = ref4[0], setFirstPrediction = ref4[1];
    var ref5 = (0,_sliced_to_array/* default */.Z)(react.useState(function() {
        if (!partnerReferralIdQueryParam) return undefined;
        return partnerReferralIdQueryParam;
    }), 2), partnerReferralId = ref5[0], setPartnerReferralId = ref5[1];
    var ref6 = (0,_sliced_to_array/* default */.Z)(react.useState(function() {
        if (!pageSetPathQueryParam) return undefined;
        return pageSetPathQueryParam;
    }), 2), pageSetPath = ref6[0], setPageSetPath = ref6[1];
    var ref7 = (0,_sliced_to_array/* default */.Z)(react.useState(function() {
        if (!trackingKeyworksQueryParam) return undefined;
        return trackingKeyworksQueryParam;
    }), 2), trackingKeywords = ref7[0], setTrackingKeywords = ref7[1];
    var ref8 = (0,_sliced_to_array/* default */.Z)(react.useState(function() {
        if (!channelQueryParam) return "DEFAULT";
        return channelQueryParam;
    }), 2), channel = ref8[0], setChannel = ref8[1];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AddressValidationContext.Provider, {
        value: {
            trackingKeywords: trackingKeywords,
            setTrackingKeywords: setTrackingKeywords,
            pageSetPath: pageSetPath,
            setPageSetPath: setPageSetPath,
            validatedAddress: validatedAddress,
            setValidatedAddress: setValidatedAddress,
            addressResults: addressResults,
            setAddressResults: setAddressResults,
            isPredictionSelectLoading: isPredictionSelectLoading,
            setIsPredictionSelectLoading: setIsPredictionSelectLoading,
            firstPrediction: firstPrediction,
            setFirstPrediction: setFirstPrediction,
            partnerReferralId: partnerReferralId,
            setPartnerReferralId: setPartnerReferralId,
            channel: channel,
            setChannel: setChannel
        },
        children: children
    });
};


/***/ }),

/***/ 49048:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "FL": function() { return /* binding */ OBSERVABILITY_QUERY_PARAM_KEYS; },
  "lT": function() { return /* binding */ initObservability; },
  "C3": function() { return /* binding */ useObservability; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@opendoor/observability/dist/observability-slim.mjs
var observability_slim = __webpack_require__(74593);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
;// CONCATENATED MODULE: ./src/__generated__/google/protobuf/timestamp.ts
/* eslint-disable */ var protobufPackage = "google.protobuf";
function createBaseTimestamp() {
    return {
        seconds: 0,
        nanos: 0
    };
}
var Timestamp = {
    fromJSON: function fromJSON(object) {
        return {
            seconds: isSet(object.seconds) ? Number(object.seconds) : 0,
            nanos: isSet(object.nanos) ? Number(object.nanos) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.seconds !== 0) {
            obj.seconds = Math.round(message.seconds);
        }
        if (message.nanos !== 0) {
            obj.nanos = Math.round(message.nanos);
        }
        return obj;
    },
    create: function create(base) {
        return Timestamp.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseTimestamp();
        var _seconds;
        message.seconds = (_seconds = object.seconds) !== null && _seconds !== void 0 ? _seconds : 0;
        var _nanos;
        message.nanos = (_nanos = object.nanos) !== null && _nanos !== void 0 ? _nanos : 0;
        return message;
    }
};
function isSet(value) {
    return value !== null && value !== undefined;
}

;// CONCATENATED MODULE: ./src/__generated__/protobuf/journey/data/categories/agent_connect_category.ts
/* eslint-disable */ var agent_connect_category_protobufPackage = "od_protos.journey.data.categories";
var AgentConnectCategory_Partner;
(function(AgentConnectCategory_Partner) {
    AgentConnectCategory_Partner[AgentConnectCategory_Partner["UNKNOWN_PARTNER"] = 0] = "UNKNOWN_PARTNER";
    AgentConnectCategory_Partner[AgentConnectCategory_Partner["MSRE"] = 1] = "MSRE";
    AgentConnectCategory_Partner[AgentConnectCategory_Partner["REDFIN"] = 2] = "REDFIN";
    AgentConnectCategory_Partner[AgentConnectCategory_Partner["JMG"] = 3] = "JMG";
    AgentConnectCategory_Partner[AgentConnectCategory_Partner["CLEVER"] = 4] = "CLEVER";
    AgentConnectCategory_Partner[AgentConnectCategory_Partner["PARN"] = 5] = "PARN";
    AgentConnectCategory_Partner[AgentConnectCategory_Partner["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(AgentConnectCategory_Partner || (AgentConnectCategory_Partner = {}));
function agentConnectCategory_PartnerFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN_PARTNER":
            return AgentConnectCategory_Partner.UNKNOWN_PARTNER;
        case 1:
        case "MSRE":
            return AgentConnectCategory_Partner.MSRE;
        case 2:
        case "REDFIN":
            return AgentConnectCategory_Partner.REDFIN;
        case 3:
        case "JMG":
            return AgentConnectCategory_Partner.JMG;
        case 4:
        case "CLEVER":
            return AgentConnectCategory_Partner.CLEVER;
        case 5:
        case "PARN":
            return AgentConnectCategory_Partner.PARN;
        case -1:
        case "UNRECOGNIZED":
        default:
            return AgentConnectCategory_Partner.UNRECOGNIZED;
    }
}
function agentConnectCategory_PartnerToJSON(object) {
    switch(object){
        case AgentConnectCategory_Partner.UNKNOWN_PARTNER:
            return "UNKNOWN_PARTNER";
        case AgentConnectCategory_Partner.MSRE:
            return "MSRE";
        case AgentConnectCategory_Partner.REDFIN:
            return "REDFIN";
        case AgentConnectCategory_Partner.JMG:
            return "JMG";
        case AgentConnectCategory_Partner.CLEVER:
            return "CLEVER";
        case AgentConnectCategory_Partner.PARN:
            return "PARN";
        case AgentConnectCategory_Partner.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var AgentConnectCategory_SellerIntent;
(function(AgentConnectCategory_SellerIntent) {
    AgentConnectCategory_SellerIntent[AgentConnectCategory_SellerIntent["UNKNOWN"] = 0] = "UNKNOWN";
    AgentConnectCategory_SellerIntent[AgentConnectCategory_SellerIntent["LIST"] = 1] = "LIST";
    AgentConnectCategory_SellerIntent[AgentConnectCategory_SellerIntent["CASH"] = 2] = "CASH";
    AgentConnectCategory_SellerIntent[AgentConnectCategory_SellerIntent["CASH_PLUS"] = 3] = "CASH_PLUS";
    AgentConnectCategory_SellerIntent[AgentConnectCategory_SellerIntent["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(AgentConnectCategory_SellerIntent || (AgentConnectCategory_SellerIntent = {}));
function agentConnectCategory_SellerIntentFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN":
            return AgentConnectCategory_SellerIntent.UNKNOWN;
        case 1:
        case "LIST":
            return AgentConnectCategory_SellerIntent.LIST;
        case 2:
        case "CASH":
            return AgentConnectCategory_SellerIntent.CASH;
        case 3:
        case "CASH_PLUS":
            return AgentConnectCategory_SellerIntent.CASH_PLUS;
        case -1:
        case "UNRECOGNIZED":
        default:
            return AgentConnectCategory_SellerIntent.UNRECOGNIZED;
    }
}
function agentConnectCategory_SellerIntentToJSON(object) {
    switch(object){
        case AgentConnectCategory_SellerIntent.UNKNOWN:
            return "UNKNOWN";
        case AgentConnectCategory_SellerIntent.LIST:
            return "LIST";
        case AgentConnectCategory_SellerIntent.CASH:
            return "CASH";
        case AgentConnectCategory_SellerIntent.CASH_PLUS:
            return "CASH_PLUS";
        case AgentConnectCategory_SellerIntent.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
function createBaseAgentConnectCategory() {
    return {
        event: undefined
    };
}
var AgentConnectCategory = {
    fromJSON: function fromJSON(object) {
        return {
            event: agent_connect_category_isSet(object.viewEvent) ? {
                $case: "viewEvent",
                viewEvent: AgentConnectCategory_ViewEvent.fromJSON(object.viewEvent)
            } : agent_connect_category_isSet(object.handoffEvent) ? {
                $case: "handoffEvent",
                handoffEvent: AgentConnectCategory_HandoffEvent.fromJSON(object.handoffEvent)
            } : agent_connect_category_isSet(object.deniedEvent) ? {
                $case: "deniedEvent",
                deniedEvent: AgentConnectCategory_DeniedEvent.fromJSON(object.deniedEvent)
            } : undefined
        };
    },
    toJSON: function toJSON(message) {
        var ref, ref1, ref2;
        var obj = {};
        if (((ref = message.event) === null || ref === void 0 ? void 0 : ref.$case) === "viewEvent") {
            obj.viewEvent = AgentConnectCategory_ViewEvent.toJSON(message.event.viewEvent);
        }
        if (((ref1 = message.event) === null || ref1 === void 0 ? void 0 : ref1.$case) === "handoffEvent") {
            obj.handoffEvent = AgentConnectCategory_HandoffEvent.toJSON(message.event.handoffEvent);
        }
        if (((ref2 = message.event) === null || ref2 === void 0 ? void 0 : ref2.$case) === "deniedEvent") {
            obj.deniedEvent = AgentConnectCategory_DeniedEvent.toJSON(message.event.deniedEvent);
        }
        return obj;
    },
    create: function create(base) {
        return AgentConnectCategory.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
        var message = createBaseAgentConnectCategory();
        if (((ref = object.event) === null || ref === void 0 ? void 0 : ref.$case) === "viewEvent" && ((ref1 = object.event) === null || ref1 === void 0 ? void 0 : ref1.viewEvent) !== undefined && ((ref2 = object.event) === null || ref2 === void 0 ? void 0 : ref2.viewEvent) !== null) {
            message.event = {
                $case: "viewEvent",
                viewEvent: AgentConnectCategory_ViewEvent.fromPartial(object.event.viewEvent)
            };
        }
        if (((ref3 = object.event) === null || ref3 === void 0 ? void 0 : ref3.$case) === "handoffEvent" && ((ref4 = object.event) === null || ref4 === void 0 ? void 0 : ref4.handoffEvent) !== undefined && ((ref5 = object.event) === null || ref5 === void 0 ? void 0 : ref5.handoffEvent) !== null) {
            message.event = {
                $case: "handoffEvent",
                handoffEvent: AgentConnectCategory_HandoffEvent.fromPartial(object.event.handoffEvent)
            };
        }
        if (((ref6 = object.event) === null || ref6 === void 0 ? void 0 : ref6.$case) === "deniedEvent" && ((ref7 = object.event) === null || ref7 === void 0 ? void 0 : ref7.deniedEvent) !== undefined && ((ref8 = object.event) === null || ref8 === void 0 ? void 0 : ref8.deniedEvent) !== null) {
            message.event = {
                $case: "deniedEvent",
                deniedEvent: AgentConnectCategory_DeniedEvent.fromPartial(object.event.deniedEvent)
            };
        }
        return message;
    }
};
function createBaseAgentConnectCategory_ViewEvent() {
    return {
        sellerInputUuid: "",
        partner: 0,
        odEstimatedSalePriceCents: undefined,
        buyerIntent: false
    };
}
var AgentConnectCategory_ViewEvent = {
    fromJSON: function fromJSON(object) {
        return {
            sellerInputUuid: agent_connect_category_isSet(object.sellerInputUuid) ? String(object.sellerInputUuid) : "",
            partner: agent_connect_category_isSet(object.partner) ? agentConnectCategory_PartnerFromJSON(object.partner) : 0,
            odEstimatedSalePriceCents: agent_connect_category_isSet(object.odEstimatedSalePriceCents) ? Number(object.odEstimatedSalePriceCents) : undefined,
            buyerIntent: agent_connect_category_isSet(object.buyerIntent) ? Boolean(object.buyerIntent) : false
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.sellerInputUuid !== "") {
            obj.sellerInputUuid = message.sellerInputUuid;
        }
        if (message.partner !== 0) {
            obj.partner = agentConnectCategory_PartnerToJSON(message.partner);
        }
        if (message.odEstimatedSalePriceCents !== undefined) {
            obj.odEstimatedSalePriceCents = message.odEstimatedSalePriceCents;
        }
        if (message.buyerIntent === true) {
            obj.buyerIntent = message.buyerIntent;
        }
        return obj;
    },
    create: function create(base) {
        return AgentConnectCategory_ViewEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAgentConnectCategory_ViewEvent();
        var _sellerInputUuid;
        message.sellerInputUuid = (_sellerInputUuid = object.sellerInputUuid) !== null && _sellerInputUuid !== void 0 ? _sellerInputUuid : "";
        var _partner;
        message.partner = (_partner = object.partner) !== null && _partner !== void 0 ? _partner : 0;
        var _odEstimatedSalePriceCents;
        message.odEstimatedSalePriceCents = (_odEstimatedSalePriceCents = object.odEstimatedSalePriceCents) !== null && _odEstimatedSalePriceCents !== void 0 ? _odEstimatedSalePriceCents : undefined;
        var _buyerIntent;
        message.buyerIntent = (_buyerIntent = object.buyerIntent) !== null && _buyerIntent !== void 0 ? _buyerIntent : false;
        return message;
    }
};
function createBaseAgentConnectCategory_HandoffEvent() {
    return {
        sellerInputUuid: "",
        partner: 0,
        sellerIntent: 0,
        buyerIntent: false,
        odEstimatedSalePriceCents: undefined
    };
}
var AgentConnectCategory_HandoffEvent = {
    fromJSON: function fromJSON(object) {
        return {
            sellerInputUuid: agent_connect_category_isSet(object.sellerInputUuid) ? String(object.sellerInputUuid) : "",
            partner: agent_connect_category_isSet(object.partner) ? agentConnectCategory_PartnerFromJSON(object.partner) : 0,
            sellerIntent: agent_connect_category_isSet(object.sellerIntent) ? agentConnectCategory_SellerIntentFromJSON(object.sellerIntent) : 0,
            buyerIntent: agent_connect_category_isSet(object.buyerIntent) ? Boolean(object.buyerIntent) : false,
            odEstimatedSalePriceCents: agent_connect_category_isSet(object.odEstimatedSalePriceCents) ? Number(object.odEstimatedSalePriceCents) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.sellerInputUuid !== "") {
            obj.sellerInputUuid = message.sellerInputUuid;
        }
        if (message.partner !== 0) {
            obj.partner = agentConnectCategory_PartnerToJSON(message.partner);
        }
        if (message.sellerIntent !== 0) {
            obj.sellerIntent = agentConnectCategory_SellerIntentToJSON(message.sellerIntent);
        }
        if (message.buyerIntent === true) {
            obj.buyerIntent = message.buyerIntent;
        }
        if (message.odEstimatedSalePriceCents !== undefined) {
            obj.odEstimatedSalePriceCents = message.odEstimatedSalePriceCents;
        }
        return obj;
    },
    create: function create(base) {
        return AgentConnectCategory_HandoffEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAgentConnectCategory_HandoffEvent();
        var _sellerInputUuid;
        message.sellerInputUuid = (_sellerInputUuid = object.sellerInputUuid) !== null && _sellerInputUuid !== void 0 ? _sellerInputUuid : "";
        var _partner;
        message.partner = (_partner = object.partner) !== null && _partner !== void 0 ? _partner : 0;
        var _sellerIntent;
        message.sellerIntent = (_sellerIntent = object.sellerIntent) !== null && _sellerIntent !== void 0 ? _sellerIntent : 0;
        var _buyerIntent;
        message.buyerIntent = (_buyerIntent = object.buyerIntent) !== null && _buyerIntent !== void 0 ? _buyerIntent : false;
        var _odEstimatedSalePriceCents;
        message.odEstimatedSalePriceCents = (_odEstimatedSalePriceCents = object.odEstimatedSalePriceCents) !== null && _odEstimatedSalePriceCents !== void 0 ? _odEstimatedSalePriceCents : undefined;
        return message;
    }
};
function createBaseAgentConnectCategory_DeniedEvent() {
    return {
        sellerInputUuid: "",
        denialReason: ""
    };
}
var AgentConnectCategory_DeniedEvent = {
    fromJSON: function fromJSON(object) {
        return {
            sellerInputUuid: agent_connect_category_isSet(object.sellerInputUuid) ? String(object.sellerInputUuid) : "",
            denialReason: agent_connect_category_isSet(object.denialReason) ? String(object.denialReason) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.sellerInputUuid !== "") {
            obj.sellerInputUuid = message.sellerInputUuid;
        }
        if (message.denialReason !== "") {
            obj.denialReason = message.denialReason;
        }
        return obj;
    },
    create: function create(base) {
        return AgentConnectCategory_DeniedEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAgentConnectCategory_DeniedEvent();
        var _sellerInputUuid;
        message.sellerInputUuid = (_sellerInputUuid = object.sellerInputUuid) !== null && _sellerInputUuid !== void 0 ? _sellerInputUuid : "";
        var _denialReason;
        message.denialReason = (_denialReason = object.denialReason) !== null && _denialReason !== void 0 ? _denialReason : "";
        return message;
    }
};
function agent_connect_category_isSet(value) {
    return value !== null && value !== undefined;
}

;// CONCATENATED MODULE: ./src/__generated__/protobuf/journey/data/categories/alo_category.ts
/* eslint-disable */ 
var alo_category_protobufPackage = "od_protos.journey.data.categories";
var AloCategory_QualificationDecision;
(function(AloCategory_QualificationDecision) {
    AloCategory_QualificationDecision[AloCategory_QualificationDecision["UNKNOWN"] = 0] = "UNKNOWN";
    AloCategory_QualificationDecision[AloCategory_QualificationDecision["ELIGIBLE"] = 1] = "ELIGIBLE";
    AloCategory_QualificationDecision[AloCategory_QualificationDecision["INELIGIBLE"] = 2] = "INELIGIBLE";
    AloCategory_QualificationDecision[AloCategory_QualificationDecision["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(AloCategory_QualificationDecision || (AloCategory_QualificationDecision = {}));
function aloCategory_QualificationDecisionFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN":
            return AloCategory_QualificationDecision.UNKNOWN;
        case 1:
        case "ELIGIBLE":
            return AloCategory_QualificationDecision.ELIGIBLE;
        case 2:
        case "INELIGIBLE":
            return AloCategory_QualificationDecision.INELIGIBLE;
        case -1:
        case "UNRECOGNIZED":
        default:
            return AloCategory_QualificationDecision.UNRECOGNIZED;
    }
}
function aloCategory_QualificationDecisionToJSON(object) {
    switch(object){
        case AloCategory_QualificationDecision.UNKNOWN:
            return "UNKNOWN";
        case AloCategory_QualificationDecision.ELIGIBLE:
            return "ELIGIBLE";
        case AloCategory_QualificationDecision.INELIGIBLE:
            return "INELIGIBLE";
        case AloCategory_QualificationDecision.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var AloCategory_ALOExperienceSlug;
(function(AloCategory_ALOExperienceSlug) {
    AloCategory_ALOExperienceSlug[AloCategory_ALOExperienceSlug["UNKNOWN_SLUG"] = 0] = "UNKNOWN_SLUG";
    AloCategory_ALOExperienceSlug[AloCategory_ALOExperienceSlug["ALO_POST_HANDOFF_V1"] = 1] = "ALO_POST_HANDOFF_V1";
    AloCategory_ALOExperienceSlug[AloCategory_ALOExperienceSlug["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(AloCategory_ALOExperienceSlug || (AloCategory_ALOExperienceSlug = {}));
function aloCategory_ALOExperienceSlugFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN_SLUG":
            return AloCategory_ALOExperienceSlug.UNKNOWN_SLUG;
        case 1:
        case "ALO_POST_HANDOFF_V1":
            return AloCategory_ALOExperienceSlug.ALO_POST_HANDOFF_V1;
        case -1:
        case "UNRECOGNIZED":
        default:
            return AloCategory_ALOExperienceSlug.UNRECOGNIZED;
    }
}
function aloCategory_ALOExperienceSlugToJSON(object) {
    switch(object){
        case AloCategory_ALOExperienceSlug.UNKNOWN_SLUG:
            return "UNKNOWN_SLUG";
        case AloCategory_ALOExperienceSlug.ALO_POST_HANDOFF_V1:
            return "ALO_POST_HANDOFF_V1";
        case AloCategory_ALOExperienceSlug.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
function createBaseAloCategory() {
    return {
        event: undefined
    };
}
var AloCategory = {
    fromJSON: function fromJSON(object) {
        return {
            event: alo_category_isSet(object.qualificationEvent) ? {
                $case: "qualificationEvent",
                qualificationEvent: AloCategory_AloQualificationEvent.fromJSON(object.qualificationEvent)
            } : alo_category_isSet(object.handoffPageViewEvent) ? {
                $case: "handoffPageViewEvent",
                handoffPageViewEvent: AloCategory_AloHandoffPageViewEvent.fromJSON(object.handoffPageViewEvent)
            } : alo_category_isSet(object.handoffSubmitEvent) ? {
                $case: "handoffSubmitEvent",
                handoffSubmitEvent: AloCategory_AloHandoffSubmitEvent.fromJSON(object.handoffSubmitEvent)
            } : alo_category_isSet(object.pageViewEvent) ? {
                $case: "pageViewEvent",
                pageViewEvent: AloCategory_AloPageViewEvent.fromJSON(object.pageViewEvent)
            } : undefined
        };
    },
    toJSON: function toJSON(message) {
        var ref, ref1, ref2, ref3;
        var obj = {};
        if (((ref = message.event) === null || ref === void 0 ? void 0 : ref.$case) === "qualificationEvent") {
            obj.qualificationEvent = AloCategory_AloQualificationEvent.toJSON(message.event.qualificationEvent);
        }
        if (((ref1 = message.event) === null || ref1 === void 0 ? void 0 : ref1.$case) === "handoffPageViewEvent") {
            obj.handoffPageViewEvent = AloCategory_AloHandoffPageViewEvent.toJSON(message.event.handoffPageViewEvent);
        }
        if (((ref2 = message.event) === null || ref2 === void 0 ? void 0 : ref2.$case) === "handoffSubmitEvent") {
            obj.handoffSubmitEvent = AloCategory_AloHandoffSubmitEvent.toJSON(message.event.handoffSubmitEvent);
        }
        if (((ref3 = message.event) === null || ref3 === void 0 ? void 0 : ref3.$case) === "pageViewEvent") {
            obj.pageViewEvent = AloCategory_AloPageViewEvent.toJSON(message.event.pageViewEvent);
        }
        return obj;
    },
    create: function create(base) {
        return AloCategory.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
        var message = createBaseAloCategory();
        if (((ref = object.event) === null || ref === void 0 ? void 0 : ref.$case) === "qualificationEvent" && ((ref1 = object.event) === null || ref1 === void 0 ? void 0 : ref1.qualificationEvent) !== undefined && ((ref2 = object.event) === null || ref2 === void 0 ? void 0 : ref2.qualificationEvent) !== null) {
            message.event = {
                $case: "qualificationEvent",
                qualificationEvent: AloCategory_AloQualificationEvent.fromPartial(object.event.qualificationEvent)
            };
        }
        if (((ref3 = object.event) === null || ref3 === void 0 ? void 0 : ref3.$case) === "handoffPageViewEvent" && ((ref4 = object.event) === null || ref4 === void 0 ? void 0 : ref4.handoffPageViewEvent) !== undefined && ((ref5 = object.event) === null || ref5 === void 0 ? void 0 : ref5.handoffPageViewEvent) !== null) {
            message.event = {
                $case: "handoffPageViewEvent",
                handoffPageViewEvent: AloCategory_AloHandoffPageViewEvent.fromPartial(object.event.handoffPageViewEvent)
            };
        }
        if (((ref6 = object.event) === null || ref6 === void 0 ? void 0 : ref6.$case) === "handoffSubmitEvent" && ((ref7 = object.event) === null || ref7 === void 0 ? void 0 : ref7.handoffSubmitEvent) !== undefined && ((ref8 = object.event) === null || ref8 === void 0 ? void 0 : ref8.handoffSubmitEvent) !== null) {
            message.event = {
                $case: "handoffSubmitEvent",
                handoffSubmitEvent: AloCategory_AloHandoffSubmitEvent.fromPartial(object.event.handoffSubmitEvent)
            };
        }
        if (((ref9 = object.event) === null || ref9 === void 0 ? void 0 : ref9.$case) === "pageViewEvent" && ((ref10 = object.event) === null || ref10 === void 0 ? void 0 : ref10.pageViewEvent) !== undefined && ((ref11 = object.event) === null || ref11 === void 0 ? void 0 : ref11.pageViewEvent) !== null) {
            message.event = {
                $case: "pageViewEvent",
                pageViewEvent: AloCategory_AloPageViewEvent.fromPartial(object.event.pageViewEvent)
            };
        }
        return message;
    }
};
function createBaseAloCategory_AloQualificationEvent() {
    return {
        sellerInputUuid: "",
        leadUuid: "",
        offerUuid: "",
        flipToken: "",
        qualificationDecision: 0,
        eligibilityDetails: {},
        market: "",
        offerRequestSource: "",
        aloEligibilityDetails: undefined,
        sellerLeadUuid: ""
    };
}
var AloCategory_AloQualificationEvent = {
    fromJSON: function fromJSON(object) {
        return {
            sellerInputUuid: alo_category_isSet(object.sellerInputUuid) ? String(object.sellerInputUuid) : "",
            leadUuid: alo_category_isSet(object.leadUuid) ? String(object.leadUuid) : "",
            offerUuid: alo_category_isSet(object.offerUuid) ? String(object.offerUuid) : "",
            flipToken: alo_category_isSet(object.flipToken) ? String(object.flipToken) : "",
            qualificationDecision: alo_category_isSet(object.qualificationDecision) ? aloCategory_QualificationDecisionFromJSON(object.qualificationDecision) : 0,
            eligibilityDetails: isObject(object.eligibilityDetails) ? Object.entries(object.eligibilityDetails).reduce(function(acc, param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
                acc[key] = Boolean(value);
                return acc;
            }, {}) : {},
            market: alo_category_isSet(object.market) ? String(object.market) : "",
            offerRequestSource: alo_category_isSet(object.offerRequestSource) ? String(object.offerRequestSource) : "",
            aloEligibilityDetails: alo_category_isSet(object.aloEligibilityDetails) ? AloCategory_AloEligibilityDetails.fromJSON(object.aloEligibilityDetails) : undefined,
            sellerLeadUuid: alo_category_isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.sellerInputUuid !== "") {
            obj.sellerInputUuid = message.sellerInputUuid;
        }
        if (message.leadUuid !== "") {
            obj.leadUuid = message.leadUuid;
        }
        if (message.offerUuid !== "") {
            obj.offerUuid = message.offerUuid;
        }
        if (message.flipToken !== "") {
            obj.flipToken = message.flipToken;
        }
        if (message.qualificationDecision !== 0) {
            obj.qualificationDecision = aloCategory_QualificationDecisionToJSON(message.qualificationDecision);
        }
        if (message.eligibilityDetails) {
            var entries = Object.entries(message.eligibilityDetails);
            if (entries.length > 0) {
                obj.eligibilityDetails = {};
                entries.forEach(function(param) {
                    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), k = _param[0], v = _param[1];
                    obj.eligibilityDetails[k] = v;
                });
            }
        }
        if (message.market !== "") {
            obj.market = message.market;
        }
        if (message.offerRequestSource !== "") {
            obj.offerRequestSource = message.offerRequestSource;
        }
        if (message.aloEligibilityDetails !== undefined) {
            obj.aloEligibilityDetails = AloCategory_AloEligibilityDetails.toJSON(message.aloEligibilityDetails);
        }
        if (message.sellerLeadUuid !== "") {
            obj.sellerLeadUuid = message.sellerLeadUuid;
        }
        return obj;
    },
    create: function create(base) {
        return AloCategory_AloQualificationEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAloCategory_AloQualificationEvent();
        var _sellerInputUuid;
        message.sellerInputUuid = (_sellerInputUuid = object.sellerInputUuid) !== null && _sellerInputUuid !== void 0 ? _sellerInputUuid : "";
        var _leadUuid;
        message.leadUuid = (_leadUuid = object.leadUuid) !== null && _leadUuid !== void 0 ? _leadUuid : "";
        var _offerUuid;
        message.offerUuid = (_offerUuid = object.offerUuid) !== null && _offerUuid !== void 0 ? _offerUuid : "";
        var _flipToken;
        message.flipToken = (_flipToken = object.flipToken) !== null && _flipToken !== void 0 ? _flipToken : "";
        var _qualificationDecision;
        message.qualificationDecision = (_qualificationDecision = object.qualificationDecision) !== null && _qualificationDecision !== void 0 ? _qualificationDecision : 0;
        var _eligibilityDetails;
        message.eligibilityDetails = Object.entries((_eligibilityDetails = object.eligibilityDetails) !== null && _eligibilityDetails !== void 0 ? _eligibilityDetails : {}).reduce(function(acc, param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
            if (value !== undefined) {
                acc[key] = Boolean(value);
            }
            return acc;
        }, {});
        var _market;
        message.market = (_market = object.market) !== null && _market !== void 0 ? _market : "";
        var _offerRequestSource;
        message.offerRequestSource = (_offerRequestSource = object.offerRequestSource) !== null && _offerRequestSource !== void 0 ? _offerRequestSource : "";
        message.aloEligibilityDetails = object.aloEligibilityDetails !== undefined && object.aloEligibilityDetails !== null ? AloCategory_AloEligibilityDetails.fromPartial(object.aloEligibilityDetails) : undefined;
        var _sellerLeadUuid;
        message.sellerLeadUuid = (_sellerLeadUuid = object.sellerLeadUuid) !== null && _sellerLeadUuid !== void 0 ? _sellerLeadUuid : "";
        return message;
    }
};
function createBaseAloCategory_AloQualificationEvent_EligibilityDetailsEntry() {
    return {
        key: "",
        value: false
    };
}
var AloCategory_AloQualificationEvent_EligibilityDetailsEntry = {
    fromJSON: function fromJSON(object) {
        return {
            key: alo_category_isSet(object.key) ? String(object.key) : "",
            value: alo_category_isSet(object.value) ? Boolean(object.value) : false
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.key !== "") {
            obj.key = message.key;
        }
        if (message.value === true) {
            obj.value = message.value;
        }
        return obj;
    },
    create: function create(base) {
        return AloCategory_AloQualificationEvent_EligibilityDetailsEntry.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAloCategory_AloQualificationEvent_EligibilityDetailsEntry();
        var _key;
        message.key = (_key = object.key) !== null && _key !== void 0 ? _key : "";
        var _value;
        message.value = (_value = object.value) !== null && _value !== void 0 ? _value : false;
        return message;
    }
};
function createBaseAloCategory_AloEligibilityDetails() {
    return {
        isFirstOffer: false,
        isAfterLaunchDate: false,
        isEligibleMarket: false,
        isNotReit: false,
        isNotWorkingWithAgent: false,
        isNotRestrictedPartnershipLead: false,
        isNotPreviouslyDeniedRefresh: false,
        isValidOfferRequestSource: false,
        isNotVolumeRestricted: false
    };
}
var AloCategory_AloEligibilityDetails = {
    fromJSON: function fromJSON(object) {
        return {
            isFirstOffer: alo_category_isSet(object.is_first_offer) ? Boolean(object.is_first_offer) : false,
            isAfterLaunchDate: alo_category_isSet(object.is_after_launch_date) ? Boolean(object.is_after_launch_date) : false,
            isEligibleMarket: alo_category_isSet(object.is_eligible_market) ? Boolean(object.is_eligible_market) : false,
            isNotReit: alo_category_isSet(object.is_not_reit) ? Boolean(object.is_not_reit) : false,
            isNotWorkingWithAgent: alo_category_isSet(object.is_not_working_with_agent) ? Boolean(object.is_not_working_with_agent) : false,
            isNotRestrictedPartnershipLead: alo_category_isSet(object.is_not_restricted_partnership_lead) ? Boolean(object.is_not_restricted_partnership_lead) : false,
            isNotPreviouslyDeniedRefresh: alo_category_isSet(object.is_not_previously_denied_refresh) ? Boolean(object.is_not_previously_denied_refresh) : false,
            isValidOfferRequestSource: alo_category_isSet(object.is_valid_offer_request_source) ? Boolean(object.is_valid_offer_request_source) : false,
            isNotVolumeRestricted: alo_category_isSet(object.is_not_volume_restricted) ? Boolean(object.is_not_volume_restricted) : false
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.isFirstOffer === true) {
            obj.is_first_offer = message.isFirstOffer;
        }
        if (message.isAfterLaunchDate === true) {
            obj.is_after_launch_date = message.isAfterLaunchDate;
        }
        if (message.isEligibleMarket === true) {
            obj.is_eligible_market = message.isEligibleMarket;
        }
        if (message.isNotReit === true) {
            obj.is_not_reit = message.isNotReit;
        }
        if (message.isNotWorkingWithAgent === true) {
            obj.is_not_working_with_agent = message.isNotWorkingWithAgent;
        }
        if (message.isNotRestrictedPartnershipLead === true) {
            obj.is_not_restricted_partnership_lead = message.isNotRestrictedPartnershipLead;
        }
        if (message.isNotPreviouslyDeniedRefresh === true) {
            obj.is_not_previously_denied_refresh = message.isNotPreviouslyDeniedRefresh;
        }
        if (message.isValidOfferRequestSource === true) {
            obj.is_valid_offer_request_source = message.isValidOfferRequestSource;
        }
        if (message.isNotVolumeRestricted === true) {
            obj.is_not_volume_restricted = message.isNotVolumeRestricted;
        }
        return obj;
    },
    create: function create(base) {
        return AloCategory_AloEligibilityDetails.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAloCategory_AloEligibilityDetails();
        var _isFirstOffer;
        message.isFirstOffer = (_isFirstOffer = object.isFirstOffer) !== null && _isFirstOffer !== void 0 ? _isFirstOffer : false;
        var _isAfterLaunchDate;
        message.isAfterLaunchDate = (_isAfterLaunchDate = object.isAfterLaunchDate) !== null && _isAfterLaunchDate !== void 0 ? _isAfterLaunchDate : false;
        var _isEligibleMarket;
        message.isEligibleMarket = (_isEligibleMarket = object.isEligibleMarket) !== null && _isEligibleMarket !== void 0 ? _isEligibleMarket : false;
        var _isNotReit;
        message.isNotReit = (_isNotReit = object.isNotReit) !== null && _isNotReit !== void 0 ? _isNotReit : false;
        var _isNotWorkingWithAgent;
        message.isNotWorkingWithAgent = (_isNotWorkingWithAgent = object.isNotWorkingWithAgent) !== null && _isNotWorkingWithAgent !== void 0 ? _isNotWorkingWithAgent : false;
        var _isNotRestrictedPartnershipLead;
        message.isNotRestrictedPartnershipLead = (_isNotRestrictedPartnershipLead = object.isNotRestrictedPartnershipLead) !== null && _isNotRestrictedPartnershipLead !== void 0 ? _isNotRestrictedPartnershipLead : false;
        var _isNotPreviouslyDeniedRefresh;
        message.isNotPreviouslyDeniedRefresh = (_isNotPreviouslyDeniedRefresh = object.isNotPreviouslyDeniedRefresh) !== null && _isNotPreviouslyDeniedRefresh !== void 0 ? _isNotPreviouslyDeniedRefresh : false;
        var _isValidOfferRequestSource;
        message.isValidOfferRequestSource = (_isValidOfferRequestSource = object.isValidOfferRequestSource) !== null && _isValidOfferRequestSource !== void 0 ? _isValidOfferRequestSource : false;
        var _isNotVolumeRestricted;
        message.isNotVolumeRestricted = (_isNotVolumeRestricted = object.isNotVolumeRestricted) !== null && _isNotVolumeRestricted !== void 0 ? _isNotVolumeRestricted : false;
        return message;
    }
};
function createBaseAloCategory_AloHandoffPageViewEvent() {
    return {
        leadUuid: "",
        offerUuid: "",
        flipToken: "",
        sellerLeadUuid: ""
    };
}
var AloCategory_AloHandoffPageViewEvent = {
    fromJSON: function fromJSON(object) {
        return {
            leadUuid: alo_category_isSet(object.leadUuid) ? String(object.leadUuid) : "",
            offerUuid: alo_category_isSet(object.offerUuid) ? String(object.offerUuid) : "",
            flipToken: alo_category_isSet(object.flipToken) ? String(object.flipToken) : "",
            sellerLeadUuid: alo_category_isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.leadUuid !== "") {
            obj.leadUuid = message.leadUuid;
        }
        if (message.offerUuid !== "") {
            obj.offerUuid = message.offerUuid;
        }
        if (message.flipToken !== "") {
            obj.flipToken = message.flipToken;
        }
        if (message.sellerLeadUuid !== "") {
            obj.sellerLeadUuid = message.sellerLeadUuid;
        }
        return obj;
    },
    create: function create(base) {
        return AloCategory_AloHandoffPageViewEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAloCategory_AloHandoffPageViewEvent();
        var _leadUuid;
        message.leadUuid = (_leadUuid = object.leadUuid) !== null && _leadUuid !== void 0 ? _leadUuid : "";
        var _offerUuid;
        message.offerUuid = (_offerUuid = object.offerUuid) !== null && _offerUuid !== void 0 ? _offerUuid : "";
        var _flipToken;
        message.flipToken = (_flipToken = object.flipToken) !== null && _flipToken !== void 0 ? _flipToken : "";
        var _sellerLeadUuid;
        message.sellerLeadUuid = (_sellerLeadUuid = object.sellerLeadUuid) !== null && _sellerLeadUuid !== void 0 ? _sellerLeadUuid : "";
        return message;
    }
};
function createBaseAloCategory_AloPageViewEvent() {
    return {
        leadUuid: "",
        offerUuid: "",
        flipToken: "",
        experienceSlug: 0,
        sellerLeadUuid: ""
    };
}
var AloCategory_AloPageViewEvent = {
    fromJSON: function fromJSON(object) {
        return {
            leadUuid: alo_category_isSet(object.leadUuid) ? String(object.leadUuid) : "",
            offerUuid: alo_category_isSet(object.offerUuid) ? String(object.offerUuid) : "",
            flipToken: alo_category_isSet(object.flipToken) ? String(object.flipToken) : "",
            experienceSlug: alo_category_isSet(object.experienceSlug) ? aloCategory_ALOExperienceSlugFromJSON(object.experienceSlug) : 0,
            sellerLeadUuid: alo_category_isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.leadUuid !== "") {
            obj.leadUuid = message.leadUuid;
        }
        if (message.offerUuid !== "") {
            obj.offerUuid = message.offerUuid;
        }
        if (message.flipToken !== "") {
            obj.flipToken = message.flipToken;
        }
        if (message.experienceSlug !== 0) {
            obj.experienceSlug = aloCategory_ALOExperienceSlugToJSON(message.experienceSlug);
        }
        if (message.sellerLeadUuid !== "") {
            obj.sellerLeadUuid = message.sellerLeadUuid;
        }
        return obj;
    },
    create: function create(base) {
        return AloCategory_AloPageViewEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAloCategory_AloPageViewEvent();
        var _leadUuid;
        message.leadUuid = (_leadUuid = object.leadUuid) !== null && _leadUuid !== void 0 ? _leadUuid : "";
        var _offerUuid;
        message.offerUuid = (_offerUuid = object.offerUuid) !== null && _offerUuid !== void 0 ? _offerUuid : "";
        var _flipToken;
        message.flipToken = (_flipToken = object.flipToken) !== null && _flipToken !== void 0 ? _flipToken : "";
        var _experienceSlug;
        message.experienceSlug = (_experienceSlug = object.experienceSlug) !== null && _experienceSlug !== void 0 ? _experienceSlug : 0;
        var _sellerLeadUuid;
        message.sellerLeadUuid = (_sellerLeadUuid = object.sellerLeadUuid) !== null && _sellerLeadUuid !== void 0 ? _sellerLeadUuid : "";
        return message;
    }
};
function createBaseAloCategory_AloHandoffSubmitEvent() {
    return {
        leadUuid: "",
        offerUuid: "",
        flipToken: "",
        customerName: "",
        customerEmail: "",
        customerPhone: "",
        sellerLeadUuid: "",
        marketIdentifier: "",
        addressReadable: ""
    };
}
var AloCategory_AloHandoffSubmitEvent = {
    fromJSON: function fromJSON(object) {
        return {
            leadUuid: alo_category_isSet(object.leadUuid) ? String(object.leadUuid) : "",
            offerUuid: alo_category_isSet(object.offerUuid) ? String(object.offerUuid) : "",
            flipToken: alo_category_isSet(object.flipToken) ? String(object.flipToken) : "",
            customerName: alo_category_isSet(object.customerName) ? String(object.customerName) : "",
            customerEmail: alo_category_isSet(object.customerEmail) ? String(object.customerEmail) : "",
            customerPhone: alo_category_isSet(object.customerPhone) ? String(object.customerPhone) : "",
            sellerLeadUuid: alo_category_isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : "",
            marketIdentifier: alo_category_isSet(object.marketIdentifier) ? String(object.marketIdentifier) : "",
            addressReadable: alo_category_isSet(object.addressReadable) ? String(object.addressReadable) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.leadUuid !== "") {
            obj.leadUuid = message.leadUuid;
        }
        if (message.offerUuid !== "") {
            obj.offerUuid = message.offerUuid;
        }
        if (message.flipToken !== "") {
            obj.flipToken = message.flipToken;
        }
        if (message.customerName !== "") {
            obj.customerName = message.customerName;
        }
        if (message.customerEmail !== "") {
            obj.customerEmail = message.customerEmail;
        }
        if (message.customerPhone !== "") {
            obj.customerPhone = message.customerPhone;
        }
        if (message.sellerLeadUuid !== "") {
            obj.sellerLeadUuid = message.sellerLeadUuid;
        }
        if (message.marketIdentifier !== "") {
            obj.marketIdentifier = message.marketIdentifier;
        }
        if (message.addressReadable !== "") {
            obj.addressReadable = message.addressReadable;
        }
        return obj;
    },
    create: function create(base) {
        return AloCategory_AloHandoffSubmitEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAloCategory_AloHandoffSubmitEvent();
        var _leadUuid;
        message.leadUuid = (_leadUuid = object.leadUuid) !== null && _leadUuid !== void 0 ? _leadUuid : "";
        var _offerUuid;
        message.offerUuid = (_offerUuid = object.offerUuid) !== null && _offerUuid !== void 0 ? _offerUuid : "";
        var _flipToken;
        message.flipToken = (_flipToken = object.flipToken) !== null && _flipToken !== void 0 ? _flipToken : "";
        var _customerName;
        message.customerName = (_customerName = object.customerName) !== null && _customerName !== void 0 ? _customerName : "";
        var _customerEmail;
        message.customerEmail = (_customerEmail = object.customerEmail) !== null && _customerEmail !== void 0 ? _customerEmail : "";
        var _customerPhone;
        message.customerPhone = (_customerPhone = object.customerPhone) !== null && _customerPhone !== void 0 ? _customerPhone : "";
        var _sellerLeadUuid;
        message.sellerLeadUuid = (_sellerLeadUuid = object.sellerLeadUuid) !== null && _sellerLeadUuid !== void 0 ? _sellerLeadUuid : "";
        var _marketIdentifier;
        message.marketIdentifier = (_marketIdentifier = object.marketIdentifier) !== null && _marketIdentifier !== void 0 ? _marketIdentifier : "";
        var _addressReadable;
        message.addressReadable = (_addressReadable = object.addressReadable) !== null && _addressReadable !== void 0 ? _addressReadable : "";
        return message;
    }
};
function isObject(value) {
    return typeof value === "object" && value !== null;
}
function alo_category_isSet(value) {
    return value !== null && value !== undefined;
}

;// CONCATENATED MODULE: ./src/__generated__/protobuf/journey/data/categories/assessment_category.ts
/* eslint-disable */ 

var assessment_category_protobufPackage = "od_protos.journey.data.categories";
var AssessmentCategory_AssessmentType;
(function(AssessmentCategory_AssessmentType) {
    AssessmentCategory_AssessmentType[AssessmentCategory_AssessmentType["UNKNOWN_ASSESSMENT_TYPE"] = 0] = "UNKNOWN_ASSESSMENT_TYPE";
    AssessmentCategory_AssessmentType[AssessmentCategory_AssessmentType["ORVA"] = 1] = "ORVA";
    AssessmentCategory_AssessmentType[AssessmentCategory_AssessmentType["SSVA"] = 2] = "SSVA";
    AssessmentCategory_AssessmentType[AssessmentCategory_AssessmentType["HA"] = 3] = "HA";
    AssessmentCategory_AssessmentType[AssessmentCategory_AssessmentType["VIRTUAL_INSPECTION"] = 4] = "VIRTUAL_INSPECTION";
    AssessmentCategory_AssessmentType[AssessmentCategory_AssessmentType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(AssessmentCategory_AssessmentType || (AssessmentCategory_AssessmentType = {}));
function assessmentCategory_AssessmentTypeFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN_ASSESSMENT_TYPE":
            return AssessmentCategory_AssessmentType.UNKNOWN_ASSESSMENT_TYPE;
        case 1:
        case "ORVA":
            return AssessmentCategory_AssessmentType.ORVA;
        case 2:
        case "SSVA":
            return AssessmentCategory_AssessmentType.SSVA;
        case 3:
        case "HA":
            return AssessmentCategory_AssessmentType.HA;
        case 4:
        case "VIRTUAL_INSPECTION":
            return AssessmentCategory_AssessmentType.VIRTUAL_INSPECTION;
        case -1:
        case "UNRECOGNIZED":
        default:
            return AssessmentCategory_AssessmentType.UNRECOGNIZED;
    }
}
function assessmentCategory_AssessmentTypeToJSON(object) {
    switch(object){
        case AssessmentCategory_AssessmentType.UNKNOWN_ASSESSMENT_TYPE:
            return "UNKNOWN_ASSESSMENT_TYPE";
        case AssessmentCategory_AssessmentType.ORVA:
            return "ORVA";
        case AssessmentCategory_AssessmentType.SSVA:
            return "SSVA";
        case AssessmentCategory_AssessmentType.HA:
            return "HA";
        case AssessmentCategory_AssessmentType.VIRTUAL_INSPECTION:
            return "VIRTUAL_INSPECTION";
        case AssessmentCategory_AssessmentType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
function createBaseAssessmentCategory() {
    return {
        event: undefined
    };
}
var AssessmentCategory = {
    fromJSON: function fromJSON(object) {
        return {
            event: assessment_category_isSet(object.flowStart) ? {
                $case: "flowStart",
                flowStart: AssessmentCategory_AssessmentFlowStartEvent.fromJSON(object.flowStart)
            } : assessment_category_isSet(object.flowCompleted) ? {
                $case: "flowCompleted",
                flowCompleted: AssessmentCategory_AssessmentFlowCompletedEvent.fromJSON(object.flowCompleted)
            } : assessment_category_isSet(object.requested) ? {
                $case: "requested",
                requested: AssessmentCategory_AssessmentRequestedEvent.fromJSON(object.requested)
            } : assessment_category_isSet(object.scheduleStart) ? {
                $case: "scheduleStart",
                scheduleStart: AssessmentCategory_AssessmentScheduleStartEvent.fromJSON(object.scheduleStart)
            } : assessment_category_isSet(object.firstPhotoTaken) ? {
                $case: "firstPhotoTaken",
                firstPhotoTaken: AssessmentCategory_AssessmentFirstPhotoTaken.fromJSON(object.firstPhotoTaken)
            } : assessment_category_isSet(object.firstQuestionAnswered) ? {
                $case: "firstQuestionAnswered",
                firstQuestionAnswered: AssessmentCategory_AssessmentFirstQuestionAnswered.fromJSON(object.firstQuestionAnswered)
            } : assessment_category_isSet(object.spaceCompleted) ? {
                $case: "spaceCompleted",
                spaceCompleted: AssessmentCategory_AssessmentSpaceCompleted.fromJSON(object.spaceCompleted)
            } : undefined
        };
    },
    toJSON: function toJSON(message) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6;
        var obj = {};
        if (((ref = message.event) === null || ref === void 0 ? void 0 : ref.$case) === "flowStart") {
            obj.flowStart = AssessmentCategory_AssessmentFlowStartEvent.toJSON(message.event.flowStart);
        }
        if (((ref1 = message.event) === null || ref1 === void 0 ? void 0 : ref1.$case) === "flowCompleted") {
            obj.flowCompleted = AssessmentCategory_AssessmentFlowCompletedEvent.toJSON(message.event.flowCompleted);
        }
        if (((ref2 = message.event) === null || ref2 === void 0 ? void 0 : ref2.$case) === "requested") {
            obj.requested = AssessmentCategory_AssessmentRequestedEvent.toJSON(message.event.requested);
        }
        if (((ref3 = message.event) === null || ref3 === void 0 ? void 0 : ref3.$case) === "scheduleStart") {
            obj.scheduleStart = AssessmentCategory_AssessmentScheduleStartEvent.toJSON(message.event.scheduleStart);
        }
        if (((ref4 = message.event) === null || ref4 === void 0 ? void 0 : ref4.$case) === "firstPhotoTaken") {
            obj.firstPhotoTaken = AssessmentCategory_AssessmentFirstPhotoTaken.toJSON(message.event.firstPhotoTaken);
        }
        if (((ref5 = message.event) === null || ref5 === void 0 ? void 0 : ref5.$case) === "firstQuestionAnswered") {
            obj.firstQuestionAnswered = AssessmentCategory_AssessmentFirstQuestionAnswered.toJSON(message.event.firstQuestionAnswered);
        }
        if (((ref6 = message.event) === null || ref6 === void 0 ? void 0 : ref6.$case) === "spaceCompleted") {
            obj.spaceCompleted = AssessmentCategory_AssessmentSpaceCompleted.toJSON(message.event.spaceCompleted);
        }
        return obj;
    },
    create: function create(base) {
        return AssessmentCategory.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20;
        var message = createBaseAssessmentCategory();
        if (((ref = object.event) === null || ref === void 0 ? void 0 : ref.$case) === "flowStart" && ((ref1 = object.event) === null || ref1 === void 0 ? void 0 : ref1.flowStart) !== undefined && ((ref2 = object.event) === null || ref2 === void 0 ? void 0 : ref2.flowStart) !== null) {
            message.event = {
                $case: "flowStart",
                flowStart: AssessmentCategory_AssessmentFlowStartEvent.fromPartial(object.event.flowStart)
            };
        }
        if (((ref3 = object.event) === null || ref3 === void 0 ? void 0 : ref3.$case) === "flowCompleted" && ((ref4 = object.event) === null || ref4 === void 0 ? void 0 : ref4.flowCompleted) !== undefined && ((ref5 = object.event) === null || ref5 === void 0 ? void 0 : ref5.flowCompleted) !== null) {
            message.event = {
                $case: "flowCompleted",
                flowCompleted: AssessmentCategory_AssessmentFlowCompletedEvent.fromPartial(object.event.flowCompleted)
            };
        }
        if (((ref6 = object.event) === null || ref6 === void 0 ? void 0 : ref6.$case) === "requested" && ((ref7 = object.event) === null || ref7 === void 0 ? void 0 : ref7.requested) !== undefined && ((ref8 = object.event) === null || ref8 === void 0 ? void 0 : ref8.requested) !== null) {
            message.event = {
                $case: "requested",
                requested: AssessmentCategory_AssessmentRequestedEvent.fromPartial(object.event.requested)
            };
        }
        if (((ref9 = object.event) === null || ref9 === void 0 ? void 0 : ref9.$case) === "scheduleStart" && ((ref10 = object.event) === null || ref10 === void 0 ? void 0 : ref10.scheduleStart) !== undefined && ((ref11 = object.event) === null || ref11 === void 0 ? void 0 : ref11.scheduleStart) !== null) {
            message.event = {
                $case: "scheduleStart",
                scheduleStart: AssessmentCategory_AssessmentScheduleStartEvent.fromPartial(object.event.scheduleStart)
            };
        }
        if (((ref12 = object.event) === null || ref12 === void 0 ? void 0 : ref12.$case) === "firstPhotoTaken" && ((ref13 = object.event) === null || ref13 === void 0 ? void 0 : ref13.firstPhotoTaken) !== undefined && ((ref14 = object.event) === null || ref14 === void 0 ? void 0 : ref14.firstPhotoTaken) !== null) {
            message.event = {
                $case: "firstPhotoTaken",
                firstPhotoTaken: AssessmentCategory_AssessmentFirstPhotoTaken.fromPartial(object.event.firstPhotoTaken)
            };
        }
        if (((ref15 = object.event) === null || ref15 === void 0 ? void 0 : ref15.$case) === "firstQuestionAnswered" && ((ref16 = object.event) === null || ref16 === void 0 ? void 0 : ref16.firstQuestionAnswered) !== undefined && ((ref17 = object.event) === null || ref17 === void 0 ? void 0 : ref17.firstQuestionAnswered) !== null) {
            message.event = {
                $case: "firstQuestionAnswered",
                firstQuestionAnswered: AssessmentCategory_AssessmentFirstQuestionAnswered.fromPartial(object.event.firstQuestionAnswered)
            };
        }
        if (((ref18 = object.event) === null || ref18 === void 0 ? void 0 : ref18.$case) === "spaceCompleted" && ((ref19 = object.event) === null || ref19 === void 0 ? void 0 : ref19.spaceCompleted) !== undefined && ((ref20 = object.event) === null || ref20 === void 0 ? void 0 : ref20.spaceCompleted) !== null) {
            message.event = {
                $case: "spaceCompleted",
                spaceCompleted: AssessmentCategory_AssessmentSpaceCompleted.fromPartial(object.event.spaceCompleted)
            };
        }
        return message;
    }
};
function createBaseAssessmentCategory_AssessmentFlowStartEvent() {
    return {
        leadId: "",
        offerUuid: "",
        assessmentType: 0,
        sellerLeadUuid: ""
    };
}
var AssessmentCategory_AssessmentFlowStartEvent = {
    fromJSON: function fromJSON(object) {
        return {
            leadId: assessment_category_isSet(object.leadId) ? String(object.leadId) : "",
            offerUuid: assessment_category_isSet(object.offerUuid) ? String(object.offerUuid) : "",
            assessmentType: assessment_category_isSet(object.assessmentType) ? assessmentCategory_AssessmentTypeFromJSON(object.assessmentType) : 0,
            sellerLeadUuid: assessment_category_isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.leadId !== "") {
            obj.leadId = message.leadId;
        }
        if (message.offerUuid !== "") {
            obj.offerUuid = message.offerUuid;
        }
        if (message.assessmentType !== 0) {
            obj.assessmentType = assessmentCategory_AssessmentTypeToJSON(message.assessmentType);
        }
        if (message.sellerLeadUuid !== "") {
            obj.sellerLeadUuid = message.sellerLeadUuid;
        }
        return obj;
    },
    create: function create(base) {
        return AssessmentCategory_AssessmentFlowStartEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAssessmentCategory_AssessmentFlowStartEvent();
        var _leadId;
        message.leadId = (_leadId = object.leadId) !== null && _leadId !== void 0 ? _leadId : "";
        var _offerUuid;
        message.offerUuid = (_offerUuid = object.offerUuid) !== null && _offerUuid !== void 0 ? _offerUuid : "";
        var _assessmentType;
        message.assessmentType = (_assessmentType = object.assessmentType) !== null && _assessmentType !== void 0 ? _assessmentType : 0;
        var _sellerLeadUuid;
        message.sellerLeadUuid = (_sellerLeadUuid = object.sellerLeadUuid) !== null && _sellerLeadUuid !== void 0 ? _sellerLeadUuid : "";
        return message;
    }
};
function createBaseAssessmentCategory_AssessmentFlowCompletedEvent() {
    return {
        leadId: "",
        offerUuid: "",
        assessmentType: 0,
        sellerLeadUuid: ""
    };
}
var AssessmentCategory_AssessmentFlowCompletedEvent = {
    fromJSON: function fromJSON(object) {
        return {
            leadId: assessment_category_isSet(object.leadId) ? String(object.leadId) : "",
            offerUuid: assessment_category_isSet(object.offerUuid) ? String(object.offerUuid) : "",
            assessmentType: assessment_category_isSet(object.assessmentType) ? assessmentCategory_AssessmentTypeFromJSON(object.assessmentType) : 0,
            sellerLeadUuid: assessment_category_isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.leadId !== "") {
            obj.leadId = message.leadId;
        }
        if (message.offerUuid !== "") {
            obj.offerUuid = message.offerUuid;
        }
        if (message.assessmentType !== 0) {
            obj.assessmentType = assessmentCategory_AssessmentTypeToJSON(message.assessmentType);
        }
        if (message.sellerLeadUuid !== "") {
            obj.sellerLeadUuid = message.sellerLeadUuid;
        }
        return obj;
    },
    create: function create(base) {
        return AssessmentCategory_AssessmentFlowCompletedEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAssessmentCategory_AssessmentFlowCompletedEvent();
        var _leadId;
        message.leadId = (_leadId = object.leadId) !== null && _leadId !== void 0 ? _leadId : "";
        var _offerUuid;
        message.offerUuid = (_offerUuid = object.offerUuid) !== null && _offerUuid !== void 0 ? _offerUuid : "";
        var _assessmentType;
        message.assessmentType = (_assessmentType = object.assessmentType) !== null && _assessmentType !== void 0 ? _assessmentType : 0;
        var _sellerLeadUuid;
        message.sellerLeadUuid = (_sellerLeadUuid = object.sellerLeadUuid) !== null && _sellerLeadUuid !== void 0 ? _sellerLeadUuid : "";
        return message;
    }
};
function createBaseAssessmentCategory_AssessmentRequestedEvent() {
    return {
        sellerLeadUuid: "",
        offerUuid: "",
        requestedDatetime: undefined
    };
}
var AssessmentCategory_AssessmentRequestedEvent = {
    fromJSON: function fromJSON(object) {
        return {
            sellerLeadUuid: assessment_category_isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : "",
            offerUuid: assessment_category_isSet(object.offerUuid) ? String(object.offerUuid) : "",
            requestedDatetime: assessment_category_isSet(object.requestedDatetime) ? fromJsonTimestamp(object.requestedDatetime) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.sellerLeadUuid !== "") {
            obj.sellerLeadUuid = message.sellerLeadUuid;
        }
        if (message.offerUuid !== "") {
            obj.offerUuid = message.offerUuid;
        }
        if (message.requestedDatetime !== undefined) {
            obj.requestedDatetime = message.requestedDatetime.toISOString();
        }
        return obj;
    },
    create: function create(base) {
        return AssessmentCategory_AssessmentRequestedEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAssessmentCategory_AssessmentRequestedEvent();
        var _sellerLeadUuid;
        message.sellerLeadUuid = (_sellerLeadUuid = object.sellerLeadUuid) !== null && _sellerLeadUuid !== void 0 ? _sellerLeadUuid : "";
        var _offerUuid;
        message.offerUuid = (_offerUuid = object.offerUuid) !== null && _offerUuid !== void 0 ? _offerUuid : "";
        var _requestedDatetime;
        message.requestedDatetime = (_requestedDatetime = object.requestedDatetime) !== null && _requestedDatetime !== void 0 ? _requestedDatetime : undefined;
        return message;
    }
};
function createBaseAssessmentCategory_AssessmentScheduleStartEvent() {
    return {
        sellerLeadUuid: "",
        offerUuid: "",
        assessmentType: 0
    };
}
var AssessmentCategory_AssessmentScheduleStartEvent = {
    fromJSON: function fromJSON(object) {
        return {
            sellerLeadUuid: assessment_category_isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : "",
            offerUuid: assessment_category_isSet(object.offerUuid) ? String(object.offerUuid) : "",
            assessmentType: assessment_category_isSet(object.assessmentType) ? assessmentCategory_AssessmentTypeFromJSON(object.assessmentType) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.sellerLeadUuid !== "") {
            obj.sellerLeadUuid = message.sellerLeadUuid;
        }
        if (message.offerUuid !== "") {
            obj.offerUuid = message.offerUuid;
        }
        if (message.assessmentType !== 0) {
            obj.assessmentType = assessmentCategory_AssessmentTypeToJSON(message.assessmentType);
        }
        return obj;
    },
    create: function create(base) {
        return AssessmentCategory_AssessmentScheduleStartEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAssessmentCategory_AssessmentScheduleStartEvent();
        var _sellerLeadUuid;
        message.sellerLeadUuid = (_sellerLeadUuid = object.sellerLeadUuid) !== null && _sellerLeadUuid !== void 0 ? _sellerLeadUuid : "";
        var _offerUuid;
        message.offerUuid = (_offerUuid = object.offerUuid) !== null && _offerUuid !== void 0 ? _offerUuid : "";
        var _assessmentType;
        message.assessmentType = (_assessmentType = object.assessmentType) !== null && _assessmentType !== void 0 ? _assessmentType : 0;
        return message;
    }
};
function createBaseAssessmentCategory_AssessmentFirstPhotoTaken() {
    return {
        sellerLeadUuid: "",
        offerUuid: ""
    };
}
var AssessmentCategory_AssessmentFirstPhotoTaken = {
    fromJSON: function fromJSON(object) {
        return {
            sellerLeadUuid: assessment_category_isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : "",
            offerUuid: assessment_category_isSet(object.offerUuid) ? String(object.offerUuid) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.sellerLeadUuid !== "") {
            obj.sellerLeadUuid = message.sellerLeadUuid;
        }
        if (message.offerUuid !== "") {
            obj.offerUuid = message.offerUuid;
        }
        return obj;
    },
    create: function create(base) {
        return AssessmentCategory_AssessmentFirstPhotoTaken.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAssessmentCategory_AssessmentFirstPhotoTaken();
        var _sellerLeadUuid;
        message.sellerLeadUuid = (_sellerLeadUuid = object.sellerLeadUuid) !== null && _sellerLeadUuid !== void 0 ? _sellerLeadUuid : "";
        var _offerUuid;
        message.offerUuid = (_offerUuid = object.offerUuid) !== null && _offerUuid !== void 0 ? _offerUuid : "";
        return message;
    }
};
function createBaseAssessmentCategory_AssessmentFirstQuestionAnswered() {
    return {
        sellerLeadUuid: "",
        offerUuid: ""
    };
}
var AssessmentCategory_AssessmentFirstQuestionAnswered = {
    fromJSON: function fromJSON(object) {
        return {
            sellerLeadUuid: assessment_category_isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : "",
            offerUuid: assessment_category_isSet(object.offerUuid) ? String(object.offerUuid) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.sellerLeadUuid !== "") {
            obj.sellerLeadUuid = message.sellerLeadUuid;
        }
        if (message.offerUuid !== "") {
            obj.offerUuid = message.offerUuid;
        }
        return obj;
    },
    create: function create(base) {
        return AssessmentCategory_AssessmentFirstQuestionAnswered.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAssessmentCategory_AssessmentFirstQuestionAnswered();
        var _sellerLeadUuid;
        message.sellerLeadUuid = (_sellerLeadUuid = object.sellerLeadUuid) !== null && _sellerLeadUuid !== void 0 ? _sellerLeadUuid : "";
        var _offerUuid;
        message.offerUuid = (_offerUuid = object.offerUuid) !== null && _offerUuid !== void 0 ? _offerUuid : "";
        return message;
    }
};
function createBaseAssessmentCategory_AssessmentSpaceCompleted() {
    return {
        sellerLeadUuid: "",
        offerUuid: "",
        allAreasCompleted: false,
        spaceTypeName: ""
    };
}
var AssessmentCategory_AssessmentSpaceCompleted = {
    fromJSON: function fromJSON(object) {
        return {
            sellerLeadUuid: assessment_category_isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : "",
            offerUuid: assessment_category_isSet(object.offerUuid) ? String(object.offerUuid) : "",
            allAreasCompleted: assessment_category_isSet(object.allAreasCompleted) ? Boolean(object.allAreasCompleted) : false,
            spaceTypeName: assessment_category_isSet(object.spaceTypeName) ? String(object.spaceTypeName) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.sellerLeadUuid !== "") {
            obj.sellerLeadUuid = message.sellerLeadUuid;
        }
        if (message.offerUuid !== "") {
            obj.offerUuid = message.offerUuid;
        }
        if (message.allAreasCompleted === true) {
            obj.allAreasCompleted = message.allAreasCompleted;
        }
        if (message.spaceTypeName !== "") {
            obj.spaceTypeName = message.spaceTypeName;
        }
        return obj;
    },
    create: function create(base) {
        return AssessmentCategory_AssessmentSpaceCompleted.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAssessmentCategory_AssessmentSpaceCompleted();
        var _sellerLeadUuid;
        message.sellerLeadUuid = (_sellerLeadUuid = object.sellerLeadUuid) !== null && _sellerLeadUuid !== void 0 ? _sellerLeadUuid : "";
        var _offerUuid;
        message.offerUuid = (_offerUuid = object.offerUuid) !== null && _offerUuid !== void 0 ? _offerUuid : "";
        var _allAreasCompleted;
        message.allAreasCompleted = (_allAreasCompleted = object.allAreasCompleted) !== null && _allAreasCompleted !== void 0 ? _allAreasCompleted : false;
        var _spaceTypeName;
        message.spaceTypeName = (_spaceTypeName = object.spaceTypeName) !== null && _spaceTypeName !== void 0 ? _spaceTypeName : "";
        return message;
    }
};
function fromTimestamp(t) {
    var millis = (t.seconds || 0) * 1000;
    millis += (t.nanos || 0) / 1000000;
    return new Date(millis);
}
function fromJsonTimestamp(o) {
    if ((0,_instanceof/* default */.Z)(o, Date)) {
        return o;
    } else if (typeof o === "string") {
        return new Date(o);
    } else {
        return fromTimestamp(Timestamp.fromJSON(o));
    }
}
function assessment_category_isSet(value) {
    return value !== null && value !== undefined;
}

;// CONCATENATED MODULE: ./src/__generated__/protobuf/journey/data/categories/authentication_category.ts
/* eslint-disable */ var authentication_category_protobufPackage = "od_protos.journey.data.categories";
var AuthenticationCategory_AuthMethod;
(function(AuthenticationCategory_AuthMethod) {
    AuthenticationCategory_AuthMethod[AuthenticationCategory_AuthMethod["METHOD_UNSPECIFIED"] = 0] = "METHOD_UNSPECIFIED";
    AuthenticationCategory_AuthMethod[AuthenticationCategory_AuthMethod["EMAIL_PASSWORD"] = 1] = "EMAIL_PASSWORD";
    AuthenticationCategory_AuthMethod[AuthenticationCategory_AuthMethod["LITE"] = 2] = "LITE";
    AuthenticationCategory_AuthMethod[AuthenticationCategory_AuthMethod["GOOGLE"] = 3] = "GOOGLE";
    AuthenticationCategory_AuthMethod[AuthenticationCategory_AuthMethod["FACEBOOK"] = 4] = "FACEBOOK";
    AuthenticationCategory_AuthMethod[AuthenticationCategory_AuthMethod["SESSION_ALREADY_EXISTS"] = 5] = "SESSION_ALREADY_EXISTS";
    AuthenticationCategory_AuthMethod[AuthenticationCategory_AuthMethod["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(AuthenticationCategory_AuthMethod || (AuthenticationCategory_AuthMethod = {}));
function authenticationCategory_AuthMethodFromJSON(object) {
    switch(object){
        case 0:
        case "METHOD_UNSPECIFIED":
            return AuthenticationCategory_AuthMethod.METHOD_UNSPECIFIED;
        case 1:
        case "EMAIL_PASSWORD":
            return AuthenticationCategory_AuthMethod.EMAIL_PASSWORD;
        case 2:
        case "LITE":
            return AuthenticationCategory_AuthMethod.LITE;
        case 3:
        case "GOOGLE":
            return AuthenticationCategory_AuthMethod.GOOGLE;
        case 4:
        case "FACEBOOK":
            return AuthenticationCategory_AuthMethod.FACEBOOK;
        case 5:
        case "SESSION_ALREADY_EXISTS":
            return AuthenticationCategory_AuthMethod.SESSION_ALREADY_EXISTS;
        case -1:
        case "UNRECOGNIZED":
        default:
            return AuthenticationCategory_AuthMethod.UNRECOGNIZED;
    }
}
function authenticationCategory_AuthMethodToJSON(object) {
    switch(object){
        case AuthenticationCategory_AuthMethod.METHOD_UNSPECIFIED:
            return "METHOD_UNSPECIFIED";
        case AuthenticationCategory_AuthMethod.EMAIL_PASSWORD:
            return "EMAIL_PASSWORD";
        case AuthenticationCategory_AuthMethod.LITE:
            return "LITE";
        case AuthenticationCategory_AuthMethod.GOOGLE:
            return "GOOGLE";
        case AuthenticationCategory_AuthMethod.FACEBOOK:
            return "FACEBOOK";
        case AuthenticationCategory_AuthMethod.SESSION_ALREADY_EXISTS:
            return "SESSION_ALREADY_EXISTS";
        case AuthenticationCategory_AuthMethod.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var AuthenticationCategory_AuthSource;
(function(AuthenticationCategory_AuthSource) {
    AuthenticationCategory_AuthSource[AuthenticationCategory_AuthSource["SOURCE_UNSPECIFIED"] = 0] = "SOURCE_UNSPECIFIED";
    AuthenticationCategory_AuthSource[AuthenticationCategory_AuthSource["KEY_APP"] = 1] = "KEY_APP";
    AuthenticationCategory_AuthSource[AuthenticationCategory_AuthSource["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(AuthenticationCategory_AuthSource || (AuthenticationCategory_AuthSource = {}));
function authenticationCategory_AuthSourceFromJSON(object) {
    switch(object){
        case 0:
        case "SOURCE_UNSPECIFIED":
            return AuthenticationCategory_AuthSource.SOURCE_UNSPECIFIED;
        case 1:
        case "KEY_APP":
            return AuthenticationCategory_AuthSource.KEY_APP;
        case -1:
        case "UNRECOGNIZED":
        default:
            return AuthenticationCategory_AuthSource.UNRECOGNIZED;
    }
}
function authenticationCategory_AuthSourceToJSON(object) {
    switch(object){
        case AuthenticationCategory_AuthSource.SOURCE_UNSPECIFIED:
            return "SOURCE_UNSPECIFIED";
        case AuthenticationCategory_AuthSource.KEY_APP:
            return "KEY_APP";
        case AuthenticationCategory_AuthSource.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
function createBaseAuthenticationCategory() {
    return {
        event: undefined
    };
}
var AuthenticationCategory = {
    fromJSON: function fromJSON(object) {
        return {
            event: authentication_category_isSet(object.login) ? {
                $case: "login",
                login: AuthenticationCategory_LoginEvent.fromJSON(object.login)
            } : authentication_category_isSet(object.loginFailure) ? {
                $case: "loginFailure",
                loginFailure: AuthenticationCategory_LoginFailureEvent.fromJSON(object.loginFailure)
            } : authentication_category_isSet(object.registration) ? {
                $case: "registration",
                registration: AuthenticationCategory_RegistrationEvent.fromJSON(object.registration)
            } : authentication_category_isSet(object.registrationFailure) ? {
                $case: "registrationFailure",
                registrationFailure: AuthenticationCategory_RegistrationFailureEvent.fromJSON(object.registrationFailure)
            } : undefined
        };
    },
    toJSON: function toJSON(message) {
        var ref, ref1, ref2, ref3;
        var obj = {};
        if (((ref = message.event) === null || ref === void 0 ? void 0 : ref.$case) === "login") {
            obj.login = AuthenticationCategory_LoginEvent.toJSON(message.event.login);
        }
        if (((ref1 = message.event) === null || ref1 === void 0 ? void 0 : ref1.$case) === "loginFailure") {
            obj.loginFailure = AuthenticationCategory_LoginFailureEvent.toJSON(message.event.loginFailure);
        }
        if (((ref2 = message.event) === null || ref2 === void 0 ? void 0 : ref2.$case) === "registration") {
            obj.registration = AuthenticationCategory_RegistrationEvent.toJSON(message.event.registration);
        }
        if (((ref3 = message.event) === null || ref3 === void 0 ? void 0 : ref3.$case) === "registrationFailure") {
            obj.registrationFailure = AuthenticationCategory_RegistrationFailureEvent.toJSON(message.event.registrationFailure);
        }
        return obj;
    },
    create: function create(base) {
        return AuthenticationCategory.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
        var message = createBaseAuthenticationCategory();
        if (((ref = object.event) === null || ref === void 0 ? void 0 : ref.$case) === "login" && ((ref1 = object.event) === null || ref1 === void 0 ? void 0 : ref1.login) !== undefined && ((ref2 = object.event) === null || ref2 === void 0 ? void 0 : ref2.login) !== null) {
            message.event = {
                $case: "login",
                login: AuthenticationCategory_LoginEvent.fromPartial(object.event.login)
            };
        }
        if (((ref3 = object.event) === null || ref3 === void 0 ? void 0 : ref3.$case) === "loginFailure" && ((ref4 = object.event) === null || ref4 === void 0 ? void 0 : ref4.loginFailure) !== undefined && ((ref5 = object.event) === null || ref5 === void 0 ? void 0 : ref5.loginFailure) !== null) {
            message.event = {
                $case: "loginFailure",
                loginFailure: AuthenticationCategory_LoginFailureEvent.fromPartial(object.event.loginFailure)
            };
        }
        if (((ref6 = object.event) === null || ref6 === void 0 ? void 0 : ref6.$case) === "registration" && ((ref7 = object.event) === null || ref7 === void 0 ? void 0 : ref7.registration) !== undefined && ((ref8 = object.event) === null || ref8 === void 0 ? void 0 : ref8.registration) !== null) {
            message.event = {
                $case: "registration",
                registration: AuthenticationCategory_RegistrationEvent.fromPartial(object.event.registration)
            };
        }
        if (((ref9 = object.event) === null || ref9 === void 0 ? void 0 : ref9.$case) === "registrationFailure" && ((ref10 = object.event) === null || ref10 === void 0 ? void 0 : ref10.registrationFailure) !== undefined && ((ref11 = object.event) === null || ref11 === void 0 ? void 0 : ref11.registrationFailure) !== null) {
            message.event = {
                $case: "registrationFailure",
                registrationFailure: AuthenticationCategory_RegistrationFailureEvent.fromPartial(object.event.registrationFailure)
            };
        }
        return message;
    }
};
function createBaseAuthenticationCategory_LoginEvent() {
    return {
        authMethod: 0,
        authSource: 0
    };
}
var AuthenticationCategory_LoginEvent = {
    fromJSON: function fromJSON(object) {
        return {
            authMethod: authentication_category_isSet(object.authMethod) ? authenticationCategory_AuthMethodFromJSON(object.authMethod) : 0,
            authSource: authentication_category_isSet(object.authSource) ? authenticationCategory_AuthSourceFromJSON(object.authSource) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.authMethod !== 0) {
            obj.authMethod = authenticationCategory_AuthMethodToJSON(message.authMethod);
        }
        if (message.authSource !== 0) {
            obj.authSource = authenticationCategory_AuthSourceToJSON(message.authSource);
        }
        return obj;
    },
    create: function create(base) {
        return AuthenticationCategory_LoginEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAuthenticationCategory_LoginEvent();
        var _authMethod;
        message.authMethod = (_authMethod = object.authMethod) !== null && _authMethod !== void 0 ? _authMethod : 0;
        var _authSource;
        message.authSource = (_authSource = object.authSource) !== null && _authSource !== void 0 ? _authSource : 0;
        return message;
    }
};
function createBaseAuthenticationCategory_LoginFailureEvent() {
    return {
        authMethod: 0,
        authSource: 0
    };
}
var AuthenticationCategory_LoginFailureEvent = {
    fromJSON: function fromJSON(object) {
        return {
            authMethod: authentication_category_isSet(object.authMethod) ? authenticationCategory_AuthMethodFromJSON(object.authMethod) : 0,
            authSource: authentication_category_isSet(object.authSource) ? authenticationCategory_AuthSourceFromJSON(object.authSource) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.authMethod !== 0) {
            obj.authMethod = authenticationCategory_AuthMethodToJSON(message.authMethod);
        }
        if (message.authSource !== 0) {
            obj.authSource = authenticationCategory_AuthSourceToJSON(message.authSource);
        }
        return obj;
    },
    create: function create(base) {
        return AuthenticationCategory_LoginFailureEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAuthenticationCategory_LoginFailureEvent();
        var _authMethod;
        message.authMethod = (_authMethod = object.authMethod) !== null && _authMethod !== void 0 ? _authMethod : 0;
        var _authSource;
        message.authSource = (_authSource = object.authSource) !== null && _authSource !== void 0 ? _authSource : 0;
        return message;
    }
};
function createBaseAuthenticationCategory_RegistrationEvent() {
    return {
        authMethod: 0,
        email: "",
        phone: undefined,
        firstName: undefined,
        lastName: undefined,
        authSource: 0
    };
}
var AuthenticationCategory_RegistrationEvent = {
    fromJSON: function fromJSON(object) {
        return {
            authMethod: authentication_category_isSet(object.authMethod) ? authenticationCategory_AuthMethodFromJSON(object.authMethod) : 0,
            email: authentication_category_isSet(object.email) ? String(object.email) : "",
            phone: authentication_category_isSet(object.phone) ? String(object.phone) : undefined,
            firstName: authentication_category_isSet(object.firstName) ? String(object.firstName) : undefined,
            lastName: authentication_category_isSet(object.lastName) ? String(object.lastName) : undefined,
            authSource: authentication_category_isSet(object.authSource) ? authenticationCategory_AuthSourceFromJSON(object.authSource) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.authMethod !== 0) {
            obj.authMethod = authenticationCategory_AuthMethodToJSON(message.authMethod);
        }
        if (message.email !== "") {
            obj.email = message.email;
        }
        if (message.phone !== undefined) {
            obj.phone = message.phone;
        }
        if (message.firstName !== undefined) {
            obj.firstName = message.firstName;
        }
        if (message.lastName !== undefined) {
            obj.lastName = message.lastName;
        }
        if (message.authSource !== 0) {
            obj.authSource = authenticationCategory_AuthSourceToJSON(message.authSource);
        }
        return obj;
    },
    create: function create(base) {
        return AuthenticationCategory_RegistrationEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAuthenticationCategory_RegistrationEvent();
        var _authMethod;
        message.authMethod = (_authMethod = object.authMethod) !== null && _authMethod !== void 0 ? _authMethod : 0;
        var _email;
        message.email = (_email = object.email) !== null && _email !== void 0 ? _email : "";
        var _phone;
        message.phone = (_phone = object.phone) !== null && _phone !== void 0 ? _phone : undefined;
        var _firstName;
        message.firstName = (_firstName = object.firstName) !== null && _firstName !== void 0 ? _firstName : undefined;
        var _lastName;
        message.lastName = (_lastName = object.lastName) !== null && _lastName !== void 0 ? _lastName : undefined;
        var _authSource;
        message.authSource = (_authSource = object.authSource) !== null && _authSource !== void 0 ? _authSource : 0;
        return message;
    }
};
function createBaseAuthenticationCategory_RegistrationFailureEvent() {
    return {
        authMethod: 0,
        authSource: 0
    };
}
var AuthenticationCategory_RegistrationFailureEvent = {
    fromJSON: function fromJSON(object) {
        return {
            authMethod: authentication_category_isSet(object.authMethod) ? authenticationCategory_AuthMethodFromJSON(object.authMethod) : 0,
            authSource: authentication_category_isSet(object.authSource) ? authenticationCategory_AuthSourceFromJSON(object.authSource) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.authMethod !== 0) {
            obj.authMethod = authenticationCategory_AuthMethodToJSON(message.authMethod);
        }
        if (message.authSource !== 0) {
            obj.authSource = authenticationCategory_AuthSourceToJSON(message.authSource);
        }
        return obj;
    },
    create: function create(base) {
        return AuthenticationCategory_RegistrationFailureEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAuthenticationCategory_RegistrationFailureEvent();
        var _authMethod;
        message.authMethod = (_authMethod = object.authMethod) !== null && _authMethod !== void 0 ? _authMethod : 0;
        var _authSource;
        message.authSource = (_authSource = object.authSource) !== null && _authSource !== void 0 ? _authSource : 0;
        return message;
    }
};
function authentication_category_isSet(value) {
    return value !== null && value !== undefined;
}

;// CONCATENATED MODULE: ./src/__generated__/protobuf/journey/data/categories/chat_category.ts
/* eslint-disable */ 

var chat_category_protobufPackage = "od_protos.journey.data.categories";
var ChatCategory_InteractionEvent_InteractionType;
(function(ChatCategory_InteractionEvent_InteractionType) {
    ChatCategory_InteractionEvent_InteractionType[ChatCategory_InteractionEvent_InteractionType["UNKNOWN_INTERACTION_TYPE"] = 0] = "UNKNOWN_INTERACTION_TYPE";
    ChatCategory_InteractionEvent_InteractionType[ChatCategory_InteractionEvent_InteractionType["SMS"] = 1] = "SMS";
    ChatCategory_InteractionEvent_InteractionType[ChatCategory_InteractionEvent_InteractionType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ChatCategory_InteractionEvent_InteractionType || (ChatCategory_InteractionEvent_InteractionType = {}));
function chatCategory_InteractionEvent_InteractionTypeFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN_INTERACTION_TYPE":
            return ChatCategory_InteractionEvent_InteractionType.UNKNOWN_INTERACTION_TYPE;
        case 1:
        case "SMS":
            return ChatCategory_InteractionEvent_InteractionType.SMS;
        case -1:
        case "UNRECOGNIZED":
        default:
            return ChatCategory_InteractionEvent_InteractionType.UNRECOGNIZED;
    }
}
function chatCategory_InteractionEvent_InteractionTypeToJSON(object) {
    switch(object){
        case ChatCategory_InteractionEvent_InteractionType.UNKNOWN_INTERACTION_TYPE:
            return "UNKNOWN_INTERACTION_TYPE";
        case ChatCategory_InteractionEvent_InteractionType.SMS:
            return "SMS";
        case ChatCategory_InteractionEvent_InteractionType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var ChatCategory_InteractionEvent_Source;
(function(ChatCategory_InteractionEvent_Source) {
    ChatCategory_InteractionEvent_Source[ChatCategory_InteractionEvent_Source["UNKNOWN_SOURCE"] = 0] = "UNKNOWN_SOURCE";
    ChatCategory_InteractionEvent_Source[ChatCategory_InteractionEvent_Source["CHAT_UI"] = 1] = "CHAT_UI";
    ChatCategory_InteractionEvent_Source[ChatCategory_InteractionEvent_Source["OPENDOOR_INITIATED"] = 2] = "OPENDOOR_INITIATED";
    ChatCategory_InteractionEvent_Source[ChatCategory_InteractionEvent_Source["CUSTOMER_INITIATED"] = 3] = "CUSTOMER_INITIATED";
    ChatCategory_InteractionEvent_Source[ChatCategory_InteractionEvent_Source["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ChatCategory_InteractionEvent_Source || (ChatCategory_InteractionEvent_Source = {}));
function chatCategory_InteractionEvent_SourceFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN_SOURCE":
            return ChatCategory_InteractionEvent_Source.UNKNOWN_SOURCE;
        case 1:
        case "CHAT_UI":
            return ChatCategory_InteractionEvent_Source.CHAT_UI;
        case 2:
        case "OPENDOOR_INITIATED":
            return ChatCategory_InteractionEvent_Source.OPENDOOR_INITIATED;
        case 3:
        case "CUSTOMER_INITIATED":
            return ChatCategory_InteractionEvent_Source.CUSTOMER_INITIATED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return ChatCategory_InteractionEvent_Source.UNRECOGNIZED;
    }
}
function chatCategory_InteractionEvent_SourceToJSON(object) {
    switch(object){
        case ChatCategory_InteractionEvent_Source.UNKNOWN_SOURCE:
            return "UNKNOWN_SOURCE";
        case ChatCategory_InteractionEvent_Source.CHAT_UI:
            return "CHAT_UI";
        case ChatCategory_InteractionEvent_Source.OPENDOOR_INITIATED:
            return "OPENDOOR_INITIATED";
        case ChatCategory_InteractionEvent_Source.CUSTOMER_INITIATED:
            return "CUSTOMER_INITIATED";
        case ChatCategory_InteractionEvent_Source.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
function createBaseChatCategory() {
    return {
        event: undefined
    };
}
var ChatCategory = {
    fromJSON: function fromJSON(object) {
        return {
            event: chat_category_isSet(object.interaction) ? {
                $case: "interaction",
                interaction: ChatCategory_InteractionEvent.fromJSON(object.interaction)
            } : undefined
        };
    },
    toJSON: function toJSON(message) {
        var ref;
        var obj = {};
        if (((ref = message.event) === null || ref === void 0 ? void 0 : ref.$case) === "interaction") {
            obj.interaction = ChatCategory_InteractionEvent.toJSON(message.event.interaction);
        }
        return obj;
    },
    create: function create(base) {
        return ChatCategory.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref, ref1, ref2;
        var message = createBaseChatCategory();
        if (((ref = object.event) === null || ref === void 0 ? void 0 : ref.$case) === "interaction" && ((ref1 = object.event) === null || ref1 === void 0 ? void 0 : ref1.interaction) !== undefined && ((ref2 = object.event) === null || ref2 === void 0 ? void 0 : ref2.interaction) !== null) {
            message.event = {
                $case: "interaction",
                interaction: ChatCategory_InteractionEvent.fromPartial(object.event.interaction)
            };
        }
        return message;
    }
};
function createBaseChatCategory_InteractionEvent() {
    return {
        interactionId: "",
        rawUserInput: "",
        phoneNumber: "",
        createdAt: undefined,
        interactionType: 0,
        source: 0,
        category: ""
    };
}
var ChatCategory_InteractionEvent = {
    fromJSON: function fromJSON(object) {
        return {
            interactionId: chat_category_isSet(object.interactionId) ? String(object.interactionId) : "",
            rawUserInput: chat_category_isSet(object.rawUserInput) ? String(object.rawUserInput) : "",
            phoneNumber: chat_category_isSet(object.phoneNumber) ? String(object.phoneNumber) : "",
            createdAt: chat_category_isSet(object.createdAt) ? chat_category_fromJsonTimestamp(object.createdAt) : undefined,
            interactionType: chat_category_isSet(object.interactionType) ? chatCategory_InteractionEvent_InteractionTypeFromJSON(object.interactionType) : 0,
            source: chat_category_isSet(object.source) ? chatCategory_InteractionEvent_SourceFromJSON(object.source) : 0,
            category: chat_category_isSet(object.category) ? String(object.category) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.interactionId !== "") {
            obj.interactionId = message.interactionId;
        }
        if (message.rawUserInput !== "") {
            obj.rawUserInput = message.rawUserInput;
        }
        if (message.phoneNumber !== "") {
            obj.phoneNumber = message.phoneNumber;
        }
        if (message.createdAt !== undefined) {
            obj.createdAt = message.createdAt.toISOString();
        }
        if (message.interactionType !== 0) {
            obj.interactionType = chatCategory_InteractionEvent_InteractionTypeToJSON(message.interactionType);
        }
        if (message.source !== 0) {
            obj.source = chatCategory_InteractionEvent_SourceToJSON(message.source);
        }
        if (message.category !== "") {
            obj.category = message.category;
        }
        return obj;
    },
    create: function create(base) {
        return ChatCategory_InteractionEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseChatCategory_InteractionEvent();
        var _interactionId;
        message.interactionId = (_interactionId = object.interactionId) !== null && _interactionId !== void 0 ? _interactionId : "";
        var _rawUserInput;
        message.rawUserInput = (_rawUserInput = object.rawUserInput) !== null && _rawUserInput !== void 0 ? _rawUserInput : "";
        var _phoneNumber;
        message.phoneNumber = (_phoneNumber = object.phoneNumber) !== null && _phoneNumber !== void 0 ? _phoneNumber : "";
        var _createdAt;
        message.createdAt = (_createdAt = object.createdAt) !== null && _createdAt !== void 0 ? _createdAt : undefined;
        var _interactionType;
        message.interactionType = (_interactionType = object.interactionType) !== null && _interactionType !== void 0 ? _interactionType : 0;
        var _source;
        message.source = (_source = object.source) !== null && _source !== void 0 ? _source : 0;
        var _category;
        message.category = (_category = object.category) !== null && _category !== void 0 ? _category : "";
        return message;
    }
};
function chat_category_fromTimestamp(t) {
    var millis = (t.seconds || 0) * 1000;
    millis += (t.nanos || 0) / 1000000;
    return new Date(millis);
}
function chat_category_fromJsonTimestamp(o) {
    if ((0,_instanceof/* default */.Z)(o, Date)) {
        return o;
    } else if (typeof o === "string") {
        return new Date(o);
    } else {
        return chat_category_fromTimestamp(Timestamp.fromJSON(o));
    }
}
function chat_category_isSet(value) {
    return value !== null && value !== undefined;
}

;// CONCATENATED MODULE: ./src/__generated__/protobuf/customer/v1/data/comm_preferences.ts
/* eslint-disable */ 

var comm_preferences_protobufPackage = "od_protos.customer.v1.data";
var FeedType;
(function(FeedType) {
    FeedType[FeedType["FEED_TYPE_UNSPECIFIED"] = 0] = "FEED_TYPE_UNSPECIFIED";
    FeedType[FeedType["MARKETING"] = 1] = "MARKETING";
    FeedType[FeedType["TRANSACTIONAL"] = 2] = "TRANSACTIONAL";
    FeedType[FeedType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(FeedType || (FeedType = {}));
function feedTypeFromJSON(object) {
    switch(object){
        case 0:
        case "FEED_TYPE_UNSPECIFIED":
            return FeedType.FEED_TYPE_UNSPECIFIED;
        case 1:
        case "MARKETING":
            return FeedType.MARKETING;
        case 2:
        case "TRANSACTIONAL":
            return FeedType.TRANSACTIONAL;
        case -1:
        case "UNRECOGNIZED":
        default:
            return FeedType.UNRECOGNIZED;
    }
}
function feedTypeToJSON(object) {
    switch(object){
        case FeedType.FEED_TYPE_UNSPECIFIED:
            return "FEED_TYPE_UNSPECIFIED";
        case FeedType.MARKETING:
            return "MARKETING";
        case FeedType.TRANSACTIONAL:
            return "TRANSACTIONAL";
        case FeedType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var Medium;
(function(Medium) {
    Medium[Medium["MEDIUM_UNSPECIFIED"] = 0] = "MEDIUM_UNSPECIFIED";
    Medium[Medium["EMAIL"] = 1] = "EMAIL";
    Medium[Medium["SMS"] = 2] = "SMS";
    Medium[Medium["CALL"] = 3] = "CALL";
    Medium[Medium["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Medium || (Medium = {}));
function mediumFromJSON(object) {
    switch(object){
        case 0:
        case "MEDIUM_UNSPECIFIED":
            return Medium.MEDIUM_UNSPECIFIED;
        case 1:
        case "EMAIL":
            return Medium.EMAIL;
        case 2:
        case "SMS":
            return Medium.SMS;
        case 3:
        case "CALL":
            return Medium.CALL;
        case -1:
        case "UNRECOGNIZED":
        default:
            return Medium.UNRECOGNIZED;
    }
}
function mediumToJSON(object) {
    switch(object){
        case Medium.MEDIUM_UNSPECIFIED:
            return "MEDIUM_UNSPECIFIED";
        case Medium.EMAIL:
            return "EMAIL";
        case Medium.SMS:
            return "SMS";
        case Medium.CALL:
            return "CALL";
        case Medium.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var SubscriptionStatus;
(function(SubscriptionStatus) {
    SubscriptionStatus[SubscriptionStatus["SUBSCRIPTION_STATUS_UNSPECIFIED"] = 0] = "SUBSCRIPTION_STATUS_UNSPECIFIED";
    SubscriptionStatus[SubscriptionStatus["SUBSCRIBED"] = 1] = "SUBSCRIBED";
    SubscriptionStatus[SubscriptionStatus["UNSUBSCRIBED"] = 2] = "UNSUBSCRIBED";
    SubscriptionStatus[SubscriptionStatus[/** FORCE_UNSUBSCRIBED - This is when OD cannot resubscribe the customer (e.g. when the customer sends a STOP message) */ "FORCE_UNSUBSCRIBED"] = 3] = "FORCE_UNSUBSCRIBED";
    SubscriptionStatus[SubscriptionStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(SubscriptionStatus || (SubscriptionStatus = {}));
function subscriptionStatusFromJSON(object) {
    switch(object){
        case 0:
        case "SUBSCRIPTION_STATUS_UNSPECIFIED":
            return SubscriptionStatus.SUBSCRIPTION_STATUS_UNSPECIFIED;
        case 1:
        case "SUBSCRIBED":
            return SubscriptionStatus.SUBSCRIBED;
        case 2:
        case "UNSUBSCRIBED":
            return SubscriptionStatus.UNSUBSCRIBED;
        case 3:
        case "FORCE_UNSUBSCRIBED":
            return SubscriptionStatus.FORCE_UNSUBSCRIBED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return SubscriptionStatus.UNRECOGNIZED;
    }
}
function subscriptionStatusToJSON(object) {
    switch(object){
        case SubscriptionStatus.SUBSCRIPTION_STATUS_UNSPECIFIED:
            return "SUBSCRIPTION_STATUS_UNSPECIFIED";
        case SubscriptionStatus.SUBSCRIBED:
            return "SUBSCRIBED";
        case SubscriptionStatus.UNSUBSCRIBED:
            return "UNSUBSCRIBED";
        case SubscriptionStatus.FORCE_UNSUBSCRIBED:
            return "FORCE_UNSUBSCRIBED";
        case SubscriptionStatus.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var Actor;
(function(Actor) {
    Actor[Actor["ACTOR_TYPE_UNSPECIFIED"] = 0] = "ACTOR_TYPE_UNSPECIFIED";
    Actor[Actor["CUSTOMER"] = 1] = "CUSTOMER";
    Actor[Actor["OPERATOR"] = 2] = "OPERATOR";
    Actor[Actor["AUTOMATED"] = 3] = "AUTOMATED";
    Actor[Actor["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Actor || (Actor = {}));
function actorFromJSON(object) {
    switch(object){
        case 0:
        case "ACTOR_TYPE_UNSPECIFIED":
            return Actor.ACTOR_TYPE_UNSPECIFIED;
        case 1:
        case "CUSTOMER":
            return Actor.CUSTOMER;
        case 2:
        case "OPERATOR":
            return Actor.OPERATOR;
        case 3:
        case "AUTOMATED":
            return Actor.AUTOMATED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return Actor.UNRECOGNIZED;
    }
}
function actorToJSON(object) {
    switch(object){
        case Actor.ACTOR_TYPE_UNSPECIFIED:
            return "ACTOR_TYPE_UNSPECIFIED";
        case Actor.CUSTOMER:
            return "CUSTOMER";
        case Actor.OPERATOR:
            return "OPERATOR";
        case Actor.AUTOMATED:
            return "AUTOMATED";
        case Actor.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
function createBaseFeed() {
    return {
        name: "",
        description: "",
        type: 0
    };
}
var Feed = {
    fromJSON: function fromJSON(object) {
        return {
            name: comm_preferences_isSet(object.name) ? String(object.name) : "",
            description: comm_preferences_isSet(object.description) ? String(object.description) : "",
            type: comm_preferences_isSet(object.type) ? feedTypeFromJSON(object.type) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.name !== "") {
            obj.name = message.name;
        }
        if (message.description !== "") {
            obj.description = message.description;
        }
        if (message.type !== 0) {
            obj.type = feedTypeToJSON(message.type);
        }
        return obj;
    },
    create: function create(base) {
        return Feed.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseFeed();
        var _name;
        message.name = (_name = object.name) !== null && _name !== void 0 ? _name : "";
        var _description;
        message.description = (_description = object.description) !== null && _description !== void 0 ? _description : "";
        var _type;
        message.type = (_type = object.type) !== null && _type !== void 0 ? _type : 0;
        return message;
    }
};
function createBaseSubscription() {
    return {
        feed: undefined,
        medium: 0,
        status: 0
    };
}
var Subscription = {
    fromJSON: function fromJSON(object) {
        return {
            feed: comm_preferences_isSet(object.feed) ? Feed.fromJSON(object.feed) : undefined,
            medium: comm_preferences_isSet(object.medium) ? mediumFromJSON(object.medium) : 0,
            status: comm_preferences_isSet(object.status) ? subscriptionStatusFromJSON(object.status) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.feed !== undefined) {
            obj.feed = Feed.toJSON(message.feed);
        }
        if (message.medium !== 0) {
            obj.medium = mediumToJSON(message.medium);
        }
        if (message.status !== 0) {
            obj.status = subscriptionStatusToJSON(message.status);
        }
        return obj;
    },
    create: function create(base) {
        return Subscription.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseSubscription();
        message.feed = object.feed !== undefined && object.feed !== null ? Feed.fromPartial(object.feed) : undefined;
        var _medium;
        message.medium = (_medium = object.medium) !== null && _medium !== void 0 ? _medium : 0;
        var _status;
        message.status = (_status = object.status) !== null && _status !== void 0 ? _status : 0;
        return message;
    }
};
function createBaseCommPreference() {
    return {
        emailOptedOut: false,
        smsOptedOut: false,
        callOptedOut: false,
        subscriptions: [],
        emailOptedOutAt: undefined
    };
}
var CommPreference = {
    fromJSON: function fromJSON(object) {
        return {
            emailOptedOut: comm_preferences_isSet(object.emailOptedOut) ? Boolean(object.emailOptedOut) : false,
            smsOptedOut: comm_preferences_isSet(object.smsOptedOut) ? Boolean(object.smsOptedOut) : false,
            callOptedOut: comm_preferences_isSet(object.callOptedOut) ? Boolean(object.callOptedOut) : false,
            subscriptions: Array.isArray(object === null || object === void 0 ? void 0 : object.subscriptions) ? object.subscriptions.map(function(e) {
                return Subscription.fromJSON(e);
            }) : [],
            emailOptedOutAt: comm_preferences_isSet(object.emailOptedOutAt) ? comm_preferences_fromJsonTimestamp(object.emailOptedOutAt) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var ref;
        var obj = {};
        if (message.emailOptedOut === true) {
            obj.emailOptedOut = message.emailOptedOut;
        }
        if (message.smsOptedOut === true) {
            obj.smsOptedOut = message.smsOptedOut;
        }
        if (message.callOptedOut === true) {
            obj.callOptedOut = message.callOptedOut;
        }
        if ((ref = message.subscriptions) === null || ref === void 0 ? void 0 : ref.length) {
            obj.subscriptions = message.subscriptions.map(function(e) {
                return Subscription.toJSON(e);
            });
        }
        if (message.emailOptedOutAt !== undefined) {
            obj.emailOptedOutAt = message.emailOptedOutAt.toISOString();
        }
        return obj;
    },
    create: function create(base) {
        return CommPreference.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref;
        var message = createBaseCommPreference();
        var _emailOptedOut;
        message.emailOptedOut = (_emailOptedOut = object.emailOptedOut) !== null && _emailOptedOut !== void 0 ? _emailOptedOut : false;
        var _smsOptedOut;
        message.smsOptedOut = (_smsOptedOut = object.smsOptedOut) !== null && _smsOptedOut !== void 0 ? _smsOptedOut : false;
        var _callOptedOut;
        message.callOptedOut = (_callOptedOut = object.callOptedOut) !== null && _callOptedOut !== void 0 ? _callOptedOut : false;
        message.subscriptions = ((ref = object.subscriptions) === null || ref === void 0 ? void 0 : ref.map(function(e) {
            return Subscription.fromPartial(e);
        })) || [];
        var _emailOptedOutAt;
        message.emailOptedOutAt = (_emailOptedOutAt = object.emailOptedOutAt) !== null && _emailOptedOutAt !== void 0 ? _emailOptedOutAt : undefined;
        return message;
    }
};
function comm_preferences_fromTimestamp(t) {
    var millis = (t.seconds || 0) * 1000;
    millis += (t.nanos || 0) / 1000000;
    return new Date(millis);
}
function comm_preferences_fromJsonTimestamp(o) {
    if ((0,_instanceof/* default */.Z)(o, Date)) {
        return o;
    } else if (typeof o === "string") {
        return new Date(o);
    } else {
        return comm_preferences_fromTimestamp(Timestamp.fromJSON(o));
    }
}
function comm_preferences_isSet(value) {
    return value !== null && value !== undefined;
}

;// CONCATENATED MODULE: ./src/__generated__/protobuf/journey/data/categories/communication_category.ts
/* eslint-disable */ 

var communication_category_protobufPackage = "od_protos.journey.data.categories";
function createBaseCommunicationCategory() {
    return {
        event: undefined
    };
}
var CommunicationCategory = {
    fromJSON: function fromJSON(object) {
        return {
            event: communication_category_isSet(object.smsReceived) ? {
                $case: "smsReceived",
                smsReceived: CommunicationCategory_SmsReceivedEvent.fromJSON(object.smsReceived)
            } : communication_category_isSet(object.smsSent) ? {
                $case: "smsSent",
                smsSent: CommunicationCategory_SmsSentEvent.fromJSON(object.smsSent)
            } : communication_category_isSet(object.subscriptionUpdated) ? {
                $case: "subscriptionUpdated",
                subscriptionUpdated: CommunicationCategory_SubscriptionUpdatedEvent.fromJSON(object.subscriptionUpdated)
            } : undefined
        };
    },
    toJSON: function toJSON(message) {
        var ref, ref1, ref2;
        var obj = {};
        if (((ref = message.event) === null || ref === void 0 ? void 0 : ref.$case) === "smsReceived") {
            obj.smsReceived = CommunicationCategory_SmsReceivedEvent.toJSON(message.event.smsReceived);
        }
        if (((ref1 = message.event) === null || ref1 === void 0 ? void 0 : ref1.$case) === "smsSent") {
            obj.smsSent = CommunicationCategory_SmsSentEvent.toJSON(message.event.smsSent);
        }
        if (((ref2 = message.event) === null || ref2 === void 0 ? void 0 : ref2.$case) === "subscriptionUpdated") {
            obj.subscriptionUpdated = CommunicationCategory_SubscriptionUpdatedEvent.toJSON(message.event.subscriptionUpdated);
        }
        return obj;
    },
    create: function create(base) {
        return CommunicationCategory.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
        var message = createBaseCommunicationCategory();
        if (((ref = object.event) === null || ref === void 0 ? void 0 : ref.$case) === "smsReceived" && ((ref1 = object.event) === null || ref1 === void 0 ? void 0 : ref1.smsReceived) !== undefined && ((ref2 = object.event) === null || ref2 === void 0 ? void 0 : ref2.smsReceived) !== null) {
            message.event = {
                $case: "smsReceived",
                smsReceived: CommunicationCategory_SmsReceivedEvent.fromPartial(object.event.smsReceived)
            };
        }
        if (((ref3 = object.event) === null || ref3 === void 0 ? void 0 : ref3.$case) === "smsSent" && ((ref4 = object.event) === null || ref4 === void 0 ? void 0 : ref4.smsSent) !== undefined && ((ref5 = object.event) === null || ref5 === void 0 ? void 0 : ref5.smsSent) !== null) {
            message.event = {
                $case: "smsSent",
                smsSent: CommunicationCategory_SmsSentEvent.fromPartial(object.event.smsSent)
            };
        }
        if (((ref6 = object.event) === null || ref6 === void 0 ? void 0 : ref6.$case) === "subscriptionUpdated" && ((ref7 = object.event) === null || ref7 === void 0 ? void 0 : ref7.subscriptionUpdated) !== undefined && ((ref8 = object.event) === null || ref8 === void 0 ? void 0 : ref8.subscriptionUpdated) !== null) {
            message.event = {
                $case: "subscriptionUpdated",
                subscriptionUpdated: CommunicationCategory_SubscriptionUpdatedEvent.fromPartial(object.event.subscriptionUpdated)
            };
        }
        return message;
    }
};
function createBaseCommunicationCategory_SmsReceivedEvent() {
    return {
        fromPhoneNumber: "",
        toPhoneNumber: "",
        conversationId: "",
        messageSid: "",
        content: ""
    };
}
var CommunicationCategory_SmsReceivedEvent = {
    fromJSON: function fromJSON(object) {
        return {
            fromPhoneNumber: communication_category_isSet(object.fromPhoneNumber) ? String(object.fromPhoneNumber) : "",
            toPhoneNumber: communication_category_isSet(object.toPhoneNumber) ? String(object.toPhoneNumber) : "",
            conversationId: communication_category_isSet(object.conversationId) ? String(object.conversationId) : "",
            messageSid: communication_category_isSet(object.messageSid) ? String(object.messageSid) : "",
            content: communication_category_isSet(object.content) ? String(object.content) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.fromPhoneNumber !== "") {
            obj.fromPhoneNumber = message.fromPhoneNumber;
        }
        if (message.toPhoneNumber !== "") {
            obj.toPhoneNumber = message.toPhoneNumber;
        }
        if (message.conversationId !== "") {
            obj.conversationId = message.conversationId;
        }
        if (message.messageSid !== "") {
            obj.messageSid = message.messageSid;
        }
        if (message.content !== "") {
            obj.content = message.content;
        }
        return obj;
    },
    create: function create(base) {
        return CommunicationCategory_SmsReceivedEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseCommunicationCategory_SmsReceivedEvent();
        var _fromPhoneNumber;
        message.fromPhoneNumber = (_fromPhoneNumber = object.fromPhoneNumber) !== null && _fromPhoneNumber !== void 0 ? _fromPhoneNumber : "";
        var _toPhoneNumber;
        message.toPhoneNumber = (_toPhoneNumber = object.toPhoneNumber) !== null && _toPhoneNumber !== void 0 ? _toPhoneNumber : "";
        var _conversationId;
        message.conversationId = (_conversationId = object.conversationId) !== null && _conversationId !== void 0 ? _conversationId : "";
        var _messageSid;
        message.messageSid = (_messageSid = object.messageSid) !== null && _messageSid !== void 0 ? _messageSid : "";
        var _content;
        message.content = (_content = object.content) !== null && _content !== void 0 ? _content : "";
        return message;
    }
};
function createBaseCommunicationCategory_SmsSentEvent() {
    return {
        fromPhoneNumber: "",
        toPhoneNumber: "",
        conversationId: "",
        messageSid: "",
        phoneNumberCategory: "",
        content: ""
    };
}
var CommunicationCategory_SmsSentEvent = {
    fromJSON: function fromJSON(object) {
        return {
            fromPhoneNumber: communication_category_isSet(object.fromPhoneNumber) ? String(object.fromPhoneNumber) : "",
            toPhoneNumber: communication_category_isSet(object.toPhoneNumber) ? String(object.toPhoneNumber) : "",
            conversationId: communication_category_isSet(object.conversationId) ? String(object.conversationId) : "",
            messageSid: communication_category_isSet(object.messageSid) ? String(object.messageSid) : "",
            phoneNumberCategory: communication_category_isSet(object.phoneNumberCategory) ? String(object.phoneNumberCategory) : "",
            content: communication_category_isSet(object.content) ? String(object.content) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.fromPhoneNumber !== "") {
            obj.fromPhoneNumber = message.fromPhoneNumber;
        }
        if (message.toPhoneNumber !== "") {
            obj.toPhoneNumber = message.toPhoneNumber;
        }
        if (message.conversationId !== "") {
            obj.conversationId = message.conversationId;
        }
        if (message.messageSid !== "") {
            obj.messageSid = message.messageSid;
        }
        if (message.phoneNumberCategory !== "") {
            obj.phoneNumberCategory = message.phoneNumberCategory;
        }
        if (message.content !== "") {
            obj.content = message.content;
        }
        return obj;
    },
    create: function create(base) {
        return CommunicationCategory_SmsSentEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseCommunicationCategory_SmsSentEvent();
        var _fromPhoneNumber;
        message.fromPhoneNumber = (_fromPhoneNumber = object.fromPhoneNumber) !== null && _fromPhoneNumber !== void 0 ? _fromPhoneNumber : "";
        var _toPhoneNumber;
        message.toPhoneNumber = (_toPhoneNumber = object.toPhoneNumber) !== null && _toPhoneNumber !== void 0 ? _toPhoneNumber : "";
        var _conversationId;
        message.conversationId = (_conversationId = object.conversationId) !== null && _conversationId !== void 0 ? _conversationId : "";
        var _messageSid;
        message.messageSid = (_messageSid = object.messageSid) !== null && _messageSid !== void 0 ? _messageSid : "";
        var _phoneNumberCategory;
        message.phoneNumberCategory = (_phoneNumberCategory = object.phoneNumberCategory) !== null && _phoneNumberCategory !== void 0 ? _phoneNumberCategory : "";
        var _content;
        message.content = (_content = object.content) !== null && _content !== void 0 ? _content : "";
        return message;
    }
};
function createBaseCommunicationCategory_SubscriptionUpdatedEvent() {
    return {
        actor: 0,
        subscriptions: {}
    };
}
var CommunicationCategory_SubscriptionUpdatedEvent = {
    fromJSON: function fromJSON(object) {
        return {
            actor: communication_category_isSet(object.actor) ? actorFromJSON(object.actor) : 0,
            subscriptions: communication_category_isObject(object.subscriptions) ? Object.entries(object.subscriptions).reduce(function(acc, param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
                acc[key] = Boolean(value);
                return acc;
            }, {}) : {}
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.actor !== 0) {
            obj.actor = actorToJSON(message.actor);
        }
        if (message.subscriptions) {
            var entries = Object.entries(message.subscriptions);
            if (entries.length > 0) {
                obj.subscriptions = {};
                entries.forEach(function(param) {
                    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), k = _param[0], v = _param[1];
                    obj.subscriptions[k] = v;
                });
            }
        }
        return obj;
    },
    create: function create(base) {
        return CommunicationCategory_SubscriptionUpdatedEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseCommunicationCategory_SubscriptionUpdatedEvent();
        var _actor;
        message.actor = (_actor = object.actor) !== null && _actor !== void 0 ? _actor : 0;
        var _subscriptions;
        message.subscriptions = Object.entries((_subscriptions = object.subscriptions) !== null && _subscriptions !== void 0 ? _subscriptions : {}).reduce(function(acc, param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
            if (value !== undefined) {
                acc[key] = Boolean(value);
            }
            return acc;
        }, {});
        return message;
    }
};
function createBaseCommunicationCategory_SubscriptionUpdatedEvent_SubscriptionsEntry() {
    return {
        key: "",
        value: false
    };
}
var CommunicationCategory_SubscriptionUpdatedEvent_SubscriptionsEntry = {
    fromJSON: function fromJSON(object) {
        return {
            key: communication_category_isSet(object.key) ? String(object.key) : "",
            value: communication_category_isSet(object.value) ? Boolean(object.value) : false
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.key !== "") {
            obj.key = message.key;
        }
        if (message.value === true) {
            obj.value = message.value;
        }
        return obj;
    },
    create: function create(base) {
        return CommunicationCategory_SubscriptionUpdatedEvent_SubscriptionsEntry.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseCommunicationCategory_SubscriptionUpdatedEvent_SubscriptionsEntry();
        var _key;
        message.key = (_key = object.key) !== null && _key !== void 0 ? _key : "";
        var _value;
        message.value = (_value = object.value) !== null && _value !== void 0 ? _value : false;
        return message;
    }
};
function communication_category_isObject(value) {
    return typeof value === "object" && value !== null;
}
function communication_category_isSet(value) {
    return value !== null && value !== undefined;
}

;// CONCATENATED MODULE: ./src/__generated__/protobuf/journey/data/categories/experimentation_category.ts
/* eslint-disable */ var experimentation_category_protobufPackage = "od_protos.journey.data.categories";
function createBaseExperimentationCategory() {
    return {
        event: undefined
    };
}
var ExperimentationCategory = {
    fromJSON: function fromJSON(object) {
        return {
            event: experimentation_category_isSet(object.impression) ? {
                $case: "impression",
                impression: ExperimentationCategory_ImpressionEvent.fromJSON(object.impression)
            } : experimentation_category_isSet(object.assignment) ? {
                $case: "assignment",
                assignment: ExperimentationCategory_AssignmentEvent.fromJSON(object.assignment)
            } : experimentation_category_isSet(object.leadImpression) ? {
                $case: "leadImpression",
                leadImpression: ExperimentationCategory_LeadImpressionEvent.fromJSON(object.leadImpression)
            } : experimentation_category_isSet(object.leadAssignment) ? {
                $case: "leadAssignment",
                leadAssignment: ExperimentationCategory_LeadAssignmentEvent.fromJSON(object.leadAssignment)
            } : undefined
        };
    },
    toJSON: function toJSON(message) {
        var ref, ref1, ref2, ref3;
        var obj = {};
        if (((ref = message.event) === null || ref === void 0 ? void 0 : ref.$case) === "impression") {
            obj.impression = ExperimentationCategory_ImpressionEvent.toJSON(message.event.impression);
        }
        if (((ref1 = message.event) === null || ref1 === void 0 ? void 0 : ref1.$case) === "assignment") {
            obj.assignment = ExperimentationCategory_AssignmentEvent.toJSON(message.event.assignment);
        }
        if (((ref2 = message.event) === null || ref2 === void 0 ? void 0 : ref2.$case) === "leadImpression") {
            obj.leadImpression = ExperimentationCategory_LeadImpressionEvent.toJSON(message.event.leadImpression);
        }
        if (((ref3 = message.event) === null || ref3 === void 0 ? void 0 : ref3.$case) === "leadAssignment") {
            obj.leadAssignment = ExperimentationCategory_LeadAssignmentEvent.toJSON(message.event.leadAssignment);
        }
        return obj;
    },
    create: function create(base) {
        return ExperimentationCategory.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
        var message = createBaseExperimentationCategory();
        if (((ref = object.event) === null || ref === void 0 ? void 0 : ref.$case) === "impression" && ((ref1 = object.event) === null || ref1 === void 0 ? void 0 : ref1.impression) !== undefined && ((ref2 = object.event) === null || ref2 === void 0 ? void 0 : ref2.impression) !== null) {
            message.event = {
                $case: "impression",
                impression: ExperimentationCategory_ImpressionEvent.fromPartial(object.event.impression)
            };
        }
        if (((ref3 = object.event) === null || ref3 === void 0 ? void 0 : ref3.$case) === "assignment" && ((ref4 = object.event) === null || ref4 === void 0 ? void 0 : ref4.assignment) !== undefined && ((ref5 = object.event) === null || ref5 === void 0 ? void 0 : ref5.assignment) !== null) {
            message.event = {
                $case: "assignment",
                assignment: ExperimentationCategory_AssignmentEvent.fromPartial(object.event.assignment)
            };
        }
        if (((ref6 = object.event) === null || ref6 === void 0 ? void 0 : ref6.$case) === "leadImpression" && ((ref7 = object.event) === null || ref7 === void 0 ? void 0 : ref7.leadImpression) !== undefined && ((ref8 = object.event) === null || ref8 === void 0 ? void 0 : ref8.leadImpression) !== null) {
            message.event = {
                $case: "leadImpression",
                leadImpression: ExperimentationCategory_LeadImpressionEvent.fromPartial(object.event.leadImpression)
            };
        }
        if (((ref9 = object.event) === null || ref9 === void 0 ? void 0 : ref9.$case) === "leadAssignment" && ((ref10 = object.event) === null || ref10 === void 0 ? void 0 : ref10.leadAssignment) !== undefined && ((ref11 = object.event) === null || ref11 === void 0 ? void 0 : ref11.leadAssignment) !== null) {
            message.event = {
                $case: "leadAssignment",
                leadAssignment: ExperimentationCategory_LeadAssignmentEvent.fromPartial(object.event.leadAssignment)
            };
        }
        return message;
    }
};
function createBaseExperimentationCategory_ImpressionEvent() {
    return {
        experimentName: "",
        variant: undefined
    };
}
var ExperimentationCategory_ImpressionEvent = {
    fromJSON: function fromJSON(object) {
        return {
            experimentName: experimentation_category_isSet(object.experimentName) ? String(object.experimentName) : "",
            variant: experimentation_category_isSet(object.variant) ? String(object.variant) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.experimentName !== "") {
            obj.experimentName = message.experimentName;
        }
        if (message.variant !== undefined) {
            obj.variant = message.variant;
        }
        return obj;
    },
    create: function create(base) {
        return ExperimentationCategory_ImpressionEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseExperimentationCategory_ImpressionEvent();
        var _experimentName;
        message.experimentName = (_experimentName = object.experimentName) !== null && _experimentName !== void 0 ? _experimentName : "";
        var _variant;
        message.variant = (_variant = object.variant) !== null && _variant !== void 0 ? _variant : undefined;
        return message;
    }
};
function createBaseExperimentationCategory_AssignmentEvent() {
    return {
        experimentName: "",
        variant: undefined
    };
}
var ExperimentationCategory_AssignmentEvent = {
    fromJSON: function fromJSON(object) {
        return {
            experimentName: experimentation_category_isSet(object.experimentName) ? String(object.experimentName) : "",
            variant: experimentation_category_isSet(object.variant) ? String(object.variant) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.experimentName !== "") {
            obj.experimentName = message.experimentName;
        }
        if (message.variant !== undefined) {
            obj.variant = message.variant;
        }
        return obj;
    },
    create: function create(base) {
        return ExperimentationCategory_AssignmentEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseExperimentationCategory_AssignmentEvent();
        var _experimentName;
        message.experimentName = (_experimentName = object.experimentName) !== null && _experimentName !== void 0 ? _experimentName : "";
        var _variant;
        message.variant = (_variant = object.variant) !== null && _variant !== void 0 ? _variant : undefined;
        return message;
    }
};
function createBaseExperimentationCategory_LeadImpressionEvent() {
    return {
        experimentName: "",
        variant: undefined,
        sellerLeadUuid: ""
    };
}
var ExperimentationCategory_LeadImpressionEvent = {
    fromJSON: function fromJSON(object) {
        return {
            experimentName: experimentation_category_isSet(object.experimentName) ? String(object.experimentName) : "",
            variant: experimentation_category_isSet(object.variant) ? String(object.variant) : undefined,
            sellerLeadUuid: experimentation_category_isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.experimentName !== "") {
            obj.experimentName = message.experimentName;
        }
        if (message.variant !== undefined) {
            obj.variant = message.variant;
        }
        if (message.sellerLeadUuid !== "") {
            obj.sellerLeadUuid = message.sellerLeadUuid;
        }
        return obj;
    },
    create: function create(base) {
        return ExperimentationCategory_LeadImpressionEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseExperimentationCategory_LeadImpressionEvent();
        var _experimentName;
        message.experimentName = (_experimentName = object.experimentName) !== null && _experimentName !== void 0 ? _experimentName : "";
        var _variant;
        message.variant = (_variant = object.variant) !== null && _variant !== void 0 ? _variant : undefined;
        var _sellerLeadUuid;
        message.sellerLeadUuid = (_sellerLeadUuid = object.sellerLeadUuid) !== null && _sellerLeadUuid !== void 0 ? _sellerLeadUuid : "";
        return message;
    }
};
function createBaseExperimentationCategory_LeadAssignmentEvent() {
    return {
        experimentName: "",
        variant: undefined,
        sellerLeadUuid: ""
    };
}
var ExperimentationCategory_LeadAssignmentEvent = {
    fromJSON: function fromJSON(object) {
        return {
            experimentName: experimentation_category_isSet(object.experimentName) ? String(object.experimentName) : "",
            variant: experimentation_category_isSet(object.variant) ? String(object.variant) : undefined,
            sellerLeadUuid: experimentation_category_isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.experimentName !== "") {
            obj.experimentName = message.experimentName;
        }
        if (message.variant !== undefined) {
            obj.variant = message.variant;
        }
        if (message.sellerLeadUuid !== "") {
            obj.sellerLeadUuid = message.sellerLeadUuid;
        }
        return obj;
    },
    create: function create(base) {
        return ExperimentationCategory_LeadAssignmentEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseExperimentationCategory_LeadAssignmentEvent();
        var _experimentName;
        message.experimentName = (_experimentName = object.experimentName) !== null && _experimentName !== void 0 ? _experimentName : "";
        var _variant;
        message.variant = (_variant = object.variant) !== null && _variant !== void 0 ? _variant : undefined;
        var _sellerLeadUuid;
        message.sellerLeadUuid = (_sellerLeadUuid = object.sellerLeadUuid) !== null && _sellerLeadUuid !== void 0 ? _sellerLeadUuid : "";
        return message;
    }
};
function experimentation_category_isSet(value) {
    return value !== null && value !== undefined;
}

;// CONCATENATED MODULE: ./src/__generated__/protobuf/journey/data/categories/home_guide_category.ts
/* eslint-disable */ var home_guide_category_protobufPackage = "od_protos.journey.data.categories";
var HomeGuideCategory_ValuationEvent_ValuationSource;
(function(HomeGuideCategory_ValuationEvent_ValuationSource) {
    HomeGuideCategory_ValuationEvent_ValuationSource[HomeGuideCategory_ValuationEvent_ValuationSource["UNKNOWN_SOURCE"] = 0] = "UNKNOWN_SOURCE";
    HomeGuideCategory_ValuationEvent_ValuationSource[HomeGuideCategory_ValuationEvent_ValuationSource["VALUATION_API"] = 1] = "VALUATION_API";
    HomeGuideCategory_ValuationEvent_ValuationSource[HomeGuideCategory_ValuationEvent_ValuationSource["BALLPARK"] = 2] = "BALLPARK";
    HomeGuideCategory_ValuationEvent_ValuationSource[HomeGuideCategory_ValuationEvent_ValuationSource["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(HomeGuideCategory_ValuationEvent_ValuationSource || (HomeGuideCategory_ValuationEvent_ValuationSource = {}));
function homeGuideCategory_ValuationEvent_ValuationSourceFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN_SOURCE":
            return HomeGuideCategory_ValuationEvent_ValuationSource.UNKNOWN_SOURCE;
        case 1:
        case "VALUATION_API":
            return HomeGuideCategory_ValuationEvent_ValuationSource.VALUATION_API;
        case 2:
        case "BALLPARK":
            return HomeGuideCategory_ValuationEvent_ValuationSource.BALLPARK;
        case -1:
        case "UNRECOGNIZED":
        default:
            return HomeGuideCategory_ValuationEvent_ValuationSource.UNRECOGNIZED;
    }
}
function homeGuideCategory_ValuationEvent_ValuationSourceToJSON(object) {
    switch(object){
        case HomeGuideCategory_ValuationEvent_ValuationSource.UNKNOWN_SOURCE:
            return "UNKNOWN_SOURCE";
        case HomeGuideCategory_ValuationEvent_ValuationSource.VALUATION_API:
            return "VALUATION_API";
        case HomeGuideCategory_ValuationEvent_ValuationSource.BALLPARK:
            return "BALLPARK";
        case HomeGuideCategory_ValuationEvent_ValuationSource.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var HomeGuideCategory_QualificationEvent_QualificationDecision;
(function(HomeGuideCategory_QualificationEvent_QualificationDecision) {
    HomeGuideCategory_QualificationEvent_QualificationDecision[HomeGuideCategory_QualificationEvent_QualificationDecision["UNKNOWN"] = 0] = "UNKNOWN";
    HomeGuideCategory_QualificationEvent_QualificationDecision[HomeGuideCategory_QualificationEvent_QualificationDecision["PRODUCT_QUALIFIED"] = 1] = "PRODUCT_QUALIFIED";
    HomeGuideCategory_QualificationEvent_QualificationDecision[HomeGuideCategory_QualificationEvent_QualificationDecision["PRODUCT_DENIED"] = 2] = "PRODUCT_DENIED";
    HomeGuideCategory_QualificationEvent_QualificationDecision[HomeGuideCategory_QualificationEvent_QualificationDecision["PRODUCT_UNDENIED"] = 3] = "PRODUCT_UNDENIED";
    HomeGuideCategory_QualificationEvent_QualificationDecision[HomeGuideCategory_QualificationEvent_QualificationDecision["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(HomeGuideCategory_QualificationEvent_QualificationDecision || (HomeGuideCategory_QualificationEvent_QualificationDecision = {}));
function homeGuideCategory_QualificationEvent_QualificationDecisionFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN":
            return HomeGuideCategory_QualificationEvent_QualificationDecision.UNKNOWN;
        case 1:
        case "PRODUCT_QUALIFIED":
            return HomeGuideCategory_QualificationEvent_QualificationDecision.PRODUCT_QUALIFIED;
        case 2:
        case "PRODUCT_DENIED":
            return HomeGuideCategory_QualificationEvent_QualificationDecision.PRODUCT_DENIED;
        case 3:
        case "PRODUCT_UNDENIED":
            return HomeGuideCategory_QualificationEvent_QualificationDecision.PRODUCT_UNDENIED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return HomeGuideCategory_QualificationEvent_QualificationDecision.UNRECOGNIZED;
    }
}
function homeGuideCategory_QualificationEvent_QualificationDecisionToJSON(object) {
    switch(object){
        case HomeGuideCategory_QualificationEvent_QualificationDecision.UNKNOWN:
            return "UNKNOWN";
        case HomeGuideCategory_QualificationEvent_QualificationDecision.PRODUCT_QUALIFIED:
            return "PRODUCT_QUALIFIED";
        case HomeGuideCategory_QualificationEvent_QualificationDecision.PRODUCT_DENIED:
            return "PRODUCT_DENIED";
        case HomeGuideCategory_QualificationEvent_QualificationDecision.PRODUCT_UNDENIED:
            return "PRODUCT_UNDENIED";
        case HomeGuideCategory_QualificationEvent_QualificationDecision.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
function createBaseHomeGuideCategory() {
    return {
        event: undefined
    };
}
var HomeGuideCategory = {
    fromJSON: function fromJSON(object) {
        return {
            event: home_guide_category_isSet(object.valuation) ? {
                $case: "valuation",
                valuation: HomeGuideCategory_ValuationEvent.fromJSON(object.valuation)
            } : home_guide_category_isSet(object.qualification) ? {
                $case: "qualification",
                qualification: HomeGuideCategory_QualificationEvent.fromJSON(object.qualification)
            } : undefined
        };
    },
    toJSON: function toJSON(message) {
        var ref, ref1;
        var obj = {};
        if (((ref = message.event) === null || ref === void 0 ? void 0 : ref.$case) === "valuation") {
            obj.valuation = HomeGuideCategory_ValuationEvent.toJSON(message.event.valuation);
        }
        if (((ref1 = message.event) === null || ref1 === void 0 ? void 0 : ref1.$case) === "qualification") {
            obj.qualification = HomeGuideCategory_QualificationEvent.toJSON(message.event.qualification);
        }
        return obj;
    },
    create: function create(base) {
        return HomeGuideCategory.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref, ref1, ref2, ref3, ref4, ref5;
        var message = createBaseHomeGuideCategory();
        if (((ref = object.event) === null || ref === void 0 ? void 0 : ref.$case) === "valuation" && ((ref1 = object.event) === null || ref1 === void 0 ? void 0 : ref1.valuation) !== undefined && ((ref2 = object.event) === null || ref2 === void 0 ? void 0 : ref2.valuation) !== null) {
            message.event = {
                $case: "valuation",
                valuation: HomeGuideCategory_ValuationEvent.fromPartial(object.event.valuation)
            };
        }
        if (((ref3 = object.event) === null || ref3 === void 0 ? void 0 : ref3.$case) === "qualification" && ((ref4 = object.event) === null || ref4 === void 0 ? void 0 : ref4.qualification) !== undefined && ((ref5 = object.event) === null || ref5 === void 0 ? void 0 : ref5.qualification) !== null) {
            message.event = {
                $case: "qualification",
                qualification: HomeGuideCategory_QualificationEvent.fromPartial(object.event.qualification)
            };
        }
        return message;
    }
};
function createBaseHomeGuideCategory_ValuationEvent() {
    return {
        addressToken: "",
        sellerInputUuid: undefined,
        source: 0,
        valuationCents: 0,
        compsAddressUuids: []
    };
}
var HomeGuideCategory_ValuationEvent = {
    fromJSON: function fromJSON(object) {
        return {
            addressToken: home_guide_category_isSet(object.addressToken) ? String(object.addressToken) : "",
            sellerInputUuid: home_guide_category_isSet(object.sellerInputUuid) ? String(object.sellerInputUuid) : undefined,
            source: home_guide_category_isSet(object.source) ? homeGuideCategory_ValuationEvent_ValuationSourceFromJSON(object.source) : 0,
            valuationCents: home_guide_category_isSet(object.valuationCents) ? Number(object.valuationCents) : 0,
            compsAddressUuids: Array.isArray(object === null || object === void 0 ? void 0 : object.compsAddressUuids) ? object.compsAddressUuids.map(function(e) {
                return String(e);
            }) : []
        };
    },
    toJSON: function toJSON(message) {
        var ref;
        var obj = {};
        if (message.addressToken !== "") {
            obj.addressToken = message.addressToken;
        }
        if (message.sellerInputUuid !== undefined) {
            obj.sellerInputUuid = message.sellerInputUuid;
        }
        if (message.source !== 0) {
            obj.source = homeGuideCategory_ValuationEvent_ValuationSourceToJSON(message.source);
        }
        if (message.valuationCents !== 0) {
            obj.valuationCents = Math.round(message.valuationCents);
        }
        if ((ref = message.compsAddressUuids) === null || ref === void 0 ? void 0 : ref.length) {
            obj.compsAddressUuids = message.compsAddressUuids;
        }
        return obj;
    },
    create: function create(base) {
        return HomeGuideCategory_ValuationEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref;
        var message = createBaseHomeGuideCategory_ValuationEvent();
        var _addressToken;
        message.addressToken = (_addressToken = object.addressToken) !== null && _addressToken !== void 0 ? _addressToken : "";
        var _sellerInputUuid;
        message.sellerInputUuid = (_sellerInputUuid = object.sellerInputUuid) !== null && _sellerInputUuid !== void 0 ? _sellerInputUuid : undefined;
        var _source;
        message.source = (_source = object.source) !== null && _source !== void 0 ? _source : 0;
        var _valuationCents;
        message.valuationCents = (_valuationCents = object.valuationCents) !== null && _valuationCents !== void 0 ? _valuationCents : 0;
        message.compsAddressUuids = ((ref = object.compsAddressUuids) === null || ref === void 0 ? void 0 : ref.map(function(e) {
            return e;
        })) || [];
        return message;
    }
};
function createBaseHomeGuideCategory_QualificationEvent() {
    return {
        sellerInputId: "",
        qualificationDecision: 0
    };
}
var HomeGuideCategory_QualificationEvent = {
    fromJSON: function fromJSON(object) {
        return {
            sellerInputId: home_guide_category_isSet(object.sellerInputId) ? String(object.sellerInputId) : "",
            qualificationDecision: home_guide_category_isSet(object.qualificationDecision) ? homeGuideCategory_QualificationEvent_QualificationDecisionFromJSON(object.qualificationDecision) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.sellerInputId !== "") {
            obj.sellerInputId = message.sellerInputId;
        }
        if (message.qualificationDecision !== 0) {
            obj.qualificationDecision = homeGuideCategory_QualificationEvent_QualificationDecisionToJSON(message.qualificationDecision);
        }
        return obj;
    },
    create: function create(base) {
        return HomeGuideCategory_QualificationEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseHomeGuideCategory_QualificationEvent();
        var _sellerInputId;
        message.sellerInputId = (_sellerInputId = object.sellerInputId) !== null && _sellerInputId !== void 0 ? _sellerInputId : "";
        var _qualificationDecision;
        message.qualificationDecision = (_qualificationDecision = object.qualificationDecision) !== null && _qualificationDecision !== void 0 ? _qualificationDecision : 0;
        return message;
    }
};
function home_guide_category_isSet(value) {
    return value !== null && value !== undefined;
}

;// CONCATENATED MODULE: ./src/__generated__/protobuf/journey/data/categories/language_category.ts
/* eslint-disable */ var language_category_protobufPackage = "od_protos.journey.data.categories";
var LanguageCategory_Language;
(function(LanguageCategory_Language) {
    LanguageCategory_Language[LanguageCategory_Language["LANGUAGE_UNSPECIFIED"] = 0] = "LANGUAGE_UNSPECIFIED";
    LanguageCategory_Language[LanguageCategory_Language["ENGLISH"] = 1] = "ENGLISH";
    LanguageCategory_Language[LanguageCategory_Language["SPANISH"] = 2] = "SPANISH";
    LanguageCategory_Language[LanguageCategory_Language["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(LanguageCategory_Language || (LanguageCategory_Language = {}));
function languageCategory_LanguageFromJSON(object) {
    switch(object){
        case 0:
        case "LANGUAGE_UNSPECIFIED":
            return LanguageCategory_Language.LANGUAGE_UNSPECIFIED;
        case 1:
        case "ENGLISH":
            return LanguageCategory_Language.ENGLISH;
        case 2:
        case "SPANISH":
            return LanguageCategory_Language.SPANISH;
        case -1:
        case "UNRECOGNIZED":
        default:
            return LanguageCategory_Language.UNRECOGNIZED;
    }
}
function languageCategory_LanguageToJSON(object) {
    switch(object){
        case LanguageCategory_Language.LANGUAGE_UNSPECIFIED:
            return "LANGUAGE_UNSPECIFIED";
        case LanguageCategory_Language.ENGLISH:
            return "ENGLISH";
        case LanguageCategory_Language.SPANISH:
            return "SPANISH";
        case LanguageCategory_Language.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
function createBaseLanguageCategory() {
    return {
        event: undefined
    };
}
var LanguageCategory = {
    fromJSON: function fromJSON(object) {
        return {
            event: language_category_isSet(object.selectEvent) ? {
                $case: "selectEvent",
                selectEvent: LanguageCategory_SelectEvent.fromJSON(object.selectEvent)
            } : undefined
        };
    },
    toJSON: function toJSON(message) {
        var ref;
        var obj = {};
        if (((ref = message.event) === null || ref === void 0 ? void 0 : ref.$case) === "selectEvent") {
            obj.selectEvent = LanguageCategory_SelectEvent.toJSON(message.event.selectEvent);
        }
        return obj;
    },
    create: function create(base) {
        return LanguageCategory.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref, ref1, ref2;
        var message = createBaseLanguageCategory();
        if (((ref = object.event) === null || ref === void 0 ? void 0 : ref.$case) === "selectEvent" && ((ref1 = object.event) === null || ref1 === void 0 ? void 0 : ref1.selectEvent) !== undefined && ((ref2 = object.event) === null || ref2 === void 0 ? void 0 : ref2.selectEvent) !== null) {
            message.event = {
                $case: "selectEvent",
                selectEvent: LanguageCategory_SelectEvent.fromPartial(object.event.selectEvent)
            };
        }
        return message;
    }
};
function createBaseLanguageCategory_SelectEvent() {
    return {
        language: 0
    };
}
var LanguageCategory_SelectEvent = {
    fromJSON: function fromJSON(object) {
        return {
            language: language_category_isSet(object.language) ? languageCategory_LanguageFromJSON(object.language) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.language !== 0) {
            obj.language = languageCategory_LanguageToJSON(message.language);
        }
        return obj;
    },
    create: function create(base) {
        return LanguageCategory_SelectEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseLanguageCategory_SelectEvent();
        var _language;
        message.language = (_language = object.language) !== null && _language !== void 0 ? _language : 0;
        return message;
    }
};
function language_category_isSet(value) {
    return value !== null && value !== undefined;
}

// EXTERNAL MODULE: ./src/__generated__/protobuf/journey/data/categories/marketplace_property_category.ts
var marketplace_property_category = __webpack_require__(46329);
;// CONCATENATED MODULE: ./src/__generated__/protobuf/journey/data/categories/mortgage_category.ts
/* eslint-disable */ var mortgage_category_protobufPackage = "od_protos.journey.data.categories";
var MortgageCategory_StepKey;
(function(MortgageCategory_StepKey) {
    MortgageCategory_StepKey[MortgageCategory_StepKey["UNKNOWN_STEP"] = 0] = "UNKNOWN_STEP";
    MortgageCategory_StepKey[MortgageCategory_StepKey["VERIFICATION"] = 1] = "VERIFICATION";
    MortgageCategory_StepKey[MortgageCategory_StepKey["ABOUT_YOU"] = 2] = "ABOUT_YOU";
    MortgageCategory_StepKey[MortgageCategory_StepKey["REAL_ESTATE"] = 3] = "REAL_ESTATE";
    MortgageCategory_StepKey[MortgageCategory_StepKey["EMPLOYMENT_INCOME"] = 4] = "EMPLOYMENT_INCOME";
    MortgageCategory_StepKey[MortgageCategory_StepKey["ASSETS"] = 5] = "ASSETS";
    MortgageCategory_StepKey[MortgageCategory_StepKey["DECLARATIONS"] = 6] = "DECLARATIONS";
    MortgageCategory_StepKey[MortgageCategory_StepKey["REVIEW_SUBMIT"] = 7] = "REVIEW_SUBMIT";
    MortgageCategory_StepKey[MortgageCategory_StepKey["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(MortgageCategory_StepKey || (MortgageCategory_StepKey = {}));
function mortgageCategory_StepKeyFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN_STEP":
            return MortgageCategory_StepKey.UNKNOWN_STEP;
        case 1:
        case "VERIFICATION":
            return MortgageCategory_StepKey.VERIFICATION;
        case 2:
        case "ABOUT_YOU":
            return MortgageCategory_StepKey.ABOUT_YOU;
        case 3:
        case "REAL_ESTATE":
            return MortgageCategory_StepKey.REAL_ESTATE;
        case 4:
        case "EMPLOYMENT_INCOME":
            return MortgageCategory_StepKey.EMPLOYMENT_INCOME;
        case 5:
        case "ASSETS":
            return MortgageCategory_StepKey.ASSETS;
        case 6:
        case "DECLARATIONS":
            return MortgageCategory_StepKey.DECLARATIONS;
        case 7:
        case "REVIEW_SUBMIT":
            return MortgageCategory_StepKey.REVIEW_SUBMIT;
        case -1:
        case "UNRECOGNIZED":
        default:
            return MortgageCategory_StepKey.UNRECOGNIZED;
    }
}
function mortgageCategory_StepKeyToJSON(object) {
    switch(object){
        case MortgageCategory_StepKey.UNKNOWN_STEP:
            return "UNKNOWN_STEP";
        case MortgageCategory_StepKey.VERIFICATION:
            return "VERIFICATION";
        case MortgageCategory_StepKey.ABOUT_YOU:
            return "ABOUT_YOU";
        case MortgageCategory_StepKey.REAL_ESTATE:
            return "REAL_ESTATE";
        case MortgageCategory_StepKey.EMPLOYMENT_INCOME:
            return "EMPLOYMENT_INCOME";
        case MortgageCategory_StepKey.ASSETS:
            return "ASSETS";
        case MortgageCategory_StepKey.DECLARATIONS:
            return "DECLARATIONS";
        case MortgageCategory_StepKey.REVIEW_SUBMIT:
            return "REVIEW_SUBMIT";
        case MortgageCategory_StepKey.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var MortgageCategory_EntrySource;
(function(MortgageCategory_EntrySource) {
    MortgageCategory_EntrySource[MortgageCategory_EntrySource["UNKNOWN_ENTRY_SOURCE"] = 0] = "UNKNOWN_ENTRY_SOURCE";
    MortgageCategory_EntrySource[MortgageCategory_EntrySource["DIRECT"] = 1] = "DIRECT";
    MortgageCategory_EntrySource[MortgageCategory_EntrySource["MARKETING"] = 2] = "MARKETING";
    MortgageCategory_EntrySource[MortgageCategory_EntrySource["PARTNER"] = 3] = "PARTNER";
    MortgageCategory_EntrySource[MortgageCategory_EntrySource["REFERRAL"] = 4] = "REFERRAL";
    MortgageCategory_EntrySource[MortgageCategory_EntrySource["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(MortgageCategory_EntrySource || (MortgageCategory_EntrySource = {}));
function mortgageCategory_EntrySourceFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN_ENTRY_SOURCE":
            return MortgageCategory_EntrySource.UNKNOWN_ENTRY_SOURCE;
        case 1:
        case "DIRECT":
            return MortgageCategory_EntrySource.DIRECT;
        case 2:
        case "MARKETING":
            return MortgageCategory_EntrySource.MARKETING;
        case 3:
        case "PARTNER":
            return MortgageCategory_EntrySource.PARTNER;
        case 4:
        case "REFERRAL":
            return MortgageCategory_EntrySource.REFERRAL;
        case -1:
        case "UNRECOGNIZED":
        default:
            return MortgageCategory_EntrySource.UNRECOGNIZED;
    }
}
function mortgageCategory_EntrySourceToJSON(object) {
    switch(object){
        case MortgageCategory_EntrySource.UNKNOWN_ENTRY_SOURCE:
            return "UNKNOWN_ENTRY_SOURCE";
        case MortgageCategory_EntrySource.DIRECT:
            return "DIRECT";
        case MortgageCategory_EntrySource.MARKETING:
            return "MARKETING";
        case MortgageCategory_EntrySource.PARTNER:
            return "PARTNER";
        case MortgageCategory_EntrySource.REFERRAL:
            return "REFERRAL";
        case MortgageCategory_EntrySource.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var MortgageCategory_IntegrationType;
(function(MortgageCategory_IntegrationType) {
    MortgageCategory_IntegrationType[MortgageCategory_IntegrationType["UNKNOWN_INTEGRATION"] = 0] = "UNKNOWN_INTEGRATION";
    MortgageCategory_IntegrationType[MortgageCategory_IntegrationType["PLAID_LINK"] = 1] = "PLAID_LINK";
    MortgageCategory_IntegrationType[MortgageCategory_IntegrationType["TRUV"] = 2] = "TRUV";
    MortgageCategory_IntegrationType[MortgageCategory_IntegrationType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(MortgageCategory_IntegrationType || (MortgageCategory_IntegrationType = {}));
function mortgageCategory_IntegrationTypeFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN_INTEGRATION":
            return MortgageCategory_IntegrationType.UNKNOWN_INTEGRATION;
        case 1:
        case "PLAID_LINK":
            return MortgageCategory_IntegrationType.PLAID_LINK;
        case 2:
        case "TRUV":
            return MortgageCategory_IntegrationType.TRUV;
        case -1:
        case "UNRECOGNIZED":
        default:
            return MortgageCategory_IntegrationType.UNRECOGNIZED;
    }
}
function mortgageCategory_IntegrationTypeToJSON(object) {
    switch(object){
        case MortgageCategory_IntegrationType.UNKNOWN_INTEGRATION:
            return "UNKNOWN_INTEGRATION";
        case MortgageCategory_IntegrationType.PLAID_LINK:
            return "PLAID_LINK";
        case MortgageCategory_IntegrationType.TRUV:
            return "TRUV";
        case MortgageCategory_IntegrationType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var MortgageCategory_IntegrationResult;
(function(MortgageCategory_IntegrationResult) {
    MortgageCategory_IntegrationResult[MortgageCategory_IntegrationResult["UNKNOWN_RESULT"] = 0] = "UNKNOWN_RESULT";
    MortgageCategory_IntegrationResult[MortgageCategory_IntegrationResult["SUCCESS"] = 1] = "SUCCESS";
    MortgageCategory_IntegrationResult[MortgageCategory_IntegrationResult["FAILED"] = 2] = "FAILED";
    MortgageCategory_IntegrationResult[MortgageCategory_IntegrationResult["CANCELLED"] = 3] = "CANCELLED";
    MortgageCategory_IntegrationResult[MortgageCategory_IntegrationResult["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(MortgageCategory_IntegrationResult || (MortgageCategory_IntegrationResult = {}));
function mortgageCategory_IntegrationResultFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN_RESULT":
            return MortgageCategory_IntegrationResult.UNKNOWN_RESULT;
        case 1:
        case "SUCCESS":
            return MortgageCategory_IntegrationResult.SUCCESS;
        case 2:
        case "FAILED":
            return MortgageCategory_IntegrationResult.FAILED;
        case 3:
        case "CANCELLED":
            return MortgageCategory_IntegrationResult.CANCELLED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return MortgageCategory_IntegrationResult.UNRECOGNIZED;
    }
}
function mortgageCategory_IntegrationResultToJSON(object) {
    switch(object){
        case MortgageCategory_IntegrationResult.UNKNOWN_RESULT:
            return "UNKNOWN_RESULT";
        case MortgageCategory_IntegrationResult.SUCCESS:
            return "SUCCESS";
        case MortgageCategory_IntegrationResult.FAILED:
            return "FAILED";
        case MortgageCategory_IntegrationResult.CANCELLED:
            return "CANCELLED";
        case MortgageCategory_IntegrationResult.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var MortgageCategory_FailureReason;
(function(MortgageCategory_FailureReason) {
    MortgageCategory_FailureReason[MortgageCategory_FailureReason["UNKNOWN_FAILURE"] = 0] = "UNKNOWN_FAILURE";
    MortgageCategory_FailureReason[MortgageCategory_FailureReason["USER_CANCELLED"] = 1] = "USER_CANCELLED";
    MortgageCategory_FailureReason[MortgageCategory_FailureReason["VERIFICATION_FAILED"] = 2] = "VERIFICATION_FAILED";
    MortgageCategory_FailureReason[MortgageCategory_FailureReason["TIMEOUT"] = 3] = "TIMEOUT";
    MortgageCategory_FailureReason[MortgageCategory_FailureReason["ERROR"] = 4] = "ERROR";
    MortgageCategory_FailureReason[MortgageCategory_FailureReason["INSTITUTION_ERROR"] = 5] = "INSTITUTION_ERROR";
    MortgageCategory_FailureReason[MortgageCategory_FailureReason["EMPLOYER_NOT_FOUND"] = 6] = "EMPLOYER_NOT_FOUND";
    MortgageCategory_FailureReason[MortgageCategory_FailureReason["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(MortgageCategory_FailureReason || (MortgageCategory_FailureReason = {}));
function mortgageCategory_FailureReasonFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN_FAILURE":
            return MortgageCategory_FailureReason.UNKNOWN_FAILURE;
        case 1:
        case "USER_CANCELLED":
            return MortgageCategory_FailureReason.USER_CANCELLED;
        case 2:
        case "VERIFICATION_FAILED":
            return MortgageCategory_FailureReason.VERIFICATION_FAILED;
        case 3:
        case "TIMEOUT":
            return MortgageCategory_FailureReason.TIMEOUT;
        case 4:
        case "ERROR":
            return MortgageCategory_FailureReason.ERROR;
        case 5:
        case "INSTITUTION_ERROR":
            return MortgageCategory_FailureReason.INSTITUTION_ERROR;
        case 6:
        case "EMPLOYER_NOT_FOUND":
            return MortgageCategory_FailureReason.EMPLOYER_NOT_FOUND;
        case -1:
        case "UNRECOGNIZED":
        default:
            return MortgageCategory_FailureReason.UNRECOGNIZED;
    }
}
function mortgageCategory_FailureReasonToJSON(object) {
    switch(object){
        case MortgageCategory_FailureReason.UNKNOWN_FAILURE:
            return "UNKNOWN_FAILURE";
        case MortgageCategory_FailureReason.USER_CANCELLED:
            return "USER_CANCELLED";
        case MortgageCategory_FailureReason.VERIFICATION_FAILED:
            return "VERIFICATION_FAILED";
        case MortgageCategory_FailureReason.TIMEOUT:
            return "TIMEOUT";
        case MortgageCategory_FailureReason.ERROR:
            return "ERROR";
        case MortgageCategory_FailureReason.INSTITUTION_ERROR:
            return "INSTITUTION_ERROR";
        case MortgageCategory_FailureReason.EMPLOYER_NOT_FOUND:
            return "EMPLOYER_NOT_FOUND";
        case MortgageCategory_FailureReason.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var MortgageCategory_ValidationErrorType;
(function(MortgageCategory_ValidationErrorType) {
    MortgageCategory_ValidationErrorType[MortgageCategory_ValidationErrorType["UNKNOWN_ERROR_TYPE"] = 0] = "UNKNOWN_ERROR_TYPE";
    MortgageCategory_ValidationErrorType[MortgageCategory_ValidationErrorType["REQUIRED"] = 1] = "REQUIRED";
    MortgageCategory_ValidationErrorType[MortgageCategory_ValidationErrorType["FORMAT"] = 2] = "FORMAT";
    MortgageCategory_ValidationErrorType[MortgageCategory_ValidationErrorType["RANGE"] = 3] = "RANGE";
    MortgageCategory_ValidationErrorType[MortgageCategory_ValidationErrorType["CUSTOM"] = 4] = "CUSTOM";
    MortgageCategory_ValidationErrorType[MortgageCategory_ValidationErrorType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(MortgageCategory_ValidationErrorType || (MortgageCategory_ValidationErrorType = {}));
function mortgageCategory_ValidationErrorTypeFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN_ERROR_TYPE":
            return MortgageCategory_ValidationErrorType.UNKNOWN_ERROR_TYPE;
        case 1:
        case "REQUIRED":
            return MortgageCategory_ValidationErrorType.REQUIRED;
        case 2:
        case "FORMAT":
            return MortgageCategory_ValidationErrorType.FORMAT;
        case 3:
        case "RANGE":
            return MortgageCategory_ValidationErrorType.RANGE;
        case 4:
        case "CUSTOM":
            return MortgageCategory_ValidationErrorType.CUSTOM;
        case -1:
        case "UNRECOGNIZED":
        default:
            return MortgageCategory_ValidationErrorType.UNRECOGNIZED;
    }
}
function mortgageCategory_ValidationErrorTypeToJSON(object) {
    switch(object){
        case MortgageCategory_ValidationErrorType.UNKNOWN_ERROR_TYPE:
            return "UNKNOWN_ERROR_TYPE";
        case MortgageCategory_ValidationErrorType.REQUIRED:
            return "REQUIRED";
        case MortgageCategory_ValidationErrorType.FORMAT:
            return "FORMAT";
        case MortgageCategory_ValidationErrorType.RANGE:
            return "RANGE";
        case MortgageCategory_ValidationErrorType.CUSTOM:
            return "CUSTOM";
        case MortgageCategory_ValidationErrorType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var MortgageCategory_DecisionType;
(function(MortgageCategory_DecisionType) {
    MortgageCategory_DecisionType[MortgageCategory_DecisionType["UNKNOWN_DECISION"] = 0] = "UNKNOWN_DECISION";
    MortgageCategory_DecisionType[MortgageCategory_DecisionType["APPROVED"] = 1] = "APPROVED";
    MortgageCategory_DecisionType[MortgageCategory_DecisionType["REJECTED"] = 2] = "REJECTED";
    MortgageCategory_DecisionType[MortgageCategory_DecisionType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(MortgageCategory_DecisionType || (MortgageCategory_DecisionType = {}));
function mortgageCategory_DecisionTypeFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN_DECISION":
            return MortgageCategory_DecisionType.UNKNOWN_DECISION;
        case 1:
        case "APPROVED":
            return MortgageCategory_DecisionType.APPROVED;
        case 2:
        case "REJECTED":
            return MortgageCategory_DecisionType.REJECTED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return MortgageCategory_DecisionType.UNRECOGNIZED;
    }
}
function mortgageCategory_DecisionTypeToJSON(object) {
    switch(object){
        case MortgageCategory_DecisionType.UNKNOWN_DECISION:
            return "UNKNOWN_DECISION";
        case MortgageCategory_DecisionType.APPROVED:
            return "APPROVED";
        case MortgageCategory_DecisionType.REJECTED:
            return "REJECTED";
        case MortgageCategory_DecisionType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var MortgageCategory_PrequalStepKey;
(function(MortgageCategory_PrequalStepKey) {
    MortgageCategory_PrequalStepKey[MortgageCategory_PrequalStepKey["PREQUAL_UNKNOWN_STEP"] = 0] = "PREQUAL_UNKNOWN_STEP";
    MortgageCategory_PrequalStepKey[MortgageCategory_PrequalStepKey["PREQUAL_LOCATION"] = 1] = "PREQUAL_LOCATION";
    MortgageCategory_PrequalStepKey[MortgageCategory_PrequalStepKey["PREQUAL_PURCHASE_PRICE"] = 2] = "PREQUAL_PURCHASE_PRICE";
    MortgageCategory_PrequalStepKey[MortgageCategory_PrequalStepKey["PREQUAL_DOWN_PAYMENT"] = 3] = "PREQUAL_DOWN_PAYMENT";
    MortgageCategory_PrequalStepKey[MortgageCategory_PrequalStepKey["PREQUAL_ANNUAL_INCOME"] = 4] = "PREQUAL_ANNUAL_INCOME";
    MortgageCategory_PrequalStepKey[MortgageCategory_PrequalStepKey["PREQUAL_MONTHLY_DEBT"] = 5] = "PREQUAL_MONTHLY_DEBT";
    MortgageCategory_PrequalStepKey[MortgageCategory_PrequalStepKey["PREQUAL_CREDIT_SCORE"] = 6] = "PREQUAL_CREDIT_SCORE";
    MortgageCategory_PrequalStepKey[MortgageCategory_PrequalStepKey["PREQUAL_PHONE_NUMBER"] = 7] = "PREQUAL_PHONE_NUMBER";
    MortgageCategory_PrequalStepKey[MortgageCategory_PrequalStepKey["PREQUAL_HOME_USAGE"] = 8] = "PREQUAL_HOME_USAGE";
    MortgageCategory_PrequalStepKey[MortgageCategory_PrequalStepKey["PREQUAL_PURCHASE_TIMELINE"] = 9] = "PREQUAL_PURCHASE_TIMELINE";
    MortgageCategory_PrequalStepKey[MortgageCategory_PrequalStepKey["PREQUAL_EMPLOYMENT_STATUS"] = 10] = "PREQUAL_EMPLOYMENT_STATUS";
    MortgageCategory_PrequalStepKey[MortgageCategory_PrequalStepKey["PREQUAL_CURRENT_ADDRESS"] = 11] = "PREQUAL_CURRENT_ADDRESS";
    MortgageCategory_PrequalStepKey[MortgageCategory_PrequalStepKey["PREQUAL_CO_BORROWER"] = 12] = "PREQUAL_CO_BORROWER";
    MortgageCategory_PrequalStepKey[MortgageCategory_PrequalStepKey["PREQUAL_CLOSING_DATE"] = 13] = "PREQUAL_CLOSING_DATE";
    MortgageCategory_PrequalStepKey[MortgageCategory_PrequalStepKey["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(MortgageCategory_PrequalStepKey || (MortgageCategory_PrequalStepKey = {}));
function mortgageCategory_PrequalStepKeyFromJSON(object) {
    switch(object){
        case 0:
        case "PREQUAL_UNKNOWN_STEP":
            return MortgageCategory_PrequalStepKey.PREQUAL_UNKNOWN_STEP;
        case 1:
        case "PREQUAL_LOCATION":
            return MortgageCategory_PrequalStepKey.PREQUAL_LOCATION;
        case 2:
        case "PREQUAL_PURCHASE_PRICE":
            return MortgageCategory_PrequalStepKey.PREQUAL_PURCHASE_PRICE;
        case 3:
        case "PREQUAL_DOWN_PAYMENT":
            return MortgageCategory_PrequalStepKey.PREQUAL_DOWN_PAYMENT;
        case 4:
        case "PREQUAL_ANNUAL_INCOME":
            return MortgageCategory_PrequalStepKey.PREQUAL_ANNUAL_INCOME;
        case 5:
        case "PREQUAL_MONTHLY_DEBT":
            return MortgageCategory_PrequalStepKey.PREQUAL_MONTHLY_DEBT;
        case 6:
        case "PREQUAL_CREDIT_SCORE":
            return MortgageCategory_PrequalStepKey.PREQUAL_CREDIT_SCORE;
        case 7:
        case "PREQUAL_PHONE_NUMBER":
            return MortgageCategory_PrequalStepKey.PREQUAL_PHONE_NUMBER;
        case 8:
        case "PREQUAL_HOME_USAGE":
            return MortgageCategory_PrequalStepKey.PREQUAL_HOME_USAGE;
        case 9:
        case "PREQUAL_PURCHASE_TIMELINE":
            return MortgageCategory_PrequalStepKey.PREQUAL_PURCHASE_TIMELINE;
        case 10:
        case "PREQUAL_EMPLOYMENT_STATUS":
            return MortgageCategory_PrequalStepKey.PREQUAL_EMPLOYMENT_STATUS;
        case 11:
        case "PREQUAL_CURRENT_ADDRESS":
            return MortgageCategory_PrequalStepKey.PREQUAL_CURRENT_ADDRESS;
        case 12:
        case "PREQUAL_CO_BORROWER":
            return MortgageCategory_PrequalStepKey.PREQUAL_CO_BORROWER;
        case 13:
        case "PREQUAL_CLOSING_DATE":
            return MortgageCategory_PrequalStepKey.PREQUAL_CLOSING_DATE;
        case -1:
        case "UNRECOGNIZED":
        default:
            return MortgageCategory_PrequalStepKey.UNRECOGNIZED;
    }
}
function mortgageCategory_PrequalStepKeyToJSON(object) {
    switch(object){
        case MortgageCategory_PrequalStepKey.PREQUAL_UNKNOWN_STEP:
            return "PREQUAL_UNKNOWN_STEP";
        case MortgageCategory_PrequalStepKey.PREQUAL_LOCATION:
            return "PREQUAL_LOCATION";
        case MortgageCategory_PrequalStepKey.PREQUAL_PURCHASE_PRICE:
            return "PREQUAL_PURCHASE_PRICE";
        case MortgageCategory_PrequalStepKey.PREQUAL_DOWN_PAYMENT:
            return "PREQUAL_DOWN_PAYMENT";
        case MortgageCategory_PrequalStepKey.PREQUAL_ANNUAL_INCOME:
            return "PREQUAL_ANNUAL_INCOME";
        case MortgageCategory_PrequalStepKey.PREQUAL_MONTHLY_DEBT:
            return "PREQUAL_MONTHLY_DEBT";
        case MortgageCategory_PrequalStepKey.PREQUAL_CREDIT_SCORE:
            return "PREQUAL_CREDIT_SCORE";
        case MortgageCategory_PrequalStepKey.PREQUAL_PHONE_NUMBER:
            return "PREQUAL_PHONE_NUMBER";
        case MortgageCategory_PrequalStepKey.PREQUAL_HOME_USAGE:
            return "PREQUAL_HOME_USAGE";
        case MortgageCategory_PrequalStepKey.PREQUAL_PURCHASE_TIMELINE:
            return "PREQUAL_PURCHASE_TIMELINE";
        case MortgageCategory_PrequalStepKey.PREQUAL_EMPLOYMENT_STATUS:
            return "PREQUAL_EMPLOYMENT_STATUS";
        case MortgageCategory_PrequalStepKey.PREQUAL_CURRENT_ADDRESS:
            return "PREQUAL_CURRENT_ADDRESS";
        case MortgageCategory_PrequalStepKey.PREQUAL_CO_BORROWER:
            return "PREQUAL_CO_BORROWER";
        case MortgageCategory_PrequalStepKey.PREQUAL_CLOSING_DATE:
            return "PREQUAL_CLOSING_DATE";
        case MortgageCategory_PrequalStepKey.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var MortgageCategory_PrequalChannel;
(function(MortgageCategory_PrequalChannel) {
    MortgageCategory_PrequalChannel[MortgageCategory_PrequalChannel["UNKNOWN_CHANNEL"] = 0] = "UNKNOWN_CHANNEL";
    MortgageCategory_PrequalChannel[MortgageCategory_PrequalChannel["BUYER_CHECKOUT"] = 1] = "BUYER_CHECKOUT";
    MortgageCategory_PrequalChannel[MortgageCategory_PrequalChannel["LISTING_PARTNER_LINK"] = 2] = "LISTING_PARTNER_LINK";
    MortgageCategory_PrequalChannel[MortgageCategory_PrequalChannel["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(MortgageCategory_PrequalChannel || (MortgageCategory_PrequalChannel = {}));
function mortgageCategory_PrequalChannelFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN_CHANNEL":
            return MortgageCategory_PrequalChannel.UNKNOWN_CHANNEL;
        case 1:
        case "BUYER_CHECKOUT":
            return MortgageCategory_PrequalChannel.BUYER_CHECKOUT;
        case 2:
        case "LISTING_PARTNER_LINK":
            return MortgageCategory_PrequalChannel.LISTING_PARTNER_LINK;
        case -1:
        case "UNRECOGNIZED":
        default:
            return MortgageCategory_PrequalChannel.UNRECOGNIZED;
    }
}
function mortgageCategory_PrequalChannelToJSON(object) {
    switch(object){
        case MortgageCategory_PrequalChannel.UNKNOWN_CHANNEL:
            return "UNKNOWN_CHANNEL";
        case MortgageCategory_PrequalChannel.BUYER_CHECKOUT:
            return "BUYER_CHECKOUT";
        case MortgageCategory_PrequalChannel.LISTING_PARTNER_LINK:
            return "LISTING_PARTNER_LINK";
        case MortgageCategory_PrequalChannel.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var MortgageCategory_PrequalDecisionType;
(function(MortgageCategory_PrequalDecisionType) {
    MortgageCategory_PrequalDecisionType[MortgageCategory_PrequalDecisionType["PREQUAL_UNKNOWN_DECISION"] = 0] = "PREQUAL_UNKNOWN_DECISION";
    MortgageCategory_PrequalDecisionType[MortgageCategory_PrequalDecisionType["PREQUAL_APPROVED"] = 1] = "PREQUAL_APPROVED";
    MortgageCategory_PrequalDecisionType[MortgageCategory_PrequalDecisionType["PREQUAL_DECLINED"] = 2] = "PREQUAL_DECLINED";
    MortgageCategory_PrequalDecisionType[MortgageCategory_PrequalDecisionType["PREQUAL_DISQUALIFIED"] = 3] = "PREQUAL_DISQUALIFIED";
    MortgageCategory_PrequalDecisionType[MortgageCategory_PrequalDecisionType["PREQUAL_TIMED_OUT"] = 4] = "PREQUAL_TIMED_OUT";
    MortgageCategory_PrequalDecisionType[MortgageCategory_PrequalDecisionType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(MortgageCategory_PrequalDecisionType || (MortgageCategory_PrequalDecisionType = {}));
function mortgageCategory_PrequalDecisionTypeFromJSON(object) {
    switch(object){
        case 0:
        case "PREQUAL_UNKNOWN_DECISION":
            return MortgageCategory_PrequalDecisionType.PREQUAL_UNKNOWN_DECISION;
        case 1:
        case "PREQUAL_APPROVED":
            return MortgageCategory_PrequalDecisionType.PREQUAL_APPROVED;
        case 2:
        case "PREQUAL_DECLINED":
            return MortgageCategory_PrequalDecisionType.PREQUAL_DECLINED;
        case 3:
        case "PREQUAL_DISQUALIFIED":
            return MortgageCategory_PrequalDecisionType.PREQUAL_DISQUALIFIED;
        case 4:
        case "PREQUAL_TIMED_OUT":
            return MortgageCategory_PrequalDecisionType.PREQUAL_TIMED_OUT;
        case -1:
        case "UNRECOGNIZED":
        default:
            return MortgageCategory_PrequalDecisionType.UNRECOGNIZED;
    }
}
function mortgageCategory_PrequalDecisionTypeToJSON(object) {
    switch(object){
        case MortgageCategory_PrequalDecisionType.PREQUAL_UNKNOWN_DECISION:
            return "PREQUAL_UNKNOWN_DECISION";
        case MortgageCategory_PrequalDecisionType.PREQUAL_APPROVED:
            return "PREQUAL_APPROVED";
        case MortgageCategory_PrequalDecisionType.PREQUAL_DECLINED:
            return "PREQUAL_DECLINED";
        case MortgageCategory_PrequalDecisionType.PREQUAL_DISQUALIFIED:
            return "PREQUAL_DISQUALIFIED";
        case MortgageCategory_PrequalDecisionType.PREQUAL_TIMED_OUT:
            return "PREQUAL_TIMED_OUT";
        case MortgageCategory_PrequalDecisionType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
function createBaseMortgageCategory() {
    return {
        event: undefined
    };
}
var MortgageCategory = {
    fromJSON: function fromJSON(object) {
        return {
            event: mortgage_category_isSet(object.applicationStart) ? {
                $case: "applicationStart",
                applicationStart: MortgageCategory_ApplicationStartEvent.fromJSON(object.applicationStart)
            } : mortgage_category_isSet(object.stepView) ? {
                $case: "stepView",
                stepView: MortgageCategory_StepViewEvent.fromJSON(object.stepView)
            } : mortgage_category_isSet(object.stepComplete) ? {
                $case: "stepComplete",
                stepComplete: MortgageCategory_StepCompleteEvent.fromJSON(object.stepComplete)
            } : mortgage_category_isSet(object.applicationSubmit) ? {
                $case: "applicationSubmit",
                applicationSubmit: MortgageCategory_ApplicationSubmitEvent.fromJSON(object.applicationSubmit)
            } : mortgage_category_isSet(object.applicationDecision) ? {
                $case: "applicationDecision",
                applicationDecision: MortgageCategory_ApplicationDecisionEvent.fromJSON(object.applicationDecision)
            } : mortgage_category_isSet(object.integrationStart) ? {
                $case: "integrationStart",
                integrationStart: MortgageCategory_IntegrationStartEvent.fromJSON(object.integrationStart)
            } : mortgage_category_isSet(object.integrationResult) ? {
                $case: "integrationResult",
                integrationResult: MortgageCategory_IntegrationResultEvent.fromJSON(object.integrationResult)
            } : mortgage_category_isSet(object.productPricingStart) ? {
                $case: "productPricingStart",
                productPricingStart: MortgageCategory_ProductPricingStartEvent.fromJSON(object.productPricingStart)
            } : mortgage_category_isSet(object.outOfPocketMaxSelection) ? {
                $case: "outOfPocketMaxSelection",
                outOfPocketMaxSelection: MortgageCategory_OutOfPocketMaxSelectionEvent.fromJSON(object.outOfPocketMaxSelection)
            } : mortgage_category_isSet(object.downPaymentSelection) ? {
                $case: "downPaymentSelection",
                downPaymentSelection: MortgageCategory_DownPaymentSelectionEvent.fromJSON(object.downPaymentSelection)
            } : mortgage_category_isSet(object.productPricingSelect) ? {
                $case: "productPricingSelect",
                productPricingSelect: MortgageCategory_ProductPricingSelectEvent.fromJSON(object.productPricingSelect)
            } : mortgage_category_isSet(object.productPricingSeeDetails) ? {
                $case: "productPricingSeeDetails",
                productPricingSeeDetails: MortgageCategory_ProductPricingSeeDetailsEvent.fromJSON(object.productPricingSeeDetails)
            } : mortgage_category_isSet(object.rateLockStart) ? {
                $case: "rateLockStart",
                rateLockStart: MortgageCategory_RateLockStartEvent.fromJSON(object.rateLockStart)
            } : mortgage_category_isSet(object.rateLockComplete) ? {
                $case: "rateLockComplete",
                rateLockComplete: MortgageCategory_RateLockCompleteEvent.fromJSON(object.rateLockComplete)
            } : mortgage_category_isSet(object.disclosuresSigned) ? {
                $case: "disclosuresSigned",
                disclosuresSigned: MortgageCategory_DisclosuresSignedEvent.fromJSON(object.disclosuresSigned)
            } : mortgage_category_isSet(object.validationError) ? {
                $case: "validationError",
                validationError: MortgageCategory_ValidationErrorEvent.fromJSON(object.validationError)
            } : mortgage_category_isSet(object.prequalStart) ? {
                $case: "prequalStart",
                prequalStart: MortgageCategory_PrequalStartEvent.fromJSON(object.prequalStart)
            } : mortgage_category_isSet(object.prequalStepView) ? {
                $case: "prequalStepView",
                prequalStepView: MortgageCategory_PrequalStepViewEvent.fromJSON(object.prequalStepView)
            } : mortgage_category_isSet(object.prequalStepComplete) ? {
                $case: "prequalStepComplete",
                prequalStepComplete: MortgageCategory_PrequalStepCompleteEvent.fromJSON(object.prequalStepComplete)
            } : mortgage_category_isSet(object.prequalSubmit) ? {
                $case: "prequalSubmit",
                prequalSubmit: MortgageCategory_PrequalSubmitEvent.fromJSON(object.prequalSubmit)
            } : mortgage_category_isSet(object.prequalDecision) ? {
                $case: "prequalDecision",
                prequalDecision: MortgageCategory_PrequalDecisionEvent.fromJSON(object.prequalDecision)
            } : mortgage_category_isSet(object.lowerReferral) ? {
                $case: "lowerReferral",
                lowerReferral: MortgageCategory_LowerReferralEvent.fromJSON(object.lowerReferral)
            } : mortgage_category_isSet(object.prequalValidationError) ? {
                $case: "prequalValidationError",
                prequalValidationError: MortgageCategory_PrequalValidationErrorEvent.fromJSON(object.prequalValidationError)
            } : undefined
        };
    },
    toJSON: function toJSON(message) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22;
        var obj = {};
        if (((ref = message.event) === null || ref === void 0 ? void 0 : ref.$case) === "applicationStart") {
            obj.applicationStart = MortgageCategory_ApplicationStartEvent.toJSON(message.event.applicationStart);
        }
        if (((ref1 = message.event) === null || ref1 === void 0 ? void 0 : ref1.$case) === "stepView") {
            obj.stepView = MortgageCategory_StepViewEvent.toJSON(message.event.stepView);
        }
        if (((ref2 = message.event) === null || ref2 === void 0 ? void 0 : ref2.$case) === "stepComplete") {
            obj.stepComplete = MortgageCategory_StepCompleteEvent.toJSON(message.event.stepComplete);
        }
        if (((ref3 = message.event) === null || ref3 === void 0 ? void 0 : ref3.$case) === "applicationSubmit") {
            obj.applicationSubmit = MortgageCategory_ApplicationSubmitEvent.toJSON(message.event.applicationSubmit);
        }
        if (((ref4 = message.event) === null || ref4 === void 0 ? void 0 : ref4.$case) === "applicationDecision") {
            obj.applicationDecision = MortgageCategory_ApplicationDecisionEvent.toJSON(message.event.applicationDecision);
        }
        if (((ref5 = message.event) === null || ref5 === void 0 ? void 0 : ref5.$case) === "integrationStart") {
            obj.integrationStart = MortgageCategory_IntegrationStartEvent.toJSON(message.event.integrationStart);
        }
        if (((ref6 = message.event) === null || ref6 === void 0 ? void 0 : ref6.$case) === "integrationResult") {
            obj.integrationResult = MortgageCategory_IntegrationResultEvent.toJSON(message.event.integrationResult);
        }
        if (((ref7 = message.event) === null || ref7 === void 0 ? void 0 : ref7.$case) === "productPricingStart") {
            obj.productPricingStart = MortgageCategory_ProductPricingStartEvent.toJSON(message.event.productPricingStart);
        }
        if (((ref8 = message.event) === null || ref8 === void 0 ? void 0 : ref8.$case) === "outOfPocketMaxSelection") {
            obj.outOfPocketMaxSelection = MortgageCategory_OutOfPocketMaxSelectionEvent.toJSON(message.event.outOfPocketMaxSelection);
        }
        if (((ref9 = message.event) === null || ref9 === void 0 ? void 0 : ref9.$case) === "downPaymentSelection") {
            obj.downPaymentSelection = MortgageCategory_DownPaymentSelectionEvent.toJSON(message.event.downPaymentSelection);
        }
        if (((ref10 = message.event) === null || ref10 === void 0 ? void 0 : ref10.$case) === "productPricingSelect") {
            obj.productPricingSelect = MortgageCategory_ProductPricingSelectEvent.toJSON(message.event.productPricingSelect);
        }
        if (((ref11 = message.event) === null || ref11 === void 0 ? void 0 : ref11.$case) === "productPricingSeeDetails") {
            obj.productPricingSeeDetails = MortgageCategory_ProductPricingSeeDetailsEvent.toJSON(message.event.productPricingSeeDetails);
        }
        if (((ref12 = message.event) === null || ref12 === void 0 ? void 0 : ref12.$case) === "rateLockStart") {
            obj.rateLockStart = MortgageCategory_RateLockStartEvent.toJSON(message.event.rateLockStart);
        }
        if (((ref13 = message.event) === null || ref13 === void 0 ? void 0 : ref13.$case) === "rateLockComplete") {
            obj.rateLockComplete = MortgageCategory_RateLockCompleteEvent.toJSON(message.event.rateLockComplete);
        }
        if (((ref14 = message.event) === null || ref14 === void 0 ? void 0 : ref14.$case) === "disclosuresSigned") {
            obj.disclosuresSigned = MortgageCategory_DisclosuresSignedEvent.toJSON(message.event.disclosuresSigned);
        }
        if (((ref15 = message.event) === null || ref15 === void 0 ? void 0 : ref15.$case) === "validationError") {
            obj.validationError = MortgageCategory_ValidationErrorEvent.toJSON(message.event.validationError);
        }
        if (((ref16 = message.event) === null || ref16 === void 0 ? void 0 : ref16.$case) === "prequalStart") {
            obj.prequalStart = MortgageCategory_PrequalStartEvent.toJSON(message.event.prequalStart);
        }
        if (((ref17 = message.event) === null || ref17 === void 0 ? void 0 : ref17.$case) === "prequalStepView") {
            obj.prequalStepView = MortgageCategory_PrequalStepViewEvent.toJSON(message.event.prequalStepView);
        }
        if (((ref18 = message.event) === null || ref18 === void 0 ? void 0 : ref18.$case) === "prequalStepComplete") {
            obj.prequalStepComplete = MortgageCategory_PrequalStepCompleteEvent.toJSON(message.event.prequalStepComplete);
        }
        if (((ref19 = message.event) === null || ref19 === void 0 ? void 0 : ref19.$case) === "prequalSubmit") {
            obj.prequalSubmit = MortgageCategory_PrequalSubmitEvent.toJSON(message.event.prequalSubmit);
        }
        if (((ref20 = message.event) === null || ref20 === void 0 ? void 0 : ref20.$case) === "prequalDecision") {
            obj.prequalDecision = MortgageCategory_PrequalDecisionEvent.toJSON(message.event.prequalDecision);
        }
        if (((ref21 = message.event) === null || ref21 === void 0 ? void 0 : ref21.$case) === "lowerReferral") {
            obj.lowerReferral = MortgageCategory_LowerReferralEvent.toJSON(message.event.lowerReferral);
        }
        if (((ref22 = message.event) === null || ref22 === void 0 ? void 0 : ref22.$case) === "prequalValidationError") {
            obj.prequalValidationError = MortgageCategory_PrequalValidationErrorEvent.toJSON(message.event.prequalValidationError);
        }
        return obj;
    },
    create: function create(base) {
        return MortgageCategory.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40, ref41, ref42, ref43, ref44, ref45, ref46, ref47, ref48, ref49, ref50, ref51, ref52, ref53, ref54, ref55, ref56, ref57, ref58, ref59, ref60, ref61, ref62, ref63, ref64, ref65, ref66, ref67, ref68;
        var message = createBaseMortgageCategory();
        if (((ref = object.event) === null || ref === void 0 ? void 0 : ref.$case) === "applicationStart" && ((ref1 = object.event) === null || ref1 === void 0 ? void 0 : ref1.applicationStart) !== undefined && ((ref2 = object.event) === null || ref2 === void 0 ? void 0 : ref2.applicationStart) !== null) {
            message.event = {
                $case: "applicationStart",
                applicationStart: MortgageCategory_ApplicationStartEvent.fromPartial(object.event.applicationStart)
            };
        }
        if (((ref3 = object.event) === null || ref3 === void 0 ? void 0 : ref3.$case) === "stepView" && ((ref4 = object.event) === null || ref4 === void 0 ? void 0 : ref4.stepView) !== undefined && ((ref5 = object.event) === null || ref5 === void 0 ? void 0 : ref5.stepView) !== null) {
            message.event = {
                $case: "stepView",
                stepView: MortgageCategory_StepViewEvent.fromPartial(object.event.stepView)
            };
        }
        if (((ref6 = object.event) === null || ref6 === void 0 ? void 0 : ref6.$case) === "stepComplete" && ((ref7 = object.event) === null || ref7 === void 0 ? void 0 : ref7.stepComplete) !== undefined && ((ref8 = object.event) === null || ref8 === void 0 ? void 0 : ref8.stepComplete) !== null) {
            message.event = {
                $case: "stepComplete",
                stepComplete: MortgageCategory_StepCompleteEvent.fromPartial(object.event.stepComplete)
            };
        }
        if (((ref9 = object.event) === null || ref9 === void 0 ? void 0 : ref9.$case) === "applicationSubmit" && ((ref10 = object.event) === null || ref10 === void 0 ? void 0 : ref10.applicationSubmit) !== undefined && ((ref11 = object.event) === null || ref11 === void 0 ? void 0 : ref11.applicationSubmit) !== null) {
            message.event = {
                $case: "applicationSubmit",
                applicationSubmit: MortgageCategory_ApplicationSubmitEvent.fromPartial(object.event.applicationSubmit)
            };
        }
        if (((ref12 = object.event) === null || ref12 === void 0 ? void 0 : ref12.$case) === "applicationDecision" && ((ref13 = object.event) === null || ref13 === void 0 ? void 0 : ref13.applicationDecision) !== undefined && ((ref14 = object.event) === null || ref14 === void 0 ? void 0 : ref14.applicationDecision) !== null) {
            message.event = {
                $case: "applicationDecision",
                applicationDecision: MortgageCategory_ApplicationDecisionEvent.fromPartial(object.event.applicationDecision)
            };
        }
        if (((ref15 = object.event) === null || ref15 === void 0 ? void 0 : ref15.$case) === "integrationStart" && ((ref16 = object.event) === null || ref16 === void 0 ? void 0 : ref16.integrationStart) !== undefined && ((ref17 = object.event) === null || ref17 === void 0 ? void 0 : ref17.integrationStart) !== null) {
            message.event = {
                $case: "integrationStart",
                integrationStart: MortgageCategory_IntegrationStartEvent.fromPartial(object.event.integrationStart)
            };
        }
        if (((ref18 = object.event) === null || ref18 === void 0 ? void 0 : ref18.$case) === "integrationResult" && ((ref19 = object.event) === null || ref19 === void 0 ? void 0 : ref19.integrationResult) !== undefined && ((ref20 = object.event) === null || ref20 === void 0 ? void 0 : ref20.integrationResult) !== null) {
            message.event = {
                $case: "integrationResult",
                integrationResult: MortgageCategory_IntegrationResultEvent.fromPartial(object.event.integrationResult)
            };
        }
        if (((ref21 = object.event) === null || ref21 === void 0 ? void 0 : ref21.$case) === "productPricingStart" && ((ref22 = object.event) === null || ref22 === void 0 ? void 0 : ref22.productPricingStart) !== undefined && ((ref23 = object.event) === null || ref23 === void 0 ? void 0 : ref23.productPricingStart) !== null) {
            message.event = {
                $case: "productPricingStart",
                productPricingStart: MortgageCategory_ProductPricingStartEvent.fromPartial(object.event.productPricingStart)
            };
        }
        if (((ref24 = object.event) === null || ref24 === void 0 ? void 0 : ref24.$case) === "outOfPocketMaxSelection" && ((ref25 = object.event) === null || ref25 === void 0 ? void 0 : ref25.outOfPocketMaxSelection) !== undefined && ((ref26 = object.event) === null || ref26 === void 0 ? void 0 : ref26.outOfPocketMaxSelection) !== null) {
            message.event = {
                $case: "outOfPocketMaxSelection",
                outOfPocketMaxSelection: MortgageCategory_OutOfPocketMaxSelectionEvent.fromPartial(object.event.outOfPocketMaxSelection)
            };
        }
        if (((ref27 = object.event) === null || ref27 === void 0 ? void 0 : ref27.$case) === "downPaymentSelection" && ((ref28 = object.event) === null || ref28 === void 0 ? void 0 : ref28.downPaymentSelection) !== undefined && ((ref29 = object.event) === null || ref29 === void 0 ? void 0 : ref29.downPaymentSelection) !== null) {
            message.event = {
                $case: "downPaymentSelection",
                downPaymentSelection: MortgageCategory_DownPaymentSelectionEvent.fromPartial(object.event.downPaymentSelection)
            };
        }
        if (((ref30 = object.event) === null || ref30 === void 0 ? void 0 : ref30.$case) === "productPricingSelect" && ((ref31 = object.event) === null || ref31 === void 0 ? void 0 : ref31.productPricingSelect) !== undefined && ((ref32 = object.event) === null || ref32 === void 0 ? void 0 : ref32.productPricingSelect) !== null) {
            message.event = {
                $case: "productPricingSelect",
                productPricingSelect: MortgageCategory_ProductPricingSelectEvent.fromPartial(object.event.productPricingSelect)
            };
        }
        if (((ref33 = object.event) === null || ref33 === void 0 ? void 0 : ref33.$case) === "productPricingSeeDetails" && ((ref34 = object.event) === null || ref34 === void 0 ? void 0 : ref34.productPricingSeeDetails) !== undefined && ((ref35 = object.event) === null || ref35 === void 0 ? void 0 : ref35.productPricingSeeDetails) !== null) {
            message.event = {
                $case: "productPricingSeeDetails",
                productPricingSeeDetails: MortgageCategory_ProductPricingSeeDetailsEvent.fromPartial(object.event.productPricingSeeDetails)
            };
        }
        if (((ref36 = object.event) === null || ref36 === void 0 ? void 0 : ref36.$case) === "rateLockStart" && ((ref37 = object.event) === null || ref37 === void 0 ? void 0 : ref37.rateLockStart) !== undefined && ((ref38 = object.event) === null || ref38 === void 0 ? void 0 : ref38.rateLockStart) !== null) {
            message.event = {
                $case: "rateLockStart",
                rateLockStart: MortgageCategory_RateLockStartEvent.fromPartial(object.event.rateLockStart)
            };
        }
        if (((ref39 = object.event) === null || ref39 === void 0 ? void 0 : ref39.$case) === "rateLockComplete" && ((ref40 = object.event) === null || ref40 === void 0 ? void 0 : ref40.rateLockComplete) !== undefined && ((ref41 = object.event) === null || ref41 === void 0 ? void 0 : ref41.rateLockComplete) !== null) {
            message.event = {
                $case: "rateLockComplete",
                rateLockComplete: MortgageCategory_RateLockCompleteEvent.fromPartial(object.event.rateLockComplete)
            };
        }
        if (((ref42 = object.event) === null || ref42 === void 0 ? void 0 : ref42.$case) === "disclosuresSigned" && ((ref43 = object.event) === null || ref43 === void 0 ? void 0 : ref43.disclosuresSigned) !== undefined && ((ref44 = object.event) === null || ref44 === void 0 ? void 0 : ref44.disclosuresSigned) !== null) {
            message.event = {
                $case: "disclosuresSigned",
                disclosuresSigned: MortgageCategory_DisclosuresSignedEvent.fromPartial(object.event.disclosuresSigned)
            };
        }
        if (((ref45 = object.event) === null || ref45 === void 0 ? void 0 : ref45.$case) === "validationError" && ((ref46 = object.event) === null || ref46 === void 0 ? void 0 : ref46.validationError) !== undefined && ((ref47 = object.event) === null || ref47 === void 0 ? void 0 : ref47.validationError) !== null) {
            message.event = {
                $case: "validationError",
                validationError: MortgageCategory_ValidationErrorEvent.fromPartial(object.event.validationError)
            };
        }
        if (((ref48 = object.event) === null || ref48 === void 0 ? void 0 : ref48.$case) === "prequalStart" && ((ref49 = object.event) === null || ref49 === void 0 ? void 0 : ref49.prequalStart) !== undefined && ((ref50 = object.event) === null || ref50 === void 0 ? void 0 : ref50.prequalStart) !== null) {
            message.event = {
                $case: "prequalStart",
                prequalStart: MortgageCategory_PrequalStartEvent.fromPartial(object.event.prequalStart)
            };
        }
        if (((ref51 = object.event) === null || ref51 === void 0 ? void 0 : ref51.$case) === "prequalStepView" && ((ref52 = object.event) === null || ref52 === void 0 ? void 0 : ref52.prequalStepView) !== undefined && ((ref53 = object.event) === null || ref53 === void 0 ? void 0 : ref53.prequalStepView) !== null) {
            message.event = {
                $case: "prequalStepView",
                prequalStepView: MortgageCategory_PrequalStepViewEvent.fromPartial(object.event.prequalStepView)
            };
        }
        if (((ref54 = object.event) === null || ref54 === void 0 ? void 0 : ref54.$case) === "prequalStepComplete" && ((ref55 = object.event) === null || ref55 === void 0 ? void 0 : ref55.prequalStepComplete) !== undefined && ((ref56 = object.event) === null || ref56 === void 0 ? void 0 : ref56.prequalStepComplete) !== null) {
            message.event = {
                $case: "prequalStepComplete",
                prequalStepComplete: MortgageCategory_PrequalStepCompleteEvent.fromPartial(object.event.prequalStepComplete)
            };
        }
        if (((ref57 = object.event) === null || ref57 === void 0 ? void 0 : ref57.$case) === "prequalSubmit" && ((ref58 = object.event) === null || ref58 === void 0 ? void 0 : ref58.prequalSubmit) !== undefined && ((ref59 = object.event) === null || ref59 === void 0 ? void 0 : ref59.prequalSubmit) !== null) {
            message.event = {
                $case: "prequalSubmit",
                prequalSubmit: MortgageCategory_PrequalSubmitEvent.fromPartial(object.event.prequalSubmit)
            };
        }
        if (((ref60 = object.event) === null || ref60 === void 0 ? void 0 : ref60.$case) === "prequalDecision" && ((ref61 = object.event) === null || ref61 === void 0 ? void 0 : ref61.prequalDecision) !== undefined && ((ref62 = object.event) === null || ref62 === void 0 ? void 0 : ref62.prequalDecision) !== null) {
            message.event = {
                $case: "prequalDecision",
                prequalDecision: MortgageCategory_PrequalDecisionEvent.fromPartial(object.event.prequalDecision)
            };
        }
        if (((ref63 = object.event) === null || ref63 === void 0 ? void 0 : ref63.$case) === "lowerReferral" && ((ref64 = object.event) === null || ref64 === void 0 ? void 0 : ref64.lowerReferral) !== undefined && ((ref65 = object.event) === null || ref65 === void 0 ? void 0 : ref65.lowerReferral) !== null) {
            message.event = {
                $case: "lowerReferral",
                lowerReferral: MortgageCategory_LowerReferralEvent.fromPartial(object.event.lowerReferral)
            };
        }
        if (((ref66 = object.event) === null || ref66 === void 0 ? void 0 : ref66.$case) === "prequalValidationError" && ((ref67 = object.event) === null || ref67 === void 0 ? void 0 : ref67.prequalValidationError) !== undefined && ((ref68 = object.event) === null || ref68 === void 0 ? void 0 : ref68.prequalValidationError) !== null) {
            message.event = {
                $case: "prequalValidationError",
                prequalValidationError: MortgageCategory_PrequalValidationErrorEvent.fromPartial(object.event.prequalValidationError)
            };
        }
        return message;
    }
};
function createBaseMortgageCategory_ApplicationStartEvent() {
    return {
        loanUuid: "",
        borrowerUuid: "",
        entrySource: 0
    };
}
var MortgageCategory_ApplicationStartEvent = {
    fromJSON: function fromJSON(object) {
        return {
            loanUuid: mortgage_category_isSet(object.loanUuid) ? String(object.loanUuid) : "",
            borrowerUuid: mortgage_category_isSet(object.borrowerUuid) ? String(object.borrowerUuid) : "",
            entrySource: mortgage_category_isSet(object.entrySource) ? mortgageCategory_EntrySourceFromJSON(object.entrySource) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.loanUuid !== "") {
            obj.loanUuid = message.loanUuid;
        }
        if (message.borrowerUuid !== "") {
            obj.borrowerUuid = message.borrowerUuid;
        }
        if (message.entrySource !== 0) {
            obj.entrySource = mortgageCategory_EntrySourceToJSON(message.entrySource);
        }
        return obj;
    },
    create: function create(base) {
        return MortgageCategory_ApplicationStartEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseMortgageCategory_ApplicationStartEvent();
        var _loanUuid;
        message.loanUuid = (_loanUuid = object.loanUuid) !== null && _loanUuid !== void 0 ? _loanUuid : "";
        var _borrowerUuid;
        message.borrowerUuid = (_borrowerUuid = object.borrowerUuid) !== null && _borrowerUuid !== void 0 ? _borrowerUuid : "";
        var _entrySource;
        message.entrySource = (_entrySource = object.entrySource) !== null && _entrySource !== void 0 ? _entrySource : 0;
        return message;
    }
};
function createBaseMortgageCategory_StepViewEvent() {
    return {
        loanUuid: "",
        borrowerUuid: "",
        stepKey: 0,
        isFirstView: false,
        isReturnVisit: false
    };
}
var MortgageCategory_StepViewEvent = {
    fromJSON: function fromJSON(object) {
        return {
            loanUuid: mortgage_category_isSet(object.loanUuid) ? String(object.loanUuid) : "",
            borrowerUuid: mortgage_category_isSet(object.borrowerUuid) ? String(object.borrowerUuid) : "",
            stepKey: mortgage_category_isSet(object.stepKey) ? mortgageCategory_StepKeyFromJSON(object.stepKey) : 0,
            isFirstView: mortgage_category_isSet(object.isFirstView) ? Boolean(object.isFirstView) : false,
            isReturnVisit: mortgage_category_isSet(object.isReturnVisit) ? Boolean(object.isReturnVisit) : false
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.loanUuid !== "") {
            obj.loanUuid = message.loanUuid;
        }
        if (message.borrowerUuid !== "") {
            obj.borrowerUuid = message.borrowerUuid;
        }
        if (message.stepKey !== 0) {
            obj.stepKey = mortgageCategory_StepKeyToJSON(message.stepKey);
        }
        if (message.isFirstView === true) {
            obj.isFirstView = message.isFirstView;
        }
        if (message.isReturnVisit === true) {
            obj.isReturnVisit = message.isReturnVisit;
        }
        return obj;
    },
    create: function create(base) {
        return MortgageCategory_StepViewEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseMortgageCategory_StepViewEvent();
        var _loanUuid;
        message.loanUuid = (_loanUuid = object.loanUuid) !== null && _loanUuid !== void 0 ? _loanUuid : "";
        var _borrowerUuid;
        message.borrowerUuid = (_borrowerUuid = object.borrowerUuid) !== null && _borrowerUuid !== void 0 ? _borrowerUuid : "";
        var _stepKey;
        message.stepKey = (_stepKey = object.stepKey) !== null && _stepKey !== void 0 ? _stepKey : 0;
        var _isFirstView;
        message.isFirstView = (_isFirstView = object.isFirstView) !== null && _isFirstView !== void 0 ? _isFirstView : false;
        var _isReturnVisit;
        message.isReturnVisit = (_isReturnVisit = object.isReturnVisit) !== null && _isReturnVisit !== void 0 ? _isReturnVisit : false;
        return message;
    }
};
function createBaseMortgageCategory_StepCompleteEvent() {
    return {
        loanUuid: "",
        borrowerUuid: "",
        stepKey: 0,
        durationMs: 0,
        integrationType: 0,
        integrationSuccess: undefined
    };
}
var MortgageCategory_StepCompleteEvent = {
    fromJSON: function fromJSON(object) {
        return {
            loanUuid: mortgage_category_isSet(object.loanUuid) ? String(object.loanUuid) : "",
            borrowerUuid: mortgage_category_isSet(object.borrowerUuid) ? String(object.borrowerUuid) : "",
            stepKey: mortgage_category_isSet(object.stepKey) ? mortgageCategory_StepKeyFromJSON(object.stepKey) : 0,
            durationMs: mortgage_category_isSet(object.durationMs) ? Number(object.durationMs) : 0,
            integrationType: mortgage_category_isSet(object.integrationType) ? mortgageCategory_IntegrationTypeFromJSON(object.integrationType) : 0,
            integrationSuccess: mortgage_category_isSet(object.integrationSuccess) ? Boolean(object.integrationSuccess) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.loanUuid !== "") {
            obj.loanUuid = message.loanUuid;
        }
        if (message.borrowerUuid !== "") {
            obj.borrowerUuid = message.borrowerUuid;
        }
        if (message.stepKey !== 0) {
            obj.stepKey = mortgageCategory_StepKeyToJSON(message.stepKey);
        }
        if (message.durationMs !== 0) {
            obj.durationMs = Math.round(message.durationMs);
        }
        if (message.integrationType !== 0) {
            obj.integrationType = mortgageCategory_IntegrationTypeToJSON(message.integrationType);
        }
        if (message.integrationSuccess !== undefined) {
            obj.integrationSuccess = message.integrationSuccess;
        }
        return obj;
    },
    create: function create(base) {
        return MortgageCategory_StepCompleteEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseMortgageCategory_StepCompleteEvent();
        var _loanUuid;
        message.loanUuid = (_loanUuid = object.loanUuid) !== null && _loanUuid !== void 0 ? _loanUuid : "";
        var _borrowerUuid;
        message.borrowerUuid = (_borrowerUuid = object.borrowerUuid) !== null && _borrowerUuid !== void 0 ? _borrowerUuid : "";
        var _stepKey;
        message.stepKey = (_stepKey = object.stepKey) !== null && _stepKey !== void 0 ? _stepKey : 0;
        var _durationMs;
        message.durationMs = (_durationMs = object.durationMs) !== null && _durationMs !== void 0 ? _durationMs : 0;
        var _integrationType;
        message.integrationType = (_integrationType = object.integrationType) !== null && _integrationType !== void 0 ? _integrationType : 0;
        var _integrationSuccess;
        message.integrationSuccess = (_integrationSuccess = object.integrationSuccess) !== null && _integrationSuccess !== void 0 ? _integrationSuccess : undefined;
        return message;
    }
};
function createBaseMortgageCategory_ApplicationSubmitEvent() {
    return {
        loanUuid: "",
        borrowerUuid: "",
        totalDurationMs: 0,
        integrationsUsed: []
    };
}
var MortgageCategory_ApplicationSubmitEvent = {
    fromJSON: function fromJSON(object) {
        return {
            loanUuid: mortgage_category_isSet(object.loanUuid) ? String(object.loanUuid) : "",
            borrowerUuid: mortgage_category_isSet(object.borrowerUuid) ? String(object.borrowerUuid) : "",
            totalDurationMs: mortgage_category_isSet(object.totalDurationMs) ? Number(object.totalDurationMs) : 0,
            integrationsUsed: Array.isArray(object === null || object === void 0 ? void 0 : object.integrationsUsed) ? object.integrationsUsed.map(function(e) {
                return mortgageCategory_IntegrationTypeFromJSON(e);
            }) : []
        };
    },
    toJSON: function toJSON(message) {
        var ref;
        var obj = {};
        if (message.loanUuid !== "") {
            obj.loanUuid = message.loanUuid;
        }
        if (message.borrowerUuid !== "") {
            obj.borrowerUuid = message.borrowerUuid;
        }
        if (message.totalDurationMs !== 0) {
            obj.totalDurationMs = Math.round(message.totalDurationMs);
        }
        if ((ref = message.integrationsUsed) === null || ref === void 0 ? void 0 : ref.length) {
            obj.integrationsUsed = message.integrationsUsed.map(function(e) {
                return mortgageCategory_IntegrationTypeToJSON(e);
            });
        }
        return obj;
    },
    create: function create(base) {
        return MortgageCategory_ApplicationSubmitEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref;
        var message = createBaseMortgageCategory_ApplicationSubmitEvent();
        var _loanUuid;
        message.loanUuid = (_loanUuid = object.loanUuid) !== null && _loanUuid !== void 0 ? _loanUuid : "";
        var _borrowerUuid;
        message.borrowerUuid = (_borrowerUuid = object.borrowerUuid) !== null && _borrowerUuid !== void 0 ? _borrowerUuid : "";
        var _totalDurationMs;
        message.totalDurationMs = (_totalDurationMs = object.totalDurationMs) !== null && _totalDurationMs !== void 0 ? _totalDurationMs : 0;
        message.integrationsUsed = ((ref = object.integrationsUsed) === null || ref === void 0 ? void 0 : ref.map(function(e) {
            return e;
        })) || [];
        return message;
    }
};
function createBaseMortgageCategory_ApplicationDecisionEvent() {
    return {
        loanUuid: "",
        borrowerUuid: "",
        timeToDecisionMs: 0,
        decisionType: 0
    };
}
var MortgageCategory_ApplicationDecisionEvent = {
    fromJSON: function fromJSON(object) {
        return {
            loanUuid: mortgage_category_isSet(object.loanUuid) ? String(object.loanUuid) : "",
            borrowerUuid: mortgage_category_isSet(object.borrowerUuid) ? String(object.borrowerUuid) : "",
            timeToDecisionMs: mortgage_category_isSet(object.timeToDecisionMs) ? Number(object.timeToDecisionMs) : 0,
            decisionType: mortgage_category_isSet(object.decisionType) ? mortgageCategory_DecisionTypeFromJSON(object.decisionType) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.loanUuid !== "") {
            obj.loanUuid = message.loanUuid;
        }
        if (message.borrowerUuid !== "") {
            obj.borrowerUuid = message.borrowerUuid;
        }
        if (message.timeToDecisionMs !== 0) {
            obj.timeToDecisionMs = Math.round(message.timeToDecisionMs);
        }
        if (message.decisionType !== 0) {
            obj.decisionType = mortgageCategory_DecisionTypeToJSON(message.decisionType);
        }
        return obj;
    },
    create: function create(base) {
        return MortgageCategory_ApplicationDecisionEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseMortgageCategory_ApplicationDecisionEvent();
        var _loanUuid;
        message.loanUuid = (_loanUuid = object.loanUuid) !== null && _loanUuid !== void 0 ? _loanUuid : "";
        var _borrowerUuid;
        message.borrowerUuid = (_borrowerUuid = object.borrowerUuid) !== null && _borrowerUuid !== void 0 ? _borrowerUuid : "";
        var _timeToDecisionMs;
        message.timeToDecisionMs = (_timeToDecisionMs = object.timeToDecisionMs) !== null && _timeToDecisionMs !== void 0 ? _timeToDecisionMs : 0;
        var _decisionType;
        message.decisionType = (_decisionType = object.decisionType) !== null && _decisionType !== void 0 ? _decisionType : 0;
        return message;
    }
};
function createBaseMortgageCategory_IntegrationStartEvent() {
    return {
        loanUuid: "",
        borrowerUuid: "",
        integrationType: 0
    };
}
var MortgageCategory_IntegrationStartEvent = {
    fromJSON: function fromJSON(object) {
        return {
            loanUuid: mortgage_category_isSet(object.loanUuid) ? String(object.loanUuid) : "",
            borrowerUuid: mortgage_category_isSet(object.borrowerUuid) ? String(object.borrowerUuid) : "",
            integrationType: mortgage_category_isSet(object.integrationType) ? mortgageCategory_IntegrationTypeFromJSON(object.integrationType) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.loanUuid !== "") {
            obj.loanUuid = message.loanUuid;
        }
        if (message.borrowerUuid !== "") {
            obj.borrowerUuid = message.borrowerUuid;
        }
        if (message.integrationType !== 0) {
            obj.integrationType = mortgageCategory_IntegrationTypeToJSON(message.integrationType);
        }
        return obj;
    },
    create: function create(base) {
        return MortgageCategory_IntegrationStartEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseMortgageCategory_IntegrationStartEvent();
        var _loanUuid;
        message.loanUuid = (_loanUuid = object.loanUuid) !== null && _loanUuid !== void 0 ? _loanUuid : "";
        var _borrowerUuid;
        message.borrowerUuid = (_borrowerUuid = object.borrowerUuid) !== null && _borrowerUuid !== void 0 ? _borrowerUuid : "";
        var _integrationType;
        message.integrationType = (_integrationType = object.integrationType) !== null && _integrationType !== void 0 ? _integrationType : 0;
        return message;
    }
};
function createBaseMortgageCategory_IntegrationResultEvent() {
    return {
        loanUuid: "",
        borrowerUuid: "",
        integrationType: 0,
        result: 0,
        durationMs: 0,
        failureReason: 0
    };
}
var MortgageCategory_IntegrationResultEvent = {
    fromJSON: function fromJSON(object) {
        return {
            loanUuid: mortgage_category_isSet(object.loanUuid) ? String(object.loanUuid) : "",
            borrowerUuid: mortgage_category_isSet(object.borrowerUuid) ? String(object.borrowerUuid) : "",
            integrationType: mortgage_category_isSet(object.integrationType) ? mortgageCategory_IntegrationTypeFromJSON(object.integrationType) : 0,
            result: mortgage_category_isSet(object.result) ? mortgageCategory_IntegrationResultFromJSON(object.result) : 0,
            durationMs: mortgage_category_isSet(object.durationMs) ? Number(object.durationMs) : 0,
            failureReason: mortgage_category_isSet(object.failureReason) ? mortgageCategory_FailureReasonFromJSON(object.failureReason) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.loanUuid !== "") {
            obj.loanUuid = message.loanUuid;
        }
        if (message.borrowerUuid !== "") {
            obj.borrowerUuid = message.borrowerUuid;
        }
        if (message.integrationType !== 0) {
            obj.integrationType = mortgageCategory_IntegrationTypeToJSON(message.integrationType);
        }
        if (message.result !== 0) {
            obj.result = mortgageCategory_IntegrationResultToJSON(message.result);
        }
        if (message.durationMs !== 0) {
            obj.durationMs = Math.round(message.durationMs);
        }
        if (message.failureReason !== 0) {
            obj.failureReason = mortgageCategory_FailureReasonToJSON(message.failureReason);
        }
        return obj;
    },
    create: function create(base) {
        return MortgageCategory_IntegrationResultEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseMortgageCategory_IntegrationResultEvent();
        var _loanUuid;
        message.loanUuid = (_loanUuid = object.loanUuid) !== null && _loanUuid !== void 0 ? _loanUuid : "";
        var _borrowerUuid;
        message.borrowerUuid = (_borrowerUuid = object.borrowerUuid) !== null && _borrowerUuid !== void 0 ? _borrowerUuid : "";
        var _integrationType;
        message.integrationType = (_integrationType = object.integrationType) !== null && _integrationType !== void 0 ? _integrationType : 0;
        var _result;
        message.result = (_result = object.result) !== null && _result !== void 0 ? _result : 0;
        var _durationMs;
        message.durationMs = (_durationMs = object.durationMs) !== null && _durationMs !== void 0 ? _durationMs : 0;
        var _failureReason;
        message.failureReason = (_failureReason = object.failureReason) !== null && _failureReason !== void 0 ? _failureReason : 0;
        return message;
    }
};
function createBaseMortgageCategory_ProductPricingStartEvent() {
    return {
        loanUuid: "",
        borrowerUuid: "",
        downPaymentPercent: 0,
        optionsCount: 0
    };
}
var MortgageCategory_ProductPricingStartEvent = {
    fromJSON: function fromJSON(object) {
        return {
            loanUuid: mortgage_category_isSet(object.loanUuid) ? String(object.loanUuid) : "",
            borrowerUuid: mortgage_category_isSet(object.borrowerUuid) ? String(object.borrowerUuid) : "",
            downPaymentPercent: mortgage_category_isSet(object.downPaymentPercent) ? Number(object.downPaymentPercent) : 0,
            optionsCount: mortgage_category_isSet(object.optionsCount) ? Number(object.optionsCount) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.loanUuid !== "") {
            obj.loanUuid = message.loanUuid;
        }
        if (message.borrowerUuid !== "") {
            obj.borrowerUuid = message.borrowerUuid;
        }
        if (message.downPaymentPercent !== 0) {
            obj.downPaymentPercent = Math.round(message.downPaymentPercent);
        }
        if (message.optionsCount !== 0) {
            obj.optionsCount = Math.round(message.optionsCount);
        }
        return obj;
    },
    create: function create(base) {
        return MortgageCategory_ProductPricingStartEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseMortgageCategory_ProductPricingStartEvent();
        var _loanUuid;
        message.loanUuid = (_loanUuid = object.loanUuid) !== null && _loanUuid !== void 0 ? _loanUuid : "";
        var _borrowerUuid;
        message.borrowerUuid = (_borrowerUuid = object.borrowerUuid) !== null && _borrowerUuid !== void 0 ? _borrowerUuid : "";
        var _downPaymentPercent;
        message.downPaymentPercent = (_downPaymentPercent = object.downPaymentPercent) !== null && _downPaymentPercent !== void 0 ? _downPaymentPercent : 0;
        var _optionsCount;
        message.optionsCount = (_optionsCount = object.optionsCount) !== null && _optionsCount !== void 0 ? _optionsCount : 0;
        return message;
    }
};
function createBaseMortgageCategory_OutOfPocketMaxSelectionEvent() {
    return {
        loanUuid: "",
        borrowerUuid: "",
        outOfPocketMaxCents: 0
    };
}
var MortgageCategory_OutOfPocketMaxSelectionEvent = {
    fromJSON: function fromJSON(object) {
        return {
            loanUuid: mortgage_category_isSet(object.loanUuid) ? String(object.loanUuid) : "",
            borrowerUuid: mortgage_category_isSet(object.borrowerUuid) ? String(object.borrowerUuid) : "",
            outOfPocketMaxCents: mortgage_category_isSet(object.outOfPocketMaxCents) ? Number(object.outOfPocketMaxCents) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.loanUuid !== "") {
            obj.loanUuid = message.loanUuid;
        }
        if (message.borrowerUuid !== "") {
            obj.borrowerUuid = message.borrowerUuid;
        }
        if (message.outOfPocketMaxCents !== 0) {
            obj.outOfPocketMaxCents = Math.round(message.outOfPocketMaxCents);
        }
        return obj;
    },
    create: function create(base) {
        return MortgageCategory_OutOfPocketMaxSelectionEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseMortgageCategory_OutOfPocketMaxSelectionEvent();
        var _loanUuid;
        message.loanUuid = (_loanUuid = object.loanUuid) !== null && _loanUuid !== void 0 ? _loanUuid : "";
        var _borrowerUuid;
        message.borrowerUuid = (_borrowerUuid = object.borrowerUuid) !== null && _borrowerUuid !== void 0 ? _borrowerUuid : "";
        var _outOfPocketMaxCents;
        message.outOfPocketMaxCents = (_outOfPocketMaxCents = object.outOfPocketMaxCents) !== null && _outOfPocketMaxCents !== void 0 ? _outOfPocketMaxCents : 0;
        return message;
    }
};
function createBaseMortgageCategory_DownPaymentSelectionEvent() {
    return {
        loanUuid: "",
        borrowerUuid: "",
        downPaymentPercent: 0,
        isCustom: false
    };
}
var MortgageCategory_DownPaymentSelectionEvent = {
    fromJSON: function fromJSON(object) {
        return {
            loanUuid: mortgage_category_isSet(object.loanUuid) ? String(object.loanUuid) : "",
            borrowerUuid: mortgage_category_isSet(object.borrowerUuid) ? String(object.borrowerUuid) : "",
            downPaymentPercent: mortgage_category_isSet(object.downPaymentPercent) ? Number(object.downPaymentPercent) : 0,
            isCustom: mortgage_category_isSet(object.isCustom) ? Boolean(object.isCustom) : false
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.loanUuid !== "") {
            obj.loanUuid = message.loanUuid;
        }
        if (message.borrowerUuid !== "") {
            obj.borrowerUuid = message.borrowerUuid;
        }
        if (message.downPaymentPercent !== 0) {
            obj.downPaymentPercent = Math.round(message.downPaymentPercent);
        }
        if (message.isCustom === true) {
            obj.isCustom = message.isCustom;
        }
        return obj;
    },
    create: function create(base) {
        return MortgageCategory_DownPaymentSelectionEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseMortgageCategory_DownPaymentSelectionEvent();
        var _loanUuid;
        message.loanUuid = (_loanUuid = object.loanUuid) !== null && _loanUuid !== void 0 ? _loanUuid : "";
        var _borrowerUuid;
        message.borrowerUuid = (_borrowerUuid = object.borrowerUuid) !== null && _borrowerUuid !== void 0 ? _borrowerUuid : "";
        var _downPaymentPercent;
        message.downPaymentPercent = (_downPaymentPercent = object.downPaymentPercent) !== null && _downPaymentPercent !== void 0 ? _downPaymentPercent : 0;
        var _isCustom;
        message.isCustom = (_isCustom = object.isCustom) !== null && _isCustom !== void 0 ? _isCustom : false;
        return message;
    }
};
function createBaseMortgageCategory_ProductPricingSelectEvent() {
    return {
        loanUuid: "",
        borrowerUuid: "",
        ratePercent: "",
        lockPeriodDays: 0,
        monthlyPaymentCents: 0
    };
}
var MortgageCategory_ProductPricingSelectEvent = {
    fromJSON: function fromJSON(object) {
        return {
            loanUuid: mortgage_category_isSet(object.loanUuid) ? String(object.loanUuid) : "",
            borrowerUuid: mortgage_category_isSet(object.borrowerUuid) ? String(object.borrowerUuid) : "",
            ratePercent: mortgage_category_isSet(object.ratePercent) ? String(object.ratePercent) : "",
            lockPeriodDays: mortgage_category_isSet(object.lockPeriodDays) ? Number(object.lockPeriodDays) : 0,
            monthlyPaymentCents: mortgage_category_isSet(object.monthlyPaymentCents) ? Number(object.monthlyPaymentCents) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.loanUuid !== "") {
            obj.loanUuid = message.loanUuid;
        }
        if (message.borrowerUuid !== "") {
            obj.borrowerUuid = message.borrowerUuid;
        }
        if (message.ratePercent !== "") {
            obj.ratePercent = message.ratePercent;
        }
        if (message.lockPeriodDays !== 0) {
            obj.lockPeriodDays = Math.round(message.lockPeriodDays);
        }
        if (message.monthlyPaymentCents !== 0) {
            obj.monthlyPaymentCents = Math.round(message.monthlyPaymentCents);
        }
        return obj;
    },
    create: function create(base) {
        return MortgageCategory_ProductPricingSelectEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseMortgageCategory_ProductPricingSelectEvent();
        var _loanUuid;
        message.loanUuid = (_loanUuid = object.loanUuid) !== null && _loanUuid !== void 0 ? _loanUuid : "";
        var _borrowerUuid;
        message.borrowerUuid = (_borrowerUuid = object.borrowerUuid) !== null && _borrowerUuid !== void 0 ? _borrowerUuid : "";
        var _ratePercent;
        message.ratePercent = (_ratePercent = object.ratePercent) !== null && _ratePercent !== void 0 ? _ratePercent : "";
        var _lockPeriodDays;
        message.lockPeriodDays = (_lockPeriodDays = object.lockPeriodDays) !== null && _lockPeriodDays !== void 0 ? _lockPeriodDays : 0;
        var _monthlyPaymentCents;
        message.monthlyPaymentCents = (_monthlyPaymentCents = object.monthlyPaymentCents) !== null && _monthlyPaymentCents !== void 0 ? _monthlyPaymentCents : 0;
        return message;
    }
};
function createBaseMortgageCategory_ProductPricingSeeDetailsEvent() {
    return {
        loanUuid: "",
        borrowerUuid: "",
        ratePercent: ""
    };
}
var MortgageCategory_ProductPricingSeeDetailsEvent = {
    fromJSON: function fromJSON(object) {
        return {
            loanUuid: mortgage_category_isSet(object.loanUuid) ? String(object.loanUuid) : "",
            borrowerUuid: mortgage_category_isSet(object.borrowerUuid) ? String(object.borrowerUuid) : "",
            ratePercent: mortgage_category_isSet(object.ratePercent) ? String(object.ratePercent) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.loanUuid !== "") {
            obj.loanUuid = message.loanUuid;
        }
        if (message.borrowerUuid !== "") {
            obj.borrowerUuid = message.borrowerUuid;
        }
        if (message.ratePercent !== "") {
            obj.ratePercent = message.ratePercent;
        }
        return obj;
    },
    create: function create(base) {
        return MortgageCategory_ProductPricingSeeDetailsEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseMortgageCategory_ProductPricingSeeDetailsEvent();
        var _loanUuid;
        message.loanUuid = (_loanUuid = object.loanUuid) !== null && _loanUuid !== void 0 ? _loanUuid : "";
        var _borrowerUuid;
        message.borrowerUuid = (_borrowerUuid = object.borrowerUuid) !== null && _borrowerUuid !== void 0 ? _borrowerUuid : "";
        var _ratePercent;
        message.ratePercent = (_ratePercent = object.ratePercent) !== null && _ratePercent !== void 0 ? _ratePercent : "";
        return message;
    }
};
function createBaseMortgageCategory_RateLockStartEvent() {
    return {
        loanUuid: "",
        borrowerUuid: "",
        ratePercent: "",
        lockPeriodDays: 0
    };
}
var MortgageCategory_RateLockStartEvent = {
    fromJSON: function fromJSON(object) {
        return {
            loanUuid: mortgage_category_isSet(object.loanUuid) ? String(object.loanUuid) : "",
            borrowerUuid: mortgage_category_isSet(object.borrowerUuid) ? String(object.borrowerUuid) : "",
            ratePercent: mortgage_category_isSet(object.ratePercent) ? String(object.ratePercent) : "",
            lockPeriodDays: mortgage_category_isSet(object.lockPeriodDays) ? Number(object.lockPeriodDays) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.loanUuid !== "") {
            obj.loanUuid = message.loanUuid;
        }
        if (message.borrowerUuid !== "") {
            obj.borrowerUuid = message.borrowerUuid;
        }
        if (message.ratePercent !== "") {
            obj.ratePercent = message.ratePercent;
        }
        if (message.lockPeriodDays !== 0) {
            obj.lockPeriodDays = Math.round(message.lockPeriodDays);
        }
        return obj;
    },
    create: function create(base) {
        return MortgageCategory_RateLockStartEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseMortgageCategory_RateLockStartEvent();
        var _loanUuid;
        message.loanUuid = (_loanUuid = object.loanUuid) !== null && _loanUuid !== void 0 ? _loanUuid : "";
        var _borrowerUuid;
        message.borrowerUuid = (_borrowerUuid = object.borrowerUuid) !== null && _borrowerUuid !== void 0 ? _borrowerUuid : "";
        var _ratePercent;
        message.ratePercent = (_ratePercent = object.ratePercent) !== null && _ratePercent !== void 0 ? _ratePercent : "";
        var _lockPeriodDays;
        message.lockPeriodDays = (_lockPeriodDays = object.lockPeriodDays) !== null && _lockPeriodDays !== void 0 ? _lockPeriodDays : 0;
        return message;
    }
};
function createBaseMortgageCategory_RateLockCompleteEvent() {
    return {
        loanUuid: "",
        borrowerUuid: "",
        ratePercent: "",
        downPaymentPercent: 0,
        monthlyPaymentCents: 0,
        cashToCloseCents: 0
    };
}
var MortgageCategory_RateLockCompleteEvent = {
    fromJSON: function fromJSON(object) {
        return {
            loanUuid: mortgage_category_isSet(object.loanUuid) ? String(object.loanUuid) : "",
            borrowerUuid: mortgage_category_isSet(object.borrowerUuid) ? String(object.borrowerUuid) : "",
            ratePercent: mortgage_category_isSet(object.ratePercent) ? String(object.ratePercent) : "",
            downPaymentPercent: mortgage_category_isSet(object.downPaymentPercent) ? Number(object.downPaymentPercent) : 0,
            monthlyPaymentCents: mortgage_category_isSet(object.monthlyPaymentCents) ? Number(object.monthlyPaymentCents) : 0,
            cashToCloseCents: mortgage_category_isSet(object.cashToCloseCents) ? Number(object.cashToCloseCents) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.loanUuid !== "") {
            obj.loanUuid = message.loanUuid;
        }
        if (message.borrowerUuid !== "") {
            obj.borrowerUuid = message.borrowerUuid;
        }
        if (message.ratePercent !== "") {
            obj.ratePercent = message.ratePercent;
        }
        if (message.downPaymentPercent !== 0) {
            obj.downPaymentPercent = Math.round(message.downPaymentPercent);
        }
        if (message.monthlyPaymentCents !== 0) {
            obj.monthlyPaymentCents = Math.round(message.monthlyPaymentCents);
        }
        if (message.cashToCloseCents !== 0) {
            obj.cashToCloseCents = Math.round(message.cashToCloseCents);
        }
        return obj;
    },
    create: function create(base) {
        return MortgageCategory_RateLockCompleteEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseMortgageCategory_RateLockCompleteEvent();
        var _loanUuid;
        message.loanUuid = (_loanUuid = object.loanUuid) !== null && _loanUuid !== void 0 ? _loanUuid : "";
        var _borrowerUuid;
        message.borrowerUuid = (_borrowerUuid = object.borrowerUuid) !== null && _borrowerUuid !== void 0 ? _borrowerUuid : "";
        var _ratePercent;
        message.ratePercent = (_ratePercent = object.ratePercent) !== null && _ratePercent !== void 0 ? _ratePercent : "";
        var _downPaymentPercent;
        message.downPaymentPercent = (_downPaymentPercent = object.downPaymentPercent) !== null && _downPaymentPercent !== void 0 ? _downPaymentPercent : 0;
        var _monthlyPaymentCents;
        message.monthlyPaymentCents = (_monthlyPaymentCents = object.monthlyPaymentCents) !== null && _monthlyPaymentCents !== void 0 ? _monthlyPaymentCents : 0;
        var _cashToCloseCents;
        message.cashToCloseCents = (_cashToCloseCents = object.cashToCloseCents) !== null && _cashToCloseCents !== void 0 ? _cashToCloseCents : 0;
        return message;
    }
};
function createBaseMortgageCategory_DisclosuresSignedEvent() {
    return {
        loanUuid: "",
        borrowerUuid: ""
    };
}
var MortgageCategory_DisclosuresSignedEvent = {
    fromJSON: function fromJSON(object) {
        return {
            loanUuid: mortgage_category_isSet(object.loanUuid) ? String(object.loanUuid) : "",
            borrowerUuid: mortgage_category_isSet(object.borrowerUuid) ? String(object.borrowerUuid) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.loanUuid !== "") {
            obj.loanUuid = message.loanUuid;
        }
        if (message.borrowerUuid !== "") {
            obj.borrowerUuid = message.borrowerUuid;
        }
        return obj;
    },
    create: function create(base) {
        return MortgageCategory_DisclosuresSignedEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseMortgageCategory_DisclosuresSignedEvent();
        var _loanUuid;
        message.loanUuid = (_loanUuid = object.loanUuid) !== null && _loanUuid !== void 0 ? _loanUuid : "";
        var _borrowerUuid;
        message.borrowerUuid = (_borrowerUuid = object.borrowerUuid) !== null && _borrowerUuid !== void 0 ? _borrowerUuid : "";
        return message;
    }
};
function createBaseMortgageCategory_ValidationErrorEvent() {
    return {
        loanUuid: "",
        borrowerUuid: "",
        stepKey: 0,
        fieldName: "",
        errorType: 0
    };
}
var MortgageCategory_ValidationErrorEvent = {
    fromJSON: function fromJSON(object) {
        return {
            loanUuid: mortgage_category_isSet(object.loanUuid) ? String(object.loanUuid) : "",
            borrowerUuid: mortgage_category_isSet(object.borrowerUuid) ? String(object.borrowerUuid) : "",
            stepKey: mortgage_category_isSet(object.stepKey) ? mortgageCategory_StepKeyFromJSON(object.stepKey) : 0,
            fieldName: mortgage_category_isSet(object.fieldName) ? String(object.fieldName) : "",
            errorType: mortgage_category_isSet(object.errorType) ? mortgageCategory_ValidationErrorTypeFromJSON(object.errorType) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.loanUuid !== "") {
            obj.loanUuid = message.loanUuid;
        }
        if (message.borrowerUuid !== "") {
            obj.borrowerUuid = message.borrowerUuid;
        }
        if (message.stepKey !== 0) {
            obj.stepKey = mortgageCategory_StepKeyToJSON(message.stepKey);
        }
        if (message.fieldName !== "") {
            obj.fieldName = message.fieldName;
        }
        if (message.errorType !== 0) {
            obj.errorType = mortgageCategory_ValidationErrorTypeToJSON(message.errorType);
        }
        return obj;
    },
    create: function create(base) {
        return MortgageCategory_ValidationErrorEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseMortgageCategory_ValidationErrorEvent();
        var _loanUuid;
        message.loanUuid = (_loanUuid = object.loanUuid) !== null && _loanUuid !== void 0 ? _loanUuid : "";
        var _borrowerUuid;
        message.borrowerUuid = (_borrowerUuid = object.borrowerUuid) !== null && _borrowerUuid !== void 0 ? _borrowerUuid : "";
        var _stepKey;
        message.stepKey = (_stepKey = object.stepKey) !== null && _stepKey !== void 0 ? _stepKey : 0;
        var _fieldName;
        message.fieldName = (_fieldName = object.fieldName) !== null && _fieldName !== void 0 ? _fieldName : "";
        var _errorType;
        message.errorType = (_errorType = object.errorType) !== null && _errorType !== void 0 ? _errorType : 0;
        return message;
    }
};
function createBaseMortgageCategory_PrequalStartEvent() {
    return {
        prequalApplicationId: "",
        customerUuid: undefined,
        prequalChannel: 0,
        prequalLinkId: undefined
    };
}
var MortgageCategory_PrequalStartEvent = {
    fromJSON: function fromJSON(object) {
        return {
            prequalApplicationId: mortgage_category_isSet(object.prequalApplicationId) ? String(object.prequalApplicationId) : "",
            customerUuid: mortgage_category_isSet(object.customerUuid) ? String(object.customerUuid) : undefined,
            prequalChannel: mortgage_category_isSet(object.prequalChannel) ? mortgageCategory_PrequalChannelFromJSON(object.prequalChannel) : 0,
            prequalLinkId: mortgage_category_isSet(object.prequalLinkId) ? String(object.prequalLinkId) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.prequalApplicationId !== "") {
            obj.prequalApplicationId = message.prequalApplicationId;
        }
        if (message.customerUuid !== undefined) {
            obj.customerUuid = message.customerUuid;
        }
        if (message.prequalChannel !== 0) {
            obj.prequalChannel = mortgageCategory_PrequalChannelToJSON(message.prequalChannel);
        }
        if (message.prequalLinkId !== undefined) {
            obj.prequalLinkId = message.prequalLinkId;
        }
        return obj;
    },
    create: function create(base) {
        return MortgageCategory_PrequalStartEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseMortgageCategory_PrequalStartEvent();
        var _prequalApplicationId;
        message.prequalApplicationId = (_prequalApplicationId = object.prequalApplicationId) !== null && _prequalApplicationId !== void 0 ? _prequalApplicationId : "";
        var _customerUuid;
        message.customerUuid = (_customerUuid = object.customerUuid) !== null && _customerUuid !== void 0 ? _customerUuid : undefined;
        var _prequalChannel;
        message.prequalChannel = (_prequalChannel = object.prequalChannel) !== null && _prequalChannel !== void 0 ? _prequalChannel : 0;
        var _prequalLinkId;
        message.prequalLinkId = (_prequalLinkId = object.prequalLinkId) !== null && _prequalLinkId !== void 0 ? _prequalLinkId : undefined;
        return message;
    }
};
function createBaseMortgageCategory_PrequalStepViewEvent() {
    return {
        prequalApplicationId: "",
        customerUuid: undefined,
        stepKey: 0,
        isFirstView: false,
        isReturnVisit: false
    };
}
var MortgageCategory_PrequalStepViewEvent = {
    fromJSON: function fromJSON(object) {
        return {
            prequalApplicationId: mortgage_category_isSet(object.prequalApplicationId) ? String(object.prequalApplicationId) : "",
            customerUuid: mortgage_category_isSet(object.customerUuid) ? String(object.customerUuid) : undefined,
            stepKey: mortgage_category_isSet(object.stepKey) ? mortgageCategory_PrequalStepKeyFromJSON(object.stepKey) : 0,
            isFirstView: mortgage_category_isSet(object.isFirstView) ? Boolean(object.isFirstView) : false,
            isReturnVisit: mortgage_category_isSet(object.isReturnVisit) ? Boolean(object.isReturnVisit) : false
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.prequalApplicationId !== "") {
            obj.prequalApplicationId = message.prequalApplicationId;
        }
        if (message.customerUuid !== undefined) {
            obj.customerUuid = message.customerUuid;
        }
        if (message.stepKey !== 0) {
            obj.stepKey = mortgageCategory_PrequalStepKeyToJSON(message.stepKey);
        }
        if (message.isFirstView === true) {
            obj.isFirstView = message.isFirstView;
        }
        if (message.isReturnVisit === true) {
            obj.isReturnVisit = message.isReturnVisit;
        }
        return obj;
    },
    create: function create(base) {
        return MortgageCategory_PrequalStepViewEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseMortgageCategory_PrequalStepViewEvent();
        var _prequalApplicationId;
        message.prequalApplicationId = (_prequalApplicationId = object.prequalApplicationId) !== null && _prequalApplicationId !== void 0 ? _prequalApplicationId : "";
        var _customerUuid;
        message.customerUuid = (_customerUuid = object.customerUuid) !== null && _customerUuid !== void 0 ? _customerUuid : undefined;
        var _stepKey;
        message.stepKey = (_stepKey = object.stepKey) !== null && _stepKey !== void 0 ? _stepKey : 0;
        var _isFirstView;
        message.isFirstView = (_isFirstView = object.isFirstView) !== null && _isFirstView !== void 0 ? _isFirstView : false;
        var _isReturnVisit;
        message.isReturnVisit = (_isReturnVisit = object.isReturnVisit) !== null && _isReturnVisit !== void 0 ? _isReturnVisit : false;
        return message;
    }
};
function createBaseMortgageCategory_PrequalStepCompleteEvent() {
    return {
        prequalApplicationId: "",
        customerUuid: undefined,
        stepKey: 0,
        durationMs: 0
    };
}
var MortgageCategory_PrequalStepCompleteEvent = {
    fromJSON: function fromJSON(object) {
        return {
            prequalApplicationId: mortgage_category_isSet(object.prequalApplicationId) ? String(object.prequalApplicationId) : "",
            customerUuid: mortgage_category_isSet(object.customerUuid) ? String(object.customerUuid) : undefined,
            stepKey: mortgage_category_isSet(object.stepKey) ? mortgageCategory_PrequalStepKeyFromJSON(object.stepKey) : 0,
            durationMs: mortgage_category_isSet(object.durationMs) ? Number(object.durationMs) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.prequalApplicationId !== "") {
            obj.prequalApplicationId = message.prequalApplicationId;
        }
        if (message.customerUuid !== undefined) {
            obj.customerUuid = message.customerUuid;
        }
        if (message.stepKey !== 0) {
            obj.stepKey = mortgageCategory_PrequalStepKeyToJSON(message.stepKey);
        }
        if (message.durationMs !== 0) {
            obj.durationMs = Math.round(message.durationMs);
        }
        return obj;
    },
    create: function create(base) {
        return MortgageCategory_PrequalStepCompleteEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseMortgageCategory_PrequalStepCompleteEvent();
        var _prequalApplicationId;
        message.prequalApplicationId = (_prequalApplicationId = object.prequalApplicationId) !== null && _prequalApplicationId !== void 0 ? _prequalApplicationId : "";
        var _customerUuid;
        message.customerUuid = (_customerUuid = object.customerUuid) !== null && _customerUuid !== void 0 ? _customerUuid : undefined;
        var _stepKey;
        message.stepKey = (_stepKey = object.stepKey) !== null && _stepKey !== void 0 ? _stepKey : 0;
        var _durationMs;
        message.durationMs = (_durationMs = object.durationMs) !== null && _durationMs !== void 0 ? _durationMs : 0;
        return message;
    }
};
function createBaseMortgageCategory_PrequalSubmitEvent() {
    return {
        prequalApplicationId: "",
        customerUuid: undefined,
        totalDurationMs: 0,
        prequalChannel: 0,
        stepsCompleted: 0
    };
}
var MortgageCategory_PrequalSubmitEvent = {
    fromJSON: function fromJSON(object) {
        return {
            prequalApplicationId: mortgage_category_isSet(object.prequalApplicationId) ? String(object.prequalApplicationId) : "",
            customerUuid: mortgage_category_isSet(object.customerUuid) ? String(object.customerUuid) : undefined,
            totalDurationMs: mortgage_category_isSet(object.totalDurationMs) ? Number(object.totalDurationMs) : 0,
            prequalChannel: mortgage_category_isSet(object.prequalChannel) ? mortgageCategory_PrequalChannelFromJSON(object.prequalChannel) : 0,
            stepsCompleted: mortgage_category_isSet(object.stepsCompleted) ? Number(object.stepsCompleted) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.prequalApplicationId !== "") {
            obj.prequalApplicationId = message.prequalApplicationId;
        }
        if (message.customerUuid !== undefined) {
            obj.customerUuid = message.customerUuid;
        }
        if (message.totalDurationMs !== 0) {
            obj.totalDurationMs = Math.round(message.totalDurationMs);
        }
        if (message.prequalChannel !== 0) {
            obj.prequalChannel = mortgageCategory_PrequalChannelToJSON(message.prequalChannel);
        }
        if (message.stepsCompleted !== 0) {
            obj.stepsCompleted = Math.round(message.stepsCompleted);
        }
        return obj;
    },
    create: function create(base) {
        return MortgageCategory_PrequalSubmitEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseMortgageCategory_PrequalSubmitEvent();
        var _prequalApplicationId;
        message.prequalApplicationId = (_prequalApplicationId = object.prequalApplicationId) !== null && _prequalApplicationId !== void 0 ? _prequalApplicationId : "";
        var _customerUuid;
        message.customerUuid = (_customerUuid = object.customerUuid) !== null && _customerUuid !== void 0 ? _customerUuid : undefined;
        var _totalDurationMs;
        message.totalDurationMs = (_totalDurationMs = object.totalDurationMs) !== null && _totalDurationMs !== void 0 ? _totalDurationMs : 0;
        var _prequalChannel;
        message.prequalChannel = (_prequalChannel = object.prequalChannel) !== null && _prequalChannel !== void 0 ? _prequalChannel : 0;
        var _stepsCompleted;
        message.stepsCompleted = (_stepsCompleted = object.stepsCompleted) !== null && _stepsCompleted !== void 0 ? _stepsCompleted : 0;
        return message;
    }
};
function createBaseMortgageCategory_PrequalDecisionEvent() {
    return {
        prequalApplicationId: "",
        customerUuid: undefined,
        timeToDecisionMs: 0,
        decisionType: 0,
        maxLoanAmountCents: undefined,
        ratePercent: undefined
    };
}
var MortgageCategory_PrequalDecisionEvent = {
    fromJSON: function fromJSON(object) {
        return {
            prequalApplicationId: mortgage_category_isSet(object.prequalApplicationId) ? String(object.prequalApplicationId) : "",
            customerUuid: mortgage_category_isSet(object.customerUuid) ? String(object.customerUuid) : undefined,
            timeToDecisionMs: mortgage_category_isSet(object.timeToDecisionMs) ? Number(object.timeToDecisionMs) : 0,
            decisionType: mortgage_category_isSet(object.decisionType) ? mortgageCategory_PrequalDecisionTypeFromJSON(object.decisionType) : 0,
            maxLoanAmountCents: mortgage_category_isSet(object.maxLoanAmountCents) ? Number(object.maxLoanAmountCents) : undefined,
            ratePercent: mortgage_category_isSet(object.ratePercent) ? String(object.ratePercent) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.prequalApplicationId !== "") {
            obj.prequalApplicationId = message.prequalApplicationId;
        }
        if (message.customerUuid !== undefined) {
            obj.customerUuid = message.customerUuid;
        }
        if (message.timeToDecisionMs !== 0) {
            obj.timeToDecisionMs = Math.round(message.timeToDecisionMs);
        }
        if (message.decisionType !== 0) {
            obj.decisionType = mortgageCategory_PrequalDecisionTypeToJSON(message.decisionType);
        }
        if (message.maxLoanAmountCents !== undefined) {
            obj.maxLoanAmountCents = message.maxLoanAmountCents;
        }
        if (message.ratePercent !== undefined) {
            obj.ratePercent = message.ratePercent;
        }
        return obj;
    },
    create: function create(base) {
        return MortgageCategory_PrequalDecisionEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseMortgageCategory_PrequalDecisionEvent();
        var _prequalApplicationId;
        message.prequalApplicationId = (_prequalApplicationId = object.prequalApplicationId) !== null && _prequalApplicationId !== void 0 ? _prequalApplicationId : "";
        var _customerUuid;
        message.customerUuid = (_customerUuid = object.customerUuid) !== null && _customerUuid !== void 0 ? _customerUuid : undefined;
        var _timeToDecisionMs;
        message.timeToDecisionMs = (_timeToDecisionMs = object.timeToDecisionMs) !== null && _timeToDecisionMs !== void 0 ? _timeToDecisionMs : 0;
        var _decisionType;
        message.decisionType = (_decisionType = object.decisionType) !== null && _decisionType !== void 0 ? _decisionType : 0;
        var _maxLoanAmountCents;
        message.maxLoanAmountCents = (_maxLoanAmountCents = object.maxLoanAmountCents) !== null && _maxLoanAmountCents !== void 0 ? _maxLoanAmountCents : undefined;
        var _ratePercent;
        message.ratePercent = (_ratePercent = object.ratePercent) !== null && _ratePercent !== void 0 ? _ratePercent : undefined;
        return message;
    }
};
function createBaseMortgageCategory_LowerReferralEvent() {
    return {
        prequalApplicationId: "",
        customerUuid: undefined,
        success: false,
        referralReason: 0
    };
}
var MortgageCategory_LowerReferralEvent = {
    fromJSON: function fromJSON(object) {
        return {
            prequalApplicationId: mortgage_category_isSet(object.prequalApplicationId) ? String(object.prequalApplicationId) : "",
            customerUuid: mortgage_category_isSet(object.customerUuid) ? String(object.customerUuid) : undefined,
            success: mortgage_category_isSet(object.success) ? Boolean(object.success) : false,
            referralReason: mortgage_category_isSet(object.referralReason) ? mortgageCategory_PrequalDecisionTypeFromJSON(object.referralReason) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.prequalApplicationId !== "") {
            obj.prequalApplicationId = message.prequalApplicationId;
        }
        if (message.customerUuid !== undefined) {
            obj.customerUuid = message.customerUuid;
        }
        if (message.success === true) {
            obj.success = message.success;
        }
        if (message.referralReason !== 0) {
            obj.referralReason = mortgageCategory_PrequalDecisionTypeToJSON(message.referralReason);
        }
        return obj;
    },
    create: function create(base) {
        return MortgageCategory_LowerReferralEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseMortgageCategory_LowerReferralEvent();
        var _prequalApplicationId;
        message.prequalApplicationId = (_prequalApplicationId = object.prequalApplicationId) !== null && _prequalApplicationId !== void 0 ? _prequalApplicationId : "";
        var _customerUuid;
        message.customerUuid = (_customerUuid = object.customerUuid) !== null && _customerUuid !== void 0 ? _customerUuid : undefined;
        var _success;
        message.success = (_success = object.success) !== null && _success !== void 0 ? _success : false;
        var _referralReason;
        message.referralReason = (_referralReason = object.referralReason) !== null && _referralReason !== void 0 ? _referralReason : 0;
        return message;
    }
};
function createBaseMortgageCategory_PrequalValidationErrorEvent() {
    return {
        prequalApplicationId: "",
        customerUuid: undefined,
        stepKey: 0,
        fieldName: "",
        errorType: 0
    };
}
var MortgageCategory_PrequalValidationErrorEvent = {
    fromJSON: function fromJSON(object) {
        return {
            prequalApplicationId: mortgage_category_isSet(object.prequalApplicationId) ? String(object.prequalApplicationId) : "",
            customerUuid: mortgage_category_isSet(object.customerUuid) ? String(object.customerUuid) : undefined,
            stepKey: mortgage_category_isSet(object.stepKey) ? mortgageCategory_PrequalStepKeyFromJSON(object.stepKey) : 0,
            fieldName: mortgage_category_isSet(object.fieldName) ? String(object.fieldName) : "",
            errorType: mortgage_category_isSet(object.errorType) ? mortgageCategory_ValidationErrorTypeFromJSON(object.errorType) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.prequalApplicationId !== "") {
            obj.prequalApplicationId = message.prequalApplicationId;
        }
        if (message.customerUuid !== undefined) {
            obj.customerUuid = message.customerUuid;
        }
        if (message.stepKey !== 0) {
            obj.stepKey = mortgageCategory_PrequalStepKeyToJSON(message.stepKey);
        }
        if (message.fieldName !== "") {
            obj.fieldName = message.fieldName;
        }
        if (message.errorType !== 0) {
            obj.errorType = mortgageCategory_ValidationErrorTypeToJSON(message.errorType);
        }
        return obj;
    },
    create: function create(base) {
        return MortgageCategory_PrequalValidationErrorEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseMortgageCategory_PrequalValidationErrorEvent();
        var _prequalApplicationId;
        message.prequalApplicationId = (_prequalApplicationId = object.prequalApplicationId) !== null && _prequalApplicationId !== void 0 ? _prequalApplicationId : "";
        var _customerUuid;
        message.customerUuid = (_customerUuid = object.customerUuid) !== null && _customerUuid !== void 0 ? _customerUuid : undefined;
        var _stepKey;
        message.stepKey = (_stepKey = object.stepKey) !== null && _stepKey !== void 0 ? _stepKey : 0;
        var _fieldName;
        message.fieldName = (_fieldName = object.fieldName) !== null && _fieldName !== void 0 ? _fieldName : "";
        var _errorType;
        message.errorType = (_errorType = object.errorType) !== null && _errorType !== void 0 ? _errorType : 0;
        return message;
    }
};
function mortgage_category_isSet(value) {
    return value !== null && value !== undefined;
}

;// CONCATENATED MODULE: ./src/__generated__/protobuf/journey/data/categories/platform_category.ts
/* eslint-disable */ var platform_category_protobufPackage = "od_protos.journey.data.categories";
var PlatformCategory_DevicePlatform;
(function(PlatformCategory_DevicePlatform) {
    PlatformCategory_DevicePlatform[PlatformCategory_DevicePlatform["DEVICE_PLATFORM_UNSPECIFIED"] = 0] = "DEVICE_PLATFORM_UNSPECIFIED";
    PlatformCategory_DevicePlatform[PlatformCategory_DevicePlatform["IOS"] = 1] = "IOS";
    PlatformCategory_DevicePlatform[PlatformCategory_DevicePlatform["ANDROID"] = 2] = "ANDROID";
    PlatformCategory_DevicePlatform[PlatformCategory_DevicePlatform["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(PlatformCategory_DevicePlatform || (PlatformCategory_DevicePlatform = {}));
function platformCategory_DevicePlatformFromJSON(object) {
    switch(object){
        case 0:
        case "DEVICE_PLATFORM_UNSPECIFIED":
            return PlatformCategory_DevicePlatform.DEVICE_PLATFORM_UNSPECIFIED;
        case 1:
        case "IOS":
            return PlatformCategory_DevicePlatform.IOS;
        case 2:
        case "ANDROID":
            return PlatformCategory_DevicePlatform.ANDROID;
        case -1:
        case "UNRECOGNIZED":
        default:
            return PlatformCategory_DevicePlatform.UNRECOGNIZED;
    }
}
function platformCategory_DevicePlatformToJSON(object) {
    switch(object){
        case PlatformCategory_DevicePlatform.DEVICE_PLATFORM_UNSPECIFIED:
            return "DEVICE_PLATFORM_UNSPECIFIED";
        case PlatformCategory_DevicePlatform.IOS:
            return "IOS";
        case PlatformCategory_DevicePlatform.ANDROID:
            return "ANDROID";
        case PlatformCategory_DevicePlatform.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var PlatformCategory_LinkMethod;
(function(PlatformCategory_LinkMethod) {
    PlatformCategory_LinkMethod[PlatformCategory_LinkMethod["LINK_METHOD_UNSPECIFIED"] = 0] = "LINK_METHOD_UNSPECIFIED";
    PlatformCategory_LinkMethod[PlatformCategory_LinkMethod["QR_SCAN"] = 1] = "QR_SCAN";
    PlatformCategory_LinkMethod[PlatformCategory_LinkMethod["CLICK"] = 2] = "CLICK";
    PlatformCategory_LinkMethod[PlatformCategory_LinkMethod["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(PlatformCategory_LinkMethod || (PlatformCategory_LinkMethod = {}));
function platformCategory_LinkMethodFromJSON(object) {
    switch(object){
        case 0:
        case "LINK_METHOD_UNSPECIFIED":
            return PlatformCategory_LinkMethod.LINK_METHOD_UNSPECIFIED;
        case 1:
        case "QR_SCAN":
            return PlatformCategory_LinkMethod.QR_SCAN;
        case 2:
        case "CLICK":
            return PlatformCategory_LinkMethod.CLICK;
        case -1:
        case "UNRECOGNIZED":
        default:
            return PlatformCategory_LinkMethod.UNRECOGNIZED;
    }
}
function platformCategory_LinkMethodToJSON(object) {
    switch(object){
        case PlatformCategory_LinkMethod.LINK_METHOD_UNSPECIFIED:
            return "LINK_METHOD_UNSPECIFIED";
        case PlatformCategory_LinkMethod.QR_SCAN:
            return "QR_SCAN";
        case PlatformCategory_LinkMethod.CLICK:
            return "CLICK";
        case PlatformCategory_LinkMethod.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
function createBasePlatformCategory() {
    return {
        event: undefined
    };
}
var PlatformCategory = {
    fromJSON: function fromJSON(object) {
        return {
            event: platform_category_isSet(object.accordionClickEvent) ? {
                $case: "accordionClickEvent",
                accordionClickEvent: PlatformCategory_AccordionClickEvent.fromJSON(object.accordionClickEvent)
            } : platform_category_isSet(object.accordionViewEvent) ? {
                $case: "accordionViewEvent",
                accordionViewEvent: PlatformCategory_AccordionViewEvent.fromJSON(object.accordionViewEvent)
            } : platform_category_isSet(object.boxViewEvent) ? {
                $case: "boxViewEvent",
                boxViewEvent: PlatformCategory_BoxViewEvent.fromJSON(object.boxViewEvent)
            } : platform_category_isSet(object.buttonClickEvent) ? {
                $case: "buttonClickEvent",
                buttonClickEvent: PlatformCategory_ButtonClickEvent.fromJSON(object.buttonClickEvent)
            } : platform_category_isSet(object.buttonViewEvent) ? {
                $case: "buttonViewEvent",
                buttonViewEvent: PlatformCategory_ButtonViewEvent.fromJSON(object.buttonViewEvent)
            } : platform_category_isSet(object.cardViewEvent) ? {
                $case: "cardViewEvent",
                cardViewEvent: PlatformCategory_CardViewEvent.fromJSON(object.cardViewEvent)
            } : platform_category_isSet(object.checkboxClickEvent) ? {
                $case: "checkboxClickEvent",
                checkboxClickEvent: PlatformCategory_CheckboxClickEvent.fromJSON(object.checkboxClickEvent)
            } : platform_category_isSet(object.checkboxViewEvent) ? {
                $case: "checkboxViewEvent",
                checkboxViewEvent: PlatformCategory_CheckboxViewEvent.fromJSON(object.checkboxViewEvent)
            } : platform_category_isSet(object.imageViewEvent) ? {
                $case: "imageViewEvent",
                imageViewEvent: PlatformCategory_ImageViewEvent.fromJSON(object.imageViewEvent)
            } : platform_category_isSet(object.inputViewEvent) ? {
                $case: "inputViewEvent",
                inputViewEvent: PlatformCategory_InputViewEvent.fromJSON(object.inputViewEvent)
            } : platform_category_isSet(object.linkClickEvent) ? {
                $case: "linkClickEvent",
                linkClickEvent: PlatformCategory_LinkClickEvent.fromJSON(object.linkClickEvent)
            } : platform_category_isSet(object.linkViewEvent) ? {
                $case: "linkViewEvent",
                linkViewEvent: PlatformCategory_LinkViewEvent.fromJSON(object.linkViewEvent)
            } : platform_category_isSet(object.radioClickEvent) ? {
                $case: "radioClickEvent",
                radioClickEvent: PlatformCategory_RadioClickEvent.fromJSON(object.radioClickEvent)
            } : platform_category_isSet(object.radioViewEvent) ? {
                $case: "radioViewEvent",
                radioViewEvent: PlatformCategory_RadioViewEvent.fromJSON(object.radioViewEvent)
            } : platform_category_isSet(object.textViewEvent) ? {
                $case: "textViewEvent",
                textViewEvent: PlatformCategory_TextViewEvent.fromJSON(object.textViewEvent)
            } : platform_category_isSet(object.pageViewEvent) ? {
                $case: "pageViewEvent",
                pageViewEvent: PlatformCategory_PageViewEvent.fromJSON(object.pageViewEvent)
            } : platform_category_isSet(object.pageLoadedEvent) ? {
                $case: "pageLoadedEvent",
                pageLoadedEvent: PlatformCategory_PageLoadedEvent.fromJSON(object.pageLoadedEvent)
            } : platform_category_isSet(object.screenViewEvent) ? {
                $case: "screenViewEvent",
                screenViewEvent: PlatformCategory_ScreenViewEvent.fromJSON(object.screenViewEvent)
            } : platform_category_isSet(object.customerOneTimeExperienceEvent) ? {
                $case: "customerOneTimeExperienceEvent",
                customerOneTimeExperienceEvent: PlatformCategory_CustomerOneTimeExperienceEvent.fromJSON(object.customerOneTimeExperienceEvent)
            } : platform_category_isSet(object.leadOneTimeExperienceEvent) ? {
                $case: "leadOneTimeExperienceEvent",
                leadOneTimeExperienceEvent: PlatformCategory_LeadOneTimeExperienceEvent.fromJSON(object.leadOneTimeExperienceEvent)
            } : platform_category_isSet(object.customerUnsubscribeEvent) ? {
                $case: "customerUnsubscribeEvent",
                customerUnsubscribeEvent: PlatformCategory_CustomerUnsubscribeEvent.fromJSON(object.customerUnsubscribeEvent)
            } : platform_category_isSet(object.sessionStartEvent) ? {
                $case: "sessionStartEvent",
                sessionStartEvent: PlatformCategory_SessionStartEvent.fromJSON(object.sessionStartEvent)
            } : platform_category_isSet(object.sessionEndEvent) ? {
                $case: "sessionEndEvent",
                sessionEndEvent: PlatformCategory_SessionEndEvent.fromJSON(object.sessionEndEvent)
            } : platform_category_isSet(object.initialPageViewEvent) ? {
                $case: "initialPageViewEvent",
                initialPageViewEvent: PlatformCategory_InitialPageViewEvent.fromJSON(object.initialPageViewEvent)
            } : platform_category_isSet(object.appLaunchedEvent) ? {
                $case: "appLaunchedEvent",
                appLaunchedEvent: PlatformCategory_AppLaunchedEvent.fromJSON(object.appLaunchedEvent)
            } : platform_category_isSet(object.appForegroundedEvent) ? {
                $case: "appForegroundedEvent",
                appForegroundedEvent: PlatformCategory_AppForegroundedEvent.fromJSON(object.appForegroundedEvent)
            } : platform_category_isSet(object.appBackgroundedEvent) ? {
                $case: "appBackgroundedEvent",
                appBackgroundedEvent: PlatformCategory_AppBackgroundedEvent.fromJSON(object.appBackgroundedEvent)
            } : platform_category_isSet(object.appDownloadLinkEvent) ? {
                $case: "appDownloadLinkEvent",
                appDownloadLinkEvent: PlatformCategory_AppDownloadLinkEvent.fromJSON(object.appDownloadLinkEvent)
            } : platform_category_isSet(object.inputFocusEvent) ? {
                $case: "inputFocusEvent",
                inputFocusEvent: PlatformCategory_InputFocusEvent.fromJSON(object.inputFocusEvent)
            } : undefined
        };
    },
    toJSON: function toJSON(message) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28;
        var obj = {};
        if (((ref = message.event) === null || ref === void 0 ? void 0 : ref.$case) === "accordionClickEvent") {
            obj.accordionClickEvent = PlatformCategory_AccordionClickEvent.toJSON(message.event.accordionClickEvent);
        }
        if (((ref1 = message.event) === null || ref1 === void 0 ? void 0 : ref1.$case) === "accordionViewEvent") {
            obj.accordionViewEvent = PlatformCategory_AccordionViewEvent.toJSON(message.event.accordionViewEvent);
        }
        if (((ref2 = message.event) === null || ref2 === void 0 ? void 0 : ref2.$case) === "boxViewEvent") {
            obj.boxViewEvent = PlatformCategory_BoxViewEvent.toJSON(message.event.boxViewEvent);
        }
        if (((ref3 = message.event) === null || ref3 === void 0 ? void 0 : ref3.$case) === "buttonClickEvent") {
            obj.buttonClickEvent = PlatformCategory_ButtonClickEvent.toJSON(message.event.buttonClickEvent);
        }
        if (((ref4 = message.event) === null || ref4 === void 0 ? void 0 : ref4.$case) === "buttonViewEvent") {
            obj.buttonViewEvent = PlatformCategory_ButtonViewEvent.toJSON(message.event.buttonViewEvent);
        }
        if (((ref5 = message.event) === null || ref5 === void 0 ? void 0 : ref5.$case) === "cardViewEvent") {
            obj.cardViewEvent = PlatformCategory_CardViewEvent.toJSON(message.event.cardViewEvent);
        }
        if (((ref6 = message.event) === null || ref6 === void 0 ? void 0 : ref6.$case) === "checkboxClickEvent") {
            obj.checkboxClickEvent = PlatformCategory_CheckboxClickEvent.toJSON(message.event.checkboxClickEvent);
        }
        if (((ref7 = message.event) === null || ref7 === void 0 ? void 0 : ref7.$case) === "checkboxViewEvent") {
            obj.checkboxViewEvent = PlatformCategory_CheckboxViewEvent.toJSON(message.event.checkboxViewEvent);
        }
        if (((ref8 = message.event) === null || ref8 === void 0 ? void 0 : ref8.$case) === "imageViewEvent") {
            obj.imageViewEvent = PlatformCategory_ImageViewEvent.toJSON(message.event.imageViewEvent);
        }
        if (((ref9 = message.event) === null || ref9 === void 0 ? void 0 : ref9.$case) === "inputViewEvent") {
            obj.inputViewEvent = PlatformCategory_InputViewEvent.toJSON(message.event.inputViewEvent);
        }
        if (((ref10 = message.event) === null || ref10 === void 0 ? void 0 : ref10.$case) === "linkClickEvent") {
            obj.linkClickEvent = PlatformCategory_LinkClickEvent.toJSON(message.event.linkClickEvent);
        }
        if (((ref11 = message.event) === null || ref11 === void 0 ? void 0 : ref11.$case) === "linkViewEvent") {
            obj.linkViewEvent = PlatformCategory_LinkViewEvent.toJSON(message.event.linkViewEvent);
        }
        if (((ref12 = message.event) === null || ref12 === void 0 ? void 0 : ref12.$case) === "radioClickEvent") {
            obj.radioClickEvent = PlatformCategory_RadioClickEvent.toJSON(message.event.radioClickEvent);
        }
        if (((ref13 = message.event) === null || ref13 === void 0 ? void 0 : ref13.$case) === "radioViewEvent") {
            obj.radioViewEvent = PlatformCategory_RadioViewEvent.toJSON(message.event.radioViewEvent);
        }
        if (((ref14 = message.event) === null || ref14 === void 0 ? void 0 : ref14.$case) === "textViewEvent") {
            obj.textViewEvent = PlatformCategory_TextViewEvent.toJSON(message.event.textViewEvent);
        }
        if (((ref15 = message.event) === null || ref15 === void 0 ? void 0 : ref15.$case) === "pageViewEvent") {
            obj.pageViewEvent = PlatformCategory_PageViewEvent.toJSON(message.event.pageViewEvent);
        }
        if (((ref16 = message.event) === null || ref16 === void 0 ? void 0 : ref16.$case) === "pageLoadedEvent") {
            obj.pageLoadedEvent = PlatformCategory_PageLoadedEvent.toJSON(message.event.pageLoadedEvent);
        }
        if (((ref17 = message.event) === null || ref17 === void 0 ? void 0 : ref17.$case) === "screenViewEvent") {
            obj.screenViewEvent = PlatformCategory_ScreenViewEvent.toJSON(message.event.screenViewEvent);
        }
        if (((ref18 = message.event) === null || ref18 === void 0 ? void 0 : ref18.$case) === "customerOneTimeExperienceEvent") {
            obj.customerOneTimeExperienceEvent = PlatformCategory_CustomerOneTimeExperienceEvent.toJSON(message.event.customerOneTimeExperienceEvent);
        }
        if (((ref19 = message.event) === null || ref19 === void 0 ? void 0 : ref19.$case) === "leadOneTimeExperienceEvent") {
            obj.leadOneTimeExperienceEvent = PlatformCategory_LeadOneTimeExperienceEvent.toJSON(message.event.leadOneTimeExperienceEvent);
        }
        if (((ref20 = message.event) === null || ref20 === void 0 ? void 0 : ref20.$case) === "customerUnsubscribeEvent") {
            obj.customerUnsubscribeEvent = PlatformCategory_CustomerUnsubscribeEvent.toJSON(message.event.customerUnsubscribeEvent);
        }
        if (((ref21 = message.event) === null || ref21 === void 0 ? void 0 : ref21.$case) === "sessionStartEvent") {
            obj.sessionStartEvent = PlatformCategory_SessionStartEvent.toJSON(message.event.sessionStartEvent);
        }
        if (((ref22 = message.event) === null || ref22 === void 0 ? void 0 : ref22.$case) === "sessionEndEvent") {
            obj.sessionEndEvent = PlatformCategory_SessionEndEvent.toJSON(message.event.sessionEndEvent);
        }
        if (((ref23 = message.event) === null || ref23 === void 0 ? void 0 : ref23.$case) === "initialPageViewEvent") {
            obj.initialPageViewEvent = PlatformCategory_InitialPageViewEvent.toJSON(message.event.initialPageViewEvent);
        }
        if (((ref24 = message.event) === null || ref24 === void 0 ? void 0 : ref24.$case) === "appLaunchedEvent") {
            obj.appLaunchedEvent = PlatformCategory_AppLaunchedEvent.toJSON(message.event.appLaunchedEvent);
        }
        if (((ref25 = message.event) === null || ref25 === void 0 ? void 0 : ref25.$case) === "appForegroundedEvent") {
            obj.appForegroundedEvent = PlatformCategory_AppForegroundedEvent.toJSON(message.event.appForegroundedEvent);
        }
        if (((ref26 = message.event) === null || ref26 === void 0 ? void 0 : ref26.$case) === "appBackgroundedEvent") {
            obj.appBackgroundedEvent = PlatformCategory_AppBackgroundedEvent.toJSON(message.event.appBackgroundedEvent);
        }
        if (((ref27 = message.event) === null || ref27 === void 0 ? void 0 : ref27.$case) === "appDownloadLinkEvent") {
            obj.appDownloadLinkEvent = PlatformCategory_AppDownloadLinkEvent.toJSON(message.event.appDownloadLinkEvent);
        }
        if (((ref28 = message.event) === null || ref28 === void 0 ? void 0 : ref28.$case) === "inputFocusEvent") {
            obj.inputFocusEvent = PlatformCategory_InputFocusEvent.toJSON(message.event.inputFocusEvent);
        }
        return obj;
    },
    create: function create(base) {
        return PlatformCategory.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40, ref41, ref42, ref43, ref44, ref45, ref46, ref47, ref48, ref49, ref50, ref51, ref52, ref53, ref54, ref55, ref56, ref57, ref58, ref59, ref60, ref61, ref62, ref63, ref64, ref65, ref66, ref67, ref68, ref69, ref70, ref71, ref72, ref73, ref74, ref75, ref76, ref77, ref78, ref79, ref80, ref81, ref82, ref83, ref84, ref85, ref86;
        var message = createBasePlatformCategory();
        if (((ref = object.event) === null || ref === void 0 ? void 0 : ref.$case) === "accordionClickEvent" && ((ref1 = object.event) === null || ref1 === void 0 ? void 0 : ref1.accordionClickEvent) !== undefined && ((ref2 = object.event) === null || ref2 === void 0 ? void 0 : ref2.accordionClickEvent) !== null) {
            message.event = {
                $case: "accordionClickEvent",
                accordionClickEvent: PlatformCategory_AccordionClickEvent.fromPartial(object.event.accordionClickEvent)
            };
        }
        if (((ref3 = object.event) === null || ref3 === void 0 ? void 0 : ref3.$case) === "accordionViewEvent" && ((ref4 = object.event) === null || ref4 === void 0 ? void 0 : ref4.accordionViewEvent) !== undefined && ((ref5 = object.event) === null || ref5 === void 0 ? void 0 : ref5.accordionViewEvent) !== null) {
            message.event = {
                $case: "accordionViewEvent",
                accordionViewEvent: PlatformCategory_AccordionViewEvent.fromPartial(object.event.accordionViewEvent)
            };
        }
        if (((ref6 = object.event) === null || ref6 === void 0 ? void 0 : ref6.$case) === "boxViewEvent" && ((ref7 = object.event) === null || ref7 === void 0 ? void 0 : ref7.boxViewEvent) !== undefined && ((ref8 = object.event) === null || ref8 === void 0 ? void 0 : ref8.boxViewEvent) !== null) {
            message.event = {
                $case: "boxViewEvent",
                boxViewEvent: PlatformCategory_BoxViewEvent.fromPartial(object.event.boxViewEvent)
            };
        }
        if (((ref9 = object.event) === null || ref9 === void 0 ? void 0 : ref9.$case) === "buttonClickEvent" && ((ref10 = object.event) === null || ref10 === void 0 ? void 0 : ref10.buttonClickEvent) !== undefined && ((ref11 = object.event) === null || ref11 === void 0 ? void 0 : ref11.buttonClickEvent) !== null) {
            message.event = {
                $case: "buttonClickEvent",
                buttonClickEvent: PlatformCategory_ButtonClickEvent.fromPartial(object.event.buttonClickEvent)
            };
        }
        if (((ref12 = object.event) === null || ref12 === void 0 ? void 0 : ref12.$case) === "buttonViewEvent" && ((ref13 = object.event) === null || ref13 === void 0 ? void 0 : ref13.buttonViewEvent) !== undefined && ((ref14 = object.event) === null || ref14 === void 0 ? void 0 : ref14.buttonViewEvent) !== null) {
            message.event = {
                $case: "buttonViewEvent",
                buttonViewEvent: PlatformCategory_ButtonViewEvent.fromPartial(object.event.buttonViewEvent)
            };
        }
        if (((ref15 = object.event) === null || ref15 === void 0 ? void 0 : ref15.$case) === "cardViewEvent" && ((ref16 = object.event) === null || ref16 === void 0 ? void 0 : ref16.cardViewEvent) !== undefined && ((ref17 = object.event) === null || ref17 === void 0 ? void 0 : ref17.cardViewEvent) !== null) {
            message.event = {
                $case: "cardViewEvent",
                cardViewEvent: PlatformCategory_CardViewEvent.fromPartial(object.event.cardViewEvent)
            };
        }
        if (((ref18 = object.event) === null || ref18 === void 0 ? void 0 : ref18.$case) === "checkboxClickEvent" && ((ref19 = object.event) === null || ref19 === void 0 ? void 0 : ref19.checkboxClickEvent) !== undefined && ((ref20 = object.event) === null || ref20 === void 0 ? void 0 : ref20.checkboxClickEvent) !== null) {
            message.event = {
                $case: "checkboxClickEvent",
                checkboxClickEvent: PlatformCategory_CheckboxClickEvent.fromPartial(object.event.checkboxClickEvent)
            };
        }
        if (((ref21 = object.event) === null || ref21 === void 0 ? void 0 : ref21.$case) === "checkboxViewEvent" && ((ref22 = object.event) === null || ref22 === void 0 ? void 0 : ref22.checkboxViewEvent) !== undefined && ((ref23 = object.event) === null || ref23 === void 0 ? void 0 : ref23.checkboxViewEvent) !== null) {
            message.event = {
                $case: "checkboxViewEvent",
                checkboxViewEvent: PlatformCategory_CheckboxViewEvent.fromPartial(object.event.checkboxViewEvent)
            };
        }
        if (((ref24 = object.event) === null || ref24 === void 0 ? void 0 : ref24.$case) === "imageViewEvent" && ((ref25 = object.event) === null || ref25 === void 0 ? void 0 : ref25.imageViewEvent) !== undefined && ((ref26 = object.event) === null || ref26 === void 0 ? void 0 : ref26.imageViewEvent) !== null) {
            message.event = {
                $case: "imageViewEvent",
                imageViewEvent: PlatformCategory_ImageViewEvent.fromPartial(object.event.imageViewEvent)
            };
        }
        if (((ref27 = object.event) === null || ref27 === void 0 ? void 0 : ref27.$case) === "inputViewEvent" && ((ref28 = object.event) === null || ref28 === void 0 ? void 0 : ref28.inputViewEvent) !== undefined && ((ref29 = object.event) === null || ref29 === void 0 ? void 0 : ref29.inputViewEvent) !== null) {
            message.event = {
                $case: "inputViewEvent",
                inputViewEvent: PlatformCategory_InputViewEvent.fromPartial(object.event.inputViewEvent)
            };
        }
        if (((ref30 = object.event) === null || ref30 === void 0 ? void 0 : ref30.$case) === "linkClickEvent" && ((ref31 = object.event) === null || ref31 === void 0 ? void 0 : ref31.linkClickEvent) !== undefined && ((ref32 = object.event) === null || ref32 === void 0 ? void 0 : ref32.linkClickEvent) !== null) {
            message.event = {
                $case: "linkClickEvent",
                linkClickEvent: PlatformCategory_LinkClickEvent.fromPartial(object.event.linkClickEvent)
            };
        }
        if (((ref33 = object.event) === null || ref33 === void 0 ? void 0 : ref33.$case) === "linkViewEvent" && ((ref34 = object.event) === null || ref34 === void 0 ? void 0 : ref34.linkViewEvent) !== undefined && ((ref35 = object.event) === null || ref35 === void 0 ? void 0 : ref35.linkViewEvent) !== null) {
            message.event = {
                $case: "linkViewEvent",
                linkViewEvent: PlatformCategory_LinkViewEvent.fromPartial(object.event.linkViewEvent)
            };
        }
        if (((ref36 = object.event) === null || ref36 === void 0 ? void 0 : ref36.$case) === "radioClickEvent" && ((ref37 = object.event) === null || ref37 === void 0 ? void 0 : ref37.radioClickEvent) !== undefined && ((ref38 = object.event) === null || ref38 === void 0 ? void 0 : ref38.radioClickEvent) !== null) {
            message.event = {
                $case: "radioClickEvent",
                radioClickEvent: PlatformCategory_RadioClickEvent.fromPartial(object.event.radioClickEvent)
            };
        }
        if (((ref39 = object.event) === null || ref39 === void 0 ? void 0 : ref39.$case) === "radioViewEvent" && ((ref40 = object.event) === null || ref40 === void 0 ? void 0 : ref40.radioViewEvent) !== undefined && ((ref41 = object.event) === null || ref41 === void 0 ? void 0 : ref41.radioViewEvent) !== null) {
            message.event = {
                $case: "radioViewEvent",
                radioViewEvent: PlatformCategory_RadioViewEvent.fromPartial(object.event.radioViewEvent)
            };
        }
        if (((ref42 = object.event) === null || ref42 === void 0 ? void 0 : ref42.$case) === "textViewEvent" && ((ref43 = object.event) === null || ref43 === void 0 ? void 0 : ref43.textViewEvent) !== undefined && ((ref44 = object.event) === null || ref44 === void 0 ? void 0 : ref44.textViewEvent) !== null) {
            message.event = {
                $case: "textViewEvent",
                textViewEvent: PlatformCategory_TextViewEvent.fromPartial(object.event.textViewEvent)
            };
        }
        if (((ref45 = object.event) === null || ref45 === void 0 ? void 0 : ref45.$case) === "pageViewEvent" && ((ref46 = object.event) === null || ref46 === void 0 ? void 0 : ref46.pageViewEvent) !== undefined && ((ref47 = object.event) === null || ref47 === void 0 ? void 0 : ref47.pageViewEvent) !== null) {
            message.event = {
                $case: "pageViewEvent",
                pageViewEvent: PlatformCategory_PageViewEvent.fromPartial(object.event.pageViewEvent)
            };
        }
        if (((ref48 = object.event) === null || ref48 === void 0 ? void 0 : ref48.$case) === "pageLoadedEvent" && ((ref49 = object.event) === null || ref49 === void 0 ? void 0 : ref49.pageLoadedEvent) !== undefined && ((ref50 = object.event) === null || ref50 === void 0 ? void 0 : ref50.pageLoadedEvent) !== null) {
            message.event = {
                $case: "pageLoadedEvent",
                pageLoadedEvent: PlatformCategory_PageLoadedEvent.fromPartial(object.event.pageLoadedEvent)
            };
        }
        if (((ref51 = object.event) === null || ref51 === void 0 ? void 0 : ref51.$case) === "screenViewEvent" && ((ref52 = object.event) === null || ref52 === void 0 ? void 0 : ref52.screenViewEvent) !== undefined && ((ref53 = object.event) === null || ref53 === void 0 ? void 0 : ref53.screenViewEvent) !== null) {
            message.event = {
                $case: "screenViewEvent",
                screenViewEvent: PlatformCategory_ScreenViewEvent.fromPartial(object.event.screenViewEvent)
            };
        }
        if (((ref54 = object.event) === null || ref54 === void 0 ? void 0 : ref54.$case) === "customerOneTimeExperienceEvent" && ((ref55 = object.event) === null || ref55 === void 0 ? void 0 : ref55.customerOneTimeExperienceEvent) !== undefined && ((ref56 = object.event) === null || ref56 === void 0 ? void 0 : ref56.customerOneTimeExperienceEvent) !== null) {
            message.event = {
                $case: "customerOneTimeExperienceEvent",
                customerOneTimeExperienceEvent: PlatformCategory_CustomerOneTimeExperienceEvent.fromPartial(object.event.customerOneTimeExperienceEvent)
            };
        }
        if (((ref57 = object.event) === null || ref57 === void 0 ? void 0 : ref57.$case) === "leadOneTimeExperienceEvent" && ((ref58 = object.event) === null || ref58 === void 0 ? void 0 : ref58.leadOneTimeExperienceEvent) !== undefined && ((ref59 = object.event) === null || ref59 === void 0 ? void 0 : ref59.leadOneTimeExperienceEvent) !== null) {
            message.event = {
                $case: "leadOneTimeExperienceEvent",
                leadOneTimeExperienceEvent: PlatformCategory_LeadOneTimeExperienceEvent.fromPartial(object.event.leadOneTimeExperienceEvent)
            };
        }
        if (((ref60 = object.event) === null || ref60 === void 0 ? void 0 : ref60.$case) === "customerUnsubscribeEvent" && ((ref61 = object.event) === null || ref61 === void 0 ? void 0 : ref61.customerUnsubscribeEvent) !== undefined && ((ref62 = object.event) === null || ref62 === void 0 ? void 0 : ref62.customerUnsubscribeEvent) !== null) {
            message.event = {
                $case: "customerUnsubscribeEvent",
                customerUnsubscribeEvent: PlatformCategory_CustomerUnsubscribeEvent.fromPartial(object.event.customerUnsubscribeEvent)
            };
        }
        if (((ref63 = object.event) === null || ref63 === void 0 ? void 0 : ref63.$case) === "sessionStartEvent" && ((ref64 = object.event) === null || ref64 === void 0 ? void 0 : ref64.sessionStartEvent) !== undefined && ((ref65 = object.event) === null || ref65 === void 0 ? void 0 : ref65.sessionStartEvent) !== null) {
            message.event = {
                $case: "sessionStartEvent",
                sessionStartEvent: PlatformCategory_SessionStartEvent.fromPartial(object.event.sessionStartEvent)
            };
        }
        if (((ref66 = object.event) === null || ref66 === void 0 ? void 0 : ref66.$case) === "sessionEndEvent" && ((ref67 = object.event) === null || ref67 === void 0 ? void 0 : ref67.sessionEndEvent) !== undefined && ((ref68 = object.event) === null || ref68 === void 0 ? void 0 : ref68.sessionEndEvent) !== null) {
            message.event = {
                $case: "sessionEndEvent",
                sessionEndEvent: PlatformCategory_SessionEndEvent.fromPartial(object.event.sessionEndEvent)
            };
        }
        if (((ref69 = object.event) === null || ref69 === void 0 ? void 0 : ref69.$case) === "initialPageViewEvent" && ((ref70 = object.event) === null || ref70 === void 0 ? void 0 : ref70.initialPageViewEvent) !== undefined && ((ref71 = object.event) === null || ref71 === void 0 ? void 0 : ref71.initialPageViewEvent) !== null) {
            message.event = {
                $case: "initialPageViewEvent",
                initialPageViewEvent: PlatformCategory_InitialPageViewEvent.fromPartial(object.event.initialPageViewEvent)
            };
        }
        if (((ref72 = object.event) === null || ref72 === void 0 ? void 0 : ref72.$case) === "appLaunchedEvent" && ((ref73 = object.event) === null || ref73 === void 0 ? void 0 : ref73.appLaunchedEvent) !== undefined && ((ref74 = object.event) === null || ref74 === void 0 ? void 0 : ref74.appLaunchedEvent) !== null) {
            message.event = {
                $case: "appLaunchedEvent",
                appLaunchedEvent: PlatformCategory_AppLaunchedEvent.fromPartial(object.event.appLaunchedEvent)
            };
        }
        if (((ref75 = object.event) === null || ref75 === void 0 ? void 0 : ref75.$case) === "appForegroundedEvent" && ((ref76 = object.event) === null || ref76 === void 0 ? void 0 : ref76.appForegroundedEvent) !== undefined && ((ref77 = object.event) === null || ref77 === void 0 ? void 0 : ref77.appForegroundedEvent) !== null) {
            message.event = {
                $case: "appForegroundedEvent",
                appForegroundedEvent: PlatformCategory_AppForegroundedEvent.fromPartial(object.event.appForegroundedEvent)
            };
        }
        if (((ref78 = object.event) === null || ref78 === void 0 ? void 0 : ref78.$case) === "appBackgroundedEvent" && ((ref79 = object.event) === null || ref79 === void 0 ? void 0 : ref79.appBackgroundedEvent) !== undefined && ((ref80 = object.event) === null || ref80 === void 0 ? void 0 : ref80.appBackgroundedEvent) !== null) {
            message.event = {
                $case: "appBackgroundedEvent",
                appBackgroundedEvent: PlatformCategory_AppBackgroundedEvent.fromPartial(object.event.appBackgroundedEvent)
            };
        }
        if (((ref81 = object.event) === null || ref81 === void 0 ? void 0 : ref81.$case) === "appDownloadLinkEvent" && ((ref82 = object.event) === null || ref82 === void 0 ? void 0 : ref82.appDownloadLinkEvent) !== undefined && ((ref83 = object.event) === null || ref83 === void 0 ? void 0 : ref83.appDownloadLinkEvent) !== null) {
            message.event = {
                $case: "appDownloadLinkEvent",
                appDownloadLinkEvent: PlatformCategory_AppDownloadLinkEvent.fromPartial(object.event.appDownloadLinkEvent)
            };
        }
        if (((ref84 = object.event) === null || ref84 === void 0 ? void 0 : ref84.$case) === "inputFocusEvent" && ((ref85 = object.event) === null || ref85 === void 0 ? void 0 : ref85.inputFocusEvent) !== undefined && ((ref86 = object.event) === null || ref86 === void 0 ? void 0 : ref86.inputFocusEvent) !== null) {
            message.event = {
                $case: "inputFocusEvent",
                inputFocusEvent: PlatformCategory_InputFocusEvent.fromPartial(object.event.inputFocusEvent)
            };
        }
        return message;
    }
};
function createBasePlatformCategory_AppDownloadLinkEvent() {
    return {
        devicePlatform: 0,
        linkMethod: 0
    };
}
var PlatformCategory_AppDownloadLinkEvent = {
    fromJSON: function fromJSON(object) {
        return {
            devicePlatform: platform_category_isSet(object.devicePlatform) ? platformCategory_DevicePlatformFromJSON(object.devicePlatform) : 0,
            linkMethod: platform_category_isSet(object.linkMethod) ? platformCategory_LinkMethodFromJSON(object.linkMethod) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.devicePlatform !== 0) {
            obj.devicePlatform = platformCategory_DevicePlatformToJSON(message.devicePlatform);
        }
        if (message.linkMethod !== 0) {
            obj.linkMethod = platformCategory_LinkMethodToJSON(message.linkMethod);
        }
        return obj;
    },
    create: function create(base) {
        return PlatformCategory_AppDownloadLinkEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBasePlatformCategory_AppDownloadLinkEvent();
        var _devicePlatform;
        message.devicePlatform = (_devicePlatform = object.devicePlatform) !== null && _devicePlatform !== void 0 ? _devicePlatform : 0;
        var _linkMethod;
        message.linkMethod = (_linkMethod = object.linkMethod) !== null && _linkMethod !== void 0 ? _linkMethod : 0;
        return message;
    }
};
function createBasePlatformCategory_AccordionClickEvent() {
    return {
        targetName: "",
        accordionName: ""
    };
}
var PlatformCategory_AccordionClickEvent = {
    fromJSON: function fromJSON(object) {
        return {
            targetName: platform_category_isSet(object.targetName) ? String(object.targetName) : "",
            accordionName: platform_category_isSet(object.accordionName) ? String(object.accordionName) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.targetName !== "") {
            obj.targetName = message.targetName;
        }
        if (message.accordionName !== "") {
            obj.accordionName = message.accordionName;
        }
        return obj;
    },
    create: function create(base) {
        return PlatformCategory_AccordionClickEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBasePlatformCategory_AccordionClickEvent();
        var _targetName;
        message.targetName = (_targetName = object.targetName) !== null && _targetName !== void 0 ? _targetName : "";
        var _accordionName;
        message.accordionName = (_accordionName = object.accordionName) !== null && _accordionName !== void 0 ? _accordionName : "";
        return message;
    }
};
function createBasePlatformCategory_AccordionViewEvent() {
    return {
        targetName: ""
    };
}
var PlatformCategory_AccordionViewEvent = {
    fromJSON: function fromJSON(object) {
        return {
            targetName: platform_category_isSet(object.targetName) ? String(object.targetName) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.targetName !== "") {
            obj.targetName = message.targetName;
        }
        return obj;
    },
    create: function create(base) {
        return PlatformCategory_AccordionViewEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBasePlatformCategory_AccordionViewEvent();
        var _targetName;
        message.targetName = (_targetName = object.targetName) !== null && _targetName !== void 0 ? _targetName : "";
        return message;
    }
};
function createBasePlatformCategory_BoxViewEvent() {
    return {
        targetName: ""
    };
}
var PlatformCategory_BoxViewEvent = {
    fromJSON: function fromJSON(object) {
        return {
            targetName: platform_category_isSet(object.targetName) ? String(object.targetName) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.targetName !== "") {
            obj.targetName = message.targetName;
        }
        return obj;
    },
    create: function create(base) {
        return PlatformCategory_BoxViewEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBasePlatformCategory_BoxViewEvent();
        var _targetName;
        message.targetName = (_targetName = object.targetName) !== null && _targetName !== void 0 ? _targetName : "";
        return message;
    }
};
function createBasePlatformCategory_ButtonClickEvent() {
    return {
        targetName: ""
    };
}
var PlatformCategory_ButtonClickEvent = {
    fromJSON: function fromJSON(object) {
        return {
            targetName: platform_category_isSet(object.targetName) ? String(object.targetName) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.targetName !== "") {
            obj.targetName = message.targetName;
        }
        return obj;
    },
    create: function create(base) {
        return PlatformCategory_ButtonClickEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBasePlatformCategory_ButtonClickEvent();
        var _targetName;
        message.targetName = (_targetName = object.targetName) !== null && _targetName !== void 0 ? _targetName : "";
        return message;
    }
};
function createBasePlatformCategory_ButtonViewEvent() {
    return {
        targetName: ""
    };
}
var PlatformCategory_ButtonViewEvent = {
    fromJSON: function fromJSON(object) {
        return {
            targetName: platform_category_isSet(object.targetName) ? String(object.targetName) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.targetName !== "") {
            obj.targetName = message.targetName;
        }
        return obj;
    },
    create: function create(base) {
        return PlatformCategory_ButtonViewEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBasePlatformCategory_ButtonViewEvent();
        var _targetName;
        message.targetName = (_targetName = object.targetName) !== null && _targetName !== void 0 ? _targetName : "";
        return message;
    }
};
function createBasePlatformCategory_CardViewEvent() {
    return {
        targetName: ""
    };
}
var PlatformCategory_CardViewEvent = {
    fromJSON: function fromJSON(object) {
        return {
            targetName: platform_category_isSet(object.targetName) ? String(object.targetName) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.targetName !== "") {
            obj.targetName = message.targetName;
        }
        return obj;
    },
    create: function create(base) {
        return PlatformCategory_CardViewEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBasePlatformCategory_CardViewEvent();
        var _targetName;
        message.targetName = (_targetName = object.targetName) !== null && _targetName !== void 0 ? _targetName : "";
        return message;
    }
};
function createBasePlatformCategory_CheckboxClickEvent() {
    return {
        targetName: "",
        optionName: ""
    };
}
var PlatformCategory_CheckboxClickEvent = {
    fromJSON: function fromJSON(object) {
        return {
            targetName: platform_category_isSet(object.targetName) ? String(object.targetName) : "",
            optionName: platform_category_isSet(object.optionName) ? String(object.optionName) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.targetName !== "") {
            obj.targetName = message.targetName;
        }
        if (message.optionName !== "") {
            obj.optionName = message.optionName;
        }
        return obj;
    },
    create: function create(base) {
        return PlatformCategory_CheckboxClickEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBasePlatformCategory_CheckboxClickEvent();
        var _targetName;
        message.targetName = (_targetName = object.targetName) !== null && _targetName !== void 0 ? _targetName : "";
        var _optionName;
        message.optionName = (_optionName = object.optionName) !== null && _optionName !== void 0 ? _optionName : "";
        return message;
    }
};
function createBasePlatformCategory_CheckboxViewEvent() {
    return {
        targetName: ""
    };
}
var PlatformCategory_CheckboxViewEvent = {
    fromJSON: function fromJSON(object) {
        return {
            targetName: platform_category_isSet(object.targetName) ? String(object.targetName) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.targetName !== "") {
            obj.targetName = message.targetName;
        }
        return obj;
    },
    create: function create(base) {
        return PlatformCategory_CheckboxViewEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBasePlatformCategory_CheckboxViewEvent();
        var _targetName;
        message.targetName = (_targetName = object.targetName) !== null && _targetName !== void 0 ? _targetName : "";
        return message;
    }
};
function createBasePlatformCategory_ImageViewEvent() {
    return {
        targetName: ""
    };
}
var PlatformCategory_ImageViewEvent = {
    fromJSON: function fromJSON(object) {
        return {
            targetName: platform_category_isSet(object.targetName) ? String(object.targetName) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.targetName !== "") {
            obj.targetName = message.targetName;
        }
        return obj;
    },
    create: function create(base) {
        return PlatformCategory_ImageViewEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBasePlatformCategory_ImageViewEvent();
        var _targetName;
        message.targetName = (_targetName = object.targetName) !== null && _targetName !== void 0 ? _targetName : "";
        return message;
    }
};
function createBasePlatformCategory_InputViewEvent() {
    return {
        targetName: ""
    };
}
var PlatformCategory_InputViewEvent = {
    fromJSON: function fromJSON(object) {
        return {
            targetName: platform_category_isSet(object.targetName) ? String(object.targetName) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.targetName !== "") {
            obj.targetName = message.targetName;
        }
        return obj;
    },
    create: function create(base) {
        return PlatformCategory_InputViewEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBasePlatformCategory_InputViewEvent();
        var _targetName;
        message.targetName = (_targetName = object.targetName) !== null && _targetName !== void 0 ? _targetName : "";
        return message;
    }
};
function createBasePlatformCategory_InputFocusEvent() {
    return {
        targetName: ""
    };
}
var PlatformCategory_InputFocusEvent = {
    fromJSON: function fromJSON(object) {
        return {
            targetName: platform_category_isSet(object.targetName) ? String(object.targetName) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.targetName !== "") {
            obj.targetName = message.targetName;
        }
        return obj;
    },
    create: function create(base) {
        return PlatformCategory_InputFocusEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBasePlatformCategory_InputFocusEvent();
        var _targetName;
        message.targetName = (_targetName = object.targetName) !== null && _targetName !== void 0 ? _targetName : "";
        return message;
    }
};
function createBasePlatformCategory_LinkClickEvent() {
    return {
        targetName: ""
    };
}
var PlatformCategory_LinkClickEvent = {
    fromJSON: function fromJSON(object) {
        return {
            targetName: platform_category_isSet(object.targetName) ? String(object.targetName) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.targetName !== "") {
            obj.targetName = message.targetName;
        }
        return obj;
    },
    create: function create(base) {
        return PlatformCategory_LinkClickEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBasePlatformCategory_LinkClickEvent();
        var _targetName;
        message.targetName = (_targetName = object.targetName) !== null && _targetName !== void 0 ? _targetName : "";
        return message;
    }
};
function createBasePlatformCategory_LinkViewEvent() {
    return {
        targetName: ""
    };
}
var PlatformCategory_LinkViewEvent = {
    fromJSON: function fromJSON(object) {
        return {
            targetName: platform_category_isSet(object.targetName) ? String(object.targetName) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.targetName !== "") {
            obj.targetName = message.targetName;
        }
        return obj;
    },
    create: function create(base) {
        return PlatformCategory_LinkViewEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBasePlatformCategory_LinkViewEvent();
        var _targetName;
        message.targetName = (_targetName = object.targetName) !== null && _targetName !== void 0 ? _targetName : "";
        return message;
    }
};
function createBasePlatformCategory_RadioClickEvent() {
    return {
        targetName: "",
        optionName: ""
    };
}
var PlatformCategory_RadioClickEvent = {
    fromJSON: function fromJSON(object) {
        return {
            targetName: platform_category_isSet(object.targetName) ? String(object.targetName) : "",
            optionName: platform_category_isSet(object.optionName) ? String(object.optionName) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.targetName !== "") {
            obj.targetName = message.targetName;
        }
        if (message.optionName !== "") {
            obj.optionName = message.optionName;
        }
        return obj;
    },
    create: function create(base) {
        return PlatformCategory_RadioClickEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBasePlatformCategory_RadioClickEvent();
        var _targetName;
        message.targetName = (_targetName = object.targetName) !== null && _targetName !== void 0 ? _targetName : "";
        var _optionName;
        message.optionName = (_optionName = object.optionName) !== null && _optionName !== void 0 ? _optionName : "";
        return message;
    }
};
function createBasePlatformCategory_RadioViewEvent() {
    return {
        targetName: ""
    };
}
var PlatformCategory_RadioViewEvent = {
    fromJSON: function fromJSON(object) {
        return {
            targetName: platform_category_isSet(object.targetName) ? String(object.targetName) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.targetName !== "") {
            obj.targetName = message.targetName;
        }
        return obj;
    },
    create: function create(base) {
        return PlatformCategory_RadioViewEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBasePlatformCategory_RadioViewEvent();
        var _targetName;
        message.targetName = (_targetName = object.targetName) !== null && _targetName !== void 0 ? _targetName : "";
        return message;
    }
};
function createBasePlatformCategory_TextViewEvent() {
    return {
        targetName: ""
    };
}
var PlatformCategory_TextViewEvent = {
    fromJSON: function fromJSON(object) {
        return {
            targetName: platform_category_isSet(object.targetName) ? String(object.targetName) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.targetName !== "") {
            obj.targetName = message.targetName;
        }
        return obj;
    },
    create: function create(base) {
        return PlatformCategory_TextViewEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBasePlatformCategory_TextViewEvent();
        var _targetName;
        message.targetName = (_targetName = object.targetName) !== null && _targetName !== void 0 ? _targetName : "";
        return message;
    }
};
function createBasePlatformCategory_PageViewEvent() {
    return {};
}
var PlatformCategory_PageViewEvent = {
    fromJSON: function fromJSON(_) {
        return {};
    },
    toJSON: function toJSON(_) {
        var obj = {};
        return obj;
    },
    create: function create(base) {
        return PlatformCategory_PageViewEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(_) {
        var message = createBasePlatformCategory_PageViewEvent();
        return message;
    }
};
function createBasePlatformCategory_PageLoadedEvent() {
    return {
        loadTimeMs: undefined,
        routerPath: undefined
    };
}
var PlatformCategory_PageLoadedEvent = {
    fromJSON: function fromJSON(object) {
        return {
            loadTimeMs: platform_category_isSet(object.loadTimeMs) ? Number(object.loadTimeMs) : undefined,
            routerPath: platform_category_isSet(object.routerPath) ? String(object.routerPath) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.loadTimeMs !== undefined) {
            obj.loadTimeMs = message.loadTimeMs;
        }
        if (message.routerPath !== undefined) {
            obj.routerPath = message.routerPath;
        }
        return obj;
    },
    create: function create(base) {
        return PlatformCategory_PageLoadedEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBasePlatformCategory_PageLoadedEvent();
        var _loadTimeMs;
        message.loadTimeMs = (_loadTimeMs = object.loadTimeMs) !== null && _loadTimeMs !== void 0 ? _loadTimeMs : undefined;
        var _routerPath;
        message.routerPath = (_routerPath = object.routerPath) !== null && _routerPath !== void 0 ? _routerPath : undefined;
        return message;
    }
};
function createBasePlatformCategory_ScreenViewEvent() {
    return {};
}
var PlatformCategory_ScreenViewEvent = {
    fromJSON: function fromJSON(_) {
        return {};
    },
    toJSON: function toJSON(_) {
        var obj = {};
        return obj;
    },
    create: function create(base) {
        return PlatformCategory_ScreenViewEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(_) {
        var message = createBasePlatformCategory_ScreenViewEvent();
        return message;
    }
};
function createBasePlatformCategory_CustomerOneTimeExperienceEvent() {
    return {
        experienceName: ""
    };
}
var PlatformCategory_CustomerOneTimeExperienceEvent = {
    fromJSON: function fromJSON(object) {
        return {
            experienceName: platform_category_isSet(object.experienceName) ? String(object.experienceName) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.experienceName !== "") {
            obj.experienceName = message.experienceName;
        }
        return obj;
    },
    create: function create(base) {
        return PlatformCategory_CustomerOneTimeExperienceEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBasePlatformCategory_CustomerOneTimeExperienceEvent();
        var _experienceName;
        message.experienceName = (_experienceName = object.experienceName) !== null && _experienceName !== void 0 ? _experienceName : "";
        return message;
    }
};
function createBasePlatformCategory_LeadOneTimeExperienceEvent() {
    return {
        experienceName: "",
        leadId: "",
        sellerLeadUuid: ""
    };
}
var PlatformCategory_LeadOneTimeExperienceEvent = {
    fromJSON: function fromJSON(object) {
        return {
            experienceName: platform_category_isSet(object.experienceName) ? String(object.experienceName) : "",
            leadId: platform_category_isSet(object.leadId) ? String(object.leadId) : "",
            sellerLeadUuid: platform_category_isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.experienceName !== "") {
            obj.experienceName = message.experienceName;
        }
        if (message.leadId !== "") {
            obj.leadId = message.leadId;
        }
        if (message.sellerLeadUuid !== "") {
            obj.sellerLeadUuid = message.sellerLeadUuid;
        }
        return obj;
    },
    create: function create(base) {
        return PlatformCategory_LeadOneTimeExperienceEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBasePlatformCategory_LeadOneTimeExperienceEvent();
        var _experienceName;
        message.experienceName = (_experienceName = object.experienceName) !== null && _experienceName !== void 0 ? _experienceName : "";
        var _leadId;
        message.leadId = (_leadId = object.leadId) !== null && _leadId !== void 0 ? _leadId : "";
        var _sellerLeadUuid;
        message.sellerLeadUuid = (_sellerLeadUuid = object.sellerLeadUuid) !== null && _sellerLeadUuid !== void 0 ? _sellerLeadUuid : "";
        return message;
    }
};
function createBasePlatformCategory_CustomerUnsubscribeEvent() {
    return {
        feedName: ""
    };
}
var PlatformCategory_CustomerUnsubscribeEvent = {
    fromJSON: function fromJSON(object) {
        return {
            feedName: platform_category_isSet(object.feedName) ? String(object.feedName) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.feedName !== "") {
            obj.feedName = message.feedName;
        }
        return obj;
    },
    create: function create(base) {
        return PlatformCategory_CustomerUnsubscribeEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBasePlatformCategory_CustomerUnsubscribeEvent();
        var _feedName;
        message.feedName = (_feedName = object.feedName) !== null && _feedName !== void 0 ? _feedName : "";
        return message;
    }
};
function createBasePlatformCategory_SessionStartEvent() {
    return {};
}
var PlatformCategory_SessionStartEvent = {
    fromJSON: function fromJSON(_) {
        return {};
    },
    toJSON: function toJSON(_) {
        var obj = {};
        return obj;
    },
    create: function create(base) {
        return PlatformCategory_SessionStartEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(_) {
        var message = createBasePlatformCategory_SessionStartEvent();
        return message;
    }
};
function createBasePlatformCategory_SessionEndEvent() {
    return {};
}
var PlatformCategory_SessionEndEvent = {
    fromJSON: function fromJSON(_) {
        return {};
    },
    toJSON: function toJSON(_) {
        var obj = {};
        return obj;
    },
    create: function create(base) {
        return PlatformCategory_SessionEndEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(_) {
        var message = createBasePlatformCategory_SessionEndEvent();
        return message;
    }
};
function createBasePlatformCategory_InitialPageViewEvent() {
    return {};
}
var PlatformCategory_InitialPageViewEvent = {
    fromJSON: function fromJSON(_) {
        return {};
    },
    toJSON: function toJSON(_) {
        var obj = {};
        return obj;
    },
    create: function create(base) {
        return PlatformCategory_InitialPageViewEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(_) {
        var message = createBasePlatformCategory_InitialPageViewEvent();
        return message;
    }
};
function createBasePlatformCategory_AppLaunchedEvent() {
    return {
        fromBackground: false,
        url: undefined,
        referringApplication: undefined,
        version: "",
        build: ""
    };
}
var PlatformCategory_AppLaunchedEvent = {
    fromJSON: function fromJSON(object) {
        return {
            fromBackground: platform_category_isSet(object.fromBackground) ? Boolean(object.fromBackground) : false,
            url: platform_category_isSet(object.url) ? String(object.url) : undefined,
            referringApplication: platform_category_isSet(object.referringApplication) ? String(object.referringApplication) : undefined,
            version: platform_category_isSet(object.version) ? String(object.version) : "",
            build: platform_category_isSet(object.build) ? String(object.build) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.fromBackground === true) {
            obj.fromBackground = message.fromBackground;
        }
        if (message.url !== undefined) {
            obj.url = message.url;
        }
        if (message.referringApplication !== undefined) {
            obj.referringApplication = message.referringApplication;
        }
        if (message.version !== "") {
            obj.version = message.version;
        }
        if (message.build !== "") {
            obj.build = message.build;
        }
        return obj;
    },
    create: function create(base) {
        return PlatformCategory_AppLaunchedEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBasePlatformCategory_AppLaunchedEvent();
        var _fromBackground;
        message.fromBackground = (_fromBackground = object.fromBackground) !== null && _fromBackground !== void 0 ? _fromBackground : false;
        var _url;
        message.url = (_url = object.url) !== null && _url !== void 0 ? _url : undefined;
        var _referringApplication;
        message.referringApplication = (_referringApplication = object.referringApplication) !== null && _referringApplication !== void 0 ? _referringApplication : undefined;
        var _version;
        message.version = (_version = object.version) !== null && _version !== void 0 ? _version : "";
        var _build;
        message.build = (_build = object.build) !== null && _build !== void 0 ? _build : "";
        return message;
    }
};
function createBasePlatformCategory_AppForegroundedEvent() {
    return {
        fromBackground: false,
        version: "",
        build: ""
    };
}
var PlatformCategory_AppForegroundedEvent = {
    fromJSON: function fromJSON(object) {
        return {
            fromBackground: platform_category_isSet(object.fromBackground) ? Boolean(object.fromBackground) : false,
            version: platform_category_isSet(object.version) ? String(object.version) : "",
            build: platform_category_isSet(object.build) ? String(object.build) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.fromBackground === true) {
            obj.fromBackground = message.fromBackground;
        }
        if (message.version !== "") {
            obj.version = message.version;
        }
        if (message.build !== "") {
            obj.build = message.build;
        }
        return obj;
    },
    create: function create(base) {
        return PlatformCategory_AppForegroundedEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBasePlatformCategory_AppForegroundedEvent();
        var _fromBackground;
        message.fromBackground = (_fromBackground = object.fromBackground) !== null && _fromBackground !== void 0 ? _fromBackground : false;
        var _version;
        message.version = (_version = object.version) !== null && _version !== void 0 ? _version : "";
        var _build;
        message.build = (_build = object.build) !== null && _build !== void 0 ? _build : "";
        return message;
    }
};
function createBasePlatformCategory_AppBackgroundedEvent() {
    return {
        version: "",
        build: ""
    };
}
var PlatformCategory_AppBackgroundedEvent = {
    fromJSON: function fromJSON(object) {
        return {
            version: platform_category_isSet(object.version) ? String(object.version) : "",
            build: platform_category_isSet(object.build) ? String(object.build) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.version !== "") {
            obj.version = message.version;
        }
        if (message.build !== "") {
            obj.build = message.build;
        }
        return obj;
    },
    create: function create(base) {
        return PlatformCategory_AppBackgroundedEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBasePlatformCategory_AppBackgroundedEvent();
        var _version;
        message.version = (_version = object.version) !== null && _version !== void 0 ? _version : "";
        var _build;
        message.build = (_build = object.build) !== null && _build !== void 0 ? _build : "";
        return message;
    }
};
function platform_category_isSet(value) {
    return value !== null && value !== undefined;
}

// EXTERNAL MODULE: ./src/__generated__/protobuf/journey/data/categories/retail_web_unlock_category.ts
var retail_web_unlock_category = __webpack_require__(79800);
;// CONCATENATED MODULE: ./src/__generated__/protobuf/sell/common/common.ts
/* eslint-disable */ var common_protobufPackage = "od_protos.sell.common";
var MarketingChannel;
(function(MarketingChannel) {
    MarketingChannel[MarketingChannel["UNKNOWN_CHANNEL"] = 0] = "UNKNOWN_CHANNEL";
    MarketingChannel[MarketingChannel[/** DEFAULT - From the main website opendoor.com. */ "DEFAULT"] = 1] = "DEFAULT";
    MarketingChannel[MarketingChannel[/** APP - From our mobile application. */ "APP"] = 2] = "APP";
    MarketingChannel[MarketingChannel[/** HOME_VALUE - From our home value report emails. */ "HOME_VALUE"] = 3] = "HOME_VALUE";
    MarketingChannel[MarketingChannel["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(MarketingChannel || (MarketingChannel = {}));
function marketingChannelFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN_CHANNEL":
            return MarketingChannel.UNKNOWN_CHANNEL;
        case 1:
        case "DEFAULT":
            return MarketingChannel.DEFAULT;
        case 2:
        case "APP":
            return MarketingChannel.APP;
        case 3:
        case "HOME_VALUE":
            return MarketingChannel.HOME_VALUE;
        case -1:
        case "UNRECOGNIZED":
        default:
            return MarketingChannel.UNRECOGNIZED;
    }
}
function marketingChannelToJSON(object) {
    switch(object){
        case MarketingChannel.UNKNOWN_CHANNEL:
            return "UNKNOWN_CHANNEL";
        case MarketingChannel.DEFAULT:
            return "DEFAULT";
        case MarketingChannel.APP:
            return "APP";
        case MarketingChannel.HOME_VALUE:
            return "HOME_VALUE";
        case MarketingChannel.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var Timeline;
(function(Timeline) {
    Timeline[Timeline["UNKNOWN_TIMELINE"] = 0] = "UNKNOWN_TIMELINE";
    Timeline[Timeline["ASAP"] = 1] = "ASAP";
    Timeline[Timeline[/** WEEKS_2_4 - 2 - 4 weeks */ "WEEKS_2_4"] = 2] = "WEEKS_2_4";
    Timeline[Timeline[/** WEEKS_4_6 - 4 - 6 weeks */ "WEEKS_4_6"] = 3] = "WEEKS_4_6";
    Timeline[Timeline[/** WEEKS_6_PLUS - 6+ weeks */ "WEEKS_6_PLUS"] = 4] = "WEEKS_6_PLUS";
    Timeline[Timeline["JUST_BROWSING"] = 5] = "JUST_BROWSING";
    Timeline[Timeline["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Timeline || (Timeline = {}));
function timelineFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN_TIMELINE":
            return Timeline.UNKNOWN_TIMELINE;
        case 1:
        case "ASAP":
            return Timeline.ASAP;
        case 2:
        case "WEEKS_2_4":
            return Timeline.WEEKS_2_4;
        case 3:
        case "WEEKS_4_6":
            return Timeline.WEEKS_4_6;
        case 4:
        case "WEEKS_6_PLUS":
            return Timeline.WEEKS_6_PLUS;
        case 5:
        case "JUST_BROWSING":
            return Timeline.JUST_BROWSING;
        case -1:
        case "UNRECOGNIZED":
        default:
            return Timeline.UNRECOGNIZED;
    }
}
function timelineToJSON(object) {
    switch(object){
        case Timeline.UNKNOWN_TIMELINE:
            return "UNKNOWN_TIMELINE";
        case Timeline.ASAP:
            return "ASAP";
        case Timeline.WEEKS_2_4:
            return "WEEKS_2_4";
        case Timeline.WEEKS_4_6:
            return "WEEKS_4_6";
        case Timeline.WEEKS_6_PLUS:
            return "WEEKS_6_PLUS";
        case Timeline.JUST_BROWSING:
            return "JUST_BROWSING";
        case Timeline.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var Partnership;
(function(Partnership) {
    Partnership[Partnership["UNKNOWN"] = 0] = "UNKNOWN";
    Partnership[Partnership["NONE"] = 1] = "NONE";
    Partnership[Partnership["LENNAR"] = 2] = "LENNAR";
    Partnership[Partnership["TOLL_BROTHERS"] = 3] = "TOLL_BROTHERS";
    Partnership[Partnership["MI_HOMES"] = 4] = "MI_HOMES";
    Partnership[Partnership["MERITAGE"] = 5] = "MERITAGE";
    Partnership[Partnership["TAYLOR_MORRISON"] = 6] = "TAYLOR_MORRISON";
    Partnership[Partnership["CHAFIN"] = 7] = "CHAFIN";
    Partnership[Partnership["SMITHDOUGLAS"] = 8] = "SMITHDOUGLAS";
    Partnership[Partnership["WOODSIDE"] = 9] = "WOODSIDE";
    Partnership[Partnership["MATTAMY"] = 10] = "MATTAMY";
    Partnership[Partnership["RYAN"] = 11] = "RYAN";
    Partnership[Partnership["PARDEE"] = 12] = "PARDEE";
    Partnership[Partnership["PULTE"] = 13] = "PULTE";
    Partnership[Partnership["CALATLANTIC"] = 14] = "CALATLANTIC";
    Partnership[Partnership["FRONTDOOR"] = 15] = "FRONTDOOR";
    Partnership[Partnership["GOODALL"] = 16] = "GOODALL";
    Partnership[Partnership["KB_HOME"] = 17] = "KB_HOME";
    Partnership[Partnership["OTHER_BUILDER"] = 18] = "OTHER_BUILDER";
    Partnership[Partnership["CENTURY_COMMUNITIES"] = 19] = "CENTURY_COMMUNITIES";
    Partnership[Partnership["DAVID_WEEKLEY"] = 20] = "DAVID_WEEKLEY";
    Partnership[Partnership["SHEA_HOMES_TRILOGY"] = 21] = "SHEA_HOMES_TRILOGY";
    Partnership[Partnership["DR_HORTON"] = 22] = "DR_HORTON";
    Partnership[Partnership["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Partnership || (Partnership = {}));
function partnershipFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN":
            return Partnership.UNKNOWN;
        case 1:
        case "NONE":
            return Partnership.NONE;
        case 2:
        case "LENNAR":
            return Partnership.LENNAR;
        case 3:
        case "TOLL_BROTHERS":
            return Partnership.TOLL_BROTHERS;
        case 4:
        case "MI_HOMES":
            return Partnership.MI_HOMES;
        case 5:
        case "MERITAGE":
            return Partnership.MERITAGE;
        case 6:
        case "TAYLOR_MORRISON":
            return Partnership.TAYLOR_MORRISON;
        case 7:
        case "CHAFIN":
            return Partnership.CHAFIN;
        case 8:
        case "SMITHDOUGLAS":
            return Partnership.SMITHDOUGLAS;
        case 9:
        case "WOODSIDE":
            return Partnership.WOODSIDE;
        case 10:
        case "MATTAMY":
            return Partnership.MATTAMY;
        case 11:
        case "RYAN":
            return Partnership.RYAN;
        case 12:
        case "PARDEE":
            return Partnership.PARDEE;
        case 13:
        case "PULTE":
            return Partnership.PULTE;
        case 14:
        case "CALATLANTIC":
            return Partnership.CALATLANTIC;
        case 15:
        case "FRONTDOOR":
            return Partnership.FRONTDOOR;
        case 16:
        case "GOODALL":
            return Partnership.GOODALL;
        case 17:
        case "KB_HOME":
            return Partnership.KB_HOME;
        case 18:
        case "OTHER_BUILDER":
            return Partnership.OTHER_BUILDER;
        case 19:
        case "CENTURY_COMMUNITIES":
            return Partnership.CENTURY_COMMUNITIES;
        case 20:
        case "DAVID_WEEKLEY":
            return Partnership.DAVID_WEEKLEY;
        case 21:
        case "SHEA_HOMES_TRILOGY":
            return Partnership.SHEA_HOMES_TRILOGY;
        case 22:
        case "DR_HORTON":
            return Partnership.DR_HORTON;
        case -1:
        case "UNRECOGNIZED":
        default:
            return Partnership.UNRECOGNIZED;
    }
}
function partnershipToJSON(object) {
    switch(object){
        case Partnership.UNKNOWN:
            return "UNKNOWN";
        case Partnership.NONE:
            return "NONE";
        case Partnership.LENNAR:
            return "LENNAR";
        case Partnership.TOLL_BROTHERS:
            return "TOLL_BROTHERS";
        case Partnership.MI_HOMES:
            return "MI_HOMES";
        case Partnership.MERITAGE:
            return "MERITAGE";
        case Partnership.TAYLOR_MORRISON:
            return "TAYLOR_MORRISON";
        case Partnership.CHAFIN:
            return "CHAFIN";
        case Partnership.SMITHDOUGLAS:
            return "SMITHDOUGLAS";
        case Partnership.WOODSIDE:
            return "WOODSIDE";
        case Partnership.MATTAMY:
            return "MATTAMY";
        case Partnership.RYAN:
            return "RYAN";
        case Partnership.PARDEE:
            return "PARDEE";
        case Partnership.PULTE:
            return "PULTE";
        case Partnership.CALATLANTIC:
            return "CALATLANTIC";
        case Partnership.FRONTDOOR:
            return "FRONTDOOR";
        case Partnership.GOODALL:
            return "GOODALL";
        case Partnership.KB_HOME:
            return "KB_HOME";
        case Partnership.OTHER_BUILDER:
            return "OTHER_BUILDER";
        case Partnership.CENTURY_COMMUNITIES:
            return "CENTURY_COMMUNITIES";
        case Partnership.DAVID_WEEKLEY:
            return "DAVID_WEEKLEY";
        case Partnership.SHEA_HOMES_TRILOGY:
            return "SHEA_HOMES_TRILOGY";
        case Partnership.DR_HORTON:
            return "DR_HORTON";
        case Partnership.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var Product;
(function(Product) {
    Product[Product[/** UNKNOWN_PRODUCT - Product with an unknown name. This should rarely happen */ "UNKNOWN_PRODUCT"] = 0] = "UNKNOWN_PRODUCT";
    Product[Product[/** OPENDOOR_DIRECT - Sell directly to Opendoor */ "OPENDOOR_DIRECT"] = 1] = "OPENDOOR_DIRECT";
    Product[Product[/**
   * AGENT_REFERRAL - Refer to an agent to help them sell their home
   *
   * @deprecated
   */ "AGENT_REFERRAL"] = 2] = "AGENT_REFERRAL";
    Product[Product[/** REIT - Sell to a REIT (Real Estate Investment Trust) */ "REIT"] = 3] = "REIT";
    Product[Product[/**
   * LIST_WITH_OPENDOOR - List your home with Opendoor
   *
   * @deprecated
   */ "LIST_WITH_OPENDOOR"] = 4] = "LIST_WITH_OPENDOOR";
    Product[Product[/** SELL_WITH_UPSIDE - Sell directly with upside */ "SELL_WITH_UPSIDE"] = 5] = "SELL_WITH_UPSIDE";
    Product[Product[/**
   * BUY_WITH_OPENDOOR - Buy a home from Opendoor
   *
   * @deprecated
   */ "BUY_WITH_OPENDOOR"] = 6] = "BUY_WITH_OPENDOOR";
    Product[Product[/**
   * OPENDOOR_BACKED_OFFERS - Make a cash offer on any listed home, using Opendoor cash
   *
   * @deprecated
   */ "OPENDOOR_BACKED_OFFERS"] = 7] = "OPENDOOR_BACKED_OFFERS";
    Product[Product[/**
   * SELL_WITH_EXCLUSIVES - Sell your home on Exclusives
   *
   * @deprecated
   */ "SELL_WITH_EXCLUSIVES"] = 8] = "SELL_WITH_EXCLUSIVES";
    Product[Product[/** LIST_WITH_CERTAINTY - List your home and get an Opendoor cash offer as a fallback */ "LIST_WITH_CERTAINTY"] = 9] = "LIST_WITH_CERTAINTY";
    Product[Product[/** EXTERNAL_LISTING_AGENT - Buy a home through an external listing agent */ "EXTERNAL_LISTING_AGENT"] = 10] = "EXTERNAL_LISTING_AGENT";
    Product[Product[/** HOME_INSIGHTS - Home insights dashboard */ "HOME_INSIGHTS"] = 11] = "HOME_INSIGHTS";
    Product[Product[/** NO_PRODUCT - No product selected - used to reset/clear product selection */ "NO_PRODUCT"] = 12] = "NO_PRODUCT";
    Product[Product["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Product || (Product = {}));
function productFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN_PRODUCT":
            return Product.UNKNOWN_PRODUCT;
        case 1:
        case "OPENDOOR_DIRECT":
            return Product.OPENDOOR_DIRECT;
        case 2:
        case "AGENT_REFERRAL":
            return Product.AGENT_REFERRAL;
        case 3:
        case "REIT":
            return Product.REIT;
        case 4:
        case "LIST_WITH_OPENDOOR":
            return Product.LIST_WITH_OPENDOOR;
        case 5:
        case "SELL_WITH_UPSIDE":
            return Product.SELL_WITH_UPSIDE;
        case 6:
        case "BUY_WITH_OPENDOOR":
            return Product.BUY_WITH_OPENDOOR;
        case 7:
        case "OPENDOOR_BACKED_OFFERS":
            return Product.OPENDOOR_BACKED_OFFERS;
        case 8:
        case "SELL_WITH_EXCLUSIVES":
            return Product.SELL_WITH_EXCLUSIVES;
        case 9:
        case "LIST_WITH_CERTAINTY":
            return Product.LIST_WITH_CERTAINTY;
        case 10:
        case "EXTERNAL_LISTING_AGENT":
            return Product.EXTERNAL_LISTING_AGENT;
        case 11:
        case "HOME_INSIGHTS":
            return Product.HOME_INSIGHTS;
        case 12:
        case "NO_PRODUCT":
            return Product.NO_PRODUCT;
        case -1:
        case "UNRECOGNIZED":
        default:
            return Product.UNRECOGNIZED;
    }
}
function productToJSON(object) {
    switch(object){
        case Product.UNKNOWN_PRODUCT:
            return "UNKNOWN_PRODUCT";
        case Product.OPENDOOR_DIRECT:
            return "OPENDOOR_DIRECT";
        case Product.AGENT_REFERRAL:
            return "AGENT_REFERRAL";
        case Product.REIT:
            return "REIT";
        case Product.LIST_WITH_OPENDOOR:
            return "LIST_WITH_OPENDOOR";
        case Product.SELL_WITH_UPSIDE:
            return "SELL_WITH_UPSIDE";
        case Product.BUY_WITH_OPENDOOR:
            return "BUY_WITH_OPENDOOR";
        case Product.OPENDOOR_BACKED_OFFERS:
            return "OPENDOOR_BACKED_OFFERS";
        case Product.SELL_WITH_EXCLUSIVES:
            return "SELL_WITH_EXCLUSIVES";
        case Product.LIST_WITH_CERTAINTY:
            return "LIST_WITH_CERTAINTY";
        case Product.EXTERNAL_LISTING_AGENT:
            return "EXTERNAL_LISTING_AGENT";
        case Product.HOME_INSIGHTS:
            return "HOME_INSIGHTS";
        case Product.NO_PRODUCT:
            return "NO_PRODUCT";
        case Product.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var DenialReason;
(function(DenialReason) {
    DenialReason[DenialReason[/** NO_DENIAL - home is not denied */ "NO_DENIAL"] = 0] = "NO_DENIAL";
    DenialReason[DenialReason[/** ADDRESS - home is not in a region serviced by Opendoor */ "ADDRESS"] = 1] = "ADDRESS";
    DenialReason[DenialReason[/** AGE_RESTRICTED_COMMUNITY - home is in an age restricted community */ "AGE_RESTRICTED_COMMUNITY"] = 2] = "AGE_RESTRICTED_COMMUNITY";
    DenialReason[DenialReason[/** DWELLING_TYPE - home type is not within the set of types purchased by Opendoor */ "DWELLING_TYPE"] = 4] = "DWELLING_TYPE";
    DenialReason[DenialReason[/** FLOOD_ZONE - home is in a flood zone. */ "FLOOD_ZONE"] = 5] = "FLOOD_ZONE";
    DenialReason[DenialReason[/** GATED_COMMUNITY - home is in a gated community */ "GATED_COMMUNITY"] = 6] = "GATED_COMMUNITY";
    DenialReason[DenialReason[/** LOT_SQ_FT - home's lot sq ft is too large */ "LOT_SQ_FT"] = 7] = "LOT_SQ_FT";
    DenialReason[DenialReason[/** POLYBUTYLENE_PIPING - home has polybutylene piping */ "POLYBUTYLENE_PIPING"] = 8] = "POLYBUTYLENE_PIPING";
    DenialReason[DenialReason[/** UNPERMITTED_ADDITION - home has unpermitted additions */ "UNPERMITTED_ADDITION"] = 9] = "UNPERMITTED_ADDITION";
    DenialReason[DenialReason[/** VALUATION_TOO_HIGH - home's value is outside of buybox range */ "VALUATION_TOO_HIGH"] = 10] = "VALUATION_TOO_HIGH";
    DenialReason[DenialReason[/** VALUATION_TOO_LOW - home's value is outside of buybox range */ "VALUATION_TOO_LOW"] = 11] = "VALUATION_TOO_LOW";
    DenialReason[DenialReason[/** LEASED_SOLAR_PANELS - home has leased solar panels */ "LEASED_SOLAR_PANELS"] = 12] = "LEASED_SOLAR_PANELS";
    DenialReason[DenialReason[/** FLOOD_HISTORY - home has a history of flooding */ "FLOOD_HISTORY"] = 13] = "FLOOD_HISTORY";
    DenialReason[DenialReason[/** SEPTIC - home has a septic system */ "SEPTIC"] = 14] = "SEPTIC";
    DenialReason[DenialReason[/** WELL_WATER - home has a private well as the primary water source */ "WELL_WATER"] = 15] = "WELL_WATER";
    DenialReason[DenialReason[/** YEAR_BUILT - home was built too long ago */ "YEAR_BUILT"] = 16] = "YEAR_BUILT";
    DenialReason[DenialReason[/** ASBESTOS_SIDING - home has asbestos siding */ "ASBESTOS_SIDING"] = 17] = "ASBESTOS_SIDING";
    DenialReason[DenialReason[/** OWNED_BY_OPENDOOR - Opendoor owns the home */ "OWNED_BY_OPENDOOR"] = 18] = "OWNED_BY_OPENDOOR";
    DenialReason[DenialReason[/** LISTED_BY_OPENDOOR - Opendoor has listed the home for sale */ "LISTED_BY_OPENDOOR"] = 19] = "LISTED_BY_OPENDOOR";
    DenialReason[DenialReason[/** IN_CONTRACT_WITH_OPENDOOR - home is in contract or in contingencies released with Opendoor */ "IN_CONTRACT_WITH_OPENDOOR"] = 20] = "IN_CONTRACT_WITH_OPENDOOR";
    DenialReason[DenialReason[/** OTHER_DENIAL - other unspecified reason */ "OTHER_DENIAL"] = 22] = "OTHER_DENIAL";
    DenialReason[DenialReason[/** AGENT_RELATION - customer is an agent representative of the homeowner */ "AGENT_RELATION"] = 23] = "AGENT_RELATION";
    DenialReason[DenialReason[/** WORKING_WITH_HOMEBUILDER - customer is working with a homebuilder partner */ "WORKING_WITH_HOMEBUILDER"] = 24] = "WORKING_WITH_HOMEBUILDER";
    DenialReason[DenialReason[/** BUYER_UNAVAILABLE - buyers are currently unavailable to make an offer on the home */ "BUYER_UNAVAILABLE"] = 25] = "BUYER_UNAVAILABLE";
    DenialReason[DenialReason[/** OFFER_OUTLIER - home has been deemed an outlier at pre-offer time */ "OFFER_OUTLIER"] = 26] = "OFFER_OUTLIER";
    DenialReason[DenialReason["NOT_IN_AUTODENIAL_LISTING_EXP"] = 27] = "NOT_IN_AUTODENIAL_LISTING_EXP";
    DenialReason[DenialReason["NOT_IN_SIDE_BY_SIDE_EXP"] = 28] = "NOT_IN_SIDE_BY_SIDE_EXP";
    DenialReason[DenialReason[/** PARTNERSHIP - seller is working with a partner, could be homebuilder or other */ "PARTNERSHIP"] = 29] = "PARTNERSHIP";
    DenialReason[DenialReason[/** TRADE_IN - seller is a trade-in customer */ "TRADE_IN"] = 30] = "TRADE_IN";
    DenialReason[DenialReason[/** FOUNDATION - home has known foundation issues */ "FOUNDATION"] = 31] = "FOUNDATION";
    DenialReason[DenialReason[/** NON_SERIOUS_SELLER - seller is not serious yet */ "NON_SERIOUS_SELLER"] = 32] = "NON_SERIOUS_SELLER";
    DenialReason[DenialReason[/** FIRE_DAMAGE - home has previous or current fire damage */ "FIRE_DAMAGE"] = 33] = "FIRE_DAMAGE";
    DenialReason[DenialReason[/** LACK_OF_ADEQUATE_COMPS - home does not have adequate comps */ "LACK_OF_ADEQUATE_COMPS"] = 34] = "LACK_OF_ADEQUATE_COMPS";
    DenialReason[DenialReason[/** NON_BUYBOX_DWELLING_TYPE - home dwelling type is not in buybox */ "NON_BUYBOX_DWELLING_TYPE"] = 35] = "NON_BUYBOX_DWELLING_TYPE";
    DenialReason[DenialReason[/** OTHER_HIGH_RISK - home has high risk factors */ "OTHER_HIGH_RISK"] = 36] = "OTHER_HIGH_RISK";
    DenialReason[DenialReason[/** TENANT_OCCUPIED - home is tenant occupied (has lease) */ "TENANT_OCCUPIED"] = 37] = "TENANT_OCCUPIED";
    DenialReason[DenialReason[/** VALUATION_TOO_LOW_LISTED - valuation is significantly lower than list price */ "VALUATION_TOO_LOW_LISTED"] = 38] = "VALUATION_TOO_LOW_LISTED";
    DenialReason[DenialReason[/** AGE_RESTRICTED_SEASONAL - seasonal age restriction for certain market */ "AGE_RESTRICTED_SEASONAL"] = 39] = "AGE_RESTRICTED_SEASONAL";
    DenialReason[DenialReason[/** BEFORE_1960 - home was built before 1960 */ "BEFORE_1960"] = 40] = "BEFORE_1960";
    DenialReason[DenialReason[/** FEES_TOO_HIGH - fees on offer are too high */ "FEES_TOO_HIGH"] = 41] = "FEES_TOO_HIGH";
    DenialReason[DenialReason[/** DUPLICATE_LEAD - duplicate lead on address */ "DUPLICATE_LEAD"] = 42] = "DUPLICATE_LEAD";
    DenialReason[DenialReason[/** SELLER_TRIAGE - rejected seller triage documentation */ "SELLER_TRIAGE"] = 43] = "SELLER_TRIAGE";
    DenialReason[DenialReason[/** SHARED_ENTRANCE - home has a shared entrance with neighbors */ "SHARED_ENTRANCE"] = 44] = "SHARED_ENTRANCE";
    DenialReason[DenialReason[/** SHARED_LOT - home has a shared lot with neighbors */ "SHARED_LOT"] = 45] = "SHARED_LOT";
    DenialReason[DenialReason[/** PREPARING_OFFER - already an active offer request for this address, still preparing offer */ "PREPARING_OFFER"] = 46] = "PREPARING_OFFER";
    DenialReason[DenialReason[/** ACTIVE_OFFER - already an active offer for this address */ "ACTIVE_OFFER"] = 47] = "ACTIVE_OFFER";
    DenialReason[DenialReason[/** PRIVATE_POOL - private pool */ "PRIVATE_POOL"] = 48] = "PRIVATE_POOL";
    DenialReason[DenialReason[/** RESERVED_FOR_EXTERNAL_BROKER - lead will be passed to external brokerage */ "RESERVED_FOR_EXTERNAL_BROKER"] = 49] = "RESERVED_FOR_EXTERNAL_BROKER";
    DenialReason[DenialReason[/**
   * NOT_IN_LWOD_PILOT - seller is not in the lwod experiment
   *
   * @deprecated
   */ "NOT_IN_LWOD_PILOT"] = 50] = "NOT_IN_LWOD_PILOT";
    DenialReason[DenialReason[/** COVID_19 - pause all acq offers for COVID-19 */ "COVID_19"] = 51] = "COVID_19";
    DenialReason[DenialReason[/**
   * NOT_IN_SELL_WITH_UPSIDE_PILOT - Not in the Sell w/ Upside experiment
   *
   * @deprecated
   */ "NOT_IN_SELL_WITH_UPSIDE_PILOT"] = 52] = "NOT_IN_SELL_WITH_UPSIDE_PILOT";
    DenialReason[DenialReason[/** UNABLE_TO_VALUE - opendoor cannot value the home. */ "UNABLE_TO_VALUE"] = 53] = "UNABLE_TO_VALUE";
    DenialReason[DenialReason[/** DENIED_FOR_SELL_WITH_UPSIDE - they were also denied for sell_with_upside, so they're not eligible for this other product */ "DENIED_FOR_SELL_WITH_UPSIDE"] = 54] = "DENIED_FOR_SELL_WITH_UPSIDE";
    DenialReason[DenialReason[/**
   * QUALIFIED_FOR_LWOD - they're qualified for list with opendoor, which is incompatible with this product
   *
   * @deprecated
   */ "QUALIFIED_FOR_LWOD"] = 55] = "QUALIFIED_FOR_LWOD";
    DenialReason[DenialReason[/** DENIED_FOR_OPENDOOR_DIRECT - they were also denied for opendoor_direct, so they're not eligible for this other product */ "DENIED_FOR_OPENDOOR_DIRECT"] = 56] = "DENIED_FOR_OPENDOOR_DIRECT";
    DenialReason[DenialReason[/** QUALIFIED_FOR_OPENDOOR_DIRECT - they're qualified for opendoor direct, which is incompatible with this product */ "QUALIFIED_FOR_OPENDOOR_DIRECT"] = 57] = "QUALIFIED_FOR_OPENDOOR_DIRECT";
    DenialReason[DenialReason[/** GUARD_GATED_COMMUNITY - home is in a guard-gated community */ "GUARD_GATED_COMMUNITY"] = 58] = "GUARD_GATED_COMMUNITY";
    DenialReason[DenialReason[/** LIVESTOCK - livestock on property */ "LIVESTOCK"] = 62] = "LIVESTOCK";
    DenialReason[DenialReason[/** MOBILE_MANUFACTURED_HOME - mobile or manufactured home */ "MOBILE_MANUFACTURED_HOME"] = 63] = "MOBILE_MANUFACTURED_HOME";
    DenialReason[DenialReason[/** ADDRESS_OVERRIDE - this address has been explicitly denied */ "ADDRESS_OVERRIDE"] = 59] = "ADDRESS_OVERRIDE";
    DenialReason[DenialReason[/** SALE_TIMELINE - sale timeline is not compatible with the experience */ "SALE_TIMELINE"] = 65] = "SALE_TIMELINE";
    DenialReason[DenialReason[/** EXPECTED_LGM - expected levered gross margin (LGM) does not meet experience criteria */ "EXPECTED_LGM"] = 66] = "EXPECTED_LGM";
    DenialReason[DenialReason[/** UNIQUE_OWNERSHIP_STRUCTURE - tenants in common, co-op programs */ "UNIQUE_OWNERSHIP_STRUCTURE"] = 68] = "UNIQUE_OWNERSHIP_STRUCTURE";
    DenialReason[DenialReason[/** BELOW_MARKET_RATE_OWNERSHIP - San Francisco-specific program for low-middle income buyers */ "BELOW_MARKET_RATE_OWNERSHIP"] = 69] = "BELOW_MARKET_RATE_OWNERSHIP";
    DenialReason[DenialReason[/** UNDERGROUND_OIL_TANK - NY/NJ specific - homes commonly have underground oil tanks that can be costly */ "UNDERGROUND_OIL_TANK"] = 70] = "UNDERGROUND_OIL_TANK";
    DenialReason[DenialReason[/** MLS_LISTING_STATUS - For use with partner API, controls display of OD offers in partner's website UI */ "MLS_LISTING_STATUS"] = 71] = "MLS_LISTING_STATUS";
    DenialReason[DenialReason[/** CESSPOOL - Boston and NY/NJ only, for homes with a cesspool */ "CESSPOOL"] = 72] = "CESSPOOL";
    DenialReason[DenialReason[/** INELIGIBLE_HOA - home is in an ineligible HOA - requires rental history, SSN, etc. */ "INELIGIBLE_HOA"] = 73] = "INELIGIBLE_HOA";
    DenialReason[DenialReason[/**
   * OFFER_IN_PROGRESS - Deprecated, used only for the ShouldDenyBasedOnFlipStatus web GRPC endpoint
   *
   * @deprecated
   */ "OFFER_IN_PROGRESS"] = 64] = "OFFER_IN_PROGRESS";
    DenialReason[DenialReason[/**
   * OTHER_DENIAL_GENERAL - denial code used externally to present that we have some uncategorized
   * reason for denying a given address for a given product.
   */ "OTHER_DENIAL_GENERAL"] = 60] = "OTHER_DENIAL_GENERAL";
    DenialReason[DenialReason[/**
   * OTHER_DENIAL_DETAIL - denial code used externally to present that we are missing a
   * particular piece of information necessary to value a home.
   * For backwards compatibility this denial_reason does not
   * have a more reasonable name like OTHER_DENIAL_VALUATION
   */ "OTHER_DENIAL_DETAIL"] = 61] = "OTHER_DENIAL_DETAIL";
    DenialReason[DenialReason[/** DEPENDENT_RULESET - dependent ruleset evaluation is incompatible with this product */ "DEPENDENT_RULESET"] = 67] = "DEPENDENT_RULESET";
    DenialReason[DenialReason[/** RISK_PROHIBITED_REGION - the home is in a region that Pricing has deemed too risky */ "RISK_PROHIBITED_REGION"] = 74] = "RISK_PROHIBITED_REGION";
    DenialReason[DenialReason[/** PRODUCT_INACTIVE - the product is not active in the current market */ "PRODUCT_INACTIVE"] = 75] = "PRODUCT_INACTIVE";
    DenialReason[DenialReason["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(DenialReason || (DenialReason = {}));
function denialReasonFromJSON(object) {
    switch(object){
        case 0:
        case "NO_DENIAL":
            return DenialReason.NO_DENIAL;
        case 1:
        case "ADDRESS":
            return DenialReason.ADDRESS;
        case 2:
        case "AGE_RESTRICTED_COMMUNITY":
            return DenialReason.AGE_RESTRICTED_COMMUNITY;
        case 4:
        case "DWELLING_TYPE":
            return DenialReason.DWELLING_TYPE;
        case 5:
        case "FLOOD_ZONE":
            return DenialReason.FLOOD_ZONE;
        case 6:
        case "GATED_COMMUNITY":
            return DenialReason.GATED_COMMUNITY;
        case 7:
        case "LOT_SQ_FT":
            return DenialReason.LOT_SQ_FT;
        case 8:
        case "POLYBUTYLENE_PIPING":
            return DenialReason.POLYBUTYLENE_PIPING;
        case 9:
        case "UNPERMITTED_ADDITION":
            return DenialReason.UNPERMITTED_ADDITION;
        case 10:
        case "VALUATION_TOO_HIGH":
            return DenialReason.VALUATION_TOO_HIGH;
        case 11:
        case "VALUATION_TOO_LOW":
            return DenialReason.VALUATION_TOO_LOW;
        case 12:
        case "LEASED_SOLAR_PANELS":
            return DenialReason.LEASED_SOLAR_PANELS;
        case 13:
        case "FLOOD_HISTORY":
            return DenialReason.FLOOD_HISTORY;
        case 14:
        case "SEPTIC":
            return DenialReason.SEPTIC;
        case 15:
        case "WELL_WATER":
            return DenialReason.WELL_WATER;
        case 16:
        case "YEAR_BUILT":
            return DenialReason.YEAR_BUILT;
        case 17:
        case "ASBESTOS_SIDING":
            return DenialReason.ASBESTOS_SIDING;
        case 18:
        case "OWNED_BY_OPENDOOR":
            return DenialReason.OWNED_BY_OPENDOOR;
        case 19:
        case "LISTED_BY_OPENDOOR":
            return DenialReason.LISTED_BY_OPENDOOR;
        case 20:
        case "IN_CONTRACT_WITH_OPENDOOR":
            return DenialReason.IN_CONTRACT_WITH_OPENDOOR;
        case 22:
        case "OTHER_DENIAL":
            return DenialReason.OTHER_DENIAL;
        case 23:
        case "AGENT_RELATION":
            return DenialReason.AGENT_RELATION;
        case 24:
        case "WORKING_WITH_HOMEBUILDER":
            return DenialReason.WORKING_WITH_HOMEBUILDER;
        case 25:
        case "BUYER_UNAVAILABLE":
            return DenialReason.BUYER_UNAVAILABLE;
        case 26:
        case "OFFER_OUTLIER":
            return DenialReason.OFFER_OUTLIER;
        case 27:
        case "NOT_IN_AUTODENIAL_LISTING_EXP":
            return DenialReason.NOT_IN_AUTODENIAL_LISTING_EXP;
        case 28:
        case "NOT_IN_SIDE_BY_SIDE_EXP":
            return DenialReason.NOT_IN_SIDE_BY_SIDE_EXP;
        case 29:
        case "PARTNERSHIP":
            return DenialReason.PARTNERSHIP;
        case 30:
        case "TRADE_IN":
            return DenialReason.TRADE_IN;
        case 31:
        case "FOUNDATION":
            return DenialReason.FOUNDATION;
        case 32:
        case "NON_SERIOUS_SELLER":
            return DenialReason.NON_SERIOUS_SELLER;
        case 33:
        case "FIRE_DAMAGE":
            return DenialReason.FIRE_DAMAGE;
        case 34:
        case "LACK_OF_ADEQUATE_COMPS":
            return DenialReason.LACK_OF_ADEQUATE_COMPS;
        case 35:
        case "NON_BUYBOX_DWELLING_TYPE":
            return DenialReason.NON_BUYBOX_DWELLING_TYPE;
        case 36:
        case "OTHER_HIGH_RISK":
            return DenialReason.OTHER_HIGH_RISK;
        case 37:
        case "TENANT_OCCUPIED":
            return DenialReason.TENANT_OCCUPIED;
        case 38:
        case "VALUATION_TOO_LOW_LISTED":
            return DenialReason.VALUATION_TOO_LOW_LISTED;
        case 39:
        case "AGE_RESTRICTED_SEASONAL":
            return DenialReason.AGE_RESTRICTED_SEASONAL;
        case 40:
        case "BEFORE_1960":
            return DenialReason.BEFORE_1960;
        case 41:
        case "FEES_TOO_HIGH":
            return DenialReason.FEES_TOO_HIGH;
        case 42:
        case "DUPLICATE_LEAD":
            return DenialReason.DUPLICATE_LEAD;
        case 43:
        case "SELLER_TRIAGE":
            return DenialReason.SELLER_TRIAGE;
        case 44:
        case "SHARED_ENTRANCE":
            return DenialReason.SHARED_ENTRANCE;
        case 45:
        case "SHARED_LOT":
            return DenialReason.SHARED_LOT;
        case 46:
        case "PREPARING_OFFER":
            return DenialReason.PREPARING_OFFER;
        case 47:
        case "ACTIVE_OFFER":
            return DenialReason.ACTIVE_OFFER;
        case 48:
        case "PRIVATE_POOL":
            return DenialReason.PRIVATE_POOL;
        case 49:
        case "RESERVED_FOR_EXTERNAL_BROKER":
            return DenialReason.RESERVED_FOR_EXTERNAL_BROKER;
        case 50:
        case "NOT_IN_LWOD_PILOT":
            return DenialReason.NOT_IN_LWOD_PILOT;
        case 51:
        case "COVID_19":
            return DenialReason.COVID_19;
        case 52:
        case "NOT_IN_SELL_WITH_UPSIDE_PILOT":
            return DenialReason.NOT_IN_SELL_WITH_UPSIDE_PILOT;
        case 53:
        case "UNABLE_TO_VALUE":
            return DenialReason.UNABLE_TO_VALUE;
        case 54:
        case "DENIED_FOR_SELL_WITH_UPSIDE":
            return DenialReason.DENIED_FOR_SELL_WITH_UPSIDE;
        case 55:
        case "QUALIFIED_FOR_LWOD":
            return DenialReason.QUALIFIED_FOR_LWOD;
        case 56:
        case "DENIED_FOR_OPENDOOR_DIRECT":
            return DenialReason.DENIED_FOR_OPENDOOR_DIRECT;
        case 57:
        case "QUALIFIED_FOR_OPENDOOR_DIRECT":
            return DenialReason.QUALIFIED_FOR_OPENDOOR_DIRECT;
        case 58:
        case "GUARD_GATED_COMMUNITY":
            return DenialReason.GUARD_GATED_COMMUNITY;
        case 62:
        case "LIVESTOCK":
            return DenialReason.LIVESTOCK;
        case 63:
        case "MOBILE_MANUFACTURED_HOME":
            return DenialReason.MOBILE_MANUFACTURED_HOME;
        case 59:
        case "ADDRESS_OVERRIDE":
            return DenialReason.ADDRESS_OVERRIDE;
        case 65:
        case "SALE_TIMELINE":
            return DenialReason.SALE_TIMELINE;
        case 66:
        case "EXPECTED_LGM":
            return DenialReason.EXPECTED_LGM;
        case 68:
        case "UNIQUE_OWNERSHIP_STRUCTURE":
            return DenialReason.UNIQUE_OWNERSHIP_STRUCTURE;
        case 69:
        case "BELOW_MARKET_RATE_OWNERSHIP":
            return DenialReason.BELOW_MARKET_RATE_OWNERSHIP;
        case 70:
        case "UNDERGROUND_OIL_TANK":
            return DenialReason.UNDERGROUND_OIL_TANK;
        case 71:
        case "MLS_LISTING_STATUS":
            return DenialReason.MLS_LISTING_STATUS;
        case 72:
        case "CESSPOOL":
            return DenialReason.CESSPOOL;
        case 73:
        case "INELIGIBLE_HOA":
            return DenialReason.INELIGIBLE_HOA;
        case 64:
        case "OFFER_IN_PROGRESS":
            return DenialReason.OFFER_IN_PROGRESS;
        case 60:
        case "OTHER_DENIAL_GENERAL":
            return DenialReason.OTHER_DENIAL_GENERAL;
        case 61:
        case "OTHER_DENIAL_DETAIL":
            return DenialReason.OTHER_DENIAL_DETAIL;
        case 67:
        case "DEPENDENT_RULESET":
            return DenialReason.DEPENDENT_RULESET;
        case 74:
        case "RISK_PROHIBITED_REGION":
            return DenialReason.RISK_PROHIBITED_REGION;
        case 75:
        case "PRODUCT_INACTIVE":
            return DenialReason.PRODUCT_INACTIVE;
        case -1:
        case "UNRECOGNIZED":
        default:
            return DenialReason.UNRECOGNIZED;
    }
}
function denialReasonToJSON(object) {
    switch(object){
        case DenialReason.NO_DENIAL:
            return "NO_DENIAL";
        case DenialReason.ADDRESS:
            return "ADDRESS";
        case DenialReason.AGE_RESTRICTED_COMMUNITY:
            return "AGE_RESTRICTED_COMMUNITY";
        case DenialReason.DWELLING_TYPE:
            return "DWELLING_TYPE";
        case DenialReason.FLOOD_ZONE:
            return "FLOOD_ZONE";
        case DenialReason.GATED_COMMUNITY:
            return "GATED_COMMUNITY";
        case DenialReason.LOT_SQ_FT:
            return "LOT_SQ_FT";
        case DenialReason.POLYBUTYLENE_PIPING:
            return "POLYBUTYLENE_PIPING";
        case DenialReason.UNPERMITTED_ADDITION:
            return "UNPERMITTED_ADDITION";
        case DenialReason.VALUATION_TOO_HIGH:
            return "VALUATION_TOO_HIGH";
        case DenialReason.VALUATION_TOO_LOW:
            return "VALUATION_TOO_LOW";
        case DenialReason.LEASED_SOLAR_PANELS:
            return "LEASED_SOLAR_PANELS";
        case DenialReason.FLOOD_HISTORY:
            return "FLOOD_HISTORY";
        case DenialReason.SEPTIC:
            return "SEPTIC";
        case DenialReason.WELL_WATER:
            return "WELL_WATER";
        case DenialReason.YEAR_BUILT:
            return "YEAR_BUILT";
        case DenialReason.ASBESTOS_SIDING:
            return "ASBESTOS_SIDING";
        case DenialReason.OWNED_BY_OPENDOOR:
            return "OWNED_BY_OPENDOOR";
        case DenialReason.LISTED_BY_OPENDOOR:
            return "LISTED_BY_OPENDOOR";
        case DenialReason.IN_CONTRACT_WITH_OPENDOOR:
            return "IN_CONTRACT_WITH_OPENDOOR";
        case DenialReason.OTHER_DENIAL:
            return "OTHER_DENIAL";
        case DenialReason.AGENT_RELATION:
            return "AGENT_RELATION";
        case DenialReason.WORKING_WITH_HOMEBUILDER:
            return "WORKING_WITH_HOMEBUILDER";
        case DenialReason.BUYER_UNAVAILABLE:
            return "BUYER_UNAVAILABLE";
        case DenialReason.OFFER_OUTLIER:
            return "OFFER_OUTLIER";
        case DenialReason.NOT_IN_AUTODENIAL_LISTING_EXP:
            return "NOT_IN_AUTODENIAL_LISTING_EXP";
        case DenialReason.NOT_IN_SIDE_BY_SIDE_EXP:
            return "NOT_IN_SIDE_BY_SIDE_EXP";
        case DenialReason.PARTNERSHIP:
            return "PARTNERSHIP";
        case DenialReason.TRADE_IN:
            return "TRADE_IN";
        case DenialReason.FOUNDATION:
            return "FOUNDATION";
        case DenialReason.NON_SERIOUS_SELLER:
            return "NON_SERIOUS_SELLER";
        case DenialReason.FIRE_DAMAGE:
            return "FIRE_DAMAGE";
        case DenialReason.LACK_OF_ADEQUATE_COMPS:
            return "LACK_OF_ADEQUATE_COMPS";
        case DenialReason.NON_BUYBOX_DWELLING_TYPE:
            return "NON_BUYBOX_DWELLING_TYPE";
        case DenialReason.OTHER_HIGH_RISK:
            return "OTHER_HIGH_RISK";
        case DenialReason.TENANT_OCCUPIED:
            return "TENANT_OCCUPIED";
        case DenialReason.VALUATION_TOO_LOW_LISTED:
            return "VALUATION_TOO_LOW_LISTED";
        case DenialReason.AGE_RESTRICTED_SEASONAL:
            return "AGE_RESTRICTED_SEASONAL";
        case DenialReason.BEFORE_1960:
            return "BEFORE_1960";
        case DenialReason.FEES_TOO_HIGH:
            return "FEES_TOO_HIGH";
        case DenialReason.DUPLICATE_LEAD:
            return "DUPLICATE_LEAD";
        case DenialReason.SELLER_TRIAGE:
            return "SELLER_TRIAGE";
        case DenialReason.SHARED_ENTRANCE:
            return "SHARED_ENTRANCE";
        case DenialReason.SHARED_LOT:
            return "SHARED_LOT";
        case DenialReason.PREPARING_OFFER:
            return "PREPARING_OFFER";
        case DenialReason.ACTIVE_OFFER:
            return "ACTIVE_OFFER";
        case DenialReason.PRIVATE_POOL:
            return "PRIVATE_POOL";
        case DenialReason.RESERVED_FOR_EXTERNAL_BROKER:
            return "RESERVED_FOR_EXTERNAL_BROKER";
        case DenialReason.NOT_IN_LWOD_PILOT:
            return "NOT_IN_LWOD_PILOT";
        case DenialReason.COVID_19:
            return "COVID_19";
        case DenialReason.NOT_IN_SELL_WITH_UPSIDE_PILOT:
            return "NOT_IN_SELL_WITH_UPSIDE_PILOT";
        case DenialReason.UNABLE_TO_VALUE:
            return "UNABLE_TO_VALUE";
        case DenialReason.DENIED_FOR_SELL_WITH_UPSIDE:
            return "DENIED_FOR_SELL_WITH_UPSIDE";
        case DenialReason.QUALIFIED_FOR_LWOD:
            return "QUALIFIED_FOR_LWOD";
        case DenialReason.DENIED_FOR_OPENDOOR_DIRECT:
            return "DENIED_FOR_OPENDOOR_DIRECT";
        case DenialReason.QUALIFIED_FOR_OPENDOOR_DIRECT:
            return "QUALIFIED_FOR_OPENDOOR_DIRECT";
        case DenialReason.GUARD_GATED_COMMUNITY:
            return "GUARD_GATED_COMMUNITY";
        case DenialReason.LIVESTOCK:
            return "LIVESTOCK";
        case DenialReason.MOBILE_MANUFACTURED_HOME:
            return "MOBILE_MANUFACTURED_HOME";
        case DenialReason.ADDRESS_OVERRIDE:
            return "ADDRESS_OVERRIDE";
        case DenialReason.SALE_TIMELINE:
            return "SALE_TIMELINE";
        case DenialReason.EXPECTED_LGM:
            return "EXPECTED_LGM";
        case DenialReason.UNIQUE_OWNERSHIP_STRUCTURE:
            return "UNIQUE_OWNERSHIP_STRUCTURE";
        case DenialReason.BELOW_MARKET_RATE_OWNERSHIP:
            return "BELOW_MARKET_RATE_OWNERSHIP";
        case DenialReason.UNDERGROUND_OIL_TANK:
            return "UNDERGROUND_OIL_TANK";
        case DenialReason.MLS_LISTING_STATUS:
            return "MLS_LISTING_STATUS";
        case DenialReason.CESSPOOL:
            return "CESSPOOL";
        case DenialReason.INELIGIBLE_HOA:
            return "INELIGIBLE_HOA";
        case DenialReason.OFFER_IN_PROGRESS:
            return "OFFER_IN_PROGRESS";
        case DenialReason.OTHER_DENIAL_GENERAL:
            return "OTHER_DENIAL_GENERAL";
        case DenialReason.OTHER_DENIAL_DETAIL:
            return "OTHER_DENIAL_DETAIL";
        case DenialReason.DEPENDENT_RULESET:
            return "DEPENDENT_RULESET";
        case DenialReason.RISK_PROHIBITED_REGION:
            return "RISK_PROHIBITED_REGION";
        case DenialReason.PRODUCT_INACTIVE:
            return "PRODUCT_INACTIVE";
        case DenialReason.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var Segment;
(function(Segment) {
    Segment[Segment["HOMEOWNER"] = 0] = "HOMEOWNER";
    Segment[Segment["WORKING_WITH_AGENT"] = 1] = "WORKING_WITH_AGENT";
    Segment[Segment["BUYER"] = 2] = "BUYER";
    Segment[Segment["HOMEBUILDER"] = 3] = "HOMEBUILDER";
    Segment[Segment["STAYING_IN_MARKET"] = 4] = "STAYING_IN_MARKET";
    Segment[Segment["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Segment || (Segment = {}));
function segmentFromJSON(object) {
    switch(object){
        case 0:
        case "HOMEOWNER":
            return Segment.HOMEOWNER;
        case 1:
        case "WORKING_WITH_AGENT":
            return Segment.WORKING_WITH_AGENT;
        case 2:
        case "BUYER":
            return Segment.BUYER;
        case 3:
        case "HOMEBUILDER":
            return Segment.HOMEBUILDER;
        case 4:
        case "STAYING_IN_MARKET":
            return Segment.STAYING_IN_MARKET;
        case -1:
        case "UNRECOGNIZED":
        default:
            return Segment.UNRECOGNIZED;
    }
}
function segmentToJSON(object) {
    switch(object){
        case Segment.HOMEOWNER:
            return "HOMEOWNER";
        case Segment.WORKING_WITH_AGENT:
            return "WORKING_WITH_AGENT";
        case Segment.BUYER:
            return "BUYER";
        case Segment.HOMEBUILDER:
            return "HOMEBUILDER";
        case Segment.STAYING_IN_MARKET:
            return "STAYING_IN_MARKET";
        case Segment.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var SelfServiceVirtualAssessmentExperimentGroup;
(function(SelfServiceVirtualAssessmentExperimentGroup) {
    SelfServiceVirtualAssessmentExperimentGroup[SelfServiceVirtualAssessmentExperimentGroup[/** NOT_IN_EXPERIMENT - Seller is not in the experiment. */ "NOT_IN_EXPERIMENT"] = 0] = "NOT_IN_EXPERIMENT";
    SelfServiceVirtualAssessmentExperimentGroup[SelfServiceVirtualAssessmentExperimentGroup[/**
   * BALANCED - Seller is presented with both uploading the self service and scheduling a virtual assessment call with no
   * bias towards either option.
   */ "BALANCED"] = 1] = "BALANCED";
    SelfServiceVirtualAssessmentExperimentGroup[SelfServiceVirtualAssessmentExperimentGroup[/**
   * ASSERTIVE - Seller is presented with a heavier bias towards the self service option, and must explicitly opt out
   * of that experience.
   */ "ASSERTIVE"] = 2] = "ASSERTIVE";
    SelfServiceVirtualAssessmentExperimentGroup[SelfServiceVirtualAssessmentExperimentGroup[/** CONTROL - Seller is in the control group of the experiment */ "CONTROL"] = 3] = "CONTROL";
    SelfServiceVirtualAssessmentExperimentGroup[SelfServiceVirtualAssessmentExperimentGroup[/** AGENT_ASSERTIVE - Agent is presented the self-serve virtual assessment option with a heavier bias towards self-service. */ "AGENT_ASSERTIVE"] = 4] = "AGENT_ASSERTIVE";
    SelfServiceVirtualAssessmentExperimentGroup[SelfServiceVirtualAssessmentExperimentGroup[/** AGENT_CONTROL - Agent is in the control group of the experiment */ "AGENT_CONTROL"] = 5] = "AGENT_CONTROL";
    SelfServiceVirtualAssessmentExperimentGroup[SelfServiceVirtualAssessmentExperimentGroup["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(SelfServiceVirtualAssessmentExperimentGroup || (SelfServiceVirtualAssessmentExperimentGroup = {}));
function selfServiceVirtualAssessmentExperimentGroupFromJSON(object) {
    switch(object){
        case 0:
        case "NOT_IN_EXPERIMENT":
            return SelfServiceVirtualAssessmentExperimentGroup.NOT_IN_EXPERIMENT;
        case 1:
        case "BALANCED":
            return SelfServiceVirtualAssessmentExperimentGroup.BALANCED;
        case 2:
        case "ASSERTIVE":
            return SelfServiceVirtualAssessmentExperimentGroup.ASSERTIVE;
        case 3:
        case "CONTROL":
            return SelfServiceVirtualAssessmentExperimentGroup.CONTROL;
        case 4:
        case "AGENT_ASSERTIVE":
            return SelfServiceVirtualAssessmentExperimentGroup.AGENT_ASSERTIVE;
        case 5:
        case "AGENT_CONTROL":
            return SelfServiceVirtualAssessmentExperimentGroup.AGENT_CONTROL;
        case -1:
        case "UNRECOGNIZED":
        default:
            return SelfServiceVirtualAssessmentExperimentGroup.UNRECOGNIZED;
    }
}
function selfServiceVirtualAssessmentExperimentGroupToJSON(object) {
    switch(object){
        case SelfServiceVirtualAssessmentExperimentGroup.NOT_IN_EXPERIMENT:
            return "NOT_IN_EXPERIMENT";
        case SelfServiceVirtualAssessmentExperimentGroup.BALANCED:
            return "BALANCED";
        case SelfServiceVirtualAssessmentExperimentGroup.ASSERTIVE:
            return "ASSERTIVE";
        case SelfServiceVirtualAssessmentExperimentGroup.CONTROL:
            return "CONTROL";
        case SelfServiceVirtualAssessmentExperimentGroup.AGENT_ASSERTIVE:
            return "AGENT_ASSERTIVE";
        case SelfServiceVirtualAssessmentExperimentGroup.AGENT_CONTROL:
            return "AGENT_CONTROL";
        case SelfServiceVirtualAssessmentExperimentGroup.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}

;// CONCATENATED MODULE: ./src/__generated__/protobuf/common/measure.ts
/* eslint-disable */ var measure_protobufPackage = "od_protos.common";
var Duration_Unit;
(function(Duration_Unit) {
    Duration_Unit[Duration_Unit["UNKWOWN"] = 0] = "UNKWOWN";
    Duration_Unit[Duration_Unit["SECOND"] = 1] = "SECOND";
    Duration_Unit[Duration_Unit["MINUTE"] = 2] = "MINUTE";
    Duration_Unit[Duration_Unit["HOUR"] = 3] = "HOUR";
    Duration_Unit[Duration_Unit["DAY"] = 4] = "DAY";
    Duration_Unit[Duration_Unit["WEEK"] = 5] = "WEEK";
    Duration_Unit[Duration_Unit["MONTH"] = 6] = "MONTH";
    Duration_Unit[Duration_Unit["YEAR"] = 7] = "YEAR";
    Duration_Unit[Duration_Unit["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Duration_Unit || (Duration_Unit = {}));
function duration_UnitFromJSON(object) {
    switch(object){
        case 0:
        case "UNKWOWN":
            return Duration_Unit.UNKWOWN;
        case 1:
        case "SECOND":
            return Duration_Unit.SECOND;
        case 2:
        case "MINUTE":
            return Duration_Unit.MINUTE;
        case 3:
        case "HOUR":
            return Duration_Unit.HOUR;
        case 4:
        case "DAY":
            return Duration_Unit.DAY;
        case 5:
        case "WEEK":
            return Duration_Unit.WEEK;
        case 6:
        case "MONTH":
            return Duration_Unit.MONTH;
        case 7:
        case "YEAR":
            return Duration_Unit.YEAR;
        case -1:
        case "UNRECOGNIZED":
        default:
            return Duration_Unit.UNRECOGNIZED;
    }
}
function duration_UnitToJSON(object) {
    switch(object){
        case Duration_Unit.UNKWOWN:
            return "UNKWOWN";
        case Duration_Unit.SECOND:
            return "SECOND";
        case Duration_Unit.MINUTE:
            return "MINUTE";
        case Duration_Unit.HOUR:
            return "HOUR";
        case Duration_Unit.DAY:
            return "DAY";
        case Duration_Unit.WEEK:
            return "WEEK";
        case Duration_Unit.MONTH:
            return "MONTH";
        case Duration_Unit.YEAR:
            return "YEAR";
        case Duration_Unit.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var Area_Unit;
(function(Area_Unit) {
    Area_Unit[Area_Unit["UNKNOWN"] = 0] = "UNKNOWN";
    Area_Unit[Area_Unit["SQUARE_METER"] = 1] = "SQUARE_METER";
    Area_Unit[Area_Unit["SQUARE_INCH"] = 2] = "SQUARE_INCH";
    Area_Unit[Area_Unit["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Area_Unit || (Area_Unit = {}));
function area_UnitFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN":
            return Area_Unit.UNKNOWN;
        case 1:
        case "SQUARE_METER":
            return Area_Unit.SQUARE_METER;
        case 2:
        case "SQUARE_INCH":
            return Area_Unit.SQUARE_INCH;
        case -1:
        case "UNRECOGNIZED":
        default:
            return Area_Unit.UNRECOGNIZED;
    }
}
function area_UnitToJSON(object) {
    switch(object){
        case Area_Unit.UNKNOWN:
            return "UNKNOWN";
        case Area_Unit.SQUARE_METER:
            return "SQUARE_METER";
        case Area_Unit.SQUARE_INCH:
            return "SQUARE_INCH";
        case Area_Unit.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
function createBaseDuration() {
    return {
        value: 0,
        unit: 0
    };
}
var Duration = {
    fromJSON: function fromJSON(object) {
        return {
            value: measure_isSet(object.value) ? Number(object.value) : 0,
            unit: measure_isSet(object.unit) ? duration_UnitFromJSON(object.unit) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.value !== 0) {
            obj.value = message.value;
        }
        if (message.unit !== 0) {
            obj.unit = duration_UnitToJSON(message.unit);
        }
        return obj;
    },
    create: function create(base) {
        return Duration.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseDuration();
        var _value;
        message.value = (_value = object.value) !== null && _value !== void 0 ? _value : 0;
        var _unit;
        message.unit = (_unit = object.unit) !== null && _unit !== void 0 ? _unit : 0;
        return message;
    }
};
function createBaseArea() {
    return {
        value: 0,
        unit: 0
    };
}
var Area = {
    fromJSON: function fromJSON(object) {
        return {
            value: measure_isSet(object.value) ? Number(object.value) : 0,
            unit: measure_isSet(object.unit) ? area_UnitFromJSON(object.unit) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.value !== 0) {
            obj.value = message.value;
        }
        if (message.unit !== 0) {
            obj.unit = area_UnitToJSON(message.unit);
        }
        return obj;
    },
    create: function create(base) {
        return Area.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseArea();
        var _value;
        message.value = (_value = object.value) !== null && _value !== void 0 ? _value : 0;
        var _unit;
        message.unit = (_unit = object.unit) !== null && _unit !== void 0 ? _unit : 0;
        return message;
    }
};
function measure_isSet(value) {
    return value !== null && value !== undefined;
}

;// CONCATENATED MODULE: ./src/__generated__/protobuf/common/money.ts
/* eslint-disable */ 
var money_protobufPackage = "od_protos.common";
var Money_AlphabeticCurrencyCode;
(function(Money_AlphabeticCurrencyCode) {
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["USD"] = 0] = "USD";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["AED"] = 1] = "AED";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["AFN"] = 2] = "AFN";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["ALL"] = 3] = "ALL";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["AMD"] = 4] = "AMD";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["ANG"] = 5] = "ANG";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["AOA"] = 6] = "AOA";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["ARS"] = 7] = "ARS";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["AUD"] = 8] = "AUD";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["AWG"] = 9] = "AWG";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["AZN"] = 10] = "AZN";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["BAM"] = 11] = "BAM";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["BBD"] = 12] = "BBD";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["BDT"] = 13] = "BDT";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["BGN"] = 14] = "BGN";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["BHD"] = 15] = "BHD";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["BIF"] = 16] = "BIF";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["BMD"] = 17] = "BMD";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["BND"] = 18] = "BND";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["BOB"] = 19] = "BOB";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["BOV"] = 20] = "BOV";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["BRL"] = 21] = "BRL";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["BSD"] = 22] = "BSD";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["BTN"] = 23] = "BTN";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["BWP"] = 24] = "BWP";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["BYN"] = 25] = "BYN";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["BZD"] = 26] = "BZD";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["CAD"] = 27] = "CAD";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["CDF"] = 28] = "CDF";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["CHE"] = 29] = "CHE";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["CHF"] = 30] = "CHF";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["CHW"] = 31] = "CHW";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["CLF"] = 32] = "CLF";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["CLP"] = 33] = "CLP";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["CNY"] = 34] = "CNY";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["COP"] = 35] = "COP";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["COU"] = 36] = "COU";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["CRC"] = 37] = "CRC";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["CUC"] = 38] = "CUC";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["CUP"] = 39] = "CUP";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["CVE"] = 40] = "CVE";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["CZK"] = 41] = "CZK";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["DJF"] = 42] = "DJF";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["DKK"] = 43] = "DKK";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["DOP"] = 44] = "DOP";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["DZD"] = 45] = "DZD";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["EGP"] = 46] = "EGP";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["ERN"] = 47] = "ERN";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["ETB"] = 48] = "ETB";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["EUR"] = 49] = "EUR";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["FJD"] = 50] = "FJD";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["FKP"] = 51] = "FKP";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["GBP"] = 52] = "GBP";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["GEL"] = 53] = "GEL";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["GHS"] = 54] = "GHS";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["GIP"] = 55] = "GIP";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["GMD"] = 56] = "GMD";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["GNF"] = 57] = "GNF";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["GTQ"] = 58] = "GTQ";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["GYD"] = 59] = "GYD";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["HKD"] = 60] = "HKD";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["HNL"] = 61] = "HNL";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["HRK"] = 62] = "HRK";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["HTG"] = 63] = "HTG";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["HUF"] = 64] = "HUF";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["IDR"] = 65] = "IDR";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["ILS"] = 66] = "ILS";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["INR"] = 67] = "INR";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["IQD"] = 68] = "IQD";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["IRR"] = 69] = "IRR";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["ISK"] = 70] = "ISK";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["JMD"] = 71] = "JMD";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["JOD"] = 72] = "JOD";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["JPY"] = 73] = "JPY";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["KES"] = 74] = "KES";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["KGS"] = 75] = "KGS";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["KHR"] = 76] = "KHR";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["KMF"] = 77] = "KMF";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["KPW"] = 78] = "KPW";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["KRW"] = 79] = "KRW";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["KWD"] = 80] = "KWD";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["KYD"] = 81] = "KYD";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["KZT"] = 82] = "KZT";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["LAK"] = 83] = "LAK";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["LBP"] = 84] = "LBP";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["LKR"] = 85] = "LKR";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["LRD"] = 86] = "LRD";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["LSL"] = 87] = "LSL";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["LYD"] = 88] = "LYD";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["MAD"] = 89] = "MAD";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["MDL"] = 90] = "MDL";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["MGA"] = 91] = "MGA";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["MKD"] = 92] = "MKD";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["MMK"] = 93] = "MMK";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["MNT"] = 94] = "MNT";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["MOP"] = 95] = "MOP";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["MRO"] = 96] = "MRO";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["MUR"] = 97] = "MUR";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["MVR"] = 98] = "MVR";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["MWK"] = 99] = "MWK";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["MXN"] = 100] = "MXN";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["MXV"] = 101] = "MXV";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["MYR"] = 102] = "MYR";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["MZN"] = 103] = "MZN";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["NAD"] = 104] = "NAD";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["NGN"] = 105] = "NGN";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["NIO"] = 106] = "NIO";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["NOK"] = 107] = "NOK";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["NPR"] = 108] = "NPR";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["NZD"] = 109] = "NZD";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["OMR"] = 110] = "OMR";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["PAB"] = 111] = "PAB";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["PEN"] = 112] = "PEN";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["PGK"] = 113] = "PGK";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["PHP"] = 114] = "PHP";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["PKR"] = 115] = "PKR";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["PLN"] = 116] = "PLN";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["PYG"] = 117] = "PYG";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["QAR"] = 118] = "QAR";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["RON"] = 119] = "RON";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["RSD"] = 120] = "RSD";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["RUB"] = 121] = "RUB";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["RWF"] = 122] = "RWF";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["SAR"] = 123] = "SAR";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["SBD"] = 124] = "SBD";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["SCR"] = 125] = "SCR";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["SDG"] = 126] = "SDG";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["SEK"] = 127] = "SEK";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["SGD"] = 128] = "SGD";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["SHP"] = 129] = "SHP";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["SLL"] = 130] = "SLL";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["SOS"] = 131] = "SOS";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["SRD"] = 132] = "SRD";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["SSP"] = 133] = "SSP";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["STD"] = 134] = "STD";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["SVC"] = 135] = "SVC";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["SYP"] = 136] = "SYP";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["SZL"] = 137] = "SZL";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["THB"] = 138] = "THB";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["TJS"] = 139] = "TJS";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["TMT"] = 140] = "TMT";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["TND"] = 141] = "TND";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["TOP"] = 142] = "TOP";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["TRY"] = 143] = "TRY";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["TTD"] = 144] = "TTD";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["TWD"] = 145] = "TWD";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["TZS"] = 146] = "TZS";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["UAH"] = 147] = "UAH";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["UGX"] = 148] = "UGX";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["USN"] = 149] = "USN";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["UYI"] = 150] = "UYI";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["UYU"] = 151] = "UYU";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["UZS"] = 152] = "UZS";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["VEF"] = 153] = "VEF";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["VND"] = 154] = "VND";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["VUV"] = 155] = "VUV";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["WST"] = 156] = "WST";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["XAF"] = 157] = "XAF";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["XAG"] = 158] = "XAG";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["XAU"] = 159] = "XAU";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["XBA"] = 160] = "XBA";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["XBB"] = 161] = "XBB";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["XBC"] = 162] = "XBC";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["XBD"] = 163] = "XBD";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["XCD"] = 164] = "XCD";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["XDR"] = 165] = "XDR";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["XOF"] = 166] = "XOF";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["XPD"] = 167] = "XPD";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["XPF"] = 168] = "XPF";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["XPT"] = 169] = "XPT";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["XSU"] = 170] = "XSU";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["XTS"] = 171] = "XTS";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["XUA"] = 172] = "XUA";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["XXX"] = 173] = "XXX";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["YER"] = 174] = "YER";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["ZAR"] = 175] = "ZAR";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["ZMW"] = 176] = "ZMW";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["ZWL"] = 177] = "ZWL";
    Money_AlphabeticCurrencyCode[Money_AlphabeticCurrencyCode["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Money_AlphabeticCurrencyCode || (Money_AlphabeticCurrencyCode = {}));
function money_AlphabeticCurrencyCodeFromJSON(object) {
    switch(object){
        case 0:
        case "USD":
            return Money_AlphabeticCurrencyCode.USD;
        case 1:
        case "AED":
            return Money_AlphabeticCurrencyCode.AED;
        case 2:
        case "AFN":
            return Money_AlphabeticCurrencyCode.AFN;
        case 3:
        case "ALL":
            return Money_AlphabeticCurrencyCode.ALL;
        case 4:
        case "AMD":
            return Money_AlphabeticCurrencyCode.AMD;
        case 5:
        case "ANG":
            return Money_AlphabeticCurrencyCode.ANG;
        case 6:
        case "AOA":
            return Money_AlphabeticCurrencyCode.AOA;
        case 7:
        case "ARS":
            return Money_AlphabeticCurrencyCode.ARS;
        case 8:
        case "AUD":
            return Money_AlphabeticCurrencyCode.AUD;
        case 9:
        case "AWG":
            return Money_AlphabeticCurrencyCode.AWG;
        case 10:
        case "AZN":
            return Money_AlphabeticCurrencyCode.AZN;
        case 11:
        case "BAM":
            return Money_AlphabeticCurrencyCode.BAM;
        case 12:
        case "BBD":
            return Money_AlphabeticCurrencyCode.BBD;
        case 13:
        case "BDT":
            return Money_AlphabeticCurrencyCode.BDT;
        case 14:
        case "BGN":
            return Money_AlphabeticCurrencyCode.BGN;
        case 15:
        case "BHD":
            return Money_AlphabeticCurrencyCode.BHD;
        case 16:
        case "BIF":
            return Money_AlphabeticCurrencyCode.BIF;
        case 17:
        case "BMD":
            return Money_AlphabeticCurrencyCode.BMD;
        case 18:
        case "BND":
            return Money_AlphabeticCurrencyCode.BND;
        case 19:
        case "BOB":
            return Money_AlphabeticCurrencyCode.BOB;
        case 20:
        case "BOV":
            return Money_AlphabeticCurrencyCode.BOV;
        case 21:
        case "BRL":
            return Money_AlphabeticCurrencyCode.BRL;
        case 22:
        case "BSD":
            return Money_AlphabeticCurrencyCode.BSD;
        case 23:
        case "BTN":
            return Money_AlphabeticCurrencyCode.BTN;
        case 24:
        case "BWP":
            return Money_AlphabeticCurrencyCode.BWP;
        case 25:
        case "BYN":
            return Money_AlphabeticCurrencyCode.BYN;
        case 26:
        case "BZD":
            return Money_AlphabeticCurrencyCode.BZD;
        case 27:
        case "CAD":
            return Money_AlphabeticCurrencyCode.CAD;
        case 28:
        case "CDF":
            return Money_AlphabeticCurrencyCode.CDF;
        case 29:
        case "CHE":
            return Money_AlphabeticCurrencyCode.CHE;
        case 30:
        case "CHF":
            return Money_AlphabeticCurrencyCode.CHF;
        case 31:
        case "CHW":
            return Money_AlphabeticCurrencyCode.CHW;
        case 32:
        case "CLF":
            return Money_AlphabeticCurrencyCode.CLF;
        case 33:
        case "CLP":
            return Money_AlphabeticCurrencyCode.CLP;
        case 34:
        case "CNY":
            return Money_AlphabeticCurrencyCode.CNY;
        case 35:
        case "COP":
            return Money_AlphabeticCurrencyCode.COP;
        case 36:
        case "COU":
            return Money_AlphabeticCurrencyCode.COU;
        case 37:
        case "CRC":
            return Money_AlphabeticCurrencyCode.CRC;
        case 38:
        case "CUC":
            return Money_AlphabeticCurrencyCode.CUC;
        case 39:
        case "CUP":
            return Money_AlphabeticCurrencyCode.CUP;
        case 40:
        case "CVE":
            return Money_AlphabeticCurrencyCode.CVE;
        case 41:
        case "CZK":
            return Money_AlphabeticCurrencyCode.CZK;
        case 42:
        case "DJF":
            return Money_AlphabeticCurrencyCode.DJF;
        case 43:
        case "DKK":
            return Money_AlphabeticCurrencyCode.DKK;
        case 44:
        case "DOP":
            return Money_AlphabeticCurrencyCode.DOP;
        case 45:
        case "DZD":
            return Money_AlphabeticCurrencyCode.DZD;
        case 46:
        case "EGP":
            return Money_AlphabeticCurrencyCode.EGP;
        case 47:
        case "ERN":
            return Money_AlphabeticCurrencyCode.ERN;
        case 48:
        case "ETB":
            return Money_AlphabeticCurrencyCode.ETB;
        case 49:
        case "EUR":
            return Money_AlphabeticCurrencyCode.EUR;
        case 50:
        case "FJD":
            return Money_AlphabeticCurrencyCode.FJD;
        case 51:
        case "FKP":
            return Money_AlphabeticCurrencyCode.FKP;
        case 52:
        case "GBP":
            return Money_AlphabeticCurrencyCode.GBP;
        case 53:
        case "GEL":
            return Money_AlphabeticCurrencyCode.GEL;
        case 54:
        case "GHS":
            return Money_AlphabeticCurrencyCode.GHS;
        case 55:
        case "GIP":
            return Money_AlphabeticCurrencyCode.GIP;
        case 56:
        case "GMD":
            return Money_AlphabeticCurrencyCode.GMD;
        case 57:
        case "GNF":
            return Money_AlphabeticCurrencyCode.GNF;
        case 58:
        case "GTQ":
            return Money_AlphabeticCurrencyCode.GTQ;
        case 59:
        case "GYD":
            return Money_AlphabeticCurrencyCode.GYD;
        case 60:
        case "HKD":
            return Money_AlphabeticCurrencyCode.HKD;
        case 61:
        case "HNL":
            return Money_AlphabeticCurrencyCode.HNL;
        case 62:
        case "HRK":
            return Money_AlphabeticCurrencyCode.HRK;
        case 63:
        case "HTG":
            return Money_AlphabeticCurrencyCode.HTG;
        case 64:
        case "HUF":
            return Money_AlphabeticCurrencyCode.HUF;
        case 65:
        case "IDR":
            return Money_AlphabeticCurrencyCode.IDR;
        case 66:
        case "ILS":
            return Money_AlphabeticCurrencyCode.ILS;
        case 67:
        case "INR":
            return Money_AlphabeticCurrencyCode.INR;
        case 68:
        case "IQD":
            return Money_AlphabeticCurrencyCode.IQD;
        case 69:
        case "IRR":
            return Money_AlphabeticCurrencyCode.IRR;
        case 70:
        case "ISK":
            return Money_AlphabeticCurrencyCode.ISK;
        case 71:
        case "JMD":
            return Money_AlphabeticCurrencyCode.JMD;
        case 72:
        case "JOD":
            return Money_AlphabeticCurrencyCode.JOD;
        case 73:
        case "JPY":
            return Money_AlphabeticCurrencyCode.JPY;
        case 74:
        case "KES":
            return Money_AlphabeticCurrencyCode.KES;
        case 75:
        case "KGS":
            return Money_AlphabeticCurrencyCode.KGS;
        case 76:
        case "KHR":
            return Money_AlphabeticCurrencyCode.KHR;
        case 77:
        case "KMF":
            return Money_AlphabeticCurrencyCode.KMF;
        case 78:
        case "KPW":
            return Money_AlphabeticCurrencyCode.KPW;
        case 79:
        case "KRW":
            return Money_AlphabeticCurrencyCode.KRW;
        case 80:
        case "KWD":
            return Money_AlphabeticCurrencyCode.KWD;
        case 81:
        case "KYD":
            return Money_AlphabeticCurrencyCode.KYD;
        case 82:
        case "KZT":
            return Money_AlphabeticCurrencyCode.KZT;
        case 83:
        case "LAK":
            return Money_AlphabeticCurrencyCode.LAK;
        case 84:
        case "LBP":
            return Money_AlphabeticCurrencyCode.LBP;
        case 85:
        case "LKR":
            return Money_AlphabeticCurrencyCode.LKR;
        case 86:
        case "LRD":
            return Money_AlphabeticCurrencyCode.LRD;
        case 87:
        case "LSL":
            return Money_AlphabeticCurrencyCode.LSL;
        case 88:
        case "LYD":
            return Money_AlphabeticCurrencyCode.LYD;
        case 89:
        case "MAD":
            return Money_AlphabeticCurrencyCode.MAD;
        case 90:
        case "MDL":
            return Money_AlphabeticCurrencyCode.MDL;
        case 91:
        case "MGA":
            return Money_AlphabeticCurrencyCode.MGA;
        case 92:
        case "MKD":
            return Money_AlphabeticCurrencyCode.MKD;
        case 93:
        case "MMK":
            return Money_AlphabeticCurrencyCode.MMK;
        case 94:
        case "MNT":
            return Money_AlphabeticCurrencyCode.MNT;
        case 95:
        case "MOP":
            return Money_AlphabeticCurrencyCode.MOP;
        case 96:
        case "MRO":
            return Money_AlphabeticCurrencyCode.MRO;
        case 97:
        case "MUR":
            return Money_AlphabeticCurrencyCode.MUR;
        case 98:
        case "MVR":
            return Money_AlphabeticCurrencyCode.MVR;
        case 99:
        case "MWK":
            return Money_AlphabeticCurrencyCode.MWK;
        case 100:
        case "MXN":
            return Money_AlphabeticCurrencyCode.MXN;
        case 101:
        case "MXV":
            return Money_AlphabeticCurrencyCode.MXV;
        case 102:
        case "MYR":
            return Money_AlphabeticCurrencyCode.MYR;
        case 103:
        case "MZN":
            return Money_AlphabeticCurrencyCode.MZN;
        case 104:
        case "NAD":
            return Money_AlphabeticCurrencyCode.NAD;
        case 105:
        case "NGN":
            return Money_AlphabeticCurrencyCode.NGN;
        case 106:
        case "NIO":
            return Money_AlphabeticCurrencyCode.NIO;
        case 107:
        case "NOK":
            return Money_AlphabeticCurrencyCode.NOK;
        case 108:
        case "NPR":
            return Money_AlphabeticCurrencyCode.NPR;
        case 109:
        case "NZD":
            return Money_AlphabeticCurrencyCode.NZD;
        case 110:
        case "OMR":
            return Money_AlphabeticCurrencyCode.OMR;
        case 111:
        case "PAB":
            return Money_AlphabeticCurrencyCode.PAB;
        case 112:
        case "PEN":
            return Money_AlphabeticCurrencyCode.PEN;
        case 113:
        case "PGK":
            return Money_AlphabeticCurrencyCode.PGK;
        case 114:
        case "PHP":
            return Money_AlphabeticCurrencyCode.PHP;
        case 115:
        case "PKR":
            return Money_AlphabeticCurrencyCode.PKR;
        case 116:
        case "PLN":
            return Money_AlphabeticCurrencyCode.PLN;
        case 117:
        case "PYG":
            return Money_AlphabeticCurrencyCode.PYG;
        case 118:
        case "QAR":
            return Money_AlphabeticCurrencyCode.QAR;
        case 119:
        case "RON":
            return Money_AlphabeticCurrencyCode.RON;
        case 120:
        case "RSD":
            return Money_AlphabeticCurrencyCode.RSD;
        case 121:
        case "RUB":
            return Money_AlphabeticCurrencyCode.RUB;
        case 122:
        case "RWF":
            return Money_AlphabeticCurrencyCode.RWF;
        case 123:
        case "SAR":
            return Money_AlphabeticCurrencyCode.SAR;
        case 124:
        case "SBD":
            return Money_AlphabeticCurrencyCode.SBD;
        case 125:
        case "SCR":
            return Money_AlphabeticCurrencyCode.SCR;
        case 126:
        case "SDG":
            return Money_AlphabeticCurrencyCode.SDG;
        case 127:
        case "SEK":
            return Money_AlphabeticCurrencyCode.SEK;
        case 128:
        case "SGD":
            return Money_AlphabeticCurrencyCode.SGD;
        case 129:
        case "SHP":
            return Money_AlphabeticCurrencyCode.SHP;
        case 130:
        case "SLL":
            return Money_AlphabeticCurrencyCode.SLL;
        case 131:
        case "SOS":
            return Money_AlphabeticCurrencyCode.SOS;
        case 132:
        case "SRD":
            return Money_AlphabeticCurrencyCode.SRD;
        case 133:
        case "SSP":
            return Money_AlphabeticCurrencyCode.SSP;
        case 134:
        case "STD":
            return Money_AlphabeticCurrencyCode.STD;
        case 135:
        case "SVC":
            return Money_AlphabeticCurrencyCode.SVC;
        case 136:
        case "SYP":
            return Money_AlphabeticCurrencyCode.SYP;
        case 137:
        case "SZL":
            return Money_AlphabeticCurrencyCode.SZL;
        case 138:
        case "THB":
            return Money_AlphabeticCurrencyCode.THB;
        case 139:
        case "TJS":
            return Money_AlphabeticCurrencyCode.TJS;
        case 140:
        case "TMT":
            return Money_AlphabeticCurrencyCode.TMT;
        case 141:
        case "TND":
            return Money_AlphabeticCurrencyCode.TND;
        case 142:
        case "TOP":
            return Money_AlphabeticCurrencyCode.TOP;
        case 143:
        case "TRY":
            return Money_AlphabeticCurrencyCode.TRY;
        case 144:
        case "TTD":
            return Money_AlphabeticCurrencyCode.TTD;
        case 145:
        case "TWD":
            return Money_AlphabeticCurrencyCode.TWD;
        case 146:
        case "TZS":
            return Money_AlphabeticCurrencyCode.TZS;
        case 147:
        case "UAH":
            return Money_AlphabeticCurrencyCode.UAH;
        case 148:
        case "UGX":
            return Money_AlphabeticCurrencyCode.UGX;
        case 149:
        case "USN":
            return Money_AlphabeticCurrencyCode.USN;
        case 150:
        case "UYI":
            return Money_AlphabeticCurrencyCode.UYI;
        case 151:
        case "UYU":
            return Money_AlphabeticCurrencyCode.UYU;
        case 152:
        case "UZS":
            return Money_AlphabeticCurrencyCode.UZS;
        case 153:
        case "VEF":
            return Money_AlphabeticCurrencyCode.VEF;
        case 154:
        case "VND":
            return Money_AlphabeticCurrencyCode.VND;
        case 155:
        case "VUV":
            return Money_AlphabeticCurrencyCode.VUV;
        case 156:
        case "WST":
            return Money_AlphabeticCurrencyCode.WST;
        case 157:
        case "XAF":
            return Money_AlphabeticCurrencyCode.XAF;
        case 158:
        case "XAG":
            return Money_AlphabeticCurrencyCode.XAG;
        case 159:
        case "XAU":
            return Money_AlphabeticCurrencyCode.XAU;
        case 160:
        case "XBA":
            return Money_AlphabeticCurrencyCode.XBA;
        case 161:
        case "XBB":
            return Money_AlphabeticCurrencyCode.XBB;
        case 162:
        case "XBC":
            return Money_AlphabeticCurrencyCode.XBC;
        case 163:
        case "XBD":
            return Money_AlphabeticCurrencyCode.XBD;
        case 164:
        case "XCD":
            return Money_AlphabeticCurrencyCode.XCD;
        case 165:
        case "XDR":
            return Money_AlphabeticCurrencyCode.XDR;
        case 166:
        case "XOF":
            return Money_AlphabeticCurrencyCode.XOF;
        case 167:
        case "XPD":
            return Money_AlphabeticCurrencyCode.XPD;
        case 168:
        case "XPF":
            return Money_AlphabeticCurrencyCode.XPF;
        case 169:
        case "XPT":
            return Money_AlphabeticCurrencyCode.XPT;
        case 170:
        case "XSU":
            return Money_AlphabeticCurrencyCode.XSU;
        case 171:
        case "XTS":
            return Money_AlphabeticCurrencyCode.XTS;
        case 172:
        case "XUA":
            return Money_AlphabeticCurrencyCode.XUA;
        case 173:
        case "XXX":
            return Money_AlphabeticCurrencyCode.XXX;
        case 174:
        case "YER":
            return Money_AlphabeticCurrencyCode.YER;
        case 175:
        case "ZAR":
            return Money_AlphabeticCurrencyCode.ZAR;
        case 176:
        case "ZMW":
            return Money_AlphabeticCurrencyCode.ZMW;
        case 177:
        case "ZWL":
            return Money_AlphabeticCurrencyCode.ZWL;
        case -1:
        case "UNRECOGNIZED":
        default:
            return Money_AlphabeticCurrencyCode.UNRECOGNIZED;
    }
}
function money_AlphabeticCurrencyCodeToJSON(object) {
    switch(object){
        case Money_AlphabeticCurrencyCode.USD:
            return "USD";
        case Money_AlphabeticCurrencyCode.AED:
            return "AED";
        case Money_AlphabeticCurrencyCode.AFN:
            return "AFN";
        case Money_AlphabeticCurrencyCode.ALL:
            return "ALL";
        case Money_AlphabeticCurrencyCode.AMD:
            return "AMD";
        case Money_AlphabeticCurrencyCode.ANG:
            return "ANG";
        case Money_AlphabeticCurrencyCode.AOA:
            return "AOA";
        case Money_AlphabeticCurrencyCode.ARS:
            return "ARS";
        case Money_AlphabeticCurrencyCode.AUD:
            return "AUD";
        case Money_AlphabeticCurrencyCode.AWG:
            return "AWG";
        case Money_AlphabeticCurrencyCode.AZN:
            return "AZN";
        case Money_AlphabeticCurrencyCode.BAM:
            return "BAM";
        case Money_AlphabeticCurrencyCode.BBD:
            return "BBD";
        case Money_AlphabeticCurrencyCode.BDT:
            return "BDT";
        case Money_AlphabeticCurrencyCode.BGN:
            return "BGN";
        case Money_AlphabeticCurrencyCode.BHD:
            return "BHD";
        case Money_AlphabeticCurrencyCode.BIF:
            return "BIF";
        case Money_AlphabeticCurrencyCode.BMD:
            return "BMD";
        case Money_AlphabeticCurrencyCode.BND:
            return "BND";
        case Money_AlphabeticCurrencyCode.BOB:
            return "BOB";
        case Money_AlphabeticCurrencyCode.BOV:
            return "BOV";
        case Money_AlphabeticCurrencyCode.BRL:
            return "BRL";
        case Money_AlphabeticCurrencyCode.BSD:
            return "BSD";
        case Money_AlphabeticCurrencyCode.BTN:
            return "BTN";
        case Money_AlphabeticCurrencyCode.BWP:
            return "BWP";
        case Money_AlphabeticCurrencyCode.BYN:
            return "BYN";
        case Money_AlphabeticCurrencyCode.BZD:
            return "BZD";
        case Money_AlphabeticCurrencyCode.CAD:
            return "CAD";
        case Money_AlphabeticCurrencyCode.CDF:
            return "CDF";
        case Money_AlphabeticCurrencyCode.CHE:
            return "CHE";
        case Money_AlphabeticCurrencyCode.CHF:
            return "CHF";
        case Money_AlphabeticCurrencyCode.CHW:
            return "CHW";
        case Money_AlphabeticCurrencyCode.CLF:
            return "CLF";
        case Money_AlphabeticCurrencyCode.CLP:
            return "CLP";
        case Money_AlphabeticCurrencyCode.CNY:
            return "CNY";
        case Money_AlphabeticCurrencyCode.COP:
            return "COP";
        case Money_AlphabeticCurrencyCode.COU:
            return "COU";
        case Money_AlphabeticCurrencyCode.CRC:
            return "CRC";
        case Money_AlphabeticCurrencyCode.CUC:
            return "CUC";
        case Money_AlphabeticCurrencyCode.CUP:
            return "CUP";
        case Money_AlphabeticCurrencyCode.CVE:
            return "CVE";
        case Money_AlphabeticCurrencyCode.CZK:
            return "CZK";
        case Money_AlphabeticCurrencyCode.DJF:
            return "DJF";
        case Money_AlphabeticCurrencyCode.DKK:
            return "DKK";
        case Money_AlphabeticCurrencyCode.DOP:
            return "DOP";
        case Money_AlphabeticCurrencyCode.DZD:
            return "DZD";
        case Money_AlphabeticCurrencyCode.EGP:
            return "EGP";
        case Money_AlphabeticCurrencyCode.ERN:
            return "ERN";
        case Money_AlphabeticCurrencyCode.ETB:
            return "ETB";
        case Money_AlphabeticCurrencyCode.EUR:
            return "EUR";
        case Money_AlphabeticCurrencyCode.FJD:
            return "FJD";
        case Money_AlphabeticCurrencyCode.FKP:
            return "FKP";
        case Money_AlphabeticCurrencyCode.GBP:
            return "GBP";
        case Money_AlphabeticCurrencyCode.GEL:
            return "GEL";
        case Money_AlphabeticCurrencyCode.GHS:
            return "GHS";
        case Money_AlphabeticCurrencyCode.GIP:
            return "GIP";
        case Money_AlphabeticCurrencyCode.GMD:
            return "GMD";
        case Money_AlphabeticCurrencyCode.GNF:
            return "GNF";
        case Money_AlphabeticCurrencyCode.GTQ:
            return "GTQ";
        case Money_AlphabeticCurrencyCode.GYD:
            return "GYD";
        case Money_AlphabeticCurrencyCode.HKD:
            return "HKD";
        case Money_AlphabeticCurrencyCode.HNL:
            return "HNL";
        case Money_AlphabeticCurrencyCode.HRK:
            return "HRK";
        case Money_AlphabeticCurrencyCode.HTG:
            return "HTG";
        case Money_AlphabeticCurrencyCode.HUF:
            return "HUF";
        case Money_AlphabeticCurrencyCode.IDR:
            return "IDR";
        case Money_AlphabeticCurrencyCode.ILS:
            return "ILS";
        case Money_AlphabeticCurrencyCode.INR:
            return "INR";
        case Money_AlphabeticCurrencyCode.IQD:
            return "IQD";
        case Money_AlphabeticCurrencyCode.IRR:
            return "IRR";
        case Money_AlphabeticCurrencyCode.ISK:
            return "ISK";
        case Money_AlphabeticCurrencyCode.JMD:
            return "JMD";
        case Money_AlphabeticCurrencyCode.JOD:
            return "JOD";
        case Money_AlphabeticCurrencyCode.JPY:
            return "JPY";
        case Money_AlphabeticCurrencyCode.KES:
            return "KES";
        case Money_AlphabeticCurrencyCode.KGS:
            return "KGS";
        case Money_AlphabeticCurrencyCode.KHR:
            return "KHR";
        case Money_AlphabeticCurrencyCode.KMF:
            return "KMF";
        case Money_AlphabeticCurrencyCode.KPW:
            return "KPW";
        case Money_AlphabeticCurrencyCode.KRW:
            return "KRW";
        case Money_AlphabeticCurrencyCode.KWD:
            return "KWD";
        case Money_AlphabeticCurrencyCode.KYD:
            return "KYD";
        case Money_AlphabeticCurrencyCode.KZT:
            return "KZT";
        case Money_AlphabeticCurrencyCode.LAK:
            return "LAK";
        case Money_AlphabeticCurrencyCode.LBP:
            return "LBP";
        case Money_AlphabeticCurrencyCode.LKR:
            return "LKR";
        case Money_AlphabeticCurrencyCode.LRD:
            return "LRD";
        case Money_AlphabeticCurrencyCode.LSL:
            return "LSL";
        case Money_AlphabeticCurrencyCode.LYD:
            return "LYD";
        case Money_AlphabeticCurrencyCode.MAD:
            return "MAD";
        case Money_AlphabeticCurrencyCode.MDL:
            return "MDL";
        case Money_AlphabeticCurrencyCode.MGA:
            return "MGA";
        case Money_AlphabeticCurrencyCode.MKD:
            return "MKD";
        case Money_AlphabeticCurrencyCode.MMK:
            return "MMK";
        case Money_AlphabeticCurrencyCode.MNT:
            return "MNT";
        case Money_AlphabeticCurrencyCode.MOP:
            return "MOP";
        case Money_AlphabeticCurrencyCode.MRO:
            return "MRO";
        case Money_AlphabeticCurrencyCode.MUR:
            return "MUR";
        case Money_AlphabeticCurrencyCode.MVR:
            return "MVR";
        case Money_AlphabeticCurrencyCode.MWK:
            return "MWK";
        case Money_AlphabeticCurrencyCode.MXN:
            return "MXN";
        case Money_AlphabeticCurrencyCode.MXV:
            return "MXV";
        case Money_AlphabeticCurrencyCode.MYR:
            return "MYR";
        case Money_AlphabeticCurrencyCode.MZN:
            return "MZN";
        case Money_AlphabeticCurrencyCode.NAD:
            return "NAD";
        case Money_AlphabeticCurrencyCode.NGN:
            return "NGN";
        case Money_AlphabeticCurrencyCode.NIO:
            return "NIO";
        case Money_AlphabeticCurrencyCode.NOK:
            return "NOK";
        case Money_AlphabeticCurrencyCode.NPR:
            return "NPR";
        case Money_AlphabeticCurrencyCode.NZD:
            return "NZD";
        case Money_AlphabeticCurrencyCode.OMR:
            return "OMR";
        case Money_AlphabeticCurrencyCode.PAB:
            return "PAB";
        case Money_AlphabeticCurrencyCode.PEN:
            return "PEN";
        case Money_AlphabeticCurrencyCode.PGK:
            return "PGK";
        case Money_AlphabeticCurrencyCode.PHP:
            return "PHP";
        case Money_AlphabeticCurrencyCode.PKR:
            return "PKR";
        case Money_AlphabeticCurrencyCode.PLN:
            return "PLN";
        case Money_AlphabeticCurrencyCode.PYG:
            return "PYG";
        case Money_AlphabeticCurrencyCode.QAR:
            return "QAR";
        case Money_AlphabeticCurrencyCode.RON:
            return "RON";
        case Money_AlphabeticCurrencyCode.RSD:
            return "RSD";
        case Money_AlphabeticCurrencyCode.RUB:
            return "RUB";
        case Money_AlphabeticCurrencyCode.RWF:
            return "RWF";
        case Money_AlphabeticCurrencyCode.SAR:
            return "SAR";
        case Money_AlphabeticCurrencyCode.SBD:
            return "SBD";
        case Money_AlphabeticCurrencyCode.SCR:
            return "SCR";
        case Money_AlphabeticCurrencyCode.SDG:
            return "SDG";
        case Money_AlphabeticCurrencyCode.SEK:
            return "SEK";
        case Money_AlphabeticCurrencyCode.SGD:
            return "SGD";
        case Money_AlphabeticCurrencyCode.SHP:
            return "SHP";
        case Money_AlphabeticCurrencyCode.SLL:
            return "SLL";
        case Money_AlphabeticCurrencyCode.SOS:
            return "SOS";
        case Money_AlphabeticCurrencyCode.SRD:
            return "SRD";
        case Money_AlphabeticCurrencyCode.SSP:
            return "SSP";
        case Money_AlphabeticCurrencyCode.STD:
            return "STD";
        case Money_AlphabeticCurrencyCode.SVC:
            return "SVC";
        case Money_AlphabeticCurrencyCode.SYP:
            return "SYP";
        case Money_AlphabeticCurrencyCode.SZL:
            return "SZL";
        case Money_AlphabeticCurrencyCode.THB:
            return "THB";
        case Money_AlphabeticCurrencyCode.TJS:
            return "TJS";
        case Money_AlphabeticCurrencyCode.TMT:
            return "TMT";
        case Money_AlphabeticCurrencyCode.TND:
            return "TND";
        case Money_AlphabeticCurrencyCode.TOP:
            return "TOP";
        case Money_AlphabeticCurrencyCode.TRY:
            return "TRY";
        case Money_AlphabeticCurrencyCode.TTD:
            return "TTD";
        case Money_AlphabeticCurrencyCode.TWD:
            return "TWD";
        case Money_AlphabeticCurrencyCode.TZS:
            return "TZS";
        case Money_AlphabeticCurrencyCode.UAH:
            return "UAH";
        case Money_AlphabeticCurrencyCode.UGX:
            return "UGX";
        case Money_AlphabeticCurrencyCode.USN:
            return "USN";
        case Money_AlphabeticCurrencyCode.UYI:
            return "UYI";
        case Money_AlphabeticCurrencyCode.UYU:
            return "UYU";
        case Money_AlphabeticCurrencyCode.UZS:
            return "UZS";
        case Money_AlphabeticCurrencyCode.VEF:
            return "VEF";
        case Money_AlphabeticCurrencyCode.VND:
            return "VND";
        case Money_AlphabeticCurrencyCode.VUV:
            return "VUV";
        case Money_AlphabeticCurrencyCode.WST:
            return "WST";
        case Money_AlphabeticCurrencyCode.XAF:
            return "XAF";
        case Money_AlphabeticCurrencyCode.XAG:
            return "XAG";
        case Money_AlphabeticCurrencyCode.XAU:
            return "XAU";
        case Money_AlphabeticCurrencyCode.XBA:
            return "XBA";
        case Money_AlphabeticCurrencyCode.XBB:
            return "XBB";
        case Money_AlphabeticCurrencyCode.XBC:
            return "XBC";
        case Money_AlphabeticCurrencyCode.XBD:
            return "XBD";
        case Money_AlphabeticCurrencyCode.XCD:
            return "XCD";
        case Money_AlphabeticCurrencyCode.XDR:
            return "XDR";
        case Money_AlphabeticCurrencyCode.XOF:
            return "XOF";
        case Money_AlphabeticCurrencyCode.XPD:
            return "XPD";
        case Money_AlphabeticCurrencyCode.XPF:
            return "XPF";
        case Money_AlphabeticCurrencyCode.XPT:
            return "XPT";
        case Money_AlphabeticCurrencyCode.XSU:
            return "XSU";
        case Money_AlphabeticCurrencyCode.XTS:
            return "XTS";
        case Money_AlphabeticCurrencyCode.XUA:
            return "XUA";
        case Money_AlphabeticCurrencyCode.XXX:
            return "XXX";
        case Money_AlphabeticCurrencyCode.YER:
            return "YER";
        case Money_AlphabeticCurrencyCode.ZAR:
            return "ZAR";
        case Money_AlphabeticCurrencyCode.ZMW:
            return "ZMW";
        case Money_AlphabeticCurrencyCode.ZWL:
            return "ZWL";
        case Money_AlphabeticCurrencyCode.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
function createBaseMoney() {
    return {
        currencyCode: 0,
        value: 0
    };
}
var Money = {
    fromJSON: function fromJSON(object) {
        return {
            currencyCode: money_isSet(object.currencyCode) ? money_AlphabeticCurrencyCodeFromJSON(object.currencyCode) : 0,
            value: money_isSet(object.value) ? Number(object.value) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.currencyCode !== 0) {
            obj.currencyCode = money_AlphabeticCurrencyCodeToJSON(message.currencyCode);
        }
        if (message.value !== 0) {
            obj.value = Math.round(message.value);
        }
        return obj;
    },
    create: function create(base) {
        return Money.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseMoney();
        var _currencyCode;
        message.currencyCode = (_currencyCode = object.currencyCode) !== null && _currencyCode !== void 0 ? _currencyCode : 0;
        var _value;
        message.value = (_value = object.value) !== null && _value !== void 0 ? _value : 0;
        return message;
    }
};
function createBaseFee() {
    return {
        amount: undefined,
        recurringPeriod: undefined,
        description: ""
    };
}
var Fee = {
    fromJSON: function fromJSON(object) {
        return {
            amount: money_isSet(object.amount) ? Money.fromJSON(object.amount) : undefined,
            recurringPeriod: money_isSet(object.recurringPeriod) ? Duration.fromJSON(object.recurringPeriod) : undefined,
            description: money_isSet(object.description) ? String(object.description) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.amount !== undefined) {
            obj.amount = Money.toJSON(message.amount);
        }
        if (message.recurringPeriod !== undefined) {
            obj.recurringPeriod = Duration.toJSON(message.recurringPeriod);
        }
        if (message.description !== "") {
            obj.description = message.description;
        }
        return obj;
    },
    create: function create(base) {
        return Fee.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseFee();
        message.amount = object.amount !== undefined && object.amount !== null ? Money.fromPartial(object.amount) : undefined;
        message.recurringPeriod = object.recurringPeriod !== undefined && object.recurringPeriod !== null ? Duration.fromPartial(object.recurringPeriod) : undefined;
        var _description;
        message.description = (_description = object.description) !== null && _description !== void 0 ? _description : "";
        return message;
    }
};
function money_isSet(value) {
    return value !== null && value !== undefined;
}

;// CONCATENATED MODULE: ./src/__generated__/protobuf/ballpark/data/home_value.ts
/* eslint-disable */ 
var home_value_protobufPackage = "od_protos.ballpark.data";
var Source;
(function(Source) {
    Source[Source["UNKNOWN_SOURCE"] = 0] = "UNKNOWN_SOURCE";
    Source[Source["BULK_OVM"] = 1] = "BULK_OVM";
    Source[Source["REALTY_TRAC"] = 2] = "REALTY_TRAC";
    Source[Source["NATIONWIDE_VALUATIONS_ENSEMBLER"] = 3] = "NATIONWIDE_VALUATIONS_ENSEMBLER";
    Source[Source["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Source || (Source = {}));
function sourceFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN_SOURCE":
            return Source.UNKNOWN_SOURCE;
        case 1:
        case "BULK_OVM":
            return Source.BULK_OVM;
        case 2:
        case "REALTY_TRAC":
            return Source.REALTY_TRAC;
        case 3:
        case "NATIONWIDE_VALUATIONS_ENSEMBLER":
            return Source.NATIONWIDE_VALUATIONS_ENSEMBLER;
        case -1:
        case "UNRECOGNIZED":
        default:
            return Source.UNRECOGNIZED;
    }
}
function sourceToJSON(object) {
    switch(object){
        case Source.UNKNOWN_SOURCE:
            return "UNKNOWN_SOURCE";
        case Source.BULK_OVM:
            return "BULK_OVM";
        case Source.REALTY_TRAC:
            return "REALTY_TRAC";
        case Source.NATIONWIDE_VALUATIONS_ENSEMBLER:
            return "NATIONWIDE_VALUATIONS_ENSEMBLER";
        case Source.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
function createBaseHomeValue() {
    return {
        addressUuid: "",
        valuationCents: 0,
        valuationCeilingCents: 0,
        valuationFloorCents: 0,
        comps: [],
        source: 0,
        headlinePrice: undefined,
        headlineRangeLower: undefined,
        headlineRangeUpper: undefined,
        expectedError: undefined
    };
}
var HomeValue = {
    fromJSON: function fromJSON(object) {
        return {
            addressUuid: home_value_isSet(object.addressUuid) ? String(object.addressUuid) : "",
            valuationCents: home_value_isSet(object.valuationCents) ? Number(object.valuationCents) : 0,
            valuationCeilingCents: home_value_isSet(object.valuationCeilingCents) ? Number(object.valuationCeilingCents) : 0,
            valuationFloorCents: home_value_isSet(object.valuationFloorCents) ? Number(object.valuationFloorCents) : 0,
            comps: Array.isArray(object === null || object === void 0 ? void 0 : object.comps) ? object.comps.map(function(e) {
                return Comp.fromJSON(e);
            }) : [],
            source: home_value_isSet(object.source) ? sourceFromJSON(object.source) : 0,
            headlinePrice: home_value_isSet(object.headlinePrice) ? Money.fromJSON(object.headlinePrice) : undefined,
            headlineRangeLower: home_value_isSet(object.headlineRangeLower) ? Money.fromJSON(object.headlineRangeLower) : undefined,
            headlineRangeUpper: home_value_isSet(object.headlineRangeUpper) ? Money.fromJSON(object.headlineRangeUpper) : undefined,
            expectedError: home_value_isSet(object.expectedError) ? Number(object.expectedError) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var ref;
        var obj = {};
        if (message.addressUuid !== "") {
            obj.addressUuid = message.addressUuid;
        }
        if (message.valuationCents !== 0) {
            obj.valuationCents = Math.round(message.valuationCents);
        }
        if (message.valuationCeilingCents !== 0) {
            obj.valuationCeilingCents = Math.round(message.valuationCeilingCents);
        }
        if (message.valuationFloorCents !== 0) {
            obj.valuationFloorCents = Math.round(message.valuationFloorCents);
        }
        if ((ref = message.comps) === null || ref === void 0 ? void 0 : ref.length) {
            obj.comps = message.comps.map(function(e) {
                return Comp.toJSON(e);
            });
        }
        if (message.source !== 0) {
            obj.source = sourceToJSON(message.source);
        }
        if (message.headlinePrice !== undefined) {
            obj.headlinePrice = Money.toJSON(message.headlinePrice);
        }
        if (message.headlineRangeLower !== undefined) {
            obj.headlineRangeLower = Money.toJSON(message.headlineRangeLower);
        }
        if (message.headlineRangeUpper !== undefined) {
            obj.headlineRangeUpper = Money.toJSON(message.headlineRangeUpper);
        }
        if (message.expectedError !== undefined) {
            obj.expectedError = message.expectedError;
        }
        return obj;
    },
    create: function create(base) {
        return HomeValue.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref;
        var message = createBaseHomeValue();
        var _addressUuid;
        message.addressUuid = (_addressUuid = object.addressUuid) !== null && _addressUuid !== void 0 ? _addressUuid : "";
        var _valuationCents;
        message.valuationCents = (_valuationCents = object.valuationCents) !== null && _valuationCents !== void 0 ? _valuationCents : 0;
        var _valuationCeilingCents;
        message.valuationCeilingCents = (_valuationCeilingCents = object.valuationCeilingCents) !== null && _valuationCeilingCents !== void 0 ? _valuationCeilingCents : 0;
        var _valuationFloorCents;
        message.valuationFloorCents = (_valuationFloorCents = object.valuationFloorCents) !== null && _valuationFloorCents !== void 0 ? _valuationFloorCents : 0;
        message.comps = ((ref = object.comps) === null || ref === void 0 ? void 0 : ref.map(function(e) {
            return Comp.fromPartial(e);
        })) || [];
        var _source;
        message.source = (_source = object.source) !== null && _source !== void 0 ? _source : 0;
        message.headlinePrice = object.headlinePrice !== undefined && object.headlinePrice !== null ? Money.fromPartial(object.headlinePrice) : undefined;
        message.headlineRangeLower = object.headlineRangeLower !== undefined && object.headlineRangeLower !== null ? Money.fromPartial(object.headlineRangeLower) : undefined;
        message.headlineRangeUpper = object.headlineRangeUpper !== undefined && object.headlineRangeUpper !== null ? Money.fromPartial(object.headlineRangeUpper) : undefined;
        var _expectedError;
        message.expectedError = (_expectedError = object.expectedError) !== null && _expectedError !== void 0 ? _expectedError : undefined;
        return message;
    }
};
function createBaseComp() {
    return {
        addressUuid: ""
    };
}
var Comp = {
    fromJSON: function fromJSON(object) {
        return {
            addressUuid: home_value_isSet(object.addressUuid) ? String(object.addressUuid) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.addressUuid !== "") {
            obj.addressUuid = message.addressUuid;
        }
        return obj;
    },
    create: function create(base) {
        return Comp.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseComp();
        var _addressUuid;
        message.addressUuid = (_addressUuid = object.addressUuid) !== null && _addressUuid !== void 0 ? _addressUuid : "";
        return message;
    }
};
function home_value_isSet(value) {
    return value !== null && value !== undefined;
}

;// CONCATENATED MODULE: ./src/__generated__/protobuf/mortgage/data/credit_range.ts
/* eslint-disable */ var credit_range_protobufPackage = "od_protos.mortgage.data";
function createBaseCreditRange() {
    return {
        min: 0,
        max: 0
    };
}
var CreditRange = {
    fromJSON: function fromJSON(object) {
        return {
            min: credit_range_isSet(object.min) ? Number(object.min) : 0,
            max: credit_range_isSet(object.max) ? Number(object.max) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.min !== 0) {
            obj.min = Math.round(message.min);
        }
        if (message.max !== 0) {
            obj.max = Math.round(message.max);
        }
        return obj;
    },
    create: function create(base) {
        return CreditRange.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseCreditRange();
        var _min;
        message.min = (_min = object.min) !== null && _min !== void 0 ? _min : 0;
        var _max;
        message.max = (_max = object.max) !== null && _max !== void 0 ? _max : 0;
        return message;
    }
};
function credit_range_isSet(value) {
    return value !== null && value !== undefined;
}

;// CONCATENATED MODULE: ./src/__generated__/protobuf/sell/reception/data/answers.ts
/* eslint-disable */ 
var answers_protobufPackage = "od_protos.sell.reception.data";
function createBaseAnswers() {
    return {
        addition: undefined,
        backYardCondition: undefined,
        backYardSlope: undefined,
        backYardSlopeRetainingWall: undefined,
        backYardSlopeType: undefined,
        basement: undefined,
        basementFinishedSqFt: undefined,
        basementSqFt: undefined,
        basementSqFtTriage: undefined,
        basementUnfinishedSqFt: undefined,
        bathroomCondition: undefined,
        masterBathroomCondition: undefined,
        bathroomRemodel: undefined,
        bathrooms: undefined,
        bathroomsFull: undefined,
        bathroomsHalf: undefined,
        bedrooms: undefined,
        bedroomsTriage: undefined,
        carportSpaces: undefined,
        dwellingType: undefined,
        entryTypes: undefined,
        exteriorFacade: undefined,
        exteriorStories: undefined,
        floodZoneTriage: undefined,
        flooringCarpetCondition: undefined,
        flooringFollowUpLiving: undefined,
        flooringFollowUpMasterBedroom: undefined,
        flooringHardwoodCondition: undefined,
        flooringLaminateCondition: undefined,
        flooringPrimaryFloorCondition: undefined,
        flooringPrimaryFloorType: undefined,
        flooringSecondaryFloorCondition: undefined,
        flooringSecondaryFloorType: undefined,
        flooringTileCondition: undefined,
        foundationIssue: undefined,
        garageSpaces: undefined,
        hoa: undefined,
        hoaTypes: undefined,
        hoaFees: undefined,
        interiorPaintCondition: undefined,
        interiorPaintNeutral: undefined,
        kitchenApplianceType: undefined,
        kitchenCondition: undefined,
        kitchenCounterType: undefined,
        kitchenRemodel: undefined,
        leasedSolarPanelsTriage: undefined,
        lotOwnership: undefined,
        masterBedroomFloor: undefined,
        poolType: undefined,
        sharedEntrance: undefined,
        solarPanelsOwnershipType: undefined,
        sqFt: undefined,
        aboveGradeSqFt: undefined,
        sqFtTriage: undefined,
        yearBuilt: undefined,
        selfServiceVirtualAssessmentChoice: undefined,
        hasUpgrades: undefined,
        userVerifiedAddress: undefined,
        listed: undefined,
        kitchenSellerScore: undefined,
        bathroomSellerScore: undefined,
        livingRoomSellerScore: undefined,
        exteriorSellerScore: undefined,
        propertyCondition: undefined,
        activelyLooking: undefined,
        agent: undefined,
        brokerage: undefined,
        email: undefined,
        signedListingAgreement: undefined,
        priceEstimateRange: undefined,
        optedIntoExclusiveOffers: undefined,
        buyingNextHome: undefined,
        buyingNextHomeStatus: undefined,
        sellingTimelineFlexibility: undefined,
        willingnessForTours: undefined,
        currentlyInSellingProcess: undefined,
        showingPreference: undefined,
        exclusivesCustomerPhoneNumber: undefined,
        exclusivesCashOfferSentiment: undefined,
        exclusivesThreeMonthTimeline: undefined,
        exclusivesShareWithSeriousBuyers: undefined,
        chatQuestions: undefined,
        exclusivesHomesTouredAmount: undefined,
        exclusivesPrequalificationStatus: undefined,
        bedroomsOverrideReason: undefined,
        bathroomsOverrideReason: undefined,
        aboveGradeSqFtOverrideReason: undefined,
        basementSqFtOverrideReason: undefined,
        homeGuideRegistered: undefined,
        listingAgentEmail: undefined,
        listingAgentFullName: undefined,
        financingReferral: undefined,
        financingReferralOpendoorMortgage: undefined,
        financingReferralTrustedLender: undefined,
        firstName: undefined,
        fullName: undefined,
        homeBuilder: undefined,
        homeBuilderCommunity: undefined,
        homeBuilderEmail: undefined,
        homeBuilderOther: undefined,
        homeBuyingProcess: undefined,
        homeBuyingProcessOther: undefined,
        initialFinancingStatus: undefined,
        lastName: undefined,
        mlsAgentId: undefined,
        mortgageAbad: undefined,
        moveInReady: undefined,
        movingAway: undefined,
        otherInformation: undefined,
        otherSellingWays: undefined,
        phoneNumber: undefined,
        priceEstimateCents: undefined,
        priceEstimateTriage: undefined,
        realtorEmailOverride: undefined,
        realtorNameOverride: undefined,
        referralSource: undefined,
        referralSourceOther: undefined,
        referralSourceRadio: undefined,
        relationToOwner: undefined,
        relationToOwnerOther: undefined,
        saleTimeline: undefined,
        scheduleOfferReview: undefined,
        sellingReasonOther: undefined,
        workingWithHomeBuilder: undefined,
        verificationPrimaryOwner: undefined,
        bathroomFeatures: undefined,
        eligibilityCriteria: undefined,
        floodHistoryTriage: undefined,
        flooringAllFloorTypes: undefined,
        flooringCarpetRooms: undefined,
        flooringHardwoodRooms: undefined,
        flooringLaminateRooms: undefined,
        flooringOtherRooms: undefined,
        flooringTileRooms: undefined,
        flooringMaterials: [],
        kitchenFeatures: undefined,
        photosUploaded: [],
        sellingReason: undefined,
        exploringFinancing: undefined,
        buyerZones: [],
        exclusivesInitialSellerOptionsInterest: undefined,
        exclusivesTasksForPotentiallyHigherOffer: undefined,
        appSmsOptIn: undefined,
        setupBuyerFeed: undefined,
        buyingPower: undefined,
        buyingTimeline: undefined,
        buyingStage: undefined,
        agentStatus: undefined,
        agentType: undefined,
        chatbotPhotoRequest: undefined,
        exteriorAttributes: undefined,
        interiorAttributes: undefined,
        agentLedOfferPhoneNumber: undefined,
        agentLedOfferFullName: undefined,
        agentLedOfferEmail: undefined,
        experimental: [],
        smsOptIn: undefined
    };
}
var Answers = {
    fromJSON: function fromJSON(object) {
        return {
            addition: answers_isSet(object["home.addition"]) ? String(object["home.addition"]) : undefined,
            backYardCondition: answers_isSet(object["home.back_yard.condition"]) ? String(object["home.back_yard.condition"]) : undefined,
            backYardSlope: answers_isSet(object["home.back_yard.slope"]) ? String(object["home.back_yard.slope"]) : undefined,
            backYardSlopeRetainingWall: answers_isSet(object["home.back_yard.slope.retaining_wall"]) ? Boolean(object["home.back_yard.slope.retaining_wall"]) : undefined,
            backYardSlopeType: answers_isSet(object["home.back_yard.slope.type"]) ? String(object["home.back_yard.slope.type"]) : undefined,
            basement: answers_isSet(object["home.basement"]) ? String(object["home.basement"]) : undefined,
            basementFinishedSqFt: answers_isSet(object["home.basement_finished_sq_ft"]) ? Number(object["home.basement_finished_sq_ft"]) : undefined,
            basementSqFt: answers_isSet(object["home.basement_sq_ft"]) ? Number(object["home.basement_sq_ft"]) : undefined,
            basementSqFtTriage: answers_isSet(object["home.basement_sq_ft.triage"]) ? String(object["home.basement_sq_ft.triage"]) : undefined,
            basementUnfinishedSqFt: answers_isSet(object["home.basement_unfinished_sq_ft"]) ? Number(object["home.basement_unfinished_sq_ft"]) : undefined,
            bathroomCondition: answers_isSet(object["home.bathroom.condition"]) ? String(object["home.bathroom.condition"]) : undefined,
            masterBathroomCondition: answers_isSet(object["home.master_bathroom.condition"]) ? String(object["home.master_bathroom.condition"]) : undefined,
            bathroomRemodel: answers_isSet(object["home.bathroom.remodel"]) ? String(object["home.bathroom.remodel"]) : undefined,
            bathrooms: answers_isSet(object["home.bathrooms"]) ? Number(object["home.bathrooms"]) : undefined,
            bathroomsFull: answers_isSet(object["home.bathrooms.full"]) ? Number(object["home.bathrooms.full"]) : undefined,
            bathroomsHalf: answers_isSet(object["home.bathrooms.half"]) ? Number(object["home.bathrooms.half"]) : undefined,
            bedrooms: answers_isSet(object["home.bedrooms"]) ? Number(object["home.bedrooms"]) : undefined,
            bedroomsTriage: answers_isSet(object["home.bedrooms.triage"]) ? String(object["home.bedrooms.triage"]) : undefined,
            carportSpaces: answers_isSet(object["home.carport_spaces"]) ? Number(object["home.carport_spaces"]) : undefined,
            dwellingType: answers_isSet(object["home.dwelling_type"]) ? String(object["home.dwelling_type"]) : undefined,
            entryTypes: answers_isSet(object["home.entry_type"]) ? Answers_EntryTypes.fromJSON(object["home.entry_type"]) : undefined,
            exteriorFacade: answers_isSet(object["home.exterior_facade"]) ? String(object["home.exterior_facade"]) : undefined,
            exteriorStories: answers_isSet(object["home.exterior_stories"]) ? Number(object["home.exterior_stories"]) : undefined,
            floodZoneTriage: answers_isSet(object["home.flood_zone.triage"]) ? String(object["home.flood_zone.triage"]) : undefined,
            flooringCarpetCondition: answers_isSet(object["home.flooring.carpet_condition"]) ? String(object["home.flooring.carpet_condition"]) : undefined,
            flooringFollowUpLiving: answers_isSet(object["home.flooring.follow_up_living"]) ? String(object["home.flooring.follow_up_living"]) : undefined,
            flooringFollowUpMasterBedroom: answers_isSet(object["home.flooring.follow_up_master_bedroom"]) ? String(object["home.flooring.follow_up_master_bedroom"]) : undefined,
            flooringHardwoodCondition: answers_isSet(object["home.flooring.hardwood_condition"]) ? String(object["home.flooring.hardwood_condition"]) : undefined,
            flooringLaminateCondition: answers_isSet(object["home.flooring.laminate_condition"]) ? String(object["home.flooring.laminate_condition"]) : undefined,
            flooringPrimaryFloorCondition: answers_isSet(object["home.flooring.primary_floor_condition"]) ? String(object["home.flooring.primary_floor_condition"]) : undefined,
            flooringPrimaryFloorType: answers_isSet(object["home.flooring.primary_floor_type"]) ? String(object["home.flooring.primary_floor_type"]) : undefined,
            flooringSecondaryFloorCondition: answers_isSet(object["home.flooring.secondary_floor_condition"]) ? String(object["home.flooring.secondary_floor_condition"]) : undefined,
            flooringSecondaryFloorType: answers_isSet(object["home.flooring.secondary_floor_type"]) ? String(object["home.flooring.secondary_floor_type"]) : undefined,
            flooringTileCondition: answers_isSet(object["home.flooring.tile_condition"]) ? String(object["home.flooring.tile_condition"]) : undefined,
            foundationIssue: answers_isSet(object["home.foundation_issue"]) ? String(object["home.foundation_issue"]) : undefined,
            garageSpaces: answers_isSet(object["home.garage_spaces"]) ? Number(object["home.garage_spaces"]) : undefined,
            hoa: answers_isSet(object["home.hoa"]) ? Boolean(object["home.hoa"]) : undefined,
            hoaTypes: answers_isSet(object["home.hoa_type"]) ? Answers_HoaTypes.fromJSON(object["home.hoa_type"]) : undefined,
            hoaFees: answers_isSet(object["home.hoa_fees"]) ? Number(object["home.hoa_fees"]) : undefined,
            interiorPaintCondition: answers_isSet(object["home.interior_paint.condition"]) ? String(object["home.interior_paint.condition"]) : undefined,
            interiorPaintNeutral: answers_isSet(object["home.interior_paint.neutral"]) ? String(object["home.interior_paint.neutral"]) : undefined,
            kitchenApplianceType: answers_isSet(object["home.kitchen.appliance_type"]) ? String(object["home.kitchen.appliance_type"]) : undefined,
            kitchenCondition: answers_isSet(object["home.kitchen.condition"]) ? String(object["home.kitchen.condition"]) : undefined,
            kitchenCounterType: answers_isSet(object["home.kitchen.counter_type"]) ? String(object["home.kitchen.counter_type"]) : undefined,
            kitchenRemodel: answers_isSet(object["home.kitchen.remodel"]) ? String(object["home.kitchen.remodel"]) : undefined,
            leasedSolarPanelsTriage: answers_isSet(object["home.leased_solar_panels.triage"]) ? String(object["home.leased_solar_panels.triage"]) : undefined,
            lotOwnership: answers_isSet(object["home.lot_ownership"]) ? String(object["home.lot_ownership"]) : undefined,
            masterBedroomFloor: answers_isSet(object["home.master_bedroom_floor"]) ? Number(object["home.master_bedroom_floor"]) : undefined,
            poolType: answers_isSet(object["home.pool_type"]) ? String(object["home.pool_type"]) : undefined,
            sharedEntrance: answers_isSet(object["home.shared_entrance"]) ? Boolean(object["home.shared_entrance"]) : undefined,
            solarPanelsOwnershipType: answers_isSet(object["home.solar_panels.ownership_type"]) ? String(object["home.solar_panels.ownership_type"]) : undefined,
            sqFt: answers_isSet(object["home.sq_ft"]) ? Number(object["home.sq_ft"]) : undefined,
            aboveGradeSqFt: answers_isSet(object["home.above_grade_sq_ft"]) ? Number(object["home.above_grade_sq_ft"]) : undefined,
            sqFtTriage: answers_isSet(object["home.sq_ft.triage"]) ? String(object["home.sq_ft.triage"]) : undefined,
            yearBuilt: answers_isSet(object["home.year_built"]) ? Number(object["home.year_built"]) : undefined,
            selfServiceVirtualAssessmentChoice: answers_isSet(object["seller.ssva_opt_in"]) ? String(object["seller.ssva_opt_in"]) : undefined,
            hasUpgrades: answers_isSet(object["home.has_upgrades"]) ? Boolean(object["home.has_upgrades"]) : undefined,
            userVerifiedAddress: answers_isSet(object["home.user_verified_address"]) ? Boolean(object["home.user_verified_address"]) : undefined,
            listed: answers_isSet(object["home.listed"]) ? Boolean(object["home.listed"]) : undefined,
            kitchenSellerScore: answers_isSet(object["home.kitchen_seller_score"]) ? String(object["home.kitchen_seller_score"]) : undefined,
            bathroomSellerScore: answers_isSet(object["home.bathroom_seller_score"]) ? String(object["home.bathroom_seller_score"]) : undefined,
            livingRoomSellerScore: answers_isSet(object["home.living_room_seller_score"]) ? String(object["home.living_room_seller_score"]) : undefined,
            exteriorSellerScore: answers_isSet(object["home.exterior_seller_score"]) ? String(object["home.exterior_seller_score"]) : undefined,
            propertyCondition: answers_isSet(object["home.property_condition"]) ? String(object["home.property_condition"]) : undefined,
            activelyLooking: answers_isSet(object["seller.actively_looking"]) ? String(object["seller.actively_looking"]) : undefined,
            agent: answers_isSet(object["seller.agent"]) ? String(object["seller.agent"]) : undefined,
            brokerage: answers_isSet(object["seller.brokerage"]) ? String(object["seller.brokerage"]) : undefined,
            email: answers_isSet(object["seller.email"]) ? String(object["seller.email"]) : undefined,
            signedListingAgreement: answers_isSet(object["seller.signed_listing_agreement"]) ? Boolean(object["seller.signed_listing_agreement"]) : undefined,
            priceEstimateRange: answers_isSet(object["seller.price_estimate_range"]) ? Answers_PriceEstimateRange.fromJSON(object["seller.price_estimate_range"]) : undefined,
            optedIntoExclusiveOffers: answers_isSet(object["seller.opted_into_exclusive_offers"]) ? Boolean(object["seller.opted_into_exclusive_offers"]) : undefined,
            buyingNextHome: answers_isSet(object["seller.buying_next_home"]) ? Boolean(object["seller.buying_next_home"]) : undefined,
            buyingNextHomeStatus: answers_isSet(object["seller.buying_next_home_status"]) ? String(object["seller.buying_next_home_status"]) : undefined,
            sellingTimelineFlexibility: answers_isSet(object["seller.selling_timeline_flexibility"]) ? String(object["seller.selling_timeline_flexibility"]) : undefined,
            willingnessForTours: answers_isSet(object["seller.willingness_for_tours"]) ? String(object["seller.willingness_for_tours"]) : undefined,
            currentlyInSellingProcess: answers_isSet(object["seller.currently_in_selling_process"]) ? String(object["seller.currently_in_selling_process"]) : undefined,
            showingPreference: answers_isSet(object["seller.showing_preference"]) ? String(object["seller.showing_preference"]) : undefined,
            exclusivesCustomerPhoneNumber: answers_isSet(object["seller.exclusives_customer_phone_number"]) ? String(object["seller.exclusives_customer_phone_number"]) : undefined,
            exclusivesCashOfferSentiment: answers_isSet(object["seller.exclusives_cash_offer_sentiment"]) ? String(object["seller.exclusives_cash_offer_sentiment"]) : undefined,
            exclusivesThreeMonthTimeline: answers_isSet(object["seller.exclusives_three_month_timeline"]) ? Boolean(object["seller.exclusives_three_month_timeline"]) : undefined,
            exclusivesShareWithSeriousBuyers: answers_isSet(object["seller.exclusives_share_with_serious_buyers"]) ? Boolean(object["seller.exclusives_share_with_serious_buyers"]) : undefined,
            chatQuestions: answers_isSet(object["seller.chat_question"]) ? String(object["seller.chat_question"]) : undefined,
            exclusivesHomesTouredAmount: answers_isSet(object["seller.exclusives_homes_toured_amount"]) ? String(object["seller.exclusives_homes_toured_amount"]) : undefined,
            exclusivesPrequalificationStatus: answers_isSet(object["seller.exclusives_prequalification_status"]) ? String(object["seller.exclusives_prequalification_status"]) : undefined,
            bedroomsOverrideReason: answers_isSet(object["home.bedrooms.override_reason"]) ? String(object["home.bedrooms.override_reason"]) : undefined,
            bathroomsOverrideReason: answers_isSet(object["home.bathrooms.override_reason"]) ? String(object["home.bathrooms.override_reason"]) : undefined,
            aboveGradeSqFtOverrideReason: answers_isSet(object["home.above_grade_sq_ft.override_reason"]) ? String(object["home.above_grade_sq_ft.override_reason"]) : undefined,
            basementSqFtOverrideReason: answers_isSet(object["home.basement_sq_ft.override_reason"]) ? String(object["home.basement_sq_ft.override_reason"]) : undefined,
            homeGuideRegistered: answers_isSet(object["seller.home_guide_registered"]) ? Boolean(object["seller.home_guide_registered"]) : undefined,
            listingAgentEmail: answers_isSet(object["seller.listing_agent.email"]) ? String(object["seller.listing_agent.email"]) : undefined,
            listingAgentFullName: answers_isSet(object["seller.listing_agent.full_name"]) ? String(object["seller.listing_agent.full_name"]) : undefined,
            financingReferral: answers_isSet(object["seller.financing_referral"]) ? String(object["seller.financing_referral"]) : undefined,
            financingReferralOpendoorMortgage: answers_isSet(object["seller.financing_referral_opendoor_mortgage"]) ? String(object["seller.financing_referral_opendoor_mortgage"]) : undefined,
            financingReferralTrustedLender: answers_isSet(object["seller.financing_referral_trusted_lender"]) ? String(object["seller.financing_referral_trusted_lender"]) : undefined,
            firstName: answers_isSet(object["seller.first_name"]) ? String(object["seller.first_name"]) : undefined,
            fullName: answers_isSet(object["seller.full_name"]) ? String(object["seller.full_name"]) : undefined,
            homeBuilder: answers_isSet(object["seller.home_builder"]) ? String(object["seller.home_builder"]) : undefined,
            homeBuilderCommunity: answers_isSet(object["seller.home_builder_community"]) ? String(object["seller.home_builder_community"]) : undefined,
            homeBuilderEmail: answers_isSet(object["seller.home_builder_email"]) ? String(object["seller.home_builder_email"]) : undefined,
            homeBuilderOther: answers_isSet(object["seller.home_builder.other"]) ? String(object["seller.home_builder.other"]) : undefined,
            homeBuyingProcess: answers_isSet(object["seller.home_buying_process"]) ? String(object["seller.home_buying_process"]) : undefined,
            homeBuyingProcessOther: answers_isSet(object["seller.home_buying_process.other"]) ? String(object["seller.home_buying_process.other"]) : undefined,
            initialFinancingStatus: answers_isSet(object["seller.initial_financing_status"]) ? String(object["seller.initial_financing_status"]) : undefined,
            lastName: answers_isSet(object["seller.last_name"]) ? String(object["seller.last_name"]) : undefined,
            mlsAgentId: answers_isSet(object["seller.mls_agent_id"]) ? String(object["seller.mls_agent_id"]) : undefined,
            mortgageAbad: answers_isSet(object["seller.mortgage_abad"]) ? String(object["seller.mortgage_abad"]) : undefined,
            moveInReady: answers_isSet(object["seller.move_in_ready"]) ? String(object["seller.move_in_ready"]) : undefined,
            movingAway: answers_isSet(object["seller.moving_away"]) ? String(object["seller.moving_away"]) : undefined,
            otherInformation: answers_isSet(object["seller.other_information"]) ? String(object["seller.other_information"]) : undefined,
            otherSellingWays: answers_isSet(object["seller.other_selling_ways"]) ? String(object["seller.other_selling_ways"]) : undefined,
            phoneNumber: answers_isSet(object["seller.phone_number"]) ? String(object["seller.phone_number"]) : undefined,
            priceEstimateCents: answers_isSet(object["seller.price_estimate_cents"]) ? Number(object["seller.price_estimate_cents"]) : undefined,
            priceEstimateTriage: answers_isSet(object["seller.price_estimate.triage"]) ? String(object["seller.price_estimate.triage"]) : undefined,
            realtorEmailOverride: answers_isSet(object["seller.realtor_email_override"]) ? Boolean(object["seller.realtor_email_override"]) : undefined,
            realtorNameOverride: answers_isSet(object["seller.realtor_name_override"]) ? Boolean(object["seller.realtor_name_override"]) : undefined,
            referralSource: answers_isSet(object["seller.referral_source"]) ? String(object["seller.referral_source"]) : undefined,
            referralSourceOther: answers_isSet(object["seller.referral_source.other"]) ? String(object["seller.referral_source.other"]) : undefined,
            referralSourceRadio: answers_isSet(object["seller.referral_source_radio"]) ? String(object["seller.referral_source_radio"]) : undefined,
            relationToOwner: answers_isSet(object["seller.relation_to_owner"]) ? String(object["seller.relation_to_owner"]) : undefined,
            relationToOwnerOther: answers_isSet(object["seller.relation_to_owner.other"]) ? String(object["seller.relation_to_owner.other"]) : undefined,
            saleTimeline: answers_isSet(object["seller.sale_timeline"]) ? String(object["seller.sale_timeline"]) : undefined,
            scheduleOfferReview: answers_isSet(object.schedule_offer_review) ? String(object.schedule_offer_review) : undefined,
            sellingReasonOther: answers_isSet(object["seller.selling_reason.other"]) ? String(object["seller.selling_reason.other"]) : undefined,
            workingWithHomeBuilder: answers_isSet(object["seller.working_with_home_builder"]) ? Boolean(object["seller.working_with_home_builder"]) : undefined,
            verificationPrimaryOwner: answers_isSet(object["verification.primary_owner"]) ? String(object["verification.primary_owner"]) : undefined,
            bathroomFeatures: answers_isSet(object["home.bathroom.features"]) ? Answers_BathroomFeatures.fromJSON(object["home.bathroom.features"]) : undefined,
            eligibilityCriteria: answers_isSet(object["home.eligibility_criteria"]) ? Answers_EligibilityCriteria.fromJSON(object["home.eligibility_criteria"]) : undefined,
            floodHistoryTriage: answers_isSet(object["home.flood_history.triage"]) ? Answers_FloodHistoryTriage.fromJSON(object["home.flood_history.triage"]) : undefined,
            flooringAllFloorTypes: answers_isSet(object["home.flooring.all_floor_types"]) ? Answers_FloorTypes.fromJSON(object["home.flooring.all_floor_types"]) : undefined,
            flooringCarpetRooms: answers_isSet(object["home.flooring.carpet_rooms"]) ? Answers_Rooms.fromJSON(object["home.flooring.carpet_rooms"]) : undefined,
            flooringHardwoodRooms: answers_isSet(object["home.flooring.hardwood_rooms"]) ? Answers_Rooms.fromJSON(object["home.flooring.hardwood_rooms"]) : undefined,
            flooringLaminateRooms: answers_isSet(object["home.flooring.laminate_rooms"]) ? Answers_Rooms.fromJSON(object["home.flooring.laminate_rooms"]) : undefined,
            flooringOtherRooms: answers_isSet(object["home.flooring.other_rooms"]) ? Answers_Rooms.fromJSON(object["home.flooring.other_rooms"]) : undefined,
            flooringTileRooms: answers_isSet(object["home.flooring.tile_rooms"]) ? Answers_Rooms.fromJSON(object["home.flooring.tile_rooms"]) : undefined,
            flooringMaterials: Array.isArray(object === null || object === void 0 ? void 0 : object["home.flooring_materials"]) ? object["home.flooring_materials"].map(function(e) {
                return String(e);
            }) : [],
            kitchenFeatures: answers_isSet(object["home.kitchen.features"]) ? Answers_KitchenFeatures.fromJSON(object["home.kitchen.features"]) : undefined,
            photosUploaded: Array.isArray(object === null || object === void 0 ? void 0 : object["home.photos.uploaded"]) ? object["home.photos.uploaded"].map(function(e) {
                return Answers_Photo.fromJSON(e);
            }) : [],
            sellingReason: answers_isSet(object["seller.selling_reason"]) ? Answers_SellingReason.fromJSON(object["seller.selling_reason"]) : undefined,
            exploringFinancing: answers_isSet(object["seller.exploring_financing"]) ? String(object["seller.exploring_financing"]) : undefined,
            buyerZones: Array.isArray(object === null || object === void 0 ? void 0 : object["seller.setup_buyer_feed.zones"]) ? object["seller.setup_buyer_feed.zones"].map(function(e) {
                return Answers_BuyerZone.fromJSON(e);
            }) : [],
            exclusivesInitialSellerOptionsInterest: answers_isSet(object["seller.exclusives_initial_seller_options_interest"]) ? Answers_ExclusivesInitialSellerOptionsInterest.fromJSON(object["seller.exclusives_initial_seller_options_interest"]) : undefined,
            exclusivesTasksForPotentiallyHigherOffer: answers_isSet(object["seller.exclusives_tasks_for_potentially_higher_offer"]) ? Answers_ExclusivesTasksForPotentiallyHigherOffer.fromJSON(object["seller.exclusives_tasks_for_potentially_higher_offer"]) : undefined,
            appSmsOptIn: answers_isSet(object["seller.app_sms_opt_in"]) ? Boolean(object["seller.app_sms_opt_in"]) : undefined,
            setupBuyerFeed: answers_isSet(object["seller.setup_buyer_feed"]) ? Answers_SetupBuyerFeed.fromJSON(object["seller.setup_buyer_feed"]) : undefined,
            buyingPower: answers_isSet(object["seller.buying_power"]) ? Answers_BuyingPower.fromJSON(object["seller.buying_power"]) : undefined,
            buyingTimeline: answers_isSet(object["seller.buying_timeline"]) ? String(object["seller.buying_timeline"]) : undefined,
            buyingStage: answers_isSet(object["seller.buying_stage"]) ? String(object["seller.buying_stage"]) : undefined,
            agentStatus: answers_isSet(object["seller.agent_status"]) ? String(object["seller.agent_status"]) : undefined,
            agentType: answers_isSet(object["seller.agent_type"]) ? String(object["seller.agent_type"]) : undefined,
            chatbotPhotoRequest: answers_isSet(object["seller.chatbot_photo_request"]) ? Answers_ChatbotPhotoRequest.fromJSON(object["seller.chatbot_photo_request"]) : undefined,
            exteriorAttributes: answers_isSet(object["home.exterior_attributes"]) ? Answers_ExteriorAttributes.fromJSON(object["home.exterior_attributes"]) : undefined,
            interiorAttributes: answers_isSet(object["home.interior_attributes"]) ? Answers_InteriorAttributes.fromJSON(object["home.interior_attributes"]) : undefined,
            agentLedOfferPhoneNumber: answers_isSet(object["seller.agent_led_offer_data.phone_number"]) ? String(object["seller.agent_led_offer_data.phone_number"]) : undefined,
            agentLedOfferFullName: answers_isSet(object["seller.agent_led_offer_data.full_name"]) ? String(object["seller.agent_led_offer_data.full_name"]) : undefined,
            agentLedOfferEmail: answers_isSet(object["seller.agent_led_offer_data.email"]) ? String(object["seller.agent_led_offer_data.email"]) : undefined,
            experimental: Array.isArray(object === null || object === void 0 ? void 0 : object.experimental) ? object.experimental.map(function(e) {
                return Answers_ExperimentalQuestionAnswer.fromJSON(e);
            }) : [],
            smsOptIn: answers_isSet(object["seller.sms_opt_in"]) ? Boolean(object["seller.sms_opt_in"]) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var ref, ref1, ref2, ref3;
        var obj = {};
        if (message.addition !== undefined) {
            obj["home.addition"] = message.addition;
        }
        if (message.backYardCondition !== undefined) {
            obj["home.back_yard.condition"] = message.backYardCondition;
        }
        if (message.backYardSlope !== undefined) {
            obj["home.back_yard.slope"] = message.backYardSlope;
        }
        if (message.backYardSlopeRetainingWall !== undefined) {
            obj["home.back_yard.slope.retaining_wall"] = message.backYardSlopeRetainingWall;
        }
        if (message.backYardSlopeType !== undefined) {
            obj["home.back_yard.slope.type"] = message.backYardSlopeType;
        }
        if (message.basement !== undefined) {
            obj["home.basement"] = message.basement;
        }
        if (message.basementFinishedSqFt !== undefined) {
            obj["home.basement_finished_sq_ft"] = message.basementFinishedSqFt;
        }
        if (message.basementSqFt !== undefined) {
            obj["home.basement_sq_ft"] = message.basementSqFt;
        }
        if (message.basementSqFtTriage !== undefined) {
            obj["home.basement_sq_ft.triage"] = message.basementSqFtTriage;
        }
        if (message.basementUnfinishedSqFt !== undefined) {
            obj["home.basement_unfinished_sq_ft"] = message.basementUnfinishedSqFt;
        }
        if (message.bathroomCondition !== undefined) {
            obj["home.bathroom.condition"] = message.bathroomCondition;
        }
        if (message.masterBathroomCondition !== undefined) {
            obj["home.master_bathroom.condition"] = message.masterBathroomCondition;
        }
        if (message.bathroomRemodel !== undefined) {
            obj["home.bathroom.remodel"] = message.bathroomRemodel;
        }
        if (message.bathrooms !== undefined) {
            obj["home.bathrooms"] = message.bathrooms;
        }
        if (message.bathroomsFull !== undefined) {
            obj["home.bathrooms.full"] = message.bathroomsFull;
        }
        if (message.bathroomsHalf !== undefined) {
            obj["home.bathrooms.half"] = message.bathroomsHalf;
        }
        if (message.bedrooms !== undefined) {
            obj["home.bedrooms"] = message.bedrooms;
        }
        if (message.bedroomsTriage !== undefined) {
            obj["home.bedrooms.triage"] = message.bedroomsTriage;
        }
        if (message.carportSpaces !== undefined) {
            obj["home.carport_spaces"] = message.carportSpaces;
        }
        if (message.dwellingType !== undefined) {
            obj["home.dwelling_type"] = message.dwellingType;
        }
        if (message.entryTypes !== undefined) {
            obj["home.entry_type"] = Answers_EntryTypes.toJSON(message.entryTypes);
        }
        if (message.exteriorFacade !== undefined) {
            obj["home.exterior_facade"] = message.exteriorFacade;
        }
        if (message.exteriorStories !== undefined) {
            obj["home.exterior_stories"] = message.exteriorStories;
        }
        if (message.floodZoneTriage !== undefined) {
            obj["home.flood_zone.triage"] = message.floodZoneTriage;
        }
        if (message.flooringCarpetCondition !== undefined) {
            obj["home.flooring.carpet_condition"] = message.flooringCarpetCondition;
        }
        if (message.flooringFollowUpLiving !== undefined) {
            obj["home.flooring.follow_up_living"] = message.flooringFollowUpLiving;
        }
        if (message.flooringFollowUpMasterBedroom !== undefined) {
            obj["home.flooring.follow_up_master_bedroom"] = message.flooringFollowUpMasterBedroom;
        }
        if (message.flooringHardwoodCondition !== undefined) {
            obj["home.flooring.hardwood_condition"] = message.flooringHardwoodCondition;
        }
        if (message.flooringLaminateCondition !== undefined) {
            obj["home.flooring.laminate_condition"] = message.flooringLaminateCondition;
        }
        if (message.flooringPrimaryFloorCondition !== undefined) {
            obj["home.flooring.primary_floor_condition"] = message.flooringPrimaryFloorCondition;
        }
        if (message.flooringPrimaryFloorType !== undefined) {
            obj["home.flooring.primary_floor_type"] = message.flooringPrimaryFloorType;
        }
        if (message.flooringSecondaryFloorCondition !== undefined) {
            obj["home.flooring.secondary_floor_condition"] = message.flooringSecondaryFloorCondition;
        }
        if (message.flooringSecondaryFloorType !== undefined) {
            obj["home.flooring.secondary_floor_type"] = message.flooringSecondaryFloorType;
        }
        if (message.flooringTileCondition !== undefined) {
            obj["home.flooring.tile_condition"] = message.flooringTileCondition;
        }
        if (message.foundationIssue !== undefined) {
            obj["home.foundation_issue"] = message.foundationIssue;
        }
        if (message.garageSpaces !== undefined) {
            obj["home.garage_spaces"] = message.garageSpaces;
        }
        if (message.hoa !== undefined) {
            obj["home.hoa"] = message.hoa;
        }
        if (message.hoaTypes !== undefined) {
            obj["home.hoa_type"] = Answers_HoaTypes.toJSON(message.hoaTypes);
        }
        if (message.hoaFees !== undefined) {
            obj["home.hoa_fees"] = message.hoaFees;
        }
        if (message.interiorPaintCondition !== undefined) {
            obj["home.interior_paint.condition"] = message.interiorPaintCondition;
        }
        if (message.interiorPaintNeutral !== undefined) {
            obj["home.interior_paint.neutral"] = message.interiorPaintNeutral;
        }
        if (message.kitchenApplianceType !== undefined) {
            obj["home.kitchen.appliance_type"] = message.kitchenApplianceType;
        }
        if (message.kitchenCondition !== undefined) {
            obj["home.kitchen.condition"] = message.kitchenCondition;
        }
        if (message.kitchenCounterType !== undefined) {
            obj["home.kitchen.counter_type"] = message.kitchenCounterType;
        }
        if (message.kitchenRemodel !== undefined) {
            obj["home.kitchen.remodel"] = message.kitchenRemodel;
        }
        if (message.leasedSolarPanelsTriage !== undefined) {
            obj["home.leased_solar_panels.triage"] = message.leasedSolarPanelsTriage;
        }
        if (message.lotOwnership !== undefined) {
            obj["home.lot_ownership"] = message.lotOwnership;
        }
        if (message.masterBedroomFloor !== undefined) {
            obj["home.master_bedroom_floor"] = message.masterBedroomFloor;
        }
        if (message.poolType !== undefined) {
            obj["home.pool_type"] = message.poolType;
        }
        if (message.sharedEntrance !== undefined) {
            obj["home.shared_entrance"] = message.sharedEntrance;
        }
        if (message.solarPanelsOwnershipType !== undefined) {
            obj["home.solar_panels.ownership_type"] = message.solarPanelsOwnershipType;
        }
        if (message.sqFt !== undefined) {
            obj["home.sq_ft"] = message.sqFt;
        }
        if (message.aboveGradeSqFt !== undefined) {
            obj["home.above_grade_sq_ft"] = message.aboveGradeSqFt;
        }
        if (message.sqFtTriage !== undefined) {
            obj["home.sq_ft.triage"] = message.sqFtTriage;
        }
        if (message.yearBuilt !== undefined) {
            obj["home.year_built"] = message.yearBuilt;
        }
        if (message.selfServiceVirtualAssessmentChoice !== undefined) {
            obj["seller.ssva_opt_in"] = message.selfServiceVirtualAssessmentChoice;
        }
        if (message.hasUpgrades !== undefined) {
            obj["home.has_upgrades"] = message.hasUpgrades;
        }
        if (message.userVerifiedAddress !== undefined) {
            obj["home.user_verified_address"] = message.userVerifiedAddress;
        }
        if (message.listed !== undefined) {
            obj["home.listed"] = message.listed;
        }
        if (message.kitchenSellerScore !== undefined) {
            obj["home.kitchen_seller_score"] = message.kitchenSellerScore;
        }
        if (message.bathroomSellerScore !== undefined) {
            obj["home.bathroom_seller_score"] = message.bathroomSellerScore;
        }
        if (message.livingRoomSellerScore !== undefined) {
            obj["home.living_room_seller_score"] = message.livingRoomSellerScore;
        }
        if (message.exteriorSellerScore !== undefined) {
            obj["home.exterior_seller_score"] = message.exteriorSellerScore;
        }
        if (message.propertyCondition !== undefined) {
            obj["home.property_condition"] = message.propertyCondition;
        }
        if (message.activelyLooking !== undefined) {
            obj["seller.actively_looking"] = message.activelyLooking;
        }
        if (message.agent !== undefined) {
            obj["seller.agent"] = message.agent;
        }
        if (message.brokerage !== undefined) {
            obj["seller.brokerage"] = message.brokerage;
        }
        if (message.email !== undefined) {
            obj["seller.email"] = message.email;
        }
        if (message.signedListingAgreement !== undefined) {
            obj["seller.signed_listing_agreement"] = message.signedListingAgreement;
        }
        if (message.priceEstimateRange !== undefined) {
            obj["seller.price_estimate_range"] = Answers_PriceEstimateRange.toJSON(message.priceEstimateRange);
        }
        if (message.optedIntoExclusiveOffers !== undefined) {
            obj["seller.opted_into_exclusive_offers"] = message.optedIntoExclusiveOffers;
        }
        if (message.buyingNextHome !== undefined) {
            obj["seller.buying_next_home"] = message.buyingNextHome;
        }
        if (message.buyingNextHomeStatus !== undefined) {
            obj["seller.buying_next_home_status"] = message.buyingNextHomeStatus;
        }
        if (message.sellingTimelineFlexibility !== undefined) {
            obj["seller.selling_timeline_flexibility"] = message.sellingTimelineFlexibility;
        }
        if (message.willingnessForTours !== undefined) {
            obj["seller.willingness_for_tours"] = message.willingnessForTours;
        }
        if (message.currentlyInSellingProcess !== undefined) {
            obj["seller.currently_in_selling_process"] = message.currentlyInSellingProcess;
        }
        if (message.showingPreference !== undefined) {
            obj["seller.showing_preference"] = message.showingPreference;
        }
        if (message.exclusivesCustomerPhoneNumber !== undefined) {
            obj["seller.exclusives_customer_phone_number"] = message.exclusivesCustomerPhoneNumber;
        }
        if (message.exclusivesCashOfferSentiment !== undefined) {
            obj["seller.exclusives_cash_offer_sentiment"] = message.exclusivesCashOfferSentiment;
        }
        if (message.exclusivesThreeMonthTimeline !== undefined) {
            obj["seller.exclusives_three_month_timeline"] = message.exclusivesThreeMonthTimeline;
        }
        if (message.exclusivesShareWithSeriousBuyers !== undefined) {
            obj["seller.exclusives_share_with_serious_buyers"] = message.exclusivesShareWithSeriousBuyers;
        }
        if (message.chatQuestions !== undefined) {
            obj["seller.chat_question"] = message.chatQuestions;
        }
        if (message.exclusivesHomesTouredAmount !== undefined) {
            obj["seller.exclusives_homes_toured_amount"] = message.exclusivesHomesTouredAmount;
        }
        if (message.exclusivesPrequalificationStatus !== undefined) {
            obj["seller.exclusives_prequalification_status"] = message.exclusivesPrequalificationStatus;
        }
        if (message.bedroomsOverrideReason !== undefined) {
            obj["home.bedrooms.override_reason"] = message.bedroomsOverrideReason;
        }
        if (message.bathroomsOverrideReason !== undefined) {
            obj["home.bathrooms.override_reason"] = message.bathroomsOverrideReason;
        }
        if (message.aboveGradeSqFtOverrideReason !== undefined) {
            obj["home.above_grade_sq_ft.override_reason"] = message.aboveGradeSqFtOverrideReason;
        }
        if (message.basementSqFtOverrideReason !== undefined) {
            obj["home.basement_sq_ft.override_reason"] = message.basementSqFtOverrideReason;
        }
        if (message.homeGuideRegistered !== undefined) {
            obj["seller.home_guide_registered"] = message.homeGuideRegistered;
        }
        if (message.listingAgentEmail !== undefined) {
            obj["seller.listing_agent.email"] = message.listingAgentEmail;
        }
        if (message.listingAgentFullName !== undefined) {
            obj["seller.listing_agent.full_name"] = message.listingAgentFullName;
        }
        if (message.financingReferral !== undefined) {
            obj["seller.financing_referral"] = message.financingReferral;
        }
        if (message.financingReferralOpendoorMortgage !== undefined) {
            obj["seller.financing_referral_opendoor_mortgage"] = message.financingReferralOpendoorMortgage;
        }
        if (message.financingReferralTrustedLender !== undefined) {
            obj["seller.financing_referral_trusted_lender"] = message.financingReferralTrustedLender;
        }
        if (message.firstName !== undefined) {
            obj["seller.first_name"] = message.firstName;
        }
        if (message.fullName !== undefined) {
            obj["seller.full_name"] = message.fullName;
        }
        if (message.homeBuilder !== undefined) {
            obj["seller.home_builder"] = message.homeBuilder;
        }
        if (message.homeBuilderCommunity !== undefined) {
            obj["seller.home_builder_community"] = message.homeBuilderCommunity;
        }
        if (message.homeBuilderEmail !== undefined) {
            obj["seller.home_builder_email"] = message.homeBuilderEmail;
        }
        if (message.homeBuilderOther !== undefined) {
            obj["seller.home_builder.other"] = message.homeBuilderOther;
        }
        if (message.homeBuyingProcess !== undefined) {
            obj["seller.home_buying_process"] = message.homeBuyingProcess;
        }
        if (message.homeBuyingProcessOther !== undefined) {
            obj["seller.home_buying_process.other"] = message.homeBuyingProcessOther;
        }
        if (message.initialFinancingStatus !== undefined) {
            obj["seller.initial_financing_status"] = message.initialFinancingStatus;
        }
        if (message.lastName !== undefined) {
            obj["seller.last_name"] = message.lastName;
        }
        if (message.mlsAgentId !== undefined) {
            obj["seller.mls_agent_id"] = message.mlsAgentId;
        }
        if (message.mortgageAbad !== undefined) {
            obj["seller.mortgage_abad"] = message.mortgageAbad;
        }
        if (message.moveInReady !== undefined) {
            obj["seller.move_in_ready"] = message.moveInReady;
        }
        if (message.movingAway !== undefined) {
            obj["seller.moving_away"] = message.movingAway;
        }
        if (message.otherInformation !== undefined) {
            obj["seller.other_information"] = message.otherInformation;
        }
        if (message.otherSellingWays !== undefined) {
            obj["seller.other_selling_ways"] = message.otherSellingWays;
        }
        if (message.phoneNumber !== undefined) {
            obj["seller.phone_number"] = message.phoneNumber;
        }
        if (message.priceEstimateCents !== undefined) {
            obj["seller.price_estimate_cents"] = message.priceEstimateCents;
        }
        if (message.priceEstimateTriage !== undefined) {
            obj["seller.price_estimate.triage"] = message.priceEstimateTriage;
        }
        if (message.realtorEmailOverride !== undefined) {
            obj["seller.realtor_email_override"] = message.realtorEmailOverride;
        }
        if (message.realtorNameOverride !== undefined) {
            obj["seller.realtor_name_override"] = message.realtorNameOverride;
        }
        if (message.referralSource !== undefined) {
            obj["seller.referral_source"] = message.referralSource;
        }
        if (message.referralSourceOther !== undefined) {
            obj["seller.referral_source.other"] = message.referralSourceOther;
        }
        if (message.referralSourceRadio !== undefined) {
            obj["seller.referral_source_radio"] = message.referralSourceRadio;
        }
        if (message.relationToOwner !== undefined) {
            obj["seller.relation_to_owner"] = message.relationToOwner;
        }
        if (message.relationToOwnerOther !== undefined) {
            obj["seller.relation_to_owner.other"] = message.relationToOwnerOther;
        }
        if (message.saleTimeline !== undefined) {
            obj["seller.sale_timeline"] = message.saleTimeline;
        }
        if (message.scheduleOfferReview !== undefined) {
            obj.schedule_offer_review = message.scheduleOfferReview;
        }
        if (message.sellingReasonOther !== undefined) {
            obj["seller.selling_reason.other"] = message.sellingReasonOther;
        }
        if (message.workingWithHomeBuilder !== undefined) {
            obj["seller.working_with_home_builder"] = message.workingWithHomeBuilder;
        }
        if (message.verificationPrimaryOwner !== undefined) {
            obj["verification.primary_owner"] = message.verificationPrimaryOwner;
        }
        if (message.bathroomFeatures !== undefined) {
            obj["home.bathroom.features"] = Answers_BathroomFeatures.toJSON(message.bathroomFeatures);
        }
        if (message.eligibilityCriteria !== undefined) {
            obj["home.eligibility_criteria"] = Answers_EligibilityCriteria.toJSON(message.eligibilityCriteria);
        }
        if (message.floodHistoryTriage !== undefined) {
            obj["home.flood_history.triage"] = Answers_FloodHistoryTriage.toJSON(message.floodHistoryTriage);
        }
        if (message.flooringAllFloorTypes !== undefined) {
            obj["home.flooring.all_floor_types"] = Answers_FloorTypes.toJSON(message.flooringAllFloorTypes);
        }
        if (message.flooringCarpetRooms !== undefined) {
            obj["home.flooring.carpet_rooms"] = Answers_Rooms.toJSON(message.flooringCarpetRooms);
        }
        if (message.flooringHardwoodRooms !== undefined) {
            obj["home.flooring.hardwood_rooms"] = Answers_Rooms.toJSON(message.flooringHardwoodRooms);
        }
        if (message.flooringLaminateRooms !== undefined) {
            obj["home.flooring.laminate_rooms"] = Answers_Rooms.toJSON(message.flooringLaminateRooms);
        }
        if (message.flooringOtherRooms !== undefined) {
            obj["home.flooring.other_rooms"] = Answers_Rooms.toJSON(message.flooringOtherRooms);
        }
        if (message.flooringTileRooms !== undefined) {
            obj["home.flooring.tile_rooms"] = Answers_Rooms.toJSON(message.flooringTileRooms);
        }
        if ((ref = message.flooringMaterials) === null || ref === void 0 ? void 0 : ref.length) {
            obj["home.flooring_materials"] = message.flooringMaterials;
        }
        if (message.kitchenFeatures !== undefined) {
            obj["home.kitchen.features"] = Answers_KitchenFeatures.toJSON(message.kitchenFeatures);
        }
        if ((ref1 = message.photosUploaded) === null || ref1 === void 0 ? void 0 : ref1.length) {
            obj["home.photos.uploaded"] = message.photosUploaded.map(function(e) {
                return Answers_Photo.toJSON(e);
            });
        }
        if (message.sellingReason !== undefined) {
            obj["seller.selling_reason"] = Answers_SellingReason.toJSON(message.sellingReason);
        }
        if (message.exploringFinancing !== undefined) {
            obj["seller.exploring_financing"] = message.exploringFinancing;
        }
        if ((ref2 = message.buyerZones) === null || ref2 === void 0 ? void 0 : ref2.length) {
            obj["seller.setup_buyer_feed.zones"] = message.buyerZones.map(function(e) {
                return Answers_BuyerZone.toJSON(e);
            });
        }
        if (message.exclusivesInitialSellerOptionsInterest !== undefined) {
            obj["seller.exclusives_initial_seller_options_interest"] = Answers_ExclusivesInitialSellerOptionsInterest.toJSON(message.exclusivesInitialSellerOptionsInterest);
        }
        if (message.exclusivesTasksForPotentiallyHigherOffer !== undefined) {
            obj["seller.exclusives_tasks_for_potentially_higher_offer"] = Answers_ExclusivesTasksForPotentiallyHigherOffer.toJSON(message.exclusivesTasksForPotentiallyHigherOffer);
        }
        if (message.appSmsOptIn !== undefined) {
            obj["seller.app_sms_opt_in"] = message.appSmsOptIn;
        }
        if (message.setupBuyerFeed !== undefined) {
            obj["seller.setup_buyer_feed"] = Answers_SetupBuyerFeed.toJSON(message.setupBuyerFeed);
        }
        if (message.buyingPower !== undefined) {
            obj["seller.buying_power"] = Answers_BuyingPower.toJSON(message.buyingPower);
        }
        if (message.buyingTimeline !== undefined) {
            obj["seller.buying_timeline"] = message.buyingTimeline;
        }
        if (message.buyingStage !== undefined) {
            obj["seller.buying_stage"] = message.buyingStage;
        }
        if (message.agentStatus !== undefined) {
            obj["seller.agent_status"] = message.agentStatus;
        }
        if (message.agentType !== undefined) {
            obj["seller.agent_type"] = message.agentType;
        }
        if (message.chatbotPhotoRequest !== undefined) {
            obj["seller.chatbot_photo_request"] = Answers_ChatbotPhotoRequest.toJSON(message.chatbotPhotoRequest);
        }
        if (message.exteriorAttributes !== undefined) {
            obj["home.exterior_attributes"] = Answers_ExteriorAttributes.toJSON(message.exteriorAttributes);
        }
        if (message.interiorAttributes !== undefined) {
            obj["home.interior_attributes"] = Answers_InteriorAttributes.toJSON(message.interiorAttributes);
        }
        if (message.agentLedOfferPhoneNumber !== undefined) {
            obj["seller.agent_led_offer_data.phone_number"] = message.agentLedOfferPhoneNumber;
        }
        if (message.agentLedOfferFullName !== undefined) {
            obj["seller.agent_led_offer_data.full_name"] = message.agentLedOfferFullName;
        }
        if (message.agentLedOfferEmail !== undefined) {
            obj["seller.agent_led_offer_data.email"] = message.agentLedOfferEmail;
        }
        if ((ref3 = message.experimental) === null || ref3 === void 0 ? void 0 : ref3.length) {
            obj.experimental = message.experimental.map(function(e) {
                return Answers_ExperimentalQuestionAnswer.toJSON(e);
            });
        }
        if (message.smsOptIn !== undefined) {
            obj["seller.sms_opt_in"] = message.smsOptIn;
        }
        return obj;
    },
    create: function create(base) {
        return Answers.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref, ref1, ref2, ref3;
        var message = createBaseAnswers();
        var _addition;
        message.addition = (_addition = object.addition) !== null && _addition !== void 0 ? _addition : undefined;
        var _backYardCondition;
        message.backYardCondition = (_backYardCondition = object.backYardCondition) !== null && _backYardCondition !== void 0 ? _backYardCondition : undefined;
        var _backYardSlope;
        message.backYardSlope = (_backYardSlope = object.backYardSlope) !== null && _backYardSlope !== void 0 ? _backYardSlope : undefined;
        var _backYardSlopeRetainingWall;
        message.backYardSlopeRetainingWall = (_backYardSlopeRetainingWall = object.backYardSlopeRetainingWall) !== null && _backYardSlopeRetainingWall !== void 0 ? _backYardSlopeRetainingWall : undefined;
        var _backYardSlopeType;
        message.backYardSlopeType = (_backYardSlopeType = object.backYardSlopeType) !== null && _backYardSlopeType !== void 0 ? _backYardSlopeType : undefined;
        var _basement;
        message.basement = (_basement = object.basement) !== null && _basement !== void 0 ? _basement : undefined;
        var _basementFinishedSqFt;
        message.basementFinishedSqFt = (_basementFinishedSqFt = object.basementFinishedSqFt) !== null && _basementFinishedSqFt !== void 0 ? _basementFinishedSqFt : undefined;
        var _basementSqFt;
        message.basementSqFt = (_basementSqFt = object.basementSqFt) !== null && _basementSqFt !== void 0 ? _basementSqFt : undefined;
        var _basementSqFtTriage;
        message.basementSqFtTriage = (_basementSqFtTriage = object.basementSqFtTriage) !== null && _basementSqFtTriage !== void 0 ? _basementSqFtTriage : undefined;
        var _basementUnfinishedSqFt;
        message.basementUnfinishedSqFt = (_basementUnfinishedSqFt = object.basementUnfinishedSqFt) !== null && _basementUnfinishedSqFt !== void 0 ? _basementUnfinishedSqFt : undefined;
        var _bathroomCondition;
        message.bathroomCondition = (_bathroomCondition = object.bathroomCondition) !== null && _bathroomCondition !== void 0 ? _bathroomCondition : undefined;
        var _masterBathroomCondition;
        message.masterBathroomCondition = (_masterBathroomCondition = object.masterBathroomCondition) !== null && _masterBathroomCondition !== void 0 ? _masterBathroomCondition : undefined;
        var _bathroomRemodel;
        message.bathroomRemodel = (_bathroomRemodel = object.bathroomRemodel) !== null && _bathroomRemodel !== void 0 ? _bathroomRemodel : undefined;
        var _bathrooms;
        message.bathrooms = (_bathrooms = object.bathrooms) !== null && _bathrooms !== void 0 ? _bathrooms : undefined;
        var _bathroomsFull;
        message.bathroomsFull = (_bathroomsFull = object.bathroomsFull) !== null && _bathroomsFull !== void 0 ? _bathroomsFull : undefined;
        var _bathroomsHalf;
        message.bathroomsHalf = (_bathroomsHalf = object.bathroomsHalf) !== null && _bathroomsHalf !== void 0 ? _bathroomsHalf : undefined;
        var _bedrooms;
        message.bedrooms = (_bedrooms = object.bedrooms) !== null && _bedrooms !== void 0 ? _bedrooms : undefined;
        var _bedroomsTriage;
        message.bedroomsTriage = (_bedroomsTriage = object.bedroomsTriage) !== null && _bedroomsTriage !== void 0 ? _bedroomsTriage : undefined;
        var _carportSpaces;
        message.carportSpaces = (_carportSpaces = object.carportSpaces) !== null && _carportSpaces !== void 0 ? _carportSpaces : undefined;
        var _dwellingType;
        message.dwellingType = (_dwellingType = object.dwellingType) !== null && _dwellingType !== void 0 ? _dwellingType : undefined;
        message.entryTypes = object.entryTypes !== undefined && object.entryTypes !== null ? Answers_EntryTypes.fromPartial(object.entryTypes) : undefined;
        var _exteriorFacade;
        message.exteriorFacade = (_exteriorFacade = object.exteriorFacade) !== null && _exteriorFacade !== void 0 ? _exteriorFacade : undefined;
        var _exteriorStories;
        message.exteriorStories = (_exteriorStories = object.exteriorStories) !== null && _exteriorStories !== void 0 ? _exteriorStories : undefined;
        var _floodZoneTriage;
        message.floodZoneTriage = (_floodZoneTriage = object.floodZoneTriage) !== null && _floodZoneTriage !== void 0 ? _floodZoneTriage : undefined;
        var _flooringCarpetCondition;
        message.flooringCarpetCondition = (_flooringCarpetCondition = object.flooringCarpetCondition) !== null && _flooringCarpetCondition !== void 0 ? _flooringCarpetCondition : undefined;
        var _flooringFollowUpLiving;
        message.flooringFollowUpLiving = (_flooringFollowUpLiving = object.flooringFollowUpLiving) !== null && _flooringFollowUpLiving !== void 0 ? _flooringFollowUpLiving : undefined;
        var _flooringFollowUpMasterBedroom;
        message.flooringFollowUpMasterBedroom = (_flooringFollowUpMasterBedroom = object.flooringFollowUpMasterBedroom) !== null && _flooringFollowUpMasterBedroom !== void 0 ? _flooringFollowUpMasterBedroom : undefined;
        var _flooringHardwoodCondition;
        message.flooringHardwoodCondition = (_flooringHardwoodCondition = object.flooringHardwoodCondition) !== null && _flooringHardwoodCondition !== void 0 ? _flooringHardwoodCondition : undefined;
        var _flooringLaminateCondition;
        message.flooringLaminateCondition = (_flooringLaminateCondition = object.flooringLaminateCondition) !== null && _flooringLaminateCondition !== void 0 ? _flooringLaminateCondition : undefined;
        var _flooringPrimaryFloorCondition;
        message.flooringPrimaryFloorCondition = (_flooringPrimaryFloorCondition = object.flooringPrimaryFloorCondition) !== null && _flooringPrimaryFloorCondition !== void 0 ? _flooringPrimaryFloorCondition : undefined;
        var _flooringPrimaryFloorType;
        message.flooringPrimaryFloorType = (_flooringPrimaryFloorType = object.flooringPrimaryFloorType) !== null && _flooringPrimaryFloorType !== void 0 ? _flooringPrimaryFloorType : undefined;
        var _flooringSecondaryFloorCondition;
        message.flooringSecondaryFloorCondition = (_flooringSecondaryFloorCondition = object.flooringSecondaryFloorCondition) !== null && _flooringSecondaryFloorCondition !== void 0 ? _flooringSecondaryFloorCondition : undefined;
        var _flooringSecondaryFloorType;
        message.flooringSecondaryFloorType = (_flooringSecondaryFloorType = object.flooringSecondaryFloorType) !== null && _flooringSecondaryFloorType !== void 0 ? _flooringSecondaryFloorType : undefined;
        var _flooringTileCondition;
        message.flooringTileCondition = (_flooringTileCondition = object.flooringTileCondition) !== null && _flooringTileCondition !== void 0 ? _flooringTileCondition : undefined;
        var _foundationIssue;
        message.foundationIssue = (_foundationIssue = object.foundationIssue) !== null && _foundationIssue !== void 0 ? _foundationIssue : undefined;
        var _garageSpaces;
        message.garageSpaces = (_garageSpaces = object.garageSpaces) !== null && _garageSpaces !== void 0 ? _garageSpaces : undefined;
        var _hoa;
        message.hoa = (_hoa = object.hoa) !== null && _hoa !== void 0 ? _hoa : undefined;
        message.hoaTypes = object.hoaTypes !== undefined && object.hoaTypes !== null ? Answers_HoaTypes.fromPartial(object.hoaTypes) : undefined;
        var _hoaFees;
        message.hoaFees = (_hoaFees = object.hoaFees) !== null && _hoaFees !== void 0 ? _hoaFees : undefined;
        var _interiorPaintCondition;
        message.interiorPaintCondition = (_interiorPaintCondition = object.interiorPaintCondition) !== null && _interiorPaintCondition !== void 0 ? _interiorPaintCondition : undefined;
        var _interiorPaintNeutral;
        message.interiorPaintNeutral = (_interiorPaintNeutral = object.interiorPaintNeutral) !== null && _interiorPaintNeutral !== void 0 ? _interiorPaintNeutral : undefined;
        var _kitchenApplianceType;
        message.kitchenApplianceType = (_kitchenApplianceType = object.kitchenApplianceType) !== null && _kitchenApplianceType !== void 0 ? _kitchenApplianceType : undefined;
        var _kitchenCondition;
        message.kitchenCondition = (_kitchenCondition = object.kitchenCondition) !== null && _kitchenCondition !== void 0 ? _kitchenCondition : undefined;
        var _kitchenCounterType;
        message.kitchenCounterType = (_kitchenCounterType = object.kitchenCounterType) !== null && _kitchenCounterType !== void 0 ? _kitchenCounterType : undefined;
        var _kitchenRemodel;
        message.kitchenRemodel = (_kitchenRemodel = object.kitchenRemodel) !== null && _kitchenRemodel !== void 0 ? _kitchenRemodel : undefined;
        var _leasedSolarPanelsTriage;
        message.leasedSolarPanelsTriage = (_leasedSolarPanelsTriage = object.leasedSolarPanelsTriage) !== null && _leasedSolarPanelsTriage !== void 0 ? _leasedSolarPanelsTriage : undefined;
        var _lotOwnership;
        message.lotOwnership = (_lotOwnership = object.lotOwnership) !== null && _lotOwnership !== void 0 ? _lotOwnership : undefined;
        var _masterBedroomFloor;
        message.masterBedroomFloor = (_masterBedroomFloor = object.masterBedroomFloor) !== null && _masterBedroomFloor !== void 0 ? _masterBedroomFloor : undefined;
        var _poolType;
        message.poolType = (_poolType = object.poolType) !== null && _poolType !== void 0 ? _poolType : undefined;
        var _sharedEntrance;
        message.sharedEntrance = (_sharedEntrance = object.sharedEntrance) !== null && _sharedEntrance !== void 0 ? _sharedEntrance : undefined;
        var _solarPanelsOwnershipType;
        message.solarPanelsOwnershipType = (_solarPanelsOwnershipType = object.solarPanelsOwnershipType) !== null && _solarPanelsOwnershipType !== void 0 ? _solarPanelsOwnershipType : undefined;
        var _sqFt;
        message.sqFt = (_sqFt = object.sqFt) !== null && _sqFt !== void 0 ? _sqFt : undefined;
        var _aboveGradeSqFt;
        message.aboveGradeSqFt = (_aboveGradeSqFt = object.aboveGradeSqFt) !== null && _aboveGradeSqFt !== void 0 ? _aboveGradeSqFt : undefined;
        var _sqFtTriage;
        message.sqFtTriage = (_sqFtTriage = object.sqFtTriage) !== null && _sqFtTriage !== void 0 ? _sqFtTriage : undefined;
        var _yearBuilt;
        message.yearBuilt = (_yearBuilt = object.yearBuilt) !== null && _yearBuilt !== void 0 ? _yearBuilt : undefined;
        var _selfServiceVirtualAssessmentChoice;
        message.selfServiceVirtualAssessmentChoice = (_selfServiceVirtualAssessmentChoice = object.selfServiceVirtualAssessmentChoice) !== null && _selfServiceVirtualAssessmentChoice !== void 0 ? _selfServiceVirtualAssessmentChoice : undefined;
        var _hasUpgrades;
        message.hasUpgrades = (_hasUpgrades = object.hasUpgrades) !== null && _hasUpgrades !== void 0 ? _hasUpgrades : undefined;
        var _userVerifiedAddress;
        message.userVerifiedAddress = (_userVerifiedAddress = object.userVerifiedAddress) !== null && _userVerifiedAddress !== void 0 ? _userVerifiedAddress : undefined;
        var _listed;
        message.listed = (_listed = object.listed) !== null && _listed !== void 0 ? _listed : undefined;
        var _kitchenSellerScore;
        message.kitchenSellerScore = (_kitchenSellerScore = object.kitchenSellerScore) !== null && _kitchenSellerScore !== void 0 ? _kitchenSellerScore : undefined;
        var _bathroomSellerScore;
        message.bathroomSellerScore = (_bathroomSellerScore = object.bathroomSellerScore) !== null && _bathroomSellerScore !== void 0 ? _bathroomSellerScore : undefined;
        var _livingRoomSellerScore;
        message.livingRoomSellerScore = (_livingRoomSellerScore = object.livingRoomSellerScore) !== null && _livingRoomSellerScore !== void 0 ? _livingRoomSellerScore : undefined;
        var _exteriorSellerScore;
        message.exteriorSellerScore = (_exteriorSellerScore = object.exteriorSellerScore) !== null && _exteriorSellerScore !== void 0 ? _exteriorSellerScore : undefined;
        var _propertyCondition;
        message.propertyCondition = (_propertyCondition = object.propertyCondition) !== null && _propertyCondition !== void 0 ? _propertyCondition : undefined;
        var _activelyLooking;
        message.activelyLooking = (_activelyLooking = object.activelyLooking) !== null && _activelyLooking !== void 0 ? _activelyLooking : undefined;
        var _agent;
        message.agent = (_agent = object.agent) !== null && _agent !== void 0 ? _agent : undefined;
        var _brokerage;
        message.brokerage = (_brokerage = object.brokerage) !== null && _brokerage !== void 0 ? _brokerage : undefined;
        var _email;
        message.email = (_email = object.email) !== null && _email !== void 0 ? _email : undefined;
        var _signedListingAgreement;
        message.signedListingAgreement = (_signedListingAgreement = object.signedListingAgreement) !== null && _signedListingAgreement !== void 0 ? _signedListingAgreement : undefined;
        message.priceEstimateRange = object.priceEstimateRange !== undefined && object.priceEstimateRange !== null ? Answers_PriceEstimateRange.fromPartial(object.priceEstimateRange) : undefined;
        var _optedIntoExclusiveOffers;
        message.optedIntoExclusiveOffers = (_optedIntoExclusiveOffers = object.optedIntoExclusiveOffers) !== null && _optedIntoExclusiveOffers !== void 0 ? _optedIntoExclusiveOffers : undefined;
        var _buyingNextHome;
        message.buyingNextHome = (_buyingNextHome = object.buyingNextHome) !== null && _buyingNextHome !== void 0 ? _buyingNextHome : undefined;
        var _buyingNextHomeStatus;
        message.buyingNextHomeStatus = (_buyingNextHomeStatus = object.buyingNextHomeStatus) !== null && _buyingNextHomeStatus !== void 0 ? _buyingNextHomeStatus : undefined;
        var _sellingTimelineFlexibility;
        message.sellingTimelineFlexibility = (_sellingTimelineFlexibility = object.sellingTimelineFlexibility) !== null && _sellingTimelineFlexibility !== void 0 ? _sellingTimelineFlexibility : undefined;
        var _willingnessForTours;
        message.willingnessForTours = (_willingnessForTours = object.willingnessForTours) !== null && _willingnessForTours !== void 0 ? _willingnessForTours : undefined;
        var _currentlyInSellingProcess;
        message.currentlyInSellingProcess = (_currentlyInSellingProcess = object.currentlyInSellingProcess) !== null && _currentlyInSellingProcess !== void 0 ? _currentlyInSellingProcess : undefined;
        var _showingPreference;
        message.showingPreference = (_showingPreference = object.showingPreference) !== null && _showingPreference !== void 0 ? _showingPreference : undefined;
        var _exclusivesCustomerPhoneNumber;
        message.exclusivesCustomerPhoneNumber = (_exclusivesCustomerPhoneNumber = object.exclusivesCustomerPhoneNumber) !== null && _exclusivesCustomerPhoneNumber !== void 0 ? _exclusivesCustomerPhoneNumber : undefined;
        var _exclusivesCashOfferSentiment;
        message.exclusivesCashOfferSentiment = (_exclusivesCashOfferSentiment = object.exclusivesCashOfferSentiment) !== null && _exclusivesCashOfferSentiment !== void 0 ? _exclusivesCashOfferSentiment : undefined;
        var _exclusivesThreeMonthTimeline;
        message.exclusivesThreeMonthTimeline = (_exclusivesThreeMonthTimeline = object.exclusivesThreeMonthTimeline) !== null && _exclusivesThreeMonthTimeline !== void 0 ? _exclusivesThreeMonthTimeline : undefined;
        var _exclusivesShareWithSeriousBuyers;
        message.exclusivesShareWithSeriousBuyers = (_exclusivesShareWithSeriousBuyers = object.exclusivesShareWithSeriousBuyers) !== null && _exclusivesShareWithSeriousBuyers !== void 0 ? _exclusivesShareWithSeriousBuyers : undefined;
        var _chatQuestions;
        message.chatQuestions = (_chatQuestions = object.chatQuestions) !== null && _chatQuestions !== void 0 ? _chatQuestions : undefined;
        var _exclusivesHomesTouredAmount;
        message.exclusivesHomesTouredAmount = (_exclusivesHomesTouredAmount = object.exclusivesHomesTouredAmount) !== null && _exclusivesHomesTouredAmount !== void 0 ? _exclusivesHomesTouredAmount : undefined;
        var _exclusivesPrequalificationStatus;
        message.exclusivesPrequalificationStatus = (_exclusivesPrequalificationStatus = object.exclusivesPrequalificationStatus) !== null && _exclusivesPrequalificationStatus !== void 0 ? _exclusivesPrequalificationStatus : undefined;
        var _bedroomsOverrideReason;
        message.bedroomsOverrideReason = (_bedroomsOverrideReason = object.bedroomsOverrideReason) !== null && _bedroomsOverrideReason !== void 0 ? _bedroomsOverrideReason : undefined;
        var _bathroomsOverrideReason;
        message.bathroomsOverrideReason = (_bathroomsOverrideReason = object.bathroomsOverrideReason) !== null && _bathroomsOverrideReason !== void 0 ? _bathroomsOverrideReason : undefined;
        var _aboveGradeSqFtOverrideReason;
        message.aboveGradeSqFtOverrideReason = (_aboveGradeSqFtOverrideReason = object.aboveGradeSqFtOverrideReason) !== null && _aboveGradeSqFtOverrideReason !== void 0 ? _aboveGradeSqFtOverrideReason : undefined;
        var _basementSqFtOverrideReason;
        message.basementSqFtOverrideReason = (_basementSqFtOverrideReason = object.basementSqFtOverrideReason) !== null && _basementSqFtOverrideReason !== void 0 ? _basementSqFtOverrideReason : undefined;
        var _homeGuideRegistered;
        message.homeGuideRegistered = (_homeGuideRegistered = object.homeGuideRegistered) !== null && _homeGuideRegistered !== void 0 ? _homeGuideRegistered : undefined;
        var _listingAgentEmail;
        message.listingAgentEmail = (_listingAgentEmail = object.listingAgentEmail) !== null && _listingAgentEmail !== void 0 ? _listingAgentEmail : undefined;
        var _listingAgentFullName;
        message.listingAgentFullName = (_listingAgentFullName = object.listingAgentFullName) !== null && _listingAgentFullName !== void 0 ? _listingAgentFullName : undefined;
        var _financingReferral;
        message.financingReferral = (_financingReferral = object.financingReferral) !== null && _financingReferral !== void 0 ? _financingReferral : undefined;
        var _financingReferralOpendoorMortgage;
        message.financingReferralOpendoorMortgage = (_financingReferralOpendoorMortgage = object.financingReferralOpendoorMortgage) !== null && _financingReferralOpendoorMortgage !== void 0 ? _financingReferralOpendoorMortgage : undefined;
        var _financingReferralTrustedLender;
        message.financingReferralTrustedLender = (_financingReferralTrustedLender = object.financingReferralTrustedLender) !== null && _financingReferralTrustedLender !== void 0 ? _financingReferralTrustedLender : undefined;
        var _firstName;
        message.firstName = (_firstName = object.firstName) !== null && _firstName !== void 0 ? _firstName : undefined;
        var _fullName;
        message.fullName = (_fullName = object.fullName) !== null && _fullName !== void 0 ? _fullName : undefined;
        var _homeBuilder;
        message.homeBuilder = (_homeBuilder = object.homeBuilder) !== null && _homeBuilder !== void 0 ? _homeBuilder : undefined;
        var _homeBuilderCommunity;
        message.homeBuilderCommunity = (_homeBuilderCommunity = object.homeBuilderCommunity) !== null && _homeBuilderCommunity !== void 0 ? _homeBuilderCommunity : undefined;
        var _homeBuilderEmail;
        message.homeBuilderEmail = (_homeBuilderEmail = object.homeBuilderEmail) !== null && _homeBuilderEmail !== void 0 ? _homeBuilderEmail : undefined;
        var _homeBuilderOther;
        message.homeBuilderOther = (_homeBuilderOther = object.homeBuilderOther) !== null && _homeBuilderOther !== void 0 ? _homeBuilderOther : undefined;
        var _homeBuyingProcess;
        message.homeBuyingProcess = (_homeBuyingProcess = object.homeBuyingProcess) !== null && _homeBuyingProcess !== void 0 ? _homeBuyingProcess : undefined;
        var _homeBuyingProcessOther;
        message.homeBuyingProcessOther = (_homeBuyingProcessOther = object.homeBuyingProcessOther) !== null && _homeBuyingProcessOther !== void 0 ? _homeBuyingProcessOther : undefined;
        var _initialFinancingStatus;
        message.initialFinancingStatus = (_initialFinancingStatus = object.initialFinancingStatus) !== null && _initialFinancingStatus !== void 0 ? _initialFinancingStatus : undefined;
        var _lastName;
        message.lastName = (_lastName = object.lastName) !== null && _lastName !== void 0 ? _lastName : undefined;
        var _mlsAgentId;
        message.mlsAgentId = (_mlsAgentId = object.mlsAgentId) !== null && _mlsAgentId !== void 0 ? _mlsAgentId : undefined;
        var _mortgageAbad;
        message.mortgageAbad = (_mortgageAbad = object.mortgageAbad) !== null && _mortgageAbad !== void 0 ? _mortgageAbad : undefined;
        var _moveInReady;
        message.moveInReady = (_moveInReady = object.moveInReady) !== null && _moveInReady !== void 0 ? _moveInReady : undefined;
        var _movingAway;
        message.movingAway = (_movingAway = object.movingAway) !== null && _movingAway !== void 0 ? _movingAway : undefined;
        var _otherInformation;
        message.otherInformation = (_otherInformation = object.otherInformation) !== null && _otherInformation !== void 0 ? _otherInformation : undefined;
        var _otherSellingWays;
        message.otherSellingWays = (_otherSellingWays = object.otherSellingWays) !== null && _otherSellingWays !== void 0 ? _otherSellingWays : undefined;
        var _phoneNumber;
        message.phoneNumber = (_phoneNumber = object.phoneNumber) !== null && _phoneNumber !== void 0 ? _phoneNumber : undefined;
        var _priceEstimateCents;
        message.priceEstimateCents = (_priceEstimateCents = object.priceEstimateCents) !== null && _priceEstimateCents !== void 0 ? _priceEstimateCents : undefined;
        var _priceEstimateTriage;
        message.priceEstimateTriage = (_priceEstimateTriage = object.priceEstimateTriage) !== null && _priceEstimateTriage !== void 0 ? _priceEstimateTriage : undefined;
        var _realtorEmailOverride;
        message.realtorEmailOverride = (_realtorEmailOverride = object.realtorEmailOverride) !== null && _realtorEmailOverride !== void 0 ? _realtorEmailOverride : undefined;
        var _realtorNameOverride;
        message.realtorNameOverride = (_realtorNameOverride = object.realtorNameOverride) !== null && _realtorNameOverride !== void 0 ? _realtorNameOverride : undefined;
        var _referralSource;
        message.referralSource = (_referralSource = object.referralSource) !== null && _referralSource !== void 0 ? _referralSource : undefined;
        var _referralSourceOther;
        message.referralSourceOther = (_referralSourceOther = object.referralSourceOther) !== null && _referralSourceOther !== void 0 ? _referralSourceOther : undefined;
        var _referralSourceRadio;
        message.referralSourceRadio = (_referralSourceRadio = object.referralSourceRadio) !== null && _referralSourceRadio !== void 0 ? _referralSourceRadio : undefined;
        var _relationToOwner;
        message.relationToOwner = (_relationToOwner = object.relationToOwner) !== null && _relationToOwner !== void 0 ? _relationToOwner : undefined;
        var _relationToOwnerOther;
        message.relationToOwnerOther = (_relationToOwnerOther = object.relationToOwnerOther) !== null && _relationToOwnerOther !== void 0 ? _relationToOwnerOther : undefined;
        var _saleTimeline;
        message.saleTimeline = (_saleTimeline = object.saleTimeline) !== null && _saleTimeline !== void 0 ? _saleTimeline : undefined;
        var _scheduleOfferReview;
        message.scheduleOfferReview = (_scheduleOfferReview = object.scheduleOfferReview) !== null && _scheduleOfferReview !== void 0 ? _scheduleOfferReview : undefined;
        var _sellingReasonOther;
        message.sellingReasonOther = (_sellingReasonOther = object.sellingReasonOther) !== null && _sellingReasonOther !== void 0 ? _sellingReasonOther : undefined;
        var _workingWithHomeBuilder;
        message.workingWithHomeBuilder = (_workingWithHomeBuilder = object.workingWithHomeBuilder) !== null && _workingWithHomeBuilder !== void 0 ? _workingWithHomeBuilder : undefined;
        var _verificationPrimaryOwner;
        message.verificationPrimaryOwner = (_verificationPrimaryOwner = object.verificationPrimaryOwner) !== null && _verificationPrimaryOwner !== void 0 ? _verificationPrimaryOwner : undefined;
        message.bathroomFeatures = object.bathroomFeatures !== undefined && object.bathroomFeatures !== null ? Answers_BathroomFeatures.fromPartial(object.bathroomFeatures) : undefined;
        message.eligibilityCriteria = object.eligibilityCriteria !== undefined && object.eligibilityCriteria !== null ? Answers_EligibilityCriteria.fromPartial(object.eligibilityCriteria) : undefined;
        message.floodHistoryTriage = object.floodHistoryTriage !== undefined && object.floodHistoryTriage !== null ? Answers_FloodHistoryTriage.fromPartial(object.floodHistoryTriage) : undefined;
        message.flooringAllFloorTypes = object.flooringAllFloorTypes !== undefined && object.flooringAllFloorTypes !== null ? Answers_FloorTypes.fromPartial(object.flooringAllFloorTypes) : undefined;
        message.flooringCarpetRooms = object.flooringCarpetRooms !== undefined && object.flooringCarpetRooms !== null ? Answers_Rooms.fromPartial(object.flooringCarpetRooms) : undefined;
        message.flooringHardwoodRooms = object.flooringHardwoodRooms !== undefined && object.flooringHardwoodRooms !== null ? Answers_Rooms.fromPartial(object.flooringHardwoodRooms) : undefined;
        message.flooringLaminateRooms = object.flooringLaminateRooms !== undefined && object.flooringLaminateRooms !== null ? Answers_Rooms.fromPartial(object.flooringLaminateRooms) : undefined;
        message.flooringOtherRooms = object.flooringOtherRooms !== undefined && object.flooringOtherRooms !== null ? Answers_Rooms.fromPartial(object.flooringOtherRooms) : undefined;
        message.flooringTileRooms = object.flooringTileRooms !== undefined && object.flooringTileRooms !== null ? Answers_Rooms.fromPartial(object.flooringTileRooms) : undefined;
        message.flooringMaterials = ((ref = object.flooringMaterials) === null || ref === void 0 ? void 0 : ref.map(function(e) {
            return e;
        })) || [];
        message.kitchenFeatures = object.kitchenFeatures !== undefined && object.kitchenFeatures !== null ? Answers_KitchenFeatures.fromPartial(object.kitchenFeatures) : undefined;
        message.photosUploaded = ((ref1 = object.photosUploaded) === null || ref1 === void 0 ? void 0 : ref1.map(function(e) {
            return Answers_Photo.fromPartial(e);
        })) || [];
        message.sellingReason = object.sellingReason !== undefined && object.sellingReason !== null ? Answers_SellingReason.fromPartial(object.sellingReason) : undefined;
        var _exploringFinancing;
        message.exploringFinancing = (_exploringFinancing = object.exploringFinancing) !== null && _exploringFinancing !== void 0 ? _exploringFinancing : undefined;
        message.buyerZones = ((ref2 = object.buyerZones) === null || ref2 === void 0 ? void 0 : ref2.map(function(e) {
            return Answers_BuyerZone.fromPartial(e);
        })) || [];
        message.exclusivesInitialSellerOptionsInterest = object.exclusivesInitialSellerOptionsInterest !== undefined && object.exclusivesInitialSellerOptionsInterest !== null ? Answers_ExclusivesInitialSellerOptionsInterest.fromPartial(object.exclusivesInitialSellerOptionsInterest) : undefined;
        message.exclusivesTasksForPotentiallyHigherOffer = object.exclusivesTasksForPotentiallyHigherOffer !== undefined && object.exclusivesTasksForPotentiallyHigherOffer !== null ? Answers_ExclusivesTasksForPotentiallyHigherOffer.fromPartial(object.exclusivesTasksForPotentiallyHigherOffer) : undefined;
        var _appSmsOptIn;
        message.appSmsOptIn = (_appSmsOptIn = object.appSmsOptIn) !== null && _appSmsOptIn !== void 0 ? _appSmsOptIn : undefined;
        message.setupBuyerFeed = object.setupBuyerFeed !== undefined && object.setupBuyerFeed !== null ? Answers_SetupBuyerFeed.fromPartial(object.setupBuyerFeed) : undefined;
        message.buyingPower = object.buyingPower !== undefined && object.buyingPower !== null ? Answers_BuyingPower.fromPartial(object.buyingPower) : undefined;
        var _buyingTimeline;
        message.buyingTimeline = (_buyingTimeline = object.buyingTimeline) !== null && _buyingTimeline !== void 0 ? _buyingTimeline : undefined;
        var _buyingStage;
        message.buyingStage = (_buyingStage = object.buyingStage) !== null && _buyingStage !== void 0 ? _buyingStage : undefined;
        var _agentStatus;
        message.agentStatus = (_agentStatus = object.agentStatus) !== null && _agentStatus !== void 0 ? _agentStatus : undefined;
        var _agentType;
        message.agentType = (_agentType = object.agentType) !== null && _agentType !== void 0 ? _agentType : undefined;
        message.chatbotPhotoRequest = object.chatbotPhotoRequest !== undefined && object.chatbotPhotoRequest !== null ? Answers_ChatbotPhotoRequest.fromPartial(object.chatbotPhotoRequest) : undefined;
        message.exteriorAttributes = object.exteriorAttributes !== undefined && object.exteriorAttributes !== null ? Answers_ExteriorAttributes.fromPartial(object.exteriorAttributes) : undefined;
        message.interiorAttributes = object.interiorAttributes !== undefined && object.interiorAttributes !== null ? Answers_InteriorAttributes.fromPartial(object.interiorAttributes) : undefined;
        var _agentLedOfferPhoneNumber;
        message.agentLedOfferPhoneNumber = (_agentLedOfferPhoneNumber = object.agentLedOfferPhoneNumber) !== null && _agentLedOfferPhoneNumber !== void 0 ? _agentLedOfferPhoneNumber : undefined;
        var _agentLedOfferFullName;
        message.agentLedOfferFullName = (_agentLedOfferFullName = object.agentLedOfferFullName) !== null && _agentLedOfferFullName !== void 0 ? _agentLedOfferFullName : undefined;
        var _agentLedOfferEmail;
        message.agentLedOfferEmail = (_agentLedOfferEmail = object.agentLedOfferEmail) !== null && _agentLedOfferEmail !== void 0 ? _agentLedOfferEmail : undefined;
        message.experimental = ((ref3 = object.experimental) === null || ref3 === void 0 ? void 0 : ref3.map(function(e) {
            return Answers_ExperimentalQuestionAnswer.fromPartial(e);
        })) || [];
        var _smsOptIn;
        message.smsOptIn = (_smsOptIn = object.smsOptIn) !== null && _smsOptIn !== void 0 ? _smsOptIn : undefined;
        return message;
    }
};
function createBaseAnswers_BathroomFeatures() {
    return {
        doubleSink: undefined,
        graniteCountertops: undefined,
        separateShowerTub: undefined,
        tileSurround: undefined,
        updatedTileFloors: undefined
    };
}
var Answers_BathroomFeatures = {
    fromJSON: function fromJSON(object) {
        return {
            doubleSink: answers_isSet(object.double_sink) ? Boolean(object.double_sink) : undefined,
            graniteCountertops: answers_isSet(object.granite_countertops) ? Boolean(object.granite_countertops) : undefined,
            separateShowerTub: answers_isSet(object.separate_shower_tub) ? Boolean(object.separate_shower_tub) : undefined,
            tileSurround: answers_isSet(object.tile_surround) ? Boolean(object.tile_surround) : undefined,
            updatedTileFloors: answers_isSet(object.updated_tile_floors) ? Boolean(object.updated_tile_floors) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.doubleSink !== undefined) {
            obj.double_sink = message.doubleSink;
        }
        if (message.graniteCountertops !== undefined) {
            obj.granite_countertops = message.graniteCountertops;
        }
        if (message.separateShowerTub !== undefined) {
            obj.separate_shower_tub = message.separateShowerTub;
        }
        if (message.tileSurround !== undefined) {
            obj.tile_surround = message.tileSurround;
        }
        if (message.updatedTileFloors !== undefined) {
            obj.updated_tile_floors = message.updatedTileFloors;
        }
        return obj;
    },
    create: function create(base) {
        return Answers_BathroomFeatures.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAnswers_BathroomFeatures();
        var _doubleSink;
        message.doubleSink = (_doubleSink = object.doubleSink) !== null && _doubleSink !== void 0 ? _doubleSink : undefined;
        var _graniteCountertops;
        message.graniteCountertops = (_graniteCountertops = object.graniteCountertops) !== null && _graniteCountertops !== void 0 ? _graniteCountertops : undefined;
        var _separateShowerTub;
        message.separateShowerTub = (_separateShowerTub = object.separateShowerTub) !== null && _separateShowerTub !== void 0 ? _separateShowerTub : undefined;
        var _tileSurround;
        message.tileSurround = (_tileSurround = object.tileSurround) !== null && _tileSurround !== void 0 ? _tileSurround : undefined;
        var _updatedTileFloors;
        message.updatedTileFloors = (_updatedTileFloors = object.updatedTileFloors) !== null && _updatedTileFloors !== void 0 ? _updatedTileFloors : undefined;
        return message;
    }
};
function createBaseAnswers_EligibilityCriteria() {
    return {
        ageRestrictedCommunity: undefined,
        asbestosSiding: undefined,
        fireDamage: undefined,
        gatedCommunity: undefined,
        historyOfChemicalContamination: undefined,
        knownFoundationIssues: undefined,
        leasedSolarPanels: undefined,
        livestock: undefined,
        mobileManufacturedHome: undefined,
        ownedSolarPanels: undefined,
        permittedAddition: undefined,
        septic: undefined,
        wellWater: undefined,
        uniqueOwnershipStructure: undefined,
        belowMarketRateOwnership: undefined,
        rentControlledTenantOccupied: undefined,
        undergroundOilTank: undefined,
        polybutylenePiping: undefined,
        unpermittedAddition: undefined,
        cesspool: undefined
    };
}
var Answers_EligibilityCriteria = {
    fromJSON: function fromJSON(object) {
        return {
            ageRestrictedCommunity: answers_isSet(object.age_restricted_community) ? Boolean(object.age_restricted_community) : undefined,
            asbestosSiding: answers_isSet(object.asbestos_siding) ? Boolean(object.asbestos_siding) : undefined,
            fireDamage: answers_isSet(object.fire_damage) ? Boolean(object.fire_damage) : undefined,
            gatedCommunity: answers_isSet(object.gated_community) ? Boolean(object.gated_community) : undefined,
            historyOfChemicalContamination: answers_isSet(object.history_of_chemical_contamination) ? Boolean(object.history_of_chemical_contamination) : undefined,
            knownFoundationIssues: answers_isSet(object.known_foundation_issues) ? Boolean(object.known_foundation_issues) : undefined,
            leasedSolarPanels: answers_isSet(object.leased_solar_panels) ? Boolean(object.leased_solar_panels) : undefined,
            livestock: answers_isSet(object.livestock) ? Boolean(object.livestock) : undefined,
            mobileManufacturedHome: answers_isSet(object.mobile_manufactured_home) ? Boolean(object.mobile_manufactured_home) : undefined,
            ownedSolarPanels: answers_isSet(object.owned_solar_panels) ? Boolean(object.owned_solar_panels) : undefined,
            permittedAddition: answers_isSet(object.permitted_addition) ? Boolean(object.permitted_addition) : undefined,
            septic: answers_isSet(object.septic) ? Boolean(object.septic) : undefined,
            wellWater: answers_isSet(object.well_water) ? Boolean(object.well_water) : undefined,
            uniqueOwnershipStructure: answers_isSet(object.unique_ownership_structure) ? Boolean(object.unique_ownership_structure) : undefined,
            belowMarketRateOwnership: answers_isSet(object.below_market_rate_ownership) ? Boolean(object.below_market_rate_ownership) : undefined,
            rentControlledTenantOccupied: answers_isSet(object.rent_controlled_tenant_occupied) ? Boolean(object.rent_controlled_tenant_occupied) : undefined,
            undergroundOilTank: answers_isSet(object.underground_oil_tank) ? Boolean(object.underground_oil_tank) : undefined,
            polybutylenePiping: answers_isSet(object.polybutylene_piping) ? Boolean(object.polybutylene_piping) : undefined,
            unpermittedAddition: answers_isSet(object.unpermitted_addition) ? Boolean(object.unpermitted_addition) : undefined,
            cesspool: answers_isSet(object.cesspool) ? Boolean(object.cesspool) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.ageRestrictedCommunity !== undefined) {
            obj.age_restricted_community = message.ageRestrictedCommunity;
        }
        if (message.asbestosSiding !== undefined) {
            obj.asbestos_siding = message.asbestosSiding;
        }
        if (message.fireDamage !== undefined) {
            obj.fire_damage = message.fireDamage;
        }
        if (message.gatedCommunity !== undefined) {
            obj.gated_community = message.gatedCommunity;
        }
        if (message.historyOfChemicalContamination !== undefined) {
            obj.history_of_chemical_contamination = message.historyOfChemicalContamination;
        }
        if (message.knownFoundationIssues !== undefined) {
            obj.known_foundation_issues = message.knownFoundationIssues;
        }
        if (message.leasedSolarPanels !== undefined) {
            obj.leased_solar_panels = message.leasedSolarPanels;
        }
        if (message.livestock !== undefined) {
            obj.livestock = message.livestock;
        }
        if (message.mobileManufacturedHome !== undefined) {
            obj.mobile_manufactured_home = message.mobileManufacturedHome;
        }
        if (message.ownedSolarPanels !== undefined) {
            obj.owned_solar_panels = message.ownedSolarPanels;
        }
        if (message.permittedAddition !== undefined) {
            obj.permitted_addition = message.permittedAddition;
        }
        if (message.septic !== undefined) {
            obj.septic = message.septic;
        }
        if (message.wellWater !== undefined) {
            obj.well_water = message.wellWater;
        }
        if (message.uniqueOwnershipStructure !== undefined) {
            obj.unique_ownership_structure = message.uniqueOwnershipStructure;
        }
        if (message.belowMarketRateOwnership !== undefined) {
            obj.below_market_rate_ownership = message.belowMarketRateOwnership;
        }
        if (message.rentControlledTenantOccupied !== undefined) {
            obj.rent_controlled_tenant_occupied = message.rentControlledTenantOccupied;
        }
        if (message.undergroundOilTank !== undefined) {
            obj.underground_oil_tank = message.undergroundOilTank;
        }
        if (message.polybutylenePiping !== undefined) {
            obj.polybutylene_piping = message.polybutylenePiping;
        }
        if (message.unpermittedAddition !== undefined) {
            obj.unpermitted_addition = message.unpermittedAddition;
        }
        if (message.cesspool !== undefined) {
            obj.cesspool = message.cesspool;
        }
        return obj;
    },
    create: function create(base) {
        return Answers_EligibilityCriteria.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAnswers_EligibilityCriteria();
        var _ageRestrictedCommunity;
        message.ageRestrictedCommunity = (_ageRestrictedCommunity = object.ageRestrictedCommunity) !== null && _ageRestrictedCommunity !== void 0 ? _ageRestrictedCommunity : undefined;
        var _asbestosSiding;
        message.asbestosSiding = (_asbestosSiding = object.asbestosSiding) !== null && _asbestosSiding !== void 0 ? _asbestosSiding : undefined;
        var _fireDamage;
        message.fireDamage = (_fireDamage = object.fireDamage) !== null && _fireDamage !== void 0 ? _fireDamage : undefined;
        var _gatedCommunity;
        message.gatedCommunity = (_gatedCommunity = object.gatedCommunity) !== null && _gatedCommunity !== void 0 ? _gatedCommunity : undefined;
        var _historyOfChemicalContamination;
        message.historyOfChemicalContamination = (_historyOfChemicalContamination = object.historyOfChemicalContamination) !== null && _historyOfChemicalContamination !== void 0 ? _historyOfChemicalContamination : undefined;
        var _knownFoundationIssues;
        message.knownFoundationIssues = (_knownFoundationIssues = object.knownFoundationIssues) !== null && _knownFoundationIssues !== void 0 ? _knownFoundationIssues : undefined;
        var _leasedSolarPanels;
        message.leasedSolarPanels = (_leasedSolarPanels = object.leasedSolarPanels) !== null && _leasedSolarPanels !== void 0 ? _leasedSolarPanels : undefined;
        var _livestock;
        message.livestock = (_livestock = object.livestock) !== null && _livestock !== void 0 ? _livestock : undefined;
        var _mobileManufacturedHome;
        message.mobileManufacturedHome = (_mobileManufacturedHome = object.mobileManufacturedHome) !== null && _mobileManufacturedHome !== void 0 ? _mobileManufacturedHome : undefined;
        var _ownedSolarPanels;
        message.ownedSolarPanels = (_ownedSolarPanels = object.ownedSolarPanels) !== null && _ownedSolarPanels !== void 0 ? _ownedSolarPanels : undefined;
        var _permittedAddition;
        message.permittedAddition = (_permittedAddition = object.permittedAddition) !== null && _permittedAddition !== void 0 ? _permittedAddition : undefined;
        var _septic;
        message.septic = (_septic = object.septic) !== null && _septic !== void 0 ? _septic : undefined;
        var _wellWater;
        message.wellWater = (_wellWater = object.wellWater) !== null && _wellWater !== void 0 ? _wellWater : undefined;
        var _uniqueOwnershipStructure;
        message.uniqueOwnershipStructure = (_uniqueOwnershipStructure = object.uniqueOwnershipStructure) !== null && _uniqueOwnershipStructure !== void 0 ? _uniqueOwnershipStructure : undefined;
        var _belowMarketRateOwnership;
        message.belowMarketRateOwnership = (_belowMarketRateOwnership = object.belowMarketRateOwnership) !== null && _belowMarketRateOwnership !== void 0 ? _belowMarketRateOwnership : undefined;
        var _rentControlledTenantOccupied;
        message.rentControlledTenantOccupied = (_rentControlledTenantOccupied = object.rentControlledTenantOccupied) !== null && _rentControlledTenantOccupied !== void 0 ? _rentControlledTenantOccupied : undefined;
        var _undergroundOilTank;
        message.undergroundOilTank = (_undergroundOilTank = object.undergroundOilTank) !== null && _undergroundOilTank !== void 0 ? _undergroundOilTank : undefined;
        var _polybutylenePiping;
        message.polybutylenePiping = (_polybutylenePiping = object.polybutylenePiping) !== null && _polybutylenePiping !== void 0 ? _polybutylenePiping : undefined;
        var _unpermittedAddition;
        message.unpermittedAddition = (_unpermittedAddition = object.unpermittedAddition) !== null && _unpermittedAddition !== void 0 ? _unpermittedAddition : undefined;
        var _cesspool;
        message.cesspool = (_cesspool = object.cesspool) !== null && _cesspool !== void 0 ? _cesspool : undefined;
        return message;
    }
};
function createBaseAnswers_FloodHistoryTriage() {
    return {
        harvey: undefined,
        memorialDay: undefined,
        notSure: undefined,
        other: undefined,
        taxDay: undefined
    };
}
var Answers_FloodHistoryTriage = {
    fromJSON: function fromJSON(object) {
        return {
            harvey: answers_isSet(object.harvey) ? Boolean(object.harvey) : undefined,
            memorialDay: answers_isSet(object.memorial_day) ? Boolean(object.memorial_day) : undefined,
            notSure: answers_isSet(object.not_sure) ? Boolean(object.not_sure) : undefined,
            other: answers_isSet(object.other) ? Boolean(object.other) : undefined,
            taxDay: answers_isSet(object.tax_day) ? Boolean(object.tax_day) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.harvey !== undefined) {
            obj.harvey = message.harvey;
        }
        if (message.memorialDay !== undefined) {
            obj.memorial_day = message.memorialDay;
        }
        if (message.notSure !== undefined) {
            obj.not_sure = message.notSure;
        }
        if (message.other !== undefined) {
            obj.other = message.other;
        }
        if (message.taxDay !== undefined) {
            obj.tax_day = message.taxDay;
        }
        return obj;
    },
    create: function create(base) {
        return Answers_FloodHistoryTriage.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAnswers_FloodHistoryTriage();
        var _harvey;
        message.harvey = (_harvey = object.harvey) !== null && _harvey !== void 0 ? _harvey : undefined;
        var _memorialDay;
        message.memorialDay = (_memorialDay = object.memorialDay) !== null && _memorialDay !== void 0 ? _memorialDay : undefined;
        var _notSure;
        message.notSure = (_notSure = object.notSure) !== null && _notSure !== void 0 ? _notSure : undefined;
        var _other;
        message.other = (_other = object.other) !== null && _other !== void 0 ? _other : undefined;
        var _taxDay;
        message.taxDay = (_taxDay = object.taxDay) !== null && _taxDay !== void 0 ? _taxDay : undefined;
        return message;
    }
};
function createBaseAnswers_FloorTypes() {
    return {
        carpet: undefined,
        hardwood: undefined,
        laminate: undefined,
        other: undefined,
        tile: undefined
    };
}
var Answers_FloorTypes = {
    fromJSON: function fromJSON(object) {
        return {
            carpet: answers_isSet(object.carpet) ? Boolean(object.carpet) : undefined,
            hardwood: answers_isSet(object.hardwood) ? Boolean(object.hardwood) : undefined,
            laminate: answers_isSet(object.laminate) ? Boolean(object.laminate) : undefined,
            other: answers_isSet(object.other) ? Boolean(object.other) : undefined,
            tile: answers_isSet(object.tile) ? Boolean(object.tile) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.carpet !== undefined) {
            obj.carpet = message.carpet;
        }
        if (message.hardwood !== undefined) {
            obj.hardwood = message.hardwood;
        }
        if (message.laminate !== undefined) {
            obj.laminate = message.laminate;
        }
        if (message.other !== undefined) {
            obj.other = message.other;
        }
        if (message.tile !== undefined) {
            obj.tile = message.tile;
        }
        return obj;
    },
    create: function create(base) {
        return Answers_FloorTypes.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAnswers_FloorTypes();
        var _carpet;
        message.carpet = (_carpet = object.carpet) !== null && _carpet !== void 0 ? _carpet : undefined;
        var _hardwood;
        message.hardwood = (_hardwood = object.hardwood) !== null && _hardwood !== void 0 ? _hardwood : undefined;
        var _laminate;
        message.laminate = (_laminate = object.laminate) !== null && _laminate !== void 0 ? _laminate : undefined;
        var _other;
        message.other = (_other = object.other) !== null && _other !== void 0 ? _other : undefined;
        var _tile;
        message.tile = (_tile = object.tile) !== null && _tile !== void 0 ? _tile : undefined;
        return message;
    }
};
function createBaseAnswers_Rooms() {
    return {
        dining: undefined,
        kitchen: undefined,
        living: undefined,
        masterBathroom: undefined,
        masterBedroom: undefined,
        other: undefined
    };
}
var Answers_Rooms = {
    fromJSON: function fromJSON(object) {
        return {
            dining: answers_isSet(object.dining) ? Boolean(object.dining) : undefined,
            kitchen: answers_isSet(object.kitchen) ? Boolean(object.kitchen) : undefined,
            living: answers_isSet(object.living) ? Boolean(object.living) : undefined,
            masterBathroom: answers_isSet(object.master_bathroom) ? Boolean(object.master_bathroom) : undefined,
            masterBedroom: answers_isSet(object.master_bedroom) ? Boolean(object.master_bedroom) : undefined,
            other: answers_isSet(object.other) ? Boolean(object.other) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.dining !== undefined) {
            obj.dining = message.dining;
        }
        if (message.kitchen !== undefined) {
            obj.kitchen = message.kitchen;
        }
        if (message.living !== undefined) {
            obj.living = message.living;
        }
        if (message.masterBathroom !== undefined) {
            obj.master_bathroom = message.masterBathroom;
        }
        if (message.masterBedroom !== undefined) {
            obj.master_bedroom = message.masterBedroom;
        }
        if (message.other !== undefined) {
            obj.other = message.other;
        }
        return obj;
    },
    create: function create(base) {
        return Answers_Rooms.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAnswers_Rooms();
        var _dining;
        message.dining = (_dining = object.dining) !== null && _dining !== void 0 ? _dining : undefined;
        var _kitchen;
        message.kitchen = (_kitchen = object.kitchen) !== null && _kitchen !== void 0 ? _kitchen : undefined;
        var _living;
        message.living = (_living = object.living) !== null && _living !== void 0 ? _living : undefined;
        var _masterBathroom;
        message.masterBathroom = (_masterBathroom = object.masterBathroom) !== null && _masterBathroom !== void 0 ? _masterBathroom : undefined;
        var _masterBedroom;
        message.masterBedroom = (_masterBedroom = object.masterBedroom) !== null && _masterBedroom !== void 0 ? _masterBedroom : undefined;
        var _other;
        message.other = (_other = object.other) !== null && _other !== void 0 ? _other : undefined;
        return message;
    }
};
function createBaseAnswers_KitchenFeatures() {
    return {
        kitchenIsland: undefined,
        newCabinets: undefined,
        tileBacksplash: undefined
    };
}
var Answers_KitchenFeatures = {
    fromJSON: function fromJSON(object) {
        return {
            kitchenIsland: answers_isSet(object.kitchen_island) ? Boolean(object.kitchen_island) : undefined,
            newCabinets: answers_isSet(object.new_cabinets) ? Boolean(object.new_cabinets) : undefined,
            tileBacksplash: answers_isSet(object.tile_backsplash) ? Boolean(object.tile_backsplash) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.kitchenIsland !== undefined) {
            obj.kitchen_island = message.kitchenIsland;
        }
        if (message.newCabinets !== undefined) {
            obj.new_cabinets = message.newCabinets;
        }
        if (message.tileBacksplash !== undefined) {
            obj.tile_backsplash = message.tileBacksplash;
        }
        return obj;
    },
    create: function create(base) {
        return Answers_KitchenFeatures.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAnswers_KitchenFeatures();
        var _kitchenIsland;
        message.kitchenIsland = (_kitchenIsland = object.kitchenIsland) !== null && _kitchenIsland !== void 0 ? _kitchenIsland : undefined;
        var _newCabinets;
        message.newCabinets = (_newCabinets = object.newCabinets) !== null && _newCabinets !== void 0 ? _newCabinets : undefined;
        var _tileBacksplash;
        message.tileBacksplash = (_tileBacksplash = object.tileBacksplash) !== null && _tileBacksplash !== void 0 ? _tileBacksplash : undefined;
        return message;
    }
};
function createBaseAnswers_ExteriorAttributes() {
    return {
        hasNiceBackyard: undefined,
        patio: undefined,
        deck: undefined,
        dock: undefined,
        hasNewRoof: undefined,
        hasNewWindows: undefined,
        sprinkler: undefined,
        vinylSiding: undefined,
        upgradedPool: undefined,
        porch: undefined
    };
}
var Answers_ExteriorAttributes = {
    fromJSON: function fromJSON(object) {
        return {
            hasNiceBackyard: answers_isSet(object.has_nice_backyard) ? Boolean(object.has_nice_backyard) : undefined,
            patio: answers_isSet(object.patio) ? Boolean(object.patio) : undefined,
            deck: answers_isSet(object.deck) ? Boolean(object.deck) : undefined,
            dock: answers_isSet(object.dock) ? Boolean(object.dock) : undefined,
            hasNewRoof: answers_isSet(object.has_new_roof) ? Boolean(object.has_new_roof) : undefined,
            hasNewWindows: answers_isSet(object.has_new_windows) ? Boolean(object.has_new_windows) : undefined,
            sprinkler: answers_isSet(object.sprinkler) ? Boolean(object.sprinkler) : undefined,
            vinylSiding: answers_isSet(object.vinyl_siding) ? Boolean(object.vinyl_siding) : undefined,
            upgradedPool: answers_isSet(object.upgraded_pool) ? Boolean(object.upgraded_pool) : undefined,
            porch: answers_isSet(object.porch) ? Boolean(object.porch) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.hasNiceBackyard !== undefined) {
            obj.has_nice_backyard = message.hasNiceBackyard;
        }
        if (message.patio !== undefined) {
            obj.patio = message.patio;
        }
        if (message.deck !== undefined) {
            obj.deck = message.deck;
        }
        if (message.dock !== undefined) {
            obj.dock = message.dock;
        }
        if (message.hasNewRoof !== undefined) {
            obj.has_new_roof = message.hasNewRoof;
        }
        if (message.hasNewWindows !== undefined) {
            obj.has_new_windows = message.hasNewWindows;
        }
        if (message.sprinkler !== undefined) {
            obj.sprinkler = message.sprinkler;
        }
        if (message.vinylSiding !== undefined) {
            obj.vinyl_siding = message.vinylSiding;
        }
        if (message.upgradedPool !== undefined) {
            obj.upgraded_pool = message.upgradedPool;
        }
        if (message.porch !== undefined) {
            obj.porch = message.porch;
        }
        return obj;
    },
    create: function create(base) {
        return Answers_ExteriorAttributes.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAnswers_ExteriorAttributes();
        var _hasNiceBackyard;
        message.hasNiceBackyard = (_hasNiceBackyard = object.hasNiceBackyard) !== null && _hasNiceBackyard !== void 0 ? _hasNiceBackyard : undefined;
        var _patio;
        message.patio = (_patio = object.patio) !== null && _patio !== void 0 ? _patio : undefined;
        var _deck;
        message.deck = (_deck = object.deck) !== null && _deck !== void 0 ? _deck : undefined;
        var _dock;
        message.dock = (_dock = object.dock) !== null && _dock !== void 0 ? _dock : undefined;
        var _hasNewRoof;
        message.hasNewRoof = (_hasNewRoof = object.hasNewRoof) !== null && _hasNewRoof !== void 0 ? _hasNewRoof : undefined;
        var _hasNewWindows;
        message.hasNewWindows = (_hasNewWindows = object.hasNewWindows) !== null && _hasNewWindows !== void 0 ? _hasNewWindows : undefined;
        var _sprinkler;
        message.sprinkler = (_sprinkler = object.sprinkler) !== null && _sprinkler !== void 0 ? _sprinkler : undefined;
        var _vinylSiding;
        message.vinylSiding = (_vinylSiding = object.vinylSiding) !== null && _vinylSiding !== void 0 ? _vinylSiding : undefined;
        var _upgradedPool;
        message.upgradedPool = (_upgradedPool = object.upgradedPool) !== null && _upgradedPool !== void 0 ? _upgradedPool : undefined;
        var _porch;
        message.porch = (_porch = object.porch) !== null && _porch !== void 0 ? _porch : undefined;
        return message;
    }
};
function createBaseAnswers_InteriorAttributes() {
    return {
        hasFireplace: undefined,
        kitchenIsland: undefined,
        sunroom: undefined,
        hasOpenFloorPlan: undefined,
        hasWalkInCloset: undefined,
        finishedLoft: undefined,
        basementWindows: undefined,
        laundry: undefined
    };
}
var Answers_InteriorAttributes = {
    fromJSON: function fromJSON(object) {
        return {
            hasFireplace: answers_isSet(object.has_fireplace) ? Boolean(object.has_fireplace) : undefined,
            kitchenIsland: answers_isSet(object.kitchen_island) ? Boolean(object.kitchen_island) : undefined,
            sunroom: answers_isSet(object.sunroom) ? Boolean(object.sunroom) : undefined,
            hasOpenFloorPlan: answers_isSet(object.has_open_floor_plan) ? Boolean(object.has_open_floor_plan) : undefined,
            hasWalkInCloset: answers_isSet(object.has_walk_in_closet) ? Boolean(object.has_walk_in_closet) : undefined,
            finishedLoft: answers_isSet(object.finished_loft) ? Boolean(object.finished_loft) : undefined,
            basementWindows: answers_isSet(object.basement_windows) ? Boolean(object.basement_windows) : undefined,
            laundry: answers_isSet(object.laundry) ? Boolean(object.laundry) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.hasFireplace !== undefined) {
            obj.has_fireplace = message.hasFireplace;
        }
        if (message.kitchenIsland !== undefined) {
            obj.kitchen_island = message.kitchenIsland;
        }
        if (message.sunroom !== undefined) {
            obj.sunroom = message.sunroom;
        }
        if (message.hasOpenFloorPlan !== undefined) {
            obj.has_open_floor_plan = message.hasOpenFloorPlan;
        }
        if (message.hasWalkInCloset !== undefined) {
            obj.has_walk_in_closet = message.hasWalkInCloset;
        }
        if (message.finishedLoft !== undefined) {
            obj.finished_loft = message.finishedLoft;
        }
        if (message.basementWindows !== undefined) {
            obj.basement_windows = message.basementWindows;
        }
        if (message.laundry !== undefined) {
            obj.laundry = message.laundry;
        }
        return obj;
    },
    create: function create(base) {
        return Answers_InteriorAttributes.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAnswers_InteriorAttributes();
        var _hasFireplace;
        message.hasFireplace = (_hasFireplace = object.hasFireplace) !== null && _hasFireplace !== void 0 ? _hasFireplace : undefined;
        var _kitchenIsland;
        message.kitchenIsland = (_kitchenIsland = object.kitchenIsland) !== null && _kitchenIsland !== void 0 ? _kitchenIsland : undefined;
        var _sunroom;
        message.sunroom = (_sunroom = object.sunroom) !== null && _sunroom !== void 0 ? _sunroom : undefined;
        var _hasOpenFloorPlan;
        message.hasOpenFloorPlan = (_hasOpenFloorPlan = object.hasOpenFloorPlan) !== null && _hasOpenFloorPlan !== void 0 ? _hasOpenFloorPlan : undefined;
        var _hasWalkInCloset;
        message.hasWalkInCloset = (_hasWalkInCloset = object.hasWalkInCloset) !== null && _hasWalkInCloset !== void 0 ? _hasWalkInCloset : undefined;
        var _finishedLoft;
        message.finishedLoft = (_finishedLoft = object.finishedLoft) !== null && _finishedLoft !== void 0 ? _finishedLoft : undefined;
        var _basementWindows;
        message.basementWindows = (_basementWindows = object.basementWindows) !== null && _basementWindows !== void 0 ? _basementWindows : undefined;
        var _laundry;
        message.laundry = (_laundry = object.laundry) !== null && _laundry !== void 0 ? _laundry : undefined;
        return message;
    }
};
function createBaseAnswers_SellingReason() {
    return {
        downsizing: undefined,
        investmentProperty: undefined,
        needCash: undefined,
        other: undefined,
        relocating: undefined,
        retiring: undefined,
        upgrading: undefined
    };
}
var Answers_SellingReason = {
    fromJSON: function fromJSON(object) {
        return {
            downsizing: answers_isSet(object.downsizing) ? Boolean(object.downsizing) : undefined,
            investmentProperty: answers_isSet(object.investment_property) ? Boolean(object.investment_property) : undefined,
            needCash: answers_isSet(object.need_cash) ? Boolean(object.need_cash) : undefined,
            other: answers_isSet(object.other) ? Boolean(object.other) : undefined,
            relocating: answers_isSet(object.relocating) ? Boolean(object.relocating) : undefined,
            retiring: answers_isSet(object.retiring) ? Boolean(object.retiring) : undefined,
            upgrading: answers_isSet(object.upgrading) ? Boolean(object.upgrading) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.downsizing !== undefined) {
            obj.downsizing = message.downsizing;
        }
        if (message.investmentProperty !== undefined) {
            obj.investment_property = message.investmentProperty;
        }
        if (message.needCash !== undefined) {
            obj.need_cash = message.needCash;
        }
        if (message.other !== undefined) {
            obj.other = message.other;
        }
        if (message.relocating !== undefined) {
            obj.relocating = message.relocating;
        }
        if (message.retiring !== undefined) {
            obj.retiring = message.retiring;
        }
        if (message.upgrading !== undefined) {
            obj.upgrading = message.upgrading;
        }
        return obj;
    },
    create: function create(base) {
        return Answers_SellingReason.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAnswers_SellingReason();
        var _downsizing;
        message.downsizing = (_downsizing = object.downsizing) !== null && _downsizing !== void 0 ? _downsizing : undefined;
        var _investmentProperty;
        message.investmentProperty = (_investmentProperty = object.investmentProperty) !== null && _investmentProperty !== void 0 ? _investmentProperty : undefined;
        var _needCash;
        message.needCash = (_needCash = object.needCash) !== null && _needCash !== void 0 ? _needCash : undefined;
        var _other;
        message.other = (_other = object.other) !== null && _other !== void 0 ? _other : undefined;
        var _relocating;
        message.relocating = (_relocating = object.relocating) !== null && _relocating !== void 0 ? _relocating : undefined;
        var _retiring;
        message.retiring = (_retiring = object.retiring) !== null && _retiring !== void 0 ? _retiring : undefined;
        var _upgrading;
        message.upgrading = (_upgrading = object.upgrading) !== null && _upgrading !== void 0 ? _upgrading : undefined;
        return message;
    }
};
function createBaseAnswers_Photo() {
    return {
        key: undefined,
        url: undefined,
        filename: undefined,
        mimetype: undefined
    };
}
var Answers_Photo = {
    fromJSON: function fromJSON(object) {
        return {
            key: answers_isSet(object.key) ? String(object.key) : undefined,
            url: answers_isSet(object.url) ? String(object.url) : undefined,
            filename: answers_isSet(object.filename) ? String(object.filename) : undefined,
            mimetype: answers_isSet(object.mimetype) ? String(object.mimetype) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.key !== undefined) {
            obj.key = message.key;
        }
        if (message.url !== undefined) {
            obj.url = message.url;
        }
        if (message.filename !== undefined) {
            obj.filename = message.filename;
        }
        if (message.mimetype !== undefined) {
            obj.mimetype = message.mimetype;
        }
        return obj;
    },
    create: function create(base) {
        return Answers_Photo.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAnswers_Photo();
        var _key;
        message.key = (_key = object.key) !== null && _key !== void 0 ? _key : undefined;
        var _url;
        message.url = (_url = object.url) !== null && _url !== void 0 ? _url : undefined;
        var _filename;
        message.filename = (_filename = object.filename) !== null && _filename !== void 0 ? _filename : undefined;
        var _mimetype;
        message.mimetype = (_mimetype = object.mimetype) !== null && _mimetype !== void 0 ? _mimetype : undefined;
        return message;
    }
};
function createBaseAnswers_BuyerZone() {
    return {
        breadcrumbPath: undefined,
        displayName: undefined,
        displayablePropertiesCount: undefined,
        id: undefined,
        isNearby: undefined,
        name: undefined,
        parentName: undefined,
        parents: [],
        value: undefined,
        zip: undefined,
        gdsId: undefined
    };
}
var Answers_BuyerZone = {
    fromJSON: function fromJSON(object) {
        return {
            breadcrumbPath: answers_isSet(object.breadcrumb_path) ? String(object.breadcrumb_path) : undefined,
            displayName: answers_isSet(object.display_name) ? String(object.display_name) : undefined,
            displayablePropertiesCount: answers_isSet(object.displayable_properties_count) ? Number(object.displayable_properties_count) : undefined,
            id: answers_isSet(object.id) ? String(object.id) : undefined,
            isNearby: answers_isSet(object.is_nearby) ? Boolean(object.is_nearby) : undefined,
            name: answers_isSet(object.name) ? String(object.name) : undefined,
            parentName: answers_isSet(object.parent_name) ? String(object.parent_name) : undefined,
            parents: Array.isArray(object === null || object === void 0 ? void 0 : object.parents) ? object.parents.map(function(e) {
                return Answers_BuyerZone_ZoneParent.fromJSON(e);
            }) : [],
            value: answers_isSet(object.value) ? String(object.value) : undefined,
            zip: answers_isSet(object.zip) ? Boolean(object.zip) : undefined,
            gdsId: answers_isSet(object.gdsId) ? String(object.gdsId) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var ref;
        var obj = {};
        if (message.breadcrumbPath !== undefined) {
            obj.breadcrumb_path = message.breadcrumbPath;
        }
        if (message.displayName !== undefined) {
            obj.display_name = message.displayName;
        }
        if (message.displayablePropertiesCount !== undefined) {
            obj.displayable_properties_count = message.displayablePropertiesCount;
        }
        if (message.id !== undefined) {
            obj.id = message.id;
        }
        if (message.isNearby !== undefined) {
            obj.is_nearby = message.isNearby;
        }
        if (message.name !== undefined) {
            obj.name = message.name;
        }
        if (message.parentName !== undefined) {
            obj.parent_name = message.parentName;
        }
        if ((ref = message.parents) === null || ref === void 0 ? void 0 : ref.length) {
            obj.parents = message.parents.map(function(e) {
                return Answers_BuyerZone_ZoneParent.toJSON(e);
            });
        }
        if (message.value !== undefined) {
            obj.value = message.value;
        }
        if (message.zip !== undefined) {
            obj.zip = message.zip;
        }
        if (message.gdsId !== undefined) {
            obj.gdsId = message.gdsId;
        }
        return obj;
    },
    create: function create(base) {
        return Answers_BuyerZone.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref;
        var message = createBaseAnswers_BuyerZone();
        var _breadcrumbPath;
        message.breadcrumbPath = (_breadcrumbPath = object.breadcrumbPath) !== null && _breadcrumbPath !== void 0 ? _breadcrumbPath : undefined;
        var _displayName;
        message.displayName = (_displayName = object.displayName) !== null && _displayName !== void 0 ? _displayName : undefined;
        var _displayablePropertiesCount;
        message.displayablePropertiesCount = (_displayablePropertiesCount = object.displayablePropertiesCount) !== null && _displayablePropertiesCount !== void 0 ? _displayablePropertiesCount : undefined;
        var _id;
        message.id = (_id = object.id) !== null && _id !== void 0 ? _id : undefined;
        var _isNearby;
        message.isNearby = (_isNearby = object.isNearby) !== null && _isNearby !== void 0 ? _isNearby : undefined;
        var _name;
        message.name = (_name = object.name) !== null && _name !== void 0 ? _name : undefined;
        var _parentName;
        message.parentName = (_parentName = object.parentName) !== null && _parentName !== void 0 ? _parentName : undefined;
        message.parents = ((ref = object.parents) === null || ref === void 0 ? void 0 : ref.map(function(e) {
            return Answers_BuyerZone_ZoneParent.fromPartial(e);
        })) || [];
        var _value;
        message.value = (_value = object.value) !== null && _value !== void 0 ? _value : undefined;
        var _zip;
        message.zip = (_zip = object.zip) !== null && _zip !== void 0 ? _zip : undefined;
        var _gdsId;
        message.gdsId = (_gdsId = object.gdsId) !== null && _gdsId !== void 0 ? _gdsId : undefined;
        return message;
    }
};
function createBaseAnswers_BuyerZone_ZoneParent() {
    return {
        breadcrumbPath: undefined,
        name: undefined
    };
}
var Answers_BuyerZone_ZoneParent = {
    fromJSON: function fromJSON(object) {
        return {
            breadcrumbPath: answers_isSet(object.breadcrumb_path) ? String(object.breadcrumb_path) : undefined,
            name: answers_isSet(object.name) ? String(object.name) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.breadcrumbPath !== undefined) {
            obj.breadcrumb_path = message.breadcrumbPath;
        }
        if (message.name !== undefined) {
            obj.name = message.name;
        }
        return obj;
    },
    create: function create(base) {
        return Answers_BuyerZone_ZoneParent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAnswers_BuyerZone_ZoneParent();
        var _breadcrumbPath;
        message.breadcrumbPath = (_breadcrumbPath = object.breadcrumbPath) !== null && _breadcrumbPath !== void 0 ? _breadcrumbPath : undefined;
        var _name;
        message.name = (_name = object.name) !== null && _name !== void 0 ? _name : undefined;
        return message;
    }
};
function createBaseAnswers_FeedPropertyTypes() {
    return {
        home: undefined,
        apartment: undefined,
        townhome: undefined,
        multiFamily: undefined
    };
}
var Answers_FeedPropertyTypes = {
    fromJSON: function fromJSON(object) {
        return {
            home: answers_isSet(object.home) ? Boolean(object.home) : undefined,
            apartment: answers_isSet(object.apartment) ? Boolean(object.apartment) : undefined,
            townhome: answers_isSet(object.townhome) ? Boolean(object.townhome) : undefined,
            multiFamily: answers_isSet(object.multi_family) ? Boolean(object.multi_family) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.home !== undefined) {
            obj.home = message.home;
        }
        if (message.apartment !== undefined) {
            obj.apartment = message.apartment;
        }
        if (message.townhome !== undefined) {
            obj.townhome = message.townhome;
        }
        if (message.multiFamily !== undefined) {
            obj.multi_family = message.multiFamily;
        }
        return obj;
    },
    create: function create(base) {
        return Answers_FeedPropertyTypes.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAnswers_FeedPropertyTypes();
        var _home;
        message.home = (_home = object.home) !== null && _home !== void 0 ? _home : undefined;
        var _apartment;
        message.apartment = (_apartment = object.apartment) !== null && _apartment !== void 0 ? _apartment : undefined;
        var _townhome;
        message.townhome = (_townhome = object.townhome) !== null && _townhome !== void 0 ? _townhome : undefined;
        var _multiFamily;
        message.multiFamily = (_multiFamily = object.multiFamily) !== null && _multiFamily !== void 0 ? _multiFamily : undefined;
        return message;
    }
};
function createBaseAnswers_SetupBuyerFeed() {
    return {
        zones: [],
        maxPrice: undefined,
        minPrice: undefined,
        minBedrooms: undefined,
        minBathrooms: undefined,
        propertyTypes: undefined
    };
}
var Answers_SetupBuyerFeed = {
    fromJSON: function fromJSON(object) {
        return {
            zones: Array.isArray(object === null || object === void 0 ? void 0 : object.zones) ? object.zones.map(function(e) {
                return Answers_BuyerZone.fromJSON(e);
            }) : [],
            maxPrice: answers_isSet(object.max_price) ? Number(object.max_price) : undefined,
            minPrice: answers_isSet(object.min_price) ? Number(object.min_price) : undefined,
            minBedrooms: answers_isSet(object.min_bedrooms) ? Number(object.min_bedrooms) : undefined,
            minBathrooms: answers_isSet(object.min_bathrooms) ? Number(object.min_bathrooms) : undefined,
            propertyTypes: answers_isSet(object.property_types) ? Answers_FeedPropertyTypes.fromJSON(object.property_types) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var ref;
        var obj = {};
        if ((ref = message.zones) === null || ref === void 0 ? void 0 : ref.length) {
            obj.zones = message.zones.map(function(e) {
                return Answers_BuyerZone.toJSON(e);
            });
        }
        if (message.maxPrice !== undefined) {
            obj.max_price = message.maxPrice;
        }
        if (message.minPrice !== undefined) {
            obj.min_price = message.minPrice;
        }
        if (message.minBedrooms !== undefined) {
            obj.min_bedrooms = message.minBedrooms;
        }
        if (message.minBathrooms !== undefined) {
            obj.min_bathrooms = message.minBathrooms;
        }
        if (message.propertyTypes !== undefined) {
            obj.property_types = Answers_FeedPropertyTypes.toJSON(message.propertyTypes);
        }
        return obj;
    },
    create: function create(base) {
        return Answers_SetupBuyerFeed.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref;
        var message = createBaseAnswers_SetupBuyerFeed();
        message.zones = ((ref = object.zones) === null || ref === void 0 ? void 0 : ref.map(function(e) {
            return Answers_BuyerZone.fromPartial(e);
        })) || [];
        var _maxPrice;
        message.maxPrice = (_maxPrice = object.maxPrice) !== null && _maxPrice !== void 0 ? _maxPrice : undefined;
        var _minPrice;
        message.minPrice = (_minPrice = object.minPrice) !== null && _minPrice !== void 0 ? _minPrice : undefined;
        var _minBedrooms;
        message.minBedrooms = (_minBedrooms = object.minBedrooms) !== null && _minBedrooms !== void 0 ? _minBedrooms : undefined;
        var _minBathrooms;
        message.minBathrooms = (_minBathrooms = object.minBathrooms) !== null && _minBathrooms !== void 0 ? _minBathrooms : undefined;
        message.propertyTypes = object.propertyTypes !== undefined && object.propertyTypes !== null ? Answers_FeedPropertyTypes.fromPartial(object.propertyTypes) : undefined;
        return message;
    }
};
function createBaseAnswers_BuyingPower() {
    return {
        annualHouseholdIncome: 0,
        downPaymentAmount: 0,
        monthlyDebt: 0,
        creditScoreIndicated: undefined
    };
}
var Answers_BuyingPower = {
    fromJSON: function fromJSON(object) {
        return {
            annualHouseholdIncome: answers_isSet(object.annual_household_income) ? Number(object.annual_household_income) : 0,
            downPaymentAmount: answers_isSet(object.down_payment_amount) ? Number(object.down_payment_amount) : 0,
            monthlyDebt: answers_isSet(object.monthly_debt) ? Number(object.monthly_debt) : 0,
            creditScoreIndicated: answers_isSet(object.credit_score_indicated) ? CreditRange.fromJSON(object.credit_score_indicated) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.annualHouseholdIncome !== 0) {
            obj.annual_household_income = Math.round(message.annualHouseholdIncome);
        }
        if (message.downPaymentAmount !== 0) {
            obj.down_payment_amount = Math.round(message.downPaymentAmount);
        }
        if (message.monthlyDebt !== 0) {
            obj.monthly_debt = Math.round(message.monthlyDebt);
        }
        if (message.creditScoreIndicated !== undefined) {
            obj.credit_score_indicated = CreditRange.toJSON(message.creditScoreIndicated);
        }
        return obj;
    },
    create: function create(base) {
        return Answers_BuyingPower.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAnswers_BuyingPower();
        var _annualHouseholdIncome;
        message.annualHouseholdIncome = (_annualHouseholdIncome = object.annualHouseholdIncome) !== null && _annualHouseholdIncome !== void 0 ? _annualHouseholdIncome : 0;
        var _downPaymentAmount;
        message.downPaymentAmount = (_downPaymentAmount = object.downPaymentAmount) !== null && _downPaymentAmount !== void 0 ? _downPaymentAmount : 0;
        var _monthlyDebt;
        message.monthlyDebt = (_monthlyDebt = object.monthlyDebt) !== null && _monthlyDebt !== void 0 ? _monthlyDebt : 0;
        message.creditScoreIndicated = object.creditScoreIndicated !== undefined && object.creditScoreIndicated !== null ? CreditRange.fromPartial(object.creditScoreIndicated) : undefined;
        return message;
    }
};
function createBaseAnswers_EntryTypes() {
    return {
        directEntry: undefined,
        sharedEntranceCondo: undefined
    };
}
var Answers_EntryTypes = {
    fromJSON: function fromJSON(object) {
        return {
            directEntry: answers_isSet(object.direct_entry) ? Boolean(object.direct_entry) : undefined,
            sharedEntranceCondo: answers_isSet(object.shared_entrance_condo) ? Boolean(object.shared_entrance_condo) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.directEntry !== undefined) {
            obj.direct_entry = message.directEntry;
        }
        if (message.sharedEntranceCondo !== undefined) {
            obj.shared_entrance_condo = message.sharedEntranceCondo;
        }
        return obj;
    },
    create: function create(base) {
        return Answers_EntryTypes.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAnswers_EntryTypes();
        var _directEntry;
        message.directEntry = (_directEntry = object.directEntry) !== null && _directEntry !== void 0 ? _directEntry : undefined;
        var _sharedEntranceCondo;
        message.sharedEntranceCondo = (_sharedEntranceCondo = object.sharedEntranceCondo) !== null && _sharedEntranceCondo !== void 0 ? _sharedEntranceCondo : undefined;
        return message;
    }
};
function createBaseAnswers_HoaTypes() {
    return {
        ageRestrictedCommunity: undefined,
        gatedCommunity: undefined,
        guardedGatedCommunity: undefined,
        sharedEntranceCondo: undefined
    };
}
var Answers_HoaTypes = {
    fromJSON: function fromJSON(object) {
        return {
            ageRestrictedCommunity: answers_isSet(object.age_restricted_community) ? Boolean(object.age_restricted_community) : undefined,
            gatedCommunity: answers_isSet(object.gated_community) ? Boolean(object.gated_community) : undefined,
            guardedGatedCommunity: answers_isSet(object.guarded_gated_community) ? String(object.guarded_gated_community) : undefined,
            sharedEntranceCondo: answers_isSet(object.shared_entrance_condo) ? Boolean(object.shared_entrance_condo) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.ageRestrictedCommunity !== undefined) {
            obj.age_restricted_community = message.ageRestrictedCommunity;
        }
        if (message.gatedCommunity !== undefined) {
            obj.gated_community = message.gatedCommunity;
        }
        if (message.guardedGatedCommunity !== undefined) {
            obj.guarded_gated_community = message.guardedGatedCommunity;
        }
        if (message.sharedEntranceCondo !== undefined) {
            obj.shared_entrance_condo = message.sharedEntranceCondo;
        }
        return obj;
    },
    create: function create(base) {
        return Answers_HoaTypes.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAnswers_HoaTypes();
        var _ageRestrictedCommunity;
        message.ageRestrictedCommunity = (_ageRestrictedCommunity = object.ageRestrictedCommunity) !== null && _ageRestrictedCommunity !== void 0 ? _ageRestrictedCommunity : undefined;
        var _gatedCommunity;
        message.gatedCommunity = (_gatedCommunity = object.gatedCommunity) !== null && _gatedCommunity !== void 0 ? _gatedCommunity : undefined;
        var _guardedGatedCommunity;
        message.guardedGatedCommunity = (_guardedGatedCommunity = object.guardedGatedCommunity) !== null && _guardedGatedCommunity !== void 0 ? _guardedGatedCommunity : undefined;
        var _sharedEntranceCondo;
        message.sharedEntranceCondo = (_sharedEntranceCondo = object.sharedEntranceCondo) !== null && _sharedEntranceCondo !== void 0 ? _sharedEntranceCondo : undefined;
        return message;
    }
};
function createBaseAnswers_PriceEstimateRange() {
    return {
        minPrice: undefined,
        maxPrice: undefined
    };
}
var Answers_PriceEstimateRange = {
    fromJSON: function fromJSON(object) {
        return {
            minPrice: answers_isSet(object.min) ? String(object.min) : undefined,
            maxPrice: answers_isSet(object.max) ? String(object.max) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.minPrice !== undefined) {
            obj.min = message.minPrice;
        }
        if (message.maxPrice !== undefined) {
            obj.max = message.maxPrice;
        }
        return obj;
    },
    create: function create(base) {
        return Answers_PriceEstimateRange.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAnswers_PriceEstimateRange();
        var _minPrice;
        message.minPrice = (_minPrice = object.minPrice) !== null && _minPrice !== void 0 ? _minPrice : undefined;
        var _maxPrice;
        message.maxPrice = (_maxPrice = object.maxPrice) !== null && _maxPrice !== void 0 ? _maxPrice : undefined;
        return message;
    }
};
function createBaseAnswers_ExclusivesInitialSellerOptionsInterest() {
    return {
        sellDirect: undefined,
        exclusives: undefined,
        traditionalListing: undefined
    };
}
var Answers_ExclusivesInitialSellerOptionsInterest = {
    fromJSON: function fromJSON(object) {
        return {
            sellDirect: answers_isSet(object.sell_direct) ? Boolean(object.sell_direct) : undefined,
            exclusives: answers_isSet(object.exclusives) ? Boolean(object.exclusives) : undefined,
            traditionalListing: answers_isSet(object.traditional_listing) ? Boolean(object.traditional_listing) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.sellDirect !== undefined) {
            obj.sell_direct = message.sellDirect;
        }
        if (message.exclusives !== undefined) {
            obj.exclusives = message.exclusives;
        }
        if (message.traditionalListing !== undefined) {
            obj.traditional_listing = message.traditionalListing;
        }
        return obj;
    },
    create: function create(base) {
        return Answers_ExclusivesInitialSellerOptionsInterest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAnswers_ExclusivesInitialSellerOptionsInterest();
        var _sellDirect;
        message.sellDirect = (_sellDirect = object.sellDirect) !== null && _sellDirect !== void 0 ? _sellDirect : undefined;
        var _exclusives;
        message.exclusives = (_exclusives = object.exclusives) !== null && _exclusives !== void 0 ? _exclusives : undefined;
        var _traditionalListing;
        message.traditionalListing = (_traditionalListing = object.traditionalListing) !== null && _traditionalListing !== void 0 ? _traditionalListing : undefined;
        return message;
    }
};
function createBaseAnswers_ExclusivesTasksForPotentiallyHigherOffer() {
    return {
        haveAnOpenHouse: undefined,
        forSaleSign: undefined,
        makeRepairs: undefined,
        listHomeTraditionally: undefined
    };
}
var Answers_ExclusivesTasksForPotentiallyHigherOffer = {
    fromJSON: function fromJSON(object) {
        return {
            haveAnOpenHouse: answers_isSet(object.have_an_open_house) ? Boolean(object.have_an_open_house) : undefined,
            forSaleSign: answers_isSet(object.for_sale_sign) ? Boolean(object.for_sale_sign) : undefined,
            makeRepairs: answers_isSet(object.make_repairs) ? Boolean(object.make_repairs) : undefined,
            listHomeTraditionally: answers_isSet(object.list_home_traditionally) ? Boolean(object.list_home_traditionally) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.haveAnOpenHouse !== undefined) {
            obj.have_an_open_house = message.haveAnOpenHouse;
        }
        if (message.forSaleSign !== undefined) {
            obj.for_sale_sign = message.forSaleSign;
        }
        if (message.makeRepairs !== undefined) {
            obj.make_repairs = message.makeRepairs;
        }
        if (message.listHomeTraditionally !== undefined) {
            obj.list_home_traditionally = message.listHomeTraditionally;
        }
        return obj;
    },
    create: function create(base) {
        return Answers_ExclusivesTasksForPotentiallyHigherOffer.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAnswers_ExclusivesTasksForPotentiallyHigherOffer();
        var _haveAnOpenHouse;
        message.haveAnOpenHouse = (_haveAnOpenHouse = object.haveAnOpenHouse) !== null && _haveAnOpenHouse !== void 0 ? _haveAnOpenHouse : undefined;
        var _forSaleSign;
        message.forSaleSign = (_forSaleSign = object.forSaleSign) !== null && _forSaleSign !== void 0 ? _forSaleSign : undefined;
        var _makeRepairs;
        message.makeRepairs = (_makeRepairs = object.makeRepairs) !== null && _makeRepairs !== void 0 ? _makeRepairs : undefined;
        var _listHomeTraditionally;
        message.listHomeTraditionally = (_listHomeTraditionally = object.listHomeTraditionally) !== null && _listHomeTraditionally !== void 0 ? _listHomeTraditionally : undefined;
        return message;
    }
};
function createBaseAnswers_ChatbotPhotoRequest() {
    return {
        status: undefined,
        variant: undefined
    };
}
var Answers_ChatbotPhotoRequest = {
    fromJSON: function fromJSON(object) {
        return {
            status: answers_isSet(object.status) ? String(object.status) : undefined,
            variant: answers_isSet(object.variant) ? String(object.variant) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.status !== undefined) {
            obj.status = message.status;
        }
        if (message.variant !== undefined) {
            obj.variant = message.variant;
        }
        return obj;
    },
    create: function create(base) {
        return Answers_ChatbotPhotoRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAnswers_ChatbotPhotoRequest();
        var _status;
        message.status = (_status = object.status) !== null && _status !== void 0 ? _status : undefined;
        var _variant;
        message.variant = (_variant = object.variant) !== null && _variant !== void 0 ? _variant : undefined;
        return message;
    }
};
function createBaseAnswers_ExperimentalQuestionAnswer() {
    return {
        questionKey: "",
        selectedValues: undefined
    };
}
var Answers_ExperimentalQuestionAnswer = {
    fromJSON: function fromJSON(object) {
        return {
            questionKey: answers_isSet(object.question_key) ? String(object.question_key) : "",
            selectedValues: answers_isSet(object.string_values) ? {
                $case: "stringValues",
                stringValues: Answers_ExperimentalQuestionAnswer_StringValues.fromJSON(object.string_values)
            } : answers_isSet(object.double_value) ? {
                $case: "doubleValue",
                doubleValue: Number(object.double_value)
            } : undefined
        };
    },
    toJSON: function toJSON(message) {
        var ref, ref1;
        var obj = {};
        if (message.questionKey !== "") {
            obj.question_key = message.questionKey;
        }
        if (((ref = message.selectedValues) === null || ref === void 0 ? void 0 : ref.$case) === "stringValues") {
            obj.string_values = Answers_ExperimentalQuestionAnswer_StringValues.toJSON(message.selectedValues.stringValues);
        }
        if (((ref1 = message.selectedValues) === null || ref1 === void 0 ? void 0 : ref1.$case) === "doubleValue") {
            obj.double_value = message.selectedValues.doubleValue;
        }
        return obj;
    },
    create: function create(base) {
        return Answers_ExperimentalQuestionAnswer.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref, ref1, ref2, ref3, ref4, ref5;
        var message = createBaseAnswers_ExperimentalQuestionAnswer();
        var _questionKey;
        message.questionKey = (_questionKey = object.questionKey) !== null && _questionKey !== void 0 ? _questionKey : "";
        if (((ref = object.selectedValues) === null || ref === void 0 ? void 0 : ref.$case) === "stringValues" && ((ref1 = object.selectedValues) === null || ref1 === void 0 ? void 0 : ref1.stringValues) !== undefined && ((ref2 = object.selectedValues) === null || ref2 === void 0 ? void 0 : ref2.stringValues) !== null) {
            message.selectedValues = {
                $case: "stringValues",
                stringValues: Answers_ExperimentalQuestionAnswer_StringValues.fromPartial(object.selectedValues.stringValues)
            };
        }
        if (((ref3 = object.selectedValues) === null || ref3 === void 0 ? void 0 : ref3.$case) === "doubleValue" && ((ref4 = object.selectedValues) === null || ref4 === void 0 ? void 0 : ref4.doubleValue) !== undefined && ((ref5 = object.selectedValues) === null || ref5 === void 0 ? void 0 : ref5.doubleValue) !== null) {
            message.selectedValues = {
                $case: "doubleValue",
                doubleValue: object.selectedValues.doubleValue
            };
        }
        return message;
    }
};
function createBaseAnswers_ExperimentalQuestionAnswer_StringValues() {
    return {
        values: []
    };
}
var Answers_ExperimentalQuestionAnswer_StringValues = {
    fromJSON: function fromJSON(object) {
        return {
            values: Array.isArray(object === null || object === void 0 ? void 0 : object.values) ? object.values.map(function(e) {
                return String(e);
            }) : []
        };
    },
    toJSON: function toJSON(message) {
        var ref;
        var obj = {};
        if ((ref = message.values) === null || ref === void 0 ? void 0 : ref.length) {
            obj.values = message.values;
        }
        return obj;
    },
    create: function create(base) {
        return Answers_ExperimentalQuestionAnswer_StringValues.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref;
        var message = createBaseAnswers_ExperimentalQuestionAnswer_StringValues();
        message.values = ((ref = object.values) === null || ref === void 0 ? void 0 : ref.map(function(e) {
            return e;
        })) || [];
        return message;
    }
};
function answers_isSet(value) {
    return value !== null && value !== undefined;
}

;// CONCATENATED MODULE: ./src/__generated__/protobuf/sell/reception/data/attributes.ts
/* eslint-disable */ 

var attributes_protobufPackage = "od_protos.sell.reception.data";
function createBaseAttributes() {
    return {
        covid19Whitelist: false,
        mtmVisited: false,
        selfServiceVirtualAssessmentGroup: 0,
        experimentsMap: {},
        hasValidAssessment: false
    };
}
var Attributes = {
    fromJSON: function fromJSON(object) {
        return {
            covid19Whitelist: attributes_isSet(object.covid19_whitelist) ? Boolean(object.covid19_whitelist) : false,
            mtmVisited: attributes_isSet(object.mtm_visited) ? Boolean(object.mtm_visited) : false,
            selfServiceVirtualAssessmentGroup: attributes_isSet(object.self_service_virtual_assessment_group) ? selfServiceVirtualAssessmentExperimentGroupFromJSON(object.self_service_virtual_assessment_group) : 0,
            experimentsMap: attributes_isObject(object.experiments_map) ? Object.entries(object.experiments_map).reduce(function(acc, param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
                acc[key] = String(value);
                return acc;
            }, {}) : {},
            hasValidAssessment: attributes_isSet(object.has_valid_assessment) ? Boolean(object.has_valid_assessment) : false
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.covid19Whitelist === true) {
            obj.covid19_whitelist = message.covid19Whitelist;
        }
        if (message.mtmVisited === true) {
            obj.mtm_visited = message.mtmVisited;
        }
        if (message.selfServiceVirtualAssessmentGroup !== 0) {
            obj.self_service_virtual_assessment_group = selfServiceVirtualAssessmentExperimentGroupToJSON(message.selfServiceVirtualAssessmentGroup);
        }
        if (message.experimentsMap) {
            var entries = Object.entries(message.experimentsMap);
            if (entries.length > 0) {
                obj.experiments_map = {};
                entries.forEach(function(param) {
                    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), k = _param[0], v = _param[1];
                    obj.experiments_map[k] = v;
                });
            }
        }
        if (message.hasValidAssessment === true) {
            obj.has_valid_assessment = message.hasValidAssessment;
        }
        return obj;
    },
    create: function create(base) {
        return Attributes.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAttributes();
        var _covid19Whitelist;
        message.covid19Whitelist = (_covid19Whitelist = object.covid19Whitelist) !== null && _covid19Whitelist !== void 0 ? _covid19Whitelist : false;
        var _mtmVisited;
        message.mtmVisited = (_mtmVisited = object.mtmVisited) !== null && _mtmVisited !== void 0 ? _mtmVisited : false;
        var _selfServiceVirtualAssessmentGroup;
        message.selfServiceVirtualAssessmentGroup = (_selfServiceVirtualAssessmentGroup = object.selfServiceVirtualAssessmentGroup) !== null && _selfServiceVirtualAssessmentGroup !== void 0 ? _selfServiceVirtualAssessmentGroup : 0;
        var _experimentsMap;
        message.experimentsMap = Object.entries((_experimentsMap = object.experimentsMap) !== null && _experimentsMap !== void 0 ? _experimentsMap : {}).reduce(function(acc, param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
            if (value !== undefined) {
                acc[key] = String(value);
            }
            return acc;
        }, {});
        var _hasValidAssessment;
        message.hasValidAssessment = (_hasValidAssessment = object.hasValidAssessment) !== null && _hasValidAssessment !== void 0 ? _hasValidAssessment : false;
        return message;
    }
};
function createBaseAttributes_ExperimentsMapEntry() {
    return {
        key: "",
        value: ""
    };
}
var Attributes_ExperimentsMapEntry = {
    fromJSON: function fromJSON(object) {
        return {
            key: attributes_isSet(object.key) ? String(object.key) : "",
            value: attributes_isSet(object.value) ? String(object.value) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.key !== "") {
            obj.key = message.key;
        }
        if (message.value !== "") {
            obj.value = message.value;
        }
        return obj;
    },
    create: function create(base) {
        return Attributes_ExperimentsMapEntry.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAttributes_ExperimentsMapEntry();
        var _key;
        message.key = (_key = object.key) !== null && _key !== void 0 ? _key : "";
        var _value;
        message.value = (_value = object.value) !== null && _value !== void 0 ? _value : "";
        return message;
    }
};
function attributes_isObject(value) {
    return typeof value === "object" && value !== null;
}
function attributes_isSet(value) {
    return value !== null && value !== undefined;
}

;// CONCATENATED MODULE: ./src/__generated__/protobuf/sell/reception/data/partnership_referral.ts
/* eslint-disable */ var partnership_referral_protobufPackage = "od_protos.sell.reception.data";
function createBasePartnershipReferral() {
    return {
        type: "",
        identifier: "",
        userId: ""
    };
}
var PartnershipReferral = {
    fromJSON: function fromJSON(object) {
        return {
            type: partnership_referral_isSet(object.type) ? String(object.type) : "",
            identifier: partnership_referral_isSet(object.identifier) ? String(object.identifier) : "",
            userId: partnership_referral_isSet(object.userId) ? String(object.userId) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.type !== "") {
            obj.type = message.type;
        }
        if (message.identifier !== "") {
            obj.identifier = message.identifier;
        }
        if (message.userId !== "") {
            obj.userId = message.userId;
        }
        return obj;
    },
    create: function create(base) {
        return PartnershipReferral.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBasePartnershipReferral();
        var _type;
        message.type = (_type = object.type) !== null && _type !== void 0 ? _type : "";
        var _identifier;
        message.identifier = (_identifier = object.identifier) !== null && _identifier !== void 0 ? _identifier : "";
        var _userId;
        message.userId = (_userId = object.userId) !== null && _userId !== void 0 ? _userId : "";
        return message;
    }
};
function partnership_referral_isSet(value) {
    return value !== null && value !== undefined;
}

;// CONCATENATED MODULE: ./src/__generated__/protobuf/sell/reception/data/product_offering.ts
/* eslint-disable */ 


var product_offering_protobufPackage = "od_protos.sell.reception.data";
function createBaseProductOffering() {
    return {
        product: 0,
        matchedAt: undefined,
        denialReason: 0,
        deniedAt: undefined,
        qualifiedAt: undefined,
        denialReasons: []
    };
}
var ProductOffering = {
    fromJSON: function fromJSON(object) {
        return {
            product: product_offering_isSet(object.product) ? productFromJSON(object.product) : 0,
            matchedAt: product_offering_isSet(object.matchedAt) ? product_offering_fromJsonTimestamp(object.matchedAt) : undefined,
            denialReason: product_offering_isSet(object.denialReason) ? denialReasonFromJSON(object.denialReason) : 0,
            deniedAt: product_offering_isSet(object.deniedAt) ? product_offering_fromJsonTimestamp(object.deniedAt) : undefined,
            qualifiedAt: product_offering_isSet(object.qualifiedAt) ? product_offering_fromJsonTimestamp(object.qualifiedAt) : undefined,
            denialReasons: Array.isArray(object === null || object === void 0 ? void 0 : object.denialReasons) ? object.denialReasons.map(function(e) {
                return denialReasonFromJSON(e);
            }) : []
        };
    },
    toJSON: function toJSON(message) {
        var ref;
        var obj = {};
        if (message.product !== 0) {
            obj.product = productToJSON(message.product);
        }
        if (message.matchedAt !== undefined) {
            obj.matchedAt = message.matchedAt.toISOString();
        }
        if (message.denialReason !== 0) {
            obj.denialReason = denialReasonToJSON(message.denialReason);
        }
        if (message.deniedAt !== undefined) {
            obj.deniedAt = message.deniedAt.toISOString();
        }
        if (message.qualifiedAt !== undefined) {
            obj.qualifiedAt = message.qualifiedAt.toISOString();
        }
        if ((ref = message.denialReasons) === null || ref === void 0 ? void 0 : ref.length) {
            obj.denialReasons = message.denialReasons.map(function(e) {
                return denialReasonToJSON(e);
            });
        }
        return obj;
    },
    create: function create(base) {
        return ProductOffering.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref;
        var message = createBaseProductOffering();
        var _product;
        message.product = (_product = object.product) !== null && _product !== void 0 ? _product : 0;
        var _matchedAt;
        message.matchedAt = (_matchedAt = object.matchedAt) !== null && _matchedAt !== void 0 ? _matchedAt : undefined;
        var _denialReason;
        message.denialReason = (_denialReason = object.denialReason) !== null && _denialReason !== void 0 ? _denialReason : 0;
        var _deniedAt;
        message.deniedAt = (_deniedAt = object.deniedAt) !== null && _deniedAt !== void 0 ? _deniedAt : undefined;
        var _qualifiedAt;
        message.qualifiedAt = (_qualifiedAt = object.qualifiedAt) !== null && _qualifiedAt !== void 0 ? _qualifiedAt : undefined;
        message.denialReasons = ((ref = object.denialReasons) === null || ref === void 0 ? void 0 : ref.map(function(e) {
            return e;
        })) || [];
        return message;
    }
};
function product_offering_fromTimestamp(t) {
    var millis = (t.seconds || 0) * 1000;
    millis += (t.nanos || 0) / 1000000;
    return new Date(millis);
}
function product_offering_fromJsonTimestamp(o) {
    if ((0,_instanceof/* default */.Z)(o, Date)) {
        return o;
    } else if (typeof o === "string") {
        return new Date(o);
    } else {
        return product_offering_fromTimestamp(Timestamp.fromJSON(o));
    }
}
function product_offering_isSet(value) {
    return value !== null && value !== undefined;
}

;// CONCATENATED MODULE: ./src/__generated__/protobuf/sell/reception/data/seller_input.ts
/* eslint-disable */ 







var seller_input_protobufPackage = "od_protos.sell.reception.data";
var SellerInput_Channel;
(function(SellerInput_Channel) {
    SellerInput_Channel[SellerInput_Channel[/** UNSET_CHANNEL - DO NOT USE, this represents an unset enum value. */ "UNSET_CHANNEL"] = 0] = "UNSET_CHANNEL";
    SellerInput_Channel[SellerInput_Channel[/** DEFAULT - DEFAULT is the standard channel for incoming leads. */ "DEFAULT"] = 1] = "DEFAULT";
    SellerInput_Channel[SellerInput_Channel[/** HOME_VALUE - HOME_VALUE is used for leads from the /home-value landing page. */ "HOME_VALUE"] = 2] = "HOME_VALUE";
    SellerInput_Channel[SellerInput_Channel[/** SELLER_REQUEST_LISTED - SELLER_REQUEST_LISTED is used for seller requested leads on listed homes. */ "SELLER_REQUEST_LISTED"] = 3] = "SELLER_REQUEST_LISTED";
    SellerInput_Channel[SellerInput_Channel[/** AGENT_REQUEST - AGENT_REQUEST is used for agent requested leads. */ "AGENT_REQUEST"] = 4] = "AGENT_REQUEST";
    SellerInput_Channel[SellerInput_Channel[/** AGENT_REQUEST_LISTED - AGENT_REQUEST_LISTED is used for agent requested leads on listed homes. */ "AGENT_REQUEST_LISTED"] = 5] = "AGENT_REQUEST_LISTED";
    SellerInput_Channel[SellerInput_Channel[/**
   * TRADE_IN - TRADE_IN is used for leads from the /trade-in landing page.
   *
   * @deprecated
   */ "TRADE_IN"] = 6] = "TRADE_IN";
    SellerInput_Channel[SellerInput_Channel[/** APP - APP is used for leads from the mobile app. */ "APP"] = 7] = "APP";
    SellerInput_Channel[SellerInput_Channel[/**
   * CAKE_LANDING_PAGE - CAKE_LANDING_PAGE is for leads starting from the /tradeins landing page,
   * intended to reach the new customer dashboard.
   */ "CAKE_LANDING_PAGE"] = 8] = "CAKE_LANDING_PAGE";
    SellerInput_Channel[SellerInput_Channel[/**
   * FLYWHEEL - FLYWHEEL is used for leads from the address entry in the app before a
   * buyer unlocks a home, as derived from project Flywheel
   */ "FLYWHEEL"] = 9] = "FLYWHEEL";
    SellerInput_Channel[SellerInput_Channel[/** EMAIL_PROSPECTING - EMAIL_PROSPECTING is used for leads from the cold email prospecting experiment. */ "EMAIL_PROSPECTING"] = 10] = "EMAIL_PROSPECTING";
    SellerInput_Channel[SellerInput_Channel[/** OUTBOUND_OFFERS_LISTED - OUTBOUND_OFFERS_LISTED is used for 2020 Hackweek experiment of sending offers to listed homes */ "OUTBOUND_OFFERS_LISTED"] = 11] = "OUTBOUND_OFFERS_LISTED";
    SellerInput_Channel[SellerInput_Channel[/**
   * HOME_RESERVE - HOME_RESERVE is used for Home reserve landing page
   *
   * @deprecated
   */ "HOME_RESERVE"] = 12] = "HOME_RESERVE";
    SellerInput_Channel[SellerInput_Channel[/** REIT_BULK_REQUEST - REIT_BULK_REQUEST is used for bulk acquisition requests from REITs */ "REIT_BULK_REQUEST"] = 13] = "REIT_BULK_REQUEST";
    SellerInput_Channel[SellerInput_Channel[/** PARTNER_API - PARTNER_API is used for seller inputs created via the partner API */ "PARTNER_API"] = 14] = "PARTNER_API";
    SellerInput_Channel[SellerInput_Channel[/** BUY_SELL_FLOW - BUY_SELL_FLOW is used for the combined buy and sell flow launched by Buyer in 2021 */ "BUY_SELL_FLOW"] = 15] = "BUY_SELL_FLOW";
    SellerInput_Channel[SellerInput_Channel["REIT_BULK_REQUEST_LISTED"] = 16] = "REIT_BULK_REQUEST_LISTED";
    SellerInput_Channel[SellerInput_Channel[/**
   * OPENDOOR_BACKED_OFFER - OPENDOOR_BACKED_OFFER is used for bwod obo program
   *
   * @deprecated
   */ "OPENDOOR_BACKED_OFFER"] = 17] = "OPENDOOR_BACKED_OFFER";
    SellerInput_Channel[SellerInput_Channel[/**
   * EXCLUSIVE_OFFERS - EXCLUSIVE_OFFER is used for exclusive offers program
   *
   * @deprecated
   */ "EXCLUSIVE_OFFERS"] = 18] = "EXCLUSIVE_OFFERS";
    SellerInput_Channel[SellerInput_Channel[/** CCPA_OPT_OUT - CCPA_OPT_OUT is used for leads that have opted out of CCPA */ "CCPA_OPT_OUT"] = 19] = "CCPA_OPT_OUT";
    SellerInput_Channel[SellerInput_Channel[/** OUTBOUND_OFFERS_UNDERWRITTEN - OUTBOUND_OFFERS_UNDERWRITTEN is used for outbound offers that will be underwritten and sent out as final offers */ "OUTBOUND_OFFERS_UNDERWRITTEN"] = 20] = "OUTBOUND_OFFERS_UNDERWRITTEN";
    SellerInput_Channel[SellerInput_Channel["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(SellerInput_Channel || (SellerInput_Channel = {}));
function sellerInput_ChannelFromJSON(object) {
    switch(object){
        case 0:
        case "UNSET_CHANNEL":
            return SellerInput_Channel.UNSET_CHANNEL;
        case 1:
        case "DEFAULT":
            return SellerInput_Channel.DEFAULT;
        case 2:
        case "HOME_VALUE":
            return SellerInput_Channel.HOME_VALUE;
        case 3:
        case "SELLER_REQUEST_LISTED":
            return SellerInput_Channel.SELLER_REQUEST_LISTED;
        case 4:
        case "AGENT_REQUEST":
            return SellerInput_Channel.AGENT_REQUEST;
        case 5:
        case "AGENT_REQUEST_LISTED":
            return SellerInput_Channel.AGENT_REQUEST_LISTED;
        case 6:
        case "TRADE_IN":
            return SellerInput_Channel.TRADE_IN;
        case 7:
        case "APP":
            return SellerInput_Channel.APP;
        case 8:
        case "CAKE_LANDING_PAGE":
            return SellerInput_Channel.CAKE_LANDING_PAGE;
        case 9:
        case "FLYWHEEL":
            return SellerInput_Channel.FLYWHEEL;
        case 10:
        case "EMAIL_PROSPECTING":
            return SellerInput_Channel.EMAIL_PROSPECTING;
        case 11:
        case "OUTBOUND_OFFERS_LISTED":
            return SellerInput_Channel.OUTBOUND_OFFERS_LISTED;
        case 12:
        case "HOME_RESERVE":
            return SellerInput_Channel.HOME_RESERVE;
        case 13:
        case "REIT_BULK_REQUEST":
            return SellerInput_Channel.REIT_BULK_REQUEST;
        case 14:
        case "PARTNER_API":
            return SellerInput_Channel.PARTNER_API;
        case 15:
        case "BUY_SELL_FLOW":
            return SellerInput_Channel.BUY_SELL_FLOW;
        case 16:
        case "REIT_BULK_REQUEST_LISTED":
            return SellerInput_Channel.REIT_BULK_REQUEST_LISTED;
        case 17:
        case "OPENDOOR_BACKED_OFFER":
            return SellerInput_Channel.OPENDOOR_BACKED_OFFER;
        case 18:
        case "EXCLUSIVE_OFFERS":
            return SellerInput_Channel.EXCLUSIVE_OFFERS;
        case 19:
        case "CCPA_OPT_OUT":
            return SellerInput_Channel.CCPA_OPT_OUT;
        case 20:
        case "OUTBOUND_OFFERS_UNDERWRITTEN":
            return SellerInput_Channel.OUTBOUND_OFFERS_UNDERWRITTEN;
        case -1:
        case "UNRECOGNIZED":
        default:
            return SellerInput_Channel.UNRECOGNIZED;
    }
}
function sellerInput_ChannelToJSON(object) {
    switch(object){
        case SellerInput_Channel.UNSET_CHANNEL:
            return "UNSET_CHANNEL";
        case SellerInput_Channel.DEFAULT:
            return "DEFAULT";
        case SellerInput_Channel.HOME_VALUE:
            return "HOME_VALUE";
        case SellerInput_Channel.SELLER_REQUEST_LISTED:
            return "SELLER_REQUEST_LISTED";
        case SellerInput_Channel.AGENT_REQUEST:
            return "AGENT_REQUEST";
        case SellerInput_Channel.AGENT_REQUEST_LISTED:
            return "AGENT_REQUEST_LISTED";
        case SellerInput_Channel.TRADE_IN:
            return "TRADE_IN";
        case SellerInput_Channel.APP:
            return "APP";
        case SellerInput_Channel.CAKE_LANDING_PAGE:
            return "CAKE_LANDING_PAGE";
        case SellerInput_Channel.FLYWHEEL:
            return "FLYWHEEL";
        case SellerInput_Channel.EMAIL_PROSPECTING:
            return "EMAIL_PROSPECTING";
        case SellerInput_Channel.OUTBOUND_OFFERS_LISTED:
            return "OUTBOUND_OFFERS_LISTED";
        case SellerInput_Channel.HOME_RESERVE:
            return "HOME_RESERVE";
        case SellerInput_Channel.REIT_BULK_REQUEST:
            return "REIT_BULK_REQUEST";
        case SellerInput_Channel.PARTNER_API:
            return "PARTNER_API";
        case SellerInput_Channel.BUY_SELL_FLOW:
            return "BUY_SELL_FLOW";
        case SellerInput_Channel.REIT_BULK_REQUEST_LISTED:
            return "REIT_BULK_REQUEST_LISTED";
        case SellerInput_Channel.OPENDOOR_BACKED_OFFER:
            return "OPENDOOR_BACKED_OFFER";
        case SellerInput_Channel.EXCLUSIVE_OFFERS:
            return "EXCLUSIVE_OFFERS";
        case SellerInput_Channel.CCPA_OPT_OUT:
            return "CCPA_OPT_OUT";
        case SellerInput_Channel.OUTBOUND_OFFERS_UNDERWRITTEN:
            return "OUTBOUND_OFFERS_UNDERWRITTEN";
        case SellerInput_Channel.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var SellerInput_AddressVerifiedStatus;
(function(SellerInput_AddressVerifiedStatus) {
    SellerInput_AddressVerifiedStatus[SellerInput_AddressVerifiedStatus[/** NOT_VERIFIED - default for new seller inputs */ "NOT_VERIFIED"] = 0] = "NOT_VERIFIED";
    SellerInput_AddressVerifiedStatus[SellerInput_AddressVerifiedStatus[/** AUTO_VERIFIED - seller has implicitly confirmed their address, able to change their address */ "AUTO_VERIFIED"] = 1] = "AUTO_VERIFIED";
    SellerInput_AddressVerifiedStatus[SellerInput_AddressVerifiedStatus[/** CONFIRMED_VERIFIED - seller has explicitly confirmed their address or moved to a state where their address cannot be changed */ "CONFIRMED_VERIFIED"] = 2] = "CONFIRMED_VERIFIED";
    SellerInput_AddressVerifiedStatus[SellerInput_AddressVerifiedStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(SellerInput_AddressVerifiedStatus || (SellerInput_AddressVerifiedStatus = {}));
function sellerInput_AddressVerifiedStatusFromJSON(object) {
    switch(object){
        case 0:
        case "NOT_VERIFIED":
            return SellerInput_AddressVerifiedStatus.NOT_VERIFIED;
        case 1:
        case "AUTO_VERIFIED":
            return SellerInput_AddressVerifiedStatus.AUTO_VERIFIED;
        case 2:
        case "CONFIRMED_VERIFIED":
            return SellerInput_AddressVerifiedStatus.CONFIRMED_VERIFIED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return SellerInput_AddressVerifiedStatus.UNRECOGNIZED;
    }
}
function sellerInput_AddressVerifiedStatusToJSON(object) {
    switch(object){
        case SellerInput_AddressVerifiedStatus.NOT_VERIFIED:
            return "NOT_VERIFIED";
        case SellerInput_AddressVerifiedStatus.AUTO_VERIFIED:
            return "AUTO_VERIFIED";
        case SellerInput_AddressVerifiedStatus.CONFIRMED_VERIFIED:
            return "CONFIRMED_VERIFIED";
        case SellerInput_AddressVerifiedStatus.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var SellerInput_AnalyticsMetadata_Product;
(function(SellerInput_AnalyticsMetadata_Product) {
    SellerInput_AnalyticsMetadata_Product[SellerInput_AnalyticsMetadata_Product["UNKNOWN"] = 0] = "UNKNOWN";
    SellerInput_AnalyticsMetadata_Product[SellerInput_AnalyticsMetadata_Product["SELL_DIRECT"] = 1] = "SELL_DIRECT";
    SellerInput_AnalyticsMetadata_Product[SellerInput_AnalyticsMetadata_Product["OPENDOOR_COMPLETE"] = 2] = "OPENDOOR_COMPLETE";
    SellerInput_AnalyticsMetadata_Product[SellerInput_AnalyticsMetadata_Product[/** @deprecated */ "OPENDOOR_EXCLUSIVES"] = 3] = "OPENDOOR_EXCLUSIVES";
    SellerInput_AnalyticsMetadata_Product[SellerInput_AnalyticsMetadata_Product["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(SellerInput_AnalyticsMetadata_Product || (SellerInput_AnalyticsMetadata_Product = {}));
function sellerInput_AnalyticsMetadata_ProductFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN":
            return SellerInput_AnalyticsMetadata_Product.UNKNOWN;
        case 1:
        case "SELL_DIRECT":
            return SellerInput_AnalyticsMetadata_Product.SELL_DIRECT;
        case 2:
        case "OPENDOOR_COMPLETE":
            return SellerInput_AnalyticsMetadata_Product.OPENDOOR_COMPLETE;
        case 3:
        case "OPENDOOR_EXCLUSIVES":
            return SellerInput_AnalyticsMetadata_Product.OPENDOOR_EXCLUSIVES;
        case -1:
        case "UNRECOGNIZED":
        default:
            return SellerInput_AnalyticsMetadata_Product.UNRECOGNIZED;
    }
}
function sellerInput_AnalyticsMetadata_ProductToJSON(object) {
    switch(object){
        case SellerInput_AnalyticsMetadata_Product.UNKNOWN:
            return "UNKNOWN";
        case SellerInput_AnalyticsMetadata_Product.SELL_DIRECT:
            return "SELL_DIRECT";
        case SellerInput_AnalyticsMetadata_Product.OPENDOOR_COMPLETE:
            return "OPENDOOR_COMPLETE";
        case SellerInput_AnalyticsMetadata_Product.OPENDOOR_EXCLUSIVES:
            return "OPENDOOR_EXCLUSIVES";
        case SellerInput_AnalyticsMetadata_Product.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
function createBaseSellerInput() {
    return {
        uuid: "",
        addressUuid: "",
        sellerFlowUuid: "",
        channel: 0,
        answersJson: "",
        answers: undefined,
        answerPrefillsJson: "",
        answerPrefills: undefined,
        createdAt: undefined,
        updatedAt: undefined,
        customerUuid: "",
        sellerFlowLastCompletedSlug: "",
        addressVerified: false,
        addressVerifiedStatus: 0,
        isListed: false,
        isAgent: false,
        isTradeIn: false,
        isTradeInBundle: false,
        isTradeInDashboard: false,
        ownerVerified: false,
        partnershipName: "",
        hasBulkValuation: false,
        homeEstimateForDenials: 0,
        homeDetails: undefined,
        marketingChannel: 0,
        partnership: 0,
        timeline: 0,
        productOfferings: [],
        region: "",
        homeDetailId: "",
        inMarketplaceTopOfFunnelExp: false,
        segments: [],
        experimentEntityId: "",
        partnershipReferrals: [],
        attributes: undefined,
        homeValue: undefined,
        isCompletedAt: undefined,
        sellerFlowName: "",
        pdpUrl: "",
        analyticsMetadata: undefined,
        isInPartnershipDenialServiceRegions: false,
        denialPartnerIdentifier: "",
        listingEstimatePricingsId: ""
    };
}
var SellerInput = {
    fromJSON: function fromJSON(object) {
        return {
            uuid: seller_input_isSet(object.uuid) ? String(object.uuid) : "",
            addressUuid: seller_input_isSet(object.addressUuid) ? String(object.addressUuid) : "",
            sellerFlowUuid: seller_input_isSet(object.sellerFlowUuid) ? String(object.sellerFlowUuid) : "",
            channel: seller_input_isSet(object.channel) ? sellerInput_ChannelFromJSON(object.channel) : 0,
            answersJson: seller_input_isSet(object.answersJson) ? String(object.answersJson) : "",
            answers: seller_input_isSet(object.answers) ? Answers.fromJSON(object.answers) : undefined,
            answerPrefillsJson: seller_input_isSet(object.answerPrefillsJson) ? String(object.answerPrefillsJson) : "",
            answerPrefills: seller_input_isObject(object.answerPrefills) ? object.answerPrefills : undefined,
            createdAt: seller_input_isSet(object.createdAt) ? seller_input_fromJsonTimestamp(object.createdAt) : undefined,
            updatedAt: seller_input_isSet(object.updatedAt) ? seller_input_fromJsonTimestamp(object.updatedAt) : undefined,
            customerUuid: seller_input_isSet(object.customerUuid) ? String(object.customerUuid) : "",
            sellerFlowLastCompletedSlug: seller_input_isSet(object.sellerFlowLastCompletedSlug) ? String(object.sellerFlowLastCompletedSlug) : "",
            addressVerified: seller_input_isSet(object.addressVerified) ? Boolean(object.addressVerified) : false,
            addressVerifiedStatus: seller_input_isSet(object.addressVerifiedStatus) ? sellerInput_AddressVerifiedStatusFromJSON(object.addressVerifiedStatus) : 0,
            isListed: seller_input_isSet(object.isListed) ? Boolean(object.isListed) : false,
            isAgent: seller_input_isSet(object.isAgent) ? Boolean(object.isAgent) : false,
            isTradeIn: seller_input_isSet(object.isTradeIn) ? Boolean(object.isTradeIn) : false,
            isTradeInBundle: seller_input_isSet(object.isTradeInBundle) ? Boolean(object.isTradeInBundle) : false,
            isTradeInDashboard: seller_input_isSet(object.isTradeInDashboard) ? Boolean(object.isTradeInDashboard) : false,
            ownerVerified: seller_input_isSet(object.ownerVerified) ? Boolean(object.ownerVerified) : false,
            partnershipName: seller_input_isSet(object.partnershipName) ? String(object.partnershipName) : "",
            hasBulkValuation: seller_input_isSet(object.hasBulkValuation) ? Boolean(object.hasBulkValuation) : false,
            homeEstimateForDenials: seller_input_isSet(object.homeEstimateForDenials) ? Number(object.homeEstimateForDenials) : 0,
            homeDetails: seller_input_isSet(object.homeDetails) ? SellerInput_HomeDetails.fromJSON(object.homeDetails) : undefined,
            marketingChannel: seller_input_isSet(object.marketingChannel) ? marketingChannelFromJSON(object.marketingChannel) : 0,
            partnership: seller_input_isSet(object.partnership) ? partnershipFromJSON(object.partnership) : 0,
            timeline: seller_input_isSet(object.timeline) ? timelineFromJSON(object.timeline) : 0,
            productOfferings: Array.isArray(object === null || object === void 0 ? void 0 : object.productOfferings) ? object.productOfferings.map(function(e) {
                return ProductOffering.fromJSON(e);
            }) : [],
            region: seller_input_isSet(object.region) ? String(object.region) : "",
            homeDetailId: seller_input_isSet(object.homeDetailId) ? String(object.homeDetailId) : "",
            inMarketplaceTopOfFunnelExp: seller_input_isSet(object.inMarketplaceTopOfFunnelExp) ? Boolean(object.inMarketplaceTopOfFunnelExp) : false,
            segments: Array.isArray(object === null || object === void 0 ? void 0 : object.segments) ? object.segments.map(function(e) {
                return segmentFromJSON(e);
            }) : [],
            experimentEntityId: seller_input_isSet(object.experimentEntityId) ? String(object.experimentEntityId) : "",
            partnershipReferrals: Array.isArray(object === null || object === void 0 ? void 0 : object.partnershipReferrals) ? object.partnershipReferrals.map(function(e) {
                return PartnershipReferral.fromJSON(e);
            }) : [],
            attributes: seller_input_isSet(object.attributes) ? Attributes.fromJSON(object.attributes) : undefined,
            homeValue: seller_input_isSet(object.homeValue) ? HomeValue.fromJSON(object.homeValue) : undefined,
            isCompletedAt: seller_input_isSet(object.isCompletedAt) ? seller_input_fromJsonTimestamp(object.isCompletedAt) : undefined,
            sellerFlowName: seller_input_isSet(object.sellerFlowName) ? String(object.sellerFlowName) : "",
            pdpUrl: seller_input_isSet(object.pdpUrl) ? String(object.pdpUrl) : "",
            analyticsMetadata: seller_input_isSet(object.analyticsMetadata) ? SellerInput_AnalyticsMetadata.fromJSON(object.analyticsMetadata) : undefined,
            isInPartnershipDenialServiceRegions: seller_input_isSet(object.isInPartnershipDenialServiceRegions) ? Boolean(object.isInPartnershipDenialServiceRegions) : false,
            denialPartnerIdentifier: seller_input_isSet(object.denialPartnerIdentifier) ? String(object.denialPartnerIdentifier) : "",
            listingEstimatePricingsId: seller_input_isSet(object.listingEstimatePricingsId) ? String(object.listingEstimatePricingsId) : ""
        };
    },
    toJSON: function toJSON(message) {
        var ref, ref1, ref2;
        var obj = {};
        if (message.uuid !== "") {
            obj.uuid = message.uuid;
        }
        if (message.addressUuid !== "") {
            obj.addressUuid = message.addressUuid;
        }
        if (message.sellerFlowUuid !== "") {
            obj.sellerFlowUuid = message.sellerFlowUuid;
        }
        if (message.channel !== 0) {
            obj.channel = sellerInput_ChannelToJSON(message.channel);
        }
        if (message.answersJson !== "") {
            obj.answersJson = message.answersJson;
        }
        if (message.answers !== undefined) {
            obj.answers = Answers.toJSON(message.answers);
        }
        if (message.answerPrefillsJson !== "") {
            obj.answerPrefillsJson = message.answerPrefillsJson;
        }
        if (message.answerPrefills !== undefined) {
            obj.answerPrefills = message.answerPrefills;
        }
        if (message.createdAt !== undefined) {
            obj.createdAt = message.createdAt.toISOString();
        }
        if (message.updatedAt !== undefined) {
            obj.updatedAt = message.updatedAt.toISOString();
        }
        if (message.customerUuid !== "") {
            obj.customerUuid = message.customerUuid;
        }
        if (message.sellerFlowLastCompletedSlug !== "") {
            obj.sellerFlowLastCompletedSlug = message.sellerFlowLastCompletedSlug;
        }
        if (message.addressVerified === true) {
            obj.addressVerified = message.addressVerified;
        }
        if (message.addressVerifiedStatus !== 0) {
            obj.addressVerifiedStatus = sellerInput_AddressVerifiedStatusToJSON(message.addressVerifiedStatus);
        }
        if (message.isListed === true) {
            obj.isListed = message.isListed;
        }
        if (message.isAgent === true) {
            obj.isAgent = message.isAgent;
        }
        if (message.isTradeIn === true) {
            obj.isTradeIn = message.isTradeIn;
        }
        if (message.isTradeInBundle === true) {
            obj.isTradeInBundle = message.isTradeInBundle;
        }
        if (message.isTradeInDashboard === true) {
            obj.isTradeInDashboard = message.isTradeInDashboard;
        }
        if (message.ownerVerified === true) {
            obj.ownerVerified = message.ownerVerified;
        }
        if (message.partnershipName !== "") {
            obj.partnershipName = message.partnershipName;
        }
        if (message.hasBulkValuation === true) {
            obj.hasBulkValuation = message.hasBulkValuation;
        }
        if (message.homeEstimateForDenials !== 0) {
            obj.homeEstimateForDenials = Math.round(message.homeEstimateForDenials);
        }
        if (message.homeDetails !== undefined) {
            obj.homeDetails = SellerInput_HomeDetails.toJSON(message.homeDetails);
        }
        if (message.marketingChannel !== 0) {
            obj.marketingChannel = marketingChannelToJSON(message.marketingChannel);
        }
        if (message.partnership !== 0) {
            obj.partnership = partnershipToJSON(message.partnership);
        }
        if (message.timeline !== 0) {
            obj.timeline = timelineToJSON(message.timeline);
        }
        if ((ref = message.productOfferings) === null || ref === void 0 ? void 0 : ref.length) {
            obj.productOfferings = message.productOfferings.map(function(e) {
                return ProductOffering.toJSON(e);
            });
        }
        if (message.region !== "") {
            obj.region = message.region;
        }
        if (message.homeDetailId !== "") {
            obj.homeDetailId = message.homeDetailId;
        }
        if (message.inMarketplaceTopOfFunnelExp === true) {
            obj.inMarketplaceTopOfFunnelExp = message.inMarketplaceTopOfFunnelExp;
        }
        if ((ref1 = message.segments) === null || ref1 === void 0 ? void 0 : ref1.length) {
            obj.segments = message.segments.map(function(e) {
                return segmentToJSON(e);
            });
        }
        if (message.experimentEntityId !== "") {
            obj.experimentEntityId = message.experimentEntityId;
        }
        if ((ref2 = message.partnershipReferrals) === null || ref2 === void 0 ? void 0 : ref2.length) {
            obj.partnershipReferrals = message.partnershipReferrals.map(function(e) {
                return PartnershipReferral.toJSON(e);
            });
        }
        if (message.attributes !== undefined) {
            obj.attributes = Attributes.toJSON(message.attributes);
        }
        if (message.homeValue !== undefined) {
            obj.homeValue = HomeValue.toJSON(message.homeValue);
        }
        if (message.isCompletedAt !== undefined) {
            obj.isCompletedAt = message.isCompletedAt.toISOString();
        }
        if (message.sellerFlowName !== "") {
            obj.sellerFlowName = message.sellerFlowName;
        }
        if (message.pdpUrl !== "") {
            obj.pdpUrl = message.pdpUrl;
        }
        if (message.analyticsMetadata !== undefined) {
            obj.analyticsMetadata = SellerInput_AnalyticsMetadata.toJSON(message.analyticsMetadata);
        }
        if (message.isInPartnershipDenialServiceRegions === true) {
            obj.isInPartnershipDenialServiceRegions = message.isInPartnershipDenialServiceRegions;
        }
        if (message.denialPartnerIdentifier !== "") {
            obj.denialPartnerIdentifier = message.denialPartnerIdentifier;
        }
        if (message.listingEstimatePricingsId !== "") {
            obj.listingEstimatePricingsId = message.listingEstimatePricingsId;
        }
        return obj;
    },
    create: function create(base) {
        return SellerInput.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref, ref1, ref2;
        var message = createBaseSellerInput();
        var _uuid;
        message.uuid = (_uuid = object.uuid) !== null && _uuid !== void 0 ? _uuid : "";
        var _addressUuid;
        message.addressUuid = (_addressUuid = object.addressUuid) !== null && _addressUuid !== void 0 ? _addressUuid : "";
        var _sellerFlowUuid;
        message.sellerFlowUuid = (_sellerFlowUuid = object.sellerFlowUuid) !== null && _sellerFlowUuid !== void 0 ? _sellerFlowUuid : "";
        var _channel;
        message.channel = (_channel = object.channel) !== null && _channel !== void 0 ? _channel : 0;
        var _answersJson;
        message.answersJson = (_answersJson = object.answersJson) !== null && _answersJson !== void 0 ? _answersJson : "";
        message.answers = object.answers !== undefined && object.answers !== null ? Answers.fromPartial(object.answers) : undefined;
        var _answerPrefillsJson;
        message.answerPrefillsJson = (_answerPrefillsJson = object.answerPrefillsJson) !== null && _answerPrefillsJson !== void 0 ? _answerPrefillsJson : "";
        var _answerPrefills;
        message.answerPrefills = (_answerPrefills = object.answerPrefills) !== null && _answerPrefills !== void 0 ? _answerPrefills : undefined;
        var _createdAt;
        message.createdAt = (_createdAt = object.createdAt) !== null && _createdAt !== void 0 ? _createdAt : undefined;
        var _updatedAt;
        message.updatedAt = (_updatedAt = object.updatedAt) !== null && _updatedAt !== void 0 ? _updatedAt : undefined;
        var _customerUuid;
        message.customerUuid = (_customerUuid = object.customerUuid) !== null && _customerUuid !== void 0 ? _customerUuid : "";
        var _sellerFlowLastCompletedSlug;
        message.sellerFlowLastCompletedSlug = (_sellerFlowLastCompletedSlug = object.sellerFlowLastCompletedSlug) !== null && _sellerFlowLastCompletedSlug !== void 0 ? _sellerFlowLastCompletedSlug : "";
        var _addressVerified;
        message.addressVerified = (_addressVerified = object.addressVerified) !== null && _addressVerified !== void 0 ? _addressVerified : false;
        var _addressVerifiedStatus;
        message.addressVerifiedStatus = (_addressVerifiedStatus = object.addressVerifiedStatus) !== null && _addressVerifiedStatus !== void 0 ? _addressVerifiedStatus : 0;
        var _isListed;
        message.isListed = (_isListed = object.isListed) !== null && _isListed !== void 0 ? _isListed : false;
        var _isAgent;
        message.isAgent = (_isAgent = object.isAgent) !== null && _isAgent !== void 0 ? _isAgent : false;
        var _isTradeIn;
        message.isTradeIn = (_isTradeIn = object.isTradeIn) !== null && _isTradeIn !== void 0 ? _isTradeIn : false;
        var _isTradeInBundle;
        message.isTradeInBundle = (_isTradeInBundle = object.isTradeInBundle) !== null && _isTradeInBundle !== void 0 ? _isTradeInBundle : false;
        var _isTradeInDashboard;
        message.isTradeInDashboard = (_isTradeInDashboard = object.isTradeInDashboard) !== null && _isTradeInDashboard !== void 0 ? _isTradeInDashboard : false;
        var _ownerVerified;
        message.ownerVerified = (_ownerVerified = object.ownerVerified) !== null && _ownerVerified !== void 0 ? _ownerVerified : false;
        var _partnershipName;
        message.partnershipName = (_partnershipName = object.partnershipName) !== null && _partnershipName !== void 0 ? _partnershipName : "";
        var _hasBulkValuation;
        message.hasBulkValuation = (_hasBulkValuation = object.hasBulkValuation) !== null && _hasBulkValuation !== void 0 ? _hasBulkValuation : false;
        var _homeEstimateForDenials;
        message.homeEstimateForDenials = (_homeEstimateForDenials = object.homeEstimateForDenials) !== null && _homeEstimateForDenials !== void 0 ? _homeEstimateForDenials : 0;
        message.homeDetails = object.homeDetails !== undefined && object.homeDetails !== null ? SellerInput_HomeDetails.fromPartial(object.homeDetails) : undefined;
        var _marketingChannel;
        message.marketingChannel = (_marketingChannel = object.marketingChannel) !== null && _marketingChannel !== void 0 ? _marketingChannel : 0;
        var _partnership;
        message.partnership = (_partnership = object.partnership) !== null && _partnership !== void 0 ? _partnership : 0;
        var _timeline;
        message.timeline = (_timeline = object.timeline) !== null && _timeline !== void 0 ? _timeline : 0;
        message.productOfferings = ((ref = object.productOfferings) === null || ref === void 0 ? void 0 : ref.map(function(e) {
            return ProductOffering.fromPartial(e);
        })) || [];
        var _region;
        message.region = (_region = object.region) !== null && _region !== void 0 ? _region : "";
        var _homeDetailId;
        message.homeDetailId = (_homeDetailId = object.homeDetailId) !== null && _homeDetailId !== void 0 ? _homeDetailId : "";
        var _inMarketplaceTopOfFunnelExp;
        message.inMarketplaceTopOfFunnelExp = (_inMarketplaceTopOfFunnelExp = object.inMarketplaceTopOfFunnelExp) !== null && _inMarketplaceTopOfFunnelExp !== void 0 ? _inMarketplaceTopOfFunnelExp : false;
        message.segments = ((ref1 = object.segments) === null || ref1 === void 0 ? void 0 : ref1.map(function(e) {
            return e;
        })) || [];
        var _experimentEntityId;
        message.experimentEntityId = (_experimentEntityId = object.experimentEntityId) !== null && _experimentEntityId !== void 0 ? _experimentEntityId : "";
        message.partnershipReferrals = ((ref2 = object.partnershipReferrals) === null || ref2 === void 0 ? void 0 : ref2.map(function(e) {
            return PartnershipReferral.fromPartial(e);
        })) || [];
        message.attributes = object.attributes !== undefined && object.attributes !== null ? Attributes.fromPartial(object.attributes) : undefined;
        message.homeValue = object.homeValue !== undefined && object.homeValue !== null ? HomeValue.fromPartial(object.homeValue) : undefined;
        var _isCompletedAt;
        message.isCompletedAt = (_isCompletedAt = object.isCompletedAt) !== null && _isCompletedAt !== void 0 ? _isCompletedAt : undefined;
        var _sellerFlowName;
        message.sellerFlowName = (_sellerFlowName = object.sellerFlowName) !== null && _sellerFlowName !== void 0 ? _sellerFlowName : "";
        var _pdpUrl;
        message.pdpUrl = (_pdpUrl = object.pdpUrl) !== null && _pdpUrl !== void 0 ? _pdpUrl : "";
        message.analyticsMetadata = object.analyticsMetadata !== undefined && object.analyticsMetadata !== null ? SellerInput_AnalyticsMetadata.fromPartial(object.analyticsMetadata) : undefined;
        var _isInPartnershipDenialServiceRegions;
        message.isInPartnershipDenialServiceRegions = (_isInPartnershipDenialServiceRegions = object.isInPartnershipDenialServiceRegions) !== null && _isInPartnershipDenialServiceRegions !== void 0 ? _isInPartnershipDenialServiceRegions : false;
        var _denialPartnerIdentifier;
        message.denialPartnerIdentifier = (_denialPartnerIdentifier = object.denialPartnerIdentifier) !== null && _denialPartnerIdentifier !== void 0 ? _denialPartnerIdentifier : "";
        var _listingEstimatePricingsId;
        message.listingEstimatePricingsId = (_listingEstimatePricingsId = object.listingEstimatePricingsId) !== null && _listingEstimatePricingsId !== void 0 ? _listingEstimatePricingsId : "";
        return message;
    }
};
function createBaseSellerInput_HomeDetails() {
    return {
        lastListing: undefined,
        physicalDetails: undefined,
        photos: [],
        nearFloodZone: false
    };
}
var SellerInput_HomeDetails = {
    fromJSON: function fromJSON(object) {
        return {
            lastListing: seller_input_isSet(object.lastListing) ? SellerInput_HomeDetails_ListingDetails.fromJSON(object.lastListing) : undefined,
            physicalDetails: seller_input_isSet(object.physicalDetails) ? SellerInput_HomeDetails_PhysicalDetails.fromJSON(object.physicalDetails) : undefined,
            photos: Array.isArray(object === null || object === void 0 ? void 0 : object.photos) ? object.photos.map(function(e) {
                return String(e);
            }) : [],
            nearFloodZone: seller_input_isSet(object.nearFloodZone) ? Boolean(object.nearFloodZone) : false
        };
    },
    toJSON: function toJSON(message) {
        var ref;
        var obj = {};
        if (message.lastListing !== undefined) {
            obj.lastListing = SellerInput_HomeDetails_ListingDetails.toJSON(message.lastListing);
        }
        if (message.physicalDetails !== undefined) {
            obj.physicalDetails = SellerInput_HomeDetails_PhysicalDetails.toJSON(message.physicalDetails);
        }
        if ((ref = message.photos) === null || ref === void 0 ? void 0 : ref.length) {
            obj.photos = message.photos;
        }
        if (message.nearFloodZone === true) {
            obj.nearFloodZone = message.nearFloodZone;
        }
        return obj;
    },
    create: function create(base) {
        return SellerInput_HomeDetails.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref;
        var message = createBaseSellerInput_HomeDetails();
        message.lastListing = object.lastListing !== undefined && object.lastListing !== null ? SellerInput_HomeDetails_ListingDetails.fromPartial(object.lastListing) : undefined;
        message.physicalDetails = object.physicalDetails !== undefined && object.physicalDetails !== null ? SellerInput_HomeDetails_PhysicalDetails.fromPartial(object.physicalDetails) : undefined;
        message.photos = ((ref = object.photos) === null || ref === void 0 ? void 0 : ref.map(function(e) {
            return e;
        })) || [];
        var _nearFloodZone;
        message.nearFloodZone = (_nearFloodZone = object.nearFloodZone) !== null && _nearFloodZone !== void 0 ? _nearFloodZone : false;
        return message;
    }
};
function createBaseSellerInput_HomeDetails_ListingDetails() {
    return {
        listingId: "",
        listingStatus: "",
        realtorName: "",
        realtorEmail: "",
        listDate: "",
        listPriceCents: 0,
        listingPhotos: []
    };
}
var SellerInput_HomeDetails_ListingDetails = {
    fromJSON: function fromJSON(object) {
        return {
            listingId: seller_input_isSet(object.listingId) ? String(object.listingId) : "",
            listingStatus: seller_input_isSet(object.listingStatus) ? String(object.listingStatus) : "",
            realtorName: seller_input_isSet(object.realtorName) ? String(object.realtorName) : "",
            realtorEmail: seller_input_isSet(object.realtorEmail) ? String(object.realtorEmail) : "",
            listDate: seller_input_isSet(object.listDate) ? String(object.listDate) : "",
            listPriceCents: seller_input_isSet(object.listPriceCents) ? Number(object.listPriceCents) : 0,
            listingPhotos: Array.isArray(object === null || object === void 0 ? void 0 : object.listingPhotos) ? object.listingPhotos.map(function(e) {
                return String(e);
            }) : []
        };
    },
    toJSON: function toJSON(message) {
        var ref;
        var obj = {};
        if (message.listingId !== "") {
            obj.listingId = message.listingId;
        }
        if (message.listingStatus !== "") {
            obj.listingStatus = message.listingStatus;
        }
        if (message.realtorName !== "") {
            obj.realtorName = message.realtorName;
        }
        if (message.realtorEmail !== "") {
            obj.realtorEmail = message.realtorEmail;
        }
        if (message.listDate !== "") {
            obj.listDate = message.listDate;
        }
        if (message.listPriceCents !== 0) {
            obj.listPriceCents = Math.round(message.listPriceCents);
        }
        if ((ref = message.listingPhotos) === null || ref === void 0 ? void 0 : ref.length) {
            obj.listingPhotos = message.listingPhotos;
        }
        return obj;
    },
    create: function create(base) {
        return SellerInput_HomeDetails_ListingDetails.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref;
        var message = createBaseSellerInput_HomeDetails_ListingDetails();
        var _listingId;
        message.listingId = (_listingId = object.listingId) !== null && _listingId !== void 0 ? _listingId : "";
        var _listingStatus;
        message.listingStatus = (_listingStatus = object.listingStatus) !== null && _listingStatus !== void 0 ? _listingStatus : "";
        var _realtorName;
        message.realtorName = (_realtorName = object.realtorName) !== null && _realtorName !== void 0 ? _realtorName : "";
        var _realtorEmail;
        message.realtorEmail = (_realtorEmail = object.realtorEmail) !== null && _realtorEmail !== void 0 ? _realtorEmail : "";
        var _listDate;
        message.listDate = (_listDate = object.listDate) !== null && _listDate !== void 0 ? _listDate : "";
        var _listPriceCents;
        message.listPriceCents = (_listPriceCents = object.listPriceCents) !== null && _listPriceCents !== void 0 ? _listPriceCents : 0;
        message.listingPhotos = ((ref = object.listingPhotos) === null || ref === void 0 ? void 0 : ref.map(function(e) {
            return e;
        })) || [];
        return message;
    }
};
function createBaseSellerInput_HomeDetails_PhysicalDetails() {
    return {
        ageRestrictedCommunity: undefined,
        basement: undefined,
        basementFinishedSqFt: undefined,
        basementSqFt: undefined,
        basementUnfinishedSqFt: undefined,
        bathrooms: undefined,
        bathroomsFull: undefined,
        bathroomsHalf: undefined,
        bedrooms: undefined,
        carportSpaces: undefined,
        distanceToFloodZone: undefined,
        dwellingStyle: undefined,
        dwellingType: undefined,
        exteriorStories: undefined,
        garageSpaces: undefined,
        hoaNames: [],
        floodZone: undefined,
        gatedCommunity: undefined,
        pool: undefined,
        primaryOwner: undefined,
        lotSqFt: undefined,
        sqFt: undefined,
        yearBuilt: undefined,
        kitchenApplianceType: undefined,
        flooringMaterials: []
    };
}
var SellerInput_HomeDetails_PhysicalDetails = {
    fromJSON: function fromJSON(object) {
        return {
            ageRestrictedCommunity: seller_input_isSet(object.ageRestrictedCommunity) ? Boolean(object.ageRestrictedCommunity) : undefined,
            basement: seller_input_isSet(object.basement) ? String(object.basement) : undefined,
            basementFinishedSqFt: seller_input_isSet(object.basementFinishedSqFt) ? Number(object.basementFinishedSqFt) : undefined,
            basementSqFt: seller_input_isSet(object.basementSqFt) ? Number(object.basementSqFt) : undefined,
            basementUnfinishedSqFt: seller_input_isSet(object.basementUnfinishedSqFt) ? Number(object.basementUnfinishedSqFt) : undefined,
            bathrooms: seller_input_isSet(object.bathrooms) ? Number(object.bathrooms) : undefined,
            bathroomsFull: seller_input_isSet(object.bathroomsFull) ? Number(object.bathroomsFull) : undefined,
            bathroomsHalf: seller_input_isSet(object.bathroomsHalf) ? Number(object.bathroomsHalf) : undefined,
            bedrooms: seller_input_isSet(object.bedrooms) ? Number(object.bedrooms) : undefined,
            carportSpaces: seller_input_isSet(object.carportSpaces) ? Number(object.carportSpaces) : undefined,
            distanceToFloodZone: seller_input_isSet(object.distanceToFloodZone) ? Number(object.distanceToFloodZone) : undefined,
            dwellingStyle: seller_input_isSet(object.dwellingStyle) ? String(object.dwellingStyle) : undefined,
            dwellingType: seller_input_isSet(object.dwellingType) ? String(object.dwellingType) : undefined,
            exteriorStories: seller_input_isSet(object.exteriorStories) ? Number(object.exteriorStories) : undefined,
            garageSpaces: seller_input_isSet(object.garageSpaces) ? Number(object.garageSpaces) : undefined,
            hoaNames: Array.isArray(object === null || object === void 0 ? void 0 : object.hoaNames) ? object.hoaNames.map(function(e) {
                return String(e);
            }) : [],
            floodZone: seller_input_isSet(object.floodZone) ? Boolean(object.floodZone) : undefined,
            gatedCommunity: seller_input_isSet(object.gatedCommunity) ? Boolean(object.gatedCommunity) : undefined,
            pool: seller_input_isSet(object.pool) ? Boolean(object.pool) : undefined,
            primaryOwner: seller_input_isSet(object.primaryOwner) ? String(object.primaryOwner) : undefined,
            lotSqFt: seller_input_isSet(object.lotSqFt) ? Number(object.lotSqFt) : undefined,
            sqFt: seller_input_isSet(object.sqFt) ? Number(object.sqFt) : undefined,
            yearBuilt: seller_input_isSet(object.yearBuilt) ? Number(object.yearBuilt) : undefined,
            kitchenApplianceType: seller_input_isSet(object["home.kitchen.appliance_type"]) ? String(object["home.kitchen.appliance_type"]) : undefined,
            flooringMaterials: Array.isArray(object === null || object === void 0 ? void 0 : object["home.flooring_materials"]) ? object["home.flooring_materials"].map(function(e) {
                return String(e);
            }) : []
        };
    },
    toJSON: function toJSON(message) {
        var ref, ref1;
        var obj = {};
        if (message.ageRestrictedCommunity !== undefined) {
            obj.ageRestrictedCommunity = message.ageRestrictedCommunity;
        }
        if (message.basement !== undefined) {
            obj.basement = message.basement;
        }
        if (message.basementFinishedSqFt !== undefined) {
            obj.basementFinishedSqFt = message.basementFinishedSqFt;
        }
        if (message.basementSqFt !== undefined) {
            obj.basementSqFt = message.basementSqFt;
        }
        if (message.basementUnfinishedSqFt !== undefined) {
            obj.basementUnfinishedSqFt = message.basementUnfinishedSqFt;
        }
        if (message.bathrooms !== undefined) {
            obj.bathrooms = message.bathrooms;
        }
        if (message.bathroomsFull !== undefined) {
            obj.bathroomsFull = message.bathroomsFull;
        }
        if (message.bathroomsHalf !== undefined) {
            obj.bathroomsHalf = message.bathroomsHalf;
        }
        if (message.bedrooms !== undefined) {
            obj.bedrooms = message.bedrooms;
        }
        if (message.carportSpaces !== undefined) {
            obj.carportSpaces = message.carportSpaces;
        }
        if (message.distanceToFloodZone !== undefined) {
            obj.distanceToFloodZone = message.distanceToFloodZone;
        }
        if (message.dwellingStyle !== undefined) {
            obj.dwellingStyle = message.dwellingStyle;
        }
        if (message.dwellingType !== undefined) {
            obj.dwellingType = message.dwellingType;
        }
        if (message.exteriorStories !== undefined) {
            obj.exteriorStories = message.exteriorStories;
        }
        if (message.garageSpaces !== undefined) {
            obj.garageSpaces = message.garageSpaces;
        }
        if ((ref = message.hoaNames) === null || ref === void 0 ? void 0 : ref.length) {
            obj.hoaNames = message.hoaNames;
        }
        if (message.floodZone !== undefined) {
            obj.floodZone = message.floodZone;
        }
        if (message.gatedCommunity !== undefined) {
            obj.gatedCommunity = message.gatedCommunity;
        }
        if (message.pool !== undefined) {
            obj.pool = message.pool;
        }
        if (message.primaryOwner !== undefined) {
            obj.primaryOwner = message.primaryOwner;
        }
        if (message.lotSqFt !== undefined) {
            obj.lotSqFt = message.lotSqFt;
        }
        if (message.sqFt !== undefined) {
            obj.sqFt = message.sqFt;
        }
        if (message.yearBuilt !== undefined) {
            obj.yearBuilt = message.yearBuilt;
        }
        if (message.kitchenApplianceType !== undefined) {
            obj["home.kitchen.appliance_type"] = message.kitchenApplianceType;
        }
        if ((ref1 = message.flooringMaterials) === null || ref1 === void 0 ? void 0 : ref1.length) {
            obj["home.flooring_materials"] = message.flooringMaterials;
        }
        return obj;
    },
    create: function create(base) {
        return SellerInput_HomeDetails_PhysicalDetails.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref, ref1;
        var message = createBaseSellerInput_HomeDetails_PhysicalDetails();
        var _ageRestrictedCommunity;
        message.ageRestrictedCommunity = (_ageRestrictedCommunity = object.ageRestrictedCommunity) !== null && _ageRestrictedCommunity !== void 0 ? _ageRestrictedCommunity : undefined;
        var _basement;
        message.basement = (_basement = object.basement) !== null && _basement !== void 0 ? _basement : undefined;
        var _basementFinishedSqFt;
        message.basementFinishedSqFt = (_basementFinishedSqFt = object.basementFinishedSqFt) !== null && _basementFinishedSqFt !== void 0 ? _basementFinishedSqFt : undefined;
        var _basementSqFt;
        message.basementSqFt = (_basementSqFt = object.basementSqFt) !== null && _basementSqFt !== void 0 ? _basementSqFt : undefined;
        var _basementUnfinishedSqFt;
        message.basementUnfinishedSqFt = (_basementUnfinishedSqFt = object.basementUnfinishedSqFt) !== null && _basementUnfinishedSqFt !== void 0 ? _basementUnfinishedSqFt : undefined;
        var _bathrooms;
        message.bathrooms = (_bathrooms = object.bathrooms) !== null && _bathrooms !== void 0 ? _bathrooms : undefined;
        var _bathroomsFull;
        message.bathroomsFull = (_bathroomsFull = object.bathroomsFull) !== null && _bathroomsFull !== void 0 ? _bathroomsFull : undefined;
        var _bathroomsHalf;
        message.bathroomsHalf = (_bathroomsHalf = object.bathroomsHalf) !== null && _bathroomsHalf !== void 0 ? _bathroomsHalf : undefined;
        var _bedrooms;
        message.bedrooms = (_bedrooms = object.bedrooms) !== null && _bedrooms !== void 0 ? _bedrooms : undefined;
        var _carportSpaces;
        message.carportSpaces = (_carportSpaces = object.carportSpaces) !== null && _carportSpaces !== void 0 ? _carportSpaces : undefined;
        var _distanceToFloodZone;
        message.distanceToFloodZone = (_distanceToFloodZone = object.distanceToFloodZone) !== null && _distanceToFloodZone !== void 0 ? _distanceToFloodZone : undefined;
        var _dwellingStyle;
        message.dwellingStyle = (_dwellingStyle = object.dwellingStyle) !== null && _dwellingStyle !== void 0 ? _dwellingStyle : undefined;
        var _dwellingType;
        message.dwellingType = (_dwellingType = object.dwellingType) !== null && _dwellingType !== void 0 ? _dwellingType : undefined;
        var _exteriorStories;
        message.exteriorStories = (_exteriorStories = object.exteriorStories) !== null && _exteriorStories !== void 0 ? _exteriorStories : undefined;
        var _garageSpaces;
        message.garageSpaces = (_garageSpaces = object.garageSpaces) !== null && _garageSpaces !== void 0 ? _garageSpaces : undefined;
        message.hoaNames = ((ref = object.hoaNames) === null || ref === void 0 ? void 0 : ref.map(function(e) {
            return e;
        })) || [];
        var _floodZone;
        message.floodZone = (_floodZone = object.floodZone) !== null && _floodZone !== void 0 ? _floodZone : undefined;
        var _gatedCommunity;
        message.gatedCommunity = (_gatedCommunity = object.gatedCommunity) !== null && _gatedCommunity !== void 0 ? _gatedCommunity : undefined;
        var _pool;
        message.pool = (_pool = object.pool) !== null && _pool !== void 0 ? _pool : undefined;
        var _primaryOwner;
        message.primaryOwner = (_primaryOwner = object.primaryOwner) !== null && _primaryOwner !== void 0 ? _primaryOwner : undefined;
        var _lotSqFt;
        message.lotSqFt = (_lotSqFt = object.lotSqFt) !== null && _lotSqFt !== void 0 ? _lotSqFt : undefined;
        var _sqFt;
        message.sqFt = (_sqFt = object.sqFt) !== null && _sqFt !== void 0 ? _sqFt : undefined;
        var _yearBuilt;
        message.yearBuilt = (_yearBuilt = object.yearBuilt) !== null && _yearBuilt !== void 0 ? _yearBuilt : undefined;
        var _kitchenApplianceType;
        message.kitchenApplianceType = (_kitchenApplianceType = object.kitchenApplianceType) !== null && _kitchenApplianceType !== void 0 ? _kitchenApplianceType : undefined;
        message.flooringMaterials = ((ref1 = object.flooringMaterials) === null || ref1 === void 0 ? void 0 : ref1.map(function(e) {
            return e;
        })) || [];
        return message;
    }
};
function createBaseSellerInput_AnalyticsMetadata() {
    return {
        addressEntry: undefined
    };
}
var SellerInput_AnalyticsMetadata = {
    fromJSON: function fromJSON(object) {
        return {
            addressEntry: seller_input_isSet(object.addressEntry) ? SellerInput_AnalyticsMetadata_AddressEntry.fromJSON(object.addressEntry) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.addressEntry !== undefined) {
            obj.addressEntry = SellerInput_AnalyticsMetadata_AddressEntry.toJSON(message.addressEntry);
        }
        return obj;
    },
    create: function create(base) {
        return SellerInput_AnalyticsMetadata.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseSellerInput_AnalyticsMetadata();
        message.addressEntry = object.addressEntry !== undefined && object.addressEntry !== null ? SellerInput_AnalyticsMetadata_AddressEntry.fromPartial(object.addressEntry) : undefined;
        return message;
    }
};
function createBaseSellerInput_AnalyticsMetadata_AddressEntry() {
    return {
        product: 0,
        url: ""
    };
}
var SellerInput_AnalyticsMetadata_AddressEntry = {
    fromJSON: function fromJSON(object) {
        return {
            product: seller_input_isSet(object.product) ? sellerInput_AnalyticsMetadata_ProductFromJSON(object.product) : 0,
            url: seller_input_isSet(object.url) ? String(object.url) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.product !== 0) {
            obj.product = sellerInput_AnalyticsMetadata_ProductToJSON(message.product);
        }
        if (message.url !== "") {
            obj.url = message.url;
        }
        return obj;
    },
    create: function create(base) {
        return SellerInput_AnalyticsMetadata_AddressEntry.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseSellerInput_AnalyticsMetadata_AddressEntry();
        var _product;
        message.product = (_product = object.product) !== null && _product !== void 0 ? _product : 0;
        var _url;
        message.url = (_url = object.url) !== null && _url !== void 0 ? _url : "";
        return message;
    }
};
function seller_input_fromTimestamp(t) {
    var millis = (t.seconds || 0) * 1000;
    millis += (t.nanos || 0) / 1000000;
    return new Date(millis);
}
function seller_input_fromJsonTimestamp(o) {
    if ((0,_instanceof/* default */.Z)(o, Date)) {
        return o;
    } else if (typeof o === "string") {
        return new Date(o);
    } else {
        return seller_input_fromTimestamp(Timestamp.fromJSON(o));
    }
}
function seller_input_isObject(value) {
    return typeof value === "object" && value !== null;
}
function seller_input_isSet(value) {
    return value !== null && value !== undefined;
}

;// CONCATENATED MODULE: ./src/__generated__/protobuf/sell/seller/data/agent_referral.ts
/* eslint-disable */ 

var agent_referral_protobufPackage = "od_protos.sell.seller.data";
function createBaseAgentReferralSpecificData() {
    return {
        availability: undefined,
        notesForCustomer: "",
        notesForAgent: "",
        referringOperatorId: "",
        offerFeedbackMarketplaceReferral: undefined
    };
}
var AgentReferralSpecificData = {
    fromJSON: function fromJSON(object) {
        return {
            availability: agent_referral_isSet(object.availability) ? AgentReferralSpecificData_Availability.fromJSON(object.availability) : undefined,
            notesForCustomer: agent_referral_isSet(object.notesForCustomer) ? String(object.notesForCustomer) : "",
            notesForAgent: agent_referral_isSet(object.notesForAgent) ? String(object.notesForAgent) : "",
            referringOperatorId: agent_referral_isSet(object.referringOperatorId) ? String(object.referringOperatorId) : "",
            offerFeedbackMarketplaceReferral: agent_referral_isSet(object.offerFeedbackMarketplaceReferral) ? AgentReferralSpecificData_OfferFeedbackMarketplaceReferral.fromJSON(object.offerFeedbackMarketplaceReferral) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.availability !== undefined) {
            obj.availability = AgentReferralSpecificData_Availability.toJSON(message.availability);
        }
        if (message.notesForCustomer !== "") {
            obj.notesForCustomer = message.notesForCustomer;
        }
        if (message.notesForAgent !== "") {
            obj.notesForAgent = message.notesForAgent;
        }
        if (message.referringOperatorId !== "") {
            obj.referringOperatorId = message.referringOperatorId;
        }
        if (message.offerFeedbackMarketplaceReferral !== undefined) {
            obj.offerFeedbackMarketplaceReferral = AgentReferralSpecificData_OfferFeedbackMarketplaceReferral.toJSON(message.offerFeedbackMarketplaceReferral);
        }
        return obj;
    },
    create: function create(base) {
        return AgentReferralSpecificData.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAgentReferralSpecificData();
        message.availability = object.availability !== undefined && object.availability !== null ? AgentReferralSpecificData_Availability.fromPartial(object.availability) : undefined;
        var _notesForCustomer;
        message.notesForCustomer = (_notesForCustomer = object.notesForCustomer) !== null && _notesForCustomer !== void 0 ? _notesForCustomer : "";
        var _notesForAgent;
        message.notesForAgent = (_notesForAgent = object.notesForAgent) !== null && _notesForAgent !== void 0 ? _notesForAgent : "";
        var _referringOperatorId;
        message.referringOperatorId = (_referringOperatorId = object.referringOperatorId) !== null && _referringOperatorId !== void 0 ? _referringOperatorId : "";
        message.offerFeedbackMarketplaceReferral = object.offerFeedbackMarketplaceReferral !== undefined && object.offerFeedbackMarketplaceReferral !== null ? AgentReferralSpecificData_OfferFeedbackMarketplaceReferral.fromPartial(object.offerFeedbackMarketplaceReferral) : undefined;
        return message;
    }
};
function createBaseAgentReferralSpecificData_Availability() {
    return {
        asap: false,
        firstChoice: undefined,
        secondChoice: undefined,
        thirdChoice: undefined
    };
}
var AgentReferralSpecificData_Availability = {
    fromJSON: function fromJSON(object) {
        return {
            asap: agent_referral_isSet(object.asap) ? Boolean(object.asap) : false,
            firstChoice: agent_referral_isSet(object.firstChoice) ? AgentReferralSpecificData_Availability_Choice.fromJSON(object.firstChoice) : undefined,
            secondChoice: agent_referral_isSet(object.secondChoice) ? AgentReferralSpecificData_Availability_Choice.fromJSON(object.secondChoice) : undefined,
            thirdChoice: agent_referral_isSet(object.thirdChoice) ? AgentReferralSpecificData_Availability_Choice.fromJSON(object.thirdChoice) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.asap === true) {
            obj.asap = message.asap;
        }
        if (message.firstChoice !== undefined) {
            obj.firstChoice = AgentReferralSpecificData_Availability_Choice.toJSON(message.firstChoice);
        }
        if (message.secondChoice !== undefined) {
            obj.secondChoice = AgentReferralSpecificData_Availability_Choice.toJSON(message.secondChoice);
        }
        if (message.thirdChoice !== undefined) {
            obj.thirdChoice = AgentReferralSpecificData_Availability_Choice.toJSON(message.thirdChoice);
        }
        return obj;
    },
    create: function create(base) {
        return AgentReferralSpecificData_Availability.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAgentReferralSpecificData_Availability();
        var _asap;
        message.asap = (_asap = object.asap) !== null && _asap !== void 0 ? _asap : false;
        message.firstChoice = object.firstChoice !== undefined && object.firstChoice !== null ? AgentReferralSpecificData_Availability_Choice.fromPartial(object.firstChoice) : undefined;
        message.secondChoice = object.secondChoice !== undefined && object.secondChoice !== null ? AgentReferralSpecificData_Availability_Choice.fromPartial(object.secondChoice) : undefined;
        message.thirdChoice = object.thirdChoice !== undefined && object.thirdChoice !== null ? AgentReferralSpecificData_Availability_Choice.fromPartial(object.thirdChoice) : undefined;
        return message;
    }
};
function createBaseAgentReferralSpecificData_Availability_Choice() {
    return {
        startTime: undefined,
        endTime: undefined
    };
}
var AgentReferralSpecificData_Availability_Choice = {
    fromJSON: function fromJSON(object) {
        return {
            startTime: agent_referral_isSet(object.startTime) ? agent_referral_fromJsonTimestamp(object.startTime) : undefined,
            endTime: agent_referral_isSet(object.endTime) ? agent_referral_fromJsonTimestamp(object.endTime) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.startTime !== undefined) {
            obj.startTime = message.startTime.toISOString();
        }
        if (message.endTime !== undefined) {
            obj.endTime = message.endTime.toISOString();
        }
        return obj;
    },
    create: function create(base) {
        return AgentReferralSpecificData_Availability_Choice.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAgentReferralSpecificData_Availability_Choice();
        var _startTime;
        message.startTime = (_startTime = object.startTime) !== null && _startTime !== void 0 ? _startTime : undefined;
        var _endTime;
        message.endTime = (_endTime = object.endTime) !== null && _endTime !== void 0 ? _endTime : undefined;
        return message;
    }
};
function createBaseAgentReferralSpecificData_OfferFeedbackMarketplaceReferral() {
    return {
        accepted: false,
        callTime: undefined,
        declineReason: undefined
    };
}
var AgentReferralSpecificData_OfferFeedbackMarketplaceReferral = {
    fromJSON: function fromJSON(object) {
        return {
            accepted: agent_referral_isSet(object.accepted) ? Boolean(object.accepted) : false,
            callTime: agent_referral_isSet(object.callTime) ? AgentReferralSpecificData_OfferFeedbackMarketplaceReferral_CallTime.fromJSON(object.callTime) : undefined,
            declineReason: agent_referral_isSet(object.declineReason) ? AgentReferralSpecificData_OfferFeedbackMarketplaceReferral_DeclineReason.fromJSON(object.declineReason) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.accepted === true) {
            obj.accepted = message.accepted;
        }
        if (message.callTime !== undefined) {
            obj.callTime = AgentReferralSpecificData_OfferFeedbackMarketplaceReferral_CallTime.toJSON(message.callTime);
        }
        if (message.declineReason !== undefined) {
            obj.declineReason = AgentReferralSpecificData_OfferFeedbackMarketplaceReferral_DeclineReason.toJSON(message.declineReason);
        }
        return obj;
    },
    create: function create(base) {
        return AgentReferralSpecificData_OfferFeedbackMarketplaceReferral.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAgentReferralSpecificData_OfferFeedbackMarketplaceReferral();
        var _accepted;
        message.accepted = (_accepted = object.accepted) !== null && _accepted !== void 0 ? _accepted : false;
        message.callTime = object.callTime !== undefined && object.callTime !== null ? AgentReferralSpecificData_OfferFeedbackMarketplaceReferral_CallTime.fromPartial(object.callTime) : undefined;
        message.declineReason = object.declineReason !== undefined && object.declineReason !== null ? AgentReferralSpecificData_OfferFeedbackMarketplaceReferral_DeclineReason.fromPartial(object.declineReason) : undefined;
        return message;
    }
};
function createBaseAgentReferralSpecificData_OfferFeedbackMarketplaceReferral_CallTime() {
    return {
        startTime: undefined,
        endTime: undefined,
        asap: false
    };
}
var AgentReferralSpecificData_OfferFeedbackMarketplaceReferral_CallTime = {
    fromJSON: function fromJSON(object) {
        return {
            startTime: agent_referral_isSet(object.startTime) ? agent_referral_fromJsonTimestamp(object.startTime) : undefined,
            endTime: agent_referral_isSet(object.endTime) ? agent_referral_fromJsonTimestamp(object.endTime) : undefined,
            asap: agent_referral_isSet(object.asap) ? Boolean(object.asap) : false
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.startTime !== undefined) {
            obj.startTime = message.startTime.toISOString();
        }
        if (message.endTime !== undefined) {
            obj.endTime = message.endTime.toISOString();
        }
        if (message.asap === true) {
            obj.asap = message.asap;
        }
        return obj;
    },
    create: function create(base) {
        return AgentReferralSpecificData_OfferFeedbackMarketplaceReferral_CallTime.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAgentReferralSpecificData_OfferFeedbackMarketplaceReferral_CallTime();
        var _startTime;
        message.startTime = (_startTime = object.startTime) !== null && _startTime !== void 0 ? _startTime : undefined;
        var _endTime;
        message.endTime = (_endTime = object.endTime) !== null && _endTime !== void 0 ? _endTime : undefined;
        var _asap;
        message.asap = (_asap = object.asap) !== null && _asap !== void 0 ? _asap : false;
        return message;
    }
};
function createBaseAgentReferralSpecificData_OfferFeedbackMarketplaceReferral_DeclineReason() {
    return {
        reason: undefined,
        other: undefined
    };
}
var AgentReferralSpecificData_OfferFeedbackMarketplaceReferral_DeclineReason = {
    fromJSON: function fromJSON(object) {
        return {
            reason: agent_referral_isSet(object.reason) ? String(object.reason) : undefined,
            other: agent_referral_isSet(object.other) ? String(object.other) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.reason !== undefined) {
            obj.reason = message.reason;
        }
        if (message.other !== undefined) {
            obj.other = message.other;
        }
        return obj;
    },
    create: function create(base) {
        return AgentReferralSpecificData_OfferFeedbackMarketplaceReferral_DeclineReason.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAgentReferralSpecificData_OfferFeedbackMarketplaceReferral_DeclineReason();
        var _reason;
        message.reason = (_reason = object.reason) !== null && _reason !== void 0 ? _reason : undefined;
        var _other;
        message.other = (_other = object.other) !== null && _other !== void 0 ? _other : undefined;
        return message;
    }
};
function agent_referral_fromTimestamp(t) {
    var millis = (t.seconds || 0) * 1000;
    millis += (t.nanos || 0) / 1000000;
    return new Date(millis);
}
function agent_referral_fromJsonTimestamp(o) {
    if ((0,_instanceof/* default */.Z)(o, Date)) {
        return o;
    } else if (typeof o === "string") {
        return new Date(o);
    } else {
        return agent_referral_fromTimestamp(Timestamp.fromJSON(o));
    }
}
function agent_referral_isSet(value) {
    return value !== null && value !== undefined;
}

;// CONCATENATED MODULE: ./src/__generated__/protobuf/common/sell/walk.ts
/* eslint-disable */ var walk_protobufPackage = "od_protos.common.sell";
var WalkInitiator;
(function(WalkInitiator) {
    WalkInitiator[WalkInitiator["WALK_INITIATOR_UNKNOWN"] = 0] = "WALK_INITIATOR_UNKNOWN";
    WalkInitiator[WalkInitiator["WALK_INITIATOR_OPENDOOR"] = 1] = "WALK_INITIATOR_OPENDOOR";
    WalkInitiator[WalkInitiator["WALK_INITIATOR_SELLER"] = 2] = "WALK_INITIATOR_SELLER";
    WalkInitiator[WalkInitiator["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(WalkInitiator || (WalkInitiator = {}));
function walkInitiatorFromJSON(object) {
    switch(object){
        case 0:
        case "WALK_INITIATOR_UNKNOWN":
            return WalkInitiator.WALK_INITIATOR_UNKNOWN;
        case 1:
        case "WALK_INITIATOR_OPENDOOR":
            return WalkInitiator.WALK_INITIATOR_OPENDOOR;
        case 2:
        case "WALK_INITIATOR_SELLER":
            return WalkInitiator.WALK_INITIATOR_SELLER;
        case -1:
        case "UNRECOGNIZED":
        default:
            return WalkInitiator.UNRECOGNIZED;
    }
}
function walkInitiatorToJSON(object) {
    switch(object){
        case WalkInitiator.WALK_INITIATOR_UNKNOWN:
            return "WALK_INITIATOR_UNKNOWN";
        case WalkInitiator.WALK_INITIATOR_OPENDOOR:
            return "WALK_INITIATOR_OPENDOOR";
        case WalkInitiator.WALK_INITIATOR_SELLER:
            return "WALK_INITIATOR_SELLER";
        case WalkInitiator.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var OpendoorWalkReason;
(function(OpendoorWalkReason) {
    OpendoorWalkReason[OpendoorWalkReason["OPENDOOR_WALK_REASON_UNKNOWN"] = 0] = "OPENDOOR_WALK_REASON_UNKNOWN";
    OpendoorWalkReason[OpendoorWalkReason["OPENDOOR_WALK_REASON_SEE_UNDERWRITING"] = 1] = "OPENDOOR_WALK_REASON_SEE_UNDERWRITING";
    OpendoorWalkReason[OpendoorWalkReason["OPENDOOR_WALK_REASON_ADJACENT_TO_STABILIZATION"] = 2] = "OPENDOOR_WALK_REASON_ADJACENT_TO_STABILIZATION";
    OpendoorWalkReason[OpendoorWalkReason["OPENDOOR_WALK_REASON_OPENDOOR_ADDENDUM"] = 3] = "OPENDOOR_WALK_REASON_OPENDOOR_ADDENDUM";
    OpendoorWalkReason[OpendoorWalkReason["OPENDOOR_WALK_REASON_PRICING_UNCERTAINTY"] = 4] = "OPENDOOR_WALK_REASON_PRICING_UNCERTAINTY";
    OpendoorWalkReason[OpendoorWalkReason["OPENDOOR_WALK_REASON_REPAIR_ASSESSMENT_INCOMPLETE"] = 5] = "OPENDOOR_WALK_REASON_REPAIR_ASSESSMENT_INCOMPLETE";
    OpendoorWalkReason[OpendoorWalkReason["OPENDOOR_WALK_REASON_REPAIR_SCOPE_OF_WORK_TOO_LARGE"] = 6] = "OPENDOOR_WALK_REASON_REPAIR_SCOPE_OF_WORK_TOO_LARGE";
    OpendoorWalkReason[OpendoorWalkReason["OPENDOOR_WALK_REASON_FAILED_ELIGIBILITY_RECHECK"] = 7] = "OPENDOOR_WALK_REASON_FAILED_ELIGIBILITY_RECHECK";
    OpendoorWalkReason[OpendoorWalkReason["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(OpendoorWalkReason || (OpendoorWalkReason = {}));
function opendoorWalkReasonFromJSON(object) {
    switch(object){
        case 0:
        case "OPENDOOR_WALK_REASON_UNKNOWN":
            return OpendoorWalkReason.OPENDOOR_WALK_REASON_UNKNOWN;
        case 1:
        case "OPENDOOR_WALK_REASON_SEE_UNDERWRITING":
            return OpendoorWalkReason.OPENDOOR_WALK_REASON_SEE_UNDERWRITING;
        case 2:
        case "OPENDOOR_WALK_REASON_ADJACENT_TO_STABILIZATION":
            return OpendoorWalkReason.OPENDOOR_WALK_REASON_ADJACENT_TO_STABILIZATION;
        case 3:
        case "OPENDOOR_WALK_REASON_OPENDOOR_ADDENDUM":
            return OpendoorWalkReason.OPENDOOR_WALK_REASON_OPENDOOR_ADDENDUM;
        case 4:
        case "OPENDOOR_WALK_REASON_PRICING_UNCERTAINTY":
            return OpendoorWalkReason.OPENDOOR_WALK_REASON_PRICING_UNCERTAINTY;
        case 5:
        case "OPENDOOR_WALK_REASON_REPAIR_ASSESSMENT_INCOMPLETE":
            return OpendoorWalkReason.OPENDOOR_WALK_REASON_REPAIR_ASSESSMENT_INCOMPLETE;
        case 6:
        case "OPENDOOR_WALK_REASON_REPAIR_SCOPE_OF_WORK_TOO_LARGE":
            return OpendoorWalkReason.OPENDOOR_WALK_REASON_REPAIR_SCOPE_OF_WORK_TOO_LARGE;
        case 7:
        case "OPENDOOR_WALK_REASON_FAILED_ELIGIBILITY_RECHECK":
            return OpendoorWalkReason.OPENDOOR_WALK_REASON_FAILED_ELIGIBILITY_RECHECK;
        case -1:
        case "UNRECOGNIZED":
        default:
            return OpendoorWalkReason.UNRECOGNIZED;
    }
}
function opendoorWalkReasonToJSON(object) {
    switch(object){
        case OpendoorWalkReason.OPENDOOR_WALK_REASON_UNKNOWN:
            return "OPENDOOR_WALK_REASON_UNKNOWN";
        case OpendoorWalkReason.OPENDOOR_WALK_REASON_SEE_UNDERWRITING:
            return "OPENDOOR_WALK_REASON_SEE_UNDERWRITING";
        case OpendoorWalkReason.OPENDOOR_WALK_REASON_ADJACENT_TO_STABILIZATION:
            return "OPENDOOR_WALK_REASON_ADJACENT_TO_STABILIZATION";
        case OpendoorWalkReason.OPENDOOR_WALK_REASON_OPENDOOR_ADDENDUM:
            return "OPENDOOR_WALK_REASON_OPENDOOR_ADDENDUM";
        case OpendoorWalkReason.OPENDOOR_WALK_REASON_PRICING_UNCERTAINTY:
            return "OPENDOOR_WALK_REASON_PRICING_UNCERTAINTY";
        case OpendoorWalkReason.OPENDOOR_WALK_REASON_REPAIR_ASSESSMENT_INCOMPLETE:
            return "OPENDOOR_WALK_REASON_REPAIR_ASSESSMENT_INCOMPLETE";
        case OpendoorWalkReason.OPENDOOR_WALK_REASON_REPAIR_SCOPE_OF_WORK_TOO_LARGE:
            return "OPENDOOR_WALK_REASON_REPAIR_SCOPE_OF_WORK_TOO_LARGE";
        case OpendoorWalkReason.OPENDOOR_WALK_REASON_FAILED_ELIGIBILITY_RECHECK:
            return "OPENDOOR_WALK_REASON_FAILED_ELIGIBILITY_RECHECK";
        case OpendoorWalkReason.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var SellerWalkReason;
(function(SellerWalkReason) {
    SellerWalkReason[SellerWalkReason["SELLER_WALK_REASON_UNKNOWN"] = 0] = "SELLER_WALK_REASON_UNKNOWN";
    SellerWalkReason[SellerWalkReason["SELLER_WALK_REASON_CANNOT_FIND_NEW_HOME"] = 1] = "SELLER_WALK_REASON_CANNOT_FIND_NEW_HOME";
    SellerWalkReason[SellerWalkReason["SELLER_WALK_REASON_NOT_SELLING"] = 2] = "SELLER_WALK_REASON_NOT_SELLING";
    SellerWalkReason[SellerWalkReason["SELLER_WALK_REASON_NET_CASH"] = 3] = "SELLER_WALK_REASON_NET_CASH";
    SellerWalkReason[SellerWalkReason["SELLER_WALK_REASON_OTHER_REASON"] = 4] = "SELLER_WALK_REASON_OTHER_REASON";
    SellerWalkReason[SellerWalkReason["SELLER_WALK_REASON_POST_INSPECTION_OPENDOOR_ASK"] = 5] = "SELLER_WALK_REASON_POST_INSPECTION_OPENDOOR_ASK";
    SellerWalkReason[SellerWalkReason["SELLER_WALK_REASON_COMPETITION_OR_INVESTOR_OFFER"] = 6] = "SELLER_WALK_REASON_COMPETITION_OR_INVESTOR_OFFER";
    SellerWalkReason[SellerWalkReason["SELLER_WALK_REASON_HOME_IS_LISTED"] = 7] = "SELLER_WALK_REASON_HOME_IS_LISTED";
    SellerWalkReason[SellerWalkReason["SELLER_WALK_REASON_LEGAL_ISSUES"] = 8] = "SELLER_WALK_REASON_LEGAL_ISSUES";
    SellerWalkReason[SellerWalkReason["SELLER_WALK_REASON_CLOSE_OF_ESCROW_EXTENSION_DENIED"] = 9] = "SELLER_WALK_REASON_CLOSE_OF_ESCROW_EXTENSION_DENIED";
    SellerWalkReason[SellerWalkReason["SELLER_WALK_REASON_HOA_SOLAR_CITY_INSPECTION"] = 10] = "SELLER_WALK_REASON_HOA_SOLAR_CITY_INSPECTION";
    SellerWalkReason[SellerWalkReason["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(SellerWalkReason || (SellerWalkReason = {}));
function sellerWalkReasonFromJSON(object) {
    switch(object){
        case 0:
        case "SELLER_WALK_REASON_UNKNOWN":
            return SellerWalkReason.SELLER_WALK_REASON_UNKNOWN;
        case 1:
        case "SELLER_WALK_REASON_CANNOT_FIND_NEW_HOME":
            return SellerWalkReason.SELLER_WALK_REASON_CANNOT_FIND_NEW_HOME;
        case 2:
        case "SELLER_WALK_REASON_NOT_SELLING":
            return SellerWalkReason.SELLER_WALK_REASON_NOT_SELLING;
        case 3:
        case "SELLER_WALK_REASON_NET_CASH":
            return SellerWalkReason.SELLER_WALK_REASON_NET_CASH;
        case 4:
        case "SELLER_WALK_REASON_OTHER_REASON":
            return SellerWalkReason.SELLER_WALK_REASON_OTHER_REASON;
        case 5:
        case "SELLER_WALK_REASON_POST_INSPECTION_OPENDOOR_ASK":
            return SellerWalkReason.SELLER_WALK_REASON_POST_INSPECTION_OPENDOOR_ASK;
        case 6:
        case "SELLER_WALK_REASON_COMPETITION_OR_INVESTOR_OFFER":
            return SellerWalkReason.SELLER_WALK_REASON_COMPETITION_OR_INVESTOR_OFFER;
        case 7:
        case "SELLER_WALK_REASON_HOME_IS_LISTED":
            return SellerWalkReason.SELLER_WALK_REASON_HOME_IS_LISTED;
        case 8:
        case "SELLER_WALK_REASON_LEGAL_ISSUES":
            return SellerWalkReason.SELLER_WALK_REASON_LEGAL_ISSUES;
        case 9:
        case "SELLER_WALK_REASON_CLOSE_OF_ESCROW_EXTENSION_DENIED":
            return SellerWalkReason.SELLER_WALK_REASON_CLOSE_OF_ESCROW_EXTENSION_DENIED;
        case 10:
        case "SELLER_WALK_REASON_HOA_SOLAR_CITY_INSPECTION":
            return SellerWalkReason.SELLER_WALK_REASON_HOA_SOLAR_CITY_INSPECTION;
        case -1:
        case "UNRECOGNIZED":
        default:
            return SellerWalkReason.UNRECOGNIZED;
    }
}
function sellerWalkReasonToJSON(object) {
    switch(object){
        case SellerWalkReason.SELLER_WALK_REASON_UNKNOWN:
            return "SELLER_WALK_REASON_UNKNOWN";
        case SellerWalkReason.SELLER_WALK_REASON_CANNOT_FIND_NEW_HOME:
            return "SELLER_WALK_REASON_CANNOT_FIND_NEW_HOME";
        case SellerWalkReason.SELLER_WALK_REASON_NOT_SELLING:
            return "SELLER_WALK_REASON_NOT_SELLING";
        case SellerWalkReason.SELLER_WALK_REASON_NET_CASH:
            return "SELLER_WALK_REASON_NET_CASH";
        case SellerWalkReason.SELLER_WALK_REASON_OTHER_REASON:
            return "SELLER_WALK_REASON_OTHER_REASON";
        case SellerWalkReason.SELLER_WALK_REASON_POST_INSPECTION_OPENDOOR_ASK:
            return "SELLER_WALK_REASON_POST_INSPECTION_OPENDOOR_ASK";
        case SellerWalkReason.SELLER_WALK_REASON_COMPETITION_OR_INVESTOR_OFFER:
            return "SELLER_WALK_REASON_COMPETITION_OR_INVESTOR_OFFER";
        case SellerWalkReason.SELLER_WALK_REASON_HOME_IS_LISTED:
            return "SELLER_WALK_REASON_HOME_IS_LISTED";
        case SellerWalkReason.SELLER_WALK_REASON_LEGAL_ISSUES:
            return "SELLER_WALK_REASON_LEGAL_ISSUES";
        case SellerWalkReason.SELLER_WALK_REASON_CLOSE_OF_ESCROW_EXTENSION_DENIED:
            return "SELLER_WALK_REASON_CLOSE_OF_ESCROW_EXTENSION_DENIED";
        case SellerWalkReason.SELLER_WALK_REASON_HOA_SOLAR_CITY_INSPECTION:
            return "SELLER_WALK_REASON_HOA_SOLAR_CITY_INSPECTION";
        case SellerWalkReason.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}

;// CONCATENATED MODULE: ./src/__generated__/protobuf/sell/seller/data/policy.ts
/* eslint-disable */ var policy_protobufPackage = "od_protos.sell.seller.data";
function createBasePolicy() {
    return {
        showComps: false,
        marketplace: false,
        expAug2019CepPilot: false,
        opendoorDirectAutomatedOffer: false
    };
}
var Policy = {
    fromJSON: function fromJSON(object) {
        return {
            showComps: policy_isSet(object.show_comps) ? Boolean(object.show_comps) : false,
            marketplace: policy_isSet(object.marketplace) ? Boolean(object.marketplace) : false,
            expAug2019CepPilot: policy_isSet(object.expAug2019CepPilot) ? Boolean(object.expAug2019CepPilot) : false,
            opendoorDirectAutomatedOffer: policy_isSet(object.opendoorDirectAutomatedOffer) ? Boolean(object.opendoorDirectAutomatedOffer) : false
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.showComps === true) {
            obj.show_comps = message.showComps;
        }
        if (message.marketplace === true) {
            obj.marketplace = message.marketplace;
        }
        if (message.expAug2019CepPilot === true) {
            obj.expAug2019CepPilot = message.expAug2019CepPilot;
        }
        if (message.opendoorDirectAutomatedOffer === true) {
            obj.opendoorDirectAutomatedOffer = message.opendoorDirectAutomatedOffer;
        }
        return obj;
    },
    create: function create(base) {
        return Policy.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBasePolicy();
        var _showComps;
        message.showComps = (_showComps = object.showComps) !== null && _showComps !== void 0 ? _showComps : false;
        var _marketplace;
        message.marketplace = (_marketplace = object.marketplace) !== null && _marketplace !== void 0 ? _marketplace : false;
        var _expAug2019CepPilot;
        message.expAug2019CepPilot = (_expAug2019CepPilot = object.expAug2019CepPilot) !== null && _expAug2019CepPilot !== void 0 ? _expAug2019CepPilot : false;
        var _opendoorDirectAutomatedOffer;
        message.opendoorDirectAutomatedOffer = (_opendoorDirectAutomatedOffer = object.opendoorDirectAutomatedOffer) !== null && _opendoorDirectAutomatedOffer !== void 0 ? _opendoorDirectAutomatedOffer : false;
        return message;
    }
};
function createBaseOfferPolicy() {
    return {
        tradeInShowOnClosingDash: false,
        tradeInShowOnOfferPage: false,
        expAug2019TradeInRefreshed: false
    };
}
var OfferPolicy = {
    fromJSON: function fromJSON(object) {
        return {
            tradeInShowOnClosingDash: policy_isSet(object.tradeInShowOnClosingDash) ? Boolean(object.tradeInShowOnClosingDash) : false,
            tradeInShowOnOfferPage: policy_isSet(object.tradeInShowOnOfferPage) ? Boolean(object.tradeInShowOnOfferPage) : false,
            expAug2019TradeInRefreshed: policy_isSet(object.expAug2019TradeInRefreshed) ? Boolean(object.expAug2019TradeInRefreshed) : false
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.tradeInShowOnClosingDash === true) {
            obj.tradeInShowOnClosingDash = message.tradeInShowOnClosingDash;
        }
        if (message.tradeInShowOnOfferPage === true) {
            obj.tradeInShowOnOfferPage = message.tradeInShowOnOfferPage;
        }
        if (message.expAug2019TradeInRefreshed === true) {
            obj.expAug2019TradeInRefreshed = message.expAug2019TradeInRefreshed;
        }
        return obj;
    },
    create: function create(base) {
        return OfferPolicy.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseOfferPolicy();
        var _tradeInShowOnClosingDash;
        message.tradeInShowOnClosingDash = (_tradeInShowOnClosingDash = object.tradeInShowOnClosingDash) !== null && _tradeInShowOnClosingDash !== void 0 ? _tradeInShowOnClosingDash : false;
        var _tradeInShowOnOfferPage;
        message.tradeInShowOnOfferPage = (_tradeInShowOnOfferPage = object.tradeInShowOnOfferPage) !== null && _tradeInShowOnOfferPage !== void 0 ? _tradeInShowOnOfferPage : false;
        var _expAug2019TradeInRefreshed;
        message.expAug2019TradeInRefreshed = (_expAug2019TradeInRefreshed = object.expAug2019TradeInRefreshed) !== null && _expAug2019TradeInRefreshed !== void 0 ? _expAug2019TradeInRefreshed : false;
        return message;
    }
};
function policy_isSet(value) {
    return value !== null && value !== undefined;
}

;// CONCATENATED MODULE: ./src/__generated__/protobuf/sell/seller/data/seller_details.ts
/* eslint-disable */ 



var seller_details_protobufPackage = "od_protos.sell.seller.data";
function createBaseSellerDetails() {
    return {
        agent: false,
        listed: false,
        tradeIn: false,
        tradeInBundle: false,
        isTradeInDashboard: false,
        offerDashboardVisited: false,
        activelyLooking: false,
        channel: 0,
        partnership: 0,
        timeline: 0,
        priceEstimateCents: 0,
        photoIds: [],
        referrerContactId: "",
        offerDeliveryTime: undefined,
        annualIncomeCents: 0,
        downPaymentCents: 0,
        monthlyDebtsCents: 0,
        creditScoreRange: undefined,
        goalPriceCents: 0,
        hasVisitedHub: false,
        eligibleForRoamAssumableLoan: false,
        roamAssumableLoanDetails: undefined
    };
}
var SellerDetails = {
    fromJSON: function fromJSON(object) {
        return {
            agent: seller_details_isSet(object.agent) ? Boolean(object.agent) : false,
            listed: seller_details_isSet(object.listed) ? Boolean(object.listed) : false,
            tradeIn: seller_details_isSet(object.trade_in) ? Boolean(object.trade_in) : false,
            tradeInBundle: seller_details_isSet(object.trade_in_bundle) ? Boolean(object.trade_in_bundle) : false,
            isTradeInDashboard: seller_details_isSet(object.is_trade_in_dashboard) ? Boolean(object.is_trade_in_dashboard) : false,
            offerDashboardVisited: seller_details_isSet(object.offer_dashboard_visited) ? Boolean(object.offer_dashboard_visited) : false,
            activelyLooking: seller_details_isSet(object.actively_looking) ? Boolean(object.actively_looking) : false,
            channel: seller_details_isSet(object.channel) ? marketingChannelFromJSON(object.channel) : 0,
            partnership: seller_details_isSet(object.partnership) ? partnershipFromJSON(object.partnership) : 0,
            timeline: seller_details_isSet(object.timeline) ? timelineFromJSON(object.timeline) : 0,
            priceEstimateCents: seller_details_isSet(object.price_estimate_cents) ? Number(object.price_estimate_cents) : 0,
            photoIds: Array.isArray(object === null || object === void 0 ? void 0 : object.photo_ids) ? object.photo_ids.map(function(e) {
                return String(e);
            }) : [],
            referrerContactId: seller_details_isSet(object.referrer_contact_id) ? String(object.referrer_contact_id) : "",
            offerDeliveryTime: seller_details_isSet(object.offer_delivery_time) ? seller_details_fromJsonTimestamp(object.offer_delivery_time) : undefined,
            annualIncomeCents: seller_details_isSet(object.annual_income_cents) ? Number(object.annual_income_cents) : 0,
            downPaymentCents: seller_details_isSet(object.down_payment_cents) ? Number(object.down_payment_cents) : 0,
            monthlyDebtsCents: seller_details_isSet(object.monthly_debts_cents) ? Number(object.monthly_debts_cents) : 0,
            creditScoreRange: seller_details_isSet(object.credit_score_range) ? CreditRange.fromJSON(object.credit_score_range) : undefined,
            goalPriceCents: seller_details_isSet(object.goal_price_cents) ? Number(object.goal_price_cents) : 0,
            hasVisitedHub: seller_details_isSet(object.has_visited_hub) ? Boolean(object.has_visited_hub) : false,
            eligibleForRoamAssumableLoan: seller_details_isSet(object.eligible_for_roam_assumable_loan) ? Boolean(object.eligible_for_roam_assumable_loan) : false,
            roamAssumableLoanDetails: seller_details_isSet(object.roam_assumable_loan_details) ? LoanDetails.fromJSON(object.roam_assumable_loan_details) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var ref;
        var obj = {};
        if (message.agent === true) {
            obj.agent = message.agent;
        }
        if (message.listed === true) {
            obj.listed = message.listed;
        }
        if (message.tradeIn === true) {
            obj.trade_in = message.tradeIn;
        }
        if (message.tradeInBundle === true) {
            obj.trade_in_bundle = message.tradeInBundle;
        }
        if (message.isTradeInDashboard === true) {
            obj.is_trade_in_dashboard = message.isTradeInDashboard;
        }
        if (message.offerDashboardVisited === true) {
            obj.offer_dashboard_visited = message.offerDashboardVisited;
        }
        if (message.activelyLooking === true) {
            obj.actively_looking = message.activelyLooking;
        }
        if (message.channel !== 0) {
            obj.channel = marketingChannelToJSON(message.channel);
        }
        if (message.partnership !== 0) {
            obj.partnership = partnershipToJSON(message.partnership);
        }
        if (message.timeline !== 0) {
            obj.timeline = timelineToJSON(message.timeline);
        }
        if (message.priceEstimateCents !== 0) {
            obj.price_estimate_cents = Math.round(message.priceEstimateCents);
        }
        if ((ref = message.photoIds) === null || ref === void 0 ? void 0 : ref.length) {
            obj.photo_ids = message.photoIds;
        }
        if (message.referrerContactId !== "") {
            obj.referrer_contact_id = message.referrerContactId;
        }
        if (message.offerDeliveryTime !== undefined) {
            obj.offer_delivery_time = message.offerDeliveryTime.toISOString();
        }
        if (message.annualIncomeCents !== 0) {
            obj.annual_income_cents = Math.round(message.annualIncomeCents);
        }
        if (message.downPaymentCents !== 0) {
            obj.down_payment_cents = Math.round(message.downPaymentCents);
        }
        if (message.monthlyDebtsCents !== 0) {
            obj.monthly_debts_cents = Math.round(message.monthlyDebtsCents);
        }
        if (message.creditScoreRange !== undefined) {
            obj.credit_score_range = CreditRange.toJSON(message.creditScoreRange);
        }
        if (message.goalPriceCents !== 0) {
            obj.goal_price_cents = Math.round(message.goalPriceCents);
        }
        if (message.hasVisitedHub === true) {
            obj.has_visited_hub = message.hasVisitedHub;
        }
        if (message.eligibleForRoamAssumableLoan === true) {
            obj.eligible_for_roam_assumable_loan = message.eligibleForRoamAssumableLoan;
        }
        if (message.roamAssumableLoanDetails !== undefined) {
            obj.roam_assumable_loan_details = LoanDetails.toJSON(message.roamAssumableLoanDetails);
        }
        return obj;
    },
    create: function create(base) {
        return SellerDetails.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref;
        var message = createBaseSellerDetails();
        var _agent;
        message.agent = (_agent = object.agent) !== null && _agent !== void 0 ? _agent : false;
        var _listed;
        message.listed = (_listed = object.listed) !== null && _listed !== void 0 ? _listed : false;
        var _tradeIn;
        message.tradeIn = (_tradeIn = object.tradeIn) !== null && _tradeIn !== void 0 ? _tradeIn : false;
        var _tradeInBundle;
        message.tradeInBundle = (_tradeInBundle = object.tradeInBundle) !== null && _tradeInBundle !== void 0 ? _tradeInBundle : false;
        var _isTradeInDashboard;
        message.isTradeInDashboard = (_isTradeInDashboard = object.isTradeInDashboard) !== null && _isTradeInDashboard !== void 0 ? _isTradeInDashboard : false;
        var _offerDashboardVisited;
        message.offerDashboardVisited = (_offerDashboardVisited = object.offerDashboardVisited) !== null && _offerDashboardVisited !== void 0 ? _offerDashboardVisited : false;
        var _activelyLooking;
        message.activelyLooking = (_activelyLooking = object.activelyLooking) !== null && _activelyLooking !== void 0 ? _activelyLooking : false;
        var _channel;
        message.channel = (_channel = object.channel) !== null && _channel !== void 0 ? _channel : 0;
        var _partnership;
        message.partnership = (_partnership = object.partnership) !== null && _partnership !== void 0 ? _partnership : 0;
        var _timeline;
        message.timeline = (_timeline = object.timeline) !== null && _timeline !== void 0 ? _timeline : 0;
        var _priceEstimateCents;
        message.priceEstimateCents = (_priceEstimateCents = object.priceEstimateCents) !== null && _priceEstimateCents !== void 0 ? _priceEstimateCents : 0;
        message.photoIds = ((ref = object.photoIds) === null || ref === void 0 ? void 0 : ref.map(function(e) {
            return e;
        })) || [];
        var _referrerContactId;
        message.referrerContactId = (_referrerContactId = object.referrerContactId) !== null && _referrerContactId !== void 0 ? _referrerContactId : "";
        var _offerDeliveryTime;
        message.offerDeliveryTime = (_offerDeliveryTime = object.offerDeliveryTime) !== null && _offerDeliveryTime !== void 0 ? _offerDeliveryTime : undefined;
        var _annualIncomeCents;
        message.annualIncomeCents = (_annualIncomeCents = object.annualIncomeCents) !== null && _annualIncomeCents !== void 0 ? _annualIncomeCents : 0;
        var _downPaymentCents;
        message.downPaymentCents = (_downPaymentCents = object.downPaymentCents) !== null && _downPaymentCents !== void 0 ? _downPaymentCents : 0;
        var _monthlyDebtsCents;
        message.monthlyDebtsCents = (_monthlyDebtsCents = object.monthlyDebtsCents) !== null && _monthlyDebtsCents !== void 0 ? _monthlyDebtsCents : 0;
        message.creditScoreRange = object.creditScoreRange !== undefined && object.creditScoreRange !== null ? CreditRange.fromPartial(object.creditScoreRange) : undefined;
        var _goalPriceCents;
        message.goalPriceCents = (_goalPriceCents = object.goalPriceCents) !== null && _goalPriceCents !== void 0 ? _goalPriceCents : 0;
        var _hasVisitedHub;
        message.hasVisitedHub = (_hasVisitedHub = object.hasVisitedHub) !== null && _hasVisitedHub !== void 0 ? _hasVisitedHub : false;
        var _eligibleForRoamAssumableLoan;
        message.eligibleForRoamAssumableLoan = (_eligibleForRoamAssumableLoan = object.eligibleForRoamAssumableLoan) !== null && _eligibleForRoamAssumableLoan !== void 0 ? _eligibleForRoamAssumableLoan : false;
        message.roamAssumableLoanDetails = object.roamAssumableLoanDetails !== undefined && object.roamAssumableLoanDetails !== null ? LoanDetails.fromPartial(object.roamAssumableLoanDetails) : undefined;
        return message;
    }
};
function createBaseLoanDetails() {
    return {
        interestRatePercent: undefined,
        loanType: "",
        estimatedBalanceCents: undefined,
        originationDate: undefined
    };
}
var LoanDetails = {
    fromJSON: function fromJSON(object) {
        return {
            interestRatePercent: seller_details_isSet(object.interest_rate_percent) ? Number(object.interest_rate_percent) : undefined,
            loanType: seller_details_isSet(object.loan_type) ? String(object.loan_type) : "",
            estimatedBalanceCents: seller_details_isSet(object.estimated_balance_cents) ? Number(object.estimated_balance_cents) : undefined,
            originationDate: seller_details_isSet(object.origination_date) ? seller_details_fromJsonTimestamp(object.origination_date) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.interestRatePercent !== undefined) {
            obj.interest_rate_percent = message.interestRatePercent;
        }
        if (message.loanType !== "") {
            obj.loan_type = message.loanType;
        }
        if (message.estimatedBalanceCents !== undefined) {
            obj.estimated_balance_cents = message.estimatedBalanceCents;
        }
        if (message.originationDate !== undefined) {
            obj.origination_date = message.originationDate.toISOString();
        }
        return obj;
    },
    create: function create(base) {
        return LoanDetails.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseLoanDetails();
        var _interestRatePercent;
        message.interestRatePercent = (_interestRatePercent = object.interestRatePercent) !== null && _interestRatePercent !== void 0 ? _interestRatePercent : undefined;
        var _loanType;
        message.loanType = (_loanType = object.loanType) !== null && _loanType !== void 0 ? _loanType : "";
        var _estimatedBalanceCents;
        message.estimatedBalanceCents = (_estimatedBalanceCents = object.estimatedBalanceCents) !== null && _estimatedBalanceCents !== void 0 ? _estimatedBalanceCents : undefined;
        var _originationDate;
        message.originationDate = (_originationDate = object.originationDate) !== null && _originationDate !== void 0 ? _originationDate : undefined;
        return message;
    }
};
function createBaseHistoricalSellerDetails() {
    return {
        sellerDetails: undefined,
        updatedByToken: "",
        updatedAt: undefined
    };
}
var HistoricalSellerDetails = {
    fromJSON: function fromJSON(object) {
        return {
            sellerDetails: seller_details_isSet(object.sellerDetails) ? SellerDetails.fromJSON(object.sellerDetails) : undefined,
            updatedByToken: seller_details_isSet(object.updatedByToken) ? String(object.updatedByToken) : "",
            updatedAt: seller_details_isSet(object.updatedAt) ? seller_details_fromJsonTimestamp(object.updatedAt) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.sellerDetails !== undefined) {
            obj.sellerDetails = SellerDetails.toJSON(message.sellerDetails);
        }
        if (message.updatedByToken !== "") {
            obj.updatedByToken = message.updatedByToken;
        }
        if (message.updatedAt !== undefined) {
            obj.updatedAt = message.updatedAt.toISOString();
        }
        return obj;
    },
    create: function create(base) {
        return HistoricalSellerDetails.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseHistoricalSellerDetails();
        message.sellerDetails = object.sellerDetails !== undefined && object.sellerDetails !== null ? SellerDetails.fromPartial(object.sellerDetails) : undefined;
        var _updatedByToken;
        message.updatedByToken = (_updatedByToken = object.updatedByToken) !== null && _updatedByToken !== void 0 ? _updatedByToken : "";
        var _updatedAt;
        message.updatedAt = (_updatedAt = object.updatedAt) !== null && _updatedAt !== void 0 ? _updatedAt : undefined;
        return message;
    }
};
function seller_details_fromTimestamp(t) {
    var millis = (t.seconds || 0) * 1000;
    millis += (t.nanos || 0) / 1000000;
    return new Date(millis);
}
function seller_details_fromJsonTimestamp(o) {
    if ((0,_instanceof/* default */.Z)(o, Date)) {
        return o;
    } else if (typeof o === "string") {
        return new Date(o);
    } else {
        return seller_details_fromTimestamp(Timestamp.fromJSON(o));
    }
}
function seller_details_isSet(value) {
    return value !== null && value !== undefined;
}

;// CONCATENATED MODULE: ./src/__generated__/protobuf/sell/seller/data/lead.ts
/* eslint-disable */ 






var lead_protobufPackage = "od_protos.sell.seller.data";
var AcquisitionState;
(function(AcquisitionState) {
    AcquisitionState[AcquisitionState["ACQUISITION_STATE_UNKNOWN"] = 0] = "ACQUISITION_STATE_UNKNOWN";
    AcquisitionState[AcquisitionState["ACQUISITION_STATE_QUALIFIED"] = 1] = "ACQUISITION_STATE_QUALIFIED";
    AcquisitionState[AcquisitionState["ACQUISITION_STATE_DENIED"] = 2] = "ACQUISITION_STATE_DENIED";
    AcquisitionState[AcquisitionState["ACQUISITION_STATE_UNDERWRITING_WALK"] = 3] = "ACQUISITION_STATE_UNDERWRITING_WALK";
    AcquisitionState[AcquisitionState["ACQUISITION_STATE_OTHER_WALK"] = 4] = "ACQUISITION_STATE_OTHER_WALK";
    AcquisitionState[AcquisitionState["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(AcquisitionState || (AcquisitionState = {}));
function acquisitionStateFromJSON(object) {
    switch(object){
        case 0:
        case "ACQUISITION_STATE_UNKNOWN":
            return AcquisitionState.ACQUISITION_STATE_UNKNOWN;
        case 1:
        case "ACQUISITION_STATE_QUALIFIED":
            return AcquisitionState.ACQUISITION_STATE_QUALIFIED;
        case 2:
        case "ACQUISITION_STATE_DENIED":
            return AcquisitionState.ACQUISITION_STATE_DENIED;
        case 3:
        case "ACQUISITION_STATE_UNDERWRITING_WALK":
            return AcquisitionState.ACQUISITION_STATE_UNDERWRITING_WALK;
        case 4:
        case "ACQUISITION_STATE_OTHER_WALK":
            return AcquisitionState.ACQUISITION_STATE_OTHER_WALK;
        case -1:
        case "UNRECOGNIZED":
        default:
            return AcquisitionState.UNRECOGNIZED;
    }
}
function acquisitionStateToJSON(object) {
    switch(object){
        case AcquisitionState.ACQUISITION_STATE_UNKNOWN:
            return "ACQUISITION_STATE_UNKNOWN";
        case AcquisitionState.ACQUISITION_STATE_QUALIFIED:
            return "ACQUISITION_STATE_QUALIFIED";
        case AcquisitionState.ACQUISITION_STATE_DENIED:
            return "ACQUISITION_STATE_DENIED";
        case AcquisitionState.ACQUISITION_STATE_UNDERWRITING_WALK:
            return "ACQUISITION_STATE_UNDERWRITING_WALK";
        case AcquisitionState.ACQUISITION_STATE_OTHER_WALK:
            return "ACQUISITION_STATE_OTHER_WALK";
        case AcquisitionState.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var Lead_Source_Type;
(function(Lead_Source_Type) {
    Lead_Source_Type[Lead_Source_Type["UNKNOWN_TYPE"] = 0] = "UNKNOWN_TYPE";
    Lead_Source_Type[Lead_Source_Type["RECEPTION"] = 1] = "RECEPTION";
    Lead_Source_Type[Lead_Source_Type["PARTNERSHIP"] = 2] = "PARTNERSHIP";
    Lead_Source_Type[Lead_Source_Type["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Lead_Source_Type || (Lead_Source_Type = {}));
function lead_Source_TypeFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN_TYPE":
            return Lead_Source_Type.UNKNOWN_TYPE;
        case 1:
        case "RECEPTION":
            return Lead_Source_Type.RECEPTION;
        case 2:
        case "PARTNERSHIP":
            return Lead_Source_Type.PARTNERSHIP;
        case -1:
        case "UNRECOGNIZED":
        default:
            return Lead_Source_Type.UNRECOGNIZED;
    }
}
function lead_Source_TypeToJSON(object) {
    switch(object){
        case Lead_Source_Type.UNKNOWN_TYPE:
            return "UNKNOWN_TYPE";
        case Lead_Source_Type.RECEPTION:
            return "RECEPTION";
        case Lead_Source_Type.PARTNERSHIP:
            return "PARTNERSHIP";
        case Lead_Source_Type.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var ProductOffering_State;
(function(ProductOffering_State) {
    ProductOffering_State[ProductOffering_State["UNKNOWN_STATE"] = 0] = "UNKNOWN_STATE";
    ProductOffering_State[ProductOffering_State["QUALIFIED"] = 1] = "QUALIFIED";
    ProductOffering_State[ProductOffering_State["DENIED"] = 2] = "DENIED";
    ProductOffering_State[ProductOffering_State["WITHDRAWN"] = 3] = "WITHDRAWN";
    ProductOffering_State[ProductOffering_State["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ProductOffering_State || (ProductOffering_State = {}));
function productOffering_StateFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN_STATE":
            return ProductOffering_State.UNKNOWN_STATE;
        case 1:
        case "QUALIFIED":
            return ProductOffering_State.QUALIFIED;
        case 2:
        case "DENIED":
            return ProductOffering_State.DENIED;
        case 3:
        case "WITHDRAWN":
            return ProductOffering_State.WITHDRAWN;
        case -1:
        case "UNRECOGNIZED":
        default:
            return ProductOffering_State.UNRECOGNIZED;
    }
}
function productOffering_StateToJSON(object) {
    switch(object){
        case ProductOffering_State.UNKNOWN_STATE:
            return "UNKNOWN_STATE";
        case ProductOffering_State.QUALIFIED:
            return "QUALIFIED";
        case ProductOffering_State.DENIED:
            return "DENIED";
        case ProductOffering_State.WITHDRAWN:
            return "WITHDRAWN";
        case ProductOffering_State.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var ProductOffering_InterestLevel;
(function(ProductOffering_InterestLevel) {
    ProductOffering_InterestLevel[ProductOffering_InterestLevel["UNKNOWN_INTEREST_LEVEL"] = 0] = "UNKNOWN_INTEREST_LEVEL";
    ProductOffering_InterestLevel[ProductOffering_InterestLevel["NOT_INTERESTED"] = 1] = "NOT_INTERESTED";
    ProductOffering_InterestLevel[ProductOffering_InterestLevel["INTERESTED"] = 2] = "INTERESTED";
    ProductOffering_InterestLevel[ProductOffering_InterestLevel["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ProductOffering_InterestLevel || (ProductOffering_InterestLevel = {}));
function productOffering_InterestLevelFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN_INTEREST_LEVEL":
            return ProductOffering_InterestLevel.UNKNOWN_INTEREST_LEVEL;
        case 1:
        case "NOT_INTERESTED":
            return ProductOffering_InterestLevel.NOT_INTERESTED;
        case 2:
        case "INTERESTED":
            return ProductOffering_InterestLevel.INTERESTED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return ProductOffering_InterestLevel.UNRECOGNIZED;
    }
}
function productOffering_InterestLevelToJSON(object) {
    switch(object){
        case ProductOffering_InterestLevel.UNKNOWN_INTEREST_LEVEL:
            return "UNKNOWN_INTEREST_LEVEL";
        case ProductOffering_InterestLevel.NOT_INTERESTED:
            return "NOT_INTERESTED";
        case ProductOffering_InterestLevel.INTERESTED:
            return "INTERESTED";
        case ProductOffering_InterestLevel.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
function createBaseLead() {
    return {
        id: "",
        addressId: "",
        customerId: "",
        customerUuid: "",
        userIds: [],
        sellRequestId: "",
        homeAdviserId: "",
        closingManagerId: "",
        brokerageId: "",
        brokerId: "",
        homeDetailId: "",
        region: "",
        productOfferings: [],
        createdAt: undefined,
        offerReview: undefined,
        policy: undefined,
        sellerDetails: undefined,
        source: undefined,
        experimentEntityId: "",
        decisionCallAt: undefined,
        channel: 0,
        refreshRequestedAt: undefined,
        answersJson: "",
        selectedProduct: 0
    };
}
var Lead = {
    fromJSON: function fromJSON(object) {
        return {
            id: lead_isSet(object.id) ? String(object.id) : "",
            addressId: lead_isSet(object.addressId) ? String(object.addressId) : "",
            customerId: lead_isSet(object.customerId) ? String(object.customerId) : "",
            customerUuid: lead_isSet(object.customerUuid) ? String(object.customerUuid) : "",
            userIds: Array.isArray(object === null || object === void 0 ? void 0 : object.userIds) ? object.userIds.map(function(e) {
                return String(e);
            }) : [],
            sellRequestId: lead_isSet(object.sellRequestId) ? String(object.sellRequestId) : "",
            homeAdviserId: lead_isSet(object.homeAdviserId) ? String(object.homeAdviserId) : "",
            closingManagerId: lead_isSet(object.closingManagerId) ? String(object.closingManagerId) : "",
            brokerageId: lead_isSet(object.brokerageId) ? String(object.brokerageId) : "",
            brokerId: lead_isSet(object.brokerId) ? String(object.brokerId) : "",
            homeDetailId: lead_isSet(object.homeDetailId) ? String(object.homeDetailId) : "",
            region: lead_isSet(object.region) ? String(object.region) : "",
            productOfferings: Array.isArray(object === null || object === void 0 ? void 0 : object.productOfferings) ? object.productOfferings.map(function(e) {
                return lead_ProductOffering.fromJSON(e);
            }) : [],
            createdAt: lead_isSet(object.createdAt) ? lead_fromJsonTimestamp(object.createdAt) : undefined,
            offerReview: lead_isSet(object.offerReview) ? OfferReview.fromJSON(object.offerReview) : undefined,
            policy: lead_isSet(object.policy) ? Policy.fromJSON(object.policy) : undefined,
            sellerDetails: lead_isSet(object.sellerDetails) ? SellerDetails.fromJSON(object.sellerDetails) : undefined,
            source: lead_isSet(object.source) ? Lead_Source.fromJSON(object.source) : undefined,
            experimentEntityId: lead_isSet(object.experimentEntityId) ? String(object.experimentEntityId) : "",
            decisionCallAt: lead_isSet(object.decisionCallAt) ? lead_fromJsonTimestamp(object.decisionCallAt) : undefined,
            channel: lead_isSet(object.channel) ? sellerInput_ChannelFromJSON(object.channel) : 0,
            refreshRequestedAt: lead_isSet(object.refreshRequestedAt) ? lead_fromJsonTimestamp(object.refreshRequestedAt) : undefined,
            answersJson: lead_isSet(object.answersJson) ? String(object.answersJson) : "",
            selectedProduct: lead_isSet(object.selectedProduct) ? productFromJSON(object.selectedProduct) : 0
        };
    },
    toJSON: function toJSON(message) {
        var ref, ref1;
        var obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.addressId !== "") {
            obj.addressId = message.addressId;
        }
        if (message.customerId !== "") {
            obj.customerId = message.customerId;
        }
        if (message.customerUuid !== "") {
            obj.customerUuid = message.customerUuid;
        }
        if ((ref = message.userIds) === null || ref === void 0 ? void 0 : ref.length) {
            obj.userIds = message.userIds;
        }
        if (message.sellRequestId !== "") {
            obj.sellRequestId = message.sellRequestId;
        }
        if (message.homeAdviserId !== "") {
            obj.homeAdviserId = message.homeAdviserId;
        }
        if (message.closingManagerId !== "") {
            obj.closingManagerId = message.closingManagerId;
        }
        if (message.brokerageId !== "") {
            obj.brokerageId = message.brokerageId;
        }
        if (message.brokerId !== "") {
            obj.brokerId = message.brokerId;
        }
        if (message.homeDetailId !== "") {
            obj.homeDetailId = message.homeDetailId;
        }
        if (message.region !== "") {
            obj.region = message.region;
        }
        if ((ref1 = message.productOfferings) === null || ref1 === void 0 ? void 0 : ref1.length) {
            obj.productOfferings = message.productOfferings.map(function(e) {
                return lead_ProductOffering.toJSON(e);
            });
        }
        if (message.createdAt !== undefined) {
            obj.createdAt = message.createdAt.toISOString();
        }
        if (message.offerReview !== undefined) {
            obj.offerReview = OfferReview.toJSON(message.offerReview);
        }
        if (message.policy !== undefined) {
            obj.policy = Policy.toJSON(message.policy);
        }
        if (message.sellerDetails !== undefined) {
            obj.sellerDetails = SellerDetails.toJSON(message.sellerDetails);
        }
        if (message.source !== undefined) {
            obj.source = Lead_Source.toJSON(message.source);
        }
        if (message.experimentEntityId !== "") {
            obj.experimentEntityId = message.experimentEntityId;
        }
        if (message.decisionCallAt !== undefined) {
            obj.decisionCallAt = message.decisionCallAt.toISOString();
        }
        if (message.channel !== 0) {
            obj.channel = sellerInput_ChannelToJSON(message.channel);
        }
        if (message.refreshRequestedAt !== undefined) {
            obj.refreshRequestedAt = message.refreshRequestedAt.toISOString();
        }
        if (message.answersJson !== "") {
            obj.answersJson = message.answersJson;
        }
        if (message.selectedProduct !== 0) {
            obj.selectedProduct = productToJSON(message.selectedProduct);
        }
        return obj;
    },
    create: function create(base) {
        return Lead.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref, ref1;
        var message = createBaseLead();
        var _id;
        message.id = (_id = object.id) !== null && _id !== void 0 ? _id : "";
        var _addressId;
        message.addressId = (_addressId = object.addressId) !== null && _addressId !== void 0 ? _addressId : "";
        var _customerId;
        message.customerId = (_customerId = object.customerId) !== null && _customerId !== void 0 ? _customerId : "";
        var _customerUuid;
        message.customerUuid = (_customerUuid = object.customerUuid) !== null && _customerUuid !== void 0 ? _customerUuid : "";
        message.userIds = ((ref = object.userIds) === null || ref === void 0 ? void 0 : ref.map(function(e) {
            return e;
        })) || [];
        var _sellRequestId;
        message.sellRequestId = (_sellRequestId = object.sellRequestId) !== null && _sellRequestId !== void 0 ? _sellRequestId : "";
        var _homeAdviserId;
        message.homeAdviserId = (_homeAdviserId = object.homeAdviserId) !== null && _homeAdviserId !== void 0 ? _homeAdviserId : "";
        var _closingManagerId;
        message.closingManagerId = (_closingManagerId = object.closingManagerId) !== null && _closingManagerId !== void 0 ? _closingManagerId : "";
        var _brokerageId;
        message.brokerageId = (_brokerageId = object.brokerageId) !== null && _brokerageId !== void 0 ? _brokerageId : "";
        var _brokerId;
        message.brokerId = (_brokerId = object.brokerId) !== null && _brokerId !== void 0 ? _brokerId : "";
        var _homeDetailId;
        message.homeDetailId = (_homeDetailId = object.homeDetailId) !== null && _homeDetailId !== void 0 ? _homeDetailId : "";
        var _region;
        message.region = (_region = object.region) !== null && _region !== void 0 ? _region : "";
        message.productOfferings = ((ref1 = object.productOfferings) === null || ref1 === void 0 ? void 0 : ref1.map(function(e) {
            return lead_ProductOffering.fromPartial(e);
        })) || [];
        var _createdAt;
        message.createdAt = (_createdAt = object.createdAt) !== null && _createdAt !== void 0 ? _createdAt : undefined;
        message.offerReview = object.offerReview !== undefined && object.offerReview !== null ? OfferReview.fromPartial(object.offerReview) : undefined;
        message.policy = object.policy !== undefined && object.policy !== null ? Policy.fromPartial(object.policy) : undefined;
        message.sellerDetails = object.sellerDetails !== undefined && object.sellerDetails !== null ? SellerDetails.fromPartial(object.sellerDetails) : undefined;
        message.source = object.source !== undefined && object.source !== null ? Lead_Source.fromPartial(object.source) : undefined;
        var _experimentEntityId;
        message.experimentEntityId = (_experimentEntityId = object.experimentEntityId) !== null && _experimentEntityId !== void 0 ? _experimentEntityId : "";
        var _decisionCallAt;
        message.decisionCallAt = (_decisionCallAt = object.decisionCallAt) !== null && _decisionCallAt !== void 0 ? _decisionCallAt : undefined;
        var _channel;
        message.channel = (_channel = object.channel) !== null && _channel !== void 0 ? _channel : 0;
        var _refreshRequestedAt;
        message.refreshRequestedAt = (_refreshRequestedAt = object.refreshRequestedAt) !== null && _refreshRequestedAt !== void 0 ? _refreshRequestedAt : undefined;
        var _answersJson;
        message.answersJson = (_answersJson = object.answersJson) !== null && _answersJson !== void 0 ? _answersJson : "";
        var _selectedProduct;
        message.selectedProduct = (_selectedProduct = object.selectedProduct) !== null && _selectedProduct !== void 0 ? _selectedProduct : 0;
        return message;
    }
};
function createBaseLead_Source() {
    return {
        type: 0,
        id: ""
    };
}
var Lead_Source = {
    fromJSON: function fromJSON(object) {
        return {
            type: lead_isSet(object.type) ? lead_Source_TypeFromJSON(object.type) : 0,
            id: lead_isSet(object.id) ? String(object.id) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.type !== 0) {
            obj.type = lead_Source_TypeToJSON(message.type);
        }
        if (message.id !== "") {
            obj.id = message.id;
        }
        return obj;
    },
    create: function create(base) {
        return Lead_Source.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseLead_Source();
        var _type;
        message.type = (_type = object.type) !== null && _type !== void 0 ? _type : 0;
        var _id;
        message.id = (_id = object.id) !== null && _id !== void 0 ? _id : "";
        return message;
    }
};
function createBaseOfferReview() {
    return {
        id: "",
        startTime: undefined,
        endTime: undefined,
        calendlyInviteeUuid: ""
    };
}
var OfferReview = {
    fromJSON: function fromJSON(object) {
        return {
            id: lead_isSet(object.id) ? String(object.id) : "",
            startTime: lead_isSet(object.startTime) ? lead_fromJsonTimestamp(object.startTime) : undefined,
            endTime: lead_isSet(object.endTime) ? lead_fromJsonTimestamp(object.endTime) : undefined,
            calendlyInviteeUuid: lead_isSet(object.calendlyInviteeUuid) ? String(object.calendlyInviteeUuid) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.startTime !== undefined) {
            obj.startTime = message.startTime.toISOString();
        }
        if (message.endTime !== undefined) {
            obj.endTime = message.endTime.toISOString();
        }
        if (message.calendlyInviteeUuid !== "") {
            obj.calendlyInviteeUuid = message.calendlyInviteeUuid;
        }
        return obj;
    },
    create: function create(base) {
        return OfferReview.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseOfferReview();
        var _id;
        message.id = (_id = object.id) !== null && _id !== void 0 ? _id : "";
        var _startTime;
        message.startTime = (_startTime = object.startTime) !== null && _startTime !== void 0 ? _startTime : undefined;
        var _endTime;
        message.endTime = (_endTime = object.endTime) !== null && _endTime !== void 0 ? _endTime : undefined;
        var _calendlyInviteeUuid;
        message.calendlyInviteeUuid = (_calendlyInviteeUuid = object.calendlyInviteeUuid) !== null && _calendlyInviteeUuid !== void 0 ? _calendlyInviteeUuid : "";
        return message;
    }
};
function lead_createBaseProductOffering() {
    return {
        product: 0,
        state: 0,
        denialReason: 0,
        denialNotes: "",
        deniedBy: "",
        deniedAt: undefined,
        initialQualifiedAt: undefined,
        interestLevel: 0,
        opendoorWalkReason: 0,
        sellerWalkReason: 0
    };
}
var lead_ProductOffering = {
    fromJSON: function fromJSON(object) {
        return {
            product: lead_isSet(object.product) ? productFromJSON(object.product) : 0,
            state: lead_isSet(object.state) ? productOffering_StateFromJSON(object.state) : 0,
            denialReason: lead_isSet(object.denialReason) ? denialReasonFromJSON(object.denialReason) : 0,
            denialNotes: lead_isSet(object.denialNotes) ? String(object.denialNotes) : "",
            deniedBy: lead_isSet(object.deniedBy) ? String(object.deniedBy) : "",
            deniedAt: lead_isSet(object.deniedAt) ? lead_fromJsonTimestamp(object.deniedAt) : undefined,
            initialQualifiedAt: lead_isSet(object.initialQualifiedAt) ? lead_fromJsonTimestamp(object.initialQualifiedAt) : undefined,
            interestLevel: lead_isSet(object.interestLevel) ? productOffering_InterestLevelFromJSON(object.interestLevel) : 0,
            opendoorWalkReason: lead_isSet(object.opendoorWalkReason) ? opendoorWalkReasonFromJSON(object.opendoorWalkReason) : 0,
            sellerWalkReason: lead_isSet(object.sellerWalkReason) ? sellerWalkReasonFromJSON(object.sellerWalkReason) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.product !== 0) {
            obj.product = productToJSON(message.product);
        }
        if (message.state !== 0) {
            obj.state = productOffering_StateToJSON(message.state);
        }
        if (message.denialReason !== 0) {
            obj.denialReason = denialReasonToJSON(message.denialReason);
        }
        if (message.denialNotes !== "") {
            obj.denialNotes = message.denialNotes;
        }
        if (message.deniedBy !== "") {
            obj.deniedBy = message.deniedBy;
        }
        if (message.deniedAt !== undefined) {
            obj.deniedAt = message.deniedAt.toISOString();
        }
        if (message.initialQualifiedAt !== undefined) {
            obj.initialQualifiedAt = message.initialQualifiedAt.toISOString();
        }
        if (message.interestLevel !== 0) {
            obj.interestLevel = productOffering_InterestLevelToJSON(message.interestLevel);
        }
        if (message.opendoorWalkReason !== 0) {
            obj.opendoorWalkReason = opendoorWalkReasonToJSON(message.opendoorWalkReason);
        }
        if (message.sellerWalkReason !== 0) {
            obj.sellerWalkReason = sellerWalkReasonToJSON(message.sellerWalkReason);
        }
        return obj;
    },
    create: function create(base) {
        return lead_ProductOffering.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = lead_createBaseProductOffering();
        var _product;
        message.product = (_product = object.product) !== null && _product !== void 0 ? _product : 0;
        var _state;
        message.state = (_state = object.state) !== null && _state !== void 0 ? _state : 0;
        var _denialReason;
        message.denialReason = (_denialReason = object.denialReason) !== null && _denialReason !== void 0 ? _denialReason : 0;
        var _denialNotes;
        message.denialNotes = (_denialNotes = object.denialNotes) !== null && _denialNotes !== void 0 ? _denialNotes : "";
        var _deniedBy;
        message.deniedBy = (_deniedBy = object.deniedBy) !== null && _deniedBy !== void 0 ? _deniedBy : "";
        var _deniedAt;
        message.deniedAt = (_deniedAt = object.deniedAt) !== null && _deniedAt !== void 0 ? _deniedAt : undefined;
        var _initialQualifiedAt;
        message.initialQualifiedAt = (_initialQualifiedAt = object.initialQualifiedAt) !== null && _initialQualifiedAt !== void 0 ? _initialQualifiedAt : undefined;
        var _interestLevel;
        message.interestLevel = (_interestLevel = object.interestLevel) !== null && _interestLevel !== void 0 ? _interestLevel : 0;
        var _opendoorWalkReason;
        message.opendoorWalkReason = (_opendoorWalkReason = object.opendoorWalkReason) !== null && _opendoorWalkReason !== void 0 ? _opendoorWalkReason : 0;
        var _sellerWalkReason;
        message.sellerWalkReason = (_sellerWalkReason = object.sellerWalkReason) !== null && _sellerWalkReason !== void 0 ? _sellerWalkReason : 0;
        return message;
    }
};
function createBaseLeadId() {
    return {
        lead: undefined
    };
}
var LeadId = {
    fromJSON: function fromJSON(object) {
        return {
            lead: lead_isSet(object.leadId) ? {
                $case: "leadId",
                leadId: String(object.leadId)
            } : lead_isSet(object.source) ? {
                $case: "source",
                source: Lead_Source.fromJSON(object.source)
            } : undefined
        };
    },
    toJSON: function toJSON(message) {
        var ref, ref1;
        var obj = {};
        if (((ref = message.lead) === null || ref === void 0 ? void 0 : ref.$case) === "leadId") {
            obj.leadId = message.lead.leadId;
        }
        if (((ref1 = message.lead) === null || ref1 === void 0 ? void 0 : ref1.$case) === "source") {
            obj.source = Lead_Source.toJSON(message.lead.source);
        }
        return obj;
    },
    create: function create(base) {
        return LeadId.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref, ref1, ref2, ref3, ref4, ref5;
        var message = createBaseLeadId();
        if (((ref = object.lead) === null || ref === void 0 ? void 0 : ref.$case) === "leadId" && ((ref1 = object.lead) === null || ref1 === void 0 ? void 0 : ref1.leadId) !== undefined && ((ref2 = object.lead) === null || ref2 === void 0 ? void 0 : ref2.leadId) !== null) {
            message.lead = {
                $case: "leadId",
                leadId: object.lead.leadId
            };
        }
        if (((ref3 = object.lead) === null || ref3 === void 0 ? void 0 : ref3.$case) === "source" && ((ref4 = object.lead) === null || ref4 === void 0 ? void 0 : ref4.source) !== undefined && ((ref5 = object.lead) === null || ref5 === void 0 ? void 0 : ref5.source) !== null) {
            message.lead = {
                $case: "source",
                source: Lead_Source.fromPartial(object.lead.source)
            };
        }
        return message;
    }
};
function lead_fromTimestamp(t) {
    var millis = (t.seconds || 0) * 1000;
    millis += (t.nanos || 0) / 1000000;
    return new Date(millis);
}
function lead_fromJsonTimestamp(o) {
    if ((0,_instanceof/* default */.Z)(o, Date)) {
        return o;
    } else if (typeof o === "string") {
        return new Date(o);
    } else {
        return lead_fromTimestamp(Timestamp.fromJSON(o));
    }
}
function lead_isSet(value) {
    return value !== null && value !== undefined;
}

;// CONCATENATED MODULE: ./src/__generated__/protobuf/sell/seller/data/list_with_opendoor.ts
/* eslint-disable */ var list_with_opendoor_protobufPackage = "od_protos.sell.seller.data";
var HomeReserveMetadata_HomeReserveAttributionSource;
(function(HomeReserveMetadata_HomeReserveAttributionSource) {
    HomeReserveMetadata_HomeReserveAttributionSource[HomeReserveMetadata_HomeReserveAttributionSource[/** @deprecated */ "UNKNOWN"] = 0] = "UNKNOWN";
    HomeReserveMetadata_HomeReserveAttributionSource[HomeReserveMetadata_HomeReserveAttributionSource[/**
   * SELLER_FLOW - The seller became eligible for Home Reserve by answering questions in the seller flow
   *
   * @deprecated
   */ "SELLER_FLOW"] = 1] = "SELLER_FLOW";
    HomeReserveMetadata_HomeReserveAttributionSource[HomeReserveMetadata_HomeReserveAttributionSource[/**
   * OFFER_REVIEW_DISPOSITION - The seller became eligible for Home Reserve by an operator submitting offer review notes
   *
   * @deprecated
   */ "OFFER_REVIEW_DISPOSITION"] = 2] = "OFFER_REVIEW_DISPOSITION";
    HomeReserveMetadata_HomeReserveAttributionSource[HomeReserveMetadata_HomeReserveAttributionSource["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(HomeReserveMetadata_HomeReserveAttributionSource || (HomeReserveMetadata_HomeReserveAttributionSource = {}));
function homeReserveMetadata_HomeReserveAttributionSourceFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN":
            return HomeReserveMetadata_HomeReserveAttributionSource.UNKNOWN;
        case 1:
        case "SELLER_FLOW":
            return HomeReserveMetadata_HomeReserveAttributionSource.SELLER_FLOW;
        case 2:
        case "OFFER_REVIEW_DISPOSITION":
            return HomeReserveMetadata_HomeReserveAttributionSource.OFFER_REVIEW_DISPOSITION;
        case -1:
        case "UNRECOGNIZED":
        default:
            return HomeReserveMetadata_HomeReserveAttributionSource.UNRECOGNIZED;
    }
}
function homeReserveMetadata_HomeReserveAttributionSourceToJSON(object) {
    switch(object){
        case HomeReserveMetadata_HomeReserveAttributionSource.UNKNOWN:
            return "UNKNOWN";
        case HomeReserveMetadata_HomeReserveAttributionSource.SELLER_FLOW:
            return "SELLER_FLOW";
        case HomeReserveMetadata_HomeReserveAttributionSource.OFFER_REVIEW_DISPOSITION:
            return "OFFER_REVIEW_DISPOSITION";
        case HomeReserveMetadata_HomeReserveAttributionSource.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
function createBaseListWithOpendoorSpecificData() {
    return {
        minListPriceCents: 0,
        maxListPriceCents: 0,
        isEligibleForHomeReserve: false,
        homeReserveMetadata: undefined,
        isEligibleForUnifiedDenialOpsFlow: false
    };
}
var ListWithOpendoorSpecificData = {
    fromJSON: function fromJSON(object) {
        return {
            minListPriceCents: list_with_opendoor_isSet(object.minListPriceCents) ? Number(object.minListPriceCents) : 0,
            maxListPriceCents: list_with_opendoor_isSet(object.maxListPriceCents) ? Number(object.maxListPriceCents) : 0,
            isEligibleForHomeReserve: list_with_opendoor_isSet(object.isEligibleForHomeReserve) ? Boolean(object.isEligibleForHomeReserve) : false,
            homeReserveMetadata: list_with_opendoor_isSet(object.homeReserveMetadata) ? HomeReserveMetadata.fromJSON(object.homeReserveMetadata) : undefined,
            isEligibleForUnifiedDenialOpsFlow: list_with_opendoor_isSet(object.isEligibleForUnifiedDenialOpsFlow) ? Boolean(object.isEligibleForUnifiedDenialOpsFlow) : false
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.minListPriceCents !== 0) {
            obj.minListPriceCents = Math.round(message.minListPriceCents);
        }
        if (message.maxListPriceCents !== 0) {
            obj.maxListPriceCents = Math.round(message.maxListPriceCents);
        }
        if (message.isEligibleForHomeReserve === true) {
            obj.isEligibleForHomeReserve = message.isEligibleForHomeReserve;
        }
        if (message.homeReserveMetadata !== undefined) {
            obj.homeReserveMetadata = HomeReserveMetadata.toJSON(message.homeReserveMetadata);
        }
        if (message.isEligibleForUnifiedDenialOpsFlow === true) {
            obj.isEligibleForUnifiedDenialOpsFlow = message.isEligibleForUnifiedDenialOpsFlow;
        }
        return obj;
    },
    create: function create(base) {
        return ListWithOpendoorSpecificData.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseListWithOpendoorSpecificData();
        var _minListPriceCents;
        message.minListPriceCents = (_minListPriceCents = object.minListPriceCents) !== null && _minListPriceCents !== void 0 ? _minListPriceCents : 0;
        var _maxListPriceCents;
        message.maxListPriceCents = (_maxListPriceCents = object.maxListPriceCents) !== null && _maxListPriceCents !== void 0 ? _maxListPriceCents : 0;
        var _isEligibleForHomeReserve;
        message.isEligibleForHomeReserve = (_isEligibleForHomeReserve = object.isEligibleForHomeReserve) !== null && _isEligibleForHomeReserve !== void 0 ? _isEligibleForHomeReserve : false;
        message.homeReserveMetadata = object.homeReserveMetadata !== undefined && object.homeReserveMetadata !== null ? HomeReserveMetadata.fromPartial(object.homeReserveMetadata) : undefined;
        var _isEligibleForUnifiedDenialOpsFlow;
        message.isEligibleForUnifiedDenialOpsFlow = (_isEligibleForUnifiedDenialOpsFlow = object.isEligibleForUnifiedDenialOpsFlow) !== null && _isEligibleForUnifiedDenialOpsFlow !== void 0 ? _isEligibleForUnifiedDenialOpsFlow : false;
        return message;
    }
};
function createBaseHomeReserveMetadata() {
    return {
        homeReserveAttributionSource: 0
    };
}
var HomeReserveMetadata = {
    fromJSON: function fromJSON(object) {
        return {
            homeReserveAttributionSource: list_with_opendoor_isSet(object.homeReserveAttributionSource) ? homeReserveMetadata_HomeReserveAttributionSourceFromJSON(object.homeReserveAttributionSource) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.homeReserveAttributionSource !== 0) {
            obj.homeReserveAttributionSource = homeReserveMetadata_HomeReserveAttributionSourceToJSON(message.homeReserveAttributionSource);
        }
        return obj;
    },
    create: function create(base) {
        return HomeReserveMetadata.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseHomeReserveMetadata();
        var _homeReserveAttributionSource;
        message.homeReserveAttributionSource = (_homeReserveAttributionSource = object.homeReserveAttributionSource) !== null && _homeReserveAttributionSource !== void 0 ? _homeReserveAttributionSource : 0;
        return message;
    }
};
function list_with_opendoor_isSet(value) {
    return value !== null && value !== undefined;
}

;// CONCATENATED MODULE: ./src/__generated__/protobuf/common/sell/offer_request.ts
/* eslint-disable */ var offer_request_protobufPackage = "od_protos.common.sell";
var OfferRequest_Source;
(function(OfferRequest_Source) {
    OfferRequest_Source[OfferRequest_Source["UNKNOWN_OFFER_SOURCE"] = 0] = "UNKNOWN_OFFER_SOURCE";
    OfferRequest_Source[OfferRequest_Source["REFRESH_ADMIN"] = 1] = "REFRESH_ADMIN";
    OfferRequest_Source[OfferRequest_Source["REFRESH_OFFER_DASHBOARD"] = 2] = "REFRESH_OFFER_DASHBOARD";
    OfferRequest_Source[OfferRequest_Source["REFRESH_BROKERAGE_OFFER_DASHBOARD"] = 3] = "REFRESH_BROKERAGE_OFFER_DASHBOARD";
    OfferRequest_Source[OfferRequest_Source["REFRESH_SELLER_FEEDBACK"] = 4] = "REFRESH_SELLER_FEEDBACK";
    OfferRequest_Source[OfferRequest_Source["REFRESH_REENGAGEMENT_EMAILS"] = 5] = "REFRESH_REENGAGEMENT_EMAILS";
    OfferRequest_Source[OfferRequest_Source["REFRESH_CORRECTED_SQ_FT_DATA"] = 6] = "REFRESH_CORRECTED_SQ_FT_DATA";
    OfferRequest_Source[OfferRequest_Source["INITIAL_LEAD_FLOW"] = 7] = "INITIAL_LEAD_FLOW";
    OfferRequest_Source[OfferRequest_Source["INCOMPLETE_INITIAL_LEAD_FLOW"] = 8] = "INCOMPLETE_INITIAL_LEAD_FLOW";
    OfferRequest_Source[OfferRequest_Source["OFFER_REENGAGEMENT_CAMPAIGN"] = 9] = "OFFER_REENGAGEMENT_CAMPAIGN";
    OfferRequest_Source[OfferRequest_Source["AUTOMATED_REENGAGEMENT_OFFER"] = 10] = "AUTOMATED_REENGAGEMENT_OFFER";
    OfferRequest_Source[OfferRequest_Source["MOBILE_APP"] = 11] = "MOBILE_APP";
    OfferRequest_Source[OfferRequest_Source["REIT_BULK_REQUEST"] = 12] = "REIT_BULK_REQUEST";
    OfferRequest_Source[OfferRequest_Source["OFFER_REVIEW"] = 13] = "OFFER_REVIEW";
    OfferRequest_Source[OfferRequest_Source[/** FLYWHEEL - FLYWHEEL is used for offer requests on leads from the FLYWHEEL channel */ "FLYWHEEL"] = 14] = "FLYWHEEL";
    OfferRequest_Source[OfferRequest_Source[/** EMAIL_PROSPECTING - EMAIL_PROSPECTING is used for offer requests on leads from the EMAIL_PROSPECTING channel */ "EMAIL_PROSPECTING"] = 15] = "EMAIL_PROSPECTING";
    OfferRequest_Source[OfferRequest_Source[/** OUTBOUND_OFFERS_LISTED - OUTBOUND_OFFERS_LISTED is used for 2020 Hackweek experiment of sending offers to listed homes */ "OUTBOUND_OFFERS_LISTED"] = 16] = "OUTBOUND_OFFERS_LISTED";
    OfferRequest_Source[OfferRequest_Source[/** REFRESH_PARTNER_REFERRAL - REFRESH_PARTNER_REFERRAL is used for offers refreshed from the partnerships referral dashboard */ "REFRESH_PARTNER_REFERRAL"] = 17] = "REFRESH_PARTNER_REFERRAL";
    OfferRequest_Source[OfferRequest_Source[/** HOME_RESERVE - HOME_RESERVE is used for offers requests on leads from the HOME_RESERVE channel */ "HOME_RESERVE"] = 18] = "HOME_RESERVE";
    OfferRequest_Source[OfferRequest_Source[/** HOMEPAGE_RETURN_EXPERIENCE - HOMEPAGE_RETURN_EXPERIENCE is used for offer refreshes that are triggered from the homepage */ "HOMEPAGE_RETURN_EXPERIENCE"] = 19] = "HOMEPAGE_RETURN_EXPERIENCE";
    OfferRequest_Source[OfferRequest_Source[/** REFRESH_HOME_DETAILS - REFRESH_HOME_DETAILS is used for offer refreshes from the offer dashboard home details page */ "REFRESH_HOME_DETAILS"] = 20] = "REFRESH_HOME_DETAILS";
    OfferRequest_Source[OfferRequest_Source[/** REFRESH_FROM_ENG - REFRESH_FROM_ENG is used for backfilling any refresh properties that expierenced a break in flow due to an error */ "REFRESH_FROM_ENG"] = 21] = "REFRESH_FROM_ENG";
    OfferRequest_Source[OfferRequest_Source[/** REFRESH_PARTNER_CTA - REFRESH_PARTNER_CTA is used for offer requests that come from Opendoor partners */ "REFRESH_PARTNER_CTA"] = 22] = "REFRESH_PARTNER_CTA";
    OfferRequest_Source[OfferRequest_Source[/** RETURN_TO_HUB_AUTO_REFRESH - RETURN_TO_HUB_AUTO_REFRESH is used for offer refreshes automatically made when users return to the Hub */ "RETURN_TO_HUB_AUTO_REFRESH"] = 23] = "RETURN_TO_HUB_AUTO_REFRESH";
    OfferRequest_Source[OfferRequest_Source[/** @deprecated */ "EXCLUSIVE_OFFERS"] = 24] = "EXCLUSIVE_OFFERS";
    OfferRequest_Source[OfferRequest_Source["REFRESH_PREVIOUSLY_DENIED"] = 25] = "REFRESH_PREVIOUSLY_DENIED";
    OfferRequest_Source[OfferRequest_Source[/** AUTOMATED_AGENT_REENGAGEMENT_OFFER - AUTOMATED_AGENT_REENGAGEMENT_OFFER is used for agent refreshes triggered via the daily DAG */ "AUTOMATED_AGENT_REENGAGEMENT_OFFER"] = 26] = "AUTOMATED_AGENT_REENGAGEMENT_OFFER";
    OfferRequest_Source[OfferRequest_Source[/**
   * RESTORE_LWOD_LISTING_AGREEMENT_SIGNED - Restore offer because of an LWOD Listing agreement being signed
   *
   * @deprecated
   */ "RESTORE_LWOD_LISTING_AGREEMENT_SIGNED"] = 27] = "RESTORE_LWOD_LISTING_AGREEMENT_SIGNED";
    OfferRequest_Source[OfferRequest_Source["AGENT_LED_OFFER_DROPOUT"] = 28] = "AGENT_LED_OFFER_DROPOUT";
    OfferRequest_Source[OfferRequest_Source["AGENT_LED_OFFERS_REACTIVATE"] = 29] = "AGENT_LED_OFFERS_REACTIVATE";
    OfferRequest_Source[OfferRequest_Source["AGENT_LED_OFFER_AUTO_REFRESH"] = 30] = "AGENT_LED_OFFER_AUTO_REFRESH";
    OfferRequest_Source[OfferRequest_Source[/** AUTOMATED_MSRE_REFRESH_OFFER - AUTOMATED_MSRE_REFRESH_OFFER is used for auto offer refreshes for MSRE leads daily */ "AUTOMATED_MSRE_REFRESH_OFFER"] = 31] = "AUTOMATED_MSRE_REFRESH_OFFER";
    OfferRequest_Source[OfferRequest_Source[/** OUTBOUND_OFFERS_UNDERWRITTEN - OUTBOUND_OFFERS_UNDERWRITTEN is used for outbound offers that should auto-start underwriting and skip assessments */ "OUTBOUND_OFFERS_UNDERWRITTEN"] = 32] = "OUTBOUND_OFFERS_UNDERWRITTEN";
    OfferRequest_Source[OfferRequest_Source[/** REFRESH_ASSESSMENT_COMPLETED - REFRESH_ASSESSMENT_COMPLETED is used when a customer completes a virtual assessment but their offer has expired */ "REFRESH_ASSESSMENT_COMPLETED"] = 33] = "REFRESH_ASSESSMENT_COMPLETED";
    OfferRequest_Source[OfferRequest_Source[/** HSA_FO_REFRESH_OUTREACH - HSA_FO_REFRESH_OUTREACH is used for final offer refresh experiment outreach after seller schedules with HSA */ "HSA_FO_REFRESH_OUTREACH"] = 34] = "HSA_FO_REFRESH_OUTREACH";
    OfferRequest_Source[OfferRequest_Source["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(OfferRequest_Source || (OfferRequest_Source = {}));
function offerRequest_SourceFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN_OFFER_SOURCE":
            return OfferRequest_Source.UNKNOWN_OFFER_SOURCE;
        case 1:
        case "REFRESH_ADMIN":
            return OfferRequest_Source.REFRESH_ADMIN;
        case 2:
        case "REFRESH_OFFER_DASHBOARD":
            return OfferRequest_Source.REFRESH_OFFER_DASHBOARD;
        case 3:
        case "REFRESH_BROKERAGE_OFFER_DASHBOARD":
            return OfferRequest_Source.REFRESH_BROKERAGE_OFFER_DASHBOARD;
        case 4:
        case "REFRESH_SELLER_FEEDBACK":
            return OfferRequest_Source.REFRESH_SELLER_FEEDBACK;
        case 5:
        case "REFRESH_REENGAGEMENT_EMAILS":
            return OfferRequest_Source.REFRESH_REENGAGEMENT_EMAILS;
        case 6:
        case "REFRESH_CORRECTED_SQ_FT_DATA":
            return OfferRequest_Source.REFRESH_CORRECTED_SQ_FT_DATA;
        case 7:
        case "INITIAL_LEAD_FLOW":
            return OfferRequest_Source.INITIAL_LEAD_FLOW;
        case 8:
        case "INCOMPLETE_INITIAL_LEAD_FLOW":
            return OfferRequest_Source.INCOMPLETE_INITIAL_LEAD_FLOW;
        case 9:
        case "OFFER_REENGAGEMENT_CAMPAIGN":
            return OfferRequest_Source.OFFER_REENGAGEMENT_CAMPAIGN;
        case 10:
        case "AUTOMATED_REENGAGEMENT_OFFER":
            return OfferRequest_Source.AUTOMATED_REENGAGEMENT_OFFER;
        case 11:
        case "MOBILE_APP":
            return OfferRequest_Source.MOBILE_APP;
        case 12:
        case "REIT_BULK_REQUEST":
            return OfferRequest_Source.REIT_BULK_REQUEST;
        case 13:
        case "OFFER_REVIEW":
            return OfferRequest_Source.OFFER_REVIEW;
        case 14:
        case "FLYWHEEL":
            return OfferRequest_Source.FLYWHEEL;
        case 15:
        case "EMAIL_PROSPECTING":
            return OfferRequest_Source.EMAIL_PROSPECTING;
        case 16:
        case "OUTBOUND_OFFERS_LISTED":
            return OfferRequest_Source.OUTBOUND_OFFERS_LISTED;
        case 17:
        case "REFRESH_PARTNER_REFERRAL":
            return OfferRequest_Source.REFRESH_PARTNER_REFERRAL;
        case 18:
        case "HOME_RESERVE":
            return OfferRequest_Source.HOME_RESERVE;
        case 19:
        case "HOMEPAGE_RETURN_EXPERIENCE":
            return OfferRequest_Source.HOMEPAGE_RETURN_EXPERIENCE;
        case 20:
        case "REFRESH_HOME_DETAILS":
            return OfferRequest_Source.REFRESH_HOME_DETAILS;
        case 21:
        case "REFRESH_FROM_ENG":
            return OfferRequest_Source.REFRESH_FROM_ENG;
        case 22:
        case "REFRESH_PARTNER_CTA":
            return OfferRequest_Source.REFRESH_PARTNER_CTA;
        case 23:
        case "RETURN_TO_HUB_AUTO_REFRESH":
            return OfferRequest_Source.RETURN_TO_HUB_AUTO_REFRESH;
        case 24:
        case "EXCLUSIVE_OFFERS":
            return OfferRequest_Source.EXCLUSIVE_OFFERS;
        case 25:
        case "REFRESH_PREVIOUSLY_DENIED":
            return OfferRequest_Source.REFRESH_PREVIOUSLY_DENIED;
        case 26:
        case "AUTOMATED_AGENT_REENGAGEMENT_OFFER":
            return OfferRequest_Source.AUTOMATED_AGENT_REENGAGEMENT_OFFER;
        case 27:
        case "RESTORE_LWOD_LISTING_AGREEMENT_SIGNED":
            return OfferRequest_Source.RESTORE_LWOD_LISTING_AGREEMENT_SIGNED;
        case 28:
        case "AGENT_LED_OFFER_DROPOUT":
            return OfferRequest_Source.AGENT_LED_OFFER_DROPOUT;
        case 29:
        case "AGENT_LED_OFFERS_REACTIVATE":
            return OfferRequest_Source.AGENT_LED_OFFERS_REACTIVATE;
        case 30:
        case "AGENT_LED_OFFER_AUTO_REFRESH":
            return OfferRequest_Source.AGENT_LED_OFFER_AUTO_REFRESH;
        case 31:
        case "AUTOMATED_MSRE_REFRESH_OFFER":
            return OfferRequest_Source.AUTOMATED_MSRE_REFRESH_OFFER;
        case 32:
        case "OUTBOUND_OFFERS_UNDERWRITTEN":
            return OfferRequest_Source.OUTBOUND_OFFERS_UNDERWRITTEN;
        case 33:
        case "REFRESH_ASSESSMENT_COMPLETED":
            return OfferRequest_Source.REFRESH_ASSESSMENT_COMPLETED;
        case 34:
        case "HSA_FO_REFRESH_OUTREACH":
            return OfferRequest_Source.HSA_FO_REFRESH_OUTREACH;
        case -1:
        case "UNRECOGNIZED":
        default:
            return OfferRequest_Source.UNRECOGNIZED;
    }
}
function offerRequest_SourceToJSON(object) {
    switch(object){
        case OfferRequest_Source.UNKNOWN_OFFER_SOURCE:
            return "UNKNOWN_OFFER_SOURCE";
        case OfferRequest_Source.REFRESH_ADMIN:
            return "REFRESH_ADMIN";
        case OfferRequest_Source.REFRESH_OFFER_DASHBOARD:
            return "REFRESH_OFFER_DASHBOARD";
        case OfferRequest_Source.REFRESH_BROKERAGE_OFFER_DASHBOARD:
            return "REFRESH_BROKERAGE_OFFER_DASHBOARD";
        case OfferRequest_Source.REFRESH_SELLER_FEEDBACK:
            return "REFRESH_SELLER_FEEDBACK";
        case OfferRequest_Source.REFRESH_REENGAGEMENT_EMAILS:
            return "REFRESH_REENGAGEMENT_EMAILS";
        case OfferRequest_Source.REFRESH_CORRECTED_SQ_FT_DATA:
            return "REFRESH_CORRECTED_SQ_FT_DATA";
        case OfferRequest_Source.INITIAL_LEAD_FLOW:
            return "INITIAL_LEAD_FLOW";
        case OfferRequest_Source.INCOMPLETE_INITIAL_LEAD_FLOW:
            return "INCOMPLETE_INITIAL_LEAD_FLOW";
        case OfferRequest_Source.OFFER_REENGAGEMENT_CAMPAIGN:
            return "OFFER_REENGAGEMENT_CAMPAIGN";
        case OfferRequest_Source.AUTOMATED_REENGAGEMENT_OFFER:
            return "AUTOMATED_REENGAGEMENT_OFFER";
        case OfferRequest_Source.MOBILE_APP:
            return "MOBILE_APP";
        case OfferRequest_Source.REIT_BULK_REQUEST:
            return "REIT_BULK_REQUEST";
        case OfferRequest_Source.OFFER_REVIEW:
            return "OFFER_REVIEW";
        case OfferRequest_Source.FLYWHEEL:
            return "FLYWHEEL";
        case OfferRequest_Source.EMAIL_PROSPECTING:
            return "EMAIL_PROSPECTING";
        case OfferRequest_Source.OUTBOUND_OFFERS_LISTED:
            return "OUTBOUND_OFFERS_LISTED";
        case OfferRequest_Source.REFRESH_PARTNER_REFERRAL:
            return "REFRESH_PARTNER_REFERRAL";
        case OfferRequest_Source.HOME_RESERVE:
            return "HOME_RESERVE";
        case OfferRequest_Source.HOMEPAGE_RETURN_EXPERIENCE:
            return "HOMEPAGE_RETURN_EXPERIENCE";
        case OfferRequest_Source.REFRESH_HOME_DETAILS:
            return "REFRESH_HOME_DETAILS";
        case OfferRequest_Source.REFRESH_FROM_ENG:
            return "REFRESH_FROM_ENG";
        case OfferRequest_Source.REFRESH_PARTNER_CTA:
            return "REFRESH_PARTNER_CTA";
        case OfferRequest_Source.RETURN_TO_HUB_AUTO_REFRESH:
            return "RETURN_TO_HUB_AUTO_REFRESH";
        case OfferRequest_Source.EXCLUSIVE_OFFERS:
            return "EXCLUSIVE_OFFERS";
        case OfferRequest_Source.REFRESH_PREVIOUSLY_DENIED:
            return "REFRESH_PREVIOUSLY_DENIED";
        case OfferRequest_Source.AUTOMATED_AGENT_REENGAGEMENT_OFFER:
            return "AUTOMATED_AGENT_REENGAGEMENT_OFFER";
        case OfferRequest_Source.RESTORE_LWOD_LISTING_AGREEMENT_SIGNED:
            return "RESTORE_LWOD_LISTING_AGREEMENT_SIGNED";
        case OfferRequest_Source.AGENT_LED_OFFER_DROPOUT:
            return "AGENT_LED_OFFER_DROPOUT";
        case OfferRequest_Source.AGENT_LED_OFFERS_REACTIVATE:
            return "AGENT_LED_OFFERS_REACTIVATE";
        case OfferRequest_Source.AGENT_LED_OFFER_AUTO_REFRESH:
            return "AGENT_LED_OFFER_AUTO_REFRESH";
        case OfferRequest_Source.AUTOMATED_MSRE_REFRESH_OFFER:
            return "AUTOMATED_MSRE_REFRESH_OFFER";
        case OfferRequest_Source.OUTBOUND_OFFERS_UNDERWRITTEN:
            return "OUTBOUND_OFFERS_UNDERWRITTEN";
        case OfferRequest_Source.REFRESH_ASSESSMENT_COMPLETED:
            return "REFRESH_ASSESSMENT_COMPLETED";
        case OfferRequest_Source.HSA_FO_REFRESH_OUTREACH:
            return "HSA_FO_REFRESH_OUTREACH";
        case OfferRequest_Source.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
function createBaseOfferRequest() {
    return {
        source: 0,
        id: 0
    };
}
var OfferRequest = {
    fromJSON: function fromJSON(object) {
        return {
            source: offer_request_isSet(object.source) ? offerRequest_SourceFromJSON(object.source) : 0,
            id: offer_request_isSet(object.id) ? Number(object.id) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.source !== 0) {
            obj.source = offerRequest_SourceToJSON(message.source);
        }
        if (message.id !== 0) {
            obj.id = Math.round(message.id);
        }
        return obj;
    },
    create: function create(base) {
        return OfferRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseOfferRequest();
        var _source;
        message.source = (_source = object.source) !== null && _source !== void 0 ? _source : 0;
        var _id;
        message.id = (_id = object.id) !== null && _id !== void 0 ? _id : 0;
        return message;
    }
};
function offer_request_isSet(value) {
    return value !== null && value !== undefined;
}

;// CONCATENATED MODULE: ./src/__generated__/protobuf/sell/seller/data/opendoor_direct.ts
/* eslint-disable */ 

var opendoor_direct_protobufPackage = "od_protos.sell.seller.data";
var VirtualAssessmentRecording_RecordedFeature;
(function(VirtualAssessmentRecording_RecordedFeature) {
    VirtualAssessmentRecording_RecordedFeature[VirtualAssessmentRecording_RecordedFeature["UNKNOWN"] = 0] = "UNKNOWN";
    VirtualAssessmentRecording_RecordedFeature[VirtualAssessmentRecording_RecordedFeature["KITCHEN"] = 1] = "KITCHEN";
    VirtualAssessmentRecording_RecordedFeature[VirtualAssessmentRecording_RecordedFeature["LIVING_ROOM"] = 2] = "LIVING_ROOM";
    VirtualAssessmentRecording_RecordedFeature[VirtualAssessmentRecording_RecordedFeature["MASTER_BEDROOM_AND_BATHROOM"] = 3] = "MASTER_BEDROOM_AND_BATHROOM";
    VirtualAssessmentRecording_RecordedFeature[VirtualAssessmentRecording_RecordedFeature["BACKYARD"] = 4] = "BACKYARD";
    VirtualAssessmentRecording_RecordedFeature[VirtualAssessmentRecording_RecordedFeature["FRONTYARD"] = 5] = "FRONTYARD";
    VirtualAssessmentRecording_RecordedFeature[VirtualAssessmentRecording_RecordedFeature["WHOLE_HOME"] = 6] = "WHOLE_HOME";
    VirtualAssessmentRecording_RecordedFeature[VirtualAssessmentRecording_RecordedFeature["UTILITIES"] = 7] = "UTILITIES";
    VirtualAssessmentRecording_RecordedFeature[VirtualAssessmentRecording_RecordedFeature["SELLER_DISCLOSURE_DOCUMENT"] = 8] = "SELLER_DISCLOSURE_DOCUMENT";
    VirtualAssessmentRecording_RecordedFeature[VirtualAssessmentRecording_RecordedFeature["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(VirtualAssessmentRecording_RecordedFeature || (VirtualAssessmentRecording_RecordedFeature = {}));
function virtualAssessmentRecording_RecordedFeatureFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN":
            return VirtualAssessmentRecording_RecordedFeature.UNKNOWN;
        case 1:
        case "KITCHEN":
            return VirtualAssessmentRecording_RecordedFeature.KITCHEN;
        case 2:
        case "LIVING_ROOM":
            return VirtualAssessmentRecording_RecordedFeature.LIVING_ROOM;
        case 3:
        case "MASTER_BEDROOM_AND_BATHROOM":
            return VirtualAssessmentRecording_RecordedFeature.MASTER_BEDROOM_AND_BATHROOM;
        case 4:
        case "BACKYARD":
            return VirtualAssessmentRecording_RecordedFeature.BACKYARD;
        case 5:
        case "FRONTYARD":
            return VirtualAssessmentRecording_RecordedFeature.FRONTYARD;
        case 6:
        case "WHOLE_HOME":
            return VirtualAssessmentRecording_RecordedFeature.WHOLE_HOME;
        case 7:
        case "UTILITIES":
            return VirtualAssessmentRecording_RecordedFeature.UTILITIES;
        case 8:
        case "SELLER_DISCLOSURE_DOCUMENT":
            return VirtualAssessmentRecording_RecordedFeature.SELLER_DISCLOSURE_DOCUMENT;
        case -1:
        case "UNRECOGNIZED":
        default:
            return VirtualAssessmentRecording_RecordedFeature.UNRECOGNIZED;
    }
}
function virtualAssessmentRecording_RecordedFeatureToJSON(object) {
    switch(object){
        case VirtualAssessmentRecording_RecordedFeature.UNKNOWN:
            return "UNKNOWN";
        case VirtualAssessmentRecording_RecordedFeature.KITCHEN:
            return "KITCHEN";
        case VirtualAssessmentRecording_RecordedFeature.LIVING_ROOM:
            return "LIVING_ROOM";
        case VirtualAssessmentRecording_RecordedFeature.MASTER_BEDROOM_AND_BATHROOM:
            return "MASTER_BEDROOM_AND_BATHROOM";
        case VirtualAssessmentRecording_RecordedFeature.BACKYARD:
            return "BACKYARD";
        case VirtualAssessmentRecording_RecordedFeature.FRONTYARD:
            return "FRONTYARD";
        case VirtualAssessmentRecording_RecordedFeature.WHOLE_HOME:
            return "WHOLE_HOME";
        case VirtualAssessmentRecording_RecordedFeature.UTILITIES:
            return "UTILITIES";
        case VirtualAssessmentRecording_RecordedFeature.SELLER_DISCLOSURE_DOCUMENT:
            return "SELLER_DISCLOSURE_DOCUMENT";
        case VirtualAssessmentRecording_RecordedFeature.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var TradeInSpecificData_Interest;
(function(TradeInSpecificData_Interest) {
    TradeInSpecificData_Interest[TradeInSpecificData_Interest["UNSET"] = 0] = "UNSET";
    TradeInSpecificData_Interest[TradeInSpecificData_Interest["INTERESTED"] = 1] = "INTERESTED";
    TradeInSpecificData_Interest[TradeInSpecificData_Interest["NOT_INTERESTED"] = 2] = "NOT_INTERESTED";
    TradeInSpecificData_Interest[TradeInSpecificData_Interest["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(TradeInSpecificData_Interest || (TradeInSpecificData_Interest = {}));
function tradeInSpecificData_InterestFromJSON(object) {
    switch(object){
        case 0:
        case "UNSET":
            return TradeInSpecificData_Interest.UNSET;
        case 1:
        case "INTERESTED":
            return TradeInSpecificData_Interest.INTERESTED;
        case 2:
        case "NOT_INTERESTED":
            return TradeInSpecificData_Interest.NOT_INTERESTED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return TradeInSpecificData_Interest.UNRECOGNIZED;
    }
}
function tradeInSpecificData_InterestToJSON(object) {
    switch(object){
        case TradeInSpecificData_Interest.UNSET:
            return "UNSET";
        case TradeInSpecificData_Interest.INTERESTED:
            return "INTERESTED";
        case TradeInSpecificData_Interest.NOT_INTERESTED:
            return "NOT_INTERESTED";
        case TradeInSpecificData_Interest.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var opendoor_direct_OfferRequest_Source;
(function(OfferRequest_Source) {
    OfferRequest_Source[OfferRequest_Source["UNKNOWN_OFFER_SOURCE"] = 0] = "UNKNOWN_OFFER_SOURCE";
    OfferRequest_Source[OfferRequest_Source["REFRESH_ADMIN"] = 1] = "REFRESH_ADMIN";
    OfferRequest_Source[OfferRequest_Source["REFRESH_OFFER_DASHBOARD"] = 2] = "REFRESH_OFFER_DASHBOARD";
    OfferRequest_Source[OfferRequest_Source["REFRESH_BROKERAGE_OFFER_DASHBOARD"] = 3] = "REFRESH_BROKERAGE_OFFER_DASHBOARD";
    OfferRequest_Source[OfferRequest_Source["REFRESH_SELLER_FEEDBACK"] = 4] = "REFRESH_SELLER_FEEDBACK";
    OfferRequest_Source[OfferRequest_Source["REFRESH_REENGAGEMENT_EMAILS"] = 5] = "REFRESH_REENGAGEMENT_EMAILS";
    OfferRequest_Source[OfferRequest_Source["REFRESH_CORRECTED_SQ_FT_DATA"] = 6] = "REFRESH_CORRECTED_SQ_FT_DATA";
    OfferRequest_Source[OfferRequest_Source["INITIAL_LEAD_FLOW"] = 7] = "INITIAL_LEAD_FLOW";
    OfferRequest_Source[OfferRequest_Source["INCOMPLETE_INITIAL_LEAD_FLOW"] = 8] = "INCOMPLETE_INITIAL_LEAD_FLOW";
    OfferRequest_Source[OfferRequest_Source["OFFER_REENGAGEMENT_CAMPAIGN"] = 9] = "OFFER_REENGAGEMENT_CAMPAIGN";
    OfferRequest_Source[OfferRequest_Source["AUTOMATED_REENGAGEMENT_OFFER"] = 10] = "AUTOMATED_REENGAGEMENT_OFFER";
    OfferRequest_Source[OfferRequest_Source["MOBILE_APP"] = 11] = "MOBILE_APP";
    OfferRequest_Source[OfferRequest_Source["REIT_BULK_REQUEST"] = 12] = "REIT_BULK_REQUEST";
    OfferRequest_Source[OfferRequest_Source["OFFER_REVIEW"] = 13] = "OFFER_REVIEW";
    OfferRequest_Source[OfferRequest_Source[/** FLYWHEEL - FLYWHEEL is used for offer requests on leads from the FLYWHEEL channel */ "FLYWHEEL"] = 14] = "FLYWHEEL";
    OfferRequest_Source[OfferRequest_Source[/** EMAIL_PROSPECTING - EMAIL_PROSPECTING is used for offer requests on leads from the EMAIL_PROSPECTING channel */ "EMAIL_PROSPECTING"] = 15] = "EMAIL_PROSPECTING";
    OfferRequest_Source[OfferRequest_Source[/** OUTBOUND_OFFERS_LISTED - OUTBOUND_OFFERS_LISTED is used for 2020 Hackweek experiment of sending offers to listed homes */ "OUTBOUND_OFFERS_LISTED"] = 16] = "OUTBOUND_OFFERS_LISTED";
    OfferRequest_Source[OfferRequest_Source[/** REFRESH_PARTNER_REFERRAL - REFRESH_PARTNER_REFERRAL is used for offers refreshed from the partnerships referral dashboard */ "REFRESH_PARTNER_REFERRAL"] = 17] = "REFRESH_PARTNER_REFERRAL";
    OfferRequest_Source[OfferRequest_Source[/** HOME_RESERVE - HOME_RESERVE is used for offers requests on leads from the HOME_RESERVE channel */ "HOME_RESERVE"] = 18] = "HOME_RESERVE";
    OfferRequest_Source[OfferRequest_Source[/** HOMEPAGE_RETURN_EXPERIENCE - HOMEPAGE_RETURN_EXPERIENCE is used for offer refreshes that are triggered from the homepage */ "HOMEPAGE_RETURN_EXPERIENCE"] = 19] = "HOMEPAGE_RETURN_EXPERIENCE";
    OfferRequest_Source[OfferRequest_Source[/** REFRESH_HOME_DETAILS - REFRESH_HOME_DETAILS is used for offer refreshes from the offer dashboard home details page */ "REFRESH_HOME_DETAILS"] = 20] = "REFRESH_HOME_DETAILS";
    OfferRequest_Source[OfferRequest_Source[/** REFRESH_FROM_ENG - REFRESH_FROM_ENG is used for backfilling any refresh properties that expierenced a break in flow due to an error */ "REFRESH_FROM_ENG"] = 21] = "REFRESH_FROM_ENG";
    OfferRequest_Source[OfferRequest_Source[/** REFRESH_PARTNER_CTA - REFRESH_PARTNER_CTA is used for offer requests that come from Opendoor partners */ "REFRESH_PARTNER_CTA"] = 22] = "REFRESH_PARTNER_CTA";
    OfferRequest_Source[OfferRequest_Source[/** RETURN_TO_HUB_AUTO_REFRESH - RETURN_TO_HUB_AUTO_REFRESH is used for offer refreshes automatically made when users return to the Hub */ "RETURN_TO_HUB_AUTO_REFRESH"] = 23] = "RETURN_TO_HUB_AUTO_REFRESH";
    OfferRequest_Source[OfferRequest_Source[/** @deprecated */ "EXCLUSIVE_OFFERS"] = 24] = "EXCLUSIVE_OFFERS";
    OfferRequest_Source[OfferRequest_Source["REFRESH_PREVIOUSLY_DENIED"] = 25] = "REFRESH_PREVIOUSLY_DENIED";
    OfferRequest_Source[OfferRequest_Source[/** AUTOMATED_AGENT_REENGAGEMENT_OFFER - AUTOMATED_AGENT_REENGAGEMENT_OFFER is used for agent refreshes triggered via the daily DAG */ "AUTOMATED_AGENT_REENGAGEMENT_OFFER"] = 26] = "AUTOMATED_AGENT_REENGAGEMENT_OFFER";
    OfferRequest_Source[OfferRequest_Source[/**
   * RESTORE_LWOD_LISTING_AGREEMENT_SIGNED - Restore offer because of an LWOD Listing agreement being signed
   *
   * @deprecated
   */ "RESTORE_LWOD_LISTING_AGREEMENT_SIGNED"] = 27] = "RESTORE_LWOD_LISTING_AGREEMENT_SIGNED";
    OfferRequest_Source[OfferRequest_Source["AGENT_LED_OFFER_DROPOUT"] = 28] = "AGENT_LED_OFFER_DROPOUT";
    OfferRequest_Source[OfferRequest_Source["AGENT_LED_OFFERS_REACTIVATE"] = 29] = "AGENT_LED_OFFERS_REACTIVATE";
    OfferRequest_Source[OfferRequest_Source["AGENT_LED_OFFER_AUTO_REFRESH"] = 30] = "AGENT_LED_OFFER_AUTO_REFRESH";
    OfferRequest_Source[OfferRequest_Source[/** AUTOMATED_MSRE_REFRESH_OFFER - AUTOMATED_MSRE_REFRESH_OFFER is used for auto offer refreshes for MSRE leads daily */ "AUTOMATED_MSRE_REFRESH_OFFER"] = 31] = "AUTOMATED_MSRE_REFRESH_OFFER";
    OfferRequest_Source[OfferRequest_Source[/** OUTBOUND_OFFERS_UNDERWRITTEN - OUTBOUND_OFFERS_UNDERWRITTEN is used for outbound offers that should auto-start underwriting and skip assessments */ "OUTBOUND_OFFERS_UNDERWRITTEN"] = 32] = "OUTBOUND_OFFERS_UNDERWRITTEN";
    OfferRequest_Source[OfferRequest_Source[/** REFRESH_ASSESSMENT_COMPLETED - REFRESH_ASSESSMENT_COMPLETED is used when a customer completes a virtual assessment but their offer has expired */ "REFRESH_ASSESSMENT_COMPLETED"] = 33] = "REFRESH_ASSESSMENT_COMPLETED";
    OfferRequest_Source[OfferRequest_Source[/** HSA_FO_REFRESH_OUTREACH - HSA_FO_REFRESH_OUTREACH is used for final offer refresh experiment outreach after seller schedules with HSA */ "HSA_FO_REFRESH_OUTREACH"] = 34] = "HSA_FO_REFRESH_OUTREACH";
    OfferRequest_Source[OfferRequest_Source["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(opendoor_direct_OfferRequest_Source || (opendoor_direct_OfferRequest_Source = {}));
function opendoor_direct_offerRequest_SourceFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN_OFFER_SOURCE":
            return opendoor_direct_OfferRequest_Source.UNKNOWN_OFFER_SOURCE;
        case 1:
        case "REFRESH_ADMIN":
            return opendoor_direct_OfferRequest_Source.REFRESH_ADMIN;
        case 2:
        case "REFRESH_OFFER_DASHBOARD":
            return opendoor_direct_OfferRequest_Source.REFRESH_OFFER_DASHBOARD;
        case 3:
        case "REFRESH_BROKERAGE_OFFER_DASHBOARD":
            return opendoor_direct_OfferRequest_Source.REFRESH_BROKERAGE_OFFER_DASHBOARD;
        case 4:
        case "REFRESH_SELLER_FEEDBACK":
            return opendoor_direct_OfferRequest_Source.REFRESH_SELLER_FEEDBACK;
        case 5:
        case "REFRESH_REENGAGEMENT_EMAILS":
            return opendoor_direct_OfferRequest_Source.REFRESH_REENGAGEMENT_EMAILS;
        case 6:
        case "REFRESH_CORRECTED_SQ_FT_DATA":
            return opendoor_direct_OfferRequest_Source.REFRESH_CORRECTED_SQ_FT_DATA;
        case 7:
        case "INITIAL_LEAD_FLOW":
            return opendoor_direct_OfferRequest_Source.INITIAL_LEAD_FLOW;
        case 8:
        case "INCOMPLETE_INITIAL_LEAD_FLOW":
            return opendoor_direct_OfferRequest_Source.INCOMPLETE_INITIAL_LEAD_FLOW;
        case 9:
        case "OFFER_REENGAGEMENT_CAMPAIGN":
            return opendoor_direct_OfferRequest_Source.OFFER_REENGAGEMENT_CAMPAIGN;
        case 10:
        case "AUTOMATED_REENGAGEMENT_OFFER":
            return opendoor_direct_OfferRequest_Source.AUTOMATED_REENGAGEMENT_OFFER;
        case 11:
        case "MOBILE_APP":
            return opendoor_direct_OfferRequest_Source.MOBILE_APP;
        case 12:
        case "REIT_BULK_REQUEST":
            return opendoor_direct_OfferRequest_Source.REIT_BULK_REQUEST;
        case 13:
        case "OFFER_REVIEW":
            return opendoor_direct_OfferRequest_Source.OFFER_REVIEW;
        case 14:
        case "FLYWHEEL":
            return opendoor_direct_OfferRequest_Source.FLYWHEEL;
        case 15:
        case "EMAIL_PROSPECTING":
            return opendoor_direct_OfferRequest_Source.EMAIL_PROSPECTING;
        case 16:
        case "OUTBOUND_OFFERS_LISTED":
            return opendoor_direct_OfferRequest_Source.OUTBOUND_OFFERS_LISTED;
        case 17:
        case "REFRESH_PARTNER_REFERRAL":
            return opendoor_direct_OfferRequest_Source.REFRESH_PARTNER_REFERRAL;
        case 18:
        case "HOME_RESERVE":
            return opendoor_direct_OfferRequest_Source.HOME_RESERVE;
        case 19:
        case "HOMEPAGE_RETURN_EXPERIENCE":
            return opendoor_direct_OfferRequest_Source.HOMEPAGE_RETURN_EXPERIENCE;
        case 20:
        case "REFRESH_HOME_DETAILS":
            return opendoor_direct_OfferRequest_Source.REFRESH_HOME_DETAILS;
        case 21:
        case "REFRESH_FROM_ENG":
            return opendoor_direct_OfferRequest_Source.REFRESH_FROM_ENG;
        case 22:
        case "REFRESH_PARTNER_CTA":
            return opendoor_direct_OfferRequest_Source.REFRESH_PARTNER_CTA;
        case 23:
        case "RETURN_TO_HUB_AUTO_REFRESH":
            return opendoor_direct_OfferRequest_Source.RETURN_TO_HUB_AUTO_REFRESH;
        case 24:
        case "EXCLUSIVE_OFFERS":
            return opendoor_direct_OfferRequest_Source.EXCLUSIVE_OFFERS;
        case 25:
        case "REFRESH_PREVIOUSLY_DENIED":
            return opendoor_direct_OfferRequest_Source.REFRESH_PREVIOUSLY_DENIED;
        case 26:
        case "AUTOMATED_AGENT_REENGAGEMENT_OFFER":
            return opendoor_direct_OfferRequest_Source.AUTOMATED_AGENT_REENGAGEMENT_OFFER;
        case 27:
        case "RESTORE_LWOD_LISTING_AGREEMENT_SIGNED":
            return opendoor_direct_OfferRequest_Source.RESTORE_LWOD_LISTING_AGREEMENT_SIGNED;
        case 28:
        case "AGENT_LED_OFFER_DROPOUT":
            return opendoor_direct_OfferRequest_Source.AGENT_LED_OFFER_DROPOUT;
        case 29:
        case "AGENT_LED_OFFERS_REACTIVATE":
            return opendoor_direct_OfferRequest_Source.AGENT_LED_OFFERS_REACTIVATE;
        case 30:
        case "AGENT_LED_OFFER_AUTO_REFRESH":
            return opendoor_direct_OfferRequest_Source.AGENT_LED_OFFER_AUTO_REFRESH;
        case 31:
        case "AUTOMATED_MSRE_REFRESH_OFFER":
            return opendoor_direct_OfferRequest_Source.AUTOMATED_MSRE_REFRESH_OFFER;
        case 32:
        case "OUTBOUND_OFFERS_UNDERWRITTEN":
            return opendoor_direct_OfferRequest_Source.OUTBOUND_OFFERS_UNDERWRITTEN;
        case 33:
        case "REFRESH_ASSESSMENT_COMPLETED":
            return opendoor_direct_OfferRequest_Source.REFRESH_ASSESSMENT_COMPLETED;
        case 34:
        case "HSA_FO_REFRESH_OUTREACH":
            return opendoor_direct_OfferRequest_Source.HSA_FO_REFRESH_OUTREACH;
        case -1:
        case "UNRECOGNIZED":
        default:
            return opendoor_direct_OfferRequest_Source.UNRECOGNIZED;
    }
}
function opendoor_direct_offerRequest_SourceToJSON(object) {
    switch(object){
        case opendoor_direct_OfferRequest_Source.UNKNOWN_OFFER_SOURCE:
            return "UNKNOWN_OFFER_SOURCE";
        case opendoor_direct_OfferRequest_Source.REFRESH_ADMIN:
            return "REFRESH_ADMIN";
        case opendoor_direct_OfferRequest_Source.REFRESH_OFFER_DASHBOARD:
            return "REFRESH_OFFER_DASHBOARD";
        case opendoor_direct_OfferRequest_Source.REFRESH_BROKERAGE_OFFER_DASHBOARD:
            return "REFRESH_BROKERAGE_OFFER_DASHBOARD";
        case opendoor_direct_OfferRequest_Source.REFRESH_SELLER_FEEDBACK:
            return "REFRESH_SELLER_FEEDBACK";
        case opendoor_direct_OfferRequest_Source.REFRESH_REENGAGEMENT_EMAILS:
            return "REFRESH_REENGAGEMENT_EMAILS";
        case opendoor_direct_OfferRequest_Source.REFRESH_CORRECTED_SQ_FT_DATA:
            return "REFRESH_CORRECTED_SQ_FT_DATA";
        case opendoor_direct_OfferRequest_Source.INITIAL_LEAD_FLOW:
            return "INITIAL_LEAD_FLOW";
        case opendoor_direct_OfferRequest_Source.INCOMPLETE_INITIAL_LEAD_FLOW:
            return "INCOMPLETE_INITIAL_LEAD_FLOW";
        case opendoor_direct_OfferRequest_Source.OFFER_REENGAGEMENT_CAMPAIGN:
            return "OFFER_REENGAGEMENT_CAMPAIGN";
        case opendoor_direct_OfferRequest_Source.AUTOMATED_REENGAGEMENT_OFFER:
            return "AUTOMATED_REENGAGEMENT_OFFER";
        case opendoor_direct_OfferRequest_Source.MOBILE_APP:
            return "MOBILE_APP";
        case opendoor_direct_OfferRequest_Source.REIT_BULK_REQUEST:
            return "REIT_BULK_REQUEST";
        case opendoor_direct_OfferRequest_Source.OFFER_REVIEW:
            return "OFFER_REVIEW";
        case opendoor_direct_OfferRequest_Source.FLYWHEEL:
            return "FLYWHEEL";
        case opendoor_direct_OfferRequest_Source.EMAIL_PROSPECTING:
            return "EMAIL_PROSPECTING";
        case opendoor_direct_OfferRequest_Source.OUTBOUND_OFFERS_LISTED:
            return "OUTBOUND_OFFERS_LISTED";
        case opendoor_direct_OfferRequest_Source.REFRESH_PARTNER_REFERRAL:
            return "REFRESH_PARTNER_REFERRAL";
        case opendoor_direct_OfferRequest_Source.HOME_RESERVE:
            return "HOME_RESERVE";
        case opendoor_direct_OfferRequest_Source.HOMEPAGE_RETURN_EXPERIENCE:
            return "HOMEPAGE_RETURN_EXPERIENCE";
        case opendoor_direct_OfferRequest_Source.REFRESH_HOME_DETAILS:
            return "REFRESH_HOME_DETAILS";
        case opendoor_direct_OfferRequest_Source.REFRESH_FROM_ENG:
            return "REFRESH_FROM_ENG";
        case opendoor_direct_OfferRequest_Source.REFRESH_PARTNER_CTA:
            return "REFRESH_PARTNER_CTA";
        case opendoor_direct_OfferRequest_Source.RETURN_TO_HUB_AUTO_REFRESH:
            return "RETURN_TO_HUB_AUTO_REFRESH";
        case opendoor_direct_OfferRequest_Source.EXCLUSIVE_OFFERS:
            return "EXCLUSIVE_OFFERS";
        case opendoor_direct_OfferRequest_Source.REFRESH_PREVIOUSLY_DENIED:
            return "REFRESH_PREVIOUSLY_DENIED";
        case opendoor_direct_OfferRequest_Source.AUTOMATED_AGENT_REENGAGEMENT_OFFER:
            return "AUTOMATED_AGENT_REENGAGEMENT_OFFER";
        case opendoor_direct_OfferRequest_Source.RESTORE_LWOD_LISTING_AGREEMENT_SIGNED:
            return "RESTORE_LWOD_LISTING_AGREEMENT_SIGNED";
        case opendoor_direct_OfferRequest_Source.AGENT_LED_OFFER_DROPOUT:
            return "AGENT_LED_OFFER_DROPOUT";
        case opendoor_direct_OfferRequest_Source.AGENT_LED_OFFERS_REACTIVATE:
            return "AGENT_LED_OFFERS_REACTIVATE";
        case opendoor_direct_OfferRequest_Source.AGENT_LED_OFFER_AUTO_REFRESH:
            return "AGENT_LED_OFFER_AUTO_REFRESH";
        case opendoor_direct_OfferRequest_Source.AUTOMATED_MSRE_REFRESH_OFFER:
            return "AUTOMATED_MSRE_REFRESH_OFFER";
        case opendoor_direct_OfferRequest_Source.OUTBOUND_OFFERS_UNDERWRITTEN:
            return "OUTBOUND_OFFERS_UNDERWRITTEN";
        case opendoor_direct_OfferRequest_Source.REFRESH_ASSESSMENT_COMPLETED:
            return "REFRESH_ASSESSMENT_COMPLETED";
        case opendoor_direct_OfferRequest_Source.HSA_FO_REFRESH_OUTREACH:
            return "HSA_FO_REFRESH_OUTREACH";
        case opendoor_direct_OfferRequest_Source.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
function createBaseOpendoorDirectSpecificData() {
    return {
        webToken: "",
        offerFeedback: undefined,
        tradeIn: undefined,
        offerRequests: [],
        selfServiceVirtualAssessmentRecordingData: undefined,
        offerRequestsCommon: []
    };
}
var OpendoorDirectSpecificData = {
    fromJSON: function fromJSON(object) {
        return {
            webToken: opendoor_direct_isSet(object.webToken) ? String(object.webToken) : "",
            offerFeedback: opendoor_direct_isSet(object.offerFeedback) ? OfferFeedback.fromJSON(object.offerFeedback) : undefined,
            tradeIn: opendoor_direct_isSet(object.tradeIn) ? TradeInSpecificData.fromJSON(object.tradeIn) : undefined,
            offerRequests: Array.isArray(object === null || object === void 0 ? void 0 : object.offerRequests) ? object.offerRequests.map(function(e) {
                return opendoor_direct_OfferRequest.fromJSON(e);
            }) : [],
            selfServiceVirtualAssessmentRecordingData: opendoor_direct_isSet(object.selfServiceVirtualAssessmentRecordingData) ? SelfServiceVirtualAssessmentData.fromJSON(object.selfServiceVirtualAssessmentRecordingData) : undefined,
            offerRequestsCommon: Array.isArray(object === null || object === void 0 ? void 0 : object.offerRequestsCommon) ? object.offerRequestsCommon.map(function(e) {
                return opendoor_direct_OfferRequest.fromJSON(e);
            }) : []
        };
    },
    toJSON: function toJSON(message) {
        var ref, ref1;
        var obj = {};
        if (message.webToken !== "") {
            obj.webToken = message.webToken;
        }
        if (message.offerFeedback !== undefined) {
            obj.offerFeedback = OfferFeedback.toJSON(message.offerFeedback);
        }
        if (message.tradeIn !== undefined) {
            obj.tradeIn = TradeInSpecificData.toJSON(message.tradeIn);
        }
        if ((ref = message.offerRequests) === null || ref === void 0 ? void 0 : ref.length) {
            obj.offerRequests = message.offerRequests.map(function(e) {
                return opendoor_direct_OfferRequest.toJSON(e);
            });
        }
        if (message.selfServiceVirtualAssessmentRecordingData !== undefined) {
            obj.selfServiceVirtualAssessmentRecordingData = SelfServiceVirtualAssessmentData.toJSON(message.selfServiceVirtualAssessmentRecordingData);
        }
        if ((ref1 = message.offerRequestsCommon) === null || ref1 === void 0 ? void 0 : ref1.length) {
            obj.offerRequestsCommon = message.offerRequestsCommon.map(function(e) {
                return opendoor_direct_OfferRequest.toJSON(e);
            });
        }
        return obj;
    },
    create: function create(base) {
        return OpendoorDirectSpecificData.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref, ref1;
        var message = createBaseOpendoorDirectSpecificData();
        var _webToken;
        message.webToken = (_webToken = object.webToken) !== null && _webToken !== void 0 ? _webToken : "";
        message.offerFeedback = object.offerFeedback !== undefined && object.offerFeedback !== null ? OfferFeedback.fromPartial(object.offerFeedback) : undefined;
        message.tradeIn = object.tradeIn !== undefined && object.tradeIn !== null ? TradeInSpecificData.fromPartial(object.tradeIn) : undefined;
        message.offerRequests = ((ref = object.offerRequests) === null || ref === void 0 ? void 0 : ref.map(function(e) {
            return opendoor_direct_OfferRequest.fromPartial(e);
        })) || [];
        message.selfServiceVirtualAssessmentRecordingData = object.selfServiceVirtualAssessmentRecordingData !== undefined && object.selfServiceVirtualAssessmentRecordingData !== null ? SelfServiceVirtualAssessmentData.fromPartial(object.selfServiceVirtualAssessmentRecordingData) : undefined;
        message.offerRequestsCommon = ((ref1 = object.offerRequestsCommon) === null || ref1 === void 0 ? void 0 : ref1.map(function(e) {
            return OfferRequest.fromPartial(e);
        })) || [];
        return message;
    }
};
function createBaseSelfServiceVirtualAssessmentData() {
    return {
        experimentGroup: 0,
        virtualAssessmentRecordings: []
    };
}
var SelfServiceVirtualAssessmentData = {
    fromJSON: function fromJSON(object) {
        return {
            experimentGroup: opendoor_direct_isSet(object.experimentGroup) ? selfServiceVirtualAssessmentExperimentGroupFromJSON(object.experimentGroup) : 0,
            virtualAssessmentRecordings: Array.isArray(object === null || object === void 0 ? void 0 : object.virtualAssessmentRecordings) ? object.virtualAssessmentRecordings.map(function(e) {
                return VirtualAssessmentRecording.fromJSON(e);
            }) : []
        };
    },
    toJSON: function toJSON(message) {
        var ref;
        var obj = {};
        if (message.experimentGroup !== 0) {
            obj.experimentGroup = selfServiceVirtualAssessmentExperimentGroupToJSON(message.experimentGroup);
        }
        if ((ref = message.virtualAssessmentRecordings) === null || ref === void 0 ? void 0 : ref.length) {
            obj.virtualAssessmentRecordings = message.virtualAssessmentRecordings.map(function(e) {
                return VirtualAssessmentRecording.toJSON(e);
            });
        }
        return obj;
    },
    create: function create(base) {
        return SelfServiceVirtualAssessmentData.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref;
        var message = createBaseSelfServiceVirtualAssessmentData();
        var _experimentGroup;
        message.experimentGroup = (_experimentGroup = object.experimentGroup) !== null && _experimentGroup !== void 0 ? _experimentGroup : 0;
        message.virtualAssessmentRecordings = ((ref = object.virtualAssessmentRecordings) === null || ref === void 0 ? void 0 : ref.map(function(e) {
            return VirtualAssessmentRecording.fromPartial(e);
        })) || [];
        return message;
    }
};
function createBaseVirtualAssessmentRecording() {
    return {
        recordedFeature: 0,
        filename: "",
        s3Directory: ""
    };
}
var VirtualAssessmentRecording = {
    fromJSON: function fromJSON(object) {
        return {
            recordedFeature: opendoor_direct_isSet(object.recordedFeature) ? virtualAssessmentRecording_RecordedFeatureFromJSON(object.recordedFeature) : 0,
            filename: opendoor_direct_isSet(object.filename) ? String(object.filename) : "",
            s3Directory: opendoor_direct_isSet(object.s3Directory) ? String(object.s3Directory) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.recordedFeature !== 0) {
            obj.recordedFeature = virtualAssessmentRecording_RecordedFeatureToJSON(message.recordedFeature);
        }
        if (message.filename !== "") {
            obj.filename = message.filename;
        }
        if (message.s3Directory !== "") {
            obj.s3Directory = message.s3Directory;
        }
        return obj;
    },
    create: function create(base) {
        return VirtualAssessmentRecording.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseVirtualAssessmentRecording();
        var _recordedFeature;
        message.recordedFeature = (_recordedFeature = object.recordedFeature) !== null && _recordedFeature !== void 0 ? _recordedFeature : 0;
        var _filename;
        message.filename = (_filename = object.filename) !== null && _filename !== void 0 ? _filename : "";
        var _s3Directory;
        message.s3Directory = (_s3Directory = object.s3Directory) !== null && _s3Directory !== void 0 ? _s3Directory : "";
        return message;
    }
};
function createBaseTradeInSpecificData() {
    return {
        interestedInTradeIn: 0
    };
}
var TradeInSpecificData = {
    fromJSON: function fromJSON(object) {
        return {
            interestedInTradeIn: opendoor_direct_isSet(object.interestedInTradeIn) ? tradeInSpecificData_InterestFromJSON(object.interestedInTradeIn) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.interestedInTradeIn !== 0) {
            obj.interestedInTradeIn = tradeInSpecificData_InterestToJSON(message.interestedInTradeIn);
        }
        return obj;
    },
    create: function create(base) {
        return TradeInSpecificData.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseTradeInSpecificData();
        var _interestedInTradeIn;
        message.interestedInTradeIn = (_interestedInTradeIn = object.interestedInTradeIn) !== null && _interestedInTradeIn !== void 0 ? _interestedInTradeIn : 0;
        return message;
    }
};
function createBaseOfferFeedback() {
    return {
        sellerFeedback: undefined,
        sellerComplete: false
    };
}
var OfferFeedback = {
    fromJSON: function fromJSON(object) {
        return {
            sellerFeedback: opendoor_direct_isSet(object.sellerFeedback) ? SellerFeedback.fromJSON(object.sellerFeedback) : undefined,
            sellerComplete: opendoor_direct_isSet(object.sellerComplete) ? Boolean(object.sellerComplete) : false
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.sellerFeedback !== undefined) {
            obj.sellerFeedback = SellerFeedback.toJSON(message.sellerFeedback);
        }
        if (message.sellerComplete === true) {
            obj.sellerComplete = message.sellerComplete;
        }
        return obj;
    },
    create: function create(base) {
        return OfferFeedback.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseOfferFeedback();
        message.sellerFeedback = object.sellerFeedback !== undefined && object.sellerFeedback !== null ? SellerFeedback.fromPartial(object.sellerFeedback) : undefined;
        var _sellerComplete;
        message.sellerComplete = (_sellerComplete = object.sellerComplete) !== null && _sellerComplete !== void 0 ? _sellerComplete : false;
        return message;
    }
};
function createBaseSellerFeedback() {
    return {
        adminDidUploadDocuments: undefined,
        adminNotes: undefined,
        feedback: undefined,
        homeValueTooLowPrimaryReason: undefined,
        homeValueTooLowSecondaryReason: undefined,
        homeValueTooLowEstHomeValueCents: undefined,
        homeValueTooLowFreeform: undefined,
        feesTooHighFreeform: undefined,
        homeValueTooLowIncorrectHomeDetailsFreeform: undefined,
        homeValueTooLowIncorrectHomeDetailsUploads: [],
        homeValueTooLowLowerThanOtherAgentQuoteCents: undefined,
        homeValueTooLowLowerThanOtherFreeform: undefined,
        homeValueTooLowLowerThanOtherSource: undefined,
        homeValueTooLowLowerThanOtherUploads: [],
        homeValueTooLowMissedCompFreeform: undefined,
        homeValueTooLowMissedCompReason: undefined,
        homeValueTooLowMissedCompUploads: [],
        homeValueTooLowMissedUpgradesFreeform: undefined,
        homeValueTooLowMissedUpgradesUpgrades: undefined,
        homeValueTooLowMissedUpgradesUploads: [],
        looksFairNotReadyToSell: undefined
    };
}
var SellerFeedback = {
    fromJSON: function fromJSON(object) {
        return {
            adminDidUploadDocuments: opendoor_direct_isSet(object["admin.did_upload_documents"]) ? String(object["admin.did_upload_documents"]) : undefined,
            adminNotes: opendoor_direct_isSet(object["admin.notes"]) ? String(object["admin.notes"]) : undefined,
            feedback: opendoor_direct_isSet(object.feedback) ? String(object.feedback) : undefined,
            homeValueTooLowPrimaryReason: opendoor_direct_isSet(object["home_value_too_low.primary_reason"]) ? String(object["home_value_too_low.primary_reason"]) : undefined,
            homeValueTooLowSecondaryReason: opendoor_direct_isSet(object["home_value_too_low.secondary_reason"]) ? String(object["home_value_too_low.secondary_reason"]) : undefined,
            homeValueTooLowEstHomeValueCents: opendoor_direct_isSet(object["home_value_too_low.est_home_value_cents"]) ? Number(object["home_value_too_low.est_home_value_cents"]) : undefined,
            homeValueTooLowFreeform: opendoor_direct_isSet(object["home_value_too_low.freeform"]) ? String(object["home_value_too_low.freeform"]) : undefined,
            feesTooHighFreeform: opendoor_direct_isSet(object["fees_too_high.freeform"]) ? String(object["fees_too_high.freeform"]) : undefined,
            homeValueTooLowIncorrectHomeDetailsFreeform: opendoor_direct_isSet(object["home_value_too_low.incorrect_home_details.freeform"]) ? String(object["home_value_too_low.incorrect_home_details.freeform"]) : undefined,
            homeValueTooLowIncorrectHomeDetailsUploads: Array.isArray(object === null || object === void 0 ? void 0 : object["home_value_too_low.incorrect_home_details.uploads"]) ? object["home_value_too_low.incorrect_home_details.uploads"].map(function(e) {
                return SellerFeedback_Upload.fromJSON(e);
            }) : [],
            homeValueTooLowLowerThanOtherAgentQuoteCents: opendoor_direct_isSet(object["home_value_too_low.lower_than_other.agent_quote_cents"]) ? Number(object["home_value_too_low.lower_than_other.agent_quote_cents"]) : undefined,
            homeValueTooLowLowerThanOtherFreeform: opendoor_direct_isSet(object["home_value_too_low.lower_than_other.freeform"]) ? String(object["home_value_too_low.lower_than_other.freeform"]) : undefined,
            homeValueTooLowLowerThanOtherSource: opendoor_direct_isSet(object["home_value_too_low.lower_than_other.source"]) ? String(object["home_value_too_low.lower_than_other.source"]) : undefined,
            homeValueTooLowLowerThanOtherUploads: Array.isArray(object === null || object === void 0 ? void 0 : object["home_value_too_low.lower_than_other.uploads"]) ? object["home_value_too_low.lower_than_other.uploads"].map(function(e) {
                return SellerFeedback_Upload.fromJSON(e);
            }) : [],
            homeValueTooLowMissedCompFreeform: opendoor_direct_isSet(object["home_value_too_low.missed_comp.freeform"]) ? String(object["home_value_too_low.missed_comp.freeform"]) : undefined,
            homeValueTooLowMissedCompReason: opendoor_direct_isSet(object["home_value_too_low.missed_comp.reason"]) ? String(object["home_value_too_low.missed_comp.reason"]) : undefined,
            homeValueTooLowMissedCompUploads: Array.isArray(object === null || object === void 0 ? void 0 : object["home_value_too_low.missed_comp.uploads"]) ? object["home_value_too_low.missed_comp.uploads"].map(function(e) {
                return SellerFeedback_Upload.fromJSON(e);
            }) : [],
            homeValueTooLowMissedUpgradesFreeform: opendoor_direct_isSet(object["home_value_too_low.missed_upgrades.freeform"]) ? String(object["home_value_too_low.missed_upgrades.freeform"]) : undefined,
            homeValueTooLowMissedUpgradesUpgrades: opendoor_direct_isSet(object["home_value_too_low.missed_upgrades.upgrades"]) ? SellerFeedback_Upgrades.fromJSON(object["home_value_too_low.missed_upgrades.upgrades"]) : undefined,
            homeValueTooLowMissedUpgradesUploads: Array.isArray(object === null || object === void 0 ? void 0 : object["home_value_too_low.missed_upgrades.uploads"]) ? object["home_value_too_low.missed_upgrades.uploads"].map(function(e) {
                return SellerFeedback_Upload.fromJSON(e);
            }) : [],
            looksFairNotReadyToSell: opendoor_direct_isSet(object["looks_fair.not_ready_to_sell"]) ? String(object["looks_fair.not_ready_to_sell"]) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var ref, ref1, ref2, ref3;
        var obj = {};
        if (message.adminDidUploadDocuments !== undefined) {
            obj["admin.did_upload_documents"] = message.adminDidUploadDocuments;
        }
        if (message.adminNotes !== undefined) {
            obj["admin.notes"] = message.adminNotes;
        }
        if (message.feedback !== undefined) {
            obj.feedback = message.feedback;
        }
        if (message.homeValueTooLowPrimaryReason !== undefined) {
            obj["home_value_too_low.primary_reason"] = message.homeValueTooLowPrimaryReason;
        }
        if (message.homeValueTooLowSecondaryReason !== undefined) {
            obj["home_value_too_low.secondary_reason"] = message.homeValueTooLowSecondaryReason;
        }
        if (message.homeValueTooLowEstHomeValueCents !== undefined) {
            obj["home_value_too_low.est_home_value_cents"] = message.homeValueTooLowEstHomeValueCents;
        }
        if (message.homeValueTooLowFreeform !== undefined) {
            obj["home_value_too_low.freeform"] = message.homeValueTooLowFreeform;
        }
        if (message.feesTooHighFreeform !== undefined) {
            obj["fees_too_high.freeform"] = message.feesTooHighFreeform;
        }
        if (message.homeValueTooLowIncorrectHomeDetailsFreeform !== undefined) {
            obj["home_value_too_low.incorrect_home_details.freeform"] = message.homeValueTooLowIncorrectHomeDetailsFreeform;
        }
        if ((ref = message.homeValueTooLowIncorrectHomeDetailsUploads) === null || ref === void 0 ? void 0 : ref.length) {
            obj["home_value_too_low.incorrect_home_details.uploads"] = message.homeValueTooLowIncorrectHomeDetailsUploads.map(function(e) {
                return SellerFeedback_Upload.toJSON(e);
            });
        }
        if (message.homeValueTooLowLowerThanOtherAgentQuoteCents !== undefined) {
            obj["home_value_too_low.lower_than_other.agent_quote_cents"] = message.homeValueTooLowLowerThanOtherAgentQuoteCents;
        }
        if (message.homeValueTooLowLowerThanOtherFreeform !== undefined) {
            obj["home_value_too_low.lower_than_other.freeform"] = message.homeValueTooLowLowerThanOtherFreeform;
        }
        if (message.homeValueTooLowLowerThanOtherSource !== undefined) {
            obj["home_value_too_low.lower_than_other.source"] = message.homeValueTooLowLowerThanOtherSource;
        }
        if ((ref1 = message.homeValueTooLowLowerThanOtherUploads) === null || ref1 === void 0 ? void 0 : ref1.length) {
            obj["home_value_too_low.lower_than_other.uploads"] = message.homeValueTooLowLowerThanOtherUploads.map(function(e) {
                return SellerFeedback_Upload.toJSON(e);
            });
        }
        if (message.homeValueTooLowMissedCompFreeform !== undefined) {
            obj["home_value_too_low.missed_comp.freeform"] = message.homeValueTooLowMissedCompFreeform;
        }
        if (message.homeValueTooLowMissedCompReason !== undefined) {
            obj["home_value_too_low.missed_comp.reason"] = message.homeValueTooLowMissedCompReason;
        }
        if ((ref2 = message.homeValueTooLowMissedCompUploads) === null || ref2 === void 0 ? void 0 : ref2.length) {
            obj["home_value_too_low.missed_comp.uploads"] = message.homeValueTooLowMissedCompUploads.map(function(e) {
                return SellerFeedback_Upload.toJSON(e);
            });
        }
        if (message.homeValueTooLowMissedUpgradesFreeform !== undefined) {
            obj["home_value_too_low.missed_upgrades.freeform"] = message.homeValueTooLowMissedUpgradesFreeform;
        }
        if (message.homeValueTooLowMissedUpgradesUpgrades !== undefined) {
            obj["home_value_too_low.missed_upgrades.upgrades"] = SellerFeedback_Upgrades.toJSON(message.homeValueTooLowMissedUpgradesUpgrades);
        }
        if ((ref3 = message.homeValueTooLowMissedUpgradesUploads) === null || ref3 === void 0 ? void 0 : ref3.length) {
            obj["home_value_too_low.missed_upgrades.uploads"] = message.homeValueTooLowMissedUpgradesUploads.map(function(e) {
                return SellerFeedback_Upload.toJSON(e);
            });
        }
        if (message.looksFairNotReadyToSell !== undefined) {
            obj["looks_fair.not_ready_to_sell"] = message.looksFairNotReadyToSell;
        }
        return obj;
    },
    create: function create(base) {
        return SellerFeedback.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref, ref1, ref2, ref3;
        var message = createBaseSellerFeedback();
        var _adminDidUploadDocuments;
        message.adminDidUploadDocuments = (_adminDidUploadDocuments = object.adminDidUploadDocuments) !== null && _adminDidUploadDocuments !== void 0 ? _adminDidUploadDocuments : undefined;
        var _adminNotes;
        message.adminNotes = (_adminNotes = object.adminNotes) !== null && _adminNotes !== void 0 ? _adminNotes : undefined;
        var _feedback;
        message.feedback = (_feedback = object.feedback) !== null && _feedback !== void 0 ? _feedback : undefined;
        var _homeValueTooLowPrimaryReason;
        message.homeValueTooLowPrimaryReason = (_homeValueTooLowPrimaryReason = object.homeValueTooLowPrimaryReason) !== null && _homeValueTooLowPrimaryReason !== void 0 ? _homeValueTooLowPrimaryReason : undefined;
        var _homeValueTooLowSecondaryReason;
        message.homeValueTooLowSecondaryReason = (_homeValueTooLowSecondaryReason = object.homeValueTooLowSecondaryReason) !== null && _homeValueTooLowSecondaryReason !== void 0 ? _homeValueTooLowSecondaryReason : undefined;
        var _homeValueTooLowEstHomeValueCents;
        message.homeValueTooLowEstHomeValueCents = (_homeValueTooLowEstHomeValueCents = object.homeValueTooLowEstHomeValueCents) !== null && _homeValueTooLowEstHomeValueCents !== void 0 ? _homeValueTooLowEstHomeValueCents : undefined;
        var _homeValueTooLowFreeform;
        message.homeValueTooLowFreeform = (_homeValueTooLowFreeform = object.homeValueTooLowFreeform) !== null && _homeValueTooLowFreeform !== void 0 ? _homeValueTooLowFreeform : undefined;
        var _feesTooHighFreeform;
        message.feesTooHighFreeform = (_feesTooHighFreeform = object.feesTooHighFreeform) !== null && _feesTooHighFreeform !== void 0 ? _feesTooHighFreeform : undefined;
        var _homeValueTooLowIncorrectHomeDetailsFreeform;
        message.homeValueTooLowIncorrectHomeDetailsFreeform = (_homeValueTooLowIncorrectHomeDetailsFreeform = object.homeValueTooLowIncorrectHomeDetailsFreeform) !== null && _homeValueTooLowIncorrectHomeDetailsFreeform !== void 0 ? _homeValueTooLowIncorrectHomeDetailsFreeform : undefined;
        message.homeValueTooLowIncorrectHomeDetailsUploads = ((ref = object.homeValueTooLowIncorrectHomeDetailsUploads) === null || ref === void 0 ? void 0 : ref.map(function(e) {
            return SellerFeedback_Upload.fromPartial(e);
        })) || [];
        var _homeValueTooLowLowerThanOtherAgentQuoteCents;
        message.homeValueTooLowLowerThanOtherAgentQuoteCents = (_homeValueTooLowLowerThanOtherAgentQuoteCents = object.homeValueTooLowLowerThanOtherAgentQuoteCents) !== null && _homeValueTooLowLowerThanOtherAgentQuoteCents !== void 0 ? _homeValueTooLowLowerThanOtherAgentQuoteCents : undefined;
        var _homeValueTooLowLowerThanOtherFreeform;
        message.homeValueTooLowLowerThanOtherFreeform = (_homeValueTooLowLowerThanOtherFreeform = object.homeValueTooLowLowerThanOtherFreeform) !== null && _homeValueTooLowLowerThanOtherFreeform !== void 0 ? _homeValueTooLowLowerThanOtherFreeform : undefined;
        var _homeValueTooLowLowerThanOtherSource;
        message.homeValueTooLowLowerThanOtherSource = (_homeValueTooLowLowerThanOtherSource = object.homeValueTooLowLowerThanOtherSource) !== null && _homeValueTooLowLowerThanOtherSource !== void 0 ? _homeValueTooLowLowerThanOtherSource : undefined;
        message.homeValueTooLowLowerThanOtherUploads = ((ref1 = object.homeValueTooLowLowerThanOtherUploads) === null || ref1 === void 0 ? void 0 : ref1.map(function(e) {
            return SellerFeedback_Upload.fromPartial(e);
        })) || [];
        var _homeValueTooLowMissedCompFreeform;
        message.homeValueTooLowMissedCompFreeform = (_homeValueTooLowMissedCompFreeform = object.homeValueTooLowMissedCompFreeform) !== null && _homeValueTooLowMissedCompFreeform !== void 0 ? _homeValueTooLowMissedCompFreeform : undefined;
        var _homeValueTooLowMissedCompReason;
        message.homeValueTooLowMissedCompReason = (_homeValueTooLowMissedCompReason = object.homeValueTooLowMissedCompReason) !== null && _homeValueTooLowMissedCompReason !== void 0 ? _homeValueTooLowMissedCompReason : undefined;
        message.homeValueTooLowMissedCompUploads = ((ref2 = object.homeValueTooLowMissedCompUploads) === null || ref2 === void 0 ? void 0 : ref2.map(function(e) {
            return SellerFeedback_Upload.fromPartial(e);
        })) || [];
        var _homeValueTooLowMissedUpgradesFreeform;
        message.homeValueTooLowMissedUpgradesFreeform = (_homeValueTooLowMissedUpgradesFreeform = object.homeValueTooLowMissedUpgradesFreeform) !== null && _homeValueTooLowMissedUpgradesFreeform !== void 0 ? _homeValueTooLowMissedUpgradesFreeform : undefined;
        message.homeValueTooLowMissedUpgradesUpgrades = object.homeValueTooLowMissedUpgradesUpgrades !== undefined && object.homeValueTooLowMissedUpgradesUpgrades !== null ? SellerFeedback_Upgrades.fromPartial(object.homeValueTooLowMissedUpgradesUpgrades) : undefined;
        message.homeValueTooLowMissedUpgradesUploads = ((ref3 = object.homeValueTooLowMissedUpgradesUploads) === null || ref3 === void 0 ? void 0 : ref3.map(function(e) {
            return SellerFeedback_Upload.fromPartial(e);
        })) || [];
        var _looksFairNotReadyToSell;
        message.looksFairNotReadyToSell = (_looksFairNotReadyToSell = object.looksFairNotReadyToSell) !== null && _looksFairNotReadyToSell !== void 0 ? _looksFairNotReadyToSell : undefined;
        return message;
    }
};
function createBaseSellerFeedback_Upload() {
    return {
        key: "",
        url: "",
        filename: "",
        mimetype: ""
    };
}
var SellerFeedback_Upload = {
    fromJSON: function fromJSON(object) {
        return {
            key: opendoor_direct_isSet(object.key) ? String(object.key) : "",
            url: opendoor_direct_isSet(object.url) ? String(object.url) : "",
            filename: opendoor_direct_isSet(object.filename) ? String(object.filename) : "",
            mimetype: opendoor_direct_isSet(object.mimetype) ? String(object.mimetype) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.key !== "") {
            obj.key = message.key;
        }
        if (message.url !== "") {
            obj.url = message.url;
        }
        if (message.filename !== "") {
            obj.filename = message.filename;
        }
        if (message.mimetype !== "") {
            obj.mimetype = message.mimetype;
        }
        return obj;
    },
    create: function create(base) {
        return SellerFeedback_Upload.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseSellerFeedback_Upload();
        var _key;
        message.key = (_key = object.key) !== null && _key !== void 0 ? _key : "";
        var _url;
        message.url = (_url = object.url) !== null && _url !== void 0 ? _url : "";
        var _filename;
        message.filename = (_filename = object.filename) !== null && _filename !== void 0 ? _filename : "";
        var _mimetype;
        message.mimetype = (_mimetype = object.mimetype) !== null && _mimetype !== void 0 ? _mimetype : "";
        return message;
    }
};
function createBaseSellerFeedback_Upgrades() {
    return {
        incorrectHomeInfo: false,
        majorUpgrades: false,
        other: false
    };
}
var SellerFeedback_Upgrades = {
    fromJSON: function fromJSON(object) {
        return {
            incorrectHomeInfo: opendoor_direct_isSet(object.incorrect_home_info) ? Boolean(object.incorrect_home_info) : false,
            majorUpgrades: opendoor_direct_isSet(object.major_upgrades) ? Boolean(object.major_upgrades) : false,
            other: opendoor_direct_isSet(object.other) ? Boolean(object.other) : false
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.incorrectHomeInfo === true) {
            obj.incorrect_home_info = message.incorrectHomeInfo;
        }
        if (message.majorUpgrades === true) {
            obj.major_upgrades = message.majorUpgrades;
        }
        if (message.other === true) {
            obj.other = message.other;
        }
        return obj;
    },
    create: function create(base) {
        return SellerFeedback_Upgrades.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseSellerFeedback_Upgrades();
        var _incorrectHomeInfo;
        message.incorrectHomeInfo = (_incorrectHomeInfo = object.incorrectHomeInfo) !== null && _incorrectHomeInfo !== void 0 ? _incorrectHomeInfo : false;
        var _majorUpgrades;
        message.majorUpgrades = (_majorUpgrades = object.majorUpgrades) !== null && _majorUpgrades !== void 0 ? _majorUpgrades : false;
        var _other;
        message.other = (_other = object.other) !== null && _other !== void 0 ? _other : false;
        return message;
    }
};
function opendoor_direct_createBaseOfferRequest() {
    return {
        source: 0,
        id: 0
    };
}
var opendoor_direct_OfferRequest = {
    fromJSON: function fromJSON(object) {
        return {
            source: opendoor_direct_isSet(object.source) ? opendoor_direct_offerRequest_SourceFromJSON(object.source) : 0,
            id: opendoor_direct_isSet(object.id) ? Number(object.id) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.source !== 0) {
            obj.source = opendoor_direct_offerRequest_SourceToJSON(message.source);
        }
        if (message.id !== 0) {
            obj.id = Math.round(message.id);
        }
        return obj;
    },
    create: function create(base) {
        return opendoor_direct_OfferRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = opendoor_direct_createBaseOfferRequest();
        var _source;
        message.source = (_source = object.source) !== null && _source !== void 0 ? _source : 0;
        var _id;
        message.id = (_id = object.id) !== null && _id !== void 0 ? _id : 0;
        return message;
    }
};
function opendoor_direct_isSet(value) {
    return value !== null && value !== undefined;
}

;// CONCATENATED MODULE: ./src/__generated__/protobuf/sell/seller/data/reit.ts
/* eslint-disable */ var reit_protobufPackage = "od_protos.sell.seller.data";
function createBaseReitSpecificData() {
    return {};
}
var ReitSpecificData = {
    fromJSON: function fromJSON(_) {
        return {};
    },
    toJSON: function toJSON(_) {
        var obj = {};
        return obj;
    },
    create: function create(base) {
        return ReitSpecificData.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(_) {
        var message = createBaseReitSpecificData();
        return message;
    }
};

;// CONCATENATED MODULE: ./src/__generated__/protobuf/sell/seller/data/offer.ts
/* eslint-disable */ 








var offer_protobufPackage = "od_protos.sell.seller.data";
var Offer_State;
(function(Offer_State) {
    Offer_State[Offer_State[/** UNKNOWN_STATE - This is an unknown or invalid state. */ "UNKNOWN_STATE"] = 0] = "UNKNOWN_STATE";
    Offer_State[Offer_State[/**
   * RECEIVED - Received means we have received an offer from a buyer, but
   * have yet to notify the seller of the offer.
   */ "RECEIVED"] = 1] = "RECEIVED";
    Offer_State[Offer_State[/**
   * SENT - Sent means we have notified the seller of the offer, and are
   * waiting on their response.
   */ "SENT"] = 2] = "SENT";
    Offer_State[Offer_State[/** REJECTED - Rejected means the seller has rejected the offer. */ "REJECTED"] = 3] = "REJECTED";
    Offer_State[Offer_State[/**
   * EXPIRED - Expired means the seller did not take action before the expiry of
   * the offer, and the offer is now invalid.
   */ "EXPIRED"] = 4] = "EXPIRED";
    Offer_State[Offer_State[/**
   * ACCEPTED - Accepted means the seller has accepted the offer and is ready
   * to proceed. This is not legally binding.
   */ "ACCEPTED"] = 5] = "ACCEPTED";
    Offer_State[Offer_State[/**
   * IN_CONTRACT - In contract means the seller has signed the purchase agreement and
   * we now have a contractual relationship with the seller.
   */ "IN_CONTRACT"] = 8] = "IN_CONTRACT";
    Offer_State[Offer_State[/**
   * CONTINGENCIES_RELEASED - Contingencies released means all contingencies have been released on
   * the transaction.
   */ "CONTINGENCIES_RELEASED"] = 9] = "CONTINGENCIES_RELEASED";
    Offer_State[Offer_State[/**
   * CLOSED - Closed means the transaction has been successfully completed. In the
   * case of a direct sale, this means they have sold their home.
   */ "CLOSED"] = 6] = "CLOSED";
    Offer_State[Offer_State[/** WITHDRAWN - Withdrawn means the seller has withdrawn from the transaction. */ "WITHDRAWN"] = 7] = "WITHDRAWN";
    Offer_State[Offer_State["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Offer_State || (Offer_State = {}));
function offer_StateFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN_STATE":
            return Offer_State.UNKNOWN_STATE;
        case 1:
        case "RECEIVED":
            return Offer_State.RECEIVED;
        case 2:
        case "SENT":
            return Offer_State.SENT;
        case 3:
        case "REJECTED":
            return Offer_State.REJECTED;
        case 4:
        case "EXPIRED":
            return Offer_State.EXPIRED;
        case 5:
        case "ACCEPTED":
            return Offer_State.ACCEPTED;
        case 8:
        case "IN_CONTRACT":
            return Offer_State.IN_CONTRACT;
        case 9:
        case "CONTINGENCIES_RELEASED":
            return Offer_State.CONTINGENCIES_RELEASED;
        case 6:
        case "CLOSED":
            return Offer_State.CLOSED;
        case 7:
        case "WITHDRAWN":
            return Offer_State.WITHDRAWN;
        case -1:
        case "UNRECOGNIZED":
        default:
            return Offer_State.UNRECOGNIZED;
    }
}
function offer_StateToJSON(object) {
    switch(object){
        case Offer_State.UNKNOWN_STATE:
            return "UNKNOWN_STATE";
        case Offer_State.RECEIVED:
            return "RECEIVED";
        case Offer_State.SENT:
            return "SENT";
        case Offer_State.REJECTED:
            return "REJECTED";
        case Offer_State.EXPIRED:
            return "EXPIRED";
        case Offer_State.ACCEPTED:
            return "ACCEPTED";
        case Offer_State.IN_CONTRACT:
            return "IN_CONTRACT";
        case Offer_State.CONTINGENCIES_RELEASED:
            return "CONTINGENCIES_RELEASED";
        case Offer_State.CLOSED:
            return "CLOSED";
        case Offer_State.WITHDRAWN:
            return "WITHDRAWN";
        case Offer_State.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var Offer_Source_Type;
(function(Offer_Source_Type) {
    Offer_Source_Type[Offer_Source_Type["UNKOWN_TYPE"] = 0] = "UNKOWN_TYPE";
    Offer_Source_Type[Offer_Source_Type["AGENT_REFERRAL"] = 1] = "AGENT_REFERRAL";
    Offer_Source_Type[Offer_Source_Type["CLEARINGHOUSE"] = 2] = "CLEARINGHOUSE";
    Offer_Source_Type[Offer_Source_Type["LASER"] = 3] = "LASER";
    Offer_Source_Type[Offer_Source_Type["WEB_BROKERAGE_OFFER"] = 4] = "WEB_BROKERAGE_OFFER";
    Offer_Source_Type[Offer_Source_Type["WEB_OFFER"] = 5] = "WEB_OFFER";
    Offer_Source_Type[Offer_Source_Type["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Offer_Source_Type || (Offer_Source_Type = {}));
function offer_Source_TypeFromJSON(object) {
    switch(object){
        case 0:
        case "UNKOWN_TYPE":
            return Offer_Source_Type.UNKOWN_TYPE;
        case 1:
        case "AGENT_REFERRAL":
            return Offer_Source_Type.AGENT_REFERRAL;
        case 2:
        case "CLEARINGHOUSE":
            return Offer_Source_Type.CLEARINGHOUSE;
        case 3:
        case "LASER":
            return Offer_Source_Type.LASER;
        case 4:
        case "WEB_BROKERAGE_OFFER":
            return Offer_Source_Type.WEB_BROKERAGE_OFFER;
        case 5:
        case "WEB_OFFER":
            return Offer_Source_Type.WEB_OFFER;
        case -1:
        case "UNRECOGNIZED":
        default:
            return Offer_Source_Type.UNRECOGNIZED;
    }
}
function offer_Source_TypeToJSON(object) {
    switch(object){
        case Offer_Source_Type.UNKOWN_TYPE:
            return "UNKOWN_TYPE";
        case Offer_Source_Type.AGENT_REFERRAL:
            return "AGENT_REFERRAL";
        case Offer_Source_Type.CLEARINGHOUSE:
            return "CLEARINGHOUSE";
        case Offer_Source_Type.LASER:
            return "LASER";
        case Offer_Source_Type.WEB_BROKERAGE_OFFER:
            return "WEB_BROKERAGE_OFFER";
        case Offer_Source_Type.WEB_OFFER:
            return "WEB_OFFER";
        case Offer_Source_Type.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var AgentReferralDetails_AgentBio_Gender;
(function(AgentReferralDetails_AgentBio_Gender) {
    AgentReferralDetails_AgentBio_Gender[AgentReferralDetails_AgentBio_Gender["UNKNOWN_GENDER"] = 0] = "UNKNOWN_GENDER";
    AgentReferralDetails_AgentBio_Gender[AgentReferralDetails_AgentBio_Gender["FEMALE"] = 1] = "FEMALE";
    AgentReferralDetails_AgentBio_Gender[AgentReferralDetails_AgentBio_Gender["MALE"] = 2] = "MALE";
    AgentReferralDetails_AgentBio_Gender[AgentReferralDetails_AgentBio_Gender["NON_BINARY"] = 3] = "NON_BINARY";
    AgentReferralDetails_AgentBio_Gender[AgentReferralDetails_AgentBio_Gender["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(AgentReferralDetails_AgentBio_Gender || (AgentReferralDetails_AgentBio_Gender = {}));
function agentReferralDetails_AgentBio_GenderFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN_GENDER":
            return AgentReferralDetails_AgentBio_Gender.UNKNOWN_GENDER;
        case 1:
        case "FEMALE":
            return AgentReferralDetails_AgentBio_Gender.FEMALE;
        case 2:
        case "MALE":
            return AgentReferralDetails_AgentBio_Gender.MALE;
        case 3:
        case "NON_BINARY":
            return AgentReferralDetails_AgentBio_Gender.NON_BINARY;
        case -1:
        case "UNRECOGNIZED":
        default:
            return AgentReferralDetails_AgentBio_Gender.UNRECOGNIZED;
    }
}
function agentReferralDetails_AgentBio_GenderToJSON(object) {
    switch(object){
        case AgentReferralDetails_AgentBio_Gender.UNKNOWN_GENDER:
            return "UNKNOWN_GENDER";
        case AgentReferralDetails_AgentBio_Gender.FEMALE:
            return "FEMALE";
        case AgentReferralDetails_AgentBio_Gender.MALE:
            return "MALE";
        case AgentReferralDetails_AgentBio_Gender.NON_BINARY:
            return "NON_BINARY";
        case AgentReferralDetails_AgentBio_Gender.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var AddOn_AddOnType;
(function(AddOn_AddOnType) {
    AddOn_AddOnType[AddOn_AddOnType[/** @deprecated */ "UNKNOWN_ADD_ON"] = 0] = "UNKNOWN_ADD_ON";
    AddOn_AddOnType[AddOn_AddOnType[/** @deprecated */ "HOME_RESERVE"] = 1] = "HOME_RESERVE";
    AddOn_AddOnType[AddOn_AddOnType[/** @deprecated */ "BWOD"] = 2] = "BWOD";
    AddOn_AddOnType[AddOn_AddOnType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(AddOn_AddOnType || (AddOn_AddOnType = {}));
function addOn_AddOnTypeFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN_ADD_ON":
            return AddOn_AddOnType.UNKNOWN_ADD_ON;
        case 1:
        case "HOME_RESERVE":
            return AddOn_AddOnType.HOME_RESERVE;
        case 2:
        case "BWOD":
            return AddOn_AddOnType.BWOD;
        case -1:
        case "UNRECOGNIZED":
        default:
            return AddOn_AddOnType.UNRECOGNIZED;
    }
}
function addOn_AddOnTypeToJSON(object) {
    switch(object){
        case AddOn_AddOnType.UNKNOWN_ADD_ON:
            return "UNKNOWN_ADD_ON";
        case AddOn_AddOnType.HOME_RESERVE:
            return "HOME_RESERVE";
        case AddOn_AddOnType.BWOD:
            return "BWOD";
        case AddOn_AddOnType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
function createBaseOffer() {
    return {
        id: "",
        leadId: "",
        state: 0,
        active: false,
        createdAt: undefined,
        updatedAt: undefined,
        receivedAt: undefined,
        sentAt: undefined,
        viewedAt: undefined,
        rejectedAt: undefined,
        expiredAt: undefined,
        acceptedAt: undefined,
        enteredContractAt: undefined,
        contingenciesReleasedAt: undefined,
        closedAt: undefined,
        withdrawnAt: undefined,
        buyerExpiresAt: undefined,
        product: 0,
        sourceId: "",
        details: undefined,
        productSpecificData: undefined,
        odlsSellResponseId: "",
        policy: undefined,
        source: undefined,
        addOns: [],
        refreshRequestedAt: undefined
    };
}
var Offer = {
    fromJSON: function fromJSON(object) {
        return {
            id: offer_isSet(object.id) ? String(object.id) : "",
            leadId: offer_isSet(object.leadId) ? String(object.leadId) : "",
            state: offer_isSet(object.state) ? offer_StateFromJSON(object.state) : 0,
            active: offer_isSet(object.active) ? Boolean(object.active) : false,
            createdAt: offer_isSet(object.createdAt) ? offer_fromJsonTimestamp(object.createdAt) : undefined,
            updatedAt: offer_isSet(object.updatedAt) ? offer_fromJsonTimestamp(object.updatedAt) : undefined,
            receivedAt: offer_isSet(object.receivedAt) ? offer_fromJsonTimestamp(object.receivedAt) : undefined,
            sentAt: offer_isSet(object.sentAt) ? offer_fromJsonTimestamp(object.sentAt) : undefined,
            viewedAt: offer_isSet(object.viewedAt) ? offer_fromJsonTimestamp(object.viewedAt) : undefined,
            rejectedAt: offer_isSet(object.rejectedAt) ? offer_fromJsonTimestamp(object.rejectedAt) : undefined,
            expiredAt: offer_isSet(object.expiredAt) ? offer_fromJsonTimestamp(object.expiredAt) : undefined,
            acceptedAt: offer_isSet(object.acceptedAt) ? offer_fromJsonTimestamp(object.acceptedAt) : undefined,
            enteredContractAt: offer_isSet(object.enteredContractAt) ? offer_fromJsonTimestamp(object.enteredContractAt) : undefined,
            contingenciesReleasedAt: offer_isSet(object.contingenciesReleasedAt) ? offer_fromJsonTimestamp(object.contingenciesReleasedAt) : undefined,
            closedAt: offer_isSet(object.closedAt) ? offer_fromJsonTimestamp(object.closedAt) : undefined,
            withdrawnAt: offer_isSet(object.withdrawnAt) ? offer_fromJsonTimestamp(object.withdrawnAt) : undefined,
            buyerExpiresAt: offer_isSet(object.buyerExpiresAt) ? offer_fromJsonTimestamp(object.buyerExpiresAt) : undefined,
            product: offer_isSet(object.product) ? productFromJSON(object.product) : 0,
            sourceId: offer_isSet(object.sourceId) ? String(object.sourceId) : "",
            details: offer_isSet(object.opendoorOffer) ? {
                $case: "opendoorOffer",
                opendoorOffer: OpendoorOfferDetails.fromJSON(object.opendoorOffer)
            } : offer_isSet(object.reitOffer) ? {
                $case: "reitOffer",
                reitOffer: REITOfferDetails.fromJSON(object.reitOffer)
            } : offer_isSet(object.agentReferral) ? {
                $case: "agentReferral",
                agentReferral: AgentReferralDetails.fromJSON(object.agentReferral)
            } : offer_isSet(object.listWithOpendoorOffer) ? {
                $case: "listWithOpendoorOffer",
                listWithOpendoorOffer: ListWithOpendoorDetails.fromJSON(object.listWithOpendoorOffer)
            } : undefined,
            productSpecificData: offer_isSet(object.productSpecificData) ? ProductSpecificData.fromJSON(object.productSpecificData) : undefined,
            odlsSellResponseId: offer_isSet(object.odlsSellResponseId) ? String(object.odlsSellResponseId) : "",
            policy: offer_isSet(object.policy) ? OfferPolicy.fromJSON(object.policy) : undefined,
            source: offer_isSet(object.source) ? Offer_Source.fromJSON(object.source) : undefined,
            addOns: Array.isArray(object === null || object === void 0 ? void 0 : object.addOns) ? object.addOns.map(function(e) {
                return AddOn.fromJSON(e);
            }) : [],
            refreshRequestedAt: offer_isSet(object.refreshRequestedAt) ? offer_fromJsonTimestamp(object.refreshRequestedAt) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var ref, ref1, ref2, ref3, ref4;
        var obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.leadId !== "") {
            obj.leadId = message.leadId;
        }
        if (message.state !== 0) {
            obj.state = offer_StateToJSON(message.state);
        }
        if (message.active === true) {
            obj.active = message.active;
        }
        if (message.createdAt !== undefined) {
            obj.createdAt = message.createdAt.toISOString();
        }
        if (message.updatedAt !== undefined) {
            obj.updatedAt = message.updatedAt.toISOString();
        }
        if (message.receivedAt !== undefined) {
            obj.receivedAt = message.receivedAt.toISOString();
        }
        if (message.sentAt !== undefined) {
            obj.sentAt = message.sentAt.toISOString();
        }
        if (message.viewedAt !== undefined) {
            obj.viewedAt = message.viewedAt.toISOString();
        }
        if (message.rejectedAt !== undefined) {
            obj.rejectedAt = message.rejectedAt.toISOString();
        }
        if (message.expiredAt !== undefined) {
            obj.expiredAt = message.expiredAt.toISOString();
        }
        if (message.acceptedAt !== undefined) {
            obj.acceptedAt = message.acceptedAt.toISOString();
        }
        if (message.enteredContractAt !== undefined) {
            obj.enteredContractAt = message.enteredContractAt.toISOString();
        }
        if (message.contingenciesReleasedAt !== undefined) {
            obj.contingenciesReleasedAt = message.contingenciesReleasedAt.toISOString();
        }
        if (message.closedAt !== undefined) {
            obj.closedAt = message.closedAt.toISOString();
        }
        if (message.withdrawnAt !== undefined) {
            obj.withdrawnAt = message.withdrawnAt.toISOString();
        }
        if (message.buyerExpiresAt !== undefined) {
            obj.buyerExpiresAt = message.buyerExpiresAt.toISOString();
        }
        if (message.product !== 0) {
            obj.product = productToJSON(message.product);
        }
        if (message.sourceId !== "") {
            obj.sourceId = message.sourceId;
        }
        if (((ref = message.details) === null || ref === void 0 ? void 0 : ref.$case) === "opendoorOffer") {
            obj.opendoorOffer = OpendoorOfferDetails.toJSON(message.details.opendoorOffer);
        }
        if (((ref1 = message.details) === null || ref1 === void 0 ? void 0 : ref1.$case) === "reitOffer") {
            obj.reitOffer = REITOfferDetails.toJSON(message.details.reitOffer);
        }
        if (((ref2 = message.details) === null || ref2 === void 0 ? void 0 : ref2.$case) === "agentReferral") {
            obj.agentReferral = AgentReferralDetails.toJSON(message.details.agentReferral);
        }
        if (((ref3 = message.details) === null || ref3 === void 0 ? void 0 : ref3.$case) === "listWithOpendoorOffer") {
            obj.listWithOpendoorOffer = ListWithOpendoorDetails.toJSON(message.details.listWithOpendoorOffer);
        }
        if (message.productSpecificData !== undefined) {
            obj.productSpecificData = ProductSpecificData.toJSON(message.productSpecificData);
        }
        if (message.odlsSellResponseId !== "") {
            obj.odlsSellResponseId = message.odlsSellResponseId;
        }
        if (message.policy !== undefined) {
            obj.policy = OfferPolicy.toJSON(message.policy);
        }
        if (message.source !== undefined) {
            obj.source = Offer_Source.toJSON(message.source);
        }
        if ((ref4 = message.addOns) === null || ref4 === void 0 ? void 0 : ref4.length) {
            obj.addOns = message.addOns.map(function(e) {
                return AddOn.toJSON(e);
            });
        }
        if (message.refreshRequestedAt !== undefined) {
            obj.refreshRequestedAt = message.refreshRequestedAt.toISOString();
        }
        return obj;
    },
    create: function create(base) {
        return Offer.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
        var message = createBaseOffer();
        var _id;
        message.id = (_id = object.id) !== null && _id !== void 0 ? _id : "";
        var _leadId;
        message.leadId = (_leadId = object.leadId) !== null && _leadId !== void 0 ? _leadId : "";
        var _state;
        message.state = (_state = object.state) !== null && _state !== void 0 ? _state : 0;
        var _active;
        message.active = (_active = object.active) !== null && _active !== void 0 ? _active : false;
        var _createdAt;
        message.createdAt = (_createdAt = object.createdAt) !== null && _createdAt !== void 0 ? _createdAt : undefined;
        var _updatedAt;
        message.updatedAt = (_updatedAt = object.updatedAt) !== null && _updatedAt !== void 0 ? _updatedAt : undefined;
        var _receivedAt;
        message.receivedAt = (_receivedAt = object.receivedAt) !== null && _receivedAt !== void 0 ? _receivedAt : undefined;
        var _sentAt;
        message.sentAt = (_sentAt = object.sentAt) !== null && _sentAt !== void 0 ? _sentAt : undefined;
        var _viewedAt;
        message.viewedAt = (_viewedAt = object.viewedAt) !== null && _viewedAt !== void 0 ? _viewedAt : undefined;
        var _rejectedAt;
        message.rejectedAt = (_rejectedAt = object.rejectedAt) !== null && _rejectedAt !== void 0 ? _rejectedAt : undefined;
        var _expiredAt;
        message.expiredAt = (_expiredAt = object.expiredAt) !== null && _expiredAt !== void 0 ? _expiredAt : undefined;
        var _acceptedAt;
        message.acceptedAt = (_acceptedAt = object.acceptedAt) !== null && _acceptedAt !== void 0 ? _acceptedAt : undefined;
        var _enteredContractAt;
        message.enteredContractAt = (_enteredContractAt = object.enteredContractAt) !== null && _enteredContractAt !== void 0 ? _enteredContractAt : undefined;
        var _contingenciesReleasedAt;
        message.contingenciesReleasedAt = (_contingenciesReleasedAt = object.contingenciesReleasedAt) !== null && _contingenciesReleasedAt !== void 0 ? _contingenciesReleasedAt : undefined;
        var _closedAt;
        message.closedAt = (_closedAt = object.closedAt) !== null && _closedAt !== void 0 ? _closedAt : undefined;
        var _withdrawnAt;
        message.withdrawnAt = (_withdrawnAt = object.withdrawnAt) !== null && _withdrawnAt !== void 0 ? _withdrawnAt : undefined;
        var _buyerExpiresAt;
        message.buyerExpiresAt = (_buyerExpiresAt = object.buyerExpiresAt) !== null && _buyerExpiresAt !== void 0 ? _buyerExpiresAt : undefined;
        var _product;
        message.product = (_product = object.product) !== null && _product !== void 0 ? _product : 0;
        var _sourceId;
        message.sourceId = (_sourceId = object.sourceId) !== null && _sourceId !== void 0 ? _sourceId : "";
        if (((ref = object.details) === null || ref === void 0 ? void 0 : ref.$case) === "opendoorOffer" && ((ref1 = object.details) === null || ref1 === void 0 ? void 0 : ref1.opendoorOffer) !== undefined && ((ref2 = object.details) === null || ref2 === void 0 ? void 0 : ref2.opendoorOffer) !== null) {
            message.details = {
                $case: "opendoorOffer",
                opendoorOffer: OpendoorOfferDetails.fromPartial(object.details.opendoorOffer)
            };
        }
        if (((ref3 = object.details) === null || ref3 === void 0 ? void 0 : ref3.$case) === "reitOffer" && ((ref4 = object.details) === null || ref4 === void 0 ? void 0 : ref4.reitOffer) !== undefined && ((ref5 = object.details) === null || ref5 === void 0 ? void 0 : ref5.reitOffer) !== null) {
            message.details = {
                $case: "reitOffer",
                reitOffer: REITOfferDetails.fromPartial(object.details.reitOffer)
            };
        }
        if (((ref6 = object.details) === null || ref6 === void 0 ? void 0 : ref6.$case) === "agentReferral" && ((ref7 = object.details) === null || ref7 === void 0 ? void 0 : ref7.agentReferral) !== undefined && ((ref8 = object.details) === null || ref8 === void 0 ? void 0 : ref8.agentReferral) !== null) {
            message.details = {
                $case: "agentReferral",
                agentReferral: AgentReferralDetails.fromPartial(object.details.agentReferral)
            };
        }
        if (((ref9 = object.details) === null || ref9 === void 0 ? void 0 : ref9.$case) === "listWithOpendoorOffer" && ((ref10 = object.details) === null || ref10 === void 0 ? void 0 : ref10.listWithOpendoorOffer) !== undefined && ((ref11 = object.details) === null || ref11 === void 0 ? void 0 : ref11.listWithOpendoorOffer) !== null) {
            message.details = {
                $case: "listWithOpendoorOffer",
                listWithOpendoorOffer: ListWithOpendoorDetails.fromPartial(object.details.listWithOpendoorOffer)
            };
        }
        message.productSpecificData = object.productSpecificData !== undefined && object.productSpecificData !== null ? ProductSpecificData.fromPartial(object.productSpecificData) : undefined;
        var _odlsSellResponseId;
        message.odlsSellResponseId = (_odlsSellResponseId = object.odlsSellResponseId) !== null && _odlsSellResponseId !== void 0 ? _odlsSellResponseId : "";
        message.policy = object.policy !== undefined && object.policy !== null ? OfferPolicy.fromPartial(object.policy) : undefined;
        message.source = object.source !== undefined && object.source !== null ? Offer_Source.fromPartial(object.source) : undefined;
        message.addOns = ((ref12 = object.addOns) === null || ref12 === void 0 ? void 0 : ref12.map(function(e) {
            return AddOn.fromPartial(e);
        })) || [];
        var _refreshRequestedAt;
        message.refreshRequestedAt = (_refreshRequestedAt = object.refreshRequestedAt) !== null && _refreshRequestedAt !== void 0 ? _refreshRequestedAt : undefined;
        return message;
    }
};
function createBaseOffer_Source() {
    return {
        type: 0,
        id: ""
    };
}
var Offer_Source = {
    fromJSON: function fromJSON(object) {
        return {
            type: offer_isSet(object.type) ? offer_Source_TypeFromJSON(object.type) : 0,
            id: offer_isSet(object.id) ? String(object.id) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.type !== 0) {
            obj.type = offer_Source_TypeToJSON(message.type);
        }
        if (message.id !== "") {
            obj.id = message.id;
        }
        return obj;
    },
    create: function create(base) {
        return Offer_Source.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseOffer_Source();
        var _type;
        message.type = (_type = object.type) !== null && _type !== void 0 ? _type : 0;
        var _id;
        message.id = (_id = object.id) !== null && _id !== void 0 ? _id : "";
        return message;
    }
};
function createBaseProductSpecificData() {
    return {
        data: undefined
    };
}
var ProductSpecificData = {
    fromJSON: function fromJSON(object) {
        return {
            data: offer_isSet(object.opendoorDirect) ? {
                $case: "opendoorDirect",
                opendoorDirect: OpendoorDirectSpecificData.fromJSON(object.opendoorDirect)
            } : offer_isSet(object.reit) ? {
                $case: "reit",
                reit: ReitSpecificData.fromJSON(object.reit)
            } : offer_isSet(object.agentReferral) ? {
                $case: "agentReferral",
                agentReferral: AgentReferralSpecificData.fromJSON(object.agentReferral)
            } : offer_isSet(object.listWithOpendoor) ? {
                $case: "listWithOpendoor",
                listWithOpendoor: ListWithOpendoorSpecificData.fromJSON(object.listWithOpendoor)
            } : undefined
        };
    },
    toJSON: function toJSON(message) {
        var ref, ref1, ref2, ref3;
        var obj = {};
        if (((ref = message.data) === null || ref === void 0 ? void 0 : ref.$case) === "opendoorDirect") {
            obj.opendoorDirect = OpendoorDirectSpecificData.toJSON(message.data.opendoorDirect);
        }
        if (((ref1 = message.data) === null || ref1 === void 0 ? void 0 : ref1.$case) === "reit") {
            obj.reit = ReitSpecificData.toJSON(message.data.reit);
        }
        if (((ref2 = message.data) === null || ref2 === void 0 ? void 0 : ref2.$case) === "agentReferral") {
            obj.agentReferral = AgentReferralSpecificData.toJSON(message.data.agentReferral);
        }
        if (((ref3 = message.data) === null || ref3 === void 0 ? void 0 : ref3.$case) === "listWithOpendoor") {
            obj.listWithOpendoor = ListWithOpendoorSpecificData.toJSON(message.data.listWithOpendoor);
        }
        return obj;
    },
    create: function create(base) {
        return ProductSpecificData.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
        var message = createBaseProductSpecificData();
        if (((ref = object.data) === null || ref === void 0 ? void 0 : ref.$case) === "opendoorDirect" && ((ref1 = object.data) === null || ref1 === void 0 ? void 0 : ref1.opendoorDirect) !== undefined && ((ref2 = object.data) === null || ref2 === void 0 ? void 0 : ref2.opendoorDirect) !== null) {
            message.data = {
                $case: "opendoorDirect",
                opendoorDirect: OpendoorDirectSpecificData.fromPartial(object.data.opendoorDirect)
            };
        }
        if (((ref3 = object.data) === null || ref3 === void 0 ? void 0 : ref3.$case) === "reit" && ((ref4 = object.data) === null || ref4 === void 0 ? void 0 : ref4.reit) !== undefined && ((ref5 = object.data) === null || ref5 === void 0 ? void 0 : ref5.reit) !== null) {
            message.data = {
                $case: "reit",
                reit: ReitSpecificData.fromPartial(object.data.reit)
            };
        }
        if (((ref6 = object.data) === null || ref6 === void 0 ? void 0 : ref6.$case) === "agentReferral" && ((ref7 = object.data) === null || ref7 === void 0 ? void 0 : ref7.agentReferral) !== undefined && ((ref8 = object.data) === null || ref8 === void 0 ? void 0 : ref8.agentReferral) !== null) {
            message.data = {
                $case: "agentReferral",
                agentReferral: AgentReferralSpecificData.fromPartial(object.data.agentReferral)
            };
        }
        if (((ref9 = object.data) === null || ref9 === void 0 ? void 0 : ref9.$case) === "listWithOpendoor" && ((ref10 = object.data) === null || ref10 === void 0 ? void 0 : ref10.listWithOpendoor) !== undefined && ((ref11 = object.data) === null || ref11 === void 0 ? void 0 : ref11.listWithOpendoor) !== null) {
            message.data = {
                $case: "listWithOpendoor",
                listWithOpendoor: ListWithOpendoorSpecificData.fromPartial(object.data.listWithOpendoor)
            };
        }
        return message;
    }
};
function createBaseOpendoorOfferDetails() {
    return {
        comps: [],
        netProceeds: undefined,
        estimatedDaysOnMarket: 0
    };
}
var OpendoorOfferDetails = {
    fromJSON: function fromJSON(object) {
        return {
            comps: Array.isArray(object === null || object === void 0 ? void 0 : object.comps) ? object.comps.map(function(e) {
                return offer_Comp.fromJSON(e);
            }) : [],
            netProceeds: offer_isSet(object.netProceeds) ? NetProceeds.fromJSON(object.netProceeds) : undefined,
            estimatedDaysOnMarket: offer_isSet(object.estimatedDaysOnMarket) ? Number(object.estimatedDaysOnMarket) : 0
        };
    },
    toJSON: function toJSON(message) {
        var ref;
        var obj = {};
        if ((ref = message.comps) === null || ref === void 0 ? void 0 : ref.length) {
            obj.comps = message.comps.map(function(e) {
                return offer_Comp.toJSON(e);
            });
        }
        if (message.netProceeds !== undefined) {
            obj.netProceeds = NetProceeds.toJSON(message.netProceeds);
        }
        if (message.estimatedDaysOnMarket !== 0) {
            obj.estimatedDaysOnMarket = Math.round(message.estimatedDaysOnMarket);
        }
        return obj;
    },
    create: function create(base) {
        return OpendoorOfferDetails.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref;
        var message = createBaseOpendoorOfferDetails();
        message.comps = ((ref = object.comps) === null || ref === void 0 ? void 0 : ref.map(function(e) {
            return offer_Comp.fromPartial(e);
        })) || [];
        message.netProceeds = object.netProceeds !== undefined && object.netProceeds !== null ? NetProceeds.fromPartial(object.netProceeds) : undefined;
        var _estimatedDaysOnMarket;
        message.estimatedDaysOnMarket = (_estimatedDaysOnMarket = object.estimatedDaysOnMarket) !== null && _estimatedDaysOnMarket !== void 0 ? _estimatedDaysOnMarket : 0;
        return message;
    }
};
function offer_createBaseComp() {
    return {
        addressId: "",
        homeDetailId: "",
        originalListPriceCents: 0,
        listPriceCents: 0,
        closePriceCents: 0,
        listDate: undefined,
        pendingDate: undefined,
        closeDate: undefined
    };
}
var offer_Comp = {
    fromJSON: function fromJSON(object) {
        return {
            addressId: offer_isSet(object.addressId) ? String(object.addressId) : "",
            homeDetailId: offer_isSet(object.homeDetailId) ? String(object.homeDetailId) : "",
            originalListPriceCents: offer_isSet(object.originalListPriceCents) ? Number(object.originalListPriceCents) : 0,
            listPriceCents: offer_isSet(object.listPriceCents) ? Number(object.listPriceCents) : 0,
            closePriceCents: offer_isSet(object.closePriceCents) ? Number(object.closePriceCents) : 0,
            listDate: offer_isSet(object.listDate) ? offer_fromJsonTimestamp(object.listDate) : undefined,
            pendingDate: offer_isSet(object.pendingDate) ? offer_fromJsonTimestamp(object.pendingDate) : undefined,
            closeDate: offer_isSet(object.closeDate) ? offer_fromJsonTimestamp(object.closeDate) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.addressId !== "") {
            obj.addressId = message.addressId;
        }
        if (message.homeDetailId !== "") {
            obj.homeDetailId = message.homeDetailId;
        }
        if (message.originalListPriceCents !== 0) {
            obj.originalListPriceCents = Math.round(message.originalListPriceCents);
        }
        if (message.listPriceCents !== 0) {
            obj.listPriceCents = Math.round(message.listPriceCents);
        }
        if (message.closePriceCents !== 0) {
            obj.closePriceCents = Math.round(message.closePriceCents);
        }
        if (message.listDate !== undefined) {
            obj.listDate = message.listDate.toISOString();
        }
        if (message.pendingDate !== undefined) {
            obj.pendingDate = message.pendingDate.toISOString();
        }
        if (message.closeDate !== undefined) {
            obj.closeDate = message.closeDate.toISOString();
        }
        return obj;
    },
    create: function create(base) {
        return offer_Comp.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = offer_createBaseComp();
        var _addressId;
        message.addressId = (_addressId = object.addressId) !== null && _addressId !== void 0 ? _addressId : "";
        var _homeDetailId;
        message.homeDetailId = (_homeDetailId = object.homeDetailId) !== null && _homeDetailId !== void 0 ? _homeDetailId : "";
        var _originalListPriceCents;
        message.originalListPriceCents = (_originalListPriceCents = object.originalListPriceCents) !== null && _originalListPriceCents !== void 0 ? _originalListPriceCents : 0;
        var _listPriceCents;
        message.listPriceCents = (_listPriceCents = object.listPriceCents) !== null && _listPriceCents !== void 0 ? _listPriceCents : 0;
        var _closePriceCents;
        message.closePriceCents = (_closePriceCents = object.closePriceCents) !== null && _closePriceCents !== void 0 ? _closePriceCents : 0;
        var _listDate;
        message.listDate = (_listDate = object.listDate) !== null && _listDate !== void 0 ? _listDate : undefined;
        var _pendingDate;
        message.pendingDate = (_pendingDate = object.pendingDate) !== null && _pendingDate !== void 0 ? _pendingDate : undefined;
        var _closeDate;
        message.closeDate = (_closeDate = object.closeDate) !== null && _closeDate !== void 0 ? _closeDate : undefined;
        return message;
    }
};
function createBaseNetProceeds() {
    return {
        headlinePriceCents: 0,
        opendoorServiceChargeCents: 0,
        closingCostCents: 0,
        repairCostCents: 0,
        netCashCertain: false
    };
}
var NetProceeds = {
    fromJSON: function fromJSON(object) {
        return {
            headlinePriceCents: offer_isSet(object.headlinePriceCents) ? Number(object.headlinePriceCents) : 0,
            opendoorServiceChargeCents: offer_isSet(object.opendoorServiceChargeCents) ? Number(object.opendoorServiceChargeCents) : 0,
            closingCostCents: offer_isSet(object.closingCostCents) ? Number(object.closingCostCents) : 0,
            repairCostCents: offer_isSet(object.repairCostCents) ? Number(object.repairCostCents) : 0,
            netCashCertain: offer_isSet(object.netCashCertain) ? Boolean(object.netCashCertain) : false
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.headlinePriceCents !== 0) {
            obj.headlinePriceCents = Math.round(message.headlinePriceCents);
        }
        if (message.opendoorServiceChargeCents !== 0) {
            obj.opendoorServiceChargeCents = Math.round(message.opendoorServiceChargeCents);
        }
        if (message.closingCostCents !== 0) {
            obj.closingCostCents = Math.round(message.closingCostCents);
        }
        if (message.repairCostCents !== 0) {
            obj.repairCostCents = Math.round(message.repairCostCents);
        }
        if (message.netCashCertain === true) {
            obj.netCashCertain = message.netCashCertain;
        }
        return obj;
    },
    create: function create(base) {
        return NetProceeds.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseNetProceeds();
        var _headlinePriceCents;
        message.headlinePriceCents = (_headlinePriceCents = object.headlinePriceCents) !== null && _headlinePriceCents !== void 0 ? _headlinePriceCents : 0;
        var _opendoorServiceChargeCents;
        message.opendoorServiceChargeCents = (_opendoorServiceChargeCents = object.opendoorServiceChargeCents) !== null && _opendoorServiceChargeCents !== void 0 ? _opendoorServiceChargeCents : 0;
        var _closingCostCents;
        message.closingCostCents = (_closingCostCents = object.closingCostCents) !== null && _closingCostCents !== void 0 ? _closingCostCents : 0;
        var _repairCostCents;
        message.repairCostCents = (_repairCostCents = object.repairCostCents) !== null && _repairCostCents !== void 0 ? _repairCostCents : 0;
        var _netCashCertain;
        message.netCashCertain = (_netCashCertain = object.netCashCertain) !== null && _netCashCertain !== void 0 ? _netCashCertain : false;
        return message;
    }
};
function createBaseREITOfferDetails() {
    return {};
}
var REITOfferDetails = {
    fromJSON: function fromJSON(_) {
        return {};
    },
    toJSON: function toJSON(_) {
        var obj = {};
        return obj;
    },
    create: function create(base) {
        return REITOfferDetails.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(_) {
        var message = createBaseREITOfferDetails();
        return message;
    }
};
function createBaseAgentReferralDetails() {
    return {
        outboundReferralId: "",
        agentPartnershipId: "",
        score: 0,
        agentBio: undefined,
        agentStats: undefined,
        agentReviews: [],
        recentSaleAddresses: [],
        specializations: []
    };
}
var AgentReferralDetails = {
    fromJSON: function fromJSON(object) {
        return {
            outboundReferralId: offer_isSet(object.outboundReferralId) ? String(object.outboundReferralId) : "",
            agentPartnershipId: offer_isSet(object.agentPartnershipId) ? String(object.agentPartnershipId) : "",
            score: offer_isSet(object.score) ? Number(object.score) : 0,
            agentBio: offer_isSet(object.agentBio) ? AgentReferralDetails_AgentBio.fromJSON(object.agentBio) : undefined,
            agentStats: offer_isSet(object.agentStats) ? AgentReferralDetails_AgentStats.fromJSON(object.agentStats) : undefined,
            agentReviews: Array.isArray(object === null || object === void 0 ? void 0 : object.agentReviews) ? object.agentReviews.map(function(e) {
                return AgentReferralDetails_AgentReview.fromJSON(e);
            }) : [],
            recentSaleAddresses: Array.isArray(object === null || object === void 0 ? void 0 : object.recentSaleAddresses) ? object.recentSaleAddresses.map(function(e) {
                return AgentReferralDetails_Address.fromJSON(e);
            }) : [],
            specializations: Array.isArray(object === null || object === void 0 ? void 0 : object.specializations) ? object.specializations.map(function(e) {
                return String(e);
            }) : []
        };
    },
    toJSON: function toJSON(message) {
        var ref, ref1, ref2;
        var obj = {};
        if (message.outboundReferralId !== "") {
            obj.outboundReferralId = message.outboundReferralId;
        }
        if (message.agentPartnershipId !== "") {
            obj.agentPartnershipId = message.agentPartnershipId;
        }
        if (message.score !== 0) {
            obj.score = message.score;
        }
        if (message.agentBio !== undefined) {
            obj.agentBio = AgentReferralDetails_AgentBio.toJSON(message.agentBio);
        }
        if (message.agentStats !== undefined) {
            obj.agentStats = AgentReferralDetails_AgentStats.toJSON(message.agentStats);
        }
        if ((ref = message.agentReviews) === null || ref === void 0 ? void 0 : ref.length) {
            obj.agentReviews = message.agentReviews.map(function(e) {
                return AgentReferralDetails_AgentReview.toJSON(e);
            });
        }
        if ((ref1 = message.recentSaleAddresses) === null || ref1 === void 0 ? void 0 : ref1.length) {
            obj.recentSaleAddresses = message.recentSaleAddresses.map(function(e) {
                return AgentReferralDetails_Address.toJSON(e);
            });
        }
        if ((ref2 = message.specializations) === null || ref2 === void 0 ? void 0 : ref2.length) {
            obj.specializations = message.specializations;
        }
        return obj;
    },
    create: function create(base) {
        return AgentReferralDetails.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref, ref1, ref2;
        var message = createBaseAgentReferralDetails();
        var _outboundReferralId;
        message.outboundReferralId = (_outboundReferralId = object.outboundReferralId) !== null && _outboundReferralId !== void 0 ? _outboundReferralId : "";
        var _agentPartnershipId;
        message.agentPartnershipId = (_agentPartnershipId = object.agentPartnershipId) !== null && _agentPartnershipId !== void 0 ? _agentPartnershipId : "";
        var _score;
        message.score = (_score = object.score) !== null && _score !== void 0 ? _score : 0;
        message.agentBio = object.agentBio !== undefined && object.agentBio !== null ? AgentReferralDetails_AgentBio.fromPartial(object.agentBio) : undefined;
        message.agentStats = object.agentStats !== undefined && object.agentStats !== null ? AgentReferralDetails_AgentStats.fromPartial(object.agentStats) : undefined;
        message.agentReviews = ((ref = object.agentReviews) === null || ref === void 0 ? void 0 : ref.map(function(e) {
            return AgentReferralDetails_AgentReview.fromPartial(e);
        })) || [];
        message.recentSaleAddresses = ((ref1 = object.recentSaleAddresses) === null || ref1 === void 0 ? void 0 : ref1.map(function(e) {
            return AgentReferralDetails_Address.fromPartial(e);
        })) || [];
        message.specializations = ((ref2 = object.specializations) === null || ref2 === void 0 ? void 0 : ref2.map(function(e) {
            return e;
        })) || [];
        return message;
    }
};
function createBaseAgentReferralDetails_AgentReview() {
    return {
        reviewerName: "",
        reviewBody: "",
        fiveStarRatingScore: 0
    };
}
var AgentReferralDetails_AgentReview = {
    fromJSON: function fromJSON(object) {
        return {
            reviewerName: offer_isSet(object.reviewerName) ? String(object.reviewerName) : "",
            reviewBody: offer_isSet(object.reviewBody) ? String(object.reviewBody) : "",
            fiveStarRatingScore: offer_isSet(object.fiveStarRatingScore) ? Number(object.fiveStarRatingScore) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.reviewerName !== "") {
            obj.reviewerName = message.reviewerName;
        }
        if (message.reviewBody !== "") {
            obj.reviewBody = message.reviewBody;
        }
        if (message.fiveStarRatingScore !== 0) {
            obj.fiveStarRatingScore = message.fiveStarRatingScore;
        }
        return obj;
    },
    create: function create(base) {
        return AgentReferralDetails_AgentReview.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAgentReferralDetails_AgentReview();
        var _reviewerName;
        message.reviewerName = (_reviewerName = object.reviewerName) !== null && _reviewerName !== void 0 ? _reviewerName : "";
        var _reviewBody;
        message.reviewBody = (_reviewBody = object.reviewBody) !== null && _reviewBody !== void 0 ? _reviewBody : "";
        var _fiveStarRatingScore;
        message.fiveStarRatingScore = (_fiveStarRatingScore = object.fiveStarRatingScore) !== null && _fiveStarRatingScore !== void 0 ? _fiveStarRatingScore : 0;
        return message;
    }
};
function createBaseAgentReferralDetails_HomeCoordinate() {
    return {
        lat: 0,
        lon: 0
    };
}
var AgentReferralDetails_HomeCoordinate = {
    fromJSON: function fromJSON(object) {
        return {
            lat: offer_isSet(object.lat) ? Number(object.lat) : 0,
            lon: offer_isSet(object.lon) ? Number(object.lon) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.lat !== 0) {
            obj.lat = message.lat;
        }
        if (message.lon !== 0) {
            obj.lon = message.lon;
        }
        return obj;
    },
    create: function create(base) {
        return AgentReferralDetails_HomeCoordinate.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAgentReferralDetails_HomeCoordinate();
        var _lat;
        message.lat = (_lat = object.lat) !== null && _lat !== void 0 ? _lat : 0;
        var _lon;
        message.lon = (_lon = object.lon) !== null && _lon !== void 0 ? _lon : 0;
        return message;
    }
};
function createBaseAgentReferralDetails_AgentBio() {
    return {
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        profilePhotoId: "",
        profilePhotoUrl: "",
        gender: 0
    };
}
var AgentReferralDetails_AgentBio = {
    fromJSON: function fromJSON(object) {
        return {
            firstName: offer_isSet(object.firstName) ? String(object.firstName) : "",
            lastName: offer_isSet(object.lastName) ? String(object.lastName) : "",
            email: offer_isSet(object.email) ? String(object.email) : "",
            phoneNumber: offer_isSet(object.phoneNumber) ? String(object.phoneNumber) : "",
            profilePhotoId: offer_isSet(object.profilePhotoId) ? String(object.profilePhotoId) : "",
            profilePhotoUrl: offer_isSet(object.profilePhotoUrl) ? String(object.profilePhotoUrl) : "",
            gender: offer_isSet(object.gender) ? agentReferralDetails_AgentBio_GenderFromJSON(object.gender) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.firstName !== "") {
            obj.firstName = message.firstName;
        }
        if (message.lastName !== "") {
            obj.lastName = message.lastName;
        }
        if (message.email !== "") {
            obj.email = message.email;
        }
        if (message.phoneNumber !== "") {
            obj.phoneNumber = message.phoneNumber;
        }
        if (message.profilePhotoId !== "") {
            obj.profilePhotoId = message.profilePhotoId;
        }
        if (message.profilePhotoUrl !== "") {
            obj.profilePhotoUrl = message.profilePhotoUrl;
        }
        if (message.gender !== 0) {
            obj.gender = agentReferralDetails_AgentBio_GenderToJSON(message.gender);
        }
        return obj;
    },
    create: function create(base) {
        return AgentReferralDetails_AgentBio.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAgentReferralDetails_AgentBio();
        var _firstName;
        message.firstName = (_firstName = object.firstName) !== null && _firstName !== void 0 ? _firstName : "";
        var _lastName;
        message.lastName = (_lastName = object.lastName) !== null && _lastName !== void 0 ? _lastName : "";
        var _email;
        message.email = (_email = object.email) !== null && _email !== void 0 ? _email : "";
        var _phoneNumber;
        message.phoneNumber = (_phoneNumber = object.phoneNumber) !== null && _phoneNumber !== void 0 ? _phoneNumber : "";
        var _profilePhotoId;
        message.profilePhotoId = (_profilePhotoId = object.profilePhotoId) !== null && _profilePhotoId !== void 0 ? _profilePhotoId : "";
        var _profilePhotoUrl;
        message.profilePhotoUrl = (_profilePhotoUrl = object.profilePhotoUrl) !== null && _profilePhotoUrl !== void 0 ? _profilePhotoUrl : "";
        var _gender;
        message.gender = (_gender = object.gender) !== null && _gender !== void 0 ? _gender : 0;
        return message;
    }
};
function createBaseAgentReferralDetails_AgentStats() {
    return {
        yearsOfExperience: 0,
        avgFiveStarRatingScore: 0,
        ratingsCount: 0,
        numHomesSoldInLast12Mo: 0,
        avgDaysListedLast12Mo: 0,
        avgListToClosePriceRatioLast12Mo: 0
    };
}
var AgentReferralDetails_AgentStats = {
    fromJSON: function fromJSON(object) {
        return {
            yearsOfExperience: offer_isSet(object.yearsOfExperience) ? Number(object.yearsOfExperience) : 0,
            avgFiveStarRatingScore: offer_isSet(object.avgFiveStarRatingScore) ? Number(object.avgFiveStarRatingScore) : 0,
            ratingsCount: offer_isSet(object.ratingsCount) ? Number(object.ratingsCount) : 0,
            numHomesSoldInLast12Mo: offer_isSet(object.numHomesSoldInLast12Mo) ? Number(object.numHomesSoldInLast12Mo) : 0,
            avgDaysListedLast12Mo: offer_isSet(object.avgDaysListedLast12Mo) ? Number(object.avgDaysListedLast12Mo) : 0,
            avgListToClosePriceRatioLast12Mo: offer_isSet(object.avgListToClosePriceRatioLast12Mo) ? Number(object.avgListToClosePriceRatioLast12Mo) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.yearsOfExperience !== 0) {
            obj.yearsOfExperience = Math.round(message.yearsOfExperience);
        }
        if (message.avgFiveStarRatingScore !== 0) {
            obj.avgFiveStarRatingScore = message.avgFiveStarRatingScore;
        }
        if (message.ratingsCount !== 0) {
            obj.ratingsCount = Math.round(message.ratingsCount);
        }
        if (message.numHomesSoldInLast12Mo !== 0) {
            obj.numHomesSoldInLast12Mo = Math.round(message.numHomesSoldInLast12Mo);
        }
        if (message.avgDaysListedLast12Mo !== 0) {
            obj.avgDaysListedLast12Mo = message.avgDaysListedLast12Mo;
        }
        if (message.avgListToClosePriceRatioLast12Mo !== 0) {
            obj.avgListToClosePriceRatioLast12Mo = message.avgListToClosePriceRatioLast12Mo;
        }
        return obj;
    },
    create: function create(base) {
        return AgentReferralDetails_AgentStats.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAgentReferralDetails_AgentStats();
        var _yearsOfExperience;
        message.yearsOfExperience = (_yearsOfExperience = object.yearsOfExperience) !== null && _yearsOfExperience !== void 0 ? _yearsOfExperience : 0;
        var _avgFiveStarRatingScore;
        message.avgFiveStarRatingScore = (_avgFiveStarRatingScore = object.avgFiveStarRatingScore) !== null && _avgFiveStarRatingScore !== void 0 ? _avgFiveStarRatingScore : 0;
        var _ratingsCount;
        message.ratingsCount = (_ratingsCount = object.ratingsCount) !== null && _ratingsCount !== void 0 ? _ratingsCount : 0;
        var _numHomesSoldInLast12Mo;
        message.numHomesSoldInLast12Mo = (_numHomesSoldInLast12Mo = object.numHomesSoldInLast12Mo) !== null && _numHomesSoldInLast12Mo !== void 0 ? _numHomesSoldInLast12Mo : 0;
        var _avgDaysListedLast12Mo;
        message.avgDaysListedLast12Mo = (_avgDaysListedLast12Mo = object.avgDaysListedLast12Mo) !== null && _avgDaysListedLast12Mo !== void 0 ? _avgDaysListedLast12Mo : 0;
        var _avgListToClosePriceRatioLast12Mo;
        message.avgListToClosePriceRatioLast12Mo = (_avgListToClosePriceRatioLast12Mo = object.avgListToClosePriceRatioLast12Mo) !== null && _avgListToClosePriceRatioLast12Mo !== void 0 ? _avgListToClosePriceRatioLast12Mo : 0;
        return message;
    }
};
function createBaseAgentReferralDetails_Address() {
    return {
        addressId: "",
        street: "",
        city: "",
        state: "",
        postalCode: "",
        suite: "",
        latitude: 0,
        longitude: 0
    };
}
var AgentReferralDetails_Address = {
    fromJSON: function fromJSON(object) {
        return {
            addressId: offer_isSet(object.addressId) ? String(object.addressId) : "",
            street: offer_isSet(object.street) ? String(object.street) : "",
            city: offer_isSet(object.city) ? String(object.city) : "",
            state: offer_isSet(object.state) ? String(object.state) : "",
            postalCode: offer_isSet(object.postalCode) ? String(object.postalCode) : "",
            suite: offer_isSet(object.suite) ? String(object.suite) : "",
            latitude: offer_isSet(object.latitude) ? Number(object.latitude) : 0,
            longitude: offer_isSet(object.longitude) ? Number(object.longitude) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.addressId !== "") {
            obj.addressId = message.addressId;
        }
        if (message.street !== "") {
            obj.street = message.street;
        }
        if (message.city !== "") {
            obj.city = message.city;
        }
        if (message.state !== "") {
            obj.state = message.state;
        }
        if (message.postalCode !== "") {
            obj.postalCode = message.postalCode;
        }
        if (message.suite !== "") {
            obj.suite = message.suite;
        }
        if (message.latitude !== 0) {
            obj.latitude = message.latitude;
        }
        if (message.longitude !== 0) {
            obj.longitude = message.longitude;
        }
        return obj;
    },
    create: function create(base) {
        return AgentReferralDetails_Address.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAgentReferralDetails_Address();
        var _addressId;
        message.addressId = (_addressId = object.addressId) !== null && _addressId !== void 0 ? _addressId : "";
        var _street;
        message.street = (_street = object.street) !== null && _street !== void 0 ? _street : "";
        var _city;
        message.city = (_city = object.city) !== null && _city !== void 0 ? _city : "";
        var _state;
        message.state = (_state = object.state) !== null && _state !== void 0 ? _state : "";
        var _postalCode;
        message.postalCode = (_postalCode = object.postalCode) !== null && _postalCode !== void 0 ? _postalCode : "";
        var _suite;
        message.suite = (_suite = object.suite) !== null && _suite !== void 0 ? _suite : "";
        var _latitude;
        message.latitude = (_latitude = object.latitude) !== null && _latitude !== void 0 ? _latitude : 0;
        var _longitude;
        message.longitude = (_longitude = object.longitude) !== null && _longitude !== void 0 ? _longitude : 0;
        return message;
    }
};
function createBaseListWithOpendoorDetails() {
    return {};
}
var ListWithOpendoorDetails = {
    fromJSON: function fromJSON(_) {
        return {};
    },
    toJSON: function toJSON(_) {
        var obj = {};
        return obj;
    },
    create: function create(base) {
        return ListWithOpendoorDetails.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(_) {
        var message = createBaseListWithOpendoorDetails();
        return message;
    }
};
function createBaseLeadOffers() {
    return {
        source: undefined,
        offers: []
    };
}
var LeadOffers = {
    fromJSON: function fromJSON(object) {
        return {
            source: offer_isSet(object.source) ? Lead_Source.fromJSON(object.source) : undefined,
            offers: Array.isArray(object === null || object === void 0 ? void 0 : object.offers) ? object.offers.map(function(e) {
                return Offer.fromJSON(e);
            }) : []
        };
    },
    toJSON: function toJSON(message) {
        var ref;
        var obj = {};
        if (message.source !== undefined) {
            obj.source = Lead_Source.toJSON(message.source);
        }
        if ((ref = message.offers) === null || ref === void 0 ? void 0 : ref.length) {
            obj.offers = message.offers.map(function(e) {
                return Offer.toJSON(e);
            });
        }
        return obj;
    },
    create: function create(base) {
        return LeadOffers.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref;
        var message = createBaseLeadOffers();
        message.source = object.source !== undefined && object.source !== null ? Lead_Source.fromPartial(object.source) : undefined;
        message.offers = ((ref = object.offers) === null || ref === void 0 ? void 0 : ref.map(function(e) {
            return Offer.fromPartial(e);
        })) || [];
        return message;
    }
};
function createBaseAddOn() {
    return {
        offerUuid: "",
        addOnType: 0,
        eligibleAt: undefined,
        included: undefined
    };
}
var AddOn = {
    fromJSON: function fromJSON(object) {
        return {
            offerUuid: offer_isSet(object.offerUuid) ? String(object.offerUuid) : "",
            addOnType: offer_isSet(object.addOnType) ? addOn_AddOnTypeFromJSON(object.addOnType) : 0,
            eligibleAt: offer_isSet(object.eligibleAt) ? offer_fromJsonTimestamp(object.eligibleAt) : undefined,
            included: offer_isSet(object.included) ? Boolean(object.included) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.offerUuid !== "") {
            obj.offerUuid = message.offerUuid;
        }
        if (message.addOnType !== 0) {
            obj.addOnType = addOn_AddOnTypeToJSON(message.addOnType);
        }
        if (message.eligibleAt !== undefined) {
            obj.eligibleAt = message.eligibleAt.toISOString();
        }
        if (message.included !== undefined) {
            obj.included = message.included;
        }
        return obj;
    },
    create: function create(base) {
        return AddOn.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAddOn();
        var _offerUuid;
        message.offerUuid = (_offerUuid = object.offerUuid) !== null && _offerUuid !== void 0 ? _offerUuid : "";
        var _addOnType;
        message.addOnType = (_addOnType = object.addOnType) !== null && _addOnType !== void 0 ? _addOnType : 0;
        var _eligibleAt;
        message.eligibleAt = (_eligibleAt = object.eligibleAt) !== null && _eligibleAt !== void 0 ? _eligibleAt : undefined;
        var _included;
        message.included = (_included = object.included) !== null && _included !== void 0 ? _included : undefined;
        return message;
    }
};
function offer_fromTimestamp(t) {
    var millis = (t.seconds || 0) * 1000;
    millis += (t.nanos || 0) / 1000000;
    return new Date(millis);
}
function offer_fromJsonTimestamp(o) {
    if ((0,_instanceof/* default */.Z)(o, Date)) {
        return o;
    } else if (typeof o === "string") {
        return new Date(o);
    } else {
        return offer_fromTimestamp(Timestamp.fromJSON(o));
    }
}
function offer_isSet(value) {
    return value !== null && value !== undefined;
}

;// CONCATENATED MODULE: ./src/__generated__/protobuf/sell/seller/data/product_experience.ts
/* eslint-disable */ var product_experience_protobufPackage = "od_protos.sell.seller.data";
var SellerExperience;
(function(SellerExperience) {
    SellerExperience[SellerExperience["SELLER_EXPERIENCE_UNKNOWN"] = 0] = "SELLER_EXPERIENCE_UNKNOWN";
    SellerExperience[SellerExperience["SELLER_EXPERIENCE_DIRECT_TO_CONSUMER"] = 1] = "SELLER_EXPERIENCE_DIRECT_TO_CONSUMER";
    SellerExperience[SellerExperience["SELLER_EXPERIENCE_AGENT_LED_OFFERS"] = 2] = "SELLER_EXPERIENCE_AGENT_LED_OFFERS";
    SellerExperience[SellerExperience["SELLER_EXPERIENCE_AGENT_ACQUISITION"] = 3] = "SELLER_EXPERIENCE_AGENT_ACQUISITION";
    SellerExperience[SellerExperience["SELLER_EXPERIENCE_DENIED"] = 4] = "SELLER_EXPERIENCE_DENIED";
    SellerExperience[SellerExperience["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(SellerExperience || (SellerExperience = {}));
function sellerExperienceFromJSON(object) {
    switch(object){
        case 0:
        case "SELLER_EXPERIENCE_UNKNOWN":
            return SellerExperience.SELLER_EXPERIENCE_UNKNOWN;
        case 1:
        case "SELLER_EXPERIENCE_DIRECT_TO_CONSUMER":
            return SellerExperience.SELLER_EXPERIENCE_DIRECT_TO_CONSUMER;
        case 2:
        case "SELLER_EXPERIENCE_AGENT_LED_OFFERS":
            return SellerExperience.SELLER_EXPERIENCE_AGENT_LED_OFFERS;
        case 3:
        case "SELLER_EXPERIENCE_AGENT_ACQUISITION":
            return SellerExperience.SELLER_EXPERIENCE_AGENT_ACQUISITION;
        case 4:
        case "SELLER_EXPERIENCE_DENIED":
            return SellerExperience.SELLER_EXPERIENCE_DENIED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return SellerExperience.UNRECOGNIZED;
    }
}
function sellerExperienceToJSON(object) {
    switch(object){
        case SellerExperience.SELLER_EXPERIENCE_UNKNOWN:
            return "SELLER_EXPERIENCE_UNKNOWN";
        case SellerExperience.SELLER_EXPERIENCE_DIRECT_TO_CONSUMER:
            return "SELLER_EXPERIENCE_DIRECT_TO_CONSUMER";
        case SellerExperience.SELLER_EXPERIENCE_AGENT_LED_OFFERS:
            return "SELLER_EXPERIENCE_AGENT_LED_OFFERS";
        case SellerExperience.SELLER_EXPERIENCE_AGENT_ACQUISITION:
            return "SELLER_EXPERIENCE_AGENT_ACQUISITION";
        case SellerExperience.SELLER_EXPERIENCE_DENIED:
            return "SELLER_EXPERIENCE_DENIED";
        case SellerExperience.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}

;// CONCATENATED MODULE: ./src/__generated__/protobuf/journey/data/categories/sell_category.ts
/* eslint-disable */ 



var sell_category_protobufPackage = "od_protos.journey.data.categories";
var SellCategory_SSVATaskType;
(function(SellCategory_SSVATaskType) {
    SellCategory_SSVATaskType[SellCategory_SSVATaskType["UNKNOWN_SSVA_TASK_TYPE"] = 0] = "UNKNOWN_SSVA_TASK_TYPE";
    SellCategory_SSVATaskType[SellCategory_SSVATaskType["UPLOAD_INTERIOR_RECORDING_TASK"] = 1] = "UPLOAD_INTERIOR_RECORDING_TASK";
    SellCategory_SSVATaskType[SellCategory_SSVATaskType["UPLOAD_FRONTYARD_RECORDING_TASK"] = 2] = "UPLOAD_FRONTYARD_RECORDING_TASK";
    SellCategory_SSVATaskType[SellCategory_SSVATaskType["UPLOAD_BACKYARD_RECORDING_TASK"] = 3] = "UPLOAD_BACKYARD_RECORDING_TASK";
    SellCategory_SSVATaskType[SellCategory_SSVATaskType["UPLOAD_WHOLE_HOME_RECORDING_TASK"] = 4] = "UPLOAD_WHOLE_HOME_RECORDING_TASK";
    SellCategory_SSVATaskType[SellCategory_SSVATaskType["QUESTIONNAIRE_TASK"] = 5] = "QUESTIONNAIRE_TASK";
    SellCategory_SSVATaskType[SellCategory_SSVATaskType["SELLER_DISCLOSURE_DOCUMENT_TASK"] = 6] = "SELLER_DISCLOSURE_DOCUMENT_TASK";
    SellCategory_SSVATaskType[SellCategory_SSVATaskType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(SellCategory_SSVATaskType || (SellCategory_SSVATaskType = {}));
function sellCategory_SSVATaskTypeFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN_SSVA_TASK_TYPE":
            return SellCategory_SSVATaskType.UNKNOWN_SSVA_TASK_TYPE;
        case 1:
        case "UPLOAD_INTERIOR_RECORDING_TASK":
            return SellCategory_SSVATaskType.UPLOAD_INTERIOR_RECORDING_TASK;
        case 2:
        case "UPLOAD_FRONTYARD_RECORDING_TASK":
            return SellCategory_SSVATaskType.UPLOAD_FRONTYARD_RECORDING_TASK;
        case 3:
        case "UPLOAD_BACKYARD_RECORDING_TASK":
            return SellCategory_SSVATaskType.UPLOAD_BACKYARD_RECORDING_TASK;
        case 4:
        case "UPLOAD_WHOLE_HOME_RECORDING_TASK":
            return SellCategory_SSVATaskType.UPLOAD_WHOLE_HOME_RECORDING_TASK;
        case 5:
        case "QUESTIONNAIRE_TASK":
            return SellCategory_SSVATaskType.QUESTIONNAIRE_TASK;
        case 6:
        case "SELLER_DISCLOSURE_DOCUMENT_TASK":
            return SellCategory_SSVATaskType.SELLER_DISCLOSURE_DOCUMENT_TASK;
        case -1:
        case "UNRECOGNIZED":
        default:
            return SellCategory_SSVATaskType.UNRECOGNIZED;
    }
}
function sellCategory_SSVATaskTypeToJSON(object) {
    switch(object){
        case SellCategory_SSVATaskType.UNKNOWN_SSVA_TASK_TYPE:
            return "UNKNOWN_SSVA_TASK_TYPE";
        case SellCategory_SSVATaskType.UPLOAD_INTERIOR_RECORDING_TASK:
            return "UPLOAD_INTERIOR_RECORDING_TASK";
        case SellCategory_SSVATaskType.UPLOAD_FRONTYARD_RECORDING_TASK:
            return "UPLOAD_FRONTYARD_RECORDING_TASK";
        case SellCategory_SSVATaskType.UPLOAD_BACKYARD_RECORDING_TASK:
            return "UPLOAD_BACKYARD_RECORDING_TASK";
        case SellCategory_SSVATaskType.UPLOAD_WHOLE_HOME_RECORDING_TASK:
            return "UPLOAD_WHOLE_HOME_RECORDING_TASK";
        case SellCategory_SSVATaskType.QUESTIONNAIRE_TASK:
            return "QUESTIONNAIRE_TASK";
        case SellCategory_SSVATaskType.SELLER_DISCLOSURE_DOCUMENT_TASK:
            return "SELLER_DISCLOSURE_DOCUMENT_TASK";
        case SellCategory_SSVATaskType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var SellCategory_ProductIntentType;
(function(SellCategory_ProductIntentType) {
    SellCategory_ProductIntentType[SellCategory_ProductIntentType["UNKNOWN_TYPE"] = 0] = "UNKNOWN_TYPE";
    SellCategory_ProductIntentType[SellCategory_ProductIntentType["LIST"] = 1] = "LIST";
    SellCategory_ProductIntentType[SellCategory_ProductIntentType[/** @deprecated */ "MARKETPLACE"] = 2] = "MARKETPLACE";
    SellCategory_ProductIntentType[SellCategory_ProductIntentType["SELL_DIRECT"] = 3] = "SELL_DIRECT";
    SellCategory_ProductIntentType[SellCategory_ProductIntentType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(SellCategory_ProductIntentType || (SellCategory_ProductIntentType = {}));
function sellCategory_ProductIntentTypeFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN_TYPE":
            return SellCategory_ProductIntentType.UNKNOWN_TYPE;
        case 1:
        case "LIST":
            return SellCategory_ProductIntentType.LIST;
        case 2:
        case "MARKETPLACE":
            return SellCategory_ProductIntentType.MARKETPLACE;
        case 3:
        case "SELL_DIRECT":
            return SellCategory_ProductIntentType.SELL_DIRECT;
        case -1:
        case "UNRECOGNIZED":
        default:
            return SellCategory_ProductIntentType.UNRECOGNIZED;
    }
}
function sellCategory_ProductIntentTypeToJSON(object) {
    switch(object){
        case SellCategory_ProductIntentType.UNKNOWN_TYPE:
            return "UNKNOWN_TYPE";
        case SellCategory_ProductIntentType.LIST:
            return "LIST";
        case SellCategory_ProductIntentType.MARKETPLACE:
            return "MARKETPLACE";
        case SellCategory_ProductIntentType.SELL_DIRECT:
            return "SELL_DIRECT";
        case SellCategory_ProductIntentType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
function createBaseSellCategory() {
    return {
        event: undefined
    };
}
var SellCategory = {
    fromJSON: function fromJSON(object) {
        return {
            event: sell_category_isSet(object.addressEntry) ? {
                $case: "addressEntry",
                addressEntry: SellCategory_AddressEntryEvent.fromJSON(object.addressEntry)
            } : sell_category_isSet(object.apiOfferRequest) ? {
                $case: "apiOfferRequest",
                apiOfferRequest: SellCategory_ApiOfferRequestEvent.fromJSON(object.apiOfferRequest)
            } : sell_category_isSet(object.apiReferralHandover) ? {
                $case: "apiReferralHandover",
                apiReferralHandover: SellCategory_ApiReferralHandoverEvent.fromJSON(object.apiReferralHandover)
            } : sell_category_isSet(object.onboardingStart) ? {
                $case: "onboardingStart",
                onboardingStart: SellCategory_OnboardingStartEvent.fromJSON(object.onboardingStart)
            } : sell_category_isSet(object.addressEntryV2) ? {
                $case: "addressEntryV2",
                addressEntryV2: SellCategory_AddressEntryV2Event.fromJSON(object.addressEntryV2)
            } : sell_category_isSet(object.ssvaTaskComplete) ? {
                $case: "ssvaTaskComplete",
                ssvaTaskComplete: SellCategory_SSVATaskCompleteEvent.fromJSON(object.ssvaTaskComplete)
            } : sell_category_isSet(object.customerProductIntentAtFinalOffer) ? {
                $case: "customerProductIntentAtFinalOffer",
                customerProductIntentAtFinalOffer: SellCategory_CustomerProductIntentAtFinalOffer.fromJSON(object.customerProductIntentAtFinalOffer)
            } : sell_category_isSet(object.customerProductIntentPostFinalOffer) ? {
                $case: "customerProductIntentPostFinalOffer",
                customerProductIntentPostFinalOffer: SellCategory_CustomerProductIntentPostFinalOffer.fromJSON(object.customerProductIntentPostFinalOffer)
            } : sell_category_isSet(object.experienceViewed) ? {
                $case: "experienceViewed",
                experienceViewed: SellCategory_ExperienceViewedEvent.fromJSON(object.experienceViewed)
            } : sell_category_isSet(object.signedContract) ? {
                $case: "signedContract",
                signedContract: SellCategory_SignedContractEvent.fromJSON(object.signedContract)
            } : sell_category_isSet(object.productClosed) ? {
                $case: "productClosed",
                productClosed: SellCategory_ProductClosedEvent.fromJSON(object.productClosed)
            } : undefined
        };
    },
    toJSON: function toJSON(message) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
        var obj = {};
        if (((ref = message.event) === null || ref === void 0 ? void 0 : ref.$case) === "addressEntry") {
            obj.addressEntry = SellCategory_AddressEntryEvent.toJSON(message.event.addressEntry);
        }
        if (((ref1 = message.event) === null || ref1 === void 0 ? void 0 : ref1.$case) === "apiOfferRequest") {
            obj.apiOfferRequest = SellCategory_ApiOfferRequestEvent.toJSON(message.event.apiOfferRequest);
        }
        if (((ref2 = message.event) === null || ref2 === void 0 ? void 0 : ref2.$case) === "apiReferralHandover") {
            obj.apiReferralHandover = SellCategory_ApiReferralHandoverEvent.toJSON(message.event.apiReferralHandover);
        }
        if (((ref3 = message.event) === null || ref3 === void 0 ? void 0 : ref3.$case) === "onboardingStart") {
            obj.onboardingStart = SellCategory_OnboardingStartEvent.toJSON(message.event.onboardingStart);
        }
        if (((ref4 = message.event) === null || ref4 === void 0 ? void 0 : ref4.$case) === "addressEntryV2") {
            obj.addressEntryV2 = SellCategory_AddressEntryV2Event.toJSON(message.event.addressEntryV2);
        }
        if (((ref5 = message.event) === null || ref5 === void 0 ? void 0 : ref5.$case) === "ssvaTaskComplete") {
            obj.ssvaTaskComplete = SellCategory_SSVATaskCompleteEvent.toJSON(message.event.ssvaTaskComplete);
        }
        if (((ref6 = message.event) === null || ref6 === void 0 ? void 0 : ref6.$case) === "customerProductIntentAtFinalOffer") {
            obj.customerProductIntentAtFinalOffer = SellCategory_CustomerProductIntentAtFinalOffer.toJSON(message.event.customerProductIntentAtFinalOffer);
        }
        if (((ref7 = message.event) === null || ref7 === void 0 ? void 0 : ref7.$case) === "customerProductIntentPostFinalOffer") {
            obj.customerProductIntentPostFinalOffer = SellCategory_CustomerProductIntentPostFinalOffer.toJSON(message.event.customerProductIntentPostFinalOffer);
        }
        if (((ref8 = message.event) === null || ref8 === void 0 ? void 0 : ref8.$case) === "experienceViewed") {
            obj.experienceViewed = SellCategory_ExperienceViewedEvent.toJSON(message.event.experienceViewed);
        }
        if (((ref9 = message.event) === null || ref9 === void 0 ? void 0 : ref9.$case) === "signedContract") {
            obj.signedContract = SellCategory_SignedContractEvent.toJSON(message.event.signedContract);
        }
        if (((ref10 = message.event) === null || ref10 === void 0 ? void 0 : ref10.$case) === "productClosed") {
            obj.productClosed = SellCategory_ProductClosedEvent.toJSON(message.event.productClosed);
        }
        return obj;
    },
    create: function create(base) {
        return SellCategory.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32;
        var message = createBaseSellCategory();
        if (((ref = object.event) === null || ref === void 0 ? void 0 : ref.$case) === "addressEntry" && ((ref1 = object.event) === null || ref1 === void 0 ? void 0 : ref1.addressEntry) !== undefined && ((ref2 = object.event) === null || ref2 === void 0 ? void 0 : ref2.addressEntry) !== null) {
            message.event = {
                $case: "addressEntry",
                addressEntry: SellCategory_AddressEntryEvent.fromPartial(object.event.addressEntry)
            };
        }
        if (((ref3 = object.event) === null || ref3 === void 0 ? void 0 : ref3.$case) === "apiOfferRequest" && ((ref4 = object.event) === null || ref4 === void 0 ? void 0 : ref4.apiOfferRequest) !== undefined && ((ref5 = object.event) === null || ref5 === void 0 ? void 0 : ref5.apiOfferRequest) !== null) {
            message.event = {
                $case: "apiOfferRequest",
                apiOfferRequest: SellCategory_ApiOfferRequestEvent.fromPartial(object.event.apiOfferRequest)
            };
        }
        if (((ref6 = object.event) === null || ref6 === void 0 ? void 0 : ref6.$case) === "apiReferralHandover" && ((ref7 = object.event) === null || ref7 === void 0 ? void 0 : ref7.apiReferralHandover) !== undefined && ((ref8 = object.event) === null || ref8 === void 0 ? void 0 : ref8.apiReferralHandover) !== null) {
            message.event = {
                $case: "apiReferralHandover",
                apiReferralHandover: SellCategory_ApiReferralHandoverEvent.fromPartial(object.event.apiReferralHandover)
            };
        }
        if (((ref9 = object.event) === null || ref9 === void 0 ? void 0 : ref9.$case) === "onboardingStart" && ((ref10 = object.event) === null || ref10 === void 0 ? void 0 : ref10.onboardingStart) !== undefined && ((ref11 = object.event) === null || ref11 === void 0 ? void 0 : ref11.onboardingStart) !== null) {
            message.event = {
                $case: "onboardingStart",
                onboardingStart: SellCategory_OnboardingStartEvent.fromPartial(object.event.onboardingStart)
            };
        }
        if (((ref12 = object.event) === null || ref12 === void 0 ? void 0 : ref12.$case) === "addressEntryV2" && ((ref13 = object.event) === null || ref13 === void 0 ? void 0 : ref13.addressEntryV2) !== undefined && ((ref14 = object.event) === null || ref14 === void 0 ? void 0 : ref14.addressEntryV2) !== null) {
            message.event = {
                $case: "addressEntryV2",
                addressEntryV2: SellCategory_AddressEntryV2Event.fromPartial(object.event.addressEntryV2)
            };
        }
        if (((ref15 = object.event) === null || ref15 === void 0 ? void 0 : ref15.$case) === "ssvaTaskComplete" && ((ref16 = object.event) === null || ref16 === void 0 ? void 0 : ref16.ssvaTaskComplete) !== undefined && ((ref17 = object.event) === null || ref17 === void 0 ? void 0 : ref17.ssvaTaskComplete) !== null) {
            message.event = {
                $case: "ssvaTaskComplete",
                ssvaTaskComplete: SellCategory_SSVATaskCompleteEvent.fromPartial(object.event.ssvaTaskComplete)
            };
        }
        if (((ref18 = object.event) === null || ref18 === void 0 ? void 0 : ref18.$case) === "customerProductIntentAtFinalOffer" && ((ref19 = object.event) === null || ref19 === void 0 ? void 0 : ref19.customerProductIntentAtFinalOffer) !== undefined && ((ref20 = object.event) === null || ref20 === void 0 ? void 0 : ref20.customerProductIntentAtFinalOffer) !== null) {
            message.event = {
                $case: "customerProductIntentAtFinalOffer",
                customerProductIntentAtFinalOffer: SellCategory_CustomerProductIntentAtFinalOffer.fromPartial(object.event.customerProductIntentAtFinalOffer)
            };
        }
        if (((ref21 = object.event) === null || ref21 === void 0 ? void 0 : ref21.$case) === "customerProductIntentPostFinalOffer" && ((ref22 = object.event) === null || ref22 === void 0 ? void 0 : ref22.customerProductIntentPostFinalOffer) !== undefined && ((ref23 = object.event) === null || ref23 === void 0 ? void 0 : ref23.customerProductIntentPostFinalOffer) !== null) {
            message.event = {
                $case: "customerProductIntentPostFinalOffer",
                customerProductIntentPostFinalOffer: SellCategory_CustomerProductIntentPostFinalOffer.fromPartial(object.event.customerProductIntentPostFinalOffer)
            };
        }
        if (((ref24 = object.event) === null || ref24 === void 0 ? void 0 : ref24.$case) === "experienceViewed" && ((ref25 = object.event) === null || ref25 === void 0 ? void 0 : ref25.experienceViewed) !== undefined && ((ref26 = object.event) === null || ref26 === void 0 ? void 0 : ref26.experienceViewed) !== null) {
            message.event = {
                $case: "experienceViewed",
                experienceViewed: SellCategory_ExperienceViewedEvent.fromPartial(object.event.experienceViewed)
            };
        }
        if (((ref27 = object.event) === null || ref27 === void 0 ? void 0 : ref27.$case) === "signedContract" && ((ref28 = object.event) === null || ref28 === void 0 ? void 0 : ref28.signedContract) !== undefined && ((ref29 = object.event) === null || ref29 === void 0 ? void 0 : ref29.signedContract) !== null) {
            message.event = {
                $case: "signedContract",
                signedContract: SellCategory_SignedContractEvent.fromPartial(object.event.signedContract)
            };
        }
        if (((ref30 = object.event) === null || ref30 === void 0 ? void 0 : ref30.$case) === "productClosed" && ((ref31 = object.event) === null || ref31 === void 0 ? void 0 : ref31.productClosed) !== undefined && ((ref32 = object.event) === null || ref32 === void 0 ? void 0 : ref32.productClosed) !== null) {
            message.event = {
                $case: "productClosed",
                productClosed: SellCategory_ProductClosedEvent.fromPartial(object.event.productClosed)
            };
        }
        return message;
    }
};
function createBaseSellCategory_AddressEntryEvent() {
    return {
        street1: "",
        city: "",
        state: "",
        postalCode: "",
        unit: undefined,
        latitude: undefined,
        longitude: undefined,
        receptionChannel: 0,
        sellerInputId: "",
        market: "",
        campaign: undefined
    };
}
var SellCategory_AddressEntryEvent = {
    fromJSON: function fromJSON(object) {
        return {
            street1: sell_category_isSet(object.street1) ? String(object.street1) : "",
            city: sell_category_isSet(object.city) ? String(object.city) : "",
            state: sell_category_isSet(object.state) ? String(object.state) : "",
            postalCode: sell_category_isSet(object.postalCode) ? String(object.postalCode) : "",
            unit: sell_category_isSet(object.unit) ? String(object.unit) : undefined,
            latitude: sell_category_isSet(object.latitude) ? Number(object.latitude) : undefined,
            longitude: sell_category_isSet(object.longitude) ? Number(object.longitude) : undefined,
            receptionChannel: sell_category_isSet(object.receptionChannel) ? sellerInput_ChannelFromJSON(object.receptionChannel) : 0,
            sellerInputId: sell_category_isSet(object.sellerInputId) ? String(object.sellerInputId) : "",
            market: sell_category_isSet(object.market) ? String(object.market) : "",
            campaign: sell_category_isSet(object.campaign) ? String(object.campaign) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.street1 !== "") {
            obj.street1 = message.street1;
        }
        if (message.city !== "") {
            obj.city = message.city;
        }
        if (message.state !== "") {
            obj.state = message.state;
        }
        if (message.postalCode !== "") {
            obj.postalCode = message.postalCode;
        }
        if (message.unit !== undefined) {
            obj.unit = message.unit;
        }
        if (message.latitude !== undefined) {
            obj.latitude = message.latitude;
        }
        if (message.longitude !== undefined) {
            obj.longitude = message.longitude;
        }
        if (message.receptionChannel !== 0) {
            obj.receptionChannel = sellerInput_ChannelToJSON(message.receptionChannel);
        }
        if (message.sellerInputId !== "") {
            obj.sellerInputId = message.sellerInputId;
        }
        if (message.market !== "") {
            obj.market = message.market;
        }
        if (message.campaign !== undefined) {
            obj.campaign = message.campaign;
        }
        return obj;
    },
    create: function create(base) {
        return SellCategory_AddressEntryEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseSellCategory_AddressEntryEvent();
        var _street1;
        message.street1 = (_street1 = object.street1) !== null && _street1 !== void 0 ? _street1 : "";
        var _city;
        message.city = (_city = object.city) !== null && _city !== void 0 ? _city : "";
        var _state;
        message.state = (_state = object.state) !== null && _state !== void 0 ? _state : "";
        var _postalCode;
        message.postalCode = (_postalCode = object.postalCode) !== null && _postalCode !== void 0 ? _postalCode : "";
        var _unit;
        message.unit = (_unit = object.unit) !== null && _unit !== void 0 ? _unit : undefined;
        var _latitude;
        message.latitude = (_latitude = object.latitude) !== null && _latitude !== void 0 ? _latitude : undefined;
        var _longitude;
        message.longitude = (_longitude = object.longitude) !== null && _longitude !== void 0 ? _longitude : undefined;
        var _receptionChannel;
        message.receptionChannel = (_receptionChannel = object.receptionChannel) !== null && _receptionChannel !== void 0 ? _receptionChannel : 0;
        var _sellerInputId;
        message.sellerInputId = (_sellerInputId = object.sellerInputId) !== null && _sellerInputId !== void 0 ? _sellerInputId : "";
        var _market;
        message.market = (_market = object.market) !== null && _market !== void 0 ? _market : "";
        var _campaign;
        message.campaign = (_campaign = object.campaign) !== null && _campaign !== void 0 ? _campaign : undefined;
        return message;
    }
};
function createBaseSellCategory_OnboardingStartEvent() {
    return {
        street1: "",
        city: "",
        state: "",
        postalCode: "",
        unit: undefined,
        latitude: undefined,
        longitude: undefined,
        receptionChannel: 0,
        sellerInputUuid: "",
        market: undefined
    };
}
var SellCategory_OnboardingStartEvent = {
    fromJSON: function fromJSON(object) {
        return {
            street1: sell_category_isSet(object.street1) ? String(object.street1) : "",
            city: sell_category_isSet(object.city) ? String(object.city) : "",
            state: sell_category_isSet(object.state) ? String(object.state) : "",
            postalCode: sell_category_isSet(object.postalCode) ? String(object.postalCode) : "",
            unit: sell_category_isSet(object.unit) ? String(object.unit) : undefined,
            latitude: sell_category_isSet(object.latitude) ? Number(object.latitude) : undefined,
            longitude: sell_category_isSet(object.longitude) ? Number(object.longitude) : undefined,
            receptionChannel: sell_category_isSet(object.receptionChannel) ? sellerInput_ChannelFromJSON(object.receptionChannel) : 0,
            sellerInputUuid: sell_category_isSet(object.sellerInputUuid) ? String(object.sellerInputUuid) : "",
            market: sell_category_isSet(object.market) ? String(object.market) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.street1 !== "") {
            obj.street1 = message.street1;
        }
        if (message.city !== "") {
            obj.city = message.city;
        }
        if (message.state !== "") {
            obj.state = message.state;
        }
        if (message.postalCode !== "") {
            obj.postalCode = message.postalCode;
        }
        if (message.unit !== undefined) {
            obj.unit = message.unit;
        }
        if (message.latitude !== undefined) {
            obj.latitude = message.latitude;
        }
        if (message.longitude !== undefined) {
            obj.longitude = message.longitude;
        }
        if (message.receptionChannel !== 0) {
            obj.receptionChannel = sellerInput_ChannelToJSON(message.receptionChannel);
        }
        if (message.sellerInputUuid !== "") {
            obj.sellerInputUuid = message.sellerInputUuid;
        }
        if (message.market !== undefined) {
            obj.market = message.market;
        }
        return obj;
    },
    create: function create(base) {
        return SellCategory_OnboardingStartEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseSellCategory_OnboardingStartEvent();
        var _street1;
        message.street1 = (_street1 = object.street1) !== null && _street1 !== void 0 ? _street1 : "";
        var _city;
        message.city = (_city = object.city) !== null && _city !== void 0 ? _city : "";
        var _state;
        message.state = (_state = object.state) !== null && _state !== void 0 ? _state : "";
        var _postalCode;
        message.postalCode = (_postalCode = object.postalCode) !== null && _postalCode !== void 0 ? _postalCode : "";
        var _unit;
        message.unit = (_unit = object.unit) !== null && _unit !== void 0 ? _unit : undefined;
        var _latitude;
        message.latitude = (_latitude = object.latitude) !== null && _latitude !== void 0 ? _latitude : undefined;
        var _longitude;
        message.longitude = (_longitude = object.longitude) !== null && _longitude !== void 0 ? _longitude : undefined;
        var _receptionChannel;
        message.receptionChannel = (_receptionChannel = object.receptionChannel) !== null && _receptionChannel !== void 0 ? _receptionChannel : 0;
        var _sellerInputUuid;
        message.sellerInputUuid = (_sellerInputUuid = object.sellerInputUuid) !== null && _sellerInputUuid !== void 0 ? _sellerInputUuid : "";
        var _market;
        message.market = (_market = object.market) !== null && _market !== void 0 ? _market : undefined;
        return message;
    }
};
function createBaseSellCategory_AddressEntryV2Event() {
    return {
        street1: undefined,
        city: undefined,
        state: undefined,
        postalCode: undefined,
        unit: undefined,
        latitude: undefined,
        longitude: undefined,
        market: undefined,
        campaign: undefined,
        sourcePage: undefined
    };
}
var SellCategory_AddressEntryV2Event = {
    fromJSON: function fromJSON(object) {
        return {
            street1: sell_category_isSet(object.street1) ? String(object.street1) : undefined,
            city: sell_category_isSet(object.city) ? String(object.city) : undefined,
            state: sell_category_isSet(object.state) ? String(object.state) : undefined,
            postalCode: sell_category_isSet(object.postalCode) ? String(object.postalCode) : undefined,
            unit: sell_category_isSet(object.unit) ? String(object.unit) : undefined,
            latitude: sell_category_isSet(object.latitude) ? Number(object.latitude) : undefined,
            longitude: sell_category_isSet(object.longitude) ? Number(object.longitude) : undefined,
            market: sell_category_isSet(object.market) ? String(object.market) : undefined,
            campaign: sell_category_isSet(object.campaign) ? String(object.campaign) : undefined,
            sourcePage: sell_category_isSet(object.sourcePage) ? String(object.sourcePage) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.street1 !== undefined) {
            obj.street1 = message.street1;
        }
        if (message.city !== undefined) {
            obj.city = message.city;
        }
        if (message.state !== undefined) {
            obj.state = message.state;
        }
        if (message.postalCode !== undefined) {
            obj.postalCode = message.postalCode;
        }
        if (message.unit !== undefined) {
            obj.unit = message.unit;
        }
        if (message.latitude !== undefined) {
            obj.latitude = message.latitude;
        }
        if (message.longitude !== undefined) {
            obj.longitude = message.longitude;
        }
        if (message.market !== undefined) {
            obj.market = message.market;
        }
        if (message.campaign !== undefined) {
            obj.campaign = message.campaign;
        }
        if (message.sourcePage !== undefined) {
            obj.sourcePage = message.sourcePage;
        }
        return obj;
    },
    create: function create(base) {
        return SellCategory_AddressEntryV2Event.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseSellCategory_AddressEntryV2Event();
        var _street1;
        message.street1 = (_street1 = object.street1) !== null && _street1 !== void 0 ? _street1 : undefined;
        var _city;
        message.city = (_city = object.city) !== null && _city !== void 0 ? _city : undefined;
        var _state;
        message.state = (_state = object.state) !== null && _state !== void 0 ? _state : undefined;
        var _postalCode;
        message.postalCode = (_postalCode = object.postalCode) !== null && _postalCode !== void 0 ? _postalCode : undefined;
        var _unit;
        message.unit = (_unit = object.unit) !== null && _unit !== void 0 ? _unit : undefined;
        var _latitude;
        message.latitude = (_latitude = object.latitude) !== null && _latitude !== void 0 ? _latitude : undefined;
        var _longitude;
        message.longitude = (_longitude = object.longitude) !== null && _longitude !== void 0 ? _longitude : undefined;
        var _market;
        message.market = (_market = object.market) !== null && _market !== void 0 ? _market : undefined;
        var _campaign;
        message.campaign = (_campaign = object.campaign) !== null && _campaign !== void 0 ? _campaign : undefined;
        var _sourcePage;
        message.sourcePage = (_sourcePage = object.sourcePage) !== null && _sourcePage !== void 0 ? _sourcePage : undefined;
        return message;
    }
};
function createBaseSellCategory_ApiOfferRequestEvent() {
    return {
        sellerInputId: "",
        partnerIdentifier: "",
        email: "",
        correlationId: undefined
    };
}
var SellCategory_ApiOfferRequestEvent = {
    fromJSON: function fromJSON(object) {
        return {
            sellerInputId: sell_category_isSet(object.sellerInputId) ? String(object.sellerInputId) : "",
            partnerIdentifier: sell_category_isSet(object.partnerIdentifier) ? String(object.partnerIdentifier) : "",
            email: sell_category_isSet(object.email) ? String(object.email) : "",
            correlationId: sell_category_isSet(object.correlationId) ? String(object.correlationId) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.sellerInputId !== "") {
            obj.sellerInputId = message.sellerInputId;
        }
        if (message.partnerIdentifier !== "") {
            obj.partnerIdentifier = message.partnerIdentifier;
        }
        if (message.email !== "") {
            obj.email = message.email;
        }
        if (message.correlationId !== undefined) {
            obj.correlationId = message.correlationId;
        }
        return obj;
    },
    create: function create(base) {
        return SellCategory_ApiOfferRequestEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseSellCategory_ApiOfferRequestEvent();
        var _sellerInputId;
        message.sellerInputId = (_sellerInputId = object.sellerInputId) !== null && _sellerInputId !== void 0 ? _sellerInputId : "";
        var _partnerIdentifier;
        message.partnerIdentifier = (_partnerIdentifier = object.partnerIdentifier) !== null && _partnerIdentifier !== void 0 ? _partnerIdentifier : "";
        var _email;
        message.email = (_email = object.email) !== null && _email !== void 0 ? _email : "";
        var _correlationId;
        message.correlationId = (_correlationId = object.correlationId) !== null && _correlationId !== void 0 ? _correlationId : undefined;
        return message;
    }
};
function createBaseSellCategory_ApiReferralHandoverEvent() {
    return {
        sellerInputId: "",
        partnerIdentifier: "",
        firstName: undefined,
        lastName: undefined,
        email: "",
        phone: undefined
    };
}
var SellCategory_ApiReferralHandoverEvent = {
    fromJSON: function fromJSON(object) {
        return {
            sellerInputId: sell_category_isSet(object.sellerInputId) ? String(object.sellerInputId) : "",
            partnerIdentifier: sell_category_isSet(object.partnerIdentifier) ? String(object.partnerIdentifier) : "",
            firstName: sell_category_isSet(object.firstName) ? String(object.firstName) : undefined,
            lastName: sell_category_isSet(object.lastName) ? String(object.lastName) : undefined,
            email: sell_category_isSet(object.email) ? String(object.email) : "",
            phone: sell_category_isSet(object.phone) ? String(object.phone) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.sellerInputId !== "") {
            obj.sellerInputId = message.sellerInputId;
        }
        if (message.partnerIdentifier !== "") {
            obj.partnerIdentifier = message.partnerIdentifier;
        }
        if (message.firstName !== undefined) {
            obj.firstName = message.firstName;
        }
        if (message.lastName !== undefined) {
            obj.lastName = message.lastName;
        }
        if (message.email !== "") {
            obj.email = message.email;
        }
        if (message.phone !== undefined) {
            obj.phone = message.phone;
        }
        return obj;
    },
    create: function create(base) {
        return SellCategory_ApiReferralHandoverEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseSellCategory_ApiReferralHandoverEvent();
        var _sellerInputId;
        message.sellerInputId = (_sellerInputId = object.sellerInputId) !== null && _sellerInputId !== void 0 ? _sellerInputId : "";
        var _partnerIdentifier;
        message.partnerIdentifier = (_partnerIdentifier = object.partnerIdentifier) !== null && _partnerIdentifier !== void 0 ? _partnerIdentifier : "";
        var _firstName;
        message.firstName = (_firstName = object.firstName) !== null && _firstName !== void 0 ? _firstName : undefined;
        var _lastName;
        message.lastName = (_lastName = object.lastName) !== null && _lastName !== void 0 ? _lastName : undefined;
        var _email;
        message.email = (_email = object.email) !== null && _email !== void 0 ? _email : "";
        var _phone;
        message.phone = (_phone = object.phone) !== null && _phone !== void 0 ? _phone : undefined;
        return message;
    }
};
function createBaseSellCategory_SSVATaskCompleteEvent() {
    return {
        leadId: "",
        offerId: "",
        ssvaTaskName: 0,
        offerUuid: "",
        sellerLeadUuid: ""
    };
}
var SellCategory_SSVATaskCompleteEvent = {
    fromJSON: function fromJSON(object) {
        return {
            leadId: sell_category_isSet(object.leadId) ? String(object.leadId) : "",
            offerId: sell_category_isSet(object.offerId) ? String(object.offerId) : "",
            ssvaTaskName: sell_category_isSet(object.ssvaTaskName) ? sellCategory_SSVATaskTypeFromJSON(object.ssvaTaskName) : 0,
            offerUuid: sell_category_isSet(object.offerUuid) ? String(object.offerUuid) : "",
            sellerLeadUuid: sell_category_isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.leadId !== "") {
            obj.leadId = message.leadId;
        }
        if (message.offerId !== "") {
            obj.offerId = message.offerId;
        }
        if (message.ssvaTaskName !== 0) {
            obj.ssvaTaskName = sellCategory_SSVATaskTypeToJSON(message.ssvaTaskName);
        }
        if (message.offerUuid !== "") {
            obj.offerUuid = message.offerUuid;
        }
        if (message.sellerLeadUuid !== "") {
            obj.sellerLeadUuid = message.sellerLeadUuid;
        }
        return obj;
    },
    create: function create(base) {
        return SellCategory_SSVATaskCompleteEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseSellCategory_SSVATaskCompleteEvent();
        var _leadId;
        message.leadId = (_leadId = object.leadId) !== null && _leadId !== void 0 ? _leadId : "";
        var _offerId;
        message.offerId = (_offerId = object.offerId) !== null && _offerId !== void 0 ? _offerId : "";
        var _ssvaTaskName;
        message.ssvaTaskName = (_ssvaTaskName = object.ssvaTaskName) !== null && _ssvaTaskName !== void 0 ? _ssvaTaskName : 0;
        var _offerUuid;
        message.offerUuid = (_offerUuid = object.offerUuid) !== null && _offerUuid !== void 0 ? _offerUuid : "";
        var _sellerLeadUuid;
        message.sellerLeadUuid = (_sellerLeadUuid = object.sellerLeadUuid) !== null && _sellerLeadUuid !== void 0 ? _sellerLeadUuid : "";
        return message;
    }
};
function createBaseSellCategory_CustomerProductIntentAtFinalOffer() {
    return {
        leadId: "",
        intent: 0,
        offerUuid: "",
        sellerLeadUuid: ""
    };
}
var SellCategory_CustomerProductIntentAtFinalOffer = {
    fromJSON: function fromJSON(object) {
        return {
            leadId: sell_category_isSet(object.leadId) ? String(object.leadId) : "",
            intent: sell_category_isSet(object.intent) ? sellCategory_ProductIntentTypeFromJSON(object.intent) : 0,
            offerUuid: sell_category_isSet(object.offerUuid) ? String(object.offerUuid) : "",
            sellerLeadUuid: sell_category_isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.leadId !== "") {
            obj.leadId = message.leadId;
        }
        if (message.intent !== 0) {
            obj.intent = sellCategory_ProductIntentTypeToJSON(message.intent);
        }
        if (message.offerUuid !== "") {
            obj.offerUuid = message.offerUuid;
        }
        if (message.sellerLeadUuid !== "") {
            obj.sellerLeadUuid = message.sellerLeadUuid;
        }
        return obj;
    },
    create: function create(base) {
        return SellCategory_CustomerProductIntentAtFinalOffer.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseSellCategory_CustomerProductIntentAtFinalOffer();
        var _leadId;
        message.leadId = (_leadId = object.leadId) !== null && _leadId !== void 0 ? _leadId : "";
        var _intent;
        message.intent = (_intent = object.intent) !== null && _intent !== void 0 ? _intent : 0;
        var _offerUuid;
        message.offerUuid = (_offerUuid = object.offerUuid) !== null && _offerUuid !== void 0 ? _offerUuid : "";
        var _sellerLeadUuid;
        message.sellerLeadUuid = (_sellerLeadUuid = object.sellerLeadUuid) !== null && _sellerLeadUuid !== void 0 ? _sellerLeadUuid : "";
        return message;
    }
};
function createBaseSellCategory_CustomerProductIntentPostFinalOffer() {
    return {
        leadId: "",
        intent: 0,
        offerUuid: "",
        sellerLeadUuid: ""
    };
}
var SellCategory_CustomerProductIntentPostFinalOffer = {
    fromJSON: function fromJSON(object) {
        return {
            leadId: sell_category_isSet(object.leadId) ? String(object.leadId) : "",
            intent: sell_category_isSet(object.intent) ? sellCategory_ProductIntentTypeFromJSON(object.intent) : 0,
            offerUuid: sell_category_isSet(object.offerUuid) ? String(object.offerUuid) : "",
            sellerLeadUuid: sell_category_isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.leadId !== "") {
            obj.leadId = message.leadId;
        }
        if (message.intent !== 0) {
            obj.intent = sellCategory_ProductIntentTypeToJSON(message.intent);
        }
        if (message.offerUuid !== "") {
            obj.offerUuid = message.offerUuid;
        }
        if (message.sellerLeadUuid !== "") {
            obj.sellerLeadUuid = message.sellerLeadUuid;
        }
        return obj;
    },
    create: function create(base) {
        return SellCategory_CustomerProductIntentPostFinalOffer.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseSellCategory_CustomerProductIntentPostFinalOffer();
        var _leadId;
        message.leadId = (_leadId = object.leadId) !== null && _leadId !== void 0 ? _leadId : "";
        var _intent;
        message.intent = (_intent = object.intent) !== null && _intent !== void 0 ? _intent : 0;
        var _offerUuid;
        message.offerUuid = (_offerUuid = object.offerUuid) !== null && _offerUuid !== void 0 ? _offerUuid : "";
        var _sellerLeadUuid;
        message.sellerLeadUuid = (_sellerLeadUuid = object.sellerLeadUuid) !== null && _sellerLeadUuid !== void 0 ? _sellerLeadUuid : "";
        return message;
    }
};
function createBaseSellCategory_ExperienceViewedEvent() {
    return {
        sellerLeadUuid: "",
        offerUuid: "",
        isFirstOffer: false,
        offerState: 0,
        experienceType: 0,
        experienceSlug: undefined
    };
}
var SellCategory_ExperienceViewedEvent = {
    fromJSON: function fromJSON(object) {
        return {
            sellerLeadUuid: sell_category_isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : "",
            offerUuid: sell_category_isSet(object.offerUuid) ? String(object.offerUuid) : "",
            isFirstOffer: sell_category_isSet(object.isFirstOffer) ? Boolean(object.isFirstOffer) : false,
            offerState: sell_category_isSet(object.offerState) ? offer_StateFromJSON(object.offerState) : 0,
            experienceType: sell_category_isSet(object.experienceType) ? sellerExperienceFromJSON(object.experienceType) : 0,
            experienceSlug: sell_category_isSet(object.experienceSlug) ? String(object.experienceSlug) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.sellerLeadUuid !== "") {
            obj.sellerLeadUuid = message.sellerLeadUuid;
        }
        if (message.offerUuid !== "") {
            obj.offerUuid = message.offerUuid;
        }
        if (message.isFirstOffer === true) {
            obj.isFirstOffer = message.isFirstOffer;
        }
        if (message.offerState !== 0) {
            obj.offerState = offer_StateToJSON(message.offerState);
        }
        if (message.experienceType !== 0) {
            obj.experienceType = sellerExperienceToJSON(message.experienceType);
        }
        if (message.experienceSlug !== undefined) {
            obj.experienceSlug = message.experienceSlug;
        }
        return obj;
    },
    create: function create(base) {
        return SellCategory_ExperienceViewedEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseSellCategory_ExperienceViewedEvent();
        var _sellerLeadUuid;
        message.sellerLeadUuid = (_sellerLeadUuid = object.sellerLeadUuid) !== null && _sellerLeadUuid !== void 0 ? _sellerLeadUuid : "";
        var _offerUuid;
        message.offerUuid = (_offerUuid = object.offerUuid) !== null && _offerUuid !== void 0 ? _offerUuid : "";
        var _isFirstOffer;
        message.isFirstOffer = (_isFirstOffer = object.isFirstOffer) !== null && _isFirstOffer !== void 0 ? _isFirstOffer : false;
        var _offerState;
        message.offerState = (_offerState = object.offerState) !== null && _offerState !== void 0 ? _offerState : 0;
        var _experienceType;
        message.experienceType = (_experienceType = object.experienceType) !== null && _experienceType !== void 0 ? _experienceType : 0;
        var _experienceSlug;
        message.experienceSlug = (_experienceSlug = object.experienceSlug) !== null && _experienceSlug !== void 0 ? _experienceSlug : undefined;
        return message;
    }
};
function createBaseSellCategory_SignedContractEvent() {
    return {
        sellerLeadUuid: "",
        offerUuid: undefined,
        product: 0
    };
}
var SellCategory_SignedContractEvent = {
    fromJSON: function fromJSON(object) {
        return {
            sellerLeadUuid: sell_category_isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : "",
            offerUuid: sell_category_isSet(object.offerUuid) ? String(object.offerUuid) : undefined,
            product: sell_category_isSet(object.product) ? productFromJSON(object.product) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.sellerLeadUuid !== "") {
            obj.sellerLeadUuid = message.sellerLeadUuid;
        }
        if (message.offerUuid !== undefined) {
            obj.offerUuid = message.offerUuid;
        }
        if (message.product !== 0) {
            obj.product = productToJSON(message.product);
        }
        return obj;
    },
    create: function create(base) {
        return SellCategory_SignedContractEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseSellCategory_SignedContractEvent();
        var _sellerLeadUuid;
        message.sellerLeadUuid = (_sellerLeadUuid = object.sellerLeadUuid) !== null && _sellerLeadUuid !== void 0 ? _sellerLeadUuid : "";
        var _offerUuid;
        message.offerUuid = (_offerUuid = object.offerUuid) !== null && _offerUuid !== void 0 ? _offerUuid : undefined;
        var _product;
        message.product = (_product = object.product) !== null && _product !== void 0 ? _product : 0;
        return message;
    }
};
function createBaseSellCategory_ProductClosedEvent() {
    return {
        sellerLeadUuid: "",
        offerUuid: undefined,
        product: 0
    };
}
var SellCategory_ProductClosedEvent = {
    fromJSON: function fromJSON(object) {
        return {
            sellerLeadUuid: sell_category_isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : "",
            offerUuid: sell_category_isSet(object.offerUuid) ? String(object.offerUuid) : undefined,
            product: sell_category_isSet(object.product) ? productFromJSON(object.product) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.sellerLeadUuid !== "") {
            obj.sellerLeadUuid = message.sellerLeadUuid;
        }
        if (message.offerUuid !== undefined) {
            obj.offerUuid = message.offerUuid;
        }
        if (message.product !== 0) {
            obj.product = productToJSON(message.product);
        }
        return obj;
    },
    create: function create(base) {
        return SellCategory_ProductClosedEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseSellCategory_ProductClosedEvent();
        var _sellerLeadUuid;
        message.sellerLeadUuid = (_sellerLeadUuid = object.sellerLeadUuid) !== null && _sellerLeadUuid !== void 0 ? _sellerLeadUuid : "";
        var _offerUuid;
        message.offerUuid = (_offerUuid = object.offerUuid) !== null && _offerUuid !== void 0 ? _offerUuid : undefined;
        var _product;
        message.product = (_product = object.product) !== null && _product !== void 0 ? _product : 0;
        return message;
    }
};
function sell_category_isSet(value) {
    return value !== null && value !== undefined;
}

;// CONCATENATED MODULE: ./src/__generated__/protobuf/journey/data/categories/sell_direct_category.ts
/* eslint-disable */ 


var sell_direct_category_protobufPackage = "od_protos.journey.data.categories";
var SellDirectCategory_FallthroughType;
(function(SellDirectCategory_FallthroughType) {
    SellDirectCategory_FallthroughType[SellDirectCategory_FallthroughType["UNKNOWN_FALLTHROUGH_TYPE"] = 0] = "UNKNOWN_FALLTHROUGH_TYPE";
    SellDirectCategory_FallthroughType[SellDirectCategory_FallthroughType["OD_WALK"] = 1] = "OD_WALK";
    SellDirectCategory_FallthroughType[SellDirectCategory_FallthroughType["SELLER_WALK"] = 2] = "SELLER_WALK";
    SellDirectCategory_FallthroughType[SellDirectCategory_FallthroughType["EXPIRATION"] = 3] = "EXPIRATION";
    SellDirectCategory_FallthroughType[SellDirectCategory_FallthroughType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(SellDirectCategory_FallthroughType || (SellDirectCategory_FallthroughType = {}));
function sellDirectCategory_FallthroughTypeFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN_FALLTHROUGH_TYPE":
            return SellDirectCategory_FallthroughType.UNKNOWN_FALLTHROUGH_TYPE;
        case 1:
        case "OD_WALK":
            return SellDirectCategory_FallthroughType.OD_WALK;
        case 2:
        case "SELLER_WALK":
            return SellDirectCategory_FallthroughType.SELLER_WALK;
        case 3:
        case "EXPIRATION":
            return SellDirectCategory_FallthroughType.EXPIRATION;
        case -1:
        case "UNRECOGNIZED":
        default:
            return SellDirectCategory_FallthroughType.UNRECOGNIZED;
    }
}
function sellDirectCategory_FallthroughTypeToJSON(object) {
    switch(object){
        case SellDirectCategory_FallthroughType.UNKNOWN_FALLTHROUGH_TYPE:
            return "UNKNOWN_FALLTHROUGH_TYPE";
        case SellDirectCategory_FallthroughType.OD_WALK:
            return "OD_WALK";
        case SellDirectCategory_FallthroughType.SELLER_WALK:
            return "SELLER_WALK";
        case SellDirectCategory_FallthroughType.EXPIRATION:
            return "EXPIRATION";
        case SellDirectCategory_FallthroughType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var SellDirectCategory_QualificationEvent_QualificationDecision;
(function(SellDirectCategory_QualificationEvent_QualificationDecision) {
    SellDirectCategory_QualificationEvent_QualificationDecision[SellDirectCategory_QualificationEvent_QualificationDecision["UNKNOWN"] = 0] = "UNKNOWN";
    SellDirectCategory_QualificationEvent_QualificationDecision[SellDirectCategory_QualificationEvent_QualificationDecision["PRODUCT_QUALIFIED"] = 1] = "PRODUCT_QUALIFIED";
    SellDirectCategory_QualificationEvent_QualificationDecision[SellDirectCategory_QualificationEvent_QualificationDecision["PRODUCT_DENIED"] = 2] = "PRODUCT_DENIED";
    SellDirectCategory_QualificationEvent_QualificationDecision[SellDirectCategory_QualificationEvent_QualificationDecision["PRODUCT_UNDENIED"] = 3] = "PRODUCT_UNDENIED";
    SellDirectCategory_QualificationEvent_QualificationDecision[SellDirectCategory_QualificationEvent_QualificationDecision["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(SellDirectCategory_QualificationEvent_QualificationDecision || (SellDirectCategory_QualificationEvent_QualificationDecision = {}));
function sellDirectCategory_QualificationEvent_QualificationDecisionFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN":
            return SellDirectCategory_QualificationEvent_QualificationDecision.UNKNOWN;
        case 1:
        case "PRODUCT_QUALIFIED":
            return SellDirectCategory_QualificationEvent_QualificationDecision.PRODUCT_QUALIFIED;
        case 2:
        case "PRODUCT_DENIED":
            return SellDirectCategory_QualificationEvent_QualificationDecision.PRODUCT_DENIED;
        case 3:
        case "PRODUCT_UNDENIED":
            return SellDirectCategory_QualificationEvent_QualificationDecision.PRODUCT_UNDENIED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return SellDirectCategory_QualificationEvent_QualificationDecision.UNRECOGNIZED;
    }
}
function sellDirectCategory_QualificationEvent_QualificationDecisionToJSON(object) {
    switch(object){
        case SellDirectCategory_QualificationEvent_QualificationDecision.UNKNOWN:
            return "UNKNOWN";
        case SellDirectCategory_QualificationEvent_QualificationDecision.PRODUCT_QUALIFIED:
            return "PRODUCT_QUALIFIED";
        case SellDirectCategory_QualificationEvent_QualificationDecision.PRODUCT_DENIED:
            return "PRODUCT_DENIED";
        case SellDirectCategory_QualificationEvent_QualificationDecision.PRODUCT_UNDENIED:
            return "PRODUCT_UNDENIED";
        case SellDirectCategory_QualificationEvent_QualificationDecision.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
function createBaseSellDirectCategory() {
    return {
        event: undefined
    };
}
var SellDirectCategory = {
    fromJSON: function fromJSON(object) {
        return {
            event: sell_direct_category_isSet(object.qualification) ? {
                $case: "qualification",
                qualification: SellDirectCategory_QualificationEvent.fromJSON(object.qualification)
            } : sell_direct_category_isSet(object.offerCreated) ? {
                $case: "offerCreated",
                offerCreated: SellDirectCategory_OfferCreatedEvent.fromJSON(object.offerCreated)
            } : sell_direct_category_isSet(object.offerView) ? {
                $case: "offerView",
                offerView: SellDirectCategory_OfferViewEvent.fromJSON(object.offerView)
            } : sell_direct_category_isSet(object.offerFallthrough) ? {
                $case: "offerFallthrough",
                offerFallthrough: SellDirectCategory_OfferFallthroughEvent.fromJSON(object.offerFallthrough)
            } : sell_direct_category_isSet(object.finalOfferCreated) ? {
                $case: "finalOfferCreated",
                finalOfferCreated: SellDirectCategory_FinalOfferCreatedEvent.fromJSON(object.finalOfferCreated)
            } : sell_direct_category_isSet(object.signStart) ? {
                $case: "signStart",
                signStart: SellDirectCategory_SignStartEvent.fromJSON(object.signStart)
            } : sell_direct_category_isSet(object.signQuestionsSubmit) ? {
                $case: "signQuestionsSubmit",
                signQuestionsSubmit: SellDirectCategory_SignQuestionsSubmitEvent.fromJSON(object.signQuestionsSubmit)
            } : sell_direct_category_isSet(object.signComplete) ? {
                $case: "signComplete",
                signComplete: SellDirectCategory_SignCompleteEvent.fromJSON(object.signComplete)
            } : undefined
        };
    },
    toJSON: function toJSON(message) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
        var obj = {};
        if (((ref = message.event) === null || ref === void 0 ? void 0 : ref.$case) === "qualification") {
            obj.qualification = SellDirectCategory_QualificationEvent.toJSON(message.event.qualification);
        }
        if (((ref1 = message.event) === null || ref1 === void 0 ? void 0 : ref1.$case) === "offerCreated") {
            obj.offerCreated = SellDirectCategory_OfferCreatedEvent.toJSON(message.event.offerCreated);
        }
        if (((ref2 = message.event) === null || ref2 === void 0 ? void 0 : ref2.$case) === "offerView") {
            obj.offerView = SellDirectCategory_OfferViewEvent.toJSON(message.event.offerView);
        }
        if (((ref3 = message.event) === null || ref3 === void 0 ? void 0 : ref3.$case) === "offerFallthrough") {
            obj.offerFallthrough = SellDirectCategory_OfferFallthroughEvent.toJSON(message.event.offerFallthrough);
        }
        if (((ref4 = message.event) === null || ref4 === void 0 ? void 0 : ref4.$case) === "finalOfferCreated") {
            obj.finalOfferCreated = SellDirectCategory_FinalOfferCreatedEvent.toJSON(message.event.finalOfferCreated);
        }
        if (((ref5 = message.event) === null || ref5 === void 0 ? void 0 : ref5.$case) === "signStart") {
            obj.signStart = SellDirectCategory_SignStartEvent.toJSON(message.event.signStart);
        }
        if (((ref6 = message.event) === null || ref6 === void 0 ? void 0 : ref6.$case) === "signQuestionsSubmit") {
            obj.signQuestionsSubmit = SellDirectCategory_SignQuestionsSubmitEvent.toJSON(message.event.signQuestionsSubmit);
        }
        if (((ref7 = message.event) === null || ref7 === void 0 ? void 0 : ref7.$case) === "signComplete") {
            obj.signComplete = SellDirectCategory_SignCompleteEvent.toJSON(message.event.signComplete);
        }
        return obj;
    },
    create: function create(base) {
        return SellDirectCategory.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23;
        var message = createBaseSellDirectCategory();
        if (((ref = object.event) === null || ref === void 0 ? void 0 : ref.$case) === "qualification" && ((ref1 = object.event) === null || ref1 === void 0 ? void 0 : ref1.qualification) !== undefined && ((ref2 = object.event) === null || ref2 === void 0 ? void 0 : ref2.qualification) !== null) {
            message.event = {
                $case: "qualification",
                qualification: SellDirectCategory_QualificationEvent.fromPartial(object.event.qualification)
            };
        }
        if (((ref3 = object.event) === null || ref3 === void 0 ? void 0 : ref3.$case) === "offerCreated" && ((ref4 = object.event) === null || ref4 === void 0 ? void 0 : ref4.offerCreated) !== undefined && ((ref5 = object.event) === null || ref5 === void 0 ? void 0 : ref5.offerCreated) !== null) {
            message.event = {
                $case: "offerCreated",
                offerCreated: SellDirectCategory_OfferCreatedEvent.fromPartial(object.event.offerCreated)
            };
        }
        if (((ref6 = object.event) === null || ref6 === void 0 ? void 0 : ref6.$case) === "offerView" && ((ref7 = object.event) === null || ref7 === void 0 ? void 0 : ref7.offerView) !== undefined && ((ref8 = object.event) === null || ref8 === void 0 ? void 0 : ref8.offerView) !== null) {
            message.event = {
                $case: "offerView",
                offerView: SellDirectCategory_OfferViewEvent.fromPartial(object.event.offerView)
            };
        }
        if (((ref9 = object.event) === null || ref9 === void 0 ? void 0 : ref9.$case) === "offerFallthrough" && ((ref10 = object.event) === null || ref10 === void 0 ? void 0 : ref10.offerFallthrough) !== undefined && ((ref11 = object.event) === null || ref11 === void 0 ? void 0 : ref11.offerFallthrough) !== null) {
            message.event = {
                $case: "offerFallthrough",
                offerFallthrough: SellDirectCategory_OfferFallthroughEvent.fromPartial(object.event.offerFallthrough)
            };
        }
        if (((ref12 = object.event) === null || ref12 === void 0 ? void 0 : ref12.$case) === "finalOfferCreated" && ((ref13 = object.event) === null || ref13 === void 0 ? void 0 : ref13.finalOfferCreated) !== undefined && ((ref14 = object.event) === null || ref14 === void 0 ? void 0 : ref14.finalOfferCreated) !== null) {
            message.event = {
                $case: "finalOfferCreated",
                finalOfferCreated: SellDirectCategory_FinalOfferCreatedEvent.fromPartial(object.event.finalOfferCreated)
            };
        }
        if (((ref15 = object.event) === null || ref15 === void 0 ? void 0 : ref15.$case) === "signStart" && ((ref16 = object.event) === null || ref16 === void 0 ? void 0 : ref16.signStart) !== undefined && ((ref17 = object.event) === null || ref17 === void 0 ? void 0 : ref17.signStart) !== null) {
            message.event = {
                $case: "signStart",
                signStart: SellDirectCategory_SignStartEvent.fromPartial(object.event.signStart)
            };
        }
        if (((ref18 = object.event) === null || ref18 === void 0 ? void 0 : ref18.$case) === "signQuestionsSubmit" && ((ref19 = object.event) === null || ref19 === void 0 ? void 0 : ref19.signQuestionsSubmit) !== undefined && ((ref20 = object.event) === null || ref20 === void 0 ? void 0 : ref20.signQuestionsSubmit) !== null) {
            message.event = {
                $case: "signQuestionsSubmit",
                signQuestionsSubmit: SellDirectCategory_SignQuestionsSubmitEvent.fromPartial(object.event.signQuestionsSubmit)
            };
        }
        if (((ref21 = object.event) === null || ref21 === void 0 ? void 0 : ref21.$case) === "signComplete" && ((ref22 = object.event) === null || ref22 === void 0 ? void 0 : ref22.signComplete) !== undefined && ((ref23 = object.event) === null || ref23 === void 0 ? void 0 : ref23.signComplete) !== null) {
            message.event = {
                $case: "signComplete",
                signComplete: SellDirectCategory_SignCompleteEvent.fromPartial(object.event.signComplete)
            };
        }
        return message;
    }
};
function createBaseSellDirectCategory_QualificationEvent() {
    return {
        sellerInputId: "",
        qualificationChannel: 0,
        qualificationDecision: 0,
        denialReason: undefined
    };
}
var SellDirectCategory_QualificationEvent = {
    fromJSON: function fromJSON(object) {
        return {
            sellerInputId: sell_direct_category_isSet(object.sellerInputId) ? String(object.sellerInputId) : "",
            qualificationChannel: sell_direct_category_isSet(object.qualificationChannel) ? sellerInput_ChannelFromJSON(object.qualificationChannel) : 0,
            qualificationDecision: sell_direct_category_isSet(object.qualificationDecision) ? sellDirectCategory_QualificationEvent_QualificationDecisionFromJSON(object.qualificationDecision) : 0,
            denialReason: sell_direct_category_isSet(object.denialReason) ? String(object.denialReason) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.sellerInputId !== "") {
            obj.sellerInputId = message.sellerInputId;
        }
        if (message.qualificationChannel !== 0) {
            obj.qualificationChannel = sellerInput_ChannelToJSON(message.qualificationChannel);
        }
        if (message.qualificationDecision !== 0) {
            obj.qualificationDecision = sellDirectCategory_QualificationEvent_QualificationDecisionToJSON(message.qualificationDecision);
        }
        if (message.denialReason !== undefined) {
            obj.denialReason = message.denialReason;
        }
        return obj;
    },
    create: function create(base) {
        return SellDirectCategory_QualificationEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseSellDirectCategory_QualificationEvent();
        var _sellerInputId;
        message.sellerInputId = (_sellerInputId = object.sellerInputId) !== null && _sellerInputId !== void 0 ? _sellerInputId : "";
        var _qualificationChannel;
        message.qualificationChannel = (_qualificationChannel = object.qualificationChannel) !== null && _qualificationChannel !== void 0 ? _qualificationChannel : 0;
        var _qualificationDecision;
        message.qualificationDecision = (_qualificationDecision = object.qualificationDecision) !== null && _qualificationDecision !== void 0 ? _qualificationDecision : 0;
        var _denialReason;
        message.denialReason = (_denialReason = object.denialReason) !== null && _denialReason !== void 0 ? _denialReason : undefined;
        return message;
    }
};
function createBaseSellDirectCategory_OfferCreatedEvent() {
    return {
        offerCreationSource: 0,
        opendoorInitiated: false,
        offerIsRefresh: false,
        offerRefreshIndex: undefined,
        leadId: "",
        offerId: "",
        headlineOffer: 0,
        internalFeePct: 0,
        headlineFeePct: 0,
        offerUuid: "",
        sellerInputId: "",
        ovmExpectedError: 0,
        sellerLeadUuid: ""
    };
}
var SellDirectCategory_OfferCreatedEvent = {
    fromJSON: function fromJSON(object) {
        return {
            offerCreationSource: sell_direct_category_isSet(object.offerCreationSource) ? offerRequest_SourceFromJSON(object.offerCreationSource) : 0,
            opendoorInitiated: sell_direct_category_isSet(object.opendoorInitiated) ? Boolean(object.opendoorInitiated) : false,
            offerIsRefresh: sell_direct_category_isSet(object.offerIsRefresh) ? Boolean(object.offerIsRefresh) : false,
            offerRefreshIndex: sell_direct_category_isSet(object.offerRefreshIndex) ? Number(object.offerRefreshIndex) : undefined,
            leadId: sell_direct_category_isSet(object.leadId) ? String(object.leadId) : "",
            offerId: sell_direct_category_isSet(object.offerId) ? String(object.offerId) : "",
            headlineOffer: sell_direct_category_isSet(object.headlineOffer) ? Number(object.headlineOffer) : 0,
            internalFeePct: sell_direct_category_isSet(object.internalFeePct) ? Number(object.internalFeePct) : 0,
            headlineFeePct: sell_direct_category_isSet(object.headlineFeePct) ? Number(object.headlineFeePct) : 0,
            offerUuid: sell_direct_category_isSet(object.offerUuid) ? String(object.offerUuid) : "",
            sellerInputId: sell_direct_category_isSet(object.sellerInputId) ? String(object.sellerInputId) : "",
            ovmExpectedError: sell_direct_category_isSet(object.ovmExpectedError) ? Number(object.ovmExpectedError) : 0,
            sellerLeadUuid: sell_direct_category_isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.offerCreationSource !== 0) {
            obj.offerCreationSource = offerRequest_SourceToJSON(message.offerCreationSource);
        }
        if (message.opendoorInitiated === true) {
            obj.opendoorInitiated = message.opendoorInitiated;
        }
        if (message.offerIsRefresh === true) {
            obj.offerIsRefresh = message.offerIsRefresh;
        }
        if (message.offerRefreshIndex !== undefined) {
            obj.offerRefreshIndex = message.offerRefreshIndex;
        }
        if (message.leadId !== "") {
            obj.leadId = message.leadId;
        }
        if (message.offerId !== "") {
            obj.offerId = message.offerId;
        }
        if (message.headlineOffer !== 0) {
            obj.headlineOffer = Math.round(message.headlineOffer);
        }
        if (message.internalFeePct !== 0) {
            obj.internalFeePct = message.internalFeePct;
        }
        if (message.headlineFeePct !== 0) {
            obj.headlineFeePct = message.headlineFeePct;
        }
        if (message.offerUuid !== "") {
            obj.offerUuid = message.offerUuid;
        }
        if (message.sellerInputId !== "") {
            obj.sellerInputId = message.sellerInputId;
        }
        if (message.ovmExpectedError !== 0) {
            obj.ovmExpectedError = message.ovmExpectedError;
        }
        if (message.sellerLeadUuid !== "") {
            obj.sellerLeadUuid = message.sellerLeadUuid;
        }
        return obj;
    },
    create: function create(base) {
        return SellDirectCategory_OfferCreatedEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseSellDirectCategory_OfferCreatedEvent();
        var _offerCreationSource;
        message.offerCreationSource = (_offerCreationSource = object.offerCreationSource) !== null && _offerCreationSource !== void 0 ? _offerCreationSource : 0;
        var _opendoorInitiated;
        message.opendoorInitiated = (_opendoorInitiated = object.opendoorInitiated) !== null && _opendoorInitiated !== void 0 ? _opendoorInitiated : false;
        var _offerIsRefresh;
        message.offerIsRefresh = (_offerIsRefresh = object.offerIsRefresh) !== null && _offerIsRefresh !== void 0 ? _offerIsRefresh : false;
        var _offerRefreshIndex;
        message.offerRefreshIndex = (_offerRefreshIndex = object.offerRefreshIndex) !== null && _offerRefreshIndex !== void 0 ? _offerRefreshIndex : undefined;
        var _leadId;
        message.leadId = (_leadId = object.leadId) !== null && _leadId !== void 0 ? _leadId : "";
        var _offerId;
        message.offerId = (_offerId = object.offerId) !== null && _offerId !== void 0 ? _offerId : "";
        var _headlineOffer;
        message.headlineOffer = (_headlineOffer = object.headlineOffer) !== null && _headlineOffer !== void 0 ? _headlineOffer : 0;
        var _internalFeePct;
        message.internalFeePct = (_internalFeePct = object.internalFeePct) !== null && _internalFeePct !== void 0 ? _internalFeePct : 0;
        var _headlineFeePct;
        message.headlineFeePct = (_headlineFeePct = object.headlineFeePct) !== null && _headlineFeePct !== void 0 ? _headlineFeePct : 0;
        var _offerUuid;
        message.offerUuid = (_offerUuid = object.offerUuid) !== null && _offerUuid !== void 0 ? _offerUuid : "";
        var _sellerInputId;
        message.sellerInputId = (_sellerInputId = object.sellerInputId) !== null && _sellerInputId !== void 0 ? _sellerInputId : "";
        var _ovmExpectedError;
        message.ovmExpectedError = (_ovmExpectedError = object.ovmExpectedError) !== null && _ovmExpectedError !== void 0 ? _ovmExpectedError : 0;
        var _sellerLeadUuid;
        message.sellerLeadUuid = (_sellerLeadUuid = object.sellerLeadUuid) !== null && _sellerLeadUuid !== void 0 ? _sellerLeadUuid : "";
        return message;
    }
};
function createBaseSellDirectCategory_OfferViewEvent() {
    return {
        leadId: "",
        offerId: "",
        offerState: 0,
        offerUuid: "",
        isFirstOffer: false,
        sellerLeadUuid: ""
    };
}
var SellDirectCategory_OfferViewEvent = {
    fromJSON: function fromJSON(object) {
        return {
            leadId: sell_direct_category_isSet(object.leadId) ? String(object.leadId) : "",
            offerId: sell_direct_category_isSet(object.offerId) ? String(object.offerId) : "",
            offerState: sell_direct_category_isSet(object.offerState) ? offer_StateFromJSON(object.offerState) : 0,
            offerUuid: sell_direct_category_isSet(object.offerUuid) ? String(object.offerUuid) : "",
            isFirstOffer: sell_direct_category_isSet(object.isFirstOffer) ? Boolean(object.isFirstOffer) : false,
            sellerLeadUuid: sell_direct_category_isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.leadId !== "") {
            obj.leadId = message.leadId;
        }
        if (message.offerId !== "") {
            obj.offerId = message.offerId;
        }
        if (message.offerState !== 0) {
            obj.offerState = offer_StateToJSON(message.offerState);
        }
        if (message.offerUuid !== "") {
            obj.offerUuid = message.offerUuid;
        }
        if (message.isFirstOffer === true) {
            obj.isFirstOffer = message.isFirstOffer;
        }
        if (message.sellerLeadUuid !== "") {
            obj.sellerLeadUuid = message.sellerLeadUuid;
        }
        return obj;
    },
    create: function create(base) {
        return SellDirectCategory_OfferViewEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseSellDirectCategory_OfferViewEvent();
        var _leadId;
        message.leadId = (_leadId = object.leadId) !== null && _leadId !== void 0 ? _leadId : "";
        var _offerId;
        message.offerId = (_offerId = object.offerId) !== null && _offerId !== void 0 ? _offerId : "";
        var _offerState;
        message.offerState = (_offerState = object.offerState) !== null && _offerState !== void 0 ? _offerState : 0;
        var _offerUuid;
        message.offerUuid = (_offerUuid = object.offerUuid) !== null && _offerUuid !== void 0 ? _offerUuid : "";
        var _isFirstOffer;
        message.isFirstOffer = (_isFirstOffer = object.isFirstOffer) !== null && _isFirstOffer !== void 0 ? _isFirstOffer : false;
        var _sellerLeadUuid;
        message.sellerLeadUuid = (_sellerLeadUuid = object.sellerLeadUuid) !== null && _sellerLeadUuid !== void 0 ? _sellerLeadUuid : "";
        return message;
    }
};
function createBaseSellDirectCategory_OfferFallthroughEvent() {
    return {
        leadId: "",
        offerId: "",
        fallthroughType: 0,
        offerUuid: "",
        sellerLeadUuid: ""
    };
}
var SellDirectCategory_OfferFallthroughEvent = {
    fromJSON: function fromJSON(object) {
        return {
            leadId: sell_direct_category_isSet(object.leadId) ? String(object.leadId) : "",
            offerId: sell_direct_category_isSet(object.offerId) ? String(object.offerId) : "",
            fallthroughType: sell_direct_category_isSet(object.fallthroughType) ? sellDirectCategory_FallthroughTypeFromJSON(object.fallthroughType) : 0,
            offerUuid: sell_direct_category_isSet(object.offerUuid) ? String(object.offerUuid) : "",
            sellerLeadUuid: sell_direct_category_isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.leadId !== "") {
            obj.leadId = message.leadId;
        }
        if (message.offerId !== "") {
            obj.offerId = message.offerId;
        }
        if (message.fallthroughType !== 0) {
            obj.fallthroughType = sellDirectCategory_FallthroughTypeToJSON(message.fallthroughType);
        }
        if (message.offerUuid !== "") {
            obj.offerUuid = message.offerUuid;
        }
        if (message.sellerLeadUuid !== "") {
            obj.sellerLeadUuid = message.sellerLeadUuid;
        }
        return obj;
    },
    create: function create(base) {
        return SellDirectCategory_OfferFallthroughEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseSellDirectCategory_OfferFallthroughEvent();
        var _leadId;
        message.leadId = (_leadId = object.leadId) !== null && _leadId !== void 0 ? _leadId : "";
        var _offerId;
        message.offerId = (_offerId = object.offerId) !== null && _offerId !== void 0 ? _offerId : "";
        var _fallthroughType;
        message.fallthroughType = (_fallthroughType = object.fallthroughType) !== null && _fallthroughType !== void 0 ? _fallthroughType : 0;
        var _offerUuid;
        message.offerUuid = (_offerUuid = object.offerUuid) !== null && _offerUuid !== void 0 ? _offerUuid : "";
        var _sellerLeadUuid;
        message.sellerLeadUuid = (_sellerLeadUuid = object.sellerLeadUuid) !== null && _sellerLeadUuid !== void 0 ? _sellerLeadUuid : "";
        return message;
    }
};
function createBaseSellDirectCategory_FinalOfferCreatedEvent() {
    return {
        leadId: "",
        offerId: "",
        headlinePrice: 0,
        finalizedFeePct: 0,
        offerUuid: "",
        ovmExpectedError: 0,
        underwritingId: "",
        sellerLeadUuid: ""
    };
}
var SellDirectCategory_FinalOfferCreatedEvent = {
    fromJSON: function fromJSON(object) {
        return {
            leadId: sell_direct_category_isSet(object.leadId) ? String(object.leadId) : "",
            offerId: sell_direct_category_isSet(object.offerId) ? String(object.offerId) : "",
            headlinePrice: sell_direct_category_isSet(object.headlinePrice) ? Number(object.headlinePrice) : 0,
            finalizedFeePct: sell_direct_category_isSet(object.finalizedFeePct) ? Number(object.finalizedFeePct) : 0,
            offerUuid: sell_direct_category_isSet(object.offerUuid) ? String(object.offerUuid) : "",
            ovmExpectedError: sell_direct_category_isSet(object.ovmExpectedError) ? Number(object.ovmExpectedError) : 0,
            underwritingId: sell_direct_category_isSet(object.underwritingId) ? String(object.underwritingId) : "",
            sellerLeadUuid: sell_direct_category_isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.leadId !== "") {
            obj.leadId = message.leadId;
        }
        if (message.offerId !== "") {
            obj.offerId = message.offerId;
        }
        if (message.headlinePrice !== 0) {
            obj.headlinePrice = Math.round(message.headlinePrice);
        }
        if (message.finalizedFeePct !== 0) {
            obj.finalizedFeePct = message.finalizedFeePct;
        }
        if (message.offerUuid !== "") {
            obj.offerUuid = message.offerUuid;
        }
        if (message.ovmExpectedError !== 0) {
            obj.ovmExpectedError = message.ovmExpectedError;
        }
        if (message.underwritingId !== "") {
            obj.underwritingId = message.underwritingId;
        }
        if (message.sellerLeadUuid !== "") {
            obj.sellerLeadUuid = message.sellerLeadUuid;
        }
        return obj;
    },
    create: function create(base) {
        return SellDirectCategory_FinalOfferCreatedEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseSellDirectCategory_FinalOfferCreatedEvent();
        var _leadId;
        message.leadId = (_leadId = object.leadId) !== null && _leadId !== void 0 ? _leadId : "";
        var _offerId;
        message.offerId = (_offerId = object.offerId) !== null && _offerId !== void 0 ? _offerId : "";
        var _headlinePrice;
        message.headlinePrice = (_headlinePrice = object.headlinePrice) !== null && _headlinePrice !== void 0 ? _headlinePrice : 0;
        var _finalizedFeePct;
        message.finalizedFeePct = (_finalizedFeePct = object.finalizedFeePct) !== null && _finalizedFeePct !== void 0 ? _finalizedFeePct : 0;
        var _offerUuid;
        message.offerUuid = (_offerUuid = object.offerUuid) !== null && _offerUuid !== void 0 ? _offerUuid : "";
        var _ovmExpectedError;
        message.ovmExpectedError = (_ovmExpectedError = object.ovmExpectedError) !== null && _ovmExpectedError !== void 0 ? _ovmExpectedError : 0;
        var _underwritingId;
        message.underwritingId = (_underwritingId = object.underwritingId) !== null && _underwritingId !== void 0 ? _underwritingId : "";
        var _sellerLeadUuid;
        message.sellerLeadUuid = (_sellerLeadUuid = object.sellerLeadUuid) !== null && _sellerLeadUuid !== void 0 ? _sellerLeadUuid : "";
        return message;
    }
};
function createBaseSellDirectCategory_SignStartEvent() {
    return {
        leadId: "",
        offerId: "",
        offerUuid: "",
        sellerLeadUuid: ""
    };
}
var SellDirectCategory_SignStartEvent = {
    fromJSON: function fromJSON(object) {
        return {
            leadId: sell_direct_category_isSet(object.leadId) ? String(object.leadId) : "",
            offerId: sell_direct_category_isSet(object.offerId) ? String(object.offerId) : "",
            offerUuid: sell_direct_category_isSet(object.offerUuid) ? String(object.offerUuid) : "",
            sellerLeadUuid: sell_direct_category_isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.leadId !== "") {
            obj.leadId = message.leadId;
        }
        if (message.offerId !== "") {
            obj.offerId = message.offerId;
        }
        if (message.offerUuid !== "") {
            obj.offerUuid = message.offerUuid;
        }
        if (message.sellerLeadUuid !== "") {
            obj.sellerLeadUuid = message.sellerLeadUuid;
        }
        return obj;
    },
    create: function create(base) {
        return SellDirectCategory_SignStartEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseSellDirectCategory_SignStartEvent();
        var _leadId;
        message.leadId = (_leadId = object.leadId) !== null && _leadId !== void 0 ? _leadId : "";
        var _offerId;
        message.offerId = (_offerId = object.offerId) !== null && _offerId !== void 0 ? _offerId : "";
        var _offerUuid;
        message.offerUuid = (_offerUuid = object.offerUuid) !== null && _offerUuid !== void 0 ? _offerUuid : "";
        var _sellerLeadUuid;
        message.sellerLeadUuid = (_sellerLeadUuid = object.sellerLeadUuid) !== null && _sellerLeadUuid !== void 0 ? _sellerLeadUuid : "";
        return message;
    }
};
function createBaseSellDirectCategory_SignQuestionsSubmitEvent() {
    return {
        leadId: "",
        offerId: "",
        offerUuid: "",
        sellerLeadUuid: ""
    };
}
var SellDirectCategory_SignQuestionsSubmitEvent = {
    fromJSON: function fromJSON(object) {
        return {
            leadId: sell_direct_category_isSet(object.leadId) ? String(object.leadId) : "",
            offerId: sell_direct_category_isSet(object.offerId) ? String(object.offerId) : "",
            offerUuid: sell_direct_category_isSet(object.offerUuid) ? String(object.offerUuid) : "",
            sellerLeadUuid: sell_direct_category_isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.leadId !== "") {
            obj.leadId = message.leadId;
        }
        if (message.offerId !== "") {
            obj.offerId = message.offerId;
        }
        if (message.offerUuid !== "") {
            obj.offerUuid = message.offerUuid;
        }
        if (message.sellerLeadUuid !== "") {
            obj.sellerLeadUuid = message.sellerLeadUuid;
        }
        return obj;
    },
    create: function create(base) {
        return SellDirectCategory_SignQuestionsSubmitEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseSellDirectCategory_SignQuestionsSubmitEvent();
        var _leadId;
        message.leadId = (_leadId = object.leadId) !== null && _leadId !== void 0 ? _leadId : "";
        var _offerId;
        message.offerId = (_offerId = object.offerId) !== null && _offerId !== void 0 ? _offerId : "";
        var _offerUuid;
        message.offerUuid = (_offerUuid = object.offerUuid) !== null && _offerUuid !== void 0 ? _offerUuid : "";
        var _sellerLeadUuid;
        message.sellerLeadUuid = (_sellerLeadUuid = object.sellerLeadUuid) !== null && _sellerLeadUuid !== void 0 ? _sellerLeadUuid : "";
        return message;
    }
};
function createBaseSellDirectCategory_SignCompleteEvent() {
    return {
        leadId: "",
        offerId: "",
        offerUuid: "",
        headlinePrice: 0,
        sellerLeadUuid: ""
    };
}
var SellDirectCategory_SignCompleteEvent = {
    fromJSON: function fromJSON(object) {
        return {
            leadId: sell_direct_category_isSet(object.leadId) ? String(object.leadId) : "",
            offerId: sell_direct_category_isSet(object.offerId) ? String(object.offerId) : "",
            offerUuid: sell_direct_category_isSet(object.offerUuid) ? String(object.offerUuid) : "",
            headlinePrice: sell_direct_category_isSet(object.headlinePrice) ? Number(object.headlinePrice) : 0,
            sellerLeadUuid: sell_direct_category_isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.leadId !== "") {
            obj.leadId = message.leadId;
        }
        if (message.offerId !== "") {
            obj.offerId = message.offerId;
        }
        if (message.offerUuid !== "") {
            obj.offerUuid = message.offerUuid;
        }
        if (message.headlinePrice !== 0) {
            obj.headlinePrice = Math.round(message.headlinePrice);
        }
        if (message.sellerLeadUuid !== "") {
            obj.sellerLeadUuid = message.sellerLeadUuid;
        }
        return obj;
    },
    create: function create(base) {
        return SellDirectCategory_SignCompleteEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseSellDirectCategory_SignCompleteEvent();
        var _leadId;
        message.leadId = (_leadId = object.leadId) !== null && _leadId !== void 0 ? _leadId : "";
        var _offerId;
        message.offerId = (_offerId = object.offerId) !== null && _offerId !== void 0 ? _offerId : "";
        var _offerUuid;
        message.offerUuid = (_offerUuid = object.offerUuid) !== null && _offerUuid !== void 0 ? _offerUuid : "";
        var _headlinePrice;
        message.headlinePrice = (_headlinePrice = object.headlinePrice) !== null && _headlinePrice !== void 0 ? _headlinePrice : 0;
        var _sellerLeadUuid;
        message.sellerLeadUuid = (_sellerLeadUuid = object.sellerLeadUuid) !== null && _sellerLeadUuid !== void 0 ? _sellerLeadUuid : "";
        return message;
    }
};
function sell_direct_category_isSet(value) {
    return value !== null && value !== undefined;
}

;// CONCATENATED MODULE: ./src/__generated__/protobuf/journey/data/categories/sell_ea_category.ts
/* eslint-disable */ 

var sell_ea_category_protobufPackage = "od_protos.journey.data.categories";
var SellEACategory_EAType;
(function(SellEACategory_EAType) {
    SellEACategory_EAType[SellEACategory_EAType["UNKNOWN_EA_TYPE"] = 0] = "UNKNOWN_EA_TYPE";
    SellEACategory_EAType[SellEACategory_EAType["EXTERIOR_ASSESSMENT"] = 1] = "EXTERIOR_ASSESSMENT";
    SellEACategory_EAType[SellEACategory_EAType["EXTERIOR_VIRTUAL_ASSESSMENT"] = 2] = "EXTERIOR_VIRTUAL_ASSESSMENT";
    SellEACategory_EAType[SellEACategory_EAType[/** HOME_ASSESSMENT - exterior + interior of home */ "HOME_ASSESSMENT"] = 3] = "HOME_ASSESSMENT";
    SellEACategory_EAType[SellEACategory_EAType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(SellEACategory_EAType || (SellEACategory_EAType = {}));
function sellEACategory_EATypeFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN_EA_TYPE":
            return SellEACategory_EAType.UNKNOWN_EA_TYPE;
        case 1:
        case "EXTERIOR_ASSESSMENT":
            return SellEACategory_EAType.EXTERIOR_ASSESSMENT;
        case 2:
        case "EXTERIOR_VIRTUAL_ASSESSMENT":
            return SellEACategory_EAType.EXTERIOR_VIRTUAL_ASSESSMENT;
        case 3:
        case "HOME_ASSESSMENT":
            return SellEACategory_EAType.HOME_ASSESSMENT;
        case -1:
        case "UNRECOGNIZED":
        default:
            return SellEACategory_EAType.UNRECOGNIZED;
    }
}
function sellEACategory_EATypeToJSON(object) {
    switch(object){
        case SellEACategory_EAType.UNKNOWN_EA_TYPE:
            return "UNKNOWN_EA_TYPE";
        case SellEACategory_EAType.EXTERIOR_ASSESSMENT:
            return "EXTERIOR_ASSESSMENT";
        case SellEACategory_EAType.EXTERIOR_VIRTUAL_ASSESSMENT:
            return "EXTERIOR_VIRTUAL_ASSESSMENT";
        case SellEACategory_EAType.HOME_ASSESSMENT:
            return "HOME_ASSESSMENT";
        case SellEACategory_EAType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
function createBaseSellEACategory() {
    return {
        event: undefined
    };
}
var SellEACategory = {
    fromJSON: function fromJSON(object) {
        return {
            event: sell_ea_category_isSet(object.schedule) ? {
                $case: "schedule",
                schedule: SellEACategory_ScheduleEvent.fromJSON(object.schedule)
            } : sell_ea_category_isSet(object.complete) ? {
                $case: "complete",
                complete: SellEACategory_CompleteEvent.fromJSON(object.complete)
            } : undefined
        };
    },
    toJSON: function toJSON(message) {
        var ref, ref1;
        var obj = {};
        if (((ref = message.event) === null || ref === void 0 ? void 0 : ref.$case) === "schedule") {
            obj.schedule = SellEACategory_ScheduleEvent.toJSON(message.event.schedule);
        }
        if (((ref1 = message.event) === null || ref1 === void 0 ? void 0 : ref1.$case) === "complete") {
            obj.complete = SellEACategory_CompleteEvent.toJSON(message.event.complete);
        }
        return obj;
    },
    create: function create(base) {
        return SellEACategory.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref, ref1, ref2, ref3, ref4, ref5;
        var message = createBaseSellEACategory();
        if (((ref = object.event) === null || ref === void 0 ? void 0 : ref.$case) === "schedule" && ((ref1 = object.event) === null || ref1 === void 0 ? void 0 : ref1.schedule) !== undefined && ((ref2 = object.event) === null || ref2 === void 0 ? void 0 : ref2.schedule) !== null) {
            message.event = {
                $case: "schedule",
                schedule: SellEACategory_ScheduleEvent.fromPartial(object.event.schedule)
            };
        }
        if (((ref3 = object.event) === null || ref3 === void 0 ? void 0 : ref3.$case) === "complete" && ((ref4 = object.event) === null || ref4 === void 0 ? void 0 : ref4.complete) !== undefined && ((ref5 = object.event) === null || ref5 === void 0 ? void 0 : ref5.complete) !== null) {
            message.event = {
                $case: "complete",
                complete: SellEACategory_CompleteEvent.fromPartial(object.event.complete)
            };
        }
        return message;
    }
};
function createBaseSellEACategory_ScheduleEvent() {
    return {
        leadId: "",
        offerId: "",
        eaType: 0,
        offerUuid: "",
        scheduledDatetime: undefined,
        sellerLeadUuid: ""
    };
}
var SellEACategory_ScheduleEvent = {
    fromJSON: function fromJSON(object) {
        return {
            leadId: sell_ea_category_isSet(object.leadId) ? String(object.leadId) : "",
            offerId: sell_ea_category_isSet(object.offerId) ? String(object.offerId) : "",
            eaType: sell_ea_category_isSet(object.eaType) ? sellEACategory_EATypeFromJSON(object.eaType) : 0,
            offerUuid: sell_ea_category_isSet(object.offerUuid) ? String(object.offerUuid) : "",
            scheduledDatetime: sell_ea_category_isSet(object.scheduledDatetime) ? sell_ea_category_fromJsonTimestamp(object.scheduledDatetime) : undefined,
            sellerLeadUuid: sell_ea_category_isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.leadId !== "") {
            obj.leadId = message.leadId;
        }
        if (message.offerId !== "") {
            obj.offerId = message.offerId;
        }
        if (message.eaType !== 0) {
            obj.eaType = sellEACategory_EATypeToJSON(message.eaType);
        }
        if (message.offerUuid !== "") {
            obj.offerUuid = message.offerUuid;
        }
        if (message.scheduledDatetime !== undefined) {
            obj.scheduledDatetime = message.scheduledDatetime.toISOString();
        }
        if (message.sellerLeadUuid !== "") {
            obj.sellerLeadUuid = message.sellerLeadUuid;
        }
        return obj;
    },
    create: function create(base) {
        return SellEACategory_ScheduleEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseSellEACategory_ScheduleEvent();
        var _leadId;
        message.leadId = (_leadId = object.leadId) !== null && _leadId !== void 0 ? _leadId : "";
        var _offerId;
        message.offerId = (_offerId = object.offerId) !== null && _offerId !== void 0 ? _offerId : "";
        var _eaType;
        message.eaType = (_eaType = object.eaType) !== null && _eaType !== void 0 ? _eaType : 0;
        var _offerUuid;
        message.offerUuid = (_offerUuid = object.offerUuid) !== null && _offerUuid !== void 0 ? _offerUuid : "";
        var _scheduledDatetime;
        message.scheduledDatetime = (_scheduledDatetime = object.scheduledDatetime) !== null && _scheduledDatetime !== void 0 ? _scheduledDatetime : undefined;
        var _sellerLeadUuid;
        message.sellerLeadUuid = (_sellerLeadUuid = object.sellerLeadUuid) !== null && _sellerLeadUuid !== void 0 ? _sellerLeadUuid : "";
        return message;
    }
};
function createBaseSellEACategory_CompleteEvent() {
    return {
        leadId: "",
        offerId: "",
        eaType: 0,
        offerUuid: "",
        sellerLeadUuid: ""
    };
}
var SellEACategory_CompleteEvent = {
    fromJSON: function fromJSON(object) {
        return {
            leadId: sell_ea_category_isSet(object.leadId) ? String(object.leadId) : "",
            offerId: sell_ea_category_isSet(object.offerId) ? String(object.offerId) : "",
            eaType: sell_ea_category_isSet(object.eaType) ? sellEACategory_EATypeFromJSON(object.eaType) : 0,
            offerUuid: sell_ea_category_isSet(object.offerUuid) ? String(object.offerUuid) : "",
            sellerLeadUuid: sell_ea_category_isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.leadId !== "") {
            obj.leadId = message.leadId;
        }
        if (message.offerId !== "") {
            obj.offerId = message.offerId;
        }
        if (message.eaType !== 0) {
            obj.eaType = sellEACategory_EATypeToJSON(message.eaType);
        }
        if (message.offerUuid !== "") {
            obj.offerUuid = message.offerUuid;
        }
        if (message.sellerLeadUuid !== "") {
            obj.sellerLeadUuid = message.sellerLeadUuid;
        }
        return obj;
    },
    create: function create(base) {
        return SellEACategory_CompleteEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseSellEACategory_CompleteEvent();
        var _leadId;
        message.leadId = (_leadId = object.leadId) !== null && _leadId !== void 0 ? _leadId : "";
        var _offerId;
        message.offerId = (_offerId = object.offerId) !== null && _offerId !== void 0 ? _offerId : "";
        var _eaType;
        message.eaType = (_eaType = object.eaType) !== null && _eaType !== void 0 ? _eaType : 0;
        var _offerUuid;
        message.offerUuid = (_offerUuid = object.offerUuid) !== null && _offerUuid !== void 0 ? _offerUuid : "";
        var _sellerLeadUuid;
        message.sellerLeadUuid = (_sellerLeadUuid = object.sellerLeadUuid) !== null && _sellerLeadUuid !== void 0 ? _sellerLeadUuid : "";
        return message;
    }
};
function sell_ea_category_fromTimestamp(t) {
    var millis = (t.seconds || 0) * 1000;
    millis += (t.nanos || 0) / 1000000;
    return new Date(millis);
}
function sell_ea_category_fromJsonTimestamp(o) {
    if ((0,_instanceof/* default */.Z)(o, Date)) {
        return o;
    } else if (typeof o === "string") {
        return new Date(o);
    } else {
        return sell_ea_category_fromTimestamp(Timestamp.fromJSON(o));
    }
}
function sell_ea_category_isSet(value) {
    return value !== null && value !== undefined;
}

;// CONCATENATED MODULE: ./src/__generated__/protobuf/journey/data/categories/sell_final_offer_call_category.ts
/* eslint-disable */ 

var sell_final_offer_call_category_protobufPackage = "od_protos.journey.data.categories";
function createBaseSellFinalOfferCallCategory() {
    return {
        event: undefined
    };
}
var SellFinalOfferCallCategory = {
    fromJSON: function fromJSON(object) {
        return {
            event: sell_final_offer_call_category_isSet(object.proposed) ? {
                $case: "proposed",
                proposed: SellFinalOfferCallCategory_FinalOfferCallProposedEvent.fromJSON(object.proposed)
            } : sell_final_offer_call_category_isSet(object.scheduled) ? {
                $case: "scheduled",
                scheduled: SellFinalOfferCallCategory_FinalOfferCallScheduledEvent.fromJSON(object.scheduled)
            } : sell_final_offer_call_category_isSet(object.rescheduled) ? {
                $case: "rescheduled",
                rescheduled: SellFinalOfferCallCategory_FinalOfferCallRescheduledEvent.fromJSON(object.rescheduled)
            } : sell_final_offer_call_category_isSet(object.canceled) ? {
                $case: "canceled",
                canceled: SellFinalOfferCallCategory_FinalOfferCallCanceledEvent.fromJSON(object.canceled)
            } : sell_final_offer_call_category_isSet(object.scheduleReminder) ? {
                $case: "scheduleReminder",
                scheduleReminder: SellFinalOfferCallCategory_FinalOfferCallScheduleReminderEvent.fromJSON(object.scheduleReminder)
            } : undefined
        };
    },
    toJSON: function toJSON(message) {
        var ref, ref1, ref2, ref3, ref4;
        var obj = {};
        if (((ref = message.event) === null || ref === void 0 ? void 0 : ref.$case) === "proposed") {
            obj.proposed = SellFinalOfferCallCategory_FinalOfferCallProposedEvent.toJSON(message.event.proposed);
        }
        if (((ref1 = message.event) === null || ref1 === void 0 ? void 0 : ref1.$case) === "scheduled") {
            obj.scheduled = SellFinalOfferCallCategory_FinalOfferCallScheduledEvent.toJSON(message.event.scheduled);
        }
        if (((ref2 = message.event) === null || ref2 === void 0 ? void 0 : ref2.$case) === "rescheduled") {
            obj.rescheduled = SellFinalOfferCallCategory_FinalOfferCallRescheduledEvent.toJSON(message.event.rescheduled);
        }
        if (((ref3 = message.event) === null || ref3 === void 0 ? void 0 : ref3.$case) === "canceled") {
            obj.canceled = SellFinalOfferCallCategory_FinalOfferCallCanceledEvent.toJSON(message.event.canceled);
        }
        if (((ref4 = message.event) === null || ref4 === void 0 ? void 0 : ref4.$case) === "scheduleReminder") {
            obj.scheduleReminder = SellFinalOfferCallCategory_FinalOfferCallScheduleReminderEvent.toJSON(message.event.scheduleReminder);
        }
        return obj;
    },
    create: function create(base) {
        return SellFinalOfferCallCategory.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14;
        var message = createBaseSellFinalOfferCallCategory();
        if (((ref = object.event) === null || ref === void 0 ? void 0 : ref.$case) === "proposed" && ((ref1 = object.event) === null || ref1 === void 0 ? void 0 : ref1.proposed) !== undefined && ((ref2 = object.event) === null || ref2 === void 0 ? void 0 : ref2.proposed) !== null) {
            message.event = {
                $case: "proposed",
                proposed: SellFinalOfferCallCategory_FinalOfferCallProposedEvent.fromPartial(object.event.proposed)
            };
        }
        if (((ref3 = object.event) === null || ref3 === void 0 ? void 0 : ref3.$case) === "scheduled" && ((ref4 = object.event) === null || ref4 === void 0 ? void 0 : ref4.scheduled) !== undefined && ((ref5 = object.event) === null || ref5 === void 0 ? void 0 : ref5.scheduled) !== null) {
            message.event = {
                $case: "scheduled",
                scheduled: SellFinalOfferCallCategory_FinalOfferCallScheduledEvent.fromPartial(object.event.scheduled)
            };
        }
        if (((ref6 = object.event) === null || ref6 === void 0 ? void 0 : ref6.$case) === "rescheduled" && ((ref7 = object.event) === null || ref7 === void 0 ? void 0 : ref7.rescheduled) !== undefined && ((ref8 = object.event) === null || ref8 === void 0 ? void 0 : ref8.rescheduled) !== null) {
            message.event = {
                $case: "rescheduled",
                rescheduled: SellFinalOfferCallCategory_FinalOfferCallRescheduledEvent.fromPartial(object.event.rescheduled)
            };
        }
        if (((ref9 = object.event) === null || ref9 === void 0 ? void 0 : ref9.$case) === "canceled" && ((ref10 = object.event) === null || ref10 === void 0 ? void 0 : ref10.canceled) !== undefined && ((ref11 = object.event) === null || ref11 === void 0 ? void 0 : ref11.canceled) !== null) {
            message.event = {
                $case: "canceled",
                canceled: SellFinalOfferCallCategory_FinalOfferCallCanceledEvent.fromPartial(object.event.canceled)
            };
        }
        if (((ref12 = object.event) === null || ref12 === void 0 ? void 0 : ref12.$case) === "scheduleReminder" && ((ref13 = object.event) === null || ref13 === void 0 ? void 0 : ref13.scheduleReminder) !== undefined && ((ref14 = object.event) === null || ref14 === void 0 ? void 0 : ref14.scheduleReminder) !== null) {
            message.event = {
                $case: "scheduleReminder",
                scheduleReminder: SellFinalOfferCallCategory_FinalOfferCallScheduleReminderEvent.fromPartial(object.event.scheduleReminder)
            };
        }
        return message;
    }
};
function createBaseSellFinalOfferCallCategory_FinalOfferCallProposedEvent() {
    return {
        sellerLeadUuid: "",
        offerUuid: ""
    };
}
var SellFinalOfferCallCategory_FinalOfferCallProposedEvent = {
    fromJSON: function fromJSON(object) {
        return {
            sellerLeadUuid: sell_final_offer_call_category_isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : "",
            offerUuid: sell_final_offer_call_category_isSet(object.offerUuid) ? String(object.offerUuid) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.sellerLeadUuid !== "") {
            obj.sellerLeadUuid = message.sellerLeadUuid;
        }
        if (message.offerUuid !== "") {
            obj.offerUuid = message.offerUuid;
        }
        return obj;
    },
    create: function create(base) {
        return SellFinalOfferCallCategory_FinalOfferCallProposedEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseSellFinalOfferCallCategory_FinalOfferCallProposedEvent();
        var _sellerLeadUuid;
        message.sellerLeadUuid = (_sellerLeadUuid = object.sellerLeadUuid) !== null && _sellerLeadUuid !== void 0 ? _sellerLeadUuid : "";
        var _offerUuid;
        message.offerUuid = (_offerUuid = object.offerUuid) !== null && _offerUuid !== void 0 ? _offerUuid : "";
        return message;
    }
};
function createBaseSellFinalOfferCallCategory_FinalOfferCallScheduledEvent() {
    return {
        sellerLeadUuid: "",
        offerUuid: "",
        scheduledDatetime: undefined
    };
}
var SellFinalOfferCallCategory_FinalOfferCallScheduledEvent = {
    fromJSON: function fromJSON(object) {
        return {
            sellerLeadUuid: sell_final_offer_call_category_isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : "",
            offerUuid: sell_final_offer_call_category_isSet(object.offerUuid) ? String(object.offerUuid) : "",
            scheduledDatetime: sell_final_offer_call_category_isSet(object.scheduledDatetime) ? sell_final_offer_call_category_fromJsonTimestamp(object.scheduledDatetime) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.sellerLeadUuid !== "") {
            obj.sellerLeadUuid = message.sellerLeadUuid;
        }
        if (message.offerUuid !== "") {
            obj.offerUuid = message.offerUuid;
        }
        if (message.scheduledDatetime !== undefined) {
            obj.scheduledDatetime = message.scheduledDatetime.toISOString();
        }
        return obj;
    },
    create: function create(base) {
        return SellFinalOfferCallCategory_FinalOfferCallScheduledEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseSellFinalOfferCallCategory_FinalOfferCallScheduledEvent();
        var _sellerLeadUuid;
        message.sellerLeadUuid = (_sellerLeadUuid = object.sellerLeadUuid) !== null && _sellerLeadUuid !== void 0 ? _sellerLeadUuid : "";
        var _offerUuid;
        message.offerUuid = (_offerUuid = object.offerUuid) !== null && _offerUuid !== void 0 ? _offerUuid : "";
        var _scheduledDatetime;
        message.scheduledDatetime = (_scheduledDatetime = object.scheduledDatetime) !== null && _scheduledDatetime !== void 0 ? _scheduledDatetime : undefined;
        return message;
    }
};
function createBaseSellFinalOfferCallCategory_FinalOfferCallRescheduledEvent() {
    return {
        sellerLeadUuid: "",
        offerUuid: "",
        scheduledDatetime: undefined
    };
}
var SellFinalOfferCallCategory_FinalOfferCallRescheduledEvent = {
    fromJSON: function fromJSON(object) {
        return {
            sellerLeadUuid: sell_final_offer_call_category_isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : "",
            offerUuid: sell_final_offer_call_category_isSet(object.offerUuid) ? String(object.offerUuid) : "",
            scheduledDatetime: sell_final_offer_call_category_isSet(object.scheduledDatetime) ? sell_final_offer_call_category_fromJsonTimestamp(object.scheduledDatetime) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.sellerLeadUuid !== "") {
            obj.sellerLeadUuid = message.sellerLeadUuid;
        }
        if (message.offerUuid !== "") {
            obj.offerUuid = message.offerUuid;
        }
        if (message.scheduledDatetime !== undefined) {
            obj.scheduledDatetime = message.scheduledDatetime.toISOString();
        }
        return obj;
    },
    create: function create(base) {
        return SellFinalOfferCallCategory_FinalOfferCallRescheduledEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseSellFinalOfferCallCategory_FinalOfferCallRescheduledEvent();
        var _sellerLeadUuid;
        message.sellerLeadUuid = (_sellerLeadUuid = object.sellerLeadUuid) !== null && _sellerLeadUuid !== void 0 ? _sellerLeadUuid : "";
        var _offerUuid;
        message.offerUuid = (_offerUuid = object.offerUuid) !== null && _offerUuid !== void 0 ? _offerUuid : "";
        var _scheduledDatetime;
        message.scheduledDatetime = (_scheduledDatetime = object.scheduledDatetime) !== null && _scheduledDatetime !== void 0 ? _scheduledDatetime : undefined;
        return message;
    }
};
function createBaseSellFinalOfferCallCategory_FinalOfferCallCanceledEvent() {
    return {
        sellerLeadUuid: "",
        offerUuid: ""
    };
}
var SellFinalOfferCallCategory_FinalOfferCallCanceledEvent = {
    fromJSON: function fromJSON(object) {
        return {
            sellerLeadUuid: sell_final_offer_call_category_isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : "",
            offerUuid: sell_final_offer_call_category_isSet(object.offerUuid) ? String(object.offerUuid) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.sellerLeadUuid !== "") {
            obj.sellerLeadUuid = message.sellerLeadUuid;
        }
        if (message.offerUuid !== "") {
            obj.offerUuid = message.offerUuid;
        }
        return obj;
    },
    create: function create(base) {
        return SellFinalOfferCallCategory_FinalOfferCallCanceledEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseSellFinalOfferCallCategory_FinalOfferCallCanceledEvent();
        var _sellerLeadUuid;
        message.sellerLeadUuid = (_sellerLeadUuid = object.sellerLeadUuid) !== null && _sellerLeadUuid !== void 0 ? _sellerLeadUuid : "";
        var _offerUuid;
        message.offerUuid = (_offerUuid = object.offerUuid) !== null && _offerUuid !== void 0 ? _offerUuid : "";
        return message;
    }
};
function createBaseSellFinalOfferCallCategory_FinalOfferCallScheduleReminderEvent() {
    return {
        sellerLeadUuid: "",
        offerUuid: ""
    };
}
var SellFinalOfferCallCategory_FinalOfferCallScheduleReminderEvent = {
    fromJSON: function fromJSON(object) {
        return {
            sellerLeadUuid: sell_final_offer_call_category_isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : "",
            offerUuid: sell_final_offer_call_category_isSet(object.offerUuid) ? String(object.offerUuid) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.sellerLeadUuid !== "") {
            obj.sellerLeadUuid = message.sellerLeadUuid;
        }
        if (message.offerUuid !== "") {
            obj.offerUuid = message.offerUuid;
        }
        return obj;
    },
    create: function create(base) {
        return SellFinalOfferCallCategory_FinalOfferCallScheduleReminderEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseSellFinalOfferCallCategory_FinalOfferCallScheduleReminderEvent();
        var _sellerLeadUuid;
        message.sellerLeadUuid = (_sellerLeadUuid = object.sellerLeadUuid) !== null && _sellerLeadUuid !== void 0 ? _sellerLeadUuid : "";
        var _offerUuid;
        message.offerUuid = (_offerUuid = object.offerUuid) !== null && _offerUuid !== void 0 ? _offerUuid : "";
        return message;
    }
};
function sell_final_offer_call_category_fromTimestamp(t) {
    var millis = (t.seconds || 0) * 1000;
    millis += (t.nanos || 0) / 1000000;
    return new Date(millis);
}
function sell_final_offer_call_category_fromJsonTimestamp(o) {
    if ((0,_instanceof/* default */.Z)(o, Date)) {
        return o;
    } else if (typeof o === "string") {
        return new Date(o);
    } else {
        return sell_final_offer_call_category_fromTimestamp(Timestamp.fromJSON(o));
    }
}
function sell_final_offer_call_category_isSet(value) {
    return value !== null && value !== undefined;
}

;// CONCATENATED MODULE: ./src/__generated__/protobuf/journey/data/categories/sell_list_category.ts
/* eslint-disable */ 
var sell_list_category_protobufPackage = "od_protos.journey.data.categories";
var SellListCategory_QualificationEvent_QualificationDecision;
(function(SellListCategory_QualificationEvent_QualificationDecision) {
    SellListCategory_QualificationEvent_QualificationDecision[SellListCategory_QualificationEvent_QualificationDecision["UNKNOWN"] = 0] = "UNKNOWN";
    SellListCategory_QualificationEvent_QualificationDecision[SellListCategory_QualificationEvent_QualificationDecision["PRODUCT_QUALIFIED"] = 1] = "PRODUCT_QUALIFIED";
    SellListCategory_QualificationEvent_QualificationDecision[SellListCategory_QualificationEvent_QualificationDecision["PRODUCT_DENIED"] = 2] = "PRODUCT_DENIED";
    SellListCategory_QualificationEvent_QualificationDecision[SellListCategory_QualificationEvent_QualificationDecision["PRODUCT_UNDENIED"] = 3] = "PRODUCT_UNDENIED";
    SellListCategory_QualificationEvent_QualificationDecision[SellListCategory_QualificationEvent_QualificationDecision["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(SellListCategory_QualificationEvent_QualificationDecision || (SellListCategory_QualificationEvent_QualificationDecision = {}));
function sellListCategory_QualificationEvent_QualificationDecisionFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN":
            return SellListCategory_QualificationEvent_QualificationDecision.UNKNOWN;
        case 1:
        case "PRODUCT_QUALIFIED":
            return SellListCategory_QualificationEvent_QualificationDecision.PRODUCT_QUALIFIED;
        case 2:
        case "PRODUCT_DENIED":
            return SellListCategory_QualificationEvent_QualificationDecision.PRODUCT_DENIED;
        case 3:
        case "PRODUCT_UNDENIED":
            return SellListCategory_QualificationEvent_QualificationDecision.PRODUCT_UNDENIED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return SellListCategory_QualificationEvent_QualificationDecision.UNRECOGNIZED;
    }
}
function sellListCategory_QualificationEvent_QualificationDecisionToJSON(object) {
    switch(object){
        case SellListCategory_QualificationEvent_QualificationDecision.UNKNOWN:
            return "UNKNOWN";
        case SellListCategory_QualificationEvent_QualificationDecision.PRODUCT_QUALIFIED:
            return "PRODUCT_QUALIFIED";
        case SellListCategory_QualificationEvent_QualificationDecision.PRODUCT_DENIED:
            return "PRODUCT_DENIED";
        case SellListCategory_QualificationEvent_QualificationDecision.PRODUCT_UNDENIED:
            return "PRODUCT_UNDENIED";
        case SellListCategory_QualificationEvent_QualificationDecision.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
function createBaseSellListCategory() {
    return {
        event: undefined
    };
}
var SellListCategory = {
    fromJSON: function fromJSON(object) {
        return {
            event: sell_list_category_isSet(object.offerView) ? {
                $case: "offerView",
                offerView: SellListCategory_OfferViewEvent.fromJSON(object.offerView)
            } : sell_list_category_isSet(object.qualification) ? {
                $case: "qualification",
                qualification: SellListCategory_QualificationEvent.fromJSON(object.qualification)
            } : sell_list_category_isSet(object.agreementSignComplete) ? {
                $case: "agreementSignComplete",
                agreementSignComplete: SellListCategory_AgreementSignCompleteEvent.fromJSON(object.agreementSignComplete)
            } : undefined
        };
    },
    toJSON: function toJSON(message) {
        var ref, ref1, ref2;
        var obj = {};
        if (((ref = message.event) === null || ref === void 0 ? void 0 : ref.$case) === "offerView") {
            obj.offerView = SellListCategory_OfferViewEvent.toJSON(message.event.offerView);
        }
        if (((ref1 = message.event) === null || ref1 === void 0 ? void 0 : ref1.$case) === "qualification") {
            obj.qualification = SellListCategory_QualificationEvent.toJSON(message.event.qualification);
        }
        if (((ref2 = message.event) === null || ref2 === void 0 ? void 0 : ref2.$case) === "agreementSignComplete") {
            obj.agreementSignComplete = SellListCategory_AgreementSignCompleteEvent.toJSON(message.event.agreementSignComplete);
        }
        return obj;
    },
    create: function create(base) {
        return SellListCategory.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
        var message = createBaseSellListCategory();
        if (((ref = object.event) === null || ref === void 0 ? void 0 : ref.$case) === "offerView" && ((ref1 = object.event) === null || ref1 === void 0 ? void 0 : ref1.offerView) !== undefined && ((ref2 = object.event) === null || ref2 === void 0 ? void 0 : ref2.offerView) !== null) {
            message.event = {
                $case: "offerView",
                offerView: SellListCategory_OfferViewEvent.fromPartial(object.event.offerView)
            };
        }
        if (((ref3 = object.event) === null || ref3 === void 0 ? void 0 : ref3.$case) === "qualification" && ((ref4 = object.event) === null || ref4 === void 0 ? void 0 : ref4.qualification) !== undefined && ((ref5 = object.event) === null || ref5 === void 0 ? void 0 : ref5.qualification) !== null) {
            message.event = {
                $case: "qualification",
                qualification: SellListCategory_QualificationEvent.fromPartial(object.event.qualification)
            };
        }
        if (((ref6 = object.event) === null || ref6 === void 0 ? void 0 : ref6.$case) === "agreementSignComplete" && ((ref7 = object.event) === null || ref7 === void 0 ? void 0 : ref7.agreementSignComplete) !== undefined && ((ref8 = object.event) === null || ref8 === void 0 ? void 0 : ref8.agreementSignComplete) !== null) {
            message.event = {
                $case: "agreementSignComplete",
                agreementSignComplete: SellListCategory_AgreementSignCompleteEvent.fromPartial(object.event.agreementSignComplete)
            };
        }
        return message;
    }
};
function createBaseSellListCategory_OfferViewEvent() {
    return {
        sellDirectLeadToken: "",
        sellDirectOfferId: "",
        listingRangeMin: undefined,
        listingRangeMax: undefined,
        recommendedProduct: undefined,
        offerUuid: "",
        isFirstOffer: false,
        sellerLeadUuid: ""
    };
}
var SellListCategory_OfferViewEvent = {
    fromJSON: function fromJSON(object) {
        return {
            sellDirectLeadToken: sell_list_category_isSet(object.sellDirectLeadToken) ? String(object.sellDirectLeadToken) : "",
            sellDirectOfferId: sell_list_category_isSet(object.sellDirectOfferId) ? String(object.sellDirectOfferId) : "",
            listingRangeMin: sell_list_category_isSet(object.listingRangeMin) ? Money.fromJSON(object.listingRangeMin) : undefined,
            listingRangeMax: sell_list_category_isSet(object.listingRangeMax) ? Money.fromJSON(object.listingRangeMax) : undefined,
            recommendedProduct: sell_list_category_isSet(object.recommendedProduct) ? String(object.recommendedProduct) : undefined,
            offerUuid: sell_list_category_isSet(object.offerUuid) ? String(object.offerUuid) : "",
            isFirstOffer: sell_list_category_isSet(object.isFirstOffer) ? Boolean(object.isFirstOffer) : false,
            sellerLeadUuid: sell_list_category_isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.sellDirectLeadToken !== "") {
            obj.sellDirectLeadToken = message.sellDirectLeadToken;
        }
        if (message.sellDirectOfferId !== "") {
            obj.sellDirectOfferId = message.sellDirectOfferId;
        }
        if (message.listingRangeMin !== undefined) {
            obj.listingRangeMin = Money.toJSON(message.listingRangeMin);
        }
        if (message.listingRangeMax !== undefined) {
            obj.listingRangeMax = Money.toJSON(message.listingRangeMax);
        }
        if (message.recommendedProduct !== undefined) {
            obj.recommendedProduct = message.recommendedProduct;
        }
        if (message.offerUuid !== "") {
            obj.offerUuid = message.offerUuid;
        }
        if (message.isFirstOffer === true) {
            obj.isFirstOffer = message.isFirstOffer;
        }
        if (message.sellerLeadUuid !== "") {
            obj.sellerLeadUuid = message.sellerLeadUuid;
        }
        return obj;
    },
    create: function create(base) {
        return SellListCategory_OfferViewEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseSellListCategory_OfferViewEvent();
        var _sellDirectLeadToken;
        message.sellDirectLeadToken = (_sellDirectLeadToken = object.sellDirectLeadToken) !== null && _sellDirectLeadToken !== void 0 ? _sellDirectLeadToken : "";
        var _sellDirectOfferId;
        message.sellDirectOfferId = (_sellDirectOfferId = object.sellDirectOfferId) !== null && _sellDirectOfferId !== void 0 ? _sellDirectOfferId : "";
        message.listingRangeMin = object.listingRangeMin !== undefined && object.listingRangeMin !== null ? Money.fromPartial(object.listingRangeMin) : undefined;
        message.listingRangeMax = object.listingRangeMax !== undefined && object.listingRangeMax !== null ? Money.fromPartial(object.listingRangeMax) : undefined;
        var _recommendedProduct;
        message.recommendedProduct = (_recommendedProduct = object.recommendedProduct) !== null && _recommendedProduct !== void 0 ? _recommendedProduct : undefined;
        var _offerUuid;
        message.offerUuid = (_offerUuid = object.offerUuid) !== null && _offerUuid !== void 0 ? _offerUuid : "";
        var _isFirstOffer;
        message.isFirstOffer = (_isFirstOffer = object.isFirstOffer) !== null && _isFirstOffer !== void 0 ? _isFirstOffer : false;
        var _sellerLeadUuid;
        message.sellerLeadUuid = (_sellerLeadUuid = object.sellerLeadUuid) !== null && _sellerLeadUuid !== void 0 ? _sellerLeadUuid : "";
        return message;
    }
};
function createBaseSellListCategory_QualificationEvent() {
    return {
        lwcProductId: "",
        sellDirectLeadToken: "",
        qualificationDecision: 0,
        sellerLeadUuid: ""
    };
}
var SellListCategory_QualificationEvent = {
    fromJSON: function fromJSON(object) {
        return {
            lwcProductId: sell_list_category_isSet(object.lwcProductId) ? String(object.lwcProductId) : "",
            sellDirectLeadToken: sell_list_category_isSet(object.sellDirectLeadToken) ? String(object.sellDirectLeadToken) : "",
            qualificationDecision: sell_list_category_isSet(object.qualificationDecision) ? sellListCategory_QualificationEvent_QualificationDecisionFromJSON(object.qualificationDecision) : 0,
            sellerLeadUuid: sell_list_category_isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.lwcProductId !== "") {
            obj.lwcProductId = message.lwcProductId;
        }
        if (message.sellDirectLeadToken !== "") {
            obj.sellDirectLeadToken = message.sellDirectLeadToken;
        }
        if (message.qualificationDecision !== 0) {
            obj.qualificationDecision = sellListCategory_QualificationEvent_QualificationDecisionToJSON(message.qualificationDecision);
        }
        if (message.sellerLeadUuid !== "") {
            obj.sellerLeadUuid = message.sellerLeadUuid;
        }
        return obj;
    },
    create: function create(base) {
        return SellListCategory_QualificationEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseSellListCategory_QualificationEvent();
        var _lwcProductId;
        message.lwcProductId = (_lwcProductId = object.lwcProductId) !== null && _lwcProductId !== void 0 ? _lwcProductId : "";
        var _sellDirectLeadToken;
        message.sellDirectLeadToken = (_sellDirectLeadToken = object.sellDirectLeadToken) !== null && _sellDirectLeadToken !== void 0 ? _sellDirectLeadToken : "";
        var _qualificationDecision;
        message.qualificationDecision = (_qualificationDecision = object.qualificationDecision) !== null && _qualificationDecision !== void 0 ? _qualificationDecision : 0;
        var _sellerLeadUuid;
        message.sellerLeadUuid = (_sellerLeadUuid = object.sellerLeadUuid) !== null && _sellerLeadUuid !== void 0 ? _sellerLeadUuid : "";
        return message;
    }
};
function createBaseSellListCategory_AgreementSignCompleteEvent() {
    return {
        lwcProductId: "",
        sellDirectLeadToken: "",
        sellerLeadUuid: ""
    };
}
var SellListCategory_AgreementSignCompleteEvent = {
    fromJSON: function fromJSON(object) {
        return {
            lwcProductId: sell_list_category_isSet(object.lwcProductId) ? String(object.lwcProductId) : "",
            sellDirectLeadToken: sell_list_category_isSet(object.sellDirectLeadToken) ? String(object.sellDirectLeadToken) : "",
            sellerLeadUuid: sell_list_category_isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.lwcProductId !== "") {
            obj.lwcProductId = message.lwcProductId;
        }
        if (message.sellDirectLeadToken !== "") {
            obj.sellDirectLeadToken = message.sellDirectLeadToken;
        }
        if (message.sellerLeadUuid !== "") {
            obj.sellerLeadUuid = message.sellerLeadUuid;
        }
        return obj;
    },
    create: function create(base) {
        return SellListCategory_AgreementSignCompleteEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseSellListCategory_AgreementSignCompleteEvent();
        var _lwcProductId;
        message.lwcProductId = (_lwcProductId = object.lwcProductId) !== null && _lwcProductId !== void 0 ? _lwcProductId : "";
        var _sellDirectLeadToken;
        message.sellDirectLeadToken = (_sellDirectLeadToken = object.sellDirectLeadToken) !== null && _sellDirectLeadToken !== void 0 ? _sellDirectLeadToken : "";
        var _sellerLeadUuid;
        message.sellerLeadUuid = (_sellerLeadUuid = object.sellerLeadUuid) !== null && _sellerLeadUuid !== void 0 ? _sellerLeadUuid : "";
        return message;
    }
};
function sell_list_category_isSet(value) {
    return value !== null && value !== undefined;
}

;// CONCATENATED MODULE: ./src/__generated__/protobuf/journey/data/categories/sell_offer_review_category.ts
/* eslint-disable */ 

var sell_offer_review_category_protobufPackage = "od_protos.journey.data.categories";
var SellOfferReviewCategory_ORType;
(function(SellOfferReviewCategory_ORType) {
    SellOfferReviewCategory_ORType[SellOfferReviewCategory_ORType["UNKNOWN_OR_TYPE"] = 0] = "UNKNOWN_OR_TYPE";
    SellOfferReviewCategory_ORType[SellOfferReviewCategory_ORType["OR"] = 1] = "OR";
    SellOfferReviewCategory_ORType[SellOfferReviewCategory_ORType["ORVA"] = 2] = "ORVA";
    SellOfferReviewCategory_ORType[SellOfferReviewCategory_ORType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(SellOfferReviewCategory_ORType || (SellOfferReviewCategory_ORType = {}));
function sellOfferReviewCategory_ORTypeFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN_OR_TYPE":
            return SellOfferReviewCategory_ORType.UNKNOWN_OR_TYPE;
        case 1:
        case "OR":
            return SellOfferReviewCategory_ORType.OR;
        case 2:
        case "ORVA":
            return SellOfferReviewCategory_ORType.ORVA;
        case -1:
        case "UNRECOGNIZED":
        default:
            return SellOfferReviewCategory_ORType.UNRECOGNIZED;
    }
}
function sellOfferReviewCategory_ORTypeToJSON(object) {
    switch(object){
        case SellOfferReviewCategory_ORType.UNKNOWN_OR_TYPE:
            return "UNKNOWN_OR_TYPE";
        case SellOfferReviewCategory_ORType.OR:
            return "OR";
        case SellOfferReviewCategory_ORType.ORVA:
            return "ORVA";
        case SellOfferReviewCategory_ORType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var SellOfferReviewCategory_OROutcome;
(function(SellOfferReviewCategory_OROutcome) {
    SellOfferReviewCategory_OROutcome[SellOfferReviewCategory_OROutcome["UNKNOWN_OR_OUTCOME"] = 0] = "UNKNOWN_OR_OUTCOME";
    SellOfferReviewCategory_OROutcome[SellOfferReviewCategory_OROutcome["NO_SHOW"] = 1] = "NO_SHOW";
    SellOfferReviewCategory_OROutcome[SellOfferReviewCategory_OROutcome["CAN_COMPLETE_OR"] = 2] = "CAN_COMPLETE_OR";
    SellOfferReviewCategory_OROutcome[SellOfferReviewCategory_OROutcome["CALL_NOT_COMPLETE_RESCHEDULE_OR"] = 3] = "CALL_NOT_COMPLETE_RESCHEDULE_OR";
    SellOfferReviewCategory_OROutcome[SellOfferReviewCategory_OROutcome["CALL_NOT_COMPLETE_SENT_SSVA"] = 4] = "CALL_NOT_COMPLETE_SENT_SSVA";
    SellOfferReviewCategory_OROutcome[SellOfferReviewCategory_OROutcome["AGENT_CUSTOMER_HANDED_OFF_TO_AEP"] = 5] = "AGENT_CUSTOMER_HANDED_OFF_TO_AEP";
    SellOfferReviewCategory_OROutcome[SellOfferReviewCategory_OROutcome["DID_NOT_CONVERT"] = 6] = "DID_NOT_CONVERT";
    SellOfferReviewCategory_OROutcome[SellOfferReviewCategory_OROutcome["OPENDOOR_CANNOT_PURCHASE_OOBB"] = 7] = "OPENDOOR_CANNOT_PURCHASE_OOBB";
    SellOfferReviewCategory_OROutcome[SellOfferReviewCategory_OROutcome["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(SellOfferReviewCategory_OROutcome || (SellOfferReviewCategory_OROutcome = {}));
function sellOfferReviewCategory_OROutcomeFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN_OR_OUTCOME":
            return SellOfferReviewCategory_OROutcome.UNKNOWN_OR_OUTCOME;
        case 1:
        case "NO_SHOW":
            return SellOfferReviewCategory_OROutcome.NO_SHOW;
        case 2:
        case "CAN_COMPLETE_OR":
            return SellOfferReviewCategory_OROutcome.CAN_COMPLETE_OR;
        case 3:
        case "CALL_NOT_COMPLETE_RESCHEDULE_OR":
            return SellOfferReviewCategory_OROutcome.CALL_NOT_COMPLETE_RESCHEDULE_OR;
        case 4:
        case "CALL_NOT_COMPLETE_SENT_SSVA":
            return SellOfferReviewCategory_OROutcome.CALL_NOT_COMPLETE_SENT_SSVA;
        case 5:
        case "AGENT_CUSTOMER_HANDED_OFF_TO_AEP":
            return SellOfferReviewCategory_OROutcome.AGENT_CUSTOMER_HANDED_OFF_TO_AEP;
        case 6:
        case "DID_NOT_CONVERT":
            return SellOfferReviewCategory_OROutcome.DID_NOT_CONVERT;
        case 7:
        case "OPENDOOR_CANNOT_PURCHASE_OOBB":
            return SellOfferReviewCategory_OROutcome.OPENDOOR_CANNOT_PURCHASE_OOBB;
        case -1:
        case "UNRECOGNIZED":
        default:
            return SellOfferReviewCategory_OROutcome.UNRECOGNIZED;
    }
}
function sellOfferReviewCategory_OROutcomeToJSON(object) {
    switch(object){
        case SellOfferReviewCategory_OROutcome.UNKNOWN_OR_OUTCOME:
            return "UNKNOWN_OR_OUTCOME";
        case SellOfferReviewCategory_OROutcome.NO_SHOW:
            return "NO_SHOW";
        case SellOfferReviewCategory_OROutcome.CAN_COMPLETE_OR:
            return "CAN_COMPLETE_OR";
        case SellOfferReviewCategory_OROutcome.CALL_NOT_COMPLETE_RESCHEDULE_OR:
            return "CALL_NOT_COMPLETE_RESCHEDULE_OR";
        case SellOfferReviewCategory_OROutcome.CALL_NOT_COMPLETE_SENT_SSVA:
            return "CALL_NOT_COMPLETE_SENT_SSVA";
        case SellOfferReviewCategory_OROutcome.AGENT_CUSTOMER_HANDED_OFF_TO_AEP:
            return "AGENT_CUSTOMER_HANDED_OFF_TO_AEP";
        case SellOfferReviewCategory_OROutcome.DID_NOT_CONVERT:
            return "DID_NOT_CONVERT";
        case SellOfferReviewCategory_OROutcome.OPENDOOR_CANNOT_PURCHASE_OOBB:
            return "OPENDOOR_CANNOT_PURCHASE_OOBB";
        case SellOfferReviewCategory_OROutcome.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var SellOfferReviewCategory_Origin;
(function(SellOfferReviewCategory_Origin) {
    SellOfferReviewCategory_Origin[SellOfferReviewCategory_Origin["UNKNOWN_ORIGIN"] = 0] = "UNKNOWN_ORIGIN";
    SellOfferReviewCategory_Origin[SellOfferReviewCategory_Origin["PROACTIVE_OUTREACH"] = 1] = "PROACTIVE_OUTREACH";
    SellOfferReviewCategory_Origin[SellOfferReviewCategory_Origin["CUSTOMER_SCHEDULED"] = 2] = "CUSTOMER_SCHEDULED";
    SellOfferReviewCategory_Origin[SellOfferReviewCategory_Origin["CUSTOMER_OUTREACH"] = 3] = "CUSTOMER_OUTREACH";
    SellOfferReviewCategory_Origin[SellOfferReviewCategory_Origin["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(SellOfferReviewCategory_Origin || (SellOfferReviewCategory_Origin = {}));
function sellOfferReviewCategory_OriginFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN_ORIGIN":
            return SellOfferReviewCategory_Origin.UNKNOWN_ORIGIN;
        case 1:
        case "PROACTIVE_OUTREACH":
            return SellOfferReviewCategory_Origin.PROACTIVE_OUTREACH;
        case 2:
        case "CUSTOMER_SCHEDULED":
            return SellOfferReviewCategory_Origin.CUSTOMER_SCHEDULED;
        case 3:
        case "CUSTOMER_OUTREACH":
            return SellOfferReviewCategory_Origin.CUSTOMER_OUTREACH;
        case -1:
        case "UNRECOGNIZED":
        default:
            return SellOfferReviewCategory_Origin.UNRECOGNIZED;
    }
}
function sellOfferReviewCategory_OriginToJSON(object) {
    switch(object){
        case SellOfferReviewCategory_Origin.UNKNOWN_ORIGIN:
            return "UNKNOWN_ORIGIN";
        case SellOfferReviewCategory_Origin.PROACTIVE_OUTREACH:
            return "PROACTIVE_OUTREACH";
        case SellOfferReviewCategory_Origin.CUSTOMER_SCHEDULED:
            return "CUSTOMER_SCHEDULED";
        case SellOfferReviewCategory_Origin.CUSTOMER_OUTREACH:
            return "CUSTOMER_OUTREACH";
        case SellOfferReviewCategory_Origin.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
function createBaseSellOfferReviewCategory() {
    return {
        event: undefined
    };
}
var SellOfferReviewCategory = {
    fromJSON: function fromJSON(object) {
        return {
            event: sell_offer_review_category_isSet(object.scheduled) ? {
                $case: "scheduled",
                scheduled: SellOfferReviewCategory_OfferReviewScheduledEvent.fromJSON(object.scheduled)
            } : sell_offer_review_category_isSet(object.completed) ? {
                $case: "completed",
                completed: SellOfferReviewCategory_OfferReviewCompletedEvent.fromJSON(object.completed)
            } : sell_offer_review_category_isSet(object.rescheduled) ? {
                $case: "rescheduled",
                rescheduled: SellOfferReviewCategory_OfferReviewRescheduledEvent.fromJSON(object.rescheduled)
            } : sell_offer_review_category_isSet(object.canceled) ? {
                $case: "canceled",
                canceled: SellOfferReviewCategory_OfferReviewCanceledEvent.fromJSON(object.canceled)
            } : undefined
        };
    },
    toJSON: function toJSON(message) {
        var ref, ref1, ref2, ref3;
        var obj = {};
        if (((ref = message.event) === null || ref === void 0 ? void 0 : ref.$case) === "scheduled") {
            obj.scheduled = SellOfferReviewCategory_OfferReviewScheduledEvent.toJSON(message.event.scheduled);
        }
        if (((ref1 = message.event) === null || ref1 === void 0 ? void 0 : ref1.$case) === "completed") {
            obj.completed = SellOfferReviewCategory_OfferReviewCompletedEvent.toJSON(message.event.completed);
        }
        if (((ref2 = message.event) === null || ref2 === void 0 ? void 0 : ref2.$case) === "rescheduled") {
            obj.rescheduled = SellOfferReviewCategory_OfferReviewRescheduledEvent.toJSON(message.event.rescheduled);
        }
        if (((ref3 = message.event) === null || ref3 === void 0 ? void 0 : ref3.$case) === "canceled") {
            obj.canceled = SellOfferReviewCategory_OfferReviewCanceledEvent.toJSON(message.event.canceled);
        }
        return obj;
    },
    create: function create(base) {
        return SellOfferReviewCategory.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
        var message = createBaseSellOfferReviewCategory();
        if (((ref = object.event) === null || ref === void 0 ? void 0 : ref.$case) === "scheduled" && ((ref1 = object.event) === null || ref1 === void 0 ? void 0 : ref1.scheduled) !== undefined && ((ref2 = object.event) === null || ref2 === void 0 ? void 0 : ref2.scheduled) !== null) {
            message.event = {
                $case: "scheduled",
                scheduled: SellOfferReviewCategory_OfferReviewScheduledEvent.fromPartial(object.event.scheduled)
            };
        }
        if (((ref3 = object.event) === null || ref3 === void 0 ? void 0 : ref3.$case) === "completed" && ((ref4 = object.event) === null || ref4 === void 0 ? void 0 : ref4.completed) !== undefined && ((ref5 = object.event) === null || ref5 === void 0 ? void 0 : ref5.completed) !== null) {
            message.event = {
                $case: "completed",
                completed: SellOfferReviewCategory_OfferReviewCompletedEvent.fromPartial(object.event.completed)
            };
        }
        if (((ref6 = object.event) === null || ref6 === void 0 ? void 0 : ref6.$case) === "rescheduled" && ((ref7 = object.event) === null || ref7 === void 0 ? void 0 : ref7.rescheduled) !== undefined && ((ref8 = object.event) === null || ref8 === void 0 ? void 0 : ref8.rescheduled) !== null) {
            message.event = {
                $case: "rescheduled",
                rescheduled: SellOfferReviewCategory_OfferReviewRescheduledEvent.fromPartial(object.event.rescheduled)
            };
        }
        if (((ref9 = object.event) === null || ref9 === void 0 ? void 0 : ref9.$case) === "canceled" && ((ref10 = object.event) === null || ref10 === void 0 ? void 0 : ref10.canceled) !== undefined && ((ref11 = object.event) === null || ref11 === void 0 ? void 0 : ref11.canceled) !== null) {
            message.event = {
                $case: "canceled",
                canceled: SellOfferReviewCategory_OfferReviewCanceledEvent.fromPartial(object.event.canceled)
            };
        }
        return message;
    }
};
function createBaseSellOfferReviewCategory_OfferReviewScheduledEvent() {
    return {
        leadId: "",
        offerUuid: "",
        orType: 0,
        scheduledDatetime: undefined,
        sellerLeadUuid: ""
    };
}
var SellOfferReviewCategory_OfferReviewScheduledEvent = {
    fromJSON: function fromJSON(object) {
        return {
            leadId: sell_offer_review_category_isSet(object.leadId) ? String(object.leadId) : "",
            offerUuid: sell_offer_review_category_isSet(object.offerUuid) ? String(object.offerUuid) : "",
            orType: sell_offer_review_category_isSet(object.orType) ? sellOfferReviewCategory_ORTypeFromJSON(object.orType) : 0,
            scheduledDatetime: sell_offer_review_category_isSet(object.scheduledDatetime) ? sell_offer_review_category_fromJsonTimestamp(object.scheduledDatetime) : undefined,
            sellerLeadUuid: sell_offer_review_category_isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.leadId !== "") {
            obj.leadId = message.leadId;
        }
        if (message.offerUuid !== "") {
            obj.offerUuid = message.offerUuid;
        }
        if (message.orType !== 0) {
            obj.orType = sellOfferReviewCategory_ORTypeToJSON(message.orType);
        }
        if (message.scheduledDatetime !== undefined) {
            obj.scheduledDatetime = message.scheduledDatetime.toISOString();
        }
        if (message.sellerLeadUuid !== "") {
            obj.sellerLeadUuid = message.sellerLeadUuid;
        }
        return obj;
    },
    create: function create(base) {
        return SellOfferReviewCategory_OfferReviewScheduledEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseSellOfferReviewCategory_OfferReviewScheduledEvent();
        var _leadId;
        message.leadId = (_leadId = object.leadId) !== null && _leadId !== void 0 ? _leadId : "";
        var _offerUuid;
        message.offerUuid = (_offerUuid = object.offerUuid) !== null && _offerUuid !== void 0 ? _offerUuid : "";
        var _orType;
        message.orType = (_orType = object.orType) !== null && _orType !== void 0 ? _orType : 0;
        var _scheduledDatetime;
        message.scheduledDatetime = (_scheduledDatetime = object.scheduledDatetime) !== null && _scheduledDatetime !== void 0 ? _scheduledDatetime : undefined;
        var _sellerLeadUuid;
        message.sellerLeadUuid = (_sellerLeadUuid = object.sellerLeadUuid) !== null && _sellerLeadUuid !== void 0 ? _sellerLeadUuid : "";
        return message;
    }
};
function createBaseSellOfferReviewCategory_OfferReviewCompletedEvent() {
    return {
        leadId: "",
        offerUuid: "",
        orType: 0,
        outcome: 0,
        origin: 0,
        sellerLeadUuid: ""
    };
}
var SellOfferReviewCategory_OfferReviewCompletedEvent = {
    fromJSON: function fromJSON(object) {
        return {
            leadId: sell_offer_review_category_isSet(object.leadId) ? String(object.leadId) : "",
            offerUuid: sell_offer_review_category_isSet(object.offerUuid) ? String(object.offerUuid) : "",
            orType: sell_offer_review_category_isSet(object.orType) ? sellOfferReviewCategory_ORTypeFromJSON(object.orType) : 0,
            outcome: sell_offer_review_category_isSet(object.outcome) ? sellOfferReviewCategory_OROutcomeFromJSON(object.outcome) : 0,
            origin: sell_offer_review_category_isSet(object.origin) ? sellOfferReviewCategory_OriginFromJSON(object.origin) : 0,
            sellerLeadUuid: sell_offer_review_category_isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.leadId !== "") {
            obj.leadId = message.leadId;
        }
        if (message.offerUuid !== "") {
            obj.offerUuid = message.offerUuid;
        }
        if (message.orType !== 0) {
            obj.orType = sellOfferReviewCategory_ORTypeToJSON(message.orType);
        }
        if (message.outcome !== 0) {
            obj.outcome = sellOfferReviewCategory_OROutcomeToJSON(message.outcome);
        }
        if (message.origin !== 0) {
            obj.origin = sellOfferReviewCategory_OriginToJSON(message.origin);
        }
        if (message.sellerLeadUuid !== "") {
            obj.sellerLeadUuid = message.sellerLeadUuid;
        }
        return obj;
    },
    create: function create(base) {
        return SellOfferReviewCategory_OfferReviewCompletedEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseSellOfferReviewCategory_OfferReviewCompletedEvent();
        var _leadId;
        message.leadId = (_leadId = object.leadId) !== null && _leadId !== void 0 ? _leadId : "";
        var _offerUuid;
        message.offerUuid = (_offerUuid = object.offerUuid) !== null && _offerUuid !== void 0 ? _offerUuid : "";
        var _orType;
        message.orType = (_orType = object.orType) !== null && _orType !== void 0 ? _orType : 0;
        var _outcome;
        message.outcome = (_outcome = object.outcome) !== null && _outcome !== void 0 ? _outcome : 0;
        var _origin;
        message.origin = (_origin = object.origin) !== null && _origin !== void 0 ? _origin : 0;
        var _sellerLeadUuid;
        message.sellerLeadUuid = (_sellerLeadUuid = object.sellerLeadUuid) !== null && _sellerLeadUuid !== void 0 ? _sellerLeadUuid : "";
        return message;
    }
};
function createBaseSellOfferReviewCategory_OfferReviewRescheduledEvent() {
    return {
        leadId: "",
        offerUuid: "",
        orType: 0,
        scheduledDatetime: undefined,
        sellerLeadUuid: ""
    };
}
var SellOfferReviewCategory_OfferReviewRescheduledEvent = {
    fromJSON: function fromJSON(object) {
        return {
            leadId: sell_offer_review_category_isSet(object.leadId) ? String(object.leadId) : "",
            offerUuid: sell_offer_review_category_isSet(object.offerUuid) ? String(object.offerUuid) : "",
            orType: sell_offer_review_category_isSet(object.orType) ? sellOfferReviewCategory_ORTypeFromJSON(object.orType) : 0,
            scheduledDatetime: sell_offer_review_category_isSet(object.scheduledDatetime) ? sell_offer_review_category_fromJsonTimestamp(object.scheduledDatetime) : undefined,
            sellerLeadUuid: sell_offer_review_category_isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.leadId !== "") {
            obj.leadId = message.leadId;
        }
        if (message.offerUuid !== "") {
            obj.offerUuid = message.offerUuid;
        }
        if (message.orType !== 0) {
            obj.orType = sellOfferReviewCategory_ORTypeToJSON(message.orType);
        }
        if (message.scheduledDatetime !== undefined) {
            obj.scheduledDatetime = message.scheduledDatetime.toISOString();
        }
        if (message.sellerLeadUuid !== "") {
            obj.sellerLeadUuid = message.sellerLeadUuid;
        }
        return obj;
    },
    create: function create(base) {
        return SellOfferReviewCategory_OfferReviewRescheduledEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseSellOfferReviewCategory_OfferReviewRescheduledEvent();
        var _leadId;
        message.leadId = (_leadId = object.leadId) !== null && _leadId !== void 0 ? _leadId : "";
        var _offerUuid;
        message.offerUuid = (_offerUuid = object.offerUuid) !== null && _offerUuid !== void 0 ? _offerUuid : "";
        var _orType;
        message.orType = (_orType = object.orType) !== null && _orType !== void 0 ? _orType : 0;
        var _scheduledDatetime;
        message.scheduledDatetime = (_scheduledDatetime = object.scheduledDatetime) !== null && _scheduledDatetime !== void 0 ? _scheduledDatetime : undefined;
        var _sellerLeadUuid;
        message.sellerLeadUuid = (_sellerLeadUuid = object.sellerLeadUuid) !== null && _sellerLeadUuid !== void 0 ? _sellerLeadUuid : "";
        return message;
    }
};
function createBaseSellOfferReviewCategory_OfferReviewCanceledEvent() {
    return {
        leadId: "",
        offerUuid: "",
        orType: 0,
        reason: undefined,
        sellerLeadUuid: ""
    };
}
var SellOfferReviewCategory_OfferReviewCanceledEvent = {
    fromJSON: function fromJSON(object) {
        return {
            leadId: sell_offer_review_category_isSet(object.leadId) ? String(object.leadId) : "",
            offerUuid: sell_offer_review_category_isSet(object.offerUuid) ? String(object.offerUuid) : "",
            orType: sell_offer_review_category_isSet(object.orType) ? sellOfferReviewCategory_ORTypeFromJSON(object.orType) : 0,
            reason: sell_offer_review_category_isSet(object.reason) ? String(object.reason) : undefined,
            sellerLeadUuid: sell_offer_review_category_isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.leadId !== "") {
            obj.leadId = message.leadId;
        }
        if (message.offerUuid !== "") {
            obj.offerUuid = message.offerUuid;
        }
        if (message.orType !== 0) {
            obj.orType = sellOfferReviewCategory_ORTypeToJSON(message.orType);
        }
        if (message.reason !== undefined) {
            obj.reason = message.reason;
        }
        if (message.sellerLeadUuid !== "") {
            obj.sellerLeadUuid = message.sellerLeadUuid;
        }
        return obj;
    },
    create: function create(base) {
        return SellOfferReviewCategory_OfferReviewCanceledEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseSellOfferReviewCategory_OfferReviewCanceledEvent();
        var _leadId;
        message.leadId = (_leadId = object.leadId) !== null && _leadId !== void 0 ? _leadId : "";
        var _offerUuid;
        message.offerUuid = (_offerUuid = object.offerUuid) !== null && _offerUuid !== void 0 ? _offerUuid : "";
        var _orType;
        message.orType = (_orType = object.orType) !== null && _orType !== void 0 ? _orType : 0;
        var _reason;
        message.reason = (_reason = object.reason) !== null && _reason !== void 0 ? _reason : undefined;
        var _sellerLeadUuid;
        message.sellerLeadUuid = (_sellerLeadUuid = object.sellerLeadUuid) !== null && _sellerLeadUuid !== void 0 ? _sellerLeadUuid : "";
        return message;
    }
};
function sell_offer_review_category_fromTimestamp(t) {
    var millis = (t.seconds || 0) * 1000;
    millis += (t.nanos || 0) / 1000000;
    return new Date(millis);
}
function sell_offer_review_category_fromJsonTimestamp(o) {
    if ((0,_instanceof/* default */.Z)(o, Date)) {
        return o;
    } else if (typeof o === "string") {
        return new Date(o);
    } else {
        return sell_offer_review_category_fromTimestamp(Timestamp.fromJSON(o));
    }
}
function sell_offer_review_category_isSet(value) {
    return value !== null && value !== undefined;
}

;// CONCATENATED MODULE: ./src/__generated__/protobuf/journey/data/categories/sell_onboarding_category.ts
/* eslint-disable */ 
var sell_onboarding_category_protobufPackage = "od_protos.journey.data.categories";
function createBaseSellOnboardingCategory() {
    return {
        event: undefined
    };
}
var SellOnboardingCategory = {
    fromJSON: function fromJSON(object) {
        return {
            event: sell_onboarding_category_isSet(object.questionsSubmit) ? {
                $case: "questionsSubmit",
                questionsSubmit: SellOnboardingCategory_QuestionsSubmitEvent.fromJSON(object.questionsSubmit)
            } : undefined
        };
    },
    toJSON: function toJSON(message) {
        var ref;
        var obj = {};
        if (((ref = message.event) === null || ref === void 0 ? void 0 : ref.$case) === "questionsSubmit") {
            obj.questionsSubmit = SellOnboardingCategory_QuestionsSubmitEvent.toJSON(message.event.questionsSubmit);
        }
        return obj;
    },
    create: function create(base) {
        return SellOnboardingCategory.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref, ref1, ref2;
        var message = createBaseSellOnboardingCategory();
        if (((ref = object.event) === null || ref === void 0 ? void 0 : ref.$case) === "questionsSubmit" && ((ref1 = object.event) === null || ref1 === void 0 ? void 0 : ref1.questionsSubmit) !== undefined && ((ref2 = object.event) === null || ref2 === void 0 ? void 0 : ref2.questionsSubmit) !== null) {
            message.event = {
                $case: "questionsSubmit",
                questionsSubmit: SellOnboardingCategory_QuestionsSubmitEvent.fromPartial(object.event.questionsSubmit)
            };
        }
        return message;
    }
};
function createBaseSellOnboardingCategory_QuestionsSubmitEvent() {
    return {
        sellerInputId: "",
        answers: undefined
    };
}
var SellOnboardingCategory_QuestionsSubmitEvent = {
    fromJSON: function fromJSON(object) {
        return {
            sellerInputId: sell_onboarding_category_isSet(object.sellerInputId) ? String(object.sellerInputId) : "",
            answers: sell_onboarding_category_isSet(object.answers) ? Answers.fromJSON(object.answers) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.sellerInputId !== "") {
            obj.sellerInputId = message.sellerInputId;
        }
        if (message.answers !== undefined) {
            obj.answers = Answers.toJSON(message.answers);
        }
        return obj;
    },
    create: function create(base) {
        return SellOnboardingCategory_QuestionsSubmitEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseSellOnboardingCategory_QuestionsSubmitEvent();
        var _sellerInputId;
        message.sellerInputId = (_sellerInputId = object.sellerInputId) !== null && _sellerInputId !== void 0 ? _sellerInputId : "";
        message.answers = object.answers !== undefined && object.answers !== null ? Answers.fromPartial(object.answers) : undefined;
        return message;
    }
};
function sell_onboarding_category_isSet(value) {
    return value !== null && value !== undefined;
}

;// CONCATENATED MODULE: ./src/__generated__/protobuf/journey/data/categories/sell_orva_category.ts
/* eslint-disable */ 

var sell_orva_category_protobufPackage = "od_protos.journey.data.categories";
var SellORVACategory_ORVACancellationReason;
(function(SellORVACategory_ORVACancellationReason) {
    SellORVACategory_ORVACancellationReason[SellORVACategory_ORVACancellationReason["CANCELLATION_REASON_UNKNOWN"] = 0] = "CANCELLATION_REASON_UNKNOWN";
    SellORVACategory_ORVACancellationReason[SellORVACategory_ORVACancellationReason["CEP_CANNOT_MAKE_IT"] = 1] = "CEP_CANNOT_MAKE_IT";
    SellORVACategory_ORVACancellationReason[SellORVACategory_ORVACancellationReason["CUSTOMER_CANNOT_MAKE_IT"] = 2] = "CUSTOMER_CANNOT_MAKE_IT";
    SellORVACategory_ORVACancellationReason[SellORVACategory_ORVACancellationReason["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(SellORVACategory_ORVACancellationReason || (SellORVACategory_ORVACancellationReason = {}));
function sellORVACategory_ORVACancellationReasonFromJSON(object) {
    switch(object){
        case 0:
        case "CANCELLATION_REASON_UNKNOWN":
            return SellORVACategory_ORVACancellationReason.CANCELLATION_REASON_UNKNOWN;
        case 1:
        case "CEP_CANNOT_MAKE_IT":
            return SellORVACategory_ORVACancellationReason.CEP_CANNOT_MAKE_IT;
        case 2:
        case "CUSTOMER_CANNOT_MAKE_IT":
            return SellORVACategory_ORVACancellationReason.CUSTOMER_CANNOT_MAKE_IT;
        case -1:
        case "UNRECOGNIZED":
        default:
            return SellORVACategory_ORVACancellationReason.UNRECOGNIZED;
    }
}
function sellORVACategory_ORVACancellationReasonToJSON(object) {
    switch(object){
        case SellORVACategory_ORVACancellationReason.CANCELLATION_REASON_UNKNOWN:
            return "CANCELLATION_REASON_UNKNOWN";
        case SellORVACategory_ORVACancellationReason.CEP_CANNOT_MAKE_IT:
            return "CEP_CANNOT_MAKE_IT";
        case SellORVACategory_ORVACancellationReason.CUSTOMER_CANNOT_MAKE_IT:
            return "CUSTOMER_CANNOT_MAKE_IT";
        case SellORVACategory_ORVACancellationReason.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
function createBaseSellORVACategory() {
    return {
        event: undefined
    };
}
var SellORVACategory = {
    fromJSON: function fromJSON(object) {
        return {
            event: sell_orva_category_isSet(object.schedule) ? {
                $case: "schedule",
                schedule: SellORVACategory_ScheduleEvent.fromJSON(object.schedule)
            } : sell_orva_category_isSet(object.reschedule) ? {
                $case: "reschedule",
                reschedule: SellORVACategory_RescheduleEvent.fromJSON(object.reschedule)
            } : sell_orva_category_isSet(object.cancel) ? {
                $case: "cancel",
                cancel: SellORVACategory_CancelEvent.fromJSON(object.cancel)
            } : undefined
        };
    },
    toJSON: function toJSON(message) {
        var ref, ref1, ref2;
        var obj = {};
        if (((ref = message.event) === null || ref === void 0 ? void 0 : ref.$case) === "schedule") {
            obj.schedule = SellORVACategory_ScheduleEvent.toJSON(message.event.schedule);
        }
        if (((ref1 = message.event) === null || ref1 === void 0 ? void 0 : ref1.$case) === "reschedule") {
            obj.reschedule = SellORVACategory_RescheduleEvent.toJSON(message.event.reschedule);
        }
        if (((ref2 = message.event) === null || ref2 === void 0 ? void 0 : ref2.$case) === "cancel") {
            obj.cancel = SellORVACategory_CancelEvent.toJSON(message.event.cancel);
        }
        return obj;
    },
    create: function create(base) {
        return SellORVACategory.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
        var message = createBaseSellORVACategory();
        if (((ref = object.event) === null || ref === void 0 ? void 0 : ref.$case) === "schedule" && ((ref1 = object.event) === null || ref1 === void 0 ? void 0 : ref1.schedule) !== undefined && ((ref2 = object.event) === null || ref2 === void 0 ? void 0 : ref2.schedule) !== null) {
            message.event = {
                $case: "schedule",
                schedule: SellORVACategory_ScheduleEvent.fromPartial(object.event.schedule)
            };
        }
        if (((ref3 = object.event) === null || ref3 === void 0 ? void 0 : ref3.$case) === "reschedule" && ((ref4 = object.event) === null || ref4 === void 0 ? void 0 : ref4.reschedule) !== undefined && ((ref5 = object.event) === null || ref5 === void 0 ? void 0 : ref5.reschedule) !== null) {
            message.event = {
                $case: "reschedule",
                reschedule: SellORVACategory_RescheduleEvent.fromPartial(object.event.reschedule)
            };
        }
        if (((ref6 = object.event) === null || ref6 === void 0 ? void 0 : ref6.$case) === "cancel" && ((ref7 = object.event) === null || ref7 === void 0 ? void 0 : ref7.cancel) !== undefined && ((ref8 = object.event) === null || ref8 === void 0 ? void 0 : ref8.cancel) !== null) {
            message.event = {
                $case: "cancel",
                cancel: SellORVACategory_CancelEvent.fromPartial(object.event.cancel)
            };
        }
        return message;
    }
};
function createBaseSellORVACategory_ScheduleEvent() {
    return {
        leadId: "",
        offerId: "",
        scheduledDatetime: undefined,
        agentScheduled: "",
        offerUuid: "",
        sellerLeadUuid: ""
    };
}
var SellORVACategory_ScheduleEvent = {
    fromJSON: function fromJSON(object) {
        return {
            leadId: sell_orva_category_isSet(object.leadId) ? String(object.leadId) : "",
            offerId: sell_orva_category_isSet(object.offerId) ? String(object.offerId) : "",
            scheduledDatetime: sell_orva_category_isSet(object.scheduledDatetime) ? sell_orva_category_fromJsonTimestamp(object.scheduledDatetime) : undefined,
            agentScheduled: sell_orva_category_isSet(object.agentScheduled) ? String(object.agentScheduled) : "",
            offerUuid: sell_orva_category_isSet(object.offerUuid) ? String(object.offerUuid) : "",
            sellerLeadUuid: sell_orva_category_isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.leadId !== "") {
            obj.leadId = message.leadId;
        }
        if (message.offerId !== "") {
            obj.offerId = message.offerId;
        }
        if (message.scheduledDatetime !== undefined) {
            obj.scheduledDatetime = message.scheduledDatetime.toISOString();
        }
        if (message.agentScheduled !== "") {
            obj.agentScheduled = message.agentScheduled;
        }
        if (message.offerUuid !== "") {
            obj.offerUuid = message.offerUuid;
        }
        if (message.sellerLeadUuid !== "") {
            obj.sellerLeadUuid = message.sellerLeadUuid;
        }
        return obj;
    },
    create: function create(base) {
        return SellORVACategory_ScheduleEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseSellORVACategory_ScheduleEvent();
        var _leadId;
        message.leadId = (_leadId = object.leadId) !== null && _leadId !== void 0 ? _leadId : "";
        var _offerId;
        message.offerId = (_offerId = object.offerId) !== null && _offerId !== void 0 ? _offerId : "";
        var _scheduledDatetime;
        message.scheduledDatetime = (_scheduledDatetime = object.scheduledDatetime) !== null && _scheduledDatetime !== void 0 ? _scheduledDatetime : undefined;
        var _agentScheduled;
        message.agentScheduled = (_agentScheduled = object.agentScheduled) !== null && _agentScheduled !== void 0 ? _agentScheduled : "";
        var _offerUuid;
        message.offerUuid = (_offerUuid = object.offerUuid) !== null && _offerUuid !== void 0 ? _offerUuid : "";
        var _sellerLeadUuid;
        message.sellerLeadUuid = (_sellerLeadUuid = object.sellerLeadUuid) !== null && _sellerLeadUuid !== void 0 ? _sellerLeadUuid : "";
        return message;
    }
};
function createBaseSellORVACategory_RescheduleEvent() {
    return {
        leadId: "",
        offerId: "",
        offerUuid: "",
        sellerLeadUuid: ""
    };
}
var SellORVACategory_RescheduleEvent = {
    fromJSON: function fromJSON(object) {
        return {
            leadId: sell_orva_category_isSet(object.leadId) ? String(object.leadId) : "",
            offerId: sell_orva_category_isSet(object.offerId) ? String(object.offerId) : "",
            offerUuid: sell_orva_category_isSet(object.offerUuid) ? String(object.offerUuid) : "",
            sellerLeadUuid: sell_orva_category_isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.leadId !== "") {
            obj.leadId = message.leadId;
        }
        if (message.offerId !== "") {
            obj.offerId = message.offerId;
        }
        if (message.offerUuid !== "") {
            obj.offerUuid = message.offerUuid;
        }
        if (message.sellerLeadUuid !== "") {
            obj.sellerLeadUuid = message.sellerLeadUuid;
        }
        return obj;
    },
    create: function create(base) {
        return SellORVACategory_RescheduleEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseSellORVACategory_RescheduleEvent();
        var _leadId;
        message.leadId = (_leadId = object.leadId) !== null && _leadId !== void 0 ? _leadId : "";
        var _offerId;
        message.offerId = (_offerId = object.offerId) !== null && _offerId !== void 0 ? _offerId : "";
        var _offerUuid;
        message.offerUuid = (_offerUuid = object.offerUuid) !== null && _offerUuid !== void 0 ? _offerUuid : "";
        var _sellerLeadUuid;
        message.sellerLeadUuid = (_sellerLeadUuid = object.sellerLeadUuid) !== null && _sellerLeadUuid !== void 0 ? _sellerLeadUuid : "";
        return message;
    }
};
function createBaseSellORVACategory_CancelEvent() {
    return {
        leadId: "",
        offerId: "",
        offerUuid: "",
        cancellationReason: 0,
        cancellationSource: undefined,
        sellerLeadUuid: ""
    };
}
var SellORVACategory_CancelEvent = {
    fromJSON: function fromJSON(object) {
        return {
            leadId: sell_orva_category_isSet(object.leadId) ? String(object.leadId) : "",
            offerId: sell_orva_category_isSet(object.offerId) ? String(object.offerId) : "",
            offerUuid: sell_orva_category_isSet(object.offerUuid) ? String(object.offerUuid) : "",
            cancellationReason: sell_orva_category_isSet(object.cancellationReason) ? sellORVACategory_ORVACancellationReasonFromJSON(object.cancellationReason) : 0,
            cancellationSource: sell_orva_category_isSet(object.cancellationSource) ? String(object.cancellationSource) : undefined,
            sellerLeadUuid: sell_orva_category_isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.leadId !== "") {
            obj.leadId = message.leadId;
        }
        if (message.offerId !== "") {
            obj.offerId = message.offerId;
        }
        if (message.offerUuid !== "") {
            obj.offerUuid = message.offerUuid;
        }
        if (message.cancellationReason !== 0) {
            obj.cancellationReason = sellORVACategory_ORVACancellationReasonToJSON(message.cancellationReason);
        }
        if (message.cancellationSource !== undefined) {
            obj.cancellationSource = message.cancellationSource;
        }
        if (message.sellerLeadUuid !== "") {
            obj.sellerLeadUuid = message.sellerLeadUuid;
        }
        return obj;
    },
    create: function create(base) {
        return SellORVACategory_CancelEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseSellORVACategory_CancelEvent();
        var _leadId;
        message.leadId = (_leadId = object.leadId) !== null && _leadId !== void 0 ? _leadId : "";
        var _offerId;
        message.offerId = (_offerId = object.offerId) !== null && _offerId !== void 0 ? _offerId : "";
        var _offerUuid;
        message.offerUuid = (_offerUuid = object.offerUuid) !== null && _offerUuid !== void 0 ? _offerUuid : "";
        var _cancellationReason;
        message.cancellationReason = (_cancellationReason = object.cancellationReason) !== null && _cancellationReason !== void 0 ? _cancellationReason : 0;
        var _cancellationSource;
        message.cancellationSource = (_cancellationSource = object.cancellationSource) !== null && _cancellationSource !== void 0 ? _cancellationSource : undefined;
        var _sellerLeadUuid;
        message.sellerLeadUuid = (_sellerLeadUuid = object.sellerLeadUuid) !== null && _sellerLeadUuid !== void 0 ? _sellerLeadUuid : "";
        return message;
    }
};
function sell_orva_category_fromTimestamp(t) {
    var millis = (t.seconds || 0) * 1000;
    millis += (t.nanos || 0) / 1000000;
    return new Date(millis);
}
function sell_orva_category_fromJsonTimestamp(o) {
    if ((0,_instanceof/* default */.Z)(o, Date)) {
        return o;
    } else if (typeof o === "string") {
        return new Date(o);
    } else {
        return sell_orva_category_fromTimestamp(Timestamp.fromJSON(o));
    }
}
function sell_orva_category_isSet(value) {
    return value !== null && value !== undefined;
}

;// CONCATENATED MODULE: ./src/__generated__/protobuf/common/date.ts
/* eslint-disable */ var date_protobufPackage = "od_protos.common";
function createBaseDateMessage() {
    return {
        year: 0,
        month: 0,
        day: 0
    };
}
var DateMessage = {
    fromJSON: function fromJSON(object) {
        return {
            year: date_isSet(object.year) ? Number(object.year) : 0,
            month: date_isSet(object.month) ? Number(object.month) : 0,
            day: date_isSet(object.day) ? Number(object.day) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.year !== 0) {
            obj.year = Math.round(message.year);
        }
        if (message.month !== 0) {
            obj.month = Math.round(message.month);
        }
        if (message.day !== 0) {
            obj.day = Math.round(message.day);
        }
        return obj;
    },
    create: function create(base) {
        return DateMessage.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseDateMessage();
        var _year;
        message.year = (_year = object.year) !== null && _year !== void 0 ? _year : 0;
        var _month;
        message.month = (_month = object.month) !== null && _month !== void 0 ? _month : 0;
        var _day;
        message.day = (_day = object.day) !== null && _day !== void 0 ? _day : 0;
        return message;
    }
};
function createBaseTime() {
    return {
        hours: 0,
        minutes: 0
    };
}
var Time = {
    fromJSON: function fromJSON(object) {
        return {
            hours: date_isSet(object.hours) ? Number(object.hours) : 0,
            minutes: date_isSet(object.minutes) ? Number(object.minutes) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.hours !== 0) {
            obj.hours = Math.round(message.hours);
        }
        if (message.minutes !== 0) {
            obj.minutes = Math.round(message.minutes);
        }
        return obj;
    },
    create: function create(base) {
        return Time.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseTime();
        var _hours;
        message.hours = (_hours = object.hours) !== null && _hours !== void 0 ? _hours : 0;
        var _minutes;
        message.minutes = (_minutes = object.minutes) !== null && _minutes !== void 0 ? _minutes : 0;
        return message;
    }
};
function createBaseDateTime() {
    return {
        year: 0,
        month: 0,
        day: 0,
        hours: 0,
        minutes: 0
    };
}
var DateTime = {
    fromJSON: function fromJSON(object) {
        return {
            year: date_isSet(object.year) ? Number(object.year) : 0,
            month: date_isSet(object.month) ? Number(object.month) : 0,
            day: date_isSet(object.day) ? Number(object.day) : 0,
            hours: date_isSet(object.hours) ? Number(object.hours) : 0,
            minutes: date_isSet(object.minutes) ? Number(object.minutes) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.year !== 0) {
            obj.year = Math.round(message.year);
        }
        if (message.month !== 0) {
            obj.month = Math.round(message.month);
        }
        if (message.day !== 0) {
            obj.day = Math.round(message.day);
        }
        if (message.hours !== 0) {
            obj.hours = Math.round(message.hours);
        }
        if (message.minutes !== 0) {
            obj.minutes = Math.round(message.minutes);
        }
        return obj;
    },
    create: function create(base) {
        return DateTime.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseDateTime();
        var _year;
        message.year = (_year = object.year) !== null && _year !== void 0 ? _year : 0;
        var _month;
        message.month = (_month = object.month) !== null && _month !== void 0 ? _month : 0;
        var _day;
        message.day = (_day = object.day) !== null && _day !== void 0 ? _day : 0;
        var _hours;
        message.hours = (_hours = object.hours) !== null && _hours !== void 0 ? _hours : 0;
        var _minutes;
        message.minutes = (_minutes = object.minutes) !== null && _minutes !== void 0 ? _minutes : 0;
        return message;
    }
};
function date_isSet(value) {
    return value !== null && value !== undefined;
}

;// CONCATENATED MODULE: ./src/__generated__/protobuf/web/data/comp.ts
/* eslint-disable */ 


var comp_protobufPackage = "od_protos.web.data";
function comp_createBaseComp() {
    return {
        id: "",
        address: undefined,
        deltas: undefined,
        photo: "",
        homeDetails: undefined,
        listingDetails: undefined
    };
}
var comp_Comp = {
    fromJSON: function fromJSON(object) {
        return {
            id: comp_isSet(object.id) ? String(object.id) : "",
            address: comp_isSet(object.address) ? Address.fromJSON(object.address) : undefined,
            deltas: comp_isSet(object.deltas) ? Deltas.fromJSON(object.deltas) : undefined,
            photo: comp_isSet(object.photo) ? String(object.photo) : "",
            homeDetails: comp_isSet(object.homeDetails) ? HomeDetails.fromJSON(object.homeDetails) : undefined,
            listingDetails: comp_isSet(object.listingDetails) ? ListingDetails.fromJSON(object.listingDetails) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.address !== undefined) {
            obj.address = Address.toJSON(message.address);
        }
        if (message.deltas !== undefined) {
            obj.deltas = Deltas.toJSON(message.deltas);
        }
        if (message.photo !== "") {
            obj.photo = message.photo;
        }
        if (message.homeDetails !== undefined) {
            obj.homeDetails = HomeDetails.toJSON(message.homeDetails);
        }
        if (message.listingDetails !== undefined) {
            obj.listingDetails = ListingDetails.toJSON(message.listingDetails);
        }
        return obj;
    },
    create: function create(base) {
        return comp_Comp.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = comp_createBaseComp();
        var _id;
        message.id = (_id = object.id) !== null && _id !== void 0 ? _id : "";
        message.address = object.address !== undefined && object.address !== null ? Address.fromPartial(object.address) : undefined;
        message.deltas = object.deltas !== undefined && object.deltas !== null ? Deltas.fromPartial(object.deltas) : undefined;
        var _photo;
        message.photo = (_photo = object.photo) !== null && _photo !== void 0 ? _photo : "";
        message.homeDetails = object.homeDetails !== undefined && object.homeDetails !== null ? HomeDetails.fromPartial(object.homeDetails) : undefined;
        message.listingDetails = object.listingDetails !== undefined && object.listingDetails !== null ? ListingDetails.fromPartial(object.listingDetails) : undefined;
        return message;
    }
};
function createBaseAddress() {
    return {
        id: "",
        addressToken: "",
        city: "",
        latitude: "",
        longitude: "",
        postalCode: "",
        state: "",
        street1: "",
        unit: "",
        createdAt: undefined,
        updatedAt: undefined,
        apn: "",
        isMissingUnitNumber: false,
        signature: "",
        valuationNotes: "",
        slug: "",
        lonlat: ""
    };
}
var Address = {
    fromJSON: function fromJSON(object) {
        return {
            id: comp_isSet(object.id) ? String(object.id) : "",
            addressToken: comp_isSet(object.addressToken) ? String(object.addressToken) : "",
            city: comp_isSet(object.city) ? String(object.city) : "",
            latitude: comp_isSet(object.latitude) ? String(object.latitude) : "",
            longitude: comp_isSet(object.longitude) ? String(object.longitude) : "",
            postalCode: comp_isSet(object.postalCode) ? String(object.postalCode) : "",
            state: comp_isSet(object.state) ? String(object.state) : "",
            street1: comp_isSet(object.street1) ? String(object.street1) : "",
            unit: comp_isSet(object.unit) ? String(object.unit) : "",
            createdAt: comp_isSet(object.createdAt) ? comp_fromJsonTimestamp(object.createdAt) : undefined,
            updatedAt: comp_isSet(object.updatedAt) ? comp_fromJsonTimestamp(object.updatedAt) : undefined,
            apn: comp_isSet(object.apn) ? String(object.apn) : "",
            isMissingUnitNumber: comp_isSet(object.isMissingUnitNumber) ? Boolean(object.isMissingUnitNumber) : false,
            signature: comp_isSet(object.signature) ? String(object.signature) : "",
            valuationNotes: comp_isSet(object.valuationNotes) ? String(object.valuationNotes) : "",
            slug: comp_isSet(object.slug) ? String(object.slug) : "",
            lonlat: comp_isSet(object.lonlat) ? String(object.lonlat) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.addressToken !== "") {
            obj.addressToken = message.addressToken;
        }
        if (message.city !== "") {
            obj.city = message.city;
        }
        if (message.latitude !== "") {
            obj.latitude = message.latitude;
        }
        if (message.longitude !== "") {
            obj.longitude = message.longitude;
        }
        if (message.postalCode !== "") {
            obj.postalCode = message.postalCode;
        }
        if (message.state !== "") {
            obj.state = message.state;
        }
        if (message.street1 !== "") {
            obj.street1 = message.street1;
        }
        if (message.unit !== "") {
            obj.unit = message.unit;
        }
        if (message.createdAt !== undefined) {
            obj.createdAt = message.createdAt.toISOString();
        }
        if (message.updatedAt !== undefined) {
            obj.updatedAt = message.updatedAt.toISOString();
        }
        if (message.apn !== "") {
            obj.apn = message.apn;
        }
        if (message.isMissingUnitNumber === true) {
            obj.isMissingUnitNumber = message.isMissingUnitNumber;
        }
        if (message.signature !== "") {
            obj.signature = message.signature;
        }
        if (message.valuationNotes !== "") {
            obj.valuationNotes = message.valuationNotes;
        }
        if (message.slug !== "") {
            obj.slug = message.slug;
        }
        if (message.lonlat !== "") {
            obj.lonlat = message.lonlat;
        }
        return obj;
    },
    create: function create(base) {
        return Address.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAddress();
        var _id;
        message.id = (_id = object.id) !== null && _id !== void 0 ? _id : "";
        var _addressToken;
        message.addressToken = (_addressToken = object.addressToken) !== null && _addressToken !== void 0 ? _addressToken : "";
        var _city;
        message.city = (_city = object.city) !== null && _city !== void 0 ? _city : "";
        var _latitude;
        message.latitude = (_latitude = object.latitude) !== null && _latitude !== void 0 ? _latitude : "";
        var _longitude;
        message.longitude = (_longitude = object.longitude) !== null && _longitude !== void 0 ? _longitude : "";
        var _postalCode;
        message.postalCode = (_postalCode = object.postalCode) !== null && _postalCode !== void 0 ? _postalCode : "";
        var _state;
        message.state = (_state = object.state) !== null && _state !== void 0 ? _state : "";
        var _street1;
        message.street1 = (_street1 = object.street1) !== null && _street1 !== void 0 ? _street1 : "";
        var _unit;
        message.unit = (_unit = object.unit) !== null && _unit !== void 0 ? _unit : "";
        var _createdAt;
        message.createdAt = (_createdAt = object.createdAt) !== null && _createdAt !== void 0 ? _createdAt : undefined;
        var _updatedAt;
        message.updatedAt = (_updatedAt = object.updatedAt) !== null && _updatedAt !== void 0 ? _updatedAt : undefined;
        var _apn;
        message.apn = (_apn = object.apn) !== null && _apn !== void 0 ? _apn : "";
        var _isMissingUnitNumber;
        message.isMissingUnitNumber = (_isMissingUnitNumber = object.isMissingUnitNumber) !== null && _isMissingUnitNumber !== void 0 ? _isMissingUnitNumber : false;
        var _signature;
        message.signature = (_signature = object.signature) !== null && _signature !== void 0 ? _signature : "";
        var _valuationNotes;
        message.valuationNotes = (_valuationNotes = object.valuationNotes) !== null && _valuationNotes !== void 0 ? _valuationNotes : "";
        var _slug;
        message.slug = (_slug = object.slug) !== null && _slug !== void 0 ? _slug : "";
        var _lonlat;
        message.lonlat = (_lonlat = object.lonlat) !== null && _lonlat !== void 0 ? _lonlat : "";
        return message;
    }
};
function createBaseDeltas() {
    return {
        bathroomsFull: 0,
        bathroomsHalf: 0,
        bedrooms: 0,
        exteriorStories: 0,
        garageSpaces: 0,
        lotSqFt: 0,
        pool: 0,
        sqFt: 0,
        yearBuilt: 0
    };
}
var Deltas = {
    fromJSON: function fromJSON(object) {
        return {
            bathroomsFull: comp_isSet(object.bathroomsFull) ? Number(object.bathroomsFull) : 0,
            bathroomsHalf: comp_isSet(object.bathroomsHalf) ? Number(object.bathroomsHalf) : 0,
            bedrooms: comp_isSet(object.bedrooms) ? Number(object.bedrooms) : 0,
            exteriorStories: comp_isSet(object.exteriorStories) ? Number(object.exteriorStories) : 0,
            garageSpaces: comp_isSet(object.garageSpaces) ? Number(object.garageSpaces) : 0,
            lotSqFt: comp_isSet(object.lotSqFt) ? Number(object.lotSqFt) : 0,
            pool: comp_isSet(object.pool) ? Number(object.pool) : 0,
            sqFt: comp_isSet(object.sqFt) ? Number(object.sqFt) : 0,
            yearBuilt: comp_isSet(object.yearBuilt) ? Number(object.yearBuilt) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.bathroomsFull !== 0) {
            obj.bathroomsFull = Math.round(message.bathroomsFull);
        }
        if (message.bathroomsHalf !== 0) {
            obj.bathroomsHalf = Math.round(message.bathroomsHalf);
        }
        if (message.bedrooms !== 0) {
            obj.bedrooms = Math.round(message.bedrooms);
        }
        if (message.exteriorStories !== 0) {
            obj.exteriorStories = Math.round(message.exteriorStories);
        }
        if (message.garageSpaces !== 0) {
            obj.garageSpaces = Math.round(message.garageSpaces);
        }
        if (message.lotSqFt !== 0) {
            obj.lotSqFt = Math.round(message.lotSqFt);
        }
        if (message.pool !== 0) {
            obj.pool = Math.round(message.pool);
        }
        if (message.sqFt !== 0) {
            obj.sqFt = Math.round(message.sqFt);
        }
        if (message.yearBuilt !== 0) {
            obj.yearBuilt = Math.round(message.yearBuilt);
        }
        return obj;
    },
    create: function create(base) {
        return Deltas.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseDeltas();
        var _bathroomsFull;
        message.bathroomsFull = (_bathroomsFull = object.bathroomsFull) !== null && _bathroomsFull !== void 0 ? _bathroomsFull : 0;
        var _bathroomsHalf;
        message.bathroomsHalf = (_bathroomsHalf = object.bathroomsHalf) !== null && _bathroomsHalf !== void 0 ? _bathroomsHalf : 0;
        var _bedrooms;
        message.bedrooms = (_bedrooms = object.bedrooms) !== null && _bedrooms !== void 0 ? _bedrooms : 0;
        var _exteriorStories;
        message.exteriorStories = (_exteriorStories = object.exteriorStories) !== null && _exteriorStories !== void 0 ? _exteriorStories : 0;
        var _garageSpaces;
        message.garageSpaces = (_garageSpaces = object.garageSpaces) !== null && _garageSpaces !== void 0 ? _garageSpaces : 0;
        var _lotSqFt;
        message.lotSqFt = (_lotSqFt = object.lotSqFt) !== null && _lotSqFt !== void 0 ? _lotSqFt : 0;
        var _pool;
        message.pool = (_pool = object.pool) !== null && _pool !== void 0 ? _pool : 0;
        var _sqFt;
        message.sqFt = (_sqFt = object.sqFt) !== null && _sqFt !== void 0 ? _sqFt : 0;
        var _yearBuilt;
        message.yearBuilt = (_yearBuilt = object.yearBuilt) !== null && _yearBuilt !== void 0 ? _yearBuilt : 0;
        return message;
    }
};
function createBaseHomeDetails() {
    return {
        bathroomsFull: 0,
        bathroomsHalf: 0,
        bedrooms: 0,
        exteriorStories: 0,
        garageSpaces: 0,
        lotSqFt: 0,
        pool: false,
        sqFt: 0,
        yearBuilt: 0,
        aboveGradeSqFt: 0,
        basementSqFt: 0
    };
}
var HomeDetails = {
    fromJSON: function fromJSON(object) {
        return {
            bathroomsFull: comp_isSet(object.bathroomsFull) ? Number(object.bathroomsFull) : 0,
            bathroomsHalf: comp_isSet(object.bathroomsHalf) ? Number(object.bathroomsHalf) : 0,
            bedrooms: comp_isSet(object.bedrooms) ? Number(object.bedrooms) : 0,
            exteriorStories: comp_isSet(object.exteriorStories) ? Number(object.exteriorStories) : 0,
            garageSpaces: comp_isSet(object.garageSpaces) ? Number(object.garageSpaces) : 0,
            lotSqFt: comp_isSet(object.lotSqFt) ? Number(object.lotSqFt) : 0,
            pool: comp_isSet(object.pool) ? Boolean(object.pool) : false,
            sqFt: comp_isSet(object.sqFt) ? Number(object.sqFt) : 0,
            yearBuilt: comp_isSet(object.yearBuilt) ? Number(object.yearBuilt) : 0,
            aboveGradeSqFt: comp_isSet(object.aboveGradeSqFt) ? Number(object.aboveGradeSqFt) : 0,
            basementSqFt: comp_isSet(object.basementSqFt) ? Number(object.basementSqFt) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.bathroomsFull !== 0) {
            obj.bathroomsFull = Math.round(message.bathroomsFull);
        }
        if (message.bathroomsHalf !== 0) {
            obj.bathroomsHalf = Math.round(message.bathroomsHalf);
        }
        if (message.bedrooms !== 0) {
            obj.bedrooms = Math.round(message.bedrooms);
        }
        if (message.exteriorStories !== 0) {
            obj.exteriorStories = Math.round(message.exteriorStories);
        }
        if (message.garageSpaces !== 0) {
            obj.garageSpaces = Math.round(message.garageSpaces);
        }
        if (message.lotSqFt !== 0) {
            obj.lotSqFt = Math.round(message.lotSqFt);
        }
        if (message.pool === true) {
            obj.pool = message.pool;
        }
        if (message.sqFt !== 0) {
            obj.sqFt = Math.round(message.sqFt);
        }
        if (message.yearBuilt !== 0) {
            obj.yearBuilt = Math.round(message.yearBuilt);
        }
        if (message.aboveGradeSqFt !== 0) {
            obj.aboveGradeSqFt = Math.round(message.aboveGradeSqFt);
        }
        if (message.basementSqFt !== 0) {
            obj.basementSqFt = Math.round(message.basementSqFt);
        }
        return obj;
    },
    create: function create(base) {
        return HomeDetails.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseHomeDetails();
        var _bathroomsFull;
        message.bathroomsFull = (_bathroomsFull = object.bathroomsFull) !== null && _bathroomsFull !== void 0 ? _bathroomsFull : 0;
        var _bathroomsHalf;
        message.bathroomsHalf = (_bathroomsHalf = object.bathroomsHalf) !== null && _bathroomsHalf !== void 0 ? _bathroomsHalf : 0;
        var _bedrooms;
        message.bedrooms = (_bedrooms = object.bedrooms) !== null && _bedrooms !== void 0 ? _bedrooms : 0;
        var _exteriorStories;
        message.exteriorStories = (_exteriorStories = object.exteriorStories) !== null && _exteriorStories !== void 0 ? _exteriorStories : 0;
        var _garageSpaces;
        message.garageSpaces = (_garageSpaces = object.garageSpaces) !== null && _garageSpaces !== void 0 ? _garageSpaces : 0;
        var _lotSqFt;
        message.lotSqFt = (_lotSqFt = object.lotSqFt) !== null && _lotSqFt !== void 0 ? _lotSqFt : 0;
        var _pool;
        message.pool = (_pool = object.pool) !== null && _pool !== void 0 ? _pool : false;
        var _sqFt;
        message.sqFt = (_sqFt = object.sqFt) !== null && _sqFt !== void 0 ? _sqFt : 0;
        var _yearBuilt;
        message.yearBuilt = (_yearBuilt = object.yearBuilt) !== null && _yearBuilt !== void 0 ? _yearBuilt : 0;
        var _aboveGradeSqFt;
        message.aboveGradeSqFt = (_aboveGradeSqFt = object.aboveGradeSqFt) !== null && _aboveGradeSqFt !== void 0 ? _aboveGradeSqFt : 0;
        var _basementSqFt;
        message.basementSqFt = (_basementSqFt = object.basementSqFt) !== null && _basementSqFt !== void 0 ? _basementSqFt : 0;
        return message;
    }
};
function createBaseListingDetails() {
    return {
        daysOnMarket: 0,
        listPrice: 0,
        originalListPrice: 0,
        closePrice: 0,
        closeDate: undefined,
        closeDate2: undefined,
        pendingDate: undefined,
        pendingDate2: undefined,
        listDate: undefined,
        listDate2: undefined,
        listingStatus: "",
        sellerConcession: 0,
        statusChangeDate: undefined,
        statusChangeDate2: undefined
    };
}
var ListingDetails = {
    fromJSON: function fromJSON(object) {
        return {
            daysOnMarket: comp_isSet(object.daysOnMarket) ? Number(object.daysOnMarket) : 0,
            listPrice: comp_isSet(object.listPrice) ? Number(object.listPrice) : 0,
            originalListPrice: comp_isSet(object.originalListPrice) ? Number(object.originalListPrice) : 0,
            closePrice: comp_isSet(object.closePrice) ? Number(object.closePrice) : 0,
            closeDate: comp_isSet(object.closeDate) ? comp_fromJsonTimestamp(object.closeDate) : undefined,
            closeDate2: comp_isSet(object.closeDate2) ? DateMessage.fromJSON(object.closeDate2) : undefined,
            pendingDate: comp_isSet(object.pendingDate) ? comp_fromJsonTimestamp(object.pendingDate) : undefined,
            pendingDate2: comp_isSet(object.pendingDate2) ? DateMessage.fromJSON(object.pendingDate2) : undefined,
            listDate: comp_isSet(object.listDate) ? comp_fromJsonTimestamp(object.listDate) : undefined,
            listDate2: comp_isSet(object.listDate2) ? DateMessage.fromJSON(object.listDate2) : undefined,
            listingStatus: comp_isSet(object.listingStatus) ? String(object.listingStatus) : "",
            sellerConcession: comp_isSet(object.sellerConcession) ? Number(object.sellerConcession) : 0,
            statusChangeDate: comp_isSet(object.statusChangeDate) ? comp_fromJsonTimestamp(object.statusChangeDate) : undefined,
            statusChangeDate2: comp_isSet(object.statusChangeDate2) ? DateMessage.fromJSON(object.statusChangeDate2) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.daysOnMarket !== 0) {
            obj.daysOnMarket = Math.round(message.daysOnMarket);
        }
        if (message.listPrice !== 0) {
            obj.listPrice = Math.round(message.listPrice);
        }
        if (message.originalListPrice !== 0) {
            obj.originalListPrice = Math.round(message.originalListPrice);
        }
        if (message.closePrice !== 0) {
            obj.closePrice = Math.round(message.closePrice);
        }
        if (message.closeDate !== undefined) {
            obj.closeDate = message.closeDate.toISOString();
        }
        if (message.closeDate2 !== undefined) {
            obj.closeDate2 = DateMessage.toJSON(message.closeDate2);
        }
        if (message.pendingDate !== undefined) {
            obj.pendingDate = message.pendingDate.toISOString();
        }
        if (message.pendingDate2 !== undefined) {
            obj.pendingDate2 = DateMessage.toJSON(message.pendingDate2);
        }
        if (message.listDate !== undefined) {
            obj.listDate = message.listDate.toISOString();
        }
        if (message.listDate2 !== undefined) {
            obj.listDate2 = DateMessage.toJSON(message.listDate2);
        }
        if (message.listingStatus !== "") {
            obj.listingStatus = message.listingStatus;
        }
        if (message.sellerConcession !== 0) {
            obj.sellerConcession = Math.round(message.sellerConcession);
        }
        if (message.statusChangeDate !== undefined) {
            obj.statusChangeDate = message.statusChangeDate.toISOString();
        }
        if (message.statusChangeDate2 !== undefined) {
            obj.statusChangeDate2 = DateMessage.toJSON(message.statusChangeDate2);
        }
        return obj;
    },
    create: function create(base) {
        return ListingDetails.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseListingDetails();
        var _daysOnMarket;
        message.daysOnMarket = (_daysOnMarket = object.daysOnMarket) !== null && _daysOnMarket !== void 0 ? _daysOnMarket : 0;
        var _listPrice;
        message.listPrice = (_listPrice = object.listPrice) !== null && _listPrice !== void 0 ? _listPrice : 0;
        var _originalListPrice;
        message.originalListPrice = (_originalListPrice = object.originalListPrice) !== null && _originalListPrice !== void 0 ? _originalListPrice : 0;
        var _closePrice;
        message.closePrice = (_closePrice = object.closePrice) !== null && _closePrice !== void 0 ? _closePrice : 0;
        var _closeDate;
        message.closeDate = (_closeDate = object.closeDate) !== null && _closeDate !== void 0 ? _closeDate : undefined;
        message.closeDate2 = object.closeDate2 !== undefined && object.closeDate2 !== null ? DateMessage.fromPartial(object.closeDate2) : undefined;
        var _pendingDate;
        message.pendingDate = (_pendingDate = object.pendingDate) !== null && _pendingDate !== void 0 ? _pendingDate : undefined;
        message.pendingDate2 = object.pendingDate2 !== undefined && object.pendingDate2 !== null ? DateMessage.fromPartial(object.pendingDate2) : undefined;
        var _listDate;
        message.listDate = (_listDate = object.listDate) !== null && _listDate !== void 0 ? _listDate : undefined;
        message.listDate2 = object.listDate2 !== undefined && object.listDate2 !== null ? DateMessage.fromPartial(object.listDate2) : undefined;
        var _listingStatus;
        message.listingStatus = (_listingStatus = object.listingStatus) !== null && _listingStatus !== void 0 ? _listingStatus : "";
        var _sellerConcession;
        message.sellerConcession = (_sellerConcession = object.sellerConcession) !== null && _sellerConcession !== void 0 ? _sellerConcession : 0;
        var _statusChangeDate;
        message.statusChangeDate = (_statusChangeDate = object.statusChangeDate) !== null && _statusChangeDate !== void 0 ? _statusChangeDate : undefined;
        message.statusChangeDate2 = object.statusChangeDate2 !== undefined && object.statusChangeDate2 !== null ? DateMessage.fromPartial(object.statusChangeDate2) : undefined;
        return message;
    }
};
function comp_fromTimestamp(t) {
    var millis = (t.seconds || 0) * 1000;
    millis += (t.nanos || 0) / 1000000;
    return new Date(millis);
}
function comp_fromJsonTimestamp(o) {
    if ((0,_instanceof/* default */.Z)(o, Date)) {
        return o;
    } else if (typeof o === "string") {
        return new Date(o);
    } else {
        return comp_fromTimestamp(Timestamp.fromJSON(o));
    }
}
function comp_isSet(value) {
    return value !== null && value !== undefined;
}

;// CONCATENATED MODULE: ./src/__generated__/protobuf/web/data/contract_change.ts
/* eslint-disable */ 
var contract_change_protobufPackage = "od_protos.web.data";
var SubsidyType;
(function(SubsidyType) {
    SubsidyType[SubsidyType["CX_SUBSIDY"] = 0] = "CX_SUBSIDY";
    SubsidyType[SubsidyType["HOME_BUILDER"] = 1] = "HOME_BUILDER";
    SubsidyType[SubsidyType["NEW_PARTNERSHIP"] = 2] = "NEW_PARTNERSHIP";
    SubsidyType[SubsidyType["AGENT"] = 3] = "AGENT";
    SubsidyType[SubsidyType["EMPLOYEE_SUBSIDY"] = 4] = "EMPLOYEE_SUBSIDY";
    SubsidyType[SubsidyType[/** @deprecated */ "OPENDOOR_EXCLUSIVES_SIGNAGE_INCENTIVE"] = 5] = "OPENDOOR_EXCLUSIVES_SIGNAGE_INCENTIVE";
    SubsidyType[SubsidyType["VAL_CREDIT_SUBSIDY"] = 6] = "VAL_CREDIT_SUBSIDY";
    SubsidyType[SubsidyType["REPAIR_ADJUSTMENT"] = 7] = "REPAIR_ADJUSTMENT";
    SubsidyType[SubsidyType["COMPETITOR_MATCH"] = 8] = "COMPETITOR_MATCH";
    SubsidyType[SubsidyType[/** @deprecated */ "OPENDOOR_EXCLUSIVES_HIGHER_OFFER_GUARANTEE_INCENTIVE"] = 9] = "OPENDOOR_EXCLUSIVES_HIGHER_OFFER_GUARANTEE_INCENTIVE";
    SubsidyType[SubsidyType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(SubsidyType || (SubsidyType = {}));
function subsidyTypeFromJSON(object) {
    switch(object){
        case 0:
        case "CX_SUBSIDY":
            return SubsidyType.CX_SUBSIDY;
        case 1:
        case "HOME_BUILDER":
            return SubsidyType.HOME_BUILDER;
        case 2:
        case "NEW_PARTNERSHIP":
            return SubsidyType.NEW_PARTNERSHIP;
        case 3:
        case "AGENT":
            return SubsidyType.AGENT;
        case 4:
        case "EMPLOYEE_SUBSIDY":
            return SubsidyType.EMPLOYEE_SUBSIDY;
        case 5:
        case "OPENDOOR_EXCLUSIVES_SIGNAGE_INCENTIVE":
            return SubsidyType.OPENDOOR_EXCLUSIVES_SIGNAGE_INCENTIVE;
        case 6:
        case "VAL_CREDIT_SUBSIDY":
            return SubsidyType.VAL_CREDIT_SUBSIDY;
        case 7:
        case "REPAIR_ADJUSTMENT":
            return SubsidyType.REPAIR_ADJUSTMENT;
        case 8:
        case "COMPETITOR_MATCH":
            return SubsidyType.COMPETITOR_MATCH;
        case 9:
        case "OPENDOOR_EXCLUSIVES_HIGHER_OFFER_GUARANTEE_INCENTIVE":
            return SubsidyType.OPENDOOR_EXCLUSIVES_HIGHER_OFFER_GUARANTEE_INCENTIVE;
        case -1:
        case "UNRECOGNIZED":
        default:
            return SubsidyType.UNRECOGNIZED;
    }
}
function subsidyTypeToJSON(object) {
    switch(object){
        case SubsidyType.CX_SUBSIDY:
            return "CX_SUBSIDY";
        case SubsidyType.HOME_BUILDER:
            return "HOME_BUILDER";
        case SubsidyType.NEW_PARTNERSHIP:
            return "NEW_PARTNERSHIP";
        case SubsidyType.AGENT:
            return "AGENT";
        case SubsidyType.EMPLOYEE_SUBSIDY:
            return "EMPLOYEE_SUBSIDY";
        case SubsidyType.OPENDOOR_EXCLUSIVES_SIGNAGE_INCENTIVE:
            return "OPENDOOR_EXCLUSIVES_SIGNAGE_INCENTIVE";
        case SubsidyType.VAL_CREDIT_SUBSIDY:
            return "VAL_CREDIT_SUBSIDY";
        case SubsidyType.REPAIR_ADJUSTMENT:
            return "REPAIR_ADJUSTMENT";
        case SubsidyType.COMPETITOR_MATCH:
            return "COMPETITOR_MATCH";
        case SubsidyType.OPENDOOR_EXCLUSIVES_HIGHER_OFFER_GUARANTEE_INCENTIVE:
            return "OPENDOOR_EXCLUSIVES_HIGHER_OFFER_GUARANTEE_INCENTIVE";
        case SubsidyType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var PrimaryCancellationReason;
(function(PrimaryCancellationReason) {
    PrimaryCancellationReason[PrimaryCancellationReason["OPENDOOR_WALK"] = 0] = "OPENDOOR_WALK";
    PrimaryCancellationReason[PrimaryCancellationReason["SELLER_INITIATED"] = 1] = "SELLER_INITIATED";
    PrimaryCancellationReason[PrimaryCancellationReason["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(PrimaryCancellationReason || (PrimaryCancellationReason = {}));
function primaryCancellationReasonFromJSON(object) {
    switch(object){
        case 0:
        case "OPENDOOR_WALK":
            return PrimaryCancellationReason.OPENDOOR_WALK;
        case 1:
        case "SELLER_INITIATED":
            return PrimaryCancellationReason.SELLER_INITIATED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return PrimaryCancellationReason.UNRECOGNIZED;
    }
}
function primaryCancellationReasonToJSON(object) {
    switch(object){
        case PrimaryCancellationReason.OPENDOOR_WALK:
            return "OPENDOOR_WALK";
        case PrimaryCancellationReason.SELLER_INITIATED:
            return "SELLER_INITIATED";
        case PrimaryCancellationReason.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var OpendoorWalkSecondaryCancellationReason;
(function(OpendoorWalkSecondaryCancellationReason) {
    OpendoorWalkSecondaryCancellationReason[OpendoorWalkSecondaryCancellationReason["SEE_UNDERWRITING"] = 0] = "SEE_UNDERWRITING";
    OpendoorWalkSecondaryCancellationReason[OpendoorWalkSecondaryCancellationReason["ADJACENT_TO_STABILIZATION"] = 1] = "ADJACENT_TO_STABILIZATION";
    OpendoorWalkSecondaryCancellationReason[OpendoorWalkSecondaryCancellationReason["OPENDOOR_ADDENDUM"] = 2] = "OPENDOOR_ADDENDUM";
    OpendoorWalkSecondaryCancellationReason[OpendoorWalkSecondaryCancellationReason["PRICING_UNCERTAINTY"] = 3] = "PRICING_UNCERTAINTY";
    OpendoorWalkSecondaryCancellationReason[OpendoorWalkSecondaryCancellationReason["REPAIR_ASSESSMENT_INCOMPLETE"] = 4] = "REPAIR_ASSESSMENT_INCOMPLETE";
    OpendoorWalkSecondaryCancellationReason[OpendoorWalkSecondaryCancellationReason["REPAIR_SCOPE_OF_WORK_TOO_LARGE"] = 5] = "REPAIR_SCOPE_OF_WORK_TOO_LARGE";
    OpendoorWalkSecondaryCancellationReason[OpendoorWalkSecondaryCancellationReason["FAILED_ELIGIBILITY_RECHECK"] = 6] = "FAILED_ELIGIBILITY_RECHECK";
    OpendoorWalkSecondaryCancellationReason[OpendoorWalkSecondaryCancellationReason["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(OpendoorWalkSecondaryCancellationReason || (OpendoorWalkSecondaryCancellationReason = {}));
function opendoorWalkSecondaryCancellationReasonFromJSON(object) {
    switch(object){
        case 0:
        case "SEE_UNDERWRITING":
            return OpendoorWalkSecondaryCancellationReason.SEE_UNDERWRITING;
        case 1:
        case "ADJACENT_TO_STABILIZATION":
            return OpendoorWalkSecondaryCancellationReason.ADJACENT_TO_STABILIZATION;
        case 2:
        case "OPENDOOR_ADDENDUM":
            return OpendoorWalkSecondaryCancellationReason.OPENDOOR_ADDENDUM;
        case 3:
        case "PRICING_UNCERTAINTY":
            return OpendoorWalkSecondaryCancellationReason.PRICING_UNCERTAINTY;
        case 4:
        case "REPAIR_ASSESSMENT_INCOMPLETE":
            return OpendoorWalkSecondaryCancellationReason.REPAIR_ASSESSMENT_INCOMPLETE;
        case 5:
        case "REPAIR_SCOPE_OF_WORK_TOO_LARGE":
            return OpendoorWalkSecondaryCancellationReason.REPAIR_SCOPE_OF_WORK_TOO_LARGE;
        case 6:
        case "FAILED_ELIGIBILITY_RECHECK":
            return OpendoorWalkSecondaryCancellationReason.FAILED_ELIGIBILITY_RECHECK;
        case -1:
        case "UNRECOGNIZED":
        default:
            return OpendoorWalkSecondaryCancellationReason.UNRECOGNIZED;
    }
}
function opendoorWalkSecondaryCancellationReasonToJSON(object) {
    switch(object){
        case OpendoorWalkSecondaryCancellationReason.SEE_UNDERWRITING:
            return "SEE_UNDERWRITING";
        case OpendoorWalkSecondaryCancellationReason.ADJACENT_TO_STABILIZATION:
            return "ADJACENT_TO_STABILIZATION";
        case OpendoorWalkSecondaryCancellationReason.OPENDOOR_ADDENDUM:
            return "OPENDOOR_ADDENDUM";
        case OpendoorWalkSecondaryCancellationReason.PRICING_UNCERTAINTY:
            return "PRICING_UNCERTAINTY";
        case OpendoorWalkSecondaryCancellationReason.REPAIR_ASSESSMENT_INCOMPLETE:
            return "REPAIR_ASSESSMENT_INCOMPLETE";
        case OpendoorWalkSecondaryCancellationReason.REPAIR_SCOPE_OF_WORK_TOO_LARGE:
            return "REPAIR_SCOPE_OF_WORK_TOO_LARGE";
        case OpendoorWalkSecondaryCancellationReason.FAILED_ELIGIBILITY_RECHECK:
            return "FAILED_ELIGIBILITY_RECHECK";
        case OpendoorWalkSecondaryCancellationReason.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var SellerInitiatedSecondaryCancellationReason;
(function(SellerInitiatedSecondaryCancellationReason) {
    SellerInitiatedSecondaryCancellationReason[SellerInitiatedSecondaryCancellationReason["CANNOT_FIND_NEW_HOME"] = 0] = "CANNOT_FIND_NEW_HOME";
    SellerInitiatedSecondaryCancellationReason[SellerInitiatedSecondaryCancellationReason["NOT_SELLING"] = 1] = "NOT_SELLING";
    SellerInitiatedSecondaryCancellationReason[SellerInitiatedSecondaryCancellationReason["NET_CASH"] = 4] = "NET_CASH";
    SellerInitiatedSecondaryCancellationReason[SellerInitiatedSecondaryCancellationReason["OTHER_REASON"] = 6] = "OTHER_REASON";
    SellerInitiatedSecondaryCancellationReason[SellerInitiatedSecondaryCancellationReason["POST_INSPECTION_OPENDOOR_ASK"] = 7] = "POST_INSPECTION_OPENDOOR_ASK";
    SellerInitiatedSecondaryCancellationReason[SellerInitiatedSecondaryCancellationReason["COMPETITION_OR_INVESTOR_OFFER"] = 8] = "COMPETITION_OR_INVESTOR_OFFER";
    SellerInitiatedSecondaryCancellationReason[SellerInitiatedSecondaryCancellationReason["HOME_IS_LISTED"] = 9] = "HOME_IS_LISTED";
    SellerInitiatedSecondaryCancellationReason[SellerInitiatedSecondaryCancellationReason["LEGAL_ISSUES"] = 10] = "LEGAL_ISSUES";
    SellerInitiatedSecondaryCancellationReason[SellerInitiatedSecondaryCancellationReason["CLOSE_OF_ESCROW_EXTENSION_DENIED"] = 11] = "CLOSE_OF_ESCROW_EXTENSION_DENIED";
    SellerInitiatedSecondaryCancellationReason[SellerInitiatedSecondaryCancellationReason["HOA_SOLAR_CITY_INSPECTION"] = 12] = "HOA_SOLAR_CITY_INSPECTION";
    SellerInitiatedSecondaryCancellationReason[SellerInitiatedSecondaryCancellationReason["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(SellerInitiatedSecondaryCancellationReason || (SellerInitiatedSecondaryCancellationReason = {}));
function sellerInitiatedSecondaryCancellationReasonFromJSON(object) {
    switch(object){
        case 0:
        case "CANNOT_FIND_NEW_HOME":
            return SellerInitiatedSecondaryCancellationReason.CANNOT_FIND_NEW_HOME;
        case 1:
        case "NOT_SELLING":
            return SellerInitiatedSecondaryCancellationReason.NOT_SELLING;
        case 4:
        case "NET_CASH":
            return SellerInitiatedSecondaryCancellationReason.NET_CASH;
        case 6:
        case "OTHER_REASON":
            return SellerInitiatedSecondaryCancellationReason.OTHER_REASON;
        case 7:
        case "POST_INSPECTION_OPENDOOR_ASK":
            return SellerInitiatedSecondaryCancellationReason.POST_INSPECTION_OPENDOOR_ASK;
        case 8:
        case "COMPETITION_OR_INVESTOR_OFFER":
            return SellerInitiatedSecondaryCancellationReason.COMPETITION_OR_INVESTOR_OFFER;
        case 9:
        case "HOME_IS_LISTED":
            return SellerInitiatedSecondaryCancellationReason.HOME_IS_LISTED;
        case 10:
        case "LEGAL_ISSUES":
            return SellerInitiatedSecondaryCancellationReason.LEGAL_ISSUES;
        case 11:
        case "CLOSE_OF_ESCROW_EXTENSION_DENIED":
            return SellerInitiatedSecondaryCancellationReason.CLOSE_OF_ESCROW_EXTENSION_DENIED;
        case 12:
        case "HOA_SOLAR_CITY_INSPECTION":
            return SellerInitiatedSecondaryCancellationReason.HOA_SOLAR_CITY_INSPECTION;
        case -1:
        case "UNRECOGNIZED":
        default:
            return SellerInitiatedSecondaryCancellationReason.UNRECOGNIZED;
    }
}
function sellerInitiatedSecondaryCancellationReasonToJSON(object) {
    switch(object){
        case SellerInitiatedSecondaryCancellationReason.CANNOT_FIND_NEW_HOME:
            return "CANNOT_FIND_NEW_HOME";
        case SellerInitiatedSecondaryCancellationReason.NOT_SELLING:
            return "NOT_SELLING";
        case SellerInitiatedSecondaryCancellationReason.NET_CASH:
            return "NET_CASH";
        case SellerInitiatedSecondaryCancellationReason.OTHER_REASON:
            return "OTHER_REASON";
        case SellerInitiatedSecondaryCancellationReason.POST_INSPECTION_OPENDOOR_ASK:
            return "POST_INSPECTION_OPENDOOR_ASK";
        case SellerInitiatedSecondaryCancellationReason.COMPETITION_OR_INVESTOR_OFFER:
            return "COMPETITION_OR_INVESTOR_OFFER";
        case SellerInitiatedSecondaryCancellationReason.HOME_IS_LISTED:
            return "HOME_IS_LISTED";
        case SellerInitiatedSecondaryCancellationReason.LEGAL_ISSUES:
            return "LEGAL_ISSUES";
        case SellerInitiatedSecondaryCancellationReason.CLOSE_OF_ESCROW_EXTENSION_DENIED:
            return "CLOSE_OF_ESCROW_EXTENSION_DENIED";
        case SellerInitiatedSecondaryCancellationReason.HOA_SOLAR_CITY_INSPECTION:
            return "HOA_SOLAR_CITY_INSPECTION";
        case SellerInitiatedSecondaryCancellationReason.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var COEChangeReason;
(function(COEChangeReason) {
    COEChangeReason[COEChangeReason["SELLER_CHANGE_IN_PLANS"] = 0] = "SELLER_CHANGE_IN_PLANS";
    COEChangeReason[COEChangeReason["SELLER_HANDLING_REPAIRS"] = 1] = "SELLER_HANDLING_REPAIRS";
    COEChangeReason[COEChangeReason["SELLER_INFORMATION_SHEET"] = 2] = "SELLER_INFORMATION_SHEET";
    COEChangeReason[COEChangeReason["SELLER_MOVING_ISSUE"] = 3] = "SELLER_MOVING_ISSUE";
    COEChangeReason[COEChangeReason["SELLER_NEXT_HOME"] = 4] = "SELLER_NEXT_HOME";
    COEChangeReason[COEChangeReason["SELLER_UNREALISTIC_COE"] = 5] = "SELLER_UNREALISTIC_COE";
    COEChangeReason[COEChangeReason["SELLER_UNRESPONSIVE"] = 6] = "SELLER_UNRESPONSIVE";
    COEChangeReason[COEChangeReason["SELLER_OTHER"] = 7] = "SELLER_OTHER";
    COEChangeReason[COEChangeReason["HOA"] = 8] = "HOA";
    COEChangeReason[COEChangeReason["OD_FWT_MISS"] = 9] = "OD_FWT_MISS";
    COEChangeReason[COEChangeReason["OD_INSP_AVAILABILITY"] = 10] = "OD_INSP_AVAILABILITY";
    COEChangeReason[COEChangeReason["OD_NEGOTIATING_REPAIRS"] = 11] = "OD_NEGOTIATING_REPAIRS";
    COEChangeReason[COEChangeReason["OD_REPAIRS_NOT_READY"] = 12] = "OD_REPAIRS_NOT_READY";
    COEChangeReason[COEChangeReason["OD_OTHER"] = 13] = "OD_OTHER";
    COEChangeReason[COEChangeReason["TITLE_SURVEY"] = 14] = "TITLE_SURVEY";
    COEChangeReason[COEChangeReason["TITLE_HOA"] = 15] = "TITLE_HOA";
    COEChangeReason[COEChangeReason["TITLE_COMMITMENT"] = 16] = "TITLE_COMMITMENT";
    COEChangeReason[COEChangeReason["TITLE_FUNDING"] = 17] = "TITLE_FUNDING";
    COEChangeReason[COEChangeReason["TITLE_CLOSING_APPT"] = 18] = "TITLE_CLOSING_APPT";
    COEChangeReason[COEChangeReason["TITLE_MORTGAGE_PAYOFF"] = 19] = "TITLE_MORTGAGE_PAYOFF";
    COEChangeReason[COEChangeReason["TITLE_OTHER"] = 20] = "TITLE_OTHER";
    COEChangeReason[COEChangeReason["TITLE_UNRESPONSIVE"] = 21] = "TITLE_UNRESPONSIVE";
    COEChangeReason[COEChangeReason["SOLAR_TRANSFER"] = 22] = "SOLAR_TRANSFER";
    COEChangeReason[COEChangeReason["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(COEChangeReason || (COEChangeReason = {}));
function cOEChangeReasonFromJSON(object) {
    switch(object){
        case 0:
        case "SELLER_CHANGE_IN_PLANS":
            return COEChangeReason.SELLER_CHANGE_IN_PLANS;
        case 1:
        case "SELLER_HANDLING_REPAIRS":
            return COEChangeReason.SELLER_HANDLING_REPAIRS;
        case 2:
        case "SELLER_INFORMATION_SHEET":
            return COEChangeReason.SELLER_INFORMATION_SHEET;
        case 3:
        case "SELLER_MOVING_ISSUE":
            return COEChangeReason.SELLER_MOVING_ISSUE;
        case 4:
        case "SELLER_NEXT_HOME":
            return COEChangeReason.SELLER_NEXT_HOME;
        case 5:
        case "SELLER_UNREALISTIC_COE":
            return COEChangeReason.SELLER_UNREALISTIC_COE;
        case 6:
        case "SELLER_UNRESPONSIVE":
            return COEChangeReason.SELLER_UNRESPONSIVE;
        case 7:
        case "SELLER_OTHER":
            return COEChangeReason.SELLER_OTHER;
        case 8:
        case "HOA":
            return COEChangeReason.HOA;
        case 9:
        case "OD_FWT_MISS":
            return COEChangeReason.OD_FWT_MISS;
        case 10:
        case "OD_INSP_AVAILABILITY":
            return COEChangeReason.OD_INSP_AVAILABILITY;
        case 11:
        case "OD_NEGOTIATING_REPAIRS":
            return COEChangeReason.OD_NEGOTIATING_REPAIRS;
        case 12:
        case "OD_REPAIRS_NOT_READY":
            return COEChangeReason.OD_REPAIRS_NOT_READY;
        case 13:
        case "OD_OTHER":
            return COEChangeReason.OD_OTHER;
        case 14:
        case "TITLE_SURVEY":
            return COEChangeReason.TITLE_SURVEY;
        case 15:
        case "TITLE_HOA":
            return COEChangeReason.TITLE_HOA;
        case 16:
        case "TITLE_COMMITMENT":
            return COEChangeReason.TITLE_COMMITMENT;
        case 17:
        case "TITLE_FUNDING":
            return COEChangeReason.TITLE_FUNDING;
        case 18:
        case "TITLE_CLOSING_APPT":
            return COEChangeReason.TITLE_CLOSING_APPT;
        case 19:
        case "TITLE_MORTGAGE_PAYOFF":
            return COEChangeReason.TITLE_MORTGAGE_PAYOFF;
        case 20:
        case "TITLE_OTHER":
            return COEChangeReason.TITLE_OTHER;
        case 21:
        case "TITLE_UNRESPONSIVE":
            return COEChangeReason.TITLE_UNRESPONSIVE;
        case 22:
        case "SOLAR_TRANSFER":
            return COEChangeReason.SOLAR_TRANSFER;
        case -1:
        case "UNRECOGNIZED":
        default:
            return COEChangeReason.UNRECOGNIZED;
    }
}
function cOEChangeReasonToJSON(object) {
    switch(object){
        case COEChangeReason.SELLER_CHANGE_IN_PLANS:
            return "SELLER_CHANGE_IN_PLANS";
        case COEChangeReason.SELLER_HANDLING_REPAIRS:
            return "SELLER_HANDLING_REPAIRS";
        case COEChangeReason.SELLER_INFORMATION_SHEET:
            return "SELLER_INFORMATION_SHEET";
        case COEChangeReason.SELLER_MOVING_ISSUE:
            return "SELLER_MOVING_ISSUE";
        case COEChangeReason.SELLER_NEXT_HOME:
            return "SELLER_NEXT_HOME";
        case COEChangeReason.SELLER_UNREALISTIC_COE:
            return "SELLER_UNREALISTIC_COE";
        case COEChangeReason.SELLER_UNRESPONSIVE:
            return "SELLER_UNRESPONSIVE";
        case COEChangeReason.SELLER_OTHER:
            return "SELLER_OTHER";
        case COEChangeReason.HOA:
            return "HOA";
        case COEChangeReason.OD_FWT_MISS:
            return "OD_FWT_MISS";
        case COEChangeReason.OD_INSP_AVAILABILITY:
            return "OD_INSP_AVAILABILITY";
        case COEChangeReason.OD_NEGOTIATING_REPAIRS:
            return "OD_NEGOTIATING_REPAIRS";
        case COEChangeReason.OD_REPAIRS_NOT_READY:
            return "OD_REPAIRS_NOT_READY";
        case COEChangeReason.OD_OTHER:
            return "OD_OTHER";
        case COEChangeReason.TITLE_SURVEY:
            return "TITLE_SURVEY";
        case COEChangeReason.TITLE_HOA:
            return "TITLE_HOA";
        case COEChangeReason.TITLE_COMMITMENT:
            return "TITLE_COMMITMENT";
        case COEChangeReason.TITLE_FUNDING:
            return "TITLE_FUNDING";
        case COEChangeReason.TITLE_CLOSING_APPT:
            return "TITLE_CLOSING_APPT";
        case COEChangeReason.TITLE_MORTGAGE_PAYOFF:
            return "TITLE_MORTGAGE_PAYOFF";
        case COEChangeReason.TITLE_OTHER:
            return "TITLE_OTHER";
        case COEChangeReason.TITLE_UNRESPONSIVE:
            return "TITLE_UNRESPONSIVE";
        case COEChangeReason.SOLAR_TRANSFER:
            return "SOLAR_TRANSFER";
        case COEChangeReason.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
function createBaseSubsidyRequest() {
    return {
        amountCents: 0,
        type: 0
    };
}
var SubsidyRequest = {
    fromJSON: function fromJSON(object) {
        return {
            amountCents: contract_change_isSet(object.amountCents) ? Number(object.amountCents) : 0,
            type: contract_change_isSet(object.type) ? subsidyTypeFromJSON(object.type) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.amountCents !== 0) {
            obj.amountCents = Math.round(message.amountCents);
        }
        if (message.type !== 0) {
            obj.type = subsidyTypeToJSON(message.type);
        }
        return obj;
    },
    create: function create(base) {
        return SubsidyRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseSubsidyRequest();
        var _amountCents;
        message.amountCents = (_amountCents = object.amountCents) !== null && _amountCents !== void 0 ? _amountCents : 0;
        var _type;
        message.type = (_type = object.type) !== null && _type !== void 0 ? _type : 0;
        return message;
    }
};
function createBaseSubsidy() {
    return {
        amountCents: 0,
        type: 0,
        active: false
    };
}
var Subsidy = {
    fromJSON: function fromJSON(object) {
        return {
            amountCents: contract_change_isSet(object.amountCents) ? Number(object.amountCents) : 0,
            type: contract_change_isSet(object.type) ? subsidyTypeFromJSON(object.type) : 0,
            active: contract_change_isSet(object.active) ? Boolean(object.active) : false
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.amountCents !== 0) {
            obj.amountCents = Math.round(message.amountCents);
        }
        if (message.type !== 0) {
            obj.type = subsidyTypeToJSON(message.type);
        }
        if (message.active === true) {
            obj.active = message.active;
        }
        return obj;
    },
    create: function create(base) {
        return Subsidy.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseSubsidy();
        var _amountCents;
        message.amountCents = (_amountCents = object.amountCents) !== null && _amountCents !== void 0 ? _amountCents : 0;
        var _type;
        message.type = (_type = object.type) !== null && _type !== void 0 ? _type : 0;
        var _active;
        message.active = (_active = object.active) !== null && _active !== void 0 ? _active : false;
        return message;
    }
};
function createBaseRepairAdjustment() {
    return {
        description: "",
        assetIds: []
    };
}
var RepairAdjustment = {
    fromJSON: function fromJSON(object) {
        return {
            description: contract_change_isSet(object.description) ? String(object.description) : "",
            assetIds: Array.isArray(object === null || object === void 0 ? void 0 : object.assetIds) ? object.assetIds.map(function(e) {
                return String(e);
            }) : []
        };
    },
    toJSON: function toJSON(message) {
        var ref;
        var obj = {};
        if (message.description !== "") {
            obj.description = message.description;
        }
        if ((ref = message.assetIds) === null || ref === void 0 ? void 0 : ref.length) {
            obj.assetIds = message.assetIds;
        }
        return obj;
    },
    create: function create(base) {
        return RepairAdjustment.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref;
        var message = createBaseRepairAdjustment();
        var _description;
        message.description = (_description = object.description) !== null && _description !== void 0 ? _description : "";
        message.assetIds = ((ref = object.assetIds) === null || ref === void 0 ? void 0 : ref.map(function(e) {
            return e;
        })) || [];
        return message;
    }
};
function createBaseCOEChangeRequest() {
    return {
        newCoeDate: undefined,
        changeReason: 0
    };
}
var COEChangeRequest = {
    fromJSON: function fromJSON(object) {
        return {
            newCoeDate: contract_change_isSet(object.newCoeDate) ? DateMessage.fromJSON(object.newCoeDate) : undefined,
            changeReason: contract_change_isSet(object.changeReason) ? cOEChangeReasonFromJSON(object.changeReason) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.newCoeDate !== undefined) {
            obj.newCoeDate = DateMessage.toJSON(message.newCoeDate);
        }
        if (message.changeReason !== 0) {
            obj.changeReason = cOEChangeReasonToJSON(message.changeReason);
        }
        return obj;
    },
    create: function create(base) {
        return COEChangeRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseCOEChangeRequest();
        message.newCoeDate = object.newCoeDate !== undefined && object.newCoeDate !== null ? DateMessage.fromPartial(object.newCoeDate) : undefined;
        var _changeReason;
        message.changeReason = (_changeReason = object.changeReason) !== null && _changeReason !== void 0 ? _changeReason : 0;
        return message;
    }
};
function createBaseCancellationRequest() {
    return {
        primaryReason: 0,
        secondaryReason: undefined
    };
}
var CancellationRequest = {
    fromJSON: function fromJSON(object) {
        return {
            primaryReason: contract_change_isSet(object.primaryReason) ? primaryCancellationReasonFromJSON(object.primaryReason) : 0,
            secondaryReason: contract_change_isSet(object.opendoorWalkReason) ? {
                $case: "opendoorWalkReason",
                opendoorWalkReason: opendoorWalkSecondaryCancellationReasonFromJSON(object.opendoorWalkReason)
            } : contract_change_isSet(object.sellerInitiatedReason) ? {
                $case: "sellerInitiatedReason",
                sellerInitiatedReason: sellerInitiatedSecondaryCancellationReasonFromJSON(object.sellerInitiatedReason)
            } : undefined
        };
    },
    toJSON: function toJSON(message) {
        var ref, ref1;
        var obj = {};
        if (message.primaryReason !== 0) {
            obj.primaryReason = primaryCancellationReasonToJSON(message.primaryReason);
        }
        if (((ref = message.secondaryReason) === null || ref === void 0 ? void 0 : ref.$case) === "opendoorWalkReason") {
            obj.opendoorWalkReason = opendoorWalkSecondaryCancellationReasonToJSON(message.secondaryReason.opendoorWalkReason);
        }
        if (((ref1 = message.secondaryReason) === null || ref1 === void 0 ? void 0 : ref1.$case) === "sellerInitiatedReason") {
            obj.sellerInitiatedReason = sellerInitiatedSecondaryCancellationReasonToJSON(message.secondaryReason.sellerInitiatedReason);
        }
        return obj;
    },
    create: function create(base) {
        return CancellationRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref, ref1, ref2, ref3, ref4, ref5;
        var message = createBaseCancellationRequest();
        var _primaryReason;
        message.primaryReason = (_primaryReason = object.primaryReason) !== null && _primaryReason !== void 0 ? _primaryReason : 0;
        if (((ref = object.secondaryReason) === null || ref === void 0 ? void 0 : ref.$case) === "opendoorWalkReason" && ((ref1 = object.secondaryReason) === null || ref1 === void 0 ? void 0 : ref1.opendoorWalkReason) !== undefined && ((ref2 = object.secondaryReason) === null || ref2 === void 0 ? void 0 : ref2.opendoorWalkReason) !== null) {
            message.secondaryReason = {
                $case: "opendoorWalkReason",
                opendoorWalkReason: object.secondaryReason.opendoorWalkReason
            };
        }
        if (((ref3 = object.secondaryReason) === null || ref3 === void 0 ? void 0 : ref3.$case) === "sellerInitiatedReason" && ((ref4 = object.secondaryReason) === null || ref4 === void 0 ? void 0 : ref4.sellerInitiatedReason) !== undefined && ((ref5 = object.secondaryReason) === null || ref5 === void 0 ? void 0 : ref5.sellerInitiatedReason) !== null) {
            message.secondaryReason = {
                $case: "sellerInitiatedReason",
                sellerInitiatedReason: object.secondaryReason.sellerInitiatedReason
            };
        }
        return message;
    }
};
function createBaseContractChangeRequestOutcomeTaskData() {
    return {
        ticketUrl: ""
    };
}
var ContractChangeRequestOutcomeTaskData = {
    fromJSON: function fromJSON(object) {
        return {
            ticketUrl: contract_change_isSet(object.ticketUrl) ? String(object.ticketUrl) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.ticketUrl !== "") {
            obj.ticketUrl = message.ticketUrl;
        }
        return obj;
    },
    create: function create(base) {
        return ContractChangeRequestOutcomeTaskData.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseContractChangeRequestOutcomeTaskData();
        var _ticketUrl;
        message.ticketUrl = (_ticketUrl = object.ticketUrl) !== null && _ticketUrl !== void 0 ? _ticketUrl : "";
        return message;
    }
};
function contract_change_isSet(value) {
    return value !== null && value !== undefined;
}

;// CONCATENATED MODULE: ./src/__generated__/protobuf/web/data/late_checkout.ts
/* eslint-disable */ 
var late_checkout_protobufPackage = "od_protos.web.data";
function createBaseLateCheckout() {
    return {
        id: "",
        offerId: "",
        lateCheckoutDate: undefined,
        numberOfDays: 0,
        totalCostCents: 0,
        costPerDayCents: 0,
        securityAmountRetainedCents: 0,
        numberOfFreeDays: 0,
        securityDepositCents: 0,
        overstayDate: undefined
    };
}
var LateCheckout = {
    fromJSON: function fromJSON(object) {
        return {
            id: late_checkout_isSet(object.id) ? String(object.id) : "",
            offerId: late_checkout_isSet(object.offerId) ? String(object.offerId) : "",
            lateCheckoutDate: late_checkout_isSet(object.lateCheckoutDate) ? DateMessage.fromJSON(object.lateCheckoutDate) : undefined,
            numberOfDays: late_checkout_isSet(object.numberOfDays) ? Number(object.numberOfDays) : 0,
            totalCostCents: late_checkout_isSet(object.totalCostCents) ? Number(object.totalCostCents) : 0,
            costPerDayCents: late_checkout_isSet(object.costPerDayCents) ? Number(object.costPerDayCents) : 0,
            securityAmountRetainedCents: late_checkout_isSet(object.securityAmountRetainedCents) ? Number(object.securityAmountRetainedCents) : 0,
            numberOfFreeDays: late_checkout_isSet(object.numberOfFreeDays) ? Number(object.numberOfFreeDays) : 0,
            securityDepositCents: late_checkout_isSet(object.securityDepositCents) ? Number(object.securityDepositCents) : 0,
            overstayDate: late_checkout_isSet(object.overstayDate) ? DateMessage.fromJSON(object.overstayDate) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.offerId !== "") {
            obj.offerId = message.offerId;
        }
        if (message.lateCheckoutDate !== undefined) {
            obj.lateCheckoutDate = DateMessage.toJSON(message.lateCheckoutDate);
        }
        if (message.numberOfDays !== 0) {
            obj.numberOfDays = Math.round(message.numberOfDays);
        }
        if (message.totalCostCents !== 0) {
            obj.totalCostCents = Math.round(message.totalCostCents);
        }
        if (message.costPerDayCents !== 0) {
            obj.costPerDayCents = Math.round(message.costPerDayCents);
        }
        if (message.securityAmountRetainedCents !== 0) {
            obj.securityAmountRetainedCents = Math.round(message.securityAmountRetainedCents);
        }
        if (message.numberOfFreeDays !== 0) {
            obj.numberOfFreeDays = Math.round(message.numberOfFreeDays);
        }
        if (message.securityDepositCents !== 0) {
            obj.securityDepositCents = Math.round(message.securityDepositCents);
        }
        if (message.overstayDate !== undefined) {
            obj.overstayDate = DateMessage.toJSON(message.overstayDate);
        }
        return obj;
    },
    create: function create(base) {
        return LateCheckout.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseLateCheckout();
        var _id;
        message.id = (_id = object.id) !== null && _id !== void 0 ? _id : "";
        var _offerId;
        message.offerId = (_offerId = object.offerId) !== null && _offerId !== void 0 ? _offerId : "";
        message.lateCheckoutDate = object.lateCheckoutDate !== undefined && object.lateCheckoutDate !== null ? DateMessage.fromPartial(object.lateCheckoutDate) : undefined;
        var _numberOfDays;
        message.numberOfDays = (_numberOfDays = object.numberOfDays) !== null && _numberOfDays !== void 0 ? _numberOfDays : 0;
        var _totalCostCents;
        message.totalCostCents = (_totalCostCents = object.totalCostCents) !== null && _totalCostCents !== void 0 ? _totalCostCents : 0;
        var _costPerDayCents;
        message.costPerDayCents = (_costPerDayCents = object.costPerDayCents) !== null && _costPerDayCents !== void 0 ? _costPerDayCents : 0;
        var _securityAmountRetainedCents;
        message.securityAmountRetainedCents = (_securityAmountRetainedCents = object.securityAmountRetainedCents) !== null && _securityAmountRetainedCents !== void 0 ? _securityAmountRetainedCents : 0;
        var _numberOfFreeDays;
        message.numberOfFreeDays = (_numberOfFreeDays = object.numberOfFreeDays) !== null && _numberOfFreeDays !== void 0 ? _numberOfFreeDays : 0;
        var _securityDepositCents;
        message.securityDepositCents = (_securityDepositCents = object.securityDepositCents) !== null && _securityDepositCents !== void 0 ? _securityDepositCents : 0;
        message.overstayDate = object.overstayDate !== undefined && object.overstayDate !== null ? DateMessage.fromPartial(object.overstayDate) : undefined;
        return message;
    }
};
function createBaseLateCheckoutCosts() {
    return {
        fixedCostCents: 0,
        dailyCostCents: 0,
        totalCostCents: 0
    };
}
var LateCheckoutCosts = {
    fromJSON: function fromJSON(object) {
        return {
            fixedCostCents: late_checkout_isSet(object.fixedCostCents) ? Number(object.fixedCostCents) : 0,
            dailyCostCents: late_checkout_isSet(object.dailyCostCents) ? Number(object.dailyCostCents) : 0,
            totalCostCents: late_checkout_isSet(object.totalCostCents) ? Number(object.totalCostCents) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.fixedCostCents !== 0) {
            obj.fixedCostCents = Math.round(message.fixedCostCents);
        }
        if (message.dailyCostCents !== 0) {
            obj.dailyCostCents = Math.round(message.dailyCostCents);
        }
        if (message.totalCostCents !== 0) {
            obj.totalCostCents = Math.round(message.totalCostCents);
        }
        return obj;
    },
    create: function create(base) {
        return LateCheckoutCosts.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseLateCheckoutCosts();
        var _fixedCostCents;
        message.fixedCostCents = (_fixedCostCents = object.fixedCostCents) !== null && _fixedCostCents !== void 0 ? _fixedCostCents : 0;
        var _dailyCostCents;
        message.dailyCostCents = (_dailyCostCents = object.dailyCostCents) !== null && _dailyCostCents !== void 0 ? _dailyCostCents : 0;
        var _totalCostCents;
        message.totalCostCents = (_totalCostCents = object.totalCostCents) !== null && _totalCostCents !== void 0 ? _totalCostCents : 0;
        return message;
    }
};
function late_checkout_isSet(value) {
    return value !== null && value !== undefined;
}

;// CONCATENATED MODULE: ./src/__generated__/protobuf/common/state/states.ts
/* eslint-disable */ var states_protobufPackage = "od_protos.common.state";
var State;
(function(State) {
    State[State["UNKNOWN"] = 0] = "UNKNOWN";
    State[State[/** AA - Armed Forces Americas */ "AA"] = 63] = "AA";
    State[State[/** AE - Armed Forces Europe */ "AE"] = 65] = "AE";
    State[State[/** AL - Alabama State */ "AL"] = 1] = "AL";
    State[State[/** AK - Alaska State */ "AK"] = 2] = "AK";
    State[State[/** AP - Armed Forces Pacific */ "AP"] = 64] = "AP";
    State[State[/** AS - American Samoa */ "AS"] = 58] = "AS";
    State[State[/** AZ - Arizona State */ "AZ"] = 4] = "AZ";
    State[State[/** AR - Arkansas State */ "AR"] = 5] = "AR";
    State[State[/** CA - California State */ "CA"] = 6] = "CA";
    State[State[/** CO - Colorado State */ "CO"] = 8] = "CO";
    State[State[/** CT - Connecticut State */ "CT"] = 9] = "CT";
    State[State[/** DE - Delaware State */ "DE"] = 10] = "DE";
    State[State[/** DC - District of Columbia Federal district */ "DC"] = 11] = "DC";
    State[State[/** FL - Florida State */ "FL"] = 12] = "FL";
    State[State[/** GA - Georgia State */ "GA"] = 13] = "GA";
    State[State[/** GU - Guam */ "GU"] = 59] = "GU";
    State[State[/** HI - Hawaii State */ "HI"] = 15] = "HI";
    State[State[/** ID - Idaho State */ "ID"] = 16] = "ID";
    State[State[/** IL - Illinois State */ "IL"] = 17] = "IL";
    State[State[/** IN - Indiana State */ "IN"] = 18] = "IN";
    State[State[/** IA - Iowa State */ "IA"] = 19] = "IA";
    State[State[/** KS - Kansas State */ "KS"] = 20] = "KS";
    State[State[/** KY - Kentucky State (Commonwealth) */ "KY"] = 21] = "KY";
    State[State[/** LA - Louisiana State */ "LA"] = 22] = "LA";
    State[State[/** ME - Maine State */ "ME"] = 23] = "ME";
    State[State[/** MD - Maryland State */ "MD"] = 24] = "MD";
    State[State[/** MA - Massachusetts State (Commonwealth) */ "MA"] = 25] = "MA";
    State[State[/** MI - Michigan State */ "MI"] = 26] = "MI";
    State[State[/** MN - Minnesota State */ "MN"] = 27] = "MN";
    State[State[/** MS - Mississippi State */ "MS"] = 28] = "MS";
    State[State[/** MO - Missouri State */ "MO"] = 29] = "MO";
    State[State[/** MT - Montana State */ "MT"] = 30] = "MT";
    State[State[/** NE - Nebraska State */ "NE"] = 31] = "NE";
    State[State[/** NV - Nevada State */ "NV"] = 32] = "NV";
    State[State[/** NH - New Hampshire State */ "NH"] = 33] = "NH";
    State[State[/** NJ - New Jersey State */ "NJ"] = 34] = "NJ";
    State[State[/** NM - New Mexico State */ "NM"] = 35] = "NM";
    State[State[/** NY - New York State */ "NY"] = 36] = "NY";
    State[State[/** NC - North Carolina */ "NC"] = 37] = "NC";
    State[State[/** ND - North Dakota State */ "ND"] = 38] = "ND";
    State[State[/** MP - Northern Mariana Islands (Commonwealth) */ "MP"] = 60] = "MP";
    State[State[/** OH - Ohio State */ "OH"] = 39] = "OH";
    State[State[/** OK - Oklahoma State */ "OK"] = 40] = "OK";
    State[State[/** OR - Oregon State */ "OR"] = 41] = "OR";
    State[State[/** PA - Pennsylvania State (Commonwealth) */ "PA"] = 42] = "PA";
    State[State[/** PR - Puerto Rico (Commonwealth) */ "PR"] = 61] = "PR";
    State[State[/** RI - Rhode Island State */ "RI"] = 44] = "RI";
    State[State[/** SC - South Carolina State */ "SC"] = 45] = "SC";
    State[State[/** SD - South Dakota State */ "SD"] = 46] = "SD";
    State[State[/** TN - Tennessee State */ "TN"] = 47] = "TN";
    State[State[/** TX - Texas State */ "TX"] = 48] = "TX";
    State[State[/** UT - Utah State */ "UT"] = 49] = "UT";
    State[State[/** VT - Vermont State */ "VT"] = 50] = "VT";
    State[State[/** VI - Virgin Islands */ "VI"] = 62] = "VI";
    State[State[/** VA - Virginia State (Commonwealth) */ "VA"] = 51] = "VA";
    State[State[/** WA - Washington State */ "WA"] = 57] = "WA";
    State[State[/** WV - West Virginia State */ "WV"] = 54] = "WV";
    State[State[/** WI - Wisconsin	State */ "WI"] = 55] = "WI";
    State[State[/** WY - Wyoming	State */ "WY"] = 56] = "WY";
    State[State["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(State || (State = {}));
function stateFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN":
            return State.UNKNOWN;
        case 63:
        case "AA":
            return State.AA;
        case 65:
        case "AE":
            return State.AE;
        case 1:
        case "AL":
            return State.AL;
        case 2:
        case "AK":
            return State.AK;
        case 64:
        case "AP":
            return State.AP;
        case 58:
        case "AS":
            return State.AS;
        case 4:
        case "AZ":
            return State.AZ;
        case 5:
        case "AR":
            return State.AR;
        case 6:
        case "CA":
            return State.CA;
        case 8:
        case "CO":
            return State.CO;
        case 9:
        case "CT":
            return State.CT;
        case 10:
        case "DE":
            return State.DE;
        case 11:
        case "DC":
            return State.DC;
        case 12:
        case "FL":
            return State.FL;
        case 13:
        case "GA":
            return State.GA;
        case 59:
        case "GU":
            return State.GU;
        case 15:
        case "HI":
            return State.HI;
        case 16:
        case "ID":
            return State.ID;
        case 17:
        case "IL":
            return State.IL;
        case 18:
        case "IN":
            return State.IN;
        case 19:
        case "IA":
            return State.IA;
        case 20:
        case "KS":
            return State.KS;
        case 21:
        case "KY":
            return State.KY;
        case 22:
        case "LA":
            return State.LA;
        case 23:
        case "ME":
            return State.ME;
        case 24:
        case "MD":
            return State.MD;
        case 25:
        case "MA":
            return State.MA;
        case 26:
        case "MI":
            return State.MI;
        case 27:
        case "MN":
            return State.MN;
        case 28:
        case "MS":
            return State.MS;
        case 29:
        case "MO":
            return State.MO;
        case 30:
        case "MT":
            return State.MT;
        case 31:
        case "NE":
            return State.NE;
        case 32:
        case "NV":
            return State.NV;
        case 33:
        case "NH":
            return State.NH;
        case 34:
        case "NJ":
            return State.NJ;
        case 35:
        case "NM":
            return State.NM;
        case 36:
        case "NY":
            return State.NY;
        case 37:
        case "NC":
            return State.NC;
        case 38:
        case "ND":
            return State.ND;
        case 60:
        case "MP":
            return State.MP;
        case 39:
        case "OH":
            return State.OH;
        case 40:
        case "OK":
            return State.OK;
        case 41:
        case "OR":
            return State.OR;
        case 42:
        case "PA":
            return State.PA;
        case 61:
        case "PR":
            return State.PR;
        case 44:
        case "RI":
            return State.RI;
        case 45:
        case "SC":
            return State.SC;
        case 46:
        case "SD":
            return State.SD;
        case 47:
        case "TN":
            return State.TN;
        case 48:
        case "TX":
            return State.TX;
        case 49:
        case "UT":
            return State.UT;
        case 50:
        case "VT":
            return State.VT;
        case 62:
        case "VI":
            return State.VI;
        case 51:
        case "VA":
            return State.VA;
        case 57:
        case "WA":
            return State.WA;
        case 54:
        case "WV":
            return State.WV;
        case 55:
        case "WI":
            return State.WI;
        case 56:
        case "WY":
            return State.WY;
        case -1:
        case "UNRECOGNIZED":
        default:
            return State.UNRECOGNIZED;
    }
}
function stateToJSON(object) {
    switch(object){
        case State.UNKNOWN:
            return "UNKNOWN";
        case State.AA:
            return "AA";
        case State.AE:
            return "AE";
        case State.AL:
            return "AL";
        case State.AK:
            return "AK";
        case State.AP:
            return "AP";
        case State.AS:
            return "AS";
        case State.AZ:
            return "AZ";
        case State.AR:
            return "AR";
        case State.CA:
            return "CA";
        case State.CO:
            return "CO";
        case State.CT:
            return "CT";
        case State.DE:
            return "DE";
        case State.DC:
            return "DC";
        case State.FL:
            return "FL";
        case State.GA:
            return "GA";
        case State.GU:
            return "GU";
        case State.HI:
            return "HI";
        case State.ID:
            return "ID";
        case State.IL:
            return "IL";
        case State.IN:
            return "IN";
        case State.IA:
            return "IA";
        case State.KS:
            return "KS";
        case State.KY:
            return "KY";
        case State.LA:
            return "LA";
        case State.ME:
            return "ME";
        case State.MD:
            return "MD";
        case State.MA:
            return "MA";
        case State.MI:
            return "MI";
        case State.MN:
            return "MN";
        case State.MS:
            return "MS";
        case State.MO:
            return "MO";
        case State.MT:
            return "MT";
        case State.NE:
            return "NE";
        case State.NV:
            return "NV";
        case State.NH:
            return "NH";
        case State.NJ:
            return "NJ";
        case State.NM:
            return "NM";
        case State.NY:
            return "NY";
        case State.NC:
            return "NC";
        case State.ND:
            return "ND";
        case State.MP:
            return "MP";
        case State.OH:
            return "OH";
        case State.OK:
            return "OK";
        case State.OR:
            return "OR";
        case State.PA:
            return "PA";
        case State.PR:
            return "PR";
        case State.RI:
            return "RI";
        case State.SC:
            return "SC";
        case State.SD:
            return "SD";
        case State.TN:
            return "TN";
        case State.TX:
            return "TX";
        case State.UT:
            return "UT";
        case State.VT:
            return "VT";
        case State.VI:
            return "VI";
        case State.VA:
            return "VA";
        case State.WA:
            return "WA";
        case State.WV:
            return "WV";
        case State.WI:
            return "WI";
        case State.WY:
            return "WY";
        case State.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}

;// CONCATENATED MODULE: ./src/__generated__/protobuf/web/data/events/customer_event.ts
/* eslint-disable */ 

var customer_event_protobufPackage = "od_protos.web.data.events";
var EventType;
(function(EventType) {
    EventType[EventType["UNKNOWN"] = 0] = "UNKNOWN";
    EventType[EventType["AGENT_REFERRAL_CREATED"] = 1] = "AGENT_REFERRAL_CREATED";
    EventType[EventType["AGENT_REFERRAL_OFFER_SMS_SENT"] = 2] = "AGENT_REFERRAL_OFFER_SMS_SENT";
    EventType[EventType["AGENT_REFERRAL_UPDATED"] = 3] = "AGENT_REFERRAL_UPDATED";
    EventType[EventType["ANALYTICS"] = 4] = "ANALYTICS";
    EventType[EventType["ASSOCIATION"] = 5] = "ASSOCIATION";
    EventType[EventType["ASSOCIATION_CHANGED"] = 6] = "ASSOCIATION_CHANGED";
    EventType[EventType["ATTRIBUTE_CHANGED"] = 7] = "ATTRIBUTE_CHANGED";
    EventType[EventType["BLACKLIST_UNLOCK_ATTEMPT"] = 8] = "BLACKLIST_UNLOCK_ATTEMPT";
    EventType[EventType["BUYER_ATTENTION_WORTHY_SIGNAL"] = 9] = "BUYER_ATTENTION_WORTHY_SIGNAL";
    EventType[EventType["BUYER_LEAD_FROM_SELLER"] = 10] = "BUYER_LEAD_FROM_SELLER";
    EventType[EventType["BUYER_SIGNUP"] = 11] = "BUYER_SIGNUP";
    EventType[EventType["CENTRALIZED_SHOWING_SERVICE_FEEDBACK"] = 12] = "CENTRALIZED_SHOWING_SERVICE_FEEDBACK";
    EventType[EventType["CODE_MISSING_UNLOCK_ATTEMPT"] = 13] = "CODE_MISSING_UNLOCK_ATTEMPT";
    EventType[EventType["CODELESS_UNLOCK_FAILED_ATTEMPT"] = 14] = "CODELESS_UNLOCK_FAILED_ATTEMPT";
    EventType[EventType["CONVERSATION_REASSIGNED"] = 15] = "CONVERSATION_REASSIGNED";
    EventType[EventType["COVID_SAFETY_WINDOW_UNLOCK_ATTEMPT"] = 16] = "COVID_SAFETY_WINDOW_UNLOCK_ATTEMPT";
    EventType[EventType["CUSTOMER_DATA"] = 17] = "CUSTOMER_DATA";
    EventType[EventType["DELIGHTED_SMS_SURVEY_REQUEST"] = 18] = "DELIGHTED_SMS_SURVEY_REQUEST";
    EventType[EventType["DELIGHTED_SURVEY_REQUEST"] = 19] = "DELIGHTED_SURVEY_REQUEST";
    EventType[EventType["DELIGHTED_SURVEY_RESPONSE"] = 20] = "DELIGHTED_SURVEY_RESPONSE";
    EventType[EventType["DEVICE_INSTALL"] = 21] = "DEVICE_INSTALL";
    EventType[EventType["EMAIL"] = 22] = "EMAIL";
    EventType[EventType["EXTERNAL_INTEREST"] = 23] = "EXTERNAL_INTEREST";
    EventType[EventType["GRAYLIST_UNLOCK_ATTEMPT"] = 24] = "GRAYLIST_UNLOCK_ATTEMPT";
    EventType[EventType["HOME_FEEDBACK_LEFT"] = 25] = "HOME_FEEDBACK_LEFT";
    EventType[EventType["HOME_ISSUE_REPORTED"] = 26] = "HOME_ISSUE_REPORTED";
    EventType[EventType["HOMEBUILDER_OR_OUTCOME"] = 27] = "HOMEBUILDER_OR_OUTCOME";
    EventType[EventType["ID_VERIFICATION"] = 28] = "ID_VERIFICATION";
    EventType[EventType["INITIAL_UNLOCK_ATTEMPT"] = 29] = "INITIAL_UNLOCK_ATTEMPT";
    EventType[EventType["INSUFFICIENT_VERSION_UNLOCK_ATTEMPT"] = 30] = "INSUFFICIENT_VERSION_UNLOCK_ATTEMPT";
    EventType[EventType["LISTING_INTEREST"] = 31] = "LISTING_INTEREST";
    EventType[EventType["LISTING_NOT_FOUND_UNLOCK_ATTEMPT"] = 32] = "LISTING_NOT_FOUND_UNLOCK_ATTEMPT";
    EventType[EventType["LISTING_OFFER_NOTIFICATION"] = 33] = "LISTING_OFFER_NOTIFICATION";
    EventType[EventType["LISTING_OFFER_SUBMITTED"] = 34] = "LISTING_OFFER_SUBMITTED";
    EventType[EventType["LISTING_RESERVATION"] = 35] = "LISTING_RESERVATION";
    EventType[EventType[/** @deprecated */ "LWOD_OFFER_SENT"] = 36] = "LWOD_OFFER_SENT";
    EventType[EventType[/** @deprecated */ "LWOD_OR_OUTCOME"] = 37] = "LWOD_OR_OUTCOME";
    EventType[EventType["MERGE"] = 38] = "MERGE";
    EventType[EventType["NEEDS_ATTENTION_FOLLOWUP_TIME"] = 39] = "NEEDS_ATTENTION_FOLLOWUP_TIME";
    EventType[EventType["NEEDS_ATTENTION_RESOLVED"] = 40] = "NEEDS_ATTENTION_RESOLVED";
    EventType[EventType["NOTE"] = 41] = "NOTE";
    EventType[EventType["OFFER_ON_INTERESTED_HOME"] = 42] = "OFFER_ON_INTERESTED_HOME";
    EventType[EventType["OFFER_SENT"] = 43] = "OFFER_SENT";
    EventType[EventType["OPEN_LISTINGS_OFFER_STATE"] = 44] = "OPEN_LISTINGS_OFFER_STATE";
    EventType[EventType["OPEN_LISTINGS_TOUR_COMPLETED"] = 45] = "OPEN_LISTINGS_TOUR_COMPLETED";
    EventType[EventType["OUT_OF_OFFICE_REPLY"] = 46] = "OUT_OF_OFFICE_REPLY";
    EventType[EventType["OUTREACH_OUTCOME"] = 47] = "OUTREACH_OUTCOME";
    EventType[EventType["OUTSIDE_VISITING_HOURS_UNLOCK_ATTEMPT"] = 48] = "OUTSIDE_VISITING_HOURS_UNLOCK_ATTEMPT";
    EventType[EventType["PARTICIPANT_CHANGED"] = 49] = "PARTICIPANT_CHANGED";
    EventType[EventType["PHONE_CALL"] = 50] = "PHONE_CALL";
    EventType[EventType["POST_FRMS_UNTRUSTED_UNLOCK_NOT_SENT"] = 51] = "POST_FRMS_UNTRUSTED_UNLOCK_NOT_SENT";
    EventType[EventType["PPM_UNLOCK_ATTEMPT"] = 52] = "PPM_UNLOCK_ATTEMPT";
    EventType[EventType["PUSH_NOTIFICATION"] = 53] = "PUSH_NOTIFICATION";
    EventType[EventType["REPEAT_VISIT"] = 54] = "REPEAT_VISIT";
    EventType[EventType["SMS_OPT_OUT_NOTIFICATION"] = 55] = "SMS_OPT_OUT_NOTIFICATION";
    EventType[EventType["SCHEDULE_TOUR_REQUEST"] = 56] = "SCHEDULE_TOUR_REQUEST";
    EventType[EventType["SELF_TOUR_FEEDBACK"] = 58] = "SELF_TOUR_FEEDBACK";
    EventType[EventType["SHOWINGTIME_FEEDBACK"] = 59] = "SHOWINGTIME_FEEDBACK";
    EventType[EventType["SMS"] = 60] = "SMS";
    EventType[EventType["SOLD_UNLOCK_ATTEMPT"] = 61] = "SOLD_UNLOCK_ATTEMPT";
    EventType[EventType["SYSTEM"] = 62] = "SYSTEM";
    EventType[EventType["TOM_UNLOCK_ATTEMPT"] = 63] = "TOM_UNLOCK_ATTEMPT";
    EventType[EventType["TRIAGE_SMS_RESPONSE_PHOTO_UPLOAD"] = 64] = "TRIAGE_SMS_RESPONSE_PHOTO_UPLOAD";
    EventType[EventType["TRUST"] = 65] = "TRUST";
    EventType[EventType["UNDER_COVID_LOCKDOWN"] = 66] = "UNDER_COVID_LOCKDOWN";
    EventType[EventType["UNKNOWN_ERROR"] = 67] = "UNKNOWN_ERROR";
    EventType[EventType["UNLOCK"] = 68] = "UNLOCK";
    EventType[EventType["VISIT_EXPERIENCE_FEEDBACK_APPRECIATION"] = 69] = "VISIT_EXPERIENCE_FEEDBACK_APPRECIATION";
    EventType[EventType["VISIT_EXPERIENCE_FEEDBACK_REQUEST"] = 70] = "VISIT_EXPERIENCE_FEEDBACK_REQUEST";
    EventType[EventType["VISIT_EXPERIENCE_FEEDBACK_RESPONSE"] = 71] = "VISIT_EXPERIENCE_FEEDBACK_RESPONSE";
    EventType[EventType["VISIT_EXPERIENCE_SCORE_REQUEST"] = 72] = "VISIT_EXPERIENCE_SCORE_REQUEST";
    EventType[EventType["VISIT_EXPERIENCE_SCORE_RESPONSE"] = 73] = "VISIT_EXPERIENCE_SCORE_RESPONSE";
    EventType[EventType["VOICEMAIL"] = 74] = "VOICEMAIL";
    EventType[EventType["WEB_CHAT"] = 75] = "WEB_CHAT";
    EventType[EventType["COMBINED_DECISION_CALL_OUTCOME"] = 76] = "COMBINED_DECISION_CALL_OUTCOME";
    EventType[EventType[/** @deprecated */ "REQUEST_FOR_LWOD_AGENT"] = 77] = "REQUEST_FOR_LWOD_AGENT";
    EventType[EventType["OR_VA_OUTCOME"] = 78] = "OR_VA_OUTCOME";
    EventType[EventType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(EventType || (EventType = {}));
function eventTypeFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN":
            return EventType.UNKNOWN;
        case 1:
        case "AGENT_REFERRAL_CREATED":
            return EventType.AGENT_REFERRAL_CREATED;
        case 2:
        case "AGENT_REFERRAL_OFFER_SMS_SENT":
            return EventType.AGENT_REFERRAL_OFFER_SMS_SENT;
        case 3:
        case "AGENT_REFERRAL_UPDATED":
            return EventType.AGENT_REFERRAL_UPDATED;
        case 4:
        case "ANALYTICS":
            return EventType.ANALYTICS;
        case 5:
        case "ASSOCIATION":
            return EventType.ASSOCIATION;
        case 6:
        case "ASSOCIATION_CHANGED":
            return EventType.ASSOCIATION_CHANGED;
        case 7:
        case "ATTRIBUTE_CHANGED":
            return EventType.ATTRIBUTE_CHANGED;
        case 8:
        case "BLACKLIST_UNLOCK_ATTEMPT":
            return EventType.BLACKLIST_UNLOCK_ATTEMPT;
        case 9:
        case "BUYER_ATTENTION_WORTHY_SIGNAL":
            return EventType.BUYER_ATTENTION_WORTHY_SIGNAL;
        case 10:
        case "BUYER_LEAD_FROM_SELLER":
            return EventType.BUYER_LEAD_FROM_SELLER;
        case 11:
        case "BUYER_SIGNUP":
            return EventType.BUYER_SIGNUP;
        case 12:
        case "CENTRALIZED_SHOWING_SERVICE_FEEDBACK":
            return EventType.CENTRALIZED_SHOWING_SERVICE_FEEDBACK;
        case 13:
        case "CODE_MISSING_UNLOCK_ATTEMPT":
            return EventType.CODE_MISSING_UNLOCK_ATTEMPT;
        case 14:
        case "CODELESS_UNLOCK_FAILED_ATTEMPT":
            return EventType.CODELESS_UNLOCK_FAILED_ATTEMPT;
        case 15:
        case "CONVERSATION_REASSIGNED":
            return EventType.CONVERSATION_REASSIGNED;
        case 16:
        case "COVID_SAFETY_WINDOW_UNLOCK_ATTEMPT":
            return EventType.COVID_SAFETY_WINDOW_UNLOCK_ATTEMPT;
        case 17:
        case "CUSTOMER_DATA":
            return EventType.CUSTOMER_DATA;
        case 18:
        case "DELIGHTED_SMS_SURVEY_REQUEST":
            return EventType.DELIGHTED_SMS_SURVEY_REQUEST;
        case 19:
        case "DELIGHTED_SURVEY_REQUEST":
            return EventType.DELIGHTED_SURVEY_REQUEST;
        case 20:
        case "DELIGHTED_SURVEY_RESPONSE":
            return EventType.DELIGHTED_SURVEY_RESPONSE;
        case 21:
        case "DEVICE_INSTALL":
            return EventType.DEVICE_INSTALL;
        case 22:
        case "EMAIL":
            return EventType.EMAIL;
        case 23:
        case "EXTERNAL_INTEREST":
            return EventType.EXTERNAL_INTEREST;
        case 24:
        case "GRAYLIST_UNLOCK_ATTEMPT":
            return EventType.GRAYLIST_UNLOCK_ATTEMPT;
        case 25:
        case "HOME_FEEDBACK_LEFT":
            return EventType.HOME_FEEDBACK_LEFT;
        case 26:
        case "HOME_ISSUE_REPORTED":
            return EventType.HOME_ISSUE_REPORTED;
        case 27:
        case "HOMEBUILDER_OR_OUTCOME":
            return EventType.HOMEBUILDER_OR_OUTCOME;
        case 28:
        case "ID_VERIFICATION":
            return EventType.ID_VERIFICATION;
        case 29:
        case "INITIAL_UNLOCK_ATTEMPT":
            return EventType.INITIAL_UNLOCK_ATTEMPT;
        case 30:
        case "INSUFFICIENT_VERSION_UNLOCK_ATTEMPT":
            return EventType.INSUFFICIENT_VERSION_UNLOCK_ATTEMPT;
        case 31:
        case "LISTING_INTEREST":
            return EventType.LISTING_INTEREST;
        case 32:
        case "LISTING_NOT_FOUND_UNLOCK_ATTEMPT":
            return EventType.LISTING_NOT_FOUND_UNLOCK_ATTEMPT;
        case 33:
        case "LISTING_OFFER_NOTIFICATION":
            return EventType.LISTING_OFFER_NOTIFICATION;
        case 34:
        case "LISTING_OFFER_SUBMITTED":
            return EventType.LISTING_OFFER_SUBMITTED;
        case 35:
        case "LISTING_RESERVATION":
            return EventType.LISTING_RESERVATION;
        case 36:
        case "LWOD_OFFER_SENT":
            return EventType.LWOD_OFFER_SENT;
        case 37:
        case "LWOD_OR_OUTCOME":
            return EventType.LWOD_OR_OUTCOME;
        case 38:
        case "MERGE":
            return EventType.MERGE;
        case 39:
        case "NEEDS_ATTENTION_FOLLOWUP_TIME":
            return EventType.NEEDS_ATTENTION_FOLLOWUP_TIME;
        case 40:
        case "NEEDS_ATTENTION_RESOLVED":
            return EventType.NEEDS_ATTENTION_RESOLVED;
        case 41:
        case "NOTE":
            return EventType.NOTE;
        case 42:
        case "OFFER_ON_INTERESTED_HOME":
            return EventType.OFFER_ON_INTERESTED_HOME;
        case 43:
        case "OFFER_SENT":
            return EventType.OFFER_SENT;
        case 44:
        case "OPEN_LISTINGS_OFFER_STATE":
            return EventType.OPEN_LISTINGS_OFFER_STATE;
        case 45:
        case "OPEN_LISTINGS_TOUR_COMPLETED":
            return EventType.OPEN_LISTINGS_TOUR_COMPLETED;
        case 46:
        case "OUT_OF_OFFICE_REPLY":
            return EventType.OUT_OF_OFFICE_REPLY;
        case 47:
        case "OUTREACH_OUTCOME":
            return EventType.OUTREACH_OUTCOME;
        case 48:
        case "OUTSIDE_VISITING_HOURS_UNLOCK_ATTEMPT":
            return EventType.OUTSIDE_VISITING_HOURS_UNLOCK_ATTEMPT;
        case 49:
        case "PARTICIPANT_CHANGED":
            return EventType.PARTICIPANT_CHANGED;
        case 50:
        case "PHONE_CALL":
            return EventType.PHONE_CALL;
        case 51:
        case "POST_FRMS_UNTRUSTED_UNLOCK_NOT_SENT":
            return EventType.POST_FRMS_UNTRUSTED_UNLOCK_NOT_SENT;
        case 52:
        case "PPM_UNLOCK_ATTEMPT":
            return EventType.PPM_UNLOCK_ATTEMPT;
        case 53:
        case "PUSH_NOTIFICATION":
            return EventType.PUSH_NOTIFICATION;
        case 54:
        case "REPEAT_VISIT":
            return EventType.REPEAT_VISIT;
        case 55:
        case "SMS_OPT_OUT_NOTIFICATION":
            return EventType.SMS_OPT_OUT_NOTIFICATION;
        case 56:
        case "SCHEDULE_TOUR_REQUEST":
            return EventType.SCHEDULE_TOUR_REQUEST;
        case 58:
        case "SELF_TOUR_FEEDBACK":
            return EventType.SELF_TOUR_FEEDBACK;
        case 59:
        case "SHOWINGTIME_FEEDBACK":
            return EventType.SHOWINGTIME_FEEDBACK;
        case 60:
        case "SMS":
            return EventType.SMS;
        case 61:
        case "SOLD_UNLOCK_ATTEMPT":
            return EventType.SOLD_UNLOCK_ATTEMPT;
        case 62:
        case "SYSTEM":
            return EventType.SYSTEM;
        case 63:
        case "TOM_UNLOCK_ATTEMPT":
            return EventType.TOM_UNLOCK_ATTEMPT;
        case 64:
        case "TRIAGE_SMS_RESPONSE_PHOTO_UPLOAD":
            return EventType.TRIAGE_SMS_RESPONSE_PHOTO_UPLOAD;
        case 65:
        case "TRUST":
            return EventType.TRUST;
        case 66:
        case "UNDER_COVID_LOCKDOWN":
            return EventType.UNDER_COVID_LOCKDOWN;
        case 67:
        case "UNKNOWN_ERROR":
            return EventType.UNKNOWN_ERROR;
        case 68:
        case "UNLOCK":
            return EventType.UNLOCK;
        case 69:
        case "VISIT_EXPERIENCE_FEEDBACK_APPRECIATION":
            return EventType.VISIT_EXPERIENCE_FEEDBACK_APPRECIATION;
        case 70:
        case "VISIT_EXPERIENCE_FEEDBACK_REQUEST":
            return EventType.VISIT_EXPERIENCE_FEEDBACK_REQUEST;
        case 71:
        case "VISIT_EXPERIENCE_FEEDBACK_RESPONSE":
            return EventType.VISIT_EXPERIENCE_FEEDBACK_RESPONSE;
        case 72:
        case "VISIT_EXPERIENCE_SCORE_REQUEST":
            return EventType.VISIT_EXPERIENCE_SCORE_REQUEST;
        case 73:
        case "VISIT_EXPERIENCE_SCORE_RESPONSE":
            return EventType.VISIT_EXPERIENCE_SCORE_RESPONSE;
        case 74:
        case "VOICEMAIL":
            return EventType.VOICEMAIL;
        case 75:
        case "WEB_CHAT":
            return EventType.WEB_CHAT;
        case 76:
        case "COMBINED_DECISION_CALL_OUTCOME":
            return EventType.COMBINED_DECISION_CALL_OUTCOME;
        case 77:
        case "REQUEST_FOR_LWOD_AGENT":
            return EventType.REQUEST_FOR_LWOD_AGENT;
        case 78:
        case "OR_VA_OUTCOME":
            return EventType.OR_VA_OUTCOME;
        case -1:
        case "UNRECOGNIZED":
        default:
            return EventType.UNRECOGNIZED;
    }
}
function eventTypeToJSON(object) {
    switch(object){
        case EventType.UNKNOWN:
            return "UNKNOWN";
        case EventType.AGENT_REFERRAL_CREATED:
            return "AGENT_REFERRAL_CREATED";
        case EventType.AGENT_REFERRAL_OFFER_SMS_SENT:
            return "AGENT_REFERRAL_OFFER_SMS_SENT";
        case EventType.AGENT_REFERRAL_UPDATED:
            return "AGENT_REFERRAL_UPDATED";
        case EventType.ANALYTICS:
            return "ANALYTICS";
        case EventType.ASSOCIATION:
            return "ASSOCIATION";
        case EventType.ASSOCIATION_CHANGED:
            return "ASSOCIATION_CHANGED";
        case EventType.ATTRIBUTE_CHANGED:
            return "ATTRIBUTE_CHANGED";
        case EventType.BLACKLIST_UNLOCK_ATTEMPT:
            return "BLACKLIST_UNLOCK_ATTEMPT";
        case EventType.BUYER_ATTENTION_WORTHY_SIGNAL:
            return "BUYER_ATTENTION_WORTHY_SIGNAL";
        case EventType.BUYER_LEAD_FROM_SELLER:
            return "BUYER_LEAD_FROM_SELLER";
        case EventType.BUYER_SIGNUP:
            return "BUYER_SIGNUP";
        case EventType.CENTRALIZED_SHOWING_SERVICE_FEEDBACK:
            return "CENTRALIZED_SHOWING_SERVICE_FEEDBACK";
        case EventType.CODE_MISSING_UNLOCK_ATTEMPT:
            return "CODE_MISSING_UNLOCK_ATTEMPT";
        case EventType.CODELESS_UNLOCK_FAILED_ATTEMPT:
            return "CODELESS_UNLOCK_FAILED_ATTEMPT";
        case EventType.CONVERSATION_REASSIGNED:
            return "CONVERSATION_REASSIGNED";
        case EventType.COVID_SAFETY_WINDOW_UNLOCK_ATTEMPT:
            return "COVID_SAFETY_WINDOW_UNLOCK_ATTEMPT";
        case EventType.CUSTOMER_DATA:
            return "CUSTOMER_DATA";
        case EventType.DELIGHTED_SMS_SURVEY_REQUEST:
            return "DELIGHTED_SMS_SURVEY_REQUEST";
        case EventType.DELIGHTED_SURVEY_REQUEST:
            return "DELIGHTED_SURVEY_REQUEST";
        case EventType.DELIGHTED_SURVEY_RESPONSE:
            return "DELIGHTED_SURVEY_RESPONSE";
        case EventType.DEVICE_INSTALL:
            return "DEVICE_INSTALL";
        case EventType.EMAIL:
            return "EMAIL";
        case EventType.EXTERNAL_INTEREST:
            return "EXTERNAL_INTEREST";
        case EventType.GRAYLIST_UNLOCK_ATTEMPT:
            return "GRAYLIST_UNLOCK_ATTEMPT";
        case EventType.HOME_FEEDBACK_LEFT:
            return "HOME_FEEDBACK_LEFT";
        case EventType.HOME_ISSUE_REPORTED:
            return "HOME_ISSUE_REPORTED";
        case EventType.HOMEBUILDER_OR_OUTCOME:
            return "HOMEBUILDER_OR_OUTCOME";
        case EventType.ID_VERIFICATION:
            return "ID_VERIFICATION";
        case EventType.INITIAL_UNLOCK_ATTEMPT:
            return "INITIAL_UNLOCK_ATTEMPT";
        case EventType.INSUFFICIENT_VERSION_UNLOCK_ATTEMPT:
            return "INSUFFICIENT_VERSION_UNLOCK_ATTEMPT";
        case EventType.LISTING_INTEREST:
            return "LISTING_INTEREST";
        case EventType.LISTING_NOT_FOUND_UNLOCK_ATTEMPT:
            return "LISTING_NOT_FOUND_UNLOCK_ATTEMPT";
        case EventType.LISTING_OFFER_NOTIFICATION:
            return "LISTING_OFFER_NOTIFICATION";
        case EventType.LISTING_OFFER_SUBMITTED:
            return "LISTING_OFFER_SUBMITTED";
        case EventType.LISTING_RESERVATION:
            return "LISTING_RESERVATION";
        case EventType.LWOD_OFFER_SENT:
            return "LWOD_OFFER_SENT";
        case EventType.LWOD_OR_OUTCOME:
            return "LWOD_OR_OUTCOME";
        case EventType.MERGE:
            return "MERGE";
        case EventType.NEEDS_ATTENTION_FOLLOWUP_TIME:
            return "NEEDS_ATTENTION_FOLLOWUP_TIME";
        case EventType.NEEDS_ATTENTION_RESOLVED:
            return "NEEDS_ATTENTION_RESOLVED";
        case EventType.NOTE:
            return "NOTE";
        case EventType.OFFER_ON_INTERESTED_HOME:
            return "OFFER_ON_INTERESTED_HOME";
        case EventType.OFFER_SENT:
            return "OFFER_SENT";
        case EventType.OPEN_LISTINGS_OFFER_STATE:
            return "OPEN_LISTINGS_OFFER_STATE";
        case EventType.OPEN_LISTINGS_TOUR_COMPLETED:
            return "OPEN_LISTINGS_TOUR_COMPLETED";
        case EventType.OUT_OF_OFFICE_REPLY:
            return "OUT_OF_OFFICE_REPLY";
        case EventType.OUTREACH_OUTCOME:
            return "OUTREACH_OUTCOME";
        case EventType.OUTSIDE_VISITING_HOURS_UNLOCK_ATTEMPT:
            return "OUTSIDE_VISITING_HOURS_UNLOCK_ATTEMPT";
        case EventType.PARTICIPANT_CHANGED:
            return "PARTICIPANT_CHANGED";
        case EventType.PHONE_CALL:
            return "PHONE_CALL";
        case EventType.POST_FRMS_UNTRUSTED_UNLOCK_NOT_SENT:
            return "POST_FRMS_UNTRUSTED_UNLOCK_NOT_SENT";
        case EventType.PPM_UNLOCK_ATTEMPT:
            return "PPM_UNLOCK_ATTEMPT";
        case EventType.PUSH_NOTIFICATION:
            return "PUSH_NOTIFICATION";
        case EventType.REPEAT_VISIT:
            return "REPEAT_VISIT";
        case EventType.SMS_OPT_OUT_NOTIFICATION:
            return "SMS_OPT_OUT_NOTIFICATION";
        case EventType.SCHEDULE_TOUR_REQUEST:
            return "SCHEDULE_TOUR_REQUEST";
        case EventType.SELF_TOUR_FEEDBACK:
            return "SELF_TOUR_FEEDBACK";
        case EventType.SHOWINGTIME_FEEDBACK:
            return "SHOWINGTIME_FEEDBACK";
        case EventType.SMS:
            return "SMS";
        case EventType.SOLD_UNLOCK_ATTEMPT:
            return "SOLD_UNLOCK_ATTEMPT";
        case EventType.SYSTEM:
            return "SYSTEM";
        case EventType.TOM_UNLOCK_ATTEMPT:
            return "TOM_UNLOCK_ATTEMPT";
        case EventType.TRIAGE_SMS_RESPONSE_PHOTO_UPLOAD:
            return "TRIAGE_SMS_RESPONSE_PHOTO_UPLOAD";
        case EventType.TRUST:
            return "TRUST";
        case EventType.UNDER_COVID_LOCKDOWN:
            return "UNDER_COVID_LOCKDOWN";
        case EventType.UNKNOWN_ERROR:
            return "UNKNOWN_ERROR";
        case EventType.UNLOCK:
            return "UNLOCK";
        case EventType.VISIT_EXPERIENCE_FEEDBACK_APPRECIATION:
            return "VISIT_EXPERIENCE_FEEDBACK_APPRECIATION";
        case EventType.VISIT_EXPERIENCE_FEEDBACK_REQUEST:
            return "VISIT_EXPERIENCE_FEEDBACK_REQUEST";
        case EventType.VISIT_EXPERIENCE_FEEDBACK_RESPONSE:
            return "VISIT_EXPERIENCE_FEEDBACK_RESPONSE";
        case EventType.VISIT_EXPERIENCE_SCORE_REQUEST:
            return "VISIT_EXPERIENCE_SCORE_REQUEST";
        case EventType.VISIT_EXPERIENCE_SCORE_RESPONSE:
            return "VISIT_EXPERIENCE_SCORE_RESPONSE";
        case EventType.VOICEMAIL:
            return "VOICEMAIL";
        case EventType.WEB_CHAT:
            return "WEB_CHAT";
        case EventType.COMBINED_DECISION_CALL_OUTCOME:
            return "COMBINED_DECISION_CALL_OUTCOME";
        case EventType.REQUEST_FOR_LWOD_AGENT:
            return "REQUEST_FOR_LWOD_AGENT";
        case EventType.OR_VA_OUTCOME:
            return "OR_VA_OUTCOME";
        case EventType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
function createBaseCustomerEvent() {
    return {
        timestamp: undefined,
        id: 0,
        eventType: 0,
        eventableId: 0,
        eventableType: "",
        metadata: "",
        content: "",
        customerUuid: ""
    };
}
var CustomerEvent = {
    fromJSON: function fromJSON(object) {
        return {
            timestamp: customer_event_isSet(object.timestamp) ? customer_event_fromJsonTimestamp(object.timestamp) : undefined,
            id: customer_event_isSet(object.id) ? Number(object.id) : 0,
            eventType: customer_event_isSet(object.eventType) ? eventTypeFromJSON(object.eventType) : 0,
            eventableId: customer_event_isSet(object.eventableId) ? Number(object.eventableId) : 0,
            eventableType: customer_event_isSet(object.eventableType) ? String(object.eventableType) : "",
            metadata: customer_event_isSet(object.metadata) ? String(object.metadata) : "",
            content: customer_event_isSet(object.content) ? String(object.content) : "",
            customerUuid: customer_event_isSet(object.customerUuid) ? String(object.customerUuid) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.timestamp !== undefined) {
            obj.timestamp = message.timestamp.toISOString();
        }
        if (message.id !== 0) {
            obj.id = Math.round(message.id);
        }
        if (message.eventType !== 0) {
            obj.eventType = eventTypeToJSON(message.eventType);
        }
        if (message.eventableId !== 0) {
            obj.eventableId = Math.round(message.eventableId);
        }
        if (message.eventableType !== "") {
            obj.eventableType = message.eventableType;
        }
        if (message.metadata !== "") {
            obj.metadata = message.metadata;
        }
        if (message.content !== "") {
            obj.content = message.content;
        }
        if (message.customerUuid !== "") {
            obj.customerUuid = message.customerUuid;
        }
        return obj;
    },
    create: function create(base) {
        return CustomerEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseCustomerEvent();
        var _timestamp;
        message.timestamp = (_timestamp = object.timestamp) !== null && _timestamp !== void 0 ? _timestamp : undefined;
        var _id;
        message.id = (_id = object.id) !== null && _id !== void 0 ? _id : 0;
        var _eventType;
        message.eventType = (_eventType = object.eventType) !== null && _eventType !== void 0 ? _eventType : 0;
        var _eventableId;
        message.eventableId = (_eventableId = object.eventableId) !== null && _eventableId !== void 0 ? _eventableId : 0;
        var _eventableType;
        message.eventableType = (_eventableType = object.eventableType) !== null && _eventableType !== void 0 ? _eventableType : "";
        var _metadata;
        message.metadata = (_metadata = object.metadata) !== null && _metadata !== void 0 ? _metadata : "";
        var _content;
        message.content = (_content = object.content) !== null && _content !== void 0 ? _content : "";
        var _customerUuid;
        message.customerUuid = (_customerUuid = object.customerUuid) !== null && _customerUuid !== void 0 ? _customerUuid : "";
        return message;
    }
};
function createBaseCustomerEventNote() {
    return {
        id: 0,
        notes: "",
        timestamp: undefined,
        eventType: 0
    };
}
var CustomerEventNote = {
    fromJSON: function fromJSON(object) {
        return {
            id: customer_event_isSet(object.id) ? Number(object.id) : 0,
            notes: customer_event_isSet(object.notes) ? String(object.notes) : "",
            timestamp: customer_event_isSet(object.timestamp) ? customer_event_fromJsonTimestamp(object.timestamp) : undefined,
            eventType: customer_event_isSet(object.eventType) ? eventTypeFromJSON(object.eventType) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.id !== 0) {
            obj.id = Math.round(message.id);
        }
        if (message.notes !== "") {
            obj.notes = message.notes;
        }
        if (message.timestamp !== undefined) {
            obj.timestamp = message.timestamp.toISOString();
        }
        if (message.eventType !== 0) {
            obj.eventType = eventTypeToJSON(message.eventType);
        }
        return obj;
    },
    create: function create(base) {
        return CustomerEventNote.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseCustomerEventNote();
        var _id;
        message.id = (_id = object.id) !== null && _id !== void 0 ? _id : 0;
        var _notes;
        message.notes = (_notes = object.notes) !== null && _notes !== void 0 ? _notes : "";
        var _timestamp;
        message.timestamp = (_timestamp = object.timestamp) !== null && _timestamp !== void 0 ? _timestamp : undefined;
        var _eventType;
        message.eventType = (_eventType = object.eventType) !== null && _eventType !== void 0 ? _eventType : 0;
        return message;
    }
};
function customer_event_fromTimestamp(t) {
    var millis = (t.seconds || 0) * 1000;
    millis += (t.nanos || 0) / 1000000;
    return new Date(millis);
}
function customer_event_fromJsonTimestamp(o) {
    if ((0,_instanceof/* default */.Z)(o, Date)) {
        return o;
    } else if (typeof o === "string") {
        return new Date(o);
    } else {
        return customer_event_fromTimestamp(Timestamp.fromJSON(o));
    }
}
function customer_event_isSet(value) {
    return value !== null && value !== undefined;
}

;// CONCATENATED MODULE: ./src/__generated__/protobuf/web/data/sell_direct/home_condition_response.ts
/* eslint-disable */ 

var home_condition_response_protobufPackage = "od_protos.web.data.sell_direct";
function createBaseHomeConditionResponse() {
    return {
        homeConditions: [],
        flowDifficulty: "",
        humanId: "",
        submittedAt: undefined,
        skippedAt: undefined,
        hasMlsPhotos: false
    };
}
var HomeConditionResponse = {
    fromJSON: function fromJSON(object) {
        return {
            homeConditions: Array.isArray(object === null || object === void 0 ? void 0 : object.homeConditions) ? object.homeConditions.map(function(e) {
                return HomeCondition.fromJSON(e);
            }) : [],
            flowDifficulty: home_condition_response_isSet(object.flowDifficulty) ? String(object.flowDifficulty) : "",
            humanId: home_condition_response_isSet(object.humanId) ? String(object.humanId) : "",
            submittedAt: home_condition_response_isSet(object.submittedAt) ? home_condition_response_fromJsonTimestamp(object.submittedAt) : undefined,
            skippedAt: home_condition_response_isSet(object.skippedAt) ? home_condition_response_fromJsonTimestamp(object.skippedAt) : undefined,
            hasMlsPhotos: home_condition_response_isSet(object.hasMlsPhotos) ? Boolean(object.hasMlsPhotos) : false
        };
    },
    toJSON: function toJSON(message) {
        var ref;
        var obj = {};
        if ((ref = message.homeConditions) === null || ref === void 0 ? void 0 : ref.length) {
            obj.homeConditions = message.homeConditions.map(function(e) {
                return HomeCondition.toJSON(e);
            });
        }
        if (message.flowDifficulty !== "") {
            obj.flowDifficulty = message.flowDifficulty;
        }
        if (message.humanId !== "") {
            obj.humanId = message.humanId;
        }
        if (message.submittedAt !== undefined) {
            obj.submittedAt = message.submittedAt.toISOString();
        }
        if (message.skippedAt !== undefined) {
            obj.skippedAt = message.skippedAt.toISOString();
        }
        if (message.hasMlsPhotos === true) {
            obj.hasMlsPhotos = message.hasMlsPhotos;
        }
        return obj;
    },
    create: function create(base) {
        return HomeConditionResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref;
        var message = createBaseHomeConditionResponse();
        message.homeConditions = ((ref = object.homeConditions) === null || ref === void 0 ? void 0 : ref.map(function(e) {
            return HomeCondition.fromPartial(e);
        })) || [];
        var _flowDifficulty;
        message.flowDifficulty = (_flowDifficulty = object.flowDifficulty) !== null && _flowDifficulty !== void 0 ? _flowDifficulty : "";
        var _humanId;
        message.humanId = (_humanId = object.humanId) !== null && _humanId !== void 0 ? _humanId : "";
        var _submittedAt;
        message.submittedAt = (_submittedAt = object.submittedAt) !== null && _submittedAt !== void 0 ? _submittedAt : undefined;
        var _skippedAt;
        message.skippedAt = (_skippedAt = object.skippedAt) !== null && _skippedAt !== void 0 ? _skippedAt : undefined;
        var _hasMlsPhotos;
        message.hasMlsPhotos = (_hasMlsPhotos = object.hasMlsPhotos) !== null && _hasMlsPhotos !== void 0 ? _hasMlsPhotos : false;
        return message;
    }
};
function createBaseProxyImage() {
    return {
        id: "",
        title: "",
        description: "",
        imageUrl: "",
        score: 0
    };
}
var ProxyImage = {
    fromJSON: function fromJSON(object) {
        return {
            id: home_condition_response_isSet(object.id) ? String(object.id) : "",
            title: home_condition_response_isSet(object.title) ? String(object.title) : "",
            description: home_condition_response_isSet(object.description) ? String(object.description) : "",
            imageUrl: home_condition_response_isSet(object.imageUrl) ? String(object.imageUrl) : "",
            score: home_condition_response_isSet(object.score) ? Number(object.score) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.title !== "") {
            obj.title = message.title;
        }
        if (message.description !== "") {
            obj.description = message.description;
        }
        if (message.imageUrl !== "") {
            obj.imageUrl = message.imageUrl;
        }
        if (message.score !== 0) {
            obj.score = Math.round(message.score);
        }
        return obj;
    },
    create: function create(base) {
        return ProxyImage.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseProxyImage();
        var _id;
        message.id = (_id = object.id) !== null && _id !== void 0 ? _id : "";
        var _title;
        message.title = (_title = object.title) !== null && _title !== void 0 ? _title : "";
        var _description;
        message.description = (_description = object.description) !== null && _description !== void 0 ? _description : "";
        var _imageUrl;
        message.imageUrl = (_imageUrl = object.imageUrl) !== null && _imageUrl !== void 0 ? _imageUrl : "";
        var _score;
        message.score = (_score = object.score) !== null && _score !== void 0 ? _score : 0;
        return message;
    }
};
function createBaseHomeCondition() {
    return {
        title: "",
        proxyImages: [],
        exampleProxyImages: [],
        selectedProxyImageId: ""
    };
}
var HomeCondition = {
    fromJSON: function fromJSON(object) {
        return {
            title: home_condition_response_isSet(object.title) ? String(object.title) : "",
            proxyImages: Array.isArray(object === null || object === void 0 ? void 0 : object.proxyImages) ? object.proxyImages.map(function(e) {
                return ProxyImage.fromJSON(e);
            }) : [],
            exampleProxyImages: Array.isArray(object === null || object === void 0 ? void 0 : object.exampleProxyImages) ? object.exampleProxyImages.map(function(e) {
                return ProxyImage.fromJSON(e);
            }) : [],
            selectedProxyImageId: home_condition_response_isSet(object.selectedProxyImageId) ? String(object.selectedProxyImageId) : ""
        };
    },
    toJSON: function toJSON(message) {
        var ref, ref1;
        var obj = {};
        if (message.title !== "") {
            obj.title = message.title;
        }
        if ((ref = message.proxyImages) === null || ref === void 0 ? void 0 : ref.length) {
            obj.proxyImages = message.proxyImages.map(function(e) {
                return ProxyImage.toJSON(e);
            });
        }
        if ((ref1 = message.exampleProxyImages) === null || ref1 === void 0 ? void 0 : ref1.length) {
            obj.exampleProxyImages = message.exampleProxyImages.map(function(e) {
                return ProxyImage.toJSON(e);
            });
        }
        if (message.selectedProxyImageId !== "") {
            obj.selectedProxyImageId = message.selectedProxyImageId;
        }
        return obj;
    },
    create: function create(base) {
        return HomeCondition.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref, ref1;
        var message = createBaseHomeCondition();
        var _title;
        message.title = (_title = object.title) !== null && _title !== void 0 ? _title : "";
        message.proxyImages = ((ref = object.proxyImages) === null || ref === void 0 ? void 0 : ref.map(function(e) {
            return ProxyImage.fromPartial(e);
        })) || [];
        message.exampleProxyImages = ((ref1 = object.exampleProxyImages) === null || ref1 === void 0 ? void 0 : ref1.map(function(e) {
            return ProxyImage.fromPartial(e);
        })) || [];
        var _selectedProxyImageId;
        message.selectedProxyImageId = (_selectedProxyImageId = object.selectedProxyImageId) !== null && _selectedProxyImageId !== void 0 ? _selectedProxyImageId : "";
        return message;
    }
};
function createBasePriceAdjustmentResponse() {
    return {
        submittedByOffer: "",
        bpsIncrease: 0,
        resultClosed: false,
        mlsPhotos: [],
        homeConditionOptions: []
    };
}
var PriceAdjustmentResponse = {
    fromJSON: function fromJSON(object) {
        return {
            submittedByOffer: home_condition_response_isSet(object.submittedByOffer) ? String(object.submittedByOffer) : "",
            bpsIncrease: home_condition_response_isSet(object.bpsIncrease) ? Number(object.bpsIncrease) : 0,
            resultClosed: home_condition_response_isSet(object.resultClosed) ? Boolean(object.resultClosed) : false,
            mlsPhotos: Array.isArray(object === null || object === void 0 ? void 0 : object.mlsPhotos) ? object.mlsPhotos.map(function(e) {
                return MlsPhoto.fromJSON(e);
            }) : [],
            homeConditionOptions: Array.isArray(object === null || object === void 0 ? void 0 : object.homeConditionOptions) ? object.homeConditionOptions.map(function(e) {
                return HomeCondition.fromJSON(e);
            }) : []
        };
    },
    toJSON: function toJSON(message) {
        var ref, ref1;
        var obj = {};
        if (message.submittedByOffer !== "") {
            obj.submittedByOffer = message.submittedByOffer;
        }
        if (message.bpsIncrease !== 0) {
            obj.bpsIncrease = Math.round(message.bpsIncrease);
        }
        if (message.resultClosed === true) {
            obj.resultClosed = message.resultClosed;
        }
        if ((ref = message.mlsPhotos) === null || ref === void 0 ? void 0 : ref.length) {
            obj.mlsPhotos = message.mlsPhotos.map(function(e) {
                return MlsPhoto.toJSON(e);
            });
        }
        if ((ref1 = message.homeConditionOptions) === null || ref1 === void 0 ? void 0 : ref1.length) {
            obj.homeConditionOptions = message.homeConditionOptions.map(function(e) {
                return HomeCondition.toJSON(e);
            });
        }
        return obj;
    },
    create: function create(base) {
        return PriceAdjustmentResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref, ref1;
        var message = createBasePriceAdjustmentResponse();
        var _submittedByOffer;
        message.submittedByOffer = (_submittedByOffer = object.submittedByOffer) !== null && _submittedByOffer !== void 0 ? _submittedByOffer : "";
        var _bpsIncrease;
        message.bpsIncrease = (_bpsIncrease = object.bpsIncrease) !== null && _bpsIncrease !== void 0 ? _bpsIncrease : 0;
        var _resultClosed;
        message.resultClosed = (_resultClosed = object.resultClosed) !== null && _resultClosed !== void 0 ? _resultClosed : false;
        message.mlsPhotos = ((ref = object.mlsPhotos) === null || ref === void 0 ? void 0 : ref.map(function(e) {
            return MlsPhoto.fromPartial(e);
        })) || [];
        message.homeConditionOptions = ((ref1 = object.homeConditionOptions) === null || ref1 === void 0 ? void 0 : ref1.map(function(e) {
            return HomeCondition.fromPartial(e);
        })) || [];
        return message;
    }
};
function createBaseMlsPhoto() {
    return {
        title: "",
        proxyImage: [],
        imageUrl: ""
    };
}
var MlsPhoto = {
    fromJSON: function fromJSON(object) {
        return {
            title: home_condition_response_isSet(object.title) ? String(object.title) : "",
            proxyImage: Array.isArray(object === null || object === void 0 ? void 0 : object.proxyImage) ? object.proxyImage.map(function(e) {
                return ProxyImage.fromJSON(e);
            }) : [],
            imageUrl: home_condition_response_isSet(object.imageUrl) ? String(object.imageUrl) : ""
        };
    },
    toJSON: function toJSON(message) {
        var ref;
        var obj = {};
        if (message.title !== "") {
            obj.title = message.title;
        }
        if ((ref = message.proxyImage) === null || ref === void 0 ? void 0 : ref.length) {
            obj.proxyImage = message.proxyImage.map(function(e) {
                return ProxyImage.toJSON(e);
            });
        }
        if (message.imageUrl !== "") {
            obj.imageUrl = message.imageUrl;
        }
        return obj;
    },
    create: function create(base) {
        return MlsPhoto.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref;
        var message = createBaseMlsPhoto();
        var _title;
        message.title = (_title = object.title) !== null && _title !== void 0 ? _title : "";
        message.proxyImage = ((ref = object.proxyImage) === null || ref === void 0 ? void 0 : ref.map(function(e) {
            return ProxyImage.fromPartial(e);
        })) || [];
        var _imageUrl;
        message.imageUrl = (_imageUrl = object.imageUrl) !== null && _imageUrl !== void 0 ? _imageUrl : "";
        return message;
    }
};
function home_condition_response_fromTimestamp(t) {
    var millis = (t.seconds || 0) * 1000;
    millis += (t.nanos || 0) / 1000000;
    return new Date(millis);
}
function home_condition_response_fromJsonTimestamp(o) {
    if ((0,_instanceof/* default */.Z)(o, Date)) {
        return o;
    } else if (typeof o === "string") {
        return new Date(o);
    } else {
        return home_condition_response_fromTimestamp(Timestamp.fromJSON(o));
    }
}
function home_condition_response_isSet(value) {
    return value !== null && value !== undefined;
}

;// CONCATENATED MODULE: ./src/__generated__/protobuf/web/data/lead.ts
/* eslint-disable */ 






var data_lead_protobufPackage = "od_protos.web.data";
var LeadSource_Type;
(function(LeadSource_Type) {
    LeadSource_Type[LeadSource_Type["UNKNOWN_TYPE"] = 0] = "UNKNOWN_TYPE";
    LeadSource_Type[LeadSource_Type["RECEPTION"] = 1] = "RECEPTION";
    LeadSource_Type[LeadSource_Type["PARTNERSHIP"] = 2] = "PARTNERSHIP";
    LeadSource_Type[LeadSource_Type["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(LeadSource_Type || (LeadSource_Type = {}));
function leadSource_TypeFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN_TYPE":
            return LeadSource_Type.UNKNOWN_TYPE;
        case 1:
        case "RECEPTION":
            return LeadSource_Type.RECEPTION;
        case 2:
        case "PARTNERSHIP":
            return LeadSource_Type.PARTNERSHIP;
        case -1:
        case "UNRECOGNIZED":
        default:
            return LeadSource_Type.UNRECOGNIZED;
    }
}
function leadSource_TypeToJSON(object) {
    switch(object){
        case LeadSource_Type.UNKNOWN_TYPE:
            return "UNKNOWN_TYPE";
        case LeadSource_Type.RECEPTION:
            return "RECEPTION";
        case LeadSource_Type.PARTNERSHIP:
            return "PARTNERSHIP";
        case LeadSource_Type.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var Lead_SellYourWayProduct;
(function(Lead_SellYourWayProduct) {
    Lead_SellYourWayProduct[Lead_SellYourWayProduct["UNKNOWN"] = 0] = "UNKNOWN";
    Lead_SellYourWayProduct[Lead_SellYourWayProduct["LIST_WITH_CERTAINTY"] = 1] = "LIST_WITH_CERTAINTY";
    Lead_SellYourWayProduct[Lead_SellYourWayProduct["SELL_DIRECT"] = 2] = "SELL_DIRECT";
    Lead_SellYourWayProduct[Lead_SellYourWayProduct["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Lead_SellYourWayProduct || (Lead_SellYourWayProduct = {}));
function lead_SellYourWayProductFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN":
            return Lead_SellYourWayProduct.UNKNOWN;
        case 1:
        case "LIST_WITH_CERTAINTY":
            return Lead_SellYourWayProduct.LIST_WITH_CERTAINTY;
        case 2:
        case "SELL_DIRECT":
            return Lead_SellYourWayProduct.SELL_DIRECT;
        case -1:
        case "UNRECOGNIZED":
        default:
            return Lead_SellYourWayProduct.UNRECOGNIZED;
    }
}
function lead_SellYourWayProductToJSON(object) {
    switch(object){
        case Lead_SellYourWayProduct.UNKNOWN:
            return "UNKNOWN";
        case Lead_SellYourWayProduct.LIST_WITH_CERTAINTY:
            return "LIST_WITH_CERTAINTY";
        case Lead_SellYourWayProduct.SELL_DIRECT:
            return "SELL_DIRECT";
        case Lead_SellYourWayProduct.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
function createBaseLeadSource() {
    return {
        type: 0,
        id: ""
    };
}
var LeadSource = {
    fromJSON: function fromJSON(object) {
        return {
            type: data_lead_isSet(object.type) ? leadSource_TypeFromJSON(object.type) : 0,
            id: data_lead_isSet(object.id) ? String(object.id) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.type !== 0) {
            obj.type = leadSource_TypeToJSON(message.type);
        }
        if (message.id !== "") {
            obj.id = message.id;
        }
        return obj;
    },
    create: function create(base) {
        return LeadSource.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseLeadSource();
        var _type;
        message.type = (_type = object.type) !== null && _type !== void 0 ? _type : 0;
        var _id;
        message.id = (_id = object.id) !== null && _id !== void 0 ? _id : "";
        return message;
    }
};
function createBaseLeadQueryParams() {
    return {
        addressToken: "",
        customerUuid: ""
    };
}
var LeadQueryParams = {
    fromJSON: function fromJSON(object) {
        return {
            addressToken: data_lead_isSet(object.addressToken) ? String(object.addressToken) : "",
            customerUuid: data_lead_isSet(object.customerUuid) ? String(object.customerUuid) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.addressToken !== "") {
            obj.addressToken = message.addressToken;
        }
        if (message.customerUuid !== "") {
            obj.customerUuid = message.customerUuid;
        }
        return obj;
    },
    create: function create(base) {
        return LeadQueryParams.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseLeadQueryParams();
        var _addressToken;
        message.addressToken = (_addressToken = object.addressToken) !== null && _addressToken !== void 0 ? _addressToken : "";
        var _customerUuid;
        message.customerUuid = (_customerUuid = object.customerUuid) !== null && _customerUuid !== void 0 ? _customerUuid : "";
        return message;
    }
};
function lead_createBaseLead() {
    return {
        isInTwilioVideoPilot: false,
        isInZoomPilot: false,
        sellYourWayProductPrioritization: [],
        id: "",
        sellerLeadUuid: "",
        latestOfferId: "",
        latestRefreshRequestedAt: undefined,
        token: "",
        isListed: false,
        sellerInputUuid: "",
        latestVirtualAssessmentId: "",
        previousOfferId: "",
        lastOfferReviewDetails: undefined,
        experiencePartner: undefined,
        customerEventNotes: [],
        isAgentExperience: false,
        addressId: "",
        customerUuid: "",
        email: "",
        isQualified: false,
        qualifiedAt: undefined,
        createdAt: undefined,
        latestSelfServeVirtualAssessmentId: "",
        latestOfferReviewVirtualAssessmentId: "",
        denialReason: 0,
        homeConditionResponse: undefined,
        channel: 0,
        customerIds: [],
        isEligibleForVirtualEa: false,
        inExclusiveOffers: false,
        sellerSsvaUploadPage: "",
        mortgagePayoffAmountCents: undefined,
        denialNotes: "",
        hubPrimaryCtaPaintedDoorExperimentVariant: "",
        hubPrimaryCtaCustomerSuccessExperimentVariant: "",
        addressesResponseOverride: undefined,
        shouldSeeAgentLedOffersExperience: false,
        shouldSeeFinalOfferNetProceeds: false,
        shouldSeeHubNewUserExperience: false
    };
}
var lead_Lead = {
    fromJSON: function fromJSON(object) {
        return {
            isInTwilioVideoPilot: data_lead_isSet(object.isInTwilioVideoPilot) ? Boolean(object.isInTwilioVideoPilot) : false,
            isInZoomPilot: data_lead_isSet(object.isInZoomPilot) ? Boolean(object.isInZoomPilot) : false,
            sellYourWayProductPrioritization: Array.isArray(object === null || object === void 0 ? void 0 : object.sellYourWayProductPrioritization) ? object.sellYourWayProductPrioritization.map(function(e) {
                return lead_SellYourWayProductFromJSON(e);
            }) : [],
            id: data_lead_isSet(object.id) ? String(object.id) : "",
            sellerLeadUuid: data_lead_isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : "",
            latestOfferId: data_lead_isSet(object.latestOfferId) ? String(object.latestOfferId) : "",
            latestRefreshRequestedAt: data_lead_isSet(object.latestRefreshRequestedAt) ? data_lead_fromJsonTimestamp(object.latestRefreshRequestedAt) : undefined,
            token: data_lead_isSet(object.token) ? String(object.token) : "",
            isListed: data_lead_isSet(object.isListed) ? Boolean(object.isListed) : false,
            sellerInputUuid: data_lead_isSet(object.sellerInputUuid) ? String(object.sellerInputUuid) : "",
            latestVirtualAssessmentId: data_lead_isSet(object.latestVirtualAssessmentId) ? String(object.latestVirtualAssessmentId) : "",
            previousOfferId: data_lead_isSet(object.previousOfferId) ? String(object.previousOfferId) : "",
            lastOfferReviewDetails: data_lead_isSet(object.lastOfferReviewDetails) ? OfferReviewDetails.fromJSON(object.lastOfferReviewDetails) : undefined,
            experiencePartner: data_lead_isSet(object.experiencePartner) ? ExperiencePartner.fromJSON(object.experiencePartner) : undefined,
            customerEventNotes: Array.isArray(object === null || object === void 0 ? void 0 : object.customerEventNotes) ? object.customerEventNotes.map(function(e) {
                return CustomerEventNote.fromJSON(e);
            }) : [],
            isAgentExperience: data_lead_isSet(object.isAgentExperience) ? Boolean(object.isAgentExperience) : false,
            addressId: data_lead_isSet(object.addressId) ? String(object.addressId) : "",
            customerUuid: data_lead_isSet(object.customerUuid) ? String(object.customerUuid) : "",
            email: data_lead_isSet(object.email) ? String(object.email) : "",
            isQualified: data_lead_isSet(object.isQualified) ? Boolean(object.isQualified) : false,
            qualifiedAt: data_lead_isSet(object.qualifiedAt) ? data_lead_fromJsonTimestamp(object.qualifiedAt) : undefined,
            createdAt: data_lead_isSet(object.createdAt) ? data_lead_fromJsonTimestamp(object.createdAt) : undefined,
            latestSelfServeVirtualAssessmentId: data_lead_isSet(object.latestSelfServeVirtualAssessmentId) ? String(object.latestSelfServeVirtualAssessmentId) : "",
            latestOfferReviewVirtualAssessmentId: data_lead_isSet(object.latestOfferReviewVirtualAssessmentId) ? String(object.latestOfferReviewVirtualAssessmentId) : "",
            denialReason: data_lead_isSet(object.denialReason) ? denialReasonFromJSON(object.denialReason) : 0,
            homeConditionResponse: data_lead_isSet(object.homeConditionResponse) ? HomeConditionResponse.fromJSON(object.homeConditionResponse) : undefined,
            channel: data_lead_isSet(object.channel) ? sellerInput_ChannelFromJSON(object.channel) : 0,
            customerIds: Array.isArray(object === null || object === void 0 ? void 0 : object.customerIds) ? object.customerIds.map(function(e) {
                return String(e);
            }) : [],
            isEligibleForVirtualEa: data_lead_isSet(object.isEligibleForVirtualEa) ? Boolean(object.isEligibleForVirtualEa) : false,
            inExclusiveOffers: data_lead_isSet(object.inExclusiveOffers) ? Boolean(object.inExclusiveOffers) : false,
            sellerSsvaUploadPage: data_lead_isSet(object.sellerSsvaUploadPage) ? String(object.sellerSsvaUploadPage) : "",
            mortgagePayoffAmountCents: data_lead_isSet(object.mortgagePayoffAmountCents) ? Number(object.mortgagePayoffAmountCents) : undefined,
            denialNotes: data_lead_isSet(object.denialNotes) ? String(object.denialNotes) : "",
            hubPrimaryCtaPaintedDoorExperimentVariant: data_lead_isSet(object.hubPrimaryCtaPaintedDoorExperimentVariant) ? String(object.hubPrimaryCtaPaintedDoorExperimentVariant) : "",
            hubPrimaryCtaCustomerSuccessExperimentVariant: data_lead_isSet(object.hubPrimaryCtaCustomerSuccessExperimentVariant) ? String(object.hubPrimaryCtaCustomerSuccessExperimentVariant) : "",
            addressesResponseOverride: data_lead_isSet(object.addressesResponseOverride) ? AddressesResponseOverride.fromJSON(object.addressesResponseOverride) : undefined,
            shouldSeeAgentLedOffersExperience: data_lead_isSet(object.shouldSeeAgentLedOffersExperience) ? Boolean(object.shouldSeeAgentLedOffersExperience) : false,
            shouldSeeFinalOfferNetProceeds: data_lead_isSet(object.shouldSeeFinalOfferNetProceeds) ? Boolean(object.shouldSeeFinalOfferNetProceeds) : false,
            shouldSeeHubNewUserExperience: data_lead_isSet(object.shouldSeeHubNewUserExperience) ? Boolean(object.shouldSeeHubNewUserExperience) : false
        };
    },
    toJSON: function toJSON(message) {
        var ref, ref1, ref2;
        var obj = {};
        if (message.isInTwilioVideoPilot === true) {
            obj.isInTwilioVideoPilot = message.isInTwilioVideoPilot;
        }
        if (message.isInZoomPilot === true) {
            obj.isInZoomPilot = message.isInZoomPilot;
        }
        if ((ref = message.sellYourWayProductPrioritization) === null || ref === void 0 ? void 0 : ref.length) {
            obj.sellYourWayProductPrioritization = message.sellYourWayProductPrioritization.map(function(e) {
                return lead_SellYourWayProductToJSON(e);
            });
        }
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.sellerLeadUuid !== "") {
            obj.sellerLeadUuid = message.sellerLeadUuid;
        }
        if (message.latestOfferId !== "") {
            obj.latestOfferId = message.latestOfferId;
        }
        if (message.latestRefreshRequestedAt !== undefined) {
            obj.latestRefreshRequestedAt = message.latestRefreshRequestedAt.toISOString();
        }
        if (message.token !== "") {
            obj.token = message.token;
        }
        if (message.isListed === true) {
            obj.isListed = message.isListed;
        }
        if (message.sellerInputUuid !== "") {
            obj.sellerInputUuid = message.sellerInputUuid;
        }
        if (message.latestVirtualAssessmentId !== "") {
            obj.latestVirtualAssessmentId = message.latestVirtualAssessmentId;
        }
        if (message.previousOfferId !== "") {
            obj.previousOfferId = message.previousOfferId;
        }
        if (message.lastOfferReviewDetails !== undefined) {
            obj.lastOfferReviewDetails = OfferReviewDetails.toJSON(message.lastOfferReviewDetails);
        }
        if (message.experiencePartner !== undefined) {
            obj.experiencePartner = ExperiencePartner.toJSON(message.experiencePartner);
        }
        if ((ref1 = message.customerEventNotes) === null || ref1 === void 0 ? void 0 : ref1.length) {
            obj.customerEventNotes = message.customerEventNotes.map(function(e) {
                return CustomerEventNote.toJSON(e);
            });
        }
        if (message.isAgentExperience === true) {
            obj.isAgentExperience = message.isAgentExperience;
        }
        if (message.addressId !== "") {
            obj.addressId = message.addressId;
        }
        if (message.customerUuid !== "") {
            obj.customerUuid = message.customerUuid;
        }
        if (message.email !== "") {
            obj.email = message.email;
        }
        if (message.isQualified === true) {
            obj.isQualified = message.isQualified;
        }
        if (message.qualifiedAt !== undefined) {
            obj.qualifiedAt = message.qualifiedAt.toISOString();
        }
        if (message.createdAt !== undefined) {
            obj.createdAt = message.createdAt.toISOString();
        }
        if (message.latestSelfServeVirtualAssessmentId !== "") {
            obj.latestSelfServeVirtualAssessmentId = message.latestSelfServeVirtualAssessmentId;
        }
        if (message.latestOfferReviewVirtualAssessmentId !== "") {
            obj.latestOfferReviewVirtualAssessmentId = message.latestOfferReviewVirtualAssessmentId;
        }
        if (message.denialReason !== 0) {
            obj.denialReason = denialReasonToJSON(message.denialReason);
        }
        if (message.homeConditionResponse !== undefined) {
            obj.homeConditionResponse = HomeConditionResponse.toJSON(message.homeConditionResponse);
        }
        if (message.channel !== 0) {
            obj.channel = sellerInput_ChannelToJSON(message.channel);
        }
        if ((ref2 = message.customerIds) === null || ref2 === void 0 ? void 0 : ref2.length) {
            obj.customerIds = message.customerIds;
        }
        if (message.isEligibleForVirtualEa === true) {
            obj.isEligibleForVirtualEa = message.isEligibleForVirtualEa;
        }
        if (message.inExclusiveOffers === true) {
            obj.inExclusiveOffers = message.inExclusiveOffers;
        }
        if (message.sellerSsvaUploadPage !== "") {
            obj.sellerSsvaUploadPage = message.sellerSsvaUploadPage;
        }
        if (message.mortgagePayoffAmountCents !== undefined) {
            obj.mortgagePayoffAmountCents = message.mortgagePayoffAmountCents;
        }
        if (message.denialNotes !== "") {
            obj.denialNotes = message.denialNotes;
        }
        if (message.hubPrimaryCtaPaintedDoorExperimentVariant !== "") {
            obj.hubPrimaryCtaPaintedDoorExperimentVariant = message.hubPrimaryCtaPaintedDoorExperimentVariant;
        }
        if (message.hubPrimaryCtaCustomerSuccessExperimentVariant !== "") {
            obj.hubPrimaryCtaCustomerSuccessExperimentVariant = message.hubPrimaryCtaCustomerSuccessExperimentVariant;
        }
        if (message.addressesResponseOverride !== undefined) {
            obj.addressesResponseOverride = AddressesResponseOverride.toJSON(message.addressesResponseOverride);
        }
        if (message.shouldSeeAgentLedOffersExperience === true) {
            obj.shouldSeeAgentLedOffersExperience = message.shouldSeeAgentLedOffersExperience;
        }
        if (message.shouldSeeFinalOfferNetProceeds === true) {
            obj.shouldSeeFinalOfferNetProceeds = message.shouldSeeFinalOfferNetProceeds;
        }
        if (message.shouldSeeHubNewUserExperience === true) {
            obj.shouldSeeHubNewUserExperience = message.shouldSeeHubNewUserExperience;
        }
        return obj;
    },
    create: function create(base) {
        return lead_Lead.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref, ref1, ref2;
        var message = lead_createBaseLead();
        var _isInTwilioVideoPilot;
        message.isInTwilioVideoPilot = (_isInTwilioVideoPilot = object.isInTwilioVideoPilot) !== null && _isInTwilioVideoPilot !== void 0 ? _isInTwilioVideoPilot : false;
        var _isInZoomPilot;
        message.isInZoomPilot = (_isInZoomPilot = object.isInZoomPilot) !== null && _isInZoomPilot !== void 0 ? _isInZoomPilot : false;
        message.sellYourWayProductPrioritization = ((ref = object.sellYourWayProductPrioritization) === null || ref === void 0 ? void 0 : ref.map(function(e) {
            return e;
        })) || [];
        var _id;
        message.id = (_id = object.id) !== null && _id !== void 0 ? _id : "";
        var _sellerLeadUuid;
        message.sellerLeadUuid = (_sellerLeadUuid = object.sellerLeadUuid) !== null && _sellerLeadUuid !== void 0 ? _sellerLeadUuid : "";
        var _latestOfferId;
        message.latestOfferId = (_latestOfferId = object.latestOfferId) !== null && _latestOfferId !== void 0 ? _latestOfferId : "";
        var _latestRefreshRequestedAt;
        message.latestRefreshRequestedAt = (_latestRefreshRequestedAt = object.latestRefreshRequestedAt) !== null && _latestRefreshRequestedAt !== void 0 ? _latestRefreshRequestedAt : undefined;
        var _token;
        message.token = (_token = object.token) !== null && _token !== void 0 ? _token : "";
        var _isListed;
        message.isListed = (_isListed = object.isListed) !== null && _isListed !== void 0 ? _isListed : false;
        var _sellerInputUuid;
        message.sellerInputUuid = (_sellerInputUuid = object.sellerInputUuid) !== null && _sellerInputUuid !== void 0 ? _sellerInputUuid : "";
        var _latestVirtualAssessmentId;
        message.latestVirtualAssessmentId = (_latestVirtualAssessmentId = object.latestVirtualAssessmentId) !== null && _latestVirtualAssessmentId !== void 0 ? _latestVirtualAssessmentId : "";
        var _previousOfferId;
        message.previousOfferId = (_previousOfferId = object.previousOfferId) !== null && _previousOfferId !== void 0 ? _previousOfferId : "";
        message.lastOfferReviewDetails = object.lastOfferReviewDetails !== undefined && object.lastOfferReviewDetails !== null ? OfferReviewDetails.fromPartial(object.lastOfferReviewDetails) : undefined;
        message.experiencePartner = object.experiencePartner !== undefined && object.experiencePartner !== null ? ExperiencePartner.fromPartial(object.experiencePartner) : undefined;
        message.customerEventNotes = ((ref1 = object.customerEventNotes) === null || ref1 === void 0 ? void 0 : ref1.map(function(e) {
            return CustomerEventNote.fromPartial(e);
        })) || [];
        var _isAgentExperience;
        message.isAgentExperience = (_isAgentExperience = object.isAgentExperience) !== null && _isAgentExperience !== void 0 ? _isAgentExperience : false;
        var _addressId;
        message.addressId = (_addressId = object.addressId) !== null && _addressId !== void 0 ? _addressId : "";
        var _customerUuid;
        message.customerUuid = (_customerUuid = object.customerUuid) !== null && _customerUuid !== void 0 ? _customerUuid : "";
        var _email;
        message.email = (_email = object.email) !== null && _email !== void 0 ? _email : "";
        var _isQualified;
        message.isQualified = (_isQualified = object.isQualified) !== null && _isQualified !== void 0 ? _isQualified : false;
        var _qualifiedAt;
        message.qualifiedAt = (_qualifiedAt = object.qualifiedAt) !== null && _qualifiedAt !== void 0 ? _qualifiedAt : undefined;
        var _createdAt;
        message.createdAt = (_createdAt = object.createdAt) !== null && _createdAt !== void 0 ? _createdAt : undefined;
        var _latestSelfServeVirtualAssessmentId;
        message.latestSelfServeVirtualAssessmentId = (_latestSelfServeVirtualAssessmentId = object.latestSelfServeVirtualAssessmentId) !== null && _latestSelfServeVirtualAssessmentId !== void 0 ? _latestSelfServeVirtualAssessmentId : "";
        var _latestOfferReviewVirtualAssessmentId;
        message.latestOfferReviewVirtualAssessmentId = (_latestOfferReviewVirtualAssessmentId = object.latestOfferReviewVirtualAssessmentId) !== null && _latestOfferReviewVirtualAssessmentId !== void 0 ? _latestOfferReviewVirtualAssessmentId : "";
        var _denialReason;
        message.denialReason = (_denialReason = object.denialReason) !== null && _denialReason !== void 0 ? _denialReason : 0;
        message.homeConditionResponse = object.homeConditionResponse !== undefined && object.homeConditionResponse !== null ? HomeConditionResponse.fromPartial(object.homeConditionResponse) : undefined;
        var _channel;
        message.channel = (_channel = object.channel) !== null && _channel !== void 0 ? _channel : 0;
        message.customerIds = ((ref2 = object.customerIds) === null || ref2 === void 0 ? void 0 : ref2.map(function(e) {
            return e;
        })) || [];
        var _isEligibleForVirtualEa;
        message.isEligibleForVirtualEa = (_isEligibleForVirtualEa = object.isEligibleForVirtualEa) !== null && _isEligibleForVirtualEa !== void 0 ? _isEligibleForVirtualEa : false;
        var _inExclusiveOffers;
        message.inExclusiveOffers = (_inExclusiveOffers = object.inExclusiveOffers) !== null && _inExclusiveOffers !== void 0 ? _inExclusiveOffers : false;
        var _sellerSsvaUploadPage;
        message.sellerSsvaUploadPage = (_sellerSsvaUploadPage = object.sellerSsvaUploadPage) !== null && _sellerSsvaUploadPage !== void 0 ? _sellerSsvaUploadPage : "";
        var _mortgagePayoffAmountCents;
        message.mortgagePayoffAmountCents = (_mortgagePayoffAmountCents = object.mortgagePayoffAmountCents) !== null && _mortgagePayoffAmountCents !== void 0 ? _mortgagePayoffAmountCents : undefined;
        var _denialNotes;
        message.denialNotes = (_denialNotes = object.denialNotes) !== null && _denialNotes !== void 0 ? _denialNotes : "";
        var _hubPrimaryCtaPaintedDoorExperimentVariant;
        message.hubPrimaryCtaPaintedDoorExperimentVariant = (_hubPrimaryCtaPaintedDoorExperimentVariant = object.hubPrimaryCtaPaintedDoorExperimentVariant) !== null && _hubPrimaryCtaPaintedDoorExperimentVariant !== void 0 ? _hubPrimaryCtaPaintedDoorExperimentVariant : "";
        var _hubPrimaryCtaCustomerSuccessExperimentVariant;
        message.hubPrimaryCtaCustomerSuccessExperimentVariant = (_hubPrimaryCtaCustomerSuccessExperimentVariant = object.hubPrimaryCtaCustomerSuccessExperimentVariant) !== null && _hubPrimaryCtaCustomerSuccessExperimentVariant !== void 0 ? _hubPrimaryCtaCustomerSuccessExperimentVariant : "";
        message.addressesResponseOverride = object.addressesResponseOverride !== undefined && object.addressesResponseOverride !== null ? AddressesResponseOverride.fromPartial(object.addressesResponseOverride) : undefined;
        var _shouldSeeAgentLedOffersExperience;
        message.shouldSeeAgentLedOffersExperience = (_shouldSeeAgentLedOffersExperience = object.shouldSeeAgentLedOffersExperience) !== null && _shouldSeeAgentLedOffersExperience !== void 0 ? _shouldSeeAgentLedOffersExperience : false;
        var _shouldSeeFinalOfferNetProceeds;
        message.shouldSeeFinalOfferNetProceeds = (_shouldSeeFinalOfferNetProceeds = object.shouldSeeFinalOfferNetProceeds) !== null && _shouldSeeFinalOfferNetProceeds !== void 0 ? _shouldSeeFinalOfferNetProceeds : false;
        var _shouldSeeHubNewUserExperience;
        message.shouldSeeHubNewUserExperience = (_shouldSeeHubNewUserExperience = object.shouldSeeHubNewUserExperience) !== null && _shouldSeeHubNewUserExperience !== void 0 ? _shouldSeeHubNewUserExperience : false;
        return message;
    }
};
function createBaseAddressesResponseOverride() {
    return {
        apn: "",
        county: "",
        legalDescription: "",
        subdivision: "",
        primaryOwner: "",
        secondaryOwner: ""
    };
}
var AddressesResponseOverride = {
    fromJSON: function fromJSON(object) {
        return {
            apn: data_lead_isSet(object.apn) ? String(object.apn) : "",
            county: data_lead_isSet(object.county) ? String(object.county) : "",
            legalDescription: data_lead_isSet(object.legalDescription) ? String(object.legalDescription) : "",
            subdivision: data_lead_isSet(object.subdivision) ? String(object.subdivision) : "",
            primaryOwner: data_lead_isSet(object.primaryOwner) ? String(object.primaryOwner) : "",
            secondaryOwner: data_lead_isSet(object.secondaryOwner) ? String(object.secondaryOwner) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.apn !== "") {
            obj.apn = message.apn;
        }
        if (message.county !== "") {
            obj.county = message.county;
        }
        if (message.legalDescription !== "") {
            obj.legalDescription = message.legalDescription;
        }
        if (message.subdivision !== "") {
            obj.subdivision = message.subdivision;
        }
        if (message.primaryOwner !== "") {
            obj.primaryOwner = message.primaryOwner;
        }
        if (message.secondaryOwner !== "") {
            obj.secondaryOwner = message.secondaryOwner;
        }
        return obj;
    },
    create: function create(base) {
        return AddressesResponseOverride.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAddressesResponseOverride();
        var _apn;
        message.apn = (_apn = object.apn) !== null && _apn !== void 0 ? _apn : "";
        var _county;
        message.county = (_county = object.county) !== null && _county !== void 0 ? _county : "";
        var _legalDescription;
        message.legalDescription = (_legalDescription = object.legalDescription) !== null && _legalDescription !== void 0 ? _legalDescription : "";
        var _subdivision;
        message.subdivision = (_subdivision = object.subdivision) !== null && _subdivision !== void 0 ? _subdivision : "";
        var _primaryOwner;
        message.primaryOwner = (_primaryOwner = object.primaryOwner) !== null && _primaryOwner !== void 0 ? _primaryOwner : "";
        var _secondaryOwner;
        message.secondaryOwner = (_secondaryOwner = object.secondaryOwner) !== null && _secondaryOwner !== void 0 ? _secondaryOwner : "";
        return message;
    }
};
function createBaseDwellingsDetail() {
    return {
        primaryOwner: "",
        secondaryOwner: "",
        dwellingType: "",
        sqFt: 0,
        lotSqFt: 0,
        apn: "",
        county: "",
        hoaFees: [],
        lastMlsListing: undefined,
        legalDescription: "",
        subdivision: ""
    };
}
var DwellingsDetail = {
    fromJSON: function fromJSON(object) {
        return {
            primaryOwner: data_lead_isSet(object.primaryOwner) ? String(object.primaryOwner) : "",
            secondaryOwner: data_lead_isSet(object.secondaryOwner) ? String(object.secondaryOwner) : "",
            dwellingType: data_lead_isSet(object.dwellingType) ? String(object.dwellingType) : "",
            sqFt: data_lead_isSet(object.sqFt) ? Number(object.sqFt) : 0,
            lotSqFt: data_lead_isSet(object.lotSqFt) ? Number(object.lotSqFt) : 0,
            apn: data_lead_isSet(object.apn) ? String(object.apn) : "",
            county: data_lead_isSet(object.county) ? String(object.county) : "",
            hoaFees: Array.isArray(object === null || object === void 0 ? void 0 : object.hoaFees) ? object.hoaFees.map(function(e) {
                return HoaFee.fromJSON(e);
            }) : [],
            lastMlsListing: data_lead_isSet(object.lastMlsListing) ? LastMlsListing.fromJSON(object.lastMlsListing) : undefined,
            legalDescription: data_lead_isSet(object.legalDescription) ? String(object.legalDescription) : "",
            subdivision: data_lead_isSet(object.subdivision) ? String(object.subdivision) : ""
        };
    },
    toJSON: function toJSON(message) {
        var ref;
        var obj = {};
        if (message.primaryOwner !== "") {
            obj.primaryOwner = message.primaryOwner;
        }
        if (message.secondaryOwner !== "") {
            obj.secondaryOwner = message.secondaryOwner;
        }
        if (message.dwellingType !== "") {
            obj.dwellingType = message.dwellingType;
        }
        if (message.sqFt !== 0) {
            obj.sqFt = Math.round(message.sqFt);
        }
        if (message.lotSqFt !== 0) {
            obj.lotSqFt = Math.round(message.lotSqFt);
        }
        if (message.apn !== "") {
            obj.apn = message.apn;
        }
        if (message.county !== "") {
            obj.county = message.county;
        }
        if ((ref = message.hoaFees) === null || ref === void 0 ? void 0 : ref.length) {
            obj.hoaFees = message.hoaFees.map(function(e) {
                return HoaFee.toJSON(e);
            });
        }
        if (message.lastMlsListing !== undefined) {
            obj.lastMlsListing = LastMlsListing.toJSON(message.lastMlsListing);
        }
        if (message.legalDescription !== "") {
            obj.legalDescription = message.legalDescription;
        }
        if (message.subdivision !== "") {
            obj.subdivision = message.subdivision;
        }
        return obj;
    },
    create: function create(base) {
        return DwellingsDetail.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref;
        var message = createBaseDwellingsDetail();
        var _primaryOwner;
        message.primaryOwner = (_primaryOwner = object.primaryOwner) !== null && _primaryOwner !== void 0 ? _primaryOwner : "";
        var _secondaryOwner;
        message.secondaryOwner = (_secondaryOwner = object.secondaryOwner) !== null && _secondaryOwner !== void 0 ? _secondaryOwner : "";
        var _dwellingType;
        message.dwellingType = (_dwellingType = object.dwellingType) !== null && _dwellingType !== void 0 ? _dwellingType : "";
        var _sqFt;
        message.sqFt = (_sqFt = object.sqFt) !== null && _sqFt !== void 0 ? _sqFt : 0;
        var _lotSqFt;
        message.lotSqFt = (_lotSqFt = object.lotSqFt) !== null && _lotSqFt !== void 0 ? _lotSqFt : 0;
        var _apn;
        message.apn = (_apn = object.apn) !== null && _apn !== void 0 ? _apn : "";
        var _county;
        message.county = (_county = object.county) !== null && _county !== void 0 ? _county : "";
        message.hoaFees = ((ref = object.hoaFees) === null || ref === void 0 ? void 0 : ref.map(function(e) {
            return HoaFee.fromPartial(e);
        })) || [];
        message.lastMlsListing = object.lastMlsListing !== undefined && object.lastMlsListing !== null ? LastMlsListing.fromPartial(object.lastMlsListing) : undefined;
        var _legalDescription;
        message.legalDescription = (_legalDescription = object.legalDescription) !== null && _legalDescription !== void 0 ? _legalDescription : "";
        var _subdivision;
        message.subdivision = (_subdivision = object.subdivision) !== null && _subdivision !== void 0 ? _subdivision : "";
        return message;
    }
};
function createBaseHoaFee() {
    return {
        amount: 0,
        frequency: ""
    };
}
var HoaFee = {
    fromJSON: function fromJSON(object) {
        return {
            amount: data_lead_isSet(object.amount) ? Number(object.amount) : 0,
            frequency: data_lead_isSet(object.frequency) ? String(object.frequency) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.amount !== 0) {
            obj.amount = message.amount;
        }
        if (message.frequency !== "") {
            obj.frequency = message.frequency;
        }
        return obj;
    },
    create: function create(base) {
        return HoaFee.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseHoaFee();
        var _amount;
        message.amount = (_amount = object.amount) !== null && _amount !== void 0 ? _amount : 0;
        var _frequency;
        message.frequency = (_frequency = object.frequency) !== null && _frequency !== void 0 ? _frequency : "";
        return message;
    }
};
function createBaseLastMlsListing() {
    return {
        listingId: "",
        sqFt: "",
        listingStatus: "",
        listDate: undefined,
        closeDate: undefined,
        numPhotos: 0,
        lotSqFt: "",
        originalListPrice: "",
        listPrice: "",
        priceHistory: [],
        closePrice: "",
        realtorName: "",
        specialListingCond: ""
    };
}
var LastMlsListing = {
    fromJSON: function fromJSON(object) {
        return {
            listingId: data_lead_isSet(object.listingId) ? String(object.listingId) : "",
            sqFt: data_lead_isSet(object.sqFt) ? String(object.sqFt) : "",
            listingStatus: data_lead_isSet(object.listingStatus) ? String(object.listingStatus) : "",
            listDate: data_lead_isSet(object.listDate) ? data_lead_fromJsonTimestamp(object.listDate) : undefined,
            closeDate: data_lead_isSet(object.closeDate) ? data_lead_fromJsonTimestamp(object.closeDate) : undefined,
            numPhotos: data_lead_isSet(object.numPhotos) ? Number(object.numPhotos) : 0,
            lotSqFt: data_lead_isSet(object.lotSqFt) ? String(object.lotSqFt) : "",
            originalListPrice: data_lead_isSet(object.originalListPrice) ? String(object.originalListPrice) : "",
            listPrice: data_lead_isSet(object.listPrice) ? String(object.listPrice) : "",
            priceHistory: Array.isArray(object === null || object === void 0 ? void 0 : object.priceHistory) ? object.priceHistory.map(function(e) {
                return PriceHistory.fromJSON(e);
            }) : [],
            closePrice: data_lead_isSet(object.closePrice) ? String(object.closePrice) : "",
            realtorName: data_lead_isSet(object.realtorName) ? String(object.realtorName) : "",
            specialListingCond: data_lead_isSet(object.specialListingCond) ? String(object.specialListingCond) : ""
        };
    },
    toJSON: function toJSON(message) {
        var ref;
        var obj = {};
        if (message.listingId !== "") {
            obj.listingId = message.listingId;
        }
        if (message.sqFt !== "") {
            obj.sqFt = message.sqFt;
        }
        if (message.listingStatus !== "") {
            obj.listingStatus = message.listingStatus;
        }
        if (message.listDate !== undefined) {
            obj.listDate = message.listDate.toISOString();
        }
        if (message.closeDate !== undefined) {
            obj.closeDate = message.closeDate.toISOString();
        }
        if (message.numPhotos !== 0) {
            obj.numPhotos = Math.round(message.numPhotos);
        }
        if (message.lotSqFt !== "") {
            obj.lotSqFt = message.lotSqFt;
        }
        if (message.originalListPrice !== "") {
            obj.originalListPrice = message.originalListPrice;
        }
        if (message.listPrice !== "") {
            obj.listPrice = message.listPrice;
        }
        if ((ref = message.priceHistory) === null || ref === void 0 ? void 0 : ref.length) {
            obj.priceHistory = message.priceHistory.map(function(e) {
                return PriceHistory.toJSON(e);
            });
        }
        if (message.closePrice !== "") {
            obj.closePrice = message.closePrice;
        }
        if (message.realtorName !== "") {
            obj.realtorName = message.realtorName;
        }
        if (message.specialListingCond !== "") {
            obj.specialListingCond = message.specialListingCond;
        }
        return obj;
    },
    create: function create(base) {
        return LastMlsListing.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref;
        var message = createBaseLastMlsListing();
        var _listingId;
        message.listingId = (_listingId = object.listingId) !== null && _listingId !== void 0 ? _listingId : "";
        var _sqFt;
        message.sqFt = (_sqFt = object.sqFt) !== null && _sqFt !== void 0 ? _sqFt : "";
        var _listingStatus;
        message.listingStatus = (_listingStatus = object.listingStatus) !== null && _listingStatus !== void 0 ? _listingStatus : "";
        var _listDate;
        message.listDate = (_listDate = object.listDate) !== null && _listDate !== void 0 ? _listDate : undefined;
        var _closeDate;
        message.closeDate = (_closeDate = object.closeDate) !== null && _closeDate !== void 0 ? _closeDate : undefined;
        var _numPhotos;
        message.numPhotos = (_numPhotos = object.numPhotos) !== null && _numPhotos !== void 0 ? _numPhotos : 0;
        var _lotSqFt;
        message.lotSqFt = (_lotSqFt = object.lotSqFt) !== null && _lotSqFt !== void 0 ? _lotSqFt : "";
        var _originalListPrice;
        message.originalListPrice = (_originalListPrice = object.originalListPrice) !== null && _originalListPrice !== void 0 ? _originalListPrice : "";
        var _listPrice;
        message.listPrice = (_listPrice = object.listPrice) !== null && _listPrice !== void 0 ? _listPrice : "";
        message.priceHistory = ((ref = object.priceHistory) === null || ref === void 0 ? void 0 : ref.map(function(e) {
            return PriceHistory.fromPartial(e);
        })) || [];
        var _closePrice;
        message.closePrice = (_closePrice = object.closePrice) !== null && _closePrice !== void 0 ? _closePrice : "";
        var _realtorName;
        message.realtorName = (_realtorName = object.realtorName) !== null && _realtorName !== void 0 ? _realtorName : "";
        var _specialListingCond;
        message.specialListingCond = (_specialListingCond = object.specialListingCond) !== null && _specialListingCond !== void 0 ? _specialListingCond : "";
        return message;
    }
};
function createBasePriceHistory() {
    return {
        price: "",
        priceDate: undefined
    };
}
var PriceHistory = {
    fromJSON: function fromJSON(object) {
        return {
            price: data_lead_isSet(object.price) ? String(object.price) : "",
            priceDate: data_lead_isSet(object.priceDate) ? data_lead_fromJsonTimestamp(object.priceDate) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.price !== "") {
            obj.price = message.price;
        }
        if (message.priceDate !== undefined) {
            obj.priceDate = message.priceDate.toISOString();
        }
        return obj;
    },
    create: function create(base) {
        return PriceHistory.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBasePriceHistory();
        var _price;
        message.price = (_price = object.price) !== null && _price !== void 0 ? _price : "";
        var _priceDate;
        message.priceDate = (_priceDate = object.priceDate) !== null && _priceDate !== void 0 ? _priceDate : undefined;
        return message;
    }
};
function createBasePrivateLead() {
    return {
        lead: undefined,
        statusNote: "",
        displayCategoryForOpsAcquisition: "",
        dwellingsDetail: undefined,
        partnerships: undefined
    };
}
var PrivateLead = {
    fromJSON: function fromJSON(object) {
        return {
            lead: data_lead_isSet(object.lead) ? lead_Lead.fromJSON(object.lead) : undefined,
            statusNote: data_lead_isSet(object.statusNote) ? String(object.statusNote) : "",
            displayCategoryForOpsAcquisition: data_lead_isSet(object.displayCategoryForOpsAcquisition) ? String(object.displayCategoryForOpsAcquisition) : "",
            dwellingsDetail: data_lead_isSet(object.dwellingsDetail) ? DwellingsDetail.fromJSON(object.dwellingsDetail) : undefined,
            partnerships: data_lead_isSet(object.partnerships) ? Partnerships.fromJSON(object.partnerships) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.lead !== undefined) {
            obj.lead = lead_Lead.toJSON(message.lead);
        }
        if (message.statusNote !== "") {
            obj.statusNote = message.statusNote;
        }
        if (message.displayCategoryForOpsAcquisition !== "") {
            obj.displayCategoryForOpsAcquisition = message.displayCategoryForOpsAcquisition;
        }
        if (message.dwellingsDetail !== undefined) {
            obj.dwellingsDetail = DwellingsDetail.toJSON(message.dwellingsDetail);
        }
        if (message.partnerships !== undefined) {
            obj.partnerships = Partnerships.toJSON(message.partnerships);
        }
        return obj;
    },
    create: function create(base) {
        return PrivateLead.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBasePrivateLead();
        message.lead = object.lead !== undefined && object.lead !== null ? lead_Lead.fromPartial(object.lead) : undefined;
        var _statusNote;
        message.statusNote = (_statusNote = object.statusNote) !== null && _statusNote !== void 0 ? _statusNote : "";
        var _displayCategoryForOpsAcquisition;
        message.displayCategoryForOpsAcquisition = (_displayCategoryForOpsAcquisition = object.displayCategoryForOpsAcquisition) !== null && _displayCategoryForOpsAcquisition !== void 0 ? _displayCategoryForOpsAcquisition : "";
        message.dwellingsDetail = object.dwellingsDetail !== undefined && object.dwellingsDetail !== null ? DwellingsDetail.fromPartial(object.dwellingsDetail) : undefined;
        message.partnerships = object.partnerships !== undefined && object.partnerships !== null ? Partnerships.fromPartial(object.partnerships) : undefined;
        return message;
    }
};
function createBasePartnerships() {
    return {
        builderPartner: undefined,
        lenderPartner: undefined,
        onlineRealEstatePartner: undefined,
        agentTechIntegrationPartner: undefined,
        realEstateAgencyPartner: undefined
    };
}
var Partnerships = {
    fromJSON: function fromJSON(object) {
        return {
            builderPartner: data_lead_isSet(object.builderPartner) ? lead_Partnership.fromJSON(object.builderPartner) : undefined,
            lenderPartner: data_lead_isSet(object.lenderPartner) ? lead_Partnership.fromJSON(object.lenderPartner) : undefined,
            onlineRealEstatePartner: data_lead_isSet(object.onlineRealEstatePartner) ? lead_Partnership.fromJSON(object.onlineRealEstatePartner) : undefined,
            agentTechIntegrationPartner: data_lead_isSet(object.agentTechIntegrationPartner) ? lead_Partnership.fromJSON(object.agentTechIntegrationPartner) : undefined,
            realEstateAgencyPartner: data_lead_isSet(object.realEstateAgencyPartner) ? lead_Partnership.fromJSON(object.realEstateAgencyPartner) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.builderPartner !== undefined) {
            obj.builderPartner = lead_Partnership.toJSON(message.builderPartner);
        }
        if (message.lenderPartner !== undefined) {
            obj.lenderPartner = lead_Partnership.toJSON(message.lenderPartner);
        }
        if (message.onlineRealEstatePartner !== undefined) {
            obj.onlineRealEstatePartner = lead_Partnership.toJSON(message.onlineRealEstatePartner);
        }
        if (message.agentTechIntegrationPartner !== undefined) {
            obj.agentTechIntegrationPartner = lead_Partnership.toJSON(message.agentTechIntegrationPartner);
        }
        if (message.realEstateAgencyPartner !== undefined) {
            obj.realEstateAgencyPartner = lead_Partnership.toJSON(message.realEstateAgencyPartner);
        }
        return obj;
    },
    create: function create(base) {
        return Partnerships.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBasePartnerships();
        message.builderPartner = object.builderPartner !== undefined && object.builderPartner !== null ? lead_Partnership.fromPartial(object.builderPartner) : undefined;
        message.lenderPartner = object.lenderPartner !== undefined && object.lenderPartner !== null ? lead_Partnership.fromPartial(object.lenderPartner) : undefined;
        message.onlineRealEstatePartner = object.onlineRealEstatePartner !== undefined && object.onlineRealEstatePartner !== null ? lead_Partnership.fromPartial(object.onlineRealEstatePartner) : undefined;
        message.agentTechIntegrationPartner = object.agentTechIntegrationPartner !== undefined && object.agentTechIntegrationPartner !== null ? lead_Partnership.fromPartial(object.agentTechIntegrationPartner) : undefined;
        message.realEstateAgencyPartner = object.realEstateAgencyPartner !== undefined && object.realEstateAgencyPartner !== null ? lead_Partnership.fromPartial(object.realEstateAgencyPartner) : undefined;
        return message;
    }
};
function createBasePartnership() {
    return {
        partnerIdentifier: "",
        referrerEmail: "",
        sellerRelation: 0
    };
}
var lead_Partnership = {
    fromJSON: function fromJSON(object) {
        return {
            partnerIdentifier: data_lead_isSet(object.partnerIdentifier) ? String(object.partnerIdentifier) : "",
            referrerEmail: data_lead_isSet(object.referrerEmail) ? String(object.referrerEmail) : "",
            sellerRelation: data_lead_isSet(object.sellerRelation) ? Number(object.sellerRelation) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.partnerIdentifier !== "") {
            obj.partnerIdentifier = message.partnerIdentifier;
        }
        if (message.referrerEmail !== "") {
            obj.referrerEmail = message.referrerEmail;
        }
        if (message.sellerRelation !== 0) {
            obj.sellerRelation = Math.round(message.sellerRelation);
        }
        return obj;
    },
    create: function create(base) {
        return lead_Partnership.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBasePartnership();
        var _partnerIdentifier;
        message.partnerIdentifier = (_partnerIdentifier = object.partnerIdentifier) !== null && _partnerIdentifier !== void 0 ? _partnerIdentifier : "";
        var _referrerEmail;
        message.referrerEmail = (_referrerEmail = object.referrerEmail) !== null && _referrerEmail !== void 0 ? _referrerEmail : "";
        var _sellerRelation;
        message.sellerRelation = (_sellerRelation = object.sellerRelation) !== null && _sellerRelation !== void 0 ? _sellerRelation : 0;
        return message;
    }
};
function createBaseOfferReviewDetails() {
    return {
        id: "",
        offerReviewOutcome: "",
        offerReviewAt: undefined,
        calendlyData: undefined
    };
}
var OfferReviewDetails = {
    fromJSON: function fromJSON(object) {
        return {
            id: data_lead_isSet(object.id) ? String(object.id) : "",
            offerReviewOutcome: data_lead_isSet(object.offerReviewOutcome) ? String(object.offerReviewOutcome) : "",
            offerReviewAt: data_lead_isSet(object.offerReviewAt) ? data_lead_fromJsonTimestamp(object.offerReviewAt) : undefined,
            calendlyData: data_lead_isSet(object.calendlyData) ? CalendlyData.fromJSON(object.calendlyData) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.offerReviewOutcome !== "") {
            obj.offerReviewOutcome = message.offerReviewOutcome;
        }
        if (message.offerReviewAt !== undefined) {
            obj.offerReviewAt = message.offerReviewAt.toISOString();
        }
        if (message.calendlyData !== undefined) {
            obj.calendlyData = CalendlyData.toJSON(message.calendlyData);
        }
        return obj;
    },
    create: function create(base) {
        return OfferReviewDetails.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseOfferReviewDetails();
        var _id;
        message.id = (_id = object.id) !== null && _id !== void 0 ? _id : "";
        var _offerReviewOutcome;
        message.offerReviewOutcome = (_offerReviewOutcome = object.offerReviewOutcome) !== null && _offerReviewOutcome !== void 0 ? _offerReviewOutcome : "";
        var _offerReviewAt;
        message.offerReviewAt = (_offerReviewAt = object.offerReviewAt) !== null && _offerReviewAt !== void 0 ? _offerReviewAt : undefined;
        message.calendlyData = object.calendlyData !== undefined && object.calendlyData !== null ? CalendlyData.fromPartial(object.calendlyData) : undefined;
        return message;
    }
};
function createBaseCalendlyData() {
    return {
        id: "",
        calendar: "",
        source: ""
    };
}
var CalendlyData = {
    fromJSON: function fromJSON(object) {
        return {
            id: data_lead_isSet(object.id) ? String(object.id) : "",
            calendar: data_lead_isSet(object.calendar) ? String(object.calendar) : "",
            source: data_lead_isSet(object.source) ? String(object.source) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.calendar !== "") {
            obj.calendar = message.calendar;
        }
        if (message.source !== "") {
            obj.source = message.source;
        }
        return obj;
    },
    create: function create(base) {
        return CalendlyData.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseCalendlyData();
        var _id;
        message.id = (_id = object.id) !== null && _id !== void 0 ? _id : "";
        var _calendar;
        message.calendar = (_calendar = object.calendar) !== null && _calendar !== void 0 ? _calendar : "";
        var _source;
        message.source = (_source = object.source) !== null && _source !== void 0 ? _source : "";
        return message;
    }
};
function createBaseExperiencePartner() {
    return {
        id: "",
        name: "",
        email: "",
        displayPhoneNumber: "",
        photoUrl: "",
        brokerageLicenses: [],
        humanToken: ""
    };
}
var ExperiencePartner = {
    fromJSON: function fromJSON(object) {
        return {
            id: data_lead_isSet(object.id) ? String(object.id) : "",
            name: data_lead_isSet(object.name) ? String(object.name) : "",
            email: data_lead_isSet(object.email) ? String(object.email) : "",
            displayPhoneNumber: data_lead_isSet(object.displayPhoneNumber) ? String(object.displayPhoneNumber) : "",
            photoUrl: data_lead_isSet(object.photoUrl) ? String(object.photoUrl) : "",
            brokerageLicenses: Array.isArray(object === null || object === void 0 ? void 0 : object.brokerageLicenses) ? object.brokerageLicenses.map(function(e) {
                return BrokerageLicense.fromJSON(e);
            }) : [],
            humanToken: data_lead_isSet(object.humanToken) ? String(object.humanToken) : ""
        };
    },
    toJSON: function toJSON(message) {
        var ref;
        var obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.name !== "") {
            obj.name = message.name;
        }
        if (message.email !== "") {
            obj.email = message.email;
        }
        if (message.displayPhoneNumber !== "") {
            obj.displayPhoneNumber = message.displayPhoneNumber;
        }
        if (message.photoUrl !== "") {
            obj.photoUrl = message.photoUrl;
        }
        if ((ref = message.brokerageLicenses) === null || ref === void 0 ? void 0 : ref.length) {
            obj.brokerageLicenses = message.brokerageLicenses.map(function(e) {
                return BrokerageLicense.toJSON(e);
            });
        }
        if (message.humanToken !== "") {
            obj.humanToken = message.humanToken;
        }
        return obj;
    },
    create: function create(base) {
        return ExperiencePartner.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref;
        var message = createBaseExperiencePartner();
        var _id;
        message.id = (_id = object.id) !== null && _id !== void 0 ? _id : "";
        var _name;
        message.name = (_name = object.name) !== null && _name !== void 0 ? _name : "";
        var _email;
        message.email = (_email = object.email) !== null && _email !== void 0 ? _email : "";
        var _displayPhoneNumber;
        message.displayPhoneNumber = (_displayPhoneNumber = object.displayPhoneNumber) !== null && _displayPhoneNumber !== void 0 ? _displayPhoneNumber : "";
        var _photoUrl;
        message.photoUrl = (_photoUrl = object.photoUrl) !== null && _photoUrl !== void 0 ? _photoUrl : "";
        message.brokerageLicenses = ((ref = object.brokerageLicenses) === null || ref === void 0 ? void 0 : ref.map(function(e) {
            return BrokerageLicense.fromPartial(e);
        })) || [];
        var _humanToken;
        message.humanToken = (_humanToken = object.humanToken) !== null && _humanToken !== void 0 ? _humanToken : "";
        return message;
    }
};
function createBaseBrokerageLicense() {
    return {
        id: "",
        geographicState: "",
        state: 0,
        licenseNumber: ""
    };
}
var BrokerageLicense = {
    fromJSON: function fromJSON(object) {
        return {
            id: data_lead_isSet(object.id) ? String(object.id) : "",
            geographicState: data_lead_isSet(object.geographicState) ? String(object.geographicState) : "",
            state: data_lead_isSet(object.state) ? stateFromJSON(object.state) : 0,
            licenseNumber: data_lead_isSet(object.licenseNumber) ? String(object.licenseNumber) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.geographicState !== "") {
            obj.geographicState = message.geographicState;
        }
        if (message.state !== 0) {
            obj.state = stateToJSON(message.state);
        }
        if (message.licenseNumber !== "") {
            obj.licenseNumber = message.licenseNumber;
        }
        return obj;
    },
    create: function create(base) {
        return BrokerageLicense.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseBrokerageLicense();
        var _id;
        message.id = (_id = object.id) !== null && _id !== void 0 ? _id : "";
        var _geographicState;
        message.geographicState = (_geographicState = object.geographicState) !== null && _geographicState !== void 0 ? _geographicState : "";
        var _state;
        message.state = (_state = object.state) !== null && _state !== void 0 ? _state : 0;
        var _licenseNumber;
        message.licenseNumber = (_licenseNumber = object.licenseNumber) !== null && _licenseNumber !== void 0 ? _licenseNumber : "";
        return message;
    }
};
function createBaseLeadIdentifier() {
    return {
        lead: undefined
    };
}
var LeadIdentifier = {
    fromJSON: function fromJSON(object) {
        return {
            lead: data_lead_isSet(object.source) ? {
                $case: "source",
                source: LeadSource.fromJSON(object.source)
            } : data_lead_isSet(object.params) ? {
                $case: "params",
                params: LeadQueryParams.fromJSON(object.params)
            } : data_lead_isSet(object.token) ? {
                $case: "token",
                token: String(object.token)
            } : data_lead_isSet(object.sellerLeadUuid) ? {
                $case: "sellerLeadUuid",
                sellerLeadUuid: String(object.sellerLeadUuid)
            } : undefined
        };
    },
    toJSON: function toJSON(message) {
        var ref, ref1, ref2, ref3;
        var obj = {};
        if (((ref = message.lead) === null || ref === void 0 ? void 0 : ref.$case) === "source") {
            obj.source = LeadSource.toJSON(message.lead.source);
        }
        if (((ref1 = message.lead) === null || ref1 === void 0 ? void 0 : ref1.$case) === "params") {
            obj.params = LeadQueryParams.toJSON(message.lead.params);
        }
        if (((ref2 = message.lead) === null || ref2 === void 0 ? void 0 : ref2.$case) === "token") {
            obj.token = message.lead.token;
        }
        if (((ref3 = message.lead) === null || ref3 === void 0 ? void 0 : ref3.$case) === "sellerLeadUuid") {
            obj.sellerLeadUuid = message.lead.sellerLeadUuid;
        }
        return obj;
    },
    create: function create(base) {
        return LeadIdentifier.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
        var message = createBaseLeadIdentifier();
        if (((ref = object.lead) === null || ref === void 0 ? void 0 : ref.$case) === "source" && ((ref1 = object.lead) === null || ref1 === void 0 ? void 0 : ref1.source) !== undefined && ((ref2 = object.lead) === null || ref2 === void 0 ? void 0 : ref2.source) !== null) {
            message.lead = {
                $case: "source",
                source: LeadSource.fromPartial(object.lead.source)
            };
        }
        if (((ref3 = object.lead) === null || ref3 === void 0 ? void 0 : ref3.$case) === "params" && ((ref4 = object.lead) === null || ref4 === void 0 ? void 0 : ref4.params) !== undefined && ((ref5 = object.lead) === null || ref5 === void 0 ? void 0 : ref5.params) !== null) {
            message.lead = {
                $case: "params",
                params: LeadQueryParams.fromPartial(object.lead.params)
            };
        }
        if (((ref6 = object.lead) === null || ref6 === void 0 ? void 0 : ref6.$case) === "token" && ((ref7 = object.lead) === null || ref7 === void 0 ? void 0 : ref7.token) !== undefined && ((ref8 = object.lead) === null || ref8 === void 0 ? void 0 : ref8.token) !== null) {
            message.lead = {
                $case: "token",
                token: object.lead.token
            };
        }
        if (((ref9 = object.lead) === null || ref9 === void 0 ? void 0 : ref9.$case) === "sellerLeadUuid" && ((ref10 = object.lead) === null || ref10 === void 0 ? void 0 : ref10.sellerLeadUuid) !== undefined && ((ref11 = object.lead) === null || ref11 === void 0 ? void 0 : ref11.sellerLeadUuid) !== null) {
            message.lead = {
                $case: "sellerLeadUuid",
                sellerLeadUuid: object.lead.sellerLeadUuid
            };
        }
        return message;
    }
};
function data_lead_fromTimestamp(t) {
    var millis = (t.seconds || 0) * 1000;
    millis += (t.nanos || 0) / 1000000;
    return new Date(millis);
}
function data_lead_fromJsonTimestamp(o) {
    if ((0,_instanceof/* default */.Z)(o, Date)) {
        return o;
    } else if (typeof o === "string") {
        return new Date(o);
    } else {
        return data_lead_fromTimestamp(Timestamp.fromJSON(o));
    }
}
function data_lead_isSet(value) {
    return value !== null && value !== undefined;
}

;// CONCATENATED MODULE: ./src/__generated__/protobuf/web/data/title_contact.ts
/* eslint-disable */ var title_contact_protobufPackage = "od_protos.web.data";
function createBaseTitleContact() {
    return {
        fullName: "",
        email: ""
    };
}
var TitleContact = {
    fromJSON: function fromJSON(object) {
        return {
            fullName: title_contact_isSet(object.fullName) ? String(object.fullName) : "",
            email: title_contact_isSet(object.email) ? String(object.email) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.fullName !== "") {
            obj.fullName = message.fullName;
        }
        if (message.email !== "") {
            obj.email = message.email;
        }
        return obj;
    },
    create: function create(base) {
        return TitleContact.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseTitleContact();
        var _fullName;
        message.fullName = (_fullName = object.fullName) !== null && _fullName !== void 0 ? _fullName : "";
        var _email;
        message.email = (_email = object.email) !== null && _email !== void 0 ? _email : "";
        return message;
    }
};
function createBaseTitleOrganization() {
    return {
        legalName: "",
        name: "",
        escrowName: ""
    };
}
var TitleOrganization = {
    fromJSON: function fromJSON(object) {
        return {
            legalName: title_contact_isSet(object.legalName) ? String(object.legalName) : "",
            name: title_contact_isSet(object.name) ? String(object.name) : "",
            escrowName: title_contact_isSet(object.escrowName) ? String(object.escrowName) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.legalName !== "") {
            obj.legalName = message.legalName;
        }
        if (message.name !== "") {
            obj.name = message.name;
        }
        if (message.escrowName !== "") {
            obj.escrowName = message.escrowName;
        }
        return obj;
    },
    create: function create(base) {
        return TitleOrganization.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseTitleOrganization();
        var _legalName;
        message.legalName = (_legalName = object.legalName) !== null && _legalName !== void 0 ? _legalName : "";
        var _name;
        message.name = (_name = object.name) !== null && _name !== void 0 ? _name : "";
        var _escrowName;
        message.escrowName = (_escrowName = object.escrowName) !== null && _escrowName !== void 0 ? _escrowName : "";
        return message;
    }
};
function title_contact_isSet(value) {
    return value !== null && value !== undefined;
}

;// CONCATENATED MODULE: ./src/__generated__/protobuf/web/data/offer.ts
/* eslint-disable */ 









var data_offer_protobufPackage = "od_protos.web.data";
var ExperimentsEnum;
(function(ExperimentsEnum) {
    ExperimentsEnum[ExperimentsEnum["UNKNOWN_EXPERIMENT"] = 0] = "UNKNOWN_EXPERIMENT";
    ExperimentsEnum[ExperimentsEnum["GUARANTEE_AT_PRELIM_OFFER"] = 1] = "GUARANTEE_AT_PRELIM_OFFER";
    ExperimentsEnum[ExperimentsEnum["NO_VIRTUAL_ASSESSMENT"] = 2] = "NO_VIRTUAL_ASSESSMENT";
    ExperimentsEnum[ExperimentsEnum["SELLER_LOW_OFFER_CONFIDENCE"] = 3] = "SELLER_LOW_OFFER_CONFIDENCE";
    ExperimentsEnum[ExperimentsEnum["LWC_WITH_ALA"] = 4] = "LWC_WITH_ALA";
    ExperimentsEnum[ExperimentsEnum["MSRE_OFFER_LOCK"] = 5] = "MSRE_OFFER_LOCK";
    ExperimentsEnum[ExperimentsEnum[/** @deprecated */ "SELL_YOUR_WAY_INCLUDE_CASH_PLUS"] = 6] = "SELL_YOUR_WAY_INCLUDE_CASH_PLUS";
    ExperimentsEnum[ExperimentsEnum["SELL_THREE_WAYS_MVP_EXPERIENCE"] = 7] = "SELL_THREE_WAYS_MVP_EXPERIENCE";
    ExperimentsEnum[ExperimentsEnum["OFFER_CALENDAR"] = 8] = "OFFER_CALENDAR";
    ExperimentsEnum[ExperimentsEnum["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ExperimentsEnum || (ExperimentsEnum = {}));
function experimentsEnumFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN_EXPERIMENT":
            return ExperimentsEnum.UNKNOWN_EXPERIMENT;
        case 1:
        case "GUARANTEE_AT_PRELIM_OFFER":
            return ExperimentsEnum.GUARANTEE_AT_PRELIM_OFFER;
        case 2:
        case "NO_VIRTUAL_ASSESSMENT":
            return ExperimentsEnum.NO_VIRTUAL_ASSESSMENT;
        case 3:
        case "SELLER_LOW_OFFER_CONFIDENCE":
            return ExperimentsEnum.SELLER_LOW_OFFER_CONFIDENCE;
        case 4:
        case "LWC_WITH_ALA":
            return ExperimentsEnum.LWC_WITH_ALA;
        case 5:
        case "MSRE_OFFER_LOCK":
            return ExperimentsEnum.MSRE_OFFER_LOCK;
        case 6:
        case "SELL_YOUR_WAY_INCLUDE_CASH_PLUS":
            return ExperimentsEnum.SELL_YOUR_WAY_INCLUDE_CASH_PLUS;
        case 7:
        case "SELL_THREE_WAYS_MVP_EXPERIENCE":
            return ExperimentsEnum.SELL_THREE_WAYS_MVP_EXPERIENCE;
        case 8:
        case "OFFER_CALENDAR":
            return ExperimentsEnum.OFFER_CALENDAR;
        case -1:
        case "UNRECOGNIZED":
        default:
            return ExperimentsEnum.UNRECOGNIZED;
    }
}
function experimentsEnumToJSON(object) {
    switch(object){
        case ExperimentsEnum.UNKNOWN_EXPERIMENT:
            return "UNKNOWN_EXPERIMENT";
        case ExperimentsEnum.GUARANTEE_AT_PRELIM_OFFER:
            return "GUARANTEE_AT_PRELIM_OFFER";
        case ExperimentsEnum.NO_VIRTUAL_ASSESSMENT:
            return "NO_VIRTUAL_ASSESSMENT";
        case ExperimentsEnum.SELLER_LOW_OFFER_CONFIDENCE:
            return "SELLER_LOW_OFFER_CONFIDENCE";
        case ExperimentsEnum.LWC_WITH_ALA:
            return "LWC_WITH_ALA";
        case ExperimentsEnum.MSRE_OFFER_LOCK:
            return "MSRE_OFFER_LOCK";
        case ExperimentsEnum.SELL_YOUR_WAY_INCLUDE_CASH_PLUS:
            return "SELL_YOUR_WAY_INCLUDE_CASH_PLUS";
        case ExperimentsEnum.SELL_THREE_WAYS_MVP_EXPERIENCE:
            return "SELL_THREE_WAYS_MVP_EXPERIENCE";
        case ExperimentsEnum.OFFER_CALENDAR:
            return "OFFER_CALENDAR";
        case ExperimentsEnum.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var OccupancyAtVa;
(function(OccupancyAtVa) {
    OccupancyAtVa[OccupancyAtVa["UNKNOWN_OCCUPANCY"] = 0] = "UNKNOWN_OCCUPANCY";
    OccupancyAtVa[OccupancyAtVa["OWNER_OCCUPIED"] = 1] = "OWNER_OCCUPIED";
    OccupancyAtVa[OccupancyAtVa["TENANT_OCCUPIED"] = 2] = "TENANT_OCCUPIED";
    OccupancyAtVa[OccupancyAtVa["LIVE_FAR_AWAY"] = 3] = "LIVE_FAR_AWAY";
    OccupancyAtVa[OccupancyAtVa["OTHER_OCCUPANCY"] = 4] = "OTHER_OCCUPANCY";
    OccupancyAtVa[OccupancyAtVa["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(OccupancyAtVa || (OccupancyAtVa = {}));
function occupancyAtVaFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN_OCCUPANCY":
            return OccupancyAtVa.UNKNOWN_OCCUPANCY;
        case 1:
        case "OWNER_OCCUPIED":
            return OccupancyAtVa.OWNER_OCCUPIED;
        case 2:
        case "TENANT_OCCUPIED":
            return OccupancyAtVa.TENANT_OCCUPIED;
        case 3:
        case "LIVE_FAR_AWAY":
            return OccupancyAtVa.LIVE_FAR_AWAY;
        case 4:
        case "OTHER_OCCUPANCY":
            return OccupancyAtVa.OTHER_OCCUPANCY;
        case -1:
        case "UNRECOGNIZED":
        default:
            return OccupancyAtVa.UNRECOGNIZED;
    }
}
function occupancyAtVaToJSON(object) {
    switch(object){
        case OccupancyAtVa.UNKNOWN_OCCUPANCY:
            return "UNKNOWN_OCCUPANCY";
        case OccupancyAtVa.OWNER_OCCUPIED:
            return "OWNER_OCCUPIED";
        case OccupancyAtVa.TENANT_OCCUPIED:
            return "TENANT_OCCUPIED";
        case OccupancyAtVa.LIVE_FAR_AWAY:
            return "LIVE_FAR_AWAY";
        case OccupancyAtVa.OTHER_OCCUPANCY:
            return "OTHER_OCCUPANCY";
        case OccupancyAtVa.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var FeatureFlagEnum;
(function(FeatureFlagEnum) {
    FeatureFlagEnum[FeatureFlagEnum["UNKNOWN_FEATURE_FLAG"] = 0] = "UNKNOWN_FEATURE_FLAG";
    FeatureFlagEnum[FeatureFlagEnum["UNEXPIRE_OFFER_WITH_VALID_UNDERWRITING"] = 1] = "UNEXPIRE_OFFER_WITH_VALID_UNDERWRITING";
    FeatureFlagEnum[FeatureFlagEnum["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(FeatureFlagEnum || (FeatureFlagEnum = {}));
function featureFlagEnumFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN_FEATURE_FLAG":
            return FeatureFlagEnum.UNKNOWN_FEATURE_FLAG;
        case 1:
        case "UNEXPIRE_OFFER_WITH_VALID_UNDERWRITING":
            return FeatureFlagEnum.UNEXPIRE_OFFER_WITH_VALID_UNDERWRITING;
        case -1:
        case "UNRECOGNIZED":
        default:
            return FeatureFlagEnum.UNRECOGNIZED;
    }
}
function featureFlagEnumToJSON(object) {
    switch(object){
        case FeatureFlagEnum.UNKNOWN_FEATURE_FLAG:
            return "UNKNOWN_FEATURE_FLAG";
        case FeatureFlagEnum.UNEXPIRE_OFFER_WITH_VALID_UNDERWRITING:
            return "UNEXPIRE_OFFER_WITH_VALID_UNDERWRITING";
        case FeatureFlagEnum.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var Reaction;
(function(Reaction) {
    Reaction[Reaction["VERY_UNSATISFIED"] = 0] = "VERY_UNSATISFIED";
    Reaction[Reaction["UNSATISFIED"] = 1] = "UNSATISFIED";
    Reaction[Reaction["OKAY"] = 2] = "OKAY";
    Reaction[Reaction["SATISFIED"] = 3] = "SATISFIED";
    Reaction[Reaction["VERY_SATISFIED"] = 4] = "VERY_SATISFIED";
    Reaction[Reaction["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Reaction || (Reaction = {}));
function reactionFromJSON(object) {
    switch(object){
        case 0:
        case "VERY_UNSATISFIED":
            return Reaction.VERY_UNSATISFIED;
        case 1:
        case "UNSATISFIED":
            return Reaction.UNSATISFIED;
        case 2:
        case "OKAY":
            return Reaction.OKAY;
        case 3:
        case "SATISFIED":
            return Reaction.SATISFIED;
        case 4:
        case "VERY_SATISFIED":
            return Reaction.VERY_SATISFIED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return Reaction.UNRECOGNIZED;
    }
}
function reactionToJSON(object) {
    switch(object){
        case Reaction.VERY_UNSATISFIED:
            return "VERY_UNSATISFIED";
        case Reaction.UNSATISFIED:
            return "UNSATISFIED";
        case Reaction.OKAY:
            return "OKAY";
        case Reaction.SATISFIED:
            return "SATISFIED";
        case Reaction.VERY_SATISFIED:
            return "VERY_SATISFIED";
        case Reaction.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var SpecialFlagType;
(function(SpecialFlagType) {
    SpecialFlagType[SpecialFlagType["DEFAULT"] = 0] = "DEFAULT";
    SpecialFlagType[SpecialFlagType["INFO"] = 1] = "INFO";
    SpecialFlagType[SpecialFlagType["SUCCESS"] = 2] = "SUCCESS";
    SpecialFlagType[SpecialFlagType["WARNING"] = 3] = "WARNING";
    SpecialFlagType[SpecialFlagType["DANGER"] = 4] = "DANGER";
    SpecialFlagType[SpecialFlagType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(SpecialFlagType || (SpecialFlagType = {}));
function specialFlagTypeFromJSON(object) {
    switch(object){
        case 0:
        case "DEFAULT":
            return SpecialFlagType.DEFAULT;
        case 1:
        case "INFO":
            return SpecialFlagType.INFO;
        case 2:
        case "SUCCESS":
            return SpecialFlagType.SUCCESS;
        case 3:
        case "WARNING":
            return SpecialFlagType.WARNING;
        case 4:
        case "DANGER":
            return SpecialFlagType.DANGER;
        case -1:
        case "UNRECOGNIZED":
        default:
            return SpecialFlagType.UNRECOGNIZED;
    }
}
function specialFlagTypeToJSON(object) {
    switch(object){
        case SpecialFlagType.DEFAULT:
            return "DEFAULT";
        case SpecialFlagType.INFO:
            return "INFO";
        case SpecialFlagType.SUCCESS:
            return "SUCCESS";
        case SpecialFlagType.WARNING:
            return "WARNING";
        case SpecialFlagType.DANGER:
            return "DANGER";
        case SpecialFlagType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var LowOfferConfidenceVariant;
(function(LowOfferConfidenceVariant) {
    LowOfferConfidenceVariant[LowOfferConfidenceVariant["UNKNOWN_VARIANT"] = 0] = "UNKNOWN_VARIANT";
    LowOfferConfidenceVariant[LowOfferConfidenceVariant["INELIGIBLE"] = 1] = "INELIGIBLE";
    LowOfferConfidenceVariant[LowOfferConfidenceVariant["CONTROL"] = 2] = "CONTROL";
    LowOfferConfidenceVariant[LowOfferConfidenceVariant["TREATMENT"] = 3] = "TREATMENT";
    LowOfferConfidenceVariant[LowOfferConfidenceVariant["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(LowOfferConfidenceVariant || (LowOfferConfidenceVariant = {}));
function lowOfferConfidenceVariantFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN_VARIANT":
            return LowOfferConfidenceVariant.UNKNOWN_VARIANT;
        case 1:
        case "INELIGIBLE":
            return LowOfferConfidenceVariant.INELIGIBLE;
        case 2:
        case "CONTROL":
            return LowOfferConfidenceVariant.CONTROL;
        case 3:
        case "TREATMENT":
            return LowOfferConfidenceVariant.TREATMENT;
        case -1:
        case "UNRECOGNIZED":
        default:
            return LowOfferConfidenceVariant.UNRECOGNIZED;
    }
}
function lowOfferConfidenceVariantToJSON(object) {
    switch(object){
        case LowOfferConfidenceVariant.UNKNOWN_VARIANT:
            return "UNKNOWN_VARIANT";
        case LowOfferConfidenceVariant.INELIGIBLE:
            return "INELIGIBLE";
        case LowOfferConfidenceVariant.CONTROL:
            return "CONTROL";
        case LowOfferConfidenceVariant.TREATMENT:
            return "TREATMENT";
        case LowOfferConfidenceVariant.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var offer_Offer_State;
(function(Offer_State) {
    Offer_State[Offer_State[/** UNKNOWN - States all defined in web/app/models/offer.rb */ "UNKNOWN"] = 0] = "UNKNOWN";
    Offer_State[Offer_State["DRAFT"] = 1] = "DRAFT";
    Offer_State[Offer_State["READY_TO_SEND"] = 2] = "READY_TO_SEND";
    Offer_State[Offer_State["SEND_IN_PROGRESS"] = 3] = "SEND_IN_PROGRESS";
    Offer_State[Offer_State["SENT"] = 4] = "SENT";
    Offer_State[Offer_State["VIEWING"] = 5] = "VIEWING";
    Offer_State[Offer_State["ACCEPTED_OFFER"] = 6] = "ACCEPTED_OFFER";
    Offer_State[Offer_State["ACCEPTED"] = 7] = "ACCEPTED";
    Offer_State[Offer_State["IN_CONTRACT"] = 8] = "IN_CONTRACT";
    Offer_State[Offer_State["CONTINGENCY_RELEASED"] = 9] = "CONTINGENCY_RELEASED";
    Offer_State[Offer_State["CLOSED"] = 10] = "CLOSED";
    Offer_State[Offer_State["WITHDRAWN"] = 11] = "WITHDRAWN";
    Offer_State[Offer_State["EXPIRED"] = 12] = "EXPIRED";
    Offer_State[Offer_State["REQUESTED_TO_LIST"] = 13] = "REQUESTED_TO_LIST";
    Offer_State[Offer_State[/** @deprecated */ "WAITING_FOR_OTHER_OFFERS"] = 14] = "WAITING_FOR_OTHER_OFFERS";
    Offer_State[Offer_State[/** @deprecated */ "WAITING_FOR_LIST_WITH_CERTAINTY"] = 15] = "WAITING_FOR_LIST_WITH_CERTAINTY";
    Offer_State[Offer_State[/** FINAL_OFFER_UNRELEASED - final offer is ready, but not yet released to the seller */ "FINAL_OFFER_UNRELEASED"] = 16] = "FINAL_OFFER_UNRELEASED";
    Offer_State[Offer_State["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(offer_Offer_State || (offer_Offer_State = {}));
function offer_offer_StateFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN":
            return offer_Offer_State.UNKNOWN;
        case 1:
        case "DRAFT":
            return offer_Offer_State.DRAFT;
        case 2:
        case "READY_TO_SEND":
            return offer_Offer_State.READY_TO_SEND;
        case 3:
        case "SEND_IN_PROGRESS":
            return offer_Offer_State.SEND_IN_PROGRESS;
        case 4:
        case "SENT":
            return offer_Offer_State.SENT;
        case 5:
        case "VIEWING":
            return offer_Offer_State.VIEWING;
        case 6:
        case "ACCEPTED_OFFER":
            return offer_Offer_State.ACCEPTED_OFFER;
        case 7:
        case "ACCEPTED":
            return offer_Offer_State.ACCEPTED;
        case 8:
        case "IN_CONTRACT":
            return offer_Offer_State.IN_CONTRACT;
        case 9:
        case "CONTINGENCY_RELEASED":
            return offer_Offer_State.CONTINGENCY_RELEASED;
        case 10:
        case "CLOSED":
            return offer_Offer_State.CLOSED;
        case 11:
        case "WITHDRAWN":
            return offer_Offer_State.WITHDRAWN;
        case 12:
        case "EXPIRED":
            return offer_Offer_State.EXPIRED;
        case 13:
        case "REQUESTED_TO_LIST":
            return offer_Offer_State.REQUESTED_TO_LIST;
        case 14:
        case "WAITING_FOR_OTHER_OFFERS":
            return offer_Offer_State.WAITING_FOR_OTHER_OFFERS;
        case 15:
        case "WAITING_FOR_LIST_WITH_CERTAINTY":
            return offer_Offer_State.WAITING_FOR_LIST_WITH_CERTAINTY;
        case 16:
        case "FINAL_OFFER_UNRELEASED":
            return offer_Offer_State.FINAL_OFFER_UNRELEASED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return offer_Offer_State.UNRECOGNIZED;
    }
}
function offer_offer_StateToJSON(object) {
    switch(object){
        case offer_Offer_State.UNKNOWN:
            return "UNKNOWN";
        case offer_Offer_State.DRAFT:
            return "DRAFT";
        case offer_Offer_State.READY_TO_SEND:
            return "READY_TO_SEND";
        case offer_Offer_State.SEND_IN_PROGRESS:
            return "SEND_IN_PROGRESS";
        case offer_Offer_State.SENT:
            return "SENT";
        case offer_Offer_State.VIEWING:
            return "VIEWING";
        case offer_Offer_State.ACCEPTED_OFFER:
            return "ACCEPTED_OFFER";
        case offer_Offer_State.ACCEPTED:
            return "ACCEPTED";
        case offer_Offer_State.IN_CONTRACT:
            return "IN_CONTRACT";
        case offer_Offer_State.CONTINGENCY_RELEASED:
            return "CONTINGENCY_RELEASED";
        case offer_Offer_State.CLOSED:
            return "CLOSED";
        case offer_Offer_State.WITHDRAWN:
            return "WITHDRAWN";
        case offer_Offer_State.EXPIRED:
            return "EXPIRED";
        case offer_Offer_State.REQUESTED_TO_LIST:
            return "REQUESTED_TO_LIST";
        case offer_Offer_State.WAITING_FOR_OTHER_OFFERS:
            return "WAITING_FOR_OTHER_OFFERS";
        case offer_Offer_State.WAITING_FOR_LIST_WITH_CERTAINTY:
            return "WAITING_FOR_LIST_WITH_CERTAINTY";
        case offer_Offer_State.FINAL_OFFER_UNRELEASED:
            return "FINAL_OFFER_UNRELEASED";
        case offer_Offer_State.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
function offer_createBaseOffer() {
    return {
        id: "",
        state: 0,
        acceptedAt: undefined,
        buyerExpiresAt: undefined,
        closedDate: undefined,
        closedAt: undefined,
        contingenciesReleasedDate: undefined,
        contingenciesReleasedAt: undefined,
        enteredContractAt: undefined,
        expiredAt: undefined,
        sentAt: undefined,
        viewedAt: undefined,
        withdrawnAt: undefined,
        coBrokePercentage: undefined,
        headlinePriceCents: 0,
        netProceedsCents: 0,
        closingCostsCents: 0,
        closingCostsPercentage: undefined,
        serviceChargeCents: 0,
        serviceChargePercentage: undefined,
        sellerVisibleValuationRangeStartCents: 0,
        sellerVisibleValuationRangeEndCents: 0,
        internalFeeCents: 0,
        initialInspectionAt: undefined,
        comps: [],
        underwritingId: "",
        isFirstOffer: false,
        coeDate: undefined,
        closeEscrowDate: undefined,
        enabledExperiments: [],
        maxRepairCostsEstimateCents: 0,
        canChangeCloseEscrowDate: false,
        coeDateChangeDeadline: undefined,
        closeEscrowDateChangeDeadline: undefined,
        hasPostInspectionExperience: false,
        purchaseAgreementExpiresAt: undefined,
        token: "",
        purchaseAgreementCompletedAt: undefined,
        createdAt: undefined,
        offerDashboardUrl: "",
        experiencePartner: undefined,
        customerExperiencePartner: undefined,
        interestedInTradeIn: false,
        tradeInSavingsCents: 0,
        preliminaryOfferExpirationDate: undefined,
        enabledFeatureFlags: [],
        numericId: 0,
        leadToken: "",
        occupancyAtVa: 0,
        offerReactions: [],
        addressId: "",
        finalOfferViewedAt: undefined,
        offerReviewAt: undefined,
        lateCheckoutDate: undefined,
        titleContact: undefined,
        titleOrg: undefined,
        signatories: [],
        offerRequestSource: 0,
        lateCheckout: undefined,
        lateCheckoutSecurityDepositCents: 0,
        listingEstimateCeilingCents: 0,
        listingEstimateFloorCents: 0,
        estimatedNetListingProceedsCents: undefined,
        expirationInfo: undefined,
        offerDashboardInternalUrl: "",
        isLatestOffer: false,
        coeAvailableDatesInternal: [],
        sellerCredits: [],
        listingPriceEstimateCents: 0,
        offerConfidenceLevel: "",
        numberOfOffers: 0,
        scheduleHomeAssessmentUrl: "",
        arvCents: 0,
        acquisitionUnderwritingPeId: "",
        canRefreshFinalOfferWithUnderwriting: false,
        netPriceCents: 0,
        postRepairValuationCents: undefined,
        experiments: {}
    };
}
var offer_Offer = {
    fromJSON: function fromJSON(object) {
        return {
            id: data_offer_isSet(object.id) ? String(object.id) : "",
            state: data_offer_isSet(object.state) ? offer_offer_StateFromJSON(object.state) : 0,
            acceptedAt: data_offer_isSet(object.acceptedAt) ? data_offer_fromJsonTimestamp(object.acceptedAt) : undefined,
            buyerExpiresAt: data_offer_isSet(object.buyerExpiresAt) ? data_offer_fromJsonTimestamp(object.buyerExpiresAt) : undefined,
            closedDate: data_offer_isSet(object.closedDate) ? DateMessage.fromJSON(object.closedDate) : undefined,
            closedAt: data_offer_isSet(object.closedAt) ? data_offer_fromJsonTimestamp(object.closedAt) : undefined,
            contingenciesReleasedDate: data_offer_isSet(object.contingenciesReleasedDate) ? DateMessage.fromJSON(object.contingenciesReleasedDate) : undefined,
            contingenciesReleasedAt: data_offer_isSet(object.contingenciesReleasedAt) ? data_offer_fromJsonTimestamp(object.contingenciesReleasedAt) : undefined,
            enteredContractAt: data_offer_isSet(object.enteredContractAt) ? data_offer_fromJsonTimestamp(object.enteredContractAt) : undefined,
            expiredAt: data_offer_isSet(object.expiredAt) ? data_offer_fromJsonTimestamp(object.expiredAt) : undefined,
            sentAt: data_offer_isSet(object.sentAt) ? data_offer_fromJsonTimestamp(object.sentAt) : undefined,
            viewedAt: data_offer_isSet(object.viewedAt) ? data_offer_fromJsonTimestamp(object.viewedAt) : undefined,
            withdrawnAt: data_offer_isSet(object.withdrawnAt) ? data_offer_fromJsonTimestamp(object.withdrawnAt) : undefined,
            coBrokePercentage: data_offer_isSet(object.coBrokePercentage) ? Number(object.coBrokePercentage) : undefined,
            headlinePriceCents: data_offer_isSet(object.headlinePriceCents) ? Number(object.headlinePriceCents) : 0,
            netProceedsCents: data_offer_isSet(object.netProceedsCents) ? Number(object.netProceedsCents) : 0,
            closingCostsCents: data_offer_isSet(object.closingCostsCents) ? Number(object.closingCostsCents) : 0,
            closingCostsPercentage: data_offer_isSet(object.closingCostsPercentage) ? Number(object.closingCostsPercentage) : undefined,
            serviceChargeCents: data_offer_isSet(object.serviceChargeCents) ? Number(object.serviceChargeCents) : 0,
            serviceChargePercentage: data_offer_isSet(object.serviceChargePercentage) ? Number(object.serviceChargePercentage) : undefined,
            sellerVisibleValuationRangeStartCents: data_offer_isSet(object.sellerVisibleValuationRangeStartCents) ? Number(object.sellerVisibleValuationRangeStartCents) : 0,
            sellerVisibleValuationRangeEndCents: data_offer_isSet(object.sellerVisibleValuationRangeEndCents) ? Number(object.sellerVisibleValuationRangeEndCents) : 0,
            internalFeeCents: data_offer_isSet(object.internalFeeCents) ? Number(object.internalFeeCents) : 0,
            initialInspectionAt: data_offer_isSet(object.initialInspectionAt) ? data_offer_fromJsonTimestamp(object.initialInspectionAt) : undefined,
            comps: Array.isArray(object === null || object === void 0 ? void 0 : object.comps) ? object.comps.map(function(e) {
                return comp_Comp.fromJSON(e);
            }) : [],
            underwritingId: data_offer_isSet(object.underwritingId) ? String(object.underwritingId) : "",
            isFirstOffer: data_offer_isSet(object.isFirstOffer) ? Boolean(object.isFirstOffer) : false,
            coeDate: data_offer_isSet(object.coeDate) ? DateMessage.fromJSON(object.coeDate) : undefined,
            closeEscrowDate: data_offer_isSet(object.closeEscrowDate) ? data_offer_fromJsonTimestamp(object.closeEscrowDate) : undefined,
            enabledExperiments: Array.isArray(object === null || object === void 0 ? void 0 : object.enabledExperiments) ? object.enabledExperiments.map(function(e) {
                return Experiment.fromJSON(e);
            }) : [],
            maxRepairCostsEstimateCents: data_offer_isSet(object.maxRepairCostsEstimateCents) ? Number(object.maxRepairCostsEstimateCents) : 0,
            canChangeCloseEscrowDate: data_offer_isSet(object.canChangeCloseEscrowDate) ? Boolean(object.canChangeCloseEscrowDate) : false,
            coeDateChangeDeadline: data_offer_isSet(object.coeDateChangeDeadline) ? DateMessage.fromJSON(object.coeDateChangeDeadline) : undefined,
            closeEscrowDateChangeDeadline: data_offer_isSet(object.closeEscrowDateChangeDeadline) ? data_offer_fromJsonTimestamp(object.closeEscrowDateChangeDeadline) : undefined,
            hasPostInspectionExperience: data_offer_isSet(object.hasPostInspectionExperience) ? Boolean(object.hasPostInspectionExperience) : false,
            purchaseAgreementExpiresAt: data_offer_isSet(object.purchaseAgreementExpiresAt) ? data_offer_fromJsonTimestamp(object.purchaseAgreementExpiresAt) : undefined,
            token: data_offer_isSet(object.token) ? String(object.token) : "",
            purchaseAgreementCompletedAt: data_offer_isSet(object.purchaseAgreementCompletedAt) ? data_offer_fromJsonTimestamp(object.purchaseAgreementCompletedAt) : undefined,
            createdAt: data_offer_isSet(object.createdAt) ? data_offer_fromJsonTimestamp(object.createdAt) : undefined,
            offerDashboardUrl: data_offer_isSet(object.offerDashboardUrl) ? String(object.offerDashboardUrl) : "",
            experiencePartner: data_offer_isSet(object.experiencePartner) ? ExperiencePartner.fromJSON(object.experiencePartner) : undefined,
            customerExperiencePartner: data_offer_isSet(object.customerExperiencePartner) ? ExperiencePartner.fromJSON(object.customerExperiencePartner) : undefined,
            interestedInTradeIn: data_offer_isSet(object.interestedInTradeIn) ? Boolean(object.interestedInTradeIn) : false,
            tradeInSavingsCents: data_offer_isSet(object.tradeInSavingsCents) ? Number(object.tradeInSavingsCents) : 0,
            preliminaryOfferExpirationDate: data_offer_isSet(object.preliminaryOfferExpirationDate) ? data_offer_fromJsonTimestamp(object.preliminaryOfferExpirationDate) : undefined,
            enabledFeatureFlags: Array.isArray(object === null || object === void 0 ? void 0 : object.enabledFeatureFlags) ? object.enabledFeatureFlags.map(function(e) {
                return FeatureFlag.fromJSON(e);
            }) : [],
            numericId: data_offer_isSet(object.numericId) ? Number(object.numericId) : 0,
            leadToken: data_offer_isSet(object.leadToken) ? String(object.leadToken) : "",
            occupancyAtVa: data_offer_isSet(object.occupancyAtVa) ? occupancyAtVaFromJSON(object.occupancyAtVa) : 0,
            offerReactions: Array.isArray(object === null || object === void 0 ? void 0 : object.offerReactions) ? object.offerReactions.map(function(e) {
                return OfferReaction.fromJSON(e);
            }) : [],
            addressId: data_offer_isSet(object.addressId) ? String(object.addressId) : "",
            finalOfferViewedAt: data_offer_isSet(object.finalOfferViewedAt) ? data_offer_fromJsonTimestamp(object.finalOfferViewedAt) : undefined,
            offerReviewAt: data_offer_isSet(object.offerReviewAt) ? data_offer_fromJsonTimestamp(object.offerReviewAt) : undefined,
            lateCheckoutDate: data_offer_isSet(object.lateCheckoutDate) ? DateMessage.fromJSON(object.lateCheckoutDate) : undefined,
            titleContact: data_offer_isSet(object.titleContact) ? TitleContact.fromJSON(object.titleContact) : undefined,
            titleOrg: data_offer_isSet(object.titleOrg) ? TitleOrganization.fromJSON(object.titleOrg) : undefined,
            signatories: Array.isArray(object === null || object === void 0 ? void 0 : object.signatories) ? object.signatories.map(function(e) {
                return Signatory.fromJSON(e);
            }) : [],
            offerRequestSource: data_offer_isSet(object.offerRequestSource) ? offerRequest_SourceFromJSON(object.offerRequestSource) : 0,
            lateCheckout: data_offer_isSet(object.lateCheckout) ? LateCheckout.fromJSON(object.lateCheckout) : undefined,
            lateCheckoutSecurityDepositCents: data_offer_isSet(object.lateCheckoutSecurityDepositCents) ? Number(object.lateCheckoutSecurityDepositCents) : 0,
            listingEstimateCeilingCents: data_offer_isSet(object.listingEstimateCeilingCents) ? Number(object.listingEstimateCeilingCents) : 0,
            listingEstimateFloorCents: data_offer_isSet(object.listingEstimateFloorCents) ? Number(object.listingEstimateFloorCents) : 0,
            estimatedNetListingProceedsCents: data_offer_isSet(object.estimatedNetListingProceedsCents) ? Number(object.estimatedNetListingProceedsCents) : undefined,
            expirationInfo: data_offer_isSet(object.expirationInfo) ? ExpirationInfo.fromJSON(object.expirationInfo) : undefined,
            offerDashboardInternalUrl: data_offer_isSet(object.offerDashboardInternalUrl) ? String(object.offerDashboardInternalUrl) : "",
            isLatestOffer: data_offer_isSet(object.isLatestOffer) ? Boolean(object.isLatestOffer) : false,
            coeAvailableDatesInternal: Array.isArray(object === null || object === void 0 ? void 0 : object.coeAvailableDatesInternal) ? object.coeAvailableDatesInternal.map(function(e) {
                return DateMessage.fromJSON(e);
            }) : [],
            sellerCredits: Array.isArray(object === null || object === void 0 ? void 0 : object.sellerCredits) ? object.sellerCredits.map(function(e) {
                return Subsidy.fromJSON(e);
            }) : [],
            listingPriceEstimateCents: data_offer_isSet(object.listingPriceEstimateCents) ? Number(object.listingPriceEstimateCents) : 0,
            offerConfidenceLevel: data_offer_isSet(object.offerConfidenceLevel) ? String(object.offerConfidenceLevel) : "",
            numberOfOffers: data_offer_isSet(object.numberOfOffers) ? Number(object.numberOfOffers) : 0,
            scheduleHomeAssessmentUrl: data_offer_isSet(object.scheduleHomeAssessmentUrl) ? String(object.scheduleHomeAssessmentUrl) : "",
            arvCents: data_offer_isSet(object.arvCents) ? Number(object.arvCents) : 0,
            acquisitionUnderwritingPeId: data_offer_isSet(object.acquisitionUnderwritingPeId) ? String(object.acquisitionUnderwritingPeId) : "",
            canRefreshFinalOfferWithUnderwriting: data_offer_isSet(object.canRefreshFinalOfferWithUnderwriting) ? Boolean(object.canRefreshFinalOfferWithUnderwriting) : false,
            netPriceCents: data_offer_isSet(object.netPriceCents) ? Number(object.netPriceCents) : 0,
            postRepairValuationCents: data_offer_isSet(object.postRepairValuationCents) ? Number(object.postRepairValuationCents) : undefined,
            experiments: offer_isObject(object.experiments) ? Object.entries(object.experiments).reduce(function(acc, param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
                acc[key] = ExperimentValue.fromJSON(value);
                return acc;
            }, {}) : {}
        };
    },
    toJSON: function toJSON(message) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6;
        var obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.state !== 0) {
            obj.state = offer_offer_StateToJSON(message.state);
        }
        if (message.acceptedAt !== undefined) {
            obj.acceptedAt = message.acceptedAt.toISOString();
        }
        if (message.buyerExpiresAt !== undefined) {
            obj.buyerExpiresAt = message.buyerExpiresAt.toISOString();
        }
        if (message.closedDate !== undefined) {
            obj.closedDate = DateMessage.toJSON(message.closedDate);
        }
        if (message.closedAt !== undefined) {
            obj.closedAt = message.closedAt.toISOString();
        }
        if (message.contingenciesReleasedDate !== undefined) {
            obj.contingenciesReleasedDate = DateMessage.toJSON(message.contingenciesReleasedDate);
        }
        if (message.contingenciesReleasedAt !== undefined) {
            obj.contingenciesReleasedAt = message.contingenciesReleasedAt.toISOString();
        }
        if (message.enteredContractAt !== undefined) {
            obj.enteredContractAt = message.enteredContractAt.toISOString();
        }
        if (message.expiredAt !== undefined) {
            obj.expiredAt = message.expiredAt.toISOString();
        }
        if (message.sentAt !== undefined) {
            obj.sentAt = message.sentAt.toISOString();
        }
        if (message.viewedAt !== undefined) {
            obj.viewedAt = message.viewedAt.toISOString();
        }
        if (message.withdrawnAt !== undefined) {
            obj.withdrawnAt = message.withdrawnAt.toISOString();
        }
        if (message.coBrokePercentage !== undefined) {
            obj.coBrokePercentage = message.coBrokePercentage;
        }
        if (message.headlinePriceCents !== 0) {
            obj.headlinePriceCents = Math.round(message.headlinePriceCents);
        }
        if (message.netProceedsCents !== 0) {
            obj.netProceedsCents = Math.round(message.netProceedsCents);
        }
        if (message.closingCostsCents !== 0) {
            obj.closingCostsCents = Math.round(message.closingCostsCents);
        }
        if (message.closingCostsPercentage !== undefined) {
            obj.closingCostsPercentage = message.closingCostsPercentage;
        }
        if (message.serviceChargeCents !== 0) {
            obj.serviceChargeCents = Math.round(message.serviceChargeCents);
        }
        if (message.serviceChargePercentage !== undefined) {
            obj.serviceChargePercentage = message.serviceChargePercentage;
        }
        if (message.sellerVisibleValuationRangeStartCents !== 0) {
            obj.sellerVisibleValuationRangeStartCents = Math.round(message.sellerVisibleValuationRangeStartCents);
        }
        if (message.sellerVisibleValuationRangeEndCents !== 0) {
            obj.sellerVisibleValuationRangeEndCents = Math.round(message.sellerVisibleValuationRangeEndCents);
        }
        if (message.internalFeeCents !== 0) {
            obj.internalFeeCents = Math.round(message.internalFeeCents);
        }
        if (message.initialInspectionAt !== undefined) {
            obj.initialInspectionAt = message.initialInspectionAt.toISOString();
        }
        if ((ref = message.comps) === null || ref === void 0 ? void 0 : ref.length) {
            obj.comps = message.comps.map(function(e) {
                return comp_Comp.toJSON(e);
            });
        }
        if (message.underwritingId !== "") {
            obj.underwritingId = message.underwritingId;
        }
        if (message.isFirstOffer === true) {
            obj.isFirstOffer = message.isFirstOffer;
        }
        if (message.coeDate !== undefined) {
            obj.coeDate = DateMessage.toJSON(message.coeDate);
        }
        if (message.closeEscrowDate !== undefined) {
            obj.closeEscrowDate = message.closeEscrowDate.toISOString();
        }
        if ((ref1 = message.enabledExperiments) === null || ref1 === void 0 ? void 0 : ref1.length) {
            obj.enabledExperiments = message.enabledExperiments.map(function(e) {
                return Experiment.toJSON(e);
            });
        }
        if (message.maxRepairCostsEstimateCents !== 0) {
            obj.maxRepairCostsEstimateCents = Math.round(message.maxRepairCostsEstimateCents);
        }
        if (message.canChangeCloseEscrowDate === true) {
            obj.canChangeCloseEscrowDate = message.canChangeCloseEscrowDate;
        }
        if (message.coeDateChangeDeadline !== undefined) {
            obj.coeDateChangeDeadline = DateMessage.toJSON(message.coeDateChangeDeadline);
        }
        if (message.closeEscrowDateChangeDeadline !== undefined) {
            obj.closeEscrowDateChangeDeadline = message.closeEscrowDateChangeDeadline.toISOString();
        }
        if (message.hasPostInspectionExperience === true) {
            obj.hasPostInspectionExperience = message.hasPostInspectionExperience;
        }
        if (message.purchaseAgreementExpiresAt !== undefined) {
            obj.purchaseAgreementExpiresAt = message.purchaseAgreementExpiresAt.toISOString();
        }
        if (message.token !== "") {
            obj.token = message.token;
        }
        if (message.purchaseAgreementCompletedAt !== undefined) {
            obj.purchaseAgreementCompletedAt = message.purchaseAgreementCompletedAt.toISOString();
        }
        if (message.createdAt !== undefined) {
            obj.createdAt = message.createdAt.toISOString();
        }
        if (message.offerDashboardUrl !== "") {
            obj.offerDashboardUrl = message.offerDashboardUrl;
        }
        if (message.experiencePartner !== undefined) {
            obj.experiencePartner = ExperiencePartner.toJSON(message.experiencePartner);
        }
        if (message.customerExperiencePartner !== undefined) {
            obj.customerExperiencePartner = ExperiencePartner.toJSON(message.customerExperiencePartner);
        }
        if (message.interestedInTradeIn === true) {
            obj.interestedInTradeIn = message.interestedInTradeIn;
        }
        if (message.tradeInSavingsCents !== 0) {
            obj.tradeInSavingsCents = Math.round(message.tradeInSavingsCents);
        }
        if (message.preliminaryOfferExpirationDate !== undefined) {
            obj.preliminaryOfferExpirationDate = message.preliminaryOfferExpirationDate.toISOString();
        }
        if ((ref2 = message.enabledFeatureFlags) === null || ref2 === void 0 ? void 0 : ref2.length) {
            obj.enabledFeatureFlags = message.enabledFeatureFlags.map(function(e) {
                return FeatureFlag.toJSON(e);
            });
        }
        if (message.numericId !== 0) {
            obj.numericId = Math.round(message.numericId);
        }
        if (message.leadToken !== "") {
            obj.leadToken = message.leadToken;
        }
        if (message.occupancyAtVa !== 0) {
            obj.occupancyAtVa = occupancyAtVaToJSON(message.occupancyAtVa);
        }
        if ((ref3 = message.offerReactions) === null || ref3 === void 0 ? void 0 : ref3.length) {
            obj.offerReactions = message.offerReactions.map(function(e) {
                return OfferReaction.toJSON(e);
            });
        }
        if (message.addressId !== "") {
            obj.addressId = message.addressId;
        }
        if (message.finalOfferViewedAt !== undefined) {
            obj.finalOfferViewedAt = message.finalOfferViewedAt.toISOString();
        }
        if (message.offerReviewAt !== undefined) {
            obj.offerReviewAt = message.offerReviewAt.toISOString();
        }
        if (message.lateCheckoutDate !== undefined) {
            obj.lateCheckoutDate = DateMessage.toJSON(message.lateCheckoutDate);
        }
        if (message.titleContact !== undefined) {
            obj.titleContact = TitleContact.toJSON(message.titleContact);
        }
        if (message.titleOrg !== undefined) {
            obj.titleOrg = TitleOrganization.toJSON(message.titleOrg);
        }
        if ((ref4 = message.signatories) === null || ref4 === void 0 ? void 0 : ref4.length) {
            obj.signatories = message.signatories.map(function(e) {
                return Signatory.toJSON(e);
            });
        }
        if (message.offerRequestSource !== 0) {
            obj.offerRequestSource = offerRequest_SourceToJSON(message.offerRequestSource);
        }
        if (message.lateCheckout !== undefined) {
            obj.lateCheckout = LateCheckout.toJSON(message.lateCheckout);
        }
        if (message.lateCheckoutSecurityDepositCents !== 0) {
            obj.lateCheckoutSecurityDepositCents = Math.round(message.lateCheckoutSecurityDepositCents);
        }
        if (message.listingEstimateCeilingCents !== 0) {
            obj.listingEstimateCeilingCents = Math.round(message.listingEstimateCeilingCents);
        }
        if (message.listingEstimateFloorCents !== 0) {
            obj.listingEstimateFloorCents = Math.round(message.listingEstimateFloorCents);
        }
        if (message.estimatedNetListingProceedsCents !== undefined) {
            obj.estimatedNetListingProceedsCents = message.estimatedNetListingProceedsCents;
        }
        if (message.expirationInfo !== undefined) {
            obj.expirationInfo = ExpirationInfo.toJSON(message.expirationInfo);
        }
        if (message.offerDashboardInternalUrl !== "") {
            obj.offerDashboardInternalUrl = message.offerDashboardInternalUrl;
        }
        if (message.isLatestOffer === true) {
            obj.isLatestOffer = message.isLatestOffer;
        }
        if ((ref5 = message.coeAvailableDatesInternal) === null || ref5 === void 0 ? void 0 : ref5.length) {
            obj.coeAvailableDatesInternal = message.coeAvailableDatesInternal.map(function(e) {
                return DateMessage.toJSON(e);
            });
        }
        if ((ref6 = message.sellerCredits) === null || ref6 === void 0 ? void 0 : ref6.length) {
            obj.sellerCredits = message.sellerCredits.map(function(e) {
                return Subsidy.toJSON(e);
            });
        }
        if (message.listingPriceEstimateCents !== 0) {
            obj.listingPriceEstimateCents = Math.round(message.listingPriceEstimateCents);
        }
        if (message.offerConfidenceLevel !== "") {
            obj.offerConfidenceLevel = message.offerConfidenceLevel;
        }
        if (message.numberOfOffers !== 0) {
            obj.numberOfOffers = Math.round(message.numberOfOffers);
        }
        if (message.scheduleHomeAssessmentUrl !== "") {
            obj.scheduleHomeAssessmentUrl = message.scheduleHomeAssessmentUrl;
        }
        if (message.arvCents !== 0) {
            obj.arvCents = Math.round(message.arvCents);
        }
        if (message.acquisitionUnderwritingPeId !== "") {
            obj.acquisitionUnderwritingPeId = message.acquisitionUnderwritingPeId;
        }
        if (message.canRefreshFinalOfferWithUnderwriting === true) {
            obj.canRefreshFinalOfferWithUnderwriting = message.canRefreshFinalOfferWithUnderwriting;
        }
        if (message.netPriceCents !== 0) {
            obj.netPriceCents = Math.round(message.netPriceCents);
        }
        if (message.postRepairValuationCents !== undefined) {
            obj.postRepairValuationCents = message.postRepairValuationCents;
        }
        if (message.experiments) {
            var entries = Object.entries(message.experiments);
            if (entries.length > 0) {
                obj.experiments = {};
                entries.forEach(function(param) {
                    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), k = _param[0], v = _param[1];
                    obj.experiments[k] = ExperimentValue.toJSON(v);
                });
            }
        }
        return obj;
    },
    create: function create(base) {
        return offer_Offer.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6;
        var message = offer_createBaseOffer();
        var _id;
        message.id = (_id = object.id) !== null && _id !== void 0 ? _id : "";
        var _state;
        message.state = (_state = object.state) !== null && _state !== void 0 ? _state : 0;
        var _acceptedAt;
        message.acceptedAt = (_acceptedAt = object.acceptedAt) !== null && _acceptedAt !== void 0 ? _acceptedAt : undefined;
        var _buyerExpiresAt;
        message.buyerExpiresAt = (_buyerExpiresAt = object.buyerExpiresAt) !== null && _buyerExpiresAt !== void 0 ? _buyerExpiresAt : undefined;
        message.closedDate = object.closedDate !== undefined && object.closedDate !== null ? DateMessage.fromPartial(object.closedDate) : undefined;
        var _closedAt;
        message.closedAt = (_closedAt = object.closedAt) !== null && _closedAt !== void 0 ? _closedAt : undefined;
        message.contingenciesReleasedDate = object.contingenciesReleasedDate !== undefined && object.contingenciesReleasedDate !== null ? DateMessage.fromPartial(object.contingenciesReleasedDate) : undefined;
        var _contingenciesReleasedAt;
        message.contingenciesReleasedAt = (_contingenciesReleasedAt = object.contingenciesReleasedAt) !== null && _contingenciesReleasedAt !== void 0 ? _contingenciesReleasedAt : undefined;
        var _enteredContractAt;
        message.enteredContractAt = (_enteredContractAt = object.enteredContractAt) !== null && _enteredContractAt !== void 0 ? _enteredContractAt : undefined;
        var _expiredAt;
        message.expiredAt = (_expiredAt = object.expiredAt) !== null && _expiredAt !== void 0 ? _expiredAt : undefined;
        var _sentAt;
        message.sentAt = (_sentAt = object.sentAt) !== null && _sentAt !== void 0 ? _sentAt : undefined;
        var _viewedAt;
        message.viewedAt = (_viewedAt = object.viewedAt) !== null && _viewedAt !== void 0 ? _viewedAt : undefined;
        var _withdrawnAt;
        message.withdrawnAt = (_withdrawnAt = object.withdrawnAt) !== null && _withdrawnAt !== void 0 ? _withdrawnAt : undefined;
        var _coBrokePercentage;
        message.coBrokePercentage = (_coBrokePercentage = object.coBrokePercentage) !== null && _coBrokePercentage !== void 0 ? _coBrokePercentage : undefined;
        var _headlinePriceCents;
        message.headlinePriceCents = (_headlinePriceCents = object.headlinePriceCents) !== null && _headlinePriceCents !== void 0 ? _headlinePriceCents : 0;
        var _netProceedsCents;
        message.netProceedsCents = (_netProceedsCents = object.netProceedsCents) !== null && _netProceedsCents !== void 0 ? _netProceedsCents : 0;
        var _closingCostsCents;
        message.closingCostsCents = (_closingCostsCents = object.closingCostsCents) !== null && _closingCostsCents !== void 0 ? _closingCostsCents : 0;
        var _closingCostsPercentage;
        message.closingCostsPercentage = (_closingCostsPercentage = object.closingCostsPercentage) !== null && _closingCostsPercentage !== void 0 ? _closingCostsPercentage : undefined;
        var _serviceChargeCents;
        message.serviceChargeCents = (_serviceChargeCents = object.serviceChargeCents) !== null && _serviceChargeCents !== void 0 ? _serviceChargeCents : 0;
        var _serviceChargePercentage;
        message.serviceChargePercentage = (_serviceChargePercentage = object.serviceChargePercentage) !== null && _serviceChargePercentage !== void 0 ? _serviceChargePercentage : undefined;
        var _sellerVisibleValuationRangeStartCents;
        message.sellerVisibleValuationRangeStartCents = (_sellerVisibleValuationRangeStartCents = object.sellerVisibleValuationRangeStartCents) !== null && _sellerVisibleValuationRangeStartCents !== void 0 ? _sellerVisibleValuationRangeStartCents : 0;
        var _sellerVisibleValuationRangeEndCents;
        message.sellerVisibleValuationRangeEndCents = (_sellerVisibleValuationRangeEndCents = object.sellerVisibleValuationRangeEndCents) !== null && _sellerVisibleValuationRangeEndCents !== void 0 ? _sellerVisibleValuationRangeEndCents : 0;
        var _internalFeeCents;
        message.internalFeeCents = (_internalFeeCents = object.internalFeeCents) !== null && _internalFeeCents !== void 0 ? _internalFeeCents : 0;
        var _initialInspectionAt;
        message.initialInspectionAt = (_initialInspectionAt = object.initialInspectionAt) !== null && _initialInspectionAt !== void 0 ? _initialInspectionAt : undefined;
        message.comps = ((ref = object.comps) === null || ref === void 0 ? void 0 : ref.map(function(e) {
            return comp_Comp.fromPartial(e);
        })) || [];
        var _underwritingId;
        message.underwritingId = (_underwritingId = object.underwritingId) !== null && _underwritingId !== void 0 ? _underwritingId : "";
        var _isFirstOffer;
        message.isFirstOffer = (_isFirstOffer = object.isFirstOffer) !== null && _isFirstOffer !== void 0 ? _isFirstOffer : false;
        message.coeDate = object.coeDate !== undefined && object.coeDate !== null ? DateMessage.fromPartial(object.coeDate) : undefined;
        var _closeEscrowDate;
        message.closeEscrowDate = (_closeEscrowDate = object.closeEscrowDate) !== null && _closeEscrowDate !== void 0 ? _closeEscrowDate : undefined;
        message.enabledExperiments = ((ref1 = object.enabledExperiments) === null || ref1 === void 0 ? void 0 : ref1.map(function(e) {
            return Experiment.fromPartial(e);
        })) || [];
        var _maxRepairCostsEstimateCents;
        message.maxRepairCostsEstimateCents = (_maxRepairCostsEstimateCents = object.maxRepairCostsEstimateCents) !== null && _maxRepairCostsEstimateCents !== void 0 ? _maxRepairCostsEstimateCents : 0;
        var _canChangeCloseEscrowDate;
        message.canChangeCloseEscrowDate = (_canChangeCloseEscrowDate = object.canChangeCloseEscrowDate) !== null && _canChangeCloseEscrowDate !== void 0 ? _canChangeCloseEscrowDate : false;
        message.coeDateChangeDeadline = object.coeDateChangeDeadline !== undefined && object.coeDateChangeDeadline !== null ? DateMessage.fromPartial(object.coeDateChangeDeadline) : undefined;
        var _closeEscrowDateChangeDeadline;
        message.closeEscrowDateChangeDeadline = (_closeEscrowDateChangeDeadline = object.closeEscrowDateChangeDeadline) !== null && _closeEscrowDateChangeDeadline !== void 0 ? _closeEscrowDateChangeDeadline : undefined;
        var _hasPostInspectionExperience;
        message.hasPostInspectionExperience = (_hasPostInspectionExperience = object.hasPostInspectionExperience) !== null && _hasPostInspectionExperience !== void 0 ? _hasPostInspectionExperience : false;
        var _purchaseAgreementExpiresAt;
        message.purchaseAgreementExpiresAt = (_purchaseAgreementExpiresAt = object.purchaseAgreementExpiresAt) !== null && _purchaseAgreementExpiresAt !== void 0 ? _purchaseAgreementExpiresAt : undefined;
        var _token;
        message.token = (_token = object.token) !== null && _token !== void 0 ? _token : "";
        var _purchaseAgreementCompletedAt;
        message.purchaseAgreementCompletedAt = (_purchaseAgreementCompletedAt = object.purchaseAgreementCompletedAt) !== null && _purchaseAgreementCompletedAt !== void 0 ? _purchaseAgreementCompletedAt : undefined;
        var _createdAt;
        message.createdAt = (_createdAt = object.createdAt) !== null && _createdAt !== void 0 ? _createdAt : undefined;
        var _offerDashboardUrl;
        message.offerDashboardUrl = (_offerDashboardUrl = object.offerDashboardUrl) !== null && _offerDashboardUrl !== void 0 ? _offerDashboardUrl : "";
        message.experiencePartner = object.experiencePartner !== undefined && object.experiencePartner !== null ? ExperiencePartner.fromPartial(object.experiencePartner) : undefined;
        message.customerExperiencePartner = object.customerExperiencePartner !== undefined && object.customerExperiencePartner !== null ? ExperiencePartner.fromPartial(object.customerExperiencePartner) : undefined;
        var _interestedInTradeIn;
        message.interestedInTradeIn = (_interestedInTradeIn = object.interestedInTradeIn) !== null && _interestedInTradeIn !== void 0 ? _interestedInTradeIn : false;
        var _tradeInSavingsCents;
        message.tradeInSavingsCents = (_tradeInSavingsCents = object.tradeInSavingsCents) !== null && _tradeInSavingsCents !== void 0 ? _tradeInSavingsCents : 0;
        var _preliminaryOfferExpirationDate;
        message.preliminaryOfferExpirationDate = (_preliminaryOfferExpirationDate = object.preliminaryOfferExpirationDate) !== null && _preliminaryOfferExpirationDate !== void 0 ? _preliminaryOfferExpirationDate : undefined;
        message.enabledFeatureFlags = ((ref2 = object.enabledFeatureFlags) === null || ref2 === void 0 ? void 0 : ref2.map(function(e) {
            return FeatureFlag.fromPartial(e);
        })) || [];
        var _numericId;
        message.numericId = (_numericId = object.numericId) !== null && _numericId !== void 0 ? _numericId : 0;
        var _leadToken;
        message.leadToken = (_leadToken = object.leadToken) !== null && _leadToken !== void 0 ? _leadToken : "";
        var _occupancyAtVa;
        message.occupancyAtVa = (_occupancyAtVa = object.occupancyAtVa) !== null && _occupancyAtVa !== void 0 ? _occupancyAtVa : 0;
        message.offerReactions = ((ref3 = object.offerReactions) === null || ref3 === void 0 ? void 0 : ref3.map(function(e) {
            return OfferReaction.fromPartial(e);
        })) || [];
        var _addressId;
        message.addressId = (_addressId = object.addressId) !== null && _addressId !== void 0 ? _addressId : "";
        var _finalOfferViewedAt;
        message.finalOfferViewedAt = (_finalOfferViewedAt = object.finalOfferViewedAt) !== null && _finalOfferViewedAt !== void 0 ? _finalOfferViewedAt : undefined;
        var _offerReviewAt;
        message.offerReviewAt = (_offerReviewAt = object.offerReviewAt) !== null && _offerReviewAt !== void 0 ? _offerReviewAt : undefined;
        message.lateCheckoutDate = object.lateCheckoutDate !== undefined && object.lateCheckoutDate !== null ? DateMessage.fromPartial(object.lateCheckoutDate) : undefined;
        message.titleContact = object.titleContact !== undefined && object.titleContact !== null ? TitleContact.fromPartial(object.titleContact) : undefined;
        message.titleOrg = object.titleOrg !== undefined && object.titleOrg !== null ? TitleOrganization.fromPartial(object.titleOrg) : undefined;
        message.signatories = ((ref4 = object.signatories) === null || ref4 === void 0 ? void 0 : ref4.map(function(e) {
            return Signatory.fromPartial(e);
        })) || [];
        var _offerRequestSource;
        message.offerRequestSource = (_offerRequestSource = object.offerRequestSource) !== null && _offerRequestSource !== void 0 ? _offerRequestSource : 0;
        message.lateCheckout = object.lateCheckout !== undefined && object.lateCheckout !== null ? LateCheckout.fromPartial(object.lateCheckout) : undefined;
        var _lateCheckoutSecurityDepositCents;
        message.lateCheckoutSecurityDepositCents = (_lateCheckoutSecurityDepositCents = object.lateCheckoutSecurityDepositCents) !== null && _lateCheckoutSecurityDepositCents !== void 0 ? _lateCheckoutSecurityDepositCents : 0;
        var _listingEstimateCeilingCents;
        message.listingEstimateCeilingCents = (_listingEstimateCeilingCents = object.listingEstimateCeilingCents) !== null && _listingEstimateCeilingCents !== void 0 ? _listingEstimateCeilingCents : 0;
        var _listingEstimateFloorCents;
        message.listingEstimateFloorCents = (_listingEstimateFloorCents = object.listingEstimateFloorCents) !== null && _listingEstimateFloorCents !== void 0 ? _listingEstimateFloorCents : 0;
        var _estimatedNetListingProceedsCents;
        message.estimatedNetListingProceedsCents = (_estimatedNetListingProceedsCents = object.estimatedNetListingProceedsCents) !== null && _estimatedNetListingProceedsCents !== void 0 ? _estimatedNetListingProceedsCents : undefined;
        message.expirationInfo = object.expirationInfo !== undefined && object.expirationInfo !== null ? ExpirationInfo.fromPartial(object.expirationInfo) : undefined;
        var _offerDashboardInternalUrl;
        message.offerDashboardInternalUrl = (_offerDashboardInternalUrl = object.offerDashboardInternalUrl) !== null && _offerDashboardInternalUrl !== void 0 ? _offerDashboardInternalUrl : "";
        var _isLatestOffer;
        message.isLatestOffer = (_isLatestOffer = object.isLatestOffer) !== null && _isLatestOffer !== void 0 ? _isLatestOffer : false;
        message.coeAvailableDatesInternal = ((ref5 = object.coeAvailableDatesInternal) === null || ref5 === void 0 ? void 0 : ref5.map(function(e) {
            return DateMessage.fromPartial(e);
        })) || [];
        message.sellerCredits = ((ref6 = object.sellerCredits) === null || ref6 === void 0 ? void 0 : ref6.map(function(e) {
            return Subsidy.fromPartial(e);
        })) || [];
        var _listingPriceEstimateCents;
        message.listingPriceEstimateCents = (_listingPriceEstimateCents = object.listingPriceEstimateCents) !== null && _listingPriceEstimateCents !== void 0 ? _listingPriceEstimateCents : 0;
        var _offerConfidenceLevel;
        message.offerConfidenceLevel = (_offerConfidenceLevel = object.offerConfidenceLevel) !== null && _offerConfidenceLevel !== void 0 ? _offerConfidenceLevel : "";
        var _numberOfOffers;
        message.numberOfOffers = (_numberOfOffers = object.numberOfOffers) !== null && _numberOfOffers !== void 0 ? _numberOfOffers : 0;
        var _scheduleHomeAssessmentUrl;
        message.scheduleHomeAssessmentUrl = (_scheduleHomeAssessmentUrl = object.scheduleHomeAssessmentUrl) !== null && _scheduleHomeAssessmentUrl !== void 0 ? _scheduleHomeAssessmentUrl : "";
        var _arvCents;
        message.arvCents = (_arvCents = object.arvCents) !== null && _arvCents !== void 0 ? _arvCents : 0;
        var _acquisitionUnderwritingPeId;
        message.acquisitionUnderwritingPeId = (_acquisitionUnderwritingPeId = object.acquisitionUnderwritingPeId) !== null && _acquisitionUnderwritingPeId !== void 0 ? _acquisitionUnderwritingPeId : "";
        var _canRefreshFinalOfferWithUnderwriting;
        message.canRefreshFinalOfferWithUnderwriting = (_canRefreshFinalOfferWithUnderwriting = object.canRefreshFinalOfferWithUnderwriting) !== null && _canRefreshFinalOfferWithUnderwriting !== void 0 ? _canRefreshFinalOfferWithUnderwriting : false;
        var _netPriceCents;
        message.netPriceCents = (_netPriceCents = object.netPriceCents) !== null && _netPriceCents !== void 0 ? _netPriceCents : 0;
        var _postRepairValuationCents;
        message.postRepairValuationCents = (_postRepairValuationCents = object.postRepairValuationCents) !== null && _postRepairValuationCents !== void 0 ? _postRepairValuationCents : undefined;
        var _experiments;
        message.experiments = Object.entries((_experiments = object.experiments) !== null && _experiments !== void 0 ? _experiments : {}).reduce(function(acc, param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
            if (value !== undefined) {
                acc[key] = ExperimentValue.fromPartial(value);
            }
            return acc;
        }, {});
        return message;
    }
};
function createBaseOffer_ExperimentsEntry() {
    return {
        key: "",
        value: undefined
    };
}
var Offer_ExperimentsEntry = {
    fromJSON: function fromJSON(object) {
        return {
            key: data_offer_isSet(object.key) ? String(object.key) : "",
            value: data_offer_isSet(object.value) ? ExperimentValue.fromJSON(object.value) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.key !== "") {
            obj.key = message.key;
        }
        if (message.value !== undefined) {
            obj.value = ExperimentValue.toJSON(message.value);
        }
        return obj;
    },
    create: function create(base) {
        return Offer_ExperimentsEntry.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseOffer_ExperimentsEntry();
        var _key;
        message.key = (_key = object.key) !== null && _key !== void 0 ? _key : "";
        message.value = object.value !== undefined && object.value !== null ? ExperimentValue.fromPartial(object.value) : undefined;
        return message;
    }
};
function createBaseExperimentValue() {
    return {
        value: undefined
    };
}
var ExperimentValue = {
    fromJSON: function fromJSON(object) {
        return {
            value: data_offer_isSet(object.booleanValue) ? {
                $case: "booleanValue",
                booleanValue: Boolean(object.booleanValue)
            } : data_offer_isSet(object.stringValue) ? {
                $case: "stringValue",
                stringValue: String(object.stringValue)
            } : data_offer_isSet(object.data) ? {
                $case: "data",
                data: object.data
            } : undefined
        };
    },
    toJSON: function toJSON(message) {
        var ref, ref1, ref2;
        var obj = {};
        if (((ref = message.value) === null || ref === void 0 ? void 0 : ref.$case) === "booleanValue") {
            obj.booleanValue = message.value.booleanValue;
        }
        if (((ref1 = message.value) === null || ref1 === void 0 ? void 0 : ref1.$case) === "stringValue") {
            obj.stringValue = message.value.stringValue;
        }
        if (((ref2 = message.value) === null || ref2 === void 0 ? void 0 : ref2.$case) === "data") {
            obj.data = message.value.data;
        }
        return obj;
    },
    create: function create(base) {
        return ExperimentValue.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
        var message = createBaseExperimentValue();
        if (((ref = object.value) === null || ref === void 0 ? void 0 : ref.$case) === "booleanValue" && ((ref1 = object.value) === null || ref1 === void 0 ? void 0 : ref1.booleanValue) !== undefined && ((ref2 = object.value) === null || ref2 === void 0 ? void 0 : ref2.booleanValue) !== null) {
            message.value = {
                $case: "booleanValue",
                booleanValue: object.value.booleanValue
            };
        }
        if (((ref3 = object.value) === null || ref3 === void 0 ? void 0 : ref3.$case) === "stringValue" && ((ref4 = object.value) === null || ref4 === void 0 ? void 0 : ref4.stringValue) !== undefined && ((ref5 = object.value) === null || ref5 === void 0 ? void 0 : ref5.stringValue) !== null) {
            message.value = {
                $case: "stringValue",
                stringValue: object.value.stringValue
            };
        }
        if (((ref6 = object.value) === null || ref6 === void 0 ? void 0 : ref6.$case) === "data" && ((ref7 = object.value) === null || ref7 === void 0 ? void 0 : ref7.data) !== undefined && ((ref8 = object.value) === null || ref8 === void 0 ? void 0 : ref8.data) !== null) {
            message.value = {
                $case: "data",
                data: object.value.data
            };
        }
        return message;
    }
};
function createBaseExpirationInfo() {
    return {
        date: undefined,
        nextStep: ""
    };
}
var ExpirationInfo = {
    fromJSON: function fromJSON(object) {
        return {
            date: data_offer_isSet(object.date) ? data_offer_fromJsonTimestamp(object.date) : undefined,
            nextStep: data_offer_isSet(object.nextStep) ? String(object.nextStep) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.date !== undefined) {
            obj.date = message.date.toISOString();
        }
        if (message.nextStep !== "") {
            obj.nextStep = message.nextStep;
        }
        return obj;
    },
    create: function create(base) {
        return ExpirationInfo.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseExpirationInfo();
        var _date;
        message.date = (_date = object.date) !== null && _date !== void 0 ? _date : undefined;
        var _nextStep;
        message.nextStep = (_nextStep = object.nextStep) !== null && _nextStep !== void 0 ? _nextStep : "";
        return message;
    }
};
function createBaseExperiment() {
    return {
        experimentEnum: 0
    };
}
var Experiment = {
    fromJSON: function fromJSON(object) {
        return {
            experimentEnum: data_offer_isSet(object.experimentEnum) ? experimentsEnumFromJSON(object.experimentEnum) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.experimentEnum !== 0) {
            obj.experimentEnum = experimentsEnumToJSON(message.experimentEnum);
        }
        return obj;
    },
    create: function create(base) {
        return Experiment.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseExperiment();
        var _experimentEnum;
        message.experimentEnum = (_experimentEnum = object.experimentEnum) !== null && _experimentEnum !== void 0 ? _experimentEnum : 0;
        return message;
    }
};
function createBaseFeatureFlag() {
    return {
        featureFlag: 0
    };
}
var FeatureFlag = {
    fromJSON: function fromJSON(object) {
        return {
            featureFlag: data_offer_isSet(object.featureFlag) ? featureFlagEnumFromJSON(object.featureFlag) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.featureFlag !== 0) {
            obj.featureFlag = featureFlagEnumToJSON(message.featureFlag);
        }
        return obj;
    },
    create: function create(base) {
        return FeatureFlag.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseFeatureFlag();
        var _featureFlag;
        message.featureFlag = (_featureFlag = object.featureFlag) !== null && _featureFlag !== void 0 ? _featureFlag : 0;
        return message;
    }
};
function createBaseOfferIdentifiers() {
    return {
        identifiers: []
    };
}
var OfferIdentifiers = {
    fromJSON: function fromJSON(object) {
        return {
            identifiers: Array.isArray(object === null || object === void 0 ? void 0 : object.identifiers) ? object.identifiers.map(function(e) {
                return String(e);
            }) : []
        };
    },
    toJSON: function toJSON(message) {
        var ref;
        var obj = {};
        if ((ref = message.identifiers) === null || ref === void 0 ? void 0 : ref.length) {
            obj.identifiers = message.identifiers;
        }
        return obj;
    },
    create: function create(base) {
        return OfferIdentifiers.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref;
        var message = createBaseOfferIdentifiers();
        message.identifiers = ((ref = object.identifiers) === null || ref === void 0 ? void 0 : ref.map(function(e) {
            return e;
        })) || [];
        return message;
    }
};
function createBaseOfferQueryParams() {
    return {
        addressToken: "",
        customerUuid: "",
        humanToken: ""
    };
}
var OfferQueryParams = {
    fromJSON: function fromJSON(object) {
        return {
            addressToken: data_offer_isSet(object.addressToken) ? String(object.addressToken) : "",
            customerUuid: data_offer_isSet(object.customerUuid) ? String(object.customerUuid) : "",
            humanToken: data_offer_isSet(object.humanToken) ? String(object.humanToken) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.addressToken !== "") {
            obj.addressToken = message.addressToken;
        }
        if (message.customerUuid !== "") {
            obj.customerUuid = message.customerUuid;
        }
        if (message.humanToken !== "") {
            obj.humanToken = message.humanToken;
        }
        return obj;
    },
    create: function create(base) {
        return OfferQueryParams.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseOfferQueryParams();
        var _addressToken;
        message.addressToken = (_addressToken = object.addressToken) !== null && _addressToken !== void 0 ? _addressToken : "";
        var _customerUuid;
        message.customerUuid = (_customerUuid = object.customerUuid) !== null && _customerUuid !== void 0 ? _customerUuid : "";
        var _humanToken;
        message.humanToken = (_humanToken = object.humanToken) !== null && _humanToken !== void 0 ? _humanToken : "";
        return message;
    }
};
function createBaseOfferReaction() {
    return {
        reaction: 0,
        humanToken: "",
        textResponse: ""
    };
}
var OfferReaction = {
    fromJSON: function fromJSON(object) {
        return {
            reaction: data_offer_isSet(object.reaction) ? reactionFromJSON(object.reaction) : 0,
            humanToken: data_offer_isSet(object.humanToken) ? String(object.humanToken) : "",
            textResponse: data_offer_isSet(object.textResponse) ? String(object.textResponse) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.reaction !== 0) {
            obj.reaction = reactionToJSON(message.reaction);
        }
        if (message.humanToken !== "") {
            obj.humanToken = message.humanToken;
        }
        if (message.textResponse !== "") {
            obj.textResponse = message.textResponse;
        }
        return obj;
    },
    create: function create(base) {
        return OfferReaction.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseOfferReaction();
        var _reaction;
        message.reaction = (_reaction = object.reaction) !== null && _reaction !== void 0 ? _reaction : 0;
        var _humanToken;
        message.humanToken = (_humanToken = object.humanToken) !== null && _humanToken !== void 0 ? _humanToken : "";
        var _textResponse;
        message.textResponse = (_textResponse = object.textResponse) !== null && _textResponse !== void 0 ? _textResponse : "";
        return message;
    }
};
function createBaseSignatory() {
    return {
        name: ""
    };
}
var Signatory = {
    fromJSON: function fromJSON(object) {
        return {
            name: data_offer_isSet(object.name) ? String(object.name) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.name !== "") {
            obj.name = message.name;
        }
        return obj;
    },
    create: function create(base) {
        return Signatory.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseSignatory();
        var _name;
        message.name = (_name = object.name) !== null && _name !== void 0 ? _name : "";
        return message;
    }
};
function createBasePrivateOfferData() {
    return {
        specialFlags: [],
        internalFeePercentage: undefined,
        finalOfferHoldReason: ""
    };
}
var PrivateOfferData = {
    fromJSON: function fromJSON(object) {
        return {
            specialFlags: Array.isArray(object === null || object === void 0 ? void 0 : object.specialFlags) ? object.specialFlags.map(function(e) {
                return SpecialFlag.fromJSON(e);
            }) : [],
            internalFeePercentage: data_offer_isSet(object.internalFeePercentage) ? Number(object.internalFeePercentage) : undefined,
            finalOfferHoldReason: data_offer_isSet(object.finalOfferHoldReason) ? String(object.finalOfferHoldReason) : ""
        };
    },
    toJSON: function toJSON(message) {
        var ref;
        var obj = {};
        if ((ref = message.specialFlags) === null || ref === void 0 ? void 0 : ref.length) {
            obj.specialFlags = message.specialFlags.map(function(e) {
                return SpecialFlag.toJSON(e);
            });
        }
        if (message.internalFeePercentage !== undefined) {
            obj.internalFeePercentage = message.internalFeePercentage;
        }
        if (message.finalOfferHoldReason !== "") {
            obj.finalOfferHoldReason = message.finalOfferHoldReason;
        }
        return obj;
    },
    create: function create(base) {
        return PrivateOfferData.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref;
        var message = createBasePrivateOfferData();
        message.specialFlags = ((ref = object.specialFlags) === null || ref === void 0 ? void 0 : ref.map(function(e) {
            return SpecialFlag.fromPartial(e);
        })) || [];
        var _internalFeePercentage;
        message.internalFeePercentage = (_internalFeePercentage = object.internalFeePercentage) !== null && _internalFeePercentage !== void 0 ? _internalFeePercentage : undefined;
        var _finalOfferHoldReason;
        message.finalOfferHoldReason = (_finalOfferHoldReason = object.finalOfferHoldReason) !== null && _finalOfferHoldReason !== void 0 ? _finalOfferHoldReason : "";
        return message;
    }
};
function createBaseSpecialFlag() {
    return {
        text: "",
        type: 0
    };
}
var SpecialFlag = {
    fromJSON: function fromJSON(object) {
        return {
            text: data_offer_isSet(object.text) ? String(object.text) : "",
            type: data_offer_isSet(object.type) ? specialFlagTypeFromJSON(object.type) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.text !== "") {
            obj.text = message.text;
        }
        if (message.type !== 0) {
            obj.type = specialFlagTypeToJSON(message.type);
        }
        return obj;
    },
    create: function create(base) {
        return SpecialFlag.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseSpecialFlag();
        var _text;
        message.text = (_text = object.text) !== null && _text !== void 0 ? _text : "";
        var _type;
        message.type = (_type = object.type) !== null && _type !== void 0 ? _type : 0;
        return message;
    }
};
function createBaseOfferDataForIterable() {
    return {
        sellerLeadUuid: "",
        offerRequestSource: 0,
        valuationCents: 0
    };
}
var OfferDataForIterable = {
    fromJSON: function fromJSON(object) {
        return {
            sellerLeadUuid: data_offer_isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : "",
            offerRequestSource: data_offer_isSet(object.offerRequestSource) ? offerRequest_SourceFromJSON(object.offerRequestSource) : 0,
            valuationCents: data_offer_isSet(object.valuationCents) ? Number(object.valuationCents) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.sellerLeadUuid !== "") {
            obj.sellerLeadUuid = message.sellerLeadUuid;
        }
        if (message.offerRequestSource !== 0) {
            obj.offerRequestSource = offerRequest_SourceToJSON(message.offerRequestSource);
        }
        if (message.valuationCents !== 0) {
            obj.valuationCents = Math.round(message.valuationCents);
        }
        return obj;
    },
    create: function create(base) {
        return OfferDataForIterable.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseOfferDataForIterable();
        var _sellerLeadUuid;
        message.sellerLeadUuid = (_sellerLeadUuid = object.sellerLeadUuid) !== null && _sellerLeadUuid !== void 0 ? _sellerLeadUuid : "";
        var _offerRequestSource;
        message.offerRequestSource = (_offerRequestSource = object.offerRequestSource) !== null && _offerRequestSource !== void 0 ? _offerRequestSource : 0;
        var _valuationCents;
        message.valuationCents = (_valuationCents = object.valuationCents) !== null && _valuationCents !== void 0 ? _valuationCents : 0;
        return message;
    }
};
function data_offer_fromTimestamp(t) {
    var millis = (t.seconds || 0) * 1000;
    millis += (t.nanos || 0) / 1000000;
    return new Date(millis);
}
function data_offer_fromJsonTimestamp(o) {
    if ((0,_instanceof/* default */.Z)(o, Date)) {
        return o;
    } else if (typeof o === "string") {
        return new Date(o);
    } else {
        return data_offer_fromTimestamp(Timestamp.fromJSON(o));
    }
}
function offer_isObject(value) {
    return typeof value === "object" && value !== null;
}
function data_offer_isSet(value) {
    return value !== null && value !== undefined;
}

;// CONCATENATED MODULE: ./src/__generated__/protobuf/journey/data/categories/sell_va_category.ts
/* eslint-disable */ 
var sell_va_category_protobufPackage = "od_protos.journey.data.categories";
var SellVACategory_VAType;
(function(SellVACategory_VAType) {
    SellVACategory_VAType[SellVACategory_VAType["UNKNOWN_VA_TYPE"] = 0] = "UNKNOWN_VA_TYPE";
    SellVACategory_VAType[SellVACategory_VAType["ORVA"] = 1] = "ORVA";
    SellVACategory_VAType[SellVACategory_VAType["SSVA"] = 2] = "SSVA";
    SellVACategory_VAType[SellVACategory_VAType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(SellVACategory_VAType || (SellVACategory_VAType = {}));
function sellVACategory_VATypeFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN_VA_TYPE":
            return SellVACategory_VAType.UNKNOWN_VA_TYPE;
        case 1:
        case "ORVA":
            return SellVACategory_VAType.ORVA;
        case 2:
        case "SSVA":
            return SellVACategory_VAType.SSVA;
        case -1:
        case "UNRECOGNIZED":
        default:
            return SellVACategory_VAType.UNRECOGNIZED;
    }
}
function sellVACategory_VATypeToJSON(object) {
    switch(object){
        case SellVACategory_VAType.UNKNOWN_VA_TYPE:
            return "UNKNOWN_VA_TYPE";
        case SellVACategory_VAType.ORVA:
            return "ORVA";
        case SellVACategory_VAType.SSVA:
            return "SSVA";
        case SellVACategory_VAType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
function createBaseSellVACategory() {
    return {
        event: undefined
    };
}
var SellVACategory = {
    fromJSON: function fromJSON(object) {
        return {
            event: sell_va_category_isSet(object.flowStart) ? {
                $case: "flowStart",
                flowStart: SellVACategory_FlowStartEvent.fromJSON(object.flowStart)
            } : sell_va_category_isSet(object.start) ? {
                $case: "start",
                start: SellVACategory_StartEvent.fromJSON(object.start)
            } : sell_va_category_isSet(object.complete) ? {
                $case: "complete",
                complete: SellVACategory_CompleteEvent.fromJSON(object.complete)
            } : sell_va_category_isSet(object.occupancy) ? {
                $case: "occupancy",
                occupancy: SellVACategory_OccupancyEvent.fromJSON(object.occupancy)
            } : undefined
        };
    },
    toJSON: function toJSON(message) {
        var ref, ref1, ref2, ref3;
        var obj = {};
        if (((ref = message.event) === null || ref === void 0 ? void 0 : ref.$case) === "flowStart") {
            obj.flowStart = SellVACategory_FlowStartEvent.toJSON(message.event.flowStart);
        }
        if (((ref1 = message.event) === null || ref1 === void 0 ? void 0 : ref1.$case) === "start") {
            obj.start = SellVACategory_StartEvent.toJSON(message.event.start);
        }
        if (((ref2 = message.event) === null || ref2 === void 0 ? void 0 : ref2.$case) === "complete") {
            obj.complete = SellVACategory_CompleteEvent.toJSON(message.event.complete);
        }
        if (((ref3 = message.event) === null || ref3 === void 0 ? void 0 : ref3.$case) === "occupancy") {
            obj.occupancy = SellVACategory_OccupancyEvent.toJSON(message.event.occupancy);
        }
        return obj;
    },
    create: function create(base) {
        return SellVACategory.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
        var message = createBaseSellVACategory();
        if (((ref = object.event) === null || ref === void 0 ? void 0 : ref.$case) === "flowStart" && ((ref1 = object.event) === null || ref1 === void 0 ? void 0 : ref1.flowStart) !== undefined && ((ref2 = object.event) === null || ref2 === void 0 ? void 0 : ref2.flowStart) !== null) {
            message.event = {
                $case: "flowStart",
                flowStart: SellVACategory_FlowStartEvent.fromPartial(object.event.flowStart)
            };
        }
        if (((ref3 = object.event) === null || ref3 === void 0 ? void 0 : ref3.$case) === "start" && ((ref4 = object.event) === null || ref4 === void 0 ? void 0 : ref4.start) !== undefined && ((ref5 = object.event) === null || ref5 === void 0 ? void 0 : ref5.start) !== null) {
            message.event = {
                $case: "start",
                start: SellVACategory_StartEvent.fromPartial(object.event.start)
            };
        }
        if (((ref6 = object.event) === null || ref6 === void 0 ? void 0 : ref6.$case) === "complete" && ((ref7 = object.event) === null || ref7 === void 0 ? void 0 : ref7.complete) !== undefined && ((ref8 = object.event) === null || ref8 === void 0 ? void 0 : ref8.complete) !== null) {
            message.event = {
                $case: "complete",
                complete: SellVACategory_CompleteEvent.fromPartial(object.event.complete)
            };
        }
        if (((ref9 = object.event) === null || ref9 === void 0 ? void 0 : ref9.$case) === "occupancy" && ((ref10 = object.event) === null || ref10 === void 0 ? void 0 : ref10.occupancy) !== undefined && ((ref11 = object.event) === null || ref11 === void 0 ? void 0 : ref11.occupancy) !== null) {
            message.event = {
                $case: "occupancy",
                occupancy: SellVACategory_OccupancyEvent.fromPartial(object.event.occupancy)
            };
        }
        return message;
    }
};
function createBaseSellVACategory_FlowStartEvent() {
    return {
        leadId: "",
        offerId: "",
        offerUuid: "",
        sellerLeadUuid: ""
    };
}
var SellVACategory_FlowStartEvent = {
    fromJSON: function fromJSON(object) {
        return {
            leadId: sell_va_category_isSet(object.leadId) ? String(object.leadId) : "",
            offerId: sell_va_category_isSet(object.offerId) ? String(object.offerId) : "",
            offerUuid: sell_va_category_isSet(object.offerUuid) ? String(object.offerUuid) : "",
            sellerLeadUuid: sell_va_category_isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.leadId !== "") {
            obj.leadId = message.leadId;
        }
        if (message.offerId !== "") {
            obj.offerId = message.offerId;
        }
        if (message.offerUuid !== "") {
            obj.offerUuid = message.offerUuid;
        }
        if (message.sellerLeadUuid !== "") {
            obj.sellerLeadUuid = message.sellerLeadUuid;
        }
        return obj;
    },
    create: function create(base) {
        return SellVACategory_FlowStartEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseSellVACategory_FlowStartEvent();
        var _leadId;
        message.leadId = (_leadId = object.leadId) !== null && _leadId !== void 0 ? _leadId : "";
        var _offerId;
        message.offerId = (_offerId = object.offerId) !== null && _offerId !== void 0 ? _offerId : "";
        var _offerUuid;
        message.offerUuid = (_offerUuid = object.offerUuid) !== null && _offerUuid !== void 0 ? _offerUuid : "";
        var _sellerLeadUuid;
        message.sellerLeadUuid = (_sellerLeadUuid = object.sellerLeadUuid) !== null && _sellerLeadUuid !== void 0 ? _sellerLeadUuid : "";
        return message;
    }
};
function createBaseSellVACategory_OccupancyEvent() {
    return {
        leadId: "",
        offerUuid: "",
        occupancy: 0,
        sellerLeadUuid: ""
    };
}
var SellVACategory_OccupancyEvent = {
    fromJSON: function fromJSON(object) {
        return {
            leadId: sell_va_category_isSet(object.leadId) ? String(object.leadId) : "",
            offerUuid: sell_va_category_isSet(object.offerUuid) ? String(object.offerUuid) : "",
            occupancy: sell_va_category_isSet(object.occupancy) ? occupancyAtVaFromJSON(object.occupancy) : 0,
            sellerLeadUuid: sell_va_category_isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.leadId !== "") {
            obj.leadId = message.leadId;
        }
        if (message.offerUuid !== "") {
            obj.offerUuid = message.offerUuid;
        }
        if (message.occupancy !== 0) {
            obj.occupancy = occupancyAtVaToJSON(message.occupancy);
        }
        if (message.sellerLeadUuid !== "") {
            obj.sellerLeadUuid = message.sellerLeadUuid;
        }
        return obj;
    },
    create: function create(base) {
        return SellVACategory_OccupancyEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseSellVACategory_OccupancyEvent();
        var _leadId;
        message.leadId = (_leadId = object.leadId) !== null && _leadId !== void 0 ? _leadId : "";
        var _offerUuid;
        message.offerUuid = (_offerUuid = object.offerUuid) !== null && _offerUuid !== void 0 ? _offerUuid : "";
        var _occupancy;
        message.occupancy = (_occupancy = object.occupancy) !== null && _occupancy !== void 0 ? _occupancy : 0;
        var _sellerLeadUuid;
        message.sellerLeadUuid = (_sellerLeadUuid = object.sellerLeadUuid) !== null && _sellerLeadUuid !== void 0 ? _sellerLeadUuid : "";
        return message;
    }
};
function createBaseSellVACategory_StartEvent() {
    return {
        leadId: "",
        offerId: "",
        vaType: 0,
        offerUuid: "",
        sellerLeadUuid: ""
    };
}
var SellVACategory_StartEvent = {
    fromJSON: function fromJSON(object) {
        return {
            leadId: sell_va_category_isSet(object.leadId) ? String(object.leadId) : "",
            offerId: sell_va_category_isSet(object.offerId) ? String(object.offerId) : "",
            vaType: sell_va_category_isSet(object.vaType) ? sellVACategory_VATypeFromJSON(object.vaType) : 0,
            offerUuid: sell_va_category_isSet(object.offerUuid) ? String(object.offerUuid) : "",
            sellerLeadUuid: sell_va_category_isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.leadId !== "") {
            obj.leadId = message.leadId;
        }
        if (message.offerId !== "") {
            obj.offerId = message.offerId;
        }
        if (message.vaType !== 0) {
            obj.vaType = sellVACategory_VATypeToJSON(message.vaType);
        }
        if (message.offerUuid !== "") {
            obj.offerUuid = message.offerUuid;
        }
        if (message.sellerLeadUuid !== "") {
            obj.sellerLeadUuid = message.sellerLeadUuid;
        }
        return obj;
    },
    create: function create(base) {
        return SellVACategory_StartEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseSellVACategory_StartEvent();
        var _leadId;
        message.leadId = (_leadId = object.leadId) !== null && _leadId !== void 0 ? _leadId : "";
        var _offerId;
        message.offerId = (_offerId = object.offerId) !== null && _offerId !== void 0 ? _offerId : "";
        var _vaType;
        message.vaType = (_vaType = object.vaType) !== null && _vaType !== void 0 ? _vaType : 0;
        var _offerUuid;
        message.offerUuid = (_offerUuid = object.offerUuid) !== null && _offerUuid !== void 0 ? _offerUuid : "";
        var _sellerLeadUuid;
        message.sellerLeadUuid = (_sellerLeadUuid = object.sellerLeadUuid) !== null && _sellerLeadUuid !== void 0 ? _sellerLeadUuid : "";
        return message;
    }
};
function createBaseSellVACategory_CompleteEvent() {
    return {
        leadId: "",
        offerId: "",
        vaType: 0,
        offerUuid: "",
        sellerLeadUuid: ""
    };
}
var SellVACategory_CompleteEvent = {
    fromJSON: function fromJSON(object) {
        return {
            leadId: sell_va_category_isSet(object.leadId) ? String(object.leadId) : "",
            offerId: sell_va_category_isSet(object.offerId) ? String(object.offerId) : "",
            vaType: sell_va_category_isSet(object.vaType) ? sellVACategory_VATypeFromJSON(object.vaType) : 0,
            offerUuid: sell_va_category_isSet(object.offerUuid) ? String(object.offerUuid) : "",
            sellerLeadUuid: sell_va_category_isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.leadId !== "") {
            obj.leadId = message.leadId;
        }
        if (message.offerId !== "") {
            obj.offerId = message.offerId;
        }
        if (message.vaType !== 0) {
            obj.vaType = sellVACategory_VATypeToJSON(message.vaType);
        }
        if (message.offerUuid !== "") {
            obj.offerUuid = message.offerUuid;
        }
        if (message.sellerLeadUuid !== "") {
            obj.sellerLeadUuid = message.sellerLeadUuid;
        }
        return obj;
    },
    create: function create(base) {
        return SellVACategory_CompleteEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseSellVACategory_CompleteEvent();
        var _leadId;
        message.leadId = (_leadId = object.leadId) !== null && _leadId !== void 0 ? _leadId : "";
        var _offerId;
        message.offerId = (_offerId = object.offerId) !== null && _offerId !== void 0 ? _offerId : "";
        var _vaType;
        message.vaType = (_vaType = object.vaType) !== null && _vaType !== void 0 ? _vaType : 0;
        var _offerUuid;
        message.offerUuid = (_offerUuid = object.offerUuid) !== null && _offerUuid !== void 0 ? _offerUuid : "";
        var _sellerLeadUuid;
        message.sellerLeadUuid = (_sellerLeadUuid = object.sellerLeadUuid) !== null && _sellerLeadUuid !== void 0 ? _sellerLeadUuid : "";
        return message;
    }
};
function sell_va_category_isSet(value) {
    return value !== null && value !== undefined;
}

;// CONCATENATED MODULE: ./src/__generated__/protobuf/journey/data/categories/sell_with_upside_category.ts
/* eslint-disable */ var sell_with_upside_category_protobufPackage = "od_protos.journey.data.categories";
var SellWithUpsideCategory_QualificationEvent_QualificationDecision;
(function(SellWithUpsideCategory_QualificationEvent_QualificationDecision) {
    SellWithUpsideCategory_QualificationEvent_QualificationDecision[SellWithUpsideCategory_QualificationEvent_QualificationDecision["UNKNOWN"] = 0] = "UNKNOWN";
    SellWithUpsideCategory_QualificationEvent_QualificationDecision[SellWithUpsideCategory_QualificationEvent_QualificationDecision["PRODUCT_QUALIFIED"] = 1] = "PRODUCT_QUALIFIED";
    SellWithUpsideCategory_QualificationEvent_QualificationDecision[SellWithUpsideCategory_QualificationEvent_QualificationDecision["PRODUCT_DENIED"] = 2] = "PRODUCT_DENIED";
    SellWithUpsideCategory_QualificationEvent_QualificationDecision[SellWithUpsideCategory_QualificationEvent_QualificationDecision["PRODUCT_UNDENIED"] = 3] = "PRODUCT_UNDENIED";
    SellWithUpsideCategory_QualificationEvent_QualificationDecision[SellWithUpsideCategory_QualificationEvent_QualificationDecision["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(SellWithUpsideCategory_QualificationEvent_QualificationDecision || (SellWithUpsideCategory_QualificationEvent_QualificationDecision = {}));
function sellWithUpsideCategory_QualificationEvent_QualificationDecisionFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN":
            return SellWithUpsideCategory_QualificationEvent_QualificationDecision.UNKNOWN;
        case 1:
        case "PRODUCT_QUALIFIED":
            return SellWithUpsideCategory_QualificationEvent_QualificationDecision.PRODUCT_QUALIFIED;
        case 2:
        case "PRODUCT_DENIED":
            return SellWithUpsideCategory_QualificationEvent_QualificationDecision.PRODUCT_DENIED;
        case 3:
        case "PRODUCT_UNDENIED":
            return SellWithUpsideCategory_QualificationEvent_QualificationDecision.PRODUCT_UNDENIED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return SellWithUpsideCategory_QualificationEvent_QualificationDecision.UNRECOGNIZED;
    }
}
function sellWithUpsideCategory_QualificationEvent_QualificationDecisionToJSON(object) {
    switch(object){
        case SellWithUpsideCategory_QualificationEvent_QualificationDecision.UNKNOWN:
            return "UNKNOWN";
        case SellWithUpsideCategory_QualificationEvent_QualificationDecision.PRODUCT_QUALIFIED:
            return "PRODUCT_QUALIFIED";
        case SellWithUpsideCategory_QualificationEvent_QualificationDecision.PRODUCT_DENIED:
            return "PRODUCT_DENIED";
        case SellWithUpsideCategory_QualificationEvent_QualificationDecision.PRODUCT_UNDENIED:
            return "PRODUCT_UNDENIED";
        case SellWithUpsideCategory_QualificationEvent_QualificationDecision.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
function createBaseSellWithUpsideCategory() {
    return {
        event: undefined
    };
}
var SellWithUpsideCategory = {
    fromJSON: function fromJSON(object) {
        return {
            event: sell_with_upside_category_isSet(object.qualification) ? {
                $case: "qualification",
                qualification: SellWithUpsideCategory_QualificationEvent.fromJSON(object.qualification)
            } : sell_with_upside_category_isSet(object.upfrontCashChange) ? {
                $case: "upfrontCashChange",
                upfrontCashChange: SellWithUpsideCategory_UpfrontCashChangeEvent.fromJSON(object.upfrontCashChange)
            } : sell_with_upside_category_isSet(object.estimatedSalesPriceChange) ? {
                $case: "estimatedSalesPriceChange",
                estimatedSalesPriceChange: SellWithUpsideCategory_EstimatedSalesPriceChangeEvent.fromJSON(object.estimatedSalesPriceChange)
            } : sell_with_upside_category_isSet(object.pricingOptionsLoaded) ? {
                $case: "pricingOptionsLoaded",
                pricingOptionsLoaded: SellWithUpsideCategory_PricingOptionsLoadedEvent.fromJSON(object.pricingOptionsLoaded)
            } : undefined
        };
    },
    toJSON: function toJSON(message) {
        var ref, ref1, ref2, ref3;
        var obj = {};
        if (((ref = message.event) === null || ref === void 0 ? void 0 : ref.$case) === "qualification") {
            obj.qualification = SellWithUpsideCategory_QualificationEvent.toJSON(message.event.qualification);
        }
        if (((ref1 = message.event) === null || ref1 === void 0 ? void 0 : ref1.$case) === "upfrontCashChange") {
            obj.upfrontCashChange = SellWithUpsideCategory_UpfrontCashChangeEvent.toJSON(message.event.upfrontCashChange);
        }
        if (((ref2 = message.event) === null || ref2 === void 0 ? void 0 : ref2.$case) === "estimatedSalesPriceChange") {
            obj.estimatedSalesPriceChange = SellWithUpsideCategory_EstimatedSalesPriceChangeEvent.toJSON(message.event.estimatedSalesPriceChange);
        }
        if (((ref3 = message.event) === null || ref3 === void 0 ? void 0 : ref3.$case) === "pricingOptionsLoaded") {
            obj.pricingOptionsLoaded = SellWithUpsideCategory_PricingOptionsLoadedEvent.toJSON(message.event.pricingOptionsLoaded);
        }
        return obj;
    },
    create: function create(base) {
        return SellWithUpsideCategory.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
        var message = createBaseSellWithUpsideCategory();
        if (((ref = object.event) === null || ref === void 0 ? void 0 : ref.$case) === "qualification" && ((ref1 = object.event) === null || ref1 === void 0 ? void 0 : ref1.qualification) !== undefined && ((ref2 = object.event) === null || ref2 === void 0 ? void 0 : ref2.qualification) !== null) {
            message.event = {
                $case: "qualification",
                qualification: SellWithUpsideCategory_QualificationEvent.fromPartial(object.event.qualification)
            };
        }
        if (((ref3 = object.event) === null || ref3 === void 0 ? void 0 : ref3.$case) === "upfrontCashChange" && ((ref4 = object.event) === null || ref4 === void 0 ? void 0 : ref4.upfrontCashChange) !== undefined && ((ref5 = object.event) === null || ref5 === void 0 ? void 0 : ref5.upfrontCashChange) !== null) {
            message.event = {
                $case: "upfrontCashChange",
                upfrontCashChange: SellWithUpsideCategory_UpfrontCashChangeEvent.fromPartial(object.event.upfrontCashChange)
            };
        }
        if (((ref6 = object.event) === null || ref6 === void 0 ? void 0 : ref6.$case) === "estimatedSalesPriceChange" && ((ref7 = object.event) === null || ref7 === void 0 ? void 0 : ref7.estimatedSalesPriceChange) !== undefined && ((ref8 = object.event) === null || ref8 === void 0 ? void 0 : ref8.estimatedSalesPriceChange) !== null) {
            message.event = {
                $case: "estimatedSalesPriceChange",
                estimatedSalesPriceChange: SellWithUpsideCategory_EstimatedSalesPriceChangeEvent.fromPartial(object.event.estimatedSalesPriceChange)
            };
        }
        if (((ref9 = object.event) === null || ref9 === void 0 ? void 0 : ref9.$case) === "pricingOptionsLoaded" && ((ref10 = object.event) === null || ref10 === void 0 ? void 0 : ref10.pricingOptionsLoaded) !== undefined && ((ref11 = object.event) === null || ref11 === void 0 ? void 0 : ref11.pricingOptionsLoaded) !== null) {
            message.event = {
                $case: "pricingOptionsLoaded",
                pricingOptionsLoaded: SellWithUpsideCategory_PricingOptionsLoadedEvent.fromPartial(object.event.pricingOptionsLoaded)
            };
        }
        return message;
    }
};
function createBaseSellWithUpsideCategory_QualificationEvent() {
    return {
        sellerLeadUuid: "",
        qualificationDecision: 0,
        denialReason: undefined,
        offerUuid: "",
        addressUuid: "",
        sellerInputId: ""
    };
}
var SellWithUpsideCategory_QualificationEvent = {
    fromJSON: function fromJSON(object) {
        return {
            sellerLeadUuid: sell_with_upside_category_isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : "",
            qualificationDecision: sell_with_upside_category_isSet(object.qualificationDecision) ? sellWithUpsideCategory_QualificationEvent_QualificationDecisionFromJSON(object.qualificationDecision) : 0,
            denialReason: sell_with_upside_category_isSet(object.denialReason) ? String(object.denialReason) : undefined,
            offerUuid: sell_with_upside_category_isSet(object.offerUuid) ? String(object.offerUuid) : "",
            addressUuid: sell_with_upside_category_isSet(object.addressUuid) ? String(object.addressUuid) : "",
            sellerInputId: sell_with_upside_category_isSet(object.sellerInputId) ? String(object.sellerInputId) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.sellerLeadUuid !== "") {
            obj.sellerLeadUuid = message.sellerLeadUuid;
        }
        if (message.qualificationDecision !== 0) {
            obj.qualificationDecision = sellWithUpsideCategory_QualificationEvent_QualificationDecisionToJSON(message.qualificationDecision);
        }
        if (message.denialReason !== undefined) {
            obj.denialReason = message.denialReason;
        }
        if (message.offerUuid !== "") {
            obj.offerUuid = message.offerUuid;
        }
        if (message.addressUuid !== "") {
            obj.addressUuid = message.addressUuid;
        }
        if (message.sellerInputId !== "") {
            obj.sellerInputId = message.sellerInputId;
        }
        return obj;
    },
    create: function create(base) {
        return SellWithUpsideCategory_QualificationEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseSellWithUpsideCategory_QualificationEvent();
        var _sellerLeadUuid;
        message.sellerLeadUuid = (_sellerLeadUuid = object.sellerLeadUuid) !== null && _sellerLeadUuid !== void 0 ? _sellerLeadUuid : "";
        var _qualificationDecision;
        message.qualificationDecision = (_qualificationDecision = object.qualificationDecision) !== null && _qualificationDecision !== void 0 ? _qualificationDecision : 0;
        var _denialReason;
        message.denialReason = (_denialReason = object.denialReason) !== null && _denialReason !== void 0 ? _denialReason : undefined;
        var _offerUuid;
        message.offerUuid = (_offerUuid = object.offerUuid) !== null && _offerUuid !== void 0 ? _offerUuid : "";
        var _addressUuid;
        message.addressUuid = (_addressUuid = object.addressUuid) !== null && _addressUuid !== void 0 ? _addressUuid : "";
        var _sellerInputId;
        message.sellerInputId = (_sellerInputId = object.sellerInputId) !== null && _sellerInputId !== void 0 ? _sellerInputId : "";
        return message;
    }
};
function createBaseSellWithUpsideCategory_UpfrontCashChangeEvent() {
    return {
        sellerLeadUuid: "",
        offerUuid: "",
        newUpfrontCashCents: 0,
        oldUpfrontCashCents: 0,
        changeCents: 0,
        pricingUuid: ""
    };
}
var SellWithUpsideCategory_UpfrontCashChangeEvent = {
    fromJSON: function fromJSON(object) {
        return {
            sellerLeadUuid: sell_with_upside_category_isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : "",
            offerUuid: sell_with_upside_category_isSet(object.offerUuid) ? String(object.offerUuid) : "",
            newUpfrontCashCents: sell_with_upside_category_isSet(object.newUpfrontCashCents) ? Number(object.newUpfrontCashCents) : 0,
            oldUpfrontCashCents: sell_with_upside_category_isSet(object.oldUpfrontCashCents) ? Number(object.oldUpfrontCashCents) : 0,
            changeCents: sell_with_upside_category_isSet(object.changeCents) ? Number(object.changeCents) : 0,
            pricingUuid: sell_with_upside_category_isSet(object.pricingUuid) ? String(object.pricingUuid) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.sellerLeadUuid !== "") {
            obj.sellerLeadUuid = message.sellerLeadUuid;
        }
        if (message.offerUuid !== "") {
            obj.offerUuid = message.offerUuid;
        }
        if (message.newUpfrontCashCents !== 0) {
            obj.newUpfrontCashCents = Math.round(message.newUpfrontCashCents);
        }
        if (message.oldUpfrontCashCents !== 0) {
            obj.oldUpfrontCashCents = Math.round(message.oldUpfrontCashCents);
        }
        if (message.changeCents !== 0) {
            obj.changeCents = Math.round(message.changeCents);
        }
        if (message.pricingUuid !== "") {
            obj.pricingUuid = message.pricingUuid;
        }
        return obj;
    },
    create: function create(base) {
        return SellWithUpsideCategory_UpfrontCashChangeEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseSellWithUpsideCategory_UpfrontCashChangeEvent();
        var _sellerLeadUuid;
        message.sellerLeadUuid = (_sellerLeadUuid = object.sellerLeadUuid) !== null && _sellerLeadUuid !== void 0 ? _sellerLeadUuid : "";
        var _offerUuid;
        message.offerUuid = (_offerUuid = object.offerUuid) !== null && _offerUuid !== void 0 ? _offerUuid : "";
        var _newUpfrontCashCents;
        message.newUpfrontCashCents = (_newUpfrontCashCents = object.newUpfrontCashCents) !== null && _newUpfrontCashCents !== void 0 ? _newUpfrontCashCents : 0;
        var _oldUpfrontCashCents;
        message.oldUpfrontCashCents = (_oldUpfrontCashCents = object.oldUpfrontCashCents) !== null && _oldUpfrontCashCents !== void 0 ? _oldUpfrontCashCents : 0;
        var _changeCents;
        message.changeCents = (_changeCents = object.changeCents) !== null && _changeCents !== void 0 ? _changeCents : 0;
        var _pricingUuid;
        message.pricingUuid = (_pricingUuid = object.pricingUuid) !== null && _pricingUuid !== void 0 ? _pricingUuid : "";
        return message;
    }
};
function createBaseSellWithUpsideCategory_EstimatedSalesPriceChangeEvent() {
    return {
        sellerLeadUuid: "",
        offerUuid: "",
        newEstimatedSalesPriceCents: 0,
        oldEstimatedSalesPriceCents: 0,
        changeCents: 0,
        opendoorEstimatedSalesPriceCents: 0
    };
}
var SellWithUpsideCategory_EstimatedSalesPriceChangeEvent = {
    fromJSON: function fromJSON(object) {
        return {
            sellerLeadUuid: sell_with_upside_category_isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : "",
            offerUuid: sell_with_upside_category_isSet(object.offerUuid) ? String(object.offerUuid) : "",
            newEstimatedSalesPriceCents: sell_with_upside_category_isSet(object.newEstimatedSalesPriceCents) ? Number(object.newEstimatedSalesPriceCents) : 0,
            oldEstimatedSalesPriceCents: sell_with_upside_category_isSet(object.oldEstimatedSalesPriceCents) ? Number(object.oldEstimatedSalesPriceCents) : 0,
            changeCents: sell_with_upside_category_isSet(object.changeCents) ? Number(object.changeCents) : 0,
            opendoorEstimatedSalesPriceCents: sell_with_upside_category_isSet(object.opendoorEstimatedSalesPriceCents) ? Number(object.opendoorEstimatedSalesPriceCents) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.sellerLeadUuid !== "") {
            obj.sellerLeadUuid = message.sellerLeadUuid;
        }
        if (message.offerUuid !== "") {
            obj.offerUuid = message.offerUuid;
        }
        if (message.newEstimatedSalesPriceCents !== 0) {
            obj.newEstimatedSalesPriceCents = Math.round(message.newEstimatedSalesPriceCents);
        }
        if (message.oldEstimatedSalesPriceCents !== 0) {
            obj.oldEstimatedSalesPriceCents = Math.round(message.oldEstimatedSalesPriceCents);
        }
        if (message.changeCents !== 0) {
            obj.changeCents = Math.round(message.changeCents);
        }
        if (message.opendoorEstimatedSalesPriceCents !== 0) {
            obj.opendoorEstimatedSalesPriceCents = Math.round(message.opendoorEstimatedSalesPriceCents);
        }
        return obj;
    },
    create: function create(base) {
        return SellWithUpsideCategory_EstimatedSalesPriceChangeEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseSellWithUpsideCategory_EstimatedSalesPriceChangeEvent();
        var _sellerLeadUuid;
        message.sellerLeadUuid = (_sellerLeadUuid = object.sellerLeadUuid) !== null && _sellerLeadUuid !== void 0 ? _sellerLeadUuid : "";
        var _offerUuid;
        message.offerUuid = (_offerUuid = object.offerUuid) !== null && _offerUuid !== void 0 ? _offerUuid : "";
        var _newEstimatedSalesPriceCents;
        message.newEstimatedSalesPriceCents = (_newEstimatedSalesPriceCents = object.newEstimatedSalesPriceCents) !== null && _newEstimatedSalesPriceCents !== void 0 ? _newEstimatedSalesPriceCents : 0;
        var _oldEstimatedSalesPriceCents;
        message.oldEstimatedSalesPriceCents = (_oldEstimatedSalesPriceCents = object.oldEstimatedSalesPriceCents) !== null && _oldEstimatedSalesPriceCents !== void 0 ? _oldEstimatedSalesPriceCents : 0;
        var _changeCents;
        message.changeCents = (_changeCents = object.changeCents) !== null && _changeCents !== void 0 ? _changeCents : 0;
        var _opendoorEstimatedSalesPriceCents;
        message.opendoorEstimatedSalesPriceCents = (_opendoorEstimatedSalesPriceCents = object.opendoorEstimatedSalesPriceCents) !== null && _opendoorEstimatedSalesPriceCents !== void 0 ? _opendoorEstimatedSalesPriceCents : 0;
        return message;
    }
};
function createBaseSellWithUpsideCategory_PricingOptionsLoadedEvent() {
    return {
        sellerLeadUuid: "",
        offerUuid: "",
        pricingUuids: [],
        recommendedPricingUuid: ""
    };
}
var SellWithUpsideCategory_PricingOptionsLoadedEvent = {
    fromJSON: function fromJSON(object) {
        return {
            sellerLeadUuid: sell_with_upside_category_isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : "",
            offerUuid: sell_with_upside_category_isSet(object.offerUuid) ? String(object.offerUuid) : "",
            pricingUuids: Array.isArray(object === null || object === void 0 ? void 0 : object.pricingUuids) ? object.pricingUuids.map(function(e) {
                return String(e);
            }) : [],
            recommendedPricingUuid: sell_with_upside_category_isSet(object.recommendedPricingUuid) ? String(object.recommendedPricingUuid) : ""
        };
    },
    toJSON: function toJSON(message) {
        var ref;
        var obj = {};
        if (message.sellerLeadUuid !== "") {
            obj.sellerLeadUuid = message.sellerLeadUuid;
        }
        if (message.offerUuid !== "") {
            obj.offerUuid = message.offerUuid;
        }
        if ((ref = message.pricingUuids) === null || ref === void 0 ? void 0 : ref.length) {
            obj.pricingUuids = message.pricingUuids;
        }
        if (message.recommendedPricingUuid !== "") {
            obj.recommendedPricingUuid = message.recommendedPricingUuid;
        }
        return obj;
    },
    create: function create(base) {
        return SellWithUpsideCategory_PricingOptionsLoadedEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref;
        var message = createBaseSellWithUpsideCategory_PricingOptionsLoadedEvent();
        var _sellerLeadUuid;
        message.sellerLeadUuid = (_sellerLeadUuid = object.sellerLeadUuid) !== null && _sellerLeadUuid !== void 0 ? _sellerLeadUuid : "";
        var _offerUuid;
        message.offerUuid = (_offerUuid = object.offerUuid) !== null && _offerUuid !== void 0 ? _offerUuid : "";
        message.pricingUuids = ((ref = object.pricingUuids) === null || ref === void 0 ? void 0 : ref.map(function(e) {
            return e;
        })) || [];
        var _recommendedPricingUuid;
        message.recommendedPricingUuid = (_recommendedPricingUuid = object.recommendedPricingUuid) !== null && _recommendedPricingUuid !== void 0 ? _recommendedPricingUuid : "";
        return message;
    }
};
function sell_with_upside_category_isSet(value) {
    return value !== null && value !== undefined;
}

;// CONCATENATED MODULE: ./src/__generated__/protobuf/journey/data/contexts.ts
/* eslint-disable */ 
var contexts_protobufPackage = "od_protos.journey.data";
function createBaseCampaignContext() {
    return {
        utmSource: undefined,
        utmMedium: undefined,
        utmCampaign: undefined,
        utmTerm: undefined,
        utmContent: undefined,
        utmAdgid: undefined,
        utmNtwk: undefined,
        utmSubsite: undefined,
        utmCta: undefined,
        utmExternalid: undefined,
        utmGeo: undefined,
        utmCat: undefined
    };
}
var CampaignContext = {
    fromJSON: function fromJSON(object) {
        return {
            utmSource: contexts_isSet(object.utmSource) ? String(object.utmSource) : undefined,
            utmMedium: contexts_isSet(object.utmMedium) ? String(object.utmMedium) : undefined,
            utmCampaign: contexts_isSet(object.utmCampaign) ? String(object.utmCampaign) : undefined,
            utmTerm: contexts_isSet(object.utmTerm) ? String(object.utmTerm) : undefined,
            utmContent: contexts_isSet(object.utmContent) ? String(object.utmContent) : undefined,
            utmAdgid: contexts_isSet(object.utmAdgid) ? String(object.utmAdgid) : undefined,
            utmNtwk: contexts_isSet(object.utmNtwk) ? String(object.utmNtwk) : undefined,
            utmSubsite: contexts_isSet(object.utmSubsite) ? String(object.utmSubsite) : undefined,
            utmCta: contexts_isSet(object.utmCta) ? String(object.utmCta) : undefined,
            utmExternalid: contexts_isSet(object.utmExternalid) ? String(object.utmExternalid) : undefined,
            utmGeo: contexts_isSet(object.utmGeo) ? String(object.utmGeo) : undefined,
            utmCat: contexts_isSet(object.utmCat) ? String(object.utmCat) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.utmSource !== undefined) {
            obj.utmSource = message.utmSource;
        }
        if (message.utmMedium !== undefined) {
            obj.utmMedium = message.utmMedium;
        }
        if (message.utmCampaign !== undefined) {
            obj.utmCampaign = message.utmCampaign;
        }
        if (message.utmTerm !== undefined) {
            obj.utmTerm = message.utmTerm;
        }
        if (message.utmContent !== undefined) {
            obj.utmContent = message.utmContent;
        }
        if (message.utmAdgid !== undefined) {
            obj.utmAdgid = message.utmAdgid;
        }
        if (message.utmNtwk !== undefined) {
            obj.utmNtwk = message.utmNtwk;
        }
        if (message.utmSubsite !== undefined) {
            obj.utmSubsite = message.utmSubsite;
        }
        if (message.utmCta !== undefined) {
            obj.utmCta = message.utmCta;
        }
        if (message.utmExternalid !== undefined) {
            obj.utmExternalid = message.utmExternalid;
        }
        if (message.utmGeo !== undefined) {
            obj.utmGeo = message.utmGeo;
        }
        if (message.utmCat !== undefined) {
            obj.utmCat = message.utmCat;
        }
        return obj;
    },
    create: function create(base) {
        return CampaignContext.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseCampaignContext();
        var _utmSource;
        message.utmSource = (_utmSource = object.utmSource) !== null && _utmSource !== void 0 ? _utmSource : undefined;
        var _utmMedium;
        message.utmMedium = (_utmMedium = object.utmMedium) !== null && _utmMedium !== void 0 ? _utmMedium : undefined;
        var _utmCampaign;
        message.utmCampaign = (_utmCampaign = object.utmCampaign) !== null && _utmCampaign !== void 0 ? _utmCampaign : undefined;
        var _utmTerm;
        message.utmTerm = (_utmTerm = object.utmTerm) !== null && _utmTerm !== void 0 ? _utmTerm : undefined;
        var _utmContent;
        message.utmContent = (_utmContent = object.utmContent) !== null && _utmContent !== void 0 ? _utmContent : undefined;
        var _utmAdgid;
        message.utmAdgid = (_utmAdgid = object.utmAdgid) !== null && _utmAdgid !== void 0 ? _utmAdgid : undefined;
        var _utmNtwk;
        message.utmNtwk = (_utmNtwk = object.utmNtwk) !== null && _utmNtwk !== void 0 ? _utmNtwk : undefined;
        var _utmSubsite;
        message.utmSubsite = (_utmSubsite = object.utmSubsite) !== null && _utmSubsite !== void 0 ? _utmSubsite : undefined;
        var _utmCta;
        message.utmCta = (_utmCta = object.utmCta) !== null && _utmCta !== void 0 ? _utmCta : undefined;
        var _utmExternalid;
        message.utmExternalid = (_utmExternalid = object.utmExternalid) !== null && _utmExternalid !== void 0 ? _utmExternalid : undefined;
        var _utmGeo;
        message.utmGeo = (_utmGeo = object.utmGeo) !== null && _utmGeo !== void 0 ? _utmGeo : undefined;
        var _utmCat;
        message.utmCat = (_utmCat = object.utmCat) !== null && _utmCat !== void 0 ? _utmCat : undefined;
        return message;
    }
};
function createBaseCustomerContext() {
    return {
        customerUuid: "",
        firstName: undefined,
        lastName: undefined,
        primaryEmail: undefined,
        primaryPhone: undefined
    };
}
var CustomerContext = {
    fromJSON: function fromJSON(object) {
        return {
            customerUuid: contexts_isSet(object.customerUuid) ? String(object.customerUuid) : "",
            firstName: contexts_isSet(object.firstName) ? String(object.firstName) : undefined,
            lastName: contexts_isSet(object.lastName) ? String(object.lastName) : undefined,
            primaryEmail: contexts_isSet(object.primaryEmail) ? String(object.primaryEmail) : undefined,
            primaryPhone: contexts_isSet(object.primaryPhone) ? String(object.primaryPhone) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.customerUuid !== "") {
            obj.customerUuid = message.customerUuid;
        }
        if (message.firstName !== undefined) {
            obj.firstName = message.firstName;
        }
        if (message.lastName !== undefined) {
            obj.lastName = message.lastName;
        }
        if (message.primaryEmail !== undefined) {
            obj.primaryEmail = message.primaryEmail;
        }
        if (message.primaryPhone !== undefined) {
            obj.primaryPhone = message.primaryPhone;
        }
        return obj;
    },
    create: function create(base) {
        return CustomerContext.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseCustomerContext();
        var _customerUuid;
        message.customerUuid = (_customerUuid = object.customerUuid) !== null && _customerUuid !== void 0 ? _customerUuid : "";
        var _firstName;
        message.firstName = (_firstName = object.firstName) !== null && _firstName !== void 0 ? _firstName : undefined;
        var _lastName;
        message.lastName = (_lastName = object.lastName) !== null && _lastName !== void 0 ? _lastName : undefined;
        var _primaryEmail;
        message.primaryEmail = (_primaryEmail = object.primaryEmail) !== null && _primaryEmail !== void 0 ? _primaryEmail : undefined;
        var _primaryPhone;
        message.primaryPhone = (_primaryPhone = object.primaryPhone) !== null && _primaryPhone !== void 0 ? _primaryPhone : undefined;
        return message;
    }
};
function createBaseExclusiveOffersContext() {
    return {
        offerBlurPricing: undefined,
        offerRangeMax: undefined,
        offerRangeMin: undefined,
        potentialBuyerCount: undefined,
        allPhotoCount: undefined,
        internalPhotoCount: undefined,
        mlsPhotoCount: undefined
    };
}
var ExclusiveOffersContext = {
    fromJSON: function fromJSON(object) {
        return {
            offerBlurPricing: contexts_isSet(object.offerBlurPricing) ? Boolean(object.offerBlurPricing) : undefined,
            offerRangeMax: contexts_isSet(object.offerRangeMax) ? Number(object.offerRangeMax) : undefined,
            offerRangeMin: contexts_isSet(object.offerRangeMin) ? Number(object.offerRangeMin) : undefined,
            potentialBuyerCount: contexts_isSet(object.potentialBuyerCount) ? Number(object.potentialBuyerCount) : undefined,
            allPhotoCount: contexts_isSet(object.allPhotoCount) ? Number(object.allPhotoCount) : undefined,
            internalPhotoCount: contexts_isSet(object.internalPhotoCount) ? Number(object.internalPhotoCount) : undefined,
            mlsPhotoCount: contexts_isSet(object.mlsPhotoCount) ? Number(object.mlsPhotoCount) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.offerBlurPricing !== undefined) {
            obj.offerBlurPricing = message.offerBlurPricing;
        }
        if (message.offerRangeMax !== undefined) {
            obj.offerRangeMax = message.offerRangeMax;
        }
        if (message.offerRangeMin !== undefined) {
            obj.offerRangeMin = message.offerRangeMin;
        }
        if (message.potentialBuyerCount !== undefined) {
            obj.potentialBuyerCount = message.potentialBuyerCount;
        }
        if (message.allPhotoCount !== undefined) {
            obj.allPhotoCount = message.allPhotoCount;
        }
        if (message.internalPhotoCount !== undefined) {
            obj.internalPhotoCount = message.internalPhotoCount;
        }
        if (message.mlsPhotoCount !== undefined) {
            obj.mlsPhotoCount = message.mlsPhotoCount;
        }
        return obj;
    },
    create: function create(base) {
        return ExclusiveOffersContext.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseExclusiveOffersContext();
        var _offerBlurPricing;
        message.offerBlurPricing = (_offerBlurPricing = object.offerBlurPricing) !== null && _offerBlurPricing !== void 0 ? _offerBlurPricing : undefined;
        var _offerRangeMax;
        message.offerRangeMax = (_offerRangeMax = object.offerRangeMax) !== null && _offerRangeMax !== void 0 ? _offerRangeMax : undefined;
        var _offerRangeMin;
        message.offerRangeMin = (_offerRangeMin = object.offerRangeMin) !== null && _offerRangeMin !== void 0 ? _offerRangeMin : undefined;
        var _potentialBuyerCount;
        message.potentialBuyerCount = (_potentialBuyerCount = object.potentialBuyerCount) !== null && _potentialBuyerCount !== void 0 ? _potentialBuyerCount : undefined;
        var _allPhotoCount;
        message.allPhotoCount = (_allPhotoCount = object.allPhotoCount) !== null && _allPhotoCount !== void 0 ? _allPhotoCount : undefined;
        var _internalPhotoCount;
        message.internalPhotoCount = (_internalPhotoCount = object.internalPhotoCount) !== null && _internalPhotoCount !== void 0 ? _internalPhotoCount : undefined;
        var _mlsPhotoCount;
        message.mlsPhotoCount = (_mlsPhotoCount = object.mlsPhotoCount) !== null && _mlsPhotoCount !== void 0 ? _mlsPhotoCount : undefined;
        return message;
    }
};
function createBaseLeadContext() {
    return {
        sellerInputUuid: undefined,
        sellerLeadUuid: undefined,
        sellerLeadMarket: undefined
    };
}
var LeadContext = {
    fromJSON: function fromJSON(object) {
        return {
            sellerInputUuid: contexts_isSet(object.sellerInputUuid) ? String(object.sellerInputUuid) : undefined,
            sellerLeadUuid: contexts_isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : undefined,
            sellerLeadMarket: contexts_isSet(object.sellerLeadMarket) ? String(object.sellerLeadMarket) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.sellerInputUuid !== undefined) {
            obj.sellerInputUuid = message.sellerInputUuid;
        }
        if (message.sellerLeadUuid !== undefined) {
            obj.sellerLeadUuid = message.sellerLeadUuid;
        }
        if (message.sellerLeadMarket !== undefined) {
            obj.sellerLeadMarket = message.sellerLeadMarket;
        }
        return obj;
    },
    create: function create(base) {
        return LeadContext.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseLeadContext();
        var _sellerInputUuid;
        message.sellerInputUuid = (_sellerInputUuid = object.sellerInputUuid) !== null && _sellerInputUuid !== void 0 ? _sellerInputUuid : undefined;
        var _sellerLeadUuid;
        message.sellerLeadUuid = (_sellerLeadUuid = object.sellerLeadUuid) !== null && _sellerLeadUuid !== void 0 ? _sellerLeadUuid : undefined;
        var _sellerLeadMarket;
        message.sellerLeadMarket = (_sellerLeadMarket = object.sellerLeadMarket) !== null && _sellerLeadMarket !== void 0 ? _sellerLeadMarket : undefined;
        return message;
    }
};
function createBaseSellDirectContext() {
    return {
        offerId: "",
        offerRequestSource: 0,
        offerHeadlinePrice: undefined,
        offerDenialReason: undefined,
        offerState: undefined,
        dwellingType: undefined
    };
}
var SellDirectContext = {
    fromJSON: function fromJSON(object) {
        return {
            offerId: contexts_isSet(object.offerId) ? String(object.offerId) : "",
            offerRequestSource: contexts_isSet(object.offerRequestSource) ? offerRequest_SourceFromJSON(object.offerRequestSource) : 0,
            offerHeadlinePrice: contexts_isSet(object.offerHeadlinePrice) ? Number(object.offerHeadlinePrice) : undefined,
            offerDenialReason: contexts_isSet(object.offerDenialReason) ? String(object.offerDenialReason) : undefined,
            offerState: contexts_isSet(object.offerState) ? String(object.offerState) : undefined,
            dwellingType: contexts_isSet(object.dwellingType) ? String(object.dwellingType) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.offerId !== "") {
            obj.offerId = message.offerId;
        }
        if (message.offerRequestSource !== 0) {
            obj.offerRequestSource = offerRequest_SourceToJSON(message.offerRequestSource);
        }
        if (message.offerHeadlinePrice !== undefined) {
            obj.offerHeadlinePrice = message.offerHeadlinePrice;
        }
        if (message.offerDenialReason !== undefined) {
            obj.offerDenialReason = message.offerDenialReason;
        }
        if (message.offerState !== undefined) {
            obj.offerState = message.offerState;
        }
        if (message.dwellingType !== undefined) {
            obj.dwellingType = message.dwellingType;
        }
        return obj;
    },
    create: function create(base) {
        return SellDirectContext.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseSellDirectContext();
        var _offerId;
        message.offerId = (_offerId = object.offerId) !== null && _offerId !== void 0 ? _offerId : "";
        var _offerRequestSource;
        message.offerRequestSource = (_offerRequestSource = object.offerRequestSource) !== null && _offerRequestSource !== void 0 ? _offerRequestSource : 0;
        var _offerHeadlinePrice;
        message.offerHeadlinePrice = (_offerHeadlinePrice = object.offerHeadlinePrice) !== null && _offerHeadlinePrice !== void 0 ? _offerHeadlinePrice : undefined;
        var _offerDenialReason;
        message.offerDenialReason = (_offerDenialReason = object.offerDenialReason) !== null && _offerDenialReason !== void 0 ? _offerDenialReason : undefined;
        var _offerState;
        message.offerState = (_offerState = object.offerState) !== null && _offerState !== void 0 ? _offerState : undefined;
        var _dwellingType;
        message.dwellingType = (_dwellingType = object.dwellingType) !== null && _dwellingType !== void 0 ? _dwellingType : undefined;
        return message;
    }
};
function createBaseAdClickContext() {
    return {
        fbclid: undefined,
        ttclid: undefined,
        gclid: undefined
    };
}
var AdClickContext = {
    fromJSON: function fromJSON(object) {
        return {
            fbclid: contexts_isSet(object.fbclid) ? String(object.fbclid) : undefined,
            ttclid: contexts_isSet(object.ttclid) ? String(object.ttclid) : undefined,
            gclid: contexts_isSet(object.gclid) ? String(object.gclid) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.fbclid !== undefined) {
            obj.fbclid = message.fbclid;
        }
        if (message.ttclid !== undefined) {
            obj.ttclid = message.ttclid;
        }
        if (message.gclid !== undefined) {
            obj.gclid = message.gclid;
        }
        return obj;
    },
    create: function create(base) {
        return AdClickContext.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAdClickContext();
        var _fbclid;
        message.fbclid = (_fbclid = object.fbclid) !== null && _fbclid !== void 0 ? _fbclid : undefined;
        var _ttclid;
        message.ttclid = (_ttclid = object.ttclid) !== null && _ttclid !== void 0 ? _ttclid : undefined;
        var _gclid;
        message.gclid = (_gclid = object.gclid) !== null && _gclid !== void 0 ? _gclid : undefined;
        return message;
    }
};
function createBaseAnalyticsContext() {
    return {
        gaClientId: undefined,
        fbBrowserId: undefined,
        fbClickId: undefined,
        gaSessionId: undefined,
        redditBrowserId: undefined,
        tiktokBrowserId: undefined,
        nextdoorClickId: undefined
    };
}
var AnalyticsContext = {
    fromJSON: function fromJSON(object) {
        return {
            gaClientId: contexts_isSet(object.gaClientId) ? String(object.gaClientId) : undefined,
            fbBrowserId: contexts_isSet(object.fbBrowserId) ? String(object.fbBrowserId) : undefined,
            fbClickId: contexts_isSet(object.fbClickId) ? String(object.fbClickId) : undefined,
            gaSessionId: contexts_isSet(object.gaSessionId) ? String(object.gaSessionId) : undefined,
            redditBrowserId: contexts_isSet(object.redditBrowserId) ? String(object.redditBrowserId) : undefined,
            tiktokBrowserId: contexts_isSet(object.tiktokBrowserId) ? String(object.tiktokBrowserId) : undefined,
            nextdoorClickId: contexts_isSet(object.nextdoorClickId) ? String(object.nextdoorClickId) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.gaClientId !== undefined) {
            obj.gaClientId = message.gaClientId;
        }
        if (message.fbBrowserId !== undefined) {
            obj.fbBrowserId = message.fbBrowserId;
        }
        if (message.fbClickId !== undefined) {
            obj.fbClickId = message.fbClickId;
        }
        if (message.gaSessionId !== undefined) {
            obj.gaSessionId = message.gaSessionId;
        }
        if (message.redditBrowserId !== undefined) {
            obj.redditBrowserId = message.redditBrowserId;
        }
        if (message.tiktokBrowserId !== undefined) {
            obj.tiktokBrowserId = message.tiktokBrowserId;
        }
        if (message.nextdoorClickId !== undefined) {
            obj.nextdoorClickId = message.nextdoorClickId;
        }
        return obj;
    },
    create: function create(base) {
        return AnalyticsContext.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseAnalyticsContext();
        var _gaClientId;
        message.gaClientId = (_gaClientId = object.gaClientId) !== null && _gaClientId !== void 0 ? _gaClientId : undefined;
        var _fbBrowserId;
        message.fbBrowserId = (_fbBrowserId = object.fbBrowserId) !== null && _fbBrowserId !== void 0 ? _fbBrowserId : undefined;
        var _fbClickId;
        message.fbClickId = (_fbClickId = object.fbClickId) !== null && _fbClickId !== void 0 ? _fbClickId : undefined;
        var _gaSessionId;
        message.gaSessionId = (_gaSessionId = object.gaSessionId) !== null && _gaSessionId !== void 0 ? _gaSessionId : undefined;
        var _redditBrowserId;
        message.redditBrowserId = (_redditBrowserId = object.redditBrowserId) !== null && _redditBrowserId !== void 0 ? _redditBrowserId : undefined;
        var _tiktokBrowserId;
        message.tiktokBrowserId = (_tiktokBrowserId = object.tiktokBrowserId) !== null && _tiktokBrowserId !== void 0 ? _tiktokBrowserId : undefined;
        var _nextdoorClickId;
        message.nextdoorClickId = (_nextdoorClickId = object.nextdoorClickId) !== null && _nextdoorClickId !== void 0 ? _nextdoorClickId : undefined;
        return message;
    }
};
function contexts_isSet(value) {
    return value !== null && value !== undefined;
}

;// CONCATENATED MODULE: ./src/__generated__/protobuf/journey/data/sources.ts
/* eslint-disable */ 
var sources_protobufPackage = "od_protos.journey.data";
var WebsiteSource_EventOrigin;
(function(WebsiteSource_EventOrigin) {
    WebsiteSource_EventOrigin[WebsiteSource_EventOrigin["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    WebsiteSource_EventOrigin[WebsiteSource_EventOrigin["SERVER"] = 1] = "SERVER";
    WebsiteSource_EventOrigin[WebsiteSource_EventOrigin["CLIENT"] = 2] = "CLIENT";
    WebsiteSource_EventOrigin[WebsiteSource_EventOrigin["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(WebsiteSource_EventOrigin || (WebsiteSource_EventOrigin = {}));
function websiteSource_EventOriginFromJSON(object) {
    switch(object){
        case 0:
        case "UNSPECIFIED":
            return WebsiteSource_EventOrigin.UNSPECIFIED;
        case 1:
        case "SERVER":
            return WebsiteSource_EventOrigin.SERVER;
        case 2:
        case "CLIENT":
            return WebsiteSource_EventOrigin.CLIENT;
        case -1:
        case "UNRECOGNIZED":
        default:
            return WebsiteSource_EventOrigin.UNRECOGNIZED;
    }
}
function websiteSource_EventOriginToJSON(object) {
    switch(object){
        case WebsiteSource_EventOrigin.UNSPECIFIED:
            return "UNSPECIFIED";
        case WebsiteSource_EventOrigin.SERVER:
            return "SERVER";
        case WebsiteSource_EventOrigin.CLIENT:
            return "CLIENT";
        case WebsiteSource_EventOrigin.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var EdgeSource_EventOrigin;
(function(EdgeSource_EventOrigin) {
    EdgeSource_EventOrigin[EdgeSource_EventOrigin["SERVER"] = 0] = "SERVER";
    EdgeSource_EventOrigin[EdgeSource_EventOrigin["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(EdgeSource_EventOrigin || (EdgeSource_EventOrigin = {}));
function edgeSource_EventOriginFromJSON(object) {
    switch(object){
        case 0:
        case "SERVER":
            return EdgeSource_EventOrigin.SERVER;
        case -1:
        case "UNRECOGNIZED":
        default:
            return EdgeSource_EventOrigin.UNRECOGNIZED;
    }
}
function edgeSource_EventOriginToJSON(object) {
    switch(object){
        case EdgeSource_EventOrigin.SERVER:
            return "SERVER";
        case EdgeSource_EventOrigin.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var MobileSource_EventOrigin;
(function(MobileSource_EventOrigin) {
    MobileSource_EventOrigin[MobileSource_EventOrigin["APP"] = 0] = "APP";
    MobileSource_EventOrigin[MobileSource_EventOrigin["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(MobileSource_EventOrigin || (MobileSource_EventOrigin = {}));
function mobileSource_EventOriginFromJSON(object) {
    switch(object){
        case 0:
        case "APP":
            return MobileSource_EventOrigin.APP;
        case -1:
        case "UNRECOGNIZED":
        default:
            return MobileSource_EventOrigin.UNRECOGNIZED;
    }
}
function mobileSource_EventOriginToJSON(object) {
    switch(object){
        case MobileSource_EventOrigin.APP:
            return "APP";
        case MobileSource_EventOrigin.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var BackfillSource_EventOrigin;
(function(BackfillSource_EventOrigin) {
    BackfillSource_EventOrigin[BackfillSource_EventOrigin["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    BackfillSource_EventOrigin[BackfillSource_EventOrigin["SNOWFLAKE"] = 1] = "SNOWFLAKE";
    BackfillSource_EventOrigin[BackfillSource_EventOrigin["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(BackfillSource_EventOrigin || (BackfillSource_EventOrigin = {}));
function backfillSource_EventOriginFromJSON(object) {
    switch(object){
        case 0:
        case "UNSPECIFIED":
            return BackfillSource_EventOrigin.UNSPECIFIED;
        case 1:
        case "SNOWFLAKE":
            return BackfillSource_EventOrigin.SNOWFLAKE;
        case -1:
        case "UNRECOGNIZED":
        default:
            return BackfillSource_EventOrigin.UNRECOGNIZED;
    }
}
function backfillSource_EventOriginToJSON(object) {
    switch(object){
        case BackfillSource_EventOrigin.UNSPECIFIED:
            return "UNSPECIFIED";
        case BackfillSource_EventOrigin.SNOWFLAKE:
            return "SNOWFLAKE";
        case BackfillSource_EventOrigin.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
function createBaseWebsiteSource() {
    return {
        url: "",
        userAgent: undefined,
        ip: undefined,
        referrer: undefined,
        proxyPath: undefined,
        pathname: undefined,
        queryMap: {},
        host: undefined,
        eventOrigin: 0,
        proxyQueryMap: {},
        screen: undefined,
        language: [],
        isWebview: false
    };
}
var WebsiteSource = {
    fromJSON: function fromJSON(object) {
        return {
            url: sources_isSet(object.url) ? String(object.url) : "",
            userAgent: sources_isSet(object.userAgent) ? String(object.userAgent) : undefined,
            ip: sources_isSet(object.ip) ? String(object.ip) : undefined,
            referrer: sources_isSet(object.referrer) ? String(object.referrer) : undefined,
            proxyPath: sources_isSet(object.proxyPath) ? String(object.proxyPath) : undefined,
            pathname: sources_isSet(object.pathname) ? String(object.pathname) : undefined,
            queryMap: sources_isObject(object.queryMap) ? Object.entries(object.queryMap).reduce(function(acc, param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
                acc[key] = String(value);
                return acc;
            }, {}) : {},
            host: sources_isSet(object.host) ? String(object.host) : undefined,
            eventOrigin: sources_isSet(object.eventOrigin) ? websiteSource_EventOriginFromJSON(object.eventOrigin) : 0,
            proxyQueryMap: sources_isObject(object.proxyQueryMap) ? Object.entries(object.proxyQueryMap).reduce(function(acc, param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
                acc[key] = String(value);
                return acc;
            }, {}) : {},
            screen: sources_isSet(object.screen) ? WebsiteSource_Screen.fromJSON(object.screen) : undefined,
            language: Array.isArray(object === null || object === void 0 ? void 0 : object.language) ? object.language.map(function(e) {
                return String(e);
            }) : [],
            isWebview: sources_isSet(object.isWebview) ? Boolean(object.isWebview) : false
        };
    },
    toJSON: function toJSON(message) {
        var ref;
        var obj = {};
        if (message.url !== "") {
            obj.url = message.url;
        }
        if (message.userAgent !== undefined) {
            obj.userAgent = message.userAgent;
        }
        if (message.ip !== undefined) {
            obj.ip = message.ip;
        }
        if (message.referrer !== undefined) {
            obj.referrer = message.referrer;
        }
        if (message.proxyPath !== undefined) {
            obj.proxyPath = message.proxyPath;
        }
        if (message.pathname !== undefined) {
            obj.pathname = message.pathname;
        }
        if (message.queryMap) {
            var entries = Object.entries(message.queryMap);
            if (entries.length > 0) {
                obj.queryMap = {};
                entries.forEach(function(param) {
                    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), k = _param[0], v = _param[1];
                    obj.queryMap[k] = v;
                });
            }
        }
        if (message.host !== undefined) {
            obj.host = message.host;
        }
        if (message.eventOrigin !== 0) {
            obj.eventOrigin = websiteSource_EventOriginToJSON(message.eventOrigin);
        }
        if (message.proxyQueryMap) {
            var entries1 = Object.entries(message.proxyQueryMap);
            if (entries1.length > 0) {
                obj.proxyQueryMap = {};
                entries1.forEach(function(param) {
                    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), k = _param[0], v = _param[1];
                    obj.proxyQueryMap[k] = v;
                });
            }
        }
        if (message.screen !== undefined) {
            obj.screen = WebsiteSource_Screen.toJSON(message.screen);
        }
        if ((ref = message.language) === null || ref === void 0 ? void 0 : ref.length) {
            obj.language = message.language;
        }
        if (message.isWebview === true) {
            obj.isWebview = message.isWebview;
        }
        return obj;
    },
    create: function create(base) {
        return WebsiteSource.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref;
        var message = createBaseWebsiteSource();
        var _url;
        message.url = (_url = object.url) !== null && _url !== void 0 ? _url : "";
        var _userAgent;
        message.userAgent = (_userAgent = object.userAgent) !== null && _userAgent !== void 0 ? _userAgent : undefined;
        var _ip;
        message.ip = (_ip = object.ip) !== null && _ip !== void 0 ? _ip : undefined;
        var _referrer;
        message.referrer = (_referrer = object.referrer) !== null && _referrer !== void 0 ? _referrer : undefined;
        var _proxyPath;
        message.proxyPath = (_proxyPath = object.proxyPath) !== null && _proxyPath !== void 0 ? _proxyPath : undefined;
        var _pathname;
        message.pathname = (_pathname = object.pathname) !== null && _pathname !== void 0 ? _pathname : undefined;
        var _queryMap;
        message.queryMap = Object.entries((_queryMap = object.queryMap) !== null && _queryMap !== void 0 ? _queryMap : {}).reduce(function(acc, param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
            if (value !== undefined) {
                acc[key] = String(value);
            }
            return acc;
        }, {});
        var _host;
        message.host = (_host = object.host) !== null && _host !== void 0 ? _host : undefined;
        var _eventOrigin;
        message.eventOrigin = (_eventOrigin = object.eventOrigin) !== null && _eventOrigin !== void 0 ? _eventOrigin : 0;
        var _proxyQueryMap;
        message.proxyQueryMap = Object.entries((_proxyQueryMap = object.proxyQueryMap) !== null && _proxyQueryMap !== void 0 ? _proxyQueryMap : {}).reduce(function(acc, param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
            if (value !== undefined) {
                acc[key] = String(value);
            }
            return acc;
        }, {});
        message.screen = object.screen !== undefined && object.screen !== null ? WebsiteSource_Screen.fromPartial(object.screen) : undefined;
        message.language = ((ref = object.language) === null || ref === void 0 ? void 0 : ref.map(function(e) {
            return e;
        })) || [];
        var _isWebview;
        message.isWebview = (_isWebview = object.isWebview) !== null && _isWebview !== void 0 ? _isWebview : false;
        return message;
    }
};
function createBaseWebsiteSource_Screen() {
    return {
        density: 0,
        width: 0,
        height: 0
    };
}
var WebsiteSource_Screen = {
    fromJSON: function fromJSON(object) {
        return {
            density: sources_isSet(object.density) ? Number(object.density) : 0,
            width: sources_isSet(object.width) ? Number(object.width) : 0,
            height: sources_isSet(object.height) ? Number(object.height) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.density !== 0) {
            obj.density = Math.round(message.density);
        }
        if (message.width !== 0) {
            obj.width = Math.round(message.width);
        }
        if (message.height !== 0) {
            obj.height = Math.round(message.height);
        }
        return obj;
    },
    create: function create(base) {
        return WebsiteSource_Screen.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseWebsiteSource_Screen();
        var _density;
        message.density = (_density = object.density) !== null && _density !== void 0 ? _density : 0;
        var _width;
        message.width = (_width = object.width) !== null && _width !== void 0 ? _width : 0;
        var _height;
        message.height = (_height = object.height) !== null && _height !== void 0 ? _height : 0;
        return message;
    }
};
function createBaseWebsiteSource_QueryMapEntry() {
    return {
        key: "",
        value: ""
    };
}
var WebsiteSource_QueryMapEntry = {
    fromJSON: function fromJSON(object) {
        return {
            key: sources_isSet(object.key) ? String(object.key) : "",
            value: sources_isSet(object.value) ? String(object.value) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.key !== "") {
            obj.key = message.key;
        }
        if (message.value !== "") {
            obj.value = message.value;
        }
        return obj;
    },
    create: function create(base) {
        return WebsiteSource_QueryMapEntry.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseWebsiteSource_QueryMapEntry();
        var _key;
        message.key = (_key = object.key) !== null && _key !== void 0 ? _key : "";
        var _value;
        message.value = (_value = object.value) !== null && _value !== void 0 ? _value : "";
        return message;
    }
};
function createBaseWebsiteSource_ProxyQueryMapEntry() {
    return {
        key: "",
        value: ""
    };
}
var WebsiteSource_ProxyQueryMapEntry = {
    fromJSON: function fromJSON(object) {
        return {
            key: sources_isSet(object.key) ? String(object.key) : "",
            value: sources_isSet(object.value) ? String(object.value) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.key !== "") {
            obj.key = message.key;
        }
        if (message.value !== "") {
            obj.value = message.value;
        }
        return obj;
    },
    create: function create(base) {
        return WebsiteSource_ProxyQueryMapEntry.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseWebsiteSource_ProxyQueryMapEntry();
        var _key;
        message.key = (_key = object.key) !== null && _key !== void 0 ? _key : "";
        var _value;
        message.value = (_value = object.value) !== null && _value !== void 0 ? _value : "";
        return message;
    }
};
function createBaseEdgeSource() {
    return {
        url: "",
        userAgent: undefined,
        ip: undefined,
        referrer: undefined,
        proxyPath: undefined,
        pathname: undefined,
        queryMap: {},
        host: undefined,
        proxyQueryMap: {},
        eventOrigin: 0,
        market: undefined,
        language: [],
        secPurpose: undefined
    };
}
var EdgeSource = {
    fromJSON: function fromJSON(object) {
        return {
            url: sources_isSet(object.url) ? String(object.url) : "",
            userAgent: sources_isSet(object.userAgent) ? String(object.userAgent) : undefined,
            ip: sources_isSet(object.ip) ? String(object.ip) : undefined,
            referrer: sources_isSet(object.referrer) ? String(object.referrer) : undefined,
            proxyPath: sources_isSet(object.proxyPath) ? String(object.proxyPath) : undefined,
            pathname: sources_isSet(object.pathname) ? String(object.pathname) : undefined,
            queryMap: sources_isObject(object.queryMap) ? Object.entries(object.queryMap).reduce(function(acc, param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
                acc[key] = String(value);
                return acc;
            }, {}) : {},
            host: sources_isSet(object.host) ? String(object.host) : undefined,
            proxyQueryMap: sources_isObject(object.proxyQueryMap) ? Object.entries(object.proxyQueryMap).reduce(function(acc, param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
                acc[key] = String(value);
                return acc;
            }, {}) : {},
            eventOrigin: sources_isSet(object.eventOrigin) ? edgeSource_EventOriginFromJSON(object.eventOrigin) : 0,
            market: sources_isSet(object.market) ? String(object.market) : undefined,
            language: Array.isArray(object === null || object === void 0 ? void 0 : object.language) ? object.language.map(function(e) {
                return String(e);
            }) : [],
            secPurpose: sources_isSet(object.secPurpose) ? String(object.secPurpose) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var ref;
        var obj = {};
        if (message.url !== "") {
            obj.url = message.url;
        }
        if (message.userAgent !== undefined) {
            obj.userAgent = message.userAgent;
        }
        if (message.ip !== undefined) {
            obj.ip = message.ip;
        }
        if (message.referrer !== undefined) {
            obj.referrer = message.referrer;
        }
        if (message.proxyPath !== undefined) {
            obj.proxyPath = message.proxyPath;
        }
        if (message.pathname !== undefined) {
            obj.pathname = message.pathname;
        }
        if (message.queryMap) {
            var entries = Object.entries(message.queryMap);
            if (entries.length > 0) {
                obj.queryMap = {};
                entries.forEach(function(param) {
                    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), k = _param[0], v = _param[1];
                    obj.queryMap[k] = v;
                });
            }
        }
        if (message.host !== undefined) {
            obj.host = message.host;
        }
        if (message.proxyQueryMap) {
            var entries1 = Object.entries(message.proxyQueryMap);
            if (entries1.length > 0) {
                obj.proxyQueryMap = {};
                entries1.forEach(function(param) {
                    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), k = _param[0], v = _param[1];
                    obj.proxyQueryMap[k] = v;
                });
            }
        }
        if (message.eventOrigin !== 0) {
            obj.eventOrigin = edgeSource_EventOriginToJSON(message.eventOrigin);
        }
        if (message.market !== undefined) {
            obj.market = message.market;
        }
        if ((ref = message.language) === null || ref === void 0 ? void 0 : ref.length) {
            obj.language = message.language;
        }
        if (message.secPurpose !== undefined) {
            obj.secPurpose = message.secPurpose;
        }
        return obj;
    },
    create: function create(base) {
        return EdgeSource.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref;
        var message = createBaseEdgeSource();
        var _url;
        message.url = (_url = object.url) !== null && _url !== void 0 ? _url : "";
        var _userAgent;
        message.userAgent = (_userAgent = object.userAgent) !== null && _userAgent !== void 0 ? _userAgent : undefined;
        var _ip;
        message.ip = (_ip = object.ip) !== null && _ip !== void 0 ? _ip : undefined;
        var _referrer;
        message.referrer = (_referrer = object.referrer) !== null && _referrer !== void 0 ? _referrer : undefined;
        var _proxyPath;
        message.proxyPath = (_proxyPath = object.proxyPath) !== null && _proxyPath !== void 0 ? _proxyPath : undefined;
        var _pathname;
        message.pathname = (_pathname = object.pathname) !== null && _pathname !== void 0 ? _pathname : undefined;
        var _queryMap;
        message.queryMap = Object.entries((_queryMap = object.queryMap) !== null && _queryMap !== void 0 ? _queryMap : {}).reduce(function(acc, param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
            if (value !== undefined) {
                acc[key] = String(value);
            }
            return acc;
        }, {});
        var _host;
        message.host = (_host = object.host) !== null && _host !== void 0 ? _host : undefined;
        var _proxyQueryMap;
        message.proxyQueryMap = Object.entries((_proxyQueryMap = object.proxyQueryMap) !== null && _proxyQueryMap !== void 0 ? _proxyQueryMap : {}).reduce(function(acc, param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
            if (value !== undefined) {
                acc[key] = String(value);
            }
            return acc;
        }, {});
        var _eventOrigin;
        message.eventOrigin = (_eventOrigin = object.eventOrigin) !== null && _eventOrigin !== void 0 ? _eventOrigin : 0;
        var _market;
        message.market = (_market = object.market) !== null && _market !== void 0 ? _market : undefined;
        message.language = ((ref = object.language) === null || ref === void 0 ? void 0 : ref.map(function(e) {
            return e;
        })) || [];
        var _secPurpose;
        message.secPurpose = (_secPurpose = object.secPurpose) !== null && _secPurpose !== void 0 ? _secPurpose : undefined;
        return message;
    }
};
function createBaseEdgeSource_QueryMapEntry() {
    return {
        key: "",
        value: ""
    };
}
var EdgeSource_QueryMapEntry = {
    fromJSON: function fromJSON(object) {
        return {
            key: sources_isSet(object.key) ? String(object.key) : "",
            value: sources_isSet(object.value) ? String(object.value) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.key !== "") {
            obj.key = message.key;
        }
        if (message.value !== "") {
            obj.value = message.value;
        }
        return obj;
    },
    create: function create(base) {
        return EdgeSource_QueryMapEntry.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseEdgeSource_QueryMapEntry();
        var _key;
        message.key = (_key = object.key) !== null && _key !== void 0 ? _key : "";
        var _value;
        message.value = (_value = object.value) !== null && _value !== void 0 ? _value : "";
        return message;
    }
};
function createBaseEdgeSource_ProxyQueryMapEntry() {
    return {
        key: "",
        value: ""
    };
}
var EdgeSource_ProxyQueryMapEntry = {
    fromJSON: function fromJSON(object) {
        return {
            key: sources_isSet(object.key) ? String(object.key) : "",
            value: sources_isSet(object.value) ? String(object.value) : ""
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.key !== "") {
            obj.key = message.key;
        }
        if (message.value !== "") {
            obj.value = message.value;
        }
        return obj;
    },
    create: function create(base) {
        return EdgeSource_ProxyQueryMapEntry.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseEdgeSource_ProxyQueryMapEntry();
        var _key;
        message.key = (_key = object.key) !== null && _key !== void 0 ? _key : "";
        var _value;
        message.value = (_value = object.value) !== null && _value !== void 0 ? _value : "";
        return message;
    }
};
function createBaseMobileSource() {
    return {
        userAgent: undefined,
        ip: undefined,
        appName: "",
        appBuild: undefined,
        appVersion: undefined,
        appNamespace: undefined,
        deviceId: "",
        deviceType: undefined,
        deviceModel: undefined,
        deviceManufacturer: undefined,
        deviceName: undefined,
        advertisingId: undefined,
        adTrackingEnabled: undefined,
        notificationPermissionStatus: undefined,
        carrier: undefined,
        osName: undefined,
        osVersion: undefined,
        screenDensity: undefined,
        screenHeight: undefined,
        screenWidth: undefined,
        focusRouteName: "",
        eventOrigin: 0
    };
}
var MobileSource = {
    fromJSON: function fromJSON(object) {
        return {
            userAgent: sources_isSet(object.userAgent) ? String(object.userAgent) : undefined,
            ip: sources_isSet(object.ip) ? String(object.ip) : undefined,
            appName: sources_isSet(object.appName) ? String(object.appName) : "",
            appBuild: sources_isSet(object.appBuild) ? String(object.appBuild) : undefined,
            appVersion: sources_isSet(object.appVersion) ? String(object.appVersion) : undefined,
            appNamespace: sources_isSet(object.appNamespace) ? String(object.appNamespace) : undefined,
            deviceId: sources_isSet(object.deviceId) ? String(object.deviceId) : "",
            deviceType: sources_isSet(object.deviceType) ? String(object.deviceType) : undefined,
            deviceModel: sources_isSet(object.deviceModel) ? String(object.deviceModel) : undefined,
            deviceManufacturer: sources_isSet(object.deviceManufacturer) ? String(object.deviceManufacturer) : undefined,
            deviceName: sources_isSet(object.deviceName) ? String(object.deviceName) : undefined,
            advertisingId: sources_isSet(object.advertisingId) ? String(object.advertisingId) : undefined,
            adTrackingEnabled: sources_isSet(object.adTrackingEnabled) ? Boolean(object.adTrackingEnabled) : undefined,
            notificationPermissionStatus: sources_isSet(object.notificationPermissionStatus) ? String(object.notificationPermissionStatus) : undefined,
            carrier: sources_isSet(object.carrier) ? String(object.carrier) : undefined,
            osName: sources_isSet(object.osName) ? String(object.osName) : undefined,
            osVersion: sources_isSet(object.osVersion) ? String(object.osVersion) : undefined,
            screenDensity: sources_isSet(object.screenDensity) ? Number(object.screenDensity) : undefined,
            screenHeight: sources_isSet(object.screenHeight) ? Number(object.screenHeight) : undefined,
            screenWidth: sources_isSet(object.screenWidth) ? Number(object.screenWidth) : undefined,
            focusRouteName: sources_isSet(object.focusRouteName) ? String(object.focusRouteName) : "",
            eventOrigin: sources_isSet(object.eventOrigin) ? mobileSource_EventOriginFromJSON(object.eventOrigin) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.userAgent !== undefined) {
            obj.userAgent = message.userAgent;
        }
        if (message.ip !== undefined) {
            obj.ip = message.ip;
        }
        if (message.appName !== "") {
            obj.appName = message.appName;
        }
        if (message.appBuild !== undefined) {
            obj.appBuild = message.appBuild;
        }
        if (message.appVersion !== undefined) {
            obj.appVersion = message.appVersion;
        }
        if (message.appNamespace !== undefined) {
            obj.appNamespace = message.appNamespace;
        }
        if (message.deviceId !== "") {
            obj.deviceId = message.deviceId;
        }
        if (message.deviceType !== undefined) {
            obj.deviceType = message.deviceType;
        }
        if (message.deviceModel !== undefined) {
            obj.deviceModel = message.deviceModel;
        }
        if (message.deviceManufacturer !== undefined) {
            obj.deviceManufacturer = message.deviceManufacturer;
        }
        if (message.deviceName !== undefined) {
            obj.deviceName = message.deviceName;
        }
        if (message.advertisingId !== undefined) {
            obj.advertisingId = message.advertisingId;
        }
        if (message.adTrackingEnabled !== undefined) {
            obj.adTrackingEnabled = message.adTrackingEnabled;
        }
        if (message.notificationPermissionStatus !== undefined) {
            obj.notificationPermissionStatus = message.notificationPermissionStatus;
        }
        if (message.carrier !== undefined) {
            obj.carrier = message.carrier;
        }
        if (message.osName !== undefined) {
            obj.osName = message.osName;
        }
        if (message.osVersion !== undefined) {
            obj.osVersion = message.osVersion;
        }
        if (message.screenDensity !== undefined) {
            obj.screenDensity = message.screenDensity;
        }
        if (message.screenHeight !== undefined) {
            obj.screenHeight = message.screenHeight;
        }
        if (message.screenWidth !== undefined) {
            obj.screenWidth = message.screenWidth;
        }
        if (message.focusRouteName !== "") {
            obj.focusRouteName = message.focusRouteName;
        }
        if (message.eventOrigin !== 0) {
            obj.eventOrigin = mobileSource_EventOriginToJSON(message.eventOrigin);
        }
        return obj;
    },
    create: function create(base) {
        return MobileSource.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseMobileSource();
        var _userAgent;
        message.userAgent = (_userAgent = object.userAgent) !== null && _userAgent !== void 0 ? _userAgent : undefined;
        var _ip;
        message.ip = (_ip = object.ip) !== null && _ip !== void 0 ? _ip : undefined;
        var _appName;
        message.appName = (_appName = object.appName) !== null && _appName !== void 0 ? _appName : "";
        var _appBuild;
        message.appBuild = (_appBuild = object.appBuild) !== null && _appBuild !== void 0 ? _appBuild : undefined;
        var _appVersion;
        message.appVersion = (_appVersion = object.appVersion) !== null && _appVersion !== void 0 ? _appVersion : undefined;
        var _appNamespace;
        message.appNamespace = (_appNamespace = object.appNamespace) !== null && _appNamespace !== void 0 ? _appNamespace : undefined;
        var _deviceId;
        message.deviceId = (_deviceId = object.deviceId) !== null && _deviceId !== void 0 ? _deviceId : "";
        var _deviceType;
        message.deviceType = (_deviceType = object.deviceType) !== null && _deviceType !== void 0 ? _deviceType : undefined;
        var _deviceModel;
        message.deviceModel = (_deviceModel = object.deviceModel) !== null && _deviceModel !== void 0 ? _deviceModel : undefined;
        var _deviceManufacturer;
        message.deviceManufacturer = (_deviceManufacturer = object.deviceManufacturer) !== null && _deviceManufacturer !== void 0 ? _deviceManufacturer : undefined;
        var _deviceName;
        message.deviceName = (_deviceName = object.deviceName) !== null && _deviceName !== void 0 ? _deviceName : undefined;
        var _advertisingId;
        message.advertisingId = (_advertisingId = object.advertisingId) !== null && _advertisingId !== void 0 ? _advertisingId : undefined;
        var _adTrackingEnabled;
        message.adTrackingEnabled = (_adTrackingEnabled = object.adTrackingEnabled) !== null && _adTrackingEnabled !== void 0 ? _adTrackingEnabled : undefined;
        var _notificationPermissionStatus;
        message.notificationPermissionStatus = (_notificationPermissionStatus = object.notificationPermissionStatus) !== null && _notificationPermissionStatus !== void 0 ? _notificationPermissionStatus : undefined;
        var _carrier;
        message.carrier = (_carrier = object.carrier) !== null && _carrier !== void 0 ? _carrier : undefined;
        var _osName;
        message.osName = (_osName = object.osName) !== null && _osName !== void 0 ? _osName : undefined;
        var _osVersion;
        message.osVersion = (_osVersion = object.osVersion) !== null && _osVersion !== void 0 ? _osVersion : undefined;
        var _screenDensity;
        message.screenDensity = (_screenDensity = object.screenDensity) !== null && _screenDensity !== void 0 ? _screenDensity : undefined;
        var _screenHeight;
        message.screenHeight = (_screenHeight = object.screenHeight) !== null && _screenHeight !== void 0 ? _screenHeight : undefined;
        var _screenWidth;
        message.screenWidth = (_screenWidth = object.screenWidth) !== null && _screenWidth !== void 0 ? _screenWidth : undefined;
        var _focusRouteName;
        message.focusRouteName = (_focusRouteName = object.focusRouteName) !== null && _focusRouteName !== void 0 ? _focusRouteName : "";
        var _eventOrigin;
        message.eventOrigin = (_eventOrigin = object.eventOrigin) !== null && _eventOrigin !== void 0 ? _eventOrigin : 0;
        return message;
    }
};
function createBaseBackendSource() {
    return {
        name: "",
        clientUserAgent: undefined,
        clientIp: undefined
    };
}
var BackendSource = {
    fromJSON: function fromJSON(object) {
        return {
            name: sources_isSet(object.name) ? String(object.name) : "",
            clientUserAgent: sources_isSet(object.clientUserAgent) ? String(object.clientUserAgent) : undefined,
            clientIp: sources_isSet(object.clientIp) ? String(object.clientIp) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.name !== "") {
            obj.name = message.name;
        }
        if (message.clientUserAgent !== undefined) {
            obj.clientUserAgent = message.clientUserAgent;
        }
        if (message.clientIp !== undefined) {
            obj.clientIp = message.clientIp;
        }
        return obj;
    },
    create: function create(base) {
        return BackendSource.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseBackendSource();
        var _name;
        message.name = (_name = object.name) !== null && _name !== void 0 ? _name : "";
        var _clientUserAgent;
        message.clientUserAgent = (_clientUserAgent = object.clientUserAgent) !== null && _clientUserAgent !== void 0 ? _clientUserAgent : undefined;
        var _clientIp;
        message.clientIp = (_clientIp = object.clientIp) !== null && _clientIp !== void 0 ? _clientIp : undefined;
        return message;
    }
};
function createBaseBackfillSource() {
    return {
        eventOrigin: 0
    };
}
var BackfillSource = {
    fromJSON: function fromJSON(object) {
        return {
            eventOrigin: sources_isSet(object.eventOrigin) ? backfillSource_EventOriginFromJSON(object.eventOrigin) : 0
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.eventOrigin !== 0) {
            obj.eventOrigin = backfillSource_EventOriginToJSON(message.eventOrigin);
        }
        return obj;
    },
    create: function create(base) {
        return BackfillSource.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseBackfillSource();
        var _eventOrigin;
        message.eventOrigin = (_eventOrigin = object.eventOrigin) !== null && _eventOrigin !== void 0 ? _eventOrigin : 0;
        return message;
    }
};
function sources_isObject(value) {
    return typeof value === "object" && value !== null;
}
function sources_isSet(value) {
    return value !== null && value !== undefined;
}

;// CONCATENATED MODULE: ./src/__generated__/protobuf/journey/data/event_wrapper.ts
/* eslint-disable */ 



























var event_wrapper_protobufPackage = "od_protos.journey.data";
var InternalEventWrapper_Destination;
(function(InternalEventWrapper_Destination) {
    InternalEventWrapper_Destination[InternalEventWrapper_Destination["UNKNOWN"] = 0] = "UNKNOWN";
    InternalEventWrapper_Destination[InternalEventWrapper_Destination["ALL"] = 1] = "ALL";
    InternalEventWrapper_Destination[InternalEventWrapper_Destination["SEGMENT_TRACK"] = 2] = "SEGMENT_TRACK";
    InternalEventWrapper_Destination[InternalEventWrapper_Destination["SEGMENT_IDENTIFY"] = 3] = "SEGMENT_IDENTIFY";
    InternalEventWrapper_Destination[InternalEventWrapper_Destination["AMPLITUDE"] = 4] = "AMPLITUDE";
    InternalEventWrapper_Destination[InternalEventWrapper_Destination["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(InternalEventWrapper_Destination || (InternalEventWrapper_Destination = {}));
function internalEventWrapper_DestinationFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN":
            return InternalEventWrapper_Destination.UNKNOWN;
        case 1:
        case "ALL":
            return InternalEventWrapper_Destination.ALL;
        case 2:
        case "SEGMENT_TRACK":
            return InternalEventWrapper_Destination.SEGMENT_TRACK;
        case 3:
        case "SEGMENT_IDENTIFY":
            return InternalEventWrapper_Destination.SEGMENT_IDENTIFY;
        case 4:
        case "AMPLITUDE":
            return InternalEventWrapper_Destination.AMPLITUDE;
        case -1:
        case "UNRECOGNIZED":
        default:
            return InternalEventWrapper_Destination.UNRECOGNIZED;
    }
}
function internalEventWrapper_DestinationToJSON(object) {
    switch(object){
        case InternalEventWrapper_Destination.UNKNOWN:
            return "UNKNOWN";
        case InternalEventWrapper_Destination.ALL:
            return "ALL";
        case InternalEventWrapper_Destination.SEGMENT_TRACK:
            return "SEGMENT_TRACK";
        case InternalEventWrapper_Destination.SEGMENT_IDENTIFY:
            return "SEGMENT_IDENTIFY";
        case InternalEventWrapper_Destination.AMPLITUDE:
            return "AMPLITUDE";
        case InternalEventWrapper_Destination.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
function createBaseInternalEventWrapper() {
    return {
        id: "",
        eventWrapper: undefined,
        receivedAt: undefined,
        consentSellOrShare: undefined,
        leadEnrichedTraits: {},
        hydrated: undefined,
        destination: 0,
        customerEnrichedTraits: {},
        sessionId: undefined,
        email: undefined,
        phone: undefined
    };
}
var InternalEventWrapper = {
    fromJSON: function fromJSON(object) {
        return {
            id: event_wrapper_isSet(object.id) ? String(object.id) : "",
            eventWrapper: event_wrapper_isSet(object.eventWrapper) ? EventWrapper.fromJSON(object.eventWrapper) : undefined,
            receivedAt: event_wrapper_isSet(object.receivedAt) ? event_wrapper_fromJsonTimestamp(object.receivedAt) : undefined,
            consentSellOrShare: event_wrapper_isSet(object.consentSellOrShare) ? Boolean(object.consentSellOrShare) : undefined,
            leadEnrichedTraits: event_wrapper_isObject(object.leadEnrichedTraits) ? Object.entries(object.leadEnrichedTraits).reduce(function(acc, param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
                acc[key] = value;
                return acc;
            }, {}) : {},
            hydrated: event_wrapper_isSet(object.hydrated) ? Hydrated.fromJSON(object.hydrated) : undefined,
            destination: event_wrapper_isSet(object.destination) ? internalEventWrapper_DestinationFromJSON(object.destination) : 0,
            customerEnrichedTraits: event_wrapper_isObject(object.customerEnrichedTraits) ? Object.entries(object.customerEnrichedTraits).reduce(function(acc, param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
                acc[key] = value;
                return acc;
            }, {}) : {},
            sessionId: event_wrapper_isSet(object.sessionId) ? Number(object.sessionId) : undefined,
            email: event_wrapper_isSet(object.email) ? String(object.email) : undefined,
            phone: event_wrapper_isSet(object.phone) ? String(object.phone) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.eventWrapper !== undefined) {
            obj.eventWrapper = EventWrapper.toJSON(message.eventWrapper);
        }
        if (message.receivedAt !== undefined) {
            obj.receivedAt = message.receivedAt.toISOString();
        }
        if (message.consentSellOrShare !== undefined) {
            obj.consentSellOrShare = message.consentSellOrShare;
        }
        if (message.leadEnrichedTraits) {
            var entries = Object.entries(message.leadEnrichedTraits);
            if (entries.length > 0) {
                obj.leadEnrichedTraits = {};
                entries.forEach(function(param) {
                    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), k = _param[0], v = _param[1];
                    obj.leadEnrichedTraits[k] = v;
                });
            }
        }
        if (message.hydrated !== undefined) {
            obj.hydrated = Hydrated.toJSON(message.hydrated);
        }
        if (message.destination !== 0) {
            obj.destination = internalEventWrapper_DestinationToJSON(message.destination);
        }
        if (message.customerEnrichedTraits) {
            var entries1 = Object.entries(message.customerEnrichedTraits);
            if (entries1.length > 0) {
                obj.customerEnrichedTraits = {};
                entries1.forEach(function(param) {
                    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), k = _param[0], v = _param[1];
                    obj.customerEnrichedTraits[k] = v;
                });
            }
        }
        if (message.sessionId !== undefined) {
            obj.sessionId = message.sessionId;
        }
        if (message.email !== undefined) {
            obj.email = message.email;
        }
        if (message.phone !== undefined) {
            obj.phone = message.phone;
        }
        return obj;
    },
    create: function create(base) {
        return InternalEventWrapper.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseInternalEventWrapper();
        var _id;
        message.id = (_id = object.id) !== null && _id !== void 0 ? _id : "";
        message.eventWrapper = object.eventWrapper !== undefined && object.eventWrapper !== null ? EventWrapper.fromPartial(object.eventWrapper) : undefined;
        var _receivedAt;
        message.receivedAt = (_receivedAt = object.receivedAt) !== null && _receivedAt !== void 0 ? _receivedAt : undefined;
        var _consentSellOrShare;
        message.consentSellOrShare = (_consentSellOrShare = object.consentSellOrShare) !== null && _consentSellOrShare !== void 0 ? _consentSellOrShare : undefined;
        var _leadEnrichedTraits;
        message.leadEnrichedTraits = Object.entries((_leadEnrichedTraits = object.leadEnrichedTraits) !== null && _leadEnrichedTraits !== void 0 ? _leadEnrichedTraits : {}).reduce(function(acc, param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
            if (value !== undefined) {
                acc[key] = value;
            }
            return acc;
        }, {});
        message.hydrated = object.hydrated !== undefined && object.hydrated !== null ? Hydrated.fromPartial(object.hydrated) : undefined;
        var _destination;
        message.destination = (_destination = object.destination) !== null && _destination !== void 0 ? _destination : 0;
        var _customerEnrichedTraits;
        message.customerEnrichedTraits = Object.entries((_customerEnrichedTraits = object.customerEnrichedTraits) !== null && _customerEnrichedTraits !== void 0 ? _customerEnrichedTraits : {}).reduce(function(acc, param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
            if (value !== undefined) {
                acc[key] = value;
            }
            return acc;
        }, {});
        var _sessionId;
        message.sessionId = (_sessionId = object.sessionId) !== null && _sessionId !== void 0 ? _sessionId : undefined;
        var _email;
        message.email = (_email = object.email) !== null && _email !== void 0 ? _email : undefined;
        var _phone;
        message.phone = (_phone = object.phone) !== null && _phone !== void 0 ? _phone : undefined;
        return message;
    }
};
function createBaseInternalEventWrapper_LeadEnrichedTraitsEntry() {
    return {
        key: "",
        value: undefined
    };
}
var InternalEventWrapper_LeadEnrichedTraitsEntry = {
    fromJSON: function fromJSON(object) {
        return {
            key: event_wrapper_isSet(object.key) ? String(object.key) : "",
            value: event_wrapper_isSet(object === null || object === void 0 ? void 0 : object.value) ? object.value : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.key !== "") {
            obj.key = message.key;
        }
        if (message.value !== undefined) {
            obj.value = message.value;
        }
        return obj;
    },
    create: function create(base) {
        return InternalEventWrapper_LeadEnrichedTraitsEntry.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseInternalEventWrapper_LeadEnrichedTraitsEntry();
        var _key;
        message.key = (_key = object.key) !== null && _key !== void 0 ? _key : "";
        var _value;
        message.value = (_value = object.value) !== null && _value !== void 0 ? _value : undefined;
        return message;
    }
};
function createBaseInternalEventWrapper_CustomerEnrichedTraitsEntry() {
    return {
        key: "",
        value: undefined
    };
}
var InternalEventWrapper_CustomerEnrichedTraitsEntry = {
    fromJSON: function fromJSON(object) {
        return {
            key: event_wrapper_isSet(object.key) ? String(object.key) : "",
            value: event_wrapper_isSet(object === null || object === void 0 ? void 0 : object.value) ? object.value : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.key !== "") {
            obj.key = message.key;
        }
        if (message.value !== undefined) {
            obj.value = message.value;
        }
        return obj;
    },
    create: function create(base) {
        return InternalEventWrapper_CustomerEnrichedTraitsEntry.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseInternalEventWrapper_CustomerEnrichedTraitsEntry();
        var _key;
        message.key = (_key = object.key) !== null && _key !== void 0 ? _key : "";
        var _value;
        message.value = (_value = object.value) !== null && _value !== void 0 ? _value : undefined;
        return message;
    }
};
function createBaseEventWrapperList() {
    return {
        eventWrappers: []
    };
}
var EventWrapperList = {
    fromJSON: function fromJSON(object) {
        return {
            eventWrappers: Array.isArray(object === null || object === void 0 ? void 0 : object.eventWrappers) ? object.eventWrappers.map(function(e) {
                return EventWrapper.fromJSON(e);
            }) : []
        };
    },
    toJSON: function toJSON(message) {
        var ref;
        var obj = {};
        if ((ref = message.eventWrappers) === null || ref === void 0 ? void 0 : ref.length) {
            obj.eventWrappers = message.eventWrappers.map(function(e) {
                return EventWrapper.toJSON(e);
            });
        }
        return obj;
    },
    create: function create(base) {
        return EventWrapperList.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref;
        var message = createBaseEventWrapperList();
        message.eventWrappers = ((ref = object.eventWrappers) === null || ref === void 0 ? void 0 : ref.map(function(e) {
            return EventWrapper.fromPartial(e);
        })) || [];
        return message;
    }
};
function createBaseEventWrapper() {
    return {
        timestamp: undefined,
        source: undefined,
        anonymousId: undefined,
        customerUuid: undefined,
        campaignContext: undefined,
        category: undefined,
        analyticsContext: undefined,
        clientEventId: undefined
    };
}
var EventWrapper = {
    fromJSON: function fromJSON(object) {
        return {
            timestamp: event_wrapper_isSet(object.timestamp) ? event_wrapper_fromJsonTimestamp(object.timestamp) : undefined,
            source: event_wrapper_isSet(object.websiteSource) ? {
                $case: "websiteSource",
                websiteSource: WebsiteSource.fromJSON(object.websiteSource)
            } : event_wrapper_isSet(object.mobileSource) ? {
                $case: "mobileSource",
                mobileSource: MobileSource.fromJSON(object.mobileSource)
            } : event_wrapper_isSet(object.backendSource) ? {
                $case: "backendSource",
                backendSource: BackendSource.fromJSON(object.backendSource)
            } : event_wrapper_isSet(object.edgeSource) ? {
                $case: "edgeSource",
                edgeSource: EdgeSource.fromJSON(object.edgeSource)
            } : event_wrapper_isSet(object.backfillSource) ? {
                $case: "backfillSource",
                backfillSource: BackfillSource.fromJSON(object.backfillSource)
            } : undefined,
            anonymousId: event_wrapper_isSet(object.anonymousId) ? String(object.anonymousId) : undefined,
            customerUuid: event_wrapper_isSet(object.customerUuid) ? String(object.customerUuid) : undefined,
            campaignContext: event_wrapper_isSet(object.campaignContext) ? CampaignContext.fromJSON(object.campaignContext) : undefined,
            category: event_wrapper_isSet(object.experimentation) ? {
                $case: "experimentation",
                experimentation: ExperimentationCategory.fromJSON(object.experimentation)
            } : event_wrapper_isSet(object.authentication) ? {
                $case: "authentication",
                authentication: AuthenticationCategory.fromJSON(object.authentication)
            } : event_wrapper_isSet(object.sellOnboarding) ? {
                $case: "sellOnboarding",
                sellOnboarding: SellOnboardingCategory.fromJSON(object.sellOnboarding)
            } : event_wrapper_isSet(object.platform) ? {
                $case: "platform",
                platform: PlatformCategory.fromJSON(object.platform)
            } : event_wrapper_isSet(object.sell) ? {
                $case: "sell",
                sell: SellCategory.fromJSON(object.sell)
            } : event_wrapper_isSet(object.sellDirect) ? {
                $case: "sellDirect",
                sellDirect: SellDirectCategory.fromJSON(object.sellDirect)
            } : event_wrapper_isSet(object.sellList) ? {
                $case: "sellList",
                sellList: SellListCategory.fromJSON(object.sellList)
            } : event_wrapper_isSet(object.sellEa) ? {
                $case: "sellEa",
                sellEa: SellEACategory.fromJSON(object.sellEa)
            } : event_wrapper_isSet(object.sellOrva) ? {
                $case: "sellOrva",
                sellOrva: SellORVACategory.fromJSON(object.sellOrva)
            } : event_wrapper_isSet(object.sellVa) ? {
                $case: "sellVa",
                sellVa: SellVACategory.fromJSON(object.sellVa)
            } : event_wrapper_isSet(object.chat) ? {
                $case: "chat",
                chat: ChatCategory.fromJSON(object.chat)
            } : event_wrapper_isSet(object.retailWebUnlock) ? {
                $case: "retailWebUnlock",
                retailWebUnlock: retail_web_unlock_category/* RetailWebUnlockCategory.fromJSON */.kv.fromJSON(object.retailWebUnlock)
            } : event_wrapper_isSet(object.communication) ? {
                $case: "communication",
                communication: CommunicationCategory.fromJSON(object.communication)
            } : event_wrapper_isSet(object.sellOfferReview) ? {
                $case: "sellOfferReview",
                sellOfferReview: SellOfferReviewCategory.fromJSON(object.sellOfferReview)
            } : event_wrapper_isSet(object.assessment) ? {
                $case: "assessment",
                assessment: AssessmentCategory.fromJSON(object.assessment)
            } : event_wrapper_isSet(object.marketplaceProperty) ? {
                $case: "marketplaceProperty",
                marketplaceProperty: marketplace_property_category/* MarketplacePropertyCategory.fromJSON */.SG.fromJSON(object.marketplaceProperty)
            } : event_wrapper_isSet(object.homeGuide) ? {
                $case: "homeGuide",
                homeGuide: HomeGuideCategory.fromJSON(object.homeGuide)
            } : event_wrapper_isSet(object.alo) ? {
                $case: "alo",
                alo: AloCategory.fromJSON(object.alo)
            } : event_wrapper_isSet(object.language) ? {
                $case: "language",
                language: LanguageCategory.fromJSON(object.language)
            } : event_wrapper_isSet(object.sellWithUpside) ? {
                $case: "sellWithUpside",
                sellWithUpside: SellWithUpsideCategory.fromJSON(object.sellWithUpside)
            } : event_wrapper_isSet(object.agentConnect) ? {
                $case: "agentConnect",
                agentConnect: AgentConnectCategory.fromJSON(object.agentConnect)
            } : event_wrapper_isSet(object.sellFinalOfferCall) ? {
                $case: "sellFinalOfferCall",
                sellFinalOfferCall: SellFinalOfferCallCategory.fromJSON(object.sellFinalOfferCall)
            } : event_wrapper_isSet(object.mortgage) ? {
                $case: "mortgage",
                mortgage: MortgageCategory.fromJSON(object.mortgage)
            } : undefined,
            analyticsContext: event_wrapper_isSet(object.analyticsContext) ? AnalyticsContext.fromJSON(object.analyticsContext) : undefined,
            clientEventId: event_wrapper_isSet(object.clientEventId) ? String(object.clientEventId) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27;
        var obj = {};
        if (message.timestamp !== undefined) {
            obj.timestamp = message.timestamp.toISOString();
        }
        if (((ref = message.source) === null || ref === void 0 ? void 0 : ref.$case) === "websiteSource") {
            obj.websiteSource = WebsiteSource.toJSON(message.source.websiteSource);
        }
        if (((ref1 = message.source) === null || ref1 === void 0 ? void 0 : ref1.$case) === "mobileSource") {
            obj.mobileSource = MobileSource.toJSON(message.source.mobileSource);
        }
        if (((ref2 = message.source) === null || ref2 === void 0 ? void 0 : ref2.$case) === "backendSource") {
            obj.backendSource = BackendSource.toJSON(message.source.backendSource);
        }
        if (((ref3 = message.source) === null || ref3 === void 0 ? void 0 : ref3.$case) === "edgeSource") {
            obj.edgeSource = EdgeSource.toJSON(message.source.edgeSource);
        }
        if (((ref4 = message.source) === null || ref4 === void 0 ? void 0 : ref4.$case) === "backfillSource") {
            obj.backfillSource = BackfillSource.toJSON(message.source.backfillSource);
        }
        if (message.anonymousId !== undefined) {
            obj.anonymousId = message.anonymousId;
        }
        if (message.customerUuid !== undefined) {
            obj.customerUuid = message.customerUuid;
        }
        if (message.campaignContext !== undefined) {
            obj.campaignContext = CampaignContext.toJSON(message.campaignContext);
        }
        if (((ref5 = message.category) === null || ref5 === void 0 ? void 0 : ref5.$case) === "experimentation") {
            obj.experimentation = ExperimentationCategory.toJSON(message.category.experimentation);
        }
        if (((ref6 = message.category) === null || ref6 === void 0 ? void 0 : ref6.$case) === "authentication") {
            obj.authentication = AuthenticationCategory.toJSON(message.category.authentication);
        }
        if (((ref7 = message.category) === null || ref7 === void 0 ? void 0 : ref7.$case) === "sellOnboarding") {
            obj.sellOnboarding = SellOnboardingCategory.toJSON(message.category.sellOnboarding);
        }
        if (((ref8 = message.category) === null || ref8 === void 0 ? void 0 : ref8.$case) === "platform") {
            obj.platform = PlatformCategory.toJSON(message.category.platform);
        }
        if (((ref9 = message.category) === null || ref9 === void 0 ? void 0 : ref9.$case) === "sell") {
            obj.sell = SellCategory.toJSON(message.category.sell);
        }
        if (((ref10 = message.category) === null || ref10 === void 0 ? void 0 : ref10.$case) === "sellDirect") {
            obj.sellDirect = SellDirectCategory.toJSON(message.category.sellDirect);
        }
        if (((ref11 = message.category) === null || ref11 === void 0 ? void 0 : ref11.$case) === "sellList") {
            obj.sellList = SellListCategory.toJSON(message.category.sellList);
        }
        if (((ref12 = message.category) === null || ref12 === void 0 ? void 0 : ref12.$case) === "sellEa") {
            obj.sellEa = SellEACategory.toJSON(message.category.sellEa);
        }
        if (((ref13 = message.category) === null || ref13 === void 0 ? void 0 : ref13.$case) === "sellOrva") {
            obj.sellOrva = SellORVACategory.toJSON(message.category.sellOrva);
        }
        if (((ref14 = message.category) === null || ref14 === void 0 ? void 0 : ref14.$case) === "sellVa") {
            obj.sellVa = SellVACategory.toJSON(message.category.sellVa);
        }
        if (((ref15 = message.category) === null || ref15 === void 0 ? void 0 : ref15.$case) === "chat") {
            obj.chat = ChatCategory.toJSON(message.category.chat);
        }
        if (((ref16 = message.category) === null || ref16 === void 0 ? void 0 : ref16.$case) === "retailWebUnlock") {
            obj.retailWebUnlock = retail_web_unlock_category/* RetailWebUnlockCategory.toJSON */.kv.toJSON(message.category.retailWebUnlock);
        }
        if (((ref17 = message.category) === null || ref17 === void 0 ? void 0 : ref17.$case) === "communication") {
            obj.communication = CommunicationCategory.toJSON(message.category.communication);
        }
        if (((ref18 = message.category) === null || ref18 === void 0 ? void 0 : ref18.$case) === "sellOfferReview") {
            obj.sellOfferReview = SellOfferReviewCategory.toJSON(message.category.sellOfferReview);
        }
        if (((ref19 = message.category) === null || ref19 === void 0 ? void 0 : ref19.$case) === "assessment") {
            obj.assessment = AssessmentCategory.toJSON(message.category.assessment);
        }
        if (((ref20 = message.category) === null || ref20 === void 0 ? void 0 : ref20.$case) === "marketplaceProperty") {
            obj.marketplaceProperty = marketplace_property_category/* MarketplacePropertyCategory.toJSON */.SG.toJSON(message.category.marketplaceProperty);
        }
        if (((ref21 = message.category) === null || ref21 === void 0 ? void 0 : ref21.$case) === "homeGuide") {
            obj.homeGuide = HomeGuideCategory.toJSON(message.category.homeGuide);
        }
        if (((ref22 = message.category) === null || ref22 === void 0 ? void 0 : ref22.$case) === "alo") {
            obj.alo = AloCategory.toJSON(message.category.alo);
        }
        if (((ref23 = message.category) === null || ref23 === void 0 ? void 0 : ref23.$case) === "language") {
            obj.language = LanguageCategory.toJSON(message.category.language);
        }
        if (((ref24 = message.category) === null || ref24 === void 0 ? void 0 : ref24.$case) === "sellWithUpside") {
            obj.sellWithUpside = SellWithUpsideCategory.toJSON(message.category.sellWithUpside);
        }
        if (((ref25 = message.category) === null || ref25 === void 0 ? void 0 : ref25.$case) === "agentConnect") {
            obj.agentConnect = AgentConnectCategory.toJSON(message.category.agentConnect);
        }
        if (((ref26 = message.category) === null || ref26 === void 0 ? void 0 : ref26.$case) === "sellFinalOfferCall") {
            obj.sellFinalOfferCall = SellFinalOfferCallCategory.toJSON(message.category.sellFinalOfferCall);
        }
        if (((ref27 = message.category) === null || ref27 === void 0 ? void 0 : ref27.$case) === "mortgage") {
            obj.mortgage = MortgageCategory.toJSON(message.category.mortgage);
        }
        if (message.analyticsContext !== undefined) {
            obj.analyticsContext = AnalyticsContext.toJSON(message.analyticsContext);
        }
        if (message.clientEventId !== undefined) {
            obj.clientEventId = message.clientEventId;
        }
        return obj;
    },
    create: function create(base) {
        return EventWrapper.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40, ref41, ref42, ref43, ref44, ref45, ref46, ref47, ref48, ref49, ref50, ref51, ref52, ref53, ref54, ref55, ref56, ref57, ref58, ref59, ref60, ref61, ref62, ref63, ref64, ref65, ref66, ref67, ref68, ref69, ref70, ref71, ref72, ref73, ref74, ref75, ref76, ref77, ref78, ref79, ref80, ref81, ref82, ref83;
        var message = createBaseEventWrapper();
        var _timestamp;
        message.timestamp = (_timestamp = object.timestamp) !== null && _timestamp !== void 0 ? _timestamp : undefined;
        if (((ref = object.source) === null || ref === void 0 ? void 0 : ref.$case) === "websiteSource" && ((ref1 = object.source) === null || ref1 === void 0 ? void 0 : ref1.websiteSource) !== undefined && ((ref2 = object.source) === null || ref2 === void 0 ? void 0 : ref2.websiteSource) !== null) {
            message.source = {
                $case: "websiteSource",
                websiteSource: WebsiteSource.fromPartial(object.source.websiteSource)
            };
        }
        if (((ref3 = object.source) === null || ref3 === void 0 ? void 0 : ref3.$case) === "mobileSource" && ((ref4 = object.source) === null || ref4 === void 0 ? void 0 : ref4.mobileSource) !== undefined && ((ref5 = object.source) === null || ref5 === void 0 ? void 0 : ref5.mobileSource) !== null) {
            message.source = {
                $case: "mobileSource",
                mobileSource: MobileSource.fromPartial(object.source.mobileSource)
            };
        }
        if (((ref6 = object.source) === null || ref6 === void 0 ? void 0 : ref6.$case) === "backendSource" && ((ref7 = object.source) === null || ref7 === void 0 ? void 0 : ref7.backendSource) !== undefined && ((ref8 = object.source) === null || ref8 === void 0 ? void 0 : ref8.backendSource) !== null) {
            message.source = {
                $case: "backendSource",
                backendSource: BackendSource.fromPartial(object.source.backendSource)
            };
        }
        if (((ref9 = object.source) === null || ref9 === void 0 ? void 0 : ref9.$case) === "edgeSource" && ((ref10 = object.source) === null || ref10 === void 0 ? void 0 : ref10.edgeSource) !== undefined && ((ref11 = object.source) === null || ref11 === void 0 ? void 0 : ref11.edgeSource) !== null) {
            message.source = {
                $case: "edgeSource",
                edgeSource: EdgeSource.fromPartial(object.source.edgeSource)
            };
        }
        if (((ref12 = object.source) === null || ref12 === void 0 ? void 0 : ref12.$case) === "backfillSource" && ((ref13 = object.source) === null || ref13 === void 0 ? void 0 : ref13.backfillSource) !== undefined && ((ref14 = object.source) === null || ref14 === void 0 ? void 0 : ref14.backfillSource) !== null) {
            message.source = {
                $case: "backfillSource",
                backfillSource: BackfillSource.fromPartial(object.source.backfillSource)
            };
        }
        var _anonymousId;
        message.anonymousId = (_anonymousId = object.anonymousId) !== null && _anonymousId !== void 0 ? _anonymousId : undefined;
        var _customerUuid;
        message.customerUuid = (_customerUuid = object.customerUuid) !== null && _customerUuid !== void 0 ? _customerUuid : undefined;
        message.campaignContext = object.campaignContext !== undefined && object.campaignContext !== null ? CampaignContext.fromPartial(object.campaignContext) : undefined;
        if (((ref15 = object.category) === null || ref15 === void 0 ? void 0 : ref15.$case) === "experimentation" && ((ref16 = object.category) === null || ref16 === void 0 ? void 0 : ref16.experimentation) !== undefined && ((ref17 = object.category) === null || ref17 === void 0 ? void 0 : ref17.experimentation) !== null) {
            message.category = {
                $case: "experimentation",
                experimentation: ExperimentationCategory.fromPartial(object.category.experimentation)
            };
        }
        if (((ref18 = object.category) === null || ref18 === void 0 ? void 0 : ref18.$case) === "authentication" && ((ref19 = object.category) === null || ref19 === void 0 ? void 0 : ref19.authentication) !== undefined && ((ref20 = object.category) === null || ref20 === void 0 ? void 0 : ref20.authentication) !== null) {
            message.category = {
                $case: "authentication",
                authentication: AuthenticationCategory.fromPartial(object.category.authentication)
            };
        }
        if (((ref21 = object.category) === null || ref21 === void 0 ? void 0 : ref21.$case) === "sellOnboarding" && ((ref22 = object.category) === null || ref22 === void 0 ? void 0 : ref22.sellOnboarding) !== undefined && ((ref23 = object.category) === null || ref23 === void 0 ? void 0 : ref23.sellOnboarding) !== null) {
            message.category = {
                $case: "sellOnboarding",
                sellOnboarding: SellOnboardingCategory.fromPartial(object.category.sellOnboarding)
            };
        }
        if (((ref24 = object.category) === null || ref24 === void 0 ? void 0 : ref24.$case) === "platform" && ((ref25 = object.category) === null || ref25 === void 0 ? void 0 : ref25.platform) !== undefined && ((ref26 = object.category) === null || ref26 === void 0 ? void 0 : ref26.platform) !== null) {
            message.category = {
                $case: "platform",
                platform: PlatformCategory.fromPartial(object.category.platform)
            };
        }
        if (((ref27 = object.category) === null || ref27 === void 0 ? void 0 : ref27.$case) === "sell" && ((ref28 = object.category) === null || ref28 === void 0 ? void 0 : ref28.sell) !== undefined && ((ref29 = object.category) === null || ref29 === void 0 ? void 0 : ref29.sell) !== null) {
            message.category = {
                $case: "sell",
                sell: SellCategory.fromPartial(object.category.sell)
            };
        }
        if (((ref30 = object.category) === null || ref30 === void 0 ? void 0 : ref30.$case) === "sellDirect" && ((ref31 = object.category) === null || ref31 === void 0 ? void 0 : ref31.sellDirect) !== undefined && ((ref32 = object.category) === null || ref32 === void 0 ? void 0 : ref32.sellDirect) !== null) {
            message.category = {
                $case: "sellDirect",
                sellDirect: SellDirectCategory.fromPartial(object.category.sellDirect)
            };
        }
        if (((ref33 = object.category) === null || ref33 === void 0 ? void 0 : ref33.$case) === "sellList" && ((ref34 = object.category) === null || ref34 === void 0 ? void 0 : ref34.sellList) !== undefined && ((ref35 = object.category) === null || ref35 === void 0 ? void 0 : ref35.sellList) !== null) {
            message.category = {
                $case: "sellList",
                sellList: SellListCategory.fromPartial(object.category.sellList)
            };
        }
        if (((ref36 = object.category) === null || ref36 === void 0 ? void 0 : ref36.$case) === "sellEa" && ((ref37 = object.category) === null || ref37 === void 0 ? void 0 : ref37.sellEa) !== undefined && ((ref38 = object.category) === null || ref38 === void 0 ? void 0 : ref38.sellEa) !== null) {
            message.category = {
                $case: "sellEa",
                sellEa: SellEACategory.fromPartial(object.category.sellEa)
            };
        }
        if (((ref39 = object.category) === null || ref39 === void 0 ? void 0 : ref39.$case) === "sellOrva" && ((ref40 = object.category) === null || ref40 === void 0 ? void 0 : ref40.sellOrva) !== undefined && ((ref41 = object.category) === null || ref41 === void 0 ? void 0 : ref41.sellOrva) !== null) {
            message.category = {
                $case: "sellOrva",
                sellOrva: SellORVACategory.fromPartial(object.category.sellOrva)
            };
        }
        if (((ref42 = object.category) === null || ref42 === void 0 ? void 0 : ref42.$case) === "sellVa" && ((ref43 = object.category) === null || ref43 === void 0 ? void 0 : ref43.sellVa) !== undefined && ((ref44 = object.category) === null || ref44 === void 0 ? void 0 : ref44.sellVa) !== null) {
            message.category = {
                $case: "sellVa",
                sellVa: SellVACategory.fromPartial(object.category.sellVa)
            };
        }
        if (((ref45 = object.category) === null || ref45 === void 0 ? void 0 : ref45.$case) === "chat" && ((ref46 = object.category) === null || ref46 === void 0 ? void 0 : ref46.chat) !== undefined && ((ref47 = object.category) === null || ref47 === void 0 ? void 0 : ref47.chat) !== null) {
            message.category = {
                $case: "chat",
                chat: ChatCategory.fromPartial(object.category.chat)
            };
        }
        if (((ref48 = object.category) === null || ref48 === void 0 ? void 0 : ref48.$case) === "retailWebUnlock" && ((ref49 = object.category) === null || ref49 === void 0 ? void 0 : ref49.retailWebUnlock) !== undefined && ((ref50 = object.category) === null || ref50 === void 0 ? void 0 : ref50.retailWebUnlock) !== null) {
            message.category = {
                $case: "retailWebUnlock",
                retailWebUnlock: retail_web_unlock_category/* RetailWebUnlockCategory.fromPartial */.kv.fromPartial(object.category.retailWebUnlock)
            };
        }
        if (((ref51 = object.category) === null || ref51 === void 0 ? void 0 : ref51.$case) === "communication" && ((ref52 = object.category) === null || ref52 === void 0 ? void 0 : ref52.communication) !== undefined && ((ref53 = object.category) === null || ref53 === void 0 ? void 0 : ref53.communication) !== null) {
            message.category = {
                $case: "communication",
                communication: CommunicationCategory.fromPartial(object.category.communication)
            };
        }
        if (((ref54 = object.category) === null || ref54 === void 0 ? void 0 : ref54.$case) === "sellOfferReview" && ((ref55 = object.category) === null || ref55 === void 0 ? void 0 : ref55.sellOfferReview) !== undefined && ((ref56 = object.category) === null || ref56 === void 0 ? void 0 : ref56.sellOfferReview) !== null) {
            message.category = {
                $case: "sellOfferReview",
                sellOfferReview: SellOfferReviewCategory.fromPartial(object.category.sellOfferReview)
            };
        }
        if (((ref57 = object.category) === null || ref57 === void 0 ? void 0 : ref57.$case) === "assessment" && ((ref58 = object.category) === null || ref58 === void 0 ? void 0 : ref58.assessment) !== undefined && ((ref59 = object.category) === null || ref59 === void 0 ? void 0 : ref59.assessment) !== null) {
            message.category = {
                $case: "assessment",
                assessment: AssessmentCategory.fromPartial(object.category.assessment)
            };
        }
        if (((ref60 = object.category) === null || ref60 === void 0 ? void 0 : ref60.$case) === "marketplaceProperty" && ((ref61 = object.category) === null || ref61 === void 0 ? void 0 : ref61.marketplaceProperty) !== undefined && ((ref62 = object.category) === null || ref62 === void 0 ? void 0 : ref62.marketplaceProperty) !== null) {
            message.category = {
                $case: "marketplaceProperty",
                marketplaceProperty: marketplace_property_category/* MarketplacePropertyCategory.fromPartial */.SG.fromPartial(object.category.marketplaceProperty)
            };
        }
        if (((ref63 = object.category) === null || ref63 === void 0 ? void 0 : ref63.$case) === "homeGuide" && ((ref64 = object.category) === null || ref64 === void 0 ? void 0 : ref64.homeGuide) !== undefined && ((ref65 = object.category) === null || ref65 === void 0 ? void 0 : ref65.homeGuide) !== null) {
            message.category = {
                $case: "homeGuide",
                homeGuide: HomeGuideCategory.fromPartial(object.category.homeGuide)
            };
        }
        if (((ref66 = object.category) === null || ref66 === void 0 ? void 0 : ref66.$case) === "alo" && ((ref67 = object.category) === null || ref67 === void 0 ? void 0 : ref67.alo) !== undefined && ((ref68 = object.category) === null || ref68 === void 0 ? void 0 : ref68.alo) !== null) {
            message.category = {
                $case: "alo",
                alo: AloCategory.fromPartial(object.category.alo)
            };
        }
        if (((ref69 = object.category) === null || ref69 === void 0 ? void 0 : ref69.$case) === "language" && ((ref70 = object.category) === null || ref70 === void 0 ? void 0 : ref70.language) !== undefined && ((ref71 = object.category) === null || ref71 === void 0 ? void 0 : ref71.language) !== null) {
            message.category = {
                $case: "language",
                language: LanguageCategory.fromPartial(object.category.language)
            };
        }
        if (((ref72 = object.category) === null || ref72 === void 0 ? void 0 : ref72.$case) === "sellWithUpside" && ((ref73 = object.category) === null || ref73 === void 0 ? void 0 : ref73.sellWithUpside) !== undefined && ((ref74 = object.category) === null || ref74 === void 0 ? void 0 : ref74.sellWithUpside) !== null) {
            message.category = {
                $case: "sellWithUpside",
                sellWithUpside: SellWithUpsideCategory.fromPartial(object.category.sellWithUpside)
            };
        }
        if (((ref75 = object.category) === null || ref75 === void 0 ? void 0 : ref75.$case) === "agentConnect" && ((ref76 = object.category) === null || ref76 === void 0 ? void 0 : ref76.agentConnect) !== undefined && ((ref77 = object.category) === null || ref77 === void 0 ? void 0 : ref77.agentConnect) !== null) {
            message.category = {
                $case: "agentConnect",
                agentConnect: AgentConnectCategory.fromPartial(object.category.agentConnect)
            };
        }
        if (((ref78 = object.category) === null || ref78 === void 0 ? void 0 : ref78.$case) === "sellFinalOfferCall" && ((ref79 = object.category) === null || ref79 === void 0 ? void 0 : ref79.sellFinalOfferCall) !== undefined && ((ref80 = object.category) === null || ref80 === void 0 ? void 0 : ref80.sellFinalOfferCall) !== null) {
            message.category = {
                $case: "sellFinalOfferCall",
                sellFinalOfferCall: SellFinalOfferCallCategory.fromPartial(object.category.sellFinalOfferCall)
            };
        }
        if (((ref81 = object.category) === null || ref81 === void 0 ? void 0 : ref81.$case) === "mortgage" && ((ref82 = object.category) === null || ref82 === void 0 ? void 0 : ref82.mortgage) !== undefined && ((ref83 = object.category) === null || ref83 === void 0 ? void 0 : ref83.mortgage) !== null) {
            message.category = {
                $case: "mortgage",
                mortgage: MortgageCategory.fromPartial(object.category.mortgage)
            };
        }
        message.analyticsContext = object.analyticsContext !== undefined && object.analyticsContext !== null ? AnalyticsContext.fromPartial(object.analyticsContext) : undefined;
        var _clientEventId;
        message.clientEventId = (_clientEventId = object.clientEventId) !== null && _clientEventId !== void 0 ? _clientEventId : undefined;
        return message;
    }
};
function createBaseHydrated() {
    return {
        buyerPropertyDetails: undefined
    };
}
var Hydrated = {
    fromJSON: function fromJSON(object) {
        return {
            buyerPropertyDetails: event_wrapper_isSet(object.buyerPropertyDetails) ? Hydrated_BuyerPropertyDetails.fromJSON(object.buyerPropertyDetails) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.buyerPropertyDetails !== undefined) {
            obj.buyerPropertyDetails = Hydrated_BuyerPropertyDetails.toJSON(message.buyerPropertyDetails);
        }
        return obj;
    },
    create: function create(base) {
        return Hydrated.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseHydrated();
        message.buyerPropertyDetails = object.buyerPropertyDetails !== undefined && object.buyerPropertyDetails !== null ? Hydrated_BuyerPropertyDetails.fromPartial(object.buyerPropertyDetails) : undefined;
        return message;
    }
};
function createBaseHydrated_BuyerPropertyDetails() {
    return {
        canSelfTour: undefined,
        city: undefined,
        inventoryType: "",
        listingState: undefined,
        slug: undefined,
        zip: undefined
    };
}
var Hydrated_BuyerPropertyDetails = {
    fromJSON: function fromJSON(object) {
        return {
            canSelfTour: event_wrapper_isSet(object.canSelfTour) ? Boolean(object.canSelfTour) : undefined,
            city: event_wrapper_isSet(object.city) ? String(object.city) : undefined,
            inventoryType: event_wrapper_isSet(object.inventoryType) ? String(object.inventoryType) : "",
            listingState: event_wrapper_isSet(object.listingState) ? String(object.listingState) : undefined,
            slug: event_wrapper_isSet(object.slug) ? String(object.slug) : undefined,
            zip: event_wrapper_isSet(object.zip) ? String(object.zip) : undefined
        };
    },
    toJSON: function toJSON(message) {
        var obj = {};
        if (message.canSelfTour !== undefined) {
            obj.canSelfTour = message.canSelfTour;
        }
        if (message.city !== undefined) {
            obj.city = message.city;
        }
        if (message.inventoryType !== "") {
            obj.inventoryType = message.inventoryType;
        }
        if (message.listingState !== undefined) {
            obj.listingState = message.listingState;
        }
        if (message.slug !== undefined) {
            obj.slug = message.slug;
        }
        if (message.zip !== undefined) {
            obj.zip = message.zip;
        }
        return obj;
    },
    create: function create(base) {
        return Hydrated_BuyerPropertyDetails.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function fromPartial(object) {
        var message = createBaseHydrated_BuyerPropertyDetails();
        var _canSelfTour;
        message.canSelfTour = (_canSelfTour = object.canSelfTour) !== null && _canSelfTour !== void 0 ? _canSelfTour : undefined;
        var _city;
        message.city = (_city = object.city) !== null && _city !== void 0 ? _city : undefined;
        var _inventoryType;
        message.inventoryType = (_inventoryType = object.inventoryType) !== null && _inventoryType !== void 0 ? _inventoryType : "";
        var _listingState;
        message.listingState = (_listingState = object.listingState) !== null && _listingState !== void 0 ? _listingState : undefined;
        var _slug;
        message.slug = (_slug = object.slug) !== null && _slug !== void 0 ? _slug : undefined;
        var _zip;
        message.zip = (_zip = object.zip) !== null && _zip !== void 0 ? _zip : undefined;
        return message;
    }
};
function event_wrapper_fromTimestamp(t) {
    var millis = (t.seconds || 0) * 1000;
    millis += (t.nanos || 0) / 1000000;
    return new Date(millis);
}
function event_wrapper_fromJsonTimestamp(o) {
    if ((0,_instanceof/* default */.Z)(o, Date)) {
        return o;
    } else if (typeof o === "string") {
        return new Date(o);
    } else {
        return event_wrapper_fromTimestamp(Timestamp.fromJSON(o));
    }
}
function event_wrapper_isObject(value) {
    return typeof value === "object" && value !== null;
}
function event_wrapper_isSet(value) {
    return value !== null && value !== undefined;
}

// EXTERNAL MODULE: ./src/components/globals.ts
var globals = __webpack_require__(35480);
;// CONCATENATED MODULE: ./src/helpers/observability.ts








var EXPERIMENT_QUERY_PARAM_KEYS = [
    /* Experiment name */ "experiment",
    /* Experiment variation */ "experimentVariation", 
];
var OBSERVABILITY_QUERY_PARAM_KEYS = (0,_to_consumable_array/* default */.Z)(EXPERIMENT_QUERY_PARAM_KEYS).concat([
    /* Cosmos path e.g. /landing-pages/[...slug] or /articles/[...name] */ "cosmosPathname",
    /* Dynamic route value e.g. $slug in /landing-pages/[...slug] */ "slug",
    /* Dynamic route value e.g. $name in /articles/topic/[...name] */ "name", 
]);
//observability
var initObservability = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, globalContext = ref.globalContext, isBot = ref.isBot;
    // make sure we only init observability client-side
    if ( true && !observability_slim/* globalObservability.isInitialized */.w.isInitialized()) {
        (0,observability_slim/* initObservability */.lT)({
            eventTrackingCategory: "cosmos",
            isBot: isBot,
            env: globals/* DEPLOY_ENV */.Zp,
            appName: "cosmos",
            version: "879c6580639e7f22400a3c8abc6bab77b69cfdb5" || 0,
            sentry: {
                dsn: "https://3414e8de867a4131a44598d29006eccc@o117144.ingest.sentry.io/1439728",
                maxBreadcrumbs: 50,
                attachStacktrace: true,
                // Only allow errors from first-party sources, to reduce sentry spam
                allowUrls: [
                    "simplersell.com",
                    "opendoor.com"
                ],
                // observability package has default ignore errors set by default
                // https://github.com/opendoor-labs/code/blob/master/js/packages/observability/src/internal/sentry.ts#L138
                init: function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(function(initOpts) {
                        var customBeforeSend, Sentry;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    customBeforeSend = function(event, hint) {
                                        var ref, ref1, ref2, ref3, ref4, ref5;
                                        // ref: https://github.com/getsentry/sentry-javascript/issues/7941#issuecomment-1525640063
                                        // {
                                        //   "type": "Event",
                                        //   "value": "Non-Error exception captured with keys: currentTarget, isTrusted, target, type",
                                        //   "stacktrace": {
                                        //     "frames": [
                                        //       {
                                        //         "module": "properties/21027-Manon-Ln-Spring-TX-77388/aid_1acb88dd-b5de-5b5f-89c8-66bf60db11fd",
                                        //         "filename": "app:///properties/21027-Manon-Ln-Spring-TX-77388/aid_1acb88dd-b5de-5b5f-89c8-66bf60db11fd",
                                        //         "abs_path": "app:///properties/21027-Manon-Ln-Spring-TX-77388/aid_1acb88dd-b5de-5b5f-89c8-66bf60db11fd",
                                        //         "in_app": true
                                        //       }
                                        //     ]
                                        //   },
                                        //   "mechanism": {
                                        //     "type": "onerror",
                                        //     "synthetic": true,
                                        //     "handled": false
                                        //   }
                                        // }
                                        var eventMessage = (event === null || event === void 0 ? void 0 : (ref = event.exception) === null || ref === void 0 ? void 0 : (ref1 = ref.values) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.value) || "";
                                        if ((ref3 = eventMessage.includes) === null || ref3 === void 0 ? void 0 : ref3.call(eventMessage, "Non-Error exception captured with keys: currentTarget, isTrusted, target, type")) {
                                            return null;
                                        }
                                        if (((window === null || window === void 0 ? void 0 : (ref4 = window.navigator) === null || ref4 === void 0 ? void 0 : ref4.userAgent) || "").includes("Netsparker")) {
                                            return null;
                                        }
                                        var ref6;
                                        return (ref6 = (ref5 = initOpts.beforeSend) === null || ref5 === void 0 ? void 0 : ref5.call(initOpts, event, hint)) !== null && ref6 !== void 0 ? ref6 : event;
                                    };
                                    return [
                                        4,
                                        Promise.all(/* import() */[__webpack_require__.e(5336), __webpack_require__.e(5527), __webpack_require__.e(2190), __webpack_require__.e(4327)]).then(__webpack_require__.bind(__webpack_require__, 34327))
                                    ];
                                case 1:
                                    Sentry = _state.sent();
                                    Sentry.init((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initOpts), {
                                        beforeSend: customBeforeSend,
                                        enableTracing: false
                                    }));
                                    window.addEventListener("unhandledrejection", function(event) {
                                        var ref, ref1;
                                        var _reason;
                                        var reason = (_reason = event.reason) !== null && _reason !== void 0 ? _reason : new Error("Unhandled promise rejection with undefined reason");
                                        Sentry.captureException(reason, {
                                            contexts: {
                                                promiseRejection: {
                                                    hadReason: event.reason != null,
                                                    promiseType: (ref = event.promise) === null || ref === void 0 ? void 0 : (ref1 = ref.constructor) === null || ref1 === void 0 ? void 0 : ref1.name
                                                }
                                            }
                                        });
                                    });
                                    return [
                                        2,
                                        Sentry
                                    ];
                            }
                        });
                    });
                    return function(initOpts) {
                        return _ref.apply(this, arguments);
                    };
                }()
            },
            datadog: {
                service: "cosmos",
                applicationId: globals/* DATADOG_RUM_APPLICATION_ID */.vt,
                clientToken: globals/* DATADOG_RUM_APPLICATION_CLIENT_TOKEN */.sE,
                sessionSampleRate: 100,
                sessionReplaySampleRate: 100,
                trackUserInteractions: true,
                silentMultipleInit: true,
                trackSessionAcrossSubdomains: true,
                // Please be careful when adding tracing origins.
                // If a server is not prepared for the new Datadog headers, then it may fail with CORS errors.
                // Relevant postmortem: https://docs.google.com/document/d/1O9eWUdXZJOS4Oha2v_dtPfjO34IU3KEDpNqjk3AtXdk/edit
                allowedTracingUrls: [
                    /https:\/\/.*\.simplersell\.com/,
                    /https:\/\/.*\.opendoor\.com/
                ],
                defaultPrivacyLevel: "mask-user-input",
                init: function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(function(initOpts) {
                        var datadogRum;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 86947))
                                    ];
                                case 1:
                                    datadogRum = _state.sent().datadogRum;
                                    datadogRum.init(initOpts);
                                    datadogRum.startSessionReplayRecording();
                                    globalContext === null || globalContext === void 0 ? void 0 : globalContext.forEach(function(param) {
                                        var key = param.key, value = param.value;
                                        datadogRum.setGlobalContextProperty(key, "".concat(value));
                                    });
                                    return [
                                        2,
                                        datadogRum
                                    ];
                            }
                        });
                    });
                    return function(initOpts) {
                        return _ref.apply(this, arguments);
                    };
                }()
            },
            journeyEventHelpers: {
                toJSON: EventWrapper.toJSON
            },
            journeyEndpoint: "/_journey/api/v1"
        });
    }
};
var useObservability = function() {
    return (0,observability_slim/* useObservability */.C3)();
};


/***/ }),

/***/ 43552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export searchParamsFromUrl */
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);

function useQueryParams() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    return router.query;
}
function searchParamsFromUrl(urlOrPathname) {
    if (!urlOrPathname) {
        return new URLSearchParams();
    }
    try {
        // http://localhost is a backup if urlOrPathname is an absolute URL
        var url = new URL(urlOrPathname, "http://localhost");
        return url.searchParams;
    } catch (e) {
        return new URLSearchParams();
    }
}
/* harmony default export */ __webpack_exports__["Z"] = (useQueryParams);


/***/ }),

/***/ 71211:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ErrorApp; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs
var _inherits = __webpack_require__(28668);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 1 modules
var _create_super = __webpack_require__(71418);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react-modal/lib/index.js
var lib = __webpack_require__(83253);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/BricksProvider.js
var BricksProvider = __webpack_require__(29301);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/theme/ODThemeLite.mjs
var ODThemeLite = __webpack_require__(69666);
// EXTERNAL MODULE: ./node_modules/@opendoor/observability/dist/observability-slim.mjs
var observability_slim = __webpack_require__(74593);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/helpers/observability.ts + 57 modules
var helpers_observability = __webpack_require__(49048);
;// CONCATENATED MODULE: ./src/components/ErrorBoundary.tsx






function ErrorBoundaryWithObservability(param) {
    var children = param.children, errorLabel = param.errorLabel;
    var observability = (0,helpers_observability/* useObservability */.C3)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ErrorBoundary, {
        observability: observability,
        errorLabel: errorLabel !== null && errorLabel !== void 0 ? errorLabel : "cosmos",
        children: children
    });
}
// We are only using this to assert that we log any unhandled exception that we receive.
var ErrorBoundary = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(ErrorBoundary, _Component);
    var _super = (0,_create_super/* default */.Z)(ErrorBoundary);
    function ErrorBoundary(props) {
        (0,_class_call_check/* default */.Z)(this, ErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            hasError: false
        };
        return _this;
    }
    var _proto = ErrorBoundary.prototype;
    _proto.componentDidCatch = function componentDidCatch(error, errorInfo) {
        this.props.observability.trackError(this.props.errorLabel, error, {
            componentStack: errorInfo.componentStack
        });
        throw error;
    };
    _proto.render = function render() {
        return this.props.children;
    };
    ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(_error) {
        return {
            hasError: true
        };
    };
    return ErrorBoundary;
}(react.Component);
/* harmony default export */ var components_ErrorBoundary = (ErrorBoundaryWithObservability);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/components/NavListener.tsx



/**
 * Listens for soft navigations (i.e. navigations that don't result in a full page refresh)
 *
 * - Reports the navigation to analytics
 */ function NavListener() {
    var trackJourneyEvent = (0,helpers_observability/* useObservability */.C3)().trackJourneyEvent;
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        var handleRouteChange = function(url) {
            if (url !== location.pathname + location.search) {
                trackJourneyEvent("platform", "pageViewEvent", {});
            }
        };
        router.events.on("routeChangeStart", handleRouteChange);
        // If the component is unmounted, unsubscribe
        // from the event with the `off` method:
        return function() {
            router.events.off("routeChangeStart", handleRouteChange);
        };
    }, [
        router
    ]);
    return null;
}

// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./src/components/shared/OneTrust.tsx
/* provided dependency */ var process = __webpack_require__(34155);


var OneTrustScripts = function() {
    if (process.env.COOKIE_BANNER_DISABLED === "true") return null;
    // eslint-disable-next-line @opendoor/no-direct-env-check
    var isProduction = "production" === "production";
    var domainScript = isProduction ? "019756e6-db1e-7dfa-97f3-4cf089c9f913" : "019756e6-db1e-7dfa-97f3-4cf089c9f913-test";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((script_default()), {
                src: "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js",
                strategy: "lazyOnload",
                "data-domain-script": domainScript
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((script_default()), {
                id: "optanon-wrapper",
                strategy: "lazyOnload",
                children: "function OptanonWrapper() { }"
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/next/app.js
var app = __webpack_require__(7544);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_wrap_native_super.mjs + 2 modules
var _wrap_native_super = __webpack_require__(25892);
// EXTERNAL MODULE: ./node_modules/@opendoor/auth-fe/dist/auth-fe.esm.js
var auth_fe_esm = __webpack_require__(95674);
// EXTERNAL MODULE: ./src/components/globals.ts
var globals = __webpack_require__(35480);
;// CONCATENATED MODULE: ./src/components/account/AuthContextProvider.tsx
/* provided dependency */ var AuthContextProvider_process = __webpack_require__(34155);
/**
 * Warning: this provider is imported by the _app component at the root
 * of the application. Make sure that you keep the imports minimal here.
 */ 









var FetchGqlError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0,_inherits/* default */.Z)(FetchGqlError, Error1);
    var _super = (0,_create_super/* default */.Z)(FetchGqlError);
    function FetchGqlError(message, errors, networkError) {
        (0,_class_call_check/* default */.Z)(this, FetchGqlError);
        var _this;
        _this = _super.call(this, message);
        _this.graphQLErrors = errors;
        _this.networkError = networkError;
        return _this;
    }
    return FetchGqlError;
}((0,_wrap_native_super/* default */.Z)(Error));
var getQueryOperationName = function(query) {
    var ref, ref1;
    var ref2;
    return (ref2 = (ref = query.match(RegExp("query\\s+(?<operationName>[^{(\\s]+)"))) === null || ref === void 0 ? void 0 : (ref1 = ref.groups) === null || ref1 === void 0 ? void 0 : ref1.operationName) !== null && ref2 !== void 0 ? ref2 : null;
};
var fetchClient = function(opts) {
    return {
        query: function query(query1, vars) {
            return (0,_async_to_generator/* default */.Z)(function() {
                var body, headers, devUserToken, res, json;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            body = {
                                operationName: getQueryOperationName(query1),
                                query: query1,
                                variables: vars
                            };
                            headers = {
                                "Content-Type": "application/json",
                                Accept: "application/json",
                                "apollographql-client-name": opts.clientName
                            };
                            devUserToken = AuthContextProvider_process.env.NEXT_PUBLIC_ATHENA_DEV_USER_TOKEN;
                            if (globals/* DEPLOY_ENV */.Zp === "development" && devUserToken) {
                                headers["x-athena-request-user"] = devUserToken;
                            }
                            return [
                                4,
                                fetch(opts.apiEndpoint, {
                                    credentials: "include",
                                    method: "POST",
                                    headers: headers,
                                    body: JSON.stringify(body),
                                    mode: "cors"
                                })
                            ];
                        case 1:
                            res = _state.sent();
                            if (!res.ok) {
                                return [
                                    2,
                                    {
                                        error: new FetchGqlError("Failed to fetch", [], {
                                            status: res.status,
                                            statusText: res.statusText
                                        }),
                                        data: undefined
                                    }
                                ];
                            }
                            return [
                                4,
                                res.json()
                            ];
                        case 2:
                            json = _state.sent();
                            if (json.errors) {
                                return [
                                    2,
                                    {
                                        error: new FetchGqlError("Graphql request had errors", json.errors, {}),
                                        data: undefined
                                    }
                                ];
                            }
                            return [
                                2,
                                {
                                    data: json.data,
                                    error: undefined
                                }
                            ];
                    }
                });
            })();
        }
    };
};
var AuthProvider = function(param) {
    var children = param.children;
    var fetchClientMemo = (0,react.useMemo)(function() {
        return fetchClient({
            apiEndpoint: globals/* ATHENA_URL */.Uw,
            clientName: "cosmos"
        });
    }, []);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(auth_fe_esm/* AuthContextProvider */.HD, {
        env: globals/* DEPLOY_ENV */.Zp,
        client: fetchClientMemo,
        children: children
    });
};
/* harmony default export */ var AuthContextProvider = (AuthProvider);

// EXTERNAL MODULE: ./src/helpers/AddressValidationContext.tsx + 2 modules
var AddressValidationContext = __webpack_require__(37662);
;// CONCATENATED MODULE: ./src/helpers/apptoolboxInjection.ts
var APPTOOLBOX_FE_INJECTION_SCRIPT = "\nif (document.cookie.includes(\"qa_env=\")) {\n  const apptoolboxFeScript = document.createElement('script');\n\n  apptoolboxFeScript.setAttribute(\n    'src',\n    'https://odfil.es/313e5541776ac579b6959a58f1751d74e0e0e26a/static/embedded/embed.latest.js?ts=".concat(Date.now(), "'\n  );\n\n  // used by apptoolbox fe to validate the current app for deploy previews\n  const cosmosSha1Sum = \"094C26F496BD0DD1B77B8BAC6810D55E69BD2B16\";\n  apptoolboxFeScript.setAttribute('appId', cosmosSha1Sum);\n  apptoolboxFeScript.setAttribute('appPathPrefix','/');\n\n  // div to render apptoolbox-fe UI. div defined in _app.tsx\n  // https://github.com/opendoor-labs/code/blob/e3f0a8ec49791c220ae4b46c77001b2b84d6a692/js/packages/cosmos/src/pages/_app.tsx#L130\n  apptoolboxFeScript.setAttribute(\"apptoolboxDivId\", \"x-od-app-toolbox-root\")\n\n  // don’t block rendering thread\n  apptoolboxFeScript.setAttribute('async','');\n\n  // inject script tag into document\n  document.head.appendChild(apptoolboxFeScript);\n}");

;// CONCATENATED MODULE: ./src/polyfills/react-createFactory.ts

if (!react.createFactory) {
    react.createFactory = function(type) {
        return react.createElement.bind(null, type);
    };
}

;// CONCATENATED MODULE: ./src/pages/_app.tsx
// eslint-disable-next-line import/order
























if (true) {
    __webpack_require__(39125);
}
// eslint-disable-next-line @opendoor/no-direct-env-check
if (false) {}
// Start MSW in browser for test mode (client-side GraphQL mocking)
// eslint-disable-next-line @opendoor/no-direct-env-check
if (false) {}
var ErrorApp = /*#__PURE__*/ function(App) {
    "use strict";
    (0,_inherits/* default */.Z)(ErrorApp, App);
    var _super = (0,_create_super/* default */.Z)(ErrorApp);
    function ErrorApp() {
        (0,_class_call_check/* default */.Z)(this, ErrorApp);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            hasError: false
        };
        return _this;
    }
    var _proto = ErrorApp.prototype;
    _proto.componentDidCatch = function componentDidCatch(error) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var _obj, ref, errorEventId;
            return (0,tslib_es6.__generator)(this, function(_state) {
                errorEventId = (ref = (_obj = observability_slim/* globalObservability.getSentryClient */.w.getSentryClient()).captureException) === null || ref === void 0 ? void 0 : ref.call(_obj, error);
                // Store the event id at this point as we don't have access to it within
                // `getDerivedStateFromError`.
                _this.setState({
                    errorEventId: errorEventId
                });
                return [
                    2
                ];
            });
        })();
    };
    _proto.componentDidMount = function componentDidMount() {
        var _this = this;
        var // For allowed query parameters, let's add them to our global observability context
        ref;
        var _props = this.props, originPath = _props.originPath, originUrl = _props.originUrl, referer = _props.referer, cosmosPathname = _props.cosmosPathname, proxyPath = _props.proxyPath, proxyQueryMap = _props.proxyQueryMap;
        var globalContext = [
            {
                key: "cosmosPathname",
                value: cosmosPathname
            }, 
        ];
        (ref = Object.keys(this.props.router.query)) === null || ref === void 0 ? void 0 : ref.forEach(function(key) {
            var queryKey = toCamelCase(key);
            var value = _this.props.router.query[key];
            if (helpers_observability/* OBSERVABILITY_QUERY_PARAM_KEYS.includes */.FL.includes(queryKey) && value !== undefined) {
                globalContext.push({
                    key: queryKey,
                    value: "".concat(value)
                });
            }
        });
        // Always initialize observability so child components calling trackJourneyEvent/trackError
        // don't throw. Skipping initObservability causes a crash loop in staging where
        // componentDidCatch -> trackError -> throw -> componentDidCatch -> infinite loop.
        (0,helpers_observability/* initObservability */.lT)({
            globalContext: globalContext,
            isBot: this.props.isBot
        });
        // Skip analytics tracking for bot traffic — bots don't need page views or journey events
        if (!this.props.isBot) {
            // TODO: [GROWEPD-806] Remove — redundant with CF Worker Journey pageViewEvent
            observability_slim/* analytics.trackPageView */.co.trackPageView({
                originPath: originPath,
                originUrl: originUrl,
                referer: referer,
                resource: "cosmos"
            });
            observability_slim/* globalObservability.trackJourneyEvent */.w.trackJourneyEvent("platform", "pageViewEvent", {}, {
                websiteSourceContext: {
                    referrer: referer,
                    proxyPath: proxyPath,
                    proxyQueryMap: proxyQueryMap
                }
            });
        }
    };
    _proto.render = function render() {
        // Necessary for accessibility. ReactModal uses this to hide (via aria-hidden) the rest of the
        // app while the modal is active.
        // https://reactcommunity.org/react-modal/accessibility/#app-element
        lib_default().setAppElement("#__next");
        // right now, we're not doing anything with the error. We might want to redirect
        // to /error in the future (or reload the page).
        var _props = this.props, Component = _props.Component, pageProps = _props.pageProps, originPath = _props.originPath, originUrl = _props.originUrl, referer = _props.referer, err = _props.err;
        // @ts-expect-error: components can set a custom theme on their default page export. Overriding nextjs type to reflect this is overly complicated
        var theme = Component.theme || "legacy";
        var _getLayout;
        // Support per-page layouts via getLayout pattern
        var getLayout = (_getLayout = Component.getLayout) !== null && _getLayout !== void 0 ? _getLayout : function(page) {
            return page;
        };
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(observability_slim/* AddContextualData */.up, {
            data: {
                originPath: originPath,
                originUrl: originUrl,
                referer: referer
            },
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ODThemeLite/* ThemedLite */.h, {
                theme: theme,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)((head_default()), {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("style", {
                                children: 'img[width="1"][height="1"] { display: none; }'
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                                name: "description",
                                content: "Opendoor is the new way to sell your home. Skip the hassle of listing, showings and months of stress, and close on your own timeline. Get a free offer today!"
                            }, "description"),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                                property: "og:url",
                                content: "https://opendoor.com"
                            }, "og:url"),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                                property: "og:type",
                                content: "website"
                            }, "og:type"),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                                property: "og:title",
                                content: "Opendoor | Sell your home the minute you’re ready."
                            }, "og:title"),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                                property: "og:description",
                                content: "Opendoor is the new way to sell your home. Skip the hassle of listing, showings and months of stress, and close on your own timeline. Get a free offer today!"
                            }, "og:description"),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                                property: "og:image",
                                content: "https://images.opendoor.com/source/s3/imgdrop-production/2024-06-1719377665829-19976.jpg?preset=square-1024&service=cosmos&dpr=2"
                            }, "og:image"),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                                name: "twitter:card",
                                content: "summary_large_image"
                            }, "twitter:card"),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                                property: "twitter:domain",
                                content: "opendoor.com"
                            }, "twitter:domain"),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                                property: "twitter:url",
                                content: "https://opendoor.com"
                            }, "twitter:url"),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                                name: "twitter:title",
                                content: "Opendoor | Sell your home the minute you’re ready."
                            }, "twitter:title"),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                                name: "twitter:description",
                                content: "Opendoor is the new way to sell your home. Skip the hassle of listing, showings and months of stress, and close on your own timeline. Get a free offer today!"
                            }, "twitter:description"),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                                name: "twitter:image",
                                content: "https://images.opendoor.com/source/s3/imgdrop-production/4c68636ad1df40d08a114638883c30d0.png?preset=square-2048"
                            }, "twitter:image")
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((script_default()), {
                        strategy: "afterInteractive",
                        dangerouslySetInnerHTML: {
                            __html: APPTOOLBOX_FE_INJECTION_SCRIPT
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OneTrustScripts, {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        id: "x-od-app-toolbox-root"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(components_ErrorBoundary, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavListener, {}),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AuthContextProvider, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BricksProvider/* BricksProvider */.C6, {
                                    useObservability: helpers_observability/* useObservability */.C3,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AddressValidationContext/* AddressValidationContextProvider */.Pj, {
                                        children: getLayout(/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Component, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pageProps), {
                                            err: err
                                        })))
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        });
    };
    ErrorApp.getInitialProps = function getInitialProps(param) {
        var Component = param.Component, ctx = param.ctx;
        return (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, ref2, ref3, ref4, ref5, isBot, ref6, originUrl, originPath, ref7, referer, ref8, proxyPath, proxyQueryMap, pageProps, error, captureException, errorEventId;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isBot = ((ref = ctx.req) === null || ref === void 0 ? void 0 : ref.headers["x-od-is-bot"]) === "true";
                        originUrl = (ref6 = (ref1 = ctx.req) === null || ref1 === void 0 ? void 0 : ref1.headers["x-od-forwarded-url"]) !== null && ref6 !== void 0 ? ref6 : "";
                        try {
                            originPath = new URL(originUrl).pathname;
                        } catch (e) {
                            originPath = "";
                        }
                        referer = (ref7 = (ref2 = ctx.req) === null || ref2 === void 0 ? void 0 : ref2.headers["referer"]) !== null && ref7 !== void 0 ? ref7 : undefined;
                        proxyPath = (ref8 = (ref3 = ctx.req) === null || ref3 === void 0 ? void 0 : ref3.headers["Proxy-Path"]) !== null && ref8 !== void 0 ? ref8 : undefined;
                        proxyQueryMap = ((ref4 = ctx.req) === null || ref4 === void 0 ? void 0 : ref4.headers["proxy-query-map"]) ? Object.fromEntries(Object.entries(JSON.parse((ref5 = ctx.req) === null || ref5 === void 0 ? void 0 : ref5.headers["proxy-query-map"])).map(function(param) {
                            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
                            return [
                                key,
                                String(value)
                            ];
                        })) : {};
                        pageProps = {};
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            6
                        ]);
                        if (!Component.getInitialProps) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            Component.getInitialProps(ctx)
                        ];
                    case 2:
                        pageProps = _state.sent();
                        _state.label = 3;
                    case 3:
                        return [
                            2,
                            {
                                pageProps: pageProps,
                                isBot: isBot,
                                originPath: originPath,
                                originUrl: originUrl,
                                referer: referer,
                                cosmosPathname: ctx.pathname,
                                proxyPath: proxyPath,
                                proxyQueryMap: proxyQueryMap
                            }
                        ];
                    case 4:
                        error = _state.sent();
                        return [
                            4,
                            Promise.all(/* import() */[__webpack_require__.e(5336), __webpack_require__.e(5527), __webpack_require__.e(2190), __webpack_require__.e(4327)]).then(__webpack_require__.bind(__webpack_require__, 34327))
                        ];
                    case 5:
                        captureException = _state.sent().captureException;
                        errorEventId = captureException(error);
                        return [
                            2,
                            {
                                hasError: true,
                                errorEventId: errorEventId,
                                pageProps: pageProps,
                                isBot: isBot,
                                originUrl: originUrl,
                                originPath: originPath,
                                referer: referer,
                                cosmosPathname: ctx.pathname,
                                proxyPath: proxyPath,
                                proxyQueryMap: proxyQueryMap
                            }
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    ErrorApp.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        // If there was an error generated within getInitialProps, and we haven't
        // yet seen an error, we add it to this.state here
        return {
            hasError: props.hasError || state.hasError || false,
            errorEventId: props.errorEventId || state.errorEventId || undefined
        };
    };
    ErrorApp.getDerivedStateFromError = function getDerivedStateFromError() {
        // React Error Boundary here allows us to set state flagging the error (and
        // later render a fallback UI).
        return {
            hasError: true
        };
    };
    return ErrorApp;
}(app["default"]);

function toCamelCase(str) {
    return str.replace(/_([a-z])/g, function(_, letter) {
        return letter.toUpperCase();
    });
}


/***/ }),

/***/ 63353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YN": function() { return /* binding */ validateAddress; },
/* harmony export */   "le": function() { return /* binding */ ADDRESS_INVALID_RESULT; }
/* harmony export */ });
/* unused harmony export UNIVERSAL_NIL_ADDRESS */
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82670);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41817);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32165);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92222);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91038);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26699);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(66992);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47042);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_some_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5212);
/* harmony import */ var core_js_modules_es_array_some_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(68309);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69070);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(30489);
/* harmony import */ var core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_object_set_prototype_of_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(68304);
/* harmony import */ var core_js_modules_es_object_set_prototype_of_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_set_prototype_of_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(88674);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(74916);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_regexp_test_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(77601);
/* harmony import */ var core_js_modules_es_regexp_test_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_test_js__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(39714);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(32023);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(78783);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(2490);
/* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_iterator_some_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(41874);
/* harmony import */ var core_js_modules_esnext_iterator_some_js__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_some_js__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(33948);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _api_mjs__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(82293);

function cov_24nvx1ule8() {
    var path = "/home/runner/_work/code/code/js/packages/cinderblocks/src/helpers/addressValidation.ts";
    var hash = "5ba9a6d5516d4aebe4f5139003b643a35e6dfbc1";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/home/runner/_work/code/code/js/packages/cinderblocks/src/helpers/addressValidation.ts",
        statementMap: {
            "0": {
                start: {
                    line: 3,
                    column: 30
                },
                end: {
                    line: 3,
                    column: 68
                }
            },
            "1": {
                start: {
                    line: 28,
                    column: 56
                },
                end: {
                    line: 41,
                    column: 1
                }
            },
            "2": {
                start: {
                    line: 63,
                    column: 37
                },
                end: {
                    line: 74,
                    column: 1
                }
            },
            "3": {
                start: {
                    line: 64,
                    column: 19
                },
                end: {
                    line: 64,
                    column: 47
                }
            },
            "4": {
                start: {
                    line: 65,
                    column: 20
                },
                end: {
                    line: 65,
                    column: 68
                }
            },
            "5": {
                start: {
                    line: 67,
                    column: 2
                },
                end: {
                    line: 73,
                    column: 4
                }
            },
            "6": {
                start: {
                    line: 69,
                    column: 6
                },
                end: {
                    line: 72,
                    column: 7
                }
            },
            "7": {
                start: {
                    line: 71,
                    column: 8
                },
                end: {
                    line: 71,
                    column: 51
                }
            },
            "8": {
                start: {
                    line: 76,
                    column: 31
                },
                end: {
                    line: 133,
                    column: 1
                }
            },
            "9": {
                start: {
                    line: 79,
                    column: 37
                },
                end: {
                    line: 79,
                    column: 39
                }
            },
            "10": {
                start: {
                    line: 80,
                    column: 20
                },
                end: {
                    line: 80,
                    column: 27
                }
            },
            "11": {
                start: {
                    line: 83,
                    column: 2
                },
                end: {
                    line: 112,
                    column: 3
                }
            },
            "12": {
                start: {
                    line: 84,
                    column: 39
                },
                end: {
                    line: 84,
                    column: 72
                }
            },
            "13": {
                start: {
                    line: 85,
                    column: 4
                },
                end: {
                    line: 98,
                    column: 5
                }
            },
            "14": {
                start: {
                    line: 91,
                    column: 6
                },
                end: {
                    line: 91,
                    column: 39
                }
            },
            "15": {
                start: {
                    line: 92,
                    column: 6
                },
                end: {
                    line: 97,
                    column: 8
                }
            },
            "16": {
                start: {
                    line: 99,
                    column: 26
                },
                end: {
                    line: 99,
                    column: 85
                }
            },
            "17": {
                start: {
                    line: 100,
                    column: 4
                },
                end: {
                    line: 111,
                    column: 6
                }
            },
            "18": {
                start: {
                    line: 115,
                    column: 2
                },
                end: {
                    line: 119,
                    column: 3
                }
            },
            "19": {
                start: {
                    line: 116,
                    column: 4
                },
                end: {
                    line: 118,
                    column: 5
                }
            },
            "20": {
                start: {
                    line: 117,
                    column: 6
                },
                end: {
                    line: 117,
                    column: 51
                }
            },
            "21": {
                start: {
                    line: 121,
                    column: 26
                },
                end: {
                    line: 121,
                    column: 73
                }
            },
            "22": {
                start: {
                    line: 124,
                    column: 27
                },
                end: {
                    line: 124,
                    column: 98
                }
            },
            "23": {
                start: {
                    line: 124,
                    column: 66
                },
                end: {
                    line: 124,
                    column: 97
                }
            },
            "24": {
                start: {
                    line: 125,
                    column: 29
                },
                end: {
                    line: 125,
                    column: 84
                }
            },
            "25": {
                start: {
                    line: 127,
                    column: 2
                },
                end: {
                    line: 132,
                    column: 4
                }
            }
        },
        fnMap: {
            "0": {
                name: "(anonymous_0)",
                decl: {
                    start: {
                        line: 63,
                        column: 37
                    },
                    end: {
                        line: 63,
                        column: 38
                    }
                },
                loc: {
                    start: {
                        line: 63,
                        column: 86
                    },
                    end: {
                        line: 74,
                        column: 1
                    }
                },
                line: 63
            },
            "1": {
                name: "(anonymous_1)",
                decl: {
                    start: {
                        line: 68,
                        column: 4
                    },
                    end: {
                        line: 68,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 69,
                        column: 6
                    },
                    end: {
                        line: 72,
                        column: 7
                    }
                },
                line: 69
            },
            "2": {
                name: "(anonymous_2)",
                decl: {
                    start: {
                        line: 70,
                        column: 28
                    },
                    end: {
                        line: 70,
                        column: 29
                    }
                },
                loc: {
                    start: {
                        line: 71,
                        column: 8
                    },
                    end: {
                        line: 71,
                        column: 51
                    }
                },
                line: 71
            },
            "3": {
                name: "(anonymous_3)",
                decl: {
                    start: {
                        line: 76,
                        column: 31
                    },
                    end: {
                        line: 76,
                        column: 32
                    }
                },
                loc: {
                    start: {
                        line: 78,
                        column: 39
                    },
                    end: {
                        line: 133,
                        column: 1
                    }
                },
                line: 78
            },
            "4": {
                name: "(anonymous_4)",
                decl: {
                    start: {
                        line: 124,
                        column: 55
                    },
                    end: {
                        line: 124,
                        column: 56
                    }
                },
                loc: {
                    start: {
                        line: 124,
                        column: 66
                    },
                    end: {
                        line: 124,
                        column: 97
                    }
                },
                line: 124
            }
        },
        branchMap: {
            "0": {
                loc: {
                    start: {
                        line: 65,
                        column: 20
                    },
                    end: {
                        line: 65,
                        column: 68
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 65,
                            column: 20
                        },
                        end: {
                            line: 65,
                            column: 62
                        }
                    },
                    {
                        start: {
                            line: 65,
                            column: 66
                        },
                        end: {
                            line: 65,
                            column: 68
                        }
                    }
                ],
                line: 65
            },
            "1": {
                loc: {
                    start: {
                        line: 69,
                        column: 6
                    },
                    end: {
                        line: 72,
                        column: 7
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 69,
                            column: 6
                        },
                        end: {
                            line: 69,
                            column: 34
                        }
                    },
                    {
                        start: {
                            line: 70,
                            column: 6
                        },
                        end: {
                            line: 72,
                            column: 7
                        }
                    }
                ],
                line: 69
            },
            "2": {
                loc: {
                    start: {
                        line: 83,
                        column: 2
                    },
                    end: {
                        line: 112,
                        column: 3
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 83,
                            column: 2
                        },
                        end: {
                            line: 112,
                            column: 3
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 83
            },
            "3": {
                loc: {
                    start: {
                        line: 85,
                        column: 4
                    },
                    end: {
                        line: 98,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 85,
                            column: 4
                        },
                        end: {
                            line: 98,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 85
            },
            "4": {
                loc: {
                    start: {
                        line: 86,
                        column: 6
                    },
                    end: {
                        line: 89,
                        column: 97
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 86,
                            column: 6
                        },
                        end: {
                            line: 86,
                            column: 33
                        }
                    },
                    {
                        start: {
                            line: 87,
                            column: 6
                        },
                        end: {
                            line: 87,
                            column: 38
                        }
                    },
                    {
                        start: {
                            line: 88,
                            column: 6
                        },
                        end: {
                            line: 88,
                            column: 39
                        }
                    },
                    {
                        start: {
                            line: 89,
                            column: 6
                        },
                        end: {
                            line: 89,
                            column: 97
                        }
                    }
                ],
                line: 86
            },
            "5": {
                loc: {
                    start: {
                        line: 115,
                        column: 2
                    },
                    end: {
                        line: 119,
                        column: 3
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 115,
                            column: 2
                        },
                        end: {
                            line: 119,
                            column: 3
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 115
            },
            "6": {
                loc: {
                    start: {
                        line: 115,
                        column: 6
                    },
                    end: {
                        line: 115,
                        column: 95
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 115,
                            column: 6
                        },
                        end: {
                            line: 115,
                            column: 67
                        }
                    },
                    {
                        start: {
                            line: 115,
                            column: 71
                        },
                        end: {
                            line: 115,
                            column: 95
                        }
                    }
                ],
                line: 115
            },
            "7": {
                loc: {
                    start: {
                        line: 116,
                        column: 4
                    },
                    end: {
                        line: 118,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 116,
                            column: 4
                        },
                        end: {
                            line: 118,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 116
            },
            "8": {
                loc: {
                    start: {
                        line: 116,
                        column: 8
                    },
                    end: {
                        line: 116,
                        column: 78
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 116,
                            column: 8
                        },
                        end: {
                            line: 116,
                            column: 22
                        }
                    },
                    {
                        start: {
                            line: 116,
                            column: 27
                        },
                        end: {
                            line: 116,
                            column: 77
                        }
                    }
                ],
                line: 116
            },
            "9": {
                loc: {
                    start: {
                        line: 121,
                        column: 31
                    },
                    end: {
                        line: 121,
                        column: 56
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 121,
                            column: 31
                        },
                        end: {
                            line: 121,
                            column: 50
                        }
                    },
                    {
                        start: {
                            line: 121,
                            column: 54
                        },
                        end: {
                            line: 121,
                            column: 56
                        }
                    }
                ],
                line: 121
            }
        },
        s: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "24": 0,
            "25": 0
        },
        f: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0
        },
        b: {
            "0": [
                0,
                0
            ],
            "1": [
                0,
                0
            ],
            "2": [
                0,
                0
            ],
            "3": [
                0,
                0
            ],
            "4": [
                0,
                0,
                0,
                0
            ],
            "5": [
                0,
                0
            ],
            "6": [
                0,
                0
            ],
            "7": [
                0,
                0
            ],
            "8": [
                0,
                0
            ],
            "9": [
                0,
                0
            ]
        },
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "5ba9a6d5516d4aebe4f5139003b643a35e6dfbc1"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        // @ts-ignore
        cov_24nvx1ule8 = function cov_24nvx1ule8() {
            return actualCoverage;
        };
    }
    return actualCoverage;
}
cov_24nvx1ule8();
function _toConsumableArray(r) {
    return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
}
function _iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
    if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function _regenerator() {
    var i = function i(r, n, o, i1) {
        var c = n && (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(n.prototype, Generator) ? n : Generator, u = Object.create(c.prototype);
        return _regeneratorDefine2(u, "_invoke", function(r, n, o) {
            var _$i, c, u, f = 0, p = o || [], y = !1, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                    return _$i = t, c = 0, u = e, G.n = r, a;
                }
            };
            function d(r, n) {
                for(c = r, u = n, t = 0; !y && f && !_$o && t < p.length; t++){
                    var _$o, _$i = p[t], _$d = G.p, l = _$i[2];
                    r > 3 ? (_$o = l === n) && (u = _$i[(c = _$i[4]) ? 5 : (c = 3, 3)], _$i[4] = _$i[5] = e) : _$i[0] <= _$d && ((_$o = r < 2 && _$d < _$i[1]) ? (c = 0, G.v = n, G.n = _$i[1]) : _$d < l && (_$o = r < 3 || _$i[0] > n || n > l) && (_$i[4] = r, _$i[5] = n, G.n = l, c = 0));
                }
                if (_$o || r > 1) return a;
                throw y = !0, n;
            }
            return function(o, p, l) {
                if (f > 1) throw TypeError("Generator is already running");
                for(y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;){
                    _$i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                    try {
                        if (f = 2, _$i) {
                            if (c || (o = "next"), t = _$i[o]) {
                                if (!(t = t.call(_$i, u))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u = t.value, c < 2 && (c = 0);
                            } else 1 === c && (t = _$i["return"]) && t.call(_$i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                            _$i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                    } catch (t1) {
                        _$i = e, c = 1, u = t1;
                    } finally{
                        f = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r, o, i1), !0), u;
    };
    var Generator = function Generator() {};
    var GeneratorFunction = function GeneratorFunction() {};
    var GeneratorFunctionPrototype = function GeneratorFunctionPrototype() {};
    var f = function f(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    };
    var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    var a = {};
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function() {
        return this;
    }), _regeneratorDefine2(u, "toString", function() {
        return "[object Generator]";
    }), (_regenerator = function _regenerator() {
        return {
            w: i,
            m: f
        };
    })();
}
function _regeneratorDefine2(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e1) {
        i = 0;
    }
    _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
        var o = function o(r, n) {
            _regeneratorDefine2(e, r, function(e) {
                return this._invoke(r, n, e);
            });
        };
        r ? i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
        }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
    }, _regeneratorDefine2(e, r, n, t);
}























function asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n1) {
        return void e(n1);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}

var UNIVERSAL_NIL_ADDRESS = (cov_24nvx1ule8().s[0]++, "6aae647b-d603-5533-8464-c42c658b101a");

// TODO: Duplicated here like other places in cinderblocks. Until we figure out
// how to share GraphQL codegen.
var ADDRESS_INVALID_RESULT = (cov_24nvx1ule8().s[1]++, [
    "ADDRESS_NIL",
    "ADDRESS_UNKNOWN",
    "ADDRESS_MISSING_PREMISE",
    "ADDRESS_INVALID_PREMISE",
    "ADDRESS_NOT_SUPPORTED",
    "ADDRESS_NOT_REAL",
    "ADDRESS_INVALID",
    "ADDRESS_INVALID_STREET",
    "ADDRESS_INVALID_SUB_PREMISE",
    "ADDRESS_MISSING_BOX_NUMBER",
    "ADDRESS_INVALID_BOX_NUMBER",
    "ADDRESS_EXTRANEOUS_INPUT"
]);
cov_24nvx1ule8().s[2]++;
var doesAddressHaveMultipleUnits = /*#__PURE__*/ function() {
    var _ref = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee(addressUuid) {
        var _response$data;
        var response, addresses;
        return _regenerator().w(function(_context) {
            while(1)switch(_context.n){
                case 0:
                    cov_24nvx1ule8().f[0]++;
                    cov_24nvx1ule8().s[3]++;
                    _context.n = 1;
                    return (0,_api_mjs__WEBPACK_IMPORTED_MODULE_24__/* .listUnits */ .fO)(addressUuid);
                case 1:
                    response = _context.v;
                    addresses = (cov_24nvx1ule8().s[4]++, (cov_24nvx1ule8().b[0][0]++, response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 || (_response$data = _response$data.casa) === null || _response$data === void 0 || (_response$data = _response$data.listUnits) === null || _response$data === void 0 ? void 0 : _response$data.addresses) || (cov_24nvx1ule8().b[0][1]++, []));
                    cov_24nvx1ule8().s[5]++;
                    return _context.a(2, addresses.some(function(address) {
                        var _address$result;
                        cov_24nvx1ule8().f[1]++;
                        cov_24nvx1ule8().s[6]++;
                        return (cov_24nvx1ule8().b[1][0]++, address.uuid !== addressUuid) && (cov_24nvx1ule8().b[1][1]++, !((_address$result = address.result) !== null && _address$result !== void 0 && _address$result.some(function(casaResult) {
                            cov_24nvx1ule8().f[2]++;
                            cov_24nvx1ule8().s[7]++;
                            return ADDRESS_INVALID_RESULT.includes(casaResult);
                        })));
                    }));
            }
        }, _callee);
    }));
    return function doesAddressHaveMultipleUnits(_x) {
        return _ref.apply(this, arguments);
    };
}();
cov_24nvx1ule8().s[8]++;
var validateAddress = /*#__PURE__*/ function() {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee2(address) {
        var _casaAddress, _casaAddress2, _casaAddress3;
        var moreResult, casaAddress, _standardizeAddressRe, _standardizeAddressRe2, standardizeAddressResponse, addressResult, combinedResults, needsManualEntry, needsUnitSelection, _t;
        return _regenerator().w(function(_context2) {
            while(1)switch(_context2.n){
                case 0:
                    cov_24nvx1ule8().f[3]++;
                    moreResult = (cov_24nvx1ule8().s[9]++, []);
                    casaAddress = (cov_24nvx1ule8().s[10]++, address); // Standardize Google addresses to Casa format
                    cov_24nvx1ule8().s[11]++;
                    if (!(address.source === "google")) {
                        _context2.n = 4;
                        break;
                    }
                    cov_24nvx1ule8().b[2][0]++;
                    cov_24nvx1ule8().s[12]++;
                    _context2.n = 1;
                    return (0,_api_mjs__WEBPACK_IMPORTED_MODULE_24__/* .standardizeAddress */ .ce)(address);
                case 1:
                    standardizeAddressResponse = _context2.v;
                    cov_24nvx1ule8().s[13]++;
                    if (!((cov_24nvx1ule8().b[4][0]++, !standardizeAddressResponse) || (cov_24nvx1ule8().b[4][1]++, !standardizeAddressResponse.data) || (cov_24nvx1ule8().b[4][2]++, standardizeAddressResponse.errors) || (cov_24nvx1ule8().b[4][3]++, ((_standardizeAddressRe = standardizeAddressResponse.data) === null || _standardizeAddressRe === void 0 || (_standardizeAddressRe = _standardizeAddressRe.casa.findByFields) === null || _standardizeAddressRe === void 0 || (_standardizeAddressRe = _standardizeAddressRe.address) === null || _standardizeAddressRe === void 0 ? void 0 : _standardizeAddressRe.uuid) === UNIVERSAL_NIL_ADDRESS))) {
                        _context2.n = 2;
                        break;
                    }
                    cov_24nvx1ule8().b[3][0]++;
                    cov_24nvx1ule8().s[14]++;
                    moreResult = [
                        "ADDRESS_UNKNOWN"
                    ];
                    cov_24nvx1ule8().s[15]++;
                    return _context2.a(2, {
                        address: address,
                        results: moreResult,
                        needsManualEntry: true,
                        needsUnitSelection: false
                    });
                case 2:
                    cov_24nvx1ule8().b[3][1]++;
                case 3:
                    addressResult = (cov_24nvx1ule8().s[16]++, (_standardizeAddressRe2 = standardizeAddressResponse.data) === null || _standardizeAddressRe2 === void 0 || (_standardizeAddressRe2 = _standardizeAddressRe2.casa.findByFields) === null || _standardizeAddressRe2 === void 0 ? void 0 : _standardizeAddressRe2.address);
                    cov_24nvx1ule8().s[17]++;
                    casaAddress = {
                        id: addressResult.uuid,
                        street1: addressResult.street,
                        city: addressResult.city,
                        state: addressResult.state,
                        postal_code: addressResult.postalCode,
                        unit: addressResult.unitNumber,
                        result: addressResult.result,
                        latitude: address.latitude,
                        longitude: address.longitude,
                        source: "casa"
                    };
                    _context2.n = 5;
                    break;
                case 4:
                    cov_24nvx1ule8().b[2][1]++;
                case 5:
                    cov_24nvx1ule8().s[18]++;
                    if (!((cov_24nvx1ule8().b[6][0]++, !((_casaAddress = casaAddress) !== null && _casaAddress !== void 0 && (_casaAddress = _casaAddress.result) !== null && _casaAddress !== void 0 && _casaAddress.includes("ADDRESS_MISSING_SUB_PREMISE"))) && (cov_24nvx1ule8().b[6][1]++, ((_casaAddress2 = casaAddress) === null || _casaAddress2 === void 0 ? void 0 : _casaAddress2.unit) === ""))) {
                        _context2.n = 10;
                        break;
                    }
                    cov_24nvx1ule8().b[5][0]++;
                    cov_24nvx1ule8().s[19]++;
                    _t = (cov_24nvx1ule8().b[8][0]++, casaAddress.id);
                    if (!_t) {
                        _context2.n = 7;
                        break;
                    }
                    cov_24nvx1ule8().b[8][1]++;
                    _context2.n = 6;
                    return doesAddressHaveMultipleUnits(casaAddress.id);
                case 6:
                    _t = _context2.v;
                case 7:
                    if (!_t) {
                        _context2.n = 8;
                        break;
                    }
                    cov_24nvx1ule8().b[7][0]++;
                    cov_24nvx1ule8().s[20]++;
                    moreResult = [
                        "ADDRESS_MISSING_SUB_PREMISE"
                    ];
                    _context2.n = 9;
                    break;
                case 8:
                    cov_24nvx1ule8().b[7][1]++;
                case 9:
                    _context2.n = 11;
                    break;
                case 10:
                    cov_24nvx1ule8().b[5][1]++;
                case 11:
                    combinedResults = (cov_24nvx1ule8().s[21]++, [].concat(_toConsumableArray((cov_24nvx1ule8().b[9][0]++, (_casaAddress3 = casaAddress) === null || _casaAddress3 === void 0 ? void 0 : _casaAddress3.result) || (cov_24nvx1ule8().b[9][1]++, [])), _toConsumableArray(moreResult))); // Check if address has invalid results
                    needsManualEntry = (cov_24nvx1ule8().s[22]++, ADDRESS_INVALID_RESULT.some(function(error) {
                        cov_24nvx1ule8().f[4]++;
                        cov_24nvx1ule8().s[23]++;
                        return combinedResults.includes(error);
                    }));
                    needsUnitSelection = (cov_24nvx1ule8().s[24]++, combinedResults.includes("ADDRESS_MISSING_SUB_PREMISE"));
                    cov_24nvx1ule8().s[25]++;
                    return _context2.a(2, {
                        address: casaAddress,
                        results: combinedResults,
                        needsManualEntry: needsManualEntry,
                        needsUnitSelection: needsUnitSelection
                    });
            }
        }, _callee2);
    }));
    return function validateAddress(_x2) {
        return _ref2.apply(this, arguments);
    };
}(); //# sourceMappingURL=addressValidation.mjs.map


/***/ }),

/***/ 82293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ce": function() { return /* binding */ standardizeAddress; },
/* harmony export */   "fO": function() { return /* binding */ listUnits; },
/* harmony export */   "xB": function() { return /* binding */ createMortgageLead; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82670);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41817);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32165);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_symbol_to_primitive_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96649);
/* harmony import */ var core_js_modules_es_symbol_to_primitive_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_to_primitive_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57327);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89554);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(66992);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_date_to_json_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5735);
/* harmony import */ var core_js_modules_es_date_to_json_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_date_to_json_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_date_to_primitive_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96078);
/* harmony import */ var core_js_modules_es_date_to_primitive_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_date_to_primitive_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_json_stringify_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(38862);
/* harmony import */ var core_js_modules_es_json_stringify_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_json_stringify_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9653);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(33321);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(69070);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(38880);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(49337);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(30489);
/* harmony import */ var core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(47941);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_object_set_prototype_of_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(68304);
/* harmony import */ var core_js_modules_es_object_set_prototype_of_js__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_set_prototype_of_js__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(88674);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(78783);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(2490);
/* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_esnext_iterator_filter_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(59849);
/* harmony import */ var core_js_modules_esnext_iterator_filter_js__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_filter_js__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_esnext_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(34514);
/* harmony import */ var core_js_modules_esnext_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(54747);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(33948);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(32564);
/* harmony import */ var core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(36808);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(74593);
/* harmony import */ var _globals_mjs__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(47254);

function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function cov_138knjrxo4() {
    var path = "/home/runner/_work/code/code/js/packages/cinderblocks/src/helpers/api.ts";
    var hash = "4e70a662b1c02fd7a559d347d3ac723a9db32776";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/home/runner/_work/code/code/js/packages/cinderblocks/src/helpers/api.ts",
        statementMap: {
            "0": {
                start: {
                    line: 7,
                    column: 19
                },
                end: {
                    line: 7,
                    column: 33
                }
            },
            "1": {
                start: {
                    line: 9,
                    column: 24
                },
                end: {
                    line: 9,
                    column: 84
                }
            },
            "2": {
                start: {
                    line: 14,
                    column: 20
                },
                end: {
                    line: 22,
                    column: 1
                }
            },
            "3": {
                start: {
                    line: 23,
                    column: 19
                },
                end: {
                    line: 23,
                    column: 42
                }
            },
            "4": {
                start: {
                    line: 35,
                    column: 23
                },
                end: {
                    line: 48,
                    column: 1
                }
            },
            "5": {
                start: {
                    line: 36,
                    column: 18
                },
                end: {
                    line: 36,
                    column: 38
                }
            },
            "6": {
                start: {
                    line: 37,
                    column: 21
                },
                end: {
                    line: 37,
                    column: 46
                }
            },
            "7": {
                start: {
                    line: 39,
                    column: 2
                },
                end: {
                    line: 47,
                    column: 3
                }
            },
            "8": {
                start: {
                    line: 40,
                    column: 4
                },
                end: {
                    line: 40,
                    column: 37
                }
            },
            "9": {
                start: {
                    line: 42,
                    column: 4
                },
                end: {
                    line: 42,
                    column: 31
                }
            },
            "10": {
                start: {
                    line: 42,
                    column: 21
                },
                end: {
                    line: 42,
                    column: 31
                }
            },
            "11": {
                start: {
                    line: 45,
                    column: 4
                },
                end: {
                    line: 45,
                    column: 56
                }
            },
            "12": {
                start: {
                    line: 45,
                    column: 29
                },
                end: {
                    line: 45,
                    column: 54
                }
            },
            "13": {
                start: {
                    line: 46,
                    column: 4
                },
                end: {
                    line: 46,
                    column: 75
                }
            },
            "14": {
                start: {
                    line: 50,
                    column: 15
                },
                end: {
                    line: 50,
                    column: 52
                }
            },
            "15": {
                start: {
                    line: 53,
                    column: 2
                },
                end: {
                    line: 55,
                    column: 3
                }
            },
            "16": {
                start: {
                    line: 54,
                    column: 4
                },
                end: {
                    line: 54,
                    column: 22
                }
            },
            "17": {
                start: {
                    line: 56,
                    column: 2
                },
                end: {
                    line: 59,
                    column: 5
                }
            },
            "18": {
                start: {
                    line: 57,
                    column: 4
                },
                end: {
                    line: 57,
                    column: 38
                }
            },
            "19": {
                start: {
                    line: 58,
                    column: 4
                },
                end: {
                    line: 58,
                    column: 69
                }
            },
            "20": {
                start: {
                    line: 60,
                    column: 2
                },
                end: {
                    line: 60,
                    column: 9
                }
            },
            "21": {
                start: {
                    line: 70,
                    column: 2
                },
                end: {
                    line: 83,
                    column: 5
                }
            },
            "22": {
                start: {
                    line: 87,
                    column: 2
                },
                end: {
                    line: 109,
                    column: 48
                }
            },
            "23": {
                start: {
                    line: 109,
                    column: 18
                },
                end: {
                    line: 109,
                    column: 46
                }
            },
            "24": {
                start: {
                    line: 113,
                    column: 2
                },
                end: {
                    line: 148,
                    column: 48
                }
            },
            "25": {
                start: {
                    line: 148,
                    column: 18
                },
                end: {
                    line: 148,
                    column: 46
                }
            },
            "26": {
                start: {
                    line: 171,
                    column: 19
                },
                end: {
                    line: 182,
                    column: 3
                }
            },
            "27": {
                start: {
                    line: 184,
                    column: 2
                },
                end: {
                    line: 226,
                    column: 7
                }
            },
            "28": {
                start: {
                    line: 213,
                    column: 6
                },
                end: {
                    line: 216,
                    column: 7
                }
            },
            "29": {
                start: {
                    line: 214,
                    column: 26
                },
                end: {
                    line: 214,
                    column: 47
                }
            },
            "30": {
                start: {
                    line: 215,
                    column: 8
                },
                end: {
                    line: 215,
                    column: 65
                }
            },
            "31": {
                start: {
                    line: 217,
                    column: 21
                },
                end: {
                    line: 217,
                    column: 42
                }
            },
            "32": {
                start: {
                    line: 218,
                    column: 6
                },
                end: {
                    line: 220,
                    column: 7
                }
            },
            "33": {
                start: {
                    line: 219,
                    column: 8
                },
                end: {
                    line: 219,
                    column: 76
                }
            },
            "34": {
                start: {
                    line: 221,
                    column: 6
                },
                end: {
                    line: 221,
                    column: 20
                }
            },
            "35": {
                start: {
                    line: 224,
                    column: 6
                },
                end: {
                    line: 224,
                    column: 35
                }
            },
            "36": {
                start: {
                    line: 225,
                    column: 6
                },
                end: {
                    line: 225,
                    column: 14
                }
            }
        },
        fnMap: {
            "0": {
                name: "(anonymous_0)",
                decl: {
                    start: {
                        line: 35,
                        column: 23
                    },
                    end: {
                        line: 35,
                        column: 24
                    }
                },
                loc: {
                    start: {
                        line: 35,
                        column: 97
                    },
                    end: {
                        line: 48,
                        column: 1
                    }
                },
                line: 35
            },
            "1": {
                name: "(anonymous_1)",
                decl: {
                    start: {
                        line: 45,
                        column: 22
                    },
                    end: {
                        line: 45,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 45,
                        column: 29
                    },
                    end: {
                        line: 45,
                        column: 54
                    }
                },
                line: 45
            },
            "2": {
                name: "handleResponse",
                decl: {
                    start: {
                        line: 52,
                        column: 9
                    },
                    end: {
                        line: 52,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 52,
                        column: 39
                    },
                    end: {
                        line: 61,
                        column: 1
                    }
                },
                line: 52
            },
            "3": {
                name: "(anonymous_3)",
                decl: {
                    start: {
                        line: 56,
                        column: 21
                    },
                    end: {
                        line: 56,
                        column: 22
                    }
                },
                loc: {
                    start: {
                        line: 56,
                        column: 32
                    },
                    end: {
                        line: 59,
                        column: 3
                    }
                },
                line: 56
            },
            "4": {
                name: "doBFFPost",
                decl: {
                    start: {
                        line: 65,
                        column: 9
                    },
                    end: {
                        line: 65,
                        column: 18
                    }
                },
                loc: {
                    start: {
                        line: 69,
                        column: 21
                    },
                    end: {
                        line: 84,
                        column: 1
                    }
                },
                line: 69
            },
            "5": {
                name: "listUnits",
                decl: {
                    start: {
                        line: 86,
                        column: 16
                    },
                    end: {
                        line: 86,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 86,
                        column: 47
                    },
                    end: {
                        line: 110,
                        column: 1
                    }
                },
                line: 86
            },
            "6": {
                name: "(anonymous_6)",
                decl: {
                    start: {
                        line: 109,
                        column: 11
                    },
                    end: {
                        line: 109,
                        column: 12
                    }
                },
                loc: {
                    start: {
                        line: 109,
                        column: 18
                    },
                    end: {
                        line: 109,
                        column: 46
                    }
                },
                line: 109
            },
            "7": {
                name: "standardizeAddress",
                decl: {
                    start: {
                        line: 112,
                        column: 16
                    },
                    end: {
                        line: 112,
                        column: 34
                    }
                },
                loc: {
                    start: {
                        line: 112,
                        column: 66
                    },
                    end: {
                        line: 149,
                        column: 1
                    }
                },
                line: 112
            },
            "8": {
                name: "(anonymous_8)",
                decl: {
                    start: {
                        line: 148,
                        column: 11
                    },
                    end: {
                        line: 148,
                        column: 12
                    }
                },
                loc: {
                    start: {
                        line: 148,
                        column: 18
                    },
                    end: {
                        line: 148,
                        column: 46
                    }
                },
                line: 148
            },
            "9": {
                name: "createMortgageLead",
                decl: {
                    start: {
                        line: 170,
                        column: 16
                    },
                    end: {
                        line: 170,
                        column: 34
                    }
                },
                loc: {
                    start: {
                        line: 170,
                        column: 67
                    },
                    end: {
                        line: 227,
                        column: 1
                    }
                },
                line: 170
            },
            "10": {
                name: "(anonymous_10)",
                decl: {
                    start: {
                        line: 212,
                        column: 10
                    },
                    end: {
                        line: 212,
                        column: 11
                    }
                },
                loc: {
                    start: {
                        line: 212,
                        column: 30
                    },
                    end: {
                        line: 222,
                        column: 5
                    }
                },
                line: 212
            },
            "11": {
                name: "(anonymous_11)",
                decl: {
                    start: {
                        line: 223,
                        column: 11
                    },
                    end: {
                        line: 223,
                        column: 12
                    }
                },
                loc: {
                    start: {
                        line: 223,
                        column: 18
                    },
                    end: {
                        line: 226,
                        column: 5
                    }
                },
                line: 223
            }
        },
        branchMap: {
            "0": {
                loc: {
                    start: {
                        line: 9,
                        column: 24
                    },
                    end: {
                        line: 9,
                        column: 84
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 9,
                            column: 55
                        },
                        end: {
                            line: 9,
                            column: 69
                        }
                    },
                    {
                        start: {
                            line: 9,
                            column: 72
                        },
                        end: {
                            line: 9,
                            column: 84
                        }
                    }
                ],
                line: 9
            },
            "1": {
                loc: {
                    start: {
                        line: 36,
                        column: 18
                    },
                    end: {
                        line: 36,
                        column: 38
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 36,
                            column: 18
                        },
                        end: {
                            line: 36,
                            column: 33
                        }
                    },
                    {
                        start: {
                            line: 36,
                            column: 37
                        },
                        end: {
                            line: 36,
                            column: 38
                        }
                    }
                ],
                line: 36
            },
            "2": {
                loc: {
                    start: {
                        line: 37,
                        column: 21
                    },
                    end: {
                        line: 37,
                        column: 46
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 37,
                            column: 21
                        },
                        end: {
                            line: 37,
                            column: 39
                        }
                    },
                    {
                        start: {
                            line: 37,
                            column: 43
                        },
                        end: {
                            line: 37,
                            column: 46
                        }
                    }
                ],
                line: 37
            },
            "3": {
                loc: {
                    start: {
                        line: 42,
                        column: 4
                    },
                    end: {
                        line: 42,
                        column: 31
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 42,
                            column: 4
                        },
                        end: {
                            line: 42,
                            column: 31
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 42
            },
            "4": {
                loc: {
                    start: {
                        line: 53,
                        column: 2
                    },
                    end: {
                        line: 55,
                        column: 3
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 53,
                            column: 2
                        },
                        end: {
                            line: 55,
                            column: 3
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 53
            },
            "5": {
                loc: {
                    start: {
                        line: 68,
                        column: 2
                    },
                    end: {
                        line: 68,
                        column: 53
                    }
                },
                type: "default-arg",
                locations: [
                    {
                        start: {
                            line: 68,
                            column: 51
                        },
                        end: {
                            line: 68,
                            column: 53
                        }
                    }
                ],
                line: 68
            },
            "6": {
                loc: {
                    start: {
                        line: 80,
                        column: 22
                    },
                    end: {
                        line: 80,
                        column: 56
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 80,
                            column: 22
                        },
                        end: {
                            line: 80,
                            column: 50
                        }
                    },
                    {
                        start: {
                            line: 80,
                            column: 54
                        },
                        end: {
                            line: 80,
                            column: 56
                        }
                    }
                ],
                line: 80
            },
            "7": {
                loc: {
                    start: {
                        line: 213,
                        column: 6
                    },
                    end: {
                        line: 216,
                        column: 7
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 213,
                            column: 6
                        },
                        end: {
                            line: 216,
                            column: 7
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 213
            },
            "8": {
                loc: {
                    start: {
                        line: 218,
                        column: 6
                    },
                    end: {
                        line: 220,
                        column: 7
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 218,
                            column: 6
                        },
                        end: {
                            line: 220,
                            column: 7
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 218
            }
        },
        s: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "24": 0,
            "25": 0,
            "26": 0,
            "27": 0,
            "28": 0,
            "29": 0,
            "30": 0,
            "31": 0,
            "32": 0,
            "33": 0,
            "34": 0,
            "35": 0,
            "36": 0
        },
        f: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            "10": 0,
            "11": 0
        },
        b: {
            "0": [
                0,
                0
            ],
            "1": [
                0,
                0
            ],
            "2": [
                0,
                0
            ],
            "3": [
                0,
                0
            ],
            "4": [
                0,
                0
            ],
            "5": [
                0
            ],
            "6": [
                0,
                0
            ],
            "7": [
                0,
                0
            ],
            "8": [
                0,
                0
            ]
        },
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "4e70a662b1c02fd7a559d347d3ac723a9db32776"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        // @ts-ignore
        cov_138knjrxo4 = function cov_138knjrxo4() {
            return actualCoverage;
        };
    }
    return actualCoverage;
}
cov_138knjrxo4();
function _regenerator() {
    var i = function i(r, n, o, i1) {
        var c = n && (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(n.prototype, Generator) ? n : Generator, u = Object.create(c.prototype);
        return _regeneratorDefine2(u, "_invoke", function(r, n, o) {
            var _$i, c, u, f = 0, p = o || [], y = !1, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                    return _$i = t, c = 0, u = e, G.n = r, a;
                }
            };
            function d(r, n) {
                for(c = r, u = n, t = 0; !y && f && !_$o && t < p.length; t++){
                    var _$o, _$i = p[t], _$d = G.p, l = _$i[2];
                    r > 3 ? (_$o = l === n) && (u = _$i[(c = _$i[4]) ? 5 : (c = 3, 3)], _$i[4] = _$i[5] = e) : _$i[0] <= _$d && ((_$o = r < 2 && _$d < _$i[1]) ? (c = 0, G.v = n, G.n = _$i[1]) : _$d < l && (_$o = r < 3 || _$i[0] > n || n > l) && (_$i[4] = r, _$i[5] = n, G.n = l, c = 0));
                }
                if (_$o || r > 1) return a;
                throw y = !0, n;
            }
            return function(o, p, l) {
                if (f > 1) throw TypeError("Generator is already running");
                for(y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;){
                    _$i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                    try {
                        if (f = 2, _$i) {
                            if (c || (o = "next"), t = _$i[o]) {
                                if (!(t = t.call(_$i, u))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u = t.value, c < 2 && (c = 0);
                            } else 1 === c && (t = _$i["return"]) && t.call(_$i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                            _$i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                    } catch (t1) {
                        _$i = e, c = 1, u = t1;
                    } finally{
                        f = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r, o, i1), !0), u;
    };
    var Generator = function Generator() {};
    var GeneratorFunction = function GeneratorFunction() {};
    var GeneratorFunctionPrototype = function GeneratorFunctionPrototype() {};
    var f = function f(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    };
    var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    var a = {};
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function() {
        return this;
    }), _regeneratorDefine2(u, "toString", function() {
        return "[object Generator]";
    }), (_regenerator = function _regenerator() {
        return {
            w: i,
            m: f
        };
    })();
}
function _regeneratorDefine2(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e1) {
        i = 0;
    }
    _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
        var o = function o(r, n) {
            _regeneratorDefine2(e, r, function(e) {
                return this._invoke(r, n, e);
            });
        };
        r ? i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
        }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
    }, _regeneratorDefine2(e, r, n, t);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}



























function asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n1) {
        return void e(n1);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}



var DEPLOY_ENV = (cov_138knjrxo4().s[0]++, (0,_globals_mjs__WEBPACK_IMPORTED_MODULE_30__/* .getDeployEnv */ .BS)());
var XSRF_COOKIE_KEY = (cov_138knjrxo4().s[1]++, DEPLOY_ENV !== "development" ? (cov_138knjrxo4().b[0][0]++, "XSRF-G-TOKEN") : (cov_138knjrxo4().b[0][1]++, "XSRF-TOKEN"));
// Hit staging Athena by default in development
//
// To hit local Athena invert the comment & uncommented `development` keys
var ATHENA_URLS = (cov_138knjrxo4().s[2]++, {
    production: "https://graphql.apps.opendoor.com/api/graphql",
    // development: 'http://localhost:4000/api/graphql',
    development: "https://graphql.simplersell.com/api/graphql",
    // development: 'http://athena-api-nginx-vpn-http.apps.internal.opendoor.com/api/graphql',
    qa: "https://graphql.simplersell.com/api/graphql",
    staging: "https://graphql.simplersell.com/api/graphql",
    test: "https://graphql.simplersell.com/api/graphql"
});
var ATHENA_URL = (cov_138knjrxo4().s[3]++, ATHENA_URLS[DEPLOY_ENV]);
/**
 * A wrapper around `fetch` with optional retries.
 * Retries up to `options.retries` times (defaults to `5` if not specified)
 * with a delay of `options.retryDelay` (defaults to `500ms` if not specified)
 */ cov_138knjrxo4().s[4]++;
var _fetchWithRetry = /*#__PURE__*/ function() {
    var _ref = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee(url, options) {
        var retries, retryDelay, _t;
        return _regenerator().w(function(_context) {
            while(1)switch(_context.p = _context.n){
                case 0:
                    cov_138knjrxo4().f[0]++;
                    retries = (cov_138knjrxo4().s[5]++, (cov_138knjrxo4().b[1][0]++, options.retries) || (cov_138knjrxo4().b[1][1]++, 0));
                    retryDelay = (cov_138knjrxo4().s[6]++, (cov_138knjrxo4().b[2][0]++, options.retryDelay) || (cov_138knjrxo4().b[2][1]++, 500));
                    cov_138knjrxo4().s[7]++;
                    _context.p = 1;
                    cov_138knjrxo4().s[8]++;
                    _context.n = 2;
                    return fetch(url, options);
                case 2:
                    return _context.a(2, _context.v);
                case 3:
                    _context.p = 3;
                    _t = _context.v;
                    cov_138knjrxo4().s[9]++;
                    if (!(retries < 1)) {
                        _context.n = 4;
                        break;
                    }
                    cov_138knjrxo4().b[3][0]++;
                    cov_138knjrxo4().s[10]++;
                    throw _t;
                case 4:
                    cov_138knjrxo4().b[3][1]++;
                case 5:
                    cov_138knjrxo4().s[11]++;
                    _context.n = 6;
                    return new Promise(function(r) {
                        cov_138knjrxo4().f[1]++;
                        cov_138knjrxo4().s[12]++;
                        return setTimeout(r, retryDelay);
                    });
                case 6:
                    cov_138knjrxo4().s[13]++;
                    _context.n = 7;
                    return _fetchWithRetry(url, _objectSpread(_objectSpread({}, options), {}, {
                        retries: retries - 1
                    }));
                case 7:
                    return _context.a(2, _context.v);
            }
        }, _callee, null, [
            [
                1,
                3
            ]
        ]);
    }));
    return function fetchWithRetry(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();
var Sentry = (cov_138knjrxo4().s[14]++, _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_29__/* .globalObservability.getSentryClient */ .w.getSentryClient());
function handleResponse(res) {
    var _Sentry$withScope;
    cov_138knjrxo4().f[2]++;
    cov_138knjrxo4().s[15]++;
    if (res.ok) {
        cov_138knjrxo4().b[4][0]++;
        cov_138knjrxo4().s[16]++;
        return res.json();
    } else {
        cov_138knjrxo4().b[4][1]++;
    }
    cov_138knjrxo4().s[17]++;
    (_Sentry$withScope = Sentry.withScope) === null || _Sentry$withScope === void 0 || _Sentry$withScope.call(Sentry, function(scope) {
        var _Sentry$captureMessag;
        cov_138knjrxo4().f[3]++;
        cov_138knjrxo4().s[18]++;
        scope.setExtras({
            resonse: res
        });
        cov_138knjrxo4().s[19]++;
        (_Sentry$captureMessag = Sentry.captureMessage) === null || _Sentry$captureMessag === void 0 || _Sentry$captureMessag.call(Sentry, "Non-200 response received in api call");
    });
    cov_138knjrxo4().s[20]++;
    return;
}
// To do: strengthen jsonParam's type
// Do not pass skip doBFFPost as it will not actually skip making the request - instead handle it conditionally
function doBFFPost(apiUrl, jsonParams) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (cov_138knjrxo4().b[5][0]++, {});
    cov_138knjrxo4().f[4]++;
    cov_138knjrxo4().s[21]++;
    return _fetchWithRetry(apiUrl, _objectSpread(_objectSpread({
        retries: 5,
        retryDelay: 500,
        credentials: "include",
        method: "POST",
        body: JSON.stringify(jsonParams)
    }, options), {}, {
        headers: _objectSpread({
            Accept: "application/json",
            "Content-Type": "application/json",
            "X-CSRF-Token": (cov_138knjrxo4().b[6][0]++, js_cookie__WEBPACK_IMPORTED_MODULE_28__.get(XSRF_COOKIE_KEY)) || (cov_138knjrxo4().b[6][1]++, "")
        }, options.headers)
    }));
}
function listUnits(addressUUID) {
    cov_138knjrxo4().f[5]++;
    cov_138knjrxo4().s[22]++;
    return doBFFPost(ATHENA_URL, {
        operationName: "ListUnits",
        query: "query ListUnits($addressUUID: String!, $limit: Float!) {\n        casa {\n          listUnits(input: { uuid: $addressUUID, limit: $limit }) {\n            addresses{\n              uuid\n              result\n            }\n          }\n        }\n      }",
        variables: {
            addressUUID: addressUUID,
            limit: 10
        }
    }, {
        headers: {
            "apollographql-client-name": "cinderblocks"
        }
    }).then(handleResponse)["catch"](function(e) {
        var _Sentry$captureExcept;
        cov_138knjrxo4().f[6]++;
        cov_138knjrxo4().s[23]++;
        return (_Sentry$captureExcept = Sentry.captureException) === null || _Sentry$captureExcept === void 0 ? void 0 : _Sentry$captureExcept.call(Sentry, e);
    });
}
function standardizeAddress(address) {
    cov_138knjrxo4().f[7]++;
    cov_138knjrxo4().s[24]++;
    return doBFFPost(ATHENA_URL, {
        operationName: "StandardizeAddress",
        query: "query StandardizeAddress($address: OdProtosCasaServices_CasaRequest_FindByFieldsInput!) {\n      casa {\n        findByFields(input: $address) {\n          address {\n            uuid\n            street\n            city\n            state\n            unitNumber\n            unitType\n            postalCode\n            latitude\n            longitude\n            result\n          }\n        }\n      }\n    }",
        variables: {
            address: {
                city: address.city,
                postalCode: address.postal_code,
                state: address.state,
                street: address.street1,
                unitNumber: address.unit
            }
        }
    }, {
        headers: {
            "apollographql-client-name": "cinderblocks"
        }
    }).then(handleResponse)["catch"](function(e) {
        var _Sentry$captureExcept2;
        cov_138knjrxo4().f[8]++;
        cov_138knjrxo4().s[25]++;
        return (_Sentry$captureExcept2 = Sentry.captureException) === null || _Sentry$captureExcept2 === void 0 ? void 0 : _Sentry$captureExcept2.call(Sentry, e);
    });
}
function createMortgageLead(input) {
    cov_138knjrxo4().f[9]++;
    var mutation = (cov_138knjrxo4().s[26]++, "\n    mutation MortgageLead($input: OdProtosCustomerFinancingServiceServices_CustomerFinancingRequests_CreateMortgageLeadInput!) {\n      customerFinancingService {\n        createMortgageLead(input: $input) {\n          mortgageLead {\n            mortgageLeadId\n            customerUuid\n          }\n        }\n      }\n    }\n  ");
    cov_138knjrxo4().s[27]++;
    return doBFFPost(ATHENA_URL, {
        operationName: "MortgageLead",
        query: mutation,
        variables: {
            input: {
                customerUuid: input.customerUuid,
                channel: "CUSTOMER_EXPERIENCE",
                addressToken: input === null || input === void 0 ? void 0 : input.addressToken,
                propertyType: input.propertyType,
                targetMoveDate: input.targetMoveDate,
                targetPrice: input.targetPrice,
                targetDownPayment: input.targetDownPayment,
                targetLocation: input.targetLocation,
                employmentStatus: input.employmentStatus,
                householdIncomeMin: input.householdIncomeMin,
                householdIncomeMax: input.householdIncomeMax,
                firstName: input.firstName,
                lastName: input.lastName,
                phone: input.phone,
                email: input.email,
                currentAddress: input.currentAddress
            }
        }
    }, {
        headers: {
            "apollographql-client-name": "cinderblocks"
        }
    }).then(/*#__PURE__*/ function() {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee2(response) {
            var errorText, result;
            return _regenerator().w(function(_context2) {
                while(1)switch(_context2.n){
                    case 0:
                        cov_138knjrxo4().f[10]++;
                        cov_138knjrxo4().s[28]++;
                        if (response.ok) {
                            _context2.n = 2;
                            break;
                        }
                        cov_138knjrxo4().b[7][0]++;
                        cov_138knjrxo4().s[29]++;
                        _context2.n = 1;
                        return response.text();
                    case 1:
                        errorText = _context2.v;
                        cov_138knjrxo4().s[30]++;
                        throw new Error("GraphQL mutation failed: ".concat(errorText));
                    case 2:
                        cov_138knjrxo4().b[7][1]++;
                    case 3:
                        cov_138knjrxo4().s[31]++;
                        _context2.n = 4;
                        return response.json();
                    case 4:
                        result = _context2.v;
                        cov_138knjrxo4().s[32]++;
                        if (!result.errors) {
                            _context2.n = 5;
                            break;
                        }
                        cov_138knjrxo4().b[8][0]++;
                        cov_138knjrxo4().s[33]++;
                        throw new Error("GraphQL errors: ".concat(JSON.stringify(result.errors)));
                    case 5:
                        cov_138knjrxo4().b[8][1]++;
                    case 6:
                        cov_138knjrxo4().s[34]++;
                        return _context2.a(2, result);
                }
            }, _callee2);
        }));
        return function(_x3) {
            return _ref2.apply(this, arguments);
        };
    }())["catch"](function(e) {
        var _Sentry$captureExcept3;
        cov_138knjrxo4().f[11]++;
        cov_138knjrxo4().s[35]++;
        (_Sentry$captureExcept3 = Sentry.captureException) === null || _Sentry$captureExcept3 === void 0 || _Sentry$captureExcept3.call(Sentry, e);
        cov_138knjrxo4().s[36]++;
        throw e;
    });
} //# sourceMappingURL=api.mjs.map


/***/ }),

/***/ 47254:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "wL": function() { return /* binding */ GOOGLE_CLIENT_ID; },
  "BS": function() { return /* binding */ getDeployEnv; },
  "aD": function() { return /* binding */ isDevelopmentEnv; },
  "n5": function() { return /* binding */ isProductionEnv; }
});

// UNUSED EXPORTS: GOOGLE_MAPS_KEY, SUPPORTED_LOCALES

;// CONCATENATED MODULE: ./node_modules/@opendoor/shared-fe/es/commonGlobals.mjs
/* harmony default export */ var commonGlobals = ({
  development: {
    sentryUrl: 'https://afc1da46c22d4c72b8cc5f5551fd6cb8@sentry.io/1232559',
    googleMaps: 'AIzaSyDoC3xVaCEZ2_S9Law-RubacPfYNZSQkBY',
    segment: 'piNVbkzXee9duAVuZBuTbCIJSmZ23KLL',
    webApiUrl: 'https://demo.simplersell.com',
    facebookAppID: '',
    googleClientID: '776479837796-ape5m5sc6ig7ei2oe2bd2modqdkhrm1a.apps.googleusercontent.com',
    hellosignClientID: 'd1c7dd4be8cc9bf9913beed4bff4fe29',
    intercomAppId: 'c505rgbd',
    consumerFeUrl: 'http://localhost:3010',
    partnerBffUrl: 'http://localhost:2995',
    partnerWebappUrl: 'http://localhost:3003',
    railsUrl: 'https://demo.simplersell.com',
    adminUrl: 'https://admin.simplersell.com',
    redirectURLsRegex: /.*/,
    buyerUrl: 'http://localhost:3000',
    cakeUrl: 'http://localhost:3016',
    partnershipDashboardUrl: 'http://localhost:3003',
    cityUrl: 'http://localhost:3001',
    nomadUrl: 'http://localhost:3000',
    maestroUrl: 'http://localhost:3000',
    listingVisualizationUrl: 'http://localhost:3000'
  },
  qa: {
    googleMaps: 'AIzaSyCTWhHrbB0MQB1LLI00jmhtgsOJi9m2NnE',
    segment: 'piNVbkzXee9duAVuZBuTbCIJSmZ23KLL',
    // Same as dev
    webApiUrl: 'https://demo.simplersell.com',
    // We'll need cookie routing to make this work
    facebookAppID: '',
    hellosignClientID: 'd1c7dd4be8cc9bf9913beed4bff4fe29',
    // Same as dev
    googleClientID: '',
    intercomAppId: 'c505rgbd',
    consumerFeUrl: 'https://consumer.simplersell.com',
    // We'll need cookie routing to make this work
    partnerBffUrl: 'https://partner.simplersell.com',
    // We'll need cookie routing to make this work
    partnerWebappUrl: 'https://partner.simplersell.com',
    // We'll need cookie routing to make this work
    railsUrl: 'https://demo.simplersell.com',
    // We'll need cookie routing to make this work
    adminUrl: 'https://admin.simplersell.com',
    // We'll need cookie routing to make this work
    redirectURLsRegex: /^https?:\/\/([a-z-]+\.)*(simplersell|qa.buy.opendoor)\.com(?=\/|$)/,
    buyerUrl: 'https://staging-buy.simplersell.com',
    // We'll need cookie routing to make this work
    cakeUrl: 'https://consumer.simplersell.com',
    // We'll need cookie routing to make this work
    partnershipDashboardUrl: 'https://partner.simplersell.com',
    cityUrl: 'http://city.apps-staging.opendoor.com',
    nomadUrl: 'https://nomad.apps-staging.opendoor.com',
    maestroUrl: 'https://maestro.apps-staging.opendoor.com',
    listingVisualizationUrl: 'https://listing-vis.apps-staging.opendoor.com'
  },
  staging: {
    googleMaps: 'AIzaSyCTWhHrbB0MQB1LLI00jmhtgsOJi9m2NnE',
    segment: 'hi0UliZdyDxaQblHZWB3HfgghAAuegGx',
    webApiUrl: 'https://demo.simplersell.com',
    facebookAppID: '534640070339580',
    hellosignClientID: 'd1c7dd4be8cc9bf9913beed4bff4fe29',
    googleClientID: '121750171886-1udhbfom8jjascfnsscaupb7n4p17csm.apps.googleusercontent.com',
    intercomAppId: 'c505rgbd',
    consumerFeUrl: 'https://consumer.simplersell.com',
    partnerBffUrl: 'https://partner.simplersell.com',
    partnerWebappUrl: 'https://partner.simplersell.com',
    railsUrl: 'https://demo.simplersell.com',
    adminUrl: 'https://admin.simplersell.com',
    redirectURLsRegex: /^https?:\/\/([a-z0-9-]+\.)*(simplersell|(qa|staging)\.buy\.opendoor|apps-staging\.opendoor)\.com(?=\/|$)/,
    buyerUrl: 'https://staging-buy.simplersell.com',
    cakeUrl: 'https://consumer.simplersell.com',
    partnershipDashboardUrl: 'https://partner.simplersell.com',
    cityUrl: 'http://city.apps-staging.opendoor.com',
    nomadUrl: 'https://nomad.apps-staging.opendoor.com',
    maestroUrl: 'https://maestro.apps-staging.opendoor.com',
    listingVisualizationUrl: 'https://listing-vis.apps-staging.opendoor.com'
  },
  production: {
    googleMaps: 'AIzaSyCPmXHjINLKF7UeKQgCsgZ4r8AUGGNzhNk',
    segment: 'Wx5CZGhLsaRDV4ILcNSKgxn5iZG7ErOU',
    webApiUrl: 'https://www.opendoor.com',
    facebookAppID: '293808974545537',
    hellosignClientID: '8260c9a5cd5402d13ce6f37342e3f881',
    googleClientID: '121750171886-1udhbfom8jjascfnsscaupb7n4p17csm.apps.googleusercontent.com',
    intercomAppId: 'xu4pjti7',
    consumerFeUrl: 'https://consumer.opendoor.com',
    partnerBffUrl: 'https://partner.opendoor.com',
    partnerWebappUrl: 'https://partner.opendoor.com',
    railsUrl: 'https://www.opendoor.com',
    adminUrl: 'https://admin.opendoor.com',
    redirectURLsRegex: /^https?:\/\/([a-z-]+\.)*opendoor\.com(?=\/|$)/,
    buyerUrl: 'https://buy.opendoor.com',
    cakeUrl: 'https://consumer.opendoor.com',
    partnershipDashboardUrl: 'https://partner.opendoor.com',
    cityUrl: 'https://city.apps.opendoor.com',
    nomadUrl: 'https://nomad.ops.opendoor.com',
    maestroUrl: 'https://maestro.apps.opendoor.com',
    listingVisualizationUrl: 'https://listing-vis.apps.opendoor.com'
  },
  test: {
    sentryUrl: '',
    googleMaps: 'AIzaSyB1lEtzN4O0FqRqG9ouIq6D-W93ZHSIZ34',
    segment: '',
    facebookAppID: '',
    googleClientID: '',
    hellosignClientID: '',
    webApiUrl: 'http://localhost:5006',
    intercomAppId: 'test',
    consumerFeUrl: 'http://localhost:3010',
    partnerBffUrl: 'http://localhost:2995',
    partnerWebappUrl: 'http://localhost:3003',
    railsUrl: 'http://localhost:5006',
    adminUrl: 'http://localhost:5006',
    redirectURLsRegex: /.*/,
    buyerUrl: 'http://localhost:3000',
    cakeUrl: 'http://localhost:3016',
    partnershipDashboardUrl: 'http://localhost:3003',
    cityUrl: 'http://localhost:3001',
    nomadUrl: 'http://localhost:3000',
    maestroUrl: 'http://localhost:3000',
    listingVisualizationUrl: 'http://localhost:3000'
  }
});
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__(26699);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__(32023);
;// CONCATENATED MODULE: ./node_modules/@opendoor/shared-fe/es/railsEnv.mjs


var envs = (/* unused pure expression or super */ null && (['production', 'staging', 'qa', 'development', 'test']));
function isRailsEnv(env) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return envs.includes(env);
}
function assertRailEnvOrThrow(env) {
  if (isRailsEnv(env)) {
    return env;
  }
  throw new Error("".concat(env, " is not a valid RailsEnv"));
}
var getRailsEnv = function getRailsEnv() {
  var _window, _window2, _document, _document2;
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return 'development';
  }
  var hostname = (_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.hostname;
  if (hostname === undefined) {
    return 'development';
  }
  var port = (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.location) === null || _window2 === void 0 ? void 0 : _window2.port;
  var locationHasPort = port && port !== '';
  var onLocalhost = hostname === 'localhost';
  var onNgrok = hostname.includes('.ngrok.io');
  var onXipIO = hostname.includes('.xip.io');
  var inAndroidEmulator = hostname.includes('10.0.2.2');
  var inDevelopment = onLocalhost && locationHasPort || onNgrok || onXipIO || inAndroidEmulator;
  if (inDevelopment) {
    return 'development';
  }

  // In Rails CI, tests my be on a random port
  var inRailsCI = hostname === '127.0.0.1';
  // on localhost without a port corresponds to test environment
  if (inRailsCI || onLocalhost) {
    return 'test';
  }
  var onStagingManagedDomain = hostname.includes('-staging.managed.services.opendoor.com') || hostname.includes('-staging.ops.opendoor.com') || hostname.includes('-staging.opendoor.com');
  var onSimplersell = hostname.includes('.simplersell.com');
  var onODMortgage = hostname.includes('.odmortgage.com');
  var inStaging = onStagingManagedDomain || onSimplersell || onODMortgage;
  var inProduction = hostname.includes('.opendoor.com') && !hostname.includes('-staging');
  var inProdOrStaging = inStaging || inProduction;
  var onQADomain = hostname.includes('-qa-');
  var hasQACookie = ((_document = document) === null || _document === void 0 || (_document = _document.cookie) === null || _document === void 0 ? void 0 : _document.includes('qa=')) && ((_document2 = document) === null || _document2 === void 0 || (_document2 = _document2.cookie) === null || _document2 === void 0 ? void 0 : _document2.includes('qa_env='));
  // most QA usage will be on a staging domain (.e.g `demo.simplersell.com`) with appropriate
  // cookies set
  var inQA = onQADomain || inProdOrStaging && hasQACookie;
  if (inQA) {
    return 'qa';
  } else if (inStaging) {
    return 'staging';
  } else if (inProduction) {
    return 'production';
  }

  // default case
  return 'development';
};
;// CONCATENATED MODULE: ./node_modules/@opendoor/cinderblocks/es/helpers/globals.mjs
/* provided dependency */ var process = __webpack_require__(34155);
function cov_wvj7jeami() {
    var path = "/home/runner/_work/code/code/js/packages/cinderblocks/src/helpers/globals.ts";
    var hash = "3a5b48f6f16f42917b077dd281745c0a66d84c3c";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/home/runner/_work/code/code/js/packages/cinderblocks/src/helpers/globals.ts",
        statementMap: {
            "0": {
                start: {
                    line: 4,
                    column: 17
                },
                end: {
                    line: 4,
                    column: 30
                }
            },
            "1": {
                start: {
                    line: 5,
                    column: 16
                },
                end: {
                    line: 5,
                    column: 39
                }
            },
            "2": {
                start: {
                    line: 7,
                    column: 32
                },
                end: {
                    line: 7,
                    column: 54
                }
            },
            "3": {
                start: {
                    line: 8,
                    column: 31
                },
                end: {
                    line: 8,
                    column: 49
                }
            },
            "4": {
                start: {
                    line: 10,
                    column: 33
                },
                end: {
                    line: 10,
                    column: 57
                }
            },
            "5": {
                start: {
                    line: 24,
                    column: 28
                },
                end: {
                    line: 42,
                    column: 1
                }
            },
            "6": {
                start: {
                    line: 26,
                    column: 2
                },
                end: {
                    line: 28,
                    column: 3
                }
            },
            "7": {
                start: {
                    line: 27,
                    column: 4
                },
                end: {
                    line: 27,
                    column: 72
                }
            },
            "8": {
                start: {
                    line: 31,
                    column: 2
                },
                end: {
                    line: 33,
                    column: 3
                }
            },
            "9": {
                start: {
                    line: 32,
                    column: 4
                },
                end: {
                    line: 32,
                    column: 76
                }
            },
            "10": {
                start: {
                    line: 36,
                    column: 2
                },
                end: {
                    line: 38,
                    column: 3
                }
            },
            "11": {
                start: {
                    line: 37,
                    column: 4
                },
                end: {
                    line: 37,
                    column: 64
                }
            },
            "12": {
                start: {
                    line: 41,
                    column: 2
                },
                end: {
                    line: 41,
                    column: 23
                }
            },
            "13": {
                start: {
                    line: 48,
                    column: 31
                },
                end: {
                    line: 50,
                    column: 1
                }
            },
            "14": {
                start: {
                    line: 49,
                    column: 2
                },
                end: {
                    line: 49,
                    column: 41
                }
            },
            "15": {
                start: {
                    line: 55,
                    column: 32
                },
                end: {
                    line: 57,
                    column: 1
                }
            },
            "16": {
                start: {
                    line: 56,
                    column: 2
                },
                end: {
                    line: 56,
                    column: 42
                }
            }
        },
        fnMap: {
            "0": {
                name: "(anonymous_0)",
                decl: {
                    start: {
                        line: 24,
                        column: 28
                    },
                    end: {
                        line: 24,
                        column: 29
                    }
                },
                loc: {
                    start: {
                        line: 24,
                        column: 62
                    },
                    end: {
                        line: 42,
                        column: 1
                    }
                },
                line: 24
            },
            "1": {
                name: "(anonymous_1)",
                decl: {
                    start: {
                        line: 48,
                        column: 31
                    },
                    end: {
                        line: 48,
                        column: 32
                    }
                },
                loc: {
                    start: {
                        line: 48,
                        column: 46
                    },
                    end: {
                        line: 50,
                        column: 1
                    }
                },
                line: 48
            },
            "2": {
                name: "(anonymous_2)",
                decl: {
                    start: {
                        line: 55,
                        column: 32
                    },
                    end: {
                        line: 55,
                        column: 33
                    }
                },
                loc: {
                    start: {
                        line: 55,
                        column: 47
                    },
                    end: {
                        line: 57,
                        column: 1
                    }
                },
                line: 55
            }
        },
        branchMap: {
            "0": {
                loc: {
                    start: {
                        line: 26,
                        column: 2
                    },
                    end: {
                        line: 28,
                        column: 3
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 26,
                            column: 2
                        },
                        end: {
                            line: 28,
                            column: 3
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 26
            },
            "1": {
                loc: {
                    start: {
                        line: 26,
                        column: 6
                    },
                    end: {
                        line: 26,
                        column: 70
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 26,
                            column: 6
                        },
                        end: {
                            line: 26,
                            column: 35
                        }
                    },
                    {
                        start: {
                            line: 26,
                            column: 39
                        },
                        end: {
                            line: 26,
                            column: 70
                        }
                    }
                ],
                line: 26
            },
            "2": {
                loc: {
                    start: {
                        line: 31,
                        column: 2
                    },
                    end: {
                        line: 33,
                        column: 3
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 31,
                            column: 2
                        },
                        end: {
                            line: 33,
                            column: 3
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 31
            },
            "3": {
                loc: {
                    start: {
                        line: 31,
                        column: 6
                    },
                    end: {
                        line: 31,
                        column: 75
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 31,
                            column: 6
                        },
                        end: {
                            line: 31,
                            column: 36
                        }
                    },
                    {
                        start: {
                            line: 31,
                            column: 40
                        },
                        end: {
                            line: 31,
                            column: 75
                        }
                    }
                ],
                line: 31
            },
            "4": {
                loc: {
                    start: {
                        line: 36,
                        column: 2
                    },
                    end: {
                        line: 38,
                        column: 3
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 36,
                            column: 2
                        },
                        end: {
                            line: 38,
                            column: 3
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 36
            },
            "5": {
                loc: {
                    start: {
                        line: 36,
                        column: 6
                    },
                    end: {
                        line: 36,
                        column: 63
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 36,
                            column: 6
                        },
                        end: {
                            line: 36,
                            column: 36
                        }
                    },
                    {
                        start: {
                            line: 36,
                            column: 40
                        },
                        end: {
                            line: 36,
                            column: 63
                        }
                    }
                ],
                line: 36
            }
        },
        s: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0
        },
        f: {
            "0": 0,
            "1": 0,
            "2": 0
        },
        b: {
            "0": [
                0,
                0
            ],
            "1": [
                0,
                0
            ],
            "2": [
                0,
                0
            ],
            "3": [
                0,
                0
            ],
            "4": [
                0,
                0
            ],
            "5": [
                0,
                0
            ]
        },
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "3a5b48f6f16f42917b077dd281745c0a66d84c3c"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        // @ts-ignore
        cov_wvj7jeami = function cov_wvj7jeami() {
            return actualCoverage;
        };
    }
    return actualCoverage;
}
cov_wvj7jeami();


var railsEnv = (cov_wvj7jeami().s[0]++, getRailsEnv());
var secrets = (cov_wvj7jeami().s[1]++, commonGlobals[railsEnv]);
var GOOGLE_CLIENT_ID = (cov_wvj7jeami().s[2]++, secrets.googleClientID);
var GOOGLE_MAPS_KEY = (cov_wvj7jeami().s[3]++, secrets.googleMaps);
var SUPPORTED_LOCALES = (cov_wvj7jeami().s[4]++, [
    "en-US",
    "es"
]);
/**
 * Gets the current environment in a framework-agnostic way.
 * Works with Next.js (Cosmos), Remix (Cake), and browser contexts.
 *
 * Priority order:
 * 1. window.ENV?.DEPLOY_ENV (Remix client-side)
 * 2. process.env.NEXT_PUBLIC_DEPLOY_ENV (Next.js client & server)
 * 3. process.env.DEPLOY_ENV (Remix server-side)
 * 4. getRailsEnv() (Fallback to hostname detection)
 */ /* eslint-disable @opendoor/no-direct-env-check -- implementing the helper function */ cov_wvj7jeami().s[5]++;
var getDeployEnv = function getDeployEnv() {
    var _ENV, _process$env, _process$env2;
    cov_wvj7jeami().f[0]++;
    cov_wvj7jeami().s[6]++;
    // Check window.ENV first (Remix pattern)
    if ((cov_wvj7jeami().b[1][0]++, "object" !== "undefined") && (cov_wvj7jeami().b[1][1]++, (_ENV = window.ENV) !== null && _ENV !== void 0 && _ENV.DEPLOY_ENV)) {
        cov_wvj7jeami().b[0][0]++;
        cov_wvj7jeami().s[7]++;
        return window.ENV.DEPLOY_ENV;
    } else {
        cov_wvj7jeami().b[0][1]++;
    }
    // Check Next.js public env var
    cov_wvj7jeami().s[8]++;
    if ((cov_wvj7jeami().b[3][0]++, typeof process !== "undefined") && (cov_wvj7jeami().b[3][1]++, (_process$env = process.env) !== null && _process$env !== void 0 && "production")) {
        cov_wvj7jeami().b[2][0]++;
        cov_wvj7jeami().s[9]++;
        return "production";
    } else {
        cov_wvj7jeami().b[2][1]++;
    }
    // Check Remix server env var
    cov_wvj7jeami().s[10]++;
    if ((cov_wvj7jeami().b[5][0]++, typeof process !== "undefined") && (cov_wvj7jeami().b[5][1]++, (_process$env2 = process.env) !== null && _process$env2 !== void 0 && _process$env2.DEPLOY_ENV)) {
        cov_wvj7jeami().b[4][0]++;
        cov_wvj7jeami().s[11]++;
        return process.env.DEPLOY_ENV;
    } else {
        cov_wvj7jeami().b[4][1]++;
    }
    // Falls back to Rails env method in shared-fe
    cov_wvj7jeami().s[12]++;
    return getRailsEnv();
};
/* eslint-enable @opendoor/no-direct-env-check */ /**
 * Checks if the current deploy environment is production.
 */ cov_wvj7jeami().s[13]++;
var isProductionEnv = function isProductionEnv() {
    cov_wvj7jeami().f[1]++;
    cov_wvj7jeami().s[14]++;
    return getDeployEnv() === "production";
};
/**
 * Checks if the current deploy environment is development.
 */ cov_wvj7jeami().s[15]++;
var isDevelopmentEnv = function isDevelopmentEnv() {
    cov_wvj7jeami().f[2]++;
    cov_wvj7jeami().s[16]++;
    return getDeployEnv() === "development";
}; //# sourceMappingURL=globals.mjs.map


/***/ }),

/***/ 29301:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C6": function() { return /* binding */ BricksProvider; },
/* harmony export */   "Os": function() { return /* binding */ useAnalyticsContext; }
/* harmony export */ });
/* unused harmony exports AnalyticsContext, defaultAnalyticsContext */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86872);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_tamagui_core__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _tamagui_portal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86660);
/* harmony import */ var _tamagui_toast__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2263);
/* harmony import */ var _tamagui_toast__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7797);
/* harmony import */ var _tamagui_config__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7109);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);









var defaultAnalyticsContext = {
    useObservability: function() {
        return {
            trackJourneyEvent: function(_categoryName, _eventName, _eventData, _contextualData) {}
        };
    }
}, AnalyticsContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(defaultAnalyticsContext), useAnalyticsContext = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(AnalyticsContext);
};
function BricksProvider(_param) {
    var children = _param.children, useObservability = _param.useObservability, toastViewportProps = _param.toastViewportProps, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "useObservability",
        "toastViewportProps"
    ]);
    return useObservability = useObservability !== null && useObservability !== void 0 ? useObservability : defaultAnalyticsContext.useObservability, /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(AnalyticsContext.Provider, {
        value: {
            useObservability: useObservability
        },
        children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.TamaguiProvider, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            config: _tamagui_config__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z,
            defaultTheme: "light"
        }, rest), {
            children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_tamagui_portal__WEBPACK_IMPORTED_MODULE_1__/* .PortalProvider */ .Xp, {
                children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_tamagui_toast__WEBPACK_IMPORTED_MODULE_8__/* .ToastProvider */ .VW, {
                    children: [
                        children,
                        /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_tamagui_toast__WEBPACK_IMPORTED_MODULE_9__/* .ToastViewport */ ._i, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                            flexDirection: "column",
                            top: 0,
                            left: 0,
                            right: 0
                        }, toastViewportProps))
                    ]
                })
            })
        }))
    });
}



/***/ }),

/***/ 7109:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ tamagui_config_default; }
});

// UNUSED EXPORTS: bricksConfig

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@opendoor/tokens-studio/dist/bricks-next/tokens/Novo.js
var Novo = __webpack_require__(59895);
// EXTERNAL MODULE: ./node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(86872);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@tamagui/constants/dist/esm/index.mjs + 1 modules
var esm = __webpack_require__(75425);
// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/cjs/index.js
var dist_cjs = __webpack_require__(17187);
// EXTERNAL MODULE: ./node_modules/@tamagui/use-presence/dist/esm/index.mjs + 2 modules
var dist_esm = __webpack_require__(61360);
;// CONCATENATED MODULE: ./node_modules/@tamagui/animations-css/dist/esm/createAnimations.mjs




function createAnimations(animations) {
  const reactionListeners = /* @__PURE__ */new WeakMap();
  return {
    animations,
    usePresence: dist_esm/* usePresence */.oO,
    ResetPresence: dist_esm/* ResetPresence */.il,
    supportsCSSVars: !0,
    useAnimatedNumber(initial) {
      const [val, setVal] = react.useState(initial);
      return {
        getInstance() {
          return setVal;
        },
        getValue() {
          return val;
        },
        setValue(next, config, onFinish) {
          setVal(next);
          const listeners = reactionListeners.get(setVal);
          listeners && listeners.forEach(cb => cb(next)), onFinish?.();
        },
        stop() {}
      };
    },
    useAnimatedNumberReaction({
      value
    }, onValue) {
      react.useEffect(() => {
        const instance = value.getInstance();
        let queue = reactionListeners.get(instance);
        if (!queue) {
          const next = /* @__PURE__ */new Set();
          reactionListeners.set(instance, next), queue = next;
        }
        return queue.add(onValue), () => {
          queue?.delete(onValue);
        };
      }, []);
    },
    useAnimatedNumberStyle(val, getStyle) {
      return getStyle(val.getValue());
    },
    useAnimations: ({
      props,
      presence,
      style,
      componentState,
      stateRef
    }) => {
      const isEntering = !!componentState.unmounted,
        isExiting = presence?.[0] === !1,
        sendExitComplete = presence?.[1],
        [animationKey, animationConfig] = Array.isArray(props.animation) ? props.animation : [props.animation],
        animation = animations[animationKey],
        keys = props.animateOnly ?? ["all"];
      return (0,esm/* useIsomorphicLayoutEffect */.LI)(() => {
        const host = stateRef.current.host;
        if (!sendExitComplete || !isExiting || !host) return;
        const node = host,
          onFinishAnimation = () => {
            sendExitComplete?.();
          };
        return node.addEventListener("transitionend", onFinishAnimation), node.addEventListener("transitioncancel", onFinishAnimation), () => {
          node.removeEventListener("transitionend", onFinishAnimation), node.removeEventListener("transitioncancel", onFinishAnimation);
        };
      }, [sendExitComplete, isExiting]), animation && (Array.isArray(style.transform) && (style.transform = (0,dist_cjs.transformsToString)(style.transform)), style.transition = keys.map(key => {
        const override = animations[animationConfig?.[key]] ?? animation;
        return `${key} ${override}`;
      }).join(", ")),  false && 0, animation ? {
        style,
        className: isEntering ? "t_unmounted" : ""
      } : null;
    }
  };
}

//# sourceMappingURL=createAnimations.mjs.map

;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/animations.js


var animationMap = {
    accelerateDecelerateFastest: Novo/* Novo.animation.timing.accelerateDecelerateFastest.web */.N.animation.timing.accelerateDecelerateFastest.web,
    accelerateDecelerateFast: Novo/* Novo.animation.timing.accelerateDecelerateFast.web */.N.animation.timing.accelerateDecelerateFast.web,
    accelerateDecelerateSlow: Novo/* Novo.animation.timing.accelerateDecelerateSlow.web */.N.animation.timing.accelerateDecelerateSlow.web,
    decelerateFastest: Novo/* Novo.animation.timing.decelerateFastest.web */.N.animation.timing.decelerateFastest.web,
    decelerateFast: Novo/* Novo.animation.timing.decelerateFast.web */.N.animation.timing.decelerateFast.web,
    accelerateFast: Novo/* Novo.animation.timing.accelerateFast.web */.N.animation.timing.accelerateFast.web,
    accelerateSlow: Novo/* Novo.animation.timing.accelerateSlow.web */.N.animation.timing.accelerateSlow.web,
    responsiveAccelerate: Novo/* Novo.animation.timing.responsiveAccelerate.web */.N.animation.timing.responsiveAccelerate.web,
    linear: Novo/* Novo.animation.timing.linear.web */.N.animation.timing.linear.web,
    contentfulArchAnimation: Novo/* Novo.animation.timing.contentfulArchAnimation.web */.N.animation.timing.contentfulArchAnimation.web
}, animations = createAnimations(animationMap);


;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/createTokens.js

var createTokens = function(tokens) {
    return createVariables(tokens);
}, cache = /* @__PURE__ */ new WeakMap(), createVariables = function(tokens) {
    var parentPath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    if (cache.has(tokens)) return tokens;
    var res = {};
    for(var keyIn in tokens){
        var val = tokens[keyIn], isPrefixed = keyIn[0] === "$", keyWithPrefix = isPrefixed ? keyIn : "$".concat(keyIn), key = isPrefixed ? keyWithPrefix.slice(1) : keyIn;
        if ((0,cjs.isVariable)(val)) {
            res[key] = val;
            continue;
        }
        if (val && typeof val == "object") {
            res[key] = createVariables(tokens[key], keyIn);
            continue;
        }
        var cssKey = /^\d+$/.test(keyIn) ? "bn-".concat(keyIn) : keyIn, name = "".concat(parentPath, "-").concat(cssKey), finalValue = (0,cjs.isVariable)(val) ? val : (0,cjs.createVariable)({
            val: val,
            name: name,
            key: keyWithPrefix
        });
        res[key] = finalValue;
    }
    return cache.set(res, !0), res;
};


;// CONCATENATED MODULE: ./node_modules/@tamagui/react-native-media-driver/dist/esm/matchMedia.mjs
const matchMedia = globalThis.matchMedia;

//# sourceMappingURL=matchMedia.mjs.map

;// CONCATENATED MODULE: ./node_modules/@tamagui/react-native-media-driver/dist/esm/createMedia.mjs


function createMedia(media) {
  return (0,dist_cjs.setupMatchMedia)(matchMedia), media;
}

//# sourceMappingURL=createMedia.mjs.map

;// CONCATENATED MODULE: ./node_modules/@tamagui/react-native-media-driver/dist/esm/index.mjs


//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/media.js

var BREAKPOINTS = {
    SM: 375,
    MD: 768,
    LG: 1201,
    XL: 1400
}, media = createMedia({
    smallerThanXL: {
        maxWidth: BREAKPOINTS.XL - 1
    },
    smallerThanLG: {
        maxWidth: BREAKPOINTS.LG - 1
    },
    smallerThanMD: {
        maxWidth: BREAKPOINTS.MD - 1
    },
    smallerThanSM: {
        maxWidth: BREAKPOINTS.SM - 1
    },
    largerThanXS: {
        minWidth: BREAKPOINTS.SM
    },
    largerThanSM: {
        minWidth: BREAKPOINTS.MD
    },
    largerThanMD: {
        minWidth: BREAKPOINTS.LG
    },
    largerThanLG: {
        minWidth: BREAKPOINTS.XL
    },
    // use to target devices that do not support hover
    hoverNone: {
        hover: "none"
    }
});


;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/tamagui.config.js







var bricksNextTokens = createTokens({
    color: (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, Novo/* Novo.color */.N.color), {
        transparent: "transparent"
    }), Novo/* Novo.shadow.shadowColor */.N.shadow.shadowColor),
    space: (0,_object_spread/* default */.Z)({}, Novo/* Novo.space */.N.space, Novo/* Novo.sp */.N.sp, Novo/* Novo.borderWidth */.N.borderWidth),
    radius: (0,_object_spread/* default */.Z)({}, Novo/* Novo.radius */.N.radius, Novo/* Novo.rad */.N.rad),
    opacity: Novo/* Novo.opacity */.N.opacity,
    state: Novo/* Novo.state */.N.state,
    size: (0,_object_spread/* default */.Z)({}, Novo/* Novo.size */.N.size, Novo/* Novo.sz */.N.sz),
    zIndex: {},
    text: Novo/* Novo.text */.N.text,
    // shadow tokens
    elevation: Novo/* Novo.shadow.elevation */.N.shadow.elevation,
    shadowOffsetWidth: Novo/* Novo.shadow.shadowOffsetWidth */.N.shadow.shadowOffsetWidth,
    shadowOffsetHeight: Novo/* Novo.shadow.shadowOffsetHeight */.N.shadow.shadowOffsetHeight,
    shadowOpacity: Novo/* Novo.shadow.shadowOpacity */.N.shadow.shadowOpacity,
    shadowRadius: Novo/* Novo.shadow.shadowRadius */.N.shadow.shadowRadius,
    percentages: Novo/* Novo.percentage */.N.percentage,
    backgroundBlur: Novo/* Novo.backgroundBlur */.N.backgroundBlur
}), graphik = (0,cjs.createFont)({
    // Have to add "true" for default font size, etc., because it's used by tamagui components like Dialog
    size: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, Novo/* Novo.typography.size */.N.typography.size), {
        true: Novo/* Novo.typography.size.bodyMedium */.N.typography.size.bodyMedium
    }),
    lineHeight: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, Novo/* Novo.typography.lineHeight */.N.typography.lineHeight), {
        true: Novo/* Novo.typography.lineHeight.bodyMedium */.N.typography.lineHeight.bodyMedium
    }),
    letterSpacing: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, Novo/* Novo.typography.letterSpacing */.N.typography.letterSpacing), {
        true: Novo/* Novo.typography.letterSpacing.bodyMedium */.N.typography.letterSpacing.bodyMedium
    }),
    weight: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, Novo/* Novo.typography.weight */.N.typography.weight, Novo/* Novo.fontWeight */.N.fontWeight), {
        true: Novo/* Novo.typography.weight.bodyMedium */.N.typography.weight.bodyMedium
    }),
    // TODO: Tokenize fallback font families
    family: "".concat(Novo/* Novo.typography.family */.N.typography.family, ", system-ui, sans-serif"),
    // "face" is required for React Native to pick up different font weights. Can also add "italic" font names here later if needed
    // See: https://tamagui.dev/docs/core/configuration#font-tokens
    face: {
        400: {
            normal: "Graphik-Regular"
        },
        500: {
            normal: "Graphik-Medium"
        },
        600: {
            normal: "Graphik-Semibold"
        },
        800: {
            normal: "Graphik-Bold"
        }
    }
}), bricksConfig = (0,cjs.createTamagui)({
    tokens: bricksNextTokens,
    fonts: {
        // Have to have at least one font called "body" to get some of Tamagui's types to work properly (FontSizeTokens, FontWeightTokens, etc.)
        body: graphik
    },
    // Not using themes yet, but we can add them later. See: https://tamagui.dev/docs/intro/themes
    themes: {
        light: {}
    },
    // Defines breakpoints and other media queries. See: https://tamagui.dev/docs/core/use-media
    media: media,
    // See: https://tamagui.dev/docs/core/configuration#animations
    animations: animations,
    // Only including shorthands for margin and padding for now. We may want to add more later.
    // Compare with tamagui's shorthands: https://github.com/tamagui/tamagui/blob/master/packages/shorthands/src/index.tsx
    shorthands: {
        m: "margin",
        mb: "marginBottom",
        ml: "marginLeft",
        mr: "marginRight",
        mt: "marginTop",
        mx: "marginHorizontal",
        my: "marginVertical",
        p: "padding",
        pb: "paddingBottom",
        pl: "paddingLeft",
        pr: "paddingRight",
        pt: "paddingTop",
        px: "paddingHorizontal",
        py: "paddingVertical"
    },
    // Setting to false because we don't support dark mode yet
    shouldAddPrefersColorThemes: !1,
    settings: {
        // Restricts what types are allowed for style prop values. Ideally these would all
        // be "strict". See: https://tamagui.dev/docs/core/configuration#settings
        allowedStyleValues: {
            // Allow tokens, %, numbers, and css values like auto/inherit
            space: "somewhat-strict-web",
            // Allow tokens, %, numbers, and css values like auto/inherit
            size: "somewhat-strict-web",
            // Only allow tokens
            radius: "strict",
            // Allow tokens and numbers
            zIndex: "somewhat-strict",
            // Only allow tokens
            color: "strict"
        },
        // Don't autocomplete tokens like "$color.name" (just include "$name") for
        // space, size, radius, zIndex, color (prefixed tokens for custom categories
        // still included).  See: https://tamagui.dev/docs/core/configuration#settings
        autocompleteSpecificTokens: "except-special"
    }
});
var tamagui_config_default = bricksConfig;



/***/ }),

/***/ 39125:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(55678)


/***/ }),

/***/ 11163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(68509)


/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(92028)


/***/ }),

/***/ 34155:
/***/ (function(module) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 92703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(50414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 45697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(92703)();
}


/***/ }),

/***/ 50414:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 69590:
/***/ (function(module) {

/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */

var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.
    var it;
    if (hasMap && (a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!equal(i.value[1], b.get(i.value[0]))) return false;
      return true;
    }

    if (hasSet && (a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      return true;
    }
    // END: Modifications

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    // END: fast-deep-equal

    // START: react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element) return false;

    // custom handling for React/Preact
    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements

        continue;
      }

      // all other properties should be traversed as usual
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }
    // END: react-fast-compare

    // START: fast-deep-equal
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

module.exports = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (((error.message || '').match(/stack|recursion/i))) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};


/***/ }),

/***/ 46871:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "polyfill": function() { return /* binding */ polyfill; }
/* harmony export */ });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),

/***/ 29983:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.bodyOpenClassName = exports.portalClassName = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(73935);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(45697);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalPortal = __webpack_require__(28747);

var _ModalPortal2 = _interopRequireDefault(_ModalPortal);

var _ariaAppHider = __webpack_require__(57149);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _safeHTMLElement = __webpack_require__(51112);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _reactLifecyclesCompat = __webpack_require__(46871);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var portalClassName = exports.portalClassName = "ReactModalPortal";
var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";

var isReact16 = _safeHTMLElement.canUseDOM && _reactDom2.default.createPortal !== undefined;

var createHTMLElement = function createHTMLElement(name) {
  return document.createElement(name);
};

var getCreatePortal = function getCreatePortal() {
  return isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
};

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
      var parent = getParentElement(_this.props.parentSelector);
      if (parent && parent.contains(_this.node)) {
        parent.removeChild(_this.node);
      } else {
        // eslint-disable-next-line no-console
        console.warn('React-Modal: "parentSelector" prop did not returned any DOM ' + "element. Make sure that the parent element is unmounted to " + "avoid any memory leaks.");
      }
    }, _this.portalRef = function (ref) {
      _this.portal = ref;
    }, _this.renderPortal = function (props) {
      var createPortal = getCreatePortal();
      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
      _this.portalRef(portal);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_safeHTMLElement.canUseDOM) return;

      if (!isReact16) {
        this.node = createHTMLElement("div");
      }
      this.node.className = this.props.portalClassName;

      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      var prevParent = getParentElement(prevProps.parentSelector);
      var nextParent = getParentElement(this.props.parentSelector);
      return { prevParent: prevParent, nextParent: nextParent };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, _, snapshot) {
      if (!_safeHTMLElement.canUseDOM) return;
      var _props = this.props,
          isOpen = _props.isOpen,
          portalClassName = _props.portalClassName;


      if (prevProps.portalClassName !== portalClassName) {
        this.node.className = portalClassName;
      }

      var prevParent = snapshot.prevParent,
          nextParent = snapshot.nextParent;

      if (nextParent !== prevParent) {
        prevParent.removeChild(this.node);
        nextParent.appendChild(this.node);
      }

      // Stop unnecessary renders if modal is remaining closed
      if (!prevProps.isOpen && !isOpen) return;

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;

      var state = this.portal.state;
      var now = Date.now();
      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);

      if (closesAt) {
        if (!state.beforeClose) {
          this.portal.closeWithTimeout();
        }

        setTimeout(this.removePortal, closesAt - now);
      } else {
        this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!_safeHTMLElement.canUseDOM || !isReact16) {
        return null;
      }

      if (!this.node && isReact16) {
        this.node = createHTMLElement("div");
      }

      var createPortal = getCreatePortal();
      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
        ref: this.portalRef,
        defaultStyles: Modal.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function setAppElement(element) {
      ariaAppHider.setElement(element);
    }

    /* eslint-disable react/no-unused-prop-types */

    /* eslint-enable react/no-unused-prop-types */

  }]);

  return Modal;
}(_react.Component);

Modal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  portalClassName: _propTypes2.default.string,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  ariaHideApp: _propTypes2.default.bool,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  preventScroll: _propTypes2.default.bool,
  parentSelector: _propTypes2.default.func,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  overlayElement: _propTypes2.default.func,
  contentElement: _propTypes2.default.func
};
Modal.defaultProps = {
  isOpen: false,
  portalClassName: portalClassName,
  bodyOpenClassName: bodyOpenClassName,
  role: "dialog",
  ariaHideApp: true,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: true,
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: true,
  shouldReturnFocusAfterClose: true,
  preventScroll: false,
  parentSelector: function parentSelector() {
    return document.body;
  },
  overlayElement: function overlayElement(props, contentEl) {
    return _react2.default.createElement(
      "div",
      props,
      contentEl
    );
  },
  contentElement: function contentElement(props, children) {
    return _react2.default.createElement(
      "div",
      props,
      children
    );
  }
};
Modal.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};


(0, _reactLifecyclesCompat.polyfill)(Modal);

if (false) {}

exports["default"] = Modal;

/***/ }),

/***/ 28747:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(67294);

var _propTypes = __webpack_require__(45697);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _focusManager = __webpack_require__(99685);

var focusManager = _interopRequireWildcard(_focusManager);

var _scopeTab = __webpack_require__(88338);

var _scopeTab2 = _interopRequireDefault(_scopeTab);

var _ariaAppHider = __webpack_require__(57149);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _classList = __webpack_require__(32409);

var classList = _interopRequireWildcard(_classList);

var _safeHTMLElement = __webpack_require__(51112);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _portalOpenInstances = __webpack_require__(89623);

var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);

__webpack_require__(35063);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: "ReactModal__Overlay",
  content: "ReactModal__Content"
};

/**
 * We need to support the deprecated `KeyboardEvent.keyCode` in addition to
 * `KeyboardEvent.code` for apps that still support IE11. Can be removed when
 * `react-modal` only supports React >18 (which dropped IE support).
 */
var isTabKey = function isTabKey(event) {
  return event.code === "Tab" || event.keyCode === 9;
};
var isEscKey = function isEscKey(event) {
  return event.code === "Escape" || event.keyCode === 27;
};

var ariaHiddenInstances = 0;

var ModalPortal = function (_Component) {
  _inherits(ModalPortal, _Component);

  function ModalPortal(props) {
    _classCallCheck(this, ModalPortal);

    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));

    _this.setOverlayRef = function (overlay) {
      _this.overlay = overlay;
      _this.props.overlayRef && _this.props.overlayRef(overlay);
    };

    _this.setContentRef = function (content) {
      _this.content = content;
      _this.props.contentRef && _this.props.contentRef(content);
    };

    _this.afterClose = function () {
      var _this$props = _this.props,
          appElement = _this$props.appElement,
          ariaHideApp = _this$props.ariaHideApp,
          htmlOpenClassName = _this$props.htmlOpenClassName,
          bodyOpenClassName = _this$props.bodyOpenClassName,
          parentSelector = _this$props.parentSelector;


      var parentDocument = parentSelector && parentSelector().ownerDocument || document;

      // Remove classes.
      bodyOpenClassName && classList.remove(parentDocument.body, bodyOpenClassName);

      htmlOpenClassName && classList.remove(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);

      // Reset aria-hidden attribute if all modals have been removed
      if (ariaHideApp && ariaHiddenInstances > 0) {
        ariaHiddenInstances -= 1;

        if (ariaHiddenInstances === 0) {
          ariaAppHider.show(appElement);
        }
      }

      if (_this.props.shouldFocusAfterRender) {
        if (_this.props.shouldReturnFocusAfterClose) {
          focusManager.returnFocus(_this.props.preventScroll);
          focusManager.teardownScopedFocus();
        } else {
          focusManager.popWithoutFocus();
        }
      }

      if (_this.props.onAfterClose) {
        _this.props.onAfterClose();
      }

      _portalOpenInstances2.default.deregister(_this);
    };

    _this.open = function () {
      _this.beforeOpen();
      if (_this.state.afterOpen && _this.state.beforeClose) {
        clearTimeout(_this.closeTimer);
        _this.setState({ beforeClose: false });
      } else {
        if (_this.props.shouldFocusAfterRender) {
          focusManager.setupScopedFocus(_this.node);
          focusManager.markForFocusLater();
        }

        _this.setState({ isOpen: true }, function () {
          _this.openAnimationFrame = requestAnimationFrame(function () {
            _this.setState({ afterOpen: true });

            if (_this.props.isOpen && _this.props.onAfterOpen) {
              _this.props.onAfterOpen({
                overlayEl: _this.overlay,
                contentEl: _this.content
              });
            }
          });
        });
      }
    };

    _this.close = function () {
      if (_this.props.closeTimeoutMS > 0) {
        _this.closeWithTimeout();
      } else {
        _this.closeWithoutTimeout();
      }
    };

    _this.focusContent = function () {
      return _this.content && !_this.contentHasFocus() && _this.content.focus({ preventScroll: true });
    };

    _this.closeWithTimeout = function () {
      var closesAt = Date.now() + _this.props.closeTimeoutMS;
      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
      });
    };

    _this.closeWithoutTimeout = function () {
      _this.setState({
        beforeClose: false,
        isOpen: false,
        afterOpen: false,
        closesAt: null
      }, _this.afterClose);
    };

    _this.handleKeyDown = function (event) {
      if (isTabKey(event)) {
        (0, _scopeTab2.default)(_this.content, event);
      }

      if (_this.props.shouldCloseOnEsc && isEscKey(event)) {
        event.stopPropagation();
        _this.requestClose(event);
      }
    };

    _this.handleOverlayOnClick = function (event) {
      if (_this.shouldClose === null) {
        _this.shouldClose = true;
      }

      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
        if (_this.ownerHandlesClose()) {
          _this.requestClose(event);
        } else {
          _this.focusContent();
        }
      }
      _this.shouldClose = null;
    };

    _this.handleContentOnMouseUp = function () {
      _this.shouldClose = false;
    };

    _this.handleOverlayOnMouseDown = function (event) {
      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
        event.preventDefault();
      }
    };

    _this.handleContentOnClick = function () {
      _this.shouldClose = false;
    };

    _this.handleContentOnMouseDown = function () {
      _this.shouldClose = false;
    };

    _this.requestClose = function (event) {
      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
    };

    _this.ownerHandlesClose = function () {
      return _this.props.onRequestClose;
    };

    _this.shouldBeClosed = function () {
      return !_this.state.isOpen && !_this.state.beforeClose;
    };

    _this.contentHasFocus = function () {
      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
    };

    _this.buildClassName = function (which, additional) {
      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
        base: CLASS_NAMES[which],
        afterOpen: CLASS_NAMES[which] + "--after-open",
        beforeClose: CLASS_NAMES[which] + "--before-close"
      };
      var className = classNames.base;
      if (_this.state.afterOpen) {
        className = className + " " + classNames.afterOpen;
      }
      if (_this.state.beforeClose) {
        className = className + " " + classNames.beforeClose;
      }
      return typeof additional === "string" && additional ? className + " " + additional : className;
    };

    _this.attributesFromObject = function (prefix, items) {
      return Object.keys(items).reduce(function (acc, name) {
        acc[prefix + "-" + name] = items[name];
        return acc;
      }, {});
    };

    _this.state = {
      afterOpen: false,
      beforeClose: false
    };

    _this.shouldClose = null;
    _this.moveFromContentToOverlay = null;
    return _this;
  }

  _createClass(ModalPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isOpen) {
        this.open();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (false) {}

      if (this.props.isOpen && !prevProps.isOpen) {
        this.open();
      } else if (!this.props.isOpen && prevProps.isOpen) {
        this.close();
      }

      // Focus only needs to be set once when the modal is being opened
      if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
        this.focusContent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.isOpen) {
        this.afterClose();
      }
      clearTimeout(this.closeTimer);
      cancelAnimationFrame(this.openAnimationFrame);
    }
  }, {
    key: "beforeOpen",
    value: function beforeOpen() {
      var _props = this.props,
          appElement = _props.appElement,
          ariaHideApp = _props.ariaHideApp,
          htmlOpenClassName = _props.htmlOpenClassName,
          bodyOpenClassName = _props.bodyOpenClassName,
          parentSelector = _props.parentSelector;


      var parentDocument = parentSelector && parentSelector().ownerDocument || document;

      // Add classes.
      bodyOpenClassName && classList.add(parentDocument.body, bodyOpenClassName);

      htmlOpenClassName && classList.add(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);

      if (ariaHideApp) {
        ariaHiddenInstances += 1;
        ariaAppHider.hide(appElement);
      }

      _portalOpenInstances2.default.register(this);
    }

    // Don't steal focus from inner elements

  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          id = _props2.id,
          className = _props2.className,
          overlayClassName = _props2.overlayClassName,
          defaultStyles = _props2.defaultStyles,
          children = _props2.children;

      var contentStyles = className ? {} : defaultStyles.content;
      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;

      if (this.shouldBeClosed()) {
        return null;
      }

      var overlayProps = {
        ref: this.setOverlayRef,
        className: this.buildClassName("overlay", overlayClassName),
        style: _extends({}, overlayStyles, this.props.style.overlay),
        onClick: this.handleOverlayOnClick,
        onMouseDown: this.handleOverlayOnMouseDown
      };

      var contentProps = _extends({
        id: id,
        ref: this.setContentRef,
        style: _extends({}, contentStyles, this.props.style.content),
        className: this.buildClassName("content", className),
        tabIndex: "-1",
        onKeyDown: this.handleKeyDown,
        onMouseDown: this.handleContentOnMouseDown,
        onMouseUp: this.handleContentOnMouseUp,
        onClick: this.handleContentOnClick,
        role: this.props.role,
        "aria-label": this.props.contentLabel
      }, this.attributesFromObject("aria", _extends({ modal: true }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
        "data-testid": this.props.testId
      });

      var contentElement = this.props.contentElement(contentProps, children);
      return this.props.overlayElement(overlayProps, contentElement);
    }
  }]);

  return ModalPortal;
}(_react.Component);

ModalPortal.defaultProps = {
  style: {
    overlay: {},
    content: {}
  },
  defaultStyles: {}
};
ModalPortal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  defaultStyles: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  parentSelector: _propTypes2.default.func,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  ariaHideApp: _propTypes2.default.bool,
  appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
  onAfterOpen: _propTypes2.default.func,
  onAfterClose: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  preventScroll: _propTypes2.default.bool,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  children: _propTypes2.default.node,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  overlayElement: _propTypes2.default.func,
  contentElement: _propTypes2.default.func,
  testId: _propTypes2.default.string
};
exports["default"] = ModalPortal;
module.exports = exports["default"];

/***/ }),

/***/ 57149:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.resetState = resetState;
exports.log = log;
exports.assertNodeList = assertNodeList;
exports.setElement = setElement;
exports.validateElement = validateElement;
exports.hide = hide;
exports.show = show;
exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;

var _warning = __webpack_require__(13799);

var _warning2 = _interopRequireDefault(_warning);

var _safeHTMLElement = __webpack_require__(51112);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var globalElement = null;

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState() {
  if (globalElement) {
    if (globalElement.removeAttribute) {
      globalElement.removeAttribute("aria-hidden");
    } else if (globalElement.length != null) {
      globalElement.forEach(function (element) {
        return element.removeAttribute("aria-hidden");
      });
    } else {
      document.querySelectorAll(globalElement).forEach(function (element) {
        return element.removeAttribute("aria-hidden");
      });
    }
  }
  globalElement = null;
}

/* istanbul ignore next */
function log() {
  if (false) { var check; }
}
/* eslint-enable no-console */

function assertNodeList(nodeList, selector) {
  if (!nodeList || !nodeList.length) {
    throw new Error("react-modal: No elements were found for selector " + selector + ".");
  }
}

function setElement(element) {
  var useElement = element;
  if (typeof useElement === "string" && _safeHTMLElement.canUseDOM) {
    var el = document.querySelectorAll(useElement);
    assertNodeList(el, useElement);
    useElement = el;
  }
  globalElement = useElement || globalElement;
  return globalElement;
}

function validateElement(appElement) {
  var el = appElement || globalElement;
  if (el) {
    return Array.isArray(el) || el instanceof HTMLCollection || el instanceof NodeList ? el : [el];
  } else {
    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));

    return [];
  }
}

function hide(appElement) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = validateElement(appElement)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var el = _step.value;

      el.setAttribute("aria-hidden", "true");
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

function show(appElement) {
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = validateElement(appElement)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var el = _step2.value;

      el.removeAttribute("aria-hidden");
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }
}

function documentNotReadyOrSSRTesting() {
  globalElement = null;
}

/***/ }),

/***/ 35063:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.resetState = resetState;
exports.log = log;

var _portalOpenInstances = __webpack_require__(89623);

var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Body focus trap see Issue #742

var before = void 0,
    after = void 0,
    instances = [];

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState() {
  var _arr = [before, after];

  for (var _i = 0; _i < _arr.length; _i++) {
    var item = _arr[_i];
    if (!item) continue;
    item.parentNode && item.parentNode.removeChild(item);
  }
  before = after = null;
  instances = [];
}

/* istanbul ignore next */
function log() {
  console.log("bodyTrap ----------");
  console.log(instances.length);
  var _arr2 = [before, after];
  for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
    var item = _arr2[_i2];
    var check = item || {};
    console.log(check.nodeName, check.className, check.id);
  }
  console.log("edn bodyTrap ----------");
}
/* eslint-enable no-console */

function focusContent() {
  if (instances.length === 0) {
    if (false) {}
    return;
  }
  instances[instances.length - 1].focusContent();
}

function bodyTrap(eventType, openInstances) {
  if (!before && !after) {
    before = document.createElement("div");
    before.setAttribute("data-react-modal-body-trap", "");
    before.style.position = "absolute";
    before.style.opacity = "0";
    before.setAttribute("tabindex", "0");
    before.addEventListener("focus", focusContent);
    after = before.cloneNode();
    after.addEventListener("focus", focusContent);
  }

  instances = openInstances;

  if (instances.length > 0) {
    // Add focus trap
    if (document.body.firstChild !== before) {
      document.body.insertBefore(before, document.body.firstChild);
    }
    if (document.body.lastChild !== after) {
      document.body.appendChild(after);
    }
  } else {
    // Remove focus trap
    if (before.parentElement) {
      before.parentElement.removeChild(before);
    }
    if (after.parentElement) {
      after.parentElement.removeChild(after);
    }
  }
}

_portalOpenInstances2.default.subscribe(bodyTrap);

/***/ }),

/***/ 32409:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.resetState = resetState;
exports.log = log;
var htmlClassList = {};
var docBodyClassList = {};

/* eslint-disable no-console */
/* istanbul ignore next */
function removeClass(at, cls) {
  at.classList.remove(cls);
}

/* istanbul ignore next */
function resetState() {
  var htmlElement = document.getElementsByTagName("html")[0];
  for (var cls in htmlClassList) {
    removeClass(htmlElement, htmlClassList[cls]);
  }

  var body = document.body;
  for (var _cls in docBodyClassList) {
    removeClass(body, docBodyClassList[_cls]);
  }

  htmlClassList = {};
  docBodyClassList = {};
}

/* istanbul ignore next */
function log() {
  if (false) { var _x, x, buffer, classes; }
}
/* eslint-enable no-console */

/**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var incrementReference = function incrementReference(poll, className) {
  if (!poll[className]) {
    poll[className] = 0;
  }
  poll[className] += 1;
  return className;
};

/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var decrementReference = function decrementReference(poll, className) {
  if (poll[className]) {
    poll[className] -= 1;
  }
  return className;
};

/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */
var trackClass = function trackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    incrementReference(poll, className);
    classListRef.add(className);
  });
};

/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */
var untrackClass = function untrackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    decrementReference(poll, className);
    poll[className] === 0 && classListRef.remove(className);
  });
};

/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var add = exports.add = function add(element, classString) {
  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var remove = exports.remove = function remove(element, classString) {
  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/***/ }),

/***/ 99685:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.resetState = resetState;
exports.log = log;
exports.handleBlur = handleBlur;
exports.handleFocus = handleFocus;
exports.markForFocusLater = markForFocusLater;
exports.returnFocus = returnFocus;
exports.popWithoutFocus = popWithoutFocus;
exports.setupScopedFocus = setupScopedFocus;
exports.teardownScopedFocus = teardownScopedFocus;

var _tabbable = __webpack_require__(37845);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState() {
  focusLaterElements = [];
}

/* istanbul ignore next */
function log() {
  if (false) {}
}
/* eslint-enable no-console */

function handleBlur() {
  needToFocus = true;
}

function handleFocus() {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.
    setTimeout(function () {
      if (modalElement.contains(document.activeElement)) {
        return;
      }
      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}

function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}

/* eslint-disable no-console */
function returnFocus() {
  var preventScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var toFocus = null;
  try {
    if (focusLaterElements.length !== 0) {
      toFocus = focusLaterElements.pop();
      toFocus.focus({ preventScroll: preventScroll });
    }
    return;
  } catch (e) {
    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
  }
}
/* eslint-enable no-console */

function popWithoutFocus() {
  focusLaterElements.length > 0 && focusLaterElements.pop();
}

function setupScopedFocus(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener("blur", handleBlur, false);
    document.addEventListener("focus", handleFocus, true);
  } else {
    window.attachEvent("onBlur", handleBlur);
    document.attachEvent("onFocus", handleFocus);
  }
}

function teardownScopedFocus() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener("blur", handleBlur);
    document.removeEventListener("focus", handleFocus);
  } else {
    window.detachEvent("onBlur", handleBlur);
    document.detachEvent("onFocus", handleFocus);
  }
}

/***/ }),

/***/ 89623:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.log = log;
exports.resetState = resetState;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Tracks portals that are open and emits events to subscribers

var PortalOpenInstances = function PortalOpenInstances() {
  var _this = this;

  _classCallCheck(this, PortalOpenInstances);

  this.register = function (openInstance) {
    if (_this.openInstances.indexOf(openInstance) !== -1) {
      if (false) {}
      return;
    }
    _this.openInstances.push(openInstance);
    _this.emit("register");
  };

  this.deregister = function (openInstance) {
    var index = _this.openInstances.indexOf(openInstance);
    if (index === -1) {
      if (false) {}
      return;
    }
    _this.openInstances.splice(index, 1);
    _this.emit("deregister");
  };

  this.subscribe = function (callback) {
    _this.subscribers.push(callback);
  };

  this.emit = function (eventType) {
    _this.subscribers.forEach(function (subscriber) {
      return subscriber(eventType,
      // shallow copy to avoid accidental mutation
      _this.openInstances.slice());
    });
  };

  this.openInstances = [];
  this.subscribers = [];
};

var portalOpenInstances = new PortalOpenInstances();

/* eslint-disable no-console */
/* istanbul ignore next */
function log() {
  console.log("portalOpenInstances ----------");
  console.log(portalOpenInstances.openInstances.length);
  portalOpenInstances.openInstances.forEach(function (p) {
    return console.log(p);
  });
  console.log("end portalOpenInstances ----------");
}

/* istanbul ignore next */
function resetState() {
  portalOpenInstances = new PortalOpenInstances();
}
/* eslint-enable no-console */

exports["default"] = portalOpenInstances;

/***/ }),

/***/ 51112:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.canUseDOM = exports.SafeNodeList = exports.SafeHTMLCollection = undefined;

var _exenv = __webpack_require__(58875);

var _exenv2 = _interopRequireDefault(_exenv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EE = _exenv2.default;

var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};

var SafeHTMLCollection = exports.SafeHTMLCollection = EE.canUseDOM ? window.HTMLCollection : {};

var SafeNodeList = exports.SafeNodeList = EE.canUseDOM ? window.NodeList : {};

var canUseDOM = exports.canUseDOM = EE.canUseDOM;

exports["default"] = SafeHTMLElement;

/***/ }),

/***/ 88338:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = scopeTab;

var _tabbable = __webpack_require__(37845);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getActiveElement() {
  var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

  return el.activeElement.shadowRoot ? getActiveElement(el.activeElement.shadowRoot) : el.activeElement;
}

function scopeTab(node, event) {
  var tabbable = (0, _tabbable2.default)(node);

  if (!tabbable.length) {
    // Do nothing, since there are no elements that can receive focus.
    event.preventDefault();
    return;
  }

  var target = void 0;

  var shiftKey = event.shiftKey;
  var head = tabbable[0];
  var tail = tabbable[tabbable.length - 1];
  var activeElement = getActiveElement();

  // proceed with default browser behavior on tab.
  // Focus on last element on shift + tab.
  if (node === activeElement) {
    if (!shiftKey) return;
    target = tail;
  }

  if (tail === activeElement && !shiftKey) {
    target = head;
  }

  if (head === activeElement && shiftKey) {
    target = tail;
  }

  if (target) {
    event.preventDefault();
    target.focus();
    return;
  }

  // Safari radio issue.
  //
  // Safari does not move the focus to the radio button,
  // so we need to force it to really walk through all elements.
  //
  // This is very error prone, since we are trying to guess
  // if it is a safari browser from the first occurence between
  // chrome or safari.
  //
  // The chrome user agent contains the first ocurrence
  // as the 'chrome/version' and later the 'safari/version'.
  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;

  // If we are not in safari desktop, let the browser control
  // the focus
  if (!isSafariDesktop) return;

  var x = tabbable.indexOf(activeElement);

  if (x > -1) {
    x += shiftKey ? -1 : 1;
  }

  target = tabbable[x];

  // If the tabbable element does not exist,
  // focus head/tail based on shiftKey
  if (typeof target === "undefined") {
    event.preventDefault();
    target = shiftKey ? tail : head;
    target.focus();
    return;
  }

  event.preventDefault();

  target.focus();
}
module.exports = exports["default"];

/***/ }),

/***/ 37845:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

var DISPLAY_NONE = "none";
var DISPLAY_CONTENTS = "contents";

// match the whole word to prevent fuzzy searching
var tabbableNode = /^(input|select|textarea|button|object|iframe)$/;

function isNotOverflowing(element, style) {
  return style.getPropertyValue("overflow") !== "visible" ||
  // if 'overflow: visible' set, check if there is actually any overflow
  element.scrollWidth <= 0 && element.scrollHeight <= 0;
}

function hidesContents(element) {
  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;

  // If the node is empty, this is good enough
  if (zeroSize && !element.innerHTML) return true;

  try {
    // Otherwise we need to check some styles
    var style = window.getComputedStyle(element);
    var displayValue = style.getPropertyValue("display");
    return zeroSize ? displayValue !== DISPLAY_CONTENTS && isNotOverflowing(element, style) : displayValue === DISPLAY_NONE;
  } catch (exception) {
    // eslint-disable-next-line no-console
    console.warn("Failed to inspect element style");
    return false;
  }
}

function visible(element) {
  var parentElement = element;
  var rootNode = element.getRootNode && element.getRootNode();
  while (parentElement) {
    if (parentElement === document.body) break;

    // if we are not hidden yet, skip to checking outside the Web Component
    if (rootNode && parentElement === rootNode) parentElement = rootNode.host.parentNode;

    if (hidesContents(parentElement)) return false;
    parentElement = parentElement.parentNode;
  }
  return true;
}

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}

function tabbable(element) {
  var tabIndex = element.getAttribute("tabindex");
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  var descendants = [].slice.call(element.querySelectorAll("*"), 0).reduce(function (finished, el) {
    return finished.concat(!el.shadowRoot ? [el] : findTabbableDescendants(el.shadowRoot));
  }, []);
  return descendants.filter(tabbable);
}
module.exports = exports["default"];

/***/ }),

/***/ 83253:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _Modal = __webpack_require__(29983);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports["default"] = _Modal2.default;
module.exports = exports["default"];

/***/ }),

/***/ 13799:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),

/***/ 22805:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var Platform = {
  OS: 'web',
  select: obj => 'web' in obj ? obj.web : obj.default,
  get isTesting() {
    if (false) {}
    return false;
  }
};
/* harmony default export */ __webpack_exports__["Z"] = (Platform);

/***/ }),

/***/ 95674:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HD": function() { return /* binding */ AuthContextProvider; },
/* harmony export */   "aC": function() { return /* binding */ useAuth; }
/* harmony export */ });
/* unused harmony exports AuthContext, DEFAULT_LOGIN_DISPLAY_ERROR_MESSAGE, EMAIL_PREFILL_QUERY_PARAM, LOGIN_LITE_ACCESS_TOKEN_QUERY_PARAM, LOGOUT_URL, getDomain, getLoginLiteUrlWithRedirect, getLoginUrlWithRedirect, isFetchResponseReauthRequired, isFetchResponseUnauthenticated, isFetchResponseUnauthorized, isGraphQLErrorReauthRequired, isGraphQLErrorUnauthenticated, isGraphQLErrorUnauthorized, parseAuthentication, resetPasswordMutation, useAuthAuthenticated, userSessionQuery, validateResetPasswordTokenQuery */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);



function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

var DEFAULT_LOGIN_DISPLAY_ERROR_MESSAGE = 'Sorry, something went wrong.';
var AuthContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext({
  authentication: {
    state: 'not_authenticated',
    user: null
  },
  logout: function logout() {},
  refresh: function refresh() {},
  verifyLogin: ( /*#__PURE__*/function () {
    var _verifyLogin = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", {
              success: false,
              displayErrorMessage: DEFAULT_LOGIN_DISPLAY_ERROR_MESSAGE
            });
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function verifyLogin() {
      return _verifyLogin.apply(this, arguments);
    }
    return verifyLogin;
  }()),
  validateResetPasswordToken: ( /*#__PURE__*/function () {
    var _validateResetPasswordToken = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", {
              success: true
            });
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    function validateResetPasswordToken() {
      return _validateResetPasswordToken.apply(this, arguments);
    }
    return validateResetPasswordToken;
  }()),
  resetPassword: ( /*#__PURE__*/function () {
    var _resetPassword = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", {
              success: true
            });
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    function resetPassword() {
      return _resetPassword.apply(this, arguments);
    }
    return resetPassword;
  }())
});
/** Gets AuthenticationState. */
function useAuth() {
  var authContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(AuthContext);
  return _extends({}, authContext, {
    user: authContext.authentication.user
  });
}
/**
 * Gets AuthenticationState, but only if used in an authenticated context.
 *
 * This hook will guarantee that a user exists, but throws an error if not in an authenticated context.
 *
 * ```typescript
 * const Hello = () => {
 *   const { authentication } = useAuth();
 *   if (authentication.state === 'authenticated') {
 *     return <HelloAuthenticated />;
 *   } else {
 *     return <HelloMaybeAuthenticated />;
 *   }
 * };
 *
 * const HelloAuthenticated = () => {
 *   // GOOD. This will get the user and we don't have to check for null/undefined.
 *   const { user } = useAuthAuthenticated();
 *   return `Hello, ${user.name}`;
 * };
 *
 * const HelloMaybeAuthenticated = () => {
 *   // BAD. This will crash.
 *   const { user } = useAuthAuthenticated();
 *
 *   // GOOD. This will get the user but we must check for null/undefined before using it.
 *   const { user } = useAuth();
 *   if (user) {
 *     return `Hello, ${user.name}`;
 *   } else {
 *     return 'Hello, stranger';
 *   }
 * };
 * ```
 * @throws an error if not in an authenticated context
 */
function useAuthAuthenticated() {
  var _useAuth = useAuth(),
    authentication = _useAuth.authentication,
    logout = _useAuth.logout,
    refresh = _useAuth.refresh,
    verifyLogin = _useAuth.verifyLogin,
    validateResetPasswordToken = _useAuth.validateResetPasswordToken,
    resetPassword = _useAuth.resetPassword;
  if (authentication.state === 'authenticated') {
    return {
      authentication: authentication,
      user: authentication.user,
      logout: logout,
      refresh: refresh,
      verifyLogin: verifyLogin,
      validateResetPasswordToken: validateResetPasswordToken,
      resetPassword: resetPassword
    };
  } else {
    throw new Error('DEVELOPER ERROR: useAuthAuthenticated must be used in an authenticated context');
  }
}

var domains = {
  production: 'https://www.opendoor.com',
  staging: 'https://demo.simplersell.com',
  qa: 'https://demo.simplersell.com',
  development: 'http://localhost:3011',
  // cosmos
  test: 'https://www.opendoor.com'
};
var getDomain = function getDomain(env) {
  var domain = domains[env];
  if (!domain) {
    throw new Error("DEVELOPER ERROR: Invalid DOMAIN, env " + env + " is not in " + Object.keys(domains).join(','));
  }
  return domain;
};
// Login redirects will not work across domains.
// if cake is configured to use staging, you will be routed
// to the staging login page, but you will not be redirected
// to your local cake instance once you've logged in.
//
// See the 'using a real session with Athena staging'
// section in the README for more information.
var getRedirectUrl = function getRedirectUrl() {
  return encodeURIComponent(window.location.href);
};
var LOGOUT_URL = function LOGOUT_URL(env) {
  return getDomain(env) + "/logout";
};
// Name of the query param that stores an email prefill for /login
var EMAIL_PREFILL_QUERY_PARAM = 'emailPrefill';
/**
 * Returns the URL for normal login. If successfully authenticated, the user will be redirected to the current location.
 *
 * @param env - Environment to use to get the correct domain
 * @param emailPrefill  - [Optional] Email to use to prefill the log-in/sign-up form
 */
var getLoginUrlWithRedirect = function getLoginUrlWithRedirect(env, emailPrefill) {
  var emailPrefillParam = emailPrefill ? "&" + EMAIL_PREFILL_QUERY_PARAM + "=" + emailPrefill : '';
  return getDomain(env) + "/login?redirectTo=" + getRedirectUrl() + emailPrefillParam;
};
// Login lite query params
var LOGIN_LITE_ACCESS_TOKEN_QUERY_PARAM = 'access_token';
/**
 * @description
 * Returns the URL for login lite. If successfully authenticated, the user will be redirected to the current location.
 *
 * Domain: `opendoor.com/token`
 * Query params:
 *    1. `access_token=<TOKEN>`
 *    2. `redirect_url=<ENCODED_CURRENT_URL>`
 */
var getLoginLiteUrlWithRedirect = function getLoginLiteUrlWithRedirect(env, accessToken) {
  return getDomain(env) + "/token?" + LOGIN_LITE_ACCESS_TOKEN_QUERY_PARAM + "=" + accessToken + "&redirect_url=" + getRedirectUrl();
};

var useGraphqlQuery = function useGraphqlQuery(client, query, vars) {
  var queryFn = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    return client.query(query, vars);
  },
  // this is just to fix the exhaustive deps false positive, it does use all of
  // the correct deps, query and vars are just in JSON.stringify
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [client, JSON.stringify({
    query: query,
    vars: vars
  })]);
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true),
    runQuery = _useState[0],
    setRunQuery = _useState[1];
  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
      loading: true,
      error: undefined,
      data: undefined
    }),
    fetchState = _useState2[0],
    setFetchState = _useState2[1];
  var refreshFn = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    return setRunQuery(true);
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (!runQuery) {
      return;
    }
    var unmounted = false;
    function execute() {
      return _execute.apply(this, arguments);
    }
    function _execute() {
      _execute = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return queryFn();
            case 3:
              result = _context.sent;
              if (!unmounted) {
                setFetchState({
                  loading: false,
                  data: result.data,
                  error: result.error
                });
              }
              _context.next = 10;
              break;
            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              if (!unmounted) {
                setFetchState({
                  loading: false,
                  data: undefined,
                  error: _context.t0
                });
              }
            case 10:
              _context.prev = 10;
              if (!unmounted) {
                setRunQuery(false);
              }
              return _context.finish(10);
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 7, 10, 13]]);
      }));
      return _execute.apply(this, arguments);
    }
    execute();
    // Check unmounted before changing state ensures that
    // 1) If the entire component unmounted, we don't change state.
    // 2) If runQuery or queryFn change, we don't mix up state between different queries.
    return function () {
      unmounted = true;
    };
  }, [runQuery, queryFn]);
  return _extends({}, fetchState, {
    refresh: refreshFn
  });
};

function convertHumanToUser(human, trackError) {
  // TODO: Remove this check (see feature request here: https://github.com/opendoor-labs/code/pull/35285)
  if (!human.email) {
    var message = 'invalid data returned: missing Human.email';
    trackError && trackError(message);
    return {
      state: 'error',
      user: undefined,
      message: message
    };
  }
  var fullName = human.full_name || human.first_name || 'Customer';
  var firstName = human.first_name || human.full_name || 'Customer';
  var hasOpendoorEmail = human.email.endsWith('@opendoor.com');
  var hasOpendoorInternalAccess = human.opendoor_internal_access || false;
  var impersonated = human.impersonated || false;
  return {
    state: 'authenticated',
    user: {
      humanToken: human.token,
      customerUuid: human.customer_uuid || null,
      email: human.email,
      fullName: fullName,
      firstName: firstName,
      hasOpendoorEmail: hasOpendoorEmail,
      hasOpendoorInternalAccess: hasOpendoorInternalAccess,
      primaryPhone: human.primary_phone || null,
      impersonated: impersonated
    }
  };
}
var parseAuthentication = function parseAuthentication(queryResult, trackError) {
  var _queryResult$data;
  if (queryResult.loading) {
    return {
      state: 'authenticating',
      user: undefined
    };
  }
  if (queryResult.error) {
    trackError && trackError('UserSession error', queryResult.error);
    return {
      state: 'error',
      user: undefined,
      message: queryResult.error.message
    };
  }
  var userSession = (_queryResult$data = queryResult.data) == null ? void 0 : _queryResult$data.web.userSession;
  if (!userSession) {
    // If UserSession is missing, the server returned invalid data.
    var message = 'invalid data returned: missing UserSession';
    trackError && trackError(message);
    return {
      state: 'error',
      user: undefined,
      message: message
    };
  }
  if (!userSession.human) {
    return {
      state: 'not_authenticated',
      user: null
    };
  }
  return convertHumanToUser(userSession.human, trackError);
};

/** TODO: Add documentation */
var AuthContextProvider = function AuthContextProvider(_ref) {
  var _ref$trackError = _ref.trackError,
    trackError = _ref$trackError === void 0 ? function () {} : _ref$trackError,
    client = _ref.client,
    _ref$fetch = _ref.fetch,
    fetchFn = _ref$fetch === void 0 ? fetch : _ref$fetch,
    env = _ref.env,
    children = _ref.children;
  // TODO: Check if we have cookie so we can possibly skip the network call.
  var queryResult = useGraphqlQuery(client, userSessionQuery, {});
  var logout = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    return fetchFn(getDomain(env) + "/session/sign-out", {
      method: 'GET',
      credentials: 'include'
    }).then(function () {
      window.location.reload();
    })["catch"](function (e) {
      trackError('logout', e);
      window.location.assign(LOGOUT_URL(env));
    });
  }, [env, fetchFn, trackError]);
  var validateResetPasswordToken = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(resetPasswordToken) {
      var _response$data, response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return client.query(validateResetPasswordTokenQuery, {
              resetPasswordToken: resetPasswordToken
            });
          case 3:
            response = _context.sent;
            return _context.abrupt("return", {
              success: !!(response != null && (_response$data = response.data) != null && (_response$data = _response$data.webPassword) != null && (_response$data = _response$data.validateResetPasswordToken) != null && _response$data.valid)
            });
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", {
              success: false,
              displayErrorMessage: 'Error Validating Reset Password Token'
            });
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 7]]);
    }));
    return function validateResetPasswordToken(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var resetPassword = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(token, password) {
      var response;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return client.query(resetPasswordMutation, {
              resetPasswordToken: token,
              newPassword: password
            });
          case 3:
            response = _context2.sent;
            if (response.error) {
              _context2.next = 6;
              break;
            }
            return _context2.abrupt("return", {
              success: true
            });
          case 6:
            return _context2.abrupt("return", {
              success: false
            });
          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](0);
            return _context2.abrupt("return", {
              success: false
            });
          case 12:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 9]]);
    }));
    return function resetPassword(_x2, _x3) {
      return _ref3.apply(this, arguments);
    };
  }();
  var verifyLogin = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (credentials) {
    return callVerifyLogin(env, fetchFn, trackError, credentials);
  }, [env, fetchFn, trackError]);
  var authentication = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return parseAuthentication({
      data: queryResult.data,
      loading: queryResult.loading,
      error: queryResult.error
    }, trackError);
  },
  // trackError isn't needed here
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [queryResult.loading, queryResult.data, queryResult.error, logout]);
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement(AuthContext.Provider, {
    value: {
      authentication: authentication,
      logout: logout,
      refresh: queryResult.refresh,
      verifyLogin: verifyLogin,
      validateResetPasswordToken: validateResetPasswordToken,
      resetPassword: resetPassword
    }
  }, children);
};
function callVerifyLogin(_x4, _x5, _x6, _x7) {
  return _callVerifyLogin.apply(this, arguments);
}
function _callVerifyLogin() {
  _callVerifyLogin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(env, fetchFn, trackError, credentials) {
    var payload, resp, displayErrorMessage, json;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          if ('googleIdToken' in credentials) {
            payload = {
              google_id_token: credentials.googleIdToken
            };
          } else if ('facebookIdToken' in credentials) {
            payload = {
              facebook_id_token: credentials.facebookIdToken
            };
          } else {
            payload = {
              human: {
                email: credentials.email,
                password: credentials.password
              }
            };
          }
          // See `verify_login` at
          // https://github.com/opendoor-labs/web/blob/master/app/controllers/humans/sessions_controller.rb
          _context3.prev = 1;
          _context3.next = 4;
          return fetchFn(getDomain(env) + "/verify_login", {
            method: 'POST',
            credentials: 'include',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
          });
        case 4:
          resp = _context3.sent;
          _context3.next = 11;
          break;
        case 7:
          _context3.prev = 7;
          _context3.t0 = _context3["catch"](1);
          trackError('login', _context3.t0);
          return _context3.abrupt("return", {
            success: false,
            displayErrorMessage: DEFAULT_LOGIN_DISPLAY_ERROR_MESSAGE
          });
        case 11:
          if (!resp.ok) {
            _context3.next = 15;
            break;
          }
          return _context3.abrupt("return", {
            success: true
          });
        case 15:
          displayErrorMessage = DEFAULT_LOGIN_DISPLAY_ERROR_MESSAGE;
          _context3.prev = 16;
          _context3.next = 19;
          return resp.json();
        case 19:
          json = _context3.sent;
          if ('error' in json) {
            displayErrorMessage = json['error'];
          }
          _context3.next = 26;
          break;
        case 23:
          _context3.prev = 23;
          _context3.t1 = _context3["catch"](16);
          trackError('login error without error message', _context3.t1);
        case 26:
          return _context3.abrupt("return", {
            success: false,
            displayErrorMessage: displayErrorMessage
          });
        case 27:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[1, 7], [16, 23]]);
  }));
  return _callVerifyLogin.apply(this, arguments);
}
var userSessionQuery = /* GraphQL */"\n  query UserSession {\n    web {\n      userSession {\n        human {\n          token\n          customer_uuid\n          email\n          first_name\n          full_name\n          opendoor_internal_access\n          primary_phone\n          impersonated\n        }\n      }\n    }\n  }\n";
var validateResetPasswordTokenQuery = /* GraphQL */"\n  query validateResetPasswordToken($resetPasswordToken: String!) {\n    webPassword {\n      validateResetPasswordToken(input: { resetPasswordToken: $resetPasswordToken }) {\n        valid\n      }\n    }\n  }\n";
var resetPasswordMutation = /* GraphQL */"\n  mutation resetPassword($resetPasswordToken: String!, $newPassword: String!) {\n    webPassword {\n      resetPassword(input: { resetPasswordToken: $resetPasswordToken, newPassword: $newPassword }) {\n        _empty\n      }\n    }\n  }\n";

var CODE_REAUTHENTICATION_REQUIRED = 'reauthentication-required';
var isFetchResponseUnauthenticated = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(resp) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", resp.status === 401);
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function isFetchResponseUnauthenticated(_x) {
    return _ref.apply(this, arguments);
  };
}()));
var isFetchResponseUnauthorized = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(resp) {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          return _context2.abrupt("return", resp.status === 403);
        case 1:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function isFetchResponseUnauthorized(_x2) {
    return _ref2.apply(this, arguments);
  };
}()));
var isFetchResponseReauthRequired = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref3 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(resp) {
    var _json$metadata, json;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          if (!(resp.status !== 403)) {
            _context3.next = 2;
            break;
          }
          return _context3.abrupt("return", false);
        case 2:
          _context3.prev = 2;
          _context3.next = 5;
          return resp.json();
        case 5:
          json = _context3.sent;
          return _context3.abrupt("return", (json == null || (_json$metadata = json.metadata) == null ? void 0 : _json$metadata.code) === CODE_REAUTHENTICATION_REQUIRED || false);
        case 9:
          _context3.prev = 9;
          _context3.t0 = _context3["catch"](2);
          return _context3.abrupt("return", false);
        case 12:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[2, 9]]);
  }));
  return function isFetchResponseReauthRequired(_x3) {
    return _ref3.apply(this, arguments);
  };
}()));
var isGraphQLErrorUnauthenticated = function isGraphQLErrorUnauthenticated(error) {
  // TODO: Update Athena error serialization so we don't need to look at the stacktrace.
  // https://opendoor.atlassian.net/browse/SXP-587
  return error.message.startsWith('HTTP Error 401');
};
var isGraphQLErrorUnauthorized = function isGraphQLErrorUnauthorized(error) {
  // TODO: Update Athena error serialization so we don't need to look at the stacktrace.
  // https://opendoor.atlassian.net/browse/SXP-587
  return error.message.startsWith('HTTP Error 403');
};
var isGraphQLErrorReauthRequired = function isGraphQLErrorReauthRequired(error) {
  // TODO: Update Athena error serialization so we don't need to look at the stacktrace.
  // https://opendoor.atlassian.net/browse/SXP-587
  return error.message.startsWith('HTTP Error 403') && error.message.includes("\"code\":\"" + CODE_REAUTHENTICATION_REQUIRED + "\"");
};




/***/ }),

/***/ 85491:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
exports.Z = {
    development: {
        sentryUrl: 'https://afc1da46c22d4c72b8cc5f5551fd6cb8@sentry.io/1232559',
        googleMaps: 'AIzaSyDoC3xVaCEZ2_S9Law-RubacPfYNZSQkBY',
        segment: 'piNVbkzXee9duAVuZBuTbCIJSmZ23KLL',
        webApiUrl: 'https://demo.simplersell.com',
        facebookAppID: '',
        googleClientID: '776479837796-ape5m5sc6ig7ei2oe2bd2modqdkhrm1a.apps.googleusercontent.com',
        hellosignClientID: 'd1c7dd4be8cc9bf9913beed4bff4fe29',
        intercomAppId: 'c505rgbd',
        consumerFeUrl: 'http://localhost:3010',
        partnerBffUrl: 'http://localhost:2995',
        partnerWebappUrl: 'http://localhost:3003',
        railsUrl: 'https://demo.simplersell.com',
        adminUrl: 'https://admin.simplersell.com',
        redirectURLsRegex: /.*/,
        buyerUrl: 'http://localhost:3000',
        cakeUrl: 'http://localhost:3016',
        partnershipDashboardUrl: 'http://localhost:3003',
        cityUrl: 'http://localhost:3001',
        nomadUrl: 'http://localhost:3000',
        maestroUrl: 'http://localhost:3000',
        listingVisualizationUrl: 'http://localhost:3000',
    },
    qa: {
        googleMaps: 'AIzaSyCTWhHrbB0MQB1LLI00jmhtgsOJi9m2NnE',
        segment: 'piNVbkzXee9duAVuZBuTbCIJSmZ23KLL', // Same as dev
        webApiUrl: 'https://demo.simplersell.com', // We'll need cookie routing to make this work
        facebookAppID: '',
        hellosignClientID: 'd1c7dd4be8cc9bf9913beed4bff4fe29', // Same as dev
        googleClientID: '',
        intercomAppId: 'c505rgbd',
        consumerFeUrl: 'https://consumer.simplersell.com', // We'll need cookie routing to make this work
        partnerBffUrl: 'https://partner.simplersell.com', // We'll need cookie routing to make this work
        partnerWebappUrl: 'https://partner.simplersell.com', // We'll need cookie routing to make this work
        railsUrl: 'https://demo.simplersell.com', // We'll need cookie routing to make this work
        adminUrl: 'https://admin.simplersell.com', // We'll need cookie routing to make this work
        redirectURLsRegex: /^https?:\/\/([a-z-]+\.)*(simplersell|qa.buy.opendoor)\.com(?=\/|$)/,
        buyerUrl: 'https://staging-buy.simplersell.com', // We'll need cookie routing to make this work
        cakeUrl: 'https://consumer.simplersell.com', // We'll need cookie routing to make this work
        partnershipDashboardUrl: 'https://partner.simplersell.com',
        cityUrl: 'http://city.apps-staging.opendoor.com',
        nomadUrl: 'https://nomad.apps-staging.opendoor.com',
        maestroUrl: 'https://maestro.apps-staging.opendoor.com',
        listingVisualizationUrl: 'https://listing-vis.apps-staging.opendoor.com',
    },
    staging: {
        googleMaps: 'AIzaSyCTWhHrbB0MQB1LLI00jmhtgsOJi9m2NnE',
        segment: 'hi0UliZdyDxaQblHZWB3HfgghAAuegGx',
        webApiUrl: 'https://demo.simplersell.com',
        facebookAppID: '534640070339580',
        hellosignClientID: 'd1c7dd4be8cc9bf9913beed4bff4fe29',
        googleClientID: '121750171886-1udhbfom8jjascfnsscaupb7n4p17csm.apps.googleusercontent.com',
        intercomAppId: 'c505rgbd',
        consumerFeUrl: 'https://consumer.simplersell.com',
        partnerBffUrl: 'https://partner.simplersell.com',
        partnerWebappUrl: 'https://partner.simplersell.com',
        railsUrl: 'https://demo.simplersell.com',
        adminUrl: 'https://admin.simplersell.com',
        redirectURLsRegex: /^https?:\/\/([a-z0-9-]+\.)*(simplersell|(qa|staging)\.buy\.opendoor|apps-staging\.opendoor)\.com(?=\/|$)/,
        buyerUrl: 'https://staging-buy.simplersell.com',
        cakeUrl: 'https://consumer.simplersell.com',
        partnershipDashboardUrl: 'https://partner.simplersell.com',
        cityUrl: 'http://city.apps-staging.opendoor.com',
        nomadUrl: 'https://nomad.apps-staging.opendoor.com',
        maestroUrl: 'https://maestro.apps-staging.opendoor.com',
        listingVisualizationUrl: 'https://listing-vis.apps-staging.opendoor.com',
    },
    production: {
        googleMaps: 'AIzaSyCPmXHjINLKF7UeKQgCsgZ4r8AUGGNzhNk',
        segment: 'Wx5CZGhLsaRDV4ILcNSKgxn5iZG7ErOU',
        webApiUrl: 'https://www.opendoor.com',
        facebookAppID: '293808974545537',
        hellosignClientID: '8260c9a5cd5402d13ce6f37342e3f881',
        googleClientID: '121750171886-1udhbfom8jjascfnsscaupb7n4p17csm.apps.googleusercontent.com',
        intercomAppId: 'xu4pjti7',
        consumerFeUrl: 'https://consumer.opendoor.com',
        partnerBffUrl: 'https://partner.opendoor.com',
        partnerWebappUrl: 'https://partner.opendoor.com',
        railsUrl: 'https://www.opendoor.com',
        adminUrl: 'https://admin.opendoor.com',
        redirectURLsRegex: /^https?:\/\/([a-z-]+\.)*opendoor\.com(?=\/|$)/,
        buyerUrl: 'https://buy.opendoor.com',
        cakeUrl: 'https://consumer.opendoor.com',
        partnershipDashboardUrl: 'https://partner.opendoor.com',
        cityUrl: 'https://city.apps.opendoor.com',
        nomadUrl: 'https://nomad.ops.opendoor.com',
        maestroUrl: 'https://maestro.apps.opendoor.com',
        listingVisualizationUrl: 'https://listing-vis.apps.opendoor.com',
    },
    test: {
        sentryUrl: '',
        googleMaps: 'AIzaSyB1lEtzN4O0FqRqG9ouIq6D-W93ZHSIZ34',
        segment: '',
        facebookAppID: '',
        googleClientID: '',
        hellosignClientID: '',
        webApiUrl: 'http://localhost:5006',
        intercomAppId: 'test',
        consumerFeUrl: 'http://localhost:3010',
        partnerBffUrl: 'http://localhost:2995',
        partnerWebappUrl: 'http://localhost:3003',
        railsUrl: 'http://localhost:5006',
        adminUrl: 'http://localhost:5006',
        redirectURLsRegex: /.*/,
        buyerUrl: 'http://localhost:3000',
        cakeUrl: 'http://localhost:3016',
        partnershipDashboardUrl: 'http://localhost:3003',
        cityUrl: 'http://localhost:3001',
        nomadUrl: 'http://localhost:3000',
        maestroUrl: 'http://localhost:3000',
        listingVisualizationUrl: 'http://localhost:3000',
    },
};


/***/ }),

/***/ 59895:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
exports.N = void 0;
exports.N = {
    "color": {
        "backgroundPrimary": "#fff",
        "backgroundSecondary": "#f9f8f8",
        "backgroundTertiary": "#f3f2f0",
        "backgroundAccentBrand": "#0042e6",
        "backgroundStateHoverPrimary": "#ebe9e7",
        "backgroundStateHoverSecondary": "#dfdbd8",
        "backgroundStateHoverTertiary": "#d3cec9",
        "backgroundStateHoverAccentBrand": "#00288b",
        "backgroundStateHoverAccentSuccess": "#005842",
        "backgroundStateHoverAccentError": "#983131",
        "backgroundStateInactivePrimary": "#fff",
        "backgroundStateInactiveSecondary": "#fdfdfd",
        "backgroundStateInactiveTertiary": "#f9f8f8",
        "backgroundStateInactiveAccentBrand": "#b5caff",
        "backgroundStateInactiveAccentSuccess": "#ddfff6",
        "backgroundStateInactiveAccentError": "#f1d3d3",
        "backgroundStateErrorPrimary": "#c13e3e",
        "backgroundStateErrorSecondary": "#f8ebeb",
        "backgroundStateSuccessDefault": "#007f5e",
        "contentPrimary": "#23201d",
        "contentSecondary": "#5e564e",
        "contentTertiary": "#786e64",
        "contentAccentBrand": "#0042e6",
        "contentStateHoverPrimary": "#786e64",
        "contentStateHoverAccentBrand": "#00288b",
        "contentStateInactivePrimary": "#a0968c",
        "contentStateInactiveSecondary": "#d3cec9",
        "contentStateInactiveAccentBrand": "#b5caff",
        "contentStateErrorDefault": "#c13e3e",
        "contentStateSuccessDefault": "#007f5e",
        "contentInfographicsBlueMedium": "#326dff",
        "contentInfographicsEarthMedium": "#cdcdbd",
        "contentInfographicsClayMedium": "#ba8e75",
        "borderPrimary": "#dfdbd8",
        "borderSecondary": "#f3f2f0",
        "borderTertiary": "#fff",
        "borderAccentBrand": "#0042e6",
        "borderStateHoverPrimary": "#786e64",
        "borderStateHoverSecondary": "#d3cec9",
        "borderStateHoverTertiary": "#ebe9e7",
        "borderStateHoverAccentBrand": "#00288b",
        "borderStateHoverAccentSuccess": "#005842",
        "borderStateHoverAccentError": "#732525",
        "borderStateInactivePrimary": "#f9f8f8",
        "borderStateInactiveSecondary": "#f3f2f0",
        "borderStateInactiveTertiary": "#ebe9e7",
        "borderStateInactiveAccentBrand": "#b5caff",
        "borderStateInactiveAccentSuccess": "#ddfff6",
        "borderStateInactiveAccentError": "#f8ebeb",
        "borderStateErrorDefault": "#c13e3e",
        "borderStateSucess": "#007f5e",
        "borderStateSelectedPrimary": "#23201d",
        "borderStateSelectedSecondary": "#433d37",
        "borderStateSelectedTertiary": "#2f2f24",
        "borderStateSelectedAccentBrand": "#001e68",
        "borderStateSelectedAccentSuccess": "#003729",
        "borderStateSelectedAccentError": "#511a1a",
        "borderStateFocusedPrimary": "#23201d",
        "borderStateFocusedSecondary": "#23201d",
        "borderStateFocusedTertiary": "#2f2f24",
        "borderStateFocusedAccentBrand": "#0042e6",
        "borderStateFocusedAccentSuccess": "#003729",
        "borderStateFocusedAccentError": "#511a1a",
        "backgroundInversePrimary": "#23201d",
        "backgroundInverseSecondary": "#37322d",
        "backgroundInverseTertiary": "#433d37",
        "backgroundInverseAccentBrand": "#0042e6",
        "backgroundInversePureBlack": "#000000",
        "backgroundInverseStateHoverPrimary": "#37322d",
        "backgroundInverseStateHoverSecondary": "#433d37",
        "backgroundInverseStateHoverTertiary": "#786e64",
        "backgroundInverseStateInactivePrimary": "#d3cec9",
        "backgroundInverseStateInactiveSecondary": "#c6c1bb",
        "backgroundInverseStateInactiveTertiary": "#b8b1aa",
        "contentInversePrimary": "#fff",
        "contentInverseSecondary": "#ebe9e7",
        "contentInverseTertiary": "#fff",
        "contentInverseAccentBrand": "#f6f9ff",
        "contentInverseStateInactivePrimary": "#f9f8f8",
        "contentInverseStateInactiveSecondary": "#ebe9e7",
        "contentInverseStateInactiveTertiary": "#dfdbd8",
        "contentInverseStateError": "#e6b1b1",
        "contentInverseStateSuccess": "#c1ffef",
        "borderInversePrimary": "#23201d",
        "borderInverseSecondary": "#37322d",
        "borderInverseTertiary": "#37322d",
        "borderInverseAccentBrand": "#e0e9ff",
        "borderInverseStateHoverPrimary": "#37322d",
        "borderInverseStateHoverSecondary": "#433d37",
        "borderInverseStateHoverTertiary": "#433d37",
        "borderInverseStateHoverAccentBrand": "#00288b",
        "borderInverseStateHoverAccentSuccess": "#005842",
        "borderInverseStateHoverAccentError": "#732525",
        "borderInverseStateInactivePrimary": "#d3cec9",
        "borderInverseStateInactiveSecondary": "#c6c1bb",
        "borderInverseStateInactiveTertiary": "#b8b1aa",
        "borderInverseStateError": "#e6b1b1",
        "borderInverseStateSuccess": "#c1ffef",
        "borderInverseStateSelectedPrimary": "#786e64",
        "borderInverseStateSelectedSecondary": "#a0968c",
        "borderInverseStateSelectedTertiary": "#a0968c",
        "borderInverseStateSelectedAccentBrand": "#0034b6",
        "borderInverseStateFocusedDefault": "#f6f9ff",
        "shadowDefault": "#000000",
        "shadowInverse": "#ffffff",
        "scrimDark": "rgba(0, 0, 0, 0.72)",
        "scrimLight": "rgba(255, 255, 255, 0.72)"
    },
    "gradient": {
        "scrimGradient180deg": {
            "direction": "180deg",
            "colorStops": [
                {
                    "color": "rgba(35, 32, 29, 0.5)",
                    "stop": 1
                },
                {
                    "color": "rgba(35, 32, 29, 0.0)",
                    "stop": 0.3
                }
            ]
        },
        "scrimGradient180degInverse": {
            "direction": "0deg",
            "colorStops": [
                {
                    "color": "rgba(255,255,255,1)",
                    "stop": 0
                },
                {
                    "color": "rgba(255,255,255,0.10)",
                    "stop": 1
                }
            ]
        },
        "scrimGradient270degInverse": {
            "direction": "270deg",
            "colorStops": [
                {
                    "color": "rgba(255,255,255,1)",
                    "stop": 0
                },
                {
                    "color": "rgba(255,255,255,0.10)",
                    "stop": 1
                }
            ]
        },
        "scrimGradient90degInverse": {
            "direction": "90deg",
            "colorStops": [
                {
                    "color": "rgba(255,255,255,1)",
                    "stop": 0
                },
                {
                    "color": "rgba(255,255,255,0.10)",
                    "stop": 1
                }
            ]
        },
        "scrimGradient290deg": {
            "direction": "290deg",
            "colorStops": [
                {
                    "color": "rgba(35, 32, 29, 1)",
                    "stop": 1
                },
                {
                    "color": "rgba(35, 32, 29, 0.0)",
                    "stop": 0.45
                }
            ]
        }
    },
    "shadow": {
        "shadowColor": {
            "default": "#000000",
            "pressed": "#000000"
        },
        "shadowOpacity": {
            "default": 0.04,
            "pressed": 0.08
        },
        "elevation": {
            "default": 6,
            "pressed": 2
        },
        "shadowOffsetWidth": {
            "default": 0,
            "pressed": 0
        },
        "shadowOffsetHeight": {
            "default": 8,
            "pressed": 3
        },
        "shadowRadius": {
            "default": 20,
            "pressed": 5
        }
    },
    "opacity": {
        "stateDisabled": 0.7,
        "stateSelected": 1,
        "stateUnselected": 0.65,
        "stateHover": 0.15,
        "statePressed": 0.04,
        "stateInvisible": 0,
        "scrim": 0.72,
        "stateInverseDisabled": 0.3,
        "stateInverseHover": 0.16,
        "stateInversePressed": 0.08
    },
    "radius": {
        "borderAllowance": 1,
        "2x": 4,
        "3x": 6,
        "4x": 8,
        "6x": 12,
        "7x": 14,
        "8x": 16,
        "9x": 18,
        "10x": 20,
        "12x": 24,
        "13x": 26,
        "14x": 28,
        "16x": 32,
        "32x": 64,
        "60x": 120,
        "full": 1998,
        "includeBorderAllowance2x": 5,
        "includeBorderAllowance4x": 9
    },
    "rad": {
        "roundedNone": 0,
        "roundedXs": 2,
        "roundedSm": 4,
        "roundedMd": 6,
        "roundedLg": 8,
        "roundedXl": 12,
        "rounded2xl": 16,
        "rounded3xl": 24,
        "rounded4xl": 32,
        "roundedFull": 9999
    },
    "borderWidth": {
        "default": 1.5,
        "object": 4,
        "thinnest": 1
    },
    "typography": {
        "size": {
            "displayLarge": 117,
            "displayMedium": 92,
            "displaySmall": 65,
            "displayXsmall": 58,
            "headerLarge": 45,
            "headerMedium": 40,
            "headerSmall": 36,
            "subheaderLarge": 32,
            "subheaderMedium": 28,
            "subheaderSmall": 25,
            "subheaderXsmall": 22,
            "bodyXlarge": 20,
            "bodyLarge": 18,
            "bodyMedium": 16,
            "bodySmall": 14,
            "bodyXsmall": 11,
            "bodyXxsmall": 8,
            "labelXlarge": 20,
            "labelLarge": 18,
            "labelMedium": 16,
            "labelSmall": 14,
            "labelXsmall": 11
        },
        "lineHeight": {
            "displayLarge": 117,
            "displayMedium": 92,
            "displaySmall": 65,
            "displayXsmall": 58,
            "headerLarge": 45,
            "headerMedium": 40,
            "headerSmall": 36,
            "subheaderLarge": 35.2,
            "subheaderMedium": 30.800000000000004,
            "subheaderSmall": 28.000000000000004,
            "subheaderXsmall": 25.08,
            "bodyXlarge": 24,
            "bodyLarge": 26.099999999999998,
            "bodyMedium": 24,
            "bodySmall": 19.599999999999998,
            "bodyXsmall": 15.399999999999999,
            "bodyXxsmall": 11.2,
            "labelXlarge": 24,
            "labelLarge": 21.599999999999998,
            "labelMedium": 20,
            "labelSmall": 17.5,
            "labelXsmall": 13.75
        },
        "letterSpacing": {
            "displayLarge": -4.212,
            "displayMedium": -3.128,
            "displaySmall": -2.21,
            "displayXsmall": -1.9720000000000002,
            "headerLarge": -1.3499999999999999,
            "headerMedium": -1.2,
            "headerSmall": -1.08,
            "subheaderLarge": -0.896,
            "subheaderMedium": -0.784,
            "subheaderSmall": -0.7000000000000001,
            "subheaderXsmall": -0.528,
            "bodyXlarge": -0.48,
            "bodyLarge": -0.432,
            "bodyMedium": -0.224,
            "bodySmall": -0.196,
            "bodyXsmall": -0.154,
            "bodyXxsmall": -0.112,
            "labelXlarge": -0.48,
            "labelLarge": -0.432,
            "labelMedium": -0.224,
            "labelSmall": -0.196,
            "labelXsmall": -0.154
        },
        "weight": {
            "displayLarge": "500",
            "displayMedium": "500",
            "displaySmall": "500",
            "displayXsmall": "500",
            "headerLarge": "500",
            "headerMedium": "500",
            "headerSmall": "500",
            "subheaderLarge": "500",
            "subheaderMedium": "500",
            "subheaderSmall": "500",
            "subheaderXsmall": "500",
            "bodyXlarge": "400",
            "bodyLarge": "400",
            "bodyMedium": "400",
            "bodySmall": "400",
            "bodyXsmall": "400",
            "bodyXxsmall": "400",
            "labelXlarge": "500",
            "labelLarge": "500",
            "labelMedium": "500",
            "labelSmall": "500",
            "labelXsmall": "500"
        },
        "family": "Graphik"
    },
    "space": {
        "0x": 0,
        "0dot5x": 1,
        "1x": 2,
        "1dot5x": 3,
        "2x": 4,
        "2dot5x": 5,
        "3x": 6,
        "4x": 8,
        "475tenthsX": 9.5,
        "5x": 10,
        "575tenthsX": 11.5,
        "6x": 12,
        "65tenthsX": 13,
        "675tenthsX": 13.5,
        "7x": 14,
        "8x": 16,
        "9x": 18,
        "975tenthsX": 19.5,
        "10x": 20,
        "10dot5x": 21,
        "11x": 22,
        "12x": 24,
        "12dot5x": 25,
        "13x": 26,
        "14x": 28,
        "15x": 30,
        "16x": 32,
        "16dot5x": 33,
        "22x": 44,
        "20x": 40,
        "21x": 42,
        "23x": 46,
        "24x": 48,
        "25x": 50,
        "26x": 52,
        "27x": 54,
        "28x": 56,
        "30x": 60,
        "32x": 64,
        "36x": 72,
        "40x": 80,
        "44x": 88,
        "50x": 100,
        "56x": 112,
        "62x": 124,
        "62dot5x": 125,
        "68x": 136,
        "80x": 160,
        "125x": 250,
        "135x": 270
    },
    "sp": {
        "0": 0,
        "1": 4,
        "2": 8,
        "3": 12,
        "4": 16,
        "5": 20,
        "6": 24,
        "7": 28,
        "8": 32,
        "9": 36,
        "10": 40,
        "11": 44,
        "12": 48,
        "13": 52,
        "14": 56,
        "15": 60,
        "16": 64,
        "17": 68,
        "18": 72,
        "19": 76,
        "20": 80,
        "21": 84,
        "22": 88,
        "23": 92,
        "24": 96,
        "25": 100,
        "26": 104,
        "27": 108,
        "28": 112,
        "29": 116,
        "30": 120,
        "31": 124,
        "32": 128,
        "33": 132,
        "34": 136,
        "35": 140,
        "36": 144,
        "37": 148,
        "38": 152,
        "39": 156,
        "40": 160,
        "41": 164,
        "42": 168,
        "43": 172,
        "44": 176,
        "45": 180,
        "46": 184,
        "47": 188,
        "48": 192,
        "49": 196,
        "50": 200,
        "51": 204,
        "52": 208,
        "53": 212,
        "54": 216,
        "55": 220,
        "56": 224,
        "57": 228,
        "58": 232,
        "59": 236,
        "60": 240,
        "61": 244,
        "62": 248,
        "63": 252,
        "64": 256,
        "65": 260,
        "66": 264,
        "67": 268,
        "68": 272,
        "69": 276,
        "70": 280,
        "71": 284,
        "72": 288,
        "73": 292,
        "74": 296,
        "75": 300,
        "76": 304,
        "77": 308,
        "78": 312,
        "79": 316,
        "80": 320,
        "81": 324,
        "82": 328,
        "83": 332,
        "84": 336,
        "85": 340,
        "86": 344,
        "87": 348,
        "88": 352,
        "89": 356,
        "90": 360,
        "91": 364,
        "92": 368,
        "93": 372,
        "94": 376,
        "95": 380,
        "96": 384,
        "97": 388,
        "98": 392,
        "99": 396,
        "100": 400,
        "101": 404,
        "102": 408,
        "103": 412,
        "104": 416,
        "105": 420,
        "106": 424,
        "107": 428,
        "108": 432,
        "109": 436,
        "110": 440,
        "111": 444,
        "112": 448,
        "113": 452,
        "114": 456,
        "115": 460,
        "116": 464,
        "117": 468,
        "118": 472,
        "119": 476,
        "120": 480,
        "121": 484,
        "122": 488,
        "123": 492,
        "124": 496,
        "125": 500,
        "126": 504,
        "127": 508,
        "128": 512,
        "129": 516,
        "130": 520,
        "131": 524,
        "132": 528,
        "133": 532,
        "134": 536,
        "135": 540,
        "136": 544,
        "137": 548,
        "138": 552,
        "139": 556,
        "140": 560,
        "141": 564,
        "142": 568,
        "143": 572,
        "144": 576,
        "145": 580,
        "146": 584,
        "147": 588,
        "148": 592,
        "149": 596,
        "150": 600,
        "151": 604,
        "152": 608,
        "153": 612,
        "154": 616,
        "155": 620,
        "156": 624,
        "157": 628,
        "158": 632,
        "159": 636,
        "160": 640,
        "161": 644,
        "162": 648,
        "163": 652,
        "164": 656,
        "165": 660,
        "166": 664,
        "167": 668,
        "168": 672,
        "169": 676,
        "170": 680,
        "171": 684,
        "172": 688,
        "173": 692,
        "174": 696,
        "175": 700,
        "176": 704,
        "177": 708,
        "178": 712,
        "179": 716,
        "180": 720,
        "181": 724,
        "182": 728,
        "183": 732,
        "184": 736,
        "185": 740,
        "186": 744,
        "187": 748,
        "188": 752,
        "189": 756,
        "190": 760,
        "191": 764,
        "192": 768,
        "193": 772,
        "194": 776,
        "195": 780,
        "196": 784,
        "197": 788,
        "198": 792,
        "199": 796,
        "200": 800,
        "201": 804,
        "202": 808,
        "203": 812,
        "204": 816,
        "205": 820,
        "206": 824,
        "207": 828,
        "208": 832,
        "209": 836,
        "210": 840,
        "211": 844,
        "212": 848,
        "213": 852,
        "214": 856,
        "215": 860,
        "216": 864,
        "217": 868,
        "218": 872,
        "219": 876,
        "220": 880,
        "221": 884,
        "222": 888,
        "223": 892,
        "224": 896,
        "225": 900,
        "226": 904,
        "227": 908,
        "228": 912,
        "229": 916,
        "230": 920,
        "231": 924,
        "232": 928,
        "233": 932,
        "234": 936,
        "235": 940,
        "236": 944,
        "237": 948,
        "238": 952,
        "239": 956,
        "240": 960,
        "241": 964,
        "242": 968,
        "243": 972,
        "244": 976,
        "245": 980,
        "246": 984,
        "247": 988,
        "248": 992,
        "249": 996,
        "250": 1000,
        "251": 1004,
        "252": 1008,
        "253": 1012,
        "254": 1016,
        "255": 1020,
        "256": 1024,
        "257": 1028,
        "258": 1032,
        "259": 1036,
        "260": 1040,
        "261": 1044,
        "262": 1048,
        "263": 1052,
        "264": 1056,
        "265": 1060,
        "266": 1064,
        "267": 1068,
        "268": 1072,
        "269": 1076,
        "270": 1080,
        "271": 1084,
        "272": 1088,
        "273": 1092,
        "274": 1096,
        "275": 1100,
        "276": 1104,
        "277": 1108,
        "278": 1112,
        "279": 1116,
        "280": 1120,
        "281": 1124,
        "282": 1128,
        "283": 1132,
        "284": 1136,
        "285": 1140,
        "286": 1144,
        "287": 1148,
        "288": 1152,
        "289": 1156,
        "290": 1160,
        "291": 1164,
        "292": 1168,
        "293": 1172,
        "294": 1176,
        "295": 1180,
        "296": 1184,
        "297": 1188,
        "298": 1192,
        "299": 1196,
        "300": 1200,
        "301": 1204,
        "302": 1208,
        "303": 1212,
        "304": 1216,
        "305": 1220,
        "306": 1224,
        "307": 1228,
        "308": 1232,
        "309": 1236,
        "310": 1240,
        "311": 1244,
        "312": 1248,
        "313": 1252,
        "314": 1256,
        "315": 1260,
        "316": 1264,
        "317": 1268,
        "318": 1272,
        "319": 1276,
        "320": 1280,
        "321": 1284,
        "322": 1288,
        "323": 1292,
        "324": 1296,
        "325": 1300,
        "326": 1304,
        "327": 1308,
        "328": 1312,
        "329": 1316,
        "330": 1320,
        "331": 1324,
        "332": 1328,
        "333": 1332,
        "334": 1336,
        "335": 1340,
        "336": 1344,
        "337": 1348,
        "338": 1352,
        "339": 1356,
        "340": 1360,
        "341": 1364,
        "342": 1368,
        "343": 1372,
        "344": 1376,
        "345": 1380,
        "346": 1384,
        "347": 1388,
        "348": 1392,
        "349": 1396,
        "350": 1400,
        "351": 1404,
        "352": 1408,
        "353": 1412,
        "354": 1416,
        "355": 1420,
        "356": 1424,
        "357": 1428,
        "358": 1432,
        "359": 1436,
        "360": 1440,
        "361": 1444,
        "362": 1448,
        "363": 1452,
        "364": 1456,
        "365": 1460,
        "366": 1464,
        "367": 1468,
        "368": 1472,
        "369": 1476,
        "370": 1480,
        "371": 1484,
        "372": 1488,
        "373": 1492,
        "374": 1496,
        "375": 1500,
        "376": 1504,
        "377": 1508,
        "378": 1512,
        "379": 1516,
        "380": 1520,
        "381": 1524,
        "382": 1528,
        "383": 1532,
        "384": 1536,
        "385": 1540,
        "386": 1544,
        "387": 1548,
        "388": 1552,
        "389": 1556,
        "390": 1560,
        "391": 1564,
        "392": 1568,
        "393": 1572,
        "394": 1576,
        "395": 1580,
        "396": 1584,
        "397": 1588,
        "398": 1592,
        "399": 1596,
        "400": 1600,
        "401": 1604,
        "402": 1608,
        "403": 1612,
        "404": 1616,
        "405": 1620,
        "406": 1624,
        "407": 1628,
        "408": 1632,
        "409": 1636,
        "410": 1640,
        "411": 1644,
        "412": 1648,
        "413": 1652,
        "414": 1656,
        "415": 1660,
        "416": 1664,
        "417": 1668,
        "418": 1672,
        "419": 1676,
        "420": 1680,
        "421": 1684,
        "422": 1688,
        "423": 1692,
        "424": 1696,
        "425": 1700,
        "426": 1704,
        "427": 1708,
        "428": 1712,
        "429": 1716,
        "430": 1720,
        "431": 1724,
        "432": 1728,
        "433": 1732,
        "434": 1736,
        "435": 1740,
        "436": 1744,
        "437": 1748,
        "438": 1752,
        "439": 1756,
        "440": 1760,
        "441": 1764,
        "442": 1768,
        "443": 1772,
        "444": 1776,
        "445": 1780,
        "446": 1784,
        "447": 1788,
        "448": 1792,
        "449": 1796,
        "450": 1800,
        "451": 1804,
        "452": 1808,
        "453": 1812,
        "454": 1816,
        "455": 1820,
        "456": 1824,
        "457": 1828,
        "458": 1832,
        "459": 1836,
        "460": 1840,
        "461": 1844,
        "462": 1848,
        "463": 1852,
        "464": 1856,
        "465": 1860,
        "466": 1864,
        "467": 1868,
        "468": 1872,
        "469": 1876,
        "470": 1880,
        "471": 1884,
        "472": 1888,
        "473": 1892,
        "474": 1896,
        "475": 1900,
        "476": 1904,
        "477": 1908,
        "478": 1912,
        "479": 1916,
        "480": 1920,
        "481": 1924,
        "482": 1928,
        "483": 1932,
        "484": 1936,
        "485": 1940,
        "486": 1944,
        "487": 1948,
        "488": 1952,
        "489": 1956,
        "490": 1960,
        "491": 1964,
        "492": 1968,
        "493": 1972,
        "494": 1976,
        "495": 1980,
        "496": 1984,
        "497": 1988,
        "498": 1992,
        "499": 1996,
        "500": 2000,
        "px": 1,
        "half": 2,
        "1half": 6,
        "2half": 10,
        "3half": 14
    },
    "state": {
        "pressedScale": 0.95,
        "pressedScaleLargerObjects": 0.98
    },
    "size": {
        "1x": 1,
        "2x": 2,
        "3x": 3,
        "4x": 4,
        "5x": 5,
        "6x": 6,
        "7x": 7,
        "8x": 8,
        "10x": 10,
        "12x": 12,
        "14x": 14,
        "15x": 15,
        "16x": 16,
        "18x": 18,
        "20x": 20,
        "24x": 24,
        "26x": 26,
        "28x": 28,
        "30x": 30,
        "32x": 32,
        "33x": 33,
        "34x": 34,
        "36x": 36,
        "38x": 38,
        "40x": 40,
        "43x": 43,
        "44x": 44,
        "45x": 45,
        "48x": 48,
        "49x": 49,
        "51x": 51,
        "55x": 55,
        "56x": 56,
        "58x": 58,
        "60x": 60,
        "62x": 62,
        "63x": 63,
        "64x": 64,
        "65x": 65,
        "67x": 67,
        "68x": 68,
        "69x": 69,
        "72x": 72,
        "75x": 75,
        "76x": 76,
        "77x": 77,
        "78x": 78,
        "80x": 80,
        "82x": 82,
        "88x": 88,
        "93x": 93,
        "101x": 101,
        "110x": 110,
        "104x": 104,
        "105x": 105,
        "112x": 112,
        "129x": 129,
        "130x": 130,
        "157x": 157,
        "165x": 165,
        "160x": 160,
        "167x": 167,
        "168x": 168,
        "180x": 180,
        "200x": 200,
        "239x": 239,
        "240x": 240,
        "250x": 250,
        "272x": 272,
        "284x": 284,
        "310x": 310,
        "314x": 314,
        "320x": 320,
        "326x": 326,
        "327x": 327,
        "328x": 328,
        "332x": 332,
        "342x": 342,
        "345x": 345,
        "374x": 374,
        "375x": 375,
        "382x": 382,
        "450x": 450,
        "430x": 430,
        "451x": 451,
        "452x": 452,
        "500x": 500,
        "512x": 512,
        "516x": 516,
        "548x": 548,
        "616x": 616,
        "636x": 636,
        "652x": 652,
        "719x": 719,
        "736x": 736,
        "744x": 744,
        "745x": 745,
        "767x": 767,
        "847x": 847,
        "848x": 848,
        "768x": 768,
        "900x": 900,
        "1023x": 1023,
        "1024x": 1024,
        "1200x": 1200,
        "1201x": 1201,
        "1399x": 1399,
        "1440x": 1440,
        "1400x": 1400
    },
    "sz": {
        "0": 0,
        "1": 4,
        "2": 8,
        "3": 12,
        "4": 16,
        "5": 20,
        "6": 24,
        "7": 28,
        "8": 32,
        "9": 36,
        "10": 40,
        "11": 44,
        "12": 48,
        "13": 52,
        "14": 56,
        "15": 60,
        "16": 64,
        "17": 68,
        "18": 72,
        "19": 76,
        "20": 80,
        "21": 84,
        "22": 88,
        "23": 92,
        "24": 96,
        "25": 100,
        "26": 104,
        "27": 108,
        "28": 112,
        "29": 116,
        "30": 120,
        "31": 124,
        "32": 128,
        "33": 132,
        "34": 136,
        "35": 140,
        "36": 144,
        "37": 148,
        "38": 152,
        "39": 156,
        "40": 160,
        "41": 164,
        "42": 168,
        "43": 172,
        "44": 176,
        "45": 180,
        "46": 184,
        "47": 188,
        "48": 192,
        "49": 196,
        "50": 200,
        "51": 204,
        "52": 208,
        "53": 212,
        "54": 216,
        "55": 220,
        "56": 224,
        "57": 228,
        "58": 232,
        "59": 236,
        "60": 240,
        "61": 244,
        "62": 248,
        "63": 252,
        "64": 256,
        "65": 260,
        "66": 264,
        "67": 268,
        "68": 272,
        "69": 276,
        "70": 280,
        "71": 284,
        "72": 288,
        "73": 292,
        "74": 296,
        "75": 300,
        "76": 304,
        "77": 308,
        "78": 312,
        "79": 316,
        "80": 320,
        "81": 324,
        "82": 328,
        "83": 332,
        "84": 336,
        "85": 340,
        "86": 344,
        "87": 348,
        "88": 352,
        "89": 356,
        "90": 360,
        "91": 364,
        "92": 368,
        "93": 372,
        "94": 376,
        "95": 380,
        "96": 384,
        "97": 388,
        "98": 392,
        "99": 396,
        "100": 400,
        "101": 404,
        "102": 408,
        "103": 412,
        "104": 416,
        "105": 420,
        "106": 424,
        "107": 428,
        "108": 432,
        "109": 436,
        "110": 440,
        "111": 444,
        "112": 448,
        "113": 452,
        "114": 456,
        "115": 460,
        "116": 464,
        "117": 468,
        "118": 472,
        "119": 476,
        "120": 480,
        "121": 484,
        "122": 488,
        "123": 492,
        "124": 496,
        "125": 500,
        "126": 504,
        "127": 508,
        "128": 512,
        "129": 516,
        "130": 520,
        "131": 524,
        "132": 528,
        "133": 532,
        "134": 536,
        "135": 540,
        "136": 544,
        "137": 548,
        "138": 552,
        "139": 556,
        "140": 560,
        "141": 564,
        "142": 568,
        "143": 572,
        "144": 576,
        "145": 580,
        "146": 584,
        "147": 588,
        "148": 592,
        "149": 596,
        "150": 600,
        "151": 604,
        "152": 608,
        "153": 612,
        "154": 616,
        "155": 620,
        "156": 624,
        "157": 628,
        "158": 632,
        "159": 636,
        "160": 640,
        "161": 644,
        "162": 648,
        "163": 652,
        "164": 656,
        "165": 660,
        "166": 664,
        "167": 668,
        "168": 672,
        "169": 676,
        "170": 680,
        "171": 684,
        "172": 688,
        "173": 692,
        "174": 696,
        "175": 700,
        "176": 704,
        "177": 708,
        "178": 712,
        "179": 716,
        "180": 720,
        "181": 724,
        "182": 728,
        "183": 732,
        "184": 736,
        "185": 740,
        "186": 744,
        "187": 748,
        "188": 752,
        "189": 756,
        "190": 760,
        "191": 764,
        "192": 768,
        "193": 772,
        "194": 776,
        "195": 780,
        "196": 784,
        "197": 788,
        "198": 792,
        "199": 796,
        "200": 800,
        "201": 804,
        "202": 808,
        "203": 812,
        "204": 816,
        "205": 820,
        "206": 824,
        "207": 828,
        "208": 832,
        "209": 836,
        "210": 840,
        "211": 844,
        "212": 848,
        "213": 852,
        "214": 856,
        "215": 860,
        "216": 864,
        "217": 868,
        "218": 872,
        "219": 876,
        "220": 880,
        "221": 884,
        "222": 888,
        "223": 892,
        "224": 896,
        "225": 900,
        "226": 904,
        "227": 908,
        "228": 912,
        "229": 916,
        "230": 920,
        "231": 924,
        "232": 928,
        "233": 932,
        "234": 936,
        "235": 940,
        "236": 944,
        "237": 948,
        "238": 952,
        "239": 956,
        "240": 960,
        "241": 964,
        "242": 968,
        "243": 972,
        "244": 976,
        "245": 980,
        "246": 984,
        "247": 988,
        "248": 992,
        "249": 996,
        "250": 1000,
        "251": 1004,
        "252": 1008,
        "253": 1012,
        "254": 1016,
        "255": 1020,
        "256": 1024,
        "257": 1028,
        "258": 1032,
        "259": 1036,
        "260": 1040,
        "261": 1044,
        "262": 1048,
        "263": 1052,
        "264": 1056,
        "265": 1060,
        "266": 1064,
        "267": 1068,
        "268": 1072,
        "269": 1076,
        "270": 1080,
        "271": 1084,
        "272": 1088,
        "273": 1092,
        "274": 1096,
        "275": 1100,
        "276": 1104,
        "277": 1108,
        "278": 1112,
        "279": 1116,
        "280": 1120,
        "281": 1124,
        "282": 1128,
        "283": 1132,
        "284": 1136,
        "285": 1140,
        "286": 1144,
        "287": 1148,
        "288": 1152,
        "289": 1156,
        "290": 1160,
        "291": 1164,
        "292": 1168,
        "293": 1172,
        "294": 1176,
        "295": 1180,
        "296": 1184,
        "297": 1188,
        "298": 1192,
        "299": 1196,
        "300": 1200,
        "301": 1204,
        "302": 1208,
        "303": 1212,
        "304": 1216,
        "305": 1220,
        "306": 1224,
        "307": 1228,
        "308": 1232,
        "309": 1236,
        "310": 1240,
        "311": 1244,
        "312": 1248,
        "313": 1252,
        "314": 1256,
        "315": 1260,
        "316": 1264,
        "317": 1268,
        "318": 1272,
        "319": 1276,
        "320": 1280,
        "321": 1284,
        "322": 1288,
        "323": 1292,
        "324": 1296,
        "325": 1300,
        "326": 1304,
        "327": 1308,
        "328": 1312,
        "329": 1316,
        "330": 1320,
        "331": 1324,
        "332": 1328,
        "333": 1332,
        "334": 1336,
        "335": 1340,
        "336": 1344,
        "337": 1348,
        "338": 1352,
        "339": 1356,
        "340": 1360,
        "341": 1364,
        "342": 1368,
        "343": 1372,
        "344": 1376,
        "345": 1380,
        "346": 1384,
        "347": 1388,
        "348": 1392,
        "349": 1396,
        "350": 1400,
        "351": 1404,
        "352": 1408,
        "353": 1412,
        "354": 1416,
        "355": 1420,
        "356": 1424,
        "357": 1428,
        "358": 1432,
        "359": 1436,
        "360": 1440,
        "361": 1444,
        "362": 1448,
        "363": 1452,
        "364": 1456,
        "365": 1460,
        "366": 1464,
        "367": 1468,
        "368": 1472,
        "369": 1476,
        "370": 1480,
        "371": 1484,
        "372": 1488,
        "373": 1492,
        "374": 1496,
        "375": 1500,
        "376": 1504,
        "377": 1508,
        "378": 1512,
        "379": 1516,
        "380": 1520,
        "381": 1524,
        "382": 1528,
        "383": 1532,
        "384": 1536,
        "385": 1540,
        "386": 1544,
        "387": 1548,
        "388": 1552,
        "389": 1556,
        "390": 1560,
        "391": 1564,
        "392": 1568,
        "393": 1572,
        "394": 1576,
        "395": 1580,
        "396": 1584,
        "397": 1588,
        "398": 1592,
        "399": 1596,
        "400": 1600,
        "401": 1604,
        "402": 1608,
        "403": 1612,
        "404": 1616,
        "405": 1620,
        "406": 1624,
        "407": 1628,
        "408": 1632,
        "409": 1636,
        "410": 1640,
        "411": 1644,
        "412": 1648,
        "413": 1652,
        "414": 1656,
        "415": 1660,
        "416": 1664,
        "417": 1668,
        "418": 1672,
        "419": 1676,
        "420": 1680,
        "421": 1684,
        "422": 1688,
        "423": 1692,
        "424": 1696,
        "425": 1700,
        "426": 1704,
        "427": 1708,
        "428": 1712,
        "429": 1716,
        "430": 1720,
        "431": 1724,
        "432": 1728,
        "433": 1732,
        "434": 1736,
        "435": 1740,
        "436": 1744,
        "437": 1748,
        "438": 1752,
        "439": 1756,
        "440": 1760,
        "441": 1764,
        "442": 1768,
        "443": 1772,
        "444": 1776,
        "445": 1780,
        "446": 1784,
        "447": 1788,
        "448": 1792,
        "449": 1796,
        "450": 1800,
        "451": 1804,
        "452": 1808,
        "453": 1812,
        "454": 1816,
        "455": 1820,
        "456": 1824,
        "457": 1828,
        "458": 1832,
        "459": 1836,
        "460": 1840,
        "461": 1844,
        "462": 1848,
        "463": 1852,
        "464": 1856,
        "465": 1860,
        "466": 1864,
        "467": 1868,
        "468": 1872,
        "469": 1876,
        "470": 1880,
        "471": 1884,
        "472": 1888,
        "473": 1892,
        "474": 1896,
        "475": 1900,
        "476": 1904,
        "477": 1908,
        "478": 1912,
        "479": 1916,
        "480": 1920,
        "481": 1924,
        "482": 1928,
        "483": 1932,
        "484": 1936,
        "485": 1940,
        "486": 1944,
        "487": 1948,
        "488": 1952,
        "489": 1956,
        "490": 1960,
        "491": 1964,
        "492": 1968,
        "493": 1972,
        "494": 1976,
        "495": 1980,
        "496": 1984,
        "497": 1988,
        "498": 1992,
        "499": 1996,
        "500": 2000,
        "px": 1,
        "half": 2,
        "1half": 6,
        "2half": 10,
        "3half": 14
    },
    "text": {
        "row1x": 1,
        "row2x": 2,
        "row3x": 3
    },
    "textDecoration": {
        "link": "underline"
    },
    "fontWeight": {
        "regular": "400",
        "medium": "500"
    },
    "backgroundBlur": {
        "8x": 8
    },
    "percentage": {
        "1000x": "10%",
        "6500x": "65%",
        "8000x": "80%",
        "9000x": "90%",
        "9500x": "95%",
        "9800x": "98%",
        "10000x": "100%",
        "15000x": "150%",
        "5000x": "50%"
    },
    "animation": {
        "timing": {
            "accelerateDecelerateFastest": {
                "web": "cubic-bezier(0.83, 0, 0.17, 1) 100ms",
                "mobile": {
                    "type": "timing",
                    "duration": 100,
                    "easing": [
                        0.83,
                        0,
                        0.17,
                        1
                    ]
                }
            },
            "accelerateDecelerateFast": {
                "web": "cubic-bezier(0.83, 0, 0.17, 1) 500ms",
                "mobile": {
                    "type": "timing",
                    "duration": 500,
                    "easing": [
                        0.83,
                        0,
                        0.17,
                        1
                    ]
                }
            },
            "accelerateDecelerateSlow": {
                "web": "cubic-bezier(0.83, 0, 0.17, 1) 1000ms",
                "mobile": {
                    "type": "timing",
                    "duration": 1000,
                    "easing": [
                        0.83,
                        0,
                        0.17,
                        1
                    ]
                }
            },
            "decelerateFastest": {
                "web": "cubic-bezier(0.22, 1, 0.36, 1) 100ms",
                "mobile": {
                    "type": "timing",
                    "duration": 100,
                    "easing": [
                        0.22,
                        1,
                        0.36,
                        1
                    ]
                }
            },
            "decelerateFast": {
                "web": "cubic-bezier(0.22, 1, 0.36, 1) 500ms",
                "mobile": {
                    "type": "timing",
                    "duration": 500,
                    "easing": [
                        0.22,
                        1,
                        0.36,
                        1
                    ]
                }
            },
            "accelerateFast": {
                "web": "cubic-bezier(0.64, 0, 0.78, 0) 400ms",
                "mobile": {
                    "type": "timing",
                    "duration": 400,
                    "easing": [
                        0.64,
                        0,
                        0.78,
                        0
                    ]
                }
            },
            "accelerateSlow": {
                "web": "cubic-bezier(0.64, 0, 0.78, 0) 800ms",
                "mobile": {
                    "type": "timing",
                    "duration": 800,
                    "easing": [
                        0.64,
                        0,
                        0.78,
                        0
                    ]
                }
            },
            "responsiveAccelerate": {
                "web": "cubic-bezier(0.11, 0, 0.5, 0) 200ms",
                "mobile": {
                    "type": "timing",
                    "duration": 200,
                    "easing": [
                        0.11,
                        0,
                        0.5,
                        0
                    ]
                }
            },
            "linear": {
                "web": "cubic-bezier(0, 0, 1, 1) 100ms",
                "mobile": {
                    "type": "timing",
                    "duration": 100,
                    "easing": [
                        0,
                        0,
                        1,
                        1
                    ]
                }
            },
            "contentfulArchAnimation": {
                "web": "cubic-bezier(0.55, 0.0, 0.15, 1.0) 1000ms",
                "mobile": {
                    "type": "timing",
                    "duration": 1000,
                    "easing": [
                        0.55,
                        0,
                        0.15,
                        1
                    ]
                }
            }
        }
    }
};


/***/ }),

/***/ 11742:
/***/ (function(module) {


module.exports = function () {
  var selection = document.getSelection();
  if (!selection.rangeCount) {
    return function () {};
  }
  var active = document.activeElement;

  var ranges = [];
  for (var i = 0; i < selection.rangeCount; i++) {
    ranges.push(selection.getRangeAt(i));
  }

  switch (active.tagName.toUpperCase()) { // .toUpperCase handles XHTML
    case 'INPUT':
    case 'TEXTAREA':
      active.blur();
      break;

    default:
      active = null;
      break;
  }

  selection.removeAllRanges();
  return function () {
    selection.type === 'Caret' &&
    selection.removeAllRanges();

    if (!selection.rangeCount) {
      ranges.forEach(function(range) {
        selection.addRange(range);
      });
    }

    active &&
    active.focus();
  };
};


/***/ }),

/***/ 87462:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}


/***/ }),

/***/ 54022:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E4": function() { return /* binding */ ResultList; },
  "ZP": function() { return /* binding */ AutocompleteInput; }
});

// UNUSED EXPORTS: RoundedStyles

// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(82110);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(82526);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(41817);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__(32165);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.to-primitive.js
var es_symbol_to_primitive = __webpack_require__(96649);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__(57327);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__(89554);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__(82772);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(66992);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__(21249);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.date.to-primitive.js
var es_date_to_primitive = __webpack_require__(96078);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(68309);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__(9653);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__(19601);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.define-properties.js
var es_object_define_properties = __webpack_require__(33321);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.define-property.js
var es_object_define_property = __webpack_require__(69070);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__(38880);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__(49337);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-prototype-of.js
var es_object_get_prototype_of = __webpack_require__(30489);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__(47941);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.set-prototype-of.js
var es_object_set_prototype_of = __webpack_require__(68304);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(41539);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__(12419);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.to-string-tag.js
var es_reflect_to_string_tag = __webpack_require__(81299);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(78783);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__(54747);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(33948);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/chakra-ui-system.esm.js + 6 modules
var chakra_ui_system_esm = __webpack_require__(24614);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Flex/Flex.mjs
var Flex = __webpack_require__(93298);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Box/Box.mjs
var Box = __webpack_require__(8013);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/hooks/dist/chakra-ui-hooks.esm.js
var chakra_ui_hooks_esm = __webpack_require__(97375);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/hooks/useObservabilitySafe.mjs + 2 modules
var useObservabilitySafe = __webpack_require__(79652);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/system/bricks.types.mjs
var bricks_types = __webpack_require__(26153);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/system/utils/use-style-config.mjs + 3 modules
var use_style_config = __webpack_require__(48189);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/core/Input/InputBase.mjs




var _excluded = ["analyticsName", "trackImpression"];
function cov_19d7qqdwnw() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Input/InputBase.tsx";
  var hash = "c41c830ca8c397c97622ceaa605004a46378ed95";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Input/InputBase.tsx",
    statementMap: {
      "0": {
        start: {
          line: 25,
          column: 18
        },
        end: {
          line: 39,
          column: 1
        }
      },
      "1": {
        start: {
          line: 27,
          column: 19
        },
        end: {
          line: 27,
          column: 49
        }
      },
      "2": {
        start: {
          line: 28,
          column: 22
        },
        end: {
          line: 28,
          column: 95
        }
      },
      "3": {
        start: {
          line: 30,
          column: 4
        },
        end: {
          line: 37,
          column: 6
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 26,
            column: 2
          },
          end: {
            line: 26,
            column: 3
          }
        },
        loc: {
          start: {
            line: 26,
            column: 57
          },
          end: {
            line: 38,
            column: 3
          }
        },
        line: 26
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    f: {
      "0": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "c41c830ca8c397c97622ceaa605004a46378ed95"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_19d7qqdwnw = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_19d7qqdwnw();
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }






var InputBase = (cov_19d7qqdwnw().s[0]++, (0,chakra_ui_system_esm/* forwardRef */.Gp)(function (_ref, ref) {
  var analyticsName = _ref.analyticsName,
    trackImpression = _ref.trackImpression,
    props = _objectWithoutProperties(_ref, _excluded);
  cov_19d7qqdwnw().f[0]++;
  var styles = (cov_19d7qqdwnw().s[1]++, (0,use_style_config/* useStyleConfig */.mq)('Input', props));
  var inViewRef = (cov_19d7qqdwnw().s[2]++, (0,useObservabilitySafe/* useTrackComponentInView */.O)('inputViewEvent', trackImpression, analyticsName));
  cov_19d7qqdwnw().s[3]++;
  return /*#__PURE__*/react.createElement(bricks_types/* bricks.input */.G.input, _extends({
    ref: (0,chakra_ui_hooks_esm/* useMergeRefs */.qq)(inViewRef, ref)
    // __css has a lower priority than sx
    ,
    __css: styles
  }, props));
}));
/* harmony default export */ var Input_InputBase = (InputBase);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/theme/eero/foundations/colors.mjs
var colors = __webpack_require__(81762);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/utils/ScreenReaderOnly.mjs
var ScreenReaderOnly = __webpack_require__(41543);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__(91038);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__(47042);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(74916);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.test.js
var es_regexp_test = __webpack_require__(77601);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__(39714);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Text/Text.mjs
var Text = __webpack_require__(4796);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Button/Button.mjs
var Button = __webpack_require__(26029);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/Icon.mjs + 1 modules
var Icon = __webpack_require__(49154);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/theme/legacy/foundations/mediaBreakpoints.mjs
var mediaBreakpoints = __webpack_require__(26009);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/system/hidden.mjs
function cov_4til87vuv() {
  var path = "/__w/code/code/js/packages/bricks/src/system/hidden.ts";
  var hash = "4a862aa87d67ef54264526c7f66197103c6be485";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/system/hidden.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 28
        },
        end: {
          line: 9,
          column: 1
        }
      },
      "1": {
        start: {
          line: 10,
          column: 26
        },
        end: {
          line: 14,
          column: 1
        }
      },
      "2": {
        start: {
          line: 15,
          column: 26
        },
        end: {
          line: 19,
          column: 1
        }
      },
      "3": {
        start: {
          line: 21,
          column: 26
        },
        end: {
          line: 25,
          column: 1
        }
      },
      "4": {
        start: {
          line: 27,
          column: 28
        },
        end: {
          line: 31,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "4a862aa87d67ef54264526c7f66197103c6be485"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_4til87vuv = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_4til87vuv();


var hiddenXsDown = (cov_4til87vuv().s[0]++, /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(mediaBreakpoints/* media.smallerThan.XS */.BC.smallerThan.XS, "{display:none!important;}" + ( true ? "" : 0),  true ? "" : 0));
var hiddenSmUp = (cov_4til87vuv().s[1]++, /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(mediaBreakpoints/* media.largerThan.SM */.BC.largerThan.SM, "{display:none!important;}" + ( true ? "" : 0),  true ? "" : 0));
var hiddenXsUp = (cov_4til87vuv().s[2]++, /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(mediaBreakpoints/* media.largerThan.XS */.BC.largerThan.XS, "{display:none!important;}" + ( true ? "" : 0),  true ? "" : 0));
var hiddenLgUp = (cov_4til87vuv().s[3]++, /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(mediaBreakpoints/* media.largerThan.LG */.BC.largerThan.LG, "{display:none!important;}" + ( true ? "" : 0),  true ? "" : 0));
var hiddenLgDown = (cov_4til87vuv().s[4]++, /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(mediaBreakpoints/* media.smallerThan.LG */.BC.smallerThan.LG, "{display:none!important;}" + ( true ? "" : 0),  true ? "" : 0));
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/complex/CtaInput/shared.mjs


function cov_z1cgriufo() {
  var path = "/__w/code/code/js/packages/bricks/src/complex/CtaInput/shared.tsx";
  var hash = "fb9da9d71afcdacff675f25ea543ef68d2dd7ac8";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/complex/CtaInput/shared.tsx",
    statementMap: {
      "0": {
        start: {
          line: 85,
          column: 31
        },
        end: {
          line: 88,
          column: 1
        }
      },
      "1": {
        start: {
          line: 87,
          column: 15
        },
        end: {
          line: 87,
          column: 56
        }
      },
      "2": {
        start: {
          line: 90,
          column: 23
        },
        end: {
          line: 112,
          column: 2
        }
      },
      "3": {
        start: {
          line: 91,
          column: 24
        },
        end: {
          line: 91,
          column: 88
        }
      },
      "4": {
        start: {
          line: 92,
          column: 18
        },
        end: {
          line: 96,
          column: 3
        }
      },
      "5": {
        start: {
          line: 97,
          column: 2
        },
        end: {
          line: 111,
          column: 4
        }
      },
      "6": {
        start: {
          line: 114,
          column: 13
        },
        end: {
          line: 120,
          column: 1
        }
      },
      "7": {
        start: {
          line: 122,
          column: 18
        },
        end: {
          line: 137,
          column: 1
        }
      },
      "8": {
        start: {
          line: 139,
          column: 20
        },
        end: {
          line: 159,
          column: 1
        }
      },
      "9": {
        start: {
          line: 161,
          column: 28
        },
        end: {
          line: 202,
          column: 1
        }
      },
      "10": {
        start: {
          line: 204,
          column: 27
        },
        end: {
          line: 210,
          column: 1
        }
      },
      "11": {
        start: {
          line: 216,
          column: 49
        },
        end: {
          line: 226,
          column: 1
        }
      },
      "12": {
        start: {
          line: 217,
          column: 2
        },
        end: {
          line: 225,
          column: 9
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 87,
            column: 4
          },
          end: {
            line: 87,
            column: 5
          }
        },
        loc: {
          start: {
            line: 87,
            column: 15
          },
          end: {
            line: 87,
            column: 56
          }
        },
        line: 87
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 90,
            column: 56
          },
          end: {
            line: 90,
            column: 57
          }
        },
        loc: {
          start: {
            line: 90,
            column: 72
          },
          end: {
            line: 112,
            column: 1
          }
        },
        line: 90
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 216,
            column: 49
          },
          end: {
            line: 216,
            column: 50
          }
        },
        loc: {
          start: {
            line: 217,
            column: 2
          },
          end: {
            line: 225,
            column: 9
          }
        },
        line: 217
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 87,
            column: 15
          },
          end: {
            line: 87,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 87,
            column: 15
          },
          end: {
            line: 87,
            column: 35
          }
        }, {
          start: {
            line: 87,
            column: 39
          },
          end: {
            line: 87,
            column: 56
          }
        }],
        line: 87
      },
      "1": {
        loc: {
          start: {
            line: 91,
            column: 24
          },
          end: {
            line: 91,
            column: 88
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 91,
            column: 43
          },
          end: {
            line: 91,
            column: 79
          }
        }, {
          start: {
            line: 91,
            column: 82
          },
          end: {
            line: 91,
            column: 88
          }
        }],
        line: 91
      },
      "2": {
        loc: {
          start: {
            line: 103,
            column: 20
          },
          end: {
            line: 103,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 103,
            column: 20
          },
          end: {
            line: 103,
            column: 37
          }
        }, {
          start: {
            line: 103,
            column: 41
          },
          end: {
            line: 103,
            column: 50
          }
        }],
        line: 103
      },
      "3": {
        loc: {
          start: {
            line: 104,
            column: 13
          },
          end: {
            line: 104,
            column: 51
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 104,
            column: 36
          },
          end: {
            line: 104,
            column: 42
          }
        }, {
          start: {
            line: 104,
            column: 45
          },
          end: {
            line: 104,
            column: 51
          }
        }],
        line: 104
      },
      "4": {
        loc: {
          start: {
            line: 105,
            column: 23
          },
          end: {
            line: 105,
            column: 51
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 105,
            column: 23
          },
          end: {
            line: 105,
            column: 41
          }
        }, {
          start: {
            line: 105,
            column: 45
          },
          end: {
            line: 105,
            column: 51
          }
        }],
        line: 105
      },
      "5": {
        loc: {
          start: {
            line: 106,
            column: 14
          },
          end: {
            line: 106,
            column: 77
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 106,
            column: 30
          },
          end: {
            line: 106,
            column: 61
          }
        }, {
          start: {
            line: 106,
            column: 64
          },
          end: {
            line: 106,
            column: 77
          }
        }],
        line: 106
      },
      "6": {
        loc: {
          start: {
            line: 107,
            column: 17
          },
          end: {
            line: 107,
            column: 80
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 107,
            column: 36
          },
          end: {
            line: 107,
            column: 71
          }
        }, {
          start: {
            line: 107,
            column: 74
          },
          end: {
            line: 107,
            column: 80
          }
        }],
        line: 107
      },
      "7": {
        loc: {
          start: {
            line: 218,
            column: 5
          },
          end: {
            line: 224,
            column: 5
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 219,
            column: 6
          },
          end: {
            line: 221,
            column: 20
          }
        }, {
          start: {
            line: 223,
            column: 6
          },
          end: {
            line: 223,
            column: 60
          }
        }],
        line: 218
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "fb9da9d71afcdacff675f25ea543ef68d2dd7ac8"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_z1cgriufo = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_z1cgriufo();
function shared_extends() { shared_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return shared_extends.apply(this, arguments); }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
/** @jsx jsx */
// Similar to the CtaInputLite component, difference is that this component
// uses the <Input /> component, which is a very heavy dependency.






var CtaInputWrapper = (cov_z1cgriufo().s[0]++, /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e16j3weq3"
} : 0)("display:flex;", function (props) {
  cov_z1cgriufo().f[0]++;
  cov_z1cgriufo().s[1]++;
  return (cov_z1cgriufo().b[0][0]++, props.unboundedWidth) && (cov_z1cgriufo().b[0][1]++, {
    width: '100%'
  });
}, ";" + ( true ? "" : 0)));
var Wrapper = (cov_z1cgriufo().s[2]++, (0,chakra_ui_system_esm/* forwardRef */.Gp)(function (props, ref) {
  var _ref, _ref2;
  cov_z1cgriufo().f[1]++;
  var defaultBorder = (cov_z1cgriufo().s[3]++, props.showBorder ? (cov_z1cgriufo().b[1][0]++, "1px solid var(--colors-neutrals40)") : (cov_z1cgriufo().b[1][1]++, 'none'));
  var padding = (cov_z1cgriufo().s[4]++, {
    medium: '10px',
    light: '5px',
    none: '0'
  });
  cov_z1cgriufo().s[5]++;
  return (0,emotion_react_browser_esm/* jsx */.tZ)(Box/* default */.Z, shared_extends({
    ref: ref,
    display: "block",
    position: "relative",
    backgroundColor: "neutrals0",
    borderRadius: (_ref = (cov_z1cgriufo().b[2][0]++, props.designStyle)) !== null && _ref !== void 0 ? _ref : (cov_z1cgriufo().b[2][1]++, 'squared'),
    width: props.unboundedWidth ? (cov_z1cgriufo().b[3][0]++, '100%') : (cov_z1cgriufo().b[3][1]++, 'auto'),
    padding: padding[(_ref2 = (cov_z1cgriufo().b[4][0]++, props.paddingLevel)) !== null && _ref2 !== void 0 ? _ref2 : (cov_z1cgriufo().b[4][1]++, 'none')],
    border: props.failure ? (cov_z1cgriufo().b[5][0]++, '2px solid var(--colors-red50)') : (cov_z1cgriufo().b[5][1]++, defaultBorder),
    boxShadow: props.showShadow ? (cov_z1cgriufo().b[6][0]++, '0 3px 15px 2px rgba(0, 0, 0, 0.1)') : (cov_z1cgriufo().b[6][1]++, 'none'),
    _focusWithin: {
      border: "1px solid var(--colors-neutrals100)"
    }
  }, props));
}));
var Form = (cov_z1cgriufo().s[6]++, /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Box/* default */.Z,  true ? {
  target: "e16j3weq2"
} : 0)( true ? {
  name: "jneeu5",
  styles: "position:relative;& .cta-input-form{display:flex;}"
} : 0));
var TextInput = (cov_z1cgriufo().s[7]++, /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)("appearance:none;font-size:var(--fontSizes-s1);::-webkit-input-placeholder{color:var(--colors-neutrals90);}:disabled::-webkit-input-placeholder{color:var(--colors-neutrals30);}:focus{box-shadow:0 0 3px var(--colors-neutrals10);}", mediaBreakpoints/* media.smallerThan.XS */.BC.smallerThan.XS, "{font-size:var(--fontSizes-s00);}" + ( true ? "" : 0),  true ? "" : 0));
var FormElement = (cov_z1cgriufo().s[8]++, /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(TextInput, ";:-webkit-autofill{background-color:var(--colors-neutrals0)!important;}:focus{border-color:var(--colors-brand50);}:focus:active{outline:0;}border:1px solid var(--colors-neutrals30);border-radius:2px;box-sizing:border-box;padding:10px 12px;", mediaBreakpoints/* media.smallerThan.XS */.BC.smallerThan.XS, "{font-size:var(--fontSizes-s00);}" + ( true ? "" : 0),  true ? "" : 0));
var InputWrapper = (cov_z1cgriufo().s[9]++, /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Box/* default */.Z,  true ? {
  target: "e16j3weq1"
} : 0)(FormElement, ";flex:1;border:0;padding:0;display:flex;align-items:center;:focus{border:0;}input{border:0;font-size:var(--fontSizes-s1);overflow:hidden;padding:10px 12px;transition-duration:0.3s;transition-property:color;text-overflow:ellipsis;z-index:1;::placeholder{color:var(--colors-neutrals90);opacity:1;}:focus{box-shadow:none;border:none;outline:none;}:focus::placeholder{color:var(--colors-neutrals90);}}& .od-single-line-input{width:200px;}" + ( true ? "" : 0)));
var InputButton = (cov_z1cgriufo().s[10]++, /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Box/* default */.Z,  true ? {
  target: "e16j3weq0"
} : 0)( true ? {
  name: "nal977",
  styles: "display:flex;align-items:center;max-width:50%;overflow:hidden;margin-left:8px"
} : 0));
cov_z1cgriufo().s[11]++;
var FormWrapper = function FormWrapper(props) {
  cov_z1cgriufo().f[2]++;
  cov_z1cgriufo().s[12]++;
  return (0,emotion_react_browser_esm/* jsx */.tZ)(Form, null, props.shouldSubmitOnClick ? (cov_z1cgriufo().b[7][0]++, (0,emotion_react_browser_esm/* jsx */.tZ)(bricks_types/* bricks.form */.G.form, {
    className: "cta-input-form",
    onSubmit: props.onSubmit
  }, props.children)) : (cov_z1cgriufo().b[7][1]++, (0,emotion_react_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
    className: "cta-input-form"
  }, props.children)));
};
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/complex/CtaInput/CtaInputLite.mjs
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }





























function cov_2gp1nbix2d() {
  var path = "/__w/code/code/js/packages/bricks/src/complex/CtaInput/CtaInputLite.tsx";
  var hash = "e854c22104893daf5b6695a15bcbb4b2713365a7";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/complex/CtaInput/CtaInputLite.tsx",
    statementMap: {
      "0": {
        start: {
          line: 14,
          column: 48
        },
        end: {
          line: 85,
          column: 1
        }
      },
      "1": {
        start: {
          line: 33,
          column: 40
        },
        end: {
          line: 33,
          column: 89
        }
      },
      "2": {
        start: {
          line: 34,
          column: 2
        },
        end: {
          line: 84,
          column: 4
        }
      },
      "3": {
        start: {
          line: 49,
          column: 14
        },
        end: {
          line: 49,
          column: 36
        }
      },
      "4": {
        start: {
          line: 88,
          column: 48
        },
        end: {
          line: 116,
          column: 3
        }
      },
      "5": {
        start: {
          line: 113,
          column: 8
        },
        end: {
          line: 113,
          column: 15
        }
      },
      "6": {
        start: {
          line: 129,
          column: 8
        },
        end: {
          line: 129,
          column: 18
        }
      },
      "7": {
        start: {
          line: 131,
          column: 27
        },
        end: {
          line: 131,
          column: 81
        }
      },
      "8": {
        start: {
          line: 133,
          column: 4
        },
        end: {
          line: 170,
          column: 6
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 14,
            column: 48
          },
          end: {
            line: 14,
            column: 49
          }
        },
        loc: {
          start: {
            line: 32,
            column: 6
          },
          end: {
            line: 85,
            column: 1
          }
        },
        line: 32
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 48,
            column: 21
          },
          end: {
            line: 48,
            column: 22
          }
        },
        loc: {
          start: {
            line: 48,
            column: 27
          },
          end: {
            line: 50,
            column: 13
          }
        },
        line: 48
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 93,
            column: 14
          },
          end: {
            line: 93,
            column: 15
          }
        },
        loc: {
          start: {
            line: 93,
            column: 20
          },
          end: {
            line: 93,
            column: 22
          }
        },
        line: 93
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 94,
            column: 15
          },
          end: {
            line: 94,
            column: 16
          }
        },
        loc: {
          start: {
            line: 94,
            column: 21
          },
          end: {
            line: 94,
            column: 23
          }
        },
        line: 94
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 95,
            column: 14
          },
          end: {
            line: 95,
            column: 15
          }
        },
        loc: {
          start: {
            line: 95,
            column: 20
          },
          end: {
            line: 95,
            column: 22
          }
        },
        line: 95
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 96,
            column: 13
          },
          end: {
            line: 96,
            column: 14
          }
        },
        loc: {
          start: {
            line: 96,
            column: 19
          },
          end: {
            line: 96,
            column: 21
          }
        },
        line: 96
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 97,
            column: 12
          },
          end: {
            line: 97,
            column: 13
          }
        },
        loc: {
          start: {
            line: 97,
            column: 18
          },
          end: {
            line: 97,
            column: 20
          }
        },
        line: 97
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 112,
            column: 15
          },
          end: {
            line: 112,
            column: 16
          }
        },
        loc: {
          start: {
            line: 112,
            column: 21
          },
          end: {
            line: 114,
            column: 7
          }
        },
        line: 112
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 118,
            column: 2
          },
          end: {
            line: 118,
            column: 3
          }
        },
        loc: {
          start: {
            line: 118,
            column: 18
          },
          end: {
            line: 171,
            column: 3
          }
        },
        line: 118
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 37,
            column: 28
          },
          end: {
            line: 37,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 37,
            column: 45
          },
          end: {
            line: 37,
            column: 51
          }
        }, {
          start: {
            line: 37,
            column: 54
          },
          end: {
            line: 37,
            column: 61
          }
        }],
        line: 37
      },
      "1": {
        loc: {
          start: {
            line: 39,
            column: 7
          },
          end: {
            line: 82,
            column: 7
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 40,
            column: 8
          },
          end: {
            line: 59,
            column: 14
          }
        }, {
          start: {
            line: 61,
            column: 8
          },
          end: {
            line: 81,
            column: 10
          }
        }],
        line: 39
      },
      "2": {
        loc: {
          start: {
            line: 56,
            column: 15
          },
          end: {
            line: 56,
            column: 83
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 56,
            column: 15
          },
          end: {
            line: 56,
            column: 40
          }
        }, {
          start: {
            line: 56,
            column: 44
          },
          end: {
            line: 56,
            column: 83
          }
        }],
        line: 56
      },
      "3": {
        loc: {
          start: {
            line: 79,
            column: 17
          },
          end: {
            line: 79,
            column: 52
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 79,
            column: 34
          },
          end: {
            line: 79,
            column: 40
          }
        }, {
          start: {
            line: 79,
            column: 43
          },
          end: {
            line: 79,
            column: 52
          }
        }],
        line: 79
      },
      "4": {
        loc: {
          start: {
            line: 160,
            column: 51
          },
          end: {
            line: 160,
            column: 85
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 160,
            column: 51
          },
          end: {
            line: 160,
            column: 77
          }
        }, {
          start: {
            line: 160,
            column: 81
          },
          end: {
            line: 160,
            column: 85
          }
        }],
        line: 160
      },
      "5": {
        loc: {
          start: {
            line: 162,
            column: 21
          },
          end: {
            line: 162,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 162,
            column: 21
          },
          end: {
            line: 162,
            column: 52
          }
        }, {
          start: {
            line: 162,
            column: 56
          },
          end: {
            line: 162,
            column: 60
          }
        }],
        line: 162
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "e854c22104893daf5b6695a15bcbb4b2713365a7"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2gp1nbix2d = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2gp1nbix2d();
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function CtaInputLite_extends() { CtaInputLite_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return CtaInputLite_extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
// Nearly identical to the CtaInput component, just removes
// the use of "<Input />" from email and tel input types
// The Input component uses libphonenumber-js and mailcheck
// which combine for ~50kb gzipped bundle size.
// Generally recommended to use this if you're in a bundle
// size optimized situation.





cov_2gp1nbix2d().s[0]++;
var InnerInputWithPrefill = function InnerInputWithPrefill(_ref) {
  var id = _ref.id,
    ariaLabel = _ref.ariaLabel,
    ariaLabelledby = _ref.ariaLabelledby,
    inputType = _ref.inputType,
    placeholderText = _ref.placeholderText,
    value = _ref.value,
    autoComplete = _ref.autoComplete,
    autoFocus = _ref.autoFocus,
    onChange = _ref.onChange,
    onKeyDown = _ref.onKeyDown,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    unboundedWidth = _ref.unboundedWidth,
    designStyle = _ref.designStyle,
    className = _ref.className,
    analyticsName = _ref.analyticsName,
    prefillBehavior = _ref.ctaProps.prefillBehavior;
  cov_2gp1nbix2d().f[0]++;
  var _ref2 = (cov_2gp1nbix2d().s[1]++, react.useState(Boolean(prefillBehavior))),
    _ref3 = _slicedToArray(_ref2, 2),
    showPrefill = _ref3[0],
    setShowPrefill = _ref3[1];
  cov_2gp1nbix2d().s[2]++;
  return /*#__PURE__*/react.createElement(Flex/* default */.Z, {
    className: "cta-input-lite-container",
    width: ['100%', null, unboundedWidth ? (cov_2gp1nbix2d().b[0][0]++, '100%') : (cov_2gp1nbix2d().b[0][1]++, '350px')]
  }, showPrefill ? (cov_2gp1nbix2d().b[1][0]++, /*#__PURE__*/react.createElement(Box/* default */.Z, null, /*#__PURE__*/react.createElement(Text/* default */.Z, {
    fontWeight: 'semibold'
  }, value), /*#__PURE__*/react.createElement(Button/* default */.ZP, {
    "aria-label": "Edit input text",
    variant: "inline-link",
    textDecoration: "none",
    analyticsName: "prefill-edit-text",
    type: "button",
    onClick: function onClick() {
      cov_2gp1nbix2d().f[1]++;
      cov_2gp1nbix2d().s[3]++;
      setShowPrefill(false);
    }
  }, /*#__PURE__*/react.createElement(Flex/* default */.Z, {
    alignItems: 'center',
    justifyContent: "center",
    gap: "2"
  }, /*#__PURE__*/react.createElement(Text/* default */.Z, CtaInputLite_extends({}, prefillBehavior.textProps, {
    textAlign: "center"
  }), prefillBehavior.editCtaText), (cov_2gp1nbix2d().b[2][0]++, prefillBehavior.iconProps) && (cov_2gp1nbix2d().b[2][1]++, /*#__PURE__*/react.createElement(Icon/* default */.Z, prefillBehavior.iconProps)))))) : (cov_2gp1nbix2d().b[1][1]++, /*#__PURE__*/react.createElement(Input_InputBase, {
    name: "CtaInput",
    id: id,
    className: "cta-input-control cta-input-js ".concat(className),
    onFocus: onFocus,
    onBlur: onBlur,
    type: inputType,
    value: value,
    onChange: onChange,
    onKeyDown: onKeyDown,
    placeholder: placeholderText,
    autoComplete: autoComplete,
    autoFocus: autoFocus,
    required: true,
    borderRadius: designStyle,
    analyticsName: analyticsName,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledby,
    width: unboundedWidth ? (cov_2gp1nbix2d().b[3][0]++, '100%') : (cov_2gp1nbix2d().b[3][1]++, 'initial'),
    height: "56px"
  })));
};
var CtaInputLite = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(CtaInputLite, _React$PureComponent);
  function CtaInputLite() {
    _classCallCheck(this, CtaInputLite);
    return _callSuper(this, CtaInputLite, arguments);
  }
  _createClass(CtaInputLite, [{
    key: "render",
    value: function render() {
      var _ref5, _ref6;
      cov_2gp1nbix2d().f[8]++;
      var _ref4 = (cov_2gp1nbix2d().s[6]++, this.props),
        onSubmit = _ref4.onSubmit,
        paddingLevel = _ref4.paddingLevel,
        showBorder = _ref4.showBorder,
        showShadow = _ref4.showShadow,
        unboundedWidth = _ref4.unboundedWidth,
        designStyle = _ref4.designStyle,
        failure = _ref4.failure,
        analyticsName = _ref4.analyticsName,
        ctaProps = _ref4.ctaProps;
      var mergedCtaProps = (cov_2gp1nbix2d().s[7]++, _objectSpread(_objectSpread({}, CtaInputLite.defaultProps.ctaProps), ctaProps));
      cov_2gp1nbix2d().s[8]++;
      return /*#__PURE__*/react.createElement(CtaInputWrapper, {
        className: "od-cta-input",
        unboundedWidth: unboundedWidth
      }, /*#__PURE__*/react.createElement(Wrapper, {
        className: "cta-input-wrapper",
        designStyle: designStyle,
        paddingLevel: paddingLevel,
        showBorder: showBorder,
        showShadow: showShadow,
        unboundedWidth: unboundedWidth,
        failure: failure
      }, /*#__PURE__*/react.createElement(FormWrapper, {
        shouldSubmitOnClick: mergedCtaProps.type === 'submit',
        onSubmit: onSubmit
      }, /*#__PURE__*/react.createElement(InputWrapper, {
        unboundedWidth: unboundedWidth,
        designStyle: designStyle
      }, /*#__PURE__*/react.createElement(InnerInputWithPrefill, this.props)), /*#__PURE__*/react.createElement(InputButton, {
        className: "cta-input-button"
      }, /*#__PURE__*/react.createElement(Button/* default */.ZP, CtaInputLite_extends({
        className: "cta-button",
        analyticsName: "".concat(analyticsName, "-cta-button"),
        trackImpression: true,
        onClick: mergedCtaProps.onClick,
        variant: mergedCtaProps.variant,
        type: mergedCtaProps.type,
        borderRadius: designStyle
      }, mergedCtaProps), /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(bricks_types/* bricks.span */.G.span, {
        css: hiddenXsDown
      }, (_ref5 = (cov_2gp1nbix2d().b[4][0]++, mergedCtaProps === null || mergedCtaProps === void 0 ? void 0 : mergedCtaProps.actionText)) !== null && _ref5 !== void 0 ? _ref5 : (cov_2gp1nbix2d().b[4][1]++, 'Go')), /*#__PURE__*/react.createElement(bricks_types/* bricks.span */.G.span, {
        css: hiddenXsUp
      }, (_ref6 = (cov_2gp1nbix2d().b[5][0]++, mergedCtaProps === null || mergedCtaProps === void 0 ? void 0 : mergedCtaProps.actionTextSmall)) !== null && _ref6 !== void 0 ? _ref6 : (cov_2gp1nbix2d().b[5][1]++, 'Go'))))))));
    }
  }]);
  return CtaInputLite;
}((react.PureComponent));
_defineProperty(CtaInputLite, "defaultProps", (cov_2gp1nbix2d().s[4]++, {
  autoComplete: 'on',
  autoFocus: true,
  className: '',
  designStyle: 'roundedSquare',
  onChange: function onChange() {
    cov_2gp1nbix2d().f[2]++;
  },
  onKeyDown: function onKeyDown() {
    cov_2gp1nbix2d().f[3]++;
  },
  onSubmit: function onSubmit() {
    cov_2gp1nbix2d().f[4]++;
  },
  onFocus: function onFocus() {
    cov_2gp1nbix2d().f[5]++;
  },
  onBlur: function onBlur() {
    cov_2gp1nbix2d().f[6]++;
  },
  paddingLevel: 'medium',
  showBorder: true,
  showShadow: false,
  value: '',
  inputType: 'text',
  unboundedWidth: false,
  ctaProps: {
    actionText: 'Go',
    actionTextSmall: 'Go',
    'aria-label': 'Input text',
    variant: 'primary',
    type: 'submit',
    disabled: false,
    prefillBehavior: undefined,
    onClick: function onClick() {
      cov_2gp1nbix2d().f[7]++;
      cov_2gp1nbix2d().s[5]++;
      return;
    }
  }
}));

;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/complex/ErrorPrompt/ErrorPrompt.mjs




var ErrorPrompt_excluded = ["message"];
function cov_1jhrnrlzhv() {
  var path = "/__w/code/code/js/packages/bricks/src/complex/ErrorPrompt/ErrorPrompt.tsx";
  var hash = "8bc57ee60b494c31a9619120dbb4e15ec52c361a";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/complex/ErrorPrompt/ErrorPrompt.tsx",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 20
        },
        end: {
          line: 11,
          column: 1
        }
      },
      "1": {
        start: {
          line: 8,
          column: 2
        },
        end: {
          line: 10,
          column: 9
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 7,
            column: 20
          },
          end: {
            line: 7,
            column: 21
          }
        },
        loc: {
          start: {
            line: 8,
            column: 2
          },
          end: {
            line: 10,
            column: 9
          }
        },
        line: 8
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {
      "0": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "8bc57ee60b494c31a9619120dbb4e15ec52c361a"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1jhrnrlzhv = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1jhrnrlzhv();
function ErrorPrompt_extends() { ErrorPrompt_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ErrorPrompt_extends.apply(this, arguments); }
function ErrorPrompt_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = ErrorPrompt_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function ErrorPrompt_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }


cov_1jhrnrlzhv().s[0]++;
var ErrorPrompt = function ErrorPrompt(_ref) {
  var message = _ref.message,
    props = ErrorPrompt_objectWithoutProperties(_ref, ErrorPrompt_excluded);
  cov_1jhrnrlzhv().f[0]++;
  cov_1jhrnrlzhv().s[1]++;
  return /*#__PURE__*/react.createElement(Text/* default */.Z, ErrorPrompt_extends({
    "data-testid": "error-prompt",
    color: "red50",
    fontSize: "s1",
    mt: 3
  }, props), message);
};
/* harmony default export */ var ErrorPrompt_ErrorPrompt = (ErrorPrompt);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/core/List/ListItem.mjs
function cov_538hk6svh() {
  var path = "/__w/code/code/js/packages/bricks/src/core/List/ListItem.tsx";
  var hash = "c2cf2ee95a6c290b01407ad59e8bc3280e8525cd";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/List/ListItem.tsx",
    statementMap: {
      "0": {
        start: {
          line: 19,
          column: 24
        },
        end: {
          line: 29,
          column: 2
        }
      },
      "1": {
        start: {
          line: 20,
          column: 17
        },
        end: {
          line: 20,
          column: 50
        }
      },
      "2": {
        start: {
          line: 21,
          column: 2
        },
        end: {
          line: 28,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 19,
            column: 56
          },
          end: {
            line: 19,
            column: 57
          }
        },
        loc: {
          start: {
            line: 19,
            column: 72
          },
          end: {
            line: 29,
            column: 1
          }
        },
        line: 19
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {
      "0": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "c2cf2ee95a6c290b01407ad59e8bc3280e8525cd"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_538hk6svh = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_538hk6svh();

function ListItem_extends() { ListItem_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ListItem_extends.apply(this, arguments); }




/**
 * ListItem should only be used as a child of a List component
 */
var ListItem = (cov_538hk6svh().s[0]++, (0,chakra_ui_system_esm/* forwardRef */.Gp)(function (props, ref) {
  cov_538hk6svh().f[0]++;
  var styles = (cov_538hk6svh().s[1]++, (0,use_style_config/* useStyleConfig */.mq)('ListItem', props));
  cov_538hk6svh().s[2]++;
  return /*#__PURE__*/react.createElement(bricks_types/* bricks.li */.G.li, ListItem_extends({
    ref: ref
    // __css has a lower priority than sx
    ,
    __css: styles
  }, props));
}));
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/complex/AutocompleteInput/AutocompleteOption.mjs




var AutocompleteOption_excluded = ["selected"];
function cov_41ufrtk5d() {
  var path = "/__w/code/code/js/packages/bricks/src/complex/AutocompleteInput/AutocompleteOption.tsx";
  var hash = "18619231e5e7503312a0e36e5f5656badc0397d7";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/complex/AutocompleteInput/AutocompleteOption.tsx",
    statementMap: {
      "0": {
        start: {
          line: 17,
          column: 75
        },
        end: {
          line: 35,
          column: 1
        }
      },
      "1": {
        start: {
          line: 21,
          column: 2
        },
        end: {
          line: 34,
          column: 4
        }
      },
      "2": {
        start: {
          line: 37,
          column: 70
        },
        end: {
          line: 50,
          column: 1
        }
      },
      "3": {
        start: {
          line: 42,
          column: 2
        },
        end: {
          line: 49,
          column: 15
        }
      },
      "4": {
        start: {
          line: 46,
          column: 23
        },
        end: {
          line: 46,
          column: 38
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 17,
            column: 75
          },
          end: {
            line: 17,
            column: 76
          }
        },
        loc: {
          start: {
            line: 21,
            column: 2
          },
          end: {
            line: 34,
            column: 4
          }
        },
        line: 21
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 37,
            column: 70
          },
          end: {
            line: 37,
            column: 71
          }
        },
        loc: {
          start: {
            line: 42,
            column: 2
          },
          end: {
            line: 49,
            column: 15
          }
        },
        line: 42
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 46,
            column: 17
          },
          end: {
            line: 46,
            column: 18
          }
        },
        loc: {
          start: {
            line: 46,
            column: 23
          },
          end: {
            line: 46,
            column: 38
          }
        },
        line: 46
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 26,
            column: 13
          },
          end: {
            line: 26,
            column: 49
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 26,
            column: 24
          },
          end: {
            line: 26,
            column: 33
          }
        }, {
          start: {
            line: 26,
            column: 36
          },
          end: {
            line: 26,
            column: 49
          }
        }],
        line: 26
      },
      "1": {
        loc: {
          start: {
            line: 27,
            column: 11
          },
          end: {
            line: 27,
            column: 49
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 27,
            column: 22
          },
          end: {
            line: 27,
            column: 33
          }
        }, {
          start: {
            line: 27,
            column: 36
          },
          end: {
            line: 27,
            column: 49
          }
        }],
        line: 27
      },
      "2": {
        loc: {
          start: {
            line: 39,
            column: 2
          },
          end: {
            line: 39,
            column: 18
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 39,
            column: 13
          },
          end: {
            line: 39,
            column: 18
          }
        }],
        line: 39
      },
      "3": {
        loc: {
          start: {
            line: 48,
            column: 5
          },
          end: {
            line: 48,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 48,
            column: 5
          },
          end: {
            line: 48,
            column: 24
          }
        }, {
          start: {
            line: 48,
            column: 28
          },
          end: {
            line: 48,
            column: 40
          }
        }],
        line: 48
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0],
      "3": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "18619231e5e7503312a0e36e5f5656badc0397d7"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_41ufrtk5d = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_41ufrtk5d();
function AutocompleteOption_extends() { AutocompleteOption_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return AutocompleteOption_extends.apply(this, arguments); }
function AutocompleteOption_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = AutocompleteOption_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function AutocompleteOption_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



cov_41ufrtk5d().s[0]++;
var ResultItem = function ResultItem(_ref) {
  var selected = _ref.selected,
    props = AutocompleteOption_objectWithoutProperties(_ref, AutocompleteOption_excluded);
  cov_41ufrtk5d().f[0]++;
  cov_41ufrtk5d().s[1]++;
  return /*#__PURE__*/react.createElement(ListItem, AutocompleteOption_extends({
    fontFamily: "sans",
    padding: "10px 19px" // eyeballed to match od-cta-input
    ,
    cursor: "pointer",
    _hover: {
      backgroundColor: colors/* default.neutrals30 */.ZP.neutrals30
    },
    bgColor: selected ? (cov_41ufrtk5d().b[0][0]++, 'brand50') : (cov_41ufrtk5d().b[0][1]++, 'transparent'),
    color: selected ? (cov_41ufrtk5d().b[1][0]++, 'neutrals0') : (cov_41ufrtk5d().b[1][1]++, 'neutrals100'),
    selected: selected
    // TODO(@core-experience-platform): Fix this a11y violation
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
    ,
    role: "option",
    "aria-selected": selected
  }, props));
};
cov_41ufrtk5d().s[2]++;
var AutocompleteOption = function AutocompleteOption(_ref2) {
  var option = _ref2.option,
    _ref2$selected = _ref2.selected,
    selected = _ref2$selected === void 0 ? (cov_41ufrtk5d().b[2][0]++, false) : _ref2$selected,
    onClick = _ref2.onClick;
  cov_41ufrtk5d().f[1]++;
  cov_41ufrtk5d().s[3]++;
  return /*#__PURE__*/react.createElement(ResultItem, {
    id: "".concat(option.value, "-option"),
    className: "autocomplete-option result-item",
    selected: selected,
    onMouseDown: function onMouseDown() {
      cov_41ufrtk5d().f[2]++;
      cov_41ufrtk5d().s[4]++;
      return onClick(option);
    }
  }, (cov_41ufrtk5d().b[3][0]++, option.displayValue) || (cov_41ufrtk5d().b[3][1]++, option.value));
};
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/complex/AutocompleteInput/AutocompleteInput.mjs
function AutocompleteInput_typeof(o) { "@babel/helpers - typeof"; return AutocompleteInput_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, AutocompleteInput_typeof(o); }

var AutocompleteInput_excluded = ["error", "showCta"];
function cov_19zj5rh3yq() {
  var path = "/__w/code/code/js/packages/bricks/src/complex/AutocompleteInput/AutocompleteInput.tsx";
  var hash = "8703f61bfa0d6b9884ce8fc986961d34d6a74079";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/complex/AutocompleteInput/AutocompleteInput.tsx",
    statementMap: {
      "0": {
        start: {
          line: 24,
          column: 13
        },
        end: {
          line: 24,
          column: 74
        }
      },
      "1": {
        start: {
          line: 26,
          column: 33
        },
        end: {
          line: 34,
          column: 2
        }
      },
      "2": {
        start: {
          line: 33,
          column: 2
        },
        end: {
          line: 33,
          column: 74
        }
      },
      "3": {
        start: {
          line: 41,
          column: 26
        },
        end: {
          line: 64,
          column: 1
        }
      },
      "4": {
        start: {
          line: 55,
          column: 4
        },
        end: {
          line: 55,
          column: 79
        }
      },
      "5": {
        start: {
          line: 62,
          column: 24
        },
        end: {
          line: 62,
          column: 41
        }
      },
      "6": {
        start: {
          line: 63,
          column: 16
        },
        end: {
          line: 63,
          column: 70
        }
      },
      "7": {
        start: {
          line: 66,
          column: 29
        },
        end: {
          line: 71,
          column: 1
        }
      },
      "8": {
        start: {
          line: 132,
          column: 65
        },
        end: {
          line: 152,
          column: 3
        }
      },
      "9": {
        start: {
          line: 155,
          column: 4
        },
        end: {
          line: 155,
          column: 17
        }
      },
      "10": {
        start: {
          line: 158,
          column: 4
        },
        end: {
          line: 158,
          column: 34
        }
      },
      "11": {
        start: {
          line: 161,
          column: 17
        },
        end: {
          line: 169,
          column: 3
        }
      },
      "12": {
        start: {
          line: 171,
          column: 49
        },
        end: {
          line: 184,
          column: 3
        }
      },
      "13": {
        start: {
          line: 172,
          column: 4
        },
        end: {
          line: 177,
          column: 7
        }
      },
      "14": {
        start: {
          line: 178,
          column: 4
        },
        end: {
          line: 178,
          column: 56
        }
      },
      "15": {
        start: {
          line: 181,
          column: 4
        },
        end: {
          line: 183,
          column: 5
        }
      },
      "16": {
        start: {
          line: 182,
          column: 6
        },
        end: {
          line: 182,
          column: 25
        }
      },
      "17": {
        start: {
          line: 186,
          column: 46
        },
        end: {
          line: 210,
          column: 3
        }
      },
      "18": {
        start: {
          line: 187,
          column: 4
        },
        end: {
          line: 189,
          column: 5
        }
      },
      "19": {
        start: {
          line: 188,
          column: 6
        },
        end: {
          line: 188,
          column: 13
        }
      },
      "20": {
        start: {
          line: 190,
          column: 4
        },
        end: {
          line: 209,
          column: 5
        }
      },
      "21": {
        start: {
          line: 192,
          column: 8
        },
        end: {
          line: 192,
          column: 27
        }
      },
      "22": {
        start: {
          line: 193,
          column: 8
        },
        end: {
          line: 193,
          column: 57
        }
      },
      "23": {
        start: {
          line: 194,
          column: 8
        },
        end: {
          line: 194,
          column: 14
        }
      },
      "24": {
        start: {
          line: 196,
          column: 8
        },
        end: {
          line: 196,
          column: 27
        }
      },
      "25": {
        start: {
          line: 197,
          column: 8
        },
        end: {
          line: 197,
          column: 57
        }
      },
      "26": {
        start: {
          line: 198,
          column: 8
        },
        end: {
          line: 198,
          column: 14
        }
      },
      "27": {
        start: {
          line: 200,
          column: 8
        },
        end: {
          line: 200,
          column: 27
        }
      },
      "28": {
        start: {
          line: 201,
          column: 8
        },
        end: {
          line: 201,
          column: 27
        }
      },
      "29": {
        start: {
          line: 202,
          column: 8
        },
        end: {
          line: 202,
          column: 14
        }
      },
      "30": {
        start: {
          line: 204,
          column: 8
        },
        end: {
          line: 204,
          column: 27
        }
      },
      "31": {
        start: {
          line: 205,
          column: 8
        },
        end: {
          line: 205,
          column: 28
        }
      },
      "32": {
        start: {
          line: 206,
          column: 8
        },
        end: {
          line: 206,
          column: 14
        }
      },
      "33": {
        start: {
          line: 208,
          column: 8
        },
        end: {
          line: 208,
          column: 14
        }
      },
      "34": {
        start: {
          line: 212,
          column: 25
        },
        end: {
          line: 219,
          column: 3
        }
      },
      "35": {
        start: {
          line: 213,
          column: 4
        },
        end: {
          line: 213,
          column: 30
        }
      },
      "36": {
        start: {
          line: 215,
          column: 4
        },
        end: {
          line: 218,
          column: 5
        }
      },
      "37": {
        start: {
          line: 216,
          column: 6
        },
        end: {
          line: 216,
          column: 63
        }
      },
      "38": {
        start: {
          line: 217,
          column: 6
        },
        end: {
          line: 217,
          column: 74
        }
      },
      "39": {
        start: {
          line: 221,
          column: 40
        },
        end: {
          line: 228,
          column: 3
        }
      },
      "40": {
        start: {
          line: 222,
          column: 4
        },
        end: {
          line: 222,
          column: 23
        }
      },
      "41": {
        start: {
          line: 223,
          column: 4
        },
        end: {
          line: 225,
          column: 5
        }
      },
      "42": {
        start: {
          line: 224,
          column: 6
        },
        end: {
          line: 224,
          column: 26
        }
      },
      "43": {
        start: {
          line: 226,
          column: 4
        },
        end: {
          line: 226,
          column: 46
        }
      },
      "44": {
        start: {
          line: 227,
          column: 4
        },
        end: {
          line: 227,
          column: 45
        }
      },
      "45": {
        start: {
          line: 236,
          column: 6
        },
        end: {
          line: 237,
          column: 84
        }
      },
      "46": {
        start: {
          line: 238,
          column: 4
        },
        end: {
          line: 244,
          column: 5
        }
      },
      "47": {
        start: {
          line: 243,
          column: 6
        },
        end: {
          line: 243,
          column: 27
        }
      },
      "48": {
        start: {
          line: 251,
          column: 4
        },
        end: {
          line: 251,
          column: 79
        }
      },
      "49": {
        start: {
          line: 269,
          column: 8
        },
        end: {
          line: 269,
          column: 18
        }
      },
      "50": {
        start: {
          line: 270,
          column: 46
        },
        end: {
          line: 270,
          column: 56
        }
      },
      "51": {
        start: {
          line: 272,
          column: 25
        },
        end: {
          line: 274,
          column: 5
        }
      },
      "52": {
        start: {
          line: 276,
          column: 4
        },
        end: {
          line: 334,
          column: 6
        }
      },
      "53": {
        start: {
          line: 299,
          column: 28
        },
        end: {
          line: 299,
          column: 47
        }
      },
      "54": {
        start: {
          line: 337,
          column: 26
        },
        end: {
          line: 364,
          column: 3
        }
      },
      "55": {
        start: {
          line: 338,
          column: 57
        },
        end: {
          line: 338,
          column: 67
        }
      },
      "56": {
        start: {
          line: 339,
          column: 28
        },
        end: {
          line: 339,
          column: 38
        }
      },
      "57": {
        start: {
          line: 340,
          column: 4
        },
        end: {
          line: 363,
          column: 6
        }
      },
      "58": {
        start: {
          line: 352,
          column: 12
        },
        end: {
          line: 359,
          column: 14
        }
      },
      "59": {
        start: {
          line: 366,
          column: 24
        },
        end: {
          line: 371,
          column: 9
        }
      },
      "60": {
        start: {
          line: 367,
          column: 4
        },
        end: {
          line: 371,
          column: 9
        }
      },
      "61": {
        start: {
          line: 373,
          column: 28
        },
        end: {
          line: 390,
          column: 3
        }
      },
      "62": {
        start: {
          line: 378,
          column: 8
        },
        end: {
          line: 378,
          column: 18
        }
      },
      "63": {
        start: {
          line: 379,
          column: 26
        },
        end: {
          line: 379,
          column: 36
        }
      },
      "64": {
        start: {
          line: 380,
          column: 27
        },
        end: {
          line: 380,
          column: 41
        }
      },
      "65": {
        start: {
          line: 381,
          column: 4
        },
        end: {
          line: 383,
          column: 7
        }
      },
      "66": {
        start: {
          line: 385,
          column: 4
        },
        end: {
          line: 389,
          column: 8
        }
      },
      "67": {
        start: {
          line: 394,
          column: 27
        },
        end: {
          line: 394,
          column: 67
        }
      },
      "68": {
        start: {
          line: 397,
          column: 31
        },
        end: {
          line: 397,
          column: 87
        }
      },
      "69": {
        start: {
          line: 398,
          column: 35
        },
        end: {
          line: 398,
          column: 93
        }
      },
      "70": {
        start: {
          line: 400,
          column: 4
        },
        end: {
          line: 404,
          column: 5
        }
      },
      "71": {
        start: {
          line: 401,
          column: 6
        },
        end: {
          line: 403,
          column: 9
        }
      },
      "72": {
        start: {
          line: 407,
          column: 24
        },
        end: {
          line: 412,
          column: 3
        }
      },
      "73": {
        start: {
          line: 408,
          column: 4
        },
        end: {
          line: 408,
          column: 36
        }
      },
      "74": {
        start: {
          line: 409,
          column: 4
        },
        end: {
          line: 409,
          column: 25
        }
      },
      "75": {
        start: {
          line: 410,
          column: 4
        },
        end: {
          line: 410,
          column: 23
        }
      },
      "76": {
        start: {
          line: 411,
          column: 4
        },
        end: {
          line: 411,
          column: 67
        }
      },
      "77": {
        start: {
          line: 414,
          column: 25
        },
        end: {
          line: 424,
          column: 3
        }
      },
      "78": {
        start: {
          line: 415,
          column: 39
        },
        end: {
          line: 415,
          column: 49
        }
      },
      "79": {
        start: {
          line: 416,
          column: 28
        },
        end: {
          line: 416,
          column: 38
        }
      },
      "80": {
        start: {
          line: 418,
          column: 4
        },
        end: {
          line: 421,
          column: 6
        }
      },
      "81": {
        start: {
          line: 422,
          column: 4
        },
        end: {
          line: 422,
          column: 36
        }
      },
      "82": {
        start: {
          line: 423,
          column: 4
        },
        end: {
          line: 423,
          column: 23
        }
      },
      "83": {
        start: {
          line: 426,
          column: 24
        },
        end: {
          line: 431,
          column: 3
        }
      },
      "84": {
        start: {
          line: 427,
          column: 4
        },
        end: {
          line: 430,
          column: 7
        }
      },
      "85": {
        start: {
          line: 433,
          column: 43
        },
        end: {
          line: 437,
          column: 3
        }
      },
      "86": {
        start: {
          line: 434,
          column: 33
        },
        end: {
          line: 434,
          column: 43
        }
      },
      "87": {
        start: {
          line: 435,
          column: 4
        },
        end: {
          line: 435,
          column: 79
        }
      },
      "88": {
        start: {
          line: 436,
          column: 4
        },
        end: {
          line: 436,
          column: 26
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 32,
            column: 2
          },
          end: {
            line: 32,
            column: 3
          }
        },
        loc: {
          start: {
            line: 33,
            column: 2
          },
          end: {
            line: 33,
            column: 74
          }
        },
        line: 33
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 54,
            column: 12
          },
          end: {
            line: 54,
            column: 13
          }
        },
        loc: {
          start: {
            line: 55,
            column: 4
          },
          end: {
            line: 55,
            column: 79
          }
        },
        line: 55
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 62,
            column: 13
          },
          end: {
            line: 62,
            column: 14
          }
        },
        loc: {
          start: {
            line: 62,
            column: 24
          },
          end: {
            line: 62,
            column: 41
          }
        },
        line: 62
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 63,
            column: 4
          },
          end: {
            line: 63,
            column: 5
          }
        },
        loc: {
          start: {
            line: 63,
            column: 16
          },
          end: {
            line: 63,
            column: 70
          }
        },
        line: 63
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 154,
            column: 2
          },
          end: {
            line: 154,
            column: 3
          }
        },
        loc: {
          start: {
            line: 154,
            column: 21
          },
          end: {
            line: 159,
            column: 3
          }
        },
        line: 154
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 171,
            column: 49
          },
          end: {
            line: 171,
            column: 50
          }
        },
        loc: {
          start: {
            line: 171,
            column: 60
          },
          end: {
            line: 184,
            column: 3
          }
        },
        line: 171
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 186,
            column: 46
          },
          end: {
            line: 186,
            column: 47
          }
        },
        loc: {
          start: {
            line: 186,
            column: 53
          },
          end: {
            line: 210,
            column: 3
          }
        },
        line: 186
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 212,
            column: 25
          },
          end: {
            line: 212,
            column: 26
          }
        },
        loc: {
          start: {
            line: 212,
            column: 58
          },
          end: {
            line: 219,
            column: 3
          }
        },
        line: 212
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 221,
            column: 40
          },
          end: {
            line: 221,
            column: 41
          }
        },
        loc: {
          start: {
            line: 221,
            column: 47
          },
          end: {
            line: 228,
            column: 3
          }
        },
        line: 221
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 230,
            column: 2
          },
          end: {
            line: 230,
            column: 3
          }
        },
        loc: {
          start: {
            line: 230,
            column: 64
          },
          end: {
            line: 245,
            column: 3
          }
        },
        line: 230
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 247,
            column: 2
          },
          end: {
            line: 247,
            column: 3
          }
        },
        loc: {
          start: {
            line: 247,
            column: 29
          },
          end: {
            line: 252,
            column: 3
          }
        },
        line: 247
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 254,
            column: 2
          },
          end: {
            line: 254,
            column: 3
          }
        },
        loc: {
          start: {
            line: 254,
            column: 18
          },
          end: {
            line: 335,
            column: 3
          }
        },
        line: 254
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 299,
            column: 22
          },
          end: {
            line: 299,
            column: 23
          }
        },
        loc: {
          start: {
            line: 299,
            column: 28
          },
          end: {
            line: 299,
            column: 47
          }
        },
        line: 299
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 337,
            column: 26
          },
          end: {
            line: 337,
            column: 27
          }
        },
        loc: {
          start: {
            line: 337,
            column: 32
          },
          end: {
            line: 364,
            column: 3
          }
        },
        line: 337
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 351,
            column: 23
          },
          end: {
            line: 351,
            column: 24
          }
        },
        loc: {
          start: {
            line: 351,
            column: 71
          },
          end: {
            line: 360,
            column: 11
          }
        },
        line: 351
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 366,
            column: 24
          },
          end: {
            line: 366,
            column: 25
          }
        },
        loc: {
          start: {
            line: 367,
            column: 4
          },
          end: {
            line: 371,
            column: 9
          }
        },
        line: 367
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 373,
            column: 28
          },
          end: {
            line: 373,
            column: 29
          }
        },
        loc: {
          start: {
            line: 373,
            column: 47
          },
          end: {
            line: 390,
            column: 3
          }
        },
        line: 373
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 392,
            column: 2
          },
          end: {
            line: 392,
            column: 3
          }
        },
        loc: {
          start: {
            line: 392,
            column: 26
          },
          end: {
            line: 405,
            column: 3
          }
        },
        line: 392
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 407,
            column: 24
          },
          end: {
            line: 407,
            column: 25
          }
        },
        loc: {
          start: {
            line: 407,
            column: 68
          },
          end: {
            line: 412,
            column: 3
          }
        },
        line: 407
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 414,
            column: 25
          },
          end: {
            line: 414,
            column: 26
          }
        },
        loc: {
          start: {
            line: 414,
            column: 65
          },
          end: {
            line: 424,
            column: 3
          }
        },
        line: 414
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 426,
            column: 24
          },
          end: {
            line: 426,
            column: 25
          }
        },
        loc: {
          start: {
            line: 426,
            column: 30
          },
          end: {
            line: 431,
            column: 3
          }
        },
        line: 426
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 433,
            column: 43
          },
          end: {
            line: 433,
            column: 44
          }
        },
        loc: {
          start: {
            line: 433,
            column: 50
          },
          end: {
            line: 437,
            column: 3
          }
        },
        line: 433
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 55,
            column: 4
          },
          end: {
            line: 55,
            column: 79
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 55,
            column: 48
          },
          end: {
            line: 55,
            column: 74
          }
        }, {
          start: {
            line: 55,
            column: 77
          },
          end: {
            line: 55,
            column: 79
          }
        }],
        line: 55
      },
      "1": {
        loc: {
          start: {
            line: 55,
            column: 4
          },
          end: {
            line: 55,
            column: 45
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 55,
            column: 4
          },
          end: {
            line: 55,
            column: 22
          }
        }, {
          start: {
            line: 55,
            column: 26
          },
          end: {
            line: 55,
            column: 45
          }
        }],
        line: 55
      },
      "2": {
        loc: {
          start: {
            line: 62,
            column: 24
          },
          end: {
            line: 62,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 62,
            column: 24
          },
          end: {
            line: 62,
            column: 36
          }
        }, {
          start: {
            line: 62,
            column: 40
          },
          end: {
            line: 62,
            column: 41
          }
        }],
        line: 62
      },
      "3": {
        loc: {
          start: {
            line: 63,
            column: 16
          },
          end: {
            line: 63,
            column: 70
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 63,
            column: 50
          },
          end: {
            line: 63,
            column: 63
          }
        }, {
          start: {
            line: 63,
            column: 66
          },
          end: {
            line: 63,
            column: 70
          }
        }],
        line: 63
      },
      "4": {
        loc: {
          start: {
            line: 181,
            column: 4
          },
          end: {
            line: 183,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 181,
            column: 4
          },
          end: {
            line: 183,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 181
      },
      "5": {
        loc: {
          start: {
            line: 187,
            column: 4
          },
          end: {
            line: 189,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 187,
            column: 4
          },
          end: {
            line: 189,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 187
      },
      "6": {
        loc: {
          start: {
            line: 187,
            column: 8
          },
          end: {
            line: 187,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 187,
            column: 8
          },
          end: {
            line: 187,
            column: 16
          }
        }, {
          start: {
            line: 187,
            column: 20
          },
          end: {
            line: 187,
            column: 29
          }
        }, {
          start: {
            line: 187,
            column: 33
          },
          end: {
            line: 187,
            column: 43
          }
        }, {
          start: {
            line: 187,
            column: 47
          },
          end: {
            line: 187,
            column: 56
          }
        }],
        line: 187
      },
      "7": {
        loc: {
          start: {
            line: 190,
            column: 4
          },
          end: {
            line: 209,
            column: 5
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 191,
            column: 6
          },
          end: {
            line: 194,
            column: 14
          }
        }, {
          start: {
            line: 195,
            column: 6
          },
          end: {
            line: 198,
            column: 14
          }
        }, {
          start: {
            line: 199,
            column: 6
          },
          end: {
            line: 202,
            column: 14
          }
        }, {
          start: {
            line: 203,
            column: 6
          },
          end: {
            line: 206,
            column: 14
          }
        }, {
          start: {
            line: 207,
            column: 6
          },
          end: {
            line: 208,
            column: 14
          }
        }],
        line: 190
      },
      "8": {
        loc: {
          start: {
            line: 215,
            column: 4
          },
          end: {
            line: 218,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 215,
            column: 4
          },
          end: {
            line: 218,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 215
      },
      "9": {
        loc: {
          start: {
            line: 217,
            column: 31
          },
          end: {
            line: 217,
            column: 66
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 217,
            column: 31
          },
          end: {
            line: 217,
            column: 50
          }
        }, {
          start: {
            line: 217,
            column: 54
          },
          end: {
            line: 217,
            column: 66
          }
        }],
        line: 217
      },
      "10": {
        loc: {
          start: {
            line: 223,
            column: 4
          },
          end: {
            line: 225,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 223,
            column: 4
          },
          end: {
            line: 225,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 223
      },
      "11": {
        loc: {
          start: {
            line: 223,
            column: 8
          },
          end: {
            line: 223,
            column: 88
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 223,
            column: 8
          },
          end: {
            line: 223,
            column: 24
          }
        }, {
          start: {
            line: 223,
            column: 28
          },
          end: {
            line: 223,
            column: 47
          }
        }, {
          start: {
            line: 223,
            column: 51
          },
          end: {
            line: 223,
            column: 88
          }
        }],
        line: 223
      },
      "12": {
        loc: {
          start: {
            line: 226,
            column: 4
          },
          end: {
            line: 226,
            column: 45
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 226,
            column: 4
          },
          end: {
            line: 226,
            column: 21
          }
        }, {
          start: {
            line: 226,
            column: 25
          },
          end: {
            line: 226,
            column: 45
          }
        }],
        line: 226
      },
      "13": {
        loc: {
          start: {
            line: 236,
            column: 6
          },
          end: {
            line: 237,
            column: 84
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 236,
            column: 6
          },
          end: {
            line: 236,
            column: 36
          }
        }, {
          start: {
            line: 237,
            column: 7
          },
          end: {
            line: 237,
            column: 23
          }
        }, {
          start: {
            line: 237,
            column: 27
          },
          end: {
            line: 237,
            column: 83
          }
        }],
        line: 236
      },
      "14": {
        loc: {
          start: {
            line: 238,
            column: 4
          },
          end: {
            line: 244,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 238,
            column: 4
          },
          end: {
            line: 244,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 238
      },
      "15": {
        loc: {
          start: {
            line: 239,
            column: 6
          },
          end: {
            line: 241,
            column: 49
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 239,
            column: 6
          },
          end: {
            line: 239,
            column: 22
          }
        }, {
          start: {
            line: 240,
            column: 7
          },
          end: {
            line: 240,
            column: 47
          }
        }, {
          start: {
            line: 240,
            column: 51
          },
          end: {
            line: 240,
            column: 69
          }
        }, {
          start: {
            line: 241,
            column: 6
          },
          end: {
            line: 241,
            column: 49
          }
        }],
        line: 239
      },
      "16": {
        loc: {
          start: {
            line: 273,
            column: 6
          },
          end: {
            line: 273,
            column: 88
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 273,
            column: 6
          },
          end: {
            line: 273,
            column: 11
          }
        }, {
          start: {
            line: 273,
            column: 16
          },
          end: {
            line: 273,
            column: 32
          }
        }, {
          start: {
            line: 273,
            column: 36
          },
          end: {
            line: 273,
            column: 43
          }
        }, {
          start: {
            line: 273,
            column: 49
          },
          end: {
            line: 273,
            column: 72
          }
        }, {
          start: {
            line: 273,
            column: 76
          },
          end: {
            line: 273,
            column: 87
          }
        }],
        line: 273
      },
      "17": {
        loc: {
          start: {
            line: 280,
            column: 15
          },
          end: {
            line: 280,
            column: 58
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 280,
            column: 43
          },
          end: {
            line: 280,
            column: 49
          }
        }, {
          start: {
            line: 280,
            column: 52
          },
          end: {
            line: 280,
            column: 58
          }
        }],
        line: 280
      },
      "18": {
        loc: {
          start: {
            line: 281,
            column: 22
          },
          end: {
            line: 281,
            column: 63
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 281,
            column: 22
          },
          end: {
            line: 281,
            column: 44
          }
        }, {
          start: {
            line: 281,
            column: 48
          },
          end: {
            line: 281,
            column: 63
          }
        }],
        line: 281
      },
      "19": {
        loc: {
          start: {
            line: 287,
            column: 9
          },
          end: {
            line: 330,
            column: 9
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 288,
            column: 10
          },
          end: {
            line: 308,
            column: 12
          }
        }, {
          start: {
            line: 310,
            column: 10
          },
          end: {
            line: 329,
            column: 20
          }
        }],
        line: 287
      },
      "20": {
        loc: {
          start: {
            line: 304,
            column: 25
          },
          end: {
            line: 304,
            column: 66
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 304,
            column: 25
          },
          end: {
            line: 304,
            column: 47
          }
        }, {
          start: {
            line: 304,
            column: 51
          },
          end: {
            line: 304,
            column: 66
          }
        }],
        line: 304
      },
      "21": {
        loc: {
          start: {
            line: 331,
            column: 9
          },
          end: {
            line: 331,
            column: 84
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 331,
            column: 9
          },
          end: {
            line: 331,
            column: 22
          }
        }, {
          start: {
            line: 331,
            column: 26
          },
          end: {
            line: 331,
            column: 38
          }
        }, {
          start: {
            line: 331,
            column: 42
          },
          end: {
            line: 331,
            column: 60
          }
        }, {
          start: {
            line: 331,
            column: 64
          },
          end: {
            line: 331,
            column: 84
          }
        }],
        line: 331
      },
      "22": {
        loc: {
          start: {
            line: 332,
            column: 9
          },
          end: {
            line: 332,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 332,
            column: 9
          },
          end: {
            line: 332,
            column: 21
          }
        }, {
          start: {
            line: 332,
            column: 25
          },
          end: {
            line: 332,
            column: 43
          }
        }],
        line: 332
      },
      "23": {
        loc: {
          start: {
            line: 367,
            column: 4
          },
          end: {
            line: 371,
            column: 9
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 368,
            column: 8
          },
          end: {
            line: 368,
            column: 32
          }
        }, {
          start: {
            line: 369,
            column: 8
          },
          end: {
            line: 371,
            column: 9
          }
        }],
        line: 367
      },
      "24": {
        loc: {
          start: {
            line: 369,
            column: 8
          },
          end: {
            line: 371,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 369,
            column: 8
          },
          end: {
            line: 369,
            column: 42
          }
        }, {
          start: {
            line: 370,
            column: 10
          },
          end: {
            line: 370,
            column: 70
          }
        }],
        line: 369
      },
      "25": {
        loc: {
          start: {
            line: 382,
            column: 19
          },
          end: {
            line: 382,
            column: 46
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 382,
            column: 36
          },
          end: {
            line: 382,
            column: 41
          }
        }, {
          start: {
            line: 382,
            column: 44
          },
          end: {
            line: 382,
            column: 46
          }
        }],
        line: 382
      },
      "26": {
        loc: {
          start: {
            line: 385,
            column: 4
          },
          end: {
            line: 389,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 385,
            column: 4
          },
          end: {
            line: 385,
            column: 29
          }
        }, {
          start: {
            line: 386,
            column: 6
          },
          end: {
            line: 389,
            column: 7
          }
        }],
        line: 385
      },
      "27": {
        loc: {
          start: {
            line: 387,
            column: 8
          },
          end: {
            line: 387,
            column: 88
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 387,
            column: 25
          },
          end: {
            line: 387,
            column: 76
          }
        }, {
          start: {
            line: 387,
            column: 79
          },
          end: {
            line: 387,
            column: 88
          }
        }],
        line: 387
      },
      "28": {
        loc: {
          start: {
            line: 387,
            column: 25
          },
          end: {
            line: 387,
            column: 76
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 387,
            column: 25
          },
          end: {
            line: 387,
            column: 52
          }
        }, {
          start: {
            line: 387,
            column: 56
          },
          end: {
            line: 387,
            column: 76
          }
        }],
        line: 387
      },
      "29": {
        loc: {
          start: {
            line: 394,
            column: 27
          },
          end: {
            line: 394,
            column: 67
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 394,
            column: 27
          },
          end: {
            line: 394,
            column: 46
          }
        }, {
          start: {
            line: 394,
            column: 50
          },
          end: {
            line: 394,
            column: 67
          }
        }],
        line: 394
      },
      "30": {
        loc: {
          start: {
            line: 397,
            column: 31
          },
          end: {
            line: 397,
            column: 87
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 397,
            column: 31
          },
          end: {
            line: 397,
            column: 58
          }
        }, {
          start: {
            line: 397,
            column: 62
          },
          end: {
            line: 397,
            column: 87
          }
        }],
        line: 397
      },
      "31": {
        loc: {
          start: {
            line: 398,
            column: 35
          },
          end: {
            line: 398,
            column: 93
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 398,
            column: 35
          },
          end: {
            line: 398,
            column: 63
          }
        }, {
          start: {
            line: 398,
            column: 67
          },
          end: {
            line: 398,
            column: 93
          }
        }],
        line: 398
      },
      "32": {
        loc: {
          start: {
            line: 400,
            column: 4
          },
          end: {
            line: 404,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 400,
            column: 4
          },
          end: {
            line: 404,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 400
      },
      "33": {
        loc: {
          start: {
            line: 400,
            column: 8
          },
          end: {
            line: 400,
            column: 72
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 400,
            column: 8
          },
          end: {
            line: 400,
            column: 26
          }
        }, {
          start: {
            line: 400,
            column: 31
          },
          end: {
            line: 400,
            column: 53
          }
        }, {
          start: {
            line: 400,
            column: 57
          },
          end: {
            line: 400,
            column: 71
          }
        }],
        line: 400
      },
      "34": {
        loc: {
          start: {
            line: 402,
            column: 26
          },
          end: {
            line: 402,
            column: 66
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 402,
            column: 54
          },
          end: {
            line: 402,
            column: 59
          }
        }, {
          start: {
            line: 402,
            column: 62
          },
          end: {
            line: 402,
            column: 66
          }
        }],
        line: 402
      },
      "35": {
        loc: {
          start: {
            line: 411,
            column: 4
          },
          end: {
            line: 411,
            column: 66
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 411,
            column: 4
          },
          end: {
            line: 411,
            column: 32
          }
        }, {
          start: {
            line: 411,
            column: 36
          },
          end: {
            line: 411,
            column: 66
          }
        }],
        line: 411
      },
      "36": {
        loc: {
          start: {
            line: 414,
            column: 26
          },
          end: {
            line: 414,
            column: 60
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 414,
            column: 56
          },
          end: {
            line: 414,
            column: 60
          }
        }],
        line: 414
      },
      "37": {
        loc: {
          start: {
            line: 419,
            column: 6
          },
          end: {
            line: 419,
            column: 88
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 419,
            column: 6
          },
          end: {
            line: 419,
            column: 12
          }
        }, {
          start: {
            line: 419,
            column: 16
          },
          end: {
            line: 419,
            column: 36
          }
        }, {
          start: {
            line: 419,
            column: 41
          },
          end: {
            line: 419,
            column: 87
          }
        }],
        line: 419
      },
      "38": {
        loc: {
          start: {
            line: 436,
            column: 4
          },
          end: {
            line: 436,
            column: 25
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 436,
            column: 4
          },
          end: {
            line: 436,
            column: 11
          }
        }, {
          start: {
            line: 436,
            column: 15
          },
          end: {
            line: 436,
            column: 25
          }
        }],
        line: 436
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0, 0, 0],
      "7": [0, 0, 0, 0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0, 0],
      "12": [0, 0],
      "13": [0, 0, 0],
      "14": [0, 0],
      "15": [0, 0, 0, 0],
      "16": [0, 0, 0, 0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0, 0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0],
      "37": [0, 0, 0],
      "38": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "8703f61bfa0d6b9884ce8fc986961d34d6a74079"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_19zj5rh3yq = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_19zj5rh3yq();
function AutocompleteInput_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AutocompleteInput_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AutocompleteInput_ownKeys(Object(t), !0).forEach(function (r) { AutocompleteInput_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AutocompleteInput_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }


























function AutocompleteInput_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function AutocompleteInput_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, AutocompleteInput_toPropertyKey(descriptor.key), descriptor); } }
function AutocompleteInput_createClass(Constructor, protoProps, staticProps) { if (protoProps) AutocompleteInput_defineProperties(Constructor.prototype, protoProps); if (staticProps) AutocompleteInput_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function AutocompleteInput_callSuper(t, o, e) { return o = AutocompleteInput_getPrototypeOf(o), AutocompleteInput_possibleConstructorReturn(t, AutocompleteInput_isNativeReflectConstruct() ? Reflect.construct(o, e || [], AutocompleteInput_getPrototypeOf(t).constructor) : o.apply(t, e)); }
function AutocompleteInput_possibleConstructorReturn(self, call) { if (call && (AutocompleteInput_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return AutocompleteInput_assertThisInitialized(self); }
function AutocompleteInput_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (AutocompleteInput_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function AutocompleteInput_getPrototypeOf(o) { AutocompleteInput_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return AutocompleteInput_getPrototypeOf(o); }
function AutocompleteInput_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function AutocompleteInput_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) AutocompleteInput_setPrototypeOf(subClass, superClass); }
function AutocompleteInput_setPrototypeOf(o, p) { AutocompleteInput_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return AutocompleteInput_setPrototypeOf(o, p); }
function AutocompleteInput_defineProperty(obj, key, value) { key = AutocompleteInput_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function AutocompleteInput_toPropertyKey(t) { var i = AutocompleteInput_toPrimitive(t, "string"); return "symbol" == AutocompleteInput_typeof(i) ? i : String(i); }
function AutocompleteInput_toPrimitive(t, r) { if ("object" != AutocompleteInput_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != AutocompleteInput_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function AutocompleteInput_extends() { AutocompleteInput_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return AutocompleteInput_extends.apply(this, arguments); }
function AutocompleteInput_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = AutocompleteInput_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function AutocompleteInput_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function AutocompleteInput_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
/** @jsx jsx */











var KEYS = (cov_19zj5rh3yq().s[0]++, {
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  enter: 13,
  esc: 27
});
var AutocompleteInputWrapper = (cov_19zj5rh3yq().s[1]++, (0,chakra_ui_system_esm/* forwardRef */.Gp)(function (_ref, ref) {
  var error = _ref.error,
    showCta = _ref.showCta,
    props = AutocompleteInput_objectWithoutProperties(_ref, AutocompleteInput_excluded);
  cov_19zj5rh3yq().f[0]++;
  cov_19zj5rh3yq().s[2]++;
  return (0,emotion_react_browser_esm/* jsx */.tZ)(Flex/* default */.Z, AutocompleteInput_extends({
    flexDirection: "column",
    position: "relative",
    ref: ref
  }, props));
}));
var ResultList = (cov_19zj5rh3yq().s[3]++, /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("ul",  true ? {
  target: "e1f034sk0"
} : 0)("margin:0;list-style:none;padding-left:0;position:absolute;box-sizing:border-box;width:100%;margin-top:-4px;bottom:", function (props) {
  cov_19zj5rh3yq().f[1]++;
  cov_19zj5rh3yq().s[4]++;
  return (cov_19zj5rh3yq().b[1][0]++, props.displayAbove) && (cov_19zj5rh3yq().b[1][1]++, props.wrapperHeight) ? (cov_19zj5rh3yq().b[0][0]++, props.wrapperHeight + 'px') : (cov_19zj5rh3yq().b[0][1]++, '');
}, ";text-align:left;background-color:#fff;border:1px solid ", colors/* default.neutrals10 */.ZP.neutrals10, ";border-bottom-left-radius:3px;border-bottom-right-radius:3px;border-top:none;z-index:", function (props) {
  cov_19zj5rh3yq().f[2]++;
  cov_19zj5rh3yq().s[5]++;
  return (cov_19zj5rh3yq().b[2][0]++, props.zIndex) || (cov_19zj5rh3yq().b[2][1]++, 2);
}, ";", function (props) {
  cov_19zj5rh3yq().f[3]++;
  cov_19zj5rh3yq().s[6]++;
  return props.designStyle === 'rounded' ? (cov_19zj5rh3yq().b[3][0]++, RoundedStyles) : (cov_19zj5rh3yq().b[3][1]++, null);
}, ";" + ( true ? "" : 0)));
var RoundedStyles = (cov_19zj5rh3yq().s[7]++,  true ? {
  name: "59siwz",
  styles: "transform-origin:center top!important;transform:scale(0.89)!important;border-bottom-left-radius:20px;border-bottom-right-radius:20px"
} : 0);
var AutocompleteInput = /*#__PURE__*/function (_React$PureComponent) {
  AutocompleteInput_inherits(AutocompleteInput, _React$PureComponent);
  function AutocompleteInput(props) {
    var _this;
    AutocompleteInput_classCallCheck(this, AutocompleteInput);
    cov_19zj5rh3yq().f[4]++;
    cov_19zj5rh3yq().s[9]++;
    _this = AutocompleteInput_callSuper(this, AutocompleteInput, [props]);

    // Use this ref to keep track of the height of the wrapper
    AutocompleteInput_defineProperty(AutocompleteInput_assertThisInitialized(_this), "wrapperRef", void 0);
    AutocompleteInput_defineProperty(AutocompleteInput_assertThisInitialized(_this), "state", (cov_19zj5rh3yq().s[11]++, {
      activeIndex: -1,
      dirty: false,
      hideOptions: true,
      invalidUserInput: false,
      isInputFocused: false,
      userInput: undefined,
      wrapperHeight: 0
    }));
    AutocompleteInput_defineProperty(AutocompleteInput_assertThisInitialized(_this), "onQueryChange", (cov_19zj5rh3yq().s[12]++, function (event) {
      cov_19zj5rh3yq().f[5]++;
      cov_19zj5rh3yq().s[13]++;
      _this.setState({
        dirty: true,
        hideOptions: false,
        userInput: event.target.value,
        invalidUserInput: false
      });
      cov_19zj5rh3yq().s[14]++;
      _this.props.onInputChange(event.target.value, false);

      //hide options dropdown when we have no query
      cov_19zj5rh3yq().s[15]++;
      if (!event.target.value) {
        cov_19zj5rh3yq().b[4][0]++;
        cov_19zj5rh3yq().s[16]++;
        _this.hideOptions();
      } else {
        cov_19zj5rh3yq().b[4][1]++;
      }
    }));
    AutocompleteInput_defineProperty(AutocompleteInput_assertThisInitialized(_this), "onKeyDown", (cov_19zj5rh3yq().s[17]++, function (e) {
      cov_19zj5rh3yq().f[6]++;
      cov_19zj5rh3yq().s[18]++;
      if ((cov_19zj5rh3yq().b[6][0]++, e.altKey) || (cov_19zj5rh3yq().b[6][1]++, e.ctrlKey) || (cov_19zj5rh3yq().b[6][2]++, e.shiftKey) || (cov_19zj5rh3yq().b[6][3]++, e.metaKey)) {
        cov_19zj5rh3yq().b[5][0]++;
        cov_19zj5rh3yq().s[19]++;
        return;
      } else {
        cov_19zj5rh3yq().b[5][1]++;
      }
      cov_19zj5rh3yq().s[20]++;
      switch (e.keyCode) {
        case KEYS.down:
          cov_19zj5rh3yq().b[7][0]++;
          cov_19zj5rh3yq().s[21]++;
          e.preventDefault();
          cov_19zj5rh3yq().s[22]++;
          _this.makeActiveIndex(_this.state.activeIndex + 1);
          cov_19zj5rh3yq().s[23]++;
          break;
        case KEYS.up:
          cov_19zj5rh3yq().b[7][1]++;
          cov_19zj5rh3yq().s[24]++;
          e.preventDefault();
          cov_19zj5rh3yq().s[25]++;
          _this.makeActiveIndex(_this.state.activeIndex - 1);
          cov_19zj5rh3yq().s[26]++;
          break;
        case KEYS.esc:
          cov_19zj5rh3yq().b[7][2]++;
          cov_19zj5rh3yq().s[27]++;
          e.preventDefault();
          cov_19zj5rh3yq().s[28]++;
          _this.hideOptions();
          cov_19zj5rh3yq().s[29]++;
          break;
        case KEYS.enter:
          cov_19zj5rh3yq().b[7][3]++;
          cov_19zj5rh3yq().s[30]++;
          e.preventDefault();
          cov_19zj5rh3yq().s[31]++;
          _this.selectOption();
          cov_19zj5rh3yq().s[32]++;
          break;
        default:
          cov_19zj5rh3yq().b[7][4]++;
          cov_19zj5rh3yq().s[33]++;
          break;
      }
    }));
    AutocompleteInput_defineProperty(AutocompleteInput_assertThisInitialized(_this), "onOptionClick", (cov_19zj5rh3yq().s[34]++, function (option) {
      cov_19zj5rh3yq().f[7]++;
      cov_19zj5rh3yq().s[35]++;
      _this.selectOption(option);
      cov_19zj5rh3yq().s[36]++;
      if (_this.props.shouldReplaceInputOnSelect) {
        cov_19zj5rh3yq().b[8][0]++;
        cov_19zj5rh3yq().s[37]++;
        _this.setState({
          dirty: false,
          invalidUserInput: false
        });
        cov_19zj5rh3yq().s[38]++;
        _this.props.onInputChange((cov_19zj5rh3yq().b[9][0]++, option.displayValue) || (cov_19zj5rh3yq().b[9][1]++, option.value), true);
      } else {
        cov_19zj5rh3yq().b[8][1]++;
      }
    }));
    AutocompleteInput_defineProperty(AutocompleteInput_assertThisInitialized(_this), "onBlur", (cov_19zj5rh3yq().s[39]++, function (e) {
      cov_19zj5rh3yq().f[8]++;
      cov_19zj5rh3yq().s[40]++;
      _this.hideOptions();
      cov_19zj5rh3yq().s[41]++;
      if ((cov_19zj5rh3yq().b[11][0]++, _this.state.dirty) && (cov_19zj5rh3yq().b[11][1]++, !_this.props.showCta) && (cov_19zj5rh3yq().b[11][2]++, _this.props.shouldReplaceInputOnSelect)) {
        cov_19zj5rh3yq().b[10][0]++;
        cov_19zj5rh3yq().s[42]++;
        _this.selectOption();
      } else {
        cov_19zj5rh3yq().b[10][1]++;
      }
      cov_19zj5rh3yq().s[43]++;
      (cov_19zj5rh3yq().b[12][0]++, _this.props.onBlur) && (cov_19zj5rh3yq().b[12][1]++, _this.props.onBlur(e));
      cov_19zj5rh3yq().s[44]++;
      _this.setState({
        isInputFocused: false
      });
    }));
    AutocompleteInput_defineProperty(AutocompleteInput_assertThisInitialized(_this), "renderOptions", (cov_19zj5rh3yq().s[54]++, function () {
      cov_19zj5rh3yq().f[13]++;
      var _ref2 = (cov_19zj5rh3yq().s[55]++, _this.props),
        inputProps = _ref2.inputProps,
        options = _ref2.options,
        optionsDisplayProps = _ref2.optionsDisplayProps;
      var _ref3 = (cov_19zj5rh3yq().s[56]++, _this.state),
        activeIndex = _ref3.activeIndex;
      cov_19zj5rh3yq().s[57]++;
      return (0,emotion_react_browser_esm/* jsx */.tZ)(Box/* default */.Z, null, (0,emotion_react_browser_esm/* jsx */.tZ)(ResultList, {
        id: "autocomplete-options",
        designStyle: inputProps.designStyle,
        zIndex: optionsDisplayProps === null || optionsDisplayProps === void 0 ? void 0 : optionsDisplayProps.zIndex,
        displayAbove: optionsDisplayProps === null || optionsDisplayProps === void 0 ? void 0 : optionsDisplayProps.displayAbove,
        className: "autocomplete-options result-list",
        role: "listbox",
        wrapperHeight: _this.state.wrapperHeight
      }, options.map(function (option, index) {
        cov_19zj5rh3yq().f[14]++;
        cov_19zj5rh3yq().s[58]++;
        return (0,emotion_react_browser_esm/* jsx */.tZ)(AutocompleteOption, {
          option: option,
          key: index,
          selected: index === activeIndex,
          onClick: _this.onOptionClick
        });
      })));
    }));
    AutocompleteInput_defineProperty(AutocompleteInput_assertThisInitialized(_this), "renderError", (cov_19zj5rh3yq().s[59]++, function () {
      cov_19zj5rh3yq().f[15]++;
      cov_19zj5rh3yq().s[60]++;
      return _this.props.renderError ? (cov_19zj5rh3yq().b[23][0]++, _this.props.renderError()) : (cov_19zj5rh3yq().b[23][1]++, (cov_19zj5rh3yq().b[24][0]++, _this.props.invalidUserInputMessage) && (cov_19zj5rh3yq().b[24][1]++, (0,emotion_react_browser_esm/* jsx */.tZ)(ErrorPrompt_ErrorPrompt, {
        message: _this.props.invalidUserInputMessage
      })));
    }));
    AutocompleteInput_defineProperty(AutocompleteInput_assertThisInitialized(_this), "makeActiveIndex", (cov_19zj5rh3yq().s[61]++, function (index) {
      cov_19zj5rh3yq().f[16]++;
      var _ref4 = (cov_19zj5rh3yq().s[62]++, _this.props),
        options = _ref4.options,
        onInputChange = _ref4.onInputChange,
        shouldReplaceInputOnClick = _ref4.shouldReplaceInputOnSelect;
      var _ref5 = (cov_19zj5rh3yq().s[63]++, _this.state),
        userInput = _ref5.userInput;
      var selectedOption = (cov_19zj5rh3yq().s[64]++, options[index]);
      cov_19zj5rh3yq().s[65]++;
      _this.setState({
        activeIndex: selectedOption ? (cov_19zj5rh3yq().b[25][0]++, index) : (cov_19zj5rh3yq().b[25][1]++, -1)
      });
      cov_19zj5rh3yq().s[66]++;
      (cov_19zj5rh3yq().b[26][0]++, shouldReplaceInputOnClick) && (cov_19zj5rh3yq().b[26][1]++, onInputChange(selectedOption ? (cov_19zj5rh3yq().b[27][0]++, (cov_19zj5rh3yq().b[28][0]++, selectedOption.displayValue) || (cov_19zj5rh3yq().b[28][1]++, selectedOption.value)) : (cov_19zj5rh3yq().b[27][1]++, userInput), true));
    }));
    AutocompleteInput_defineProperty(AutocompleteInput_assertThisInitialized(_this), "handleClick", (cov_19zj5rh3yq().s[72]++, function (e) {
      cov_19zj5rh3yq().f[18]++;
      cov_19zj5rh3yq().s[73]++;
      _this.setState({
        dirty: false
      });
      cov_19zj5rh3yq().s[74]++;
      _this.validateInput();
      cov_19zj5rh3yq().s[75]++;
      _this.hideOptions();
      cov_19zj5rh3yq().s[76]++;
      (cov_19zj5rh3yq().b[35][0]++, !_this.state.invalidUserInput) && (cov_19zj5rh3yq().b[35][1]++, _this.props.ctaProps.onClick(e));
    }));
    AutocompleteInput_defineProperty(AutocompleteInput_assertThisInitialized(_this), "selectOption", (cov_19zj5rh3yq().s[77]++, function () {
      var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_19zj5rh3yq().b[36][0]++, null);
      cov_19zj5rh3yq().f[19]++;
      var _ref6 = (cov_19zj5rh3yq().s[78]++, _this.props),
        options = _ref6.options,
        select = _ref6.select,
        input = _ref6.input;
      var _ref7 = (cov_19zj5rh3yq().s[79]++, _this.state),
        activeIndex = _ref7.activeIndex;
      cov_19zj5rh3yq().s[80]++;
      select((cov_19zj5rh3yq().b[37][0]++, option) || (cov_19zj5rh3yq().b[37][1]++, options[activeIndex]) || (cov_19zj5rh3yq().b[37][2]++, {
        displayValue: input
      }), activeIndex);
      cov_19zj5rh3yq().s[81]++;
      _this.setState({
        dirty: false
      });
      cov_19zj5rh3yq().s[82]++;
      _this.hideOptions();
    }));
    AutocompleteInput_defineProperty(AutocompleteInput_assertThisInitialized(_this), "hideOptions", (cov_19zj5rh3yq().s[83]++, function () {
      cov_19zj5rh3yq().f[20]++;
      cov_19zj5rh3yq().s[84]++;
      _this.setState({
        activeIndex: -1,
        hideOptions: true
      });
    }));
    AutocompleteInput_defineProperty(AutocompleteInput_assertThisInitialized(_this), "onFocus", (cov_19zj5rh3yq().s[85]++, function (e) {
      cov_19zj5rh3yq().f[21]++;
      var _ref8 = (cov_19zj5rh3yq().s[86]++, _this.props),
        onFocus = _ref8.onFocus,
        options = _ref8.options;
      cov_19zj5rh3yq().s[87]++;
      _this.setState({
        isInputFocused: true,
        hideOptions: options.length === 0
      });
      cov_19zj5rh3yq().s[88]++;
      (cov_19zj5rh3yq().b[38][0]++, onFocus) && (cov_19zj5rh3yq().b[38][1]++, onFocus(e));
    }));
    cov_19zj5rh3yq().s[10]++;
    _this.wrapperRef = /*#__PURE__*/(0,react.createRef)();
    return _this;
  }
  AutocompleteInput_createClass(AutocompleteInput, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      cov_19zj5rh3yq().f[9]++;
      // Don't want to trigger a re-render if props have not changed
      // However, there is an exception when the first query that the user enters
      // also results in a empty list
      // if validationThreshold reached or no validationThreshold
      var noValidationThresholdOrGreaterThanThreshold = (cov_19zj5rh3yq().s[45]++, (cov_19zj5rh3yq().b[13][0]++, !prevProps.validationThreshold) || (cov_19zj5rh3yq().b[13][1]++, this.props.input) && (cov_19zj5rh3yq().b[13][2]++, this.props.input.length >= prevProps.validationThreshold));
      cov_19zj5rh3yq().s[46]++;
      if ((cov_19zj5rh3yq().b[15][0]++, this.props.input) && ((cov_19zj5rh3yq().b[15][1]++, !this.props.fetchOptionsStatus.isLoading) || (cov_19zj5rh3yq().b[15][2]++, this.props.showCta)) && (cov_19zj5rh3yq().b[15][3]++, noValidationThresholdOrGreaterThanThreshold)) {
        cov_19zj5rh3yq().b[14][0]++;
        cov_19zj5rh3yq().s[47]++;
        this.validateInput();
      } else {
        cov_19zj5rh3yq().b[14][1]++;
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      cov_19zj5rh3yq().f[10]++;
      cov_19zj5rh3yq().s[48]++;
      // set the height of the wrapper on component mount
      // This height is primarily when we want to display results above
      // The + 5 is to add some gap between the input and the result box
      this.setState({
        wrapperHeight: this.wrapperRef.current.clientHeight + 5
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _ref11,
        _this2 = this,
        _ref12,
        _options$this$state$a,
        _options$this$state$a2;
      cov_19zj5rh3yq().f[11]++;
      var _ref9 = (cov_19zj5rh3yq().s[49]++, this.props),
        ariaLabel = _ref9.ariaLabel,
        ariaLabelledby = _ref9.ariaLabelledby,
        analyticsName = _ref9.analyticsName,
        name = _ref9.name,
        inputProps = _ref9.inputProps,
        ctaProps = _ref9.ctaProps,
        showCta = _ref9.showCta,
        input = _ref9.input,
        invalidUserInputMessage = _ref9.invalidUserInputMessage,
        options = _ref9.options,
        placeholderText = _ref9.placeholderText,
        renderError = _ref9.renderError,
        failure = _ref9.failure;
      var _ref10 = (cov_19zj5rh3yq().s[50]++, this.state),
        hideOptions = _ref10.hideOptions,
        invalidUserInput = _ref10.invalidUserInput;
      var showErrorMsg = (cov_19zj5rh3yq().s[51]++, Boolean((cov_19zj5rh3yq().b[16][0]++, input) && ((cov_19zj5rh3yq().b[16][1]++, invalidUserInput) || (cov_19zj5rh3yq().b[16][2]++, failure)) && ((cov_19zj5rh3yq().b[16][3]++, invalidUserInputMessage) || (cov_19zj5rh3yq().b[16][4]++, renderError))));
      cov_19zj5rh3yq().s[52]++;
      return (0,emotion_react_browser_esm/* jsx */.tZ)(AutocompleteInputWrapper, {
        error: showErrorMsg,
        showCta: showCta,
        width: inputProps.unboundedWidth ? (cov_19zj5rh3yq().b[17][0]++, '100%') : (cov_19zj5rh3yq().b[17][1]++, 'auto'),
        borderRadius: (_ref11 = (cov_19zj5rh3yq().b[18][0]++, inputProps.designStyle)) !== null && _ref11 !== void 0 ? _ref11 : (cov_19zj5rh3yq().b[18][1]++, 'roundedSquare'),
        ref: this.wrapperRef
      }, (0,emotion_react_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
        as: "span",
        sx: ScreenReaderOnly/* screenReaderOnly */.i,
        "aria-live": "assertive"
      }, options.length), showCta ? (cov_19zj5rh3yq().b[19][0]++, (0,emotion_react_browser_esm/* jsx */.tZ)(CtaInputLite, AutocompleteInput_extends({
        analyticsName: analyticsName,
        ariaLabel: ariaLabel,
        ariaLabelledby: ariaLabelledby,
        inputType: "text",
        value: input,
        onBlur: this.onBlur,
        onFocus: this.onFocus,
        onChange: this.onQueryChange,
        onKeyDown: this.onKeyDown,
        placeholderText: placeholderText,
        onSubmit: function onSubmit() {
          cov_19zj5rh3yq().f[12]++;
          cov_19zj5rh3yq().s[53]++;
          return _this2.selectOption();
        },
        failure: showErrorMsg,
        unboundedWidth: showCta // can be overridden by inputProps
        ,
        autoComplete: "off",
        ctaProps: AutocompleteInput_objectSpread(AutocompleteInput_objectSpread({}, ctaProps), {}, {
          onClick: this.handleClick
        }),
        designStyle: (_ref12 = (cov_19zj5rh3yq().b[20][0]++, inputProps.designStyle)) !== null && _ref12 !== void 0 ? _ref12 : (cov_19zj5rh3yq().b[20][1]++, 'roundedSquare'),
        "aria-expanded": options.length > 0,
        "aria-activedescendant": "".concat((_options$this$state$a = options[this.state.activeIndex]) === null || _options$this$state$a === void 0 ? void 0 : _options$this$state$a.value, "-option")
      }, inputProps))) : (cov_19zj5rh3yq().b[19][1]++, (0,emotion_react_browser_esm/* jsx */.tZ)(Wrapper, AutocompleteInput_extends({
        className: "od-autocomplete-wrapper"
      }, inputProps, {
        failure: showErrorMsg
      }), (0,emotion_react_browser_esm/* jsx */.tZ)(InputWrapper, null, (0,emotion_react_browser_esm/* jsx */.tZ)(Input_InputBase, AutocompleteInput_extends({
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledby,
        name: name,
        type: "text",
        value: input,
        onBlur: this.onBlur,
        onFocus: this.onFocus,
        onChange: this.onQueryChange,
        onKeyDown: this.onKeyDown,
        unboundedWidth: showCta // can be overridden by inputProps
        ,
        autoComplete: "off",
        "aria-expanded": options.length > 0,
        "aria-activedescendant": "".concat((_options$this$state$a2 = options[this.state.activeIndex]) === null || _options$this$state$a2 === void 0 ? void 0 : _options$this$state$a2.value, "-option")
      }, inputProps))))), (cov_19zj5rh3yq().b[21][0]++, !showErrorMsg) && (cov_19zj5rh3yq().b[21][1]++, !hideOptions) && (cov_19zj5rh3yq().b[21][2]++, options.length > 0) && (cov_19zj5rh3yq().b[21][3]++, this.renderOptions()), (cov_19zj5rh3yq().b[22][0]++, showErrorMsg) && (cov_19zj5rh3yq().b[22][1]++, this.renderError()));
    }
  }, {
    key: "validateInput",
    value: function validateInput() {
      cov_19zj5rh3yq().f[17]++;
      // Always validate for autompletion without a CTA button OR if the input has been submitted
      var shouldValidate = (cov_19zj5rh3yq().s[67]++, (cov_19zj5rh3yq().b[29][0]++, !this.props.showCta) || (cov_19zj5rh3yq().b[29][1]++, !this.state.dirty));

      // validate input once user starts typing
      var isInvalidAndTyping = (cov_19zj5rh3yq().s[68]++, (cov_19zj5rh3yq().b[30][0]++, this.state.invalidUserInput) && (cov_19zj5rh3yq().b[30][1]++, this.props.options.length));
      var isNotInvalidAndDeleted = (cov_19zj5rh3yq().s[69]++, (cov_19zj5rh3yq().b[31][0]++, !this.state.invalidUserInput) && (cov_19zj5rh3yq().b[31][1]++, !this.props.options.length));
      cov_19zj5rh3yq().s[70]++;
      if ((cov_19zj5rh3yq().b[33][0]++, isInvalidAndTyping) || (cov_19zj5rh3yq().b[33][1]++, isNotInvalidAndDeleted) && (cov_19zj5rh3yq().b[33][2]++, shouldValidate)) {
        cov_19zj5rh3yq().b[32][0]++;
        cov_19zj5rh3yq().s[71]++;
        this.setState({
          invalidUserInput: this.props.options.length ? (cov_19zj5rh3yq().b[34][0]++, false) : (cov_19zj5rh3yq().b[34][1]++, true)
        });
      } else {
        cov_19zj5rh3yq().b[32][1]++;
      }
    }
  }]);
  return AutocompleteInput;
}((react.PureComponent));
AutocompleteInput_defineProperty(AutocompleteInput, "defaultProps", (cov_19zj5rh3yq().s[8]++, {
  input: '',
  invalidUserInputMessage: '',
  name: 'AutocompleteInput',
  placeholderText: 'Start typing...',
  showCta: false,
  shouldReplaceInputOnSelect: true,
  fetchOptionsStatus: {
    isLoading: false
  },
  inputProps: {
    designStyle: 'roundedSquare',
    paddingLevel: 'medium',
    showBorder: true,
    showShadow: false,
    unboundedWidth: true,
    role: 'combobox',
    'aria-autocomplete': 'list',
    'aria-controls': 'autocomplete-options',
    'aria-haspopup': 'listbox',
    'aria-expanded': false
  }
}));


/***/ }),

/***/ 94339:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ ReactDatesStyles; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70917);
function cov_29j5m5gjfb() {
  var path = "/__w/code/code/js/packages/bricks/src/complex/DatePicker/ReactDatesStyles.tsx";
  var hash = "c7519e335d1e1ab498bcc461345a1e8d09635ceb";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/complex/DatePicker/ReactDatesStyles.tsx",
    statementMap: {
      "0": {
        start: {
          line: 8,
          column: 32
        },
        end: {
          line: 899,
          column: 1
        }
      },
      "1": {
        start: {
          line: 9,
          column: 2
        },
        end: {
          line: 898,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 8,
            column: 32
          },
          end: {
            line: 8,
            column: 33
          }
        },
        loc: {
          start: {
            line: 9,
            column: 2
          },
          end: {
            line: 898,
            column: 4
          }
        },
        line: 9
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {
      "0": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "c7519e335d1e1ab498bcc461345a1e8d09635ceb"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_29j5m5gjfb = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_29j5m5gjfb();
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



/**
 * Global styles for React Dates to enable use without webpack loaders https://github.com/react-dates/react-dates?tab=readme-ov-file#without-webpack
 */
cov_29j5m5gjfb().s[0]++;
var _ref =  true ? {
  name: "f0gvhf",
  styles: ".PresetDateRangePicker_panel{padding:0 22px 11px;}.PresetDateRangePicker_button{position:relative;height:100%;text-align:center;background:0 0;border:2px solid #00a699;color:#00a699;padding:4px 12px;margin-right:8px;font:inherit;font-weight:700;line-height:normal;overflow:visible;-moz-box-sizing:border-box;box-sizing:border-box;cursor:pointer;}.PresetDateRangePicker_button:active{outline:0;}.PresetDateRangePicker_button__selected{color:#fff;background:#00a699;}.SingleDatePickerInput{display:inline-block;background-color:#fff;}.SingleDatePickerInput__withBorder{border-radius:2px;border:1px solid #dbdbdb;}.SingleDatePickerInput__rtl{direction:rtl;}.SingleDatePickerInput__disabled{background-color:#f2f2f2;}.SingleDatePickerInput__block{display:block;}.SingleDatePickerInput__showClearDate{padding-right:30px;}.SingleDatePickerInput_clearDate{background:0 0;border:0;color:inherit;font:inherit;line-height:normal;overflow:visible;cursor:pointer;padding:10px;margin:0 10px 0 5px;position:absolute;right:0;top:50%;-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);}.SingleDatePickerInput_clearDate__default:focus,.SingleDatePickerInput_clearDate__default:hover{background:#dbdbdb;border-radius:50%;}.SingleDatePickerInput_clearDate__small{padding:6px;}.SingleDatePickerInput_clearDate__hide{visibility:hidden;}.SingleDatePickerInput_clearDate_svg{fill:#82888a;height:12px;width:15px;vertical-align:middle;}.SingleDatePickerInput_clearDate_svg__small{height:9px;}.SingleDatePickerInput_calendarIcon{background:0 0;border:0;color:inherit;font:inherit;line-height:normal;overflow:visible;cursor:pointer;display:inline-block;vertical-align:middle;padding:10px;margin:0 5px 0 10px;}.SingleDatePickerInput_calendarIcon_svg{fill:#82888a;height:15px;width:14px;vertical-align:middle;}.SingleDatePicker{position:relative;display:inline-block;}.SingleDatePicker__block{display:block;}.SingleDatePicker_picker{z-index:1;background-color:#fff;position:absolute;}.SingleDatePicker_picker__rtl{direction:rtl;}.SingleDatePicker_picker__directionLeft{left:0;}.SingleDatePicker_picker__directionRight{right:0;}.SingleDatePicker_picker__portal{background-color:rgba(0, 0, 0, 0.3);position:fixed;top:0;left:0;height:100%;width:100%;}.SingleDatePicker_picker__fullScreenPortal{background-color:#fff;}.SingleDatePicker_closeButton{background:0 0;border:0;color:inherit;font:inherit;line-height:normal;overflow:visible;cursor:pointer;position:absolute;top:0;right:0;padding:15px;z-index:2;}.SingleDatePicker_closeButton:focus,.SingleDatePicker_closeButton:hover{color:darken(#cacccd, 10%);text-decoration:none;}.SingleDatePicker_closeButton_svg{height:15px;width:15px;fill:#cacccd;}.DayPickerKeyboardShortcuts_buttonReset{background:0 0;border:0;border-radius:0;color:inherit;font:inherit;line-height:normal;overflow:visible;padding:0;cursor:pointer;font-size:14px;}.DayPickerKeyboardShortcuts_buttonReset:active{outline:0;}.DayPickerKeyboardShortcuts_show{width:33px;height:26px;position:absolute;z-index:2;}.DayPickerKeyboardShortcuts_show::before{content:'';display:block;position:absolute;}.DayPickerKeyboardShortcuts_show__bottomRight{bottom:0;right:0;}.DayPickerKeyboardShortcuts_show__bottomRight::before{border-top:26px solid transparent;border-right:33px solid #00a699;bottom:0;right:0;}.DayPickerKeyboardShortcuts_show__bottomRight:hover::before{border-right:33px solid #008489;}.DayPickerKeyboardShortcuts_show__topRight{top:0;right:0;}.DayPickerKeyboardShortcuts_show__topRight::before{border-bottom:26px solid transparent;border-right:33px solid #00a699;top:0;right:0;}.DayPickerKeyboardShortcuts_show__topRight:hover::before{border-right:33px solid #008489;}.DayPickerKeyboardShortcuts_show__topLeft{top:0;left:0;}.DayPickerKeyboardShortcuts_show__topLeft::before{border-bottom:26px solid transparent;border-left:33px solid #00a699;top:0;left:0;}.DayPickerKeyboardShortcuts_show__topLeft:hover::before{border-left:33px solid #008489;}.DayPickerKeyboardShortcuts_showSpan{color:#fff;position:absolute;}.DayPickerKeyboardShortcuts_showSpan__bottomRight{bottom:0;right:5px;}.DayPickerKeyboardShortcuts_showSpan__topRight{top:1px;right:5px;}.DayPickerKeyboardShortcuts_showSpan__topLeft{top:1px;left:5px;}.DayPickerKeyboardShortcuts_panel{overflow:auto;background:#fff;border:1px solid #dbdbdb;border-radius:2px;position:absolute;top:0;bottom:0;right:0;left:0;z-index:2;padding:22px;margin:33px;text-align:left;}.DayPickerKeyboardShortcuts_title{font-size:16px;font-weight:700;margin:0;}.DayPickerKeyboardShortcuts_list{list-style:none;padding:0;font-size:14px;}.DayPickerKeyboardShortcuts_close{position:absolute;right:22px;top:22px;z-index:2;}.DayPickerKeyboardShortcuts_close:active{outline:0;}.DayPickerKeyboardShortcuts_closeSvg{height:15px;width:15px;fill:#cacccd;}.DayPickerKeyboardShortcuts_closeSvg:focus,.DayPickerKeyboardShortcuts_closeSvg:hover{fill:#82888a;}.CalendarDay{-moz-box-sizing:border-box;box-sizing:border-box;cursor:pointer;font-size:14px;text-align:center;}.CalendarDay:active{outline:0;}.CalendarDay__defaultCursor{cursor:default;}.CalendarDay__default{border:1px solid #e4e7e7;color:#484848;background:#fff;}.CalendarDay__default:hover{background:#e4e7e7;border:1px solid #e4e7e7;color:inherit;}.CalendarDay__hovered_offset{background:#f4f5f5;border:1px double #e4e7e7;color:inherit;}.CalendarDay__outside{border:0;background:#fff;color:#484848;}.CalendarDay__outside:hover{border:0;}.CalendarDay__blocked_minimum_nights{background:#fff;border:1px solid #eceeee;color:#cacccd;}.CalendarDay__blocked_minimum_nights:active,.CalendarDay__blocked_minimum_nights:hover{background:#fff;color:#cacccd;}.CalendarDay__highlighted_calendar{background:#ffe8bc;color:#484848;}.CalendarDay__highlighted_calendar:active,.CalendarDay__highlighted_calendar:hover{background:#ffce71;color:#484848;}.CalendarDay__selected_span{background:#66e2da;border:1px double #33dacd;color:#fff;}.CalendarDay__selected_span:active,.CalendarDay__selected_span:hover{background:#33dacd;border:1px double #33dacd;color:#fff;}.CalendarDay__selected,.CalendarDay__selected:active,.CalendarDay__selected:hover{background:#00a699;border:1px double #00a699;color:#fff;}.CalendarDay__hovered_span,.CalendarDay__hovered_span:hover{background:#b2f1ec;border:1px double #80e8e0;color:#007a87;}.CalendarDay__hovered_span:active{background:#80e8e0;border:1px double #80e8e0;color:#007a87;}.CalendarDay__blocked_calendar,.CalendarDay__blocked_calendar:active,.CalendarDay__blocked_calendar:hover{background:#cacccd;border:1px solid #cacccd;color:#82888a;}.CalendarDay__blocked_out_of_range,.CalendarDay__blocked_out_of_range:active,.CalendarDay__blocked_out_of_range:hover{background:#fff;border:1px solid #e4e7e7;color:#cacccd;}.CalendarDay__hovered_start_first_possible_end{background:#eceeee;border:1px double #eceeee;}.CalendarDay__hovered_start_blocked_min_nights{background:#eceeee;border:1px double #e4e7e7;}.CalendarMonth{background:#fff;text-align:center;vertical-align:top;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;}.CalendarMonth_table{border-collapse:collapse;border-spacing:0;}.CalendarMonth_verticalSpacing{border-collapse:separate;}.CalendarMonth_caption{color:#484848;font-size:18px;text-align:center;padding-top:22px;padding-bottom:37px;caption-side:initial;}.CalendarMonth_caption__verticalScrollable{padding-top:12px;padding-bottom:7px;}.CalendarMonthGrid{background:#fff;text-align:left;z-index:0;}.CalendarMonthGrid__animating{z-index:1;}.CalendarMonthGrid__horizontal{position:absolute;left:9px;}.CalendarMonthGrid__vertical,.CalendarMonthGrid__vertical_scrollable{margin:0 auto;}.CalendarMonthGrid_month__horizontal{display:inline-block;vertical-align:top;min-height:100%;}.CalendarMonthGrid_month__hideForAnimation{position:absolute;z-index:-1;opacity:0;pointer-events:none;}.CalendarMonthGrid_month__hidden{visibility:hidden;}.DayPickerNavigation{position:relative;z-index:2;}.DayPickerNavigation__horizontal{height:0;}.DayPickerNavigation__verticalScrollable_prevNav{z-index:1;}.DayPickerNavigation__verticalDefault{position:absolute;width:100%;height:52px;bottom:0;left:0;}.DayPickerNavigation__verticalScrollableDefault{position:relative;}.DayPickerNavigation__bottom{height:auto;}.DayPickerNavigation__bottomDefault{-webkit-box-pack:justify;-ms-flex-pack:justify;display:-webkit-box;display:-moz-box;display:-ms-flexbox;display:-webkit-flex;display:flex;-webkit-justify-content:space-between;justify-content:space-between;}.DayPickerNavigation_button{cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;border:0;padding:0;margin:0;}.DayPickerNavigation_button__default{border:1px solid #e4e7e7;background-color:#fff;color:#757575;}.DayPickerNavigation_button__default:focus,.DayPickerNavigation_button__default:hover{border:1px solid #c4c4c4;}.DayPickerNavigation_button__default:active{background:#f2f2f2;}.DayPickerNavigation_button__disabled{cursor:default;border:1px solid #f2f2f2;}.DayPickerNavigation_button__disabled:focus,.DayPickerNavigation_button__disabled:hover{border:1px solid #f2f2f2;}.DayPickerNavigation_button__disabled:active{background:0 0;}.DayPickerNavigation_button__horizontalDefault{position:absolute;top:18px;line-height:0.78;border-radius:3px;padding:6px 9px;}.DayPickerNavigation_bottomButton__horizontalDefault{position:static;margin:-10px 22px 30px;}.DayPickerNavigation_leftButton__horizontalDefault{left:22px;}.DayPickerNavigation_rightButton__horizontalDefault{right:22px;}.DayPickerNavigation_button__verticalDefault{padding:5px;background:#fff;box-shadow:0 0 5px 2px rgba(0, 0, 0, 0.1);position:relative;display:inline-block;text-align:center;height:100%;width:50%;}.DayPickerNavigation_nextButton__verticalDefault{border-left:0;}.DayPickerNavigation_nextButton__verticalScrollableDefault,.DayPickerNavigation_prevButton__verticalScrollableDefault{width:100%;}.DayPickerNavigation_svg__horizontal{height:19px;width:19px;fill:#82888a;display:block;}.DayPickerNavigation_svg__vertical{height:42px;width:42px;fill:#484848;}.DayPickerNavigation_svg__disabled{fill:#f2f2f2;}.DayPicker{background:#fff;position:relative;text-align:left;}.DayPicker__horizontal{background:#fff;}.DayPicker__verticalScrollable{height:100%;}.DayPicker__hidden{visibility:hidden;}.DayPicker__withBorder{box-shadow:0 2px 6px rgba(0, 0, 0, 0.05),0 0 0 1px rgba(0, 0, 0, 0.07);border-radius:3px;}.DayPicker_portal__horizontal{box-shadow:none;position:absolute;left:50%;top:50%;}.DayPicker_portal__vertical{position:initial;}.DayPicker_focusRegion{outline:0;}.DayPicker_calendarInfo__horizontal,.DayPicker_wrapper__horizontal{display:inline-block;vertical-align:top;}.DayPicker_weekHeaders{position:relative;}.DayPicker_weekHeaders__horizontal{margin-left:9px;}.DayPicker_weekHeader{color:#757575;position:absolute;top:62px;z-index:2;text-align:left;}.DayPicker_weekHeader__vertical{left:50%;}.DayPicker_weekHeader__verticalScrollable{top:0;display:table-row;border-bottom:1px solid #dbdbdb;background:#fff;margin-left:0;left:0;width:100%;text-align:center;}.DayPicker_weekHeader_ul{list-style:none;margin:1px 0;padding-left:0;padding-right:0;font-size:14px;}.DayPicker_weekHeader_li{display:inline-block;text-align:center;}.DayPicker_transitionContainer{position:relative;overflow:hidden;border-radius:3px;}.DayPicker_transitionContainer__horizontal{-webkit-transition:height 0.2s ease-in-out;-moz-transition:height 0.2s ease-in-out;transition:height 0.2s ease-in-out;}.DayPicker_transitionContainer__vertical{width:100%;}.DayPicker_transitionContainer__verticalScrollable{padding-top:20px;height:100%;position:absolute;top:0;bottom:0;right:0;left:0;overflow-y:scroll;}.DateInput{margin:0;padding:0;background:#fff;position:relative;display:inline-block;width:130px;vertical-align:middle;}.DateInput__small{width:97px;}.DateInput__block{width:100%;}.DateInput__disabled{background:#f2f2f2;color:#dbdbdb;}.DateInput_input{font-weight:200;font-size:19px;line-height:24px;color:#484848;background-color:#fff;width:100%;padding:11px 11px 9px;border:0;border-top:0;border-right:0;border-bottom:2px solid transparent;border-left:0;border-radius:0;}.DateInput_input__small{font-size:15px;line-height:18px;letter-spacing:0.2px;padding:7px 7px 5px;}.DateInput_input__regular{font-weight:auto;}.DateInput_input__readOnly{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;}.DateInput_input__focused{outline:0;background:#fff;border:0;border-top:0;border-right:0;border-bottom:2px solid #008489;border-left:0;}.DateInput_input__disabled{background:#f2f2f2;font-style:italic;}.DateInput_screenReaderMessage{border:0;clip:rect(0, 0, 0, 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px;}.DateInput_fang{position:absolute;width:20px;height:10px;left:22px;z-index:2;}.DateInput_fangShape{fill:#fff;}.DateInput_fangStroke{stroke:#dbdbdb;fill:transparent;}.DateRangePickerInput{background-color:#fff;display:inline-block;}.DateRangePickerInput__disabled{background:#f2f2f2;}.DateRangePickerInput__withBorder{border-radius:2px;border:1px solid #dbdbdb;}.DateRangePickerInput__rtl{direction:rtl;}.DateRangePickerInput__block{display:block;}.DateRangePickerInput__showClearDates{padding-right:30px;}.DateRangePickerInput_arrow{display:inline-block;vertical-align:middle;color:#484848;}.DateRangePickerInput_arrow_svg{vertical-align:middle;fill:#484848;height:24px;width:24px;}.DateRangePickerInput_clearDates{background:0 0;border:0;color:inherit;font:inherit;line-height:normal;overflow:visible;cursor:pointer;padding:10px;margin:0 10px 0 5px;position:absolute;right:0;top:50%;-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);}.DateRangePickerInput_clearDates__small{padding:6px;}.DateRangePickerInput_clearDates_default:focus,.DateRangePickerInput_clearDates_default:hover{background:#dbdbdb;border-radius:50%;}.DateRangePickerInput_clearDates__hide{visibility:hidden;}.DateRangePickerInput_clearDates_svg{fill:#82888a;height:12px;width:15px;vertical-align:middle;}.DateRangePickerInput_clearDates_svg__small{height:9px;}.DateRangePickerInput_calendarIcon{background:0 0;border:0;color:inherit;font:inherit;line-height:normal;overflow:visible;cursor:pointer;display:inline-block;vertical-align:middle;padding:10px;margin:0 5px 0 10px;}.DateRangePickerInput_calendarIcon_svg{fill:#82888a;height:15px;width:14px;vertical-align:middle;}.DateRangePicker{position:relative;display:inline-block;}.DateRangePicker__block{display:block;}.DateRangePicker_picker{z-index:1;background-color:#fff;position:absolute;}.DateRangePicker_picker__rtl{direction:rtl;}.DateRangePicker_picker__directionLeft{left:0;}.DateRangePicker_picker__directionRight{right:0;}.DateRangePicker_picker__portal{background-color:rgba(0, 0, 0, 0.3);position:fixed;top:0;left:0;height:100%;width:100%;}.DateRangePicker_picker__fullScreenPortal{background-color:#fff;}.DateRangePicker_closeButton{background:0 0;border:0;color:inherit;font:inherit;line-height:normal;overflow:visible;cursor:pointer;position:absolute;top:0;right:0;padding:15px;z-index:2;}.DateRangePicker_closeButton:focus,.DateRangePicker_closeButton:hover{color:darken(#cacccd, 10%);text-decoration:none;}.DateRangePicker_closeButton_svg{height:15px;width:15px;fill:#cacccd;}"
} : 0;
var ReactDatesStyles = function ReactDatesStyles() {
  cov_29j5m5gjfb().f[0]++;
  cov_29j5m5gjfb().s[1]++;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .Global */ .xB, {
    styles: _ref
  });
};

/***/ }),

/***/ 8013:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82772);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19601);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47941);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_hooks__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(97375);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24614);
/* harmony import */ var _hooks_useObservabilitySafe_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(79652);
/* harmony import */ var _system_bricks_types_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26153);




var _excluded = ["analyticsName", "inViewThreshold", "trackImpression"],
  _excluded2 = ["analyticsName", "inViewThreshold"];
function cov_1kt4fvyrry() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Box/Box.tsx";
  var hash = "b9c87f307cc9dcdb8114e71bf69314c3fbdd87f3";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Box/Box.tsx",
    statementMap: {
      "0": {
        start: {
          line: 42,
          column: 24
        },
        end: {
          line: 49,
          column: 1
        }
      },
      "1": {
        start: {
          line: 44,
          column: 22
        },
        end: {
          line: 46,
          column: 6
        }
      },
      "2": {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 47,
          column: 95
        }
      },
      "3": {
        start: {
          line: 82,
          column: 12
        },
        end: {
          line: 94,
          column: 2
        }
      },
      "4": {
        start: {
          line: 83,
          column: 2
        },
        end: {
          line: 92,
          column: 3
        }
      },
      "5": {
        start: {
          line: 84,
          column: 4
        },
        end: {
          line: 91,
          column: 6
        }
      },
      "6": {
        start: {
          line: 93,
          column: 2
        },
        end: {
          line: 93,
          column: 68
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 43,
            column: 2
          },
          end: {
            line: 43,
            column: 3
          }
        },
        loc: {
          start: {
            line: 43,
            column: 78
          },
          end: {
            line: 48,
            column: 3
          }
        },
        line: 43
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 82,
            column: 40
          },
          end: {
            line: 82,
            column: 41
          }
        },
        loc: {
          start: {
            line: 82,
            column: 95
          },
          end: {
            line: 94,
            column: 1
          }
        },
        line: 82
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 43,
            column: 20
          },
          end: {
            line: 43,
            column: 39
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 43,
            column: 38
          },
          end: {
            line: 43,
            column: 39
          }
        }],
        line: 43
      },
      "1": {
        loc: {
          start: {
            line: 83,
            column: 2
          },
          end: {
            line: 92,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 83,
            column: 2
          },
          end: {
            line: 92,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 83
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0],
      "1": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "b9c87f307cc9dcdb8114e71bf69314c3fbdd87f3"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1kt4fvyrry = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1kt4fvyrry();
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }






/**
 * NOTE ABOUT METRIC TRACKING: Box is set up to track impression events
 * It will only track impression events if:
 *  1) a non-empty analyticsName is passed down - Convention: {appName}-{boxName}
 *  2) box enters viewport (threshold is set at 100% for now.  threshold: Number between 0 and 1 indicates the percentage that should be visible before triggering.)
 *
 * Events will be sent to the journey service and will end up in the corresponding tables (e.g. journey_service_production.box_view_event for box impression events)
 * For more information on tracking please refer here: https://opendoor.atlassian.net/wiki/spaces/SELL/pages/1926201404/EDD+User+Behavior+Metrics+in+Bricks
 */

var BoxWithTracking = (cov_1kt4fvyrry().s[0]++, (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_5__/* .forwardRef */ .Gp)(function (_ref, ref) {
  var analyticsName = _ref.analyticsName,
    _ref$inViewThreshold = _ref.inViewThreshold,
    inViewThreshold = _ref$inViewThreshold === void 0 ? (cov_1kt4fvyrry().b[0][0]++, 1) : _ref$inViewThreshold,
    trackImpression = _ref.trackImpression,
    props = _objectWithoutProperties(_ref, _excluded);
  cov_1kt4fvyrry().f[0]++;
  var inViewRef = (cov_1kt4fvyrry().s[1]++, (0,_hooks_useObservabilitySafe_mjs__WEBPACK_IMPORTED_MODULE_6__/* .useTrackComponentInView */ .O)('boxViewEvent', trackImpression, analyticsName, {
    threshold: inViewThreshold
  }));
  cov_1kt4fvyrry().s[2]++;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(_system_bricks_types_mjs__WEBPACK_IMPORTED_MODULE_7__/* .bricks.div */ .G.div, _extends({
    ref: (0,_chakra_ui_hooks__WEBPACK_IMPORTED_MODULE_8__/* .useMergeRefs */ .qq)(ref, inViewRef),
    boxSizing: "border-box"
  }, props));
}));

/**
 * Box is an abstract styled component that renders a div element by default.
 * `Box` implements all style functions exposed by
 * [styled-sytem](https://styled-system.com/table).
 *
 * `Box` also supports a variety of custom style functions defined in bricks. It
 * is useful for rapidly building responsive layouts as well as applying style
 * functions to another component by making use of the `as` prop.
 *
 * Analytics
 *
 *
 * -------------
 *
 * `Box` is set up to track impression events. It will only track impression
 * events if:
 *
 * 1.  a non-empty `analyticsName` is passed down (convention:
 * {appName}-{boxName})
 *
 * 2.  passing `trackImpression={true}` Box impression events will only be
 * tracked the first time that the box enters the viewport
 *
 *
 * Events will be sent to the journey service and will end up in the
 * corresponding tables (e.g.
 * journey\_service\_production.platform\_box\_view\_event for box impression
 * events). For more information on tracking please refer
 * here:[https://opendoor.atlassian.net/wiki/spaces/CONSUMER/blog/2023/05/10/2304737293/Bricks+Events+Update](https://opendoor.atlassian.net/wiki/spaces/CONSUMER/blog/2023/05/10/2304737293/Bricks+Events+Update)
 *
 */
var Box = (cov_1kt4fvyrry().s[3]++, (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_5__/* .forwardRef */ .Gp)(function (_ref2, ref) {
  var analyticsName = _ref2.analyticsName,
    inViewThreshold = _ref2.inViewThreshold,
    props = _objectWithoutProperties(_ref2, _excluded2);
  cov_1kt4fvyrry().f[1]++;
  cov_1kt4fvyrry().s[4]++;
  if (analyticsName) {
    cov_1kt4fvyrry().b[1][0]++;
    cov_1kt4fvyrry().s[5]++;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(BoxWithTracking, _extends({
      analyticsName: analyticsName,
      inViewThreshold: inViewThreshold,
      ref: ref
    }, props));
  } else {
    cov_1kt4fvyrry().b[1][1]++;
  }
  cov_1kt4fvyrry().s[6]++;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(_system_bricks_types_mjs__WEBPACK_IMPORTED_MODULE_7__/* .bricks.div */ .G.div, _extends({
    ref: ref,
    boxSizing: "border-box"
  }, props));
}));
/* harmony default export */ __webpack_exports__["Z"] = (Box);

/***/ }),

/***/ 26029:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports NovoLoadingAnimation, ButtonSpinner */
/* harmony import */ var lodash_isNil_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14293);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41817);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32165);
/* harmony import */ var core_js_modules_es_symbol_to_primitive_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96649);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57327);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89554);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(91038);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(82772);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(66992);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(21249);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(47042);
/* harmony import */ var core_js_modules_es_date_to_primitive_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(96078);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(68309);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(9653);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(19601);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(33321);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(69070);
/* harmony import */ var core_js_modules_es_object_freeze_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(43371);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(38880);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(49337);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(47941);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(74916);
/* harmony import */ var core_js_modules_es_regexp_test_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(77601);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(39714);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(78783);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(54747);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(33948);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_hooks__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(97375);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(24614);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(70917);
/* harmony import */ var _hooks_useMedia_mjs__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(61151);
/* harmony import */ var _hooks_useObservabilitySafe_mjs__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(79652);
/* harmony import */ var _system_bricks_types_mjs__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(26153);
/* harmony import */ var _system_theme_index_mjs__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(79141);
/* harmony import */ var _system_utils_index_mjs__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(48189);
/* harmony import */ var _theme_eero_index_mjs__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(79848);
/* harmony import */ var _theme_novo_index_mjs__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(62762);
/* harmony import */ var _Box_index_mjs__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(8013);
/* harmony import */ var _Icon_index_mjs__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(49154);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }

var _templateObject, _templateObject2, _templateObject3;
var _excluded = ["children", "variant", "analyticsName", "trackImpression", "disabled", "loading", "loadingText", "onClick", "type", "success", "onMouseDown", "unbounded", "preSelected"];
function cov_x1j7yn8w6() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Button/Button.tsx";
  var hash = "e77ac029b19b05c3079729680475b48b1de2ed70";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Button/Button.tsx",
    statementMap: {
      "0": {
        start: {
          line: 90,
          column: 22
        },
        end: {
          line: 117,
          column: 1
        }
      },
      "1": {
        start: {
          line: 91,
          column: 2
        },
        end: {
          line: 93,
          column: 3
        }
      },
      "2": {
        start: {
          line: 92,
          column: 4
        },
        end: {
          line: 92,
          column: 20
        }
      },
      "3": {
        start: {
          line: 94,
          column: 2
        },
        end: {
          line: 116,
          column: 5
        }
      },
      "4": {
        start: {
          line: 95,
          column: 17
        },
        end: {
          line: 95,
          column: 80
        }
      },
      "5": {
        start: {
          line: 96,
          column: 21
        },
        end: {
          line: 96,
          column: 36
        }
      },
      "6": {
        start: {
          line: 109,
          column: 4
        },
        end: {
          line: 114,
          column: 5
        }
      },
      "7": {
        start: {
          line: 110,
          column: 6
        },
        end: {
          line: 112,
          column: 7
        }
      },
      "8": {
        start: {
          line: 111,
          column: 8
        },
        end: {
          line: 111,
          column: 74
        }
      },
      "9": {
        start: {
          line: 113,
          column: 6
        },
        end: {
          line: 113,
          column: 68
        }
      },
      "10": {
        start: {
          line: 115,
          column: 4
        },
        end: {
          line: 115,
          column: 17
        }
      },
      "11": {
        start: {
          line: 426,
          column: 15
        },
        end: {
          line: 510,
          column: 1
        }
      },
      "12": {
        start: {
          line: 447,
          column: 21
        },
        end: {
          line: 447,
          column: 31
        }
      },
      "13": {
        start: {
          line: 448,
          column: 23
        },
        end: {
          line: 448,
          column: 59
        }
      },
      "14": {
        start: {
          line: 449,
          column: 19
        },
        end: {
          line: 454,
          column: 6
        }
      },
      "15": {
        start: {
          line: 455,
          column: 24
        },
        end: {
          line: 455,
          column: 49
        }
      },
      "16": {
        start: {
          line: 456,
          column: 36
        },
        end: {
          line: 456,
          column: 57
        }
      },
      "17": {
        start: {
          line: 458,
          column: 22
        },
        end: {
          line: 458,
          column: 96
        }
      },
      "18": {
        start: {
          line: 459,
          column: 34
        },
        end: {
          line: 459,
          column: 56
        }
      },
      "19": {
        start: {
          line: 460,
          column: 27
        },
        end: {
          line: 460,
          column: 75
        }
      },
      "20": {
        start: {
          line: 464,
          column: 4
        },
        end: {
          line: 466,
          column: 5
        }
      },
      "21": {
        start: {
          line: 465,
          column: 6
        },
        end: {
          line: 465,
          column: 30
        }
      },
      "22": {
        start: {
          line: 468,
          column: 30
        },
        end: {
          line: 476,
          column: 5
        }
      },
      "23": {
        start: {
          line: 478,
          column: 4
        },
        end: {
          line: 508,
          column: 6
        }
      },
      "24": {
        start: {
          line: 486,
          column: 10
        },
        end: {
          line: 488,
          column: 11
        }
      },
      "25": {
        start: {
          line: 487,
          column: 12
        },
        end: {
          line: 487,
          column: 93
        }
      },
      "26": {
        start: {
          line: 489,
          column: 10
        },
        end: {
          line: 489,
          column: 33
        }
      },
      "27": {
        start: {
          line: 490,
          column: 10
        },
        end: {
          line: 490,
          column: 32
        }
      },
      "28": {
        start: {
          line: 512,
          column: 25
        },
        end: {
          line: 524,
          column: 1
        }
      },
      "29": {
        start: {
          line: 513,
          column: 23
        },
        end: {
          line: 513,
          column: 74
        }
      },
      "30": {
        start: {
          line: 514,
          column: 29
        },
        end: {
          line: 514,
          column: 68
        }
      },
      "31": {
        start: {
          line: 515,
          column: 2
        },
        end: {
          line: 517,
          column: 3
        }
      },
      "32": {
        start: {
          line: 516,
          column: 4
        },
        end: {
          line: 516,
          column: 76
        }
      },
      "33": {
        start: {
          line: 518,
          column: 2
        },
        end: {
          line: 523,
          column: 4
        }
      },
      "34": {
        start: {
          line: 526,
          column: 0
        },
        end: {
          line: 532,
          column: 2
        }
      },
      "35": {
        start: {
          line: 540,
          column: 36
        },
        end: {
          line: 581,
          column: 1
        }
      },
      "36": {
        start: {
          line: 541,
          column: 24
        },
        end: {
          line: 541,
          column: 43
        }
      },
      "37": {
        start: {
          line: 542,
          column: 2
        },
        end: {
          line: 546,
          column: 3
        }
      },
      "38": {
        start: {
          line: 543,
          column: 4
        },
        end: {
          line: 543,
          column: 36
        }
      },
      "39": {
        start: {
          line: 544,
          column: 9
        },
        end: {
          line: 546,
          column: 3
        }
      },
      "40": {
        start: {
          line: 545,
          column: 4
        },
        end: {
          line: 545,
          column: 41
        }
      },
      "41": {
        start: {
          line: 547,
          column: 21
        },
        end: {
          line: 555,
          column: 3
        }
      },
      "42": {
        start: {
          line: 556,
          column: 2
        },
        end: {
          line: 580,
          column: 4
        }
      },
      "43": {
        start: {
          line: 583,
          column: 20
        },
        end: {
          line: 587,
          column: 1
        }
      },
      "44": {
        start: {
          line: 589,
          column: 59
        },
        end: {
          line: 611,
          column: 1
        }
      },
      "45": {
        start: {
          line: 590,
          column: 2
        },
        end: {
          line: 610,
          column: 4
        }
      },
      "46": {
        start: {
          line: 613,
          column: 25
        },
        end: {
          line: 617,
          column: 1
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 90,
            column: 22
          },
          end: {
            line: 90,
            column: 23
          }
        },
        loc: {
          start: {
            line: 90,
            column: 78
          },
          end: {
            line: 117,
            column: 1
          }
        },
        line: 90
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 94,
            column: 38
          },
          end: {
            line: 94,
            column: 39
          }
        },
        loc: {
          start: {
            line: 94,
            column: 49
          },
          end: {
            line: 116,
            column: 3
          }
        },
        line: 94
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 427,
            column: 2
          },
          end: {
            line: 427,
            column: 3
          }
        },
        loc: {
          start: {
            line: 445,
            column: 7
          },
          end: {
            line: 509,
            column: 3
          }
        },
        line: 445
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 485,
            column: 17
          },
          end: {
            line: 485,
            column: 18
          }
        },
        loc: {
          start: {
            line: 485,
            column: 24
          },
          end: {
            line: 491,
            column: 9
          }
        },
        line: 485
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 512,
            column: 25
          },
          end: {
            line: 512,
            column: 26
          }
        },
        loc: {
          start: {
            line: 512,
            column: 72
          },
          end: {
            line: 524,
            column: 1
          }
        },
        line: 512
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 540,
            column: 36
          },
          end: {
            line: 540,
            column: 37
          }
        },
        loc: {
          start: {
            line: 540,
            column: 64
          },
          end: {
            line: 581,
            column: 1
          }
        },
        line: 540
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 589,
            column: 59
          },
          end: {
            line: 589,
            column: 60
          }
        },
        loc: {
          start: {
            line: 590,
            column: 2
          },
          end: {
            line: 610,
            column: 4
          }
        },
        line: 590
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 91,
            column: 2
          },
          end: {
            line: 93,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 91,
            column: 2
          },
          end: {
            line: 93,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 91
      },
      "1": {
        loc: {
          start: {
            line: 91,
            column: 6
          },
          end: {
            line: 91,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 91,
            column: 6
          },
          end: {
            line: 91,
            column: 24
          }
        }, {
          start: {
            line: 91,
            column: 28
          },
          end: {
            line: 91,
            column: 43
          }
        }],
        line: 91
      },
      "2": {
        loc: {
          start: {
            line: 109,
            column: 4
          },
          end: {
            line: 114,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 109,
            column: 4
          },
          end: {
            line: 114,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 109
      },
      "3": {
        loc: {
          start: {
            line: 110,
            column: 6
          },
          end: {
            line: 112,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 110,
            column: 6
          },
          end: {
            line: 112,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 110
      },
      "4": {
        loc: {
          start: {
            line: 440,
            column: 6
          },
          end: {
            line: 440,
            column: 23
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 440,
            column: 18
          },
          end: {
            line: 440,
            column: 23
          }
        }],
        line: 440
      },
      "5": {
        loc: {
          start: {
            line: 441,
            column: 6
          },
          end: {
            line: 441,
            column: 25
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 441,
            column: 20
          },
          end: {
            line: 441,
            column: 25
          }
        }],
        line: 441
      },
      "6": {
        loc: {
          start: {
            line: 448,
            column: 23
          },
          end: {
            line: 448,
            column: 59
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 448,
            column: 41
          },
          end: {
            line: 448,
            column: 48
          }
        }, {
          start: {
            line: 448,
            column: 51
          },
          end: {
            line: 448,
            column: 59
          }
        }],
        line: 448
      },
      "7": {
        loc: {
          start: {
            line: 464,
            column: 4
          },
          end: {
            line: 466,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 464,
            column: 4
          },
          end: {
            line: 466,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 464
      },
      "8": {
        loc: {
          start: {
            line: 486,
            column: 10
          },
          end: {
            line: 488,
            column: 11
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 486,
            column: 10
          },
          end: {
            line: 488,
            column: 11
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 486
      },
      "9": {
        loc: {
          start: {
            line: 490,
            column: 10
          },
          end: {
            line: 490,
            column: 31
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 490,
            column: 10
          },
          end: {
            line: 490,
            column: 17
          }
        }, {
          start: {
            line: 490,
            column: 21
          },
          end: {
            line: 490,
            column: 31
          }
        }],
        line: 490
      },
      "10": {
        loc: {
          start: {
            line: 494,
            column: 19
          },
          end: {
            line: 494,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 494,
            column: 29
          },
          end: {
            line: 494,
            column: 54
          }
        }, {
          start: {
            line: 494,
            column: 57
          },
          end: {
            line: 494,
            column: 61
          }
        }],
        line: 494
      },
      "11": {
        loc: {
          start: {
            line: 497,
            column: 9
          },
          end: {
            line: 506,
            column: 9
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 498,
            column: 10
          },
          end: {
            line: 503,
            column: 12
          }
        }, {
          start: {
            line: 505,
            column: 10
          },
          end: {
            line: 505,
            column: 24
          }
        }],
        line: 497
      },
      "12": {
        loc: {
          start: {
            line: 513,
            column: 23
          },
          end: {
            line: 513,
            column: 74
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 513,
            column: 47
          },
          end: {
            line: 513,
            column: 58
          }
        }, {
          start: {
            line: 513,
            column: 61
          },
          end: {
            line: 513,
            column: 74
          }
        }],
        line: 513
      },
      "13": {
        loc: {
          start: {
            line: 514,
            column: 29
          },
          end: {
            line: 514,
            column: 68
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 514,
            column: 50
          },
          end: {
            line: 514,
            column: 54
          }
        }, {
          start: {
            line: 514,
            column: 57
          },
          end: {
            line: 514,
            column: 68
          }
        }],
        line: 514
      },
      "14": {
        loc: {
          start: {
            line: 515,
            column: 2
          },
          end: {
            line: 517,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 515,
            column: 2
          },
          end: {
            line: 517,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 515
      },
      "15": {
        loc: {
          start: {
            line: 542,
            column: 2
          },
          end: {
            line: 546,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 542,
            column: 2
          },
          end: {
            line: 546,
            column: 3
          }
        }, {
          start: {
            line: 544,
            column: 9
          },
          end: {
            line: 546,
            column: 3
          }
        }],
        line: 542
      },
      "16": {
        loc: {
          start: {
            line: 542,
            column: 6
          },
          end: {
            line: 542,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 542,
            column: 6
          },
          end: {
            line: 542,
            column: 27
          }
        }, {
          start: {
            line: 542,
            column: 31
          },
          end: {
            line: 542,
            column: 41
          }
        }],
        line: 542
      },
      "17": {
        loc: {
          start: {
            line: 544,
            column: 9
          },
          end: {
            line: 546,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 544,
            column: 9
          },
          end: {
            line: 546,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 544
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0],
      "5": [0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "e77ac029b19b05c3079729680475b48b1de2ed70"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_x1j7yn8w6 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_x1j7yn8w6();
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }










































/**
 * NOTE ABOUT METRIC TRACKING: Button is set up to track impression, click and hover events
 * Tracking for interactable components like button is mandatory so an analyticsName is required
 * Events will be sent to journey service and will end up in the corresponding tables (e.g. journey_service_production.button_click_event for button click events)
 * For more information on tracking please refer here: https://opendoor.atlassian.net/wiki/spaces/SELL/pages/1926201404/EDD+User+Behavior+Metrics+in+Bricks
 */
cov_x1j7yn8w6().s[0]++;
var validateChild = function validateChild(children, variant, name, selected) {
  cov_x1j7yn8w6().f[0]++;
  cov_x1j7yn8w6().s[1]++;
  if ((cov_x1j7yn8w6().b[1][0]++, variant !== 'icon') || (cov_x1j7yn8w6().b[1][1]++, name !== 'novo')) {
    cov_x1j7yn8w6().b[0][0]++;
    cov_x1j7yn8w6().s[2]++;
    return children;
  } else {
    cov_x1j7yn8w6().b[0][1]++;
  }
  cov_x1j7yn8w6().s[3]++;
  return react__WEBPACK_IMPORTED_MODULE_29__.Children.map(children, function (child) {
    cov_x1j7yn8w6().f[1]++;
    var item = (cov_x1j7yn8w6().s[4]++, child);
    var iconName = (cov_x1j7yn8w6().s[5]++, item.props.name);
    // ensures that we're only using the correct icons for novo icon buttons
    // if (
    //   iconName.match(
    //     /(chevron-right|chevron-left|add|remove|close|share|filter|chat|trash|favorite|favorite-filled)/g,
    //   ) === null ||
    //   item.props.size !== 24
    // ) {
    //   // eslint-disable-next-line no-console
    //   console.error(
    //     'Novo icon buttons should use a specific set of Icons all sized at 24. Please refer back to the figma file for the list of icons',
    //   );
    // }
    cov_x1j7yn8w6().s[6]++;
    if (iconName === 'favorite') {
      cov_x1j7yn8w6().b[2][0]++;
      cov_x1j7yn8w6().s[7]++;
      if (selected) {
        cov_x1j7yn8w6().b[3][0]++;
        cov_x1j7yn8w6().s[8]++;
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_29__.createElement(_Icon_index_mjs__WEBPACK_IMPORTED_MODULE_30__/* ["default"] */ .Z, {
          name: "favorite-filled",
          size: 24,
          color: "error500"
        });
      } else {
        cov_x1j7yn8w6().b[3][1]++;
      }
      cov_x1j7yn8w6().s[9]++;
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_29__.createElement(_Icon_index_mjs__WEBPACK_IMPORTED_MODULE_30__/* ["default"] */ .Z, {
        name: "favorite",
        size: 24,
        color: "neutrals100"
      });
    } else {
      cov_x1j7yn8w6().b[2][1]++;
    }
    cov_x1j7yn8w6().s[10]++;
    return child;
  });
};

/**
 * Buttons help users browse listings, submit offers, and contact agents. We use
 * different types of buttons depending on the context, but we also keep choices
 * simple.
 *
 * Variants
 *
 *
 * ------------
 *
 * The `Button` component uses styled-system variants to build variant styles,
 * sizes, and border radii.
 *
 * ###
 *
 * Style
 *
 * The `Button` component supports variant styles `primary`, `secondary`,
 * `ghost`, `icon`, `inline-link`, `inline-secondary-link` and `link`. It will
 * be `primary` by default if not set. The `inline-link` and
 * `inline-secondary-link` variants should be used sparingly (please see the
 * Accessibility section below for more information). The `link` variant is
 * deprecated and only exists for backwards compatibility.
 *
 * Button variant variations
 * ----------------------------------------------------------------------------------------------------
 *
 * "primary"
 *
 * "secondary"
 *
 * "ghost"
 *
 * "icon"
 *
 * "inline-link"
 *
 * "inline-secondary-link"
 *
 * "link"
 *
 * ###
 *
 * Size
 *
 * The `Button` component supports variant sizes `sm`, `md`, and `lg`. It will
 * be `md` by default if not set.
 *
 * Button size variations
 * -------------------------------------------------------------------------------------------------
 *
 * "sm"
 *
 * "md"
 *
 * "lg"
 *
 * Behaviors
 *
 *
 * -------------
 *
 * The `Button` component supports props `loading`, `success`, and `disabled` to
 * control the behavior of the button. These props should generally be set based
 * on some state that is determined by a user interaction or the status of data
 * fetching.
 *
 * ###
 *
 * Loading
 *
 * Pass `loading` prop to the `Button` component to show it's loading state. You
 * can optionally pass `loadingText` prop, if you do, the button will show a
 * spinner and the loading text. Otherwise, `loadingText` will default to
 * "Loading...". The button will be disabled when `loading` is true and
 * `disabled` is `undefined`.
 *
 * Button loading variations
 * ----------------------------------------------------------------------------------------------------
 *
 * true
 *
 * false
 *
 * ###
 *
 * Disabled
 *
 * Pass `disabled` prop to the `Button` component to show it's disabled state.
 *
 * Button disabled variations
 * -----------------------------------------------------------------------------------------------------
 *
 * true
 *
 * false
 *
 * ###
 *
 * Success
 *
 * Pass `success` prop to the `Button` component to show it's success animation.
 *
 * Style Props
 *
 *
 * ---------------
 *
 * Button inherits style props:
 *
 * [layout](https://styled-system.com/api#layout)
 *
 * [space](https://styled-system.com/api#space)
 *
 * [typography](https://styled-system.com/api#typography)
 *
 *
 * Accessibility
 *
 *
 * -----------------
 *
 * Screen readers handle links slightly differently than they do buttons. All
 * links and buttons are tab-able, but pressing the Space key or Enter triggers
 * a button, whereas pressing the Enter key only triggers a link.
 *
 * **The simplest rule of thumb is to just use the right HTML elements for the
 * content. Realistically, this is not possible 100% of the time—just remember,
 * when using the wrong elements keep in mind there are behaviors and states
 * that *may be expected that will need to be accounted for.**
 *
 * Functional buttons that look like link variants (`inline-link`) are known as
 * a antipattern, however for conversion reasons this is occasionally a
 * requirement.  Make sure to verify with design that this behavior is
 * absolutely necessary and appropriate a11y concerns were considered.
 *
 * ###
 *
 * Impact:
 *
 * ####
 *
 * Tab order
 *
 * `<a>` elements without an href attribute are NOT in the tab order. Elements
 * typically not in the tab order can be added by setting the tabindex attribute
 * to 0 on that element.
 *
 * ####
 *
 * Hover and focus states
 *
 * Unlike button and input elements, `<a>` do NOT by default trigger the
 * associated click event on keypress of the `SPACE` keys without additional
 * work.
 *
 * ####
 *
 * Assistive technologies
 *
 * While `<a>` elements are treated uniquely, it's common to identify all links
 * on a page using assistive technologies to more easily navigate throughout a
 * site.  Therefore, it might be strange having those intended to be used as a
 * button to be mixed up with the other actual links. Any element intended to be
 * a button not marked up using button or input can have the ARIA role attribute
 * set to button—keep in mind, though, all the behaviors/states above still need
 * to be implemented.
 *
 * ###
 *
 * Clickable actions
 *
 * Use buttons to signal clickable actions, such as “download,” “sign up,” or
 * “log out.” You may use links for less popular or less important actions. If
 * you want something that looks and acts like a button, try to always use
 * the`<button>` element rather than styling a link like a button. If you want
 * the user to trigger some kind of Javascript functionality by clicking it, use
 * a `<button>`.
 *
 * ###
 *
 * Clickable actions
 *
 * Use buttons to signal clickable actions, such as “download,” “sign up,” or
 * “log out.” You may use links for less popular or less important actions. If
 * you want something that looks and acts like a button, try to always use
 * the`<button>` element rather than styling a link like a button. If you want
 * the user to trigger some kind of Javascript functionality by clicking it, use
 * a `<button>`.
 *
 * If you need to have a functional link that looks like a button, use a `<Link
 * />` component with a button variant:
 *
 * ####
 *
 * ✅ Pass
 *
 * <Link onClick={() => { /* function that does something other than navigation
 * *&#47; }} variant="primary-button" aria-label={null} > Click me!!!  </Button>
 *
 *
 * ####
 *
 * 🛑 Fail
 *
 * <Link onClick={() => { /* function that does something other than navigation
 * *&#47; }} href="" aria-label={null} > Click me!!!  </Link>
 *
 *
 * ###
 *
 * Navigation
 *
 * If you want a user to navigate to a new page or to a different target on the
 * same page, use an anchor element`<a>`.
 *
 * If you need to have a functional button that looks like a link, use a
 * `<Button />` component with a link variant:
 *
 * ####
 *
 * ✅ Pass
 *
 * <Button onClick={() => { /* function that does something other than
 * navigation *&#47; }} variant="link" aria-label={null} > Click me!!!
 * </Button>
 *
 *
 * ####
 *
 * 🛑 Fail
 *
 * <Link onClick={() => { /* function that does something other than navigation
 * *&#47; }} href="" aria-label={null} > Click me!!!  </Link>
 *
 *
 * ###
 *
 * Clickable Cards
 *
 * Non-interactable elements should not have an onClick method. When an element
 * should be clickable, it should be wrapped in a Button component with the
 * ghost variant. This will ensure that the element is clickable and has a hover
 * state without adding interactive behaviors to the element.
 *
 * ####
 *
 * ✅ Pass
 *
 * <Button variant="ghost" onClick={() => { /* do something *&#47; }}
 * aria-label={null}> <Box>Click me!!!</Box> </Button>
 *
 *
 * ####
 *
 * 🛑 Fail
 *
 * <Box onClick={() => { /* do something *&#47; }}> Click me!!!  </Box>
 *
 *
 * Buttons do not always need `aria-label` attributes. There are instances where
 * the CTA text is descriptive enough. These cases do not need an explicit
 * `aria-label` prop. Instead you can pass in `null`.
 *
 * If you want to still pass in an `aria-label` make sure that the accessible
 * name to match or at least contain the visible text as written. For better
 * usability, this should be placed at the beginning of the accessible name, but
 * this is not required.
 *
 * ###
 *
 * Further Reading
 *
 * [Buttons & Links | Accessibility
 * Guidelines](http://web-accessibility.carnegiemuseums.org/content/buttons/)
 * [Proper Use of Buttons and
 * Links](https://www.webaxe.org/proper-use-buttons-links/)  [Links, Buttons,
 * Submits, and Divs, Oh
 * Hell](https://adrianroselli.com/2016/01/links-buttons-submits-and-divs-oh-hell.html)
 * [When To Use The Button Element |
 * CSS-Tricks](https://css-tricks.com/use-button-element/) [The Anchor Button:
 * Bad for Accessibility, Bad for
 * Usability](http://itstiredinhere.blogspot.com/2014/08/the-anchor-button-bad-for-accessibility.html?m=1)
 *
 * Analytics
 *
 *
 * -------------
 *
 * `Button` is set up to track click and impression events:
 *
 * *   To track click events pass in an non-empty `analyticsName` (convention: *
 * {appName}-{buttonName})
 *
 * *   To track impression events pass: 1) a non-empty `analyticsName` 2) pass *
 * `trackImpression={true}`
 *
 *
 * Button impression events will only be tracked the first time that the button
 * enters the viewport
 *
 * Events will be sent to the journey service and will end up in the
 * corresponding tables (e.g.
 * journey\_service\_production.platform\_button\_view\_event for button
 * impression events). For more information on tracking please refer
 * here:[https://opendoor.atlassian.net/wiki/spaces/CONSUMER/blog/2023/05/10/2304737293/Bricks+Events+Update](https://opendoor.atlassian.net/wiki/spaces/CONSUMER/blog/2023/05/10/2304737293/Bricks+Events+Update)
 */
var Button = (cov_x1j7yn8w6().s[11]++, (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_31__/* .forwardRef */ .Gp)(function (_ref, ref) {
  var children = _ref.children,
    variant = _ref.variant,
    analyticsName = _ref.analyticsName,
    trackImpression = _ref.trackImpression,
    disabled = _ref.disabled,
    loading = _ref.loading,
    loadingText = _ref.loadingText,
    _onClick = _ref.onClick,
    type = _ref.type,
    success = _ref.success,
    onMouseDown = _ref.onMouseDown,
    _ref$unbounded = _ref.unbounded,
    unbounded = _ref$unbounded === void 0 ? (cov_x1j7yn8w6().b[4][0]++, false) : _ref$unbounded,
    _ref$preSelected = _ref.preSelected,
    preSelected = _ref$preSelected === void 0 ? (cov_x1j7yn8w6().b[5][0]++, false) : _ref$preSelected,
    props = _objectWithoutProperties(_ref, _excluded);
  cov_x1j7yn8w6().f[2]++;
  // Pulls the theme from the React context so we can see what loading design to use
  var _ref2 = (cov_x1j7yn8w6().s[12]++, (0,_system_theme_index_mjs__WEBPACK_IMPORTED_MODULE_32__/* .useTheme */ .F)()),
    name = _ref2.name;
  var isDisabled = (cov_x1j7yn8w6().s[13]++, lodash_isNil_js__WEBPACK_IMPORTED_MODULE_0__(disabled) ? (cov_x1j7yn8w6().b[6][0]++, loading) : (cov_x1j7yn8w6().b[6][1]++, disabled));
  var styles = (cov_x1j7yn8w6().s[14]++, (0,_system_utils_index_mjs__WEBPACK_IMPORTED_MODULE_33__/* .useStyleConfig */ .mq)('Button', _objectSpread({
    variant: variant,
    unbounded: unbounded,
    loading: loading
  }, props)));
  var canNotHover = (cov_x1j7yn8w6().s[15]++, (0,_hooks_useMedia_mjs__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .Z)('(hover: none)'));
  var _ref3 = (cov_x1j7yn8w6().s[16]++, (0,react__WEBPACK_IMPORTED_MODULE_29__.useState)(preSelected)),
    _ref4 = _slicedToArray(_ref3, 2),
    selected = _ref4[0],
    setSelected = _ref4[1];
  var inViewRef = (cov_x1j7yn8w6().s[17]++, (0,_hooks_useObservabilitySafe_mjs__WEBPACK_IMPORTED_MODULE_35__/* .useTrackComponentInView */ .O)('buttonViewEvent', trackImpression, analyticsName));
  var _ref5 = (cov_x1j7yn8w6().s[18]++, (0,_hooks_useObservabilitySafe_mjs__WEBPACK_IMPORTED_MODULE_35__/* .useObservabilitySafe */ .r)()),
    trackJourneyEvent = _ref5.trackJourneyEvent;
  var validatedChild = (cov_x1j7yn8w6().s[19]++, validateChild(children, variant, name, selected));

  // Even though a touch device can't hover, after a button is tapped, it will
  // retain the hover state. Instead we will remove the hover state when it is not supported.
  cov_x1j7yn8w6().s[20]++;
  if (canNotHover) {
    cov_x1j7yn8w6().b[7][0]++;
    cov_x1j7yn8w6().s[21]++;
    delete styles['_hover'];
  } else {
    cov_x1j7yn8w6().b[7][1]++;
  }
  var successTransition = (cov_x1j7yn8w6().s[22]++, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_36__/* .keyframes */ .F4)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      0% {\n        background: var(--colors-brand50);\n      }\n\n      100% {\n        background: var(--colors-green50);\n      }\n    "]))));
  cov_x1j7yn8w6().s[23]++;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_29__.createElement(_system_bricks_types_mjs__WEBPACK_IMPORTED_MODULE_37__/* .bricks.button */ .G.button, _extends({
    ref: (0,_chakra_ui_hooks__WEBPACK_IMPORTED_MODULE_38__/* .useMergeRefs */ .qq)(inViewRef, ref),
    className: "cta-button"
    // __css has a lower priority than sx
    ,
    __css: styles,
    disabled: isDisabled,
    onClick: function onClick(e) {
      cov_x1j7yn8w6().f[3]++;
      cov_x1j7yn8w6().s[24]++;
      if (analyticsName) {
        cov_x1j7yn8w6().b[8][0]++;
        cov_x1j7yn8w6().s[25]++;
        trackJourneyEvent('platform', 'buttonClickEvent', {
          targetName: analyticsName
        });
      } else {
        cov_x1j7yn8w6().b[8][1]++;
      }
      cov_x1j7yn8w6().s[26]++;
      setSelected(!selected);
      cov_x1j7yn8w6().s[27]++;
      (cov_x1j7yn8w6().b[9][0]++, _onClick) && (cov_x1j7yn8w6().b[9][1]++, _onClick(e));
    },
    type: type,
    onMouseDown: onMouseDown,
    animation: success ? (cov_x1j7yn8w6().b[10][0]++, "".concat(successTransition, " 1s")) : (cov_x1j7yn8w6().b[10][1]++, null)
  }, props), loading ? (cov_x1j7yn8w6().b[11][0]++, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_29__.createElement(LoadingAnimation, {
    variant: variant,
    loadingText: loadingText,
    unbounded: unbounded,
    name: name
  })) : (cov_x1j7yn8w6().b[11][1]++, validatedChild));
}));
cov_x1j7yn8w6().s[28]++;
var LoadingAnimation = function LoadingAnimation(_ref6) {
  var variant = _ref6.variant,
    loadingText = _ref6.loadingText,
    unbounded = _ref6.unbounded,
    name = _ref6.name;
  cov_x1j7yn8w6().f[4]++;
  var spinnerColor = (cov_x1j7yn8w6().s[29]++, variant === 'primary' ? (cov_x1j7yn8w6().b[12][0]++, 'neutrals0') : (cov_x1j7yn8w6().b[12][1]++, 'neutrals100'));
  var displayLoadingText = (cov_x1j7yn8w6().s[30]++, variant === 'icon' ? (cov_x1j7yn8w6().b[13][0]++, null) : (cov_x1j7yn8w6().b[13][1]++, loadingText));
  cov_x1j7yn8w6().s[31]++;
  if (name === 'novo') {
    cov_x1j7yn8w6().b[14][0]++;
    cov_x1j7yn8w6().s[32]++;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_29__.createElement(NovoLoadingAnimation, {
      variant: variant,
      unbounded: unbounded
    });
  } else {
    cov_x1j7yn8w6().b[14][1]++;
  }
  cov_x1j7yn8w6().s[33]++;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_29__.createElement(react__WEBPACK_IMPORTED_MODULE_29__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_29__.createElement(ButtonSpinner, {
    color: spinnerColor
  }), displayLoadingText);
};
cov_x1j7yn8w6().s[34]++;
Button.defaultProps = {
  variant: 'primary',
  loading: false,
  loadingText: 'Loading ...',
  size: 'md',
  type: 'button'
};
/* harmony default export */ __webpack_exports__["ZP"] = (Button);
cov_x1j7yn8w6().s[35]++;
var NovoLoadingAnimation = function NovoLoadingAnimation(_ref7) {
  var variant = _ref7.variant,
    unbounded = _ref7.unbounded;
  cov_x1j7yn8w6().f[5]++;
  var backgroundColor = (cov_x1j7yn8w6().s[36]++, _theme_novo_index_mjs__WEBPACK_IMPORTED_MODULE_39__/* ["default"].brandBlue600 */ .ZP.brandBlue600);
  cov_x1j7yn8w6().s[37]++;
  if ((cov_x1j7yn8w6().b[16][0]++, variant === 'primary') && (cov_x1j7yn8w6().b[16][1]++, !unbounded)) {
    cov_x1j7yn8w6().b[15][0]++;
    cov_x1j7yn8w6().s[38]++;
    backgroundColor = _theme_novo_index_mjs__WEBPACK_IMPORTED_MODULE_39__/* ["default"].white0 */ .ZP.white0;
  } else {
    cov_x1j7yn8w6().b[15][1]++;
    cov_x1j7yn8w6().s[39]++;
    if (variant === 'secondary') {
      cov_x1j7yn8w6().b[17][0]++;
      cov_x1j7yn8w6().s[40]++;
      backgroundColor = _theme_novo_index_mjs__WEBPACK_IMPORTED_MODULE_39__/* ["default"].warmgrey900 */ .ZP.warmgrey900;
    } else {
      cov_x1j7yn8w6().b[17][1]++;
    }
  }
  var baseStyles = (cov_x1j7yn8w6().s[41]++, {
    width: '4px',
    height: '4px',
    top: '1px',
    left: '6px',
    borderRadius: _theme_eero_index_mjs__WEBPACK_IMPORTED_MODULE_40__/* ["default"].semiRounded */ .Z.semiRounded,
    backgroundColor: backgroundColor,
    marginLeft: '2px'
  });
  cov_x1j7yn8w6().s[42]++;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_29__.createElement(react__WEBPACK_IMPORTED_MODULE_29__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_29__.createElement(_Box_index_mjs__WEBPACK_IMPORTED_MODULE_41__/* ["default"] */ .Z, {
    "data-testid": "loading-animation-dot-one",
    animation: "".concat(dotFlashing, " 0.6s infinite alternate .2s"),
    css: baseStyles,
    marginLeft: "0px"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_29__.createElement(_Box_index_mjs__WEBPACK_IMPORTED_MODULE_41__/* ["default"] */ .Z, {
    "data-testid": "loading-animation-dot-two",
    animation: "".concat(dotFlashing, " 0.6s infinite alternate .4s"),
    css: baseStyles
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_29__.createElement(_Box_index_mjs__WEBPACK_IMPORTED_MODULE_41__/* ["default"] */ .Z, {
    "data-testid": "loading-animation-dot-three",
    animation: "".concat(dotFlashing, " 0.6s infinite alternate .6s"),
    css: baseStyles
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_29__.createElement(_Box_index_mjs__WEBPACK_IMPORTED_MODULE_41__/* ["default"] */ .Z, {
    "data-testid": "loading-animation-dot-four",
    animation: "".concat(dotFlashing, " 0.6s infinite alternate .8s"),
    css: baseStyles
  }));
};
var dotFlashing = (cov_x1j7yn8w6().s[43]++, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_36__/* .keyframes */ .F4)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\nto {\n  opacity: 40%;\n}\n"]))));
cov_x1j7yn8w6().s[44]++;
var ButtonSpinner = function ButtonSpinner(_ref8) {
  var color = _ref8.color;
  cov_x1j7yn8w6().f[6]++;
  cov_x1j7yn8w6().s[45]++;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_29__.createElement(_Box_index_mjs__WEBPACK_IMPORTED_MODULE_41__/* ["default"] */ .Z, {
    "data-testid": "button-spinner",
    transition: "all ease-in-out 0.1s",
    position: "absolute",
    top: "50%",
    left: "50%",
    width: "20px",
    height: "20px",
    mt: "-10px",
    ml: "-10px",
    borderRadius: "rounded",
    border: "solid 3px transparent",
    color: "transparent",
    zIndex: 2,
    borderColor: color,
    borderBottomColor: "transparent",
    animation: "".concat(inProgressRotate, " 0.6s infinite linear"),
    _hover: {
      color: 'transparent'
    }
  });
};
var inProgressRotate = (cov_x1j7yn8w6().s[46]++, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_36__/* .keyframes */ .F4)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  to {\n    transform: rotate(360deg);\n  }\n"]))));

/***/ }),

/***/ 93298:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19601);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24614);
/* harmony import */ var _Box_index_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8013);
function cov_2idfc7fy2c() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Flex/Flex.tsx";
  var hash = "4fc6ce1e1ead4d462523f87184176f79f2c0b6dd";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Flex/Flex.tsx",
    statementMap: {
      "0": {
        start: {
          line: 15,
          column: 13
        },
        end: {
          line: 17,
          column: 2
        }
      },
      "1": {
        start: {
          line: 16,
          column: 2
        },
        end: {
          line: 16,
          column: 45
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 15,
            column: 42
          },
          end: {
            line: 15,
            column: 43
          }
        },
        loc: {
          start: {
            line: 16,
            column: 2
          },
          end: {
            line: 16,
            column: 45
          }
        },
        line: 16
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {
      "0": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "4fc6ce1e1ead4d462523f87184176f79f2c0b6dd"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2idfc7fy2c = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2idfc7fy2c();

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var Flex = (cov_2idfc7fy2c().s[0]++, (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)(function (props, ref) {
  cov_2idfc7fy2c().f[0]++;
  cov_2idfc7fy2c().s[1]++;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(_Box_index_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _extends({
    display: "flex",
    ref: ref
  }, props));
}));
/* harmony default export */ __webpack_exports__["Z"] = (Flex);

/***/ }),

/***/ 49154:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Icon_Icon; }
});

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(82526);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(41817);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__(32165);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.to-primitive.js
var es_symbol_to_primitive = __webpack_require__(96649);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__(57327);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__(89554);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__(82772);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(66992);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.date.to-primitive.js
var es_date_to_primitive = __webpack_require__(96078);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__(9653);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__(19601);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.define-properties.js
var es_object_define_properties = __webpack_require__(33321);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.define-property.js
var es_object_define_property = __webpack_require__(69070);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__(38880);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__(49337);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__(47941);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(41539);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(78783);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__(54747);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(33948);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(92222);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(68309);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/system/bricks.types.mjs
var bricks_types = __webpack_require__(26153);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/SpritesheetManifest.mjs
function cov_11wxv0t7j7() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetManifest.tsx";
  var hash = "18a09459aecac8299d5fee0b7966970d4815bb7a";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetManifest.tsx",
    statementMap: {
      "0": {
        start: {
          line: 8,
          column: 42
        },
        end: {
          line: 45,
          column: 1
        }
      },
      "1": {
        start: {
          line: 49,
          column: 44
        },
        end: {
          line: 52,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "18a09459aecac8299d5fee0b7966970d4815bb7a"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_11wxv0t7j7 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_11wxv0t7j7();
/**
 * Source of truth for Icons.
 * Adding an Icon here will kick off typechecking that will ensure
 * that an Icon is added to the "Spritesheet" that is included on
 * different pages.
 *
 */
var SPRITESHEET_ICONS_MANIFEST = (cov_11wxv0t7j7().s[0]++, {
  'arrow-left': true,
  'arrow-right': true,
  avatar: true,
  'center-focus-strong': true,
  'chevron-down-16': true,
  'close-16': true,
  'chat-inactive': true,
  checkmark: true,
  close: true,
  'chevron-down': true,
  'chevron-left': true,
  'chevron-right': true,
  'chevron-up': true,
  'contact-phone': true,
  date: true,
  'date-add': true,
  'date-checked': true,
  email: true,
  favorite: true,
  'favorite-filled': true,
  info: true,
  'invite-filled': true,
  'live-help': true,
  money: true,
  'new-tab': true,
  pdf: true,
  phone: true,
  plus: true,
  refresh: true,
  search: true,
  sign: true,
  'sign-filled': true,
  'unlock-left': true,
  'unlock-right': true,
  video: true,
  warning: true
});
var SIZE_SPECIFIC_ICONS_MANIFEST = (cov_11wxv0t7j7().s[1]++, {
  'chevron-left-12': true,
  'chevron-right-12': true
});
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/Icon.mjs
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }




















var _excluded = ["name", "size", "color", "viewBox"];
function cov_17iqqzwknt() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/Icon.tsx";
  var hash = "f9672941d0675340939188e1a6ed6d952e9b5c45";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/Icon.tsx",
    statementMap: {
      "0": {
        start: {
          line: 55,
          column: 34
        },
        end: {
          line: 91,
          column: 1
        }
      },
      "1": {
        start: {
          line: 65,
          column: 19
        },
        end: {
          line: 65,
          column: 31
        }
      },
      "2": {
        start: {
          line: 66,
          column: 2
        },
        end: {
          line: 68,
          column: 3
        }
      },
      "3": {
        start: {
          line: 67,
          column: 4
        },
        end: {
          line: 67,
          column: 23
        }
      },
      "4": {
        start: {
          line: 69,
          column: 2
        },
        end: {
          line: 71,
          column: 3
        }
      },
      "5": {
        start: {
          line: 70,
          column: 4
        },
        end: {
          line: 70,
          column: 26
        }
      },
      "6": {
        start: {
          line: 73,
          column: 29
        },
        end: {
          line: 73,
          column: 78
        }
      },
      "7": {
        start: {
          line: 75,
          column: 2
        },
        end: {
          line: 90,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 55,
            column: 34
          },
          end: {
            line: 55,
            column: 35
          }
        },
        loc: {
          start: {
            line: 63,
            column: 6
          },
          end: {
            line: 91,
            column: 1
          }
        },
        line: 63
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 57,
            column: 2
          },
          end: {
            line: 57,
            column: 11
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 57,
            column: 9
          },
          end: {
            line: 57,
            column: 11
          }
        }],
        line: 57
      },
      "1": {
        loc: {
          start: {
            line: 58,
            column: 9
          },
          end: {
            line: 58,
            column: 34
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 58,
            column: 21
          },
          end: {
            line: 58,
            column: 34
          }
        }],
        line: 58
      },
      "2": {
        loc: {
          start: {
            line: 61,
            column: 2
          },
          end: {
            line: 61,
            column: 23
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 61,
            column: 12
          },
          end: {
            line: 61,
            column: 23
          }
        }],
        line: 61
      },
      "3": {
        loc: {
          start: {
            line: 66,
            column: 2
          },
          end: {
            line: 68,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 66,
            column: 2
          },
          end: {
            line: 68,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 66
      },
      "4": {
        loc: {
          start: {
            line: 69,
            column: 2
          },
          end: {
            line: 71,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 69,
            column: 2
          },
          end: {
            line: 71,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 69
      },
      "5": {
        loc: {
          start: {
            line: 81,
            column: 15
          },
          end: {
            line: 81,
            column: 67
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 81,
            column: 36
          },
          end: {
            line: 81,
            column: 57
          }
        }, {
          start: {
            line: 81,
            column: 60
          },
          end: {
            line: 81,
            column: 67
          }
        }],
        line: 81
      },
      "6": {
        loc: {
          start: {
            line: 84,
            column: 23
          },
          end: {
            line: 84,
            column: 59
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 84,
            column: 39
          },
          end: {
            line: 84,
            column: 47
          }
        }, {
          start: {
            line: 84,
            column: 50
          },
          end: {
            line: 84,
            column: 59
          }
        }],
        line: 84
      },
      "7": {
        loc: {
          start: {
            line: 87,
            column: 7
          },
          end: {
            line: 87,
            column: 69
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 87,
            column: 7
          },
          end: {
            line: 87,
            column: 23
          }
        }, {
          start: {
            line: 87,
            column: 27
          },
          end: {
            line: 87,
            column: 69
          }
        }],
        line: 87
      },
      "8": {
        loc: {
          start: {
            line: 88,
            column: 7
          },
          end: {
            line: 88,
            column: 99
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 88,
            column: 28
          },
          end: {
            line: 88,
            column: 66
          }
        }, {
          start: {
            line: 88,
            column: 69
          },
          end: {
            line: 88,
            column: 99
          }
        }],
        line: 88
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0],
      "1": [0],
      "2": [0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "f9672941d0675340939188e1a6ed6d952e9b5c45"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_17iqqzwknt = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_17iqqzwknt();
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



/**
 * Icon references the named icons in the Spritesheet
 * `js/packages/bricks/src/core/Icon/Spritesheet.tsx`. The spritesheet
 * is injected once per page, each instance of Icon references the spritesheet
 * using an SVG `<use />` element.
 *
 * All icons support dynamic colors via the `color` prop.
 *
 * ## How to add Icons to Bricks
 *
 * 1. Add your new icon name to the SPRITESHEET_ICONS_MANIFEST in
 *    `./SpritesheetManifest.tsx` - this is the source of truth for icons.
 *
 * 2. Create a new file in `./SpritesheetIcons/YourNewIcon.tsx` with:
 *    ```
 *    const Icon: { name: 'your-icon-name'; svg: string } = {
 *      name: 'your-icon-name',
 *      svg: `<path ... fill="currentColor"/>`,
 *    };
 *    export default Icon;
 *    ```
 *
 * 3. Import and add to SPRITESHEET_ICONS in `./Spritesheet.tsx`
 *
 * ## Available Icons
 *
 * See SpritesheetManifest.tsx for the current list of available icons:
 * center-focus-strong, chat-inactive, checkmark, chevron-down, chevron-left,
 * chevron-right, chevron-up, contact-phone, date-add, date-checked, email,
 * favorite, favorite-filled, info, invite-filled, live-help, money, pdf,
 * phone, plus, refresh, search, sign, unlock-left, unlock-right, video, warning
 */
cov_17iqqzwknt().s[0]++;
var Icon = function Icon(_ref) {
  var name = _ref.name,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? (cov_17iqqzwknt().b[0][0]++, 24) : _ref$size,
    _ref$color = _ref.color,
    colorName = _ref$color === void 0 ? (cov_17iqqzwknt().b[1][0]++, 'neutrals100') : _ref$color,
    _ref$viewBox = _ref.viewBox,
    viewBox = _ref$viewBox === void 0 ? (cov_17iqqzwknt().b[2][0]++, '0 0 24 24') : _ref$viewBox,
    props = _objectWithoutProperties(_ref, _excluded);
  cov_17iqqzwknt().f[0]++;
  // Pass arbitrary styling props to the svg element, but remove `id` and `title` first
  var svgProps = (cov_17iqqzwknt().s[1]++, _objectSpread({}, props));
  cov_17iqqzwknt().s[2]++;
  if ('id' in svgProps) {
    cov_17iqqzwknt().b[3][0]++;
    cov_17iqqzwknt().s[3]++;
    delete svgProps.id;
  } else {
    cov_17iqqzwknt().b[3][1]++;
  }
  cov_17iqqzwknt().s[4]++;
  if ('title' in svgProps) {
    cov_17iqqzwknt().b[4][0]++;
    cov_17iqqzwknt().s[5]++;
    delete svgProps.title;
  } else {
    cov_17iqqzwknt().b[4][1]++;
  }
  var isSizeSpecificIcon = (cov_17iqqzwknt().s[6]++, "".concat(name, "-").concat(size) in SIZE_SPECIFIC_ICONS_MANIFEST);
  cov_17iqqzwknt().s[7]++;
  return /*#__PURE__*/react.createElement(bricks_types/* bricks.svg */.G.svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "".concat(name, "-icon"),
    width: "".concat(size, "px"),
    height: "".concat(size, "px"),
    viewBox: isSizeSpecificIcon ? (cov_17iqqzwknt().b[5][0]++, "0 0 ".concat(size, " ").concat(size)) : (cov_17iqqzwknt().b[5][1]++, viewBox),
    flexShrink: 0,
    color: colorName,
    "aria-labelledby": 'id' in props ? (cov_17iqqzwknt().b[6][0]++, props.id) : (cov_17iqqzwknt().b[6][1]++, undefined)
  }, svgProps), (cov_17iqqzwknt().b[7][0]++, 'title' in props) && (cov_17iqqzwknt().b[7][1]++, /*#__PURE__*/react.createElement("title", {
    id: props.id
  }, props.title)), isSizeSpecificIcon ? (cov_17iqqzwknt().b[8][0]++, /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#".concat(name, "-").concat(size)
  })) : (cov_17iqqzwknt().b[8][1]++, /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#".concat(name)
  })));
};
/* harmony default export */ var Icon_Icon = (Icon);

/***/ }),

/***/ 77972:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__) {

"use strict";
function cov_h1va2hsng() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Checkmark.tsx";
  var hash = "784188e5e7764a506fb9aa958865fa94eb34653c";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Checkmark.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 49
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "784188e5e7764a506fb9aa958865fa94eb34653c"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_h1va2hsng = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_h1va2hsng();
var Icon = (cov_h1va2hsng().s[0]++, {
  name: 'checkmark',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21.7929 5.03366C22.3266 5.47156 22.4043 6.2592 21.9664 6.79289L12.0728 18.8507C11.1726 19.9478 9.4941 19.9478 8.59396 18.8507L4.03369 13.2929C3.59579 12.7592 3.67345 11.9716 4.20714 11.5337C4.74084 11.0958 5.52847 11.1734 5.96638 11.7071L10.3334 17.0294L20.0337 5.2071C20.4716 4.67341 21.2592 4.59575 21.7929 5.03366Z\" fill=\"currentColor\"/>"
});
/* harmony default export */ __webpack_exports__["Z"] = (Icon);

/***/ }),

/***/ 4796:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Text */
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41817);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32165);
/* harmony import */ var core_js_modules_es_symbol_to_primitive_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96649);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57327);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89554);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82772);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(66992);
/* harmony import */ var core_js_modules_es_date_to_primitive_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96078);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9653);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(19601);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(33321);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69070);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(38880);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(49337);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(47941);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(78783);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(54747);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(33948);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_hooks__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(97375);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(24614);
/* harmony import */ var _hooks_useObservabilitySafe_mjs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(79652);
/* harmony import */ var _system_bricks_types_mjs__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(26153);
/* harmony import */ var _system_utils_index_mjs__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(48189);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }




















var _excluded = ["analyticsName", "trackImpression", "styles"],
  _excluded2 = ["size", "analyticsName"];
function cov_28joxrqmeg() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Text/Text.tsx";
  var hash = "686a6feeee470633d5f5df17b397f905dbc75013";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Text/Text.tsx",
    statementMap: {
      "0": {
        start: {
          line: 40,
          column: 25
        },
        end: {
          line: 53,
          column: 1
        }
      },
      "1": {
        start: {
          line: 42,
          column: 22
        },
        end: {
          line: 42,
          column: 94
        }
      },
      "2": {
        start: {
          line: 44,
          column: 4
        },
        end: {
          line: 51,
          column: 6
        }
      },
      "3": {
        start: {
          line: 186,
          column: 20
        },
        end: {
          line: 199,
          column: 2
        }
      },
      "4": {
        start: {
          line: 187,
          column: 17
        },
        end: {
          line: 187,
          column: 59
        }
      },
      "5": {
        start: {
          line: 188,
          column: 2
        },
        end: {
          line: 190,
          column: 3
        }
      },
      "6": {
        start: {
          line: 189,
          column: 4
        },
        end: {
          line: 189,
          column: 99
        }
      },
      "7": {
        start: {
          line: 191,
          column: 2
        },
        end: {
          line: 198,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 41,
            column: 2
          },
          end: {
            line: 41,
            column: 3
          }
        },
        loc: {
          start: {
            line: 41,
            column: 65
          },
          end: {
            line: 52,
            column: 3
          }
        },
        line: 41
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 186,
            column: 47
          },
          end: {
            line: 186,
            column: 48
          }
        },
        loc: {
          start: {
            line: 186,
            column: 91
          },
          end: {
            line: 199,
            column: 1
          }
        },
        line: 186
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 188,
            column: 2
          },
          end: {
            line: 190,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 188,
            column: 2
          },
          end: {
            line: 190,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 188
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "686a6feeee470633d5f5df17b397f905dbc75013"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_28joxrqmeg = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_28joxrqmeg();
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }







/**
 * NOTE ABOUT METRIC TRACKING: Text is set up to track impression events
 * It will only track impression events if:
 *  1) a non-empty analyticsName is passed down - Convention: {appName}-{textName}
 *  2) text enters viewport (threshold is set at 100% for now.  threshold: Number between 0 and 1 indicates the percentage that should be visible before triggering.)
 *
 * Events will be sent to the journey service and will end up in the corresponding tables (e.g. journey_service_production.text_view_event for text impression events)
 * For more information on tracking please refer here: https://opendoor.atlassian.net/wiki/spaces/SELL/pages/1926201404/EDD+User+Behavior+Metrics+in+Bricks
 */

var TextWithTracking = (cov_28joxrqmeg().s[0]++, (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_21__/* .forwardRef */ .Gp)(function (_ref, ref) {
  var analyticsName = _ref.analyticsName,
    trackImpression = _ref.trackImpression,
    styles = _ref.styles,
    props = _objectWithoutProperties(_ref, _excluded);
  cov_28joxrqmeg().f[0]++;
  var inViewRef = (cov_28joxrqmeg().s[1]++, (0,_hooks_useObservabilitySafe_mjs__WEBPACK_IMPORTED_MODULE_22__/* .useTrackComponentInView */ .O)('textViewEvent', trackImpression, analyticsName));
  cov_28joxrqmeg().s[2]++;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_20__.createElement(_system_bricks_types_mjs__WEBPACK_IMPORTED_MODULE_23__/* .bricks.p */ .G.p, _extends({
    // __css has a lower priority than sx
    __css: styles,
    ref: (0,_chakra_ui_hooks__WEBPACK_IMPORTED_MODULE_24__/* .useMergeRefs */ .qq)(inViewRef, ref)
  }, props));
}));

/**
 * Text renders as a <p> paragraph html element. It supports all of the p style
 * props. It is useful when rendering text or paragraphs as the default design
 * system styles will be applied to the text automatically.
 *
 * Note on the `as` prop
 *
 *
 * -------------------------
 *
 * As with most other components, you can pass `as` to render the `Text`
 * component as an HTML element other than the default. Currently the default is
 * `<p>`, which is a block-level element that typically has spacing above and
 * below. If you need an inline text element, use`<Text as="span">`. (`<p>` is
 * the default mainly for backwards-compatibility reasons. This may change in
 * the future. To help future-proof your code, feel free to use `<Text as="p">`
 * if you actively want your text rendered as a paragraph, but note that this
 * isn't a requirement.)
 *
 * Typography Sizes
 *
 *
 * --------------------
 *
 * The size options range from the very smallest (`80`) to the largest (`260`).
 * Consumers of the design system should never have to explicitly specify the
 * tokens or pixel values for `fontSize`, `lineHeight`, and other type styles.
 * Instead, by using the `size` prop on the typography components, type styles
 * will not only be standardized but also responsive as specified by design
 * standards.
 *
 * The size prop is not responsive but rather handles any responsive font sizes
 * under the hood. For example, size 210 is equal to `48px` on desktop and
 * tablet but `40px` on mobile.
 *
 * Text size variations
 * ---------------------------------------------------------------------------------------------
 *
 * "80"
 *
 * "90"
 *
 * "100"
 *
 * "110"
 *
 * "120"
 *
 * "130"
 *
 * "140"
 *
 * "150"
 *
 * "160"
 *
 * "170"
 *
 * "180"
 *
 * "190"
 *
 * "200"
 *
 * "210"
 *
 * "220"
 *
 * "230"
 *
 * "240"
 *
 * "250"
 *
 * "260"
 *
 * Font Families
 *
 *
 * -----------------
 *
 * Bricks uses three font family stacks, `mono`, `sans`, and `serif`.
 *
 * Text fontFamily variations
 * ---------------------------------------------------------------------------------------------------
 *
 * "mono"
 *
 * "sans"
 *
 * "serif"
 *
 * Font Weight
 *
 *
 * ---------------
 *
 * The weight options are `regular` (`400`), `semibold` (`600`), `bold` (`700`).
 *
 * Text fontWeight variations
 * ---------------------------------------------------------------------------------------------------
 *
 * "regular"
 *
 * "medium"
 *
 * "semibold"
 *
 * "bold"
 *
 * Analytics
 *
 *
 * -------------
 *
 * `Text` is set up to track impression events. It will only track impression
 * events if:
 *
 * 1.  a non-empty `analyticsName` is passed down (convention:
 * {appName}-{textName})
 *
 * 2.  passing `trackImpression={true}` Text impression events will only be
 * tracked the first time that the text enters the viewport
 *
 *
 * Events will be sent to the journey service and will end up in the
 * corresponding tables (e.g.
 * journey\_service\_production.platform\_text\_view\_event for text impression
 * events). For more information on tracking please refer
 * here:[https://opendoor.atlassian.net/wiki/spaces/CONSUMER/blog/2023/05/10/2304737293/Bricks+Events+Update](https://opendoor.atlassian.net/wiki/spaces/CONSUMER/blog/2023/05/10/2304737293/Bricks+Events+Update)
 */
var Text = (cov_28joxrqmeg().s[3]++, (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_21__/* .forwardRef */ .Gp)(function (_ref2, ref) {
  var size = _ref2.size,
    analyticsName = _ref2.analyticsName,
    props = _objectWithoutProperties(_ref2, _excluded2);
  cov_28joxrqmeg().f[1]++;
  var styles = (cov_28joxrqmeg().s[4]++, (0,_system_utils_index_mjs__WEBPACK_IMPORTED_MODULE_25__/* .useStyleConfig */ .mq)('Text', _objectSpread({
    size: size
  }, props)));
  cov_28joxrqmeg().s[5]++;
  if (analyticsName) {
    cov_28joxrqmeg().b[0][0]++;
    cov_28joxrqmeg().s[6]++;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_20__.createElement(TextWithTracking, _extends({
      analyticsName: analyticsName,
      styles: styles,
      ref: ref
    }, props));
  } else {
    cov_28joxrqmeg().b[0][1]++;
  }
  cov_28joxrqmeg().s[7]++;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_20__.createElement(_system_bricks_types_mjs__WEBPACK_IMPORTED_MODULE_23__/* .bricks.p */ .G.p, _extends({
    // __css has a lower priority than sx
    __css: styles,
    ref: ref
  }, props));
}));
/* harmony default export */ __webpack_exports__["Z"] = (Text);

/***/ }),

/***/ 61151:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ hooks_useMedia; },
  "F": function() { return /* binding */ useDevice; }
});

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(82526);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(41817);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__(32165);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__(91038);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(66992);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__(47042);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(68309);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(41539);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(74916);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.test.js
var es_regexp_test = __webpack_require__(77601);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__(39714);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(78783);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(33948);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(92222);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.global-this.js
var es_global_this = __webpack_require__(35837);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/theme/eero/foundations/breakpoints.mjs
var breakpoints = __webpack_require__(64863);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/hooks/useIsomorphicLayoutEffect.mjs
function cov_2dh2dxne21() {
  var path = "/__w/code/code/js/packages/bricks/src/hooks/useIsomorphicLayoutEffect.ts";
  var hash = "c5a9a093240f8be267e080122468e8aa6db250b2";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/hooks/useIsomorphicLayoutEffect.ts",
    statementMap: {
      "0": {
        start: {
          line: 9,
          column: 34
        },
        end: {
          line: 9,
          column: 93
        }
      }
    },
    fnMap: {},
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 9,
            column: 34
          },
          end: {
            line: 9,
            column: 93
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 9,
            column: 66
          },
          end: {
            line: 9,
            column: 81
          }
        }, {
          start: {
            line: 9,
            column: 84
          },
          end: {
            line: 9,
            column: 93
          }
        }],
        line: 9
      }
    },
    s: {
      "0": 0
    },
    f: {},
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "c5a9a093240f8be267e080122468e8aa6db250b2"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2dh2dxne21 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2dh2dxne21();


/**
 * useLayoutEffect on the client, useEffect when SSR.
 *
 * Both hooks are not executed on the server, but useLayoutEffect causes a warning in NextJS.
 * Using this hook instead of useLayoutEffect will prevent the warning.
 */
var useIsomorphicLayoutEffect = (cov_2dh2dxne21().s[0]++, typeof window !== 'undefined' ? (cov_2dh2dxne21().b[0][0]++, react.useLayoutEffect) : (cov_2dh2dxne21().b[0][1]++, react.useEffect));
/* harmony default export */ var hooks_useIsomorphicLayoutEffect = (useIsomorphicLayoutEffect);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/hooks/useMedia.mjs
function cov_1g41p4xppg() {
  var path = "/__w/code/code/js/packages/bricks/src/hooks/useMedia.ts";
  var hash = "785b3686517342cd307792e0d8b19924a5bb410c";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/hooks/useMedia.ts",
    statementMap: {
      "0": {
        start: {
          line: 15,
          column: 0
        },
        end: {
          line: 29,
          column: 4
        }
      },
      "1": {
        start: {
          line: 18,
          column: 4
        },
        end: {
          line: 28,
          column: 6
        }
      },
      "2": {
        start: {
          line: 19,
          column: 25
        },
        end: {
          line: 19,
          column: 34
        }
      },
      "3": {
        start: {
          line: 20,
          column: 30
        },
        end: {
          line: 20,
          column: 39
        }
      },
      "4": {
        start: {
          line: 21,
          column: 27
        },
        end: {
          line: 21,
          column: 32
        }
      },
      "5": {
        start: {
          line: 24,
          column: 22
        },
        end: {
          line: 24,
          column: 31
        }
      },
      "6": {
        start: {
          line: 25,
          column: 22
        },
        end: {
          line: 25,
          column: 31
        }
      },
      "7": {
        start: {
          line: 26,
          column: 28
        },
        end: {
          line: 26,
          column: 37
        }
      },
      "8": {
        start: {
          line: 27,
          column: 33
        },
        end: {
          line: 27,
          column: 42
        }
      },
      "9": {
        start: {
          line: 31,
          column: 17
        },
        end: {
          line: 53,
          column: 1
        }
      },
      "10": {
        start: {
          line: 32,
          column: 18
        },
        end: {
          line: 32,
          column: 30
        }
      },
      "11": {
        start: {
          line: 33,
          column: 28
        },
        end: {
          line: 33,
          column: 43
        }
      },
      "12": {
        start: {
          line: 35,
          column: 2
        },
        end: {
          line: 47,
          column: 14
        }
      },
      "13": {
        start: {
          line: 36,
          column: 16
        },
        end: {
          line: 36,
          column: 44
        }
      },
      "14": {
        start: {
          line: 37,
          column: 21
        },
        end: {
          line: 39,
          column: 5
        }
      },
      "15": {
        start: {
          line: 38,
          column: 6
        },
        end: {
          line: 38,
          column: 30
        }
      },
      "16": {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 41,
          column: 30
        }
      },
      "17": {
        start: {
          line: 42,
          column: 4
        },
        end: {
          line: 42,
          column: 26
        }
      },
      "18": {
        start: {
          line: 44,
          column: 4
        },
        end: {
          line: 46,
          column: 6
        }
      },
      "19": {
        start: {
          line: 45,
          column: 6
        },
        end: {
          line: 45,
          column: 35
        }
      },
      "20": {
        start: {
          line: 48,
          column: 2
        },
        end: {
          line: 51,
          column: 3
        }
      },
      "21": {
        start: {
          line: 49,
          column: 21
        },
        end: {
          line: 49,
          column: 49
        }
      },
      "22": {
        start: {
          line: 50,
          column: 4
        },
        end: {
          line: 50,
          column: 28
        }
      },
      "23": {
        start: {
          line: 52,
          column: 2
        },
        end: {
          line: 52,
          column: 15
        }
      },
      "24": {
        start: {
          line: 55,
          column: 43
        },
        end: {
          line: 62,
          column: 1
        }
      },
      "25": {
        start: {
          line: 64,
          column: 25
        },
        end: {
          line: 109,
          column: 1
        }
      },
      "26": {
        start: {
          line: 65,
          column: 35
        },
        end: {
          line: 65,
          column: 74
        }
      },
      "27": {
        start: {
          line: 66,
          column: 36
        },
        end: {
          line: 66,
          column: 51
        }
      },
      "28": {
        start: {
          line: 67,
          column: 2
        },
        end: {
          line: 69,
          column: 3
        }
      },
      "29": {
        start: {
          line: 68,
          column: 4
        },
        end: {
          line: 68,
          column: 44
        }
      },
      "30": {
        start: {
          line: 68,
          column: 20
        },
        end: {
          line: 68,
          column: 38
        }
      },
      "31": {
        start: {
          line: 70,
          column: 24
        },
        end: {
          line: 70,
          column: 76
        }
      },
      "32": {
        start: {
          line: 71,
          column: 19
        },
        end: {
          line: 71,
          column: 72
        }
      },
      "33": {
        start: {
          line: 73,
          column: 24
        },
        end: {
          line: 73,
          column: 96
        }
      },
      "34": {
        start: {
          line: 74,
          column: 19
        },
        end: {
          line: 76,
          column: 3
        }
      },
      "35": {
        start: {
          line: 77,
          column: 20
        },
        end: {
          line: 77,
          column: 69
        }
      },
      "36": {
        start: {
          line: 78,
          column: 25
        },
        end: {
          line: 78,
          column: 74
        }
      },
      "37": {
        start: {
          line: 80,
          column: 2
        },
        end: {
          line: 89,
          column: 6
        }
      },
      "38": {
        start: {
          line: 81,
          column: 4
        },
        end: {
          line: 89,
          column: 6
        }
      },
      "39": {
        start: {
          line: 90,
          column: 17
        },
        end: {
          line: 107,
          column: 94
        }
      },
      "40": {
        start: {
          line: 97,
          column: 4
        },
        end: {
          line: 97,
          column: 62
        }
      },
      "41": {
        start: {
          line: 97,
          column: 20
        },
        end: {
          line: 97,
          column: 62
        }
      },
      "42": {
        start: {
          line: 98,
          column: 4
        },
        end: {
          line: 106,
          column: 6
        }
      },
      "43": {
        start: {
          line: 108,
          column: 2
        },
        end: {
          line: 108,
          column: 16
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 17,
            column: 2
          },
          end: {
            line: 17,
            column: 3
          }
        },
        loc: {
          start: {
            line: 17,
            column: 14
          },
          end: {
            line: 29,
            column: 3
          }
        },
        line: 17
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 19,
            column: 19
          },
          end: {
            line: 19,
            column: 20
          }
        },
        loc: {
          start: {
            line: 19,
            column: 25
          },
          end: {
            line: 19,
            column: 34
          }
        },
        line: 19
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 20,
            column: 24
          },
          end: {
            line: 20,
            column: 25
          }
        },
        loc: {
          start: {
            line: 20,
            column: 30
          },
          end: {
            line: 20,
            column: 39
          }
        },
        line: 20
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 21,
            column: 21
          },
          end: {
            line: 21,
            column: 22
          }
        },
        loc: {
          start: {
            line: 21,
            column: 27
          },
          end: {
            line: 21,
            column: 32
          }
        },
        line: 21
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 24,
            column: 16
          },
          end: {
            line: 24,
            column: 17
          }
        },
        loc: {
          start: {
            line: 24,
            column: 22
          },
          end: {
            line: 24,
            column: 31
          }
        },
        line: 24
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 25,
            column: 16
          },
          end: {
            line: 25,
            column: 17
          }
        },
        loc: {
          start: {
            line: 25,
            column: 22
          },
          end: {
            line: 25,
            column: 31
          }
        },
        line: 25
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 26,
            column: 22
          },
          end: {
            line: 26,
            column: 23
          }
        },
        loc: {
          start: {
            line: 26,
            column: 28
          },
          end: {
            line: 26,
            column: 37
          }
        },
        line: 26
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 27,
            column: 27
          },
          end: {
            line: 27,
            column: 28
          }
        },
        loc: {
          start: {
            line: 27,
            column: 33
          },
          end: {
            line: 27,
            column: 42
          }
        },
        line: 27
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 31,
            column: 17
          },
          end: {
            line: 31,
            column: 18
          }
        },
        loc: {
          start: {
            line: 31,
            column: 36
          },
          end: {
            line: 53,
            column: 1
          }
        },
        line: 31
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 35,
            column: 28
          },
          end: {
            line: 35,
            column: 29
          }
        },
        loc: {
          start: {
            line: 35,
            column: 34
          },
          end: {
            line: 47,
            column: 3
          }
        },
        line: 35
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 37,
            column: 21
          },
          end: {
            line: 37,
            column: 22
          }
        },
        loc: {
          start: {
            line: 37,
            column: 27
          },
          end: {
            line: 39,
            column: 5
          }
        },
        line: 37
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 44,
            column: 11
          },
          end: {
            line: 44,
            column: 12
          }
        },
        loc: {
          start: {
            line: 44,
            column: 17
          },
          end: {
            line: 46,
            column: 5
          }
        },
        line: 44
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 64,
            column: 25
          },
          end: {
            line: 64,
            column: 26
          }
        },
        loc: {
          start: {
            line: 64,
            column: 71
          },
          end: {
            line: 109,
            column: 1
          }
        },
        line: 64
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 68,
            column: 14
          },
          end: {
            line: 68,
            column: 15
          }
        },
        loc: {
          start: {
            line: 68,
            column: 20
          },
          end: {
            line: 68,
            column: 38
          }
        },
        line: 68
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 90,
            column: 25
          },
          end: {
            line: 90,
            column: 26
          }
        },
        loc: {
          start: {
            line: 90,
            column: 31
          },
          end: {
            line: 107,
            column: 3
          }
        },
        line: 90
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 16,
            column: 2
          },
          end: {
            line: 29,
            column: 3
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 16,
            column: 2
          },
          end: {
            line: 16,
            column: 23
          }
        }, {
          start: {
            line: 17,
            column: 2
          },
          end: {
            line: 29,
            column: 3
          }
        }],
        line: 16
      },
      "1": {
        loc: {
          start: {
            line: 48,
            column: 2
          },
          end: {
            line: 51,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 48,
            column: 2
          },
          end: {
            line: 51,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 48
      },
      "2": {
        loc: {
          start: {
            line: 65,
            column: 35
          },
          end: {
            line: 65,
            column: 74
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 65,
            column: 35
          },
          end: {
            line: 65,
            column: 39
          }
        }, {
          start: {
            line: 65,
            column: 43
          },
          end: {
            line: 65,
            column: 74
          }
        }],
        line: 65
      },
      "3": {
        loc: {
          start: {
            line: 67,
            column: 2
          },
          end: {
            line: 69,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 67,
            column: 2
          },
          end: {
            line: 69,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 67
      },
      "4": {
        loc: {
          start: {
            line: 80,
            column: 2
          },
          end: {
            line: 89,
            column: 6
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 80,
            column: 2
          },
          end: {
            line: 89,
            column: 6
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 80
      },
      "5": {
        loc: {
          start: {
            line: 97,
            column: 4
          },
          end: {
            line: 97,
            column: 62
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 97,
            column: 4
          },
          end: {
            line: 97,
            column: 62
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 97
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "785b3686517342cd307792e0d8b19924a5bb410c"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1g41p4xppg = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1g41p4xppg();
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }



function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }




function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }








/* eslint-disable react-hooks/rules-of-hooks */

/*
  useMedia is a React hook that tracks the state of a CSS media query
  
  usage:
  const isMobile = useMedia('(max-width: 480px)')
  */




// Stub matchMedia for SSR+Jest
cov_1g41p4xppg().s[0]++;
globalThis.matchMedia = (cov_1g41p4xppg().b[0][0]++, globalThis.matchMedia) || (cov_1g41p4xppg().b[0][1]++, function () {
  cov_1g41p4xppg().f[0]++;
  cov_1g41p4xppg().s[1]++;
  return {
    addListener: function addListener() {
      cov_1g41p4xppg().f[1]++;
      cov_1g41p4xppg().s[2]++;
      return undefined;
    },
    addEventListener: function addEventListener() {
      cov_1g41p4xppg().f[2]++;
      cov_1g41p4xppg().s[3]++;
      return undefined;
    },
    dispatchEvent: function dispatchEvent() {
      cov_1g41p4xppg().f[3]++;
      cov_1g41p4xppg().s[4]++;
      return false;
    },
    matches: false,
    media: '',
    onChange: function onChange() {
      cov_1g41p4xppg().f[4]++;
      cov_1g41p4xppg().s[5]++;
      return undefined;
    },
    onchange: function onchange() {
      cov_1g41p4xppg().f[5]++;
      cov_1g41p4xppg().s[6]++;
      return undefined;
    },
    removeListener: function removeListener() {
      cov_1g41p4xppg().f[6]++;
      cov_1g41p4xppg().s[7]++;
      return undefined;
    },
    removeEventListener: function removeEventListener() {
      cov_1g41p4xppg().f[7]++;
      cov_1g41p4xppg().s[8]++;
      return undefined;
    }
  };
});
cov_1g41p4xppg().s[9]++;
var useMedia = function useMedia(query) {
  cov_1g41p4xppg().f[8]++;
  var isFirst = (cov_1g41p4xppg().s[10]++, (0,react.useRef)(true));
  var _ref = (cov_1g41p4xppg().s[11]++, (0,react.useState)(false)),
    _ref2 = _slicedToArray(_ref, 2),
    state = _ref2[0],
    setState = _ref2[1];
  cov_1g41p4xppg().s[12]++;
  hooks_useIsomorphicLayoutEffect(function () {
    cov_1g41p4xppg().f[9]++;
    var mql = (cov_1g41p4xppg().s[13]++, globalThis.matchMedia(query));
    cov_1g41p4xppg().s[14]++;
    var onChange = function onChange() {
      cov_1g41p4xppg().f[10]++;
      cov_1g41p4xppg().s[15]++;
      setState(!!mql.matches);
    };
    cov_1g41p4xppg().s[16]++;
    mql.addListener(onChange);
    cov_1g41p4xppg().s[17]++;
    setState(mql.matches);
    cov_1g41p4xppg().s[18]++;
    return function () {
      cov_1g41p4xppg().f[11]++;
      cov_1g41p4xppg().s[19]++;
      mql.removeListener(onChange);
    };
  }, [query]);
  cov_1g41p4xppg().s[20]++;
  if (isFirst.current) {
    cov_1g41p4xppg().b[1][0]++;
    var firstMQL = (cov_1g41p4xppg().s[21]++, globalThis.matchMedia(query));
    cov_1g41p4xppg().s[22]++;
    return firstMQL.matches;
  } else {
    cov_1g41p4xppg().b[1][1]++;
  }
  cov_1g41p4xppg().s[23]++;
  return state;
};
var MEDIA_QUERY_CONTEXT_DEFAULT_VALUES = (cov_1g41p4xppg().s[24]++, {
  isSmallMobile: false,
  isMobile: false,
  isSmallTablet: false,
  isTablet: false,
  isDesktop: false,
  isLargeDesktop: false
});
cov_1g41p4xppg().s[25]++;
var useDevice = function useDevice(opts) {
  cov_1g41p4xppg().f[12]++;
  var _ref3 = (cov_1g41p4xppg().s[26]++, (cov_1g41p4xppg().b[2][0]++, opts) || (cov_1g41p4xppg().b[2][1]++, {
      reevaluateAfterMount: false
    })),
    reevaluateAfterMount = _ref3.reevaluateAfterMount;
  var _ref4 = (cov_1g41p4xppg().s[27]++, (0,react.useState)(false)),
    _ref5 = _slicedToArray(_ref4, 2),
    isMounted = _ref5[0],
    setIsMounted = _ref5[1];
  cov_1g41p4xppg().s[28]++;
  if (reevaluateAfterMount) {
    cov_1g41p4xppg().b[3][0]++;
    cov_1g41p4xppg().s[29]++;
    (0,react.useEffect)(function () {
      cov_1g41p4xppg().f[13]++;
      cov_1g41p4xppg().s[30]++;
      return setIsMounted(true);
    }, []);
  } else {
    cov_1g41p4xppg().b[3][1]++;
  }
  var isSmallMobile = (cov_1g41p4xppg().s[31]++, useMedia("(max-width: ".concat(breakpoints/* BREAKPOINTS_DICT.SM */.lU.SM - 1, "px")));
  var isMobile = (cov_1g41p4xppg().s[32]++, useMedia("(max-width: ".concat(breakpoints/* BREAKPOINTS_DICT.MD */.lU.MD - 1, "px)")));
  /** @deprecated */
  var isSmallTablet = (cov_1g41p4xppg().s[33]++, useMedia("(min-width: ".concat(breakpoints/* BREAKPOINTS_DICT.MD */.lU.MD, "px) and (max-width: 992px)")));
  var isTablet = (cov_1g41p4xppg().s[34]++, useMedia("(min-width: ".concat(breakpoints/* BREAKPOINTS_DICT.MD */.lU.MD, "px) and (max-width: ").concat(breakpoints/* BREAKPOINTS_DICT.LG */.lU.LG - 1, "px)")));
  var isDesktop = (cov_1g41p4xppg().s[35]++, useMedia("(min-width: ".concat(breakpoints/* BREAKPOINTS_DICT.LG */.lU.LG, "px)")));
  var isLargeDesktop = (cov_1g41p4xppg().s[36]++, useMedia("(min-width: ".concat(breakpoints/* BREAKPOINTS_DICT.XL */.lU.XL, "px)")));
  // If we don't need to reevaluate after mount, we can return the values immediately
  cov_1g41p4xppg().s[37]++;
  if (!reevaluateAfterMount) {
    cov_1g41p4xppg().b[4][0]++;
    cov_1g41p4xppg().s[38]++;
    return {
      isSmallMobile: isSmallMobile,
      isMobile: isMobile,
      /** @deprecated*/
      isSmallTablet: isSmallTablet,
      isTablet: isTablet,
      isDesktop: isDesktop,
      isLargeDesktop: isLargeDesktop
    };
  } else {
    cov_1g41p4xppg().b[4][1]++;
  }
  var values = (cov_1g41p4xppg().s[39]++, (0,react.useMemo)(function () {
    cov_1g41p4xppg().f[14]++;
    cov_1g41p4xppg().s[40]++;
    /**
     * This reevaluates after mount
     * Since we're using breakpoints in locations that are server-sided rendered, using
     * just the `useMedia` by itself will cause hydration issues. This is why we're
     * returning the default values if the component hasn't been mounted yet.
     */
    if (!isMounted) {
      cov_1g41p4xppg().b[5][0]++;
      cov_1g41p4xppg().s[41]++;
      return MEDIA_QUERY_CONTEXT_DEFAULT_VALUES;
    } else {
      cov_1g41p4xppg().b[5][1]++;
    }
    cov_1g41p4xppg().s[42]++;
    return {
      isSmallMobile: isSmallMobile,
      isMobile: isMobile,
      /** @deprecated*/
      isSmallTablet: isSmallTablet,
      isTablet: isTablet,
      isDesktop: isDesktop,
      isLargeDesktop: isLargeDesktop
    };
  }, [isMounted, isSmallMobile, isMobile, isSmallTablet, isTablet, isDesktop, isLargeDesktop]));
  cov_1g41p4xppg().s[43]++;
  return values;
};
/* harmony default export */ var hooks_useMedia = (useMedia);

/***/ }),

/***/ 79652:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "r": function() { return /* binding */ useObservabilitySafe; },
  "O": function() { return /* binding */ useTrackComponentInView; }
});

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(82526);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(41817);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__(32165);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.to-primitive.js
var es_symbol_to_primitive = __webpack_require__(96649);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__(57327);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__(89554);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__(91038);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(66992);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__(47042);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.date.to-primitive.js
var es_date_to_primitive = __webpack_require__(96078);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(68309);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__(9653);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.define-properties.js
var es_object_define_properties = __webpack_require__(33321);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.define-property.js
var es_object_define_property = __webpack_require__(69070);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__(38880);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__(49337);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__(47941);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(41539);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(74916);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.test.js
var es_regexp_test = __webpack_require__(77601);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__(39714);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(78783);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__(54747);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(33948);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/node_modules/react-intersection-observer/dist/index.mjs
"use client";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);

// src/InView.tsx


// src/observe.ts
var observerMap = /* @__PURE__ */ new Map();
var RootIds = /* @__PURE__ */ new WeakMap();
var rootId = 0;
var unsupportedValue = void 0;
function defaultFallbackInView(inView) {
  unsupportedValue = inView;
}
function getRootId(root) {
  if (!root) return "0";
  if (RootIds.has(root)) return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
function optionsToId(options) {
  return Object.keys(options).sort().filter(
    (key) => options[key] !== void 0
  ).map((key) => {
    return `${key}_${key === "root" ? getRootId(options.root) : options[key]}`;
  }).toString();
}
function createObserver(options) {
  const id = optionsToId(options);
  let instance = observerMap.get(id);
  if (!instance) {
    const elements = /* @__PURE__ */ new Map();
    let thresholds;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        var _a;
        const inView = entry.isIntersecting && thresholds.some((threshold) => entry.intersectionRatio >= threshold);
        if (options.trackVisibility && typeof entry.isVisible === "undefined") {
          entry.isVisible = inView;
        }
        (_a = elements.get(entry.target)) == null ? void 0 : _a.forEach((callback) => {
          callback(inView, entry);
        });
      });
    }, options);
    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id,
      observer,
      elements
    };
    observerMap.set(id, instance);
  }
  return instance;
}
function observe(element, callback, options = {}, fallbackInView = unsupportedValue) {
  if (typeof window.IntersectionObserver === "undefined" && fallbackInView !== void 0) {
    const bounds = element.getBoundingClientRect();
    callback(fallbackInView, {
      isIntersecting: fallbackInView,
      target: element,
      intersectionRatio: typeof options.threshold === "number" ? options.threshold : 0,
      time: 0,
      boundingClientRect: bounds,
      intersectionRect: bounds,
      rootBounds: bounds
    });
    return () => {
    };
  }
  const { id, observer, elements } = createObserver(options);
  const callbacks = elements.get(element) || [];
  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }
  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    callbacks.splice(callbacks.indexOf(callback), 1);
    if (callbacks.length === 0) {
      elements.delete(element);
      observer.unobserve(element);
    }
    if (elements.size === 0) {
      observer.disconnect();
      observerMap.delete(id);
    }
  };
}

// src/InView.tsx
function isPlainChildren(props) {
  return typeof props.children !== "function";
}
var InView = class extends react.Component {
  constructor(props) {
    super(props);
    __publicField(this, "node", null);
    __publicField(this, "_unobserveCb", null);
    __publicField(this, "handleNode", (node) => {
      if (this.node) {
        this.unobserve();
        if (!node && !this.props.triggerOnce && !this.props.skip) {
          this.setState({ inView: !!this.props.initialInView, entry: void 0 });
        }
      }
      this.node = node ? node : null;
      this.observeNode();
    });
    __publicField(this, "handleChange", (inView, entry) => {
      if (inView && this.props.triggerOnce) {
        this.unobserve();
      }
      if (!isPlainChildren(this.props)) {
        this.setState({ inView, entry });
      }
      if (this.props.onChange) {
        this.props.onChange(inView, entry);
      }
    });
    this.state = {
      inView: !!props.initialInView,
      entry: void 0
    };
  }
  componentDidMount() {
    this.unobserve();
    this.observeNode();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  }
  componentWillUnmount() {
    this.unobserve();
  }
  observeNode() {
    if (!this.node || this.props.skip) return;
    const {
      threshold,
      root,
      rootMargin,
      trackVisibility,
      delay,
      fallbackInView
    } = this.props;
    this._unobserveCb = observe(
      this.node,
      this.handleChange,
      {
        threshold,
        root,
        rootMargin,
        // @ts-ignore
        trackVisibility,
        // @ts-ignore
        delay
      },
      fallbackInView
    );
  }
  unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();
      this._unobserveCb = null;
    }
  }
  render() {
    const { children } = this.props;
    if (typeof children === "function") {
      const { inView, entry } = this.state;
      return children({ inView, entry, ref: this.handleNode });
    }
    const {
      as,
      triggerOnce,
      threshold,
      root,
      rootMargin,
      onChange,
      skip,
      trackVisibility,
      delay,
      initialInView,
      fallbackInView,
      ...props
    } = this.props;
    return React.createElement(
      as || "div",
      { ref: this.handleNode, ...props },
      children
    );
  }
};

// src/useInView.tsx

function useInView({
  threshold,
  delay,
  trackVisibility,
  rootMargin,
  root,
  triggerOnce,
  skip,
  initialInView,
  fallbackInView,
  onChange
} = {}) {
  var _a;
  const [ref, setRef] = react.useState(null);
  const callback = react.useRef(onChange);
  const [state, setState] = react.useState({
    inView: !!initialInView,
    entry: void 0
  });
  callback.current = onChange;
  react.useEffect(
    () => {
      if (skip || !ref) return;
      let unobserve;
      unobserve = observe(
        ref,
        (inView, entry) => {
          setState({
            inView,
            entry
          });
          if (callback.current) callback.current(inView, entry);
          if (entry.isIntersecting && triggerOnce && unobserve) {
            unobserve();
            unobserve = void 0;
          }
        },
        {
          root,
          rootMargin,
          threshold,
          // @ts-ignore
          trackVisibility,
          // @ts-ignore
          delay
        },
        fallbackInView
      );
      return () => {
        if (unobserve) {
          unobserve();
        }
      };
    },
    // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      // If the threshold is an array, convert it to a string, so it won't change between renders.
      Array.isArray(threshold) ? threshold.toString() : threshold,
      ref,
      root,
      rootMargin,
      triggerOnce,
      skip,
      trackVisibility,
      fallbackInView,
      delay
    ]
  );
  const entryTarget = (_a = state.entry) == null ? void 0 : _a.target;
  const previousEntryTarget = react.useRef(void 0);
  if (!ref && entryTarget && !triggerOnce && !skip && previousEntryTarget.current !== entryTarget) {
    previousEntryTarget.current = entryTarget;
    setState({
      inView: !!initialInView,
      entry: void 0
    });
  }
  const result = [setRef, state.inView, state.entry];
  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}

//# sourceMappingURL=index.mjs.map
// EXTERNAL MODULE: ./node_modules/@opendoor/observability/dist/chunk-SXEEZYFT.mjs + 1 modules
var chunk_SXEEZYFT = __webpack_require__(68751);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-rum/esm/entries/main.js + 15 modules
var main = __webpack_require__(86947);
;// CONCATENATED MODULE: ./node_modules/@opendoor/observability/dist/observability.mjs
/* provided dependency */ var process = __webpack_require__(34155);


// src/internal/builtin.ts


var defaultInitSentry = (sentryOptions) => {
  Sentry.init(sentryOptions);
  return Sentry.getCurrentHub();
};
var defaultInitDatadogRumClient = (datadogInitOpts) => {
  datadogRum.init({ ...datadogInitOpts });
  datadogRum.startSessionReplayRecording();
  return datadogRum;
};
var loadSentry = (url, sentryOptions = {}) => {
  const env = getDeployEnv();
  const gitSha = process.env.REACT_APP_GIT_SHA || "unknown";
  defaultInitSentry({
    ...buildDefaultSentryOpts({ appName: "", env, version: gitSha }),
    ...sentryOptions,
    dsn: url
  });
};

// src/observability.ts
function initObservability({
  appName,
  env,
  version,
  eventTrackingCategory,
  sentry,
  datadog,
  debug,
  sendJourneyEventsInDev,
  journeyEventHelpers,
  journeyEndpoint,
  isInternalTool,
  isBot
}) {
  if (globalObservability.isInitialized()) {
    throw new Error("initObservability was already called");
  }
  env = env || getDeployEnv();
  if (env === "development") {
    let journeyEventClient = void 0;
    if (sendJourneyEventsInDev) {
      const { eventClient } = initJourney(BASE_JOURNEY_ENDPOINT);
      journeyEventClient = eventClient;
    }
    globalObservability.setCurrentInstance(
      new DebugObservability(
        { log: debug, sendJourneyEventsInDev, journeyEventClient, env },
        eventTrackingCategory,
        journeyEventHelpers
      )
    );
  } else {
    if (isInternalTool !== true && !isBot) {
      loadGoogleTagManager();
    }
    if (!isBot) {
      loadSegment();
    }
    const realObservabilityInstance = new RealObservability(eventTrackingCategory, journeyEventHelpers);
    if (!isBot) {
      const { eventClient, userClient } = initJourney(journeyEndpoint);
      userClient && realObservabilityInstance.setJourneyUserClient(userClient);
      eventClient && realObservabilityInstance.setJourneyEventClient(eventClient);
    }
    realObservabilityInstance.setSentryClient(
      defaultInitSentry({ ...buildDefaultSentryOpts({ appName, env, version }), ...sentry })
    );
    realObservabilityInstance.setDatadogRumClient(
      defaultInitDatadogRumClient({
        ...buildDefaultDatadogOptions({ appName, env, version }),
        ...datadog
      })
    );
    globalObservability.setCurrentInstance(realObservabilityInstance);
  }
}


;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/hooks/useObservabilitySafe.mjs
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
























function cov_2ivfm6f0vc() {
  var path = "/__w/code/code/js/packages/bricks/src/hooks/useObservabilitySafe.ts";
  var hash = "5836c9acf698fa74a3b0eb4d7d017c89841e55bf";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/hooks/useObservabilitySafe.ts",
    statementMap: {
      "0": {
        start: {
          line: 13,
          column: 36
        },
        end: {
          line: 38,
          column: 1
        }
      },
      "1": {
        start: {
          line: 17,
          column: 48
        },
        end: {
          line: 21,
          column: 5
        }
      },
      "2": {
        start: {
          line: 22,
          column: 2
        },
        end: {
          line: 37,
          column: 4
        }
      },
      "3": {
        start: {
          line: 23,
          column: 11
        },
        end: {
          line: 34,
          column: 5
        }
      },
      "4": {
        start: {
          line: 25,
          column: 8
        },
        end: {
          line: 27,
          column: 18
        }
      },
      "5": {
        start: {
          line: 26,
          column: 10
        },
        end: {
          line: 26,
          column: 32
        }
      },
      "6": {
        start: {
          line: 30,
          column: 8
        },
        end: {
          line: 32,
          column: 18
        }
      },
      "7": {
        start: {
          line: 31,
          column: 10
        },
        end: {
          line: 31,
          column: 37
        }
      },
      "8": {
        start: {
          line: 55,
          column: 39
        },
        end: {
          line: 83,
          column: 1
        }
      },
      "9": {
        start: {
          line: 61,
          column: 32
        },
        end: {
          line: 61,
          column: 54
        }
      },
      "10": {
        start: {
          line: 64,
          column: 30
        },
        end: {
          line: 72,
          column: 4
        }
      },
      "11": {
        start: {
          line: 74,
          column: 2
        },
        end: {
          line: 80,
          column: 47
        }
      },
      "12": {
        start: {
          line: 76,
          column: 4
        },
        end: {
          line: 78,
          column: 5
        }
      },
      "13": {
        start: {
          line: 77,
          column: 6
        },
        end: {
          line: 77,
          column: 78
        }
      },
      "14": {
        start: {
          line: 82,
          column: 2
        },
        end: {
          line: 82,
          column: 47
        }
      },
      "15": {
        start: {
          line: 82,
          column: 23
        },
        end: {
          line: 82,
          column: 32
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 13,
            column: 36
          },
          end: {
            line: 13,
            column: 37
          }
        },
        loc: {
          start: {
            line: 16,
            column: 5
          },
          end: {
            line: 38,
            column: 1
          }
        },
        line: 16
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 23,
            column: 4
          },
          end: {
            line: 23,
            column: 5
          }
        },
        loc: {
          start: {
            line: 23,
            column: 11
          },
          end: {
            line: 34,
            column: 5
          }
        },
        line: 23
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 24,
            column: 22
          },
          end: {
            line: 24,
            column: 23
          }
        },
        loc: {
          start: {
            line: 24,
            column: 44
          },
          end: {
            line: 28,
            column: 7
          }
        },
        line: 24
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 29,
            column: 25
          },
          end: {
            line: 29,
            column: 26
          }
        },
        loc: {
          start: {
            line: 29,
            column: 76
          },
          end: {
            line: 33,
            column: 7
          }
        },
        line: 29
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 55,
            column: 39
          },
          end: {
            line: 55,
            column: 40
          }
        },
        loc: {
          start: {
            line: 60,
            column: 16
          },
          end: {
            line: 83,
            column: 1
          }
        },
        line: 60
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 74,
            column: 12
          },
          end: {
            line: 74,
            column: 13
          }
        },
        loc: {
          start: {
            line: 74,
            column: 18
          },
          end: {
            line: 80,
            column: 3
          }
        },
        line: 74
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 82,
            column: 17
          },
          end: {
            line: 82,
            column: 18
          }
        },
        loc: {
          start: {
            line: 82,
            column: 23
          },
          end: {
            line: 82,
            column: 32
          }
        },
        line: 82
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 76,
            column: 4
          },
          end: {
            line: 78,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 76,
            column: 4
          },
          end: {
            line: 78,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 76
      },
      "1": {
        loc: {
          start: {
            line: 76,
            column: 8
          },
          end: {
            line: 76,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 76,
            column: 8
          },
          end: {
            line: 76,
            column: 14
          }
        }, {
          start: {
            line: 76,
            column: 18
          },
          end: {
            line: 76,
            column: 31
          }
        }, {
          start: {
            line: 76,
            column: 35
          },
          end: {
            line: 76,
            column: 50
          }
        }],
        line: 76
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "5836c9acf698fa74a3b0eb4d7d017c89841e55bf"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2ivfm6f0vc = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2ivfm6f0vc();
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }



/**
 * This wrapper hook is added because not every FE app is onboarded to use observability, and observability
 * expects `globalObservability` to have been initialized when `trackUserEvent` is called. Thus, within the
 * scope of `bricks`, we catch any errors of the real `trackUserEvent` call.
 */
cov_2ivfm6f0vc().s[0]++;
var useObservabilitySafe = function useObservabilitySafe() {
  cov_2ivfm6f0vc().f[0]++;
  var _ref = (cov_2ivfm6f0vc().s[1]++, (0,chunk_SXEEZYFT/* useObservability */.C3)()),
    _trackUserEvent = _ref.trackUserEvent,
    _trackJourneyEvent = _ref.trackJourneyEvent;
  cov_2ivfm6f0vc().s[2]++;
  return (0,react.useMemo)(function () {
    cov_2ivfm6f0vc().f[1]++;
    cov_2ivfm6f0vc().s[3]++;
    return {
      trackUserEvent: function trackUserEvent(event) {
        cov_2ivfm6f0vc().f[2]++;
        cov_2ivfm6f0vc().s[4]++;
        try {
          cov_2ivfm6f0vc().s[5]++;
          _trackUserEvent(event);
        } catch (_unused) {} // eslint-disable-line no-empty
      },
      trackJourneyEvent: function trackJourneyEvent() {
        cov_2ivfm6f0vc().f[3]++;
        cov_2ivfm6f0vc().s[6]++;
        try {
          cov_2ivfm6f0vc().s[7]++;
          _trackJourneyEvent.apply(void 0, arguments);
        } catch (_unused2) {} // eslint-disable-line no-empty
      }
    };
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
};

/**
 * Bricks specific event name extracted from EventWrapper protobuf
 */
/**
 * This hook is used to track component in view events. It is used to track the first time a component enters the viewport.
 * @param eventName - The event name to track
 * @param trackImpression - Whether or not to track impression events
 * @param analyticsName - The name of the component to track
 * @returns A ref to be passed to the component which is used to trigger the inView event
 */
cov_2ivfm6f0vc().s[8]++;
var useTrackComponentInView = function useTrackComponentInView(eventName, trackImpression, analyticsName, options) {
  cov_2ivfm6f0vc().f[4]++;
  var _ref2 = (cov_2ivfm6f0vc().s[9]++, useObservabilitySafe()),
    trackJourneyEvent = _ref2.trackJourneyEvent;

  // Tracks impression events
  var _ref3 = (cov_2ivfm6f0vc().s[10]++, useInView(_objectSpread({
      // https://react-intersection-observer.vercel.app/?path=/docs/useinview-hook--basic
      // threshold: Number between 0 and 1 indicates the percentage that should be visible
      // before triggering. (defaults to 100% unless an override is provided)
      threshold: 1,
      skip: !analyticsName,
      triggerOnce: true
    }, options))),
    _ref4 = _slicedToArray(_ref3, 2),
    inViewRef = _ref4[0],
    inView = _ref4[1];
  cov_2ivfm6f0vc().s[11]++;
  (0,react.useEffect)(function () {
    cov_2ivfm6f0vc().f[5]++;
    cov_2ivfm6f0vc().s[12]++;
    // this tracks impression events whenenver the component enters or leaves the viewport
    if ((cov_2ivfm6f0vc().b[1][0]++, inView) && (cov_2ivfm6f0vc().b[1][1]++, analyticsName) && (cov_2ivfm6f0vc().b[1][2]++, trackImpression)) {
      cov_2ivfm6f0vc().b[0][0]++;
      cov_2ivfm6f0vc().s[13]++;
      trackJourneyEvent('platform', eventName, {
        targetName: analyticsName
      });
    } else {
      cov_2ivfm6f0vc().b[0][1]++;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView, analyticsName, trackImpression]);
  cov_2ivfm6f0vc().s[14]++;
  return (0,react.useMemo)(function () {
    cov_2ivfm6f0vc().f[6]++;
    cov_2ivfm6f0vc().s[15]++;
    return inViewRef;
  }, [inViewRef]);
};

/***/ }),

/***/ 75590:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ Reset; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70917);
function cov_10ph4dp91i() {
  var path = "/__w/code/code/js/packages/bricks/src/styles/Reset.tsx";
  var hash = "171710c0e429b32e8942f5863dd77f32dda765d1";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/styles/Reset.tsx",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 31
        },
        end: {
          line: 65,
          column: 1
        }
      },
      "1": {
        start: {
          line: 11,
          column: 2
        },
        end: {
          line: 64,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 10,
            column: 31
          },
          end: {
            line: 10,
            column: 32
          }
        },
        loc: {
          start: {
            line: 11,
            column: 2
          },
          end: {
            line: 64,
            column: 4
          }
        },
        line: 11
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {
      "0": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "171710c0e429b32e8942f5863dd77f32dda765d1"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_10ph4dp91i = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_10ph4dp91i();



/**
 * Globally defined style baselines for the theme.
 * Currently font are also defined in packages/primer/stylesheets/reset.less -
 * this will ultimately replace the less file.
 */
cov_10ph4dp91i().s[0]++;
var Reset = function Reset() {
  cov_10ph4dp91i().f[0]++;
  cov_10ph4dp91i().s[1]++;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .Global */ .xB, {
    styles: " \n      html,\n      body {\n        margin: 0;\n        padding: 0;\n        background-color: var(--colors-neutrals0);\n\n        // Base font size for all breakpoints\n        font: 400 16px / 1.7 'Graphik', sans-serif;\n        color: var(--colors-neutrals100);\n      }\n\n      p {\n        margin-block-start: 0px;\n        margin-block-end: 0px;\n      }\n\n      html {\n        height: 100%;\n      }\n\n      body {\n        min-height: 100%;\n      }\n\n      main {\n        flex: 1;\n        -ms-flex-preferred-size: auto; /* Fix for IE10 */\n      }\n\n      input:-webkit-autofill {\n        background-color: var(--colors-neutrals0)!important;\n      }\n\n      :focus {\n        border-color: var(--colors-brand50);\n      }\n\n      /* hide outline *during* click, but not after */\n      :focus:active {\n        outline: 0;\n      } ]\n\n      ul {\n        margin: 0;\n      }\n\n      button {\n        border: none;\n        background: none;\n      }\n    "
  });
};

/***/ }),

/***/ 30110:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "lW": function() { return /* binding */ accordionListItemAnatomy; },
  "$5": function() { return /* binding */ avatarAnatomy; },
  "F7": function() { return /* binding */ cardListItemAnatomy; },
  "Q0": function() { return /* binding */ chipAnatomy; },
  "Ss": function() { return /* binding */ formElementsAnatomy; },
  "yo": function() { return /* binding */ labelAnatomy; },
  "Ut": function() { return /* binding */ linkAnatomy; },
  "vE": function() { return /* binding */ listAnatomy; }
});

// UNUSED EXPORTS: ComponentAnatomy

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(82526);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(41817);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__(32165);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__(91038);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__(57327);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__(26699);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(66992);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__(69600);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__(21249);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__(47042);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(68309);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.entries.js
var es_object_entries = __webpack_require__(69720);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.from-entries.js
var es_object_from_entries = __webpack_require__(38559);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(74916);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.test.js
var es_regexp_test = __webpack_require__(77601);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__(39714);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(78783);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(33948);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__(47941);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(41539);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/system/utils/anatomy.mjs
function cov_19dp62ti12() {
  var path = "/__w/code/code/js/packages/bricks/src/system/utils/anatomy.ts";
  var hash = "57765f5359c9dbe9649861db90e3c38e3d3311bf";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/system/utils/anatomy.ts",
    statementMap: {
      "0": {
        start: {
          line: 11,
          column: 15
        },
        end: {
          line: 11,
          column: 20
        }
      },
      "1": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 23,
          column: 5
        }
      },
      "2": {
        start: {
          line: 21,
          column: 6
        },
        end: {
          line: 21,
          column: 20
        }
      },
      "3": {
        start: {
          line: 22,
          column: 6
        },
        end: {
          line: 22,
          column: 13
        }
      },
      "4": {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 27,
          column: 6
        }
      },
      "5": {
        start: {
          line: 34,
          column: 4
        },
        end: {
          line: 34,
          column: 13
        }
      },
      "6": {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 37,
          column: 5
        }
      },
      "7": {
        start: {
          line: 36,
          column: 6
        },
        end: {
          line: 36,
          column: 40
        }
      },
      "8": {
        start: {
          line: 38,
          column: 4
        },
        end: {
          line: 38,
          column: 70
        }
      },
      "9": {
        start: {
          line: 45,
          column: 4
        },
        end: {
          line: 48,
          column: 5
        }
      },
      "10": {
        start: {
          line: 46,
          column: 6
        },
        end: {
          line: 46,
          column: 32
        }
      },
      "11": {
        start: {
          line: 46,
          column: 23
        },
        end: {
          line: 46,
          column: 32
        }
      },
      "12": {
        start: {
          line: 47,
          column: 6
        },
        end: {
          line: 47,
          column: 40
        }
      },
      "13": {
        start: {
          line: 49,
          column: 4
        },
        end: {
          line: 49,
          column: 74
        }
      },
      "14": {
        start: {
          line: 56,
          column: 18
        },
        end: {
          line: 58,
          column: 5
        }
      },
      "15": {
        start: {
          line: 57,
          column: 47
        },
        end: {
          line: 57,
          column: 76
        }
      },
      "16": {
        start: {
          line: 59,
          column: 4
        },
        end: {
          line: 59,
          column: 38
        }
      },
      "17": {
        start: {
          line: 66,
          column: 18
        },
        end: {
          line: 68,
          column: 5
        }
      },
      "18": {
        start: {
          line: 67,
          column: 47
        },
        end: {
          line: 67,
          column: 77
        }
      },
      "19": {
        start: {
          line: 69,
          column: 4
        },
        end: {
          line: 69,
          column: 38
        }
      },
      "20": {
        start: {
          line: 76,
          column: 15
        },
        end: {
          line: 76,
          column: 81
        }
      },
      "21": {
        start: {
          line: 77,
          column: 17
        },
        end: {
          line: 77,
          column: 46
        }
      },
      "22": {
        start: {
          line: 78,
          column: 22
        },
        end: {
          line: 78,
          column: 38
        }
      },
      "23": {
        start: {
          line: 80,
          column: 20
        },
        end: {
          line: 84,
          column: 5
        }
      },
      "24": {
        start: {
          line: 83,
          column: 22
        },
        end: {
          line: 83,
          column: 26
        }
      },
      "25": {
        start: {
          line: 86,
          column: 4
        },
        end: {
          line: 86,
          column: 46
        }
      },
      "26": {
        start: {
          line: 92,
          column: 17
        },
        end: {
          line: 92,
          column: 24
        }
      },
      "27": {
        start: {
          line: 94,
          column: 2
        },
        end: {
          line: 104,
          column: 4
        }
      },
      "28": {
        start: {
          line: 101,
          column: 6
        },
        end: {
          line: 101,
          column: 37
        }
      }
    },
    fnMap: {
      "0": {
        name: "anatomy",
        decl: {
          start: {
            line: 7,
            column: 16
          },
          end: {
            line: 7,
            column: 23
          }
        },
        loc: {
          start: {
            line: 10,
            column: 14
          },
          end: {
            line: 105,
            column: 1
          }
        },
        line: 10
      },
      "1": {
        name: "assert",
        decl: {
          start: {
            line: 19,
            column: 11
          },
          end: {
            line: 19,
            column: 17
          }
        },
        loc: {
          start: {
            line: 19,
            column: 20
          },
          end: {
            line: 28,
            column: 3
          }
        },
        line: 19
      },
      "2": {
        name: "parts",
        decl: {
          start: {
            line: 33,
            column: 11
          },
          end: {
            line: 33,
            column: 16
          }
        },
        loc: {
          start: {
            line: 33,
            column: 51
          },
          end: {
            line: 39,
            column: 3
          }
        },
        line: 33
      },
      "3": {
        name: "extend",
        decl: {
          start: {
            line: 44,
            column: 11
          },
          end: {
            line: 44,
            column: 17
          }
        },
        loc: {
          start: {
            line: 44,
            column: 51
          },
          end: {
            line: 50,
            column: 3
          }
        },
        line: 44
      },
      "4": {
        name: "selectors",
        decl: {
          start: {
            line: 55,
            column: 11
          },
          end: {
            line: 55,
            column: 20
          }
        },
        loc: {
          start: {
            line: 55,
            column: 23
          },
          end: {
            line: 60,
            column: 3
          }
        },
        line: 55
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 57,
            column: 30
          },
          end: {
            line: 57,
            column: 31
          }
        },
        loc: {
          start: {
            line: 57,
            column: 47
          },
          end: {
            line: 57,
            column: 76
          }
        },
        line: 57
      },
      "6": {
        name: "classnames",
        decl: {
          start: {
            line: 65,
            column: 11
          },
          end: {
            line: 65,
            column: 21
          }
        },
        loc: {
          start: {
            line: 65,
            column: 24
          },
          end: {
            line: 70,
            column: 3
          }
        },
        line: 65
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 67,
            column: 30
          },
          end: {
            line: 67,
            column: 31
          }
        },
        loc: {
          start: {
            line: 67,
            column: 47
          },
          end: {
            line: 67,
            column: 77
          }
        },
        line: 67
      },
      "8": {
        name: "toPart",
        decl: {
          start: {
            line: 75,
            column: 11
          },
          end: {
            line: 75,
            column: 17
          }
        },
        loc: {
          start: {
            line: 75,
            column: 32
          },
          end: {
            line: 87,
            column: 3
          }
        },
        line: 75
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 83,
            column: 16
          },
          end: {
            line: 83,
            column: 17
          }
        },
        loc: {
          start: {
            line: 83,
            column: 22
          },
          end: {
            line: 83,
            column: 26
          }
        },
        line: 83
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 100,
            column: 4
          },
          end: {
            line: 100,
            column: 5
          }
        },
        loc: {
          start: {
            line: 100,
            column: 20
          },
          end: {
            line: 102,
            column: 5
          }
        },
        line: 100
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 9,
            column: 2
          },
          end: {
            line: 9,
            column: 29
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 9,
            column: 8
          },
          end: {
            line: 9,
            column: 29
          }
        }],
        line: 9
      },
      "1": {
        loc: {
          start: {
            line: 20,
            column: 4
          },
          end: {
            line: 23,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 20,
            column: 4
          },
          end: {
            line: 23,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 20
      },
      "2": {
        loc: {
          start: {
            line: 46,
            column: 6
          },
          end: {
            line: 46,
            column: 32
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 46,
            column: 6
          },
          end: {
            line: 46,
            column: 32
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 46
      },
      "3": {
        loc: {
          start: {
            line: 76,
            column: 15
          },
          end: {
            line: 76,
            column: 81
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 76,
            column: 60
          },
          end: {
            line: 76,
            column: 66
          }
        }, {
          start: {
            line: 76,
            column: 69
          },
          end: {
            line: 76,
            column: 81
          }
        }],
        line: 76
      },
      "4": {
        loc: {
          start: {
            line: 76,
            column: 46
          },
          end: {
            line: 76,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 76,
            column: 46
          },
          end: {
            line: 76,
            column: 50
          }
        }, {
          start: {
            line: 76,
            column: 54
          },
          end: {
            line: 76,
            column: 56
          }
        }],
        line: 76
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0
    },
    b: {
      "0": [0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "57765f5359c9dbe9649861db90e3c38e3d3311bf"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_19dp62ti12 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_19dp62ti12();
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }



function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
















/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Used to define the anatomy/parts of a component in a way that provides
 * a consistent API for `className`, css selector and `theming`.
 */
function anatomy(name) {
  var map = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_19dp62ti12().b[0][0]++, {});
  cov_19dp62ti12().f[0]++;
  var called = (cov_19dp62ti12().s[0]++, false);

  /**
   * Prevents user from calling `.parts` multiple times.
   * It should only be called once.
   *
   * @throws Error if called more than once
   */
  function assert() {
    cov_19dp62ti12().f[1]++;
    cov_19dp62ti12().s[1]++;
    if (!called) {
      cov_19dp62ti12().b[1][0]++;
      cov_19dp62ti12().s[2]++;
      called = true;
      cov_19dp62ti12().s[3]++;
      return;
    } else {
      cov_19dp62ti12().b[1][1]++;
    }
    cov_19dp62ti12().s[4]++;
    throw new Error('[anatomy] .part(...) should only be called once. Did you mean to use .extend(...) ?');
  }

  /**
   * Add the core parts of the components
   */
  function parts() {
    cov_19dp62ti12().f[2]++;
    cov_19dp62ti12().s[5]++;
    assert();
    cov_19dp62ti12().s[6]++;
    for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
      values[_key] = arguments[_key];
    }
    for (var _i = 0, _values = values; _i < _values.length; _i++) {
      var _part = _values[_i];
      cov_19dp62ti12().s[7]++;
      map[_part] = toPart(_part);
    }
    cov_19dp62ti12().s[8]++;
    return anatomy(name, map);
  }

  /**
   * Extend the component anatomy to includes new parts
   */
  function extend() {
    cov_19dp62ti12().f[3]++;
    cov_19dp62ti12().s[9]++;
    for (var _len2 = arguments.length, parts = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      parts[_key2] = arguments[_key2];
    }
    for (var _i2 = 0, _parts = parts; _i2 < _parts.length; _i2++) {
      var _part2 = _parts[_i2];
      cov_19dp62ti12().s[10]++;
      if (_part2 in map) {
        cov_19dp62ti12().b[2][0]++;
        cov_19dp62ti12().s[11]++;
        continue;
      } else {
        cov_19dp62ti12().b[2][1]++;
      }
      cov_19dp62ti12().s[12]++;
      map[_part2] = toPart(_part2);
    }
    cov_19dp62ti12().s[13]++;
    return anatomy(name, map);
  }

  /**
   * Get all selectors for the component anatomy
   */
  function selectors() {
    cov_19dp62ti12().f[4]++;
    var value = (cov_19dp62ti12().s[14]++, Object.fromEntries(Object.entries(map).map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        part = _ref2[1];
      cov_19dp62ti12().f[5]++;
      cov_19dp62ti12().s[15]++;
      return [key, part.selector];
    })));
    cov_19dp62ti12().s[16]++;
    return value;
  }

  /**
   * Get all classNames for the component anatomy
   */
  function classnames() {
    cov_19dp62ti12().f[6]++;
    var value = (cov_19dp62ti12().s[17]++, Object.fromEntries(Object.entries(map).map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
        key = _ref4[0],
        part = _ref4[1];
      cov_19dp62ti12().f[7]++;
      cov_19dp62ti12().s[18]++;
      return [key, part.className];
    })));
    cov_19dp62ti12().s[19]++;
    return value;
  }

  /**
   * Creates the part object for the given part
   */
  function toPart(part) {
    var _ref5;
    cov_19dp62ti12().f[8]++;
    var el = (cov_19dp62ti12().s[20]++, ['container', 'root'].includes((_ref5 = (cov_19dp62ti12().b[4][0]++, part)) !== null && _ref5 !== void 0 ? _ref5 : (cov_19dp62ti12().b[4][1]++, '')) ? (cov_19dp62ti12().b[3][0]++, [name]) : (cov_19dp62ti12().b[3][1]++, [name, part]));
    var attr = (cov_19dp62ti12().s[21]++, el.filter(Boolean).join('__'));
    var className = (cov_19dp62ti12().s[22]++, "chakra-".concat(attr));
    var partObj = (cov_19dp62ti12().s[23]++, {
      className: className,
      selector: ".".concat(className),
      toString: function toString() {
        cov_19dp62ti12().f[9]++;
        cov_19dp62ti12().s[24]++;
        return part;
      }
    });
    cov_19dp62ti12().s[25]++;
    return partObj;
  }

  /**
   * Used to get the derived type of the anatomy
   */
  var __type = (cov_19dp62ti12().s[26]++, {});
  cov_19dp62ti12().s[27]++;
  return {
    parts: parts,
    toPart: toPart,
    extend: extend,
    selectors: selectors,
    classnames: classnames,
    get keys() {
      cov_19dp62ti12().f[10]++;
      cov_19dp62ti12().s[28]++;
      return Object.keys(map);
    },
    __type: __type
  };
}
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/system/anatomy.types.mjs
function cov_2g6xom66lv() {
  var path = "/__w/code/code/js/packages/bricks/src/system/anatomy.types.ts";
  var hash = "d6351dfc54e5b7955df8732e42f269c48a558c09";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/system/anatomy.types.ts",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 27
        },
        end: {
          line: 7,
          column: 75
        }
      },
      "1": {
        start: {
          line: 12,
          column: 27
        },
        end: {
          line: 12,
          column: 70
        }
      },
      "2": {
        start: {
          line: 17,
          column: 27
        },
        end: {
          line: 17,
          column: 78
        }
      },
      "3": {
        start: {
          line: 18,
          column: 40
        },
        end: {
          line: 26,
          column: 1
        }
      },
      "4": {
        start: {
          line: 27,
          column: 35
        },
        end: {
          line: 34,
          column: 1
        }
      },
      "5": {
        start: {
          line: 39,
          column: 35
        },
        end: {
          line: 51,
          column: 1
        }
      },
      "6": {
        start: {
          line: 52,
          column: 28
        },
        end: {
          line: 52,
          column: 80
        }
      },
      "7": {
        start: {
          line: 57,
          column: 29
        },
        end: {
          line: 57,
          column: 74
        }
      },
      "8": {
        start: {
          line: 59,
          column: 99
        },
        end: {
          line: 68,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "d6351dfc54e5b7955df8732e42f269c48a558c09"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2g6xom66lv = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2g6xom66lv();


/**
 * ACTIONS
 */
var linkAnatomy = (cov_2g6xom66lv().s[0]++, anatomy('link').parts('link', 'content', 'icon'));

/**
 * CONTAINERS
 */
var chipAnatomy = (cov_2g6xom66lv().s[1]++, anatomy('chip').parts('container', 'label'));

/**
 * LIST
 */
var listAnatomy = (cov_2g6xom66lv().s[2]++, anatomy('list').parts('container', 'list', 'title'));
var accordionListItemAnatomy = (cov_2g6xom66lv().s[3]++, anatomy('accordionListItem').parts('listItem', 'button', 'title', 'icon', 'iconContainer', 'panel', 'bodyText'));
var cardListItemAnatomy = (cov_2g6xom66lv().s[4]++, anatomy('cardListItem').parts('listItem', 'content', 'accessoryIconContainer', 'accessoryIcon', 'accessoryImage', 'chevron'));

/**
 * FORM ELEMENTS
 */
var formElementsAnatomy = (cov_2g6xom66lv().s[5]++, anatomy('formElements').parts('label', 'disabledLabel', 'subtitle', 'disabledSubtitle', 'noContainer', 'hasContainer', 'disabledContainer', 'errorContainer', 'disabledLabel', 'disabledSubtitle', 'disabledContainer'));
var labelAnatomy = (cov_2g6xom66lv().s[6]++, anatomy('label').parts('label', 'requiredIndicator'));

/**
 * CONTENT
 */
var avatarAnatomy = (cov_2g6xom66lv().s[7]++, anatomy('avatar').parts('container', 'image'));
var ComponentAnatomy = (cov_2g6xom66lv().s[8]++, {
  AccordionListItem: accordionListItemAnatomy,
  Avatar: avatarAnatomy,
  CardListItem: cardListItemAnatomy,
  Chip: chipAnatomy,
  FormElements: formElementsAnatomy,
  Label: labelAnatomy,
  Link: linkAnatomy,
  List: listAnatomy
});

/***/ }),

/***/ 26153:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ bricks; }
/* harmony export */ });
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41817);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32165);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91038);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66992);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47042);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68309);
/* harmony import */ var core_js_modules_es_map_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(51532);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(74916);
/* harmony import */ var core_js_modules_es_regexp_test_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(77601);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(39714);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(78783);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(33948);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(24614);
function cov_5qh3tjiml() {
  var path = "/__w/code/code/js/packages/bricks/src/system/bricks.types.ts";
  var hash = "0b75d46c65dbeb2526ebd57e7f85a29d7adb352f";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/system/bricks.types.ts",
    statementMap: {
      "0": {
        start: {
          line: 95,
          column: 16
        },
        end: {
          line: 95,
          column: 68
        }
      },
      "1": {
        start: {
          line: 97,
          column: 2
        },
        end: {
          line: 116,
          column: 45
        }
      },
      "2": {
        start: {
          line: 104,
          column: 6
        },
        end: {
          line: 104,
          column: 33
        }
      },
      "3": {
        start: {
          line: 111,
          column: 6
        },
        end: {
          line: 113,
          column: 7
        }
      },
      "4": {
        start: {
          line: 112,
          column: 8
        },
        end: {
          line: 112,
          column: 44
        }
      },
      "5": {
        start: {
          line: 114,
          column: 6
        },
        end: {
          line: 114,
          column: 32
        }
      },
      "6": {
        start: {
          line: 136,
          column: 22
        },
        end: {
          line: 136,
          column: 31
        }
      }
    },
    fnMap: {
      "0": {
        name: "factory",
        decl: {
          start: {
            line: 94,
            column: 9
          },
          end: {
            line: 94,
            column: 16
          }
        },
        loc: {
          start: {
            line: 94,
            column: 19
          },
          end: {
            line: 117,
            column: 1
          }
        },
        line: 94
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 103,
            column: 4
          },
          end: {
            line: 103,
            column: 5
          }
        },
        loc: {
          start: {
            line: 103,
            column: 73
          },
          end: {
            line: 105,
            column: 5
          }
        },
        line: 103
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 110,
            column: 4
          },
          end: {
            line: 110,
            column: 5
          }
        },
        loc: {
          start: {
            line: 110,
            column: 33
          },
          end: {
            line: 115,
            column: 5
          }
        },
        line: 110
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 111,
            column: 6
          },
          end: {
            line: 113,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 111,
            column: 6
          },
          end: {
            line: 113,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 111
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "0b75d46c65dbeb2526ebd57e7f85a29d7adb352f"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_5qh3tjiml = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_5qh3tjiml();
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }




function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }












/**
 * Overrides ChakraComponents to use our more strictly typed BricksProps
 *
 * @see https://github.com/chakra-ui/chakra-ui/blob/master/packages/system/src/system.types.tsx
 * @override
 */

/**
 * Overrides HTMLChakraComponents to use our more strictly typed BricksComponent
 *
 * @see https://github.com/chakra-ui/chakra-ui/blob/master/packages/system/src/system.ts
 * @override
 */

/**
 * Extracts the props of a React element or component with refs and
 * ensures they can be passed to defined components. Overrides chakra's
 * PropsOf to intentionally include refs
 *
 * Aria attributes are all removed and explicitly added to core components via A11yProps.
 * This is intentional to ensure a11y best practices are followed in the core components.
 *
 * @see https://github.com/chakra-ui/chakra-ui/blob/master/packages/system/src/system.types.tsx
 * @see system/a11y.types.ts
 *
 * @override
 */

/**
 * Overrides HTMLChakraProps to use our more strictly typed BricksProps
 *
 * Chakra has a [union type](https://github.com/chakra-ui/chakra-ui/blob/b0da6e6665234c1584403f7f7251390c3a9433c8/packages/styled-system/src/utils/types.ts#L14) that allows arbitrary string/objects in addition to
 * theme values which makes typing a lot looser for design system enforcement.
 *
 * However, we explicitly want to prevent engineers from using arbitrary string or
 * numerical values on certain theme props that are controlled by the design system
 * (such as preventing hex values on the color prop).
 *
 * So we've redefined Token and have overridden chakra types in lots of places to ensure
 * OUR Token gets used instead of chakra's Token.
 *
 * @see https://github.com/chakra-ui/chakra-ui/blob/master/packages/system/src/system.ts
 * @override
 */

/**
 * Type for components created via the bricks factory function.
 * Overrides ChakraFactory to use our more strictly typed BricksComponent.
 *
 * @see https://github.com/chakra-ui/chakra-ui/blob/master/packages/system/src/factory.ts
 * @override
 */

/**
 * See https://chakra-ui.com/docs/features/chakra-factory
 * Overrides chakra factory function to more strictly type theme tokens
 *
 * @see https://github.com/chakra-ui/chakra-ui/blob/master/packages/system/src/factory.ts
 * @override
 */
function factory() {
  cov_5qh3tjiml().f[0]++;
  var cache = (cov_5qh3tjiml().s[0]++, new Map());
  cov_5qh3tjiml().s[1]++;
  return new Proxy(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_14__/* .styled */ .zo, {
    /**
     * @example
     * const Div = chakra("div")
     * const WithChakra = chakra(AnotherComponent)
     */
    apply: function apply(target, thisArg, argArray) {
      cov_5qh3tjiml().f[1]++;
      cov_5qh3tjiml().s[2]++;
      return _chakra_ui_system__WEBPACK_IMPORTED_MODULE_14__/* .styled.apply */ .zo.apply(void 0, _toConsumableArray(argArray));
    },
    /**
     * @example
     * <chakra.div />
     */
    get: function get(_, element) {
      cov_5qh3tjiml().f[2]++;
      cov_5qh3tjiml().s[3]++;
      if (!cache.has(element)) {
        cov_5qh3tjiml().b[0][0]++;
        cov_5qh3tjiml().s[4]++;
        cache.set(element, (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_14__/* .styled */ .zo)(element));
      } else {
        cov_5qh3tjiml().b[0][1]++;
      }
      cov_5qh3tjiml().s[5]++;
      return cache.get(element);
    }
  });
}

/**
 * See https://chakra-ui.com/docs/features/chakra-factory
 * Overrides chakra factory function to more strictly type theme tokens
 *
 * Chakra has a [union type](https://github.com/chakra-ui/chakra-ui/blob/b0da6e6665234c1584403f7f7251390c3a9433c8/packages/styled-system/src/utils/types.ts#L14) that allows arbitrary string/objects in addition to
 * theme values which makes typing a lot looser for design system enforcement.
 *
 * However, we explicitly want to prevent engineers from using arbitrary string or
 * numerical values on certain theme props that are controlled by the design system
 * (such as preventing hex values on the color prop).
 *
 * So we've redefined Token and have overridden chakra types in lots of places to ensure
 * OUR Token gets used instead of chakra's Token.
 *
 * @see https://github.com/chakra-ui/chakra-ui/blob/master/packages/system/src/factory.ts
 * @override
 */
var bricks = (cov_5qh3tjiml().s[6]++, factory());

/***/ }),

/***/ 79141:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ useTheme; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30174);
function cov_tvwdyxemm() {
  var path = "/__w/code/code/js/packages/bricks/src/system/theme/index.ts";
  var hash = "e285a5722f8474adb2726db29fd2527019aa543c";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/system/theme/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 133,
          column: 24
        },
        end: {
          line: 142,
          column: 1
        }
      },
      "1": {
        start: {
          line: 134,
          column: 16
        },
        end: {
          line: 134,
          column: 40
        }
      },
      "2": {
        start: {
          line: 135,
          column: 2
        },
        end: {
          line: 139,
          column: 3
        }
      },
      "3": {
        start: {
          line: 136,
          column: 4
        },
        end: {
          line: 138,
          column: 6
        }
      },
      "4": {
        start: {
          line: 141,
          column: 2
        },
        end: {
          line: 141,
          column: 40
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 133,
            column: 24
          },
          end: {
            line: 133,
            column: 25
          }
        },
        loc: {
          start: {
            line: 133,
            column: 30
          },
          end: {
            line: 142,
            column: 1
          }
        },
        line: 133
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 135,
            column: 2
          },
          end: {
            line: 139,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 135,
            column: 2
          },
          end: {
            line: 139,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 135
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "e285a5722f8474adb2726db29fd2527019aa543c"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_tvwdyxemm = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_tvwdyxemm();








// Types







/** @deprecated */
cov_tvwdyxemm().s[0]++;
var useTheme = function useTheme() {
  cov_tvwdyxemm().f[0]++;
  var theme = (cov_tvwdyxemm().s[1]++, (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_emotion_react__WEBPACK_IMPORTED_MODULE_1__.T));
  cov_tvwdyxemm().s[2]++;
  if (!theme) {
    cov_tvwdyxemm().b[0][0]++;
    cov_tvwdyxemm().s[3]++;
    throw Error('useTheme: `theme` is undefined. Seems you forgot to wrap your app in `<Themed />` from ODTheme');
  } else {
    cov_tvwdyxemm().b[0][1]++;
  }
  cov_tvwdyxemm().s[4]++;
  return theme;
};

/***/ }),

/***/ 48189:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "mq": function() { return /* binding */ useStyleConfig; }
});

// UNUSED EXPORTS: useMultiStyleConfig, useStyleConfigImpl

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(82526);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__(82772);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__(47941);
// EXTERNAL MODULE: ./node_modules/lodash/mergeWith.js
var mergeWith = __webpack_require__(30236);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-fast-compare/index.js
var react_fast_compare = __webpack_require__(69590);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__(89554);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__(26699);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(66992);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.map.js
var es_map = __webpack_require__(51532);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(41539);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__(32023);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(78783);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.weak-map.js
var es_weak_map = __webpack_require__(4129);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__(54747);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(33948);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/system/utils/index.mjs
function cov_1guynrgctd() {
  var path = "/__w/code/code/js/packages/bricks/src/system/utils/index.ts";
  var hash = "fda8429ca47a9556b4f4fe6455d9f8ae07a02268";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/system/utils/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 12,
          column: 23
        },
        end: {
          line: 12,
          column: 25
        }
      },
      "1": {
        start: {
          line: 14,
          column: 2
        },
        end: {
          line: 17,
          column: 5
        }
      },
      "2": {
        start: {
          line: 15,
          column: 4
        },
        end: {
          line: 15,
          column: 40
        }
      },
      "3": {
        start: {
          line: 15,
          column: 33
        },
        end: {
          line: 15,
          column: 40
        }
      },
      "4": {
        start: {
          line: 16,
          column: 4
        },
        end: {
          line: 16,
          column: 30
        }
      },
      "5": {
        start: {
          line: 19,
          column: 2
        },
        end: {
          line: 19,
          column: 30
        }
      },
      "6": {
        start: {
          line: 35,
          column: 14
        },
        end: {
          line: 35,
          column: 65
        }
      },
      "7": {
        start: {
          line: 37,
          column: 2
        },
        end: {
          line: 40,
          column: 3
        }
      },
      "8": {
        start: {
          line: 38,
          column: 4
        },
        end: {
          line: 38,
          column: 20
        }
      },
      "9": {
        start: {
          line: 38,
          column: 14
        },
        end: {
          line: 38,
          column: 20
        }
      },
      "10": {
        start: {
          line: 39,
          column: 4
        },
        end: {
          line: 39,
          column: 26
        }
      },
      "11": {
        start: {
          line: 42,
          column: 2
        },
        end: {
          line: 42,
          column: 44
        }
      },
      "12": {
        start: {
          line: 47,
          column: 23
        },
        end: {
          line: 73,
          column: 1
        }
      },
      "13": {
        start: {
          line: 48,
          column: 16
        },
        end: {
          line: 48,
          column: 29
        }
      },
      "14": {
        start: {
          line: 50,
          column: 26
        },
        end: {
          line: 70,
          column: 3
        }
      },
      "15": {
        start: {
          line: 51,
          column: 4
        },
        end: {
          line: 53,
          column: 5
        }
      },
      "16": {
        start: {
          line: 52,
          column: 6
        },
        end: {
          line: 52,
          column: 37
        }
      },
      "17": {
        start: {
          line: 55,
          column: 4
        },
        end: {
          line: 57,
          column: 5
        }
      },
      "18": {
        start: {
          line: 56,
          column: 6
        },
        end: {
          line: 56,
          column: 32
        }
      },
      "19": {
        start: {
          line: 59,
          column: 16
        },
        end: {
          line: 59,
          column: 30
        }
      },
      "20": {
        start: {
          line: 61,
          column: 4
        },
        end: {
          line: 63,
          column: 5
        }
      },
      "21": {
        start: {
          line: 62,
          column: 6
        },
        end: {
          line: 62,
          column: 27
        }
      },
      "22": {
        start: {
          line: 65,
          column: 18
        },
        end: {
          line: 65,
          column: 48
        }
      },
      "23": {
        start: {
          line: 67,
          column: 4
        },
        end: {
          line: 67,
          column: 25
        }
      },
      "24": {
        start: {
          line: 69,
          column: 4
        },
        end: {
          line: 69,
          column: 17
        }
      },
      "25": {
        start: {
          line: 72,
          column: 2
        },
        end: {
          line: 72,
          column: 20
        }
      },
      "26": {
        start: {
          line: 75,
          column: 27
        },
        end: {
          line: 75,
          column: 39
        }
      },
      "27": {
        start: {
          line: 86,
          column: 23
        },
        end: {
          line: 86,
          column: 25
        }
      },
      "28": {
        start: {
          line: 88,
          column: 2
        },
        end: {
          line: 94,
          column: 5
        }
      },
      "29": {
        start: {
          line: 89,
          column: 18
        },
        end: {
          line: 89,
          column: 29
        }
      },
      "30": {
        start: {
          line: 90,
          column: 23
        },
        end: {
          line: 90,
          column: 45
        }
      },
      "31": {
        start: {
          line: 91,
          column: 4
        },
        end: {
          line: 93,
          column: 5
        }
      },
      "32": {
        start: {
          line: 92,
          column: 6
        },
        end: {
          line: 92,
          column: 26
        }
      },
      "33": {
        start: {
          line: 96,
          column: 2
        },
        end: {
          line: 96,
          column: 16
        }
      },
      "34": {
        start: {
          line: 99,
          column: 31
        },
        end: {
          line: 100,
          column: 66
        }
      },
      "35": {
        start: {
          line: 100,
          column: 2
        },
        end: {
          line: 100,
          column: 66
        }
      },
      "36": {
        start: {
          line: 100,
          column: 32
        },
        end: {
          line: 100,
          column: 65
        }
      },
      "37": {
        start: {
          line: 102,
          column: 19
        },
        end: {
          line: 103,
          column: 29
        }
      },
      "38": {
        start: {
          line: 103,
          column: 2
        },
        end: {
          line: 103,
          column: 29
        }
      },
      "39": {
        start: {
          line: 106,
          column: 2
        },
        end: {
          line: 106,
          column: 64
        }
      }
    },
    fnMap: {
      "0": {
        name: "omit",
        decl: {
          start: {
            line: 11,
            column: 16
          },
          end: {
            line: 11,
            column: 20
          }
        },
        loc: {
          start: {
            line: 11,
            column: 78
          },
          end: {
            line: 20,
            column: 1
          }
        },
        line: 11
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 14,
            column: 30
          },
          end: {
            line: 14,
            column: 31
          }
        },
        loc: {
          start: {
            line: 14,
            column: 39
          },
          end: {
            line: 17,
            column: 3
          }
        },
        line: 14
      },
      "2": {
        name: "get",
        decl: {
          start: {
            line: 29,
            column: 16
          },
          end: {
            line: 29,
            column: 19
          }
        },
        loc: {
          start: {
            line: 34,
            column: 2
          },
          end: {
            line: 43,
            column: 1
          }
        },
        line: 34
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 47,
            column: 23
          },
          end: {
            line: 47,
            column: 24
          }
        },
        loc: {
          start: {
            line: 47,
            column: 36
          },
          end: {
            line: 73,
            column: 1
          }
        },
        line: 47
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 50,
            column: 26
          },
          end: {
            line: 50,
            column: 27
          }
        },
        loc: {
          start: {
            line: 50,
            column: 58
          },
          end: {
            line: 70,
            column: 3
          }
        },
        line: 50
      },
      "5": {
        name: "objectFilter",
        decl: {
          start: {
            line: 85,
            column: 16
          },
          end: {
            line: 85,
            column: 28
          }
        },
        loc: {
          start: {
            line: 85,
            column: 73
          },
          end: {
            line: 97,
            column: 1
          }
        },
        line: 85
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 88,
            column: 30
          },
          end: {
            line: 88,
            column: 31
          }
        },
        loc: {
          start: {
            line: 88,
            column: 39
          },
          end: {
            line: 94,
            column: 3
          }
        },
        line: 88
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 99,
            column: 31
          },
          end: {
            line: 99,
            column: 32
          }
        },
        loc: {
          start: {
            line: 100,
            column: 2
          },
          end: {
            line: 100,
            column: 66
          }
        },
        line: 100
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 100,
            column: 23
          },
          end: {
            line: 100,
            column: 24
          }
        },
        loc: {
          start: {
            line: 100,
            column: 32
          },
          end: {
            line: 100,
            column: 65
          }
        },
        line: 100
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 102,
            column: 19
          },
          end: {
            line: 102,
            column: 20
          }
        },
        loc: {
          start: {
            line: 103,
            column: 2
          },
          end: {
            line: 103,
            column: 29
          }
        },
        line: 103
      },
      "10": {
        name: "runIfFn",
        decl: {
          start: {
            line: 105,
            column: 16
          },
          end: {
            line: 105,
            column: 23
          }
        },
        loc: {
          start: {
            line: 105,
            column: 87
          },
          end: {
            line: 107,
            column: 1
          }
        },
        line: 105
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 15,
            column: 4
          },
          end: {
            line: 15,
            column: 40
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 15,
            column: 4
          },
          end: {
            line: 15,
            column: 40
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 15
      },
      "1": {
        loc: {
          start: {
            line: 35,
            column: 14
          },
          end: {
            line: 35,
            column: 65
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 35,
            column: 41
          },
          end: {
            line: 35,
            column: 56
          }
        }, {
          start: {
            line: 35,
            column: 59
          },
          end: {
            line: 35,
            column: 65
          }
        }],
        line: 35
      },
      "2": {
        loc: {
          start: {
            line: 38,
            column: 4
          },
          end: {
            line: 38,
            column: 20
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 38,
            column: 4
          },
          end: {
            line: 38,
            column: 20
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 38
      },
      "3": {
        loc: {
          start: {
            line: 42,
            column: 9
          },
          end: {
            line: 42,
            column: 43
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 42,
            column: 29
          },
          end: {
            line: 42,
            column: 37
          }
        }, {
          start: {
            line: 42,
            column: 40
          },
          end: {
            line: 42,
            column: 43
          }
        }],
        line: 42
      },
      "4": {
        loc: {
          start: {
            line: 51,
            column: 4
          },
          end: {
            line: 53,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 51,
            column: 4
          },
          end: {
            line: 53,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 51
      },
      "5": {
        loc: {
          start: {
            line: 55,
            column: 4
          },
          end: {
            line: 57,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 55,
            column: 4
          },
          end: {
            line: 57,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 55
      },
      "6": {
        loc: {
          start: {
            line: 61,
            column: 4
          },
          end: {
            line: 63,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 61,
            column: 4
          },
          end: {
            line: 63,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 61
      },
      "7": {
        loc: {
          start: {
            line: 91,
            column: 4
          },
          end: {
            line: 93,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 91,
            column: 4
          },
          end: {
            line: 93,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 91
      },
      "8": {
        loc: {
          start: {
            line: 100,
            column: 32
          },
          end: {
            line: 100,
            column: 65
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 100,
            column: 32
          },
          end: {
            line: 100,
            column: 44
          }
        }, {
          start: {
            line: 100,
            column: 48
          },
          end: {
            line: 100,
            column: 65
          }
        }],
        line: 100
      },
      "9": {
        loc: {
          start: {
            line: 106,
            column: 9
          },
          end: {
            line: 106,
            column: 63
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 106,
            column: 33
          },
          end: {
            line: 106,
            column: 51
          }
        }, {
          start: {
            line: 106,
            column: 54
          },
          end: {
            line: 106,
            column: 63
          }
        }],
        line: 106
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "fda8429ca47a9556b4f4fe6455d9f8ae07a02268"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1guynrgctd = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1guynrgctd();











/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-explicit-any */




function omit(object, keys) {
  cov_1guynrgctd().f[0]++;
  var result = (cov_1guynrgctd().s[0]++, {});
  cov_1guynrgctd().s[1]++;
  Object.keys(object).forEach(function (key) {
    cov_1guynrgctd().f[1]++;
    cov_1guynrgctd().s[2]++;
    if (keys.includes(key)) {
      cov_1guynrgctd().b[0][0]++;
      cov_1guynrgctd().s[3]++;
      return;
    } else {
      cov_1guynrgctd().b[0][1]++;
    }
    cov_1guynrgctd().s[4]++;
    result[key] = object[key];
  });
  cov_1guynrgctd().s[5]++;
  return result;
}

/**
 * Get value from a deeply nested object using a string path.
 * Memorizes the value.
 * @param obj - the object
 * @param path - the string path
 * @param fallback  - the fallback value
 */
function get(obj, path, fallback, index) {
  cov_1guynrgctd().f[2]++;
  var key = (cov_1guynrgctd().s[6]++, typeof path === 'string' ? (cov_1guynrgctd().b[1][0]++, path.split('.')) : (cov_1guynrgctd().b[1][1]++, [path]));
  cov_1guynrgctd().s[7]++;
  for (index = 0; index < key.length; index += 1) {
    cov_1guynrgctd().s[8]++;
    if (!obj) {
      cov_1guynrgctd().b[2][0]++;
      cov_1guynrgctd().s[9]++;
      break;
    } else {
      cov_1guynrgctd().b[2][1]++;
    }
    cov_1guynrgctd().s[10]++;
    obj = obj[key[index]];
  }
  cov_1guynrgctd().s[11]++;
  return obj === undefined ? (cov_1guynrgctd().b[3][0]++, fallback) : (cov_1guynrgctd().b[3][1]++, obj);
}
cov_1guynrgctd().s[12]++;
var memoize = function memoize(fn) {
  cov_1guynrgctd().f[3]++;
  var cache = (cov_1guynrgctd().s[13]++, new WeakMap());
  cov_1guynrgctd().s[14]++;
  var memoizedFn = function memoizedFn(obj, path, fallback, index) {
    cov_1guynrgctd().f[4]++;
    cov_1guynrgctd().s[15]++;
    if (typeof obj === 'undefined') {
      cov_1guynrgctd().b[4][0]++;
      cov_1guynrgctd().s[16]++;
      return fn(obj, path, fallback);
    } else {
      cov_1guynrgctd().b[4][1]++;
    }
    cov_1guynrgctd().s[17]++;
    if (!cache.has(obj)) {
      cov_1guynrgctd().b[5][0]++;
      cov_1guynrgctd().s[18]++;
      cache.set(obj, new Map());
    } else {
      cov_1guynrgctd().b[5][1]++;
    }
    var map = (cov_1guynrgctd().s[19]++, cache.get(obj));
    cov_1guynrgctd().s[20]++;
    if (map.has(path)) {
      cov_1guynrgctd().b[6][0]++;
      cov_1guynrgctd().s[21]++;
      return map.get(path);
    } else {
      cov_1guynrgctd().b[6][1]++;
    }
    var value = (cov_1guynrgctd().s[22]++, fn(obj, path, fallback, index));
    cov_1guynrgctd().s[23]++;
    map.set(path, value);
    cov_1guynrgctd().s[24]++;
    return value;
  };
  cov_1guynrgctd().s[25]++;
  return memoizedFn;
};
var memoizedGet = (cov_1guynrgctd().s[26]++, memoize(get));
/**
 * Returns the items of an object that meet the condition specified in a callback function.
 *
 * @param object the object to loop through
 * @param fn The filter function
 */
function objectFilter(object, fn) {
  cov_1guynrgctd().f[5]++;
  var result = (cov_1guynrgctd().s[27]++, {});
  cov_1guynrgctd().s[28]++;
  Object.keys(object).forEach(function (key) {
    cov_1guynrgctd().f[6]++;
    var value = (cov_1guynrgctd().s[29]++, object[key]);
    var shouldPass = (cov_1guynrgctd().s[30]++, fn(value, key, object));
    cov_1guynrgctd().s[31]++;
    if (shouldPass) {
      cov_1guynrgctd().b[7][0]++;
      cov_1guynrgctd().s[32]++;
      result[key] = value;
    } else {
      cov_1guynrgctd().b[7][1]++;
    }
  });
  cov_1guynrgctd().s[33]++;
  return result;
}
cov_1guynrgctd().s[34]++;
var filterUndefined = function filterUndefined(object) {
  cov_1guynrgctd().f[7]++;
  cov_1guynrgctd().s[35]++;
  return objectFilter(object, function (val) {
    cov_1guynrgctd().f[8]++;
    cov_1guynrgctd().s[36]++;
    return (cov_1guynrgctd().b[8][0]++, val !== null) && (cov_1guynrgctd().b[8][1]++, val !== undefined);
  });
};
cov_1guynrgctd().s[37]++;
var isFunction = function isFunction(value) {
  cov_1guynrgctd().f[9]++;
  cov_1guynrgctd().s[38]++;
  return typeof value === 'function';
};
function runIfFn(valueOrFn) {
  cov_1guynrgctd().f[10]++;
  cov_1guynrgctd().s[39]++;
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  return isFunction(valueOrFn) ? (cov_1guynrgctd().b[9][0]++, valueOrFn.apply(void 0, args)) : (cov_1guynrgctd().b[9][1]++, valueOrFn);
}
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/system/theme/index.mjs
var system_theme = __webpack_require__(79141);
// EXTERNAL MODULE: ./node_modules/lodash/isObject.js
var isObject = __webpack_require__(13218);
// EXTERNAL MODULE: ./node_modules/lodash/isArray.js
var isArray = __webpack_require__(1469);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(41817);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__(32165);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.to-primitive.js
var es_symbol_to_primitive = __webpack_require__(96649);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.date.to-primitive.js
var es_date_to_primitive = __webpack_require__(96078);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__(9653);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.define-property.js
var es_object_define_property = __webpack_require__(69070);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(92222);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.every.js
var es_array_every = __webpack_require__(26541);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__(91038);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__(69600);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__(21249);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__(85827);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__(47042);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.sort.js
var es_array_sort = __webpack_require__(2707);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(68309);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__(19601);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.entries.js
var es_object_entries = __webpack_require__(69720);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.values.js
var es_object_values = __webpack_require__(26833);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.parse-float.js
var es_parse_float = __webpack_require__(54678);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.parse-int.js
var es_parse_int = __webpack_require__(91058);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(74916);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.test.js
var es_regexp_test = __webpack_require__(77601);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__(39714);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.set.js
var es_set = __webpack_require__(70189);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.ends-with.js
var es_string_ends_with = __webpack_require__(27852);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__(15306);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/system/utils/breakpoint.mjs

/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable jsdoc/require-throws */
function cov_28xk52jqwt() {
  var path = "/__w/code/code/js/packages/bricks/src/system/utils/breakpoint.ts";
  var hash = "1435075d6562c9bb3112f30ef367f7400a36e612";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/system/utils/breakpoint.ts",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 17
        },
        end: {
          line: 7,
          column: 49
        }
      },
      "1": {
        start: {
          line: 8,
          column: 2
        },
        end: {
          line: 8,
          column: 48
        }
      },
      "2": {
        start: {
          line: 12,
          column: 14
        },
        end: {
          line: 12,
          column: 42
        }
      },
      "3": {
        start: {
          line: 13,
          column: 15
        },
        end: {
          line: 13,
          column: 56
        }
      },
      "4": {
        start: {
          line: 14,
          column: 2
        },
        end: {
          line: 14,
          column: 47
        }
      },
      "5": {
        start: {
          line: 18,
          column: 2
        },
        end: {
          line: 18,
          column: 51
        }
      },
      "6": {
        start: {
          line: 18,
          column: 21
        },
        end: {
          line: 18,
          column: 51
        }
      },
      "7": {
        start: {
          line: 19,
          column: 23
        },
        end: {
          line: 19,
          column: 45
        }
      },
      "8": {
        start: {
          line: 20,
          column: 2
        },
        end: {
          line: 20,
          column: 70
        }
      },
      "9": {
        start: {
          line: 23,
          column: 30
        },
        end: {
          line: 24,
          column: 50
        }
      },
      "10": {
        start: {
          line: 24,
          column: 2
        },
        end: {
          line: 24,
          column: 50
        }
      },
      "11": {
        start: {
          line: 26,
          column: 16
        },
        end: {
          line: 27,
          column: 57
        }
      },
      "12": {
        start: {
          line: 27,
          column: 2
        },
        end: {
          line: 27,
          column: 57
        }
      },
      "13": {
        start: {
          line: 30,
          column: 17
        },
        end: {
          line: 30,
          column: 37
        }
      },
      "14": {
        start: {
          line: 31,
          column: 2
        },
        end: {
          line: 31,
          column: 66
        }
      },
      "15": {
        start: {
          line: 35,
          column: 16
        },
        end: {
          line: 35,
          column: 49
        }
      },
      "16": {
        start: {
          line: 36,
          column: 2
        },
        end: {
          line: 36,
          column: 24
        }
      },
      "17": {
        start: {
          line: 40,
          column: 2
        },
        end: {
          line: 40,
          column: 27
        }
      },
      "18": {
        start: {
          line: 40,
          column: 14
        },
        end: {
          line: 40,
          column: 27
        }
      },
      "19": {
        start: {
          line: 41,
          column: 2
        },
        end: {
          line: 41,
          column: 29
        }
      },
      "20": {
        start: {
          line: 42,
          column: 17
        },
        end: {
          line: 45,
          column: 13
        }
      },
      "21": {
        start: {
          line: 46,
          column: 2
        },
        end: {
          line: 48,
          column: 72
        }
      },
      "22": {
        start: {
          line: 48,
          column: 43
        },
        end: {
          line: 48,
          column: 70
        }
      },
      "23": {
        start: {
          line: 52,
          column: 16
        },
        end: {
          line: 52,
          column: 33
        }
      },
      "24": {
        start: {
          line: 54,
          column: 2
        },
        end: {
          line: 54,
          column: 56
        }
      },
      "25": {
        start: {
          line: 54,
          column: 11
        },
        end: {
          line: 54,
          column: 56
        }
      },
      "26": {
        start: {
          line: 55,
          column: 2
        },
        end: {
          line: 55,
          column: 56
        }
      },
      "27": {
        start: {
          line: 55,
          column: 11
        },
        end: {
          line: 55,
          column: 56
        }
      },
      "28": {
        start: {
          line: 57,
          column: 2
        },
        end: {
          line: 57,
          column: 25
        }
      },
      "29": {
        start: {
          line: 61,
          column: 2
        },
        end: {
          line: 61,
          column: 32
        }
      },
      "30": {
        start: {
          line: 61,
          column: 20
        },
        end: {
          line: 61,
          column: 32
        }
      },
      "31": {
        start: {
          line: 63,
          column: 2
        },
        end: {
          line: 63,
          column: 47
        }
      },
      "32": {
        start: {
          line: 65,
          column: 21
        },
        end: {
          line: 65,
          column: 43
        }
      },
      "33": {
        start: {
          line: 67,
          column: 18
        },
        end: {
          line: 81,
          column: 6
        }
      },
      "34": {
        start: {
          line: 70,
          column: 21
        },
        end: {
          line: 70,
          column: 43
        }
      },
      "35": {
        start: {
          line: 71,
          column: 6
        },
        end: {
          line: 71,
          column: 63
        }
      },
      "36": {
        start: {
          line: 72,
          column: 6
        },
        end: {
          line: 80,
          column: 8
        }
      },
      "37": {
        start: {
          line: 83,
          column: 16
        },
        end: {
          line: 83,
          column: 33
        }
      },
      "38": {
        start: {
          line: 84,
          column: 19
        },
        end: {
          line: 84,
          column: 45
        }
      },
      "39": {
        start: {
          line: 86,
          column: 2
        },
        end: {
          line: 129,
          column: 4
        }
      },
      "40": {
        start: {
          line: 90,
          column: 19
        },
        end: {
          line: 90,
          column: 36
        }
      },
      "41": {
        start: {
          line: 91,
          column: 6
        },
        end: {
          line: 91,
          column: 68
        }
      },
      "42": {
        start: {
          line: 91,
          column: 52
        },
        end: {
          line: 91,
          column: 66
        }
      },
      "43": {
        start: {
          line: 96,
          column: 46
        },
        end: {
          line: 96,
          column: 70
        }
      },
      "44": {
        start: {
          line: 104,
          column: 6
        },
        end: {
          line: 106,
          column: 7
        }
      },
      "45": {
        start: {
          line: 105,
          column: 8
        },
        end: {
          line: 105,
          column: 65
        }
      },
      "46": {
        start: {
          line: 107,
          column: 21
        },
        end: {
          line: 107,
          column: 59
        }
      },
      "47": {
        start: {
          line: 107,
          column: 42
        },
        end: {
          line: 107,
          column: 58
        }
      },
      "48": {
        start: {
          line: 108,
          column: 6
        },
        end: {
          line: 110,
          column: 7
        }
      },
      "49": {
        start: {
          line: 109,
          column: 8
        },
        end: {
          line: 109,
          column: 21
        }
      },
      "50": {
        start: {
          line: 111,
          column: 6
        },
        end: {
          line: 111,
          column: 20
        }
      },
      "51": {
        start: {
          line: 120,
          column: 6
        },
        end: {
          line: 122,
          column: 7
        }
      },
      "52": {
        start: {
          line: 121,
          column: 8
        },
        end: {
          line: 121,
          column: 65
        }
      },
      "53": {
        start: {
          line: 123,
          column: 6
        },
        end: {
          line: 127,
          column: 36
        }
      },
      "54": {
        start: {
          line: 124,
          column: 20
        },
        end: {
          line: 124,
          column: 35
        }
      },
      "55": {
        start: {
          line: 125,
          column: 8
        },
        end: {
          line: 125,
          column: 59
        }
      },
      "56": {
        start: {
          line: 125,
          column: 42
        },
        end: {
          line: 125,
          column: 59
        }
      },
      "57": {
        start: {
          line: 126,
          column: 8
        },
        end: {
          line: 126,
          column: 19
        }
      }
    },
    fnMap: {
      "0": {
        name: "getLastItem",
        decl: {
          start: {
            line: 6,
            column: 9
          },
          end: {
            line: 6,
            column: 20
          }
        },
        loc: {
          start: {
            line: 6,
            column: 51
          },
          end: {
            line: 9,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "analyzeCSSValue",
        decl: {
          start: {
            line: 11,
            column: 9
          },
          end: {
            line: 11,
            column: 24
          }
        },
        loc: {
          start: {
            line: 11,
            column: 49
          },
          end: {
            line: 15,
            column: 1
          }
        },
        line: 11
      },
      "2": {
        name: "px",
        decl: {
          start: {
            line: 17,
            column: 16
          },
          end: {
            line: 17,
            column: 18
          }
        },
        loc: {
          start: {
            line: 17,
            column: 65
          },
          end: {
            line: 21,
            column: 1
          }
        },
        line: 17
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 23,
            column: 30
          },
          end: {
            line: 23,
            column: 31
          }
        },
        loc: {
          start: {
            line: 24,
            column: 2
          },
          end: {
            line: 24,
            column: 50
          }
        },
        line: 24
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 26,
            column: 16
          },
          end: {
            line: 26,
            column: 17
          }
        },
        loc: {
          start: {
            line: 27,
            column: 2
          },
          end: {
            line: 27,
            column: 57
          }
        },
        line: 27
      },
      "5": {
        name: "normalize",
        decl: {
          start: {
            line: 29,
            column: 9
          },
          end: {
            line: 29,
            column: 18
          }
        },
        loc: {
          start: {
            line: 29,
            column: 53
          },
          end: {
            line: 32,
            column: 1
          }
        },
        line: 29
      },
      "6": {
        name: "keys",
        decl: {
          start: {
            line: 34,
            column: 9
          },
          end: {
            line: 34,
            column: 13
          }
        },
        loc: {
          start: {
            line: 34,
            column: 48
          },
          end: {
            line: 37,
            column: 1
          }
        },
        line: 34
      },
      "7": {
        name: "subtract",
        decl: {
          start: {
            line: 39,
            column: 9
          },
          end: {
            line: 39,
            column: 17
          }
        },
        loc: {
          start: {
            line: 39,
            column: 33
          },
          end: {
            line: 49,
            column: 1
          }
        },
        line: 39
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 48,
            column: 36
          },
          end: {
            line: 48,
            column: 37
          }
        },
        loc: {
          start: {
            line: 48,
            column: 43
          },
          end: {
            line: 48,
            column: 70
          }
        },
        line: 48
      },
      "9": {
        name: "toMediaQueryString",
        decl: {
          start: {
            line: 51,
            column: 16
          },
          end: {
            line: 51,
            column: 34
          }
        },
        loc: {
          start: {
            line: 51,
            column: 69
          },
          end: {
            line: 58,
            column: 1
          }
        },
        line: 51
      },
      "10": {
        name: "analyzeBreakpoints",
        decl: {
          start: {
            line: 60,
            column: 16
          },
          end: {
            line: 60,
            column: 34
          }
        },
        loc: {
          start: {
            line: 60,
            column: 69
          },
          end: {
            line: 130,
            column: 1
          }
        },
        line: 60
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 69,
            column: 9
          },
          end: {
            line: 69,
            column: 10
          }
        },
        loc: {
          start: {
            line: 69,
            column: 47
          },
          end: {
            line: 81,
            column: 5
          }
        },
        line: 69
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 89,
            column: 4
          },
          end: {
            line: 89,
            column: 5
          }
        },
        loc: {
          start: {
            line: 89,
            column: 44
          },
          end: {
            line: 92,
            column: 5
          }
        },
        line: 89
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 91,
            column: 43
          },
          end: {
            line: 91,
            column: 44
          }
        },
        loc: {
          start: {
            line: 91,
            column: 52
          },
          end: {
            line: 91,
            column: 66
          }
        },
        line: 91
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 96,
            column: 36
          },
          end: {
            line: 96,
            column: 37
          }
        },
        loc: {
          start: {
            line: 96,
            column: 46
          },
          end: {
            line: 96,
            column: 70
          }
        },
        line: 96
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 103,
            column: 4
          },
          end: {
            line: 103,
            column: 5
          }
        },
        loc: {
          start: {
            line: 103,
            column: 44
          },
          end: {
            line: 112,
            column: 5
          }
        },
        line: 103
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 107,
            column: 34
          },
          end: {
            line: 107,
            column: 35
          }
        },
        loc: {
          start: {
            line: 107,
            column: 42
          },
          end: {
            line: 107,
            column: 58
          }
        },
        line: 107
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 119,
            column: 4
          },
          end: {
            line: 119,
            column: 5
          }
        },
        loc: {
          start: {
            line: 119,
            column: 31
          },
          end: {
            line: 128,
            column: 5
          }
        },
        line: 119
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 123,
            column: 25
          },
          end: {
            line: 123,
            column: 26
          }
        },
        loc: {
          start: {
            line: 123,
            column: 48
          },
          end: {
            line: 127,
            column: 7
          }
        },
        line: 123
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 7,
            column: 17
          },
          end: {
            line: 7,
            column: 49
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 7,
            column: 33
          },
          end: {
            line: 7,
            column: 34
          }
        }, {
          start: {
            line: 7,
            column: 37
          },
          end: {
            line: 7,
            column: 49
          }
        }],
        line: 7
      },
      "1": {
        loc: {
          start: {
            line: 8,
            column: 9
          },
          end: {
            line: 8,
            column: 47
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 8,
            column: 18
          },
          end: {
            line: 8,
            column: 35
          }
        }, {
          start: {
            line: 8,
            column: 38
          },
          end: {
            line: 8,
            column: 47
          }
        }],
        line: 8
      },
      "2": {
        loc: {
          start: {
            line: 18,
            column: 2
          },
          end: {
            line: 18,
            column: 51
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 18,
            column: 2
          },
          end: {
            line: 18,
            column: 51
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 18
      },
      "3": {
        loc: {
          start: {
            line: 20,
            column: 9
          },
          end: {
            line: 20,
            column: 69
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 20,
            column: 49
          },
          end: {
            line: 20,
            column: 61
          }
        }, {
          start: {
            line: 20,
            column: 64
          },
          end: {
            line: 20,
            column: 69
          }
        }],
        line: 20
      },
      "4": {
        loc: {
          start: {
            line: 20,
            column: 9
          },
          end: {
            line: 20,
            column: 46
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 20,
            column: 9
          },
          end: {
            line: 20,
            column: 17
          }
        }, {
          start: {
            line: 20,
            column: 21
          },
          end: {
            line: 20,
            column: 46
          }
        }],
        line: 20
      },
      "5": {
        loc: {
          start: {
            line: 24,
            column: 2
          },
          end: {
            line: 24,
            column: 50
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 24,
            column: 44
          },
          end: {
            line: 24,
            column: 45
          }
        }, {
          start: {
            line: 24,
            column: 48
          },
          end: {
            line: 24,
            column: 50
          }
        }],
        line: 24
      },
      "6": {
        loc: {
          start: {
            line: 40,
            column: 2
          },
          end: {
            line: 40,
            column: 27
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 40,
            column: 2
          },
          end: {
            line: 40,
            column: 27
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 40
      },
      "7": {
        loc: {
          start: {
            line: 41,
            column: 10
          },
          end: {
            line: 41,
            column: 28
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 41,
            column: 10
          },
          end: {
            line: 41,
            column: 19
          }
        }, {
          start: {
            line: 41,
            column: 23
          },
          end: {
            line: 41,
            column: 28
          }
        }],
        line: 41
      },
      "8": {
        loc: {
          start: {
            line: 42,
            column: 17
          },
          end: {
            line: 45,
            column: 13
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 43,
            column: 6
          },
          end: {
            line: 43,
            column: 8
          }
        }, {
          start: {
            line: 45,
            column: 6
          },
          end: {
            line: 45,
            column: 13
          }
        }],
        line: 42
      },
      "9": {
        loc: {
          start: {
            line: 46,
            column: 9
          },
          end: {
            line: 48,
            column: 71
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 47,
            column: 6
          },
          end: {
            line: 47,
            column: 25
          }
        }, {
          start: {
            line: 48,
            column: 6
          },
          end: {
            line: 48,
            column: 71
          }
        }],
        line: 46
      },
      "10": {
        loc: {
          start: {
            line: 54,
            column: 2
          },
          end: {
            line: 54,
            column: 56
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 54,
            column: 2
          },
          end: {
            line: 54,
            column: 56
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 54
      },
      "11": {
        loc: {
          start: {
            line: 55,
            column: 2
          },
          end: {
            line: 55,
            column: 56
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 55,
            column: 2
          },
          end: {
            line: 55,
            column: 56
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 55
      },
      "12": {
        loc: {
          start: {
            line: 61,
            column: 2
          },
          end: {
            line: 61,
            column: 32
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 61,
            column: 2
          },
          end: {
            line: 61,
            column: 32
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 61
      },
      "13": {
        loc: {
          start: {
            line: 63,
            column: 21
          },
          end: {
            line: 63,
            column: 46
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 63,
            column: 21
          },
          end: {
            line: 63,
            column: 37
          }
        }, {
          start: {
            line: 63,
            column: 41
          },
          end: {
            line: 63,
            column: 46
          }
        }],
        line: 63
      },
      "14": {
        loc: {
          start: {
            line: 70,
            column: 21
          },
          end: {
            line: 70,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 70,
            column: 21
          },
          end: {
            line: 70,
            column: 37
          }
        }, {
          start: {
            line: 70,
            column: 41
          },
          end: {
            line: 70,
            column: 43
          }
        }],
        line: 70
      },
      "15": {
        loc: {
          start: {
            line: 71,
            column: 13
          },
          end: {
            line: 71,
            column: 62
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 71,
            column: 36
          },
          end: {
            line: 71,
            column: 50
          }
        }, {
          start: {
            line: 71,
            column: 53
          },
          end: {
            line: 71,
            column: 62
          }
        }],
        line: 71
      },
      "16": {
        loc: {
          start: {
            line: 91,
            column: 13
          },
          end: {
            line: 91,
            column: 67
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 91,
            column: 13
          },
          end: {
            line: 91,
            column: 28
          }
        }, {
          start: {
            line: 91,
            column: 32
          },
          end: {
            line: 91,
            column: 67
          }
        }],
        line: 91
      },
      "17": {
        loc: {
          start: {
            line: 104,
            column: 6
          },
          end: {
            line: 106,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 104,
            column: 6
          },
          end: {
            line: 106,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 104
      },
      "18": {
        loc: {
          start: {
            line: 107,
            column: 42
          },
          end: {
            line: 107,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 107,
            column: 42
          },
          end: {
            line: 107,
            column: 50
          }
        }, {
          start: {
            line: 107,
            column: 54
          },
          end: {
            line: 107,
            column: 58
          }
        }],
        line: 107
      },
      "19": {
        loc: {
          start: {
            line: 120,
            column: 6
          },
          end: {
            line: 122,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 120,
            column: 6
          },
          end: {
            line: 122,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 120
      },
      "20": {
        loc: {
          start: {
            line: 125,
            column: 8
          },
          end: {
            line: 125,
            column: 59
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 125,
            column: 8
          },
          end: {
            line: 125,
            column: 59
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 125
      },
      "21": {
        loc: {
          start: {
            line: 125,
            column: 12
          },
          end: {
            line: 125,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 125,
            column: 12
          },
          end: {
            line: 125,
            column: 23
          }
        }, {
          start: {
            line: 125,
            column: 27
          },
          end: {
            line: 125,
            column: 40
          }
        }],
        line: 125
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "1435075d6562c9bb3112f30ef367f7400a36e612"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_28xk52jqwt = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_28xk52jqwt();
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }




























function getLastItem(array) {
  cov_28xk52jqwt().f[0]++;
  var length = (cov_28xk52jqwt().s[0]++, array == null ? (cov_28xk52jqwt().b[0][0]++, 0) : (cov_28xk52jqwt().b[0][1]++, array.length));
  cov_28xk52jqwt().s[1]++;
  return length ? (cov_28xk52jqwt().b[1][0]++, array[length - 1]) : (cov_28xk52jqwt().b[1][1]++, undefined);
}
function analyzeCSSValue(value) {
  cov_28xk52jqwt().f[1]++;
  var num = (cov_28xk52jqwt().s[2]++, parseFloat(value.toString()));
  var unit = (cov_28xk52jqwt().s[3]++, value.toString().replace(String(num), ''));
  cov_28xk52jqwt().s[4]++;
  return {
    unitless: !unit,
    value: num,
    unit: unit
  };
}
function px(value) {
  cov_28xk52jqwt().f[2]++;
  cov_28xk52jqwt().s[5]++;
  if (value == null) {
    cov_28xk52jqwt().b[2][0]++;
    cov_28xk52jqwt().s[6]++;
    return value;
  } else {
    cov_28xk52jqwt().b[2][1]++;
  }
  var _ref = (cov_28xk52jqwt().s[7]++, analyzeCSSValue(value)),
    unitless = _ref.unitless;
  cov_28xk52jqwt().s[8]++;
  return (cov_28xk52jqwt().b[4][0]++, unitless) || (cov_28xk52jqwt().b[4][1]++, typeof value === 'number') ? (cov_28xk52jqwt().b[3][0]++, "".concat(value, "px")) : (cov_28xk52jqwt().b[3][1]++, value);
}
cov_28xk52jqwt().s[9]++;
var sortByBreakpointValue = function sortByBreakpointValue(a, b) {
  cov_28xk52jqwt().f[3]++;
  cov_28xk52jqwt().s[10]++;
  return parseInt(a[1], 10) > parseInt(b[1], 10) ? (cov_28xk52jqwt().b[5][0]++, 1) : (cov_28xk52jqwt().b[5][1]++, -1);
};
cov_28xk52jqwt().s[11]++;
var sortBps = function sortBps(breakpoints) {
  cov_28xk52jqwt().f[4]++;
  cov_28xk52jqwt().s[12]++;
  return Object.entries(breakpoints).sort(sortByBreakpointValue);
};
function normalize(breakpoints) {
  cov_28xk52jqwt().f[5]++;
  var sorted = (cov_28xk52jqwt().s[13]++, sortBps(breakpoints));
  cov_28xk52jqwt().s[14]++;
  return _extends(Object.values(sorted), sorted);
}
function keys(breakpoints) {
  cov_28xk52jqwt().f[6]++;
  var value = (cov_28xk52jqwt().s[15]++, Object.keys(sortBps(breakpoints)));
  cov_28xk52jqwt().s[16]++;
  return new Set(value);
}
function subtract(value) {
  var _ref2;
  cov_28xk52jqwt().f[7]++;
  cov_28xk52jqwt().s[17]++;
  if (!value) {
    cov_28xk52jqwt().b[6][0]++;
    cov_28xk52jqwt().s[18]++;
    return value;
  } else {
    cov_28xk52jqwt().b[6][1]++;
  }
  cov_28xk52jqwt().s[19]++;
  value = (_ref2 = (cov_28xk52jqwt().b[7][0]++, px(value))) !== null && _ref2 !== void 0 ? _ref2 : (cov_28xk52jqwt().b[7][1]++, value);
  var factor = (cov_28xk52jqwt().s[20]++, value.endsWith('px') ? (cov_28xk52jqwt().b[8][0]++, -1) : ( // the equivalent of 1px in em using a 16px base
  cov_28xk52jqwt().b[8][1]++, -0.0625));
  cov_28xk52jqwt().s[21]++;
  return typeof value === 'number' ? (cov_28xk52jqwt().b[9][0]++, "".concat(value + factor)) : (cov_28xk52jqwt().b[9][1]++, value.replace(/([0-9]+\.?[0-9]*)/, function (m) {
    cov_28xk52jqwt().f[8]++;
    cov_28xk52jqwt().s[22]++;
    return "".concat(parseFloat(m) + factor);
  }));
}
function toMediaQueryString(min, max) {
  cov_28xk52jqwt().f[9]++;
  var query = (cov_28xk52jqwt().s[23]++, ['@media screen']);
  cov_28xk52jqwt().s[24]++;
  if (min) {
    cov_28xk52jqwt().b[10][0]++;
    cov_28xk52jqwt().s[25]++;
    query.push('and', "(min-width: ".concat(px(min), ")"));
  } else {
    cov_28xk52jqwt().b[10][1]++;
  }
  cov_28xk52jqwt().s[26]++;
  if (max) {
    cov_28xk52jqwt().b[11][0]++;
    cov_28xk52jqwt().s[27]++;
    query.push('and', "(max-width: ".concat(px(max), ")"));
  } else {
    cov_28xk52jqwt().b[11][1]++;
  }
  cov_28xk52jqwt().s[28]++;
  return query.join(' ');
}
function analyzeBreakpoints(breakpoints) {
  var _ref3;
  cov_28xk52jqwt().f[10]++;
  cov_28xk52jqwt().s[29]++;
  if (!breakpoints) {
    cov_28xk52jqwt().b[12][0]++;
    cov_28xk52jqwt().s[30]++;
    return null;
  } else {
    cov_28xk52jqwt().b[12][1]++;
  }
  cov_28xk52jqwt().s[31]++;
  breakpoints.base = (_ref3 = (cov_28xk52jqwt().b[13][0]++, breakpoints.base)) !== null && _ref3 !== void 0 ? _ref3 : (cov_28xk52jqwt().b[13][1]++, '0px');
  var normalized = (cov_28xk52jqwt().s[32]++, normalize(breakpoints));
  var queries = (cov_28xk52jqwt().s[33]++, Object.entries(breakpoints).sort(sortByBreakpointValue).map(function (_ref4, index, entry) {
    var _ref8;
    var _ref5 = _slicedToArray(_ref4, 2),
      breakpoint = _ref5[0],
      minW = _ref5[1];
    cov_28xk52jqwt().f[11]++;
    var _ref6 = (cov_28xk52jqwt().s[34]++, (_ref8 = (cov_28xk52jqwt().b[14][0]++, entry[index + 1])) !== null && _ref8 !== void 0 ? _ref8 : (cov_28xk52jqwt().b[14][1]++, [])),
      _ref7 = _slicedToArray(_ref6, 2),
      maxW = _ref7[1];
    cov_28xk52jqwt().s[35]++;
    maxW = parseFloat(maxW) > 0 ? (cov_28xk52jqwt().b[15][0]++, subtract(maxW)) : (cov_28xk52jqwt().b[15][1]++, undefined);
    cov_28xk52jqwt().s[36]++;
    return {
      _minW: subtract(minW),
      breakpoint: breakpoint,
      minW: minW,
      maxW: maxW,
      maxWQuery: toMediaQueryString(null, maxW),
      minWQuery: toMediaQueryString(minW),
      minMaxQuery: toMediaQueryString(minW, maxW)
    };
  }));
  var _keys = (cov_28xk52jqwt().s[37]++, keys(breakpoints));
  var _keysArr = (cov_28xk52jqwt().s[38]++, Array.from(_keys.values()));
  cov_28xk52jqwt().s[39]++;
  return {
    keys: _keys,
    normalized: normalized,
    isResponsive: function isResponsive(test) {
      cov_28xk52jqwt().f[12]++;
      var keys = (cov_28xk52jqwt().s[40]++, Object.keys(test));
      cov_28xk52jqwt().s[41]++;
      return (cov_28xk52jqwt().b[16][0]++, keys.length > 0) && (cov_28xk52jqwt().b[16][1]++, keys.every(function (key) {
        cov_28xk52jqwt().f[13]++;
        cov_28xk52jqwt().s[42]++;
        return _keys.has(key);
      }));
    },
    asObject: sortBps(breakpoints),
    asArray: normalize(breakpoints),
    details: queries,
    media: [null].concat(_toConsumableArray(normalized.map(function (minW) {
      cov_28xk52jqwt().f[14]++;
      cov_28xk52jqwt().s[43]++;
      return toMediaQueryString(minW);
    }).slice(1))),
    /**
     * Converts the object responsive syntax to array syntax
     *
     * @example
     * toArrayValue({ base: 1, sm: 2, md: 3 }) // => [1, 2, 3]
     */
    toArrayValue: function toArrayValue(test) {
      cov_28xk52jqwt().f[15]++;
      cov_28xk52jqwt().s[44]++;
      if (!_isObject(test)) {
        cov_28xk52jqwt().b[17][0]++;
        cov_28xk52jqwt().s[45]++;
        throw new Error('toArrayValue: value must be an object');
      } else {
        cov_28xk52jqwt().b[17][1]++;
      }
      var result = (cov_28xk52jqwt().s[46]++, _keysArr.map(function (bp) {
        var _ref9;
        cov_28xk52jqwt().f[16]++;
        cov_28xk52jqwt().s[47]++;
        return (_ref9 = (cov_28xk52jqwt().b[18][0]++, test[bp])) !== null && _ref9 !== void 0 ? _ref9 : (cov_28xk52jqwt().b[18][1]++, null);
      }));
      cov_28xk52jqwt().s[48]++;
      while (getLastItem(result) === null) {
        cov_28xk52jqwt().s[49]++;
        result.pop();
      }
      cov_28xk52jqwt().s[50]++;
      return result;
    },
    /**
     * Converts the array responsive syntax to object syntax
     *
     * @example
     * toObjectValue([1, 2, 3]) // => { base: 1, sm: 2, md: 3 }
     */
    toObjectValue: function toObjectValue(test) {
      cov_28xk52jqwt().f[17]++;
      cov_28xk52jqwt().s[51]++;
      if (!Array.isArray(test)) {
        cov_28xk52jqwt().b[19][0]++;
        cov_28xk52jqwt().s[52]++;
        throw new Error('toObjectValue: value must be an array');
      } else {
        cov_28xk52jqwt().b[19][1]++;
      }
      cov_28xk52jqwt().s[53]++;
      return test.reduce(function (acc, value, index) {
        cov_28xk52jqwt().f[18]++;
        var key = (cov_28xk52jqwt().s[54]++, _keysArr[index]);
        cov_28xk52jqwt().s[55]++;
        if ((cov_28xk52jqwt().b[21][0]++, key != null) && (cov_28xk52jqwt().b[21][1]++, value != null)) {
          cov_28xk52jqwt().b[20][0]++;
          cov_28xk52jqwt().s[56]++;
          acc[key] = value;
        } else {
          cov_28xk52jqwt().b[20][1]++;
        }
        cov_28xk52jqwt().s[57]++;
        return acc;
      }, {});
    }
  };
}
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/system/utils/style-config.mjs
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }



/* eslint-disable @typescript-eslint/no-explicit-any */
// import { ResponsiveValue, WithCSSVar } from './utils';
function cov_12ekfcgw1() {
  var path = "/__w/code/code/js/packages/bricks/src/system/utils/style-config.ts";
  var hash = "658eee715ada37aa2d6f33c32db40a90bd014819";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/system/utils/style-config.ts",
    statementMap: {
      "0": {
        start: {
          line: 28,
          column: 2
        },
        end: {
          line: 28,
          column: 35
        }
      },
      "1": {
        start: {
          line: 28,
          column: 22
        },
        end: {
          line: 28,
          column: 35
        }
      },
      "2": {
        start: {
          line: 29,
          column: 2
        },
        end: {
          line: 29,
          column: 45
        }
      },
      "3": {
        start: {
          line: 29,
          column: 23
        },
        end: {
          line: 29,
          column: 45
        }
      },
      "4": {
        start: {
          line: 30,
          column: 2
        },
        end: {
          line: 30,
          column: 36
        }
      },
      "5": {
        start: {
          line: 30,
          column: 21
        },
        end: {
          line: 30,
          column: 36
        }
      },
      "6": {
        start: {
          line: 35,
          column: 2
        },
        end: {
          line: 37,
          column: 3
        }
      },
      "7": {
        start: {
          line: 35,
          column: 15
        },
        end: {
          line: 35,
          column: 20
        }
      },
      "8": {
        start: {
          line: 36,
          column: 4
        },
        end: {
          line: 36,
          column: 36
        }
      },
      "9": {
        start: {
          line: 36,
          column: 27
        },
        end: {
          line: 36,
          column: 36
        }
      },
      "10": {
        start: {
          line: 38,
          column: 2
        },
        end: {
          line: 38,
          column: 12
        }
      },
      "11": {
        start: {
          line: 42,
          column: 25
        },
        end: {
          line: 42,
          column: 44
        }
      },
      "12": {
        start: {
          line: 43,
          column: 2
        },
        end: {
          line: 95,
          column: 4
        }
      },
      "13": {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 54,
          column: 32
        }
      },
      "14": {
        start: {
          line: 54,
          column: 25
        },
        end: {
          line: 54,
          column: 32
        }
      },
      "15": {
        start: {
          line: 56,
          column: 25
        },
        end: {
          line: 56,
          column: 27
        }
      },
      "16": {
        start: {
          line: 58,
          column: 23
        },
        end: {
          line: 58,
          column: 68
        }
      },
      "17": {
        start: {
          line: 60,
          column: 4
        },
        end: {
          line: 60,
          column: 35
        }
      },
      "18": {
        start: {
          line: 60,
          column: 21
        },
        end: {
          line: 60,
          column: 35
        }
      },
      "19": {
        start: {
          line: 62,
          column: 16
        },
        end: {
          line: 62,
          column: 33
        }
      },
      "20": {
        start: {
          line: 63,
          column: 21
        },
        end: {
          line: 63,
          column: 30
        }
      },
      "21": {
        start: {
          line: 65,
          column: 24
        },
        end: {
          line: 65,
          column: 38
        }
      },
      "22": {
        start: {
          line: 67,
          column: 4
        },
        end: {
          line: 92,
          column: 5
        }
      },
      "23": {
        start: {
          line: 67,
          column: 17
        },
        end: {
          line: 67,
          column: 18
        }
      },
      "24": {
        start: {
          line: 68,
          column: 18
        },
        end: {
          line: 68,
          column: 43
        }
      },
      "25": {
        start: {
          line: 69,
          column: 22
        },
        end: {
          line: 69,
          column: 73
        }
      },
      "26": {
        start: {
          line: 70,
          column: 20
        },
        end: {
          line: 70,
          column: 64
        }
      },
      "27": {
        start: {
          line: 72,
          column: 21
        },
        end: {
          line: 72,
          column: 66
        }
      },
      "28": {
        start: {
          line: 74,
          column: 6
        },
        end: {
          line: 74,
          column: 28
        }
      },
      "29": {
        start: {
          line: 74,
          column: 19
        },
        end: {
          line: 74,
          column: 28
        }
      },
      "30": {
        start: {
          line: 76,
          column: 6
        },
        end: {
          line: 83,
          column: 7
        }
      },
      "31": {
        start: {
          line: 77,
          column: 8
        },
        end: {
          line: 81,
          column: 11
        }
      },
      "32": {
        start: {
          line: 78,
          column: 10
        },
        end: {
          line: 80,
          column: 13
        }
      },
      "33": {
        start: {
          line: 82,
          column: 8
        },
        end: {
          line: 82,
          column: 17
        }
      },
      "34": {
        start: {
          line: 85,
          column: 6
        },
        end: {
          line: 89,
          column: 7
        }
      },
      "35": {
        start: {
          line: 86,
          column: 8
        },
        end: {
          line: 87,
          column: 36
        }
      },
      "36": {
        start: {
          line: 86,
          column: 22
        },
        end: {
          line: 86,
          column: 48
        }
      },
      "37": {
        start: {
          line: 87,
          column: 13
        },
        end: {
          line: 87,
          column: 36
        }
      },
      "38": {
        start: {
          line: 88,
          column: 8
        },
        end: {
          line: 88,
          column: 17
        }
      },
      "39": {
        start: {
          line: 91,
          column: 6
        },
        end: {
          line: 91,
          column: 29
        }
      },
      "40": {
        start: {
          line: 94,
          column: 4
        },
        end: {
          line: 94,
          column: 18
        }
      },
      "41": {
        start: {
          line: 105,
          column: 2
        },
        end: {
          line: 116,
          column: 4
        }
      },
      "42": {
        start: {
          line: 106,
          column: 37
        },
        end: {
          line: 106,
          column: 42
        }
      },
      "43": {
        start: {
          line: 107,
          column: 19
        },
        end: {
          line: 107,
          column: 40
        }
      },
      "44": {
        start: {
          line: 108,
          column: 4
        },
        end: {
          line: 115,
          column: 6
        }
      }
    },
    fnMap: {
      "0": {
        name: "normalize",
        decl: {
          start: {
            line: 27,
            column: 9
          },
          end: {
            line: 27,
            column: 18
          }
        },
        loc: {
          start: {
            line: 27,
            column: 79
          },
          end: {
            line: 31,
            column: 1
          }
        },
        line: 27
      },
      "1": {
        name: "getNextIndex",
        decl: {
          start: {
            line: 34,
            column: 9
          },
          end: {
            line: 34,
            column: 21
          }
        },
        loc: {
          start: {
            line: 34,
            column: 51
          },
          end: {
            line: 39,
            column: 1
          }
        },
        line: 34
      },
      "2": {
        name: "createResolver",
        decl: {
          start: {
            line: 41,
            column: 9
          },
          end: {
            line: 41,
            column: 23
          }
        },
        loc: {
          start: {
            line: 41,
            column: 38
          },
          end: {
            line: 96,
            column: 1
          }
        },
        line: 41
      },
      "3": {
        name: "resolver",
        decl: {
          start: {
            line: 43,
            column: 18
          },
          end: {
            line: 43,
            column: 26
          }
        },
        loc: {
          start: {
            line: 52,
            column: 4
          },
          end: {
            line: 95,
            column: 3
          }
        },
        line: 52
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 77,
            column: 30
          },
          end: {
            line: 77,
            column: 31
          }
        },
        loc: {
          start: {
            line: 77,
            column: 40
          },
          end: {
            line: 81,
            column: 9
          }
        },
        line: 77
      },
      "5": {
        name: "resolveStyleConfig",
        decl: {
          start: {
            line: 104,
            column: 16
          },
          end: {
            line: 104,
            column: 34
          }
        },
        loc: {
          start: {
            line: 104,
            column: 51
          },
          end: {
            line: 117,
            column: 1
          }
        },
        line: 104
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 105,
            column: 9
          },
          end: {
            line: 105,
            column: 10
          }
        },
        loc: {
          start: {
            line: 105,
            column: 28
          },
          end: {
            line: 116,
            column: 3
          }
        },
        line: 105
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 28,
            column: 2
          },
          end: {
            line: 28,
            column: 35
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 28,
            column: 2
          },
          end: {
            line: 28,
            column: 35
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 28
      },
      "1": {
        loc: {
          start: {
            line: 29,
            column: 2
          },
          end: {
            line: 29,
            column: 45
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 29,
            column: 2
          },
          end: {
            line: 29,
            column: 45
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 29
      },
      "2": {
        loc: {
          start: {
            line: 30,
            column: 2
          },
          end: {
            line: 30,
            column: 36
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 30,
            column: 2
          },
          end: {
            line: 30,
            column: 36
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 30
      },
      "3": {
        loc: {
          start: {
            line: 36,
            column: 4
          },
          end: {
            line: 36,
            column: 36
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 36,
            column: 4
          },
          end: {
            line: 36,
            column: 36
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 36
      },
      "4": {
        loc: {
          start: {
            line: 54,
            column: 4
          },
          end: {
            line: 54,
            column: 32
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 54,
            column: 4
          },
          end: {
            line: 54,
            column: 32
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 54
      },
      "5": {
        loc: {
          start: {
            line: 60,
            column: 4
          },
          end: {
            line: 60,
            column: 35
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 60,
            column: 4
          },
          end: {
            line: 60,
            column: 35
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 60
      },
      "6": {
        loc: {
          start: {
            line: 74,
            column: 6
          },
          end: {
            line: 74,
            column: 28
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 74,
            column: 6
          },
          end: {
            line: 74,
            column: 28
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 74
      },
      "7": {
        loc: {
          start: {
            line: 76,
            column: 6
          },
          end: {
            line: 83,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 76,
            column: 6
          },
          end: {
            line: 83,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 76
      },
      "8": {
        loc: {
          start: {
            line: 79,
            column: 20
          },
          end: {
            line: 79,
            column: 71
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 79,
            column: 31
          },
          end: {
            line: 79,
            column: 43
          }
        }, {
          start: {
            line: 79,
            column: 46
          },
          end: {
            line: 79,
            column: 71
          }
        }],
        line: 79
      },
      "9": {
        loc: {
          start: {
            line: 85,
            column: 6
          },
          end: {
            line: 89,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 85,
            column: 6
          },
          end: {
            line: 89,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 85
      },
      "10": {
        loc: {
          start: {
            line: 86,
            column: 8
          },
          end: {
            line: 87,
            column: 36
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 86,
            column: 8
          },
          end: {
            line: 87,
            column: 36
          }
        }, {
          start: {
            line: 87,
            column: 13
          },
          end: {
            line: 87,
            column: 36
          }
        }],
        line: 86
      },
      "11": {
        loc: {
          start: {
            line: 110,
            column: 14
          },
          end: {
            line: 110,
            column: 36
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 110,
            column: 14
          },
          end: {
            line: 110,
            column: 30
          }
        }, {
          start: {
            line: 110,
            column: 34
          },
          end: {
            line: 110,
            column: 36
          }
        }],
        line: 110
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "658eee715ada37aa2d6f33c32db40a90bd014819"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_12ekfcgw1 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_12ekfcgw1();
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }















function style_config_normalize(value, toArray) {
  cov_12ekfcgw1().f[0]++;
  cov_12ekfcgw1().s[0]++;
  if (isArray(value)) {
    cov_12ekfcgw1().b[0][0]++;
    cov_12ekfcgw1().s[1]++;
    return value;
  } else {
    cov_12ekfcgw1().b[0][1]++;
  }
  cov_12ekfcgw1().s[2]++;
  if (isObject(value)) {
    cov_12ekfcgw1().b[1][0]++;
    cov_12ekfcgw1().s[3]++;
    return toArray(value);
  } else {
    cov_12ekfcgw1().b[1][1]++;
  }
  cov_12ekfcgw1().s[4]++;
  if (value != null) {
    cov_12ekfcgw1().b[2][0]++;
    cov_12ekfcgw1().s[5]++;
    return [value];
  } else {
    cov_12ekfcgw1().b[2][1]++;
  }
}

//given [ 'sm', null, null, 'md' ] and i'm at "sm", find the next index that has non-null value
function getNextIndex(values, i) {
  cov_12ekfcgw1().f[1]++;
  cov_12ekfcgw1().s[6]++;
  for (var j = (cov_12ekfcgw1().s[7]++, i + 1); j < values.length; j++) {
    cov_12ekfcgw1().s[8]++;
    if (values[j] != null) {
      cov_12ekfcgw1().b[3][0]++;
      cov_12ekfcgw1().s[9]++;
      return j;
    } else {
      cov_12ekfcgw1().b[3][1]++;
    }
  }
  cov_12ekfcgw1().s[10]++;
  return -1;
}
function createResolver(theme) {
  cov_12ekfcgw1().f[2]++;
  var breakpointUtil = (cov_12ekfcgw1().s[11]++, theme.__breakpoints);
  cov_12ekfcgw1().s[12]++;
  return function resolver(config, prop, value, props) {
    cov_12ekfcgw1().f[3]++;
    cov_12ekfcgw1().s[13]++;
    //
    if (!breakpointUtil) {
      cov_12ekfcgw1().b[4][0]++;
      cov_12ekfcgw1().s[14]++;
      return;
    } else {
      cov_12ekfcgw1().b[4][1]++;
    }
    var result = (cov_12ekfcgw1().s[15]++, {});
    var normalized = (cov_12ekfcgw1().s[16]++, style_config_normalize(value, breakpointUtil.toArrayValue));
    cov_12ekfcgw1().s[17]++;
    if (!normalized) {
      cov_12ekfcgw1().b[5][0]++;
      cov_12ekfcgw1().s[18]++;
      return result;
    } else {
      cov_12ekfcgw1().b[5][1]++;
    }
    var len = (cov_12ekfcgw1().s[19]++, normalized.length);
    var isSingle = (cov_12ekfcgw1().s[20]++, len === 1);
    var isMultipart = (cov_12ekfcgw1().s[21]++, !!config.parts);
    cov_12ekfcgw1().s[22]++;
    var _loop = function _loop() {
        var _config$prop;
        var key = (cov_12ekfcgw1().s[24]++, breakpointUtil.details[i]);
        var nextKey = (cov_12ekfcgw1().s[25]++, breakpointUtil.details[getNextIndex(normalized, i)]);
        var query = (cov_12ekfcgw1().s[26]++, toMediaQueryString(key.minW, nextKey === null || nextKey === void 0 ? void 0 : nextKey._minW));
        var styles = (cov_12ekfcgw1().s[27]++, runIfFn((_config$prop = config[prop]) === null || _config$prop === void 0 ? void 0 : _config$prop[normalized[i]], props));
        cov_12ekfcgw1().s[28]++;
        if (!styles) {
          cov_12ekfcgw1().b[6][0]++;
          cov_12ekfcgw1().s[29]++;
          return 0; // continue
        } else {
          cov_12ekfcgw1().b[6][1]++;
        }
        cov_12ekfcgw1().s[30]++;
        if (isMultipart) {
          var _config$parts;
          cov_12ekfcgw1().b[7][0]++;
          cov_12ekfcgw1().s[31]++;
          (_config$parts = config.parts) === null || _config$parts === void 0 || _config$parts.forEach(function (part) {
            cov_12ekfcgw1().f[4]++;
            cov_12ekfcgw1().s[32]++;
            mergeWith(result, _defineProperty({}, part, isSingle ? (cov_12ekfcgw1().b[8][0]++, styles[part]) : (cov_12ekfcgw1().b[8][1]++, _defineProperty({}, query, styles[part]))));
          });
          cov_12ekfcgw1().s[33]++;
          return 0; // continue
        } else {
          cov_12ekfcgw1().b[7][1]++;
        }
        cov_12ekfcgw1().s[34]++;
        if (!isMultipart) {
          cov_12ekfcgw1().b[9][0]++;
          cov_12ekfcgw1().s[35]++;
          if (isSingle) {
            cov_12ekfcgw1().b[10][0]++;
            cov_12ekfcgw1().s[36]++;
            mergeWith(result, styles);
          } else {
            cov_12ekfcgw1().b[10][1]++;
            cov_12ekfcgw1().s[37]++;
            result[query] = styles;
          }
          cov_12ekfcgw1().s[38]++;
          return 0; // continue
        } else {
          cov_12ekfcgw1().b[9][1]++;
        }
        cov_12ekfcgw1().s[39]++;
        result[query] = styles;
      },
      _ret;
    for (var i = (cov_12ekfcgw1().s[23]++, 0); i < len; i++) {
      _ret = _loop();
      if (_ret === 0) continue;
    }
    cov_12ekfcgw1().s[40]++;
    return result;
  };
}
function resolveStyleConfig(config) {
  cov_12ekfcgw1().f[5]++;
  cov_12ekfcgw1().s[41]++;
  return function (props) {
    var _ref3;
    cov_12ekfcgw1().f[6]++;
    var _ref2 = (cov_12ekfcgw1().s[42]++, props),
      variant = _ref2.variant,
      size = _ref2.size,
      theme = _ref2.theme;
    var recipe = (cov_12ekfcgw1().s[43]++, createResolver(theme));
    cov_12ekfcgw1().s[44]++;
    return mergeWith({}, runIfFn((_ref3 = (cov_12ekfcgw1().b[11][0]++, config.baseStyle)) !== null && _ref3 !== void 0 ? _ref3 : (cov_12ekfcgw1().b[11][1]++, {}), props), recipe(config, 'variants', variant, props),
    // This ordering is important
    // Ensures that size CSS modifiers are applied on TOP of variant CSS modifiers
    recipe(config, 'sizes', size, props));
  };
}
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/system/utils/use-style-config.mjs




var _excluded = ["styleConfig"];
function cov_3oob4nova() {
  var path = "/__w/code/code/js/packages/bricks/src/system/utils/use-style-config.ts";
  var hash = "7b084bf671efad07a412044702b854d34bc961a7";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/system/utils/use-style-config.ts",
    statementMap: {
      "0": {
        start: {
          line: 109,
          column: 52
        },
        end: {
          line: 109,
          column: 57
        }
      },
      "1": {
        start: {
          line: 112,
          column: 16
        },
        end: {
          line: 112,
          column: 26
        }
      },
      "2": {
        start: {
          line: 114,
          column: 27
        },
        end: {
          line: 114,
          column: 71
        }
      },
      "3": {
        start: {
          line: 115,
          column: 22
        },
        end: {
          line: 115,
          column: 57
        }
      },
      "4": {
        start: {
          line: 117,
          column: 22
        },
        end: {
          line: 121,
          column: 3
        }
      },
      "5": {
        start: {
          line: 126,
          column: 20
        },
        end: {
          line: 126,
          column: 41
        }
      },
      "6": {
        start: {
          line: 128,
          column: 2
        },
        end: {
          line: 137,
          column: 3
        }
      },
      "7": {
        start: {
          line: 129,
          column: 22
        },
        end: {
          line: 129,
          column: 53
        }
      },
      "8": {
        start: {
          line: 130,
          column: 19
        },
        end: {
          line: 130,
          column: 41
        }
      },
      "9": {
        start: {
          line: 132,
          column: 25
        },
        end: {
          line: 132,
          column: 59
        }
      },
      "10": {
        start: {
          line: 134,
          column: 4
        },
        end: {
          line: 136,
          column: 5
        }
      },
      "11": {
        start: {
          line: 135,
          column: 6
        },
        end: {
          line: 135,
          column: 33
        }
      },
      "12": {
        start: {
          line: 139,
          column: 2
        },
        end: {
          line: 139,
          column: 27
        }
      },
      "13": {
        start: {
          line: 149,
          column: 2
        },
        end: {
          line: 149,
          column: 66
        }
      },
      "14": {
        start: {
          line: 159,
          column: 2
        },
        end: {
          line: 161,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "useStyleConfigImpl",
        decl: {
          start: {
            line: 102,
            column: 16
          },
          end: {
            line: 102,
            column: 34
          }
        },
        loc: {
          start: {
            line: 108,
            column: 2
          },
          end: {
            line: 140,
            column: 1
          }
        },
        line: 108
      },
      "1": {
        name: "useStyleConfig",
        decl: {
          start: {
            line: 142,
            column: 16
          },
          end: {
            line: 142,
            column: 30
          }
        },
        loc: {
          start: {
            line: 148,
            column: 2
          },
          end: {
            line: 150,
            column: 1
          }
        },
        line: 148
      },
      "2": {
        name: "useMultiStyleConfig",
        decl: {
          start: {
            line: 152,
            column: 16
          },
          end: {
            line: 152,
            column: 35
          }
        },
        loc: {
          start: {
            line: 158,
            column: 2
          },
          end: {
            line: 162,
            column: 1
          }
        },
        line: 158
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 115,
            column: 22
          },
          end: {
            line: 115,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 115,
            column: 22
          },
          end: {
            line: 115,
            column: 37
          }
        }, {
          start: {
            line: 115,
            column: 41
          },
          end: {
            line: 115,
            column: 57
          }
        }],
        line: 115
      },
      "1": {
        loc: {
          start: {
            line: 119,
            column: 4
          },
          end: {
            line: 119,
            column: 35
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 119,
            column: 4
          },
          end: {
            line: 119,
            column: 29
          }
        }, {
          start: {
            line: 119,
            column: 33
          },
          end: {
            line: 119,
            column: 35
          }
        }],
        line: 119
      },
      "2": {
        loc: {
          start: {
            line: 128,
            column: 2
          },
          end: {
            line: 137,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 128,
            column: 2
          },
          end: {
            line: 137,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 128
      },
      "3": {
        loc: {
          start: {
            line: 134,
            column: 4
          },
          end: {
            line: 136,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 134,
            column: 4
          },
          end: {
            line: 136,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 134
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "7b084bf671efad07a412044702b854d34bc961a7"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_3oob4nova = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_3oob4nova();
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }






// Minimal representation of the anatomy object

/* -----------------------------------------------------------------------------
 * Style Functions used in the theme
   - Single part components: use SystemStyleObject or SystemStyleFunction
   - Multi part components: use PartsStyleObject or PartsStyleFunction
 * -----------------------------------------------------------------------------*/

/**
 * Hook which applies base styles, default props and variants to core components
 *
 * @param themeKey - `Component` type defined in the bricks theme
 * @param props - variants and base styles defined for the component factory function.
 *                Make sure to pass in ALL remaining component props to this param to
 *                ensure that baseStyles are applied
 * @param opts - optional config to determine whether to apply multipart styles or not
 */
function useStyleConfigImpl(themeKey,
// These are intentionally typed as any to allow all customizations from other
// components while maintaining arough typing structure
// eslint-disable-next-line @typescript-eslint/no-explicit-any
props) {
  var _ref2;
  cov_3oob4nova().f[0]++;
  var _ref = (cov_3oob4nova().s[0]++, props),
    styleConfigProp = _ref.styleConfig,
    rest = _objectWithoutProperties(_ref, _excluded);

  // Pulls the theme from the React context and applies the base styles
  var theme = (cov_3oob4nova().s[1]++, (0,system_theme/* useTheme */.F)());
  var themeStyleConfig = (cov_3oob4nova().s[2]++, memoizedGet(theme, "components.".concat(themeKey)));
  var styleConfig = (cov_3oob4nova().s[3]++, (cov_3oob4nova().b[0][0]++, styleConfigProp) || (cov_3oob4nova().b[0][1]++, themeStyleConfig));
  var mergedProps = (cov_3oob4nova().s[4]++, mergeWith({
    theme: theme
  }, (_ref2 = (cov_3oob4nova().b[1][0]++, styleConfig === null || styleConfig === void 0 ? void 0 : styleConfig.defaultProps)) !== null && _ref2 !== void 0 ? _ref2 : (cov_3oob4nova().b[1][1]++, {}), filterUndefined(omit(rest, ['children']))));

  /**
   * Store the computed styles in a `ref` to avoid unneeded re-computation
   */
  var stylesRef = (cov_3oob4nova().s[5]++, (0,react.useRef)({}));
  cov_3oob4nova().s[6]++;
  if (styleConfig) {
    cov_3oob4nova().b[2][0]++;
    var getStyles = (cov_3oob4nova().s[7]++, resolveStyleConfig(styleConfig));
    var styles = (cov_3oob4nova().s[8]++, getStyles(mergedProps));
    var isStyleEqual = (cov_3oob4nova().s[9]++, react_fast_compare(stylesRef.current, styles));
    cov_3oob4nova().s[10]++;
    if (!isStyleEqual) {
      cov_3oob4nova().b[3][0]++;
      cov_3oob4nova().s[11]++;
      stylesRef.current = styles;
    } else {
      cov_3oob4nova().b[3][1]++;
    }
  } else {
    cov_3oob4nova().b[2][1]++;
  }
  cov_3oob4nova().s[12]++;
  return stylesRef.current;
}
function useStyleConfig(themeKey,
// These are intentionally typed as any to allow all customizations from other
// components while maintaining arough typing structure
// eslint-disable-next-line @typescript-eslint/no-explicit-any
props) {
  cov_3oob4nova().f[1]++;
  cov_3oob4nova().s[13]++;
  return useStyleConfigImpl(themeKey, props);
}
function useMultiStyleConfig(themeKey,
// These are intentionally typed as any to allow all customizations from other
// components while maintaining arough typing structure
// eslint-disable-next-line @typescript-eslint/no-explicit-any
props) {
  cov_3oob4nova().f[2]++;
  cov_3oob4nova().s[14]++;
  return useStyleConfigImpl(themeKey, props);
}

/***/ }),

/***/ 69666:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ ThemedLite; }
/* harmony export */ });
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82772);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19601);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47941);
/* harmony import */ var lodash_mergeWith_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30236);
/* harmony import */ var lodash_cloneDeep_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50361);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(24614);
/* harmony import */ var _index_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18617);
/* harmony import */ var _complex_DatePicker_ReactDatesStyles_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(94339);
/* harmony import */ var _styles_index_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(75590);
/* harmony import */ var _ThemeOverrideExpiredBanner_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(58605);






var _excluded = ["children"];
function cov_xneq8aal3() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/ODThemeLite.tsx";
  var hash = "5073749b588bb7b7dd8d366674cd4cbba1a8b02d";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/ODThemeLite.tsx",
    statementMap: {
      "0": {
        start: {
          line: 14,
          column: 49
        },
        end: {
          line: 36,
          column: 1
        }
      },
      "1": {
        start: {
          line: 16,
          column: 24
        },
        end: {
          line: 16,
          column: 76
        }
      },
      "2": {
        start: {
          line: 17,
          column: 14
        },
        end: {
          line: 17,
          column: 48
        }
      },
      "3": {
        start: {
          line: 20,
          column: 2
        },
        end: {
          line: 23,
          column: 3
        }
      },
      "4": {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 21,
          column: 29
        }
      },
      "5": {
        start: {
          line: 22,
          column: 4
        },
        end: {
          line: 22,
          column: 38
        }
      },
      "6": {
        start: {
          line: 25,
          column: 2
        },
        end: {
          line: 35,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 14,
            column: 49
          },
          end: {
            line: 14,
            column: 50
          }
        },
        loc: {
          start: {
            line: 14,
            column: 77
          },
          end: {
            line: 36,
            column: 1
          }
        },
        line: 14
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 16,
            column: 24
          },
          end: {
            line: 16,
            column: 76
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 16,
            column: 47
          },
          end: {
            line: 16,
            column: 62
          }
        }, {
          start: {
            line: 16,
            column: 65
          },
          end: {
            line: 16,
            column: 76
          }
        }],
        line: 16
      },
      "1": {
        loc: {
          start: {
            line: 17,
            column: 24
          },
          end: {
            line: 17,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 17,
            column: 24
          },
          end: {
            line: 17,
            column: 37
          }
        }, {
          start: {
            line: 17,
            column: 41
          },
          end: {
            line: 17,
            column: 47
          }
        }],
        line: 17
      },
      "2": {
        loc: {
          start: {
            line: 20,
            column: 2
          },
          end: {
            line: 23,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 20,
            column: 2
          },
          end: {
            line: 23,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 20
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "5073749b588bb7b7dd8d366674cd4cbba1a8b02d"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_xneq8aal3 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_xneq8aal3();
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }







// Provide a theme without the heavy spritesheet (saves around 20kb gzipped)
// this "Lite" theme may include further optimizations in the future
cov_xneq8aal3().s[0]++;
var ThemedLite = function ThemedLite(_ref) {
  var _ref2;
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  cov_xneq8aal3().f[0]++;
  // Determines the base theme to apply to the component library
  var baseThemeName = (cov_xneq8aal3().s[1]++, 'baseTheme' in props ? (cov_xneq8aal3().b[0][0]++, props.baseTheme) : (cov_xneq8aal3().b[0][1]++, props.theme));
  var theme = (cov_xneq8aal3().s[2]++, _index_mjs__WEBPACK_IMPORTED_MODULE_7__/* .THEME_MAP */ .v[(_ref2 = (cov_xneq8aal3().b[1][0]++, baseThemeName)) !== null && _ref2 !== void 0 ? _ref2 : (cov_xneq8aal3().b[1][1]++, 'eero')]);

  // Applies any theme overrides to the base theme
  cov_xneq8aal3().s[3]++;
  if ('baseTheme' in props) {
    cov_xneq8aal3().b[2][0]++;
    cov_xneq8aal3().s[4]++;
    theme = lodash_cloneDeep_js__WEBPACK_IMPORTED_MODULE_5__(theme);
    cov_xneq8aal3().s[5]++;
    lodash_mergeWith_js__WEBPACK_IMPORTED_MODULE_4__(theme, props.overrides);
  } else {
    cov_xneq8aal3().b[2][1]++;
  }
  cov_xneq8aal3().s[6]++;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_8__/* .ThemeProvider */ .f6, _extends({}, props, {
    theme: theme
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(_styles_index_mjs__WEBPACK_IMPORTED_MODULE_9__/* .Reset */ .A, null), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(_complex_DatePicker_ReactDatesStyles_mjs__WEBPACK_IMPORTED_MODULE_10__/* .ReactDatesStyles */ .i, null), children, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(_ThemeOverrideExpiredBanner_mjs__WEBPACK_IMPORTED_MODULE_11__/* .ThemeOverrideExpiredBanner */ .C, {
    baseTheme: baseThemeName,
    launchDateString: props['launchDateString']
  }));
};

/***/ }),

/***/ 58605:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "C": function() { return /* binding */ ThemeOverrideExpiredBanner; }
});

// UNUSED EXPORTS: LAST_SEEN_THEME_OVERRIDE_EXPIRATION_BANNER_KEY

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(82526);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(41817);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__(32165);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__(91038);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(66992);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__(47042);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(68309);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(74916);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.test.js
var es_regexp_test = __webpack_require__(77601);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(78783);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(41539);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(33948);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__(39714);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.starts-with.js
var es_string_starts_with = __webpack_require__(23157);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.async-iterator.js
var es_symbol_async_iterator = __webpack_require__(72443);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.to-string-tag.js
var es_symbol_to_string_tag = __webpack_require__(39341);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__(89554);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__(82772);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.reverse.js
var es_array_reverse = __webpack_require__(65069);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.json.to-string-tag.js
var es_json_to_string_tag = __webpack_require__(73706);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.math.to-string-tag.js
var es_math_to_string_tag = __webpack_require__(10408);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.define-property.js
var es_object_define_property = __webpack_require__(69070);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-prototype-of.js
var es_object_get_prototype_of = __webpack_require__(30489);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__(47941);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.set-prototype-of.js
var es_object_set_prototype_of = __webpack_require__(68304);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__(54747);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(92222);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__(88674);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.timers.js
var web_timers = __webpack_require__(32564);
// EXTERNAL MODULE: ./node_modules/react-modal/lib/index.js
var lib = __webpack_require__(83253);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Box/Box.mjs
var Box_Box = __webpack_require__(8013);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/hooks/useMedia.mjs + 1 modules
var useMedia = __webpack_require__(61151);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/system/theme/index.mjs
var theme = __webpack_require__(79141);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/theme/novo/foundations/colors.mjs
var foundations_colors = __webpack_require__(62762);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/theme/ODThemeLite.mjs
var ODThemeLite = __webpack_require__(69666);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__(19601);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Flex/Flex.mjs
var Flex = __webpack_require__(93298);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Text/Text.mjs
var Text = __webpack_require__(4796);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/complex/Modal/NavigationBar.mjs
function cov_2h0ts38pj6() {
  var path = "/__w/code/code/js/packages/bricks/src/complex/Modal/NavigationBar.tsx";
  var hash = "35e742a1bec36b34261da54206e37e835740d037";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/complex/Modal/NavigationBar.tsx",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 55
        },
        end: {
          line: 24,
          column: 1
        }
      },
      "1": {
        start: {
          line: 11,
          column: 19
        },
        end: {
          line: 11,
          column: 51
        }
      },
      "2": {
        start: {
          line: 13,
          column: 2
        },
        end: {
          line: 23,
          column: 4
        }
      },
      "3": {
        start: {
          line: 36,
          column: 39
        },
        end: {
          line: 38,
          column: 1
        }
      },
      "4": {
        start: {
          line: 37,
          column: 2
        },
        end: {
          line: 37,
          column: 49
        }
      },
      "5": {
        start: {
          line: 40,
          column: 59
        },
        end: {
          line: 122,
          column: 1
        }
      },
      "6": {
        start: {
          line: 49,
          column: 19
        },
        end: {
          line: 49,
          column: 40
        }
      },
      "7": {
        start: {
          line: 50,
          column: 2
        },
        end: {
          line: 121,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 10,
            column: 55
          },
          end: {
            line: 10,
            column: 56
          }
        },
        loc: {
          start: {
            line: 10,
            column: 88
          },
          end: {
            line: 24,
            column: 1
          }
        },
        line: 10
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 36,
            column: 39
          },
          end: {
            line: 36,
            column: 40
          }
        },
        loc: {
          start: {
            line: 36,
            column: 82
          },
          end: {
            line: 38,
            column: 1
          }
        },
        line: 36
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 40,
            column: 59
          },
          end: {
            line: 40,
            column: 60
          }
        },
        loc: {
          start: {
            line: 48,
            column: 6
          },
          end: {
            line: 122,
            column: 1
          }
        },
        line: 48
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 17,
            column: 27
          },
          end: {
            line: 17,
            column: 64
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 17,
            column: 46
          },
          end: {
            line: 17,
            column: 52
          }
        }, {
          start: {
            line: 17,
            column: 55
          },
          end: {
            line: 17,
            column: 64
          }
        }],
        line: 17
      },
      "1": {
        loc: {
          start: {
            line: 37,
            column: 12
          },
          end: {
            line: 37,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 37,
            column: 12
          },
          end: {
            line: 37,
            column: 20
          }
        }, {
          start: {
            line: 37,
            column: 24
          },
          end: {
            line: 37,
            column: 40
          }
        }],
        line: 37
      },
      "2": {
        loc: {
          start: {
            line: 49,
            column: 22
          },
          end: {
            line: 49,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 49,
            column: 22
          },
          end: {
            line: 49,
            column: 27
          }
        }, {
          start: {
            line: 49,
            column: 31
          },
          end: {
            line: 49,
            column: 39
          }
        }],
        line: 49
      },
      "3": {
        loc: {
          start: {
            line: 63,
            column: 19
          },
          end: {
            line: 63,
            column: 44
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 63,
            column: 30
          },
          end: {
            line: 63,
            column: 35
          }
        }, {
          start: {
            line: 63,
            column: 38
          },
          end: {
            line: 63,
            column: 44
          }
        }],
        line: 63
      },
      "4": {
        loc: {
          start: {
            line: 67,
            column: 18
          },
          end: {
            line: 67,
            column: 39
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 67,
            column: 29
          },
          end: {
            line: 67,
            column: 35
          }
        }, {
          start: {
            line: 67,
            column: 38
          },
          end: {
            line: 67,
            column: 39
          }
        }],
        line: 67
      },
      "5": {
        loc: {
          start: {
            line: 71,
            column: 7
          },
          end: {
            line: 108,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 71,
            column: 8
          },
          end: {
            line: 71,
            column: 13
          }
        }, {
          start: {
            line: 71,
            column: 17
          },
          end: {
            line: 71,
            column: 25
          }
        }, {
          start: {
            line: 72,
            column: 8
          },
          end: {
            line: 107,
            column: 15
          }
        }],
        line: 71
      },
      "6": {
        loc: {
          start: {
            line: 82,
            column: 22
          },
          end: {
            line: 82,
            column: 44
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 82,
            column: 33
          },
          end: {
            line: 82,
            column: 37
          }
        }, {
          start: {
            line: 82,
            column: 40
          },
          end: {
            line: 82,
            column: 44
          }
        }],
        line: 82
      },
      "7": {
        loc: {
          start: {
            line: 83,
            column: 24
          },
          end: {
            line: 83,
            column: 54
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 83,
            column: 35
          },
          end: {
            line: 83,
            column: 45
          }
        }, {
          start: {
            line: 83,
            column: 48
          },
          end: {
            line: 83,
            column: 54
          }
        }],
        line: 83
      },
      "8": {
        loc: {
          start: {
            line: 93,
            column: 11
          },
          end: {
            line: 106,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 93,
            column: 11
          },
          end: {
            line: 93,
            column: 19
          }
        }, {
          start: {
            line: 94,
            column: 12
          },
          end: {
            line: 105,
            column: 19
          }
        }],
        line: 93
      },
      "9": {
        loc: {
          start: {
            line: 112,
            column: 19
          },
          end: {
            line: 112,
            column: 44
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 112,
            column: 30
          },
          end: {
            line: 112,
            column: 35
          }
        }, {
          start: {
            line: 112,
            column: 38
          },
          end: {
            line: 112,
            column: 44
          }
        }],
        line: 112
      },
      "10": {
        loc: {
          start: {
            line: 116,
            column: 18
          },
          end: {
            line: 116,
            column: 39
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 116,
            column: 29
          },
          end: {
            line: 116,
            column: 35
          }
        }, {
          start: {
            line: 116,
            column: 38
          },
          end: {
            line: 116,
            column: 39
          }
        }],
        line: 116
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "35e742a1bec36b34261da54206e37e835740d037"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2h0ts38pj6 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2h0ts38pj6();

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }


cov_2h0ts38pj6().s[0]++;
var ProgressBar = function ProgressBar(_ref) {
  var currentStep = _ref.currentStep,
    totalSteps = _ref.totalSteps;
  cov_2h0ts38pj6().f[0]++;
  var progress = (cov_2h0ts38pj6().s[1]++, currentStep / totalSteps * 100);
  cov_2h0ts38pj6().s[2]++;
  return /*#__PURE__*/React.createElement(Box, {
    backgroundColor: "neutrals30",
    height: "4px",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Box, {
    backgroundColor: "brand50",
    borderRightRadius: progress === 100 ? (cov_2h0ts38pj6().b[0][0]++, 'none') : (cov_2h0ts38pj6().b[0][1]++, 'rounded'),
    height: "100%",
    transition: "width 1s ease-out",
    width: "".concat(progress, "%")
  }));
};
cov_2h0ts38pj6().s[3]++;
var getNavigationBarTitleId = function getNavigationBarTitleId(props) {
  cov_2h0ts38pj6().f[1]++;
  cov_2h0ts38pj6().s[4]++;
  return "".concat((cov_2h0ts38pj6().b[1][0]++, props.id) || (cov_2h0ts38pj6().b[1][1]++, 'navigation-bar'), "-title");
};
cov_2h0ts38pj6().s[5]++;
var NavigationBar = function NavigationBar(_ref2) {
  var id = _ref2.id,
    title = _ref2.title,
    titleProps = _ref2.titleProps,
    subtitle = _ref2.subtitle,
    subtitleProps = _ref2.subtitleProps,
    leftComponent = _ref2.leftComponent,
    rightComponent = _ref2.rightComponent;
  cov_2h0ts38pj6().f[2]++;
  var hasTitle = (cov_2h0ts38pj6().s[6]++, !!((cov_2h0ts38pj6().b[2][0]++, title) || (cov_2h0ts38pj6().b[2][1]++, subtitle)));
  cov_2h0ts38pj6().s[7]++;
  return /*#__PURE__*/react.createElement(Flex/* default */.Z, {
    bgColor: "neutrals0",
    px: [4, 7],
    py: [4, 6],
    flex: "1 1 auto",
    alignItems: "center",
    justifyContent: "space-between",
    id: id
  }, /*#__PURE__*/react.createElement(Flex/* default */.Z, {
    id: "".concat(id, "-navigation-bar-left-component"),
    justifySelf: "flex-start",
    flexBasis: hasTitle ? (cov_2h0ts38pj6().b[3][0]++, '50%') : (cov_2h0ts38pj6().b[3][1]++, 'auto'),
    justifyContent: "flex-start",
    alignItems: "center",
    flexShrink: 2,
    minWidth: hasTitle ? (cov_2h0ts38pj6().b[4][0]++, 'auto') : (cov_2h0ts38pj6().b[4][1]++, 0)
  }, leftComponent), ((cov_2h0ts38pj6().b[5][0]++, title) || (cov_2h0ts38pj6().b[5][1]++, subtitle)) && (cov_2h0ts38pj6().b[5][2]++, /*#__PURE__*/react.createElement(Flex/* default */.Z, {
    flexDirection: "column",
    flexBasis: "100%",
    textAlign: "center",
    mx: "4",
    flexShrink: 1,
    minWidth: 0
  }, /*#__PURE__*/react.createElement(Text/* default */.Z, _extends({
    lineHeight: "120",
    fontSize: subtitle ? (cov_2h0ts38pj6().b[6][0]++, 's1') : (cov_2h0ts38pj6().b[6][1]++, 's2'),
    fontWeight: subtitle ? (cov_2h0ts38pj6().b[7][0]++, 'semibold') : (cov_2h0ts38pj6().b[7][1]++, 'bold'),
    whiteSpace: "nowrap",
    as: "h1",
    id: getNavigationBarTitleId({
      id: id
    }),
    textOverflow: "ellipsis",
    overflow: "hidden"
  }, titleProps), title), (cov_2h0ts38pj6().b[8][0]++, subtitle) && (cov_2h0ts38pj6().b[8][1]++, /*#__PURE__*/react.createElement(Text/* default */.Z, _extends({
    pt: 2,
    fontWeight: "regular",
    fontSize: "s00",
    lineHeight: "100",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden"
  }, subtitleProps), subtitle)))), /*#__PURE__*/react.createElement(Flex/* default */.Z, {
    id: "".concat(id, "-navigation-bar-right-component"),
    justifySelf: "flex-end",
    flexBasis: hasTitle ? (cov_2h0ts38pj6().b[9][0]++, '50%') : (cov_2h0ts38pj6().b[9][1]++, 'auto'),
    justifyContent: "flex-end",
    alignItems: "center",
    flexShrink: 2,
    minWidth: hasTitle ? (cov_2h0ts38pj6().b[10][0]++, 'auto') : (cov_2h0ts38pj6().b[10][1]++, 0)
  }, rightComponent));
};
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.parse-int.js
var es_parse_int = __webpack_require__(91058);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Button/Button.mjs
var Button_Button = __webpack_require__(26029);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/Icon.mjs + 1 modules
var Icon = __webpack_require__(49154);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/system/bricks.types.mjs
var bricks_types = __webpack_require__(26153);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/core/Divider/Divider.mjs
function cov_9kl717b21() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Divider/Divider.tsx";
  var hash = "11e9a4e5a13751065b81200f03e5dcaf1c931e98";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Divider/Divider.tsx",
    statementMap: {
      "0": {
        start: {
          line: 11,
          column: 49
        },
        end: {
          line: 22,
          column: 1
        }
      },
      "1": {
        start: {
          line: 12,
          column: 21
        },
        end: {
          line: 12,
          column: 31
        }
      },
      "2": {
        start: {
          line: 13,
          column: 2
        },
        end: {
          line: 21,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 11,
            column: 49
          },
          end: {
            line: 11,
            column: 50
          }
        },
        loc: {
          start: {
            line: 11,
            column: 60
          },
          end: {
            line: 22,
            column: 1
          }
        },
        line: 11
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {
      "0": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "11e9a4e5a13751065b81200f03e5dcaf1c931e98"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_9kl717b21 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_9kl717b21();

function Divider_extends() { Divider_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Divider_extends.apply(this, arguments); }




/**
 * Dividers separate content into clear groups.
 *
 * Dividers can have an arbitrary width, which defaults to "100%" (full-bleed).
 */
cov_9kl717b21().s[0]++;
var Divider = function Divider(props) {
  cov_9kl717b21().f[0]++;
  var _ref = (cov_9kl717b21().s[1]++, (0,theme/* useTheme */.F)()),
    colors = _ref.colors;
  cov_9kl717b21().s[2]++;
  return /*#__PURE__*/react.createElement(bricks_types/* bricks.hr */.G.hr, Divider_extends({
    m: "0",
    border: "none",
    borderTop: "1px solid ".concat(colors.neutrals30),
    width: "100%"
  }, props));
};
/* harmony default export */ var Divider_Divider = (Divider);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/complex/Modal/shared.mjs
function cov_ehh839z3q() {
  var path = "/__w/code/code/js/packages/bricks/src/complex/Modal/shared.tsx";
  var hash = "735a3ad8fee23bb939ae142125b212de90a2eb39";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/complex/Modal/shared.tsx",
    statementMap: {
      "0": {
        start: {
          line: 33,
          column: 37
        },
        end: {
          line: 79,
          column: 1
        }
      },
      "1": {
        start: {
          line: 34,
          column: 23
        },
        end: {
          line: 34,
          column: 34
        }
      },
      "2": {
        start: {
          line: 35,
          column: 66
        },
        end: {
          line: 35,
          column: 81
        }
      },
      "3": {
        start: {
          line: 41,
          column: 27
        },
        end: {
          line: 52,
          column: 16
        }
      },
      "4": {
        start: {
          line: 42,
          column: 4
        },
        end: {
          line: 51,
          column: 5
        }
      },
      "5": {
        start: {
          line: 43,
          column: 22
        },
        end: {
          line: 43,
          column: 45
        }
      },
      "6": {
        start: {
          line: 44,
          column: 6
        },
        end: {
          line: 44,
          column: 40
        }
      },
      "7": {
        start: {
          line: 45,
          column: 6
        },
        end: {
          line: 45,
          column: 35
        }
      },
      "8": {
        start: {
          line: 46,
          column: 6
        },
        end: {
          line: 46,
          column: 56
        }
      },
      "9": {
        start: {
          line: 47,
          column: 6
        },
        end: {
          line: 47,
          column: 41
        }
      },
      "10": {
        start: {
          line: 49,
          column: 6
        },
        end: {
          line: 49,
          column: 40
        }
      },
      "11": {
        start: {
          line: 50,
          column: 6
        },
        end: {
          line: 50,
          column: 41
        }
      },
      "12": {
        start: {
          line: 53,
          column: 2
        },
        end: {
          line: 78,
          column: 69
        }
      },
      "13": {
        start: {
          line: 56,
          column: 4
        },
        end: {
          line: 60,
          column: 5
        }
      },
      "14": {
        start: {
          line: 59,
          column: 6
        },
        end: {
          line: 59,
          column: 13
        }
      },
      "15": {
        start: {
          line: 62,
          column: 4
        },
        end: {
          line: 74,
          column: 5
        }
      },
      "16": {
        start: {
          line: 63,
          column: 6
        },
        end: {
          line: 71,
          column: 7
        }
      },
      "17": {
        start: {
          line: 64,
          column: 20
        },
        end: {
          line: 64,
          column: 34
        }
      },
      "18": {
        start: {
          line: 65,
          column: 8
        },
        end: {
          line: 65,
          column: 47
        }
      },
      "19": {
        start: {
          line: 66,
          column: 8
        },
        end: {
          line: 66,
          column: 46
        }
      },
      "20": {
        start: {
          line: 67,
          column: 8
        },
        end: {
          line: 67,
          column: 42
        }
      },
      "21": {
        start: {
          line: 69,
          column: 8
        },
        end: {
          line: 69,
          column: 48
        }
      },
      "22": {
        start: {
          line: 70,
          column: 8
        },
        end: {
          line: 70,
          column: 42
        }
      },
      "23": {
        start: {
          line: 73,
          column: 6
        },
        end: {
          line: 73,
          column: 25
        }
      },
      "24": {
        start: {
          line: 77,
          column: 4
        },
        end: {
          line: 77,
          column: 28
        }
      },
      "25": {
        start: {
          line: 121,
          column: 55
        },
        end: {
          line: 177,
          column: 1
        }
      },
      "26": {
        start: {
          line: 133,
          column: 2
        },
        end: {
          line: 176,
          column: 5
        }
      },
      "27": {
        start: {
          line: 179,
          column: 55
        },
        end: {
          line: 225,
          column: 1
        }
      },
      "28": {
        start: {
          line: 185,
          column: 2
        },
        end: {
          line: 224,
          column: 8
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 33,
            column: 37
          },
          end: {
            line: 33,
            column: 38
          }
        },
        loc: {
          start: {
            line: 33,
            column: 58
          },
          end: {
            line: 79,
            column: 1
          }
        },
        line: 33
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 41,
            column: 39
          },
          end: {
            line: 41,
            column: 40
          }
        },
        loc: {
          start: {
            line: 41,
            column: 45
          },
          end: {
            line: 52,
            column: 3
          }
        },
        line: 41
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 53,
            column: 12
          },
          end: {
            line: 53,
            column: 13
          }
        },
        loc: {
          start: {
            line: 53,
            column: 18
          },
          end: {
            line: 78,
            column: 3
          }
        },
        line: 53
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 121,
            column: 55
          },
          end: {
            line: 121,
            column: 56
          }
        },
        loc: {
          start: {
            line: 133,
            column: 2
          },
          end: {
            line: 176,
            column: 5
          }
        },
        line: 133
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 179,
            column: 55
          },
          end: {
            line: 179,
            column: 56
          }
        },
        loc: {
          start: {
            line: 185,
            column: 2
          },
          end: {
            line: 224,
            column: 8
          }
        },
        line: 185
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 42,
            column: 4
          },
          end: {
            line: 51,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 42,
            column: 4
          },
          end: {
            line: 51,
            column: 5
          }
        }, {
          start: {
            line: 48,
            column: 11
          },
          end: {
            line: 51,
            column: 5
          }
        }],
        line: 42
      },
      "1": {
        loc: {
          start: {
            line: 46,
            column: 34
          },
          end: {
            line: 46,
            column: 48
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 46,
            column: 34
          },
          end: {
            line: 46,
            column: 41
          }
        }, {
          start: {
            line: 46,
            column: 45
          },
          end: {
            line: 46,
            column: 48
          }
        }],
        line: 46
      },
      "2": {
        loc: {
          start: {
            line: 56,
            column: 4
          },
          end: {
            line: 60,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 56,
            column: 4
          },
          end: {
            line: 60,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 56
      },
      "3": {
        loc: {
          start: {
            line: 56,
            column: 8
          },
          end: {
            line: 56,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 56,
            column: 8
          },
          end: {
            line: 56,
            column: 15
          }
        }, {
          start: {
            line: 56,
            column: 19
          },
          end: {
            line: 56,
            column: 44
          }
        }],
        line: 56
      },
      "4": {
        loc: {
          start: {
            line: 62,
            column: 4
          },
          end: {
            line: 74,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 62,
            column: 4
          },
          end: {
            line: 74,
            column: 5
          }
        }, {
          start: {
            line: 72,
            column: 11
          },
          end: {
            line: 74,
            column: 5
          }
        }],
        line: 62
      },
      "5": {
        loc: {
          start: {
            line: 63,
            column: 6
          },
          end: {
            line: 71,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 63,
            column: 6
          },
          end: {
            line: 71,
            column: 7
          }
        }, {
          start: {
            line: 68,
            column: 13
          },
          end: {
            line: 71,
            column: 7
          }
        }],
        line: 63
      },
      "6": {
        loc: {
          start: {
            line: 130,
            column: 2
          },
          end: {
            line: 130,
            column: 20
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 130,
            column: 16
          },
          end: {
            line: 130,
            column: 20
          }
        }],
        line: 130
      },
      "7": {
        loc: {
          start: {
            line: 131,
            column: 2
          },
          end: {
            line: 131,
            column: 34
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 131,
            column: 28
          },
          end: {
            line: 131,
            column: 34
          }
        }],
        line: 131
      },
      "8": {
        loc: {
          start: {
            line: 135,
            column: 21
          },
          end: {
            line: 135,
            column: 67
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 135,
            column: 42
          },
          end: {
            line: 135,
            column: 55
          }
        }, {
          start: {
            line: 135,
            column: 58
          },
          end: {
            line: 135,
            column: 67
          }
        }],
        line: 135
      },
      "9": {
        loc: {
          start: {
            line: 137,
            column: 23
          },
          end: {
            line: 137,
            column: 57
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 137,
            column: 44
          },
          end: {
            line: 137,
            column: 45
          }
        }, {
          start: {
            line: 137,
            column: 48
          },
          end: {
            line: 137,
            column: 57
          }
        }],
        line: 137
      },
      "10": {
        loc: {
          start: {
            line: 142,
            column: 10
          },
          end: {
            line: 153,
            column: 11
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 142,
            column: 25
          },
          end: {
            line: 142,
            column: 29
          }
        }, {
          start: {
            line: 143,
            column: 12
          },
          end: {
            line: 152,
            column: 21
          }
        }],
        line: 142
      },
      "11": {
        loc: {
          start: {
            line: 156,
            column: 10
          },
          end: {
            line: 168,
            column: 11
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 156,
            column: 28
          },
          end: {
            line: 156,
            column: 32
          }
        }, {
          start: {
            line: 157,
            column: 12
          },
          end: {
            line: 167,
            column: 21
          }
        }],
        line: 156
      },
      "12": {
        loc: {
          start: {
            line: 175,
            column: 5
          },
          end: {
            line: 175,
            column: 31
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 175,
            column: 5
          },
          end: {
            line: 175,
            column: 16
          }
        }, {
          start: {
            line: 175,
            column: 20
          },
          end: {
            line: 175,
            column: 31
          }
        }],
        line: 175
      },
      "13": {
        loc: {
          start: {
            line: 189,
            column: 19
          },
          end: {
            line: 189,
            column: 47
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 189,
            column: 31
          },
          end: {
            line: 189,
            column: 39
          }
        }, {
          start: {
            line: 189,
            column: 42
          },
          end: {
            line: 189,
            column: 47
          }
        }],
        line: 189
      },
      "14": {
        loc: {
          start: {
            line: 190,
            column: 20
          },
          end: {
            line: 190,
            column: 59
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 190,
            column: 32
          },
          end: {
            line: 190,
            column: 41
          }
        }, {
          start: {
            line: 190,
            column: 44
          },
          end: {
            line: 190,
            column: 59
          }
        }],
        line: 190
      },
      "15": {
        loc: {
          start: {
            line: 192,
            column: 5
          },
          end: {
            line: 208,
            column: 5
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 192,
            column: 5
          },
          end: {
            line: 192,
            column: 23
          }
        }, {
          start: {
            line: 193,
            column: 6
          },
          end: {
            line: 207,
            column: 8
          }
        }],
        line: 192
      },
      "16": {
        loc: {
          start: {
            line: 195,
            column: 15
          },
          end: {
            line: 195,
            column: 32
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 195,
            column: 27
          },
          end: {
            line: 195,
            column: 28
          }
        }, {
          start: {
            line: 195,
            column: 31
          },
          end: {
            line: 195,
            column: 32
          }
        }],
        line: 195
      },
      "17": {
        loc: {
          start: {
            line: 197,
            column: 15
          },
          end: {
            line: 197,
            column: 67
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 197,
            column: 52
          },
          end: {
            line: 197,
            column: 58
          }
        }, {
          start: {
            line: 197,
            column: 61
          },
          end: {
            line: 197,
            column: 67
          }
        }],
        line: 197
      },
      "18": {
        loc: {
          start: {
            line: 197,
            column: 15
          },
          end: {
            line: 197,
            column: 49
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 197,
            column: 15
          },
          end: {
            line: 197,
            column: 24
          }
        }, {
          start: {
            line: 197,
            column: 28
          },
          end: {
            line: 197,
            column: 49
          }
        }],
        line: 197
      },
      "19": {
        loc: {
          start: {
            line: 198,
            column: 12
          },
          end: {
            line: 198,
            column: 65
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 198,
            column: 50
          },
          end: {
            line: 198,
            column: 53
          }
        }, {
          start: {
            line: 198,
            column: 56
          },
          end: {
            line: 198,
            column: 65
          }
        }],
        line: 198
      },
      "20": {
        loc: {
          start: {
            line: 198,
            column: 12
          },
          end: {
            line: 198,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 198,
            column: 12
          },
          end: {
            line: 198,
            column: 21
          }
        }, {
          start: {
            line: 198,
            column: 25
          },
          end: {
            line: 198,
            column: 47
          }
        }],
        line: 198
      },
      "21": {
        loc: {
          start: {
            line: 199,
            column: 20
          },
          end: {
            line: 199,
            column: 74
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 199,
            column: 59
          },
          end: {
            line: 199,
            column: 62
          }
        }, {
          start: {
            line: 199,
            column: 65
          },
          end: {
            line: 199,
            column: 74
          }
        }],
        line: 199
      },
      "22": {
        loc: {
          start: {
            line: 199,
            column: 20
          },
          end: {
            line: 199,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 199,
            column: 20
          },
          end: {
            line: 199,
            column: 30
          }
        }, {
          start: {
            line: 199,
            column: 34
          },
          end: {
            line: 199,
            column: 56
          }
        }],
        line: 199
      },
      "23": {
        loc: {
          start: {
            line: 209,
            column: 5
          },
          end: {
            line: 223,
            column: 5
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 209,
            column: 5
          },
          end: {
            line: 209,
            column: 25
          }
        }, {
          start: {
            line: 210,
            column: 6
          },
          end: {
            line: 222,
            column: 8
          }
        }],
        line: 209
      },
      "24": {
        loc: {
          start: {
            line: 211,
            column: 17
          },
          end: {
            line: 211,
            column: 90
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 211,
            column: 53
          },
          end: {
            line: 211,
            column: 64
          }
        }, {
          start: {
            line: 211,
            column: 67
          },
          end: {
            line: 211,
            column: 90
          }
        }],
        line: 211
      },
      "25": {
        loc: {
          start: {
            line: 211,
            column: 17
          },
          end: {
            line: 211,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 211,
            column: 17
          },
          end: {
            line: 211,
            column: 26
          }
        }, {
          start: {
            line: 211,
            column: 30
          },
          end: {
            line: 211,
            column: 50
          }
        }],
        line: 211
      },
      "26": {
        loc: {
          start: {
            line: 212,
            column: 15
          },
          end: {
            line: 212,
            column: 65
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 212,
            column: 50
          },
          end: {
            line: 212,
            column: 56
          }
        }, {
          start: {
            line: 212,
            column: 59
          },
          end: {
            line: 212,
            column: 65
          }
        }],
        line: 212
      },
      "27": {
        loc: {
          start: {
            line: 212,
            column: 15
          },
          end: {
            line: 212,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 212,
            column: 15
          },
          end: {
            line: 212,
            column: 24
          }
        }, {
          start: {
            line: 212,
            column: 28
          },
          end: {
            line: 212,
            column: 47
          }
        }],
        line: 212
      },
      "28": {
        loc: {
          start: {
            line: 213,
            column: 20
          },
          end: {
            line: 213,
            column: 78
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 213,
            column: 56
          },
          end: {
            line: 213,
            column: 66
          }
        }, {
          start: {
            line: 213,
            column: 69
          },
          end: {
            line: 213,
            column: 78
          }
        }],
        line: 213
      },
      "29": {
        loc: {
          start: {
            line: 213,
            column: 20
          },
          end: {
            line: 213,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 213,
            column: 20
          },
          end: {
            line: 213,
            column: 30
          }
        }, {
          start: {
            line: 213,
            column: 34
          },
          end: {
            line: 213,
            column: 53
          }
        }],
        line: 213
      },
      "30": {
        loc: {
          start: {
            line: 214,
            column: 19
          },
          end: {
            line: 214,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 214,
            column: 41
          },
          end: {
            line: 214,
            column: 49
          }
        }, {
          start: {
            line: 214,
            column: 52
          },
          end: {
            line: 214,
            column: 61
          }
        }],
        line: 214
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0],
      "7": [0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "735a3ad8fee23bb939ae142125b212de90a2eb39"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_ehh839z3q = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}









cov_ehh839z3q();





function shared_extends() { shared_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return shared_extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }





/**
 * To meet accessibility standards, modal components must receive either title, aria-labelledby, or aria-label.
 */
/**
 * Helper hook to remove scrolling to the parent element when modal is opened.
 */
cov_ehh839z3q().s[0]++;
var useDisabledBodyScroll = function useDisabledBodyScroll(isOpen) {
  cov_ehh839z3q().f[0]++;
  var _ref = (cov_ehh839z3q().s[1]++, (0,useMedia/* useDevice */.F)()),
    isMobile = _ref.isMobile;
  var _ref2 = (cov_ehh839z3q().s[2]++, (0,react.useState)(false)),
    _ref3 = _slicedToArray(_ref2, 2),
    isScrollingBodyPrevented = _ref3[0],
    setIsScrollingBodyPrevented = _ref3[1];
  /*
      Scrolling needs to be blocked on elements behind the modal for a better accessable design.
      The useEffect below blocks scrolling when modal is opened.
      https://chakra-ui.com/docs/overlay/modal#keyboard-and-focus-management
  */
  var handleModalClose = (cov_ehh839z3q().s[3]++, (0,react.useCallback)(function () {
    cov_ehh839z3q().f[1]++;
    cov_ehh839z3q().s[4]++;
    if (isMobile) {
      cov_ehh839z3q().b[0][0]++;
      var scrollY = (cov_ehh839z3q().s[5]++, document.body.style.top);
      cov_ehh839z3q().s[6]++;
      document.body.style.position = '';
      cov_ehh839z3q().s[7]++;
      document.body.style.top = '';
      cov_ehh839z3q().s[8]++;
      window.scrollTo(0, parseInt((cov_ehh839z3q().b[1][0]++, scrollY) || (cov_ehh839z3q().b[1][1]++, '0')) * -1);
      cov_ehh839z3q().s[9]++;
      setIsScrollingBodyPrevented(false);
    } else {
      cov_ehh839z3q().b[0][1]++;
      cov_ehh839z3q().s[10]++;
      document.body.style.overflow = '';
      cov_ehh839z3q().s[11]++;
      setIsScrollingBodyPrevented(false);
    }
  }, [isMobile]));
  cov_ehh839z3q().s[12]++;
  (0,react.useEffect)(function () {
    cov_ehh839z3q().f[2]++;
    cov_ehh839z3q().s[13]++;
    // Need specific styling for iOS body touchscreen
    // https://css-tricks.com/prevent-page-scrolling-when-a-modal-is-open/
    if ((cov_ehh839z3q().b[3][0]++, !isOpen) && (cov_ehh839z3q().b[3][1]++, !isScrollingBodyPrevented)) {
      cov_ehh839z3q().b[2][0]++;
      cov_ehh839z3q().s[14]++;
      // does not run rest of code in the useEffect since modal has not been opened & is not in the process of being opened
      // this is needed for pages that have multiple modals on the page
      return;
    } else {
      cov_ehh839z3q().b[2][1]++;
    }
    cov_ehh839z3q().s[15]++;
    if (isOpen) {
      cov_ehh839z3q().b[4][0]++;
      cov_ehh839z3q().s[16]++;
      if (isMobile) {
        cov_ehh839z3q().b[5][0]++;
        var top = (cov_ehh839z3q().s[17]++, window.scrollY);
        cov_ehh839z3q().s[18]++;
        document.body.style.position = 'fixed';
        cov_ehh839z3q().s[19]++;
        document.body.style.top = "-".concat(top, "px");
        cov_ehh839z3q().s[20]++;
        setIsScrollingBodyPrevented(true);
      } else {
        cov_ehh839z3q().b[5][1]++;
        cov_ehh839z3q().s[21]++;
        document.body.style.overflow = 'hidden';
        cov_ehh839z3q().s[22]++;
        setIsScrollingBodyPrevented(true);
      }
    } else {
      cov_ehh839z3q().b[4][1]++;
      cov_ehh839z3q().s[23]++;
      handleModalClose();
    }

    // Ensure that we re-enable scrolling if the component is unmounted
    cov_ehh839z3q().s[24]++;
    return handleModalClose;
  }, [isMobile, isOpen, isScrollingBodyPrevented, handleModalClose]);
};
cov_ehh839z3q().s[25]++;
var ModalHeader = function ModalHeader(_ref4) {
  var trackBoxImpression = _ref4.trackBoxImpression,
    trackButtonImpressions = _ref4.trackButtonImpressions,
    analyticsName = _ref4.analyticsName,
    onBackClick = _ref4.onBackClick,
    onRequestClose = _ref4.onRequestClose,
    title = _ref4.title,
    subtitle = _ref4.subtitle,
    id = _ref4.id,
    _ref4$showDivider = _ref4.showDivider,
    showDivider = _ref4$showDivider === void 0 ? (cov_ehh839z3q().b[6][0]++, true) : _ref4$showDivider,
    _ref4$headerIconButto = _ref4.headerIconButtonVariant,
    headerIconButtonVariant = _ref4$headerIconButto === void 0 ? (cov_ehh839z3q().b[7][0]++, 'icon') : _ref4$headerIconButto;
  cov_ehh839z3q().f[3]++;
  cov_ehh839z3q().s[26]++;
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(Box_Box/* default */.Z, {
    analyticsName: trackBoxImpression ? (cov_ehh839z3q().b[8][0]++, analyticsName) : (cov_ehh839z3q().b[8][1]++, undefined),
    trackImpression: trackBoxImpression,
    inViewThreshold: trackBoxImpression ? (cov_ehh839z3q().b[9][0]++, 0) : (cov_ehh839z3q().b[9][1]++, undefined),
    flexGrow: 0
  }, /*#__PURE__*/react.createElement(NavigationBar, {
    leftComponent: !onBackClick ? (cov_ehh839z3q().b[10][0]++, null) : (cov_ehh839z3q().b[10][1]++, /*#__PURE__*/react.createElement(Button_Button/* default */.ZP, {
      id: "modal-back-button",
      onClick: onBackClick,
      variant: headerIconButtonVariant,
      analyticsName: "".concat(analyticsName, "-back"),
      trackImpression: trackButtonImpressions,
      "aria-label": "Back"
    }, /*#__PURE__*/react.createElement(Icon/* default */.Z, {
      name: "chevron-left",
      size: 16,
      "aria-hidden": "true"
    }))),
    rightComponent: !onRequestClose ? (cov_ehh839z3q().b[11][0]++, null) : (cov_ehh839z3q().b[11][1]++, /*#__PURE__*/react.createElement(Button_Button/* default */.ZP, {
      id: "modal-close-button",
      onClick: onRequestClose,
      variant: headerIconButtonVariant,
      analyticsName: "".concat(analyticsName, "-close"),
      trackImpression: trackButtonImpressions,
      "aria-label": "Close",
      zIndex: 1
    }, /*#__PURE__*/react.createElement(Icon/* default */.Z, {
      name: "close",
      size: 16,
      "aria-hidden": "true"
    }))),
    title: title,
    subtitle: subtitle,
    id: id
  })), (cov_ehh839z3q().b[12][0]++, showDivider) && (cov_ehh839z3q().b[12][1]++, /*#__PURE__*/react.createElement(Divider_Divider, null)));
};
cov_ehh839z3q().s[27]++;
var ModalFooter = function ModalFooter(_ref5) {
  var stackCTAs = _ref5.stackCTAs,
    primaryButtonProps = _ref5.primaryButtonProps,
    secondaryButtonProps = _ref5.secondaryButtonProps,
    analyticsName = _ref5.analyticsName;
  cov_ehh839z3q().f[4]++;
  cov_ehh839z3q().s[28]++;
  return /*#__PURE__*/React.createElement(Box, {
    py: "6",
    px: "7",
    display: "flex",
    flexDirection: stackCTAs ? (cov_ehh839z3q().b[13][0]++, 'column') : (cov_ehh839z3q().b[13][1]++, 'row'),
    justifyContent: stackCTAs ? (cov_ehh839z3q().b[14][0]++, undefined) : (cov_ehh839z3q().b[14][1]++, 'space-between')
  }, (cov_ehh839z3q().b[15][0]++, primaryButtonProps) && (cov_ehh839z3q().b[15][1]++, /*#__PURE__*/React.createElement(Button, shared_extends({
    variant: "primary",
    order: stackCTAs ? (cov_ehh839z3q().b[16][0]++, 0) : (cov_ehh839z3q().b[16][1]++, 1),
    minWidth: "41.5%",
    width: (cov_ehh839z3q().b[18][0]++, stackCTAs) || (cov_ehh839z3q().b[18][1]++, !secondaryButtonProps) ? (cov_ehh839z3q().b[17][0]++, '100%') : (cov_ehh839z3q().b[17][1]++, 'auto'),
    mb: (cov_ehh839z3q().b[20][0]++, stackCTAs) && (cov_ehh839z3q().b[20][1]++, !!secondaryButtonProps) ? (cov_ehh839z3q().b[19][0]++, '5') : (cov_ehh839z3q().b[19][1]++, undefined),
    marginLeft: (cov_ehh839z3q().b[22][0]++, !stackCTAs) && (cov_ehh839z3q().b[22][1]++, !!secondaryButtonProps) ? (cov_ehh839z3q().b[21][0]++, '4') : (cov_ehh839z3q().b[21][1]++, undefined)
    // default value for aria-label
    ,
    "aria-label": null
    // default value for analyticsName
    ,
    analyticsName: "".concat(analyticsName, "-primary-button"),
    onClick: primaryButtonProps.onClick
  }, primaryButtonProps, {
    "data-testid": "popover-primary-button"
  }))), (cov_ehh839z3q().b[23][0]++, secondaryButtonProps) && (cov_ehh839z3q().b[23][1]++, /*#__PURE__*/React.createElement(Button, shared_extends({
    variant: (cov_ehh839z3q().b[25][0]++, stackCTAs) && (cov_ehh839z3q().b[25][1]++, !!primaryButtonProps) ? (cov_ehh839z3q().b[24][0]++, 'secondary') : (cov_ehh839z3q().b[24][1]++, 'inline-secondary-link'),
    width: (cov_ehh839z3q().b[27][0]++, stackCTAs) || (cov_ehh839z3q().b[27][1]++, !primaryButtonProps) ? (cov_ehh839z3q().b[26][0]++, '100%') : (cov_ehh839z3q().b[26][1]++, 'auto'),
    fontWeight: (cov_ehh839z3q().b[29][0]++, !stackCTAs) || (cov_ehh839z3q().b[29][1]++, !primaryButtonProps) ? (cov_ehh839z3q().b[28][0]++, 'semibold') : (cov_ehh839z3q().b[28][1]++, undefined),
    textAlign: !primaryButtonProps ? (cov_ehh839z3q().b[30][0]++, 'center') : (cov_ehh839z3q().b[30][1]++, undefined)
    // default value for aria-label
    ,
    "aria-label": null
    // default value for analyticsName
    ,
    analyticsName: "".concat(analyticsName, "-secondary-button"),
    onClick: secondaryButtonProps.onClick
  }, secondaryButtonProps, {
    "data-testid": "popover-secondary-button"
  }))));
};
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/complex/Modal/ContextSheet.mjs
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
























var _excluded = ["isOpen", "onRequestClose", "onBackClick", "title", "subtitle", "headerIconButtonVariant", "id", "analyticsName", "trackBoxImpression", "trackButtonImpressions", "children", "contentKey", "showScrollbar", "hasPadding", "tabletAndDesktopCentered", "themeProps", "contentBgColor"];
function cov_1z9ciwl7mm() {
  var path = "/__w/code/code/js/packages/bricks/src/complex/Modal/ContextSheet.tsx";
  var hash = "6dec98129cdbe8286d6b58d3baf4fe67fd04413d";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/complex/Modal/ContextSheet.tsx",
    statementMap: {
      "0": {
        start: {
          line: 83,
          column: 25
        },
        end: {
          line: 83,
          column: 28
        }
      },
      "1": {
        start: {
          line: 84,
          column: 27
        },
        end: {
          line: 88,
          column: 1
        }
      },
      "2": {
        start: {
          line: 89,
          column: 27
        },
        end: {
          line: 93,
          column: 1
        }
      },
      "3": {
        start: {
          line: 94,
          column: 26
        },
        end: {
          line: 94,
          column: 28
        }
      },
      "4": {
        start: {
          line: 95,
          column: 29
        },
        end: {
          line: 95,
          column: 32
        }
      },
      "5": {
        start: {
          line: 96,
          column: 30
        },
        end: {
          line: 96,
          column: 33
        }
      },
      "6": {
        start: {
          line: 190,
          column: 57
        },
        end: {
          line: 439,
          column: 1
        }
      },
      "7": {
        start: {
          line: 210,
          column: 40
        },
        end: {
          line: 210,
          column: 55
        }
      },
      "8": {
        start: {
          line: 211,
          column: 23
        },
        end: {
          line: 214,
          column: 3
        }
      },
      "9": {
        start: {
          line: 212,
          column: 11
        },
        end: {
          line: 212,
          column: 56
        }
      },
      "10": {
        start: {
          line: 216,
          column: 2
        },
        end: {
          line: 216,
          column: 32
        }
      },
      "11": {
        start: {
          line: 218,
          column: 25
        },
        end: {
          line: 218,
          column: 91
        }
      },
      "12": {
        start: {
          line: 219,
          column: 20
        },
        end: {
          line: 219,
          column: 63
        }
      },
      "13": {
        start: {
          line: 221,
          column: 23
        },
        end: {
          line: 221,
          column: 34
        }
      },
      "14": {
        start: {
          line: 223,
          column: 37
        },
        end: {
          line: 223,
          column: 47
        }
      },
      "15": {
        start: {
          line: 225,
          column: 19
        },
        end: {
          line: 225,
          column: 56
        }
      },
      "16": {
        start: {
          line: 227,
          column: 45
        },
        end: {
          line: 246,
          column: 3
        }
      },
      "17": {
        start: {
          line: 248,
          column: 26
        },
        end: {
          line: 248,
          column: 50
        }
      },
      "18": {
        start: {
          line: 249,
          column: 31
        },
        end: {
          line: 249,
          column: 55
        }
      },
      "19": {
        start: {
          line: 250,
          column: 29
        },
        end: {
          line: 250,
          column: 49
        }
      },
      "20": {
        start: {
          line: 252,
          column: 26
        },
        end: {
          line: 267,
          column: 3
        }
      },
      "21": {
        start: {
          line: 253,
          column: 20
        },
        end: {
          line: 253,
          column: 43
        }
      },
      "22": {
        start: {
          line: 254,
          column: 4
        },
        end: {
          line: 266,
          column: 5
        }
      },
      "23": {
        start: {
          line: 255,
          column: 6
        },
        end: {
          line: 265,
          column: 9
        }
      },
      "24": {
        start: {
          line: 256,
          column: 8
        },
        end: {
          line: 258,
          column: 11
        }
      },
      "25": {
        start: {
          line: 257,
          column: 10
        },
        end: {
          line: 257,
          column: 50
        }
      },
      "26": {
        start: {
          line: 259,
          column: 8
        },
        end: {
          line: 264,
          column: 10
        }
      },
      "27": {
        start: {
          line: 260,
          column: 10
        },
        end: {
          line: 263,
          column: 11
        }
      },
      "28": {
        start: {
          line: 261,
          column: 12
        },
        end: {
          line: 261,
          column: 43
        }
      },
      "29": {
        start: {
          line: 262,
          column: 12
        },
        end: {
          line: 262,
          column: 22
        }
      },
      "30": {
        start: {
          line: 271,
          column: 2
        },
        end: {
          line: 284,
          column: 15
        }
      },
      "31": {
        start: {
          line: 273,
          column: 4
        },
        end: {
          line: 282,
          column: 5
        }
      },
      "32": {
        start: {
          line: 274,
          column: 6
        },
        end: {
          line: 277,
          column: 27
        }
      },
      "33": {
        start: {
          line: 275,
          column: 8
        },
        end: {
          line: 275,
          column: 74
        }
      },
      "34": {
        start: {
          line: 276,
          column: 8
        },
        end: {
          line: 276,
          column: 81
        }
      },
      "35": {
        start: {
          line: 279,
          column: 6
        },
        end: {
          line: 281,
          column: 27
        }
      },
      "36": {
        start: {
          line: 280,
          column: 8
        },
        end: {
          line: 280,
          column: 42
        }
      },
      "37": {
        start: {
          line: 283,
          column: 4
        },
        end: {
          line: 283,
          column: 39
        }
      },
      "38": {
        start: {
          line: 283,
          column: 17
        },
        end: {
          line: 283,
          column: 38
        }
      },
      "39": {
        start: {
          line: 286,
          column: 27
        },
        end: {
          line: 286,
          column: 43
        }
      },
      "40": {
        start: {
          line: 287,
          column: 42
        },
        end: {
          line: 287,
          column: 57
        }
      },
      "41": {
        start: {
          line: 290,
          column: 2
        },
        end: {
          line: 316,
          column: 19
        }
      },
      "42": {
        start: {
          line: 291,
          column: 26
        },
        end: {
          line: 302,
          column: 5
        }
      },
      "43": {
        start: {
          line: 292,
          column: 27
        },
        end: {
          line: 292,
          column: 50
        }
      },
      "44": {
        start: {
          line: 293,
          column: 32
        },
        end: {
          line: 293,
          column: 60
        }
      },
      "45": {
        start: {
          line: 294,
          column: 20
        },
        end: {
          line: 294,
          column: 56
        }
      },
      "46": {
        start: {
          line: 295,
          column: 6
        },
        end: {
          line: 301,
          column: 7
        }
      },
      "47": {
        start: {
          line: 296,
          column: 29
        },
        end: {
          line: 296,
          column: 87
        }
      },
      "48": {
        start: {
          line: 297,
          column: 35
        },
        end: {
          line: 297,
          column: 68
        }
      },
      "49": {
        start: {
          line: 298,
          column: 26
        },
        end: {
          line: 298,
          column: 64
        }
      },
      "50": {
        start: {
          line: 299,
          column: 8
        },
        end: {
          line: 299,
          column: 95
        }
      },
      "51": {
        start: {
          line: 300,
          column: 8
        },
        end: {
          line: 300,
          column: 74
        }
      },
      "52": {
        start: {
          line: 304,
          column: 4
        },
        end: {
          line: 304,
          column: 26
        }
      },
      "53": {
        start: {
          line: 306,
          column: 18
        },
        end: {
          line: 310,
          column: 29
        }
      },
      "54": {
        start: {
          line: 307,
          column: 6
        },
        end: {
          line: 307,
          column: 42
        }
      },
      "55": {
        start: {
          line: 308,
          column: 6
        },
        end: {
          line: 308,
          column: 29
        }
      },
      "56": {
        start: {
          line: 309,
          column: 6
        },
        end: {
          line: 309,
          column: 22
        }
      },
      "57": {
        start: {
          line: 312,
          column: 4
        },
        end: {
          line: 312,
          column: 37
        }
      },
      "58": {
        start: {
          line: 312,
          column: 17
        },
        end: {
          line: 312,
          column: 36
        }
      },
      "59": {
        start: {
          line: 318,
          column: 45
        },
        end: {
          line: 328,
          column: 3
        }
      },
      "60": {
        start: {
          line: 330,
          column: 23
        },
        end: {
          line: 352,
          column: 3
        }
      },
      "61": {
        start: {
          line: 354,
          column: 2
        },
        end: {
          line: 438,
          column: 4
        }
      },
      "62": {
        start: {
          line: 363,
          column: 29
        },
        end: {
          line: 363,
          column: 59
        }
      },
      "63": {
        start: {
          line: 441,
          column: 20
        },
        end: {
          line: 516,
          column: 1
        }
      },
      "64": {
        start: {
          line: 442,
          column: 20
        },
        end: {
          line: 442,
          column: 48
        }
      },
      "65": {
        start: {
          line: 443,
          column: 22
        },
        end: {
          line: 443,
          column: 42
        }
      },
      "66": {
        start: {
          line: 444,
          column: 21
        },
        end: {
          line: 444,
          column: 41
        }
      },
      "67": {
        start: {
          line: 449,
          column: 2
        },
        end: {
          line: 457,
          column: 9
        }
      },
      "68": {
        start: {
          line: 450,
          column: 4
        },
        end: {
          line: 456,
          column: 6
        }
      },
      "69": {
        start: {
          line: 453,
          column: 8
        },
        end: {
          line: 453,
          column: 27
        }
      },
      "70": {
        start: {
          line: 459,
          column: 62
        },
        end: {
          line: 466,
          column: 3
        }
      },
      "71": {
        start: {
          line: 460,
          column: 4
        },
        end: {
          line: 460,
          column: 45
        }
      },
      "72": {
        start: {
          line: 462,
          column: 4
        },
        end: {
          line: 462,
          column: 66
        }
      },
      "73": {
        start: {
          line: 463,
          column: 4
        },
        end: {
          line: 465,
          column: 7
        }
      },
      "74": {
        start: {
          line: 464,
          column: 6
        },
        end: {
          line: 464,
          column: 56
        }
      },
      "75": {
        start: {
          line: 468,
          column: 45
        },
        end: {
          line: 475,
          column: 3
        }
      },
      "76": {
        start: {
          line: 469,
          column: 4
        },
        end: {
          line: 469,
          column: 44
        }
      },
      "77": {
        start: {
          line: 470,
          column: 4
        },
        end: {
          line: 474,
          column: 7
        }
      },
      "78": {
        start: {
          line: 471,
          column: 6
        },
        end: {
          line: 473,
          column: 11
        }
      },
      "79": {
        start: {
          line: 477,
          column: 25
        },
        end: {
          line: 492,
          column: 3
        }
      },
      "80": {
        start: {
          line: 479,
          column: 4
        },
        end: {
          line: 481,
          column: 7
        }
      },
      "81": {
        start: {
          line: 480,
          column: 6
        },
        end: {
          line: 480,
          column: 68
        }
      },
      "82": {
        start: {
          line: 482,
          column: 4
        },
        end: {
          line: 489,
          column: 5
        }
      },
      "83": {
        start: {
          line: 484,
          column: 6
        },
        end: {
          line: 484,
          column: 31
        }
      },
      "84": {
        start: {
          line: 485,
          column: 6
        },
        end: {
          line: 485,
          column: 23
        }
      },
      "85": {
        start: {
          line: 488,
          column: 6
        },
        end: {
          line: 488,
          column: 56
        }
      },
      "86": {
        start: {
          line: 490,
          column: 4
        },
        end: {
          line: 490,
          column: 31
        }
      },
      "87": {
        start: {
          line: 491,
          column: 4
        },
        end: {
          line: 491,
          column: 30
        }
      },
      "88": {
        start: {
          line: 494,
          column: 2
        },
        end: {
          line: 515,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 190,
            column: 57
          },
          end: {
            line: 190,
            column: 58
          }
        },
        loc: {
          start: {
            line: 209,
            column: 6
          },
          end: {
            line: 439,
            column: 1
          }
        },
        line: 209
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 212,
            column: 4
          },
          end: {
            line: 212,
            column: 5
          }
        },
        loc: {
          start: {
            line: 212,
            column: 11
          },
          end: {
            line: 212,
            column: 56
          }
        },
        line: 212
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 252,
            column: 26
          },
          end: {
            line: 252,
            column: 27
          }
        },
        loc: {
          start: {
            line: 252,
            column: 55
          },
          end: {
            line: 267,
            column: 3
          }
        },
        line: 252
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 255,
            column: 31
          },
          end: {
            line: 255,
            column: 32
          }
        },
        loc: {
          start: {
            line: 255,
            column: 44
          },
          end: {
            line: 265,
            column: 7
          }
        },
        line: 255
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 256,
            column: 30
          },
          end: {
            line: 256,
            column: 31
          }
        },
        loc: {
          start: {
            line: 256,
            column: 36
          },
          end: {
            line: 258,
            column: 9
          }
        },
        line: 256
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 259,
            column: 34
          },
          end: {
            line: 259,
            column: 35
          }
        },
        loc: {
          start: {
            line: 259,
            column: 41
          },
          end: {
            line: 264,
            column: 9
          }
        },
        line: 259
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 271,
            column: 12
          },
          end: {
            line: 271,
            column: 13
          }
        },
        loc: {
          start: {
            line: 271,
            column: 18
          },
          end: {
            line: 284,
            column: 3
          }
        },
        line: 271
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 274,
            column: 27
          },
          end: {
            line: 274,
            column: 28
          }
        },
        loc: {
          start: {
            line: 274,
            column: 33
          },
          end: {
            line: 277,
            column: 7
          }
        },
        line: 274
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 279,
            column: 27
          },
          end: {
            line: 279,
            column: 28
          }
        },
        loc: {
          start: {
            line: 279,
            column: 33
          },
          end: {
            line: 281,
            column: 7
          }
        },
        line: 279
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 283,
            column: 11
          },
          end: {
            line: 283,
            column: 12
          }
        },
        loc: {
          start: {
            line: 283,
            column: 17
          },
          end: {
            line: 283,
            column: 38
          }
        },
        line: 283
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 290,
            column: 12
          },
          end: {
            line: 290,
            column: 13
          }
        },
        loc: {
          start: {
            line: 290,
            column: 18
          },
          end: {
            line: 316,
            column: 3
          }
        },
        line: 290
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 291,
            column: 26
          },
          end: {
            line: 291,
            column: 27
          }
        },
        loc: {
          start: {
            line: 291,
            column: 38
          },
          end: {
            line: 302,
            column: 5
          }
        },
        line: 291
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 306,
            column: 29
          },
          end: {
            line: 306,
            column: 30
          }
        },
        loc: {
          start: {
            line: 306,
            column: 35
          },
          end: {
            line: 310,
            column: 5
          }
        },
        line: 306
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 312,
            column: 11
          },
          end: {
            line: 312,
            column: 12
          }
        },
        loc: {
          start: {
            line: 312,
            column: 17
          },
          end: {
            line: 312,
            column: 36
          }
        },
        line: 312
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 363,
            column: 18
          },
          end: {
            line: 363,
            column: 19
          }
        },
        loc: {
          start: {
            line: 363,
            column: 29
          },
          end: {
            line: 363,
            column: 59
          }
        },
        line: 363
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 441,
            column: 20
          },
          end: {
            line: 441,
            column: 21
          }
        },
        loc: {
          start: {
            line: 441,
            column: 98
          },
          end: {
            line: 516,
            column: 1
          }
        },
        line: 441
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 449,
            column: 12
          },
          end: {
            line: 449,
            column: 13
          }
        },
        loc: {
          start: {
            line: 449,
            column: 18
          },
          end: {
            line: 457,
            column: 3
          }
        },
        line: 449
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 452,
            column: 6
          },
          end: {
            line: 452,
            column: 7
          }
        },
        loc: {
          start: {
            line: 452,
            column: 13
          },
          end: {
            line: 454,
            column: 7
          }
        },
        line: 452
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 459,
            column: 62
          },
          end: {
            line: 459,
            column: 63
          }
        },
        loc: {
          start: {
            line: 459,
            column: 69
          },
          end: {
            line: 466,
            column: 3
          }
        },
        line: 459
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 463,
            column: 26
          },
          end: {
            line: 463,
            column: 27
          }
        },
        loc: {
          start: {
            line: 463,
            column: 32
          },
          end: {
            line: 465,
            column: 5
          }
        },
        line: 463
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 468,
            column: 45
          },
          end: {
            line: 468,
            column: 46
          }
        },
        loc: {
          start: {
            line: 468,
            column: 52
          },
          end: {
            line: 475,
            column: 3
          }
        },
        line: 468
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 470,
            column: 26
          },
          end: {
            line: 470,
            column: 27
          }
        },
        loc: {
          start: {
            line: 470,
            column: 32
          },
          end: {
            line: 474,
            column: 5
          }
        },
        line: 470
      },
      "22": {
        name: "(anonymous_22)",
        decl: {
          start: {
            line: 477,
            column: 25
          },
          end: {
            line: 477,
            column: 26
          }
        },
        loc: {
          start: {
            line: 477,
            column: 37
          },
          end: {
            line: 492,
            column: 3
          }
        },
        line: 477
      },
      "23": {
        name: "(anonymous_23)",
        decl: {
          start: {
            line: 479,
            column: 26
          },
          end: {
            line: 479,
            column: 27
          }
        },
        loc: {
          start: {
            line: 479,
            column: 32
          },
          end: {
            line: 481,
            column: 5
          }
        },
        line: 479
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 191,
            column: 2
          },
          end: {
            line: 191,
            column: 16
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 191,
            column: 11
          },
          end: {
            line: 191,
            column: 16
          }
        }],
        line: 191
      },
      "1": {
        loc: {
          start: {
            line: 203,
            column: 2
          },
          end: {
            line: 203,
            column: 22
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 203,
            column: 18
          },
          end: {
            line: 203,
            column: 22
          }
        }],
        line: 203
      },
      "2": {
        loc: {
          start: {
            line: 204,
            column: 2
          },
          end: {
            line: 204,
            column: 19
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 204,
            column: 15
          },
          end: {
            line: 204,
            column: 19
          }
        }],
        line: 204
      },
      "3": {
        loc: {
          start: {
            line: 218,
            column: 25
          },
          end: {
            line: 218,
            column: 91
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 218,
            column: 33
          },
          end: {
            line: 218,
            column: 64
          }
        }, {
          start: {
            line: 218,
            column: 67
          },
          end: {
            line: 218,
            column: 91
          }
        }],
        line: 218
      },
      "4": {
        loc: {
          start: {
            line: 219,
            column: 20
          },
          end: {
            line: 219,
            column: 63
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 219,
            column: 37
          },
          end: {
            line: 219,
            column: 41
          }
        }, {
          start: {
            line: 219,
            column: 44
          },
          end: {
            line: 219,
            column: 63
          }
        }],
        line: 219
      },
      "5": {
        loc: {
          start: {
            line: 225,
            column: 19
          },
          end: {
            line: 225,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 225,
            column: 19
          },
          end: {
            line: 225,
            column: 28
          }
        }, {
          start: {
            line: 225,
            column: 32
          },
          end: {
            line: 225,
            column: 56
          }
        }],
        line: 225
      },
      "6": {
        loc: {
          start: {
            line: 228,
            column: 16
          },
          end: {
            line: 228,
            column: 77
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 228,
            column: 33
          },
          end: {
            line: 228,
            column: 58
          }
        }, {
          start: {
            line: 228,
            column: 61
          },
          end: {
            line: 228,
            column: 77
          }
        }],
        line: 228
      },
      "7": {
        loc: {
          start: {
            line: 236,
            column: 12
          },
          end: {
            line: 236,
            column: 33
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 236,
            column: 23
          },
          end: {
            line: 236,
            column: 29
          }
        }, {
          start: {
            line: 236,
            column: 32
          },
          end: {
            line: 236,
            column: 33
          }
        }],
        line: 236
      },
      "8": {
        loc: {
          start: {
            line: 239,
            column: 18
          },
          end: {
            line: 239,
            column: 96
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 239,
            column: 29
          },
          end: {
            line: 239,
            column: 46
          }
        }, {
          start: {
            line: 239,
            column: 49
          },
          end: {
            line: 239,
            column: 96
          }
        }],
        line: 239
      },
      "9": {
        loc: {
          start: {
            line: 243,
            column: 15
          },
          end: {
            line: 243,
            column: 89
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 243,
            column: 26
          },
          end: {
            line: 243,
            column: 65
          }
        }, {
          start: {
            line: 243,
            column: 68
          },
          end: {
            line: 243,
            column: 89
          }
        }],
        line: 243
      },
      "10": {
        loc: {
          start: {
            line: 244,
            column: 11
          },
          end: {
            line: 244,
            column: 37
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 244,
            column: 22
          },
          end: {
            line: 244,
            column: 28
          }
        }, {
          start: {
            line: 244,
            column: 31
          },
          end: {
            line: 244,
            column: 37
          }
        }],
        line: 244
      },
      "11": {
        loc: {
          start: {
            line: 254,
            column: 4
          },
          end: {
            line: 266,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 254,
            column: 4
          },
          end: {
            line: 266,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 254
      },
      "12": {
        loc: {
          start: {
            line: 260,
            column: 10
          },
          end: {
            line: 263,
            column: 11
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 260,
            column: 10
          },
          end: {
            line: 263,
            column: 11
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 260
      },
      "13": {
        loc: {
          start: {
            line: 273,
            column: 4
          },
          end: {
            line: 282,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 273,
            column: 4
          },
          end: {
            line: 282,
            column: 5
          }
        }, {
          start: {
            line: 278,
            column: 11
          },
          end: {
            line: 282,
            column: 5
          }
        }],
        line: 273
      },
      "14": {
        loc: {
          start: {
            line: 295,
            column: 6
          },
          end: {
            line: 301,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 295,
            column: 6
          },
          end: {
            line: 301,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 295
      },
      "15": {
        loc: {
          start: {
            line: 295,
            column: 10
          },
          end: {
            line: 295,
            column: 52
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 295,
            column: 10
          },
          end: {
            line: 295,
            column: 22
          }
        }, {
          start: {
            line: 295,
            column: 26
          },
          end: {
            line: 295,
            column: 43
          }
        }, {
          start: {
            line: 295,
            column: 47
          },
          end: {
            line: 295,
            column: 52
          }
        }],
        line: 295
      },
      "16": {
        loc: {
          start: {
            line: 299,
            column: 30
          },
          end: {
            line: 299,
            column: 93
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 299,
            column: 63
          },
          end: {
            line: 299,
            column: 72
          }
        }, {
          start: {
            line: 299,
            column: 75
          },
          end: {
            line: 299,
            column: 93
          }
        }],
        line: 299
      },
      "17": {
        loc: {
          start: {
            line: 387,
            column: 11
          },
          end: {
            line: 394,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 387,
            column: 11
          },
          end: {
            line: 387,
            column: 19
          }
        }, {
          start: {
            line: 388,
            column: 12
          },
          end: {
            line: 393,
            column: 14
          }
        }],
        line: 387
      },
      "18": {
        loc: {
          start: {
            line: 396,
            column: 11
          },
          end: {
            line: 409,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 396,
            column: 12
          },
          end: {
            line: 396,
            column: 26
          }
        }, {
          start: {
            line: 396,
            column: 30
          },
          end: {
            line: 396,
            column: 41
          }
        }, {
          start: {
            line: 396,
            column: 45
          },
          end: {
            line: 396,
            column: 50
          }
        }, {
          start: {
            line: 396,
            column: 54
          },
          end: {
            line: 396,
            column: 62
          }
        }, {
          start: {
            line: 397,
            column: 12
          },
          end: {
            line: 408,
            column: 14
          }
        }],
        line: 396
      },
      "19": {
        loc: {
          start: {
            line: 416,
            column: 12
          },
          end: {
            line: 422,
            column: 17
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 417,
            column: 16
          },
          end: {
            line: 417,
            column: 18
          }
        }, {
          start: {
            line: 418,
            column: 16
          },
          end: {
            line: 422,
            column: 17
          }
        }],
        line: 416
      },
      "20": {
        loc: {
          start: {
            line: 428,
            column: 21
          },
          end: {
            line: 428,
            column: 41
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 428,
            column: 36
          },
          end: {
            line: 428,
            column: 37
          }
        }, {
          start: {
            line: 428,
            column: 40
          },
          end: {
            line: 428,
            column: 41
          }
        }],
        line: 428
      },
      "21": {
        loc: {
          start: {
            line: 430,
            column: 29
          },
          end: {
            line: 430,
            column: 73
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 430,
            column: 29
          },
          end: {
            line: 430,
            column: 42
          }
        }, {
          start: {
            line: 430,
            column: 46
          },
          end: {
            line: 430,
            column: 73
          }
        }],
        line: 430
      },
      "22": {
        loc: {
          start: {
            line: 431,
            column: 15
          },
          end: {
            line: 431,
            column: 33
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 431,
            column: 28
          },
          end: {
            line: 431,
            column: 29
          }
        }, {
          start: {
            line: 431,
            column: 32
          },
          end: {
            line: 431,
            column: 33
          }
        }],
        line: 431
      },
      "23": {
        loc: {
          start: {
            line: 482,
            column: 4
          },
          end: {
            line: 489,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 482,
            column: 4
          },
          end: {
            line: 489,
            column: 5
          }
        }, {
          start: {
            line: 486,
            column: 11
          },
          end: {
            line: 489,
            column: 5
          }
        }],
        line: 482
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0
    },
    b: {
      "0": [0],
      "1": [0],
      "2": [0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0, 0, 0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "6dec98129cdbe8286d6b58d3baf4fe67fd04413d"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1z9ciwl7mm = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1z9ciwl7mm();
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }




function ContextSheet_slicedToArray(arr, i) { return ContextSheet_arrayWithHoles(arr) || ContextSheet_iterableToArrayLimit(arr, i) || ContextSheet_unsupportedIterableToArray(arr, i) || ContextSheet_nonIterableRest(); }
function ContextSheet_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function ContextSheet_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return ContextSheet_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ContextSheet_arrayLikeToArray(o, minLen); }
function ContextSheet_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ContextSheet_iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function ContextSheet_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }











// To meet accessibility standards, the ContextSheet component must receive either title, aria-labelledby, or aria-label.

var CLOSE_TIMEOUT_MS = (cov_1z9ciwl7mm().s[0]++, 500);
var CONTENT_CLASS_NAME = (cov_1z9ciwl7mm().s[1]++, {
  base: 'BricksContextSheet',
  afterOpen: 'BricksContextSheet--after-open',
  beforeClose: 'BricksContextSheet--before-close'
});
var OVERLAY_CLASS_NAME = (cov_1z9ciwl7mm().s[2]++, {
  base: 'BricksContextSheet__Overlay',
  afterOpen: 'BricksContextSheet__Overlay--after-open',
  beforeClose: 'BricksContextSheet__Overlay--before-close'
});
var MARGIN_TOP_MOBILE = (cov_1z9ciwl7mm().s[3]++, 48);
var HEIGHT_TRANSITION_MS = (cov_1z9ciwl7mm().s[4]++, 250);
var OPACITY_TRANSITION_MS = (cov_1z9ciwl7mm().s[5]++, 200);

/**
 * These are our default modal patterns for mobile. Context sheets don’t cover
 * the whole screen but rather maintain a peek of a source view. This helps
 * users understand where they came from and quickly navigate back if they need
 * to. Also called Bottom Sheets via Google Materials
 *
 * Content Sizing
 *
 *
 * ------------------
 *
 * ContextSheets change size based on their content. On mobile, their height
 * expands up to 48px from the top of the screen and on larger screens, up to
 * 64px from the top of the screen. Their width will take up 100% of the screen
 * width, up to a max of 960px. ContextSheets allow for vertical scrolling. If
 * for some reason you don't want the ContextSheet to stick to the bottom of the
 * screen on larger devices, pass`tabletAndDesktopCentered={true}`.
 *
 * If the content of your ContextSheet is dynamic (e.g., because it's a
 * multi-step wizard), you must pass a`contentKey` that uniquely identifies the
 * content. This lets the component adjust its height to fit the updated
 * content.
 *
 * Header Props
 *
 *
 * ----------------
 *
 * ContextSheets render header content based on props:
 *
 * *   The close icon renders when you pass `onRequestClose` (this is required)
 *
 * *   A back icon renders when you pass `onBackClick`
 *
 * *   On scroll, a divider appears between the header and the content
 *
 *
 * Touch Handle
 *
 *
 * ----------------
 *
 * On mobile, ContextSheets render a bar at the top that lets users drag the
 * sheet up and down. If the user drags the sheet down more than 20% of the
 * sheet's height, the sheet will dismiss itself (just like tapping the X icon
 * or the overlay).
 *
 * Accessibility
 *
 *
 * -----------------
 *
 * It's required to pass one of these props: `title`, `aria-labelledby`, or
 * `aria-label`. We recommend passing `title` (if you do that, the component
 * will render the appropriate `aria-labelledby` attribute for you).
 *
 * <Popover title="My Popover"> <Text>Content</Text> </Popover>
 *
 * <Popover aria-labelledby="popover-heading"> <Box> <Text
 * id="popover-heading">Heading</Text> <Text>Content</Text> </Box> </Popover>
 *
 * // Acceptable, but try to avoid because there's no visible text label
 * <Popover aria-label="Popover with Content"> <Image /> </Popover>
 *
 *
 * Analytics
 *
 *
 * -------------
 *
 * If you pass `analyticsName`, the Popover component will track:
 *
 * *   Modal impression events, if you also pass `trackBoxImpression={true}`
 *
 * *   `boxViewEvent: { targetName: "example" }`
 *
 * *   Back button events, if you also pass `onBackClick`
 *
 * *   `buttonViewEvent: { targetName: "example-back" }`
 *
 * *   `buttonHoverEvent: { targetName: "example-back" }`
 *
 * *   `buttonClickEvent: { targetName: "example-back" }`,
 *
 * *   Close button events
 *
 * *   `buttonViewEvent: { targetName: "example-close" }`
 *
 * *   `buttonHoverEvent: { targetName: "example-close" }`
 *
 * *   `buttonClickEvent: { targetName: "example-close" }`
 */
cov_1z9ciwl7mm().s[6]++;
var ContextSheet = function ContextSheet(_ref) {
  var _ref$isOpen = _ref.isOpen,
    isOpen = _ref$isOpen === void 0 ? (cov_1z9ciwl7mm().b[0][0]++, false) : _ref$isOpen,
    onRequestClose = _ref.onRequestClose,
    onBackClick = _ref.onBackClick,
    title = _ref.title,
    subtitle = _ref.subtitle,
    headerIconButtonVariant = _ref.headerIconButtonVariant,
    id = _ref.id,
    analyticsName = _ref.analyticsName,
    trackBoxImpression = _ref.trackBoxImpression,
    trackButtonImpressions = _ref.trackButtonImpressions,
    children = _ref.children,
    contentKey = _ref.contentKey,
    _ref$showScrollbar = _ref.showScrollbar,
    showScrollbar = _ref$showScrollbar === void 0 ? (cov_1z9ciwl7mm().b[1][0]++, true) : _ref$showScrollbar,
    _ref$hasPadding = _ref.hasPadding,
    hasPadding = _ref$hasPadding === void 0 ? (cov_1z9ciwl7mm().b[2][0]++, true) : _ref$hasPadding,
    tabletAndDesktopCentered = _ref.tabletAndDesktopCentered,
    themeProps = _ref.themeProps,
    contentBgColor = _ref.contentBgColor,
    props = _objectWithoutProperties(_ref, _excluded);
  cov_1z9ciwl7mm().f[0]++;
  var _ref2 = (cov_1z9ciwl7mm().s[7]++, (0,react.useState)(false)),
    _ref3 = ContextSheet_slicedToArray(_ref2, 2),
    showDivider = _ref3[0],
    setShowDivider = _ref3[1];
  var handleScroll = (cov_1z9ciwl7mm().s[8]++, (0,react.useCallback)(function (e) {
    cov_1z9ciwl7mm().f[1]++;
    cov_1z9ciwl7mm().s[9]++;
    return setShowDivider(e.currentTarget.scrollTop > 0);
  }, []));
  cov_1z9ciwl7mm().s[10]++;
  useDisabledBodyScroll(isOpen);
  var ariaLabelledBy = (cov_1z9ciwl7mm().s[11]++, title ? (cov_1z9ciwl7mm().b[3][0]++, getNavigationBarTitleId({
    id: id
  })) : (cov_1z9ciwl7mm().b[3][1]++, props['aria-labelledby']));
  var ariaLabel = (cov_1z9ciwl7mm().s[12]++, ariaLabelledBy ? (cov_1z9ciwl7mm().b[4][0]++, null) : (cov_1z9ciwl7mm().b[4][1]++, props['aria-label']));
  var _ref4 = (cov_1z9ciwl7mm().s[13]++, (0,useMedia/* useDevice */.F)()),
    isMobile = _ref4.isMobile;
  var _ref5 = (cov_1z9ciwl7mm().s[14]++, (0,theme/* useTheme */.F)()),
    radii = _ref5.radii,
    shadows = _ref5.shadows,
    colors = _ref5.colors;
  var centered = (cov_1z9ciwl7mm().s[15]++, (cov_1z9ciwl7mm().b[5][0]++, !isMobile) && (cov_1z9ciwl7mm().b[5][1]++, tabletAndDesktopCentered));
  var contentStyles = (cov_1z9ciwl7mm().s[16]++, {
    background: contentBgColor ? (cov_1z9ciwl7mm().b[6][0]++, foundations_colors/* default */.ZP[contentBgColor]) : (cov_1z9ciwl7mm().b[6][1]++, colors.neutrals0),
    WebkitOverflowScrolling: 'touch',
    outline: 'none',
    border: 'none',
    position: 'fixed',
    top: 'auto',
    left: 'auto',
    right: 'auto',
    bottom: centered ? (cov_1z9ciwl7mm().b[7][0]++, 'auto') : (cov_1z9ciwl7mm().b[7][1]++, 0),
    padding: 0,
    boxShadow: shadows.z2,
    borderRadius: centered ? (cov_1z9ciwl7mm().b[8][0]++, radii.semiRounded) : (cov_1z9ciwl7mm().b[8][1]++, "".concat(radii.semiRounded, " ").concat(radii.semiRounded, " 0 0")),
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    maxHeight: isMobile ? (cov_1z9ciwl7mm().b[9][0]++, "calc(100svh - ".concat(MARGIN_TOP_MOBILE, "px)")) : (cov_1z9ciwl7mm().b[9][1]++, 'calc(100svh - 64px)'),
    width: centered ? (cov_1z9ciwl7mm().b[10][0]++, 'auto') : (cov_1z9ciwl7mm().b[10][1]++, '100%'),
    maxWidth: '960px'
  });
  var contextSheetRef = (cov_1z9ciwl7mm().s[17]++, (0,react.useRef)());
  var childrenContainerRef = (cov_1z9ciwl7mm().s[18]++, (0,react.useRef)());
  var contextSheetHeight = (cov_1z9ciwl7mm().s[19]++, (0,react.useRef)(null));
  cov_1z9ciwl7mm().s[20]++;
  var animateToHeight = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(endHeight) {
      var element;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            cov_1z9ciwl7mm().f[2]++;
            element = (cov_1z9ciwl7mm().s[21]++, contextSheetRef.current);
            cov_1z9ciwl7mm().s[22]++;
            if (!element) {
              _context.next = 9;
              break;
            }
            cov_1z9ciwl7mm().b[11][0]++;
            cov_1z9ciwl7mm().s[23]++;
            return _context.abrupt("return", new Promise(function (resolve) {
              cov_1z9ciwl7mm().f[3]++;
              cov_1z9ciwl7mm().s[24]++;
              requestAnimationFrame(function () {
                cov_1z9ciwl7mm().f[4]++;
                cov_1z9ciwl7mm().s[25]++;
                element.style.height = "".concat(endHeight, "px");
              });
              cov_1z9ciwl7mm().s[26]++;
              element.ontransitionend = function (e) {
                cov_1z9ciwl7mm().f[5]++;
                cov_1z9ciwl7mm().s[27]++;
                if (e.propertyName === 'height') {
                  cov_1z9ciwl7mm().b[12][0]++;
                  cov_1z9ciwl7mm().s[28]++;
                  element.ontransitionend = null;
                  cov_1z9ciwl7mm().s[29]++;
                  resolve();
                } else {
                  cov_1z9ciwl7mm().b[12][1]++;
                }
              };
            }));
          case 9:
            cov_1z9ciwl7mm().b[11][1]++;
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function animateToHeight(_x) {
      return _ref6.apply(this, arguments);
    };
  }();

  // Read the context sheet's height once it's fully opened, and set it to a pixel value because
  // transitions don't work with height: auto
  cov_1z9ciwl7mm().s[30]++;
  (0,react.useEffect)(function () {
    cov_1z9ciwl7mm().f[6]++;
    var timeout;
    cov_1z9ciwl7mm().s[31]++;
    if (isOpen) {
      cov_1z9ciwl7mm().b[13][0]++;
      cov_1z9ciwl7mm().s[32]++;
      timeout = setTimeout(function () {
        cov_1z9ciwl7mm().f[7]++;
        cov_1z9ciwl7mm().s[33]++;
        contextSheetHeight.current = contextSheetRef.current.clientHeight;
        cov_1z9ciwl7mm().s[34]++;
        contextSheetRef.current.style.height = "".concat(contextSheetHeight.current, "px");
      }, CLOSE_TIMEOUT_MS);
    } else {
      cov_1z9ciwl7mm().b[13][1]++;
      cov_1z9ciwl7mm().s[35]++;
      timeout = setTimeout(function () {
        cov_1z9ciwl7mm().f[8]++;
        cov_1z9ciwl7mm().s[36]++;
        contextSheetHeight.current = null;
      }, CLOSE_TIMEOUT_MS);
    }
    cov_1z9ciwl7mm().s[37]++;
    return function () {
      cov_1z9ciwl7mm().f[9]++;
      cov_1z9ciwl7mm().s[38]++;
      return clearTimeout(timeout);
    };
  }, [isOpen]);
  var renderedChildren = (cov_1z9ciwl7mm().s[39]++, (0,react.useRef)(children));
  var _ref7 = (cov_1z9ciwl7mm().s[40]++, (0,react.useState)(false)),
    _ref8 = ContextSheet_slicedToArray(_ref7, 2),
    hideChildren = _ref8[0],
    setHideChildren = _ref8[1];

  // Animate the height and opacity of the context sheet when the content changes
  cov_1z9ciwl7mm().s[41]++;
  (0,react.useEffect)(function () {
    cov_1z9ciwl7mm().f[10]++;
    cov_1z9ciwl7mm().s[42]++;
    var animateHeight = /*#__PURE__*/function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var contextSheet, childrenContainer, child, headerHeight, totalContentHeight, maxHeight;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              cov_1z9ciwl7mm().f[11]++;
              contextSheet = (cov_1z9ciwl7mm().s[43]++, contextSheetRef.current);
              childrenContainer = (cov_1z9ciwl7mm().s[44]++, childrenContainerRef.current);
              child = (cov_1z9ciwl7mm().s[45]++, childrenContainer === null || childrenContainer === void 0 ? void 0 : childrenContainer.firstElementChild);
              cov_1z9ciwl7mm().s[46]++;
              if (!((cov_1z9ciwl7mm().b[15][0]++, contextSheet) && (cov_1z9ciwl7mm().b[15][1]++, childrenContainer) && (cov_1z9ciwl7mm().b[15][2]++, child))) {
                _context2.next = 17;
                break;
              }
              cov_1z9ciwl7mm().b[14][0]++;
              headerHeight = (cov_1z9ciwl7mm().s[47]++, contextSheet.clientHeight - childrenContainer.clientHeight);
              totalContentHeight = (cov_1z9ciwl7mm().s[48]++, headerHeight + child.scrollHeight);
              maxHeight = (cov_1z9ciwl7mm().s[49]++, window.innerHeight - MARGIN_TOP_MOBILE);
              cov_1z9ciwl7mm().s[50]++;
              _context2.next = 13;
              return animateToHeight(totalContentHeight > maxHeight ? (cov_1z9ciwl7mm().b[16][0]++, maxHeight) : (cov_1z9ciwl7mm().b[16][1]++, totalContentHeight));
            case 13:
              cov_1z9ciwl7mm().s[51]++;
              contextSheetHeight.current = contextSheetRef.current.clientHeight;
              _context2.next = 18;
              break;
            case 17:
              cov_1z9ciwl7mm().b[14][1]++;
            case 18:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function animateHeight() {
        return _ref9.apply(this, arguments);
      };
    }();
    cov_1z9ciwl7mm().s[52]++;
    setHideChildren(true);
    var timer = (cov_1z9ciwl7mm().s[53]++, setTimeout(function () {
      cov_1z9ciwl7mm().f[12]++;
      cov_1z9ciwl7mm().s[54]++;
      renderedChildren.current = children;
      cov_1z9ciwl7mm().s[55]++;
      setHideChildren(false);
      cov_1z9ciwl7mm().s[56]++;
      animateHeight();
    }, OPACITY_TRANSITION_MS));
    cov_1z9ciwl7mm().s[57]++;
    return function () {
      cov_1z9ciwl7mm().f[13]++;
      cov_1z9ciwl7mm().s[58]++;
      return clearTimeout(timer);
    };

    // `children` intentionally left out of dependencies array
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contentKey]);
  var overlayStyles = (cov_1z9ciwl7mm().s[59]++, {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 999
  });
  var globalStyles = (cov_1z9ciwl7mm().s[60]++, /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(".", OVERLAY_CLASS_NAME.base, "{background-color:rgba(34, 34, 34, 0);transition:background-color ", CLOSE_TIMEOUT_MS, "ms ease-out;}.", OVERLAY_CLASS_NAME.afterOpen, "{background-color:rgba(34, 34, 34, 0.6);}.", OVERLAY_CLASS_NAME.beforeClose, "{background-color:rgba(34, 34, 34, 0);}.", CONTENT_CLASS_NAME.base, "{transform:translateY(100%);transition:transform ", CLOSE_TIMEOUT_MS, "ms ease-out,height ", HEIGHT_TRANSITION_MS, "ms ease-out;}.", CONTENT_CLASS_NAME.afterOpen, "{transform:translateY(0);}.", CONTENT_CLASS_NAME.beforeClose, "{transform:translateY(100%);}" + ( true ? "" : 0),  true ? "" : 0));
  cov_1z9ciwl7mm().s[61]++;
  return /*#__PURE__*/react.createElement(lib, {
    isOpen: isOpen,
    onRequestClose: onRequestClose,
    shouldCloseOnOverlayClick: true,
    className: CONTENT_CLASS_NAME,
    overlayClassName: OVERLAY_CLASS_NAME,
    closeTimeoutMS: CLOSE_TIMEOUT_MS,
    style: {
      content: contentStyles,
      overlay: overlayStyles
    },
    contentRef: function contentRef(node) {
      cov_1z9ciwl7mm().f[14]++;
      cov_1z9ciwl7mm().s[62]++;
      return contextSheetRef.current = node;
    }
    /*
      Accessibility note: Aria-model indicates the presence of a modal element
      https://www.w3.org/TR/wai-aria-1.2/#aria-modal
    */,
    "aria-modal": isOpen
    /*
      Accessibility note: use the contentLabel prop to provide a label for the modal content
      If the modal is already labeled with visible text, you should specify the element including the label with the aria-labelledby attribute.
      https://reactcommunity.org/react-modal/accessibility/#aria-attributes
      To set aria-labelledby, either (1) pass headerProps.title and let this component set aria-labelledby for you, or (2) pass ariaLabelledBy
      and set it to the id of your custom label
    */,
    aria: {
      labelledby: ariaLabelledBy
    },
    contentLabel: ariaLabel
  }, /*#__PURE__*/react.createElement(emotion_react_browser_esm/* Global */.xB, {
    styles: globalStyles
  }), /*#__PURE__*/react.createElement(ODThemeLite/* ThemedLite */.h, themeProps, /*#__PURE__*/react.createElement(react.Fragment, null, (cov_1z9ciwl7mm().b[17][0]++, isMobile) && (cov_1z9ciwl7mm().b[17][1]++, /*#__PURE__*/react.createElement(TouchHandle, {
    contextSheetRef: contextSheetRef,
    contextSheetHeight: contextSheetHeight,
    animateToHeight: animateToHeight,
    onRequestClose: onRequestClose
  })), ((cov_1z9ciwl7mm().b[18][0]++, onRequestClose) || (cov_1z9ciwl7mm().b[18][1]++, onBackClick) || (cov_1z9ciwl7mm().b[18][2]++, title) || (cov_1z9ciwl7mm().b[18][3]++, subtitle)) && (cov_1z9ciwl7mm().b[18][4]++, /*#__PURE__*/react.createElement(ModalHeader, {
    trackBoxImpression: trackBoxImpression,
    trackButtonImpressions: trackButtonImpressions,
    analyticsName: analyticsName,
    onBackClick: onBackClick,
    onRequestClose: onRequestClose,
    title: title,
    subtitle: subtitle,
    id: id,
    showDivider: showDivider,
    headerIconButtonVariant: headerIconButtonVariant
  }))), /*#__PURE__*/react.createElement(Box_Box/* default */.Z, {
    flexGrow: 1,
    overflowY: "scroll",
    sx: showScrollbar ? (cov_1z9ciwl7mm().b[19][0]++, {}) : (cov_1z9ciwl7mm().b[19][1]++, {
      '&::-webkit-scrollbar': {
        display: 'none'
      },
      msOverflowStyle: 'none',
      scrollbarWidth: 'none'
    }),
    onScroll: handleScroll,
    ref: childrenContainerRef
  }, /*#__PURE__*/react.createElement(Box_Box/* default */.Z, {
    opacity: hideChildren ? (cov_1z9ciwl7mm().b[20][0]++, 0) : (cov_1z9ciwl7mm().b[20][1]++, 1),
    transition: "opacity ".concat(OPACITY_TRANSITION_MS, "ms ease-out"),
    transitionDelay: (cov_1z9ciwl7mm().b[21][0]++, !hideChildren) && (cov_1z9ciwl7mm().b[21][1]++, "".concat(HEIGHT_TRANSITION_MS, "ms")),
    p: hasPadding ? (cov_1z9ciwl7mm().b[22][0]++, 5) : (cov_1z9ciwl7mm().b[22][1]++, 0)
  }, renderedChildren.current))));
};
cov_1z9ciwl7mm().s[63]++;
var TouchHandle = function TouchHandle(_ref10) {
  var contextSheetRef = _ref10.contextSheetRef,
    contextSheetHeight = _ref10.contextSheetHeight,
    animateToHeight = _ref10.animateToHeight,
    onRequestClose = _ref10.onRequestClose;
  cov_1z9ciwl7mm().f[15]++;
  var handleRef = (cov_1z9ciwl7mm().s[64]++, (0,react.useRef)(null));
  var touchStartY = (cov_1z9ciwl7mm().s[65]++, (0,react.useRef)(null));
  var touchMoveY = (cov_1z9ciwl7mm().s[66]++, (0,react.useRef)(null));
  var originalTransition;

  // Prevent pull-to-refresh
  cov_1z9ciwl7mm().s[67]++;
  (0,react.useEffect)(function () {
    cov_1z9ciwl7mm().f[16]++;
    cov_1z9ciwl7mm().s[68]++;
    handleRef.current.addEventListener('touchstart', function (e) {
      cov_1z9ciwl7mm().f[17]++;
      cov_1z9ciwl7mm().s[69]++;
      e.preventDefault();
    }, {
      passive: false
    });
  }, []);
  cov_1z9ciwl7mm().s[70]++;
  var handleTouchStart = function handleTouchStart(e) {
    cov_1z9ciwl7mm().f[18]++;
    cov_1z9ciwl7mm().s[71]++;
    touchStartY.current = e.touches[0].pageY;
    // Remove the original transition so height changes match the touch movements exactly
    cov_1z9ciwl7mm().s[72]++;
    originalTransition = contextSheetRef.current.style.transition;
    cov_1z9ciwl7mm().s[73]++;
    requestAnimationFrame(function () {
      cov_1z9ciwl7mm().f[19]++;
      cov_1z9ciwl7mm().s[74]++;
      contextSheetRef.current.style.transition = 'none';
    });
  };
  cov_1z9ciwl7mm().s[75]++;
  var handleTouchMove = function handleTouchMove(e) {
    cov_1z9ciwl7mm().f[20]++;
    cov_1z9ciwl7mm().s[76]++;
    touchMoveY.current = e.touches[0].pageY;
    cov_1z9ciwl7mm().s[77]++;
    requestAnimationFrame(function () {
      cov_1z9ciwl7mm().f[21]++;
      cov_1z9ciwl7mm().s[78]++;
      contextSheetRef.current.style.height = "".concat(contextSheetHeight.current + touchStartY.current - touchMoveY.current, "px");
    });
  };
  cov_1z9ciwl7mm().s[79]++;
  var handleTouchEnd = /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            cov_1z9ciwl7mm().f[22]++;
            cov_1z9ciwl7mm().s[80]++;
            // Restore the original transition
            requestAnimationFrame(function () {
              cov_1z9ciwl7mm().f[23]++;
              cov_1z9ciwl7mm().s[81]++;
              contextSheetRef.current.style.transition = originalTransition;
            });
            cov_1z9ciwl7mm().s[82]++;
            if (!(touchMoveY.current - touchStartY.current > contextSheetHeight.current * 0.2)) {
              _context3.next = 13;
              break;
            }
            cov_1z9ciwl7mm().b[23][0]++;
            cov_1z9ciwl7mm().s[83]++;
            _context3.next = 9;
            return animateToHeight(0);
          case 9:
            cov_1z9ciwl7mm().s[84]++;
            onRequestClose();
            _context3.next = 17;
            break;
          case 13:
            cov_1z9ciwl7mm().b[23][1]++;
            cov_1z9ciwl7mm().s[85]++;
            _context3.next = 17;
            return animateToHeight(contextSheetHeight.current);
          case 17:
            cov_1z9ciwl7mm().s[86]++;
            touchStartY.current = null;
            cov_1z9ciwl7mm().s[87]++;
            touchMoveY.current = null;
          case 21:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function handleTouchEnd() {
      return _ref11.apply(this, arguments);
    };
  }();
  cov_1z9ciwl7mm().s[88]++;
  return /*#__PURE__*/react.createElement(Box_Box/* default */.Z, {
    display: "flex",
    justifyContent: "center"
  }, /*#__PURE__*/react.createElement(Box_Box/* default */.Z, {
    px: "10",
    py: "4",
    mb: "-12px" // Bottom padding + negative margin makes tappable region larger without creating extra visible space
    ,
    zIndex: 1,
    onTouchStart: handleTouchStart,
    onTouchMove: handleTouchMove,
    onTouchEnd: handleTouchEnd,
    ref: handleRef
  }, /*#__PURE__*/react.createElement(Box_Box/* default */.Z, {
    backgroundColor: "neutrals20",
    width: "48px",
    height: "6px",
    borderRadius: "semiRounded",
    userSelect: "none"
  })));
};
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/ThemeOverrideExpiredBanner.mjs
function cov_bylmr23c3() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/ThemeOverrideExpiredBanner.tsx";
  var hash = "aec3420ee9fc8dd29618f71ba46ffcdf4c9c6baa";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/ThemeOverrideExpiredBanner.tsx",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 2
        },
        end: {
          line: 10,
          column: 44
        }
      },
      "1": {
        start: {
          line: 12,
          column: 29
        },
        end: {
          line: 12,
          column: 31
        }
      },
      "2": {
        start: {
          line: 23,
          column: 5
        },
        end: {
          line: 98,
          column: 1
        }
      },
      "3": {
        start: {
          line: 24,
          column: 16
        },
        end: {
          line: 24,
          column: 24
        }
      },
      "4": {
        start: {
          line: 25,
          column: 31
        },
        end: {
          line: 25,
          column: 60
        }
      },
      "5": {
        start: {
          line: 32,
          column: 25
        },
        end: {
          line: 32,
          column: 83
        }
      },
      "6": {
        start: {
          line: 33,
          column: 20
        },
        end: {
          line: 33,
          column: 69
        }
      },
      "7": {
        start: {
          line: 38,
          column: 42
        },
        end: {
          line: 40,
          column: 15
        }
      },
      "8": {
        start: {
          line: 41,
          column: 41
        },
        end: {
          line: 41,
          column: 98
        }
      },
      "9": {
        start: {
          line: 47,
          column: 19
        },
        end: {
          line: 49,
          column: 11
        }
      },
      "10": {
        start: {
          line: 54,
          column: 38
        },
        end: {
          line: 56,
          column: 3
        }
      },
      "11": {
        start: {
          line: 57,
          column: 2
        },
        end: {
          line: 59,
          column: 3
        }
      },
      "12": {
        start: {
          line: 58,
          column: 4
        },
        end: {
          line: 58,
          column: 16
        }
      },
      "13": {
        start: {
          line: 62,
          column: 2
        },
        end: {
          line: 64,
          column: 4
        }
      },
      "14": {
        start: {
          line: 66,
          column: 2
        },
        end: {
          line: 71,
          column: 3
        }
      },
      "15": {
        start: {
          line: 67,
          column: 4
        },
        end: {
          line: 70,
          column: 6
        }
      },
      "16": {
        start: {
          line: 74,
          column: 2
        },
        end: {
          line: 97,
          column: 4
        }
      },
      "17": {
        start: {
          line: 77,
          column: 28
        },
        end: {
          line: 77,
          column: 48
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 23,
            column: 5
          },
          end: {
            line: 23,
            column: 6
          }
        },
        loc: {
          start: {
            line: 23,
            column: 42
          },
          end: {
            line: 98,
            column: 1
          }
        },
        line: 23
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 77,
            column: 22
          },
          end: {
            line: 77,
            column: 23
          }
        },
        loc: {
          start: {
            line: 77,
            column: 28
          },
          end: {
            line: 77,
            column: 48
          }
        },
        line: 77
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 33,
            column: 20
          },
          end: {
            line: 33,
            column: 69
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 33,
            column: 20
          },
          end: {
            line: 33,
            column: 36
          }
        }, {
          start: {
            line: 33,
            column: 40
          },
          end: {
            line: 33,
            column: 69
          }
        }],
        line: 33
      },
      "1": {
        loc: {
          start: {
            line: 38,
            column: 42
          },
          end: {
            line: 40,
            column: 15
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 39,
            column: 6
          },
          end: {
            line: 39,
            column: 81
          }
        }, {
          start: {
            line: 40,
            column: 6
          },
          end: {
            line: 40,
            column: 15
          }
        }],
        line: 38
      },
      "2": {
        loc: {
          start: {
            line: 41,
            column: 41
          },
          end: {
            line: 41,
            column: 98
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 41,
            column: 55
          },
          end: {
            line: 41,
            column: 90
          }
        }, {
          start: {
            line: 41,
            column: 93
          },
          end: {
            line: 41,
            column: 98
          }
        }],
        line: 41
      },
      "3": {
        loc: {
          start: {
            line: 47,
            column: 19
          },
          end: {
            line: 49,
            column: 11
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 48,
            column: 6
          },
          end: {
            line: 48,
            column: 57
          }
        }, {
          start: {
            line: 49,
            column: 6
          },
          end: {
            line: 49,
            column: 11
          }
        }],
        line: 47
      },
      "4": {
        loc: {
          start: {
            line: 55,
            column: 4
          },
          end: {
            line: 55,
            column: 51
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 55,
            column: 4
          },
          end: {
            line: 55,
            column: 26
          }
        }, {
          start: {
            line: 55,
            column: 30
          },
          end: {
            line: 55,
            column: 38
          }
        }, {
          start: {
            line: 55,
            column: 42
          },
          end: {
            line: 55,
            column: 51
          }
        }],
        line: 55
      },
      "5": {
        loc: {
          start: {
            line: 57,
            column: 2
          },
          end: {
            line: 59,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 57,
            column: 2
          },
          end: {
            line: 59,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 57
      },
      "6": {
        loc: {
          start: {
            line: 66,
            column: 2
          },
          end: {
            line: 71,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 66,
            column: 2
          },
          end: {
            line: 71,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 66
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0],
      "5": [0, 0],
      "6": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "aec3420ee9fc8dd29618f71ba46ffcdf4c9c6baa"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_bylmr23c3 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_bylmr23c3();
function ThemeOverrideExpiredBanner_slicedToArray(arr, i) { return ThemeOverrideExpiredBanner_arrayWithHoles(arr) || ThemeOverrideExpiredBanner_iterableToArrayLimit(arr, i) || ThemeOverrideExpiredBanner_unsupportedIterableToArray(arr, i) || ThemeOverrideExpiredBanner_nonIterableRest(); }
function ThemeOverrideExpiredBanner_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function ThemeOverrideExpiredBanner_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return ThemeOverrideExpiredBanner_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ThemeOverrideExpiredBanner_arrayLikeToArray(o, minLen); }
function ThemeOverrideExpiredBanner_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }







function ThemeOverrideExpiredBanner_iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }


function ThemeOverrideExpiredBanner_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }









var LAST_SEEN_THEME_OVERRIDE_EXPIRATION_BANNER_KEY = (cov_bylmr23c3().s[0]++, 'last-seen-expired_theme_overrides-banner');
var THEME_EXPERIMENT_SLA = (cov_bylmr23c3().s[1]++, 60); // days

/**
 * Theme overrides should only be done while experimenting with new themes. Once a theme is
 * finalized, it should be added to the theme map before hte specified expiration date.
 *
 * Contact @corexp-eng with any further questions
 */
cov_bylmr23c3().s[2]++;
var ThemeOverrideExpiredBanner = function ThemeOverrideExpiredBanner(_ref) {
  var baseTheme = _ref.baseTheme,
    launchDateString = _ref.launchDateString;
  cov_bylmr23c3().f[0]++;
  var today = (cov_bylmr23c3().s[3]++, moment());
  var isServerSideRendered = (cov_bylmr23c3().s[4]++, typeof window === 'undefined');

  /**
   * In order to reduce the number of theme overrides, we should only allow theme overrides to be valid for a defined period of time. Teams should work with @corexp-eng to integrate their design sysetm learnings into the latest theme before the expiration date.
   *
   * NOTE: This only triggers on devs/staging environments
   */
  var expirationDate = (cov_bylmr23c3().s[5]++, moment(launchDateString).add(THEME_EXPERIMENT_SLA, 'days'));
  var isExpired = (cov_bylmr23c3().s[6]++, (cov_bylmr23c3().b[0][0]++, launchDateString) && (cov_bylmr23c3().b[0][1]++, today.isAfter(expirationDate)));
  /**
   * Determines whether or not the engineer has seen this warning banner in the last 7 days
   * Conditional so cosmos doesn't try to access window in SSR
   */
  var lastSeenStr = (cov_bylmr23c3().s[7]++, !isServerSideRendered ? (cov_bylmr23c3().b[1][0]++, window.localStorage.getItem(LAST_SEEN_THEME_OVERRIDE_EXPIRATION_BANNER_KEY)) : (cov_bylmr23c3().b[1][1]++, undefined));
  var hasSeenBannerRecently = (cov_bylmr23c3().s[8]++, lastSeenStr ? (cov_bylmr23c3().b[2][0]++, today.diff(moment(lastSeenStr)) < 7) : (cov_bylmr23c3().b[2][1]++, false));

  /**
   * NOTE: Can't just use RAILS_ENV since it returns 'staging' when using the staging DB
   * Conditional so cosmos doesn't try to access window in SSR
   */
  var inDevEnv = (cov_bylmr23c3().s[9]++, !isServerSideRendered ? (cov_bylmr23c3().b[3][0]++, window.location.href.startsWith('http://localhost')) : (cov_bylmr23c3().b[3][1]++, false));

  /**
   * Only show banner if engineer hasn't seen it in the last week AND not in prod/test environments
   */
  var _ref2 = (cov_bylmr23c3().s[10]++, react.useState((cov_bylmr23c3().b[4][0]++, !hasSeenBannerRecently) && (cov_bylmr23c3().b[4][1]++, inDevEnv) && (cov_bylmr23c3().b[4][2]++, isExpired))),
    _ref3 = ThemeOverrideExpiredBanner_slicedToArray(_ref2, 2),
    showBanner = _ref3[0],
    setShowBanner = _ref3[1];
  cov_bylmr23c3().s[11]++;
  if (!showBanner) {
    cov_bylmr23c3().b[5][0]++;
    cov_bylmr23c3().s[12]++;
    return null;
  } else {
    cov_bylmr23c3().b[5][1]++;
  }

  // eslint-disable-next-line no-console
  cov_bylmr23c3().s[13]++;
  console.error("The current theme experiment applied onto ".concat(baseTheme, " has expired. CPLAT will begin to deprecate this custom theme."));
  cov_bylmr23c3().s[14]++;
  if (!isServerSideRendered) {
    cov_bylmr23c3().b[6][0]++;
    cov_bylmr23c3().s[15]++;
    window.localStorage.setItem(LAST_SEEN_THEME_OVERRIDE_EXPIRATION_BANNER_KEY, moment.now().toString());
  } else {
    cov_bylmr23c3().b[6][1]++;
  }

  // eslint-disable-next-line react/display-name
  cov_bylmr23c3().s[16]++;
  return /*#__PURE__*/react.createElement(ContextSheet, {
    isOpen: showBanner,
    onRequestClose: function onRequestClose() {
      cov_bylmr23c3().f[1]++;
      cov_bylmr23c3().s[17]++;
      return setShowBanner(false);
    },
    analyticsName: "bricks-theme-override",
    "data-testid": "bricks-theme-override",
    "aria-label": null
  }, /*#__PURE__*/react.createElement(Box_Box/* default */.Z, {
    analyticsName: "bricks-theme-override",
    "data-testid": "bricks-theme-override"
  }, /*#__PURE__*/react.createElement(Box_Box/* default */.Z, {
    fontWeight: "bold"
  }, "\u26A0\uFE0F The current theme experiment applied onto ", baseTheme, " expired", ' ', expirationDate.fromNow(), ". CPLAT will soon begin to deprecate this custom theme."), /*#__PURE__*/react.createElement(Text/* default */.Z, null, "Please work with your team to migrate onto the latest theme which would allow you to move onto the latest design system iteration. Contact", ' ', /*#__PURE__*/react.createElement(Text/* default */.Z, {
    fontWeight: "bold",
    as: "span"
  }, "@corexp-eng"), ' ', "if you have any questions.")));
};

/***/ }),

/***/ 64863:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AV": function() { return /* binding */ breakpoints; },
/* harmony export */   "BC": function() { return /* binding */ media; },
/* harmony export */   "lU": function() { return /* binding */ BREAKPOINTS_DICT; }
/* harmony export */ });
function cov_2069i7ssyt() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/eero/foundations/breakpoints.ts";
  var hash = "5ff5aaf2498c43ed40f5b3015ab4425d530d2cb5";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/eero/foundations/breakpoints.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 32
        },
        end: {
          line: 12,
          column: 1
        }
      },
      "1": {
        start: {
          line: 14,
          column: 27
        },
        end: {
          line: 20,
          column: 1
        }
      },
      "2": {
        start: {
          line: 22,
          column: 21
        },
        end: {
          line: 35,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "5ff5aaf2498c43ed40f5b3015ab4425d530d2cb5"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2069i7ssyt = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2069i7ssyt();
/**
 * Breakpoints designated by most common device usage
 * https://www.figma.com/file/w3nEyANoniTZdjz8kCUaDS/Bricks-Design-System?node-id=6881%3A17688&t=4QS53fgl4nBJp4hQ-0
 */

var BREAKPOINTS_DICT = (cov_2069i7ssyt().s[0]++, {
  XS: 0,
  // 0-374 - XS
  SM: 375,
  // 375-767 - S
  MD: 768,
  //768-1200 - M
  LG: 1201,
  // 1201 - 1399 - L
  XL: 1440 // 1440+ XL
});
var breakpoints = (cov_2069i7ssyt().s[1]++, [BREAKPOINTS_DICT.XS,
// 0-374 - XS
BREAKPOINTS_DICT.SM,
// 375-767 - S
BREAKPOINTS_DICT.MD,
//768-1200 - M
BREAKPOINTS_DICT.LG,
// 1201 - 1399 - L
BREAKPOINTS_DICT.XL // 1440+ XL
]);
var media = (cov_2069i7ssyt().s[2]++, {
  largerThan: {
    XS: "@media (min-width: ".concat(BREAKPOINTS_DICT.SM, "px)"),
    SM: "@media (min-width: ".concat(BREAKPOINTS_DICT.MD, "px)"),
    MD: "@media (min-width: ".concat(BREAKPOINTS_DICT.LG, "px)"),
    LG: "@media (min-width: ".concat(BREAKPOINTS_DICT.XL, "px)")
  },
  smallerThan: {
    SM: "@media (max-width: ".concat(BREAKPOINTS_DICT.SM - 1, "px)"),
    MD: "@media (max-width: ".concat(BREAKPOINTS_DICT.MD - 1, "px)"),
    LG: "@media (max-width: ".concat(BREAKPOINTS_DICT.LG - 1, "px)"),
    XL: "@media (max-width: ".concat(BREAKPOINTS_DICT.XL - 1, "px)")
  }
});

/***/ }),

/***/ 81762:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O9": function() { return /* binding */ colors; }
/* harmony export */ });
/* unused harmony export ColorSchemeKeys */
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47941);
function cov_1nom9xj7dw() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/eero/foundations/colors.ts";
  var hash = "4fa52d0d575d99cbf9a1396e9fc1d6a08867737e";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/eero/foundations/colors.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 62
        },
        end: {
          line: 21,
          column: 1
        }
      },
      "1": {
        start: {
          line: 23,
          column: 31
        },
        end: {
          line: 23,
          column: 50
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "4fa52d0d575d99cbf9a1396e9fc1d6a08867737e"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1nom9xj7dw = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1nom9xj7dw();

var colors = (cov_1nom9xj7dw().s[0]++, {
  brand50: '#0D76D6',
  brand40: '#3E8DD8',
  brand30: '#49A3E0',
  neutrals100: '#222222',
  neutrals90: '#6E6E6E',
  neutrals70: '#949494',
  neutrals40: '#DEDEDE',
  neutrals30: '#E9E9E9',
  neutrals20: '#F2F2F2',
  neutrals10: '#FAFAFA',
  neutrals0: '#FFFFFF',
  red50: '#C34143',
  green50: '#007F5E',
  terracotta50: '#FF896F',
  blue30: '#EEF4FA',
  transparent: 'transparent',
  currentColor: 'currentColor'
});
var ColorSchemeKeys = (cov_1nom9xj7dw().s[1]++, Object.keys(colors));
/* harmony default export */ __webpack_exports__["ZP"] = (colors);

/***/ }),

/***/ 2324:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NR": function() { return /* binding */ fontSizesNamedWithUnits; },
/* harmony export */   "Vu": function() { return /* binding */ fontSizesWithUnits; },
/* harmony export */   "gj": function() { return /* binding */ fontSizesNamed; }
/* harmony export */ });
/* harmony import */ var _helpers_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73173);
function cov_13pcomb2jx() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/eero/foundations/fontSizes.ts";
  var hash = "965aad2b1beaf57cb78c2049df96ae1855f149fb";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/eero/foundations/fontSizes.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 91
        },
        end: {
          line: 52,
          column: 1
        }
      },
      "1": {
        start: {
          line: 56,
          column: 4
        },
        end: {
          line: 56,
          column: 39
        }
      },
      "2": {
        start: {
          line: 58,
          column: 39
        },
        end: {
          line: 58,
          column: 57
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "965aad2b1beaf57cb78c2049df96ae1855f149fb"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_13pcomb2jx = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_13pcomb2jx();
/* eslint-disable import/no-deprecated */


var fontSizesNamed = (cov_13pcomb2jx().s[0]++, {
  '11px': 11,
  '12px': 12,
  '14px': 14,
  '16px': 16,
  '18px': 18,
  '20px': 20,
  '22px': 22,
  '24px': 24,
  '28px': 28,
  '32px': 32,
  '36px': 36,
  '40px': 40,
  '44px': 44,
  '48px': 48,
  '56px': 56,
  '64px': 64,
  '80px': 80,
  '88px': 88,
  '96px': 96,
  /**  @deprecated  */
  s8: 98,
  /**  @deprecated  */
  s7: 80,
  /**  @deprecated  */
  s6: 56,
  /**  @deprecated  */
  s5: 42,
  /**  @deprecated  */
  s4: 32,
  /**  @deprecated  */
  s3: 24,
  /**  @deprecated  */
  s2: 19,
  /**  @deprecated  */
  s1: 16,
  /**  @deprecated  */
  s0: 14,
  /**  @deprecated  */
  s00: 12,
  /**  @deprecated  */
  s000: 10,
  /**  @deprecated  */
  UNSAFE_h2: 36,
  /**  @deprecated  */
  UNSAFE_h1Mobile: 36
});
var fontSizesWithUnits = (cov_13pcomb2jx().s[1]++, (0,_helpers_mjs__WEBPACK_IMPORTED_MODULE_0__/* .numbersObjWithUnits */ .hX)(fontSizesNamed));
var fontSizesNamedWithUnits = (cov_13pcomb2jx().s[2]++, fontSizesWithUnits);

/***/ }),

/***/ 53174:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ fontWeights; }
/* harmony export */ });
function cov_1cmhk6j59a() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/eero/foundations/fontWeights.ts";
  var hash = "2c0ecb56f6b6199775ad66a4c98b4b898c206671";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/eero/foundations/fontWeights.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 60
        },
        end: {
          line: 13,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "2c0ecb56f6b6199775ad66a4c98b4b898c206671"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1cmhk6j59a = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1cmhk6j59a();
var fontWeights = (cov_1cmhk6j59a().s[0]++, {
  regular: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
  /**  @deprecated  */
  normal: 400,
  /**  @deprecated  */
  bolder: 800
});

/***/ }),

/***/ 82383:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ fonts; }
/* harmony export */ });
function cov_sgz80vlek() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/eero/foundations/fonts.ts";
  var hash = "8bc472bf1f6903542978f30e4bce243cb374a374";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/eero/foundations/fonts.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 48
        },
        end: {
          line: 7,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "8bc472bf1f6903542978f30e4bce243cb374a374"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_sgz80vlek = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_sgz80vlek();
var fonts = (cov_sgz80vlek().s[0]++, {
  mono: 'Noto-Mono, monospace',
  sans: 'Graphik, system-ui, sans-serif',
  serif: 'Publico, serif'
});

/***/ }),

/***/ 91620:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ lineHeightsWithUnits; },
/* harmony export */   "t": function() { return /* binding */ lineHeights; }
/* harmony export */ });
function cov_q1gwpw15m() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/eero/foundations/lineHeights.ts";
  var hash = "1d9b15692775b796cecc136d5e1434330bcec0f4";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/eero/foundations/lineHeights.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 83
        },
        end: {
          line: 43,
          column: 1
        }
      },
      "1": {
        start: {
          line: 45,
          column: 36
        },
        end: {
          line: 45,
          column: 47
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "1d9b15692775b796cecc136d5e1434330bcec0f4"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_q1gwpw15m = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_q1gwpw15m();
var lineHeights = (cov_q1gwpw15m().s[0]++, {
  '160': '160%',
  '150': '150%',
  '140': '140%',
  '130': '130%',
  '120': '120%',
  '112': '112%',
  '110': '110%',
  '100': '100%',
  /**  @deprecated  */
  s8: '136px',
  /**  @deprecated  */
  s7: '96px',
  /**  @deprecated  */
  s6: '64px',
  /**  @deprecated  */
  s5: '56px',
  /**  @deprecated  */
  s4: '36px',
  /**  @deprecated  */
  s3: '32px',
  /**  @deprecated  */
  s2: '28px',
  /**  @deprecated  */
  s1: '26px',
  /**  @deprecated  */
  s0: '24px',
  /**  @deprecated  */
  s00: '22px',
  /**  @deprecated  */
  s000: '16px',
  /**  @deprecated  */
  bodyTighter: '1.45',
  /**  @deprecated  */
  heading: '1.45',
  /**  @deprecated  */
  mobileHeader: '1.35',
  /**  @deprecated  */
  header: '1.45'
});
var lineHeightsWithUnits = (cov_q1gwpw15m().s[1]++, lineHeights);

/***/ }),

/***/ 79848:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__) {

"use strict";
function cov_208v4a4ao0() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/eero/foundations/radii.ts";
  var hash = "d2c251ba944a867ca99307af50457adef80c1c75";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/eero/foundations/radii.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 42
        },
        end: {
          line: 12,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "d2c251ba944a867ca99307af50457adef80c1c75"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_208v4a4ao0 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_208v4a4ao0();
var radii = (cov_208v4a4ao0().s[0]++, {
  none: '0',
  squared: '4px',
  roundedSquare: '8px',
  semiRounded: '16px',
  roundedSmooth: '24px',
  full: '9999px',
  /** @deprecated use "full" instead */
  rounded: '9999px'
});
/* harmony default export */ __webpack_exports__["Z"] = (radii);

/***/ }),

/***/ 99425:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ space; },
/* harmony export */   "u": function() { return /* binding */ spaceWithUnits; }
/* harmony export */ });
/* harmony import */ var _helpers_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73173);
function cov_28cec5gp0z() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/eero/foundations/space.ts";
  var hash = "e9d0214beb00a5d32e7a192b2e1070a79d72fc76";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/eero/foundations/space.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 21
        },
        end: {
          line: 17,
          column: 1
        }
      },
      "1": {
        start: {
          line: 19,
          column: 30
        },
        end: {
          line: 19,
          column: 56
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "e9d0214beb00a5d32e7a192b2e1070a79d72fc76"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_28cec5gp0z = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_28cec5gp0z();

var space = (cov_28cec5gp0z().s[0]++, [0,
// 0
2,
// 1
4,
// 2
8,
// 3
12,
// 4
16,
// 5
20,
// 6
24,
// 7
32,
// 8
40,
// 9
48,
// 10
64,
// 11
128 // 12
]);
var spaceWithUnits = (cov_28cec5gp0z().s[1]++, (0,_helpers_mjs__WEBPACK_IMPORTED_MODULE_0__/* .numbersArrWithUnits */ .U3)(space));

/***/ }),

/***/ 73173:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U3": function() { return /* binding */ numbersArrWithUnits; },
/* harmony export */   "YX": function() { return /* binding */ svgToStyledDataURI; },
/* harmony export */   "hX": function() { return /* binding */ numbersObjWithUnits; }
/* harmony export */ });
/* unused harmony export addUnitsToNumber */
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89554);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21249);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47941);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74916);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15306);
/* harmony import */ var core_js_modules_es_string_replace_all_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68757);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(54747);
/* harmony import */ var mini_svg_data_uri__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(42555);
function cov_1qq1ded45f() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/helpers.ts";
  var hash = "d55aaa5e891d3161cb675ce1725ab6b110785da7";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/helpers.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 32
        },
        end: {
          line: 4,
          column: 47
        }
      },
      "1": {
        start: {
          line: 4,
          column: 2
        },
        end: {
          line: 4,
          column: 47
        }
      },
      "2": {
        start: {
          line: 6,
          column: 35
        },
        end: {
          line: 7,
          column: 27
        }
      },
      "3": {
        start: {
          line: 7,
          column: 2
        },
        end: {
          line: 7,
          column: 27
        }
      },
      "4": {
        start: {
          line: 9,
          column: 35
        },
        end: {
          line: 14,
          column: 1
        }
      },
      "5": {
        start: {
          line: 10,
          column: 2
        },
        end: {
          line: 12,
          column: 5
        }
      },
      "6": {
        start: {
          line: 11,
          column: 4
        },
        end: {
          line: 11,
          column: 42
        }
      },
      "7": {
        start: {
          line: 13,
          column: 2
        },
        end: {
          line: 13,
          column: 13
        }
      },
      "8": {
        start: {
          line: 23,
          column: 34
        },
        end: {
          line: 35,
          column: 1
        }
      },
      "9": {
        start: {
          line: 24,
          column: 2
        },
        end: {
          line: 26,
          column: 3
        }
      },
      "10": {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 25,
          column: 37
        }
      },
      "11": {
        start: {
          line: 28,
          column: 18
        },
        end: {
          line: 28,
          column: 25
        }
      },
      "12": {
        start: {
          line: 29,
          column: 2
        },
        end: {
          line: 31,
          column: 3
        }
      },
      "13": {
        start: {
          line: 30,
          column: 4
        },
        end: {
          line: 30,
          column: 87
        }
      },
      "14": {
        start: {
          line: 34,
          column: 2
        },
        end: {
          line: 34,
          column: 37
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 3,
            column: 32
          },
          end: {
            line: 3,
            column: 33
          }
        },
        loc: {
          start: {
            line: 4,
            column: 2
          },
          end: {
            line: 4,
            column: 47
          }
        },
        line: 4
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 6,
            column: 35
          },
          end: {
            line: 6,
            column: 36
          }
        },
        loc: {
          start: {
            line: 7,
            column: 2
          },
          end: {
            line: 7,
            column: 27
          }
        },
        line: 7
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 9,
            column: 35
          },
          end: {
            line: 9,
            column: 36
          }
        },
        loc: {
          start: {
            line: 9,
            column: 44
          },
          end: {
            line: 14,
            column: 1
          }
        },
        line: 9
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 10,
            column: 27
          },
          end: {
            line: 10,
            column: 28
          }
        },
        loc: {
          start: {
            line: 10,
            column: 36
          },
          end: {
            line: 12,
            column: 3
          }
        },
        line: 10
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 23,
            column: 34
          },
          end: {
            line: 23,
            column: 35
          }
        },
        loc: {
          start: {
            line: 23,
            column: 84
          },
          end: {
            line: 35,
            column: 1
          }
        },
        line: 23
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 4,
            column: 2
          },
          end: {
            line: 4,
            column: 47
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 4,
            column: 29
          },
          end: {
            line: 4,
            column: 40
          }
        }, {
          start: {
            line: 4,
            column: 43
          },
          end: {
            line: 4,
            column: 47
          }
        }],
        line: 4
      },
      "1": {
        loc: {
          start: {
            line: 24,
            column: 2
          },
          end: {
            line: 26,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 24,
            column: 2
          },
          end: {
            line: 26,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 24
      },
      "2": {
        loc: {
          start: {
            line: 24,
            column: 6
          },
          end: {
            line: 24,
            column: 25
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 24,
            column: 6
          },
          end: {
            line: 24,
            column: 13
          }
        }, {
          start: {
            line: 24,
            column: 17
          },
          end: {
            line: 24,
            column: 25
          }
        }],
        line: 24
      },
      "3": {
        loc: {
          start: {
            line: 29,
            column: 2
          },
          end: {
            line: 31,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 29,
            column: 2
          },
          end: {
            line: 31,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 29
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "d55aaa5e891d3161cb675ce1725ab6b110785da7"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1qq1ded45f = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1qq1ded45f();









cov_1qq1ded45f().s[0]++;
var addUnitsToNumber = function addUnitsToNumber(item) {
  cov_1qq1ded45f().f[0]++;
  cov_1qq1ded45f().s[1]++;
  return typeof item === 'number' ? (cov_1qq1ded45f().b[0][0]++, "".concat(item, "px")) : (cov_1qq1ded45f().b[0][1]++, item);
};
cov_1qq1ded45f().s[2]++;
var numbersArrWithUnits = function numbersArrWithUnits(arr) {
  cov_1qq1ded45f().f[1]++;
  cov_1qq1ded45f().s[3]++;
  return arr.map(addUnitsToNumber);
};
cov_1qq1ded45f().s[4]++;
var numbersObjWithUnits = function numbersObjWithUnits(obj) {
  cov_1qq1ded45f().f[2]++;
  cov_1qq1ded45f().s[5]++;
  Object.keys(obj).forEach(function (key) {
    cov_1qq1ded45f().f[3]++;
    cov_1qq1ded45f().s[6]++;
    obj[key] = addUnitsToNumber(obj[key]);
  });
  cov_1qq1ded45f().s[7]++;
  return obj;
};

/**
 * Converts the string representation of an SVG into a data URI to be consumed for
 * list item types. Additionally allows for the color of the SVG to be changed.
 * Passing in a custom color will replace ALL the fill colors in the SVG.
 *
 * NOTE: We are intentionally allowing hex values for colors here since data URIs don't allow custom CSS variables
 */
cov_1qq1ded45f().s[8]++;
var svgToStyledDataURI = function svgToStyledDataURI(iconStr, styles) {
  cov_1qq1ded45f().f[4]++;
  cov_1qq1ded45f().s[9]++;
  if ((cov_1qq1ded45f().b[2][0]++, !styles) || (cov_1qq1ded45f().b[2][1]++, !iconStr)) {
    cov_1qq1ded45f().b[1][0]++;
    cov_1qq1ded45f().s[10]++;
    return mini_svg_data_uri__WEBPACK_IMPORTED_MODULE_8__(iconStr);
  } else {
    cov_1qq1ded45f().b[1][1]++;
  }
  var styledSvg = (cov_1qq1ded45f().s[11]++, iconStr);
  cov_1qq1ded45f().s[12]++;
  if (styles !== null && styles !== void 0 && styles.color) {
    cov_1qq1ded45f().b[3][0]++;
    cov_1qq1ded45f().s[13]++;
    styledSvg = styledSvg.replaceAll('fill="currentColor"', " fill=\"".concat(styles.color, "\""));
  } else {
    cov_1qq1ded45f().b[3][1]++;
  }

  // return styledSvg;
  cov_1qq1ded45f().s[14]++;
  return mini_svg_data_uri__WEBPACK_IMPORTED_MODULE_8__(styledSvg);
};

/***/ }),

/***/ 18617:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v": function() { return /* binding */ THEME_MAP; }
});

// UNUSED EXPORTS: eero, exclusives, legacy, novo

// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/theme/helpers.mjs
var helpers = __webpack_require__(73173);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__(32165);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(82526);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__(57327);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__(89554);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(41817);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.to-primitive.js
var es_symbol_to_primitive = __webpack_require__(96649);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(66992);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.define-properties.js
var es_object_define_properties = __webpack_require__(33321);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.define-property.js
var es_object_define_property = __webpack_require__(69070);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__(38880);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__(49337);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__(47941);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.date.to-primitive.js
var es_date_to_primitive = __webpack_require__(96078);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(78783);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__(54747);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__(9653);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(41539);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(33948);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/system/anatomy.types.mjs + 1 modules
var anatomy_types = __webpack_require__(30110);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/eero/components/card.mjs
function cov_2lobie7x93() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/eero/components/card.ts";
  var hash = "a48d5c1b6b403a0bfad472298b8de1ebf920f18b";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/eero/components/card.ts",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 54
        },
        end: {
          line: 8,
          column: 1
        }
      },
      "1": {
        start: {
          line: 10,
          column: 42
        },
        end: {
          line: 17,
          column: 1
        }
      },
      "2": {
        start: {
          line: 19,
          column: 51
        },
        end: {
          line: 30,
          column: 1
        }
      },
      "3": {
        start: {
          line: 32,
          column: 44
        },
        end: {
          line: 40,
          column: 1
        }
      },
      "4": {
        start: {
          line: 42,
          column: 53
        },
        end: {
          line: 53,
          column: 1
        }
      },
      "5": {
        start: {
          line: 55,
          column: 43
        },
        end: {
          line: 63,
          column: 1
        }
      },
      "6": {
        start: {
          line: 65,
          column: 52
        },
        end: {
          line: 76,
          column: 1
        }
      },
      "7": {
        start: {
          line: 78,
          column: 42
        },
        end: {
          line: 86,
          column: 1
        }
      },
      "8": {
        start: {
          line: 88,
          column: 69
        },
        end: {
          line: 93,
          column: 1
        }
      },
      "9": {
        start: {
          line: 96,
          column: 67
        },
        end: {
          line: 100,
          column: 1
        }
      },
      "10": {
        start: {
          line: 108,
          column: 30
        },
        end: {
          line: 116,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "a48d5c1b6b403a0bfad472298b8de1ebf920f18b"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2lobie7x93 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2lobie7x93();


















function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var sharedVariantStyles = (cov_2lobie7x93().s[0]++, {
  flexDirection: 'column',
  borderRadius: 'semiRounded',
  padding: [5, null, 8]
});
var primary = (cov_2lobie7x93().s[1]++, _objectSpread(_objectSpread({}, sharedVariantStyles), {}, {
  boxShadow: 'z2',
  _focus: {
    background: 'neutrals10',
    border: "1px solid var(--colors-neutrals90)"
  }
}));
var primaryClickable = (cov_2lobie7x93().s[2]++, {
  _hover: {
    background: 'neutrals10',
    boxShadow: 'z2',
    cursor: 'pointer'
  },
  _active: {
    background: 'neutrals10',
    boxShadow: 'z1',
    cursor: 'pointer'
  }
});
var secondary = (cov_2lobie7x93().s[3]++, _objectSpread(_objectSpread({}, sharedVariantStyles), {}, {
  boxShadow: 'z1',
  _focus: {
    background: 'neutrals10',
    boxShadow: 'z2',
    border: "1px solid var(--colors-neutrals90)"
  }
}));
var secondaryClickable = (cov_2lobie7x93().s[4]++, {
  _hover: {
    background: 'neutrals10',
    boxShadow: 'z2',
    cursor: 'pointer'
  },
  _active: {
    background: 'neutrals10',
    boxShadow: 'z1',
    cursor: 'pointer'
  }
});
var tertiary = (cov_2lobie7x93().s[5]++, _objectSpread(_objectSpread({}, sharedVariantStyles), {}, {
  background: 'neutrals10',
  border: "1px solid var(--colors-neutrals20)",
  _focus: {
    background: 'neutrals20',
    border: "1px solid var(--colors-neutrals70)"
  }
}));
var tertiaryClickable = (cov_2lobie7x93().s[6]++, {
  _hover: {
    background: 'neutrals20',
    border: "1px solid var(--colors-neutrals30)",
    cursor: 'pointer'
  },
  _active: {
    background: 'neutrals30',
    border: "1px solid var(--colors-neutrals30)",
    cursor: 'pointer'
  }
});
var outline = (cov_2lobie7x93().s[7]++, _objectSpread(_objectSpread({}, sharedVariantStyles), {}, {
  background: 'neutrals0',
  border: "1px solid var(--colors-neutrals40)",
  _focus: {
    background: 'neutrals10',
    border: "1px solid var(--colors-neutrals90)"
  }
}));
var variants = (cov_2lobie7x93().s[8]++, {
  primary: primary,
  secondary: secondary,
  tertiary: tertiary,
  outline: outline
});

/** @deprecated This is not a11y compliant */
var clickables = (cov_2lobie7x93().s[9]++, {
  primary: primaryClickable,
  secondary: secondaryClickable,
  tertiary: tertiaryClickable
});
var card = (cov_2lobie7x93().s[10]++, {
  baseStyle: {
    width: '100%',
    backgroundColor: 'neutrals0'
  },
  variants: variants,
  /** @deprecated This is not a11y compliant */
  clickables: clickables
});
/* harmony default export */ var components_card = (card);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/eero/components/cardListItem.mjs
function cov_1mdeaiefik() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/eero/components/cardListItem.ts";
  var hash = "ed73fc4423a83122f74fefec675f8246d47b2bc8";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/eero/components/cardListItem.ts",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 48
        },
        end: {
          line: 22,
          column: 1
        }
      },
      "1": {
        start: {
          line: 24,
          column: 57
        },
        end: {
          line: 26,
          column: 1
        }
      },
      "2": {
        start: {
          line: 28,
          column: 59
        },
        end: {
          line: 44,
          column: 1
        }
      },
      "3": {
        start: {
          line: 48,
          column: 4
        },
        end: {
          line: 51,
          column: 1
        }
      },
      "4": {
        start: {
          line: 57,
          column: 38
        },
        end: {
          line: 86,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "ed73fc4423a83122f74fefec675f8246d47b2bc8"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1mdeaiefik = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1mdeaiefik();
function cardListItem_typeof(o) { "@babel/helpers - typeof"; return cardListItem_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, cardListItem_typeof(o); }


















function cardListItem_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function cardListItem_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? cardListItem_ownKeys(Object(t), !0).forEach(function (r) { cardListItem_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : cardListItem_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function cardListItem_defineProperty(obj, key, value) { key = cardListItem_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function cardListItem_toPropertyKey(t) { var i = cardListItem_toPrimitive(t, "string"); return "symbol" == cardListItem_typeof(i) ? i : String(i); }
function cardListItem_toPrimitive(t, r) { if ("object" != cardListItem_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != cardListItem_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


var baseLinkStyle = (cov_1mdeaiefik().s[0]++, {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  listStyleType: 'none',
  boxSizing: 'border-box',
  borderRadius: 'semiRounded',
  cursor: 'pointer',
  fontWeight: 'semibold',
  lineHeight: 1,
  padding: 6
});
var cardListItem_primary = (cov_1mdeaiefik().s[1]++, {
  listItem: cardListItem_objectSpread(cardListItem_objectSpread({}, components_card.variants.primary), baseLinkStyle)
});
var cardListItem_secondary = (cov_1mdeaiefik().s[2]++, {
  listItem: cardListItem_objectSpread(cardListItem_objectSpread(cardListItem_objectSpread({}, components_card.variants.secondary), baseLinkStyle), {}, {
    boxShadow: 'none',
    background: 'neutrals10',
    border: "1px solid var(--colors-neutrals30)",
    _hover: {
      background: 'neutrals20',
      border: "1px solid var(--colors-neutrals30)"
    },
    _active: {
      background: 'neutrals30',
      border: "1px solid var(--colors-neutrals30)"
    }
  })
});
var cardListItem_variants = (cov_1mdeaiefik().s[3]++, {
  primary: cardListItem_primary,
  secondary: cardListItem_secondary
});
var cardList = (cov_1mdeaiefik().s[4]++, {
  parts: anatomy_types/* cardListItemAnatomy.keys */.F7.keys,
  baseStyle: {
    listItem: cardListItem_objectSpread(cardListItem_objectSpread({}, components_card.baseStyle), baseLinkStyle),
    content: {
      lineHeight: 1,
      alignItems: 'center',
      width: '100%',
      height: '100%'
    },
    accessoryIconContainer: {
      mr: 3,
      lineHeight: 0
    },
    accessoryIcon: {
      color: 'neutrals100'
    },
    accessoryImage: {
      height: '40px',
      mr: 4
    }
  },
  defaultProps: {
    variant: 'primary'
  },
  variants: cardListItem_variants
});
/* harmony default export */ var cardListItem = (cardList);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/eero/components/accordionListItem.mjs
function cov_2ftasb1r9a() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/eero/components/accordionListItem.ts";
  var hash = "fba8fb28a19678705a468fb3c2d301965b600e00";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/eero/components/accordionListItem.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 64
        },
        end: {
          line: 85,
          column: 2
        }
      },
      "1": {
        start: {
          line: 14,
          column: 7
        },
        end: {
          line: 85,
          column: 1
        }
      },
      "2": {
        start: {
          line: 87,
          column: 62
        },
        end: {
          line: 87,
          column: 71
        }
      },
      "3": {
        start: {
          line: 89,
          column: 64
        },
        end: {
          line: 104,
          column: 2
        }
      },
      "4": {
        start: {
          line: 89,
          column: 98
        },
        end: {
          line: 104,
          column: 1
        }
      },
      "5": {
        start: {
          line: 108,
          column: 4
        },
        end: {
          line: 111,
          column: 1
        }
      },
      "6": {
        start: {
          line: 120,
          column: 52
        },
        end: {
          line: 125,
          column: 1
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 64
          },
          end: {
            line: 6,
            column: 65
          }
        },
        loc: {
          start: {
            line: 14,
            column: 7
          },
          end: {
            line: 85,
            column: 1
          }
        },
        line: 14
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 89,
            column: 64
          },
          end: {
            line: 89,
            column: 65
          }
        },
        loc: {
          start: {
            line: 89,
            column: 98
          },
          end: {
            line: 104,
            column: 1
          }
        },
        line: 89
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 25,
            column: 15
          },
          end: {
            line: 25,
            column: 32
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 25,
            column: 15
          },
          end: {
            line: 25,
            column: 24
          }
        }, {
          start: {
            line: 25,
            column: 28
          },
          end: {
            line: 25,
            column: 32
          }
        }],
        line: 25
      },
      "1": {
        loc: {
          start: {
            line: 31,
            column: 17
          },
          end: {
            line: 31,
            column: 34
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 31,
            column: 17
          },
          end: {
            line: 31,
            column: 26
          }
        }, {
          start: {
            line: 31,
            column: 30
          },
          end: {
            line: 31,
            column: 34
          }
        }],
        line: 31
      },
      "2": {
        loc: {
          start: {
            line: 34,
            column: 17
          },
          end: {
            line: 34,
            column: 34
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 34,
            column: 17
          },
          end: {
            line: 34,
            column: 26
          }
        }, {
          start: {
            line: 34,
            column: 30
          },
          end: {
            line: 34,
            column: 34
          }
        }],
        line: 34
      },
      "3": {
        loc: {
          start: {
            line: 43,
            column: 20
          },
          end: {
            line: 43,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 43,
            column: 20
          },
          end: {
            line: 43,
            column: 34
          }
        }, {
          start: {
            line: 43,
            column: 38
          },
          end: {
            line: 43,
            column: 53
          }
        }],
        line: 43
      },
      "4": {
        loc: {
          start: {
            line: 62,
            column: 15
          },
          end: {
            line: 62,
            column: 52
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 62,
            column: 24
          },
          end: {
            line: 62,
            column: 40
          }
        }, {
          start: {
            line: 62,
            column: 43
          },
          end: {
            line: 62,
            column: 52
          }
        }],
        line: 62
      },
      "5": {
        loc: {
          start: {
            line: 64,
            column: 20
          },
          end: {
            line: 64,
            column: 48
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 64,
            column: 20
          },
          end: {
            line: 64,
            column: 34
          }
        }, {
          start: {
            line: 64,
            column: 38
          },
          end: {
            line: 64,
            column: 48
          }
        }],
        line: 64
      },
      "6": {
        loc: {
          start: {
            line: 69,
            column: 15
          },
          end: {
            line: 69,
            column: 48
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 69,
            column: 24
          },
          end: {
            line: 69,
            column: 44
          }
        }, {
          start: {
            line: 69,
            column: 47
          },
          end: {
            line: 69,
            column: 48
          }
        }],
        line: 69
      },
      "7": {
        loc: {
          start: {
            line: 69,
            column: 24
          },
          end: {
            line: 69,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 69,
            column: 24
          },
          end: {
            line: 69,
            column: 33
          }
        }, {
          start: {
            line: 69,
            column: 37
          },
          end: {
            line: 69,
            column: 44
          }
        }],
        line: 69
      },
      "8": {
        loc: {
          start: {
            line: 70,
            column: 8
          },
          end: {
            line: 70,
            column: 22
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 70,
            column: 17
          },
          end: {
            line: 70,
            column: 18
          }
        }, {
          start: {
            line: 70,
            column: 21
          },
          end: {
            line: 70,
            column: 22
          }
        }],
        line: 70
      },
      "9": {
        loc: {
          start: {
            line: 72,
            column: 13
          },
          end: {
            line: 72,
            column: 27
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 72,
            column: 22
          },
          end: {
            line: 72,
            column: 23
          }
        }, {
          start: {
            line: 72,
            column: 26
          },
          end: {
            line: 72,
            column: 27
          }
        }],
        line: 72
      },
      "10": {
        loc: {
          start: {
            line: 95,
            column: 18
          },
          end: {
            line: 95,
            column: 78
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 95,
            column: 33
          },
          end: {
            line: 95,
            column: 69
          }
        }, {
          start: {
            line: 95,
            column: 72
          },
          end: {
            line: 95,
            column: 78
          }
        }],
        line: 95
      },
      "11": {
        loc: {
          start: {
            line: 101,
            column: 14
          },
          end: {
            line: 101,
            column: 72
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 101,
            column: 26
          },
          end: {
            line: 101,
            column: 63
          }
        }, {
          start: {
            line: 101,
            column: 66
          },
          end: {
            line: 101,
            column: 72
          }
        }],
        line: 101
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "fba8fb28a19678705a468fb3c2d301965b600e00"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2ftasb1r9a = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2ftasb1r9a();
function accordionListItem_typeof(o) { "@babel/helpers - typeof"; return accordionListItem_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, accordionListItem_typeof(o); }


















function accordionListItem_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function accordionListItem_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? accordionListItem_ownKeys(Object(t), !0).forEach(function (r) { accordionListItem_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : accordionListItem_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function accordionListItem_defineProperty(obj, key, value) { key = accordionListItem_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function accordionListItem_toPropertyKey(t) { var i = accordionListItem_toPrimitive(t, "string"); return "symbol" == accordionListItem_typeof(i) ? i : String(i); }
function accordionListItem_toPrimitive(t, r) { if ("object" != accordionListItem_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != accordionListItem_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


cov_2ftasb1r9a().s[0]++;
var baseStyle = function baseStyle(_ref) {
  var _ref2, _ref3, _ref4, _ref5, _ref6, _ref7;
  var padding = _ref.padding,
    paddingInline = _ref.paddingInline,
    justifyContent = _ref.justifyContent,
    isOpen = _ref.isOpen,
    whiteSpace = _ref.whiteSpace,
    maxHeight = _ref.maxHeight,
    boxShadow = _ref.boxShadow;
  cov_2ftasb1r9a().f[0]++;
  cov_2ftasb1r9a().s[1]++;
  return accordionListItem_objectSpread(accordionListItem_objectSpread({}, cardListItem.variants.primary), {}, {
    listItem: accordionListItem_objectSpread(accordionListItem_objectSpread({}, cardListItem.variants.primary.listItem), {}, {
      background: 'neutrals0',
      borderRadius: 'semiRounded',
      flexDirection: 'column',
      alignItems: 'flex-start',
      padding: padding,
      paddingInline: paddingInline,
      border: '2px solid transparent',
      boxShadow: (_ref2 = (cov_2ftasb1r9a().b[0][0]++, boxShadow)) !== null && _ref2 !== void 0 ? _ref2 : (cov_2ftasb1r9a().b[0][1]++, 'z1'),
      // Add styling to accordion when it is focused on to make website accessable to keyboard only users. More info on focus-within below
      // https://developer.mozilla.org/en-US/docs/Web/CSS/:focus-within
      _focusWithin: {
        border: '2px solid var(--colors-neutrals100)',
        borderRadius: 'semiRounded',
        boxShadow: (_ref3 = (cov_2ftasb1r9a().b[1][0]++, boxShadow)) !== null && _ref3 !== void 0 ? _ref3 : (cov_2ftasb1r9a().b[1][1]++, 'z1')
      },
      __hover: {
        boxShadow: (_ref4 = (cov_2ftasb1r9a().b[2][0]++, boxShadow)) !== null && _ref4 !== void 0 ? _ref4 : (cov_2ftasb1r9a().b[2][1]++, 'z1')
      }
    }),
    button: {
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      outline: 0,
      width: '100%',
      justifyContent: (_ref5 = (cov_2ftasb1r9a().b[3][0]++, justifyContent)) !== null && _ref5 !== void 0 ? _ref5 : (cov_2ftasb1r9a().b[3][1]++, 'space-between'),
      textAlign: 'start',
      // {border: none and background: none} are originally defined in Primer.
      // Although bricks still depends on Primer in some ways, it should be decoupled.
      border: 'none',
      background: 'none'
    },
    title: {
      fontSize: 's1',
      lineHeight: 's1',
      color: 'neutrals100',
      fontWeight: 'semibold',
      whiteSpace: whiteSpace,
      textAlign: 'left'
    },
    iconContainer: {
      display: 'flex',
      mx: 3,
      alignItems: 'center',
      transform: isOpen ? (cov_2ftasb1r9a().b[4][0]++, 'rotate(180deg)') : (cov_2ftasb1r9a().b[4][1]++, undefined),
      transition: 'transform 0.2s',
      justifyContent: (_ref6 = (cov_2ftasb1r9a().b[5][0]++, justifyContent)) !== null && _ref6 !== void 0 ? _ref6 : (cov_2ftasb1r9a().b[5][1]++, 'flex-end'),
      transformOrigin: 'center'
    },
    panel: {
      height: 'auto',
      maxHeight: isOpen ? (cov_2ftasb1r9a().b[6][0]++, (_ref7 = (cov_2ftasb1r9a().b[7][0]++, maxHeight)) !== null && _ref7 !== void 0 ? _ref7 : (cov_2ftasb1r9a().b[7][1]++, '875px')) : (cov_2ftasb1r9a().b[6][1]++, 0),
      mt: isOpen ? (cov_2ftasb1r9a().b[8][0]++, 3) : (cov_2ftasb1r9a().b[8][1]++, 0),
      paddingLeft: 3,
      opacity: isOpen ? (cov_2ftasb1r9a().b[9][0]++, 1) : (cov_2ftasb1r9a().b[9][1]++, 0),
      overflow: 'hidden',
      transition: 'all 0.3s ease-out',
      width: '100%',
      fontWeight: 'regular'
    },
    bodyText: {
      fontSize: 's1',
      lineHeight: 1.6,
      color: 'neutrals90',
      fontWeight: 'regular',
      whiteSpace: 'pre-line'
    }
  });
};
var accordionListItem_primary = (cov_2ftasb1r9a().s[2]++, baseStyle);
cov_2ftasb1r9a().s[3]++;
var accordionListItem_secondary = function secondary(_ref8) {
  var hasBorder = _ref8.hasBorder,
    hasUnderline = _ref8.hasUnderline;
  cov_2ftasb1r9a().f[1]++;
  cov_2ftasb1r9a().s[4]++;
  return {
    listItem: {
      background: 'inherit',
      borderRadius: 'none',
      boxShadow: 'none',
      border: 'none',
      borderBottom: hasUnderline ? (cov_2ftasb1r9a().b[10][0]++, '1px solid var(--colors-neutrals70)') : (cov_2ftasb1r9a().b[10][1]++, 'none'),
      // Add styling to accordion when it is focused on to make website accessable to keyboard only users. More info on focus-within below
      // https://developer.mozilla.org/en-US/docs/Web/CSS/:focus-within
      _focusWithin: {
        borderRadius: 'none',
        boxShadow: 'none',
        border: hasBorder ? (cov_2ftasb1r9a().b[11][0]++, '1px solid var(--colors-neutrals100)') : (cov_2ftasb1r9a().b[11][1]++, 'none')
      }
    }
  };
};
var accordionListItem_variants = (cov_2ftasb1r9a().s[5]++, {
  primary: accordionListItem_primary,
  secondary: accordionListItem_secondary
});
var accordionListItem = (cov_2ftasb1r9a().s[6]++, {
  parts: anatomy_types/* accordionListItemAnatomy.keys */.lW.keys,
  baseStyle: baseStyle,
  variants: accordionListItem_variants,
  defaultProps: {
    variant: 'primary'
  }
});
/* harmony default export */ var components_accordionListItem = (accordionListItem);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/theme/eero/foundations/fontSizes.mjs
var fontSizes = __webpack_require__(2324);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/eero/components/avatar.mjs
function cov_26vk3vjzi3() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/eero/components/avatar.ts";
  var hash = "58f9b4d38f21fd2fd62eba7f73ff6aeda0ab759c";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/eero/components/avatar.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 53
        },
        end: {
          line: 16,
          column: 2
        }
      },
      "1": {
        start: {
          line: 6,
          column: 72
        },
        end: {
          line: 16,
          column: 1
        }
      },
      "2": {
        start: {
          line: 18,
          column: 80
        },
        end: {
          line: 27,
          column: 1
        }
      },
      "3": {
        start: {
          line: 29,
          column: 68
        },
        end: {
          line: 66,
          column: 1
        }
      },
      "4": {
        start: {
          line: 68,
          column: 21
        },
        end: {
          line: 70,
          column: 1
        }
      },
      "5": {
        start: {
          line: 76,
          column: 34
        },
        end: {
          line: 82,
          column: 1
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 53
          },
          end: {
            line: 6,
            column: 54
          }
        },
        loc: {
          start: {
            line: 6,
            column: 72
          },
          end: {
            line: 16,
            column: 1
          }
        },
        line: 6
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 10,
            column: 13
          },
          end: {
            line: 10,
            column: 31
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 10,
            column: 24
          },
          end: {
            line: 10,
            column: 27
          }
        }, {
          start: {
            line: 10,
            column: 30
          },
          end: {
            line: 10,
            column: 31
          }
        }],
        line: 10
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "58f9b4d38f21fd2fd62eba7f73ff6aeda0ab759c"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_26vk3vjzi3 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_26vk3vjzi3();





cov_26vk3vjzi3().s[0]++;
var avatar_baseStyle = function baseStyle(_ref) {
  var disabled = _ref.disabled;
  cov_26vk3vjzi3().f[0]++;
  cov_26vk3vjzi3().s[1]++;
  return {
    container: {
      borderRadius: 'full',
      flexShrink: 0,
      opacity: disabled ? (cov_26vk3vjzi3().b[0][0]++, 0.6) : (cov_26vk3vjzi3().b[0][1]++, 1),
      overflow: 'hidden'
    },
    image: {
      objectFit: 'cover'
    }
  };
};
var avatar_variants = (cov_26vk3vjzi3().s[2]++, {
  human: {
    container: {
      bgColor: 'neutrals20'
    }
  },
  bot: {
    container: {
      display: 'flex',
      alignItems: 'center',
      bgColor: 'brand50'
    }
  }
});
var sizes = (cov_26vk3vjzi3().s[3]++, {
  sm: {
    container: {
      width: '32px',
      height: '32px',
      lineHeight: '32px',
      fontSize: fontSizes/* fontSizesNamedWithUnits.s0 */.NR.s0
    },
    image: {
      width: '32px',
      height: '32px'
    }
  },
  md: {
    container: {
      width: '60px',
      height: '60px',
      lineHeight: '60px',
      fontSize: fontSizes/* fontSizesNamedWithUnits.s1 */.NR.s1
    },
    image: {
      width: '60px',
      height: '60px'
    }
  },
  lg: {
    container: {
      width: '72px',
      height: '72px',
      lineHeight: '72px',
      fontSize: fontSizes/* fontSizesNamedWithUnits.s2 */.NR.s2
    },
    image: {
      width: '72px',
      height: '72px'
    }
  }
});
var defaultProps = (cov_26vk3vjzi3().s[4]++, {
  size: 'md'
});
var avatar = (cov_26vk3vjzi3().s[5]++, {
  parts: anatomy_types/* avatarAnatomy.keys */.$5.keys,
  baseStyle: avatar_baseStyle,
  variants: avatar_variants,
  sizes: sizes,
  defaultProps: defaultProps
});
/* harmony default export */ var components_avatar = (avatar);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/theme/eero/foundations/fonts.mjs
var fonts = __webpack_require__(82383);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/eero/components/sharedCta.mjs
function cov_1ok8yj0pkf() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/eero/components/sharedCta.ts";
  var hash = "b79729ee4066dcea26bbdf42a3b8bd9706fe9ea2";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/eero/components/sharedCta.ts",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 58
        },
        end: {
          line: 22,
          column: 1
        }
      },
      "1": {
        start: {
          line: 24,
          column: 59
        },
        end: {
          line: 33,
          column: 1
        }
      },
      "2": {
        start: {
          line: 35,
          column: 44
        },
        end: {
          line: 35,
          column: 65
        }
      },
      "3": {
        start: {
          line: 36,
          column: 44
        },
        end: {
          line: 36,
          column: 65
        }
      },
      "4": {
        start: {
          line: 37,
          column: 44
        },
        end: {
          line: 37,
          column: 65
        }
      },
      "5": {
        start: {
          line: 39,
          column: 55
        },
        end: {
          line: 59,
          column: 1
        }
      },
      "6": {
        start: {
          line: 61,
          column: 57
        },
        end: {
          line: 78,
          column: 1
        }
      },
      "7": {
        start: {
          line: 80,
          column: 57
        },
        end: {
          line: 85,
          column: 1
        }
      },
      "8": {
        start: {
          line: 87,
          column: 56
        },
        end: {
          line: 99,
          column: 1
        }
      },
      "9": {
        start: {
          line: 101,
          column: 46
        },
        end: {
          line: 110,
          column: 1
        }
      },
      "10": {
        start: {
          line: 112,
          column: 55
        },
        end: {
          line: 121,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "b79729ee4066dcea26bbdf42a3b8bd9706fe9ea2"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1ok8yj0pkf = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1ok8yj0pkf();


















function sharedCta_typeof(o) { "@babel/helpers - typeof"; return sharedCta_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, sharedCta_typeof(o); }
function sharedCta_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function sharedCta_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? sharedCta_ownKeys(Object(t), !0).forEach(function (r) { sharedCta_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : sharedCta_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function sharedCta_defineProperty(obj, key, value) { key = sharedCta_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function sharedCta_toPropertyKey(t) { var i = sharedCta_toPrimitive(t, "string"); return "symbol" == sharedCta_typeof(i) ? i : String(i); }
function sharedCta_toPrimitive(t, r) { if ("object" != sharedCta_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != sharedCta_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var buttonBaseStyles = (cov_1ok8yj0pkf().s[0]++, {
  boxSizing: 'border-box',
  border: 'none',
  borderRadius: 'roundedSquare',
  cursor: 'pointer',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontFamily: fonts/* fonts.sans */.R.sans,
  fontSize: 's1',
  fontWeight: 'semibold',
  width: '100%',
  padding: '0.5em 1.5em',
  transition: 'all 0.3s ease',
  position: 'relative',
  _disabled: {
    cursor: 'not-allowed'
  }
});
var resetButtonStyles = (cov_1ok8yj0pkf().s[1]++, {
  display: 'inline',
  textAlign: 'left',
  padding: 0,
  width: 'unset',
  borderRadius: 'none',
  fontSize: 'inherit',
  fontWeight: 'inherit',
  minHeight: 'unset'
});
var sharedCta_sm = (cov_1ok8yj0pkf().s[2]++, {
  minHeight: '36px'
});
var sharedCta_md = (cov_1ok8yj0pkf().s[3]++, {
  minHeight: '56px'
});
var sharedCta_lg = (cov_1ok8yj0pkf().s[4]++, {
  minHeight: '66px'
});
var primaryButton = (cov_1ok8yj0pkf().s[5]++, {
  color: 'neutrals0',
  backgroundColor: 'brand50',
  _hover: {
    color: 'neutrals0',
    background: 'linear-gradient(0deg, rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0.4)) var(--colors-brand50)',
    backgroundBlendMode: 'soft-light, normal',
    _disabled: {
      backgroundColor: 'neutrals30',
      color: 'neutrals70'
    }
  },
  _active: {
    color: 'rgba(255, 255, 255, 0.6)'
  },
  _disabled: {
    backgroundColor: 'neutrals30',
    color: 'neutrals70'
  }
});
var secondaryButton = (cov_1ok8yj0pkf().s[6]++, {
  color: 'neutrals100',
  backgroundColor: 'neutrals0',
  border: "2px solid black",
  borderColor: 'neutrals100',
  _hover: {
    color: 'neutrals100',
    background: 'neutrals30'
  },
  _active: {
    color: 'neutrals90'
  },
  _disabled: {
    border: 'none',
    backgroundColor: 'neutrals30',
    color: 'neutrals70'
  }
});
var resetLinkStyles = (cov_1ok8yj0pkf().s[7]++, {
  backgroundColor: 'none',
  textDecoration: 'none',
  fontSize: 'inherit',
  fontWeight: 'inherit'
});
var linkBaseStyles = (cov_1ok8yj0pkf().s[8]++, sharedCta_objectSpread(sharedCta_objectSpread({}, resetLinkStyles), {}, {
  cursor: 'pointer',
  _disabled: {
    color: 'neutrals70',
    _hover: {
      color: 'neutrals70'
    },
    _active: {
      color: 'neutrals70'
    }
  }
}));
var sharedCta_link = (cov_1ok8yj0pkf().s[9]++, {
  color: 'brand50',
  textDecoration: 'underline',
  _hover: {
    color: 'brand40'
  },
  _active: {
    color: 'brand30'
  }
});
var secondaryLink = (cov_1ok8yj0pkf().s[10]++, {
  color: 'neutrals100',
  textDecoration: 'underline',
  _hover: {
    color: 'neutrals90'
  },
  _active: {
    color: 'neutrals70'
  }
});
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/eero/components/button.mjs
function cov_29ee6edmzo() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/eero/components/button.ts";
  var hash = "4690ec8fac1c5c1b5f13a9c181c3013b1a08dcec";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/eero/components/button.ts",
    statementMap: {
      "0": {
        start: {
          line: 16,
          column: 40
        },
        end: {
          line: 35,
          column: 1
        }
      },
      "1": {
        start: {
          line: 37,
          column: 39
        },
        end: {
          line: 85,
          column: 1
        }
      },
      "2": {
        start: {
          line: 87,
          column: 71
        },
        end: {
          line: 117,
          column: 1
        }
      },
      "3": {
        start: {
          line: 119,
          column: 25
        },
        end: {
          line: 119,
          column: 94
        }
      },
      "4": {
        start: {
          line: 119,
          column: 46
        },
        end: {
          line: 119,
          column: 94
        }
      },
      "5": {
        start: {
          line: 122,
          column: 59
        },
        end: {
          line: 126,
          column: 1
        }
      },
      "6": {
        start: {
          line: 123,
          column: 24
        },
        end: {
          line: 123,
          column: 66
        }
      },
      "7": {
        start: {
          line: 124,
          column: 24
        },
        end: {
          line: 124,
          column: 66
        }
      },
      "8": {
        start: {
          line: 125,
          column: 24
        },
        end: {
          line: 125,
          column: 66
        }
      },
      "9": {
        start: {
          line: 133,
          column: 34
        },
        end: {
          line: 141,
          column: 1
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 119,
            column: 25
          },
          end: {
            line: 119,
            column: 26
          }
        },
        loc: {
          start: {
            line: 119,
            column: 46
          },
          end: {
            line: 119,
            column: 94
          }
        },
        line: 119
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 123,
            column: 6
          },
          end: {
            line: 123,
            column: 7
          }
        },
        loc: {
          start: {
            line: 123,
            column: 24
          },
          end: {
            line: 123,
            column: 66
          }
        },
        line: 123
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 124,
            column: 6
          },
          end: {
            line: 124,
            column: 7
          }
        },
        loc: {
          start: {
            line: 124,
            column: 24
          },
          end: {
            line: 124,
            column: 66
          }
        },
        line: 124
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 125,
            column: 6
          },
          end: {
            line: 125,
            column: 7
          }
        },
        loc: {
          start: {
            line: 125,
            column: 24
          },
          end: {
            line: 125,
            column: 66
          }
        },
        line: 125
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 119,
            column: 46
          },
          end: {
            line: 119,
            column: 94
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 119,
            column: 46
          },
          end: {
            line: 119,
            column: 67
          }
        }, {
          start: {
            line: 119,
            column: 71
          },
          end: {
            line: 119,
            column: 94
          }
        }],
        line: 119
      },
      "1": {
        loc: {
          start: {
            line: 123,
            column: 24
          },
          end: {
            line: 123,
            column: 66
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 123,
            column: 52
          },
          end: {
            line: 123,
            column: 61
          }
        }, {
          start: {
            line: 123,
            column: 64
          },
          end: {
            line: 123,
            column: 66
          }
        }],
        line: 123
      },
      "2": {
        loc: {
          start: {
            line: 124,
            column: 24
          },
          end: {
            line: 124,
            column: 66
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 124,
            column: 52
          },
          end: {
            line: 124,
            column: 61
          }
        }, {
          start: {
            line: 124,
            column: 64
          },
          end: {
            line: 124,
            column: 66
          }
        }],
        line: 124
      },
      "3": {
        loc: {
          start: {
            line: 125,
            column: 24
          },
          end: {
            line: 125,
            column: 66
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 125,
            column: 52
          },
          end: {
            line: 125,
            column: 61
          }
        }, {
          start: {
            line: 125,
            column: 64
          },
          end: {
            line: 125,
            column: 66
          }
        }],
        line: 125
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "4690ec8fac1c5c1b5f13a9c181c3013b1a08dcec"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_29ee6edmzo = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_29ee6edmzo();


















function button_typeof(o) { "@babel/helpers - typeof"; return button_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, button_typeof(o); }
function button_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function button_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? button_ownKeys(Object(t), !0).forEach(function (r) { button_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : button_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function button_defineProperty(obj, key, value) { key = button_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function button_toPropertyKey(t) { var i = button_toPrimitive(t, "string"); return "symbol" == button_typeof(i) ? i : String(i); }
function button_toPrimitive(t, r) { if ("object" != button_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != button_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var ghost = (cov_29ee6edmzo().s[0]++, {
  padding: 0,
  height: 'auto',
  width: 'auto',
  backgroundColor: 'transparent',
  ' & > *': {
    _hover: {
      color: 'neutrals100',
      backgroundColor: 'neutrals30'
    },
    _active: {
      color: 'neutrals90'
    },
    _disabled: {
      border: 'none',
      backgroundColor: 'neutrals30',
      color: 'neutrals70'
    }
  }
});
var icon = (cov_29ee6edmzo().s[1]++, {
  flexShrink: 0,
  flexGrow: 0,
  border: "0.5px solid var(--colors-neutrals30)",
  borderRadius: 'rounded',
  boxShadow: '0px 5px 10px rgba(29, 71, 123, 0.04), 0px 1px 5px rgba(29, 71, 123, 0.12)',
  minHeight: 'auto',
  height: '40px',
  width: '40px',
  color: 'neutrals100',
  backgroundColor: 'neutrals0',
  padding: 0,
  ' svg': {
    ' path': {
      fill: 'neutrals100'
    }
  },
  _hover: {
    backgroundColor: 'neutrals30',
    _disabled: {
      backgroundColor: 'neutrals0',
      color: '#bfbfbf !important',
      ' svg': {
        ' path': {
          fill: '#bfbfbf !important'
        }
      }
    }
  },
  _active: {
    color: "var(--colors-neutrals70) !important",
    ' svg': {
      color: "var(--colors-neutrals70) !important",
      ' path': {
        fill: "var(--colors-neutrals70) !important"
      }
    }
  },
  _disabled: {
    backgroundColor: 'neutrals0',
    color: '#bfbfbf !important',
    ' svg': {
      color: '#bfbfbf !important',
      ' path': {
        fill: '#bfbfbf !important'
      }
    }
  }
});
var button_variants = (cov_29ee6edmzo().s[2]++, {
  primary: primaryButton,
  secondary: secondaryButton,
  icon: icon,
  ghost: ghost,
  /**
   * @deprecated
   * NOTE: This is a known antipattern, however for conversion reasons this is occasionally a
   * requirement. Make sure to verify with design that this behavior is absolutely necessary
   * and appropriate a11y concerns were considered.
   */
  link: button_objectSpread(button_objectSpread(button_objectSpread(button_objectSpread({}, resetButtonStyles), linkBaseStyles), sharedCta_link), {}, {
    textDecoration: 'none',
    fontWeight: 'semibold'
  }),
  /**
   * NOTE: This is a known antipattern, however for conversion reasons this is occasionally a
   * requirement. Make sure to verify with design that this behavior is absolutely necessary
   * and appropriate a11y concerns were considered.
   */
  'inline-link': button_objectSpread(button_objectSpread(button_objectSpread({}, resetButtonStyles), linkBaseStyles), sharedCta_link),
  /**
   * NOTE: This is a known antipattern, however for conversion reasons this is occasionally a
   * requirement. Make sure to verify with design that this behavior is absolutely necessary
   * and appropriate a11y concerns were considered
   */
  'inline-secondary-link': button_objectSpread(button_objectSpread(button_objectSpread({}, resetButtonStyles), linkBaseStyles), secondaryLink)
});
cov_29ee6edmzo().s[3]++;
var shouldApplySizes = function shouldApplySizes(variant) {
  cov_29ee6edmzo().f[0]++;
  cov_29ee6edmzo().s[4]++;
  return (cov_29ee6edmzo().b[0][0]++, variant === 'primary') || (cov_29ee6edmzo().b[0][1]++, variant === 'secondary');
};

/** NOTE: Sizes only get applied for button variants */
var button_sizes = (cov_29ee6edmzo().s[5]++, {
  sm: function sm(_ref) {
    var variant = _ref.variant;
    cov_29ee6edmzo().f[1]++;
    cov_29ee6edmzo().s[6]++;
    return shouldApplySizes(variant) ? (cov_29ee6edmzo().b[1][0]++, button_objectSpread({}, sharedCta_sm)) : (cov_29ee6edmzo().b[1][1]++, {});
  },
  md: function md(_ref2) {
    var variant = _ref2.variant;
    cov_29ee6edmzo().f[2]++;
    cov_29ee6edmzo().s[7]++;
    return shouldApplySizes(variant) ? (cov_29ee6edmzo().b[2][0]++, button_objectSpread({}, sharedCta_md)) : (cov_29ee6edmzo().b[2][1]++, {});
  },
  lg: function lg(_ref3) {
    var variant = _ref3.variant;
    cov_29ee6edmzo().f[3]++;
    cov_29ee6edmzo().s[8]++;
    return shouldApplySizes(variant) ? (cov_29ee6edmzo().b[3][0]++, button_objectSpread({}, sharedCta_lg)) : (cov_29ee6edmzo().b[3][1]++, {});
  }
});
var button_button = (cov_29ee6edmzo().s[9]++, {
  baseStyle: buttonBaseStyles,
  variants: button_variants,
  sizes: button_sizes,
  defaultProps: {
    variant: 'primary',
    size: 'md'
  }
});
/* harmony default export */ var components_button = (button_button);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/eero/components/checkbox.mjs
function cov_22u7t08tvg() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/eero/components/checkbox.ts";
  var hash = "e6ff22e48971499d932c7eb10c7ed942c3c61fda";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/eero/components/checkbox.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 50
        },
        end: {
          line: 14,
          column: 1
        }
      },
      "1": {
        start: {
          line: 15,
          column: 51
        },
        end: {
          line: 19,
          column: 1
        }
      },
      "2": {
        start: {
          line: 24,
          column: 44
        },
        end: {
          line: 69,
          column: 1
        }
      },
      "3": {
        start: {
          line: 71,
          column: 45
        },
        end: {
          line: 73,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "e6ff22e48971499d932c7eb10c7ed942c3c61fda"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_22u7t08tvg = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_22u7t08tvg();


















function checkbox_typeof(o) { "@babel/helpers - typeof"; return checkbox_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, checkbox_typeof(o); }
function checkbox_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function checkbox_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? checkbox_ownKeys(Object(t), !0).forEach(function (r) { checkbox_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : checkbox_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function checkbox_defineProperty(obj, key, value) { key = checkbox_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function checkbox_toPropertyKey(t) { var i = checkbox_toPrimitive(t, "string"); return "symbol" == checkbox_typeof(i) ? i : String(i); }
function checkbox_toPrimitive(t, r) { if ("object" != checkbox_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != checkbox_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var defaultCheckbox = (cov_22u7t08tvg().s[0]++, {
  content: "\"\"",
  width: '12px',
  height: '12px',
  position: 'absolute',
  left: '0',
  top: '2px',
  cursor: 'pointer',
  borderRadius: 'squared',
  transition: 'all 0.15s cubic-bezier(0.1, 0.7, 0.1, 1)',
  boxSizing: 'content-box'
});
var disabledCheckbox = (cov_22u7t08tvg().s[1]++, {
  content: "\"\"",
  opacity: '40%',
  cursor: 'default'
});

// Custom styling for the checkbox button & hides input
// Used pseudo-elements & adjacent sibling selectors to create a custom accessible checkbox button
// https://medium.com/claritydesignsystem/pure-css-accessible-checkboxes-and-radios-buttons-54063e759bb3
var checkbox_baseStyle = (cov_22u7t08tvg().s[2]++, {
  // opacity: 0 visually hides this input in an accessible way (do not use display: none), so we can create our own custom checkbox
  opacity: 0,
  position: 'absolute',
  // & + label styles is applied to the label component immediately after the input to style a custom checkbox button
  '& + label': {
    position: 'relative',
    paddingLeft: '23px',
    _before: checkbox_objectSpread({
      border: "2px solid var(--colors-neutrals40)"
    }, defaultCheckbox)
  },
  '&:checked + label': {
    // checked checkbox background
    _before: checkbox_objectSpread({
      border: "2px solid var(--colors-brand50)",
      bg: 'brand50'
    }, defaultCheckbox),
    // checkmark styling
    _after: checkbox_objectSpread(checkbox_objectSpread({}, defaultCheckbox), {}, {
      content: "\"\"",
      position: 'absolute',
      left: '5px',
      top: '5px',
      width: '3px',
      height: '6px',
      border: "solid var(--colors-neutrals0)",
      borderWidth: '0 3px 3px 0',
      transform: 'rotate(45deg)'
    })
  },
  _disabled: {
    '& + label': {
      _before: checkbox_objectSpread({}, disabledCheckbox),
      _after: checkbox_objectSpread({}, disabledCheckbox)
    }
  }
});
var checkbox_checkbox = (cov_22u7t08tvg().s[3]++, {
  baseStyle: checkbox_baseStyle
});
/* harmony default export */ var components_checkbox = (checkbox_checkbox);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/eero/components/chip.mjs
function cov_2byb6u738i() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/eero/components/chip.ts";
  var hash = "f77e700fa2035a6ed12c3da93c4bacba7fbdd19b";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/eero/components/chip.ts",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 51
        },
        end: {
          line: 20,
          column: 2
        }
      },
      "1": {
        start: {
          line: 4,
          column: 63
        },
        end: {
          line: 20,
          column: 1
        }
      },
      "2": {
        start: {
          line: 22,
          column: 47
        },
        end: {
          line: 32,
          column: 2
        }
      },
      "3": {
        start: {
          line: 22,
          column: 59
        },
        end: {
          line: 32,
          column: 1
        }
      },
      "4": {
        start: {
          line: 34,
          column: 48
        },
        end: {
          line: 44,
          column: 2
        }
      },
      "5": {
        start: {
          line: 34,
          column: 60
        },
        end: {
          line: 44,
          column: 1
        }
      },
      "6": {
        start: {
          line: 46,
          column: 47
        },
        end: {
          line: 56,
          column: 2
        }
      },
      "7": {
        start: {
          line: 46,
          column: 59
        },
        end: {
          line: 56,
          column: 1
        }
      },
      "8": {
        start: {
          line: 58,
          column: 52
        },
        end: {
          line: 68,
          column: 2
        }
      },
      "9": {
        start: {
          line: 58,
          column: 64
        },
        end: {
          line: 68,
          column: 1
        }
      },
      "10": {
        start: {
          line: 70,
          column: 56
        },
        end: {
          line: 86,
          column: 1
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 4,
            column: 51
          },
          end: {
            line: 4,
            column: 52
          }
        },
        loc: {
          start: {
            line: 4,
            column: 63
          },
          end: {
            line: 20,
            column: 1
          }
        },
        line: 4
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 22,
            column: 47
          },
          end: {
            line: 22,
            column: 48
          }
        },
        loc: {
          start: {
            line: 22,
            column: 59
          },
          end: {
            line: 32,
            column: 1
          }
        },
        line: 22
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 34,
            column: 48
          },
          end: {
            line: 34,
            column: 49
          }
        },
        loc: {
          start: {
            line: 34,
            column: 60
          },
          end: {
            line: 44,
            column: 1
          }
        },
        line: 34
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 46,
            column: 47
          },
          end: {
            line: 46,
            column: 48
          }
        },
        loc: {
          start: {
            line: 46,
            column: 59
          },
          end: {
            line: 56,
            column: 1
          }
        },
        line: 46
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 58,
            column: 52
          },
          end: {
            line: 58,
            column: 53
          }
        },
        loc: {
          start: {
            line: 58,
            column: 64
          },
          end: {
            line: 68,
            column: 1
          }
        },
        line: 58
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 11
          },
          end: {
            line: 6,
            column: 75
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 6,
            column: 28
          },
          end: {
            line: 6,
            column: 40
          }
        }, {
          start: {
            line: 6,
            column: 43
          },
          end: {
            line: 6,
            column: 75
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 6,
            column: 43
          },
          end: {
            line: 6,
            column: 75
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 43
          },
          end: {
            line: 6,
            column: 58
          }
        }, {
          start: {
            line: 6,
            column: 62
          },
          end: {
            line: 6,
            column: 75
          }
        }],
        line: 6
      },
      "2": {
        loc: {
          start: {
            line: 13,
            column: 21
          },
          end: {
            line: 13,
            column: 74
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 13,
            column: 38
          },
          end: {
            line: 13,
            column: 50
          }
        }, {
          start: {
            line: 13,
            column: 53
          },
          end: {
            line: 13,
            column: 74
          }
        }],
        line: 13
      },
      "3": {
        loc: {
          start: {
            line: 14,
            column: 12
          },
          end: {
            line: 14,
            column: 69
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 14,
            column: 49
          },
          end: {
            line: 14,
            column: 55
          }
        }, {
          start: {
            line: 14,
            column: 58
          },
          end: {
            line: 14,
            column: 69
          }
        }],
        line: 14
      },
      "4": {
        loc: {
          start: {
            line: 14,
            column: 12
          },
          end: {
            line: 14,
            column: 46
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 14,
            column: 12
          },
          end: {
            line: 14,
            column: 26
          }
        }, {
          start: {
            line: 14,
            column: 30
          },
          end: {
            line: 14,
            column: 46
          }
        }],
        line: 14
      },
      "5": {
        loc: {
          start: {
            line: 25,
            column: 11
          },
          end: {
            line: 25,
            column: 75
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 25,
            column: 28
          },
          end: {
            line: 25,
            column: 40
          }
        }, {
          start: {
            line: 25,
            column: 43
          },
          end: {
            line: 25,
            column: 75
          }
        }],
        line: 25
      },
      "6": {
        loc: {
          start: {
            line: 25,
            column: 43
          },
          end: {
            line: 25,
            column: 75
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 25,
            column: 43
          },
          end: {
            line: 25,
            column: 58
          }
        }, {
          start: {
            line: 25,
            column: 62
          },
          end: {
            line: 25,
            column: 75
          }
        }],
        line: 25
      },
      "7": {
        loc: {
          start: {
            line: 37,
            column: 11
          },
          end: {
            line: 37,
            column: 75
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 37,
            column: 28
          },
          end: {
            line: 37,
            column: 40
          }
        }, {
          start: {
            line: 37,
            column: 43
          },
          end: {
            line: 37,
            column: 75
          }
        }],
        line: 37
      },
      "8": {
        loc: {
          start: {
            line: 37,
            column: 43
          },
          end: {
            line: 37,
            column: 75
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 37,
            column: 43
          },
          end: {
            line: 37,
            column: 58
          }
        }, {
          start: {
            line: 37,
            column: 62
          },
          end: {
            line: 37,
            column: 75
          }
        }],
        line: 37
      },
      "9": {
        loc: {
          start: {
            line: 49,
            column: 11
          },
          end: {
            line: 49,
            column: 75
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 49,
            column: 28
          },
          end: {
            line: 49,
            column: 40
          }
        }, {
          start: {
            line: 49,
            column: 43
          },
          end: {
            line: 49,
            column: 75
          }
        }],
        line: 49
      },
      "10": {
        loc: {
          start: {
            line: 49,
            column: 43
          },
          end: {
            line: 49,
            column: 75
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 49,
            column: 43
          },
          end: {
            line: 49,
            column: 58
          }
        }, {
          start: {
            line: 49,
            column: 62
          },
          end: {
            line: 49,
            column: 75
          }
        }],
        line: 49
      },
      "11": {
        loc: {
          start: {
            line: 61,
            column: 11
          },
          end: {
            line: 61,
            column: 75
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 61,
            column: 28
          },
          end: {
            line: 61,
            column: 40
          }
        }, {
          start: {
            line: 61,
            column: 43
          },
          end: {
            line: 61,
            column: 75
          }
        }],
        line: 61
      },
      "12": {
        loc: {
          start: {
            line: 61,
            column: 43
          },
          end: {
            line: 61,
            column: 75
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 61,
            column: 43
          },
          end: {
            line: 61,
            column: 58
          }
        }, {
          start: {
            line: 61,
            column: 62
          },
          end: {
            line: 61,
            column: 75
          }
        }],
        line: 61
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "f77e700fa2035a6ed12c3da93c4bacba7fbdd19b"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2byb6u738i = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2byb6u738i();




cov_2byb6u738i().s[0]++;
var chip_baseStyle = function baseStyle(props) {
  var _ref;
  cov_2byb6u738i().f[0]++;
  cov_2byb6u738i().s[1]++;
  return {
    label: {
      color: props.disabled ? (cov_2byb6u738i().b[0][0]++, 'neutrals70') : (cov_2byb6u738i().b[0][1]++, (_ref = (cov_2byb6u738i().b[1][0]++, props.textColor)) !== null && _ref !== void 0 ? _ref : (cov_2byb6u738i().b[1][1]++, 'neutrals100')),
      fontWeight: 'semibold'
    },
    container: {
      flexDirection: props.flexDirection,
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: props.disabled ? (cov_2byb6u738i().b[2][0]++, 'neutrals20') : (cov_2byb6u738i().b[2][1]++, props.backgroundColor),
      border: (cov_2byb6u738i().b[4][0]++, props.disabled) || (cov_2byb6u738i().b[4][1]++, !props.hasBorder) ? (cov_2byb6u738i().b[3][0]++, 'none') : (cov_2byb6u738i().b[3][1]++, '2px solid'),
      borderRadius: 'squared',
      borderColor: props.borderColor,
      paddingLeft: 3,
      paddingRight: 3
    }
  };
};
cov_2byb6u738i().s[2]++;
var small = function small(props) {
  var _ref2;
  cov_2byb6u738i().f[1]++;
  cov_2byb6u738i().s[3]++;
  return {
    label: {
      fontSize: 's00',
      color: props.disabled ? (cov_2byb6u738i().b[5][0]++, 'neutrals70') : (cov_2byb6u738i().b[5][1]++, (_ref2 = (cov_2byb6u738i().b[6][0]++, props.textColor)) !== null && _ref2 !== void 0 ? _ref2 : (cov_2byb6u738i().b[6][1]++, 'neutrals100'))
    },
    container: {
      height: '28px',
      paddingTop: 3,
      paddingBottom: 3
    }
  };
};
cov_2byb6u738i().s[4]++;
var medium = function medium(props) {
  var _ref3;
  cov_2byb6u738i().f[2]++;
  cov_2byb6u738i().s[5]++;
  return {
    label: {
      fontSize: 's0',
      color: props.disabled ? (cov_2byb6u738i().b[7][0]++, 'neutrals70') : (cov_2byb6u738i().b[7][1]++, (_ref3 = (cov_2byb6u738i().b[8][0]++, props.textColor)) !== null && _ref3 !== void 0 ? _ref3 : (cov_2byb6u738i().b[8][1]++, 'neutrals100'))
    },
    container: {
      height: '30px',
      paddingTop: 3,
      paddingBottom: 3
    }
  };
};
cov_2byb6u738i().s[6]++;
var large = function large(props) {
  var _ref4;
  cov_2byb6u738i().f[3]++;
  cov_2byb6u738i().s[7]++;
  return {
    label: {
      fontSize: 's1',
      color: props.disabled ? (cov_2byb6u738i().b[9][0]++, 'neutrals70') : (cov_2byb6u738i().b[9][1]++, (_ref4 = (cov_2byb6u738i().b[10][0]++, props.textColor)) !== null && _ref4 !== void 0 ? _ref4 : (cov_2byb6u738i().b[10][1]++, 'neutrals100'))
    },
    container: {
      height: '36px',
      paddingTop: 4,
      paddingBottom: 4
    }
  };
};
cov_2byb6u738i().s[8]++;
var extraLarge = function extraLarge(props) {
  var _ref5;
  cov_2byb6u738i().f[4]++;
  cov_2byb6u738i().s[9]++;
  return {
    label: {
      fontSize: 's1',
      color: props.disabled ? (cov_2byb6u738i().b[11][0]++, 'neutrals70') : (cov_2byb6u738i().b[11][1]++, (_ref5 = (cov_2byb6u738i().b[12][0]++, props.textColor)) !== null && _ref5 !== void 0 ? _ref5 : (cov_2byb6u738i().b[12][1]++, 'neutrals100'))
    },
    container: {
      height: '44px',
      paddingTop: 4,
      paddingBottom: 4
    }
  };
};
var Chip = (cov_2byb6u738i().s[10]++, {
  // The parts of the component
  parts: anatomy_types/* chipAnatomy.keys */.Q0.keys,
  // The base styles for each part
  baseStyle: chip_baseStyle,
  // The size styles for each part
  sizes: {
    small: small,
    medium: medium,
    large: large,
    'extra-large': extraLarge
  },
  // The default `size` or `variant` values
  defaultProps: {
    sizes: 'small'
  }
});
/* harmony default export */ var chip = (Chip);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/eero/components/form.mjs
function cov_2vr400hn8() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/eero/components/form.ts";
  var hash = "58501b5f7980d31eccf3a063186f5e6e8b7e30bb";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/eero/components/form.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 41
        },
        end: {
          line: 3,
          column: 58
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "58501b5f7980d31eccf3a063186f5e6e8b7e30bb"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2vr400hn8 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2vr400hn8();
var form_form = (cov_2vr400hn8().s[0]++, {
  baseStyle: {}
});
/* harmony default export */ var components_form = (form_form);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/eero/components/formElements.mjs
function cov_tsjp2ivf1() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/eero/components/formElements.ts";
  var hash = "d118a202a256aa66a16ac80b1c1d384a37afe4ac";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/eero/components/formElements.ts",
    statementMap: {
      "0": {
        start: {
          line: 9,
          column: 49
        },
        end: {
          line: 12,
          column: 1
        }
      },
      "1": {
        start: {
          line: 13,
          column: 57
        },
        end: {
          line: 16,
          column: 1
        }
      },
      "2": {
        start: {
          line: 18,
          column: 52
        },
        end: {
          line: 26,
          column: 1
        }
      },
      "3": {
        start: {
          line: 27,
          column: 60
        },
        end: {
          line: 30,
          column: 1
        }
      },
      "4": {
        start: {
          line: 32,
          column: 55
        },
        end: {
          line: 36,
          column: 1
        }
      },
      "5": {
        start: {
          line: 38,
          column: 56
        },
        end: {
          line: 59,
          column: 1
        }
      },
      "6": {
        start: {
          line: 61,
          column: 61
        },
        end: {
          line: 65,
          column: 1
        }
      },
      "7": {
        start: {
          line: 67,
          column: 61
        },
        end: {
          line: 71,
          column: 1
        }
      },
      "8": {
        start: {
          line: 73,
          column: 59
        },
        end: {
          line: 82,
          column: 1
        }
      },
      "9": {
        start: {
          line: 85,
          column: 64
        },
        end: {
          line: 88,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "d118a202a256aa66a16ac80b1c1d384a37afe4ac"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_tsjp2ivf1 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_tsjp2ivf1();
function formElements_typeof(o) { "@babel/helpers - typeof"; return formElements_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, formElements_typeof(o); }


















function formElements_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function formElements_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? formElements_ownKeys(Object(t), !0).forEach(function (r) { formElements_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : formElements_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function formElements_defineProperty(obj, key, value) { key = formElements_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function formElements_toPropertyKey(t) { var i = formElements_toPrimitive(t, "string"); return "symbol" == formElements_typeof(i) ? i : String(i); }
function formElements_toPrimitive(t, r) { if ("object" != formElements_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != formElements_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

// Styles the label
var baseStyleLabel = (cov_tsjp2ivf1().s[0]++, {
  ml: 3,
  textColor: 'neutrals100'
});
var baseStyleDisabledLabel = (cov_tsjp2ivf1().s[1]++, formElements_objectSpread(formElements_objectSpread({}, baseStyleLabel), {}, {
  textColor: 'neutrals70'
}));
// Styles the subtitle
var baseStyleSubtitle = (cov_tsjp2ivf1().s[2]++, {
  pt: 3,
  pl: 3,
  display: 'block',
  color: 'neutrals100',
  fontWeight: 'normal',
  fontSize: 's0',
  lineHeight: 1
});
var baseStyleDisabledSubtitle = (cov_tsjp2ivf1().s[3]++, formElements_objectSpread(formElements_objectSpread({}, baseStyleSubtitle), {}, {
  textColor: 'neutrals70'
}));
var baseStyleNoContainer = (cov_tsjp2ivf1().s[4]++, {
  marginRight: 5,
  paddingBlock: 3,
  lineHeight: 1.3
});
var baseStyleHasContainer = (cov_tsjp2ivf1().s[5]++, {
  border: "2px solid var(--colors-neutrals40)",
  borderRadius: 'roundedSquare',
  cursor: 'pointer',
  paddingBlock: 7,
  paddingLeft: 5,
  paddingRight: 4,
  marginBlockEnd: 3,
  lineHeight: 1.3,
  transition: "250ms ease border-color",
  _hover: {
    border: "2px solid var(--colors-neutrals70)"
  },
  // Focus-within styling provides styling if the parent has focus.
  // https://developer.mozilla.org/en-US/docs/Web/CSS/:focus-within
  _focusWithin: {
    border: "2px solid var(--colors-neutrals100)"
  },
  '&:first-of-type': {
    marginBlockStart: 3
  }
});
var baseStyleDisabledContainer = (cov_tsjp2ivf1().s[6]++, formElements_objectSpread(formElements_objectSpread({}, baseStyleHasContainer), {}, {
  backgroundColor: 'neutrals10',
  cursor: 'default'
}));
var baseStyleHasErrorContainer = (cov_tsjp2ivf1().s[7]++, formElements_objectSpread(formElements_objectSpread({}, baseStyleHasContainer), {}, {
  border: "2px solid var(--colors-red50)",
  cursor: 'default'
}));
var formElements_baseStyle = (cov_tsjp2ivf1().s[8]++, {
  label: baseStyleLabel,
  disabledLabel: baseStyleDisabledLabel,
  subtitle: baseStyleSubtitle,
  disabledSubtitle: baseStyleDisabledSubtitle,
  noContainer: baseStyleNoContainer,
  errorContainer: baseStyleHasErrorContainer,
  disabledContainer: baseStyleDisabledContainer,
  hasContainer: formElements_objectSpread({}, baseStyleHasContainer)
});

// NOTE: This is not a correctly styled multiStyleConfig so the types have been fudged a bit
var formElements = (cov_tsjp2ivf1().s[9]++, {
  parts: anatomy_types/* formElementsAnatomy.keys */.Ss.keys,
  baseStyle: formElements_baseStyle
});
/* harmony default export */ var components_formElements = (formElements);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.bold.js
var es_string_bold = __webpack_require__(50915);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/theme/eero/foundations/fontWeights.mjs
var fontWeights = __webpack_require__(53174);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/theme/eero/foundations/colors.mjs
var colors = __webpack_require__(81762);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/theme/eero/foundations/lineHeights.mjs
var lineHeights = __webpack_require__(91620);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/eero/components/text.mjs
function cov_1envy28gxf() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/eero/components/text.ts";
  var hash = "7f0129b4d4b5ad328b7b860b61958501163296a3";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/eero/components/text.ts",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 44
        },
        end: {
          line: 11,
          column: 1
        }
      },
      "1": {
        start: {
          line: 15,
          column: 4
        },
        end: {
          line: 121,
          column: 1
        }
      },
      "2": {
        start: {
          line: 125,
          column: 4
        },
        end: {
          line: 181,
          column: 1
        }
      },
      "3": {
        start: {
          line: 183,
          column: 21
        },
        end: {
          line: 185,
          column: 1
        }
      },
      "4": {
        start: {
          line: 191,
          column: 30
        },
        end: {
          line: 198,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "7f0129b4d4b5ad328b7b860b61958501163296a3"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1envy28gxf = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1envy28gxf();


















function text_typeof(o) { "@babel/helpers - typeof"; return text_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, text_typeof(o); }
function text_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function text_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? text_ownKeys(Object(t), !0).forEach(function (r) { text_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : text_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function text_defineProperty(obj, key, value) { key = text_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function text_toPropertyKey(t) { var i = text_toPrimitive(t, "string"); return "symbol" == text_typeof(i) ? i : String(i); }
function text_toPrimitive(t, r) { if ("object" != text_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != text_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable import/no-deprecated */


var text_baseStyle = (cov_1envy28gxf().s[0]++, {
  fontFamily: fonts/* fonts.sans */.R.sans,
  fontWeight: fontWeights/* fontWeights.regular */.v.regular,
  color: colors/* default.neutrals100 */.ZP.neutrals100
});
var text_sizes = (cov_1envy28gxf().s[1]++, {
  80: {
    fontSize: '11px',
    lineHeight: '150',
    letterSpacing: '-1.4'
  },
  90: {
    fontSize: '12px',
    lineHeight: '150',
    letterSpacing: '-1.4'
  },
  100: {
    fontSize: '14px',
    lineHeight: '140',
    letterSpacing: '-1.4'
  },
  110: {
    fontSize: '16px',
    lineHeight: '130',
    letterSpacing: '-1.4'
  },
  '110-L': {
    fontSize: '16px',
    lineHeight: '160',
    letterSpacing: '-1.4'
  },
  120: {
    fontSize: ['16px', null, '18px'],
    lineHeight: '120',
    letterSpacing: '-2.4'
  },
  130: {
    fontSize: ['16px', null, '20px'],
    lineHeight: '120',
    letterSpacing: '-2.4'
  },
  140: {
    fontSize: ['18px', null, '22px'],
    lineHeight: '112',
    letterSpacing: '-2.4'
  },
  150: {
    fontSize: ['18px', null, '24px'],
    lineHeight: '112',
    letterSpacing: '-2.8'
  },
  160: {
    fontSize: ['20px', null, '28px'],
    lineHeight: '110',
    letterSpacing: '-2.8'
  },
  170: {
    fontSize: ['20px', null, '32px'],
    lineHeight: '110',
    letterSpacing: '-2.8'
  },
  180: {
    fontSize: ['22px', null, '36px'],
    lineHeight: '100',
    letterSpacing: '-3'
  },
  190: {
    fontSize: ['24px', null, '40px'],
    lineHeight: '100',
    letterSpacing: '-3'
  },
  200: {
    fontSize: ['28px', null, '44px'],
    lineHeight: '100',
    letterSpacing: '-3'
  },
  210: {
    fontSize: ['32px', null, '48px'],
    lineHeight: '100',
    letterSpacing: '-3'
  },
  220: {
    fontSize: ['36px', null, '56px'],
    lineHeight: '100',
    letterSpacing: '-3.4'
  },
  230: {
    fontSize: ['40px', null, '64px'],
    lineHeight: '100',
    letterSpacing: '-3.4'
  },
  240: {
    fontSize: ['44px', null, '80px'],
    lineHeight: '100',
    letterSpacing: '-3.4'
  },
  250: {
    fontSize: ['56px', null, '88px'],
    lineHeight: '100',
    letterSpacing: '-3.4'
  },
  260: {
    fontSize: ['64px', null, '96px'],
    lineHeight: '100',
    letterSpacing: '-3.4'
  },
  270: {
    fontSize: ['68px', null, '96px'],
    lineHeight: '100',
    letterSpacing: '-3.4'
  }
});
var deprecatedSizes = (cov_1envy28gxf().s[2]++, {
  /** @deprecated */
  s8: {
    fontSize: fontSizes/* fontSizesNamed.s8 */.gj.s8,
    lineHeight: lineHeights/* lineHeights.s8 */.t.s8
  },
  /** @deprecated */
  s7: {
    fontSize: fontSizes/* fontSizesNamed.s7 */.gj.s7,
    lineHeight: lineHeights/* lineHeights.s7 */.t.s7
  },
  /** @deprecated */
  s6: {
    fontSize: fontSizes/* fontSizesNamed.s6 */.gj.s6,
    lineHeight: lineHeights/* lineHeights.s6 */.t.s6
  },
  /** @deprecated */
  s5: {
    fontSize: fontSizes/* fontSizesNamed.s5 */.gj.s5,
    lineHeight: lineHeights/* lineHeights.s5 */.t.s5
  },
  /** @deprecated */
  s4: {
    fontSize: fontSizes/* fontSizesNamed.s4 */.gj.s4,
    lineHeight: lineHeights/* lineHeights.s4 */.t.s4
  },
  /** @deprecated */
  s3: {
    fontSize: fontSizes/* fontSizesNamed.s3 */.gj.s3,
    lineHeight: lineHeights/* lineHeights.s3 */.t.s3
  },
  /** @deprecated */
  s2: {
    fontSize: fontSizes/* fontSizesNamed.s2 */.gj.s2,
    lineHeight: lineHeights/* lineHeights.s2 */.t.s2
  },
  /** @deprecated */
  s1: {
    fontSize: fontSizes/* fontSizesNamed.s1 */.gj.s1,
    lineHeight: lineHeights/* lineHeights.s1 */.t.s1
  },
  /** @deprecated */
  s0: {
    fontSize: fontSizes/* fontSizesNamed.s0 */.gj.s0,
    lineHeight: lineHeights/* lineHeights.s0 */.t.s0
  },
  /** @deprecated */
  s00: {
    fontSize: fontSizes/* fontSizesNamed.s00 */.gj.s00,
    lineHeight: lineHeights/* lineHeights.s00 */.t.s00
  },
  /** @deprecated */
  s000: {
    fontSize: fontSizes/* fontSizesNamed.s000 */.gj.s000,
    lineHeight: lineHeights/* lineHeights.s000 */.t.s000
  }
});
var text_defaultProps = (cov_1envy28gxf().s[3]++, {
  sizes: '110'
});
var text_text = (cov_1envy28gxf().s[4]++, {
  baseStyle: text_baseStyle,
  sizes: text_objectSpread(text_objectSpread({}, text_sizes), deprecatedSizes),
  defaultProps: text_defaultProps
});
/* harmony default export */ var components_text = (text_text);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/eero/components/heading.mjs
function cov_16w98tyiqo() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/eero/components/heading.ts";
  var hash = "24a93768b14379b2ba8634fddfe456bb85e629e1";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/eero/components/heading.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 44
        },
        end: {
          line: 10,
          column: 1
        }
      },
      "1": {
        start: {
          line: 12,
          column: 66
        },
        end: {
          line: 44,
          column: 1
        }
      },
      "2": {
        start: {
          line: 46,
          column: 21
        },
        end: {
          line: 48,
          column: 1
        }
      },
      "3": {
        start: {
          line: 53,
          column: 36
        },
        end: {
          line: 53,
          column: 70
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "24a93768b14379b2ba8634fddfe456bb85e629e1"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_16w98tyiqo = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_16w98tyiqo();
function heading_typeof(o) { "@babel/helpers - typeof"; return heading_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, heading_typeof(o); }



















function heading_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function heading_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? heading_ownKeys(Object(t), !0).forEach(function (r) { heading_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : heading_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function heading_defineProperty(obj, key, value) { key = heading_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function heading_toPropertyKey(t) { var i = heading_toPrimitive(t, "string"); return "symbol" == heading_typeof(i) ? i : String(i); }
function heading_toPrimitive(t, r) { if ("object" != heading_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != heading_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


var heading_baseStyle = (cov_16w98tyiqo().s[0]++, {
  fontWeight: fontWeights/* fontWeights.semibold */.v.semibold,
  fontFamily: fonts/* fonts.sans */.R.sans,
  color: colors/* default.neutrals100 */.ZP.neutrals100
});
var heading_sizes = (cov_16w98tyiqo().s[1]++, heading_objectSpread(heading_objectSpread({}, text_sizes), {}, {
  /** @deprecated */
  UNSAFE_h6: {},
  /** @deprecated */
  UNSAFE_h5: {},
  /** @deprecated */
  UNSAFE_h4: {
    fontSize: fontSizes/* fontSizesNamed.s2 */.gj.s2,
    lineHeight: lineHeights/* lineHeights.s2 */.t.s2,
    fontWeight: fontWeights/* fontWeights.semibold */.v.semibold
  },
  /** @deprecated */
  UNSAFE_h3: {
    fontSize: fontSizes/* fontSizesNamed.s3 */.gj.s3,
    lineHeight: lineHeights/* lineHeights.s3 */.t.s3,
    fontWeight: fontWeights/* fontWeights.bold */.v.bold
  },
  /** @deprecated */
  UNSAFE_h2: {
    fontSize: fontSizes/* fontSizesNamed.s4 */.gj.s4,
    lineHeight: lineHeights/* lineHeights.s4 */.t.s4,
    fontWeight: fontWeights/* fontWeights.bold */.v.bold
  },
  /** @deprecated */
  UNSAFE_h1: {
    fontSize: fontSizes/* fontSizesNamed.s5 */.gj.s5,
    lineHeight: lineHeights/* lineHeights.s5 */.t.s5,
    fontWeight: fontWeights/* fontWeights.bold */.v.bold,
    fontFamily: fonts/* fonts.sans */.R.sans
  }
}));
var heading_defaultProps = (cov_16w98tyiqo().s[2]++, {
  sizes: 'h4'
});
var heading = (cov_16w98tyiqo().s[3]++, {
  baseStyle: heading_baseStyle,
  sizes: heading_sizes,
  defaultProps: heading_defaultProps
});
/* harmony default export */ var components_heading = (heading);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/eero/components/image.mjs
function cov_qrhj5s6ig() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/eero/components/image.ts";
  var hash = "8ba3d4470930da46927496ce14cc7e4d89ae4320";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/eero/components/image.ts",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 42
        },
        end: {
          line: 8,
          column: 1
        }
      },
      "1": {
        start: {
          line: 9,
          column: 43
        },
        end: {
          line: 9,
          column: 45
        }
      },
      "2": {
        start: {
          line: 15,
          column: 32
        },
        end: {
          line: 18,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "8ba3d4470930da46927496ce14cc7e4d89ae4320"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_qrhj5s6ig = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_qrhj5s6ig();
var image_primary = (cov_qrhj5s6ig().s[0]++, {
  m: 0,
  height: 'auto',
  maxWidth: '100%'
});
var unstyled = (cov_qrhj5s6ig().s[1]++, {});
var image_image = (cov_qrhj5s6ig().s[2]++, {
  variants: {
    primary: image_primary,
    unstyled: unstyled
  },
  defaultProps: {
    variant: 'primary'
  }
});
/* harmony default export */ var components_image = (image_image);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/theme/eero/foundations/radii.mjs
var radii = __webpack_require__(79848);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/theme/eero/foundations/space.mjs
var space = __webpack_require__(99425);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/eero/components/input.mjs
function cov_2kjyeu216s() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/eero/components/input.ts";
  var hash = "8e4760d075fe5db7d8cb0a491f7cc0205d28e9e0";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/eero/components/input.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 44
        },
        end: {
          line: 33,
          column: 1
        }
      },
      "1": {
        start: {
          line: 35,
          column: 42
        },
        end: {
          line: 35,
          column: 55
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "8e4760d075fe5db7d8cb0a491f7cc0205d28e9e0"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2kjyeu216s = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2kjyeu216s();


var input_baseStyle = (cov_2kjyeu216s().s[0]++, {
  boxSizing: 'border-box',
  textOverflow: 'ellipsis',
  transition: 'color 0.3s ease',
  fontSize: fontSizes/* fontSizesNamedWithUnits.s1 */.NR.s1,
  width: '100%',
  border: "2px solid ".concat(colors/* colors.neutrals40 */.O9.neutrals40),
  borderRadius: radii/* default.roundedSquare */.Z.roundedSquare,
  padding: space/* spaceWithUnits.4 */.u[4],
  _placeholder: {
    color: colors/* colors.neutrals90 */.O9.neutrals90,
    opacity: 1
  },
  _disabled: {
    bgcolor: colors/* colors.neutrals10 */.O9.neutrals10,
    color: colors/* colors.neutrals70 */.O9.neutrals70,
    cursor: 'not-allowed',
    _placeholder: {
      color: colors/* colors.neutrals70 */.O9.neutrals70
    }
  },
  _focus: {
    outline: 'none',
    border: "2px solid ".concat(colors/* colors.neutrals100 */.O9.neutrals100)
  },
  _invalid: {
    border: "2px solid ".concat(colors/* colors.red50 */.O9.red50)
  }
});
var input = (cov_2kjyeu216s().s[1]++, {
  baseStyle: input_baseStyle
});
/* harmony default export */ var components_input = (input);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/eero/components/label.mjs
function cov_2bjvdf14hr() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/eero/components/label.ts";
  var hash = "01b6752dd60ae08d1b6bf9c0999388599aa7b476";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/eero/components/label.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 52
        },
        end: {
          line: 15,
          column: 1
        }
      },
      "1": {
        start: {
          line: 17,
          column: 50
        },
        end: {
          line: 20,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "01b6752dd60ae08d1b6bf9c0999388599aa7b476"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2bjvdf14hr = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2bjvdf14hr();





var label_baseStyle = (cov_2bjvdf14hr().s[0]++, {
  label: {
    fontSize: fontSizes/* fontSizesNamedWithUnits.s1 */.NR.s1,
    fontWeight: fontWeights/* fontWeights.semibold */.v.semibold,
    textAlign: 'left'
  },
  requiredIndicator: {
    marginStart: 1,
    color: 'red50'
  }
});
var label = (cov_2bjvdf14hr().s[1]++, {
  parts: anatomy_types/* labelAnatomy.keys */.yo.keys,
  baseStyle: label_baseStyle
});
/* harmony default export */ var components_label = (label);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__(26699);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__(32023);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/eero/components/link.mjs
function cov_1cy80jfzde() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/eero/components/link.ts";
  var hash = "20505ce66837550ef93300ad06de6b510c257847";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/eero/components/link.ts",
    statementMap: {
      "0": {
        start: {
          line: 17,
          column: 45
        },
        end: {
          line: 38,
          column: 2
        }
      },
      "1": {
        start: {
          line: 17,
          column: 64
        },
        end: {
          line: 38,
          column: 1
        }
      },
      "2": {
        start: {
          line: 40,
          column: 76
        },
        end: {
          line: 71,
          column: 1
        }
      },
      "3": {
        start: {
          line: 74,
          column: 66
        },
        end: {
          line: 78,
          column: 1
        }
      },
      "4": {
        start: {
          line: 75,
          column: 24
        },
        end: {
          line: 75,
          column: 77
        }
      },
      "5": {
        start: {
          line: 76,
          column: 24
        },
        end: {
          line: 76,
          column: 77
        }
      },
      "6": {
        start: {
          line: 77,
          column: 24
        },
        end: {
          line: 77,
          column: 77
        }
      },
      "7": {
        start: {
          line: 85,
          column: 30
        },
        end: {
          line: 91,
          column: 1
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 17,
            column: 45
          },
          end: {
            line: 17,
            column: 46
          }
        },
        loc: {
          start: {
            line: 17,
            column: 64
          },
          end: {
            line: 38,
            column: 1
          }
        },
        line: 17
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 75,
            column: 6
          },
          end: {
            line: 75,
            column: 7
          }
        },
        loc: {
          start: {
            line: 75,
            column: 24
          },
          end: {
            line: 75,
            column: 77
          }
        },
        line: 75
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 76,
            column: 6
          },
          end: {
            line: 76,
            column: 7
          }
        },
        loc: {
          start: {
            line: 76,
            column: 24
          },
          end: {
            line: 76,
            column: 77
          }
        },
        line: 76
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 77,
            column: 6
          },
          end: {
            line: 77,
            column: 7
          }
        },
        loc: {
          start: {
            line: 77,
            column: 24
          },
          end: {
            line: 77,
            column: 77
          }
        },
        line: 77
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 24,
            column: 11
          },
          end: {
            line: 24,
            column: 46
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 24,
            column: 22
          },
          end: {
            line: 24,
            column: 34
          }
        }, {
          start: {
            line: 24,
            column: 37
          },
          end: {
            line: 24,
            column: 46
          }
        }],
        line: 24
      },
      "1": {
        loc: {
          start: {
            line: 25,
            column: 12
          },
          end: {
            line: 25,
            column: 48
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 25,
            column: 23
          },
          end: {
            line: 25,
            column: 36
          }
        }, {
          start: {
            line: 25,
            column: 39
          },
          end: {
            line: 25,
            column: 48
          }
        }],
        line: 25
      },
      "2": {
        loc: {
          start: {
            line: 28,
            column: 13
          },
          end: {
            line: 28,
            column: 48
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 28,
            column: 24
          },
          end: {
            line: 28,
            column: 36
          }
        }, {
          start: {
            line: 28,
            column: 39
          },
          end: {
            line: 28,
            column: 48
          }
        }],
        line: 28
      },
      "3": {
        loc: {
          start: {
            line: 32,
            column: 13
          },
          end: {
            line: 32,
            column: 48
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 32,
            column: 24
          },
          end: {
            line: 32,
            column: 36
          }
        }, {
          start: {
            line: 32,
            column: 39
          },
          end: {
            line: 32,
            column: 48
          }
        }],
        line: 32
      },
      "4": {
        loc: {
          start: {
            line: 75,
            column: 24
          },
          end: {
            line: 75,
            column: 77
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 75,
            column: 53
          },
          end: {
            line: 75,
            column: 72
          }
        }, {
          start: {
            line: 75,
            column: 75
          },
          end: {
            line: 75,
            column: 77
          }
        }],
        line: 75
      },
      "5": {
        loc: {
          start: {
            line: 76,
            column: 24
          },
          end: {
            line: 76,
            column: 77
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 76,
            column: 53
          },
          end: {
            line: 76,
            column: 72
          }
        }, {
          start: {
            line: 76,
            column: 75
          },
          end: {
            line: 76,
            column: 77
          }
        }],
        line: 76
      },
      "6": {
        loc: {
          start: {
            line: 77,
            column: 24
          },
          end: {
            line: 77,
            column: 77
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 77,
            column: 53
          },
          end: {
            line: 77,
            column: 72
          }
        }, {
          start: {
            line: 77,
            column: 75
          },
          end: {
            line: 77,
            column: 77
          }
        }],
        line: 77
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "20505ce66837550ef93300ad06de6b510c257847"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1cy80jfzde = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1cy80jfzde();
function link_typeof(o) { "@babel/helpers - typeof"; return link_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, link_typeof(o); }




















function link_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function link_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? link_ownKeys(Object(t), !0).forEach(function (r) { link_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : link_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function link_defineProperty(obj, key, value) { key = link_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function link_toPropertyKey(t) { var i = link_toPrimitive(t, "string"); return "symbol" == link_typeof(i) ? i : String(i); }
function link_toPrimitive(t, r) { if ("object" != link_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != link_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


cov_1cy80jfzde().s[0]++;
var nav = function nav(_ref) {
  var disabled = _ref.disabled;
  cov_1cy80jfzde().f[0]++;
  cov_1cy80jfzde().s[1]++;
  return {
    icon: {
      mx: 1
    },
    link: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      textDecoration: 'none',
      color: disabled ? (cov_1cy80jfzde().b[0][0]++, 'neutrals70') : (cov_1cy80jfzde().b[0][1]++, 'brand50'),
      cursor: disabled ? (cov_1cy80jfzde().b[1][0]++, 'not-allowed') : (cov_1cy80jfzde().b[1][1]++, 'pointer'),
      _hover: {
        backgroundColor: 'none',
        color: disabled ? (cov_1cy80jfzde().b[2][0]++, 'neutrals70') : (cov_1cy80jfzde().b[2][1]++, 'brand40')
      },
      _active: {
        backgroundColor: 'none',
        color: disabled ? (cov_1cy80jfzde().b[3][0]++, 'neutrals70') : (cov_1cy80jfzde().b[3][1]++, 'brand30')
      }
    },
    content: {
      alignItems: 'center'
    }
  };
};
var link_variants = (cov_1cy80jfzde().s[2]++, {
  /** @deprecated */
  primary: {
    link: link_objectSpread(link_objectSpread({}, sharedCta_link), resetLinkStyles)
  },
  'inline-primary': {
    link: link_objectSpread({}, sharedCta_link)
  },
  'inline-secondary': {
    link: link_objectSpread({}, secondaryLink)
  },
  nav: nav,
  /**
   * NOTE: This is a known antipattern, however for conversion reasons this is occasionally a
   * requirement. Make sure to verify with design that this behavior is absolutely necessary
   * and appropriate a11y concerns were considered.
   */
  'primary-button': {
    link: link_objectSpread(link_objectSpread(link_objectSpread({}, resetLinkStyles), buttonBaseStyles), primaryButton)
  },
  /**
   * NOTE: This is a known antipattern, however for conversion reasons this is occasionally a
   * requirement. Make sure to verify with design that this behavior is absolutely necessary
   * and appropriate a11y concerns were considered.
   */
  'secondary-button': {
    link: link_objectSpread(link_objectSpread(link_objectSpread({}, resetLinkStyles), buttonBaseStyles), secondaryButton)
  }
});

/** NOTE: Sizes only get applied for button variants */
var link_sizes = (cov_1cy80jfzde().s[3]++, {
  sm: function sm(_ref2) {
    var variant = _ref2.variant;
    cov_1cy80jfzde().f[1]++;
    cov_1cy80jfzde().s[4]++;
    return variant.includes('button') ? (cov_1cy80jfzde().b[4][0]++, {
      link: link_objectSpread({}, sharedCta_sm)
    }) : (cov_1cy80jfzde().b[4][1]++, {});
  },
  md: function md(_ref3) {
    var variant = _ref3.variant;
    cov_1cy80jfzde().f[2]++;
    cov_1cy80jfzde().s[5]++;
    return variant.includes('button') ? (cov_1cy80jfzde().b[5][0]++, {
      link: link_objectSpread({}, sharedCta_md)
    }) : (cov_1cy80jfzde().b[5][1]++, {});
  },
  lg: function lg(_ref4) {
    var variant = _ref4.variant;
    cov_1cy80jfzde().f[3]++;
    cov_1cy80jfzde().s[6]++;
    return variant.includes('button') ? (cov_1cy80jfzde().b[6][0]++, {
      link: link_objectSpread({}, sharedCta_lg)
    }) : (cov_1cy80jfzde().b[6][1]++, {});
  }
});
var link_link = (cov_1cy80jfzde().s[7]++, {
  parts: anatomy_types/* linkAnatomy.keys */.Ut.keys,
  baseStyle: {
    link: link_objectSpread({}, linkBaseStyles)
  },
  variants: link_variants,
  sizes: link_sizes,
  defaultProps: {
    variant: 'primary'
  }
});
/* harmony default export */ var components_link = (link_link);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(92222);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/SpritesheetIcons/Checkmark.mjs
var Checkmark = __webpack_require__(77972);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/eero/components/list.mjs
function cov_186xepgpwm() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/eero/components/list.ts";
  var hash = "ff6e02392d335dec87011b980bc5578536380179";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/eero/components/list.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 62
        },
        end: {
          line: 25,
          column: 2
        }
      },
      "1": {
        start: {
          line: 10,
          column: 7
        },
        end: {
          line: 25,
          column: 1
        }
      },
      "2": {
        start: {
          line: 45,
          column: 50
        },
        end: {
          line: 47,
          column: 1
        }
      },
      "3": {
        start: {
          line: 48,
          column: 49
        },
        end: {
          line: 50,
          column: 1
        }
      },
      "4": {
        start: {
          line: 51,
          column: 46
        },
        end: {
          line: 53,
          column: 1
        }
      },
      "5": {
        start: {
          line: 54,
          column: 48
        },
        end: {
          line: 56,
          column: 1
        }
      },
      "6": {
        start: {
          line: 57,
          column: 51
        },
        end: {
          line: 76,
          column: 1
        }
      },
      "7": {
        start: {
          line: 62,
          column: 15
        },
        end: {
          line: 62,
          column: 37
        }
      },
      "8": {
        start: {
          line: 63,
          column: 2
        },
        end: {
          line: 75,
          column: 4
        }
      },
      "9": {
        start: {
          line: 77,
          column: 46
        },
        end: {
          line: 79,
          column: 1
        }
      },
      "10": {
        start: {
          line: 80,
          column: 51
        },
        end: {
          line: 82,
          column: 2
        }
      },
      "11": {
        start: {
          line: 80,
          column: 58
        },
        end: {
          line: 82,
          column: 1
        }
      },
      "12": {
        start: {
          line: 86,
          column: 4
        },
        end: {
          line: 86,
          column: 67
        }
      },
      "13": {
        start: {
          line: 92,
          column: 4
        },
        end: {
          line: 95,
          column: 1
        }
      },
      "14": {
        start: {
          line: 102,
          column: 30
        },
        end: {
          line: 108,
          column: 1
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 62
          },
          end: {
            line: 6,
            column: 63
          }
        },
        loc: {
          start: {
            line: 10,
            column: 7
          },
          end: {
            line: 25,
            column: 1
          }
        },
        line: 10
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 57,
            column: 51
          },
          end: {
            line: 57,
            column: 52
          }
        },
        loc: {
          start: {
            line: 61,
            column: 6
          },
          end: {
            line: 76,
            column: 1
          }
        },
        line: 61
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 80,
            column: 51
          },
          end: {
            line: 80,
            column: 52
          }
        },
        loc: {
          start: {
            line: 80,
            column: 58
          },
          end: {
            line: 82,
            column: 1
          }
        },
        line: 80
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 17,
            column: 21
          },
          end: {
            line: 17,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 17,
            column: 21
          },
          end: {
            line: 17,
            column: 28
          }
        }, {
          start: {
            line: 17,
            column: 32
          },
          end: {
            line: 17,
            column: 47
          }
        }, {
          start: {
            line: 17,
            column: 51
          },
          end: {
            line: 17,
            column: 60
          }
        }],
        line: 17
      },
      "1": {
        loc: {
          start: {
            line: 62,
            column: 15
          },
          end: {
            line: 62,
            column: 37
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 62,
            column: 15
          },
          end: {
            line: 62,
            column: 29
          }
        }, {
          start: {
            line: 62,
            column: 33
          },
          end: {
            line: 62,
            column: 37
          }
        }],
        line: 62
      },
      "2": {
        loc: {
          start: {
            line: 67,
            column: 11
          },
          end: {
            line: 67,
            column: 38
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 67,
            column: 11
          },
          end: {
            line: 67,
            column: 21
          }
        }, {
          start: {
            line: 67,
            column: 25
          },
          end: {
            line: 67,
            column: 38
          }
        }],
        line: 67
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "ff6e02392d335dec87011b980bc5578536380179"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_186xepgpwm = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_186xepgpwm();







cov_186xepgpwm().s[0]++;
var baseListStyle = function baseListStyle(_ref) {
  var _ref2, _ref3;
  var bgColor = _ref.bgColor,
    backgroundColor = _ref.backgroundColor,
    color = _ref.color;
  cov_186xepgpwm().f[0]++;
  cov_186xepgpwm().s[1]++;
  return {
    container: {
      width: '100%',
      borderRadius: 'none'
    },
    list: {
      m: 0,
      pl: 5,
      listStyleType: 'none',
      listStylePosition: 'outside',
      backgroundColor: (_ref2 = (_ref3 = (cov_186xepgpwm().b[0][0]++, bgColor)) !== null && _ref3 !== void 0 ? _ref3 : (cov_186xepgpwm().b[0][1]++, backgroundColor)) !== null && _ref2 !== void 0 ? _ref2 : (cov_186xepgpwm().b[0][2]++, 'inherit'),
      color: color
    },
    title: {
      fontSize: 's2',
      fontWeight: 'semibold',
      color: 'neutrals90'
    }
  };
};

// Provide a custom SVG string, color, and size for this Icon.
// If you want to use an existing icon, use it as follows:
// import VideoFilled from '../Icon/SpritesheetIcons/VideoFilled';
// <List
//   variant="checklist"
//   customIcon={{ svg: VideoFilled.svg, color: colors.green50, size: '20' }}
// >

var numbered = (cov_186xepgpwm().s[2]++, {
  list: {
    listStyleType: 'numeric'
  }
});
var decimal = (cov_186xepgpwm().s[3]++, {
  list: {
    listStyleType: 'decimal'
  }
});
var list_text = (cov_186xepgpwm().s[4]++, {
  list: {
    pl: 0
  }
});
var bullet = (cov_186xepgpwm().s[5]++, {
  list: {
    listStyleType: 'disc'
  }
});
cov_186xepgpwm().s[6]++;
var checklist = function checklist(_ref4) {
  var _ref5, _ref6;
  var dataURISVG = _ref4.dataURISVG,
    dataURISVGColor = _ref4.dataURISVGColor,
    dataURISVGSize = _ref4.dataURISVGSize;
  cov_186xepgpwm().f[1]++;
  var size = (cov_186xepgpwm().s[7]++, (_ref5 = (cov_186xepgpwm().b[1][0]++, dataURISVGSize)) !== null && _ref5 !== void 0 ? _ref5 : (cov_186xepgpwm().b[1][1]++, '12'));
  cov_186xepgpwm().s[8]++;
  return {
    list: {
      listStyleImage: "url(\"".concat((0,helpers/* svgToStyledDataURI */.YX)("<svg xmlns=\"http://www.w3.org/2000/svg\" width='".concat(size, "' height='").concat(size, "' viewBox=\"0 0 24 24\">") + ((_ref6 = (cov_186xepgpwm().b[2][0]++, dataURISVG)) !== null && _ref6 !== void 0 ? _ref6 : (cov_186xepgpwm().b[2][1]++, Checkmark/* default.svg */.Z.svg)) + '</svg>', {
        color: dataURISVGColor
      }), "\")"),
      pl: 7
    }
  };
};
var list_card = (cov_186xepgpwm().s[9]++, {
  list: {
    pl: 0
  }
});
cov_186xepgpwm().s[10]++;
var accordion = function accordion() {
  cov_186xepgpwm().f[2]++;
  cov_186xepgpwm().s[11]++;
  return {
    list: {
      pl: 0
    }
  };
};
var list_variants = (cov_186xepgpwm().s[12]++, {
  text: list_text,
  bullet: bullet,
  checklist: checklist,
  card: list_card,
  accordion: accordion,
  numbered: numbered,
  decimal: decimal
});
var list_sizes = (cov_186xepgpwm().s[13]++, {
  compact: {},
  standard: {}
});
var list = (cov_186xepgpwm().s[14]++, {
  parts: anatomy_types/* listAnatomy.keys */.vE.keys,
  baseStyle: baseListStyle,
  variants: list_variants,
  sizes: list_sizes,
  defaultProps: {
    variant: 'text',
    size: 'standard'
  }
});
/* harmony default export */ var components_list = (list);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/eero/components/listItem.mjs
function cov_1do4nudgdi() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/eero/components/listItem.ts";
  var hash = "388446e85ed4510e6d5535469d4514092497193e";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/eero/components/listItem.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 45
        },
        end: {
          line: 10,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "388446e85ed4510e6d5535469d4514092497193e"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1do4nudgdi = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1do4nudgdi();
var listItem = (cov_1do4nudgdi().s[0]++, {
  baseStyle: {
    breakInside: 'avoid',
    pageBreakInside: 'avoid',
    m: 0,
    pl: 0
  }
});
/* harmony default export */ var components_listItem = (listItem);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/eero/components/radio.mjs
function cov_1gher9d0wo() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/eero/components/radio.ts";
  var hash = "4384231596c866086bbaa48d0edebb46026cac94";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/eero/components/radio.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 53
        },
        end: {
          line: 13,
          column: 1
        }
      },
      "1": {
        start: {
          line: 14,
          column: 54
        },
        end: {
          line: 18,
          column: 1
        }
      },
      "2": {
        start: {
          line: 23,
          column: 44
        },
        end: {
          line: 58,
          column: 1
        }
      },
      "3": {
        start: {
          line: 60,
          column: 42
        },
        end: {
          line: 62,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "4384231596c866086bbaa48d0edebb46026cac94"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1gher9d0wo = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1gher9d0wo();


















function radio_typeof(o) { "@babel/helpers - typeof"; return radio_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, radio_typeof(o); }
function radio_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function radio_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? radio_ownKeys(Object(t), !0).forEach(function (r) { radio_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : radio_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function radio_defineProperty(obj, key, value) { key = radio_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function radio_toPropertyKey(t) { var i = radio_toPrimitive(t, "string"); return "symbol" == radio_typeof(i) ? i : String(i); }
function radio_toPrimitive(t, r) { if ("object" != radio_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != radio_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var defaultRadioButton = (cov_1gher9d0wo().s[0]++, {
  width: '12px',
  height: '12px',
  margin: '2px',
  content: "\"\"",
  position: 'absolute',
  left: '0',
  top: '0',
  cursor: 'pointer',
  borderRadius: 'rounded'
});
var disabledRadioButton = (cov_1gher9d0wo().s[1]++, {
  content: "\"\"",
  opacity: '40%',
  cursor: 'default'
});

// Custom styling for the radio button & hides input
// Used pseudo-elements & adjacent sibiling selectors to create a custom accessible radio button
// https://medium.com/claritydesignsystem/pure-css-accessible-checkboxes-and-radios-buttons-54063e759bb3
var radio_baseStyle = (cov_1gher9d0wo().s[2]++, {
  // opacity: 0 visually hides this input in an accessible way so we can create our own custom radio
  // do not use display: none this completely removes the element from the dom flow and we still want to use input's features like _focus & _checked to style our custom radio
  // https://dev.to/lkopacz/create-custom-keyboard-accessible-radio-buttons-22eh <- article that was used by chakra - https://chakra-ui.com/docs/components/form/radio
  opacity: 0,
  position: 'absolute',
  // & + label styles is applied to the label component immediately after the input to style a custom radio button
  '& + label': {
    position: 'relative',
    paddingLeft: '23px',
    _before: radio_objectSpread({
      boxShadow: " 0 0 0 1px var(--colors-neutrals40)",
      transition: 'all 0.15s cubic-bezier(0.1, 0.7, 0.1, 1)',
      bg: 'neutrals0',
      border: "2px solid var(--colors-neutrals40)"
    }, defaultRadioButton)
  },
  '&:checked + label': {
    _after: radio_objectSpread({
      border: "2px solid var(--colors-brand50)",
      boxShadow: "inset 0px 0px 0px 2px var(--colors-brand50)"
    }, defaultRadioButton)
  },
  _disabled: {
    '& + label': {
      _before: radio_objectSpread({}, disabledRadioButton),
      _after: radio_objectSpread({}, disabledRadioButton)
    }
  }
});
var radio_radio = (cov_1gher9d0wo().s[3]++, {
  baseStyle: radio_baseStyle
});
/* harmony default export */ var components_radio = (radio_radio);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/theme/eero/foundations/breakpoints.mjs
var breakpoints = __webpack_require__(64863);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/eero/components/tab.mjs
function tab_typeof(o) { "@babel/helpers - typeof"; return tab_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, tab_typeof(o); }
function cov_s0funll3m() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/eero/components/tab.ts";
  var hash = "368a8d84155968b463595fdd003098d4286409c7";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/eero/components/tab.ts",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 24
        },
        end: {
          line: 26,
          column: 1
        }
      },
      "1": {
        start: {
          line: 28,
          column: 25
        },
        end: {
          line: 55,
          column: 1
        }
      },
      "2": {
        start: {
          line: 58,
          column: 16
        },
        end: {
          line: 65,
          column: 1
        }
      },
      "3": {
        start: {
          line: 68,
          column: 16
        },
        end: {
          line: 68,
          column: 31
        }
      },
      "4": {
        start: {
          line: 70,
          column: 15
        },
        end: {
          line: 73,
          column: 1
        }
      },
      "5": {
        start: {
          line: 75,
          column: 15
        },
        end: {
          line: 92,
          column: 1
        }
      },
      "6": {
        start: {
          line: 94,
          column: 68
        },
        end: {
          line: 101,
          column: 1
        }
      },
      "7": {
        start: {
          line: 107,
          column: 28
        },
        end: {
          line: 124,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "368a8d84155968b463595fdd003098d4286409c7"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_s0funll3m = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_s0funll3m();
function tab_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function tab_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? tab_ownKeys(Object(t), !0).forEach(function (r) { tab_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : tab_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function tab_defineProperty(obj, key, value) { key = tab_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function tab_toPropertyKey(t) { var i = tab_toPrimitive(t, "string"); return "symbol" == tab_typeof(i) ? i : String(i); }
function tab_toPrimitive(t, r) { if ("object" != tab_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != tab_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }






















/** @deprecated */
var oldCommonStyles = (cov_s0funll3m().s[0]++, {
  color: colors/* default.neutrals100 */.ZP.neutrals100,
  fontSize: fontSizes/* fontSizesWithUnits.s1 */.Vu.s1,
  borderRadius: radii/* default.squared */.Z.squared,
  padding: space/* spaceWithUnits.5 */.u[5],
  '&:hover': {
    color: colors/* default.neutrals100 */.ZP.neutrals100
  },
  '&.disabled': {
    opacity: 0.25,
    cursor: 'auto',
    userSelect: 'none',
    '&:hover': {
      color: colors/* default.neutrals90 */.ZP.neutrals90
    }
  }
});
var eeroCommonStyles = (cov_s0funll3m().s[1]++, {
  fontWeight: fontWeights/* fontWeights.semibold */.v.semibold,
  color: colors/* default.neutrals70 */.ZP.neutrals70,
  fontSize: fontSizes/* fontSizesWithUnits.s0 */.Vu.s0,
  borderRadius: radii/* default.semiRounded */.Z.semiRounded,
  padding: "".concat(space/* spaceWithUnits.4 */.u[4], " ").concat(space/* spaceWithUnits.5 */.u[5], " ").concat(space/* spaceWithUnits.4 */.u[4], " ").concat(space/* spaceWithUnits.4 */.u[4]),
  '&:hover': {
    color: colors/* default.neutrals100 */.ZP.neutrals100
  },
  '&.active': {
    color: colors/* default.neutrals100 */.ZP.neutrals100
  },
  '&.syncIconStyle svg': {
    color: "".concat(colors/* default.neutrals70 */.ZP.neutrals70, " !important"),
    transition: 'all 0.3s ease'
  },
  '&.syncIconStyle:hover svg': {
    color: "".concat(colors/* default.neutrals100 */.ZP.neutrals100, " !important")
  },
  '&.active.syncIconStyle svg': {
    color: "".concat(colors/* default.neutrals100 */.ZP.neutrals100, " !important")
  }
});

/** @deprecated */
var navItem = (cov_s0funll3m().s[2]++, tab_objectSpread(tab_objectSpread({}, oldCommonStyles), {}, {
  '&.active': {
    color: colors/* default.neutrals100 */.ZP.neutrals100,
    fontWeight: fontWeights/* fontWeights.semibold */.v.semibold,
    backgroundColor: colors/* default.blue30 */.ZP.blue30
  }
}));

/** @deprecated */
var navLink = (cov_s0funll3m().s[3]++, oldCommonStyles);
var subNav = (cov_s0funll3m().s[4]++, tab_objectSpread(tab_objectSpread({}, eeroCommonStyles), {}, {
  padding: "".concat(space/* spaceWithUnits.2 */.u[2], " ").concat(space/* spaceWithUnits.4 */.u[4], " ").concat(space/* spaceWithUnits.2 */.u[2], " ").concat(space/* spaceWithUnits.4 */.u[4])
}));
var appNav = (cov_s0funll3m().s[5]++, tab_objectSpread(tab_objectSpread({}, eeroCommonStyles), {}, tab_defineProperty(tab_defineProperty({
  color: 'neutrals100',
  '&.active': {
    color: colors/* default.brand50 */.ZP.brand50,
    backgroundColor: colors/* default.neutrals10 */.ZP.neutrals10
  }
}, breakpoints/* media.smallerThan.XL */.BC.smallerThan.XL, {
  fontSize: fontSizes/* fontSizesWithUnits.s00 */.Vu.s00
}), breakpoints/* media.smallerThan.MD */.BC.smallerThan.MD, {
  // Intentionally removing the background for mobile nav
  '&.active': {
    backgroundColor: 'transparent'
  }
})));
var tab_variants = (cov_s0funll3m().s[6]++, {
  /** @deprecated */
  'nav-item': navItem,
  /** @deprecated */
  'nav-link': navLink,
  'app-nav': appNav,
  'sub-nav': subNav
});
var tab = (cov_s0funll3m().s[7]++, {
  baseStyle: {
    border: 'none',
    cursor: 'pointer',
    fontSize: fontSizes/* fontSizesWithUnits.s1 */.Vu.s1,
    width: '100%',
    transition: 'all 0.3s ease',
    position: 'relative',
    padding: space/* spaceWithUnits.5 */.u[5],
    borderRadius: radii/* default.squared */.Z.squared,
    display: 'block',
    color: colors/* default.neutrals90 */.ZP.neutrals90
  },
  variants: tab_variants,
  defaultProps: {
    variant: 'nav-item'
  }
});
/* harmony default export */ var components_tab = (tab);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/eero/components/table.mjs
function cov_266jsclbfi() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/eero/components/table.ts";
  var hash = "8afa7e5c904e8947518164dfd29c2edc1cc11d92";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/eero/components/table.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 42
        },
        end: {
          line: 3,
          column: 59
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "8afa7e5c904e8947518164dfd29c2edc1cc11d92"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_266jsclbfi = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_266jsclbfi();
var table = (cov_266jsclbfi().s[0]++, {
  baseStyle: {}
});
/* harmony default export */ var components_table = (table);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/eero/components/tableBody.mjs
function cov_2pftdqiawy() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/eero/components/tableBody.ts";
  var hash = "daf798d9ece9e1d08f38cd6dcbc9af6da79cb080";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/eero/components/tableBody.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 46
        },
        end: {
          line: 3,
          column: 63
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "daf798d9ece9e1d08f38cd6dcbc9af6da79cb080"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2pftdqiawy = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2pftdqiawy();
var tableBody = (cov_2pftdqiawy().s[0]++, {
  baseStyle: {}
});
/* harmony default export */ var components_tableBody = (tableBody);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/eero/components/tableCell.mjs
function cov_26ic6tsv64() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/eero/components/tableCell.ts";
  var hash = "be61a23d7d549161597f2bbfa138245c355a265d";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/eero/components/tableCell.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 46
        },
        end: {
          line: 8,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "be61a23d7d549161597f2bbfa138245c355a265d"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_26ic6tsv64 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_26ic6tsv64();
var tableCell = (cov_26ic6tsv64().s[0]++, {
  baseStyle: {
    textAlign: 'center',
    verticalAlign: 'middle'
  }
});
/* harmony default export */ var components_tableCell = (tableCell);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/eero/components/tableFooter.mjs
function cov_15hya4xxx1() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/eero/components/tableFooter.ts";
  var hash = "111ce1491a38c6ac50194acc81bfd18721ddd003";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/eero/components/tableFooter.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 48
        },
        end: {
          line: 3,
          column: 65
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "111ce1491a38c6ac50194acc81bfd18721ddd003"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_15hya4xxx1 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_15hya4xxx1();
var tableFooter = (cov_15hya4xxx1().s[0]++, {
  baseStyle: {}
});
/* harmony default export */ var components_tableFooter = (tableFooter);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/eero/components/tableHeader.mjs
function cov_2ighziok8y() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/eero/components/tableHeader.ts";
  var hash = "f13e32380030001b863ca174a73cecd75c32f554";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/eero/components/tableHeader.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 48
        },
        end: {
          line: 8,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "f13e32380030001b863ca174a73cecd75c32f554"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2ighziok8y = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2ighziok8y();
var tableHeader = (cov_2ighziok8y().s[0]++, {
  baseStyle: {
    textAlign: 'center',
    verticalAlign: 'middle'
  }
});
/* harmony default export */ var components_tableHeader = (tableHeader);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/eero/components/tableHeading.mjs
function cov_1tqi60184b() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/eero/components/tableHeading.ts";
  var hash = "07450a84568a58c17607526d0c31a741bd42f770";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/eero/components/tableHeading.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 48
        },
        end: {
          line: 8,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "07450a84568a58c17607526d0c31a741bd42f770"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1tqi60184b = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1tqi60184b();
var tableHeading_tableHeader = (cov_1tqi60184b().s[0]++, {
  baseStyle: {
    textAlign: 'center',
    verticalAlign: 'middle'
  }
});
/* harmony default export */ var tableHeading = (tableHeading_tableHeader);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/eero/components/tableRow.mjs
function cov_9k928hdc3() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/eero/components/tableRow.ts";
  var hash = "deea3496a34468c10e356dd9bea66b450857ab75";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/eero/components/tableRow.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 45
        },
        end: {
          line: 3,
          column: 62
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "deea3496a34468c10e356dd9bea66b450857ab75"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_9k928hdc3 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_9k928hdc3();
var tableRow = (cov_9k928hdc3().s[0]++, {
  baseStyle: {}
});
/* harmony default export */ var components_tableRow = (tableRow);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/eero/components/index.mjs
function cov_27uiw2xere() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/eero/components/index.ts";
  var hash = "dbc6d5fc0b0619c64965d1cc2fca12e11bd0da18";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/eero/components/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 32,
          column: 4
        },
        end: {
          line: 59,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "dbc6d5fc0b0619c64965d1cc2fca12e11bd0da18"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_27uiw2xere = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_27uiw2xere();


























var components = (cov_27uiw2xere().s[0]++, {
  AccordionListItem: components_accordionListItem,
  Avatar: components_avatar,
  Button: components_button,
  Card: components_card,
  CardListItem: cardListItem,
  Checkbox: components_checkbox,
  Chip: chip,
  Form: components_form,
  Heading: components_heading,
  Image: components_image,
  Input: components_input,
  Label: components_label,
  Link: components_link,
  List: components_list,
  ListItem: components_listItem,
  Radio: components_radio,
  FormElements: components_formElements,
  Tab: components_tab,
  Table: components_table,
  TableBody: components_tableBody,
  TableCell: components_tableCell,
  TableFooter: components_tableFooter,
  TableHeading: tableHeading,
  TableHeader: components_tableHeader,
  TableRow: components_tableRow,
  Text: components_text
});
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/eero/foundations/letterSpacings.mjs
function cov_2fekey18o5() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/eero/foundations/letterSpacings.ts";
  var hash = "ba5e4aa7cdc3bcdeee55213fd86ba951f116004f";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/eero/foundations/letterSpacings.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 66
        },
        end: {
          line: 9,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "ba5e4aa7cdc3bcdeee55213fd86ba951f116004f"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2fekey18o5 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2fekey18o5();
var letterSpacings = (cov_2fekey18o5().s[0]++, {
  '-3.4': '-.034em',
  '-3': '-.03em',
  '-2.8': '-.028em',
  '-2.4': '-.024em',
  '-1.4': '-.014em'
});
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/eero/foundations/shadows.mjs
function cov_z1ghxlqgy() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/eero/foundations/shadows.ts";
  var hash = "f62a9cb4e332b8a29172cfb6a17a4012a7ceceba";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/eero/foundations/shadows.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 46
        },
        end: {
          line: 13,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "f62a9cb4e332b8a29172cfb6a17a4012a7ceceba"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_z1ghxlqgy = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_z1ghxlqgy();
var shadows = (cov_z1ghxlqgy().s[0]++, {
  none: 'none',
  z1: '0px 5px 10px rgba(29, 71, 123, 0.04), 0px 1px 5px rgba(29, 71, 123, 0.12)',
  z2: '0px 10px 22px rgba(29, 71, 123, 0.08), 0px 2px 12px rgba(29, 71, 123, 0.08)',
  /** @deprecated */
  large: '0 0 24px rgba(0, 0, 0, .125)',
  /** @deprecated */
  medium: '0 3px 15px 2px rgba(0, 0, 0, 0.1)',
  /** @deprecated */
  small: '0 1px 3px 1px rgba(0, 0, 0, 0.1)'
});
/* harmony default export */ var foundations_shadows = (shadows);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/eero/index.mjs
function cov_2pxkz9a1h6() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/eero/index.ts";
  var hash = "415704dd7395fc83a558408875ca06458b05fa7b";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/eero/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 19,
          column: 34
        },
        end: {
          line: 32,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "415704dd7395fc83a558408875ca06458b05fa7b"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2pxkz9a1h6 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2pxkz9a1h6();




var eero = (cov_2pxkz9a1h6().s[0]++, {
  name: 'eero',
  breakpoints: (0,helpers/* numbersArrWithUnits */.U3)(breakpoints/* breakpoints */.AV),
  colors: colors/* default */.ZP,
  fonts: fonts/* fonts */.R,
  fontSizes: fontSizes/* fontSizesNamedWithUnits */.NR,
  fontWeights: fontWeights/* fontWeights */.v,
  lineHeights: lineHeights/* lineHeightsWithUnits */.c,
  letterSpacings: letterSpacings,
  radii: radii/* default */.Z,
  shadows: foundations_shadows,
  space: (0,helpers/* numbersArrWithUnits */.U3)(space/* space */.D),
  components: components
});
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/theme/novo/index.mjs + 35 modules
var novo = __webpack_require__(40994);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/theme/legacy/foundations/mediaBreakpoints.mjs
var mediaBreakpoints = __webpack_require__(26009);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/legacy/foundations/breakpoints.mjs
function cov_f8d8qpgd6() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/legacy/foundations/breakpoints.ts";
  var hash = "79b19389810abce21181ab2ab905a3e22042bafb";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/legacy/foundations/breakpoints.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 27
        },
        end: {
          line: 10,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "79b19389810abce21181ab2ab905a3e22042bafb"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_f8d8qpgd6 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_f8d8qpgd6();

var breakpoints_breakpoints = (cov_f8d8qpgd6().s[0]++, [0,
// base breakpoint size is required for chakra-ui
mediaBreakpoints/* BREAKPOINTS_DICT.XS */.lU.XS, mediaBreakpoints/* BREAKPOINTS_DICT.SM */.lU.SM, mediaBreakpoints/* BREAKPOINTS_DICT.MD */.lU.MD, mediaBreakpoints/* BREAKPOINTS_DICT.LG */.lU.LG, mediaBreakpoints/* BREAKPOINTS_DICT.XL */.lU.XL]);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/legacy/index.mjs
function cov_2jhg4rqxlz() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/legacy/index.ts";
  var hash = "5ecf78b6e6864532742b18223e553fe2827fbb26";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/legacy/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 36
        },
        end: {
          line: 10,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "5ecf78b6e6864532742b18223e553fe2827fbb26"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2jhg4rqxlz = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2jhg4rqxlz();


















function legacy_typeof(o) { "@babel/helpers - typeof"; return legacy_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, legacy_typeof(o); }
function legacy_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function legacy_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? legacy_ownKeys(Object(t), !0).forEach(function (r) { legacy_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : legacy_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function legacy_defineProperty(obj, key, value) { key = legacy_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function legacy_toPropertyKey(t) { var i = legacy_toPrimitive(t, "string"); return "symbol" == legacy_typeof(i) ? i : String(i); }
function legacy_toPrimitive(t, r) { if ("object" != legacy_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != legacy_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }



var legacy = (cov_2jhg4rqxlz().s[0]++, legacy_objectSpread(legacy_objectSpread({}, eero), {}, {
  breakpoints: (0,helpers/* numbersArrWithUnits */.U3)(breakpoints_breakpoints),
  name: 'legacy'
}));
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/exclusives/foundations/colors.mjs
function cov_1c4jattdbp() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/exclusives/foundations/colors.ts";
  var hash = "b4c74574bee5dc3c1305de3d3ba0d04df1a71591";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/exclusives/foundations/colors.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 62
        },
        end: {
          line: 10,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "b4c74574bee5dc3c1305de3d3ba0d04df1a71591"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1c4jattdbp = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1c4jattdbp();


















function colors_typeof(o) { "@babel/helpers - typeof"; return colors_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, colors_typeof(o); }
function colors_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function colors_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? colors_ownKeys(Object(t), !0).forEach(function (r) { colors_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : colors_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function colors_defineProperty(obj, key, value) { key = colors_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function colors_toPropertyKey(t) { var i = colors_toPrimitive(t, "string"); return "symbol" == colors_typeof(i) ? i : String(i); }
function colors_toPrimitive(t, r) { if ("object" != colors_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != colors_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


var colors_colors = (cov_1c4jattdbp().s[0]++, colors_objectSpread(colors_objectSpread({}, colors/* colors */.O9), {}, {
  brand50: '#082DE6',
  brand40: '#6985FF',
  brand30: '#95A5FC'
}));
/* harmony default export */ var foundations_colors = (colors_colors);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/exclusives/index.mjs
function cov_1jkbrirmkv() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/exclusives/index.ts";
  var hash = "19a20e4e6a0f5f1f3e353b7976dcc6acbbf3766d";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/exclusives/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 40
        },
        end: {
          line: 5,
          column: 81
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "19a20e4e6a0f5f1f3e353b7976dcc6acbbf3766d"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1jkbrirmkv = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1jkbrirmkv();


















function exclusives_typeof(o) { "@babel/helpers - typeof"; return exclusives_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, exclusives_typeof(o); }
function exclusives_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function exclusives_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? exclusives_ownKeys(Object(t), !0).forEach(function (r) { exclusives_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : exclusives_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function exclusives_defineProperty(obj, key, value) { key = exclusives_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function exclusives_toPropertyKey(t) { var i = exclusives_toPrimitive(t, "string"); return "symbol" == exclusives_typeof(i) ? i : String(i); }
function exclusives_toPrimitive(t, r) { if ("object" != exclusives_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != exclusives_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


var exclusives = (cov_1jkbrirmkv().s[0]++, exclusives_objectSpread(exclusives_objectSpread({}, legacy), {}, {
  colors: foundations_colors,
  name: 'exclusives'
}));
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/index.mjs
function cov_6vpa9k5a1() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/index.ts";
  var hash = "bb97f3559fc4f67f884f0cfbcdcda7e0e65268d1";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 8,
          column: 25
        },
        end: {
          line: 13,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "bb97f3559fc4f67f884f0cfbcdcda7e0e65268d1"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_6vpa9k5a1 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_6vpa9k5a1();





var THEME_MAP = (cov_6vpa9k5a1().s[0]++, {
  eero: eero,
  novo: novo/* novo */.hI,
  legacy: legacy,
  exclusives: exclusives
});

/***/ }),

/***/ 26009:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BC": function() { return /* binding */ media; },
/* harmony export */   "lU": function() { return /* binding */ BREAKPOINTS_DICT; }
/* harmony export */ });
/* unused harmony exports BREAKPOINTS_SORTED_LIST, getCurrentBreakpoint */
/* harmony import */ var lodash_sortBy_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89734);
/* harmony import */ var lodash_find_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13311);
/* harmony import */ var core_js_modules_es_global_this_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35837);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47941);


/* this code is duplicated in `shared-fe`'s */
/* changes here should be reflected there */
/* additional context - https://github.com/opendoor-labs/code/pull/11068#discussion_r349428972 */
function cov_1vm5gfwvft() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/legacy/foundations/mediaBreakpoints.ts";
  var hash = "422642d24ac6a04f192dc64c7078693abdc40c67";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/legacy/foundations/mediaBreakpoints.ts",
    statementMap: {
      "0": {
        start: {
          line: 8,
          column: 32
        },
        end: {
          line: 16,
          column: 1
        }
      },
      "1": {
        start: {
          line: 17,
          column: 39
        },
        end: {
          line: 20,
          column: 1
        }
      },
      "2": {
        start: {
          line: 19,
          column: 11
        },
        end: {
          line: 19,
          column: 33
        }
      },
      "3": {
        start: {
          line: 22,
          column: 36
        },
        end: {
          line: 28,
          column: 1
        }
      },
      "4": {
        start: {
          line: 23,
          column: 2
        },
        end: {
          line: 27,
          column: 19
        }
      },
      "5": {
        start: {
          line: 26,
          column: 6
        },
        end: {
          line: 26,
          column: 85
        }
      },
      "6": {
        start: {
          line: 30,
          column: 21
        },
        end: {
          line: 49,
          column: 1
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 19,
            column: 2
          },
          end: {
            line: 19,
            column: 3
          }
        },
        loc: {
          start: {
            line: 19,
            column: 11
          },
          end: {
            line: 19,
            column: 33
          }
        },
        line: 19
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 22,
            column: 36
          },
          end: {
            line: 22,
            column: 37
          }
        },
        loc: {
          start: {
            line: 22,
            column: 55
          },
          end: {
            line: 28,
            column: 1
          }
        },
        line: 22
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 25,
            column: 4
          },
          end: {
            line: 25,
            column: 5
          }
        },
        loc: {
          start: {
            line: 26,
            column: 6
          },
          end: {
            line: 26,
            column: 85
          }
        },
        line: 26
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "422642d24ac6a04f192dc64c7078693abdc40c67"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1vm5gfwvft = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1vm5gfwvft();


var BREAKPOINTS_DICT = (cov_1vm5gfwvft().s[0]++, {
  XXS: 374,
  XS: 480,
  SM: 768,
  MD: 992,
  LG: 1200,
  XL: 1600,
  XXL: 1920
});
var BREAKPOINTS_SORTED_LIST = (cov_1vm5gfwvft().s[1]++, lodash_sortBy_js__WEBPACK_IMPORTED_MODULE_0__(Object.keys(BREAKPOINTS_DICT), function (key) {
  cov_1vm5gfwvft().f[0]++;
  cov_1vm5gfwvft().s[2]++;
  return -BREAKPOINTS_DICT[key];
}));
cov_1vm5gfwvft().s[3]++;
var getCurrentBreakpoint = function getCurrentBreakpoint() {
  cov_1vm5gfwvft().f[1]++;
  cov_1vm5gfwvft().s[4]++;
  return _find(BREAKPOINTS_SORTED_LIST, function (breakpoint) {
    cov_1vm5gfwvft().f[2]++;
    cov_1vm5gfwvft().s[5]++;
    return globalThis.matchMedia("(min-width: ".concat(BREAKPOINTS_DICT[breakpoint], "px)")).matches;
  });
};
var media = (cov_1vm5gfwvft().s[6]++, {
  largerThan: {
    LG: "@media (min-width: ".concat(BREAKPOINTS_DICT.LG + 1, "px)"),
    MD: "@media (min-width: ".concat(BREAKPOINTS_DICT.MD + 1, "px)"),
    SM: "@media (min-width: ".concat(BREAKPOINTS_DICT.SM + 1, "px)"),
    XL: "@media (min-width: ".concat(BREAKPOINTS_DICT.XL + 1, "px)"),
    XS: "@media (min-width: ".concat(BREAKPOINTS_DICT.XS + 1, "px)"),
    XXS: "@media (min-width: ".concat(BREAKPOINTS_DICT.XXS + 1, "px)"),
    XXL: "@media (min-width: ".concat(BREAKPOINTS_DICT.XXL + 1, "px)")
  },
  smallerThan: {
    LG: "@media (max-width: ".concat(BREAKPOINTS_DICT.LG, "px)"),
    MD: "@media (max-width: ".concat(BREAKPOINTS_DICT.MD, "px)"),
    SM: "@media (max-width: ".concat(BREAKPOINTS_DICT.SM, "px)"),
    XL: "@media (max-width: ".concat(BREAKPOINTS_DICT.XL, "px)"),
    XS: "@media (max-width: ".concat(BREAKPOINTS_DICT.XS, "px)"),
    XXS: "@media (max-width: ".concat(BREAKPOINTS_DICT.XXS, "px)"),
    XXL: "@media (max-width: ".concat(BREAKPOINTS_DICT.XXL, "px)")
  }
});

/***/ }),

/***/ 9225:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ sizes; }
/* harmony export */ });
function cov_laq44ibxs() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/novo/components/text.ts";
  var hash = "ff2620ab5bcc9e386e142f9f824141a8945641cd";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/novo/components/text.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 44
        },
        end: {
          line: 9,
          column: 1
        }
      },
      "1": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 119,
          column: 1
        }
      },
      "2": {
        start: {
          line: 121,
          column: 21
        },
        end: {
          line: 123,
          column: 1
        }
      },
      "3": {
        start: {
          line: 129,
          column: 30
        },
        end: {
          line: 133,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "ff2620ab5bcc9e386e142f9f824141a8945641cd"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_laq44ibxs = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_laq44ibxs();
/* eslint-disable import/no-deprecated */

var baseStyle = (cov_laq44ibxs().s[0]++, {
  fontFamily: 'sans',
  fontWeight: 'regular',
  color: 'warmgrey950'
});
var sizes = (cov_laq44ibxs().s[1]++, {
  80: {
    fontSize: '11px',
    lineHeight: '150',
    letterSpacing: '-1.4'
  },
  90: {
    fontSize: '12px',
    lineHeight: '150',
    letterSpacing: '-1.4'
  },
  100: {
    fontSize: '14px',
    lineHeight: '140',
    letterSpacing: '-1.4'
  },
  110: {
    fontSize: '16px',
    lineHeight: '130',
    letterSpacing: '-1.4'
  },
  '110-L': {
    fontSize: '16px',
    lineHeight: '160',
    letterSpacing: '-1.4'
  },
  120: {
    fontSize: ['16px', null, '18px'],
    lineHeight: '120',
    letterSpacing: '-2.4'
  },
  130: {
    fontSize: ['16px', null, '20px'],
    lineHeight: '120',
    letterSpacing: '-2.4'
  },
  140: {
    fontSize: ['18px', null, '22px'],
    lineHeight: '112',
    letterSpacing: '-2.4'
  },
  150: {
    fontSize: ['18px', null, '24px'],
    lineHeight: '112',
    letterSpacing: '-2.8'
  },
  160: {
    fontSize: ['20px', null, '28px'],
    lineHeight: '110',
    letterSpacing: '-2.8'
  },
  170: {
    fontSize: ['20px', null, '32px'],
    lineHeight: '110',
    letterSpacing: '-2.8'
  },
  180: {
    fontSize: ['22px', null, '36px'],
    lineHeight: '100',
    letterSpacing: '-3'
  },
  190: {
    fontSize: ['24px', null, '40px'],
    lineHeight: '100',
    letterSpacing: '-3'
  },
  200: {
    fontSize: ['28px', null, '44px'],
    lineHeight: '100',
    letterSpacing: '-3'
  },
  210: {
    fontSize: ['32px', null, '48px'],
    lineHeight: '100',
    letterSpacing: '-3'
  },
  220: {
    fontSize: ['36px', null, '56px'],
    lineHeight: '100',
    letterSpacing: '-3.4'
  },
  230: {
    fontSize: ['40px', null, '64px'],
    lineHeight: '100',
    letterSpacing: '-3.4'
  },
  240: {
    fontSize: ['44px', null, '80px'],
    lineHeight: '100',
    letterSpacing: '-3.4'
  },
  250: {
    fontSize: ['56px', null, '88px'],
    lineHeight: '100',
    letterSpacing: '-3.4'
  },
  260: {
    fontSize: ['64px', null, '96px'],
    lineHeight: '100',
    letterSpacing: '-3.4'
  },
  270: {
    fontSize: ['68px', null, '96px'],
    lineHeight: '100',
    letterSpacing: '-3.4'
  }
});
var defaultProps = (cov_laq44ibxs().s[2]++, {
  sizes: '110'
});
var text = (cov_laq44ibxs().s[3]++, {
  baseStyle: baseStyle,
  sizes: sizes,
  defaultProps: defaultProps
});
/* harmony default export */ __webpack_exports__["Z"] = (text);

/***/ }),

/***/ 40156:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AV": function() { return /* binding */ breakpoints; },
/* harmony export */   "BC": function() { return /* binding */ media; }
/* harmony export */ });
/* unused harmony export BREAKPOINTS_DICT */
function cov_1hr11dqsbd() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/novo/foundations/breakpoints.ts";
  var hash = "f09c56c317342af8db30154430cb8f4280bd54b3";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/novo/foundations/breakpoints.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 32
        },
        end: {
          line: 12,
          column: 1
        }
      },
      "1": {
        start: {
          line: 14,
          column: 27
        },
        end: {
          line: 20,
          column: 1
        }
      },
      "2": {
        start: {
          line: 22,
          column: 21
        },
        end: {
          line: 35,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "f09c56c317342af8db30154430cb8f4280bd54b3"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1hr11dqsbd = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1hr11dqsbd();
/**
 * Breakpoints designated by most common device usage
 * https://www.figma.com/file/w3nEyANoniTZdjz8kCUaDS/Bricks-Design-System?node-id=6881%3A17688&t=4QS53fgl4nBJp4hQ-0
 */

var BREAKPOINTS_DICT = (cov_1hr11dqsbd().s[0]++, {
  XS: 0,
  // 0-374 - XS
  SM: 375,
  // 375-767 - S
  MD: 768,
  //768-1200 - M
  LG: 1201,
  // 1201 - 1399 - L
  XL: 1440 // 1440+ XL
});
var breakpoints = (cov_1hr11dqsbd().s[1]++, [BREAKPOINTS_DICT.XS,
// 0-374 - XS
BREAKPOINTS_DICT.SM,
// 375-767 - S
BREAKPOINTS_DICT.MD,
//768-1200 - M
BREAKPOINTS_DICT.LG,
// 1201 - 1399 - L
BREAKPOINTS_DICT.XL // 1440+ XL
]);
var media = (cov_1hr11dqsbd().s[2]++, {
  largerThan: {
    XS: "@media (min-width: ".concat(BREAKPOINTS_DICT.SM, "px)"),
    SM: "@media (min-width: ".concat(BREAKPOINTS_DICT.MD, "px)"),
    MD: "@media (min-width: ".concat(BREAKPOINTS_DICT.LG, "px)"),
    LG: "@media (min-width: ".concat(BREAKPOINTS_DICT.XL, "px)")
  },
  smallerThan: {
    SM: "@media (max-width: ".concat(BREAKPOINTS_DICT.SM - 1, "px)"),
    MD: "@media (max-width: ".concat(BREAKPOINTS_DICT.MD - 1, "px)"),
    LG: "@media (max-width: ".concat(BREAKPOINTS_DICT.LG - 1, "px)"),
    XL: "@media (max-width: ".concat(BREAKPOINTS_DICT.XL - 1, "px)")
  }
});

/***/ }),

/***/ 62762:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports brand, warmGreys, earth, clay, states, eeroOverrides, colors, ColorSchemeKeys */
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32165);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41817);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57327);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89554);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91038);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66992);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47042);
/* harmony import */ var core_js_modules_es_symbol_to_primitive_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96649);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(68309);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(92222);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(33321);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69070);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(38880);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(49337);
/* harmony import */ var core_js_modules_es_date_to_primitive_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(96078);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(9653);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(74916);
/* harmony import */ var core_js_modules_es_regexp_test_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(77601);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(39714);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(78783);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(54747);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(33948);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(47941);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(41539);
/* harmony import */ var _eero_foundations_colors_mjs__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(81762);
function cov_y7gir10pq() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/novo/foundations/colors.ts";
  var hash = "93d8bb61876e1b412d853fc2584fc193dc60da6b";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/novo/foundations/colors.ts",
    statementMap: {
      "0": {
        start: {
          line: 13,
          column: 60
        },
        end: {
          line: 23,
          column: 1
        }
      },
      "1": {
        start: {
          line: 25,
          column: 67
        },
        end: {
          line: 34,
          column: 1
        }
      },
      "2": {
        start: {
          line: 36,
          column: 60
        },
        end: {
          line: 42,
          column: 1
        }
      },
      "3": {
        start: {
          line: 44,
          column: 58
        },
        end: {
          line: 50,
          column: 1
        }
      },
      "4": {
        start: {
          line: 52,
          column: 61
        },
        end: {
          line: 57,
          column: 1
        }
      },
      "5": {
        start: {
          line: 63,
          column: 69
        },
        end: {
          line: 82,
          column: 1
        }
      },
      "6": {
        start: {
          line: 84,
          column: 56
        },
        end: {
          line: 94,
          column: 1
        }
      },
      "7": {
        start: {
          line: 96,
          column: 31
        },
        end: {
          line: 102,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "93d8bb61876e1b412d853fc2584fc193dc60da6b"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_y7gir10pq = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_y7gir10pq();
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }

























function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


// Design System
var brand = (cov_y7gir10pq().s[0]++, {
  blue50: '#F2F4F7',
  blue100: '#DFEAF8',
  blue200: '#BBD7FA',
  blue300: '#709AF1',
  blue500: '#2B54EA',
  brandBlue600: '#0040E6',
  blue700: '#002F93',
  blue900: '#00256B',
  blue950: '#051A44'
});
var warmGreys = (cov_y7gir10pq().s[1]++, {
  white0: '#FFFFFF',
  warmgrey100: '#FAF8F7',
  warmgrey200: '#ECE9E7',
  warmgrey300: '#DEDAD7',
  warmgrey700: '#9D9893',
  warmgrey800: '#736D68',
  warmgrey900: '#403E3C',
  warmgrey950: '#21201F'
});
var earth = (cov_y7gir10pq().s[2]++, {
  earth100: '#F3F3EE',
  earth200: '#ECE9E7',
  earth300: '#D7D7C4',
  earth700: '#C3C3AF',
  earth900: '#3F3832'
});
var clay = (cov_y7gir10pq().s[3]++, {
  clay100: '#FBF4F1',
  clay200: '#EED4C6',
  clay300: '#E2B49B',
  clay500: '#D59470',
  clay900: '#E2332A'
});
var states = (cov_y7gir10pq().s[4]++, {
  success500: '#007F5E',
  success100: '#EBF5EE',
  error500: '#C34143',
  error100: '#FAE4E4'
});

/**
 * There are components in Bricks that have not been componentized yet - so they are still using eero token names
 * This is a temporary solution to override those components to use the new novo colors
 */
var eeroOverrides = (cov_y7gir10pq().s[5]++, _objectSpread(_objectSpread({}, _eero_foundations_colors_mjs__WEBPACK_IMPORTED_MODULE_25__/* .colors */ .O9), {}, {
  blue30: brand.blue50,
  brand30: brand.blue300,
  brand40: brand.blue500,
  brand50: brand.brandBlue600,
  neutrals0: warmGreys.white0,
  neutrals10: warmGreys.warmgrey100,
  neutrals20: warmGreys.warmgrey100,
  neutrals30: warmGreys.warmgrey200,
  neutrals40: warmGreys.warmgrey300,
  neutrals70: warmGreys.warmgrey700,
  neutrals90: warmGreys.warmgrey800,
  neutrals100: warmGreys.warmgrey950,
  green50: states.success500,
  red50: states.error500,
  //terracotta50 has not been updated - did not find a suitable replacement
  terracotta50: '#FF896F'
}));
var colors = (cov_y7gir10pq().s[6]++, _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, eeroOverrides), brand), warmGreys), earth), clay), states), {}, {
  transparent: 'transparent',
  currentColor: 'currentColor'
}));
var ColorSchemeKeys = (cov_y7gir10pq().s[7]++, [].concat(_toConsumableArray(Object.keys(_eero_foundations_colors_mjs__WEBPACK_IMPORTED_MODULE_25__/* .colors */ .O9)), _toConsumableArray(Object.keys(brand)), _toConsumableArray(Object.keys(warmGreys)), _toConsumableArray(Object.keys(earth)), _toConsumableArray(Object.keys(clay))));
/* harmony default export */ __webpack_exports__["ZP"] = (colors);

/***/ }),

/***/ 40994:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "hI": function() { return /* binding */ novo; }
});

// UNUSED EXPORTS: BREAKPOINTS_DICT, breakpoints, colors, fontSizesNamed, fontSizesNamedWithUnits, fontSizesWithUnits, fontWeights, fonts, heights, heightsWithUnits, letterSpacings, lineHeights, media, radii, shadows, sizes, space, spaceWithUnits

// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/theme/helpers.mjs
var helpers = __webpack_require__(73173);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__(32165);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(82526);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__(57327);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__(89554);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(41817);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.to-primitive.js
var es_symbol_to_primitive = __webpack_require__(96649);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(66992);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.define-properties.js
var es_object_define_properties = __webpack_require__(33321);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.define-property.js
var es_object_define_property = __webpack_require__(69070);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__(38880);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__(49337);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__(47941);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.date.to-primitive.js
var es_date_to_primitive = __webpack_require__(96078);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(78783);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__(54747);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__(9653);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(41539);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(33948);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/system/anatomy.types.mjs + 1 modules
var anatomy_types = __webpack_require__(30110);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/novo/components/card.mjs
function cov_13pc4wf258() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/novo/components/card.ts";
  var hash = "8001a37a3786350068d90e352f8c3f9064c286e0";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/novo/components/card.ts",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 54
        },
        end: {
          line: 8,
          column: 1
        }
      },
      "1": {
        start: {
          line: 10,
          column: 42
        },
        end: {
          line: 17,
          column: 1
        }
      },
      "2": {
        start: {
          line: 19,
          column: 51
        },
        end: {
          line: 30,
          column: 1
        }
      },
      "3": {
        start: {
          line: 32,
          column: 44
        },
        end: {
          line: 40,
          column: 1
        }
      },
      "4": {
        start: {
          line: 42,
          column: 53
        },
        end: {
          line: 53,
          column: 1
        }
      },
      "5": {
        start: {
          line: 55,
          column: 43
        },
        end: {
          line: 63,
          column: 1
        }
      },
      "6": {
        start: {
          line: 65,
          column: 52
        },
        end: {
          line: 76,
          column: 1
        }
      },
      "7": {
        start: {
          line: 78,
          column: 42
        },
        end: {
          line: 86,
          column: 1
        }
      },
      "8": {
        start: {
          line: 88,
          column: 69
        },
        end: {
          line: 93,
          column: 1
        }
      },
      "9": {
        start: {
          line: 96,
          column: 67
        },
        end: {
          line: 100,
          column: 1
        }
      },
      "10": {
        start: {
          line: 108,
          column: 30
        },
        end: {
          line: 116,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "8001a37a3786350068d90e352f8c3f9064c286e0"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_13pc4wf258 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_13pc4wf258();


















function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var sharedVariantStyles = (cov_13pc4wf258().s[0]++, {
  flexDirection: 'column',
  borderRadius: 'semiRounded',
  padding: [5, null, 8]
});
var primary = (cov_13pc4wf258().s[1]++, _objectSpread(_objectSpread({}, sharedVariantStyles), {}, {
  boxShadow: 'z2',
  _focus: {
    background: 'warmgrey100',
    border: "1px solid var(--colors-warmgrey800)"
  }
}));
var primaryClickable = (cov_13pc4wf258().s[2]++, {
  _hover: {
    background: 'warmgrey100',
    boxShadow: 'z2',
    cursor: 'pointer'
  },
  _active: {
    background: 'warmgrey100',
    boxShadow: 'z1',
    cursor: 'pointer'
  }
});
var secondary = (cov_13pc4wf258().s[3]++, _objectSpread(_objectSpread({}, sharedVariantStyles), {}, {
  boxShadow: 'z1',
  _focus: {
    background: 'warmgrey100',
    boxShadow: 'z2',
    border: "1px solid var(--colors-warmgrey800)"
  }
}));
var secondaryClickable = (cov_13pc4wf258().s[4]++, {
  _hover: {
    background: 'warmgrey100',
    boxShadow: 'z2',
    cursor: 'pointer'
  },
  _active: {
    background: 'warmgrey100',
    boxShadow: 'z1',
    cursor: 'pointer'
  }
});
var tertiary = (cov_13pc4wf258().s[5]++, _objectSpread(_objectSpread({}, sharedVariantStyles), {}, {
  background: 'warmgrey100',
  border: "1px solid var(--colors-warmgrey100)",
  _focus: {
    background: 'warmgrey100',
    border: "1px solid var(--colors-warmgrey700)"
  }
}));
var tertiaryClickable = (cov_13pc4wf258().s[6]++, {
  _hover: {
    background: 'warmgrey100',
    border: "1px solid var(--colors-warmgrey200)",
    cursor: 'pointer'
  },
  _active: {
    background: 'warmgrey200',
    border: "1px solid var(--colors-warmgrey200)",
    cursor: 'pointer'
  }
});
var outline = (cov_13pc4wf258().s[7]++, _objectSpread(_objectSpread({}, sharedVariantStyles), {}, {
  background: 'white0',
  border: "1px solid var(--colors-warmgrey300)",
  _focus: {
    background: 'warmgrey100',
    border: "1px solid var(--colors-warmgrey800)"
  }
}));
var variants = (cov_13pc4wf258().s[8]++, {
  primary: primary,
  secondary: secondary,
  tertiary: tertiary,
  outline: outline
});

/** @deprecated This is not a11y compliant */
var clickables = (cov_13pc4wf258().s[9]++, {
  primary: primaryClickable,
  secondary: secondaryClickable,
  tertiary: tertiaryClickable
});
var card = (cov_13pc4wf258().s[10]++, {
  baseStyle: {
    width: '100%',
    backgroundColor: 'white0'
  },
  variants: variants,
  /** @deprecated This is not a11y compliant */
  clickables: clickables
});
/* harmony default export */ var components_card = (card);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/novo/components/cardListItem.mjs
function cov_2j0sh5zyhb() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/novo/components/cardListItem.ts";
  var hash = "1cb2cf16ee6ad80b093eb348c529c25751bcb0bb";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/novo/components/cardListItem.ts",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 48
        },
        end: {
          line: 22,
          column: 1
        }
      },
      "1": {
        start: {
          line: 24,
          column: 57
        },
        end: {
          line: 26,
          column: 1
        }
      },
      "2": {
        start: {
          line: 28,
          column: 59
        },
        end: {
          line: 44,
          column: 1
        }
      },
      "3": {
        start: {
          line: 48,
          column: 4
        },
        end: {
          line: 51,
          column: 1
        }
      },
      "4": {
        start: {
          line: 57,
          column: 38
        },
        end: {
          line: 86,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "1cb2cf16ee6ad80b093eb348c529c25751bcb0bb"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2j0sh5zyhb = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2j0sh5zyhb();
function cardListItem_typeof(o) { "@babel/helpers - typeof"; return cardListItem_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, cardListItem_typeof(o); }


















function cardListItem_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function cardListItem_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? cardListItem_ownKeys(Object(t), !0).forEach(function (r) { cardListItem_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : cardListItem_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function cardListItem_defineProperty(obj, key, value) { key = cardListItem_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function cardListItem_toPropertyKey(t) { var i = cardListItem_toPrimitive(t, "string"); return "symbol" == cardListItem_typeof(i) ? i : String(i); }
function cardListItem_toPrimitive(t, r) { if ("object" != cardListItem_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != cardListItem_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


var baseLinkStyle = (cov_2j0sh5zyhb().s[0]++, {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  listStyleType: 'none',
  boxSizing: 'border-box',
  borderRadius: 'semiRounded',
  cursor: 'pointer',
  fontWeight: 'semibold',
  lineHeight: 1,
  padding: 6
});
var cardListItem_primary = (cov_2j0sh5zyhb().s[1]++, {
  listItem: cardListItem_objectSpread(cardListItem_objectSpread({}, components_card.variants.primary), baseLinkStyle)
});
var cardListItem_secondary = (cov_2j0sh5zyhb().s[2]++, {
  listItem: cardListItem_objectSpread(cardListItem_objectSpread(cardListItem_objectSpread({}, components_card.variants.secondary), baseLinkStyle), {}, {
    boxShadow: 'none',
    background: 'warmgrey100',
    border: "1px solid var(--colors-warmgrey200)",
    _hover: {
      background: 'warmgrey100',
      border: "1px solid var(--colors-warmgrey200)"
    },
    _active: {
      background: 'warmgrey200',
      border: "1px solid var(--colors-warmgrey200)"
    }
  })
});
var cardListItem_variants = (cov_2j0sh5zyhb().s[3]++, {
  primary: cardListItem_primary,
  secondary: cardListItem_secondary
});
var cardList = (cov_2j0sh5zyhb().s[4]++, {
  parts: anatomy_types/* cardListItemAnatomy.keys */.F7.keys,
  baseStyle: {
    listItem: cardListItem_objectSpread(cardListItem_objectSpread({}, components_card.baseStyle), baseLinkStyle),
    content: {
      lineHeight: 1,
      alignItems: 'center',
      width: '100%',
      height: '100%'
    },
    accessoryIconContainer: {
      mr: 3,
      lineHeight: 0
    },
    accessoryIcon: {
      color: 'warmgrey950'
    },
    accessoryImage: {
      height: '40px',
      mr: 4
    }
  },
  defaultProps: {
    variant: 'primary'
  },
  variants: cardListItem_variants
});
/* harmony default export */ var cardListItem = (cardList);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/novo/components/accordionListItem.mjs
function cov_swfxz5mvx() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/novo/components/accordionListItem.ts";
  var hash = "a21f5e4b023c9c747d6e86e16fa1cdee201b5f3f";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/novo/components/accordionListItem.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 64
        },
        end: {
          line: 85,
          column: 2
        }
      },
      "1": {
        start: {
          line: 14,
          column: 7
        },
        end: {
          line: 85,
          column: 1
        }
      },
      "2": {
        start: {
          line: 87,
          column: 62
        },
        end: {
          line: 87,
          column: 71
        }
      },
      "3": {
        start: {
          line: 89,
          column: 64
        },
        end: {
          line: 104,
          column: 2
        }
      },
      "4": {
        start: {
          line: 89,
          column: 98
        },
        end: {
          line: 104,
          column: 1
        }
      },
      "5": {
        start: {
          line: 108,
          column: 4
        },
        end: {
          line: 111,
          column: 1
        }
      },
      "6": {
        start: {
          line: 120,
          column: 52
        },
        end: {
          line: 125,
          column: 1
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 64
          },
          end: {
            line: 6,
            column: 65
          }
        },
        loc: {
          start: {
            line: 14,
            column: 7
          },
          end: {
            line: 85,
            column: 1
          }
        },
        line: 14
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 89,
            column: 64
          },
          end: {
            line: 89,
            column: 65
          }
        },
        loc: {
          start: {
            line: 89,
            column: 98
          },
          end: {
            line: 104,
            column: 1
          }
        },
        line: 89
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 25,
            column: 15
          },
          end: {
            line: 25,
            column: 32
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 25,
            column: 15
          },
          end: {
            line: 25,
            column: 24
          }
        }, {
          start: {
            line: 25,
            column: 28
          },
          end: {
            line: 25,
            column: 32
          }
        }],
        line: 25
      },
      "1": {
        loc: {
          start: {
            line: 31,
            column: 17
          },
          end: {
            line: 31,
            column: 34
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 31,
            column: 17
          },
          end: {
            line: 31,
            column: 26
          }
        }, {
          start: {
            line: 31,
            column: 30
          },
          end: {
            line: 31,
            column: 34
          }
        }],
        line: 31
      },
      "2": {
        loc: {
          start: {
            line: 34,
            column: 17
          },
          end: {
            line: 34,
            column: 34
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 34,
            column: 17
          },
          end: {
            line: 34,
            column: 26
          }
        }, {
          start: {
            line: 34,
            column: 30
          },
          end: {
            line: 34,
            column: 34
          }
        }],
        line: 34
      },
      "3": {
        loc: {
          start: {
            line: 43,
            column: 20
          },
          end: {
            line: 43,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 43,
            column: 20
          },
          end: {
            line: 43,
            column: 34
          }
        }, {
          start: {
            line: 43,
            column: 38
          },
          end: {
            line: 43,
            column: 53
          }
        }],
        line: 43
      },
      "4": {
        loc: {
          start: {
            line: 62,
            column: 15
          },
          end: {
            line: 62,
            column: 52
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 62,
            column: 24
          },
          end: {
            line: 62,
            column: 40
          }
        }, {
          start: {
            line: 62,
            column: 43
          },
          end: {
            line: 62,
            column: 52
          }
        }],
        line: 62
      },
      "5": {
        loc: {
          start: {
            line: 64,
            column: 20
          },
          end: {
            line: 64,
            column: 48
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 64,
            column: 20
          },
          end: {
            line: 64,
            column: 34
          }
        }, {
          start: {
            line: 64,
            column: 38
          },
          end: {
            line: 64,
            column: 48
          }
        }],
        line: 64
      },
      "6": {
        loc: {
          start: {
            line: 69,
            column: 15
          },
          end: {
            line: 69,
            column: 48
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 69,
            column: 24
          },
          end: {
            line: 69,
            column: 44
          }
        }, {
          start: {
            line: 69,
            column: 47
          },
          end: {
            line: 69,
            column: 48
          }
        }],
        line: 69
      },
      "7": {
        loc: {
          start: {
            line: 69,
            column: 24
          },
          end: {
            line: 69,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 69,
            column: 24
          },
          end: {
            line: 69,
            column: 33
          }
        }, {
          start: {
            line: 69,
            column: 37
          },
          end: {
            line: 69,
            column: 44
          }
        }],
        line: 69
      },
      "8": {
        loc: {
          start: {
            line: 70,
            column: 8
          },
          end: {
            line: 70,
            column: 22
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 70,
            column: 17
          },
          end: {
            line: 70,
            column: 18
          }
        }, {
          start: {
            line: 70,
            column: 21
          },
          end: {
            line: 70,
            column: 22
          }
        }],
        line: 70
      },
      "9": {
        loc: {
          start: {
            line: 72,
            column: 13
          },
          end: {
            line: 72,
            column: 27
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 72,
            column: 22
          },
          end: {
            line: 72,
            column: 23
          }
        }, {
          start: {
            line: 72,
            column: 26
          },
          end: {
            line: 72,
            column: 27
          }
        }],
        line: 72
      },
      "10": {
        loc: {
          start: {
            line: 95,
            column: 18
          },
          end: {
            line: 95,
            column: 79
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 95,
            column: 33
          },
          end: {
            line: 95,
            column: 70
          }
        }, {
          start: {
            line: 95,
            column: 73
          },
          end: {
            line: 95,
            column: 79
          }
        }],
        line: 95
      },
      "11": {
        loc: {
          start: {
            line: 101,
            column: 14
          },
          end: {
            line: 101,
            column: 72
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 101,
            column: 26
          },
          end: {
            line: 101,
            column: 63
          }
        }, {
          start: {
            line: 101,
            column: 66
          },
          end: {
            line: 101,
            column: 72
          }
        }],
        line: 101
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "a21f5e4b023c9c747d6e86e16fa1cdee201b5f3f"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_swfxz5mvx = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_swfxz5mvx();
function accordionListItem_typeof(o) { "@babel/helpers - typeof"; return accordionListItem_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, accordionListItem_typeof(o); }


















function accordionListItem_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function accordionListItem_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? accordionListItem_ownKeys(Object(t), !0).forEach(function (r) { accordionListItem_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : accordionListItem_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function accordionListItem_defineProperty(obj, key, value) { key = accordionListItem_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function accordionListItem_toPropertyKey(t) { var i = accordionListItem_toPrimitive(t, "string"); return "symbol" == accordionListItem_typeof(i) ? i : String(i); }
function accordionListItem_toPrimitive(t, r) { if ("object" != accordionListItem_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != accordionListItem_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


cov_swfxz5mvx().s[0]++;
var baseStyle = function baseStyle(_ref) {
  var _ref2, _ref3, _ref4, _ref5, _ref6, _ref7;
  var padding = _ref.padding,
    paddingInline = _ref.paddingInline,
    justifyContent = _ref.justifyContent,
    isOpen = _ref.isOpen,
    whiteSpace = _ref.whiteSpace,
    maxHeight = _ref.maxHeight,
    boxShadow = _ref.boxShadow;
  cov_swfxz5mvx().f[0]++;
  cov_swfxz5mvx().s[1]++;
  return accordionListItem_objectSpread(accordionListItem_objectSpread({}, cardListItem.variants.primary), {}, {
    listItem: accordionListItem_objectSpread(accordionListItem_objectSpread({}, cardListItem.variants.primary.listItem), {}, {
      background: 'white0',
      borderRadius: 'semiRounded',
      flexDirection: 'column',
      alignItems: 'flex-start',
      padding: padding,
      paddingInline: paddingInline,
      border: '2px solid transparent',
      boxShadow: (_ref2 = (cov_swfxz5mvx().b[0][0]++, boxShadow)) !== null && _ref2 !== void 0 ? _ref2 : (cov_swfxz5mvx().b[0][1]++, 'z1'),
      // Add styling to accordion when it is focused on to make website accessable to keyboard only users. More info on focus-within below
      // https://developer.mozilla.org/en-US/docs/Web/CSS/:focus-within
      _focusWithin: {
        border: '2px solid var(--colors-warmgrey950)',
        borderRadius: 'semiRounded',
        boxShadow: (_ref3 = (cov_swfxz5mvx().b[1][0]++, boxShadow)) !== null && _ref3 !== void 0 ? _ref3 : (cov_swfxz5mvx().b[1][1]++, 'z1')
      },
      __hover: {
        boxShadow: (_ref4 = (cov_swfxz5mvx().b[2][0]++, boxShadow)) !== null && _ref4 !== void 0 ? _ref4 : (cov_swfxz5mvx().b[2][1]++, 'z1')
      }
    }),
    button: {
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      outline: 0,
      width: '100%',
      justifyContent: (_ref5 = (cov_swfxz5mvx().b[3][0]++, justifyContent)) !== null && _ref5 !== void 0 ? _ref5 : (cov_swfxz5mvx().b[3][1]++, 'space-between'),
      textAlign: 'start',
      // {border: none and background: none} are originally defined in Primer.
      // Although bricks still depends on Primer in some ways, it should be decoupled.
      border: 'none',
      background: 'none'
    },
    title: {
      fontSize: 's1',
      lineHeight: 's1',
      color: 'warmgrey950',
      fontWeight: 'semibold',
      whiteSpace: whiteSpace,
      textAlign: 'left'
    },
    iconContainer: {
      display: 'flex',
      mx: 3,
      alignItems: 'center',
      transform: isOpen ? (cov_swfxz5mvx().b[4][0]++, 'rotate(180deg)') : (cov_swfxz5mvx().b[4][1]++, undefined),
      transition: 'transform 0.2s',
      justifyContent: (_ref6 = (cov_swfxz5mvx().b[5][0]++, justifyContent)) !== null && _ref6 !== void 0 ? _ref6 : (cov_swfxz5mvx().b[5][1]++, 'flex-end'),
      transformOrigin: 'center'
    },
    panel: {
      height: 'auto',
      maxHeight: isOpen ? (cov_swfxz5mvx().b[6][0]++, (_ref7 = (cov_swfxz5mvx().b[7][0]++, maxHeight)) !== null && _ref7 !== void 0 ? _ref7 : (cov_swfxz5mvx().b[7][1]++, '875px')) : (cov_swfxz5mvx().b[6][1]++, 0),
      mt: isOpen ? (cov_swfxz5mvx().b[8][0]++, 3) : (cov_swfxz5mvx().b[8][1]++, 0),
      paddingLeft: 3,
      opacity: isOpen ? (cov_swfxz5mvx().b[9][0]++, 1) : (cov_swfxz5mvx().b[9][1]++, 0),
      overflow: 'hidden',
      transition: 'all 0.3s ease-out',
      width: '100%',
      fontWeight: 'regular'
    },
    bodyText: {
      fontSize: 's1',
      lineHeight: 1.6,
      color: 'warmgrey800',
      fontWeight: 'regular',
      whiteSpace: 'pre-line'
    }
  });
};
var accordionListItem_primary = (cov_swfxz5mvx().s[2]++, baseStyle);
cov_swfxz5mvx().s[3]++;
var accordionListItem_secondary = function secondary(_ref8) {
  var hasBorder = _ref8.hasBorder,
    hasUnderline = _ref8.hasUnderline;
  cov_swfxz5mvx().f[1]++;
  cov_swfxz5mvx().s[4]++;
  return {
    listItem: {
      background: 'inherit',
      borderRadius: 'none',
      boxShadow: 'none',
      border: 'none',
      borderBottom: hasUnderline ? (cov_swfxz5mvx().b[10][0]++, '1px solid var(--colors-warmgrey700)') : (cov_swfxz5mvx().b[10][1]++, 'none'),
      // Add styling to accordion when it is focused on to make website accessable to keyboard only users. More info on focus-within below
      // https://developer.mozilla.org/en-US/docs/Web/CSS/:focus-within
      _focusWithin: {
        borderRadius: 'none',
        boxShadow: 'none',
        border: hasBorder ? (cov_swfxz5mvx().b[11][0]++, '1px solid var(--colors-warmgrey950)') : (cov_swfxz5mvx().b[11][1]++, 'none')
      }
    }
  };
};
var accordionListItem_variants = (cov_swfxz5mvx().s[5]++, {
  primary: accordionListItem_primary,
  secondary: accordionListItem_secondary
});
var accordionListItem = (cov_swfxz5mvx().s[6]++, {
  parts: anatomy_types/* accordionListItemAnatomy.keys */.lW.keys,
  baseStyle: baseStyle,
  variants: accordionListItem_variants,
  defaultProps: {
    variant: 'primary'
  }
});
/* harmony default export */ var components_accordionListItem = (accordionListItem);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/novo/components/avatar.mjs
function cov_1whlbnzica() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/novo/components/avatar.ts";
  var hash = "d018e66afa92006dc947242164defb4aa2da966f";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/novo/components/avatar.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 53
        },
        end: {
          line: 15,
          column: 2
        }
      },
      "1": {
        start: {
          line: 5,
          column: 72
        },
        end: {
          line: 15,
          column: 1
        }
      },
      "2": {
        start: {
          line: 17,
          column: 80
        },
        end: {
          line: 26,
          column: 1
        }
      },
      "3": {
        start: {
          line: 28,
          column: 68
        },
        end: {
          line: 65,
          column: 1
        }
      },
      "4": {
        start: {
          line: 67,
          column: 21
        },
        end: {
          line: 69,
          column: 1
        }
      },
      "5": {
        start: {
          line: 75,
          column: 34
        },
        end: {
          line: 81,
          column: 1
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 5,
            column: 53
          },
          end: {
            line: 5,
            column: 54
          }
        },
        loc: {
          start: {
            line: 5,
            column: 72
          },
          end: {
            line: 15,
            column: 1
          }
        },
        line: 5
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 9,
            column: 13
          },
          end: {
            line: 9,
            column: 31
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 9,
            column: 24
          },
          end: {
            line: 9,
            column: 27
          }
        }, {
          start: {
            line: 9,
            column: 30
          },
          end: {
            line: 9,
            column: 31
          }
        }],
        line: 9
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "d018e66afa92006dc947242164defb4aa2da966f"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1whlbnzica = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1whlbnzica();




cov_1whlbnzica().s[0]++;
var avatar_baseStyle = function baseStyle(_ref) {
  var disabled = _ref.disabled;
  cov_1whlbnzica().f[0]++;
  cov_1whlbnzica().s[1]++;
  return {
    container: {
      borderRadius: 'full',
      flexShrink: 0,
      opacity: disabled ? (cov_1whlbnzica().b[0][0]++, 0.6) : (cov_1whlbnzica().b[0][1]++, 1),
      overflow: 'hidden'
    },
    image: {
      objectFit: 'cover'
    }
  };
};
var avatar_variants = (cov_1whlbnzica().s[2]++, {
  human: {
    container: {
      bgColor: 'warmgrey100'
    }
  },
  bot: {
    container: {
      display: 'flex',
      alignItems: 'center',
      bgColor: 'brandBlue600'
    }
  }
});
var sizes = (cov_1whlbnzica().s[3]++, {
  sm: {
    container: {
      width: '32px',
      height: '32px',
      lineHeight: '32px',
      fontSize: 's0'
    },
    image: {
      width: '32px',
      height: '32px'
    }
  },
  md: {
    container: {
      width: '60px',
      height: '60px',
      lineHeight: '60px',
      fontSize: 's1'
    },
    image: {
      width: '60px',
      height: '60px'
    }
  },
  lg: {
    container: {
      width: '72px',
      height: '72px',
      lineHeight: '72px',
      fontSize: 's2'
    },
    image: {
      width: '72px',
      height: '72px'
    }
  }
});
var defaultProps = (cov_1whlbnzica().s[4]++, {
  size: 'md'
});
var avatar = (cov_1whlbnzica().s[5]++, {
  parts: anatomy_types/* avatarAnatomy.keys */.$5.keys,
  baseStyle: avatar_baseStyle,
  variants: avatar_variants,
  sizes: sizes,
  defaultProps: defaultProps
});
/* harmony default export */ var components_avatar = (avatar);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__(82772);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/novo/foundations/fonts.mjs
function cov_lnei2ur7l() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/novo/foundations/fonts.ts";
  var hash = "b2a635670f562a5abbe116b0c926f7ee7b095992";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/novo/foundations/fonts.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 48
        },
        end: {
          line: 7,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "b2a635670f562a5abbe116b0c926f7ee7b095992"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_lnei2ur7l = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_lnei2ur7l();
var fonts = (cov_lnei2ur7l().s[0]++, {
  mono: 'Noto-Mono, monospace',
  sans: 'Graphik, system-ui, sans-serif',
  serif: 'Publico, serif'
});
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/theme/novo/components/text.mjs
var components_text = __webpack_require__(9225);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/theme/novo/foundations/colors.mjs
var colors = __webpack_require__(62762);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/novo/components/sharedCta.mjs
function cov_ovl9oy3tk() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/novo/components/sharedCta.ts";
  var hash = "4c8defb6a2a06430212d64f4aad44a1f82a83e4a";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/novo/components/sharedCta.ts",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 58
        },
        end: {
          line: 22,
          column: 1
        }
      },
      "1": {
        start: {
          line: 24,
          column: 59
        },
        end: {
          line: 33,
          column: 1
        }
      },
      "2": {
        start: {
          line: 35,
          column: 39
        },
        end: {
          line: 52,
          column: 1
        }
      },
      "3": {
        start: {
          line: 36,
          column: 2
        },
        end: {
          line: 51,
          column: 4
        }
      },
      "4": {
        start: {
          line: 54,
          column: 39
        },
        end: {
          line: 70,
          column: 1
        }
      },
      "5": {
        start: {
          line: 55,
          column: 2
        },
        end: {
          line: 69,
          column: 4
        }
      },
      "6": {
        start: {
          line: 72,
          column: 39
        },
        end: {
          line: 90,
          column: 1
        }
      },
      "7": {
        start: {
          line: 73,
          column: 2
        },
        end: {
          line: 89,
          column: 4
        }
      },
      "8": {
        start: {
          line: 92,
          column: 50
        },
        end: {
          line: 165,
          column: 1
        }
      },
      "9": {
        start: {
          line: 93,
          column: 32
        },
        end: {
          line: 99,
          column: 3
        }
      },
      "10": {
        start: {
          line: 100,
          column: 34
        },
        end: {
          line: 103,
          column: 3
        }
      },
      "11": {
        start: {
          line: 104,
          column: 27
        },
        end: {
          line: 128,
          column: 3
        }
      },
      "12": {
        start: {
          line: 129,
          column: 25
        },
        end: {
          line: 160,
          column: 3
        }
      },
      "13": {
        start: {
          line: 161,
          column: 2
        },
        end: {
          line: 164,
          column: 4
        }
      },
      "14": {
        start: {
          line: 167,
          column: 52
        },
        end: {
          line: 240,
          column: 1
        }
      },
      "15": {
        start: {
          line: 168,
          column: 32
        },
        end: {
          line: 170,
          column: 3
        }
      },
      "16": {
        start: {
          line: 171,
          column: 34
        },
        end: {
          line: 175,
          column: 3
        }
      },
      "17": {
        start: {
          line: 176,
          column: 27
        },
        end: {
          line: 204,
          column: 3
        }
      },
      "18": {
        start: {
          line: 205,
          column: 25
        },
        end: {
          line: 234,
          column: 3
        }
      },
      "19": {
        start: {
          line: 235,
          column: 2
        },
        end: {
          line: 239,
          column: 4
        }
      },
      "20": {
        start: {
          line: 242,
          column: 57
        },
        end: {
          line: 247,
          column: 1
        }
      },
      "21": {
        start: {
          line: 249,
          column: 56
        },
        end: {
          line: 261,
          column: 1
        }
      },
      "22": {
        start: {
          line: 263,
          column: 46
        },
        end: {
          line: 272,
          column: 1
        }
      },
      "23": {
        start: {
          line: 274,
          column: 55
        },
        end: {
          line: 283,
          column: 1
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 35,
            column: 39
          },
          end: {
            line: 35,
            column: 40
          }
        },
        loc: {
          start: {
            line: 35,
            column: 67
          },
          end: {
            line: 52,
            column: 1
          }
        },
        line: 35
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 54,
            column: 39
          },
          end: {
            line: 54,
            column: 40
          }
        },
        loc: {
          start: {
            line: 54,
            column: 56
          },
          end: {
            line: 70,
            column: 1
          }
        },
        line: 54
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 72,
            column: 39
          },
          end: {
            line: 72,
            column: 40
          }
        },
        loc: {
          start: {
            line: 72,
            column: 56
          },
          end: {
            line: 90,
            column: 1
          }
        },
        line: 72
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 92,
            column: 50
          },
          end: {
            line: 92,
            column: 51
          }
        },
        loc: {
          start: {
            line: 92,
            column: 78
          },
          end: {
            line: 165,
            column: 1
          }
        },
        line: 92
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 167,
            column: 52
          },
          end: {
            line: 167,
            column: 53
          }
        },
        loc: {
          start: {
            line: 167,
            column: 80
          },
          end: {
            line: 240,
            column: 1
          }
        },
        line: 167
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 38,
            column: 14
          },
          end: {
            line: 38,
            column: 40
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 38,
            column: 26
          },
          end: {
            line: 38,
            column: 30
          }
        }, {
          start: {
            line: 38,
            column: 33
          },
          end: {
            line: 38,
            column: 40
          }
        }],
        line: 38
      },
      "1": {
        loc: {
          start: {
            line: 49,
            column: 20
          },
          end: {
            line: 49,
            column: 47
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 49,
            column: 30
          },
          end: {
            line: 49,
            column: 38
          }
        }, {
          start: {
            line: 49,
            column: 41
          },
          end: {
            line: 49,
            column: 47
          }
        }],
        line: 49
      },
      "2": {
        loc: {
          start: {
            line: 67,
            column: 20
          },
          end: {
            line: 67,
            column: 54
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 67,
            column: 30
          },
          end: {
            line: 67,
            column: 38
          }
        }, {
          start: {
            line: 67,
            column: 41
          },
          end: {
            line: 67,
            column: 54
          }
        }],
        line: 67
      },
      "3": {
        loc: {
          start: {
            line: 87,
            column: 20
          },
          end: {
            line: 87,
            column: 47
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 87,
            column: 30
          },
          end: {
            line: 87,
            column: 38
          }
        }, {
          start: {
            line: 87,
            column: 41
          },
          end: {
            line: 87,
            column: 47
          }
        }],
        line: 87
      },
      "4": {
        loc: {
          start: {
            line: 94,
            column: 21
          },
          end: {
            line: 94,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 94,
            column: 31
          },
          end: {
            line: 94,
            column: 45
          }
        }, {
          start: {
            line: 94,
            column: 48
          },
          end: {
            line: 94,
            column: 61
          }
        }],
        line: 94
      },
      "5": {
        loc: {
          start: {
            line: 95,
            column: 16
          },
          end: {
            line: 97,
            column: 12
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 96,
            column: 8
          },
          end: {
            line: 96,
            column: 186
          }
        }, {
          start: {
            line: 97,
            column: 8
          },
          end: {
            line: 97,
            column: 12
          }
        }],
        line: 95
      },
      "6": {
        loc: {
          start: {
            line: 102,
            column: 21
          },
          end: {
            line: 102,
            column: 60
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 102,
            column: 31
          },
          end: {
            line: 102,
            column: 44
          }
        }, {
          start: {
            line: 102,
            column: 47
          },
          end: {
            line: 102,
            column: 60
          }
        }],
        line: 102
      },
      "7": {
        loc: {
          start: {
            line: 125,
            column: 56
          },
          end: {
            line: 125,
            column: 88
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 125,
            column: 66
          },
          end: {
            line: 125,
            column: 79
          }
        }, {
          start: {
            line: 125,
            column: 82
          },
          end: {
            line: 125,
            column: 88
          }
        }],
        line: 125
      },
      "8": {
        loc: {
          start: {
            line: 152,
            column: 19
          },
          end: {
            line: 152,
            column: 51
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 152,
            column: 29
          },
          end: {
            line: 152,
            column: 42
          }
        }, {
          start: {
            line: 152,
            column: 45
          },
          end: {
            line: 152,
            column: 51
          }
        }],
        line: 152
      },
      "9": {
        loc: {
          start: {
            line: 153,
            column: 20
          },
          end: {
            line: 153,
            column: 60
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 153,
            column: 30
          },
          end: {
            line: 153,
            column: 44
          }
        }, {
          start: {
            line: 153,
            column: 47
          },
          end: {
            line: 153,
            column: 60
          }
        }],
        line: 153
      },
      "10": {
        loc: {
          start: {
            line: 157,
            column: 20
          },
          end: {
            line: 157,
            column: 60
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 157,
            column: 30
          },
          end: {
            line: 157,
            column: 44
          }
        }, {
          start: {
            line: 157,
            column: 47
          },
          end: {
            line: 157,
            column: 60
          }
        }],
        line: 157
      },
      "11": {
        loc: {
          start: {
            line: 162,
            column: 15
          },
          end: {
            line: 162,
            column: 45
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 162,
            column: 25
          },
          end: {
            line: 162,
            column: 38
          }
        }, {
          start: {
            line: 162,
            column: 41
          },
          end: {
            line: 162,
            column: 45
          }
        }],
        line: 162
      },
      "12": {
        loc: {
          start: {
            line: 163,
            column: 8
          },
          end: {
            line: 163,
            column: 53
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 163,
            column: 20
          },
          end: {
            line: 163,
            column: 36
          }
        }, {
          start: {
            line: 163,
            column: 39
          },
          end: {
            line: 163,
            column: 53
          }
        }],
        line: 163
      },
      "13": {
        loc: {
          start: {
            line: 169,
            column: 21
          },
          end: {
            line: 169,
            column: 60
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 169,
            column: 31
          },
          end: {
            line: 169,
            column: 44
          }
        }, {
          start: {
            line: 169,
            column: 47
          },
          end: {
            line: 169,
            column: 60
          }
        }],
        line: 169
      },
      "14": {
        loc: {
          start: {
            line: 172,
            column: 21
          },
          end: {
            line: 172,
            column: 60
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 172,
            column: 31
          },
          end: {
            line: 172,
            column: 44
          }
        }, {
          start: {
            line: 172,
            column: 47
          },
          end: {
            line: 172,
            column: 60
          }
        }],
        line: 172
      },
      "15": {
        loc: {
          start: {
            line: 198,
            column: 19
          },
          end: {
            line: 198,
            column: 51
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 198,
            column: 29
          },
          end: {
            line: 198,
            column: 42
          }
        }, {
          start: {
            line: 198,
            column: 45
          },
          end: {
            line: 198,
            column: 51
          }
        }],
        line: 198
      },
      "16": {
        loc: {
          start: {
            line: 228,
            column: 19
          },
          end: {
            line: 228,
            column: 51
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 228,
            column: 29
          },
          end: {
            line: 228,
            column: 42
          }
        }, {
          start: {
            line: 228,
            column: 45
          },
          end: {
            line: 228,
            column: 51
          }
        }],
        line: 228
      },
      "17": {
        loc: {
          start: {
            line: 236,
            column: 15
          },
          end: {
            line: 236,
            column: 45
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 236,
            column: 25
          },
          end: {
            line: 236,
            column: 38
          }
        }, {
          start: {
            line: 236,
            column: 41
          },
          end: {
            line: 236,
            column: 45
          }
        }],
        line: 236
      },
      "18": {
        loc: {
          start: {
            line: 238,
            column: 8
          },
          end: {
            line: 238,
            column: 53
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 238,
            column: 20
          },
          end: {
            line: 238,
            column: 36
          }
        }, {
          start: {
            line: 238,
            column: 39
          },
          end: {
            line: 238,
            column: 53
          }
        }],
        line: 238
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "4c8defb6a2a06430212d64f4aad44a1f82a83e4a"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_ovl9oy3tk = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_ovl9oy3tk();


















function sharedCta_typeof(o) { "@babel/helpers - typeof"; return sharedCta_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, sharedCta_typeof(o); }
function sharedCta_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function sharedCta_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? sharedCta_ownKeys(Object(t), !0).forEach(function (r) { sharedCta_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : sharedCta_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function sharedCta_defineProperty(obj, key, value) { key = sharedCta_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function sharedCta_toPropertyKey(t) { var i = sharedCta_toPrimitive(t, "string"); return "symbol" == sharedCta_typeof(i) ? i : String(i); }
function sharedCta_toPrimitive(t, r) { if ("object" != sharedCta_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != sharedCta_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var buttonBaseStyles = (cov_ovl9oy3tk().s[0]++, {
  boxSizing: 'border-box',
  border: 'none',
  borderRadius: 'roundedSquare',
  cursor: 'pointer',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontSize: 's1',
  fontFamily: fonts.sans,
  fontWeight: '425',
  width: '100%',
  padding: '0.5em 1.5em',
  transition: 'all 0.3s ease',
  position: 'relative',
  _disabled: {
    cursor: 'not-allowed'
  }
});
var resetButtonStyles = (cov_ovl9oy3tk().s[1]++, {
  display: 'inline',
  textAlign: 'left',
  padding: 0,
  width: 'unset',
  borderRadius: 'none',
  fontSize: 'inherit',
  fontWeight: 'inherit',
  minHeight: 'unset'
});
cov_ovl9oy3tk().s[2]++;
var sharedCta_sm = function sm(_ref) {
  var unbounded = _ref.unbounded,
    loading = _ref.loading;
  cov_ovl9oy3tk().f[0]++;
  cov_ovl9oy3tk().s[3]++;
  return sharedCta_objectSpread(sharedCta_objectSpread({
    minHeight: '36px',
    maxWidth: unbounded ? (cov_ovl9oy3tk().b[0][0]++, null) : (cov_ovl9oy3tk().b[0][1]++, '256px')
  }, components_text/* sizes.110 */.J[110]), {}, {
    padding: '8px 16px 7px 16px',
    borderRadius: '12px',
    _active: {
      borderRadius: '11.4px'
    },
    _focus: {
      borderRadius: '14px'
    },
    _disabled: {
      borderRadius: loading ? (cov_ovl9oy3tk().b[1][0]++, '11.4px') : (cov_ovl9oy3tk().b[1][1]++, '12px')
    }
  });
};
cov_ovl9oy3tk().s[4]++;
var sharedCta_md = function md(_ref2) {
  var loading = _ref2.loading;
  cov_ovl9oy3tk().f[1]++;
  cov_ovl9oy3tk().s[5]++;
  return sharedCta_objectSpread(sharedCta_objectSpread({
    minHeight: '56px'
  }, components_text/* sizes.110 */.J[110]), {}, {
    padding: '18px 24px 17px 24px',
    borderRadius: 'semiRounded',
    _active: {
      borderRadius: '15.2px'
    },
    _focus: {
      borderRadius: '18px'
    },
    _disabled: {
      borderRadius: loading ? (cov_ovl9oy3tk().b[2][0]++, '15.2px') : (cov_ovl9oy3tk().b[2][1]++, 'semiRounded')
    }
  });
};
cov_ovl9oy3tk().s[6]++;
var sharedCta_lg = function lg(_ref3) {
  var loading = _ref3.loading;
  cov_ovl9oy3tk().f[2]++;
  cov_ovl9oy3tk().s[7]++;
  return sharedCta_objectSpread(sharedCta_objectSpread({
    minHeight: '68px'
  }, components_text/* sizes.130 */.J[130]), {}, {
    // cplat todo: go back to update this hard coded font once we finalize font size tokens
    fontSize: '20px',
    padding: '23px, 24px, 21px, 24px',
    borderRadius: '18px',
    _active: {
      borderRadius: '17.1px'
    },
    _focus: {
      borderRadius: '20px'
    },
    _disabled: {
      borderRadius: loading ? (cov_ovl9oy3tk().b[3][0]++, '17.1px') : (cov_ovl9oy3tk().b[3][1]++, '18px')
    }
  });
};
cov_ovl9oy3tk().s[8]++;
var sharedCta_primaryButton = function primaryButton(_ref4) {
  var unbounded = _ref4.unbounded,
    loading = _ref4.loading;
  cov_ovl9oy3tk().f[3]++;
  var boundedInactiveStyles = (cov_ovl9oy3tk().s[9]++, {
    backgroundColor: loading ? (cov_ovl9oy3tk().b[4][0]++, 'brandBlue600') : (cov_ovl9oy3tk().b[4][1]++, 'warmgrey300'),
    background: loading ? (cov_ovl9oy3tk().b[5][0]++, "linear-gradient(0deg, rgba(0, 0, 0, 0.10) 0%, rgba(0, 0, 0, 0.10) 100%), linear-gradient(0deg, rgba(106, 0, 241, 0.40) 0%, rgba(106, 0, 241, 0.40) 100%), ".concat(colors/* default.brandBlue600 */.ZP.brandBlue600)) : (cov_ovl9oy3tk().b[5][1]++, null),
    color: 'warmgrey900'
  });
  var unboundedInactiveStyles = (cov_ovl9oy3tk().s[10]++, {
    color: 'blue700',
    backgroundColor: loading ? (cov_ovl9oy3tk().b[6][0]++, 'warmgrey200') : (cov_ovl9oy3tk().b[6][1]++, 'transparent')
  });
  var unBoundedStyling = (cov_ovl9oy3tk().s[11]++, {
    color: 'brandBlue600',
    backgroundColor: 'transparent',
    border: 'none',
    _focus: {
      outline: "1.5px solid ".concat(colors/* default.brandBlue600 */.ZP.brandBlue600),
      _active: {
        outline: 'none'
      }
    },
    _hover: {
      backgroundColor: 'warmgrey200'
    },
    _active: {
      backgroundColor: 'warmgrey200',
      transform: 'scale(0.95)',
      color: 'blue700'
    },
    _disabled: sharedCta_objectSpread(sharedCta_objectSpread({}, unboundedInactiveStyles), {}, {
      _focus: sharedCta_objectSpread(sharedCta_objectSpread({}, unboundedInactiveStyles), {}, {
        outline: 'none'
      }),
      _active: sharedCta_objectSpread(sharedCta_objectSpread({}, unboundedInactiveStyles), {}, {
        transform: loading ? (cov_ovl9oy3tk().b[7][0]++, 'scale(0.95)') : (cov_ovl9oy3tk().b[7][1]++, 'none')
      }),
      _hover: sharedCta_objectSpread({}, unboundedInactiveStyles)
    })
  });
  var boundedStyling = (cov_ovl9oy3tk().s[12]++, {
    color: 'white0',
    backgroundColor: 'brandBlue600',
    _focus: {
      outline: "1.5px solid ".concat(colors/* default.brandBlue600 */.ZP.brandBlue600),
      outlineOffset: '2px',
      _active: {
        outline: 'none'
      }
    },
    _hover: {
      color: 'white0',
      background: "linear-gradient(0deg, rgba(0, 0, 0, 0.10) 0%, rgba(0, 0, 0, 0.10) 100%), linear-gradient(0deg, rgba(106, 0, 241, 0.40) 0%, rgba(106, 0, 241, 0.40) 100%), ".concat(colors/* default.brandBlue600 */.ZP.brandBlue600)
    },
    _active: {
      background: "linear-gradient(0deg, rgba(0, 0, 0, 0.10) 0%, rgba(0, 0, 0, 0.10) 100%), linear-gradient(0deg, rgba(106, 0, 241, 0.40) 0%, rgba(106, 0, 241, 0.40) 100%), ".concat(colors/* default.brandBlue600 */.ZP.brandBlue600),
      transform: 'scale(0.95)'
    },
    _disabled: sharedCta_objectSpread(sharedCta_objectSpread({}, boundedInactiveStyles), {}, {
      _focus: sharedCta_objectSpread(sharedCta_objectSpread({}, boundedInactiveStyles), {}, {
        outline: 'none'
      }),
      _active: sharedCta_objectSpread(sharedCta_objectSpread({}, boundedInactiveStyles), {}, {
        transform: loading ? (cov_ovl9oy3tk().b[8][0]++, 'scale(0.95)') : (cov_ovl9oy3tk().b[8][1]++, 'none'),
        background: loading ? (cov_ovl9oy3tk().b[9][0]++, 'brandBlue600') : (cov_ovl9oy3tk().b[9][1]++, 'warmgrey300')
      }),
      _hover: sharedCta_objectSpread(sharedCta_objectSpread({}, boundedInactiveStyles), {}, {
        background: loading ? (cov_ovl9oy3tk().b[10][0]++, 'brandBlue600') : (cov_ovl9oy3tk().b[10][1]++, 'warmgrey300')
      })
    })
  });
  cov_ovl9oy3tk().s[13]++;
  return sharedCta_objectSpread({
    transform: loading ? (cov_ovl9oy3tk().b[11][0]++, 'scale(0.95)') : (cov_ovl9oy3tk().b[11][1]++, null)
  }, unbounded ? (cov_ovl9oy3tk().b[12][0]++, unBoundedStyling) : (cov_ovl9oy3tk().b[12][1]++, boundedStyling));
};
cov_ovl9oy3tk().s[14]++;
var sharedCta_secondaryButton = function secondaryButton(_ref5) {
  var unbounded = _ref5.unbounded,
    loading = _ref5.loading;
  cov_ovl9oy3tk().f[4]++;
  var boundedInactiveStyles = (cov_ovl9oy3tk().s[15]++, {
    backgroundColor: loading ? (cov_ovl9oy3tk().b[13][0]++, 'warmgrey200') : (cov_ovl9oy3tk().b[13][1]++, 'warmgrey300')
  });
  var unboundedInactiveStyles = (cov_ovl9oy3tk().s[16]++, {
    backgroundColor: loading ? (cov_ovl9oy3tk().b[14][0]++, 'warmgrey200') : (cov_ovl9oy3tk().b[14][1]++, 'transparent'),
    color: 'warmgrey800',
    textDecorationLine: 'none'
  });
  var unBoundedStyling = (cov_ovl9oy3tk().s[17]++, {
    color: 'warmgrey950',
    backgroundColor: 'transparent',
    textDecorationLine: 'underline',
    textUnderlineOffset: '2px',
    _focus: {
      border: "1.5px solid ".concat(colors/* default.warmgrey950 */.ZP.warmgrey950)
    },
    _hover: {
      backgroundColor: 'warmgrey200'
    },
    _active: {
      transform: 'scale(0.95)',
      backgroundColor: 'warmgrey200'
    },
    _disabled: sharedCta_objectSpread(sharedCta_objectSpread({}, unboundedInactiveStyles), {}, {
      _focus: sharedCta_objectSpread({}, unboundedInactiveStyles),
      _active: sharedCta_objectSpread(sharedCta_objectSpread({}, unboundedInactiveStyles), {}, {
        transform: loading ? (cov_ovl9oy3tk().b[15][0]++, 'scale(0.95)') : (cov_ovl9oy3tk().b[15][1]++, 'none')
      }),
      _hover: sharedCta_objectSpread({}, unboundedInactiveStyles)
    })
  });
  var boundedStyling = (cov_ovl9oy3tk().s[18]++, {
    backgroundColor: 'white0',
    border: "1.5px solid ".concat(colors/* default.warmgrey300 */.ZP.warmgrey300),
    _focus: {
      border: "1.5px solid ".concat(colors/* default.warmgrey950 */.ZP.warmgrey950),
      _active: {
        border: "1.5px solid ".concat(colors/* default.warmgrey300 */.ZP.warmgrey300)
      }
    },
    _hover: {
      backgroundColor: 'warmgrey200'
    },
    _active: {
      transform: 'scale(0.95)',
      backgroundColor: 'warmgrey200'
    },
    _disabled: sharedCta_objectSpread(sharedCta_objectSpread({}, boundedInactiveStyles), {}, {
      _focus: sharedCta_objectSpread({}, boundedInactiveStyles),
      _active: sharedCta_objectSpread(sharedCta_objectSpread({}, boundedInactiveStyles), {}, {
        transform: loading ? (cov_ovl9oy3tk().b[16][0]++, 'scale(0.95)') : (cov_ovl9oy3tk().b[16][1]++, 'none')
      }),
      _hover: sharedCta_objectSpread({}, boundedInactiveStyles)
    })
  });
  cov_ovl9oy3tk().s[19]++;
  return sharedCta_objectSpread({
    transform: loading ? (cov_ovl9oy3tk().b[17][0]++, 'scale(0.95)') : (cov_ovl9oy3tk().b[17][1]++, null),
    color: 'warmgrey950'
  }, unbounded ? (cov_ovl9oy3tk().b[18][0]++, unBoundedStyling) : (cov_ovl9oy3tk().b[18][1]++, boundedStyling));
};
var resetLinkStyles = (cov_ovl9oy3tk().s[20]++, {
  backgroundColor: 'none',
  textDecoration: 'none',
  fontSize: 'inherit',
  fontWeight: 'inherit'
});
var linkBaseStyles = (cov_ovl9oy3tk().s[21]++, sharedCta_objectSpread(sharedCta_objectSpread({}, resetLinkStyles), {}, {
  cursor: 'pointer',
  _disabled: {
    color: 'warmgrey700',
    _hover: {
      color: 'warmgrey700'
    },
    _active: {
      color: 'warmgrey700'
    }
  }
}));
var sharedCta_link = (cov_ovl9oy3tk().s[22]++, {
  color: 'brandBlue600',
  textDecoration: 'underline',
  _hover: {
    color: 'blue500'
  },
  _active: {
    color: 'blue200'
  }
});
var secondaryLink = (cov_ovl9oy3tk().s[23]++, {
  color: 'warmgrey950',
  textDecoration: 'underline',
  _hover: {
    color: 'warmgrey800'
  },
  _active: {
    color: 'warmgrey700'
  }
});
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/novo/components/button.mjs













var _excluded = ["variant"],
  _excluded2 = ["variant"],
  _excluded3 = ["variant"];
function cov_mpevqs74i() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/novo/components/button.ts";
  var hash = "a20df828af276bbff82178247a423c259b0026e1";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/novo/components/button.ts",
    statementMap: {
      "0": {
        start: {
          line: 20,
          column: 40
        },
        end: {
          line: 37,
          column: 1
        }
      },
      "1": {
        start: {
          line: 39,
          column: 41
        },
        end: {
          line: 87,
          column: 1
        }
      },
      "2": {
        start: {
          line: 40,
          column: 26
        },
        end: {
          line: 47,
          column: 3
        }
      },
      "3": {
        start: {
          line: 48,
          column: 2
        },
        end: {
          line: 86,
          column: 4
        }
      },
      "4": {
        start: {
          line: 89,
          column: 71
        },
        end: {
          line: 119,
          column: 1
        }
      },
      "5": {
        start: {
          line: 121,
          column: 25
        },
        end: {
          line: 121,
          column: 94
        }
      },
      "6": {
        start: {
          line: 121,
          column: 46
        },
        end: {
          line: 121,
          column: 94
        }
      },
      "7": {
        start: {
          line: 124,
          column: 59
        },
        end: {
          line: 128,
          column: 1
        }
      },
      "8": {
        start: {
          line: 125,
          column: 34
        },
        end: {
          line: 125,
          column: 76
        }
      },
      "9": {
        start: {
          line: 126,
          column: 34
        },
        end: {
          line: 126,
          column: 76
        }
      },
      "10": {
        start: {
          line: 127,
          column: 34
        },
        end: {
          line: 127,
          column: 76
        }
      },
      "11": {
        start: {
          line: 135,
          column: 34
        },
        end: {
          line: 143,
          column: 1
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 39,
            column: 41
          },
          end: {
            line: 39,
            column: 42
          }
        },
        loc: {
          start: {
            line: 39,
            column: 60
          },
          end: {
            line: 87,
            column: 1
          }
        },
        line: 39
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 121,
            column: 25
          },
          end: {
            line: 121,
            column: 26
          }
        },
        loc: {
          start: {
            line: 121,
            column: 46
          },
          end: {
            line: 121,
            column: 94
          }
        },
        line: 121
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 125,
            column: 6
          },
          end: {
            line: 125,
            column: 7
          }
        },
        loc: {
          start: {
            line: 125,
            column: 34
          },
          end: {
            line: 125,
            column: 76
          }
        },
        line: 125
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 126,
            column: 6
          },
          end: {
            line: 126,
            column: 7
          }
        },
        loc: {
          start: {
            line: 126,
            column: 34
          },
          end: {
            line: 126,
            column: 76
          }
        },
        line: 126
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 127,
            column: 6
          },
          end: {
            line: 127,
            column: 7
          }
        },
        loc: {
          start: {
            line: 127,
            column: 34
          },
          end: {
            line: 127,
            column: 76
          }
        },
        line: 127
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 41,
            column: 17
          },
          end: {
            line: 41,
            column: 58
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 41,
            column: 29
          },
          end: {
            line: 41,
            column: 42
          }
        }, {
          start: {
            line: 41,
            column: 45
          },
          end: {
            line: 41,
            column: 58
          }
        }],
        line: 41
      },
      "1": {
        loc: {
          start: {
            line: 42,
            column: 21
          },
          end: {
            line: 42,
            column: 62
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 42,
            column: 33
          },
          end: {
            line: 42,
            column: 46
          }
        }, {
          start: {
            line: 42,
            column: 49
          },
          end: {
            line: 42,
            column: 62
          }
        }],
        line: 42
      },
      "2": {
        loc: {
          start: {
            line: 51,
            column: 12
          },
          end: {
            line: 53,
            column: 47
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 52,
            column: 8
          },
          end: {
            line: 52,
            column: 47
          }
        }, {
          start: {
            line: 53,
            column: 8
          },
          end: {
            line: 53,
            column: 47
          }
        }],
        line: 51
      },
      "3": {
        loc: {
          start: {
            line: 69,
            column: 14
          },
          end: {
            line: 71,
            column: 49
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 70,
            column: 10
          },
          end: {
            line: 70,
            column: 49
          }
        }, {
          start: {
            line: 71,
            column: 10
          },
          end: {
            line: 71,
            column: 49
          }
        }],
        line: 69
      },
      "4": {
        loc: {
          start: {
            line: 76,
            column: 14
          },
          end: {
            line: 78,
            column: 49
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 77,
            column: 10
          },
          end: {
            line: 77,
            column: 49
          }
        }, {
          start: {
            line: 78,
            column: 10
          },
          end: {
            line: 78,
            column: 49
          }
        }],
        line: 76
      },
      "5": {
        loc: {
          start: {
            line: 121,
            column: 46
          },
          end: {
            line: 121,
            column: 94
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 121,
            column: 46
          },
          end: {
            line: 121,
            column: 67
          }
        }, {
          start: {
            line: 121,
            column: 71
          },
          end: {
            line: 121,
            column: 94
          }
        }],
        line: 121
      },
      "6": {
        loc: {
          start: {
            line: 125,
            column: 34
          },
          end: {
            line: 125,
            column: 76
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 125,
            column: 62
          },
          end: {
            line: 125,
            column: 71
          }
        }, {
          start: {
            line: 125,
            column: 74
          },
          end: {
            line: 125,
            column: 76
          }
        }],
        line: 125
      },
      "7": {
        loc: {
          start: {
            line: 126,
            column: 34
          },
          end: {
            line: 126,
            column: 76
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 126,
            column: 62
          },
          end: {
            line: 126,
            column: 71
          }
        }, {
          start: {
            line: 126,
            column: 74
          },
          end: {
            line: 126,
            column: 76
          }
        }],
        line: 126
      },
      "8": {
        loc: {
          start: {
            line: 127,
            column: 34
          },
          end: {
            line: 127,
            column: 76
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 127,
            column: 62
          },
          end: {
            line: 127,
            column: 71
          }
        }, {
          start: {
            line: 127,
            column: 74
          },
          end: {
            line: 127,
            column: 76
          }
        }],
        line: 127
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "a20df828af276bbff82178247a423c259b0026e1"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_mpevqs74i = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_mpevqs74i();






function button_typeof(o) { "@babel/helpers - typeof"; return button_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, button_typeof(o); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function button_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function button_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? button_ownKeys(Object(t), !0).forEach(function (r) { button_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : button_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function button_defineProperty(obj, key, value) { key = button_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function button_toPropertyKey(t) { var i = button_toPrimitive(t, "string"); return "symbol" == button_typeof(i) ? i : String(i); }
function button_toPrimitive(t, r) { if ("object" != button_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != button_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var ghost = (cov_mpevqs74i().s[0]++, {
  padding: 0,
  height: 'auto',
  width: 'auto',
  backgroundColor: 'transparent',
  _hover: {
    color: 'warmgrey950',
    backgroundColor: 'warmgrey200'
  },
  _active: {
    color: 'warmgrey800'
  },
  _disabled: {
    border: 'none',
    backgroundColor: 'warmgrey200',
    color: 'warmgrey800'
  }
});
cov_mpevqs74i().s[1]++;
var icon = function icon(_ref) {
  var unbounded = _ref.unbounded;
  cov_mpevqs74i().f[0]++;
  var inactiveStyling = (cov_mpevqs74i().s[2]++, {
    borderColor: unbounded ? (cov_mpevqs74i().b[0][0]++, 'transparent') : (cov_mpevqs74i().b[0][1]++, 'warmgrey300'),
    backgroundColor: unbounded ? (cov_mpevqs74i().b[1][0]++, 'transparent') : (cov_mpevqs74i().b[1][1]++, 'warmgrey300'),
    color: 'warmgrey700',
    ' svg': {
      color: '#9D9893 !important'
    }
  });
  cov_mpevqs74i().s[3]++;
  return {
    flexShrink: 0,
    flexGrow: 0,
    border: unbounded ? (cov_mpevqs74i().b[2][0]++, "1.5px solid var(--colors-transparent)") : (cov_mpevqs74i().b[2][1]++, "1.5px solid var(--colors-warmgrey300)"),
    outline: 'none',
    borderRadius: 'rounded',
    minHeight: 'auto',
    height: '40px',
    width: '40px',
    color: 'warmgrey950',
    backgroundColor: 'white0',
    padding: 0,
    _focus: {
      border: "1.5px solid var(--colors-warmgrey950)",
      outline: 'none',
      _disabled: inactiveStyling
    },
    _hover: {
      backgroundColor: 'warmgrey200',
      border: unbounded ? (cov_mpevqs74i().b[3][0]++, '1.5px solid var(--colors-warmgrey200)') : (cov_mpevqs74i().b[3][1]++, "1.5px solid var(--colors-warmgrey300)"),
      _disabled: inactiveStyling
    },
    _active: {
      backgroundColor: 'warmgrey200',
      border: unbounded ? (cov_mpevqs74i().b[4][0]++, "1.5px solid var(--colors-warmgrey200)") : (cov_mpevqs74i().b[4][1]++, "1.5px solid var(--colors-warmgrey300)"),
      transform: 'scale(0.95)',
      ' svg': {
        color: 'warmgrey950'
      },
      _disabled: button_objectSpread(button_objectSpread({}, inactiveStyling), {}, {
        transform: 'none'
      })
    },
    _disabled: inactiveStyling
  };
};
var button_variants = (cov_mpevqs74i().s[4]++, {
  primary: sharedCta_primaryButton,
  secondary: sharedCta_secondaryButton,
  icon: icon,
  ghost: ghost,
  /**
   * @deprecated
   * NOTE: This is a known antipattern, however for conversion reasons this is occasionally a
   * requirement. Make sure to verify with design that this behavior is absolutely necessary
   * and appropriate a11y concerns were considered.
   */
  link: button_objectSpread(button_objectSpread(button_objectSpread(button_objectSpread({}, resetButtonStyles), linkBaseStyles), sharedCta_link), {}, {
    textDecoration: 'none',
    fontWeight: 'semibold'
  }),
  /**
   * NOTE: This is a known antipattern, however for conversion reasons this is occasionally a
   * requirement. Make sure to verify with design that this behavior is absolutely necessary
   * and appropriate a11y concerns were considered.
   */
  'inline-link': button_objectSpread(button_objectSpread(button_objectSpread({}, resetButtonStyles), linkBaseStyles), sharedCta_link),
  /**
   * NOTE: This is a known antipattern, however for conversion reasons this is occasionally a
   * requirement. Make sure to verify with design that this behavior is absolutely necessary
   * and appropriate a11y concerns were considered
   */
  'inline-secondary-link': button_objectSpread(button_objectSpread(button_objectSpread({}, resetButtonStyles), linkBaseStyles), secondaryLink)
});
cov_mpevqs74i().s[5]++;
var shouldApplySizes = function shouldApplySizes(variant) {
  cov_mpevqs74i().f[1]++;
  cov_mpevqs74i().s[6]++;
  return (cov_mpevqs74i().b[5][0]++, variant === 'primary') || (cov_mpevqs74i().b[5][1]++, variant === 'secondary');
};

/** NOTE: Sizes only get applied for button variants */
var button_sizes = (cov_mpevqs74i().s[7]++, {
  sm: function sm(_ref2) {
    var variant = _ref2.variant,
      props = _objectWithoutProperties(_ref2, _excluded);
    cov_mpevqs74i().f[2]++;
    cov_mpevqs74i().s[8]++;
    return shouldApplySizes(variant) ? (cov_mpevqs74i().b[6][0]++, sharedCta_sm(props)) : (cov_mpevqs74i().b[6][1]++, {});
  },
  md: function md(_ref3) {
    var variant = _ref3.variant,
      props = _objectWithoutProperties(_ref3, _excluded2);
    cov_mpevqs74i().f[3]++;
    cov_mpevqs74i().s[9]++;
    return shouldApplySizes(variant) ? (cov_mpevqs74i().b[7][0]++, sharedCta_md(props)) : (cov_mpevqs74i().b[7][1]++, {});
  },
  lg: function lg(_ref4) {
    var variant = _ref4.variant,
      props = _objectWithoutProperties(_ref4, _excluded3);
    cov_mpevqs74i().f[4]++;
    cov_mpevqs74i().s[10]++;
    return shouldApplySizes(variant) ? (cov_mpevqs74i().b[8][0]++, sharedCta_lg(props)) : (cov_mpevqs74i().b[8][1]++, {});
  }
});
var button_button = (cov_mpevqs74i().s[11]++, {
  baseStyle: buttonBaseStyles,
  variants: button_variants,
  sizes: button_sizes,
  defaultProps: {
    variant: 'primary',
    size: 'md'
  }
});
/* harmony default export */ var components_button = (button_button);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/novo/components/checkbox.mjs
function cov_qwcglqo2z() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/novo/components/checkbox.ts";
  var hash = "b4b6966e4cfc17528770c068047db162f344414e";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/novo/components/checkbox.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 50
        },
        end: {
          line: 14,
          column: 1
        }
      },
      "1": {
        start: {
          line: 15,
          column: 51
        },
        end: {
          line: 19,
          column: 1
        }
      },
      "2": {
        start: {
          line: 24,
          column: 44
        },
        end: {
          line: 69,
          column: 1
        }
      },
      "3": {
        start: {
          line: 71,
          column: 45
        },
        end: {
          line: 73,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "b4b6966e4cfc17528770c068047db162f344414e"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_qwcglqo2z = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_qwcglqo2z();


















function checkbox_typeof(o) { "@babel/helpers - typeof"; return checkbox_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, checkbox_typeof(o); }
function checkbox_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function checkbox_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? checkbox_ownKeys(Object(t), !0).forEach(function (r) { checkbox_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : checkbox_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function checkbox_defineProperty(obj, key, value) { key = checkbox_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function checkbox_toPropertyKey(t) { var i = checkbox_toPrimitive(t, "string"); return "symbol" == checkbox_typeof(i) ? i : String(i); }
function checkbox_toPrimitive(t, r) { if ("object" != checkbox_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != checkbox_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var defaultCheckbox = (cov_qwcglqo2z().s[0]++, {
  content: "\"\"",
  width: '12px',
  height: '12px',
  position: 'absolute',
  left: '0',
  top: '2px',
  cursor: 'pointer',
  borderRadius: 'squared',
  transition: 'all 0.15s cubic-bezier(0.1, 0.7, 0.1, 1)',
  boxSizing: 'content-box'
});
var disabledCheckbox = (cov_qwcglqo2z().s[1]++, {
  content: "\"\"",
  opacity: '40%',
  cursor: 'default'
});

// Custom styling for the checkbox button & hides input
// Used pseudo-elements & adjacent sibling selectors to create a custom accessible checkbox button
// https://medium.com/claritydesignsystem/pure-css-accessible-checkboxes-and-radios-buttons-54063e759bb3
var checkbox_baseStyle = (cov_qwcglqo2z().s[2]++, {
  // opacity: 0 visually hides this input in an accessible way (do not use display: none), so we can create our own custom checkbox
  opacity: 0,
  position: 'absolute',
  // & + label styles is applied to the label component immediately after the input to style a custom checkbox button
  '& + label': {
    position: 'relative',
    paddingLeft: '23px',
    _before: checkbox_objectSpread({
      border: "2px solid var(--colors-warmgrey300)"
    }, defaultCheckbox)
  },
  '&:checked + label': {
    // checked checkbox background
    _before: checkbox_objectSpread({
      border: "2px solid var(--colors-brandBlue600)",
      bg: 'brandBlue600'
    }, defaultCheckbox),
    // checkmark styling
    _after: checkbox_objectSpread(checkbox_objectSpread({}, defaultCheckbox), {}, {
      content: "\"\"",
      position: 'absolute',
      left: '5px',
      top: '5px',
      width: '3px',
      height: '6px',
      border: "solid var(--colors-white0)",
      borderWidth: '0 3px 3px 0',
      transform: 'rotate(45deg)'
    })
  },
  _disabled: {
    '& + label': {
      _before: checkbox_objectSpread({}, disabledCheckbox),
      _after: checkbox_objectSpread({}, disabledCheckbox)
    }
  }
});
var checkbox_checkbox = (cov_qwcglqo2z().s[3]++, {
  baseStyle: checkbox_baseStyle
});
/* harmony default export */ var components_checkbox = (checkbox_checkbox);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/novo/components/chip.mjs
function cov_1tape47z9() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/novo/components/chip.ts";
  var hash = "96f5fab5ffa1552333ab3d50645e2dc3f64281e9";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/novo/components/chip.ts",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 51
        },
        end: {
          line: 20,
          column: 2
        }
      },
      "1": {
        start: {
          line: 4,
          column: 63
        },
        end: {
          line: 20,
          column: 1
        }
      },
      "2": {
        start: {
          line: 22,
          column: 47
        },
        end: {
          line: 32,
          column: 2
        }
      },
      "3": {
        start: {
          line: 22,
          column: 59
        },
        end: {
          line: 32,
          column: 1
        }
      },
      "4": {
        start: {
          line: 34,
          column: 48
        },
        end: {
          line: 44,
          column: 2
        }
      },
      "5": {
        start: {
          line: 34,
          column: 60
        },
        end: {
          line: 44,
          column: 1
        }
      },
      "6": {
        start: {
          line: 46,
          column: 47
        },
        end: {
          line: 56,
          column: 2
        }
      },
      "7": {
        start: {
          line: 46,
          column: 59
        },
        end: {
          line: 56,
          column: 1
        }
      },
      "8": {
        start: {
          line: 58,
          column: 52
        },
        end: {
          line: 68,
          column: 2
        }
      },
      "9": {
        start: {
          line: 58,
          column: 64
        },
        end: {
          line: 68,
          column: 1
        }
      },
      "10": {
        start: {
          line: 70,
          column: 56
        },
        end: {
          line: 86,
          column: 1
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 4,
            column: 51
          },
          end: {
            line: 4,
            column: 52
          }
        },
        loc: {
          start: {
            line: 4,
            column: 63
          },
          end: {
            line: 20,
            column: 1
          }
        },
        line: 4
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 22,
            column: 47
          },
          end: {
            line: 22,
            column: 48
          }
        },
        loc: {
          start: {
            line: 22,
            column: 59
          },
          end: {
            line: 32,
            column: 1
          }
        },
        line: 22
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 34,
            column: 48
          },
          end: {
            line: 34,
            column: 49
          }
        },
        loc: {
          start: {
            line: 34,
            column: 60
          },
          end: {
            line: 44,
            column: 1
          }
        },
        line: 34
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 46,
            column: 47
          },
          end: {
            line: 46,
            column: 48
          }
        },
        loc: {
          start: {
            line: 46,
            column: 59
          },
          end: {
            line: 56,
            column: 1
          }
        },
        line: 46
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 58,
            column: 52
          },
          end: {
            line: 58,
            column: 53
          }
        },
        loc: {
          start: {
            line: 58,
            column: 64
          },
          end: {
            line: 68,
            column: 1
          }
        },
        line: 58
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 11
          },
          end: {
            line: 6,
            column: 76
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 6,
            column: 28
          },
          end: {
            line: 6,
            column: 41
          }
        }, {
          start: {
            line: 6,
            column: 44
          },
          end: {
            line: 6,
            column: 76
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 6,
            column: 44
          },
          end: {
            line: 6,
            column: 76
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 44
          },
          end: {
            line: 6,
            column: 59
          }
        }, {
          start: {
            line: 6,
            column: 63
          },
          end: {
            line: 6,
            column: 76
          }
        }],
        line: 6
      },
      "2": {
        loc: {
          start: {
            line: 13,
            column: 21
          },
          end: {
            line: 13,
            column: 74
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 13,
            column: 38
          },
          end: {
            line: 13,
            column: 50
          }
        }, {
          start: {
            line: 13,
            column: 53
          },
          end: {
            line: 13,
            column: 74
          }
        }],
        line: 13
      },
      "3": {
        loc: {
          start: {
            line: 14,
            column: 12
          },
          end: {
            line: 14,
            column: 69
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 14,
            column: 49
          },
          end: {
            line: 14,
            column: 55
          }
        }, {
          start: {
            line: 14,
            column: 58
          },
          end: {
            line: 14,
            column: 69
          }
        }],
        line: 14
      },
      "4": {
        loc: {
          start: {
            line: 14,
            column: 12
          },
          end: {
            line: 14,
            column: 46
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 14,
            column: 12
          },
          end: {
            line: 14,
            column: 26
          }
        }, {
          start: {
            line: 14,
            column: 30
          },
          end: {
            line: 14,
            column: 46
          }
        }],
        line: 14
      },
      "5": {
        loc: {
          start: {
            line: 25,
            column: 11
          },
          end: {
            line: 25,
            column: 76
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 25,
            column: 28
          },
          end: {
            line: 25,
            column: 41
          }
        }, {
          start: {
            line: 25,
            column: 44
          },
          end: {
            line: 25,
            column: 76
          }
        }],
        line: 25
      },
      "6": {
        loc: {
          start: {
            line: 25,
            column: 44
          },
          end: {
            line: 25,
            column: 76
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 25,
            column: 44
          },
          end: {
            line: 25,
            column: 59
          }
        }, {
          start: {
            line: 25,
            column: 63
          },
          end: {
            line: 25,
            column: 76
          }
        }],
        line: 25
      },
      "7": {
        loc: {
          start: {
            line: 37,
            column: 11
          },
          end: {
            line: 37,
            column: 76
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 37,
            column: 28
          },
          end: {
            line: 37,
            column: 41
          }
        }, {
          start: {
            line: 37,
            column: 44
          },
          end: {
            line: 37,
            column: 76
          }
        }],
        line: 37
      },
      "8": {
        loc: {
          start: {
            line: 37,
            column: 44
          },
          end: {
            line: 37,
            column: 76
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 37,
            column: 44
          },
          end: {
            line: 37,
            column: 59
          }
        }, {
          start: {
            line: 37,
            column: 63
          },
          end: {
            line: 37,
            column: 76
          }
        }],
        line: 37
      },
      "9": {
        loc: {
          start: {
            line: 49,
            column: 11
          },
          end: {
            line: 49,
            column: 76
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 49,
            column: 28
          },
          end: {
            line: 49,
            column: 41
          }
        }, {
          start: {
            line: 49,
            column: 44
          },
          end: {
            line: 49,
            column: 76
          }
        }],
        line: 49
      },
      "10": {
        loc: {
          start: {
            line: 49,
            column: 44
          },
          end: {
            line: 49,
            column: 76
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 49,
            column: 44
          },
          end: {
            line: 49,
            column: 59
          }
        }, {
          start: {
            line: 49,
            column: 63
          },
          end: {
            line: 49,
            column: 76
          }
        }],
        line: 49
      },
      "11": {
        loc: {
          start: {
            line: 61,
            column: 11
          },
          end: {
            line: 61,
            column: 76
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 61,
            column: 28
          },
          end: {
            line: 61,
            column: 41
          }
        }, {
          start: {
            line: 61,
            column: 44
          },
          end: {
            line: 61,
            column: 76
          }
        }],
        line: 61
      },
      "12": {
        loc: {
          start: {
            line: 61,
            column: 44
          },
          end: {
            line: 61,
            column: 76
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 61,
            column: 44
          },
          end: {
            line: 61,
            column: 59
          }
        }, {
          start: {
            line: 61,
            column: 63
          },
          end: {
            line: 61,
            column: 76
          }
        }],
        line: 61
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "96f5fab5ffa1552333ab3d50645e2dc3f64281e9"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1tape47z9 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1tape47z9();




cov_1tape47z9().s[0]++;
var chip_baseStyle = function baseStyle(props) {
  var _ref;
  cov_1tape47z9().f[0]++;
  cov_1tape47z9().s[1]++;
  return {
    label: {
      color: props.disabled ? (cov_1tape47z9().b[0][0]++, 'warmgrey700') : (cov_1tape47z9().b[0][1]++, (_ref = (cov_1tape47z9().b[1][0]++, props.textColor)) !== null && _ref !== void 0 ? _ref : (cov_1tape47z9().b[1][1]++, 'warmgrey950')),
      fontWeight: 'semibold'
    },
    container: {
      flexDirection: props.flexDirection,
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: props.disabled ? (cov_1tape47z9().b[2][0]++, 'neutrals20') : (cov_1tape47z9().b[2][1]++, props.backgroundColor),
      border: (cov_1tape47z9().b[4][0]++, props.disabled) || (cov_1tape47z9().b[4][1]++, !props.hasBorder) ? (cov_1tape47z9().b[3][0]++, 'none') : (cov_1tape47z9().b[3][1]++, '2px solid'),
      borderRadius: 'squared',
      borderColor: props.borderColor,
      paddingLeft: 3,
      paddingRight: 3
    }
  };
};
cov_1tape47z9().s[2]++;
var small = function small(props) {
  var _ref2;
  cov_1tape47z9().f[1]++;
  cov_1tape47z9().s[3]++;
  return {
    label: {
      fontSize: 's00',
      color: props.disabled ? (cov_1tape47z9().b[5][0]++, 'warmgrey700') : (cov_1tape47z9().b[5][1]++, (_ref2 = (cov_1tape47z9().b[6][0]++, props.textColor)) !== null && _ref2 !== void 0 ? _ref2 : (cov_1tape47z9().b[6][1]++, 'warmgrey950'))
    },
    container: {
      height: '28px',
      paddingTop: 3,
      paddingBottom: 3
    }
  };
};
cov_1tape47z9().s[4]++;
var medium = function medium(props) {
  var _ref3;
  cov_1tape47z9().f[2]++;
  cov_1tape47z9().s[5]++;
  return {
    label: {
      fontSize: 's0',
      color: props.disabled ? (cov_1tape47z9().b[7][0]++, 'warmgrey700') : (cov_1tape47z9().b[7][1]++, (_ref3 = (cov_1tape47z9().b[8][0]++, props.textColor)) !== null && _ref3 !== void 0 ? _ref3 : (cov_1tape47z9().b[8][1]++, 'warmgrey950'))
    },
    container: {
      height: '30px',
      paddingTop: 3,
      paddingBottom: 3
    }
  };
};
cov_1tape47z9().s[6]++;
var large = function large(props) {
  var _ref4;
  cov_1tape47z9().f[3]++;
  cov_1tape47z9().s[7]++;
  return {
    label: {
      fontSize: 's1',
      color: props.disabled ? (cov_1tape47z9().b[9][0]++, 'warmgrey700') : (cov_1tape47z9().b[9][1]++, (_ref4 = (cov_1tape47z9().b[10][0]++, props.textColor)) !== null && _ref4 !== void 0 ? _ref4 : (cov_1tape47z9().b[10][1]++, 'warmgrey950'))
    },
    container: {
      height: '36px',
      paddingTop: 4,
      paddingBottom: 4
    }
  };
};
cov_1tape47z9().s[8]++;
var extraLarge = function extraLarge(props) {
  var _ref5;
  cov_1tape47z9().f[4]++;
  cov_1tape47z9().s[9]++;
  return {
    label: {
      fontSize: 's1',
      color: props.disabled ? (cov_1tape47z9().b[11][0]++, 'warmgrey700') : (cov_1tape47z9().b[11][1]++, (_ref5 = (cov_1tape47z9().b[12][0]++, props.textColor)) !== null && _ref5 !== void 0 ? _ref5 : (cov_1tape47z9().b[12][1]++, 'warmgrey950'))
    },
    container: {
      height: '44px',
      paddingTop: 4,
      paddingBottom: 4
    }
  };
};
var Chip = (cov_1tape47z9().s[10]++, {
  // The parts of the component
  parts: anatomy_types/* chipAnatomy.keys */.Q0.keys,
  // The base styles for each part
  baseStyle: chip_baseStyle,
  // The size styles for each part
  sizes: {
    small: small,
    medium: medium,
    large: large,
    'extra-large': extraLarge
  },
  // The default `size` or `variant` values
  defaultProps: {
    sizes: 'small'
  }
});
/* harmony default export */ var chip = (Chip);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/novo/components/form.mjs
function cov_s1t1o8z1q() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/novo/components/form.ts";
  var hash = "b757325b85f5b6fcbaaa6450aa9386a166324de1";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/novo/components/form.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 41
        },
        end: {
          line: 3,
          column: 58
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "b757325b85f5b6fcbaaa6450aa9386a166324de1"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_s1t1o8z1q = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_s1t1o8z1q();
var form_form = (cov_s1t1o8z1q().s[0]++, {
  baseStyle: {}
});
/* harmony default export */ var components_form = (form_form);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/novo/components/formElements.mjs
function cov_1fqm18nmqf() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/novo/components/formElements.ts";
  var hash = "cc7fadf508288838c42c1cbb4af84814b60c290f";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/novo/components/formElements.ts",
    statementMap: {
      "0": {
        start: {
          line: 9,
          column: 49
        },
        end: {
          line: 12,
          column: 1
        }
      },
      "1": {
        start: {
          line: 13,
          column: 57
        },
        end: {
          line: 16,
          column: 1
        }
      },
      "2": {
        start: {
          line: 18,
          column: 52
        },
        end: {
          line: 26,
          column: 1
        }
      },
      "3": {
        start: {
          line: 27,
          column: 60
        },
        end: {
          line: 30,
          column: 1
        }
      },
      "4": {
        start: {
          line: 32,
          column: 55
        },
        end: {
          line: 36,
          column: 1
        }
      },
      "5": {
        start: {
          line: 38,
          column: 56
        },
        end: {
          line: 59,
          column: 1
        }
      },
      "6": {
        start: {
          line: 61,
          column: 61
        },
        end: {
          line: 65,
          column: 1
        }
      },
      "7": {
        start: {
          line: 67,
          column: 61
        },
        end: {
          line: 71,
          column: 1
        }
      },
      "8": {
        start: {
          line: 73,
          column: 59
        },
        end: {
          line: 82,
          column: 1
        }
      },
      "9": {
        start: {
          line: 85,
          column: 64
        },
        end: {
          line: 88,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "cc7fadf508288838c42c1cbb4af84814b60c290f"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1fqm18nmqf = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1fqm18nmqf();
function formElements_typeof(o) { "@babel/helpers - typeof"; return formElements_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, formElements_typeof(o); }


















function formElements_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function formElements_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? formElements_ownKeys(Object(t), !0).forEach(function (r) { formElements_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : formElements_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function formElements_defineProperty(obj, key, value) { key = formElements_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function formElements_toPropertyKey(t) { var i = formElements_toPrimitive(t, "string"); return "symbol" == formElements_typeof(i) ? i : String(i); }
function formElements_toPrimitive(t, r) { if ("object" != formElements_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != formElements_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

// Styles the label
var baseStyleLabel = (cov_1fqm18nmqf().s[0]++, {
  ml: 3,
  textColor: 'warmgrey950'
});
var baseStyleDisabledLabel = (cov_1fqm18nmqf().s[1]++, formElements_objectSpread(formElements_objectSpread({}, baseStyleLabel), {}, {
  textColor: 'warmgrey700'
}));
// Styles the subtitle
var baseStyleSubtitle = (cov_1fqm18nmqf().s[2]++, {
  pt: 3,
  pl: 3,
  display: 'block',
  color: 'warmgrey950',
  fontWeight: 'normal',
  fontSize: 's0',
  lineHeight: 1
});
var baseStyleDisabledSubtitle = (cov_1fqm18nmqf().s[3]++, formElements_objectSpread(formElements_objectSpread({}, baseStyleSubtitle), {}, {
  textColor: 'warmgrey700'
}));
var baseStyleNoContainer = (cov_1fqm18nmqf().s[4]++, {
  marginRight: 5,
  paddingBlock: 3,
  lineHeight: 1.3
});
var baseStyleHasContainer = (cov_1fqm18nmqf().s[5]++, {
  border: "2px solid var(--colors-neutrals40)",
  borderRadius: 'roundedSquare',
  cursor: 'pointer',
  paddingBlock: 7,
  paddingLeft: 5,
  paddingRight: 4,
  marginBlockEnd: 3,
  lineHeight: 1.3,
  transition: "250ms ease border-color",
  _hover: {
    border: "2px solid var(--colors-warmgrey700)"
  },
  // Focus-within styling provides styling if the parent has focus.
  // https://developer.mozilla.org/en-US/docs/Web/CSS/:focus-within
  _focusWithin: {
    border: "2px solid var(--colors-warmgrey950)"
  },
  '&:first-of-type': {
    marginBlockStart: 3
  }
});
var baseStyleDisabledContainer = (cov_1fqm18nmqf().s[6]++, formElements_objectSpread(formElements_objectSpread({}, baseStyleHasContainer), {}, {
  backgroundColor: 'warmgrey100',
  cursor: 'default'
}));
var baseStyleHasErrorContainer = (cov_1fqm18nmqf().s[7]++, formElements_objectSpread(formElements_objectSpread({}, baseStyleHasContainer), {}, {
  border: "2px solid var(--colors-error500)",
  cursor: 'default'
}));
var formElements_baseStyle = (cov_1fqm18nmqf().s[8]++, {
  label: baseStyleLabel,
  disabledLabel: baseStyleDisabledLabel,
  subtitle: baseStyleSubtitle,
  disabledSubtitle: baseStyleDisabledSubtitle,
  noContainer: baseStyleNoContainer,
  errorContainer: baseStyleHasErrorContainer,
  disabledContainer: baseStyleDisabledContainer,
  hasContainer: formElements_objectSpread({}, baseStyleHasContainer)
});

// NOTE: This is not a correctly styled multiStyleConfig so the types have been fudged a bit
var formElements = (cov_1fqm18nmqf().s[9]++, {
  parts: anatomy_types/* formElementsAnatomy.keys */.Ss.keys,
  baseStyle: formElements_baseStyle
});
/* harmony default export */ var components_formElements = (formElements);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/novo/components/heading.mjs
function cov_28c0m897tm() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/novo/components/heading.ts";
  var hash = "0662da101ea3d821a69eefb7b277f9e7ebf00c40";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/novo/components/heading.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 44
        },
        end: {
          line: 9,
          column: 1
        }
      },
      "1": {
        start: {
          line: 16,
          column: 4
        },
        end: {
          line: 16,
          column: 13
        }
      },
      "2": {
        start: {
          line: 21,
          column: 36
        },
        end: {
          line: 21,
          column: 56
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "0662da101ea3d821a69eefb7b277f9e7ebf00c40"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_28c0m897tm = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_28c0m897tm();

var heading_baseStyle = (cov_28c0m897tm().s[0]++, {
  fontWeight: 'semibold',
  fontFamily: 'sans',
  color: 'warmgrey950'
});
var heading_sizes = (cov_28c0m897tm().s[1]++, components_text/* sizes */.J);
var heading = (cov_28c0m897tm().s[2]++, {
  baseStyle: heading_baseStyle,
  sizes: heading_sizes
});
/* harmony default export */ var components_heading = (heading);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/novo/components/image.mjs
function cov_1gkle4g1kc() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/novo/components/image.ts";
  var hash = "96558e6ccebf648d973f39bf0fce327ffb3d3c7b";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/novo/components/image.ts",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 42
        },
        end: {
          line: 8,
          column: 1
        }
      },
      "1": {
        start: {
          line: 9,
          column: 43
        },
        end: {
          line: 9,
          column: 45
        }
      },
      "2": {
        start: {
          line: 15,
          column: 32
        },
        end: {
          line: 18,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "96558e6ccebf648d973f39bf0fce327ffb3d3c7b"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1gkle4g1kc = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1gkle4g1kc();
var image_primary = (cov_1gkle4g1kc().s[0]++, {
  m: 0,
  height: 'auto',
  maxWidth: '100%'
});
var unstyled = (cov_1gkle4g1kc().s[1]++, {});
var image_image = (cov_1gkle4g1kc().s[2]++, {
  variants: {
    primary: image_primary,
    unstyled: unstyled
  },
  defaultProps: {
    variant: 'primary'
  }
});
/* harmony default export */ var components_image = (image_image);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/novo/components/input.mjs
function cov_muqpqj5oy() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/novo/components/input.ts";
  var hash = "a847bcb14117a5c320b1f1e02db9fa2baa53c457";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/novo/components/input.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 44
        },
        end: {
          line: 31,
          column: 1
        }
      },
      "1": {
        start: {
          line: 33,
          column: 42
        },
        end: {
          line: 33,
          column: 55
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "a847bcb14117a5c320b1f1e02db9fa2baa53c457"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_muqpqj5oy = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_muqpqj5oy();
var input_baseStyle = (cov_muqpqj5oy().s[0]++, {
  boxSizing: 'border-box',
  textOverflow: 'ellipsis',
  transition: 'color 0.3s ease',
  fontSize: 's1',
  width: '100%',
  border: "2px solid var(--colors-neutrals40)",
  borderRadius: 'roundedSquare',
  padding: 4,
  _placeholder: {
    color: 'warmgrey800',
    opacity: 1
  },
  _disabled: {
    bgcolor: 'warmgrey100',
    color: 'warmgrey700',
    cursor: 'not-allowed',
    _placeholder: {
      color: 'warmgrey700'
    }
  },
  _focus: {
    outline: 'none',
    border: "2px solid var(--colors-warmgrey950)"
  },
  _invalid: {
    border: "2px solid var(--colors-error500)"
  }
});
var input = (cov_muqpqj5oy().s[1]++, {
  baseStyle: input_baseStyle
});
/* harmony default export */ var components_input = (input);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/novo/components/label.mjs
function cov_2b0ga36c6g() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/novo/components/label.ts";
  var hash = "b514a7004f91128ab0b78c5fa8c13c1644fde15d";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/novo/components/label.ts",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 52
        },
        end: {
          line: 14,
          column: 1
        }
      },
      "1": {
        start: {
          line: 16,
          column: 50
        },
        end: {
          line: 19,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "b514a7004f91128ab0b78c5fa8c13c1644fde15d"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2b0ga36c6g = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2b0ga36c6g();




var label_baseStyle = (cov_2b0ga36c6g().s[0]++, {
  label: {
    fontSize: 's1',
    fontWeight: 'semibold',
    textAlign: 'left'
  },
  requiredIndicator: {
    marginStart: 1,
    color: 'error500'
  }
});
var label = (cov_2b0ga36c6g().s[1]++, {
  parts: anatomy_types/* labelAnatomy.keys */.yo.keys,
  baseStyle: label_baseStyle
});
/* harmony default export */ var components_label = (label);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__(26699);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__(32023);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/novo/components/link.mjs











var link_excluded = ["variant"],
  link_excluded2 = ["variant"],
  link_excluded3 = ["variant"];
function cov_1bjx6atoez() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/novo/components/link.ts";
  var hash = "f7f466cbc62c5ba2b8038954d014b01df449d43b";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/novo/components/link.ts",
    statementMap: {
      "0": {
        start: {
          line: 17,
          column: 45
        },
        end: {
          line: 38,
          column: 2
        }
      },
      "1": {
        start: {
          line: 17,
          column: 64
        },
        end: {
          line: 38,
          column: 1
        }
      },
      "2": {
        start: {
          line: 40,
          column: 76
        },
        end: {
          line: 71,
          column: 1
        }
      },
      "3": {
        start: {
          line: 60,
          column: 32
        },
        end: {
          line: 62,
          column: 3
        }
      },
      "4": {
        start: {
          line: 68,
          column: 34
        },
        end: {
          line: 70,
          column: 3
        }
      },
      "5": {
        start: {
          line: 74,
          column: 66
        },
        end: {
          line: 78,
          column: 1
        }
      },
      "6": {
        start: {
          line: 75,
          column: 34
        },
        end: {
          line: 75,
          column: 87
        }
      },
      "7": {
        start: {
          line: 76,
          column: 34
        },
        end: {
          line: 76,
          column: 87
        }
      },
      "8": {
        start: {
          line: 77,
          column: 34
        },
        end: {
          line: 77,
          column: 87
        }
      },
      "9": {
        start: {
          line: 85,
          column: 30
        },
        end: {
          line: 91,
          column: 1
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 17,
            column: 45
          },
          end: {
            line: 17,
            column: 46
          }
        },
        loc: {
          start: {
            line: 17,
            column: 64
          },
          end: {
            line: 38,
            column: 1
          }
        },
        line: 17
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 60,
            column: 20
          },
          end: {
            line: 60,
            column: 21
          }
        },
        loc: {
          start: {
            line: 60,
            column: 32
          },
          end: {
            line: 62,
            column: 3
          }
        },
        line: 60
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 68,
            column: 22
          },
          end: {
            line: 68,
            column: 23
          }
        },
        loc: {
          start: {
            line: 68,
            column: 34
          },
          end: {
            line: 70,
            column: 3
          }
        },
        line: 68
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 75,
            column: 6
          },
          end: {
            line: 75,
            column: 7
          }
        },
        loc: {
          start: {
            line: 75,
            column: 34
          },
          end: {
            line: 75,
            column: 87
          }
        },
        line: 75
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 76,
            column: 6
          },
          end: {
            line: 76,
            column: 7
          }
        },
        loc: {
          start: {
            line: 76,
            column: 34
          },
          end: {
            line: 76,
            column: 87
          }
        },
        line: 76
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 77,
            column: 6
          },
          end: {
            line: 77,
            column: 7
          }
        },
        loc: {
          start: {
            line: 77,
            column: 34
          },
          end: {
            line: 77,
            column: 87
          }
        },
        line: 77
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 24,
            column: 11
          },
          end: {
            line: 24,
            column: 52
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 24,
            column: 22
          },
          end: {
            line: 24,
            column: 35
          }
        }, {
          start: {
            line: 24,
            column: 38
          },
          end: {
            line: 24,
            column: 52
          }
        }],
        line: 24
      },
      "1": {
        loc: {
          start: {
            line: 25,
            column: 12
          },
          end: {
            line: 25,
            column: 48
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 25,
            column: 23
          },
          end: {
            line: 25,
            column: 36
          }
        }, {
          start: {
            line: 25,
            column: 39
          },
          end: {
            line: 25,
            column: 48
          }
        }],
        line: 25
      },
      "2": {
        loc: {
          start: {
            line: 28,
            column: 13
          },
          end: {
            line: 28,
            column: 49
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 28,
            column: 24
          },
          end: {
            line: 28,
            column: 37
          }
        }, {
          start: {
            line: 28,
            column: 40
          },
          end: {
            line: 28,
            column: 49
          }
        }],
        line: 28
      },
      "3": {
        loc: {
          start: {
            line: 32,
            column: 13
          },
          end: {
            line: 32,
            column: 49
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 32,
            column: 24
          },
          end: {
            line: 32,
            column: 37
          }
        }, {
          start: {
            line: 32,
            column: 40
          },
          end: {
            line: 32,
            column: 49
          }
        }],
        line: 32
      },
      "4": {
        loc: {
          start: {
            line: 75,
            column: 34
          },
          end: {
            line: 75,
            column: 87
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 75,
            column: 63
          },
          end: {
            line: 75,
            column: 82
          }
        }, {
          start: {
            line: 75,
            column: 85
          },
          end: {
            line: 75,
            column: 87
          }
        }],
        line: 75
      },
      "5": {
        loc: {
          start: {
            line: 76,
            column: 34
          },
          end: {
            line: 76,
            column: 87
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 76,
            column: 63
          },
          end: {
            line: 76,
            column: 82
          }
        }, {
          start: {
            line: 76,
            column: 85
          },
          end: {
            line: 76,
            column: 87
          }
        }],
        line: 76
      },
      "6": {
        loc: {
          start: {
            line: 77,
            column: 34
          },
          end: {
            line: 77,
            column: 87
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 77,
            column: 63
          },
          end: {
            line: 77,
            column: 82
          }
        }, {
          start: {
            line: 77,
            column: 85
          },
          end: {
            line: 77,
            column: 87
          }
        }],
        line: 77
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "f7f466cbc62c5ba2b8038954d014b01df449d43b"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1bjx6atoez = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1bjx6atoez();
function link_typeof(o) { "@babel/helpers - typeof"; return link_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, link_typeof(o); }










function link_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = link_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function link_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function link_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function link_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? link_ownKeys(Object(t), !0).forEach(function (r) { link_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : link_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function link_defineProperty(obj, key, value) { key = link_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function link_toPropertyKey(t) { var i = link_toPrimitive(t, "string"); return "symbol" == link_typeof(i) ? i : String(i); }
function link_toPrimitive(t, r) { if ("object" != link_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != link_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


cov_1bjx6atoez().s[0]++;
var nav = function nav(_ref) {
  var disabled = _ref.disabled;
  cov_1bjx6atoez().f[0]++;
  cov_1bjx6atoez().s[1]++;
  return {
    icon: {
      mx: 1
    },
    link: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      textDecoration: 'none',
      color: disabled ? (cov_1bjx6atoez().b[0][0]++, 'warmgrey700') : (cov_1bjx6atoez().b[0][1]++, 'brandBlue600'),
      cursor: disabled ? (cov_1bjx6atoez().b[1][0]++, 'not-allowed') : (cov_1bjx6atoez().b[1][1]++, 'pointer'),
      _hover: {
        backgroundColor: 'none',
        color: disabled ? (cov_1bjx6atoez().b[2][0]++, 'warmgrey700') : (cov_1bjx6atoez().b[2][1]++, 'blue500')
      },
      _active: {
        backgroundColor: 'none',
        color: disabled ? (cov_1bjx6atoez().b[3][0]++, 'warmgrey700') : (cov_1bjx6atoez().b[3][1]++, 'blue200')
      }
    },
    content: {
      alignItems: 'center'
    }
  };
};
var link_variants = (cov_1bjx6atoez().s[2]++, {
  /** @deprecated */
  primary: {
    link: link_objectSpread(link_objectSpread({}, sharedCta_link), resetLinkStyles)
  },
  'inline-primary': {
    link: link_objectSpread({}, sharedCta_link)
  },
  'inline-secondary': {
    link: link_objectSpread({}, secondaryLink)
  },
  nav: nav,
  /**
   * NOTE: This is a known antipattern, however for conversion reasons this is occasionally a
   * requirement. Make sure to verify with design that this behavior is absolutely necessary
   * and appropriate a11y concerns were considered.
   */
  'primary-button': function primaryButton(props) {
    cov_1bjx6atoez().f[1]++;
    cov_1bjx6atoez().s[3]++;
    return {
      link: link_objectSpread(link_objectSpread(link_objectSpread({}, resetLinkStyles), buttonBaseStyles), sharedCta_primaryButton(props))
    };
  },
  /**
   * NOTE: This is a known antipattern, however for conversion reasons this is occasionally a
   * requirement. Make sure to verify with design that this behavior is absolutely necessary
   * and appropriate a11y concerns were considered.
   */
  'secondary-button': function secondaryButton(props) {
    cov_1bjx6atoez().f[2]++;
    cov_1bjx6atoez().s[4]++;
    return {
      link: link_objectSpread(link_objectSpread(link_objectSpread({}, resetLinkStyles), buttonBaseStyles), sharedCta_secondaryButton(props))
    };
  }
});

/** NOTE: Sizes only get applied for button variants */
var link_sizes = (cov_1bjx6atoez().s[5]++, {
  sm: function sm(_ref2) {
    var variant = _ref2.variant,
      props = link_objectWithoutProperties(_ref2, link_excluded);
    cov_1bjx6atoez().f[3]++;
    cov_1bjx6atoez().s[6]++;
    return variant.includes('button') ? (cov_1bjx6atoez().b[4][0]++, {
      link: sharedCta_sm(props)
    }) : (cov_1bjx6atoez().b[4][1]++, {});
  },
  md: function md(_ref3) {
    var variant = _ref3.variant,
      props = link_objectWithoutProperties(_ref3, link_excluded2);
    cov_1bjx6atoez().f[4]++;
    cov_1bjx6atoez().s[7]++;
    return variant.includes('button') ? (cov_1bjx6atoez().b[5][0]++, {
      link: sharedCta_md(props)
    }) : (cov_1bjx6atoez().b[5][1]++, {});
  },
  lg: function lg(_ref4) {
    var variant = _ref4.variant,
      props = link_objectWithoutProperties(_ref4, link_excluded3);
    cov_1bjx6atoez().f[5]++;
    cov_1bjx6atoez().s[8]++;
    return variant.includes('button') ? (cov_1bjx6atoez().b[6][0]++, {
      link: sharedCta_lg(props)
    }) : (cov_1bjx6atoez().b[6][1]++, {});
  }
});
var link_link = (cov_1bjx6atoez().s[9]++, {
  parts: anatomy_types/* linkAnatomy.keys */.Ut.keys,
  baseStyle: {
    link: link_objectSpread({}, linkBaseStyles)
  },
  variants: link_variants,
  sizes: link_sizes,
  defaultProps: {
    variant: 'primary'
  }
});
/* harmony default export */ var components_link = (link_link);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(92222);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/SpritesheetIcons/Checkmark.mjs
var Checkmark = __webpack_require__(77972);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/novo/components/list.mjs
function cov_vz9mzhgue() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/novo/components/list.ts";
  var hash = "103f5a66d073bee6a74eb98eb471ba9d18683160";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/novo/components/list.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 62
        },
        end: {
          line: 25,
          column: 2
        }
      },
      "1": {
        start: {
          line: 10,
          column: 7
        },
        end: {
          line: 25,
          column: 1
        }
      },
      "2": {
        start: {
          line: 45,
          column: 50
        },
        end: {
          line: 47,
          column: 1
        }
      },
      "3": {
        start: {
          line: 48,
          column: 49
        },
        end: {
          line: 50,
          column: 1
        }
      },
      "4": {
        start: {
          line: 51,
          column: 46
        },
        end: {
          line: 53,
          column: 1
        }
      },
      "5": {
        start: {
          line: 54,
          column: 48
        },
        end: {
          line: 56,
          column: 1
        }
      },
      "6": {
        start: {
          line: 57,
          column: 51
        },
        end: {
          line: 76,
          column: 1
        }
      },
      "7": {
        start: {
          line: 62,
          column: 15
        },
        end: {
          line: 62,
          column: 37
        }
      },
      "8": {
        start: {
          line: 63,
          column: 2
        },
        end: {
          line: 75,
          column: 4
        }
      },
      "9": {
        start: {
          line: 77,
          column: 46
        },
        end: {
          line: 79,
          column: 1
        }
      },
      "10": {
        start: {
          line: 80,
          column: 51
        },
        end: {
          line: 82,
          column: 2
        }
      },
      "11": {
        start: {
          line: 80,
          column: 58
        },
        end: {
          line: 82,
          column: 1
        }
      },
      "12": {
        start: {
          line: 86,
          column: 4
        },
        end: {
          line: 86,
          column: 67
        }
      },
      "13": {
        start: {
          line: 92,
          column: 4
        },
        end: {
          line: 95,
          column: 1
        }
      },
      "14": {
        start: {
          line: 102,
          column: 30
        },
        end: {
          line: 108,
          column: 1
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 62
          },
          end: {
            line: 6,
            column: 63
          }
        },
        loc: {
          start: {
            line: 10,
            column: 7
          },
          end: {
            line: 25,
            column: 1
          }
        },
        line: 10
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 57,
            column: 51
          },
          end: {
            line: 57,
            column: 52
          }
        },
        loc: {
          start: {
            line: 61,
            column: 6
          },
          end: {
            line: 76,
            column: 1
          }
        },
        line: 61
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 80,
            column: 51
          },
          end: {
            line: 80,
            column: 52
          }
        },
        loc: {
          start: {
            line: 80,
            column: 58
          },
          end: {
            line: 82,
            column: 1
          }
        },
        line: 80
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 17,
            column: 21
          },
          end: {
            line: 17,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 17,
            column: 21
          },
          end: {
            line: 17,
            column: 28
          }
        }, {
          start: {
            line: 17,
            column: 32
          },
          end: {
            line: 17,
            column: 47
          }
        }, {
          start: {
            line: 17,
            column: 51
          },
          end: {
            line: 17,
            column: 60
          }
        }],
        line: 17
      },
      "1": {
        loc: {
          start: {
            line: 62,
            column: 15
          },
          end: {
            line: 62,
            column: 37
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 62,
            column: 15
          },
          end: {
            line: 62,
            column: 29
          }
        }, {
          start: {
            line: 62,
            column: 33
          },
          end: {
            line: 62,
            column: 37
          }
        }],
        line: 62
      },
      "2": {
        loc: {
          start: {
            line: 67,
            column: 11
          },
          end: {
            line: 67,
            column: 38
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 67,
            column: 11
          },
          end: {
            line: 67,
            column: 21
          }
        }, {
          start: {
            line: 67,
            column: 25
          },
          end: {
            line: 67,
            column: 38
          }
        }],
        line: 67
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "103f5a66d073bee6a74eb98eb471ba9d18683160"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_vz9mzhgue = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_vz9mzhgue();







cov_vz9mzhgue().s[0]++;
var baseListStyle = function baseListStyle(_ref) {
  var _ref2, _ref3;
  var bgColor = _ref.bgColor,
    backgroundColor = _ref.backgroundColor,
    color = _ref.color;
  cov_vz9mzhgue().f[0]++;
  cov_vz9mzhgue().s[1]++;
  return {
    container: {
      width: '100%',
      borderRadius: 'none'
    },
    list: {
      m: 0,
      pl: 5,
      listStyleType: 'none',
      listStylePosition: 'outside',
      backgroundColor: (_ref2 = (_ref3 = (cov_vz9mzhgue().b[0][0]++, bgColor)) !== null && _ref3 !== void 0 ? _ref3 : (cov_vz9mzhgue().b[0][1]++, backgroundColor)) !== null && _ref2 !== void 0 ? _ref2 : (cov_vz9mzhgue().b[0][2]++, 'inherit'),
      color: color
    },
    title: {
      fontSize: 's2',
      fontWeight: 'semibold',
      color: 'warmgrey800'
    }
  };
};

// Provide a custom SVG string, color, and size for this Icon.
// If you want to use an existing icon, use it as follows:
// import VideoFilled from '../Icon/SpritesheetIcons/VideoFilled';
// <List
//   variant="checklist"
//   customIcon={{ svg: VideoFilled.svg, color: colors.success500, size: '20' }}
// >

var numbered = (cov_vz9mzhgue().s[2]++, {
  list: {
    listStyleType: 'numeric'
  }
});
var decimal = (cov_vz9mzhgue().s[3]++, {
  list: {
    listStyleType: 'decimal'
  }
});
var list_text = (cov_vz9mzhgue().s[4]++, {
  list: {
    pl: 0
  }
});
var bullet = (cov_vz9mzhgue().s[5]++, {
  list: {
    listStyleType: 'disc'
  }
});
cov_vz9mzhgue().s[6]++;
var checklist = function checklist(_ref4) {
  var _ref5, _ref6;
  var dataURISVG = _ref4.dataURISVG,
    dataURISVGColor = _ref4.dataURISVGColor,
    dataURISVGSize = _ref4.dataURISVGSize;
  cov_vz9mzhgue().f[1]++;
  var size = (cov_vz9mzhgue().s[7]++, (_ref5 = (cov_vz9mzhgue().b[1][0]++, dataURISVGSize)) !== null && _ref5 !== void 0 ? _ref5 : (cov_vz9mzhgue().b[1][1]++, '12'));
  cov_vz9mzhgue().s[8]++;
  return {
    list: {
      listStyleImage: "url(\"".concat((0,helpers/* svgToStyledDataURI */.YX)("<svg xmlns=\"http://www.w3.org/2000/svg\" width='".concat(size, "' height='").concat(size, "' viewBox=\"0 0 24 24\">") + ((_ref6 = (cov_vz9mzhgue().b[2][0]++, dataURISVG)) !== null && _ref6 !== void 0 ? _ref6 : (cov_vz9mzhgue().b[2][1]++, Checkmark/* default.svg */.Z.svg)) + '</svg>', {
        color: dataURISVGColor
      }), "\")"),
      pl: 7
    }
  };
};
var list_card = (cov_vz9mzhgue().s[9]++, {
  list: {
    pl: 0
  }
});
cov_vz9mzhgue().s[10]++;
var accordion = function accordion() {
  cov_vz9mzhgue().f[2]++;
  cov_vz9mzhgue().s[11]++;
  return {
    list: {
      pl: 0
    }
  };
};
var list_variants = (cov_vz9mzhgue().s[12]++, {
  text: list_text,
  bullet: bullet,
  checklist: checklist,
  card: list_card,
  accordion: accordion,
  numbered: numbered,
  decimal: decimal
});
var list_sizes = (cov_vz9mzhgue().s[13]++, {
  compact: {},
  standard: {}
});
var list = (cov_vz9mzhgue().s[14]++, {
  parts: anatomy_types/* listAnatomy.keys */.vE.keys,
  baseStyle: baseListStyle,
  variants: list_variants,
  sizes: list_sizes,
  defaultProps: {
    variant: 'text',
    size: 'standard'
  }
});
/* harmony default export */ var components_list = (list);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/novo/components/listItem.mjs
function cov_1ti8vmmruo() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/novo/components/listItem.ts";
  var hash = "a60bb769f061a910f3cf6cf011e477c7db9998e7";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/novo/components/listItem.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 45
        },
        end: {
          line: 10,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "a60bb769f061a910f3cf6cf011e477c7db9998e7"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1ti8vmmruo = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1ti8vmmruo();
var listItem = (cov_1ti8vmmruo().s[0]++, {
  baseStyle: {
    breakInside: 'avoid',
    pageBreakInside: 'avoid',
    m: 0,
    pl: 0
  }
});
/* harmony default export */ var components_listItem = (listItem);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/novo/components/radio.mjs
function cov_ez8wg34hq() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/novo/components/radio.ts";
  var hash = "4b17b55f364eb044e2b2b70db2c5e2292a8cf885";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/novo/components/radio.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 53
        },
        end: {
          line: 13,
          column: 1
        }
      },
      "1": {
        start: {
          line: 14,
          column: 54
        },
        end: {
          line: 18,
          column: 1
        }
      },
      "2": {
        start: {
          line: 23,
          column: 44
        },
        end: {
          line: 58,
          column: 1
        }
      },
      "3": {
        start: {
          line: 60,
          column: 42
        },
        end: {
          line: 62,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "4b17b55f364eb044e2b2b70db2c5e2292a8cf885"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_ez8wg34hq = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_ez8wg34hq();


















function radio_typeof(o) { "@babel/helpers - typeof"; return radio_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, radio_typeof(o); }
function radio_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function radio_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? radio_ownKeys(Object(t), !0).forEach(function (r) { radio_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : radio_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function radio_defineProperty(obj, key, value) { key = radio_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function radio_toPropertyKey(t) { var i = radio_toPrimitive(t, "string"); return "symbol" == radio_typeof(i) ? i : String(i); }
function radio_toPrimitive(t, r) { if ("object" != radio_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != radio_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var defaultRadioButton = (cov_ez8wg34hq().s[0]++, {
  width: '12px',
  height: '12px',
  margin: '2px',
  content: "\"\"",
  position: 'absolute',
  left: '0',
  top: '0',
  cursor: 'pointer',
  borderRadius: 'rounded'
});
var disabledRadioButton = (cov_ez8wg34hq().s[1]++, {
  content: "\"\"",
  opacity: '40%',
  cursor: 'default'
});

// Custom styling for the radio button & hides input
// Used pseudo-elements & adjacent sibiling selectors to create a custom accessible radio button
// https://medium.com/claritydesignsystem/pure-css-accessible-checkboxes-and-radios-buttons-54063e759bb3
var radio_baseStyle = (cov_ez8wg34hq().s[2]++, {
  // opacity: 0 visually hides this input in an accessible way so we can create our own custom radio
  // do not use display: none this completely removes the element from the dom flow and we still want to use input's features like _focus & _checked to style our custom radio
  // https://dev.to/lkopacz/create-custom-keyboard-accessible-radio-buttons-22eh <- article that was used by chakra - https://chakra-ui.com/docs/components/form/radio
  opacity: 0,
  position: 'absolute',
  // & + label styles is applied to the label component immediately after the input to style a custom radio button
  '& + label': {
    position: 'relative',
    paddingLeft: '23px',
    _before: radio_objectSpread({
      boxShadow: " 0 0 0 1px var(--colors-warmgrey300)",
      transition: 'all 0.15s cubic-bezier(0.1, 0.7, 0.1, 1)',
      bg: 'white0',
      border: "2px solid var(--colors-warmgrey300)"
    }, defaultRadioButton)
  },
  '&:checked + label': {
    _after: radio_objectSpread({
      border: "2px solid var(--colors-brandBlue600)",
      boxShadow: "inset 0px 0px 0px 2px var(--colors-brandBlue600)"
    }, defaultRadioButton)
  },
  _disabled: {
    '& + label': {
      _before: radio_objectSpread({}, disabledRadioButton),
      _after: radio_objectSpread({}, disabledRadioButton)
    }
  }
});
var radio_radio = (cov_ez8wg34hq().s[3]++, {
  baseStyle: radio_baseStyle
});
/* harmony default export */ var components_radio = (radio_radio);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/novo/foundations/fontWeights.mjs
function cov_280n678u0s() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/novo/foundations/fontWeights.ts";
  var hash = "7c414cd703e76e7ee634b09132eef7dc22dd7dcb";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/novo/foundations/fontWeights.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 60
        },
        end: {
          line: 13,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "7c414cd703e76e7ee634b09132eef7dc22dd7dcb"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_280n678u0s = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_280n678u0s();
var fontWeights = (cov_280n678u0s().s[0]++, {
  regular: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
  /**  @deprecated  */
  normal: 400,
  /**  @deprecated  */
  bolder: 800
});
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/novo/foundations/space.mjs
function cov_2lv18lawzh() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/novo/foundations/space.ts";
  var hash = "e98b0a0835eb933807af270ca0fd2d34164ef1c6";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/novo/foundations/space.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 21
        },
        end: {
          line: 17,
          column: 1
        }
      },
      "1": {
        start: {
          line: 19,
          column: 30
        },
        end: {
          line: 19,
          column: 56
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "e98b0a0835eb933807af270ca0fd2d34164ef1c6"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2lv18lawzh = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2lv18lawzh();

var space = (cov_2lv18lawzh().s[0]++, [0,
// 0
2,
// 1
4,
// 2
8,
// 3
12,
// 4
16,
// 5
20,
// 6
24,
// 7
32,
// 8
40,
// 9
48,
// 10
64,
// 11
128 // 12
]);
var spaceWithUnits = (cov_2lv18lawzh().s[1]++, (0,helpers/* numbersArrWithUnits */.U3)(space));
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/theme/novo/foundations/breakpoints.mjs
var breakpoints = __webpack_require__(40156);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/novo/components/tab.mjs
function tab_typeof(o) { "@babel/helpers - typeof"; return tab_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, tab_typeof(o); }
function cov_2qu1qkyosl() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/novo/components/tab.ts";
  var hash = "4bc567329df66cb3efef355da9e8b9ca308e38dc";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/novo/components/tab.ts",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 24
        },
        end: {
          line: 26,
          column: 1
        }
      },
      "1": {
        start: {
          line: 28,
          column: 25
        },
        end: {
          line: 55,
          column: 1
        }
      },
      "2": {
        start: {
          line: 58,
          column: 16
        },
        end: {
          line: 65,
          column: 1
        }
      },
      "3": {
        start: {
          line: 68,
          column: 16
        },
        end: {
          line: 68,
          column: 31
        }
      },
      "4": {
        start: {
          line: 70,
          column: 15
        },
        end: {
          line: 73,
          column: 1
        }
      },
      "5": {
        start: {
          line: 75,
          column: 15
        },
        end: {
          line: 92,
          column: 1
        }
      },
      "6": {
        start: {
          line: 94,
          column: 68
        },
        end: {
          line: 101,
          column: 1
        }
      },
      "7": {
        start: {
          line: 107,
          column: 28
        },
        end: {
          line: 124,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "4bc567329df66cb3efef355da9e8b9ca308e38dc"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2qu1qkyosl = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2qu1qkyosl();
function tab_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function tab_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? tab_ownKeys(Object(t), !0).forEach(function (r) { tab_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : tab_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function tab_defineProperty(obj, key, value) { key = tab_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function tab_toPropertyKey(t) { var i = tab_toPrimitive(t, "string"); return "symbol" == tab_typeof(i) ? i : String(i); }
function tab_toPrimitive(t, r) { if ("object" != tab_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != tab_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }






















/** @deprecated */
var oldCommonStyles = (cov_2qu1qkyosl().s[0]++, {
  color: 'warmgrey950',
  fontSize: 's1',
  borderRadius: 'squared',
  padding: 5,
  '&:hover': {
    color: 'warmgrey950'
  },
  '&.disabled': {
    opacity: 0.25,
    cursor: 'auto',
    userSelect: 'none',
    '&:hover': {
      color: 'warmgrey800'
    }
  }
});
var eeroCommonStyles = (cov_2qu1qkyosl().s[1]++, {
  fontWeight: fontWeights.semibold,
  color: 'warmgrey700',
  fontSize: 's0',
  borderRadius: 'semiRounded',
  padding: "".concat(spaceWithUnits[4], " ").concat(spaceWithUnits[5], " ").concat(spaceWithUnits[4], " ").concat(spaceWithUnits[4]),
  '&:hover': {
    color: 'warmgrey950'
  },
  '&.active': {
    color: 'warmgrey950'
  },
  '&.syncIconStyle svg': {
    color: 'warmgrey700'.concat(" !important"),
    transition: 'all 0.3s ease'
  },
  '&.syncIconStyle:hover svg': {
    color: 'warmgrey950'.concat(" !important")
  },
  '&.active.syncIconStyle svg': {
    color: 'warmgrey950'.concat(" !important")
  }
});

/** @deprecated */
var navItem = (cov_2qu1qkyosl().s[2]++, tab_objectSpread(tab_objectSpread({}, oldCommonStyles), {}, {
  '&.active': {
    color: 'warmgrey950',
    fontWeight: fontWeights.semibold,
    backgroundColor: 'blue50'
  }
}));

/** @deprecated */
var navLink = (cov_2qu1qkyosl().s[3]++, oldCommonStyles);
var subNav = (cov_2qu1qkyosl().s[4]++, tab_objectSpread(tab_objectSpread({}, eeroCommonStyles), {}, {
  padding: "".concat(spaceWithUnits[2], " ").concat(spaceWithUnits[4], " ").concat(spaceWithUnits[2], " ").concat(spaceWithUnits[4])
}));
var appNav = (cov_2qu1qkyosl().s[5]++, tab_objectSpread(tab_objectSpread({}, eeroCommonStyles), {}, tab_defineProperty(tab_defineProperty({
  color: 'warmgrey950',
  '&.active': {
    color: 'brandBlue600',
    backgroundColor: 'warmgrey100'
  }
}, breakpoints/* media.smallerThan.XL */.BC.smallerThan.XL, {
  fontSize: 's00'
}), breakpoints/* media.smallerThan.MD */.BC.smallerThan.MD, {
  // Intentionally removing the background for mobile nav
  '&.active': {
    backgroundColor: 'transparent'
  }
})));
var tab_variants = (cov_2qu1qkyosl().s[6]++, {
  /** @deprecated */
  'nav-item': navItem,
  /** @deprecated */
  'nav-link': navLink,
  'app-nav': appNav,
  'sub-nav': subNav
});
var tab = (cov_2qu1qkyosl().s[7]++, {
  baseStyle: {
    border: 'none',
    cursor: 'pointer',
    fontSize: 's1',
    width: '100%',
    transition: 'all 0.3s ease',
    position: 'relative',
    padding: 5,
    borderRadius: 'squared',
    display: 'block',
    color: 'warmgrey800'
  },
  variants: tab_variants,
  defaultProps: {
    variant: 'nav-item'
  }
});
/* harmony default export */ var components_tab = (tab);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/novo/components/table.mjs
function cov_1a02usfhtj() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/novo/components/table.ts";
  var hash = "48f7d8136198b0f38f17b131c118bd174de3531a";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/novo/components/table.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 42
        },
        end: {
          line: 3,
          column: 59
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "48f7d8136198b0f38f17b131c118bd174de3531a"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1a02usfhtj = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1a02usfhtj();
var table = (cov_1a02usfhtj().s[0]++, {
  baseStyle: {}
});
/* harmony default export */ var components_table = (table);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/novo/components/tableBody.mjs
function cov_2iyuyy13ng() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/novo/components/tableBody.ts";
  var hash = "3ef5e0d9bc39cee281867aab3492e2afe0a17c9f";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/novo/components/tableBody.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 46
        },
        end: {
          line: 3,
          column: 63
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "3ef5e0d9bc39cee281867aab3492e2afe0a17c9f"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2iyuyy13ng = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2iyuyy13ng();
var tableBody = (cov_2iyuyy13ng().s[0]++, {
  baseStyle: {}
});
/* harmony default export */ var components_tableBody = (tableBody);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/novo/components/tableCell.mjs
function cov_bpewandtg() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/novo/components/tableCell.ts";
  var hash = "ea7f96324ed78e9c754a0cd70dca90d8b7ec89ee";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/novo/components/tableCell.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 46
        },
        end: {
          line: 8,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "ea7f96324ed78e9c754a0cd70dca90d8b7ec89ee"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_bpewandtg = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_bpewandtg();
var tableCell = (cov_bpewandtg().s[0]++, {
  baseStyle: {
    textAlign: 'center',
    verticalAlign: 'middle'
  }
});
/* harmony default export */ var components_tableCell = (tableCell);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/novo/components/tableFooter.mjs
function cov_2bmec1qohc() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/novo/components/tableFooter.ts";
  var hash = "5127f6999cc2b0032216f386ef1532aa5e292ae9";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/novo/components/tableFooter.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 48
        },
        end: {
          line: 3,
          column: 65
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "5127f6999cc2b0032216f386ef1532aa5e292ae9"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2bmec1qohc = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2bmec1qohc();
var tableFooter = (cov_2bmec1qohc().s[0]++, {
  baseStyle: {}
});
/* harmony default export */ var components_tableFooter = (tableFooter);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/novo/components/tableHeader.mjs
function cov_14nc52xs0y() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/novo/components/tableHeader.ts";
  var hash = "5d3a38cab7d71cff282dc1abf1c538a138040f24";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/novo/components/tableHeader.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 48
        },
        end: {
          line: 8,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "5d3a38cab7d71cff282dc1abf1c538a138040f24"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_14nc52xs0y = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_14nc52xs0y();
var tableHeader = (cov_14nc52xs0y().s[0]++, {
  baseStyle: {
    textAlign: 'center',
    verticalAlign: 'middle'
  }
});
/* harmony default export */ var components_tableHeader = (tableHeader);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/novo/components/tableHeading.mjs
function cov_25exlc7q2() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/novo/components/tableHeading.ts";
  var hash = "8899080095d17708b10b1167ae15861fb72ca710";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/novo/components/tableHeading.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 48
        },
        end: {
          line: 8,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "8899080095d17708b10b1167ae15861fb72ca710"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_25exlc7q2 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_25exlc7q2();
var tableHeading_tableHeader = (cov_25exlc7q2().s[0]++, {
  baseStyle: {
    textAlign: 'center',
    verticalAlign: 'middle'
  }
});
/* harmony default export */ var tableHeading = (tableHeading_tableHeader);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/novo/components/tableRow.mjs
function cov_2ans7ed5yw() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/novo/components/tableRow.ts";
  var hash = "850fff45e1a9ca1148ee69e303253f78cdb01ee6";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/novo/components/tableRow.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 45
        },
        end: {
          line: 3,
          column: 62
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "850fff45e1a9ca1148ee69e303253f78cdb01ee6"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2ans7ed5yw = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2ans7ed5yw();
var tableRow = (cov_2ans7ed5yw().s[0]++, {
  baseStyle: {}
});
/* harmony default export */ var components_tableRow = (tableRow);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/novo/components/index.mjs
function cov_1vjbzp0bs1() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/novo/components/index.ts";
  var hash = "d72aba007ba12d244f32afd0298ae841716ae826";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/novo/components/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 32,
          column: 4
        },
        end: {
          line: 59,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "d72aba007ba12d244f32afd0298ae841716ae826"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1vjbzp0bs1 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1vjbzp0bs1();


























var components = (cov_1vjbzp0bs1().s[0]++, {
  AccordionListItem: components_accordionListItem,
  Avatar: components_avatar,
  Button: components_button,
  Card: components_card,
  CardListItem: cardListItem,
  Checkbox: components_checkbox,
  Chip: chip,
  Form: components_form,
  Heading: components_heading,
  Image: components_image,
  Input: components_input,
  Label: components_label,
  Link: components_link,
  List: components_list,
  ListItem: components_listItem,
  Radio: components_radio,
  FormElements: components_formElements,
  Tab: components_tab,
  Table: components_table,
  TableBody: components_tableBody,
  TableCell: components_tableCell,
  TableFooter: components_tableFooter,
  TableHeading: tableHeading,
  TableHeader: components_tableHeader,
  TableRow: components_tableRow,
  Text: components_text/* default */.Z
});
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/novo/foundations/fontSizes.mjs
function cov_2jf7umqqh2() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/novo/foundations/fontSizes.ts";
  var hash = "d2961ce65206ff78f84fcc6dd6a08d4a7ec8a663";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/novo/foundations/fontSizes.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 70
        },
        end: {
          line: 25,
          column: 1
        }
      },
      "1": {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 29,
          column: 39
        }
      },
      "2": {
        start: {
          line: 31,
          column: 39
        },
        end: {
          line: 31,
          column: 57
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "d2961ce65206ff78f84fcc6dd6a08d4a7ec8a663"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2jf7umqqh2 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2jf7umqqh2();
/* eslint-disable import/no-deprecated */


var fontSizesNamed = (cov_2jf7umqqh2().s[0]++, {
  '11px': 11,
  '12px': 12,
  '14px': 14,
  '16px': 16,
  '18px': 18,
  '20px': 20,
  '22px': 22,
  '24px': 24,
  '28px': 28,
  '32px': 32,
  '36px': 36,
  '40px': 40,
  '44px': 44,
  '48px': 48,
  '56px': 56,
  '64px': 64,
  '80px': 80,
  '88px': 88,
  '96px': 96
});
var fontSizesWithUnits = (cov_2jf7umqqh2().s[1]++, (0,helpers/* numbersObjWithUnits */.hX)(fontSizesNamed));
var fontSizesNamedWithUnits = (cov_2jf7umqqh2().s[2]++, fontSizesWithUnits);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/novo/foundations/lineHeights.mjs
function cov_1a0csgz2cj() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/novo/foundations/lineHeights.ts";
  var hash = "c2c722cf3e00db4a6cb92270e02077703cfda376";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/novo/foundations/lineHeights.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 60
        },
        end: {
          line: 12,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "c2c722cf3e00db4a6cb92270e02077703cfda376"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1a0csgz2cj = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1a0csgz2cj();
var lineHeights = (cov_1a0csgz2cj().s[0]++, {
  '160': '160%',
  '150': '150%',
  '140': '140%',
  '130': '130%',
  '120': '120%',
  '112': '112%',
  '110': '110%',
  '100': '100%'
});
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/novo/foundations/letterSpacings.mjs
function cov_wex4qlfvv() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/novo/foundations/letterSpacings.ts";
  var hash = "a34cb8bc6f0e50589b6799ee83e9ebcaf06cd60b";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/novo/foundations/letterSpacings.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 66
        },
        end: {
          line: 9,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "a34cb8bc6f0e50589b6799ee83e9ebcaf06cd60b"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_wex4qlfvv = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_wex4qlfvv();
var letterSpacings = (cov_wex4qlfvv().s[0]++, {
  '-3.4': '-.034em',
  '-3': '-.03em',
  '-2.8': '-.028em',
  '-2.4': '-.024em',
  '-1.4': '-.014em'
});
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/novo/foundations/radii.mjs
function cov_rfneyhtsx() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/novo/foundations/radii.ts";
  var hash = "5adc42c978ed9862d4da901efd14d73ce41b1b06";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/novo/foundations/radii.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 42
        },
        end: {
          line: 12,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "5adc42c978ed9862d4da901efd14d73ce41b1b06"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_rfneyhtsx = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_rfneyhtsx();
var radii = (cov_rfneyhtsx().s[0]++, {
  none: '0',
  squared: '4px',
  roundedSquare: '8px',
  semiRounded: '16px',
  roundedSmooth: '24px',
  full: '9999px',
  /** @deprecated use "full" instead */
  rounded: '9999px'
});
/* harmony default export */ var foundations_radii = (radii);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/novo/foundations/shadows.mjs
function cov_20ap3dq9f7() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/novo/foundations/shadows.ts";
  var hash = "3d716a46066917026b12b8a716e4e49a19705e15";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/novo/foundations/shadows.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 46
        },
        end: {
          line: 13,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "3d716a46066917026b12b8a716e4e49a19705e15"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_20ap3dq9f7 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_20ap3dq9f7();
var shadows = (cov_20ap3dq9f7().s[0]++, {
  none: 'none',
  z1: '0px 5px 10px rgba(29, 71, 123, 0.04), 0px 1px 5px rgba(29, 71, 123, 0.12)',
  z2: '0px 10px 22px rgba(29, 71, 123, 0.08), 0px 2px 12px rgba(29, 71, 123, 0.08)',
  /** @deprecated */
  large: '0 0 24px rgba(0, 0, 0, .125)',
  /** @deprecated */
  medium: '0 3px 15px 2px rgba(0, 0, 0, 0.1)',
  /** @deprecated */
  small: '0 1px 3px 1px rgba(0, 0, 0, 0.1)'
});
/* harmony default export */ var foundations_shadows = (shadows);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/novo/index.mjs
function cov_2c05eb5u0f() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/novo/index.ts";
  var hash = "f762231252d6fabea31089159726d4ed3f934f28";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/novo/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 19,
          column: 28
        },
        end: {
          line: 32,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "f762231252d6fabea31089159726d4ed3f934f28"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2c05eb5u0f = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2c05eb5u0f();




var novo = (cov_2c05eb5u0f().s[0]++, {
  name: 'novo',
  breakpoints: (0,helpers/* numbersArrWithUnits */.U3)(breakpoints/* breakpoints */.AV),
  colors: colors/* default */.ZP,
  fonts: fonts,
  fontSizes: fontSizesNamedWithUnits,
  fontWeights: fontWeights,
  lineHeights: lineHeights,
  letterSpacings: letterSpacings,
  radii: foundations_radii,
  shadows: foundations_shadows,
  space: (0,helpers/* numbersArrWithUnits */.U3)(space),
  components: components
});

/***/ }),

/***/ 41543:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ screenReaderOnly; }
/* harmony export */ });
/* unused harmony export ScreenReaderOnly */
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19601);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
function cov_2j6isamq1b() {
  var path = "/__w/code/code/js/packages/bricks/src/utils/ScreenReaderOnly.tsx";
  var hash = "9528e16214dc108441b715908fe1d6f432dc1a1b";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/utils/ScreenReaderOnly.tsx",
    statementMap: {
      "0": {
        start: {
          line: 8,
          column: 52
        },
        end: {
          line: 17,
          column: 1
        }
      },
      "1": {
        start: {
          line: 24,
          column: 52
        },
        end: {
          line: 26,
          column: 1
        }
      },
      "2": {
        start: {
          line: 25,
          column: 2
        },
        end: {
          line: 25,
          column: 45
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 24,
            column: 52
          },
          end: {
            line: 24,
            column: 53
          }
        },
        loc: {
          start: {
            line: 25,
            column: 2
          },
          end: {
            line: 25,
            column: 45
          }
        },
        line: 25
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {
      "0": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "9528e16214dc108441b715908fe1d6f432dc1a1b"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2j6isamq1b = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2j6isamq1b();

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



// NOTE: from A360 Knowledge Base
var screenReaderOnly = (cov_2j6isamq1b().s[0]++, {
  position: 'absolute',
  width: '1px',
  height: '1px',
  padding: 0,
  margin: '-1px',
  overflow: 'hidden',
  clip: 'rect(0,0,0,0)',
  border: 0
});

/**
 * A utility component for rendering content that will only be seen by screen
 * readers. For example, this allows you to provide a table of values alongside
 * a chart with only the chart visible and the table read by a screen reader.
 */
cov_2j6isamq1b().s[1]++;
var ScreenReaderOnly = function ScreenReaderOnly(props) {
  cov_2j6isamq1b().f[0]++;
  cov_2j6isamq1b().s[2]++;
  return /*#__PURE__*/React.createElement(Box, _extends({
    __css: screenReaderOnly
  }, props));
};

/***/ }),

/***/ 68751:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "up": function() { return /* binding */ AddContextualData; },
  "pb": function() { return /* binding */ BASE_JOURNEY_ENDPOINT; },
  "ZU": function() { return /* binding */ DebugObservability; },
  "Md": function() { return /* binding */ RealObservability; },
  "YE": function() { return /* binding */ analytics_exports; },
  "UJ": function() { return /* binding */ buildDefaultDatadogOptions; },
  "vg": function() { return /* binding */ buildDefaultSentryOpts; },
  "BS": function() { return /* binding */ getDeployEnv; },
  "w": function() { return /* binding */ globalObservability; },
  "UN": function() { return /* binding */ initJourney; },
  "dl": function() { return /* binding */ loadGoogleTagManager; },
  "m7": function() { return /* binding */ loadSegment; },
  "C3": function() { return /* binding */ useObservability; }
});

// UNUSED EXPORTS: ContextualDataContext, UTM_ADGID, UTM_CAMPAIGN, UTM_CAT, UTM_CONTENT, UTM_CTA, UTM_EXTERNALID, UTM_GEO, UTM_MEDIUM, UTM_NTWK, UTM_SOURCE, UTM_SUBSITE, UTM_TERM, addDatadogRUMGlobalContext, emptyContextualData, emptyJourneyEventContextualData, mergeContextualData, readUtmCookie, setRUMUser, setRUMUserProperty, subscribeToDevtoolsEvents, testonly, useContextualData, useFakeObservability

;// CONCATENATED MODULE: ./node_modules/@opendoor/observability/node_modules/js-cookie/dist/js.cookie.mjs
/*! js-cookie v3.0.1 | MIT */
/* eslint-disable no-var */
function js_cookie_assign (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target
}
/* eslint-enable no-var */

/* eslint-disable no-var */
var defaultConverter = {
  read: function (value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
  },
  write: function (value) {
    return encodeURIComponent(value).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    )
  }
};
/* eslint-enable no-var */

/* eslint-disable no-var */

function init (converter, defaultAttributes) {
  function set (key, value, attributes) {
    if (typeof document === 'undefined') {
      return
    }

    attributes = js_cookie_assign({}, defaultAttributes, attributes);

    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }

    key = encodeURIComponent(key)
      .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
      .replace(/[()]/g, escape);

    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue
      }

      stringifiedAttributes += '; ' + attributeName;

      if (attributes[attributeName] === true) {
        continue
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }

    return (document.cookie =
      key + '=' + converter.write(value, key) + stringifiedAttributes)
  }

  function get (key) {
    if (typeof document === 'undefined' || (arguments.length && !key)) {
      return
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');

      try {
        var foundKey = decodeURIComponent(parts[0]);
        jar[foundKey] = converter.read(value, foundKey);

        if (key === foundKey) {
          break
        }
      } catch (e) {}
    }

    return key ? jar[key] : jar
  }

  return Object.create(
    {
      set: set,
      get: get,
      remove: function (key, attributes) {
        set(
          key,
          '',
          js_cookie_assign({}, attributes, {
            expires: -1
          })
        );
      },
      withAttributes: function (attributes) {
        return init(this.converter, js_cookie_assign({}, this.attributes, attributes))
      },
      withConverter: function (converter) {
        return init(js_cookie_assign({}, this.converter, converter), this.attributes)
      }
    },
    {
      attributes: { value: Object.freeze(defaultAttributes) },
      converter: { value: Object.freeze(converter) }
    }
  )
}

var api = init(defaultConverter, { path: '/' });
/* eslint-enable no-var */

/* harmony default export */ var js_cookie = (api);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@opendoor/observability/dist/chunk-SXEEZYFT.mjs
var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/internal/deployEnv.ts
var getDeployEnv = () => {
  var _a, _b, _c, _d;
  if (typeof window === "undefined" || typeof document === "undefined") {
    return "development";
  }
  const hostname = (_a = window == null ? void 0 : window.location) == null ? void 0 : _a.hostname;
  if (hostname === void 0) {
    return "development";
  }
  const port = (_b = window == null ? void 0 : window.location) == null ? void 0 : _b.port;
  const locationHasPort = port && port !== "";
  const onLocalhost = hostname === "localhost";
  const onNgrok = hostname.includes(".ngrok.io");
  const onXipIO = hostname.includes(".xip.io");
  const inAndroidEmulator = hostname.includes("10.0.2.2");
  const inDevelopment = onLocalhost && locationHasPort || onNgrok || onXipIO || inAndroidEmulator;
  if (inDevelopment) {
    return "development";
  }
  const inRailsCI = hostname === "127.0.0.1";
  if (inRailsCI || onLocalhost) {
    return "test";
  }
  const onStagingManagedDomain = hostname.includes("-staging.managed.services.opendoor.com");
  const onSimplersell = hostname.includes(".simplersell.com");
  const onODMortgage = hostname.includes(".odmortgage.com");
  const inStaging = onStagingManagedDomain || onSimplersell || onODMortgage;
  const onOpendoorHomeLoans = hostname.includes("opendoorhomeloans.com");
  const onOpendoor = hostname.includes(".opendoor.com") && !hostname.includes("-staging");
  const inProduction = onOpendoor || onOpendoorHomeLoans;
  const inProdOrStaging = inStaging || inProduction;
  const onQADomain = hostname.includes("-qa-");
  const hasQACookie = ((_c = document == null ? void 0 : document.cookie) == null ? void 0 : _c.includes("qa=")) && ((_d = document == null ? void 0 : document.cookie) == null ? void 0 : _d.includes("qa_env="));
  const inQA = onQADomain || inProdOrStaging && hasQACookie;
  if (inQA) {
    return "qa";
  } else if (inStaging) {
    return "staging";
  } else if (inProduction) {
    return "production";
  }
  return "development";
};

// src/contextualData.ts
var emptyContextualData = {
  user: void 0,
  data: {},
  adClickContext: void 0,
  campaignContext: void 0,
  customerContext: void 0,
  exclusiveOffersContext: void 0,
  leadContext: void 0,
  sellDirectContext: void 0
};
var emptyJourneyEventContextualData = {
  customerContext: void 0,
  campaignContext: void 0,
  websiteSourceContext: void 0
};
function mergeContextualData(parent, child = emptyContextualData) {
  if (getDeployEnv() !== "production" && parent.user && child.user) {
    throw new Error("User already set. This error only shows in non-production environments.");
  }
  return {
    user: child.user || parent.user,
    data: { ...parent.data, ...child.data },
    campaignContext: child.campaignContext || parent.campaignContext,
    customerContext: child.customerContext || parent.customerContext,
    exclusiveOffersContext: child.exclusiveOffersContext || parent.exclusiveOffersContext,
    leadContext: child.leadContext || parent.leadContext,
    sellDirectContext: child.sellDirectContext || parent.sellDirectContext,
    adClickContext: child.adClickContext || parent.adClickContext
  };
}

// src/global.ts
var ProxyObservabilityInstance = class {
  currentInstance = null;
  setCurrentInstance(instance) {
    this.currentInstance = instance;
  }
  // This is only used for testing.
  _destroyCurrentInstance() {
    this.currentInstance = null;
  }
  /**
   * Track events not performed by a user but meaningful internally. For events performed
   * by a user, use `trackUserEvent`.
   *
   * TODO (@core-experience-platform): rename to `trackInternalEvent`
   */
  trackEvent(action, label, contextualData, options) {
    var _a;
    (_a = this.currentInstance) == null ? void 0 : _a.trackEvent(action, label, contextualData, options);
  }
  /**
   * @deprecated Use trackJourneyEvent instead
   * @see https://opendoor.atlassian.net/wiki/spaces/CONSUMER/pages/2283536444/How+to+Create+Journey+2.0+Events
   */
  trackUserEvent(event, contextualData) {
    var _a;
    (_a = this.currentInstance) == null ? void 0 : _a.trackUserEvent(event, contextualData);
  }
  trackJourneyEvent(categoryName, eventName, eventData, contextualData = emptyJourneyEventContextualData, options) {
    var _a;
    (_a = this.currentInstance) == null ? void 0 : _a.trackJourneyEvent(
      categoryName,
      eventName,
      eventData,
      contextualData,
      options
    );
  }
  trackError(label, error, contextualData, options) {
    var _a;
    (_a = this.currentInstance) == null ? void 0 : _a.trackError(label, error, contextualData, options);
  }
  // All of the "getXXXClient" methods return a Proxy object, that capture requests
  // and then re-evaluate and forward the request to the currentInstance every time.
  // This ensures that if the currentInstance is changed, the new instance will be used.
  // And it also allows for behavior like:
  // import { Sentry } from '@opendoor/observability';
  // If you don't do this, and Sentry is delayed in initializing, then the user will
  // have a reference to an empty object forever, instead of a reference to an object
  // that will eventually have methods in it.
  // The only downside of this is that users have to handle undefined for the methods
  // but that tradeoff is okay.
  getDatadogRumClient() {
    return new Proxy(
      {},
      {
        get: (_, prop) => {
          return this.currentInstance ? this.currentInstance.getDatadogRumClient()[prop] : void 0;
        }
      }
    );
  }
  getJourneyUserClient() {
    return new Proxy(
      {},
      {
        get: (_, prop) => {
          return this.currentInstance ? this.currentInstance.getJourneyUserClient()[prop] : void 0;
        },
        set: (_, prop, value) => {
          return this.currentInstance ? this.currentInstance.getJourneyUserClient()[prop] = value : void 0;
        }
      }
    );
  }
  getJourneyEventClient() {
    return new Proxy(
      {},
      {
        get: (_, prop) => {
          return this.currentInstance ? this.currentInstance.getJourneyEventClient()[prop] : void 0;
        },
        set: (_, prop, value) => {
          return this.currentInstance ? this.currentInstance.getJourneyEventClient()[prop] = value : void 0;
        }
      }
    );
  }
  getSentryClient() {
    return new Proxy(
      {},
      {
        get: (_, prop) => this.currentInstance ? this.currentInstance.getSentryClient()[prop] : void 0
      }
    );
  }
  isInitialized() {
    return this.currentInstance !== null;
  }
};
var globalObservability = new ProxyObservabilityInstance();

// src/internal/sentry.ts
function buildDefaultSentryOpts(opts) {
  const { env, appName, version } = opts;
  return {
    environment: env,
    release: `${appName}@${version}`,
    ignoreErrors: [...DEFAULT_IGNORE_ERRORS],
    beforeSend
  };
}
function trackEventInSentry(action, label, contextualData = emptyContextualData) {
  var _a, _b;
  (_b = (_a = globalObservability.getSentryClient()).addBreadcrumb) == null ? void 0 : _b.call(_a, {
    category: action,
    message: label,
    data: {
      ...contextualData.data,
      adClickContext: contextualData.adClickContext,
      campaignContext: contextualData.campaignContext,
      customerContext: contextualData.customerContext,
      exclusiveOffersContext: contextualData.exclusiveOffersContext,
      leadContext: contextualData.leadContext,
      sellDirectContext: contextualData.sellDirectContext
    },
    timestamp: Date.now()
  });
}
function trackUserEventInSentry(event, contextualData = emptyContextualData) {
  var _a, _b;
  (_b = (_a = globalObservability.getSentryClient()).addBreadcrumb) == null ? void 0 : _b.call(_a, {
    category: Object.keys(event)[0] ?? "unknownUserEvent",
    data: {
      ...event,
      ...contextualData.data,
      adClickContext: contextualData.adClickContext,
      campaignContext: contextualData.campaignContext,
      customerContext: contextualData.customerContext,
      exclusiveOffersContext: contextualData.exclusiveOffersContext,
      leadContext: contextualData.leadContext,
      sellDirectContext: contextualData.sellDirectContext
    },
    timestamp: Date.now()
  });
}
function trackJourneyEventInSentry(event, contextualData, journeyEventHelpers) {
  var _a, _b, _c;
  const category = ((_a = event.category) == null ? void 0 : _a.$case) ?? "unknownUserEvent";
  const journeyEventJSON = journeyEventHelpers.toJSON(event);
  (_c = (_b = globalObservability.getSentryClient()).addBreadcrumb) == null ? void 0 : _c.call(_b, {
    category,
    data: {
      ...journeyEventJSON,
      campaignContext: contextualData.campaignContext
    },
    timestamp: Date.now()
  });
}
function trackErrorInSentry(label, error, contextualData = emptyContextualData) {
  var _a, _b;
  let newContextualData = emptyContextualData;
  (_b = (_a = globalObservability.getSentryClient()).withScope) == null ? void 0 : _b.call(_a, (scope) => {
    var _a2, _b2;
    scope.setFingerprint([label]);
    scope.setUser(
      contextualData.user ? {
        ...contextualData.user,
        id: contextualData.user.humanID
      } : null
    );
    scope.setTags({
      ...contextualDataToTags(contextualData.data),
      label
      // add label as a tag so we can search for it
    });
    scope.setExtras(contextualData.data);
    const eventId = (_b2 = (_a2 = globalObservability.getSentryClient()).captureException) == null ? void 0 : _b2.call(_a2, error || new Error(label));
    newContextualData = {
      data: {
        "sentry-event-id": eventId
      }
    };
  });
  return newContextualData;
}
function contextualDataToTags(data) {
  let tags = {};
  Object.keys(data).forEach((key) => {
    const value = data[key];
    switch (typeof value) {
      case "undefined":
      case "boolean":
      case "number":
      case "bigint":
      case "string":
      case "symbol":
        tags[key] = String(value);
        break;
      case "object":
        if (value === null) {
          tags[key] = "null";
        }
        break;
    }
  });
  return tags;
}
var DEFAULT_IGNORE_ERRORS = [
  // Error generated by a bug in auto-fill library from Chrome Mobile on iOS
  // https://github.com/getsentry/sentry/issues/5267
  "Blocked a frame with origin",
  // error generated by microsoft outlook's safelink crawler on pages we email out
  // https://forum.sentry.io/t/unhandledrejection-non-error-promise-rejection-captured-with-value/14062
  "Object Not Found Matching Id",
  // Error that MAY indicate a performance issue due to browser implementation, but has been shown to be safe to ignore.
  // https://stackoverflow.com/questions/49384120/resizeobserver-loop-limit-exceeded
  "ResizeObserver loop limit exceeded",
  "ResizeObserver loop completed with undelivered notifications"
];
var beforeSendFn = (mappers, event) => {
  return mappers.reduce((acc, mapper) => mapper(acc), event);
};
var beforeSend = (event) => {
  if (!event) {
    return null;
  }
  return beforeSendFn(MAPPERS, event);
};
var isPhantomJs = (event) => {
  if (typeof window === "undefined") {
    return event;
  }
  const isPhantomJS = /PhantomJS/.test(window.navigator.userAgent);
  return !isPhantomJS ? event : null;
};
var isInvalidArgumentError = (event) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  const firstFrameFilename = ((_f = (_e = (_d = (_c = (_b = (_a = event == null ? void 0 : event.exception) == null ? void 0 : _a.values) == null ? void 0 : _b[0]) == null ? void 0 : _c.stacktrace) == null ? void 0 : _d.frames) == null ? void 0 : _e[0]) == null ? void 0 : _f.filename) || "";
  const eventMessage = ((_i = (_h = (_g = event == null ? void 0 : event.exception) == null ? void 0 : _g.values) == null ? void 0 : _h[0]) == null ? void 0 : _i.value) || "";
  if (eventMessage.includes("Invalid argument") && firstFrameFilename.includes("maps-api-v3")) {
    return null;
  }
  if (eventMessage.includes('Could not load "map"') || eventMessage.includes('Could not load "marker"') || // Error occurs when watching Vimeo videos on Safari
  eventMessage.includes("The operation was aborted.")) {
    return null;
  }
  return event;
};
var MAPPERS = [isPhantomJs, isInvalidArgumentError];

// src/internal/datadog.ts
var buildDefaultDatadogOptions = (opts) => {
  const { appName, env, version } = opts;
  return {
    site: "datadoghq.com",
    version,
    env,
    service: appName
  };
};
function getContextualDataFromDatadog() {
  var _a, _b, _c;
  const sessionId = (_c = (_b = (_a = globalObservability.getDatadogRumClient()).getInternalContext) == null ? void 0 : _b.call(_a)) == null ? void 0 : _c.session_id;
  if (sessionId) {
    return {
      data: {
        "datadog-rum-session-id": sessionId,
        "datadog-rum-session-replay": `https://app.datadoghq.com/rum/replay/sessions/${sessionId}`,
        "datadog-rum-session-search": `https://app.datadoghq.com/rum/explorer?query=%40session.id%3A${sessionId}`
      }
    };
  } else {
    return emptyContextualData;
  }
}
function trackPerformanceInDatadog(eventName) {
  var _a, _b;
  (_b = (_a = globalObservability.getDatadogRumClient()).addTiming) == null ? void 0 : _b.call(_a, eventName);
}
function addRUMGlobalContext(context) {
  var _a, _b, _c, _d;
  (_d = (_a = globalObservability.getDatadogRumClient()) == null ? void 0 : _a.setGlobalContext) == null ? void 0 : _d.call(_a, {
    ...(_c = (_b = globalObservability.getDatadogRumClient()).getGlobalContext) == null ? void 0 : _c.call(_b),
    ...context
  });
}
function trackEventInDatadog(action, label, contextualData = emptyContextualData) {
  var _a, _b;
  (_b = (_a = globalObservability.getDatadogRumClient()).addAction) == null ? void 0 : _b.call(_a, action, {
    ...contextualData.data,
    adClickContext: contextualData.adClickContext,
    campaignContext: contextualData.campaignContext,
    customerContext: contextualData.customerContext,
    exclusiveOffersContext: contextualData.exclusiveOffersContext,
    leadContext: contextualData.leadContext,
    sellDirectContext: contextualData.sellDirectContext,
    label
  });
}
function trackUserEventInDatadog(event, contextualData = emptyContextualData) {
  var _a, _b, _c;
  (_c = (_b = globalObservability.getDatadogRumClient()).addAction) == null ? void 0 : _c.call(_b, ((_a = Object.keys(event)) == null ? void 0 : _a[0]) ?? "unknownUserEvent", {
    ...event,
    ...contextualData.data,
    adClickContext: contextualData.adClickContext,
    campaignContext: contextualData.campaignContext,
    customerContext: contextualData.customerContext,
    exclusiveOffersContext: contextualData.exclusiveOffersContext,
    leadContext: contextualData.leadContext,
    sellDirectContext: contextualData.sellDirectContext
  });
}
function trackJourneyEventInDatadog(event, contextualData, journeyEventHelpers) {
  var _a, _b, _c;
  const category = ((_a = event.category) == null ? void 0 : _a.$case) ?? "unknownUserEvent";
  const journeyEventJSON = journeyEventHelpers.toJSON(event);
  (_c = (_b = globalObservability.getDatadogRumClient()).addAction) == null ? void 0 : _c.call(_b, category, {
    ...journeyEventJSON,
    campaignContext: contextualData.campaignContext
  });
}
function trackErrorInDatadog(label, error, contextualData = emptyContextualData) {
  var _a, _b;
  if (shouldExcludeErrorByMessage(error)) {
    return;
  }
  (_b = (_a = globalObservability.getDatadogRumClient()).addError) == null ? void 0 : _b.call(_a, error || new Error(label), {
    ...contextualData.data,
    label
  });
}
var ERROR_MESSAGES_TO_EXCLUDE = [
  // Error that MAY indicate a performance issue due to browser implementation, but has been shown to be safe to ignore.
  // https://stackoverflow.com/questions/49384120/resizeobserver-loop-limit-exceeded
  "ResizeObserver loop limit exceeded"
];
var shouldExcludeErrorByMessage = (error) => {
  return ERROR_MESSAGES_TO_EXCLUDE.includes((error == null ? void 0 : error.message) || "");
};
function setRUMUser(user) {
  var _a, _b;
  (_b = (_a = globalObservability.getDatadogRumClient()).setUser) == null ? void 0 : _b.call(_a, user);
}
function setRUMUserProperty(user) {
  Object.entries(user).forEach(([key, value]) => {
    var _a, _b;
    (_b = (_a = globalObservability.getDatadogRumClient()).setUserProperty) == null ? void 0 : _b.call(_a, key, value);
  });
}

// src/internal/googleTagManager.ts
var loadGoogleTagManager = (lazyLoad) => {
  const injectScript = () => {
    if (typeof window !== "undefined") {
      (function(w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({
          "gtm.start": (/* @__PURE__ */ new Date()).getTime(),
          event: "gtm.js"
        });
        var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l !== "dataLayer" ? "&l=" + l : "";
        j.async = true;
        j.src = "//www.googletagmanager.com/gtm.js?id=" + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, "script", "dataLayer", "GTM-MSX7NS");
    }
  };
  if (lazyLoad) {
    window.addEventListener("load", injectScript);
  } else {
    injectScript();
  }
};

// src/internal/journey.ts


// src/__generated__/protobuf/journey/data/sources.ts
function websiteSource_EventOriginFromJSON(object) {
  switch (object) {
    case 0:
    case "UNSPECIFIED":
      return 0 /* UNSPECIFIED */;
    case 1:
    case "SERVER":
      return 1 /* SERVER */;
    case 2:
    case "CLIENT":
      return 2 /* CLIENT */;
    case -1:
    case "UNRECOGNIZED":
    default:
      return -1 /* UNRECOGNIZED */;
  }
}
function websiteSource_EventOriginToJSON(object) {
  switch (object) {
    case 0 /* UNSPECIFIED */:
      return "UNSPECIFIED";
    case 1 /* SERVER */:
      return "SERVER";
    case 2 /* CLIENT */:
      return "CLIENT";
    case -1 /* UNRECOGNIZED */:
    default:
      return "UNRECOGNIZED";
  }
}
function mobileSource_EventOriginFromJSON(object) {
  switch (object) {
    case 0:
    case "APP":
      return 0 /* APP */;
    case -1:
    case "UNRECOGNIZED":
    default:
      return -1 /* UNRECOGNIZED */;
  }
}
function mobileSource_EventOriginToJSON(object) {
  switch (object) {
    case 0 /* APP */:
      return "APP";
    case -1 /* UNRECOGNIZED */:
    default:
      return "UNRECOGNIZED";
  }
}
function createBaseWebsiteSource() {
  return {
    url: "",
    userAgent: void 0,
    ip: void 0,
    referrer: void 0,
    proxyPath: void 0,
    pathname: void 0,
    queryMap: {},
    host: void 0,
    eventOrigin: 0,
    proxyQueryMap: {},
    screen: void 0,
    language: [],
    isWebview: false
  };
}
var WebsiteSource = {
  fromJSON(object) {
    return {
      url: isSet(object.url) ? String(object.url) : "",
      userAgent: isSet(object.userAgent) ? String(object.userAgent) : void 0,
      ip: isSet(object.ip) ? String(object.ip) : void 0,
      referrer: isSet(object.referrer) ? String(object.referrer) : void 0,
      proxyPath: isSet(object.proxyPath) ? String(object.proxyPath) : void 0,
      pathname: isSet(object.pathname) ? String(object.pathname) : void 0,
      queryMap: isObject(object.queryMap) ? Object.entries(object.queryMap).reduce((acc, [key, value]) => {
        acc[key] = String(value);
        return acc;
      }, {}) : {},
      host: isSet(object.host) ? String(object.host) : void 0,
      eventOrigin: isSet(object.eventOrigin) ? websiteSource_EventOriginFromJSON(object.eventOrigin) : 0,
      proxyQueryMap: isObject(object.proxyQueryMap) ? Object.entries(object.proxyQueryMap).reduce((acc, [key, value]) => {
        acc[key] = String(value);
        return acc;
      }, {}) : {},
      screen: isSet(object.screen) ? WebsiteSource_Screen.fromJSON(object.screen) : void 0,
      language: Array.isArray(object == null ? void 0 : object.language) ? object.language.map((e) => String(e)) : [],
      isWebview: isSet(object.isWebview) ? Boolean(object.isWebview) : false
    };
  },
  toJSON(message) {
    var _a;
    const obj = {};
    if (message.url !== "") {
      obj.url = message.url;
    }
    if (message.userAgent !== void 0) {
      obj.userAgent = message.userAgent;
    }
    if (message.ip !== void 0) {
      obj.ip = message.ip;
    }
    if (message.referrer !== void 0) {
      obj.referrer = message.referrer;
    }
    if (message.proxyPath !== void 0) {
      obj.proxyPath = message.proxyPath;
    }
    if (message.pathname !== void 0) {
      obj.pathname = message.pathname;
    }
    if (message.queryMap) {
      const entries = Object.entries(message.queryMap);
      if (entries.length > 0) {
        obj.queryMap = {};
        entries.forEach(([k, v]) => {
          obj.queryMap[k] = v;
        });
      }
    }
    if (message.host !== void 0) {
      obj.host = message.host;
    }
    if (message.eventOrigin !== 0) {
      obj.eventOrigin = websiteSource_EventOriginToJSON(message.eventOrigin);
    }
    if (message.proxyQueryMap) {
      const entries = Object.entries(message.proxyQueryMap);
      if (entries.length > 0) {
        obj.proxyQueryMap = {};
        entries.forEach(([k, v]) => {
          obj.proxyQueryMap[k] = v;
        });
      }
    }
    if (message.screen !== void 0) {
      obj.screen = WebsiteSource_Screen.toJSON(message.screen);
    }
    if ((_a = message.language) == null ? void 0 : _a.length) {
      obj.language = message.language;
    }
    if (message.isWebview === true) {
      obj.isWebview = message.isWebview;
    }
    return obj;
  },
  create(base) {
    return WebsiteSource.fromPartial(base ?? {});
  },
  fromPartial(object) {
    var _a;
    const message = createBaseWebsiteSource();
    message.url = object.url ?? "";
    message.userAgent = object.userAgent ?? void 0;
    message.ip = object.ip ?? void 0;
    message.referrer = object.referrer ?? void 0;
    message.proxyPath = object.proxyPath ?? void 0;
    message.pathname = object.pathname ?? void 0;
    message.queryMap = Object.entries(object.queryMap ?? {}).reduce((acc, [key, value]) => {
      if (value !== void 0) {
        acc[key] = String(value);
      }
      return acc;
    }, {});
    message.host = object.host ?? void 0;
    message.eventOrigin = object.eventOrigin ?? 0;
    message.proxyQueryMap = Object.entries(object.proxyQueryMap ?? {}).reduce(
      (acc, [key, value]) => {
        if (value !== void 0) {
          acc[key] = String(value);
        }
        return acc;
      },
      {}
    );
    message.screen = object.screen !== void 0 && object.screen !== null ? WebsiteSource_Screen.fromPartial(object.screen) : void 0;
    message.language = ((_a = object.language) == null ? void 0 : _a.map((e) => e)) || [];
    message.isWebview = object.isWebview ?? false;
    return message;
  }
};
function createBaseWebsiteSource_Screen() {
  return { density: 0, width: 0, height: 0 };
}
var WebsiteSource_Screen = {
  fromJSON(object) {
    return {
      density: isSet(object.density) ? Number(object.density) : 0,
      width: isSet(object.width) ? Number(object.width) : 0,
      height: isSet(object.height) ? Number(object.height) : 0
    };
  },
  toJSON(message) {
    const obj = {};
    if (message.density !== 0) {
      obj.density = Math.round(message.density);
    }
    if (message.width !== 0) {
      obj.width = Math.round(message.width);
    }
    if (message.height !== 0) {
      obj.height = Math.round(message.height);
    }
    return obj;
  },
  create(base) {
    return WebsiteSource_Screen.fromPartial(base ?? {});
  },
  fromPartial(object) {
    const message = createBaseWebsiteSource_Screen();
    message.density = object.density ?? 0;
    message.width = object.width ?? 0;
    message.height = object.height ?? 0;
    return message;
  }
};
function createBaseMobileSource() {
  return {
    userAgent: void 0,
    ip: void 0,
    appName: "",
    appBuild: void 0,
    appVersion: void 0,
    appNamespace: void 0,
    deviceId: "",
    deviceType: void 0,
    deviceModel: void 0,
    deviceManufacturer: void 0,
    deviceName: void 0,
    advertisingId: void 0,
    adTrackingEnabled: void 0,
    notificationPermissionStatus: void 0,
    carrier: void 0,
    osName: void 0,
    osVersion: void 0,
    screenDensity: void 0,
    screenHeight: void 0,
    screenWidth: void 0,
    focusRouteName: "",
    eventOrigin: 0
  };
}
var MobileSource = {
  fromJSON(object) {
    return {
      userAgent: isSet(object.userAgent) ? String(object.userAgent) : void 0,
      ip: isSet(object.ip) ? String(object.ip) : void 0,
      appName: isSet(object.appName) ? String(object.appName) : "",
      appBuild: isSet(object.appBuild) ? String(object.appBuild) : void 0,
      appVersion: isSet(object.appVersion) ? String(object.appVersion) : void 0,
      appNamespace: isSet(object.appNamespace) ? String(object.appNamespace) : void 0,
      deviceId: isSet(object.deviceId) ? String(object.deviceId) : "",
      deviceType: isSet(object.deviceType) ? String(object.deviceType) : void 0,
      deviceModel: isSet(object.deviceModel) ? String(object.deviceModel) : void 0,
      deviceManufacturer: isSet(object.deviceManufacturer) ? String(object.deviceManufacturer) : void 0,
      deviceName: isSet(object.deviceName) ? String(object.deviceName) : void 0,
      advertisingId: isSet(object.advertisingId) ? String(object.advertisingId) : void 0,
      adTrackingEnabled: isSet(object.adTrackingEnabled) ? Boolean(object.adTrackingEnabled) : void 0,
      notificationPermissionStatus: isSet(object.notificationPermissionStatus) ? String(object.notificationPermissionStatus) : void 0,
      carrier: isSet(object.carrier) ? String(object.carrier) : void 0,
      osName: isSet(object.osName) ? String(object.osName) : void 0,
      osVersion: isSet(object.osVersion) ? String(object.osVersion) : void 0,
      screenDensity: isSet(object.screenDensity) ? Number(object.screenDensity) : void 0,
      screenHeight: isSet(object.screenHeight) ? Number(object.screenHeight) : void 0,
      screenWidth: isSet(object.screenWidth) ? Number(object.screenWidth) : void 0,
      focusRouteName: isSet(object.focusRouteName) ? String(object.focusRouteName) : "",
      eventOrigin: isSet(object.eventOrigin) ? mobileSource_EventOriginFromJSON(object.eventOrigin) : 0
    };
  },
  toJSON(message) {
    const obj = {};
    if (message.userAgent !== void 0) {
      obj.userAgent = message.userAgent;
    }
    if (message.ip !== void 0) {
      obj.ip = message.ip;
    }
    if (message.appName !== "") {
      obj.appName = message.appName;
    }
    if (message.appBuild !== void 0) {
      obj.appBuild = message.appBuild;
    }
    if (message.appVersion !== void 0) {
      obj.appVersion = message.appVersion;
    }
    if (message.appNamespace !== void 0) {
      obj.appNamespace = message.appNamespace;
    }
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    if (message.deviceType !== void 0) {
      obj.deviceType = message.deviceType;
    }
    if (message.deviceModel !== void 0) {
      obj.deviceModel = message.deviceModel;
    }
    if (message.deviceManufacturer !== void 0) {
      obj.deviceManufacturer = message.deviceManufacturer;
    }
    if (message.deviceName !== void 0) {
      obj.deviceName = message.deviceName;
    }
    if (message.advertisingId !== void 0) {
      obj.advertisingId = message.advertisingId;
    }
    if (message.adTrackingEnabled !== void 0) {
      obj.adTrackingEnabled = message.adTrackingEnabled;
    }
    if (message.notificationPermissionStatus !== void 0) {
      obj.notificationPermissionStatus = message.notificationPermissionStatus;
    }
    if (message.carrier !== void 0) {
      obj.carrier = message.carrier;
    }
    if (message.osName !== void 0) {
      obj.osName = message.osName;
    }
    if (message.osVersion !== void 0) {
      obj.osVersion = message.osVersion;
    }
    if (message.screenDensity !== void 0) {
      obj.screenDensity = message.screenDensity;
    }
    if (message.screenHeight !== void 0) {
      obj.screenHeight = message.screenHeight;
    }
    if (message.screenWidth !== void 0) {
      obj.screenWidth = message.screenWidth;
    }
    if (message.focusRouteName !== "") {
      obj.focusRouteName = message.focusRouteName;
    }
    if (message.eventOrigin !== 0) {
      obj.eventOrigin = mobileSource_EventOriginToJSON(message.eventOrigin);
    }
    return obj;
  },
  create(base) {
    return MobileSource.fromPartial(base ?? {});
  },
  fromPartial(object) {
    const message = createBaseMobileSource();
    message.userAgent = object.userAgent ?? void 0;
    message.ip = object.ip ?? void 0;
    message.appName = object.appName ?? "";
    message.appBuild = object.appBuild ?? void 0;
    message.appVersion = object.appVersion ?? void 0;
    message.appNamespace = object.appNamespace ?? void 0;
    message.deviceId = object.deviceId ?? "";
    message.deviceType = object.deviceType ?? void 0;
    message.deviceModel = object.deviceModel ?? void 0;
    message.deviceManufacturer = object.deviceManufacturer ?? void 0;
    message.deviceName = object.deviceName ?? void 0;
    message.advertisingId = object.advertisingId ?? void 0;
    message.adTrackingEnabled = object.adTrackingEnabled ?? void 0;
    message.notificationPermissionStatus = object.notificationPermissionStatus ?? void 0;
    message.carrier = object.carrier ?? void 0;
    message.osName = object.osName ?? void 0;
    message.osVersion = object.osVersion ?? void 0;
    message.screenDensity = object.screenDensity ?? void 0;
    message.screenHeight = object.screenHeight ?? void 0;
    message.screenWidth = object.screenWidth ?? void 0;
    message.focusRouteName = object.focusRouteName ?? "";
    message.eventOrigin = object.eventOrigin ?? 0;
    return message;
  }
};
function createBaseBackendSource() {
  return { name: "", clientUserAgent: void 0, clientIp: void 0 };
}
var BackendSource = {
  fromJSON(object) {
    return {
      name: isSet(object.name) ? String(object.name) : "",
      clientUserAgent: isSet(object.clientUserAgent) ? String(object.clientUserAgent) : void 0,
      clientIp: isSet(object.clientIp) ? String(object.clientIp) : void 0
    };
  },
  toJSON(message) {
    const obj = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.clientUserAgent !== void 0) {
      obj.clientUserAgent = message.clientUserAgent;
    }
    if (message.clientIp !== void 0) {
      obj.clientIp = message.clientIp;
    }
    return obj;
  },
  create(base) {
    return BackendSource.fromPartial(base ?? {});
  },
  fromPartial(object) {
    const message = createBaseBackendSource();
    message.name = object.name ?? "";
    message.clientUserAgent = object.clientUserAgent ?? void 0;
    message.clientIp = object.clientIp ?? void 0;
    return message;
  }
};
function isObject(value) {
  return typeof value === "object" && value !== null;
}
function isSet(value) {
  return value !== null && value !== void 0;
}

// src/__generated__/google/protobuf/timestamp.ts
function createBaseTimestamp() {
  return { seconds: 0, nanos: 0 };
}
var Timestamp = {
  fromJSON(object) {
    return {
      seconds: isSet2(object.seconds) ? Number(object.seconds) : 0,
      nanos: isSet2(object.nanos) ? Number(object.nanos) : 0
    };
  },
  toJSON(message) {
    const obj = {};
    if (message.seconds !== 0) {
      obj.seconds = Math.round(message.seconds);
    }
    if (message.nanos !== 0) {
      obj.nanos = Math.round(message.nanos);
    }
    return obj;
  },
  create(base) {
    return Timestamp.fromPartial(base ?? {});
  },
  fromPartial(object) {
    const message = createBaseTimestamp();
    message.seconds = object.seconds ?? 0;
    message.nanos = object.nanos ?? 0;
    return message;
  }
};
function isSet2(value) {
  return value !== null && value !== void 0;
}

// src/__generated__/protobuf/common/sell/offer_request.ts
function offerRequest_SourceFromJSON(object) {
  switch (object) {
    case 0:
    case "UNKNOWN_OFFER_SOURCE":
      return 0 /* UNKNOWN_OFFER_SOURCE */;
    case 1:
    case "REFRESH_ADMIN":
      return 1 /* REFRESH_ADMIN */;
    case 2:
    case "REFRESH_OFFER_DASHBOARD":
      return 2 /* REFRESH_OFFER_DASHBOARD */;
    case 3:
    case "REFRESH_BROKERAGE_OFFER_DASHBOARD":
      return 3 /* REFRESH_BROKERAGE_OFFER_DASHBOARD */;
    case 4:
    case "REFRESH_SELLER_FEEDBACK":
      return 4 /* REFRESH_SELLER_FEEDBACK */;
    case 5:
    case "REFRESH_REENGAGEMENT_EMAILS":
      return 5 /* REFRESH_REENGAGEMENT_EMAILS */;
    case 6:
    case "REFRESH_CORRECTED_SQ_FT_DATA":
      return 6 /* REFRESH_CORRECTED_SQ_FT_DATA */;
    case 7:
    case "INITIAL_LEAD_FLOW":
      return 7 /* INITIAL_LEAD_FLOW */;
    case 8:
    case "INCOMPLETE_INITIAL_LEAD_FLOW":
      return 8 /* INCOMPLETE_INITIAL_LEAD_FLOW */;
    case 9:
    case "OFFER_REENGAGEMENT_CAMPAIGN":
      return 9 /* OFFER_REENGAGEMENT_CAMPAIGN */;
    case 10:
    case "AUTOMATED_REENGAGEMENT_OFFER":
      return 10 /* AUTOMATED_REENGAGEMENT_OFFER */;
    case 11:
    case "MOBILE_APP":
      return 11 /* MOBILE_APP */;
    case 12:
    case "REIT_BULK_REQUEST":
      return 12 /* REIT_BULK_REQUEST */;
    case 13:
    case "OFFER_REVIEW":
      return 13 /* OFFER_REVIEW */;
    case 14:
    case "FLYWHEEL":
      return 14 /* FLYWHEEL */;
    case 15:
    case "EMAIL_PROSPECTING":
      return 15 /* EMAIL_PROSPECTING */;
    case 16:
    case "OUTBOUND_OFFERS_LISTED":
      return 16 /* OUTBOUND_OFFERS_LISTED */;
    case 17:
    case "REFRESH_PARTNER_REFERRAL":
      return 17 /* REFRESH_PARTNER_REFERRAL */;
    case 18:
    case "HOME_RESERVE":
      return 18 /* HOME_RESERVE */;
    case 19:
    case "HOMEPAGE_RETURN_EXPERIENCE":
      return 19 /* HOMEPAGE_RETURN_EXPERIENCE */;
    case 20:
    case "REFRESH_HOME_DETAILS":
      return 20 /* REFRESH_HOME_DETAILS */;
    case 21:
    case "REFRESH_FROM_ENG":
      return 21 /* REFRESH_FROM_ENG */;
    case 22:
    case "REFRESH_PARTNER_CTA":
      return 22 /* REFRESH_PARTNER_CTA */;
    case 23:
    case "RETURN_TO_HUB_AUTO_REFRESH":
      return 23 /* RETURN_TO_HUB_AUTO_REFRESH */;
    case 24:
    case "EXCLUSIVE_OFFERS":
      return 24 /* EXCLUSIVE_OFFERS */;
    case 25:
    case "REFRESH_PREVIOUSLY_DENIED":
      return 25 /* REFRESH_PREVIOUSLY_DENIED */;
    case 26:
    case "AUTOMATED_AGENT_REENGAGEMENT_OFFER":
      return 26 /* AUTOMATED_AGENT_REENGAGEMENT_OFFER */;
    case 27:
    case "RESTORE_LWOD_LISTING_AGREEMENT_SIGNED":
      return 27 /* RESTORE_LWOD_LISTING_AGREEMENT_SIGNED */;
    case 28:
    case "AGENT_LED_OFFER_DROPOUT":
      return 28 /* AGENT_LED_OFFER_DROPOUT */;
    case 29:
    case "AGENT_LED_OFFERS_REACTIVATE":
      return 29 /* AGENT_LED_OFFERS_REACTIVATE */;
    case 30:
    case "AGENT_LED_OFFER_AUTO_REFRESH":
      return 30 /* AGENT_LED_OFFER_AUTO_REFRESH */;
    case 31:
    case "AUTOMATED_MSRE_REFRESH_OFFER":
      return 31 /* AUTOMATED_MSRE_REFRESH_OFFER */;
    case 32:
    case "OUTBOUND_OFFERS_UNDERWRITTEN":
      return 32 /* OUTBOUND_OFFERS_UNDERWRITTEN */;
    case 33:
    case "REFRESH_ASSESSMENT_COMPLETED":
      return 33 /* REFRESH_ASSESSMENT_COMPLETED */;
    case -1:
    case "UNRECOGNIZED":
    default:
      return -1 /* UNRECOGNIZED */;
  }
}
function offerRequest_SourceToJSON(object) {
  switch (object) {
    case 0 /* UNKNOWN_OFFER_SOURCE */:
      return "UNKNOWN_OFFER_SOURCE";
    case 1 /* REFRESH_ADMIN */:
      return "REFRESH_ADMIN";
    case 2 /* REFRESH_OFFER_DASHBOARD */:
      return "REFRESH_OFFER_DASHBOARD";
    case 3 /* REFRESH_BROKERAGE_OFFER_DASHBOARD */:
      return "REFRESH_BROKERAGE_OFFER_DASHBOARD";
    case 4 /* REFRESH_SELLER_FEEDBACK */:
      return "REFRESH_SELLER_FEEDBACK";
    case 5 /* REFRESH_REENGAGEMENT_EMAILS */:
      return "REFRESH_REENGAGEMENT_EMAILS";
    case 6 /* REFRESH_CORRECTED_SQ_FT_DATA */:
      return "REFRESH_CORRECTED_SQ_FT_DATA";
    case 7 /* INITIAL_LEAD_FLOW */:
      return "INITIAL_LEAD_FLOW";
    case 8 /* INCOMPLETE_INITIAL_LEAD_FLOW */:
      return "INCOMPLETE_INITIAL_LEAD_FLOW";
    case 9 /* OFFER_REENGAGEMENT_CAMPAIGN */:
      return "OFFER_REENGAGEMENT_CAMPAIGN";
    case 10 /* AUTOMATED_REENGAGEMENT_OFFER */:
      return "AUTOMATED_REENGAGEMENT_OFFER";
    case 11 /* MOBILE_APP */:
      return "MOBILE_APP";
    case 12 /* REIT_BULK_REQUEST */:
      return "REIT_BULK_REQUEST";
    case 13 /* OFFER_REVIEW */:
      return "OFFER_REVIEW";
    case 14 /* FLYWHEEL */:
      return "FLYWHEEL";
    case 15 /* EMAIL_PROSPECTING */:
      return "EMAIL_PROSPECTING";
    case 16 /* OUTBOUND_OFFERS_LISTED */:
      return "OUTBOUND_OFFERS_LISTED";
    case 17 /* REFRESH_PARTNER_REFERRAL */:
      return "REFRESH_PARTNER_REFERRAL";
    case 18 /* HOME_RESERVE */:
      return "HOME_RESERVE";
    case 19 /* HOMEPAGE_RETURN_EXPERIENCE */:
      return "HOMEPAGE_RETURN_EXPERIENCE";
    case 20 /* REFRESH_HOME_DETAILS */:
      return "REFRESH_HOME_DETAILS";
    case 21 /* REFRESH_FROM_ENG */:
      return "REFRESH_FROM_ENG";
    case 22 /* REFRESH_PARTNER_CTA */:
      return "REFRESH_PARTNER_CTA";
    case 23 /* RETURN_TO_HUB_AUTO_REFRESH */:
      return "RETURN_TO_HUB_AUTO_REFRESH";
    case 24 /* EXCLUSIVE_OFFERS */:
      return "EXCLUSIVE_OFFERS";
    case 25 /* REFRESH_PREVIOUSLY_DENIED */:
      return "REFRESH_PREVIOUSLY_DENIED";
    case 26 /* AUTOMATED_AGENT_REENGAGEMENT_OFFER */:
      return "AUTOMATED_AGENT_REENGAGEMENT_OFFER";
    case 27 /* RESTORE_LWOD_LISTING_AGREEMENT_SIGNED */:
      return "RESTORE_LWOD_LISTING_AGREEMENT_SIGNED";
    case 28 /* AGENT_LED_OFFER_DROPOUT */:
      return "AGENT_LED_OFFER_DROPOUT";
    case 29 /* AGENT_LED_OFFERS_REACTIVATE */:
      return "AGENT_LED_OFFERS_REACTIVATE";
    case 30 /* AGENT_LED_OFFER_AUTO_REFRESH */:
      return "AGENT_LED_OFFER_AUTO_REFRESH";
    case 31 /* AUTOMATED_MSRE_REFRESH_OFFER */:
      return "AUTOMATED_MSRE_REFRESH_OFFER";
    case 32 /* OUTBOUND_OFFERS_UNDERWRITTEN */:
      return "OUTBOUND_OFFERS_UNDERWRITTEN";
    case 33 /* REFRESH_ASSESSMENT_COMPLETED */:
      return "REFRESH_ASSESSMENT_COMPLETED";
    case -1 /* UNRECOGNIZED */:
    default:
      return "UNRECOGNIZED";
  }
}

// src/__generated__/protobuf/journey/data/contexts.ts
function createBaseCampaignContext() {
  return {
    utmSource: void 0,
    utmMedium: void 0,
    utmCampaign: void 0,
    utmTerm: void 0,
    utmContent: void 0,
    utmAdgid: void 0,
    utmNtwk: void 0,
    utmSubsite: void 0,
    utmCta: void 0,
    utmExternalid: void 0,
    utmGeo: void 0,
    utmCat: void 0
  };
}
var CampaignContext = {
  fromJSON(object) {
    return {
      utmSource: isSet3(object.utmSource) ? String(object.utmSource) : void 0,
      utmMedium: isSet3(object.utmMedium) ? String(object.utmMedium) : void 0,
      utmCampaign: isSet3(object.utmCampaign) ? String(object.utmCampaign) : void 0,
      utmTerm: isSet3(object.utmTerm) ? String(object.utmTerm) : void 0,
      utmContent: isSet3(object.utmContent) ? String(object.utmContent) : void 0,
      utmAdgid: isSet3(object.utmAdgid) ? String(object.utmAdgid) : void 0,
      utmNtwk: isSet3(object.utmNtwk) ? String(object.utmNtwk) : void 0,
      utmSubsite: isSet3(object.utmSubsite) ? String(object.utmSubsite) : void 0,
      utmCta: isSet3(object.utmCta) ? String(object.utmCta) : void 0,
      utmExternalid: isSet3(object.utmExternalid) ? String(object.utmExternalid) : void 0,
      utmGeo: isSet3(object.utmGeo) ? String(object.utmGeo) : void 0,
      utmCat: isSet3(object.utmCat) ? String(object.utmCat) : void 0
    };
  },
  toJSON(message) {
    const obj = {};
    if (message.utmSource !== void 0) {
      obj.utmSource = message.utmSource;
    }
    if (message.utmMedium !== void 0) {
      obj.utmMedium = message.utmMedium;
    }
    if (message.utmCampaign !== void 0) {
      obj.utmCampaign = message.utmCampaign;
    }
    if (message.utmTerm !== void 0) {
      obj.utmTerm = message.utmTerm;
    }
    if (message.utmContent !== void 0) {
      obj.utmContent = message.utmContent;
    }
    if (message.utmAdgid !== void 0) {
      obj.utmAdgid = message.utmAdgid;
    }
    if (message.utmNtwk !== void 0) {
      obj.utmNtwk = message.utmNtwk;
    }
    if (message.utmSubsite !== void 0) {
      obj.utmSubsite = message.utmSubsite;
    }
    if (message.utmCta !== void 0) {
      obj.utmCta = message.utmCta;
    }
    if (message.utmExternalid !== void 0) {
      obj.utmExternalid = message.utmExternalid;
    }
    if (message.utmGeo !== void 0) {
      obj.utmGeo = message.utmGeo;
    }
    if (message.utmCat !== void 0) {
      obj.utmCat = message.utmCat;
    }
    return obj;
  },
  create(base) {
    return CampaignContext.fromPartial(base ?? {});
  },
  fromPartial(object) {
    const message = createBaseCampaignContext();
    message.utmSource = object.utmSource ?? void 0;
    message.utmMedium = object.utmMedium ?? void 0;
    message.utmCampaign = object.utmCampaign ?? void 0;
    message.utmTerm = object.utmTerm ?? void 0;
    message.utmContent = object.utmContent ?? void 0;
    message.utmAdgid = object.utmAdgid ?? void 0;
    message.utmNtwk = object.utmNtwk ?? void 0;
    message.utmSubsite = object.utmSubsite ?? void 0;
    message.utmCta = object.utmCta ?? void 0;
    message.utmExternalid = object.utmExternalid ?? void 0;
    message.utmGeo = object.utmGeo ?? void 0;
    message.utmCat = object.utmCat ?? void 0;
    return message;
  }
};
function createBaseCustomerContext() {
  return {
    customerUuid: "",
    firstName: void 0,
    lastName: void 0,
    primaryEmail: void 0,
    primaryPhone: void 0
  };
}
var CustomerContext = {
  fromJSON(object) {
    return {
      customerUuid: isSet3(object.customerUuid) ? String(object.customerUuid) : "",
      firstName: isSet3(object.firstName) ? String(object.firstName) : void 0,
      lastName: isSet3(object.lastName) ? String(object.lastName) : void 0,
      primaryEmail: isSet3(object.primaryEmail) ? String(object.primaryEmail) : void 0,
      primaryPhone: isSet3(object.primaryPhone) ? String(object.primaryPhone) : void 0
    };
  },
  toJSON(message) {
    const obj = {};
    if (message.customerUuid !== "") {
      obj.customerUuid = message.customerUuid;
    }
    if (message.firstName !== void 0) {
      obj.firstName = message.firstName;
    }
    if (message.lastName !== void 0) {
      obj.lastName = message.lastName;
    }
    if (message.primaryEmail !== void 0) {
      obj.primaryEmail = message.primaryEmail;
    }
    if (message.primaryPhone !== void 0) {
      obj.primaryPhone = message.primaryPhone;
    }
    return obj;
  },
  create(base) {
    return CustomerContext.fromPartial(base ?? {});
  },
  fromPartial(object) {
    const message = createBaseCustomerContext();
    message.customerUuid = object.customerUuid ?? "";
    message.firstName = object.firstName ?? void 0;
    message.lastName = object.lastName ?? void 0;
    message.primaryEmail = object.primaryEmail ?? void 0;
    message.primaryPhone = object.primaryPhone ?? void 0;
    return message;
  }
};
function createBaseExclusiveOffersContext() {
  return {
    offerBlurPricing: void 0,
    offerRangeMax: void 0,
    offerRangeMin: void 0,
    potentialBuyerCount: void 0,
    allPhotoCount: void 0,
    internalPhotoCount: void 0,
    mlsPhotoCount: void 0
  };
}
var ExclusiveOffersContext = {
  fromJSON(object) {
    return {
      offerBlurPricing: isSet3(object.offerBlurPricing) ? Boolean(object.offerBlurPricing) : void 0,
      offerRangeMax: isSet3(object.offerRangeMax) ? Number(object.offerRangeMax) : void 0,
      offerRangeMin: isSet3(object.offerRangeMin) ? Number(object.offerRangeMin) : void 0,
      potentialBuyerCount: isSet3(object.potentialBuyerCount) ? Number(object.potentialBuyerCount) : void 0,
      allPhotoCount: isSet3(object.allPhotoCount) ? Number(object.allPhotoCount) : void 0,
      internalPhotoCount: isSet3(object.internalPhotoCount) ? Number(object.internalPhotoCount) : void 0,
      mlsPhotoCount: isSet3(object.mlsPhotoCount) ? Number(object.mlsPhotoCount) : void 0
    };
  },
  toJSON(message) {
    const obj = {};
    if (message.offerBlurPricing !== void 0) {
      obj.offerBlurPricing = message.offerBlurPricing;
    }
    if (message.offerRangeMax !== void 0) {
      obj.offerRangeMax = message.offerRangeMax;
    }
    if (message.offerRangeMin !== void 0) {
      obj.offerRangeMin = message.offerRangeMin;
    }
    if (message.potentialBuyerCount !== void 0) {
      obj.potentialBuyerCount = message.potentialBuyerCount;
    }
    if (message.allPhotoCount !== void 0) {
      obj.allPhotoCount = message.allPhotoCount;
    }
    if (message.internalPhotoCount !== void 0) {
      obj.internalPhotoCount = message.internalPhotoCount;
    }
    if (message.mlsPhotoCount !== void 0) {
      obj.mlsPhotoCount = message.mlsPhotoCount;
    }
    return obj;
  },
  create(base) {
    return ExclusiveOffersContext.fromPartial(base ?? {});
  },
  fromPartial(object) {
    const message = createBaseExclusiveOffersContext();
    message.offerBlurPricing = object.offerBlurPricing ?? void 0;
    message.offerRangeMax = object.offerRangeMax ?? void 0;
    message.offerRangeMin = object.offerRangeMin ?? void 0;
    message.potentialBuyerCount = object.potentialBuyerCount ?? void 0;
    message.allPhotoCount = object.allPhotoCount ?? void 0;
    message.internalPhotoCount = object.internalPhotoCount ?? void 0;
    message.mlsPhotoCount = object.mlsPhotoCount ?? void 0;
    return message;
  }
};
function createBaseLeadContext() {
  return { sellerInputUuid: void 0, sellerLeadUuid: void 0, sellerLeadMarket: void 0 };
}
var LeadContext = {
  fromJSON(object) {
    return {
      sellerInputUuid: isSet3(object.sellerInputUuid) ? String(object.sellerInputUuid) : void 0,
      sellerLeadUuid: isSet3(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : void 0,
      sellerLeadMarket: isSet3(object.sellerLeadMarket) ? String(object.sellerLeadMarket) : void 0
    };
  },
  toJSON(message) {
    const obj = {};
    if (message.sellerInputUuid !== void 0) {
      obj.sellerInputUuid = message.sellerInputUuid;
    }
    if (message.sellerLeadUuid !== void 0) {
      obj.sellerLeadUuid = message.sellerLeadUuid;
    }
    if (message.sellerLeadMarket !== void 0) {
      obj.sellerLeadMarket = message.sellerLeadMarket;
    }
    return obj;
  },
  create(base) {
    return LeadContext.fromPartial(base ?? {});
  },
  fromPartial(object) {
    const message = createBaseLeadContext();
    message.sellerInputUuid = object.sellerInputUuid ?? void 0;
    message.sellerLeadUuid = object.sellerLeadUuid ?? void 0;
    message.sellerLeadMarket = object.sellerLeadMarket ?? void 0;
    return message;
  }
};
function createBaseSellDirectContext() {
  return {
    offerId: "",
    offerRequestSource: 0,
    offerHeadlinePrice: void 0,
    offerDenialReason: void 0,
    offerState: void 0,
    dwellingType: void 0
  };
}
var SellDirectContext = {
  fromJSON(object) {
    return {
      offerId: isSet3(object.offerId) ? String(object.offerId) : "",
      offerRequestSource: isSet3(object.offerRequestSource) ? offerRequest_SourceFromJSON(object.offerRequestSource) : 0,
      offerHeadlinePrice: isSet3(object.offerHeadlinePrice) ? Number(object.offerHeadlinePrice) : void 0,
      offerDenialReason: isSet3(object.offerDenialReason) ? String(object.offerDenialReason) : void 0,
      offerState: isSet3(object.offerState) ? String(object.offerState) : void 0,
      dwellingType: isSet3(object.dwellingType) ? String(object.dwellingType) : void 0
    };
  },
  toJSON(message) {
    const obj = {};
    if (message.offerId !== "") {
      obj.offerId = message.offerId;
    }
    if (message.offerRequestSource !== 0) {
      obj.offerRequestSource = offerRequest_SourceToJSON(message.offerRequestSource);
    }
    if (message.offerHeadlinePrice !== void 0) {
      obj.offerHeadlinePrice = message.offerHeadlinePrice;
    }
    if (message.offerDenialReason !== void 0) {
      obj.offerDenialReason = message.offerDenialReason;
    }
    if (message.offerState !== void 0) {
      obj.offerState = message.offerState;
    }
    if (message.dwellingType !== void 0) {
      obj.dwellingType = message.dwellingType;
    }
    return obj;
  },
  create(base) {
    return SellDirectContext.fromPartial(base ?? {});
  },
  fromPartial(object) {
    const message = createBaseSellDirectContext();
    message.offerId = object.offerId ?? "";
    message.offerRequestSource = object.offerRequestSource ?? 0;
    message.offerHeadlinePrice = object.offerHeadlinePrice ?? void 0;
    message.offerDenialReason = object.offerDenialReason ?? void 0;
    message.offerState = object.offerState ?? void 0;
    message.dwellingType = object.dwellingType ?? void 0;
    return message;
  }
};
function createBaseAdClickContext() {
  return { fbclid: void 0, ttclid: void 0, gclid: void 0 };
}
var AdClickContext = {
  fromJSON(object) {
    return {
      fbclid: isSet3(object.fbclid) ? String(object.fbclid) : void 0,
      ttclid: isSet3(object.ttclid) ? String(object.ttclid) : void 0,
      gclid: isSet3(object.gclid) ? String(object.gclid) : void 0
    };
  },
  toJSON(message) {
    const obj = {};
    if (message.fbclid !== void 0) {
      obj.fbclid = message.fbclid;
    }
    if (message.ttclid !== void 0) {
      obj.ttclid = message.ttclid;
    }
    if (message.gclid !== void 0) {
      obj.gclid = message.gclid;
    }
    return obj;
  },
  create(base) {
    return AdClickContext.fromPartial(base ?? {});
  },
  fromPartial(object) {
    const message = createBaseAdClickContext();
    message.fbclid = object.fbclid ?? void 0;
    message.ttclid = object.ttclid ?? void 0;
    message.gclid = object.gclid ?? void 0;
    return message;
  }
};
function createBaseAnalyticsContext() {
  return {
    gaClientId: void 0,
    fbBrowserId: void 0,
    fbClickId: void 0,
    gaSessionId: void 0,
    redditBrowserId: void 0,
    tiktokBrowserId: void 0,
    nextdoorClickId: void 0
  };
}
var AnalyticsContext = {
  fromJSON(object) {
    return {
      gaClientId: isSet3(object.gaClientId) ? String(object.gaClientId) : void 0,
      fbBrowserId: isSet3(object.fbBrowserId) ? String(object.fbBrowserId) : void 0,
      fbClickId: isSet3(object.fbClickId) ? String(object.fbClickId) : void 0,
      gaSessionId: isSet3(object.gaSessionId) ? String(object.gaSessionId) : void 0,
      redditBrowserId: isSet3(object.redditBrowserId) ? String(object.redditBrowserId) : void 0,
      tiktokBrowserId: isSet3(object.tiktokBrowserId) ? String(object.tiktokBrowserId) : void 0,
      nextdoorClickId: isSet3(object.nextdoorClickId) ? String(object.nextdoorClickId) : void 0
    };
  },
  toJSON(message) {
    const obj = {};
    if (message.gaClientId !== void 0) {
      obj.gaClientId = message.gaClientId;
    }
    if (message.fbBrowserId !== void 0) {
      obj.fbBrowserId = message.fbBrowserId;
    }
    if (message.fbClickId !== void 0) {
      obj.fbClickId = message.fbClickId;
    }
    if (message.gaSessionId !== void 0) {
      obj.gaSessionId = message.gaSessionId;
    }
    if (message.redditBrowserId !== void 0) {
      obj.redditBrowserId = message.redditBrowserId;
    }
    if (message.tiktokBrowserId !== void 0) {
      obj.tiktokBrowserId = message.tiktokBrowserId;
    }
    if (message.nextdoorClickId !== void 0) {
      obj.nextdoorClickId = message.nextdoorClickId;
    }
    return obj;
  },
  create(base) {
    return AnalyticsContext.fromPartial(base ?? {});
  },
  fromPartial(object) {
    const message = createBaseAnalyticsContext();
    message.gaClientId = object.gaClientId ?? void 0;
    message.fbBrowserId = object.fbBrowserId ?? void 0;
    message.fbClickId = object.fbClickId ?? void 0;
    message.gaSessionId = object.gaSessionId ?? void 0;
    message.redditBrowserId = object.redditBrowserId ?? void 0;
    message.tiktokBrowserId = object.tiktokBrowserId ?? void 0;
    message.nextdoorClickId = object.nextdoorClickId ?? void 0;
    return message;
  }
};
function isSet3(value) {
  return value !== null && value !== void 0;
}

// src/__generated__/protobuf/web/data/sell_direct/sell_direct_event_types.ts
function sellDirectEventTypeFromJSON(object) {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return 0 /* UNKNOWN */;
    case 1:
    case "PRELIM_OFFER_SENT":
      return 1 /* PRELIM_OFFER_SENT */;
    case 2:
    case "FINAL_OFFER_SENT":
      return 2 /* FINAL_OFFER_SENT */;
    case 3:
    case "FINAL_OFFER_VIEWED":
      return 3 /* FINAL_OFFER_VIEWED */;
    case 4:
    case "OFFER_CONTINGENCY_RELEASED":
      return 4 /* OFFER_CONTINGENCY_RELEASED */;
    case 5:
    case "OFFER_CLOSED":
      return 5 /* OFFER_CLOSED */;
    case 6:
    case "OFFER_EXPIRED":
      return 6 /* OFFER_EXPIRED */;
    case 7:
    case "OFFER_WITHDRAWN":
      return 7 /* OFFER_WITHDRAWN */;
    case -1:
    case "UNRECOGNIZED":
    default:
      return -1 /* UNRECOGNIZED */;
  }
}
function sellDirectEventTypeToJSON(object) {
  switch (object) {
    case 0 /* UNKNOWN */:
      return "UNKNOWN";
    case 1 /* PRELIM_OFFER_SENT */:
      return "PRELIM_OFFER_SENT";
    case 2 /* FINAL_OFFER_SENT */:
      return "FINAL_OFFER_SENT";
    case 3 /* FINAL_OFFER_VIEWED */:
      return "FINAL_OFFER_VIEWED";
    case 4 /* OFFER_CONTINGENCY_RELEASED */:
      return "OFFER_CONTINGENCY_RELEASED";
    case 5 /* OFFER_CLOSED */:
      return "OFFER_CLOSED";
    case 6 /* OFFER_EXPIRED */:
      return "OFFER_EXPIRED";
    case 7 /* OFFER_WITHDRAWN */:
      return "OFFER_WITHDRAWN";
    case -1 /* UNRECOGNIZED */:
    default:
      return "UNRECOGNIZED";
  }
}

// src/__generated__/protobuf/journey/data/conversion_events.ts
function createBaseSellDirectConversionEvent() {
  return { conversionEvent: 0 };
}
var SellDirectConversionEvent = {
  fromJSON(object) {
    return { conversionEvent: isSet4(object.conversionEvent) ? sellDirectEventTypeFromJSON(object.conversionEvent) : 0 };
  },
  toJSON(message) {
    const obj = {};
    if (message.conversionEvent !== 0) {
      obj.conversionEvent = sellDirectEventTypeToJSON(message.conversionEvent);
    }
    return obj;
  },
  create(base) {
    return SellDirectConversionEvent.fromPartial(base ?? {});
  },
  fromPartial(object) {
    const message = createBaseSellDirectConversionEvent();
    message.conversionEvent = object.conversionEvent ?? 0;
    return message;
  }
};
function isSet4(value) {
  return value !== null && value !== void 0;
}

// src/__generated__/protobuf/journey/data/user_event.ts
function createBaseUserEvent() {
  return {
    uuid: "",
    timestamp: void 0,
    anonymousId: void 0,
    humanId: void 0,
    source: void 0,
    event: void 0,
    customerContext: void 0,
    campaignContext: void 0,
    exclusiveOffersContext: void 0,
    leadContext: void 0,
    sellDirectContext: void 0,
    adClickContext: void 0,
    analyticsContext: void 0
  };
}
var UserEvent = {
  fromJSON(object) {
    return {
      uuid: isSet5(object.uuid) ? String(object.uuid) : "",
      timestamp: isSet5(object.timestamp) ? fromJsonTimestamp(object.timestamp) : void 0,
      anonymousId: isSet5(object.anonymousId) ? String(object.anonymousId) : void 0,
      humanId: isSet5(object.humanId) ? String(object.humanId) : void 0,
      source: isSet5(object.websiteSource) ? { $case: "websiteSource", websiteSource: WebsiteSource.fromJSON(object.websiteSource) } : isSet5(object.mobileSource) ? { $case: "mobileSource", mobileSource: MobileSource.fromJSON(object.mobileSource) } : isSet5(object.backendSource) ? { $case: "backendSource", backendSource: BackendSource.fromJSON(object.backendSource) } : void 0,
      event: isSet5(object.sellDirectConversionEvent) ? {
        $case: "sellDirectConversionEvent",
        sellDirectConversionEvent: SellDirectConversionEvent.fromJSON(object.sellDirectConversionEvent)
      } : void 0,
      customerContext: isSet5(object.customerContext) ? CustomerContext.fromJSON(object.customerContext) : void 0,
      campaignContext: isSet5(object.campaignContext) ? CampaignContext.fromJSON(object.campaignContext) : void 0,
      exclusiveOffersContext: isSet5(object.exclusiveOffersContext) ? ExclusiveOffersContext.fromJSON(object.exclusiveOffersContext) : void 0,
      leadContext: isSet5(object.leadContext) ? LeadContext.fromJSON(object.leadContext) : void 0,
      sellDirectContext: isSet5(object.sellDirectContext) ? SellDirectContext.fromJSON(object.sellDirectContext) : void 0,
      adClickContext: isSet5(object.adClickContext) ? AdClickContext.fromJSON(object.adClickContext) : void 0,
      analyticsContext: isSet5(object.analyticsContext) ? AnalyticsContext.fromJSON(object.analyticsContext) : void 0
    };
  },
  toJSON(message) {
    var _a, _b, _c, _d;
    const obj = {};
    if (message.uuid !== "") {
      obj.uuid = message.uuid;
    }
    if (message.timestamp !== void 0) {
      obj.timestamp = message.timestamp.toISOString();
    }
    if (message.anonymousId !== void 0) {
      obj.anonymousId = message.anonymousId;
    }
    if (message.humanId !== void 0) {
      obj.humanId = message.humanId;
    }
    if (((_a = message.source) == null ? void 0 : _a.$case) === "websiteSource") {
      obj.websiteSource = WebsiteSource.toJSON(message.source.websiteSource);
    }
    if (((_b = message.source) == null ? void 0 : _b.$case) === "mobileSource") {
      obj.mobileSource = MobileSource.toJSON(message.source.mobileSource);
    }
    if (((_c = message.source) == null ? void 0 : _c.$case) === "backendSource") {
      obj.backendSource = BackendSource.toJSON(message.source.backendSource);
    }
    if (((_d = message.event) == null ? void 0 : _d.$case) === "sellDirectConversionEvent") {
      obj.sellDirectConversionEvent = SellDirectConversionEvent.toJSON(message.event.sellDirectConversionEvent);
    }
    if (message.customerContext !== void 0) {
      obj.customerContext = CustomerContext.toJSON(message.customerContext);
    }
    if (message.campaignContext !== void 0) {
      obj.campaignContext = CampaignContext.toJSON(message.campaignContext);
    }
    if (message.exclusiveOffersContext !== void 0) {
      obj.exclusiveOffersContext = ExclusiveOffersContext.toJSON(message.exclusiveOffersContext);
    }
    if (message.leadContext !== void 0) {
      obj.leadContext = LeadContext.toJSON(message.leadContext);
    }
    if (message.sellDirectContext !== void 0) {
      obj.sellDirectContext = SellDirectContext.toJSON(message.sellDirectContext);
    }
    if (message.adClickContext !== void 0) {
      obj.adClickContext = AdClickContext.toJSON(message.adClickContext);
    }
    if (message.analyticsContext !== void 0) {
      obj.analyticsContext = AnalyticsContext.toJSON(message.analyticsContext);
    }
    return obj;
  },
  create(base) {
    return UserEvent.fromPartial(base ?? {});
  },
  fromPartial(object) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
    const message = createBaseUserEvent();
    message.uuid = object.uuid ?? "";
    message.timestamp = object.timestamp ?? void 0;
    message.anonymousId = object.anonymousId ?? void 0;
    message.humanId = object.humanId ?? void 0;
    if (((_a = object.source) == null ? void 0 : _a.$case) === "websiteSource" && ((_b = object.source) == null ? void 0 : _b.websiteSource) !== void 0 && ((_c = object.source) == null ? void 0 : _c.websiteSource) !== null) {
      message.source = {
        $case: "websiteSource",
        websiteSource: WebsiteSource.fromPartial(object.source.websiteSource)
      };
    }
    if (((_d = object.source) == null ? void 0 : _d.$case) === "mobileSource" && ((_e = object.source) == null ? void 0 : _e.mobileSource) !== void 0 && ((_f = object.source) == null ? void 0 : _f.mobileSource) !== null) {
      message.source = { $case: "mobileSource", mobileSource: MobileSource.fromPartial(object.source.mobileSource) };
    }
    if (((_g = object.source) == null ? void 0 : _g.$case) === "backendSource" && ((_h = object.source) == null ? void 0 : _h.backendSource) !== void 0 && ((_i = object.source) == null ? void 0 : _i.backendSource) !== null) {
      message.source = {
        $case: "backendSource",
        backendSource: BackendSource.fromPartial(object.source.backendSource)
      };
    }
    if (((_j = object.event) == null ? void 0 : _j.$case) === "sellDirectConversionEvent" && ((_k = object.event) == null ? void 0 : _k.sellDirectConversionEvent) !== void 0 && ((_l = object.event) == null ? void 0 : _l.sellDirectConversionEvent) !== null) {
      message.event = {
        $case: "sellDirectConversionEvent",
        sellDirectConversionEvent: SellDirectConversionEvent.fromPartial(object.event.sellDirectConversionEvent)
      };
    }
    message.customerContext = object.customerContext !== void 0 && object.customerContext !== null ? CustomerContext.fromPartial(object.customerContext) : void 0;
    message.campaignContext = object.campaignContext !== void 0 && object.campaignContext !== null ? CampaignContext.fromPartial(object.campaignContext) : void 0;
    message.exclusiveOffersContext = object.exclusiveOffersContext !== void 0 && object.exclusiveOffersContext !== null ? ExclusiveOffersContext.fromPartial(object.exclusiveOffersContext) : void 0;
    message.leadContext = object.leadContext !== void 0 && object.leadContext !== null ? LeadContext.fromPartial(object.leadContext) : void 0;
    message.sellDirectContext = object.sellDirectContext !== void 0 && object.sellDirectContext !== null ? SellDirectContext.fromPartial(object.sellDirectContext) : void 0;
    message.adClickContext = object.adClickContext !== void 0 && object.adClickContext !== null ? AdClickContext.fromPartial(object.adClickContext) : void 0;
    message.analyticsContext = object.analyticsContext !== void 0 && object.analyticsContext !== null ? AnalyticsContext.fromPartial(object.analyticsContext) : void 0;
    return message;
  }
};
function fromTimestamp(t) {
  let millis = (t.seconds || 0) * 1e3;
  millis += (t.nanos || 0) / 1e6;
  return new Date(millis);
}
function fromJsonTimestamp(o) {
  if (o instanceof Date) {
    return o;
  } else if (typeof o === "string") {
    return new Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}
function isSet5(value) {
  return value !== null && value !== void 0;
}

// src/internal/journey.ts
var BASE_JOURNEY_ENDPOINT = getDeployEnv() === "production" ? "https://journey.apps.opendoor.com/_journey/api/v1" : "https://journey.apps-staging.opendoor.com/_journey/api/v1";
var getJourneyEndpoint = (journeyEndpoint) => {
  if (journeyEndpoint) {
    return `${journeyEndpoint}/events`;
  } else {
    trackErrorInDatadog("the old journey endpoint is still being used", void 0, {
      data: {
        location: "observability"
      }
    });
    return `${BASE_JOURNEY_ENDPOINT}/events`;
  }
};
function initJourney(journeyEndpoint, batchInterval = 5e3) {
  if (typeof window === "undefined") {
    return {};
  }
  const userEventClient = new JourneyClientImpl({
    batchInterval,
    journeyEndpoint: `${BASE_JOURNEY_ENDPOINT}/user_event_batch`,
    jsonKey: "userEvents",
    maxNumRequest: 10
  });
  userEventClient.start();
  const eventWrapperClient = new JourneyClientImpl({
    batchInterval,
    journeyEndpoint: getJourneyEndpoint(journeyEndpoint),
    jsonKey: "eventWrappers",
    maxNumRequest: 20
  });
  eventWrapperClient.start();
  window.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") {
      userEventClient == null ? void 0 : userEventClient.send();
      eventWrapperClient == null ? void 0 : eventWrapperClient.send();
    }
  });
  window.addEventListener("beforeunload", () => {
    userEventClient == null ? void 0 : userEventClient.send();
    eventWrapperClient == null ? void 0 : eventWrapperClient.send();
  });
  return {
    userClient: userEventClient,
    eventClient: eventWrapperClient
  };
}
var getWebsiteSource = (overrides) => {
  let url = "";
  let language = [];
  let userAgent = "";
  let host = "";
  let pathname = "";
  let queryMap = {};
  let screen = void 0;
  let proxyPath = (overrides == null ? void 0 : overrides.proxyPath) ?? void 0;
  let proxyQueryMap = (overrides == null ? void 0 : overrides.proxyQueryMap) ?? {};
  let referrer = (overrides == null ? void 0 : overrides.referrer) ?? void 0;
  if (typeof window !== "undefined") {
    url = window.location.href;
    userAgent = typeof navigator !== "undefined" ? navigator.userAgent : "";
    language = typeof navigator !== "undefined" ? [...navigator.languages] : [];
    host = window.location.host;
    pathname = window.location.pathname;
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.forEach((value, key) => {
      queryMap[key] = queryMap[key] ? `${queryMap[key]},${value}` : value;
    });
    screen = {
      width: window.innerWidth,
      height: window.innerHeight,
      density: window.devicePixelRatio
    };
  }
  return {
    url,
    userAgent,
    host,
    pathname,
    queryMap,
    eventOrigin: 2 /* CLIENT */,
    proxyQueryMap,
    referrer,
    proxyPath,
    screen,
    language,
    isWebview: false
    // Gets overridden in Journey Service for http events based on the user agent
  };
};
var trackUserEventInJourney = (userEvent, contextualData) => {
  var _a, _b, _c;
  const anonymousId = getAnonymousID();
  const websiteSource = getWebsiteSource();
  const event = { $case: Object.keys(userEvent)[0], ...userEvent };
  if (!anonymousId) {
    trackErrorInDatadog("ajs_anonymous_id is empty or undefined", void 0, {
      data: {
        location: "observability",
        anonymousId,
        event
      }
    });
  }
  const protobufUserEvent = {
    uuid: "",
    // journey generates this
    timestamp: /* @__PURE__ */ new Date(),
    anonymousId,
    humanId: (_a = contextualData.user) == null ? void 0 : _a.humanID,
    // extend when we add mobile
    source: {
      $case: "websiteSource",
      websiteSource
    },
    event,
    adClickContext: contextualData.adClickContext,
    campaignContext: contextualData.campaignContext,
    customerContext: contextualData.customerContext,
    exclusiveOffersContext: contextualData.exclusiveOffersContext,
    leadContext: contextualData.leadContext,
    sellDirectContext: contextualData.sellDirectContext
  };
  (_c = (_b = globalObservability.getJourneyUserClient()).enqueue) == null ? void 0 : _c.call(_b, JSON.stringify(UserEvent.toJSON(protobufUserEvent)));
};
var getAnalyticsCookieData = () => {
  if (typeof document === "undefined") {
    return {};
  }
  const cookies = document.cookie.split(";").reduce((acc, cookie) => {
    const [key, value] = cookie.trim().split("=");
    if (key && value) {
      acc[key] = value;
    }
    return acc;
  }, {});
  const analyticsContext = {};
  if (cookies["_fbp"]) {
    analyticsContext.fbBrowserId = cookies["_fbp"];
  }
  if (cookies["_fbc"]) {
    analyticsContext.fbClickId = cookies["_fbc"];
  }
  if (cookies["_rdt_uuid"]) {
    analyticsContext.redditBrowserId = cookies["_rdt_uuid"];
  }
  if (cookies["_ttp"]) {
    analyticsContext.tiktokBrowserId = cookies["_ttp"];
  }
  const ndclidCookie = cookies["ndclid"];
  if (ndclidCookie) {
    analyticsContext.nextdoorClickId = ndclidCookie;
  }
  return analyticsContext;
};
var trackJourneyEventInJourney = (event, contextualData, journeyEventHelpers, sendJourneyEventsInDev, clientEventId) => {
  var _a, _b, _c;
  const anonymousId = getAnonymousID();
  const websiteSource = getWebsiteSource(contextualData.websiteSourceContext);
  if (!anonymousId) {
    if (sendJourneyEventsInDev) {
      console.log(
        "Please copy your odAuthAid cookie value and set it as the ajs_anonymous_id cookie value for your localhost to send journey events"
      );
    } else {
      trackErrorInDatadog("ajs_anonymous_id is empty or undefined", void 0, {
        data: {
          location: "observability",
          anonymousId,
          event
        }
      });
    }
  }
  const analyticsCookieData = getAnalyticsCookieData();
  const protobufJourneyEvent = {
    timestamp: /* @__PURE__ */ new Date(),
    source: {
      $case: "websiteSource",
      websiteSource
    },
    anonymousId,
    customerUuid: (_a = contextualData.customerContext) == null ? void 0 : _a.customerUuid,
    campaignContext: contextualData.campaignContext,
    category: event.category,
    analyticsContext: Object.keys(analyticsCookieData).length > 0 ? analyticsCookieData : void 0,
    clientEventId
  };
  const json = JSON.stringify(journeyEventHelpers.toJSON(protobufJourneyEvent));
  (_c = (_b = globalObservability.getJourneyEventClient()).enqueue) == null ? void 0 : _c.call(_b, json);
};
var getAnonymousID = () => {
  let anonymousID = js_cookie.get("ajs_anonymous_id");
  if (!anonymousID) {
    return void 0;
  }
  return anonymousID;
};
var MAX_PAYLOAD_SIZE = 512;
function computeSizeInKilobytes(buffer) {
  const size = buffer.map((s) => s.length).reduce((prev, cur) => prev + cur, 0);
  return size / 1024;
}
function isApproachingBatchAPILimit(buffer) {
  return computeSizeInKilobytes(buffer) >= MAX_PAYLOAD_SIZE - 50;
}
var fetchWithRetry = async (url, init) => {
  var _a, _b;
  let retries = 5;
  const retryDelay = 500;
  let response = void 0;
  while (retries > 0) {
    try {
      response = await fetch(url, init);
      const statusCode = response.status;
      if (statusCode === 202) {
        return;
      }
      if (statusCode >= 500 && retries >= 1) {
        await new Promise((r) => setTimeout(r, retryDelay));
        retries = retries - 1;
      } else {
        break;
      }
    } catch (err) {
      if (retries >= 1) {
        await new Promise((r) => setTimeout(r, retryDelay));
        retries = retries - 1;
      }
    }
  }
  if ((_a = init.headers) == null ? void 0 : _a.toString().includes("Puppeteer")) {
    return;
  }
  const sentry = globalObservability.getSentryClient();
  (_b = sentry.withScope) == null ? void 0 : _b.call(sentry, (scope) => {
    var _a2;
    scope.setExtra("body", init.body);
    (_a2 = sentry.captureException) == null ? void 0 : _a2.call(
      sentry,
      `failed to track events in journey,statusCode: ${response == null ? void 0 : response.status}, response available: ${!!response}`
    );
  });
};
var JourneyClientImpl = class {
  buffer;
  batchInterval;
  journeyEndpoint;
  jsonKey;
  maxNumRequest;
  timer;
  constructor({ batchInterval, journeyEndpoint, jsonKey, maxNumRequest }) {
    this.buffer = [];
    this.batchInterval = batchInterval;
    this.journeyEndpoint = journeyEndpoint;
    this.jsonKey = jsonKey;
    this.maxNumRequest = maxNumRequest;
  }
  start() {
    this.timer = setInterval(() => this.send(), this.batchInterval);
  }
  stop() {
    this.timer && clearInterval(this.timer);
  }
  send() {
    if (this.buffer.length === 0) {
      return;
    }
    fetchWithRetry(this.journeyEndpoint, {
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "X-Journey-Client-Name": "observability",
        "X-Journey-Client-Version": "1.0"
      },
      // Using keepalive:true ensures that the request is made even if the page is being unloaded.
      // There are actually benefits to using keep-alive true: https://www.stackpath.com/edge-academy/what-is-keep-alive/
      keepalive: true,
      method: "POST",
      body: `{"${this.jsonKey}":[${this.buffer.join(",")}]}`
    });
    this.buffer = [];
  }
  enqueue(json) {
    this.buffer.push(json);
    if (this.buffer.length >= this.maxNumRequest || isApproachingBatchAPILimit(this.buffer)) {
      this.send();
    }
  }
};

// src/internal/segment.ts
var SEGMENT_METHODS = [
  "trackSubmit",
  "trackClick",
  "trackLink",
  "trackForm",
  "pageview",
  "identify",
  "reset",
  "group",
  "track",
  "ready",
  "alias",
  "debug",
  "page",
  "once",
  "off",
  "on",
  "addSourceMiddleware",
  "addIntegrationMiddleware",
  "setAnonymousId",
  "addDestinationMiddleware"
];
var RESET_PASSWORD_TOKEN_REGEX = /reset_password_token=[a-zA-Z0-9_\-.]+?(?=&|$)/;
var ACCESS_TOKEN_REGEX = /access_token=[a-zA-Z0-9_\-.]+?(?=&|$)/;
if (typeof window !== "undefined") {
  const segment = [];
  window.analytics = window.analytics || segment;
  segment.factory = function(method) {
    return function() {
      var args = Array.prototype.slice.call(arguments);
      args.unshift(method);
      segment.push(args);
      return segment;
    };
  };
  for (i = 0; i < SEGMENT_METHODS.length; i++) {
    key = SEGMENT_METHODS[i];
    segment[key] = segment.factory(key);
  }
  segment.SNIPPET_VERSION = "4.15.2";
  segment._loadOptions = { user: { localStorageFallbackDisabled: true } };
  segment.page({
    url: window.location.href.replace(RESET_PASSWORD_TOKEN_REGEX, "reset_password_token=REDACTED").replace(ACCESS_TOKEN_REGEX, "access_token=REDACTED"),
    search: window.location.search.replace(RESET_PASSWORD_TOKEN_REGEX, "reset_password_token=REDACTED").replace(ACCESS_TOKEN_REGEX, "access_token=REDACTED")
  });
}
var key;
var i;
var segmentWrapper = {};
SEGMENT_METHODS.forEach((methodName) => {
  segmentWrapper[methodName] = async function(...args) {
    var _a, _b, _c, _d, _e;
    try {
      await window.analytics[methodName](...args);
    } catch (e) {
      let error = new Error("Error sending to Segment");
      let extraErrorData = {
        method: methodName
      };
      if (methodName === "track") {
        error = new Error("Failed to send Segment Event or Error");
        extraErrorData["event"] = args[0];
        extraErrorData["value"] = (_a = args[1]) == null ? void 0 : _a.value;
        extraErrorData["team"] = ((_b = args[1]) == null ? void 0 : _b.team) || "";
        extraErrorData["pathname"] = ((_c = args[1]) == null ? void 0 : _c.pathname) || "";
      }
      (_e = (_d = globalObservability.getSentryClient()).withScope) == null ? void 0 : _e.call(_d, (scope) => {
        var _a2, _b2;
        scope.setExtras({
          error: e,
          ...extraErrorData
        });
        (_b2 = (_a2 = globalObservability.getSentryClient()).captureException) == null ? void 0 : _b2.call(_a2, error);
      });
    }
  };
});
var loadSegment = (key, lazyLoad) => {
  const injectScript = () => {
    var script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    if (key) {
      script.src = ("https:" === document.location.protocol ? "https://" : "http://") + "trkcdn.opendoor.com/analytics.js/v1/" + key + "/analytics.min.js";
    } else {
      script.src = ("https:" === document.location.protocol ? "https://" : "http://") + (getDeployEnv() === "production" ? "www.opendoor.com" : "demo.simplersell.com") + "/_scripts/sgm.min.js";
    }
    var first = document.getElementsByTagName("script")[0];
    first.parentNode.insertBefore(script, first);
  };
  if (lazyLoad) {
    window.addEventListener("load", injectScript);
  } else {
    injectScript();
  }
};
var segment_default = segmentWrapper;

// src/constants.ts
var UTM_MEDIUM = "utm_medium";
var UTM_SOURCE = "utm_source";
var UTM_CAMPAIGN = "utm_campaign";
var UTM_CONTENT = "utm_content";
var UTM_TERM = "utm_term";
var UTM_ADGID = "utm_adgid";
var UTM_NTWK = "utm_ntwk";
var UTM_SUBSITE = "utm_subsite";
var UTM_CTA = "utm_cta";
var UTM_EXTERNALID = "utm_externalid";
var UTM_GEO = "utm_geo";
var UTM_CAT = "utm_cat";

// src/devtools-events.ts
var subscribers = /* @__PURE__ */ new Set();
var MAX_BUFFERED_EVENTS = 500;
var eventBuffer = [];
function subscribeToDevtoolsEvents(callback) {
  eventBuffer.forEach((event) => callback(event));
  subscribers.add(callback);
  return () => subscribers.delete(callback);
}
function emitDevtoolsEvent(event) {
  eventBuffer.push(event);
  if (eventBuffer.length > MAX_BUFFERED_EVENTS) {
    eventBuffer.shift();
  }
  subscribers.forEach((callback) => callback(event));
}

// src/internal/analytics.ts
var analytics_exports = {};
__export(analytics_exports, {
  register: () => register,
  registerWithUserID: () => registerWithUserID,
  trackEvent: () => trackEvent,
  trackPageView: () => trackPageView
});

// src/internal/isQuotaExceededError.ts
var isQuotaExceededError = (e) => {
  let quotaExceeded = false;
  if (e) {
    if (e.code) {
      switch (e.code) {
        case 22:
          quotaExceeded = true;
          break;
        case 1014:
          if (e.name === "NS_ERROR_DOM_QUOTA_REACHED") {
            quotaExceeded = true;
          }
          break;
        default:
          break;
      }
    } else if (e.number === -2147024882) {
      quotaExceeded = true;
    }
  }
  return quotaExceeded;
};

// src/internal/analytics.ts
var LOG_LEVEL_CONFIG_NAME = "opendoor_log_level";
var log = (..._args) => {
  if (typeof window !== "undefined" && window.localStorage.getItem(LOG_LEVEL_CONFIG_NAME) === "true") {
    console.log(..._args);
  }
};
var wrapQuotaError = (cb) => {
  var _a, _b;
  try {
    cb();
  } catch (e) {
    if (!isQuotaExceededError(e)) {
      (_b = (_a = globalObservability.getSentryClient()).captureException) == null ? void 0 : _b.call(_a, e);
    }
  }
};
var register = (traits) => {
  if (typeof ga === "function" && typeof traits === "object") {
    ga("set", traits);
  }
  segment_default.identify(traits);
  if (getDeployEnv() !== "production") {
    log(`[DEBUG] Analytics.register: 
${JSON.stringify(traits, null, 2)}`);
  }
};
var registerWithUserID = (userId, traits) => {
  if (typeof ga === "function" && typeof traits === "object") {
    ga("set", traits);
  }
  segment_default.identify(userId, traits);
  if (getDeployEnv() !== "production") {
    log(`[DEBUG] Analytics.register: 
${userId} ${JSON.stringify(traits, null, 2)}`);
  }
};
var trackEvent = (category, action, value, extra) => {
  wrapQuotaError(() => {
    if (typeof ga === "function") {
      ga("send", "event", category, action, value, extra);
    }
  });
  wrapQuotaError(() => {
    segment_default.track(`${category}-${action}`, {
      channel: "web",
      domain: window.location.host,
      screen: {
        height: window.screen.height,
        width: window.screen.width
      },
      value,
      ...extra
    });
  });
  wrapQuotaError(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: `${category}.${action}.${value}`, extra });
  });
  if (getDeployEnv() !== "production") {
    log(
      `[DEBUG] Analytics.trackEvent: 
${category}-${action} ${JSON.stringify(
        {
          value,
          ...extra
        },
        null,
        2
      )}`
    );
  }
};
var matchInAppQueryParam = (queryParams) => {
  const fragments = queryParams && queryParams.match(/app\=(\d+)/);
  if (!fragments) {
    return false;
  }
  return !!fragments[1];
};
var trackPageView = (extra) => {
  const location = window.location;
  const pathname = location.pathname;
  const search = location.search;
  trackEvent("page", "view", "page", {
    app: matchInAppQueryParam(search),
    pathname,
    search,
    ...extra
  });
};

// src/internal/gtmEvents.ts
function trackJourneyEventInGTM(categoryName, eventName, clientEventId) {
  if (typeof window === "undefined")
    return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "journey_event",
    journey_category: categoryName,
    journey_event_name: eventName,
    journey_event_id: clientEventId
  });
}

// src/observability-base.ts
var OD_UTM_COOKIE = "od_utm";
function readUtmCookie() {
  if (typeof document === "undefined")
    return void 0;
  try {
    const match = document.cookie.split(";").find((c) => c.trim().startsWith(`${OD_UTM_COOKIE}=`));
    if (!match)
      return void 0;
    const value = match.split("=").slice(1).join("=");
    return CampaignContext.fromJSON(JSON.parse(decodeURIComponent(value.trim())));
  } catch {
    return void 0;
  }
}
var RealObservability = class {
  constructor(eventTrackingCategory, journeyEventHelpers) {
    this.eventTrackingCategory = eventTrackingCategory;
    this.journeyEventHelpers = journeyEventHelpers;
  }
  sentryClient = {};
  datadogRumClient = {};
  journeyUserClient = {};
  journeyEventClient = {};
  setSentryClient(sentryClient) {
    this.sentryClient = sentryClient;
  }
  getSentryClient() {
    return this.sentryClient;
  }
  setJourneyUserClient(journeyClient) {
    this.journeyUserClient = journeyClient;
  }
  setJourneyEventClient(journeyClient) {
    this.journeyEventClient = journeyClient;
  }
  getJourneyUserClient() {
    return this.journeyUserClient;
  }
  getJourneyEventClient() {
    return this.journeyEventClient;
  }
  setDatadogRumClient(datadogRumClient) {
    this.datadogRumClient = datadogRumClient;
  }
  getDatadogRumClient() {
    return this.datadogRumClient;
  }
  /**
   * Updates contextual data to add campaign context from URL search params.
   * When UTMs are in the URL, uses them directly (the CF Worker sets the od_utm cookie server-side).
   * When UTMs are not in the URL, falls back to reading the od_utm cookie.
   * This ensures SPA navigations retain campaign attribution from the landing page.
   */
  updateJourneyContextualData(contextualData = emptyJourneyEventContextualData) {
    if (typeof window !== "undefined") {
      const searchParams = new URLSearchParams(window.location.search);
      const utmParameters = [UTM_MEDIUM, UTM_SOURCE, UTM_CAMPAIGN, UTM_CONTENT, UTM_TERM];
      if (utmParameters.some((param) => searchParams.get(param))) {
        const campaignContext = {
          utmMedium: searchParams.get(UTM_MEDIUM) ?? void 0,
          utmSource: searchParams.get(UTM_SOURCE) ?? void 0,
          utmCampaign: searchParams.get(UTM_CAMPAIGN) ?? void 0,
          utmContent: searchParams.get(UTM_CONTENT) ?? void 0,
          utmTerm: searchParams.get(UTM_TERM) ?? void 0,
          utmAdgid: searchParams.get(UTM_ADGID) ?? void 0,
          utmNtwk: searchParams.get(UTM_NTWK) ?? void 0,
          utmSubsite: searchParams.get(UTM_SUBSITE) ?? void 0,
          utmCta: searchParams.get(UTM_CTA) ?? void 0,
          utmExternalid: searchParams.get(UTM_EXTERNALID) ?? void 0,
          utmGeo: searchParams.get(UTM_GEO) ?? void 0,
          utmCat: searchParams.get(UTM_CAT) ?? void 0
        };
        return { ...contextualData, campaignContext };
      }
      if (!contextualData.campaignContext) {
        const cookieCampaign = readUtmCookie();
        if (cookieCampaign) {
          return { ...contextualData, campaignContext: cookieCampaign };
        }
      }
    }
    return contextualData;
  }
  /**
   * Updates contextual data for non-journey events
   * This will be removed when we remove old versions of tracking data
   */
  updateDeprecatedContextualData(contextualData = emptyContextualData) {
    if (typeof window !== "undefined") {
      const searchParams = new URLSearchParams(window.location.search);
      const utmParameters = [UTM_MEDIUM, UTM_SOURCE, UTM_CAMPAIGN, UTM_CONTENT, UTM_TERM];
      if (utmParameters.some((param) => searchParams.get(param))) {
        const campaignContext = {
          utmMedium: searchParams.get(UTM_MEDIUM) ?? void 0,
          utmSource: searchParams.get(UTM_SOURCE) ?? void 0,
          utmCampaign: searchParams.get(UTM_CAMPAIGN) ?? void 0,
          utmContent: searchParams.get(UTM_CONTENT) ?? void 0,
          utmTerm: searchParams.get(UTM_TERM) ?? void 0
        };
        return {
          ...contextualData,
          campaignContext
        };
      }
    }
    return contextualData;
  }
  /**
   * Track events not performed by a user but meaningful internally. For events performed
   * by a user, use `trackUserEvent`.
   *
   * TODO (@core-experience-platform): rename to `trackInternalEvent`
   */
  trackEvent(action, label, contextualData = emptyContextualData, options) {
    contextualData = this.updateDeprecatedContextualData(contextualData);
    contextualData = mergeContextualData(contextualData, getContextualDataFromDatadog());
    if (getDeployEnv() !== "production") {
      const categoryOverride = (options == null ? void 0 : options.categoryOverride) ? String(options.categoryOverride) : void 0;
      emitDevtoolsEvent({
        type: "trackEvent",
        action: String(action),
        label,
        categoryOverride,
        contextualData
      });
    }
    trackEvent(
      (options == null ? void 0 : options.categoryOverride) ?? this.eventTrackingCategory,
      action,
      label,
      contextualData.data
    );
    trackEventInDatadog(action, label, contextualData);
    trackEventInSentry(action, label, contextualData);
    if (options == null ? void 0 : options.addTiming) {
      trackPerformanceInDatadog(`${this.eventTrackingCategory}-${action}-${label}`);
    }
  }
  /**
   * @deprecated Use trackJourneyEvent instead
   * @see https://opendoor.atlassian.net/wiki/spaces/CONSUMER/pages/2283536444/How+to+Create+Journey+2.0+Events
   */
  trackUserEvent(event, contextualData = emptyContextualData) {
    contextualData = this.updateDeprecatedContextualData(contextualData);
    trackUserEventInJourney(event, contextualData);
    trackUserEventInDatadog(event, contextualData);
    trackUserEventInSentry(event, contextualData);
  }
  trackJourneyEvent(categoryName, eventName, eventData, contextualData = emptyJourneyEventContextualData, options) {
    var _a, _b;
    if (!this.journeyEventHelpers)
      throw new Error(
        "Provide journeyEventHelpers and EventWrapper types in initObservability to use trackJourneyEvent"
      );
    const eventWrapper = {
      category: {
        $case: categoryName,
        [categoryName]: {
          event: {
            $case: eventName,
            [eventName]: eventData
          }
        }
      }
    };
    contextualData = this.updateJourneyContextualData(contextualData);
    if (getDeployEnv() !== "production") {
      emitDevtoolsEvent({
        type: "trackJourneyEvent",
        categoryName: String(categoryName),
        eventName: String(eventName),
        eventData,
        contextualData
      });
    }
    const clientEventId = typeof crypto !== "undefined" && crypto.randomUUID ? crypto.randomUUID() : void 0;
    trackJourneyEventInJourney(
      eventWrapper,
      contextualData,
      this.journeyEventHelpers,
      void 0,
      clientEventId
    );
    if (clientEventId) {
      trackJourneyEventInGTM(String(categoryName), String(eventName), clientEventId);
    }
    trackJourneyEventInDatadog(
      eventWrapper,
      contextualData,
      this.journeyEventHelpers
    );
    trackJourneyEventInSentry(
      eventWrapper,
      contextualData,
      this.journeyEventHelpers
    );
    if (options == null ? void 0 : options.flush) {
      (_b = (_a = globalObservability.getJourneyEventClient()).send) == null ? void 0 : _b.call(_a);
    }
  }
  trackError(label, error, contextualData = emptyContextualData, options) {
    contextualData = this.updateDeprecatedContextualData(contextualData);
    contextualData = mergeContextualData(contextualData, getContextualDataFromDatadog());
    if (!(options == null ? void 0 : options.skipSentry)) {
      const sentryContextualData = trackErrorInSentry(label, error, contextualData);
      contextualData = mergeContextualData(contextualData, sentryContextualData);
    }
    trackErrorInDatadog(label, error, contextualData);
    trackEvent(this.eventTrackingCategory, "error", label, contextualData.data);
    if (options == null ? void 0 : options.addTiming) {
      trackPerformanceInDatadog(`${this.eventTrackingCategory}-error-${label}`);
    }
  }
};
var testonly = {
  initDebugObservability(opts = {}) {
    globalObservability.setCurrentInstance(new DebugObservability({ log: true, ...opts }));
  }
};
function useFakeObservability() {
  return {
    trackJourneyEvent: (categoryName, eventName, eventData) => {
      const eventWrapper = {
        category: {
          $case: categoryName,
          [categoryName]: {
            event: {
              $case: eventName,
              [eventName]: eventData
            }
          }
        }
      };
      console.info(`trackClientJourneyEvent(${JSON.stringify(eventWrapper)})`);
    }
  };
}
var DebugObservability = class {
  constructor(opts = {}, eventTrackingCategory, journeyEventHelpers) {
    this.eventTrackingCategory = eventTrackingCategory;
    this.journeyEventHelpers = journeyEventHelpers;
    this.sentryClient = (opts == null ? void 0 : opts.sentryClient) || {};
    this.journeyUserClient = (opts == null ? void 0 : opts.journeyUserClient) || {};
    this.journeyEventClient = (opts == null ? void 0 : opts.journeyEventClient) || {};
    this.datadogRumClient = (opts == null ? void 0 : opts.datadogRumClient) || {};
    this.log = (opts == null ? void 0 : opts.log) || false;
    this.sendJourneyEventsInDev = (opts == null ? void 0 : opts.sendJourneyEventsInDev) || false;
    this.env = opts == null ? void 0 : opts.env;
  }
  sentryClient = {};
  journeyUserClient = {};
  journeyEventClient = {};
  datadogRumClient = {};
  log = false;
  sendJourneyEventsInDev = false;
  env = getDeployEnv();
  /**
   * Updates contextual data to add campaign context from URL search params.
   * When UTMs are in the URL, uses them directly (the CF Worker sets the od_utm cookie server-side).
   * When UTMs are not in the URL, falls back to reading the od_utm cookie.
   * This ensures SPA navigations retain campaign attribution from the landing page.
   */
  updateJourneyContextualData(contextualData = emptyJourneyEventContextualData) {
    if (typeof window !== "undefined") {
      const searchParams = new URLSearchParams(window.location.search);
      const utmParameters = [UTM_MEDIUM, UTM_SOURCE, UTM_CAMPAIGN, UTM_CONTENT, UTM_TERM];
      if (utmParameters.some((param) => searchParams.get(param))) {
        const campaignContext = {
          utmMedium: searchParams.get(UTM_MEDIUM) ?? void 0,
          utmSource: searchParams.get(UTM_SOURCE) ?? void 0,
          utmCampaign: searchParams.get(UTM_CAMPAIGN) ?? void 0,
          utmContent: searchParams.get(UTM_CONTENT) ?? void 0,
          utmTerm: searchParams.get(UTM_TERM) ?? void 0,
          utmAdgid: searchParams.get(UTM_ADGID) ?? void 0,
          utmNtwk: searchParams.get(UTM_NTWK) ?? void 0,
          utmSubsite: searchParams.get(UTM_SUBSITE) ?? void 0,
          utmCta: searchParams.get(UTM_CTA) ?? void 0,
          utmExternalid: searchParams.get(UTM_EXTERNALID) ?? void 0,
          utmGeo: searchParams.get(UTM_GEO) ?? void 0,
          utmCat: searchParams.get(UTM_CAT) ?? void 0
        };
        return { ...contextualData, campaignContext };
      }
      if (!contextualData.campaignContext) {
        const cookieCampaign = readUtmCookie();
        if (cookieCampaign) {
          return { ...contextualData, campaignContext: cookieCampaign };
        }
      }
    }
    return contextualData;
  }
  /**
   * Updates contextual data for non-journey events
   * This will be removed when we remove old versions of tracking data
   */
  updateDeprecatedContextualData(contextualData = emptyContextualData) {
    if (typeof window !== "undefined") {
      const searchParams = new URLSearchParams(window.location.search);
      const utmParameters = [UTM_MEDIUM, UTM_SOURCE, UTM_CAMPAIGN, UTM_CONTENT, UTM_TERM];
      if (utmParameters.some((param) => searchParams.get(param))) {
        const campaignContext = {
          utmMedium: searchParams.get(UTM_MEDIUM) ?? void 0,
          utmSource: searchParams.get(UTM_SOURCE) ?? void 0,
          utmCampaign: searchParams.get(UTM_CAMPAIGN) ?? void 0,
          utmContent: searchParams.get(UTM_CONTENT) ?? void 0,
          utmTerm: searchParams.get(UTM_TERM) ?? void 0
        };
        return {
          ...contextualData,
          campaignContext
        };
      }
    }
    return contextualData;
  }
  trackEvent(action, label, contextualData = emptyContextualData, options) {
    contextualData = this.updateDeprecatedContextualData(contextualData);
    const categoryOverride = (options == null ? void 0 : options.categoryOverride) ? String(options.categoryOverride) : void 0;
    emitDevtoolsEvent({
      type: "trackEvent",
      action: String(action),
      label,
      categoryOverride,
      contextualData
    });
    if (this.log) {
      const categoryPrefix = categoryOverride ? `${categoryOverride}, ` : "";
      console.info(`trackEvent(${categoryPrefix}${action}, ${label})`, contextualData);
    }
  }
  trackUserEvent(event, contextualData = emptyContextualData) {
    contextualData = this.updateDeprecatedContextualData(contextualData);
    this.log && console.info(`trackUserEvent(${JSON.stringify(event)})`, contextualData);
  }
  trackJourneyEvent(categoryName, eventName, eventData, contextualData = emptyJourneyEventContextualData, options) {
    var _a, _b;
    const eventWrapper = {
      category: {
        $case: categoryName,
        [categoryName]: {
          event: {
            $case: eventName,
            [eventName]: eventData
          }
        }
      }
    };
    contextualData = this.updateJourneyContextualData(contextualData);
    emitDevtoolsEvent({
      type: "trackJourneyEvent",
      categoryName: String(categoryName),
      eventName: String(eventName),
      eventData,
      contextualData
    });
    const clientEventId = typeof crypto !== "undefined" && crypto.randomUUID ? crypto.randomUUID() : void 0;
    if (this.sendJourneyEventsInDev && this.env === "development") {
      if (!this.journeyEventHelpers)
        throw new Error(
          "Provide journeyEventHelpers and EventWrapper types in initObservability to use trackJourneyEvent"
        );
      trackJourneyEventInJourney(
        eventWrapper,
        contextualData,
        this.journeyEventHelpers,
        this.sendJourneyEventsInDev,
        clientEventId
      );
      if (clientEventId) {
        trackJourneyEventInGTM(String(categoryName), String(eventName), clientEventId);
      }
      if (options == null ? void 0 : options.flush) {
        (_b = (_a = globalObservability.getJourneyEventClient()).send) == null ? void 0 : _b.call(_a);
      }
    }
    this.log && console.info(`trackJourneyEvent(${JSON.stringify(eventWrapper)})`, {
      clientEventId,
      ...contextualData
    });
  }
  trackError(label, error, contextualData = emptyContextualData) {
    contextualData = this.updateDeprecatedContextualData(contextualData);
    this.log && console.error(`trackError(${label})`, error, contextualData);
  }
  setDatadogRumClient(datadogRumClient) {
    this.datadogRumClient = datadogRumClient;
  }
  getDatadogRumClient() {
    return this.datadogRumClient;
  }
  setJourneyUserClient(journeyClient) {
    this.journeyUserClient = journeyClient;
  }
  setJourneyEventClient(journeyClient) {
    this.journeyEventClient = journeyClient;
  }
  getJourneyUserClient() {
    return this.journeyUserClient;
  }
  getJourneyEventClient() {
    return this.journeyEventClient;
  }
  setSentClient(sentryClient) {
    this.sentryClient = sentryClient;
  }
  getSentryClient() {
    return this.sentryClient;
  }
};
var addDatadogRUMGlobalContext = (context) => {
  addRUMGlobalContext(context);
};

// src/react/ContextualDataContext.tsx

var ContextualDataContext = react.createContext(emptyContextualData);
var useContextualData = () => {
  return (0,react.useContext)(ContextualDataContext);
};
var AddContextualData = ({
  children,
  user,
  data = {},
  campaignContext,
  customerContext,
  exclusiveOffersContext,
  leadContext,
  sellDirectContext
}) => {
  const parent = useContextualData();
  return /* @__PURE__ */ react.createElement(
    ContextualDataContext.Provider,
    {
      value: mergeContextualData(parent, {
        user,
        data,
        campaignContext,
        customerContext,
        exclusiveOffersContext,
        leadContext,
        sellDirectContext
      })
    },
    children
  );
};

// src/react/useObservability.ts

function useObservability() {
  const env = getDeployEnv();
  const contextualData = useContextualData();
  const contextualDataRef = (0,react.useRef)(contextualData);
  (0,react.useEffect)(() => {
    contextualDataRef.current = contextualData;
  }, [contextualData]);
  return (0,react.useMemo)(
    () => ({
      /**
       * Track events not performed by a user but meaningful internally. For events performed
       * by a user, use `trackUserEvent`.
       *
       * TODO (@core-experience-platform): rename to `trackInternalEvent`
       */
      trackEvent: (action, label, data, options) => {
        if (!globalObservability.isInitialized()) {
          if (env === "production") {
            return;
          }
          throw new Error("Call initObservability before trackEvent");
        }
        globalObservability.trackEvent(
          action,
          label,
          mergeContextualData(contextualDataRef.current, { data }),
          options
        );
      },
      /**
       * @deprecated Use trackJourneyEvent instead
       * @see https://opendoor.atlassian.net/wiki/spaces/CONSUMER/pages/2283536444/How+to+Create+Journey+2.0+Events
       */
      trackUserEvent: (event) => {
        if (!globalObservability.isInitialized()) {
          if (env === "production") {
            return;
          }
          throw new Error("Call initObservability before trackUserEvent");
        }
        globalObservability.trackUserEvent(event, contextualDataRef.current);
      },
      trackJourneyEvent: (categoryName, eventName, eventData, options) => {
        if (!globalObservability.isInitialized()) {
          if (env === "production") {
            return;
          }
          throw new Error("Call initObservability before trackJourneyEvent");
        }
        globalObservability.trackJourneyEvent(
          categoryName,
          eventName,
          eventData,
          contextualDataRef.current,
          options
        );
      },
      trackError: (label, error, data, options) => {
        if (!globalObservability.isInitialized()) {
          if (env === "production") {
            return;
          }
          throw new Error("Call initObservability before trackError");
        }
        globalObservability.trackError(
          label,
          error,
          mergeContextualData(contextualDataRef.current, { data }),
          options
        );
      }
    }),
    [env]
  );
}




/***/ }),

/***/ 74593:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C3": function() { return /* reexport safe */ _chunk_SXEEZYFT_mjs__WEBPACK_IMPORTED_MODULE_0__.C3; },
/* harmony export */   "co": function() { return /* reexport safe */ _chunk_SXEEZYFT_mjs__WEBPACK_IMPORTED_MODULE_0__.YE; },
/* harmony export */   "lT": function() { return /* binding */ initObservability; },
/* harmony export */   "up": function() { return /* reexport safe */ _chunk_SXEEZYFT_mjs__WEBPACK_IMPORTED_MODULE_0__.up; },
/* harmony export */   "w": function() { return /* reexport safe */ _chunk_SXEEZYFT_mjs__WEBPACK_IMPORTED_MODULE_0__.w; }
/* harmony export */ });
/* harmony import */ var _chunk_SXEEZYFT_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68751);


// src/observability-slim.ts
function initObservability({
  appName,
  env,
  version,
  eventTrackingCategory,
  sentry,
  datadog,
  debug,
  sendJourneyEventsInDev,
  journeyEventHelpers,
  journeyEndpoint,
  lazyLoadAnalytics,
  isBot
}) {
  if (_chunk_SXEEZYFT_mjs__WEBPACK_IMPORTED_MODULE_0__/* .globalObservability.isInitialized */ .w.isInitialized()) {
    throw new Error("initObservability was already called");
  }
  env = env || (0,_chunk_SXEEZYFT_mjs__WEBPACK_IMPORTED_MODULE_0__/* .getDeployEnv */ .BS)();
  if (env === "development") {
    let journeyEventClient = void 0;
    if (sendJourneyEventsInDev) {
      const { eventClient } = (0,_chunk_SXEEZYFT_mjs__WEBPACK_IMPORTED_MODULE_0__/* .initJourney */ .UN)(_chunk_SXEEZYFT_mjs__WEBPACK_IMPORTED_MODULE_0__/* .BASE_JOURNEY_ENDPOINT */ .pb);
      journeyEventClient = eventClient;
    }
    _chunk_SXEEZYFT_mjs__WEBPACK_IMPORTED_MODULE_0__/* .globalObservability.setCurrentInstance */ .w.setCurrentInstance(
      new _chunk_SXEEZYFT_mjs__WEBPACK_IMPORTED_MODULE_0__/* .DebugObservability */ .ZU(
        {
          log: debug,
          sendJourneyEventsInDev,
          journeyEventClient,
          env
        },
        eventTrackingCategory,
        journeyEventHelpers
      )
    );
  } else {
    if (typeof window !== "undefined" && !isBot) {
      (0,_chunk_SXEEZYFT_mjs__WEBPACK_IMPORTED_MODULE_0__/* .loadGoogleTagManager */ .dl)(lazyLoadAnalytics);
      (0,_chunk_SXEEZYFT_mjs__WEBPACK_IMPORTED_MODULE_0__/* .loadSegment */ .m7)(void 0, lazyLoadAnalytics);
    }
    const realObservabilityInstance = new _chunk_SXEEZYFT_mjs__WEBPACK_IMPORTED_MODULE_0__/* .RealObservability */ .Md(eventTrackingCategory, journeyEventHelpers);
    if (!isBot) {
      const { eventClient, userClient } = (0,_chunk_SXEEZYFT_mjs__WEBPACK_IMPORTED_MODULE_0__/* .initJourney */ .UN)(journeyEndpoint);
      userClient && realObservabilityInstance.setJourneyUserClient(userClient);
      eventClient && realObservabilityInstance.setJourneyEventClient(eventClient);
    }
    _chunk_SXEEZYFT_mjs__WEBPACK_IMPORTED_MODULE_0__/* .globalObservability.setCurrentInstance */ .w.setCurrentInstance(realObservabilityInstance);
    sentry == null ? void 0 : sentry.init({ ...(0,_chunk_SXEEZYFT_mjs__WEBPACK_IMPORTED_MODULE_0__/* .buildDefaultSentryOpts */ .vg)({ appName, env, version }), ...sentry }).then((sentryClient) => {
      realObservabilityInstance.setSentryClient(sentryClient);
    }).catch((e) => {
      console.error("Error initializing Sentry", e);
    });
    datadog == null ? void 0 : datadog.init({ ...(0,_chunk_SXEEZYFT_mjs__WEBPACK_IMPORTED_MODULE_0__/* .buildDefaultDatadogOptions */ .UJ)({ appName, env, version }), ...datadog }).then((datadogRumClient) => {
      realObservabilityInstance.setDatadogRumClient(datadogRumClient);
    }).catch((e) => {
      console.error("Error initializing Datadog", e);
    });
  }
}



/***/ }),

/***/ 20943:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 39474:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayWithHoles; }
/* harmony export */ });
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}


/***/ }),

/***/ 4111:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}


/***/ }),

/***/ 47568:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ }),

/***/ 51438:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 71418:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _createSuper; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_is_native_reflect_construct.mjs
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { }));
        return true;
    } catch (e) {
        return false;
    }
}
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_get_prototype_of.mjs
var _get_prototype_of = __webpack_require__(82662);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_possible_constructor_return.mjs
var _possible_constructor_return = __webpack_require__(41357);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs




function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0,_get_prototype_of/* default */.Z)(Derived),
            result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0,_get_prototype_of/* default */.Z)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return (0,_possible_constructor_return/* default */.Z)(this, result);
    };
}

/***/ }),

/***/ 14924:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}


/***/ }),

/***/ 82662:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
function getPrototypeOf(o) {
  getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return getPrototypeOf(o);
}

function _getPrototypeOf(o) {
  return getPrototypeOf(o);
}

/***/ }),

/***/ 28668:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _inherits; }
/* harmony export */ });
/* harmony import */ var _set_prototype_of_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44998);


function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) (0,_set_prototype_of_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(subClass, superClass);
}


/***/ }),

/***/ 82670:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _instanceof; }
/* harmony export */ });
function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}

/***/ }),

/***/ 13375:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 53128:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _nonIterableRest; }
/* harmony export */ });
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


/***/ }),

/***/ 26042:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpread; }
/* harmony export */ });
/* harmony import */ var _define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);


function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      (0,_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    });
  }

  return target;
}

/***/ }),

/***/ 69396:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ }),

/***/ 99534:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 41357:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _possibleConstructorReturn; }
/* harmony export */ });
/* harmony import */ var _assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4111);
/* harmony import */ var _type_of_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82222);



function _possibleConstructorReturn(self, call) {
  if (call && ((0,_type_of_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(call) === "object" || typeof call === "function")) {
    return call;
  }

  return (0,_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(self);
}


/***/ }),

/***/ 44998:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function setPrototypeOf(o, p) {
  setPrototypeOf = Object.setPrototypeOf || function setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return setPrototypeOf(o, p);
}

function _setPrototypeOf(o, p) {
  return setPrototypeOf(o, p);
}


/***/ }),

/***/ 10253:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _slicedToArray; }
/* harmony export */ });
/* harmony import */ var _array_with_holes_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39474);
/* harmony import */ var _iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13375);
/* harmony import */ var _non_iterable_rest_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53128);
/* harmony import */ var _unsupported_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91566);





function _slicedToArray(arr, i) {
  return (0,_array_with_holes_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(arr) || (0,_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(arr, i) || (0,_unsupported_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(arr, i) || (0,_non_iterable_rest_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
}


/***/ }),

/***/ 7297:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _taggedTemplateLiteral; }
/* harmony export */ });
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}


/***/ }),

/***/ 36305:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(20943);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ }),

/***/ 82222:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
    "@swc/helpers - typeof";
    return obj && obj.constructor === Symbol ? "symbol" : typeof obj;
};


/***/ }),

/***/ 91566:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20943);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ }),

/***/ 25892:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _wrapNativeSuper; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_set_prototype_of.mjs
var _set_prototype_of = __webpack_require__(44998);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_construct.mjs


function isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () { }));
    return true;
  } catch (e) {
    return false;
  }
}

function construct(Parent, args, Class) {
  if (isNativeReflectConstruct()) {
    construct = Reflect.construct;
  } else {
    construct = function construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) (0,_set_prototype_of/* default */.Z)(instance, Class.prototype);
      return instance;
    };
  }

  return construct.apply(null, arguments);
}

function _construct(Parent, args, Class) {
  return construct.apply(null, arguments);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_is_native_function.mjs
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_get_prototype_of.mjs
var _get_prototype_of = __webpack_require__(82662);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_wrap_native_super.mjs





function wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  wrapNativeSuper = function wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, (0,_get_prototype_of/* default */.Z)(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return (0,_set_prototype_of/* default */.Z)(Wrapper, Class);
  };

  return wrapNativeSuper(Class);
}

function _wrapNativeSuper(Class) {
  return wrapNativeSuper(Class);
}


/***/ }),

/***/ 26062:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": function() { return /* binding */ AnimatePresence; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@tamagui/use-force-update/dist/esm/index.mjs

const isServerSide = typeof window > "u",
  idFn = () => {};
function useForceUpdate() {
  return isServerSide ? idFn : react.useReducer(x => Math.random(), 0)[1];
}

//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@tamagui/animate-presence/dist/esm/LayoutGroupContext.mjs

const LayoutGroupContext = react.createContext({});

//# sourceMappingURL=LayoutGroupContext.mjs.map

// EXTERNAL MODULE: ./node_modules/@tamagui/use-constant/dist/esm/index.mjs
var esm = __webpack_require__(22827);
// EXTERNAL MODULE: ./node_modules/@tamagui/use-presence/dist/esm/index.mjs + 2 modules
var dist_esm = __webpack_require__(61360);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@tamagui/animate-presence/dist/esm/PresenceChild.mjs





const PresenceChild = react.memo(({
  children,
  initial,
  isPresent,
  onExitComplete,
  exitVariant,
  enterVariant,
  enterExitVariant,
  presenceAffectsLayout,
  custom
}) => {
  const presenceChildren = (0,esm/* useConstant */.h)(newChildrenMap),
    id = (0,react.useId)() || "",
    context = react.useMemo(() => ({
      id,
      initial,
      isPresent,
      custom,
      exitVariant,
      enterVariant,
      enterExitVariant,
      onExitComplete: () => {
        presenceChildren.set(id, !0);
        for (const isComplete of presenceChildren.values()) if (!isComplete) return;
        onExitComplete?.();
      },
      register: () => (presenceChildren.set(id, !1), () => presenceChildren.delete(id))
    }),
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    // @ts-expect-error its ok
    presenceAffectsLayout ? void 0 : [isPresent, exitVariant, enterVariant]);
  return react.useMemo(() => {
    presenceChildren.forEach((_, key) => presenceChildren.set(key, !1));
  }, [isPresent]), react.useEffect(() => {
    !isPresent && !presenceChildren.size && onExitComplete?.();
  }, [isPresent]), /* @__PURE__ */(0,jsx_runtime.jsx)(dist_esm/* PresenceContext.Provider */.Oy.Provider, {
    value: context,
    children
  });
});
function newChildrenMap() {
  return /* @__PURE__ */new Map();
}

//# sourceMappingURL=PresenceChild.mjs.map

;// CONCATENATED MODULE: ./node_modules/@tamagui/animate-presence/dist/esm/AnimatePresence.mjs





const getChildKey = child => child.key || "";
function updateChildLookup(children, allChildren) {
  children.forEach(child => {
    const key = getChildKey(child);
    allChildren.set(key, child);
  });
}
function onlyElements(children) {
  const filtered = [];
  return react.Children.forEach(children, child => {
    (0,react.isValidElement)(child) && filtered.push(child);
  }), filtered;
}
const AnimatePresence = ({
  children,
  enterVariant,
  exitVariant,
  enterExitVariant,
  initial = !0,
  onExitComplete,
  exitBeforeEnter,
  presenceAffectsLayout = !0,
  custom
}) => {
  let forceRender = (0,react.useContext)(LayoutGroupContext).forceRender ?? useForceUpdate();
  const filteredChildren = onlyElements(children),
    presentChildren = (0,react.useRef)(filteredChildren),
    allChildren = (0,react.useRef)( /* @__PURE__ */new Map()).current,
    exiting = (0,react.useRef)( /* @__PURE__ */new Set()).current;
  updateChildLookup(filteredChildren, allChildren);
  const isInitialRender = (0,react.useRef)(!0);
  if (isInitialRender.current) return isInitialRender.current = !1, /* @__PURE__ */(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: filteredChildren.map(child => /* @__PURE__ */(0,jsx_runtime.jsx)(PresenceChild, {
      isPresent: !0,
      enterExitVariant,
      exitVariant,
      enterVariant,
      initial: initial ? void 0 : !1,
      presenceAffectsLayout,
      custom,
      children: child
    }, getChildKey(child)))
  });
  let childrenToRender = [...filteredChildren];
  const presentKeys = presentChildren.current.map(getChildKey),
    targetKeys = filteredChildren.map(getChildKey),
    numPresent = presentKeys.length;
  for (let i = 0; i < numPresent; i++) {
    const key = presentKeys[i];
    targetKeys.indexOf(key) === -1 ? exiting.add(key) : exiting.delete(key);
  }
  return exitBeforeEnter && exiting.size && (childrenToRender = []), exiting.forEach(key => {
    if (targetKeys.indexOf(key) !== -1) return;
    const child = allChildren.get(key);
    if (!child) return;
    const insertionIndex = presentKeys.indexOf(key),
      exitingComponent = /* @__PURE__ */(0,jsx_runtime.jsx)(PresenceChild, {
        isPresent: !1,
        onExitComplete: () => {
          allChildren.delete(key), exiting.delete(key);
          const removeIndex = presentChildren.current.findIndex(presentChild => presentChild.key === key);
          presentChildren.current.splice(removeIndex, 1), exiting.size || (presentChildren.current = filteredChildren, forceRender(), onExitComplete?.());
        },
        presenceAffectsLayout,
        enterExitVariant,
        enterVariant,
        exitVariant,
        custom,
        children: child
      }, getChildKey(child));
    childrenToRender.splice(insertionIndex, 0, exitingComponent);
  }), childrenToRender = childrenToRender.map(child => {
    const key = child.key;
    return exiting.has(key) ? child : /* @__PURE__ */(0,jsx_runtime.jsx)(PresenceChild, {
      isPresent: !0,
      exitVariant,
      enterVariant,
      enterExitVariant,
      presenceAffectsLayout,
      custom,
      children: child
    }, getChildKey(child));
  }), presentChildren.current = childrenToRender, /* @__PURE__ */(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: exiting.size ? childrenToRender :
    // biome-ignore lint/correctness/useJsxKeyInIterable: <explanation>
    childrenToRender.map(child => (0,react.cloneElement)(child))
  });
};
AnimatePresence.displayName = "AnimatePresence";

//# sourceMappingURL=AnimatePresence.mjs.map


/***/ }),

/***/ 9053:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ createCollection; }
/* harmony export */ });
/* harmony import */ var _tamagui_compose_refs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94030);
/* harmony import */ var _tamagui_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75425);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86872);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);





function createCollection(name) {
  const {
      Provider: CollectionProviderImpl,
      useStyledContext: useCollectionContext
    } = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_3__.createStyledContext)({
      collectionRef: {
        current: null
      },
      itemMap: /* @__PURE__ */new Map()
    }),
    CollectionProvider = props => {
      const {
          __scopeCollection,
          children
        } = props,
        ref = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null),
        itemMap = react__WEBPACK_IMPORTED_MODULE_1__.useRef( /* @__PURE__ */new Map()).current;
      return /* @__PURE__ */(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(CollectionProviderImpl, {
        scope: __scopeCollection,
        itemMap,
        collectionRef: ref,
        children
      });
    };
  CollectionProvider.displayName = "CollectionProvider";
  const COLLECTION_SLOT_NAME = name + "CollectionSlot",
    CollectionSlot = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((props, forwardedRef) => {
      const {
          __scopeCollection,
          children
        } = props,
        context = useCollectionContext(__scopeCollection),
        composedRefs = (0,_tamagui_compose_refs__WEBPACK_IMPORTED_MODULE_4__/* .useComposedRefs */ .ex)(forwardedRef, context.collectionRef);
      return /* @__PURE__ */(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_tamagui_core__WEBPACK_IMPORTED_MODULE_3__.Slot, {
        ref: composedRefs,
        children
      });
    });
  CollectionSlot.displayName = COLLECTION_SLOT_NAME;
  const ITEM_SLOT_NAME = name + "CollectionItemSlot",
    ITEM_DATA_ATTR = "data-collection-item",
    CollectionItemSlot = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((props, forwardedRef) => {
      const {
          __scopeCollection,
          children,
          ...itemData
        } = props,
        ref = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null),
        composedRefs = (0,_tamagui_compose_refs__WEBPACK_IMPORTED_MODULE_4__/* .useComposedRefs */ .ex)(forwardedRef, ref),
        context = useCollectionContext(__scopeCollection);
      return react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => (context.itemMap.set(ref, {
        ref,
        ...itemData
      }), () => void context.itemMap.delete(ref))), /* @__PURE__ */(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_tamagui_core__WEBPACK_IMPORTED_MODULE_3__.Slot, {
        [ITEM_DATA_ATTR]: "",
        ref: composedRefs,
        children
      });
    });
  CollectionItemSlot.displayName = ITEM_SLOT_NAME;
  function useCollection(__scopeCollection) {
    const context = useCollectionContext(__scopeCollection);
    return react__WEBPACK_IMPORTED_MODULE_1__.useCallback(() => {
      if (!_tamagui_constants__WEBPACK_IMPORTED_MODULE_0__/* .isWeb */ .$L) return [];
      const collectionNode = context.collectionRef.current;
      if (!collectionNode) return [];
      const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
      return Array.from(context.itemMap.values()).sort((a, b) => orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current));
    }, [context.collectionRef, context.itemMap]);
  }
  return [{
    Provider: CollectionProvider,
    Slot: CollectionSlot,
    ItemSlot: CollectionItemSlot
  }, useCollection];
}

//# sourceMappingURL=Collection.mjs.map


/***/ }),

/***/ 94030:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FE": function() { return /* binding */ composeRefs; },
/* harmony export */   "ex": function() { return /* binding */ useComposedRefs; }
/* harmony export */ });
/* unused harmony export setRef */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function setRef(ref, value) {
  typeof ref == "function" ? ref(value) : ref && (ref.current = value);
}
function composeRefs(...refs) {
  return node => refs.forEach(ref => setRef(ref, node));
}
function useComposedRefs(...refs) {
  return react__WEBPACK_IMPORTED_MODULE_0__.useCallback(composeRefs(...refs), refs);
}

//# sourceMappingURL=compose-refs.mjs.map


/***/ }),

/***/ 75425:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ob": function() { return /* reexport */ currentPlatform; },
  "Dt": function() { return /* reexport */ isAndroid; },
  "s": function() { return /* reexport */ isIos; },
  "sk": function() { return /* reexport */ isServer; },
  "wT": function() { return /* reexport */ isTouchable; },
  "$L": function() { return /* reexport */ isWeb; },
  "LI": function() { return /* reexport */ useIsomorphicLayoutEffect; }
});

// UNUSED EXPORTS: isChrome, isClient, isWebTouchable, isWindowDefined

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@tamagui/constants/dist/esm/constants.mjs

const isWeb = !0,
  isWindowDefined = typeof window < "u",
  isServer = isWeb && !isWindowDefined,
  isClient = isWeb && isWindowDefined,
  useIsomorphicLayoutEffect = isServer ? react.useEffect : react.useLayoutEffect,
  isChrome = typeof navigator < "u" && /Chrome/.test(navigator.userAgent || ""),
  isWebTouchable = isClient && ("ontouchstart" in window || navigator.maxTouchPoints > 0),
  isTouchable = !isWeb || isWebTouchable,
  isAndroid = !1,
  isIos = !1,
  currentPlatform = "web";

//# sourceMappingURL=constants.mjs.map

;// CONCATENATED MODULE: ./node_modules/@tamagui/constants/dist/esm/index.mjs

//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 86660:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h_": function() { return /* reexport */ Portal; },
  "$2": function() { return /* reexport */ PortalHost; },
  "b5": function() { return /* reexport */ PortalItem; },
  "Xp": function() { return /* reexport */ PortalProvider; }
});

// UNUSED EXPORTS: ACTIONS, INITIAL_STATE, usePortal

// EXTERNAL MODULE: ./node_modules/@tamagui/polyfill-dev/index.js
var polyfill_dev = __webpack_require__(65190);
// EXTERNAL MODULE: ./node_modules/@tamagui/constants/dist/esm/index.mjs + 1 modules
var esm = __webpack_require__(75425);
// EXTERNAL MODULE: ./node_modules/@tamagui/stacks/dist/esm/Stacks.mjs
var Stacks = __webpack_require__(43702);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/@tamagui/use-did-finish-ssr/dist/esm/index.mjs
var dist_esm = __webpack_require__(96039);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@tamagui/portal/dist/esm/Portal.mjs







const Portal = react.memo(({
  host = globalThis.document?.body,
  ...props
}) => {
  if (esm/* isServer */.sk) return null;
  const didFinishSSR = (0,dist_esm/* useDidFinishSSR */.SZ)(),
    contents = /* @__PURE__ */(0,jsx_runtime.jsx)(Stacks/* YStack */.FA, {
      contain: "strict",
      fullscreen: !0,
      position: "fixed",
      maxWidth: "100vw",
      maxHeight: "100vh",
      pointerEvents: "none",
      ...props
    });
  return (0,react_dom.createPortal)(didFinishSSR ? contents : null, host);
});

//# sourceMappingURL=Portal.mjs.map

// EXTERNAL MODULE: ./node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(86872);
// EXTERNAL MODULE: ./node_modules/@tamagui/start-transition/dist/esm/index.mjs
var start_transition_dist_esm = __webpack_require__(28031);
;// CONCATENATED MODULE: ./node_modules/@tamagui/portal/dist/esm/GorhomPortal.mjs





var ACTIONS = /* @__PURE__ */(ACTIONS2 => (ACTIONS2[ACTIONS2.REGISTER_HOST = 0] = "REGISTER_HOST", ACTIONS2[ACTIONS2.DEREGISTER_HOST = 1] = "DEREGISTER_HOST", ACTIONS2[ACTIONS2.ADD_UPDATE_PORTAL = 2] = "ADD_UPDATE_PORTAL", ACTIONS2[ACTIONS2.REMOVE_PORTAL = 3] = "REMOVE_PORTAL", ACTIONS2))(ACTIONS || {});
const INITIAL_STATE = {};
const registerHost = (state, hostName) => (hostName in state || (state[hostName] = []), state),
  deregisterHost = (state, hostName) => (delete state[hostName], state),
  addUpdatePortal = (state, hostName, portalName, node) => {
    hostName in state || (state = registerHost(state, hostName));
    const index = state[hostName].findIndex(item => item.name === portalName);
    return index !== -1 ? state[hostName][index].node = node : state[hostName].push({
      name: portalName,
      node
    }), state;
  },
  removePortal = (state, hostName, portalName) => {
    if (!(hostName in state)) return console.info(`Failed to remove portal '${portalName}', '${hostName}' was not registered!`), state;
    const index = state[hostName].findIndex(item => item.name === portalName);
    return index !== -1 && state[hostName].splice(index, 1), state;
  },
  reducer = (state, action) => {
    const {
      type
    } = action;
    switch (type) {
      case 0 /* REGISTER_HOST */:
        return registerHost({
          ...state
        }, action.hostName);
      case 1 /* DEREGISTER_HOST */:
        return deregisterHost({
          ...state
        }, action.hostName);
      case 2 /* ADD_UPDATE_PORTAL */:
        return addUpdatePortal({
          ...state
        }, action.hostName, action.portalName, action.node);
      case 3 /* REMOVE_PORTAL */:
        return removePortal({
          ...state
        }, action.hostName, action.portalName);
      default:
        return state;
    }
  },
  PortalStateContext = (0,react.createContext)(null),
  PortalDispatchContext = (0,react.createContext)(null),
  usePortalState = hostName => {
    const state = (0,react.useContext)(PortalStateContext);
    if (state === null) throw new Error("'PortalStateContext' cannot be null, please add 'PortalProvider' to the root component.");
    return state[hostName] || [];
  },
  usePortal = (hostName = "root") => {
    const dispatch = (0,react.useContext)(PortalDispatchContext);
    if (dispatch === null) throw new Error("'PortalDispatchContext' cannot be null, please add 'PortalProvider' to the root component.");
    const registerHost2 = (0,react.useCallback)(() => {
        dispatch({
          type: 0 /* REGISTER_HOST */,
          hostName
        });
      }, []),
      deregisterHost2 = (0,react.useCallback)(() => {
        dispatch({
          type: 1 /* DEREGISTER_HOST */,
          hostName
        });
      }, []),
      addUpdatePortal2 = (0,react.useCallback)((name, node) => {
        dispatch({
          type: 2 /* ADD_UPDATE_PORTAL */,
          hostName,
          portalName: name,
          node
        });
      }, []),
      removePortal2 = (0,react.useCallback)(name => {
        dispatch({
          type: 3 /* REMOVE_PORTAL */,
          hostName,
          portalName: name
        });
      }, []);
    return {
      registerHost: registerHost2,
      deregisterHost: deregisterHost2,
      addPortal: addUpdatePortal2,
      updatePortal: addUpdatePortal2,
      removePortal: removePortal2
    };
  },
  PortalProviderComponent = ({
    rootHostName = "root",
    shouldAddRootHost = !0,
    children
  }) => {
    const [state, dispatch] = (0,react.useReducer)(reducer, INITIAL_STATE),
      transitionDispatch = (0,react.useMemo)(() => value => {
        (0,start_transition_dist_esm/* startTransition */.L)(() => {
          dispatch(value);
        });
      }, [dispatch]);
    return /* @__PURE__ */(0,jsx_runtime.jsx)(PortalDispatchContext.Provider, {
      value: transitionDispatch,
      children: /* @__PURE__ */(0,jsx_runtime.jsxs)(PortalStateContext.Provider, {
        value: state,
        children: [children, shouldAddRootHost && /* @__PURE__ */(0,jsx_runtime.jsx)(PortalHost, {
          name: rootHostName
        })]
      })
    });
  },
  PortalProvider = (0,react.memo)(PortalProviderComponent);
PortalProvider.displayName = "PortalProvider";
const defaultRenderer = children => /* @__PURE__ */(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children
  }),
  PortalHostComponent = props => {
    const {
        name,
        forwardProps,
        render = defaultRenderer
      } = props,
      state = usePortalState(name),
      {
        registerHost: registerHost2,
        deregisterHost: deregisterHost2
      } = usePortal(props.name);
    return (0,react.useEffect)(() => {
      if (!(typeof window > "u")) return registerHost2(), () => {
        deregisterHost2();
      };
    }, []), render(forwardProps ? state.map(item => {
      let next = item.node;
      return forwardProps ? react.Children.map(next, child => react.isValidElement(child) ? react.cloneElement(child, {
        key: child.key,
        ...forwardProps
      }) : child) : next;
    }) : state.map(item => item.node));
  },
  PortalHost = (0,react.memo)(PortalHostComponent);
PortalHost.displayName = "PortalHost";
const PortalComponent = props => {
    const {
        name: _providedName,
        hostName,
        handleOnMount: _providedHandleOnMount,
        handleOnUnmount: _providedHandleOnUnmount,
        handleOnUpdate: _providedHandleOnUpdate,
        children
      } = props,
      {
        addPortal: addUpdatePortal2,
        removePortal: removePortal2
      } = usePortal(hostName),
      id = (0,react.useId)(),
      name = _providedName || id,
      handleOnMount = (0,cjs.useEvent)(() => {
        _providedHandleOnMount ? _providedHandleOnMount(() => addUpdatePortal2(name, children)) : addUpdatePortal2(name, children);
      }),
      handleOnUnmount = (0,cjs.useEvent)(() => {
        _providedHandleOnUnmount ? _providedHandleOnUnmount(() => removePortal2(name)) : removePortal2(name);
      }),
      handleOnUpdate = (0,cjs.useEvent)(() => {
        _providedHandleOnUpdate ? _providedHandleOnUpdate(() => addUpdatePortal2(name, children)) : addUpdatePortal2(name, children);
      });
    return (0,esm/* useIsomorphicLayoutEffect */.LI)(() => (handleOnMount(), () => {
      handleOnUnmount();
    }), []), (0,react.useEffect)(() => {
      handleOnUpdate();
    }, [children]), null;
  },
  PortalItem = (0,react.memo)(PortalComponent);
PortalItem.displayName = "Portal";

//# sourceMappingURL=GorhomPortal.mjs.map

;// CONCATENATED MODULE: ./node_modules/@tamagui/portal/dist/esm/index.mjs



//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 43702:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FA": function() { return /* binding */ YStack; },
/* harmony export */   "Xu": function() { return /* binding */ fullscreenStyle; },
/* harmony export */   "sL": function() { return /* binding */ XStack; }
/* harmony export */ });
/* unused harmony export ZStack */
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86872);
/* harmony import */ var _getElevation_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52702);


const fullscreenStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  },
  getInset = val => val && typeof val == "object" ? val : {
    top: val,
    left: val,
    bottom: val,
    right: val
  },
  variants = {
    fullscreen: {
      true: fullscreenStyle
    },
    elevation: {
      "...size": _getElevation_mjs__WEBPACK_IMPORTED_MODULE_0__/* .getElevation */ .y,
      ":number": _getElevation_mjs__WEBPACK_IMPORTED_MODULE_0__/* .getElevation */ .y
    },
    inset: getInset
  },
  YStack = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_1__.styled)(_tamagui_core__WEBPACK_IMPORTED_MODULE_1__.View, {
    flexDirection: "column",
    variants
  });
YStack.displayName = "YStack";
const XStack = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_1__.styled)(_tamagui_core__WEBPACK_IMPORTED_MODULE_1__.View, {
  flexDirection: "row",
  variants
});
XStack.displayName = "XStack";
const ZStack = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_1__.styled)(YStack, {
  position: "relative"
}, {
  neverFlatten: !0,
  isZStack: !0
});
ZStack.displayName = "ZStack";

//# sourceMappingURL=Stacks.mjs.map


/***/ }),

/***/ 52702:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ getElevation; }
/* harmony export */ });
/* unused harmony export getSizedElevation */
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86872);

const getElevation = (size, extras) => {
    if (!size) return;
    const {
        tokens
      } = extras,
      token = tokens.size[size],
      sizeNum = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_0__.isVariable)(token) ? +token.val : size;
    return getSizedElevation(sizeNum, extras);
  },
  getSizedElevation = (val, {
    theme,
    tokens
  }) => {
    let num = 0;
    if (val === !0) {
      const val2 = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_0__.getVariableValue)(tokens.size.true);
      typeof val2 == "number" ? num = val2 : num = 10;
    } else num = +val;
    if (num === 0) return;
    const [height, shadowRadius] = [Math.round(num / 4 + 1), Math.round(num / 2 + 2)];
    return {
      shadowColor: theme.shadowColor,
      shadowRadius,
      shadowOffset: {
        height,
        width: 0
      },
      ...(_tamagui_core__WEBPACK_IMPORTED_MODULE_0__.isAndroid ? {
        elevationAndroid: 2 * height
      } : {})
    };
  };

//# sourceMappingURL=getElevation.mjs.map


/***/ }),

/***/ 28031:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ startTransition; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const startTransition = callback => {
  (0,react__WEBPACK_IMPORTED_MODULE_0__.startTransition)(callback);
};

//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 2263:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "FE": function() { return /* binding */ ToastProvider_Collection; },
  "ZD": function() { return /* binding */ ReprogapateToastProvider; },
  "VW": function() { return /* binding */ ToastProvider; },
  "Kx": function() { return /* binding */ useCollection; },
  "jz": function() { return /* binding */ useToastProviderContext; }
});

// EXTERNAL MODULE: ./node_modules/@tamagui/collection/dist/esm/Collection.mjs
var Collection = __webpack_require__(9053);
// EXTERNAL MODULE: ./node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(86872);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@tamagui/start-transition/dist/esm/index.mjs
var esm = __webpack_require__(28031);
// EXTERNAL MODULE: ./node_modules/@tamagui/toast/dist/esm/constants.mjs
var constants = __webpack_require__(20335);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/Platform/index.js
var Platform = __webpack_require__(22805);
;// CONCATENATED MODULE: ./node_modules/@tamagui/toast/dist/esm/createNativeToast.mjs
const createNativeToast = (title, {
    message,
    notificationOptions
  }) => {
    if (!("Notification" in window)) return console.error("This browser does not support notifications"), !1;
    Notification.permission;
    const showNotification = () => new Notification(title, {
      body: message,
      ...notificationOptions
    });
    return Notification.permission === "granted" ? {
      nativeToastRef: showNotification()
    } : (Notification.requestPermission().then(permission => {
      if (permission === "granted") return {
        nativeToastRef: showNotification()
      };
    }), !0);
  },
  hideNativeToast = ref => {
    if (!("Notification" in window)) {
      console.error("This browser does not support notifications");
      return;
    }
    ref && ref.close();
  };

//# sourceMappingURL=createNativeToast.mjs.map

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@tamagui/toast/dist/esm/ToastImperative.mjs





const ToastContext = react.createContext({}),
  ToastCurrentContext = react.createContext(null),
  useToastController = () => React.useContext(ToastContext),
  useToastState = () => React.useContext(ToastCurrentContext),
  useToast = () => ({
    ...useToastController(),
    currentToast: useToastState()
  }),
  ToastImperativeProvider = ({
    children,
    options
  }) => {
    const counterRef = react.useRef(0),
      [toast, setToast] = react.useState(null),
      [lastNativeToastRef, setLastNativeToastRef] = react.useState(null),
      show = react.useCallback((title, showOptions) => {
        const native = showOptions?.native ?? options.native,
          isWebNative = Array.isArray(native) ? native.includes("web") : native === "web",
          isMobileNative = Array.isArray(native) ? native.includes("mobile") : native === "mobile",
          isAndroidNative = isMobileNative || (Array.isArray(native) ? native.includes("android") : native === "android"),
          isIosNative = isMobileNative || (Array.isArray(native) ? native.includes("ios") : native === "ios"),
          isHandledNatively = native === !0 || cjs.isWeb && isWebNative || !cjs.isWeb && isMobileNative || Platform/* default.OS */.Z.OS === "android" && isAndroidNative || Platform/* default.OS */.Z.OS === "ios" && isIosNative;
        if (isHandledNatively) {
          const nativeToastResult = createNativeToast(title, showOptions ?? {});
          typeof nativeToastResult == "object" && nativeToastResult.nativeToastRef && setLastNativeToastRef(nativeToastResult.nativeToastRef);
        }
        return counterRef.current++, setToast({
          ...showOptions?.customData,
          ...showOptions,
          viewportName: showOptions?.viewportName ?? "default",
          title,
          id: counterRef.current.toString(),
          isHandledNatively
        }), !0;
      }, [setToast, options.native]),
      hide = react.useCallback(() => {
        lastNativeToastRef?.close(), setToast(null);
      }, [setToast, lastNativeToastRef]),
      contextValue = react.useMemo(() => ({
        show,
        hide,
        nativeToast: lastNativeToastRef,
        options
      }), [show, hide, lastNativeToastRef, JSON.stringify(options || null)]);
    return /* @__PURE__ */(0,jsx_runtime.jsx)(ToastContext.Provider, {
      value: contextValue,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(ToastCurrentContext.Provider, {
        value: toast,
        children
      })
    });
  };

//# sourceMappingURL=ToastImperative.mjs.map

;// CONCATENATED MODULE: ./node_modules/@tamagui/toast/dist/esm/ToastProvider.mjs







const PROVIDER_NAME = "ToastProvider",
  [ToastProvider_Collection, useCollection] = (0,Collection/* createCollection */.B)("Toast"),
  {
    Provider: ToastProviderProvider,
    useStyledContext: useToastProviderContext
  } = (0,cjs.createStyledContext)(),
  ToastProvider = props => {
    const {
        __scopeToast,
        id: providedId,
        burntOptions,
        native,
        notificationOptions,
        label = "Notification",
        duration = 5e3,
        swipeDirection = "right",
        swipeThreshold = 50,
        children
      } = props,
      backupId = react.useId(),
      id = providedId ?? backupId,
      [viewports, setViewports] = react.useState({}),
      [toastCount, setToastCount] = react.useState(0),
      isFocusedToastEscapeKeyDownRef = react.useRef(!1),
      isClosePausedRef = react.useRef(!1),
      handleViewportChange = react.useCallback((name, viewport) => {
        (0,esm/* startTransition */.L)(() => {
          setViewports(prev => ({
            ...prev,
            [name]: viewport
          }));
        });
      }, []),
      options = react.useMemo(() => ({
        duration,
        burntOptions,
        native,
        notificationOptions
      }), [JSON.stringify([duration, burntOptions, native, notificationOptions])]);
    return /* @__PURE__ */(0,jsx_runtime.jsx)(ToastProvider_Collection.Provider, {
      __scopeCollection: __scopeToast || constants/* TOAST_CONTEXT */.B,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(ToastProviderProvider, {
        scope: __scopeToast,
        id,
        label,
        duration,
        swipeDirection,
        swipeThreshold,
        toastCount,
        viewports,
        onViewportChange: handleViewportChange,
        onToastAdd: react.useCallback(() => {
          (0,esm/* startTransition */.L)(() => {
            setToastCount(prevCount => prevCount + 1);
          });
        }, []),
        onToastRemove: react.useCallback(() => {
          (0,esm/* startTransition */.L)(() => {
            setToastCount(prevCount => prevCount - 1);
          });
        }, []),
        isFocusedToastEscapeKeyDownRef,
        isClosePausedRef,
        options,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(ToastImperativeProvider, {
          options,
          children
        })
      })
    });
  };
function ReprogapateToastProvider(props) {
  const {
    children,
    context
  } = props;
  return /* @__PURE__ */(0,jsx_runtime.jsx)(ToastProvider_Collection.Provider, {
    __scopeCollection: constants/* TOAST_CONTEXT */.B,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(ToastProviderProvider, {
      ...context,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(ToastImperativeProvider, {
        options: context.options,
        children
      })
    })
  });
}
ToastProvider.propTypes = {
  label(props) {
    if (props.label && typeof props.label == "string" && !props.label.trim()) {
      const error = `Invalid prop \`label\` supplied to \`${PROVIDER_NAME}\`. Expected non-empty \`string\`.`;
      return new Error(error);
    }
    return null;
  }
};
ToastProvider.displayName = PROVIDER_NAME;

//# sourceMappingURL=ToastProvider.mjs.map


/***/ }),

/***/ 7797:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_i": function() { return /* binding */ ToastViewport; },
  "hu": function() { return /* binding */ VIEWPORT_PAUSE; },
  "AR": function() { return /* binding */ VIEWPORT_RESUME; }
});

// UNUSED EXPORTS: VIEWPORT_DEFAULT_HOTKEY

// EXTERNAL MODULE: ./node_modules/@tamagui/animate-presence/dist/esm/AnimatePresence.mjs + 3 modules
var AnimatePresence = __webpack_require__(26062);
// EXTERNAL MODULE: ./node_modules/@tamagui/compose-refs/dist/esm/compose-refs.mjs
var compose_refs = __webpack_require__(94030);
// EXTERNAL MODULE: ./node_modules/@tamagui/constants/dist/esm/index.mjs + 1 modules
var esm = __webpack_require__(75425);
// EXTERNAL MODULE: ./node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(86872);
// EXTERNAL MODULE: ./node_modules/@tamagui/portal/dist/esm/index.mjs + 2 modules
var dist_esm = __webpack_require__(86660);
// EXTERNAL MODULE: ./node_modules/@tamagui/stacks/dist/esm/Stacks.mjs
var Stacks = __webpack_require__(43702);
// EXTERNAL MODULE: ./node_modules/@tamagui/visually-hidden/dist/esm/VisuallyHidden.mjs
var VisuallyHidden = __webpack_require__(68648);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@tamagui/toast/dist/esm/constants.mjs
var constants = __webpack_require__(20335);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/Platform/index.js
var Platform = __webpack_require__(22805);
// EXTERNAL MODULE: ./node_modules/@tamagui/toast/dist/esm/ToastProvider.mjs + 2 modules
var ToastProvider = __webpack_require__(2263);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@tamagui/toast/dist/esm/ToastPortal.mjs




function ToastPortal({
  children,
  zIndex
}) {
  let content = children;
  return Platform/* default.OS */.Z.OS === "android" && (content = /* @__PURE__ */(0,jsx_runtime.jsx)(ToastProvider/* ReprogapateToastProvider */.ZD, {
    context: (0,ToastProvider/* useToastProviderContext */.jz)(),
    children
  })), /* @__PURE__ */(0,jsx_runtime.jsx)(dist_esm/* Portal */.h_, {
    zIndex: zIndex || 1e9,
    children: content
  });
}

//# sourceMappingURL=ToastPortal.mjs.map

;// CONCATENATED MODULE: ./node_modules/@tamagui/toast/dist/esm/ToastViewport.mjs
/* provided dependency */ var process = __webpack_require__(34155);












const VIEWPORT_NAME = "ToastViewport",
  VIEWPORT_DEFAULT_HOTKEY = ["F8"],
  VIEWPORT_PAUSE = "toast.viewportPause",
  VIEWPORT_RESUME = "toast.viewportResume",
  ToastViewportWrapperFrame = (0,cjs.styled)(Stacks/* YStack */.FA, {
    name: "ViewportWrapper",
    variants: {
      unstyled: {
        false: {
          pointerEvents: "box-none",
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          position: esm/* isWeb */.$L ? "fixed" : "absolute",
          maxWidth: "100%",
          tabIndex: 0,
          zIndex: 1e5
        }
      }
    },
    defaultVariants: {
      unstyled: process.env.TAMAGUI_HEADLESS === "1"
    }
  }),
  ToastViewportFrame = (0,cjs.styled)(Stacks/* YStack */.FA, {
    name: VIEWPORT_NAME,
    variants: {
      unstyled: {
        false: {
          pointerEvents: "box-none",
          position: esm/* isWeb */.$L ? "fixed" : "absolute",
          maxWidth: "100%"
        }
      }
    },
    defaultVariants: {
      unstyled: process.env.TAMAGUI_HEADLESS === "1"
    }
  }),
  ToastViewport = react.memo(react.forwardRef((props, forwardedRef) => {
    const {
        __scopeToast,
        hotkey = VIEWPORT_DEFAULT_HOTKEY,
        label = "Notifications ({hotkey})",
        name = "default",
        multipleToasts,
        zIndex,
        portalToRoot,
        ...viewportProps
      } = props,
      context = (0,ToastProvider/* useToastProviderContext */.jz)(__scopeToast),
      getItems = (0,ToastProvider/* useCollection */.Kx)(__scopeToast || constants/* TOAST_CONTEXT */.B),
      headFocusProxyRef = react.useRef(null),
      tailFocusProxyRef = react.useRef(null),
      wrapperRef = react.useRef(null),
      ref = react.useRef(null),
      onViewportChange = react.useCallback(el => {
        context.viewports[name] !== el && context.onViewportChange(name, el);
      }, [name, context.viewports]),
      composedRefs = (0,compose_refs/* useComposedRefs */.ex)(forwardedRef, ref, onViewportChange),
      hotkeyLabel = hotkey.join("+").replace(/Key/g, "").replace(/Digit/g, ""),
      hasToasts = context.toastCount > 0;
    react.useEffect(() => {
      if (!esm/* isWeb */.$L || context.toastCount === 0) return;
      const handleKeyDown = event => {
        hotkey.every(key => event[key] || event.code === key) && ref.current?.focus();
      };
      return document.addEventListener("keydown", handleKeyDown), () => {
        document.removeEventListener("keydown", handleKeyDown);
      };
    }, [hotkey, context.toastCount]), react.useEffect(() => {
      if (!esm/* isWeb */.$L || context.toastCount === 0) return;
      const wrapper = wrapperRef.current,
        viewport = ref.current;
      if (hasToasts && wrapper && viewport) {
        const handlePause = () => {
            if (!context.isClosePausedRef.current) {
              const pauseEvent = new CustomEvent(VIEWPORT_PAUSE);
              viewport.dispatchEvent(pauseEvent), context.isClosePausedRef.current = !0;
            }
          },
          handleResume = () => {
            if (context.isClosePausedRef.current) {
              const resumeEvent = new CustomEvent(VIEWPORT_RESUME);
              viewport.dispatchEvent(resumeEvent), context.isClosePausedRef.current = !1;
            }
          },
          handleFocusOutResume = event => {
            !wrapper.contains(event.relatedTarget) && handleResume();
          },
          handlePointerLeaveResume = () => {
            wrapper.contains(document.activeElement) || handleResume();
          };
        return wrapper.addEventListener("focusin", handlePause), wrapper.addEventListener("focusout", handleFocusOutResume), wrapper.addEventListener("pointermove", handlePause), wrapper.addEventListener("pointerleave", handlePointerLeaveResume), window.addEventListener("blur", handlePause), window.addEventListener("focus", handleResume), () => {
          wrapper.removeEventListener("focusin", handlePause), wrapper.removeEventListener("focusout", handleFocusOutResume), wrapper.removeEventListener("pointermove", handlePause), wrapper.removeEventListener("pointerleave", handlePointerLeaveResume), window.removeEventListener("blur", handlePause), window.removeEventListener("focus", handleResume);
        };
      }
    }, [hasToasts, context.isClosePausedRef, context.toastCount]);
    const getSortedTabbableCandidates = react.useCallback(({
      tabbingDirection
    }) => {
      const tabbableCandidates = getItems().map(toastItem => {
        const toastNode = toastItem.ref.current,
          toastTabbableCandidates = [toastNode, ...getTabbableCandidates(toastNode)];
        return tabbingDirection === "forwards" ? toastTabbableCandidates : toastTabbableCandidates.reverse();
      });
      return (tabbingDirection === "forwards" ? tabbableCandidates.reverse() : tabbableCandidates).flat();
    }, [getItems]);
    react.useEffect(() => {
      if (!esm/* isWeb */.$L || context.toastCount === 0) return;
      const viewport = ref.current;
      if (viewport) {
        const handleKeyDown = event => {
          const isMetaKey = event.altKey || event.ctrlKey || event.metaKey;
          if (event.key === "Tab" && !isMetaKey) {
            const focusedElement = document.activeElement,
              isTabbingBackwards = event.shiftKey;
            if (event.target === viewport && isTabbingBackwards) {
              headFocusProxyRef.current?.focus();
              return;
            }
            const sortedCandidates = getSortedTabbableCandidates({
                tabbingDirection: isTabbingBackwards ? "backwards" : "forwards"
              }),
              index = sortedCandidates.findIndex(candidate => candidate === focusedElement);
            focusFirst(sortedCandidates.slice(index + 1)) ? event.preventDefault() : isTabbingBackwards ?
            // @ts-ignore ali TODO type
            headFocusProxyRef.current?.focus() :
            // @ts-ignore ali TODO type
            tailFocusProxyRef.current?.focus();
          }
        };
        return viewport.addEventListener("keydown", handleKeyDown), () => viewport.removeEventListener("keydown", handleKeyDown);
      }
    }, [getItems, getSortedTabbableCandidates, context.toastCount]);
    const contents = /* @__PURE__ */(0,jsx_runtime.jsxs)(ToastViewportWrapperFrame, {
      ref: wrapperRef,
      role: "region",
      "aria-label": label.replace("{hotkey}", hotkeyLabel),
      tabIndex: -1,
      children: [hasToasts && /* @__PURE__ */(0,jsx_runtime.jsx)(FocusProxy, {
        __scopeToast,
        viewportName: name,
        ref: headFocusProxyRef,
        onFocusFromOutsideViewport: () => {
          const tabbableCandidates = getSortedTabbableCandidates({
            tabbingDirection: "forwards"
          });
          focusFirst(tabbableCandidates);
        }
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(ToastProvider/* Collection.Slot */.FE.Slot, {
        __scopeCollection: __scopeToast || constants/* TOAST_CONTEXT */.B,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(ToastViewportFrame, {
          focusable: context.toastCount > 0,
          ref: composedRefs,
          ...viewportProps,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(dist_esm/* PortalHost */.$2, {
            render: children => /* @__PURE__ */(0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
              exitBeforeEnter: !multipleToasts,
              children
            }),
            name: name ?? "default"
          })
        })
      }), hasToasts && /* @__PURE__ */(0,jsx_runtime.jsx)(FocusProxy, {
        __scopeToast,
        viewportName: name,
        ref: tailFocusProxyRef,
        onFocusFromOutsideViewport: () => {
          const tabbableCandidates = getSortedTabbableCandidates({
            tabbingDirection: "backwards"
          });
          focusFirst(tabbableCandidates);
        }
      })]
    });
    return portalToRoot ? /* @__PURE__ */(0,jsx_runtime.jsx)(ToastPortal, {
      ...(typeof zIndex == "number" ? {
        zIndex
      } : {}),
      children: contents
    }) : contents;
  }));
ToastViewport.displayName = VIEWPORT_NAME;
const FOCUS_PROXY_NAME = "ToastFocusProxy",
  FocusProxy = react.forwardRef((props, forwardedRef) => {
    const {
        __scopeToast,
        onFocusFromOutsideViewport,
        viewportName,
        ...proxyProps
      } = props,
      viewport = (0,ToastProvider/* useToastProviderContext */.jz)(__scopeToast).viewports[viewportName];
    return /* @__PURE__ */(0,jsx_runtime.jsx)(VisuallyHidden/* VisuallyHidden */.T, {
      "aria-hidden": !0,
      tabIndex: 0,
      ...proxyProps,
      ref: forwardedRef,
      position: esm/* isWeb */.$L ? "fixed" : "absolute",
      onFocus: event => {
        if (!esm/* isWeb */.$L) return;
        const prevFocusedElement = event.relatedTarget;
        !viewport?.contains(prevFocusedElement) && onFocusFromOutsideViewport();
      }
    });
  });
FocusProxy.displayName = FOCUS_PROXY_NAME;
function focusFirst(candidates) {
  if (!esm/* isWeb */.$L) return;
  const previouslyFocusedElement = document.activeElement;
  return candidates.some(candidate => candidate === previouslyFocusedElement ? !0 : (candidate.focus(), document.activeElement !== previouslyFocusedElement));
}
function getTabbableCandidates(container) {
  if (!esm/* isWeb */.$L) return [];
  const containerHtml = container,
    nodes = [],
    walker = document.createTreeWalker(containerHtml, NodeFilter.SHOW_ELEMENT, {
      acceptNode: node => {
        const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
        return node.disabled || node.hidden || isHiddenInput ? NodeFilter.FILTER_SKIP : node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });
  for (; walker.nextNode();) nodes.push(walker.currentNode);
  return nodes;
}

//# sourceMappingURL=ToastViewport.mjs.map


/***/ }),

/***/ 20335:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ TOAST_CONTEXT; },
/* harmony export */   "F": function() { return /* binding */ TOAST_NAME; }
/* harmony export */ });
const TOAST_NAME = "Toast",
  TOAST_CONTEXT = "Toast";

//# sourceMappingURL=constants.mjs.map


/***/ }),

/***/ 22827:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ useConstant; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useConstant(fn) {
  if (typeof document > "u") return react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => fn(), []);
  const ref = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  return ref.current || (ref.current = {
    v: fn()
  }), ref.current.v;
}

//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 96039:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SZ": function() { return /* binding */ useDidFinishSSR; }
/* harmony export */ });
/* unused harmony exports useClientValue, useDidFinishSSRSync */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const emptyFn = () => {},
  emptyFnFn = () => emptyFn;
function useDidFinishSSR(value, options) {
  if (options?.sync) return react__WEBPACK_IMPORTED_MODULE_0__.useSyncExternalStore(emptyFnFn, () => value ?? !0, () => !1);
  const [cur, setCur] = react__WEBPACK_IMPORTED_MODULE_0__.useState(value);
  return react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    setCur(value ?? !0);
  }, []), cur ?? !1;
}
function useDidFinishSSRSync(value) {
  return useDidFinishSSR(value, {
    sync: !0
  });
}
function useClientValue(value) {
  return useDidFinishSSR() ? typeof value == "function" ? value() : value : void 0;
}

//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 61360:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Oy": function() { return /* reexport */ PresenceContext; },
  "il": function() { return /* reexport */ ResetPresence; },
  "hO": function() { return /* reexport */ useIsPresent; },
  "oO": function() { return /* reexport */ usePresence; }
});

// UNUSED EXPORTS: isPresent

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@tamagui/use-presence/dist/esm/PresenceContext.mjs


const PresenceContext = react.createContext(null),
  ResetPresence = props => /* @__PURE__ */(0,jsx_runtime.jsx)(PresenceContext.Provider, {
    value: null,
    children: props.children
  });

//# sourceMappingURL=PresenceContext.mjs.map

;// CONCATENATED MODULE: ./node_modules/@tamagui/use-presence/dist/esm/usePresence.mjs


function usePresence() {
  const context = react.useContext(PresenceContext);
  if (!context) return [!0, null, context];
  const {
    id,
    isPresent: isPresent2,
    onExitComplete,
    register
  } = context;
  return react.useEffect(() => register(id), []), !isPresent2 && onExitComplete ? [!1, () => onExitComplete?.(id), context] : [!0, void 0, context];
}
function useIsPresent() {
  return isPresent(react.useContext(PresenceContext));
}
function isPresent(context) {
  return context === null ? !0 : context.isPresent;
}

//# sourceMappingURL=usePresence.mjs.map

;// CONCATENATED MODULE: ./node_modules/@tamagui/use-presence/dist/esm/index.mjs


//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 68648:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ VisuallyHidden; }
/* harmony export */ });
/* harmony import */ var _tamagui_web__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17187);

const VisuallyHidden = (0,_tamagui_web__WEBPACK_IMPORTED_MODULE_0__.styled)(_tamagui_web__WEBPACK_IMPORTED_MODULE_0__.Text, {
  position: "absolute",
  width: 1,
  height: 1,
  margin: -1,
  zIndex: -1e4,
  overflow: "hidden",
  opacity: 1e-8,
  pointerEvents: "none",
  variants: {
    preserveDimensions: {
      true: {
        position: "relative",
        width: "auto",
        height: "auto"
      }
    },
    visible: {
      true: {
        position: "relative",
        width: "auto",
        height: "auto",
        margin: 0,
        zIndex: 1,
        overflow: "visible",
        opacity: 1,
        pointerEvents: "auto"
      }
    }
  }
});
VisuallyHidden.isVisuallyHidden = !0;

//# sourceMappingURL=VisuallyHidden.mjs.map


/***/ }),

/***/ 65759:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "XF": function() { return /* reexport */ ClientError; },
  "g6": function() { return /* reexport */ GraphQLClient_GraphQLClient; }
});

// UNUSED EXPORTS: analyzeDocument, batchRequests, default, gql, rawRequest, request

;// CONCATENATED MODULE: ./node_modules/graphql-request/build/legacy/classes/ClientError.js
class ClientError extends Error {
    response;
    request;
    constructor(response, request) {
        const message = `${ClientError.extractMessage(response)}: ${JSON.stringify({
            response,
            request,
        })}`;
        super(message);
        Object.setPrototypeOf(this, ClientError.prototype);
        this.response = response;
        this.request = request;
        // this is needed as Safari doesn't support .captureStackTrace
        if (typeof Error.captureStackTrace === `function`) {
            Error.captureStackTrace(this, ClientError);
        }
    }
    static extractMessage(response) {
        return response.errors?.[0]?.message ?? `GraphQL Error (Code: ${String(response.status)})`;
    }
}
//# sourceMappingURL=ClientError.js.map
;// CONCATENATED MODULE: ./node_modules/graphql-request/build/lib/prelude.js
/* provided dependency */ var process = __webpack_require__(34155);
const uppercase = (str) => str.toUpperCase();
const callOrIdentity = (value) => {
    return typeof value === `function` ? value() : value;
};
const zip = (a, b) => a.map((k, i) => [k, b[i]]);
const HeadersInitToPlainObject = (headers) => {
    let oHeaders = {};
    if (headers instanceof Headers) {
        oHeaders = HeadersInstanceToPlainObject(headers);
    }
    else if (Array.isArray(headers)) {
        headers.forEach(([name, value]) => {
            if (name && value !== undefined) {
                oHeaders[name] = value;
            }
        });
    }
    else if (headers) {
        oHeaders = headers;
    }
    return oHeaders;
};
const HeadersInstanceToPlainObject = (headers) => {
    const o = {};
    headers.forEach((v, k) => {
        o[k] = v;
    });
    return o;
};
const tryCatch = (fn) => {
    try {
        const result = fn();
        if (isPromiseLikeValue(result)) {
            return result.catch((error) => {
                return errorFromMaybeError(error);
            });
        }
        return result;
    }
    catch (error) {
        return errorFromMaybeError(error);
    }
};
/**
 * Ensure that the given value is an error and return it. If it is not an error than
 * wrap it in one, passing the given value as the error message.
 */
const errorFromMaybeError = (maybeError) => {
    if (maybeError instanceof Error)
        return maybeError;
    return new Error(String(maybeError));
};
const isPromiseLikeValue = (value) => {
    return (typeof value === `object`
        && value !== null
        && `then` in value
        && typeof value.then === `function`
        && `catch` in value
        && typeof value.catch === `function`
        && `finally` in value
        && typeof value.finally === `function`);
};
const casesExhausted = (value) => {
    throw new Error(`Unhandled case: ${String(value)}`);
};
const isPlainObject = (value) => {
    return typeof value === `object` && value !== null && !Array.isArray(value);
};
const entries = (obj) => Object.entries(obj);
const values = (obj) => Object.values(obj);
const mapValues = (object, fn) => {
    return Object.fromEntries(Object.entries(object).map(([key, value]) => {
        return [key, fn(value, key)];
    }));
};
const lowerCaseFirstLetter = (s) => {
    return s.charAt(0).toLowerCase() + s.slice(1);
};
function assertArray(v) {
    if (!Array.isArray(v))
        throw new Error(`Expected array. Got: ${String(v)}`);
}
function assertObject(v) {
    if (v === null || typeof v !== `object`)
        throw new Error(`Expected object. Got: ${String(v)}`);
}
const capitalizeFirstLetter = (string) => string.charAt(0).toUpperCase() + string.slice(1);
const createDeferred = (options) => {
    let isResolved = false;
    let resolve;
    let reject;
    const promise = new Promise(($resolve, $reject) => {
        resolve = $resolve;
        reject = $reject;
    });
    return {
        promise,
        isResolved: () => isResolved,
        resolve: (value) => {
            isResolved = true;
            if (options?.strict && isResolved) {
                throw new Error(`Deferred is already resolved. Attempted to resolve with: ${JSON.stringify(value)}`);
            }
            resolve(value);
        },
        reject: (error) => reject(error),
    };
};
const debug = (...args) => {
    if (process.env[`DEBUG`]) {
        console.log(...args);
    }
};
const debugSub = (...args) => (...subArgs) => {
    debug(...args, ...subArgs);
};
const partitionErrors = (array) => {
    const errors = [];
    const values = [];
    for (const item of array) {
        if (item instanceof Error) {
            errors.push(item);
        }
        else {
            values.push(item);
        }
    }
    return [values, errors];
};
//# sourceMappingURL=prelude.js.map
;// CONCATENATED MODULE: ./node_modules/graphql-request/build/legacy/functions/batchRequests.js

/**
 * Send a batch of GraphQL Document to the GraphQL server for execution.
 *
 * @example
 *
 * ```ts
 * // You can pass a raw string
 *
 * await batchRequests('https://foo.bar/graphql', [
 * {
 *  query: `
 *   {
 *     query {
 *       users
 *     }
 *   }`
 * },
 * {
 *   query: `
 *   {
 *     query {
 *       users
 *     }
 *   }`
 * }])
 *
 * // You can also pass a GraphQL DocumentNode as query. Convenient if you
 * // are using graphql-tag package.
 *
 * import gql from 'graphql-tag'
 *
 * await batchRequests('https://foo.bar/graphql', [{ query: gql`...` }])
 * ```
 */
const batchRequests = async (...args) => {
    const params = parseBatchRequestsArgsExtended(args);
    const client = new GraphQLClient(params.url);
    return client.batchRequests(params);
};
const parseBatchRequestsArgsExtended = (args) => {
    if (args.length === 1) {
        return args[0];
    }
    else {
        return {
            url: args[0],
            documents: args[1],
            requestHeaders: args[2],
            signal: undefined,
        };
    }
};
const parseBatchRequestArgs = (documentsOrOptions, requestHeaders) => {
    // eslint-disable-next-line
    return documentsOrOptions.documents
        ? documentsOrOptions
        : {
            documents: documentsOrOptions,
            requestHeaders: requestHeaders,
            signal: undefined,
        };
};
//# sourceMappingURL=batchRequests.js.map
;// CONCATENATED MODULE: ./node_modules/graphql-request/build/legacy/functions/rawRequest.js

/**
 * Send a GraphQL Query to the GraphQL server for execution.
 */
const rawRequest = async (...args) => {
    const [urlOrOptions, query, ...variablesAndRequestHeaders] = args;
    const requestOptions = parseRawRequestExtendedArgs(urlOrOptions, query, ...variablesAndRequestHeaders);
    const client = new GraphQLClient(requestOptions.url);
    return client.rawRequest({
        ...requestOptions,
    });
};
const parseRawRequestExtendedArgs = (urlOrOptions, query, ...variablesAndRequestHeaders) => {
    const [variables, requestHeaders] = variablesAndRequestHeaders;
    return typeof urlOrOptions === `string`
        ? {
            url: urlOrOptions,
            query: query,
            variables,
            requestHeaders,
            signal: undefined,
        }
        : urlOrOptions;
};
const parseRawRequestArgs = (queryOrOptions, variables, requestHeaders) => {
    return queryOrOptions.query
        ? queryOrOptions
        : {
            query: queryOrOptions,
            variables: variables,
            requestHeaders: requestHeaders,
            signal: undefined,
        };
};
//# sourceMappingURL=rawRequest.js.map
// EXTERNAL MODULE: ./node_modules/graphql/language/kinds.mjs
var kinds = __webpack_require__(97359);
;// CONCATENATED MODULE: ./node_modules/graphql-request/build/lib/http.js
const ACCEPT_HEADER = `Accept`;
const CONTENT_TYPE_HEADER = `Content-Type`;
const CONTENT_TYPE_JSON = `application/json`;
const CONTENT_TYPE_GQL = `application/graphql-response+json`;
const statusCodes = {
    success: 200,
};
//# sourceMappingURL=http.js.map
;// CONCATENATED MODULE: ./node_modules/graphql-request/build/legacy/lib/graphql.js



/**
 * Clean a GraphQL document to send it via a GET query
 */
const cleanQuery = (str) => str.replace(/([\s,]|#[^\n\r]+)+/g, ` `).trim();
const isGraphQLContentType = (contentType) => {
    const contentTypeLower = contentType.toLowerCase();
    return contentTypeLower.includes(CONTENT_TYPE_GQL) || contentTypeLower.includes(CONTENT_TYPE_JSON);
};
const parseGraphQLExecutionResult = (result) => {
    try {
        if (Array.isArray(result)) {
            return {
                _tag: `Batch`,
                executionResults: result.map(parseExecutionResult),
            };
        }
        else if (isPlainObject(result)) {
            return {
                _tag: `Single`,
                executionResult: parseExecutionResult(result),
            };
        }
        else {
            throw new Error(`Invalid execution result: result is not object or array. \nGot:\n${String(result)}`);
        }
    }
    catch (e) {
        return e;
    }
};
/**
 * Example result:
 *
 * ```
 * {
 *  "data": null,
 *  "errors": [{
 *    "message": "custom error",
 *    "locations": [{ "line": 2, "column": 3 }],
 *    "path": ["playerNew"]
 *  }]
 * }
 * ```
 */
const parseExecutionResult = (result) => {
    if (typeof result !== `object` || result === null) {
        throw new Error(`Invalid execution result: result is not object`);
    }
    let errors = undefined;
    let data = undefined;
    let extensions = undefined;
    if (`errors` in result) {
        if (!isPlainObject(result.errors) && !Array.isArray(result.errors)) {
            throw new Error(`Invalid execution result: errors is not plain object OR array`); // prettier-ignore
        }
        errors = result.errors;
    }
    // todo add test coverage for case of null. @see https://github.com/jasonkuhrt/graphql-request/issues/739
    if (`data` in result) {
        if (!isPlainObject(result.data) && result.data !== null) {
            throw new Error(`Invalid execution result: data is not plain object`); // prettier-ignore
        }
        data = result.data;
    }
    if (`extensions` in result) {
        if (!isPlainObject(result.extensions))
            throw new Error(`Invalid execution result: extensions is not plain object`); // prettier-ignore
        extensions = result.extensions;
    }
    return {
        data,
        errors,
        extensions,
    };
};
const isRequestResultHaveErrors = (result) => result._tag === `Batch`
    ? result.executionResults.some(isExecutionResultHaveErrors)
    : isExecutionResultHaveErrors(result.executionResult);
const isExecutionResultHaveErrors = (result) => Array.isArray(result.errors) ? result.errors.length > 0 : Boolean(result.errors);
const isOperationDefinitionNode = (definition) => {
    return (typeof definition === `object`
        && definition !== null
        && `kind` in definition
        && definition.kind === kinds/* Kind.OPERATION_DEFINITION */.h.OPERATION_DEFINITION);
};
//# sourceMappingURL=graphql.js.map
// EXTERNAL MODULE: ./node_modules/graphql/language/parser.mjs + 11 modules
var parser = __webpack_require__(86355);
// EXTERNAL MODULE: ./node_modules/graphql/language/blockString.mjs
var blockString = __webpack_require__(87392);
;// CONCATENATED MODULE: ./node_modules/graphql/language/printString.mjs
/**
 * Prints a string as a GraphQL StringValue literal. Replaces control characters
 * and excluded characters (" U+0022 and \\ U+005C) with escape sequences.
 */
function printString(str) {
  return `"${str.replace(escapedRegExp, escapedReplacer)}"`;
} // eslint-disable-next-line no-control-regex

const escapedRegExp = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;

function escapedReplacer(str) {
  return escapeSequences[str.charCodeAt(0)];
} // prettier-ignore

const escapeSequences = [
  '\\u0000',
  '\\u0001',
  '\\u0002',
  '\\u0003',
  '\\u0004',
  '\\u0005',
  '\\u0006',
  '\\u0007',
  '\\b',
  '\\t',
  '\\n',
  '\\u000B',
  '\\f',
  '\\r',
  '\\u000E',
  '\\u000F',
  '\\u0010',
  '\\u0011',
  '\\u0012',
  '\\u0013',
  '\\u0014',
  '\\u0015',
  '\\u0016',
  '\\u0017',
  '\\u0018',
  '\\u0019',
  '\\u001A',
  '\\u001B',
  '\\u001C',
  '\\u001D',
  '\\u001E',
  '\\u001F',
  '',
  '',
  '\\"',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 2F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 3F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 4F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '\\\\',
  '',
  '',
  '', // 5F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 6F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '\\u007F',
  '\\u0080',
  '\\u0081',
  '\\u0082',
  '\\u0083',
  '\\u0084',
  '\\u0085',
  '\\u0086',
  '\\u0087',
  '\\u0088',
  '\\u0089',
  '\\u008A',
  '\\u008B',
  '\\u008C',
  '\\u008D',
  '\\u008E',
  '\\u008F',
  '\\u0090',
  '\\u0091',
  '\\u0092',
  '\\u0093',
  '\\u0094',
  '\\u0095',
  '\\u0096',
  '\\u0097',
  '\\u0098',
  '\\u0099',
  '\\u009A',
  '\\u009B',
  '\\u009C',
  '\\u009D',
  '\\u009E',
  '\\u009F',
];

// EXTERNAL MODULE: ./node_modules/graphql/jsutils/devAssert.mjs
var devAssert = __webpack_require__(37826);
// EXTERNAL MODULE: ./node_modules/graphql/jsutils/inspect.mjs
var inspect = __webpack_require__(25821);
// EXTERNAL MODULE: ./node_modules/graphql/language/ast.mjs
var ast = __webpack_require__(72380);
;// CONCATENATED MODULE: ./node_modules/graphql/language/visitor.mjs




/**
 * A visitor is provided to visit, it contains the collection of
 * relevant functions to be called during the visitor's traversal.
 */

const BREAK = Object.freeze({});
/**
 * visit() will walk through an AST using a depth-first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 *
 * ```ts
 * const editedAST = visit(ast, {
 *   enter(node, key, parent, path, ancestors) {
 *     // @return
 *     //   undefined: no action
 *     //   false: skip visiting this node
 *     //   visitor.BREAK: stop visiting altogether
 *     //   null: delete this node
 *     //   any value: replace this node with the returned value
 *   },
 *   leave(node, key, parent, path, ancestors) {
 *     // @return
 *     //   undefined: no action
 *     //   false: no action
 *     //   visitor.BREAK: stop visiting altogether
 *     //   null: delete this node
 *     //   any value: replace this node with the returned value
 *   }
 * });
 * ```
 *
 * Alternatively to providing enter() and leave() functions, a visitor can
 * instead provide functions named the same as the kinds of AST nodes, or
 * enter/leave visitors at a named key, leading to three permutations of the
 * visitor API:
 *
 * 1) Named visitors triggered when entering a node of a specific kind.
 *
 * ```ts
 * visit(ast, {
 *   Kind(node) {
 *     // enter the "Kind" node
 *   }
 * })
 * ```
 *
 * 2) Named visitors that trigger upon entering and leaving a node of a specific kind.
 *
 * ```ts
 * visit(ast, {
 *   Kind: {
 *     enter(node) {
 *       // enter the "Kind" node
 *     }
 *     leave(node) {
 *       // leave the "Kind" node
 *     }
 *   }
 * })
 * ```
 *
 * 3) Generic visitors that trigger upon entering and leaving any node.
 *
 * ```ts
 * visit(ast, {
 *   enter(node) {
 *     // enter any node
 *   },
 *   leave(node) {
 *     // leave any node
 *   }
 * })
 * ```
 */

function visit(root, visitor, visitorKeys = ast/* QueryDocumentKeys */.h8) {
  const enterLeaveMap = new Map();

  for (const kind of Object.values(kinds/* Kind */.h)) {
    enterLeaveMap.set(kind, getEnterLeaveForKind(visitor, kind));
  }
  /* eslint-disable no-undef-init */

  let stack = undefined;
  let inArray = Array.isArray(root);
  let keys = [root];
  let index = -1;
  let edits = [];
  let node = root;
  let key = undefined;
  let parent = undefined;
  const path = [];
  const ancestors = [];
  /* eslint-enable no-undef-init */

  do {
    index++;
    const isLeaving = index === keys.length;
    const isEdited = isLeaving && edits.length !== 0;

    if (isLeaving) {
      key = ancestors.length === 0 ? undefined : path[path.length - 1];
      node = parent;
      parent = ancestors.pop();

      if (isEdited) {
        if (inArray) {
          node = node.slice();
          let editOffset = 0;

          for (const [editKey, editValue] of edits) {
            const arrayKey = editKey - editOffset;

            if (editValue === null) {
              node.splice(arrayKey, 1);
              editOffset++;
            } else {
              node[arrayKey] = editValue;
            }
          }
        } else {
          node = { ...node };

          for (const [editKey, editValue] of edits) {
            node[editKey] = editValue;
          }
        }
      }

      index = stack.index;
      keys = stack.keys;
      edits = stack.edits;
      inArray = stack.inArray;
      stack = stack.prev;
    } else if (parent) {
      key = inArray ? index : keys[index];
      node = parent[key];

      if (node === null || node === undefined) {
        continue;
      }

      path.push(key);
    }

    let result;

    if (!Array.isArray(node)) {
      var _enterLeaveMap$get, _enterLeaveMap$get2;

      (0,ast/* isNode */.UG)(node) || (0,devAssert/* devAssert */.a)(false, `Invalid AST Node: ${(0,inspect/* inspect */.X)(node)}.`);
      const visitFn = isLeaving
        ? (_enterLeaveMap$get = enterLeaveMap.get(node.kind)) === null ||
          _enterLeaveMap$get === void 0
          ? void 0
          : _enterLeaveMap$get.leave
        : (_enterLeaveMap$get2 = enterLeaveMap.get(node.kind)) === null ||
          _enterLeaveMap$get2 === void 0
        ? void 0
        : _enterLeaveMap$get2.enter;
      result =
        visitFn === null || visitFn === void 0
          ? void 0
          : visitFn.call(visitor, node, key, parent, path, ancestors);

      if (result === BREAK) {
        break;
      }

      if (result === false) {
        if (!isLeaving) {
          path.pop();
          continue;
        }
      } else if (result !== undefined) {
        edits.push([key, result]);

        if (!isLeaving) {
          if ((0,ast/* isNode */.UG)(result)) {
            node = result;
          } else {
            path.pop();
            continue;
          }
        }
      }
    }

    if (result === undefined && isEdited) {
      edits.push([key, node]);
    }

    if (isLeaving) {
      path.pop();
    } else {
      var _node$kind;

      stack = {
        inArray,
        index,
        keys,
        edits,
        prev: stack,
      };
      inArray = Array.isArray(node);
      keys = inArray
        ? node
        : (_node$kind = visitorKeys[node.kind]) !== null &&
          _node$kind !== void 0
        ? _node$kind
        : [];
      index = -1;
      edits = [];

      if (parent) {
        ancestors.push(parent);
      }

      parent = node;
    }
  } while (stack !== undefined);

  if (edits.length !== 0) {
    // New root
    return edits[edits.length - 1][1];
  }

  return root;
}
/**
 * Creates a new visitor instance which delegates to many visitors to run in
 * parallel. Each visitor will be visited for each node before moving on.
 *
 * If a prior visitor edits a node, no following visitors will see that node.
 */

function visitInParallel(visitors) {
  const skipping = new Array(visitors.length).fill(null);
  const mergedVisitor = Object.create(null);

  for (const kind of Object.values(Kind)) {
    let hasVisitor = false;
    const enterList = new Array(visitors.length).fill(undefined);
    const leaveList = new Array(visitors.length).fill(undefined);

    for (let i = 0; i < visitors.length; ++i) {
      const { enter, leave } = getEnterLeaveForKind(visitors[i], kind);
      hasVisitor || (hasVisitor = enter != null || leave != null);
      enterList[i] = enter;
      leaveList[i] = leave;
    }

    if (!hasVisitor) {
      continue;
    }

    const mergedEnterLeave = {
      enter(...args) {
        const node = args[0];

        for (let i = 0; i < visitors.length; i++) {
          if (skipping[i] === null) {
            var _enterList$i;

            const result =
              (_enterList$i = enterList[i]) === null || _enterList$i === void 0
                ? void 0
                : _enterList$i.apply(visitors[i], args);

            if (result === false) {
              skipping[i] = node;
            } else if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined) {
              return result;
            }
          }
        }
      },

      leave(...args) {
        const node = args[0];

        for (let i = 0; i < visitors.length; i++) {
          if (skipping[i] === null) {
            var _leaveList$i;

            const result =
              (_leaveList$i = leaveList[i]) === null || _leaveList$i === void 0
                ? void 0
                : _leaveList$i.apply(visitors[i], args);

            if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined && result !== false) {
              return result;
            }
          } else if (skipping[i] === node) {
            skipping[i] = null;
          }
        }
      },
    };
    mergedVisitor[kind] = mergedEnterLeave;
  }

  return mergedVisitor;
}
/**
 * Given a visitor instance and a node kind, return EnterLeaveVisitor for that kind.
 */

function getEnterLeaveForKind(visitor, kind) {
  const kindVisitor = visitor[kind];

  if (typeof kindVisitor === 'object') {
    // { Kind: { enter() {}, leave() {} } }
    return kindVisitor;
  } else if (typeof kindVisitor === 'function') {
    // { Kind() {} }
    return {
      enter: kindVisitor,
      leave: undefined,
    };
  } // { enter() {}, leave() {} }

  return {
    enter: visitor.enter,
    leave: visitor.leave,
  };
}
/**
 * Given a visitor instance, if it is leaving or not, and a node kind, return
 * the function the visitor runtime should call.
 *
 * @deprecated Please use `getEnterLeaveForKind` instead. Will be removed in v17
 */

/* c8 ignore next 8 */

function getVisitFn(visitor, kind, isLeaving) {
  const { enter, leave } = getEnterLeaveForKind(visitor, kind);
  return isLeaving ? leave : enter;
}

;// CONCATENATED MODULE: ./node_modules/graphql/language/printer.mjs



/**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 */

function print(ast) {
  return visit(ast, printDocASTReducer);
}
const MAX_LINE_LENGTH = 80;
const printDocASTReducer = {
  Name: {
    leave: (node) => node.value,
  },
  Variable: {
    leave: (node) => '$' + node.name,
  },
  // Document
  Document: {
    leave: (node) => join(node.definitions, '\n\n'),
  },
  OperationDefinition: {
    leave(node) {
      const varDefs = hasMultilineItems(node.variableDefinitions)
        ? wrap('(\n', join(node.variableDefinitions, '\n'), '\n)')
        : wrap('(', join(node.variableDefinitions, ', '), ')');
      const prefix =
        wrap('', node.description, '\n') +
        join(
          [
            node.operation,
            join([node.name, varDefs]),
            join(node.directives, ' '),
          ],
          ' ',
        ); // Anonymous queries with no directives or variable definitions can use
      // the query short form.

      return (prefix === 'query' ? '' : prefix + ' ') + node.selectionSet;
    },
  },
  VariableDefinition: {
    leave: ({ variable, type, defaultValue, directives, description }) =>
      wrap('', description, '\n') +
      variable +
      ': ' +
      type +
      wrap(' = ', defaultValue) +
      wrap(' ', join(directives, ' ')),
  },
  SelectionSet: {
    leave: ({ selections }) => block(selections),
  },
  Field: {
    leave({ alias, name, arguments: args, directives, selectionSet }) {
      const prefix = wrap('', alias, ': ') + name;
      let argsLine = prefix + wrap('(', join(args, ', '), ')');

      if (argsLine.length > MAX_LINE_LENGTH) {
        argsLine = prefix + wrap('(\n', indent(join(args, '\n')), '\n)');
      }

      return join([argsLine, join(directives, ' '), selectionSet], ' ');
    },
  },
  Argument: {
    leave: ({ name, value }) => name + ': ' + value,
  },
  // Fragments
  FragmentSpread: {
    leave: ({ name, directives }) =>
      '...' + name + wrap(' ', join(directives, ' ')),
  },
  InlineFragment: {
    leave: ({ typeCondition, directives, selectionSet }) =>
      join(
        [
          '...',
          wrap('on ', typeCondition),
          join(directives, ' '),
          selectionSet,
        ],
        ' ',
      ),
  },
  FragmentDefinition: {
    leave: ({
      name,
      typeCondition,
      variableDefinitions,
      directives,
      selectionSet,
      description,
    }) =>
      wrap('', description, '\n') + // Note: fragment variable definitions are experimental and may be changed
      // or removed in the future.
      `fragment ${name}${wrap('(', join(variableDefinitions, ', '), ')')} ` +
      `on ${typeCondition} ${wrap('', join(directives, ' '), ' ')}` +
      selectionSet,
  },
  // Value
  IntValue: {
    leave: ({ value }) => value,
  },
  FloatValue: {
    leave: ({ value }) => value,
  },
  StringValue: {
    leave: ({ value, block: isBlockString }) =>
      isBlockString ? (0,blockString/* printBlockString */.LZ)(value) : printString(value),
  },
  BooleanValue: {
    leave: ({ value }) => (value ? 'true' : 'false'),
  },
  NullValue: {
    leave: () => 'null',
  },
  EnumValue: {
    leave: ({ value }) => value,
  },
  ListValue: {
    leave: ({ values }) => '[' + join(values, ', ') + ']',
  },
  ObjectValue: {
    leave: ({ fields }) => '{' + join(fields, ', ') + '}',
  },
  ObjectField: {
    leave: ({ name, value }) => name + ': ' + value,
  },
  // Directive
  Directive: {
    leave: ({ name, arguments: args }) =>
      '@' + name + wrap('(', join(args, ', '), ')'),
  },
  // Type
  NamedType: {
    leave: ({ name }) => name,
  },
  ListType: {
    leave: ({ type }) => '[' + type + ']',
  },
  NonNullType: {
    leave: ({ type }) => type + '!',
  },
  // Type System Definitions
  SchemaDefinition: {
    leave: ({ description, directives, operationTypes }) =>
      wrap('', description, '\n') +
      join(['schema', join(directives, ' '), block(operationTypes)], ' '),
  },
  OperationTypeDefinition: {
    leave: ({ operation, type }) => operation + ': ' + type,
  },
  ScalarTypeDefinition: {
    leave: ({ description, name, directives }) =>
      wrap('', description, '\n') +
      join(['scalar', name, join(directives, ' ')], ' '),
  },
  ObjectTypeDefinition: {
    leave: ({ description, name, interfaces, directives, fields }) =>
      wrap('', description, '\n') +
      join(
        [
          'type',
          name,
          wrap('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  FieldDefinition: {
    leave: ({ description, name, arguments: args, type, directives }) =>
      wrap('', description, '\n') +
      name +
      (hasMultilineItems(args)
        ? wrap('(\n', indent(join(args, '\n')), '\n)')
        : wrap('(', join(args, ', '), ')')) +
      ': ' +
      type +
      wrap(' ', join(directives, ' ')),
  },
  InputValueDefinition: {
    leave: ({ description, name, type, defaultValue, directives }) =>
      wrap('', description, '\n') +
      join(
        [name + ': ' + type, wrap('= ', defaultValue), join(directives, ' ')],
        ' ',
      ),
  },
  InterfaceTypeDefinition: {
    leave: ({ description, name, interfaces, directives, fields }) =>
      wrap('', description, '\n') +
      join(
        [
          'interface',
          name,
          wrap('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  UnionTypeDefinition: {
    leave: ({ description, name, directives, types }) =>
      wrap('', description, '\n') +
      join(
        ['union', name, join(directives, ' '), wrap('= ', join(types, ' | '))],
        ' ',
      ),
  },
  EnumTypeDefinition: {
    leave: ({ description, name, directives, values }) =>
      wrap('', description, '\n') +
      join(['enum', name, join(directives, ' '), block(values)], ' '),
  },
  EnumValueDefinition: {
    leave: ({ description, name, directives }) =>
      wrap('', description, '\n') + join([name, join(directives, ' ')], ' '),
  },
  InputObjectTypeDefinition: {
    leave: ({ description, name, directives, fields }) =>
      wrap('', description, '\n') +
      join(['input', name, join(directives, ' '), block(fields)], ' '),
  },
  DirectiveDefinition: {
    leave: ({ description, name, arguments: args, repeatable, locations }) =>
      wrap('', description, '\n') +
      'directive @' +
      name +
      (hasMultilineItems(args)
        ? wrap('(\n', indent(join(args, '\n')), '\n)')
        : wrap('(', join(args, ', '), ')')) +
      (repeatable ? ' repeatable' : '') +
      ' on ' +
      join(locations, ' | '),
  },
  SchemaExtension: {
    leave: ({ directives, operationTypes }) =>
      join(
        ['extend schema', join(directives, ' '), block(operationTypes)],
        ' ',
      ),
  },
  ScalarTypeExtension: {
    leave: ({ name, directives }) =>
      join(['extend scalar', name, join(directives, ' ')], ' '),
  },
  ObjectTypeExtension: {
    leave: ({ name, interfaces, directives, fields }) =>
      join(
        [
          'extend type',
          name,
          wrap('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  InterfaceTypeExtension: {
    leave: ({ name, interfaces, directives, fields }) =>
      join(
        [
          'extend interface',
          name,
          wrap('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  UnionTypeExtension: {
    leave: ({ name, directives, types }) =>
      join(
        [
          'extend union',
          name,
          join(directives, ' '),
          wrap('= ', join(types, ' | ')),
        ],
        ' ',
      ),
  },
  EnumTypeExtension: {
    leave: ({ name, directives, values }) =>
      join(['extend enum', name, join(directives, ' '), block(values)], ' '),
  },
  InputObjectTypeExtension: {
    leave: ({ name, directives, fields }) =>
      join(['extend input', name, join(directives, ' '), block(fields)], ' '),
  },
  // Schema Coordinates
  TypeCoordinate: {
    leave: ({ name }) => name,
  },
  MemberCoordinate: {
    leave: ({ name, memberName }) => join([name, wrap('.', memberName)]),
  },
  ArgumentCoordinate: {
    leave: ({ name, fieldName, argumentName }) =>
      join([name, wrap('.', fieldName), wrap('(', argumentName, ':)')]),
  },
  DirectiveCoordinate: {
    leave: ({ name }) => join(['@', name]),
  },
  DirectiveArgumentCoordinate: {
    leave: ({ name, argumentName }) =>
      join(['@', name, wrap('(', argumentName, ':)')]),
  },
};
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */

function join(maybeArray, separator = '') {
  var _maybeArray$filter$jo;

  return (_maybeArray$filter$jo =
    maybeArray === null || maybeArray === void 0
      ? void 0
      : maybeArray.filter((x) => x).join(separator)) !== null &&
    _maybeArray$filter$jo !== void 0
    ? _maybeArray$filter$jo
    : '';
}
/**
 * Given array, print each item on its own line, wrapped in an indented `{ }` block.
 */

function block(array) {
  return wrap('{\n', indent(join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */

function wrap(start, maybeString, end = '') {
  return maybeString != null && maybeString !== ''
    ? start + maybeString + end
    : '';
}

function indent(str) {
  return wrap('  ', str.replace(/\n/g, '\n  '));
}

function hasMultilineItems(maybeArray) {
  var _maybeArray$some;

  // FIXME: https://github.com/graphql/graphql-js/issues/2203

  /* c8 ignore next */
  return (_maybeArray$some =
    maybeArray === null || maybeArray === void 0
      ? void 0
      : maybeArray.some((str) => str.includes('\n'))) !== null &&
    _maybeArray$some !== void 0
    ? _maybeArray$some
    : false;
}

;// CONCATENATED MODULE: ./node_modules/graphql-request/build/legacy/helpers/analyzeDocument.js




/**
 * helpers
 */
const extractOperationName = (document) => {
    let operationName = undefined;
    const defs = document.definitions.filter(isOperationDefinitionNode);
    if (defs.length === 1) {
        operationName = defs[0].name?.value;
    }
    return operationName;
};
const extractIsMutation = (document) => {
    let isMutation = false;
    const defs = document.definitions.filter(isOperationDefinitionNode);
    if (defs.length === 1) {
        /* eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison --
         * graphql@15's `OperationTypeNode` is a type, but graphql@16's `OperationTypeNode` is a native TypeScript enum
         * Therefore, we cannot use `OperationTypeNode.MUTATION` here because it wouldn't work with graphql@15
         **/
        isMutation = defs[0].operation === `mutation`;
    }
    return isMutation;
};
const analyzeDocument = (document, excludeOperationName) => {
    /**
     * Normalize boxed String objects to primitive strings for compatibility with TypedDocumentString.
     *
     * Problem: \@graphql-codegen with `documentMode: 'string'` generates a TypedDocumentString class that
     * extends the built-in String class, creating "boxed String" instances:
     *
     * @see https://github.com/dotansimha/graphql-code-generator/blob/c87b779b9b400813d733fa89dcb16724b30c6d16/packages/plugins/typescript/typed-document-node/src/index.ts#L40-L57
     *
     * ```
     * class TypedDocumentString<TResult, TVariables> extends String
     *   constructor(value: string)
     *     super(value)  // Creates a boxed String object, not a primitive string
     * ```
     *
     * Boxed Strings are objects, not primitives:
     * - `typeof "hello" === "string"` returns true
     * - `typeof new String("hello") === "string"` returns false (returns "object")
     *
     * Without normalization, TypedDocumentString instances would fail the `typeof === 'string'` check
     * and incorrectly be passed to `print()`, which expects a DocumentNode AST, causing a crash.
     *
     * Solution: Detect and convert boxed Strings to primitives using template literal coercion.
     * - Primitive strings pass through (typeof === "string")
     * - DocumentNode objects pass through (have .kind property)
     * - Boxed Strings get converted to primitives (template literal to primitive string)
     *
     * @see https://github.com/graffle-js/graffle/issues/1453
     */
    const normalizedDocument = typeof document === `string` || `kind` in document
        ? document
        : String(document);
    const expression = typeof normalizedDocument === `string` ? normalizedDocument : print(normalizedDocument);
    let isMutation = false;
    let operationName = undefined;
    if (excludeOperationName) {
        return { expression, isMutation, operationName };
    }
    const docNode = tryCatch(() => (typeof normalizedDocument === `string` ? (0,parser/* parse */.Qc)(normalizedDocument) : normalizedDocument));
    if (docNode instanceof Error) {
        return { expression, isMutation, operationName };
    }
    operationName = extractOperationName(docNode);
    isMutation = extractIsMutation(docNode);
    return { expression, operationName, isMutation };
};
//# sourceMappingURL=analyzeDocument.js.map
;// CONCATENATED MODULE: ./node_modules/graphql-request/build/legacy/helpers/defaultJsonSerializer.js
const defaultJsonSerializer = JSON;
//# sourceMappingURL=defaultJsonSerializer.js.map
;// CONCATENATED MODULE: ./node_modules/graphql-request/build/legacy/helpers/runRequest.js





// @ts-expect-error todo
const runRequest = async (input) => {
    // todo make a Config type
    const config = {
        ...input,
        method: input.request._tag === `Single`
            ? input.request.document.isMutation
                ? `POST`
                : uppercase(input.method ?? `post`)
            : input.request.hasMutations
                ? `POST`
                : uppercase(input.method ?? `post`),
        fetchOptions: {
            ...input.fetchOptions,
            errorPolicy: input.fetchOptions.errorPolicy ?? `none`,
        },
    };
    const fetcher = createFetcher(config.method);
    const fetchResponse = await fetcher(config);
    // Read response body text first (can only be read once)
    const body = await fetchResponse.text();
    // Parse response body FIRST, regardless of HTTP status
    // This allows GraphQL errors to be extracted even when HTTP status is 4xx/5xx (fixes #1281)
    let result;
    try {
        result = parseResultFromText(body, fetchResponse.headers.get(CONTENT_TYPE_HEADER), input.fetchOptions.jsonSerializer ?? defaultJsonSerializer);
    }
    catch (error) {
        // If parsing fails, we'll handle it below based on HTTP status
        result = error;
    }
    const clientResponseBase = {
        status: fetchResponse.status,
        headers: fetchResponse.headers,
        body,
    };
    // Handle non-2xx HTTP status codes
    if (!fetchResponse.ok) {
        if (result instanceof Error) {
            // Parse failed - return ClientError without GraphQL data
            // Still returns ClientError (not generic Error) to allow status code access
            return new ClientError({ ...clientResponseBase }, {
                query: input.request._tag === `Single` ? input.request.document.expression : input.request.query,
                variables: input.request.variables,
            });
        }
        // Parse succeeded - return ClientError WITH GraphQL errors/data (fixes #1281)
        const clientResponse = result._tag === `Batch`
            ? { ...result.executionResults, ...clientResponseBase }
            : {
                ...result.executionResult,
                ...clientResponseBase,
            };
        // @ts-expect-error todo
        return new ClientError(clientResponse, {
            query: input.request._tag === `Single` ? input.request.document.expression : input.request.query,
            variables: input.request.variables,
        });
    }
    // For 2xx responses, parse errors should throw
    if (result instanceof Error)
        throw result;
    if (isRequestResultHaveErrors(result) && config.fetchOptions.errorPolicy === `none`) {
        // todo this client response on error is not consistent with the data type for success
        const clientResponse = result._tag === `Batch`
            ? { ...result.executionResults, ...clientResponseBase }
            : {
                ...result.executionResult,
                ...clientResponseBase,
            };
        // @ts-expect-error todo
        return new ClientError(clientResponse, {
            query: input.request._tag === `Single` ? input.request.document.expression : input.request.query,
            variables: input.request.variables,
        });
    }
    switch (result._tag) {
        case `Single`:
            // @ts-expect-error todo
            return {
                ...clientResponseBase,
                ...executionResultClientResponseFields(config)(result.executionResult),
            };
        case `Batch`:
            return {
                ...clientResponseBase,
                data: result.executionResults.map(executionResultClientResponseFields(config)),
            };
        default:
            casesExhausted(result);
    }
};
const executionResultClientResponseFields = ($params) => (executionResult) => {
    return {
        extensions: executionResult.extensions,
        data: executionResult.data,
        errors: $params.fetchOptions.errorPolicy === `all` ? executionResult.errors : undefined,
    };
};
const parseResultFromText = (text, contentType, jsonSerializer) => {
    if (contentType && isGraphQLContentType(contentType)) {
        return parseGraphQLExecutionResult(jsonSerializer.parse(text));
    }
    else {
        // todo what is this good for...? Seems very random/undefined
        return parseGraphQLExecutionResult(text);
    }
};
const createFetcher = (method) => async (params) => {
    const headers = new Headers(params.headers);
    let searchParams = null;
    let body = undefined;
    if (!headers.has(ACCEPT_HEADER)) {
        headers.set(ACCEPT_HEADER, [CONTENT_TYPE_GQL, CONTENT_TYPE_JSON].join(`, `));
    }
    if (method === `POST`) {
        const $jsonSerializer = params.fetchOptions.jsonSerializer ?? defaultJsonSerializer;
        body = $jsonSerializer.stringify(buildBody(params));
        if (typeof body === `string` && !headers.has(CONTENT_TYPE_HEADER)) {
            headers.set(CONTENT_TYPE_HEADER, CONTENT_TYPE_JSON);
        }
    }
    else {
        searchParams = buildQueryParams(params);
    }
    const init = { method, headers, body, ...params.fetchOptions };
    let url = new URL(params.url);
    let initResolved = init;
    if (params.middleware) {
        const result = await Promise.resolve(params.middleware({
            ...init,
            url: params.url,
            operationName: params.request._tag === `Single` ? params.request.document.operationName : undefined,
            variables: params.request.variables,
        }));
        const { url: urlNew, ...initNew } = result;
        url = new URL(urlNew);
        initResolved = initNew;
    }
    if (searchParams) {
        searchParams.forEach((value, name) => {
            url.searchParams.append(name, value);
        });
    }
    const $fetch = params.fetch ?? fetch;
    return await $fetch(url, initResolved);
};
const buildBody = (params) => {
    switch (params.request._tag) {
        case `Single`:
            return {
                query: params.request.document.expression,
                variables: params.request.variables,
                operationName: params.request.document.operationName,
            };
        case `Batch`:
            return zip(params.request.query, params.request.variables ?? []).map(([query, variables]) => ({
                query,
                variables,
            }));
        default:
            throw casesExhausted(params.request);
    }
};
const buildQueryParams = (params) => {
    const $jsonSerializer = params.fetchOptions.jsonSerializer ?? defaultJsonSerializer;
    const searchParams = new URLSearchParams();
    switch (params.request._tag) {
        case `Single`: {
            searchParams.append(`query`, cleanQuery(params.request.document.expression));
            if (params.request.variables) {
                searchParams.append(`variables`, $jsonSerializer.stringify(params.request.variables));
            }
            if (params.request.document.operationName) {
                searchParams.append(`operationName`, params.request.document.operationName);
            }
            return searchParams;
        }
        case `Batch`: {
            const variablesSerialized = params.request.variables?.map((v) => $jsonSerializer.stringify(v)) ?? [];
            const queriesCleaned = params.request.query.map(cleanQuery);
            const payload = zip(queriesCleaned, variablesSerialized).map(([query, variables]) => ({
                query,
                variables,
            }));
            searchParams.append(`query`, $jsonSerializer.stringify(payload));
            return searchParams;
        }
        default:
            throw casesExhausted(params.request);
    }
};
//# sourceMappingURL=runRequest.js.map
;// CONCATENATED MODULE: ./node_modules/graphql-request/build/legacy/classes/GraphQLClient.js






/**
 * GraphQL Client.
 */
class GraphQLClient_GraphQLClient {
    url;
    requestConfig;
    constructor(url, requestConfig = {}) {
        this.url = url;
        this.requestConfig = requestConfig;
    }
    /**
     * Send a GraphQL query to the server.
     */
    rawRequest = async (...args) => {
        const [queryOrOptions, variables, requestHeaders] = args;
        const rawRequestOptions = parseRawRequestArgs(queryOrOptions, variables, requestHeaders);
        const { headers, fetch = globalThis.fetch, method = `POST`, requestMiddleware, responseMiddleware, excludeOperationName, ...fetchOptions } = this.requestConfig;
        const { url } = this;
        if (rawRequestOptions.signal !== undefined) {
            fetchOptions.signal = rawRequestOptions.signal;
        }
        const document = analyzeDocument(rawRequestOptions.query, excludeOperationName);
        const response = await runRequest({
            url,
            request: {
                _tag: `Single`,
                document,
                variables: rawRequestOptions.variables,
            },
            headers: {
                ...HeadersInitToPlainObject(callOrIdentity(headers)),
                ...HeadersInitToPlainObject(rawRequestOptions.requestHeaders),
            },
            fetch,
            method,
            fetchOptions,
            middleware: requestMiddleware,
        });
        if (responseMiddleware) {
            await responseMiddleware(response, {
                operationName: document.operationName,
                variables,
                url: this.url,
            });
        }
        if (response instanceof Error) {
            throw response;
        }
        return response;
    };
    async request(documentOrOptions, ...variablesAndRequestHeaders) {
        const [variables, requestHeaders] = variablesAndRequestHeaders;
        const requestOptions = parseRequestArgs(documentOrOptions, variables, requestHeaders);
        const { headers, fetch = globalThis.fetch, method = `POST`, requestMiddleware, responseMiddleware, excludeOperationName, ...fetchOptions } = this.requestConfig;
        const { url } = this;
        if (requestOptions.signal !== undefined) {
            fetchOptions.signal = requestOptions.signal;
        }
        const analyzedDocument = analyzeDocument(requestOptions.document, excludeOperationName);
        const response = await runRequest({
            url,
            request: {
                _tag: `Single`,
                document: analyzedDocument,
                variables: requestOptions.variables,
            },
            headers: {
                ...HeadersInitToPlainObject(callOrIdentity(headers)),
                ...HeadersInitToPlainObject(requestOptions.requestHeaders),
            },
            fetch,
            method,
            fetchOptions,
            middleware: requestMiddleware,
        });
        if (responseMiddleware) {
            await responseMiddleware(response, {
                operationName: analyzedDocument.operationName,
                variables: requestOptions.variables,
                url: this.url,
            });
        }
        if (response instanceof Error) {
            throw response;
        }
        return response.data;
    }
    async batchRequests(documentsOrOptions, requestHeaders) {
        const batchRequestOptions = parseBatchRequestArgs(documentsOrOptions, requestHeaders);
        const { headers, excludeOperationName, ...fetchOptions } = this.requestConfig;
        if (batchRequestOptions.signal !== undefined) {
            fetchOptions.signal = batchRequestOptions.signal;
        }
        const analyzedDocuments = batchRequestOptions.documents.map(({ document }) => analyzeDocument(document, excludeOperationName));
        const expressions = analyzedDocuments.map(({ expression }) => expression);
        const hasMutations = analyzedDocuments.some(({ isMutation }) => isMutation);
        const variables = batchRequestOptions.documents.map(({ variables }) => variables);
        const response = await runRequest({
            url: this.url,
            request: {
                _tag: `Batch`,
                operationName: undefined,
                query: expressions,
                hasMutations,
                variables,
            },
            headers: {
                ...HeadersInitToPlainObject(callOrIdentity(headers)),
                ...HeadersInitToPlainObject(batchRequestOptions.requestHeaders),
            },
            fetch: this.requestConfig.fetch ?? globalThis.fetch,
            method: this.requestConfig.method || `POST`,
            fetchOptions,
            middleware: this.requestConfig.requestMiddleware,
        });
        if (this.requestConfig.responseMiddleware) {
            await this.requestConfig.responseMiddleware(response, {
                operationName: undefined,
                variables,
                url: this.url,
            });
        }
        if (response instanceof Error) {
            throw response;
        }
        return response.data;
    }
    setHeaders(headers) {
        this.requestConfig.headers = headers;
        return this;
    }
    /**
     * Attach a header to the client. All subsequent requests will have this header.
     */
    setHeader(key, value) {
        const { headers } = this.requestConfig;
        if (headers) {
            // todo what if headers is in nested array form... ?
            // @ts-expect-error todo
            headers[key] = value;
        }
        else {
            this.requestConfig.headers = { [key]: value };
        }
        return this;
    }
    /**
     * Change the client endpoint. All subsequent requests will send to this endpoint.
     */
    setEndpoint(value) {
        this.url = value;
        return this;
    }
}
//# sourceMappingURL=GraphQLClient.js.map
;// CONCATENATED MODULE: ./node_modules/graphql-request/build/legacy/functions/request.js

// dprint-ignore
// eslint-disable-next-line
async function request_request(urlOrOptions, document, ...variablesAndRequestHeaders) {
    const requestOptions = parseRequestExtendedArgs(urlOrOptions, document, ...variablesAndRequestHeaders);
    const client = new GraphQLClient(requestOptions.url);
    return client.request({
        ...requestOptions,
    });
}
const parseRequestArgs = (documentOrOptions, variables, requestHeaders) => {
    return documentOrOptions.document
        ? documentOrOptions
        : {
            document: documentOrOptions,
            variables: variables,
            requestHeaders: requestHeaders,
            signal: undefined,
        };
};
const parseRequestExtendedArgs = (urlOrOptions, document, ...variablesAndRequestHeaders) => {
    const [variables, requestHeaders] = variablesAndRequestHeaders;
    return typeof urlOrOptions === `string`
        ? {
            url: urlOrOptions,
            document: document,
            variables,
            requestHeaders,
            signal: undefined,
        }
        : urlOrOptions;
};
//# sourceMappingURL=request.js.map
;// CONCATENATED MODULE: ./node_modules/graphql-request/build/entrypoints/main.js








/* harmony default export */ var main = ((/* unused pure expression or super */ null && (request)));
//# sourceMappingURL=main.js.map

/***/ }),

/***/ 37826:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ devAssert; }
/* harmony export */ });
function devAssert(condition, message) {
  const booleanCondition = Boolean(condition);

  if (!booleanCondition) {
    throw new Error(message);
  }
}


/***/ }),

/***/ 25821:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ inspect; }
/* harmony export */ });
const MAX_ARRAY_LENGTH = 10;
const MAX_RECURSIVE_DEPTH = 2;
/**
 * Used to print values in error messages.
 */

function inspect(value) {
  return formatValue(value, []);
}

function formatValue(value, seenValues) {
  switch (typeof value) {
    case 'string':
      return JSON.stringify(value);

    case 'function':
      return value.name ? `[function ${value.name}]` : '[function]';

    case 'object':
      return formatObjectValue(value, seenValues);

    default:
      return String(value);
  }
}

function formatObjectValue(value, previouslySeenValues) {
  if (value === null) {
    return 'null';
  }

  if (previouslySeenValues.includes(value)) {
    return '[Circular]';
  }

  const seenValues = [...previouslySeenValues, value];

  if (isJSONable(value)) {
    const jsonValue = value.toJSON(); // check for infinite recursion

    if (jsonValue !== value) {
      return typeof jsonValue === 'string'
        ? jsonValue
        : formatValue(jsonValue, seenValues);
    }
  } else if (Array.isArray(value)) {
    return formatArray(value, seenValues);
  }

  return formatObject(value, seenValues);
}

function isJSONable(value) {
  return typeof value.toJSON === 'function';
}

function formatObject(object, seenValues) {
  const entries = Object.entries(object);

  if (entries.length === 0) {
    return '{}';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[' + getObjectTag(object) + ']';
  }

  const properties = entries.map(
    ([key, value]) => key + ': ' + formatValue(value, seenValues),
  );
  return '{ ' + properties.join(', ') + ' }';
}

function formatArray(array, seenValues) {
  if (array.length === 0) {
    return '[]';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[Array]';
  }

  const len = Math.min(MAX_ARRAY_LENGTH, array.length);
  const remaining = array.length - len;
  const items = [];

  for (let i = 0; i < len; ++i) {
    items.push(formatValue(array[i], seenValues));
  }

  if (remaining === 1) {
    items.push('... 1 more item');
  } else if (remaining > 1) {
    items.push(`... ${remaining} more items`);
  }

  return '[' + items.join(', ') + ']';
}

function getObjectTag(object) {
  const tag = Object.prototype.toString
    .call(object)
    .replace(/^\[object /, '')
    .replace(/]$/, '');

  if (tag === 'Object' && typeof object.constructor === 'function') {
    const name = object.constructor.name;

    if (typeof name === 'string' && name !== '') {
      return name;
    }
  }

  return tag;
}


/***/ }),

/***/ 72380:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "UG": function() { return /* binding */ isNode; },
/* harmony export */   "WU": function() { return /* binding */ Token; },
/* harmony export */   "Ye": function() { return /* binding */ Location; },
/* harmony export */   "h8": function() { return /* binding */ QueryDocumentKeys; },
/* harmony export */   "ku": function() { return /* binding */ OperationTypeNode; }
/* harmony export */ });
/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */
class Location {
  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The Token at which this Node begins.
   */

  /**
   * The Token at which this Node ends.
   */

  /**
   * The Source document the AST represents.
   */
  constructor(startToken, endToken, source) {
    this.start = startToken.start;
    this.end = endToken.end;
    this.startToken = startToken;
    this.endToken = endToken;
    this.source = source;
  }

  get [Symbol.toStringTag]() {
    return 'Location';
  }

  toJSON() {
    return {
      start: this.start,
      end: this.end,
    };
  }
}
/**
 * Represents a range of characters represented by a lexical token
 * within a Source.
 */

class Token {
  /**
   * The kind of Token.
   */

  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The 1-indexed line number on which this Token appears.
   */

  /**
   * The 1-indexed column number at which this Token begins.
   */

  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */

  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  constructor(kind, start, end, line, column, value) {
    this.kind = kind;
    this.start = start;
    this.end = end;
    this.line = line;
    this.column = column; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

    this.value = value;
    this.prev = null;
    this.next = null;
  }

  get [Symbol.toStringTag]() {
    return 'Token';
  }

  toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column,
    };
  }
}
/**
 * The list of all possible AST node types.
 */

/**
 * @internal
 */
const QueryDocumentKeys = {
  Name: [],
  Document: ['definitions'],
  OperationDefinition: [
    'description',
    'name',
    'variableDefinitions',
    'directives',
    'selectionSet',
  ],
  VariableDefinition: [
    'description',
    'variable',
    'type',
    'defaultValue',
    'directives',
  ],
  Variable: ['name'],
  SelectionSet: ['selections'],
  Field: ['alias', 'name', 'arguments', 'directives', 'selectionSet'],
  Argument: ['name', 'value'],
  FragmentSpread: ['name', 'directives'],
  InlineFragment: ['typeCondition', 'directives', 'selectionSet'],
  FragmentDefinition: [
    'description',
    'name', // Note: fragment variable definitions are deprecated and will removed in v17.0.0
    'variableDefinitions',
    'typeCondition',
    'directives',
    'selectionSet',
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ['values'],
  ObjectValue: ['fields'],
  ObjectField: ['name', 'value'],
  Directive: ['name', 'arguments'],
  NamedType: ['name'],
  ListType: ['type'],
  NonNullType: ['type'],
  SchemaDefinition: ['description', 'directives', 'operationTypes'],
  OperationTypeDefinition: ['type'],
  ScalarTypeDefinition: ['description', 'name', 'directives'],
  ObjectTypeDefinition: [
    'description',
    'name',
    'interfaces',
    'directives',
    'fields',
  ],
  FieldDefinition: ['description', 'name', 'arguments', 'type', 'directives'],
  InputValueDefinition: [
    'description',
    'name',
    'type',
    'defaultValue',
    'directives',
  ],
  InterfaceTypeDefinition: [
    'description',
    'name',
    'interfaces',
    'directives',
    'fields',
  ],
  UnionTypeDefinition: ['description', 'name', 'directives', 'types'],
  EnumTypeDefinition: ['description', 'name', 'directives', 'values'],
  EnumValueDefinition: ['description', 'name', 'directives'],
  InputObjectTypeDefinition: ['description', 'name', 'directives', 'fields'],
  DirectiveDefinition: ['description', 'name', 'arguments', 'locations'],
  SchemaExtension: ['directives', 'operationTypes'],
  ScalarTypeExtension: ['name', 'directives'],
  ObjectTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  InterfaceTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  UnionTypeExtension: ['name', 'directives', 'types'],
  EnumTypeExtension: ['name', 'directives', 'values'],
  InputObjectTypeExtension: ['name', 'directives', 'fields'],
  TypeCoordinate: ['name'],
  MemberCoordinate: ['name', 'memberName'],
  ArgumentCoordinate: ['name', 'fieldName', 'argumentName'],
  DirectiveCoordinate: ['name'],
  DirectiveArgumentCoordinate: ['name', 'argumentName'],
};
const kindValues = new Set(Object.keys(QueryDocumentKeys));
/**
 * @internal
 */

function isNode(maybeNode) {
  const maybeKind =
    maybeNode === null || maybeNode === void 0 ? void 0 : maybeNode.kind;
  return typeof maybeKind === 'string' && kindValues.has(maybeKind);
}
/** Name */

var OperationTypeNode;

(function (OperationTypeNode) {
  OperationTypeNode['QUERY'] = 'query';
  OperationTypeNode['MUTATION'] = 'mutation';
  OperationTypeNode['SUBSCRIPTION'] = 'subscription';
})(OperationTypeNode || (OperationTypeNode = {}));




/***/ }),

/***/ 87392:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LZ": function() { return /* binding */ printBlockString; },
/* harmony export */   "wv": function() { return /* binding */ dedentBlockStringLines; }
/* harmony export */ });
/* unused harmony export isPrintableAsBlockString */
/* harmony import */ var _characterClasses_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68297);

/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */

function dedentBlockStringLines(lines) {
  var _firstNonEmptyLine2;

  let commonIndent = Number.MAX_SAFE_INTEGER;
  let firstNonEmptyLine = null;
  let lastNonEmptyLine = -1;

  for (let i = 0; i < lines.length; ++i) {
    var _firstNonEmptyLine;

    const line = lines[i];
    const indent = leadingWhitespace(line);

    if (indent === line.length) {
      continue; // skip empty lines
    }

    firstNonEmptyLine =
      (_firstNonEmptyLine = firstNonEmptyLine) !== null &&
      _firstNonEmptyLine !== void 0
        ? _firstNonEmptyLine
        : i;
    lastNonEmptyLine = i;

    if (i !== 0 && indent < commonIndent) {
      commonIndent = indent;
    }
  }

  return lines // Remove common indentation from all lines but first.
    .map((line, i) => (i === 0 ? line : line.slice(commonIndent))) // Remove leading and trailing blank lines.
    .slice(
      (_firstNonEmptyLine2 = firstNonEmptyLine) !== null &&
        _firstNonEmptyLine2 !== void 0
        ? _firstNonEmptyLine2
        : 0,
      lastNonEmptyLine + 1,
    );
}

function leadingWhitespace(str) {
  let i = 0;

  while (i < str.length && (0,_characterClasses_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isWhiteSpace */ .FD)(str.charCodeAt(i))) {
    ++i;
  }

  return i;
}
/**
 * @internal
 */

function isPrintableAsBlockString(value) {
  if (value === '') {
    return true; // empty string is printable
  }

  let isEmptyLine = true;
  let hasIndent = false;
  let hasCommonIndent = true;
  let seenNonEmptyLine = false;

  for (let i = 0; i < value.length; ++i) {
    switch (value.codePointAt(i)) {
      case 0x0000:
      case 0x0001:
      case 0x0002:
      case 0x0003:
      case 0x0004:
      case 0x0005:
      case 0x0006:
      case 0x0007:
      case 0x0008:
      case 0x000b:
      case 0x000c:
      case 0x000e:
      case 0x000f:
        return false;
      // Has non-printable characters

      case 0x000d:
        //  \r
        return false;
      // Has \r or \r\n which will be replaced as \n

      case 10:
        //  \n
        if (isEmptyLine && !seenNonEmptyLine) {
          return false; // Has leading new line
        }

        seenNonEmptyLine = true;
        isEmptyLine = true;
        hasIndent = false;
        break;

      case 9: //   \t

      case 32:
        //  <space>
        hasIndent || (hasIndent = isEmptyLine);
        break;

      default:
        hasCommonIndent && (hasCommonIndent = hasIndent);
        isEmptyLine = false;
    }
  }

  if (isEmptyLine) {
    return false; // Has trailing empty lines
  }

  if (hasCommonIndent && seenNonEmptyLine) {
    return false; // Has internal indent
  }

  return true;
}
/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 *
 * @internal
 */

function printBlockString(value, options) {
  const escapedValue = value.replace(/"""/g, '\\"""'); // Expand a block string's raw value into independent lines.

  const lines = escapedValue.split(/\r\n|[\n\r]/g);
  const isSingleLine = lines.length === 1; // If common indentation is found we can fix some of those cases by adding leading new line

  const forceLeadingNewLine =
    lines.length > 1 &&
    lines
      .slice(1)
      .every((line) => line.length === 0 || (0,_characterClasses_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isWhiteSpace */ .FD)(line.charCodeAt(0))); // Trailing triple quotes just looks confusing but doesn't force trailing new line

  const hasTrailingTripleQuotes = escapedValue.endsWith('\\"""'); // Trailing quote (single or double) or slash forces trailing new line

  const hasTrailingQuote = value.endsWith('"') && !hasTrailingTripleQuotes;
  const hasTrailingSlash = value.endsWith('\\');
  const forceTrailingNewline = hasTrailingQuote || hasTrailingSlash;
  const printAsMultipleLines =
    !(options !== null && options !== void 0 && options.minimize) && // add leading and trailing new lines only if it improves readability
    (!isSingleLine ||
      value.length > 70 ||
      forceTrailingNewline ||
      forceLeadingNewLine ||
      hasTrailingTripleQuotes);
  let result = ''; // Format a multi-line block quote to account for leading space.

  const skipLeadingNewLine = isSingleLine && (0,_characterClasses_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isWhiteSpace */ .FD)(value.charCodeAt(0));

  if ((printAsMultipleLines && !skipLeadingNewLine) || forceLeadingNewLine) {
    result += '\n';
  }

  result += escapedValue;

  if (printAsMultipleLines || forceTrailingNewline) {
    result += '\n';
  }

  return '"""' + result + '"""';
}


/***/ }),

/***/ 68297:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FD": function() { return /* binding */ isWhiteSpace; },
/* harmony export */   "HQ": function() { return /* binding */ isNameContinue; },
/* harmony export */   "LQ": function() { return /* binding */ isNameStart; },
/* harmony export */   "X1": function() { return /* binding */ isDigit; }
/* harmony export */ });
/* unused harmony export isLetter */
/**
 * ```
 * WhiteSpace ::
 *   - "Horizontal Tab (U+0009)"
 *   - "Space (U+0020)"
 * ```
 * @internal
 */
function isWhiteSpace(code) {
  return code === 0x0009 || code === 0x0020;
}
/**
 * ```
 * Digit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 * ```
 * @internal
 */

function isDigit(code) {
  return code >= 0x0030 && code <= 0x0039;
}
/**
 * ```
 * Letter :: one of
 *   - `A` `B` `C` `D` `E` `F` `G` `H` `I` `J` `K` `L` `M`
 *   - `N` `O` `P` `Q` `R` `S` `T` `U` `V` `W` `X` `Y` `Z`
 *   - `a` `b` `c` `d` `e` `f` `g` `h` `i` `j` `k` `l` `m`
 *   - `n` `o` `p` `q` `r` `s` `t` `u` `v` `w` `x` `y` `z`
 * ```
 * @internal
 */

function isLetter(code) {
  return (
    (code >= 0x0061 && code <= 0x007a) || // A-Z
    (code >= 0x0041 && code <= 0x005a) // a-z
  );
}
/**
 * ```
 * NameStart ::
 *   - Letter
 *   - `_`
 * ```
 * @internal
 */

function isNameStart(code) {
  return isLetter(code) || code === 0x005f;
}
/**
 * ```
 * NameContinue ::
 *   - Letter
 *   - Digit
 *   - `_`
 * ```
 * @internal
 */

function isNameContinue(code) {
  return isLetter(code) || isDigit(code) || code === 0x005f;
}


/***/ }),

/***/ 97359:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Kind; }
/* harmony export */ });
/**
 * The set of allowed kind values for AST nodes.
 */
var Kind;

(function (Kind) {
  Kind['NAME'] = 'Name';
  Kind['DOCUMENT'] = 'Document';
  Kind['OPERATION_DEFINITION'] = 'OperationDefinition';
  Kind['VARIABLE_DEFINITION'] = 'VariableDefinition';
  Kind['SELECTION_SET'] = 'SelectionSet';
  Kind['FIELD'] = 'Field';
  Kind['ARGUMENT'] = 'Argument';
  Kind['FRAGMENT_SPREAD'] = 'FragmentSpread';
  Kind['INLINE_FRAGMENT'] = 'InlineFragment';
  Kind['FRAGMENT_DEFINITION'] = 'FragmentDefinition';
  Kind['VARIABLE'] = 'Variable';
  Kind['INT'] = 'IntValue';
  Kind['FLOAT'] = 'FloatValue';
  Kind['STRING'] = 'StringValue';
  Kind['BOOLEAN'] = 'BooleanValue';
  Kind['NULL'] = 'NullValue';
  Kind['ENUM'] = 'EnumValue';
  Kind['LIST'] = 'ListValue';
  Kind['OBJECT'] = 'ObjectValue';
  Kind['OBJECT_FIELD'] = 'ObjectField';
  Kind['DIRECTIVE'] = 'Directive';
  Kind['NAMED_TYPE'] = 'NamedType';
  Kind['LIST_TYPE'] = 'ListType';
  Kind['NON_NULL_TYPE'] = 'NonNullType';
  Kind['SCHEMA_DEFINITION'] = 'SchemaDefinition';
  Kind['OPERATION_TYPE_DEFINITION'] = 'OperationTypeDefinition';
  Kind['SCALAR_TYPE_DEFINITION'] = 'ScalarTypeDefinition';
  Kind['OBJECT_TYPE_DEFINITION'] = 'ObjectTypeDefinition';
  Kind['FIELD_DEFINITION'] = 'FieldDefinition';
  Kind['INPUT_VALUE_DEFINITION'] = 'InputValueDefinition';
  Kind['INTERFACE_TYPE_DEFINITION'] = 'InterfaceTypeDefinition';
  Kind['UNION_TYPE_DEFINITION'] = 'UnionTypeDefinition';
  Kind['ENUM_TYPE_DEFINITION'] = 'EnumTypeDefinition';
  Kind['ENUM_VALUE_DEFINITION'] = 'EnumValueDefinition';
  Kind['INPUT_OBJECT_TYPE_DEFINITION'] = 'InputObjectTypeDefinition';
  Kind['DIRECTIVE_DEFINITION'] = 'DirectiveDefinition';
  Kind['SCHEMA_EXTENSION'] = 'SchemaExtension';
  Kind['SCALAR_TYPE_EXTENSION'] = 'ScalarTypeExtension';
  Kind['OBJECT_TYPE_EXTENSION'] = 'ObjectTypeExtension';
  Kind['INTERFACE_TYPE_EXTENSION'] = 'InterfaceTypeExtension';
  Kind['UNION_TYPE_EXTENSION'] = 'UnionTypeExtension';
  Kind['ENUM_TYPE_EXTENSION'] = 'EnumTypeExtension';
  Kind['INPUT_OBJECT_TYPE_EXTENSION'] = 'InputObjectTypeExtension';
  Kind['TYPE_COORDINATE'] = 'TypeCoordinate';
  Kind['MEMBER_COORDINATE'] = 'MemberCoordinate';
  Kind['ARGUMENT_COORDINATE'] = 'ArgumentCoordinate';
  Kind['DIRECTIVE_COORDINATE'] = 'DirectiveCoordinate';
  Kind['DIRECTIVE_ARGUMENT_COORDINATE'] = 'DirectiveArgumentCoordinate';
})(Kind || (Kind = {}));


/**
 * The enum type representing the possible kind values of AST nodes.
 *
 * @deprecated Please use `Kind`. Will be remove in v17.
 */


/***/ }),

/***/ 86355:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Qc": function() { return /* binding */ parse; }
});

// UNUSED EXPORTS: Parser, parseConstValue, parseSchemaCoordinate, parseType, parseValue

;// CONCATENATED MODULE: ./node_modules/graphql/jsutils/isObjectLike.mjs
/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 */
function isObjectLike(value) {
  return typeof value == 'object' && value !== null;
}

;// CONCATENATED MODULE: ./node_modules/graphql/jsutils/invariant.mjs
function invariant(condition, message) {
  const booleanCondition = Boolean(condition);

  if (!booleanCondition) {
    throw new Error(
      message != null ? message : 'Unexpected invariant triggered.',
    );
  }
}

;// CONCATENATED MODULE: ./node_modules/graphql/language/location.mjs

const LineRegExp = /\r\n|[\n\r]/g;
/**
 * Represents a location in a Source.
 */

/**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */
function getLocation(source, position) {
  let lastLineStart = 0;
  let line = 1;

  for (const match of source.body.matchAll(LineRegExp)) {
    typeof match.index === 'number' || invariant(false);

    if (match.index >= position) {
      break;
    }

    lastLineStart = match.index + match[0].length;
    line += 1;
  }

  return {
    line,
    column: position + 1 - lastLineStart,
  };
}

;// CONCATENATED MODULE: ./node_modules/graphql/language/printLocation.mjs


/**
 * Render a helpful description of the location in the GraphQL Source document.
 */
function printLocation(location) {
  return printSourceLocation(
    location.source,
    getLocation(location.source, location.start),
  );
}
/**
 * Render a helpful description of the location in the GraphQL Source document.
 */

function printSourceLocation(source, sourceLocation) {
  const firstLineColumnOffset = source.locationOffset.column - 1;
  const body = ''.padStart(firstLineColumnOffset) + source.body;
  const lineIndex = sourceLocation.line - 1;
  const lineOffset = source.locationOffset.line - 1;
  const lineNum = sourceLocation.line + lineOffset;
  const columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
  const columnNum = sourceLocation.column + columnOffset;
  const locationStr = `${source.name}:${lineNum}:${columnNum}\n`;
  const lines = body.split(/\r\n|[\n\r]/g);
  const locationLine = lines[lineIndex]; // Special case for minified documents

  if (locationLine.length > 120) {
    const subLineIndex = Math.floor(columnNum / 80);
    const subLineColumnNum = columnNum % 80;
    const subLines = [];

    for (let i = 0; i < locationLine.length; i += 80) {
      subLines.push(locationLine.slice(i, i + 80));
    }

    return (
      locationStr +
      printPrefixedLines([
        [`${lineNum} |`, subLines[0]],
        ...subLines.slice(1, subLineIndex + 1).map((subLine) => ['|', subLine]),
        ['|', '^'.padStart(subLineColumnNum)],
        ['|', subLines[subLineIndex + 1]],
      ])
    );
  }

  return (
    locationStr +
    printPrefixedLines([
      // Lines specified like this: ["prefix", "string"],
      [`${lineNum - 1} |`, lines[lineIndex - 1]],
      [`${lineNum} |`, locationLine],
      ['|', '^'.padStart(columnNum)],
      [`${lineNum + 1} |`, lines[lineIndex + 1]],
    ])
  );
}

function printPrefixedLines(lines) {
  const existingLines = lines.filter(([_, line]) => line !== undefined);
  const padLen = Math.max(...existingLines.map(([prefix]) => prefix.length));
  return existingLines
    .map(([prefix, line]) => prefix.padStart(padLen) + (line ? ' ' + line : ''))
    .join('\n');
}

;// CONCATENATED MODULE: ./node_modules/graphql/error/GraphQLError.mjs




function toNormalizedOptions(args) {
  const firstArg = args[0];

  if (firstArg == null || 'kind' in firstArg || 'length' in firstArg) {
    return {
      nodes: firstArg,
      source: args[1],
      positions: args[2],
      path: args[3],
      originalError: args[4],
      extensions: args[5],
    };
  }

  return firstArg;
}
/**
 * A GraphQLError describes an Error found during the parse, validate, or
 * execute phases of performing a GraphQL operation. In addition to a message
 * and stack trace, it also includes information about the locations in a
 * GraphQL document and/or execution result that correspond to the Error.
 */

class GraphQLError extends Error {
  /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */

  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */

  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */

  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */

  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */

  /**
   * The original error thrown from a field resolver during execution.
   */

  /**
   * Extension fields to add to the formatted error.
   */

  /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */
  constructor(message, ...rawArgs) {
    var _this$nodes, _nodeLocations$, _ref;

    const { nodes, source, positions, path, originalError, extensions } =
      toNormalizedOptions(rawArgs);
    super(message);
    this.name = 'GraphQLError';
    this.path = path !== null && path !== void 0 ? path : undefined;
    this.originalError =
      originalError !== null && originalError !== void 0
        ? originalError
        : undefined; // Compute list of blame nodes.

    this.nodes = undefinedIfEmpty(
      Array.isArray(nodes) ? nodes : nodes ? [nodes] : undefined,
    );
    const nodeLocations = undefinedIfEmpty(
      (_this$nodes = this.nodes) === null || _this$nodes === void 0
        ? void 0
        : _this$nodes.map((node) => node.loc).filter((loc) => loc != null),
    ); // Compute locations in the source for the given nodes/positions.

    this.source =
      source !== null && source !== void 0
        ? source
        : nodeLocations === null || nodeLocations === void 0
        ? void 0
        : (_nodeLocations$ = nodeLocations[0]) === null ||
          _nodeLocations$ === void 0
        ? void 0
        : _nodeLocations$.source;
    this.positions =
      positions !== null && positions !== void 0
        ? positions
        : nodeLocations === null || nodeLocations === void 0
        ? void 0
        : nodeLocations.map((loc) => loc.start);
    this.locations =
      positions && source
        ? positions.map((pos) => getLocation(source, pos))
        : nodeLocations === null || nodeLocations === void 0
        ? void 0
        : nodeLocations.map((loc) => getLocation(loc.source, loc.start));
    const originalExtensions = isObjectLike(
      originalError === null || originalError === void 0
        ? void 0
        : originalError.extensions,
    )
      ? originalError === null || originalError === void 0
        ? void 0
        : originalError.extensions
      : undefined;
    this.extensions =
      (_ref =
        extensions !== null && extensions !== void 0
          ? extensions
          : originalExtensions) !== null && _ref !== void 0
        ? _ref
        : Object.create(null); // Only properties prescribed by the spec should be enumerable.
    // Keep the rest as non-enumerable.

    Object.defineProperties(this, {
      message: {
        writable: true,
        enumerable: true,
      },
      name: {
        enumerable: false,
      },
      nodes: {
        enumerable: false,
      },
      source: {
        enumerable: false,
      },
      positions: {
        enumerable: false,
      },
      originalError: {
        enumerable: false,
      },
    }); // Include (non-enumerable) stack trace.

    /* c8 ignore start */
    // FIXME: https://github.com/graphql/graphql-js/issues/2317

    if (
      originalError !== null &&
      originalError !== void 0 &&
      originalError.stack
    ) {
      Object.defineProperty(this, 'stack', {
        value: originalError.stack,
        writable: true,
        configurable: true,
      });
    } else if (Error.captureStackTrace) {
      Error.captureStackTrace(this, GraphQLError);
    } else {
      Object.defineProperty(this, 'stack', {
        value: Error().stack,
        writable: true,
        configurable: true,
      });
    }
    /* c8 ignore stop */
  }

  get [Symbol.toStringTag]() {
    return 'GraphQLError';
  }

  toString() {
    let output = this.message;

    if (this.nodes) {
      for (const node of this.nodes) {
        if (node.loc) {
          output += '\n\n' + printLocation(node.loc);
        }
      }
    } else if (this.source && this.locations) {
      for (const location of this.locations) {
        output += '\n\n' + printSourceLocation(this.source, location);
      }
    }

    return output;
  }

  toJSON() {
    const formattedError = {
      message: this.message,
    };

    if (this.locations != null) {
      formattedError.locations = this.locations;
    }

    if (this.path != null) {
      formattedError.path = this.path;
    }

    if (this.extensions != null && Object.keys(this.extensions).length > 0) {
      formattedError.extensions = this.extensions;
    }

    return formattedError;
  }
}

function undefinedIfEmpty(array) {
  return array === undefined || array.length === 0 ? undefined : array;
}
/**
 * See: https://spec.graphql.org/draft/#sec-Errors
 */

/**
 * Prints a GraphQLError to a string, representing useful location information
 * about the error's position in the source.
 *
 * @deprecated Please use `error.toString` instead. Will be removed in v17
 */
function printError(error) {
  return error.toString();
}
/**
 * Given a GraphQLError, format it according to the rules described by the
 * Response Format, Errors section of the GraphQL Specification.
 *
 * @deprecated Please use `error.toJSON` instead. Will be removed in v17
 */

function formatError(error) {
  return error.toJSON();
}

;// CONCATENATED MODULE: ./node_modules/graphql/error/syntaxError.mjs

/**
 * Produces a GraphQLError representing a syntax error, containing useful
 * descriptive information about the syntax error's position in the source.
 */

function syntaxError(source, position, description) {
  return new GraphQLError(`Syntax Error: ${description}`, {
    source,
    positions: [position],
  });
}

// EXTERNAL MODULE: ./node_modules/graphql/language/ast.mjs
var ast = __webpack_require__(72380);
;// CONCATENATED MODULE: ./node_modules/graphql/language/directiveLocation.mjs
/**
 * The set of allowed directive location values.
 */
var DirectiveLocation;

(function (DirectiveLocation) {
  DirectiveLocation['QUERY'] = 'QUERY';
  DirectiveLocation['MUTATION'] = 'MUTATION';
  DirectiveLocation['SUBSCRIPTION'] = 'SUBSCRIPTION';
  DirectiveLocation['FIELD'] = 'FIELD';
  DirectiveLocation['FRAGMENT_DEFINITION'] = 'FRAGMENT_DEFINITION';
  DirectiveLocation['FRAGMENT_SPREAD'] = 'FRAGMENT_SPREAD';
  DirectiveLocation['INLINE_FRAGMENT'] = 'INLINE_FRAGMENT';
  DirectiveLocation['VARIABLE_DEFINITION'] = 'VARIABLE_DEFINITION';
  DirectiveLocation['SCHEMA'] = 'SCHEMA';
  DirectiveLocation['SCALAR'] = 'SCALAR';
  DirectiveLocation['OBJECT'] = 'OBJECT';
  DirectiveLocation['FIELD_DEFINITION'] = 'FIELD_DEFINITION';
  DirectiveLocation['ARGUMENT_DEFINITION'] = 'ARGUMENT_DEFINITION';
  DirectiveLocation['INTERFACE'] = 'INTERFACE';
  DirectiveLocation['UNION'] = 'UNION';
  DirectiveLocation['ENUM'] = 'ENUM';
  DirectiveLocation['ENUM_VALUE'] = 'ENUM_VALUE';
  DirectiveLocation['INPUT_OBJECT'] = 'INPUT_OBJECT';
  DirectiveLocation['INPUT_FIELD_DEFINITION'] = 'INPUT_FIELD_DEFINITION';
})(DirectiveLocation || (DirectiveLocation = {}));


/**
 * The enum type representing the directive location values.
 *
 * @deprecated Please use `DirectiveLocation`. Will be remove in v17.
 */

// EXTERNAL MODULE: ./node_modules/graphql/language/kinds.mjs
var kinds = __webpack_require__(97359);
// EXTERNAL MODULE: ./node_modules/graphql/language/blockString.mjs
var blockString = __webpack_require__(87392);
// EXTERNAL MODULE: ./node_modules/graphql/language/characterClasses.mjs
var characterClasses = __webpack_require__(68297);
;// CONCATENATED MODULE: ./node_modules/graphql/language/tokenKind.mjs
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */
var tokenKind_TokenKind;

(function (TokenKind) {
  TokenKind['SOF'] = '<SOF>';
  TokenKind['EOF'] = '<EOF>';
  TokenKind['BANG'] = '!';
  TokenKind['DOLLAR'] = '$';
  TokenKind['AMP'] = '&';
  TokenKind['PAREN_L'] = '(';
  TokenKind['PAREN_R'] = ')';
  TokenKind['DOT'] = '.';
  TokenKind['SPREAD'] = '...';
  TokenKind['COLON'] = ':';
  TokenKind['EQUALS'] = '=';
  TokenKind['AT'] = '@';
  TokenKind['BRACKET_L'] = '[';
  TokenKind['BRACKET_R'] = ']';
  TokenKind['BRACE_L'] = '{';
  TokenKind['PIPE'] = '|';
  TokenKind['BRACE_R'] = '}';
  TokenKind['NAME'] = 'Name';
  TokenKind['INT'] = 'Int';
  TokenKind['FLOAT'] = 'Float';
  TokenKind['STRING'] = 'String';
  TokenKind['BLOCK_STRING'] = 'BlockString';
  TokenKind['COMMENT'] = 'Comment';
})(tokenKind_TokenKind || (tokenKind_TokenKind = {}));


/**
 * The enum type representing the token kinds values.
 *
 * @deprecated Please use `TokenKind`. Will be remove in v17.
 */

;// CONCATENATED MODULE: ./node_modules/graphql/language/lexer.mjs





/**
 * A Lexer interface which provides common properties and methods required for
 * lexing GraphQL source.
 *
 * @internal
 */

/**
 * Given a Source object, creates a Lexer for that source.
 * A Lexer is a stateful stream generator in that every time
 * it is advanced, it returns the next token in the Source. Assuming the
 * source lexes, the final Token emitted by the lexer will be of kind
 * EOF, after which the lexer will repeatedly return the same EOF token
 * whenever called.
 */
class Lexer {
  /**
   * The previously focused non-ignored token.
   */

  /**
   * The currently focused non-ignored token.
   */

  /**
   * The (1-indexed) line containing the current token.
   */

  /**
   * The character offset at which the current line begins.
   */
  constructor(source) {
    const startOfFileToken = new ast/* Token */.WU(tokenKind_TokenKind.SOF, 0, 0, 0, 0);
    this.source = source;
    this.lastToken = startOfFileToken;
    this.token = startOfFileToken;
    this.line = 1;
    this.lineStart = 0;
  }

  get [Symbol.toStringTag]() {
    return 'Lexer';
  }
  /**
   * Advances the token stream to the next non-ignored token.
   */

  advance() {
    this.lastToken = this.token;
    const token = (this.token = this.lookahead());
    return token;
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */

  lookahead() {
    let token = this.token;

    if (token.kind !== tokenKind_TokenKind.EOF) {
      do {
        if (token.next) {
          token = token.next;
        } else {
          // Read the next token and form a link in the token linked-list.
          const nextToken = readNextToken(this, token.end); // @ts-expect-error next is only mutable during parsing.

          token.next = nextToken; // @ts-expect-error prev is only mutable during parsing.

          nextToken.prev = token;
          token = nextToken;
        }
      } while (token.kind === tokenKind_TokenKind.COMMENT);
    }

    return token;
  }
}
/**
 * @internal
 */

function isPunctuatorTokenKind(kind) {
  return (
    kind === tokenKind_TokenKind.BANG ||
    kind === tokenKind_TokenKind.DOLLAR ||
    kind === tokenKind_TokenKind.AMP ||
    kind === tokenKind_TokenKind.PAREN_L ||
    kind === tokenKind_TokenKind.PAREN_R ||
    kind === tokenKind_TokenKind.DOT ||
    kind === tokenKind_TokenKind.SPREAD ||
    kind === tokenKind_TokenKind.COLON ||
    kind === tokenKind_TokenKind.EQUALS ||
    kind === tokenKind_TokenKind.AT ||
    kind === tokenKind_TokenKind.BRACKET_L ||
    kind === tokenKind_TokenKind.BRACKET_R ||
    kind === tokenKind_TokenKind.BRACE_L ||
    kind === tokenKind_TokenKind.PIPE ||
    kind === tokenKind_TokenKind.BRACE_R
  );
}
/**
 * A Unicode scalar value is any Unicode code point except surrogate code
 * points. In other words, the inclusive ranges of values 0x0000 to 0xD7FF and
 * 0xE000 to 0x10FFFF.
 *
 * SourceCharacter ::
 *   - "Any Unicode scalar value"
 */

function isUnicodeScalarValue(code) {
  return (
    (code >= 0x0000 && code <= 0xd7ff) || (code >= 0xe000 && code <= 0x10ffff)
  );
}
/**
 * The GraphQL specification defines source text as a sequence of unicode scalar
 * values (which Unicode defines to exclude surrogate code points). However
 * JavaScript defines strings as a sequence of UTF-16 code units which may
 * include surrogates. A surrogate pair is a valid source character as it
 * encodes a supplementary code point (above U+FFFF), but unpaired surrogate
 * code points are not valid source characters.
 */

function isSupplementaryCodePoint(body, location) {
  return (
    isLeadingSurrogate(body.charCodeAt(location)) &&
    isTrailingSurrogate(body.charCodeAt(location + 1))
  );
}

function isLeadingSurrogate(code) {
  return code >= 0xd800 && code <= 0xdbff;
}

function isTrailingSurrogate(code) {
  return code >= 0xdc00 && code <= 0xdfff;
}
/**
 * Prints the code point (or end of file reference) at a given location in a
 * source for use in error messages.
 *
 * Printable ASCII is printed quoted, while other points are printed in Unicode
 * code point form (ie. U+1234).
 *
 * @internal
 */

function printCodePointAt(lexer, location) {
  const code = lexer.source.body.codePointAt(location);

  if (code === undefined) {
    return tokenKind_TokenKind.EOF;
  } else if (code >= 0x0020 && code <= 0x007e) {
    // Printable ASCII
    const char = String.fromCodePoint(code);
    return char === '"' ? "'\"'" : `"${char}"`;
  } // Unicode code point

  return 'U+' + code.toString(16).toUpperCase().padStart(4, '0');
}
/**
 * Create a token with line and column location information.
 *
 * @internal
 */

function createToken(lexer, kind, start, end, value) {
  const line = lexer.line;
  const col = 1 + start - lexer.lineStart;
  return new ast/* Token */.WU(kind, start, end, line, col, value);
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */

function readNextToken(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start;

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // SourceCharacter

    switch (code) {
      // Ignored ::
      //   - UnicodeBOM
      //   - WhiteSpace
      //   - LineTerminator
      //   - Comment
      //   - Comma
      //
      // UnicodeBOM :: "Byte Order Mark (U+FEFF)"
      //
      // WhiteSpace ::
      //   - "Horizontal Tab (U+0009)"
      //   - "Space (U+0020)"
      //
      // Comma :: ,
      case 0xfeff: // <BOM>

      case 0x0009: // \t

      case 0x0020: // <space>

      case 0x002c:
        // ,
        ++position;
        continue;
      // LineTerminator ::
      //   - "New Line (U+000A)"
      //   - "Carriage Return (U+000D)" [lookahead != "New Line (U+000A)"]
      //   - "Carriage Return (U+000D)" "New Line (U+000A)"

      case 0x000a:
        // \n
        ++position;
        ++lexer.line;
        lexer.lineStart = position;
        continue;

      case 0x000d:
        // \r
        if (body.charCodeAt(position + 1) === 0x000a) {
          position += 2;
        } else {
          ++position;
        }

        ++lexer.line;
        lexer.lineStart = position;
        continue;
      // Comment

      case 0x0023:
        // #
        return readComment(lexer, position);
      // Token ::
      //   - Punctuator
      //   - Name
      //   - IntValue
      //   - FloatValue
      //   - StringValue
      //
      // Punctuator :: one of ! $ & ( ) ... : = @ [ ] { | }

      case 0x0021:
        // !
        return createToken(lexer, tokenKind_TokenKind.BANG, position, position + 1);

      case 0x0024:
        // $
        return createToken(lexer, tokenKind_TokenKind.DOLLAR, position, position + 1);

      case 0x0026:
        // &
        return createToken(lexer, tokenKind_TokenKind.AMP, position, position + 1);

      case 0x0028:
        // (
        return createToken(lexer, tokenKind_TokenKind.PAREN_L, position, position + 1);

      case 0x0029:
        // )
        return createToken(lexer, tokenKind_TokenKind.PAREN_R, position, position + 1);

      case 0x002e:
        // .
        if (
          body.charCodeAt(position + 1) === 0x002e &&
          body.charCodeAt(position + 2) === 0x002e
        ) {
          return createToken(lexer, tokenKind_TokenKind.SPREAD, position, position + 3);
        }

        break;

      case 0x003a:
        // :
        return createToken(lexer, tokenKind_TokenKind.COLON, position, position + 1);

      case 0x003d:
        // =
        return createToken(lexer, tokenKind_TokenKind.EQUALS, position, position + 1);

      case 0x0040:
        // @
        return createToken(lexer, tokenKind_TokenKind.AT, position, position + 1);

      case 0x005b:
        // [
        return createToken(lexer, tokenKind_TokenKind.BRACKET_L, position, position + 1);

      case 0x005d:
        // ]
        return createToken(lexer, tokenKind_TokenKind.BRACKET_R, position, position + 1);

      case 0x007b:
        // {
        return createToken(lexer, tokenKind_TokenKind.BRACE_L, position, position + 1);

      case 0x007c:
        // |
        return createToken(lexer, tokenKind_TokenKind.PIPE, position, position + 1);

      case 0x007d:
        // }
        return createToken(lexer, tokenKind_TokenKind.BRACE_R, position, position + 1);
      // StringValue

      case 0x0022:
        // "
        if (
          body.charCodeAt(position + 1) === 0x0022 &&
          body.charCodeAt(position + 2) === 0x0022
        ) {
          return readBlockString(lexer, position);
        }

        return readString(lexer, position);
    } // IntValue | FloatValue (Digit | -)

    if ((0,characterClasses/* isDigit */.X1)(code) || code === 0x002d) {
      return readNumber(lexer, position, code);
    } // Name

    if ((0,characterClasses/* isNameStart */.LQ)(code)) {
      return readName(lexer, position);
    }

    throw syntaxError(
      lexer.source,
      position,
      code === 0x0027
        ? 'Unexpected single quote character (\'), did you mean to use a double quote (")?'
        : isUnicodeScalarValue(code) || isSupplementaryCodePoint(body, position)
        ? `Unexpected character: ${printCodePointAt(lexer, position)}.`
        : `Invalid character: ${printCodePointAt(lexer, position)}.`,
    );
  }

  return createToken(lexer, tokenKind_TokenKind.EOF, bodyLength, bodyLength);
}
/**
 * Reads a comment token from the source file.
 *
 * ```
 * Comment :: # CommentChar* [lookahead != CommentChar]
 *
 * CommentChar :: SourceCharacter but not LineTerminator
 * ```
 */

function readComment(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start + 1;

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // LineTerminator (\n | \r)

    if (code === 0x000a || code === 0x000d) {
      break;
    } // SourceCharacter

    if (isUnicodeScalarValue(code)) {
      ++position;
    } else if (isSupplementaryCodePoint(body, position)) {
      position += 2;
    } else {
      break;
    }
  }

  return createToken(
    lexer,
    tokenKind_TokenKind.COMMENT,
    start,
    position,
    body.slice(start + 1, position),
  );
}
/**
 * Reads a number token from the source file, either a FloatValue or an IntValue
 * depending on whether a FractionalPart or ExponentPart is encountered.
 *
 * ```
 * IntValue :: IntegerPart [lookahead != {Digit, `.`, NameStart}]
 *
 * IntegerPart ::
 *   - NegativeSign? 0
 *   - NegativeSign? NonZeroDigit Digit*
 *
 * NegativeSign :: -
 *
 * NonZeroDigit :: Digit but not `0`
 *
 * FloatValue ::
 *   - IntegerPart FractionalPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart FractionalPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *
 * FractionalPart :: . Digit+
 *
 * ExponentPart :: ExponentIndicator Sign? Digit+
 *
 * ExponentIndicator :: one of `e` `E`
 *
 * Sign :: one of + -
 * ```
 */

function readNumber(lexer, start, firstCode) {
  const body = lexer.source.body;
  let position = start;
  let code = firstCode;
  let isFloat = false; // NegativeSign (-)

  if (code === 0x002d) {
    code = body.charCodeAt(++position);
  } // Zero (0)

  if (code === 0x0030) {
    code = body.charCodeAt(++position);

    if ((0,characterClasses/* isDigit */.X1)(code)) {
      throw syntaxError(
        lexer.source,
        position,
        `Invalid number, unexpected digit after 0: ${printCodePointAt(
          lexer,
          position,
        )}.`,
      );
    }
  } else {
    position = readDigits(lexer, position, code);
    code = body.charCodeAt(position);
  } // Full stop (.)

  if (code === 0x002e) {
    isFloat = true;
    code = body.charCodeAt(++position);
    position = readDigits(lexer, position, code);
    code = body.charCodeAt(position);
  } // E e

  if (code === 0x0045 || code === 0x0065) {
    isFloat = true;
    code = body.charCodeAt(++position); // + -

    if (code === 0x002b || code === 0x002d) {
      code = body.charCodeAt(++position);
    }

    position = readDigits(lexer, position, code);
    code = body.charCodeAt(position);
  } // Numbers cannot be followed by . or NameStart

  if (code === 0x002e || (0,characterClasses/* isNameStart */.LQ)(code)) {
    throw syntaxError(
      lexer.source,
      position,
      `Invalid number, expected digit but got: ${printCodePointAt(
        lexer,
        position,
      )}.`,
    );
  }

  return createToken(
    lexer,
    isFloat ? tokenKind_TokenKind.FLOAT : tokenKind_TokenKind.INT,
    start,
    position,
    body.slice(start, position),
  );
}
/**
 * Returns the new position in the source after reading one or more digits.
 */

function readDigits(lexer, start, firstCode) {
  if (!(0,characterClasses/* isDigit */.X1)(firstCode)) {
    throw syntaxError(
      lexer.source,
      start,
      `Invalid number, expected digit but got: ${printCodePointAt(
        lexer,
        start,
      )}.`,
    );
  }

  const body = lexer.source.body;
  let position = start + 1; // +1 to skip first firstCode

  while ((0,characterClasses/* isDigit */.X1)(body.charCodeAt(position))) {
    ++position;
  }

  return position;
}
/**
 * Reads a single-quote string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `""` [lookahead != `"`]
 *   - `"` StringCharacter+ `"`
 *
 * StringCharacter ::
 *   - SourceCharacter but not `"` or `\` or LineTerminator
 *   - `\u` EscapedUnicode
 *   - `\` EscapedCharacter
 *
 * EscapedUnicode ::
 *   - `{` HexDigit+ `}`
 *   - HexDigit HexDigit HexDigit HexDigit
 *
 * EscapedCharacter :: one of `"` `\` `/` `b` `f` `n` `r` `t`
 * ```
 */

function readString(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start + 1;
  let chunkStart = position;
  let value = '';

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // Closing Quote (")

    if (code === 0x0022) {
      value += body.slice(chunkStart, position);
      return createToken(lexer, tokenKind_TokenKind.STRING, start, position + 1, value);
    } // Escape Sequence (\)

    if (code === 0x005c) {
      value += body.slice(chunkStart, position);
      const escape =
        body.charCodeAt(position + 1) === 0x0075 // u
          ? body.charCodeAt(position + 2) === 0x007b // {
            ? readEscapedUnicodeVariableWidth(lexer, position)
            : readEscapedUnicodeFixedWidth(lexer, position)
          : readEscapedCharacter(lexer, position);
      value += escape.value;
      position += escape.size;
      chunkStart = position;
      continue;
    } // LineTerminator (\n | \r)

    if (code === 0x000a || code === 0x000d) {
      break;
    } // SourceCharacter

    if (isUnicodeScalarValue(code)) {
      ++position;
    } else if (isSupplementaryCodePoint(body, position)) {
      position += 2;
    } else {
      throw syntaxError(
        lexer.source,
        position,
        `Invalid character within String: ${printCodePointAt(
          lexer,
          position,
        )}.`,
      );
    }
  }

  throw syntaxError(lexer.source, position, 'Unterminated string.');
} // The string value and lexed size of an escape sequence.

function readEscapedUnicodeVariableWidth(lexer, position) {
  const body = lexer.source.body;
  let point = 0;
  let size = 3; // Cannot be larger than 12 chars (\u{00000000}).

  while (size < 12) {
    const code = body.charCodeAt(position + size++); // Closing Brace (})

    if (code === 0x007d) {
      // Must be at least 5 chars (\u{0}) and encode a Unicode scalar value.
      if (size < 5 || !isUnicodeScalarValue(point)) {
        break;
      }

      return {
        value: String.fromCodePoint(point),
        size,
      };
    } // Append this hex digit to the code point.

    point = (point << 4) | readHexDigit(code);

    if (point < 0) {
      break;
    }
  }

  throw syntaxError(
    lexer.source,
    position,
    `Invalid Unicode escape sequence: "${body.slice(
      position,
      position + size,
    )}".`,
  );
}

function readEscapedUnicodeFixedWidth(lexer, position) {
  const body = lexer.source.body;
  const code = read16BitHexCode(body, position + 2);

  if (isUnicodeScalarValue(code)) {
    return {
      value: String.fromCodePoint(code),
      size: 6,
    };
  } // GraphQL allows JSON-style surrogate pair escape sequences, but only when
  // a valid pair is formed.

  if (isLeadingSurrogate(code)) {
    // \u
    if (
      body.charCodeAt(position + 6) === 0x005c &&
      body.charCodeAt(position + 7) === 0x0075
    ) {
      const trailingCode = read16BitHexCode(body, position + 8);

      if (isTrailingSurrogate(trailingCode)) {
        // JavaScript defines strings as a sequence of UTF-16 code units and
        // encodes Unicode code points above U+FFFF using a surrogate pair of
        // code units. Since this is a surrogate pair escape sequence, just
        // include both codes into the JavaScript string value. Had JavaScript
        // not been internally based on UTF-16, then this surrogate pair would
        // be decoded to retrieve the supplementary code point.
        return {
          value: String.fromCodePoint(code, trailingCode),
          size: 12,
        };
      }
    }
  }

  throw syntaxError(
    lexer.source,
    position,
    `Invalid Unicode escape sequence: "${body.slice(position, position + 6)}".`,
  );
}
/**
 * Reads four hexadecimal characters and returns the positive integer that 16bit
 * hexadecimal string represents. For example, "000f" will return 15, and "dead"
 * will return 57005.
 *
 * Returns a negative number if any char was not a valid hexadecimal digit.
 */

function read16BitHexCode(body, position) {
  // readHexDigit() returns -1 on error. ORing a negative value with any other
  // value always produces a negative value.
  return (
    (readHexDigit(body.charCodeAt(position)) << 12) |
    (readHexDigit(body.charCodeAt(position + 1)) << 8) |
    (readHexDigit(body.charCodeAt(position + 2)) << 4) |
    readHexDigit(body.charCodeAt(position + 3))
  );
}
/**
 * Reads a hexadecimal character and returns its positive integer value (0-15).
 *
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 if the provided character code was not a valid hexadecimal digit.
 *
 * HexDigit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 *   - `A` `B` `C` `D` `E` `F`
 *   - `a` `b` `c` `d` `e` `f`
 */

function readHexDigit(code) {
  return code >= 0x0030 && code <= 0x0039 // 0-9
    ? code - 0x0030
    : code >= 0x0041 && code <= 0x0046 // A-F
    ? code - 0x0037
    : code >= 0x0061 && code <= 0x0066 // a-f
    ? code - 0x0057
    : -1;
}
/**
 * | Escaped Character | Code Point | Character Name               |
 * | ----------------- | ---------- | ---------------------------- |
 * | `"`               | U+0022     | double quote                 |
 * | `\`               | U+005C     | reverse solidus (back slash) |
 * | `/`               | U+002F     | solidus (forward slash)      |
 * | `b`               | U+0008     | backspace                    |
 * | `f`               | U+000C     | form feed                    |
 * | `n`               | U+000A     | line feed (new line)         |
 * | `r`               | U+000D     | carriage return              |
 * | `t`               | U+0009     | horizontal tab               |
 */

function readEscapedCharacter(lexer, position) {
  const body = lexer.source.body;
  const code = body.charCodeAt(position + 1);

  switch (code) {
    case 0x0022:
      // "
      return {
        value: '\u0022',
        size: 2,
      };

    case 0x005c:
      // \
      return {
        value: '\u005c',
        size: 2,
      };

    case 0x002f:
      // /
      return {
        value: '\u002f',
        size: 2,
      };

    case 0x0062:
      // b
      return {
        value: '\u0008',
        size: 2,
      };

    case 0x0066:
      // f
      return {
        value: '\u000c',
        size: 2,
      };

    case 0x006e:
      // n
      return {
        value: '\u000a',
        size: 2,
      };

    case 0x0072:
      // r
      return {
        value: '\u000d',
        size: 2,
      };

    case 0x0074:
      // t
      return {
        value: '\u0009',
        size: 2,
      };
  }

  throw syntaxError(
    lexer.source,
    position,
    `Invalid character escape sequence: "${body.slice(
      position,
      position + 2,
    )}".`,
  );
}
/**
 * Reads a block string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `"""` BlockStringCharacter* `"""`
 *
 * BlockStringCharacter ::
 *   - SourceCharacter but not `"""` or `\"""`
 *   - `\"""`
 * ```
 */

function readBlockString(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let lineStart = lexer.lineStart;
  let position = start + 3;
  let chunkStart = position;
  let currentLine = '';
  const blockLines = [];

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // Closing Triple-Quote (""")

    if (
      code === 0x0022 &&
      body.charCodeAt(position + 1) === 0x0022 &&
      body.charCodeAt(position + 2) === 0x0022
    ) {
      currentLine += body.slice(chunkStart, position);
      blockLines.push(currentLine);
      const token = createToken(
        lexer,
        tokenKind_TokenKind.BLOCK_STRING,
        start,
        position + 3, // Return a string of the lines joined with U+000A.
        (0,blockString/* dedentBlockStringLines */.wv)(blockLines).join('\n'),
      );
      lexer.line += blockLines.length - 1;
      lexer.lineStart = lineStart;
      return token;
    } // Escaped Triple-Quote (\""")

    if (
      code === 0x005c &&
      body.charCodeAt(position + 1) === 0x0022 &&
      body.charCodeAt(position + 2) === 0x0022 &&
      body.charCodeAt(position + 3) === 0x0022
    ) {
      currentLine += body.slice(chunkStart, position);
      chunkStart = position + 1; // skip only slash

      position += 4;
      continue;
    } // LineTerminator

    if (code === 0x000a || code === 0x000d) {
      currentLine += body.slice(chunkStart, position);
      blockLines.push(currentLine);

      if (code === 0x000d && body.charCodeAt(position + 1) === 0x000a) {
        position += 2;
      } else {
        ++position;
      }

      currentLine = '';
      chunkStart = position;
      lineStart = position;
      continue;
    } // SourceCharacter

    if (isUnicodeScalarValue(code)) {
      ++position;
    } else if (isSupplementaryCodePoint(body, position)) {
      position += 2;
    } else {
      throw syntaxError(
        lexer.source,
        position,
        `Invalid character within String: ${printCodePointAt(
          lexer,
          position,
        )}.`,
      );
    }
  }

  throw syntaxError(lexer.source, position, 'Unterminated string.');
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * ```
 * Name ::
 *   - NameStart NameContinue* [lookahead != NameContinue]
 * ```
 *
 * @internal
 */

function readName(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start + 1;

  while (position < bodyLength) {
    const code = body.charCodeAt(position);

    if ((0,characterClasses/* isNameContinue */.HQ)(code)) {
      ++position;
    } else {
      break;
    }
  }

  return createToken(
    lexer,
    tokenKind_TokenKind.NAME,
    start,
    position,
    body.slice(start, position),
  );
}

// EXTERNAL MODULE: ./node_modules/graphql/jsutils/devAssert.mjs
var devAssert = __webpack_require__(37826);
// EXTERNAL MODULE: ./node_modules/graphql/jsutils/inspect.mjs
var inspect = __webpack_require__(25821);
;// CONCATENATED MODULE: ./node_modules/graphql/jsutils/instanceOf.mjs

/* c8 ignore next 3 */

const isProduction =
  globalThis.process && // eslint-disable-next-line no-undef
  "production" === 'production';
/**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 * See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
 * See: https://webpack.js.org/guides/production/
 */

const instanceOf =
  /* c8 ignore next 6 */
  // FIXME: https://github.com/graphql/graphql-js/issues/2317
  isProduction
    ? function instanceOf(value, constructor) {
        return value instanceof constructor;
      }
    : function instanceOf(value, constructor) {
        if (value instanceof constructor) {
          return true;
        }

        if (typeof value === 'object' && value !== null) {
          var _value$constructor;

          // Prefer Symbol.toStringTag since it is immune to minification.
          const className = constructor.prototype[Symbol.toStringTag];
          const valueClassName = // We still need to support constructor's name to detect conflicts with older versions of this library.
            Symbol.toStringTag in value // @ts-expect-error TS bug see, https://github.com/microsoft/TypeScript/issues/38009
              ? value[Symbol.toStringTag]
              : (_value$constructor = value.constructor) === null ||
                _value$constructor === void 0
              ? void 0
              : _value$constructor.name;

          if (className === valueClassName) {
            const stringifiedValue = (0,inspect/* inspect */.X)(value);
            throw new Error(`Cannot use ${className} "${stringifiedValue}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
          }
        }

        return false;
      };

;// CONCATENATED MODULE: ./node_modules/graphql/language/source.mjs




/**
 * A representation of source input to GraphQL. The `name` and `locationOffset` parameters are
 * optional, but they are useful for clients who store GraphQL documents in source files.
 * For example, if the GraphQL input starts at line 40 in a file named `Foo.graphql`, it might
 * be useful for `name` to be `"Foo.graphql"` and location to be `{ line: 40, column: 1 }`.
 * The `line` and `column` properties in `locationOffset` are 1-indexed.
 */
class source_Source {
  constructor(
    body,
    name = 'GraphQL request',
    locationOffset = {
      line: 1,
      column: 1,
    },
  ) {
    typeof body === 'string' ||
      (0,devAssert/* devAssert */.a)(false, `Body must be a string. Received: ${(0,inspect/* inspect */.X)(body)}.`);
    this.body = body;
    this.name = name;
    this.locationOffset = locationOffset;
    this.locationOffset.line > 0 ||
      (0,devAssert/* devAssert */.a)(
        false,
        'line in locationOffset is 1-indexed and must be positive.',
      );
    this.locationOffset.column > 0 ||
      (0,devAssert/* devAssert */.a)(
        false,
        'column in locationOffset is 1-indexed and must be positive.',
      );
  }

  get [Symbol.toStringTag]() {
    return 'Source';
  }
}
/**
 * Test if the given value is a Source object.
 *
 * @internal
 */

function source_isSource(source) {
  return instanceOf(source, source_Source);
}

;// CONCATENATED MODULE: ./node_modules/graphql/language/parser.mjs








/**
 * Configuration options to control parser behavior
 */

/**
 * Given a GraphQL source, parses it into a Document.
 * Throws GraphQLError if a syntax error is encountered.
 */
function parse(source, options) {
  const parser = new Parser(source, options);
  const document = parser.parseDocument();
  Object.defineProperty(document, 'tokenCount', {
    enumerable: false,
    value: parser.tokenCount,
  });
  return document;
}
/**
 * Given a string containing a GraphQL value (ex. `[42]`), parse the AST for
 * that value.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Values directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: valueFromAST().
 */

function parseValue(source, options) {
  const parser = new Parser(source, options);
  parser.expectToken(TokenKind.SOF);
  const value = parser.parseValueLiteral(false);
  parser.expectToken(TokenKind.EOF);
  return value;
}
/**
 * Similar to parseValue(), but raises a parse error if it encounters a
 * variable. The return type will be a constant value.
 */

function parseConstValue(source, options) {
  const parser = new Parser(source, options);
  parser.expectToken(TokenKind.SOF);
  const value = parser.parseConstValueLiteral();
  parser.expectToken(TokenKind.EOF);
  return value;
}
/**
 * Given a string containing a GraphQL Type (ex. `[Int!]`), parse the AST for
 * that type.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Types directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: typeFromAST().
 */

function parseType(source, options) {
  const parser = new Parser(source, options);
  parser.expectToken(TokenKind.SOF);
  const type = parser.parseTypeReference();
  parser.expectToken(TokenKind.EOF);
  return type;
}
/**
 * Given a string containing a GraphQL Schema Coordinate (ex. `Type.field`),
 * parse the AST for that schema coordinate.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * Consider providing the results to the utility function:
 * resolveASTSchemaCoordinate(). Or calling resolveSchemaCoordinate() directly
 * with an unparsed source.
 */

function parseSchemaCoordinate(source) {
  const sourceObj = isSource(source) ? source : new Source(source);
  const lexer = new SchemaCoordinateLexer(sourceObj);
  const parser = new Parser(source, {
    lexer,
  });
  parser.expectToken(TokenKind.SOF);
  const coordinate = parser.parseSchemaCoordinate();
  parser.expectToken(TokenKind.EOF);
  return coordinate;
}
/**
 * This class is exported only to assist people in implementing their own parsers
 * without duplicating too much code and should be used only as last resort for cases
 * such as experimental syntax or if certain features could not be contributed upstream.
 *
 * It is still part of the internal API and is versioned, so any changes to it are never
 * considered breaking changes. If you still need to support multiple versions of the
 * library, please use the `versionInfo` variable for version detection.
 *
 * @internal
 */

class Parser {
  constructor(source, options = {}) {
    const { lexer, ..._options } = options;

    if (lexer) {
      this._lexer = lexer;
    } else {
      const sourceObj = source_isSource(source) ? source : new source_Source(source);
      this._lexer = new Lexer(sourceObj);
    }

    this._options = _options;
    this._tokenCounter = 0;
  }

  get tokenCount() {
    return this._tokenCounter;
  }
  /**
   * Converts a name lex token into a name parse node.
   */

  parseName() {
    const token = this.expectToken(tokenKind_TokenKind.NAME);
    return this.node(token, {
      kind: kinds/* Kind.NAME */.h.NAME,
      value: token.value,
    });
  } // Implements the parsing rules in the Document section.

  /**
   * Document : Definition+
   */

  parseDocument() {
    return this.node(this._lexer.token, {
      kind: kinds/* Kind.DOCUMENT */.h.DOCUMENT,
      definitions: this.many(
        tokenKind_TokenKind.SOF,
        this.parseDefinition,
        tokenKind_TokenKind.EOF,
      ),
    });
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */

  parseDefinition() {
    if (this.peek(tokenKind_TokenKind.BRACE_L)) {
      return this.parseOperationDefinition();
    } // Many definitions begin with a description and require a lookahead.

    const hasDescription = this.peekDescription();
    const keywordToken = hasDescription
      ? this._lexer.lookahead()
      : this._lexer.token;

    if (hasDescription && keywordToken.kind === tokenKind_TokenKind.BRACE_L) {
      throw syntaxError(
        this._lexer.source,
        this._lexer.token.start,
        'Unexpected description, descriptions are not supported on shorthand queries.',
      );
    }

    if (keywordToken.kind === tokenKind_TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaDefinition();

        case 'scalar':
          return this.parseScalarTypeDefinition();

        case 'type':
          return this.parseObjectTypeDefinition();

        case 'interface':
          return this.parseInterfaceTypeDefinition();

        case 'union':
          return this.parseUnionTypeDefinition();

        case 'enum':
          return this.parseEnumTypeDefinition();

        case 'input':
          return this.parseInputObjectTypeDefinition();

        case 'directive':
          return this.parseDirectiveDefinition();
      }

      switch (keywordToken.value) {
        case 'query':
        case 'mutation':
        case 'subscription':
          return this.parseOperationDefinition();

        case 'fragment':
          return this.parseFragmentDefinition();
      }

      if (hasDescription) {
        throw syntaxError(
          this._lexer.source,
          this._lexer.token.start,
          'Unexpected description, only GraphQL definitions support descriptions.',
        );
      }

      switch (keywordToken.value) {
        case 'extend':
          return this.parseTypeSystemExtension();
      }
    }

    throw this.unexpected(keywordToken);
  } // Implements the parsing rules in the Operations section.

  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */

  parseOperationDefinition() {
    const start = this._lexer.token;

    if (this.peek(tokenKind_TokenKind.BRACE_L)) {
      return this.node(start, {
        kind: kinds/* Kind.OPERATION_DEFINITION */.h.OPERATION_DEFINITION,
        operation: ast/* OperationTypeNode.QUERY */.ku.QUERY,
        description: undefined,
        name: undefined,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet(),
      });
    }

    const description = this.parseDescription();
    const operation = this.parseOperationType();
    let name;

    if (this.peek(tokenKind_TokenKind.NAME)) {
      name = this.parseName();
    }

    return this.node(start, {
      kind: kinds/* Kind.OPERATION_DEFINITION */.h.OPERATION_DEFINITION,
      operation,
      description,
      name,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
    });
  }
  /**
   * OperationType : one of query mutation subscription
   */

  parseOperationType() {
    const operationToken = this.expectToken(tokenKind_TokenKind.NAME);

    switch (operationToken.value) {
      case 'query':
        return ast/* OperationTypeNode.QUERY */.ku.QUERY;

      case 'mutation':
        return ast/* OperationTypeNode.MUTATION */.ku.MUTATION;

      case 'subscription':
        return ast/* OperationTypeNode.SUBSCRIPTION */.ku.SUBSCRIPTION;
    }

    throw this.unexpected(operationToken);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */

  parseVariableDefinitions() {
    return this.optionalMany(
      tokenKind_TokenKind.PAREN_L,
      this.parseVariableDefinition,
      tokenKind_TokenKind.PAREN_R,
    );
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */

  parseVariableDefinition() {
    return this.node(this._lexer.token, {
      kind: kinds/* Kind.VARIABLE_DEFINITION */.h.VARIABLE_DEFINITION,
      description: this.parseDescription(),
      variable: this.parseVariable(),
      type: (this.expectToken(tokenKind_TokenKind.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(tokenKind_TokenKind.EQUALS)
        ? this.parseConstValueLiteral()
        : undefined,
      directives: this.parseConstDirectives(),
    });
  }
  /**
   * Variable : $ Name
   */

  parseVariable() {
    const start = this._lexer.token;
    this.expectToken(tokenKind_TokenKind.DOLLAR);
    return this.node(start, {
      kind: kinds/* Kind.VARIABLE */.h.VARIABLE,
      name: this.parseName(),
    });
  }
  /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */

  parseSelectionSet() {
    return this.node(this._lexer.token, {
      kind: kinds/* Kind.SELECTION_SET */.h.SELECTION_SET,
      selections: this.many(
        tokenKind_TokenKind.BRACE_L,
        this.parseSelection,
        tokenKind_TokenKind.BRACE_R,
      ),
    });
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */

  parseSelection() {
    return this.peek(tokenKind_TokenKind.SPREAD)
      ? this.parseFragment()
      : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */

  parseField() {
    const start = this._lexer.token;
    const nameOrAlias = this.parseName();
    let alias;
    let name;

    if (this.expectOptionalToken(tokenKind_TokenKind.COLON)) {
      alias = nameOrAlias;
      name = this.parseName();
    } else {
      name = nameOrAlias;
    }

    return this.node(start, {
      kind: kinds/* Kind.FIELD */.h.FIELD,
      alias,
      name,
      arguments: this.parseArguments(false),
      directives: this.parseDirectives(false),
      selectionSet: this.peek(tokenKind_TokenKind.BRACE_L)
        ? this.parseSelectionSet()
        : undefined,
    });
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */

  parseArguments(isConst) {
    const item = isConst ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(tokenKind_TokenKind.PAREN_L, item, tokenKind_TokenKind.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */

  parseArgument(isConst = false) {
    const start = this._lexer.token;
    const name = this.parseName();
    this.expectToken(tokenKind_TokenKind.COLON);
    return this.node(start, {
      kind: kinds/* Kind.ARGUMENT */.h.ARGUMENT,
      name,
      value: this.parseValueLiteral(isConst),
    });
  }

  parseConstArgument() {
    return this.parseArgument(true);
  } // Implements the parsing rules in the Fragments section.

  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */

  parseFragment() {
    const start = this._lexer.token;
    this.expectToken(tokenKind_TokenKind.SPREAD);
    const hasTypeCondition = this.expectOptionalKeyword('on');

    if (!hasTypeCondition && this.peek(tokenKind_TokenKind.NAME)) {
      return this.node(start, {
        kind: kinds/* Kind.FRAGMENT_SPREAD */.h.FRAGMENT_SPREAD,
        name: this.parseFragmentName(),
        directives: this.parseDirectives(false),
      });
    }

    return this.node(start, {
      kind: kinds/* Kind.INLINE_FRAGMENT */.h.INLINE_FRAGMENT,
      typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
    });
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */

  parseFragmentDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('fragment'); // Legacy support for defining variables within fragments changes
    // the grammar of FragmentDefinition:
    //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet

    if (this._options.allowLegacyFragmentVariables === true) {
      return this.node(start, {
        kind: kinds/* Kind.FRAGMENT_DEFINITION */.h.FRAGMENT_DEFINITION,
        description,
        name: this.parseFragmentName(),
        variableDefinitions: this.parseVariableDefinitions(),
        typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
        directives: this.parseDirectives(false),
        selectionSet: this.parseSelectionSet(),
      });
    }

    return this.node(start, {
      kind: kinds/* Kind.FRAGMENT_DEFINITION */.h.FRAGMENT_DEFINITION,
      description,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
    });
  }
  /**
   * FragmentName : Name but not `on`
   */

  parseFragmentName() {
    if (this._lexer.token.value === 'on') {
      throw this.unexpected();
    }

    return this.parseName();
  } // Implements the parsing rules in the Values section.

  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */

  parseValueLiteral(isConst) {
    const token = this._lexer.token;

    switch (token.kind) {
      case tokenKind_TokenKind.BRACKET_L:
        return this.parseList(isConst);

      case tokenKind_TokenKind.BRACE_L:
        return this.parseObject(isConst);

      case tokenKind_TokenKind.INT:
        this.advanceLexer();
        return this.node(token, {
          kind: kinds/* Kind.INT */.h.INT,
          value: token.value,
        });

      case tokenKind_TokenKind.FLOAT:
        this.advanceLexer();
        return this.node(token, {
          kind: kinds/* Kind.FLOAT */.h.FLOAT,
          value: token.value,
        });

      case tokenKind_TokenKind.STRING:
      case tokenKind_TokenKind.BLOCK_STRING:
        return this.parseStringLiteral();

      case tokenKind_TokenKind.NAME:
        this.advanceLexer();

        switch (token.value) {
          case 'true':
            return this.node(token, {
              kind: kinds/* Kind.BOOLEAN */.h.BOOLEAN,
              value: true,
            });

          case 'false':
            return this.node(token, {
              kind: kinds/* Kind.BOOLEAN */.h.BOOLEAN,
              value: false,
            });

          case 'null':
            return this.node(token, {
              kind: kinds/* Kind.NULL */.h.NULL,
            });

          default:
            return this.node(token, {
              kind: kinds/* Kind.ENUM */.h.ENUM,
              value: token.value,
            });
        }

      case tokenKind_TokenKind.DOLLAR:
        if (isConst) {
          this.expectToken(tokenKind_TokenKind.DOLLAR);

          if (this._lexer.token.kind === tokenKind_TokenKind.NAME) {
            const varName = this._lexer.token.value;
            throw syntaxError(
              this._lexer.source,
              token.start,
              `Unexpected variable "$${varName}" in constant value.`,
            );
          } else {
            throw this.unexpected(token);
          }
        }

        return this.parseVariable();

      default:
        throw this.unexpected();
    }
  }

  parseConstValueLiteral() {
    return this.parseValueLiteral(true);
  }

  parseStringLiteral() {
    const token = this._lexer.token;
    this.advanceLexer();
    return this.node(token, {
      kind: kinds/* Kind.STRING */.h.STRING,
      value: token.value,
      block: token.kind === tokenKind_TokenKind.BLOCK_STRING,
    });
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */

  parseList(isConst) {
    const item = () => this.parseValueLiteral(isConst);

    return this.node(this._lexer.token, {
      kind: kinds/* Kind.LIST */.h.LIST,
      values: this.any(tokenKind_TokenKind.BRACKET_L, item, tokenKind_TokenKind.BRACKET_R),
    });
  }
  /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */

  parseObject(isConst) {
    const item = () => this.parseObjectField(isConst);

    return this.node(this._lexer.token, {
      kind: kinds/* Kind.OBJECT */.h.OBJECT,
      fields: this.any(tokenKind_TokenKind.BRACE_L, item, tokenKind_TokenKind.BRACE_R),
    });
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */

  parseObjectField(isConst) {
    const start = this._lexer.token;
    const name = this.parseName();
    this.expectToken(tokenKind_TokenKind.COLON);
    return this.node(start, {
      kind: kinds/* Kind.OBJECT_FIELD */.h.OBJECT_FIELD,
      name,
      value: this.parseValueLiteral(isConst),
    });
  } // Implements the parsing rules in the Directives section.

  /**
   * Directives[Const] : Directive[?Const]+
   */

  parseDirectives(isConst) {
    const directives = [];

    while (this.peek(tokenKind_TokenKind.AT)) {
      directives.push(this.parseDirective(isConst));
    }

    return directives;
  }

  parseConstDirectives() {
    return this.parseDirectives(true);
  }
  /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */

  parseDirective(isConst) {
    const start = this._lexer.token;
    this.expectToken(tokenKind_TokenKind.AT);
    return this.node(start, {
      kind: kinds/* Kind.DIRECTIVE */.h.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(isConst),
    });
  } // Implements the parsing rules in the Types section.

  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */

  parseTypeReference() {
    const start = this._lexer.token;
    let type;

    if (this.expectOptionalToken(tokenKind_TokenKind.BRACKET_L)) {
      const innerType = this.parseTypeReference();
      this.expectToken(tokenKind_TokenKind.BRACKET_R);
      type = this.node(start, {
        kind: kinds/* Kind.LIST_TYPE */.h.LIST_TYPE,
        type: innerType,
      });
    } else {
      type = this.parseNamedType();
    }

    if (this.expectOptionalToken(tokenKind_TokenKind.BANG)) {
      return this.node(start, {
        kind: kinds/* Kind.NON_NULL_TYPE */.h.NON_NULL_TYPE,
        type,
      });
    }

    return type;
  }
  /**
   * NamedType : Name
   */

  parseNamedType() {
    return this.node(this._lexer.token, {
      kind: kinds/* Kind.NAMED_TYPE */.h.NAMED_TYPE,
      name: this.parseName(),
    });
  } // Implements the parsing rules in the Type Definition section.

  peekDescription() {
    return this.peek(tokenKind_TokenKind.STRING) || this.peek(tokenKind_TokenKind.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */

  parseDescription() {
    if (this.peekDescription()) {
      return this.parseStringLiteral();
    }
  }
  /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */

  parseSchemaDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('schema');
    const directives = this.parseConstDirectives();
    const operationTypes = this.many(
      tokenKind_TokenKind.BRACE_L,
      this.parseOperationTypeDefinition,
      tokenKind_TokenKind.BRACE_R,
    );
    return this.node(start, {
      kind: kinds/* Kind.SCHEMA_DEFINITION */.h.SCHEMA_DEFINITION,
      description,
      directives,
      operationTypes,
    });
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */

  parseOperationTypeDefinition() {
    const start = this._lexer.token;
    const operation = this.parseOperationType();
    this.expectToken(tokenKind_TokenKind.COLON);
    const type = this.parseNamedType();
    return this.node(start, {
      kind: kinds/* Kind.OPERATION_TYPE_DEFINITION */.h.OPERATION_TYPE_DEFINITION,
      operation,
      type,
    });
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */

  parseScalarTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('scalar');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: kinds/* Kind.SCALAR_TYPE_DEFINITION */.h.SCALAR_TYPE_DEFINITION,
      description,
      name,
      directives,
    });
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */

  parseObjectTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('type');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();
    return this.node(start, {
      kind: kinds/* Kind.OBJECT_TYPE_DEFINITION */.h.OBJECT_TYPE_DEFINITION,
      description,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */

  parseImplementsInterfaces() {
    return this.expectOptionalKeyword('implements')
      ? this.delimitedMany(tokenKind_TokenKind.AMP, this.parseNamedType)
      : [];
  }
  /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */

  parseFieldsDefinition() {
    return this.optionalMany(
      tokenKind_TokenKind.BRACE_L,
      this.parseFieldDefinition,
      tokenKind_TokenKind.BRACE_R,
    );
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */

  parseFieldDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    const name = this.parseName();
    const args = this.parseArgumentDefs();
    this.expectToken(tokenKind_TokenKind.COLON);
    const type = this.parseTypeReference();
    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: kinds/* Kind.FIELD_DEFINITION */.h.FIELD_DEFINITION,
      description,
      name,
      arguments: args,
      type,
      directives,
    });
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */

  parseArgumentDefs() {
    return this.optionalMany(
      tokenKind_TokenKind.PAREN_L,
      this.parseInputValueDef,
      tokenKind_TokenKind.PAREN_R,
    );
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */

  parseInputValueDef() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    const name = this.parseName();
    this.expectToken(tokenKind_TokenKind.COLON);
    const type = this.parseTypeReference();
    let defaultValue;

    if (this.expectOptionalToken(tokenKind_TokenKind.EQUALS)) {
      defaultValue = this.parseConstValueLiteral();
    }

    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: kinds/* Kind.INPUT_VALUE_DEFINITION */.h.INPUT_VALUE_DEFINITION,
      description,
      name,
      type,
      defaultValue,
      directives,
    });
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */

  parseInterfaceTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('interface');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();
    return this.node(start, {
      kind: kinds/* Kind.INTERFACE_TYPE_DEFINITION */.h.INTERFACE_TYPE_DEFINITION,
      description,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */

  parseUnionTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('union');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const types = this.parseUnionMemberTypes();
    return this.node(start, {
      kind: kinds/* Kind.UNION_TYPE_DEFINITION */.h.UNION_TYPE_DEFINITION,
      description,
      name,
      directives,
      types,
    });
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */

  parseUnionMemberTypes() {
    return this.expectOptionalToken(tokenKind_TokenKind.EQUALS)
      ? this.delimitedMany(tokenKind_TokenKind.PIPE, this.parseNamedType)
      : [];
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */

  parseEnumTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('enum');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const values = this.parseEnumValuesDefinition();
    return this.node(start, {
      kind: kinds/* Kind.ENUM_TYPE_DEFINITION */.h.ENUM_TYPE_DEFINITION,
      description,
      name,
      directives,
      values,
    });
  }
  /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */

  parseEnumValuesDefinition() {
    return this.optionalMany(
      tokenKind_TokenKind.BRACE_L,
      this.parseEnumValueDefinition,
      tokenKind_TokenKind.BRACE_R,
    );
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */

  parseEnumValueDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    const name = this.parseEnumValueName();
    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: kinds/* Kind.ENUM_VALUE_DEFINITION */.h.ENUM_VALUE_DEFINITION,
      description,
      name,
      directives,
    });
  }
  /**
   * EnumValue : Name but not `true`, `false` or `null`
   */

  parseEnumValueName() {
    if (
      this._lexer.token.value === 'true' ||
      this._lexer.token.value === 'false' ||
      this._lexer.token.value === 'null'
    ) {
      throw syntaxError(
        this._lexer.source,
        this._lexer.token.start,
        `${getTokenDesc(
          this._lexer.token,
        )} is reserved and cannot be used for an enum value.`,
      );
    }

    return this.parseName();
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */

  parseInputObjectTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('input');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const fields = this.parseInputFieldsDefinition();
    return this.node(start, {
      kind: kinds/* Kind.INPUT_OBJECT_TYPE_DEFINITION */.h.INPUT_OBJECT_TYPE_DEFINITION,
      description,
      name,
      directives,
      fields,
    });
  }
  /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */

  parseInputFieldsDefinition() {
    return this.optionalMany(
      tokenKind_TokenKind.BRACE_L,
      this.parseInputValueDef,
      tokenKind_TokenKind.BRACE_R,
    );
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */

  parseTypeSystemExtension() {
    const keywordToken = this._lexer.lookahead();

    if (keywordToken.kind === tokenKind_TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaExtension();

        case 'scalar':
          return this.parseScalarTypeExtension();

        case 'type':
          return this.parseObjectTypeExtension();

        case 'interface':
          return this.parseInterfaceTypeExtension();

        case 'union':
          return this.parseUnionTypeExtension();

        case 'enum':
          return this.parseEnumTypeExtension();

        case 'input':
          return this.parseInputObjectTypeExtension();
      }
    }

    throw this.unexpected(keywordToken);
  }
  /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */

  parseSchemaExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('schema');
    const directives = this.parseConstDirectives();
    const operationTypes = this.optionalMany(
      tokenKind_TokenKind.BRACE_L,
      this.parseOperationTypeDefinition,
      tokenKind_TokenKind.BRACE_R,
    );

    if (directives.length === 0 && operationTypes.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.SCHEMA_EXTENSION */.h.SCHEMA_EXTENSION,
      directives,
      operationTypes,
    });
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */

  parseScalarTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('scalar');
    const name = this.parseName();
    const directives = this.parseConstDirectives();

    if (directives.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.SCALAR_TYPE_EXTENSION */.h.SCALAR_TYPE_EXTENSION,
      name,
      directives,
    });
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */

  parseObjectTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('type');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();

    if (
      interfaces.length === 0 &&
      directives.length === 0 &&
      fields.length === 0
    ) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.OBJECT_TYPE_EXTENSION */.h.OBJECT_TYPE_EXTENSION,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */

  parseInterfaceTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('interface');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();

    if (
      interfaces.length === 0 &&
      directives.length === 0 &&
      fields.length === 0
    ) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.INTERFACE_TYPE_EXTENSION */.h.INTERFACE_TYPE_EXTENSION,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */

  parseUnionTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('union');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const types = this.parseUnionMemberTypes();

    if (directives.length === 0 && types.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.UNION_TYPE_EXTENSION */.h.UNION_TYPE_EXTENSION,
      name,
      directives,
      types,
    });
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */

  parseEnumTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('enum');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const values = this.parseEnumValuesDefinition();

    if (directives.length === 0 && values.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.ENUM_TYPE_EXTENSION */.h.ENUM_TYPE_EXTENSION,
      name,
      directives,
      values,
    });
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */

  parseInputObjectTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('input');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const fields = this.parseInputFieldsDefinition();

    if (directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.INPUT_OBJECT_TYPE_EXTENSION */.h.INPUT_OBJECT_TYPE_EXTENSION,
      name,
      directives,
      fields,
    });
  }
  /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */

  parseDirectiveDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('directive');
    this.expectToken(tokenKind_TokenKind.AT);
    const name = this.parseName();
    const args = this.parseArgumentDefs();
    const repeatable = this.expectOptionalKeyword('repeatable');
    this.expectKeyword('on');
    const locations = this.parseDirectiveLocations();
    return this.node(start, {
      kind: kinds/* Kind.DIRECTIVE_DEFINITION */.h.DIRECTIVE_DEFINITION,
      description,
      name,
      arguments: args,
      repeatable,
      locations,
    });
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */

  parseDirectiveLocations() {
    return this.delimitedMany(tokenKind_TokenKind.PIPE, this.parseDirectiveLocation);
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */

  parseDirectiveLocation() {
    const start = this._lexer.token;
    const name = this.parseName();

    if (Object.prototype.hasOwnProperty.call(DirectiveLocation, name.value)) {
      return name;
    }

    throw this.unexpected(start);
  } // Schema Coordinates

  /**
   * SchemaCoordinate :
   *   - Name
   *   - Name . Name
   *   - Name . Name ( Name : )
   *   - \@ Name
   *   - \@ Name ( Name : )
   */

  parseSchemaCoordinate() {
    const start = this._lexer.token;
    const ofDirective = this.expectOptionalToken(tokenKind_TokenKind.AT);
    const name = this.parseName();
    let memberName;

    if (!ofDirective && this.expectOptionalToken(tokenKind_TokenKind.DOT)) {
      memberName = this.parseName();
    }

    let argumentName;

    if (
      (ofDirective || memberName) &&
      this.expectOptionalToken(tokenKind_TokenKind.PAREN_L)
    ) {
      argumentName = this.parseName();
      this.expectToken(tokenKind_TokenKind.COLON);
      this.expectToken(tokenKind_TokenKind.PAREN_R);
    }

    if (ofDirective) {
      if (argumentName) {
        return this.node(start, {
          kind: kinds/* Kind.DIRECTIVE_ARGUMENT_COORDINATE */.h.DIRECTIVE_ARGUMENT_COORDINATE,
          name,
          argumentName,
        });
      }

      return this.node(start, {
        kind: kinds/* Kind.DIRECTIVE_COORDINATE */.h.DIRECTIVE_COORDINATE,
        name,
      });
    } else if (memberName) {
      if (argumentName) {
        return this.node(start, {
          kind: kinds/* Kind.ARGUMENT_COORDINATE */.h.ARGUMENT_COORDINATE,
          name,
          fieldName: memberName,
          argumentName,
        });
      }

      return this.node(start, {
        kind: kinds/* Kind.MEMBER_COORDINATE */.h.MEMBER_COORDINATE,
        name,
        memberName,
      });
    }

    return this.node(start, {
      kind: kinds/* Kind.TYPE_COORDINATE */.h.TYPE_COORDINATE,
      name,
    });
  } // Core parsing utility functions

  /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */

  node(startToken, node) {
    if (this._options.noLocation !== true) {
      node.loc = new ast/* Location */.Ye(
        startToken,
        this._lexer.lastToken,
        this._lexer.source,
      );
    }

    return node;
  }
  /**
   * Determines if the next token is of a given kind
   */

  peek(kind) {
    return this._lexer.token.kind === kind;
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */

  expectToken(kind) {
    const token = this._lexer.token;

    if (token.kind === kind) {
      this.advanceLexer();
      return token;
    }

    throw syntaxError(
      this._lexer.source,
      token.start,
      `Expected ${getTokenKindDesc(kind)}, found ${getTokenDesc(token)}.`,
    );
  }
  /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */

  expectOptionalToken(kind) {
    const token = this._lexer.token;

    if (token.kind === kind) {
      this.advanceLexer();
      return true;
    }

    return false;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */

  expectKeyword(value) {
    const token = this._lexer.token;

    if (token.kind === tokenKind_TokenKind.NAME && token.value === value) {
      this.advanceLexer();
    } else {
      throw syntaxError(
        this._lexer.source,
        token.start,
        `Expected "${value}", found ${getTokenDesc(token)}.`,
      );
    }
  }
  /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */

  expectOptionalKeyword(value) {
    const token = this._lexer.token;

    if (token.kind === tokenKind_TokenKind.NAME && token.value === value) {
      this.advanceLexer();
      return true;
    }

    return false;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */

  unexpected(atToken) {
    const token =
      atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
    return syntaxError(
      this._lexer.source,
      token.start,
      `Unexpected ${getTokenDesc(token)}.`,
    );
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */

  any(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    const nodes = [];

    while (!this.expectOptionalToken(closeKind)) {
      nodes.push(parseFn.call(this));
    }

    return nodes;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */

  optionalMany(openKind, parseFn, closeKind) {
    if (this.expectOptionalToken(openKind)) {
      const nodes = [];

      do {
        nodes.push(parseFn.call(this));
      } while (!this.expectOptionalToken(closeKind));

      return nodes;
    }

    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */

  many(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    const nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (!this.expectOptionalToken(closeKind));

    return nodes;
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */

  delimitedMany(delimiterKind, parseFn) {
    this.expectOptionalToken(delimiterKind);
    const nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (this.expectOptionalToken(delimiterKind));

    return nodes;
  }

  advanceLexer() {
    const { maxTokens } = this._options;

    const token = this._lexer.advance();

    if (token.kind !== tokenKind_TokenKind.EOF) {
      ++this._tokenCounter;

      if (maxTokens !== undefined && this._tokenCounter > maxTokens) {
        throw syntaxError(
          this._lexer.source,
          token.start,
          `Document contains more that ${maxTokens} tokens. Parsing aborted.`,
        );
      }
    }
  }
}
/**
 * A helper function to describe a token as a string for debugging.
 */

function getTokenDesc(token) {
  const value = token.value;
  return getTokenKindDesc(token.kind) + (value != null ? ` "${value}"` : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */

function getTokenKindDesc(kind) {
  return isPunctuatorTokenKind(kind) ? `"${kind}"` : kind;
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,179], function() { return __webpack_exec__(74562), __webpack_exec__(6840), __webpack_exec__(68509); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);